/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(171);
	module.exports = __webpack_require__(394);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js
	//! version : 2.10.6
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.moment = factory();
	})(undefined, function () {
	    'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            m._isValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated;
	
	            if (m._strict) {
	                m._isValid = m._isValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid(flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (typeof from._isAMomentObject !== 'undefined') {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (typeof from._i !== 'undefined') {
	            to._i = from._i;
	        }
	        if (typeof from._f !== 'undefined') {
	            to._f = from._f;
	        }
	        if (typeof from._l !== 'undefined') {
	            to._l = from._l;
	        }
	        if (typeof from._strict !== 'undefined') {
	            to._strict = from._strict;
	        }
	        if (typeof from._tzm !== 'undefined') {
	            to._tzm = from._tzm;
	        }
	        if (typeof from._isUTC !== 'undefined') {
	            to._isUTC = from._isUTC;
	        }
	        if (typeof from._offset !== 'undefined') {
	            to._offset = from._offset;
	        }
	        if (typeof from._pf !== 'undefined') {
	            to._pf = getParsingFlags(from);
	        }
	        if (typeof from._locale !== 'undefined') {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (typeof val !== 'undefined') {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function Locale() {}
	
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && typeof module !== 'undefined' && module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(432)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (typeof values === 'undefined') {
	                data = locale_locales__getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, values) {
	        if (values !== null) {
	            values.abbr = name;
	            locales[name] = locales[name] || new Locale();
	            locales[name].set(values);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    // returns locale data
	    function locale_locales__getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get(mom, unit) {
	        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
	    }
	
	    function get_set__set(mom, unit, value) {
	        return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	
	    // MOMENTS
	
	    function getSet(units, value) {
	        var unit;
	        if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (typeof this[units] === 'function') {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function func() {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '';
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1 = /\d/; //       0 - 9
	    var match2 = /\d\d/; //      00 - 99
	    var match3 = /\d{3}/; //     000 - 999
	    var match4 = /\d{4}/; //    0000 - 9999
	    var match6 = /[+-]?\d{6}/; // -999999 - 999999
	    var match1to2 = /\d\d?/; //       0 - 99
	    var match1to3 = /\d{1,3}/; //       0 - 999
	    var match1to4 = /\d{1,4}/; //       0 - 9999
	    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999
	
	    var matchUnsigned = /\d+/; //       0 - inf
	    var matchSigned = /[+-]?\d+/; //    -inf - inf
	
	    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	    var regexes = {};
	
	    function isFunction(sth) {
	        // https://github.com/moment/moment/issues/2325
	        return typeof sth === 'function' && Object.prototype.toString.call(sth) === '[object Function]';
	    }
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict) {
	            return isStrict && strictRegex ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function func(input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', matchWord);
	    addRegexToken('MMMM', matchWord);
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths(m) {
	        return this._months[m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort(m) {
	        return this._monthsShort[m.month()];
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        // TODO: Move this out of here!
	        if (typeof value === 'string') {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (typeof value !== 'number') {
	                return mom;
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function checkOverflow(m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (firstTime) {
	                warn(msg + '\n' + new Error().stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	
	    var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/], ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/], ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/], ['GGGG-[W]WW', /\d{4}-W\d{2}/], ['YYYY-DDD', /\d{4}-\d{3}/]];
	
	    // iso time formats and regexes
	    var isoTimes = [['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/], ['HH:mm', /(T| )\d\d:\d\d/], ['HH', /(T| )\d\d/]];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = from_string__isoRegex.exec(string);
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(string)) {
	                    config._f = isoDates[i][0];
	                    break;
	                }
	            }
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(string)) {
	                    // match[6] should be 'T' or space
	                    config._f += (match[6] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (string.match(matchOffset)) {
	                config._f += 'Z';
	            }
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate('moment construction falls back to js Date. This is ' + 'discouraged and will be removed in upcoming major ' + 'release. Please refer to ' + 'https://github.com/moment/moment/issues/1407 for more info.', function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    });
	
	    function createDate(y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor doesn't accept years < 1970
	        if (y < 1970) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	        if (y < 1970) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', false);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // firstDayOfWeek       0 = sun, 6 = sat
	    //                      the day of the week that starts the week
	    //                      (usually sunday or monday)
	    // firstDayOfWeekOfYear 0 = sun, 6 = sat
	    //                      the first week is the week that contains the first
	    //                      of this day of the week
	    //                      (eg. ISO weeks use thursday (4))
	    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
	        var end = firstDayOfWeekOfYear - firstDayOfWeek,
	            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
	            adjustedMoment;
	
	        if (daysToDayOfWeek > end) {
	            daysToDayOfWeek -= 7;
	        }
	
	        if (daysToDayOfWeek < end - 7) {
	            daysToDayOfWeek += 7;
	        }
	
	        adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
	        return {
	            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
	            year: adjustedMoment.year()
	        };
	    }
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
	        var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear,
	            janX = createUTCDate(year, 0, 1 + week1Jan),
	            d = janX.getUTCDay(),
	            dayOfYear;
	        if (d < firstDayOfWeek) {
	            d += 7;
	        }
	
	        weekday = weekday != null ? 1 * weekday : firstDayOfWeek;
	
	        dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;
	
	        return {
	            year: dayOfYear > 0 ? year : year - 1,
	            dayOfYear: dayOfYear > 0 ? dayOfYear : daysInYear(year - 1) + dayOfYear
	        };
	    }
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        var now = new Date();
	        if (config._useUTC) {
	            return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
	        }
	        return [now.getFullYear(), now.getMonth(), now.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < dow) {
	                    ++week;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);
	
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true && config._a[HOUR] <= 12 && config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    function configFromStringAndArray(config) {
	        var tempConfig, bestMoment, scoreToBeat, i, currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || format === undefined && input === '') {
	            return valid__createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date();
	        } else if (isDate(input)) {
	            config._d = new Date(+input);
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
	            configFromObject(config);
	        } else if (typeof input === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof locale === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate('moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548', function () {
	        var other = local__createLocal.apply(null, arguments);
	        return other < this ? this : other;
	    });
	
	    var prototypeMax = deprecate('moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548', function () {
	        var other = local__createLocal.apply(null, arguments);
	        return other > this ? this : other;
	    });
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 36e5; // 1000 * 60 * 60
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchOffset);
	    addRegexToken('ZZ', matchOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(string) {
	        var matches = (string || '').match(matchOffset) || [];
	        var chunk = matches[matches.length - 1] || [];
	        var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - +res;
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(+res._d + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(input);
	            }
	            if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (typeof this._isDSTShifted !== 'undefined') {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return !this._isUTC;
	    }
	
	    function isUtcOffset() {
	        return this._isUTC;
	    }
	
	    function isUtc() {
	        return this._isUTC && this._offset === 0;
	    }
	
	    var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
	
	    function create__createDuration(input, key) {
	        var duration = input,
	
	        // matching against regexp is expensive, do it on demand
	        match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = create__isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                d: parseIso(match[4], sign),
	                h: parseIso(match[5], sign),
	                m: parseIso(match[6], sign),
	                s: parseIso(match[7], sign),
	                w: parseIso(match[8], sign)
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = { milliseconds: 0, months: 0 };
	
	        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val;val = period;period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = duration._days,
	            months = duration._months;
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(+mom._d + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar(time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
	        return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this > +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return inputMs < +this.clone().startOf(units);
	        }
	    }
	
	    function isBefore(input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this < +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return +this.clone().endOf(units) < inputMs;
	        }
	    }
	
	    function isBetween(from, to, units) {
	        return this.isAfter(from, units) && this.isBefore(to, units);
	    }
	
	    function isSame(input, units) {
	        var inputMs;
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this === +input;
	        } else {
	            inputMs = +local__createLocal(input);
	            return +this.clone().startOf(units) <= inputMs && inputMs <= +this.clone().endOf(units);
	        }
	    }
	
	    function diff(input, units, asFloat) {
	        var that = cloneWithOffset(input, this),
	            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
	            delta,
	            output;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        return -(wholeMonthDiff + adjust);
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString() {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if ('function' === typeof Date.prototype.toISOString) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format(inputString) {
	        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    });
	
	    function localeData() {
	        return this._locale;
	    }
	
	    function startOf(units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	            /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	            /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	                this.hours(0);
	            /* falls through */
	            case 'hour':
	                this.minutes(0);
	            /* falls through */
	            case 'minute':
	                this.seconds(0);
	            /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf(units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	        return this.startOf(units).add(1, units === 'isoWeek' ? 'week' : units).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf() {
	        return +this._d - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(+this / 1000);
	    }
	
	    function toDate() {
	        return this._offset ? new Date(+this) : this._d;
	    }
	
	    function toArray() {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function moment_valid__isValid() {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function weeksInYear(year, dow, doy) {
	        return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
	    }
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
	        return input == null ? year : this.add(input - year, 'y');
	    }
	
	    function getSetISOWeekYear(input) {
	        var year = weekOfYear(this, 1, 4).year;
	        return input == null ? year : this.add(input - year, 'y');
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    addFormatToken('Q', 0, 0, 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', matchWord);
	    addRegexToken('ddd', matchWord);
	    addRegexToken('dddd', matchWord);
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
	        var weekday = config._locale.weekdaysParse(input);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays(m) {
	        return this._weekdays[m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort(m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin(m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function localeWeekdaysParse(weekdayName) {
	        var i, mom, regex;
	
	        this._weekdaysParse = this._weekdaysParse || [];
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            if (!this._weekdaysParse[i]) {
	                mom = local__createLocal([2000, 1]).day(i);
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, function () {
	        return this.hours() % 12 || 12;
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add = add_subtract__add;
	    momentPrototype__proto.calendar = moment_calendar__calendar;
	    momentPrototype__proto.clone = clone;
	    momentPrototype__proto.diff = diff;
	    momentPrototype__proto.endOf = endOf;
	    momentPrototype__proto.format = format;
	    momentPrototype__proto.from = from;
	    momentPrototype__proto.fromNow = fromNow;
	    momentPrototype__proto.to = to;
	    momentPrototype__proto.toNow = toNow;
	    momentPrototype__proto.get = getSet;
	    momentPrototype__proto.invalidAt = invalidAt;
	    momentPrototype__proto.isAfter = isAfter;
	    momentPrototype__proto.isBefore = isBefore;
	    momentPrototype__proto.isBetween = isBetween;
	    momentPrototype__proto.isSame = isSame;
	    momentPrototype__proto.isValid = moment_valid__isValid;
	    momentPrototype__proto.lang = lang;
	    momentPrototype__proto.locale = locale;
	    momentPrototype__proto.localeData = localeData;
	    momentPrototype__proto.max = prototypeMax;
	    momentPrototype__proto.min = prototypeMin;
	    momentPrototype__proto.parsingFlags = parsingFlags;
	    momentPrototype__proto.set = getSet;
	    momentPrototype__proto.startOf = startOf;
	    momentPrototype__proto.subtract = add_subtract__subtract;
	    momentPrototype__proto.toArray = toArray;
	    momentPrototype__proto.toObject = toObject;
	    momentPrototype__proto.toDate = toDate;
	    momentPrototype__proto.toISOString = moment_format__toISOString;
	    momentPrototype__proto.toJSON = moment_format__toISOString;
	    momentPrototype__proto.toString = toString;
	    momentPrototype__proto.unix = unix;
	    momentPrototype__proto.valueOf = to_type__valueOf;
	
	    // Year
	    momentPrototype__proto.year = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week = momentPrototype__proto.weeks = getSetWeek;
	    momentPrototype__proto.isoWeek = momentPrototype__proto.isoWeeks = getSetISOWeek;
	    momentPrototype__proto.weeksInYear = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date = getSetDayOfMonth;
	    momentPrototype__proto.day = momentPrototype__proto.days = getSetDayOfWeek;
	    momentPrototype__proto.weekday = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset = getSetOffset;
	    momentPrototype__proto.utc = setOffsetToUTC;
	    momentPrototype__proto.local = setOffsetToLocal;
	    momentPrototype__proto.parseZone = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal = isLocal;
	    momentPrototype__proto.isUtcOffset = isUtcOffset;
	    momentPrototype__proto.isUtc = isUtc;
	    momentPrototype__proto.isUTC = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix(input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone() {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L'
	    };
	
	    function locale_calendar__calendar(key, mom, now) {
	        var output = this._calendar[key];
	        return typeof output === 'function' ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years'
	    };
	
	    function relative__relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return typeof output === 'function' ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
	    }
	
	    function locale_set__set(config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (typeof prop === 'function') {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + /\d{1,2}/.source);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar = defaultCalendar;
	    prototype__proto.calendar = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat = longDateFormat;
	    prototype__proto._invalidDate = defaultInvalidDate;
	    prototype__proto.invalidDate = invalidDate;
	    prototype__proto._ordinal = defaultOrdinal;
	    prototype__proto.ordinal = ordinal;
	    prototype__proto._ordinalParse = defaultOrdinalParse;
	    prototype__proto.preparse = preParsePostFormat;
	    prototype__proto.postformat = preParsePostFormat;
	    prototype__proto._relativeTime = defaultRelativeTime;
	    prototype__proto.relativeTime = relative__relativeTime;
	    prototype__proto.pastFuture = pastFuture;
	    prototype__proto.set = locale_set__set;
	
	    // Month
	    prototype__proto.months = localeMonths;
	    prototype__proto._months = defaultLocaleMonths;
	    prototype__proto.monthsShort = localeMonthsShort;
	    prototype__proto._monthsShort = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse = localeMonthsParse;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays = localeWeekdays;
	    prototype__proto._weekdays = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin = localeWeekdaysMin;
	    prototype__proto._weekdaysMin = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort = localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse = localeWeekdaysParse;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get(format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function list(format, index, field, count, setter) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, setter);
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < count; i++) {
	            out[i] = lists__get(format, i, field, setter);
	        }
	        return out;
	    }
	
	    function lists__listMonths(format, index) {
	        return list(format, index, 'months', 12, 'month');
	    }
	
	    function lists__listMonthsShort(format, index) {
	        return list(format, index, 'monthsShort', 12, 'month');
	    }
	
	    function lists__listWeekdays(format, index) {
	        return list(format, index, 'weekdays', 7, 'day');
	    }
	
	    function lists__listWeekdaysShort(format, index) {
	        return list(format, index, 'weekdaysShort', 7, 'day');
	    }
	
	    function lists__listWeekdaysMin(format, index) {
	        return list(format, index, 'weekdaysMin', 7, 'day');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract(duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add(input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract(input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds;
	        var days = this._days;
	        var months = this._months;
	        var data = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as(units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf() {
	        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds = makeAs('s');
	    var asMinutes = makeAs('m');
	    var asHours = makeAs('h');
	    var asDays = makeAs('d');
	    var asWeeks = makeAs('w');
	    var asMonths = makeAs('M');
	    var asYears = makeAs('y');
	
	    function duration_get__get(units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds = makeGetter('seconds');
	    var minutes = makeGetter('minutes');
	    var hours = makeGetter('hours');
	    var days = makeGetter('days');
	    var months = makeGetter('months');
	    var years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45, // seconds to minute
	        m: 45, // minutes to hour
	        h: 22, // hours to day
	        d: 26, // days to month
	        M: 11 // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime(posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds = round(duration.as('s'));
	        var minutes = round(duration.as('m'));
	        var hours = round(duration.as('h'));
	        var days = round(duration.as('d'));
	        var months = round(duration.as('M'));
	        var years = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds] || minutes === 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours === 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days === 1 && ['d'] || days < thresholds.d && ['dd', days] || months === 1 && ['M'] || months < thresholds.M && ['MM', months] || years === 1 && ['y'] || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize(withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days = iso_string__abs(this._days);
	        var months = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') + 'P' + (Y ? Y + 'Y' : '') + (M ? M + 'M' : '') + (D ? D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? h + 'H' : '') + (m ? m + 'M' : '') + (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs = duration_abs__abs;
	    duration_prototype__proto.add = duration_add_subtract__add;
	    duration_prototype__proto.subtract = duration_add_subtract__subtract;
	    duration_prototype__proto.as = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds = asSeconds;
	    duration_prototype__proto.asMinutes = asMinutes;
	    duration_prototype__proto.asHours = asHours;
	    duration_prototype__proto.asDays = asDays;
	    duration_prototype__proto.asWeeks = asWeeks;
	    duration_prototype__proto.asMonths = asMonths;
	    duration_prototype__proto.asYears = asYears;
	    duration_prototype__proto.valueOf = duration_as__valueOf;
	    duration_prototype__proto._bubble = bubble;
	    duration_prototype__proto.get = duration_get__get;
	    duration_prototype__proto.milliseconds = milliseconds;
	    duration_prototype__proto.seconds = seconds;
	    duration_prototype__proto.minutes = minutes;
	    duration_prototype__proto.hours = hours;
	    duration_prototype__proto.days = days;
	    duration_prototype__proto.weeks = weeks;
	    duration_prototype__proto.months = months;
	    duration_prototype__proto.years = years;
	    duration_prototype__proto.humanize = humanize;
	    duration_prototype__proto.toISOString = iso_string__toISOString;
	    duration_prototype__proto.toString = iso_string__toISOString;
	    duration_prototype__proto.toJSON = iso_string__toISOString;
	    duration_prototype__proto.locale = locale;
	    duration_prototype__proto.localeData = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.10.6';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn = momentPrototype;
	    utils_hooks__hooks.min = min;
	    utils_hooks__hooks.max = max;
	    utils_hooks__hooks.utc = create_utc__createUTC;
	    utils_hooks__hooks.unix = moment__createUnix;
	    utils_hooks__hooks.months = lists__listMonths;
	    utils_hooks__hooks.isDate = isDate;
	    utils_hooks__hooks.locale = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid = valid__createInvalid;
	    utils_hooks__hooks.duration = create__createDuration;
	    utils_hooks__hooks.isMoment = isMoment;
	    utils_hooks__hooks.weekdays = lists__listWeekdays;
	    utils_hooks__hooks.parseZone = moment__createInZone;
	    utils_hooks__hooks.localeData = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration = isDuration;
	    utils_hooks__hooks.monthsShort = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale = defineLocale;
	    utils_hooks__hooks.weekdaysShort = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var _UtilsStringUtils = __webpack_require__(115);
	
	var _UtilsStringUtils2 = _interopRequireDefault(_UtilsStringUtils);
	
	var Field = function () {
	    function Field(name) {
	        _classCallCheck(this, Field);
	
	        this._name = name || Math.random().toString(36).substring(7);
	        this._detailLink = name === 'id';
	        this._type = "string";
	        this._order = null;
	        this._label = null;
	        this._maps = [];
	        this._transforms = [];
	        this._attributes = {};
	        this._cssClasses = null;
	        this._validation = { required: false, minlength: 0, maxlength: 99999 };
	        this._defaultValue = null;
	        this._editable = true;
	        this._sortable = true;
	        this._detailLinkRoute = 'edit';
	        this._pinned = false;
	        this._flattenable = true;
	        this._helpText = null;
	        this.dashboard = true;
	        this.list = true;
	        this._template = function () {
	            return '';
	        };
	        this._templateIncludesLabel = false;
	    }
	
	    _createClass(Field, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _UtilsStringUtils2["default"].camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "type",
	        value: function type() {
	            return this._type;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "order",
	        value: function order() {
	            if (arguments.length) {
	                if (arguments[1] !== true) {
	                    console.warn('Setting order with Field.order is deprecated, order directly in fields array');
	                }
	                this._order = arguments[0];
	                return this;
	            }
	
	            return this._order;
	        }
	    }, {
	        key: "isDetailLink",
	        value: function isDetailLink(detailLink) {
	            if (arguments.length) {
	                this._detailLink = arguments[0];
	                return this;
	            }
	
	            if (this._detailLink === null) {
	                return this._name === 'id';
	            }
	
	            return this._detailLink;
	        }
	    }, {
	        key: "map",
	
	        /**
	         * Add a function to be applied to the response object to turn it into an entry
	         */
	        value: function map(fn) {
	            if (!fn) return this._maps;
	            if (typeof fn !== "function") {
	                var type = typeof fn === "undefined" ? "undefined" : _typeof(fn);
	                throw new Error("Map argument should be a function, " + type + " given.");
	            }
	
	            this._maps.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasMaps",
	        value: function hasMaps() {
	            return !!this._maps.length;
	        }
	    }, {
	        key: "getMappedValue",
	        value: function getMappedValue(value, entry) {
	            for (var i in this._maps) {
	                value = this._maps[i](value, entry);
	            }
	
	            return value;
	        }
	
	        /**
	         * Add a function to be applied to the entry to turn it into a response object
	         */
	    }, {
	        key: "transform",
	        value: function transform(fn) {
	            if (!fn) return this._transforms;
	            if (typeof fn !== "function") {
	                var type = typeof fn === "undefined" ? "undefined" : _typeof(fn);
	                throw new Error("transform argument should be a function, " + type + " given.");
	            }
	
	            this._transforms.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasTranforms",
	        value: function hasTranforms() {
	            return !!this._transforms.length;
	        }
	    }, {
	        key: "getTransformedValue",
	        value: function getTransformedValue(value, entry) {
	            for (var i in this._transforms) {
	                value = this._transforms[i](value, entry);
	            }
	
	            return value;
	        }
	    }, {
	        key: "attributes",
	        value: function attributes(_attributes) {
	            if (!arguments.length) {
	                return this._attributes;
	            }
	
	            this._attributes = _attributes;
	
	            return this;
	        }
	    }, {
	        key: "cssClasses",
	        value: function cssClasses(classes) {
	            if (!arguments.length) return this._cssClasses;
	            this._cssClasses = classes;
	            return this;
	        }
	    }, {
	        key: "getCssClasses",
	        value: function getCssClasses(entry) {
	            if (!this._cssClasses) {
	                return '';
	            }
	
	            if (this._cssClasses.constructor === Array) {
	                return this._cssClasses.join(' ');
	            }
	
	            if (typeof this._cssClasses === 'function') {
	                return this._cssClasses(entry);
	            }
	
	            return this._cssClasses;
	        }
	    }, {
	        key: "validation",
	        value: function validation(_validation) {
	            if (!arguments.length) {
	                return this._validation;
	            }
	
	            for (var property in _validation) {
	                if (!_validation.hasOwnProperty(property)) continue;
	                if (_validation[property] === null) {
	                    delete this._validation[property];
	                } else {
	                    this._validation[property] = _validation[property];
	                }
	            }
	
	            return this;
	        }
	    }, {
	        key: "defaultValue",
	        value: function defaultValue(_defaultValue) {
	            if (!arguments.length) return this._defaultValue;
	            this._defaultValue = _defaultValue;
	            return this;
	        }
	    }, {
	        key: "editable",
	        value: function editable(_editable) {
	            if (!arguments.length) return this._editable;
	            this._editable = _editable;
	            return this;
	        }
	    }, {
	        key: "sortable",
	        value: function sortable(_sortable) {
	            if (!arguments.length) return this._sortable;
	            this._sortable = _sortable;
	            return this;
	        }
	    }, {
	        key: "detailLinkRoute",
	        value: function detailLinkRoute(route) {
	            if (!arguments.length) return this._detailLinkRoute;
	            this._detailLinkRoute = route;
	            return this;
	        }
	    }, {
	        key: "pinned",
	        value: function pinned(_pinned) {
	            if (!arguments.length) return this._pinned;
	            this._pinned = _pinned;
	            return this;
	        }
	    }, {
	        key: "flattenable",
	        value: function flattenable() {
	            return this._flattenable;
	        }
	    }, {
	        key: "helpText",
	        value: function helpText() {
	            if (arguments.length) {
	                this._helpText = arguments[0];
	                return this;
	            }
	
	            return this._helpText;
	        }
	    }, {
	        key: "getTemplateValue",
	        value: function getTemplateValue(data) {
	            if (typeof this._template === 'function') {
	                return this._template(data);
	            }
	
	            return this._template;
	        }
	    }, {
	        key: "getTemplateValueWithLabel",
	        value: function getTemplateValueWithLabel(data) {
	            return this._templateIncludesLabel ? this.getTemplateValue(data) : false;
	        }
	    }, {
	        key: "templateIncludesLabel",
	        value: function templateIncludesLabel(_templateIncludesLabel) {
	            if (!arguments.length) return this._templateIncludesLabel;
	            this._templateIncludesLabel = _templateIncludesLabel;
	            return this;
	        }
	    }, {
	        key: "template",
	        value: function template(_template) {
	            var templateIncludesLabel = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            if (!arguments.length) return this._template;
	            this._template = _template;
	            this._templateIncludesLabel = templateIncludesLabel;
	            return this;
	        }
	    }, {
	        key: "detailLink",
	        set: function set(isDetailLink) {
	            return this._detailLink = isDetailLink;
	        }
	    }]);
	
	    return Field;
	}();
	
	exports["default"] = Field;
	module.exports = exports["default"];
	//# sourceMappingURL=Field.js.map

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// This is CodeMirror (http://codemirror.net), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.CodeMirror = factory();
	})(undefined, function () {
	  'use strict';
	
	  // Kludges for bugs and behavior differences that can't be feature
	  // detected are enabled based on userAgent etc sniffing.
	
	  var userAgent = navigator.userAgent;
	  var platform = navigator.platform;
	
	  var gecko = /gecko\/\d/i.test(userAgent);
	  var ie_upto10 = /MSIE \d/.test(userAgent);
	  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
	  var edge = /Edge\/(\d+)/.exec(userAgent);
	  var ie = ie_upto10 || ie_11up || edge;
	  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
	  var webkit = !edge && /WebKit\//.test(userAgent);
	  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
	  var chrome = !edge && /Chrome\//.test(userAgent);
	  var presto = /Opera\//.test(userAgent);
	  var safari = /Apple Computer/.test(navigator.vendor);
	  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
	  var phantom = /PhantomJS/.test(userAgent);
	
	  var ios = !edge && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
	  var android = /Android/.test(userAgent);
	  // This is woefully incomplete. Suggestions for alternative methods welcome.
	  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
	  var mac = ios || /Mac/.test(platform);
	  var chromeOS = /\bCrOS\b/.test(userAgent);
	  var windows = /win/i.test(platform);
	
	  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
	  if (presto_version) {
	    presto_version = Number(presto_version[1]);
	  }
	  if (presto_version && presto_version >= 15) {
	    presto = false;webkit = true;
	  }
	  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
	  var captureRightClick = gecko || ie && ie_version >= 9;
	
	  function classTest(cls) {
	    return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
	  }
	
	  var rmClass = function rmClass(node, cls) {
	    var current = node.className;
	    var match = classTest(cls).exec(current);
	    if (match) {
	      var after = current.slice(match.index + match[0].length);
	      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
	    }
	  };
	
	  function removeChildren(e) {
	    for (var count = e.childNodes.length; count > 0; --count) {
	      e.removeChild(e.firstChild);
	    }
	    return e;
	  }
	
	  function removeChildrenAndAdd(parent, e) {
	    return removeChildren(parent).appendChild(e);
	  }
	
	  function elt(tag, content, className, style) {
	    var e = document.createElement(tag);
	    if (className) {
	      e.className = className;
	    }
	    if (style) {
	      e.style.cssText = style;
	    }
	    if (typeof content == "string") {
	      e.appendChild(document.createTextNode(content));
	    } else if (content) {
	      for (var i = 0; i < content.length; ++i) {
	        e.appendChild(content[i]);
	      }
	    }
	    return e;
	  }
	  // wrapper for elt, which removes the elt from the accessibility tree
	  function eltP(tag, content, className, style) {
	    var e = elt(tag, content, className, style);
	    e.setAttribute("role", "presentation");
	    return e;
	  }
	
	  var range;
	  if (document.createRange) {
	    range = function range(node, start, end, endNode) {
	      var r = document.createRange();
	      r.setEnd(endNode || node, end);
	      r.setStart(node, start);
	      return r;
	    };
	  } else {
	    range = function range(node, start, end) {
	      var r = document.body.createTextRange();
	      try {
	        r.moveToElementText(node.parentNode);
	      } catch (e) {
	        return r;
	      }
	      r.collapse(true);
	      r.moveEnd("character", end);
	      r.moveStart("character", start);
	      return r;
	    };
	  }
	
	  function contains(parent, child) {
	    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	      {
	        child = child.parentNode;
	      }
	    if (parent.contains) {
	      return parent.contains(child);
	    }
	    do {
	      if (child.nodeType == 11) {
	        child = child.host;
	      }
	      if (child == parent) {
	        return true;
	      }
	    } while (child = child.parentNode);
	  }
	
	  function activeElt() {
	    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	    // IE < 10 will throw when accessed while the page is loading or in an iframe.
	    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	    var activeElement;
	    try {
	      activeElement = document.activeElement;
	    } catch (e) {
	      activeElement = document.body || null;
	    }
	    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement) {
	      activeElement = activeElement.shadowRoot.activeElement;
	    }
	    return activeElement;
	  }
	
	  function addClass(node, cls) {
	    var current = node.className;
	    if (!classTest(cls).test(current)) {
	      node.className += (current ? " " : "") + cls;
	    }
	  }
	  function joinClasses(a, b) {
	    var as = a.split(" ");
	    for (var i = 0; i < as.length; i++) {
	      if (as[i] && !classTest(as[i]).test(b)) {
	        b += " " + as[i];
	      }
	    }
	    return b;
	  }
	
	  var selectInput = function selectInput(node) {
	    node.select();
	  };
	  if (ios) // Mobile Safari apparently has a bug where select() is broken.
	    {
	      selectInput = function selectInput(node) {
	        node.selectionStart = 0;node.selectionEnd = node.value.length;
	      };
	    } else if (ie) // Suppress mysterious IE10 errors
	    {
	      selectInput = function selectInput(node) {
	        try {
	          node.select();
	        } catch (_e) {}
	      };
	    }
	
	  function bind(f) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return function () {
	      return f.apply(null, args);
	    };
	  }
	
	  function copyObj(obj, target, overwrite) {
	    if (!target) {
	      target = {};
	    }
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) {
	        target[prop] = obj[prop];
	      }
	    }
	    return target;
	  }
	
	  // Counts the column offset in a string, taking tabs into account.
	  // Used mostly to find indentation.
	  function countColumn(string, end, tabSize, startIndex, startValue) {
	    if (end == null) {
	      end = string.search(/[^\s\u00a0]/);
	      if (end == -1) {
	        end = string.length;
	      }
	    }
	    for (var i = startIndex || 0, n = startValue || 0;;) {
	      var nextTab = string.indexOf("\t", i);
	      if (nextTab < 0 || nextTab >= end) {
	        return n + (end - i);
	      }
	      n += nextTab - i;
	      n += tabSize - n % tabSize;
	      i = nextTab + 1;
	    }
	  }
	
	  var Delayed = function Delayed() {
	    this.id = null;
	  };
	  Delayed.prototype.set = function (ms, f) {
	    clearTimeout(this.id);
	    this.id = setTimeout(f, ms);
	  };
	
	  function indexOf(array, elt) {
	    for (var i = 0; i < array.length; ++i) {
	      if (array[i] == elt) {
	        return i;
	      }
	    }
	    return -1;
	  }
	
	  // Number of pixels added to scroller and sizer to hide scrollbar
	  var scrollerGap = 30;
	
	  // Returned or thrown by various protocols to signal 'I'm not
	  // handling this'.
	  var Pass = { toString: function toString() {
	      return "CodeMirror.Pass";
	    } };
	
	  // Reused option objects for setSelection & friends
	  var sel_dontScroll = { scroll: false };
	  var sel_mouse = { origin: "*mouse" };
	  var sel_move = { origin: "+move" };
	
	  // The inverse of countColumn -- find the offset that corresponds to
	  // a particular column.
	  function findColumn(string, goal, tabSize) {
	    for (var pos = 0, col = 0;;) {
	      var nextTab = string.indexOf("\t", pos);
	      if (nextTab == -1) {
	        nextTab = string.length;
	      }
	      var skipped = nextTab - pos;
	      if (nextTab == string.length || col + skipped >= goal) {
	        return pos + Math.min(skipped, goal - col);
	      }
	      col += nextTab - pos;
	      col += tabSize - col % tabSize;
	      pos = nextTab + 1;
	      if (col >= goal) {
	        return pos;
	      }
	    }
	  }
	
	  var spaceStrs = [""];
	  function spaceStr(n) {
	    while (spaceStrs.length <= n) {
	      spaceStrs.push(lst(spaceStrs) + " ");
	    }
	    return spaceStrs[n];
	  }
	
	  function lst(arr) {
	    return arr[arr.length - 1];
	  }
	
	  function map(array, f) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) {
	      out[i] = f(array[i], i);
	    }
	    return out;
	  }
	
	  function insertSorted(array, value, score) {
	    var pos = 0,
	        priority = score(value);
	    while (pos < array.length && score(array[pos]) <= priority) {
	      pos++;
	    }
	    array.splice(pos, 0, value);
	  }
	
	  function nothing() {}
	
	  function createObj(base, props) {
	    var inst;
	    if (Object.create) {
	      inst = Object.create(base);
	    } else {
	      nothing.prototype = base;
	      inst = new nothing();
	    }
	    if (props) {
	      copyObj(props, inst);
	    }
	    return inst;
	  }
	
	  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
	  function isWordCharBasic(ch) {
	    return (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
	    );
	  }
	  function isWordChar(ch, helper) {
	    if (!helper) {
	      return isWordCharBasic(ch);
	    }
	    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) {
	      return true;
	    }
	    return helper.test(ch);
	  }
	
	  function isEmpty(obj) {
	    for (var n in obj) {
	      if (obj.hasOwnProperty(n) && obj[n]) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  // Extending unicode characters. A series of a non-extending char +
	  // any number of extending chars is treated as a single unit as far
	  // as editing and measuring is concerned. This is not fully correct,
	  // since some scripts/fonts/browsers also treat other configurations
	  // of code points as a group.
	  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
	  function isExtendingChar(ch) {
	    return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
	  }
	
	  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
	  function skipExtendingChars(str, pos, dir) {
	    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) {
	      pos += dir;
	    }
	    return pos;
	  }
	
	  // Returns the value from the range [`from`; `to`] that satisfies
	  // `pred` and is closest to `from`. Assumes that at least `to`
	  // satisfies `pred`. Supports `from` being greater than `to`.
	  function findFirst(pred, from, to) {
	    // At any point we are certain `to` satisfies `pred`, don't know
	    // whether `from` does.
	    var dir = from > to ? -1 : 1;
	    for (;;) {
	      if (from == to) {
	        return from;
	      }
	      var midF = (from + to) / 2,
	          mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
	      if (mid == from) {
	        return pred(mid) ? from : to;
	      }
	      if (pred(mid)) {
	        to = mid;
	      } else {
	        from = mid + dir;
	      }
	    }
	  }
	
	  // The display handles the DOM integration, both for input reading
	  // and content drawing. It holds references to DOM nodes and
	  // display-related state.
	
	  function Display(place, doc, input) {
	    var d = this;
	    this.input = input;
	
	    // Covers bottom-right square when both scrollbars are present.
	    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
	    d.scrollbarFiller.setAttribute("cm-not-content", "true");
	    // Covers bottom of gutter when coverGutterNextToScrollbar is on
	    // and h scrollbar is present.
	    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
	    d.gutterFiller.setAttribute("cm-not-content", "true");
	    // Will contain the actual code, positioned to cover the viewport.
	    d.lineDiv = eltP("div", null, "CodeMirror-code");
	    // Elements are added to these to represent selection and cursors.
	    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
	    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
	    // A visibility: hidden element used to find the size of things.
	    d.measure = elt("div", null, "CodeMirror-measure");
	    // When lines outside of the viewport are measured, they are drawn in this.
	    d.lineMeasure = elt("div", null, "CodeMirror-measure");
	    // Wraps everything that needs to exist inside the vertically-padded coordinate system
	    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv], null, "position: relative; outline: none");
	    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
	    // Moved around its parent to cover visible view.
	    d.mover = elt("div", [lines], null, "position: relative");
	    // Set to the height of the document, allowing scrolling.
	    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
	    d.sizerWidth = null;
	    // Behavior of elts with overflow: auto and padding is
	    // inconsistent across browsers. This is used to ensure the
	    // scrollable area is big enough.
	    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
	    // Will contain the gutters, if any.
	    d.gutters = elt("div", null, "CodeMirror-gutters");
	    d.lineGutter = null;
	    // Actual scrollable element.
	    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
	    d.scroller.setAttribute("tabIndex", "-1");
	    // The element in which the editor lives.
	    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");
	
	    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	    if (ie && ie_version < 8) {
	      d.gutters.style.zIndex = -1;d.scroller.style.paddingRight = 0;
	    }
	    if (!webkit && !(gecko && mobile)) {
	      d.scroller.draggable = true;
	    }
	
	    if (place) {
	      if (place.appendChild) {
	        place.appendChild(d.wrapper);
	      } else {
	        place(d.wrapper);
	      }
	    }
	
	    // Current rendered range (may be bigger than the view window).
	    d.viewFrom = d.viewTo = doc.first;
	    d.reportedViewFrom = d.reportedViewTo = doc.first;
	    // Information about the rendered lines.
	    d.view = [];
	    d.renderedView = null;
	    // Holds info about a single rendered line when it was rendered
	    // for measurement, while not in view.
	    d.externalMeasured = null;
	    // Empty space (in pixels) above the view
	    d.viewOffset = 0;
	    d.lastWrapHeight = d.lastWrapWidth = 0;
	    d.updateLineNumbers = null;
	
	    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
	    d.scrollbarsClipped = false;
	
	    // Used to only resize the line number gutter when necessary (when
	    // the amount of lines crosses a boundary that makes its width change)
	    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
	    // Set to true when a non-horizontal-scrolling line widget is
	    // added. As an optimization, line widget aligning is skipped when
	    // this is false.
	    d.alignWidgets = false;
	
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	
	    // Tracks the maximum line length so that the horizontal scrollbar
	    // can be kept static when scrolling.
	    d.maxLine = null;
	    d.maxLineLength = 0;
	    d.maxLineChanged = false;
	
	    // Used for measuring wheel scrolling granularity
	    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
	
	    // True when shift is held down.
	    d.shift = false;
	
	    // Used to track whether anything happened since the context menu
	    // was opened.
	    d.selForContextMenu = null;
	
	    d.activeTouch = null;
	
	    input.init(d);
	  }
	
	  // Find the line object corresponding to the given line number.
	  function getLine(doc, n) {
	    n -= doc.first;
	    if (n < 0 || n >= doc.size) {
	      throw new Error("There is no line " + (n + doc.first) + " in the document.");
	    }
	    var chunk = doc;
	    while (!chunk.lines) {
	      for (var i = 0;; ++i) {
	        var child = chunk.children[i],
	            sz = child.chunkSize();
	        if (n < sz) {
	          chunk = child;break;
	        }
	        n -= sz;
	      }
	    }
	    return chunk.lines[n];
	  }
	
	  // Get the part of a document between two positions, as an array of
	  // strings.
	  function getBetween(doc, start, end) {
	    var out = [],
	        n = start.line;
	    doc.iter(start.line, end.line + 1, function (line) {
	      var text = line.text;
	      if (n == end.line) {
	        text = text.slice(0, end.ch);
	      }
	      if (n == start.line) {
	        text = text.slice(start.ch);
	      }
	      out.push(text);
	      ++n;
	    });
	    return out;
	  }
	  // Get the lines between from and to, as array of strings.
	  function getLines(doc, from, to) {
	    var out = [];
	    doc.iter(from, to, function (line) {
	      out.push(line.text);
	    }); // iter aborts when callback returns truthy value
	    return out;
	  }
	
	  // Update the height of a line, propagating the height change
	  // upwards to parent nodes.
	  function updateLineHeight(line, height) {
	    var diff = height - line.height;
	    if (diff) {
	      for (var n = line; n; n = n.parent) {
	        n.height += diff;
	      }
	    }
	  }
	
	  // Given a line object, find its line number by walking up through
	  // its parent links.
	  function lineNo(line) {
	    if (line.parent == null) {
	      return null;
	    }
	    var cur = line.parent,
	        no = indexOf(cur.lines, line);
	    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	      for (var i = 0;; ++i) {
	        if (chunk.children[i] == cur) {
	          break;
	        }
	        no += chunk.children[i].chunkSize();
	      }
	    }
	    return no + cur.first;
	  }
	
	  // Find the line at the given vertical position, using the height
	  // information in the document tree.
	  function _lineAtHeight(chunk, h) {
	    var n = chunk.first;
	    outer: do {
	      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
	        var child = chunk.children[i$1],
	            ch = child.height;
	        if (h < ch) {
	          chunk = child;continue outer;
	        }
	        h -= ch;
	        n += child.chunkSize();
	      }
	      return n;
	    } while (!chunk.lines);
	    var i = 0;
	    for (; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i],
	          lh = line.height;
	      if (h < lh) {
	        break;
	      }
	      h -= lh;
	    }
	    return n + i;
	  }
	
	  function isLine(doc, l) {
	    return l >= doc.first && l < doc.first + doc.size;
	  }
	
	  function lineNumberFor(options, i) {
	    return String(options.lineNumberFormatter(i + options.firstLineNumber));
	  }
	
	  // A Pos instance represents a position within the text.
	  function Pos(line, ch, sticky) {
	    if (sticky === void 0) sticky = null;
	
	    if (!(this instanceof Pos)) {
	      return new Pos(line, ch, sticky);
	    }
	    this.line = line;
	    this.ch = ch;
	    this.sticky = sticky;
	  }
	
	  // Compare two positions, return 0 if they are the same, a negative
	  // number when a is less, and a positive number otherwise.
	  function cmp(a, b) {
	    return a.line - b.line || a.ch - b.ch;
	  }
	
	  function equalCursorPos(a, b) {
	    return a.sticky == b.sticky && cmp(a, b) == 0;
	  }
	
	  function copyPos(x) {
	    return Pos(x.line, x.ch);
	  }
	  function maxPos(a, b) {
	    return cmp(a, b) < 0 ? b : a;
	  }
	  function minPos(a, b) {
	    return cmp(a, b) < 0 ? a : b;
	  }
	
	  // Most of the external API clips given positions to make sure they
	  // actually exist within the document.
	  function clipLine(doc, n) {
	    return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
	  }
	  function _clipPos(doc, pos) {
	    if (pos.line < doc.first) {
	      return Pos(doc.first, 0);
	    }
	    var last = doc.first + doc.size - 1;
	    if (pos.line > last) {
	      return Pos(last, getLine(doc, last).text.length);
	    }
	    return clipToLen(pos, getLine(doc, pos.line).text.length);
	  }
	  function clipToLen(pos, linelen) {
	    var ch = pos.ch;
	    if (ch == null || ch > linelen) {
	      return Pos(pos.line, linelen);
	    } else if (ch < 0) {
	      return Pos(pos.line, 0);
	    } else {
	      return pos;
	    }
	  }
	  function clipPosArray(doc, array) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) {
	      out[i] = _clipPos(doc, array[i]);
	    }
	    return out;
	  }
	
	  // Optimize some code when these features are not used.
	  var sawReadOnlySpans = false;
	  var sawCollapsedSpans = false;
	
	  function seeReadOnlySpans() {
	    sawReadOnlySpans = true;
	  }
	
	  function seeCollapsedSpans() {
	    sawCollapsedSpans = true;
	  }
	
	  // TEXTMARKER SPANS
	
	  function MarkedSpan(marker, from, to) {
	    this.marker = marker;
	    this.from = from;this.to = to;
	  }
	
	  // Search an array of spans for a span matching the given marker.
	  function getMarkedSpanFor(spans, marker) {
	    if (spans) {
	      for (var i = 0; i < spans.length; ++i) {
	        var span = spans[i];
	        if (span.marker == marker) {
	          return span;
	        }
	      }
	    }
	  }
	  // Remove a span from an array, returning undefined if no spans are
	  // left (we don't store arrays for lines without spans).
	  function removeMarkedSpan(spans, span) {
	    var r;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i] != span) {
	        (r || (r = [])).push(spans[i]);
	      }
	    }
	    return r;
	  }
	  // Add a span to a line.
	  function addMarkedSpan(line, span) {
	    line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
	    span.marker.attachLine(line);
	  }
	
	  // Used for the algorithm that adjusts markers for a change in the
	  // document. These functions cut an array of spans at a given
	  // character position, returning an array of remaining chunks (or
	  // undefined if nothing remains).
	  function markedSpansBefore(old, startCh, isInsert) {
	    var nw;
	    if (old) {
	      for (var i = 0; i < old.length; ++i) {
	        var span = old[i],
	            marker = span.marker;
	        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
	        if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	          var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
	        }
	      }
	    }
	    return nw;
	  }
	  function markedSpansAfter(old, endCh, isInsert) {
	    var nw;
	    if (old) {
	      for (var i = 0; i < old.length; ++i) {
	        var span = old[i],
	            marker = span.marker;
	        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
	        if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	          var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
	        }
	      }
	    }
	    return nw;
	  }
	
	  // Given a change object, compute the new set of marker spans that
	  // cover the line in which the change took place. Removes spans
	  // entirely within the change, reconnects spans belonging to the
	  // same marker that appear on both sides of the change, and cuts off
	  // spans partially within the change. Returns an array of span
	  // arrays with one element for each line in (after) the change.
	  function stretchSpansOverChange(doc, change) {
	    if (change.full) {
	      return null;
	    }
	    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
	    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
	    if (!oldFirst && !oldLast) {
	      return null;
	    }
	
	    var startCh = change.from.ch,
	        endCh = change.to.ch,
	        isInsert = cmp(change.from, change.to) == 0;
	    // Get the spans that 'stick out' on both sides
	    var first = markedSpansBefore(oldFirst, startCh, isInsert);
	    var last = markedSpansAfter(oldLast, endCh, isInsert);
	
	    // Next, merge those two ends
	    var sameLine = change.text.length == 1,
	        offset = lst(change.text).length + (sameLine ? startCh : 0);
	    if (first) {
	      // Fix up .to properties of first
	      for (var i = 0; i < first.length; ++i) {
	        var span = first[i];
	        if (span.to == null) {
	          var found = getMarkedSpanFor(last, span.marker);
	          if (!found) {
	            span.to = startCh;
	          } else if (sameLine) {
	            span.to = found.to == null ? null : found.to + offset;
	          }
	        }
	      }
	    }
	    if (last) {
	      // Fix up .from in last (or move them into first in case of sameLine)
	      for (var i$1 = 0; i$1 < last.length; ++i$1) {
	        var span$1 = last[i$1];
	        if (span$1.to != null) {
	          span$1.to += offset;
	        }
	        if (span$1.from == null) {
	          var found$1 = getMarkedSpanFor(first, span$1.marker);
	          if (!found$1) {
	            span$1.from = offset;
	            if (sameLine) {
	              (first || (first = [])).push(span$1);
	            }
	          }
	        } else {
	          span$1.from += offset;
	          if (sameLine) {
	            (first || (first = [])).push(span$1);
	          }
	        }
	      }
	    }
	    // Make sure we didn't create any zero-length spans
	    if (first) {
	      first = clearEmptySpans(first);
	    }
	    if (last && last != first) {
	      last = clearEmptySpans(last);
	    }
	
	    var newMarkers = [first];
	    if (!sameLine) {
	      // Fill gap with whole-line-spans
	      var gap = change.text.length - 2,
	          gapMarkers;
	      if (gap > 0 && first) {
	        for (var i$2 = 0; i$2 < first.length; ++i$2) {
	          if (first[i$2].to == null) {
	            (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
	          }
	        }
	      }
	      for (var i$3 = 0; i$3 < gap; ++i$3) {
	        newMarkers.push(gapMarkers);
	      }
	      newMarkers.push(last);
	    }
	    return newMarkers;
	  }
	
	  // Remove spans that are empty and don't have a clearWhenEmpty
	  // option of false.
	  function clearEmptySpans(spans) {
	    for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) {
	        spans.splice(i--, 1);
	      }
	    }
	    if (!spans.length) {
	      return null;
	    }
	    return spans;
	  }
	
	  // Used to 'clip' out readOnly ranges when making a change.
	  function removeReadOnlyRanges(doc, from, to) {
	    var markers = null;
	    doc.iter(from.line, to.line + 1, function (line) {
	      if (line.markedSpans) {
	        for (var i = 0; i < line.markedSpans.length; ++i) {
	          var mark = line.markedSpans[i].marker;
	          if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) {
	            (markers || (markers = [])).push(mark);
	          }
	        }
	      }
	    });
	    if (!markers) {
	      return null;
	    }
	    var parts = [{ from: from, to: to }];
	    for (var i = 0; i < markers.length; ++i) {
	      var mk = markers[i],
	          m = mk.find(0);
	      for (var j = 0; j < parts.length; ++j) {
	        var p = parts[j];
	        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) {
	          continue;
	        }
	        var newParts = [j, 1],
	            dfrom = cmp(p.from, m.from),
	            dto = cmp(p.to, m.to);
	        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) {
	          newParts.push({ from: p.from, to: m.from });
	        }
	        if (dto > 0 || !mk.inclusiveRight && !dto) {
	          newParts.push({ from: m.to, to: p.to });
	        }
	        parts.splice.apply(parts, newParts);
	        j += newParts.length - 3;
	      }
	    }
	    return parts;
	  }
	
	  // Connect or disconnect spans from a line.
	  function detachMarkedSpans(line) {
	    var spans = line.markedSpans;
	    if (!spans) {
	      return;
	    }
	    for (var i = 0; i < spans.length; ++i) {
	      spans[i].marker.detachLine(line);
	    }
	    line.markedSpans = null;
	  }
	  function attachMarkedSpans(line, spans) {
	    if (!spans) {
	      return;
	    }
	    for (var i = 0; i < spans.length; ++i) {
	      spans[i].marker.attachLine(line);
	    }
	    line.markedSpans = spans;
	  }
	
	  // Helpers used when computing which overlapping collapsed span
	  // counts as the larger one.
	  function extraLeft(marker) {
	    return marker.inclusiveLeft ? -1 : 0;
	  }
	  function extraRight(marker) {
	    return marker.inclusiveRight ? 1 : 0;
	  }
	
	  // Returns a number indicating which of two overlapping collapsed
	  // spans is larger (and thus includes the other). Falls back to
	  // comparing ids when the spans cover exactly the same range.
	  function compareCollapsedMarkers(a, b) {
	    var lenDiff = a.lines.length - b.lines.length;
	    if (lenDiff != 0) {
	      return lenDiff;
	    }
	    var aPos = a.find(),
	        bPos = b.find();
	    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
	    if (fromCmp) {
	      return -fromCmp;
	    }
	    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
	    if (toCmp) {
	      return toCmp;
	    }
	    return b.id - a.id;
	  }
	
	  // Find out whether a line ends or starts in a collapsed span. If
	  // so, return the marker for that span.
	  function collapsedSpanAtSide(line, start) {
	    var sps = sawCollapsedSpans && line.markedSpans,
	        found;
	    if (sps) {
	      for (var sp = void 0, i = 0; i < sps.length; ++i) {
	        sp = sps[i];
	        if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
	          found = sp.marker;
	        }
	      }
	    }
	    return found;
	  }
	  function collapsedSpanAtStart(line) {
	    return collapsedSpanAtSide(line, true);
	  }
	  function collapsedSpanAtEnd(line) {
	    return collapsedSpanAtSide(line, false);
	  }
	
	  // Test whether there exists a collapsed span that partially
	  // overlaps (covers the start or end, but not both) of a new span.
	  // Such overlap is not allowed.
	  function conflictingCollapsedRange(doc, lineNo$$1, from, to, marker) {
	    var line = getLine(doc, lineNo$$1);
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) {
	      for (var i = 0; i < sps.length; ++i) {
	        var sp = sps[i];
	        if (!sp.marker.collapsed) {
	          continue;
	        }
	        var found = sp.marker.find(0);
	        var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
	        var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
	        if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) {
	          continue;
	        }
	        if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) {
	          return true;
	        }
	      }
	    }
	  }
	
	  // A visual line is a line as drawn on the screen. Folding, for
	  // example, can cause multiple logical lines to appear on the same
	  // visual line. This finds the start of the visual line that the
	  // given line is part of (usually that is the line itself).
	  function visualLine(line) {
	    var merged;
	    while (merged = collapsedSpanAtStart(line)) {
	      line = merged.find(-1, true).line;
	    }
	    return line;
	  }
	
	  function visualLineEnd(line) {
	    var merged;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;
	    }
	    return line;
	  }
	
	  // Returns an array of logical lines that continue the visual line
	  // started by the argument, or undefined if there are no such lines.
	  function visualLineContinued(line) {
	    var merged, lines;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;(lines || (lines = [])).push(line);
	    }
	    return lines;
	  }
	
	  // Get the line number of the start of the visual line that the
	  // given line number is part of.
	  function visualLineNo(doc, lineN) {
	    var line = getLine(doc, lineN),
	        vis = visualLine(line);
	    if (line == vis) {
	      return lineN;
	    }
	    return lineNo(vis);
	  }
	
	  // Get the line number of the start of the next visual line after
	  // the given line.
	  function visualLineEndNo(doc, lineN) {
	    if (lineN > doc.lastLine()) {
	      return lineN;
	    }
	    var line = getLine(doc, lineN),
	        merged;
	    if (!lineIsHidden(doc, line)) {
	      return lineN;
	    }
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;
	    }
	    return lineNo(line) + 1;
	  }
	
	  // Compute whether a line is hidden. Lines count as hidden when they
	  // are part of a visual line that starts with another line, or when
	  // they are entirely covered by collapsed, non-widget span.
	  function lineIsHidden(doc, line) {
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) {
	      for (var sp = void 0, i = 0; i < sps.length; ++i) {
	        sp = sps[i];
	        if (!sp.marker.collapsed) {
	          continue;
	        }
	        if (sp.from == null) {
	          return true;
	        }
	        if (sp.marker.widgetNode) {
	          continue;
	        }
	        if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) {
	          return true;
	        }
	      }
	    }
	  }
	  function lineIsHiddenInner(doc, line, span) {
	    if (span.to == null) {
	      var end = span.marker.find(1, true);
	      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
	    }
	    if (span.marker.inclusiveRight && span.to == line.text.length) {
	      return true;
	    }
	    for (var sp = void 0, i = 0; i < line.markedSpans.length; ++i) {
	      sp = line.markedSpans[i];
	      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) {
	        return true;
	      }
	    }
	  }
	
	  // Find the height above the given line.
	  function _heightAtLine(lineObj) {
	    lineObj = visualLine(lineObj);
	
	    var h = 0,
	        chunk = lineObj.parent;
	    for (var i = 0; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i];
	      if (line == lineObj) {
	        break;
	      } else {
	        h += line.height;
	      }
	    }
	    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
	        var cur = p.children[i$1];
	        if (cur == chunk) {
	          break;
	        } else {
	          h += cur.height;
	        }
	      }
	    }
	    return h;
	  }
	
	  // Compute the character length of a line, taking into account
	  // collapsed ranges (see markText) that might hide parts, and join
	  // other lines onto it.
	  function lineLength(line) {
	    if (line.height == 0) {
	      return 0;
	    }
	    var len = line.text.length,
	        merged,
	        cur = line;
	    while (merged = collapsedSpanAtStart(cur)) {
	      var found = merged.find(0, true);
	      cur = found.from.line;
	      len += found.from.ch - found.to.ch;
	    }
	    cur = line;
	    while (merged = collapsedSpanAtEnd(cur)) {
	      var found$1 = merged.find(0, true);
	      len -= cur.text.length - found$1.from.ch;
	      cur = found$1.to.line;
	      len += cur.text.length - found$1.to.ch;
	    }
	    return len;
	  }
	
	  // Find the longest line in the document.
	  function findMaxLine(cm) {
	    var d = cm.display,
	        doc = cm.doc;
	    d.maxLine = getLine(doc, doc.first);
	    d.maxLineLength = lineLength(d.maxLine);
	    d.maxLineChanged = true;
	    doc.iter(function (line) {
	      var len = lineLength(line);
	      if (len > d.maxLineLength) {
	        d.maxLineLength = len;
	        d.maxLine = line;
	      }
	    });
	  }
	
	  // BIDI HELPERS
	
	  function iterateBidiSections(order, from, to, f) {
	    if (!order) {
	      return f(from, to, "ltr", 0);
	    }
	    var found = false;
	    for (var i = 0; i < order.length; ++i) {
	      var part = order[i];
	      if (part.from < to && part.to > from || from == to && part.to == from) {
	        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
	        found = true;
	      }
	    }
	    if (!found) {
	      f(from, to, "ltr");
	    }
	  }
	
	  var bidiOther = null;
	  function getBidiPartAt(order, ch, sticky) {
	    var found;
	    bidiOther = null;
	    for (var i = 0; i < order.length; ++i) {
	      var cur = order[i];
	      if (cur.from < ch && cur.to > ch) {
	        return i;
	      }
	      if (cur.to == ch) {
	        if (cur.from != cur.to && sticky == "before") {
	          found = i;
	        } else {
	          bidiOther = i;
	        }
	      }
	      if (cur.from == ch) {
	        if (cur.from != cur.to && sticky != "before") {
	          found = i;
	        } else {
	          bidiOther = i;
	        }
	      }
	    }
	    return found != null ? found : bidiOther;
	  }
	
	  // Bidirectional ordering algorithm
	  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	  // that this (partially) implements.
	
	  // One-char codes used for character types:
	  // L (L):   Left-to-Right
	  // R (R):   Right-to-Left
	  // r (AL):  Right-to-Left Arabic
	  // 1 (EN):  European Number
	  // + (ES):  European Number Separator
	  // % (ET):  European Number Terminator
	  // n (AN):  Arabic Number
	  // , (CS):  Common Number Separator
	  // m (NSM): Non-Spacing Mark
	  // b (BN):  Boundary Neutral
	  // s (B):   Paragraph Separator
	  // t (S):   Segment Separator
	  // w (WS):  Whitespace
	  // N (ON):  Other Neutrals
	
	  // Returns null if characters are ordered as they appear
	  // (left-to-right), or an array of sections ({from, to, level}
	  // objects) in the order in which they occur visually.
	  var bidiOrdering = function () {
	    // Character types for codepoints 0 to 0xff
	    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
	    // Character types for codepoints 0x600 to 0x6f9
	    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
	    function charType(code) {
	      if (code <= 0xf7) {
	        return lowTypes.charAt(code);
	      } else if (0x590 <= code && code <= 0x5f4) {
	        return "R";
	      } else if (0x600 <= code && code <= 0x6f9) {
	        return arabicTypes.charAt(code - 0x600);
	      } else if (0x6ee <= code && code <= 0x8ac) {
	        return "r";
	      } else if (0x2000 <= code && code <= 0x200b) {
	        return "w";
	      } else if (code == 0x200c) {
	        return "b";
	      } else {
	        return "L";
	      }
	    }
	
	    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
	    var isNeutral = /[stwN]/,
	        isStrong = /[LRr]/,
	        countsAsLeft = /[Lb1n]/,
	        countsAsNum = /[1n]/;
	
	    function BidiSpan(level, from, to) {
	      this.level = level;
	      this.from = from;this.to = to;
	    }
	
	    return function (str, direction) {
	      var outerType = direction == "ltr" ? "L" : "R";
	
	      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) {
	        return false;
	      }
	      var len = str.length,
	          types = [];
	      for (var i = 0; i < len; ++i) {
	        types.push(charType(str.charCodeAt(i)));
	      }
	
	      // W1. Examine each non-spacing mark (NSM) in the level run, and
	      // change the type of the NSM to the type of the previous
	      // character. If the NSM is at the start of the level run, it will
	      // get the type of sor.
	      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
	        var type = types[i$1];
	        if (type == "m") {
	          types[i$1] = prev;
	        } else {
	          prev = type;
	        }
	      }
	
	      // W2. Search backwards from each instance of a European number
	      // until the first strong type (R, L, AL, or sor) is found. If an
	      // AL is found, change the type of the European number to Arabic
	      // number.
	      // W3. Change all ALs to R.
	      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
	        var type$1 = types[i$2];
	        if (type$1 == "1" && cur == "r") {
	          types[i$2] = "n";
	        } else if (isStrong.test(type$1)) {
	          cur = type$1;if (type$1 == "r") {
	            types[i$2] = "R";
	          }
	        }
	      }
	
	      // W4. A single European separator between two European numbers
	      // changes to a European number. A single common separator between
	      // two numbers of the same type changes to that type.
	      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
	        var type$2 = types[i$3];
	        if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") {
	          types[i$3] = "1";
	        } else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) {
	          types[i$3] = prev$1;
	        }
	        prev$1 = type$2;
	      }
	
	      // W5. A sequence of European terminators adjacent to European
	      // numbers changes to all European numbers.
	      // W6. Otherwise, separators and terminators change to Other
	      // Neutral.
	      for (var i$4 = 0; i$4 < len; ++i$4) {
	        var type$3 = types[i$4];
	        if (type$3 == ",") {
	          types[i$4] = "N";
	        } else if (type$3 == "%") {
	          var end = void 0;
	          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
	          var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
	          for (var j = i$4; j < end; ++j) {
	            types[j] = replace;
	          }
	          i$4 = end - 1;
	        }
	      }
	
	      // W7. Search backwards from each instance of a European number
	      // until the first strong type (R, L, or sor) is found. If an L is
	      // found, then change the type of the European number to L.
	      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
	        var type$4 = types[i$5];
	        if (cur$1 == "L" && type$4 == "1") {
	          types[i$5] = "L";
	        } else if (isStrong.test(type$4)) {
	          cur$1 = type$4;
	        }
	      }
	
	      // N1. A sequence of neutrals takes the direction of the
	      // surrounding strong text if the text on both sides has the same
	      // direction. European and Arabic numbers act as if they were R in
	      // terms of their influence on neutrals. Start-of-level-run (sor)
	      // and end-of-level-run (eor) are used at level run boundaries.
	      // N2. Any remaining neutrals take the embedding direction.
	      for (var i$6 = 0; i$6 < len; ++i$6) {
	        if (isNeutral.test(types[i$6])) {
	          var end$1 = void 0;
	          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
	          var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
	          var after = (end$1 < len ? types[end$1] : outerType) == "L";
	          var replace$1 = before == after ? before ? "L" : "R" : outerType;
	          for (var j$1 = i$6; j$1 < end$1; ++j$1) {
	            types[j$1] = replace$1;
	          }
	          i$6 = end$1 - 1;
	        }
	      }
	
	      // Here we depart from the documented algorithm, in order to avoid
	      // building up an actual levels array. Since there are only three
	      // levels (0, 1, 2) in an implementation that doesn't take
	      // explicit embedding into account, we can build up the order on
	      // the fly, without following the level-based algorithm.
	      var order = [],
	          m;
	      for (var i$7 = 0; i$7 < len;) {
	        if (countsAsLeft.test(types[i$7])) {
	          var start = i$7;
	          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
	          order.push(new BidiSpan(0, start, i$7));
	        } else {
	          var pos = i$7,
	              at = order.length;
	          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
	          for (var j$2 = pos; j$2 < i$7;) {
	            if (countsAsNum.test(types[j$2])) {
	              if (pos < j$2) {
	                order.splice(at, 0, new BidiSpan(1, pos, j$2));
	              }
	              var nstart = j$2;
	              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
	              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
	              pos = j$2;
	            } else {
	              ++j$2;
	            }
	          }
	          if (pos < i$7) {
	            order.splice(at, 0, new BidiSpan(1, pos, i$7));
	          }
	        }
	      }
	      if (direction == "ltr") {
	        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	          order[0].from = m[0].length;
	          order.unshift(new BidiSpan(0, 0, m[0].length));
	        }
	        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	          lst(order).to -= m[0].length;
	          order.push(new BidiSpan(0, len - m[0].length, len));
	        }
	      }
	
	      return direction == "rtl" ? order.reverse() : order;
	    };
	  }();
	
	  // Get the bidi ordering for the given line (and cache it). Returns
	  // false for lines that are fully left-to-right, and an array of
	  // BidiSpan objects otherwise.
	  function getOrder(line, direction) {
	    var order = line.order;
	    if (order == null) {
	      order = line.order = bidiOrdering(line.text, direction);
	    }
	    return order;
	  }
	
	  // EVENT HANDLING
	
	  // Lightweight event framework. on/off also work on DOM nodes,
	  // registering native DOM handlers.
	
	  var noHandlers = [];
	
	  var on = function on(emitter, type, f) {
	    if (emitter.addEventListener) {
	      emitter.addEventListener(type, f, false);
	    } else if (emitter.attachEvent) {
	      emitter.attachEvent("on" + type, f);
	    } else {
	      var map$$1 = emitter._handlers || (emitter._handlers = {});
	      map$$1[type] = (map$$1[type] || noHandlers).concat(f);
	    }
	  };
	
	  function getHandlers(emitter, type) {
	    return emitter._handlers && emitter._handlers[type] || noHandlers;
	  }
	
	  function off(emitter, type, f) {
	    if (emitter.removeEventListener) {
	      emitter.removeEventListener(type, f, false);
	    } else if (emitter.detachEvent) {
	      emitter.detachEvent("on" + type, f);
	    } else {
	      var map$$1 = emitter._handlers,
	          arr = map$$1 && map$$1[type];
	      if (arr) {
	        var index = indexOf(arr, f);
	        if (index > -1) {
	          map$$1[type] = arr.slice(0, index).concat(arr.slice(index + 1));
	        }
	      }
	    }
	  }
	
	  function signal(emitter, type /*, values...*/) {
	    var handlers = getHandlers(emitter, type);
	    if (!handlers.length) {
	      return;
	    }
	    var args = Array.prototype.slice.call(arguments, 2);
	    for (var i = 0; i < handlers.length; ++i) {
	      handlers[i].apply(null, args);
	    }
	  }
	
	  // The DOM events that CodeMirror handles can be overridden by
	  // registering a (non-DOM) handler on the editor for the event name,
	  // and preventDefault-ing the event in that handler.
	  function signalDOMEvent(cm, e, override) {
	    if (typeof e == "string") {
	      e = { type: e, preventDefault: function preventDefault() {
	          this.defaultPrevented = true;
	        } };
	    }
	    signal(cm, override || e.type, cm, e);
	    return e_defaultPrevented(e) || e.codemirrorIgnore;
	  }
	
	  function signalCursorActivity(cm) {
	    var arr = cm._handlers && cm._handlers.cursorActivity;
	    if (!arr) {
	      return;
	    }
	    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
	    for (var i = 0; i < arr.length; ++i) {
	      if (indexOf(set, arr[i]) == -1) {
	        set.push(arr[i]);
	      }
	    }
	  }
	
	  function hasHandler(emitter, type) {
	    return getHandlers(emitter, type).length > 0;
	  }
	
	  // Add on and off methods to a constructor's prototype, to make
	  // registering events on such objects more convenient.
	  function eventMixin(ctor) {
	    ctor.prototype.on = function (type, f) {
	      on(this, type, f);
	    };
	    ctor.prototype.off = function (type, f) {
	      off(this, type, f);
	    };
	  }
	
	  // Due to the fact that we still support jurassic IE versions, some
	  // compatibility wrappers are needed.
	
	  function e_preventDefault(e) {
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      e.returnValue = false;
	    }
	  }
	  function e_stopPropagation(e) {
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      e.cancelBubble = true;
	    }
	  }
	  function e_defaultPrevented(e) {
	    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
	  }
	  function e_stop(e) {
	    e_preventDefault(e);e_stopPropagation(e);
	  }
	
	  function e_target(e) {
	    return e.target || e.srcElement;
	  }
	  function e_button(e) {
	    var b = e.which;
	    if (b == null) {
	      if (e.button & 1) {
	        b = 1;
	      } else if (e.button & 2) {
	        b = 3;
	      } else if (e.button & 4) {
	        b = 2;
	      }
	    }
	    if (mac && e.ctrlKey && b == 1) {
	      b = 3;
	    }
	    return b;
	  }
	
	  // Detect drag-and-drop
	  var dragAndDrop = function () {
	    // There is *some* kind of drag-and-drop support in IE6-8, but I
	    // couldn't get it to work yet.
	    if (ie && ie_version < 9) {
	      return false;
	    }
	    var div = elt('div');
	    return "draggable" in div || "dragDrop" in div;
	  }();
	
	  var zwspSupported;
	  function zeroWidthElement(measure) {
	    if (zwspSupported == null) {
	      var test = elt("span", '\u200B');
	      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
	      if (measure.firstChild.offsetHeight != 0) {
	        zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
	      }
	    }
	    var node = zwspSupported ? elt("span", '\u200B') : elt("span", '\xA0', null, "display: inline-block; width: 1px; margin-right: -1px");
	    node.setAttribute("cm-text", "");
	    return node;
	  }
	
	  // Feature-detect IE's crummy client rect reporting for bidi text
	  var badBidiRects;
	  function hasBadBidiRects(measure) {
	    if (badBidiRects != null) {
	      return badBidiRects;
	    }
	    var txt = removeChildrenAndAdd(measure, document.createTextNode('A\u062EA'));
	    var r0 = range(txt, 0, 1).getBoundingClientRect();
	    var r1 = range(txt, 1, 2).getBoundingClientRect();
	    removeChildren(measure);
	    if (!r0 || r0.left == r0.right) {
	      return false;
	    } // Safari returns null in some cases (#2780)
	    return badBidiRects = r1.right - r0.right < 3;
	  }
	
	  // See if "".split is the broken IE version, if so, provide an
	  // alternative way to split lines.
	  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
	    var pos = 0,
	        result = [],
	        l = string.length;
	    while (pos <= l) {
	      var nl = string.indexOf("\n", pos);
	      if (nl == -1) {
	        nl = string.length;
	      }
	      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
	      var rt = line.indexOf("\r");
	      if (rt != -1) {
	        result.push(line.slice(0, rt));
	        pos += rt + 1;
	      } else {
	        result.push(line);
	        pos = nl + 1;
	      }
	    }
	    return result;
	  } : function (string) {
	    return string.split(/\r\n?|\n/);
	  };
	
	  var hasSelection = window.getSelection ? function (te) {
	    try {
	      return te.selectionStart != te.selectionEnd;
	    } catch (e) {
	      return false;
	    }
	  } : function (te) {
	    var range$$1;
	    try {
	      range$$1 = te.ownerDocument.selection.createRange();
	    } catch (e) {}
	    if (!range$$1 || range$$1.parentElement() != te) {
	      return false;
	    }
	    return range$$1.compareEndPoints("StartToEnd", range$$1) != 0;
	  };
	
	  var hasCopyEvent = function () {
	    var e = elt("div");
	    if ("oncopy" in e) {
	      return true;
	    }
	    e.setAttribute("oncopy", "return;");
	    return typeof e.oncopy == "function";
	  }();
	
	  var badZoomedRects = null;
	  function hasBadZoomedRects(measure) {
	    if (badZoomedRects != null) {
	      return badZoomedRects;
	    }
	    var node = removeChildrenAndAdd(measure, elt("span", "x"));
	    var normal = node.getBoundingClientRect();
	    var fromRange = range(node, 0, 1).getBoundingClientRect();
	    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
	  }
	
	  // Known modes, by name and by MIME
	  var modes = {};
	  var mimeModes = {};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  function defineMode(name, mode) {
	    if (arguments.length > 2) {
	      mode.dependencies = Array.prototype.slice.call(arguments, 2);
	    }
	    modes[name] = mode;
	  }
	
	  function defineMIME(mime, spec) {
	    mimeModes[mime] = spec;
	  }
	
	  // Given a MIME type, a {name, ...options} config object, or a name
	  // string, return a mode config object.
	  function resolveMode(spec) {
	    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	      spec = mimeModes[spec];
	    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	      var found = mimeModes[spec.name];
	      if (typeof found == "string") {
	        found = { name: found };
	      }
	      spec = createObj(found, spec);
	      spec.name = found.name;
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	      return resolveMode("application/xml");
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	      return resolveMode("application/json");
	    }
	    if (typeof spec == "string") {
	      return { name: spec };
	    } else {
	      return spec || { name: "null" };
	    }
	  }
	
	  // Given a mode spec (anything that resolveMode accepts), find and
	  // initialize an actual mode object.
	  function getMode(options, spec) {
	    spec = resolveMode(spec);
	    var mfactory = modes[spec.name];
	    if (!mfactory) {
	      return getMode(options, "text/plain");
	    }
	    var modeObj = mfactory(options, spec);
	    if (modeExtensions.hasOwnProperty(spec.name)) {
	      var exts = modeExtensions[spec.name];
	      for (var prop in exts) {
	        if (!exts.hasOwnProperty(prop)) {
	          continue;
	        }
	        if (modeObj.hasOwnProperty(prop)) {
	          modeObj["_" + prop] = modeObj[prop];
	        }
	        modeObj[prop] = exts[prop];
	      }
	    }
	    modeObj.name = spec.name;
	    if (spec.helperType) {
	      modeObj.helperType = spec.helperType;
	    }
	    if (spec.modeProps) {
	      for (var prop$1 in spec.modeProps) {
	        modeObj[prop$1] = spec.modeProps[prop$1];
	      }
	    }
	
	    return modeObj;
	  }
	
	  // This can be used to attach properties to mode objects from
	  // outside the actual mode definition.
	  var modeExtensions = {};
	  function extendMode(mode, properties) {
	    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
	    copyObj(properties, exts);
	  }
	
	  function copyState(mode, state) {
	    if (state === true) {
	      return state;
	    }
	    if (mode.copyState) {
	      return mode.copyState(state);
	    }
	    var nstate = {};
	    for (var n in state) {
	      var val = state[n];
	      if (val instanceof Array) {
	        val = val.concat([]);
	      }
	      nstate[n] = val;
	    }
	    return nstate;
	  }
	
	  // Given a mode and a state (for that mode), find the inner mode and
	  // state at the position that the state refers to.
	  function innerMode(mode, state) {
	    var info;
	    while (mode.innerMode) {
	      info = mode.innerMode(state);
	      if (!info || info.mode == mode) {
	        break;
	      }
	      state = info.state;
	      mode = info.mode;
	    }
	    return info || { mode: mode, state: state };
	  }
	
	  function startState(mode, a1, a2) {
	    return mode.startState ? mode.startState(a1, a2) : true;
	  }
	
	  // STRING STREAM
	
	  // Fed to the mode parsers, provides helper functions to make
	  // parsers more succinct.
	
	  var StringStream = function StringStream(string, tabSize, lineOracle) {
	    this.pos = this.start = 0;
	    this.string = string;
	    this.tabSize = tabSize || 8;
	    this.lastColumnPos = this.lastColumnValue = 0;
	    this.lineStart = 0;
	    this.lineOracle = lineOracle;
	  };
	
	  StringStream.prototype.eol = function () {
	    return this.pos >= this.string.length;
	  };
	  StringStream.prototype.sol = function () {
	    return this.pos == this.lineStart;
	  };
	  StringStream.prototype.peek = function () {
	    return this.string.charAt(this.pos) || undefined;
	  };
	  StringStream.prototype.next = function () {
	    if (this.pos < this.string.length) {
	      return this.string.charAt(this.pos++);
	    }
	  };
	  StringStream.prototype.eat = function (match) {
	    var ch = this.string.charAt(this.pos);
	    var ok;
	    if (typeof match == "string") {
	      ok = ch == match;
	    } else {
	      ok = ch && (match.test ? match.test(ch) : match(ch));
	    }
	    if (ok) {
	      ++this.pos;return ch;
	    }
	  };
	  StringStream.prototype.eatWhile = function (match) {
	    var start = this.pos;
	    while (this.eat(match)) {}
	    return this.pos > start;
	  };
	  StringStream.prototype.eatSpace = function () {
	    var this$1 = this;
	
	    var start = this.pos;
	    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) {
	      ++this$1.pos;
	    }
	    return this.pos > start;
	  };
	  StringStream.prototype.skipToEnd = function () {
	    this.pos = this.string.length;
	  };
	  StringStream.prototype.skipTo = function (ch) {
	    var found = this.string.indexOf(ch, this.pos);
	    if (found > -1) {
	      this.pos = found;return true;
	    }
	  };
	  StringStream.prototype.backUp = function (n) {
	    this.pos -= n;
	  };
	  StringStream.prototype.column = function () {
	    if (this.lastColumnPos < this.start) {
	      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
	      this.lastColumnPos = this.start;
	    }
	    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
	  };
	  StringStream.prototype.indentation = function () {
	    return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
	  };
	  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
	    if (typeof pattern == "string") {
	      var cased = function cased(str) {
	        return caseInsensitive ? str.toLowerCase() : str;
	      };
	      var substr = this.string.substr(this.pos, pattern.length);
	      if (cased(substr) == cased(pattern)) {
	        if (consume !== false) {
	          this.pos += pattern.length;
	        }
	        return true;
	      }
	    } else {
	      var match = this.string.slice(this.pos).match(pattern);
	      if (match && match.index > 0) {
	        return null;
	      }
	      if (match && consume !== false) {
	        this.pos += match[0].length;
	      }
	      return match;
	    }
	  };
	  StringStream.prototype.current = function () {
	    return this.string.slice(this.start, this.pos);
	  };
	  StringStream.prototype.hideFirstChars = function (n, inner) {
	    this.lineStart += n;
	    try {
	      return inner();
	    } finally {
	      this.lineStart -= n;
	    }
	  };
	  StringStream.prototype.lookAhead = function (n) {
	    var oracle = this.lineOracle;
	    return oracle && oracle.lookAhead(n);
	  };
	  StringStream.prototype.baseToken = function () {
	    var oracle = this.lineOracle;
	    return oracle && oracle.baseToken(this.pos);
	  };
	
	  var SavedContext = function SavedContext(state, lookAhead) {
	    this.state = state;
	    this.lookAhead = lookAhead;
	  };
	
	  var Context = function Context(doc, state, line, lookAhead) {
	    this.state = state;
	    this.doc = doc;
	    this.line = line;
	    this.maxLookAhead = lookAhead || 0;
	    this.baseTokens = null;
	    this.baseTokenPos = 1;
	  };
	
	  Context.prototype.lookAhead = function (n) {
	    var line = this.doc.getLine(this.line + n);
	    if (line != null && n > this.maxLookAhead) {
	      this.maxLookAhead = n;
	    }
	    return line;
	  };
	
	  Context.prototype.baseToken = function (n) {
	    var this$1 = this;
	
	    if (!this.baseTokens) {
	      return null;
	    }
	    while (this.baseTokens[this.baseTokenPos] <= n) {
	      this$1.baseTokenPos += 2;
	    }
	    var type = this.baseTokens[this.baseTokenPos + 1];
	    return { type: type && type.replace(/( |^)overlay .*/, ""),
	      size: this.baseTokens[this.baseTokenPos] - n };
	  };
	
	  Context.prototype.nextLine = function () {
	    this.line++;
	    if (this.maxLookAhead > 0) {
	      this.maxLookAhead--;
	    }
	  };
	
	  Context.fromSaved = function (doc, saved, line) {
	    if (saved instanceof SavedContext) {
	      return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
	    } else {
	      return new Context(doc, copyState(doc.mode, saved), line);
	    }
	  };
	
	  Context.prototype.save = function (copy) {
	    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
	    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
	  };
	
	  // Compute a style array (an array starting with a mode generation
	  // -- for invalidation -- followed by pairs of end positions and
	  // style strings), which is used to highlight the tokens on the
	  // line.
	  function highlightLine(cm, line, context, forceToEnd) {
	    // A styles array always starts with a number identifying the
	    // mode/overlays that it is based on (for easy invalidation).
	    var st = [cm.state.modeGen],
	        lineClasses = {};
	    // Compute the base array of styles
	    runMode(cm, line.text, cm.doc.mode, context, function (end, style) {
	      return st.push(end, style);
	    }, lineClasses, forceToEnd);
	    var state = context.state;
	
	    // Run overlays, adjust style array.
	    var loop = function loop(o) {
	      context.baseTokens = st;
	      var overlay = cm.state.overlays[o],
	          i = 1,
	          at = 0;
	      context.state = true;
	      runMode(cm, line.text, overlay.mode, context, function (end, style) {
	        var start = i;
	        // Ensure there's a token end at the current position, and that i points at it
	        while (at < end) {
	          var i_end = st[i];
	          if (i_end > end) {
	            st.splice(i, 1, end, st[i + 1], i_end);
	          }
	          i += 2;
	          at = Math.min(end, i_end);
	        }
	        if (!style) {
	          return;
	        }
	        if (overlay.opaque) {
	          st.splice(start, i - start, end, "overlay " + style);
	          i = start + 2;
	        } else {
	          for (; start < i; start += 2) {
	            var cur = st[start + 1];
	            st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
	          }
	        }
	      }, lineClasses);
	      context.state = state;
	      context.baseTokens = null;
	      context.baseTokenPos = 1;
	    };
	
	    for (var o = 0; o < cm.state.overlays.length; ++o) {
	      loop(o);
	    }return { styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null };
	  }
	
	  function getLineStyles(cm, line, updateFrontier) {
	    if (!line.styles || line.styles[0] != cm.state.modeGen) {
	      var context = getContextBefore(cm, lineNo(line));
	      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
	      var result = highlightLine(cm, line, context);
	      if (resetState) {
	        context.state = resetState;
	      }
	      line.stateAfter = context.save(!resetState);
	      line.styles = result.styles;
	      if (result.classes) {
	        line.styleClasses = result.classes;
	      } else if (line.styleClasses) {
	        line.styleClasses = null;
	      }
	      if (updateFrontier === cm.doc.highlightFrontier) {
	        cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
	      }
	    }
	    return line.styles;
	  }
	
	  function getContextBefore(cm, n, precise) {
	    var doc = cm.doc,
	        display = cm.display;
	    if (!doc.mode.startState) {
	      return new Context(doc, true, n);
	    }
	    var start = findStartLine(cm, n, precise);
	    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
	    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
	
	    doc.iter(start, n, function (line) {
	      processLine(cm, line.text, context);
	      var pos = context.line;
	      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
	      context.nextLine();
	    });
	    if (precise) {
	      doc.modeFrontier = context.line;
	    }
	    return context;
	  }
	
	  // Lightweight form of highlight -- proceed over this line and
	  // update state, but don't save a style array. Used for lines that
	  // aren't currently visible.
	  function processLine(cm, text, context, startAt) {
	    var mode = cm.doc.mode;
	    var stream = new StringStream(text, cm.options.tabSize, context);
	    stream.start = stream.pos = startAt || 0;
	    if (text == "") {
	      callBlankLine(mode, context.state);
	    }
	    while (!stream.eol()) {
	      readToken(mode, stream, context.state);
	      stream.start = stream.pos;
	    }
	  }
	
	  function callBlankLine(mode, state) {
	    if (mode.blankLine) {
	      return mode.blankLine(state);
	    }
	    if (!mode.innerMode) {
	      return;
	    }
	    var inner = innerMode(mode, state);
	    if (inner.mode.blankLine) {
	      return inner.mode.blankLine(inner.state);
	    }
	  }
	
	  function readToken(mode, stream, state, inner) {
	    for (var i = 0; i < 10; i++) {
	      if (inner) {
	        inner[0] = innerMode(mode, state).mode;
	      }
	      var style = mode.token(stream, state);
	      if (stream.pos > stream.start) {
	        return style;
	      }
	    }
	    throw new Error("Mode " + mode.name + " failed to advance stream.");
	  }
	
	  var Token = function Token(stream, type, state) {
	    this.start = stream.start;this.end = stream.pos;
	    this.string = stream.current();
	    this.type = type || null;
	    this.state = state;
	  };
	
	  // Utility for getTokenAt and getLineTokens
	  function takeToken(cm, pos, precise, asArray) {
	    var doc = cm.doc,
	        mode = doc.mode,
	        style;
	    pos = _clipPos(doc, pos);
	    var line = getLine(doc, pos.line),
	        context = getContextBefore(cm, pos.line, precise);
	    var stream = new StringStream(line.text, cm.options.tabSize, context),
	        tokens;
	    if (asArray) {
	      tokens = [];
	    }
	    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	      stream.start = stream.pos;
	      style = readToken(mode, stream, context.state);
	      if (asArray) {
	        tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
	      }
	    }
	    return asArray ? tokens : new Token(stream, style, context.state);
	  }
	
	  function extractLineClasses(type, output) {
	    if (type) {
	      for (;;) {
	        var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
	        if (!lineClass) {
	          break;
	        }
	        type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
	        var prop = lineClass[1] ? "bgClass" : "textClass";
	        if (output[prop] == null) {
	          output[prop] = lineClass[2];
	        } else if (!new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)").test(output[prop])) {
	          output[prop] += " " + lineClass[2];
	        }
	      }
	    }
	    return type;
	  }
	
	  // Run the given mode's parser over a line, calling f for each token.
	  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
	    var flattenSpans = mode.flattenSpans;
	    if (flattenSpans == null) {
	      flattenSpans = cm.options.flattenSpans;
	    }
	    var curStart = 0,
	        curStyle = null;
	    var stream = new StringStream(text, cm.options.tabSize, context),
	        style;
	    var inner = cm.options.addModeClass && [null];
	    if (text == "") {
	      extractLineClasses(callBlankLine(mode, context.state), lineClasses);
	    }
	    while (!stream.eol()) {
	      if (stream.pos > cm.options.maxHighlightLength) {
	        flattenSpans = false;
	        if (forceToEnd) {
	          processLine(cm, text, context, stream.pos);
	        }
	        stream.pos = text.length;
	        style = null;
	      } else {
	        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
	      }
	      if (inner) {
	        var mName = inner[0].name;
	        if (mName) {
	          style = "m-" + (style ? mName + " " + style : mName);
	        }
	      }
	      if (!flattenSpans || curStyle != style) {
	        while (curStart < stream.start) {
	          curStart = Math.min(stream.start, curStart + 5000);
	          f(curStart, curStyle);
	        }
	        curStyle = style;
	      }
	      stream.start = stream.pos;
	    }
	    while (curStart < stream.pos) {
	      // Webkit seems to refuse to render text nodes longer than 57444
	      // characters, and returns inaccurate measurements in nodes
	      // starting around 5000 chars.
	      var pos = Math.min(stream.pos, curStart + 5000);
	      f(pos, curStyle);
	      curStart = pos;
	    }
	  }
	
	  // Finds the line to start with when starting a parse. Tries to
	  // find a line with a stateAfter, so that it can start with a
	  // valid state. If that fails, it returns the line with the
	  // smallest indentation, which tends to need the least context to
	  // parse correctly.
	  function findStartLine(cm, n, precise) {
	    var minindent,
	        minline,
	        doc = cm.doc;
	    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
	    for (var search = n; search > lim; --search) {
	      if (search <= doc.first) {
	        return doc.first;
	      }
	      var line = getLine(doc, search - 1),
	          after = line.stateAfter;
	      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier)) {
	        return search;
	      }
	      var indented = countColumn(line.text, null, cm.options.tabSize);
	      if (minline == null || minindent > indented) {
	        minline = search - 1;
	        minindent = indented;
	      }
	    }
	    return minline;
	  }
	
	  function retreatFrontier(doc, n) {
	    doc.modeFrontier = Math.min(doc.modeFrontier, n);
	    if (doc.highlightFrontier < n - 10) {
	      return;
	    }
	    var start = doc.first;
	    for (var line = n - 1; line > start; line--) {
	      var saved = getLine(doc, line).stateAfter;
	      // change is on 3
	      // state on line 1 looked ahead 2 -- so saw 3
	      // test 1 + 2 < 3 should cover this
	      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
	        start = line + 1;
	        break;
	      }
	    }
	    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
	  }
	
	  // LINE DATA STRUCTURE
	
	  // Line objects. These hold state related to a line, including
	  // highlighting info (the styles array).
	  var Line = function Line(text, markedSpans, estimateHeight) {
	    this.text = text;
	    attachMarkedSpans(this, markedSpans);
	    this.height = estimateHeight ? estimateHeight(this) : 1;
	  };
	
	  Line.prototype.lineNo = function () {
	    return lineNo(this);
	  };
	  eventMixin(Line);
	
	  // Change the content (text, markers) of a line. Automatically
	  // invalidates cached information and tries to re-estimate the
	  // line's height.
	  function updateLine(line, text, markedSpans, estimateHeight) {
	    line.text = text;
	    if (line.stateAfter) {
	      line.stateAfter = null;
	    }
	    if (line.styles) {
	      line.styles = null;
	    }
	    if (line.order != null) {
	      line.order = null;
	    }
	    detachMarkedSpans(line);
	    attachMarkedSpans(line, markedSpans);
	    var estHeight = estimateHeight ? estimateHeight(line) : 1;
	    if (estHeight != line.height) {
	      updateLineHeight(line, estHeight);
	    }
	  }
	
	  // Detach a line from the document tree and its markers.
	  function cleanUpLine(line) {
	    line.parent = null;
	    detachMarkedSpans(line);
	  }
	
	  // Convert a style as returned by a mode (either null, or a string
	  // containing one or more styles) to a CSS style. This is cached,
	  // and also looks for line-wide styles.
	  var styleToClassCache = {};
	  var styleToClassCacheWithMode = {};
	  function interpretTokenStyle(style, options) {
	    if (!style || /^\s*$/.test(style)) {
	      return null;
	    }
	    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
	    return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
	  }
	
	  // Render the DOM representation of the text of a line. Also builds
	  // up a 'line map', which points at the DOM nodes that represent
	  // specific stretches of text, and is used by the measuring code.
	  // The returned object contains the DOM node, this map, and
	  // information about line-wide styles that were set by the mode.
	  function buildLineContent(cm, lineView) {
	    // The padding-right forces the element to have a 'border', which
	    // is needed on Webkit to be able to get line-level bounding
	    // rectangles for it (in measureChar).
	    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
	    var builder = { pre: eltP("pre", [content], "CodeMirror-line"), content: content,
	      col: 0, pos: 0, cm: cm,
	      trailingSpace: false,
	      splitSpaces: (ie || webkit) && cm.getOption("lineWrapping") };
	    lineView.measure = {};
	
	    // Iterate over the logical lines that make up this visual line.
	    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	      var line = i ? lineView.rest[i - 1] : lineView.line,
	          order = void 0;
	      builder.pos = 0;
	      builder.addToken = buildToken;
	      // Optionally wire in some hacks into the token-rendering
	      // algorithm, to deal with browser quirks.
	      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) {
	        builder.addToken = buildTokenBadBidi(builder.addToken, order);
	      }
	      builder.map = [];
	      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
	      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
	      if (line.styleClasses) {
	        if (line.styleClasses.bgClass) {
	          builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
	        }
	        if (line.styleClasses.textClass) {
	          builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
	        }
	      }
	
	      // Ensure at least a single node is present, for measuring.
	      if (builder.map.length == 0) {
	        builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
	      }
	
	      // Store the map and a cache object for the current logical line
	      if (i == 0) {
	        lineView.measure.map = builder.map;
	        lineView.measure.cache = {};
	      } else {
	        (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);(lineView.measure.caches || (lineView.measure.caches = [])).push({});
	      }
	    }
	
	    // See issue #2901
	    if (webkit) {
	      var last = builder.content.lastChild;
	      if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) {
	        builder.content.className = "cm-tab-wrap-hack";
	      }
	    }
	
	    signal(cm, "renderLine", cm, lineView.line, builder.pre);
	    if (builder.pre.className) {
	      builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
	    }
	
	    return builder;
	  }
	
	  function defaultSpecialCharPlaceholder(ch) {
	    var token = elt("span", '\u2022', "cm-invalidchar");
	    token.title = '\\u' + ch.charCodeAt(0).toString(16);
	    token.setAttribute("aria-label", token.title);
	    return token;
	  }
	
	  // Build up the DOM representation for a single token, and add it to
	  // the line map. Takes care to render special characters separately.
	  function buildToken(builder, text, style, startStyle, endStyle, title, css) {
	    if (!text) {
	      return;
	    }
	    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
	    var special = builder.cm.state.specialChars,
	        mustWrap = false;
	    var content;
	    if (!special.test(text)) {
	      builder.col += text.length;
	      content = document.createTextNode(displayText);
	      builder.map.push(builder.pos, builder.pos + text.length, content);
	      if (ie && ie_version < 9) {
	        mustWrap = true;
	      }
	      builder.pos += text.length;
	    } else {
	      content = document.createDocumentFragment();
	      var pos = 0;
	      while (true) {
	        special.lastIndex = pos;
	        var m = special.exec(text);
	        var skipped = m ? m.index - pos : text.length - pos;
	        if (skipped) {
	          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
	          if (ie && ie_version < 9) {
	            content.appendChild(elt("span", [txt]));
	          } else {
	            content.appendChild(txt);
	          }
	          builder.map.push(builder.pos, builder.pos + skipped, txt);
	          builder.col += skipped;
	          builder.pos += skipped;
	        }
	        if (!m) {
	          break;
	        }
	        pos += skipped + 1;
	        var txt$1 = void 0;
	        if (m[0] == "\t") {
	          var tabSize = builder.cm.options.tabSize,
	              tabWidth = tabSize - builder.col % tabSize;
	          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
	          txt$1.setAttribute("role", "presentation");
	          txt$1.setAttribute("cm-text", "\t");
	          builder.col += tabWidth;
	        } else if (m[0] == "\r" || m[0] == "\n") {
	          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? '\u240D' : '\u2424', "cm-invalidchar"));
	          txt$1.setAttribute("cm-text", m[0]);
	          builder.col += 1;
	        } else {
	          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
	          txt$1.setAttribute("cm-text", m[0]);
	          if (ie && ie_version < 9) {
	            content.appendChild(elt("span", [txt$1]));
	          } else {
	            content.appendChild(txt$1);
	          }
	          builder.col += 1;
	        }
	        builder.map.push(builder.pos, builder.pos + 1, txt$1);
	        builder.pos++;
	      }
	    }
	    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
	    if (style || startStyle || endStyle || mustWrap || css) {
	      var fullStyle = style || "";
	      if (startStyle) {
	        fullStyle += startStyle;
	      }
	      if (endStyle) {
	        fullStyle += endStyle;
	      }
	      var token = elt("span", [content], fullStyle, css);
	      if (title) {
	        token.title = title;
	      }
	      return builder.content.appendChild(token);
	    }
	    builder.content.appendChild(content);
	  }
	
	  function splitSpaces(text, trailingBefore) {
	    if (text.length > 1 && !/  /.test(text)) {
	      return text;
	    }
	    var spaceBefore = trailingBefore,
	        result = "";
	    for (var i = 0; i < text.length; i++) {
	      var ch = text.charAt(i);
	      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) {
	        ch = '\xA0';
	      }
	      result += ch;
	      spaceBefore = ch == " ";
	    }
	    return result;
	  }
	
	  // Work around nonsense dimensions being reported for stretches of
	  // right-to-left text.
	  function buildTokenBadBidi(inner, order) {
	    return function (builder, text, style, startStyle, endStyle, title, css) {
	      style = style ? style + " cm-force-border" : "cm-force-border";
	      var start = builder.pos,
	          end = start + text.length;
	      for (;;) {
	        // Find the part that overlaps with the start of this text
	        var part = void 0;
	        for (var i = 0; i < order.length; i++) {
	          part = order[i];
	          if (part.to > start && part.from <= start) {
	            break;
	          }
	        }
	        if (part.to >= end) {
	          return inner(builder, text, style, startStyle, endStyle, title, css);
	        }
	        inner(builder, text.slice(0, part.to - start), style, startStyle, null, title, css);
	        startStyle = null;
	        text = text.slice(part.to - start);
	        start = part.to;
	      }
	    };
	  }
	
	  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	    var widget = !ignoreWidget && marker.widgetNode;
	    if (widget) {
	      builder.map.push(builder.pos, builder.pos + size, widget);
	    }
	    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	      if (!widget) {
	        widget = builder.content.appendChild(document.createElement("span"));
	      }
	      widget.setAttribute("cm-marker", marker.id);
	    }
	    if (widget) {
	      builder.cm.display.input.setUneditable(widget);
	      builder.content.appendChild(widget);
	    }
	    builder.pos += size;
	    builder.trailingSpace = false;
	  }
	
	  // Outputs a number of spans to make up a line, taking highlighting
	  // and marked text into account.
	  function insertLineContent(line, builder, styles) {
	    var spans = line.markedSpans,
	        allText = line.text,
	        at = 0;
	    if (!spans) {
	      for (var i$1 = 1; i$1 < styles.length; i$1 += 2) {
	        builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
	      }
	      return;
	    }
	
	    var len = allText.length,
	        pos = 0,
	        i = 1,
	        text = "",
	        style,
	        css;
	    var nextChange = 0,
	        spanStyle,
	        spanEndStyle,
	        spanStartStyle,
	        title,
	        collapsed;
	    for (;;) {
	      if (nextChange == pos) {
	        // Update current marker set
	        spanStyle = spanEndStyle = spanStartStyle = title = css = "";
	        collapsed = null;nextChange = Infinity;
	        var foundBookmarks = [],
	            endStyles = void 0;
	        for (var j = 0; j < spans.length; ++j) {
	          var sp = spans[j],
	              m = sp.marker;
	          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	            foundBookmarks.push(m);
	          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	              nextChange = sp.to;
	              spanEndStyle = "";
	            }
	            if (m.className) {
	              spanStyle += " " + m.className;
	            }
	            if (m.css) {
	              css = (css ? css + ";" : "") + m.css;
	            }
	            if (m.startStyle && sp.from == pos) {
	              spanStartStyle += " " + m.startStyle;
	            }
	            if (m.endStyle && sp.to == nextChange) {
	              (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
	            }
	            if (m.title && !title) {
	              title = m.title;
	            }
	            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) {
	              collapsed = sp;
	            }
	          } else if (sp.from > pos && nextChange > sp.from) {
	            nextChange = sp.from;
	          }
	        }
	        if (endStyles) {
	          for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2) {
	            if (endStyles[j$1 + 1] == nextChange) {
	              spanEndStyle += " " + endStyles[j$1];
	            }
	          }
	        }
	
	        if (!collapsed || collapsed.from == pos) {
	          for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2) {
	            buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
	          }
	        }
	        if (collapsed && (collapsed.from || 0) == pos) {
	          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
	          if (collapsed.to == null) {
	            return;
	          }
	          if (collapsed.to == pos) {
	            collapsed = false;
	          }
	        }
	      }
	      if (pos >= len) {
	        break;
	      }
	
	      var upto = Math.min(len, nextChange);
	      while (true) {
	        if (text) {
	          var end = pos + text.length;
	          if (!collapsed) {
	            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
	            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", title, css);
	          }
	          if (end >= upto) {
	            text = text.slice(upto - pos);pos = upto;break;
	          }
	          pos = end;
	          spanStartStyle = "";
	        }
	        text = allText.slice(at, at = styles[i++]);
	        style = interpretTokenStyle(styles[i++], builder.cm.options);
	      }
	    }
	  }
	
	  // These objects are used to represent the visible (currently drawn)
	  // part of the document. A LineView may correspond to multiple
	  // logical lines, if those are connected by collapsed ranges.
	  function LineView(doc, line, lineN) {
	    // The starting line
	    this.line = line;
	    // Continuing lines, if any
	    this.rest = visualLineContinued(line);
	    // Number of logical lines in this visual line
	    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
	    this.node = this.text = null;
	    this.hidden = lineIsHidden(doc, line);
	  }
	
	  // Create a range of LineView objects for the given lines.
	  function buildViewArray(cm, from, to) {
	    var array = [],
	        nextPos;
	    for (var pos = from; pos < to; pos = nextPos) {
	      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
	      nextPos = pos + view.size;
	      array.push(view);
	    }
	    return array;
	  }
	
	  var operationGroup = null;
	
	  function pushOperation(op) {
	    if (operationGroup) {
	      operationGroup.ops.push(op);
	    } else {
	      op.ownsGroup = operationGroup = {
	        ops: [op],
	        delayedCallbacks: []
	      };
	    }
	  }
	
	  function fireCallbacksForOps(group) {
	    // Calls delayed callbacks and cursorActivity handlers until no
	    // new ones appear
	    var callbacks = group.delayedCallbacks,
	        i = 0;
	    do {
	      for (; i < callbacks.length; i++) {
	        callbacks[i].call(null);
	      }
	      for (var j = 0; j < group.ops.length; j++) {
	        var op = group.ops[j];
	        if (op.cursorActivityHandlers) {
	          while (op.cursorActivityCalled < op.cursorActivityHandlers.length) {
	            op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
	          }
	        }
	      }
	    } while (i < callbacks.length);
	  }
	
	  function finishOperation(op, endCb) {
	    var group = op.ownsGroup;
	    if (!group) {
	      return;
	    }
	
	    try {
	      fireCallbacksForOps(group);
	    } finally {
	      operationGroup = null;
	      endCb(group);
	    }
	  }
	
	  var orphanDelayedCallbacks = null;
	
	  // Often, we want to signal events at a point where we are in the
	  // middle of some work, but don't want the handler to start calling
	  // other methods on the editor, which might be in an inconsistent
	  // state or simply not expect any other events to happen.
	  // signalLater looks whether there are any handlers, and schedules
	  // them to be executed when the last operation ends, or, if no
	  // operation is active, when a timeout fires.
	  function signalLater(emitter, type /*, values...*/) {
	    var arr = getHandlers(emitter, type);
	    if (!arr.length) {
	      return;
	    }
	    var args = Array.prototype.slice.call(arguments, 2),
	        list;
	    if (operationGroup) {
	      list = operationGroup.delayedCallbacks;
	    } else if (orphanDelayedCallbacks) {
	      list = orphanDelayedCallbacks;
	    } else {
	      list = orphanDelayedCallbacks = [];
	      setTimeout(fireOrphanDelayed, 0);
	    }
	    var loop = function loop(i) {
	      list.push(function () {
	        return arr[i].apply(null, args);
	      });
	    };
	
	    for (var i = 0; i < arr.length; ++i) {
	      loop(i);
	    }
	  }
	
	  function fireOrphanDelayed() {
	    var delayed = orphanDelayedCallbacks;
	    orphanDelayedCallbacks = null;
	    for (var i = 0; i < delayed.length; ++i) {
	      delayed[i]();
	    }
	  }
	
	  // When an aspect of a line changes, a string is added to
	  // lineView.changes. This updates the relevant part of the line's
	  // DOM structure.
	  function updateLineForChanges(cm, lineView, lineN, dims) {
	    for (var j = 0; j < lineView.changes.length; j++) {
	      var type = lineView.changes[j];
	      if (type == "text") {
	        updateLineText(cm, lineView);
	      } else if (type == "gutter") {
	        updateLineGutter(cm, lineView, lineN, dims);
	      } else if (type == "class") {
	        updateLineClasses(cm, lineView);
	      } else if (type == "widget") {
	        updateLineWidgets(cm, lineView, dims);
	      }
	    }
	    lineView.changes = null;
	  }
	
	  // Lines with gutter elements, widgets or a background class need to
	  // be wrapped, and have the extra elements added to the wrapper div
	  function ensureLineWrapped(lineView) {
	    if (lineView.node == lineView.text) {
	      lineView.node = elt("div", null, null, "position: relative");
	      if (lineView.text.parentNode) {
	        lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
	      }
	      lineView.node.appendChild(lineView.text);
	      if (ie && ie_version < 8) {
	        lineView.node.style.zIndex = 2;
	      }
	    }
	    return lineView.node;
	  }
	
	  function updateLineBackground(cm, lineView) {
	    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
	    if (cls) {
	      cls += " CodeMirror-linebackground";
	    }
	    if (lineView.background) {
	      if (cls) {
	        lineView.background.className = cls;
	      } else {
	        lineView.background.parentNode.removeChild(lineView.background);lineView.background = null;
	      }
	    } else if (cls) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
	      cm.display.input.setUneditable(lineView.background);
	    }
	  }
	
	  // Wrapper around buildLineContent which will reuse the structure
	  // in display.externalMeasured when possible.
	  function getLineContent(cm, lineView) {
	    var ext = cm.display.externalMeasured;
	    if (ext && ext.line == lineView.line) {
	      cm.display.externalMeasured = null;
	      lineView.measure = ext.measure;
	      return ext.built;
	    }
	    return buildLineContent(cm, lineView);
	  }
	
	  // Redraw the line's text. Interacts with the background and text
	  // classes because the mode may output tokens that influence these
	  // classes.
	  function updateLineText(cm, lineView) {
	    var cls = lineView.text.className;
	    var built = getLineContent(cm, lineView);
	    if (lineView.text == lineView.node) {
	      lineView.node = built.pre;
	    }
	    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
	    lineView.text = built.pre;
	    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	      lineView.bgClass = built.bgClass;
	      lineView.textClass = built.textClass;
	      updateLineClasses(cm, lineView);
	    } else if (cls) {
	      lineView.text.className = cls;
	    }
	  }
	
	  function updateLineClasses(cm, lineView) {
	    updateLineBackground(cm, lineView);
	    if (lineView.line.wrapClass) {
	      ensureLineWrapped(lineView).className = lineView.line.wrapClass;
	    } else if (lineView.node != lineView.text) {
	      lineView.node.className = "";
	    }
	    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
	    lineView.text.className = textClass || "";
	  }
	
	  function updateLineGutter(cm, lineView, lineN, dims) {
	    if (lineView.gutter) {
	      lineView.node.removeChild(lineView.gutter);
	      lineView.gutter = null;
	    }
	    if (lineView.gutterBackground) {
	      lineView.node.removeChild(lineView.gutterBackground);
	      lineView.gutterBackground = null;
	    }
	    if (lineView.line.gutterClass) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
	      cm.display.input.setUneditable(lineView.gutterBackground);
	      wrap.insertBefore(lineView.gutterBackground, lineView.text);
	    }
	    var markers = lineView.line.gutterMarkers;
	    if (cm.options.lineNumbers || markers) {
	      var wrap$1 = ensureLineWrapped(lineView);
	      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
	      cm.display.input.setUneditable(gutterWrap);
	      wrap$1.insertBefore(gutterWrap, lineView.text);
	      if (lineView.line.gutterClass) {
	        gutterWrap.className += " " + lineView.line.gutterClass;
	      }
	      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) {
	        lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
	      }
	      if (markers) {
	        for (var k = 0; k < cm.options.gutters.length; ++k) {
	          var id = cm.options.gutters[k],
	              found = markers.hasOwnProperty(id) && markers[id];
	          if (found) {
	            gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
	          }
	        }
	      }
	    }
	  }
	
	  function updateLineWidgets(cm, lineView, dims) {
	    if (lineView.alignable) {
	      lineView.alignable = null;
	    }
	    for (var node = lineView.node.firstChild, next = void 0; node; node = next) {
	      next = node.nextSibling;
	      if (node.className == "CodeMirror-linewidget") {
	        lineView.node.removeChild(node);
	      }
	    }
	    insertLineWidgets(cm, lineView, dims);
	  }
	
	  // Build a line's DOM representation from scratch
	  function buildLineElement(cm, lineView, lineN, dims) {
	    var built = getLineContent(cm, lineView);
	    lineView.text = lineView.node = built.pre;
	    if (built.bgClass) {
	      lineView.bgClass = built.bgClass;
	    }
	    if (built.textClass) {
	      lineView.textClass = built.textClass;
	    }
	
	    updateLineClasses(cm, lineView);
	    updateLineGutter(cm, lineView, lineN, dims);
	    insertLineWidgets(cm, lineView, dims);
	    return lineView.node;
	  }
	
	  // A lineView may contain multiple logical lines (when merged by
	  // collapsed spans). The widgets for all of them need to be drawn.
	  function insertLineWidgets(cm, lineView, dims) {
	    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
	    if (lineView.rest) {
	      for (var i = 0; i < lineView.rest.length; i++) {
	        insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
	      }
	    }
	  }
	
	  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	    if (!line.widgets) {
	      return;
	    }
	    var wrap = ensureLineWrapped(lineView);
	    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	      var widget = ws[i],
	          node = elt("div", [widget.node], "CodeMirror-linewidget");
	      if (!widget.handleMouseEvents) {
	        node.setAttribute("cm-ignore-events", "true");
	      }
	      positionLineWidget(widget, node, lineView, dims);
	      cm.display.input.setUneditable(node);
	      if (allowAbove && widget.above) {
	        wrap.insertBefore(node, lineView.gutter || lineView.text);
	      } else {
	        wrap.appendChild(node);
	      }
	      signalLater(widget, "redraw");
	    }
	  }
	
	  function positionLineWidget(widget, node, lineView, dims) {
	    if (widget.noHScroll) {
	      (lineView.alignable || (lineView.alignable = [])).push(node);
	      var width = dims.wrapperWidth;
	      node.style.left = dims.fixedPos + "px";
	      if (!widget.coverGutter) {
	        width -= dims.gutterTotalWidth;
	        node.style.paddingLeft = dims.gutterTotalWidth + "px";
	      }
	      node.style.width = width + "px";
	    }
	    if (widget.coverGutter) {
	      node.style.zIndex = 5;
	      node.style.position = "relative";
	      if (!widget.noHScroll) {
	        node.style.marginLeft = -dims.gutterTotalWidth + "px";
	      }
	    }
	  }
	
	  function widgetHeight(widget) {
	    if (widget.height != null) {
	      return widget.height;
	    }
	    var cm = widget.doc.cm;
	    if (!cm) {
	      return 0;
	    }
	    if (!contains(document.body, widget.node)) {
	      var parentStyle = "position: relative;";
	      if (widget.coverGutter) {
	        parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
	      }
	      if (widget.noHScroll) {
	        parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
	      }
	      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
	    }
	    return widget.height = widget.node.parentNode.offsetHeight;
	  }
	
	  // Return true when the given mouse event happened in a widget
	  function eventInWidget(display, e) {
	    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	      if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) {
	        return true;
	      }
	    }
	  }
	
	  // POSITION MEASUREMENT
	
	  function paddingTop(display) {
	    return display.lineSpace.offsetTop;
	  }
	  function paddingVert(display) {
	    return display.mover.offsetHeight - display.lineSpace.offsetHeight;
	  }
	  function paddingH(display) {
	    if (display.cachedPaddingH) {
	      return display.cachedPaddingH;
	    }
	    var e = removeChildrenAndAdd(display.measure, elt("pre", "x"));
	    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
	    var data = { left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight) };
	    if (!isNaN(data.left) && !isNaN(data.right)) {
	      display.cachedPaddingH = data;
	    }
	    return data;
	  }
	
	  function scrollGap(cm) {
	    return scrollerGap - cm.display.nativeBarWidth;
	  }
	  function displayWidth(cm) {
	    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
	  }
	  function displayHeight(cm) {
	    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
	  }
	
	  // Ensure the lineView.wrapping.heights array is populated. This is
	  // an array of bottom offsets for the lines that make up a drawn
	  // line. When lineWrapping is on, there might be more than one
	  // height.
	  function ensureLineHeights(cm, lineView, rect) {
	    var wrapping = cm.options.lineWrapping;
	    var curWidth = wrapping && displayWidth(cm);
	    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	      var heights = lineView.measure.heights = [];
	      if (wrapping) {
	        lineView.measure.width = curWidth;
	        var rects = lineView.text.firstChild.getClientRects();
	        for (var i = 0; i < rects.length - 1; i++) {
	          var cur = rects[i],
	              next = rects[i + 1];
	          if (Math.abs(cur.bottom - next.bottom) > 2) {
	            heights.push((cur.bottom + next.top) / 2 - rect.top);
	          }
	        }
	      }
	      heights.push(rect.bottom - rect.top);
	    }
	  }
	
	  // Find a line map (mapping character offsets to text nodes) and a
	  // measurement cache for the given line number. (A line view might
	  // contain multiple lines when collapsed ranges are present.)
	  function mapFromLineView(lineView, line, lineN) {
	    if (lineView.line == line) {
	      return { map: lineView.measure.map, cache: lineView.measure.cache };
	    }
	    for (var i = 0; i < lineView.rest.length; i++) {
	      if (lineView.rest[i] == line) {
	        return { map: lineView.measure.maps[i], cache: lineView.measure.caches[i] };
	      }
	    }
	    for (var i$1 = 0; i$1 < lineView.rest.length; i$1++) {
	      if (lineNo(lineView.rest[i$1]) > lineN) {
	        return { map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true };
	      }
	    }
	  }
	
	  // Render a line into the hidden node display.externalMeasured. Used
	  // when measurement is needed for a line that's not in the viewport.
	  function updateExternalMeasurement(cm, line) {
	    line = visualLine(line);
	    var lineN = lineNo(line);
	    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
	    view.lineN = lineN;
	    var built = view.built = buildLineContent(cm, view);
	    view.text = built.pre;
	    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
	    return view;
	  }
	
	  // Get a {top, bottom, left, right} box (in line-local coordinates)
	  // for a given character.
	  function measureChar(cm, line, ch, bias) {
	    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
	  }
	
	  // Find a line view that corresponds to the given line number.
	  function findViewForLine(cm, lineN) {
	    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) {
	      return cm.display.view[findViewIndex(cm, lineN)];
	    }
	    var ext = cm.display.externalMeasured;
	    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) {
	      return ext;
	    }
	  }
	
	  // Measurement can be split in two steps, the set-up work that
	  // applies to the whole line, and the measurement of the actual
	  // character. Functions like coordsChar, that need to do a lot of
	  // measurements in a row, can thus ensure that the set-up work is
	  // only done once.
	  function prepareMeasureForLine(cm, line) {
	    var lineN = lineNo(line);
	    var view = findViewForLine(cm, lineN);
	    if (view && !view.text) {
	      view = null;
	    } else if (view && view.changes) {
	      updateLineForChanges(cm, view, lineN, getDimensions(cm));
	      cm.curOp.forceUpdate = true;
	    }
	    if (!view) {
	      view = updateExternalMeasurement(cm, line);
	    }
	
	    var info = mapFromLineView(view, line, lineN);
	    return {
	      line: line, view: view, rect: null,
	      map: info.map, cache: info.cache, before: info.before,
	      hasHeights: false
	    };
	  }
	
	  // Given a prepared measurement object, measures the position of an
	  // actual character (or fetches it from the cache).
	  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	    if (prepared.before) {
	      ch = -1;
	    }
	    var key = ch + (bias || ""),
	        found;
	    if (prepared.cache.hasOwnProperty(key)) {
	      found = prepared.cache[key];
	    } else {
	      if (!prepared.rect) {
	        prepared.rect = prepared.view.text.getBoundingClientRect();
	      }
	      if (!prepared.hasHeights) {
	        ensureLineHeights(cm, prepared.view, prepared.rect);
	        prepared.hasHeights = true;
	      }
	      found = measureCharInner(cm, prepared, ch, bias);
	      if (!found.bogus) {
	        prepared.cache[key] = found;
	      }
	    }
	    return { left: found.left, right: found.right,
	      top: varHeight ? found.rtop : found.top,
	      bottom: varHeight ? found.rbottom : found.bottom };
	  }
	
	  var nullRect = { left: 0, right: 0, top: 0, bottom: 0 };
	
	  function nodeAndOffsetInLineMap(map$$1, ch, bias) {
	    var node, start, end, collapse, mStart, mEnd;
	    // First, search the line map for the text node corresponding to,
	    // or closest to, the target character.
	    for (var i = 0; i < map$$1.length; i += 3) {
	      mStart = map$$1[i];
	      mEnd = map$$1[i + 1];
	      if (ch < mStart) {
	        start = 0;end = 1;
	        collapse = "left";
	      } else if (ch < mEnd) {
	        start = ch - mStart;
	        end = start + 1;
	      } else if (i == map$$1.length - 3 || ch == mEnd && map$$1[i + 3] > ch) {
	        end = mEnd - mStart;
	        start = end - 1;
	        if (ch >= mEnd) {
	          collapse = "right";
	        }
	      }
	      if (start != null) {
	        node = map$$1[i + 2];
	        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) {
	          collapse = bias;
	        }
	        if (bias == "left" && start == 0) {
	          while (i && map$$1[i - 2] == map$$1[i - 3] && map$$1[i - 1].insertLeft) {
	            node = map$$1[(i -= 3) + 2];
	            collapse = "left";
	          }
	        }
	        if (bias == "right" && start == mEnd - mStart) {
	          while (i < map$$1.length - 3 && map$$1[i + 3] == map$$1[i + 4] && !map$$1[i + 5].insertLeft) {
	            node = map$$1[(i += 3) + 2];
	            collapse = "right";
	          }
	        }
	        break;
	      }
	    }
	    return { node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd };
	  }
	
	  function getUsefulRect(rects, bias) {
	    var rect = nullRect;
	    if (bias == "left") {
	      for (var i = 0; i < rects.length; i++) {
	        if ((rect = rects[i]).left != rect.right) {
	          break;
	        }
	      }
	    } else {
	      for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
	        if ((rect = rects[i$1]).left != rect.right) {
	          break;
	        }
	      }
	    }
	    return rect;
	  }
	
	  function measureCharInner(cm, prepared, ch, bias) {
	    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
	    var node = place.node,
	        start = place.start,
	        end = place.end,
	        collapse = place.collapse;
	
	    var rect;
	    if (node.nodeType == 3) {
	      // If it is a text node, use a range to retrieve the coordinates.
	      for (var i$1 = 0; i$1 < 4; i$1++) {
	        // Retry a maximum of 4 times when nonsense rectangles are returned
	        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) {
	          --start;
	        }
	        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) {
	          ++end;
	        }
	        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) {
	          rect = node.parentNode.getBoundingClientRect();
	        } else {
	          rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
	        }
	        if (rect.left || rect.right || start == 0) {
	          break;
	        }
	        end = start;
	        start = start - 1;
	        collapse = "right";
	      }
	      if (ie && ie_version < 11) {
	        rect = maybeUpdateRectForZooming(cm.display.measure, rect);
	      }
	    } else {
	      // If it is a widget, simply get the box for the whole widget.
	      if (start > 0) {
	        collapse = bias = "right";
	      }
	      var rects;
	      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) {
	        rect = rects[bias == "right" ? rects.length - 1 : 0];
	      } else {
	        rect = node.getBoundingClientRect();
	      }
	    }
	    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	      var rSpan = node.parentNode.getClientRects()[0];
	      if (rSpan) {
	        rect = { left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom };
	      } else {
	        rect = nullRect;
	      }
	    }
	
	    var rtop = rect.top - prepared.rect.top,
	        rbot = rect.bottom - prepared.rect.top;
	    var mid = (rtop + rbot) / 2;
	    var heights = prepared.view.measure.heights;
	    var i = 0;
	    for (; i < heights.length - 1; i++) {
	      if (mid < heights[i]) {
	        break;
	      }
	    }
	    var top = i ? heights[i - 1] : 0,
	        bot = heights[i];
	    var result = { left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	      right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	      top: top, bottom: bot };
	    if (!rect.left && !rect.right) {
	      result.bogus = true;
	    }
	    if (!cm.options.singleCursorHeightPerLine) {
	      result.rtop = rtop;result.rbottom = rbot;
	    }
	
	    return result;
	  }
	
	  // Work around problem with bounding client rects on ranges being
	  // returned incorrectly when zoomed on IE10 and below.
	  function maybeUpdateRectForZooming(measure, rect) {
	    if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) {
	      return rect;
	    }
	    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
	    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
	    return { left: rect.left * scaleX, right: rect.right * scaleX,
	      top: rect.top * scaleY, bottom: rect.bottom * scaleY };
	  }
	
	  function clearLineMeasurementCacheFor(lineView) {
	    if (lineView.measure) {
	      lineView.measure.cache = {};
	      lineView.measure.heights = null;
	      if (lineView.rest) {
	        for (var i = 0; i < lineView.rest.length; i++) {
	          lineView.measure.caches[i] = {};
	        }
	      }
	    }
	  }
	
	  function clearLineMeasurementCache(cm) {
	    cm.display.externalMeasure = null;
	    removeChildren(cm.display.lineMeasure);
	    for (var i = 0; i < cm.display.view.length; i++) {
	      clearLineMeasurementCacheFor(cm.display.view[i]);
	    }
	  }
	
	  function clearCaches(cm) {
	    clearLineMeasurementCache(cm);
	    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
	    if (!cm.options.lineWrapping) {
	      cm.display.maxLineChanged = true;
	    }
	    cm.display.lineNumChars = null;
	  }
	
	  function pageScrollX() {
	    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
	    // which causes page_Offset and bounding client rects to use
	    // different reference viewports and invalidate our calculations.
	    if (chrome && android) {
	      return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft));
	    }
	    return window.pageXOffset || (document.documentElement || document.body).scrollLeft;
	  }
	  function pageScrollY() {
	    if (chrome && android) {
	      return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop));
	    }
	    return window.pageYOffset || (document.documentElement || document.body).scrollTop;
	  }
	
	  function widgetTopHeight(lineObj) {
	    var height = 0;
	    if (lineObj.widgets) {
	      for (var i = 0; i < lineObj.widgets.length; ++i) {
	        if (lineObj.widgets[i].above) {
	          height += widgetHeight(lineObj.widgets[i]);
	        }
	      }
	    }
	    return height;
	  }
	
	  // Converts a {top, bottom, left, right} box from line-local
	  // coordinates into another coordinate system. Context may be one of
	  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
	  // or "page".
	  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
	    if (!includeWidgets) {
	      var height = widgetTopHeight(lineObj);
	      rect.top += height;rect.bottom += height;
	    }
	    if (context == "line") {
	      return rect;
	    }
	    if (!context) {
	      context = "local";
	    }
	    var yOff = _heightAtLine(lineObj);
	    if (context == "local") {
	      yOff += paddingTop(cm.display);
	    } else {
	      yOff -= cm.display.viewOffset;
	    }
	    if (context == "page" || context == "window") {
	      var lOff = cm.display.lineSpace.getBoundingClientRect();
	      yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
	      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
	      rect.left += xOff;rect.right += xOff;
	    }
	    rect.top += yOff;rect.bottom += yOff;
	    return rect;
	  }
	
	  // Coverts a box from "div" coords to another coordinate system.
	  // Context may be "window", "page", "div", or "local"./null.
	  function fromCoordSystem(cm, coords, context) {
	    if (context == "div") {
	      return coords;
	    }
	    var left = coords.left,
	        top = coords.top;
	    // First move into "page" coordinate system
	    if (context == "page") {
	      left -= pageScrollX();
	      top -= pageScrollY();
	    } else if (context == "local" || !context) {
	      var localBox = cm.display.sizer.getBoundingClientRect();
	      left += localBox.left;
	      top += localBox.top;
	    }
	
	    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
	    return { left: left - lineSpaceBox.left, top: top - lineSpaceBox.top };
	  }
	
	  function _charCoords(cm, pos, context, lineObj, bias) {
	    if (!lineObj) {
	      lineObj = getLine(cm.doc, pos.line);
	    }
	    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
	  }
	
	  // Returns a box for a given cursor position, which may have an
	  // 'other' property containing the position of the secondary cursor
	  // on a bidi boundary.
	  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
	  // and after `char - 1` in writing order of `char - 1`
	  // A cursor Pos(line, char, "after") is on the same visual line as `char`
	  // and before `char` in writing order of `char`
	  // Examples (upper-case letters are RTL, lower-case are LTR):
	  //     Pos(0, 1, ...)
	  //     before   after
	  // ab     a|b     a|b
	  // aB     a|B     aB|
	  // Ab     |Ab     A|b
	  // AB     B|A     B|A
	  // Every position after the last character on a line is considered to stick
	  // to the last character on the line.
	  function _cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	    lineObj = lineObj || getLine(cm.doc, pos.line);
	    if (!preparedMeasure) {
	      preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    }
	    function get(ch, right) {
	      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
	      if (right) {
	        m.left = m.right;
	      } else {
	        m.right = m.left;
	      }
	      return intoCoordSystem(cm, lineObj, m, context);
	    }
	    var order = getOrder(lineObj, cm.doc.direction),
	        ch = pos.ch,
	        sticky = pos.sticky;
	    if (ch >= lineObj.text.length) {
	      ch = lineObj.text.length;
	      sticky = "before";
	    } else if (ch <= 0) {
	      ch = 0;
	      sticky = "after";
	    }
	    if (!order) {
	      return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
	    }
	
	    function getBidi(ch, partPos, invert) {
	      var part = order[partPos],
	          right = part.level == 1;
	      return get(invert ? ch - 1 : ch, right != invert);
	    }
	    var partPos = getBidiPartAt(order, ch, sticky);
	    var other = bidiOther;
	    var val = getBidi(ch, partPos, sticky == "before");
	    if (other != null) {
	      val.other = getBidi(ch, other, sticky != "before");
	    }
	    return val;
	  }
	
	  // Used to cheaply estimate the coordinates for a position. Used for
	  // intermediate scroll updates.
	  function estimateCoords(cm, pos) {
	    var left = 0;
	    pos = _clipPos(cm.doc, pos);
	    if (!cm.options.lineWrapping) {
	      left = charWidth(cm.display) * pos.ch;
	    }
	    var lineObj = getLine(cm.doc, pos.line);
	    var top = _heightAtLine(lineObj) + paddingTop(cm.display);
	    return { left: left, right: left, top: top, bottom: top + lineObj.height };
	  }
	
	  // Positions returned by coordsChar contain some extra information.
	  // xRel is the relative x position of the input coordinates compared
	  // to the found position (so xRel > 0 means the coordinates are to
	  // the right of the character position, for example). When outside
	  // is true, that means the coordinates lie outside the line's
	  // vertical range.
	  function PosWithInfo(line, ch, sticky, outside, xRel) {
	    var pos = Pos(line, ch, sticky);
	    pos.xRel = xRel;
	    if (outside) {
	      pos.outside = true;
	    }
	    return pos;
	  }
	
	  // Compute the character position closest to the given coordinates.
	  // Input must be lineSpace-local ("div" coordinate system).
	  function _coordsChar(cm, x, y) {
	    var doc = cm.doc;
	    y += cm.display.viewOffset;
	    if (y < 0) {
	      return PosWithInfo(doc.first, 0, null, true, -1);
	    }
	    var lineN = _lineAtHeight(doc, y),
	        last = doc.first + doc.size - 1;
	    if (lineN > last) {
	      return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, true, 1);
	    }
	    if (x < 0) {
	      x = 0;
	    }
	
	    var lineObj = getLine(doc, lineN);
	    for (;;) {
	      var found = coordsCharInner(cm, lineObj, lineN, x, y);
	      var merged = collapsedSpanAtEnd(lineObj);
	      var mergedPos = merged && merged.find(0, true);
	      if (merged && (found.ch > mergedPos.from.ch || found.ch == mergedPos.from.ch && found.xRel > 0)) {
	        lineN = lineNo(lineObj = mergedPos.to.line);
	      } else {
	        return found;
	      }
	    }
	  }
	
	  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
	    y -= widgetTopHeight(lineObj);
	    var end = lineObj.text.length;
	    var begin = findFirst(function (ch) {
	      return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
	    }, end, 0);
	    end = findFirst(function (ch) {
	      return measureCharPrepared(cm, preparedMeasure, ch).top > y;
	    }, begin, end);
	    return { begin: begin, end: end };
	  }
	
	  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
	    if (!preparedMeasure) {
	      preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    }
	    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
	    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
	  }
	
	  // Returns true if the given side of a box is after the given
	  // coordinates, in top-to-bottom, left-to-right order.
	  function boxIsAfter(box, x, y, left) {
	    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
	  }
	
	  function coordsCharInner(cm, lineObj, lineNo$$1, x, y) {
	    // Move y into line-local coordinate space
	    y -= _heightAtLine(lineObj);
	    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    // When directly calling `measureCharPrepared`, we have to adjust
	    // for the widgets at this line.
	    var widgetHeight$$1 = widgetTopHeight(lineObj);
	    var begin = 0,
	        end = lineObj.text.length,
	        ltr = true;
	
	    var order = getOrder(lineObj, cm.doc.direction);
	    // If the line isn't plain left-to-right text, first figure out
	    // which bidi section the coordinates fall into.
	    if (order) {
	      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo$$1, preparedMeasure, order, x, y);
	      ltr = part.level != 1;
	      // The awkward -1 offsets are needed because findFirst (called
	      // on these below) will treat its first bound as inclusive,
	      // second as exclusive, but we want to actually address the
	      // characters in the part's range
	      begin = ltr ? part.from : part.to - 1;
	      end = ltr ? part.to : part.from - 1;
	    }
	
	    // A binary search to find the first character whose bounding box
	    // starts after the coordinates. If we run across any whose box wrap
	    // the coordinates, store that.
	    var chAround = null,
	        boxAround = null;
	    var ch = findFirst(function (ch) {
	      var box = measureCharPrepared(cm, preparedMeasure, ch);
	      box.top += widgetHeight$$1;box.bottom += widgetHeight$$1;
	      if (!boxIsAfter(box, x, y, false)) {
	        return false;
	      }
	      if (box.top <= y && box.left <= x) {
	        chAround = ch;
	        boxAround = box;
	      }
	      return true;
	    }, begin, end);
	
	    var baseX,
	        sticky,
	        outside = false;
	    // If a box around the coordinates was found, use that
	    if (boxAround) {
	      // Distinguish coordinates nearer to the left or right side of the box
	      var atLeft = x - boxAround.left < boxAround.right - x,
	          atStart = atLeft == ltr;
	      ch = chAround + (atStart ? 0 : 1);
	      sticky = atStart ? "after" : "before";
	      baseX = atLeft ? boxAround.left : boxAround.right;
	    } else {
	      // (Adjust for extended bound, if necessary.)
	      if (!ltr && (ch == end || ch == begin)) {
	        ch++;
	      }
	      // To determine which side to associate with, get the box to the
	      // left of the character and compare it's vertical position to the
	      // coordinates
	      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight$$1 <= y == ltr ? "after" : "before";
	      // Now get accurate coordinates for this place, in order to get a
	      // base X position
	      var coords = _cursorCoords(cm, Pos(lineNo$$1, ch, sticky), "line", lineObj, preparedMeasure);
	      baseX = coords.left;
	      outside = y < coords.top || y >= coords.bottom;
	    }
	
	    ch = skipExtendingChars(lineObj.text, ch, 1);
	    return PosWithInfo(lineNo$$1, ch, sticky, outside, x - baseX);
	  }
	
	  function coordsBidiPart(cm, lineObj, lineNo$$1, preparedMeasure, order, x, y) {
	    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
	    // situation, we can take this ordering to correspond to the visual
	    // ordering. This finds the first part whose end is after the given
	    // coordinates.
	    var index = findFirst(function (i) {
	      var part = order[i],
	          ltr = part.level != 1;
	      return boxIsAfter(_cursorCoords(cm, Pos(lineNo$$1, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
	    }, 0, order.length - 1);
	    var part = order[index];
	    // If this isn't the first part, the part's start is also after
	    // the coordinates, and the coordinates aren't on the same line as
	    // that start, move one part back.
	    if (index > 0) {
	      var ltr = part.level != 1;
	      var start = _cursorCoords(cm, Pos(lineNo$$1, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
	      if (boxIsAfter(start, x, y, true) && start.top > y) {
	        part = order[index - 1];
	      }
	    }
	    return part;
	  }
	
	  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
	    // In a wrapped line, rtl text on wrapping boundaries can do things
	    // that don't correspond to the ordering in our `order` array at
	    // all, so a binary search doesn't work, and we want to return a
	    // part that only spans one line so that the binary search in
	    // coordsCharInner is safe. As such, we first find the extent of the
	    // wrapped line, and then do a flat search in which we discard any
	    // spans that aren't on the line.
	    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
	    var begin = ref.begin;
	    var end = ref.end;
	    if (/\s/.test(lineObj.text.charAt(end - 1))) {
	      end--;
	    }
	    var part = null,
	        closestDist = null;
	    for (var i = 0; i < order.length; i++) {
	      var p = order[i];
	      if (p.from >= end || p.to <= begin) {
	        continue;
	      }
	      var ltr = p.level != 1;
	      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
	      // Weigh against spans ending before this, so that they are only
	      // picked if nothing ends after
	      var dist = endX < x ? x - endX + 1e9 : endX - x;
	      if (!part || closestDist > dist) {
	        part = p;
	        closestDist = dist;
	      }
	    }
	    if (!part) {
	      part = order[order.length - 1];
	    }
	    // Clip the part to the wrapped line.
	    if (part.from < begin) {
	      part = { from: begin, to: part.to, level: part.level };
	    }
	    if (part.to > end) {
	      part = { from: part.from, to: end, level: part.level };
	    }
	    return part;
	  }
	
	  var measureText;
	  // Compute the default text height.
	  function textHeight(display) {
	    if (display.cachedTextHeight != null) {
	      return display.cachedTextHeight;
	    }
	    if (measureText == null) {
	      measureText = elt("pre");
	      // Measure a bunch of lines, for browsers that compute
	      // fractional heights.
	      for (var i = 0; i < 49; ++i) {
	        measureText.appendChild(document.createTextNode("x"));
	        measureText.appendChild(elt("br"));
	      }
	      measureText.appendChild(document.createTextNode("x"));
	    }
	    removeChildrenAndAdd(display.measure, measureText);
	    var height = measureText.offsetHeight / 50;
	    if (height > 3) {
	      display.cachedTextHeight = height;
	    }
	    removeChildren(display.measure);
	    return height || 1;
	  }
	
	  // Compute the default character width.
	  function charWidth(display) {
	    if (display.cachedCharWidth != null) {
	      return display.cachedCharWidth;
	    }
	    var anchor = elt("span", "xxxxxxxxxx");
	    var pre = elt("pre", [anchor]);
	    removeChildrenAndAdd(display.measure, pre);
	    var rect = anchor.getBoundingClientRect(),
	        width = (rect.right - rect.left) / 10;
	    if (width > 2) {
	      display.cachedCharWidth = width;
	    }
	    return width || 10;
	  }
	
	  // Do a bulk-read of the DOM positions and sizes needed to draw the
	  // view, so that we don't interleave reading and writing to the DOM.
	  function getDimensions(cm) {
	    var d = cm.display,
	        left = {},
	        width = {};
	    var gutterLeft = d.gutters.clientLeft;
	    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	      left[cm.options.gutters[i]] = n.offsetLeft + n.clientLeft + gutterLeft;
	      width[cm.options.gutters[i]] = n.clientWidth;
	    }
	    return { fixedPos: compensateForHScroll(d),
	      gutterTotalWidth: d.gutters.offsetWidth,
	      gutterLeft: left,
	      gutterWidth: width,
	      wrapperWidth: d.wrapper.clientWidth };
	  }
	
	  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	  // but using getBoundingClientRect to get a sub-pixel-accurate
	  // result.
	  function compensateForHScroll(display) {
	    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
	  }
	
	  // Returns a function that estimates the height of a line, to use as
	  // first approximation until the line becomes visible (and is thus
	  // properly measurable).
	  function estimateHeight(cm) {
	    var th = textHeight(cm.display),
	        wrapping = cm.options.lineWrapping;
	    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
	    return function (line) {
	      if (lineIsHidden(cm.doc, line)) {
	        return 0;
	      }
	
	      var widgetsHeight = 0;
	      if (line.widgets) {
	        for (var i = 0; i < line.widgets.length; i++) {
	          if (line.widgets[i].height) {
	            widgetsHeight += line.widgets[i].height;
	          }
	        }
	      }
	
	      if (wrapping) {
	        return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
	      } else {
	        return widgetsHeight + th;
	      }
	    };
	  }
	
	  function estimateLineHeights(cm) {
	    var doc = cm.doc,
	        est = estimateHeight(cm);
	    doc.iter(function (line) {
	      var estHeight = est(line);
	      if (estHeight != line.height) {
	        updateLineHeight(line, estHeight);
	      }
	    });
	  }
	
	  // Given a mouse event, find the corresponding position. If liberal
	  // is false, it checks whether a gutter or scrollbar was clicked,
	  // and returns null if it was. forRect is used by rectangular
	  // selections, and tries to estimate a character position even for
	  // coordinates beyond the right of the text.
	  function posFromMouse(cm, e, liberal, forRect) {
	    var display = cm.display;
	    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") {
	      return null;
	    }
	
	    var x,
	        y,
	        space = display.lineSpace.getBoundingClientRect();
	    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	    try {
	      x = e.clientX - space.left;y = e.clientY - space.top;
	    } catch (e) {
	      return null;
	    }
	    var coords = _coordsChar(cm, x, y),
	        line;
	    if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
	      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
	    }
	    return coords;
	  }
	
	  // Find the view element corresponding to a given line. Return null
	  // when the line isn't visible.
	  function findViewIndex(cm, n) {
	    if (n >= cm.display.viewTo) {
	      return null;
	    }
	    n -= cm.display.viewFrom;
	    if (n < 0) {
	      return null;
	    }
	    var view = cm.display.view;
	    for (var i = 0; i < view.length; i++) {
	      n -= view[i].size;
	      if (n < 0) {
	        return i;
	      }
	    }
	  }
	
	  function updateSelection(cm) {
	    cm.display.input.showSelection(cm.display.input.prepareSelection());
	  }
	
	  function prepareSelection(cm, primary) {
	    if (primary === void 0) primary = true;
	
	    var doc = cm.doc,
	        result = {};
	    var curFragment = result.cursors = document.createDocumentFragment();
	    var selFragment = result.selection = document.createDocumentFragment();
	
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      if (!primary && i == doc.sel.primIndex) {
	        continue;
	      }
	      var range$$1 = doc.sel.ranges[i];
	      if (range$$1.from().line >= cm.display.viewTo || range$$1.to().line < cm.display.viewFrom) {
	        continue;
	      }
	      var collapsed = range$$1.empty();
	      if (collapsed || cm.options.showCursorWhenSelecting) {
	        drawSelectionCursor(cm, range$$1.head, curFragment);
	      }
	      if (!collapsed) {
	        drawSelectionRange(cm, range$$1, selFragment);
	      }
	    }
	    return result;
	  }
	
	  // Draws a cursor for the given range
	  function drawSelectionCursor(cm, head, output) {
	    var pos = _cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
	
	    var cursor = output.appendChild(elt("div", '\xA0', "CodeMirror-cursor"));
	    cursor.style.left = pos.left + "px";
	    cursor.style.top = pos.top + "px";
	    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
	
	    if (pos.other) {
	      // Secondary cursor, shown when on a 'jump' in bi-directional text
	      var otherCursor = output.appendChild(elt("div", '\xA0', "CodeMirror-cursor CodeMirror-secondarycursor"));
	      otherCursor.style.display = "";
	      otherCursor.style.left = pos.other.left + "px";
	      otherCursor.style.top = pos.other.top + "px";
	      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
	    }
	  }
	
	  function cmpCoords(a, b) {
	    return a.top - b.top || a.left - b.left;
	  }
	
	  // Draws the given range as a highlighted selection
	  function drawSelectionRange(cm, range$$1, output) {
	    var display = cm.display,
	        doc = cm.doc;
	    var fragment = document.createDocumentFragment();
	    var padding = paddingH(cm.display),
	        leftSide = padding.left;
	    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
	    var docLTR = doc.direction == "ltr";
	
	    function add(left, top, width, bottom) {
	      if (top < 0) {
	        top = 0;
	      }
	      top = Math.round(top);
	      bottom = Math.round(bottom);
	      fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
	    }
	
	    function drawForLine(line, fromArg, toArg) {
	      var lineObj = getLine(doc, line);
	      var lineLen = lineObj.text.length;
	      var start, end;
	      function coords(ch, bias) {
	        return _charCoords(cm, Pos(line, ch), "div", lineObj, bias);
	      }
	
	      function wrapX(pos, dir, side) {
	        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
	        var prop = dir == "ltr" == (side == "after") ? "left" : "right";
	        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
	        return coords(ch, prop)[prop];
	      }
	
	      var order = getOrder(lineObj, doc.direction);
	      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
	        var ltr = dir == "ltr";
	        var fromPos = coords(from, ltr ? "left" : "right");
	        var toPos = coords(to - 1, ltr ? "right" : "left");
	
	        var openStart = fromArg == null && from == 0,
	            openEnd = toArg == null && to == lineLen;
	        var first = i == 0,
	            last = !order || i == order.length - 1;
	        if (toPos.top - fromPos.top <= 3) {
	          // Single line
	          var openLeft = (docLTR ? openStart : openEnd) && first;
	          var openRight = (docLTR ? openEnd : openStart) && last;
	          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
	          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
	          add(left, fromPos.top, right - left, fromPos.bottom);
	        } else {
	          // Multiple lines
	          var topLeft, topRight, botLeft, botRight;
	          if (ltr) {
	            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
	            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
	            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
	            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
	          } else {
	            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
	            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
	            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
	            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
	          }
	          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
	          if (fromPos.bottom < toPos.top) {
	            add(leftSide, fromPos.bottom, null, toPos.top);
	          }
	          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
	        }
	
	        if (!start || cmpCoords(fromPos, start) < 0) {
	          start = fromPos;
	        }
	        if (cmpCoords(toPos, start) < 0) {
	          start = toPos;
	        }
	        if (!end || cmpCoords(fromPos, end) < 0) {
	          end = fromPos;
	        }
	        if (cmpCoords(toPos, end) < 0) {
	          end = toPos;
	        }
	      });
	      return { start: start, end: end };
	    }
	
	    var sFrom = range$$1.from(),
	        sTo = range$$1.to();
	    if (sFrom.line == sTo.line) {
	      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
	    } else {
	      var fromLine = getLine(doc, sFrom.line),
	          toLine = getLine(doc, sTo.line);
	      var singleVLine = visualLine(fromLine) == visualLine(toLine);
	      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
	      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
	      if (singleVLine) {
	        if (leftEnd.top < rightStart.top - 2) {
	          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
	          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
	        } else {
	          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
	        }
	      }
	      if (leftEnd.bottom < rightStart.top) {
	        add(leftSide, leftEnd.bottom, null, rightStart.top);
	      }
	    }
	
	    output.appendChild(fragment);
	  }
	
	  // Cursor-blinking
	  function restartBlink(cm) {
	    if (!cm.state.focused) {
	      return;
	    }
	    var display = cm.display;
	    clearInterval(display.blinker);
	    var on = true;
	    display.cursorDiv.style.visibility = "";
	    if (cm.options.cursorBlinkRate > 0) {
	      display.blinker = setInterval(function () {
	        return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
	      }, cm.options.cursorBlinkRate);
	    } else if (cm.options.cursorBlinkRate < 0) {
	      display.cursorDiv.style.visibility = "hidden";
	    }
	  }
	
	  function ensureFocus(cm) {
	    if (!cm.state.focused) {
	      cm.display.input.focus();onFocus(cm);
	    }
	  }
	
	  function delayBlurEvent(cm) {
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () {
	      if (cm.state.delayingBlurEvent) {
	        cm.state.delayingBlurEvent = false;
	        onBlur(cm);
	      }
	    }, 100);
	  }
	
	  function onFocus(cm, e) {
	    if (cm.state.delayingBlurEvent) {
	      cm.state.delayingBlurEvent = false;
	    }
	
	    if (cm.options.readOnly == "nocursor") {
	      return;
	    }
	    if (!cm.state.focused) {
	      signal(cm, "focus", cm, e);
	      cm.state.focused = true;
	      addClass(cm.display.wrapper, "CodeMirror-focused");
	      // This test prevents this from firing when a context
	      // menu is closed (since the input reset would kill the
	      // select-all detection hack)
	      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	        cm.display.input.reset();
	        if (webkit) {
	          setTimeout(function () {
	            return cm.display.input.reset(true);
	          }, 20);
	        } // Issue #1730
	      }
	      cm.display.input.receivedFocus();
	    }
	    restartBlink(cm);
	  }
	  function onBlur(cm, e) {
	    if (cm.state.delayingBlurEvent) {
	      return;
	    }
	
	    if (cm.state.focused) {
	      signal(cm, "blur", cm, e);
	      cm.state.focused = false;
	      rmClass(cm.display.wrapper, "CodeMirror-focused");
	    }
	    clearInterval(cm.display.blinker);
	    setTimeout(function () {
	      if (!cm.state.focused) {
	        cm.display.shift = false;
	      }
	    }, 150);
	  }
	
	  // Read the actual heights of the rendered lines, and update their
	  // stored heights to match.
	  function updateHeightsInViewport(cm) {
	    var display = cm.display;
	    var prevBottom = display.lineDiv.offsetTop;
	    for (var i = 0; i < display.view.length; i++) {
	      var cur = display.view[i],
	          height = void 0;
	      if (cur.hidden) {
	        continue;
	      }
	      if (ie && ie_version < 8) {
	        var bot = cur.node.offsetTop + cur.node.offsetHeight;
	        height = bot - prevBottom;
	        prevBottom = bot;
	      } else {
	        var box = cur.node.getBoundingClientRect();
	        height = box.bottom - box.top;
	      }
	      var diff = cur.line.height - height;
	      if (height < 2) {
	        height = textHeight(display);
	      }
	      if (diff > .005 || diff < -.005) {
	        updateLineHeight(cur.line, height);
	        updateWidgetHeight(cur.line);
	        if (cur.rest) {
	          for (var j = 0; j < cur.rest.length; j++) {
	            updateWidgetHeight(cur.rest[j]);
	          }
	        }
	      }
	    }
	  }
	
	  // Read and store the height of line widgets associated with the
	  // given line.
	  function updateWidgetHeight(line) {
	    if (line.widgets) {
	      for (var i = 0; i < line.widgets.length; ++i) {
	        var w = line.widgets[i],
	            parent = w.node.parentNode;
	        if (parent) {
	          w.height = parent.offsetHeight;
	        }
	      }
	    }
	  }
	
	  // Compute the lines that are visible in a given viewport (defaults
	  // the the current scroll position). viewport may contain top,
	  // height, and ensure (see op.scrollToPos) properties.
	  function visibleLines(display, doc, viewport) {
	    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
	    top = Math.floor(top - paddingTop(display));
	    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
	
	    var from = _lineAtHeight(doc, top),
	        to = _lineAtHeight(doc, bottom);
	    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	    // forces those lines into the viewport (if possible).
	    if (viewport && viewport.ensure) {
	      var ensureFrom = viewport.ensure.from.line,
	          ensureTo = viewport.ensure.to.line;
	      if (ensureFrom < from) {
	        from = ensureFrom;
	        to = _lineAtHeight(doc, _heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
	      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	        from = _lineAtHeight(doc, _heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
	        to = ensureTo;
	      }
	    }
	    return { from: from, to: Math.max(to, from + 1) };
	  }
	
	  // Re-align line numbers and gutter marks to compensate for
	  // horizontal scrolling.
	  function alignHorizontally(cm) {
	    var display = cm.display,
	        view = display.view;
	    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) {
	      return;
	    }
	    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
	    var gutterW = display.gutters.offsetWidth,
	        left = comp + "px";
	    for (var i = 0; i < view.length; i++) {
	      if (!view[i].hidden) {
	        if (cm.options.fixedGutter) {
	          if (view[i].gutter) {
	            view[i].gutter.style.left = left;
	          }
	          if (view[i].gutterBackground) {
	            view[i].gutterBackground.style.left = left;
	          }
	        }
	        var align = view[i].alignable;
	        if (align) {
	          for (var j = 0; j < align.length; j++) {
	            align[j].style.left = left;
	          }
	        }
	      }
	    }
	    if (cm.options.fixedGutter) {
	      display.gutters.style.left = comp + gutterW + "px";
	    }
	  }
	
	  // Used to ensure that the line number gutter is still the right
	  // size for the current document size. Returns true when an update
	  // is needed.
	  function maybeUpdateLineNumberWidth(cm) {
	    if (!cm.options.lineNumbers) {
	      return false;
	    }
	    var doc = cm.doc,
	        last = lineNumberFor(cm.options, doc.first + doc.size - 1),
	        display = cm.display;
	    if (last.length != display.lineNumChars) {
	      var test = display.measure.appendChild(elt("div", [elt("div", last)], "CodeMirror-linenumber CodeMirror-gutter-elt"));
	      var innerW = test.firstChild.offsetWidth,
	          padding = test.offsetWidth - innerW;
	      display.lineGutter.style.width = "";
	      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
	      display.lineNumWidth = display.lineNumInnerWidth + padding;
	      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
	      display.lineGutter.style.width = display.lineNumWidth + "px";
	      updateGutterSpace(cm);
	      return true;
	    }
	    return false;
	  }
	
	  // SCROLLING THINGS INTO VIEW
	
	  // If an editor sits on the top or bottom of the window, partially
	  // scrolled out of view, this ensures that the cursor is visible.
	  function maybeScrollWindow(cm, rect) {
	    if (signalDOMEvent(cm, "scrollCursorIntoView")) {
	      return;
	    }
	
	    var display = cm.display,
	        box = display.sizer.getBoundingClientRect(),
	        doScroll = null;
	    if (rect.top + box.top < 0) {
	      doScroll = true;
	    } else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) {
	      doScroll = false;
	    }
	    if (doScroll != null && !phantom) {
	      var scrollNode = elt("div", '\u200B', null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
	      cm.display.lineSpace.appendChild(scrollNode);
	      scrollNode.scrollIntoView(doScroll);
	      cm.display.lineSpace.removeChild(scrollNode);
	    }
	  }
	
	  // Scroll a given position into view (immediately), verifying that
	  // it actually became visible (as line heights are accurately
	  // measured, the position of something may 'drift' during drawing).
	  function scrollPosIntoView(cm, pos, end, margin) {
	    if (margin == null) {
	      margin = 0;
	    }
	    var rect;
	    if (!cm.options.lineWrapping && pos == end) {
	      // Set pos and end to the cursor positions around the character pos sticks to
	      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
	      // If pos == Pos(_, 0, "before"), pos and end are unchanged
	      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
	      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
	    }
	    for (var limit = 0; limit < 5; limit++) {
	      var changed = false;
	      var coords = _cursorCoords(cm, pos);
	      var endCoords = !end || end == pos ? coords : _cursorCoords(cm, end);
	      rect = { left: Math.min(coords.left, endCoords.left),
	        top: Math.min(coords.top, endCoords.top) - margin,
	        right: Math.max(coords.left, endCoords.left),
	        bottom: Math.max(coords.bottom, endCoords.bottom) + margin };
	      var scrollPos = calculateScrollPos(cm, rect);
	      var startTop = cm.doc.scrollTop,
	          startLeft = cm.doc.scrollLeft;
	      if (scrollPos.scrollTop != null) {
	        updateScrollTop(cm, scrollPos.scrollTop);
	        if (Math.abs(cm.doc.scrollTop - startTop) > 1) {
	          changed = true;
	        }
	      }
	      if (scrollPos.scrollLeft != null) {
	        setScrollLeft(cm, scrollPos.scrollLeft);
	        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) {
	          changed = true;
	        }
	      }
	      if (!changed) {
	        break;
	      }
	    }
	    return rect;
	  }
	
	  // Scroll a given set of coordinates into view (immediately).
	  function scrollIntoView(cm, rect) {
	    var scrollPos = calculateScrollPos(cm, rect);
	    if (scrollPos.scrollTop != null) {
	      updateScrollTop(cm, scrollPos.scrollTop);
	    }
	    if (scrollPos.scrollLeft != null) {
	      setScrollLeft(cm, scrollPos.scrollLeft);
	    }
	  }
	
	  // Calculate a new scroll position needed to scroll the given
	  // rectangle into view. Returns an object with scrollTop and
	  // scrollLeft properties. When these are undefined, the
	  // vertical/horizontal position does not need to be adjusted.
	  function calculateScrollPos(cm, rect) {
	    var display = cm.display,
	        snapMargin = textHeight(cm.display);
	    if (rect.top < 0) {
	      rect.top = 0;
	    }
	    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
	    var screen = displayHeight(cm),
	        result = {};
	    if (rect.bottom - rect.top > screen) {
	      rect.bottom = rect.top + screen;
	    }
	    var docBottom = cm.doc.height + paddingVert(display);
	    var atTop = rect.top < snapMargin,
	        atBottom = rect.bottom > docBottom - snapMargin;
	    if (rect.top < screentop) {
	      result.scrollTop = atTop ? 0 : rect.top;
	    } else if (rect.bottom > screentop + screen) {
	      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
	      if (newTop != screentop) {
	        result.scrollTop = newTop;
	      }
	    }
	
	    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
	    var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
	    var tooWide = rect.right - rect.left > screenw;
	    if (tooWide) {
	      rect.right = rect.left + screenw;
	    }
	    if (rect.left < 10) {
	      result.scrollLeft = 0;
	    } else if (rect.left < screenleft) {
	      result.scrollLeft = Math.max(0, rect.left - (tooWide ? 0 : 10));
	    } else if (rect.right > screenw + screenleft - 3) {
	      result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
	    }
	    return result;
	  }
	
	  // Store a relative adjustment to the scroll position in the current
	  // operation (to be applied when the operation finishes).
	  function addToScrollTop(cm, top) {
	    if (top == null) {
	      return;
	    }
	    resolveScrollToPos(cm);
	    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
	  }
	
	  // Make sure that at the end of the operation the current cursor is
	  // shown.
	  function ensureCursorVisible(cm) {
	    resolveScrollToPos(cm);
	    var cur = cm.getCursor();
	    cm.curOp.scrollToPos = { from: cur, to: cur, margin: cm.options.cursorScrollMargin };
	  }
	
	  function scrollToCoords(cm, x, y) {
	    if (x != null || y != null) {
	      resolveScrollToPos(cm);
	    }
	    if (x != null) {
	      cm.curOp.scrollLeft = x;
	    }
	    if (y != null) {
	      cm.curOp.scrollTop = y;
	    }
	  }
	
	  function scrollToRange(cm, range$$1) {
	    resolveScrollToPos(cm);
	    cm.curOp.scrollToPos = range$$1;
	  }
	
	  // When an operation has its scrollToPos property set, and another
	  // scroll action is applied before the end of the operation, this
	  // 'simulates' scrolling that position into view in a cheap way, so
	  // that the effect of intermediate scroll commands is not ignored.
	  function resolveScrollToPos(cm) {
	    var range$$1 = cm.curOp.scrollToPos;
	    if (range$$1) {
	      cm.curOp.scrollToPos = null;
	      var from = estimateCoords(cm, range$$1.from),
	          to = estimateCoords(cm, range$$1.to);
	      scrollToCoordsRange(cm, from, to, range$$1.margin);
	    }
	  }
	
	  function scrollToCoordsRange(cm, from, to, margin) {
	    var sPos = calculateScrollPos(cm, {
	      left: Math.min(from.left, to.left),
	      top: Math.min(from.top, to.top) - margin,
	      right: Math.max(from.right, to.right),
	      bottom: Math.max(from.bottom, to.bottom) + margin
	    });
	    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
	  }
	
	  // Sync the scrollable area and scrollbars, ensure the viewport
	  // covers the visible area.
	  function updateScrollTop(cm, val) {
	    if (Math.abs(cm.doc.scrollTop - val) < 2) {
	      return;
	    }
	    if (!gecko) {
	      updateDisplaySimple(cm, { top: val });
	    }
	    setScrollTop(cm, val, true);
	    if (gecko) {
	      updateDisplaySimple(cm);
	    }
	    startWorker(cm, 100);
	  }
	
	  function setScrollTop(cm, val, forceScroll) {
	    val = Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val);
	    if (cm.display.scroller.scrollTop == val && !forceScroll) {
	      return;
	    }
	    cm.doc.scrollTop = val;
	    cm.display.scrollbars.setScrollTop(val);
	    if (cm.display.scroller.scrollTop != val) {
	      cm.display.scroller.scrollTop = val;
	    }
	  }
	
	  // Sync scroller and scrollbar, ensure the gutter elements are
	  // aligned.
	  function setScrollLeft(cm, val, isScroller, forceScroll) {
	    val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth);
	    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) {
	      return;
	    }
	    cm.doc.scrollLeft = val;
	    alignHorizontally(cm);
	    if (cm.display.scroller.scrollLeft != val) {
	      cm.display.scroller.scrollLeft = val;
	    }
	    cm.display.scrollbars.setScrollLeft(val);
	  }
	
	  // SCROLLBARS
	
	  // Prepare DOM reads needed to update the scrollbars. Done in one
	  // shot to minimize update/measure roundtrips.
	  function measureForScrollbars(cm) {
	    var d = cm.display,
	        gutterW = d.gutters.offsetWidth;
	    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
	    return {
	      clientHeight: d.scroller.clientHeight,
	      viewHeight: d.wrapper.clientHeight,
	      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	      viewWidth: d.wrapper.clientWidth,
	      barLeft: cm.options.fixedGutter ? gutterW : 0,
	      docHeight: docH,
	      scrollHeight: docH + scrollGap(cm) + d.barHeight,
	      nativeBarWidth: d.nativeBarWidth,
	      gutterWidth: gutterW
	    };
	  }
	
	  var NativeScrollbars = function NativeScrollbars(place, scroll, cm) {
	    this.cm = cm;
	    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
	    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
	    place(vert);place(horiz);
	
	    on(vert, "scroll", function () {
	      if (vert.clientHeight) {
	        scroll(vert.scrollTop, "vertical");
	      }
	    });
	    on(horiz, "scroll", function () {
	      if (horiz.clientWidth) {
	        scroll(horiz.scrollLeft, "horizontal");
	      }
	    });
	
	    this.checkedZeroWidth = false;
	    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	    if (ie && ie_version < 8) {
	      this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
	    }
	  };
	
	  NativeScrollbars.prototype.update = function (measure) {
	    var needsH = measure.scrollWidth > measure.clientWidth + 1;
	    var needsV = measure.scrollHeight > measure.clientHeight + 1;
	    var sWidth = measure.nativeBarWidth;
	
	    if (needsV) {
	      this.vert.style.display = "block";
	      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
	      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
	      // A bug in IE8 can cause this value to be negative, so guard it.
	      this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
	    } else {
	      this.vert.style.display = "";
	      this.vert.firstChild.style.height = "0";
	    }
	
	    if (needsH) {
	      this.horiz.style.display = "block";
	      this.horiz.style.right = needsV ? sWidth + "px" : "0";
	      this.horiz.style.left = measure.barLeft + "px";
	      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
	      this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
	    } else {
	      this.horiz.style.display = "";
	      this.horiz.firstChild.style.width = "0";
	    }
	
	    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	      if (sWidth == 0) {
	        this.zeroWidthHack();
	      }
	      this.checkedZeroWidth = true;
	    }
	
	    return { right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0 };
	  };
	
	  NativeScrollbars.prototype.setScrollLeft = function (pos) {
	    if (this.horiz.scrollLeft != pos) {
	      this.horiz.scrollLeft = pos;
	    }
	    if (this.disableHoriz) {
	      this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
	    }
	  };
	
	  NativeScrollbars.prototype.setScrollTop = function (pos) {
	    if (this.vert.scrollTop != pos) {
	      this.vert.scrollTop = pos;
	    }
	    if (this.disableVert) {
	      this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
	    }
	  };
	
	  NativeScrollbars.prototype.zeroWidthHack = function () {
	    var w = mac && !mac_geMountainLion ? "12px" : "18px";
	    this.horiz.style.height = this.vert.style.width = w;
	    this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
	    this.disableHoriz = new Delayed();
	    this.disableVert = new Delayed();
	  };
	
	  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
	    bar.style.pointerEvents = "auto";
	    function maybeDisable() {
	      // To find out whether the scrollbar is still visible, we
	      // check whether the element under the pixel in the bottom
	      // right corner of the scrollbar box is the scrollbar box
	      // itself (when the bar is still visible) or its filler child
	      // (when the bar is hidden). If it is still visible, we keep
	      // it enabled, if it's hidden, we disable pointer events.
	      var box = bar.getBoundingClientRect();
	      var elt$$1 = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
	      if (elt$$1 != bar) {
	        bar.style.pointerEvents = "none";
	      } else {
	        delay.set(1000, maybeDisable);
	      }
	    }
	    delay.set(1000, maybeDisable);
	  };
	
	  NativeScrollbars.prototype.clear = function () {
	    var parent = this.horiz.parentNode;
	    parent.removeChild(this.horiz);
	    parent.removeChild(this.vert);
	  };
	
	  var NullScrollbars = function NullScrollbars() {};
	
	  NullScrollbars.prototype.update = function () {
	    return { bottom: 0, right: 0 };
	  };
	  NullScrollbars.prototype.setScrollLeft = function () {};
	  NullScrollbars.prototype.setScrollTop = function () {};
	  NullScrollbars.prototype.clear = function () {};
	
	  function updateScrollbars(cm, measure) {
	    if (!measure) {
	      measure = measureForScrollbars(cm);
	    }
	    var startWidth = cm.display.barWidth,
	        startHeight = cm.display.barHeight;
	    updateScrollbarsInner(cm, measure);
	    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	      if (startWidth != cm.display.barWidth && cm.options.lineWrapping) {
	        updateHeightsInViewport(cm);
	      }
	      updateScrollbarsInner(cm, measureForScrollbars(cm));
	      startWidth = cm.display.barWidth;startHeight = cm.display.barHeight;
	    }
	  }
	
	  // Re-synchronize the fake scrollbars with the actual size of the
	  // content.
	  function updateScrollbarsInner(cm, measure) {
	    var d = cm.display;
	    var sizes = d.scrollbars.update(measure);
	
	    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
	    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
	    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
	
	    if (sizes.right && sizes.bottom) {
	      d.scrollbarFiller.style.display = "block";
	      d.scrollbarFiller.style.height = sizes.bottom + "px";
	      d.scrollbarFiller.style.width = sizes.right + "px";
	    } else {
	      d.scrollbarFiller.style.display = "";
	    }
	    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	      d.gutterFiller.style.display = "block";
	      d.gutterFiller.style.height = sizes.bottom + "px";
	      d.gutterFiller.style.width = measure.gutterWidth + "px";
	    } else {
	      d.gutterFiller.style.display = "";
	    }
	  }
	
	  var scrollbarModel = { "native": NativeScrollbars, "null": NullScrollbars };
	
	  function initScrollbars(cm) {
	    if (cm.display.scrollbars) {
	      cm.display.scrollbars.clear();
	      if (cm.display.scrollbars.addClass) {
	        rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
	      }
	    }
	
	    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
	      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
	      // Prevent clicks in the scrollbars from killing focus
	      on(node, "mousedown", function () {
	        if (cm.state.focused) {
	          setTimeout(function () {
	            return cm.display.input.focus();
	          }, 0);
	        }
	      });
	      node.setAttribute("cm-not-content", "true");
	    }, function (pos, axis) {
	      if (axis == "horizontal") {
	        setScrollLeft(cm, pos);
	      } else {
	        updateScrollTop(cm, pos);
	      }
	    }, cm);
	    if (cm.display.scrollbars.addClass) {
	      addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
	    }
	  }
	
	  // Operations are used to wrap a series of changes to the editor
	  // state in such a way that each change won't have to update the
	  // cursor and display (which would be awkward, slow, and
	  // error-prone). Instead, display updates are batched and then all
	  // combined and executed at once.
	
	  var nextOpId = 0;
	  // Start a new operation.
	  function _startOperation(cm) {
	    cm.curOp = {
	      cm: cm,
	      viewChanged: false, // Flag that indicates that lines might need to be redrawn
	      startHeight: cm.doc.height, // Used to detect need to update scrollbar
	      forceUpdate: false, // Used to force a redraw
	      updateInput: null, // Whether to reset the input textarea
	      typing: false, // Whether this reset should be careful to leave existing text (for compositing)
	      changeObjs: null, // Accumulated changes, for firing change events
	      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	      selectionChanged: false, // Whether the selection needs to be redrawn
	      updateMaxLine: false, // Set when the widest line needs to be determined anew
	      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	      scrollToPos: null, // Used to scroll to a specific position
	      focus: false,
	      id: ++nextOpId // Unique ID
	    };
	    pushOperation(cm.curOp);
	  }
	
	  // Finish an operation, updating the display and signalling delayed events
	  function _endOperation(cm) {
	    var op = cm.curOp;
	    finishOperation(op, function (group) {
	      for (var i = 0; i < group.ops.length; i++) {
	        group.ops[i].cm.curOp = null;
	      }
	      endOperations(group);
	    });
	  }
	
	  // The DOM updates done when an operation finishes are batched so
	  // that the minimum number of relayouts are required.
	  function endOperations(group) {
	    var ops = group.ops;
	    for (var i = 0; i < ops.length; i++) // Read DOM
	    {
	      endOperation_R1(ops[i]);
	    }
	    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
	    {
	      endOperation_W1(ops[i$1]);
	    }
	    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
	    {
	      endOperation_R2(ops[i$2]);
	    }
	    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
	    {
	      endOperation_W2(ops[i$3]);
	    }
	    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
	    {
	      endOperation_finish(ops[i$4]);
	    }
	  }
	
	  function endOperation_R1(op) {
	    var cm = op.cm,
	        display = cm.display;
	    maybeClipScrollbars(cm);
	    if (op.updateMaxLine) {
	      findMaxLine(cm);
	    }
	
	    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
	    op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && { top: op.scrollTop, ensure: op.scrollToPos }, op.forceUpdate);
	  }
	
	  function endOperation_W1(op) {
	    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
	  }
	
	  function endOperation_R2(op) {
	    var cm = op.cm,
	        display = cm.display;
	    if (op.updatedDisplay) {
	      updateHeightsInViewport(cm);
	    }
	
	    op.barMeasure = measureForScrollbars(cm);
	
	    // If the max line changed since it was last measured, measure it,
	    // and ensure the document's width matches it.
	    // updateDisplay_W2 will use these properties to do the actual resizing
	    if (display.maxLineChanged && !cm.options.lineWrapping) {
	      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
	      cm.display.sizerWidth = op.adjustWidthTo;
	      op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
	      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
	    }
	
	    if (op.updatedDisplay || op.selectionChanged) {
	      op.preparedSelection = display.input.prepareSelection();
	    }
	  }
	
	  function endOperation_W2(op) {
	    var cm = op.cm;
	
	    if (op.adjustWidthTo != null) {
	      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
	      if (op.maxScrollLeft < cm.doc.scrollLeft) {
	        setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
	      }
	      cm.display.maxLineChanged = false;
	    }
	
	    var takeFocus = op.focus && op.focus == activeElt();
	    if (op.preparedSelection) {
	      cm.display.input.showSelection(op.preparedSelection, takeFocus);
	    }
	    if (op.updatedDisplay || op.startHeight != cm.doc.height) {
	      updateScrollbars(cm, op.barMeasure);
	    }
	    if (op.updatedDisplay) {
	      setDocumentHeight(cm, op.barMeasure);
	    }
	
	    if (op.selectionChanged) {
	      restartBlink(cm);
	    }
	
	    if (cm.state.focused && op.updateInput) {
	      cm.display.input.reset(op.typing);
	    }
	    if (takeFocus) {
	      ensureFocus(op.cm);
	    }
	  }
	
	  function endOperation_finish(op) {
	    var cm = op.cm,
	        display = cm.display,
	        doc = cm.doc;
	
	    if (op.updatedDisplay) {
	      postUpdateDisplay(cm, op.update);
	    }
	
	    // Abort mouse wheel delta measurement, when scrolling explicitly
	    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) {
	      display.wheelStartX = display.wheelStartY = null;
	    }
	
	    // Propagate the scroll position to the actual DOM scroller
	    if (op.scrollTop != null) {
	      setScrollTop(cm, op.scrollTop, op.forceScroll);
	    }
	
	    if (op.scrollLeft != null) {
	      setScrollLeft(cm, op.scrollLeft, true, true);
	    }
	    // If we need to scroll a specific position into view, do so.
	    if (op.scrollToPos) {
	      var rect = scrollPosIntoView(cm, _clipPos(doc, op.scrollToPos.from), _clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
	      maybeScrollWindow(cm, rect);
	    }
	
	    // Fire events for markers that are hidden/unidden by editing or
	    // undoing
	    var hidden = op.maybeHiddenMarkers,
	        unhidden = op.maybeUnhiddenMarkers;
	    if (hidden) {
	      for (var i = 0; i < hidden.length; ++i) {
	        if (!hidden[i].lines.length) {
	          signal(hidden[i], "hide");
	        }
	      }
	    }
	    if (unhidden) {
	      for (var i$1 = 0; i$1 < unhidden.length; ++i$1) {
	        if (unhidden[i$1].lines.length) {
	          signal(unhidden[i$1], "unhide");
	        }
	      }
	    }
	
	    if (display.wrapper.offsetHeight) {
	      doc.scrollTop = cm.display.scroller.scrollTop;
	    }
	
	    // Fire change events, and delayed event handlers
	    if (op.changeObjs) {
	      signal(cm, "changes", cm, op.changeObjs);
	    }
	    if (op.update) {
	      op.update.finish();
	    }
	  }
	
	  // Run the given function in an operation
	  function runInOp(cm, f) {
	    if (cm.curOp) {
	      return f();
	    }
	    _startOperation(cm);
	    try {
	      return f();
	    } finally {
	      _endOperation(cm);
	    }
	  }
	  // Wraps a function in an operation. Returns the wrapped function.
	  function operation(cm, f) {
	    return function () {
	      if (cm.curOp) {
	        return f.apply(cm, arguments);
	      }
	      _startOperation(cm);
	      try {
	        return f.apply(cm, arguments);
	      } finally {
	        _endOperation(cm);
	      }
	    };
	  }
	  // Used to add methods to editor and doc instances, wrapping them in
	  // operations.
	  function methodOp(f) {
	    return function () {
	      if (this.curOp) {
	        return f.apply(this, arguments);
	      }
	      _startOperation(this);
	      try {
	        return f.apply(this, arguments);
	      } finally {
	        _endOperation(this);
	      }
	    };
	  }
	  function docMethodOp(f) {
	    return function () {
	      var cm = this.cm;
	      if (!cm || cm.curOp) {
	        return f.apply(this, arguments);
	      }
	      _startOperation(cm);
	      try {
	        return f.apply(this, arguments);
	      } finally {
	        _endOperation(cm);
	      }
	    };
	  }
	
	  // Updates the display.view data structure for a given change to the
	  // document. From and to are in pre-change coordinates. Lendiff is
	  // the amount of lines added or subtracted by the change. This is
	  // used for changes that span multiple lines, or change the way
	  // lines are divided into visual lines. regLineChange (below)
	  // registers single-line changes.
	  function regChange(cm, from, to, lendiff) {
	    if (from == null) {
	      from = cm.doc.first;
	    }
	    if (to == null) {
	      to = cm.doc.first + cm.doc.size;
	    }
	    if (!lendiff) {
	      lendiff = 0;
	    }
	
	    var display = cm.display;
	    if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) {
	      display.updateLineNumbers = from;
	    }
	
	    cm.curOp.viewChanged = true;
	
	    if (from >= display.viewTo) {
	      // Change after
	      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) {
	        resetView(cm);
	      }
	    } else if (to <= display.viewFrom) {
	      // Change before
	      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	        resetView(cm);
	      } else {
	        display.viewFrom += lendiff;
	        display.viewTo += lendiff;
	      }
	    } else if (from <= display.viewFrom && to >= display.viewTo) {
	      // Full overlap
	      resetView(cm);
	    } else if (from <= display.viewFrom) {
	      // Top overlap
	      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cut) {
	        display.view = display.view.slice(cut.index);
	        display.viewFrom = cut.lineN;
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    } else if (to >= display.viewTo) {
	      // Bottom overlap
	      var cut$1 = viewCuttingPoint(cm, from, from, -1);
	      if (cut$1) {
	        display.view = display.view.slice(0, cut$1.index);
	        display.viewTo = cut$1.lineN;
	      } else {
	        resetView(cm);
	      }
	    } else {
	      // Gap in the middle
	      var cutTop = viewCuttingPoint(cm, from, from, -1);
	      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cutTop && cutBot) {
	        display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    }
	
	    var ext = display.externalMeasured;
	    if (ext) {
	      if (to < ext.lineN) {
	        ext.lineN += lendiff;
	      } else if (from < ext.lineN + ext.size) {
	        display.externalMeasured = null;
	      }
	    }
	  }
	
	  // Register a change to a single line. Type must be one of "text",
	  // "gutter", "class", "widget"
	  function regLineChange(cm, line, type) {
	    cm.curOp.viewChanged = true;
	    var display = cm.display,
	        ext = cm.display.externalMeasured;
	    if (ext && line >= ext.lineN && line < ext.lineN + ext.size) {
	      display.externalMeasured = null;
	    }
	
	    if (line < display.viewFrom || line >= display.viewTo) {
	      return;
	    }
	    var lineView = display.view[findViewIndex(cm, line)];
	    if (lineView.node == null) {
	      return;
	    }
	    var arr = lineView.changes || (lineView.changes = []);
	    if (indexOf(arr, type) == -1) {
	      arr.push(type);
	    }
	  }
	
	  // Clear the view.
	  function resetView(cm) {
	    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
	    cm.display.view = [];
	    cm.display.viewOffset = 0;
	  }
	
	  function viewCuttingPoint(cm, oldN, newN, dir) {
	    var index = findViewIndex(cm, oldN),
	        diff,
	        view = cm.display.view;
	    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) {
	      return { index: index, lineN: newN };
	    }
	    var n = cm.display.viewFrom;
	    for (var i = 0; i < index; i++) {
	      n += view[i].size;
	    }
	    if (n != oldN) {
	      if (dir > 0) {
	        if (index == view.length - 1) {
	          return null;
	        }
	        diff = n + view[index].size - oldN;
	        index++;
	      } else {
	        diff = n - oldN;
	      }
	      oldN += diff;newN += diff;
	    }
	    while (visualLineNo(cm.doc, newN) != newN) {
	      if (index == (dir < 0 ? 0 : view.length - 1)) {
	        return null;
	      }
	      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
	      index += dir;
	    }
	    return { index: index, lineN: newN };
	  }
	
	  // Force the view to cover a given range, adding empty view element
	  // or clipping off existing ones as needed.
	  function adjustView(cm, from, to) {
	    var display = cm.display,
	        view = display.view;
	    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	      display.view = buildViewArray(cm, from, to);
	      display.viewFrom = from;
	    } else {
	      if (display.viewFrom > from) {
	        display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
	      } else if (display.viewFrom < from) {
	        display.view = display.view.slice(findViewIndex(cm, from));
	      }
	      display.viewFrom = from;
	      if (display.viewTo < to) {
	        display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
	      } else if (display.viewTo > to) {
	        display.view = display.view.slice(0, findViewIndex(cm, to));
	      }
	    }
	    display.viewTo = to;
	  }
	
	  // Count the number of lines in the view whose DOM representation is
	  // out of date (or nonexistent).
	  function countDirtyView(cm) {
	    var view = cm.display.view,
	        dirty = 0;
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (!lineView.hidden && (!lineView.node || lineView.changes)) {
	        ++dirty;
	      }
	    }
	    return dirty;
	  }
	
	  // HIGHLIGHT WORKER
	
	  function startWorker(cm, time) {
	    if (cm.doc.highlightFrontier < cm.display.viewTo) {
	      cm.state.highlight.set(time, bind(highlightWorker, cm));
	    }
	  }
	
	  function highlightWorker(cm) {
	    var doc = cm.doc;
	    if (doc.highlightFrontier >= cm.display.viewTo) {
	      return;
	    }
	    var end = +new Date() + cm.options.workTime;
	    var context = getContextBefore(cm, doc.highlightFrontier);
	    var changedLines = [];
	
	    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
	      if (context.line >= cm.display.viewFrom) {
	        // Visible
	        var oldStyles = line.styles;
	        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
	        var highlighted = highlightLine(cm, line, context, true);
	        if (resetState) {
	          context.state = resetState;
	        }
	        line.styles = highlighted.styles;
	        var oldCls = line.styleClasses,
	            newCls = highlighted.classes;
	        if (newCls) {
	          line.styleClasses = newCls;
	        } else if (oldCls) {
	          line.styleClasses = null;
	        }
	        var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
	        for (var i = 0; !ischange && i < oldStyles.length; ++i) {
	          ischange = oldStyles[i] != line.styles[i];
	        }
	        if (ischange) {
	          changedLines.push(context.line);
	        }
	        line.stateAfter = context.save();
	        context.nextLine();
	      } else {
	        if (line.text.length <= cm.options.maxHighlightLength) {
	          processLine(cm, line.text, context);
	        }
	        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
	        context.nextLine();
	      }
	      if (+new Date() > end) {
	        startWorker(cm, cm.options.workDelay);
	        return true;
	      }
	    });
	    doc.highlightFrontier = context.line;
	    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
	    if (changedLines.length) {
	      runInOp(cm, function () {
	        for (var i = 0; i < changedLines.length; i++) {
	          regLineChange(cm, changedLines[i], "text");
	        }
	      });
	    }
	  }
	
	  // DISPLAY DRAWING
	
	  var DisplayUpdate = function DisplayUpdate(cm, viewport, force) {
	    var display = cm.display;
	
	    this.viewport = viewport;
	    // Store some values that we'll need later (but don't want to force a relayout for)
	    this.visible = visibleLines(display, cm.doc, viewport);
	    this.editorIsHidden = !display.wrapper.offsetWidth;
	    this.wrapperHeight = display.wrapper.clientHeight;
	    this.wrapperWidth = display.wrapper.clientWidth;
	    this.oldDisplayWidth = displayWidth(cm);
	    this.force = force;
	    this.dims = getDimensions(cm);
	    this.events = [];
	  };
	
	  DisplayUpdate.prototype.signal = function (emitter, type) {
	    if (hasHandler(emitter, type)) {
	      this.events.push(arguments);
	    }
	  };
	  DisplayUpdate.prototype.finish = function () {
	    var this$1 = this;
	
	    for (var i = 0; i < this.events.length; i++) {
	      signal.apply(null, this$1.events[i]);
	    }
	  };
	
	  function maybeClipScrollbars(cm) {
	    var display = cm.display;
	    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
	      display.heightForcer.style.height = scrollGap(cm) + "px";
	      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
	      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
	      display.scrollbarsClipped = true;
	    }
	  }
	
	  function selectionSnapshot(cm) {
	    if (cm.hasFocus()) {
	      return null;
	    }
	    var active = activeElt();
	    if (!active || !contains(cm.display.lineDiv, active)) {
	      return null;
	    }
	    var result = { activeElt: active };
	    if (window.getSelection) {
	      var sel = window.getSelection();
	      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
	        result.anchorNode = sel.anchorNode;
	        result.anchorOffset = sel.anchorOffset;
	        result.focusNode = sel.focusNode;
	        result.focusOffset = sel.focusOffset;
	      }
	    }
	    return result;
	  }
	
	  function restoreSelection(snapshot) {
	    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) {
	      return;
	    }
	    snapshot.activeElt.focus();
	    if (snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
	      var sel = window.getSelection(),
	          range$$1 = document.createRange();
	      range$$1.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
	      range$$1.collapse(false);
	      sel.removeAllRanges();
	      sel.addRange(range$$1);
	      sel.extend(snapshot.focusNode, snapshot.focusOffset);
	    }
	  }
	
	  // Does the actual updating of the line display. Bails out
	  // (returning false) when there is nothing to be done and forced is
	  // false.
	  function updateDisplayIfNeeded(cm, update) {
	    var display = cm.display,
	        doc = cm.doc;
	
	    if (update.editorIsHidden) {
	      resetView(cm);
	      return false;
	    }
	
	    // Bail out if the visible area is already rendered and nothing changed.
	    if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) {
	      return false;
	    }
	
	    if (maybeUpdateLineNumberWidth(cm)) {
	      resetView(cm);
	      update.dims = getDimensions(cm);
	    }
	
	    // Compute a suitable new viewport (from & to)
	    var end = doc.first + doc.size;
	    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
	    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
	    if (display.viewFrom < from && from - display.viewFrom < 20) {
	      from = Math.max(doc.first, display.viewFrom);
	    }
	    if (display.viewTo > to && display.viewTo - to < 20) {
	      to = Math.min(end, display.viewTo);
	    }
	    if (sawCollapsedSpans) {
	      from = visualLineNo(cm.doc, from);
	      to = visualLineEndNo(cm.doc, to);
	    }
	
	    var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
	    adjustView(cm, from, to);
	
	    display.viewOffset = _heightAtLine(getLine(cm.doc, display.viewFrom));
	    // Position the mover div to align with the current scroll position
	    cm.display.mover.style.top = display.viewOffset + "px";
	
	    var toUpdate = countDirtyView(cm);
	    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) {
	      return false;
	    }
	
	    // For big changes, we hide the enclosing element during the
	    // update, since that speeds up the operations on most browsers.
	    var selSnapshot = selectionSnapshot(cm);
	    if (toUpdate > 4) {
	      display.lineDiv.style.display = "none";
	    }
	    patchDisplay(cm, display.updateLineNumbers, update.dims);
	    if (toUpdate > 4) {
	      display.lineDiv.style.display = "";
	    }
	    display.renderedView = display.view;
	    // There might have been a widget with a focused element that got
	    // hidden or updated, if so re-focus it.
	    restoreSelection(selSnapshot);
	
	    // Prevent selection and cursors from interfering with the scroll
	    // width and height.
	    removeChildren(display.cursorDiv);
	    removeChildren(display.selectionDiv);
	    display.gutters.style.height = display.sizer.style.minHeight = 0;
	
	    if (different) {
	      display.lastWrapHeight = update.wrapperHeight;
	      display.lastWrapWidth = update.wrapperWidth;
	      startWorker(cm, 400);
	    }
	
	    display.updateLineNumbers = null;
	
	    return true;
	  }
	
	  function postUpdateDisplay(cm, update) {
	    var viewport = update.viewport;
	
	    for (var first = true;; first = false) {
	      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	        // Clip forced viewport to actual scrollable area.
	        if (viewport && viewport.top != null) {
	          viewport = { top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top) };
	        }
	        // Updated line heights might result in the drawn area not
	        // actually covering the viewport. Keep looping until it does.
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) {
	          break;
	        }
	      }
	      if (!updateDisplayIfNeeded(cm, update)) {
	        break;
	      }
	      updateHeightsInViewport(cm);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.force = false;
	    }
	
	    update.signal(cm, "update", cm);
	    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
	      cm.display.reportedViewFrom = cm.display.viewFrom;cm.display.reportedViewTo = cm.display.viewTo;
	    }
	  }
	
	  function updateDisplaySimple(cm, viewport) {
	    var update = new DisplayUpdate(cm, viewport);
	    if (updateDisplayIfNeeded(cm, update)) {
	      updateHeightsInViewport(cm);
	      postUpdateDisplay(cm, update);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.finish();
	    }
	  }
	
	  // Sync the actual display DOM structure with display.view, removing
	  // nodes for lines that are no longer in view, and creating the ones
	  // that are not there yet, and updating the ones that are out of
	  // date.
	  function patchDisplay(cm, updateNumbersFrom, dims) {
	    var display = cm.display,
	        lineNumbers = cm.options.lineNumbers;
	    var container = display.lineDiv,
	        cur = container.firstChild;
	
	    function rm(node) {
	      var next = node.nextSibling;
	      // Works around a throw-scroll bug in OS X Webkit
	      if (webkit && mac && cm.display.currentWheelTarget == node) {
	        node.style.display = "none";
	      } else {
	        node.parentNode.removeChild(node);
	      }
	      return next;
	    }
	
	    var view = display.view,
	        lineN = display.viewFrom;
	    // Loop over the elements in the view, syncing cur (the DOM nodes
	    // in display.lineDiv) with the view as we go.
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (lineView.hidden) {} else if (!lineView.node || lineView.node.parentNode != container) {
	        // Not drawn yet
	        var node = buildLineElement(cm, lineView, lineN, dims);
	        container.insertBefore(node, cur);
	      } else {
	        // Already drawn
	        while (cur != lineView.node) {
	          cur = rm(cur);
	        }
	        var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
	        if (lineView.changes) {
	          if (indexOf(lineView.changes, "gutter") > -1) {
	            updateNumber = false;
	          }
	          updateLineForChanges(cm, lineView, lineN, dims);
	        }
	        if (updateNumber) {
	          removeChildren(lineView.lineNumber);
	          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
	        }
	        cur = lineView.node.nextSibling;
	      }
	      lineN += lineView.size;
	    }
	    while (cur) {
	      cur = rm(cur);
	    }
	  }
	
	  function updateGutterSpace(cm) {
	    var width = cm.display.gutters.offsetWidth;
	    cm.display.sizer.style.marginLeft = width + "px";
	  }
	
	  function setDocumentHeight(cm, measure) {
	    cm.display.sizer.style.minHeight = measure.docHeight + "px";
	    cm.display.heightForcer.style.top = measure.docHeight + "px";
	    cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
	  }
	
	  // Rebuild the gutter elements, ensure the margin to the left of the
	  // code matches their width.
	  function updateGutters(cm) {
	    var gutters = cm.display.gutters,
	        specs = cm.options.gutters;
	    removeChildren(gutters);
	    var i = 0;
	    for (; i < specs.length; ++i) {
	      var gutterClass = specs[i];
	      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + gutterClass));
	      if (gutterClass == "CodeMirror-linenumbers") {
	        cm.display.lineGutter = gElt;
	        gElt.style.width = (cm.display.lineNumWidth || 1) + "px";
	      }
	    }
	    gutters.style.display = i ? "" : "none";
	    updateGutterSpace(cm);
	  }
	
	  // Make sure the gutters options contains the element
	  // "CodeMirror-linenumbers" when the lineNumbers option is true.
	  function setGuttersForLineNumbers(options) {
	    var found = indexOf(options.gutters, "CodeMirror-linenumbers");
	    if (found == -1 && options.lineNumbers) {
	      options.gutters = options.gutters.concat(["CodeMirror-linenumbers"]);
	    } else if (found > -1 && !options.lineNumbers) {
	      options.gutters = options.gutters.slice(0);
	      options.gutters.splice(found, 1);
	    }
	  }
	
	  // Since the delta values reported on mouse wheel events are
	  // unstandardized between browsers and even browser versions, and
	  // generally horribly unpredictable, this code starts by measuring
	  // the scroll effect that the first few mouse wheel events have,
	  // and, from that, detects the way it can convert deltas to pixel
	  // offsets afterwards.
	  //
	  // The reason we want to know the amount a wheel event will scroll
	  // is that it gives us a chance to update the display before the
	  // actual scrolling happens, reducing flickering.
	
	  var wheelSamples = 0;
	  var wheelPixelsPerUnit = null;
	  // Fill in a browser-detected starting value on browsers where we
	  // know one. These don't have to be accurate -- the result of them
	  // being wrong would just be a slight flicker on the first wheel
	  // scroll (if it is large enough).
	  if (ie) {
	    wheelPixelsPerUnit = -.53;
	  } else if (gecko) {
	    wheelPixelsPerUnit = 15;
	  } else if (chrome) {
	    wheelPixelsPerUnit = -.7;
	  } else if (safari) {
	    wheelPixelsPerUnit = -1 / 3;
	  }
	
	  function wheelEventDelta(e) {
	    var dx = e.wheelDeltaX,
	        dy = e.wheelDeltaY;
	    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) {
	      dx = e.detail;
	    }
	    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) {
	      dy = e.detail;
	    } else if (dy == null) {
	      dy = e.wheelDelta;
	    }
	    return { x: dx, y: dy };
	  }
	  function wheelEventPixels(e) {
	    var delta = wheelEventDelta(e);
	    delta.x *= wheelPixelsPerUnit;
	    delta.y *= wheelPixelsPerUnit;
	    return delta;
	  }
	
	  function onScrollWheel(cm, e) {
	    var delta = wheelEventDelta(e),
	        dx = delta.x,
	        dy = delta.y;
	
	    var display = cm.display,
	        scroll = display.scroller;
	    // Quit if there's nothing to scroll here
	    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
	    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
	    if (!(dx && canScrollX || dy && canScrollY)) {
	      return;
	    }
	
	    // Webkit browsers on OS X abort momentum scrolls when the target
	    // of the scroll event is removed from the scrollable element.
	    // This hack (see related code in patchDisplay) makes sure the
	    // element is kept around.
	    if (dy && mac && webkit) {
	      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	        for (var i = 0; i < view.length; i++) {
	          if (view[i].node == cur) {
	            cm.display.currentWheelTarget = cur;
	            break outer;
	          }
	        }
	      }
	    }
	
	    // On some browsers, horizontal scrolling will cause redraws to
	    // happen before the gutter has been realigned, causing it to
	    // wriggle around in a most unseemly way. When we have an
	    // estimated pixels/delta value, we just handle horizontal
	    // scrolling entirely here. It'll be slightly off from native, but
	    // better than glitching out.
	    if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
	      if (dy && canScrollY) {
	        updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit));
	      }
	      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
	      // Only prevent default scrolling if vertical scrolling is
	      // actually possible. Otherwise, it causes vertical scroll
	      // jitter on OSX trackpads when deltaX is small and deltaY
	      // is large (issue #3579)
	      if (!dy || dy && canScrollY) {
	        e_preventDefault(e);
	      }
	      display.wheelStartX = null; // Abort measurement, if in progress
	      return;
	    }
	
	    // 'Project' the visible viewport to cover the area that is being
	    // scrolled into view (if we know enough to estimate it).
	    if (dy && wheelPixelsPerUnit != null) {
	      var pixels = dy * wheelPixelsPerUnit;
	      var top = cm.doc.scrollTop,
	          bot = top + display.wrapper.clientHeight;
	      if (pixels < 0) {
	        top = Math.max(0, top + pixels - 50);
	      } else {
	        bot = Math.min(cm.doc.height, bot + pixels + 50);
	      }
	      updateDisplaySimple(cm, { top: top, bottom: bot });
	    }
	
	    if (wheelSamples < 20) {
	      if (display.wheelStartX == null) {
	        display.wheelStartX = scroll.scrollLeft;display.wheelStartY = scroll.scrollTop;
	        display.wheelDX = dx;display.wheelDY = dy;
	        setTimeout(function () {
	          if (display.wheelStartX == null) {
	            return;
	          }
	          var movedX = scroll.scrollLeft - display.wheelStartX;
	          var movedY = scroll.scrollTop - display.wheelStartY;
	          var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
	          display.wheelStartX = display.wheelStartY = null;
	          if (!sample) {
	            return;
	          }
	          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
	          ++wheelSamples;
	        }, 200);
	      } else {
	        display.wheelDX += dx;display.wheelDY += dy;
	      }
	    }
	  }
	
	  // Selection objects are immutable. A new one is created every time
	  // the selection changes. A selection is one or more non-overlapping
	  // (and non-touching) ranges, sorted, and an integer that indicates
	  // which one is the primary selection (the one that's scrolled into
	  // view, that getCursor returns, etc).
	  var Selection = function Selection(ranges, primIndex) {
	    this.ranges = ranges;
	    this.primIndex = primIndex;
	  };
	
	  Selection.prototype.primary = function () {
	    return this.ranges[this.primIndex];
	  };
	
	  Selection.prototype.equals = function (other) {
	    var this$1 = this;
	
	    if (other == this) {
	      return true;
	    }
	    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) {
	      return false;
	    }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var here = this$1.ranges[i],
	          there = other.ranges[i];
	      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  Selection.prototype.deepCopy = function () {
	    var this$1 = this;
	
	    var out = [];
	    for (var i = 0; i < this.ranges.length; i++) {
	      out[i] = new Range(copyPos(this$1.ranges[i].anchor), copyPos(this$1.ranges[i].head));
	    }
	    return new Selection(out, this.primIndex);
	  };
	
	  Selection.prototype.somethingSelected = function () {
	    var this$1 = this;
	
	    for (var i = 0; i < this.ranges.length; i++) {
	      if (!this$1.ranges[i].empty()) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  Selection.prototype.contains = function (pos, end) {
	    var this$1 = this;
	
	    if (!end) {
	      end = pos;
	    }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var range = this$1.ranges[i];
	      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  var Range = function Range(anchor, head) {
	    this.anchor = anchor;this.head = head;
	  };
	
	  Range.prototype.from = function () {
	    return minPos(this.anchor, this.head);
	  };
	  Range.prototype.to = function () {
	    return maxPos(this.anchor, this.head);
	  };
	  Range.prototype.empty = function () {
	    return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
	  };
	
	  // Take an unsorted, potentially overlapping set of ranges, and
	  // build a selection out of it. 'Consumes' ranges array (modifying
	  // it).
	  function normalizeSelection(ranges, primIndex) {
	    var prim = ranges[primIndex];
	    ranges.sort(function (a, b) {
	      return cmp(a.from(), b.from());
	    });
	    primIndex = indexOf(ranges, prim);
	    for (var i = 1; i < ranges.length; i++) {
	      var cur = ranges[i],
	          prev = ranges[i - 1];
	      if (cmp(prev.to(), cur.from()) >= 0) {
	        var from = minPos(prev.from(), cur.from()),
	            to = maxPos(prev.to(), cur.to());
	        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
	        if (i <= primIndex) {
	          --primIndex;
	        }
	        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
	      }
	    }
	    return new Selection(ranges, primIndex);
	  }
	
	  function simpleSelection(anchor, head) {
	    return new Selection([new Range(anchor, head || anchor)], 0);
	  }
	
	  // Compute the position of the end of a change (its 'to' property
	  // refers to the pre-change end).
	  function changeEnd(change) {
	    if (!change.text) {
	      return change.to;
	    }
	    return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
	  }
	
	  // Adjust a position to refer to the post-change position of the
	  // same text, or the end of the change if the change covers it.
	  function adjustForChange(pos, change) {
	    if (cmp(pos, change.from) < 0) {
	      return pos;
	    }
	    if (cmp(pos, change.to) <= 0) {
	      return changeEnd(change);
	    }
	
	    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1,
	        ch = pos.ch;
	    if (pos.line == change.to.line) {
	      ch += changeEnd(change).ch - change.to.ch;
	    }
	    return Pos(line, ch);
	  }
	
	  function computeSelAfterChange(doc, change) {
	    var out = [];
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      var range = doc.sel.ranges[i];
	      out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
	    }
	    return normalizeSelection(out, doc.sel.primIndex);
	  }
	
	  function offsetPos(pos, old, nw) {
	    if (pos.line == old.line) {
	      return Pos(nw.line, pos.ch - old.ch + nw.ch);
	    } else {
	      return Pos(nw.line + (pos.line - old.line), pos.ch);
	    }
	  }
	
	  // Used by replaceSelections to allow moving the selection to the
	  // start or around the replaced test. Hint may be "start" or "around".
	  function computeReplacedSel(doc, changes, hint) {
	    var out = [];
	    var oldPrev = Pos(doc.first, 0),
	        newPrev = oldPrev;
	    for (var i = 0; i < changes.length; i++) {
	      var change = changes[i];
	      var from = offsetPos(change.from, oldPrev, newPrev);
	      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
	      oldPrev = change.to;
	      newPrev = to;
	      if (hint == "around") {
	        var range = doc.sel.ranges[i],
	            inv = cmp(range.head, range.anchor) < 0;
	        out[i] = new Range(inv ? to : from, inv ? from : to);
	      } else {
	        out[i] = new Range(from, from);
	      }
	    }
	    return new Selection(out, doc.sel.primIndex);
	  }
	
	  // Used to get the editor into a consistent state again when options change.
	
	  function loadMode(cm) {
	    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
	    resetModeState(cm);
	  }
	
	  function resetModeState(cm) {
	    cm.doc.iter(function (line) {
	      if (line.stateAfter) {
	        line.stateAfter = null;
	      }
	      if (line.styles) {
	        line.styles = null;
	      }
	    });
	    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
	    startWorker(cm, 100);
	    cm.state.modeGen++;
	    if (cm.curOp) {
	      regChange(cm);
	    }
	  }
	
	  // DOCUMENT DATA STRUCTURE
	
	  // By default, updates that start and end at the beginning of a line
	  // are treated specially, in order to make the association of line
	  // widgets and marker elements with the text behave more intuitive.
	  function isWholeLineUpdate(doc, change) {
	    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
	  }
	
	  // Perform a change on the document data structure.
	  function updateDoc(doc, change, markedSpans, estimateHeight$$1) {
	    function spansFor(n) {
	      return markedSpans ? markedSpans[n] : null;
	    }
	    function update(line, text, spans) {
	      updateLine(line, text, spans, estimateHeight$$1);
	      signalLater(line, "change", line, change);
	    }
	    function linesFor(start, end) {
	      var result = [];
	      for (var i = start; i < end; ++i) {
	        result.push(new Line(text[i], spansFor(i), estimateHeight$$1));
	      }
	      return result;
	    }
	
	    var from = change.from,
	        to = change.to,
	        text = change.text;
	    var firstLine = getLine(doc, from.line),
	        lastLine = getLine(doc, to.line);
	    var lastText = lst(text),
	        lastSpans = spansFor(text.length - 1),
	        nlines = to.line - from.line;
	
	    // Adjust the line structure
	    if (change.full) {
	      doc.insert(0, linesFor(0, text.length));
	      doc.remove(text.length, doc.size - text.length);
	    } else if (isWholeLineUpdate(doc, change)) {
	      // This is a whole-line replace. Treated specially to make
	      // sure line objects move the way they are supposed to.
	      var added = linesFor(0, text.length - 1);
	      update(lastLine, lastLine.text, lastSpans);
	      if (nlines) {
	        doc.remove(from.line, nlines);
	      }
	      if (added.length) {
	        doc.insert(from.line, added);
	      }
	    } else if (firstLine == lastLine) {
	      if (text.length == 1) {
	        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
	      } else {
	        var added$1 = linesFor(1, text.length - 1);
	        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight$$1));
	        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	        doc.insert(from.line + 1, added$1);
	      }
	    } else if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
	      doc.remove(from.line + 1, nlines);
	    } else {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
	      var added$2 = linesFor(1, text.length - 1);
	      if (nlines > 1) {
	        doc.remove(from.line + 1, nlines - 1);
	      }
	      doc.insert(from.line + 1, added$2);
	    }
	
	    signalLater(doc, "change", doc, change);
	  }
	
	  // Call f for all linked documents.
	  function linkedDocs(doc, f, sharedHistOnly) {
	    function propagate(doc, skip, sharedHist) {
	      if (doc.linked) {
	        for (var i = 0; i < doc.linked.length; ++i) {
	          var rel = doc.linked[i];
	          if (rel.doc == skip) {
	            continue;
	          }
	          var shared = sharedHist && rel.sharedHist;
	          if (sharedHistOnly && !shared) {
	            continue;
	          }
	          f(rel.doc, shared);
	          propagate(rel.doc, doc, shared);
	        }
	      }
	    }
	    propagate(doc, null, true);
	  }
	
	  // Attach a document to an editor.
	  function attachDoc(cm, doc) {
	    if (doc.cm) {
	      throw new Error("This document is already in use.");
	    }
	    cm.doc = doc;
	    doc.cm = cm;
	    estimateLineHeights(cm);
	    loadMode(cm);
	    setDirectionClass(cm);
	    if (!cm.options.lineWrapping) {
	      findMaxLine(cm);
	    }
	    cm.options.mode = doc.modeOption;
	    regChange(cm);
	  }
	
	  function setDirectionClass(cm) {
	    (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
	  }
	
	  function directionChanged(cm) {
	    runInOp(cm, function () {
	      setDirectionClass(cm);
	      regChange(cm);
	    });
	  }
	
	  function History(startGen) {
	    // Arrays of change events and selections. Doing something adds an
	    // event to done and clears undo. Undoing moves events from done
	    // to undone, redoing moves them in the other direction.
	    this.done = [];this.undone = [];
	    this.undoDepth = Infinity;
	    // Used to track when changes can be merged into a single undo
	    // event
	    this.lastModTime = this.lastSelTime = 0;
	    this.lastOp = this.lastSelOp = null;
	    this.lastOrigin = this.lastSelOrigin = null;
	    // Used by the isClean() method
	    this.generation = this.maxGeneration = startGen || 1;
	  }
	
	  // Create a history change event from an updateDoc-style change
	  // object.
	  function historyChangeFromChange(doc, change) {
	    var histChange = { from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to) };
	    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    linkedDocs(doc, function (doc) {
	      return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    }, true);
	    return histChange;
	  }
	
	  // Pop all selection events off the end of a history array. Stop at
	  // a change event.
	  function clearSelectionEvents(array) {
	    while (array.length) {
	      var last = lst(array);
	      if (last.ranges) {
	        array.pop();
	      } else {
	        break;
	      }
	    }
	  }
	
	  // Find the top change event in the history. Pop off selection
	  // events that are in the way.
	  function lastChangeEvent(hist, force) {
	    if (force) {
	      clearSelectionEvents(hist.done);
	      return lst(hist.done);
	    } else if (hist.done.length && !lst(hist.done).ranges) {
	      return lst(hist.done);
	    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	      hist.done.pop();
	      return lst(hist.done);
	    }
	  }
	
	  // Register a change in the history. Merges changes that are within
	  // a single operation, or are close together with an origin that
	  // allows merging (starting with "+") into a single event.
	  function addChangeToHistory(doc, change, selAfter, opId) {
	    var hist = doc.history;
	    hist.undone.length = 0;
	    var time = +new Date(),
	        cur;
	    var last;
	
	    if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	      // Merge this change into the last event
	      last = lst(cur.changes);
	      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	        // Optimized case for simple insertion -- don't want to add
	        // new changesets for every character typed
	        last.to = changeEnd(change);
	      } else {
	        // Add new sub-event
	        cur.changes.push(historyChangeFromChange(doc, change));
	      }
	    } else {
	      // Can not be merged, start a new event.
	      var before = lst(hist.done);
	      if (!before || !before.ranges) {
	        pushSelectionToHistory(doc.sel, hist.done);
	      }
	      cur = { changes: [historyChangeFromChange(doc, change)],
	        generation: hist.generation };
	      hist.done.push(cur);
	      while (hist.done.length > hist.undoDepth) {
	        hist.done.shift();
	        if (!hist.done[0].ranges) {
	          hist.done.shift();
	        }
	      }
	    }
	    hist.done.push(selAfter);
	    hist.generation = ++hist.maxGeneration;
	    hist.lastModTime = hist.lastSelTime = time;
	    hist.lastOp = hist.lastSelOp = opId;
	    hist.lastOrigin = hist.lastSelOrigin = change.origin;
	
	    if (!last) {
	      signal(doc, "historyAdded");
	    }
	  }
	
	  function selectionEventCanBeMerged(doc, origin, prev, sel) {
	    var ch = origin.charAt(0);
	    return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date() - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
	  }
	
	  // Called whenever the selection changes, sets the new selection as
	  // the pending selection in the history, and pushes the old pending
	  // selection into the 'done' array when it was significantly
	  // different (in number of selected ranges, emptiness, or time).
	  function addSelectionToHistory(doc, sel, opId, options) {
	    var hist = doc.history,
	        origin = options && options.origin;
	
	    // A new event is started when the previous origin does not match
	    // the current, or the origins don't allow matching. Origins
	    // starting with * are always merged, those starting with + are
	    // merged when similar and close together in time.
	    if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) {
	      hist.done[hist.done.length - 1] = sel;
	    } else {
	      pushSelectionToHistory(sel, hist.done);
	    }
	
	    hist.lastSelTime = +new Date();
	    hist.lastSelOrigin = origin;
	    hist.lastSelOp = opId;
	    if (options && options.clearRedo !== false) {
	      clearSelectionEvents(hist.undone);
	    }
	  }
	
	  function pushSelectionToHistory(sel, dest) {
	    var top = lst(dest);
	    if (!(top && top.ranges && top.equals(sel))) {
	      dest.push(sel);
	    }
	  }
	
	  // Used to store marked span information in the history.
	  function attachLocalSpans(doc, change, from, to) {
	    var existing = change["spans_" + doc.id],
	        n = 0;
	    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
	      if (line.markedSpans) {
	        (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
	      }
	      ++n;
	    });
	  }
	
	  // When un/re-doing restores text containing marked spans, those
	  // that have been explicitly cleared should not be restored.
	  function removeClearedSpans(spans) {
	    if (!spans) {
	      return null;
	    }
	    var out;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i].marker.explicitlyCleared) {
	        if (!out) {
	          out = spans.slice(0, i);
	        }
	      } else if (out) {
	        out.push(spans[i]);
	      }
	    }
	    return !out ? spans : out.length ? out : null;
	  }
	
	  // Retrieve and filter the old marked spans stored in a change event.
	  function getOldSpans(doc, change) {
	    var found = change["spans_" + doc.id];
	    if (!found) {
	      return null;
	    }
	    var nw = [];
	    for (var i = 0; i < change.text.length; ++i) {
	      nw.push(removeClearedSpans(found[i]));
	    }
	    return nw;
	  }
	
	  // Used for un/re-doing changes from the history. Combines the
	  // result of computing the existing spans with the set of spans that
	  // existed in the history (so that deleting around a span and then
	  // undoing brings back the span).
	  function mergeOldSpans(doc, change) {
	    var old = getOldSpans(doc, change);
	    var stretched = stretchSpansOverChange(doc, change);
	    if (!old) {
	      return stretched;
	    }
	    if (!stretched) {
	      return old;
	    }
	
	    for (var i = 0; i < old.length; ++i) {
	      var oldCur = old[i],
	          stretchCur = stretched[i];
	      if (oldCur && stretchCur) {
	        spans: for (var j = 0; j < stretchCur.length; ++j) {
	          var span = stretchCur[j];
	          for (var k = 0; k < oldCur.length; ++k) {
	            if (oldCur[k].marker == span.marker) {
	              continue spans;
	            }
	          }
	          oldCur.push(span);
	        }
	      } else if (stretchCur) {
	        old[i] = stretchCur;
	      }
	    }
	    return old;
	  }
	
	  // Used both to provide a JSON-safe object in .getHistory, and, when
	  // detaching a document, to split the history in two
	  function copyHistoryArray(events, newGroup, instantiateSel) {
	    var copy = [];
	    for (var i = 0; i < events.length; ++i) {
	      var event = events[i];
	      if (event.ranges) {
	        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
	        continue;
	      }
	      var changes = event.changes,
	          newChanges = [];
	      copy.push({ changes: newChanges });
	      for (var j = 0; j < changes.length; ++j) {
	        var change = changes[j],
	            m = void 0;
	        newChanges.push({ from: change.from, to: change.to, text: change.text });
	        if (newGroup) {
	          for (var prop in change) {
	            if (m = prop.match(/^spans_(\d+)$/)) {
	              if (indexOf(newGroup, Number(m[1])) > -1) {
	                lst(newChanges)[prop] = change[prop];
	                delete change[prop];
	              }
	            }
	          }
	        }
	      }
	    }
	    return copy;
	  }
	
	  // The 'scroll' parameter given to many of these indicated whether
	  // the new cursor position should be scrolled into view after
	  // modifying the selection.
	
	  // If shift is held or the extend flag is set, extends a range to
	  // include a given position (and optionally a second position).
	  // Otherwise, simply returns the range between the given positions.
	  // Used for cursor motion and such.
	  function extendRange(range, head, other, extend) {
	    if (extend) {
	      var anchor = range.anchor;
	      if (other) {
	        var posBefore = cmp(head, anchor) < 0;
	        if (posBefore != cmp(other, anchor) < 0) {
	          anchor = head;
	          head = other;
	        } else if (posBefore != cmp(head, other) < 0) {
	          head = other;
	        }
	      }
	      return new Range(anchor, head);
	    } else {
	      return new Range(other || head, head);
	    }
	  }
	
	  // Extend the primary selection range, discard the rest.
	  function extendSelection(doc, head, other, options, extend) {
	    if (extend == null) {
	      extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    }
	    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
	  }
	
	  // Extend all selections (pos is an array of selections with length
	  // equal the number of selections)
	  function extendSelections(doc, heads, options) {
	    var out = [];
	    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
	    }
	    var newSel = normalizeSelection(out, doc.sel.primIndex);
	    setSelection(doc, newSel, options);
	  }
	
	  // Updates a single range in the selection.
	  function replaceOneSelection(doc, i, range, options) {
	    var ranges = doc.sel.ranges.slice(0);
	    ranges[i] = range;
	    setSelection(doc, normalizeSelection(ranges, doc.sel.primIndex), options);
	  }
	
	  // Reset the selection to a single range.
	  function setSimpleSelection(doc, anchor, head, options) {
	    setSelection(doc, simpleSelection(anchor, head), options);
	  }
	
	  // Give beforeSelectionChange handlers a change to influence a
	  // selection update.
	  function filterSelectionChange(doc, sel, options) {
	    var obj = {
	      ranges: sel.ranges,
	      update: function update(ranges) {
	        var this$1 = this;
	
	        this.ranges = [];
	        for (var i = 0; i < ranges.length; i++) {
	          this$1.ranges[i] = new Range(_clipPos(doc, ranges[i].anchor), _clipPos(doc, ranges[i].head));
	        }
	      },
	      origin: options && options.origin
	    };
	    signal(doc, "beforeSelectionChange", doc, obj);
	    if (doc.cm) {
	      signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
	    }
	    if (obj.ranges != sel.ranges) {
	      return normalizeSelection(obj.ranges, obj.ranges.length - 1);
	    } else {
	      return sel;
	    }
	  }
	
	  function setSelectionReplaceHistory(doc, sel, options) {
	    var done = doc.history.done,
	        last = lst(done);
	    if (last && last.ranges) {
	      done[done.length - 1] = sel;
	      setSelectionNoUndo(doc, sel, options);
	    } else {
	      setSelection(doc, sel, options);
	    }
	  }
	
	  // Set a new selection.
	  function setSelection(doc, sel, options) {
	    setSelectionNoUndo(doc, sel, options);
	    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
	  }
	
	  function setSelectionNoUndo(doc, sel, options) {
	    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) {
	      sel = filterSelectionChange(doc, sel, options);
	    }
	
	    var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
	    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
	
	    if (!(options && options.scroll === false) && doc.cm) {
	      ensureCursorVisible(doc.cm);
	    }
	  }
	
	  function setSelectionInner(doc, sel) {
	    if (sel.equals(doc.sel)) {
	      return;
	    }
	
	    doc.sel = sel;
	
	    if (doc.cm) {
	      doc.cm.curOp.updateInput = doc.cm.curOp.selectionChanged = true;
	      signalCursorActivity(doc.cm);
	    }
	    signalLater(doc, "cursorActivity", doc);
	  }
	
	  // Verify that the selection does not partially select any atomic
	  // marked ranges.
	  function reCheckSelection(doc) {
	    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
	  }
	
	  // Return a selection that does not partially select any atomic
	  // ranges.
	  function skipAtomicInSelection(doc, sel, bias, mayClear) {
	    var out;
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i];
	      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
	      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
	      var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
	      if (out || newAnchor != range.anchor || newHead != range.head) {
	        if (!out) {
	          out = sel.ranges.slice(0, i);
	        }
	        out[i] = new Range(newAnchor, newHead);
	      }
	    }
	    return out ? normalizeSelection(out, sel.primIndex) : sel;
	  }
	
	  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	    var line = getLine(doc, pos.line);
	    if (line.markedSpans) {
	      for (var i = 0; i < line.markedSpans.length; ++i) {
	        var sp = line.markedSpans[i],
	            m = sp.marker;
	        if ((sp.from == null || (m.inclusiveLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (m.inclusiveRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	          if (mayClear) {
	            signal(m, "beforeCursorEnter");
	            if (m.explicitlyCleared) {
	              if (!line.markedSpans) {
	                break;
	              } else {
	                --i;continue;
	              }
	            }
	          }
	          if (!m.atomic) {
	            continue;
	          }
	
	          if (oldPos) {
	            var near = m.find(dir < 0 ? 1 : -1),
	                diff = void 0;
	            if (dir < 0 ? m.inclusiveRight : m.inclusiveLeft) {
	              near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
	            }
	            if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) {
	              return skipAtomicInner(doc, near, pos, dir, mayClear);
	            }
	          }
	
	          var far = m.find(dir < 0 ? -1 : 1);
	          if (dir < 0 ? m.inclusiveLeft : m.inclusiveRight) {
	            far = movePos(doc, far, dir, far.line == pos.line ? line : null);
	          }
	          return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
	        }
	      }
	    }
	    return pos;
	  }
	
	  // Ensure a given position is not inside an atomic range.
	  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	    var dir = bias || 1;
	    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
	    if (!found) {
	      doc.cantEdit = true;
	      return Pos(doc.first, 0);
	    }
	    return found;
	  }
	
	  function movePos(doc, pos, dir, line) {
	    if (dir < 0 && pos.ch == 0) {
	      if (pos.line > doc.first) {
	        return _clipPos(doc, Pos(pos.line - 1));
	      } else {
	        return null;
	      }
	    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	      if (pos.line < doc.first + doc.size - 1) {
	        return Pos(pos.line + 1, 0);
	      } else {
	        return null;
	      }
	    } else {
	      return new Pos(pos.line, pos.ch + dir);
	    }
	  }
	
	  function selectAll(cm) {
	    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
	  }
	
	  // UPDATING
	
	  // Allow "beforeChange" event handlers to influence a change
	  function filterChange(doc, change, update) {
	    var obj = {
	      canceled: false,
	      from: change.from,
	      to: change.to,
	      text: change.text,
	      origin: change.origin,
	      cancel: function cancel() {
	        return obj.canceled = true;
	      }
	    };
	    if (update) {
	      obj.update = function (from, to, text, origin) {
	        if (from) {
	          obj.from = _clipPos(doc, from);
	        }
	        if (to) {
	          obj.to = _clipPos(doc, to);
	        }
	        if (text) {
	          obj.text = text;
	        }
	        if (origin !== undefined) {
	          obj.origin = origin;
	        }
	      };
	    }
	    signal(doc, "beforeChange", doc, obj);
	    if (doc.cm) {
	      signal(doc.cm, "beforeChange", doc.cm, obj);
	    }
	
	    if (obj.canceled) {
	      return null;
	    }
	    return { from: obj.from, to: obj.to, text: obj.text, origin: obj.origin };
	  }
	
	  // Apply a change to a document, and add it to the document's
	  // history, and propagating it to all linked documents.
	  function makeChange(doc, change, ignoreReadOnly) {
	    if (doc.cm) {
	      if (!doc.cm.curOp) {
	        return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
	      }
	      if (doc.cm.state.suppressEdits) {
	        return;
	      }
	    }
	
	    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	      change = filterChange(doc, change, true);
	      if (!change) {
	        return;
	      }
	    }
	
	    // Possibly split or suppress the update based on the presence
	    // of read-only spans in its range.
	    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
	    if (split) {
	      for (var i = split.length - 1; i >= 0; --i) {
	        makeChangeInner(doc, { from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin });
	      }
	    } else {
	      makeChangeInner(doc, change);
	    }
	  }
	
	  function makeChangeInner(doc, change) {
	    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) {
	      return;
	    }
	    var selAfter = computeSelAfterChange(doc, change);
	    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
	
	    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
	    var rebased = [];
	
	    linkedDocs(doc, function (doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change);
	        rebased.push(doc.history);
	      }
	      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
	    });
	  }
	
	  // Revert a change stored in a document's history.
	  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	    var suppress = doc.cm && doc.cm.state.suppressEdits;
	    if (suppress && !allowSelectionOnly) {
	      return;
	    }
	
	    var hist = doc.history,
	        event,
	        selAfter = doc.sel;
	    var source = type == "undo" ? hist.done : hist.undone,
	        dest = type == "undo" ? hist.undone : hist.done;
	
	    // Verify that there is a useable event (so that ctrl-z won't
	    // needlessly clear selection events)
	    var i = 0;
	    for (; i < source.length; i++) {
	      event = source[i];
	      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) {
	        break;
	      }
	    }
	    if (i == source.length) {
	      return;
	    }
	    hist.lastOrigin = hist.lastSelOrigin = null;
	
	    for (;;) {
	      event = source.pop();
	      if (event.ranges) {
	        pushSelectionToHistory(event, dest);
	        if (allowSelectionOnly && !event.equals(doc.sel)) {
	          setSelection(doc, event, { clearRedo: false });
	          return;
	        }
	        selAfter = event;
	      } else if (suppress) {
	        source.push(event);
	        return;
	      } else {
	        break;
	      }
	    }
	
	    // Build up a reverse change object to add to the opposite history
	    // stack (redo when undoing, and vice versa).
	    var antiChanges = [];
	    pushSelectionToHistory(selAfter, dest);
	    dest.push({ changes: antiChanges, generation: hist.generation });
	    hist.generation = event.generation || ++hist.maxGeneration;
	
	    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
	
	    var loop = function loop(i) {
	      var change = event.changes[i];
	      change.origin = type;
	      if (filter && !filterChange(doc, change, false)) {
	        source.length = 0;
	        return {};
	      }
	
	      antiChanges.push(historyChangeFromChange(doc, change));
	
	      var after = i ? computeSelAfterChange(doc, change) : lst(source);
	      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
	      if (!i && doc.cm) {
	        doc.cm.scrollIntoView({ from: change.from, to: changeEnd(change) });
	      }
	      var rebased = [];
	
	      // Propagate to the linked documents
	      linkedDocs(doc, function (doc, sharedHist) {
	        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	          rebaseHist(doc.history, change);
	          rebased.push(doc.history);
	        }
	        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
	      });
	    };
	
	    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
	      var returned = loop(i$1);
	
	      if (returned) return returned.v;
	    }
	  }
	
	  // Sub-views need their line numbers shifted when text is added
	  // above or below them in the parent document.
	  function shiftDoc(doc, distance) {
	    if (distance == 0) {
	      return;
	    }
	    doc.first += distance;
	    doc.sel = new Selection(map(doc.sel.ranges, function (range) {
	      return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
	    }), doc.sel.primIndex);
	    if (doc.cm) {
	      regChange(doc.cm, doc.first, doc.first - distance, distance);
	      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++) {
	        regLineChange(doc.cm, l, "gutter");
	      }
	    }
	  }
	
	  // More lower-level change function, handling only a single document
	  // (not linked ones).
	  function makeChangeSingleDoc(doc, change, selAfter, spans) {
	    if (doc.cm && !doc.cm.curOp) {
	      return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
	    }
	
	    if (change.to.line < doc.first) {
	      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
	      return;
	    }
	    if (change.from.line > doc.lastLine()) {
	      return;
	    }
	
	    // Clip the change to the size of this doc
	    if (change.from.line < doc.first) {
	      var shift = change.text.length - 1 - (doc.first - change.from.line);
	      shiftDoc(doc, shift);
	      change = { from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	        text: [lst(change.text)], origin: change.origin };
	    }
	    var last = doc.lastLine();
	    if (change.to.line > last) {
	      change = { from: change.from, to: Pos(last, getLine(doc, last).text.length),
	        text: [change.text[0]], origin: change.origin };
	    }
	
	    change.removed = getBetween(doc, change.from, change.to);
	
	    if (!selAfter) {
	      selAfter = computeSelAfterChange(doc, change);
	    }
	    if (doc.cm) {
	      makeChangeSingleDocInEditor(doc.cm, change, spans);
	    } else {
	      updateDoc(doc, change, spans);
	    }
	    setSelectionNoUndo(doc, selAfter, sel_dontScroll);
	  }
	
	  // Handle the interaction of a change to a document with the editor
	  // that this document is part of.
	  function makeChangeSingleDocInEditor(cm, change, spans) {
	    var doc = cm.doc,
	        display = cm.display,
	        from = change.from,
	        to = change.to;
	
	    var recomputeMaxLength = false,
	        checkWidthStart = from.line;
	    if (!cm.options.lineWrapping) {
	      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
	      doc.iter(checkWidthStart, to.line + 1, function (line) {
	        if (line == display.maxLine) {
	          recomputeMaxLength = true;
	          return true;
	        }
	      });
	    }
	
	    if (doc.sel.contains(change.from, change.to) > -1) {
	      signalCursorActivity(cm);
	    }
	
	    updateDoc(doc, change, spans, estimateHeight(cm));
	
	    if (!cm.options.lineWrapping) {
	      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
	        var len = lineLength(line);
	        if (len > display.maxLineLength) {
	          display.maxLine = line;
	          display.maxLineLength = len;
	          display.maxLineChanged = true;
	          recomputeMaxLength = false;
	        }
	      });
	      if (recomputeMaxLength) {
	        cm.curOp.updateMaxLine = true;
	      }
	    }
	
	    retreatFrontier(doc, from.line);
	    startWorker(cm, 400);
	
	    var lendiff = change.text.length - (to.line - from.line) - 1;
	    // Remember that these lines changed, for updating the display
	    if (change.full) {
	      regChange(cm);
	    } else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) {
	      regLineChange(cm, from.line, "text");
	    } else {
	      regChange(cm, from.line, to.line + 1, lendiff);
	    }
	
	    var changesHandler = hasHandler(cm, "changes"),
	        changeHandler = hasHandler(cm, "change");
	    if (changeHandler || changesHandler) {
	      var obj = {
	        from: from, to: to,
	        text: change.text,
	        removed: change.removed,
	        origin: change.origin
	      };
	      if (changeHandler) {
	        signalLater(cm, "change", cm, obj);
	      }
	      if (changesHandler) {
	        (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
	      }
	    }
	    cm.display.selForContextMenu = null;
	  }
	
	  function _replaceRange(doc, code, from, to, origin) {
	    if (!to) {
	      to = from;
	    }
	    if (cmp(to, from) < 0) {
	      var assign;
	      assign = [to, from], from = assign[0], to = assign[1];
	    }
	    if (typeof code == "string") {
	      code = doc.splitLines(code);
	    }
	    makeChange(doc, { from: from, to: to, text: code, origin: origin });
	  }
	
	  // Rebasing/resetting history to deal with externally-sourced changes
	
	  function rebaseHistSelSingle(pos, from, to, diff) {
	    if (to < pos.line) {
	      pos.line += diff;
	    } else if (from < pos.line) {
	      pos.line = from;
	      pos.ch = 0;
	    }
	  }
	
	  // Tries to rebase an array of history events given a change in the
	  // document. If the change touches the same lines as the event, the
	  // event, and everything 'behind' it, is discarded. If the change is
	  // before the event, the event's positions are updated. Uses a
	  // copy-on-write scheme for the positions, to avoid having to
	  // reallocate them all on every rebase, but also avoid problems with
	  // shared position objects being unsafely updated.
	  function rebaseHistArray(array, from, to, diff) {
	    for (var i = 0; i < array.length; ++i) {
	      var sub = array[i],
	          ok = true;
	      if (sub.ranges) {
	        if (!sub.copied) {
	          sub = array[i] = sub.deepCopy();sub.copied = true;
	        }
	        for (var j = 0; j < sub.ranges.length; j++) {
	          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
	          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
	        }
	        continue;
	      }
	      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
	        var cur = sub.changes[j$1];
	        if (to < cur.from.line) {
	          cur.from = Pos(cur.from.line + diff, cur.from.ch);
	          cur.to = Pos(cur.to.line + diff, cur.to.ch);
	        } else if (from <= cur.to.line) {
	          ok = false;
	          break;
	        }
	      }
	      if (!ok) {
	        array.splice(0, i + 1);
	        i = 0;
	      }
	    }
	  }
	
	  function rebaseHist(hist, change) {
	    var from = change.from.line,
	        to = change.to.line,
	        diff = change.text.length - (to - from) - 1;
	    rebaseHistArray(hist.done, from, to, diff);
	    rebaseHistArray(hist.undone, from, to, diff);
	  }
	
	  // Utility for applying a change to a line by handle or number,
	  // returning the number and optionally registering the line as
	  // changed.
	  function changeLine(doc, handle, changeType, op) {
	    var no = handle,
	        line = handle;
	    if (typeof handle == "number") {
	      line = getLine(doc, clipLine(doc, handle));
	    } else {
	      no = lineNo(handle);
	    }
	    if (no == null) {
	      return null;
	    }
	    if (op(line, no) && doc.cm) {
	      regLineChange(doc.cm, no, changeType);
	    }
	    return line;
	  }
	
	  // The document is represented as a BTree consisting of leaves, with
	  // chunk of lines in them, and branches, with up to ten leaves or
	  // other branch nodes below them. The top node is always a branch
	  // node, and is the document object itself (meaning it has
	  // additional methods and properties).
	  //
	  // All nodes have parent links. The tree is used both to go from
	  // line numbers to line objects, and to go from objects to numbers.
	  // It also indexes by height, and is used to convert between height
	  // and line object, and to find the total height of the document.
	  //
	  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	  function LeafChunk(lines) {
	    var this$1 = this;
	
	    this.lines = lines;
	    this.parent = null;
	    var height = 0;
	    for (var i = 0; i < lines.length; ++i) {
	      lines[i].parent = this$1;
	      height += lines[i].height;
	    }
	    this.height = height;
	  }
	
	  LeafChunk.prototype = {
	    chunkSize: function chunkSize() {
	      return this.lines.length;
	    },
	
	    // Remove the n lines at offset 'at'.
	    removeInner: function removeInner(at, n) {
	      var this$1 = this;
	
	      for (var i = at, e = at + n; i < e; ++i) {
	        var line = this$1.lines[i];
	        this$1.height -= line.height;
	        cleanUpLine(line);
	        signalLater(line, "delete");
	      }
	      this.lines.splice(at, n);
	    },
	
	    // Helper used to collapse a small branch into a single leaf.
	    collapse: function collapse(lines) {
	      lines.push.apply(lines, this.lines);
	    },
	
	    // Insert the given array of lines at offset 'at', count them as
	    // having the given height.
	    insertInner: function insertInner(at, lines, height) {
	      var this$1 = this;
	
	      this.height += height;
	      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
	      for (var i = 0; i < lines.length; ++i) {
	        lines[i].parent = this$1;
	      }
	    },
	
	    // Used to iterate over a part of the tree.
	    iterN: function iterN(at, n, op) {
	      var this$1 = this;
	
	      for (var e = at + n; at < e; ++at) {
	        if (op(this$1.lines[at])) {
	          return true;
	        }
	      }
	    }
	  };
	
	  function BranchChunk(children) {
	    var this$1 = this;
	
	    this.children = children;
	    var size = 0,
	        height = 0;
	    for (var i = 0; i < children.length; ++i) {
	      var ch = children[i];
	      size += ch.chunkSize();height += ch.height;
	      ch.parent = this$1;
	    }
	    this.size = size;
	    this.height = height;
	    this.parent = null;
	  }
	
	  BranchChunk.prototype = {
	    chunkSize: function chunkSize() {
	      return this.size;
	    },
	
	    removeInner: function removeInner(at, n) {
	      var this$1 = this;
	
	      this.size -= n;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this$1.children[i],
	            sz = child.chunkSize();
	        if (at < sz) {
	          var rm = Math.min(n, sz - at),
	              oldHeight = child.height;
	          child.removeInner(at, rm);
	          this$1.height -= oldHeight - child.height;
	          if (sz == rm) {
	            this$1.children.splice(i--, 1);child.parent = null;
	          }
	          if ((n -= rm) == 0) {
	            break;
	          }
	          at = 0;
	        } else {
	          at -= sz;
	        }
	      }
	      // If the result is smaller than 25 lines, ensure that it is a
	      // single leaf node.
	      if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	        var lines = [];
	        this.collapse(lines);
	        this.children = [new LeafChunk(lines)];
	        this.children[0].parent = this;
	      }
	    },
	
	    collapse: function collapse(lines) {
	      var this$1 = this;
	
	      for (var i = 0; i < this.children.length; ++i) {
	        this$1.children[i].collapse(lines);
	      }
	    },
	
	    insertInner: function insertInner(at, lines, height) {
	      var this$1 = this;
	
	      this.size += lines.length;
	      this.height += height;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this$1.children[i],
	            sz = child.chunkSize();
	        if (at <= sz) {
	          child.insertInner(at, lines, height);
	          if (child.lines && child.lines.length > 50) {
	            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	            var remaining = child.lines.length % 25 + 25;
	            for (var pos = remaining; pos < child.lines.length;) {
	              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
	              child.height -= leaf.height;
	              this$1.children.splice(++i, 0, leaf);
	              leaf.parent = this$1;
	            }
	            child.lines = child.lines.slice(0, remaining);
	            this$1.maybeSpill();
	          }
	          break;
	        }
	        at -= sz;
	      }
	    },
	
	    // When a node has grown, check whether it should be split.
	    maybeSpill: function maybeSpill() {
	      if (this.children.length <= 10) {
	        return;
	      }
	      var me = this;
	      do {
	        var spilled = me.children.splice(me.children.length - 5, 5);
	        var sibling = new BranchChunk(spilled);
	        if (!me.parent) {
	          // Become the parent node
	          var copy = new BranchChunk(me.children);
	          copy.parent = me;
	          me.children = [copy, sibling];
	          me = copy;
	        } else {
	          me.size -= sibling.size;
	          me.height -= sibling.height;
	          var myIndex = indexOf(me.parent.children, me);
	          me.parent.children.splice(myIndex + 1, 0, sibling);
	        }
	        sibling.parent = me.parent;
	      } while (me.children.length > 10);
	      me.parent.maybeSpill();
	    },
	
	    iterN: function iterN(at, n, op) {
	      var this$1 = this;
	
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this$1.children[i],
	            sz = child.chunkSize();
	        if (at < sz) {
	          var used = Math.min(n, sz - at);
	          if (child.iterN(at, used, op)) {
	            return true;
	          }
	          if ((n -= used) == 0) {
	            break;
	          }
	          at = 0;
	        } else {
	          at -= sz;
	        }
	      }
	    }
	  };
	
	  // Line widgets are block elements displayed above or below a line.
	
	  var LineWidget = function LineWidget(doc, node, options) {
	    var this$1 = this;
	
	    if (options) {
	      for (var opt in options) {
	        if (options.hasOwnProperty(opt)) {
	          this$1[opt] = options[opt];
	        }
	      }
	    }
	    this.doc = doc;
	    this.node = node;
	  };
	
	  LineWidget.prototype.clear = function () {
	    var this$1 = this;
	
	    var cm = this.doc.cm,
	        ws = this.line.widgets,
	        line = this.line,
	        no = lineNo(line);
	    if (no == null || !ws) {
	      return;
	    }
	    for (var i = 0; i < ws.length; ++i) {
	      if (ws[i] == this$1) {
	        ws.splice(i--, 1);
	      }
	    }
	    if (!ws.length) {
	      line.widgets = null;
	    }
	    var height = widgetHeight(this);
	    updateLineHeight(line, Math.max(0, line.height - height));
	    if (cm) {
	      runInOp(cm, function () {
	        adjustScrollWhenAboveVisible(cm, line, -height);
	        regLineChange(cm, no, "widget");
	      });
	      signalLater(cm, "lineWidgetCleared", cm, this, no);
	    }
	  };
	
	  LineWidget.prototype.changed = function () {
	    var this$1 = this;
	
	    var oldH = this.height,
	        cm = this.doc.cm,
	        line = this.line;
	    this.height = null;
	    var diff = widgetHeight(this) - oldH;
	    if (!diff) {
	      return;
	    }
	    updateLineHeight(line, line.height + diff);
	    if (cm) {
	      runInOp(cm, function () {
	        cm.curOp.forceUpdate = true;
	        adjustScrollWhenAboveVisible(cm, line, diff);
	        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
	      });
	    }
	  };
	  eventMixin(LineWidget);
	
	  function adjustScrollWhenAboveVisible(cm, line, diff) {
	    if (_heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) {
	      addToScrollTop(cm, diff);
	    }
	  }
	
	  function addLineWidget(doc, handle, node, options) {
	    var widget = new LineWidget(doc, node, options);
	    var cm = doc.cm;
	    if (cm && widget.noHScroll) {
	      cm.display.alignWidgets = true;
	    }
	    changeLine(doc, handle, "widget", function (line) {
	      var widgets = line.widgets || (line.widgets = []);
	      if (widget.insertAt == null) {
	        widgets.push(widget);
	      } else {
	        widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget);
	      }
	      widget.line = line;
	      if (cm && !lineIsHidden(doc, line)) {
	        var aboveVisible = _heightAtLine(line) < doc.scrollTop;
	        updateLineHeight(line, line.height + widgetHeight(widget));
	        if (aboveVisible) {
	          addToScrollTop(cm, widget.height);
	        }
	        cm.curOp.forceUpdate = true;
	      }
	      return true;
	    });
	    if (cm) {
	      signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
	    }
	    return widget;
	  }
	
	  // TEXTMARKERS
	
	  // Created with markText and setBookmark methods. A TextMarker is a
	  // handle that can be used to clear or find a marked position in the
	  // document. Line objects hold arrays (markedSpans) containing
	  // {from, to, marker} object pointing to such marker objects, and
	  // indicating that such a marker is present on that line. Multiple
	  // lines may point to the same marker when it spans across lines.
	  // The spans will have null for their from/to properties when the
	  // marker continues beyond the start/end of the line. Markers have
	  // links back to the lines they currently touch.
	
	  // Collapsed markers have unique ids, in order to be able to order
	  // them, which is needed for uniquely determining an outer marker
	  // when they overlap (they may nest, but not partially overlap).
	  var nextMarkerId = 0;
	
	  var TextMarker = function TextMarker(doc, type) {
	    this.lines = [];
	    this.type = type;
	    this.doc = doc;
	    this.id = ++nextMarkerId;
	  };
	
	  // Clear the marker.
	  TextMarker.prototype.clear = function () {
	    var this$1 = this;
	
	    if (this.explicitlyCleared) {
	      return;
	    }
	    var cm = this.doc.cm,
	        withOp = cm && !cm.curOp;
	    if (withOp) {
	      _startOperation(cm);
	    }
	    if (hasHandler(this, "clear")) {
	      var found = this.find();
	      if (found) {
	        signalLater(this, "clear", found.from, found.to);
	      }
	    }
	    var min = null,
	        max = null;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this$1.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this$1);
	      if (cm && !this$1.collapsed) {
	        regLineChange(cm, lineNo(line), "text");
	      } else if (cm) {
	        if (span.to != null) {
	          max = lineNo(line);
	        }
	        if (span.from != null) {
	          min = lineNo(line);
	        }
	      }
	      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
	      if (span.from == null && this$1.collapsed && !lineIsHidden(this$1.doc, line) && cm) {
	        updateLineHeight(line, textHeight(cm.display));
	      }
	    }
	    if (cm && this.collapsed && !cm.options.lineWrapping) {
	      for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
	        var visual = visualLine(this$1.lines[i$1]),
	            len = lineLength(visual);
	        if (len > cm.display.maxLineLength) {
	          cm.display.maxLine = visual;
	          cm.display.maxLineLength = len;
	          cm.display.maxLineChanged = true;
	        }
	      }
	    }
	
	    if (min != null && cm && this.collapsed) {
	      regChange(cm, min, max + 1);
	    }
	    this.lines.length = 0;
	    this.explicitlyCleared = true;
	    if (this.atomic && this.doc.cantEdit) {
	      this.doc.cantEdit = false;
	      if (cm) {
	        reCheckSelection(cm.doc);
	      }
	    }
	    if (cm) {
	      signalLater(cm, "markerCleared", cm, this, min, max);
	    }
	    if (withOp) {
	      _endOperation(cm);
	    }
	    if (this.parent) {
	      this.parent.clear();
	    }
	  };
	
	  // Find the position of the marker in the document. Returns a {from,
	  // to} object by default. Side can be passed to get a specific side
	  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	  // Pos objects returned contain a line object, rather than a line
	  // number (used to prevent looking up the same line twice).
	  TextMarker.prototype.find = function (side, lineObj) {
	    var this$1 = this;
	
	    if (side == null && this.type == "bookmark") {
	      side = 1;
	    }
	    var from, to;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this$1.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this$1);
	      if (span.from != null) {
	        from = Pos(lineObj ? line : lineNo(line), span.from);
	        if (side == -1) {
	          return from;
	        }
	      }
	      if (span.to != null) {
	        to = Pos(lineObj ? line : lineNo(line), span.to);
	        if (side == 1) {
	          return to;
	        }
	      }
	    }
	    return from && { from: from, to: to };
	  };
	
	  // Signals that the marker's widget changed, and surrounding layout
	  // should be recomputed.
	  TextMarker.prototype.changed = function () {
	    var this$1 = this;
	
	    var pos = this.find(-1, true),
	        widget = this,
	        cm = this.doc.cm;
	    if (!pos || !cm) {
	      return;
	    }
	    runInOp(cm, function () {
	      var line = pos.line,
	          lineN = lineNo(pos.line);
	      var view = findViewForLine(cm, lineN);
	      if (view) {
	        clearLineMeasurementCacheFor(view);
	        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
	      }
	      cm.curOp.updateMaxLine = true;
	      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	        var oldHeight = widget.height;
	        widget.height = null;
	        var dHeight = widgetHeight(widget) - oldHeight;
	        if (dHeight) {
	          updateLineHeight(line, line.height + dHeight);
	        }
	      }
	      signalLater(cm, "markerChanged", cm, this$1);
	    });
	  };
	
	  TextMarker.prototype.attachLine = function (line) {
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;
	      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) {
	        (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
	      }
	    }
	    this.lines.push(line);
	  };
	
	  TextMarker.prototype.detachLine = function (line) {
	    this.lines.splice(indexOf(this.lines, line), 1);
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
	    }
	  };
	  eventMixin(TextMarker);
	
	  // Create a marker, wire it up to the right lines, and
	  function _markText(doc, from, to, options, type) {
	    // Shared markers (across linked documents) are handled separately
	    // (markTextShared will call out to this again, once per
	    // document).
	    if (options && options.shared) {
	      return markTextShared(doc, from, to, options, type);
	    }
	    // Ensure we are in an operation.
	    if (doc.cm && !doc.cm.curOp) {
	      return operation(doc.cm, _markText)(doc, from, to, options, type);
	    }
	
	    var marker = new TextMarker(doc, type),
	        diff = cmp(from, to);
	    if (options) {
	      copyObj(options, marker, false);
	    }
	    // Don't connect empty markers unless clearWhenEmpty is false
	    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) {
	      return marker;
	    }
	    if (marker.replacedWith) {
	      // Showing up as a widget implies collapsed (widget replaces text)
	      marker.collapsed = true;
	      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
	      if (!options.handleMouseEvents) {
	        marker.widgetNode.setAttribute("cm-ignore-events", "true");
	      }
	      if (options.insertLeft) {
	        marker.widgetNode.insertLeft = true;
	      }
	    }
	    if (marker.collapsed) {
	      if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) {
	        throw new Error("Inserting collapsed marker partially overlapping an existing one");
	      }
	      seeCollapsedSpans();
	    }
	
	    if (marker.addToHistory) {
	      addChangeToHistory(doc, { from: from, to: to, origin: "markText" }, doc.sel, NaN);
	    }
	
	    var curLine = from.line,
	        cm = doc.cm,
	        updateMaxLine;
	    doc.iter(curLine, to.line + 1, function (line) {
	      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) {
	        updateMaxLine = true;
	      }
	      if (marker.collapsed && curLine != from.line) {
	        updateLineHeight(line, 0);
	      }
	      addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null));
	      ++curLine;
	    });
	    // lineIsHidden depends on the presence of the spans, so needs a second pass
	    if (marker.collapsed) {
	      doc.iter(from.line, to.line + 1, function (line) {
	        if (lineIsHidden(doc, line)) {
	          updateLineHeight(line, 0);
	        }
	      });
	    }
	
	    if (marker.clearOnEnter) {
	      on(marker, "beforeCursorEnter", function () {
	        return marker.clear();
	      });
	    }
	
	    if (marker.readOnly) {
	      seeReadOnlySpans();
	      if (doc.history.done.length || doc.history.undone.length) {
	        doc.clearHistory();
	      }
	    }
	    if (marker.collapsed) {
	      marker.id = ++nextMarkerId;
	      marker.atomic = true;
	    }
	    if (cm) {
	      // Sync editor state
	      if (updateMaxLine) {
	        cm.curOp.updateMaxLine = true;
	      }
	      if (marker.collapsed) {
	        regChange(cm, from.line, to.line + 1);
	      } else if (marker.className || marker.title || marker.startStyle || marker.endStyle || marker.css) {
	        for (var i = from.line; i <= to.line; i++) {
	          regLineChange(cm, i, "text");
	        }
	      }
	      if (marker.atomic) {
	        reCheckSelection(cm.doc);
	      }
	      signalLater(cm, "markerAdded", cm, marker);
	    }
	    return marker;
	  }
	
	  // SHARED TEXTMARKERS
	
	  // A shared marker spans multiple linked documents. It is
	  // implemented as a meta-marker-object controlling multiple normal
	  // markers.
	  var SharedTextMarker = function SharedTextMarker(markers, primary) {
	    var this$1 = this;
	
	    this.markers = markers;
	    this.primary = primary;
	    for (var i = 0; i < markers.length; ++i) {
	      markers[i].parent = this$1;
	    }
	  };
	
	  SharedTextMarker.prototype.clear = function () {
	    var this$1 = this;
	
	    if (this.explicitlyCleared) {
	      return;
	    }
	    this.explicitlyCleared = true;
	    for (var i = 0; i < this.markers.length; ++i) {
	      this$1.markers[i].clear();
	    }
	    signalLater(this, "clear");
	  };
	
	  SharedTextMarker.prototype.find = function (side, lineObj) {
	    return this.primary.find(side, lineObj);
	  };
	  eventMixin(SharedTextMarker);
	
	  function markTextShared(doc, from, to, options, type) {
	    options = copyObj(options);
	    options.shared = false;
	    var markers = [_markText(doc, from, to, options, type)],
	        primary = markers[0];
	    var widget = options.widgetNode;
	    linkedDocs(doc, function (doc) {
	      if (widget) {
	        options.widgetNode = widget.cloneNode(true);
	      }
	      markers.push(_markText(doc, _clipPos(doc, from), _clipPos(doc, to), options, type));
	      for (var i = 0; i < doc.linked.length; ++i) {
	        if (doc.linked[i].isParent) {
	          return;
	        }
	      }
	      primary = lst(markers);
	    });
	    return new SharedTextMarker(markers, primary);
	  }
	
	  function findSharedMarkers(doc) {
	    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) {
	      return m.parent;
	    });
	  }
	
	  function copySharedMarkers(doc, markers) {
	    for (var i = 0; i < markers.length; i++) {
	      var marker = markers[i],
	          pos = marker.find();
	      var mFrom = doc.clipPos(pos.from),
	          mTo = doc.clipPos(pos.to);
	      if (cmp(mFrom, mTo)) {
	        var subMark = _markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
	        marker.markers.push(subMark);
	        subMark.parent = marker;
	      }
	    }
	  }
	
	  function detachSharedMarkers(markers) {
	    var loop = function loop(i) {
	      var marker = markers[i],
	          linked = [marker.primary.doc];
	      linkedDocs(marker.primary.doc, function (d) {
	        return linked.push(d);
	      });
	      for (var j = 0; j < marker.markers.length; j++) {
	        var subMarker = marker.markers[j];
	        if (indexOf(linked, subMarker.doc) == -1) {
	          subMarker.parent = null;
	          marker.markers.splice(j--, 1);
	        }
	      }
	    };
	
	    for (var i = 0; i < markers.length; i++) {
	      loop(i);
	    }
	  }
	
	  var nextDocId = 0;
	  var Doc = function Doc(text, mode, firstLine, lineSep, direction) {
	    if (!(this instanceof Doc)) {
	      return new Doc(text, mode, firstLine, lineSep, direction);
	    }
	    if (firstLine == null) {
	      firstLine = 0;
	    }
	
	    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
	    this.first = firstLine;
	    this.scrollTop = this.scrollLeft = 0;
	    this.cantEdit = false;
	    this.cleanGeneration = 1;
	    this.modeFrontier = this.highlightFrontier = firstLine;
	    var start = Pos(firstLine, 0);
	    this.sel = simpleSelection(start);
	    this.history = new History(null);
	    this.id = ++nextDocId;
	    this.modeOption = mode;
	    this.lineSep = lineSep;
	    this.direction = direction == "rtl" ? "rtl" : "ltr";
	    this.extend = false;
	
	    if (typeof text == "string") {
	      text = this.splitLines(text);
	    }
	    updateDoc(this, { from: start, to: start, text: text });
	    setSelection(this, simpleSelection(start), sel_dontScroll);
	  };
	
	  Doc.prototype = createObj(BranchChunk.prototype, {
	    constructor: Doc,
	    // Iterate over the document. Supports two forms -- with only one
	    // argument, it calls that for each line in the document. With
	    // three, it iterates over the range given by the first two (with
	    // the second being non-inclusive).
	    iter: function iter(from, to, op) {
	      if (op) {
	        this.iterN(from - this.first, to - from, op);
	      } else {
	        this.iterN(this.first, this.first + this.size, from);
	      }
	    },
	
	    // Non-public interface for adding and removing lines.
	    insert: function insert(at, lines) {
	      var height = 0;
	      for (var i = 0; i < lines.length; ++i) {
	        height += lines[i].height;
	      }
	      this.insertInner(at - this.first, lines, height);
	    },
	    remove: function remove(at, n) {
	      this.removeInner(at - this.first, n);
	    },
	
	    // From here, the methods are part of the public interface. Most
	    // are also available from CodeMirror (editor) instances.
	
	    getValue: function getValue(lineSep) {
	      var lines = getLines(this, this.first, this.first + this.size);
	      if (lineSep === false) {
	        return lines;
	      }
	      return lines.join(lineSep || this.lineSeparator());
	    },
	    setValue: docMethodOp(function (code) {
	      var top = Pos(this.first, 0),
	          last = this.first + this.size - 1;
	      makeChange(this, { from: top, to: Pos(last, getLine(this, last).text.length),
	        text: this.splitLines(code), origin: "setValue", full: true }, true);
	      if (this.cm) {
	        scrollToCoords(this.cm, 0, 0);
	      }
	      setSelection(this, simpleSelection(top), sel_dontScroll);
	    }),
	    replaceRange: function replaceRange(code, from, to, origin) {
	      from = _clipPos(this, from);
	      to = to ? _clipPos(this, to) : from;
	      _replaceRange(this, code, from, to, origin);
	    },
	    getRange: function getRange(from, to, lineSep) {
	      var lines = getBetween(this, _clipPos(this, from), _clipPos(this, to));
	      if (lineSep === false) {
	        return lines;
	      }
	      return lines.join(lineSep || this.lineSeparator());
	    },
	
	    getLine: function getLine(line) {
	      var l = this.getLineHandle(line);return l && l.text;
	    },
	
	    getLineHandle: function getLineHandle(line) {
	      if (isLine(this, line)) {
	        return getLine(this, line);
	      }
	    },
	    getLineNumber: function getLineNumber(line) {
	      return lineNo(line);
	    },
	
	    getLineHandleVisualStart: function getLineHandleVisualStart(line) {
	      if (typeof line == "number") {
	        line = getLine(this, line);
	      }
	      return visualLine(line);
	    },
	
	    lineCount: function lineCount() {
	      return this.size;
	    },
	    firstLine: function firstLine() {
	      return this.first;
	    },
	    lastLine: function lastLine() {
	      return this.first + this.size - 1;
	    },
	
	    clipPos: function clipPos(pos) {
	      return _clipPos(this, pos);
	    },
	
	    getCursor: function getCursor(start) {
	      var range$$1 = this.sel.primary(),
	          pos;
	      if (start == null || start == "head") {
	        pos = range$$1.head;
	      } else if (start == "anchor") {
	        pos = range$$1.anchor;
	      } else if (start == "end" || start == "to" || start === false) {
	        pos = range$$1.to();
	      } else {
	        pos = range$$1.from();
	      }
	      return pos;
	    },
	    listSelections: function listSelections() {
	      return this.sel.ranges;
	    },
	    somethingSelected: function somethingSelected() {
	      return this.sel.somethingSelected();
	    },
	
	    setCursor: docMethodOp(function (line, ch, options) {
	      setSimpleSelection(this, _clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
	    }),
	    setSelection: docMethodOp(function (anchor, head, options) {
	      setSimpleSelection(this, _clipPos(this, anchor), _clipPos(this, head || anchor), options);
	    }),
	    extendSelection: docMethodOp(function (head, other, options) {
	      extendSelection(this, _clipPos(this, head), other && _clipPos(this, other), options);
	    }),
	    extendSelections: docMethodOp(function (heads, options) {
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    extendSelectionsBy: docMethodOp(function (f, options) {
	      var heads = map(this.sel.ranges, f);
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    setSelections: docMethodOp(function (ranges, primary, options) {
	      var this$1 = this;
	
	      if (!ranges.length) {
	        return;
	      }
	      var out = [];
	      for (var i = 0; i < ranges.length; i++) {
	        out[i] = new Range(_clipPos(this$1, ranges[i].anchor), _clipPos(this$1, ranges[i].head));
	      }
	      if (primary == null) {
	        primary = Math.min(ranges.length - 1, this.sel.primIndex);
	      }
	      setSelection(this, normalizeSelection(out, primary), options);
	    }),
	    addSelection: docMethodOp(function (anchor, head, options) {
	      var ranges = this.sel.ranges.slice(0);
	      ranges.push(new Range(_clipPos(this, anchor), _clipPos(this, head || anchor)));
	      setSelection(this, normalizeSelection(ranges, ranges.length - 1), options);
	    }),
	
	    getSelection: function getSelection(lineSep) {
	      var this$1 = this;
	
	      var ranges = this.sel.ranges,
	          lines;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
	        lines = lines ? lines.concat(sel) : sel;
	      }
	      if (lineSep === false) {
	        return lines;
	      } else {
	        return lines.join(lineSep || this.lineSeparator());
	      }
	    },
	    getSelections: function getSelections(lineSep) {
	      var this$1 = this;
	
	      var parts = [],
	          ranges = this.sel.ranges;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
	        if (lineSep !== false) {
	          sel = sel.join(lineSep || this$1.lineSeparator());
	        }
	        parts[i] = sel;
	      }
	      return parts;
	    },
	    replaceSelection: function replaceSelection(code, collapse, origin) {
	      var dup = [];
	      for (var i = 0; i < this.sel.ranges.length; i++) {
	        dup[i] = code;
	      }
	      this.replaceSelections(dup, collapse, origin || "+input");
	    },
	    replaceSelections: docMethodOp(function (code, collapse, origin) {
	      var this$1 = this;
	
	      var changes = [],
	          sel = this.sel;
	      for (var i = 0; i < sel.ranges.length; i++) {
	        var range$$1 = sel.ranges[i];
	        changes[i] = { from: range$$1.from(), to: range$$1.to(), text: this$1.splitLines(code[i]), origin: origin };
	      }
	      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
	      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--) {
	        makeChange(this$1, changes[i$1]);
	      }
	      if (newSel) {
	        setSelectionReplaceHistory(this, newSel);
	      } else if (this.cm) {
	        ensureCursorVisible(this.cm);
	      }
	    }),
	    undo: docMethodOp(function () {
	      makeChangeFromHistory(this, "undo");
	    }),
	    redo: docMethodOp(function () {
	      makeChangeFromHistory(this, "redo");
	    }),
	    undoSelection: docMethodOp(function () {
	      makeChangeFromHistory(this, "undo", true);
	    }),
	    redoSelection: docMethodOp(function () {
	      makeChangeFromHistory(this, "redo", true);
	    }),
	
	    setExtending: function setExtending(val) {
	      this.extend = val;
	    },
	    getExtending: function getExtending() {
	      return this.extend;
	    },
	
	    historySize: function historySize() {
	      var hist = this.history,
	          done = 0,
	          undone = 0;
	      for (var i = 0; i < hist.done.length; i++) {
	        if (!hist.done[i].ranges) {
	          ++done;
	        }
	      }
	      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) {
	        if (!hist.undone[i$1].ranges) {
	          ++undone;
	        }
	      }
	      return { undo: done, redo: undone };
	    },
	    clearHistory: function clearHistory() {
	      this.history = new History(this.history.maxGeneration);
	    },
	
	    markClean: function markClean() {
	      this.cleanGeneration = this.changeGeneration(true);
	    },
	    changeGeneration: function changeGeneration(forceSplit) {
	      if (forceSplit) {
	        this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
	      }
	      return this.history.generation;
	    },
	    isClean: function isClean(gen) {
	      return this.history.generation == (gen || this.cleanGeneration);
	    },
	
	    getHistory: function getHistory() {
	      return { done: copyHistoryArray(this.history.done),
	        undone: copyHistoryArray(this.history.undone) };
	    },
	    setHistory: function setHistory(histData) {
	      var hist = this.history = new History(this.history.maxGeneration);
	      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
	      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
	    },
	
	    setGutterMarker: docMethodOp(function (line, gutterID, value) {
	      return changeLine(this, line, "gutter", function (line) {
	        var markers = line.gutterMarkers || (line.gutterMarkers = {});
	        markers[gutterID] = value;
	        if (!value && isEmpty(markers)) {
	          line.gutterMarkers = null;
	        }
	        return true;
	      });
	    }),
	
	    clearGutter: docMethodOp(function (gutterID) {
	      var this$1 = this;
	
	      this.iter(function (line) {
	        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	          changeLine(this$1, line, "gutter", function () {
	            line.gutterMarkers[gutterID] = null;
	            if (isEmpty(line.gutterMarkers)) {
	              line.gutterMarkers = null;
	            }
	            return true;
	          });
	        }
	      });
	    }),
	
	    lineInfo: function lineInfo(line) {
	      var n;
	      if (typeof line == "number") {
	        if (!isLine(this, line)) {
	          return null;
	        }
	        n = line;
	        line = getLine(this, line);
	        if (!line) {
	          return null;
	        }
	      } else {
	        n = lineNo(line);
	        if (n == null) {
	          return null;
	        }
	      }
	      return { line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	        textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	        widgets: line.widgets };
	    },
	
	    addLineClass: docMethodOp(function (handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
	        if (!line[prop]) {
	          line[prop] = cls;
	        } else if (classTest(cls).test(line[prop])) {
	          return false;
	        } else {
	          line[prop] += " " + cls;
	        }
	        return true;
	      });
	    }),
	    removeLineClass: docMethodOp(function (handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
	        var cur = line[prop];
	        if (!cur) {
	          return false;
	        } else if (cls == null) {
	          line[prop] = null;
	        } else {
	          var found = cur.match(classTest(cls));
	          if (!found) {
	            return false;
	          }
	          var end = found.index + found[0].length;
	          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
	        }
	        return true;
	      });
	    }),
	
	    addLineWidget: docMethodOp(function (handle, node, options) {
	      return addLineWidget(this, handle, node, options);
	    }),
	    removeLineWidget: function removeLineWidget(widget) {
	      widget.clear();
	    },
	
	    markText: function markText(from, to, options) {
	      return _markText(this, _clipPos(this, from), _clipPos(this, to), options, options && options.type || "range");
	    },
	    setBookmark: function setBookmark(pos, options) {
	      var realOpts = { replacedWith: options && (options.nodeType == null ? options.widget : options),
	        insertLeft: options && options.insertLeft,
	        clearWhenEmpty: false, shared: options && options.shared,
	        handleMouseEvents: options && options.handleMouseEvents };
	      pos = _clipPos(this, pos);
	      return _markText(this, pos, pos, realOpts, "bookmark");
	    },
	    findMarksAt: function findMarksAt(pos) {
	      pos = _clipPos(this, pos);
	      var markers = [],
	          spans = getLine(this, pos.line).markedSpans;
	      if (spans) {
	        for (var i = 0; i < spans.length; ++i) {
	          var span = spans[i];
	          if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) {
	            markers.push(span.marker.parent || span.marker);
	          }
	        }
	      }
	      return markers;
	    },
	    findMarks: function findMarks(from, to, filter) {
	      from = _clipPos(this, from);to = _clipPos(this, to);
	      var found = [],
	          lineNo$$1 = from.line;
	      this.iter(from.line, to.line + 1, function (line) {
	        var spans = line.markedSpans;
	        if (spans) {
	          for (var i = 0; i < spans.length; i++) {
	            var span = spans[i];
	            if (!(span.to != null && lineNo$$1 == from.line && from.ch >= span.to || span.from == null && lineNo$$1 != from.line || span.from != null && lineNo$$1 == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) {
	              found.push(span.marker.parent || span.marker);
	            }
	          }
	        }
	        ++lineNo$$1;
	      });
	      return found;
	    },
	    getAllMarks: function getAllMarks() {
	      var markers = [];
	      this.iter(function (line) {
	        var sps = line.markedSpans;
	        if (sps) {
	          for (var i = 0; i < sps.length; ++i) {
	            if (sps[i].from != null) {
	              markers.push(sps[i].marker);
	            }
	          }
	        }
	      });
	      return markers;
	    },
	
	    posFromIndex: function posFromIndex(off) {
	      var ch,
	          lineNo$$1 = this.first,
	          sepSize = this.lineSeparator().length;
	      this.iter(function (line) {
	        var sz = line.text.length + sepSize;
	        if (sz > off) {
	          ch = off;return true;
	        }
	        off -= sz;
	        ++lineNo$$1;
	      });
	      return _clipPos(this, Pos(lineNo$$1, ch));
	    },
	    indexFromPos: function indexFromPos(coords) {
	      coords = _clipPos(this, coords);
	      var index = coords.ch;
	      if (coords.line < this.first || coords.ch < 0) {
	        return 0;
	      }
	      var sepSize = this.lineSeparator().length;
	      this.iter(this.first, coords.line, function (line) {
	        // iter aborts when callback returns a truthy value
	        index += line.text.length + sepSize;
	      });
	      return index;
	    },
	
	    copy: function copy(copyHistory) {
	      var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
	      doc.scrollTop = this.scrollTop;doc.scrollLeft = this.scrollLeft;
	      doc.sel = this.sel;
	      doc.extend = false;
	      if (copyHistory) {
	        doc.history.undoDepth = this.history.undoDepth;
	        doc.setHistory(this.getHistory());
	      }
	      return doc;
	    },
	
	    linkedDoc: function linkedDoc(options) {
	      if (!options) {
	        options = {};
	      }
	      var from = this.first,
	          to = this.first + this.size;
	      if (options.from != null && options.from > from) {
	        from = options.from;
	      }
	      if (options.to != null && options.to < to) {
	        to = options.to;
	      }
	      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
	      if (options.sharedHist) {
	        copy.history = this.history;
	      }(this.linked || (this.linked = [])).push({ doc: copy, sharedHist: options.sharedHist });
	      copy.linked = [{ doc: this, isParent: true, sharedHist: options.sharedHist }];
	      copySharedMarkers(copy, findSharedMarkers(this));
	      return copy;
	    },
	    unlinkDoc: function unlinkDoc(other) {
	      var this$1 = this;
	
	      if (other instanceof CodeMirror$1) {
	        other = other.doc;
	      }
	      if (this.linked) {
	        for (var i = 0; i < this.linked.length; ++i) {
	          var link = this$1.linked[i];
	          if (link.doc != other) {
	            continue;
	          }
	          this$1.linked.splice(i, 1);
	          other.unlinkDoc(this$1);
	          detachSharedMarkers(findSharedMarkers(this$1));
	          break;
	        }
	      }
	      // If the histories were shared, split them again
	      if (other.history == this.history) {
	        var splitIds = [other.id];
	        linkedDocs(other, function (doc) {
	          return splitIds.push(doc.id);
	        }, true);
	        other.history = new History(null);
	        other.history.done = copyHistoryArray(this.history.done, splitIds);
	        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
	      }
	    },
	    iterLinkedDocs: function iterLinkedDocs(f) {
	      linkedDocs(this, f);
	    },
	
	    getMode: function getMode() {
	      return this.mode;
	    },
	    getEditor: function getEditor() {
	      return this.cm;
	    },
	
	    splitLines: function splitLines(str) {
	      if (this.lineSep) {
	        return str.split(this.lineSep);
	      }
	      return splitLinesAuto(str);
	    },
	    lineSeparator: function lineSeparator() {
	      return this.lineSep || "\n";
	    },
	
	    setDirection: docMethodOp(function (dir) {
	      if (dir != "rtl") {
	        dir = "ltr";
	      }
	      if (dir == this.direction) {
	        return;
	      }
	      this.direction = dir;
	      this.iter(function (line) {
	        return line.order = null;
	      });
	      if (this.cm) {
	        directionChanged(this.cm);
	      }
	    })
	  });
	
	  // Public alias.
	  Doc.prototype.eachLine = Doc.prototype.iter;
	
	  // Kludge to work around strange IE behavior where it'll sometimes
	  // re-fire a series of drag-related events right after the drop (#1551)
	  var lastDrop = 0;
	
	  function onDrop(e) {
	    var cm = this;
	    clearDragCursor(cm);
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
	      return;
	    }
	    e_preventDefault(e);
	    if (ie) {
	      lastDrop = +new Date();
	    }
	    var pos = posFromMouse(cm, e, true),
	        files = e.dataTransfer.files;
	    if (!pos || cm.isReadOnly()) {
	      return;
	    }
	    // Might be a file drop, in which case we simply extract the text
	    // and insert it.
	    if (files && files.length && window.FileReader && window.File) {
	      var n = files.length,
	          text = Array(n),
	          read = 0;
	      var loadFile = function loadFile(file, i) {
	        if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
	          return;
	        }
	
	        var reader = new FileReader();
	        reader.onload = operation(cm, function () {
	          var content = reader.result;
	          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
	            content = "";
	          }
	          text[i] = content;
	          if (++read == n) {
	            pos = _clipPos(cm.doc, pos);
	            var change = { from: pos, to: pos,
	              text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
	              origin: "paste" };
	            makeChange(cm.doc, change);
	            setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)));
	          }
	        });
	        reader.readAsText(file);
	      };
	      for (var i = 0; i < n; ++i) {
	        loadFile(files[i], i);
	      }
	    } else {
	      // Normal drop
	      // Don't do a replace if the drop happened inside of the selected text.
	      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	        cm.state.draggingText(e);
	        // Ensure the editor is re-focused
	        setTimeout(function () {
	          return cm.display.input.focus();
	        }, 20);
	        return;
	      }
	      try {
	        var text$1 = e.dataTransfer.getData("Text");
	        if (text$1) {
	          var selected;
	          if (cm.state.draggingText && !cm.state.draggingText.copy) {
	            selected = cm.listSelections();
	          }
	          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
	          if (selected) {
	            for (var i$1 = 0; i$1 < selected.length; ++i$1) {
	              _replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
	            }
	          }
	          cm.replaceSelection(text$1, "around", "paste");
	          cm.display.input.focus();
	        }
	      } catch (e) {}
	    }
	  }
	
	  function onDragStart(cm, e) {
	    if (ie && (!cm.state.draggingText || +new Date() - lastDrop < 100)) {
	      e_stop(e);return;
	    }
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
	      return;
	    }
	
	    e.dataTransfer.setData("Text", cm.getSelection());
	    e.dataTransfer.effectAllowed = "copyMove";
	
	    // Use dummy image instead of default browsers image.
	    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	    if (e.dataTransfer.setDragImage && !safari) {
	      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
	      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	      if (presto) {
	        img.width = img.height = 1;
	        cm.display.wrapper.appendChild(img);
	        // Force a relayout, or Opera won't use our image for some obscure reason
	        img._top = img.offsetTop;
	      }
	      e.dataTransfer.setDragImage(img, 0, 0);
	      if (presto) {
	        img.parentNode.removeChild(img);
	      }
	    }
	  }
	
	  function onDragOver(cm, e) {
	    var pos = posFromMouse(cm, e);
	    if (!pos) {
	      return;
	    }
	    var frag = document.createDocumentFragment();
	    drawSelectionCursor(cm, pos, frag);
	    if (!cm.display.dragCursor) {
	      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
	      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
	    }
	    removeChildrenAndAdd(cm.display.dragCursor, frag);
	  }
	
	  function clearDragCursor(cm) {
	    if (cm.display.dragCursor) {
	      cm.display.lineSpace.removeChild(cm.display.dragCursor);
	      cm.display.dragCursor = null;
	    }
	  }
	
	  // These must be handled carefully, because naively registering a
	  // handler for each editor will cause the editors to never be
	  // garbage collected.
	
	  function forEachCodeMirror(f) {
	    if (!document.getElementsByClassName) {
	      return;
	    }
	    var byClass = document.getElementsByClassName("CodeMirror");
	    for (var i = 0; i < byClass.length; i++) {
	      var cm = byClass[i].CodeMirror;
	      if (cm) {
	        f(cm);
	      }
	    }
	  }
	
	  var globalsRegistered = false;
	  function ensureGlobalHandlers() {
	    if (globalsRegistered) {
	      return;
	    }
	    registerGlobalHandlers();
	    globalsRegistered = true;
	  }
	  function registerGlobalHandlers() {
	    // When the window resizes, we need to refresh active editors.
	    var resizeTimer;
	    on(window, "resize", function () {
	      if (resizeTimer == null) {
	        resizeTimer = setTimeout(function () {
	          resizeTimer = null;
	          forEachCodeMirror(onResize);
	        }, 100);
	      }
	    });
	    // When the window loses focus, we want to show the editor as blurred
	    on(window, "blur", function () {
	      return forEachCodeMirror(onBlur);
	    });
	  }
	  // Called when the window resizes
	  function onResize(cm) {
	    var d = cm.display;
	    if (d.lastWrapHeight == d.wrapper.clientHeight && d.lastWrapWidth == d.wrapper.clientWidth) {
	      return;
	    }
	    // Might be a text scaling operation, clear size caches.
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	    d.scrollbarsClipped = false;
	    cm.setSize();
	  }
	
	  var keyNames = {
	    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 127: "Delete", 145: "ScrollLock",
	    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	    221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	  };
	
	  // Number keys
	  for (var i = 0; i < 10; i++) {
	    keyNames[i + 48] = keyNames[i + 96] = String(i);
	  }
	  // Alphabetic keys
	  for (var i$1 = 65; i$1 <= 90; i$1++) {
	    keyNames[i$1] = String.fromCharCode(i$1);
	  }
	  // Function keys
	  for (var i$2 = 1; i$2 <= 12; i$2++) {
	    keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
	  }
	
	  var keyMap = {};
	
	  keyMap.basic = {
	    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	    "Esc": "singleSelection"
	  };
	  // Note that the save and find-related commands aren't defined by
	  // default. User code or addons can define them. Unknown commands
	  // are simply ignored.
	  keyMap.pcDefault = {
	    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	    fallthrough: "basic"
	  };
	  // Very basic readline/emacs-style bindings, which are standard on Mac.
	  keyMap.emacsy = {
	    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	    "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
	    "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
	    "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
	    "Ctrl-O": "openLine"
	  };
	  keyMap.macDefault = {
	    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	    fallthrough: ["basic", "emacsy"]
	  };
	  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
	
	  // KEYMAP DISPATCH
	
	  function normalizeKeyName(name) {
	    var parts = name.split(/-(?!$)/);
	    name = parts[parts.length - 1];
	    var alt, ctrl, shift, cmd;
	    for (var i = 0; i < parts.length - 1; i++) {
	      var mod = parts[i];
	      if (/^(cmd|meta|m)$/i.test(mod)) {
	        cmd = true;
	      } else if (/^a(lt)?$/i.test(mod)) {
	        alt = true;
	      } else if (/^(c|ctrl|control)$/i.test(mod)) {
	        ctrl = true;
	      } else if (/^s(hift)?$/i.test(mod)) {
	        shift = true;
	      } else {
	        throw new Error("Unrecognized modifier name: " + mod);
	      }
	    }
	    if (alt) {
	      name = "Alt-" + name;
	    }
	    if (ctrl) {
	      name = "Ctrl-" + name;
	    }
	    if (cmd) {
	      name = "Cmd-" + name;
	    }
	    if (shift) {
	      name = "Shift-" + name;
	    }
	    return name;
	  }
	
	  // This is a kludge to keep keymaps mostly working as raw objects
	  // (backwards compatibility) while at the same time support features
	  // like normalization and multi-stroke key bindings. It compiles a
	  // new normalized keymap, and then updates the old object to reflect
	  // this.
	  function normalizeKeyMap(keymap) {
	    var copy = {};
	    for (var keyname in keymap) {
	      if (keymap.hasOwnProperty(keyname)) {
	        var value = keymap[keyname];
	        if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) {
	          continue;
	        }
	        if (value == "...") {
	          delete keymap[keyname];continue;
	        }
	
	        var keys = map(keyname.split(" "), normalizeKeyName);
	        for (var i = 0; i < keys.length; i++) {
	          var val = void 0,
	              name = void 0;
	          if (i == keys.length - 1) {
	            name = keys.join(" ");
	            val = value;
	          } else {
	            name = keys.slice(0, i + 1).join(" ");
	            val = "...";
	          }
	          var prev = copy[name];
	          if (!prev) {
	            copy[name] = val;
	          } else if (prev != val) {
	            throw new Error("Inconsistent bindings for " + name);
	          }
	        }
	        delete keymap[keyname];
	      }
	    }
	    for (var prop in copy) {
	      keymap[prop] = copy[prop];
	    }
	    return keymap;
	  }
	
	  function lookupKey(key, map$$1, handle, context) {
	    map$$1 = getKeyMap(map$$1);
	    var found = map$$1.call ? map$$1.call(key, context) : map$$1[key];
	    if (found === false) {
	      return "nothing";
	    }
	    if (found === "...") {
	      return "multi";
	    }
	    if (found != null && handle(found)) {
	      return "handled";
	    }
	
	    if (map$$1.fallthrough) {
	      if (Object.prototype.toString.call(map$$1.fallthrough) != "[object Array]") {
	        return lookupKey(key, map$$1.fallthrough, handle, context);
	      }
	      for (var i = 0; i < map$$1.fallthrough.length; i++) {
	        var result = lookupKey(key, map$$1.fallthrough[i], handle, context);
	        if (result) {
	          return result;
	        }
	      }
	    }
	  }
	
	  // Modifier key presses don't count as 'real' key presses for the
	  // purpose of keymap fallthrough.
	  function isModifierKey(value) {
	    var name = typeof value == "string" ? value : keyNames[value.keyCode];
	    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
	  }
	
	  function addModifierNames(name, event, noShift) {
	    var base = name;
	    if (event.altKey && base != "Alt") {
	      name = "Alt-" + name;
	    }
	    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") {
	      name = "Ctrl-" + name;
	    }
	    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") {
	      name = "Cmd-" + name;
	    }
	    if (!noShift && event.shiftKey && base != "Shift") {
	      name = "Shift-" + name;
	    }
	    return name;
	  }
	
	  // Look up the name of a key as indicated by an event object.
	  function keyName(event, noShift) {
	    if (presto && event.keyCode == 34 && event["char"]) {
	      return false;
	    }
	    var name = keyNames[event.keyCode];
	    if (name == null || event.altGraphKey) {
	      return false;
	    }
	    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
	    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
	    if (event.keyCode == 3 && event.code) {
	      name = event.code;
	    }
	    return addModifierNames(name, event, noShift);
	  }
	
	  function getKeyMap(val) {
	    return typeof val == "string" ? keyMap[val] : val;
	  }
	
	  // Helper for deleting text near the selection(s), used to implement
	  // backspace, delete, and similar functionality.
	  function deleteNearSelection(cm, compute) {
	    var ranges = cm.doc.sel.ranges,
	        kill = [];
	    // Build up a set of ranges to kill first, merging overlapping
	    // ranges.
	    for (var i = 0; i < ranges.length; i++) {
	      var toKill = compute(ranges[i]);
	      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	        var replaced = kill.pop();
	        if (cmp(replaced.from, toKill.from) < 0) {
	          toKill.from = replaced.from;
	          break;
	        }
	      }
	      kill.push(toKill);
	    }
	    // Next, remove those actual ranges.
	    runInOp(cm, function () {
	      for (var i = kill.length - 1; i >= 0; i--) {
	        _replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
	      }
	      ensureCursorVisible(cm);
	    });
	  }
	
	  function moveCharLogically(line, ch, dir) {
	    var target = skipExtendingChars(line.text, ch + dir, dir);
	    return target < 0 || target > line.text.length ? null : target;
	  }
	
	  function moveLogically(line, start, dir) {
	    var ch = moveCharLogically(line, start.ch, dir);
	    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
	  }
	
	  function endOfLine(visually, cm, lineObj, lineNo, dir) {
	    if (visually) {
	      var order = getOrder(lineObj, cm.doc.direction);
	      if (order) {
	        var part = dir < 0 ? lst(order) : order[0];
	        var moveInStorageOrder = dir < 0 == (part.level == 1);
	        var sticky = moveInStorageOrder ? "after" : "before";
	        var ch;
	        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
	        // it could be that the last bidi part is not on the last visual line,
	        // since visual lines contain content order-consecutive chunks.
	        // Thus, in rtl, we are looking for the first (content-order) character
	        // in the rtl chunk that is on the last line (that is, the same line
	        // as the last (content-order) character).
	        if (part.level > 0 || cm.doc.direction == "rtl") {
	          var prep = prepareMeasureForLine(cm, lineObj);
	          ch = dir < 0 ? lineObj.text.length - 1 : 0;
	          var targetTop = measureCharPrepared(cm, prep, ch).top;
	          ch = findFirst(function (ch) {
	            return measureCharPrepared(cm, prep, ch).top == targetTop;
	          }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
	          if (sticky == "before") {
	            ch = moveCharLogically(lineObj, ch, 1);
	          }
	        } else {
	          ch = dir < 0 ? part.to : part.from;
	        }
	        return new Pos(lineNo, ch, sticky);
	      }
	    }
	    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
	  }
	
	  function moveVisually(cm, line, start, dir) {
	    var bidi = getOrder(line, cm.doc.direction);
	    if (!bidi) {
	      return moveLogically(line, start, dir);
	    }
	    if (start.ch >= line.text.length) {
	      start.ch = line.text.length;
	      start.sticky = "before";
	    } else if (start.ch <= 0) {
	      start.ch = 0;
	      start.sticky = "after";
	    }
	    var partPos = getBidiPartAt(bidi, start.ch, start.sticky),
	        part = bidi[partPos];
	    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
	      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
	      // nothing interesting happens.
	      return moveLogically(line, start, dir);
	    }
	
	    var mv = function mv(pos, dir) {
	      return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir);
	    };
	    var prep;
	    var getWrappedLineExtent = function getWrappedLineExtent(ch) {
	      if (!cm.options.lineWrapping) {
	        return { begin: 0, end: line.text.length };
	      }
	      prep = prep || prepareMeasureForLine(cm, line);
	      return wrappedLineExtentChar(cm, line, prep, ch);
	    };
	    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
	
	    if (cm.doc.direction == "rtl" || part.level == 1) {
	      var moveInStorageOrder = part.level == 1 == dir < 0;
	      var ch = mv(start, moveInStorageOrder ? 1 : -1);
	      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
	        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
	        var sticky = moveInStorageOrder ? "before" : "after";
	        return new Pos(start.line, ch, sticky);
	      }
	    }
	
	    // Case 3: Could not move within this bidi part in this visual line, so leave
	    // the current bidi part
	
	    var searchInVisualLine = function searchInVisualLine(partPos, dir, wrappedLineExtent) {
	      var getRes = function getRes(ch, moveInStorageOrder) {
	        return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
	      };
	
	      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
	        var part = bidi[partPos];
	        var moveInStorageOrder = dir > 0 == (part.level != 1);
	        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
	        if (part.from <= ch && ch < part.to) {
	          return getRes(ch, moveInStorageOrder);
	        }
	        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
	        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) {
	          return getRes(ch, moveInStorageOrder);
	        }
	      }
	    };
	
	    // Case 3a: Look for other bidi parts on the same visual line
	    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
	    if (res) {
	      return res;
	    }
	
	    // Case 3b: Look for other bidi parts on the next visual line
	    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
	    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
	      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
	      if (res) {
	        return res;
	      }
	    }
	
	    // Case 4: Nowhere to move
	    return null;
	  }
	
	  // Commands are parameter-less actions that can be performed on an
	  // editor, mostly used for keybindings.
	  var commands = {
	    selectAll: selectAll,
	    singleSelection: function singleSelection(cm) {
	      return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
	    },
	    killLine: function killLine(cm) {
	      return deleteNearSelection(cm, function (range) {
	        if (range.empty()) {
	          var len = getLine(cm.doc, range.head.line).text.length;
	          if (range.head.ch == len && range.head.line < cm.lastLine()) {
	            return { from: range.head, to: Pos(range.head.line + 1, 0) };
	          } else {
	            return { from: range.head, to: Pos(range.head.line, len) };
	          }
	        } else {
	          return { from: range.from(), to: range.to() };
	        }
	      });
	    },
	    deleteLine: function deleteLine(cm) {
	      return deleteNearSelection(cm, function (range) {
	        return {
	          from: Pos(range.from().line, 0),
	          to: _clipPos(cm.doc, Pos(range.to().line + 1, 0))
	        };
	      });
	    },
	    delLineLeft: function delLineLeft(cm) {
	      return deleteNearSelection(cm, function (range) {
	        return {
	          from: Pos(range.from().line, 0), to: range.from()
	        };
	      });
	    },
	    delWrappedLineLeft: function delWrappedLineLeft(cm) {
	      return deleteNearSelection(cm, function (range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var leftPos = cm.coordsChar({ left: 0, top: top }, "div");
	        return { from: leftPos, to: range.from() };
	      });
	    },
	    delWrappedLineRight: function delWrappedLineRight(cm) {
	      return deleteNearSelection(cm, function (range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var rightPos = cm.coordsChar({ left: cm.display.lineDiv.offsetWidth + 100, top: top }, "div");
	        return { from: range.from(), to: rightPos };
	      });
	    },
	    undo: function undo(cm) {
	      return cm.undo();
	    },
	    redo: function redo(cm) {
	      return cm.redo();
	    },
	    undoSelection: function undoSelection(cm) {
	      return cm.undoSelection();
	    },
	    redoSelection: function redoSelection(cm) {
	      return cm.redoSelection();
	    },
	    goDocStart: function goDocStart(cm) {
	      return cm.extendSelection(Pos(cm.firstLine(), 0));
	    },
	    goDocEnd: function goDocEnd(cm) {
	      return cm.extendSelection(Pos(cm.lastLine()));
	    },
	    goLineStart: function goLineStart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineStart(cm, range.head.line);
	      }, { origin: "+move", bias: 1 });
	    },
	    goLineStartSmart: function goLineStartSmart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineStartSmart(cm, range.head);
	      }, { origin: "+move", bias: 1 });
	    },
	    goLineEnd: function goLineEnd(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineEnd(cm, range.head.line);
	      }, { origin: "+move", bias: -1 });
	    },
	    goLineRight: function goLineRight(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        return cm.coordsChar({ left: cm.display.lineDiv.offsetWidth + 100, top: top }, "div");
	      }, sel_move);
	    },
	    goLineLeft: function goLineLeft(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        return cm.coordsChar({ left: 0, top: top }, "div");
	      }, sel_move);
	    },
	    goLineLeftSmart: function goLineLeftSmart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        var pos = cm.coordsChar({ left: 0, top: top }, "div");
	        if (pos.ch < cm.getLine(pos.line).search(/\S/)) {
	          return lineStartSmart(cm, range.head);
	        }
	        return pos;
	      }, sel_move);
	    },
	    goLineUp: function goLineUp(cm) {
	      return cm.moveV(-1, "line");
	    },
	    goLineDown: function goLineDown(cm) {
	      return cm.moveV(1, "line");
	    },
	    goPageUp: function goPageUp(cm) {
	      return cm.moveV(-1, "page");
	    },
	    goPageDown: function goPageDown(cm) {
	      return cm.moveV(1, "page");
	    },
	    goCharLeft: function goCharLeft(cm) {
	      return cm.moveH(-1, "char");
	    },
	    goCharRight: function goCharRight(cm) {
	      return cm.moveH(1, "char");
	    },
	    goColumnLeft: function goColumnLeft(cm) {
	      return cm.moveH(-1, "column");
	    },
	    goColumnRight: function goColumnRight(cm) {
	      return cm.moveH(1, "column");
	    },
	    goWordLeft: function goWordLeft(cm) {
	      return cm.moveH(-1, "word");
	    },
	    goGroupRight: function goGroupRight(cm) {
	      return cm.moveH(1, "group");
	    },
	    goGroupLeft: function goGroupLeft(cm) {
	      return cm.moveH(-1, "group");
	    },
	    goWordRight: function goWordRight(cm) {
	      return cm.moveH(1, "word");
	    },
	    delCharBefore: function delCharBefore(cm) {
	      return cm.deleteH(-1, "char");
	    },
	    delCharAfter: function delCharAfter(cm) {
	      return cm.deleteH(1, "char");
	    },
	    delWordBefore: function delWordBefore(cm) {
	      return cm.deleteH(-1, "word");
	    },
	    delWordAfter: function delWordAfter(cm) {
	      return cm.deleteH(1, "word");
	    },
	    delGroupBefore: function delGroupBefore(cm) {
	      return cm.deleteH(-1, "group");
	    },
	    delGroupAfter: function delGroupAfter(cm) {
	      return cm.deleteH(1, "group");
	    },
	    indentAuto: function indentAuto(cm) {
	      return cm.indentSelection("smart");
	    },
	    indentMore: function indentMore(cm) {
	      return cm.indentSelection("add");
	    },
	    indentLess: function indentLess(cm) {
	      return cm.indentSelection("subtract");
	    },
	    insertTab: function insertTab(cm) {
	      return cm.replaceSelection("\t");
	    },
	    insertSoftTab: function insertSoftTab(cm) {
	      var spaces = [],
	          ranges = cm.listSelections(),
	          tabSize = cm.options.tabSize;
	      for (var i = 0; i < ranges.length; i++) {
	        var pos = ranges[i].from();
	        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
	        spaces.push(spaceStr(tabSize - col % tabSize));
	      }
	      cm.replaceSelections(spaces);
	    },
	    defaultTab: function defaultTab(cm) {
	      if (cm.somethingSelected()) {
	        cm.indentSelection("add");
	      } else {
	        cm.execCommand("insertTab");
	      }
	    },
	    // Swap the two chars left and right of each selection's head.
	    // Move cursor behind the two swapped characters afterwards.
	    //
	    // Doesn't consider line feeds a character.
	    // Doesn't scan more than one line above to find a character.
	    // Doesn't do anything on an empty line.
	    // Doesn't do anything with non-empty selections.
	    transposeChars: function transposeChars(cm) {
	      return runInOp(cm, function () {
	        var ranges = cm.listSelections(),
	            newSel = [];
	        for (var i = 0; i < ranges.length; i++) {
	          if (!ranges[i].empty()) {
	            continue;
	          }
	          var cur = ranges[i].head,
	              line = getLine(cm.doc, cur.line).text;
	          if (line) {
	            if (cur.ch == line.length) {
	              cur = new Pos(cur.line, cur.ch - 1);
	            }
	            if (cur.ch > 0) {
	              cur = new Pos(cur.line, cur.ch + 1);
	              cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
	            } else if (cur.line > cm.doc.first) {
	              var prev = getLine(cm.doc, cur.line - 1).text;
	              if (prev) {
	                cur = new Pos(cur.line, 1);
	                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
	              }
	            }
	          }
	          newSel.push(new Range(cur, cur));
	        }
	        cm.setSelections(newSel);
	      });
	    },
	    newlineAndIndent: function newlineAndIndent(cm) {
	      return runInOp(cm, function () {
	        var sels = cm.listSelections();
	        for (var i = sels.length - 1; i >= 0; i--) {
	          cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
	        }
	        sels = cm.listSelections();
	        for (var i$1 = 0; i$1 < sels.length; i$1++) {
	          cm.indentLine(sels[i$1].from().line, null, true);
	        }
	        ensureCursorVisible(cm);
	      });
	    },
	    openLine: function openLine(cm) {
	      return cm.replaceSelection("\n", "start");
	    },
	    toggleOverwrite: function toggleOverwrite(cm) {
	      return cm.toggleOverwrite();
	    }
	  };
	
	  function lineStart(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLine(line);
	    if (visual != line) {
	      lineN = lineNo(visual);
	    }
	    return endOfLine(true, cm, visual, lineN, 1);
	  }
	  function lineEnd(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLineEnd(line);
	    if (visual != line) {
	      lineN = lineNo(visual);
	    }
	    return endOfLine(true, cm, line, lineN, -1);
	  }
	  function lineStartSmart(cm, pos) {
	    var start = lineStart(cm, pos.line);
	    var line = getLine(cm.doc, start.line);
	    var order = getOrder(line, cm.doc.direction);
	    if (!order || order[0].level == 0) {
	      var firstNonWS = Math.max(0, line.text.search(/\S/));
	      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
	      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
	    }
	    return start;
	  }
	
	  // Run a handler that was bound to a key.
	  function doHandleBinding(cm, bound, dropShift) {
	    if (typeof bound == "string") {
	      bound = commands[bound];
	      if (!bound) {
	        return false;
	      }
	    }
	    // Ensure previous input has been read, so that the handler sees a
	    // consistent view of the document
	    cm.display.input.ensurePolled();
	    var prevShift = cm.display.shift,
	        done = false;
	    try {
	      if (cm.isReadOnly()) {
	        cm.state.suppressEdits = true;
	      }
	      if (dropShift) {
	        cm.display.shift = false;
	      }
	      done = bound(cm) != Pass;
	    } finally {
	      cm.display.shift = prevShift;
	      cm.state.suppressEdits = false;
	    }
	    return done;
	  }
	
	  function lookupKeyForEditor(cm, name, handle) {
	    for (var i = 0; i < cm.state.keyMaps.length; i++) {
	      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
	      if (result) {
	        return result;
	      }
	    }
	    return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
	  }
	
	  // Note that, despite the name, this function is also used to check
	  // for bound mouse clicks.
	
	  var stopSeq = new Delayed();
	
	  function dispatchKey(cm, name, e, handle) {
	    var seq = cm.state.keySeq;
	    if (seq) {
	      if (isModifierKey(name)) {
	        return "handled";
	      }
	      if (/\'$/.test(name)) {
	        cm.state.keySeq = null;
	      } else {
	        stopSeq.set(50, function () {
	          if (cm.state.keySeq == seq) {
	            cm.state.keySeq = null;
	            cm.display.input.reset();
	          }
	        });
	      }
	      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) {
	        return true;
	      }
	    }
	    return dispatchKeyInner(cm, name, e, handle);
	  }
	
	  function dispatchKeyInner(cm, name, e, handle) {
	    var result = lookupKeyForEditor(cm, name, handle);
	
	    if (result == "multi") {
	      cm.state.keySeq = name;
	    }
	    if (result == "handled") {
	      signalLater(cm, "keyHandled", cm, name, e);
	    }
	
	    if (result == "handled" || result == "multi") {
	      e_preventDefault(e);
	      restartBlink(cm);
	    }
	
	    return !!result;
	  }
	
	  // Handle a key from the keydown event.
	  function handleKeyBinding(cm, e) {
	    var name = keyName(e, true);
	    if (!name) {
	      return false;
	    }
	
	    if (e.shiftKey && !cm.state.keySeq) {
	      // First try to resolve full name (including 'Shift-'). Failing
	      // that, see if there is a cursor-motion command (starting with
	      // 'go') bound to the keyname without 'Shift-'.
	      return dispatchKey(cm, "Shift-" + name, e, function (b) {
	        return doHandleBinding(cm, b, true);
	      }) || dispatchKey(cm, name, e, function (b) {
	        if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) {
	          return doHandleBinding(cm, b);
	        }
	      });
	    } else {
	      return dispatchKey(cm, name, e, function (b) {
	        return doHandleBinding(cm, b);
	      });
	    }
	  }
	
	  // Handle a key from the keypress event
	  function handleCharBinding(cm, e, ch) {
	    return dispatchKey(cm, "'" + ch + "'", e, function (b) {
	      return doHandleBinding(cm, b, true);
	    });
	  }
	
	  var lastStoppedKey = null;
	  function onKeyDown(e) {
	    var cm = this;
	    cm.curOp.focus = activeElt();
	    if (signalDOMEvent(cm, e)) {
	      return;
	    }
	    // IE does strange things with escape.
	    if (ie && ie_version < 11 && e.keyCode == 27) {
	      e.returnValue = false;
	    }
	    var code = e.keyCode;
	    cm.display.shift = code == 16 || e.shiftKey;
	    var handled = handleKeyBinding(cm, e);
	    if (presto) {
	      lastStoppedKey = handled ? code : null;
	      // Opera has no cut event... we try to at least catch the key combo
	      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) {
	        cm.replaceSelection("", null, "cut");
	      }
	    }
	
	    // Turn mouse into crosshair when Alt is held on Mac.
	    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) {
	      showCrossHair(cm);
	    }
	  }
	
	  function showCrossHair(cm) {
	    var lineDiv = cm.display.lineDiv;
	    addClass(lineDiv, "CodeMirror-crosshair");
	
	    function up(e) {
	      if (e.keyCode == 18 || !e.altKey) {
	        rmClass(lineDiv, "CodeMirror-crosshair");
	        off(document, "keyup", up);
	        off(document, "mouseover", up);
	      }
	    }
	    on(document, "keyup", up);
	    on(document, "mouseover", up);
	  }
	
	  function onKeyUp(e) {
	    if (e.keyCode == 16) {
	      this.doc.sel.shift = false;
	    }
	    signalDOMEvent(this, e);
	  }
	
	  function onKeyPress(e) {
	    var cm = this;
	    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) {
	      return;
	    }
	    var keyCode = e.keyCode,
	        charCode = e.charCode;
	    if (presto && keyCode == lastStoppedKey) {
	      lastStoppedKey = null;e_preventDefault(e);return;
	    }
	    if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) {
	      return;
	    }
	    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
	    // Some browsers fire keypress events for backspace
	    if (ch == "\x08") {
	      return;
	    }
	    if (handleCharBinding(cm, e, ch)) {
	      return;
	    }
	    cm.display.input.onKeyPress(e);
	  }
	
	  var DOUBLECLICK_DELAY = 400;
	
	  var PastClick = function PastClick(time, pos, button) {
	    this.time = time;
	    this.pos = pos;
	    this.button = button;
	  };
	
	  PastClick.prototype.compare = function (time, pos, button) {
	    return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
	  };
	
	  var lastClick;
	  var lastDoubleClick;
	  function clickRepeat(pos, button) {
	    var now = +new Date();
	    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
	      lastClick = lastDoubleClick = null;
	      return "triple";
	    } else if (lastClick && lastClick.compare(now, pos, button)) {
	      lastDoubleClick = new PastClick(now, pos, button);
	      lastClick = null;
	      return "double";
	    } else {
	      lastClick = new PastClick(now, pos, button);
	      lastDoubleClick = null;
	      return "single";
	    }
	  }
	
	  // A mouse down can be a single click, double click, triple click,
	  // start of selection drag, start of text drag, new cursor
	  // (ctrl-click), rectangle drag (alt-drag), or xwin
	  // middle-click-paste. Or it might be a click on something we should
	  // not interfere with, such as a scrollbar or widget.
	  function onMouseDown(e) {
	    var cm = this,
	        display = cm.display;
	    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) {
	      return;
	    }
	    display.input.ensurePolled();
	    display.shift = e.shiftKey;
	
	    if (eventInWidget(display, e)) {
	      if (!webkit) {
	        // Briefly turn off draggability, to allow widgets to do
	        // normal dragging things.
	        display.scroller.draggable = false;
	        setTimeout(function () {
	          return display.scroller.draggable = true;
	        }, 100);
	      }
	      return;
	    }
	    if (clickInGutter(cm, e)) {
	      return;
	    }
	    var pos = posFromMouse(cm, e),
	        button = e_button(e),
	        repeat = pos ? clickRepeat(pos, button) : "single";
	    window.focus();
	
	    // #3261: make sure, that we're not starting a second selection
	    if (button == 1 && cm.state.selectingText) {
	      cm.state.selectingText(e);
	    }
	
	    if (pos && handleMappedButton(cm, button, pos, repeat, e)) {
	      return;
	    }
	
	    if (button == 1) {
	      if (pos) {
	        leftButtonDown(cm, pos, repeat, e);
	      } else if (e_target(e) == display.scroller) {
	        e_preventDefault(e);
	      }
	    } else if (button == 2) {
	      if (pos) {
	        extendSelection(cm.doc, pos);
	      }
	      setTimeout(function () {
	        return display.input.focus();
	      }, 20);
	    } else if (button == 3) {
	      if (captureRightClick) {
	        onContextMenu(cm, e);
	      } else {
	        delayBlurEvent(cm);
	      }
	    }
	  }
	
	  function handleMappedButton(cm, button, pos, repeat, event) {
	    var name = "Click";
	    if (repeat == "double") {
	      name = "Double" + name;
	    } else if (repeat == "triple") {
	      name = "Triple" + name;
	    }
	    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
	
	    return dispatchKey(cm, addModifierNames(name, event), event, function (bound) {
	      if (typeof bound == "string") {
	        bound = commands[bound];
	      }
	      if (!bound) {
	        return false;
	      }
	      var done = false;
	      try {
	        if (cm.isReadOnly()) {
	          cm.state.suppressEdits = true;
	        }
	        done = bound(cm, pos) != Pass;
	      } finally {
	        cm.state.suppressEdits = false;
	      }
	      return done;
	    });
	  }
	
	  function configureMouse(cm, repeat, event) {
	    var option = cm.getOption("configureMouse");
	    var value = option ? option(cm, repeat, event) : {};
	    if (value.unit == null) {
	      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
	      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
	    }
	    if (value.extend == null || cm.doc.extend) {
	      value.extend = cm.doc.extend || event.shiftKey;
	    }
	    if (value.addNew == null) {
	      value.addNew = mac ? event.metaKey : event.ctrlKey;
	    }
	    if (value.moveOnDrag == null) {
	      value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
	    }
	    return value;
	  }
	
	  function leftButtonDown(cm, pos, repeat, event) {
	    if (ie) {
	      setTimeout(bind(ensureFocus, cm), 0);
	    } else {
	      cm.curOp.focus = activeElt();
	    }
	
	    var behavior = configureMouse(cm, repeat, event);
	
	    var sel = cm.doc.sel,
	        contained;
	    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) {
	      leftButtonStartDrag(cm, event, pos, behavior);
	    } else {
	      leftButtonSelect(cm, event, pos, behavior);
	    }
	  }
	
	  // Start a text drag. When it ends, see if any dragging actually
	  // happen, and treat as a click if it didn't.
	  function leftButtonStartDrag(cm, event, pos, behavior) {
	    var display = cm.display,
	        moved = false;
	    var dragEnd = operation(cm, function (e) {
	      if (webkit) {
	        display.scroller.draggable = false;
	      }
	      cm.state.draggingText = false;
	      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
	      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
	      off(display.scroller, "dragstart", dragStart);
	      off(display.scroller, "drop", dragEnd);
	      if (!moved) {
	        e_preventDefault(e);
	        if (!behavior.addNew) {
	          extendSelection(cm.doc, pos, null, null, behavior.extend);
	        }
	        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	        if (webkit || ie && ie_version == 9) {
	          setTimeout(function () {
	            display.wrapper.ownerDocument.body.focus();display.input.focus();
	          }, 20);
	        } else {
	          display.input.focus();
	        }
	      }
	    });
	    var mouseMove = function mouseMove(e2) {
	      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
	    };
	    var dragStart = function dragStart() {
	      return moved = true;
	    };
	    // Let the drag handler handle this.
	    if (webkit) {
	      display.scroller.draggable = true;
	    }
	    cm.state.draggingText = dragEnd;
	    dragEnd.copy = !behavior.moveOnDrag;
	    // IE's approach to draggable
	    if (display.scroller.dragDrop) {
	      display.scroller.dragDrop();
	    }
	    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
	    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
	    on(display.scroller, "dragstart", dragStart);
	    on(display.scroller, "drop", dragEnd);
	
	    delayBlurEvent(cm);
	    setTimeout(function () {
	      return display.input.focus();
	    }, 20);
	  }
	
	  function rangeForUnit(cm, pos, unit) {
	    if (unit == "char") {
	      return new Range(pos, pos);
	    }
	    if (unit == "word") {
	      return cm.findWordAt(pos);
	    }
	    if (unit == "line") {
	      return new Range(Pos(pos.line, 0), _clipPos(cm.doc, Pos(pos.line + 1, 0)));
	    }
	    var result = unit(cm, pos);
	    return new Range(result.from, result.to);
	  }
	
	  // Normal selection, as opposed to text dragging.
	  function leftButtonSelect(cm, event, start, behavior) {
	    var display = cm.display,
	        doc = cm.doc;
	    e_preventDefault(event);
	
	    var ourRange,
	        ourIndex,
	        startSel = doc.sel,
	        ranges = startSel.ranges;
	    if (behavior.addNew && !behavior.extend) {
	      ourIndex = doc.sel.contains(start);
	      if (ourIndex > -1) {
	        ourRange = ranges[ourIndex];
	      } else {
	        ourRange = new Range(start, start);
	      }
	    } else {
	      ourRange = doc.sel.primary();
	      ourIndex = doc.sel.primIndex;
	    }
	
	    if (behavior.unit == "rectangle") {
	      if (!behavior.addNew) {
	        ourRange = new Range(start, start);
	      }
	      start = posFromMouse(cm, event, true, true);
	      ourIndex = -1;
	    } else {
	      var range$$1 = rangeForUnit(cm, start, behavior.unit);
	      if (behavior.extend) {
	        ourRange = extendRange(ourRange, range$$1.anchor, range$$1.head, behavior.extend);
	      } else {
	        ourRange = range$$1;
	      }
	    }
	
	    if (!behavior.addNew) {
	      ourIndex = 0;
	      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
	      startSel = doc.sel;
	    } else if (ourIndex == -1) {
	      ourIndex = ranges.length;
	      setSelection(doc, normalizeSelection(ranges.concat([ourRange]), ourIndex), { scroll: false, origin: "*mouse" });
	    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
	      setSelection(doc, normalizeSelection(ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), { scroll: false, origin: "*mouse" });
	      startSel = doc.sel;
	    } else {
	      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
	    }
	
	    var lastPos = start;
	    function extendTo(pos) {
	      if (cmp(lastPos, pos) == 0) {
	        return;
	      }
	      lastPos = pos;
	
	      if (behavior.unit == "rectangle") {
	        var ranges = [],
	            tabSize = cm.options.tabSize;
	        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
	        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
	        var left = Math.min(startCol, posCol),
	            right = Math.max(startCol, posCol);
	        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++) {
	          var text = getLine(doc, line).text,
	              leftPos = findColumn(text, left, tabSize);
	          if (left == right) {
	            ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
	          } else if (text.length > leftPos) {
	            ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
	          }
	        }
	        if (!ranges.length) {
	          ranges.push(new Range(start, start));
	        }
	        setSelection(doc, normalizeSelection(startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), { origin: "*mouse", scroll: false });
	        cm.scrollIntoView(pos);
	      } else {
	        var oldRange = ourRange;
	        var range$$1 = rangeForUnit(cm, pos, behavior.unit);
	        var anchor = oldRange.anchor,
	            head;
	        if (cmp(range$$1.anchor, anchor) > 0) {
	          head = range$$1.head;
	          anchor = minPos(oldRange.from(), range$$1.anchor);
	        } else {
	          head = range$$1.anchor;
	          anchor = maxPos(oldRange.to(), range$$1.head);
	        }
	        var ranges$1 = startSel.ranges.slice(0);
	        ranges$1[ourIndex] = bidiSimplify(cm, new Range(_clipPos(doc, anchor), head));
	        setSelection(doc, normalizeSelection(ranges$1, ourIndex), sel_mouse);
	      }
	    }
	
	    var editorSize = display.wrapper.getBoundingClientRect();
	    // Used to ensure timeout re-tries don't fire when another extend
	    // happened in the meantime (clearTimeout isn't reliable -- at
	    // least on Chrome, the timeouts still happen even when cleared,
	    // if the clear happens after their scheduled firing time).
	    var counter = 0;
	
	    function extend(e) {
	      var curCount = ++counter;
	      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
	      if (!cur) {
	        return;
	      }
	      if (cmp(cur, lastPos) != 0) {
	        cm.curOp.focus = activeElt();
	        extendTo(cur);
	        var visible = visibleLines(display, doc);
	        if (cur.line >= visible.to || cur.line < visible.from) {
	          setTimeout(operation(cm, function () {
	            if (counter == curCount) {
	              extend(e);
	            }
	          }), 150);
	        }
	      } else {
	        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
	        if (outside) {
	          setTimeout(operation(cm, function () {
	            if (counter != curCount) {
	              return;
	            }
	            display.scroller.scrollTop += outside;
	            extend(e);
	          }), 50);
	        }
	      }
	    }
	
	    function done(e) {
	      cm.state.selectingText = false;
	      counter = Infinity;
	      e_preventDefault(e);
	      display.input.focus();
	      off(display.wrapper.ownerDocument, "mousemove", move);
	      off(display.wrapper.ownerDocument, "mouseup", up);
	      doc.history.lastSelOrigin = null;
	    }
	
	    var move = operation(cm, function (e) {
	      if (!e_button(e)) {
	        done(e);
	      } else {
	        extend(e);
	      }
	    });
	    var up = operation(cm, done);
	    cm.state.selectingText = up;
	    on(display.wrapper.ownerDocument, "mousemove", move);
	    on(display.wrapper.ownerDocument, "mouseup", up);
	  }
	
	  // Used when mouse-selecting to adjust the anchor to the proper side
	  // of a bidi jump depending on the visual position of the head.
	  function bidiSimplify(cm, range$$1) {
	    var anchor = range$$1.anchor;
	    var head = range$$1.head;
	    var anchorLine = getLine(cm.doc, anchor.line);
	    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) {
	      return range$$1;
	    }
	    var order = getOrder(anchorLine);
	    if (!order) {
	      return range$$1;
	    }
	    var index = getBidiPartAt(order, anchor.ch, anchor.sticky),
	        part = order[index];
	    if (part.from != anchor.ch && part.to != anchor.ch) {
	      return range$$1;
	    }
	    var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
	    if (boundary == 0 || boundary == order.length) {
	      return range$$1;
	    }
	
	    // Compute the relative visual position of the head compared to the
	    // anchor (<0 is to the left, >0 to the right)
	    var leftSide;
	    if (head.line != anchor.line) {
	      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
	    } else {
	      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
	      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
	      if (headIndex == boundary - 1 || headIndex == boundary) {
	        leftSide = dir < 0;
	      } else {
	        leftSide = dir > 0;
	      }
	    }
	
	    var usePart = order[boundary + (leftSide ? -1 : 0)];
	    var from = leftSide == (usePart.level == 1);
	    var ch = from ? usePart.from : usePart.to,
	        sticky = from ? "after" : "before";
	    return anchor.ch == ch && anchor.sticky == sticky ? range$$1 : new Range(new Pos(anchor.line, ch, sticky), head);
	  }
	
	  // Determines whether an event happened in the gutter, and fires the
	  // handlers for the corresponding event.
	  function gutterEvent(cm, e, type, prevent) {
	    var mX, mY;
	    if (e.touches) {
	      mX = e.touches[0].clientX;
	      mY = e.touches[0].clientY;
	    } else {
	      try {
	        mX = e.clientX;mY = e.clientY;
	      } catch (e) {
	        return false;
	      }
	    }
	    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) {
	      return false;
	    }
	    if (prevent) {
	      e_preventDefault(e);
	    }
	
	    var display = cm.display;
	    var lineBox = display.lineDiv.getBoundingClientRect();
	
	    if (mY > lineBox.bottom || !hasHandler(cm, type)) {
	      return e_defaultPrevented(e);
	    }
	    mY -= lineBox.top - display.viewOffset;
	
	    for (var i = 0; i < cm.options.gutters.length; ++i) {
	      var g = display.gutters.childNodes[i];
	      if (g && g.getBoundingClientRect().right >= mX) {
	        var line = _lineAtHeight(cm.doc, mY);
	        var gutter = cm.options.gutters[i];
	        signal(cm, type, cm, line, gutter, e);
	        return e_defaultPrevented(e);
	      }
	    }
	  }
	
	  function clickInGutter(cm, e) {
	    return gutterEvent(cm, e, "gutterClick", true);
	  }
	
	  // CONTEXT MENU HANDLING
	
	  // To make the context menu work, we need to briefly unhide the
	  // textarea (making it as unobtrusive as possible) to let the
	  // right-click take effect on it.
	  function onContextMenu(cm, e) {
	    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) {
	      return;
	    }
	    if (signalDOMEvent(cm, e, "contextmenu")) {
	      return;
	    }
	    cm.display.input.onContextMenu(e);
	  }
	
	  function contextMenuInGutter(cm, e) {
	    if (!hasHandler(cm, "gutterContextMenu")) {
	      return false;
	    }
	    return gutterEvent(cm, e, "gutterContextMenu", false);
	  }
	
	  function themeChanged(cm) {
	    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
	    clearCaches(cm);
	  }
	
	  var Init = { toString: function toString() {
	      return "CodeMirror.Init";
	    } };
	
	  var defaults = {};
	  var optionHandlers = {};
	
	  function defineOptions(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    function option(name, deflt, handle, notOnInit) {
	      CodeMirror.defaults[name] = deflt;
	      if (handle) {
	        optionHandlers[name] = notOnInit ? function (cm, val, old) {
	          if (old != Init) {
	            handle(cm, val, old);
	          }
	        } : handle;
	      }
	    }
	
	    CodeMirror.defineOption = option;
	
	    // Passed to option handlers when there is no old value.
	    CodeMirror.Init = Init;
	
	    // These two are, on init, called from the constructor because they
	    // have to be initialized before the editor can start at all.
	    option("value", "", function (cm, val) {
	      return cm.setValue(val);
	    }, true);
	    option("mode", null, function (cm, val) {
	      cm.doc.modeOption = val;
	      loadMode(cm);
	    }, true);
	
	    option("indentUnit", 2, loadMode, true);
	    option("indentWithTabs", false);
	    option("smartIndent", true);
	    option("tabSize", 4, function (cm) {
	      resetModeState(cm);
	      clearCaches(cm);
	      regChange(cm);
	    }, true);
	
	    option("lineSeparator", null, function (cm, val) {
	      cm.doc.lineSep = val;
	      if (!val) {
	        return;
	      }
	      var newBreaks = [],
	          lineNo = cm.doc.first;
	      cm.doc.iter(function (line) {
	        for (var pos = 0;;) {
	          var found = line.text.indexOf(val, pos);
	          if (found == -1) {
	            break;
	          }
	          pos = found + val.length;
	          newBreaks.push(Pos(lineNo, found));
	        }
	        lineNo++;
	      });
	      for (var i = newBreaks.length - 1; i >= 0; i--) {
	        _replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
	      }
	    });
	    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff]/g, function (cm, val, old) {
	      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
	      if (old != Init) {
	        cm.refresh();
	      }
	    });
	    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) {
	      return cm.refresh();
	    }, true);
	    option("electricChars", true);
	    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
	      throw new Error("inputStyle can not (yet) be changed in a running editor"); // FIXME
	    }, true);
	    option("spellcheck", false, function (cm, val) {
	      return cm.getInputField().spellcheck = val;
	    }, true);
	    option("rtlMoveVisually", !windows);
	    option("wholeLineUpdateBefore", true);
	
	    option("theme", "default", function (cm) {
	      themeChanged(cm);
	      guttersChanged(cm);
	    }, true);
	    option("keyMap", "default", function (cm, val, old) {
	      var next = getKeyMap(val);
	      var prev = old != Init && getKeyMap(old);
	      if (prev && prev.detach) {
	        prev.detach(cm, next);
	      }
	      if (next.attach) {
	        next.attach(cm, prev || null);
	      }
	    });
	    option("extraKeys", null);
	    option("configureMouse", null);
	
	    option("lineWrapping", false, wrappingChanged, true);
	    option("gutters", [], function (cm) {
	      setGuttersForLineNumbers(cm.options);
	      guttersChanged(cm);
	    }, true);
	    option("fixedGutter", true, function (cm, val) {
	      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
	      cm.refresh();
	    }, true);
	    option("coverGutterNextToScrollbar", false, function (cm) {
	      return updateScrollbars(cm);
	    }, true);
	    option("scrollbarStyle", "native", function (cm) {
	      initScrollbars(cm);
	      updateScrollbars(cm);
	      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
	      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
	    }, true);
	    option("lineNumbers", false, function (cm) {
	      setGuttersForLineNumbers(cm.options);
	      guttersChanged(cm);
	    }, true);
	    option("firstLineNumber", 1, guttersChanged, true);
	    option("lineNumberFormatter", function (integer) {
	      return integer;
	    }, guttersChanged, true);
	    option("showCursorWhenSelecting", false, updateSelection, true);
	
	    option("resetSelectionOnContextMenu", true);
	    option("lineWiseCopyCut", true);
	    option("pasteLinesPerSelection", true);
	
	    option("readOnly", false, function (cm, val) {
	      if (val == "nocursor") {
	        onBlur(cm);
	        cm.display.input.blur();
	      }
	      cm.display.input.readOnlyChanged(val);
	    });
	    option("disableInput", false, function (cm, val) {
	      if (!val) {
	        cm.display.input.reset();
	      }
	    }, true);
	    option("dragDrop", true, dragDropChanged);
	    option("allowDropFileTypes", null);
	
	    option("cursorBlinkRate", 530);
	    option("cursorScrollMargin", 0);
	    option("cursorHeight", 1, updateSelection, true);
	    option("singleCursorHeightPerLine", true, updateSelection, true);
	    option("workTime", 100);
	    option("workDelay", 100);
	    option("flattenSpans", true, resetModeState, true);
	    option("addModeClass", false, resetModeState, true);
	    option("pollInterval", 100);
	    option("undoDepth", 200, function (cm, val) {
	      return cm.doc.history.undoDepth = val;
	    });
	    option("historyEventDelay", 1250);
	    option("viewportMargin", 10, function (cm) {
	      return cm.refresh();
	    }, true);
	    option("maxHighlightLength", 10000, resetModeState, true);
	    option("moveInputWithCursor", true, function (cm, val) {
	      if (!val) {
	        cm.display.input.resetPosition();
	      }
	    });
	
	    option("tabindex", null, function (cm, val) {
	      return cm.display.input.getField().tabIndex = val || "";
	    });
	    option("autofocus", null);
	    option("direction", "ltr", function (cm, val) {
	      return cm.doc.setDirection(val);
	    }, true);
	  }
	
	  function guttersChanged(cm) {
	    updateGutters(cm);
	    regChange(cm);
	    alignHorizontally(cm);
	  }
	
	  function dragDropChanged(cm, value, old) {
	    var wasOn = old && old != Init;
	    if (!value != !wasOn) {
	      var funcs = cm.display.dragFunctions;
	      var toggle = value ? on : off;
	      toggle(cm.display.scroller, "dragstart", funcs.start);
	      toggle(cm.display.scroller, "dragenter", funcs.enter);
	      toggle(cm.display.scroller, "dragover", funcs.over);
	      toggle(cm.display.scroller, "dragleave", funcs.leave);
	      toggle(cm.display.scroller, "drop", funcs.drop);
	    }
	  }
	
	  function wrappingChanged(cm) {
	    if (cm.options.lineWrapping) {
	      addClass(cm.display.wrapper, "CodeMirror-wrap");
	      cm.display.sizer.style.minWidth = "";
	      cm.display.sizerWidth = null;
	    } else {
	      rmClass(cm.display.wrapper, "CodeMirror-wrap");
	      findMaxLine(cm);
	    }
	    estimateLineHeights(cm);
	    regChange(cm);
	    clearCaches(cm);
	    setTimeout(function () {
	      return updateScrollbars(cm);
	    }, 100);
	  }
	
	  // A CodeMirror instance represents an editor. This is the object
	  // that user code is usually dealing with.
	
	  function CodeMirror$1(place, options) {
	    var this$1 = this;
	
	    if (!(this instanceof CodeMirror$1)) {
	      return new CodeMirror$1(place, options);
	    }
	
	    this.options = options = options ? copyObj(options) : {};
	    // Determine effective options based on given values and defaults.
	    copyObj(defaults, options, false);
	    setGuttersForLineNumbers(options);
	
	    var doc = options.value;
	    if (typeof doc == "string") {
	      doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
	    }
	    this.doc = doc;
	
	    var input = new CodeMirror$1.inputStyles[options.inputStyle](this);
	    var display = this.display = new Display(place, doc, input);
	    display.wrapper.CodeMirror = this;
	    updateGutters(this);
	    themeChanged(this);
	    if (options.lineWrapping) {
	      this.display.wrapper.className += " CodeMirror-wrap";
	    }
	    initScrollbars(this);
	
	    this.state = {
	      keyMaps: [], // stores maps added by addKeyMap
	      overlays: [], // highlighting overlays, as added by addOverlay
	      modeGen: 0, // bumped when mode/overlay changes, used to invalidate highlighting info
	      overwrite: false,
	      delayingBlurEvent: false,
	      focused: false,
	      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	      pasteIncoming: false, cutIncoming: false, // help recognize paste/cut edits in input.poll
	      selectingText: false,
	      draggingText: false,
	      highlight: new Delayed(), // stores highlight worker timeout
	      keySeq: null, // Unfinished key sequence
	      specialChars: null
	    };
	
	    if (options.autofocus && !mobile) {
	      display.input.focus();
	    }
	
	    // Override magic textarea content restore that IE sometimes does
	    // on our hidden textarea on reload
	    if (ie && ie_version < 11) {
	      setTimeout(function () {
	        return this$1.display.input.reset(true);
	      }, 20);
	    }
	
	    registerEventHandlers(this);
	    ensureGlobalHandlers();
	
	    _startOperation(this);
	    this.curOp.forceUpdate = true;
	    attachDoc(this, doc);
	
	    if (options.autofocus && !mobile || this.hasFocus()) {
	      setTimeout(bind(onFocus, this), 20);
	    } else {
	      onBlur(this);
	    }
	
	    for (var opt in optionHandlers) {
	      if (optionHandlers.hasOwnProperty(opt)) {
	        optionHandlers[opt](this$1, options[opt], Init);
	      }
	    }
	    maybeUpdateLineNumberWidth(this);
	    if (options.finishInit) {
	      options.finishInit(this);
	    }
	    for (var i = 0; i < initHooks.length; ++i) {
	      initHooks[i](this$1);
	    }
	    _endOperation(this);
	    // Suppress optimizelegibility in Webkit, since it breaks text
	    // measuring on line wrapping boundaries.
	    if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") {
	      display.lineDiv.style.textRendering = "auto";
	    }
	  }
	
	  // The default configuration options.
	  CodeMirror$1.defaults = defaults;
	  // Functions to run when options are changed.
	  CodeMirror$1.optionHandlers = optionHandlers;
	
	  // Attach the necessary event handlers when initializing the editor
	  function registerEventHandlers(cm) {
	    var d = cm.display;
	    on(d.scroller, "mousedown", operation(cm, onMouseDown));
	    // Older IE's will not fire a second mousedown for a double click
	    if (ie && ie_version < 11) {
	      on(d.scroller, "dblclick", operation(cm, function (e) {
	        if (signalDOMEvent(cm, e)) {
	          return;
	        }
	        var pos = posFromMouse(cm, e);
	        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) {
	          return;
	        }
	        e_preventDefault(e);
	        var word = cm.findWordAt(pos);
	        extendSelection(cm.doc, word.anchor, word.head);
	      }));
	    } else {
	      on(d.scroller, "dblclick", function (e) {
	        return signalDOMEvent(cm, e) || e_preventDefault(e);
	      });
	    }
	    // Some browsers fire contextmenu *after* opening the menu, at
	    // which point we can't mess with it anymore. Context menu is
	    // handled in onMouseDown for these browsers.
	    if (!captureRightClick) {
	      on(d.scroller, "contextmenu", function (e) {
	        return onContextMenu(cm, e);
	      });
	    }
	
	    // Used to suppress mouse event handling when a touch happens
	    var touchFinished,
	        prevTouch = { end: 0 };
	    function finishTouch() {
	      if (d.activeTouch) {
	        touchFinished = setTimeout(function () {
	          return d.activeTouch = null;
	        }, 1000);
	        prevTouch = d.activeTouch;
	        prevTouch.end = +new Date();
	      }
	    }
	    function isMouseLikeTouchEvent(e) {
	      if (e.touches.length != 1) {
	        return false;
	      }
	      var touch = e.touches[0];
	      return touch.radiusX <= 1 && touch.radiusY <= 1;
	    }
	    function farAway(touch, other) {
	      if (other.left == null) {
	        return true;
	      }
	      var dx = other.left - touch.left,
	          dy = other.top - touch.top;
	      return dx * dx + dy * dy > 20 * 20;
	    }
	    on(d.scroller, "touchstart", function (e) {
	      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
	        d.input.ensurePolled();
	        clearTimeout(touchFinished);
	        var now = +new Date();
	        d.activeTouch = { start: now, moved: false,
	          prev: now - prevTouch.end <= 300 ? prevTouch : null };
	        if (e.touches.length == 1) {
	          d.activeTouch.left = e.touches[0].pageX;
	          d.activeTouch.top = e.touches[0].pageY;
	        }
	      }
	    });
	    on(d.scroller, "touchmove", function () {
	      if (d.activeTouch) {
	        d.activeTouch.moved = true;
	      }
	    });
	    on(d.scroller, "touchend", function (e) {
	      var touch = d.activeTouch;
	      if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date() - touch.start < 300) {
	        var pos = cm.coordsChar(d.activeTouch, "page"),
	            range;
	        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	          {
	            range = new Range(pos, pos);
	          } else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	          {
	            range = cm.findWordAt(pos);
	          } else // Triple tap
	          {
	            range = new Range(Pos(pos.line, 0), _clipPos(cm.doc, Pos(pos.line + 1, 0)));
	          }
	        cm.setSelection(range.anchor, range.head);
	        cm.focus();
	        e_preventDefault(e);
	      }
	      finishTouch();
	    });
	    on(d.scroller, "touchcancel", finishTouch);
	
	    // Sync scrolling between fake scrollbars and real scrollable
	    // area, ensure viewport is updated when scrolling.
	    on(d.scroller, "scroll", function () {
	      if (d.scroller.clientHeight) {
	        updateScrollTop(cm, d.scroller.scrollTop);
	        setScrollLeft(cm, d.scroller.scrollLeft, true);
	        signal(cm, "scroll", cm);
	      }
	    });
	
	    // Listen to wheel events in order to try and update the viewport on time.
	    on(d.scroller, "mousewheel", function (e) {
	      return onScrollWheel(cm, e);
	    });
	    on(d.scroller, "DOMMouseScroll", function (e) {
	      return onScrollWheel(cm, e);
	    });
	
	    // Prevent wrapper from ever scrolling
	    on(d.wrapper, "scroll", function () {
	      return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
	    });
	
	    d.dragFunctions = {
	      enter: function enter(e) {
	        if (!signalDOMEvent(cm, e)) {
	          e_stop(e);
	        }
	      },
	      over: function over(e) {
	        if (!signalDOMEvent(cm, e)) {
	          onDragOver(cm, e);e_stop(e);
	        }
	      },
	      start: function start(e) {
	        return onDragStart(cm, e);
	      },
	      drop: operation(cm, onDrop),
	      leave: function leave(e) {
	        if (!signalDOMEvent(cm, e)) {
	          clearDragCursor(cm);
	        }
	      }
	    };
	
	    var inp = d.input.getField();
	    on(inp, "keyup", function (e) {
	      return onKeyUp.call(cm, e);
	    });
	    on(inp, "keydown", operation(cm, onKeyDown));
	    on(inp, "keypress", operation(cm, onKeyPress));
	    on(inp, "focus", function (e) {
	      return onFocus(cm, e);
	    });
	    on(inp, "blur", function (e) {
	      return onBlur(cm, e);
	    });
	  }
	
	  var initHooks = [];
	  CodeMirror$1.defineInitHook = function (f) {
	    return initHooks.push(f);
	  };
	
	  // Indent the given line. The how parameter can be "smart",
	  // "add"/null, "subtract", or "prev". When aggressive is false
	  // (typically set to true for forced single-line indents), empty
	  // lines are not indented, and places where the mode returns Pass
	  // are left alone.
	  function indentLine(cm, n, how, aggressive) {
	    var doc = cm.doc,
	        state;
	    if (how == null) {
	      how = "add";
	    }
	    if (how == "smart") {
	      // Fall back to "prev" when the mode doesn't have an indentation
	      // method.
	      if (!doc.mode.indent) {
	        how = "prev";
	      } else {
	        state = getContextBefore(cm, n).state;
	      }
	    }
	
	    var tabSize = cm.options.tabSize;
	    var line = getLine(doc, n),
	        curSpace = countColumn(line.text, null, tabSize);
	    if (line.stateAfter) {
	      line.stateAfter = null;
	    }
	    var curSpaceString = line.text.match(/^\s*/)[0],
	        indentation;
	    if (!aggressive && !/\S/.test(line.text)) {
	      indentation = 0;
	      how = "not";
	    } else if (how == "smart") {
	      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
	      if (indentation == Pass || indentation > 150) {
	        if (!aggressive) {
	          return;
	        }
	        how = "prev";
	      }
	    }
	    if (how == "prev") {
	      if (n > doc.first) {
	        indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
	      } else {
	        indentation = 0;
	      }
	    } else if (how == "add") {
	      indentation = curSpace + cm.options.indentUnit;
	    } else if (how == "subtract") {
	      indentation = curSpace - cm.options.indentUnit;
	    } else if (typeof how == "number") {
	      indentation = curSpace + how;
	    }
	    indentation = Math.max(0, indentation);
	
	    var indentString = "",
	        pos = 0;
	    if (cm.options.indentWithTabs) {
	      for (var i = Math.floor(indentation / tabSize); i; --i) {
	        pos += tabSize;indentString += "\t";
	      }
	    }
	    if (pos < indentation) {
	      indentString += spaceStr(indentation - pos);
	    }
	
	    if (indentString != curSpaceString) {
	      _replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
	      line.stateAfter = null;
	      return true;
	    } else {
	      // Ensure that, if the cursor was in the whitespace at the start
	      // of the line, it is moved to the end of that space.
	      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
	        var range = doc.sel.ranges[i$1];
	        if (range.head.line == n && range.head.ch < curSpaceString.length) {
	          var pos$1 = Pos(n, curSpaceString.length);
	          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
	          break;
	        }
	      }
	    }
	  }
	
	  // This will be set to a {lineWise: bool, text: [string]} object, so
	  // that, when pasting, we know what kind of selections the copied
	  // text was made out of.
	  var lastCopied = null;
	
	  function setLastCopied(newLastCopied) {
	    lastCopied = newLastCopied;
	  }
	
	  function applyTextInput(cm, inserted, deleted, sel, origin) {
	    var doc = cm.doc;
	    cm.display.shift = false;
	    if (!sel) {
	      sel = doc.sel;
	    }
	
	    var paste = cm.state.pasteIncoming || origin == "paste";
	    var textLines = splitLinesAuto(inserted),
	        multiPaste = null;
	    // When pasting N lines into N selections, insert one line per selection
	    if (paste && sel.ranges.length > 1) {
	      if (lastCopied && lastCopied.text.join("\n") == inserted) {
	        if (sel.ranges.length % lastCopied.text.length == 0) {
	          multiPaste = [];
	          for (var i = 0; i < lastCopied.text.length; i++) {
	            multiPaste.push(doc.splitLines(lastCopied.text[i]));
	          }
	        }
	      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
	        multiPaste = map(textLines, function (l) {
	          return [l];
	        });
	      }
	    }
	
	    var updateInput;
	    // Normal behavior is to insert the new text into every selection
	    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
	      var range$$1 = sel.ranges[i$1];
	      var from = range$$1.from(),
	          to = range$$1.to();
	      if (range$$1.empty()) {
	        if (deleted && deleted > 0) // Handle deletion
	          {
	            from = Pos(from.line, from.ch - deleted);
	          } else if (cm.state.overwrite && !paste) // Handle overwrite
	          {
	            to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
	          } else if (lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted) {
	          from = to = Pos(from.line, 0);
	        }
	      }
	      updateInput = cm.curOp.updateInput;
	      var changeEvent = { from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
	        origin: origin || (paste ? "paste" : cm.state.cutIncoming ? "cut" : "+input") };
	      makeChange(cm.doc, changeEvent);
	      signalLater(cm, "inputRead", cm, changeEvent);
	    }
	    if (inserted && !paste) {
	      triggerElectric(cm, inserted);
	    }
	
	    ensureCursorVisible(cm);
	    cm.curOp.updateInput = updateInput;
	    cm.curOp.typing = true;
	    cm.state.pasteIncoming = cm.state.cutIncoming = false;
	  }
	
	  function handlePaste(e, cm) {
	    var pasted = e.clipboardData && e.clipboardData.getData("Text");
	    if (pasted) {
	      e.preventDefault();
	      if (!cm.isReadOnly() && !cm.options.disableInput) {
	        runInOp(cm, function () {
	          return applyTextInput(cm, pasted, 0, null, "paste");
	        });
	      }
	      return true;
	    }
	  }
	
	  function triggerElectric(cm, inserted) {
	    // When an 'electric' character is inserted, immediately trigger a reindent
	    if (!cm.options.electricChars || !cm.options.smartIndent) {
	      return;
	    }
	    var sel = cm.doc.sel;
	
	    for (var i = sel.ranges.length - 1; i >= 0; i--) {
	      var range$$1 = sel.ranges[i];
	      if (range$$1.head.ch > 100 || i && sel.ranges[i - 1].head.line == range$$1.head.line) {
	        continue;
	      }
	      var mode = cm.getModeAt(range$$1.head);
	      var indented = false;
	      if (mode.electricChars) {
	        for (var j = 0; j < mode.electricChars.length; j++) {
	          if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	            indented = indentLine(cm, range$$1.head.line, "smart");
	            break;
	          }
	        }
	      } else if (mode.electricInput) {
	        if (mode.electricInput.test(getLine(cm.doc, range$$1.head.line).text.slice(0, range$$1.head.ch))) {
	          indented = indentLine(cm, range$$1.head.line, "smart");
	        }
	      }
	      if (indented) {
	        signalLater(cm, "electricInput", cm, range$$1.head.line);
	      }
	    }
	  }
	
	  function copyableRanges(cm) {
	    var text = [],
	        ranges = [];
	    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	      var line = cm.doc.sel.ranges[i].head.line;
	      var lineRange = { anchor: Pos(line, 0), head: Pos(line + 1, 0) };
	      ranges.push(lineRange);
	      text.push(cm.getRange(lineRange.anchor, lineRange.head));
	    }
	    return { text: text, ranges: ranges };
	  }
	
	  function disableBrowserMagic(field, spellcheck) {
	    field.setAttribute("autocorrect", "off");
	    field.setAttribute("autocapitalize", "off");
	    field.setAttribute("spellcheck", !!spellcheck);
	  }
	
	  function hiddenTextarea() {
	    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
	    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
	    // The textarea is kept positioned near the cursor to prevent the
	    // fact that it'll be scrolled into view on input from scrolling
	    // our fake cursor out of view. On webkit, when wrap=off, paste is
	    // very slow. So make the area wide instead.
	    if (webkit) {
	      te.style.width = "1000px";
	    } else {
	      te.setAttribute("wrap", "off");
	    }
	    // If border: 0; -- iOS fails to open keyboard (issue #1287)
	    if (ios) {
	      te.style.border = "1px solid black";
	    }
	    disableBrowserMagic(te);
	    return div;
	  }
	
	  // The publicly visible API. Note that methodOp(f) means
	  // 'wrap f in an operation, performed on its `this` parameter'.
	
	  // This is not the complete set of editor methods. Most of the
	  // methods defined on the Doc type are also injected into
	  // CodeMirror.prototype, for backwards compatibility and
	  // convenience.
	
	  var addEditorMethods = function addEditorMethods(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    var helpers = CodeMirror.helpers = {};
	
	    CodeMirror.prototype = {
	      constructor: CodeMirror,
	      focus: function focus() {
	        window.focus();this.display.input.focus();
	      },
	
	      setOption: function setOption(option, value) {
	        var options = this.options,
	            old = options[option];
	        if (options[option] == value && option != "mode") {
	          return;
	        }
	        options[option] = value;
	        if (optionHandlers.hasOwnProperty(option)) {
	          operation(this, optionHandlers[option])(this, value, old);
	        }
	        signal(this, "optionChange", this, option);
	      },
	
	      getOption: function getOption(option) {
	        return this.options[option];
	      },
	      getDoc: function getDoc() {
	        return this.doc;
	      },
	
	      addKeyMap: function addKeyMap(map$$1, bottom) {
	        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map$$1));
	      },
	      removeKeyMap: function removeKeyMap(map$$1) {
	        var maps = this.state.keyMaps;
	        for (var i = 0; i < maps.length; ++i) {
	          if (maps[i] == map$$1 || maps[i].name == map$$1) {
	            maps.splice(i, 1);
	            return true;
	          }
	        }
	      },
	
	      addOverlay: methodOp(function (spec, options) {
	        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
	        if (mode.startState) {
	          throw new Error("Overlays may not be stateful.");
	        }
	        insertSorted(this.state.overlays, { mode: mode, modeSpec: spec, opaque: options && options.opaque,
	          priority: options && options.priority || 0 }, function (overlay) {
	          return overlay.priority;
	        });
	        this.state.modeGen++;
	        regChange(this);
	      }),
	      removeOverlay: methodOp(function (spec) {
	        var this$1 = this;
	
	        var overlays = this.state.overlays;
	        for (var i = 0; i < overlays.length; ++i) {
	          var cur = overlays[i].modeSpec;
	          if (cur == spec || typeof spec == "string" && cur.name == spec) {
	            overlays.splice(i, 1);
	            this$1.state.modeGen++;
	            regChange(this$1);
	            return;
	          }
	        }
	      }),
	
	      indentLine: methodOp(function (n, dir, aggressive) {
	        if (typeof dir != "string" && typeof dir != "number") {
	          if (dir == null) {
	            dir = this.options.smartIndent ? "smart" : "prev";
	          } else {
	            dir = dir ? "add" : "subtract";
	          }
	        }
	        if (isLine(this.doc, n)) {
	          indentLine(this, n, dir, aggressive);
	        }
	      }),
	      indentSelection: methodOp(function (how) {
	        var this$1 = this;
	
	        var ranges = this.doc.sel.ranges,
	            end = -1;
	        for (var i = 0; i < ranges.length; i++) {
	          var range$$1 = ranges[i];
	          if (!range$$1.empty()) {
	            var from = range$$1.from(),
	                to = range$$1.to();
	            var start = Math.max(end, from.line);
	            end = Math.min(this$1.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
	            for (var j = start; j < end; ++j) {
	              indentLine(this$1, j, how);
	            }
	            var newRanges = this$1.doc.sel.ranges;
	            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) {
	              replaceOneSelection(this$1.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
	            }
	          } else if (range$$1.head.line > end) {
	            indentLine(this$1, range$$1.head.line, how, true);
	            end = range$$1.head.line;
	            if (i == this$1.doc.sel.primIndex) {
	              ensureCursorVisible(this$1);
	            }
	          }
	        }
	      }),
	
	      // Fetch the parser token for a given character. Useful for hacks
	      // that want to inspect the mode state (say, for completion).
	      getTokenAt: function getTokenAt(pos, precise) {
	        return takeToken(this, pos, precise);
	      },
	
	      getLineTokens: function getLineTokens(line, precise) {
	        return takeToken(this, Pos(line), precise, true);
	      },
	
	      getTokenTypeAt: function getTokenTypeAt(pos) {
	        pos = _clipPos(this.doc, pos);
	        var styles = getLineStyles(this, getLine(this.doc, pos.line));
	        var before = 0,
	            after = (styles.length - 1) / 2,
	            ch = pos.ch;
	        var type;
	        if (ch == 0) {
	          type = styles[2];
	        } else {
	          for (;;) {
	            var mid = before + after >> 1;
	            if ((mid ? styles[mid * 2 - 1] : 0) >= ch) {
	              after = mid;
	            } else if (styles[mid * 2 + 1] < ch) {
	              before = mid + 1;
	            } else {
	              type = styles[mid * 2 + 2];break;
	            }
	          }
	        }
	        var cut = type ? type.indexOf("overlay ") : -1;
	        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
	      },
	
	      getModeAt: function getModeAt(pos) {
	        var mode = this.doc.mode;
	        if (!mode.innerMode) {
	          return mode;
	        }
	        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
	      },
	
	      getHelper: function getHelper(pos, type) {
	        return this.getHelpers(pos, type)[0];
	      },
	
	      getHelpers: function getHelpers(pos, type) {
	        var this$1 = this;
	
	        var found = [];
	        if (!helpers.hasOwnProperty(type)) {
	          return found;
	        }
	        var help = helpers[type],
	            mode = this.getModeAt(pos);
	        if (typeof mode[type] == "string") {
	          if (help[mode[type]]) {
	            found.push(help[mode[type]]);
	          }
	        } else if (mode[type]) {
	          for (var i = 0; i < mode[type].length; i++) {
	            var val = help[mode[type][i]];
	            if (val) {
	              found.push(val);
	            }
	          }
	        } else if (mode.helperType && help[mode.helperType]) {
	          found.push(help[mode.helperType]);
	        } else if (help[mode.name]) {
	          found.push(help[mode.name]);
	        }
	        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
	          var cur = help._global[i$1];
	          if (cur.pred(mode, this$1) && indexOf(found, cur.val) == -1) {
	            found.push(cur.val);
	          }
	        }
	        return found;
	      },
	
	      getStateAfter: function getStateAfter(line, precise) {
	        var doc = this.doc;
	        line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
	        return getContextBefore(this, line + 1, precise).state;
	      },
	
	      cursorCoords: function cursorCoords(start, mode) {
	        var pos,
	            range$$1 = this.doc.sel.primary();
	        if (start == null) {
	          pos = range$$1.head;
	        } else if ((typeof start === 'undefined' ? 'undefined' : _typeof(start)) == "object") {
	          pos = _clipPos(this.doc, start);
	        } else {
	          pos = start ? range$$1.from() : range$$1.to();
	        }
	        return _cursorCoords(this, pos, mode || "page");
	      },
	
	      charCoords: function charCoords(pos, mode) {
	        return _charCoords(this, _clipPos(this.doc, pos), mode || "page");
	      },
	
	      coordsChar: function coordsChar(coords, mode) {
	        coords = fromCoordSystem(this, coords, mode || "page");
	        return _coordsChar(this, coords.left, coords.top);
	      },
	
	      lineAtHeight: function lineAtHeight(height, mode) {
	        height = fromCoordSystem(this, { top: height, left: 0 }, mode || "page").top;
	        return _lineAtHeight(this.doc, height + this.display.viewOffset);
	      },
	      heightAtLine: function heightAtLine(line, mode, includeWidgets) {
	        var end = false,
	            lineObj;
	        if (typeof line == "number") {
	          var last = this.doc.first + this.doc.size - 1;
	          if (line < this.doc.first) {
	            line = this.doc.first;
	          } else if (line > last) {
	            line = last;end = true;
	          }
	          lineObj = getLine(this.doc, line);
	        } else {
	          lineObj = line;
	        }
	        return intoCoordSystem(this, lineObj, { top: 0, left: 0 }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - _heightAtLine(lineObj) : 0);
	      },
	
	      defaultTextHeight: function defaultTextHeight() {
	        return textHeight(this.display);
	      },
	      defaultCharWidth: function defaultCharWidth() {
	        return charWidth(this.display);
	      },
	
	      getViewport: function getViewport() {
	        return { from: this.display.viewFrom, to: this.display.viewTo };
	      },
	
	      addWidget: function addWidget(pos, node, scroll, vert, horiz) {
	        var display = this.display;
	        pos = _cursorCoords(this, _clipPos(this.doc, pos));
	        var top = pos.bottom,
	            left = pos.left;
	        node.style.position = "absolute";
	        node.setAttribute("cm-ignore-events", "true");
	        this.display.input.setUneditable(node);
	        display.sizer.appendChild(node);
	        if (vert == "over") {
	          top = pos.top;
	        } else if (vert == "above" || vert == "near") {
	          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	              hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
	          // Default to positioning above (if specified and possible); otherwise default to positioning below
	          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) {
	            top = pos.top - node.offsetHeight;
	          } else if (pos.bottom + node.offsetHeight <= vspace) {
	            top = pos.bottom;
	          }
	          if (left + node.offsetWidth > hspace) {
	            left = hspace - node.offsetWidth;
	          }
	        }
	        node.style.top = top + "px";
	        node.style.left = node.style.right = "";
	        if (horiz == "right") {
	          left = display.sizer.clientWidth - node.offsetWidth;
	          node.style.right = "0px";
	        } else {
	          if (horiz == "left") {
	            left = 0;
	          } else if (horiz == "middle") {
	            left = (display.sizer.clientWidth - node.offsetWidth) / 2;
	          }
	          node.style.left = left + "px";
	        }
	        if (scroll) {
	          scrollIntoView(this, { left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight });
	        }
	      },
	
	      triggerOnKeyDown: methodOp(onKeyDown),
	      triggerOnKeyPress: methodOp(onKeyPress),
	      triggerOnKeyUp: onKeyUp,
	      triggerOnMouseDown: methodOp(onMouseDown),
	
	      execCommand: function execCommand(cmd) {
	        if (commands.hasOwnProperty(cmd)) {
	          return commands[cmd].call(null, this);
	        }
	      },
	
	      triggerElectric: methodOp(function (text) {
	        triggerElectric(this, text);
	      }),
	
	      findPosH: function findPosH(from, amount, unit, visually) {
	        var this$1 = this;
	
	        var dir = 1;
	        if (amount < 0) {
	          dir = -1;amount = -amount;
	        }
	        var cur = _clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          cur = _findPosH(this$1.doc, cur, dir, unit, visually);
	          if (cur.hitSide) {
	            break;
	          }
	        }
	        return cur;
	      },
	
	      moveH: methodOp(function (dir, unit) {
	        var this$1 = this;
	
	        this.extendSelectionsBy(function (range$$1) {
	          if (this$1.display.shift || this$1.doc.extend || range$$1.empty()) {
	            return _findPosH(this$1.doc, range$$1.head, dir, unit, this$1.options.rtlMoveVisually);
	          } else {
	            return dir < 0 ? range$$1.from() : range$$1.to();
	          }
	        }, sel_move);
	      }),
	
	      deleteH: methodOp(function (dir, unit) {
	        var sel = this.doc.sel,
	            doc = this.doc;
	        if (sel.somethingSelected()) {
	          doc.replaceSelection("", null, "+delete");
	        } else {
	          deleteNearSelection(this, function (range$$1) {
	            var other = _findPosH(doc, range$$1.head, dir, unit, false);
	            return dir < 0 ? { from: other, to: range$$1.head } : { from: range$$1.head, to: other };
	          });
	        }
	      }),
	
	      findPosV: function findPosV(from, amount, unit, goalColumn) {
	        var this$1 = this;
	
	        var dir = 1,
	            x = goalColumn;
	        if (amount < 0) {
	          dir = -1;amount = -amount;
	        }
	        var cur = _clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          var coords = _cursorCoords(this$1, cur, "div");
	          if (x == null) {
	            x = coords.left;
	          } else {
	            coords.left = x;
	          }
	          cur = _findPosV(this$1, coords, dir, unit);
	          if (cur.hitSide) {
	            break;
	          }
	        }
	        return cur;
	      },
	
	      moveV: methodOp(function (dir, unit) {
	        var this$1 = this;
	
	        var doc = this.doc,
	            goals = [];
	        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
	        doc.extendSelectionsBy(function (range$$1) {
	          if (collapse) {
	            return dir < 0 ? range$$1.from() : range$$1.to();
	          }
	          var headPos = _cursorCoords(this$1, range$$1.head, "div");
	          if (range$$1.goalColumn != null) {
	            headPos.left = range$$1.goalColumn;
	          }
	          goals.push(headPos.left);
	          var pos = _findPosV(this$1, headPos, dir, unit);
	          if (unit == "page" && range$$1 == doc.sel.primary()) {
	            addToScrollTop(this$1, _charCoords(this$1, pos, "div").top - headPos.top);
	          }
	          return pos;
	        }, sel_move);
	        if (goals.length) {
	          for (var i = 0; i < doc.sel.ranges.length; i++) {
	            doc.sel.ranges[i].goalColumn = goals[i];
	          }
	        }
	      }),
	
	      // Find the word at the given position (as returned by coordsChar).
	      findWordAt: function findWordAt(pos) {
	        var doc = this.doc,
	            line = getLine(doc, pos.line).text;
	        var start = pos.ch,
	            end = pos.ch;
	        if (line) {
	          var helper = this.getHelper(pos, "wordChars");
	          if ((pos.sticky == "before" || end == line.length) && start) {
	            --start;
	          } else {
	            ++end;
	          }
	          var startChar = line.charAt(start);
	          var check = isWordChar(startChar, helper) ? function (ch) {
	            return isWordChar(ch, helper);
	          } : /\s/.test(startChar) ? function (ch) {
	            return (/\s/.test(ch)
	            );
	          } : function (ch) {
	            return !/\s/.test(ch) && !isWordChar(ch);
	          };
	          while (start > 0 && check(line.charAt(start - 1))) {
	            --start;
	          }
	          while (end < line.length && check(line.charAt(end))) {
	            ++end;
	          }
	        }
	        return new Range(Pos(pos.line, start), Pos(pos.line, end));
	      },
	
	      toggleOverwrite: function toggleOverwrite(value) {
	        if (value != null && value == this.state.overwrite) {
	          return;
	        }
	        if (this.state.overwrite = !this.state.overwrite) {
	          addClass(this.display.cursorDiv, "CodeMirror-overwrite");
	        } else {
	          rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
	        }
	
	        signal(this, "overwriteToggle", this, this.state.overwrite);
	      },
	      hasFocus: function hasFocus() {
	        return this.display.input.getField() == activeElt();
	      },
	      isReadOnly: function isReadOnly() {
	        return !!(this.options.readOnly || this.doc.cantEdit);
	      },
	
	      scrollTo: methodOp(function (x, y) {
	        scrollToCoords(this, x, y);
	      }),
	      getScrollInfo: function getScrollInfo() {
	        var scroller = this.display.scroller;
	        return { left: scroller.scrollLeft, top: scroller.scrollTop,
	          height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	          width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	          clientHeight: displayHeight(this), clientWidth: displayWidth(this) };
	      },
	
	      scrollIntoView: methodOp(function (range$$1, margin) {
	        if (range$$1 == null) {
	          range$$1 = { from: this.doc.sel.primary().head, to: null };
	          if (margin == null) {
	            margin = this.options.cursorScrollMargin;
	          }
	        } else if (typeof range$$1 == "number") {
	          range$$1 = { from: Pos(range$$1, 0), to: null };
	        } else if (range$$1.from == null) {
	          range$$1 = { from: range$$1, to: null };
	        }
	        if (!range$$1.to) {
	          range$$1.to = range$$1.from;
	        }
	        range$$1.margin = margin || 0;
	
	        if (range$$1.from.line != null) {
	          scrollToRange(this, range$$1);
	        } else {
	          scrollToCoordsRange(this, range$$1.from, range$$1.to, range$$1.margin);
	        }
	      }),
	
	      setSize: methodOp(function (width, height) {
	        var this$1 = this;
	
	        var interpret = function interpret(val) {
	          return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
	        };
	        if (width != null) {
	          this.display.wrapper.style.width = interpret(width);
	        }
	        if (height != null) {
	          this.display.wrapper.style.height = interpret(height);
	        }
	        if (this.options.lineWrapping) {
	          clearLineMeasurementCache(this);
	        }
	        var lineNo$$1 = this.display.viewFrom;
	        this.doc.iter(lineNo$$1, this.display.viewTo, function (line) {
	          if (line.widgets) {
	            for (var i = 0; i < line.widgets.length; i++) {
	              if (line.widgets[i].noHScroll) {
	                regLineChange(this$1, lineNo$$1, "widget");break;
	              }
	            }
	          }
	          ++lineNo$$1;
	        });
	        this.curOp.forceUpdate = true;
	        signal(this, "refresh", this);
	      }),
	
	      operation: function operation(f) {
	        return runInOp(this, f);
	      },
	      startOperation: function startOperation() {
	        return _startOperation(this);
	      },
	      endOperation: function endOperation() {
	        return _endOperation(this);
	      },
	
	      refresh: methodOp(function () {
	        var oldHeight = this.display.cachedTextHeight;
	        regChange(this);
	        this.curOp.forceUpdate = true;
	        clearCaches(this);
	        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
	        updateGutterSpace(this);
	        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5) {
	          estimateLineHeights(this);
	        }
	        signal(this, "refresh", this);
	      }),
	
	      swapDoc: methodOp(function (doc) {
	        var old = this.doc;
	        old.cm = null;
	        attachDoc(this, doc);
	        clearCaches(this);
	        this.display.input.reset();
	        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
	        this.curOp.forceScroll = true;
	        signalLater(this, "swapDoc", this, old);
	        return old;
	      }),
	
	      getInputField: function getInputField() {
	        return this.display.input.getField();
	      },
	      getWrapperElement: function getWrapperElement() {
	        return this.display.wrapper;
	      },
	      getScrollerElement: function getScrollerElement() {
	        return this.display.scroller;
	      },
	      getGutterElement: function getGutterElement() {
	        return this.display.gutters;
	      }
	    };
	    eventMixin(CodeMirror);
	
	    CodeMirror.registerHelper = function (type, name, value) {
	      if (!helpers.hasOwnProperty(type)) {
	        helpers[type] = CodeMirror[type] = { _global: [] };
	      }
	      helpers[type][name] = value;
	    };
	    CodeMirror.registerGlobalHelper = function (type, name, predicate, value) {
	      CodeMirror.registerHelper(type, name, value);
	      helpers[type]._global.push({ pred: predicate, val: value });
	    };
	  };
	
	  // Used for horizontal relative motion. Dir is -1 or 1 (left or
	  // right), unit can be "char", "column" (like char, but doesn't
	  // cross line boundaries), "word" (across next word), or "group" (to
	  // the start of next group of word or non-word-non-whitespace
	  // chars). The visually param controls whether, in right-to-left
	  // text, direction 1 means to move towards the next index in the
	  // string, or towards the character to the right of the current
	  // position. The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function _findPosH(doc, pos, dir, unit, visually) {
	    var oldPos = pos;
	    var origDir = dir;
	    var lineObj = getLine(doc, pos.line);
	    function findNextLine() {
	      var l = pos.line + dir;
	      if (l < doc.first || l >= doc.first + doc.size) {
	        return false;
	      }
	      pos = new Pos(l, pos.ch, pos.sticky);
	      return lineObj = getLine(doc, l);
	    }
	    function moveOnce(boundToLine) {
	      var next;
	      if (visually) {
	        next = moveVisually(doc.cm, lineObj, pos, dir);
	      } else {
	        next = moveLogically(lineObj, pos, dir);
	      }
	      if (next == null) {
	        if (!boundToLine && findNextLine()) {
	          pos = endOfLine(visually, doc.cm, lineObj, pos.line, dir);
	        } else {
	          return false;
	        }
	      } else {
	        pos = next;
	      }
	      return true;
	    }
	
	    if (unit == "char") {
	      moveOnce();
	    } else if (unit == "column") {
	      moveOnce(true);
	    } else if (unit == "word" || unit == "group") {
	      var sawType = null,
	          group = unit == "group";
	      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
	      for (var first = true;; first = false) {
	        if (dir < 0 && !moveOnce(!first)) {
	          break;
	        }
	        var cur = lineObj.text.charAt(pos.ch) || "\n";
	        var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
	        if (group && !first && !type) {
	          type = "s";
	        }
	        if (sawType && sawType != type) {
	          if (dir < 0) {
	            dir = 1;moveOnce();pos.sticky = "after";
	          }
	          break;
	        }
	
	        if (type) {
	          sawType = type;
	        }
	        if (dir > 0 && !moveOnce(!first)) {
	          break;
	        }
	      }
	    }
	    var result = skipAtomic(doc, pos, oldPos, origDir, true);
	    if (equalCursorPos(oldPos, result)) {
	      result.hitSide = true;
	    }
	    return result;
	  }
	
	  // For relative vertical movement. Dir may be -1 or 1. Unit can be
	  // "page" or "line". The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function _findPosV(cm, pos, dir, unit) {
	    var doc = cm.doc,
	        x = pos.left,
	        y;
	    if (unit == "page") {
	      var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
	      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
	      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
	    } else if (unit == "line") {
	      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
	    }
	    var target;
	    for (;;) {
	      target = _coordsChar(cm, x, y);
	      if (!target.outside) {
	        break;
	      }
	      if (dir < 0 ? y <= 0 : y >= doc.height) {
	        target.hitSide = true;break;
	      }
	      y += dir * 5;
	    }
	    return target;
	  }
	
	  // CONTENTEDITABLE INPUT STYLE
	
	  var ContentEditableInput = function ContentEditableInput(cm) {
	    this.cm = cm;
	    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
	    this.polling = new Delayed();
	    this.composing = null;
	    this.gracePeriod = false;
	    this.readDOMTimeout = null;
	  };
	
	  ContentEditableInput.prototype.init = function (display) {
	    var this$1 = this;
	
	    var input = this,
	        cm = input.cm;
	    var div = input.div = display.lineDiv;
	    disableBrowserMagic(div, cm.options.spellcheck);
	
	    on(div, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) {
	        return;
	      }
	      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	      if (ie_version <= 11) {
	        setTimeout(operation(cm, function () {
	          return this$1.updateFromDOM();
	        }), 20);
	      }
	    });
	
	    on(div, "compositionstart", function (e) {
	      this$1.composing = { data: e.data, done: false };
	    });
	    on(div, "compositionupdate", function (e) {
	      if (!this$1.composing) {
	        this$1.composing = { data: e.data, done: false };
	      }
	    });
	    on(div, "compositionend", function (e) {
	      if (this$1.composing) {
	        if (e.data != this$1.composing.data) {
	          this$1.readFromDOMSoon();
	        }
	        this$1.composing.done = true;
	      }
	    });
	
	    on(div, "touchstart", function () {
	      return input.forceCompositionEnd();
	    });
	
	    on(div, "input", function () {
	      if (!this$1.composing) {
	        this$1.readFromDOMSoon();
	      }
	    });
	
	    function onCopyCut(e) {
	      if (signalDOMEvent(cm, e)) {
	        return;
	      }
	      if (cm.somethingSelected()) {
	        setLastCopied({ lineWise: false, text: cm.getSelections() });
	        if (e.type == "cut") {
	          cm.replaceSelection("", null, "cut");
	        }
	      } else if (!cm.options.lineWiseCopyCut) {
	        return;
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({ lineWise: true, text: ranges.text });
	        if (e.type == "cut") {
	          cm.operation(function () {
	            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
	            cm.replaceSelection("", null, "cut");
	          });
	        }
	      }
	      if (e.clipboardData) {
	        e.clipboardData.clearData();
	        var content = lastCopied.text.join("\n");
	        // iOS exposes the clipboard API, but seems to discard content inserted into it
	        e.clipboardData.setData("Text", content);
	        if (e.clipboardData.getData("Text") == content) {
	          e.preventDefault();
	          return;
	        }
	      }
	      // Old-fashioned briefly-focus-a-textarea hack
	      var kludge = hiddenTextarea(),
	          te = kludge.firstChild;
	      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
	      te.value = lastCopied.text.join("\n");
	      var hadFocus = document.activeElement;
	      selectInput(te);
	      setTimeout(function () {
	        cm.display.lineSpace.removeChild(kludge);
	        hadFocus.focus();
	        if (hadFocus == div) {
	          input.showPrimarySelection();
	        }
	      }, 50);
	    }
	    on(div, "copy", onCopyCut);
	    on(div, "cut", onCopyCut);
	  };
	
	  ContentEditableInput.prototype.prepareSelection = function () {
	    var result = prepareSelection(this.cm, false);
	    result.focus = this.cm.state.focused;
	    return result;
	  };
	
	  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
	    if (!info || !this.cm.display.view.length) {
	      return;
	    }
	    if (info.focus || takeFocus) {
	      this.showPrimarySelection();
	    }
	    this.showMultipleSelections(info);
	  };
	
	  ContentEditableInput.prototype.showPrimarySelection = function () {
	    var sel = window.getSelection(),
	        cm = this.cm,
	        prim = cm.doc.sel.primary();
	    var from = prim.from(),
	        to = prim.to();
	
	    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
	      sel.removeAllRanges();
	      return;
	    }
	
	    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) {
	      return;
	    }
	
	    var view = cm.display.view;
	    var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || { node: view[0].measure.map[2], offset: 0 };
	    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
	    if (!end) {
	      var measure = view[view.length - 1].measure;
	      var map$$1 = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
	      end = { node: map$$1[map$$1.length - 1], offset: map$$1[map$$1.length - 2] - map$$1[map$$1.length - 3] };
	    }
	
	    if (!start || !end) {
	      sel.removeAllRanges();
	      return;
	    }
	
	    var old = sel.rangeCount && sel.getRangeAt(0),
	        rng;
	    try {
	      rng = range(start.node, start.offset, end.offset, end.node);
	    } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	    if (rng) {
	      if (!gecko && cm.state.focused) {
	        sel.collapse(start.node, start.offset);
	        if (!rng.collapsed) {
	          sel.removeAllRanges();
	          sel.addRange(rng);
	        }
	      } else {
	        sel.removeAllRanges();
	        sel.addRange(rng);
	      }
	      if (old && sel.anchorNode == null) {
	        sel.addRange(old);
	      } else if (gecko) {
	        this.startGracePeriod();
	      }
	    }
	    this.rememberSelection();
	  };
	
	  ContentEditableInput.prototype.startGracePeriod = function () {
	    var this$1 = this;
	
	    clearTimeout(this.gracePeriod);
	    this.gracePeriod = setTimeout(function () {
	      this$1.gracePeriod = false;
	      if (this$1.selectionChanged()) {
	        this$1.cm.operation(function () {
	          return this$1.cm.curOp.selectionChanged = true;
	        });
	      }
	    }, 20);
	  };
	
	  ContentEditableInput.prototype.showMultipleSelections = function (info) {
	    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
	    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
	  };
	
	  ContentEditableInput.prototype.rememberSelection = function () {
	    var sel = window.getSelection();
	    this.lastAnchorNode = sel.anchorNode;this.lastAnchorOffset = sel.anchorOffset;
	    this.lastFocusNode = sel.focusNode;this.lastFocusOffset = sel.focusOffset;
	  };
	
	  ContentEditableInput.prototype.selectionInEditor = function () {
	    var sel = window.getSelection();
	    if (!sel.rangeCount) {
	      return false;
	    }
	    var node = sel.getRangeAt(0).commonAncestorContainer;
	    return contains(this.div, node);
	  };
	
	  ContentEditableInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor") {
	      if (!this.selectionInEditor()) {
	        this.showSelection(this.prepareSelection(), true);
	      }
	      this.div.focus();
	    }
	  };
	  ContentEditableInput.prototype.blur = function () {
	    this.div.blur();
	  };
	  ContentEditableInput.prototype.getField = function () {
	    return this.div;
	  };
	
	  ContentEditableInput.prototype.supportsTouch = function () {
	    return true;
	  };
	
	  ContentEditableInput.prototype.receivedFocus = function () {
	    var input = this;
	    if (this.selectionInEditor()) {
	      this.pollSelection();
	    } else {
	      runInOp(this.cm, function () {
	        return input.cm.curOp.selectionChanged = true;
	      });
	    }
	
	    function poll() {
	      if (input.cm.state.focused) {
	        input.pollSelection();
	        input.polling.set(input.cm.options.pollInterval, poll);
	      }
	    }
	    this.polling.set(this.cm.options.pollInterval, poll);
	  };
	
	  ContentEditableInput.prototype.selectionChanged = function () {
	    var sel = window.getSelection();
	    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
	  };
	
	  ContentEditableInput.prototype.pollSelection = function () {
	    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) {
	      return;
	    }
	    var sel = window.getSelection(),
	        cm = this.cm;
	    // On Android Chrome (version 56, at least), backspacing into an
	    // uneditable block element will put the cursor in that element,
	    // and then, because it's not editable, hide the virtual keyboard.
	    // Because Android doesn't allow us to actually detect backspace
	    // presses in a sane way, this code checks for when that happens
	    // and simulates a backspace press in this case.
	    if (android && chrome && this.cm.options.gutters.length && isInGutter(sel.anchorNode)) {
	      this.cm.triggerOnKeyDown({ type: "keydown", keyCode: 8, preventDefault: Math.abs });
	      this.blur();
	      this.focus();
	      return;
	    }
	    if (this.composing) {
	      return;
	    }
	    this.rememberSelection();
	    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (anchor && head) {
	      runInOp(cm, function () {
	        setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
	        if (anchor.bad || head.bad) {
	          cm.curOp.selectionChanged = true;
	        }
	      });
	    }
	  };
	
	  ContentEditableInput.prototype.pollContent = function () {
	    if (this.readDOMTimeout != null) {
	      clearTimeout(this.readDOMTimeout);
	      this.readDOMTimeout = null;
	    }
	
	    var cm = this.cm,
	        display = cm.display,
	        sel = cm.doc.sel.primary();
	    var from = sel.from(),
	        to = sel.to();
	    if (from.ch == 0 && from.line > cm.firstLine()) {
	      from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
	    }
	    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) {
	      to = Pos(to.line + 1, 0);
	    }
	    if (from.line < display.viewFrom || to.line > display.viewTo - 1) {
	      return false;
	    }
	
	    var fromIndex, fromLine, fromNode;
	    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	      fromLine = lineNo(display.view[0].line);
	      fromNode = display.view[0].node;
	    } else {
	      fromLine = lineNo(display.view[fromIndex].line);
	      fromNode = display.view[fromIndex - 1].node.nextSibling;
	    }
	    var toIndex = findViewIndex(cm, to.line);
	    var toLine, toNode;
	    if (toIndex == display.view.length - 1) {
	      toLine = display.viewTo - 1;
	      toNode = display.lineDiv.lastChild;
	    } else {
	      toLine = lineNo(display.view[toIndex + 1].line) - 1;
	      toNode = display.view[toIndex + 1].node.previousSibling;
	    }
	
	    if (!fromNode) {
	      return false;
	    }
	    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
	    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
	    while (newText.length > 1 && oldText.length > 1) {
	      if (lst(newText) == lst(oldText)) {
	        newText.pop();oldText.pop();toLine--;
	      } else if (newText[0] == oldText[0]) {
	        newText.shift();oldText.shift();fromLine++;
	      } else {
	        break;
	      }
	    }
	
	    var cutFront = 0,
	        cutEnd = 0;
	    var newTop = newText[0],
	        oldTop = oldText[0],
	        maxCutFront = Math.min(newTop.length, oldTop.length);
	    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront)) {
	      ++cutFront;
	    }
	    var newBot = lst(newText),
	        oldBot = lst(oldText);
	    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
	    while (cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	      ++cutEnd;
	    }
	    // Try to move start of change to start of selection if ambiguous
	    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
	      while (cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	        cutFront--;
	        cutEnd++;
	      }
	    }
	
	    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
	    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
	
	    var chFrom = Pos(fromLine, cutFront);
	    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
	    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	      _replaceRange(cm.doc, newText, chFrom, chTo, "+input");
	      return true;
	    }
	  };
	
	  ContentEditableInput.prototype.ensurePolled = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.reset = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.forceCompositionEnd = function () {
	    if (!this.composing) {
	      return;
	    }
	    clearTimeout(this.readDOMTimeout);
	    this.composing = null;
	    this.updateFromDOM();
	    this.div.blur();
	    this.div.focus();
	  };
	  ContentEditableInput.prototype.readFromDOMSoon = function () {
	    var this$1 = this;
	
	    if (this.readDOMTimeout != null) {
	      return;
	    }
	    this.readDOMTimeout = setTimeout(function () {
	      this$1.readDOMTimeout = null;
	      if (this$1.composing) {
	        if (this$1.composing.done) {
	          this$1.composing = null;
	        } else {
	          return;
	        }
	      }
	      this$1.updateFromDOM();
	    }, 80);
	  };
	
	  ContentEditableInput.prototype.updateFromDOM = function () {
	    var this$1 = this;
	
	    if (this.cm.isReadOnly() || !this.pollContent()) {
	      runInOp(this.cm, function () {
	        return regChange(this$1.cm);
	      });
	    }
	  };
	
	  ContentEditableInput.prototype.setUneditable = function (node) {
	    node.contentEditable = "false";
	  };
	
	  ContentEditableInput.prototype.onKeyPress = function (e) {
	    if (e.charCode == 0) {
	      return;
	    }
	    e.preventDefault();
	    if (!this.cm.isReadOnly()) {
	      operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
	    }
	  };
	
	  ContentEditableInput.prototype.readOnlyChanged = function (val) {
	    this.div.contentEditable = String(val != "nocursor");
	  };
	
	  ContentEditableInput.prototype.onContextMenu = function () {};
	  ContentEditableInput.prototype.resetPosition = function () {};
	
	  ContentEditableInput.prototype.needsContentAttribute = true;
	
	  function posToDOM(cm, pos) {
	    var view = findViewForLine(cm, pos.line);
	    if (!view || view.hidden) {
	      return null;
	    }
	    var line = getLine(cm.doc, pos.line);
	    var info = mapFromLineView(view, line, pos.line);
	
	    var order = getOrder(line, cm.doc.direction),
	        side = "left";
	    if (order) {
	      var partPos = getBidiPartAt(order, pos.ch);
	      side = partPos % 2 ? "right" : "left";
	    }
	    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
	    result.offset = result.collapse == "right" ? result.end : result.start;
	    return result;
	  }
	
	  function isInGutter(node) {
	    for (var scan = node; scan; scan = scan.parentNode) {
	      if (/CodeMirror-gutter-wrapper/.test(scan.className)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function badPos(pos, bad) {
	    if (bad) {
	      pos.bad = true;
	    }return pos;
	  }
	
	  function domTextBetween(cm, from, to, fromLine, toLine) {
	    var text = "",
	        closing = false,
	        lineSep = cm.doc.lineSeparator();
	    function recognizeMarker(id) {
	      return function (marker) {
	        return marker.id == id;
	      };
	    }
	    function close() {
	      if (closing) {
	        text += lineSep;
	        closing = false;
	      }
	    }
	    function addText(str) {
	      if (str) {
	        close();
	        text += str;
	      }
	    }
	    function walk(node) {
	      if (node.nodeType == 1) {
	        var cmText = node.getAttribute("cm-text");
	        if (cmText != null) {
	          addText(cmText || node.textContent.replace(/\u200b/g, ""));
	          return;
	        }
	        var markerID = node.getAttribute("cm-marker"),
	            range$$1;
	        if (markerID) {
	          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
	          if (found.length && (range$$1 = found[0].find(0))) {
	            addText(getBetween(cm.doc, range$$1.from, range$$1.to).join(lineSep));
	          }
	          return;
	        }
	        if (node.getAttribute("contenteditable") == "false") {
	          return;
	        }
	        var isBlock = /^(pre|div|p)$/i.test(node.nodeName);
	        if (isBlock) {
	          close();
	        }
	        for (var i = 0; i < node.childNodes.length; i++) {
	          walk(node.childNodes[i]);
	        }
	        if (isBlock) {
	          closing = true;
	        }
	      } else if (node.nodeType == 3) {
	        addText(node.nodeValue);
	      }
	    }
	    for (;;) {
	      walk(from);
	      if (from == to) {
	        break;
	      }
	      from = from.nextSibling;
	    }
	    return text;
	  }
	
	  function domToPos(cm, node, offset) {
	    var lineNode;
	    if (node == cm.display.lineDiv) {
	      lineNode = cm.display.lineDiv.childNodes[offset];
	      if (!lineNode) {
	        return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
	      }
	      node = null;offset = 0;
	    } else {
	      for (lineNode = node;; lineNode = lineNode.parentNode) {
	        if (!lineNode || lineNode == cm.display.lineDiv) {
	          return null;
	        }
	        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) {
	          break;
	        }
	      }
	    }
	    for (var i = 0; i < cm.display.view.length; i++) {
	      var lineView = cm.display.view[i];
	      if (lineView.node == lineNode) {
	        return locateNodeInLineView(lineView, node, offset);
	      }
	    }
	  }
	
	  function locateNodeInLineView(lineView, node, offset) {
	    var wrapper = lineView.text.firstChild,
	        bad = false;
	    if (!node || !contains(wrapper, node)) {
	      return badPos(Pos(lineNo(lineView.line), 0), true);
	    }
	    if (node == wrapper) {
	      bad = true;
	      node = wrapper.childNodes[offset];
	      offset = 0;
	      if (!node) {
	        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
	        return badPos(Pos(lineNo(line), line.text.length), bad);
	      }
	    }
	
	    var textNode = node.nodeType == 3 ? node : null,
	        topNode = node;
	    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	      textNode = node.firstChild;
	      if (offset) {
	        offset = textNode.nodeValue.length;
	      }
	    }
	    while (topNode.parentNode != wrapper) {
	      topNode = topNode.parentNode;
	    }
	    var measure = lineView.measure,
	        maps = measure.maps;
	
	    function find(textNode, topNode, offset) {
	      for (var i = -1; i < (maps ? maps.length : 0); i++) {
	        var map$$1 = i < 0 ? measure.map : maps[i];
	        for (var j = 0; j < map$$1.length; j += 3) {
	          var curNode = map$$1[j + 2];
	          if (curNode == textNode || curNode == topNode) {
	            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
	            var ch = map$$1[j] + offset;
	            if (offset < 0 || curNode != textNode) {
	              ch = map$$1[j + (offset ? 1 : 0)];
	            }
	            return Pos(line, ch);
	          }
	        }
	      }
	    }
	    var found = find(textNode, topNode, offset);
	    if (found) {
	      return badPos(found, bad);
	    }
	
	    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	      found = find(after, after.firstChild, 0);
	      if (found) {
	        return badPos(Pos(found.line, found.ch - dist), bad);
	      } else {
	        dist += after.textContent.length;
	      }
	    }
	    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
	      found = find(before, before.firstChild, -1);
	      if (found) {
	        return badPos(Pos(found.line, found.ch + dist$1), bad);
	      } else {
	        dist$1 += before.textContent.length;
	      }
	    }
	  }
	
	  // TEXTAREA INPUT STYLE
	
	  var TextareaInput = function TextareaInput(cm) {
	    this.cm = cm;
	    // See input.poll and input.reset
	    this.prevInput = "";
	
	    // Flag that indicates whether we expect input to appear real soon
	    // now (after some event like 'keypress' or 'input') and are
	    // polling intensively.
	    this.pollingFast = false;
	    // Self-resetting timeout for the poller
	    this.polling = new Delayed();
	    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	    this.hasSelection = false;
	    this.composing = null;
	  };
	
	  TextareaInput.prototype.init = function (display) {
	    var this$1 = this;
	
	    var input = this,
	        cm = this.cm;
	    this.createField(display);
	    var te = this.textarea;
	
	    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
	
	    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	    if (ios) {
	      te.style.width = "0px";
	    }
	
	    on(te, "input", function () {
	      if (ie && ie_version >= 9 && this$1.hasSelection) {
	        this$1.hasSelection = null;
	      }
	      input.poll();
	    });
	
	    on(te, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) {
	        return;
	      }
	
	      cm.state.pasteIncoming = true;
	      input.fastPoll();
	    });
	
	    function prepareCopyCut(e) {
	      if (signalDOMEvent(cm, e)) {
	        return;
	      }
	      if (cm.somethingSelected()) {
	        setLastCopied({ lineWise: false, text: cm.getSelections() });
	      } else if (!cm.options.lineWiseCopyCut) {
	        return;
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({ lineWise: true, text: ranges.text });
	        if (e.type == "cut") {
	          cm.setSelections(ranges.ranges, null, sel_dontScroll);
	        } else {
	          input.prevInput = "";
	          te.value = ranges.text.join("\n");
	          selectInput(te);
	        }
	      }
	      if (e.type == "cut") {
	        cm.state.cutIncoming = true;
	      }
	    }
	    on(te, "cut", prepareCopyCut);
	    on(te, "copy", prepareCopyCut);
	
	    on(display.scroller, "paste", function (e) {
	      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) {
	        return;
	      }
	      cm.state.pasteIncoming = true;
	      input.focus();
	    });
	
	    // Prevent normal selection in the editor (we handle our own)
	    on(display.lineSpace, "selectstart", function (e) {
	      if (!eventInWidget(display, e)) {
	        e_preventDefault(e);
	      }
	    });
	
	    on(te, "compositionstart", function () {
	      var start = cm.getCursor("from");
	      if (input.composing) {
	        input.composing.range.clear();
	      }
	      input.composing = {
	        start: start,
	        range: cm.markText(start, cm.getCursor("to"), { className: "CodeMirror-composing" })
	      };
	    });
	    on(te, "compositionend", function () {
	      if (input.composing) {
	        input.poll();
	        input.composing.range.clear();
	        input.composing = null;
	      }
	    });
	  };
	
	  TextareaInput.prototype.createField = function (_display) {
	    // Wraps and hides input textarea
	    this.wrapper = hiddenTextarea();
	    // The semihidden textarea that is focused when the editor is
	    // focused, and receives input.
	    this.textarea = this.wrapper.firstChild;
	  };
	
	  TextareaInput.prototype.prepareSelection = function () {
	    // Redraw the selection and/or cursor
	    var cm = this.cm,
	        display = cm.display,
	        doc = cm.doc;
	    var result = prepareSelection(cm);
	
	    // Move the hidden textarea near the cursor to prevent scrolling artifacts
	    if (cm.options.moveInputWithCursor) {
	      var headPos = _cursorCoords(cm, doc.sel.primary().head, "div");
	      var wrapOff = display.wrapper.getBoundingClientRect(),
	          lineOff = display.lineDiv.getBoundingClientRect();
	      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
	      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
	    }
	
	    return result;
	  };
	
	  TextareaInput.prototype.showSelection = function (drawn) {
	    var cm = this.cm,
	        display = cm.display;
	    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
	    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
	    if (drawn.teTop != null) {
	      this.wrapper.style.top = drawn.teTop + "px";
	      this.wrapper.style.left = drawn.teLeft + "px";
	    }
	  };
	
	  // Reset the input to correspond to the selection (or to be empty,
	  // when not typing and nothing is selected)
	  TextareaInput.prototype.reset = function (typing) {
	    if (this.contextMenuPending || this.composing) {
	      return;
	    }
	    var cm = this.cm;
	    if (cm.somethingSelected()) {
	      this.prevInput = "";
	      var content = cm.getSelection();
	      this.textarea.value = content;
	      if (cm.state.focused) {
	        selectInput(this.textarea);
	      }
	      if (ie && ie_version >= 9) {
	        this.hasSelection = content;
	      }
	    } else if (!typing) {
	      this.prevInput = this.textarea.value = "";
	      if (ie && ie_version >= 9) {
	        this.hasSelection = null;
	      }
	    }
	  };
	
	  TextareaInput.prototype.getField = function () {
	    return this.textarea;
	  };
	
	  TextareaInput.prototype.supportsTouch = function () {
	    return false;
	  };
	
	  TextareaInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
	      try {
	        this.textarea.focus();
	      } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	    }
	  };
	
	  TextareaInput.prototype.blur = function () {
	    this.textarea.blur();
	  };
	
	  TextareaInput.prototype.resetPosition = function () {
	    this.wrapper.style.top = this.wrapper.style.left = 0;
	  };
	
	  TextareaInput.prototype.receivedFocus = function () {
	    this.slowPoll();
	  };
	
	  // Poll for input changes, using the normal rate of polling. This
	  // runs as long as the editor is focused.
	  TextareaInput.prototype.slowPoll = function () {
	    var this$1 = this;
	
	    if (this.pollingFast) {
	      return;
	    }
	    this.polling.set(this.cm.options.pollInterval, function () {
	      this$1.poll();
	      if (this$1.cm.state.focused) {
	        this$1.slowPoll();
	      }
	    });
	  };
	
	  // When an event has just come in that is likely to add or change
	  // something in the input textarea, we poll faster, to ensure that
	  // the change appears on the screen quickly.
	  TextareaInput.prototype.fastPoll = function () {
	    var missed = false,
	        input = this;
	    input.pollingFast = true;
	    function p() {
	      var changed = input.poll();
	      if (!changed && !missed) {
	        missed = true;input.polling.set(60, p);
	      } else {
	        input.pollingFast = false;input.slowPoll();
	      }
	    }
	    input.polling.set(20, p);
	  };
	
	  // Read input from the textarea, and update the document to match.
	  // When something is selected, it is present in the textarea, and
	  // selected (unless it is huge, in which case a placeholder is
	  // used). When nothing is selected, the cursor sits after previously
	  // seen text (can be empty), which is stored in prevInput (we must
	  // not reset the textarea when typing, because that breaks IME).
	  TextareaInput.prototype.poll = function () {
	    var this$1 = this;
	
	    var cm = this.cm,
	        input = this.textarea,
	        prevInput = this.prevInput;
	    // Since this is called a *lot*, try to bail out as cheaply as
	    // possible when it is clear that nothing happened. hasSelection
	    // will be the case when there is a lot of text in the textarea,
	    // in which case reading its value would be expensive.
	    if (this.contextMenuPending || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) {
	      return false;
	    }
	
	    var text = input.value;
	    // If nothing changed, bail.
	    if (text == prevInput && !cm.somethingSelected()) {
	      return false;
	    }
	    // Work around nonsensical selection resetting in IE9/10, and
	    // inexplicable appearance of private area unicode characters on
	    // some key combos in Mac (#2689).
	    if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
	      cm.display.input.reset();
	      return false;
	    }
	
	    if (cm.doc.sel == cm.display.selForContextMenu) {
	      var first = text.charCodeAt(0);
	      if (first == 0x200b && !prevInput) {
	        prevInput = '\u200B';
	      }
	      if (first == 0x21da) {
	        this.reset();return this.cm.execCommand("undo");
	      }
	    }
	    // Find the part of the input that is actually new
	    var same = 0,
	        l = Math.min(prevInput.length, text.length);
	    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) {
	      ++same;
	    }
	
	    runInOp(cm, function () {
	      applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
	
	      // Don't leave long text in the textarea, since it makes further polling slow
	      if (text.length > 1000 || text.indexOf("\n") > -1) {
	        input.value = this$1.prevInput = "";
	      } else {
	        this$1.prevInput = text;
	      }
	
	      if (this$1.composing) {
	        this$1.composing.range.clear();
	        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), { className: "CodeMirror-composing" });
	      }
	    });
	    return true;
	  };
	
	  TextareaInput.prototype.ensurePolled = function () {
	    if (this.pollingFast && this.poll()) {
	      this.pollingFast = false;
	    }
	  };
	
	  TextareaInput.prototype.onKeyPress = function () {
	    if (ie && ie_version >= 9) {
	      this.hasSelection = null;
	    }
	    this.fastPoll();
	  };
	
	  TextareaInput.prototype.onContextMenu = function (e) {
	    var input = this,
	        cm = input.cm,
	        display = cm.display,
	        te = input.textarea;
	    var pos = posFromMouse(cm, e),
	        scrollPos = display.scroller.scrollTop;
	    if (!pos || presto) {
	      return;
	    } // Opera is difficult.
	
	    // Reset the current text selection only if the click is done outside of the selection
	    // and 'resetSelectionOnContextMenu' option is true.
	    var reset = cm.options.resetSelectionOnContextMenu;
	    if (reset && cm.doc.sel.contains(pos) == -1) {
	      operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
	    }
	
	    var oldCSS = te.style.cssText,
	        oldWrapperCSS = input.wrapper.style.cssText;
	    input.wrapper.style.cssText = "position: absolute";
	    var wrapperBox = input.wrapper.getBoundingClientRect();
	    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
	    var oldScrollY;
	    if (webkit) {
	      oldScrollY = window.scrollY;
	    } // Work around Chrome issue (#2712)
	    display.input.focus();
	    if (webkit) {
	      window.scrollTo(null, oldScrollY);
	    }
	    display.input.reset();
	    // Adds "Select all" to context menu in FF
	    if (!cm.somethingSelected()) {
	      te.value = input.prevInput = " ";
	    }
	    input.contextMenuPending = true;
	    display.selForContextMenu = cm.doc.sel;
	    clearTimeout(display.detectingSelectAll);
	
	    // Select-all will be greyed out if there's nothing to select, so
	    // this adds a zero-width space so that we can later check whether
	    // it got selected.
	    function prepareSelectAllHack() {
	      if (te.selectionStart != null) {
	        var selected = cm.somethingSelected();
	        var extval = '\u200B' + (selected ? te.value : "");
	        te.value = '\u21DA'; // Used to catch context-menu undo
	        te.value = extval;
	        input.prevInput = selected ? "" : '\u200B';
	        te.selectionStart = 1;te.selectionEnd = extval.length;
	        // Re-set this, in case some other handler touched the
	        // selection in the meantime.
	        display.selForContextMenu = cm.doc.sel;
	      }
	    }
	    function rehide() {
	      input.contextMenuPending = false;
	      input.wrapper.style.cssText = oldWrapperCSS;
	      te.style.cssText = oldCSS;
	      if (ie && ie_version < 9) {
	        display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
	      }
	
	      // Try to detect the user choosing select-all
	      if (te.selectionStart != null) {
	        if (!ie || ie && ie_version < 9) {
	          prepareSelectAllHack();
	        }
	        var i = 0,
	            poll = function poll() {
	          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == '\u200B') {
	            operation(cm, selectAll)(cm);
	          } else if (i++ < 10) {
	            display.detectingSelectAll = setTimeout(poll, 500);
	          } else {
	            display.selForContextMenu = null;
	            display.input.reset();
	          }
	        };
	        display.detectingSelectAll = setTimeout(poll, 200);
	      }
	    }
	
	    if (ie && ie_version >= 9) {
	      prepareSelectAllHack();
	    }
	    if (captureRightClick) {
	      e_stop(e);
	      var mouseup = function mouseup() {
	        off(window, "mouseup", mouseup);
	        setTimeout(rehide, 20);
	      };
	      on(window, "mouseup", mouseup);
	    } else {
	      setTimeout(rehide, 50);
	    }
	  };
	
	  TextareaInput.prototype.readOnlyChanged = function (val) {
	    if (!val) {
	      this.reset();
	    }
	    this.textarea.disabled = val == "nocursor";
	  };
	
	  TextareaInput.prototype.setUneditable = function () {};
	
	  TextareaInput.prototype.needsContentAttribute = false;
	
	  function fromTextArea(textarea, options) {
	    options = options ? copyObj(options) : {};
	    options.value = textarea.value;
	    if (!options.tabindex && textarea.tabIndex) {
	      options.tabindex = textarea.tabIndex;
	    }
	    if (!options.placeholder && textarea.placeholder) {
	      options.placeholder = textarea.placeholder;
	    }
	    // Set autofocus to true if this textarea is focused, or if it has
	    // autofocus and no other element is focused.
	    if (options.autofocus == null) {
	      var hasFocus = activeElt();
	      options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
	    }
	
	    function save() {
	      textarea.value = cm.getValue();
	    }
	
	    var realSubmit;
	    if (textarea.form) {
	      on(textarea.form, "submit", save);
	      // Deplorable hack to make the submit method do the right thing.
	      if (!options.leaveSubmitMethodAlone) {
	        var form = textarea.form;
	        realSubmit = form.submit;
	        try {
	          var wrappedSubmit = form.submit = function () {
	            save();
	            form.submit = realSubmit;
	            form.submit();
	            form.submit = wrappedSubmit;
	          };
	        } catch (e) {}
	      }
	    }
	
	    options.finishInit = function (cm) {
	      cm.save = save;
	      cm.getTextArea = function () {
	        return textarea;
	      };
	      cm.toTextArea = function () {
	        cm.toTextArea = isNaN; // Prevent this from being ran twice
	        save();
	        textarea.parentNode.removeChild(cm.getWrapperElement());
	        textarea.style.display = "";
	        if (textarea.form) {
	          off(textarea.form, "submit", save);
	          if (typeof textarea.form.submit == "function") {
	            textarea.form.submit = realSubmit;
	          }
	        }
	      };
	    };
	
	    textarea.style.display = "none";
	    var cm = CodeMirror$1(function (node) {
	      return textarea.parentNode.insertBefore(node, textarea.nextSibling);
	    }, options);
	    return cm;
	  }
	
	  function addLegacyProps(CodeMirror) {
	    CodeMirror.off = off;
	    CodeMirror.on = on;
	    CodeMirror.wheelEventPixels = wheelEventPixels;
	    CodeMirror.Doc = Doc;
	    CodeMirror.splitLines = splitLinesAuto;
	    CodeMirror.countColumn = countColumn;
	    CodeMirror.findColumn = findColumn;
	    CodeMirror.isWordChar = isWordCharBasic;
	    CodeMirror.Pass = Pass;
	    CodeMirror.signal = signal;
	    CodeMirror.Line = Line;
	    CodeMirror.changeEnd = changeEnd;
	    CodeMirror.scrollbarModel = scrollbarModel;
	    CodeMirror.Pos = Pos;
	    CodeMirror.cmpPos = cmp;
	    CodeMirror.modes = modes;
	    CodeMirror.mimeModes = mimeModes;
	    CodeMirror.resolveMode = resolveMode;
	    CodeMirror.getMode = getMode;
	    CodeMirror.modeExtensions = modeExtensions;
	    CodeMirror.extendMode = extendMode;
	    CodeMirror.copyState = copyState;
	    CodeMirror.startState = startState;
	    CodeMirror.innerMode = innerMode;
	    CodeMirror.commands = commands;
	    CodeMirror.keyMap = keyMap;
	    CodeMirror.keyName = keyName;
	    CodeMirror.isModifierKey = isModifierKey;
	    CodeMirror.lookupKey = lookupKey;
	    CodeMirror.normalizeKeyMap = normalizeKeyMap;
	    CodeMirror.StringStream = StringStream;
	    CodeMirror.SharedTextMarker = SharedTextMarker;
	    CodeMirror.TextMarker = TextMarker;
	    CodeMirror.LineWidget = LineWidget;
	    CodeMirror.e_preventDefault = e_preventDefault;
	    CodeMirror.e_stopPropagation = e_stopPropagation;
	    CodeMirror.e_stop = e_stop;
	    CodeMirror.addClass = addClass;
	    CodeMirror.contains = contains;
	    CodeMirror.rmClass = rmClass;
	    CodeMirror.keyNames = keyNames;
	  }
	
	  // EDITOR CONSTRUCTOR
	
	  defineOptions(CodeMirror$1);
	
	  addEditorMethods(CodeMirror$1);
	
	  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
	  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
	  for (var prop in Doc.prototype) {
	    if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) {
	      CodeMirror$1.prototype[prop] = function (method) {
	        return function () {
	          return method.apply(this.doc, arguments);
	        };
	      }(Doc.prototype[prop]);
	    }
	  }
	
	  eventMixin(Doc);
	
	  // INPUT HANDLING
	
	  CodeMirror$1.inputStyles = { "textarea": TextareaInput, "contenteditable": ContentEditableInput };
	
	  // MODE DEFINITION AND QUERYING
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  CodeMirror$1.defineMode = function (name /*, mode, …*/) {
	    if (!CodeMirror$1.defaults.mode && name != "null") {
	      CodeMirror$1.defaults.mode = name;
	    }
	    defineMode.apply(this, arguments);
	  };
	
	  CodeMirror$1.defineMIME = defineMIME;
	
	  // Minimal default mode.
	  CodeMirror$1.defineMode("null", function () {
	    return { token: function token(stream) {
	        return stream.skipToEnd();
	      } };
	  });
	  CodeMirror$1.defineMIME("text/plain", "null");
	
	  // EXTENSIONS
	
	  CodeMirror$1.defineExtension = function (name, func) {
	    CodeMirror$1.prototype[name] = func;
	  };
	  CodeMirror$1.defineDocExtension = function (name, func) {
	    Doc.prototype[name] = func;
	  };
	
	  CodeMirror$1.fromTextArea = fromTextArea;
	
	  addLegacyProps(CodeMirror$1);
	
	  CodeMirror$1.version = "5.36.0";
	
	  return CodeMirror$1;
	});

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(227);
	module.exports = angular;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var _UtilsObjectProperties = __webpack_require__(113);
	
	var Entry = function () {
	    function Entry(entityName, values, identifierValue) {
	        _classCallCheck(this, Entry);
	
	        this._entityName = entityName;
	        this.values = values || {};
	        this._identifierValue = identifierValue;
	        this.listValues = {};
	    }
	
	    _createClass(Entry, [{
	        key: 'transformToRest',
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         *
	         * @return {Object}
	         */
	        value: function transformToRest(fields) {
	
	            var restEntry = (0, _UtilsObjectProperties.clone)(this.values);
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                if (fieldName in restEntry) {
	                    restEntry[fieldName] = field.getTransformedValue(restEntry[fieldName], restEntry);
	                }
	            });
	
	            return (0, _UtilsObjectProperties.cloneAndNest)(restEntry);
	        }
	    }, {
	        key: 'entityName',
	        get: function get() {
	            return this._entityName;
	        }
	    }, {
	        key: 'identifierValue',
	        get: function get() {
	            return this._identifierValue;
	        }
	    }], [{
	        key: 'createForFields',
	        value: function createForFields(fields, entityName) {
	            var entry = new Entry(entityName);
	            fields.forEach(function (field) {
	                entry.values[field.name()] = field.defaultValue();
	            });
	            return entry;
	        }
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         *
	         * @return {Entry}
	         */
	    }, {
	        key: 'createFromRest',
	        value: function createFromRest(restEntry) {
	            var fields = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	            var entityName = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	            var identifierName = arguments.length <= 3 || arguments[3] === undefined ? 'id' : arguments[3];
	
	            if (!restEntry || Object.keys(restEntry).length == 0) {
	                return Entry.createForFields(fields, entityName);
	            }
	            var excludedFields = fields.filter(function (f) {
	                return !f.flattenable();
	            }).map(function (f) {
	                return f.name();
	            });
	
	            var values = (0, _UtilsObjectProperties.cloneAndFlatten)(restEntry, excludedFields);
	
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                values[fieldName] = field.getMappedValue(values[fieldName], values);
	            });
	
	            return new Entry(entityName, values, values[identifierName]);
	        }
	
	        /**
	         * Map an array of JS objects from the REST API Response to an array of Entries
	         *
	         * @return {Array[Entry]}
	         */
	    }, {
	        key: 'createArrayFromRest',
	        value: function createArrayFromRest(restEntries, fields, entityName, identifierName) {
	            return restEntries.map(function (e) {
	                return Entry.createFromRest(e, fields, entityName, identifierName);
	            });
	        }
	    }]);
	
	    return Entry;
	}();
	
	exports['default'] = Entry;
	module.exports = exports['default'];
	//# sourceMappingURL=Entry.js.map

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var _Entry = __webpack_require__(6);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	var _UtilsReferenceExtractor = __webpack_require__(13);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var _UtilsObjectProperties = __webpack_require__(113);
	
	var View = function () {
	    function View(name) {
	        _classCallCheck(this, View);
	
	        this.entity = null;
	        this._actions = null;
	        this._title = false;
	        this._description = '';
	        this._template = null;
	
	        this._enabled = null;
	        this._fields = [];
	        this._type = null;
	        this._name = name;
	        this._order = 0;
	        this._errorMessage = null;
	        this._url = null;
	        this._prepare = null;
	    }
	
	    _createClass(View, [{
	        key: 'title',
	        value: function title(_title) {
	            if (!arguments.length) return this._title;
	            this._title = _title;
	            return this;
	        }
	    }, {
	        key: 'description',
	        value: function description() {
	            if (arguments.length) {
	                this._description = arguments[0];
	                return this;
	            }
	
	            return this._description;
	        }
	    }, {
	        key: 'name',
	        value: function name(_name) {
	            if (!arguments.length) {
	                return this._name || this.entity.name() + '_' + this._type;
	            }
	
	            this._name = _name;
	            return this;
	        }
	    }, {
	        key: 'disable',
	        value: function disable() {
	            this._enabled = false;
	
	            return this;
	        }
	    }, {
	        key: 'enable',
	        value: function enable() {
	            this._enabled = true;
	
	            return this;
	        }
	
	        /**
	         * @deprecated Use getter "enabled" instead
	         */
	    }, {
	        key: 'isEnabled',
	        value: function isEnabled() {
	            return this.enabled;
	        }
	
	        /**
	         * @deprecated Use getter "entity" instead
	         */
	    }, {
	        key: 'getEntity',
	        value: function getEntity() {
	            return this.entity;
	        }
	
	        /**
	         * @deprecated Specify entity at view creation or use "entity" setter instead
	         */
	    }, {
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name() + '_' + this._type;
	            }
	
	            return this;
	        }
	
	        /*
	         * Supports various syntax
	         * fields([ Field1, Field2 ])
	         * fields(Field1, Field2)
	         * fields([Field1, {Field2, Field3}])
	         * fields(Field1, {Field2, Field3})
	         * fields({Field2, Field3})
	         */
	    }, {
	        key: 'fields',
	        value: function fields() {
	            if (!arguments.length) return this._fields;
	
	            [].slice.call(arguments).map(function (argument) {
	                var _this = this;
	
	                View.flatten(argument).map(function (arg) {
	                    return _this.addField(arg);
	                });
	            }, this);
	
	            return this;
	        }
	    }, {
	        key: 'hasFields',
	        value: function hasFields() {
	            return this.fields.length > 0;
	        }
	    }, {
	        key: 'removeFields',
	        value: function removeFields() {
	            this._fields = [];
	            return this;
	        }
	    }, {
	        key: 'getFields',
	        value: function getFields() {
	            return this._fields;
	        }
	    }, {
	        key: 'getField',
	        value: function getField(fieldName) {
	            return this._fields.filter(function (f) {
	                return f.name() === fieldName;
	            })[0];
	        }
	    }, {
	        key: 'getFieldsOfType',
	        value: function getFieldsOfType(type) {
	            return this._fields.filter(function (f) {
	                return f.type() === type;
	            });
	        }
	    }, {
	        key: 'addField',
	        value: function addField(field) {
	            if (field.order() === null) {
	                field.order(this._fields.length, true);
	            }
	            this._fields.push(field);
	            this._fields = this._fields.sort(function (a, b) {
	                return a.order() - b.order();
	            });
	
	            return this;
	        }
	    }, {
	        key: 'order',
	        value: function order(_order) {
	            if (!arguments.length) return this._order;
	            this._order = _order;
	            return this;
	        }
	    }, {
	        key: 'getReferences',
	        value: function getReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getNonOptimizedReferences',
	        value: function getNonOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getNonOptimizedReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getOptimizedReferences',
	        value: function getOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getOptimizedReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getReferencedLists',
	        value: function getReferencedLists() {
	            return _UtilsReferenceExtractor2['default'].getReferencedLists(this._fields);
	        }
	    }, {
	        key: 'template',
	        value: function template(_template) {
	            if (!arguments.length) {
	                return this._template;
	            }
	
	            this._template = _template;
	
	            return this;
	        }
	    }, {
	        key: 'identifier',
	        value: function identifier() {
	            return this.entity.identifier();
	        }
	    }, {
	        key: 'actions',
	        value: function actions(_actions) {
	            if (!arguments.length) return this._actions;
	            this._actions = _actions;
	            return this;
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: 'errorMessage',
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: 'url',
	        value: function url(_url) {
	            if (!arguments.length) return this._url;
	            this._url = _url;
	            return this;
	        }
	    }, {
	        key: 'getUrl',
	        value: function getUrl(identifierValue) {
	            if (typeof this._url === 'function') {
	                return this._url(identifierValue);
	            }
	
	            return this._url;
	        }
	    }, {
	        key: 'validate',
	        value: function validate(entry) {
	            this._fields.map(function (field) {
	                var validation = field.validation();
	
	                if (typeof validation.validator === 'function') {
	                    validation.validator(entry.values[field.name()], entry.values);
	                }
	            });
	        }
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         */
	    }, {
	        key: 'mapEntry',
	        value: function mapEntry(restEntry) {
	            return _Entry2['default'].createFromRest(restEntry, this._fields, this.entity.name(), this.entity.identifier().name());
	        }
	    }, {
	        key: 'mapEntries',
	        value: function mapEntries(restEntries) {
	            return _Entry2['default'].createArrayFromRest(restEntries, this._fields, this.entity.name(), this.entity.identifier().name());
	        }
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         */
	    }, {
	        key: 'transformEntry',
	        value: function transformEntry(entry) {
	            return entry.transformToRest(this._fields);
	        }
	
	        /**
	         * Add a function to be executed before the view renders
	         *
	         * This is the ideal place to prefetch related entities and manipulate
	         * the dataStore.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - query: the query object (an object representation of the main request
	         *    query string)
	         *  - datastore: where the Entries are stored. The dataStore is accessible
	         *    during rendering
	         *  - view: the current View object
	         *  - entry: the current Entry instance (except in listView)
	         *  - Entry: the Entry constructor (required to transform an object from
	         *    the REST response to an Entry)
	         *  - window: the window object. If you need to fetch anything other than an
	         *    entry and pass it to the view layer, it's the only way.
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.listView().prepare(['datastore', 'view', 'Entry', function(datastore, view, Entry) {
	         *       const posts = datastore.getEntries(view.getEntity().uniqueId);
	         *       const authorIds = posts.map(post => post.values.authorId).join(',');
	         *       return fetch('http://myapi.com/authors?id[]=' + authorIds)
	         *          .then(response => response.json())
	         *          .then(authors => Entry.createArrayFromRest(
	         *              authors,
	         *              [new Field('first_name'), new Field('last_name')],
	         *              'author'
	         *          ))
	         *          .then(authorEntries => datastore.setEntries('authors', authorEntries));
	         *     }]);
	         */
	    }, {
	        key: 'prepare',
	        value: function prepare(_prepare) {
	            if (!arguments.length) return this._prepare;
	            this._prepare = _prepare;
	            return this;
	        }
	    }, {
	        key: 'doPrepare',
	        value: function doPrepare() {
	            return this._prepare.apply(this, arguments);
	        }
	    }, {
	        key: 'enabled',
	        get: function get() {
	            return this._enabled === null ? !!this._fields.length : this._enabled;
	        }
	    }, {
	        key: 'type',
	        get: function get() {
	            return this._type;
	        }
	    }], [{
	        key: 'flatten',
	        value: function flatten(arg) {
	            if (arg.constructor.name === 'Object') {
	                console.warn('Passing literal of Field to fields method is deprecated use array instead');
	                var result = [];
	                for (var fieldName in arg) {
	                    result = result.concat(View.flatten(arg[fieldName]));
	                }
	                return result;
	            }
	            if (Array.isArray(arg)) {
	                return arg.reduce(function (previous, current) {
	                    return previous.concat(View.flatten(current));
	                }, []);
	            }
	            // arg is a scalar
	            return [arg];
	        }
	    }]);
	
	    return View;
	}();
	
	exports['default'] = View;
	module.exports = exports['default'];
	//# sourceMappingURL=View.js.map

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _objectProperties = __webpack_require__(210);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Entry = function () {
	    function Entry(entityName, values, identifierValue) {
	        _classCallCheck(this, Entry);
	
	        this._entityName = entityName;
	        this.values = values || {};
	        this._identifierValue = identifierValue;
	        this.listValues = {};
	    }
	
	    _createClass(Entry, [{
	        key: 'transformToRest',
	
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         *
	         * @return {Object}
	         */
	        value: function transformToRest(fields) {
	
	            var restEntry = (0, _objectProperties.clone)(this.values);
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                if (fieldName in restEntry) {
	                    restEntry[fieldName] = field.getTransformedValue(restEntry[fieldName]);
	                }
	            });
	
	            return (0, _objectProperties.cloneAndNest)(restEntry);
	        }
	    }, {
	        key: 'entityName',
	        get: function get() {
	            return this._entityName;
	        }
	    }, {
	        key: 'identifierValue',
	        get: function get() {
	            return this._identifierValue;
	        }
	    }], [{
	        key: 'createForFields',
	        value: function createForFields(fields, entityName) {
	            var entry = new Entry(entityName);
	            fields.forEach(function (field) {
	                entry.values[field.name()] = field.defaultValue();
	            });
	            return entry;
	        }
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         *
	         * @return {Entry}
	         */
	
	    }, {
	        key: 'createFromRest',
	        value: function createFromRest(restEntry) {
	            var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	            var entityName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	            var identifierName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'id';
	
	            if (!restEntry || Object.keys(restEntry).length == 0) {
	                return Entry.createForFields(fields, entityName);
	            }
	            var excludedFields = fields.filter(function (f) {
	                return !f.flattenable();
	            }).map(function (f) {
	                return f.name();
	            });
	
	            var values = (0, _objectProperties.cloneAndFlatten)(restEntry, excludedFields);
	
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                values[fieldName] = field.getMappedValue(values[fieldName], values);
	            });
	
	            return new Entry(entityName, values, values[identifierName]);
	        }
	
	        /**
	         * Map an array of JS objects from the REST API Response to an array of Entries
	         *
	         * @return {Array[Entry]}
	         */
	
	    }, {
	        key: 'createArrayFromRest',
	        value: function createArrayFromRest(restEntries, fields, entityName, identifierName) {
	            return restEntries.map(function (e) {
	                return Entry.createFromRest(e, fields, entityName, identifierName);
	            });
	        }
	    }]);
	
	    return Entry;
	}();
	
	exports.default = Entry;
	module.exports = exports['default'];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(7);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var _UtilsOrderElement = __webpack_require__(114);
	
	var _UtilsOrderElement2 = _interopRequireDefault(_UtilsOrderElement);
	
	var ListView = function (_View) {
	    _inherits(ListView, _View);
	
	    function ListView(name) {
	        _classCallCheck(this, ListView);
	
	        _get(Object.getPrototypeOf(ListView.prototype), 'constructor', this).call(this, name);
	
	        this._type = 'ListView';
	        this._perPage = 30;
	        this._infinitePagination = false;
	        this._listActions = [];
	        this._batchActions = ['delete'];
	        this._filters = [];
	        this._permanentFilters = {};
	        this._exportFields = null;
	        this._exportOptions = {};
	        this._entryCssClasses = null;
	
	        this._sortField = 'id';
	        this._sortDir = 'DESC';
	    }
	
	    _createClass(ListView, [{
	        key: 'perPage',
	        value: function perPage() {
	            if (!arguments.length) {
	                return this._perPage;
	            }
	            this._perPage = arguments[0];
	            return this;
	        }
	
	        /** @deprecated Use perPage instead */
	    }, {
	        key: 'limit',
	        value: function limit() {
	            if (!arguments.length) {
	                return this.perPage();
	            }
	            return this.perPage(arguments[0]);
	        }
	    }, {
	        key: 'sortField',
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField;
	        }
	    }, {
	        key: 'sortDir',
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            return this.name() + '.' + this._sortField;
	        }
	    }, {
	        key: 'infinitePagination',
	        value: function infinitePagination() {
	            if (arguments.length) {
	                this._infinitePagination = arguments[0];
	                return this;
	            }
	
	            return this._infinitePagination;
	        }
	    }, {
	        key: 'actions',
	        value: function actions(_actions) {
	            if (!arguments.length) {
	                return this._actions;
	            }
	
	            this._actions = _actions;
	
	            return this;
	        }
	    }, {
	        key: 'exportFields',
	        value: function exportFields(_exportFields) {
	            if (!arguments.length) {
	                return this._exportFields;
	            }
	
	            this._exportFields = _exportFields;
	
	            return this;
	        }
	    }, {
	        key: 'exportOptions',
	        value: function exportOptions(_exportOptions) {
	            if (!arguments.length) {
	                return this._exportOptions;
	            }
	
	            this._exportOptions = _exportOptions;
	
	            return this;
	        }
	    }, {
	        key: 'batchActions',
	        value: function batchActions(actions) {
	            if (!arguments.length) {
	                return this._batchActions;
	            }
	
	            this._batchActions = actions;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     posts.listView().permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: 'permanentFilters',
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	
	        /**
	         * Define filters the user can add to the datagrid
	         *
	         *     posts.listView().filters([
	         *       nga.field('title'),
	         *       nga.field('age', 'number')
	         *     ]);
	         *
	         * @param {Field[]} filters list of filters to add to the GUI
	         */
	    }, {
	        key: 'filters',
	        value: function filters(_filters) {
	            if (!arguments.length) {
	                return this._filters;
	            }
	
	            this._filters = _UtilsOrderElement2['default'].order(_filters);
	
	            return this;
	        }
	    }, {
	        key: 'getFilterReferences',
	        value: function getFilterReferences(withRemoteComplete) {
	            var result = {};
	            var lists = this._filters.filter(function (f) {
	                return f.type() === 'reference';
	            });
	
	            var filterFunction = null;
	            if (withRemoteComplete === true) {
	                filterFunction = function filterFunction(f) {
	                    return f.remoteComplete();
	                };
	            } else if (withRemoteComplete === false) {
	                filterFunction = function filterFunction(f) {
	                    return !f.remoteComplete();
	                };
	            }
	
	            if (filterFunction !== null) {
	                lists = lists.filter(filterFunction);
	            }
	
	            for (var i = 0, c = lists.length; i < c; i++) {
	                var list = lists[i];
	                result[list.name()] = list;
	            }
	
	            return result;
	        }
	    }, {
	        key: 'listActions',
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'entryCssClasses',
	        value: function entryCssClasses(classes) {
	            if (!arguments.length) {
	                return this._entryCssClasses;
	            }
	
	            this._entryCssClasses = classes;
	
	            return this;
	        }
	    }, {
	        key: 'getEntryCssClasses',
	        value: function getEntryCssClasses(entry) {
	            if (!this._entryCssClasses) {
	                return '';
	            }
	
	            if (this._entryCssClasses.constructor === Array) {
	                return this._entryCssClasses.join(' ');
	            }
	
	            if (typeof this._entryCssClasses === 'function') {
	                return this._entryCssClasses(entry);
	            }
	
	            return this._entryCssClasses;
	        }
	    }]);
	
	    return ListView;
	}(_View3['default']);
	
	exports['default'] = ListView;
	module.exports = exports['default'];
	//# sourceMappingURL=ListView.js.map

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var _UtilsStringUtils = __webpack_require__(115);
	
	var _UtilsStringUtils2 = _interopRequireDefault(_UtilsStringUtils);
	
	var _FieldField = __webpack_require__(2);
	
	var _FieldField2 = _interopRequireDefault(_FieldField);
	
	var _ViewDashboardView = __webpack_require__(376);
	
	var _ViewDashboardView2 = _interopRequireDefault(_ViewDashboardView);
	
	var _ViewMenuView = __webpack_require__(380);
	
	var _ViewMenuView2 = _interopRequireDefault(_ViewMenuView);
	
	var _ViewListView = __webpack_require__(9);
	
	var _ViewListView2 = _interopRequireDefault(_ViewListView);
	
	var _ViewCreateView = __webpack_require__(375);
	
	var _ViewCreateView2 = _interopRequireDefault(_ViewCreateView);
	
	var _ViewEditView = __webpack_require__(378);
	
	var _ViewEditView2 = _interopRequireDefault(_ViewEditView);
	
	var _ViewDeleteView = __webpack_require__(377);
	
	var _ViewDeleteView2 = _interopRequireDefault(_ViewDeleteView);
	
	var _ViewShowView = __webpack_require__(381);
	
	var _ViewShowView2 = _interopRequireDefault(_ViewShowView);
	
	var _ViewBatchDeleteView = __webpack_require__(374);
	
	var _ViewBatchDeleteView2 = _interopRequireDefault(_ViewBatchDeleteView);
	
	var _ViewExportView = __webpack_require__(379);
	
	var _ViewExportView2 = _interopRequireDefault(_ViewExportView);
	
	var index = 0;
	
	var Entity = function () {
	    function Entity(name) {
	        _classCallCheck(this, Entity);
	
	        this._name = name;
	        this._uniqueId = this._name + '_' + index++;
	        this._baseApiUrl = null;
	        this._label = null;
	        this._identifierField = new _FieldField2["default"]("id");
	        this._isReadOnly = false;
	        this._errorMessage = null;
	        this._order = 0;
	        this._url = null;
	        this._createMethod = null; // manually set the HTTP-method for create operation, defaults to post
	        this._updateMethod = null; // manually set the HTTP-method for update operation, defaults to put
	        this._retrieveMethod = null; // manually set the HTTP-method for the get operation, defaults to get
	        this._deleteMethod = null; // manually set the HTTP-method for the delete operation, defaults to delete
	
	        this._initViews();
	    }
	
	    _createClass(Entity, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _UtilsStringUtils2["default"].camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "menuView",
	        value: function menuView() {
	            return this._views["MenuView"];
	        }
	    }, {
	        key: "dashboardView",
	        value: function dashboardView() {
	            return this._views["DashboardView"];
	        }
	    }, {
	        key: "listView",
	        value: function listView() {
	            return this._views["ListView"];
	        }
	    }, {
	        key: "creationView",
	        value: function creationView() {
	            return this._views["CreateView"];
	        }
	    }, {
	        key: "editionView",
	        value: function editionView() {
	            return this._views["EditView"];
	        }
	    }, {
	        key: "deletionView",
	        value: function deletionView() {
	            return this._views["DeleteView"];
	        }
	    }, {
	        key: "batchDeleteView",
	        value: function batchDeleteView() {
	            return this._views["BatchDeleteView"];
	        }
	    }, {
	        key: "exportView",
	        value: function exportView() {
	            return this._views["ExportView"];
	        }
	    }, {
	        key: "showView",
	        value: function showView() {
	            return this._views["ShowView"];
	        }
	    }, {
	        key: "baseApiUrl",
	        value: function baseApiUrl(_baseApiUrl) {
	            if (!arguments.length) return this._baseApiUrl;
	            this._baseApiUrl = _baseApiUrl;
	            return this;
	        }
	    }, {
	        key: "_initViews",
	        value: function _initViews() {
	            this._views = {
	                "DashboardView": new _ViewDashboardView2["default"]().setEntity(this),
	                "MenuView": new _ViewMenuView2["default"]().setEntity(this),
	                "ListView": new _ViewListView2["default"]().setEntity(this),
	                "CreateView": new _ViewCreateView2["default"]().setEntity(this),
	                "EditView": new _ViewEditView2["default"]().setEntity(this),
	                "DeleteView": new _ViewDeleteView2["default"]().setEntity(this),
	                "BatchDeleteView": new _ViewBatchDeleteView2["default"]().setEntity(this),
	                "ExportView": new _ViewExportView2["default"]().setEntity(this),
	                "ShowView": new _ViewShowView2["default"]().setEntity(this)
	            };
	        }
	    }, {
	        key: "identifier",
	        value: function identifier(value) {
	            if (!arguments.length) return this._identifierField;
	            if (!(value instanceof _FieldField2["default"])) {
	                throw new Error('Entity ' + this.name() + ': identifier must be an instance of Field.');
	            }
	            this._identifierField = value;
	            return this;
	        }
	    }, {
	        key: "readOnly",
	        value: function readOnly() {
	            this._isReadOnly = true;
	
	            this._views["CreateView"].disable();
	            this._views["EditView"].disable();
	            this._views["DeleteView"].disable();
	            this._views["BatchDeleteView"].disable();
	
	            return this;
	        }
	    }, {
	        key: "getErrorMessage",
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: "errorMessage",
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: "order",
	        value: function order(_order) {
	            if (!arguments.length) return this._order;
	            this._order = _order;
	            return this;
	        }
	    }, {
	        key: "url",
	        value: function url(_url) {
	            if (!arguments.length) return this._url;
	            this._url = _url;
	            return this;
	        }
	    }, {
	        key: "getUrl",
	        value: function getUrl(viewType, identifierValue, identifierName) {
	            if (typeof this._url === 'function') {
	                return this._url(this.name(), viewType, identifierValue, identifierName);
	            }
	
	            return this._url;
	        }
	    }, {
	        key: "createMethod",
	        value: function createMethod(_createMethod) {
	            if (!arguments.length) return this._createMethod;
	            this._createMethod = _createMethod;
	            return this;
	        }
	    }, {
	        key: "updateMethod",
	        value: function updateMethod(_updateMethod) {
	            if (!arguments.length) return this._updateMethod;
	            this._updateMethod = _updateMethod;
	            return this;
	        }
	    }, {
	        key: "retrieveMethod",
	        value: function retrieveMethod(_retrieveMethod) {
	            if (!arguments.length) return this._retrieveMethod;
	            this._retrieveMethod = _retrieveMethod;
	            return this;
	        }
	    }, {
	        key: "deleteMethod",
	        value: function deleteMethod(_deleteMethod) {
	            if (!arguments.length) return this._deleteMethod;
	            this._deleteMethod = _deleteMethod;
	            return this;
	        }
	    }, {
	        key: "uniqueId",
	        get: function get() {
	            return this._uniqueId;
	        }
	    }, {
	        key: "views",
	        get: function get() {
	            return this._views;
	        }
	    }, {
	        key: "isReadOnly",
	        get: function get() {
	            return this._isReadOnly;
	        }
	    }]);
	
	    return Entity;
	}();
	
	exports["default"] = Entity;
	module.exports = exports["default"];
	//# sourceMappingURL=Entity.js.map

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var ChoiceField = function (_Field) {
	    _inherits(ChoiceField, _Field);
	
	    function ChoiceField(name) {
	        _classCallCheck(this, ChoiceField);
	
	        _get(Object.getPrototypeOf(ChoiceField.prototype), "constructor", this).call(this, name);
	        this._type = "choice";
	        this._choices = [];
	    }
	
	    _createClass(ChoiceField, [{
	        key: "choices",
	        value: function choices(_choices) {
	            if (!arguments.length) return this._choices;
	            this._choices = _choices;
	
	            return this;
	        }
	    }, {
	        key: "getLabelForChoice",
	        value: function getLabelForChoice(value, entry) {
	            var choices = typeof this._choices === 'function' ? this._choices(entry) : this._choices;
	            var choice = choices.filter(function (c) {
	                return c.value == value;
	            }).pop();
	            return choice ? choice.label : null;
	        }
	    }]);
	
	    return ChoiceField;
	}(_Field3["default"]);
	
	exports["default"] = ChoiceField;
	module.exports = exports["default"];
	//# sourceMappingURL=ChoiceField.js.map

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var ReferenceField = function (_Field) {
	    _inherits(ReferenceField, _Field);
	
	    function ReferenceField(name) {
	        _classCallCheck(this, ReferenceField);
	
	        _get(Object.getPrototypeOf(ReferenceField.prototype), 'constructor', this).call(this, name);
	        this._type = 'reference';
	        this._targetEntity = null;
	        this._targetField = null;
	        this._perPage = 30;
	        this._permanentFilters = null;
	        this._sortField = null;
	        this._sortDir = null;
	        this._singleApiCall = false;
	        this._detailLink = true;
	        this._remoteComplete = false;
	        this._remoteCompleteOptions = {
	            refreshDelay: 500
	        };
	    }
	
	    _createClass(ReferenceField, [{
	        key: 'perPage',
	        value: function perPage(_perPage) {
	            if (!arguments.length) return this._perPage;
	            this._perPage = _perPage;
	            return this;
	        }
	    }, {
	        key: 'datagridName',
	        value: function datagridName() {
	            return this._targetEntity.name() + '_ListView';
	        }
	    }, {
	        key: 'targetEntity',
	        value: function targetEntity(entity) {
	            if (!arguments.length) {
	                return this._targetEntity;
	            }
	            this._targetEntity = entity;
	
	            return this;
	        }
	    }, {
	        key: 'targetField',
	        value: function targetField(field) {
	            if (!arguments.length) return this._targetField;
	            this._targetField = field;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     nga.field('post_id', 'reference').permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts/:id?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: 'permanentFilters',
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	
	        /**
	         * @deprecated use permanentFilters() instead
	         */
	    }, {
	        key: 'filters',
	        value: function filters(_filters) {
	            console.warn('ReferenceField.filters() is deprecated, please use ReferenceField.permanentFilters() instead');
	            return this.permanentFilters(_filters);
	        }
	    }, {
	        key: 'sortField',
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField;
	        }
	    }, {
	        key: 'sortDir',
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: 'singleApiCall',
	        value: function singleApiCall(_singleApiCall) {
	            if (!arguments.length) return this._singleApiCall;
	            this._singleApiCall = _singleApiCall;
	            return this;
	        }
	    }, {
	        key: 'hasSingleApiCall',
	        value: function hasSingleApiCall() {
	            return typeof this._singleApiCall === 'function';
	        }
	    }, {
	        key: 'getSingleApiCall',
	        value: function getSingleApiCall(identifiers) {
	            return this.hasSingleApiCall() ? this._singleApiCall(identifiers) : this._singleApiCall;
	        }
	    }, {
	        key: 'getIdentifierValues',
	        value: function getIdentifierValues(rawValues) {
	            var results = {};
	            var identifierName = this._name;
	            for (var i = 0, l = rawValues.length; i < l; i++) {
	                var identifier = rawValues[i][identifierName];
	                if (identifier == null) {
	                    continue;
	                }
	
	                if (identifier instanceof Array) {
	                    for (var j in identifier) {
	                        results[identifier[j]] = true;
	                    }
	                    continue;
	                }
	
	                results[identifier] = true;
	            }
	
	            return Object.keys(results);
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            if (!this.sortField()) {
	                return null;
	            }
	
	            return this._targetEntity.name() + '_ListView.' + this.sortField();
	        }
	
	        /**
	         * Enable autocompletion using REST API for choices.
	         *
	         * Available options are:
	         *
	         * * `refreshDelay`: minimal delay between two API calls in milliseconds. By default: 500.
	         * * `searchQuery`: a function returning the parameters to add to the query string basd on the input string.
	         *
	         *       new ReferenceField('authors')
	         *           .targetEntity(author)
	         *           .targetField(new Field('name'))
	         *           .remoteComplete(true, {
	         *               refreshDelay: 300,
	         *               // populate choices from the response of GET /tags?q=XXX
	         *               searchQuery: function(search) { return { q: search }; }
	         *           })
	         *           .perPage(10) // limit the number of results to 10
	         *
	         * @param {Boolean} remoteComplete true to enable remote complete. False by default
	         * @param {Object} options Remote completion options (optional)
	         */
	    }, {
	        key: 'remoteComplete',
	        value: function remoteComplete(_remoteComplete, options) {
	            if (!arguments.length) return this._remoteComplete;
	            this._remoteComplete = _remoteComplete;
	            if (options) {
	                this.remoteCompleteOptions(options);
	            }
	            return this;
	        }
	    }, {
	        key: 'remoteCompleteOptions',
	        value: function remoteCompleteOptions(options) {
	            if (!arguments.length) return this._remoteCompleteOptions;
	            this._remoteCompleteOptions = options;
	            return this;
	        }
	    }]);
	
	    return ReferenceField;
	}(_Field3['default']);
	
	exports['default'] = ReferenceField;
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceField.js.map

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	
	    getReferencedLists: function getReferencedLists(fields) {
	        return this.indexByName(fields.filter(function (f) {
	            return f.type() === 'referenced_list';
	        }));
	    },
	    getReferences: function getReferences(fields, withRemoteComplete) {
	        var optimized = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	        var references = fields.filter(function (f) {
	            return f.type() === 'reference' || f.type() === 'reference_many';
	        });
	        if (withRemoteComplete === true) {
	            references = references.filter(function (r) {
	                return r.remoteComplete();
	            });
	        } else if (withRemoteComplete === false) {
	            references = references.filter(function (r) {
	                return !r.remoteComplete();
	            });
	        }
	        if (optimized !== null) {
	            references = references.filter(function (r) {
	                return r.hasSingleApiCall() === optimized;
	            });
	        }
	        return this.indexByName(references);
	    },
	    getNonOptimizedReferences: function getNonOptimizedReferences(fields, withRemoteComplete) {
	        return this.getReferences(fields, withRemoteComplete, false);
	    },
	    getOptimizedReferences: function getOptimizedReferences(fields, withRemoteComplete) {
	        return this.getReferences(fields, withRemoteComplete, true);
	    },
	    indexByName: function indexByName(references) {
	        return references.reduce(function (referencesByName, reference) {
	            referencesByName[reference.name()] = reference;
	            return referencesByName;
	        }, {});
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceExtractor.js.map

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/*! @preserve
	 * numeral.js
	 * version : 1.5.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function () {
	
	    /************************************
	        Variables
	    ************************************/
	
	    var _numeral,
	        VERSION = '1.5.6',
	
	    // internal storage for language config files
	    languages = {},
	        defaults = {
	        currentLanguage: 'en',
	        zeroFormat: null,
	        nullFormat: null,
	        defaultFormat: '0,0'
	    },
	        options = {
	        currentLanguage: defaults.currentLanguage,
	        zeroFormat: defaults.zeroFormat,
	        nullFormat: defaults.nullFormat,
	        defaultFormat: defaults.defaultFormat
	    },
	        byteSuffixes = {
	        bytes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	        iec: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	    };
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(number) {
	        this._value = number;
	    }
	
	    /**
	     * Implementation of toFixed() that treats floats more like decimals
	     *
	     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	     * problems for accounting- and finance-related software.
	     */
	    function toFixed(value, maxDecimals, roundingFunction, optionals) {
	        var splitValue = value.toString().split('.'),
	            minDecimals = maxDecimals - (optionals || 0),
	            boundedPrecision,
	            optionalsRegExp,
	            power,
	            output;
	
	        // Use the smallest precision value possible to avoid errors from floating point representation
	        if (splitValue.length === 2) {
	            boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	        } else {
	            boundedPrecision = minDecimals;
	        }
	
	        power = Math.pow(10, boundedPrecision);
	
	        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
	        // Multiply up by precision, round accurately, then divide and use native toFixed():
	        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
	
	        if (optionals > maxDecimals - boundedPrecision) {
	            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	            output = output.replace(optionalsRegExp, '');
	        }
	
	        return output;
	    }
	
	    /************************************
	        Formatting
	    ************************************/
	
	    // determine what type of formatting we need to do
	    function formatNumeral(n, format, roundingFunction) {
	        var output;
	
	        if (n._value === 0 && options.zeroFormat !== null) {
	            output = options.zeroFormat;
	        } else if (n._value === null && options.nullFormat !== null) {
	            output = options.nullFormat;
	        } else {
	            // figure out what kind of format we are dealing with
	            if (format.indexOf('$') > -1) {
	                output = formatCurrency(n, format, roundingFunction);
	            } else if (format.indexOf('%') > -1) {
	                output = formatPercentage(n, format, roundingFunction);
	            } else if (format.indexOf(':') > -1) {
	                output = formatTime(n, format);
	            } else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) {
	                output = formatBytes(n, format, roundingFunction);
	            } else if (format.indexOf('o') > -1) {
	                output = formatOrdinal(n, format, roundingFunction);
	            } else {
	                output = formatNumber(n._value, format, roundingFunction);
	            }
	        }
	
	        return output;
	    }
	
	    function formatCurrency(n, format, roundingFunction) {
	        var symbolIndex = format.indexOf('$'),
	            openParenIndex = format.indexOf('('),
	            minusSignIndex = format.indexOf('-'),
	            space = '',
	            spliceIndex,
	            output;
	
	        // check for space before or after currency
	        if (format.indexOf(' $') > -1) {
	            space = ' ';
	            format = format.replace(' $', '');
	        } else if (format.indexOf('$ ') > -1) {
	            space = ' ';
	            format = format.replace('$ ', '');
	        } else {
	            format = format.replace('$', '');
	        }
	
	        // format the number
	        output = formatNumber(n._value, format, roundingFunction, false);
	
	        // position the symbol
	        if (symbolIndex <= 1) {
	            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
	                output = output.split('');
	                spliceIndex = 1;
	                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) {
	                    // the symbol appears before the "(" or "-"
	                    spliceIndex = 0;
	                }
	                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
	                output = output.join('');
	            } else {
	                output = languages[options.currentLanguage].currency.symbol + space + output;
	            }
	        } else {
	            if (output.indexOf(')') > -1) {
	                output = output.split('');
	                output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
	                output = output.join('');
	            } else {
	                output = output + space + languages[options.currentLanguage].currency.symbol;
	            }
	        }
	
	        return output;
	    }
	
	    function formatPercentage(n, format, roundingFunction) {
	        var space = '',
	            output,
	            value = n._value * 100;
	
	        // check for space before %
	        if (format.indexOf(' %') > -1) {
	            space = ' ';
	            format = format.replace(' %', '');
	        } else {
	            format = format.replace('%', '');
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        if (output.indexOf(')') > -1) {
	            output = output.split('');
	            output.splice(-1, 0, space + '%');
	            output = output.join('');
	        } else {
	            output = output + space + '%';
	        }
	
	        return output;
	    }
	
	    function formatBytes(n, format, roundingFunction) {
	        var output,
	            suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes,
	            value = n._value,
	            suffix = '',
	            power,
	            min,
	            max;
	
	        // check for space before
	        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
	            suffix = ' ';
	            format = format.replace(' ib', '').replace(' b', '');
	        } else {
	            format = format.replace('ib', '').replace('b', '');
	        }
	
	        for (power = 0; power <= suffixes.length; power++) {
	            min = Math.pow(1024, power);
	            max = Math.pow(1024, power + 1);
	
	            if (value === null || value === 0 || value >= min && value < max) {
	                suffix += suffixes[power];
	
	                if (min > 0) {
	                    value = value / min;
	                }
	
	                break;
	            }
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        return output + suffix;
	    }
	
	    function formatOrdinal(n, format, roundingFunction) {
	        var output,
	            ordinal = '';
	
	        // check for space before
	        if (format.indexOf(' o') > -1) {
	            ordinal = ' ';
	            format = format.replace(' o', '');
	        } else {
	            format = format.replace('o', '');
	        }
	
	        ordinal += languages[options.currentLanguage].ordinal(n._value);
	
	        output = formatNumber(n._value, format, roundingFunction);
	
	        return output + ordinal;
	    }
	
	    function formatTime(n) {
	        var hours = Math.floor(n._value / 60 / 60),
	            minutes = Math.floor((n._value - hours * 60 * 60) / 60),
	            seconds = Math.round(n._value - hours * 60 * 60 - minutes * 60);
	
	        return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	    }
	
	    function formatNumber(value, format, roundingFunction) {
	        var negP = false,
	            signed = false,
	            optDec = false,
	            abbr = '',
	            abbrK = false,
	            // force abbreviation to thousands
	        abbrM = false,
	            // force abbreviation to millions
	        abbrB = false,
	            // force abbreviation to billions
	        abbrT = false,
	            // force abbreviation to trillions
	        abbrForce = false,
	            // force abbreviation
	        abs,
	            min,
	            max,
	            power,
	            w,
	            precision,
	            thousands,
	            d = '',
	            neg = false;
	
	        if (value === null) {
	            value = 0;
	        }
	
	        abs = Math.abs(value);
	
	        // see if we should use parentheses for negative number or if we should prefix with a sign
	        // if both are present we default to parentheses
	        if (format.indexOf('(') > -1) {
	            negP = true;
	            format = format.slice(1, -1);
	        } else if (format.indexOf('+') > -1) {
	            signed = true;
	            format = format.replace(/\+/g, '');
	        }
	
	        // see if abbreviation is wanted
	        if (format.indexOf('a') > -1) {
	            // check if abbreviation is specified
	            abbrK = format.indexOf('aK') >= 0;
	            abbrM = format.indexOf('aM') >= 0;
	            abbrB = format.indexOf('aB') >= 0;
	            abbrT = format.indexOf('aT') >= 0;
	            abbrForce = abbrK || abbrM || abbrB || abbrT;
	
	            // check for space before abbreviation
	            if (format.indexOf(' a') > -1) {
	                abbr = ' ';
	            }
	
	            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');
	
	            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
	                // trillion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
	                value = value / Math.pow(10, 12);
	            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
	                // billion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
	                value = value / Math.pow(10, 9);
	            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
	                // million
	                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
	                value = value / Math.pow(10, 6);
	            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
	                // thousand
	                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
	                value = value / Math.pow(10, 3);
	            }
	        }
	
	        if (format.indexOf('[.]') > -1) {
	            optDec = true;
	            format = format.replace('[.]', '.');
	        }
	
	        w = value.toString().split('.')[0];
	        precision = format.split('.')[1];
	        thousands = format.indexOf(',');
	
	        if (precision) {
	            if (precision.indexOf('[') > -1) {
	                precision = precision.replace(']', '');
	                precision = precision.split('[');
	                d = toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
	            } else {
	                d = toFixed(value, precision.length, roundingFunction);
	            }
	
	            w = d.split('.')[0];
	
	            if (d.indexOf('.') > -1) {
	                d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
	            } else {
	                d = '';
	            }
	
	            if (optDec && Number(d.slice(1)) === 0) {
	                d = '';
	            }
	        } else {
	            w = toFixed(value, null, roundingFunction);
	        }
	
	        // format number
	        if (w.indexOf('-') > -1) {
	            w = w.slice(1);
	            neg = true;
	        }
	
	        if (thousands > -1) {
	            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
	        }
	
	        if (format.indexOf('.') === 0) {
	            w = '';
	        }
	
	        return (negP && neg ? '(' : '') + (!negP && neg ? '-' : '') + (!neg && signed ? '+' : '') + w + d + (abbr ? abbr : '') + (negP && neg ? ')' : '');
	    }
	
	    /************************************
	        Unformatting
	    ************************************/
	
	    // revert to number
	    function unformatNumeral(n, string) {
	        var stringOriginal = string,
	            thousandRegExp,
	            millionRegExp,
	            billionRegExp,
	            trillionRegExp,
	            bytesMultiplier = false,
	            power,
	            value;
	
	        if (string.indexOf(':') > -1) {
	            value = unformatTime(string);
	        } else {
	            if (string === options.zeroFormat || string === options.nullFormat) {
	                value = 0;
	            } else {
	                if (languages[options.currentLanguage].delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
	                }
	
	                // see if abbreviations are there so that we can multiply to the correct number
	                thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	
	                // see if bytes are there so that we can multiply to the correct number
	                for (power = 1; power <= byteSuffixes.bytes.length; power++) {
	                    bytesMultiplier = string.indexOf(byteSuffixes.bytes[power]) > -1 || string.indexOf(byteSuffixes.iec[power]) > -1 ? Math.pow(1024, power) : false;
	
	                    if (bytesMultiplier) {
	                        break;
	                    }
	                }
	
	                // do some math to create our number
	                value = bytesMultiplier ? bytesMultiplier : 1;
	                value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
	                value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
	                value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
	                value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
	                // check for percentage
	                value *= string.indexOf('%') > -1 ? 0.01 : 1;
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	                // remove non numbers
	                value *= Number(string.replace(/[^0-9\.]+/g, ''));
	                // round if we are talking about bytes
	                value = bytesMultiplier ? Math.ceil(value) : value;
	            }
	        }
	
	        n._value = value;
	
	        return n._value;
	    }
	    function unformatTime(string) {
	        var timeArray = string.split(':'),
	            seconds = 0;
	        // turn hours and minutes into seconds and add them all up
	        if (timeArray.length === 3) {
	            // hours
	            seconds = seconds + Number(timeArray[0]) * 60 * 60;
	            // minutes
	            seconds = seconds + Number(timeArray[1]) * 60;
	            // seconds
	            seconds = seconds + Number(timeArray[2]);
	        } else if (timeArray.length === 2) {
	            // minutes
	            seconds = seconds + Number(timeArray[0]) * 60;
	            // seconds
	            seconds = seconds + Number(timeArray[1]);
	        }
	        return Number(seconds);
	    }
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    _numeral = function numeral(input) {
	        if (_numeral.isNumeral(input)) {
	            input = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            input = 0;
	        } else if (input === null) {
	            input = null;
	        } else if (!Number(input)) {
	            input = _numeral.fn.unformat(input);
	        } else {
	            input = Number(input);
	        }
	
	        return new Numeral(input);
	    };
	
	    // version number
	    _numeral.version = VERSION;
	
	    // compare numeral object
	    _numeral.isNumeral = function (obj) {
	        return obj instanceof Numeral;
	    };
	
	    // This function will load languages and then set the global language.  If
	    // no arguments are passed in, it will simply return the current global
	    // language key.
	    _numeral.language = function (key, values) {
	        if (!key) {
	            return options.currentLanguage;
	        }
	
	        key = key.toLowerCase();
	
	        if (key && !values) {
	            if (!languages[key]) {
	                throw new Error('Unknown language : ' + key);
	            }
	
	            options.currentLanguage = key;
	        }
	
	        if (values || !languages[key]) {
	            loadLanguage(key, values);
	        }
	
	        return _numeral;
	    };
	
	    _numeral.reset = function () {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    // This function provides access to the loaded language data.  If
	    // no arguments are passed in, it will simply return the current
	    // global language object.
	    _numeral.languageData = function (key) {
	        if (!key) {
	            return languages[options.currentLanguage];
	        }
	
	        if (!languages[key]) {
	            throw new Error('Unknown language : ' + key);
	        }
	
	        return languages[key];
	    };
	
	    _numeral.language('en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function ordinal(number) {
	            var b = number % 10;
	            return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    _numeral.zeroFormat = function (format) {
	        options.zeroFormat = typeof format === 'string' ? format : null;
	    };
	
	    _numeral.nullFormat = function (format) {
	        options.nullFormat = typeof format === 'string' ? format : null;
	    };
	
	    _numeral.defaultFormat = function (format) {
	        options.defaultFormat = typeof format === 'string' ? format : '0.0';
	    };
	
	    _numeral.validate = function (val, culture) {
	        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, languageData, temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.languageData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current language
	            languageData = _numeral.languageData(culture);
	        } catch (e) {
	            languageData = _numeral.languageData(_numeral.language());
	        }
	
	        //setup the delimiters and currency symbol based on culture/language
	        _currSymbol = languageData.currency.symbol;
	        _abbrObj = languageData.abbreviations;
	        _decimalSep = languageData.delimiters.decimal;
	        if (languageData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = languageData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
	                    } else {
	                        return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /************************************
	        Helpers
	    ************************************/
	
	    function loadLanguage(key, values) {
	        languages[key] = values;
	    }
	
	    /************************************
	        Floating-point helpers
	    ************************************/
	
	    // The floating-point helper functions and implementation
	    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
	
	    // Production steps of ECMA-262, Edition 5, 15.4.4.21
	    // Reference: http://es5.github.io/#x15.4.4.21
	    if (!Array.prototype.reduce) {
	        Array.prototype.reduce = function (callback /*, initialValue*/) {
	            'use strict';
	
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(this),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 2) {
	                value = arguments[1];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        };
	    }
	
	    /**
	     * Computes the multiplier necessary to make x >= 1,
	     * effectively eliminating miscalculations caused by
	     * finite precision.
	     */
	    function multiplier(x) {
	        var parts = x.toString().split('.');
	        if (parts.length < 2) {
	            return 1;
	        }
	        return Math.pow(10, parts[1].length);
	    }
	
	    /**
	     * Given a variable number of arguments, returns the maximum
	     * multiplier that must be used to normalize an operation involving
	     * all of them.
	     */
	    function correctionFactor() {
	        var args = Array.prototype.slice.call(arguments);
	        return args.reduce(function (prev, next) {
	            var mp = multiplier(prev),
	                mn = multiplier(next);
	            return mp > mn ? mp : mn;
	        }, -Infinity);
	    }
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    _numeral.fn = Numeral.prototype = {
	
	        clone: function clone() {
	            return _numeral(this);
	        },
	
	        format: function format(inputString, roundingFunction) {
	            return formatNumeral(this, inputString ? inputString : options.defaultFormat, roundingFunction !== undefined ? roundingFunction : Math.round);
	        },
	
	        unformat: function unformat(inputString) {
	            if (Object.prototype.toString.call(inputString) === '[object Number]') {
	                return inputString;
	            }
	
	            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
	        },
	
	        value: function value() {
	            return this._value;
	        },
	
	        valueOf: function valueOf() {
	            return this._value;
	        },
	
	        set: function set(value) {
	            this._value = Number(value);
	            return this;
	        },
	
	        add: function add(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + corrFactor * curr;
	            }
	            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
	            return this;
	        },
	
	        subtract: function subtract(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - corrFactor * curr;
	            }
	            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
	            return this;
	        },
	
	        multiply: function multiply(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback, 1);
	            return this;
	        },
	
	        divide: function divide(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return accum * corrFactor / (curr * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback);
	            return this;
	        },
	
	        difference: function difference(value) {
	            return Math.abs(_numeral(this._value).subtract(value).value());
	        }
	
	    };
	
	    /************************************
	        Exposing Numeral
	    ************************************/
	
	    // CommonJS module is defined
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = _numeral;
	    }
	
	    /*global ender:false */
	    if (typeof ender === 'undefined') {
	        // here, `this` means `window` in the browser, or `global` on the server
	        // add `numeral` as a global object via a string identifier,
	        // for Closure Compiler 'advanced' mode
	        this['numeral'] = _numeral;
	    }
	
	    /*global define:false */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return _numeral;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}).call(undefined);

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) {
	    return [];
	};
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {"use strict";
	
	var nextTick = __webpack_require__(15).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function () {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function () {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout = exports.clearInterval = function (timeout) {
	  timeout.close();
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function () {};
	Timeout.prototype.close = function () {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function (item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function (item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function (item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout) item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function (fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function (id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16).setImmediate, __webpack_require__(16).clearImmediate))

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($translateProvider) {
	    $translateProvider.translations('en', __webpack_require__(169));
	    $translateProvider.translations('es', __webpack_require__(170));
	    $translateProvider.translations('ca', __webpack_require__(168));
	
	    $translateProvider.useSanitizeValueStrategy(null);
	
	    $translateProvider.registerAvailableLanguageKeys(['en', 'es', 'ca']);
	    $translateProvider.preferredLanguage('es');
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Should already be required, here for clarity
	__webpack_require__(5);
	
	// Load Angular and dependent libs
	__webpack_require__(213);
	__webpack_require__(215);
	
	// Now load Angular Material
	__webpack_require__(220);
	
	// Export namespace
	module.exports = 'ngMaterial';

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * State-based routing for AngularJS
	 * @version v0.4.3
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	  /*jshint globalstrict:true*/
	  /*global angular:false*/
	  'use strict';
	
	  var isDefined = angular.isDefined,
	      isFunction = angular.isFunction,
	      isString = angular.isString,
	      isObject = angular.isObject,
	      isArray = angular.isArray,
	      forEach = angular.forEach,
	      extend = angular.extend,
	      copy = angular.copy,
	      toJson = angular.toJson;
	
	  function inherit(parent, extra) {
	    return extend(new (extend(function () {}, { prototype: parent }))(), extra);
	  }
	
	  function merge(dst) {
	    forEach(arguments, function (obj) {
	      if (obj !== dst) {
	        forEach(obj, function (value, key) {
	          if (!dst.hasOwnProperty(key)) dst[key] = value;
	        });
	      }
	    });
	    return dst;
	  }
	
	  /**
	   * Finds the common ancestor path between two states.
	   *
	   * @param {Object} first The first state.
	   * @param {Object} second The second state.
	   * @return {Array} Returns an array of state names in descending order, not including the root.
	   */
	  function ancestors(first, second) {
	    var path = [];
	
	    for (var n in first.path) {
	      if (first.path[n] !== second.path[n]) break;
	      path.push(first.path[n]);
	    }
	    return path;
	  }
	
	  /**
	   * IE8-safe wrapper for `Object.keys()`.
	   *
	   * @param {Object} object A JavaScript object.
	   * @return {Array} Returns the keys of the object as an array.
	   */
	  function objectKeys(object) {
	    if (Object.keys) {
	      return Object.keys(object);
	    }
	    var result = [];
	
	    forEach(object, function (val, key) {
	      result.push(key);
	    });
	    return result;
	  }
	
	  /**
	   * IE8-safe wrapper for `Array.prototype.indexOf()`.
	   *
	   * @param {Array} array A JavaScript array.
	   * @param {*} value A value to search the array for.
	   * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	   */
	  function indexOf(array, value) {
	    if (Array.prototype.indexOf) {
	      return array.indexOf(value, Number(arguments[2]) || 0);
	    }
	    var len = array.length >>> 0,
	        from = Number(arguments[2]) || 0;
	    from = from < 0 ? Math.ceil(from) : Math.floor(from);
	
	    if (from < 0) from += len;
	
	    for (; from < len; from++) {
	      if (from in array && array[from] === value) return from;
	    }
	    return -1;
	  }
	
	  /**
	   * Merges a set of parameters with all parameters inherited between the common parents of the
	   * current state and a given destination state.
	   *
	   * @param {Object} currentParams The value of the current state parameters ($stateParams).
	   * @param {Object} newParams The set of parameters which will be composited with inherited params.
	   * @param {Object} $current Internal definition of object representing the current state.
	   * @param {Object} $to Internal definition of object representing state to transition to.
	   */
	  function inheritParams(currentParams, newParams, $current, $to) {
	    var parents = ancestors($current, $to),
	        parentParams,
	        inherited = {},
	        inheritList = [];
	
	    for (var i in parents) {
	      if (!parents[i] || !parents[i].params) continue;
	      parentParams = objectKeys(parents[i].params);
	      if (!parentParams.length) continue;
	
	      for (var j in parentParams) {
	        if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	        inheritList.push(parentParams[j]);
	        inherited[parentParams[j]] = currentParams[parentParams[j]];
	      }
	    }
	    return extend({}, inherited, newParams);
	  }
	
	  /**
	   * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	   *
	   * @param {Object} a The first object.
	   * @param {Object} b The second object.
	   * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	   *                     it defaults to the list of keys in `a`.
	   * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	   */
	  function equalForKeys(a, b, keys) {
	    if (!keys) {
	      keys = [];
	      for (var n in a) {
	        keys.push(n);
	      } // Used instead of Object.keys() for IE8 compatibility
	    }
	
	    for (var i = 0; i < keys.length; i++) {
	      var k = keys[i];
	      if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	    }
	    return true;
	  }
	
	  /**
	   * Returns the subset of an object, based on a list of keys.
	   *
	   * @param {Array} keys
	   * @param {Object} values
	   * @return {Boolean} Returns a subset of `values`.
	   */
	  function filterByKeys(keys, values) {
	    var filtered = {};
	
	    forEach(keys, function (name) {
	      filtered[name] = values[name];
	    });
	    return filtered;
	  }
	
	  // like _.indexBy
	  // when you know that your index values will be unique, or you want last-one-in to win
	  function indexBy(array, propName) {
	    var result = {};
	    forEach(array, function (item) {
	      result[item[propName]] = item;
	    });
	    return result;
	  }
	
	  // extracted from underscore.js
	  // Return a copy of the object only containing the whitelisted properties.
	  function pick(obj) {
	    var copy = {};
	    var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	    forEach(keys, function (key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  }
	
	  // extracted from underscore.js
	  // Return a copy of the object omitting the blacklisted properties.
	  function omit(obj) {
	    var copy = {};
	    var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	    for (var key in obj) {
	      if (indexOf(keys, key) == -1) copy[key] = obj[key];
	    }
	    return copy;
	  }
	
	  function pluck(collection, key) {
	    var result = isArray(collection) ? [] : {};
	
	    forEach(collection, function (val, i) {
	      result[i] = isFunction(key) ? key(val) : val[key];
	    });
	    return result;
	  }
	
	  function filter(collection, callback) {
	    var array = isArray(collection);
	    var result = array ? [] : {};
	    forEach(collection, function (val, i) {
	      if (callback(val, i)) {
	        result[array ? result.length : i] = val;
	      }
	    });
	    return result;
	  }
	
	  function map(collection, callback) {
	    var result = isArray(collection) ? [] : {};
	
	    forEach(collection, function (val, i) {
	      result[i] = callback(val, i);
	    });
	    return result;
	  }
	
	  // issue #2676 #2889
	  function silenceUncaughtInPromise(promise) {
	    return promise.then(undefined, function () {}) && promise;
	  }
	
	  /**
	   * @ngdoc overview
	   * @name ui.router.util
	   *
	   * @description
	   * # ui.router.util sub-module
	   *
	   * This module is a dependency of other sub-modules. Do not include this module as a dependency
	   * in your angular app (use {@link ui.router} module instead).
	   *
	   */
	  angular.module('ui.router.util', ['ng']);
	
	  /**
	   * @ngdoc overview
	   * @name ui.router.router
	   * 
	   * @requires ui.router.util
	   *
	   * @description
	   * # ui.router.router sub-module
	   *
	   * This module is a dependency of other sub-modules. Do not include this module as a dependency
	   * in your angular app (use {@link ui.router} module instead).
	   */
	  angular.module('ui.router.router', ['ui.router.util']);
	
	  /**
	   * @ngdoc overview
	   * @name ui.router.state
	   * 
	   * @requires ui.router.router
	   * @requires ui.router.util
	   *
	   * @description
	   * # ui.router.state sub-module
	   *
	   * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	   * in your angular app (use {@link ui.router} module instead).
	   * 
	   */
	  angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	  /**
	   * @ngdoc overview
	   * @name ui.router
	   *
	   * @requires ui.router.state
	   *
	   * @description
	   * # ui.router
	   * 
	   * ## The main module for ui.router 
	   * There are several sub-modules included with the ui.router module, however only this module is needed
	   * as a dependency within your angular app. The other modules are for organization purposes. 
	   *
	   * The modules are:
	   * * ui.router - the main "umbrella" module
	   * * ui.router.router - 
	   * 
	   * *You'll need to include **only** this module as the dependency within your angular app.*
	   * 
	   * <pre>
	   * <!doctype html>
	   * <html ng-app="myApp">
	   * <head>
	   *   <script src="js/angular.js"></script>
	   *   <!-- Include the ui-router script -->
	   *   <script src="js/angular-ui-router.min.js"></script>
	   *   <script>
	   *     // ...and add 'ui.router' as a dependency
	   *     var myApp = angular.module('myApp', ['ui.router']);
	   *   </script>
	   * </head>
	   * <body>
	   * </body>
	   * </html>
	   * </pre>
	   */
	  angular.module('ui.router', ['ui.router.state']);
	
	  angular.module('ui.router.compat', ['ui.router']);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$resolve
	   *
	   * @requires $q
	   * @requires $injector
	   *
	   * @description
	   * Manages resolution of (acyclic) graphs of promises.
	   */
	  $Resolve.$inject = ['$q', '$injector'];
	  function $Resolve($q, $injector) {
	
	    var VISIT_IN_PROGRESS = 1,
	        VISIT_DONE = 2,
	        NOTHING = {},
	        NO_DEPENDENCIES = [],
	        NO_LOCALS = NOTHING,
	        NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$resolve#study
	     * @methodOf ui.router.util.$resolve
	     *
	     * @description
	     * Studies a set of invocables that are likely to be used multiple times.
	     * <pre>
	     * $resolve.study(invocables)(locals, parent, self)
	     * </pre>
	     * is equivalent to
	     * <pre>
	     * $resolve.resolve(invocables, locals, parent, self)
	     * </pre>
	     * but the former is more efficient (in fact `resolve` just calls `study` 
	     * internally).
	     *
	     * @param {object} invocables Invocable objects
	     * @return {function} a function to pass in locals, parent and self
	     */
	    this.study = function (invocables) {
	      if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	      var invocableKeys = objectKeys(invocables || {});
	
	      // Perform a topological sort of invocables to build an ordered plan
	      var plan = [],
	          cycle = [],
	          visited = {};
	      function visit(value, key) {
	        if (visited[key] === VISIT_DONE) return;
	
	        cycle.push(key);
	        if (visited[key] === VISIT_IN_PROGRESS) {
	          cycle.splice(0, indexOf(cycle, key));
	          throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	        }
	        visited[key] = VISIT_IN_PROGRESS;
	
	        if (isString(value)) {
	          plan.push(key, [function () {
	            return $injector.get(value);
	          }], NO_DEPENDENCIES);
	        } else {
	          var params = $injector.annotate(value);
	          forEach(params, function (param) {
	            if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	          });
	          plan.push(key, value, params);
	        }
	
	        cycle.pop();
	        visited[key] = VISIT_DONE;
	      }
	      forEach(invocables, visit);
	      invocables = cycle = visited = null; // plan is all that's required
	
	      function isResolve(value) {
	        return isObject(value) && value.then && value.$$promises;
	      }
	
	      return function (locals, parent, self) {
	        if (isResolve(locals) && self === undefined) {
	          self = parent;parent = locals;locals = null;
	        }
	        if (!locals) locals = NO_LOCALS;else if (!isObject(locals)) {
	          throw new Error("'locals' must be an object");
	        }
	        if (!parent) parent = NO_PARENT;else if (!isResolve(parent)) {
	          throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	        }
	
	        // To complete the overall resolution, we have to wait for the parent
	        // promise and for the promise for each invokable in our plan.
	        var resolution = $q.defer(),
	            result = silenceUncaughtInPromise(resolution.promise),
	            promises = result.$$promises = {},
	            values = extend({}, locals),
	            wait = 1 + plan.length / 3,
	            merged = false;
	
	        silenceUncaughtInPromise(result);
	
	        function done() {
	          // Merge parent values we haven't got yet and publish our own $$values
	          if (! --wait) {
	            if (!merged) merge(values, parent.$$values);
	            result.$$values = values;
	            result.$$promises = result.$$promises || true; // keep for isResolve()
	            delete result.$$inheritedValues;
	            resolution.resolve(values);
	          }
	        }
	
	        function fail(reason) {
	          result.$$failure = reason;
	          resolution.reject(reason);
	        }
	
	        // Short-circuit if parent has already failed
	        if (isDefined(parent.$$failure)) {
	          fail(parent.$$failure);
	          return result;
	        }
	
	        if (parent.$$inheritedValues) {
	          merge(values, omit(parent.$$inheritedValues, invocableKeys));
	        }
	
	        // Merge parent values if the parent has already resolved, or merge
	        // parent promises and wait if the parent resolve is still in progress.
	        extend(promises, parent.$$promises);
	        if (parent.$$values) {
	          merged = merge(values, omit(parent.$$values, invocableKeys));
	          result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	          done();
	        } else {
	          if (parent.$$inheritedValues) {
	            result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	          }
	          parent.then(done, fail);
	        }
	
	        // Process each invocable in the plan, but ignore any where a local of the same name exists.
	        for (var i = 0, ii = plan.length; i < ii; i += 3) {
	          if (locals.hasOwnProperty(plan[i])) done();else invoke(plan[i], plan[i + 1], plan[i + 2]);
	        }
	
	        function invoke(key, invocable, params) {
	          // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	          var invocation = $q.defer(),
	              waitParams = 0;
	          function onfailure(reason) {
	            invocation.reject(reason);
	            fail(reason);
	          }
	          // Wait for any parameter that we have a promise for (either from parent or from this
	          // resolve; in that case study() will have made sure it's ordered before us in the plan).
	          forEach(params, function (dep) {
	            if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	              waitParams++;
	              promises[dep].then(function (result) {
	                values[dep] = result;
	                if (! --waitParams) proceed();
	              }, onfailure);
	            }
	          });
	          if (!waitParams) proceed();
	          function proceed() {
	            if (isDefined(result.$$failure)) return;
	            try {
	              invocation.resolve($injector.invoke(invocable, self, values));
	              invocation.promise.then(function (result) {
	                values[key] = result;
	                done();
	              }, onfailure);
	            } catch (e) {
	              onfailure(e);
	            }
	          }
	          // Publish promise synchronously; invocations further down in the plan may depend on it.
	          promises[key] = silenceUncaughtInPromise(invocation.promise);
	        }
	
	        return result;
	      };
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$resolve#resolve
	     * @methodOf ui.router.util.$resolve
	     *
	     * @description
	     * Resolves a set of invocables. An invocable is a function to be invoked via 
	     * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	     * An invocable can either return a value directly,
	     * or a `$q` promise. If a promise is returned it will be resolved and the 
	     * resulting value will be used instead. Dependencies of invocables are resolved 
	     * (in this order of precedence)
	     *
	     * - from the specified `locals`
	     * - from another invocable that is part of this `$resolve` call
	     * - from an invocable that is inherited from a `parent` call to `$resolve` 
	     *   (or recursively
	     * - from any ancestor `$resolve` of that parent).
	     *
	     * The return value of `$resolve` is a promise for an object that contains 
	     * (in this order of precedence)
	     *
	     * - any `locals` (if specified)
	     * - the resolved return values of all injectables
	     * - any values inherited from a `parent` call to `$resolve` (if specified)
	     *
	     * The promise will resolve after the `parent` promise (if any) and all promises 
	     * returned by injectables have been resolved. If any invocable 
	     * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	     * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	     * same error. A rejection of a `parent` promise (if specified) will likewise be 
	     * propagated immediately. Once the `$resolve` promise has been rejected, no 
	     * further invocables will be called.
	     * 
	     * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	     * to throw an error. As a special case, an injectable can depend on a parameter 
	     * with the same name as the injectable, which will be fulfilled from the `parent` 
	     * injectable of the same name. This allows inherited values to be decorated. 
	     * Note that in this case any other injectable in the same `$resolve` with the same
	     * dependency would see the decorated value, not the inherited value.
	     *
	     * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	     * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	     * exception.
	     *
	     * Invocables are invoked eagerly as soon as all dependencies are available. 
	     * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	     *
	     * As a special case, an invocable can be a string, in which case it is taken to 
	     * be a service name to be passed to `$injector.get()`. This is supported primarily 
	     * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	     * routes.
	     *
	     * @param {object} invocables functions to invoke or 
	     * `$injector` services to fetch.
	     * @param {object} locals  values to make available to the injectables
	     * @param {object} parent  a promise returned by another call to `$resolve`.
	     * @param {object} self  the `this` for the invoked methods
	     * @return {object} Promise for an object that contains the resolved return value
	     * of all invocables, as well as any inherited and local values.
	     */
	    this.resolve = function (invocables, locals, parent, self) {
	      return this.study(invocables)(locals, parent, self);
	    };
	  }
	
	  angular.module('ui.router.util').service('$resolve', $Resolve);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$templateFactoryProvider
	   *
	   * @description
	   * Provider for $templateFactory. Manages which template-loading mechanism to
	   * use, and will default to the most recent one ($templateRequest on Angular
	   * versions starting from 1.3, $http otherwise).
	   */
	  function TemplateFactoryProvider() {
	    var shouldUnsafelyUseHttp = angular.version.minor < 3;
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
	     * @methodOf ui.router.util.$templateFactoryProvider
	     *
	     * @description
	     * Forces $templateFactory to use $http instead of $templateRequest. This
	     * might cause XSS, as $http doesn't enforce the regular security checks for
	     * templates that have been introduced in Angular 1.3. Note that setting this
	     * to false on Angular older than 1.3.x will crash, as the $templateRequest
	     * service (and the security checks) are not implemented on these versions.
	     *
	     * See the $sce documentation, section
	     * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
	     * Impact on loading templates</a> for more details about this mechanism.
	     *
	     * @param {boolean} value
	     */
	    this.shouldUnsafelyUseHttp = function (value) {
	      shouldUnsafelyUseHttp = !!value;
	    };
	
	    /**
	     * @ngdoc object
	     * @name ui.router.util.$templateFactory
	     *
	     * @requires $http
	     * @requires $templateCache
	     * @requires $injector
	     *
	     * @description
	     * Service. Manages loading of templates.
	     */
	    this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
	      return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);
	    }];
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$templateFactory
	   *
	   * @requires $http
	   * @requires $templateCache
	   * @requires $injector
	   *
	   * @description
	   * Service. Manages loading of templates.
	   */
	  function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactory#fromConfig
	     * @methodOf ui.router.util.$templateFactory
	     *
	     * @description
	     * Creates a template from a configuration object. 
	     *
	     * @param {object} config Configuration object for which to load a template. 
	     * The following properties are search in the specified order, and the first one 
	     * that is defined is used to create the template:
	     *
	     * @param {string|object} config.template html string template or function to 
	     * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	     * @param {string|object} config.templateUrl url to load or a function returning 
	     * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	     * @param {Function} config.templateProvider function to invoke via 
	     * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	     * @param {object} params  Parameters to pass to the template function.
	     * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	     * via a `templateProvider`. Defaults to `{ params: params }`.
	     *
	     * @return {string|object}  The template html as a string, or a promise for 
	     * that string,or `null` if no template is configured.
	     */
	    this.fromConfig = function (config, params, locals) {
	      return isDefined(config.template) ? this.fromString(config.template, params) : isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) : isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) : null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactory#fromString
	     * @methodOf ui.router.util.$templateFactory
	     *
	     * @description
	     * Creates a template from a string or a function returning a string.
	     *
	     * @param {string|object} template html template as a string or function that 
	     * returns an html template as a string.
	     * @param {object} params Parameters to pass to the template function.
	     *
	     * @return {string|object} The template html as a string, or a promise for that 
	     * string.
	     */
	    this.fromString = function (template, params) {
	      return isFunction(template) ? template(params) : template;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactory#fromUrl
	     * @methodOf ui.router.util.$templateFactory
	     * 
	     * @description
	     * Loads a template from the a URL via `$http` and `$templateCache`.
	     *
	     * @param {string|Function} url url of the template to load, or a function 
	     * that returns a url.
	     * @param {Object} params Parameters to pass to the url function.
	     * @return {string|Promise.<string>} The template html as a string, or a promise 
	     * for that string.
	     */
	    this.fromUrl = function (url, params) {
	      if (isFunction(url)) url = url(params);
	      if (url == null) return null;else {
	        if (!shouldUnsafelyUseHttp) {
	          return $injector.get('$templateRequest')(url);
	        } else {
	          return $http.get(url, { cache: $templateCache, headers: { Accept: 'text/html' } }).then(function (response) {
	            return response.data;
	          });
	        }
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactory#fromProvider
	     * @methodOf ui.router.util.$templateFactory
	     *
	     * @description
	     * Creates a template by invoking an injectable provider function.
	     *
	     * @param {Function} provider Function to invoke via `$injector.invoke`
	     * @param {Object} params Parameters for the template.
	     * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	     * `{ params: params }`.
	     * @return {string|Promise.<string>} The template html as a string, or a promise 
	     * for that string.
	     */
	    this.fromProvider = function (provider, params, locals) {
	      return $injector.invoke(provider, null, locals || { params: params });
	    };
	  }
	
	  angular.module('ui.router.util').provider('$templateFactory', TemplateFactoryProvider);
	
	  var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Matches URLs against patterns and extracts named parameters from the path or the search
	   * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	   * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	   * do not influence whether or not a URL is matched, but their values are passed through into
	   * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	   *
	   * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	   * syntax, which optionally allows a regular expression for the parameter to be specified:
	   *
	   * * `':'` name - colon placeholder
	   * * `'*'` name - catch-all placeholder
	   * * `'{' name '}'` - curly placeholder
	   * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	   *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	   *
	   * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	   * must be unique within the pattern (across both path and search parameters). For colon
	   * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	   * number of characters other than '/'. For catch-all placeholders the path parameter matches
	   * any number of characters.
	   *
	   * Examples:
	   *
	   * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	   *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	   * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	   *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	   * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	   * * `'/user/{id:[^/]*}'` - Same as the previous example.
	   * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	   *   parameter consists of 1 to 8 hex digits.
	   * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	   *   path into the parameter 'path'.
	   * * `'/files/*path'` - ditto.
	   * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	   *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	   *
	   * @param {string} pattern  The pattern to compile into a matcher.
	   * @param {Object} config  A configuration object hash:
	   * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	   *   an existing UrlMatcher
	   *
	   * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	   * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	   *
	   * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	   *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	   *   non-null) will start with this prefix.
	   *
	   * @property {string} source  The pattern that was passed into the constructor
	   *
	   * @property {string} sourcePath  The path portion of the source property
	   *
	   * @property {string} sourceSearch  The search portion of the source property
	   *
	   * @property {string} regex  The constructed regex that will be used to match against the url when
	   *   it is time to determine which url will match.
	   *
	   * @returns {Object}  New `UrlMatcher` object
	   */
	  function UrlMatcher(pattern, config, parentMatcher) {
	    config = extend({ params: {} }, isObject(config) ? config : {});
	
	    // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	    //   '*' name
	    //   ':' name
	    //   '{' name '}'
	    //   '{' name ':' regexp '}'
	    // The regular expression is somewhat complicated due to the need to allow curly braces
	    // inside the regular expression. The placeholder regexp breaks down as follows:
	    //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	    //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	    //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	    //    [^{}\\]+                       - anything other than curly braces or backslash
	    //    \\.                            - a backslash escape
	    //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	    var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	        searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	        compiled = '^',
	        last = 0,
	        m,
	        segments = this.segments = [],
	        parentParams = parentMatcher ? parentMatcher.params : {},
	        params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	        paramNames = [];
	
	    function addParameter(id, type, config, location) {
	      paramNames.push(id);
	      if (parentParams[id]) return parentParams[id];
	      if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	      if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	      params[id] = new $$UMFP.Param(id, type, config, location);
	      return params[id];
	    }
	
	    function quoteRegExp(string, pattern, squash, optional) {
	      var surroundPattern = ['', ''],
	          result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	      if (!pattern) return result;
	      switch (squash) {
	        case false:
	          surroundPattern = ['(', ')' + (optional ? "?" : "")];break;
	        case true:
	          result = result.replace(/\/$/, '');
	          surroundPattern = ['(?:\/(', ')|\/)?'];
	          break;
	        default:
	          surroundPattern = ['(' + squash + "|", ')?'];break;
	      }
	      return result + surroundPattern[0] + pattern + surroundPattern[1];
	    }
	
	    this.source = pattern;
	
	    // Split into static segments separated by path parameter placeholders.
	    // The number of segments is always 1 more than the number of parameters.
	    function matchDetails(m, isSearch) {
	      var id, regexp, segment, type, cfg, arrayMode;
	      id = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	      cfg = config.params[id];
	      segment = pattern.substring(last, m.index);
	      regexp = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	      if (regexp) {
	        type = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	      }
	
	      return {
	        id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	      };
	    }
	
	    var p, param, segment;
	    while (m = placeholder.exec(pattern)) {
	      p = matchDetails(m, false);
	      if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	      param = addParameter(p.id, p.type, p.cfg, "path");
	      compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	      segments.push(p.segment);
	      last = placeholder.lastIndex;
	    }
	    segment = pattern.substring(last);
	
	    // Find any search parameter names and remove them from the last segment
	    var i = segment.indexOf('?');
	
	    if (i >= 0) {
	      var search = this.sourceSearch = segment.substring(i);
	      segment = segment.substring(0, i);
	      this.sourcePath = pattern.substring(0, last + i);
	
	      if (search.length > 0) {
	        last = 0;
	        while (m = searchPlaceholder.exec(search)) {
	          p = matchDetails(m, true);
	          param = addParameter(p.id, p.type, p.cfg, "search");
	          last = placeholder.lastIndex;
	          // check if ?&
	        }
	      }
	    } else {
	      this.sourcePath = pattern;
	      this.sourceSearch = '';
	    }
	
	    compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	    segments.push(segment);
	
	    this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	    this.prefix = segments[0];
	    this.$$paramNames = paramNames;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#concat
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Returns a new matcher for a pattern constructed by appending the path part and adding the
	   * search parameters of the specified pattern to this pattern. The current pattern is not
	   * modified. This can be understood as creating a pattern for URLs that are relative to (or
	   * suffixes of) the current pattern.
	   *
	   * @example
	   * The following two matchers are equivalent:
	   * <pre>
	   * new UrlMatcher('/user/{id}?q').concat('/details?date');
	   * new UrlMatcher('/user/{id}/details?q&date');
	   * </pre>
	   *
	   * @param {string} pattern  The pattern to append.
	   * @param {Object} config  An object hash of the configuration for the matcher.
	   * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	   */
	  UrlMatcher.prototype.concat = function (pattern, config) {
	    // Because order of search parameters is irrelevant, we can add our own search
	    // parameters to the end of the new pattern. Parse the new pattern by itself
	    // and then join the bits together, but it's much easier to do this on a string level.
	    var defaultConfig = {
	      caseInsensitive: $$UMFP.caseInsensitive(),
	      strict: $$UMFP.strictMode(),
	      squash: $$UMFP.defaultSquashPolicy()
	    };
	    return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	  };
	
	  UrlMatcher.prototype.toString = function () {
	    return this.source;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#exec
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Tests the specified path against this matcher, and returns an object containing the captured
	   * parameter values, or null if the path does not match. The returned object contains the values
	   * of any search parameters that are mentioned in the pattern, but their value may be null if
	   * they are not present in `searchParams`. This means that search parameters are always treated
	   * as optional.
	   *
	   * @example
	   * <pre>
	   * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	   *   x: '1', q: 'hello'
	   * });
	   * // returns { id: 'bob', q: 'hello', r: null }
	   * </pre>
	   *
	   * @param {string} path  The URL path to match, e.g. `$location.path()`.
	   * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	   * @returns {Object}  The captured parameter values.
	   */
	  UrlMatcher.prototype.exec = function (path, searchParams) {
	    var m = this.regexp.exec(path);
	    if (!m) return null;
	    searchParams = searchParams || {};
	
	    var paramNames = this.parameters(),
	        nTotal = paramNames.length,
	        nPath = this.segments.length - 1,
	        values = {},
	        i,
	        j,
	        cfg,
	        paramName;
	
	    if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	    function decodePathArray(string) {
	      function reverseString(str) {
	        return str.split("").reverse().join("");
	      }
	      function unquoteDashes(str) {
	        return str.replace(/\\-/g, "-");
	      }
	
	      var split = reverseString(string).split(/-(?!\\)/);
	      var allReversed = map(split, reverseString);
	      return map(allReversed, unquoteDashes).reverse();
	    }
	
	    var param, paramVal;
	    for (i = 0; i < nPath; i++) {
	      paramName = paramNames[i];
	      param = this.params[paramName];
	      paramVal = m[i + 1];
	      // if the param value matches a pre-replace pair, replace the value before decoding.
	      for (j = 0; j < param.replace.length; j++) {
	        if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	      }
	      if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	      if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	      values[paramName] = param.value(paramVal);
	    }
	    for (; /**/i < nTotal; i++) {
	      paramName = paramNames[i];
	      values[paramName] = this.params[paramName].value(searchParams[paramName]);
	      param = this.params[paramName];
	      paramVal = searchParams[paramName];
	      for (j = 0; j < param.replace.length; j++) {
	        if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	      }
	      if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	      values[paramName] = param.value(paramVal);
	    }
	
	    return values;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#parameters
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Returns the names of all path and search parameters of this pattern in an unspecified order.
	   *
	   * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	   *    pattern has no parameters, an empty array is returned.
	   */
	  UrlMatcher.prototype.parameters = function (param) {
	    if (!isDefined(param)) return this.$$paramNames;
	    return this.params[param] || null;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#validates
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Checks an object hash of parameters to validate their correctness according to the parameter
	   * types of this `UrlMatcher`.
	   *
	   * @param {Object} params The object hash of parameters to validate.
	   * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	   */
	  UrlMatcher.prototype.validates = function (params) {
	    return this.params.$$validates(params);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#format
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Creates a URL that matches this pattern by substituting the specified values
	   * for the path and search parameters. Null values for path parameters are
	   * treated as empty strings.
	   *
	   * @example
	   * <pre>
	   * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	   * // returns '/user/bob?q=yes'
	   * </pre>
	   *
	   * @param {Object} values  the values to substitute for the parameters in this pattern.
	   * @returns {string}  the formatted URL (path and optionally search part).
	   */
	  UrlMatcher.prototype.format = function (values) {
	    values = values || {};
	    var segments = this.segments,
	        params = this.parameters(),
	        paramset = this.params;
	    if (!this.validates(values)) return null;
	
	    var i,
	        search = false,
	        nPath = segments.length - 1,
	        nTotal = params.length,
	        result = segments[0];
	
	    function encodeDashes(str) {
	      // Replace dashes with encoded "\-"
	      return encodeURIComponent(str).replace(/-/g, function (c) {
	        return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase();
	      });
	    }
	
	    for (i = 0; i < nTotal; i++) {
	      var isPathParam = i < nPath;
	      var name = params[i],
	          param = paramset[name],
	          value = param.value(values[name]);
	      var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	      var squash = isDefaultValue ? param.squash : false;
	      var encoded = param.type.encode(value);
	
	      if (isPathParam) {
	        var nextSegment = segments[i + 1];
	        var isFinalPathParam = i + 1 === nPath;
	
	        if (squash === false) {
	          if (encoded != null) {
	            if (isArray(encoded)) {
	              result += map(encoded, encodeDashes).join("-");
	            } else {
	              result += encodeURIComponent(encoded);
	            }
	          }
	          result += nextSegment;
	        } else if (squash === true) {
	          var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	          result += nextSegment.match(capture)[1];
	        } else if (isString(squash)) {
	          result += squash + nextSegment;
	        }
	
	        if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	      } else {
	        if (encoded == null || isDefaultValue && squash !== false) continue;
	        if (!isArray(encoded)) encoded = [encoded];
	        if (encoded.length === 0) continue;
	        encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	        result += (search ? '&' : '?') + (name + '=' + encoded);
	        search = true;
	      }
	    }
	
	    return result;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.type:Type
	   *
	   * @description
	   * Implements an interface to define custom parameter types that can be decoded from and encoded to
	   * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	   * objects when matching or formatting URLs, or comparing or validating parameter values.
	   *
	   * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	   * information on registering custom types.
	   *
	   * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	   *        properties will override the default methods and/or pattern in `Type`'s public interface.
	   * @example
	   * <pre>
	   * {
	   *   decode: function(val) { return parseInt(val, 10); },
	   *   encode: function(val) { return val && val.toString(); },
	   *   equals: function(a, b) { return this.is(a) && a === b; },
	   *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	   *   pattern: /\d+/
	   * }
	   * </pre>
	   *
	   * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	   *           coming from a substring of a URL.
	   *
	   * @returns {Object}  Returns a new `Type` object.
	   */
	  function Type(config) {
	    extend(this, config);
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:Type#is
	   * @methodOf ui.router.util.type:Type
	   *
	   * @description
	   * Detects whether a value is of a particular type. Accepts a native (decoded) value
	   * and determines whether it matches the current `Type` object.
	   *
	   * @param {*} val  The value to check.
	   * @param {string} key  Optional. If the type check is happening in the context of a specific
	   *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	   *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	   * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	   */
	  Type.prototype.is = function (val, key) {
	    return true;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:Type#encode
	   * @methodOf ui.router.util.type:Type
	   *
	   * @description
	   * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	   * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	   * only needs to be a representation of `val` that has been coerced to a string.
	   *
	   * @param {*} val  The value to encode.
	   * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	   *        meta-programming of `Type` objects.
	   * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	   */
	  Type.prototype.encode = function (val, key) {
	    return val;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:Type#decode
	   * @methodOf ui.router.util.type:Type
	   *
	   * @description
	   * Converts a parameter value (from URL string or transition param) to a custom/native value.
	   *
	   * @param {string} val  The URL parameter value to decode.
	   * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	   *        meta-programming of `Type` objects.
	   * @returns {*}  Returns a custom representation of the URL parameter value.
	   */
	  Type.prototype.decode = function (val, key) {
	    return val;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:Type#equals
	   * @methodOf ui.router.util.type:Type
	   *
	   * @description
	   * Determines whether two decoded values are equivalent.
	   *
	   * @param {*} a  A value to compare against.
	   * @param {*} b  A value to compare against.
	   * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	   */
	  Type.prototype.equals = function (a, b) {
	    return a == b;
	  };
	
	  Type.prototype.$subPattern = function () {
	    var sub = this.pattern.toString();
	    return sub.substr(1, sub.length - 2);
	  };
	
	  Type.prototype.pattern = /.*/;
	
	  Type.prototype.toString = function () {
	    return "{Type:" + this.name + "}";
	  };
	
	  /** Given an encoded string, or a decoded object, returns a decoded object */
	  Type.prototype.$normalize = function (val) {
	    return this.is(val) ? val : this.decode(val);
	  };
	
	  /*
	   * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	   * e.g.:
	   * - urlmatcher pattern "/path?{queryParam[]:int}"
	   * - url: "/path?queryParam=1&queryParam=2
	   * - $stateParams.queryParam will be [1, 2]
	   * if `mode` is "auto", then
	   * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	   * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	   */
	  Type.prototype.$asArray = function (mode, isSearch) {
	    if (!mode) return this;
	    if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	    function ArrayType(type, mode) {
	      function bindTo(type, callbackName) {
	        return function () {
	          return type[callbackName].apply(type, arguments);
	        };
	      }
	
	      // Wrap non-array value as array
	      function arrayWrap(val) {
	        return isArray(val) ? val : isDefined(val) ? [val] : [];
	      }
	      // Unwrap array value for "auto" mode. Return undefined for empty array.
	      function arrayUnwrap(val) {
	        switch (val.length) {
	          case 0:
	            return undefined;
	          case 1:
	            return mode === "auto" ? val[0] : val;
	          default:
	            return val;
	        }
	      }
	      function falsey(val) {
	        return !val;
	      }
	
	      // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	      function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	          if (isArray(val) && val.length === 0) return val;
	          val = arrayWrap(val);
	          var result = map(val, callback);
	          if (allTruthyMode === true) return filter(result, falsey).length === 0;
	          return arrayUnwrap(result);
	        };
	      }
	
	      // Wraps type (.equals) functions to operate on each value of an array
	      function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	          var left = arrayWrap(val1),
	              right = arrayWrap(val2);
	          if (left.length !== right.length) return false;
	          for (var i = 0; i < left.length; i++) {
	            if (!callback(left[i], right[i])) return false;
	          }
	          return true;
	        };
	      }
	
	      this.encode = arrayHandler(bindTo(type, 'encode'));
	      this.decode = arrayHandler(bindTo(type, 'decode'));
	      this.is = arrayHandler(bindTo(type, 'is'), true);
	      this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	      this.pattern = type.pattern;
	      this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	      this.name = type.name;
	      this.$arrayMode = mode;
	    }
	
	    return new ArrayType(this, mode);
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	   * is also available to providers under the name `$urlMatcherFactoryProvider`.
	   */
	  function $UrlMatcherFactory() {
	    $$UMFP = this;
	
	    var isCaseInsensitive = false,
	        isStrictMode = true,
	        defaultSquashPolicy = false;
	
	    // Use tildes to pre-encode slashes.
	    // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	    // and bidirectional encoding/decoding fails.
	    // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	    function valToString(val) {
	      return val != null ? val.toString().replace(/(~|\/)/g, function (m) {
	        return { '~': '~~', '/': '~2F' }[m];
	      }) : val;
	    }
	    function valFromString(val) {
	      return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) {
	        return { '~~': '~', '~2F': '/' }[m];
	      }) : val;
	    }
	
	    var $types = {},
	        enqueue = true,
	        typeQueue = [],
	        injector,
	        defaultTypes = {
	      "string": {
	        encode: valToString,
	        decode: valFromString,
	        // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	        // In 0.2.x, string params are optional by default for backwards compat
	        is: function is(val) {
	          return val == null || !isDefined(val) || typeof val === "string";
	        },
	        pattern: /[^/]*/
	      },
	      "int": {
	        encode: valToString,
	        decode: function decode(val) {
	          return parseInt(val, 10);
	        },
	        is: function is(val) {
	          return val !== undefined && val !== null && this.decode(val.toString()) === val;
	        },
	        pattern: /-?\d+/
	      },
	      "bool": {
	        encode: function encode(val) {
	          return val ? 1 : 0;
	        },
	        decode: function decode(val) {
	          return parseInt(val, 10) !== 0;
	        },
	        is: function is(val) {
	          return val === true || val === false;
	        },
	        pattern: /0|1/
	      },
	      "date": {
	        encode: function encode(val) {
	          if (!this.is(val)) return undefined;
	          return [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join("-");
	        },
	        decode: function decode(val) {
	          if (this.is(val)) return val;
	          var match = this.capture.exec(val);
	          return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	        },
	        is: function is(val) {
	          return val instanceof Date && !isNaN(val.valueOf());
	        },
	        equals: function equals(a, b) {
	          return this.is(a) && this.is(b) && a.toISOString() === b.toISOString();
	        },
	        pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	        capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	      },
	      "json": {
	        encode: angular.toJson,
	        decode: angular.fromJson,
	        is: angular.isObject,
	        equals: angular.equals,
	        pattern: /[^/]*/
	      },
	      "any": { // does not encode/decode
	        encode: angular.identity,
	        decode: angular.identity,
	        equals: angular.equals,
	        pattern: /.*/
	      }
	    };
	
	    function getDefaultConfig() {
	      return {
	        strict: isStrictMode,
	        caseInsensitive: isCaseInsensitive
	      };
	    }
	
	    function isInjectable(value) {
	      return isFunction(value) || isArray(value) && isFunction(value[value.length - 1]);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    $UrlMatcherFactory.$$getDefaultValue = function (config) {
	      if (!isInjectable(config.value)) return config.value;
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      return injector.invoke(config.value);
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Defines whether URL matching should be case sensitive (the default behavior), or not.
	     *
	     * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	     * @returns {boolean} the current value of caseInsensitive
	     */
	    this.caseInsensitive = function (value) {
	      if (isDefined(value)) isCaseInsensitive = value;
	      return isCaseInsensitive;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#strictMode
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Defines whether URLs should match trailing slashes, or not (the default behavior).
	     *
	     * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	     * @returns {boolean} the current value of strictMode
	     */
	    this.strictMode = function (value) {
	      if (isDefined(value)) isStrictMode = value;
	      return isStrictMode;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Sets the default behavior when generating or matching URLs with default parameter values.
	     *
	     * @param {string} value A string that defines the default parameter URL squashing behavior.
	     *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	     *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	     *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	     *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	     *             the parameter value from the URL and replace it with this string.
	     */
	    this.defaultSquashPolicy = function (value) {
	      if (!isDefined(value)) return defaultSquashPolicy;
	      if (value !== true && value !== false && !isString(value)) throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	      defaultSquashPolicy = value;
	      return value;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#compile
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	     *
	     * @param {string} pattern  The URL pattern.
	     * @param {Object} config  The config object hash.
	     * @returns {UrlMatcher}  The UrlMatcher.
	     */
	    this.compile = function (pattern, config) {
	      return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#isMatcher
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	     *
	     * @param {Object} object  The object to perform the type check against.
	     * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    this.isMatcher = function (o) {
	      if (!isObject(o)) return false;
	      var result = true;
	
	      forEach(UrlMatcher.prototype, function (val, name) {
	        if (isFunction(val)) {
	          result = result && isDefined(o[name]) && isFunction(o[name]);
	        }
	      });
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#type
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	     * generate URLs with typed parameters.
	     *
	     * @param {string} name  The type name.
	     * @param {Object|Function} definition   The type definition. See
	     *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	     * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	     *        runtime starts.  The result of this function is merged into the existing `definition`.
	     *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	     *
	     * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	     *
	     * @example
	     * This is a simple example of a custom type that encodes and decodes items from an
	     * array, using the array index as the URL-encoded value:
	     *
	     * <pre>
	     * var list = ['John', 'Paul', 'George', 'Ringo'];
	     *
	     * $urlMatcherFactoryProvider.type('listItem', {
	     *   encode: function(item) {
	     *     // Represent the list item in the URL using its corresponding index
	     *     return list.indexOf(item);
	     *   },
	     *   decode: function(item) {
	     *     // Look up the list item by index
	     *     return list[parseInt(item, 10)];
	     *   },
	     *   is: function(item) {
	     *     // Ensure the item is valid by checking to see that it appears
	     *     // in the list
	     *     return list.indexOf(item) > -1;
	     *   }
	     * });
	     *
	     * $stateProvider.state('list', {
	     *   url: "/list/{item:listItem}",
	     *   controller: function($scope, $stateParams) {
	     *     console.log($stateParams.item);
	     *   }
	     * });
	     *
	     * // ...
	     *
	     * // Changes URL to '/list/3', logs "Ringo" to the console
	     * $state.go('list', { item: "Ringo" });
	     * </pre>
	     *
	     * This is a more complex example of a type that relies on dependency injection to
	     * interact with services, and uses the parameter name from the URL to infer how to
	     * handle encoding and decoding parameter values:
	     *
	     * <pre>
	     * // Defines a custom type that gets a value from a service,
	     * // where each service gets different types of values from
	     * // a backend API:
	     * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	     *
	     *   // Matches up services to URL parameter names
	     *   var services = {
	     *     user: Users,
	     *     post: Posts
	     *   };
	     *
	     *   return {
	     *     encode: function(object) {
	     *       // Represent the object in the URL using its unique ID
	     *       return object.id;
	     *     },
	     *     decode: function(value, key) {
	     *       // Look up the object by ID, using the parameter
	     *       // name (key) to call the correct service
	     *       return services[key].findById(value);
	     *     },
	     *     is: function(object, key) {
	     *       // Check that object is a valid dbObject
	     *       return angular.isObject(object) && object.id && services[key];
	     *     }
	     *     equals: function(a, b) {
	     *       // Check the equality of decoded objects by comparing
	     *       // their unique IDs
	     *       return a.id === b.id;
	     *     }
	     *   };
	     * });
	     *
	     * // In a config() block, you can then attach URLs with
	     * // type-annotated parameters:
	     * $stateProvider.state('users', {
	     *   url: "/users",
	     *   // ...
	     * }).state('users.item', {
	     *   url: "/{user:dbObject}",
	     *   controller: function($scope, $stateParams) {
	     *     // $stateParams.user will now be an object returned from
	     *     // the Users service
	     *   },
	     *   // ...
	     * });
	     * </pre>
	     */
	    this.type = function (name, definition, definitionFn) {
	      if (!isDefined(definition)) return $types[name];
	      if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	      $types[name] = new Type(extend({ name: name }, definition));
	      if (definitionFn) {
	        typeQueue.push({ name: name, def: definitionFn });
	        if (!enqueue) flushTypeQueue();
	      }
	      return this;
	    };
	
	    // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	    function flushTypeQueue() {
	      while (typeQueue.length) {
	        var type = typeQueue.shift();
	        if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	        angular.extend($types[type.name], injector.invoke(type.def));
	      }
	    }
	
	    // Register default types. Store them in the prototype of $types.
	    forEach(defaultTypes, function (type, name) {
	      $types[name] = new Type(extend({ name: name }, type));
	    });
	    $types = inherit($types, {});
	
	    /* No need to document $get, since it returns this */
	    this.$get = ['$injector', function ($injector) {
	      injector = $injector;
	      enqueue = false;
	      flushTypeQueue();
	
	      forEach(defaultTypes, function (type, name) {
	        if (!$types[name]) $types[name] = new Type(type);
	      });
	      return this;
	    }];
	
	    this.Param = function Param(id, type, config, location) {
	      var self = this;
	      config = unwrapShorthand(config);
	      type = getType(config, type, location);
	      var arrayMode = getArrayMode();
	      type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	      if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined) config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	      var isOptional = config.value !== undefined;
	      var squash = getSquashPolicy(config, isOptional);
	      var replace = getReplace(config, arrayMode, isOptional, squash);
	
	      function unwrapShorthand(config) {
	        var keys = isObject(config) ? objectKeys(config) : [];
	        var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 && indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	        if (isShorthand) config = { value: config };
	        config.$$fn = isInjectable(config.value) ? config.value : function () {
	          return config.value;
	        };
	        return config;
	      }
	
	      function getType(config, urlType, location) {
	        if (config.type && urlType) throw new Error("Param '" + id + "' has two type configurations.");
	        if (urlType) return urlType;
	        if (!config.type) return location === "config" ? $types.any : $types.string;
	
	        if (angular.isString(config.type)) return $types[config.type];
	        if (config.type instanceof Type) return config.type;
	        return new Type(config.type);
	      }
	
	      // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	      function getArrayMode() {
	        var arrayDefaults = { array: location === "search" ? "auto" : false };
	        var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	        return extend(arrayDefaults, arrayParamNomenclature, config).array;
	      }
	
	      /**
	       * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	       */
	      function getSquashPolicy(config, isOptional) {
	        var squash = config.squash;
	        if (!isOptional || squash === false) return false;
	        if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	        if (squash === true || isString(squash)) return squash;
	        throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	      }
	
	      function getReplace(config, arrayMode, isOptional, squash) {
	        var replace,
	            configuredKeys,
	            defaultPolicy = [{ from: "", to: isOptional || arrayMode ? undefined : "" }, { from: null, to: isOptional || arrayMode ? undefined : "" }];
	        replace = isArray(config.replace) ? config.replace : [];
	        if (isString(squash)) replace.push({ from: squash, to: undefined });
	        configuredKeys = map(replace, function (item) {
	          return item.from;
	        });
	        return filter(defaultPolicy, function (item) {
	          return indexOf(configuredKeys, item.from) === -1;
	        }).concat(replace);
	      }
	
	      /**
	       * [Internal] Get the default value of a parameter, which may be an injectable function.
	       */
	      function $$getDefaultValue() {
	        if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	        var defaultValue = injector.invoke(config.$$fn);
	        if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue)) throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	        return defaultValue;
	      }
	
	      /**
	       * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	       * default value, which may be the result of an injectable function.
	       */
	      function $value(value) {
	        function hasReplaceVal(val) {
	          return function (obj) {
	            return obj.from === val;
	          };
	        }
	        function $replace(value) {
	          var replacement = map(filter(self.replace, hasReplaceVal(value)), function (obj) {
	            return obj.to;
	          });
	          return replacement.length ? replacement[0] : value;
	        }
	        value = $replace(value);
	        return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	      }
	
	      function toString() {
	        return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}";
	      }
	
	      extend(this, {
	        id: id,
	        type: type,
	        location: location,
	        array: arrayMode,
	        squash: squash,
	        replace: replace,
	        isOptional: isOptional,
	        value: $value,
	        dynamic: undefined,
	        config: config,
	        toString: toString
	      });
	    };
	
	    function ParamSet(params) {
	      extend(this, params || {});
	    }
	
	    ParamSet.prototype = {
	      $$new: function $$new() {
	        return inherit(this, extend(new ParamSet(), { $$parent: this }));
	      },
	      $$keys: function $$keys() {
	        var keys = [],
	            chain = [],
	            parent = this,
	            ignore = objectKeys(ParamSet.prototype);
	        while (parent) {
	          chain.push(parent);parent = parent.$$parent;
	        }
	        chain.reverse();
	        forEach(chain, function (paramset) {
	          forEach(objectKeys(paramset), function (key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	          });
	        });
	        return keys;
	      },
	      $$values: function $$values(paramValues) {
	        var values = {},
	            self = this;
	        forEach(self.$$keys(), function (key) {
	          values[key] = self[key].value(paramValues && paramValues[key]);
	        });
	        return values;
	      },
	      $$equals: function $$equals(paramValues1, paramValues2) {
	        var equal = true,
	            self = this;
	        forEach(self.$$keys(), function (key) {
	          var left = paramValues1 && paramValues1[key],
	              right = paramValues2 && paramValues2[key];
	          if (!self[key].type.equals(left, right)) equal = false;
	        });
	        return equal;
	      },
	      $$validates: function $$validate(paramValues) {
	        var keys = this.$$keys(),
	            i,
	            param,
	            rawVal,
	            normalized,
	            encoded;
	        for (i = 0; i < keys.length; i++) {
	          param = this[keys[i]];
	          rawVal = paramValues[keys[i]];
	          if ((rawVal === undefined || rawVal === null) && param.isOptional) break; // There was no parameter value, but the param is optional
	          normalized = param.type.$normalize(rawVal);
	          if (!param.type.is(normalized)) return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	          encoded = param.type.encode(normalized);
	          if (angular.isString(encoded) && !param.type.pattern.exec(encoded)) return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	        }
	        return true;
	      },
	      $$parent: undefined
	    };
	
	    this.ParamSet = ParamSet;
	  }
	
	  // Register as a provider so it's available to other providers
	  angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	  angular.module('ui.router.util').run(['$urlMatcherFactory', function ($urlMatcherFactory) {}]);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider
	   *
	   * @requires ui.router.util.$urlMatcherFactoryProvider
	   * @requires $locationProvider
	   *
	   * @description
	   * `$urlRouterProvider` has the responsibility of watching `$location`. 
	   * When `$location` changes it runs through a list of rules one by one until a 
	   * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	   * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	   *
	   * There are several methods on `$urlRouterProvider` that make it useful to use directly
	   * in your module config.
	   */
	  $UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	  function $UrlRouterProvider($locationProvider, $urlMatcherFactory) {
	    var rules = [],
	        otherwise = null,
	        interceptDeferred = false,
	        listener;
	
	    // Returns a string that is a prefix of all strings matching the RegExp
	    function regExpPrefix(re) {
	      var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	      return prefix != null ? prefix[1].replace(/\\(.)/g, "$1") : '';
	    }
	
	    // Interpolates matched values into a String.replace()-style pattern
	    function interpolate(pattern, match) {
	      return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	        return match[what === '$' ? 0 : Number(what)];
	      });
	    }
	
	    /**
	     * @ngdoc function
	     * @name ui.router.router.$urlRouterProvider#rule
	     * @methodOf ui.router.router.$urlRouterProvider
	     *
	     * @description
	     * Defines rules that are used by `$urlRouterProvider` to find matches for
	     * specific URLs.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   // Here's an example of how you might allow case insensitive urls
	     *   $urlRouterProvider.rule(function ($injector, $location) {
	     *     var path = $location.path(),
	     *         normalized = path.toLowerCase();
	     *
	     *     if (path !== normalized) {
	     *       return normalized;
	     *     }
	     *   });
	     * });
	     * </pre>
	     *
	     * @param {function} rule Handler function that takes `$injector` and `$location`
	     * services as arguments. You can use them to return a valid path as a string.
	     *
	     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	     */
	    this.rule = function (rule) {
	      if (!isFunction(rule)) throw new Error("'rule' must be a function");
	      rules.push(rule);
	      return this;
	    };
	
	    /**
	     * @ngdoc object
	     * @name ui.router.router.$urlRouterProvider#otherwise
	     * @methodOf ui.router.router.$urlRouterProvider
	     *
	     * @description
	     * Defines a path that is used when an invalid route is requested.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   // if the path doesn't match any of the urls you configured
	     *   // otherwise will take care of routing the user to the
	     *   // specified url
	     *   $urlRouterProvider.otherwise('/index');
	     *
	     *   // Example of using function rule as param
	     *   $urlRouterProvider.otherwise(function ($injector, $location) {
	     *     return '/a/valid/url';
	     *   });
	     * });
	     * </pre>
	     *
	     * @param {string|function} rule The url path you want to redirect to or a function 
	     * rule that returns the url path. The function version is passed two params: 
	     * `$injector` and `$location` services, and must return a url string.
	     *
	     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	     */
	    this.otherwise = function (rule) {
	      if (isString(rule)) {
	        var redirect = rule;
	        rule = function rule() {
	          return redirect;
	        };
	      } else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	      otherwise = rule;
	      return this;
	    };
	
	    function handleIfMatch($injector, handler, match) {
	      if (!match) return false;
	      var result = $injector.invoke(handler, handler, { $match: match });
	      return isDefined(result) ? result : true;
	    }
	
	    /**
	     * @ngdoc function
	     * @name ui.router.router.$urlRouterProvider#when
	     * @methodOf ui.router.router.$urlRouterProvider
	     *
	     * @description
	     * Registers a handler for a given url matching. 
	     * 
	     * If the handler is a string, it is
	     * treated as a redirect, and is interpolated according to the syntax of match
	     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	     *
	     * If the handler is a function, it is injectable. It gets invoked if `$location`
	     * matches. You have the option of inject the match object as `$match`.
	     *
	     * The handler can return
	     *
	     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	     *   will continue trying to find another one that matches.
	     * - **string** which is treated as a redirect and passed to `$location.url()`
	     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	     *     if ($state.$current.navigable !== state ||
	     *         !equalForKeys($match, $stateParams) {
	     *      $state.transitionTo(state, $match, false);
	     *     }
	     *   });
	     * });
	     * </pre>
	     *
	     * @param {string|object} what The incoming path that you want to redirect.
	     * @param {string|function} handler The path you want to redirect your user to.
	     */
	    this.when = function (what, handler) {
	      var redirect,
	          handlerIsString = isString(handler);
	      if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	      if (!handlerIsString && !isFunction(handler) && !isArray(handler)) throw new Error("invalid 'handler' in when()");
	
	      var strategies = {
	        matcher: function matcher(what, handler) {
	          if (handlerIsString) {
	            redirect = $urlMatcherFactory.compile(handler);
	            handler = ['$match', function ($match) {
	              return redirect.format($match);
	            }];
	          }
	          return extend(function ($injector, $location) {
	            return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	          }, {
	            prefix: isString(what.prefix) ? what.prefix : ''
	          });
	        },
	        regex: function regex(what, handler) {
	          if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	          if (handlerIsString) {
	            redirect = handler;
	            handler = ['$match', function ($match) {
	              return interpolate(redirect, $match);
	            }];
	          }
	          return extend(function ($injector, $location) {
	            return handleIfMatch($injector, handler, what.exec($location.path()));
	          }, {
	            prefix: regExpPrefix(what)
	          });
	        }
	      };
	
	      var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	      for (var n in check) {
	        if (check[n]) return this.rule(strategies[n](what, handler));
	      }
	
	      throw new Error("invalid 'what' in when()");
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.router.$urlRouterProvider#deferIntercept
	     * @methodOf ui.router.router.$urlRouterProvider
	     *
	     * @description
	     * Disables (or enables) deferring location change interception.
	     *
	     * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	     * defer a transition but maintain the current URL), call this method at configuration time.
	     * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	     * `$locationChangeSuccess` event handler.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *
	     *   // Prevent $urlRouter from automatically intercepting URL changes;
	     *   // this allows you to configure custom behavior in between
	     *   // location changes and route synchronization:
	     *   $urlRouterProvider.deferIntercept();
	     *
	     * }).run(function ($rootScope, $urlRouter, UserService) {
	     *
	     *   $rootScope.$on('$locationChangeSuccess', function(e) {
	     *     // UserService is an example service for managing user state
	     *     if (UserService.isLoggedIn()) return;
	     *
	     *     // Prevent $urlRouter's default handler from firing
	     *     e.preventDefault();
	     *
	     *     UserService.handleLogin().then(function() {
	     *       // Once the user has logged in, sync the current URL
	     *       // to the router:
	     *       $urlRouter.sync();
	     *     });
	     *   });
	     *
	     *   // Configures $urlRouter's listener *after* your custom listener
	     *   $urlRouter.listen();
	     * });
	     * </pre>
	     *
	     * @param {boolean} defer Indicates whether to defer location change interception. Passing
	              no parameter is equivalent to `true`.
	     */
	    this.deferIntercept = function (defer) {
	      if (defer === undefined) defer = true;
	      interceptDeferred = defer;
	    };
	
	    /**
	     * @ngdoc object
	     * @name ui.router.router.$urlRouter
	     *
	     * @requires $location
	     * @requires $rootScope
	     * @requires $injector
	     * @requires $browser
	     *
	     * @description
	     *
	     */
	    this.$get = $get;
	    $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	    function $get($location, $rootScope, $injector, $browser, $sniffer) {
	
	      var baseHref = $browser.baseHref(),
	          location = $location.url(),
	          lastPushedUrl;
	
	      function appendBasePath(url, isHtml5, absolute) {
	        if (baseHref === '/') return url;
	        if (isHtml5) return baseHref.slice(0, -1) + url;
	        if (absolute) return baseHref.slice(1) + url;
	        return url;
	      }
	
	      // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	      function update(evt) {
	        if (evt && evt.defaultPrevented) return;
	        var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	        lastPushedUrl = undefined;
	        // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	        //if (ignoreUpdate) return true;
	
	        function check(rule) {
	          var handled = rule($injector, $location);
	
	          if (!handled) return false;
	          if (isString(handled)) $location.replace().url(handled);
	          return true;
	        }
	        var n = rules.length,
	            i;
	
	        for (i = 0; i < n; i++) {
	          if (check(rules[i])) return;
	        }
	        // always check otherwise last to allow dynamic updates to the set of rules
	        if (otherwise) check(otherwise);
	      }
	
	      function _listen() {
	        listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	        return listener;
	      }
	
	      if (!interceptDeferred) _listen();
	
	      return {
	        /**
	         * @ngdoc function
	         * @name ui.router.router.$urlRouter#sync
	         * @methodOf ui.router.router.$urlRouter
	         *
	         * @description
	         * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	         * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	         * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	         * with the transition by calling `$urlRouter.sync()`.
	         *
	         * @example
	         * <pre>
	         * angular.module('app', ['ui.router'])
	         *   .run(function($rootScope, $urlRouter) {
	         *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	         *       // Halt state change from even starting
	         *       evt.preventDefault();
	         *       // Perform custom logic
	         *       var meetsRequirement = ...
	         *       // Continue with the update and state transition if logic allows
	         *       if (meetsRequirement) $urlRouter.sync();
	         *     });
	         * });
	         * </pre>
	         */
	        sync: function sync() {
	          update();
	        },
	
	        listen: function listen() {
	          return _listen();
	        },
	
	        update: function update(read) {
	          if (read) {
	            location = $location.url();
	            return;
	          }
	          if ($location.url() === location) return;
	
	          $location.url(location);
	          $location.replace();
	        },
	
	        push: function push(urlMatcher, params, options) {
	          var url = urlMatcher.format(params || {});
	
	          // Handle the special hash param, if needed
	          if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	          }
	
	          $location.url(url);
	          lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	          if (options && options.replace) $location.replace();
	        },
	
	        /**
	         * @ngdoc function
	         * @name ui.router.router.$urlRouter#href
	         * @methodOf ui.router.router.$urlRouter
	         *
	         * @description
	         * A URL generation method that returns the compiled URL for a given
	         * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	         *
	         * @example
	         * <pre>
	         * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	         *   person: "bob"
	         * });
	         * // $bob == "/about/bob";
	         * </pre>
	         *
	         * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	         * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	         * @param {object=} options Options object. The options are:
	         *
	         * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	         *
	         * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	         */
	        href: function href(urlMatcher, params, options) {
	          if (!urlMatcher.validates(params)) return null;
	
	          var isHtml5 = $locationProvider.html5Mode();
	          if (angular.isObject(isHtml5)) {
	            isHtml5 = isHtml5.enabled;
	          }
	
	          isHtml5 = isHtml5 && $sniffer.history;
	
	          var url = urlMatcher.format(params);
	          options = options || {};
	
	          if (!isHtml5 && url !== null) {
	            url = "#" + $locationProvider.hashPrefix() + url;
	          }
	
	          // Handle special hash param, if needed
	          if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	          }
	
	          url = appendBasePath(url, isHtml5, options.absolute);
	
	          if (!options.absolute || !url) {
	            return url;
	          }
	
	          var slash = !isHtml5 && url ? '/' : '',
	              port = $location.port();
	          port = port === 80 || port === 443 ? '' : ':' + port;
	
	          return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	        }
	      };
	    }
	  }
	
	  angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$stateProvider
	   *
	   * @requires ui.router.router.$urlRouterProvider
	   * @requires ui.router.util.$urlMatcherFactoryProvider
	   *
	   * @description
	   * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	   * on state.
	   *
	   * A state corresponds to a "place" in the application in terms of the overall UI and
	   * navigation. A state describes (via the controller / template / view properties) what
	   * the UI looks like and does at that place.
	   *
	   * States often have things in common, and the primary way of factoring out these
	   * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	   * nested states.
	   *
	   * The `$stateProvider` provides interfaces to declare these states for your app.
	   */
	  $StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	  function $StateProvider($urlRouterProvider, $urlMatcherFactory) {
	
	    var root,
	        states = {},
	        $state,
	        queue = {},
	        abstractKey = 'abstract';
	
	    // Builds state properties from definition passed to registerState()
	    var stateBuilder = {
	
	      // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	      // state.children = [];
	      // if (parent) parent.children.push(state);
	      parent: function parent(state) {
	        if (isDefined(state.parent) && state.parent) return findState(state.parent);
	        // regex matches any valid composite state name
	        // would match "contact.list" but not "contacts"
	        var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	        return compositeName ? findState(compositeName[1]) : root;
	      },
	
	      // inherit 'data' from parent and override by own values (if any)
	      data: function data(state) {
	        if (state.parent && state.parent.data) {
	          state.data = state.self.data = inherit(state.parent.data, state.data);
	        }
	        return state.data;
	      },
	
	      // Build a URLMatcher if necessary, either via a relative or absolute URL
	      url: function url(state) {
	        var url = state.url,
	            config = { params: state.params || {} };
	
	        if (isString(url)) {
	          if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	          return (state.parent.navigable || root).url.concat(url, config);
	        }
	
	        if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	        throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	      },
	
	      // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	      navigable: function navigable(state) {
	        return state.url ? state : state.parent ? state.parent.navigable : null;
	      },
	
	      // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	      ownParams: function ownParams(state) {
	        var params = state.url && state.url.params || new $$UMFP.ParamSet();
	        forEach(state.params || {}, function (config, id) {
	          if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	        });
	        return params;
	      },
	
	      // Derive parameters for this state and ensure they're a super-set of parent's parameters
	      params: function params(state) {
	        var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	        return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	      },
	
	      // If there is no explicit multi-view configuration, make one up so we don't have
	      // to handle both cases in the view directive later. Note that having an explicit
	      // 'views' property will mean the default unnamed view properties are ignored. This
	      // is also a good time to resolve view names to absolute names, so everything is a
	      // straight lookup at link time.
	      views: function views(state) {
	        var views = {};
	
	        forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	          if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	          view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
	          views[name] = view;
	        });
	        return views;
	      },
	
	      // Keep a full path from the root down to this state as this is needed for state activation.
	      path: function path(state) {
	        return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	      },
	
	      // Speed up $state.contains() as it's used a lot
	      includes: function includes(state) {
	        var includes = state.parent ? extend({}, state.parent.includes) : {};
	        includes[state.name] = true;
	        return includes;
	      },
	
	      $delegates: {}
	    };
	
	    function isRelative(stateName) {
	      return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	    }
	
	    function findState(stateOrName, base) {
	      if (!stateOrName) return undefined;
	
	      var isStr = isString(stateOrName),
	          name = isStr ? stateOrName : stateOrName.name,
	          path = isRelative(name);
	
	      if (path) {
	        if (!base) throw new Error("No reference point given for path '" + name + "'");
	        base = findState(base);
	
	        var rel = name.split("."),
	            i = 0,
	            pathLength = rel.length,
	            current = base;
	
	        for (; i < pathLength; i++) {
	          if (rel[i] === "" && i === 0) {
	            current = base;
	            continue;
	          }
	          if (rel[i] === "^") {
	            if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	            current = current.parent;
	            continue;
	          }
	          break;
	        }
	        rel = rel.slice(i).join(".");
	        name = current.name + (current.name && rel ? "." : "") + rel;
	      }
	      var state = states[name];
	
	      if (state && (isStr || !isStr && (state === stateOrName || state.self === stateOrName))) {
	        return state;
	      }
	      return undefined;
	    }
	
	    function queueState(parentName, state) {
	      if (!queue[parentName]) {
	        queue[parentName] = [];
	      }
	      queue[parentName].push(state);
	    }
	
	    function flushQueuedChildren(parentName) {
	      var queued = queue[parentName] || [];
	      while (queued.length) {
	        registerState(queued.shift());
	      }
	    }
	
	    function registerState(state) {
	      // Wrap a new object around the state so we can store our private details easily.
	      state = inherit(state, {
	        self: state,
	        resolve: state.resolve || {},
	        toString: function toString() {
	          return this.name;
	        }
	      });
	
	      var name = state.name;
	      if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	      if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	      // Get parent name
	      var parentName = name.indexOf('.') !== -1 ? name.substring(0, name.lastIndexOf('.')) : isString(state.parent) ? state.parent : isObject(state.parent) && isString(state.parent.name) ? state.parent.name : '';
	
	      // If parent is not registered yet, add state to queue and register later
	      if (parentName && !states[parentName]) {
	        return queueState(parentName, state.self);
	      }
	
	      for (var key in stateBuilder) {
	        if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	      }
	      states[name] = state;
	
	      // Register the state in the global state list and with $urlRouter if necessary.
	      if (!state[abstractKey] && state.url) {
	        $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	          if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	            $state.transitionTo(state, $match, { inherit: true, location: false });
	          }
	        }]);
	      }
	
	      // Register any queued children
	      flushQueuedChildren(name);
	
	      return state;
	    }
	
	    // Checks text to see if it looks like a glob.
	    function isGlob(text) {
	      return text.indexOf('*') > -1;
	    }
	
	    // Returns true if glob matches current $state name.
	    function doesStateMatchGlob(glob) {
	      var globSegments = glob.split('.'),
	          segments = $state.$current.name.split('.');
	
	      //match single stars
	      for (var i = 0, l = globSegments.length; i < l; i++) {
	        if (globSegments[i] === '*') {
	          segments[i] = '*';
	        }
	      }
	
	      //match greedy starts
	      if (globSegments[0] === '**') {
	        segments = segments.slice(indexOf(segments, globSegments[1]));
	        segments.unshift('**');
	      }
	      //match greedy ends
	      if (globSegments[globSegments.length - 1] === '**') {
	        segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	        segments.push('**');
	      }
	
	      if (globSegments.length != segments.length) {
	        return false;
	      }
	
	      return segments.join('') === globSegments.join('');
	    }
	
	    // Implicit root state that is always active
	    root = registerState({
	      name: '',
	      url: '^',
	      views: null,
	      'abstract': true
	    });
	    root.navigable = null;
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$stateProvider#decorator
	     * @methodOf ui.router.state.$stateProvider
	     *
	     * @description
	     * Allows you to extend (carefully) or override (at your own peril) the 
	     * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	     * to add custom functionality to ui-router, for example inferring templateUrl 
	     * based on the state name.
	     *
	     * When passing only a name, it returns the current (original or decorated) builder
	     * function that matches `name`.
	     *
	     * The builder functions that can be decorated are listed below. Though not all
	     * necessarily have a good use case for decoration, that is up to you to decide.
	     *
	     * In addition, users can attach custom decorators, which will generate new 
	     * properties within the state's internal definition. There is currently no clear 
	     * use-case for this beyond accessing internal states (i.e. $state.$current), 
	     * however, expect this to become increasingly relevant as we introduce additional 
	     * meta-programming features.
	     *
	     * **Warning**: Decorators should not be interdependent because the order of 
	     * execution of the builder functions in non-deterministic. Builder functions 
	     * should only be dependent on the state definition object and super function.
	     *
	     *
	     * Existing builder functions and current return values:
	     *
	     * - **parent** `{object}` - returns the parent state object.
	     * - **data** `{object}` - returns state data, including any inherited data that is not
	     *   overridden by own values (if any).
	     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	     *   or `null`.
	     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	     *   navigable).
	     * - **params** `{object}` - returns an array of state params that are ensured to 
	     *   be a super-set of parent's params.
	     * - **views** `{object}` - returns a views object where each key is an absolute view 
	     *   name (i.e. "viewName@stateName") and each value is the config object 
	     *   (template, controller) for the view. Even when you don't use the views object 
	     *   explicitly on a state config, one is still created for you internally.
	     *   So by decorating this builder function you have access to decorating template 
	     *   and controller properties.
	     * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	     *   not including any params defined by ancestor states.
	     * - **path** `{string}` - returns the full path from the root down to this state. 
	     *   Needed for state activation.
	     * - **includes** `{object}` - returns an object that includes every state that 
	     *   would pass a `$state.includes()` test.
	     *
	     * @example
	     * <pre>
	     * // Override the internal 'views' builder with a function that takes the state
	     * // definition, and a reference to the internal function being overridden:
	     * $stateProvider.decorator('views', function (state, parent) {
	     *   var result = {},
	     *       views = parent(state);
	     *
	     *   angular.forEach(views, function (config, name) {
	     *     var autoName = (state.name + '.' + name).replace('.', '/');
	     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	     *     result[name] = config;
	     *   });
	     *   return result;
	     * });
	     *
	     * $stateProvider.state('home', {
	     *   views: {
	     *     'contact.list': { controller: 'ListController' },
	     *     'contact.item': { controller: 'ItemController' }
	     *   }
	     * });
	     *
	     * // ...
	     *
	     * $state.go('home');
	     * // Auto-populates list and item views with /partials/home/contact/list.html,
	     * // and /partials/home/contact/item.html, respectively.
	     * </pre>
	     *
	     * @param {string} name The name of the builder function to decorate. 
	     * @param {object} func A function that is responsible for decorating the original 
	     * builder function. The function receives two parameters:
	     *
	     *   - `{object}` - state - The state config object.
	     *   - `{object}` - super - The original builder function.
	     *
	     * @return {object} $stateProvider - $stateProvider instance
	     */
	    this.decorator = decorator;
	    function decorator(name, func) {
	      /*jshint validthis: true */
	      if (isString(name) && !isDefined(func)) {
	        return stateBuilder[name];
	      }
	      if (!isFunction(func) || !isString(name)) {
	        return this;
	      }
	      if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	        stateBuilder.$delegates[name] = stateBuilder[name];
	      }
	      stateBuilder[name] = func;
	      return this;
	    }
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$stateProvider#state
	     * @methodOf ui.router.state.$stateProvider
	     *
	     * @description
	     * Registers a state configuration under a given state name. The stateConfig object
	     * has the following acceptable properties.
	     *
	     * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	     * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	     * @param {object} stateConfig State configuration object.
	     * @param {string|function=} stateConfig.template
	     * <a id='template'></a>
	     *   html template as a string or a function that returns
	     *   an html template as a string which should be used by the uiView directives. This property 
	     *   takes precedence over templateUrl.
	     *   
	     *   If `template` is a function, it will be called with the following parameters:
	     *
	     *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	     *     applying the current state
	     *
	     * <pre>template:
	     *   "<h1>inline template definition</h1>" +
	     *   "<div ui-view></div>"</pre>
	     * <pre>template: function(params) {
	     *       return "<h1>generated template</h1>"; }</pre>
	     * </div>
	     *
	     * @param {string|function=} stateConfig.templateUrl
	     * <a id='templateUrl'></a>
	     *
	     *   path or function that returns a path to an html
	     *   template that should be used by uiView.
	     *   
	     *   If `templateUrl` is a function, it will be called with the following parameters:
	     *
	     *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	     *     applying the current state
	     *
	     * <pre>templateUrl: "home.html"</pre>
	     * <pre>templateUrl: function(params) {
	     *     return myTemplates[params.pageId]; }</pre>
	     *
	     * @param {function=} stateConfig.templateProvider
	     * <a id='templateProvider'></a>
	     *    Provider function that returns HTML content string.
	     * <pre> templateProvider:
	     *       function(MyTemplateService, params) {
	     *         return MyTemplateService.getTemplate(params.pageId);
	     *       }</pre>
	     *
	     * @param {string|function=} stateConfig.controller
	     * <a id='controller'></a>
	     *
	     *  Controller fn that should be associated with newly
	     *   related scope or the name of a registered controller if passed as a string.
	     *   Optionally, the ControllerAs may be declared here.
	     * <pre>controller: "MyRegisteredController"</pre>
	     * <pre>controller:
	     *     "MyRegisteredController as fooCtrl"}</pre>
	     * <pre>controller: function($scope, MyService) {
	     *     $scope.data = MyService.getData(); }</pre>
	     *
	     * @param {function=} stateConfig.controllerProvider
	     * <a id='controllerProvider'></a>
	     *
	     * Injectable provider function that returns the actual controller or string.
	     * <pre>controllerProvider:
	     *   function(MyResolveData) {
	     *     if (MyResolveData.foo)
	     *       return "FooCtrl"
	     *     else if (MyResolveData.bar)
	     *       return "BarCtrl";
	     *     else return function($scope) {
	     *       $scope.baz = "Qux";
	     *     }
	     *   }</pre>
	     *
	     * @param {string=} stateConfig.controllerAs
	     * <a id='controllerAs'></a>
	     * 
	     * A controller alias name. If present the controller will be
	     *   published to scope under the controllerAs name.
	     * <pre>controllerAs: "myCtrl"</pre>
	     *
	     * @param {string|object=} stateConfig.parent
	     * <a id='parent'></a>
	     * Optionally specifies the parent state of this state.
	     *
	     * <pre>parent: 'parentState'</pre>
	     * <pre>parent: parentState // JS variable</pre>
	     *
	     * @param {object=} stateConfig.resolve
	     * <a id='resolve'></a>
	     *
	     * An optional map&lt;string, function&gt; of dependencies which
	     *   should be injected into the controller. If any of these dependencies are promises, 
	     *   the router will wait for them all to be resolved before the controller is instantiated.
	     *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	     *   and the values of the resolved promises are injected into any controllers that reference them.
	     *   If any  of the promises are rejected the $stateChangeError event is fired.
	     *
	     *   The map object is:
	     *   
	     *   - key - {string}: name of dependency to be injected into controller
	     *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	     *     it is injected and return value it treated as dependency. If result is a promise, it is 
	     *     resolved before its value is injected into controller.
	     *
	     * <pre>resolve: {
	     *     myResolve1:
	     *       function($http, $stateParams) {
	     *         return $http.get("/api/foos/"+stateParams.fooID);
	     *       }
	     *     }</pre>
	     *
	     * @param {string=} stateConfig.url
	     * <a id='url'></a>
	     *
	     *   A url fragment with optional parameters. When a state is navigated or
	     *   transitioned to, the `$stateParams` service will be populated with any 
	     *   parameters that were passed.
	     *
	     *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	     *   more details on acceptable patterns )
	     *
	     * examples:
	     * <pre>url: "/home"
	     * url: "/users/:userid"
	     * url: "/books/{bookid:[a-zA-Z_-]}"
	     * url: "/books/{categoryid:int}"
	     * url: "/books/{publishername:string}/{categoryid:int}"
	     * url: "/messages?before&after"
	     * url: "/messages?{before:date}&{after:date}"
	     * url: "/messages/:mailboxid?{before:date}&{after:date}"
	     * </pre>
	     *
	     * @param {object=} stateConfig.views
	     * <a id='views'></a>
	     * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	     * manually/explicitly.
	     *
	     * Examples:
	     *
	     * Targets three named `ui-view`s in the parent state's template
	     * <pre>views: {
	     *     header: {
	     *       controller: "headerCtrl",
	     *       templateUrl: "header.html"
	     *     }, body: {
	     *       controller: "bodyCtrl",
	     *       templateUrl: "body.html"
	     *     }, footer: {
	     *       controller: "footCtrl",
	     *       templateUrl: "footer.html"
	     *     }
	     *   }</pre>
	     *
	     * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	     * <pre>views: {
	     *     'header@top': {
	     *       controller: "msgHeaderCtrl",
	     *       templateUrl: "msgHeader.html"
	     *     }, 'body': {
	     *       controller: "messagesCtrl",
	     *       templateUrl: "messages.html"
	     *     }
	     *   }</pre>
	     *
	     * @param {boolean=} [stateConfig.abstract=false]
	     * <a id='abstract'></a>
	     * An abstract state will never be directly activated,
	     *   but can provide inherited properties to its common children states.
	     * <pre>abstract: true</pre>
	     *
	     * @param {function=} stateConfig.onEnter
	     * <a id='onEnter'></a>
	     *
	     * Callback function for when a state is entered. Good way
	     *   to trigger an action or dispatch an event, such as opening a dialog.
	     * If minifying your scripts, make sure to explicitly annotate this function,
	     * because it won't be automatically annotated by your build tools.
	     *
	     * <pre>onEnter: function(MyService, $stateParams) {
	     *     MyService.foo($stateParams.myParam);
	     * }</pre>
	     *
	     * @param {function=} stateConfig.onExit
	     * <a id='onExit'></a>
	     *
	     * Callback function for when a state is exited. Good way to
	     *   trigger an action or dispatch an event, such as opening a dialog.
	     * If minifying your scripts, make sure to explicitly annotate this function,
	     * because it won't be automatically annotated by your build tools.
	     *
	     * <pre>onExit: function(MyService, $stateParams) {
	     *     MyService.cleanup($stateParams.myParam);
	     * }</pre>
	     *
	     * @param {boolean=} [stateConfig.reloadOnSearch=true]
	     * <a id='reloadOnSearch'></a>
	     *
	     * If `false`, will not retrigger the same state
	     *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	     *   Useful for when you'd like to modify $location.search() without triggering a reload.
	     * <pre>reloadOnSearch: false</pre>
	     *
	     * @param {object=} stateConfig.data
	     * <a id='data'></a>
	     *
	     * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	     *   prototypally inherited.  In other words, adding a data property to a state adds it to
	     *   the entire subtree via prototypal inheritance.
	     *
	     * <pre>data: {
	     *     requiredRole: 'foo'
	     * } </pre>
	     *
	     * @param {object=} stateConfig.params
	     * <a id='params'></a>
	     *
	     * A map which optionally configures parameters declared in the `url`, or
	     *   defines additional non-url parameters.  For each parameter being
	     *   configured, add a configuration object keyed to the name of the parameter.
	     *
	     *   Each parameter configuration object may contain the following properties:
	     *
	     *   - ** value ** - {object|function=}: specifies the default value for this
	     *     parameter.  This implicitly sets this parameter as optional.
	     *
	     *     When UI-Router routes to a state and no value is
	     *     specified for this parameter in the URL or transition, the
	     *     default value will be used instead.  If `value` is a function,
	     *     it will be injected and invoked, and the return value used.
	     *
	     *     *Note*: `undefined` is treated as "no default value" while `null`
	     *     is treated as "the default value is `null`".
	     *
	     *     *Shorthand*: If you only need to configure the default value of the
	     *     parameter, you may use a shorthand syntax.   In the **`params`**
	     *     map, instead mapping the param name to a full parameter configuration
	     *     object, simply set map it to the default parameter value, e.g.:
	     *
	     * <pre>// define a parameter's default value
	     * params: {
	     *     param1: { value: "defaultValue" }
	     * }
	     * // shorthand default values
	     * params: {
	     *     param1: "defaultValue",
	     *     param2: "param2Default"
	     * }</pre>
	     *
	     *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	     *     treated as an array of values.  If you specified a Type, the value will be
	     *     treated as an array of the specified Type.  Note: query parameter values
	     *     default to a special `"auto"` mode.
	     *
	     *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	     *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	     *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	     *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	     *     value (e.g.: `{ foo: '1' }`).
	     *
	     * <pre>params: {
	     *     param1: { array: true }
	     * }</pre>
	     *
	     *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	     *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	     *     configured default squash policy.
	     *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	     *
	     *   There are three squash settings:
	     *
	     *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	     *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	     *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	     *       This can allow for cleaner looking URLs.
	     *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	     *
	     * <pre>params: {
	     *     param1: {
	     *       value: "defaultId",
	     *       squash: true
	     * } }
	     * // squash "defaultValue" to "~"
	     * params: {
	     *     param1: {
	     *       value: "defaultValue",
	     *       squash: "~"
	     * } }
	     * </pre>
	     *
	     *
	     * @example
	     * <pre>
	     * // Some state name examples
	     *
	     * // stateName can be a single top-level name (must be unique).
	     * $stateProvider.state("home", {});
	     *
	     * // Or it can be a nested state name. This state is a child of the
	     * // above "home" state.
	     * $stateProvider.state("home.newest", {});
	     *
	     * // Nest states as deeply as needed.
	     * $stateProvider.state("home.newest.abc.xyz.inception", {});
	     *
	     * // state() returns $stateProvider, so you can chain state declarations.
	     * $stateProvider
	     *   .state("home", {})
	     *   .state("about", {})
	     *   .state("contacts", {});
	     * </pre>
	     *
	     */
	    this.state = state;
	    function state(name, definition) {
	      /*jshint validthis: true */
	      if (isObject(name)) definition = name;else definition.name = name;
	      registerState(definition);
	      return this;
	    }
	
	    /**
	     * @ngdoc object
	     * @name ui.router.state.$state
	     *
	     * @requires $rootScope
	     * @requires $q
	     * @requires ui.router.state.$view
	     * @requires $injector
	     * @requires ui.router.util.$resolve
	     * @requires ui.router.state.$stateParams
	     * @requires ui.router.router.$urlRouter
	     *
	     * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	     * you'd like to test against the current active state.
	     * @property {object} current A reference to the state's config object. However 
	     * you passed it in. Useful for accessing custom data.
	     * @property {object} transition Currently pending transition. A promise that'll 
	     * resolve or reject.
	     *
	     * @description
	     * `$state` service is responsible for representing states as well as transitioning
	     * between them. It also provides interfaces to ask for current state or even states
	     * you're coming from.
	     */
	    this.$get = $get;
	    $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	    function $get($rootScope, $q, $view, $injector, $resolve, $stateParams, $urlRouter, $location, $urlMatcherFactory) {
	
	      var TransitionSupersededError = new Error('transition superseded');
	
	      var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
	      var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
	      var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
	      var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));
	
	      // Handles the case where a state which is the target of a transition is not found, and the user
	      // can optionally retry or defer the transition
	      function handleRedirect(redirect, state, params, options) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateNotFound
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when a requested state **cannot be found** using the provided state name during transition.
	         * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	         * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	         * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	         * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	         * @param {State} fromState Current state object.
	         * @param {Object} fromParams Current state params.
	         *
	         * @example
	         *
	         * <pre>
	         * // somewhere, assume lazy.state has not been defined
	         * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	         *
	         * // somewhere else
	         * $scope.$on('$stateNotFound',
	         * function(event, unfoundState, fromState, fromParams){
	         *     console.log(unfoundState.to); // "lazy.state"
	         *     console.log(unfoundState.toParams); // {a:1, b:2}
	         *     console.log(unfoundState.options); // {inherit:false} + default options
	         * })
	         * </pre>
	         */
	        var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	        if (evt.defaultPrevented) {
	          $urlRouter.update();
	          return TransitionAborted;
	        }
	
	        if (!evt.retry) {
	          return null;
	        }
	
	        // Allow the handler to return a promise to defer state lookup retry
	        if (options.$retry) {
	          $urlRouter.update();
	          return TransitionFailed;
	        }
	        var retryTransition = $state.transition = $q.when(evt.retry);
	
	        retryTransition.then(function () {
	          if (retryTransition !== $state.transition) {
	            $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
	            return TransitionSuperseded;
	          }
	          redirect.options.$retry = true;
	          return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	        }, function () {
	          return TransitionAborted;
	        });
	        $urlRouter.update();
	
	        return retryTransition;
	      }
	
	      root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	      $state = {
	        params: {},
	        current: root.self,
	        $current: root,
	        transition: null
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#reload
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * A method that force reloads the current state. All resolves are re-resolved,
	       * controllers reinstantiated, and events re-fired.
	       *
	       * @example
	       * <pre>
	       * var app angular.module('app', ['ui.router']);
	       *
	       * app.controller('ctrl', function ($scope, $state) {
	       *   $scope.reload = function(){
	       *     $state.reload();
	       *   }
	       * });
	       * </pre>
	       *
	       * `reload()` is just an alias for:
	       * <pre>
	       * $state.transitionTo($state.current, $stateParams, { 
	       *   reload: true, inherit: false, notify: true
	       * });
	       * </pre>
	       *
	       * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	       * @example
	       * <pre>
	       * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	       * //and current state is 'contacts.detail.item'
	       * var app angular.module('app', ['ui.router']);
	       *
	       * app.controller('ctrl', function ($scope, $state) {
	       *   $scope.reload = function(){
	       *     //will reload 'contact.detail' and 'contact.detail.item' states
	       *     $state.reload('contact.detail');
	       *   }
	       * });
	       * </pre>
	       *
	       * `reload()` is just an alias for:
	       * <pre>
	       * $state.transitionTo($state.current, $stateParams, { 
	       *   reload: true, inherit: false, notify: true
	       * });
	       * </pre>
	        * @returns {promise} A promise representing the state of the new transition. See
	       * {@link ui.router.state.$state#methods_go $state.go}.
	       */
	      $state.reload = function reload(state) {
	        return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true });
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#go
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * Convenience method for transitioning to a new state. `$state.go` calls 
	       * `$state.transitionTo` internally but automatically sets options to 
	       * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	       * This allows you to easily use an absolute or relative to path and specify 
	       * only the parameters you'd like to update (while letting unspecified parameters 
	       * inherit from the currently active ancestor states).
	       *
	       * @example
	       * <pre>
	       * var app = angular.module('app', ['ui.router']);
	       *
	       * app.controller('ctrl', function ($scope, $state) {
	       *   $scope.changeState = function () {
	       *     $state.go('contact.detail');
	       *   };
	       * });
	       * </pre>
	       * <img src='../ngdoc_assets/StateGoExamples.png'/>
	       *
	       * @param {string} to Absolute state name or relative state path. Some examples:
	       *
	       * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	       * - `$state.go('^')` - will go to a parent state
	       * - `$state.go('^.sibling')` - will go to a sibling state
	       * - `$state.go('.child.grandchild')` - will go to grandchild state
	       *
	       * @param {object=} params A map of the parameters that will be sent to the state, 
	       * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	       * defined parameters. Only parameters specified in the state definition can be overridden, new 
	       * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	       * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	       * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	       * will get you all current parameters, etc.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	       *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	       * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	       * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	       *    defines which state to be relative from.
	       * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	       * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	       *    have changed.  It will reload the resolves and views of the current state and parent states.
	       *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	       *    the transition reloads the resolves and views for that matched state, and all its children states.
	       *
	       * @returns {promise} A promise representing the state of the new transition.
	       *
	       * Possible success values:
	       *
	       * - $state.current
	       *
	       * <br/>Possible rejection values:
	       *
	       * - 'transition superseded' - when a newer transition has been started after this one
	       * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	       * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	       *   when a `$stateNotFound` `event.retry` promise errors.
	       * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	       * - *resolve error* - when an error has occurred with a `resolve`
	       *
	       */
	      $state.go = function go(to, params, options) {
	        return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#transitionTo
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	       * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	       *
	       * @example
	       * <pre>
	       * var app = angular.module('app', ['ui.router']);
	       *
	       * app.controller('ctrl', function ($scope, $state) {
	       *   $scope.changeState = function () {
	       *     $state.transitionTo('contact.detail');
	       *   };
	       * });
	       * </pre>
	       *
	       * @param {string} to State name.
	       * @param {object=} toParams A map of the parameters that will be sent to the state,
	       * will populate $stateParams.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	       *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	       * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	       * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	       *    defines which state to be relative from.
	       * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	       * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	       *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	       *    use this when you want to force a reload when *everything* is the same, including search params.
	       *    if String, then will reload the state with the name given in reload, and any children.
	       *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	       *
	       * @returns {promise} A promise representing the state of the new transition. See
	       * {@link ui.router.state.$state#methods_go $state.go}.
	       */
	      $state.transitionTo = function transitionTo(to, toParams, options) {
	        toParams = toParams || {};
	        options = extend({
	          location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	        }, options || {});
	
	        var from = $state.$current,
	            fromParams = $state.params,
	            fromPath = from.path;
	        var evt,
	            toState = findState(to, options.relative);
	
	        // Store the hash param for later (since it will be stripped out by various methods)
	        var hash = toParams['#'];
	
	        if (!isDefined(toState)) {
	          var redirect = { to: to, toParams: toParams, options: options };
	          var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	          if (redirectResult) {
	            return redirectResult;
	          }
	
	          // Always retry once if the $stateNotFound was not prevented
	          // (handles either redirect changed or state lazy-definition)
	          to = redirect.to;
	          toParams = redirect.toParams;
	          options = redirect.options;
	          toState = findState(to, options.relative);
	
	          if (!isDefined(toState)) {
	            if (!options.relative) throw new Error("No such state '" + to + "'");
	            throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	          }
	        }
	        if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	        if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	        if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	        toParams = toState.params.$$values(toParams);
	        to = toState;
	
	        var toPath = to.path;
	
	        // Starting from the root of the path, keep all levels that haven't changed
	        var keep = 0,
	            state = toPath[keep],
	            locals = root.locals,
	            toLocals = [];
	
	        if (!options.reload) {
	          while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	            locals = toLocals[keep] = state.locals;
	            keep++;
	            state = toPath[keep];
	          }
	        } else if (isString(options.reload) || isObject(options.reload)) {
	          if (isObject(options.reload) && !options.reload.name) {
	            throw new Error('Invalid reload state object');
	          }
	
	          var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	          if (options.reload && !reloadState) {
	            throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	          }
	
	          while (state && state === fromPath[keep] && state !== reloadState) {
	            locals = toLocals[keep] = state.locals;
	            keep++;
	            state = toPath[keep];
	          }
	        }
	
	        // If we're going to the same state and all locals are kept, we've got nothing to do.
	        // But clear 'transition', as we still want to cancel any other pending transitions.
	        // TODO: We may not want to bump 'transition' if we're called from a location change
	        // that we've initiated ourselves, because we might accidentally abort a legitimate
	        // transition initiated from code?
	        if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	          if (hash) toParams['#'] = hash;
	          $state.params = toParams;
	          copy($state.params, $stateParams);
	          copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	          if (options.location && to.navigable && to.navigable.url) {
	            $urlRouter.push(to.navigable.url, toParams, {
	              $$avoidResync: true, replace: options.location === 'replace'
	            });
	            $urlRouter.update(true);
	          }
	          $state.transition = null;
	          return $q.when($state.current);
	        }
	
	        // Filter parameters before we pass them to event handlers etc.
	        toParams = filterByKeys(to.params.$$keys(), toParams || {});
	
	        // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	        if (hash) toParams['#'] = hash;
	
	        // Broadcast start event and cancel the transition if requested
	        if (options.notify) {
	          /**
	           * @ngdoc event
	           * @name ui.router.state.$state#$stateChangeStart
	           * @eventOf ui.router.state.$state
	           * @eventType broadcast on root scope
	           * @description
	           * Fired when the state transition **begins**. You can use `event.preventDefault()`
	           * to prevent the transition from happening and then the transition promise will be
	           * rejected with a `'transition prevented'` value.
	           *
	           * @param {Object} event Event object.
	           * @param {State} toState The state being transitioned to.
	           * @param {Object} toParams The params supplied to the `toState`.
	           * @param {State} fromState The current state, pre-transition.
	           * @param {Object} fromParams The params supplied to the `fromState`.
	           *
	           * @example
	           *
	           * <pre>
	           * $rootScope.$on('$stateChangeStart',
	           * function(event, toState, toParams, fromState, fromParams){
	           *     event.preventDefault();
	           *     // transitionTo() promise will be rejected with
	           *     // a 'transition prevented' error
	           * })
	           * </pre>
	           */
	          if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	            $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	            //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	            if ($state.transition == null) $urlRouter.update();
	            return TransitionPrevented;
	          }
	        }
	
	        // Resolve locals for the remaining states, but don't update any global state just
	        // yet -- if anything fails to resolve the current state needs to remain untouched.
	        // We also set up an inheritance chain for the locals here. This allows the view directive
	        // to quickly look up the correct definition for each view in the current state. Even
	        // though we create the locals object itself outside resolveState(), it is initially
	        // empty and gets filled asynchronously. We need to keep track of the promise for the
	        // (fully resolved) current locals, and pass this down the chain.
	        var resolved = $q.when(locals);
	
	        for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	          locals = toLocals[l] = inherit(locals);
	          resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	        }
	
	        // Once everything is resolved, we are ready to perform the actual transition
	        // and return a promise for the new state. We also keep track of what the
	        // current promise is, so that we can detect overlapping transitions and
	        // keep only the outcome of the last transition.
	        var transition = $state.transition = resolved.then(function () {
	          var l, entering, exiting;
	
	          if ($state.transition !== transition) {
	            $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	            return TransitionSuperseded;
	          }
	
	          // Exit 'from' states not kept
	          for (l = fromPath.length - 1; l >= keep; l--) {
	            exiting = fromPath[l];
	            if (exiting.self.onExit) {
	              $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	            }
	            exiting.locals = null;
	          }
	
	          // Enter 'to' states not kept
	          for (l = keep; l < toPath.length; l++) {
	            entering = toPath[l];
	            entering.locals = toLocals[l];
	            if (entering.self.onEnter) {
	              $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	            }
	          }
	
	          // Run it again, to catch any transitions in callbacks
	          if ($state.transition !== transition) {
	            $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	            return TransitionSuperseded;
	          }
	
	          // Update globals in $state
	          $state.$current = to;
	          $state.current = to.self;
	          $state.params = toParams;
	          copy($state.params, $stateParams);
	          $state.transition = null;
	
	          if (options.location && to.navigable) {
	            $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	              $$avoidResync: true, replace: options.location === 'replace'
	            });
	          }
	
	          if (options.notify) {
	            /**
	             * @ngdoc event
	             * @name ui.router.state.$state#$stateChangeSuccess
	             * @eventOf ui.router.state.$state
	             * @eventType broadcast on root scope
	             * @description
	             * Fired once the state transition is **complete**.
	             *
	             * @param {Object} event Event object.
	             * @param {State} toState The state being transitioned to.
	             * @param {Object} toParams The params supplied to the `toState`.
	             * @param {State} fromState The current state, pre-transition.
	             * @param {Object} fromParams The params supplied to the `fromState`.
	             */
	            $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	          }
	          $urlRouter.update(true);
	
	          return $state.current;
	        }).then(null, function (error) {
	          // propagate TransitionSuperseded error without emitting $stateChangeCancel
	          // as it was already emitted in the success handler above
	          if (error === TransitionSupersededError) return TransitionSuperseded;
	
	          if ($state.transition !== transition) {
	            $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	            return TransitionSuperseded;
	          }
	
	          $state.transition = null;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.$state#$stateChangeError
	           * @eventOf ui.router.state.$state
	           * @eventType broadcast on root scope
	           * @description
	           * Fired when an **error occurs** during transition. It's important to note that if you
	           * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	           * they will not throw traditionally. You must listen for this $stateChangeError event to
	           * catch **ALL** errors.
	           *
	           * @param {Object} event Event object.
	           * @param {State} toState The state being transitioned to.
	           * @param {Object} toParams The params supplied to the `toState`.
	           * @param {State} fromState The current state, pre-transition.
	           * @param {Object} fromParams The params supplied to the `fromState`.
	           * @param {Error} error The resolve error object.
	           */
	          evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	          if (!evt.defaultPrevented) {
	            $urlRouter.update();
	          }
	
	          return $q.reject(error);
	        });
	
	        silenceUncaughtInPromise(transition);
	        return transition;
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#is
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	       * but only checks for the full state name. If params is supplied then it will be
	       * tested for strict equality against the current active params object, so all params
	       * must match with none missing and no extras.
	       *
	       * @example
	       * <pre>
	       * $state.$current.name = 'contacts.details.item';
	       *
	       * // absolute name
	       * $state.is('contact.details.item'); // returns true
	       * $state.is(contactDetailItemStateObject); // returns true
	       *
	       * // relative name (. and ^), typically from a template
	       * // E.g. from the 'contacts.details' template
	       * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	       * </pre>
	       *
	       * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	       * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	       * to test against the current active state.
	       * @param {object=} options An options object.  The options are:
	       *
	       * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	       * test relative to `options.relative` state (or name).
	       *
	       * @returns {boolean} Returns true if it is the state.
	       */
	      $state.is = function is(stateOrName, params, options) {
	        options = extend({ relative: $state.$current }, options || {});
	        var state = findState(stateOrName, options.relative);
	
	        if (!isDefined(state)) {
	          return undefined;
	        }
	        if ($state.$current !== state) {
	          return false;
	        }
	
	        return !params || objectKeys(params).reduce(function (acc, key) {
	          var paramDef = state.params[key];
	          return acc && (!paramDef || paramDef.type.equals($stateParams[key], params[key]));
	        }, true);
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#includes
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * A method to determine if the current active state is equal to or is the child of the
	       * state stateName. If any params are passed then they will be tested for a match as well.
	       * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	       *
	       * @example
	       * Partial and relative names
	       * <pre>
	       * $state.$current.name = 'contacts.details.item';
	       *
	       * // Using partial names
	       * $state.includes("contacts"); // returns true
	       * $state.includes("contacts.details"); // returns true
	       * $state.includes("contacts.details.item"); // returns true
	       * $state.includes("contacts.list"); // returns false
	       * $state.includes("about"); // returns false
	       *
	       * // Using relative names (. and ^), typically from a template
	       * // E.g. from the 'contacts.details' template
	       * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	       * </pre>
	       *
	       * Basic globbing patterns
	       * <pre>
	       * $state.$current.name = 'contacts.details.item.url';
	       *
	       * $state.includes("*.details.*.*"); // returns true
	       * $state.includes("*.details.**"); // returns true
	       * $state.includes("**.item.**"); // returns true
	       * $state.includes("*.details.item.url"); // returns true
	       * $state.includes("*.details.*.url"); // returns true
	       * $state.includes("*.details.*"); // returns false
	       * $state.includes("item.**"); // returns false
	       * </pre>
	       *
	       * @param {string} stateOrName A partial name, relative name, or glob pattern
	       * to be searched for within the current state name.
	       * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	       * that you'd like to test against the current active state.
	       * @param {object=} options An options object.  The options are:
	       *
	       * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	       * .includes will test relative to `options.relative` state (or name).
	       *
	       * @returns {boolean} Returns true if it does include the state
	       */
	      $state.includes = function includes(stateOrName, params, options) {
	        options = extend({ relative: $state.$current }, options || {});
	        if (isString(stateOrName) && isGlob(stateOrName)) {
	          if (!doesStateMatchGlob(stateOrName)) {
	            return false;
	          }
	          stateOrName = $state.$current.name;
	        }
	
	        var state = findState(stateOrName, options.relative);
	        if (!isDefined(state)) {
	          return undefined;
	        }
	        if (!isDefined($state.$current.includes[state.name])) {
	          return false;
	        }
	        if (!params) {
	          return true;
	        }
	
	        var keys = objectKeys(params);
	        for (var i = 0; i < keys.length; i++) {
	          var key = keys[i],
	              paramDef = state.params[key];
	          if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
	            return false;
	          }
	        }
	
	        return objectKeys(params).reduce(function (acc, key) {
	          var paramDef = state.params[key];
	          return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
	        }, true);
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#href
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * A url generation method that returns the compiled url for the given state populated with the given params.
	       *
	       * @example
	       * <pre>
	       * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	       * </pre>
	       *
	       * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	       * @param {object=} params An object of parameter values to fill the state's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	       *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	       *    ancestor with a valid url).
	       * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	       * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	       *    defines which state to be relative from.
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       * 
	       * @returns {string} compiled state url
	       */
	      $state.href = function href(stateOrName, params, options) {
	        options = extend({
	          lossy: true,
	          inherit: true,
	          absolute: false,
	          relative: $state.$current
	        }, options || {});
	
	        var state = findState(stateOrName, options.relative);
	
	        if (!isDefined(state)) return null;
	        if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	
	        var nav = state && options.lossy ? state.navigable : state;
	
	        if (!nav || nav.url === undefined || nav.url === null) {
	          return null;
	        }
	        return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	          absolute: options.absolute
	        });
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#get
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * Returns the state configuration object for any specific state or all states.
	       *
	       * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	       * the requested state. If not provided, returns an array of ALL state configs.
	       * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	       * @returns {Object|Array} State configuration object or array of all objects.
	       */
	      $state.get = function (stateOrName, context) {
	        if (arguments.length === 0) return map(objectKeys(states), function (name) {
	          return states[name].self;
	        });
	        var state = findState(stateOrName, context || $state.$current);
	        return state && state.self ? state.self : null;
	      };
	
	      function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	        // Make a restricted $stateParams with only the parameters that apply to this state if
	        // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	        // we also need $stateParams to be available for any $injector calls we make during the
	        // dependency resolution process.
	        var $stateParams = paramsAreFiltered ? params : filterByKeys(state.params.$$keys(), params);
	        var locals = { $stateParams: $stateParams };
	
	        // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	        // We're also including $stateParams in this; that way the parameters are restricted
	        // to the set that should be visible to the state, and are independent of when we update
	        // the global $state and $stateParams values.
	        dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	        var promises = [dst.resolve.then(function (globals) {
	          dst.globals = globals;
	        })];
	        if (inherited) promises.push(inherited);
	
	        function resolveViews() {
	          var viewsPromises = [];
	
	          // Resolve template and dependencies for all views.
	          forEach(state.views, function (view, name) {
	            var injectables = view.resolve && view.resolve !== state.resolve ? view.resolve : {};
	            injectables.$template = [function () {
	              return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	            }];
	
	            viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	              // References to the controller (only instantiated at link time)
	              if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	                var injectLocals = angular.extend({}, injectables, dst.globals);
	                result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	              } else {
	                result.$$controller = view.controller;
	              }
	              // Provide access to the state itself for internal use
	              result.$$state = state;
	              result.$$controllerAs = view.controllerAs;
	              result.$$resolveAs = view.resolveAs;
	              dst[name] = result;
	            }));
	          });
	
	          return $q.all(viewsPromises).then(function () {
	            return dst.globals;
	          });
	        }
	
	        // Wait for all the promises and then return the activation object
	        return $q.all(promises).then(resolveViews).then(function (values) {
	          return dst;
	        });
	      }
	
	      return $state;
	    }
	
	    function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	      // Return true if there are no differences in non-search (path/object) params, false if there are differences
	      function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	        // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	        function notSearchParam(key) {
	          return fromAndToState.params[key].location != "search";
	        }
	        var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	        var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	        var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	        return nonQueryParamSet.$$equals(fromParams, toParams);
	      }
	
	      // If reload was not explicitly requested
	      // and we're transitioning to the same state we're already in
	      // and    the locals didn't change
	      //     or they changed in a way that doesn't merit reloading
	      //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	      // Then return true.
	      if (!options.reload && to === from && (locals === from.locals || to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams))) {
	        return true;
	      }
	    }
	  }
	
	  angular.module('ui.router.state').factory('$stateParams', function () {
	    return {};
	  }).constant("$state.runtime", { autoinject: true }).provider('$state', $StateProvider)
	  // Inject $state to initialize when entering runtime. #2574
	  .run(['$injector', function ($injector) {
	    // Allow tests (stateSpec.js) to turn this off by defining this constant
	    if ($injector.get("$state.runtime").autoinject) {
	      $injector.get('$state');
	    }
	  }]);
	
	  $ViewProvider.$inject = [];
	  function $ViewProvider() {
	
	    this.$get = $get;
	    /**
	     * @ngdoc object
	     * @name ui.router.state.$view
	     *
	     * @requires ui.router.util.$templateFactory
	     * @requires $rootScope
	     *
	     * @description
	     *
	     */
	    $get.$inject = ['$rootScope', '$templateFactory'];
	    function $get($rootScope, $templateFactory) {
	      return {
	        // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	        /**
	         * @ngdoc function
	         * @name ui.router.state.$view#load
	         * @methodOf ui.router.state.$view
	         *
	         * @description
	         *
	         * @param {string} name name
	         * @param {object} options option object.
	         */
	        load: function load(name, options) {
	          var result,
	              defaults = {
	            template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	          };
	          options = extend(defaults, options);
	
	          if (options.view) {
	            result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	          }
	          return result;
	        }
	      };
	    }
	  }
	
	  angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	   */
	  function $ViewScrollProvider() {
	
	    var useAnchorScroll = false;
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	     * @methodOf ui.router.state.$uiViewScrollProvider
	     *
	     * @description
	     * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	     * scrolling based on the url anchor.
	     */
	    this.useAnchorScroll = function () {
	      useAnchorScroll = true;
	    };
	
	    /**
	     * @ngdoc object
	     * @name ui.router.state.$uiViewScroll
	     *
	     * @requires $anchorScroll
	     * @requires $timeout
	     *
	     * @description
	     * When called with a jqLite element, it scrolls the element into view (after a
	     * `$timeout` so the DOM has time to refresh).
	     *
	     * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	     * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	     */
	    this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	      if (useAnchorScroll) {
	        return $anchorScroll;
	      }
	
	      return function ($element) {
	        return $timeout(function () {
	          $element[0].scrollIntoView();
	        }, 0, false);
	      };
	    }];
	  }
	
	  angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-view
	   *
	   * @requires ui.router.state.$state
	   * @requires $compile
	   * @requires $controller
	   * @requires $injector
	   * @requires ui.router.state.$uiViewScroll
	   * @requires $document
	   *
	   * @restrict ECA
	   *
	   * @description
	   * The ui-view directive tells $state where to place your templates.
	   *
	   * @param {string=} name A view name. The name should be unique amongst the other views in the
	   * same state. You can have views of the same name that live in different states.
	   *
	   * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	   * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	   * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	   * scroll ui-view elements into view when they are populated during a state activation.
	   *
	   * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	   * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	   *
	   * @param {string=} onload Expression to evaluate whenever the view updates.
	   *
	   * @example
	   * A view can be unnamed or named.
	   * <pre>
	   * <!-- Unnamed -->
	   * <div ui-view></div>
	   *
	   * <!-- Named -->
	   * <div ui-view="viewName"></div>
	   * </pre>
	   *
	   * You can only have one unnamed view within any template (or root html). If you are only using a
	   * single view and it is unnamed then you can populate it like so:
	   * <pre>
	   * <div ui-view></div>
	   * $stateProvider.state("home", {
	   *   template: "<h1>HELLO!</h1>"
	   * })
	   * </pre>
	   *
	   * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
	   * config property, by name, in this case an empty name:
	   * <pre>
	   * $stateProvider.state("home", {
	   *   views: {
	   *     "": {
	   *       template: "<h1>HELLO!</h1>"
	   *     }
	   *   }    
	   * })
	   * </pre>
	   *
	   * But typically you'll only use the views property if you name your view or have more than one view
	   * in the same template. There's not really a compelling reason to name a view if its the only one,
	   * but you could if you wanted, like so:
	   * <pre>
	   * <div ui-view="main"></div>
	   * </pre>
	   * <pre>
	   * $stateProvider.state("home", {
	   *   views: {
	   *     "main": {
	   *       template: "<h1>HELLO!</h1>"
	   *     }
	   *   }    
	   * })
	   * </pre>
	   *
	   * Really though, you'll use views to set up multiple views:
	   * <pre>
	   * <div ui-view></div>
	   * <div ui-view="chart"></div>
	   * <div ui-view="data"></div>
	   * </pre>
	   *
	   * <pre>
	   * $stateProvider.state("home", {
	   *   views: {
	   *     "": {
	   *       template: "<h1>HELLO!</h1>"
	   *     },
	   *     "chart": {
	   *       template: "<chart_thing/>"
	   *     },
	   *     "data": {
	   *       template: "<data_thing/>"
	   *     }
	   *   }    
	   * })
	   * </pre>
	   *
	   * Examples for `autoscroll`:
	   *
	   * <pre>
	   * <!-- If autoscroll present with no expression,
	   *      then scroll ui-view into view -->
	   * <ui-view autoscroll/>
	   *
	   * <!-- If autoscroll present with valid expression,
	   *      then scroll ui-view into view if expression evaluates to true -->
	   * <ui-view autoscroll='true'/>
	   * <ui-view autoscroll='false'/>
	   * <ui-view autoscroll='scopeVariable'/>
	   * </pre>
	   *
	   * Resolve data:
	   *
	   * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	   * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	   *
	   * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	   * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	   * depends on `$resolve` data.
	   *
	   * Example usage of $resolve in a view template
	   * <pre>
	   * $stateProvider.state('home', {
	   *   template: '<my-component user="$resolve.user"></my-component>',
	   *   resolve: {
	   *     user: function(UserService) { return UserService.fetchUser(); }
	   *   }
	   * });
	   * </pre>
	   */
	  $ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
	  function $ViewDirective($state, $injector, $uiViewScroll, $interpolate, $q) {
	
	    function getService() {
	      return $injector.has ? function (service) {
	        return $injector.has(service) ? $injector.get(service) : null;
	      } : function (service) {
	        try {
	          return $injector.get(service);
	        } catch (e) {
	          return null;
	        }
	      };
	    }
	
	    var service = getService(),
	        $animator = service('$animator'),
	        $animate = service('$animate');
	
	    // Returns a set of DOM manipulation functions based on which Angular version
	    // it should use
	    function getRenderer(attrs, scope) {
	      var statics = function statics() {
	        return {
	          enter: function enter(element, target, cb) {
	            target.after(element);cb();
	          },
	          leave: function leave(element, cb) {
	            element.remove();cb();
	          }
	        };
	      };
	
	      if ($animate) {
	        return {
	          enter: function enter(element, target, cb) {
	            if (angular.version.minor > 2) {
	              $animate.enter(element, null, target).then(cb);
	            } else {
	              $animate.enter(element, null, target, cb);
	            }
	          },
	          leave: function leave(element, cb) {
	            if (angular.version.minor > 2) {
	              $animate.leave(element).then(cb);
	            } else {
	              $animate.leave(element, cb);
	            }
	          }
	        };
	      }
	
	      if ($animator) {
	        var animate = $animator && $animator(scope, attrs);
	
	        return {
	          enter: function enter(element, target, cb) {
	            animate.enter(element, null, target);cb();
	          },
	          leave: function leave(element, cb) {
	            animate.leave(element);cb();
	          }
	        };
	      }
	
	      return statics();
	    }
	
	    var directive = {
	      restrict: 'ECA',
	      terminal: true,
	      priority: 400,
	      transclude: 'element',
	      compile: function compile(tElement, tAttrs, $transclude) {
	        return function (scope, $element, attrs) {
	          var previousEl,
	              currentEl,
	              currentScope,
	              latestLocals,
	              onloadExp = attrs.onload || '',
	              autoScrollExp = attrs.autoscroll,
	              renderer = getRenderer(attrs, scope),
	              inherited = $element.inheritedData('$uiView');
	
	          scope.$on('$stateChangeSuccess', function () {
	            updateView(false);
	          });
	
	          updateView(true);
	
	          function cleanupLastView() {
	            if (previousEl) {
	              previousEl.remove();
	              previousEl = null;
	            }
	
	            if (currentScope) {
	              currentScope.$destroy();
	              currentScope = null;
	            }
	
	            if (currentEl) {
	              var $uiViewData = currentEl.data('$uiViewAnim');
	              renderer.leave(currentEl, function () {
	                $uiViewData.$$animLeave.resolve();
	                previousEl = null;
	              });
	
	              previousEl = currentEl;
	              currentEl = null;
	            }
	          }
	
	          function updateView(firstTime) {
	            var newScope,
	                name = getUiViewName(scope, attrs, $element, $interpolate),
	                previousLocals = name && $state.$current && $state.$current.locals[name];
	
	            if (!firstTime && previousLocals === latestLocals) return; // nothing to do
	            newScope = scope.$new();
	            latestLocals = $state.$current.locals[name];
	
	            /**
	             * @ngdoc event
	             * @name ui.router.state.directive:ui-view#$viewContentLoading
	             * @eventOf ui.router.state.directive:ui-view
	             * @eventType emits on ui-view directive scope
	             * @description
	             *
	             * Fired once the view **begins loading**, *before* the DOM is rendered.
	             *
	             * @param {Object} event Event object.
	             * @param {string} viewName Name of the view.
	             */
	            newScope.$emit('$viewContentLoading', name);
	
	            var clone = $transclude(newScope, function (clone) {
	              var animEnter = $q.defer(),
	                  animLeave = $q.defer();
	              var viewAnimData = {
	                $animEnter: animEnter.promise,
	                $animLeave: animLeave.promise,
	                $$animLeave: animLeave
	              };
	
	              clone.data('$uiViewAnim', viewAnimData);
	              renderer.enter(clone, $element, function onUiViewEnter() {
	                animEnter.resolve();
	                if (currentScope) {
	                  currentScope.$emit('$viewContentAnimationEnded');
	                }
	
	                if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                  $uiViewScroll(clone);
	                }
	              });
	              cleanupLastView();
	            });
	
	            currentEl = clone;
	            currentScope = newScope;
	            /**
	             * @ngdoc event
	             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	             * @eventOf ui.router.state.directive:ui-view
	             * @eventType emits on ui-view directive scope
	             * @description
	             * Fired once the view is **loaded**, *after* the DOM is rendered.
	             *
	             * @param {Object} event Event object.
	             * @param {string} viewName Name of the view.
	             */
	            currentScope.$emit('$viewContentLoaded', name);
	            currentScope.$eval(onloadExp);
	          }
	        };
	      }
	    };
	
	    return directive;
	  }
	
	  $ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	  function $ViewDirectiveFill($compile, $controller, $state, $interpolate) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      compile: function compile(tElement) {
	        var initial = tElement.html();
	        if (tElement.empty) {
	          tElement.empty();
	        } else {
	          // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
	          tElement[0].innerHTML = null;
	        }
	
	        return function (scope, $element, attrs) {
	          var current = $state.$current,
	              name = getUiViewName(scope, attrs, $element, $interpolate),
	              locals = current && current.locals[name];
	
	          if (!locals) {
	            $element.html(initial);
	            $compile($element.contents())(scope);
	            return;
	          }
	
	          $element.data('$uiView', { name: name, state: locals.$$state });
	          $element.html(locals.$template ? locals.$template : initial);
	
	          var resolveData = angular.extend({}, locals);
	          scope[locals.$$resolveAs] = resolveData;
	
	          var link = $compile($element.contents());
	
	          if (locals.$$controller) {
	            locals.$scope = scope;
	            locals.$element = $element;
	            var controller = $controller(locals.$$controller, locals);
	            if (locals.$$controllerAs) {
	              scope[locals.$$controllerAs] = controller;
	              scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
	            }
	            if (isFunction(controller.$onInit)) controller.$onInit();
	            $element.data('$ngControllerController', controller);
	            $element.children().data('$ngControllerController', controller);
	          }
	
	          link(scope);
	        };
	      }
	    };
	  }
	
	  /**
	   * Shared ui-view code for both directives:
	   * Given scope, element, and its attributes, return the view's name
	   */
	  function getUiViewName(scope, attrs, element, $interpolate) {
	    var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	    var uiViewCreatedBy = element.inheritedData('$uiView');
	    return name.indexOf('@') >= 0 ? name : name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : '');
	  }
	
	  angular.module('ui.router.state').directive('uiView', $ViewDirective);
	  angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	  function parseStateRef(ref, current) {
	    var preparsed = ref.match(/^\s*({[^}]*})\s*$/),
	        parsed;
	    if (preparsed) ref = current + '(' + preparsed[1] + ')';
	    parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	    if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	    return { state: parsed[1], paramExpr: parsed[3] || null };
	  }
	
	  function stateContext(el) {
	    var stateData = el.parent().inheritedData('$uiView');
	
	    if (stateData && stateData.state && stateData.state.name) {
	      return stateData.state;
	    }
	  }
	
	  function getTypeInfo(el) {
	    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	    var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	    var isForm = el[0].nodeName === "FORM";
	
	    return {
	      attr: isForm ? "action" : isSvg ? 'xlink:href' : 'href',
	      isAnchor: el.prop("tagName").toUpperCase() === "A",
	      clickable: !isForm
	    };
	  }
	
	  function clickHook(el, $state, $timeout, type, current) {
	    return function (e) {
	      var button = e.which || e.button,
	          target = current();
	
	      if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	        // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	        var transition = $timeout(function () {
	          $state.go(target.state, target.params, target.options);
	        });
	        e.preventDefault();
	
	        // if the state has no URL, ignore one preventDefault from the <a> directive.
	        var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
	
	        e.preventDefault = function () {
	          if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	        };
	      }
	    };
	  }
	
	  function defaultOpts(el, $state) {
	    return { relative: stateContext(el) || $state.$current, inherit: true };
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-sref
	   *
	   * @requires ui.router.state.$state
	   * @requires $timeout
	   *
	   * @restrict A
	   *
	   * @description
	   * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	   * URL, the directive will automatically generate & update the `href` attribute via
	   * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	   * the link will trigger a state transition with optional parameters.
	   *
	   * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	   * handled natively by the browser.
	   *
	   * You can also use relative state paths within ui-sref, just like the relative
	   * paths passed to `$state.go()`. You just need to be aware that the path is relative
	   * to the state that the link lives in, in other words the state that loaded the
	   * template containing the link.
	   *
	   * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	   * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	   * and `reload`.
	   *
	   * @example
	   * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	   * following template:
	   * <pre>
	   * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	   *
	   * <ul>
	   *     <li ng-repeat="contact in contacts">
	   *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	   *     </li>
	   * </ul>
	   * </pre>
	   *
	   * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	   * <pre>
	   * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	   *
	   * <ul>
	   *     <li ng-repeat="contact in contacts">
	   *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	   *     </li>
	   *     <li ng-repeat="contact in contacts">
	   *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	   *     </li>
	   *     <li ng-repeat="contact in contacts">
	   *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	   *     </li>
	   * </ul>
	   *
	   * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	   * </pre>
	   *
	   * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	   * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	   */
	  $StateRefDirective.$inject = ['$state', '$timeout'];
	  function $StateRefDirective($state, $timeout) {
	    return {
	      restrict: 'A',
	      require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	      link: function link(scope, element, attrs, uiSrefActive) {
	        var ref = parseStateRef(attrs.uiSref, $state.current.name);
	        var def = { state: ref.state, href: null, params: null };
	        var type = getTypeInfo(element);
	        var active = uiSrefActive[1] || uiSrefActive[0];
	        var unlinkInfoFn = null;
	        var hookFn;
	
	        def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	        var update = function update(val) {
	          if (val) def.params = angular.copy(val);
	          def.href = $state.href(ref.state, def.params, def.options);
	
	          if (unlinkInfoFn) unlinkInfoFn();
	          if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
	          if (def.href !== null) attrs.$set(type.attr, def.href);
	        };
	
	        if (ref.paramExpr) {
	          scope.$watch(ref.paramExpr, function (val) {
	            if (val !== def.params) update(val);
	          }, true);
	          def.params = angular.copy(scope.$eval(ref.paramExpr));
	        }
	        update();
	
	        if (!type.clickable) return;
	        hookFn = clickHook(element, $state, $timeout, type, function () {
	          return def;
	        });
	        element[element.on ? 'on' : 'bind']("click", hookFn);
	        scope.$on('$destroy', function () {
	          element[element.off ? 'off' : 'unbind']("click", hookFn);
	        });
	      }
	    };
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-state
	   *
	   * @requires ui.router.state.uiSref
	   *
	   * @restrict A
	   *
	   * @description
	   * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	   * params and override options.
	   *
	   * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	   * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
	   * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	   */
	  $StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	  function $StateRefDynamicDirective($state, $timeout) {
	    return {
	      restrict: 'A',
	      require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	      link: function link(scope, element, attrs, uiSrefActive) {
	        var type = getTypeInfo(element);
	        var active = uiSrefActive[1] || uiSrefActive[0];
	        var group = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	        var watch = '[' + group.map(function (val) {
	          return val || 'null';
	        }).join(', ') + ']';
	        var def = { state: null, params: null, options: null, href: null };
	        var unlinkInfoFn = null;
	        var hookFn;
	
	        function runStateRefLink(group) {
	          def.state = group[0];def.params = group[1];def.options = group[2];
	          def.href = $state.href(def.state, def.params, def.options);
	
	          if (unlinkInfoFn) unlinkInfoFn();
	          if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
	          if (def.href) attrs.$set(type.attr, def.href);
	        }
	
	        scope.$watch(watch, runStateRefLink, true);
	        runStateRefLink(scope.$eval(watch));
	
	        if (!type.clickable) return;
	        hookFn = clickHook(element, $state, $timeout, type, function () {
	          return def;
	        });
	        element[element.on ? 'on' : 'bind']("click", hookFn);
	        scope.$on('$destroy', function () {
	          element[element.off ? 'off' : 'unbind']("click", hookFn);
	        });
	      }
	    };
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-sref-active
	   *
	   * @requires ui.router.state.$state
	   * @requires ui.router.state.$stateParams
	   * @requires $interpolate
	   *
	   * @restrict A
	   *
	   * @description
	   * A directive working alongside ui-sref to add classes to an element when the
	   * related ui-sref directive's state is active, and removing them when it is inactive.
	   * The primary use-case is to simplify the special appearance of navigation menus
	   * relying on `ui-sref`, by having the "active" state's menu button appear different,
	   * distinguishing it from the inactive menu items.
	   *
	   * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	   * ui-sref-active found at the same level or above the ui-sref will be used.
	   *
	   * Will activate when the ui-sref's target state or any child state is active. If you
	   * need to activate only when the ui-sref target state is active and *not* any of
	   * it's children, then you will use
	   * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	   *
	   * @example
	   * Given the following template:
	   * <pre>
	   * <ul>
	   *   <li ui-sref-active="active" class="item">
	   *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	   *   </li>
	   * </ul>
	   * </pre>
	   *
	   *
	   * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	   * the resulting HTML will appear as (note the 'active' class):
	   * <pre>
	   * <ul>
	   *   <li ui-sref-active="active" class="item active">
	   *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	   *   </li>
	   * </ul>
	   * </pre>
	   *
	   * The class name is interpolated **once** during the directives link time (any further changes to the
	   * interpolated value are ignored).
	   *
	   * Multiple classes may be specified in a space-separated format:
	   * <pre>
	   * <ul>
	   *   <li ui-sref-active='class1 class2 class3'>
	   *     <a ui-sref="app.user">link</a>
	   *   </li>
	   * </ul>
	   * </pre>
	   *
	   * It is also possible to pass ui-sref-active an expression that evaluates
	   * to an object hash, whose keys represent active class names and whose
	   * values represent the respective state names/globs.
	   * ui-sref-active will match if the current active state **includes** any of
	   * the specified state names/globs, even the abstract ones.
	   *
	   * @Example
	   * Given the following template, with "admin" being an abstract state:
	   * <pre>
	   * <div ui-sref-active="{'active': 'admin.*'}">
	   *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	   * </div>
	   * </pre>
	   *
	   * When the current state is "admin.roles" the "active" class will be applied
	   * to both the <div> and <a> elements. It is important to note that the state
	   * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-sref-active-eq
	   *
	   * @requires ui.router.state.$state
	   * @requires ui.router.state.$stateParams
	   * @requires $interpolate
	   *
	   * @restrict A
	   *
	   * @description
	   * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	   * when the exact target state used in the `ui-sref` is active; no child states.
	   *
	   */
	  $StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	  function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	    return {
	      restrict: "A",
	      controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	        var states = [],
	            activeClasses = {},
	            activeEqClass,
	            uiSrefActive;
	
	        // There probably isn't much point in $observing this
	        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	        // slight difference in logic routing
	        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	        try {
	          uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	        } catch (e) {
	          // Do nothing. uiSrefActive is not a valid expression.
	          // Fall back to using $interpolate below
	        }
	        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	        if (isObject(uiSrefActive)) {
	          forEach(uiSrefActive, function (stateOrName, activeClass) {
	            if (isString(stateOrName)) {
	              var ref = parseStateRef(stateOrName, $state.current.name);
	              addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	            }
	          });
	        }
	
	        // Allow uiSref to communicate with uiSrefActive[Equals]
	        this.$$addStateInfo = function (newState, newParams) {
	          // we already got an explicit state provided by ui-sref-active, so we
	          // shadow the one that comes from ui-sref
	          if (isObject(uiSrefActive) && states.length > 0) {
	            return;
	          }
	          var deregister = addState(newState, newParams, uiSrefActive);
	          update();
	          return deregister;
	        };
	
	        $scope.$on('$stateChangeSuccess', update);
	
	        function addState(stateName, stateParams, activeClass) {
	          var state = $state.get(stateName, stateContext($element));
	          var stateHash = createStateHash(stateName, stateParams);
	
	          var stateInfo = {
	            state: state || { name: stateName },
	            params: stateParams,
	            hash: stateHash
	          };
	
	          states.push(stateInfo);
	          activeClasses[stateHash] = activeClass;
	
	          return function removeState() {
	            var idx = states.indexOf(stateInfo);
	            if (idx !== -1) states.splice(idx, 1);
	          };
	        }
	
	        /**
	         * @param {string} state
	         * @param {Object|string} [params]
	         * @return {string}
	         */
	        function createStateHash(state, params) {
	          if (!isString(state)) {
	            throw new Error('state should be a string');
	          }
	          if (isObject(params)) {
	            return state + toJson(params);
	          }
	          params = $scope.$eval(params);
	          if (isObject(params)) {
	            return state + toJson(params);
	          }
	          return state;
	        }
	
	        // Update route state
	        function update() {
	          for (var i = 0; i < states.length; i++) {
	            if (anyMatch(states[i].state, states[i].params)) {
	              addClass($element, activeClasses[states[i].hash]);
	            } else {
	              removeClass($element, activeClasses[states[i].hash]);
	            }
	
	            if (exactMatch(states[i].state, states[i].params)) {
	              addClass($element, activeEqClass);
	            } else {
	              removeClass($element, activeEqClass);
	            }
	          }
	        }
	
	        function addClass(el, className) {
	          $timeout(function () {
	            el.addClass(className);
	          });
	        }
	        function removeClass(el, className) {
	          el.removeClass(className);
	        }
	        function anyMatch(state, params) {
	          return $state.includes(state.name, params);
	        }
	        function exactMatch(state, params) {
	          return $state.is(state.name, params);
	        }
	
	        update();
	      }]
	    };
	  }
	
	  angular.module('ui.router.state').directive('uiSref', $StateRefDirective).directive('uiSrefActive', $StateRefActiveDirective).directive('uiSrefActiveEq', $StateRefActiveDirective).directive('uiState', $StateRefDynamicDirective);
	
	  /**
	   * @ngdoc filter
	   * @name ui.router.state.filter:isState
	   *
	   * @requires ui.router.state.$state
	   *
	   * @description
	   * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	   */
	  $IsStateFilter.$inject = ['$state'];
	  function $IsStateFilter($state) {
	    var isFilter = function isFilter(state, params) {
	      return $state.is(state, params);
	    };
	    isFilter.$stateful = true;
	    return isFilter;
	  }
	
	  /**
	   * @ngdoc filter
	   * @name ui.router.state.filter:includedByState
	   *
	   * @requires ui.router.state.$state
	   *
	   * @description
	   * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	   */
	  $IncludedByStateFilter.$inject = ['$state'];
	  function $IncludedByStateFilter($state) {
	    var includesFilter = function includesFilter(state, params, options) {
	      return $state.includes(state, params, options);
	    };
	    includesFilter.$stateful = true;
	    return includesFilter;
	  }
	
	  angular.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict';
	
	var base64 = __webpack_require__(228);
	var ieee754 = __webpack_require__(238);
	var isArray = __webpack_require__(240);
	
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	Buffer.poolSize = 8192; // not used by this implementation
	
	var rootParent = {};
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
	 *     on objects.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
	
	function typedArraySupport() {
	  function Bar() {}
	  try {
	    var arr = new Uint8Array(1);
	    arr.foo = function () {
	      return 42;
	    };
	    arr.constructor = Bar;
	    return arr.foo() === 42 && // typed array instances can be augmented
	    arr.constructor === Bar && // constructor can be set
	    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
	  } catch (e) {
	    return false;
	  }
	}
	
	function kMaxLength() {
	  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
	}
	
	/**
	 * Class: Buffer
	 * =============
	 *
	 * The Buffer constructor returns instances of `Uint8Array` that are augmented
	 * with function properties for all the node `Buffer` API functions. We use
	 * `Uint8Array` so that square bracket notation works as expected -- it returns
	 * a single octet.
	 *
	 * By augmenting the instances, we can avoid modifying the `Uint8Array`
	 * prototype.
	 */
	function Buffer(arg) {
	  if (!(this instanceof Buffer)) {
	    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
	    if (arguments.length > 1) return new Buffer(arg, arguments[1]);
	    return new Buffer(arg);
	  }
	
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    this.length = 0;
	    this.parent = undefined;
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    return fromNumber(this, arg);
	  }
	
	  // Slightly less common case.
	  if (typeof arg === 'string') {
	    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8');
	  }
	
	  // Unusual.
	  return fromObject(this, arg);
	}
	
	function fromNumber(that, length) {
	  that = allocate(that, length < 0 ? 0 : checked(length) | 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < length; i++) {
	      that[i] = 0;
	    }
	  }
	  return that;
	}
	
	function fromString(that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
	
	  // Assumption: byteLength() return value is always < kMaxLength.
	  var length = byteLength(string, encoding) | 0;
	  that = allocate(that, length);
	
	  that.write(string, encoding);
	  return that;
	}
	
	function fromObject(that, object) {
	  if (Buffer.isBuffer(object)) return fromBuffer(that, object);
	
	  if (isArray(object)) return fromArray(that, object);
	
	  if (object == null) {
	    throw new TypeError('must start with number, buffer, array or string');
	  }
	
	  if (typeof ArrayBuffer !== 'undefined') {
	    if (object.buffer instanceof ArrayBuffer) {
	      return fromTypedArray(that, object);
	    }
	    if (object instanceof ArrayBuffer) {
	      return fromArrayBuffer(that, object);
	    }
	  }
	
	  if (object.length) return fromArrayLike(that, object);
	
	  return fromJsonObject(that, object);
	}
	
	function fromBuffer(that, buffer) {
	  var length = checked(buffer.length) | 0;
	  that = allocate(that, length);
	  buffer.copy(that, 0, 0, length);
	  return that;
	}
	
	function fromArray(that, array) {
	  var length = checked(array.length) | 0;
	  that = allocate(that, length);
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	// Duplicate of fromArray() to keep fromArray() monomorphic.
	function fromTypedArray(that, array) {
	  var length = checked(array.length) | 0;
	  that = allocate(that, length);
	  // Truncating the elements is probably not what people expect from typed
	  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
	  // of the old Buffer constructor.
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	function fromArrayBuffer(that, array) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    array.byteLength;
	    that = Buffer._augment(new Uint8Array(array));
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromTypedArray(that, new Uint8Array(array));
	  }
	  return that;
	}
	
	function fromArrayLike(that, array) {
	  var length = checked(array.length) | 0;
	  that = allocate(that, length);
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
	// Returns a zero-length buffer for inputs that don't conform to the spec.
	function fromJsonObject(that, object) {
	  var array;
	  var length = 0;
	
	  if (object.type === 'Buffer' && isArray(object.data)) {
	    array = object.data;
	    length = checked(array.length) | 0;
	  }
	  that = allocate(that, length);
	
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype;
	  Buffer.__proto__ = Uint8Array;
	} else {
	  // pre-set for values that may exist in the future
	  Buffer.prototype.length = undefined;
	  Buffer.prototype.parent = undefined;
	}
	
	function allocate(that, length) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = Buffer._augment(new Uint8Array(length));
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that.length = length;
	    that._isBuffer = true;
	  }
	
	  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1;
	  if (fromPool) that.parent = rootParent;
	
	  return that;
	}
	
	function checked(length) {
	  // Note: cannot use `length < kMaxLength` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
	  }
	  return length | 0;
	}
	
	function SlowBuffer(subject, encoding) {
	  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding);
	
	  var buf = new Buffer(subject, encoding);
	  delete buf.parent;
	  return buf;
	}
	
	Buffer.isBuffer = function isBuffer(b) {
	  return !!(b != null && b._isBuffer);
	};
	
	Buffer.compare = function compare(a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers');
	  }
	
	  if (a === b) return 0;
	
	  var x = a.length;
	  var y = b.length;
	
	  var i = 0;
	  var len = Math.min(x, y);
	  while (i < len) {
	    if (a[i] !== b[i]) break;
	
	    ++i;
	  }
	
	  if (i !== len) {
	    x = a[i];
	    y = b[i];
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	Buffer.isEncoding = function isEncoding(encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'binary':
	    case 'base64':
	    case 'raw':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true;
	    default:
	      return false;
	  }
	};
	
	Buffer.concat = function concat(list, length) {
	  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.');
	
	  if (list.length === 0) {
	    return new Buffer(0);
	  }
	
	  var i;
	  if (length === undefined) {
	    length = 0;
	    for (i = 0; i < list.length; i++) {
	      length += list[i].length;
	    }
	  }
	
	  var buf = new Buffer(length);
	  var pos = 0;
	  for (i = 0; i < list.length; i++) {
	    var item = list[i];
	    item.copy(buf, pos);
	    pos += item.length;
	  }
	  return buf;
	};
	
	function byteLength(string, encoding) {
	  if (typeof string !== 'string') string = '' + string;
	
	  var len = string.length;
	  if (len === 0) return 0;
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'binary':
	      // Deprecated
	      case 'raw':
	      case 'raws':
	        return len;
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length;
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2;
	      case 'hex':
	        return len >>> 1;
	      case 'base64':
	        return base64ToBytes(string).length;
	      default:
	        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	Buffer.byteLength = byteLength;
	
	function slowToString(encoding, start, end) {
	  var loweredCase = false;
	
	  start = start | 0;
	  end = end === undefined || end === Infinity ? this.length : end | 0;
	
	  if (!encoding) encoding = 'utf8';
	  if (start < 0) start = 0;
	  if (end > this.length) end = this.length;
	  if (end <= start) return '';
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end);
	
	      case 'ascii':
	        return asciiSlice(this, start, end);
	
	      case 'binary':
	        return binarySlice(this, start, end);
	
	      case 'base64':
	        return base64Slice(this, start, end);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = (encoding + '').toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	
	Buffer.prototype.toString = function toString() {
	  var length = this.length | 0;
	  if (length === 0) return '';
	  if (arguments.length === 0) return utf8Slice(this, 0, length);
	  return slowToString.apply(this, arguments);
	};
	
	Buffer.prototype.equals = function equals(b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
	  if (this === b) return true;
	  return Buffer.compare(this, b) === 0;
	};
	
	Buffer.prototype.inspect = function inspect() {
	  var str = '';
	  var max = exports.INSPECT_MAX_BYTES;
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	    if (this.length > max) str += ' ... ';
	  }
	  return '<Buffer ' + str + '>';
	};
	
	Buffer.prototype.compare = function compare(b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
	  if (this === b) return 0;
	  return Buffer.compare(this, b);
	};
	
	Buffer.prototype.indexOf = function indexOf(val, byteOffset) {
	  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;else if (byteOffset < -0x80000000) byteOffset = -0x80000000;
	  byteOffset >>= 0;
	
	  if (this.length === 0) return -1;
	  if (byteOffset >= this.length) return -1;
	
	  // Negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0);
	
	  if (typeof val === 'string') {
	    if (val.length === 0) return -1; // special case: looking for empty string always fails
	    return String.prototype.indexOf.call(this, val, byteOffset);
	  }
	  if (Buffer.isBuffer(val)) {
	    return arrayIndexOf(this, val, byteOffset);
	  }
	  if (typeof val === 'number') {
	    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
	      return Uint8Array.prototype.indexOf.call(this, val, byteOffset);
	    }
	    return arrayIndexOf(this, [val], byteOffset);
	  }
	
	  function arrayIndexOf(arr, val, byteOffset) {
	    var foundIndex = -1;
	    for (var i = 0; byteOffset + i < arr.length; i++) {
	      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
	        if (foundIndex === -1) foundIndex = i;
	        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex;
	      } else {
	        foundIndex = -1;
	      }
	    }
	    return -1;
	  }
	
	  throw new TypeError('val must be string, number or Buffer');
	};
	
	// `get` is deprecated
	Buffer.prototype.get = function get(offset) {
	  console.log('.get() is deprecated. Access using array indexes instead.');
	  return this.readUInt8(offset);
	};
	
	// `set` is deprecated
	Buffer.prototype.set = function set(v, offset) {
	  console.log('.set() is deprecated. Access using array indexes instead.');
	  return this.writeUInt8(v, offset);
	};
	
	function hexWrite(buf, string, offset, length) {
	  offset = Number(offset) || 0;
	  var remaining = buf.length - offset;
	  if (!length) {
	    length = remaining;
	  } else {
	    length = Number(length);
	    if (length > remaining) {
	      length = remaining;
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length;
	  if (strLen % 2 !== 0) throw new Error('Invalid hex string');
	
	  if (length > strLen / 2) {
	    length = strLen / 2;
	  }
	  for (var i = 0; i < length; i++) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16);
	    if (isNaN(parsed)) throw new Error('Invalid hex string');
	    buf[offset + i] = parsed;
	  }
	  return i;
	}
	
	function utf8Write(buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	function asciiWrite(buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	
	function binaryWrite(buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length);
	}
	
	function base64Write(buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	
	function ucs2Write(buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	Buffer.prototype.write = function write(string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8';
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset;
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0;
	    if (isFinite(length)) {
	      length = length | 0;
	      if (encoding === undefined) encoding = 'utf8';
	    } else {
	      encoding = length;
	      length = undefined;
	    }
	    // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    var swap = encoding;
	    encoding = offset;
	    offset = length | 0;
	    length = swap;
	  }
	
	  var remaining = this.length - offset;
	  if (length === undefined || length > remaining) length = remaining;
	
	  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	    throw new RangeError('attempt to write outside buffer bounds');
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length);
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length);
	
	      case 'binary':
	        return binaryWrite(this, string, offset, length);
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	};
	
	Buffer.prototype.toJSON = function toJSON() {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  };
	};
	
	function base64Slice(buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf);
	  } else {
	    return base64.fromByteArray(buf.slice(start, end));
	  }
	}
	
	function utf8Slice(buf, start, end) {
	  end = Math.min(buf.length, end);
	  var res = [];
	
	  var i = start;
	  while (i < end) {
	    var firstByte = buf[i];
	    var codePoint = null;
	    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint;
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte;
	          }
	          break;
	        case 2:
	          secondByte = buf[i + 1];
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 3:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 4:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          fourthByte = buf[i + 3];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint;
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD;
	      bytesPerSequence = 1;
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000;
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	      codePoint = 0xDC00 | codePoint & 0x3FF;
	    }
	
	    res.push(codePoint);
	    i += bytesPerSequence;
	  }
	
	  return decodeCodePointsArray(res);
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000;
	
	function decodeCodePointsArray(codePoints) {
	  var len = codePoints.length;
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = '';
	  var i = 0;
	  while (i < len) {
	    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	  }
	  return res;
	}
	
	function asciiSlice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i] & 0x7F);
	  }
	  return ret;
	}
	
	function binarySlice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i]);
	  }
	  return ret;
	}
	
	function hexSlice(buf, start, end) {
	  var len = buf.length;
	
	  if (!start || start < 0) start = 0;
	  if (!end || end < 0 || end > len) end = len;
	
	  var out = '';
	  for (var i = start; i < end; i++) {
	    out += toHex(buf[i]);
	  }
	  return out;
	}
	
	function utf16leSlice(buf, start, end) {
	  var bytes = buf.slice(start, end);
	  var res = '';
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	  }
	  return res;
	}
	
	Buffer.prototype.slice = function slice(start, end) {
	  var len = this.length;
	  start = ~~start;
	  end = end === undefined ? len : ~~end;
	
	  if (start < 0) {
	    start += len;
	    if (start < 0) start = 0;
	  } else if (start > len) {
	    start = len;
	  }
	
	  if (end < 0) {
	    end += len;
	    if (end < 0) end = 0;
	  } else if (end > len) {
	    end = len;
	  }
	
	  if (end < start) end = start;
	
	  var newBuf;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = Buffer._augment(this.subarray(start, end));
	  } else {
	    var sliceLen = end - start;
	    newBuf = new Buffer(sliceLen, undefined);
	    for (var i = 0; i < sliceLen; i++) {
	      newBuf[i] = this[i + start];
	    }
	  }
	
	  if (newBuf.length) newBuf.parent = this.parent || this;
	
	  return newBuf;
	};
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset(offset, ext, length) {
	  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length);
	  }
	
	  var val = this[offset + --byteLength];
	  var mul = 1;
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  return this[offset];
	};
	
	Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] | this[offset + 1] << 8;
	};
	
	Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] << 8 | this[offset + 1];
	};
	
	Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
	};
	
	Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var i = byteLength;
	  var mul = 1;
	  var val = this[offset + --i];
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  if (!(this[offset] & 0x80)) return this[offset];
	  return (0xff - this[offset] + 1) * -1;
	};
	
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset] | this[offset + 1] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset + 1] | this[offset] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, true, 23, 4);
	};
	
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, false, 23, 4);
	};
	
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, true, 52, 8);
	};
	
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, false, 52, 8);
	};
	
	function checkInt(buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance');
	  if (value > max || value < min) throw new RangeError('value is out of bounds');
	  if (offset + ext > buf.length) throw new RangeError('index out of range');
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0);
	
	  var mul = 1;
	  var i = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0);
	
	  var i = byteLength - 1;
	  var mul = 1;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	function objectWriteUInt16(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	function objectWriteUInt32(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = value >>> 24;
	    this[offset + 2] = value >>> 16;
	    this[offset + 1] = value >>> 8;
	    this[offset] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = 0;
	  var mul = 1;
	  var sub = value < 0 ? 1 : 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  var sub = value < 0 ? 1 : 0;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  if (value < 0) value = 0xff + value + 1;
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	    this[offset + 2] = value >>> 16;
	    this[offset + 3] = value >>> 24;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (value < 0) value = 0xffffffff + value + 1;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	function checkIEEE754(buf, value, offset, ext, max, min) {
	  if (value > max || value < min) throw new RangeError('value is out of bounds');
	  if (offset + ext > buf.length) throw new RangeError('index out of range');
	  if (offset < 0) throw new RangeError('index out of range');
	}
	
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4);
	  return offset + 4;
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert);
	};
	
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8);
	  return offset + 8;
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert);
	};
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (targetStart >= target.length) targetStart = target.length;
	  if (!targetStart) targetStart = 0;
	  if (end > 0 && end < start) end = start;
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0;
	  if (target.length === 0 || this.length === 0) return 0;
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds');
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
	  if (end < 0) throw new RangeError('sourceEnd out of bounds');
	
	  // Are we oob?
	  if (end > this.length) end = this.length;
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start;
	  }
	
	  var len = end - start;
	  var i;
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    target._set(this.subarray(start, start + len), targetStart);
	  }
	
	  return len;
	};
	
	// fill(value, start=0, end=buffer.length)
	Buffer.prototype.fill = function fill(value, start, end) {
	  if (!value) value = 0;
	  if (!start) start = 0;
	  if (!end) end = this.length;
	
	  if (end < start) throw new RangeError('end < start');
	
	  // Fill 0 bytes; we're done
	  if (end === start) return;
	  if (this.length === 0) return;
	
	  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds');
	  if (end < 0 || end > this.length) throw new RangeError('end out of bounds');
	
	  var i;
	  if (typeof value === 'number') {
	    for (i = start; i < end; i++) {
	      this[i] = value;
	    }
	  } else {
	    var bytes = utf8ToBytes(value.toString());
	    var len = bytes.length;
	    for (i = start; i < end; i++) {
	      this[i] = bytes[i % len];
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
	 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
	 */
	Buffer.prototype.toArrayBuffer = function toArrayBuffer() {
	  if (typeof Uint8Array !== 'undefined') {
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      return new Buffer(this).buffer;
	    } else {
	      var buf = new Uint8Array(this.length);
	      for (var i = 0, len = buf.length; i < len; i += 1) {
	        buf[i] = this[i];
	      }
	      return buf.buffer;
	    }
	  } else {
	    throw new TypeError('Buffer.toArrayBuffer not supported in this browser');
	  }
	};
	
	// HELPER FUNCTIONS
	// ================
	
	var BP = Buffer.prototype;
	
	/**
	 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
	 */
	Buffer._augment = function _augment(arr) {
	  arr.constructor = Buffer;
	  arr._isBuffer = true;
	
	  // save reference to original Uint8Array set method before overwriting
	  arr._set = arr.set;
	
	  // deprecated
	  arr.get = BP.get;
	  arr.set = BP.set;
	
	  arr.write = BP.write;
	  arr.toString = BP.toString;
	  arr.toLocaleString = BP.toString;
	  arr.toJSON = BP.toJSON;
	  arr.equals = BP.equals;
	  arr.compare = BP.compare;
	  arr.indexOf = BP.indexOf;
	  arr.copy = BP.copy;
	  arr.slice = BP.slice;
	  arr.readUIntLE = BP.readUIntLE;
	  arr.readUIntBE = BP.readUIntBE;
	  arr.readUInt8 = BP.readUInt8;
	  arr.readUInt16LE = BP.readUInt16LE;
	  arr.readUInt16BE = BP.readUInt16BE;
	  arr.readUInt32LE = BP.readUInt32LE;
	  arr.readUInt32BE = BP.readUInt32BE;
	  arr.readIntLE = BP.readIntLE;
	  arr.readIntBE = BP.readIntBE;
	  arr.readInt8 = BP.readInt8;
	  arr.readInt16LE = BP.readInt16LE;
	  arr.readInt16BE = BP.readInt16BE;
	  arr.readInt32LE = BP.readInt32LE;
	  arr.readInt32BE = BP.readInt32BE;
	  arr.readFloatLE = BP.readFloatLE;
	  arr.readFloatBE = BP.readFloatBE;
	  arr.readDoubleLE = BP.readDoubleLE;
	  arr.readDoubleBE = BP.readDoubleBE;
	  arr.writeUInt8 = BP.writeUInt8;
	  arr.writeUIntLE = BP.writeUIntLE;
	  arr.writeUIntBE = BP.writeUIntBE;
	  arr.writeUInt16LE = BP.writeUInt16LE;
	  arr.writeUInt16BE = BP.writeUInt16BE;
	  arr.writeUInt32LE = BP.writeUInt32LE;
	  arr.writeUInt32BE = BP.writeUInt32BE;
	  arr.writeIntLE = BP.writeIntLE;
	  arr.writeIntBE = BP.writeIntBE;
	  arr.writeInt8 = BP.writeInt8;
	  arr.writeInt16LE = BP.writeInt16LE;
	  arr.writeInt16BE = BP.writeInt16BE;
	  arr.writeInt32LE = BP.writeInt32LE;
	  arr.writeInt32BE = BP.writeInt32BE;
	  arr.writeFloatLE = BP.writeFloatLE;
	  arr.writeFloatBE = BP.writeFloatBE;
	  arr.writeDoubleLE = BP.writeDoubleLE;
	  arr.writeDoubleBE = BP.writeDoubleBE;
	  arr.fill = BP.fill;
	  arr.inspect = BP.inspect;
	  arr.toArrayBuffer = BP.toArrayBuffer;
	
	  return arr;
	};
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
	
	function base64clean(str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return '';
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '=';
	  }
	  return str;
	}
	
	function stringtrim(str) {
	  if (str.trim) return str.trim();
	  return str.replace(/^\s+|\s+$/g, '');
	}
	
	function toHex(n) {
	  if (n < 16) return '0' + n.toString(16);
	  return n.toString(16);
	}
	
	function utf8ToBytes(string, units) {
	  units = units || Infinity;
	  var codePoint;
	  var length = string.length;
	  var leadSurrogate = null;
	  var bytes = [];
	
	  for (var i = 0; i < length; i++) {
	    codePoint = string.charCodeAt(i);
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        }
	
	        // valid lead
	        leadSurrogate = codePoint;
	
	        continue;
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	        leadSurrogate = codePoint;
	        continue;
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	    }
	
	    leadSurrogate = null;
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break;
	      bytes.push(codePoint);
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break;
	      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break;
	      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break;
	      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else {
	      throw new Error('Invalid code point');
	    }
	  }
	
	  return bytes;
	}
	
	function asciiToBytes(str) {
	  var byteArray = [];
	  for (var i = 0; i < str.length; i++) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF);
	  }
	  return byteArray;
	}
	
	function utf16leToBytes(str, units) {
	  var c, hi, lo;
	  var byteArray = [];
	  for (var i = 0; i < str.length; i++) {
	    if ((units -= 2) < 0) break;
	
	    c = str.charCodeAt(i);
	    hi = c >> 8;
	    lo = c % 256;
	    byteArray.push(lo);
	    byteArray.push(hi);
	  }
	
	  return byteArray;
	}
	
	function base64ToBytes(str) {
	  return base64.toByteArray(base64clean(str));
	}
	
	function blitBuffer(src, dst, offset, length) {
	  for (var i = 0; i < length; i++) {
	    if (i + offset >= dst.length || i >= src.length) break;
	    dst[i + offset] = src[i];
	  }
	  return i;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20).Buffer, (function() { return this; }())))

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : afrikaans (af)
	//! author : Werner Mollentze : https://github.com/wernerm
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function isPM(input) {
	            return (/^nm$/i.test(input)
	            );
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: '\'n paar sekondes',
	            m: '\'n minuut',
	            mm: '%d minute',
	            h: '\'n uur',
	            hh: '%d ure',
	            d: '\'n dag',
	            dd: '%d dae',
	            M: '\'n maand',
	            MM: '%d maande',
	            y: '\'n jaar',
	            yy: '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4 // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Moroccan Arabic (ar-ma)
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	});

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Arabic Saudi Arabia (ar-sa)
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    },
	        numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM: function isPM(input) {
	            return 'م' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	});

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale  : Tunisian Arabic (ar-tn)
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	});

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! Locale: Arabic (ar)
	//! Author: Abdel Said: https://github.com/abdelsaid
	//! Changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    },
	        numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	        pluralForm = function pluralForm(n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    },
	        plurals = {
	        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    },
	        pluralize = function pluralize(u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    },
	        months = ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM: function isPM(input) {
	            return 'م' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y')
	        },
	        preparse: function preparse(string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	});

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : azerbaijani (az)
	//! author : topchiyev : https://github.com/topchiyev
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'birneçə saniyyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function isPM(input) {
	            return (/^(gündüz|axşam)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	});

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : belarusian (be)
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
	            'accusative': 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            'accusative': 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_')
	        },
	            nounCase = /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/.test(format) ? 'accusative' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var be = moment.defineLocale('be', {
	        months: monthsCaseReplace,
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function nextWeek() {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function isPM(input) {
	            return (/^(дня|вечара)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	});

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : bulgarian (bg)
	//! author : Krasen Borisov : https://github.com/kraz
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дни',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function ordinal(number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	});

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bengali (bn)
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	        numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort: 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রুবার_শনিবার'.split('_'),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্রু_শনি'.split('_'),
	        weekdaysMin: 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কএক সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকেল|রাত/,
	        isPM: function isPM(input) {
	            return (/^(দুপুর|বিকেল|রাত)$/.test(input)
	            );
	        },
	        //Bengali is a vast language its spoken
	        //in different forms in various parts of the world.
	        //I have just generalized with most common one used
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকেল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	});

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : tibetan (bo)
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	        numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        isPM: function isPM(input) {
	            return (/^(ཉིན་གུང|དགོང་དག|མཚན་མོ)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	});

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : breton (br)
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h[e]mm A',
	            LTS: 'h[e]mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL: 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warc\'hoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Dec\'h da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s \'zo',
	            s: 'un nebeud segondennoù',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function ordinal(number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	});

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : bosnian (bs)
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	});

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : catalan (ca)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ca = moment.defineLocale('ca', {
	        months: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort: 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'LT:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'fa %s',
	            s: 'uns segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function ordinal(number, period) {
	            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	});

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : czech (cs)
	//! author : petrbela : https://github.com/petrbela
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'm':
	                // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm':
	                // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':
	                // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh':
	                // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':
	                // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd':
	                // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':
	                // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM':
	                // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':
	                // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy':
	                // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParse: function (months, monthsShort) {
	            var i,
	                _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort),
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	});

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : chuvash (cv)
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Welsh (cy)
	//! author : Robert Allen
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function ordinal(number) {
	            var b = number,
	                output = '',
	                lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	            'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	});

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : danish (da)
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[I dag kl.] LT',
	            nextDay: '[I morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[I går kl.] LT',
	            lastWeek: '[sidste] dddd [kl] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	});

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : austrian german (de-at)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	});

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : german (de)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	});

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : modern greek (el)
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months: function months(momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function isPM(input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        calendar: function calendar(key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (typeof output === 'function') {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	});

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : australian english (en-au)
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var en_au = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	});

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : canadian english (en-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM, YYYY',
	            LLL: 'D MMMM, YYYY h:mm A',
	            LLLL: 'dddd, D MMMM, YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	});

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	});

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : esperanto (eo)
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays: 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort: 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D[-an de] MMMM, YYYY',
	            LLL: 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function isPM(input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd [je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasinta] dddd [je] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'je %s',
	            past: 'antaŭ %s',
	            s: 'sekundoj',
	            m: 'minuto',
	            mm: '%d minutoj',
	            h: 'horo',
	            hh: '%d horoj',
	            d: 'tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'monato',
	            MM: '%d monatoj',
	            y: 'jaro',
	            yy: '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	});

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : spanish (es)
	//! author : Julio Napurí : https://github.com/julionc
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortDot = 'Ene._Feb._Mar._Abr._May._Jun._Jul._Ago._Sep._Oct._Nov._Dic.'.split('_'),
	        _monthsShort = 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (/-MMM-/.test(format)) {
	                return _monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
	        weekdaysShort: 'Dom._Lun._Mar._Mié._Jue._Vie._Sáb.'.split('_'),
	        weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	});

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : estonian (et)
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm': ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h': ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd': ['ühe päeva', 'üks päev'],
	            'M': ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y': ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	});

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : euskara (eu)
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	});

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Persian (fa)
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    },
	        numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
	        weekdaysShort: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function isPM(input) {
	            return (/بعد از ظهر/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چندین ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	});

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : finnish (fi)
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	});

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : faroese (fo)
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            m: 'ein minutt',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaði',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	});

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : canadian french (fr-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	});

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	});

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : frisian (fy)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	});

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : galician (gl)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var gl = moment.defineLocale('gl', {
	        months: 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort: 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        weekdays: 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort: 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin: 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	});

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Hebrew (he)
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function hh(number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function dd(number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function MM(number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function yy(number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        }
	    });
	
	    return he;
	});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : hindi (hi)
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	        numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	});

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : hrvatski (hr)
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_'),
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	});

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : hungarian (hu)
	//! author : Adam Brunner : https://github.com/adambrunner
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function isPM(input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function nextWeek() {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function lastWeek() {
	                return week.call(this, false);
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	});

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Armenian (hy-am)
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_'),
	            'accusative': 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function monthsShortCaseReplace(m, format) {
	        var monthsShort = 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_');
	        return monthsShort[m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_');
	        return weekdays[m.day()];
	    }
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months: monthsCaseReplace,
	        monthsShort: monthsShortCaseReplace,
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function nextWeek() {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function isPM(input) {
	            return (/^(ցերեկվա|երեկոյան)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	});

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bahasa Indonesia (id)
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	});

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : icelandic (is)
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	});

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : italian (it)
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort: 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin: 'D_L_Ma_Me_G_V_S'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: 'un\'ora',
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	});

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : japanese (ja)
	//! author : LI Long : https://github.com/baryon
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ja = moment.defineLocale('ja', {
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'Ah時m分',
	            LTS: 'Ah時m分s秒',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah時m分',
	            LLLL: 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function isPM(input) {
	            return input === '午後';
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: '[来週]dddd LT',
	            lastDay: '[昨日] LT',
	            lastWeek: '[前週]dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年'
	        }
	    });
	
	    return ja;
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Boso Jowo (jv)
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Georgian (ka)
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            'accusative': 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	            nounCase = /D[oD] *MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            'accusative': 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_')
	        },
	            nounCase = /(წინა|შემდეგ)/.test(format) ? 'accusative' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ka = moment.defineLocale('ka', {
	        months: monthsCaseReplace,
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(s) {
	                return (/(წამი|წუთი|საათი|წელი)/.test(s) ? s.replace(/ი$/, 'ში') : s + 'ში'
	                );
	            },
	            past: function past(s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s: 'რამდენიმე წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7
	        }
	    });
	
	    return ka;
	});

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : khmer (km)
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនៈ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : korean (ko)
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h시 m분',
	            LTS: 'A h시 m분 s초',
	            L: 'YYYY.MM.DD',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h시 m분',
	            LLLL: 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇초',
	            ss: '%d초',
	            m: '일분',
	            mm: '%d분',
	            h: '한시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한달',
	            MM: '%d달',
	            y: '일년',
	            yy: '%d년'
	        },
	        ordinalParse: /\d{1,2}일/,
	        ordinal: '%d일',
	        meridiemParse: /오전|오후/,
	        isPM: function isPM(token) {
	            return token === '오후';
	        },
	        meridiem: function meridiem(hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	});

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Luxembourgish (lb)
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function lastWeek() {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	});

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Lithuanian (lt)
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var units = {
	        'm': 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h': 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd': 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M': 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y': 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    },
	        weekDays = 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_');
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            'accusative': 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || number > 10 && number < 20;
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    function relativeWeekDay(moment, format) {
	        var nominative = format.indexOf('dddd HH:mm') === -1,
	            weekDay = weekDays[moment.day()];
	        return nominative ? weekDay : weekDay.substring(0, weekDay.length - 2) + 'į';
	    }
	
	    var lt = moment.defineLocale('lt', {
	        months: monthsCaseReplace,
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: relativeWeekDay,
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal: function ordinal(number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	});

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : latvian (lv)
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	});

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Montenegrin (me)
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sri.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	});

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : macedonian (mk)
	//! author : Borislav Mickov : https://github.com/B0k0
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: 'dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Во изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Во изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'после %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            M: 'месец',
	            MM: '%d месеци',
	            y: 'година',
	            yy: '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function ordinal(number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	});

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : malayalam (ml)
	//! author : Floyd Pink : https://github.com/floydpink
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        isPM: function isPM(input) {
	            return (/^(ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	});

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Marathi (mr)
	//! author : Harshad Kale : https://github.com/kalehv
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	        numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s नंतर',
	            past: '%s पूर्वी',
	            s: 'सेकंद',
	            m: 'एक मिनिट',
	            mm: '%d मिनिटे',
	            h: 'एक तास',
	            hh: '%d तास',
	            d: 'एक दिवस',
	            dd: '%d दिवस',
	            M: 'एक महिना',
	            MM: '%d महिने',
	            y: 'एक वर्ष',
	            yy: '%d वर्षे'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	});

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	});

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	});

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Burmese (my)
	//! author : Squar team, mysquar.com
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    },
	        numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	});

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : norwegian bokmål (nb)
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tirs_ons_tors_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'H.mm',
	            LTS: 'H.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H.mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] H.mm'
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'for %s siden',
	            s: 'noen sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	});

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : nepali/nepalese
	//! author : suvash : https://github.com/suvash
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	        numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आइ._सो._मङ्_बु._बि._शु._श.'.split('_'),
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राती|बिहान|दिउँसो|बेलुका|साँझ|राती/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 3 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'बेलुका' || meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राती';
	            } else if (hour < 10) {
	                return 'बिहान';
	            } else if (hour < 15) {
	                return 'दिउँसो';
	            } else if (hour < 18) {
	                return 'बेलुका';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राती';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोली] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडी',
	            s: 'केही समय',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	});

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : dutch (nl)
	//! author : Joris Röling : https://github.com/jjupiter
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	});

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : norwegian nynorsk (nn)
	//! author : https://github.com/mechuwind
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'for %s sidan',
	            s: 'nokre sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	});

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : polish (pl)
	//! author : Rafal Hirsz : https://github.com/evoL
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function months(momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin: 'N_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	});

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : brazilian portuguese (pt-br)
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function lastWeek() {
	                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: '%s atrás',
	            s: 'poucos segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº'
	    });
	
	    return pt_br;
	});

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : portuguese (pt)
	//! author : Jefferson : https://github.com/jalex79
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var pt = moment.defineLocale('pt', {
	        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function lastWeek() {
	                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	});

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : romanian (ro)
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	            separator = ' ';
	        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort: 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	});

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : russian (ru)
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	            'accusative': 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function monthsShortCaseReplace(m, format) {
	        var monthsShort = {
	            'nominative': 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	            'accusative': 'янв_фев_мар_апр_мая_июня_июля_авг_сен_окт_ноя_дек'.split('_')
	        },
	            nounCase = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return monthsShort[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            'accusative': 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_')
	        },
	            nounCase = /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/.test(format) ? 'accusative' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ru = moment.defineLocale('ru', {
	        months: monthsCaseReplace,
	        monthsShort: monthsShortCaseReplace,
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[й|я]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i],
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar: {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function nextWeek() {
	                return this.day() === 2 ? '[Во] dddd [в] LT' : '[В] dddd [в] LT';
	            },
	            lastWeek: function lastWeek(now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function isPM(input) {
	            return (/^(дня|вечера)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	});

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Sinhalese (si)
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal: function ordinal(number) {
	            return number + ' වැනි';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	});

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : slovak (sk)
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'm':
	                // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm':
	                // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':
	                // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh':
	                // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':
	                // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd':
	                // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':
	                // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM':
	                // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':
	                // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy':
	                // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParse: function (months, monthsShort) {
	            var i,
	                _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort),
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	});

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : slovenian (sl)
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	});

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Albanian (sq)
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        meridiemParse: /PD|MD/,
	        isPM: function isPM(input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	});

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Serbian-cyrillic (sr-cyrl)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар'],
	        monthsShort: ['јан.', 'феб.', 'мар.', 'апр.', 'мај', 'јун', 'јул', 'авг.', 'сеп.', 'окт.', 'нов.', 'дец.'],
	        weekdays: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'],
	        weekdaysShort: ['нед.', 'пон.', 'уто.', 'сре.', 'чет.', 'пет.', 'суб.'],
	        weekdaysMin: ['не', 'по', 'ут', 'ср', 'че', 'пе', 'су'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	});

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Serbian-latin (sr)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	});

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : swedish (sv)
	//! author : Jens Alm : https://github.com/ulmus
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'e' : b === 1 ? 'a' : b === 2 ? 'a' : b === 3 ? 'e' : 'e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	});

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : tamil (ta)
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal: function ordinal(number) {
	            return number + 'வது';
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : thai (th)
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort: 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        longDateFormat: {
	            LT: 'H นาฬิกา m นาที',
	            LTS: 'H นาฬิกา m นาที s วินาที',
	            L: 'YYYY/MM/DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function isPM(input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี'
	        }
	    });
	
	    return th;
	});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Tagalog/Filipino (tl-ph)
	//! author : Dan Hagman
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal: function ordinal(number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	});

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : turkish (tr)
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[haftaya] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen hafta] dddd [saat] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	});

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : talossan (tzl)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'LT.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY LT',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY LT'
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', ' ' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', ' ' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', ' ' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', ' ' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', ' ' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1].trim();
	    }
	
	    return tzl;
	});

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	});

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt (tzm)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	});

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : ukrainian (uk)
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'хвилина_хвилини_хвилин',
	            'hh': 'година_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_'),
	            'accusative': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_')
	        },
	            nounCase = /D[oD]? *MMMM?/.test(format) ? 'accusative' : 'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	            nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: monthsCaseReplace,
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function isPM(input) {
	            return (/^(дня|вечора)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	});

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : uzbek (uz)
	//! author : Sardor Muminov : https://github.com/muminoff
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	});

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : vietnamese (vi)
	//! author : Bang Nguyen : https://github.com/bangnk
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal: function ordinal(number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	});

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : chinese (zh-cn)
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'Ah点mm分',
	            LTS: 'Ah点m分s秒',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY年MMMD日',
	            LLL: 'YYYY年MMMD日Ah点mm分',
	            LLLL: 'YYYY年MMMD日ddddAh点mm分',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY年MMMD日',
	            lll: 'YYYY年MMMD日Ah点mm分',
	            llll: 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay: function nextDay() {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay: function lastDay() {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek: function nextWeek() {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek: function lastWeek() {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix() ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse: 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s内',
	            past: '%s前',
	            s: '几秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年'
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	});

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : traditional chinese (zh-tw)
	//! author : Ben : https://github.com/ben-lin
	
	(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'Ah點mm分',
	            LTS: 'Ah點m分s秒',
	            L: 'YYYY年MMMD日',
	            LL: 'YYYY年MMMD日',
	            LLL: 'YYYY年MMMD日Ah點mm分',
	            LLLL: 'YYYY年MMMD日ddddAh點mm分',
	            l: 'YYYY年MMMD日',
	            ll: 'YYYY年MMMD日',
	            lll: 'YYYY年MMMD日Ah點mm分',
	            llll: 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            m: '一分鐘',
	            mm: '%d分鐘',
	            h: '一小時',
	            hh: '%d小時',
	            d: '一天',
	            dd: '%d天',
	            M: '一個月',
	            MM: '%d個月',
	            y: '一年',
	            yy: '%d年'
	        }
	    });
	
	    return zh_tw;
	});

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _ViewListView = __webpack_require__(9);
	
	var _ViewListView2 = _interopRequireDefault(_ViewListView);
	
	var Collection = function (_ListView) {
	    _inherits(Collection, _ListView);
	
	    function Collection() {
	        _classCallCheck(this, Collection);
	
	        _get(Object.getPrototypeOf(Collection.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Collection, [{
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name();
	            }
	            return this;
	        }
	    }]);
	
	    return Collection;
	}(_ViewListView2['default']);
	
	exports['default'] = Collection;
	module.exports = exports['default'];
	//# sourceMappingURL=Collection.js.map

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var Dashboard = function () {
	    function Dashboard() {
	        _classCallCheck(this, Dashboard);
	
	        this._collections = {};
	        this._template = null;
	    }
	
	    _createClass(Dashboard, [{
	        key: "addCollection",
	        value: function addCollection(collection) {
	            this._collections[collection.name()] = collection;
	            return this;
	        }
	    }, {
	        key: "collections",
	        value: function collections(_collections) {
	            if (arguments.length) {
	                this._collections = _collections;
	                return this;
	            }
	            return this._collections;
	        }
	    }, {
	        key: "hasCollections",
	        value: function hasCollections() {
	            return Object.keys(this._collections).length > 0;
	        }
	    }, {
	        key: "template",
	        value: function template(_template) {
	            if (arguments.length) {
	                this._template = _template;
	                return this;
	            }
	            return this._template;
	        }
	    }]);
	
	    return Dashboard;
	}();
	
	exports["default"] = Dashboard;
	module.exports = exports["default"];
	//# sourceMappingURL=Dashboard.js.map

/***/ },
/* 108 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var DataStore = function () {
	    function DataStore() {
	        _classCallCheck(this, DataStore);
	
	        this._entries = {};
	    }
	
	    _createClass(DataStore, [{
	        key: 'setEntries',
	        value: function setEntries(name, entries) {
	            this._entries[name] = entries;
	
	            return this;
	        }
	    }, {
	        key: 'addEntry',
	        value: function addEntry(name, entry) {
	            if (!(name in this._entries)) {
	                this._entries[name] = [];
	            }
	
	            this._entries[name].push(entry);
	        }
	    }, {
	        key: 'getEntries',
	        value: function getEntries(name) {
	            return this._entries[name] || [];
	        }
	
	        /**
	         * Get first entry satisfying a filter function
	         *
	         * @example datastore.getEntry('books', book => book.title === 'War and Peace');
	         */
	    }, {
	        key: 'getFirstEntry',
	        value: function getFirstEntry(name) {
	            var filter = arguments.length <= 1 || arguments[1] === undefined ? function () {
	                return true;
	            } : arguments[1];
	
	            return this.getEntries(name).filter(filter).shift();
	        }
	    }, {
	        key: 'getChoices',
	        value: function getChoices(field) {
	            var identifier = field.targetEntity().identifier().name();
	            var name = field.targetField().name();
	
	            return this.getEntries(field.targetEntity().uniqueId + '_choices').map(function (entry) {
	                return {
	                    value: entry.values[identifier],
	                    label: entry.values[name]
	                };
	            });
	        }
	    }, {
	        key: 'fillReferencesValuesFromCollection',
	        value: function fillReferencesValuesFromCollection(collection, referencedValues, fillSimpleReference) {
	            fillSimpleReference = typeof fillSimpleReference === 'undefined' ? false : fillSimpleReference;
	
	            for (var i = 0, l = collection.length; i < l; i++) {
	                collection[i] = this.fillReferencesValuesFromEntry(collection[i], referencedValues, fillSimpleReference);
	            }
	
	            return collection;
	        }
	    }, {
	        key: 'fillReferencesValuesFromEntry',
	        value: function fillReferencesValuesFromEntry(entry, referencedValues, fillSimpleReference) {
	            for (var referenceField in referencedValues) {
	                var reference = referencedValues[referenceField],
	                    choices = this.getReferenceChoicesById(reference),
	                    entries = [],
	                    identifier = reference.getMappedValue(entry.values[referenceField], entry.values);
	
	                if (reference.type() === 'reference_many') {
	                    for (var i in identifier) {
	                        var id = identifier[i];
	                        entries.push(choices[id]);
	                    }
	
	                    entry.listValues[referenceField] = entries;
	                } else if (fillSimpleReference && identifier != null && identifier in choices) {
	                    entry.listValues[referenceField] = reference.getMappedValue(choices[identifier], entry.values);
	                }
	            }
	
	            return entry;
	        }
	    }, {
	        key: 'getReferenceChoicesById',
	        value: function getReferenceChoicesById(field) {
	            var result = {},
	                targetField = field.targetField().name(),
	                targetIdentifier = field.targetEntity().identifier().name(),
	                entries = this.getEntries(field.targetEntity().uniqueId + '_values');
	
	            for (var i = 0, l = entries.length; i < l; i++) {
	                var entry = entries[i];
	                result[entry.values[targetIdentifier]] = entry.values[targetField];
	            }
	
	            return result;
	        }
	    }]);
	
	    return DataStore;
	}();
	
	exports['default'] = DataStore;
	module.exports = exports['default'];
	//# sourceMappingURL=DataStore.js.map

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var DateField = function (_Field) {
	    _inherits(DateField, _Field);
	
	    function DateField(name) {
	        _classCallCheck(this, DateField);
	
	        _get(Object.getPrototypeOf(DateField.prototype), "constructor", this).call(this, name);
	
	        this._format = null;
	        this._parse = function (date) {
	            if (date instanceof Date) {
	                // the datepicker returns a JS Date object, with hours, minutes and timezone
	                // in order to convert it back to date, we must remove the timezone, then
	                // remove hours and minutes
	                date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
	
	                var dateString = date.toJSON();
	                return dateString ? dateString.substr(0, 10) : null;
	            }
	            return date;
	        };
	        this._type = "date";
	    }
	
	    _createClass(DateField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "parse",
	        value: function parse(value) {
	            if (!arguments.length) return this._parse;
	            this._parse = value;
	            return this;
	        }
	    }]);
	
	    return DateField;
	}(_Field3["default"]);
	
	exports["default"] = DateField;
	module.exports = exports["default"];
	//# sourceMappingURL=DateField.js.map

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var NumberField = function (_Field) {
	    _inherits(NumberField, _Field);
	
	    function NumberField(name) {
	        _classCallCheck(this, NumberField);
	
	        _get(Object.getPrototypeOf(NumberField.prototype), "constructor", this).call(this, name);
	        this._type = "number";
	        this._format = undefined;
	    }
	
	    /**
	     * Specify format pattern for number to string conversion. 
	     *
	     * Based on NumeralJs, which uses a syntax similar to Excel.
	     *
	     * {@link} http://numeraljs.com/
	     * {@link} https://github.com/baumandm/angular-numeraljs
	     * {@example}
	     *
	     *     nga.field('height', 'number').format('$0,0.00');
	     */
	
	    _createClass(NumberField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "fractionSize",
	        value: function fractionSize(decimals) {
	            console.warn('NumberField.fractionSize() is deprecated, use NumberField.format() instead');
	            this.format('0.' + '0'.repeat(decimals));
	            return this;
	        }
	    }]);
	
	    return NumberField;
	}(_Field3["default"]);
	
	exports["default"] = NumberField;
	module.exports = exports["default"];
	//# sourceMappingURL=NumberField.js.map

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _defineProperty(obj, key, value) {
	    if (key in obj) {
	        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	    } else {
	        obj[key] = value;
	    }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var _EntityEntity = __webpack_require__(10);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	function alwaysFalse() {
	    return false;
	}
	
	var uuid = 0;
	var _autoClose = true;
	
	var Menu = function () {
	    function Menu() {
	        _classCallCheck(this, Menu);
	
	        this._link = null;
	        this._activeFunc = alwaysFalse;
	        this._title = null;
	        this._icon = false;
	        this._children = [];
	        this._template = false;
	        this._autoClose = true;
	        this.uuid = uuid++;
	    }
	
	    _createClass(Menu, [{
	        key: 'title',
	        value: function title() {
	            if (arguments.length) {
	                this._title = arguments[0];
	                return this;
	            }
	            return this._title;
	        }
	    }, {
	        key: 'isLink',
	        value: function isLink() {
	            return !!this._link;
	        }
	    }, {
	        key: 'link',
	        value: function link() {
	            var _this = this;
	
	            if (arguments.length) {
	                this._link = arguments[0];
	                if (this._activeFunc == alwaysFalse) {
	                    this._activeFunc = function (url) {
	                        return url.indexOf(_this._link) === 0;
	                    };
	                }
	                return this;
	            }
	            return this._link;
	        }
	    }, {
	        key: 'autoClose',
	        value: function autoClose() {
	            if (arguments.length) {
	                _autoClose = arguments[0];
	                return this;
	            }
	            return _autoClose;
	        }
	    }, {
	        key: 'active',
	        value: function active(activeFunc) {
	            if (arguments.length) {
	                this._activeFunc = arguments[0];
	                return this;
	            }
	            return this._activeFunc;
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive(url) {
	            return this._activeFunc(url);
	        }
	    }, {
	        key: 'isChildActive',
	        value: function isChildActive(url) {
	            return this.isActive(url) || this.children().filter(function (menu) {
	                return menu.isChildActive(url);
	            }).length > 0;
	        }
	    }, {
	        key: 'addChild',
	        value: function addChild(child) {
	            if (!(child instanceof Menu)) {
	                throw new Error('Only Menu instances are accepted as children of a Menu');
	            }
	            this._children.push(child);
	            return this;
	        }
	    }, {
	        key: 'hasChild',
	        value: function hasChild() {
	            return this._children.length > 0;
	        }
	    }, {
	        key: 'getChildByTitle',
	        value: function getChildByTitle(title) {
	            return this.children().filter(function (child) {
	                return child.title() == title;
	            }).pop();
	        }
	    }, {
	        key: 'children',
	        value: function children() {
	            if (arguments.length) {
	                this._children = arguments[0];
	                return this;
	            }
	            return this._children;
	        }
	    }, {
	        key: 'icon',
	        value: function icon() {
	            if (arguments.length) {
	                this._icon = arguments[0];
	                return this;
	            }
	            return this._icon;
	        }
	    }, {
	        key: 'template',
	        value: function template() {
	            if (arguments.length) {
	                this._template = arguments[0];
	                return this;
	            }
	            return this._template;
	        }
	    }, {
	        key: 'populateFromEntity',
	        value: function populateFromEntity(entity) {
	            if (!(entity instanceof _EntityEntity2['default'])) {
	                throw new Error('populateFromEntity() only accepts an Entity parameter');
	            }
	            this.title(entity.label());
	            this.active(function (path) {
	                return path.indexOf('/' + entity.name() + '/') === 0;
	            });
	
	            var search = "";
	            var defaultFilters = entity.listView().filters().filter(function (filter) {
	                return filter.pinned() && filter.defaultValue();
	            }).reduce(function (filters, currentFilter) {
	                return Object.assign({}, filters, _defineProperty({}, currentFilter.name(), currentFilter.getTransformedValue(currentFilter.defaultValue())));
	            }, {});
	
	            if (Object.keys(defaultFilters).length) {
	                var encodedDefaultFilters = encodeURIComponent(JSON.stringify(defaultFilters));
	                search = '?search=' + encodedDefaultFilters;
	            }
	
	            this.link('/' + entity.name() + '/list' + search);
	            // deprecated
	            this.icon(entity.menuView().icon());
	            return this;
	        }
	    }]);
	
	    return Menu;
	}();
	
	exports['default'] = Menu;
	module.exports = exports['default'];
	//# sourceMappingURL=Menu.js.map

/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var Queries = function Queries(RestWrapper, PromisesResolver, Application) {
	    _classCallCheck(this, Queries);
	
	    this._restWrapper = RestWrapper;
	    this._promisesResolver = PromisesResolver;
	    this._application = Application;
	};
	
	exports["default"] = Queries;
	module.exports = exports["default"];
	//# sourceMappingURL=Queries.js.map

/***/ },
/* 113 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.clone = clone;
	exports.cloneAndFlatten = cloneAndFlatten;
	exports.cloneAndNest = cloneAndNest;
	function isObject(value) {
	    if (value === null) return false;
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') return false;
	    if (Array.isArray(value)) return false;
	    if (Object.prototype.toString.call(value) === '[object Date]') return false;
	    return true;
	}
	
	function clone(object) {
	    return Object.keys(object).reduce(function (values, name) {
	        if (object.hasOwnProperty(name)) {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	/*
	 * Flatten nested object into a single level object with 'foo.bar' property names
	 *
	 * The parameter object is left unchanged. All values in the returned object are scalar.
	 *
	 *     cloneAndFlatten({ a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } }, i: { j: 6 } }, ['i'])
	 *     // { a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5, i: { j: 6 } } }
	 *
	 * @param {Object} object
	 * @param {String[]} excludedProperties
	 * @return {Object}
	 */
	
	function cloneAndFlatten(object) {
	    var excludedProperties = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	    if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        if (isObject(object[name])) {
	            if (excludedProperties.indexOf(name) === -1) {
	                (function () {
	                    var flatObject = cloneAndFlatten(object[name]);
	                    Object.keys(flatObject).forEach(function (flatObjectKey) {
	                        if (!flatObject.hasOwnProperty(flatObjectKey)) return;
	                        values[name + '.' + flatObjectKey] = flatObject[flatObjectKey];
	                    });
	                })();
	            } else {
	                values[name] = clone(object[name]);
	            }
	        } else {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	;
	
	/*
	 * Clone flattened object into a nested object
	 *
	 * The parameter object is left unchanged.
	 *
	 *     cloneAndNest({ a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5 } )
	 *     // { a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } } }
	 *
	 * @param {Object} object
	 * @return {Object}
	 */
	
	function cloneAndNest(object) {
	    if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        name.split('.').reduce(function (previous, current, index, list) {
	            if (previous != null) {
	                if (typeof previous[current] === 'undefined') previous[current] = {};
	                if (index < list.length - 1) {
	                    return previous[current];
	                };
	                previous[current] = object[name];
	            }
	        }, values);
	        return values;
	    }, {});
	}
	//# sourceMappingURL=objectProperties.js.map

/***/ },
/* 114 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = {
	    order: function order(input) {
	        var results = [],
	            objectKey;
	
	        for (objectKey in input) {
	            results.push(input[objectKey]);
	        }
	
	        return results.sort(function (e1, e2) {
	            return e1.order() - e2.order();
	        });
	    }
	};
	module.exports = exports["default"];
	//# sourceMappingURL=orderElement.js.map

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    /**
	     * @see http://stackoverflow.com/questions/10425287/convert-string-to-camelcase-with-regular-expression
	     * @see http://phpjs.org/functions/ucfirst/
	     */
	    camelCase: function camelCase(text) {
	        if (!text) {
	            return text;
	        }
	
	        var f = text.charAt(0).toUpperCase();
	        text = f + text.substr(1);
	
	        return text.replace(/[-_.\s](.)/g, function (match, group1) {
	            return ' ' + group1.toUpperCase();
	        });
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=stringUtils.js.map

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	
	(function (factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object") {
	        // Node/CommonJS style
	        module.exports = factory();
	    } else {
	        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
	        root.rangy = factory();
	    }
	})(function () {
	
	    var OBJECT = "object",
	        FUNCTION = "function",
	        UNDEFINED = "undefined";
	
	    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
	    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
	    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed", "commonAncestorContainer"];
	
	    // Minimal set of methods required for DOM Level 2 Range compliance
	    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore", "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents", "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];
	
	    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];
	
	    // Subset of TextRange's full set of methods that we're interested in
	    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select", "setEndPoint", "getBoundingClientRect"];
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Trio of functions taken from Peter Michaux's article:
	    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
	    function isHostMethod(o, p) {
	        var t = _typeof(o[p]);
	        return t == FUNCTION || !!(t == OBJECT && o[p]) || t == "unknown";
	    }
	
	    function isHostObject(o, p) {
	        return !!(_typeof(o[p]) == OBJECT && o[p]);
	    }
	
	    function isHostProperty(o, p) {
	        return _typeof(o[p]) != UNDEFINED;
	    }
	
	    // Creates a convenience function to save verbose repeated calls to tests functions
	    function createMultiplePropertyTest(testFunc) {
	        return function (o, props) {
	            var i = props.length;
	            while (i--) {
	                if (!testFunc(o, props[i])) {
	                    return false;
	                }
	            }
	            return true;
	        };
	    }
	
	    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
	    var areHostMethods = createMultiplePropertyTest(isHostMethod);
	    var areHostObjects = createMultiplePropertyTest(isHostObject);
	    var areHostProperties = createMultiplePropertyTest(isHostProperty);
	
	    function isTextRange(range) {
	        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
	    }
	
	    function getBody(doc) {
	        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
	    }
	
	    var forEach = [].forEach ? function (arr, func) {
	        arr.forEach(func);
	    } : function (arr, func) {
	        for (var i = 0, len = arr.length; i < len; ++i) {
	            func(arr[i], i);
	        }
	    };
	
	    var modules = {};
	
	    var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) != UNDEFINED && (typeof document === "undefined" ? "undefined" : _typeof(document)) != UNDEFINED;
	
	    var util = {
	        isHostMethod: isHostMethod,
	        isHostObject: isHostObject,
	        isHostProperty: isHostProperty,
	        areHostMethods: areHostMethods,
	        areHostObjects: areHostObjects,
	        areHostProperties: areHostProperties,
	        isTextRange: isTextRange,
	        getBody: getBody,
	        forEach: forEach
	    };
	
	    var api = {
	        version: "1.3.0",
	        initialized: false,
	        isBrowser: isBrowser,
	        supported: true,
	        util: util,
	        features: {},
	        modules: modules,
	        config: {
	            alertOnFail: false,
	            alertOnWarn: false,
	            preferTextRange: false,
	            autoInitialize: (typeof rangyAutoInitialize === "undefined" ? "undefined" : _typeof(rangyAutoInitialize)) == UNDEFINED ? true : rangyAutoInitialize
	        }
	    };
	
	    function consoleLog(msg) {
	        if ((typeof console === "undefined" ? "undefined" : _typeof(console)) != UNDEFINED && isHostMethod(console, "log")) {
	            console.log(msg);
	        }
	    }
	
	    function alertOrLog(msg, shouldAlert) {
	        if (isBrowser && shouldAlert) {
	            alert(msg);
	        } else {
	            consoleLog(msg);
	        }
	    }
	
	    function fail(reason) {
	        api.initialized = true;
	        api.supported = false;
	        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
	    }
	
	    api.fail = fail;
	
	    function warn(msg) {
	        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
	    }
	
	    api.warn = warn;
	
	    // Add utility extend() method
	    var _extend;
	    if ({}.hasOwnProperty) {
	        util.extend = _extend = function extend(obj, props, deep) {
	            var o, p;
	            for (var i in props) {
	                if (props.hasOwnProperty(i)) {
	                    o = obj[i];
	                    p = props[i];
	                    if (deep && o !== null && (typeof o === "undefined" ? "undefined" : _typeof(o)) == "object" && p !== null && (typeof p === "undefined" ? "undefined" : _typeof(p)) == "object") {
	                        _extend(o, p, true);
	                    }
	                    obj[i] = p;
	                }
	            }
	            // Special case for toString, which does not show up in for...in loops in IE <= 8
	            if (props.hasOwnProperty("toString")) {
	                obj.toString = props.toString;
	            }
	            return obj;
	        };
	
	        util.createOptions = function (optionsParam, defaults) {
	            var options = {};
	            _extend(options, defaults);
	            if (optionsParam) {
	                _extend(options, optionsParam);
	            }
	            return options;
	        };
	    } else {
	        fail("hasOwnProperty not supported");
	    }
	
	    // Test whether we're in a browser and bail out if not
	    if (!isBrowser) {
	        fail("Rangy can only run in a browser");
	    }
	
	    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
	    (function () {
	        var toArray;
	
	        if (isBrowser) {
	            var el = document.createElement("div");
	            el.appendChild(document.createElement("span"));
	            var slice = [].slice;
	            try {
	                if (slice.call(el.childNodes, 0)[0].nodeType == 1) {
	                    toArray = function toArray(arrayLike) {
	                        return slice.call(arrayLike, 0);
	                    };
	                }
	            } catch (e) {}
	        }
	
	        if (!toArray) {
	            toArray = function toArray(arrayLike) {
	                var arr = [];
	                for (var i = 0, len = arrayLike.length; i < len; ++i) {
	                    arr[i] = arrayLike[i];
	                }
	                return arr;
	            };
	        }
	
	        util.toArray = toArray;
	    })();
	
	    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
	    // normalization of event properties
	    var addListener;
	    if (isBrowser) {
	        if (isHostMethod(document, "addEventListener")) {
	            addListener = function addListener(obj, eventType, listener) {
	                obj.addEventListener(eventType, listener, false);
	            };
	        } else if (isHostMethod(document, "attachEvent")) {
	            addListener = function addListener(obj, eventType, listener) {
	                obj.attachEvent("on" + eventType, listener);
	            };
	        } else {
	            fail("Document does not have required addEventListener or attachEvent method");
	        }
	
	        util.addListener = addListener;
	    }
	
	    var initListeners = [];
	
	    function getErrorDesc(ex) {
	        return ex.message || ex.description || String(ex);
	    }
	
	    // Initialization
	    function init() {
	        if (!isBrowser || api.initialized) {
	            return;
	        }
	        var testRange;
	        var implementsDomRange = false,
	            implementsTextRange = false;
	
	        // First, perform basic feature tests
	
	        if (isHostMethod(document, "createRange")) {
	            testRange = document.createRange();
	            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
	                implementsDomRange = true;
	            }
	        }
	
	        var body = getBody(document);
	        if (!body || body.nodeName.toLowerCase() != "body") {
	            fail("No body element found");
	            return;
	        }
	
	        if (body && isHostMethod(body, "createTextRange")) {
	            testRange = body.createTextRange();
	            if (isTextRange(testRange)) {
	                implementsTextRange = true;
	            }
	        }
	
	        if (!implementsDomRange && !implementsTextRange) {
	            fail("Neither Range nor TextRange are available");
	            return;
	        }
	
	        api.initialized = true;
	        api.features = {
	            implementsDomRange: implementsDomRange,
	            implementsTextRange: implementsTextRange
	        };
	
	        // Initialize modules
	        var module, errorMessage;
	        for (var moduleName in modules) {
	            if ((module = modules[moduleName]) instanceof Module) {
	                module.init(module, api);
	            }
	        }
	
	        // Call init listeners
	        for (var i = 0, len = initListeners.length; i < len; ++i) {
	            try {
	                initListeners[i](api);
	            } catch (ex) {
	                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
	                consoleLog(errorMessage);
	            }
	        }
	    }
	
	    function deprecationNotice(deprecated, replacement, module) {
	        if (module) {
	            deprecated += " in module " + module.name;
	        }
	        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " + replacement + " instead.");
	    }
	
	    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
	        owner[deprecated] = function () {
	            deprecationNotice(deprecated, replacement, module);
	            return owner[replacement].apply(owner, util.toArray(arguments));
	        };
	    }
	
	    util.deprecationNotice = deprecationNotice;
	    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;
	
	    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
	    api.init = init;
	
	    // Execute listener immediately if already initialized
	    api.addInitListener = function (listener) {
	        if (api.initialized) {
	            listener(api);
	        } else {
	            initListeners.push(listener);
	        }
	    };
	
	    var shimListeners = [];
	
	    api.addShimListener = function (listener) {
	        shimListeners.push(listener);
	    };
	
	    function shim(win) {
	        win = win || window;
	        init();
	
	        // Notify listeners
	        for (var i = 0, len = shimListeners.length; i < len; ++i) {
	            shimListeners[i](win);
	        }
	    }
	
	    if (isBrowser) {
	        api.shim = api.createMissingNativeApi = shim;
	        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
	    }
	
	    function Module(name, dependencies, initializer) {
	        this.name = name;
	        this.dependencies = dependencies;
	        this.initialized = false;
	        this.supported = false;
	        this.initializer = initializer;
	    }
	
	    Module.prototype = {
	        init: function init() {
	            var requiredModuleNames = this.dependencies || [];
	            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
	                moduleName = requiredModuleNames[i];
	
	                requiredModule = modules[moduleName];
	                if (!requiredModule || !(requiredModule instanceof Module)) {
	                    throw new Error("required module '" + moduleName + "' not found");
	                }
	
	                requiredModule.init();
	
	                if (!requiredModule.supported) {
	                    throw new Error("required module '" + moduleName + "' not supported");
	                }
	            }
	
	            // Now run initializer
	            this.initializer(this);
	        },
	
	        fail: function fail(reason) {
	            this.initialized = true;
	            this.supported = false;
	            throw new Error(reason);
	        },
	
	        warn: function warn(msg) {
	            api.warn("Module " + this.name + ": " + msg);
	        },
	
	        deprecationNotice: function deprecationNotice(deprecated, replacement) {
	            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " + replacement + " instead");
	        },
	
	        createError: function createError(msg) {
	            return new Error("Error in Rangy " + this.name + " module: " + msg);
	        }
	    };
	
	    function createModule(name, dependencies, initFunc) {
	        var newModule = new Module(name, dependencies, function (module) {
	            if (!module.initialized) {
	                module.initialized = true;
	                try {
	                    initFunc(api, module);
	                    module.supported = true;
	                } catch (ex) {
	                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
	                    consoleLog(errorMessage);
	                    if (ex.stack) {
	                        consoleLog(ex.stack);
	                    }
	                }
	            }
	        });
	        modules[name] = newModule;
	        return newModule;
	    }
	
	    api.createModule = function (name) {
	        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
	        var initFunc, dependencies;
	        if (arguments.length == 2) {
	            initFunc = arguments[1];
	            dependencies = [];
	        } else {
	            initFunc = arguments[2];
	            dependencies = arguments[1];
	        }
	
	        var module = createModule(name, dependencies, initFunc);
	
	        // Initialize the module immediately if the core is already initialized
	        if (api.initialized && api.supported) {
	            module.init();
	        }
	    };
	
	    api.createCoreModule = function (name, dependencies, initFunc) {
	        createModule(name, dependencies, initFunc);
	    };
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately
	
	    function RangePrototype() {}
	    api.RangePrototype = RangePrototype;
	    api.rangePrototype = new RangePrototype();
	
	    function SelectionPrototype() {}
	    api.selectionPrototype = new SelectionPrototype();
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // DOM utility methods used by Rangy
	    api.createCoreModule("DomUtil", [], function (api, module) {
	        var UNDEF = "undefined";
	        var util = api.util;
	        var getBody = util.getBody;
	
	        // Perform feature tests
	        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
	            module.fail("document missing a Node creation method");
	        }
	
	        if (!util.isHostMethod(document, "getElementsByTagName")) {
	            module.fail("document missing getElementsByTagName method");
	        }
	
	        var el = document.createElement("div");
	        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] || !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
	            module.fail("Incomplete Element implementation");
	        }
	
	        // innerHTML is required for Range's createContextualFragment method
	        if (!util.isHostProperty(el, "innerHTML")) {
	            module.fail("Element is missing innerHTML property");
	        }
	
	        var textNode = document.createTextNode("test");
	        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] || !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) || !util.areHostProperties(textNode, ["data"]))) {
	            module.fail("Incomplete Text Node implementation");
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
	        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
	        // contains just the document as a single element and the value searched for is the document.
	        var arrayContains = /*Array.prototype.indexOf ?
	                            function(arr, val) {
	                            return arr.indexOf(val) > -1;
	                            }:*/
	
	        function arrayContains(arr, val) {
	            var i = arr.length;
	            while (i--) {
	                if (arr[i] === val) {
	                    return true;
	                }
	            }
	            return false;
	        };
	
	        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
	        function isHtmlNamespace(node) {
	            var ns;
	            return _typeof(node.namespaceURI) == UNDEF || (ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml";
	        }
	
	        function parentElement(node) {
	            var parent = node.parentNode;
	            return parent.nodeType == 1 ? parent : null;
	        }
	
	        function getNodeIndex(node) {
	            var i = 0;
	            while (node = node.previousSibling) {
	                ++i;
	            }
	            return i;
	        }
	
	        function getNodeLength(node) {
	            switch (node.nodeType) {
	                case 7:
	                case 10:
	                    return 0;
	                case 3:
	                case 8:
	                    return node.length;
	                default:
	                    return node.childNodes.length;
	            }
	        }
	
	        function getCommonAncestor(node1, node2) {
	            var ancestors = [],
	                n;
	            for (n = node1; n; n = n.parentNode) {
	                ancestors.push(n);
	            }
	
	            for (n = node2; n; n = n.parentNode) {
	                if (arrayContains(ancestors, n)) {
	                    return n;
	                }
	            }
	
	            return null;
	        }
	
	        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
	            var n = selfIsAncestor ? descendant : descendant.parentNode;
	            while (n) {
	                if (n === ancestor) {
	                    return true;
	                } else {
	                    n = n.parentNode;
	                }
	            }
	            return false;
	        }
	
	        function isOrIsAncestorOf(ancestor, descendant) {
	            return isAncestorOf(ancestor, descendant, true);
	        }
	
	        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
	            var p,
	                n = selfIsAncestor ? node : node.parentNode;
	            while (n) {
	                p = n.parentNode;
	                if (p === ancestor) {
	                    return n;
	                }
	                n = p;
	            }
	            return null;
	        }
	
	        function isCharacterDataNode(node) {
	            var t = node.nodeType;
	            return t == 3 || t == 4 || t == 8; // Text, CDataSection or Comment
	        }
	
	        function isTextOrCommentNode(node) {
	            if (!node) {
	                return false;
	            }
	            var t = node.nodeType;
	            return t == 3 || t == 8; // Text or Comment
	        }
	
	        function insertAfter(node, precedingNode) {
	            var nextNode = precedingNode.nextSibling,
	                parent = precedingNode.parentNode;
	            if (nextNode) {
	                parent.insertBefore(node, nextNode);
	            } else {
	                parent.appendChild(node);
	            }
	            return node;
	        }
	
	        // Note that we cannot use splitText() because it is bugridden in IE 9.
	        function splitDataNode(node, index, positionsToPreserve) {
	            var newNode = node.cloneNode(false);
	            newNode.deleteData(0, index);
	            node.deleteData(index, node.length - index);
	            insertAfter(newNode, node);
	
	            // Preserve positions
	            if (positionsToPreserve) {
	                for (var i = 0, position; position = positionsToPreserve[i++];) {
	                    // Handle case where position was inside the portion of node after the split point
	                    if (position.node == node && position.offset > index) {
	                        position.node = newNode;
	                        position.offset -= index;
	                    }
	                    // Handle the case where the position is a node offset within node's parent
	                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
	                            ++position.offset;
	                        }
	                }
	            }
	            return newNode;
	        }
	
	        function getDocument(node) {
	            if (node.nodeType == 9) {
	                return node;
	            } else if (_typeof(node.ownerDocument) != UNDEF) {
	                return node.ownerDocument;
	            } else if (_typeof(node.document) != UNDEF) {
	                return node.document;
	            } else if (node.parentNode) {
	                return getDocument(node.parentNode);
	            } else {
	                throw module.createError("getDocument: no document found for node");
	            }
	        }
	
	        function getWindow(node) {
	            var doc = getDocument(node);
	            if (_typeof(doc.defaultView) != UNDEF) {
	                return doc.defaultView;
	            } else if (_typeof(doc.parentWindow) != UNDEF) {
	                return doc.parentWindow;
	            } else {
	                throw module.createError("Cannot get a window object for node");
	            }
	        }
	
	        function getIframeDocument(iframeEl) {
	            if (_typeof(iframeEl.contentDocument) != UNDEF) {
	                return iframeEl.contentDocument;
	            } else if (_typeof(iframeEl.contentWindow) != UNDEF) {
	                return iframeEl.contentWindow.document;
	            } else {
	                throw module.createError("getIframeDocument: No Document object found for iframe element");
	            }
	        }
	
	        function getIframeWindow(iframeEl) {
	            if (_typeof(iframeEl.contentWindow) != UNDEF) {
	                return iframeEl.contentWindow;
	            } else if (_typeof(iframeEl.contentDocument) != UNDEF) {
	                return iframeEl.contentDocument.defaultView;
	            } else {
	                throw module.createError("getIframeWindow: No Window object found for iframe element");
	            }
	        }
	
	        // This looks bad. Is it worth it?
	        function isWindow(obj) {
	            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
	        }
	
	        function getContentDocument(obj, module, methodName) {
	            var doc;
	
	            if (!obj) {
	                doc = document;
	            }
	
	            // Test if a DOM node has been passed and obtain a document object for it if so
	            else if (util.isHostProperty(obj, "nodeType")) {
	                    doc = obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe" ? getIframeDocument(obj) : getDocument(obj);
	                }
	
	                // Test if the doc parameter appears to be a Window object
	                else if (isWindow(obj)) {
	                        doc = obj.document;
	                    }
	
	            if (!doc) {
	                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
	            }
	
	            return doc;
	        }
	
	        function getRootContainer(node) {
	            var parent;
	            while (parent = node.parentNode) {
	                node = parent;
	            }
	            return node;
	        }
	
	        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
	            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
	            var nodeC, root, childA, childB, n;
	            if (nodeA == nodeB) {
	                // Case 1: nodes are the same
	                return offsetA === offsetB ? 0 : offsetA < offsetB ? -1 : 1;
	            } else if (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) {
	                // Case 2: node C (container B or an ancestor) is a child node of A
	                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
	            } else if (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) {
	                // Case 3: node C (container A or an ancestor) is a child node of B
	                return getNodeIndex(nodeC) < offsetB ? -1 : 1;
	            } else {
	                root = getCommonAncestor(nodeA, nodeB);
	                if (!root) {
	                    throw new Error("comparePoints error: nodes have no common ancestor");
	                }
	
	                // Case 4: containers are siblings or descendants of siblings
	                childA = nodeA === root ? root : getClosestAncestorIn(nodeA, root, true);
	                childB = nodeB === root ? root : getClosestAncestorIn(nodeB, root, true);
	
	                if (childA === childB) {
	                    // This shouldn't be possible
	                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
	                } else {
	                    n = root.firstChild;
	                    while (n) {
	                        if (n === childA) {
	                            return -1;
	                        } else if (n === childB) {
	                            return 1;
	                        }
	                        n = n.nextSibling;
	                    }
	                }
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
	        var crashyTextNodes = false;
	
	        function isBrokenNode(node) {
	            var n;
	            try {
	                n = node.parentNode;
	                return false;
	            } catch (e) {
	                return true;
	            }
	        }
	
	        (function () {
	            var el = document.createElement("b");
	            el.innerHTML = "1";
	            var textNode = el.firstChild;
	            el.innerHTML = "<br />";
	            crashyTextNodes = isBrokenNode(textNode);
	
	            api.features.crashyTextNodes = crashyTextNodes;
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function inspectNode(node) {
	            if (!node) {
	                return "[No node]";
	            }
	            if (crashyTextNodes && isBrokenNode(node)) {
	                return "[Broken node]";
	            }
	            if (isCharacterDataNode(node)) {
	                return '"' + node.data + '"';
	            }
	            if (node.nodeType == 1) {
	                var idAttr = node.id ? ' id="' + node.id + '"' : "";
	                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
	            }
	            return node.nodeName;
	        }
	
	        function fragmentFromNodeChildren(node) {
	            var fragment = getDocument(node).createDocumentFragment(),
	                child;
	            while (child = node.firstChild) {
	                fragment.appendChild(child);
	            }
	            return fragment;
	        }
	
	        var getComputedStyleProperty;
	        if (_typeof(window.getComputedStyle) != UNDEF) {
	            getComputedStyleProperty = function getComputedStyleProperty(el, propName) {
	                return getWindow(el).getComputedStyle(el, null)[propName];
	            };
	        } else if (_typeof(document.documentElement.currentStyle) != UNDEF) {
	            getComputedStyleProperty = function getComputedStyleProperty(el, propName) {
	                return el.currentStyle ? el.currentStyle[propName] : "";
	            };
	        } else {
	            module.fail("No means of obtaining computed style properties found");
	        }
	
	        function createTestElement(doc, html, contentEditable) {
	            var body = getBody(doc);
	            var el = doc.createElement("div");
	            el.contentEditable = "" + !!contentEditable;
	            if (html) {
	                el.innerHTML = html;
	            }
	
	            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
	            var bodyFirstChild = body.firstChild;
	            if (bodyFirstChild) {
	                body.insertBefore(el, bodyFirstChild);
	            } else {
	                body.appendChild(el);
	            }
	
	            return el;
	        }
	
	        function removeNode(node) {
	            return node.parentNode.removeChild(node);
	        }
	
	        function NodeIterator(root) {
	            this.root = root;
	            this._next = root;
	        }
	
	        NodeIterator.prototype = {
	            _current: null,
	
	            hasNext: function hasNext() {
	                return !!this._next;
	            },
	
	            next: function next() {
	                var n = this._current = this._next;
	                var child, next;
	                if (this._current) {
	                    child = n.firstChild;
	                    if (child) {
	                        this._next = child;
	                    } else {
	                        next = null;
	                        while (n !== this.root && !(next = n.nextSibling)) {
	                            n = n.parentNode;
	                        }
	                        this._next = next;
	                    }
	                }
	                return this._current;
	            },
	
	            detach: function detach() {
	                this._current = this._next = this.root = null;
	            }
	        };
	
	        function createIterator(root) {
	            return new NodeIterator(root);
	        }
	
	        function DomPosition(node, offset) {
	            this.node = node;
	            this.offset = offset;
	        }
	
	        DomPosition.prototype = {
	            equals: function equals(pos) {
	                return !!pos && this.node === pos.node && this.offset == pos.offset;
	            },
	
	            inspect: function inspect() {
	                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
	            },
	
	            toString: function toString() {
	                return this.inspect();
	            }
	        };
	
	        function DOMException(codeName) {
	            this.code = this[codeName];
	            this.codeName = codeName;
	            this.message = "DOMException: " + this.codeName;
	        }
	
	        DOMException.prototype = {
	            INDEX_SIZE_ERR: 1,
	            HIERARCHY_REQUEST_ERR: 3,
	            WRONG_DOCUMENT_ERR: 4,
	            NO_MODIFICATION_ALLOWED_ERR: 7,
	            NOT_FOUND_ERR: 8,
	            NOT_SUPPORTED_ERR: 9,
	            INVALID_STATE_ERR: 11,
	            INVALID_NODE_TYPE_ERR: 24
	        };
	
	        DOMException.prototype.toString = function () {
	            return this.message;
	        };
	
	        api.dom = {
	            arrayContains: arrayContains,
	            isHtmlNamespace: isHtmlNamespace,
	            parentElement: parentElement,
	            getNodeIndex: getNodeIndex,
	            getNodeLength: getNodeLength,
	            getCommonAncestor: getCommonAncestor,
	            isAncestorOf: isAncestorOf,
	            isOrIsAncestorOf: isOrIsAncestorOf,
	            getClosestAncestorIn: getClosestAncestorIn,
	            isCharacterDataNode: isCharacterDataNode,
	            isTextOrCommentNode: isTextOrCommentNode,
	            insertAfter: insertAfter,
	            splitDataNode: splitDataNode,
	            getDocument: getDocument,
	            getWindow: getWindow,
	            getIframeWindow: getIframeWindow,
	            getIframeDocument: getIframeDocument,
	            getBody: getBody,
	            isWindow: isWindow,
	            getContentDocument: getContentDocument,
	            getRootContainer: getRootContainer,
	            comparePoints: comparePoints,
	            isBrokenNode: isBrokenNode,
	            inspectNode: inspectNode,
	            getComputedStyleProperty: getComputedStyleProperty,
	            createTestElement: createTestElement,
	            removeNode: removeNode,
	            fragmentFromNodeChildren: fragmentFromNodeChildren,
	            createIterator: createIterator,
	            DomPosition: DomPosition
	        };
	
	        api.DOMException = DOMException;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Pure JavaScript implementation of DOM Range
	    api.createCoreModule("DomRange", ["DomUtil"], function (api, module) {
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DOMException = api.DOMException;
	
	        var isCharacterDataNode = dom.isCharacterDataNode;
	        var getNodeIndex = dom.getNodeIndex;
	        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
	        var getDocument = dom.getDocument;
	        var comparePoints = dom.comparePoints;
	        var splitDataNode = dom.splitDataNode;
	        var getClosestAncestorIn = dom.getClosestAncestorIn;
	        var getNodeLength = dom.getNodeLength;
	        var arrayContains = dom.arrayContains;
	        var getRootContainer = dom.getRootContainer;
	        var crashyTextNodes = api.features.crashyTextNodes;
	
	        var removeNode = dom.removeNode;
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Utility functions
	
	        function isNonTextPartiallySelected(node, range) {
	            return node.nodeType != 3 && (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
	        }
	
	        function getRangeDocument(range) {
	            return range.document || getDocument(range.startContainer);
	        }
	
	        function getRangeRoot(range) {
	            return getRootContainer(range.startContainer);
	        }
	
	        function getBoundaryBeforeNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node));
	        }
	
	        function getBoundaryAfterNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
	        }
	
	        function insertNodeAtPosition(node, n, o) {
	            var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
	            if (isCharacterDataNode(n)) {
	                if (o == n.length) {
	                    dom.insertAfter(node, n);
	                } else {
	                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
	                }
	            } else if (o >= n.childNodes.length) {
	                n.appendChild(node);
	            } else {
	                n.insertBefore(node, n.childNodes[o]);
	            }
	            return firstNodeInserted;
	        }
	
	        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
	            assertRangeValid(rangeA);
	            assertRangeValid(rangeB);
	
	            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	
	            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
	                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);
	
	            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	        }
	
	        function cloneSubtree(iterator) {
	            var partiallySelected;
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next();) {
	                partiallySelected = iterator.isPartiallySelectedSubtree();
	                node = node.cloneNode(!partiallySelected);
	                if (partiallySelected) {
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(cloneSubtree(subIterator));
	                    subIterator.detach();
	                }
	
	                if (node.nodeType == 10) {
	                    // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function iterateSubtree(rangeIterator, func, iteratorState) {
	            var it, n;
	            iteratorState = iteratorState || { stop: false };
	            for (var node, subRangeIterator; node = rangeIterator.next();) {
	                if (rangeIterator.isPartiallySelectedSubtree()) {
	                    if (func(node) === false) {
	                        iteratorState.stop = true;
	                        return;
	                    } else {
	                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
	                        // the node selected by the Range.
	                        subRangeIterator = rangeIterator.getSubtreeIterator();
	                        iterateSubtree(subRangeIterator, func, iteratorState);
	                        subRangeIterator.detach();
	                        if (iteratorState.stop) {
	                            return;
	                        }
	                    }
	                } else {
	                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
	                    // descendants
	                    it = dom.createIterator(node);
	                    while (n = it.next()) {
	                        if (func(n) === false) {
	                            iteratorState.stop = true;
	                            return;
	                        }
	                    }
	                }
	            }
	        }
	
	        function deleteSubtree(iterator) {
	            var subIterator;
	            while (iterator.next()) {
	                if (iterator.isPartiallySelectedSubtree()) {
	                    subIterator = iterator.getSubtreeIterator();
	                    deleteSubtree(subIterator);
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	            }
	        }
	
	        function extractSubtree(iterator) {
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next();) {
	
	                if (iterator.isPartiallySelectedSubtree()) {
	                    node = node.cloneNode(false);
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(extractSubtree(subIterator));
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	                if (node.nodeType == 10) {
	                    // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function getNodesInRange(range, nodeTypes, filter) {
	            var filterNodeTypes = !!(nodeTypes && nodeTypes.length),
	                regex;
	            var filterExists = !!filter;
	            if (filterNodeTypes) {
	                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
	            }
	
	            var nodes = [];
	            iterateSubtree(new RangeIterator(range, false), function (node) {
	                if (filterNodeTypes && !regex.test(node.nodeType)) {
	                    return;
	                }
	                if (filterExists && !filter(node)) {
	                    return;
	                }
	                // Don't include a boundary container if it is a character data node and the range does not contain any
	                // of its character data. See issue 190.
	                var sc = range.startContainer;
	                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
	                    return;
	                }
	
	                var ec = range.endContainer;
	                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
	                    return;
	                }
	
	                nodes.push(node);
	            });
	            return nodes;
	        }
	
	        function _inspect(range) {
	            var name = typeof range.getName == "undefined" ? "Range" : range.getName();
	            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " + dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)
	
	        function RangeIterator(range, clonePartiallySelectedTextNodes) {
	            this.range = range;
	            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;
	
	            if (!range.collapsed) {
	                this.sc = range.startContainer;
	                this.so = range.startOffset;
	                this.ec = range.endContainer;
	                this.eo = range.endOffset;
	                var root = range.commonAncestorContainer;
	
	                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
	                    this.isSingleCharacterDataNode = true;
	                    this._first = this._last = this._next = this.sc;
	                } else {
	                    this._first = this._next = this.sc === root && !isCharacterDataNode(this.sc) ? this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
	                    this._last = this.ec === root && !isCharacterDataNode(this.ec) ? this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
	                }
	            }
	        }
	
	        RangeIterator.prototype = {
	            _current: null,
	            _next: null,
	            _first: null,
	            _last: null,
	            isSingleCharacterDataNode: false,
	
	            reset: function reset() {
	                this._current = null;
	                this._next = this._first;
	            },
	
	            hasNext: function hasNext() {
	                return !!this._next;
	            },
	
	            next: function next() {
	                // Move to next node
	                var current = this._current = this._next;
	                if (current) {
	                    this._next = current !== this._last ? current.nextSibling : null;
	
	                    // Check for partially selected text nodes
	                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
	                        if (current === this.ec) {
	                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
	                        }
	                        if (this._current === this.sc) {
	                            (current = current.cloneNode(true)).deleteData(0, this.so);
	                        }
	                    }
	                }
	
	                return current;
	            },
	
	            remove: function remove() {
	                var current = this._current,
	                    start,
	                    end;
	
	                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
	                    start = current === this.sc ? this.so : 0;
	                    end = current === this.ec ? this.eo : current.length;
	                    if (start != end) {
	                        current.deleteData(start, end - start);
	                    }
	                } else {
	                    if (current.parentNode) {
	                        removeNode(current);
	                    } else {}
	                }
	            },
	
	            // Checks if the current node is partially selected
	            isPartiallySelectedSubtree: function isPartiallySelectedSubtree() {
	                var current = this._current;
	                return isNonTextPartiallySelected(current, this.range);
	            },
	
	            getSubtreeIterator: function getSubtreeIterator() {
	                var subRange;
	                if (this.isSingleCharacterDataNode) {
	                    subRange = this.range.cloneRange();
	                    subRange.collapse(false);
	                } else {
	                    subRange = new Range(getRangeDocument(this.range));
	                    var current = this._current;
	                    var startContainer = current,
	                        startOffset = 0,
	                        endContainer = current,
	                        endOffset = getNodeLength(current);
	
	                    if (isOrIsAncestorOf(current, this.sc)) {
	                        startContainer = this.sc;
	                        startOffset = this.so;
	                    }
	                    if (isOrIsAncestorOf(current, this.ec)) {
	                        endContainer = this.ec;
	                        endOffset = this.eo;
	                    }
	
	                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
	                }
	                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
	            },
	
	            detach: function detach() {
	                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
	            }
	        };
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
	        var rootContainerNodeTypes = [2, 9, 11];
	        var readonlyNodeTypes = [5, 6, 10, 12];
	        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
	        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];
	
	        function createAncestorFinder(nodeTypes) {
	            return function (node, selfIsAncestor) {
	                var t,
	                    n = selfIsAncestor ? node : node.parentNode;
	                while (n) {
	                    t = n.nodeType;
	                    if (arrayContains(nodeTypes, t)) {
	                        return n;
	                    }
	                    n = n.parentNode;
	                }
	                return null;
	            };
	        }
	
	        var getDocumentOrFragmentContainer = createAncestorFinder([9, 11]);
	        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
	        var getDocTypeNotationEntityAncestor = createAncestorFinder([6, 10, 12]);
	
	        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
	            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidNodeType(node, invalidTypes) {
	            if (!arrayContains(invalidTypes, node.nodeType)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        function assertSameDocumentOrFragment(node1, node2) {
	            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertNodeNotReadOnly(node) {
	            if (getReadonlyAncestor(node, true)) {
	                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
	            }
	        }
	
	        function assertNode(node, codeName) {
	            if (!node) {
	                throw new DOMException(codeName);
	            }
	        }
	
	        function isValidOffset(node, offset) {
	            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
	        }
	
	        function isRangeValid(range) {
	            return !!range.startContainer && !!range.endContainer && !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) && getRootContainer(range.startContainer) == getRootContainer(range.endContainer) && isValidOffset(range.startContainer, range.startOffset) && isValidOffset(range.endContainer, range.endOffset);
	        }
	
	        function assertRangeValid(range) {
	            if (!isRangeValid(range)) {
	                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test the browser's innerHTML support to decide how to implement createContextualFragment
	        var styleEl = document.createElement("style");
	        var htmlParsingConforms = false;
	        try {
	            styleEl.innerHTML = "<b>x</b>";
	            htmlParsingConforms = styleEl.firstChild.nodeType == 3; // Opera incorrectly creates an element node
	        } catch (e) {
	            // IE 6 and 7 throw
	        }
	
	        api.features.htmlParsingConforms = htmlParsingConforms;
	
	        var createContextualFragment = htmlParsingConforms ?
	
	        // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
	        // discussion and base code for this implementation at issue 67.
	        // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
	        // Thanks to Aleks Williams.
	        function (fragmentStr) {
	            // "Let node the context object's start's node."
	            var node = this.startContainer;
	            var doc = getDocument(node);
	
	            // "If the context object's start's node is null, raise an INVALID_STATE_ERR
	            // exception and abort these steps."
	            if (!node) {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	
	            // "Let element be as follows, depending on node's interface:"
	            // Document, Document Fragment: null
	            var el = null;
	
	            // "Element: node"
	            if (node.nodeType == 1) {
	                el = node;
	
	                // "Text, Comment: node's parentElement"
	            } else if (isCharacterDataNode(node)) {
	                el = dom.parentElement(node);
	            }
	
	            // "If either element is null or element's ownerDocument is an HTML document
	            // and element's local name is "html" and element's namespace is the HTML
	            // namespace"
	            if (el === null || el.nodeName == "HTML" && dom.isHtmlNamespace(getDocument(el).documentElement) && dom.isHtmlNamespace(el)) {
	
	                // "let element be a new Element with "body" as its local name and the HTML
	                // namespace as its namespace.""
	                el = doc.createElement("body");
	            } else {
	                el = el.cloneNode(false);
	            }
	
	            // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
	            // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
	            // "In either case, the algorithm must be invoked with fragment as the input
	            // and element as the context element."
	            el.innerHTML = fragmentStr;
	
	            // "If this raises an exception, then abort these steps. Otherwise, let new
	            // children be the nodes returned."
	
	            // "Let fragment be a new DocumentFragment."
	            // "Append all new children to fragment."
	            // "Return fragment."
	            return dom.fragmentFromNodeChildren(el);
	        } :
	
	        // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
	        // previous versions of Rangy used (with the exception of using a body element rather than a div)
	        function (fragmentStr) {
	            var doc = getRangeDocument(this);
	            var el = doc.createElement("body");
	            el.innerHTML = fragmentStr;
	
	            return dom.fragmentFromNodeChildren(el);
	        };
	
	        function splitRangeBoundaries(range, positionsToPreserve) {
	            assertRangeValid(range);
	
	            var sc = range.startContainer,
	                so = range.startOffset,
	                ec = range.endContainer,
	                eo = range.endOffset;
	            var startEndSame = sc === ec;
	
	            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
	                splitDataNode(ec, eo, positionsToPreserve);
	            }
	
	            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
	                sc = splitDataNode(sc, so, positionsToPreserve);
	                if (startEndSame) {
	                    eo -= so;
	                    ec = sc;
	                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
	                    eo++;
	                }
	                so = 0;
	            }
	            range.setStartAndEnd(sc, so, ec, eo);
	        }
	
	        function rangeToHtml(range) {
	            assertRangeValid(range);
	            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
	            container.appendChild(range.cloneContents());
	            return container.innerHTML;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed", "commonAncestorContainer"];
	
	        var s2s = 0,
	            s2e = 1,
	            e2e = 2,
	            e2s = 3;
	        var n_b = 0,
	            n_a = 1,
	            n_b_a = 2,
	            n_i = 3;
	
	        util.extend(api.rangePrototype, {
	            compareBoundaryPoints: function compareBoundaryPoints(how, range) {
	                assertRangeValid(this);
	                assertSameDocumentOrFragment(this.startContainer, range.startContainer);
	
	                var nodeA, offsetA, nodeB, offsetB;
	                var prefixA = how == e2s || how == s2s ? "start" : "end";
	                var prefixB = how == s2e || how == s2s ? "start" : "end";
	                nodeA = this[prefixA + "Container"];
	                offsetA = this[prefixA + "Offset"];
	                nodeB = range[prefixB + "Container"];
	                offsetB = range[prefixB + "Offset"];
	                return comparePoints(nodeA, offsetA, nodeB, offsetB);
	            },
	
	            insertNode: function insertNode(node) {
	                assertRangeValid(this);
	                assertValidNodeType(node, insertableNodeTypes);
	                assertNodeNotReadOnly(this.startContainer);
	
	                if (isOrIsAncestorOf(node, this.startContainer)) {
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	
	                // No check for whether the container of the start of the Range is of a type that does not allow
	                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
	                // to add the node
	
	                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                this.setStartBefore(firstNodeInserted);
	            },
	
	            cloneContents: function cloneContents() {
	                assertRangeValid(this);
	
	                var clone, frag;
	                if (this.collapsed) {
	                    return getRangeDocument(this).createDocumentFragment();
	                } else {
	                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
	                        clone = this.startContainer.cloneNode(true);
	                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
	                        frag = getRangeDocument(this).createDocumentFragment();
	                        frag.appendChild(clone);
	                        return frag;
	                    } else {
	                        var iterator = new RangeIterator(this, true);
	                        clone = cloneSubtree(iterator);
	                        iterator.detach();
	                    }
	                    return clone;
	                }
	            },
	
	            canSurroundContents: function canSurroundContents() {
	                assertRangeValid(this);
	                assertNodeNotReadOnly(this.startContainer);
	                assertNodeNotReadOnly(this.endContainer);
	
	                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                // no non-text nodes.
	                var iterator = new RangeIterator(this, true);
	                var boundariesInvalid = iterator._first && isNonTextPartiallySelected(iterator._first, this) || iterator._last && isNonTextPartiallySelected(iterator._last, this);
	                iterator.detach();
	                return !boundariesInvalid;
	            },
	
	            surroundContents: function surroundContents(node) {
	                assertValidNodeType(node, surroundNodeTypes);
	
	                if (!this.canSurroundContents()) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // Extract the contents
	                var content = this.extractContents();
	
	                // Clear the children of the node
	                if (node.hasChildNodes()) {
	                    while (node.lastChild) {
	                        node.removeChild(node.lastChild);
	                    }
	                }
	
	                // Insert the new node and add the extracted contents
	                insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                node.appendChild(content);
	
	                this.selectNode(node);
	            },
	
	            cloneRange: function cloneRange() {
	                assertRangeValid(this);
	                var range = new Range(getRangeDocument(this));
	                var i = rangeProperties.length,
	                    prop;
	                while (i--) {
	                    prop = rangeProperties[i];
	                    range[prop] = this[prop];
	                }
	                return range;
	            },
	
	            toString: function toString() {
	                assertRangeValid(this);
	                var sc = this.startContainer;
	                if (sc === this.endContainer && isCharacterDataNode(sc)) {
	                    return sc.nodeType == 3 || sc.nodeType == 4 ? sc.data.slice(this.startOffset, this.endOffset) : "";
	                } else {
	                    var textParts = [],
	                        iterator = new RangeIterator(this, true);
	                    iterateSubtree(iterator, function (node) {
	                        // Accept only text or CDATA nodes, not comments
	                        if (node.nodeType == 3 || node.nodeType == 4) {
	                            textParts.push(node.data);
	                        }
	                    });
	                    iterator.detach();
	                    return textParts.join("");
	                }
	            },
	
	            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
	            // been removed from Mozilla.
	
	            compareNode: function compareNode(node) {
	                assertRangeValid(this);
	
	                var parent = node.parentNode;
	                var nodeIndex = getNodeIndex(node);
	
	                if (!parent) {
	                    throw new DOMException("NOT_FOUND_ERR");
	                }
	
	                var startComparison = this.comparePoint(parent, nodeIndex),
	                    endComparison = this.comparePoint(parent, nodeIndex + 1);
	
	                if (startComparison < 0) {
	                    // Node starts before
	                    return endComparison > 0 ? n_b_a : n_b;
	                } else {
	                    return endComparison > 0 ? n_a : n_i;
	                }
	            },
	
	            comparePoint: function comparePoint(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
	                    return -1;
	                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
	                    return 1;
	                }
	                return 0;
	            },
	
	            createContextualFragment: createContextualFragment,
	
	            toHtml: function toHtml() {
	                return rangeToHtml(this);
	            },
	
	            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
	            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
	            intersectsNode: function intersectsNode(node, touchingIsIntersecting) {
	                assertRangeValid(this);
	                if (getRootContainer(node) != getRangeRoot(this)) {
	                    return false;
	                }
	
	                var parent = node.parentNode,
	                    offset = getNodeIndex(node);
	                if (!parent) {
	                    return true;
	                }
	
	                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
	                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);
	
	                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	            },
	
	            isPointInRange: function isPointInRange(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                return comparePoints(node, offset, this.startContainer, this.startOffset) >= 0 && comparePoints(node, offset, this.endContainer, this.endOffset) <= 0;
	            },
	
	            // The methods below are non-standard and invented by me.
	
	            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
	            intersectsRange: function intersectsRange(range) {
	                return rangesIntersect(this, range, false);
	            },
	
	            // Sharing a boundary start-to-end or end-to-start does count as intersection.
	            intersectsOrTouchesRange: function intersectsOrTouchesRange(range) {
	                return rangesIntersect(this, range, true);
	            },
	
	            intersection: function intersection(range) {
	                if (this.intersectsRange(range)) {
	                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
	                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);
	
	                    var intersectionRange = this.cloneRange();
	                    if (startComparison == -1) {
	                        intersectionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (endComparison == 1) {
	                        intersectionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return intersectionRange;
	                }
	                return null;
	            },
	
	            union: function union(range) {
	                if (this.intersectsOrTouchesRange(range)) {
	                    var unionRange = this.cloneRange();
	                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
	                        unionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
	                        unionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return unionRange;
	                } else {
	                    throw new DOMException("Ranges do not intersect");
	                }
	            },
	
	            containsNode: function containsNode(node, allowPartial) {
	                if (allowPartial) {
	                    return this.intersectsNode(node, false);
	                } else {
	                    return this.compareNode(node) == n_i;
	                }
	            },
	
	            containsNodeContents: function containsNodeContents(node) {
	                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
	            },
	
	            containsRange: function containsRange(range) {
	                var intersection = this.intersection(range);
	                return intersection !== null && range.equals(intersection);
	            },
	
	            containsNodeText: function containsNodeText(node) {
	                var nodeRange = this.cloneRange();
	                nodeRange.selectNode(node);
	                var textNodes = nodeRange.getNodes([3]);
	                if (textNodes.length > 0) {
	                    nodeRange.setStart(textNodes[0], 0);
	                    var lastTextNode = textNodes.pop();
	                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
	                    return this.containsRange(nodeRange);
	                } else {
	                    return this.containsNodeContents(node);
	                }
	            },
	
	            getNodes: function getNodes(nodeTypes, filter) {
	                assertRangeValid(this);
	                return getNodesInRange(this, nodeTypes, filter);
	            },
	
	            getDocument: function getDocument() {
	                return getRangeDocument(this);
	            },
	
	            collapseBefore: function collapseBefore(node) {
	                this.setEndBefore(node);
	                this.collapse(false);
	            },
	
	            collapseAfter: function collapseAfter(node) {
	                this.setStartAfter(node);
	                this.collapse(true);
	            },
	
	            getBookmark: function getBookmark(containerNode) {
	                var doc = getRangeDocument(this);
	                var preSelectionRange = api.createRange(doc);
	                containerNode = containerNode || dom.getBody(doc);
	                preSelectionRange.selectNodeContents(containerNode);
	                var range = this.intersection(preSelectionRange);
	                var start = 0,
	                    end = 0;
	                if (range) {
	                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
	                    start = preSelectionRange.toString().length;
	                    end = start + range.toString().length;
	                }
	
	                return {
	                    start: start,
	                    end: end,
	                    containerNode: containerNode
	                };
	            },
	
	            moveToBookmark: function moveToBookmark(bookmark) {
	                var containerNode = bookmark.containerNode;
	                var charIndex = 0;
	                this.setStart(containerNode, 0);
	                this.collapse(true);
	                var nodeStack = [containerNode],
	                    node,
	                    foundStart = false,
	                    stop = false;
	                var nextCharIndex, i, childNodes;
	
	                while (!stop && (node = nodeStack.pop())) {
	                    if (node.nodeType == 3) {
	                        nextCharIndex = charIndex + node.length;
	                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
	                            this.setStart(node, bookmark.start - charIndex);
	                            foundStart = true;
	                        }
	                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
	                            this.setEnd(node, bookmark.end - charIndex);
	                            stop = true;
	                        }
	                        charIndex = nextCharIndex;
	                    } else {
	                        childNodes = node.childNodes;
	                        i = childNodes.length;
	                        while (i--) {
	                            nodeStack.push(childNodes[i]);
	                        }
	                    }
	                }
	            },
	
	            getName: function getName() {
	                return "DomRange";
	            },
	
	            equals: function equals(range) {
	                return Range.rangesEqual(this, range);
	            },
	
	            isValid: function isValid() {
	                return isRangeValid(this);
	            },
	
	            inspect: function inspect() {
	                return _inspect(this);
	            },
	
	            detach: function detach() {
	                // In DOM4, detach() is now a no-op.
	            }
	        });
	
	        function copyComparisonConstantsToObject(obj) {
	            obj.START_TO_START = s2s;
	            obj.START_TO_END = s2e;
	            obj.END_TO_END = e2e;
	            obj.END_TO_START = e2s;
	
	            obj.NODE_BEFORE = n_b;
	            obj.NODE_AFTER = n_a;
	            obj.NODE_BEFORE_AND_AFTER = n_b_a;
	            obj.NODE_INSIDE = n_i;
	        }
	
	        function copyComparisonConstants(constructor) {
	            copyComparisonConstantsToObject(constructor);
	            copyComparisonConstantsToObject(constructor.prototype);
	        }
	
	        function createRangeContentRemover(remover, boundaryUpdater) {
	            return function () {
	                assertRangeValid(this);
	
	                var sc = this.startContainer,
	                    so = this.startOffset,
	                    root = this.commonAncestorContainer;
	
	                var iterator = new RangeIterator(this, true);
	
	                // Work out where to position the range after content removal
	                var node, boundary;
	                if (sc !== root) {
	                    node = getClosestAncestorIn(sc, root, true);
	                    boundary = getBoundaryAfterNode(node);
	                    sc = boundary.node;
	                    so = boundary.offset;
	                }
	
	                // Check none of the range is read-only
	                iterateSubtree(iterator, assertNodeNotReadOnly);
	
	                iterator.reset();
	
	                // Remove the content
	                var returnValue = remover(iterator);
	                iterator.detach();
	
	                // Move to the new position
	                boundaryUpdater(this, sc, so, sc, so);
	
	                return returnValue;
	            };
	        }
	
	        function createPrototypeRange(constructor, boundaryUpdater) {
	            function createBeforeAfterNodeSetter(isBefore, isStart) {
	                return function (node) {
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);
	
	                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
	                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
	                };
	            }
	
	            function setRangeStart(range, node, offset) {
	                var ec = range.endContainer,
	                    eo = range.endOffset;
	                if (node !== range.startContainer || offset !== range.startOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
	                        ec = node;
	                        eo = offset;
	                    }
	                    boundaryUpdater(range, node, offset, ec, eo);
	                }
	            }
	
	            function setRangeEnd(range, node, offset) {
	                var sc = range.startContainer,
	                    so = range.startOffset;
	                if (node !== range.endContainer || offset !== range.endOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
	                        sc = node;
	                        so = offset;
	                    }
	                    boundaryUpdater(range, sc, so, node, offset);
	                }
	            }
	
	            // Set up inheritance
	            var F = function F() {};
	            F.prototype = api.rangePrototype;
	            constructor.prototype = new F();
	
	            util.extend(constructor.prototype, {
	                setStart: function setStart(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeStart(this, node, offset);
	                },
	
	                setEnd: function setEnd(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeEnd(this, node, offset);
	                },
	
	                /**
	                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
	                 * - Two parameters (node, offset) creates a collapsed range at that position
	                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
	                 *   startOffset and ending at endOffset
	                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
	                 *   startNode and ending at endOffset in endNode
	                 */
	                setStartAndEnd: function setStartAndEnd() {
	                    var args = arguments;
	                    var sc = args[0],
	                        so = args[1],
	                        ec = sc,
	                        eo = so;
	
	                    switch (args.length) {
	                        case 3:
	                            eo = args[2];
	                            break;
	                        case 4:
	                            ec = args[2];
	                            eo = args[3];
	                            break;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                setBoundary: function setBoundary(node, offset, isStart) {
	                    this["set" + (isStart ? "Start" : "End")](node, offset);
	                },
	
	                setStartBefore: createBeforeAfterNodeSetter(true, true),
	                setStartAfter: createBeforeAfterNodeSetter(false, true),
	                setEndBefore: createBeforeAfterNodeSetter(true, false),
	                setEndAfter: createBeforeAfterNodeSetter(false, false),
	
	                collapse: function collapse(isStart) {
	                    assertRangeValid(this);
	                    if (isStart) {
	                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
	                    } else {
	                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
	                    }
	                },
	
	                selectNodeContents: function selectNodeContents(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	
	                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
	                },
	
	                selectNode: function selectNode(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, false);
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	
	                    var start = getBoundaryBeforeNode(node),
	                        end = getBoundaryAfterNode(node);
	                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
	                },
	
	                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),
	
	                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),
	
	                canSurroundContents: function canSurroundContents() {
	                    assertRangeValid(this);
	                    assertNodeNotReadOnly(this.startContainer);
	                    assertNodeNotReadOnly(this.endContainer);
	
	                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                    // no non-text nodes.
	                    var iterator = new RangeIterator(this, true);
	                    var boundariesInvalid = iterator._first && isNonTextPartiallySelected(iterator._first, this) || iterator._last && isNonTextPartiallySelected(iterator._last, this);
	                    iterator.detach();
	                    return !boundariesInvalid;
	                },
	
	                splitBoundaries: function splitBoundaries() {
	                    splitRangeBoundaries(this);
	                },
	
	                splitBoundariesPreservingPositions: function splitBoundariesPreservingPositions(positionsToPreserve) {
	                    splitRangeBoundaries(this, positionsToPreserve);
	                },
	
	                normalizeBoundaries: function normalizeBoundaries() {
	                    assertRangeValid(this);
	
	                    var sc = this.startContainer,
	                        so = this.startOffset,
	                        ec = this.endContainer,
	                        eo = this.endOffset;
	
	                    var mergeForward = function mergeForward(node) {
	                        var sibling = node.nextSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            ec = node;
	                            eo = node.length;
	                            node.appendData(sibling.data);
	                            removeNode(sibling);
	                        }
	                    };
	
	                    var mergeBackward = function mergeBackward(node) {
	                        var sibling = node.previousSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            sc = node;
	                            var nodeLength = node.length;
	                            so = sibling.length;
	                            node.insertData(0, sibling.data);
	                            removeNode(sibling);
	                            if (sc == ec) {
	                                eo += so;
	                                ec = sc;
	                            } else if (ec == node.parentNode) {
	                                var nodeIndex = getNodeIndex(node);
	                                if (eo == nodeIndex) {
	                                    ec = node;
	                                    eo = nodeLength;
	                                } else if (eo > nodeIndex) {
	                                    eo--;
	                                }
	                            }
	                        }
	                    };
	
	                    var normalizeStart = true;
	                    var sibling;
	
	                    if (isCharacterDataNode(ec)) {
	                        if (eo == ec.length) {
	                            mergeForward(ec);
	                        } else if (eo == 0) {
	                            sibling = ec.previousSibling;
	                            if (sibling && sibling.nodeType == ec.nodeType) {
	                                eo = sibling.length;
	                                if (sc == ec) {
	                                    normalizeStart = false;
	                                }
	                                sibling.appendData(ec.data);
	                                removeNode(ec);
	                                ec = sibling;
	                            }
	                        }
	                    } else {
	                        if (eo > 0) {
	                            var endNode = ec.childNodes[eo - 1];
	                            if (endNode && isCharacterDataNode(endNode)) {
	                                mergeForward(endNode);
	                            }
	                        }
	                        normalizeStart = !this.collapsed;
	                    }
	
	                    if (normalizeStart) {
	                        if (isCharacterDataNode(sc)) {
	                            if (so == 0) {
	                                mergeBackward(sc);
	                            } else if (so == sc.length) {
	                                sibling = sc.nextSibling;
	                                if (sibling && sibling.nodeType == sc.nodeType) {
	                                    if (ec == sibling) {
	                                        ec = sc;
	                                        eo += sc.length;
	                                    }
	                                    sc.appendData(sibling.data);
	                                    removeNode(sibling);
	                                }
	                            }
	                        } else {
	                            if (so < sc.childNodes.length) {
	                                var startNode = sc.childNodes[so];
	                                if (startNode && isCharacterDataNode(startNode)) {
	                                    mergeBackward(startNode);
	                                }
	                            }
	                        }
	                    } else {
	                        sc = ec;
	                        so = eo;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                collapseToPoint: function collapseToPoint(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	                    this.setStartAndEnd(node, offset);
	                }
	            });
	
	            copyComparisonConstants(constructor);
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Updates commonAncestorContainer and collapsed after boundary change
	        function updateCollapsedAndCommonAncestor(range) {
	            range.collapsed = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
	            range.commonAncestorContainer = range.collapsed ? range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
	        }
	
	        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
	            range.startContainer = startContainer;
	            range.startOffset = startOffset;
	            range.endContainer = endContainer;
	            range.endOffset = endOffset;
	            range.document = dom.getDocument(startContainer);
	
	            updateCollapsedAndCommonAncestor(range);
	        }
	
	        function Range(doc) {
	            this.startContainer = doc;
	            this.startOffset = 0;
	            this.endContainer = doc;
	            this.endOffset = 0;
	            this.document = doc;
	            updateCollapsedAndCommonAncestor(this);
	        }
	
	        createPrototypeRange(Range, updateBoundaries);
	
	        util.extend(Range, {
	            rangeProperties: rangeProperties,
	            RangeIterator: RangeIterator,
	            copyComparisonConstants: copyComparisonConstants,
	            createPrototypeRange: createPrototypeRange,
	            inspect: _inspect,
	            toHtml: rangeToHtml,
	            getRangeDocument: getRangeDocument,
	            rangesEqual: function rangesEqual(r1, r2) {
	                return r1.startContainer === r2.startContainer && r1.startOffset === r2.startOffset && r1.endContainer === r2.endContainer && r1.endOffset === r2.endOffset;
	            }
	        });
	
	        api.DomRange = Range;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wrappers for the browser's native DOM Range and/or TextRange implementation
	    api.createCoreModule("WrappedRange", ["DomRange"], function (api, module) {
	        var WrappedRange, WrappedTextRange;
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DomRange = api.DomRange;
	        var getBody = dom.getBody;
	        var getContentDocument = dom.getContentDocument;
	        var isCharacterDataNode = dom.isCharacterDataNode;
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        if (api.features.implementsDomRange) {
	            // This is a wrapper around the browser's native DOM Range. It has two aims:
	            // - Provide workarounds for specific browser bugs
	            // - provide convenient extensions, which are inherited from Rangy's DomRange
	
	            (function () {
	                var rangeProto;
	                var rangeProperties = DomRange.rangeProperties;
	
	                function updateRangeProperties(range) {
	                    var i = rangeProperties.length,
	                        prop;
	                    while (i--) {
	                        prop = rangeProperties[i];
	                        range[prop] = range.nativeRange[prop];
	                    }
	                    // Fix for broken collapsed property in IE 9.
	                    range.collapsed = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
	                }
	
	                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
	                    var startMoved = range.startContainer !== startContainer || range.startOffset != startOffset;
	                    var endMoved = range.endContainer !== endContainer || range.endOffset != endOffset;
	                    var nativeRangeDifferent = !range.equals(range.nativeRange);
	
	                    // Always set both boundaries for the benefit of IE9 (see issue 35)
	                    if (startMoved || endMoved || nativeRangeDifferent) {
	                        range.setEnd(endContainer, endOffset);
	                        range.setStart(startContainer, startOffset);
	                    }
	                }
	
	                var createBeforeAfterNodeSetter;
	
	                WrappedRange = function WrappedRange(range) {
	                    if (!range) {
	                        throw module.createError("WrappedRange: Range must be specified");
	                    }
	                    this.nativeRange = range;
	                    updateRangeProperties(this);
	                };
	
	                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);
	
	                rangeProto = WrappedRange.prototype;
	
	                rangeProto.selectNode = function (node) {
	                    this.nativeRange.selectNode(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneContents = function () {
	                    return this.nativeRange.cloneContents();
	                };
	
	                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
	                // insertNode() is never delegated to the native range.
	
	                rangeProto.surroundContents = function (node) {
	                    this.nativeRange.surroundContents(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.collapse = function (isStart) {
	                    this.nativeRange.collapse(isStart);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneRange = function () {
	                    return new WrappedRange(this.nativeRange.cloneRange());
	                };
	
	                rangeProto.refresh = function () {
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.toString = function () {
	                    return this.nativeRange.toString();
	                };
	
	                // Create test range and node for feature detection
	
	                var testTextNode = document.createTextNode("test");
	                getBody(document).appendChild(testTextNode);
	                var range = document.createRange();
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
	                // correct for it
	
	                range.setStart(testTextNode, 0);
	                range.setEnd(testTextNode, 0);
	
	                try {
	                    range.setStart(testTextNode, 1);
	
	                    rangeProto.setStart = function (node, offset) {
	                        this.nativeRange.setStart(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function (node, offset) {
	                        this.nativeRange.setEnd(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function createBeforeAfterNodeSetter(name) {
	                        return function (node) {
	                            this.nativeRange[name](node);
	                            updateRangeProperties(this);
	                        };
	                    };
	                } catch (ex) {
	
	                    rangeProto.setStart = function (node, offset) {
	                        try {
	                            this.nativeRange.setStart(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setEnd(node, offset);
	                            this.nativeRange.setStart(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function (node, offset) {
	                        try {
	                            this.nativeRange.setEnd(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setStart(node, offset);
	                            this.nativeRange.setEnd(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function createBeforeAfterNodeSetter(name, oppositeName) {
	                        return function (node) {
	                            try {
	                                this.nativeRange[name](node);
	                            } catch (ex) {
	                                this.nativeRange[oppositeName](node);
	                                this.nativeRange[name](node);
	                            }
	                            updateRangeProperties(this);
	                        };
	                    };
	                }
	
	                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
	                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
	                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
	                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
	                // whether the native implementation can be trusted
	                rangeProto.selectNodeContents = function (node) {
	                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
	                };
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
	                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738
	
	                range.selectNodeContents(testTextNode);
	                range.setEnd(testTextNode, 3);
	
	                var range2 = document.createRange();
	                range2.selectNodeContents(testTextNode);
	                range2.setEnd(testTextNode, 4);
	                range2.setStart(testTextNode, 2);
	
	                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 && range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
	                    // This is the wrong way round, so correct for it
	
	                    rangeProto.compareBoundaryPoints = function (type, range) {
	                        range = range.nativeRange || range;
	                        if (type == range.START_TO_END) {
	                            type = range.END_TO_START;
	                        } else if (type == range.END_TO_START) {
	                            type = range.START_TO_END;
	                        }
	                        return this.nativeRange.compareBoundaryPoints(type, range);
	                    };
	                } else {
	                    rangeProto.compareBoundaryPoints = function (type, range) {
	                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.
	
	                var el = document.createElement("div");
	                el.innerHTML = "123";
	                var textNode = el.firstChild;
	                var body = getBody(document);
	                body.appendChild(el);
	
	                range.setStart(textNode, 1);
	                range.setEnd(textNode, 2);
	                range.deleteContents();
	
	                if (textNode.data == "13") {
	                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
	                    // extractContents()
	                    rangeProto.deleteContents = function () {
	                        this.nativeRange.deleteContents();
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.extractContents = function () {
	                        var frag = this.nativeRange.extractContents();
	                        updateRangeProperties(this);
	                        return frag;
	                    };
	                } else {}
	
	                body.removeChild(el);
	                body = null;
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for existence of createContextualFragment and delegate to it if it exists
	                if (util.isHostMethod(range, "createContextualFragment")) {
	                    rangeProto.createContextualFragment = function (fragmentStr) {
	                        return this.nativeRange.createContextualFragment(fragmentStr);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Clean up
	                getBody(document).removeChild(testTextNode);
	
	                rangeProto.getName = function () {
	                    return "WrappedRange";
	                };
	
	                api.WrappedRange = WrappedRange;
	
	                api.createNativeRange = function (doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return doc.createRange();
	                };
	            })();
	        }
	
	        if (api.features.implementsTextRange) {
	            /*
	            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
	            method. For example, in the following (where pipes denote the selection boundaries):
	             <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>
	             var range = document.selection.createRange();
	            alert(range.parentElement().id); // Should alert "ul" but alerts "b"
	             This method returns the common ancestor node of the following:
	            - the parentElement() of the textRange
	            - the parentElement() of the textRange after calling collapse(true)
	            - the parentElement() of the textRange after calling collapse(false)
	            */
	            var getTextRangeContainerElement = function getTextRangeContainerElement(textRange) {
	                var parentEl = textRange.parentElement();
	                var range = textRange.duplicate();
	                range.collapse(true);
	                var startEl = range.parentElement();
	                range = textRange.duplicate();
	                range.collapse(false);
	                var endEl = range.parentElement();
	                var startEndContainer = startEl == endEl ? startEl : dom.getCommonAncestor(startEl, endEl);
	
	                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
	            };
	
	            var textRangeIsCollapsed = function textRangeIsCollapsed(textRange) {
	                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
	            };
	
	            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
	            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
	            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
	            // bugs, handling for inputs and images, plus optimizations.
	            var getTextRangeBoundaryPosition = function getTextRangeBoundaryPosition(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
	                var workingRange = textRange.duplicate();
	                workingRange.collapse(isStart);
	                var containerElement = workingRange.parentElement();
	
	                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
	                // check for that
	                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
	                    containerElement = wholeRangeContainerElement;
	                }
	
	                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
	                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
	                if (!containerElement.canHaveHTML) {
	                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
	                    return {
	                        boundaryPosition: pos,
	                        nodeInfo: {
	                            nodeIndex: pos.offset,
	                            containerElement: pos.node
	                        }
	                    };
	                }
	
	                var workingNode = dom.getDocument(containerElement).createElement("span");
	
	                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
	                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
	                if (workingNode.parentNode) {
	                    dom.removeNode(workingNode);
	                }
	
	                var comparison,
	                    workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
	                var previousNode, nextNode, boundaryPosition, boundaryNode;
	                var start = startInfo && startInfo.containerElement == containerElement ? startInfo.nodeIndex : 0;
	                var childNodeCount = containerElement.childNodes.length;
	                var end = childNodeCount;
	
	                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
	                // after the range boundary.
	                var nodeIndex = end;
	
	                while (true) {
	                    if (nodeIndex == childNodeCount) {
	                        containerElement.appendChild(workingNode);
	                    } else {
	                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
	                    }
	                    workingRange.moveToElementText(workingNode);
	                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
	                    if (comparison == 0 || start == end) {
	                        break;
	                    } else if (comparison == -1) {
	                        if (end == start + 1) {
	                            // We know the endth child node is after the range boundary, so we must be done.
	                            break;
	                        } else {
	                            start = nodeIndex;
	                        }
	                    } else {
	                        end = end == start + 1 ? start : nodeIndex;
	                    }
	                    nodeIndex = Math.floor((start + end) / 2);
	                    containerElement.removeChild(workingNode);
	                }
	
	                // We've now reached or gone past the boundary of the text range we're interested in
	                // so have identified the node we want
	                boundaryNode = workingNode.nextSibling;
	
	                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
	                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
	                    // the node containing the text range's boundary, so we move the end of the working range to the
	                    // boundary point and measure the length of its text to get the boundary's offset within the node.
	                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);
	
	                    var offset;
	
	                    if (/[\r\n]/.test(boundaryNode.data)) {
	                        /*
	                        For the particular case of a boundary within a text node containing rendered line breaks (within a
	                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
	                        IE. The facts:
	                         - Each line break is represented as \r in the text node's data/nodeValue properties
	                        - Each line break is represented as \r\n in the TextRange's 'text' property
	                        - The 'text' property of the TextRange does not contain trailing line breaks
	                         To get round the problem presented by the final fact above, we can use the fact that TextRange's
	                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
	                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
	                        to use this to store the characters moved when moving both the start and end of the range to the
	                        start of the document body and subtracting the start offset from the end offset (the
	                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
	                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
	                        the end of the document) has the same problem.
	                         Another approach that works is to use moveStart() to move the start boundary of the range up to the
	                        end boundary one character at a time and incrementing a counter with the value returned by the
	                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
	                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
	                        by the location of the range within the document).
	                         The approach used below is a hybrid of the two methods above. It uses the fact that a string
	                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
	                        be longer than the text of the TextRange, so the start of the range is moved that length initially
	                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
	                        property. This has good performance in most situations compared to the previous two methods.
	                        */
	                        var tempRange = workingRange.duplicate();
	                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;
	
	                        offset = tempRange.moveStart("character", rangeLength);
	                        while ((comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
	                            offset++;
	                            tempRange.moveStart("character", 1);
	                        }
	                    } else {
	                        offset = workingRange.text.length;
	                    }
	                    boundaryPosition = new DomPosition(boundaryNode, offset);
	                } else {
	
	                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
	                    // a position within that, and likewise for a start boundary preceding a character data node
	                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
	                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
	                    if (nextNode && isCharacterDataNode(nextNode)) {
	                        boundaryPosition = new DomPosition(nextNode, 0);
	                    } else if (previousNode && isCharacterDataNode(previousNode)) {
	                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
	                    } else {
	                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
	                    }
	                }
	
	                // Clean up
	                dom.removeNode(workingNode);
	
	                return {
	                    boundaryPosition: boundaryPosition,
	                    nodeInfo: {
	                        nodeIndex: nodeIndex,
	                        containerElement: containerElement
	                    }
	                };
	            };
	
	            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
	            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
	            // (http://code.google.com/p/ierange/)
	            var createBoundaryTextRange = function createBoundaryTextRange(boundaryPosition, isStart) {
	                var boundaryNode,
	                    boundaryParent,
	                    boundaryOffset = boundaryPosition.offset;
	                var doc = dom.getDocument(boundaryPosition.node);
	                var workingNode,
	                    childNodes,
	                    workingRange = getBody(doc).createTextRange();
	                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);
	
	                if (nodeIsDataNode) {
	                    boundaryNode = boundaryPosition.node;
	                    boundaryParent = boundaryNode.parentNode;
	                } else {
	                    childNodes = boundaryPosition.node.childNodes;
	                    boundaryNode = boundaryOffset < childNodes.length ? childNodes[boundaryOffset] : null;
	                    boundaryParent = boundaryPosition.node;
	                }
	
	                // Position the range immediately before the node containing the boundary
	                workingNode = doc.createElement("span");
	
	                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
	                // the element rather than immediately before or after it
	                workingNode.innerHTML = "&#feff;";
	
	                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
	                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
	                if (boundaryNode) {
	                    boundaryParent.insertBefore(workingNode, boundaryNode);
	                } else {
	                    boundaryParent.appendChild(workingNode);
	                }
	
	                workingRange.moveToElementText(workingNode);
	                workingRange.collapse(!isStart);
	
	                // Clean up
	                boundaryParent.removeChild(workingNode);
	
	                // Move the working range to the text offset, if required
	                if (nodeIsDataNode) {
	                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
	                }
	
	                return workingRange;
	            };
	
	            /*------------------------------------------------------------------------------------------------------------*/
	
	            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
	            // prototype
	
	            WrappedTextRange = function WrappedTextRange(textRange) {
	                this.textRange = textRange;
	                this.refresh();
	            };
	
	            WrappedTextRange.prototype = new DomRange(document);
	
	            WrappedTextRange.prototype.refresh = function () {
	                var start, end, startBoundary;
	
	                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
	                var rangeContainerElement = getTextRangeContainerElement(this.textRange);
	
	                if (textRangeIsCollapsed(this.textRange)) {
	                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, true).boundaryPosition;
	                } else {
	                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
	                    start = startBoundary.boundaryPosition;
	
	                    // An optimization used here is that if the start and end boundaries have the same parent element, the
	                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
	                    // the start boundary
	                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false, startBoundary.nodeInfo).boundaryPosition;
	                }
	
	                this.setStart(start.node, start.offset);
	                this.setEnd(end.node, end.offset);
	            };
	
	            WrappedTextRange.prototype.getName = function () {
	                return "WrappedTextRange";
	            };
	
	            DomRange.copyComparisonConstants(WrappedTextRange);
	
	            var rangeToTextRange = function rangeToTextRange(range) {
	                if (range.collapsed) {
	                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                } else {
	                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
	                    var textRange = getBody(DomRange.getRangeDocument(range)).createTextRange();
	                    textRange.setEndPoint("StartToStart", startRange);
	                    textRange.setEndPoint("EndToEnd", endRange);
	                    return textRange;
	                }
	            };
	
	            WrappedTextRange.rangeToTextRange = rangeToTextRange;
	
	            WrappedTextRange.prototype.toTextRange = function () {
	                return rangeToTextRange(this);
	            };
	
	            api.WrappedTextRange = WrappedTextRange;
	
	            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
	            // implementation to use by default.
	            if (!api.features.implementsDomRange || api.config.preferTextRange) {
	                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
	                var globalObj = function (f) {
	                    return f("return this;")();
	                }(Function);
	                if (typeof globalObj.Range == "undefined") {
	                    globalObj.Range = WrappedTextRange;
	                }
	
	                api.createNativeRange = function (doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return getBody(doc).createTextRange();
	                };
	
	                api.WrappedRange = WrappedTextRange;
	            }
	        }
	
	        api.createRange = function (doc) {
	            doc = getContentDocument(doc, module, "createRange");
	            return new api.WrappedRange(api.createNativeRange(doc));
	        };
	
	        api.createRangyRange = function (doc) {
	            doc = getContentDocument(doc, module, "createRangyRange");
	            return new DomRange(doc);
	        };
	
	        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
	        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");
	
	        api.addShimListener(function (win) {
	            var doc = win.document;
	            if (typeof doc.createRange == "undefined") {
	                doc.createRange = function () {
	                    return api.createRange(doc);
	                };
	            }
	            doc = win = null;
	        });
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
	    // in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)
	    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function (api, module) {
	        api.config.checkSelectionRanges = true;
	
	        var BOOLEAN = "boolean";
	        var NUMBER = "number";
	        var dom = api.dom;
	        var util = api.util;
	        var isHostMethod = util.isHostMethod;
	        var DomRange = api.DomRange;
	        var WrappedRange = api.WrappedRange;
	        var DOMException = api.DOMException;
	        var DomPosition = dom.DomPosition;
	        var getNativeSelection;
	        var selectionIsCollapsed;
	        var features = api.features;
	        var CONTROL = "Control";
	        var getDocument = dom.getDocument;
	        var getBody = dom.getBody;
	        var rangesEqual = DomRange.rangesEqual;
	
	        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
	        // "forward" or "forwards") or a Boolean (true for backwards).
	        function isDirectionBackward(dir) {
	            return typeof dir == "string" ? /^backward(s)?$/i.test(dir) : !!dir;
	        }
	
	        function getWindow(win, methodName) {
	            if (!win) {
	                return window;
	            } else if (dom.isWindow(win)) {
	                return win;
	            } else if (win instanceof WrappedSelection) {
	                return win.win;
	            } else {
	                var doc = dom.getContentDocument(win, module, methodName);
	                return dom.getWindow(doc);
	            }
	        }
	
	        function getWinSelection(winParam) {
	            return getWindow(winParam, "getWinSelection").getSelection();
	        }
	
	        function getDocSelection(winParam) {
	            return getWindow(winParam, "getDocSelection").document.selection;
	        }
	
	        function winSelectionIsBackward(sel) {
	            var backward = false;
	            if (sel.anchorNode) {
	                backward = dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1;
	            }
	            return backward;
	        }
	
	        // Test for the Range/TextRange and Selection features required
	        // Test for ability to retrieve selection
	        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
	            implementsDocSelection = util.isHostObject(document, "selection");
	
	        features.implementsWinGetSelection = implementsWinGetSelection;
	        features.implementsDocSelection = implementsDocSelection;
	
	        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);
	
	        if (useDocumentSelection) {
	            getNativeSelection = getDocSelection;
	            api.isSelectionValid = function (winParam) {
	                var doc = getWindow(winParam, "isSelectionValid").document,
	                    nativeSel = doc.selection;
	
	                // Check whether the selection TextRange is actually contained within the correct document
	                return nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc;
	            };
	        } else if (implementsWinGetSelection) {
	            getNativeSelection = getWinSelection;
	            api.isSelectionValid = function () {
	                return true;
	            };
	        } else {
	            module.fail("Neither document.selection or window.getSelection() detected.");
	            return false;
	        }
	
	        api.getNativeSelection = getNativeSelection;
	
	        var testSelection = getNativeSelection();
	
	        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
	        if (!testSelection) {
	            module.fail("Native selection was null (possibly issue 138?)");
	            return false;
	        }
	
	        var testRange = api.createNativeRange(document);
	        var body = getBody(document);
	
	        // Obtaining a range from a selection
	        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection, ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);
	
	        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;
	
	        // Test for existence of native selection extend() method
	        var selectionHasExtend = isHostMethod(testSelection, "extend");
	        features.selectionHasExtend = selectionHasExtend;
	
	        // Test if rangeCount exists
	        var selectionHasRangeCount = _typeof(testSelection.rangeCount) == NUMBER;
	        features.selectionHasRangeCount = selectionHasRangeCount;
	
	        var selectionSupportsMultipleRanges = false;
	        var collapsedNonEditableSelectionsSupported = true;
	
	        var addRangeBackwardToNative = selectionHasExtend ? function (nativeSelection, range) {
	            var doc = DomRange.getRangeDocument(range);
	            var endRange = api.createRange(doc);
	            endRange.collapseToPoint(range.endContainer, range.endOffset);
	            nativeSelection.addRange(getNativeRange(endRange));
	            nativeSelection.extend(range.startContainer, range.startOffset);
	        } : null;
	
	        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) && _typeof(testSelection.rangeCount) == NUMBER && features.implementsDomRange) {
	
	            (function () {
	                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
	                // performed on the current document's selection. See issue 109.
	
	                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
	                // will result in the selection direction begin reversed if the original selection was backwards and the
	                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
	                var sel = window.getSelection();
	                if (sel) {
	                    // Store the current selection
	                    var originalSelectionRangeCount = sel.rangeCount;
	                    var selectionHasMultipleRanges = originalSelectionRangeCount > 1;
	                    var originalSelectionRanges = [];
	                    var originalSelectionBackward = winSelectionIsBackward(sel);
	                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
	                        originalSelectionRanges[i] = sel.getRangeAt(i);
	                    }
	
	                    // Create some test elements
	                    var testEl = dom.createTestElement(document, "", false);
	                    var textNode = testEl.appendChild(document.createTextNode("\xA0\xA0\xA0"));
	
	                    // Test whether the native selection will allow a collapsed selection within a non-editable element
	                    var r1 = document.createRange();
	
	                    r1.setStart(textNode, 1);
	                    r1.collapse(true);
	                    sel.removeAllRanges();
	                    sel.addRange(r1);
	                    collapsedNonEditableSelectionsSupported = sel.rangeCount == 1;
	                    sel.removeAllRanges();
	
	                    // Test whether the native selection is capable of supporting multiple ranges.
	                    if (!selectionHasMultipleRanges) {
	                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
	                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
	                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
	                        // sniff. I'm not happy about it. See
	                        // https://code.google.com/p/chromium/issues/detail?id=399791
	                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
	                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
	                            selectionSupportsMultipleRanges = false;
	                        } else {
	                            var r2 = r1.cloneRange();
	                            r1.setStart(textNode, 0);
	                            r2.setEnd(textNode, 3);
	                            r2.setStart(textNode, 2);
	                            sel.addRange(r1);
	                            sel.addRange(r2);
	                            selectionSupportsMultipleRanges = sel.rangeCount == 2;
	                        }
	                    }
	
	                    // Clean up
	                    dom.removeNode(testEl);
	                    sel.removeAllRanges();
	
	                    for (i = 0; i < originalSelectionRangeCount; ++i) {
	                        if (i == 0 && originalSelectionBackward) {
	                            if (addRangeBackwardToNative) {
	                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
	                            } else {
	                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
	                                sel.addRange(originalSelectionRanges[i]);
	                            }
	                        } else {
	                            sel.addRange(originalSelectionRanges[i]);
	                        }
	                    }
	                }
	            })();
	        }
	
	        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
	        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;
	
	        // ControlRanges
	        var implementsControlRange = false,
	            testControlRange;
	
	        if (body && isHostMethod(body, "createControlRange")) {
	            testControlRange = body.createControlRange();
	            if (util.areHostProperties(testControlRange, ["item", "add"])) {
	                implementsControlRange = true;
	            }
	        }
	        features.implementsControlRange = implementsControlRange;
	
	        // Selection collapsedness
	        if (selectionHasAnchorAndFocus) {
	            selectionIsCollapsed = function selectionIsCollapsed(sel) {
	                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
	            };
	        } else {
	            selectionIsCollapsed = function selectionIsCollapsed(sel) {
	                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
	            };
	        }
	
	        function updateAnchorAndFocusFromRange(sel, range, backward) {
	            var anchorPrefix = backward ? "end" : "start",
	                focusPrefix = backward ? "start" : "end";
	            sel.anchorNode = range[anchorPrefix + "Container"];
	            sel.anchorOffset = range[anchorPrefix + "Offset"];
	            sel.focusNode = range[focusPrefix + "Container"];
	            sel.focusOffset = range[focusPrefix + "Offset"];
	        }
	
	        function updateAnchorAndFocusFromNativeSelection(sel) {
	            var nativeSel = sel.nativeSelection;
	            sel.anchorNode = nativeSel.anchorNode;
	            sel.anchorOffset = nativeSel.anchorOffset;
	            sel.focusNode = nativeSel.focusNode;
	            sel.focusOffset = nativeSel.focusOffset;
	        }
	
	        function updateEmptySelection(sel) {
	            sel.anchorNode = sel.focusNode = null;
	            sel.anchorOffset = sel.focusOffset = 0;
	            sel.rangeCount = 0;
	            sel.isCollapsed = true;
	            sel._ranges.length = 0;
	        }
	
	        function getNativeRange(range) {
	            var nativeRange;
	            if (range instanceof DomRange) {
	                nativeRange = api.createNativeRange(range.getDocument());
	                nativeRange.setEnd(range.endContainer, range.endOffset);
	                nativeRange.setStart(range.startContainer, range.startOffset);
	            } else if (range instanceof WrappedRange) {
	                nativeRange = range.nativeRange;
	            } else if (features.implementsDomRange && range instanceof dom.getWindow(range.startContainer).Range) {
	                nativeRange = range;
	            }
	            return nativeRange;
	        }
	
	        function rangeContainsSingleElement(rangeNodes) {
	            if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
	                return false;
	            }
	            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
	                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        function getSingleElementFromRange(range) {
	            var nodes = range.getNodes();
	            if (!rangeContainsSingleElement(nodes)) {
	                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
	            }
	            return nodes[0];
	        }
	
	        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
	        function isTextRange(range) {
	            return !!range && typeof range.text != "undefined";
	        }
	
	        function updateFromTextRange(sel, range) {
	            // Create a Range from the selected TextRange
	            var wrappedRange = new WrappedRange(range);
	            sel._ranges = [wrappedRange];
	
	            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
	            sel.rangeCount = 1;
	            sel.isCollapsed = wrappedRange.collapsed;
	        }
	
	        function updateControlSelection(sel) {
	            // Update the wrapped selection based on what's now in the native selection
	            sel._ranges.length = 0;
	            if (sel.docSelection.type == "None") {
	                updateEmptySelection(sel);
	            } else {
	                var controlRange = sel.docSelection.createRange();
	                if (isTextRange(controlRange)) {
	                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
	                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
	                    // ControlRange have been removed from the ControlRange and removed from the document.
	                    updateFromTextRange(sel, controlRange);
	                } else {
	                    sel.rangeCount = controlRange.length;
	                    var range,
	                        doc = getDocument(controlRange.item(0));
	                    for (var i = 0; i < sel.rangeCount; ++i) {
	                        range = api.createRange(doc);
	                        range.selectNode(controlRange.item(i));
	                        sel._ranges.push(range);
	                    }
	                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
	                }
	            }
	        }
	
	        function addRangeToControlSelection(sel, range) {
	            var controlRange = sel.docSelection.createRange();
	            var rangeElement = getSingleElementFromRange(range);
	
	            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
	            // contained by the supplied range
	            var doc = getDocument(controlRange.item(0));
	            var newControlRange = getBody(doc).createControlRange();
	            for (var i = 0, len = controlRange.length; i < len; ++i) {
	                newControlRange.add(controlRange.item(i));
	            }
	            try {
	                newControlRange.add(rangeElement);
	            } catch (ex) {
	                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
	            }
	            newControlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        var getSelectionRangeAt;
	
	        if (isHostMethod(testSelection, "getRangeAt")) {
	            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
	            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
	            // lesson to us all, especially me.
	            getSelectionRangeAt = function getSelectionRangeAt(sel, index) {
	                try {
	                    return sel.getRangeAt(index);
	                } catch (ex) {
	                    return null;
	                }
	            };
	        } else if (selectionHasAnchorAndFocus) {
	            getSelectionRangeAt = function getSelectionRangeAt(sel) {
	                var doc = getDocument(sel.anchorNode);
	                var range = api.createRange(doc);
	                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);
	
	                // Handle the case when the selection was selected backwards (from the end to the start in the
	                // document)
	                if (range.collapsed !== this.isCollapsed) {
	                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
	                }
	
	                return range;
	            };
	        }
	
	        function WrappedSelection(selection, docSelection, win) {
	            this.nativeSelection = selection;
	            this.docSelection = docSelection;
	            this._ranges = [];
	            this.win = win;
	            this.refresh();
	        }
	
	        WrappedSelection.prototype = api.selectionPrototype;
	
	        function deleteProperties(sel) {
	            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
	            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
	            sel.detached = true;
	        }
	
	        var cachedRangySelections = [];
	
	        function actOnCachedSelection(win, action) {
	            var i = cachedRangySelections.length,
	                cached,
	                sel;
	            while (i--) {
	                cached = cachedRangySelections[i];
	                sel = cached.selection;
	                if (action == "deleteAll") {
	                    deleteProperties(sel);
	                } else if (cached.win == win) {
	                    if (action == "delete") {
	                        cachedRangySelections.splice(i, 1);
	                        return true;
	                    } else {
	                        return sel;
	                    }
	                }
	            }
	            if (action == "deleteAll") {
	                cachedRangySelections.length = 0;
	            }
	            return null;
	        }
	
	        var getSelection = function getSelection(win) {
	            // Check if the parameter is a Rangy Selection object
	            if (win && win instanceof WrappedSelection) {
	                win.refresh();
	                return win;
	            }
	
	            win = getWindow(win, "getNativeSelection");
	
	            var sel = actOnCachedSelection(win);
	            var nativeSel = getNativeSelection(win),
	                docSel = implementsDocSelection ? getDocSelection(win) : null;
	            if (sel) {
	                sel.nativeSelection = nativeSel;
	                sel.docSelection = docSel;
	                sel.refresh();
	            } else {
	                sel = new WrappedSelection(nativeSel, docSel, win);
	                cachedRangySelections.push({ win: win, selection: sel });
	            }
	            return sel;
	        };
	
	        api.getSelection = getSelection;
	
	        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");
	
	        var selProto = WrappedSelection.prototype;
	
	        function createControlSelection(sel, ranges) {
	            // Ensure that the selection becomes of type "Control"
	            var doc = getDocument(ranges[0].startContainer);
	            var controlRange = getBody(doc).createControlRange();
	            for (var i = 0, el, len = ranges.length; i < len; ++i) {
	                el = getSingleElementFromRange(ranges[i]);
	                try {
	                    controlRange.add(el);
	                } catch (ex) {
	                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
	                }
	            }
	            controlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        // Selecting a range
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
	            selProto.removeAllRanges = function () {
	                this.nativeSelection.removeAllRanges();
	                updateEmptySelection(this);
	            };
	
	            var addRangeBackward = function addRangeBackward(sel, range) {
	                addRangeBackwardToNative(sel.nativeSelection, range);
	                sel.refresh();
	            };
	
	            if (selectionHasRangeCount) {
	                selProto.addRange = function (range, direction) {
	                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                        addRangeToControlSelection(this, range);
	                    } else {
	                        if (isDirectionBackward(direction) && selectionHasExtend) {
	                            addRangeBackward(this, range);
	                        } else {
	                            var previousRangeCount;
	                            if (selectionSupportsMultipleRanges) {
	                                previousRangeCount = this.rangeCount;
	                            } else {
	                                this.removeAllRanges();
	                                previousRangeCount = 0;
	                            }
	                            // Clone the native range so that changing the selected range does not affect the selection.
	                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
	                            // issue 80.
	                            var clonedNativeRange = getNativeRange(range).cloneRange();
	                            try {
	                                this.nativeSelection.addRange(clonedNativeRange);
	                            } catch (ex) {}
	
	                            // Check whether adding the range was successful
	                            this.rangeCount = this.nativeSelection.rangeCount;
	
	                            if (this.rangeCount == previousRangeCount + 1) {
	                                // The range was added successfully
	
	                                // Check whether the range that we added to the selection is reflected in the last range extracted from
	                                // the selection
	                                if (api.config.checkSelectionRanges) {
	                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
	                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
	                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
	                                        range = new WrappedRange(nativeRange);
	                                    }
	                                }
	                                this._ranges[this.rangeCount - 1] = range;
	                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
	                                this.isCollapsed = selectionIsCollapsed(this);
	                            } else {
	                                // The range was not added successfully. The simplest thing is to refresh
	                                this.refresh();
	                            }
	                        }
	                    }
	                };
	            } else {
	                selProto.addRange = function (range, direction) {
	                    if (isDirectionBackward(direction) && selectionHasExtend) {
	                        addRangeBackward(this, range);
	                    } else {
	                        this.nativeSelection.addRange(getNativeRange(range));
	                        this.refresh();
	                    }
	                };
	            }
	
	            selProto.setRanges = function (ranges) {
	                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
	                    createControlSelection(this, ranges);
	                } else {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        this.addRange(ranges[i]);
	                    }
	                }
	            };
	        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") && implementsControlRange && useDocumentSelection) {
	
	            selProto.removeAllRanges = function () {
	                // Added try/catch as fix for issue #21
	                try {
	                    this.docSelection.empty();
	
	                    // Check for empty() not working (issue #24)
	                    if (this.docSelection.type != "None") {
	                        // Work around failure to empty a control selection by instead selecting a TextRange and then
	                        // calling empty()
	                        var doc;
	                        if (this.anchorNode) {
	                            doc = getDocument(this.anchorNode);
	                        } else if (this.docSelection.type == CONTROL) {
	                            var controlRange = this.docSelection.createRange();
	                            if (controlRange.length) {
	                                doc = getDocument(controlRange.item(0));
	                            }
	                        }
	                        if (doc) {
	                            var textRange = getBody(doc).createTextRange();
	                            textRange.select();
	                            this.docSelection.empty();
	                        }
	                    }
	                } catch (ex) {}
	                updateEmptySelection(this);
	            };
	
	            selProto.addRange = function (range) {
	                if (this.docSelection.type == CONTROL) {
	                    addRangeToControlSelection(this, range);
	                } else {
	                    api.WrappedTextRange.rangeToTextRange(range).select();
	                    this._ranges[0] = range;
	                    this.rangeCount = 1;
	                    this.isCollapsed = this._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(this, range, false);
	                }
	            };
	
	            selProto.setRanges = function (ranges) {
	                this.removeAllRanges();
	                var rangeCount = ranges.length;
	                if (rangeCount > 1) {
	                    createControlSelection(this, ranges);
	                } else if (rangeCount) {
	                    this.addRange(ranges[0]);
	                }
	            };
	        } else {
	            module.fail("No means of selecting a Range or TextRange was found");
	            return false;
	        }
	
	        selProto.getRangeAt = function (index) {
	            if (index < 0 || index >= this.rangeCount) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            } else {
	                // Clone the range to preserve selection-range independence. See issue 80.
	                return this._ranges[index].cloneRange();
	            }
	        };
	
	        var refreshSelection;
	
	        if (useDocumentSelection) {
	            refreshSelection = function refreshSelection(sel) {
	                var range;
	                if (api.isSelectionValid(sel.win)) {
	                    range = sel.docSelection.createRange();
	                } else {
	                    range = getBody(sel.win.document).createTextRange();
	                    range.collapse(true);
	                }
	
	                if (sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else if (isTextRange(range)) {
	                    updateFromTextRange(sel, range);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else if (isHostMethod(testSelection, "getRangeAt") && _typeof(testSelection.rangeCount) == NUMBER) {
	            refreshSelection = function refreshSelection(sel) {
	                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else {
	                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
	                    if (sel.rangeCount) {
	                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
	                        }
	                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
	                        sel.isCollapsed = selectionIsCollapsed(sel);
	                    } else {
	                        updateEmptySelection(sel);
	                    }
	                }
	            };
	        } else if (selectionHasAnchorAndFocus && _typeof(testSelection.isCollapsed) == BOOLEAN && _typeof(testRange.collapsed) == BOOLEAN && features.implementsDomRange) {
	            refreshSelection = function refreshSelection(sel) {
	                var range,
	                    nativeSel = sel.nativeSelection;
	                if (nativeSel.anchorNode) {
	                    range = getSelectionRangeAt(nativeSel, 0);
	                    sel._ranges = [range];
	                    sel.rangeCount = 1;
	                    updateAnchorAndFocusFromNativeSelection(sel);
	                    sel.isCollapsed = selectionIsCollapsed(sel);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else {
	            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
	            return false;
	        }
	
	        selProto.refresh = function (checkForChanges) {
	            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
	            var oldAnchorNode = this.anchorNode,
	                oldAnchorOffset = this.anchorOffset;
	
	            refreshSelection(this);
	            if (checkForChanges) {
	                // Check the range count first
	                var i = oldRanges.length;
	                if (i != this._ranges.length) {
	                    return true;
	                }
	
	                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
	                // ranges after this
	                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
	                    return true;
	                }
	
	                // Finally, compare each range in turn
	                while (i--) {
	                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        };
	
	        // Removal of a single range
	        var removeRangeManually = function removeRangeManually(sel, range) {
	            var ranges = sel.getAllRanges();
	            sel.removeAllRanges();
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                if (!rangesEqual(range, ranges[i])) {
	                    sel.addRange(ranges[i]);
	                }
	            }
	            if (!sel.rangeCount) {
	                updateEmptySelection(sel);
	            }
	        };
	
	        if (implementsControlRange && implementsDocSelection) {
	            selProto.removeRange = function (range) {
	                if (this.docSelection.type == CONTROL) {
	                    var controlRange = this.docSelection.createRange();
	                    var rangeElement = getSingleElementFromRange(range);
	
	                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
	                    // element contained by the supplied range
	                    var doc = getDocument(controlRange.item(0));
	                    var newControlRange = getBody(doc).createControlRange();
	                    var el,
	                        removed = false;
	                    for (var i = 0, len = controlRange.length; i < len; ++i) {
	                        el = controlRange.item(i);
	                        if (el !== rangeElement || removed) {
	                            newControlRange.add(controlRange.item(i));
	                        } else {
	                            removed = true;
	                        }
	                    }
	                    newControlRange.select();
	
	                    // Update the wrapped selection based on what's now in the native selection
	                    updateControlSelection(this);
	                } else {
	                    removeRangeManually(this, range);
	                }
	            };
	        } else {
	            selProto.removeRange = function (range) {
	                removeRangeManually(this, range);
	            };
	        }
	
	        // Detecting if a selection is backward
	        var selectionIsBackward;
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
	            selectionIsBackward = winSelectionIsBackward;
	
	            selProto.isBackward = function () {
	                return selectionIsBackward(this);
	            };
	        } else {
	            selectionIsBackward = selProto.isBackward = function () {
	                return false;
	            };
	        }
	
	        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
	        selProto.isBackwards = selProto.isBackward;
	
	        // Selection stringifier
	        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
	        // The current spec does not yet define this method.
	        selProto.toString = function () {
	            var rangeTexts = [];
	            for (var i = 0, len = this.rangeCount; i < len; ++i) {
	                rangeTexts[i] = "" + this._ranges[i];
	            }
	            return rangeTexts.join("");
	        };
	
	        function assertNodeInSameDocument(sel, node) {
	            if (sel.win.document != getDocument(node)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
	        selProto.collapse = function (node, offset) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.collapseToPoint(node, offset);
	            this.setSingleRange(range);
	            this.isCollapsed = true;
	        };
	
	        selProto.collapseToStart = function () {
	            if (this.rangeCount) {
	                var range = this._ranges[0];
	                this.collapse(range.startContainer, range.startOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        selProto.collapseToEnd = function () {
	            if (this.rangeCount) {
	                var range = this._ranges[this.rangeCount - 1];
	                this.collapse(range.endContainer, range.endOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
	        // specified so the native implementation is never used by Rangy.
	        selProto.selectAllChildren = function (node) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.selectNodeContents(node);
	            this.setSingleRange(range);
	        };
	
	        selProto.deleteFromDocument = function () {
	            // Sepcial behaviour required for IE's control selections
	            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                var controlRange = this.docSelection.createRange();
	                var element;
	                while (controlRange.length) {
	                    element = controlRange.item(0);
	                    controlRange.remove(element);
	                    dom.removeNode(element);
	                }
	                this.refresh();
	            } else if (this.rangeCount) {
	                var ranges = this.getAllRanges();
	                if (ranges.length) {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        ranges[i].deleteContents();
	                    }
	                    // The spec says nothing about what the selection should contain after calling deleteContents on each
	                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
	                    this.addRange(ranges[len - 1]);
	                }
	            }
	        };
	
	        // The following are non-standard extensions
	        selProto.eachRange = function (func, returnValue) {
	            for (var i = 0, len = this._ranges.length; i < len; ++i) {
	                if (func(this.getRangeAt(i))) {
	                    return returnValue;
	                }
	            }
	        };
	
	        selProto.getAllRanges = function () {
	            var ranges = [];
	            this.eachRange(function (range) {
	                ranges.push(range);
	            });
	            return ranges;
	        };
	
	        selProto.setSingleRange = function (range, direction) {
	            this.removeAllRanges();
	            this.addRange(range, direction);
	        };
	
	        selProto.callMethodOnEachRange = function (methodName, params) {
	            var results = [];
	            this.eachRange(function (range) {
	                results.push(range[methodName].apply(range, params || []));
	            });
	            return results;
	        };
	
	        function createStartOrEndSetter(isStart) {
	            return function (node, offset) {
	                var range;
	                if (this.rangeCount) {
	                    range = this.getRangeAt(0);
	                    range["set" + (isStart ? "Start" : "End")](node, offset);
	                } else {
	                    range = api.createRange(this.win.document);
	                    range.setStartAndEnd(node, offset);
	                }
	                this.setSingleRange(range, this.isBackward());
	            };
	        }
	
	        selProto.setStart = createStartOrEndSetter(true);
	        selProto.setEnd = createStartOrEndSetter(false);
	
	        // Add select() method to Range prototype. Any existing selection will be removed.
	        api.rangePrototype.select = function (direction) {
	            getSelection(this.getDocument()).setSingleRange(this, direction);
	        };
	
	        selProto.changeEachRange = function (func) {
	            var ranges = [];
	            var backward = this.isBackward();
	
	            this.eachRange(function (range) {
	                func(range);
	                ranges.push(range);
	            });
	
	            this.removeAllRanges();
	            if (backward && ranges.length == 1) {
	                this.addRange(ranges[0], "backward");
	            } else {
	                this.setRanges(ranges);
	            }
	        };
	
	        selProto.containsNode = function (node, allowPartial) {
	            return this.eachRange(function (range) {
	                return range.containsNode(node, allowPartial);
	            }, true) || false;
	        };
	
	        selProto.getBookmark = function (containerNode) {
	            return {
	                backward: this.isBackward(),
	                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
	            };
	        };
	
	        selProto.moveToBookmark = function (bookmark) {
	            var selRanges = [];
	            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++];) {
	                range = api.createRange(this.win);
	                range.moveToBookmark(rangeBookmark);
	                selRanges.push(range);
	            }
	            if (bookmark.backward) {
	                this.setSingleRange(selRanges[0], "backward");
	            } else {
	                this.setRanges(selRanges);
	            }
	        };
	
	        selProto.saveRanges = function () {
	            return {
	                backward: this.isBackward(),
	                ranges: this.callMethodOnEachRange("cloneRange")
	            };
	        };
	
	        selProto.restoreRanges = function (selRanges) {
	            this.removeAllRanges();
	            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
	                this.addRange(range, selRanges.backward && i == 0);
	            }
	        };
	
	        selProto.toHtml = function () {
	            var rangeHtmls = [];
	            this.eachRange(function (range) {
	                rangeHtmls.push(DomRange.toHtml(range));
	            });
	            return rangeHtmls.join("");
	        };
	
	        if (features.implementsTextRange) {
	            selProto.getNativeTextRange = function () {
	                var sel, textRange;
	                if (sel = this.docSelection) {
	                    var range = sel.createRange();
	                    if (isTextRange(range)) {
	                        return range;
	                    } else {
	                        throw module.createError("getNativeTextRange: selection is a control selection");
	                    }
	                } else if (this.rangeCount > 0) {
	                    return api.WrappedTextRange.rangeToTextRange(this.getRangeAt(0));
	                } else {
	                    throw module.createError("getNativeTextRange: selection contains no range");
	                }
	            };
	        }
	
	        function inspect(sel) {
	            var rangeInspects = [];
	            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
	            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
	            var name = typeof sel.getName == "function" ? sel.getName() : "Selection";
	
	            if (typeof sel.rangeCount != "undefined") {
	                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
	                }
	            }
	            return "[" + name + "(Ranges: " + rangeInspects.join(", ") + ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
	        }
	
	        selProto.getName = function () {
	            return "WrappedSelection";
	        };
	
	        selProto.inspect = function () {
	            return inspect(this);
	        };
	
	        selProto.detach = function () {
	            actOnCachedSelection(this.win, "delete");
	            deleteProperties(this);
	        };
	
	        WrappedSelection.detachAll = function () {
	            actOnCachedSelection(null, "deleteAll");
	        };
	
	        WrappedSelection.inspect = inspect;
	        WrappedSelection.isDirectionBackward = isDirectionBackward;
	
	        api.Selection = WrappedSelection;
	
	        api.selectionPrototype = selProto;
	
	        api.addShimListener(function (win) {
	            if (typeof win.getSelection == "undefined") {
	                win.getSelection = function () {
	                    return getSelection(win);
	                };
	            }
	            win = null;
	        });
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wait for document to load before initializing
	    var docReady = false;
	
	    var loadHandler = function loadHandler(e) {
	        if (!docReady) {
	            docReady = true;
	            if (!api.initialized && api.config.autoInitialize) {
	                init();
	            }
	        }
	    };
	
	    if (isBrowser) {
	        // Test whether the document has already been loaded and initialize immediately if so
	        if (document.readyState == "complete") {
	            loadHandler();
	        } else {
	            if (isHostMethod(document, "addEventListener")) {
	                document.addEventListener("DOMContentLoaded", loadHandler, false);
	            }
	
	            // Add a fallback in case the DOMContentLoaded event isn't supported
	            addListener(window, "load", loadHandler);
	        }
	    }
	
	    return api;
	}, undefined);

/***/ },
/* 117 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($mdDateLocaleProvider) {
	    $mdDateLocaleProvider.formatDate = function (date) {
	        return moment(date).format('DD/MM/YYYY');
	    };
	};
	
	var moment = __webpack_require__(1);
	
	module.exports = exports['default'];

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (RestangularProvider, $windowProvider) {
	    RestangularProvider.setErrorInterceptor(function (response, deferred, responseHandler) {
	        if (response.status == '401' && (response.data == 'invalid_grant' || response.data.error == 'invalid_grant')) {
	            RemoveData();
	            $windowProvider.$get().location.href = '#/login';
	            return false;
	        }
	    });
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 120 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($mdThemingProvider) {
	    $mdThemingProvider.definePalette('amazingPaletteName', {
	        '50': '337ab7',
	        '100': '337ab7',
	        '200': '337ab7',
	        '300': '337ab7',
	        '400': '337ab7',
	        '500': '337ab7',
	        '600': '337ab7',
	        '700': '337ab7',
	        '800': '337ab7',
	        '900': '337ab7',
	        'A100': '337ab7',
	        'A200': '337ab7',
	        'A400': '337ab7',
	        'A700': '337ab7',
	        'contrastDefaultColor': 'light', // whether, by default, text (contrast)
	        // on this palette should be dark or light
	        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
	        '200', '300', '400', 'A100'],
	        'contrastLightColors': undefined // could also specify this if default was 'dark'
	    });
	    $mdThemingProvider.theme('default').primaryPalette('amazingPaletteName');
	
	    $mdThemingProvider.definePalette('brownPalette', {
	        '50': '795548',
	        '100': '795548',
	        '200': '795548',
	        '300': '795548',
	        '400': '795548',
	        '500': '795548',
	        '600': '5D4037',
	        '700': '5D4037',
	        '800': '4E342E',
	        '900': '4E342E',
	        'A100': 'BCAAA4',
	        'A200': 'BCAAA4',
	        'A400': 'BCAAA4',
	        'A700': 'BCAAA4',
	        'contrastDefaultColor': 'light', // whether, by default, text (contrast)
	        // on this palette should be dark or light
	        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
	        '200', '300', '400', 'A100'],
	        'contrastLightColors': undefined // could also specify this if default was 'dark'
	    });
	    $mdThemingProvider.theme('brown').primaryPalette('brownPalette');
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($provide) {
	    $provide.decorator('maExportToCsvButtonDirective', ['$delegate', function ($delegate) {
	        //$delegate is array of all ng-click directive
	        //in this case first one is angular buildin ng-click
	        //so we remove it.
	        $delegate.shift();
	        return $delegate;
	    }]);
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 122 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (RestangularProvider) {
	    RestangularProvider.addFullRequestInterceptor(function (element, operation, what, url, headers, params, httpConfig) {
	
	        if (['patch', 'put'].indexOf(operation) !== -1) delete element.id;
	
	        if (['post', 'put', 'patch'].indexOf(operation) !== -1 && ['user', 'prenscriptor', 'company'].indexOf(what) !== -1) {
	
	            if (element.workers) {
	                element.workers = element.workers.map(function (obj) {
	                    return obj.id;
	                });
	            }
	
	            if (element.birthday) {
	                var date = new Date(element.birthday);
	                element.birthday = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
	            }
	
	            if (element.training_date) {
	                var _date = new Date(element.training_date);
	                element.trainingDate = _date.getFullYear() + "-" + ("0" + (_date.getMonth() + 1)).slice(-2) + "-" + ("0" + _date.getDate()).slice(-2);
	            }
	
	            if (element.prescriber_type) {
	                element.prescriberType = element.prescriber_type.id;
	            }
	            if (element.training_time) {
	                element.trainingTime = element.training_time;
	            }
	            if (element.postal_code) {
	                element.postalCode = element.postal_code;
	            }
	
	            if (element.prescriber && element.prescriber.id) {
	                element.prescriber = element.prescriber.id;
	            }
	
	            if (element.company && element.company.id) {
	                element.company = element.company.id;
	            }
	            if (element.roles) {
	                element.roles = [element.roles];
	            }
	
	            delete element.company;
	            delete element.training_date;
	            delete element.patients;
	            delete element.subscriptions;
	            delete element.subscription;
	            delete element.created;
	            delete element.prescriber_type;
	            delete element.training_time;
	            delete element.licences;
	            delete element.purchases;
	            delete element.workers;
	            delete element.postal_code;
	            delete element.updated;
	            delete element.points;
	        }
	
	        if (operation == 'post') {
	            if ((typeof element === 'undefined' ? 'undefined' : _typeof(element)) == 'object') {
	                for (var i in element) {
	
	                    if (!element[i]) delete element[i];else if (_typeof(element[i]) == 'object' && element[i]['id'] && element[i]['id'] == 0) delete element[i];
	                }
	            }
	        }
	        if (['post', 'patch'].indexOf(operation) !== -1 && ['event'].indexOf(what) !== -1) {
	            if (element.date) {
	                var _date2 = new Date(element.date);
	                element.date = _date2.getFullYear() + "-" + ("0" + (_date2.getMonth() + 1)).slice(-2) + "-" + ("0" + _date2.getDate()).slice(-2) + " " + ("0" + _date2.getHours()).slice(-2) + ":" + ("0" + _date2.getMinutes()).slice(-2);
	            }
	
	            if (element.location_map) {
	                element.locationMap = element.location_map;
	            }
	
	            delete element.location_map;
	        }
	        if (['post', 'put'].indexOf(operation) !== -1 && ['config', 'variable'].indexOf(what) !== -1) {
	
	            if (element.hardness_initial) {
	                var newValue = {};
	
	                for (var _i in element.hardness_initial) {
	                    newValue[element.hardness_initial[_i].key] = element.hardness_initial[_i].value;
	                }
	
	                element.hardnessInitial = newValue;
	            }
	
	            if (element.modify_variable) {
	                var _newValue = {};
	
	                for (var _i2 in element.modify_variable) {
	                    _newValue[element.modify_variable[_i2].key] = element.modify_variable[_i2].value;
	                }
	
	                element.modifyVariable = _newValue;
	            }
	
	            if (element.modify_relation) {
	                var _newValue2 = {};
	
	                for (var _i3 in element.modify_relation) {
	                    _newValue2[element.modify_relation[_i3].key] = element.modify_relation[_i3].value;
	                }
	
	                element.modifyRelation = _newValue2;
	            }
	
	            if (element.modify_fixed) {
	                element.modifyFixed = element.modify_fixed;
	            }
	
	            if (element.game) {
	                element.game = element.game.id;
	            }
	
	            delete element.hardness_initial;
	            delete element.modify_variable;
	            delete element.modify_relation;
	            delete element.modify_fixed;
	        }
	
	        if (['post', 'put'].indexOf(operation) !== -1 && ['prescriberType'].indexOf(what) !== -1) {
	            delete element.prescribers;
	        }
	
	        if (['post', 'put'].indexOf(operation) !== -1 && ['game'].indexOf(what) !== -1) {
	            if (element.ability) {
	                element.ability = element.ability.id;
	            }
	        }
	
	        if (['post', 'put', 'patch'].indexOf(operation) !== -1 && ['purchase', 'licence', 'subscription', 'product', 'invoice', 'payment'].indexOf(what) !== -1) {
	            if (element.created) {
	                var _date3 = new Date(element.created);
	                element.created = _date3.getFullYear() + "-" + ("0" + (_date3.getMonth() + 1)).slice(-2) + "-" + ("0" + _date3.getDate()).slice(-2);
	            }
	            if (element.updated) {
	                var _date4 = new Date(element.updated);
	                element.updated = _date4.getFullYear() + "-" + ("0" + (_date4.getMonth() + 1)).slice(-2) + "-" + ("0" + _date4.getDate()).slice(-2);
	            }
	            if (element.finalized) {
	                var _date5 = new Date(element.finalized);
	                element.finalized = _date5.getFullYear() + "-" + ("0" + (_date5.getMonth() + 1)).slice(-2) + "-" + ("0" + _date5.getDate()).slice(-2);
	            }
	            if (element.initialize) {
	                var _date6 = new Date(element.initialize);
	                element.initialize = _date6.getFullYear() + "-" + ("0" + (_date6.getMonth() + 1)).slice(-2) + "-" + ("0" + _date6.getDate()).slice(-2);
	            }
	
	            if ('licence'.indexOf(what) !== -1) delete element.gamesvr;
	
	            if (element.licence_type) {
	                element.licenceType = element.licence_type;
	                delete element.licence_type;
	            }
	
	            if (element.licences_type) {
	                element.licencesType = element.licences_type;
	                delete element.licences_type;
	            }
	
	            if (element.purchase_user) {
	                element.purchaseUser = element.purchase_user.id;
	                delete element.purchase_user;
	            }
	
	            delete element.invoice_data;
	            delete element.internal;
	        }
	
	        if (['post', 'put', 'patch'].indexOf(operation) !== -1 && ['invoice', 'payment'].indexOf(what) !== -1) {
	            if (element.product) {
	                element.product = element.product.id;
	            }
	        }
	
	        return { element: element };
	    });
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (RestangularProvider) {
	    RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response) {
	        if (operation == "getList" || operation == "get") {
	            if (data instanceof Array) response.data.map(parse);else response.data = parse(response.data);
	        }
	        return data;
	    });
	};
	
	;
	
	function parse(obj) {
	    if (obj.hardness_initial) {
	        var newValue = [];
	
	        for (var i in obj.hardness_initial) {
	            newValue.push({ key: i, value: obj.hardness_initial[i] });
	        }
	        obj.hardness_initial = newValue;
	    }
	    if (obj.competences) {
	        var newValue = [];
	
	        for (var i in obj.competences) {
	            newValue.push(obj.competences[i].id);
	        }
	        obj.competences = newValue;
	    }
	
	    if (obj.licences_type) {
	        var newValue = [];
	
	        for (var i in obj.licences_type) {
	            newValue.push(obj.licences_type[i].id);
	        }
	        obj.licences_type = newValue;
	    }
	    if (obj.licencesType) {
	        var newValue = [];
	
	        for (var i in obj.licencesType) {
	            newValue.push(obj.licencesType[i].id);
	        }
	        obj.licencesType = newValue;
	    }
	    if (obj.roles) {
	        var newValue = obj.roles[0];
	
	        obj.roles = newValue;
	    }
	    if (obj.modify_variable) {
	        var newValue = [];
	
	        for (var i in obj.modify_variable) {
	            newValue.push({ key: i, value: obj.modify_variable[i] });
	        }
	        obj.modify_variable = newValue;
	    }
	    if (obj.modify_relation) {
	        var newValue = [];
	
	        for (var i in obj.modify_relation) {
	            newValue.push({ key: i, value: obj.modify_relation[i] });
	        }
	        obj.modify_relation = newValue;
	    }
	
	    if (obj.variable) {
	        obj.variable = {
	            id: obj.variable.id,
	            name: obj.variable.name
	        };
	    }
	}
	module.exports = exports["default"];

/***/ },
/* 124 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var moduleName = 'appConstants';
	
	angular.module(moduleName, []).constant('Api', {
	    IMAGES: 'https://educa.brainvt.com/',
	    Public: 'https://educa.brainvt.com/',
	    Path: 'https://educa.brainvt.com/api/',
	    AuthPath: 'https://educa.brainvt.com/oauth/v2/token',
	    ClientId: '8_tc087udzsmook4ok00sk8occgk0w04kkgssgogco0w0sog4c0',
	    ClientSecret: 'spa0m79gsm8k888wswss00gssskkkk8c88kowcc8wcg0ks4gs',
	    TPVURL: 'https://sis-t.redsys.es:25443/sis/realizarPago',
	    IBAN: 'ES84 2100 0254 8602 0044 3515'
	});
	
	exports.default = moduleName;
	module.exports = exports['default'];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var moduleName = 'appControllers';
	
	angular.module(moduleName, []).controller('menuController', ['$scope', '$rootScope', __webpack_require__(126)]).controller('headerController', ['$scope', '$rootScope', '$mdSidenav', '$mdMedia', 'AuthenticationService', '$location', '$translate', __webpack_require__(187)]).controller('purchaseBlockController', ['$scope', '$timeout', '$mdDialog', 'Restangular', 'FlashService', __webpack_require__(200)]).controller('purchaseLicenceBlockController', ['$scope', '$timeout', '$mdDialog', 'Restangular', 'FlashService', __webpack_require__(198)]);
	
	exports.default = moduleName;
	module.exports = exports['default'];

/***/ },
/* 126 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $rootScope) {
	    $scope.isParentActive = function (item) {
	        for (var i in item._children) {
	            if ($rootScope.current_page === item._children[i]) return true;
	        }return $rootScope.toggle_open === item;
	    };
	};
	
	module.exports = exports["default"];

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var moduleName = 'appDirectives';
	
	angular.module(moduleName, []).directive('brandHome', ['$rootScope', __webpack_require__(128)]).directive('languageSwitcher', ['$translate', 'Api', __webpack_require__(136)]).directive('entityShow', ['$location', __webpack_require__(131)]).directive('maExportToCsvButton', __webpack_require__(132)).directive('entityEdit', ['$location', __webpack_require__(130)]).directive('invoiceDownload', ['Restangular', __webpack_require__(133)]).directive('invoiceResend', ['Restangular', 'FlashService', __webpack_require__(135)]).directive('invoicePayment', ['Restangular', 'FlashService', '$location', __webpack_require__(134)]).directive('className', ['$rootScope', __webpack_require__(129)]).directive('maInputArray', __webpack_require__(138)).directive('maAbilities', ['Restangular', '$timeout', __webpack_require__(137)]).directive('menuLink', __webpack_require__(140)).directive('menuToggle', __webpack_require__(141)).directive('maSwitchField', __webpack_require__(139)).directive('dashboardSummary', __webpack_require__(184));
	
	exports.default = moduleName;
	module.exports = exports['default'];

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = brandHome;
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function brandHome($rootScope) {
	    return {
	        scope: {
	            'default': '&'
	        },
	        restrict: 'E',
	        link: function link(scope) {
	            scope.lang = $rootScope.current_language;
	
	            scope.get_lang = function () {
	                return $rootScope.current_language;
	            };
	        },
	        template: '\n            <a href="/?lang={{ get_lang() }}" class="logo"></a>\n            '
	    };
	};
	
	brandHome.$inject = ['$rootScope'];
	module.exports = exports['default'];

/***/ },
/* 129 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($rootScope) {
	    return {
	        restrict: 'A',
	        scope: {},
	        link: function link(scope, elem) {
	            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                var fromClassnames = angular.isDefined(fromState.data) && angular.isDefined(fromState.data.class_name) ? fromState.data.class_name : null;
	                var toClassnames = angular.isDefined(toState.data) && angular.isDefined(toState.data.class_name) ? toState.data.class_name : null;
	
	                // don't do anything if they are the same
	                if (fromClassnames != toClassnames) {
	                    if (fromClassnames) {
	                        elem.removeClass(fromClassnames);
	                    }
	
	                    if (toClassnames) {
	                        elem.addClass(toClassnames);
	                    }
	                }
	            });
	        }
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($location) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            text: '=',
	            id: '=',
	            type: '='
	
	        },
	        link: function link(scope, element) {
	            if (!scope.entity()) scope.entity = {
	                id: scope.id,
	                entity: scope.type
	            };
	        },
	        template: '<a ui-sref="edit(entity)">{{text}}</a>'
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($location) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            text: '=',
	            id: '=',
	            type: '='
	
	        },
	        link: function link(scope, element) {
	            if (!scope.entity()) scope.entity = {
	                id: scope.id,
	                entity: scope.type
	            };
	        },
	        template: '<a ui-sref="show(entity)">{{text}}</a>'
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maExportToCsvButton;
	function maExportToCsvButton($stateParams, Papa, notification, AdminDescription, entryFormatter, ReadQueries) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            label: '@',
	            datastore: '&'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'EXPORT';
	            scope.datastore = scope.datastore();
	            scope.entity = scope.entity();
	            var exportView = scope.entity.exportView();
	            var listView = scope.entity.listView();
	            if (exportView.fields().length === 0) {
	                var exportFields = listView.exportFields();
	                if (exportFields === null) {
	                    exportFields = listView.fields();
	                }
	                exportView.fields(exportFields);
	                exportView.filters(listView.filters());
	                exportView.name(listView.name()); // to enable reuse of sortField
	            }
	            scope.has_export = exportView.fields().length > 0;
	            var formatEntry = entryFormatter.getFormatter(exportView.fields());
	
	            scope.exportToCsv = function () {
	                var rawEntries;
	
	                if (exportView.entity._name.slice(-1) != 's') exportView.url(exportView.entity._name + 's');
	
	                ReadQueries.getAll(exportView, -1, $stateParams.search, $stateParams.sortField, $stateParams.sortDir).then(function (response) {
	                    rawEntries = response.data;
	                    return rawEntries;
	                }).then(function (rawEntries) {
	                    return ReadQueries.getReferenceData(exportView.fields(), rawEntries);
	                }).then(function (referenceData) {
	                    var references = exportView.getReferences();
	                    for (var name in referenceData) {
	                        AdminDescription.getEntryConstructor().createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                            return scope.datastore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                        });
	                    }
	                }).then(function () {
	                    var entries = exportView.mapEntries(rawEntries);
	
	                    // shortcut to diplay collection of entry with included referenced values
	                    scope.datastore.fillReferencesValuesFromCollection(entries, exportView.getReferences(), true);
	
	                    var results = [];
	                    for (var i = entries.length - 1; i >= 0; i--) {
	                        results[i] = formatEntry(entries[i]);
	                    }
	                    var csv = Papa.unparse(results, listView.exportOptions());
	                    var fakeLink = document.createElement('a');
	                    document.body.appendChild(fakeLink);
	
	                    var blobName = scope.entity.name() + '.csv';
	
	                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                        // Manage IE11+ & Edge
	                        var blob = new Blob([csv], { type: 'text/csv' });
	                        window.navigator.msSaveOrOpenBlob(blob, blobName);
	                    } else {
	                        fakeLink.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(csv));
	                        fakeLink.setAttribute('download', blobName);
	                        fakeLink.click();
	                    }
	                }, function (error) {
	                    notification.log(error.message, { addnCls: 'humane-flatty-error' });
	                });
	            };
	        },
	        template: '<span ng-if="has_export">\n    <a class="btn btn-default" ng-click="exportToCsv()">\n        <span class="glyphicon glyphicon-download" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n    </a>\n</span>'
	    };
	}
	
	maExportToCsvButton.$inject = ['$stateParams', 'Papa', 'notification', 'AdminDescription', 'EntryFormatter', 'ReadQueries'];
	module.exports = exports['default'];

/***/ },
/* 133 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (Restangular) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '=',
	            entry: '='
	
	        },
	        link: function link(scope, element) {
	            scope.loading = false;
	
	            scope.viewInvoice = function () {
	                var purchase = scope.entry.values;
	                if (scope.loading) {
	                    return false;
	                }
	
	                scope.loading = true;
	
	                return Restangular.one("invoice", purchase.id).one("pdf").withHttpConfig({ responseType: 'blob' }).get().then(function (data) {
	                    scope.loading = false;
	
	                    data = data.data ? data.data : data;
	
	                    var fileName = 'BrainVt-' + purchase.numeration + '.pdf';
	                    var a = document.createElement('a');
	                    document.body.appendChild(a);
	                    a.style = 'display: none';
	                    var file = new Blob([data], { type: 'application/pdf' });
	                    var fileURL = (window.URL || window.webkitURL).createObjectURL(file);
	
	                    //Open
	                    //window.open(fileURL);
	
	                    // Download
	                    a.href = fileURL;
	                    a.download = fileName;
	                    a.click();
	                    (window.URL || window.webkitURL).revokeObjectURL(data);
	                });
	            };
	        },
	        template: '<a class="btn btn-default" ng-click="viewInvoice()"><i class="fa text-primary" ng-class="{\'fa-spinner fa-pulse\': loading, \'fa-download\': !loading}"></i><md-tooltip>Download Invoice</md-tooltip></a>'
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (Restangular, FlashService, $location) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '=',
	            entry: '='
	
	        },
	        link: function link(scope, element) {
	            scope.loading = false;
	
	            scope.paymentInvoice = function () {
	                var invoice = scope.entry.values;
	                if (scope.loading) {
	                    return false;
	                }
	
	                scope.loading = true;
	
	                return Restangular.one("invoice", invoice.id).one("payment").withHttpConfig({ responseType: 'blob' }).get().then(function (response) {
	                    scope.loading = false;
	                    if (response.status == 204 || response.status == 200) {
	                        FlashService.Success('SUCCESS_PAYMENT');
	
	                        $location.path('/payment/list');
	                    } else {
	                        FlashService.ERROR('ERROR_PAYMENT');
	                    }
	                });
	            };
	        },
	        template: '<a class="btn btn-default" ng-click="paymentInvoice()" ><i class="fa text-warning" ng-class="{\'fa-spinner fa-pulse\': loading, \'fa-refresh\': !loading}"></i><md-tooltip>Create a payment</md-tooltip></a>'
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (Restangular, FlashService) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '=',
	            entry: '='
	
	        },
	        link: function link(scope, element) {
	            scope.loading = false;
	
	            scope.sendInvoice = function () {
	                var invoice = scope.entry.values;
	                if (scope.loading) {
	                    return false;
	                }
	
	                scope.loading = true;
	
	                return Restangular.one("invoice", invoice.id).one("email").withHttpConfig({ responseType: 'blob' }).get().then(function (response) {
	                    scope.loading = false;
	                    if (response.status == 204 || response.status == 200) {
	                        FlashService.Success('SUCCESS_RESEND');
	                    } else {
	                        FlashService.Error('ERROR_RESEND');
	                    }
	                });
	            };
	        },
	        template: '<a class="btn btn-default" ng-click="sendInvoice()" ><i class="fa text-success" ng-class="{\'fa-spinner fa-pulse\': loading, \'fa-paper-plane-o\': !loading}"></i><md-tooltip>Resend Invoice Email</md-tooltip></a>'
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = languageSwitcher;
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function languageSwitcher($translate, Api) {
	    return {
	        scope: {
	            'default': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var lang = Api.LANG_COOKIE || 'lang';
	
	                scope.languages = $translate.getAvailableLanguageKeys();
	
	                if (Cookies.get(lang)) $translate.use(Cookies.get(lang));
	
	                scope.$root.current_language = scope.current = $translate.use();
	
	                scope.flags = {
	                    'en': 'us',
	                    'ca': 'cat'
	                };
	                scope.flags_string = {
	                    'es': 'SPANISH',
	                    'en': 'ENGLISH',
	                    'ca': 'CATALAN'
	                };
	
	                scope.switchLanguage = function (code) {
	                    scope.$root.current_language = scope.current = code;
	                    $translate.use(code);
	                    Cookies.set(lang, code);
	                };
	
	                scope.getFlag = function (code) {
	                    if (scope.flags[code]) return scope.flags[code];
	
	                    return code;
	                };
	
	                scope.getFlagString = function (code) {
	                    if (scope.flags_string[code]) return scope.flags_string[code];
	
	                    return code;
	                };
	            }
	        },
	        template: '\n            <md-menu md-position-mode="target-right target" >\n                <md-button aria-label="Change Language" ng-click="$mdMenu.open($event)">\n                    <span class="flag-icon flag-icon-{{ getFlag(current) | translate }}"></span> {{ getFlagString(current) | translate }}\n                </md-button>\n                <md-menu-content width="4">\n                    <md-menu-item ng-repeat="lang in languages">\n                        <md-button ng-click="switchLanguage(lang)">\n                            <span class="flag-icon flag-icon-{{ getFlag(lang) | translate }}"></span> {{ getFlagString(lang) | translate }}\n                        </md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n'
	    };
	};
	
	languageSwitcher.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maInputArray;
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function maInputArray(Restangular, $timeout) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var field = scope.field();
	                var targetEntity = field.targetEntity();
	                var targetEntityName = targetEntity.name();
	                var targetFields = field.targetFields();
	                var sortField = field.sortField();
	                var sortDir = field.sortDir() === 'DESC' ? -1 : 1;
	                var filterFunc = void 0;
	
	                if (field.permanentFilters()) {
	                    var filters = field.permanentFilters();
	                    var filterKeys = Object.keys(filters);
	                    filterFunc = function filterFunc(entry) {
	                        return filterKeys.reduce(function (isFiltered, key) {
	                            return isFiltered && entry.values[key] === filters[key];
	                        }, true);
	                    };
	                } else {
	                    filterFunc = function filterFunc() {
	                        return true;
	                    };
	                }
	                scope.fields = angular.copy(targetFields);
	                scope.field_games_default = scope.fields.pop();
	                scope.field_games = [];
	                scope.field_no_games = [];
	                scope.timer = [];
	                scope.globalTimer = null;
	                scope.changer = null;
	
	                scope.targetEntity = targetEntity;
	                scope.entries = _Entry2.default.createArrayFromRest(scope.value || [], targetFields, targetEntityName, targetEntity.identifier().name()).sort(function (entry1, entry2) {
	                    // use < and > instead of substraction to sort strings properly
	                    if (entry1.values[sortField] > entry2.values[sortField]) {
	                        return sortDir;
	                    }
	                    if (entry1.values[sortField] < entry2.values[sortField]) {
	                        return -1 * sortDir;
	                    }
	                    return 0;
	                }).filter(filterFunc);
	                scope.addNew = function () {
	                    scope.entries.push(_Entry2.default.createForFields(targetFields));
	                    /*Add new ability with the % of the numTotal of abilities and update the rest*/
	                    var addNewWeight = Math.round(100 / scope.entries.length);
	                    var index = scope.entries.length - 1;
	                    scope.entries[index].values.weight = addNewWeight;
	                    scope.updateWeights(addNewWeight, index);
	                };
	
	                scope.remove = function (entry) {
	                    /*Update rest of abilities on remove*/
	                    scope.entries = scope.entries.filter(function (e) {
	                        return e !== entry;
	                    });
	                    scope.updateWeights(0, null);
	                };
	                scope.$watch('entries', function (newEntries, oldEntries) {
	                    if (newEntries === oldEntries) {
	                        return;
	                    }
	                    scope.value = newEntries.map(function (e) {
	                        return e.transformToRest(targetFields);
	                    });
	                }, true);
	
	                scope.$watch('value', function (newValue, oldValue) {
	                    var _loop = function _loop(i) {
	
	                        newValue[i] = controlValue(newValue[i], i);
	
	                        if (newValue[i] && oldValue[i] && oldValue[i].ability != newValue[i].ability) {
	                            var ability = newValue[i].ability;
	                            scope.updateChoices(ability, i);
	                        }
	
	                        if (newValue[i] && oldValue[i] && oldValue[i].weight != newValue[i].weight) {
	                            var weight = newValue[i].weight;
	
	                            if (scope.timer[i] != null) $timeout.cancel(scope.timer[i]);
	
	                            scope.timer[i] = $timeout(function () {
	                                scope.updateWeights(weight, i);
	                            }, 1000);
	                        }
	                    };
	
	                    for (var i in oldValue) {
	                        _loop(i);
	                    }
	                }, true);
	
	                scope.updateWeights = function (weight, index) {
	
	                    if (scope.changer == null) {
	                        scope.changer = index;
	
	                        $timeout.cancel(scope.globalTimer);
	
	                        scope.globalTimer = $timeout(function () {
	                            updateAllWeight(weight, index);
	                            $timeout(function () {
	                                for (var i = 0; i < scope.entries.length; i++) {
	                                    $timeout.cancel(scope.timer[i]);
	                                }
	                                scope.changer = null;
	                            }, 10);
	                        }, 10);
	                    }
	                };
	
	                function controlValue(newV, index) {
	                    /*control value and restriction of new ability*/
	                    if (newV) {
	
	                        if (newV.weight == 'undefined') {
	                            return scope.entries[index].values.weight = 1;
	                        } else if (isNaN(newV.weight)) {
	                            return scope.entries[index].values.weight = 1;
	                        } else if (!newV.weight) {
	                            return scope.entries[index].values.weight = 1;
	                        } else if (newV.weight < 1) {
	                            scope.entries[index].values.weight = 1;
	                        } else if (newV.weight > 100) {
	                            scope.entries[index].values.weight = 100;
	                        } else if (newV.weight > 0) {
	                            scope.entries[index].values.weight = scope.entries[index].values.weight * 1;
	                            return newV;
	                        } else {
	                            return newV;
	                        }
	                    }
	                }
	
	                function updateAllWeight(weight, index) {
	                    var numEntries = scope.entries.length;
	                    var totalAbilities = 0.0;
	                    var newValues = [];
	                    var value = 0.0;
	
	                    /*total weight of ability*/
	                    for (var i = 0; i < numEntries; i++) {
	                        if (scope.entries[i].values.weight) {
	                            totalAbilities = parseInt(scope.entries[i].values.weight) + totalAbilities;
	                        }
	                    }
	
	                    /*calculate diff in % of totalAbilities - 100 */
	                    if (totalAbilities != 100) {
	                        var totalChangeAbilities = (totalAbilities - 100) / 100;
	                        var difChange = totalAbilities - weight;
	
	                        for (var x = 0; x < numEntries; x++) {
	                            if (x != index) {
	                                newValues[x] = scope.entries[x].values.weight * (100 / difChange);
	                            }
	                        }
	                        /*apply % of the diff in % of total weight to the rest abilities*/
	                        for (var _x = 0; _x < numEntries; _x++) {
	                            if (scope.entries[_x].values.weight != weight) {
	                                value = parseInt(scope.entries[_x].values.weight) - newValues[_x] * totalChangeAbilities;
	                                scope.entries[_x].values.weight = value;
	                                ;
	                            }
	                        }
	                    }
	                }
	
	                function getAge(dateString) {
	                    var today = new Date();
	                    var birthDate = new Date(dateString);
	                    var age = today.getFullYear() - birthDate.getFullYear();
	                    var m = today.getMonth() - birthDate.getMonth();
	                    if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
	                        age--;
	                    }
	                    return age;
	                }
	
	                scope.updateChoices = function (ability, index) {
	                    if (scope.field_games[index]) delete scope.field_games[index];
	
	                    var years = 0;
	
	                    if (scope.$parent.entry.values.birthday) {
	                        years = getAge(scope.$parent.entry.values.birthday);
	                    }
	                    if (scope.$parent.entry.values.maturative) {
	                        years = getAge(scope.$parent.entry.values.maturative);
	                    }
	
	                    Restangular.all('games').getList({ _sortField: "name", _sortDir: "ASC", _filters: '{"ability": ' + ability + ', "age": ' + years + '}' }).then(function (data) {
	                        data = data.data ? data.data : data;
	
	                        if (!data.length) return scope.field_no_games[index] = true;
	
	                        scope.field_games[index] = angular.copy(scope.field_games_default);
	                        scope.field_games[index]._choices = data.map(function (ability) {
	                            return {
	                                value: ability.id,
	                                label: ability.name
	                            };
	                        });
	                        scope.field_no_games[index] = false;
	                    });
	                };
	
	                Restangular.all('abilities').getList({ sort: '["name","DESC"]' }).then(function (abilities) {
	                    scope.abilities = abilities.data.map(function (ability) {
	                        return {
	                            value: ability.id,
	                            label: ability.name
	                        };
	                    });
	                });
	
	                scope.choices = function () {
	                    return scope.abilities;
	                };
	
	                for (var i in scope.entries) {
	                    scope.updateChoices(scope.entries[i].values.ability, i);
	                }
	            }
	        },
	        template: '\n<div class="row input-array">\n    <div class="col-sm-12">\n    <table class="table table-striped">\n        <thead> \n            <tr> \n                <th>{{ \'ABILITY\' | translate }}</th> \n                <th>{{ \'PERCENTAGE\' | translate }}</th> \n                <th></th>\n            </tr>\n        </thead>\n        <tbody ng-repeat="entry in entries track by $index" name="subform_{{$index}}" ng-init="formName = \'subform_\' + $index"> \n            <tr>\n                <td ng-repeat="field in ::fields track by $index">\n                    <ma-choice-field ng-if="field.name() == \'ability\' && abilities" field="::field" value="entry.values[field.name()]" choices="choices()"></ma-choice-field>            \n                    <ma-field ng-if="field.name() == \'weight\'" field="::field" value="entry.values[field.name()]" entry="entry" entity="::targetEntity" form="formName" datastore="::datastore()"></ma-field>\n                </td> \n                <td>\n                    <a class="remove" ng-click="remove(entry)"><span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span>&nbsp;</a>\n                </td>\n            </tr>\n            <tr>\n                <td colspan="3">\n                    <div ng-if="field_no_games[$index]">No games</div>\n                    <ma-choices-field ng-if="field_games[$index]" field="field_games[$index]" value="entry.values[field_games_default.name()]" entry="::entry"></ma-choices-field>      \n                </td>\n            </tr>\n        </tbody>\n    </table>\n    \n    <div class="form-group">\n        <div class="col-sm-12">\n            <a class="btn btn-default" ng-click="addNew()"><span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>&nbsp;<span translate="ADD" translate-values="{ name: field().name() }"></span></a>\n        </div>\n    </div>\n</div>'
	    };
	}
	
	maInputArray.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maInputArray;
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function maInputArray() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'datastore': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var field = scope.field();
	                var targetEntity = field.targetEntity();
	                var targetEntityName = targetEntity.name();
	                var targetFields = field.targetFields();
	                var sortField = field.sortField();
	                var sortDir = field.sortDir() === 'DESC' ? -1 : 1;
	                var filterFunc = void 0;
	
	                if (field.permanentFilters()) {
	                    var filters = field.permanentFilters();
	                    var filterKeys = Object.keys(filters);
	                    filterFunc = function filterFunc(entry) {
	                        return filterKeys.reduce(function (isFiltered, key) {
	                            return isFiltered && entry.values[key] === filters[key];
	                        }, true);
	                    };
	                } else {
	                    filterFunc = function filterFunc() {
	                        return true;
	                    };
	                }
	                scope.fields = targetFields;
	                scope.targetEntity = targetEntity;
	                scope.entries = _Entry2.default.createArrayFromRest(scope.value || [], targetFields, targetEntityName, targetEntity.identifier().name()).sort(function (entry1, entry2) {
	                    // use < and > instead of substraction to sort strings properly
	                    if (entry1.values[sortField] > entry2.values[sortField]) {
	                        return sortDir;
	                    }
	                    if (entry1.values[sortField] < entry2.values[sortField]) {
	                        return -1 * sortDir;
	                    }
	                    return 0;
	                }).filter(filterFunc);
	                scope.addNew = function () {
	                    return scope.entries.push(_Entry2.default.createForFields(targetFields));
	                };
	                scope.remove = function (entry) {
	                    scope.entries = scope.entries.filter(function (e) {
	                        return e !== entry;
	                    });
	                };
	                scope.$watch('entries', function (newEntries, oldEntries) {
	                    if (newEntries === oldEntries) {
	                        return;
	                    }
	                    scope.value = newEntries.map(function (e) {
	                        return e.transformToRest(targetFields);
	                    });
	                }, true);
	            }
	        },
	        template: '\n<div class="row input-array">\n    <div class="col-sm-12">\n    <table class="table table-striped">\n        <thead> \n            <tr> \n                <th ng-repeat="field in ::fields track by $index">{{ field._name }}</th> \n                <th></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr ng-repeat="entry in entries track by $index" name="subform_{{$index}}" ng-init="formName = \'subform_\' + $index">\n                <td ng-repeat="field in ::fields track by $index">\n                    <ma-field field="::field" value="entry.values[field.name()]" entry="entry" entity="::targetEntity" form="formName" datastore="::datastore()"></ma-field>\n                </td> \n                <th>\n                    <a class="remove" ng-click="remove(entry)"><span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span>&nbsp;</a>\n                </th>\n            </tr>\n        </tbody>\n    </table>\n    \n    <div class="form-group">\n        <div class="col-sm-12">\n            <a class="btn btn-default" ng-click="addNew()"><span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>&nbsp;<span translate="Add" translate-values="{ name: field().name() }"></span></a>\n        </div>\n    </div>\n</div>'
	    };
	};
	
	maInputArray.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maSwitchField;
	
	var _Entry = __webpack_require__(8);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function maSwitchField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'datastore': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {}
	        },
	        template: '\n <md-switch class="md-primary" md-no-ink  ng-model="value"> </md-switch>\n'
	    };
	};
	
	maSwitchField.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maInputArray;
	function maInputArray($location, $filter) {
	    return {
	        scope: {
	            item: '='
	        },
	        link: function link(scope, element) {
	            var controller = scope.$root;
	
	            scope.focusSection = function () {
	                //controller.toggle_open = null;
	                controller.current_page = scope.item;
	            };
	            scope.isActive = function () {
	                if (scope.item.isActive($location.absUrl())) {
	                    controller.current_page = scope.item;
	                    return scope.item.isActive($location.absUrl());
	                }
	
	                return controller.current_page === scope.item;
	            };
	            scope.link = function (link) {
	
	                link = $filter('translate')(link);
	
	                if (link.indexOf('http') > -1) {
	                    return link;
	                } else {
	                    return '#' + link;
	                }
	            };
	            scope.target = function (link) {
	                link = $filter('translate')(link);
	
	                if (link.indexOf('http') > -1) {
	                    return '_blank';
	                }
	            };
	        },
	        template: '\n            <md-button ui-sref-active="active" href="{{ link(item._link) }}" target="{{ target(item._link) }}" ng-click="focusSection()" ng-class="{\'active\': isActive()}">\n                <span ng-bind-html="item._icon"></span>\n                {{ item._title | translate }}\n            </md-button>\n        '
	    };
	};
	
	maInputArray.$inject = ['$location', '$filter'];
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maInputArray;
	function maInputArray() {
	    return {
	        scope: {
	            item: '='
	        },
	        link: function link(scope, element) {
	            var controller = scope.$parent;
	
	            scope.isOpen = function () {
	                return controller.isParentActive(scope.item);
	            };
	            scope.toggle = function () {
	                scope.$root.toggle_open = scope.$root.toggle_open === scope.item ? null : scope.item;
	            };
	        },
	        template: '\n            <md-button class="md-button-toggle" ng-click="toggle()"\n                aria-expanded="true">\n                <span aria-hidden="true" class="pull-right caret" ng-class="{\'toggled\' : isOpen()}"></span>\n                <span ng-bind-html="item._icon"></span>\n                {{item._title | translate}}\n            </md-button>\n            <ul ng-show="isOpen()" id="docs-menu-{{item._title | nospace}}" class="menu-toggle-list">\n                <li ng-repeat="subitem in item._children">\n                    <menu-link item="subitem"></menu-link>\n                </li>\n            </ul>\n        '
	    };
	};
	
	maInputArray.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('ability').label('Abilities');
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'), nga.field('competences', 'reference_many').label('COMPETENCES').targetEntity(nga.entity('competence').url('competences')).targetField(nga.field('name')).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }), nga.field('games').label('GAMES').template('<ma-filtered-list-button label="{{ value }}" entity-name="game" ' + 'filter="{  ability: entry.values.id }" size="xs"></ma-filtered-list-button>')]).sortDir('asc').url('abilities').prepare(['Restangular', 'datastore', 'entries', 'Entry', function (Restangular, datastore, entries, Entry) {
	        return Restangular.all('games').getList().then(function (data) {
	            data = data.data ? data.data : data;
	
	            entries.forEach(function (e, i) {
	                e.values.games = 0;
	
	                data.forEach(function (i, ii) {
	                    if (i.ability && i.ability.id == e.values.id) e.values.games++;
	                });
	            });
	        });
	    }]);
	
	    if (HasRole('admin')) {
	        entity.showView().fields([nga.field('id').label('ID'), nga.field('name').label('NAME'), nga.field('competences', 'reference_many').label('COMPETENCES').targetEntity(nga.entity('competence').url('competences')).targetField(nga.field('name')).singleApiCall(function (ids) {
	            return { 'id': ids };
	        }), nga.field('games', 'referenced_list').label('PROCEDURES').targetEntity(nga.entity('game').url('games')).targetReferenceField('ability').targetFields([nga.field('id').label('ID').isDetailLink(true), nga.field('name').label('NAME').isDetailLink(true).map(function truncate(value, entry) {
	            return entry['name'];
	        })])]);
	
	        entity.creationView().fields([nga.field('name').label('NAME'), nga.field('competences', 'reference_many').label('COMPETENCES').targetEntity(nga.entity('competence').url('competences')).targetField(nga.field('name'))]);
	
	        entity.editionView().fields(entity.creationView().fields());
	        entity.deletionView();
	    }
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var entity = admin.getEntity('company').updateMethod('patch').label('company').url(function (entity, view, id) {
	        if (id) return 'user/' + encodeURIComponent(id);
	
	        return 'user';
	    });
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('COMPANY').isDetailLink(true).detailLinkRoute('show'), nga.field('subscription').label('SUBSCRIPTION').sortable(false), nga.field('last', 'date').label('LAST_ASSINGED').format('yyyy-MM-dd').sortable(false)]).listActions(['show', 'edit', 'delete']).sortDir('asc').url('companies').title('Companies').prepare(['Restangular', 'datastore', 'entries', 'Entry', function (Restangular, datastore, entries, Entry) {
	        return Restangular.all('subscriptions').getList().then(function (data) {
	            data = data.data ? data.data : data;
	
	            entries.forEach(function (u, i) {
	                u.values.sub_active = [];
	                u.values.sub_unactive = [];
	                u.values.last = null;
	
	                data.forEach(function (s, si) {
	                    if (s.purchaseUser && u.values.id == s.purchaseUser.id) {
	                        if (!s.user && !s.finalize) {
	                            u.values.sub_unactive.push(s);
	                        } else if (!s.finalize || new Date(s.finalize).getTime() >= new Date().getTime()) {
	                            u.values.sub_active.push(s);
	                        }
	
	                        if (!u.values.last || s.updated > u.values.last) {
	                            u.values.last = s.updated;
	                        }
	                        if (u.values.sub_active.length && (!u.values.last || s.created > u.values.last)) {
	                            u.values.last = s.created;
	                        }
	                    }
	                });
	
	                u.values.subscription = u.values.sub_active.length + " / " + u.values.sub_unactive.length;
	            });
	
	            return true;
	        });
	    }]);
	
	    var fields = [nga.field('username').label('COMPANY'), nga.field('email', 'email').label('EMAIL'), nga.field('name').label('NAME'), nga.field('surname').label('SURNAME'), nga.field('enabled', 'boolean').label('ENABLED')];
	
	    if (HasRole('admin')) {
	        fields.push(nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'));
	        fields.push(nga.field('roles').label('ROLES'));
	
	        fields.push(nga.field('prescriber').map(function (value, entry) {
	            if (entry['prescriber.name']) return entry['prescriber.name'] + ' ' + (entry['prescriber.surname'] ? entry['prescriber.surname'] : '');
	        }).template('<entity-show type="\'user\'" id="entry.values[\'prescriber.id\']" text="value"></entity-show>').label('PRESCRIBER').cssClasses(function (entry) {
	            if (!entry.values.prescriber) return 'hidden';
	        }));
	        fields.push(nga.field('company').map(function (value, entry) {
	            if (entry['company.name']) return entry['company.name'] + ' ' + (entry['company.surname'] ? entry['company.surname'] : '');
	        }).template('<entity-show type="\'user\'" id="entry.values[\'company.id\']" text="value"></entity-show>').label('COMPANY'));
	        fields.push(nga.field('workers', 'referenced_list').label('WORKERS').targetEntity(nga.entity('user').url('users')).targetReferenceField('company').targetFields([nga.field('id').label('ID'), nga.field('name').label('NAME').isDetailLink(true), nga.field('surname').label('COMPANY').isDetailLink(true)]));
	        fields.push(nga.field('patients', 'referenced_list').label('PATIENTS').targetEntity(nga.entity('user').url('users')).targetReferenceField('prescriber').targetFields([nga.field('id').label('ID'), nga.field('name').label('NAME').isDetailLink(true), nga.field('surname').label('SURNAME').isDetailLink(true)]));
	
	        fields.push(nga.field('cif').label('CIF'));
	        fields.push(nga.field('address').label('ADDRESS'));
	        fields.push(nga.field('city').label('CITY'));
	        fields.push(nga.field('postal_code').label('POSTAL_CODE'));
	        fields.push(nga.field('state.name').label('STATE'));
	    }
	    if (HasRole('company')) {
	        fields.push(nga.field('prescriber_type.description').label('PRESCRIBER_TYPE'));
	        fields.push(nga.field('patients', 'referenced_list').label('PATIENTS').targetEntity(nga.entity('user').url('users')).targetReferenceField('prescriber').targetFields([nga.field('id').label('ID'), nga.field('name').label('NAME').isDetailLink(true), nga.field('surname').label('SURNAME').isDetailLink(true)]));
	    }
	    if (HasRole('prenscriptor')) {
	        fields.push(nga.field('birthday', 'date').label('BIRTHDAY').format('yyyy-MM-dd'));
	        fields.push(nga.field('training_time').label('TRAINING_TIME_MIN'));
	        fields.push(nga.field('training_date', 'date').format('yyyy-MM-dd').label('TRAINING_TIME'));
	        fields.push(nga.field('abilities', 'reference_many').label('ABILITIES').targetEntity(nga.entity('ability').url('abilities')).targetField(nga.field('name')).singleApiCall(function (ids) {
	            return null;
	        }).map(function (value, entry) {
	            if (entry.formatedAB) return entry.formatedAB;
	
	            return entry.formatedAB = value.map(function (ability) {
	                return ability.ability;
	            });
	        }));
	    }
	
	    entity.showView().fields(fields).prepare(['Restangular', 'datastore', function (Restangular, datastore) {
	        var _this = this;
	
	        if (HasRole('admin', 'superadmin')) return false;
	
	        return Restangular.all('licences').getList().then(function (data) {
	            data = data.data ? data.data : data;
	
	            var licences_pro = [];
	
	            data.forEach(function (licence, index) {
	                if (licence.type == 'gold') {
	                    licences_pro.push(licence);
	                }
	            });
	
	            if (!licences_pro.length) {
	                var _fields = _this.fields();
	                var remove = [];
	
	                _fields.forEach(function (field, index) {
	                    if (['training_time', 'training_date', 'abilities'].indexOf(field._name) !== -1) {
	                        remove.push(index);
	                    }
	                });
	
	                remove.reverse().forEach(function (index, i) {
	                    _fields.splice(index, 1);
	                });
	            }
	        });
	    }]);
	
	    fields = [nga.field('username').label('USERNAME'), nga.field('email', 'email').label('EMAIL'),
	    //nga.field('plainPassword', 'password').label('PASSWORD'),
	    nga.field('name').label('NAME'), nga.field('surname').label('SURNAME'), nga.field('enabled', 'boolean').label('ENABLED').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>')];
	
	    if (HasRole('admin')) {
	        fields.push(nga.field('roles', 'choice').label('ROLES').choices([{ label: 'COMPANY', value: 'ROLE_COMPANY' }, { label: 'PRENSCRIPTOR', value: 'ROLE_PRENSCRIPTOR' }, { label: 'PATINET', value: 'ROLE_PATIENT' }]));
	        fields.push(nga.field('prescriber', 'reference').label('PRESCRIBER').map(function truncate(value, entry) {
	            return entry['prescriber.id'];
	        }).targetEntity(nga.entity('user').url('users')).targetField(nga.field('name')));
	        fields.push(nga.field('company', 'reference').label('COMPANY').map(function truncate(value, entry) {
	            return entry['company.id'];
	        }).targetEntity(nga.entity('company').url('companies')).targetField(nga.field('name')));
	
	        fields.push(nga.field('cif').label('CIF'));
	        fields.push(nga.field('address').label('ADDRESS'));
	        fields.push(nga.field('city').label('CITY'));
	        fields.push(nga.field('postal_code').label('POSTAL_CODE'));
	        fields.push(nga.field('state', 'reference').label('STATE').map(function truncate(value, entry) {
	            return entry['state.id'];
	        }).perPage(0).targetEntity(nga.entity('state').url('states')).targetField(nga.field('name')).singleApiCall(function (ids) {
	            return null;
	        }));
	    }
	    if (HasRole('company')) {
	        fields.push(nga.field('prescriber_type.id', 'reference').label('PRESCRIBER_TYPE').map(function truncate(value, entry) {
	            return entry['prescriber_type.id'];
	        }).targetEntity(nga.entity('prescriberType').url('prescriberTypes')).targetField(nga.field('description')));
	    }
	    entity.creationView().fields(fields).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function (error, form, progression, notification, $filter) {
	        $(':input').each(function () {
	            $(this).closest('.form-field').removeClass('has-error').find('.help-block.error').remove();
	        });
	
	        error.data.fields.forEach(function (error, index) {
	            var input = $('[name=' + error.property_path + ']');
	            $('<span class="help-block error">' + error.message + '</span>').insertAfter(input);
	            input.closest('.form-field').addClass('has-error');
	        });
	
	        form['email'].$valid = false;
	
	        progression.done();
	
	        notification.log($filter('translate')('INVALID_DETAILS_IN_FORM'), { addnCls: 'humane-flatty-error' });
	
	        return true;
	    }]).prepare(entity.showView().prepare());
	
	    entity.editionView().fields(entity.creationView().fields()).onSubmitError(entity.creationView().onSubmitError()).prepare(entity.showView().prepare());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('competence').label('COMPETENCES');
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'), nga.field('description').label('DESCRIPTION').isDetailLink(true).detailLinkRoute('show')]
	    /*nga.field('abilities')
	        .label('ABILITIES')
	        .template('<ma-filtered-list-button label="{{ value }}" entity-name="ability" ' +
	            'filter="{  competences: entry.values.id }" size="xs"></ma-filtered-list-button>')*/
	    ).sortDir('asc').url('competences');
	    /*.prepare(['Restangular', 'datastore', 'entries', 'Entry', function (Restangular, datastore, entries, Entry) {
	        return Restangular
	            .all('abilities')
	            .getList()
	            .then(function (data) {
	                data = data.data ? data.data : data;
	                 entries.forEach(function (e, i) {
	                    e.values.abilities = 0;
	                     data.forEach(function (i, ii) {
	                        if (i.competences && i.competences.indexOf(e.values.id) >= 0 )
	                            e.values.abilities++;
	                    });
	                })
	            });
	    }]);*/
	
	    if (HasRole('admin')) {
	        entity.showView().fields([nga.field('id').label('ID'), nga.field('name').label('NAME'), nga.field('description').label('DESCRIPTION')]
	        /*
	        nga.field('abilities', 'referenced_list').label('ABILITIES')
	            .targetEntity(nga.entity('ability').url('abilities'))
	            .targetReferenceField('competences')
	            .targetFields([
	                nga.field('id').label('ID').isDetailLink(true),
	                nga.field('name').label('NAME').isDetailLink(true)
	                    .map(function truncate(value, entry) {
	                        return entry['name'];
	                    })
	            ])*/
	
	        );
	
	        entity.creationView().fields([nga.field('name').label('NAME'), nga.field('description').label('DESCRIPTION')]);
	
	        entity.editionView().fields(entity.creationView().fields());
	        entity.deletionView();
	    }
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 145 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('config').label('Configs');
	
	    entity.listView().fields([nga.field('id').isDetailLink(true), nga.field('variable.name').isDetailLink(true)]).sortDir('asc').url('configs');
	
	    entity.creationView().fields([nga.field('game.id', 'reference').label('Game').map(function truncate(value, entry) {
	        return entry['game.id'];
	    }).targetEntity(nga.entity('game').url('games')).targetField(nga.field('name')), nga.field('variable', 'reference').map(function truncate(value, entry) {
	        return entry['variable.id'];
	    }).targetEntity(nga.entity('variable').url('variables')).targetField(nga.field('name')).perPage(0).remoteComplete(true, {
	        refreshDelay: 200,
	        searchQuery: function searchQuery(search) {
	            return { q: search };
	        }
	    }), nga.field('max'), nga.field('min'), nga.field('modify_fixed'), nga.field('steps')]);
	
	    entity.creationView().fields(nga.field('modify_relation', 'embedded_list').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('Percentage'), nga.field('value')]).template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'), nga.field('modify_variable', 'embedded_list').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('Percentage'), nga.field('value')]).template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'), nga.field('hardness_initial', 'embedded_list').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('Group'), nga.field('value').label('Hardness')]).template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array')).onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function (progression, notification, $state, entry, entity) {
	        progression.done();
	
	        notification.log('Element #' + entry._identifierValue + ' successfully created.', { addnCls: 'humane-flatty-success' });
	
	        $state.go($state.get('show'), { entity: 'game', id: entry.values['game.id'] });
	
	        return false;
	    }]);
	
	    entity.editionView().fields(entity.creationView().fields());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin, Api) {
	    var entity = admin.getEntity('event').updateMethod('patch').label('EVENTS');
	    //.readOnly();
	
	    entity.listView().fields([nga.field('id').detailLinkRoute('show').isDetailLink(true), nga.field('name').label('NAME').detailLinkRoute('show').isDetailLink(true), nga.field('location').label('LOCATION').detailLinkRoute('show').isDetailLink(true), nga.field('date', 'date').label('DATE').label('DATE').format('yyyy-MM-dd / HH:mm'), nga.field('interested').label('INTERESTED').template('<ma-filtered-list-button label="{{ value }}" entity-name="interested" ' + 'filter="{  event: entry.values.id }" size="xs"></ma-filtered-list-button>')]).sortDir('asc').url('events').prepare(['Restangular', 'datastore', 'entries', 'Entry', function (Restangular, datastore, entries, Entry) {
	        return Restangular.all('interesteds').getList({ _sortDir: "ASC", _sortField: "created" }).then(function (data) {
	            data = data.data ? data.data : data;
	
	            entries.forEach(function (e, i) {
	                e.values.interested = 0;
	
	                data.forEach(function (i, ii) {
	                    if (i.event && i.event.id == e.values.id) e.values.interested++;
	                });
	            });
	        });
	    }]);
	
	    entity.showView().fields([nga.field('name').label('NAME'), nga.field('description').label('DESCRIPTION'), nga.field('date', 'date').label('DATE').format('yyyy-MM-dd / HH:mm'), nga.field('image').label('IMAGE').template('<img src="/uploads/events/{{ entry.values[\'image\'] }}" style="max-width: 100%;"/>'), nga.field('location').label('LOCATION'), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'), nga.field('updated', 'date').label('UPDATED').format('yyyy-MM-dd'), nga.field('email').label('EMAIL'), nga.field('interested', 'referenced_list').label('INTERESTED').targetEntity(nga.entity('interested').url('interesteds')).targetReferenceField('event').targetFields([nga.field('name').label('NAME').detailLinkRoute('show').isDetailLink(false), nga.field('surname').label('SURNAME').detailLinkRoute('show').isDetailLink(false), nga.field('email').label('EMAIL').detailLinkRoute('show').isDetailLink(false), nga.field('phone').label('PHONE').detailLinkRoute('show').isDetailLink(false)]), nga.field('').label('').template('<ma-filtered-list-button label="See all related interested" entity-name="interested" ' + 'filter="{  event: entry.values.id }" size="sm" class="pull-right"></ma-filtered-list-button>')]);
	
	    entity.creationView().fields([nga.field('name').label('NAME'), nga.field('description', 'text').label('DESCRIPTION'), nga.field('date', 'datetime').format('yyyy-MM-dd HH:mm').label('DATE').map(ParseDate), nga.field('image', 'file').label('IMAGE').uploadInformation({ 'url': Api.Path + 'event/upload', 'apifilename': 'file' }), nga.field('location').label('LOCATION'), nga.field('email').label('EMAIL'), nga.field('created', 'date').label('CRETED').format('yyyy-MM-dd').map(ParseDate), nga.field('updated', 'date').label('UPDATED').format('yyyy-MM-dd').map(ParseDate), nga.field('location_map').label('LOCATION_MAP')]);
	
	    entity.editionView().fields(entity.creationView().fields());
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('game').label('Game');
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'), nga.field('ability.name').label('ABILITY').label('ABILITY').isDetailLink(true).detailLinkRoute('show'), nga.field('weight').label('WEIGHT').isDetailLink(true).detailLinkRoute('show'), nga.field('gold', 'boolean').label('VISIBLE_AUTOMATIC'), nga.field('age')]).sortDir('asc').url('games');
	
	    entity.showView().fields([nga.field('id').label('ID'), nga.field('name').label('NAME'), nga.field('description').label('DESCRIPTION'), nga.field('weight').label('WEIGHT'), nga.field('gold', 'boolean').label('VISIBLE_AUTOMATIC'), nga.field('age'), nga.field('ability.name').label('ABILITY').label('ABILITY'), nga.field('variables', 'referenced_list').label('VARIABLES').targetEntity(nga.entity('config').url('configs')).targetReferenceField('game').targetFields([nga.field('id').label('ID').isDetailLink(false), nga.field('variable').label('VARIABLE').map(function truncate(value, entry) {
	        return entry['variable.name'];
	    })]), nga.field('').label('').template('<ma-create-button entity-name="config" size="sm" label="Add related variable" default-values="{ \'game.id\': entry.values.id }" class="pull-right"> </ma-create-button><ma-filtered-list-button label="See all related variable" entity-name="config" filter="{  game: entry.values.id }" size="sm" class="pull-right">')]).actions(['<a class="btn btn-default" ui-sref="gameTest({id: entry.values.id})"><span class="glyphicon glyphicon-wrench" aria-hidden="true"></span>&nbsp;<span class="hidden-xs ng-scope" translate="Test">Test</span></a>', 'list', 'edit', 'delete']);
	
	    entity.creationView().fields([nga.field('name').label('NAME'), nga.field('description').label('DESCRIPTION'), nga.field('weight').label('WEIGHT'), nga.field('age', 'number'), nga.field('gold', 'boolean').label('VISIBLE_AUTOMATIC').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'), nga.field('ability.id', 'reference').label('ABILITY').map(function truncate(value, entry) {
	        return entry['ability.id'];
	    }).targetEntity(nga.entity('ability').url('abilities')).targetField(nga.field('name'))]);
	
	    entity.editionView().fields(entity.creationView().fields());
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('gamevr').label('GAMEVR');
	
	    entity.listView().title('GAMEVR').fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'), nga.field('included', 'boolean').label('INCLUDED')]).sortDir('asc').url('gamevrs');
	
	    entity.showView().fields([nga.field('id').label('ID'), nga.field('name').label('NAME'), nga.field('description').label('DESCRIPTION'), nga.field('included', 'boolean').label('INCLUDED')]);
	
	    entity.creationView().fields([nga.field('name').label('NAME'), nga.field('description').label('DESCRIPTION'), nga.field('included', 'boolean').label('INCLUDED').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>')]);
	
	    entity.editionView().fields(entity.creationView().fields());
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 149 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('gamevrlicence').label('LICENCES_GAME_VR').url(function (entity, view, id) {
	        if (id) return 'gamevr/licence/' + encodeURIComponent(id);
	
	        return 'gamevr/licence';
	    });
	
	    var pad = function pad(n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true), nga.field('licence').label('LICENCE').map(function (value, entry) {
	        return entry['licence.licence'];
	    }).template('<entity-show type="\'licence\'" id="entry.values[\'licence.id\']" text="value"></entity-show>'), nga.field('gamevr').label('GAMEVR').map(function (value, entry) {
	        return entry['gamevr.name'];
	    }).template('<entity-show type="\'gamevr\'" id="entry.values[\'gamevr.id\']" text="value"></entity-show>'), nga.field('purchase.order').label('ORDER').isDetailLink(true).template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd')]).sortDir('ASC').url('gamevr/licences');
	
	    entity.creationView().fields([nga.field('gamevr', 'reference').map(function (value, entry) {
	        return entry['gamevr.id'];
	    }).targetEntity(nga.entity('game').url('gamevrs')).targetField(nga.field('name')).perPage(0), nga.field('licence', 'reference').map(function (value, entry) {
	        return entry['licence.id'];
	    }).targetEntity(nga.entity('licence').url('licences')).targetField(nga.field('licence')).perPage(0), nga.field('purchase', 'reference').map(function (value, entry) {
	        return entry['purchase.id'];
	    }).targetEntity(nga.entity('purchase').url('purchases')).targetField(nga.field('order').map(function (value, entry) {
	        var date = ParseDate(entry['created']);
	
	        if (date) return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['id'], 4);
	    })).perPage(0), nga.field('created', 'date').format('yyyy-MM-dd').map(ParseDate)]).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function (error, form, progression, notification, $filter) {
	
	        $(':input').each(function () {
	            $(this).closest('.form-field').removeClass('has-error').find('.help-block.error').remove();
	        });
	
	        error.data.fields.forEach(function (error, index) {
	            var input = $('[name=' + error.property_path + ']');
	            $('<span class="help-block error">' + error.message + '</span>').insertAfter(input);
	            input.closest('.form-field').addClass('has-error');
	        });
	
	        progression.done();
	
	        notification.log($filter('translate')('INVALID_DETAILS_IN_FORM'), { addnCls: 'humane-flatty-error' });
	
	        return true;
	    }]);
	
	    entity.editionView().fields(entity.creationView().fields()).onSubmitError(entity.creationView().onSubmitError());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 150 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('interested').label('INTERESTED');
	    //.readOnly();
	
	    entity.listView().fields([nga.field('name').label('NAME').detailLinkRoute('show').isDetailLink(true), nga.field('surname').label('SURNAME').detailLinkRoute('show').isDetailLink(true), nga.field('email').label('EMAIL').detailLinkRoute('show').isDetailLink(true), nga.field('phone').label('PHONE').detailLinkRoute('show').isDetailLink(true), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd / HH:mm')]).sortDir('asc').url('interesteds');
	
	    entity.showView().fields([nga.field('id'), nga.field('name').label('NAME'), nga.field('surname').label('SURNAME'), nga.field('email').label('EMAIL'), nga.field('phone').label('PHONE'), nga.field('comment').label('COMMENT'), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd / HH:mm')]);
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('invoice')
	    //.updateMethod('patch')
	    .label('invoice');
	
	    var pad = function pad(n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    entity.listView().fields([nga.field('numeration').label('NUMERATION'), nga.field('owner').label('OWNER').map(function (value, entry) {
	        return entry['owner.name'] + ' ' + (entry['owner.surname'] || '');
	    }).template('<entity-show type="\'user\'" id="entry.values[\'owner.id\']" text="value"></entity-show>'), nga.field('status').label('STATUS'), nga.field('product_name').label('PRODUCT'), nga.field('price').label('PRICE'), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd')]).url('invoices').permanentFilters({
	        payment: false
	    }).listActions(['<invoice-download entry="entry" entity="entity"/>', '<invoice-resend entry="entry" entity="entity"/>', 'edit', 'delete', '<invoice-payment entry="entry" entity="entity"/>']).filters([nga.field('q', 'template').label('').pinned(true).template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search order" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'), nga.field('status', 'choice').choices([{ label: 'active', value: '1' }, { label: 'inactive', value: '0' }])]);
	
	    entity.editionView().fields([nga.field('numeration').label('NUMERATION'), nga.field('payment', 'boolean').label('PAYMENT').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'), nga.field('owner', 'reference').map(function (value, entry) {
	        return entry['owner.id'];
	    }).targetEntity(nga.entity('professional').url('professionals')).targetField(nga.field('name')).perPage(0), nga.field('status').label('STATUS'), nga.field('created', 'date').format('yyyy-MM-dd').map(ParseDate), nga.field('updated', 'date').format('yyyy-MM-dd').map(ParseDate), nga.field('purchase', 'reference').map(function (value, entry) {
	        return entry['purchase.id'];
	    }).targetEntity(nga.entity('purchase').url('purchases')).targetField(nga.field('order')).perPage(0), nga.field('product_name').label('PRODUCT'), nga.field('price').label('PRICE')]);
	
	    entity.creationView().fields(entity.editionView().fields());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('licence').updateMethod('patch').label('Licences');
	
	    var pad = function pad(n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('licence').label('LICENCE').isDetailLink(true).detailLinkRoute('show'), nga.field('user').label('USER').map(function (value, entry) {
	        return entry['user.name'] + ' ' + (entry['user.surname'] || '');
	    }).template('<entity-show type="\'user\'" id="entry.values[\'user.id\']" text="value"></entity-show>'), nga.field('purchase.order').label('ORDER').isDetailLink(true).template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'), nga.field('type.name').label('TYPE').isDetailLink(true).template('<entity-edit type="\'licencetype\'" id="entry.values[\'type.id\']" text="value"></entity-edit>'), nga.field('finalized', 'date').label('FINALIZED').format('yyyy-MM-dd'), nga.field('identifier').label('IDENTIFIER'), nga.field('ip').label('IP'), nga.field('promo', 'boolean').label('PROMO')]).sortDir('ASC').url('licences');
	
	    entity.showView().fields(nga.field('id').label('ID'), nga.field('licence').label('LICENCE'), nga.field('user').label('USER').map(function (value, entry) {
	        return entry['user.name'] + ' ' + (entry['user.surname'] || '');
	    }).template('<entity-show type="\'user\'" id="entry.values[\'user.id\']" text="value"></entity-show>'), nga.field('order').label('ORDER').isDetailLink(true).detailLinkRoute('show').map(function (value, entry) {
	        if (!entry['purchase.created']) return null;
	
	        var date = ParseDate(entry['purchase.created']);
	        return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['purchase.id'], 4);
	    }).template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'), nga.field('manual_invoice').label('MANUAL_INVOICE'), nga.field('type').label('TYPE').isDetailLink(true).detailLinkRoute('show').map(function (value, entry) {
	        return entry['type.name'];
	    }).template('<entity-edit type="\'licencetype\'" id="entry.values[\'type.id\']" text="value"></entity-edit>'), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'), nga.field('updated', 'date').label('UPDATED').format('yyyy-MM-dd'), nga.field('finalized', 'date').label('FINALIZED').format('yyyy-MM-dd'), nga.field('identifier').label('IDENTIFIER'), nga.field('promo', 'boolean').label('PROMO'), nga.field('gamesvr', 'referenced_list').label('LICENCES_GAME_VR').targetEntity(nga.entity('gamevrlicence').url('gamevr/licences')).targetReferenceField('licence').targetFields([nga.field('id').label('ID'), nga.field('gamevr').label('GAMEVR').map(function (value, entry) {
	        return entry['gamevr.name'];
	    }).template('<entity-show type="\'gamevr\'" id="entry.values[\'gamevr.id\']" text="value"></entity-show>'), nga.field('order').label('ORDER').isDetailLink(true).map(function (value, entry) {
	        if (!entry['purchase.created']) return null;
	
	        var date = ParseDate(entry['purchase.created']);
	        return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['purchase.id'], 4);
	    }).template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd')]));
	
	    entity.creationView().fields(nga.field('licence'), nga.field('user', 'reference').map(function (value, entry) {
	        return entry['user.id'];
	    }).targetEntity(nga.entity('professional').url('professionals')).targetField(nga.field('name').map(function (value, entry) {
	        return entry['name'] + ' ' + (entry['surname'] || '');
	    })).perPage(0), nga.field('purchase', 'reference').map(function (value, entry) {
	        return entry['purchase.id'];
	    }).targetEntity(nga.entity('purchase').url('purchases')).targetField(nga.field('order').map(function (value, entry) {
	
	        var date = ParseDate(entry['created']);
	
	        if (date) return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['id'], 4);
	    })).perPage(0), nga.field('manual_invoice').label('MANUAL_INVOICE'), nga.field('type', 'reference').map(function (value, entry) {
	        return entry['type.id'];
	    }).targetEntity(nga.entity('licencetype').url('licencetypes')).targetField(nga.field('name')).perPage(0), nga.field('promo', 'boolean').label('PROMO').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'), nga.field('finalized', 'date').format('yyyy-MM-dd').map(ParseDate), nga.field('identifier'), nga.field('ip')).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function (error, form, progression, notification, $filter) {
	
	        $(':input').each(function () {
	            $(this).closest('.form-field').removeClass('has-error').find('.help-block.error').remove();
	        });
	
	        error.data.fields.forEach(function (error, index) {
	            var input = $('[name=' + error.property_path + ']');
	            $('<span class="help-block error">' + error.message + '</span>').insertAfter(input);
	            input.closest('.form-field').addClass('has-error');
	        });
	
	        progression.done();
	
	        notification.log($filter('translate')('INVALID_DETAILS_IN_FORM'), { addnCls: 'humane-flatty-error' });
	
	        return true;
	    }]);
	
	    entity.editionView().fields(entity.creationView().fields()).onSubmitError(entity.creationView().onSubmitError());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('licencetype').label('Licence Type');
	    //.readOnly();
	
	    entity.listView().fields([nga.field('id').isDetailLink(true), nga.field('name').isDetailLink(true), nga.field('code').label('CODE')]).sortDir('asc').url('licencetypes');
	
	    entity.creationView().fields([nga.field('name'), nga.field('code', 'choice').label('CODE').choices([{ label: 'specialist', value: 'specialist' }, { label: 'gold', value: 'gold' }, { label: 'pro', value: 'pro' }, { label: 'vr', value: 'vr' }])]);
	
	    entity.editionView().fields(entity.creationView().fields());
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 154 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var extend = admin.getEntity('invoice');
	    var entity = admin.getEntity('payment')
	    //.updateMethod('patch')
	    .label('payment').url(function (entity, view, id) {
	        if (id) return 'invoice/' + encodeURIComponent(id);
	
	        return 'invoice';
	    });
	
	    var pad = function pad(n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    var fields = Object.assign([], extend.listView().fields());
	    fields.push(nga.field('payment_relation').label('INVOICE').map(function (value, entry) {
	        return entry['payment_relation.numeration'];
	    }).template('<entity-edit type="\'invoice\'" id="entry.values[\'payment_relation.id\']" text="value"></entity-edit>'));
	
	    entity.listView().fields(fields).url(extend.listView().url()).permanentFilters({
	        payment: true
	    }).listActions(['<invoice-download entry="entry" entity="entity"/>', '<invoice-resend entry="entry" entity="entity"/>', 'edit', 'delete']).filters(extend.listView().filters());
	
	    var fields_edit = Object.assign([], extend.editionView().fields());
	    fields_edit.push(nga.field('payment_relation', 'reference').singleApiCall(function () {
	        return { 'payment': false };
	    }).map(function (value, entry) {
	        return entry['payment_relation.id'];
	    }).targetEntity(nga.entity('invoice').url('invoices')).targetField(nga.field('numeration')).perPage(0));
	
	    entity.editionView().fields(fields_edit);
	
	    entity.creationView().fields(entity.editionView().fields());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var entity = admin.getEntity('prenscriptor').updateMethod('patch').label('prenscriptor').url(function (entity, view, id) {
	        if (id) return 'user/' + encodeURIComponent(id);
	
	        return 'user';
	    });
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'), nga.field('surname').label('SURNAME').isDetailLink(true).detailLinkRoute('show'), nga.field('email').label('EMAIL'), nga.field('username').label('USER')]).listActions(['show', 'edit', 'delete']).sortDir('asc').url('prenscriptors').title('Users');
	
	    var fields = [nga.field('username').label('USERNAME'), nga.field('email', 'email').label('EMAIL'), nga.field('name').label('NAME'), nga.field('surname').label('SURNAME'), nga.field('enabled', 'boolean').label('ENABLED')];
	
	    if (HasRole('admin')) {
	        fields.push(nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'));
	        fields.push(nga.field('roles').label('ROLES'));
	
	        fields.push(nga.field('prescriber').map(function (value, entry) {
	            if (entry['prescriber.name']) return entry['prescriber.name'] + ' ' + (entry['prescriber.surname'] ? entry['prescriber.surname'] : '');
	        }).template('<entity-show type="\'user\'" id="entry.values[\'prescriber.id\']" text="value"></entity-show>').label('PRESCRIBER').cssClasses(function (entry) {
	            if (!entry.values.prescriber) return 'hidden';
	        }));
	        fields.push(nga.field('company').map(function (value, entry) {
	            if (entry['company.name']) return entry['company.name'] + ' ' + (entry['company.surname'] ? entry['company.surname'] : '');
	        }).template('<entity-show type="\'user\'" id="entry.values[\'company.id\']" text="value"></entity-show>').label('COMPANY'));
	        fields.push(nga.field('workers', 'referenced_list').label('WORKERS').targetEntity(nga.entity('user').url('users')).targetReferenceField('company').targetFields([nga.field('id').label('ID'), nga.field('name').label('NAME').isDetailLink(true), nga.field('surname').label('COMPANY').isDetailLink(true)]));
	        fields.push(nga.field('patients', 'referenced_list').label('PATIENTS').targetEntity(nga.entity('user').url('users')).targetReferenceField('prescriber').targetFields([nga.field('id').label('ID'), nga.field('name').label('NAME').isDetailLink(true), nga.field('surname').label('SURNAME').isDetailLink(true)]));
	
	        fields.push(nga.field('cif').label('CIF'));
	        fields.push(nga.field('address').label('ADDRESS'));
	        fields.push(nga.field('city').label('CITY'));
	        fields.push(nga.field('postal_code').label('POSTAL_CODE'));
	        fields.push(nga.field('state.name').label('STATE'));
	    }
	    if (HasRole('company')) {
	        fields.push(nga.field('prescriber_type.description').label('PRESCRIBER_TYPE'));
	        fields.push(nga.field('patients', 'referenced_list').label('PATIENTS').targetEntity(nga.entity('user').url('users')).targetReferenceField('prescriber').targetFields([nga.field('id').label('ID'), nga.field('name').label('NAME').isDetailLink(true), nga.field('surname').label('SURNAME').isDetailLink(true)]));
	    }
	    if (HasRole('prenscriptor')) {
	        fields.push(nga.field('birthday', 'date').label('BIRTHDAY').format('yyyy-MM-dd'));
	        fields.push(nga.field('training_time').label('TRAINING_TIME_MIN'));
	        fields.push(nga.field('training_date', 'date').format('yyyy-MM-dd').label('TRAINING_TIME'));
	        fields.push(nga.field('abilities', 'reference_many').label('ABILITIES').targetEntity(nga.entity('ability').url('abilities')).targetField(nga.field('name')).singleApiCall(function (ids) {
	            return null;
	        }).map(function (value, entry) {
	            if (entry.formatedAB) return entry.formatedAB;
	
	            return entry.formatedAB = value.map(function (ability) {
	                return ability.ability;
	            });
	        }));
	    }
	
	    entity.showView().fields(fields).prepare(['Restangular', 'datastore', function (Restangular, datastore) {
	        var _this = this;
	
	        if (HasRole('admin', 'superadmin')) return false;
	
	        return Restangular.all('licences').getList().then(function (data) {
	            data = data.data ? data.data : data;
	
	            var licences_pro = [];
	
	            data.forEach(function (licence, index) {
	                if (licence.type == 'gold') {
	                    licences_pro.push(licence);
	                }
	            });
	
	            if (!licences_pro.length) {
	                var _fields = _this.fields();
	                var remove = [];
	
	                _fields.forEach(function (field, index) {
	                    if (['training_time', 'training_date', 'abilities'].indexOf(field._name) !== -1) {
	                        remove.push(index);
	                    }
	                });
	
	                remove.reverse().forEach(function (index, i) {
	                    _fields.splice(index, 1);
	                });
	            }
	        });
	    }]);
	
	    fields = [nga.field('username').label('USERNAME'), nga.field('email', 'email').label('EMAIL'),
	    //nga.field('plainPassword', 'password').label('PASSWORD'),
	    nga.field('name').label('NAME'), nga.field('surname').label('SURNAME'), nga.field('enabled', 'boolean').label('ENABLED').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>')];
	
	    if (HasRole('admin')) {
	        fields.push(nga.field('roles', 'choice').label('ROLES').choices([{ label: 'COMPANY', value: 'ROLE_COMPANY' }, { label: 'PRENSCRIPTOR', value: 'ROLE_PRENSCRIPTOR' }, { label: 'PATINET', value: 'ROLE_PATIENT' }]));
	        fields.push(nga.field('prescriber', 'reference').label('PRESCRIBER').map(function truncate(value, entry) {
	            return entry['prescriber.id'];
	        }).targetEntity(nga.entity('professional').url('professionals')).targetField(nga.field('name')));
	        fields.push(nga.field('company', 'reference').label('COMPANY').map(function truncate(value, entry) {
	            return entry['company.id'];
	        }).targetEntity(nga.entity('company').url('companies')).targetField(nga.field('name')));
	
	        fields.push(nga.field('cif').label('CIF'));
	        fields.push(nga.field('address').label('ADDRESS'));
	        fields.push(nga.field('city').label('CITY'));
	        fields.push(nga.field('postal_code').label('POSTAL_CODE'));
	        fields.push(nga.field('state', 'reference').label('STATE').map(function truncate(value, entry) {
	            return entry['state.id'];
	        }).perPage(0).targetEntity(nga.entity('state').url('states')).targetField(nga.field('name')).singleApiCall(function (ids) {
	            return null;
	        }));
	    }
	    if (HasRole('company')) {
	        fields.push(nga.field('prescriber_type.id', 'reference').label('PRESCRIBER_TYPE').map(function truncate(value, entry) {
	            return entry['prescriber_type.id'];
	        }).targetEntity(nga.entity('prescriberType').url('prescriberTypes')).targetField(nga.field('description')));
	    }
	
	    entity.creationView().fields(fields).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function (error, form, progression, notification, $filter) {
	        $(':input').each(function () {
	            $(this).closest('.form-field').removeClass('has-error').find('.help-block.error').remove();
	        });
	
	        error.data.fields.forEach(function (error, index) {
	            var input = $('[name=' + error.property_path + ']');
	            $('<span class="help-block error">' + error.message + '</span>').insertAfter(input);
	            input.closest('.form-field').addClass('has-error');
	        });
	
	        form['email'].$valid = false;
	
	        progression.done();
	
	        notification.log($filter('translate')('INVALID_DETAILS_IN_FORM'), { addnCls: 'humane-flatty-error' });
	
	        return true;
	    }]).prepare(entity.showView().prepare());
	
	    entity.editionView().fields(entity.creationView().fields()).onSubmitError(entity.creationView().onSubmitError()).prepare(entity.showView().prepare());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('prescriberType').label('Prescriber Type');
	    //.readOnly();
	
	    entity.listView().fields([nga.field('id').isDetailLink(true), nga.field('description').isDetailLink(true), nga.field('competences', 'reference_many').label('COMPETENCES').targetEntity(nga.entity('competence').url('competences')).targetField(nga.field('name')).singleApiCall(function (ids) {
	        return { 'id': ids };
	    })]).sortDir('asc').url('prescriberTypes');
	
	    entity.creationView().fields([nga.field('description'), nga.field('description_es'), nga.field('description_ca'), nga.field('competences', 'reference_many').label('COMPETENCES').targetEntity(nga.entity('competence').url('competences')).targetField(nga.field('name'))]);
	
	    entity.editionView().fields(entity.creationView().fields());
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin, Api) {
	    var entity = admin.getEntity('product').label('products');
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true), nga.field('name').label('NAME').isDetailLink(true), nga.field('abbr').label('ABBR'), nga.field('price', 'number').label('PRICE_MONTH').format("0,000.00"), nga.field('price_annual', 'number').label('ENROLLMENT').format("0,000.00"), nga.field('promotional', 'boolean').label('PRICE_ANNUAL'), nga.field('type').label('TYPE'), nga.field('licencesType', 'reference_many').label('Licences Type').targetEntity(nga.entity('licencetype').url('licencetypes')).targetField(nga.field('name')).singleApiCall(function (ids) {
	        return { 'id': ids };
	    }), nga.field('units').label('UNITS')]).sortDir('asc').url('products').entryCssClasses(function (entry) {
	        return entry.promotional ? 'warning' : '';
	    });
	
	    entity.creationView().fields([nga.field('name').label('NAME'), nga.field('description', 'text').label('DESCRIPTION'), nga.field('image', 'file').label('IMAGE').uploadInformation({ 'url': Api.Path + 'product/upload', 'apifilename': 'file' }), nga.field('abbr').label('ABBR'), nga.field('price', 'float').label('PRICE_MONTH').format("0,000.00"), nga.field('price_annual', 'float').label('PRICE_ANNUAL').format("0,000.00"), nga.field('promotional', 'boolean').label('PROMOTIONAL').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'), nga.field('type', 'choice').label('TYPE').choices([{ label: 'LICENCE', value: 'licence' }, { label: 'SUBSCRIPTION', value: 'subscription' }, { label: 'GAME', value: 'game' }]), nga.field('licences_type', 'reference_many').label('Licences Type').targetEntity(nga.entity('licencetype').url('licencetypes')).targetField(nga.field('name')), nga.field('gamesvr', 'reference_many').label('GAMES').targetEntity(nga.entity('gamevr').url('gamevrs')).targetField(nga.field('name')), nga.field('units').label('UNITS'), nga.field('codes', 'embedded_list').label('CODES') // Define a 1-N relationship with the (embedded) comment entity
	    .targetFields([// which comment fields to display in the datagrid / form
	    nga.field('code').label('CODE'), nga.field('limit', 'date').label('LIMIT').format('dd-MM-yyyy').map(ParseDate)])]).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function (error, form, progression, notification, $filter) {
	
	        $('.form-field').each(function () {
	            $(this).removeClass('has-error').find('.help-block.error').remove();
	        });
	
	        error.data.fields.forEach(function (error, index) {
	            var input = $('[name=' + error.property_path + ']');
	
	            if (error.property_path == 'codes') {
	                input = $('#row-codes').find('.row');
	            }
	
	            $('<span class="help-block error">' + error.message + '</span>').insertAfter(input);
	            input.closest('.form-field').addClass('has-error');
	        });
	
	        progression.done();
	
	        //notification.log($filter('translate')(`INVALID_DETAILS_IN_FORM`), { addnCls: 'humane-flatty-error' });
	
	        return true;
	    }]);
	
	    entity.editionView().fields(entity.creationView().fields()).onSubmitError(entity.creationView().onSubmitError());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('promo').label('Promo');
	    //.readOnly();
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'), nga.field('email').label('EMAIL').isDetailLink(true).detailLinkRoute('show'), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'), nga.field('phone').label('PHONE').map(function (value, entry) {
	        if (entry['user.phone']) return entry['user.phone'];
	    }), nga.field('user').label('USER').map(function (value, entry) {
	        if (entry['user.name']) return entry['user.name'] + ' ' + (entry['user.surname'] || '');
	    }).template('<entity-show type="\'user\'" id="entry.values[\'user.id\']" text="value"></entity-show>'), nga.field('licence').label('LICENCE').map(function (value, entry) {
	        if (entry['licence.licence']) return entry['licence.licence'];
	    }).template('<entity-show type="\'licence\'" id="entry.values[\'licence.id\']" text="value"></entity-show>'), nga.field('used', 'boolean').label('USED')]).sortDir('asc').url('promos').listActions(['edit', 'delete']);
	
	    entity.creationView().fields([nga.field('name').label('NAME'), nga.field('email').label('EMAIL'), nga.field('phone').label('PHONE'), nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'), nga.field('user', 'reference').map(function (value, entry) {
	        return entry['user.id'];
	    }).targetEntity(nga.entity('user').url('users')).targetField(nga.field('name').map(function (value, entry) {
	        return entry['name'] + ' ' + (entry['surname'] || '');
	    })).perPage(0), nga.field('licence', 'reference').map(function (value, entry) {
	        return entry['licence.id'];
	    }).targetEntity(nga.entity('licence').url('licences')).targetField(nga.field('licence')).perPage(0), nga.field('used', 'boolean').label('USED').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>')]);
	
	    entity.editionView().fields(entity.creationView().fields());
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('purchase')
	    //.updateMethod('patch')
	    .label('purchases');
	
	    var pad = function pad(n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    entity.listView().fields([nga.field('order').label('ORDER').isDetailLink(true), nga.field('user').label('USER').map(function (value, entry) {
	        return entry['user.name'] + ' ' + (entry['user.surname'] || '');
	    }).template('<entity-show type="\'user\'" id="entry.values[\'user.id\']" text="value"></entity-show>'), nga.field('product').label('PRODUCT').isDetailLink(true).map(function (value, entry) {
	        return entry['product.name'];
	    }), nga.field('method').label('METHOD'), nga.field('status').label('STATUS').map(function (value, entry) {
	        if (value) return "active";else return "inactive";
	    }), nga.field('updated', 'date').label('UPDATED').format('yyyy-MM-dd'), nga.field('interested').label('INVOICE').template(function (entry) {
	        if (entry.values.status == 'inactive') {
	            return null;
	        }
	
	        return '<ma-filtered-list-button label="{{ \'SHOW INVOICES\' | translate }}" entity-name="invoice" ' + 'filter="{  purchase: entry.values.id }" size="xs"></ma-filtered-list-button>';
	    })]).url('purchases').listActions(['edit', 'delete']).filters([nga.field('q', 'template').label('').pinned(true).template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search order" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'), nga.field('status', 'choice').choices([{ label: 'active', value: '1' }, { label: 'inactive', value: '0' }])]);
	
	    entity.editionView().fields([nga.field('id'), nga.field('user', 'reference').map(function (value, entry) {
	        return entry['user.id'];
	    }).targetEntity(nga.entity('user').url('users')).targetField(nga.field('name')).perPage(0), nga.field('product', 'reference').map(function (value, entry) {
	        return entry['product.id'];
	    }).targetEntity(nga.entity('product').url('products')).targetField(nga.field('name')).perPage(0), nga.field('status', 'boolean').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'), nga.field('status_code'), nga.field('method', 'choice').choices([{ label: 'PAYPAL', value: 'paypal' }, { label: 'CREDIT_CARD', value: 'credit_card' }, { label: 'WIRE_TRANSFER', value: 'wire' }])]);
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	    var entity = admin.getEntity('subscription').updateMethod('patch').label('Subscriptions');
	
	    var pad = function pad(n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true), nga.field('code').label('CODE').isDetailLink(true), nga.field('purchase.order').label('ORDER').isDetailLink(true).template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'), nga.field('type.name').label('TYPE').isDetailLink(true).template('<entity-edit type="\'licencetype\'" id="entry.values[\'type.id\']" text="value"></entity-edit>'), nga.field('user').label('USER'), nga.field('finalize', 'date').format('yyyy-MM-dd').label('EXPIRATE_AT')]).entryCssClasses(function (entry) {
	        return entry.subscription == 'active' ? 'success' : 'warning';
	    }).sortDir('asc').url('subscriptions').prepare(['Restangular', 'datastore', 'entries', 'Entry', function (Restangular, datastore, entries, Entry) {
	        return Restangular.all('subscriptions/active').getList({ _sortDir: "ASC", _sortField: "finalize" }).then(function (data) {
	            data = data.data ? data.data : data;
	
	            entries.forEach(function (u, i) {
	                u.values.subscription = 'inactive';
	
	                data.forEach(function (s, si) {
	                    if (u.values.id == s.id) {
	                        u.values.user = s.user.name + ' ' + s.user.surname;
	                        u.values.subscription = 'active';
	                    }
	                });
	            });
	        });
	    }]);;
	
	    entity.creationView().fields([nga.field('code'), nga.field('user', 'reference').map(function (value, entry) {
	        return entry['user.id'];
	    }).targetEntity(nga.entity('user').url('users')).targetField(nga.field('name').map(function (value, entry) {
	        return entry['name'] + ' ' + (entry['surname'] || '');
	    })).perPage(0), nga.field('purchase', 'reference').map(function (value, entry) {
	        return entry['purchase.id'];
	    }).targetEntity(nga.entity('purchase').url('purchases')).targetField(nga.field('order').map(function (value, entry) {
	        var date = ParseDate(entry['created']);
	        if (date) return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['id'], 4);
	    })).perPage(0), nga.field('purchaseUser', 'reference').map(function (value, entry) {
	        return entry['purchase_user.id'];
	    }).targetEntity(nga.entity('professional').url('professionals')).targetField(nga.field('name').map(function (value, entry) {
	        return entry['name'] + ' ' + (entry['surname'] || '');
	    })).perPage(0), nga.field('initialize', 'date').format('yyyy-MM-dd').map(ParseDate), nga.field('finalize', 'date').format('yyyy-MM-dd').map(ParseDate), nga.field('type', 'reference').map(function (value, entry) {
	        return entry['type.id'];
	    }).targetEntity(nga.entity('licencetype').url('licencetypes')).targetField(nga.field('name')).perPage(0)]);
	
	    entity.editionView().fields(entity.creationView().fields());
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var entity = admin.getEntity('user').updateMethod('patch').label('USER');
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'), nga.field('surname').label('SURNAME').isDetailLink(true).detailLinkRoute('show'), nga.field('email').label('EMAIL'), nga.field('username').label('USER'), nga.field('subscription').label('SUBSCRIPTION').sortable(false)]).listActions(['show', 'edit', 'delete']).sortDir('ASC').url('users').entryCssClasses(function (entry) {
	        if (entry.dummy) return 'dummy';
	
	        return entry.subscription == 'active' ? 'success' : 'warning';
	    }).prepare(['Restangular', 'datastore', 'entries', 'Entry', function (Restangular, datastore, entries, Entry) {
	        return Restangular.all('subscriptions/active').getList({ _sortDir: "ASC", _sortField: "finalize" }).then(function (data) {
	            data = data.data ? data.data : data;
	
	            entries.forEach(function (u, i) {
	                u.values.subscription = 'inactive';
	
	                data.forEach(function (s, si) {
	                    if (s.user && u.values.id == s.user.id) {
	                        u.values.subscription = 'active';
	                    }
	                });
	            });
	        });
	    }]).filters([nga.field('q', 'template').label('').pinned(true).template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search order" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'), nga.field('status', 'choice').choices([{ label: 'active', value: '1' }, { label: 'inactive', value: '0' }])]);
	
	    var fields = [nga.field('username').label('USERNAME'), nga.field('email', 'email').label('EMAIL'), nga.field('name').label('NAME'), nga.field('surname').label('SURNAME'), nga.field('enabled', 'boolean').label('ENABLED')];
	
	    if (HasRole('admin')) {
	        fields.push(nga.field('dummy', 'boolean').label('USER_TEST'));
	        fields.push(nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'));
	        fields.push(nga.field('prescriber_type.description').label('Prescriber Type'));
	
	        fields.push(nga.field('prescriber').map(function (value, entry) {
	            if (entry['prescriber.name']) return entry['prescriber.name'] + ' ' + (entry['prescriber.surname'] ? entry['prescriber.surname'] : '');
	        }).template('<entity-show type="\'user\'" id="entry.values[\'prescriber.id\']" text="value"></entity-show>').label('PRESCRIBER').cssClasses(function (entry) {
	            if (!entry.values.prescriber) return 'hidden';
	        }));
	        fields.push(nga.field('company').map(function (value, entry) {
	            if (entry['company.name']) return entry['company.name'] + ' ' + (entry['company.surname'] ? entry['company.surname'] : '');
	        }).template('<entity-show type="\'user\'" id="entry.values[\'company.id\']" text="value"></entity-show>').label('COMPANY'));
	        fields.push(nga.field('workers', 'referenced_list').label('WORKERS').targetEntity(nga.entity('prenscriptor').url('prenscriptors')).targetReferenceField('company').targetFields([nga.field('id').label('ID'), nga.field('name').label('NAME').isDetailLink(true), nga.field('surname').label('COMPANY').isDetailLink(true)]));
	        fields.push(nga.field('patients', 'referenced_list').label('PATIENTS').targetEntity(nga.entity('user').url('users')).targetReferenceField('prescriber').targetFields([nga.field('id').label('ID'), nga.field('name').label('NAME').isDetailLink(true), nga.field('surname').label('SURNAME').isDetailLink(true)]));
	
	        fields.push(nga.field('cif').label('CIF'));
	        fields.push(nga.field('address').label('ADDRESS'));
	        fields.push(nga.field('city').label('CITY'));
	        fields.push(nga.field('postal_code').label('POSTAL_CODE'));
	        fields.push(nga.field('state.name').label('STATE'));
	    }
	    if (HasRole('company') && !HasRole('admin')) {
	        fields.push(nga.field('prescriber_type.description').label('Prescriber Type'));
	        fields.push(nga.field('prescriber').map(function (value, entry) {
	            if (entry['prescriber.name']) return entry['prescriber.name'] + ' ' + (entry['prescriber.surname'] ? entry['prescriber.surname'] : '');
	        }).template('<entity-show type="\'user\'" id="entry.values[\'prescriber.id\']" text="value"></entity-show>').label('PRESCRIBER').cssClasses(function (entry) {
	            if (!entry.values.prescriber) return 'hidden';
	        }));
	    }
	    if (HasRole(['prenscriptor', 'company'])) {
	        fields.push(nga.field('birthday', 'date').label('BIRTHDAY').format('yyyy-MM-dd'));
	        fields.push(nga.field('maturative', 'date').label('MATURATIVE_AGE').format('yyyy-MM-dd'));
	        fields.push(nga.field('training_time').label('TRAINING_TIME_MIN'));
	        fields.push(nga.field('training_date', 'date').format('yyyy-MM-dd').label('TRAINING_TIME'));
	        fields.push(nga.field('abilities', 'reference_many').label('ABILITIES').targetEntity(nga.entity('ability').url('abilities')).targetField(nga.field('name')).singleApiCall(function (ids) {
	            return null;
	        }).map(function (value, entry) {
	            if (entry.formatedAB) return entry.formatedAB;
	
	            return entry.formatedAB = value.map(function (ability) {
	                return ability.ability;
	            });
	        }));
	    }
	    if (HasRole(['admin'])) {
	        fields.push(nga.field('subscriptions', 'referenced_list').label('SUBSCRIPTIONS').targetEntity(nga.entity('subscription').url('subscriptions')).targetReferenceField('user').targetFields([nga.field('id').label('ID').isDetailLink(true), nga.field('code').label('CODE').isDetailLink(true), nga.field('purchase.order').label('ORDER').isDetailLink(true).template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'), nga.field('type').label('TYPE'), nga.field('finalize', 'date').format('yyyy-MM-dd').label('EXPIRATE_AT')]));
	    }
	
	    entity.showView().fields(fields).prepare(['Restangular', 'datastore', function (Restangular, datastore) {
	        var _this = this;
	
	        if (HasRole('admin', 'superadmin')) return false;
	
	        return Restangular.all('licences').getList().then(function (data) {
	            data = data.data ? data.data : data;
	
	            var licences_pro = [];
	
	            data.forEach(function (licence, index) {
	                if (licence.type.code == 'gold' || licence.type.code == 'specialist') {
	                    licences_pro.push(licence);
	                }
	            });
	
	            if (!licences_pro.length) {
	                var _fields = _this.fields();
	                var remove = [];
	
	                _fields.forEach(function (field, index) {
	                    if (['training_time', 'training_date', 'abilities', 'maturative'].indexOf(field._name) !== -1) {
	                        remove.push(index);
	                    }
	                });
	
	                remove.reverse().forEach(function (index, i) {
	                    _fields.splice(index, 1);
	                });
	            }
	        });
	    }]);
	
	    fields = [nga.field('username').label('USERNAME'), nga.field('email', 'email').label('EMAIL'),
	    //nga.field('plainPassword', 'password').label('PASSWORD'),
	    nga.field('name').label('NAME'), nga.field('surname').label('SURNAME'), nga.field('enabled', 'boolean').label('ENABLED').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>')];
	
	    if (HasRole('admin')) {
	        fields.push(nga.field('roles', 'choice').label('ROLES').choices([{ label: 'COMPANY', value: 'ROLE_COMPANY' }, { label: 'PRENSCRIPTOR', value: 'ROLE_PRENSCRIPTOR' }, { label: 'PATINET', value: 'ROLE_PATIENT' }]));
	        fields.push(nga.field('dummy', 'boolean').label('USER_TEST').template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'));
	        fields.push(nga.field('prescriber_type.id', 'reference').label('Prescriber Type').map(function truncate(value, entry) {
	            return entry['prescriber_type.id'];
	        }).targetEntity(nga.entity('prescriberType').url('prescriberTypes')).targetField(nga.field('description')));
	
	        fields.push(nga.field('prescriber', 'reference').label('PRESCRIBER').map(function truncate(value, entry) {
	            return entry['prescriber.id'];
	        }).perPage(0).targetEntity(nga.entity('prenscriptor').url('prenscriptors')).targetField(nga.field('name').map(function (value, entry) {
	            if (entry['name']) return entry['name'] + ' ' + (entry['surname'] ? entry['surname'] : '');
	        })));
	        fields.push(nga.field('company', 'reference').label('COMPANY').map(function truncate(value, entry) {
	            return entry['company.id'];
	        }).targetEntity(nga.entity('company').url('companies')).targetField(nga.field('name')));
	
	        fields.push(nga.field('cif').label('CIF'));
	        fields.push(nga.field('address').label('ADDRESS'));
	        fields.push(nga.field('city').label('CITY'));
	        fields.push(nga.field('postal_code').label('POSTAL_CODE'));
	        fields.push(nga.field('state', 'reference').label('STATE').map(function truncate(value, entry) {
	            return entry['state.id'];
	        }).perPage(0).targetEntity(nga.entity('state').url('states')).targetField(nga.field('name')).singleApiCall(function (ids) {
	            return null;
	        }));
	    }
	    if (HasRole('company') && !HasRole('admin')) {
	        fields.push(nga.field('prescriber', 'reference').label('PRESCRIBER').map(function truncate(value, entry) {
	            return entry['prescriber.id'];
	        }).perPage(0).targetEntity(nga.entity('prenscriptor').url('prenscriptors')).targetField(nga.field('name').map(function (value, entry) {
	            if (entry['name']) return entry['name'] + ' ' + (entry['surname'] ? entry['surname'] : '');
	        })));
	    }
	    if (HasRole(['prenscriptor', 'company'])) {
	        fields.push(nga.field('birthday', 'date').label('BIRTHDAY').format('yyyy-MM-dd').map(ParseDate));
	        fields.push(nga.field('maturative', 'date').label('MATURATIVE_AGE').format('yyyy-MM-dd').map(ParseDate));
	        fields.push(nga.field('training_time').label('TRAINING_TIME_MIN'));
	        fields.push(nga.field('training_date', 'date').label('TRAINING_DATE').format('yyyy-MM-dd').map(ParseDate));
	        fields.push(nga.field('abilities', 'embedded_list').label('ABILITIES').targetFields([// which comment fields to display in the datagrid / form
	        nga.field('ability').label('ABILITY'), nga.field('weight').label('WEIGHT'), nga.field('games', 'choices').label('GAMES')]).template('<ma-abilities field="::field" value="value" entry="::entry"></ma-abilities>'));
	    }
	    if (HasRole(['prenscriptor', 'superadmin', 'admin'])) {
	        entity.creationView().fields(fields).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function (error, form, progression, notification, $filter) {
	            $(':input').each(function () {
	                $(this).closest('.form-field').removeClass('has-error').find('.help-block.error').remove();
	            });
	
	            error.data.fields.forEach(function (error, index) {
	                var input = $('[name=' + error.property_path + ']');
	                $('<span class="help-block error">' + error.message + '</span>').insertAfter(input);
	                input.closest('.form-field').addClass('has-error');
	            });
	
	            form['email'].$valid = false;
	
	            progression.done();
	
	            notification.log($filter('translate')('INVALID_DETAILS_IN_FORM'), { addnCls: 'humane-flatty-error' });
	
	            return true;
	        }]).prepare(entity.showView().prepare());
	    }
	
	    entity.editionView().fields(entity.creationView().fields()).onSubmitError(entity.creationView().onSubmitError()).prepare(entity.showView().prepare());
	
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var entity = admin.getEntity('variable').label('Variables');
	
	    entity.listView().fields([nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'), nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'), nga.field('abbreviation').label('ABBREVIATION'), nga.field('description').label('DESCRIPTION'), nga.field('type').label('TYPE')]).sortDir('asc').url('variables');
	
	    entity.creationView().fields([nga.field('name').label('NAME'), nga.field('abbreviation').label('ABBREVIATION'), nga.field('description').label('DESCRIPTION'), nga.field('type', 'choice').label('TYPE').choices([{ label: 'FLOAT', value: 'float' }, { label: 'INTEGER', value: 'int' }, { label: 'BOOLEAN', value: 'boolean' }, { label: 'MULTIPLE', value: 'multiple' }, { label: 'REPETITIONS', value: 'repetitions' }]).defaultValue('float'), nga.field('max'), nga.field('min'), nga.field('modify_fixed').label('MODIFY_FIXED'), nga.field('steps').label('STEPS')]);
	
	    entity.showView().fields(entity.creationView().fields(), nga.field('modify_relation', 'embedded_list').label('MODIFY_RELATION').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('KEY').label('PERCENTAGE'), nga.field('value').label('VALUE')]), nga.field('modify_variable', 'embedded_list').label('MODIFY_FIXED').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('KEY').label('PERCENTAGE'), nga.field('value').label('VALUE')]), nga.field('hardness_initial', 'embedded_list').label('HARDNESS_INITIAL').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('KEY').label('GROUP'), nga.field('value').label('VALUE').label('HARDNESS')]), nga.field('games', 'referenced_list').label('GAMES').targetEntity(nga.entity('config').url('configs')).targetReferenceField('variable').targetFields([nga.field('game').label('GAME').map(function (value, entry) {
	        if (entry['game.name']) return entry['game.name'];
	    }).template('<entity-show type="\'game\'" id="::entry.values[\'game.id\']" text="value"></entity-show>')]));
	
	    entity.creationView().fields(nga.field('modify_relation', 'embedded_list').label('MODIFY_RELATION').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('KEY').label('PERCENTAGE'), nga.field('value').label('VALUE')]).template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'), nga.field('modify_variable', 'embedded_list').label('MODIFY_VARIABLE').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('KEY').label('PERCENTAGE'), nga.field('value').label('VALUE')]).template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'), nga.field('hardness_initial', 'embedded_list').label('HARDNESS_INITIAL').targetFields([// which comment fields to display in the datagrid / form
	    nga.field('key').label('KEY').label('GROUP'), nga.field('value').label('VALUE').label('HARDNESS')]).template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'));
	
	    entity.editionView().fields(entity.creationView().fields());
	    entity.deletionView();
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var moduleName = 'appFilters';
	
	angular.module(moduleName, []).filter('nospace', __webpack_require__(165)).filter('raw', ['$sce', __webpack_require__(166)]).filter('humanizeDoc', __webpack_require__(164));
	
	exports.default = moduleName;
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return function (doc) {
	        if (!doc) return;
	        if (doc.type === 'directive') {
	            return doc.name.replace(/([A-Z])/g, function ($1) {
	                return '-' + $1.toLowerCase();
	            });
	        }
	
	        return doc.label || doc.name;
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 165 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return function (value) {
	        return !value ? '' : value.replace(/ /g, '');
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($sce) {
	    return function (val) {
	        return $sce.trustAsHtml(val);
	    };
	};
	
	;
	module.exports = exports["default"];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	window.GetData = function () {
	    if (typeof Cookies.get('globals') != "undefined") return JSON.parse(new Buffer(Cookies.get('globals'), 'base64').toString('utf8'));
	
	    return {};
	};
	
	window.SetData = function (Data) {
	    Cookies.set('globals', new Buffer(JSON.stringify(Data)).toString('base64'));
	};
	
	window.RemoveData = function () {
	    Cookies.remove('globals');
	};
	
	window.HasRole = function (roles) {
	
	    var exists = false;
	
	    if ((typeof roles === 'undefined' ? 'undefined' : _typeof(roles)) != 'object') roles = [roles];
	
	    var data = window.GetData();
	    if (!data) return exists;
	
	    var currentUser = data.currentUser;
	    if (!currentUser) return exists;
	
	    var userRoles = currentUser.roles;
	
	    userRoles.forEach(function (userRole) {
	        if (userRole == 'admin' || userRole == 'superadmin') if (!exists) exists = true;
	
	        roles.forEach(function (role) {
	            if (!exists) exists = userRole == role;
	        });
	    });
	
	    return exists;
	};
	
	window.ParseDate = function (date) {
	    if (!date || typeof date == 'undefined') return date;
	
	    var v = new Date(Date.parse(date.replace(/\-/ig, '/').split('.')[0]));
	
	    if (v == 'Invalid Date') v = new Date(date);
	
	    return v;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20).Buffer))

/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	
	    'OLD_PASSWORD': "Antiga clau d'acces",
	    'OLD_PASSWORD_REQUIRED': "Es requereix l'antiga clau d'acces",
	    'OLD_PASSWORD_NOT': "L'antiga clau d'acces no és correcta",
	    'NEW_PASSWORD': "Nova clau d'acces",
	    'NEW_PASSWORD_REQUIRED': "Es requereix la nova clau d'acces",
	    'CONFIRM_PASSWORD': "Confirmar clau d'acces",
	    'CONFIRM_PASSWORD_REQUIRED': "Cal una confirmació de clau d'acces",
	    'CONFIRM_PASSWORD_SAME': "Les claus d'acces no coincideixen",
	
	    // NG-Admin
	    'BACK': 'Tornar',
	    'DELETE': 'Eliminar',
	    'CREATE': 'Crear',
	    'EDIT': 'Edita',
	    'EXPORT': 'Exporta',
	    'ADD_FILTER': 'Afegir filtre',
	    'SEE_RELATED': "Veure tot relacionat {{ entityName }}",
	    'LIST': 'llista',
	    'SHOW': 'Mostrar',
	    'SAVE': 'Desar',
	    'N_SELECTED': '{{ length }} Seleccionat',
	    'ARE_YOU_SURE': 'Estàs segur?',
	    'YES': 'Si',
	    'NO': 'No',
	    'FILTER_VALUES': 'Valors de filtre',
	    'CLOSE': 'Tancar',
	    'CLEAR': 'Netejar',
	    'CURRENT': 'Corrent',
	    'REMOVE': 'Treure',
	    'ADD_NEW': 'Afegeix nou {{ name }}',
	    'BROWSE': 'Busqueda',
	    'N_COMPLETE': '{{ progress }}% Complet',
	    'CREATE_NEW': 'Crear nou',
	    'SUBMIT': 'Enviar',
	    'SAVE_CHANGES': 'Desa els canvis',
	    'BATCH_DELETE_SUCCESS': 'Elements eliminats correctament',
	    'DELETE_SUCCESS': 'Element eliminat correctament',
	    'ERROR_MESSAGE': 'Oops! Hi ha hagut un error(code: {{ status }})',
	    'INVALID_FORM': 'Forma invalida',
	    'CREATION_SUCCESS': 'Element creat correctament',
	    'EDITION_SUCCESS': 'Canvis guardats correctament',
	    'ACTIONS': 'Accions',
	    'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>',
	    'NO_PAGINATION': 'Cap record va ser trobat',
	    'PREVIOUS': '« Anterior',
	    'NEXT': 'Següent »',
	    'DETAIL': 'Detall',
	    'STATE_CHANGE_ERROR': 'Error de canvi d\'estat: {{ message }}',
	    'NOT_FOUND': 'No funciona',
	    'NOT_FOUND_DETAILS': 'La pàgina que cerca no es troba. Tome un descans abans d\'intentar de nou.',
	
	    //lang
	    'SPANISH': "Castellà",
	    'ENGLISH': "Anglès",
	    'CATALAN': "Català",
	
	    //Menu
	    'ORDERS': "Ordres",
	    'ACCOUNT': "Compte",
	    'PURCHASES': "Compres",
	    'DOWNLOADS': "Descàrregues",
	    'USERS': "Usuaris",
	    'USER_LIST': "Llista de pacients",
	    'PRENSCRIBER_LIST': "Llista de professionals",
	    'COMPANY_LIST': "Llista d'empreses",
	    'PRESCRIBER_TYPES': "Tipus de prescriptor",
	    'PRODUCTS': "Productes",
	    'SUBSCRIPTIONS': "Subscripcions",
	    'LICENCES': "Llicències",
	    'LICENCES_TEXT': "Totes les llicències estan subjectes a un manteniment anual i la signatura d'un contracte",
	    'GAMES': "Jocs",
	    'CONFIG': "Configuració",
	    'VARIABLES': "Variables",
	    'ABILITIES': "Habilitats",
	    'LOGOUT': "Tancar sessió",
	    'PRESNCRIPTORS': 'Prescriptors',
	    'PROFESSIONAL_MANUAL': "Manual del professional",
	    'PROFESSIONAL_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/manual_profesional_cast.pdf',
	    'USER_MANUAL': "Guia d'usuari",
	    'USER_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/guia_usuari_cat.pdf',
	    'VIDEOS_TUTORIAL': 'videos tutorials',
	
	    // Login
	    'REGISTER': "Registre",
	    'LOGIN': "Inicia sessió",
	    'USERNAME_OR_EMAIL': "Nom d'usuari",
	    'RECOVERY_PASSWORD': "Recuperar clau d'acces",
	    'USERNAME_EMAIL_RECOVERY': "Es requereix un nom d'usuari.",
	    'PASSWORD_REQUIRED': "Es requereix clau d'acces.",
	    'LETS_GO': "¡Som-hi!",
	    'PASSWORD': "Contrasenya",
	    'ERROR_USSER_PASSWORD_INCORRECT': "Nom d'usuari o clau d'acces incorrecta",
	    'LOGIN_REGISTER': "Registra't",
	    'OR': "o",
	    'ERROR_LINK_EXPIRED': "El enllaç per recuperar la clau d'acces ha expirat, per favor sol·liciteu un altre",
	
	    //Recovery
	    'SIGN_IN_AGAIN': "Iniciar sessió de nou",
	    'INTERNAL_ERROR': "Error intern",
	    'Invalid username or email': "Nom d'usuari no vàlid",
	    'Password request alerady requested': "Sol·licitud de clau d'acces ja ha estat sol·licitada",
	    'SEND_EMAIL_REQUEST_SUCCESS': "T'hem enviat un email amb els passos per restablir la clau d'acces.",
	
	    //Register
	    'USER': "Usuari",
	    'USERNAME': "Nom d'usuari",
	    'USERNAME_REASON': "El nom d'usuari es farà servir perquè et puguem identificar a la pantalla de login",
	    'PRESCRIBER': "Prescriptor",
	    'USERNAME_REQUIRED': "Es requereix nom d'usuari",
	    'ACCEPT_TERMS_SERVICE': "Estic d'acord amb els termes del servei",
	    'YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED': "Ha d'acceptar els termes de servei abans de continuar",
	    'USERNAME_ALREADY_TAKEN': "El nom d'usuari ja aquesta fet servir",
	    'CREATED_CHECK_YOUR_EMAIL': 'El seu compte ha estat creat amb èxit, comprova el seu correu electrònic.',
	    'MALFORMET_DATA': 'S\'ha Produït errors en el formulari',
	    'PASSWORD_SHORT': "La clau d'acces és massa curta",
	
	    //Account
	    'YOU_ARE': "Tipus d'usuari",
	    'YOUR_LICENCES': "Les teves llicències",
	    'MANAGE_LICENCES': "Administrar llicències",
	    'YOUR_SUBSCRIPTIONS': "Les teves subscripcions",
	    'NEED_MORE_LICENCES': "¿Necessita més llicències?",
	    'PURCHASE_LICENCES': "Llicències de compra",
	    'PURCHASE_SUBSCRIPTIONS': "Comprar Subscripcions",
	    'ADD_LICENCE': "Afegir llicència",
	    'RECHARGE_SUBSCRIPTIONS': "Subscripcions de recàrrega",
	    'ACTIVE_UNUSED': "Actiu / no utilitzat",
	    'MANAGE_SUSCRIPTIONS': "Administrar Subscripcions",
	    'ADD_SUSCRIPTIONS': "Afegir subscripcions",
	    'ORDERS_INVOICES': "Comandes i factures",
	    'YOUR_LAST_PAYMENT': "El seu últim pagament, de",
	    'WAS_MADE_ON': "Va ser fet a",
	    'SHOW_ORDERS': "Mostra comandes & factures",
	    'Company': 'Empresa',
	    'Prescriber': 'Prescriptor',
	    'Patient': 'Pacient',
	
	    //calendary
	    'january': "gener",
	    'february': "febrer",
	    'march': "març",
	    'april': "abril",
	    'mayo': "maig",
	    'june': "juny",
	    'july': "juliol",
	    'august': "agost",
	    'september': "setembre",
	    'october': "octubre",
	    'november': "novembre",
	    'december': "desembre",
	
	    //Licences
	    'LICENCE': "Llicència",
	    'ASSIGNED_TO': "Assignat a",
	    'EXPIRATION_AT': "Expira el",
	    'MAC': "Mac",
	    'REASSIGN_THIS_LICENCE': "Reassignar aquesta llicència",
	    'CHOOSE_AN_USER': "Tria un usuari",
	    'SELECT_AN_USER': "Selecciona un usuari",
	    'REVOKE_MAC_LICENCE': "Revocar aquesta llicència de Mac",
	    'REASSIGN': "Reassignar",
	    'REMOVE_YOUR_LICENCE_LINK': "Li agradaria eliminar el seu enllaç de llicència?",
	    'REMOVE_YOUR_LICENCE_LINK_TEXT': "En eliminar l'enllaç de llicència podria utilitzar aquesta llicència en un altre equip. de cerca:' + 'Recordeu que el nou equip estarà vinculat a aquesta llicència",
	    'LUCKY_DAY': "Bon dia",
	    'SUCCESS_REMOVE_LICENCE': "El seu enllaç de llicència s'ha eliminat",
	    'MANUAL_INVOICE': 'Factura manual',
	    'NO_LICENCE': 'Necessita una llicència activa',
	    'NO_LICENCE_BUY': 'Si us plau compri una llicència',
	
	    //Purchases
	    'SELECT_PRODUCT': "Seleccionar producte",
	    'PROMOTIONAL_CODE': "Té un codi promocional?",
	    'CODE_DOES_NOT_PROMOTION': "El codi no té cap promoció",
	    'TOTAL_ITEMS': "Articles totals",
	    'TAXES': "Impostos",
	    'AMOUNT_PAYABLE': "Total a pagar",
	    'USE_MY_ACCOUNT_INFORMATION_INVOICE': "Utilitza la informació del meu compte per a la factura",
	    'USE_OTHER_INFORMATION_INVOICE': "Utilitza una altra informació per a la factura",
	    'NAME': "Nom",
	    'NAME_REQUIRED': "Es requereix el nom",
	    'SURNAME': "Cognom",
	    'SURNAME_REQUIRED': "El cognom és obligatori",
	    'COMPANY': "Empresa",
	    'CIF/NIF': "CIF/NIF",
	    'CIF_NIF_REQUIRED': "CIF o NIF és necessari",
	    'ADDRESS': "Direcció",
	    'CITY': "Ciutat",
	    'STATE': "Província",
	    'COMPANY_REQUIRED': "L'empresa és requerida",
	    'POSTAL_CODE': "Codi postal",
	    'YOU_SUPPLY_POSTAL_CODE': "Ha de proporcionar un codi postal",
	    'THAT_DOESNT_LOOK_LIKE_VALID_PC': "Això no sembla un codi postal vàlid",
	    'BUY_LICENCE': "Comprar",
	    'BUY_SUSCRIPTIONS': "Comprar",
	    'ORDER': "Ordre",
	    'YOU_MUST_MAKE_BANK_TRANSFER': "Ha de fer una transferència bancària al",
	    'WITH_THE_CONCEPT': "Amb el concepte",
	    'PAY_WITH_PAYPAL': "Pagar amb PayPal",
	    'PAY_WITH_CREDIT_CARD': "Pagar amb targeta de crèdit",
	    'PAY_WITH_WIRE_TRANSFER': "Pagar amb transferència bancària",
	    'SELECT_METHOD': "Selecciona un mètode",
	    'YOU_DONT_HAVE_PERMISSION_AREA': "No tens permís en aquesta àrea",
	    'UNIT_PRICE': "La unitat surt a",
	    'YOUR_PENDING_REMOVED': "La seva compra pendent s'ha eliminat",
	    'CONFIRM_REMOVE_PURCHASE_PENDING': "Vols eliminar aquesta compra pendent?",
	    'CANCEL': "Cancel",
	    'REMOVE!': "Eliminar!",
	    'BUY_SUCCESS': "La seva comanda ha estat tramitat correctament.",
	    'CIF_NIF_ALREADY_EXISTS': "El cif/nif/nie ja existeix",
	    'CIF_NIF_INVALID': "El cif/nif/nie no és vàlid",
	    'PHONE_REQUIRED': "El telèfon és obligatori",
	    'ADDRESS_REQUIRED': "L'adreça és obligatòria",
	    'CITY_REQUIRED': "La ciutat és obligatória",
	
	    //ERRORS
	    'PLEASE_INSERT_NUMERIC_VAL': "Please insert a numeric value!",
	    'NOT_ENOUGH_SUBS': "No té suficients subscripcions",
	    'USER_HAS_NOT_SUBS': "Aquest usuari no té subscripció",
	    'UNAUTORITHED': "Sense autorització",
	    'INVALID_DETAILS_IN_FORM': "Alguns valors no són vàlids, vegeu els detalls del formulari",
	
	    //thanks
	    'THANK_YOU': "Gràcies",
	    'THE_PURCHASE_WAS_MADE_CORRECTLY': "La compra es va realitzar correctament, pot administrar les seves compres a la secció del seu compte",
	
	    //Profile
	    'PROFILE': "Perfil",
	    'EMAIL': "Email",
	    'EMAIL_REQUIRED': "Email és requerit",
	    'EMAIL_NOT_VALID': "Email no és vàlid",
	    'EMAIL_ALREADY_TAKEN': "Email ja acceptat o no vàlid",
	    'BIRTHDAY': "Data de naixement",
	    'MATURATIVE_AGE': 'Edat madurativa',
	    'BIRTHDAY_REQUIRED': "Eaniversari és requerit",
	    'PRESCRIBER_TYPE': "Tipus d'prescriptor",
	    'PRESCRIBER_TYPE_REQUIRED': "Es requereix el tipus de prescripció",
	    'UPDATE_MY_DATA': "Actualitzar les meves dades",
	    'CHANGE_PASSWORD': "Canviar clau d'acces",
	    'PROFILE_UPDATE': "El teu perfil ha estat actualitzat",
	
	    //Subscriptions
	    'MANAGE_SUBSCRIPTIONS': "Administrar Subscripcions",
	    'PRESCRIPTOR': "Prescriptor",
	    'PATIENT': "Pacient",
	    'PATIEN_EMAIL': "Ppacient Email",
	    'STATUS': "Estat",
	    'NUM_SUBSCRIPTIONS': "Número de subscripcions",
	    'EXPIRATE_AT': "Expira el",
	    'LINK_SUBSCRIPTION': "Vincular una nova subscripció",
	    'UNLINK_SUBSCRIPTION': "Desvincular aquesta subscripció",
	    'ADD_SUBSCRIPTION': "Afegir més subscripcions",
	    'NO_SERS_YET': "No hi ha usuaris encara",
	    'WOULD_LIKE_ADD_NEW_USER': "Vols afegir un nou usuari?",
	    'active': 'Actiu',
	    'inactive': 'Inactiu',
	    'MODAL_CANCEL': 'Cancel',
	    'ADD_SUBSCRIPTION_TITLE': 'Quants mesos de subscripció vol afegir?',
	    'ADD_SUBSCRIPTION_CONTENT': "Cada unitat de subscripció és equivalent a 1 mes. <br> Si vols que un usuari tingui 3 mesos de subscripció, afegiu 3. <br> Nota: cada unitat consumeix un subscriptor del total.",
	    'ADD_SUBSCRIPTION_INPUT': 'Número de subscripcions',
	    'ADD_SUBSCRIPTION_SUCCESS': "La suscripción s'ha afegit correctament.",
	    'ADD_SUBSCRIPTION_BUTTON': 'Afegir subscripció!',
	    'REMOVE_SUBSCRIPTION_TITLE': 'Segur que desitja eliminar aquesta subscrición a aquest usuari?',
	    'REMOVE_SUBSCRIPTION_CONTENT': 'En eliminar la subscripció, l\'usuari ja no tindrà accés.',
	    'REMOVE_SUBSCRIPTION_BUTTON': 'Eliminar!',
	    'REMOVE_SUBSCRIPTION_SUCCESS': "La subscripció s'ha eliminat correctament",
	    'NO_USERS_YET': "No té usuaris",
	    'ENOUGH_SUBSCRIPTION_TITLE': 'No tens prou subscripcions',
	    'ENOUGH_SUBSCRIPTION': 'No té més subscripcions per assignar. <br> Comprar més o avisa al seu administrador',
	    'OK': 'Val',
	    'LAST_ASSINGED': 'Darrera assignació',
	
	    //Invoices
	    'INVOICES': "Factures",
	    'PRODUCT': "Producte",
	    'AMOUNT': "Quantitat",
	    'DATE': "Data",
	    'DOWNLOAD_INVOICE': "Descarregar factura",
	    'NO_PURCHASE_YET': "No hi ha compra encara",
	    'PENDING_ORDERS': "Ordres pendents",
	    'MAKE_PAYMENT_NOW': "Realitzar el pagament ara",
	    'REMOVE_PENDING_ORDER': "Eliminar aquesta ordre pendent",
	    'PAYMENTS': 'Abonaments',
	    'PAYMENT': 'Abonament',
	
	    //summary
	    'MONTHLY_REVENUE': "Benefici Mensual",
	    'VIEW_DETAILS': "Veure detalls",
	    'PENDING_REVIEWS': "Ressenyes pendents",
	    'NEW_CUSTOMERS': "Nous clients",
	
	    //Products
	    'ABBR': "Abbr",
	    'PRICE': "Preu",
	    'PRICE_MONTH': "Preu total",
	    'ENROLLMENT': "Matricula",
	    'PROMOTIONAL': "Promocional",
	    'TYPE': "Tipus",
	    'UNITS': "Unitats",
	    'GAME': "Joc",
	
	    //Variables
	    'ABBREVIATION': "Abreviatura",
	    'DESCRIPTION': "Descripció",
	    'FLOAT': "Float",
	    'INTEGER': "Integer",
	    'BOOLEAN': "Boolean",
	    'MULTIPLE': "Multiple",
	    'REPETITIONS': "Repetitions",
	    'MODIFY_FIXED': "Modificar fix",
	    'MODIFY_RELATION': "Modificar Relació",
	    'HARDNESS_INITIAL': "Duresa Inicial",
	    'MODIFY_VARIABLE': "Modificar la variable",
	    'STEPS': "Passos",
	    'KEY': "Clau",
	    'VALUE': "Valor",
	
	    //Game
	    'WEIGHT': "Pes",
	    'ABILITY': "Habilitat",
	    'PERCENTAGE': "Percentatge",
	    'ADD': "Añadir",
	    'VARIABLE': "Variable",
	    'INCLUDED': "Inclòs",
	    'ONLY_GOLD': 'Només visible en PRO',
	    'VISIBLE_AUTOMATIC': 'NO visible en teràpia automàtica',
	
	    //Entities
	    'ID': "Id",
	    'FINALIZED': "Finalitzat",
	    'IDENTIFIER': "Identificador",
	    'IP': "Ip",
	    'METHOD': "Mètode",
	    'UPDATED': "Actualitzat",
	    'PAYPAL': "PayPal",
	    'CREDIT_CARD': "Targeta de Crèdit",
	    'WIRE_TRANSFER': "Transferència Bancària",
	    'SUBSCRIPTION': "Subscripció",
	    'CODE': "Codi",
	
	    //User
	    'user': "usuari",
	    'Users': "Usuaris",
	    'ENABLED': "Habilitat",
	    'CREATED': "Creat",
	    'ROLES': "Rols",
	    'WORKERS': "Treballadors",
	    'PATIENTS': "Pacients",
	    'CIF': "Cif",
	    'TRAINING_TIME_MIN': "Temps d'entrenament (min)",
	    'TRAINING_TIME': "Temps d'entrenament",
	    'TRAINING_DATE': "Data d'entrenament",
	    'USER_TEST': "Usuari de Test",
	
	    //Download
	    'DOWNLOAD': 'Descarregar',
	    'TEXT_DOWNLOAD': 'Descarrega aquí el teu gestor d\'aplicacions',
	
	    //Licences VR
	    'LICENCES_GAME_VR': 'Licencias GAME VR',
	
	    //Events
	    'EVENTS': 'Esdeveniments',
	    'LOCATION': 'Localizació',
	    'LOCATION_MAP': 'Localizació en mapa google',
	    'INTERESTED': 'Interessats',
	    'IMAGE': 'Imatge',
	    'PHONE': 'Telèfon',
	
	    //ORDERS
	    'purchase': "compra",
	    'User': "Usuari",
	    'Product': "Producte",
	    'Status': "Estat",
	    'Status Code': "Codi d'estat",
	    'Method': "Mètode",
	
	    // Promo
	    'PROMO_UNAVAIABLE': 'La prova gratuïta ja a estat usada',
	    'PROMO_REQUEST': 'Sol·licita la teva prova gratuïta',
	    'PROMO_REGISTER': 'Registre per prova gratuïta',
	    'PROMO_CREATED_CHECK_YOUR_EMAIL': 'Li hem enviat els passos a seguir per email.',
	    'PROMO_PROBLEM_TITLE': "Se produjo un error",
	    'PROMO_PROBLEM_TEXT': "S'han detectat errors i no pot continuar amb el registre per a la prova gratuïta, <br>si us plau enviï un correu electrònic a <a href=\"mailto:info@brainvt.com?Subject=Error pera a proba gratuïta\">info@brainvt.com</a> o trucant al 619 871 407"
	};

/***/ },
/* 169 */
/***/ function(module, exports) {

	'use strict';
	
	var _module$exports;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	module.exports = (_module$exports = {
	
	    'OLD_PASSWORD': 'Old password',
	    'OLD_PASSWORD_REQUIRED': 'Old password is required',
	    'OLD_PASSWORD_NOT': 'Old password is incorrect',
	    'NEW_PASSWORD': 'New password',
	    'NEW_PASSWORD_REQUIRED': 'New password is required',
	    'CONFIRM_PASSWORD': 'Confirm password',
	    'CONFIRM_PASSWORD_REQUIRED': 'Confirm password is required',
	    'CONFIRM_PASSWORD_SAME': 'Passwords must be the same',
	
	    // NG-Admin
	    'BACK': 'Back',
	    'DELETE': 'Delete',
	    'CREATE': 'Create',
	    'EDIT': 'Edit',
	    'EXPORT': 'Export',
	    'ADD_FILTER': 'Add filter',
	    'SEE_RELATED': 'See all related {{ entityName }}',
	    'LIST': 'list',
	    'SHOW': 'Show',
	    'SAVE': 'Save',
	    'N_SELECTED': '{{ length }} Selected',
	    'ARE_YOU_SURE': 'Are you sure?',
	    'YES': 'Yes',
	    'NO': 'No',
	    'FILTER_VALUES': 'Filter values',
	    'CLOSE': 'Close',
	    'CLEAR': 'Clear',
	    'CURRENT': 'Current',
	    'REMOVE': 'Remove',
	    'ADD_NEW': 'Add new {{ name }}',
	    'BROWSE': 'Browse',
	    'N_COMPLETE': '{{ progress }}% Complete',
	    'CREATE_NEW': 'Create new',
	    'SUBMIT': 'Submit',
	    'SAVE_CHANGES': 'Save changes',
	    'BATCH_DELETE_SUCCESS': 'Elements successfully deleted',
	    'DELETE_SUCCESS': 'Element successfully deleted',
	    'ERROR_MESSAGE': 'Oops, an error occurred (code: {{ status }})',
	    'INVALID_FORM': 'Invalid form',
	    'CREATION_SUCCESS': 'Element successfully created',
	    'EDITION_SUCCESS': 'Changes successfully saved',
	    'ACTIONS': 'Actions',
	    'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>',
	    'NO_PAGINATION': 'No record found',
	    'PREVIOUS': '« Prev',
	    'NEXT': 'Next »',
	    'DETAIL': 'Detail',
	    'STATE_CHANGE_ERROR': 'State change error: {{ message }}',
	    'NOT_FOUND': 'Not Found',
	    'NOT_FOUND_DETAILS': 'The page you are looking for cannot be found. Take a break before trying again.',
	
	    //lang
	    'SPANISH': "Spanish",
	    'ENGLISH': "English",
	    'CATALAN': "Catalan",
	
	    //Menu
	    'ORDERS': "Orders",
	    'ACCOUNT': "Account",
	    'PURCHASES': "Purchases",
	    'DOWNLOADS': "Downloads",
	    'USERS': "Users",
	    'USER_LIST': "Patients list",
	    'PRENSCRIBER_LIST': "Profesionals lists",
	    'COMPANY_LIST': "Company list",
	    'PRESCRIBER_TYPES': "Prescriber Types",
	    'PRODUCTS': "Products",
	    'SUBSCRIPTIONS': "Subscriptions",
	    'LICENCES': "licences",
	    'LICENCES_TEXT': 'All licenses are subject to annual maintenance and the signing of a contract',
	    'GAMES': "Games",
	    'CONFIG': "Config",
	    'VARIABLES': "Variables",
	    'ABILITIES': "Abilities",
	    'LOGOUT': "Logout",
	    'PRESNCRIPTORS': 'Prescriptors',
	    'PROFESSIONAL_MANUAL': "Professional's manual",
	    'PROFESSIONAL_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/manual_profesional_eng.pdf',
	    'USER_MANUAL': "User's guide",
	    'USER_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/guia_usuario_cast.pdf',
	    'VIDEOS_TUTORIAL': 'Tutorial videos',
	
	    // Login
	    'REGISTER': "Register",
	    'LOGIN': "Login",
	    'USERNAME_OR_EMAIL': "Username",
	    'RECOVERY_PASSWORD': "Recovery password",
	    'USERNAME_EMAIL_RECOVERY': "Username is required.",
	    'PASSWORD_REQUIRED': "Password is required.",
	    'LETS_GO': "Let's go",
	    'PASSWORD': "Password",
	    'ERROR_USSER_PASSWORD_INCORRECT': "Username or password is incorrect",
	    'LOGIN_REGISTER': "Sign up",
	    'OR': "or",
	    'ERROR_LINK_EXPIRED': 'The link to retrieve password has expired, please request another one',
	
	    //Recovery
	    'SIGN_IN_AGAIN': "Sign in again",
	    'INTERNAL_ERROR': "Internal error",
	    'Invalid username or email': "Invalid username",
	    'Password request alerady requested': "Password request alerady requested",
	    'SEND_EMAIL_REQUEST_SUCCESS': "We have sent you an email with the steps to reset the password",
	
	    //Register
	    'USER': "User",
	    'USERNAME': "Username",
	    'USERNAME_REASON': 'The username will be used so that we can identify you on the login screen',
	    'PRESCRIBER': "Prescriber",
	    'USERNAME_REQUIRED': "Username is required",
	    'ACCEPT_TERMS_SERVICE': "I accept the terms of service",
	    'YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED': "You must accept the terms of service before you can proceed",
	    'USERNAME_ALREADY_TAKEN': "Username already taken",
	    'CREATED_CHECK_YOUR_EMAIL': 'Your account has been created successfully, check your email.',
	    'MALFORMET_DATA': 'Malformet data',
	    'PASSWORD_SHORT': 'The password is too short',
	
	    //Account
	    'MANAGE_LICENCES': "Manage Licences",
	    'YOU_ARE': "User type",
	    'YOUR_LICENCES': "Your licences",
	    'YOUR_SUBSCRIPTIONS': "Your subscriptions",
	    'NEED_MORE_LICENCES': "Need more licences?",
	    'PURCHASE_LICENCES': "Purchase licences",
	    'PURCHASE_SUBSCRIPTIONS': "Buy Subscriptions",
	    'ADD_LICENCE': "Add licence",
	    'RECHARGE_SUBSCRIPTIONS': "Recharge subscriptions",
	    'ACTIVE_UNUSED': "active / unused",
	    'MANAGE_SUSCRIPTIONS': "Manage suscriptions",
	    'ADD_SUSCRIPTIONS': "Add suscriptions",
	    'ORDERS_INVOICES': "Orders & Invoices",
	    'YOUR_LAST_PAYMENT': "Your last payment, of",
	    'WAS_MADE_ON': "was made on",
	    'SHOW_ORDERS': "Show orders & invoices",
	
	    //Licences
	    'LICENCE': "Licence",
	    'ASSIGNED_TO': "Assigned to",
	    'EXPIRATION_AT': "Expiration at",
	    'MAC': "Mac",
	    'REASSIGN_THIS_LICENCE': "Reassign this licence",
	    'CHOOSE_AN_USER': "Choose an user",
	    'SELECT_AN_USER': "Select an user",
	    'REVOKE_MAC_LICENCE': "Revoke this mac licence",
	    'REASSIGN': "Reassign",
	    'REMOVE_YOUR_LICENCE_LINK': "Would you like to remove your licence link?",
	    'REMOVE_YOUR_LICENCE_LINK_TEXT': "By removing the license link you could use this license on another computer. <br>' + 'Note that the new computer will be linked to this license",
	    'LUCKY_DAY': "Lucky day",
	    'SUCCESS_REMOVE_LICENCE': "Your licence link has been removed",
	    'MANUAL_INVOICE': 'Manual Invoice',
	    'NO_LICENCE': 'You need an active license',
	    'NO_LICENCE_BUY': 'Please buy a license',
	
	    //Purchases
	    'SELECT_PRODUCT': "Select a product",
	    'PROMOTIONAL_CODE': "Do you have a promotional code?",
	    'CODE_DOES_NOT_PROMOTION': "The code does not have any promotion",
	    'TOTAL_ITEMS': "Total Items",
	    'TAXES': "Taxes",
	    'AMOUNT_PAYABLE': "Amount payable",
	    'USE_MY_ACCOUNT_INFORMATION_INVOICE': "Use my account information for the invoice",
	    'USE_OTHER_INFORMATION_INVOICE': "Use other information for the invoice",
	    'NAME': "Name",
	    'NAME_REQUIRED': "Name is required",
	    'SURNAME': "Surname",
	    'SURNAME_REQUIRED': "Surname is required",
	    'COMPANY': "Company",
	    'CIF/NIF': "CIF/NIF",
	    'CIF_NIF_REQUIRED': "CIF or NIF is required",
	    'ADDRESS': "Address",
	    'ADDRESS_REQUIRED': "Address is required",
	    'COMPANY_REQUIRED': "Company is required",
	    'POSTAL_CODE': "Postal Code",
	    'CITY': "City",
	    'STATE': "State",
	    'YOU_SUPPLY_POSTAL_CODE': "You must supply a postal code",
	    'THAT_DOESNT_LOOK_LIKE_VALID_PC': "That doesn't look like a valid postal code",
	    'BUY_LICENCE': "Buy",
	    'BUY_SUSCRIPTIONS': "Buy",
	    'ORDER': "Order",
	    'YOU_MUST_MAKE_BANK_TRANSFER': "You must make a bank transfer to",
	    'WITH_THE_CONCEPT': "with the concept",
	    'PAY_WITH_PAYPAL': "Pay with Paypal",
	    'PAY_WITH_CREDIT_CARD': "Pay with credit card",
	    'PAY_WITH_WIRE_TRANSFER': "Pay with wire transfer",
	    'SELECT_METHOD': "Select a method",
	    'YOU_DONT_HAVE_PERMISSION_AREA': "You don't have permission in this area",
	    'UNIT_PRICE': "The unit comes out",
	    'YOUR_PENDING_REMOVED': "Your pending purchase has been removed",
	    'CONFIRM_REMOVE_PURCHASE_PENDING': "Would you like to remove this pending purchase?",
	    'CANCEL': "Cancel",
	    'REMOVE!': "Remove!",
	    'BUY_SUCCESS': "Your order has been processed correctly.",
	    'CIF_NIF_ALREADY_EXISTS': "The cif/nif/nie already exists",
	    'CIF_NIF_INVALID': "The cif/nif/nie is invalid",
	    'PHONE_REQUIRED': "The phone is requierd"
	}, _defineProperty(_module$exports, 'ADDRESS_REQUIRED', "The address is requierd"), _defineProperty(_module$exports, 'CITY_REQUIRED', "The city is requied"), _defineProperty(_module$exports, 'PLEASE_INSERT_NUMERIC_VAL', "Si us plau, introduïu un valor numèric!"), _defineProperty(_module$exports, 'NOT_ENOUGH_SUBS', "You do not have enough subscriptions"), _defineProperty(_module$exports, 'USER_HAS_NOT_SUBS', "This user has not subscription"), _defineProperty(_module$exports, 'UNAUTORITHED', "Unautorithed"), _defineProperty(_module$exports, 'INVALID_DETAILS_IN_FORM', "Some values are invalid, see details in the form"), _defineProperty(_module$exports, 'THANK_YOU', "Thank you"), _defineProperty(_module$exports, 'THE_PURCHASE_WAS_MADE_CORRECTLY', "The purchase was made correctly, you can manage your purchases in the section of your account"), _defineProperty(_module$exports, 'ERROR', "Error"), _defineProperty(_module$exports, 'COULD_NOT_COMPLETE_PURCHASE', "Could not complete purchase"), _defineProperty(_module$exports, 'PROFILE', "Profile"), _defineProperty(_module$exports, 'EMAIL', "Email"), _defineProperty(_module$exports, 'EMAIL_REQUIRED', "Email is required"), _defineProperty(_module$exports, 'EMAIL_NOT_VALID', "Email is not valid"), _defineProperty(_module$exports, 'EMAIL_ALREADY_TAKEN', "Email already taken or is not valid"), _defineProperty(_module$exports, 'BIRTHDAY', "Birthdate"), _defineProperty(_module$exports, 'MATURATIVE_AGE', 'Maturative age'), _defineProperty(_module$exports, 'BIRTHDAY_REQUIRED', "Birthday is required"), _defineProperty(_module$exports, 'PRESCRIBER_TYPE', "Prescriber Type"), _defineProperty(_module$exports, 'PRESCRIBER_TYPE_REQUIRED', "Prescriber type is required"), _defineProperty(_module$exports, 'UPDATE_MY_DATA', "Update my data"), _defineProperty(_module$exports, 'CHANGE_PASSWORD', "Change password"), _defineProperty(_module$exports, 'PROFILE_UPDATE', "Your profile has been updated"), _defineProperty(_module$exports, 'MANAGE_SUBSCRIPTIONS', "Manage Subscriptions"), _defineProperty(_module$exports, 'PRESCRIPTOR', "Prescriptor"), _defineProperty(_module$exports, 'PATIENT', "Patient"), _defineProperty(_module$exports, 'PATIEN_EMAIL', "Patien Email"), _defineProperty(_module$exports, 'STATUS', "Status"), _defineProperty(_module$exports, 'NUM_SUBSCRIPTIONS', "Num of subscriptions"), _defineProperty(_module$exports, 'EXPIRATE_AT', "Expirate at"), _defineProperty(_module$exports, 'LINK_SUBSCRIPTION', "Link a new subscription"), _defineProperty(_module$exports, 'UNLINK_SUBSCRIPTION', "Unlink this subscription"), _defineProperty(_module$exports, 'ADD_SUBSCRIPTION', "Add more subscriptions"), _defineProperty(_module$exports, 'NO_SERS_YET', "No users yet"), _defineProperty(_module$exports, 'WOULD_LIKE_ADD_NEW_USER', "Would you like add a new user?"), _defineProperty(_module$exports, 'active', 'Active'), _defineProperty(_module$exports, 'inactive', 'Inactive'), _defineProperty(_module$exports, 'MODAL_CANCEL', 'Cancel'), _defineProperty(_module$exports, 'ADD_SUBSCRIPTION_TITLE', 'How many months do you want to have a subscription?'), _defineProperty(_module$exports, 'ADD_SUBSCRIPTION_CONTENT', "Each subscription unit is equivalent to 1 month. <br> If you want a user to have 3 months of subscription add 3. <br> Note: that each unit consumes a subscriber of the total."), _defineProperty(_module$exports, 'ADD_SUBSCRIPTION_INPUT', 'Number of subscriptions'), _defineProperty(_module$exports, 'ADD_SUBSCRIPTION_SUCCESS', "The subscription link has been added"), _defineProperty(_module$exports, 'ADD_SUBSCRIPTION_BUTTON', 'Add subscription!'), _defineProperty(_module$exports, 'REMOVE_SUBSCRIPTION_TITLE', 'Would you like to remove the subscription link?'), _defineProperty(_module$exports, 'REMOVE_SUBSCRIPTION_CONTENT', 'By removing the subscription link the user will no longer have access immediately.'), _defineProperty(_module$exports, 'REMOVE_SUBSCRIPTION_BUTTON', 'Remove!'), _defineProperty(_module$exports, 'REMOVE_SUBSCRIPTION_SUCCESS', "Your subscription has been successfully deleted"), _defineProperty(_module$exports, 'NO_USERS_YET', "No users yet"), _defineProperty(_module$exports, 'ENOUGH_SUBSCRIPTION_TITLE', 'You do not have enough subscriptions'), _defineProperty(_module$exports, 'ENOUGH_SUBSCRIPTION', 'You do not have more subscriptions to assign. <br> Buy more or notify your administrator.'), _defineProperty(_module$exports, 'OK', 'ok'), _defineProperty(_module$exports, 'LAST_ASSINGED', 'Last assignment'), _defineProperty(_module$exports, 'INVOICES', "Invoices"), _defineProperty(_module$exports, 'PRODUCT', "Product"), _defineProperty(_module$exports, 'AMOUNT', "Amount"), _defineProperty(_module$exports, 'DATE', "Date"), _defineProperty(_module$exports, 'DOWNLOAD_INVOICE', "Download invoice"), _defineProperty(_module$exports, 'NO_PURCHASE_YET', "No purchase yet"), _defineProperty(_module$exports, 'PENDING_ORDERS', "Pending orders"), _defineProperty(_module$exports, 'MAKE_PAYMENT_NOW', "Make payment now"), _defineProperty(_module$exports, 'REMOVE_PENDING_ORDER', "Remove this pending order"), _defineProperty(_module$exports, 'PAYMENTS', 'Payments'), _defineProperty(_module$exports, 'PAYMENT', 'Payment'), _defineProperty(_module$exports, 'MONTHLY_REVENUE', "Monthly Revenue"), _defineProperty(_module$exports, 'VIEW_DETAILS', "View Details"), _defineProperty(_module$exports, 'PENDING_REVIEWS', "Pending reviews"), _defineProperty(_module$exports, 'NEW_CUSTOMERS', "New customers"), _defineProperty(_module$exports, 'ABBR', "Abbr"), _defineProperty(_module$exports, 'PRICE', "Price"), _defineProperty(_module$exports, 'PRICE_MONTH', "Total price"), _defineProperty(_module$exports, 'ENROLLMENT', "Enrollment"), _defineProperty(_module$exports, 'PROMOTIONAL', "Promotional"), _defineProperty(_module$exports, 'TYPE', "Type"), _defineProperty(_module$exports, 'UNITS', "Units"), _defineProperty(_module$exports, 'GAME', "Game"), _defineProperty(_module$exports, 'ABBREVIATION', "Abbreviation"), _defineProperty(_module$exports, 'DESCRIPTION', 'Description'), _defineProperty(_module$exports, 'FLOAT', "Float"), _defineProperty(_module$exports, 'INTEGER', "Integer"), _defineProperty(_module$exports, 'BOOLEAN', "Boolean"), _defineProperty(_module$exports, 'MULTIPLE', "Multiple"), _defineProperty(_module$exports, 'REPETITIONS', "Repetitions"), _defineProperty(_module$exports, 'MODIFY_FIXED', "Modify Fixed"), _defineProperty(_module$exports, 'MODIFY_RELATION', "Modify Relation"), _defineProperty(_module$exports, 'HARDNESS_INITIAL', "Hardness Initial"), _defineProperty(_module$exports, 'MODIFY_VARIABLE', "Modify Variable"), _defineProperty(_module$exports, 'STEPS', "Steps"), _defineProperty(_module$exports, 'KEY', "Key"), _defineProperty(_module$exports, 'VALUE', "Value"), _defineProperty(_module$exports, 'WEIGHT', "Weight"), _defineProperty(_module$exports, 'ABILITY', "Ability"), _defineProperty(_module$exports, 'PERCENTAGE', "Percentage"), _defineProperty(_module$exports, 'ADD', "Afegir"), _defineProperty(_module$exports, 'VARIABLE', "Variable"), _defineProperty(_module$exports, 'INCLUDED', "Included"), _defineProperty(_module$exports, 'ONLY_GOLD', 'Only visible in PRO GOLD'), _defineProperty(_module$exports, 'VISIBLE_AUTOMATIC', 'NO visible in automatic therapy'), _defineProperty(_module$exports, 'ID', "Id"), _defineProperty(_module$exports, 'FINALIZED', "Finalized"), _defineProperty(_module$exports, 'IDENTIFIER', "Identifier"), _defineProperty(_module$exports, 'IP', "Ip"), _defineProperty(_module$exports, 'METHOD', "Method"), _defineProperty(_module$exports, 'UPDATED', "Updated"), _defineProperty(_module$exports, 'PAYPAL', "PayPal"), _defineProperty(_module$exports, 'CREDIT_CARD', "Credit Card"), _defineProperty(_module$exports, 'WIRE_TRANSFER', "Wire Transfer"), _defineProperty(_module$exports, 'SUBSCRIPTION', "Subscription"), _defineProperty(_module$exports, 'CODE', "Code"), _defineProperty(_module$exports, 'user', "user"), _defineProperty(_module$exports, 'Users', "Users"), _defineProperty(_module$exports, 'ENABLED', "Enabled"), _defineProperty(_module$exports, 'CREATED', "Created"), _defineProperty(_module$exports, 'ROLES', "Roles"), _defineProperty(_module$exports, 'WORKERS', "Workers"), _defineProperty(_module$exports, 'PATIENTS', "Patients"), _defineProperty(_module$exports, 'CIF', "Cif"), _defineProperty(_module$exports, 'TRAINING_TIME_MIN', "Training Time (min)"), _defineProperty(_module$exports, 'TRAINING_TIME', "Training Time"), _defineProperty(_module$exports, 'TRAINING_DATE', "Training Date"), _defineProperty(_module$exports, 'USER_TEST', "Test User"), _defineProperty(_module$exports, 'DOWNLOAD', 'Download'), _defineProperty(_module$exports, 'TEXT_DOWNLOAD', 'Download here your application manager'), _defineProperty(_module$exports, 'LICENCES_GAME_VR', 'Licences GAME VR'), _defineProperty(_module$exports, 'EVENTS', 'Events'), _defineProperty(_module$exports, 'LOCATION', 'Location'), _defineProperty(_module$exports, 'LOCATION_MAP', 'Location in google maps'), _defineProperty(_module$exports, 'INTERESTED', 'Interested'), _defineProperty(_module$exports, 'IMAGE', 'Image'), _defineProperty(_module$exports, 'PHONE', 'Phone'), _defineProperty(_module$exports, 'PROMO_UNAVAIABLE', 'The free trial has already been used'), _defineProperty(_module$exports, 'PROMO_REQUEST', 'Request your free trial'), _defineProperty(_module$exports, 'PROMO_REGISTER', 'Registration free trial'), _defineProperty(_module$exports, 'PROMO_CREATED_CHECK_YOUR_EMAIL', 'We have sent you the following steps by email.'), _defineProperty(_module$exports, 'PROMO_PROBLEM_TITLE', "There was an error"), _defineProperty(_module$exports, 'PROMO_PROBLEM_TEXT', "Errors have been detected and you can not continue registration for the free trial, <br>please send an email to <a href=\"mailto:info@brainvt.com?Subject=Error for free trial\">info@brainvt.com</a> or by calling"), _module$exports);

/***/ },
/* 170 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	
	    'OLD_PASSWORD': 'Antigua contraseña',
	    'OLD_PASSWORD_REQUIRED': 'Se requiere la antigua contraseña',
	    'OLD_PASSWORD_NOT': 'La antigua contraseña no es correcta',
	    'NEW_PASSWORD': 'Nueva contraseña',
	    'NEW_PASSWORD_REQUIRED': 'Se requiere la nueva contraseña',
	    'CONFIRM_PASSWORD': 'Confirmar contraseña',
	    'CONFIRM_PASSWORD_REQUIRED': 'Se requiere confirmación dela contraseña',
	    'CONFIRM_PASSWORD_SAME': 'Las contraseñas no coinciden',
	
	    // NG-Admin
	    'BACK': 'Volver',
	    'DELETE': 'Eliminar',
	    'CREATE': 'Crear',
	    'EDIT': 'Editar',
	    'EXPORT': 'Exportar',
	    'ADD_FILTER': 'Añadir filtro',
	    'SEE_RELATED': 'Ver todo relacionado de {{ entityName }}',
	    'LIST': 'lista',
	    'SHOW': 'Mostrar',
	    'SAVE': 'Guardar',
	    'N_SELECTED': '{{ length }} Seleccionado',
	    'ARE_YOU_SURE': '¿Estás seguro?',
	    'YES': 'Si',
	    'NO': 'No',
	    'FILTER_VALUES': 'Valores de filtro',
	    'CLOSE': 'Cerrar',
	    'CLEAR': 'Limpiar',
	    'CURRENT': 'Corriente',
	    'REMOVE': 'Quitar',
	    'ADD_NEW': 'Añadir nuevo {{ name }}',
	    'BROWSE': 'Busqueda',
	    'N_COMPLETE': '{{ progress }}% Completo',
	    'CREATE_NEW': 'Crear nuevo',
	    'SUBMIT': 'Enviar',
	    'SAVE_CHANGES': 'Guardar cambios',
	    'BATCH_DELETE_SUCCESS': 'Elementos eliminados correctamente',
	    'DELETE_SUCCESS': 'Elemento eliminado correctamente',
	    'ERROR_MESSAGE': 'Oops! Ha ocurrido un error(code: {{ status }})',
	    'INVALID_FORM': 'Forma invalida',
	    'CREATION_SUCCESS': 'Elemento creado correctamente',
	    'EDITION_SUCCESS': 'Cambios guardados correctamente',
	    'ACTIONS': 'Acciones',
	    'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>',
	    'NO_PAGINATION': 'Ningún record fue encontrado',
	    'PREVIOUS': '« Anterior',
	    'NEXT': 'Siguiente »',
	    'DETAIL': 'Detalle',
	    'STATE_CHANGE_ERROR': 'Error de cambio de estado: {{ message }}',
	    'NOT_FOUND': 'No funciona',
	    'NOT_FOUND_DETAILS': 'La página que busca no se encuentra. Tome un descanso antes de intentarlo de nuevo.',
	
	    //lang
	    'SPANISH': "Castellano",
	    'ENGLISH': "Inglés",
	    'CATALAN': "Catalán",
	
	    //Menu
	    'ORDERS': "Ordenes",
	    'ACCOUNT': "Cuenta",
	    'PURCHASES': "Compras",
	    'DOWNLOADS': "Descargas",
	    'USERS': "Usuarios",
	    'USER_LIST': "Lista de pacientes",
	    'PRENSCRIBER_LIST': "Lista de profesionales",
	    'COMPANY_LIST': "Lista de empresas",
	    'PRESCRIBER_TYPES': "Tipos de prescriptor",
	    'PRODUCTS': "Productos",
	    'SUBSCRIPTIONS': "Suscripciones",
	    'LICENCES': "Licencias",
	    'LICENCES_TEXT': 'Todas las licencias están sujetas a un mantenimiento anual y la firma de un contrato',
	    'GAMES': "Juegos",
	    'CONFIG': "Configuración",
	    'VARIABLES': "Variables",
	    'ABILITIES': "Habilidades",
	    'LOGOUT': "Cerrar sesión",
	    'PRESNCRIPTORS': 'Prescriptores',
	    'PROFESSIONAL_MANUAL': 'Manual del profesional',
	    'PROFESSIONAL_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/manual_profesional_cast.pdf',
	    'USER_MANUAL': 'Guia de usuario',
	    'USER_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/guia_usuario_cast.pdf',
	    'VIDEOS_TUTORIAL': 'Videos tutoriales',
	    // Login
	    'REGISTER': "Registro",
	    'LOGIN': "Iniciar sesión",
	    'USERNAME_OR_EMAIL': "Nombre de usuario",
	    'RECOVERY_PASSWORD': "Recuperar contraseña",
	    'USERNAME_EMAIL_RECOVERY': "Se requiere un nombre de usuario.",
	    'PASSWORD_REQUIRED': "Se requiere contraseña.",
	    'LETS_GO': "¡Vamos!",
	    'PASSWORD': "Contraseña",
	    'ERROR_USSER_PASSWORD_INCORRECT': "Nombre de usuario o contraseña incorrecta",
	    'LOGIN_REGISTER': "Regístrate",
	    'OR': "o",
	    'ERROR_LINK_EXPIRED': 'El link para recuperar contraseña ha expirado, por favor solicite otros',
	
	    //Recovery
	    'SIGN_IN_AGAIN': "Iniciar sesión de nuevo",
	    'INTERNAL_ERROR': "Error interno",
	    'Invalid username or email': "Nombre de usuario no válido",
	    'Password request alerady requested': "Solicitud de contraseña ya ha sido solicitada",
	    'SEND_EMAIL_REQUEST_SUCCESS': "Te hemos enviado un email con los pasos para restablecer la contraseña.",
	
	    //Register
	    'USER': "Usuario",
	    'USERNAME': "Nombre de usuario",
	    'USERNAME_REASON': 'El nombre de usuario se usará para que te podamos identificar en la pantalla de login',
	    'PRESCRIBER': "Prescriptor",
	    'USERNAME_REQUIRED': "Se requiere nombre de usuario",
	    'ACCEPT_TERMS_SERVICE': "Acepto los términos del servicio",
	    'YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED': "Debe aceptar los términos de servicio antes de continuar",
	    'USERNAME_ALREADY_TAKEN': "El nombre de usuario ya esta usado",
	    'CREATED_CHECK_YOUR_EMAIL': 'Su cuenta se ha creado correctamente, verifique su correo electrónico.',
	    'MALFORMET_DATA': 'Se ha producido errores en el formulario',
	    'PASSWORD_SHORT': 'La contraseña es demasiado corta',
	
	    //Account
	    'YOU_ARE': "Tipo de usuario",
	    'YOUR_LICENCES': "Tus licencias",
	    'MANAGE_LICENCES': "Administrar licencias",
	    'YOUR_SUBSCRIPTIONS': "Tus suscripciones",
	    'NEED_MORE_LICENCES': "¿Necesita más licencias?",
	    'PURCHASE_LICENCES': "Licencias de compra",
	    'PURCHASE_SUBSCRIPTIONS': "Comprar Subscripciones",
	    'ADD_LICENCE': "Agregar licencia",
	    'RECHARGE_SUBSCRIPTIONS': "Suscripciones de recarga",
	    'ACTIVE_UNUSED': "Activo / no utilizado",
	    'MANAGE_SUSCRIPTIONS': "Administrar Suscripciones",
	    'ADD_SUSCRIPTIONS': "Añadir suscripciones",
	    'ORDERS_INVOICES': "Pedidos y facturas",
	    'YOUR_LAST_PAYMENT': "Su último pago, de",
	    'WAS_MADE_ON': "Fue hecho en",
	    'SHOW_ORDERS': "Mostrar pedidos y facuturas",
	    'Company': 'Empresa',
	    'Prescriber': 'Prescriptor',
	    'Patient': 'Paciente',
	
	    //calendary
	    'january': "enero",
	    'february': "febrero",
	    'march': "marzo",
	    'april': "abril",
	    'mayo': "mayo",
	    'june': "junio",
	    'july': "julio",
	    'august': "agosto",
	    'september': "septiembre",
	    'october': "octubre",
	    'november': "noviembre",
	    'december': "diciembre",
	
	    //Licences
	    'LICENCE': "Liciencia",
	    'ASSIGNED_TO': "Asignado a",
	    'EXPIRATION_AT': "Expira el",
	    'MAC': "Mac",
	    'REASSIGN_THIS_LICENCE': "Reasignar esta licencia",
	    'CHOOSE_AN_USER': "Elige un usuario",
	    'SELECT_AN_USER': "Seleccione un usuario",
	    'REVOKE_MAC_LICENCE': "Revocar esta licencia de Mac",
	    'REASSIGN': "Reasignar",
	    'REMOVE_YOUR_LICENCE_LINK': "¿Desea eliminar su enlace de licencia?",
	    'REMOVE_YOUR_LICENCE_LINK_TEXT': "Al eliminar el enlace de licencia, puede utilizar esta licencia en otro equipo. <br>' + 'Tenga en cuenta que el nuevo equipo estará vinculado a esta licencia",
	    'LUCKY_DAY': "Feliz dia",
	    'SUCCESS_REMOVE_LICENCE': "Su enlace de licencia se ha eliminado.",
	    'MANUAL_INVOICE': 'Factura manual',
	    'NO_LICENCE': 'Necesita una licencia activa',
	    'NO_LICENCE_BUY': 'Por favor compre una licencia',
	
	    //Purchases
	    'SELECT_PRODUCT': "Seleccionar producto",
	    'PROMOTIONAL_CODE': "¿Tiene un código promocional?",
	    'CODE_DOES_NOT_PROMOTION': "El código no tiene ninguna promoción",
	    'TOTAL_ITEMS': "Articulos totales",
	    'TAXES': "Impuestos",
	    'AMOUNT_PAYABLE': "Total a pagar",
	    'USE_MY_ACCOUNT_INFORMATION_INVOICE': "Usar la información de mi cuenta para la factura",
	    'USE_OTHER_INFORMATION_INVOICE': "Usar otra información para la factura",
	    'NAME': "Nombre",
	    'NAME_REQUIRED': "Se requiere el nombre",
	    'SURNAME': "Apellido",
	    'SURNAME_REQUIRED': "El apellido es requerido",
	    'COMPANY': "Empresa",
	    'CIF/NIF': "CIF/NIF",
	    'CIF_NIF_REQUIRED': "CIF o NIF es requerido",
	    'ADDRESS': "Dirección",
	    'CITY': "Ciudad",
	    'STATE': "Provincia",
	    'COMPANY_REQUIRED': "La empresa es requerida",
	    'POSTAL_CODE': "Código Postal",
	    'YOU_SUPPLY_POSTAL_CODE': "Debe proporcionar un código postal",
	    'THAT_DOESNT_LOOK_LIKE_VALID_PC': "Eso no parece un código postal válido",
	    'BUY_LICENCE': "Comprar",
	    'BUY_SUSCRIPTIONS': "Comprar",
	    'ORDER': "Orden",
	    'YOU_MUST_MAKE_BANK_TRANSFER': "Debe hacer una transferencia bancaria a",
	    'WITH_THE_CONCEPT': "Con el concepto",
	    'PAY_WITH_PAYPAL': "Pagar con PayPal",
	    'PAY_WITH_CREDIT_CARD': "Pagar con tarjeta de crédito",
	    'PAY_WITH_WIRE_TRANSFER': "Pagar con transferencia bancaria",
	    'SELECT_METHOD': "Seleccione un método",
	    'YOU_DONT_HAVE_PERMISSION_AREA': "No tienes permiso en esta área",
	    'UNIT_PRICE': "La unidad sale a",
	    'YOUR_PENDING_REMOVED': "Se ha eliminado la compra pendiente",
	    'CONFIRM_REMOVE_PURCHASE_PENDING': "¿Desea eliminar esta compra pendiente?",
	    'CANCEL': "Cancelar",
	    'REMOVE!': "Eliminar!",
	    'BUY_SUCCESS': "Su pedido ha sido tramitado correctamente.",
	    'CIF_NIF_ALREADY_EXISTS': "El cif/nif/nie ya existe",
	    'CIF_NIF_INVALID': "El cif/nif/nie es invalido",
	    'PHONE_REQUIRED': "El telefono es requerido",
	    'ADDRESS_REQUIRED': "La dirección es requerida",
	    'CITY_REQUIRED': "La ciudad s requedia",
	
	    //ERRORS
	    'PLEASE_INSERT_NUMERIC_VAL': "¡Porfavor inserte un valor numérico!",
	    'NOT_ENOUGH_SUBS': "No tienes suficientes suscripciones",
	    'USER_HAS_NOT_SUBS': "Este usuario no tiene suscripción",
	    'UNAUTORITHED': "Sin autorización",
	    'INVALID_DETAILS_IN_FORM': "Algunos valores no son válidos, ver detalles en el formulario",
	
	    //thanks
	    'THANK_YOU': "Gracias",
	    'THE_PURCHASE_WAS_MADE_CORRECTLY': "La compra se realizó correctamente, puede administrar sus compras en la sección de su cuenta",
	
	    //Profile
	    'PROFILE': "Perfil",
	    'EMAIL': "Email",
	    'EMAIL_REQUIRED': "El email es requerido",
	    'EMAIL_NOT_VALID': "El Email no es válido",
	    'EMAIL_ALREADY_TAKEN': "El Email ya aceptado o no válido",
	    'BIRTHDAY': "Fecha de nacimiento",
	    'MATURATIVE_AGE': 'Edad madurativa',
	    'BIRTHDAY_REQUIRED': "El cumpleaños es requerido",
	    'PRESCRIBER_TYPE': "Tipo de prescriptor",
	    'PRESCRIBER_TYPE_REQUIRED': "Se requiere el tipo de prescripción",
	    'UPDATE_MY_DATA': "Actualizar mis datos",
	    'CHANGE_PASSWORD': "Cambiar contraseña",
	    'PROFILE_UPDATE': "Tu perfil ha sido actualizado",
	
	    //Subscriptions
	    'MANAGE_SUBSCRIPTIONS': "Administrar Suscripciones",
	    'PRESCRIPTOR': "Prescriptor",
	    'PATIENT': "Paciente",
	    'PATIEN_EMAIL': "Paciente Email",
	    'STATUS': "Estado",
	    'NUM_SUBSCRIPTIONS': "Número de suscripciones",
	    'EXPIRATE_AT': "Expira en",
	    'LINK_SUBSCRIPTION': "Vincular una nueva suscripción",
	    'UNLINK_SUBSCRIPTION': "Desvincular esta suscripción",
	    'ADD_SUBSCRIPTION': "Añadir más suscripciones",
	    'NO_SERS_YET': "No hay usuarios todavía",
	    'WOULD_LIKE_ADD_NEW_USER': "¿Quieres añadir un nuevo usuario?",
	    'active': 'Activo',
	    'inactive': 'Inactivo',
	    'MODAL_CANCEL': 'Cancelar',
	    'ADD_SUBSCRIPTION_TITLE': '¿Cuántos meses de suscripción quiere agregar?',
	    'ADD_SUBSCRIPTION_CONTENT': "Cada unidad de suscripción es equivalente a 1 mes. <br> Si desea que un usuario tenga 3 meses de suscripción, agregue 3. <br> Nota: cada unidad consume un suscriptor del total.",
	    'ADD_SUBSCRIPTION_INPUT': 'Numero de suscripciónes',
	    'ADD_SUBSCRIPTION_SUCCESS': "La suscripción se ha agregado correctamente.",
	    'ADD_SUBSCRIPTION_BUTTON': 'Añadir suscripción!',
	    'REMOVE_SUBSCRIPTION_TITLE': '¿Seguro que desea eliminar esta subscrición a este usuario?',
	    'REMOVE_SUBSCRIPTION_CONTENT': 'Al eliminar la suscripción, el usuario ya no tendrá acceso.',
	    'REMOVE_SUBSCRIPTION_BUTTON': 'Eliminar!',
	    'REMOVE_SUBSCRIPTION_SUCCESS': "La suscripción se ha eliminado correctamente",
	    'NO_USERS_YET': "No tiene usuarios",
	    'ENOUGH_SUBSCRIPTION_TITLE': 'No tienes suficientes suscripciones',
	    'ENOUGH_SUBSCRIPTION': 'No tiene más suscripciones para asignar. <br> Compra más o notifica a tu administrador',
	    'OK': 'Vale',
	    'LAST_ASSINGED': 'Última asignación',
	
	    //Invoices
	    'INVOICES': "Facturas",
	    'PRODUCT': "Producto",
	    'AMOUNT': "Cantidad",
	    'DATE': "Fecha",
	    'DOWNLOAD_INVOICE': "Descargar factura",
	    'NO_PURCHASE_YET': "No hay compra todavía",
	    'PENDING_ORDERS': "Ordenes pendientes",
	    'MAKE_PAYMENT_NOW': "Realizar el pago ahora",
	    'REMOVE_PENDING_ORDER': "Eliminar esta orden pendiente",
	    'PAYMENTS': 'Abonos',
	    'PAYMENT': 'Abono',
	
	    //summary
	    'MONTHLY_REVENUE': "Ganancia Mensual",
	    'VIEW_DETAILS': "Ver detalles",
	    'PENDING_REVIEWS': "Reseñas pendientes",
	    'NEW_CUSTOMERS': "Nuevos clientes",
	
	    //Products
	    'ABBR': "Abbr",
	    'PRICE': "Precio",
	    'PRICE_MONTH': "Precio total",
	    'ENROLLMENT': "Matrícula",
	    'PROMOTIONAL': "Promocional",
	    'TYPE': "Tipo",
	    'UNITS': "Unidades",
	    'GAME': "Juego",
	
	    //Variables
	    'ABBREVIATION': "Abreviatura",
	    'DESCRIPTION': "Descripción",
	    'FLOAT': "Float",
	    'INTEGER': "Integer",
	    'BOOLEAN': "Boolean",
	    'MULTIPLE': "Multiple",
	    'REPETITIONS': "Repetitions",
	    'MODIFY_FIXED': "Modificar fijo",
	    'MODIFY_RELATION': "Modificar Relación",
	    'HARDNESS_INITIAL': "Dureza Inicial",
	    'MODIFY_VARIABLE': "Modificar la variable",
	    'STEPS': "Pasos",
	    'KEY': "Llave",
	    'VALUE': "Valor",
	
	    //Game
	    'WEIGHT': "Peso",
	    'ABILITY': "Habilidad",
	    'PERCENTAGE': "Porcentaje",
	    'ADD': "Añadir",
	    'VARIABLE': "Variable",
	    'INCLUDED': "Incluido",
	    'ONLY_GOLD': 'Solo visible en PRO GOLD',
	    'VISIBLE_AUTOMATIC': 'NO visible en terapia automática',
	
	    //Entities
	    'ID': "Id",
	    'FINALIZED': "Finalizado",
	    'IDENTIFIER': "Identificador",
	    'IP': "Ip",
	    'METHOD': "Método",
	    'UPDATED': "Actualizado",
	    'PAYPAL': "PayPal",
	    'CREDIT_CARD': "Tarjeta de Crédito",
	    'WIRE_TRANSFER': "Transferencia Bancaria",
	    'SUBSCRIPTION': "Suscripción",
	    'CODE': "Código",
	
	    //User
	    'user': "usuario",
	    'Users': "Usuarios",
	    'ENABLED': "Habilitado",
	    'CREATED': "Creado",
	    'ROLES': "Roles",
	    'WORKERS': "Trabajadores",
	    'PATIENTS': "Pacientes",
	    'CIF': "Cif",
	    'TRAINING_TIME_MIN': "Tiempo de entrenamiento (min)",
	    'TRAINING_TIME': "Tiempo de entrenamiento",
	    'TRAINING_DATE': "Fecha de entrenamiento",
	    'USER_TEST': "Usuario Test",
	
	    //Download
	    'DOWNLOAD': 'Descargar',
	    'TEXT_DOWNLOAD': 'Descarga aquí tu gestor de aplicaciones',
	
	    //Licences VR
	    'LICENCES_GAME_VR': 'Licencias GAME VR',
	
	    //Events
	    'EVENTS': 'Eventos',
	    'LOCATION': 'Localización',
	    'LOCATION_MAP': 'Localización en mapa google',
	    'INTERESTED': 'Interesados',
	    'IMAGE': 'Imagen',
	    'PHONE': 'Teléfono',
	
	    //ORDERS
	    'purchase': "compra",
	    'User': "Usuario",
	    'Product': "Producto",
	    'Status': "Estado",
	    'Status Code': "Código de estado",
	    'Method': "Método",
	
	    //Promo
	    'PROMO_UNAVAIABLE': 'La prueba gratuita ya a sido usada',
	    'PROMO_REQUEST': 'Solicita tu prueba gratuita',
	    'PROMO_REGISTER': 'Registro para prueba gratuita',
	    'PROMO_CREATED_CHECK_YOUR_EMAIL': 'Le hemos enviado los pasos a seguir por email.',
	    'PROMO_PROBLEM_TITLE': "Se produjo un error",
	    'PROMO_PROBLEM_TEXT': "Se han detectado errores y no puede continuar con el registro para la prueba gratuita, <br>por favor envíe un correo electrónico a <a href=\"mailto:info@brainvt.com?Subject=Error para prueba gratuita\">info@brainvt.com</a> o llamando al 619 871 407",
	
	    //Purchase Licence
	    'BILLED_YEARLY': 'Facturado anualmente',
	    'YEAR_SAVE': 'Ahorras',
	    'MOTNH': 'Mes',
	    'SELECT': 'Seleccionar',
	    'YEAR': 'Año',
	    'BILLED_MONTHLY': 'Facturado mensualmente',
	
	    //Paypal status
	    'SHOW_INVOICES': 'Ver facturas',
	    'PAY_STATE': 'Estado',
	    'CANCEL_SUBSCRIPTION': 'Cancelar subscripción',
	    'REFRESH_SUBSCRIPTION': 'Iniciar subscripción',
	    'recurring_payment_profile_created': 'Pendiente',
	    'recurring_payment_profile_created_help': 'La subscripción a la licencia se ha iniciado pero aun no se ha aprobado',
	    'recurring_payment': 'Completado',
	    'recurring_payment_help': 'La subsripción a la licencia se ha completado con exito',
	    'recurring_payment_profile_cancel': 'Cancelado',
	    'recurring_payment_profile_cancel_help': 'La subsripción a la licencia se ha cancelado, puede volver a activarla usando el icono del carrito',
	    'recurring_payment_expired': 'Expirado',
	    'recurring_payment_expired_help': 'La subscripción a la licencia ha expirado, puede volver a activarla usando el icono del carrito',
	    'recurring_payment_suspended': 'Suspendido',
	    'recurring_payment_suspended_help': 'La subscripción a la licencia se ha suspendido, puede volver a activarla usando el icono del carrito',
	    'recurring_payment_default': 'Fallido',
	    'recurring_payment_default_help': 'La subscripción a la licencia ha fallado, pongase en contacto con el equipo de BrainVTEduca'
	
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.$ = window.jQuery = __webpack_require__(241);
	window.Cookies = __webpack_require__(242);
	
	__webpack_require__(217);
	__webpack_require__(229);
	__webpack_require__(167);
	
	var myApp = _angular2.default.module('myApp', [__webpack_require__(246), __webpack_require__(18), __webpack_require__(222), __webpack_require__(219), __webpack_require__(124), __webpack_require__(177), __webpack_require__(125), __webpack_require__(127), __webpack_require__(174), __webpack_require__(173), __webpack_require__(163)]);
	
	myApp.config(['RestangularProvider', __webpack_require__(122)]);
	myApp.config(['RestangularProvider', __webpack_require__(123)]);
	myApp.config(['$provide', __webpack_require__(121)]);
	myApp.config(['RestangularProvider', '$windowProvider', __webpack_require__(119)]);
	myApp.config(['$mdThemingProvider', __webpack_require__(120)]);
	myApp.config(['$translateProvider', __webpack_require__(17)]);
	myApp.config(['$translateProvider', __webpack_require__(17)]);
	myApp.config(['$mdDateLocaleProvider', __webpack_require__(118)]);
	
	myApp.config(['NgAdminConfigurationProvider', 'Api', function (nga, Api) {
	
	    // create the admin application
	    var admin = nga.application('BrainVT').baseApiUrl(Api.Path);
	
	    admin.addEntity(nga.entity('game'));
	    admin.addEntity(nga.entity('gamevr'));
	    admin.addEntity(nga.entity('user'));
	    admin.addEntity(nga.entity('prenscriptor'));
	    admin.addEntity(nga.entity('prescriberType'));
	    admin.addEntity(nga.entity('variable'));
	    admin.addEntity(nga.entity('config'));
	    admin.addEntity(nga.entity('ability'));
	    admin.addEntity(nga.entity('licence'));
	    admin.addEntity(nga.entity('gamevrlicence'));
	    admin.addEntity(nga.entity('subscription'));
	    admin.addEntity(nga.entity('purchase'));
	    admin.addEntity(nga.entity('product'));
	    admin.addEntity(nga.entity('event'));
	    admin.addEntity(nga.entity('interested'));
	    admin.addEntity(nga.entity('invoice'));
	    admin.addEntity(nga.entity('payment'));
	    admin.addEntity(nga.entity('promo'));
	    admin.addEntity(nga.entity('competence'));
	    admin.addEntity(nga.entity('licencetype'));
	    admin.addEntity(nga.entity('company'));
	    admin.addEntity(nga.entity('professional'));
	
	    __webpack_require__(147)(nga, admin);
	    __webpack_require__(148)(nga, admin);
	    __webpack_require__(161)(nga, admin);
	    __webpack_require__(155)(nga, admin);
	    __webpack_require__(143)(nga, admin);
	    __webpack_require__(156)(nga, admin);
	    __webpack_require__(162)(nga, admin);
	    __webpack_require__(145)(nga, admin);
	    __webpack_require__(142)(nga, admin);
	    __webpack_require__(152)(nga, admin);
	    __webpack_require__(149)(nga, admin);
	    __webpack_require__(160)(nga, admin);
	    __webpack_require__(159)(nga, admin);
	    __webpack_require__(157)(nga, admin, Api);
	    __webpack_require__(146)(nga, admin, Api);
	    __webpack_require__(150)(nga, admin);
	    __webpack_require__(151)(nga, admin);
	    __webpack_require__(154)(nga, admin);
	    __webpack_require__(158)(nga, admin);
	    __webpack_require__(144)(nga, admin);
	    __webpack_require__(153)(nga, admin);
	
	    admin.menu(__webpack_require__(172)(nga, admin));
	    //admin.dashboard(require('./theme/dashboard/config')(nga, admin));
	    admin.header(__webpack_require__(400));
	    admin.layout(__webpack_require__(405));
	
	    // attach the admin application to the DOM and execute it
	    nga.configure(admin);
	}]);
	
	myApp.config(['$compileProvider', function ($compileProvider) {
	    $compileProvider.preAssignBindingsEnabled(true);
	}]);
	
	myApp.config(['$qProvider', function ($qProvider) {
	    $qProvider.errorOnUnhandledRejections(false);
	}]);

/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (nga, admin) {
	
	    var menu = nga.menu();
	
	    menu.addChild(nga.menu().title('ACCOUNT').icon('<i class="fa fa-user fa-fw"></i>').link('/account').active(function (path) {
	        return path.indexOf('/account') !== -1 || path.indexOf('/profile') !== -1;
	    }));
	
	    var purchases = nga.menu().title('PURCHASES').icon('<i class="fa fa-shopping-cart fa-fw"></i>').link('/purchases/').active(function (path) {
	        return path.indexOf('/purchases') !== -1;
	    });
	
	    if (HasRole(['admin', 'superadmin'])) {
	        if (GetData().currentUser && !GetData().currentUser.company) {
	            menu.addChild(purchases);
	        }
	    }
	
	    menu.addChild(nga.menu().title('DOWNLOADS').icon('<i class="fa fa-cloud-download fa-fw"></i>').link('/downloads').active(function (path) {
	        return path.indexOf('/downloads') !== -1;
	    }));
	
	    if (HasRole(['superadmin', 'company', 'prenscriptor'])) {
	
	        var user = nga.menu(admin.getEntity('user')).title('USERS').icon('<i class="fa fa-users fa-fw"></i>').active(function (path) {
	            return path.indexOf('/user') !== -1;
	        });
	
	        if (HasRole(['admin', 'superadmin'])) {
	            user.addChild(nga.menu(admin.getEntity('user')).title('USER_LIST').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/user') !== -1;
	            }));
	
	            user.addChild(nga.menu(admin.getEntity('prenscriptor')).title('PRENSCRIBER_LIST').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/prenscriptor') !== -1;
	            }));
	
	            user.addChild(nga.menu(admin.getEntity('company')).title('COMPANY_LIST').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/compnay') !== -1;
	            }));
	
	            user.addChild(nga.menu(admin.getEntity('prescriberType')).title('PRESCRIBER_TYPES').icon('<i class="fa fa-graduation-cap fa-fw"></i>').active(function (path) {
	                return path.indexOf('/prescriberType') !== -1;
	            }));
	
	            purchases.addChild(nga.menu(admin.getEntity('promo')).title('PROMOS').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/promo') !== -1;
	            }));
	
	            purchases.addChild(nga.menu(admin.getEntity('purchase')).title('ORDERS').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/purchase') !== -1;
	            }));
	            purchases.addChild(nga.menu(admin.getEntity('licence')).title('LICENCES').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/licence/') !== -1;
	            }));
	            purchases.addChild(nga.menu(admin.getEntity('licencetype')).title('LICENCES_TYPE').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/licencetype/') !== -1;
	            }));
	            purchases.addChild(nga.menu(admin.getEntity('gamevrlicence')).title('LICENCES_GAME_VR').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/gamevrlicence') !== -1;
	            }));
	            purchases.addChild(nga.menu(admin.getEntity('subscription')).title('SUBSCRIPTIONS').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/subscription') !== -1;
	            }));
	            purchases.addChild(nga.menu(admin.getEntity('product')).title('PRODUCTS').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/product') !== -1;
	            }));
	            purchases.addChild(nga.menu(admin.getEntity('invoice')).title('INVOICES').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/invoice') !== -1;
	            }));
	            purchases.addChild(nga.menu(admin.getEntity('payment')).title('PAYMENTS').icon('<i class="fa fa-list fa-fw"></i>').active(function (path) {
	                return path.indexOf('/payment') !== -1;
	            }));
	        };
	
	        menu.addChild(user);
	    }
	
	    if (HasRole(['company']) && !HasRole(['superadmin'])) {
	        menu.addChild(nga.menu(admin.getEntity('prenscriptor')).title('PRESNCRIPTORS').icon('<i class="fa fa-users fa-fw"></i>').active(function (path) {
	            return path.indexOf('/prenscriptor') !== -1;
	        }));
	    }
	
	    if (HasRole('admin')) {
	        var games = nga.menu(admin.getEntity('game')).title('GAMES').icon('<i class="fa fa-gamepad fa-fw"></i>').active(function (path) {
	            return path.indexOf('/game') !== -1;
	        });
	        menu.addChild(games);
	
	        games.addChild(nga.menu(admin.getEntity('competence')).title('COMPETENCES').icon('<i class="fa fa-object-group fa-fw"></i>').active(function (path) {
	            return path.indexOf('/competence') !== -1;
	        }));
	
	        games.addChild(nga.menu(admin.getEntity('ability')).title('ABILITIES').icon('<i class="fa fa-puzzle-piece fa-fw"></i>').active(function (path) {
	            return path.indexOf('/ability') !== -1;
	        }));
	
	        games.addChild(nga.menu(admin.getEntity('game')).title('PROCEDURES').icon('<i class="fa fa-gamepad fa-fw"></i>').active(function (path) {
	            return path.indexOf('/game/') !== -1;
	        }));
	
	        games.addChild(nga.menu(admin.getEntity('gamevr')).title('VR').icon('<i class="fa fa-eye fa-fw"></i>').active(function (path) {
	            return path.indexOf('/gamevr') !== -1;
	        }));
	
	        games.addChild(nga.menu(admin.getEntity('variable')).title('VARIABLES').icon('<i class="fa fa-cog fa-fw"></i>').active(function (path) {
	            return path.indexOf('/variable') !== -1;
	        }));
	
	        menu.addChild(nga.menu(admin.getEntity('event')).title('EVENTS').icon('<i class="fa fa-calendar fa-fw"></i>')).active(function (path) {
	            return path.indexOf('/event') !== -1;
	        });
	    }
	
	    if (HasRole(['superadmin'])) {
	        menu.addChild(nga.menu().title('CONFIG').icon('<i class="fa fa-cog fa-fw"></i>').link('/options').active(function (path) {
	            return path.indexOf('/options') !== -1;
	        }));
	    }
	
	    if (HasRole(['company', 'prenscriptor']) && !HasRole(['superadmin'])) {
	        menu.addChild(nga.menu().title('PROFESSIONAL_MANUAL').icon('<i class="fa fa-book fa-fw"></i>').link('PROFESSIONAL_MANUAL_LINK'));
	    }
	
	    if (HasRole(['patient']) && !HasRole(['superadmin'])) {
	        menu.addChild(nga.menu().title('USER_MANUAL').icon('<i class="fa fa-book fa-fw"></i>').link('USER_MANUAL_LINK'));
	    }
	
	    return menu;
	};
	
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var moduleName = 'appRouter';
	
	angular.module(moduleName, []).config(['$stateProvider', '$locationProvider', '$urlRouterProvider', function ($stateProvider, $locationProvider, $urlRouterProvider) {
	
	    $stateProvider.state('login', {
	        url: '/login',
	        params: {},
	        controller: ['$scope', '$location', '$window', 'AuthenticationService', 'FlashService', __webpack_require__(191)],
	        template: __webpack_require__(404),
	        data: {
	            class_name: 'login'
	        }
	    });
	
	    $stateProvider.state('recovery', {
	        url: '/recovery',
	        params: {},
	        controller: ['$scope', '$location', '$window', 'AuthenticationService', 'FlashService', 'Restangular', __webpack_require__(204)],
	        template: __webpack_require__(416),
	        data: {
	            class_name: 'login recovery'
	        }
	    });
	
	    $stateProvider.state('register', {
	        url: '/register',
	        params: {},
	        controller: ['$scope', '$location', '$window', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', 'CifService', __webpack_require__(205)],
	        template: __webpack_require__(417),
	        data: {
	            class_name: 'register'
	        }
	    });
	
	    $stateProvider.state('promo', {
	        url: '/promo',
	        params: {},
	        controller: ['$scope', '$location', '$window', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', 'CifService', '$mdDialog', '$filter', 'promo', __webpack_require__(197)],
	        template: __webpack_require__(411),
	        data: {
	            class_name: 'register promo'
	        },
	        resolve: {
	            promo: ['Restangular', 'AuthenticationService', '$location', function (Restangular, AuthenticationService, $location) {
	                return Restangular.oneUrl('promo', AuthenticationService.Api.Public + 'promo/' + $location.search().token).get().then(function (data) {
	                    if (data) return data.id ? data : data.data;
	
	                    return null;
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('request-promo', {
	        url: '/request-promo',
	        params: {},
	        controller: ['$scope', '$location', '$window', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', __webpack_require__(206)],
	        template: __webpack_require__(418),
	        data: {
	            class_name: 'register promo'
	        }
	    });
	
	    $stateProvider.state('gameTest', {
	        url: '/game/test/:id',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', 'Restangular', '$stateParams', 'NgAdminConfiguration', __webpack_require__(186)],
	        template: __webpack_require__(399),
	        data: {
	            class_name: 'test'
	        }
	    });
	
	    $stateProvider.state('downloads', {
	        url: '/downloads',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$location', __webpack_require__(185)],
	        template: __webpack_require__(398),
	        data: {
	            class_name: 'download'
	        },
	        resolve: {}
	    });
	
	    $stateProvider.state('options', {
	        url: '/options',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$location', 'products', 'settings', '$anchorScroll', 'FlashService', 'Restangular', __webpack_require__(192)],
	        template: __webpack_require__(406),
	        data: {
	            class_name: 'options'
	        },
	        resolve: {
	            products: ['Restangular', function (Restangular) {
	                return Restangular.all('products').getList({ _filters: '{"type":"licence"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            settings: ['Restangular', function (Restangular) {
	                return Restangular.all('settings').getList().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('account', {
	        url: '/account',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', 'Restangular', 'current', 'licences', 'active', 'unused', __webpack_require__(182)],
	        template: __webpack_require__(395),
	        data: {
	            class_name: 'account'
	        },
	        resolve: {
	            licences: ['Restangular', function (Restangular) {
	                if (!HasRole(['superadmin', 'company', 'prenscriptor'])) return false;
	
	                return Restangular.all('licences').getList({ _sortDir: "DESC", _sortField: "updated" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            current: ['Restangular', function (Restangular) {
	                return Restangular.one('user').get().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            active: ['Restangular', function (Restangular) {
	                if (!HasRole(['superadmin', 'company', 'prenscriptor'])) return false;
	
	                return Restangular.all('subscriptions/active').getList().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            unused: ['Restangular', function (Restangular) {
	                if (!HasRole(['superadmin', 'company', 'prenscriptor'])) return false;
	
	                return Restangular.all('subscriptions/unused').getList().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('profile', {
	        url: '/profile',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', 'states', 'prescriberTypes', 'user', 'progression', '$location', __webpack_require__(196)],
	        template: __webpack_require__(410),
	        data: {
	            class_name: 'profile'
	        },
	        resolve: {
	            states: ['Restangular', function (Restangular) {
	                return Restangular.all('states').getList({ _filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            prescriberTypes: ['Restangular', function (Restangular) {
	                return Restangular.all('prescriberTypes').getList({ _sortDir: "ASC", _sortField: "description" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            user: ['Restangular', function (Restangular) {
	                return Restangular.one('user').get().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('change-password', {
	        url: '/change-password',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$anchorScroll', 'AuthenticationService', 'FlashService', 'Restangular', 'progression', '$location', __webpack_require__(183)],
	        template: __webpack_require__(396),
	        data: {
	            class_name: 'profile'
	        },
	        resolve: {}
	    });
	
	    $stateProvider.state('purchasesthank', {
	        url: '/purchase/thank',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', __webpack_require__(203)],
	        template: __webpack_require__(414),
	        data: {
	            class_name: 'purchases'
	        }
	    });
	
	    $stateProvider.state('purchaseserror', {
	        url: '/purchase/error',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', __webpack_require__(202)],
	        template: __webpack_require__(413),
	        data: {
	            class_name: 'purchases'
	        }
	    });
	
	    $stateProvider.state('paypalsuccess', {
	        url: '/paypal/success',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', __webpack_require__(195)],
	        template: __webpack_require__(409),
	        data: {
	            class_name: 'purchases paypal success'
	        },
	        resolve: {
	            success: ['Restangular', 'AuthenticationService', '$location', function (Restangular, AuthenticationService, $location) {
	                return Restangular.one('purchase', $location.search().purchase).one('paypal', $location.search().token).post().then(function (data) {
	                    if (data) return data.id ? data : data.data;
	
	                    return null;
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('paypalcancel', {
	        url: '/paypal/cancel',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', __webpack_require__(193)],
	        template: __webpack_require__(407),
	        data: {
	            class_name: 'purchases paypal cancel'
	        }
	    });
	
	    $stateProvider.state('paypalerror', {
	        url: '/paypal/error',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', __webpack_require__(194)],
	        template: __webpack_require__(408),
	        data: {
	            class_name: 'purchases paypal error'
	        }
	    });
	
	    $stateProvider.state('purchases', {
	        url: '/purchases/{id}',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$sce', '$timeout', '$anchorScroll', '$filter', 'Api', 'Restangular', 'FlashService', 'user', 'states', 'subscriptions', 'games', 'purchase', 'active_licences', __webpack_require__(201)],
	        template: __webpack_require__(415),
	        data: {
	            class_name: 'purchases'
	        },
	        resolve: {
	            user: ['Restangular', function (Restangular) {
	                return Restangular.one('user').get().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            states: ['Restangular', function (Restangular) {
	                return Restangular.all('states').getList({ _filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            games: ['Restangular', function (Restangular) {
	                return Restangular.all('products').getList({ _filters: '{"type":"game"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            active_licences: ['Restangular', function (Restangular) {
	                return Restangular.all('licences').getList().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            subscriptions: ['Restangular', function (Restangular) {
	                return Restangular.all('products').getList({ _filters: '{"type":"subscription"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            purchase: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
	
	                if (!$stateParams.id || !$stateParams.id.match(/\d+/g)) return $stateParams.id;
	
	                return Restangular.one("purchase", $stateParams.id).get().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }]
	
	        }
	    });
	
	    $stateProvider.state('purchase_licence', {
	        url: '/purchase_licence/{id}',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$sce', '$timeout', '$anchorScroll', '$filter', 'Api', 'Restangular', 'FlashService', 'user', 'states', 'licences', 'purchase', 'active_licences', __webpack_require__(199)],
	        template: __webpack_require__(412),
	        data: {
	            class_name: 'purchase_licence'
	        },
	        resolve: {
	            user: ['Restangular', function (Restangular) {
	                return Restangular.one('user').get().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            states: ['Restangular', function (Restangular) {
	                return Restangular.all('states').getList({ _filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            licences: ['Restangular', function (Restangular) {
	                return Restangular.all('products').getList({ _filters: '{"type":"licence"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            active_licences: ['Restangular', function (Restangular) {
	                return Restangular.all('licences').getList().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            purchase: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
	
	                if (!$stateParams.id || !$stateParams.id.match(/\d+/g)) return $stateParams.id;
	
	                return Restangular.one("purchase", $stateParams.id).get().then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('licences', {
	        url: '/licences',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$timeout', '$mdDialog', '$filter', 'Restangular', 'FlashService', 'progression', 'licences', 'users', 'invoices', __webpack_require__(189)],
	        template: __webpack_require__(402),
	        data: {
	            class_name: 'purchases'
	        },
	        resolve: {
	            licences: ['Restangular', function (Restangular) {
	
	                return Restangular.all('licences').getList({ _sortDir: "DESC", _sortField: "updated" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            users: ['Restangular', function (Restangular) {
	                var filters = { _sortDir: "ASC", _sortField: "name" };
	                var workers = GetData().currentUser.workers;
	
	                if (HasRole('company')) {
	                    if (!workers.length) return [];else filters._filters = '{"id":[' + workers.join(',') + ']}';
	                }
	
	                return Restangular.all('users').getList(filters).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            invoices: ['Restangular', function (Restangular) {
	                return Restangular.all('invoices').getList({ _sortDir: "DESC", _sortField: "updated" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }]
	
	        }
	    });
	
	    $stateProvider.state('invoices', {
	        url: '/invoices',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$timeout', '$mdDialog', '$filter', 'Restangular', 'FlashService', 'purchases', 'invoices', __webpack_require__(188)],
	        template: __webpack_require__(401),
	        data: {
	            class_name: 'purchases invoices'
	        },
	        resolve: {
	            purchases: ['Restangular', function (Restangular) {
	                return Restangular.all('purchases').getList({ _sortDir: "DESC", _sortField: "updated" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            invoices: ['Restangular', function (Restangular) {
	                return Restangular.all('invoices').getList({ _sortDir: "DESC", _sortField: "updated" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }]
	
	        }
	    });
	
	    $stateProvider.state('subscriptions', {
	        url: '/subscriptions',
	        params: {},
	        parent: 'ng-admin',
	        controller: ['$scope', '$timeout', '$mdDialog', 'Restangular', 'FlashService', 'progression', 'subscriptions', 'users', '$filter', __webpack_require__(207)],
	        template: __webpack_require__(419),
	        data: {
	            class_name: 'purchases subscriptions'
	        },
	        resolve: {
	            subscriptions: ['Restangular', function (Restangular) {
	                return Restangular.all('subscriptions/active').getList({ _sortDir: "ASC", _sortField: "finalize" }).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }],
	            users: ['Restangular', function (Restangular) {
	                var filters = { _sortDir: "ASC", _sortField: "name" };
	                var workers = GetData().currentUser.workers;
	
	                if (HasRole('company')) {
	                    if (!workers.length) return [];else filters._filters = '{"prescriber":[' + workers.join(',') + ']}';
	                }
	
	                return Restangular.all('users').getList(filters).then(function (data) {
	                    return data.data ? data.data : data;
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('loading', {
	        url: '/loading',
	        params: {},
	        parent: '',
	        controller: ['$scope', '$location', '$window', __webpack_require__(190)],
	        template: __webpack_require__(403),
	        data: {
	            class_name: 'page-loading'
	        }
	    });
	
	    $locationProvider.hashPrefix('');
	    $urlRouterProvider.otherwise('account');
	    $urlRouterProvider.when('dashboard', 'account');
	}]);
	
	exports.default = moduleName;
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var moduleName = 'appRun';
	
	angular.module(moduleName, []).run(['$rootScope', '$location', '$http', '$window', 'AuthenticationService', __webpack_require__(175)]).run(['$rootScope', __webpack_require__(176)]);
	
	exports.default = moduleName;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($rootScope, $location, $http, $window, AuthenticationService) {
	
	    $rootScope.globals = GetData();
	
	    if ($rootScope.globals.Token) {
	        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.Token;
	    }
	
	    $rootScope.$on('$locationChangeStart', function (event, next, current) {
	        // redirect to login page if not logged in and trying to access a restricted page
	
	        if (['/dashboard'].indexOf($location.path()) !== -1) {
	            event.preventDefault();
	            $location.path('/account');
	        }
	
	        var token = $location.search().t;
	        if (token) {
	            AuthenticationService.SetCredentials(token, function () {
	                $location.search('t', null);
	                Cookies.set('loading_path', $location.path());
	                $location.path('loading');
	            });
	
	            return false;
	        }
	
	        var restrictedPage = ['/login', '/register', '/recovery', '/promo', '/request-promo'].indexOf($location.path()) === -1;
	
	        var loggedIn = $rootScope.globals.currentUser;
	        if (restrictedPage && !loggedIn) {
	            $location.path('/login');
	        }
	    });
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($rootScope) {
	    return {
	        restrict: 'A',
	        scope: {},
	        link: function link(scope, elem) {
	            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                var fromClassnames = angular.isDefined(fromState.data) && angular.isDefined(fromState.data.class_name) ? fromState.data.class_name : null;
	                var toClassnames = angular.isDefined(toState.data) && angular.isDefined(toState.data.class_name) ? toState.data.class_name : null;
	
	                // don't do anything if they are the same
	                if (fromClassnames != toClassnames) {
	                    if (fromClassnames) {
	                        elem.removeClass(fromClassnames);
	                    }
	
	                    if (toClassnames) {
	                        elem.addClass(toClassnames);
	                    }
	                }
	            });
	        }
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var moduleName = 'appFactories';
	
	angular.module(moduleName, ['ngCookies']).factory('UserService', ['$rootScope', 'ApiService', __webpack_require__(181)]).factory('CifService', ['$rootScope', __webpack_require__(179)]).factory('FlashService', ['$rootScope', '$mdToast', '$filter', __webpack_require__(180)]).factory('AuthenticationService', ['$http', '$cookieStore', '$rootScope', 'Api', __webpack_require__(178)]);
	
	exports.default = moduleName;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    'use strict';
	
	    return function ($http, $cookieStore, $rootScope, Api) {
	        return {
	            Login: function Login(username, password, callback) {
	                return $http.post(Api.AuthPath, {
	                    username: username,
	                    password: password,
	                    client_id: Api.ClientId,
	                    client_secret: Api.ClientSecret,
	                    grant_type: 'password'
	                }).then(callback, callback);
	            },
	            Api: Api,
	            PublicLogin: function PublicLogin(callback, force) {
	
	                if (this.HasCredentials() && !force) return callback({ status: 200 });
	
	                return $http.post(Api.AuthPath, {
	                    client_id: Api.ClientId,
	                    client_secret: Api.ClientSecret,
	                    grant_type: 'client_credentials'
	                }).then(function (response) {
	                    var token = response.data.access_token;
	                    $http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	
	                    $rootScope.globals = { Token: token };
	                    SetData($rootScope.globals);
	
	                    callback(response);
	                }, callback);
	            },
	
	            Logout: function Logout() {
	                this.ClearCredentials();
	            },
	
	
	            User: function User(callback) {
	                return $http.get(Api.Path + "user", {}).then(callback, callback);
	            },
	
	            HasCredentials: function HasCredentials() {
	                if ($rootScope.globals.Token) return true;
	
	                return false;
	            },
	
	            SetCredentials: function SetCredentials(token, callback) {
	                $http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	
	                this.User(function (response) {
	                    if (response.status == "200") {
	                        $rootScope.globals = {
	                            currentUser: {
	                                roles: response.data.roles.map(function (obj) {
	                                    return obj.replace('ROLE_', '').replace('_', '').toLowerCase();
	                                }),
	                                id: response.data.id,
	                                username: response.data.username,
	                                workers: response.data.workers.map(function (worker) {
	                                    return worker.id;
	                                }),
	                                company: response.data.company ? response.data.company.id : null
	                            },
	                            Token: token
	                        };
	
	                        SetData($rootScope.globals);
	
	                        callback();
	                    }
	                });
	            },
	
	            ClearCredentials: function ClearCredentials() {
	                $rootScope.globals = {};
	                RemoveData();
	                $http.defaults.headers.common.Authorization = 'Basic';
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    'use strict';
	
	    return function ($rootScope) {
	        return {
	            Validate: function Validate(value) {
	                if (this.Cif(value)) return true;
	                if (this.Nie(value)) return true;
	                if (this.Nif(value)) return true;
	
	                return;
	            },
	            Cif: function Cif(value) {
	                var regExp = new RegExp("^[a-zA-Z]{1}\\d{7}[a-jA-J0-9]{1}$");
	                return regExp.exec(value) ? true : false;
	            },
	            Nie: function Nie(value) {
	                var regExp = new RegExp("^[XYZ]?\\d{5,8}[a-zA-Z]{1}$");
	                var checkCharacters = "TRWAGMYFPDXBNJZSQVHLCKET";
	
	                /* Check expression */
	                var valid = regExp.exec(value) ? true : false;
	                if (!valid) return false;
	                var nie_prefix = value.charAt(0);
	                switch (nie_prefix) {
	                    case 'X':
	                        nie_prefix = 0;
	                        break;
	                    case 'Y':
	                        nie_prefix = 1;
	                        break;
	                    case 'Z':
	                        nie_prefix = 2;
	                        break;
	                }
	
	                /* Check character */
	                var number = nie_prefix + value.substr(1, value.length - 2);
	                var character = value.substr(value.length - 1, 1).toUpperCase();
	                var validCharacter = checkCharacters.substr(parseInt(number) % 23, 1);
	                if (character != validCharacter) return false;
	                return true;
	            },
	            Nif: function Nif(value) {
	                var regExp = new RegExp("^\\d{8}[a-zA-Z]{1}$");
	                var checkCharacters = "TRWAGMYFPDXBNJZSQVHLCKET";
	
	                /* Check expression */
	                var valid = regExp.exec(value) ? true : false;
	                if (!valid) return false;
	
	                /* Check character */
	                var number = value.substr(0, value.length - 1);
	                var character = value.substr(value.length - 1, 1).toUpperCase();
	                var validCharacter = checkCharacters.substr(parseInt(number) % 23, 1);
	                if (character != validCharacter) return false;
	
	                return true;
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    'use strict';
	
	    return function ($rootScope, $mdToast, $filter) {
	        return {
	            Success: function Success(message, keepAfterLocationChange) {
	                $mdToast.show($mdToast.simple().toastClass('md-toast success').position('top right').textContent($filter('translate')(message)).hideDelay(10000));
	            },
	            Error: function Error(message, keepAfterLocationChange) {
	
	                $mdToast.show($mdToast.simple().toastClass('md-toast error').position('top right').textContent($filter('translate')(message)).hideDelay(10000));
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	     'use strict';
	
	     return function ($rootScope, ApiService) {
	          return {
	               User: $rootScope.globals.currentUser.username,
	               HasRole: function HasRole(role) {}
	          };
	     };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, Restangular, current, licences, active, unused) {
	
	    $scope.has_company = GetData().currentUser.company;
	    $scope.has_admin = HasRole('admin');
	    $scope.has_patient = !HasRole(['superadmin', 'company', 'prenscriptor']);
	
	    $scope.licences = licences;
	
	    $scope.user = current;
	    $scope.month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	    $scope.roles = {
	        'ROLE_PATIENT': 'Patient',
	        'ROLE_PRENSCRIPTOR': 'Prescriber',
	        'ROLE_COMPANY': 'Company'
	    };
	
	    if ($scope.roles instanceof Array) {
	        $scope.user.type = $scope.roles[$scope.user.roles[0]];
	    } else {
	        $scope.user.type = $scope.roles[$scope.user.roles];
	    }
	
	    // Subscriptions
	    $scope.user.use_subscriptions = active.length + '/' + unused.length;
	
	    // Invoices
	    if ($scope.user.purchases.length) {
	        var last = null;
	
	        $scope.user.purchases.forEach(function (v, i) {
	            if (v.status <= 99 && v.updated) last = v;
	        });
	
	        if (last && last.product) {
	            var product = last.product;
	
	            var date = ParseDate(last.updated);
	            var day = date.getDate();
	            var month = date.getMonth();
	
	            $scope.last_pay = {
	                total: product.price,
	                day: day,
	                month: $scope.month[month].toString().toLowerCase()
	            };
	        }
	    }
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $anchorScroll, AuthenticationService, FlashService, Restangular, progression, $location) {
	
	    $scope.$watch('plainPassword', function () {
	        $scope.form.plainPassword.$setValidity('low', true);
	    });
	
	    $scope.$watch('confirm', function () {
	        $scope.form.confirm.$setValidity('same', true);
	    });
	
	    $scope.$watch('old', function () {
	        $scope.form.old.$setValidity('not', true);
	    });
	
	    $scope.register = function () {
	        $scope.dataLoading = true;
	        progression.start();
	
	        var user = {
	            old: $scope.old,
	            plainPassword: $scope.plainPassword,
	            confirm: $scope.confirm
	        };
	
	        Restangular.all('user/change-password').patch(user).then(function (data) {
	
	            $location.path('/account');
	
	            FlashService.Success("PROFILE_UPDATE");
	            progression.done();
	
	            $scope.dataLoading = false;
	        }, function (error) {
	            $scope.dataLoading = false;
	
	            $anchorScroll("body");
	            FlashService.Error("MALFORMET_DATA");
	            progression.done();
	
	            error.data.fields.forEach(function (field, index) {
	                if (field.property_path == 'plainPassword') {
	                    $scope.form[field.property_path].$setValidity('low', false);
	                }
	
	                if (field.property_path == 'confirm') {
	                    $scope.form[field.property_path].$setValidity('same', false);
	                }
	
	                if (field.property_path == 'old') {
	                    $scope.form[field.property_path].$setValidity('not', false);
	                }
	            });
	
	            form.$invalid = false;
	        });
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _sumaryView = __webpack_require__(397);
	
	var _sumaryView2 = _interopRequireDefault(_sumaryView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneMonthAgo = (0, _moment2.default)().subtract(1, 'months').toDate();
	
	var has_seen_alert = false;
	
	function dashboardSummary(Restangular) {
	    'use strict';
	
	    return {
	        restrict: 'E',
	        scope: {},
	        controller: ['$scope', function ($scope) {
	            $scope.stats = {};
	            $scope.has_seen_alert = has_seen_alert;
	            $scope.dismissAlert = function () {
	                has_seen_alert = true;
	                $scope.has_seen_alert = true;
	            };
	            /*
	            Restangular
	                .all('commands')
	                .getList({filter: '{"date_gte":"' + oneMonthAgo.toISOString() +'"}', sort: '["date","DESC"]'})
	                .then(commands => {
	                    $scope.stats.commands = commands.data
	                        .reduce((stats, command) => {
	                            if (command.status != 'cancelled') stats.revenue += command.total;
	                            if (command.status == 'ordered') stats.pending_orders++;
	                            return stats;
	                        }, { revenue: 0, pending_orders: 0})
	                });
	            Restangular
	                .all('customers')
	                .getList({range: '[1,100]', sort: '["first_seen","DESC"]', filter: '{"has_ordered":true,"first_seen_gte":"' +oneMonthAgo.toISOString() + '"}'})
	                .then(customers => {
	                    $scope.stats.customers = customers.data.reduce(nb => ++nb, 0)
	                });
	            Restangular
	                .all('reviews')
	                .getList({range: '[1,100]', sort: '["date","DESC"]', filter: '{"status":"pending"}'})
	                .then(reviews => {
	                    $scope.stats.reviews = reviews.data.reduce(nb => ++nb, 0)
	                });
	                */
	        }],
	        template: _sumaryView2.default
	    };
	}
	
	dashboardSummary.$inject = ['Restangular'];
	
	exports.default = dashboardSummary;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $location) {
	
	    console.log($location.absUrl());
	};
	
	;
	module.exports = exports["default"];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function ($scope, Restangular, $stateParams, NgAdminConfiguration) {
	    var admin = NgAdminConfiguration();
	    var DateField = __webpack_require__(208);
	
	    $scope.label = "Game";
	    $scope.id = $stateParams.id;
	    $scope.entity = admin.getEntity('game');
	    $scope.entry = {};
	    $scope.configs = {};
	    $scope.date = new DateField('age');
	
	    Restangular.one('game', $stateParams.id).get().then(function (data) {
	        data = data.data ? data.data : data;
	
	        $scope.entry = {
	            entity: 'game',
	            id: data.id
	        };
	    });
	    Restangular.all('configs').getList({ _filters: '{"game":"' + $stateParams.id + '"}', _sortDir: "ASC", _sortField: "variable" }).then(function (data) {
	        data = data.data ? data.data : data;
	
	        $scope.configs = data;
	        $scope.apply();
	    });
	
	    $scope.apply = function () {
	        Restangular.one('config/test/game', $stateParams.id).get({ age: $scope.age }).then(function (data) {
	            data = data.data ? data.data : data;
	
	            for (var i in $scope.configs) {
	                var id = $scope.configs[i].variable.id;
	                $scope.configs[i].initial_value = data.config[id].config;
	            }
	        });
	    };
	
	    $scope.range = function (min, max, step) {
	        step = step || 1;
	        var input = [];
	        for (var i = min; i <= max; i += step) {
	            input.push(i);
	        }return input;
	    };
	
	    $scope.columns = 0;
	
	    $scope.run = function (index, column_update, callback) {
	
	        var params = {
	            finished: $scope.configs[index] ? $scope.configs[index].finished : false,
	            returnParams: {},
	            activityValues: {}
	        };
	
	        for (var i in $scope.configs) {
	            var data = void 0,
	                activity = null;
	
	            if (!$scope.configs[i] || _typeof($scope.configs[i]) !== 'object' || !('variable' in $scope.configs[i])) continue;
	
	            if (index > 0) activity = $scope.configs[i].return[index - 1];else activity = $scope.configs[i].initial_value;
	
	            if ($scope.configs[i].data && $scope.configs[i].data[index]) data = $scope.configs[i].data[index];else data = activity;
	
	            params.activityValues[$scope.configs[i].variable.id] = activity;
	            params.returnParams[$scope.configs[i].variable.id] = data;
	        }
	
	        Restangular.one('config/test/game', $stateParams.id).get({ activity: params }).then(function (data) {
	            data = data.data ? data.data : data;
	
	            for (var _i in $scope.configs) {
	                if (!$scope.configs[_i] || _typeof($scope.configs[_i]) !== 'object' || !('variable' in $scope.configs[_i])) continue;
	
	                if (!$scope.configs[_i].return) $scope.configs[_i].return = [];
	
	                $scope.configs[_i].return[column_update != null ? column_update : $scope.columns] = data.config[$scope.configs[_i].variable.id].config;
	            }
	
	            if (column_update == null) $scope.columns++;
	
	            if (callback) callback();
	        });
	    };
	    $scope.reset = function (index) {
	        $scope.run(index, index);
	    };
	
	    $scope.reset_index = 0;
	    $scope.reset_all = function () {
	
	        $scope.run($scope.reset_index, $scope.reset_index, function () {
	            if ($scope.reset_index < $scope.columns) {
	                $scope.reset_all();
	                $scope.reset_index++;
	            } else {
	                $scope.reset_index = 0;
	            }
	        });
	    };
	
	    $scope.delete_all = function () {
	
	        for (var i in $scope.configs) {
	            var data = void 0,
	                activity = null;
	
	            if (!$scope.configs[i] || _typeof($scope.configs[i]) !== 'object' || !('variable' in $scope.configs[i])) continue;
	
	            delete $scope.configs[i].return;
	            delete $scope.configs[i].data;
	        }
	        $scope.columns = 0;
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $rootScope, $mdSidenav, $mdMedia, AuthenticationService, $location, $translate) {
	    $scope.username = $rootScope.globals.currentUser.username;
	
	    $rootScope.aside = true;
	    $scope.show = true;
	
	    $scope.toggleLeft = function () {
	        if (!$mdMedia('gt-sm')) {
	            $mdSidenav('left').toggle();
	            $rootScope.aside = true;
	        } else $rootScope.aside = !$rootScope.aside;
	
	        $scope.show = $rootScope.aside;
	    };
	
	    $scope.logout = function () {
	        AuthenticationService.Logout();
	        $location.path('/login');
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $timeout, $mdDialog, $filter, Restangular, FlashService, purchases, invoices) {
	
	    $scope.has_company = GetData().currentUser.company;
	    $scope.purchases = [], $scope.invoices = [], $scope.payments = [], $scope.pending = [];
	
	    $scope.pad = function (n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    purchases.forEach(function (v, i) {
	
	        var date = ParseDate(v.created);
	        v.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(v.id, 4);
	
	        if (v.status <= 99 && v.updated) $scope.purchases.push(v);else $scope.pending.push(v);
	    });
	
	    invoices.forEach(function (v, i) {
	
	        if (!v.purchase) return;
	
	        var date = ParseDate(v.created);
	        v.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(v.purchase.id, 4);
	
	        if (v.payment) {
	            $scope.payments.push(v);
	        } else {
	            $scope.invoices.push(v);
	        }
	    });
	
	    $scope.removePending = function ($event, purchase, index) {
	
	        var confirm = $mdDialog.confirm().title($filter('translate')('CONFIRM_REMOVE_PURCHASE_PENDING')).targetEvent($event).ok($filter('translate')('REMOVE!')).cancel($filter('translate')('CANCEL'));
	
	        $mdDialog.show(confirm).then(function () {
	            FlashService.Success("YOUR_PENDING_REMOVED");
	
	            return Restangular.one("purchase", purchase.id).remove().then(function (data) {
	                $scope.pending.splice(index, 1);
	            });
	        });
	    };
	
	    $scope.viewInvoice = function ($event, invoice) {
	        return Restangular.one("invoice", invoice.id).one("pdf").withHttpConfig({ responseType: 'blob' }).get().then(function (data) {
	            data = data.data ? data.data : data;
	
	            var fileName = 'BrainVt-' + invoice.numeration + '.pdf';
	            var a = document.createElement('a');
	            document.body.appendChild(a);
	            a.style = 'display: none';
	            var file = new Blob([data], { type: 'application/pdf' });
	            var fileURL = (window.URL || window.webkitURL).createObjectURL(file);
	
	            //Open
	            //window.open(fileURL);
	
	            // Download
	            a.href = fileURL;
	            a.download = fileName;
	            a.click();
	            (window.URL || window.webkitURL).revokeObjectURL(data);
	        });
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $timeout, $mdDialog, $filter, Restangular, FlashService, progression, licences, users, invoices) {
	
	    $scope.selected = [];
	
	    $scope.invoices = [];
	    $scope.licences = licences;
	    $scope.users = users;
	    $scope.is_company = HasRole('company');
	    $scope.current = GetData().currentUser.id;
	
	    $scope.user_reassign = null;
	    $scope.licence = null;
	    $scope.toggleInvoiceLicence = null;
	    $scope.licenceInvoices = null;
	
	    $scope.pad = function (n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    invoices.forEach(function (v, i) {
	
	        if (!v.purchase) return;
	
	        var date = ParseDate(v.created);
	        v.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(v.purchase.id, 4);
	
	        if (v.payment) {} else {
	            $scope.invoices.push(v);
	        }
	    });
	
	    licences.forEach(function (v, i) {
	        if (v.purchase && !v.purchase.paypal_status || v.purchase && ['recurring_payment_skipped', 'mp_cancel', 'recurring_payment_failed'].indexOf(v.purchase.paypal_status) >= 0) {
	            v.purchase.paypal_status = 'recurring_payment_default';
	        }
	    });
	
	    $scope.removeIdentifier = function ($event, licence) {
	
	        progression.start();
	
	        var confirm = $mdDialog.confirm().title($filter('translate')('REMOVE_YOUR_LICENCE_LINK')).htmlContent($filter('translate')('REMOVE_YOUR_LICENCE_LINK_TEXT')).ariaLabel($filter('translate')('LUCKY_DAY')).targetEvent($event).ok($filter('translate')('REMOVE!')).cancel($filter('translate')('CANCEL'));
	
	        $mdDialog.show(confirm).then(function () {
	
	            progression.done();
	
	            return Restangular.one("licence", licence.id).one("identifier").remove().then(function (data) {
	                FlashService.Success($filter('translate')("SUCCESS_REMOVE_LICENCE"));
	
	                licence.identifier = "";
	            });
	        });
	    };
	
	    $scope.toggle_invoices = function ($event, licence) {
	        if ($scope.toggleInvoiceLicence == licence.licence) {
	            $scope.toggleInvoiceLicence = null;
	            $scope.licenceInvoices = null;
	        } else {
	            if (typeof licence.purchase != 'undefined') {
	                $scope.toggleInvoiceLicence = licence.licence;
	                $scope.licenceInvoices = $scope.invoices.filter(function (x) {
	                    return x.purchase.id == licence.purchase.id;
	                });
	            }
	        }
	    };
	
	    $scope.viewInvoice = function ($event, invoice) {
	        return Restangular.one("invoice", invoice.id).one("pdf").withHttpConfig({ responseType: 'blob' }).get().then(function (data) {
	            data = data.data ? data.data : data;
	
	            var fileName = 'BrainVt-' + invoice.numeration + '.pdf';
	            var a = document.createElement('a');
	            document.body.appendChild(a);
	            a.style = 'display: none';
	            var file = new Blob([data], { type: 'application/pdf' });
	            var fileURL = (window.URL || window.webkitURL).createObjectURL(file);
	
	            //Open
	            //window.open(fileURL);
	
	            // Download
	            a.href = fileURL;
	            a.download = fileName;
	            a.click();
	            (window.URL || window.webkitURL).revokeObjectURL(data);
	        });
	    };
	
	    $scope.cancel_subscription = function ($event, licence) {
	        progression.start();
	
	        var confirm = $mdDialog.confirm().title($filter('translate')('CANCEL_YOUT_SUBSCRIPTION')).htmlContent($filter('translate')('CANCEL_YOUT_SUBSCRIPTION_TEXT')).ariaLabel($filter('translate')('LUCKY_DAY')).targetEvent($event).ok($filter('translate')('OK!')).cancel($filter('translate')('CANCEL'));
	
	        $mdDialog.show(confirm).then(function () {
	
	            progression.done();
	
	            return Restangular.one("purchase", licence.purchase.id).one("cancel").remove().then(function (data) {
	                FlashService.Success($filter('translate')("SUCCESS_CANCEL_SUBSCRIPTION"));
	
	                $scope.licences.map(function (l) {
	                    if (l.id == licence.id) {
	                        l.purchase.paypal_status = 'recurring_payment_profile_cancel';
	                    }
	
	                    return l;
	                });
	            });
	        });
	    };
	
	    $scope.suspend_subscription = function ($event, licence) {
	        progression.start();
	
	        var confirm = $mdDialog.confirm().title($filter('translate')('SUSPEND_YOUT_SUBSCRIPTION')).htmlContent($filter('translate')('SUSPEND_YOUT_SUBSCRIPTION_TEXT')).ariaLabel($filter('translate')('LUCKY_DAY')).targetEvent($event).ok($filter('translate')('OK!')).cancel($filter('translate')('CANCEL'));
	
	        $mdDialog.show(confirm).then(function () {
	
	            progression.done();
	
	            return Restangular.one("purchase", licence.purchase.id).one("suspend").remove().then(function (data) {
	                FlashService.Success($filter('translate')("SUCCESS_SUSPEND_SUBSCRIPTION"));
	
	                $scope.licences.map(function (l) {
	                    if (l.id == licence.id) {
	                        l.purchase.paypal_status = 'recurring_payment_suspended';
	                    }
	
	                    return l;
	                });
	            });
	        });
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $location, $window) {
	    //AuthenticationService.ClearCredentials();
	
	
	    if (Cookies.get('loading') && GetData()) {
	        var path = Cookies.get('loading_path') || '/account';
	        Cookies.remove('loading');
	        Cookies.remove('loading_path');
	
	        $location.path(path);
	    } else {
	        Cookies.set('loading', true);
	        $window.location.reload();
	    }
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $location, $window, AuthenticationService, FlashService) {
	    //AuthenticationService.ClearCredentials();
	
	    if (GetData().currentUser) $location.path('/account');
	
	    $scope.menu = function () {
	        $('html').toggleClass("nav-open");
	    };
	    $scope.year = new Date().getFullYear();
	
	    setTimeout(function () {
	        if ($location.search().expired) {
	            FlashService.Error('ERROR_LINK_EXPIRED');
	
	            $location.search('expired', null);
	        }
	    }, 100);
	
	    $scope.login = function () {
	        $scope.dataLoading = true;
	        AuthenticationService.Login($scope.username, $scope.password, function (response) {
	            if (response.status == "200") {
	                AuthenticationService.SetCredentials(response.data.access_token, function () {
	                    $location.path('/loading');
	                });
	            } else {
	                FlashService.Error('ERROR_USSER_PASSWORD_INCORRECT');
	                $scope.dataLoading = false;
	            }
	        });
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 192 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function ($scope, $location, products, settings, $anchorScroll, FlashService, Restangular) {
	
	    $scope.promo = {
	        product: findProduct(find('promo_product', null)),
	        duration: find('promo_duration', null),
	        licence: find('promo_licence_days', null),
	        enabled: find('promo_enabled', false),
	        text: find('promo_text', {})
	    };
	
	    $scope.days = [{ value: '', label: 'None' }, { value: '1', label: '1 día' }, { value: '5', label: '5 dias' }, { value: '10', label: '10 dias' }, { value: '20', label: '20 dias' }, { value: '30', label: '30 dias' }, { value: '45', label: '45 dias' }, { value: '60', label: '60 dias' }, { value: '75', label: '75 dias' }, { value: '90', label: '90 dias' }];
	
	    $scope.querySearch = function (query) {
	        return query ? products.filter(createFilterFor(query)) : products;
	    };
	
	    function createFilterFor(query) {
	        var lowercaseQuery = angular.lowercase(query);
	
	        return function filterFn(product) {
	            return angular.lowercase(product.name).indexOf(lowercaseQuery) !== -1;
	        };
	    }
	
	    function find(query, def) {
	        var setting = settings.find(function (config) {
	            return config.name === query;
	        });
	
	        if (!setting) {
	            return def;
	        }
	
	        if (_typeof(setting.value) == 'object' && setting.value.length == 0) {
	            return def;
	        }
	
	        if (setting.value) {
	            return setting.value;
	        }
	
	        return def;
	    }
	
	    function findProduct(query) {
	        return products.find(function (product) {
	            return product.id === query;
	        });
	
	        return null;
	    }
	
	    $scope.save = function () {
	        $scope.dataLoading = true;
	
	        var data = {
	            promo_enabled: $scope.promo.enabled,
	            promo_product: $scope.promo.product ? $scope.promo.product.id : null,
	            promo_duration: $scope.promo.duration,
	            promo_licence_days: $scope.promo.licence,
	            promo_text: $scope.promo.text
	        };
	
	        data.fields = Object.keys(data);
	
	        Restangular.all('settings').customPOST(data, false).then(function (data) {
	
	            FlashService.Success("Se ha guardado correctamente");
	
	            $scope.dataLoading = false;
	
	            //$location.path('/login');
	        }, function (error) {
	            $scope.dataLoading = false;
	
	            $anchorScroll("navbar");
	            FlashService.Error("Se han encontrado errores contacta tu administador de sistema");
	
	            error.data.fields.forEach(function (field, index) {
	                if (field.property_path == 'email' || field.property_path == 'username') {
	                    $scope.form[field.property_path].$setValidity('exists', false);
	                }
	
	                if (field.property_path == 'plainPassword') {
	                    $scope.form[field.property_path].$setValidity('low', false);
	                }
	            });
	
	            form.$invalid = false;
	        });
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($scope) {};
	
	;
	module.exports = exports["default"];

/***/ },
/* 194 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($scope) {};
	
	;
	module.exports = exports["default"];

/***/ },
/* 195 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($scope) {};
	
	;
	module.exports = exports["default"];

/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function ($scope, $anchorScroll, AuthenticationService, FlashService, Restangular, states, prescriberTypes, user, progression, $location) {
	
	    $scope.year = new Date().getFullYear();
	
	    var date = new Date();
	    date.setFullYear(date.getFullYear());
	    $scope.maxdate = date;
	
	    $scope.roles = {
	        'ROLE_PATIENT': 'patient',
	        'ROLE_PRENSCRIPTOR': 'prescriber',
	        'ROLE_COMPANY': 'company'
	    };
	
	    $scope.role = _typeof(user.roles) == 'object' ? user.roles[0] : user.roles;
	
	    $scope.prescriberTypes = prescriberTypes;
	    $scope.states = states;
	    $scope.type = $scope.roles instanceof Array ? $scope.roles[user.roles[0]] : $scope.roles[user.roles];
	    $scope.email = user.email;
	    $scope.company = user.company;
	    $scope.cif = user.cif;
	    $scope.postalCode = user.postal_code;
	    $scope.city = user.city;
	    $scope.address = user.address;
	    $scope.prescriberType = user.prescriber_type ? user.prescriber_type.id : null;
	    $scope.state = user.state ? user.state.id : null;
	    $scope.birthday = user.birthday ? ParseDate(user.birthday) : null;
	    $scope.name = user.name;
	    $scope.surname = user.surname;
	
	    $scope.$root.$watch('current_language', function (new_value) {
	        $scope.updatePrescriptorType(new_value);
	    });
	
	    $scope.updatePrescriptorType = function (language) {
	        if (!$scope.prescriberTypes || !language) return false;
	
	        $scope.prescriberTypes.map(function (type) {
	            if (type['description_' + language]) type.label = type['description_' + language];else type.label = type['description'];
	
	            return type;
	        });
	    };
	
	    $scope.$watch('email', function () {
	        $scope.form.email.$setValidity('exists', true);
	    });
	
	    $scope.register = function () {
	        $scope.dataLoading = true;
	        progression.start();
	
	        var birthday = null;
	
	        if ($scope.birthday) {
	            var date = new Date($scope.birthday);
	            birthday = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
	        }
	
	        var user = {
	            username: $scope.username,
	            email: $scope.email,
	            plainPassword: $scope.plainPassword,
	            name: $scope.name ? $scope.name : $scope.company,
	            surname: $scope.surname,
	            birthday: birthday,
	            prescriberType: $scope.precriberType,
	            city: $scope.city,
	            address: $scope.address,
	            postalCode: $scope.postalCode,
	            state: $scope.state,
	            cif: $scope.cif
	        };
	
	        if (!$scope.plainPassword) delete user.plainPassword;
	
	        if (!birthday) delete user.birthday;
	
	        Restangular.all('user').patch(user).then(function (data) {
	
	            $location.path('/account');
	
	            FlashService.Success("PROFILE_UPDATE");
	            progression.done();
	
	            $scope.dataLoading = false;
	        }, function (error) {
	            $scope.dataLoading = false;
	
	            $anchorScroll("body");
	            FlashService.Error("MALFORMET_DATA");
	            progression.done();
	
	            error.data.fields.forEach(function (field, index) {
	                if (field.property_path == 'email' || field.property_path == 'username') {
	                    $scope.form[field.property_path].$setValidity('exists', false);
	                }
	
	                if (field.property_path == 'plainPassword') {
	                    $scope.form[field.property_path].$setValidity('low', false);
	                }
	            });
	
	            form.$invalid = false;
	        });
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $location, $window, $anchorScroll, AuthenticationService, FlashService, Restangular, CifService, $mdDialog, $filter, promo) {
	    if (GetData().currentUser) $location.path('/account');
	
	    if (!promo) {
	        $location.path('/login');
	        FlashService.Error('PROMO_UNAVAIABLE');
	    }
	
	    $scope.menu = function () {
	        $('html').toggleClass("nav-open");
	    };
	    $scope.year = new Date().getFullYear();
	
	    var date = new Date();
	    date.setFullYear(date.getFullYear() - 18);
	    $scope.maxdate = date;
	
	    $scope.roles_list = {
	        'patient': 'ROLE_PATIENT',
	        'prescriber': 'ROLE_PRENSCRIPTOR',
	        'company': 'ROLE_COMPANY'
	    };
	
	    Restangular.allUrl('states', AuthenticationService.Api.Public + 'states').getList({ _filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	        data = data.data ? data.data : data;
	
	        $scope.states = data;
	        $scope.apply();
	    });
	
	    Restangular.allUrl('prescriberTypes', AuthenticationService.Api.Public + 'prescriberTypes').getList({ _sortDir: "ASC", _sortField: "description" }).then(function (data) {
	        data = data.data ? data.data : data;
	
	        $scope.prescriberTypes = data;
	        $scope.updatePrescriptorType($scope.$root.current_language);
	
	        $scope.apply();
	    });
	
	    $scope.$watch('username', function () {
	        $scope.form.username.$setValidity('exists', true);
	    });
	
	    $scope.$watch('cif', function (value) {
	        $scope.form.cif.$setValidity('exists', true);
	
	        if (!CifService.Validate(value)) {
	            $scope.form.cif.$setValidity('invalid', false);
	        } else {
	            $scope.form.cif.$setValidity('invalid', true);
	        }
	    });
	
	    $scope.$root.$watch('current_language', function (new_value) {
	        $scope.updatePrescriptorType(new_value);
	    });
	
	    $scope.updatePrescriptorType = function (language) {
	        if (!$scope.prescriberTypes || !language) return false;
	
	        $scope.prescriberTypes.map(function (type) {
	            if (type['description_' + language]) type.label = type['description_' + language];else type.label = type['description'];
	
	            return type;
	        });
	    };
	
	    $scope.translate = function (text) {
	        return $filter('translate')(text);
	    };
	
	    $scope.problem = function (ev) {
	        var alert = $mdDialog.alert().parent(angular.element(document.body)).clickOutsideToClose(true).htmlContent('<h3>' + $scope.translate('PROMO_PROBLEM_TITLE') + '</h3>' + "<br>" + $scope.translate('PROMO_PROBLEM_TEXT')).targetEvent(ev).fullscreen(true).ok("ok");
	
	        $mdDialog.show(alert).finally(function () {
	            $location.path('/login');
	        });
	    };
	
	    $scope.register = function () {
	        $scope.dataLoading = true;
	
	        AuthenticationService.PublicLogin(function (response) {
	            if (response.status == "200") {
	
	                var birthday = null;
	
	                if ($scope.birthday) {
	                    var _date = new Date($scope.birthday);
	                    birthday = _date.getFullYear() + "-" + ("0" + (_date.getMonth() + 1)).slice(-2) + "-" + ("0" + _date.getDate()).slice(-2);
	                }
	
	                var userData = {
	                    username: $scope.username,
	                    email: promo.email ? promo.email : $scope.email,
	                    name: $scope.name ? $scope.name : $scope.company,
	                    surname: $scope.surname,
	                    roles: 'ROLE_PRENSCRIPTOR',
	                    birthday: birthday,
	                    prescriberType: $scope.precriberType,
	                    city: $scope.city,
	                    address: $scope.address,
	                    postalCode: $scope.postalCode,
	                    state: $scope.state,
	                    phone: $scope.phone,
	                    cif: $scope.cif,
	                    promo: promo.token
	                };
	
	                if (!birthday) delete userData.birthday;
	
	                Restangular.all('user').post(userData).then(function (data) {
	
	                    FlashService.Success("CREATED_CHECK_YOUR_EMAIL");
	
	                    $scope.dataLoading = false;
	
	                    $location.path('/login');
	                }, function (error) {
	                    $scope.dataLoading = false;
	
	                    $anchorScroll("navbar");
	
	                    var flash_error = "MALFORMET_DATA";
	                    var modal = false;
	
	                    error.data.fields.forEach(function (field, index) {
	                        if (field.property_path == 'email' || field.property_path == 'username') {
	                            $scope.form[field.property_path].$setValidity('exists', false);
	                        }
	
	                        if (field.property_path == 'plainPassword') {
	                            $scope.form[field.property_path].$setValidity('low', false);
	                        }
	
	                        if (field.property_path == 'ip' || field.property_path == 'cif') {
	                            modal = true;
	                        }
	                    });
	
	                    form.$invalid = false;
	
	                    if (modal) {
	                        $scope.problem();
	                    } else {
	                        FlashService.Error(flash_error);
	                    }
	                });
	            } else {
	                FlashService.Error("Internal Error");
	            }
	        }, true);
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $timeout, $mdDialog, Restangular, FlashService) {
	
	    var type = $scope.$parent.type;
	    var states = $scope.$parent.states;
	    var user = $scope.$parent.user;
	    var purchase = $scope.$parent.purchase;
	    var licences = $scope.$parent.licences;
	
	    $scope.iban = $scope.$parent.iban;
	    $scope.licence = {};
	    $scope.states = states;
	    $scope.invoice_data = 'user';
	    $scope.validateCodeTime = null;
	
	    $scope.licences = {};
	
	    licences.forEach(function (v, i) {
	        if ($scope.$parent.licences_pro.length && v.abbr == 'pro' || v.abbr != 'pro' && v.abbr != 'gold') $scope.licences[v.id] = v;
	
	        if ($scope.$parent.licences_gold.length && v.abbr == 'gold' || v.abbr != 'pro' && v.abbr != 'gold') $scope.licences[v.id] = v;
	
	        if (!$scope.$parent.licences_pro.length && !$scope.$parent.licences_gold.length) $scope.licences[v.id] = v;
	    });
	
	    $scope.pad = function (n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    if (purchase) {
	
	        $scope.product = purchase.product.id;
	        $scope.sub = purchase.sub;
	
	        if (purchase.product.type == 'licence') {
	            $scope.licences[$scope.product].promotional = false;
	
	            if (purchase.method == "wire") {
	                $scope.method = "wire";
	                $scope.isBuy = true;
	
	                var date = ParseDate(purchase.created);
	                $scope.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(purchase.id, 4);
	            }
	        }
	
	        if (purchase.invoice_data.invoice_data == "other") {
	            $scope.invoice_data = purchase.invoice_data.invoice_data;
	            $scope.company = purchase.invoice_data.company;
	            $scope.name = purchase.invoice_data.name;
	            $scope.surname = purchase.invoice_data.surname;
	            $scope.city = purchase.invoice_data.city;
	            $scope.address = purchase.invoice_data.address;
	            $scope.postalCode = purchase.invoice_data.postalCode;
	            $scope.state = purchase.invoice_data.state;
	            $scope.cif = purchase.invoice_data.cif;
	        }
	    }
	
	    $scope.setProduct = function (product) {
	        if (!$scope.$parent.purchase) {
	            $scope.product = product.id;
	        }
	    };
	
	    $scope.setSub = function (sub) {
	        $scope.sub = sub;
	    };
	
	    if (HasRole('company')) {
	        $scope.data = user.name + " - " + user.cif;
	    }
	    if (HasRole('prenscriptor')) {
	        $scope.data = user.name + " " + user.surname + " - " + user.cif;
	    }
	
	    $scope.$watchGroup(['product', 'sub'], function (new_value, old_value) {
	        var tax = 21;
	        var price = 0;
	        var price_year = 0;
	
	        if (user.state && user.state.country && user.state.country.tax) tax = user.state.country.tax;
	
	        if ($scope.licences[new_value[0]]) {
	            price = $scope.licences[new_value[0]].price;
	            price_year = $scope.licences[new_value[0]].price_annual;
	        }
	
	        $scope.total = new_value[1] === 12 ? price_year : price / 12;
	        $scope.taxes = $scope.total ? $scope.total * (tax / 100) : 0;
	        $scope.total_taxes = $scope.total ? $scope.taxes + $scope.total : 0;
	
	        var month = (price / 12).toFixed(2).split('.');
	        $scope.month_big = month[0];
	        $scope.month_small = month[1];
	        $scope.month_total = price;
	
	        var year = (price_year / 12).toFixed(2).split('.');
	        $scope.year_big = year[0];
	        $scope.year_small = year[1];
	        $scope.year_total = price_year;
	        $scope.year_save = (price_year * 100 / price).toFixed(0);
	
	        $scope.form.promotion.$setValidity('no', true);
	
	        $scope.$parent.scroll('pay');
	    });
	
	    $scope.validateCodeChange = function () {
	        $scope.form.promotion.$setValidity('no', true);
	
	        if ($scope.validateCodeTime != null) {
	            $timeout.cancel($scope.validateCodeTime);
	        }
	
	        $scope.validateCodeTime = $timeout(function () {
	            $scope.validateCode();
	        }, 2000);
	    };
	
	    $scope.validateCodeEnter = function ($event) {
	        $scope.form.promotion.$setValidity('no', true);
	
	        if ($scope.validateCodeTime != null) $timeout.cancel($scope.validateCodeTime);
	
	        $scope.validateCodeTime = $timeout(function () {
	            $scope.validateCode();
	        }, 2000);
	    };
	
	    $scope.validateCode = function () {
	        if (!$scope.promotion) return $scope.form.promotion.$setValidity('no', true);
	
	        Restangular.one('promotional_code/validate/' + $scope.promotion).get().then(function (data) {
	            data = data.data ? data.data : data;
	
	            if (data.product) {
	                data.product.promotional = false;
	
	                if (data.product.type == 'licence') $scope.licences[data.product.id] = data.product;
	
	                $scope.product = data.product.id;
	            }
	
	            $scope.form.promotion.$$element.blur();
	        }, function (error) {
	            $scope.form.promotion.$setValidity('no', false);
	
	            $scope.form.promotion.$$element.blur().focus();
	        });
	    };
	
	    $scope.buy = function (ev) {
	        $scope.dataLoading = true;
	
	        var data = {
	            product: $scope.product,
	            invoice_data: $scope.invoice_data,
	            method: $scope.method,
	            company: $scope.company,
	            name: $scope.name,
	            surname: $scope.surname,
	            city: $scope.city,
	            address: $scope.address,
	            postalCode: $scope.postalCode,
	            state: $scope.state,
	            cif: $scope.cif,
	            sub: $scope.sub
	        };
	
	        if (purchase && purchase.id) data.purchase = purchase.id;
	
	        if ($scope.method == 'credit_card') {
	
	            Restangular.all('purchase/creditcard').post(data).then(function (data) {
	                $scope.isBuy = true;
	                $scope.dataLoading = false;
	
	                data = data.data ? data.data : data;
	
	                $('#params').val(data.params);
	                $('#signature').val(data.signature);
	
	                $('#visa').attr('action', data.url).submit();
	            });
	        } else if ($scope.method == 'wire') {
	            Restangular.all('purchase/wire').post(data).then(function (data) {
	                data = data.data ? data.data : data;
	
	                $scope.isBuy = true;
	                $scope.dataLoading = false;
	                $scope.order = data.order;
	
	                var translate = $scope.$parent.translate;
	
	                var alert = $mdDialog.alert().parent(angular.element(document.body)).clickOutsideToClose(true).htmlContent('<h3>' + translate('BUY_SUCCESS') + '</h3>' + "<br>" + translate('YOU_MUST_MAKE_BANK_TRANSFER') + " <strong>" + $scope.iban + "</strong> " + '<br>' + translate('WITH_THE_CONCEPT') + ': <strong>' + translate('ORDER') + ' ' + data.order + '</strong>').targetEvent(ev).fullscreen(true).ok("ok");
	
	                $mdDialog.show(alert);
	            });
	        } else if ($scope.method == 'paypal') {
	            Restangular.all('purchase/paypal').post(data).then(function (data) {
	                $scope.isBuy = true;
	                $scope.dataLoading = false;
	
	                data = data.data ? data.data : data;
	
	                window.location.href = data.url;
	            });
	        }
	    };
	};
	
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $sce, $timeout, $anchorScroll, $filter, Api, Restangular, FlashService, user, states, licences, purchase, active_licences) {
	
	    $scope.licences_pro = [];
	    $scope.licences_vr = [];
	    $scope.licences_gold = [];
	    $scope.scroll = $anchorScroll;
	
	    $scope.has_company = GetData().currentUser.company;
	    $scope.user = user;
	    $scope.states = states;
	    $scope.iban = Api.IBAN;
	
	    $scope.image_path = Api.IMAGES + 'uploads/products/';
	
	    if (purchase.id) {
	        $scope.purchase = purchase;
	        $scope.show_only = purchase.product.type;
	    } else $scope.show_only = purchase;
	
	    $scope.licences = licences;
	
	    active_licences.forEach(function (licence, index) {
	        if (licence.type == 'vr') {
	            $scope.licences_vr.push(licence);
	        }
	        if (licence.type == 'pro') {
	            $scope.licences_pro.push(licence);
	        }
	        if (licence.type == 'gold') {
	            $scope.licences_gold.push(licence);
	        }
	    });
	
	    $scope.gotoAnchor = function (x) {
	        $timeout(function () {
	            $anchorScroll($scope.show_only);
	        }, 1);
	    };
	
	    $scope.types = {
	        'licence': {
	            name: 'LICENCES'
	        }
	    };
	
	    $scope.translate = function (text) {
	        return $filter('translate')(text);
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $timeout, $mdDialog, Restangular, FlashService) {
	
	    var type = $scope.$parent.type;
	    var states = $scope.$parent.states;
	    var user = $scope.$parent.user;
	    var purchase = $scope.$parent.purchase;
	    var subscriptions = $scope.$parent.subscriptions;
	    var games = $scope.$parent.games;
	    var active_licences = $scope.$parent.active_licences;
	
	    $scope.iban = $scope.$parent.iban;
	    $scope.licence = {};
	    $scope.states = states;
	    $scope.invoice_data = 'user';
	    $scope.validateCodeTime = null;
	
	    $scope.subscriptions = {};
	    $scope.games = {};
	    $scope.active_types = [];
	
	    active_licences.forEach(function (v, i) {
	        $scope.active_types[v.type.id] = v.type.id;
	    });
	
	    subscriptions.forEach(function (v, i) {
	
	        if (!v.licencesType) {
	            $scope.subscriptions[v.id] = v;
	        } else {
	            v.licencesType.forEach(function (s, i) {
	                if ($scope.active_types.indexOf(s) >= 0) {
	                    $scope.subscriptions[v.id] = v;
	                }
	            });
	        }
	    });
	
	    games.forEach(function (v, i) {
	        $scope.games[v.id] = v;
	    });
	
	    $scope.pad = function (n, width, z) {
	        z = z || '0';
	        n = n + '';
	        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    };
	
	    if (purchase) {
	
	        $scope.product = purchase.product.id;
	
	        if (purchase.product.type == 'subscription') {
	            $scope.subscriptions[$scope.product].promotional = false;
	
	            if (purchase.method == "wire") {
	                $scope.method = "wire";
	                $scope.isBuy = true;
	
	                var date = ParseDate(purchase.created);
	                $scope.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(purchase.id, 4);
	            }
	        }
	
	        if (purchase.product.type == 'game') {
	            $scope.games[$scope.product].promotional = false;
	
	            if (purchase.method == "wire") {
	                $scope.method = "wire";
	                $scope.isBuy = true;
	
	                var _date = ParseDate(purchase.created);
	                $scope.order = _date.getFullYear() + "" + _date.getMonth() + "" + _date.getDate() + "" + $scope.pad(purchase.id, 4);
	            }
	        }
	
	        if (purchase.invoice_data.invoice_data == "other") {
	            $scope.invoice_data = purchase.invoice_data.invoice_data;
	            $scope.company = purchase.invoice_data.company;
	            $scope.name = purchase.invoice_data.name;
	            $scope.surname = purchase.invoice_data.surname;
	            $scope.city = purchase.invoice_data.city;
	            $scope.address = purchase.invoice_data.address;
	            $scope.postalCode = purchase.invoice_data.postalCode;
	            $scope.state = purchase.invoice_data.state;
	            $scope.cif = purchase.invoice_data.cif;
	        }
	    }
	
	    if (HasRole('company')) {
	        $scope.data = user.name + " - " + user.cif;
	    }
	    if (HasRole('prenscriptor')) {
	        $scope.data = user.name + " " + user.surname + " - " + user.cif;
	    }
	
	    $scope.$watch('product', function (new_value, old_value) {
	        var tax = 21;
	        var price = 0;
	
	        if (user.state && user.state.country && user.state.country.tax) tax = user.state.country.tax;
	
	        if ($scope.subscriptions[new_value]) price = $scope.subscriptions[new_value].price;
	
	        if ($scope.games[new_value]) price = $scope.games[new_value].price;
	
	        $scope.total = price;
	        $scope.taxes = price ? price * (tax / 100) : 0;
	        $scope.total_taxes = price ? $scope.taxes + price : 0;
	
	        $scope.form.promotion.$setValidity('no', true);
	    });
	
	    $scope.validateCodeChange = function () {
	        $scope.form.promotion.$setValidity('no', true);
	
	        if ($scope.validateCodeTime != null) {
	            $timeout.cancel($scope.validateCodeTime);
	        }
	
	        $scope.validateCodeTime = $timeout(function () {
	            $scope.validateCode();
	        }, 2000);
	    };
	
	    $scope.validateCodeEnter = function ($event) {
	        $scope.form.promotion.$setValidity('no', true);
	
	        if ($scope.validateCodeTime != null) $timeout.cancel($scope.validateCodeTime);
	
	        $scope.validateCodeTime = $timeout(function () {
	            $scope.validateCode();
	        }, 2000);
	    };
	
	    $scope.validateCode = function () {
	        if (!$scope.promotion) return $scope.form.promotion.$setValidity('no', true);
	
	        Restangular.one('promotional_code/validate/' + $scope.promotion).get().then(function (data) {
	            data = data.data ? data.data : data;
	
	            if (data.product) {
	                data.product.promotional = false;
	
	                if (data.product.type == 'subscription') $scope.subscriptions[data.product.id] = data.product;
	
	                if (data.product.type == 'game') $scope.games[data.product.id] = data.product;
	
	                $scope.product = data.product.id;
	            }
	
	            $scope.form.promotion.$$element.blur();
	        }, function (error) {
	            $scope.form.promotion.$setValidity('no', false);
	
	            $scope.form.promotion.$$element.blur().focus();
	        });
	    };
	
	    $scope.buy = function (ev) {
	
	        $scope.dataLoading = true;
	
	        var data = {
	            product: $scope.product,
	            invoice_data: $scope.invoice_data,
	            method: $scope.method,
	            company: $scope.company,
	            name: $scope.name,
	            surname: $scope.surname,
	            city: $scope.city,
	            address: $scope.address,
	            postalCode: $scope.postalCode,
	            state: $scope.state,
	            cif: $scope.cif
	        };
	
	        if (purchase && purchase.id) data.purchase = purchase.id;
	
	        if ($scope.method == 'credit_card') {
	
	            Restangular.all('purchase/creditcard').post(data).then(function (data) {
	                $scope.isBuy = true;
	                $scope.dataLoading = false;
	
	                data = data.data ? data.data : data;
	
	                $('#params').val(data.params);
	                $('#signature').val(data.signature);
	
	                $('#visa').attr('action', data.url).submit();
	            });
	        } else if ($scope.method == 'wire') {
	            Restangular.all('purchase/wire').post(data).then(function (data) {
	                data = data.data ? data.data : data;
	
	                $scope.isBuy = true;
	                $scope.dataLoading = false;
	                $scope.order = data.order;
	
	                var translate = $scope.$parent.translate;
	
	                var alert = $mdDialog.alert().parent(angular.element(document.body)).clickOutsideToClose(true).htmlContent('<h3>' + translate('BUY_SUCCESS') + '</h3>' + "<br>" + translate('YOU_MUST_MAKE_BANK_TRANSFER') + " <strong>" + $scope.iban + "</strong> " + '<br>' + translate('WITH_THE_CONCEPT') + ': <strong>' + translate('ORDER') + ' ' + data.order + '</strong>').targetEvent(ev).fullscreen(true).ok("ok");
	
	                $mdDialog.show(alert);
	            });
	        } else if ($scope.method == 'paypal') {}
	    };
	};
	
	module.exports = exports['default'];

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $sce, $timeout, $anchorScroll, $filter, Api, Restangular, FlashService, user, states, subscriptions, games, purchase, active_licences) {
	
	    $scope.licences_pro = [];
	    $scope.licences_vr = [];
	    $scope.licences_gold = [];
	    $scope.active_licences = active_licences;
	
	    $scope.has_company = GetData().currentUser.company;
	    $scope.user = user;
	    $scope.states = states;
	    $scope.iban = Api.IBAN;
	
	    $scope.image_path = Api.IMAGES + 'uploads/products/';
	
	    if (purchase.id) {
	        $scope.purchase = purchase;
	        $scope.show_only = purchase.product.type;
	    } else $scope.show_only = purchase;
	
	    $scope.subscriptions = subscriptions;
	    $scope.games = games;
	
	    $scope.active_licences.forEach(function (licence, index) {
	        if (licence.type.code == 'vr') {
	            $scope.licences_vr.push(licence);
	        }
	        if (licence.type.code == 'pro') {
	            $scope.licences_pro.push(licence);
	        }
	        if (licence.type.code == 'gold' || licence.type.code == 'specialist') {
	            $scope.licences_gold.push(licence);
	        }
	    });
	
	    $scope.gotoAnchor = function (x) {
	        $timeout(function () {
	            $anchorScroll($scope.show_only);
	        }, 1);
	    };
	
	    $scope.types = {};
	
	    if ($scope.licences_pro.length || $scope.licences_gold.length) {
	        $scope.types['subscription'] = {
	            name: 'SUBSCRIPTIONS'
	        };
	    }
	
	    if ($scope.licences_vr.length) {
	        $scope.types['game'] = {
	            name: 'GAMES VR'
	        };
	    }
	
	    $scope.translate = function (text) {
	        return $filter('translate')(text);
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 202 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($scope) {};
	
	;
	module.exports = exports["default"];

/***/ },
/* 203 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($scope) {};
	
	;
	module.exports = exports["default"];

/***/ },
/* 204 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $location, $window, AuthenticationService, FlashService, Restangular) {
	    if (GetData().currentUser) $location.path('/account');
	
	    $scope.menu = function () {
	        $('html').toggleClass("nav-open");
	    };
	
	    $scope.recovery = function () {
	        $scope.dataLoading = true;
	
	        AuthenticationService.PublicLogin(function (response) {
	            if (response.status == "200") {
	                return Restangular.one('resetpassword', $scope.alias).get().then(function (data) {
	                    data = data.data ? data.data : data;
	
	                    $scope.dataLoading = false;
	
	                    FlashService.Success("SEND_EMAIL_REQUEST_SUCCESS");
	
	                    $location.path('/login');
	                }, function (error) {
	                    error = error.data ? error.data : error;
	
	                    FlashService.Error(error.error_description);
	
	                    $scope.dataLoading = false;
	                });
	            } else {
	                FlashService.Error("INTERNAL_ERROR");
	
	                $scope.dataLoading = false;
	            }
	        }, true);
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $location, $window, $anchorScroll, AuthenticationService, FlashService, Restangular, CifService) {
	    if (GetData().currentUser) $location.path('/account');
	
	    $scope.menu = function () {
	        $('html').toggleClass("nav-open");
	    };
	    $scope.year = new Date().getFullYear();
	
	    var date = new Date();
	    date.setFullYear(date.getFullYear() - 18);
	    $scope.maxdate = date;
	
	    $scope.roles_list = {
	        'patient': 'ROLE_PATIENT',
	        'prescriber': 'ROLE_PRENSCRIPTOR',
	        'company': 'ROLE_COMPANY'
	    };
	
	    Restangular.allUrl('states', AuthenticationService.Api.Public + 'states').getList({ _filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name" }).then(function (data) {
	        data = data.data ? data.data : data;
	
	        $scope.states = data;
	        $scope.apply();
	    });
	
	    Restangular.allUrl('prescriberTypes', AuthenticationService.Api.Public + 'prescriberTypes').getList({ _sortDir: "ASC", _sortField: "description" }).then(function (data) {
	        data = data.data ? data.data : data;
	
	        $scope.prescriberTypes = data;
	        $scope.updatePrescriptorType($scope.$root.current_language);
	
	        $scope.apply();
	    });
	
	    $scope.$watch('email', function () {
	        $scope.form.email.$setValidity('exists', true);
	    });
	
	    $scope.$watch('username', function () {
	        $scope.form.username.$setValidity('exists', true);
	    });
	
	    $scope.$watch('plainPassword', function () {
	        $scope.form.plainPassword.$setValidity('low', true);
	    });
	
	    $scope.$watch('confirm', function () {
	        $scope.form.confirm.$setValidity('same', true);
	    });
	
	    $scope.$root.$watch('current_language', function (new_value) {
	        $scope.updatePrescriptorType(new_value);
	    });
	
	    $scope.$watch('cif', function (value) {
	        $scope.form.cif.$setValidity('exists', true);
	
	        if (!CifService.Validate(value)) {
	            $scope.form.cif.$setValidity('invalid', false);
	        } else {
	            $scope.form.cif.$setValidity('invalid', true);
	        }
	    });
	
	    $scope.updatePrescriptorType = function (language) {
	        if (!$scope.prescriberTypes || !language) return false;
	
	        $scope.prescriberTypes.map(function (type) {
	            if (type['description_' + language]) type.label = type['description_' + language];else type.label = type['description'];
	
	            return type;
	        });
	    };
	
	    $scope.register = function () {
	        $scope.dataLoading = true;
	
	        AuthenticationService.PublicLogin(function (response) {
	            if (response.status == "200") {
	
	                var birthday = null;
	
	                if ($scope.birthday) {
	                    var date = new Date($scope.birthday);
	                    birthday = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
	                }
	
	                var userData = {
	                    username: $scope.username,
	                    email: $scope.email,
	                    plainPassword: $scope.plainPassword,
	                    confirm: $scope.confirm,
	                    name: $scope.name ? $scope.name : $scope.company,
	                    surname: $scope.surname,
	                    roles: $scope.roles_list[$scope.type],
	                    birthday: birthday,
	                    prescriberType: $scope.precriberType,
	                    city: $scope.city,
	                    address: $scope.address,
	                    postalCode: $scope.postalCode,
	                    state: $scope.state,
	                    cif: $scope.cif
	                };
	
	                if (!birthday) delete userData.birthday;
	
	                Restangular.all('user').post(userData).then(function (data) {
	
	                    FlashService.Success("CREATED_CHECK_YOUR_EMAIL");
	
	                    $scope.dataLoading = false;
	
	                    $location.path('/login');
	                }, function (error) {
	                    $scope.dataLoading = false;
	
	                    $anchorScroll("navbar");
	                    FlashService.Error("MALFORMET_DATA");
	
	                    error.data.fields.forEach(function (field, index) {
	                        if (field.property_path == 'email' || field.property_path == 'username') {
	                            $scope.form[field.property_path].$setValidity('exists', false);
	                        }
	
	                        if (field.property_path == 'confirm') {
	                            $scope.form[field.property_path].$setValidity('same', false);
	                        }
	
	                        if (field.property_path == 'plainPassword') {
	                            $scope.form[field.property_path].$setValidity('low', false);
	                        }
	                    });
	
	                    form.$invalid = false;
	                });
	            } else {
	                FlashService.Error("Internal Error");
	            }
	        }, true);
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $location, $window, $anchorScroll, AuthenticationService, FlashService, Restangular) {
	    if (GetData().currentUser) $location.path('/account');
	
	    $scope.menu = function () {
	        $('html').toggleClass("nav-open");
	    };
	
	    $scope.$watch('email', function () {
	        $scope.form.email.$setValidity('exists', true);
	    });
	
	    $scope.$root.$watch('current_language', function (new_value) {
	        $scope.updatePrescriptorType(new_value);
	    });
	
	    $scope.register = function () {
	        $scope.dataLoading = true;
	
	        AuthenticationService.PublicLogin(function (response) {
	            if (response.status == "200") {
	
	                var userData = {
	                    name: $scope.name,
	                    email: $scope.email
	                };
	
	                Restangular.all('user/request-promo').post(userData).then(function (data) {
	
	                    FlashService.Success("PROMO_CREATED_CHECK_YOUR_EMAIL");
	
	                    $scope.dataLoading = false;
	
	                    //$location.path('/login');
	                }, function (error) {
	                    $scope.dataLoading = false;
	
	                    $anchorScroll("navbar");
	
	                    var flash_error = "MALFORMET_DATA";
	
	                    error.data.fields.forEach(function (field, index) {
	                        if (field.property_path == 'email') {
	                            $scope.form[field.property_path].$setValidity('exists', false);
	                        }
	                    });
	                    FlashService.Error(flash_error);
	
	                    form.$invalid = false;
	                });
	            } else {
	                FlashService.Error("Internal Error");
	            }
	        }, true);
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 207 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($scope, $timeout, $mdDialog, Restangular, FlashService, progression, subscriptions, users, $filter) {
	
	    $scope.selected = [];
	    $scope.users = [];
	    $scope.is_company = HasRole('company');
	
	    $scope.subscriptions = subscriptions;
	
	    users.forEach(function (u, ui) {
	        u.subscription_state = 'inactive';
	        u.subscriptions_use = 0;
	
	        subscriptions.forEach(function (s, si) {
	            if (s.user && u.id == s.user.id) {
	                u.subscription_state = 'active';
	                u.subscription_expirated = s.finalize;
	                u.subscriptions_use++;
	            }
	        });
	
	        $scope.users.push(u);
	    });
	
	    $scope.addSubscription = function ($event, user) {
	        var translate = $filter('translate');
	
	        var confirm = $mdDialog.prompt().title(translate('ADD_SUBSCRIPTION_TITLE')).htmlContent(translate('ADD_SUBSCRIPTION_CONTENT')).placeholder(translate('ADD_SUBSCRIPTION_INPUT')).targetEvent($event).ok(translate('ADD_SUBSCRIPTION_BUTTON')).cancel(translate('MODAL_CANCEL'));
	
	        $mdDialog.show(confirm).then(function (total) {
	            progression.start();
	
	            return Restangular.one("subscription/link").one("user", user.id).patch({ _use: total }).then(function (data) {
	                data = data.data ? data.data : data;
	
	                FlashService.Success("ADD_SUBSCRIPTION_SUCCESS");
	
	                user.subscription_state = 'active';
	                user.subscription_expirated = data.date;
	                user.subscriptions_use = data.total;
	
	                progression.done();
	            }, function (error) {
	                error = error.data ? error.data : error;
	
	                if (error.error == 1000) {
	                    var alert = $mdDialog.alert().title(translate('ENOUGH_SUBSCRIPTION_TITLE')).htmlContent(translate('ENOUGH_SUBSCRIPTION')).targetEvent($event).ok(translate('OK'));
	
	                    $mdDialog.show(alert);
	                } else FlashService.Error(error.error_description);
	
	                progression.done();
	            });
	        });
	    };
	
	    $scope.removeSubscription = function ($event, user) {
	        var translate = $filter('translate');
	
	        var confirm = $mdDialog.confirm().title(translate('REMOVE_SUBSCRIPTION_TITLE')).htmlContent(translate('REMOVE_SUBSCRIPTION_CONTENT')).targetEvent($event).ok(translate('REMOVE_SUBSCRIPTION_BUTTON')).cancel(translate('MODAL_CANCEL'));
	
	        $mdDialog.show(confirm).then(function () {
	            progression.start();
	
	            return Restangular.one("subscription/unlink").one("user", user.id).patch().then(function (data) {
	                user.subscription_state = 'inactive';
	                user.subscription_expirated = null;
	                user.subscriptions_use = 0;
	
	                FlashService.Success("REMOVE_SUBSCRIPTION_SUCCESS");
	
	                progression.done();
	            }, function (error) {
	                error = error.data ? error.data : error;
	
	                FlashService.Error(error.error_description);
	
	                progression.done();
	            });
	        });
	    };
	};
	
	;
	module.exports = exports['default'];

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Field2 = __webpack_require__(209);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateField = function (_Field) {
	    _inherits(DateField, _Field);
	
	    function DateField(name) {
	        _classCallCheck(this, DateField);
	
	        var _this = _possibleConstructorReturn(this, (DateField.__proto__ || Object.getPrototypeOf(DateField)).call(this, name));
	
	        _this._format = null;
	        _this._parse = function (date) {
	            if (date instanceof Date) {
	                // the datepicker returns a JS Date object, with hours, minutes and timezone
	                // in order to convert it back to date, we must remove the timezone, then
	                // remove hours and minutes
	                date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
	
	                var dateString = date.toJSON();
	                return dateString ? dateString.substr(0, 10) : null;
	            }
	        };
	        _this._type = "date";
	        return _this;
	    }
	
	    _createClass(DateField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "parse",
	        value: function parse(value) {
	            if (!arguments.length) return this._parse;
	            this._parse = value;
	            return this;
	        }
	    }]);
	
	    return DateField;
	}(_Field3.default);
	
	exports.default = DateField;
	module.exports = exports["default"];

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stringUtils = __webpack_require__(211);
	
	var _stringUtils2 = _interopRequireDefault(_stringUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Field = function () {
	    function Field(name) {
	        _classCallCheck(this, Field);
	
	        this._name = name || Math.random().toString(36).substring(7);
	        this._detailLink = name === 'id';
	        this._type = "string";
	        this._order = null;
	        this._label = null;
	        this._maps = [];
	        this._transforms = [];
	        this._attributes = {};
	        this._cssClasses = null;
	        this._validation = { required: false, minlength: 0, maxlength: 99999 };
	        this._defaultValue = null;
	        this._editable = true;
	        this._detailLinkRoute = 'edit';
	        this._pinned = false;
	        this._flattenable = true;
	        this.dashboard = true;
	        this.list = true;
	        this._template = function () {
	            return '';
	        };
	    }
	
	    _createClass(Field, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _stringUtils2.default.camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "type",
	        value: function type() {
	            return this._type;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "order",
	        value: function order() {
	            if (arguments.length) {
	                if (arguments[1] !== true) {
	                    console.warn('Setting order with Field.order is deprecated, order directly in fields array');
	                }
	                this._order = arguments[0];
	                return this;
	            }
	
	            return this._order;
	        }
	    }, {
	        key: "isDetailLink",
	        value: function isDetailLink(detailLink) {
	            if (arguments.length) {
	                this._detailLink = arguments[0];
	                return this;
	            }
	
	            if (this._detailLink === null) {
	                return this._name === 'id';
	            }
	
	            return this._detailLink;
	        }
	    }, {
	        key: "map",
	
	
	        /**
	         * Add a function to be applied to the response object to turn it into an entry
	         */
	        value: function map(fn) {
	            if (!fn) return this._maps;
	            if (typeof fn !== "function") {
	                var type = typeof fn === "undefined" ? "undefined" : _typeof(fn);
	                throw new Error("Map argument should be a function, " + type + " given.");
	            }
	
	            this._maps.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasMaps",
	        value: function hasMaps() {
	            return !!this._maps.length;
	        }
	    }, {
	        key: "getMappedValue",
	        value: function getMappedValue(value, entry) {
	            for (var i in this._maps) {
	                value = this._maps[i](value, entry);
	            }
	
	            return value;
	        }
	
	        /**
	         * Add a function to be applied to the entry to turn it into a response object
	         */
	
	    }, {
	        key: "transform",
	        value: function transform(fn) {
	            if (!fn) return this._transforms;
	            if (typeof fn !== "function") {
	                var type = typeof fn === "undefined" ? "undefined" : _typeof(fn);
	                throw new Error("transform argument should be a function, " + type + " given.");
	            }
	
	            this._transforms.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasTranforms",
	        value: function hasTranforms() {
	            return !!this._transforms.length;
	        }
	    }, {
	        key: "getTransformedValue",
	        value: function getTransformedValue(value, entry) {
	            for (var i in this._transforms) {
	                value = this._transforms[i](value, entry);
	            }
	
	            return value;
	        }
	    }, {
	        key: "attributes",
	        value: function attributes(_attributes) {
	            if (!arguments.length) {
	                return this._attributes;
	            }
	
	            this._attributes = _attributes;
	
	            return this;
	        }
	    }, {
	        key: "cssClasses",
	        value: function cssClasses(classes) {
	            if (!arguments.length) return this._cssClasses;
	            this._cssClasses = classes;
	            return this;
	        }
	    }, {
	        key: "getCssClasses",
	        value: function getCssClasses(entry) {
	            if (!this._cssClasses) {
	                return '';
	            }
	
	            if (this._cssClasses.constructor === Array) {
	                return this._cssClasses.join(' ');
	            }
	
	            if (typeof this._cssClasses === 'function') {
	                return this._cssClasses(entry);
	            }
	
	            return this._cssClasses;
	        }
	    }, {
	        key: "validation",
	        value: function validation(_validation) {
	            if (!arguments.length) {
	                return this._validation;
	            }
	
	            for (var property in _validation) {
	                if (!_validation.hasOwnProperty(property)) continue;
	                if (_validation[property] === null) {
	                    delete this._validation[property];
	                } else {
	                    this._validation[property] = _validation[property];
	                }
	            }
	
	            return this;
	        }
	    }, {
	        key: "defaultValue",
	        value: function defaultValue(_defaultValue) {
	            if (!arguments.length) return this._defaultValue;
	            this._defaultValue = _defaultValue;
	            return this;
	        }
	    }, {
	        key: "editable",
	        value: function editable(_editable) {
	            if (!arguments.length) return this._editable;
	            this._editable = _editable;
	            return this;
	        }
	    }, {
	        key: "detailLinkRoute",
	        value: function detailLinkRoute(route) {
	            if (!arguments.length) return this._detailLinkRoute;
	            this._detailLinkRoute = route;
	            return this;
	        }
	    }, {
	        key: "pinned",
	        value: function pinned(_pinned) {
	            if (!arguments.length) return this._pinned;
	            this._pinned = _pinned;
	            return this;
	        }
	    }, {
	        key: "flattenable",
	        value: function flattenable() {
	            return this._flattenable;
	        }
	    }, {
	        key: "getTemplateValue",
	        value: function getTemplateValue(data) {
	            if (typeof this._template === 'function') {
	                return this._template(data);
	            }
	
	            return this._template;
	        }
	    }, {
	        key: "template",
	        value: function template(_template) {
	            if (!arguments.length) return this._template;
	            this._template = _template;
	            return this;
	        }
	    }, {
	        key: "detailLink",
	        set: function set(isDetailLink) {
	            return this._detailLink = isDetailLink;
	        }
	    }]);
	
	    return Field;
	}();
	
	exports.default = Field;
	module.exports = exports["default"];

/***/ },
/* 210 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.clone = clone;
	exports.cloneAndFlatten = cloneAndFlatten;
	exports.cloneAndNest = cloneAndNest;
	function isObject(value) {
	    if (value === null) return false;
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') return false;
	    if (Array.isArray(value)) return false;
	    if (Object.prototype.toString.call(value) === '[object Date]') return false;
	    return true;
	}
	
	function clone(object) {
	    return Object.keys(object).reduce(function (values, name) {
	        if (object.hasOwnProperty(name)) {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	/*
	 * Flatten nested object into a single level object with 'foo.bar' property names
	 *
	 * The parameter object is left unchanged. All values in the returned object are scalar.
	 *
	 *     cloneAndFlatten({ a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } }, i: { j: 6 } }, ['i'])
	 *     // { a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5, i: { j: 6 } } }
	 *
	 * @param {Object} object
	 * @param {String[]} excludedProperties
	 * @return {Object}
	 */
	function cloneAndFlatten(object) {
	    var excludedProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        if (isObject(object[name])) {
	            if (excludedProperties.indexOf(name) === -1) {
	                var flatObject = cloneAndFlatten(object[name]);
	                Object.keys(flatObject).forEach(function (flatObjectKey) {
	                    if (!flatObject.hasOwnProperty(flatObjectKey)) return;
	                    values[name + '.' + flatObjectKey] = flatObject[flatObjectKey];
	                });
	            } else {
	                values[name] = clone(object[name]);
	            }
	        } else {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	};
	
	/*
	 * Clone flattened object into a nested object
	 *
	 * The parameter object is left unchanged.
	 *
	 *     cloneAndNest({ a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5 } )
	 *     // { a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } } }
	 *
	 * @param {Object} object
	 * @return {Object}
	 */
	function cloneAndNest(object) {
	    if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        name.split('.').reduce(function (previous, current, index, list) {
	            if (typeof previous[current] === 'undefined') previous[current] = {};
	            if (index < list.length - 1) {
	                return previous[current];
	            };
	            previous[current] = object[name];
	        }, values);
	        return values;
	    }, {});
	}

/***/ },
/* 211 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    /**
	     * @see http://stackoverflow.com/questions/10425287/convert-string-to-camelcase-with-regular-expression
	     * @see http://phpjs.org/functions/ucfirst/
	     */
	    camelCase: function camelCase(text) {
	        if (!text) {
	            return text;
	        }
	
	        var f = text.charAt(0).toUpperCase();
	        text = f + text.substr(1);
	
	        return text.replace(/[-_.\s](.)/g, function (match, group1) {
	            return ' ' + group1.toUpperCase();
	        });
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function (window, angular) {
	  'use strict';
	
	  var ELEMENT_NODE = 1;
	  var COMMENT_NODE = 8;
	
	  var ADD_CLASS_SUFFIX = '-add';
	  var REMOVE_CLASS_SUFFIX = '-remove';
	  var EVENT_CLASS_PREFIX = 'ng-';
	  var ACTIVE_CLASS_SUFFIX = '-active';
	  var PREPARE_CLASS_SUFFIX = '-prepare';
	
	  var NG_ANIMATE_CLASSNAME = 'ng-animate';
	  var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	  // Detect proper transitionend/animationend event names.
	  var CSS_PREFIX = '',
	      TRANSITION_PROP,
	      TRANSITIONEND_EVENT,
	      ANIMATION_PROP,
	      ANIMATIONEND_EVENT;
	
	  // If unprefixed events are not supported but webkit-prefixed are, use the latter.
	  // Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	  // Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	  // but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	  // Register both events in case `window.onanimationend` is not supported because of that,
	  // do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	  // Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	  // therefore there is no reason to test anymore for other vendor prefixes:
	  // http://caniuse.com/#search=transition
	  if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
	    CSS_PREFIX = '-webkit-';
	    TRANSITION_PROP = 'WebkitTransition';
	    TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	  } else {
	    TRANSITION_PROP = 'transition';
	    TRANSITIONEND_EVENT = 'transitionend';
	  }
	
	  if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
	    CSS_PREFIX = '-webkit-';
	    ANIMATION_PROP = 'WebkitAnimation';
	    ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	  } else {
	    ANIMATION_PROP = 'animation';
	    ANIMATIONEND_EVENT = 'animationend';
	  }
	
	  var DURATION_KEY = 'Duration';
	  var PROPERTY_KEY = 'Property';
	  var DELAY_KEY = 'Delay';
	  var TIMING_KEY = 'TimingFunction';
	  var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	  var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	  var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	  var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	  var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	  var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	  var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	  var ngMinErr = angular.$$minErr('ng');
	  function assertArg(arg, name, reason) {
	    if (!arg) {
	      throw ngMinErr('areq', 'Argument \'{0}\' is {1}', name || '?', reason || 'required');
	    }
	    return arg;
	  }
	
	  function mergeClasses(a, b) {
	    if (!a && !b) return '';
	    if (!a) return b;
	    if (!b) return a;
	    if (isArray(a)) a = a.join(' ');
	    if (isArray(b)) b = b.join(' ');
	    return a + ' ' + b;
	  }
	
	  function packageStyles(options) {
	    var styles = {};
	    if (options && (options.to || options.from)) {
	      styles.to = options.to;
	      styles.from = options.from;
	    }
	    return styles;
	  }
	
	  function pendClasses(classes, fix, isPrefix) {
	    var className = '';
	    classes = isArray(classes) ? classes : classes && isString(classes) && classes.length ? classes.split(/\s+/) : [];
	    forEach(classes, function (klass, i) {
	      if (klass && klass.length > 0) {
	        className += i > 0 ? ' ' : '';
	        className += isPrefix ? fix + klass : klass + fix;
	      }
	    });
	    return className;
	  }
	
	  function removeFromArray(arr, val) {
	    var index = arr.indexOf(val);
	    if (val >= 0) {
	      arr.splice(index, 1);
	    }
	  }
	
	  function stripCommentsFromElement(element) {
	    if (element instanceof jqLite) {
	      switch (element.length) {
	        case 0:
	          return element;
	
	        case 1:
	          // there is no point of stripping anything if the element
	          // is the only element within the jqLite wrapper.
	          // (it's important that we retain the element instance.)
	          if (element[0].nodeType === ELEMENT_NODE) {
	            return element;
	          }
	          break;
	
	        default:
	          return jqLite(extractElementNode(element));
	      }
	    }
	
	    if (element.nodeType === ELEMENT_NODE) {
	      return jqLite(element);
	    }
	  }
	
	  function extractElementNode(element) {
	    if (!element[0]) return element;
	    for (var i = 0; i < element.length; i++) {
	      var elm = element[i];
	      if (elm.nodeType === ELEMENT_NODE) {
	        return elm;
	      }
	    }
	  }
	
	  function $$addClass($$jqLite, element, className) {
	    forEach(element, function (elm) {
	      $$jqLite.addClass(elm, className);
	    });
	  }
	
	  function $$removeClass($$jqLite, element, className) {
	    forEach(element, function (elm) {
	      $$jqLite.removeClass(elm, className);
	    });
	  }
	
	  function applyAnimationClassesFactory($$jqLite) {
	    return function (element, options) {
	      if (options.addClass) {
	        $$addClass($$jqLite, element, options.addClass);
	        options.addClass = null;
	      }
	      if (options.removeClass) {
	        $$removeClass($$jqLite, element, options.removeClass);
	        options.removeClass = null;
	      }
	    };
	  }
	
	  function prepareAnimationOptions(options) {
	    options = options || {};
	    if (!options.$$prepared) {
	      var domOperation = options.domOperation || noop;
	      options.domOperation = function () {
	        options.$$domOperationFired = true;
	        domOperation();
	        domOperation = noop;
	      };
	      options.$$prepared = true;
	    }
	    return options;
	  }
	
	  function applyAnimationStyles(element, options) {
	    applyAnimationFromStyles(element, options);
	    applyAnimationToStyles(element, options);
	  }
	
	  function applyAnimationFromStyles(element, options) {
	    if (options.from) {
	      element.css(options.from);
	      options.from = null;
	    }
	  }
	
	  function applyAnimationToStyles(element, options) {
	    if (options.to) {
	      element.css(options.to);
	      options.to = null;
	    }
	  }
	
	  function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	    var target = oldAnimation.options || {};
	    var newOptions = newAnimation.options || {};
	
	    var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	    var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	    var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	    if (newOptions.preparationClasses) {
	      target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	      delete newOptions.preparationClasses;
	    }
	
	    // noop is basically when there is no callback; otherwise something has been set
	    var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	    extend(target, newOptions);
	
	    // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	    if (realDomOperation) {
	      target.domOperation = realDomOperation;
	    }
	
	    if (classes.addClass) {
	      target.addClass = classes.addClass;
	    } else {
	      target.addClass = null;
	    }
	
	    if (classes.removeClass) {
	      target.removeClass = classes.removeClass;
	    } else {
	      target.removeClass = null;
	    }
	
	    oldAnimation.addClass = target.addClass;
	    oldAnimation.removeClass = target.removeClass;
	
	    return target;
	  }
	
	  function resolveElementClasses(existing, toAdd, toRemove) {
	    var ADD_CLASS = 1;
	    var REMOVE_CLASS = -1;
	
	    var flags = {};
	    existing = splitClassesToLookup(existing);
	
	    toAdd = splitClassesToLookup(toAdd);
	    forEach(toAdd, function (value, key) {
	      flags[key] = ADD_CLASS;
	    });
	
	    toRemove = splitClassesToLookup(toRemove);
	    forEach(toRemove, function (value, key) {
	      flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	    });
	
	    var classes = {
	      addClass: '',
	      removeClass: ''
	    };
	
	    forEach(flags, function (val, klass) {
	      var prop, allow;
	      if (val === ADD_CLASS) {
	        prop = 'addClass';
	        allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	      } else if (val === REMOVE_CLASS) {
	        prop = 'removeClass';
	        allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	      }
	      if (allow) {
	        if (classes[prop].length) {
	          classes[prop] += ' ';
	        }
	        classes[prop] += klass;
	      }
	    });
	
	    function splitClassesToLookup(classes) {
	      if (isString(classes)) {
	        classes = classes.split(' ');
	      }
	
	      var obj = {};
	      forEach(classes, function (klass) {
	        // sometimes the split leaves empty string values
	        // incase extra spaces were applied to the options
	        if (klass.length) {
	          obj[klass] = true;
	        }
	      });
	      return obj;
	    }
	
	    return classes;
	  }
	
	  function getDomNode(element) {
	    return element instanceof jqLite ? element[0] : element;
	  }
	
	  function applyGeneratedPreparationClasses(element, event, options) {
	    var classes = '';
	    if (event) {
	      classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	    }
	    if (options.addClass) {
	      classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	    }
	    if (options.removeClass) {
	      classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	    }
	    if (classes.length) {
	      options.preparationClasses = classes;
	      element.addClass(classes);
	    }
	  }
	
	  function clearGeneratedClasses(element, options) {
	    if (options.preparationClasses) {
	      element.removeClass(options.preparationClasses);
	      options.preparationClasses = null;
	    }
	    if (options.activeClasses) {
	      element.removeClass(options.activeClasses);
	      options.activeClasses = null;
	    }
	  }
	
	  function blockTransitions(node, duration) {
	    // we use a negative delay value since it performs blocking
	    // yet it doesn't kill any existing transitions running on the
	    // same element which makes this safe for class-based animations
	    var value = duration ? '-' + duration + 's' : '';
	    applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	    return [TRANSITION_DELAY_PROP, value];
	  }
	
	  function blockKeyframeAnimations(node, applyBlock) {
	    var value = applyBlock ? 'paused' : '';
	    var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	    applyInlineStyle(node, [key, value]);
	    return [key, value];
	  }
	
	  function applyInlineStyle(node, styleTuple) {
	    var prop = styleTuple[0];
	    var value = styleTuple[1];
	    node.style[prop] = value;
	  }
	
	  function concatWithSpace(a, b) {
	    if (!a) return b;
	    if (!b) return a;
	    return a + ' ' + b;
	  }
	
	  var $$rAFSchedulerFactory = ['$$rAF', function ($$rAF) {
	    var queue, cancelFn;
	
	    function scheduler(tasks) {
	      // we make a copy since RAFScheduler mutates the state
	      // of the passed in array variable and this would be difficult
	      // to track down on the outside code
	      queue = queue.concat(tasks);
	      nextTick();
	    }
	
	    queue = scheduler.queue = [];
	
	    /* waitUntilQuiet does two things:
	     * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	     * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	     *
	     * The motivation here is that animation code can request more time from the scheduler
	     * before the next wave runs. This allows for certain DOM properties such as classes to
	     * be resolved in time for the next animation to run.
	     */
	    scheduler.waitUntilQuiet = function (fn) {
	      if (cancelFn) cancelFn();
	
	      cancelFn = $$rAF(function () {
	        cancelFn = null;
	        fn();
	        nextTick();
	      });
	    };
	
	    return scheduler;
	
	    function nextTick() {
	      if (!queue.length) return;
	
	      var items = queue.shift();
	      for (var i = 0; i < items.length; i++) {
	        items[i]();
	      }
	
	      if (!cancelFn) {
	        $$rAF(function () {
	          if (!cancelFn) nextTick();
	        });
	      }
	    }
	  }];
	
	  /**
	   * @ngdoc directive
	   * @name ngAnimateChildren
	   * @restrict AE
	   * @element ANY
	   *
	   * @description
	   *
	   * ngAnimateChildren allows you to specify that children of this element should animate even if any
	   * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	   * (structural) animation, child elements that also have an active structural animation are not animated.
	   *
	   * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	   *
	   *
	   * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	   *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	   *
	   * @example
	   * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	       <file name="index.html">
	         <div ng-controller="MainController as main">
	           <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	           <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	           <hr>
	           <div ng-animate-children="{{main.animateChildren}}">
	             <div ng-if="main.enterElement" class="container">
	               List of items:
	               <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	             </div>
	           </div>
	         </div>
	       </file>
	       <file name="animations.css">
	  
	        .container.ng-enter,
	        .container.ng-leave {
	          transition: all ease 1.5s;
	        }
	  
	        .container.ng-enter,
	        .container.ng-leave-active {
	          opacity: 0;
	        }
	  
	        .container.ng-leave,
	        .container.ng-enter-active {
	          opacity: 1;
	        }
	  
	        .item {
	          background: firebrick;
	          color: #FFF;
	          margin-bottom: 10px;
	        }
	  
	        .item.ng-enter,
	        .item.ng-leave {
	          transition: transform 1.5s ease;
	        }
	  
	        .item.ng-enter {
	          transform: translateX(50px);
	        }
	  
	        .item.ng-enter-active {
	          transform: translateX(0);
	        }
	      </file>
	      <file name="script.js">
	        angular.module('ngAnimateChildren', ['ngAnimate'])
	          .controller('MainController', function MainController() {
	            this.animateChildren = false;
	            this.enterElement = false;
	          });
	      </file>
	    </example>
	   */
	  var $$AnimateChildrenDirective = ['$interpolate', function ($interpolate) {
	    return {
	      link: function link(scope, element, attrs) {
	        var val = attrs.ngAnimateChildren;
	        if (isString(val) && val.length === 0) {
	          //empty attribute
	          element.data(NG_ANIMATE_CHILDREN_DATA, true);
	        } else {
	          // Interpolate and set the value, so that it is available to
	          // animations that run right after compilation
	          setData($interpolate(val)(scope));
	          attrs.$observe('ngAnimateChildren', setData);
	        }
	
	        function setData(value) {
	          value = value === 'on' || value === 'true';
	          element.data(NG_ANIMATE_CHILDREN_DATA, value);
	        }
	      }
	    };
	  }];
	
	  /* exported $AnimateCssProvider */
	
	  var ANIMATE_TIMER_KEY = '$$animateCss';
	
	  /**
	   * @ngdoc service
	   * @name $animateCss
	   * @kind object
	   *
	   * @description
	   * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	   * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	   * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	   * directives to create more complex animations that can be purely driven using CSS code.
	   *
	   * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	   * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	   *
	   * ## General Use
	   * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	   * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	   * any automatic control over cancelling animations and/or preventing animations from being run on
	   * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
	   * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	   * the CSS animation.
	   *
	   * The example below shows how we can create a folding animation on an element using `ng-if`:
	   *
	   * ```html
	   * <!-- notice the `fold-animation` CSS class -->
	   * <div ng-if="onOff" class="fold-animation">
	   *   This element will go BOOM
	   * </div>
	   * <button ng-click="onOff=true">Fold In</button>
	   * ```
	   *
	   * Now we create the **JavaScript animation** that will trigger the CSS transition:
	   *
	   * ```js
	   * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	   *   return {
	   *     enter: function(element, doneFn) {
	   *       var height = element[0].offsetHeight;
	   *       return $animateCss(element, {
	   *         from: { height:'0px' },
	   *         to: { height:height + 'px' },
	   *         duration: 1 // one second
	   *       });
	   *     }
	   *   }
	   * }]);
	   * ```
	   *
	   * ## More Advanced Uses
	   *
	   * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	   * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	   *
	   * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	   * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	   * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	   * to provide a working animation that will run in CSS.
	   *
	   * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	   *
	   * ```js
	   * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	   *   return {
	   *     enter: function(element, doneFn) {
	   *       var height = element[0].offsetHeight;
	   *       return $animateCss(element, {
	   *         addClass: 'red large-text pulse-twice',
	   *         easing: 'ease-out',
	   *         from: { height:'0px' },
	   *         to: { height:height + 'px' },
	   *         duration: 1 // one second
	   *       });
	   *     }
	   *   }
	   * }]);
	   * ```
	   *
	   * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	   *
	   * ```css
	   * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	   * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	   * .red { background:red; }
	   * .large-text { font-size:20px; }
	   *
	   * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	   * .pulse-twice {
	   *   animation: 0.5s pulse linear 2;
	   *   -webkit-animation: 0.5s pulse linear 2;
	   * }
	   *
	   * @keyframes pulse {
	   *   from { transform: scale(0.5); }
	   *   to { transform: scale(1.5); }
	   * }
	   *
	   * @-webkit-keyframes pulse {
	   *   from { -webkit-transform: scale(0.5); }
	   *   to { -webkit-transform: scale(1.5); }
	   * }
	   * ```
	   *
	   * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	   *
	   * ## How the Options are handled
	   *
	   * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	   * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	   * styles using the `from` and `to` properties.
	   *
	   * ```js
	   * var animator = $animateCss(element, {
	   *   from: { background:'red' },
	   *   to: { background:'blue' }
	   * });
	   * animator.start();
	   * ```
	   *
	   * ```css
	   * .rotating-animation {
	   *   animation:0.5s rotate linear;
	   *   -webkit-animation:0.5s rotate linear;
	   * }
	   *
	   * @keyframes rotate {
	   *   from { transform: rotate(0deg); }
	   *   to { transform: rotate(360deg); }
	   * }
	   *
	   * @-webkit-keyframes rotate {
	   *   from { -webkit-transform: rotate(0deg); }
	   *   to { -webkit-transform: rotate(360deg); }
	   * }
	   * ```
	   *
	   * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	   * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	   * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	   * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	   * and spread across the transition and keyframe animation.
	   *
	   * ## What is returned
	   *
	   * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	   * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	   * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	   *
	   * ```js
	   * var animator = $animateCss(element, { ... });
	   * ```
	   *
	   * Now what do the contents of our `animator` variable look like:
	   *
	   * ```js
	   * {
	   *   // starts the animation
	   *   start: Function,
	   *
	   *   // ends (aborts) the animation
	   *   end: Function
	   * }
	   * ```
	   *
	   * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	   * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	   * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	   * and that changing them will not reconfigure the parameters of the animation.
	   *
	   * ### runner.done() vs runner.then()
	   * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	   * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	   * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	   * unless you really need a digest to kick off afterwards.
	   *
	   * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	   * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	   * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	   *
	   * @param {DOMElement} element the element that will be animated
	   * @param {object} options the animation-related options that will be applied during the animation
	   *
	   * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	   * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	   * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	   * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	   * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	   * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	   * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	   * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	   * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	   * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	   * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	   * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	   * is provided then the animation will be skipped entirely.
	   * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	   * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	   * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	   * CSS delay value.
	   * * `stagger` - A numeric time value representing the delay between successively animated elements
	   * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	   * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	   *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	   * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	   * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	   *    the animation is closed. This is useful for when the styles are used purely for the sake of
	   *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	   *    By default this value is set to `false`.
	   *
	   * @return {object} an object with start and end methods and details about the animation.
	   *
	   * * `start` - The method to start the animation. This will return a `Promise` when called.
	   * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	   */
	  var ONE_SECOND = 1000;
	
	  var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	  var CLOSING_TIME_BUFFER = 1.5;
	
	  var DETECT_CSS_PROPERTIES = {
	    transitionDuration: TRANSITION_DURATION_PROP,
	    transitionDelay: TRANSITION_DELAY_PROP,
	    transitionProperty: TRANSITION_PROP + PROPERTY_KEY,
	    animationDuration: ANIMATION_DURATION_PROP,
	    animationDelay: ANIMATION_DELAY_PROP,
	    animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	  };
	
	  var DETECT_STAGGER_CSS_PROPERTIES = {
	    transitionDuration: TRANSITION_DURATION_PROP,
	    transitionDelay: TRANSITION_DELAY_PROP,
	    animationDuration: ANIMATION_DURATION_PROP,
	    animationDelay: ANIMATION_DELAY_PROP
	  };
	
	  function getCssKeyframeDurationStyle(duration) {
	    return [ANIMATION_DURATION_PROP, duration + 's'];
	  }
	
	  function getCssDelayStyle(delay, isKeyframeAnimation) {
	    var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	    return [prop, delay + 's'];
	  }
	
	  function computeCssStyles($window, element, properties) {
	    var styles = Object.create(null);
	    var detectedStyles = $window.getComputedStyle(element) || {};
	    forEach(properties, function (formalStyleName, actualStyleName) {
	      var val = detectedStyles[formalStyleName];
	      if (val) {
	        var c = val.charAt(0);
	
	        // only numerical-based values have a negative sign or digit as the first value
	        if (c === '-' || c === '+' || c >= 0) {
	          val = parseMaxTime(val);
	        }
	
	        // by setting this to null in the event that the delay is not set or is set directly as 0
	        // then we can still allow for negative values to be used later on and not mistake this
	        // value for being greater than any other negative value.
	        if (val === 0) {
	          val = null;
	        }
	        styles[actualStyleName] = val;
	      }
	    });
	
	    return styles;
	  }
	
	  function parseMaxTime(str) {
	    var maxValue = 0;
	    var values = str.split(/\s*,\s*/);
	    forEach(values, function (value) {
	      // it's always safe to consider only second values and omit `ms` values since
	      // getComputedStyle will always handle the conversion for us
	      if (value.charAt(value.length - 1) === 's') {
	        value = value.substring(0, value.length - 1);
	      }
	      value = parseFloat(value) || 0;
	      maxValue = maxValue ? Math.max(value, maxValue) : value;
	    });
	    return maxValue;
	  }
	
	  function truthyTimingValue(val) {
	    return val === 0 || val != null;
	  }
	
	  function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	    var style = TRANSITION_PROP;
	    var value = duration + 's';
	    if (applyOnlyDuration) {
	      style += DURATION_KEY;
	    } else {
	      value += ' linear all';
	    }
	    return [style, value];
	  }
	
	  function createLocalCacheLookup() {
	    var cache = Object.create(null);
	    return {
	      flush: function flush() {
	        cache = Object.create(null);
	      },
	
	      count: function count(key) {
	        var entry = cache[key];
	        return entry ? entry.total : 0;
	      },
	
	      get: function get(key) {
	        var entry = cache[key];
	        return entry && entry.value;
	      },
	
	      put: function put(key, value) {
	        if (!cache[key]) {
	          cache[key] = { total: 1, value: value };
	        } else {
	          cache[key].total++;
	        }
	      }
	    };
	  }
	
	  // we do not reassign an already present style value since
	  // if we detect the style property value again we may be
	  // detecting styles that were added via the `from` styles.
	  // We make use of `isDefined` here since an empty string
	  // or null value (which is what getPropertyValue will return
	  // for a non-existing style) will still be marked as a valid
	  // value for the style (a falsy value implies that the style
	  // is to be removed at the end of the animation). If we had a simple
	  // "OR" statement then it would not be enough to catch that.
	  function registerRestorableStyles(backup, node, properties) {
	    forEach(properties, function (prop) {
	      backup[prop] = isDefined(backup[prop]) ? backup[prop] : node.style.getPropertyValue(prop);
	    });
	  }
	
	  var $AnimateCssProvider = ['$animateProvider', /** @this */function ($animateProvider) {
	    var gcsLookup = createLocalCacheLookup();
	    var gcsStaggerLookup = createLocalCacheLookup();
	
	    this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout', '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue', function ($window, $$jqLite, $$AnimateRunner, $timeout, $$forceReflow, $sniffer, $$rAFScheduler, $$animateQueue) {
	
	      var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	      var parentCounter = 0;
	      function gcsHashFn(node, extraClasses) {
	        var KEY = '$$ngAnimateParentKey';
	        var parentNode = node.parentNode;
	        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	        return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
	      }
	
	      function computeCachedCssStyles(node, className, cacheKey, properties) {
	        var timings = gcsLookup.get(cacheKey);
	
	        if (!timings) {
	          timings = computeCssStyles($window, node, properties);
	          if (timings.animationIterationCount === 'infinite') {
	            timings.animationIterationCount = 1;
	          }
	        }
	
	        // we keep putting this in multiple times even though the value and the cacheKey are the same
	        // because we're keeping an internal tally of how many duplicate animations are detected.
	        gcsLookup.put(cacheKey, timings);
	        return timings;
	      }
	
	      function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	        var stagger;
	
	        // if we have one or more existing matches of matching elements
	        // containing the same parent + CSS styles (which is how cacheKey works)
	        // then staggering is possible
	        if (gcsLookup.count(cacheKey) > 0) {
	          stagger = gcsStaggerLookup.get(cacheKey);
	
	          if (!stagger) {
	            var staggerClassName = pendClasses(className, '-stagger');
	
	            $$jqLite.addClass(node, staggerClassName);
	
	            stagger = computeCssStyles($window, node, properties);
	
	            // force the conversion of a null value to zero incase not set
	            stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	            stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	            $$jqLite.removeClass(node, staggerClassName);
	
	            gcsStaggerLookup.put(cacheKey, stagger);
	          }
	        }
	
	        return stagger || {};
	      }
	
	      var rafWaitQueue = [];
	      function waitUntilQuiet(callback) {
	        rafWaitQueue.push(callback);
	        $$rAFScheduler.waitUntilQuiet(function () {
	          gcsLookup.flush();
	          gcsStaggerLookup.flush();
	
	          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	          var pageWidth = $$forceReflow();
	
	          // we use a for loop to ensure that if the queue is changed
	          // during this looping then it will consider new requests
	          for (var i = 0; i < rafWaitQueue.length; i++) {
	            rafWaitQueue[i](pageWidth);
	          }
	          rafWaitQueue.length = 0;
	        });
	      }
	
	      function computeTimings(node, className, cacheKey) {
	        var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
	        var aD = timings.animationDelay;
	        var tD = timings.transitionDelay;
	        timings.maxDelay = aD && tD ? Math.max(aD, tD) : aD || tD;
	        timings.maxDuration = Math.max(timings.animationDuration * timings.animationIterationCount, timings.transitionDuration);
	
	        return timings;
	      }
	
	      return function init(element, initialOptions) {
	        // all of the animation functions should create
	        // a copy of the options data, however, if a
	        // parent service has already created a copy then
	        // we should stick to using that
	        var options = initialOptions || {};
	        if (!options.$$prepared) {
	          options = prepareAnimationOptions(copy(options));
	        }
	
	        var restoreStyles = {};
	        var node = getDomNode(element);
	        if (!node || !node.parentNode || !$$animateQueue.enabled()) {
	          return closeAndReturnNoopAnimator();
	        }
	
	        var temporaryStyles = [];
	        var classes = element.attr('class');
	        var styles = packageStyles(options);
	        var animationClosed;
	        var animationPaused;
	        var animationCompleted;
	        var runner;
	        var runnerHost;
	        var maxDelay;
	        var maxDelayTime;
	        var maxDuration;
	        var maxDurationTime;
	        var startTime;
	        var events = [];
	
	        if (options.duration === 0 || !$sniffer.animations && !$sniffer.transitions) {
	          return closeAndReturnNoopAnimator();
	        }
	
	        var method = options.event && isArray(options.event) ? options.event.join(' ') : options.event;
	
	        var isStructural = method && options.structural;
	        var structuralClassName = '';
	        var addRemoveClassName = '';
	
	        if (isStructural) {
	          structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	        } else if (method) {
	          structuralClassName = method;
	        }
	
	        if (options.addClass) {
	          addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	        }
	
	        if (options.removeClass) {
	          if (addRemoveClassName.length) {
	            addRemoveClassName += ' ';
	          }
	          addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	        }
	
	        // there may be a situation where a structural animation is combined together
	        // with CSS classes that need to resolve before the animation is computed.
	        // However this means that there is no explicit CSS code to block the animation
	        // from happening (by setting 0s none in the class name). If this is the case
	        // we need to apply the classes before the first rAF so we know to continue if
	        // there actually is a detected transition or keyframe animation
	        if (options.applyClassesEarly && addRemoveClassName.length) {
	          applyAnimationClasses(element, options);
	        }
	
	        var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	        var fullClassName = classes + ' ' + preparationClasses;
	        var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	        var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	        var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	        // there is no way we can trigger an animation if no styles and
	        // no classes are being applied which would then trigger a transition,
	        // unless there a is raw keyframe value that is applied to the element.
	        if (!containsKeyframeAnimation && !hasToStyles && !preparationClasses) {
	          return closeAndReturnNoopAnimator();
	        }
	
	        var cacheKey, stagger;
	        if (options.stagger > 0) {
	          var staggerVal = parseFloat(options.stagger);
	          stagger = {
	            transitionDelay: staggerVal,
	            animationDelay: staggerVal,
	            transitionDuration: 0,
	            animationDuration: 0
	          };
	        } else {
	          cacheKey = gcsHashFn(node, fullClassName);
	          stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	        }
	
	        if (!options.$$skipPreparationClasses) {
	          $$jqLite.addClass(element, preparationClasses);
	        }
	
	        var applyOnlyDuration;
	
	        if (options.transitionStyle) {
	          var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	          applyInlineStyle(node, transitionStyle);
	          temporaryStyles.push(transitionStyle);
	        }
	
	        if (options.duration >= 0) {
	          applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	          var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	          // we set the duration so that it will be picked up by getComputedStyle later
	          applyInlineStyle(node, durationStyle);
	          temporaryStyles.push(durationStyle);
	        }
	
	        if (options.keyframeStyle) {
	          var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	          applyInlineStyle(node, keyframeStyle);
	          temporaryStyles.push(keyframeStyle);
	        }
	
	        var itemIndex = stagger ? options.staggerIndex >= 0 ? options.staggerIndex : gcsLookup.count(cacheKey) : 0;
	
	        var isFirst = itemIndex === 0;
	
	        // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	        // without causing any combination of transitions to kick in. By adding a negative delay value
	        // it forces the setup class' transition to end immediately. We later then remove the negative
	        // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	        // that if there is no transition defined then nothing will happen and this will also allow
	        // other transitions to be stacked on top of each other without any chopping them out.
	        if (isFirst && !options.skipBlocking) {
	          blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	        }
	
	        var timings = computeTimings(node, fullClassName, cacheKey);
	        var relativeDelay = timings.maxDelay;
	        maxDelay = Math.max(relativeDelay, 0);
	        maxDuration = timings.maxDuration;
	
	        var flags = {};
	        flags.hasTransitions = timings.transitionDuration > 0;
	        flags.hasAnimations = timings.animationDuration > 0;
	        flags.hasTransitionAll = flags.hasTransitions && timings.transitionProperty === 'all';
	        flags.applyTransitionDuration = hasToStyles && (flags.hasTransitions && !flags.hasTransitionAll || flags.hasAnimations && !flags.hasTransitions);
	        flags.applyAnimationDuration = options.duration && flags.hasAnimations;
	        flags.applyTransitionDelay = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	        flags.applyAnimationDelay = truthyTimingValue(options.delay) && flags.hasAnimations;
	        flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	        if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	          maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	          if (flags.applyTransitionDuration) {
	            flags.hasTransitions = true;
	            timings.transitionDuration = maxDuration;
	            applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	            temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	          }
	
	          if (flags.applyAnimationDuration) {
	            flags.hasAnimations = true;
	            timings.animationDuration = maxDuration;
	            temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	          }
	        }
	
	        if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	          return closeAndReturnNoopAnimator();
	        }
	
	        if (options.delay != null) {
	          var delayStyle;
	          if (typeof options.delay !== 'boolean') {
	            delayStyle = parseFloat(options.delay);
	            // number in options.delay means we have to recalculate the delay for the closing timeout
	            maxDelay = Math.max(delayStyle, 0);
	          }
	
	          if (flags.applyTransitionDelay) {
	            temporaryStyles.push(getCssDelayStyle(delayStyle));
	          }
	
	          if (flags.applyAnimationDelay) {
	            temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	          }
	        }
	
	        // we need to recalculate the delay value since we used a pre-emptive negative
	        // delay value and the delay value is required for the final event checking. This
	        // property will ensure that this will happen after the RAF phase has passed.
	        if (options.duration == null && timings.transitionDuration > 0) {
	          flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	        }
	
	        maxDelayTime = maxDelay * ONE_SECOND;
	        maxDurationTime = maxDuration * ONE_SECOND;
	        if (!options.skipBlocking) {
	          flags.blockTransition = timings.transitionDuration > 0;
	          flags.blockKeyframeAnimation = timings.animationDuration > 0 && stagger.animationDelay > 0 && stagger.animationDuration === 0;
	        }
	
	        if (options.from) {
	          if (options.cleanupStyles) {
	            registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	          }
	          applyAnimationFromStyles(element, options);
	        }
	
	        if (flags.blockTransition || flags.blockKeyframeAnimation) {
	          applyBlocking(maxDuration);
	        } else if (!options.skipBlocking) {
	          blockTransitions(node, false);
	        }
	
	        // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	        return {
	          $$willAnimate: true,
	          end: endFn,
	          start: function start() {
	            if (animationClosed) return;
	
	            runnerHost = {
	              end: endFn,
	              cancel: cancelFn,
	              resume: null, //this will be set during the start() phase
	              pause: null
	            };
	
	            runner = new $$AnimateRunner(runnerHost);
	
	            waitUntilQuiet(_start);
	
	            // we don't have access to pause/resume the animation
	            // since it hasn't run yet. AnimateRunner will therefore
	            // set noop functions for resume and pause and they will
	            // later be overridden once the animation is triggered
	            return runner;
	          }
	        };
	
	        function endFn() {
	          close();
	        }
	
	        function cancelFn() {
	          close(true);
	        }
	
	        function close(rejected) {
	          // if the promise has been called already then we shouldn't close
	          // the animation again
	          if (animationClosed || animationCompleted && animationPaused) return;
	          animationClosed = true;
	          animationPaused = false;
	
	          if (!options.$$skipPreparationClasses) {
	            $$jqLite.removeClass(element, preparationClasses);
	          }
	          $$jqLite.removeClass(element, activeClasses);
	
	          blockKeyframeAnimations(node, false);
	          blockTransitions(node, false);
	
	          forEach(temporaryStyles, function (entry) {
	            // There is only one way to remove inline style properties entirely from elements.
	            // By using `removeProperty` this works, but we need to convert camel-cased CSS
	            // styles down to hyphenated values.
	            node.style[entry[0]] = '';
	          });
	
	          applyAnimationClasses(element, options);
	          applyAnimationStyles(element, options);
	
	          if (Object.keys(restoreStyles).length) {
	            forEach(restoreStyles, function (value, prop) {
	              if (value) {
	                node.style.setProperty(prop, value);
	              } else {
	                node.style.removeProperty(prop);
	              }
	            });
	          }
	
	          // the reason why we have this option is to allow a synchronous closing callback
	          // that is fired as SOON as the animation ends (when the CSS is removed) or if
	          // the animation never takes off at all. A good example is a leave animation since
	          // the element must be removed just after the animation is over or else the element
	          // will appear on screen for one animation frame causing an overbearing flicker.
	          if (options.onDone) {
	            options.onDone();
	          }
	
	          if (events && events.length) {
	            // Remove the transitionend / animationend listener(s)
	            element.off(events.join(' '), onAnimationProgress);
	          }
	
	          //Cancel the fallback closing timeout and remove the timer data
	          var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	          if (animationTimerData) {
	            $timeout.cancel(animationTimerData[0].timer);
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	
	          // if the preparation function fails then the promise is not setup
	          if (runner) {
	            runner.complete(!rejected);
	          }
	        }
	
	        function applyBlocking(duration) {
	          if (flags.blockTransition) {
	            blockTransitions(node, duration);
	          }
	
	          if (flags.blockKeyframeAnimation) {
	            blockKeyframeAnimations(node, !!duration);
	          }
	        }
	
	        function closeAndReturnNoopAnimator() {
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: cancelFn
	          });
	
	          // should flush the cache animation
	          waitUntilQuiet(noop);
	          close();
	
	          return {
	            $$willAnimate: false,
	            start: function start() {
	              return runner;
	            },
	            end: endFn
	          };
	        }
	
	        function onAnimationProgress(event) {
	          event.stopPropagation();
	          var ev = event.originalEvent || event;
	
	          if (ev.target !== node) {
	            // Since TransitionEvent / AnimationEvent bubble up,
	            // we have to ignore events by finished child animations
	            return;
	          }
	
	          // we now always use `Date.now()` due to the recent changes with
	          // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	          var timeStamp = ev.$manualTimeStamp || Date.now();
	
	          /* Firefox (or possibly just Gecko) likes to not round values up
	           * when a ms measurement is used for the animation */
	          var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	          /* $manualTimeStamp is a mocked timeStamp value which is set
	           * within browserTrigger(). This is only here so that tests can
	           * mock animations properly. Real events fallback to event.timeStamp,
	           * or, if they don't, then a timeStamp is automatically created for them.
	           * We're checking to see if the timeStamp surpasses the expected delay,
	           * but we're using elapsedTime instead of the timeStamp on the 2nd
	           * pre-condition since animationPauseds sometimes close off early */
	          if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	            // we set this flag to ensure that if the transition is paused then, when resumed,
	            // the animation will automatically close itself since transitions cannot be paused.
	            animationCompleted = true;
	            close();
	          }
	        }
	
	        function _start() {
	          if (animationClosed) return;
	          if (!node.parentNode) {
	            close();
	            return;
	          }
	
	          // even though we only pause keyframe animations here the pause flag
	          // will still happen when transitions are used. Only the transition will
	          // not be paused since that is not possible. If the animation ends when
	          // paused then it will not complete until unpaused or cancelled.
	          var playPause = function playPause(playAnimation) {
	            if (!animationCompleted) {
	              animationPaused = !playAnimation;
	              if (timings.animationDuration) {
	                var value = blockKeyframeAnimations(node, animationPaused);
	                if (animationPaused) {
	                  temporaryStyles.push(value);
	                } else {
	                  removeFromArray(temporaryStyles, value);
	                }
	              }
	            } else if (animationPaused && playAnimation) {
	              animationPaused = false;
	              close();
	            }
	          };
	
	          // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	          // being inherited from the parent. If the transition duration is zero then we can safely
	          // rely that the delay value is an intentional stagger delay style.
	          var maxStagger = itemIndex > 0 && (timings.transitionDuration && stagger.transitionDuration === 0 || timings.animationDuration && stagger.animationDuration === 0) && Math.max(stagger.animationDelay, stagger.transitionDelay);
	          if (maxStagger) {
	            $timeout(triggerAnimationStart, Math.floor(maxStagger * itemIndex * ONE_SECOND), false);
	          } else {
	            triggerAnimationStart();
	          }
	
	          // this will decorate the existing promise runner with pause/resume methods
	          runnerHost.resume = function () {
	            playPause(true);
	          };
	
	          runnerHost.pause = function () {
	            playPause(false);
	          };
	
	          function triggerAnimationStart() {
	            // just incase a stagger animation kicks in when the animation
	            // itself was cancelled entirely
	            if (animationClosed) return;
	
	            applyBlocking(false);
	
	            forEach(temporaryStyles, function (entry) {
	              var key = entry[0];
	              var value = entry[1];
	              node.style[key] = value;
	            });
	
	            applyAnimationClasses(element, options);
	            $$jqLite.addClass(element, activeClasses);
	
	            if (flags.recalculateTimingStyles) {
	              fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
	              cacheKey = gcsHashFn(node, fullClassName);
	
	              timings = computeTimings(node, fullClassName, cacheKey);
	              relativeDelay = timings.maxDelay;
	              maxDelay = Math.max(relativeDelay, 0);
	              maxDuration = timings.maxDuration;
	
	              if (maxDuration === 0) {
	                close();
	                return;
	              }
	
	              flags.hasTransitions = timings.transitionDuration > 0;
	              flags.hasAnimations = timings.animationDuration > 0;
	            }
	
	            if (flags.applyAnimationDelay) {
	              relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay) ? parseFloat(options.delay) : relativeDelay;
	
	              maxDelay = Math.max(relativeDelay, 0);
	              timings.animationDelay = relativeDelay;
	              delayStyle = getCssDelayStyle(relativeDelay, true);
	              temporaryStyles.push(delayStyle);
	              node.style[delayStyle[0]] = delayStyle[1];
	            }
	
	            maxDelayTime = maxDelay * ONE_SECOND;
	            maxDurationTime = maxDuration * ONE_SECOND;
	
	            if (options.easing) {
	              var easeProp,
	                  easeVal = options.easing;
	              if (flags.hasTransitions) {
	                easeProp = TRANSITION_PROP + TIMING_KEY;
	                temporaryStyles.push([easeProp, easeVal]);
	                node.style[easeProp] = easeVal;
	              }
	              if (flags.hasAnimations) {
	                easeProp = ANIMATION_PROP + TIMING_KEY;
	                temporaryStyles.push([easeProp, easeVal]);
	                node.style[easeProp] = easeVal;
	              }
	            }
	
	            if (timings.transitionDuration) {
	              events.push(TRANSITIONEND_EVENT);
	            }
	
	            if (timings.animationDuration) {
	              events.push(ANIMATIONEND_EVENT);
	            }
	
	            startTime = Date.now();
	            var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	            var endTime = startTime + timerTime;
	
	            var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	            var setupFallbackTimer = true;
	            if (animationsData.length) {
	              var currentTimerData = animationsData[0];
	              setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	              if (setupFallbackTimer) {
	                $timeout.cancel(currentTimerData.timer);
	              } else {
	                animationsData.push(close);
	              }
	            }
	
	            if (setupFallbackTimer) {
	              var timer = $timeout(onAnimationExpired, timerTime, false);
	              animationsData[0] = {
	                timer: timer,
	                expectedEndTime: endTime
	              };
	              animationsData.push(close);
	              element.data(ANIMATE_TIMER_KEY, animationsData);
	            }
	
	            if (events.length) {
	              element.on(events.join(' '), onAnimationProgress);
	            }
	
	            if (options.to) {
	              if (options.cleanupStyles) {
	                registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	              }
	              applyAnimationToStyles(element, options);
	            }
	          }
	
	          function onAnimationExpired() {
	            var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	            // this will be false in the event that the element was
	            // removed from the DOM (via a leave animation or something
	            // similar)
	            if (animationsData) {
	              for (var i = 1; i < animationsData.length; i++) {
	                animationsData[i]();
	              }
	              element.removeData(ANIMATE_TIMER_KEY);
	            }
	          }
	        }
	      };
	    }];
	  }];
	
	  var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */function ($$animationProvider) {
	    $$animationProvider.drivers.push('$$animateCssDriver');
	
	    var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	    var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	    var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	    var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	    function isDocumentFragment(node) {
	      return node.parentNode && node.parentNode.nodeType === 11;
	    }
	
	    this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document', function ($animateCss, $rootScope, $$AnimateRunner, $rootElement, $sniffer, $$jqLite, $document) {
	
	      // only browsers that support these properties can render animations
	      if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	      var bodyNode = $document[0].body;
	      var rootNode = getDomNode($rootElement);
	
	      var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode);
	
	      return function initDriverFn(animationDetails) {
	        return animationDetails.from && animationDetails.to ? prepareFromToAnchorAnimation(animationDetails.from, animationDetails.to, animationDetails.classes, animationDetails.anchors) : prepareRegularAnimation(animationDetails);
	      };
	
	      function filterCssClasses(classes) {
	        //remove all the `ng-` stuff
	        return classes.replace(/\bng-\S+\b/g, '');
	      }
	
	      function getUniqueValues(a, b) {
	        if (isString(a)) a = a.split(' ');
	        if (isString(b)) b = b.split(' ');
	        return a.filter(function (val) {
	          return b.indexOf(val) === -1;
	        }).join(' ');
	      }
	
	      function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	        var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	        var startingClasses = filterCssClasses(getClassVal(clone));
	
	        outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	        clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	        rootBodyElement.append(clone);
	
	        var animatorIn,
	            animatorOut = prepareOutAnimation();
	
	        // the user may not end up using the `out` animation and
	        // only making use of the `in` animation or vice-versa.
	        // In either case we should allow this and not assume the
	        // animation is over unless both animations are not used.
	        if (!animatorOut) {
	          animatorIn = prepareInAnimation();
	          if (!animatorIn) {
	            return end();
	          }
	        }
	
	        var startingAnimator = animatorOut || animatorIn;
	
	        return {
	          start: function start() {
	            var runner;
	
	            var currentAnimation = startingAnimator.start();
	            currentAnimation.done(function () {
	              currentAnimation = null;
	              if (!animatorIn) {
	                animatorIn = prepareInAnimation();
	                if (animatorIn) {
	                  currentAnimation = animatorIn.start();
	                  currentAnimation.done(function () {
	                    currentAnimation = null;
	                    end();
	                    runner.complete();
	                  });
	                  return currentAnimation;
	                }
	              }
	              // in the event that there is no `in` animation
	              end();
	              runner.complete();
	            });
	
	            runner = new $$AnimateRunner({
	              end: endFn,
	              cancel: endFn
	            });
	
	            return runner;
	
	            function endFn() {
	              if (currentAnimation) {
	                currentAnimation.end();
	              }
	            }
	          }
	        };
	
	        function calculateAnchorStyles(anchor) {
	          var styles = {};
	
	          var coords = getDomNode(anchor).getBoundingClientRect();
	
	          // we iterate directly since safari messes up and doesn't return
	          // all the keys for the coords object when iterated
	          forEach(['width', 'height', 'top', 'left'], function (key) {
	            var value = coords[key];
	            switch (key) {
	              case 'top':
	                value += bodyNode.scrollTop;
	                break;
	              case 'left':
	                value += bodyNode.scrollLeft;
	                break;
	            }
	            styles[key] = Math.floor(value) + 'px';
	          });
	          return styles;
	        }
	
	        function prepareOutAnimation() {
	          var animator = $animateCss(clone, {
	            addClass: NG_OUT_ANCHOR_CLASS_NAME,
	            delay: true,
	            from: calculateAnchorStyles(outAnchor)
	          });
	
	          // read the comment within `prepareRegularAnimation` to understand
	          // why this check is necessary
	          return animator.$$willAnimate ? animator : null;
	        }
	
	        function getClassVal(element) {
	          return element.attr('class') || '';
	        }
	
	        function prepareInAnimation() {
	          var endingClasses = filterCssClasses(getClassVal(inAnchor));
	          var toAdd = getUniqueValues(endingClasses, startingClasses);
	          var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	          var animator = $animateCss(clone, {
	            to: calculateAnchorStyles(inAnchor),
	            addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	            removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	            delay: true
	          });
	
	          // read the comment within `prepareRegularAnimation` to understand
	          // why this check is necessary
	          return animator.$$willAnimate ? animator : null;
	        }
	
	        function end() {
	          clone.remove();
	          outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	          inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        }
	      }
	
	      function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	        var fromAnimation = prepareRegularAnimation(from, noop);
	        var toAnimation = prepareRegularAnimation(to, noop);
	
	        var anchorAnimations = [];
	        forEach(anchors, function (anchor) {
	          var outElement = anchor['out'];
	          var inElement = anchor['in'];
	          var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	          if (animator) {
	            anchorAnimations.push(animator);
	          }
	        });
	
	        // no point in doing anything when there are no elements to animate
	        if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	        return {
	          start: function start() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            forEach(anchorAnimations, function (animation) {
	              animationRunners.push(animation.start());
	            });
	
	            var runner = new $$AnimateRunner({
	              end: endFn,
	              cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	            });
	
	            $$AnimateRunner.all(animationRunners, function (status) {
	              runner.complete(status);
	            });
	
	            return runner;
	
	            function endFn() {
	              forEach(animationRunners, function (runner) {
	                runner.end();
	              });
	            }
	          }
	        };
	      }
	
	      function prepareRegularAnimation(animationDetails) {
	        var element = animationDetails.element;
	        var options = animationDetails.options || {};
	
	        if (animationDetails.structural) {
	          options.event = animationDetails.event;
	          options.structural = true;
	          options.applyClassesEarly = true;
	
	          // we special case the leave animation since we want to ensure that
	          // the element is removed as soon as the animation is over. Otherwise
	          // a flicker might appear or the element may not be removed at all
	          if (animationDetails.event === 'leave') {
	            options.onDone = options.domOperation;
	          }
	        }
	
	        // We assign the preparationClasses as the actual animation event since
	        // the internals of $animateCss will just suffix the event token values
	        // with `-active` to trigger the animation.
	        if (options.preparationClasses) {
	          options.event = concatWithSpace(options.event, options.preparationClasses);
	        }
	
	        var animator = $animateCss(element, options);
	
	        // the driver lookup code inside of $$animation attempts to spawn a
	        // driver one by one until a driver returns a.$$willAnimate animator object.
	        // $animateCss will always return an object, however, it will pass in
	        // a flag as a hint as to whether an animation was detected or not
	        return animator.$$willAnimate ? animator : null;
	      }
	    }];
	  }];
	
	  // TODO(matsko): use caching here to speed things up for detection
	  // TODO(matsko): add documentation
	  //  by the time...
	
	  var $$AnimateJsProvider = ['$animateProvider', /** @this */function ($animateProvider) {
	    this.$get = ['$injector', '$$AnimateRunner', '$$jqLite', function ($injector, $$AnimateRunner, $$jqLite) {
	
	      var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	      // $animateJs(element, 'enter');
	      return function (element, event, classes, options) {
	        var animationClosed = false;
	
	        // the `classes` argument is optional and if it is not used
	        // then the classes will be resolved from the element's className
	        // property as well as options.addClass/options.removeClass.
	        if (arguments.length === 3 && isObject(classes)) {
	          options = classes;
	          classes = null;
	        }
	
	        options = prepareAnimationOptions(options);
	        if (!classes) {
	          classes = element.attr('class') || '';
	          if (options.addClass) {
	            classes += ' ' + options.addClass;
	          }
	          if (options.removeClass) {
	            classes += ' ' + options.removeClass;
	          }
	        }
	
	        var classesToAdd = options.addClass;
	        var classesToRemove = options.removeClass;
	
	        // the lookupAnimations function returns a series of animation objects that are
	        // matched up with one or more of the CSS classes. These animation objects are
	        // defined via the module.animation factory function. If nothing is detected then
	        // we don't return anything which then makes $animation query the next driver.
	        var animations = lookupAnimations(classes);
	        var before, after;
	        if (animations.length) {
	          var afterFn, beforeFn;
	          if (event === 'leave') {
	            beforeFn = 'leave';
	            afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	          } else {
	            beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	            afterFn = event;
	          }
	
	          if (event !== 'enter' && event !== 'move') {
	            before = packageAnimations(element, event, options, animations, beforeFn);
	          }
	          after = packageAnimations(element, event, options, animations, afterFn);
	        }
	
	        // no matching animations
	        if (!before && !after) return;
	
	        function applyOptions() {
	          options.domOperation();
	          applyAnimationClasses(element, options);
	        }
	
	        function close() {
	          animationClosed = true;
	          applyOptions();
	          applyAnimationStyles(element, options);
	        }
	
	        var runner;
	
	        return {
	          $$willAnimate: true,
	          end: function end() {
	            if (runner) {
	              runner.end();
	            } else {
	              close();
	              runner = new $$AnimateRunner();
	              runner.complete(true);
	            }
	            return runner;
	          },
	          start: function start() {
	            if (runner) {
	              return runner;
	            }
	
	            runner = new $$AnimateRunner();
	            var closeActiveAnimations;
	            var chain = [];
	
	            if (before) {
	              chain.push(function (fn) {
	                closeActiveAnimations = before(fn);
	              });
	            }
	
	            if (chain.length) {
	              chain.push(function (fn) {
	                applyOptions();
	                fn(true);
	              });
	            } else {
	              applyOptions();
	            }
	
	            if (after) {
	              chain.push(function (fn) {
	                closeActiveAnimations = after(fn);
	              });
	            }
	
	            runner.setHost({
	              end: function end() {
	                endAnimations();
	              },
	              cancel: function cancel() {
	                endAnimations(true);
	              }
	            });
	
	            $$AnimateRunner.chain(chain, onComplete);
	            return runner;
	
	            function onComplete(success) {
	              close(success);
	              runner.complete(success);
	            }
	
	            function endAnimations(cancelled) {
	              if (!animationClosed) {
	                (closeActiveAnimations || noop)(cancelled);
	                onComplete(cancelled);
	              }
	            }
	          }
	        };
	
	        function executeAnimationFn(fn, element, event, options, onDone) {
	          var args;
	          switch (event) {
	            case 'animate':
	              args = [element, options.from, options.to, onDone];
	              break;
	
	            case 'setClass':
	              args = [element, classesToAdd, classesToRemove, onDone];
	              break;
	
	            case 'addClass':
	              args = [element, classesToAdd, onDone];
	              break;
	
	            case 'removeClass':
	              args = [element, classesToRemove, onDone];
	              break;
	
	            default:
	              args = [element, onDone];
	              break;
	          }
	
	          args.push(options);
	
	          var value = fn.apply(fn, args);
	          if (value) {
	            if (isFunction(value.start)) {
	              value = value.start();
	            }
	
	            if (value instanceof $$AnimateRunner) {
	              value.done(onDone);
	            } else if (isFunction(value)) {
	              // optional onEnd / onCancel callback
	              return value;
	            }
	          }
	
	          return noop;
	        }
	
	        function groupEventedAnimations(element, event, options, animations, fnName) {
	          var operations = [];
	          forEach(animations, function (ani) {
	            var animation = ani[fnName];
	            if (!animation) return;
	
	            // note that all of these animations will run in parallel
	            operations.push(function () {
	              var runner;
	              var endProgressCb;
	
	              var resolved = false;
	              var onAnimationComplete = function onAnimationComplete(rejected) {
	                if (!resolved) {
	                  resolved = true;
	                  (endProgressCb || noop)(rejected);
	                  runner.complete(!rejected);
	                }
	              };
	
	              runner = new $$AnimateRunner({
	                end: function end() {
	                  onAnimationComplete();
	                },
	                cancel: function cancel() {
	                  onAnimationComplete(true);
	                }
	              });
	
	              endProgressCb = executeAnimationFn(animation, element, event, options, function (result) {
	                var cancelled = result === false;
	                onAnimationComplete(cancelled);
	              });
	
	              return runner;
	            });
	          });
	
	          return operations;
	        }
	
	        function packageAnimations(element, event, options, animations, fnName) {
	          var operations = groupEventedAnimations(element, event, options, animations, fnName);
	          if (operations.length === 0) {
	            var a, b;
	            if (fnName === 'beforeSetClass') {
	              a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	              b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	            } else if (fnName === 'setClass') {
	              a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	              b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	            }
	
	            if (a) {
	              operations = operations.concat(a);
	            }
	            if (b) {
	              operations = operations.concat(b);
	            }
	          }
	
	          if (operations.length === 0) return;
	
	          // TODO(matsko): add documentation
	          return function startAnimation(callback) {
	            var runners = [];
	            if (operations.length) {
	              forEach(operations, function (animateFn) {
	                runners.push(animateFn());
	              });
	            }
	
	            if (runners.length) {
	              $$AnimateRunner.all(runners, callback);
	            } else {
	              callback();
	            }
	
	            return function endFn(reject) {
	              forEach(runners, function (runner) {
	                if (reject) {
	                  runner.cancel();
	                } else {
	                  runner.end();
	                }
	              });
	            };
	          };
	        }
	      };
	
	      function lookupAnimations(classes) {
	        classes = isArray(classes) ? classes : classes.split(' ');
	        var matches = [],
	            flagMap = {};
	        for (var i = 0; i < classes.length; i++) {
	          var klass = classes[i],
	              animationFactory = $animateProvider.$$registeredAnimations[klass];
	          if (animationFactory && !flagMap[klass]) {
	            matches.push($injector.get(animationFactory));
	            flagMap[klass] = true;
	          }
	        }
	        return matches;
	      }
	    }];
	  }];
	
	  var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */function ($$animationProvider) {
	    $$animationProvider.drivers.push('$$animateJsDriver');
	    this.$get = ['$$animateJs', '$$AnimateRunner', function ($$animateJs, $$AnimateRunner) {
	      return function initDriverFn(animationDetails) {
	        if (animationDetails.from && animationDetails.to) {
	          var fromAnimation = prepareAnimation(animationDetails.from);
	          var toAnimation = prepareAnimation(animationDetails.to);
	          if (!fromAnimation && !toAnimation) return;
	
	          return {
	            start: function start() {
	              var animationRunners = [];
	
	              if (fromAnimation) {
	                animationRunners.push(fromAnimation.start());
	              }
	
	              if (toAnimation) {
	                animationRunners.push(toAnimation.start());
	              }
	
	              $$AnimateRunner.all(animationRunners, done);
	
	              var runner = new $$AnimateRunner({
	                end: endFnFactory(),
	                cancel: endFnFactory()
	              });
	
	              return runner;
	
	              function endFnFactory() {
	                return function () {
	                  forEach(animationRunners, function (runner) {
	                    // at this point we cannot cancel animations for groups just yet. 1.5+
	                    runner.end();
	                  });
	                };
	              }
	
	              function done(status) {
	                runner.complete(status);
	              }
	            }
	          };
	        } else {
	          return prepareAnimation(animationDetails);
	        }
	      };
	
	      function prepareAnimation(animationDetails) {
	        // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	        var element = animationDetails.element;
	        var event = animationDetails.event;
	        var options = animationDetails.options;
	        var classes = animationDetails.classes;
	        return $$animateJs(element, event, classes, options);
	      }
	    }];
	  }];
	
	  var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	  var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	  var $$AnimateQueueProvider = ['$animateProvider', /** @this */function ($animateProvider) {
	    var PRE_DIGEST_STATE = 1;
	    var RUNNING_STATE = 2;
	    var ONE_SPACE = ' ';
	
	    var rules = this.rules = {
	      skip: [],
	      cancel: [],
	      join: []
	    };
	
	    function makeTruthyCssClassMap(classString) {
	      if (!classString) {
	        return null;
	      }
	
	      var keys = classString.split(ONE_SPACE);
	      var map = Object.create(null);
	
	      forEach(keys, function (key) {
	        map[key] = true;
	      });
	      return map;
	    }
	
	    function hasMatchingClasses(newClassString, currentClassString) {
	      if (newClassString && currentClassString) {
	        var currentClassMap = makeTruthyCssClassMap(currentClassString);
	        return newClassString.split(ONE_SPACE).some(function (className) {
	          return currentClassMap[className];
	        });
	      }
	    }
	
	    function isAllowed(ruleType, currentAnimation, previousAnimation) {
	      return rules[ruleType].some(function (fn) {
	        return fn(currentAnimation, previousAnimation);
	      });
	    }
	
	    function hasAnimationClasses(animation, and) {
	      var a = (animation.addClass || '').length > 0;
	      var b = (animation.removeClass || '').length > 0;
	      return and ? a && b : a || b;
	    }
	
	    rules.join.push(function (newAnimation, currentAnimation) {
	      // if the new animation is class-based then we can just tack that on
	      return !newAnimation.structural && hasAnimationClasses(newAnimation);
	    });
	
	    rules.skip.push(function (newAnimation, currentAnimation) {
	      // there is no need to animate anything if no classes are being added and
	      // there is no structural animation that will be triggered
	      return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	    });
	
	    rules.skip.push(function (newAnimation, currentAnimation) {
	      // why should we trigger a new structural animation if the element will
	      // be removed from the DOM anyway?
	      return currentAnimation.event === 'leave' && newAnimation.structural;
	    });
	
	    rules.skip.push(function (newAnimation, currentAnimation) {
	      // if there is an ongoing current animation then don't even bother running the class-based animation
	      return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	    });
	
	    rules.cancel.push(function (newAnimation, currentAnimation) {
	      // there can never be two structural animations running at the same time
	      return currentAnimation.structural && newAnimation.structural;
	    });
	
	    rules.cancel.push(function (newAnimation, currentAnimation) {
	      // if the previous animation is already running, but the new animation will
	      // be triggered, but the new animation is structural
	      return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	    });
	
	    rules.cancel.push(function (newAnimation, currentAnimation) {
	      // cancel the animation if classes added / removed in both animation cancel each other out,
	      // but only if the current animation isn't structural
	
	      if (currentAnimation.structural) return false;
	
	      var nA = newAnimation.addClass;
	      var nR = newAnimation.removeClass;
	      var cA = currentAnimation.addClass;
	      var cR = currentAnimation.removeClass;
	
	      // early detection to save the global CPU shortage :)
	      if (isUndefined(nA) && isUndefined(nR) || isUndefined(cA) && isUndefined(cR)) {
	        return false;
	      }
	
	      return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	    });
	
	    this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map', '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow', '$$isDocumentHidden', function ($$rAF, $rootScope, $rootElement, $document, $$Map, $$animation, $$AnimateRunner, $templateRequest, $$jqLite, $$forceReflow, $$isDocumentHidden) {
	
	      var activeAnimationsLookup = new $$Map();
	      var disabledElementsLookup = new $$Map();
	      var animationsEnabled = null;
	
	      function postDigestTaskFactory() {
	        var postDigestCalled = false;
	        return function (fn) {
	          // we only issue a call to postDigest before
	          // it has first passed. This prevents any callbacks
	          // from not firing once the animation has completed
	          // since it will be out of the digest cycle.
	          if (postDigestCalled) {
	            fn();
	          } else {
	            $rootScope.$$postDigest(function () {
	              postDigestCalled = true;
	              fn();
	            });
	          }
	        };
	      }
	
	      // Wait until all directive and route-related templates are downloaded and
	      // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	      // all of the remote templates being currently downloaded. If there are no
	      // templates currently downloading then the watcher will still fire anyway.
	      var deregisterWatch = $rootScope.$watch(function () {
	        return $templateRequest.totalPendingRequests === 0;
	      }, function (isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function () {
	          $rootScope.$$postDigest(function () {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      });
	
	      var callbackRegistry = Object.create(null);
	
	      // remember that the `customFilter`/`classNameFilter` are set during the
	      // provider/config stage therefore we can optimize here and setup helper functions
	      var customFilter = $animateProvider.customFilter();
	      var classNameFilter = $animateProvider.classNameFilter();
	      var returnTrue = function returnTrue() {
	        return true;
	      };
	
	      var isAnimatableByFilter = customFilter || returnTrue;
	      var isAnimatableClassName = !classNameFilter ? returnTrue : function (node, options) {
	        var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
	        return classNameFilter.test(className);
	      };
	
	      var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	      function normalizeAnimationDetails(element, animation) {
	        return mergeAnimationDetails(element, animation, {});
	      }
	
	      // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	      var contains = window.Node.prototype.contains || /** @this */function (arg) {
	        // eslint-disable-next-line no-bitwise
	        return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	      };
	
	      function findCallbacks(targetParentNode, targetNode, event) {
	        var matches = [];
	        var entries = callbackRegistry[event];
	        if (entries) {
	          forEach(entries, function (entry) {
	            if (contains.call(entry.node, targetNode)) {
	              matches.push(entry.callback);
	            } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	              matches.push(entry.callback);
	            }
	          });
	        }
	
	        return matches;
	      }
	
	      function filterFromRegistry(list, matchContainer, matchCallback) {
	        var containerNode = extractElementNode(matchContainer);
	        return list.filter(function (entry) {
	          var isMatch = entry.node === containerNode && (!matchCallback || entry.callback === matchCallback);
	          return !isMatch;
	        });
	      }
	
	      function cleanupEventListeners(phase, node) {
	        if (phase === 'close' && !node.parentNode) {
	          // If the element is not attached to a parentNode, it has been removed by
	          // the domOperation, and we can safely remove the event callbacks
	          $animate.off(node);
	        }
	      }
	
	      var $animate = {
	        on: function on(event, container, callback) {
	          var node = extractElementNode(container);
	          callbackRegistry[event] = callbackRegistry[event] || [];
	          callbackRegistry[event].push({
	            node: node,
	            callback: callback
	          });
	
	          // Remove the callback when the element is removed from the DOM
	          jqLite(container).on('$destroy', function () {
	            var animationDetails = activeAnimationsLookup.get(node);
	
	            if (!animationDetails) {
	              // If there's an animation ongoing, the callback calling code will remove
	              // the event listeners. If we'd remove here, the callbacks would be removed
	              // before the animation ends
	              $animate.off(event, container, callback);
	            }
	          });
	        },
	
	        off: function off(event, container, callback) {
	          if (arguments.length === 1 && !isString(arguments[0])) {
	            container = arguments[0];
	            for (var eventType in callbackRegistry) {
	              callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	            }
	
	            return;
	          }
	
	          var entries = callbackRegistry[event];
	          if (!entries) return;
	
	          callbackRegistry[event] = arguments.length === 1 ? null : filterFromRegistry(entries, container, callback);
	        },
	
	        pin: function pin(element, parentElement) {
	          assertArg(isElement(element), 'element', 'not an element');
	          assertArg(isElement(parentElement), 'parentElement', 'not an element');
	          element.data(NG_ANIMATE_PIN_DATA, parentElement);
	        },
	
	        push: function push(element, event, options, domOperation) {
	          options = options || {};
	          options.domOperation = domOperation;
	          return queueAnimation(element, event, options);
	        },
	
	        // this method has four signatures:
	        //  () - global getter
	        //  (bool) - global setter
	        //  (element) - element getter
	        //  (element, bool) - element setter<F37>
	        enabled: function enabled(element, bool) {
	          var argCount = arguments.length;
	
	          if (argCount === 0) {
	            // () - Global getter
	            bool = !!animationsEnabled;
	          } else {
	            var hasElement = isElement(element);
	
	            if (!hasElement) {
	              // (bool) - Global setter
	              bool = animationsEnabled = !!element;
	            } else {
	              var node = getDomNode(element);
	
	              if (argCount === 1) {
	                // (element) - Element getter
	                bool = !disabledElementsLookup.get(node);
	              } else {
	                // (element, bool) - Element setter
	                disabledElementsLookup.set(node, !bool);
	              }
	            }
	          }
	
	          return bool;
	        }
	      };
	
	      return $animate;
	
	      function queueAnimation(originalElement, event, initialOptions) {
	        // we always make a copy of the options since
	        // there should never be any side effects on
	        // the input data when running `$animateCss`.
	        var options = copy(initialOptions);
	
	        var element = stripCommentsFromElement(originalElement);
	        var node = getDomNode(element);
	        var parentNode = node && node.parentNode;
	
	        options = prepareAnimationOptions(options);
	
	        // we create a fake runner with a working promise.
	        // These methods will become available after the digest has passed
	        var runner = new $$AnimateRunner();
	
	        // this is used to trigger callbacks in postDigest mode
	        var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	        if (isArray(options.addClass)) {
	          options.addClass = options.addClass.join(' ');
	        }
	
	        if (options.addClass && !isString(options.addClass)) {
	          options.addClass = null;
	        }
	
	        if (isArray(options.removeClass)) {
	          options.removeClass = options.removeClass.join(' ');
	        }
	
	        if (options.removeClass && !isString(options.removeClass)) {
	          options.removeClass = null;
	        }
	
	        if (options.from && !isObject(options.from)) {
	          options.from = null;
	        }
	
	        if (options.to && !isObject(options.to)) {
	          options.to = null;
	        }
	
	        // If animations are hard-disabled for the whole application there is no need to continue.
	        // There are also situations where a directive issues an animation for a jqLite wrapper that
	        // contains only comment nodes. In this case, there is no way we can perform an animation.
	        if (!animationsEnabled || !node || !isAnimatableByFilter(node, event, initialOptions) || !isAnimatableClassName(node, options)) {
	          close();
	          return runner;
	        }
	
	        var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	        var documentHidden = $$isDocumentHidden();
	
	        // This is a hard disable of all animations the element itself, therefore  there is no need to
	        // continue further past this point if not enabled
	        // Animations are also disabled if the document is currently hidden (page is not visible
	        // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	        var skipAnimations = documentHidden || disabledElementsLookup.get(node);
	        var existingAnimation = !skipAnimations && activeAnimationsLookup.get(node) || {};
	        var hasExistingAnimation = !!existingAnimation.state;
	
	        // there is no point in traversing the same collection of parent ancestors if a followup
	        // animation will be run on the same element that already did all that checking work
	        if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
	          skipAnimations = !areAnimationsAllowed(node, parentNode, event);
	        }
	
	        if (skipAnimations) {
	          // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	          if (documentHidden) notifyProgress(runner, event, 'start');
	          close();
	          if (documentHidden) notifyProgress(runner, event, 'close');
	          return runner;
	        }
	
	        if (isStructural) {
	          closeChildAnimations(node);
	        }
	
	        var newAnimation = {
	          structural: isStructural,
	          element: element,
	          event: event,
	          addClass: options.addClass,
	          removeClass: options.removeClass,
	          close: close,
	          options: options,
	          runner: runner
	        };
	
	        if (hasExistingAnimation) {
	          var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
	          if (skipAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              close();
	              return runner;
	            } else {
	              mergeAnimationDetails(element, existingAnimation, newAnimation);
	              return existingAnimation.runner;
	            }
	          }
	          var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
	          if (cancelAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              // this will end the animation right away and it is safe
	              // to do so since the animation is already running and the
	              // runner callback code will run in async
	              existingAnimation.runner.end();
	            } else if (existingAnimation.structural) {
	              // this means that the animation is queued into a digest, but
	              // hasn't started yet. Therefore it is safe to run the close
	              // method which will call the runner methods in async.
	              existingAnimation.close();
	            } else {
	              // this will merge the new animation options into existing animation options
	              mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              return existingAnimation.runner;
	            }
	          } else {
	            // a joined animation means that this animation will take over the existing one
	            // so an example would involve a leave animation taking over an enter. Then when
	            // the postDigest kicks in the enter will be ignored.
	            var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
	            if (joinAnimationFlag) {
	              if (existingAnimation.state === RUNNING_STATE) {
	                normalizeAnimationDetails(element, newAnimation);
	              } else {
	                applyGeneratedPreparationClasses(element, isStructural ? event : null, options);
	
	                event = newAnimation.event = existingAnimation.event;
	                options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	                //we return the same runner since only the option values of this animation will
	                //be fed into the `existingAnimation`.
	                return existingAnimation.runner;
	              }
	            }
	          }
	        } else {
	          // normalization in this case means that it removes redundant CSS classes that
	          // already exist (addClass) or do not exist (removeClass) on the element
	          normalizeAnimationDetails(element, newAnimation);
	        }
	
	        // when the options are merged and cleaned up we may end up not having to do
	        // an animation at all, therefore we should check this before issuing a post
	        // digest callback. Structural animations will always run no matter what.
	        var isValidAnimation = newAnimation.structural;
	        if (!isValidAnimation) {
	          // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	          isValidAnimation = newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0 || hasAnimationClasses(newAnimation);
	        }
	
	        if (!isValidAnimation) {
	          close();
	          clearElementAnimationState(node);
	          return runner;
	        }
	
	        // the counter keeps track of cancelled animations
	        var counter = (existingAnimation.counter || 0) + 1;
	        newAnimation.counter = counter;
	
	        markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
	
	        $rootScope.$$postDigest(function () {
	          // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
	          // happen if the animated element is a transcluded clone and also has a `templateUrl`
	          // directive on it. Therefore, we must recreate `element` in order to interact with the
	          // actual DOM nodes.
	          // Note: We still need to use the old `node` for certain things, such as looking up in
	          //       HashMaps where it was used as the key.
	
	          element = stripCommentsFromElement(originalElement);
	
	          var animationDetails = activeAnimationsLookup.get(node);
	          var animationCancelled = !animationDetails;
	          animationDetails = animationDetails || {};
	
	          // if addClass/removeClass is called before something like enter then the
	          // registered parent element may not be present. The code below will ensure
	          // that a final value for parent element is obtained
	          var parentElement = element.parent() || [];
	
	          // animate/structural/class-based animations all have requirements. Otherwise there
	          // is no point in performing an animation. The parent node must also be set.
	          var isValidAnimation = parentElement.length > 0 && (animationDetails.event === 'animate' || animationDetails.structural || hasAnimationClasses(animationDetails));
	
	          // this means that the previous animation was cancelled
	          // even if the follow-up animation is the same event
	          if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	            // if another animation did not take over then we need
	            // to make sure that the domOperation and options are
	            // handled accordingly
	            if (animationCancelled) {
	              applyAnimationClasses(element, options);
	              applyAnimationStyles(element, options);
	            }
	
	            // if the event changed from something like enter to leave then we do
	            // it, otherwise if it's the same then the end result will be the same too
	            if (animationCancelled || isStructural && animationDetails.event !== event) {
	              options.domOperation();
	              runner.end();
	            }
	
	            // in the event that the element animation was not cancelled or a follow-up animation
	            // isn't allowed to animate from here then we need to clear the state of the element
	            // so that any future animations won't read the expired animation data.
	            if (!isValidAnimation) {
	              clearElementAnimationState(node);
	            }
	
	            return;
	          }
	
	          // this combined multiple class to addClass / removeClass into a setClass event
	          // so long as a structural event did not take over the animation
	          event = !animationDetails.structural && hasAnimationClasses(animationDetails, true) ? 'setClass' : animationDetails.event;
	
	          markElementAnimationState(node, RUNNING_STATE);
	          var realRunner = $$animation(element, event, animationDetails.options);
	
	          // this will update the runner's flow-control events based on
	          // the `realRunner` object.
	          runner.setHost(realRunner);
	          notifyProgress(runner, event, 'start', {});
	
	          realRunner.done(function (status) {
	            close(!status);
	            var animationDetails = activeAnimationsLookup.get(node);
	            if (animationDetails && animationDetails.counter === counter) {
	              clearElementAnimationState(node);
	            }
	            notifyProgress(runner, event, 'close', {});
	          });
	        });
	
	        return runner;
	
	        function notifyProgress(runner, event, phase, data) {
	          runInNextPostDigestOrNow(function () {
	            var callbacks = findCallbacks(parentNode, node, event);
	            if (callbacks.length) {
	              // do not optimize this call here to RAF because
	              // we don't know how heavy the callback code here will
	              // be and if this code is buffered then this can
	              // lead to a performance regression.
	              $$rAF(function () {
	                forEach(callbacks, function (callback) {
	                  callback(element, phase, data);
	                });
	                cleanupEventListeners(phase, node);
	              });
	            } else {
	              cleanupEventListeners(phase, node);
	            }
	          });
	          runner.progress(event, phase, data);
	        }
	
	        function close(reject) {
	          clearGeneratedClasses(element, options);
	          applyAnimationClasses(element, options);
	          applyAnimationStyles(element, options);
	          options.domOperation();
	          runner.complete(!reject);
	        }
	      }
	
	      function closeChildAnimations(node) {
	        var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	        forEach(children, function (child) {
	          var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
	          var animationDetails = activeAnimationsLookup.get(child);
	          if (animationDetails) {
	            switch (state) {
	              case RUNNING_STATE:
	                animationDetails.runner.end();
	              /* falls through */
	              case PRE_DIGEST_STATE:
	                activeAnimationsLookup.delete(child);
	                break;
	            }
	          }
	        });
	      }
	
	      function clearElementAnimationState(node) {
	        node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	        activeAnimationsLookup.delete(node);
	      }
	
	      /**
	       * This fn returns false if any of the following is true:
	       * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	       * b) a parent element has an ongoing structural animation, and animateChildren is false
	       * c) the element is not a child of the body
	       * d) the element is not a child of the $rootElement
	       */
	      function areAnimationsAllowed(node, parentNode, event) {
	        var bodyNode = $document[0].body;
	        var rootNode = getDomNode($rootElement);
	
	        var bodyNodeDetected = node === bodyNode || node.nodeName === 'HTML';
	        var rootNodeDetected = node === rootNode;
	        var parentAnimationDetected = false;
	        var elementDisabled = disabledElementsLookup.get(node);
	        var animateChildren;
	
	        var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
	        if (parentHost) {
	          parentNode = getDomNode(parentHost);
	        }
	
	        while (parentNode) {
	          if (!rootNodeDetected) {
	            // AngularJS doesn't want to attempt to animate elements outside of the application
	            // therefore we need to ensure that the rootElement is an ancestor of the current element
	            rootNodeDetected = parentNode === rootNode;
	          }
	
	          if (parentNode.nodeType !== ELEMENT_NODE) {
	            // no point in inspecting the #document element
	            break;
	          }
	
	          var details = activeAnimationsLookup.get(parentNode) || {};
	          // either an enter, leave or move animation will commence
	          // therefore we can't allow any animations to take place
	          // but if a parent animation is class-based then that's ok
	          if (!parentAnimationDetected) {
	            var parentNodeDisabled = disabledElementsLookup.get(parentNode);
	
	            if (parentNodeDisabled === true && elementDisabled !== false) {
	              // disable animations if the user hasn't explicitly enabled animations on the
	              // current element
	              elementDisabled = true;
	              // element is disabled via parent element, no need to check anything else
	              break;
	            } else if (parentNodeDisabled === false) {
	              elementDisabled = false;
	            }
	            parentAnimationDetected = details.structural;
	          }
	
	          if (isUndefined(animateChildren) || animateChildren === true) {
	            var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
	            if (isDefined(value)) {
	              animateChildren = value;
	            }
	          }
	
	          // there is no need to continue traversing at this point
	          if (parentAnimationDetected && animateChildren === false) break;
	
	          if (!bodyNodeDetected) {
	            // we also need to ensure that the element is or will be a part of the body element
	            // otherwise it is pointless to even issue an animation to be rendered
	            bodyNodeDetected = parentNode === bodyNode;
	          }
	
	          if (bodyNodeDetected && rootNodeDetected) {
	            // If both body and root have been found, any other checks are pointless,
	            // as no animation data should live outside the application
	            break;
	          }
	
	          if (!rootNodeDetected) {
	            // If `rootNode` is not detected, check if `parentNode` is pinned to another element
	            parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
	            if (parentHost) {
	              // The pin target element becomes the next parent element
	              parentNode = getDomNode(parentHost);
	              continue;
	            }
	          }
	
	          parentNode = parentNode.parentNode;
	        }
	
	        var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	        return allowAnimation && rootNodeDetected && bodyNodeDetected;
	      }
	
	      function markElementAnimationState(node, state, details) {
	        details = details || {};
	        details.state = state;
	
	        node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	        var oldValue = activeAnimationsLookup.get(node);
	        var newValue = oldValue ? extend(oldValue, details) : details;
	        activeAnimationsLookup.set(node, newValue);
	      }
	    }];
	  }];
	
	  /* exported $$AnimationProvider */
	
	  var $$AnimationProvider = ['$animateProvider', /** @this */function ($animateProvider) {
	    var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	    var drivers = this.drivers = [];
	
	    var RUNNER_STORAGE_KEY = '$$animationRunner';
	
	    function setRunner(element, runner) {
	      element.data(RUNNER_STORAGE_KEY, runner);
	    }
	
	    function removeRunner(element) {
	      element.removeData(RUNNER_STORAGE_KEY);
	    }
	
	    function getRunner(element) {
	      return element.data(RUNNER_STORAGE_KEY);
	    }
	
	    this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler', function ($$jqLite, $rootScope, $injector, $$AnimateRunner, $$Map, $$rAFScheduler) {
	
	      var animationQueue = [];
	      var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	      function sortAnimations(animations) {
	        var tree = { children: [] };
	        var i,
	            lookup = new $$Map();
	
	        // this is done first beforehand so that the map
	        // is filled with a list of the elements that will be animated
	        for (i = 0; i < animations.length; i++) {
	          var animation = animations[i];
	          lookup.set(animation.domNode, animations[i] = {
	            domNode: animation.domNode,
	            fn: animation.fn,
	            children: []
	          });
	        }
	
	        for (i = 0; i < animations.length; i++) {
	          processNode(animations[i]);
	        }
	
	        return flatten(tree);
	
	        function processNode(entry) {
	          if (entry.processed) return entry;
	          entry.processed = true;
	
	          var elementNode = entry.domNode;
	          var parentNode = elementNode.parentNode;
	          lookup.set(elementNode, entry);
	
	          var parentEntry;
	          while (parentNode) {
	            parentEntry = lookup.get(parentNode);
	            if (parentEntry) {
	              if (!parentEntry.processed) {
	                parentEntry = processNode(parentEntry);
	              }
	              break;
	            }
	            parentNode = parentNode.parentNode;
	          }
	
	          (parentEntry || tree).children.push(entry);
	          return entry;
	        }
	
	        function flatten(tree) {
	          var result = [];
	          var queue = [];
	          var i;
	
	          for (i = 0; i < tree.children.length; i++) {
	            queue.push(tree.children[i]);
	          }
	
	          var remainingLevelEntries = queue.length;
	          var nextLevelEntries = 0;
	          var row = [];
	
	          for (i = 0; i < queue.length; i++) {
	            var entry = queue[i];
	            if (remainingLevelEntries <= 0) {
	              remainingLevelEntries = nextLevelEntries;
	              nextLevelEntries = 0;
	              result.push(row);
	              row = [];
	            }
	            row.push(entry.fn);
	            entry.children.forEach(function (childEntry) {
	              nextLevelEntries++;
	              queue.push(childEntry);
	            });
	            remainingLevelEntries--;
	          }
	
	          if (row.length) {
	            result.push(row);
	          }
	
	          return result;
	        }
	      }
	
	      // TODO(matsko): document the signature in a better way
	      return function (element, event, options) {
	        options = prepareAnimationOptions(options);
	        var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	        // there is no animation at the current moment, however
	        // these runner methods will get later updated with the
	        // methods leading into the driver's end/cancel methods
	        // for now they just stop the animation from starting
	        var runner = new $$AnimateRunner({
	          end: function end() {
	            close();
	          },
	          cancel: function cancel() {
	            close(true);
	          }
	        });
	
	        if (!drivers.length) {
	          close();
	          return runner;
	        }
	
	        setRunner(element, runner);
	
	        var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	        var tempClasses = options.tempClasses;
	        if (tempClasses) {
	          classes += ' ' + tempClasses;
	          options.tempClasses = null;
	        }
	
	        var prepareClassName;
	        if (isStructural) {
	          prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
	          $$jqLite.addClass(element, prepareClassName);
	        }
	
	        animationQueue.push({
	          // this data is used by the postDigest code and passed into
	          // the driver step function
	          element: element,
	          classes: classes,
	          event: event,
	          structural: isStructural,
	          options: options,
	          beforeStart: beforeStart,
	          close: close
	        });
	
	        element.on('$destroy', handleDestroyedElement);
	
	        // we only want there to be one function called within the post digest
	        // block. This way we can group animations for all the animations that
	        // were apart of the same postDigest flush call.
	        if (animationQueue.length > 1) return runner;
	
	        $rootScope.$$postDigest(function () {
	          var animations = [];
	          forEach(animationQueue, function (entry) {
	            // the element was destroyed early on which removed the runner
	            // form its storage. This means we can't animate this element
	            // at all and it already has been closed due to destruction.
	            if (getRunner(entry.element)) {
	              animations.push(entry);
	            } else {
	              entry.close();
	            }
	          });
	
	          // now any future animations will be in another postDigest
	          animationQueue.length = 0;
	
	          var groupedAnimations = groupAnimations(animations);
	          var toBeSortedAnimations = [];
	
	          forEach(groupedAnimations, function (animationEntry) {
	            toBeSortedAnimations.push({
	              domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
	              fn: function triggerAnimationStart() {
	                // it's important that we apply the `ng-animate` CSS class and the
	                // temporary classes before we do any driver invoking since these
	                // CSS classes may be required for proper CSS detection.
	                animationEntry.beforeStart();
	
	                var startAnimationFn,
	                    closeFn = animationEntry.close;
	
	                // in the event that the element was removed before the digest runs or
	                // during the RAF sequencing then we should not trigger the animation.
	                var targetElement = animationEntry.anchors ? animationEntry.from.element || animationEntry.to.element : animationEntry.element;
	
	                if (getRunner(targetElement)) {
	                  var operation = invokeFirstDriver(animationEntry);
	                  if (operation) {
	                    startAnimationFn = operation.start;
	                  }
	                }
	
	                if (!startAnimationFn) {
	                  closeFn();
	                } else {
	                  var animationRunner = startAnimationFn();
	                  animationRunner.done(function (status) {
	                    closeFn(!status);
	                  });
	                  updateAnimationRunners(animationEntry, animationRunner);
	                }
	              }
	            });
	          });
	
	          // we need to sort each of the animations in order of parent to child
	          // relationships. This ensures that the child classes are applied at the
	          // right time.
	          $$rAFScheduler(sortAnimations(toBeSortedAnimations));
	        });
	
	        return runner;
	
	        // TODO(matsko): change to reference nodes
	        function getAnchorNodes(node) {
	          var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	          var items = node.hasAttribute(NG_ANIMATE_REF_ATTR) ? [node] : node.querySelectorAll(SELECTOR);
	          var anchors = [];
	          forEach(items, function (node) {
	            var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	            if (attr && attr.length) {
	              anchors.push(node);
	            }
	          });
	          return anchors;
	        }
	
	        function groupAnimations(animations) {
	          var preparedAnimations = [];
	          var refLookup = {};
	          forEach(animations, function (animation, index) {
	            var element = animation.element;
	            var node = getDomNode(element);
	            var event = animation.event;
	            var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	            var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	            if (anchorNodes.length) {
	              var direction = enterOrMove ? 'to' : 'from';
	
	              forEach(anchorNodes, function (anchor) {
	                var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	                refLookup[key] = refLookup[key] || {};
	                refLookup[key][direction] = {
	                  animationID: index,
	                  element: jqLite(anchor)
	                };
	              });
	            } else {
	              preparedAnimations.push(animation);
	            }
	          });
	
	          var usedIndicesLookup = {};
	          var anchorGroups = {};
	          forEach(refLookup, function (operations, key) {
	            var from = operations.from;
	            var to = operations.to;
	
	            if (!from || !to) {
	              // only one of these is set therefore we can't have an
	              // anchor animation since all three pieces are required
	              var index = from ? from.animationID : to.animationID;
	              var indexKey = index.toString();
	              if (!usedIndicesLookup[indexKey]) {
	                usedIndicesLookup[indexKey] = true;
	                preparedAnimations.push(animations[index]);
	              }
	              return;
	            }
	
	            var fromAnimation = animations[from.animationID];
	            var toAnimation = animations[to.animationID];
	            var lookupKey = from.animationID.toString();
	            if (!anchorGroups[lookupKey]) {
	              var group = anchorGroups[lookupKey] = {
	                structural: true,
	                beforeStart: function beforeStart() {
	                  fromAnimation.beforeStart();
	                  toAnimation.beforeStart();
	                },
	                close: function close() {
	                  fromAnimation.close();
	                  toAnimation.close();
	                },
	                classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	                from: fromAnimation,
	                to: toAnimation,
	                anchors: [] // TODO(matsko): change to reference nodes
	              };
	
	              // the anchor animations require that the from and to elements both have at least
	              // one shared CSS class which effectively marries the two elements together to use
	              // the same animation driver and to properly sequence the anchor animation.
	              if (group.classes.length) {
	                preparedAnimations.push(group);
	              } else {
	                preparedAnimations.push(fromAnimation);
	                preparedAnimations.push(toAnimation);
	              }
	            }
	
	            anchorGroups[lookupKey].anchors.push({
	              'out': from.element, 'in': to.element
	            });
	          });
	
	          return preparedAnimations;
	        }
	
	        function cssClassesIntersection(a, b) {
	          a = a.split(' ');
	          b = b.split(' ');
	          var matches = [];
	
	          for (var i = 0; i < a.length; i++) {
	            var aa = a[i];
	            if (aa.substring(0, 3) === 'ng-') continue;
	
	            for (var j = 0; j < b.length; j++) {
	              if (aa === b[j]) {
	                matches.push(aa);
	                break;
	              }
	            }
	          }
	
	          return matches.join(' ');
	        }
	
	        function invokeFirstDriver(animationDetails) {
	          // we loop in reverse order since the more general drivers (like CSS and JS)
	          // may attempt more elements, but custom drivers are more particular
	          for (var i = drivers.length - 1; i >= 0; i--) {
	            var driverName = drivers[i];
	            var factory = $injector.get(driverName);
	            var driver = factory(animationDetails);
	            if (driver) {
	              return driver;
	            }
	          }
	        }
	
	        function beforeStart() {
	          element.addClass(NG_ANIMATE_CLASSNAME);
	          if (tempClasses) {
	            $$jqLite.addClass(element, tempClasses);
	          }
	          if (prepareClassName) {
	            $$jqLite.removeClass(element, prepareClassName);
	            prepareClassName = null;
	          }
	        }
	
	        function updateAnimationRunners(animation, newRunner) {
	          if (animation.from && animation.to) {
	            update(animation.from.element);
	            update(animation.to.element);
	          } else {
	            update(animation.element);
	          }
	
	          function update(element) {
	            var runner = getRunner(element);
	            if (runner) runner.setHost(newRunner);
	          }
	        }
	
	        function handleDestroyedElement() {
	          var runner = getRunner(element);
	          if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	            runner.end();
	          }
	        }
	
	        function close(rejected) {
	          element.off('$destroy', handleDestroyedElement);
	          removeRunner(element);
	
	          applyAnimationClasses(element, options);
	          applyAnimationStyles(element, options);
	          options.domOperation();
	
	          if (tempClasses) {
	            $$jqLite.removeClass(element, tempClasses);
	          }
	
	          element.removeClass(NG_ANIMATE_CLASSNAME);
	          runner.complete(!rejected);
	        }
	      };
	    }];
	  }];
	
	  /**
	   * @ngdoc directive
	   * @name ngAnimateSwap
	   * @restrict A
	   * @scope
	   *
	   * @description
	   *
	   * ngAnimateSwap is a animation-oriented directive that allows for the container to
	   * be removed and entered in whenever the associated expression changes. A
	   * common usecase for this directive is a rotating banner or slider component which
	   * contains one image being present at a time. When the active image changes
	   * then the old image will perform a `leave` animation and the new element
	   * will be inserted via an `enter` animation.
	   *
	   * @animations
	   * | Animation                        | Occurs                               |
	   * |----------------------------------|--------------------------------------|
	   * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	   * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	   *
	   * @example
	   * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	   *          deps="angular-animate.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <div class="container" ng-controller="AppCtrl">
	   *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	   *         {{ number }}
	   *       </div>
	   *     </div>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	   *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	   *         $scope.number = 0;
	   *         $interval(function() {
	   *           $scope.number++;
	   *         }, 1000);
	   *
	   *         var colors = ['red','blue','green','yellow','orange'];
	   *         $scope.colorClass = function(number) {
	   *           return colors[number % colors.length];
	   *         };
	   *       }]);
	   *   </file>
	   *  <file name="animations.css">
	   *  .container {
	   *    height:250px;
	   *    width:250px;
	   *    position:relative;
	   *    overflow:hidden;
	   *    border:2px solid black;
	   *  }
	   *  .container .cell {
	   *    font-size:150px;
	   *    text-align:center;
	   *    line-height:250px;
	   *    position:absolute;
	   *    top:0;
	   *    left:0;
	   *    right:0;
	   *    border-bottom:2px solid black;
	   *  }
	   *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	   *    transition:0.5s linear all;
	   *  }
	   *  .swap-animation.ng-enter {
	   *    top:-250px;
	   *  }
	   *  .swap-animation.ng-enter-active {
	   *    top:0px;
	   *  }
	   *  .swap-animation.ng-leave {
	   *    top:0px;
	   *  }
	   *  .swap-animation.ng-leave-active {
	   *    top:250px;
	   *  }
	   *  .red { background:red; }
	   *  .green { background:green; }
	   *  .blue { background:blue; }
	   *  .yellow { background:yellow; }
	   *  .orange { background:orange; }
	   *  </file>
	   * </example>
	   */
	  var ngAnimateSwapDirective = ['$animate', '$rootScope', function ($animate, $rootScope) {
	    return {
	      restrict: 'A',
	      transclude: 'element',
	      terminal: true,
	      priority: 600, // we use 600 here to ensure that the directive is caught before others
	      link: function link(scope, $element, attrs, ctrl, $transclude) {
	        var previousElement, previousScope;
	        scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function (value) {
	          if (previousElement) {
	            $animate.leave(previousElement);
	          }
	          if (previousScope) {
	            previousScope.$destroy();
	            previousScope = null;
	          }
	          if (value || value === 0) {
	            previousScope = scope.$new();
	            $transclude(previousScope, function (element) {
	              previousElement = element;
	              $animate.enter(element, null, $element);
	            });
	          }
	        });
	      }
	    };
	  }];
	
	  /**
	   * @ngdoc module
	   * @name ngAnimate
	   * @description
	   *
	   * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	   * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
	   *
	   * ## Usage
	   * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	   * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	   * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	   * the HTML element that the animation will be triggered on.
	   *
	   * ## Directive Support
	   * The following directives are "animation aware":
	   *
	   * | Directive                                                                                                | Supported Animations                                                     |
	   * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	   * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	   * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	   * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	   * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	   * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	   * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	   * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	   * | {@link ng.directive:form#animations form} & {@link ng.directive:ngModel#animations ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	   * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	   * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	   *
	   * (More information can be found by visiting each the documentation associated with each directive.)
	   *
	   * ## CSS-based Animations
	   *
	   * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	   * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
	   *
	   * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	   *
	   * ```html
	   * <div ng-if="bool" class="fade">
	   *    Fade me in out
	   * </div>
	   * <button ng-click="bool=true">Fade In!</button>
	   * <button ng-click="bool=false">Fade Out!</button>
	   * ```
	   *
	   * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	   *
	   * ```css
	   * /&#42; The starting CSS styles for the enter animation &#42;/
	   * .fade.ng-enter {
	   *   transition:0.5s linear all;
	   *   opacity:0;
	   * }
	   *
	   * /&#42; The finishing CSS styles for the enter animation &#42;/
	   * .fade.ng-enter.ng-enter-active {
	   *   opacity:1;
	   * }
	   * ```
	   *
	   * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	   * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	   * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	   *
	   * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	   *
	   * ```css
	   * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	   * .fade.ng-leave {
	   *   transition:0.5s linear all;
	   *   opacity:1;
	   * }
	   * .fade.ng-leave.ng-leave-active {
	   *   opacity:0;
	   * }
	   * ```
	   *
	   * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	   *
	   * ```css
	   * /&#42; there is no need to define anything inside of the destination
	   * CSS class since the keyframe will take charge of the animation &#42;/
	   * .fade.ng-leave {
	   *   animation: my_fade_animation 0.5s linear;
	   *   -webkit-animation: my_fade_animation 0.5s linear;
	   * }
	   *
	   * @keyframes my_fade_animation {
	   *   from { opacity:1; }
	   *   to { opacity:0; }
	   * }
	   *
	   * @-webkit-keyframes my_fade_animation {
	   *   from { opacity:1; }
	   *   to { opacity:0; }
	   * }
	   * ```
	   *
	   * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	   *
	   * ### CSS Class-based Animations
	   *
	   * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	   * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	   * and removed.
	   *
	   * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	   *
	   * ```html
	   * <div ng-show="bool" class="fade">
	   *   Show and hide me
	   * </div>
	   * <button ng-click="bool=!bool">Toggle</button>
	   *
	   * <style>
	   * .fade.ng-hide {
	   *   transition:0.5s linear all;
	   *   opacity:0;
	   * }
	   * </style>
	   * ```
	   *
	   * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	   * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	   *
	   * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	   * with CSS styles.
	   *
	   * ```html
	   * <div ng-class="{on:onOff}" class="highlight">
	   *   Highlight this box
	   * </div>
	   * <button ng-click="onOff=!onOff">Toggle</button>
	   *
	   * <style>
	   * .highlight {
	   *   transition:0.5s linear all;
	   * }
	   * .highlight.on-add {
	   *   background:white;
	   * }
	   * .highlight.on {
	   *   background:yellow;
	   * }
	   * .highlight.on-remove {
	   *   background:black;
	   * }
	   * </style>
	   * ```
	   *
	   * We can also make use of CSS keyframes by placing them within the CSS classes.
	   *
	   *
	   * ### CSS Staggering Animations
	   * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	   * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	   * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	   * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	   * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	   *
	   * ```css
	   * .my-animation.ng-enter {
	   *   /&#42; standard transition code &#42;/
	   *   transition: 1s linear all;
	   *   opacity:0;
	   * }
	   * .my-animation.ng-enter-stagger {
	   *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	   *   transition-delay: 0.1s;
	   *
	   *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	   *     to not accidentally inherit a delay property from another CSS class &#42;/
	   *   transition-duration: 0s;
	   *
	   *   /&#42; if you are using animations instead of transitions you should configure as follows:
	   *     animation-delay: 0.1s;
	   *     animation-duration: 0s; &#42;/
	   * }
	   * .my-animation.ng-enter.ng-enter-active {
	   *   /&#42; standard transition styles &#42;/
	   *   opacity:1;
	   * }
	   * ```
	   *
	   * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	   * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	   * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	   * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	   *
	   * The following code will issue the **ng-leave-stagger** event on the element provided:
	   *
	   * ```js
	   * var kids = parent.children();
	   *
	   * $animate.leave(kids[0]); //stagger index=0
	   * $animate.leave(kids[1]); //stagger index=1
	   * $animate.leave(kids[2]); //stagger index=2
	   * $animate.leave(kids[3]); //stagger index=3
	   * $animate.leave(kids[4]); //stagger index=4
	   *
	   * window.requestAnimationFrame(function() {
	   *   //stagger has reset itself
	   *   $animate.leave(kids[5]); //stagger index=0
	   *   $animate.leave(kids[6]); //stagger index=1
	   *
	   *   $scope.$digest();
	   * });
	   * ```
	   *
	   * Stagger animations are currently only supported within CSS-defined animations.
	   *
	   * ### The `ng-animate` CSS class
	   *
	   * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	   * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	   *
	   * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	   *
	   * ```css
	   * .zipper.ng-animate {
	   *   transition:0.5s linear all;
	   * }
	   * .zipper.ng-enter {
	   *   opacity:0;
	   * }
	   * .zipper.ng-enter.ng-enter-active {
	   *   opacity:1;
	   * }
	   * .zipper.ng-leave {
	   *   opacity:1;
	   * }
	   * .zipper.ng-leave.ng-leave-active {
	   *   opacity:0;
	   * }
	   * ```
	   *
	   * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	   * the CSS class once an animation has completed.)
	   *
	   *
	   * ### The `ng-[event]-prepare` class
	   *
	   * This is a special class that can be used to prevent unwanted flickering / flash of content before
	   * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	   * before the actual animation starts (after waiting for a $digest).
	   * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	   *
	   * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	   * into elements that have class-based animations such as `ngClass`.
	   *
	   * ```html
	   * <div ng-class="{red: myProp}">
	   *   <div ng-class="{blue: myProp}">
	   *     <div class="message" ng-if="myProp"></div>
	   *   </div>
	   * </div>
	   * ```
	   *
	   * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	   * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	   *
	   * ```css
	   * .message.ng-enter-prepare {
	   *   opacity: 0;
	   * }
	   *
	   * ```
	   *
	   * ## JavaScript-based Animations
	   *
	   * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	   * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	   * `module.animation()` module function we can register the animation.
	   *
	   * Let's see an example of a enter/leave animation using `ngRepeat`:
	   *
	   * ```html
	   * <div ng-repeat="item in items" class="slide">
	   *   {{ item }}
	   * </div>
	   * ```
	   *
	   * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	   *
	   * ```js
	   * myModule.animation('.slide', [function() {
	   *   return {
	   *     // make note that other events (like addClass/removeClass)
	   *     // have different function input parameters
	   *     enter: function(element, doneFn) {
	   *       jQuery(element).fadeIn(1000, doneFn);
	   *
	   *       // remember to call doneFn so that AngularJS
	   *       // knows that the animation has concluded
	   *     },
	   *
	   *     move: function(element, doneFn) {
	   *       jQuery(element).fadeIn(1000, doneFn);
	   *     },
	   *
	   *     leave: function(element, doneFn) {
	   *       jQuery(element).fadeOut(1000, doneFn);
	   *     }
	   *   }
	   * }]);
	   * ```
	   *
	   * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	   * greensock.js and velocity.js.
	   *
	   * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	   * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	   *
	   * ```html
	   * <div ng-class="color" class="colorful">
	   *   this box is moody
	   * </div>
	   * <button ng-click="color='red'">Change to red</button>
	   * <button ng-click="color='blue'">Change to blue</button>
	   * <button ng-click="color='green'">Change to green</button>
	   * ```
	   *
	   * ```js
	   * myModule.animation('.colorful', [function() {
	   *   return {
	   *     addClass: function(element, className, doneFn) {
	   *       // do some cool animation and call the doneFn
	   *     },
	   *     removeClass: function(element, className, doneFn) {
	   *       // do some cool animation and call the doneFn
	   *     },
	   *     setClass: function(element, addedClass, removedClass, doneFn) {
	   *       // do some cool animation and call the doneFn
	   *     }
	   *   }
	   * }]);
	   * ```
	   *
	   * ## CSS + JS Animations Together
	   *
	   * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
	   * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	   * charge of the animation**:
	   *
	   * ```html
	   * <div ng-if="bool" class="slide">
	   *   Slide in and out
	   * </div>
	   * ```
	   *
	   * ```js
	   * myModule.animation('.slide', [function() {
	   *   return {
	   *     enter: function(element, doneFn) {
	   *       jQuery(element).slideIn(1000, doneFn);
	   *     }
	   *   }
	   * }]);
	   * ```
	   *
	   * ```css
	   * .slide.ng-enter {
	   *   transition:0.5s linear all;
	   *   transform:translateY(-100px);
	   * }
	   * .slide.ng-enter.ng-enter-active {
	   *   transform:translateY(0);
	   * }
	   * ```
	   *
	   * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	   * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	   * our own JS-based animation code:
	   *
	   * ```js
	   * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	   *   return {
	   *     enter: function(element) {
	  *        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	   *       return $animateCss(element, {
	   *         event: 'enter',
	   *         structural: true
	   *       });
	   *     }
	   *   }
	   * }]);
	   * ```
	   *
	   * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	   *
	   * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	   * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	   * data into `$animateCss` directly:
	   *
	   * ```js
	   * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	   *   return {
	   *     enter: function(element) {
	   *       return $animateCss(element, {
	   *         event: 'enter',
	   *         structural: true,
	   *         addClass: 'maroon-setting',
	   *         from: { height:0 },
	   *         to: { height: 200 }
	   *       });
	   *     }
	   *   }
	   * }]);
	   * ```
	   *
	   * Now we can fill in the rest via our transition CSS code:
	   *
	   * ```css
	   * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	   * .slide.ng-enter { transition:0.5s linear all; }
	   *
	   * /&#42; this extra CSS class will be absorbed into the transition
	   * since the $animateCss code is adding the class &#42;/
	   * .maroon-setting { background:red; }
	   * ```
	   *
	   * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	   *
	   * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	   *
	   * ## Animation Anchoring (via `ng-animate-ref`)
	   *
	   * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	   * structural areas of an application (like views) by pairing up elements using an attribute
	   * called `ng-animate-ref`.
	   *
	   * Let's say for example we have two views that are managed by `ng-view` and we want to show
	   * that there is a relationship between two components situated in within these views. By using the
	   * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	   * can then attach an animation, which is triggered when the view changes.
	   *
	   * Say for example we have the following template code:
	   *
	   * ```html
	   * <!-- index.html -->
	   * <div ng-view class="view-animation">
	   * </div>
	   *
	   * <!-- home.html -->
	   * <a href="#/banner-page">
	   *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	   * </a>
	   *
	   * <!-- banner-page.html -->
	   * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	   * ```
	   *
	   * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	   * HTML contents to see if there is a match reference between any components in the view
	   * that is leaving and the view that is entering. It will scan both the view which is being
	   * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	   * contain a matching ref value.
	   *
	   * The two images match since they share the same ref value. ngAnimate will now create a
	   * transport element (which is a clone of the first image element) and it will then attempt
	   * to animate to the position of the second image element in the next view. For the animation to
	   * work a special CSS class called `ng-anchor` will be added to the transported element.
	   *
	   * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	   * ngAnimate will handle the entire transition for us as well as the addition and removal of
	   * any changes of CSS classes between the elements:
	   *
	   * ```css
	   * .banner.ng-anchor {
	   *   /&#42; this animation will last for 1 second since there are
	   *          two phases to the animation (an `in` and an `out` phase) &#42;/
	   *   transition:0.5s linear all;
	   * }
	   * ```
	   *
	   * We also **must** include animations for the views that are being entered and removed
	   * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	   *
	   * ```css
	   * .view-animation.ng-enter, .view-animation.ng-leave {
	   *   transition:0.5s linear all;
	   *   position:fixed;
	   *   left:0;
	   *   top:0;
	   *   width:100%;
	   * }
	   * .view-animation.ng-enter {
	   *   transform:translateX(100%);
	   * }
	   * .view-animation.ng-leave,
	   * .view-animation.ng-enter.ng-enter-active {
	   *   transform:translateX(0%);
	   * }
	   * .view-animation.ng-leave.ng-leave-active {
	   *   transform:translateX(-100%);
	   * }
	   * ```
	   *
	   * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	   * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	   * from its origin. Once that animation is over then the `in` stage occurs which animates the
	   * element to its destination. The reason why there are two animations is to give enough time
	   * for the enter animation on the new element to be ready.
	   *
	   * The example above sets up a transition for both the in and out phases, but we can also target the out or
	   * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	   *
	   * ```css
	   * .banner.ng-anchor-out {
	   *   transition: 0.5s linear all;
	   *
	   *   /&#42; the scale will be applied during the out animation,
	   *          but will be animated away when the in animation runs &#42;/
	   *   transform: scale(1.2);
	   * }
	   *
	   * .banner.ng-anchor-in {
	   *   transition: 1s linear all;
	   * }
	   * ```
	   *
	   *
	   *
	   *
	   * ### Anchoring Demo
	   *
	    <example module="anchoringExample"
	             name="anchoringExample"
	             id="anchoringExample"
	             deps="angular-animate.js;angular-route.js"
	             animations="true">
	      <file name="index.html">
	        <a href="#!/">Home</a>
	        <hr />
	        <div class="view-container">
	          <div ng-view class="view"></div>
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	          .config(['$routeProvider', function($routeProvider) {
	            $routeProvider.when('/', {
	              templateUrl: 'home.html',
	              controller: 'HomeController as home'
	            });
	            $routeProvider.when('/profile/:id', {
	              templateUrl: 'profile.html',
	              controller: 'ProfileController as profile'
	            });
	          }])
	          .run(['$rootScope', function($rootScope) {
	            $rootScope.records = [
	              { id: 1, title: 'Miss Beulah Roob' },
	              { id: 2, title: 'Trent Morissette' },
	              { id: 3, title: 'Miss Ava Pouros' },
	              { id: 4, title: 'Rod Pouros' },
	              { id: 5, title: 'Abdul Rice' },
	              { id: 6, title: 'Laurie Rutherford Sr.' },
	              { id: 7, title: 'Nakia McLaughlin' },
	              { id: 8, title: 'Jordon Blanda DVM' },
	              { id: 9, title: 'Rhoda Hand' },
	              { id: 10, title: 'Alexandrea Sauer' }
	            ];
	          }])
	          .controller('HomeController', [function() {
	            //empty
	          }])
	          .controller('ProfileController', ['$rootScope', '$routeParams',
	              function ProfileController($rootScope, $routeParams) {
	            var index = parseInt($routeParams.id, 10);
	            var record = $rootScope.records[index - 1];
	  
	            this.title = record.title;
	            this.id = record.id;
	          }]);
	      </file>
	      <file name="home.html">
	        <h2>Welcome to the home page</h1>
	        <p>Please click on an element</p>
	        <a class="record"
	           ng-href="#!/profile/{{ record.id }}"
	           ng-animate-ref="{{ record.id }}"
	           ng-repeat="record in records">
	          {{ record.title }}
	        </a>
	      </file>
	      <file name="profile.html">
	        <div class="profile record" ng-animate-ref="{{ profile.id }}">
	          {{ profile.title }}
	        </div>
	      </file>
	      <file name="animations.css">
	        .record {
	          display:block;
	          font-size:20px;
	        }
	        .profile {
	          background:black;
	          color:white;
	          font-size:100px;
	        }
	        .view-container {
	          position:relative;
	        }
	        .view-container > .view.ng-animate {
	          position:absolute;
	          top:0;
	          left:0;
	          width:100%;
	          min-height:500px;
	        }
	        .view.ng-enter, .view.ng-leave,
	        .record.ng-anchor {
	          transition:0.5s linear all;
	        }
	        .view.ng-enter {
	          transform:translateX(100%);
	        }
	        .view.ng-enter.ng-enter-active, .view.ng-leave {
	          transform:translateX(0%);
	        }
	        .view.ng-leave.ng-leave-active {
	          transform:translateX(-100%);
	        }
	        .record.ng-anchor-out {
	          background:red;
	        }
	      </file>
	    </example>
	   *
	   * ### How is the element transported?
	   *
	   * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	   * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	   * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	   * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	   * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	   * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	   * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	   * will become visible since the shim class will be removed.
	   *
	   * ### How is the morphing handled?
	   *
	   * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	   * what CSS classes differ between the starting element and the destination element. These different CSS classes
	   * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	   * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	   * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	   * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	   * the cloned element is placed inside of root element which is likely close to the body element).
	   *
	   * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	   *
	   *
	   * ## Using $animate in your directive code
	   *
	   * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
	   * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	   * imagine we have a greeting box that shows and hides itself when the data changes
	   *
	   * ```html
	   * <greeting-box active="onOrOff">Hi there</greeting-box>
	   * ```
	   *
	   * ```js
	   * ngModule.directive('greetingBox', ['$animate', function($animate) {
	   *   return function(scope, element, attrs) {
	   *     attrs.$observe('active', function(value) {
	   *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	   *     });
	   *   });
	   * }]);
	   * ```
	   *
	   * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	   * in our HTML code then we can trigger a CSS or JS animation to happen.
	   *
	   * ```css
	   * /&#42; normally we would create a CSS class to reference on the element &#42;/
	   * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	   * ```
	   *
	   * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	   * possible be sure to visit the {@link ng.$animate $animate service API page}.
	   *
	   *
	   * ## Callbacks and Promises
	   *
	   * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	   * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	   * ended by chaining onto the returned promise that animation method returns.
	   *
	   * ```js
	   * // somewhere within the depths of the directive
	   * $animate.enter(element, parent).then(function() {
	   *   //the animation has completed
	   * });
	   * ```
	   *
	   * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	   * anymore.)
	   *
	   * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	   * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	   * routing controller to hook into that:
	   *
	   * ```js
	   * ngModule.controller('HomePageController', ['$animate', function($animate) {
	   *   $animate.on('enter', ngViewElement, function(element) {
	   *     // the animation for this route has completed
	   *   }]);
	   * }])
	   * ```
	   *
	   * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
	   */
	
	  var copy;
	  var extend;
	  var forEach;
	  var isArray;
	  var isDefined;
	  var isElement;
	  var isFunction;
	  var isObject;
	  var isString;
	  var isUndefined;
	  var jqLite;
	  var noop;
	
	  /**
	   * @ngdoc service
	   * @name $animate
	   * @kind object
	   *
	   * @description
	   * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	   *
	   * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	   */
	  angular.module('ngAnimate', [], function initAngularHelpers() {
	    // Access helpers from AngularJS core.
	    // Do it inside a `config` block to ensure `window.angular` is available.
	    noop = angular.noop;
	    copy = angular.copy;
	    extend = angular.extend;
	    jqLite = angular.element;
	    forEach = angular.forEach;
	    isArray = angular.isArray;
	    isString = angular.isString;
	    isObject = angular.isObject;
	    isUndefined = angular.isUndefined;
	    isDefined = angular.isDefined;
	    isFunction = angular.isFunction;
	    isElement = angular.isElement;
	  }).info({ angularVersion: '1.6.9' }).directive('ngAnimateSwap', ngAnimateSwapDirective).directive('ngAnimateChildren', $$AnimateChildrenDirective).factory('$$rAFScheduler', $$rAFSchedulerFactory).provider('$$animateQueue', $$AnimateQueueProvider).provider('$$animation', $$AnimationProvider).provider('$animateCss', $AnimateCssProvider).provider('$$animateCssDriver', $$AnimateCssDriverProvider).provider('$$animateJs', $$AnimateJsProvider).provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	})(window, window.angular);

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(212);
	module.exports = 'ngAnimate';

/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function (window, angular) {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name ngAria
	   * @description
	   *
	   * The `ngAria` module provides support for common
	   * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
	   * attributes that convey state or semantic information about the application for users
	   * of assistive technologies, such as screen readers.
	   *
	   * ## Usage
	   *
	   * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
	   * directives are supported:
	   * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
	   * `ngDblClick`, and `ngMessages`.
	   *
	   * Below is a more detailed breakdown of the attributes handled by ngAria:
	   *
	   * | Directive                                   | Supported Attributes                                                                                |
	   * |---------------------------------------------|-----------------------------------------------------------------------------------------------------|
	   * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
	   * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                                       |
	   * | {@link ng.directive:ngRequired ngRequired}  | aria-required                                                                                       |
	   * | {@link ng.directive:ngChecked ngChecked}    | aria-checked                                                                                        |
	   * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                                       |
	   * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                                        |
	   * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                                         |
	   * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                                         |
	   * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                                            |
	   * | {@link module:ngMessages ngMessages}        | aria-live                                                                                           |
	   * | {@link ng.directive:ngClick ngClick}        | tabindex, keydown event, button role                                                                |
	   *
	   * Find out more information about each directive by reading the
	   * {@link guide/accessibility ngAria Developer Guide}.
	   *
	   * ## Example
	   * Using ngDisabled with ngAria:
	   * ```html
	   * <md-checkbox ng-disabled="disabled">
	   * ```
	   * Becomes:
	   * ```html
	   * <md-checkbox ng-disabled="disabled" aria-disabled="true">
	   * ```
	   *
	   * ## Disabling Attributes
	   * It's possible to disable individual attributes added by ngAria with the
	   * {@link ngAria.$ariaProvider#config config} method. For more details, see the
	   * {@link guide/accessibility Developer Guide}.
	   */
	
	  var ngAriaModule = angular.module('ngAria', ['ng']).info({ angularVersion: '1.6.9' }).provider('$aria', $AriaProvider);
	
	  /**
	  * Internal Utilities
	  */
	  var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];
	
	  var isNodeOneOf = function isNodeOneOf(elem, nodeTypeArray) {
	    if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
	      return true;
	    }
	  };
	  /**
	   * @ngdoc provider
	   * @name $ariaProvider
	   * @this
	   *
	   * @description
	   *
	   * Used for configuring the ARIA attributes injected and managed by ngAria.
	   *
	   * ```js
	   * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
	   *   $ariaProvider.config({
	   *     ariaValue: true,
	   *     tabindex: false
	   *   });
	   * });
	   *```
	   *
	   * ## Dependencies
	   * Requires the {@link ngAria} module to be installed.
	   *
	   */
	  function $AriaProvider() {
	    var _config = {
	      ariaHidden: true,
	      ariaChecked: true,
	      ariaReadonly: true,
	      ariaDisabled: true,
	      ariaRequired: true,
	      ariaInvalid: true,
	      ariaValue: true,
	      tabindex: true,
	      bindKeydown: true,
	      bindRoleForClick: true
	    };
	
	    /**
	     * @ngdoc method
	     * @name $ariaProvider#config
	     *
	     * @param {object} config object to enable/disable specific ARIA attributes
	     *
	     *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
	     *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
	     *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
	     *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
	     *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
	     *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
	     *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and
	     *    aria-valuenow tags
	     *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
	     *  - **bindKeydown** – `{boolean}` – Enables/disables keyboard event binding on non-interactive
	     *    elements (such as `div` or `li`) using ng-click, making them more accessible to users of
	     *    assistive technologies
	     *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements (such as
	     *    `div` or `li`) using ng-click, making them more accessible to users of assistive
	     *    technologies
	     *
	     * @description
	     * Enables/disables various ARIA attributes
	     */
	    this.config = function (newConfig) {
	      _config = angular.extend(_config, newConfig);
	    };
	
	    function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
	      return function (scope, elem, attr) {
	        var ariaCamelName = attr.$normalize(ariaAttr);
	        if (_config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
	          scope.$watch(attr[attrName], function (boolVal) {
	            // ensure boolean value
	            boolVal = negate ? !boolVal : !!boolVal;
	            elem.attr(ariaAttr, boolVal);
	          });
	        }
	      };
	    }
	    /**
	     * @ngdoc service
	     * @name $aria
	     *
	     * @description
	     * @priority 200
	     *
	     * The $aria service contains helper methods for applying common
	     * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
	     *
	     * ngAria injects common accessibility attributes that tell assistive technologies when HTML
	     * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
	     * let's review a code snippet from ngAria itself:
	     *
	     *```js
	     * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
	     *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	     * }])
	     *```
	     * Shown above, the ngAria module creates a directive with the same signature as the
	     * traditional `ng-disabled` directive. But this ngAria version is dedicated to
	     * solely managing accessibility attributes on custom elements. The internal `$aria` service is
	     * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
	     * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
	     * value in `ngDisabled`.
	     *
	     * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
	     * anything to enable this feature. The `aria-disabled` attribute is automatically managed
	     * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
	     *
	     * The full list of directives that interface with ngAria:
	     * * **ngModel**
	     * * **ngChecked**
	     * * **ngReadonly**
	     * * **ngRequired**
	     * * **ngDisabled**
	     * * **ngValue**
	     * * **ngShow**
	     * * **ngHide**
	     * * **ngClick**
	     * * **ngDblclick**
	     * * **ngMessages**
	     *
	     * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
	     * directive.
	     *
	     *
	     * ## Dependencies
	     * Requires the {@link ngAria} module to be installed.
	     */
	    this.$get = function () {
	      return {
	        config: function config(key) {
	          return _config[key];
	        },
	        $$watchExpr: watchExpr
	      };
	    };
	  }
	
	  ngAriaModule.directive('ngShow', ['$aria', function ($aria) {
	    return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
	  }]).directive('ngHide', ['$aria', function ($aria) {
	    return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
	  }]).directive('ngValue', ['$aria', function ($aria) {
	    return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
	  }]).directive('ngChecked', ['$aria', function ($aria) {
	    return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
	  }]).directive('ngReadonly', ['$aria', function ($aria) {
	    return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
	  }]).directive('ngRequired', ['$aria', function ($aria) {
	    return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
	  }]).directive('ngModel', ['$aria', function ($aria) {
	
	    function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
	      return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
	    }
	
	    function shouldAttachRole(role, elem) {
	      // if element does not have role attribute
	      // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
	      // AND element is not in nodeBlackList
	      return !elem.attr('role') && elem.attr('type') === role && !isNodeOneOf(elem, nodeBlackList);
	    }
	
	    function getShape(attr, elem) {
	      var type = attr.type,
	          role = attr.role;
	
	      return (type || role) === 'checkbox' || role === 'menuitemcheckbox' ? 'checkbox' : (type || role) === 'radio' || role === 'menuitemradio' ? 'radio' : type === 'range' || role === 'progressbar' || role === 'slider' ? 'range' : '';
	    }
	
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
	      compile: function compile(elem, attr) {
	        var shape = getShape(attr, elem);
	
	        return {
	          post: function post(scope, elem, attr, ngModel) {
	            var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);
	
	            function ngAriaWatchModelValue() {
	              return ngModel.$modelValue;
	            }
	
	            function getRadioReaction(newVal) {
	              // Strict comparison would cause a BC
	              // eslint-disable-next-line eqeqeq
	              var boolVal = attr.value == ngModel.$viewValue;
	              elem.attr('aria-checked', boolVal);
	            }
	
	            function getCheckboxReaction() {
	              elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
	            }
	
	            switch (shape) {
	              case 'radio':
	              case 'checkbox':
	                if (shouldAttachRole(shape, elem)) {
	                  elem.attr('role', shape);
	                }
	                if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
	                  scope.$watch(ngAriaWatchModelValue, shape === 'radio' ? getRadioReaction : getCheckboxReaction);
	                }
	                if (needsTabIndex) {
	                  elem.attr('tabindex', 0);
	                }
	                break;
	              case 'range':
	                if (shouldAttachRole(shape, elem)) {
	                  elem.attr('role', 'slider');
	                }
	                if ($aria.config('ariaValue')) {
	                  var needsAriaValuemin = !elem.attr('aria-valuemin') && (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
	                  var needsAriaValuemax = !elem.attr('aria-valuemax') && (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
	                  var needsAriaValuenow = !elem.attr('aria-valuenow');
	
	                  if (needsAriaValuemin) {
	                    attr.$observe('min', function ngAriaValueMinReaction(newVal) {
	                      elem.attr('aria-valuemin', newVal);
	                    });
	                  }
	                  if (needsAriaValuemax) {
	                    attr.$observe('max', function ngAriaValueMinReaction(newVal) {
	                      elem.attr('aria-valuemax', newVal);
	                    });
	                  }
	                  if (needsAriaValuenow) {
	                    scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
	                      elem.attr('aria-valuenow', newVal);
	                    });
	                  }
	                }
	                if (needsTabIndex) {
	                  elem.attr('tabindex', 0);
	                }
	                break;
	            }
	
	            if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
	              // ngModel.$error.required is undefined on custom controls
	              attr.$observe('required', function () {
	                elem.attr('aria-required', !!attr['required']);
	              });
	            }
	
	            if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
	              scope.$watch(function ngAriaInvalidWatch() {
	                return ngModel.$invalid;
	              }, function ngAriaInvalidReaction(newVal) {
	                elem.attr('aria-invalid', !!newVal);
	              });
	            }
	          }
	        };
	      }
	    };
	  }]).directive('ngDisabled', ['$aria', function ($aria) {
	    return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	  }]).directive('ngMessages', function () {
	    return {
	      restrict: 'A',
	      require: '?ngMessages',
	      link: function link(scope, elem, attr, ngMessages) {
	        if (!elem.attr('aria-live')) {
	          elem.attr('aria-live', 'assertive');
	        }
	      }
	    };
	  }).directive('ngClick', ['$aria', '$parse', function ($aria, $parse) {
	    return {
	      restrict: 'A',
	      compile: function compile(elem, attr) {
	        var fn = $parse(attr.ngClick);
	        return function (scope, elem, attr) {
	
	          if (!isNodeOneOf(elem, nodeBlackList)) {
	
	            if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
	              elem.attr('role', 'button');
	            }
	
	            if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	              elem.attr('tabindex', 0);
	            }
	
	            if ($aria.config('bindKeydown') && !attr.ngKeydown && !attr.ngKeypress && !attr.ngKeyup) {
	              elem.on('keydown', function (event) {
	                var keyCode = event.which || event.keyCode;
	                if (keyCode === 32 || keyCode === 13) {
	                  scope.$apply(callback);
	                }
	
	                function callback() {
	                  fn(scope, { $event: event });
	                }
	              });
	            }
	          }
	        };
	      }
	    };
	  }]).directive('ngDblclick', ['$aria', function ($aria) {
	    return function (scope, elem, attr) {
	      if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
	        elem.attr('tabindex', 0);
	      }
	    };
	  }]);
	})(window, window.angular);

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(214);
	module.exports = 'ngAria';

/***/ },
/* 216 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function (window, angular) {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name ngCookies
	   * @description
	   *
	   * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	   *
	   * See {@link ngCookies.$cookies `$cookies`} for usage.
	   */
	
	  angular.module('ngCookies', ['ng']).info({ angularVersion: '1.6.9' }).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	  provider('$cookies', [/** @this */function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesProviderExample', ['ngCookies'])
	     *   .config(['$cookiesProvider', function($cookiesProvider) {
	     *     // Setting default options
	     *     $cookiesProvider.defaults.domain = 'foo.com';
	     *     $cookiesProvider.defaults.secure = true;
	     *   }]);
	     * ```
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function ($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function get(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function getObject(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function getAll() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function put(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function putObject(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function remove(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	  angular.module('ngCookies').
	  /**
	   * @ngdoc service
	   * @name $cookieStore
	   * @deprecated
	   * sinceVersion="v1.4.0"
	   * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	   *
	   * @requires $cookies
	   *
	   * @description
	   * Provides a key-value (string-object) storage, that is backed by session cookies.
	   * Objects put or retrieved from this storage are automatically serialized or
	   * deserialized by AngularJS's `toJson`/`fromJson`.
	   *
	   * Requires the {@link ngCookies `ngCookies`} module to be installed.
	   *
	   * @example
	   *
	   * ```js
	   * angular.module('cookieStoreExample', ['ngCookies'])
	   *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	   *     // Put cookie
	   *     $cookieStore.put('myFavorite','oatmeal');
	   *     // Get cookie
	   *     var favoriteCookie = $cookieStore.get('myFavorite');
	   *     // Removing a cookie
	   *     $cookieStore.remove('myFavorite');
	   *   }]);
	   * ```
	   */
	  factory('$cookieStore', ['$cookies', function ($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function get(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function put(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function remove(key) {
	        $cookies.remove(key);
	      }
	    };
	  }]);
	
	  /**
	   * @name $$cookieWriter
	   * @requires $document
	   *
	   * @description
	   * This is a private service for writing cookies
	   *
	   * @param {string} name Cookie name
	   * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	   * @param {Object=} options Object with options that need to be stored for the cookie.
	   */
	  function $$CookieWriter($document, $log, $browser) {
	    var cookiePath = $browser.baseHref();
	    var rawDocument = $document[0];
	
	    function buildCookieString(name, value, options) {
	      var path, expires;
	      options = options || {};
	      expires = options.expires;
	      path = angular.isDefined(options.path) ? options.path : cookiePath;
	      if (angular.isUndefined(value)) {
	        expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	        value = '';
	      }
	      if (angular.isString(expires)) {
	        expires = new Date(expires);
	      }
	
	      var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	      str += path ? ';path=' + path : '';
	      str += options.domain ? ';domain=' + options.domain : '';
	      str += expires ? ';expires=' + expires.toUTCString() : '';
	      str += options.secure ? ';secure' : '';
	
	      // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	      // - 300 cookies
	      // - 20 cookies per unique domain
	      // - 4096 bytes per cookie
	      var cookieLength = str.length + 1;
	      if (cookieLength > 4096) {
	        $log.warn('Cookie \'' + name + '\' possibly not set or overflowed because it was too large (' + cookieLength + ' > 4096 bytes)!');
	      }
	
	      return str;
	    }
	
	    return function (name, value, options) {
	      rawDocument.cookie = buildCookieString(name, value, options);
	    };
	  }
	
	  $$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	  angular.module('ngCookies').provider('$$cookieWriter', /** @this */function $$CookieWriterProvider() {
	    this.$get = $$CookieWriter;
	  });
	})(window, window.angular);

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(216);
	module.exports = 'ngCookies';

/***/ },
/* 218 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 * Angular Material Data Table
	 * https://github.com/daniel-nagy/md-data-table
	 * @license MIT
	 * v0.10.9
	 */
	(function (window, angular, undefined) {
	  'use strict';
	
	  angular.module('md.table.templates', ['md-table-pagination.html', 'md-table-progress.html', 'arrow-up.svg', 'navigate-before.svg', 'navigate-first.svg', 'navigate-last.svg', 'navigate-next.svg']);
	
	  angular.module('md-table-pagination.html', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('md-table-pagination.html', '<div class="page-select" ng-if="$pagination.showPageSelect()">\n' + '  <div class="label">{{$pagination.label.page}}</div>\n' + '\n' + '  <md-select virtual-page-select total="{{$pagination.pages()}}" class="md-table-select" ng-model="$pagination.page" md-container-class="md-pagination-select" ng-change="$pagination.onPaginationChange()" ng-disabled="$pagination.disabled" aria-label="Page">\n' + '    <md-content>\n' + '      <md-option ng-repeat="page in $pageSelect.pages" ng-value="page">{{page}}</md-option>\n' + '    </md-content>\n' + '  </md-select>\n' + '</div>\n' + '\n' + '<div class="limit-select" ng-if="$pagination.limitOptions">\n' + '  <div class="label">{{$pagination.label.rowsPerPage}}</div>\n' + '\n' + '  <md-select class="md-table-select" ng-model="$pagination.limit" md-container-class="md-pagination-select" ng-disabled="$pagination.disabled" aria-label="Rows" placeholder="{{ $pagination.limitOptions[0] }}">\n' + '    <md-option ng-repeat="option in $pagination.limitOptions" ng-value="option.value ? $pagination.eval(option.value) : option">{{::option.label ? option.label : option}}</md-option>\n' + '  </md-select>\n' + '</div>\n' + '\n' + '<div class="buttons">\n' + '  <div class="label">{{$pagination.min()}} - {{$pagination.max()}} {{$pagination.label.of}} {{$pagination.total}}</div>\n' + '\n' + '  <md-button class="md-icon-button" type="button" ng-if="$pagination.showBoundaryLinks()" ng-click="$pagination.first()" ng-disabled="$pagination.disabled || !$pagination.hasPrevious()" aria-label="First">\n' + '    <md-icon md-svg-icon="navigate-first.svg"></md-icon>\n' + '  </md-button>\n' + '\n' + '  <md-button class="md-icon-button" type="button" ng-click="$pagination.previous()" ng-disabled="$pagination.disabled || !$pagination.hasPrevious()" aria-label="Previous">\n' + '    <md-icon md-svg-icon="navigate-before.svg"></md-icon>\n' + '  </md-button>\n' + '\n' + '  <md-button class="md-icon-button" type="button" ng-click="$pagination.next()" ng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Next">\n' + '    <md-icon md-svg-icon="navigate-next.svg"></md-icon>\n' + '  </md-button>\n' + '\n' + '  <md-button class="md-icon-button" type="button" ng-if="$pagination.showBoundaryLinks()" ng-click="$pagination.last()" ng-disabled="$pagination.disabled || !$pagination.hasNext()" aria-label="Last">\n' + '    <md-icon md-svg-icon="navigate-last.svg"></md-icon>\n' + '  </md-button>\n' + '</div>');
	  }]);
	
	  angular.module('md-table-progress.html', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('md-table-progress.html', '<tr>\n' + '  <th colspan="{{columnCount()}}">\n' + '    <md-progress-linear ng-show="deferred()" md-mode="indeterminate"></md-progress-linear>\n' + '  </th>\n' + '</tr>');
	  }]);
	
	  angular.module('arrow-up.svg', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('arrow-up.svg', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>');
	  }]);
	
	  angular.module('navigate-before.svg', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('navigate-before.svg', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>');
	  }]);
	
	  angular.module('navigate-first.svg', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('navigate-first.svg', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 6 v12 h2 v-12 h-2z M17.41 7.41L16 6l-6 6 6 6 1.41-1.41L12.83 12z"/></svg>');
	  }]);
	
	  angular.module('navigate-last.svg', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('navigate-last.svg', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 6 v12 h2 v-12 h-2z M8 6L6.59 7.41 11.17 12l-4.58 4.59L8 18l6-6z"/></svg>');
	  }]);
	
	  angular.module('navigate-next.svg', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('navigate-next.svg', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>');
	  }]);
	
	  angular.module('md.data.table', ['md.table.templates']);
	
	  angular.module('md.data.table').directive('mdBody', mdBody);
	
	  function mdBody() {
	
	    function compile(tElement) {
	      tElement.addClass('md-body');
	    }
	
	    return {
	      compile: compile,
	      restrict: 'A'
	    };
	  }
	
	  angular.module('md.data.table').directive('mdCell', mdCell);
	
	  function mdCell() {
	
	    function compile(tElement) {
	      var select = tElement.find('md-select');
	
	      if (select.length) {
	        select.addClass('md-table-select').attr('md-container-class', 'md-table-select');
	      }
	
	      tElement.addClass('md-cell');
	
	      return postLink;
	    }
	
	    // empty controller to be bind properties to in postLink function
	    function Controller() {}
	
	    function postLink(scope, element, attrs, ctrls) {
	      var select = element.find('md-select');
	      var cellCtrl = ctrls.shift();
	      var tableCtrl = ctrls.shift();
	
	      if (attrs.ngClick) {
	        element.addClass('md-clickable');
	      }
	
	      if (select.length) {
	        select.on('click', function (event) {
	          event.stopPropagation();
	        });
	
	        element.addClass('md-clickable').on('click', function (event) {
	          event.stopPropagation();
	          select[0].click();
	        });
	      }
	
	      cellCtrl.getTable = tableCtrl.getElement;
	
	      function getColumn() {
	        return tableCtrl.$$columns[getIndex()];
	      }
	
	      function getIndex() {
	        return Array.prototype.indexOf.call(element.parent().children(), element[0]);
	      }
	
	      scope.$watch(getColumn, function (column) {
	        if (!column) {
	          return;
	        }
	
	        if (column.numeric) {
	          element.addClass('md-numeric');
	        } else {
	          element.removeClass('md-numeric');
	        }
	      });
	    }
	
	    return {
	      controller: Controller,
	      compile: compile,
	      require: ['mdCell', '^^mdTable'],
	      restrict: 'A'
	    };
	  }
	
	  angular.module('md.data.table').directive('mdColumn', mdColumn);
	
	  function mdColumn($compile, $mdUtil) {
	
	    function compile(tElement) {
	      tElement.addClass('md-column');
	      return postLink;
	    }
	
	    function postLink(scope, element, attrs, ctrls) {
	      var headCtrl = ctrls.shift();
	      var tableCtrl = ctrls.shift();
	
	      function attachSortIcon() {
	        var sortIcon = angular.element('<md-icon md-svg-icon="arrow-up.svg">');
	
	        $compile(sortIcon.addClass('md-sort-icon').attr('ng-class', 'getDirection()'))(scope);
	
	        if (element.hasClass('md-numeric')) {
	          element.prepend(sortIcon);
	        } else {
	          element.append(sortIcon);
	        }
	      }
	
	      function detachSortIcon() {
	        Array.prototype.some.call(element.find('md-icon'), function (icon) {
	          return icon.classList.contains('md-sort-icon') && element[0].removeChild(icon);
	        });
	      }
	
	      function disableSorting() {
	        detachSortIcon();
	        element.removeClass('md-sort').off('click', setOrder);
	      }
	
	      function enableSorting() {
	        attachSortIcon();
	        element.addClass('md-sort').on('click', setOrder);
	      }
	
	      function getIndex() {
	        return Array.prototype.indexOf.call(element.parent().children(), element[0]);
	      }
	
	      function isActive() {
	        return scope.orderBy && (headCtrl.order === scope.orderBy || headCtrl.order === '-' + scope.orderBy);
	      }
	
	      function isNumeric() {
	        return attrs.mdNumeric === '' || scope.numeric;
	      }
	
	      function setOrder() {
	        scope.$applyAsync(function () {
	          if (isActive()) {
	            headCtrl.order = scope.getDirection() === 'md-asc' ? '-' + scope.orderBy : scope.orderBy;
	          } else {
	            headCtrl.order = scope.getDirection() === 'md-asc' ? scope.orderBy : '-' + scope.orderBy;
	          }
	
	          if (angular.isFunction(headCtrl.onReorder)) {
	            $mdUtil.nextTick(function () {
	              headCtrl.onReorder(headCtrl.order);
	            });
	          }
	        });
	      }
	
	      function updateColumn(index, column) {
	        tableCtrl.$$columns[index] = column;
	
	        if (column.numeric) {
	          element.addClass('md-numeric');
	        } else {
	          element.removeClass('md-numeric');
	        }
	      }
	
	      scope.getDirection = function () {
	        if (isActive()) {
	          return headCtrl.order.charAt(0) === '-' ? 'md-desc' : 'md-asc';
	        }
	
	        return attrs.mdDesc === '' || scope.$eval(attrs.mdDesc) ? 'md-desc' : 'md-asc';
	      };
	
	      scope.$watch(isActive, function (active) {
	        if (active) {
	          element.addClass('md-active');
	        } else {
	          element.removeClass('md-active');
	        }
	      });
	
	      scope.$watch(getIndex, function (index) {
	        updateColumn(index, { 'numeric': isNumeric() });
	      });
	
	      scope.$watch(isNumeric, function (numeric) {
	        updateColumn(getIndex(), { 'numeric': numeric });
	      });
	
	      scope.$watch('orderBy', function (orderBy) {
	        if (orderBy) {
	          if (!element.hasClass('md-sort')) {
	            enableSorting();
	          }
	        } else if (element.hasClass('md-sort')) {
	          disableSorting();
	        }
	      });
	    }
	
	    return {
	      compile: compile,
	      require: ['^^mdHead', '^^mdTable'],
	      restrict: 'A',
	      scope: {
	        numeric: '=?mdNumeric',
	        orderBy: '@?mdOrderBy'
	      }
	    };
	  }
	
	  mdColumn.$inject = ['$compile', '$mdUtil'];
	
	  angular.module('md.data.table').decorator('$controller', controllerDecorator).factory('$mdEditDialog', mdEditDialog);
	
	  /*
	   * A decorator for ng.$controller to optionally bind properties to the
	   * controller before invoking the constructor. Stolen from the ngMock.
	   *
	   * https://docs.angularjs.org/api/ngMock/service/$controller
	   */
	  function controllerDecorator($delegate) {
	    return function (expression, locals, later, ident) {
	      if (later && (typeof later === 'undefined' ? 'undefined' : _typeof(later)) === 'object') {
	        var create = $delegate(expression, locals, true, ident);
	        angular.extend(create.instance, later);
	        return create();
	      }
	      return $delegate(expression, locals, later, ident);
	    };
	  }
	
	  controllerDecorator.$inject = ['$delegate'];
	
	  function mdEditDialog($compile, $controller, $document, $mdUtil, $q, $rootScope, $templateCache, $templateRequest, $window) {
	    /* jshint validthis: true */
	
	    var ESCAPE = 27;
	
	    var busy = false;
	    var body = angular.element($document.prop('body'));
	
	    /*
	     * bindToController
	     * controller
	     * controllerAs
	     * locals
	     * resolve
	     * scope
	     * targetEvent
	     * template
	     * templateUrl
	     */
	    var defaultOptions = {
	      clickOutsideToClose: true,
	      disableScroll: true,
	      escToClose: true,
	      focusOnOpen: true
	    };
	
	    function build(template, options) {
	      var scope = $rootScope.$new();
	      var element = $compile(template)(scope);
	      var backdrop = $mdUtil.createBackdrop(scope, 'md-edit-dialog-backdrop');
	      var controller;
	
	      if (options.controller) {
	        controller = getController(options, scope, { $element: element, $scope: scope });
	      } else {
	        angular.extend(scope, options.scope);
	      }
	
	      if (options.disableScroll) {
	        disableScroll(element);
	      }
	
	      body.prepend(backdrop).append(element.addClass('md-whiteframe-1dp'));
	
	      positionDialog(element, options.target);
	
	      if (options.focusOnOpen) {
	        focusOnOpen(element);
	      }
	
	      if (options.clickOutsideToClose) {
	        backdrop.on('click', function () {
	          element.remove();
	        });
	      }
	
	      if (options.escToClose) {
	        escToClose(element);
	      }
	
	      element.on('$destroy', function () {
	        busy = false;
	        backdrop.remove();
	      });
	
	      return controller;
	    }
	
	    function disableScroll(element) {
	      var restoreScroll = $mdUtil.disableScrollAround(element, body);
	
	      element.on('$destroy', function () {
	        restoreScroll();
	      });
	    }
	
	    function getController(options, scope, inject) {
	      if (!options.controller) {
	        return;
	      }
	
	      if (options.resolve) {
	        angular.extend(inject, options.resolve);
	      }
	
	      if (options.locals) {
	        angular.extend(inject, options.locals);
	      }
	
	      if (options.controllerAs) {
	        scope[options.controllerAs] = {};
	
	        if (options.bindToController) {
	          angular.extend(scope[options.controllerAs], options.scope);
	        } else {
	          angular.extend(scope, options.scope);
	        }
	      } else {
	        angular.extend(scope, options.scope);
	      }
	
	      if (options.bindToController) {
	        return $controller(options.controller, inject, scope[options.controllerAs]);
	      } else {
	        return $controller(options.controller, inject);
	      }
	    }
	
	    function getTemplate(options) {
	      return $q(function (resolve, reject) {
	        var template = options.template;
	
	        function illegalType(type) {
	          reject('Unexpected template value. Expected a string; received a ' + type + '.');
	        }
	
	        if (template) {
	          return angular.isString(template) ? resolve(template) : illegalType(typeof template === 'undefined' ? 'undefined' : _typeof(template));
	        }
	
	        if (options.templateUrl) {
	          template = $templateCache.get(options.templateUrl);
	
	          if (template) {
	            return resolve(template);
	          }
	
	          var success = function success(template) {
	            return resolve(template);
	          };
	
	          var error = function error() {
	            return reject('Error retrieving template from URL.');
	          };
	
	          return $templateRequest(options.templateUrl).then(success, error);
	        }
	
	        reject('Template not provided.');
	      });
	    }
	
	    function logError(error) {
	      busy = false;
	      console.error(error);
	    }
	
	    function escToClose(element) {
	      var keyup = function keyup(event) {
	        if (event.keyCode === ESCAPE) {
	          element.remove();
	        }
	      };
	
	      body.on('keyup', keyup);
	
	      element.on('$destroy', function () {
	        body.off('keyup', keyup);
	      });
	    }
	
	    function focusOnOpen(element) {
	      $mdUtil.nextTick(function () {
	        var autofocus = $mdUtil.findFocusTarget(element);
	
	        if (autofocus) {
	          autofocus.focus();
	        }
	      }, false);
	    }
	
	    function positionDialog(element, target) {
	      var table = angular.element(target).controller('mdCell').getTable();
	
	      var getHeight = function getHeight() {
	        return element.prop('clientHeight');
	      };
	
	      var getSize = function getSize() {
	        return {
	          width: getWidth(),
	          height: getHeight()
	        };
	      };
	
	      var getTableBounds = function getTableBounds() {
	        var parent = table.parent();
	
	        if (parent.prop('tagName') === 'MD-TABLE-CONTAINER') {
	          return parent[0].getBoundingClientRect();
	        } else {
	          return table[0].getBoundingClientRect();
	        }
	      };
	
	      var getWidth = function getWidth() {
	        return element.prop('clientWidth');
	      };
	
	      var reposition = function reposition() {
	        var size = getSize();
	        var cellBounds = target.getBoundingClientRect();
	        var tableBounds = getTableBounds();
	
	        if (size.width > tableBounds.right - cellBounds.left) {
	          element.css('left', tableBounds.right - size.width + 'px');
	        } else {
	          element.css('left', cellBounds.left + 'px');
	        }
	
	        if (size.height > tableBounds.bottom - cellBounds.top) {
	          element.css('top', tableBounds.bottom - size.height + 'px');
	        } else {
	          element.css('top', cellBounds.top + 1 + 'px');
	        }
	
	        element.css('minWidth', cellBounds.width + 'px');
	      };
	
	      var watchWidth = $rootScope.$watch(getWidth, reposition);
	      var watchHeight = $rootScope.$watch(getHeight, reposition);
	
	      $window.addEventListener('resize', reposition);
	
	      element.on('$destroy', function () {
	        watchWidth();
	        watchHeight();
	
	        $window.removeEventListener('resize', reposition);
	      });
	    }
	
	    function preset(size, options) {
	
	      function getAttrs() {
	        var attrs = 'type="' + (options.type || 'text') + '"';
	
	        for (var attr in options.validators) {
	          attrs += ' ' + attr + '="' + options.validators[attr] + '"';
	        }
	
	        return attrs;
	      }
	
	      return {
	        controller: ['$element', '$q', 'save', '$scope', function ($element, $q, save, $scope) {
	          function update() {
	            if ($scope.editDialog.$invalid) {
	              return $q.reject();
	            }
	
	            if (angular.isFunction(save)) {
	              return $q.when(save($scope.editDialog.input));
	            }
	
	            return $q.resolve();
	          }
	
	          this.dismiss = function () {
	            $element.remove();
	          };
	
	          this.getInput = function () {
	            return $scope.editDialog.input;
	          };
	
	          $scope.dismiss = this.dismiss;
	
	          $scope.submit = function () {
	            update().then(function () {
	              $scope.dismiss();
	            });
	          };
	        }],
	        locals: {
	          save: options.save
	        },
	        scope: {
	          cancel: options.cancel || 'Cancel',
	          messages: options.messages,
	          model: options.modelValue,
	          ok: options.ok || 'Save',
	          placeholder: options.placeholder,
	          title: options.title,
	          size: size
	        },
	        template: '<md-edit-dialog>' + '<div layout="column" class="md-content">' + '<div ng-if="size === \'large\'" class="md-title">{{title || \'Edit\'}}</div>' + '<form name="editDialog" layout="column" ng-submit="submit(model)">' + '<md-input-container md-no-float>' + '<input name="input" ng-model="model" md-autofocus placeholder="{{placeholder}} "' + getAttrs() + '>' + '<div ng-messages="editDialog.input.$error">' + '<div ng-repeat="(key, message) in messages" ng-message="{{key}}">{{message}}</div>' + '</div>' + '</md-input-container>' + '</form>' + '</div>' + '<div ng-if="size === \'large\'" layout="row" layout-align="end" class="md-actions">' + '<md-button class="md-primary" ng-click="dismiss()">{{cancel}}</md-button>' + '<md-button class="md-primary" ng-click="submit()">{{ok}}</md-button>' + '</div>' + '</md-edit-dialog>'
	      };
	    }
	
	    this.show = function (options) {
	      if (busy) {
	        return $q.reject();
	      }
	
	      busy = true;
	      options = angular.extend({}, defaultOptions, options);
	
	      if (!options.targetEvent) {
	        return logError('options.targetEvent is required to align the dialog with the table cell.');
	      }
	
	      if (!options.targetEvent.currentTarget.classList.contains('md-cell')) {
	        return logError('The event target must be a table cell.');
	      }
	
	      if (options.bindToController && !options.controllerAs) {
	        return logError('You must define options.controllerAs when options.bindToController is true.');
	      }
	
	      options.target = options.targetEvent.currentTarget;
	
	      var promise = getTemplate(options);
	      var promises = [promise];
	
	      for (var prop in options.resolve) {
	        promise = options.resolve[prop];
	        promises.push($q.when(angular.isFunction(promise) ? promise() : promise));
	      }
	
	      promise = $q.all(promises);
	
	      promise['catch'](logError);
	
	      return promise.then(function (results) {
	        var template = results.shift();
	
	        for (var prop in options.resolve) {
	          options.resolve[prop] = results.shift();
	        }
	
	        return build(template, options);
	      });
	    };
	
	    this.small = function (options) {
	      return this.show(angular.extend({}, options, preset('small', options)));
	    }.bind(this);
	
	    this.large = function (options) {
	      return this.show(angular.extend({}, options, preset('large', options)));
	    }.bind(this);
	
	    return this;
	  }
	
	  mdEditDialog.$inject = ['$compile', '$controller', '$document', '$mdUtil', '$q', '$rootScope', '$templateCache', '$templateRequest', '$window'];
	
	  angular.module('md.data.table').directive('mdFoot', mdFoot);
	
	  function mdFoot() {
	
	    function compile(tElement) {
	      tElement.addClass('md-foot');
	    }
	
	    return {
	      compile: compile,
	      restrict: 'A'
	    };
	  }
	
	  angular.module('md.data.table').directive('mdHead', mdHead);
	
	  function mdHead($compile) {
	
	    function compile(tElement) {
	      tElement.addClass('md-head');
	      return postLink;
	    }
	
	    // empty controller to be bind scope properties to
	    function Controller() {}
	
	    function postLink(scope, element, attrs, tableCtrl) {
	      // because scope.$watch is unpredictable
	      var oldValue = new Array(2);
	
	      function addCheckboxColumn() {
	        element.children().prepend('<th class="md-column md-checkbox-column">');
	      }
	
	      function attatchCheckbox() {
	        element.prop('lastElementChild').firstElementChild.appendChild($compile(createCheckBox())(scope)[0]);
	      }
	
	      function createCheckBox() {
	        return angular.element('<md-checkbox>').attr({
	          'aria-label': 'Select All',
	          'ng-click': 'toggleAll()',
	          'ng-checked': 'allSelected()',
	          'ng-disabled': '!getSelectableRows().length'
	        });
	      }
	
	      function detachCheckbox() {
	        var cell = element.prop('lastElementChild').firstElementChild;
	
	        if (cell.classList.contains('md-checkbox-column')) {
	          angular.element(cell).empty();
	        }
	      }
	
	      function enableRowSelection() {
	        return tableCtrl.$$rowSelect;
	      }
	
	      function mdSelectCtrl(row) {
	        return angular.element(row).controller('mdSelect');
	      }
	
	      function removeCheckboxColumn() {
	        Array.prototype.some.call(element.find('th'), function (cell) {
	          return cell.classList.contains('md-checkbox-column') && cell.remove();
	        });
	      }
	
	      scope.allSelected = function () {
	        var rows = scope.getSelectableRows();
	
	        return rows.length && rows.every(function (row) {
	          return row.isSelected();
	        });
	      };
	
	      scope.getSelectableRows = function () {
	        return tableCtrl.getBodyRows().map(mdSelectCtrl).filter(function (ctrl) {
	          return ctrl && !ctrl.disabled;
	        });
	      };
	
	      scope.selectAll = function () {
	        tableCtrl.getBodyRows().map(mdSelectCtrl).forEach(function (ctrl) {
	          if (ctrl && !ctrl.isSelected()) {
	            ctrl.select();
	          }
	        });
	      };
	
	      scope.toggleAll = function () {
	        return scope.allSelected() ? scope.unSelectAll() : scope.selectAll();
	      };
	
	      scope.unSelectAll = function () {
	        tableCtrl.getBodyRows().map(mdSelectCtrl).forEach(function (ctrl) {
	          if (ctrl && ctrl.isSelected()) {
	            ctrl.deselect();
	          }
	        });
	      };
	
	      scope.$watchGroup([enableRowSelection, tableCtrl.enableMultiSelect], function (newValue) {
	        if (newValue[0] !== oldValue[0]) {
	          if (newValue[0]) {
	            addCheckboxColumn();
	
	            if (newValue[1]) {
	              attatchCheckbox();
	            }
	          } else {
	            removeCheckboxColumn();
	          }
	        } else if (newValue[0] && newValue[1] !== oldValue[1]) {
	          if (newValue[1]) {
	            attatchCheckbox();
	          } else {
	            detachCheckbox();
	          }
	        }
	
	        angular.copy(newValue, oldValue);
	      });
	    }
	
	    return {
	      bindToController: true,
	      compile: compile,
	      controller: Controller,
	      controllerAs: '$mdHead',
	      require: '^^mdTable',
	      restrict: 'A',
	      scope: {
	        order: '=?mdOrder',
	        onReorder: '=?mdOnReorder'
	      }
	    };
	  }
	
	  mdHead.$inject = ['$compile'];
	
	  angular.module('md.data.table').directive('mdRow', mdRow);
	
	  function mdRow() {
	
	    function compile(tElement) {
	      tElement.addClass('md-row');
	      return postLink;
	    }
	
	    function postLink(scope, element, attrs, tableCtrl) {
	      function enableRowSelection() {
	        return tableCtrl.$$rowSelect;
	      }
	
	      function isBodyRow() {
	        return tableCtrl.getBodyRows().indexOf(element[0]) !== -1;
	      }
	
	      function isChild(node) {
	        return element[0].contains(node[0]);
	      }
	
	      if (isBodyRow()) {
	        var cell = angular.element('<td class="md-cell">');
	
	        scope.$watch(enableRowSelection, function (enable) {
	          // if a row is not selectable, prepend an empty cell to it
	          if (enable && !attrs.mdSelect) {
	            if (!isChild(cell)) {
	              element.prepend(cell);
	            }
	            return;
	          }
	
	          if (isChild(cell)) {
	            cell.remove();
	          }
	        });
	      }
	    }
	
	    return {
	      compile: compile,
	      require: '^^mdTable',
	      restrict: 'A'
	    };
	  }
	
	  angular.module('md.data.table').directive('mdSelect', mdSelect);
	
	  function mdSelect($compile, $parse) {
	
	    // empty controller to bind scope properties to
	    function Controller() {}
	
	    function postLink(scope, element, attrs, ctrls) {
	      var self = ctrls.shift();
	      var tableCtrl = ctrls.shift();
	      var getId = $parse(attrs.mdSelectId);
	
	      self.id = getId(self.model);
	
	      if (tableCtrl.$$rowSelect && self.id) {
	        if (tableCtrl.$$hash.has(self.id)) {
	          var index = tableCtrl.selected.indexOf(tableCtrl.$$hash.get(self.id));
	
	          // if the item is no longer selected remove it
	          if (index === -1) {
	            tableCtrl.$$hash.purge(self.id);
	          }
	
	          // if the item is not a reference to the current model update the reference
	          else if (!tableCtrl.$$hash.equals(self.id, self.model)) {
	              tableCtrl.$$hash.update(self.id, self.model);
	              tableCtrl.selected.splice(index, 1, self.model);
	            }
	        } else {
	
	          // check if the item has been selected
	          tableCtrl.selected.some(function (item, index) {
	            if (getId(item) === self.id) {
	              tableCtrl.$$hash.update(self.id, self.model);
	              tableCtrl.selected.splice(index, 1, self.model);
	
	              return true;
	            }
	          });
	        }
	      }
	
	      self.isSelected = function () {
	        if (!tableCtrl.$$rowSelect) {
	          return false;
	        }
	
	        if (self.id) {
	          return tableCtrl.$$hash.has(self.id);
	        }
	
	        return tableCtrl.selected.indexOf(self.model) !== -1;
	      };
	
	      self.select = function () {
	        if (self.disabled) {
	          return;
	        }
	
	        if (tableCtrl.enableMultiSelect()) {
	          tableCtrl.selected.push(self.model);
	        } else {
	          tableCtrl.selected.splice(0, tableCtrl.selected.length, self.model);
	        }
	
	        if (angular.isFunction(self.onSelect)) {
	          self.onSelect(self.model);
	        }
	      };
	
	      self.deselect = function () {
	        if (self.disabled) {
	          return;
	        }
	
	        tableCtrl.selected.splice(tableCtrl.selected.indexOf(self.model), 1);
	
	        if (angular.isFunction(self.onDeselect)) {
	          self.onDeselect(self.model);
	        }
	      };
	
	      self.toggle = function (event) {
	        if (event && event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        return self.isSelected() ? self.deselect() : self.select();
	      };
	
	      function autoSelect() {
	        return attrs.mdAutoSelect === '' || self.autoSelect;
	      }
	
	      function createCheckbox() {
	        var checkbox = angular.element('<md-checkbox>').attr({
	          'aria-label': 'Select Row',
	          'ng-click': '$mdSelect.toggle($event)',
	          'ng-checked': '$mdSelect.isSelected()',
	          'ng-disabled': '$mdSelect.disabled'
	        });
	
	        return angular.element('<td class="md-cell md-checkbox-cell">').append($compile(checkbox)(scope));
	      }
	
	      function disableSelection() {
	        Array.prototype.some.call(element.children(), function (child) {
	          return child.classList.contains('md-checkbox-cell') && element[0].removeChild(child);
	        });
	
	        if (autoSelect()) {
	          element.off('click', toggle);
	        }
	      }
	
	      function enableSelection() {
	        element.prepend(createCheckbox());
	
	        if (autoSelect()) {
	          element.on('click', toggle);
	        }
	      }
	
	      function enableRowSelection() {
	        return tableCtrl.$$rowSelect;
	      }
	
	      function onSelectChange(selected) {
	        if (!self.id) {
	          return;
	        }
	
	        if (tableCtrl.$$hash.has(self.id)) {
	          // check if the item has been deselected
	          if (selected.indexOf(tableCtrl.$$hash.get(self.id)) === -1) {
	            tableCtrl.$$hash.purge(self.id);
	          }
	
	          return;
	        }
	
	        // check if the item has been selected
	        if (selected.indexOf(self.model) !== -1) {
	          tableCtrl.$$hash.update(self.id, self.model);
	        }
	      }
	
	      function toggle(event) {
	        scope.$applyAsync(function () {
	          self.toggle(event);
	        });
	      }
	
	      scope.$watch(enableRowSelection, function (enable) {
	        if (enable) {
	          enableSelection();
	        } else {
	          disableSelection();
	        }
	      });
	
	      scope.$watch(autoSelect, function (newValue, oldValue) {
	        if (newValue === oldValue) {
	          return;
	        }
	
	        if (tableCtrl.$$rowSelect && newValue) {
	          element.on('click', toggle);
	        } else {
	          element.off('click', toggle);
	        }
	      });
	
	      scope.$watch(self.isSelected, function (isSelected) {
	        return isSelected ? element.addClass('md-selected') : element.removeClass('md-selected');
	      });
	
	      scope.$watch(tableCtrl.enableMultiSelect, function (multiple) {
	        if (tableCtrl.$$rowSelect && !multiple) {
	          // remove all but the first selected item
	          tableCtrl.selected.splice(1);
	        }
	      });
	
	      tableCtrl.registerModelChangeListener(onSelectChange);
	
	      element.on('$destroy', function () {
	        tableCtrl.removeModelChangeListener(onSelectChange);
	      });
	    }
	
	    return {
	      bindToController: true,
	      controller: Controller,
	      controllerAs: '$mdSelect',
	      link: postLink,
	      require: ['mdSelect', '^^mdTable'],
	      restrict: 'A',
	      scope: {
	        model: '=mdSelect',
	        disabled: '=ngDisabled',
	        onSelect: '=?mdOnSelect',
	        onDeselect: '=?mdOnDeselect',
	        autoSelect: '=mdAutoSelect'
	      }
	    };
	  }
	
	  mdSelect.$inject = ['$compile', '$parse'];
	
	  angular.module('md.data.table').directive('mdTable', mdTable);
	
	  function Hash() {
	    var keys = {};
	
	    this.equals = function (key, item) {
	      return keys[key] === item;
	    };
	
	    this.get = function (key) {
	      return keys[key];
	    };
	
	    this.has = function (key) {
	      return keys.hasOwnProperty(key);
	    };
	
	    this.purge = function (key) {
	      delete keys[key];
	    };
	
	    this.update = function (key, item) {
	      keys[key] = item;
	    };
	  }
	
	  function mdTable() {
	
	    function compile(tElement, tAttrs) {
	      tElement.addClass('md-table');
	
	      if (tAttrs.hasOwnProperty('mdProgress')) {
	        var body = tElement.find('tbody')[0];
	        var progress = angular.element('<thead class="md-table-progress" md-table-progress>');
	
	        if (body) {
	          tElement[0].insertBefore(progress[0], body);
	        }
	      }
	    }
	
	    function Controller($attrs, $element, $q, $scope) {
	      var self = this;
	      var queue = [];
	      var watchListener;
	      var modelChangeListeners = [];
	
	      self.$$hash = new Hash();
	      self.$$columns = {};
	
	      function enableRowSelection() {
	        self.$$rowSelect = true;
	
	        watchListener = $scope.$watchCollection('$mdTable.selected', function (selected) {
	          modelChangeListeners.forEach(function (listener) {
	            listener(selected);
	          });
	        });
	
	        $element.addClass('md-row-select');
	      }
	
	      function disableRowSelection() {
	        self.$$rowSelect = false;
	
	        if (angular.isFunction(watchListener)) {
	          watchListener();
	        }
	
	        $element.removeClass('md-row-select');
	      }
	
	      function resolvePromises() {
	        if (!queue.length) {
	          return $scope.$applyAsync();
	        }
	
	        queue[0]['finally'](function () {
	          queue.shift();
	          resolvePromises();
	        });
	      }
	
	      function rowSelect() {
	        return $attrs.mdRowSelect === '' || self.rowSelect;
	      }
	
	      function validateModel() {
	        if (!self.selected) {
	          return console.error('Row selection: ngModel is not defined.');
	        }
	
	        if (!angular.isArray(self.selected)) {
	          return console.error('Row selection: Expected an array. Recived ' + _typeof(self.selected) + '.');
	        }
	
	        return true;
	      }
	
	      self.columnCount = function () {
	        return self.getRows($element[0]).reduce(function (count, row) {
	          return row.cells.length > count ? row.cells.length : count;
	        }, 0);
	      };
	
	      self.getRows = function (element) {
	        return Array.prototype.filter.call(element.rows, function (row) {
	          return !row.classList.contains('ng-leave');
	        });
	      };
	
	      self.getBodyRows = function () {
	        return Array.prototype.reduce.call($element.prop('tBodies'), function (result, tbody) {
	          return result.concat(self.getRows(tbody));
	        }, []);
	      };
	
	      self.getElement = function () {
	        return $element;
	      };
	
	      self.getHeaderRows = function () {
	        return self.getRows($element.prop('tHead'));
	      };
	
	      self.enableMultiSelect = function () {
	        return $attrs.multiple === '' || $scope.$eval($attrs.multiple);
	      };
	
	      self.waitingOnPromise = function () {
	        return !!queue.length;
	      };
	
	      self.queuePromise = function (promise) {
	        if (!promise) {
	          return;
	        }
	
	        if (queue.push(angular.isArray(promise) ? $q.all(promise) : $q.when(promise)) === 1) {
	          resolvePromises();
	        }
	      };
	
	      self.registerModelChangeListener = function (listener) {
	        modelChangeListeners.push(listener);
	      };
	
	      self.removeModelChangeListener = function (listener) {
	        var index = modelChangeListeners.indexOf(listener);
	
	        if (index !== -1) {
	          modelChangeListeners.splice(index, 1);
	        }
	      };
	
	      if ($attrs.hasOwnProperty('mdProgress')) {
	        $scope.$watch('$mdTable.progress', self.queuePromise);
	      }
	
	      $scope.$watch(rowSelect, function (enable) {
	        if (enable && !!validateModel()) {
	          enableRowSelection();
	        } else {
	          disableRowSelection();
	        }
	      });
	    }
	
	    Controller.$inject = ['$attrs', '$element', '$q', '$scope'];
	
	    return {
	      bindToController: true,
	      compile: compile,
	      controller: Controller,
	      controllerAs: '$mdTable',
	      restrict: 'A',
	      scope: {
	        progress: '=?mdProgress',
	        selected: '=ngModel',
	        rowSelect: '=mdRowSelect'
	      }
	    };
	  }
	
	  angular.module('md.data.table').directive('mdTablePagination', mdTablePagination);
	
	  function mdTablePagination() {
	
	    function compile(tElement) {
	      tElement.addClass('md-table-pagination');
	    }
	
	    function Controller($attrs, $mdUtil, $scope) {
	      var self = this;
	      var defaultLabel = {
	        page: 'Page:',
	        rowsPerPage: 'Rows per page:',
	        of: 'of'
	      };
	
	      self.label = angular.copy(defaultLabel);
	
	      function isPositive(number) {
	        return parseInt(number, 10) > 0;
	      }
	
	      self.eval = function (expression) {
	        return $scope.$eval(expression);
	      };
	
	      self.first = function () {
	        self.page = 1;
	        self.onPaginationChange();
	      };
	
	      self.hasNext = function () {
	        return self.page * self.limit < self.total;
	      };
	
	      self.hasPrevious = function () {
	        return self.page > 1;
	      };
	
	      self.last = function () {
	        self.page = self.pages();
	        self.onPaginationChange();
	      };
	
	      self.max = function () {
	        return self.hasNext() ? self.page * self.limit : self.total;
	      };
	
	      self.min = function () {
	        return isPositive(self.total) ? self.page * self.limit - self.limit + 1 : 0;
	      };
	
	      self.next = function () {
	        self.page++;
	        self.onPaginationChange();
	      };
	
	      self.onPaginationChange = function () {
	        if (angular.isFunction(self.onPaginate)) {
	          $mdUtil.nextTick(function () {
	            self.onPaginate(self.page, self.limit);
	          });
	        }
	      };
	
	      self.pages = function () {
	        return isPositive(self.total) ? Math.ceil(self.total / (isPositive(self.limit) ? self.limit : 1)) : 1;
	      };
	
	      self.previous = function () {
	        self.page--;
	        self.onPaginationChange();
	      };
	
	      self.showBoundaryLinks = function () {
	        return $attrs.mdBoundaryLinks === '' || self.boundaryLinks;
	      };
	
	      self.showPageSelect = function () {
	        return $attrs.mdPageSelect === '' || self.pageSelect;
	      };
	
	      $scope.$watch('$pagination.limit', function (newValue, oldValue) {
	        if (isNaN(newValue) || isNaN(oldValue) || newValue === oldValue) {
	          return;
	        }
	
	        // find closest page from previous min
	        self.page = Math.floor((self.page * oldValue - oldValue + newValue) / (isPositive(newValue) ? newValue : 1));
	        self.onPaginationChange();
	      });
	
	      $attrs.$observe('mdLabel', function (label) {
	        angular.extend(self.label, defaultLabel, $scope.$eval(label));
	      });
	
	      $scope.$watch('$pagination.total', function (newValue, oldValue) {
	        if (isNaN(newValue) || newValue === oldValue) {
	          return;
	        }
	
	        if (self.page > self.pages()) {
	          self.last();
	        }
	      });
	    }
	
	    Controller.$inject = ['$attrs', '$mdUtil', '$scope'];
	
	    return {
	      bindToController: {
	        boundaryLinks: '=?mdBoundaryLinks',
	        disabled: '=ngDisabled',
	        limit: '=mdLimit',
	        page: '=mdPage',
	        pageSelect: '=?mdPageSelect',
	        onPaginate: '=?mdOnPaginate',
	        limitOptions: '=?mdLimitOptions',
	        total: '@mdTotal'
	      },
	      compile: compile,
	      controller: Controller,
	      controllerAs: '$pagination',
	      restrict: 'E',
	      scope: {},
	      templateUrl: 'md-table-pagination.html'
	    };
	  }
	
	  angular.module('md.data.table').directive('mdTableProgress', mdTableProgress);
	
	  function mdTableProgress() {
	
	    function postLink(scope, element, attrs, tableCtrl) {
	      scope.columnCount = tableCtrl.columnCount;
	      scope.deferred = tableCtrl.waitingOnPromise;
	    }
	
	    return {
	      link: postLink,
	      require: '^^mdTable',
	      restrict: 'A',
	      scope: {},
	      templateUrl: 'md-table-progress.html'
	    };
	  }
	
	  angular.module('md.data.table').directive('virtualPageSelect', virtualPageSelect);
	
	  function virtualPageSelect() {
	
	    function Controller($element, $scope) {
	      var self = this;
	      var content = $element.find('md-content');
	
	      self.pages = [];
	
	      function getMin(pages, total) {
	        return Math.min(pages, isFinite(total) && isPositive(total) ? total : 1);
	      }
	
	      function isPositive(number) {
	        return number > 0;
	      }
	
	      function setPages(max) {
	        if (self.pages.length > max) {
	          return self.pages.splice(max);
	        }
	
	        for (var i = self.pages.length; i < max; i++) {
	          self.pages.push(i + 1);
	        }
	      }
	
	      content.on('scroll', function () {
	        if (content.prop('clientHeight') + content.prop('scrollTop') >= content.prop('scrollHeight')) {
	          $scope.$applyAsync(function () {
	            setPages(getMin(self.pages.length + 10, self.total));
	          });
	        }
	      });
	
	      $scope.$watch('$pageSelect.total', function (total) {
	        setPages(getMin(Math.max(self.pages.length, 10), total));
	      });
	
	      $scope.$watch('$pagination.page', function (page) {
	        for (var i = self.pages.length; i < page; i++) {
	          self.pages.push(i + 1);
	        }
	      });
	    }
	
	    Controller.$inject = ['$element', '$scope'];
	
	    return {
	      bindToController: {
	        total: '@'
	      },
	      controller: Controller,
	      controllerAs: '$pageSelect'
	    };
	  }
	})(window, angular);

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// support for Browserify
	
	__webpack_require__(18);
	__webpack_require__(218);
	
	module.exports = 'md.data.table';

/***/ },
/* 220 */
/***/ function(module, exports) {

	"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*!
	 * AngularJS Material Design
	 * https://github.com/angular/material
	 * @license MIT
	 * v1.1.8
	 */(function(window,angular,undefined){"use strict";(function(){"use strict";angular.module('ngMaterial',["ng","ngAnimate","ngAria","material.core","material.core.gestures","material.core.interaction","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.core.animate","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.checkbox","material.components.chips","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.gridList","material.components.icon","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.panel","material.components.progressCircular","material.components.progressLinear","material.components.radioButton","material.components.showHide","material.components.select","material.components.sidenav","material.components.slider","material.components.sticky","material.components.subheader","material.components.swipe","material.components.switch","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.truncate","material.components.virtualRepeat","material.components.whiteframe"]);})();(function(){"use strict";/**
	 * Initialization function that validates environment
	 * requirements.
	 */DetectNgTouch.$inject=["$log","$injector"];MdCoreConfigure.$inject=["$provide","$mdThemingProvider"];rAFDecorator.$inject=["$delegate"];qDecorator.$inject=["$delegate"];angular.module('material.core',['ngAnimate','material.core.animate','material.core.layout','material.core.interaction','material.core.gestures','material.core.theming']).config(MdCoreConfigure).run(DetectNgTouch);/**
	 * Detect if the ng-Touch module is also being used.
	 * Warn if detected.
	 * @ngInject
	 */function DetectNgTouch($log,$injector){if($injector.has('$swipe')){var msg=""+"You are using the ngTouch module. \n"+"AngularJS Material already has mobile click, tap, and swipe support... \n"+"ngTouch is not supported with AngularJS Material!";$log.warn(msg);}}/**
	 * @ngInject
	 */function MdCoreConfigure($provide,$mdThemingProvider){$provide.decorator('$$rAF',['$delegate',rAFDecorator]);$provide.decorator('$q',['$delegate',qDecorator]);$mdThemingProvider.theme('default').primaryPalette('indigo').accentPalette('pink').warnPalette('deep-orange').backgroundPalette('grey');}/**
	 * @ngInject
	 */function rAFDecorator($delegate){/**
	   * Use this to throttle events that come in often.
	   * The throttled function will always use the *last* invocation before the
	   * coming frame.
	   *
	   * For example, window resize events that fire many times a second:
	   * If we set to use an raf-throttled callback on window resize, then
	   * our callback will only be fired once per frame, with the last resize
	   * event that happened before that frame.
	   *
	   * @param {function} callback function to debounce
	   */$delegate.throttle=function(cb){var queuedArgs,alreadyQueued,queueCb,context;return function debounced(){queuedArgs=arguments;context=this;queueCb=cb;if(!alreadyQueued){alreadyQueued=true;$delegate(function(){queueCb.apply(context,Array.prototype.slice.call(queuedArgs));alreadyQueued=false;});}};};return $delegate;}/**
	 * @ngInject
	 */function qDecorator($delegate){/**
	   * Adds a shim for $q.resolve for AngularJS version that don't have it,
	   * so we don't have to think about it.
	   *
	   * via https://github.com/angular/angular.js/pull/11987
	   */// TODO(crisbeto): this won't be necessary once we drop AngularJS 1.3
	if(!$delegate.resolve){$delegate.resolve=$delegate.when;}return $delegate;}})();(function(){"use strict";MdAutofocusDirective.$inject=["$parse"];angular.module('material.core').directive('mdAutofocus',MdAutofocusDirective)// Support the deprecated md-auto-focus and md-sidenav-focus as well
	.directive('mdAutoFocus',MdAutofocusDirective).directive('mdSidenavFocus',MdAutofocusDirective);/**
	 * @ngdoc directive
	 * @name mdAutofocus
	 * @module material.core.util
	 *
	 * @description
	 *
	 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
	 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
	 *
	 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
	 * attribute directive and optional expression. An expression may be specified as the directive
	 * value to enable conditional activation of the autofocus.
	 *
	 * @usage
	 *
	 * ### Dialog
	 * <hljs lang="html">
	 * <md-dialog>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-autofocus>
	 *     </md-input-container>
	 *   </form>
	 * </md-dialog>
	 * </hljs>
	 *
	 * ### Bottomsheet
	 * <hljs lang="html">
	 * <md-bottom-sheet class="md-list md-has-header">
	 *  <md-subheader>Comment Actions</md-subheader>
	 *  <md-list>
	 *    <md-list-item ng-repeat="item in items">
	 *
	 *      <md-button md-autofocus="$index == 2">
	 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
	 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
	 *      </md-button>
	 *
	 *    </md-list-item>
	 *  </md-list>
	 * </md-bottom-sheet>
	 * </hljs>
	 *
	 * ### Autocomplete
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-autofocus
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Sidenav
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 **/function MdAutofocusDirective($parse){return{restrict:'A',link:{pre:preLink}};function preLink(scope,element,attr){var attrExp=attr.mdAutoFocus||attr.mdAutofocus||attr.mdSidenavFocus;// Initially update the expression by manually parsing the expression as per $watch source.
	updateExpression($parse(attrExp)(scope));// Only watch the expression if it is not empty.
	if(attrExp){scope.$watch(attrExp,updateExpression);}/**
	     * Updates the autofocus class which is used to determine whether the attribute
	     * expression evaluates to true or false.
	     * @param {string|boolean} value Attribute Value
	     */function updateExpression(value){// Rather than passing undefined to the jqLite toggle class function we explicitly set the
	// value to true. Otherwise the class will be just toggled instead of being forced.
	if(angular.isUndefined(value)){value=true;}element.toggleClass('md-autofocus',!!value);}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.core.colorUtil
	 * @description
	 * Color Util
	 */angular.module('material.core').factory('$mdColorUtil',ColorUtilFactory);function ColorUtilFactory(){/**
	   * Converts hex value to RGBA string
	   * @param color {string}
	   * @returns {string}
	   */function hexToRgba(color){var hex=color[0]==='#'?color.substr(1):color,dig=hex.length/3,red=hex.substr(0,dig),green=hex.substr(dig,dig),blue=hex.substr(dig*2);if(dig===1){red+=red;green+=green;blue+=blue;}return'rgba('+parseInt(red,16)+','+parseInt(green,16)+','+parseInt(blue,16)+',0.1)';}/**
	   * Converts rgba value to hex string
	   * @param color {string}
	   * @returns {string}
	   */function rgbaToHex(color){color=color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);var hex=color&&color.length===4?"#"+("0"+parseInt(color[1],10).toString(16)).slice(-2)+("0"+parseInt(color[2],10).toString(16)).slice(-2)+("0"+parseInt(color[3],10).toString(16)).slice(-2):'';return hex.toUpperCase();}/**
	   * Converts an RGB color to RGBA
	   * @param color {string}
	   * @returns {string}
	   */function rgbToRgba(color){return color.replace(')',', 0.1)').replace('(','a(');}/**
	   * Converts an RGBA color to RGB
	   * @param color {string}
	   * @returns {string}
	   */function rgbaToRgb(color){return color?color.replace('rgba','rgb').replace(/,[^),]+\)/,')'):'rgb(0,0,0)';}return{rgbaToHex:rgbaToHex,hexToRgba:hexToRgba,rgbToRgba:rgbToRgba,rgbaToRgb:rgbaToRgb};}})();(function(){"use strict";angular.module('material.core').factory('$mdConstant',MdConstantFactory);/**
	 * Factory function that creates the grab-bag $mdConstant service.
	 * @ngInject
	 */function MdConstantFactory(){var prefixTestEl=document.createElement('div');var vendorPrefix=getVendorPrefix(prefixTestEl);var isWebkit=/webkit/i.test(vendorPrefix);var SPECIAL_CHARS_REGEXP=/([:\-_]+(.))/g;function vendorProperty(name){// Add a dash between the prefix and name, to be able to transform the string into camelcase.
	var prefixedName=vendorPrefix+'-'+name;var ucPrefix=camelCase(prefixedName);var lcPrefix=ucPrefix.charAt(0).toLowerCase()+ucPrefix.substring(1);return hasStyleProperty(prefixTestEl,name)?name:// The current browser supports the un-prefixed property
	hasStyleProperty(prefixTestEl,ucPrefix)?ucPrefix:// The current browser only supports the prefixed property.
	hasStyleProperty(prefixTestEl,lcPrefix)?lcPrefix:name;// Some browsers are only supporting the prefix in lowercase.
	}function hasStyleProperty(testElement,property){return angular.isDefined(testElement.style[property]);}function camelCase(input){return input.replace(SPECIAL_CHARS_REGEXP,function(matches,separator,letter,offset){return offset?letter.toUpperCase():letter;});}function getVendorPrefix(testElement){var prop,match;var vendorRegex=/^(Moz|webkit|ms)(?=[A-Z])/;for(prop in testElement.style){if(match=vendorRegex.exec(prop)){return match[0];}}}var self={isInputKey:function isInputKey(e){return e.keyCode>=31&&e.keyCode<=90;},isNumPadKey:function isNumPadKey(e){return 3===e.location&&e.keyCode>=97&&e.keyCode<=105;},isMetaKey:function isMetaKey(e){return e.keyCode>=91&&e.keyCode<=93;},isFnLockKey:function isFnLockKey(e){return e.keyCode>=112&&e.keyCode<=145;},isNavigationKey:function isNavigationKey(e){var kc=self.KEY_CODE,NAVIGATION_KEYS=[kc.SPACE,kc.ENTER,kc.UP_ARROW,kc.DOWN_ARROW];return NAVIGATION_KEYS.indexOf(e.keyCode)!=-1;},hasModifierKey:function hasModifierKey(e){return e.ctrlKey||e.metaKey||e.altKey;},/**
	     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
	     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
	     * compute this value, but Firefox always reports an element to have a size of zero if it
	     * goes over the max, meaning that we'd have to binary search for the value.
	     */ELEMENT_MAX_PIXELS:1533917,/**
	     * Priority for a directive that should run before the directives from ngAria.
	     */BEFORE_NG_ARIA:210,/**
	     * Common Keyboard actions and their associated keycode.
	     */KEY_CODE:{COMMA:188,SEMICOLON:186,ENTER:13,ESCAPE:27,SPACE:32,PAGE_UP:33,PAGE_DOWN:34,END:35,HOME:36,LEFT_ARROW:37,UP_ARROW:38,RIGHT_ARROW:39,DOWN_ARROW:40,TAB:9,BACKSPACE:8,DELETE:46},/**
	     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
	     * as well.
	     */CSS:{/* Constants */TRANSITIONEND:'transitionend'+(isWebkit?' webkitTransitionEnd':''),ANIMATIONEND:'animationend'+(isWebkit?' webkitAnimationEnd':''),TRANSFORM:vendorProperty('transform'),TRANSFORM_ORIGIN:vendorProperty('transformOrigin'),TRANSITION:vendorProperty('transition'),TRANSITION_DURATION:vendorProperty('transitionDuration'),ANIMATION_PLAY_STATE:vendorProperty('animationPlayState'),ANIMATION_DURATION:vendorProperty('animationDuration'),ANIMATION_NAME:vendorProperty('animationName'),ANIMATION_TIMING:vendorProperty('animationTimingFunction'),ANIMATION_DIRECTION:vendorProperty('animationDirection')},/**
	     * As defined in core/style/variables.scss
	     *
	     * $layout-breakpoint-xs:     600px !default;
	     * $layout-breakpoint-sm:     960px !default;
	     * $layout-breakpoint-md:     1280px !default;
	     * $layout-breakpoint-lg:     1920px !default;
	     *
	     */MEDIA:{'xs':'(max-width: 599px)','gt-xs':'(min-width: 600px)','sm':'(min-width: 600px) and (max-width: 959px)','gt-sm':'(min-width: 960px)','md':'(min-width: 960px) and (max-width: 1279px)','gt-md':'(min-width: 1280px)','lg':'(min-width: 1280px) and (max-width: 1919px)','gt-lg':'(min-width: 1920px)','xl':'(min-width: 1920px)','landscape':'(orientation: landscape)','portrait':'(orientation: portrait)','print':'print'},MEDIA_PRIORITY:['xl','gt-lg','lg','gt-md','md','gt-sm','sm','gt-xs','xs','landscape','portrait','print']};return self;}})();(function(){"use strict";angular.module('material.core').config(["$provide",function($provide){$provide.decorator('$mdUtil',['$delegate',function($delegate){/**
	            * Inject the iterator facade to easily support iteration and accessors
	            * @see iterator below
	            */$delegate.iterator=MdIterator;return $delegate;}]);}]);/**
	   * iterator is a list facade to easily support iteration and accessors
	   *
	   * @param items Array list which this iterator will enumerate
	   * @param reloop Boolean enables iterator to consider the list as an endless reloop
	   */function MdIterator(items,reloop){var trueFn=function trueFn(){return true;};if(items&&!angular.isArray(items)){items=Array.prototype.slice.call(items);}reloop=!!reloop;var _items=items||[];// Published API
	return{items:getItems,count:count,inRange:inRange,contains:contains,indexOf:indexOf,itemAt:itemAt,findBy:findBy,add:add,remove:remove,first:first,last:last,next:angular.bind(null,findSubsequentItem,false),previous:angular.bind(null,findSubsequentItem,true),hasPrevious:hasPrevious,hasNext:hasNext};/**
	     * Publish copy of the enumerable set
	     * @returns {Array|*}
	     */function getItems(){return[].concat(_items);}/**
	     * Determine length of the list
	     * @returns {Array.length|*|number}
	     */function count(){return _items.length;}/**
	     * Is the index specified valid
	     * @param index
	     * @returns {Array.length|*|number|boolean}
	     */function inRange(index){return _items.length&&index>-1&&index<_items.length;}/**
	     * Can the iterator proceed to the next item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */function hasNext(item){return item?inRange(indexOf(item)+1):false;}/**
	     * Can the iterator proceed to the previous item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */function hasPrevious(item){return item?inRange(indexOf(item)-1):false;}/**
	     * Get item at specified index/position
	     * @param index
	     * @returns {*}
	     */function itemAt(index){return inRange(index)?_items[index]:null;}/**
	     * Find all elements matching the key/value pair
	     * otherwise return null
	     *
	     * @param val
	     * @param key
	     *
	     * @return array
	     */function findBy(key,val){return _items.filter(function(item){return item[key]===val;});}/**
	     * Add item to list
	     * @param item
	     * @param index
	     * @returns {*}
	     */function add(item,index){if(!item)return-1;if(!angular.isNumber(index)){index=_items.length;}_items.splice(index,0,item);return indexOf(item);}/**
	     * Remove item from list...
	     * @param item
	     */function remove(item){if(contains(item)){_items.splice(indexOf(item),1);}}/**
	     * Get the zero-based index of the target item
	     * @param item
	     * @returns {*}
	     */function indexOf(item){return _items.indexOf(item);}/**
	     * Boolean existence check
	     * @param item
	     * @returns {boolean}
	     */function contains(item){return item&&indexOf(item)>-1;}/**
	     * Return first item in the list
	     * @returns {*}
	     */function first(){return _items.length?_items[0]:null;}/**
	     * Return last item in the list...
	     * @returns {*}
	     */function last(){return _items.length?_items[_items.length-1]:null;}/**
	     * Find the next item. If reloop is true and at the end of the list, it will go back to the
	     * first item. If given, the `validate` callback will be used to determine whether the next item
	     * is valid. If not valid, it will try to find the next item again.
	     *
	     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
	     * @param {*} item The item whose subsequent item we are looking for
	     * @param {Function=} validate The `validate` function
	     * @param {integer=} limit The recursion limit
	     *
	     * @returns {*} The subsequent item or null
	     */function findSubsequentItem(backwards,item,validate,limit){validate=validate||trueFn;var curIndex=indexOf(item);while(true){if(!inRange(curIndex))return null;var nextIndex=curIndex+(backwards?-1:1);var foundItem=null;if(inRange(nextIndex)){foundItem=_items[nextIndex];}else if(reloop){foundItem=backwards?last():first();nextIndex=indexOf(foundItem);}if(foundItem===null||nextIndex===limit)return null;if(validate(foundItem))return foundItem;if(angular.isUndefined(limit))limit=nextIndex;curIndex=nextIndex;}}}})();(function(){"use strict";mdMediaFactory.$inject=["$mdConstant","$rootScope","$window"];angular.module('material.core').factory('$mdMedia',mdMediaFactory);/**
	 * @ngdoc service
	 * @name $mdMedia
	 * @module material.core
	 *
	 * @description
	 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
	 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
	 * you to register a watch.
	 *
	 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
	 *
	 *  <table class="md-api-table">
	 *    <thead>
	 *    <tr>
	 *      <th>Breakpoint</th>
	 *      <th>mediaQuery</th>
	 *    </tr>
	 *    </thead>
	 *    <tbody>
	 *    <tr>
	 *      <td>xs</td>
	 *      <td>(max-width: 599px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-xs</td>
	 *      <td>(min-width: 600px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>sm</td>
	 *      <td>(min-width: 600px) and (max-width: 959px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-sm</td>
	 *      <td>(min-width: 960px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>md</td>
	 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-md</td>
	 *      <td>(min-width: 1280px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>lg</td>
	 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-lg</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>xl</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>landscape</td>
	 *      <td>landscape</td>
	 *    </tr>
	 *    <tr>
	 *      <td>portrait</td>
	 *      <td>portrait</td>
	 *    </tr>
	 *    <tr>
	 *      <td>print</td>
	 *      <td>print</td>
	 *    </tr>
	 *    </tbody>
	 *  </table>
	 *
	 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
	 *
	 *  <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">
	 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
	 *  </a>
	 *
	 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.controller('MyController', function($mdMedia, $scope) {
	 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
	 *     $scope.bigScreen = big;
	 *   });
	 *
	 *   $scope.screenIsSmall = $mdMedia('sm');
	 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
	 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
	 * });
	 * </hljs>
	 *//* @ngInject */function mdMediaFactory($mdConstant,$rootScope,$window){var queries={};var mqls={};var results={};var normalizeCache={};$mdMedia.getResponsiveAttribute=getResponsiveAttribute;$mdMedia.getQuery=getQuery;$mdMedia.watchResponsiveAttributes=watchResponsiveAttributes;return $mdMedia;function $mdMedia(query){var validated=queries[query];if(angular.isUndefined(validated)){validated=queries[query]=validate(query);}var result=results[validated];if(angular.isUndefined(result)){result=add(validated);}return result;}function validate(query){return $mdConstant.MEDIA[query]||(query.charAt(0)!=='('?'('+query+')':query);}function add(query){var result=mqls[query];if(!result){result=mqls[query]=$window.matchMedia(query);}result.addListener(onQueryChange);return results[result.media]=!!result.matches;}function onQueryChange(query){$rootScope.$evalAsync(function(){results[query.media]=!!query.matches;});}function getQuery(name){return mqls[name];}function getResponsiveAttribute(attrs,attrName){for(var i=0;i<$mdConstant.MEDIA_PRIORITY.length;i++){var mediaName=$mdConstant.MEDIA_PRIORITY[i];if(!mqls[queries[mediaName]].matches){continue;}var normalizedName=getNormalizedName(attrs,attrName+'-'+mediaName);if(attrs[normalizedName]){return attrs[normalizedName];}}// fallback on unprefixed
	return attrs[getNormalizedName(attrs,attrName)];}function watchResponsiveAttributes(attrNames,attrs,watchFn){var unwatchFns=[];attrNames.forEach(function(attrName){var normalizedName=getNormalizedName(attrs,attrName);if(angular.isDefined(attrs[normalizedName])){unwatchFns.push(attrs.$observe(normalizedName,angular.bind(void 0,watchFn,null)));}for(var mediaName in $mdConstant.MEDIA){normalizedName=getNormalizedName(attrs,attrName+'-'+mediaName);if(angular.isDefined(attrs[normalizedName])){unwatchFns.push(attrs.$observe(normalizedName,angular.bind(void 0,watchFn,mediaName)));}}});return function unwatch(){unwatchFns.forEach(function(fn){fn();});};}// Improves performance dramatically
	function getNormalizedName(attrs,attrName){return normalizeCache[attrName]||(normalizeCache[attrName]=attrs.$normalize(attrName));}}})();(function(){"use strict";angular.module('material.core').config(["$provide",function($provide){$provide.decorator('$mdUtil',['$delegate',function($delegate){// Inject the prefixer into our original $mdUtil service.
	$delegate.prefixer=MdPrefixer;return $delegate;}]);}]);function MdPrefixer(initialAttributes,buildSelector){var PREFIXES=['data','x'];if(initialAttributes){// The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
	// the specified attributes.
	return buildSelector?_buildSelector(initialAttributes):_buildList(initialAttributes);}return{buildList:_buildList,buildSelector:_buildSelector,hasAttribute:_hasAttribute,removeAttribute:_removeAttribute};function _buildList(attributes){attributes=angular.isArray(attributes)?attributes:[attributes];attributes.forEach(function(item){PREFIXES.forEach(function(prefix){attributes.push(prefix+'-'+item);});});return attributes;}function _buildSelector(attributes){attributes=angular.isArray(attributes)?attributes:[attributes];return _buildList(attributes).map(function(item){return'['+item+']';}).join(',');}function _hasAttribute(element,attribute){element=_getNativeElement(element);if(!element){return false;}var prefixedAttrs=_buildList(attribute);for(var i=0;i<prefixedAttrs.length;i++){if(element.hasAttribute(prefixedAttrs[i])){return true;}}return false;}function _removeAttribute(element,attribute){element=_getNativeElement(element);if(!element){return;}_buildList(attribute).forEach(function(prefixedAttribute){element.removeAttribute(prefixedAttribute);});}/**
	   * Transforms a jqLite or DOM element into a HTML element.
	   * This is useful when supporting jqLite elements and DOM elements at
	   * same time.
	   * @param element {JQLite|Element} Element to be parsed
	   * @returns {HTMLElement} Parsed HTMLElement
	   */function _getNativeElement(element){element=element[0]||element;if(element.nodeType){return element;}}}})();(function(){"use strict";/*
	 * This var has to be outside the angular factory, otherwise when
	 * there are multiple material apps on the same page, each app
	 * will create its own instance of this array and the app's IDs
	 * will not be unique.
	 */UtilFactory.$inject=["$document","$timeout","$compile","$rootScope","$$mdAnimate","$interpolate","$log","$rootElement","$window","$$rAF"];var nextUniqueId=0;/**
	 * @ngdoc module
	 * @name material.core.util
	 * @description
	 * Util
	 */angular.module('material.core').factory('$mdUtil',UtilFactory);/**
	 * @ngInject
	 */function UtilFactory($document,$timeout,$compile,$rootScope,$$mdAnimate,$interpolate,$log,$rootElement,$window,$$rAF){// Setup some core variables for the processTemplate method
	var startSymbol=$interpolate.startSymbol(),endSymbol=$interpolate.endSymbol(),usesStandardSymbols=startSymbol==='{{'&&endSymbol==='}}';/**
	   * Checks if the target element has the requested style by key
	   * @param {DOMElement|JQLite} target Target element
	   * @param {string} key Style key
	   * @param {string=} expectedVal Optional expected value
	   * @returns {boolean} Whether the target element has the style or not
	   */var hasComputedStyle=function hasComputedStyle(target,key,expectedVal){var hasValue=false;if(target&&target.length){var computedStyles=$window.getComputedStyle(target[0]);hasValue=angular.isDefined(computedStyles[key])&&(expectedVal?computedStyles[key]==expectedVal:true);}return hasValue;};function validateCssValue(value){return!value?'0':hasPx(value)||hasPercent(value)?value:value+'px';}function hasPx(value){return String(value).indexOf('px')>-1;}function hasPercent(value){return String(value).indexOf('%')>-1;}var $mdUtil={dom:{},now:window.performance&&window.performance.now?angular.bind(window.performance,window.performance.now):Date.now||function(){return new Date().getTime();},/**
	     * Cross-version compatibility method to retrieve an option of a ngModel controller,
	     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
	     * @param {!angular.ngModelCtrl} ngModelCtrl
	     * @param {!string} optionName
	     * @returns {Object|undefined}
	     */getModelOption:function getModelOption(ngModelCtrl,optionName){if(!ngModelCtrl.$options){return;}var $options=ngModelCtrl.$options;// The newer versions of AngularJS introduced a `getOption function and made the option values no longer
	// visible on the $options object.
	return $options.getOption?$options.getOption(optionName):$options[optionName];},/**
	     * Bi-directional accessor/mutator used to easily update an element's
	     * property based on the current 'dir'ectional value.
	     */bidi:function bidi(element,property,lValue,rValue){var ltr=!($document[0].dir=='rtl'||$document[0].body.dir=='rtl');// If accessor
	if(arguments.length==0)return ltr?'ltr':'rtl';// If mutator
	var elem=angular.element(element);if(ltr&&angular.isDefined(lValue)){elem.css(property,validateCssValue(lValue));}else if(!ltr&&angular.isDefined(rValue)){elem.css(property,validateCssValue(rValue));}},bidiProperty:function bidiProperty(element,lProperty,rProperty,value){var ltr=!($document[0].dir=='rtl'||$document[0].body.dir=='rtl');var elem=angular.element(element);if(ltr&&angular.isDefined(lProperty)){elem.css(lProperty,validateCssValue(value));elem.css(rProperty,'');}else if(!ltr&&angular.isDefined(rProperty)){elem.css(rProperty,validateCssValue(value));elem.css(lProperty,'');}},clientRect:function clientRect(element,offsetParent,isOffsetRect){var node=getNode(element);offsetParent=getNode(offsetParent||node.offsetParent||document.body);var nodeRect=node.getBoundingClientRect();// The user can ask for an offsetRect: a rect relative to the offsetParent,
	// or a clientRect: a rect relative to the page
	var offsetRect=isOffsetRect?offsetParent.getBoundingClientRect():{left:0,top:0,width:0,height:0};return{left:nodeRect.left-offsetRect.left,top:nodeRect.top-offsetRect.top,width:nodeRect.width,height:nodeRect.height};},offsetRect:function offsetRect(element,offsetParent){return $mdUtil.clientRect(element,offsetParent,true);},// Annoying method to copy nodes to an array, thanks to IE
	nodesToArray:function nodesToArray(nodes){nodes=nodes||[];var results=[];for(var i=0;i<nodes.length;++i){results.push(nodes.item(i));}return results;},/**
	     * Determines the absolute position of the viewport.
	     * Useful when making client rectangles absolute.
	     * @returns {number}
	     */getViewportTop:function getViewportTop(){return window.scrollY||window.pageYOffset||0;},/**
	     * Finds the proper focus target by searching the DOM.
	     *
	     * @param containerEl
	     * @param attributeVal
	     * @returns {*}
	     */findFocusTarget:function findFocusTarget(containerEl,attributeVal){var AUTO_FOCUS=this.prefixer('md-autofocus',true);var elToFocus;elToFocus=scanForFocusable(containerEl,attributeVal||AUTO_FOCUS);if(!elToFocus&&attributeVal!=AUTO_FOCUS){// Scan for deprecated attribute
	elToFocus=scanForFocusable(containerEl,this.prefixer('md-auto-focus',true));if(!elToFocus){// Scan for fallback to 'universal' API
	elToFocus=scanForFocusable(containerEl,AUTO_FOCUS);}}return elToFocus;/**
	       * Can target and nested children for specified Selector (attribute)
	       * whose value may be an expression that evaluates to True/False.
	       */function scanForFocusable(target,selector){var elFound,items=target[0].querySelectorAll(selector);// Find the last child element with the focus attribute
	if(items&&items.length){items.length&&angular.forEach(items,function(it){it=angular.element(it);// Check the element for the md-autofocus class to ensure any associated expression
	// evaluated to true.
	var isFocusable=it.hasClass('md-autofocus');if(isFocusable)elFound=it;});}return elFound;}},/**
	     * Disables scroll around the passed parent element.
	     * @param element Unused
	     * @param {!Element|!angular.JQLite} parent Element to disable scrolling within.
	     *   Defaults to body if none supplied.
	     * @param options Object of options to modify functionality
	     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	     *     use the passed parent element.
	     */disableScrollAround:function disableScrollAround(element,parent,options){options=options||{};$mdUtil.disableScrollAround._count=Math.max(0,$mdUtil.disableScrollAround._count||0);$mdUtil.disableScrollAround._count++;if($mdUtil.disableScrollAround._restoreScroll){return $mdUtil.disableScrollAround._restoreScroll;}var body=$document[0].body;var restoreBody=disableBodyScroll();var restoreElement=disableElementScroll(parent);return $mdUtil.disableScrollAround._restoreScroll=function(){if(--$mdUtil.disableScrollAround._count<=0){restoreBody();restoreElement();delete $mdUtil.disableScrollAround._restoreScroll;}};/**
	       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
	       * and wheel events
	       */function disableElementScroll(element){element=angular.element(element||body);var scrollMask;if(options.disableScrollMask){scrollMask=element;}else{scrollMask=angular.element('<div class="md-scroll-mask">'+'  <div class="md-scroll-mask-bar"></div>'+'</div>');element.append(scrollMask);}scrollMask.on('wheel',preventDefault);scrollMask.on('touchmove',preventDefault);return function restoreElementScroll(){scrollMask.off('wheel');scrollMask.off('touchmove');if(!options.disableScrollMask&&scrollMask[0].parentNode){scrollMask[0].parentNode.removeChild(scrollMask[0]);}};function preventDefault(e){e.preventDefault();}}// Converts the body to a position fixed block and translate it to the proper scroll position
	function disableBodyScroll(){var documentElement=$document[0].documentElement;var prevDocumentStyle=documentElement.style.cssText||'';var prevBodyStyle=body.style.cssText||'';var viewportTop=$mdUtil.getViewportTop();var clientWidth=body.clientWidth;var hasVerticalScrollbar=body.scrollHeight>body.clientHeight+1;// Scroll may be set on <html> element (for example by overflow-y: scroll)
	// but Chrome is reporting the scrollTop position always on <body>.
	// scrollElement will allow to restore the scrollTop position to proper target.
	var scrollElement=documentElement.scrollTop>0?documentElement:body;if(hasVerticalScrollbar){angular.element(body).css({position:'fixed',width:'100%',top:-viewportTop+'px'});}if(body.clientWidth<clientWidth){body.style.overflow='hidden';}// This should be applied after the manipulation to the body, because
	// adding a scrollbar can potentially resize it, causing the measurement
	// to change.
	if(hasVerticalScrollbar){documentElement.style.overflowY='scroll';}return function restoreScroll(){// Reset the inline style CSS to the previous.
	body.style.cssText=prevBodyStyle;documentElement.style.cssText=prevDocumentStyle;// The scroll position while being fixed
	scrollElement.scrollTop=viewportTop;};}},enableScrolling:function enableScrolling(){var restoreFn=this.disableScrollAround._restoreScroll;restoreFn&&restoreFn();},floatingScrollbars:function floatingScrollbars(){if(this.floatingScrollbars.cached===undefined){var tempNode=angular.element('<div><div></div></div>').css({width:'100%','z-index':-1,position:'absolute',height:'35px','overflow-y':'scroll'});tempNode.children().css('height','60px');$document[0].body.appendChild(tempNode[0]);this.floatingScrollbars.cached=tempNode[0].offsetWidth==tempNode[0].childNodes[0].offsetWidth;tempNode.remove();}return this.floatingScrollbars.cached;},// Mobile safari only allows you to set focus in click event listeners...
	forceFocus:function forceFocus(element){var node=element[0]||element;document.addEventListener('click',function focusOnClick(ev){if(ev.target===node&&ev.$focus){node.focus();ev.stopImmediatePropagation();ev.preventDefault();node.removeEventListener('click',focusOnClick);}},true);var newEvent=document.createEvent('MouseEvents');newEvent.initMouseEvent('click',false,true,window,{},0,0,0,0,false,false,false,false,0,null);newEvent.$material=true;newEvent.$focus=true;node.dispatchEvent(newEvent);},/**
	     * facade to build md-backdrop element with desired styles
	     * NOTE: Use $compile to trigger backdrop postLink function
	     */createBackdrop:function createBackdrop(scope,addClass){return $compile($mdUtil.supplant('<md-backdrop class="{0}">',[addClass]))(scope);},/**
	     * supplant() method from Crockford's `Remedial Javascript`
	     * Equivalent to use of $interpolate; without dependency on
	     * interpolation symbols and scope. Note: the '{<token>}' can
	     * be property names, property chains, or array indices.
	     */supplant:function supplant(template,values,pattern){pattern=pattern||/\{([^{}]*)\}/g;return template.replace(pattern,function(a,b){var p=b.split('.'),r=values;try{for(var s in p){if(p.hasOwnProperty(s)){r=r[p[s]];}}}catch(e){r=a;}return typeof r==='string'||typeof r==='number'?r:a;});},fakeNgModel:function fakeNgModel(){return{$fake:true,$setTouched:angular.noop,$setViewValue:function $setViewValue(value){this.$viewValue=value;this.$render(value);this.$viewChangeListeners.forEach(function(cb){cb();});},$isEmpty:function $isEmpty(value){return(''+value).length===0;},$parsers:[],$formatters:[],$viewChangeListeners:[],$render:angular.noop};},// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds.
	// @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
	// @param invokeApply should the $timeout trigger $digest() dirty checking
	debounce:function debounce(func,wait,scope,invokeApply){var timer;return function debounced(){var context=scope,args=Array.prototype.slice.call(arguments);$timeout.cancel(timer);timer=$timeout(function(){timer=undefined;func.apply(context,args);},wait||10,invokeApply);};},// Returns a function that can only be triggered every `delay` milliseconds.
	// In other words, the function will not be called unless it has been more
	// than `delay` milliseconds since the last call.
	throttle:function throttle(func,delay){var recent;return function throttled(){var context=this;var args=arguments;var now=$mdUtil.now();if(!recent||now-recent>delay){func.apply(context,args);recent=now;}};},/**
	     * Measures the number of milliseconds taken to run the provided callback
	     * function. Uses a high-precision timer if available.
	     */time:function time(cb){var start=$mdUtil.now();cb();return $mdUtil.now()-start;},/**
	     * Create an implicit getter that caches its `getter()`
	     * lookup value
	     */valueOnUse:function valueOnUse(scope,key,getter){var value=null,args=Array.prototype.slice.call(arguments);var params=args.length>3?args.slice(3):[];Object.defineProperty(scope,key,{get:function get(){if(value===null)value=getter.apply(scope,params);return value;}});},/**
	     * Get a unique ID.
	     *
	     * @returns {string} an unique numeric string
	     */nextUid:function nextUid(){return''+nextUniqueId++;},// Stop watchers and events from firing on a scope without destroying it,
	// by disconnecting it from its parent and its siblings' linked lists.
	disconnectScope:function disconnectScope(scope){if(!scope)return;// we can't destroy the root scope or a scope that has been already destroyed
	if(scope.$root===scope)return;if(scope.$$destroyed)return;var parent=scope.$parent;scope.$$disconnected=true;// See Scope.$destroy
	if(parent.$$childHead===scope)parent.$$childHead=scope.$$nextSibling;if(parent.$$childTail===scope)parent.$$childTail=scope.$$prevSibling;if(scope.$$prevSibling)scope.$$prevSibling.$$nextSibling=scope.$$nextSibling;if(scope.$$nextSibling)scope.$$nextSibling.$$prevSibling=scope.$$prevSibling;scope.$$nextSibling=scope.$$prevSibling=null;},// Undo the effects of disconnectScope above.
	reconnectScope:function reconnectScope(scope){if(!scope)return;// we can't disconnect the root node or scope already disconnected
	if(scope.$root===scope)return;if(!scope.$$disconnected)return;var child=scope;var parent=child.$parent;child.$$disconnected=false;// See Scope.$new for this logic...
	child.$$prevSibling=parent.$$childTail;if(parent.$$childHead){parent.$$childTail.$$nextSibling=child;parent.$$childTail=child;}else{parent.$$childHead=parent.$$childTail=child;}},/*
	     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
	     *
	     * @param el Element to start walking the DOM from
	     * @param check Either a string or a function. If a string is passed, it will be evaluated against
	     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each of
	     * the parents and will use the return value to determine whether the node is a match.
	     * @param onlyParent Only start checking from the parent element, not `el`.
	     */getClosest:function getClosest(el,validateWith,onlyParent){if(angular.isString(validateWith)){var tagName=validateWith.toUpperCase();validateWith=function validateWith(el){return el.nodeName.toUpperCase()===tagName;};}if(el instanceof angular.element)el=el[0];if(onlyParent)el=el.parentNode;if(!el)return null;do{if(validateWith(el)){return el;}}while(el=el.parentNode);return null;},/**
	     * Build polyfill for the Node.contains feature (if needed)
	     */elementContains:function elementContains(node,child){var hasContains=window.Node&&window.Node.prototype&&Node.prototype.contains;var findFn=hasContains?angular.bind(node,node.contains):angular.bind(node,function(arg){// compares the positions of two nodes and returns a bitmask
	return node===child||!!(this.compareDocumentPosition(arg)&16);});return findFn(child);},/**
	     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
	     * useful with interimElements where the element and its container are important...
	     *
	     * @param {[]} elements to scan
	     * @param {string} name of node to find (e.g. 'md-dialog')
	     * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
	     * @param {boolean=} optional flag to enable log warnings; defaults to false
	     */extractElementByName:function extractElementByName(element,nodeName,scanDeep,warnNotFound){var found=scanTree(element);if(!found&&!!warnNotFound){$log.warn($mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName,element[0].outerHTML]));}return angular.element(found||element);/**
	       * Breadth-First tree scan for element with matching `nodeName`
	       */function scanTree(element){return scanLevel(element)||(scanDeep?scanChildren(element):null);}/**
	       * Case-insensitive scan of current elements only (do not descend).
	       */function scanLevel(element){if(element){for(var i=0,len=element.length;i<len;i++){if(element[i].nodeName.toLowerCase()===nodeName){return element[i];}}}return null;}/**
	       * Scan children of specified node
	       */function scanChildren(element){var found;if(element){for(var i=0,len=element.length;i<len;i++){var target=element[i];if(!found){for(var j=0,numChild=target.childNodes.length;j<numChild;j++){found=found||scanTree([target.childNodes[j]]);}}}}return found;}},/**
	     * Give optional properties with no value a boolean true if attr provided or false otherwise
	     */initOptionalProperties:function initOptionalProperties(scope,attr,defaults){defaults=defaults||{};angular.forEach(scope.$$isolateBindings,function(binding,key){if(binding.optional&&angular.isUndefined(scope[key])){var attrIsDefined=angular.isDefined(attr[binding.attrName]);scope[key]=angular.isDefined(defaults[key])?defaults[key]:attrIsDefined;}});},/**
	     * Alternative to $timeout calls with 0 delay.
	     * nextTick() coalesces all calls within a single frame
	     * to minimize $digest thrashing
	     *
	     * @param callback
	     * @param digest
	     * @returns {*}
	     */nextTick:function nextTick(callback,digest,scope){//-- grab function reference for storing state details
	var nextTick=$mdUtil.nextTick;var timeout=nextTick.timeout;var queue=nextTick.queue||[];//-- add callback to the queue
	queue.push({scope:scope,callback:callback});//-- set default value for digest
	if(digest==null)digest=true;//-- store updated digest/queue values
	nextTick.digest=nextTick.digest||digest;nextTick.queue=queue;//-- either return existing timeout or create a new one
	return timeout||(nextTick.timeout=$timeout(processQueue,0,false));/**
	       * Grab a copy of the current queue
	       * Clear the queue for future use
	       * Process the existing queue
	       * Trigger digest if necessary
	       */function processQueue(){var queue=nextTick.queue;var digest=nextTick.digest;nextTick.queue=[];nextTick.timeout=null;nextTick.digest=false;queue.forEach(function(queueItem){var skip=queueItem.scope&&queueItem.scope.$$destroyed;if(!skip){queueItem.callback();}});if(digest)$rootScope.$digest();}},/**
	     * Processes a template and replaces the start/end symbols if the application has
	     * overriden them.
	     *
	     * @param template The template to process whose start/end tags may be replaced.
	     * @returns {*}
	     */processTemplate:function processTemplate(template){if(usesStandardSymbols){return template;}else{if(!template||!angular.isString(template))return template;return template.replace(/\{\{/g,startSymbol).replace(/}}/g,endSymbol);}},/**
	     * Scan up dom hierarchy for enabled parent;
	     */getParentWithPointerEvents:function getParentWithPointerEvents(element){var parent=element.parent();// jqLite might return a non-null, but still empty, parent; so check for parent and length
	while(hasComputedStyle(parent,'pointer-events','none')){parent=parent.parent();}return parent;},getNearestContentElement:function getNearestContentElement(element){var current=element.parent()[0];// Look for the nearest parent md-content, stopping at the rootElement.
	while(current&&current!==$rootElement[0]&&current!==document.body&&current.nodeName.toUpperCase()!=='MD-CONTENT'){current=current.parentNode;}return current;},/**
	     * Checks if the current browser is natively supporting the `sticky` position.
	     * @returns {string} supported sticky property name
	     */checkStickySupport:function checkStickySupport(){var stickyProp;var testEl=angular.element('<div>');$document[0].body.appendChild(testEl[0]);var stickyProps=['sticky','-webkit-sticky'];for(var i=0;i<stickyProps.length;++i){testEl.css({position:stickyProps[i],top:0,'z-index':2});if(testEl.css('position')==stickyProps[i]){stickyProp=stickyProps[i];break;}}testEl.remove();return stickyProp;},/**
	     * Parses an attribute value, mostly a string.
	     * By default checks for negated values and returns `false´ if present.
	     * Negated values are: (native falsy) and negative strings like:
	     * `false` or `0`.
	     * @param value Attribute value which should be parsed.
	     * @param negatedCheck When set to false, won't check for negated values.
	     * @returns {boolean}
	     */parseAttributeBoolean:function parseAttributeBoolean(value,negatedCheck){return value===''||!!value&&(negatedCheck===false||value!=='false'&&value!=='0');},hasComputedStyle:hasComputedStyle,/**
	     * Returns true if the parent form of the element has been submitted.
	     *
	     * @param element An AngularJS or HTML5 element.
	     *
	     * @returns {boolean}
	     */isParentFormSubmitted:function isParentFormSubmitted(element){var parent=$mdUtil.getClosest(element,'form');var form=parent?angular.element(parent).controller('form'):null;return form?form.$submitted:false;},/**
	     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
	     *
	     * @param {!HTMLElement} element The element to scroll.
	     * @param {number} scrollEnd The new/final scroll position.
	     * @param {number=} duration Duration of the scroll. Default is 1000ms.
	     */animateScrollTo:function animateScrollTo(element,scrollEnd,duration){var scrollStart=element.scrollTop;var scrollChange=scrollEnd-scrollStart;var scrollingDown=scrollStart<scrollEnd;var startTime=$mdUtil.now();$$rAF(scrollChunk);function scrollChunk(){var newPosition=calculateNewPosition();element.scrollTop=newPosition;if(scrollingDown?newPosition<scrollEnd:newPosition>scrollEnd){$$rAF(scrollChunk);}}function calculateNewPosition(){var easeDuration=duration||1000;var currentTime=$mdUtil.now()-startTime;return ease(currentTime,scrollStart,scrollChange,easeDuration);}function ease(currentTime,start,change,duration){// If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
	// straight to the proper position
	if(currentTime>duration){return start+change;}var ts=(currentTime/=duration)*currentTime;var tc=ts*currentTime;return start+change*(-2*tc+3*ts);}},/**
	     * Provides an easy mechanism for removing duplicates from an array.
	     *
	     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
	     *
	     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
	     *
	     * @param {array} array The array whose unique values should be returned.
	     *
	     * @returns {array} A copy of the array containing only unique values.
	     */uniq:function uniq(array){if(!array){return;}return array.filter(function(value,index,self){return self.indexOf(value)===index;});}};// Instantiate other namespace utility methods
	$mdUtil.dom.animator=$$mdAnimate($mdUtil);return $mdUtil;function getNode(el){return el[0]||el;}}/*
	 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
	 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
	 */angular.element.prototype.focus=angular.element.prototype.focus||function(){if(this.length){this[0].focus();}return this;};angular.element.prototype.blur=angular.element.prototype.blur||function(){if(this.length){this[0].blur();}return this;};})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.core.aria
	 * @description
	 * Aria Expectations for AngularJS Material components.
	 */MdAriaService.$inject=["$$rAF","$log","$window","$interpolate"];angular.module('material.core').provider('$mdAria',MdAriaProvider);/**
	 * @ngdoc service
	 * @name $mdAriaProvider
	 * @module material.core.aria
	 *
	 * @description
	 *
	 * Modify options of the `$mdAria` service, which will be used by most of the AngularJS Material
	 * components.
	 *
	 * You are able to disable `$mdAria` warnings, by using the following markup.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdAriaProvider) {
	 *     // Globally disables all ARIA warnings.
	 *     $mdAriaProvider.disableWarnings();
	 *   });
	 * </hljs>
	 *
	 */function MdAriaProvider(){var config={/** Whether we should show ARIA warnings in the console if labels are missing on the element */showWarnings:true};return{disableWarnings:disableWarnings,$get:["$$rAF","$log","$window","$interpolate",function($$rAF,$log,$window,$interpolate){return MdAriaService.apply(config,arguments);}]};/**
	   * @ngdoc method
	   * @name $mdAriaProvider#disableWarnings
	   * @description Disables all ARIA warnings generated by AngularJS Material.
	   */function disableWarnings(){config.showWarnings=false;}}/*
	 * @ngInject
	 */function MdAriaService($$rAF,$log,$window,$interpolate){// Load the showWarnings option from the current context and store it inside of a scope variable,
	// because the context will be probably lost in some function calls.
	var showWarnings=this.showWarnings;return{expect:expect,expectAsync:expectAsync,expectWithText:expectWithText,expectWithoutText:expectWithoutText,getText:getText,hasAriaLabel:hasAriaLabel,parentHasAriaLabel:parentHasAriaLabel};/**
	   * Check if expected attribute has been specified on the target element or child
	   * @param element
	   * @param attrName
	   * @param {optional} defaultValue What to set the attr to if no value is found
	   */function expect(element,attrName,defaultValue){var node=angular.element(element)[0]||element;// if node exists and neither it nor its children have the attribute
	if(node&&(!node.hasAttribute(attrName)||node.getAttribute(attrName).length===0)&&!childHasAttribute(node,attrName)){defaultValue=angular.isString(defaultValue)?defaultValue.trim():'';if(defaultValue.length){element.attr(attrName,defaultValue);}else if(showWarnings){$log.warn('ARIA: Attribute "',attrName,'", required for accessibility, is missing on node:',node);}}}function expectAsync(element,attrName,defaultValueGetter){// Problem: when retrieving the element's contents synchronously to find the label,
	// the text may not be defined yet in the case of a binding.
	// There is a higher chance that a binding will be defined if we wait one frame.
	$$rAF(function(){expect(element,attrName,defaultValueGetter());});}function expectWithText(element,attrName){var content=getText(element)||"";var hasBinding=content.indexOf($interpolate.startSymbol())>-1;if(hasBinding){expectAsync(element,attrName,function(){return getText(element);});}else{expect(element,attrName,content);}}function expectWithoutText(element,attrName){var content=getText(element);var hasBinding=content.indexOf($interpolate.startSymbol())>-1;if(!hasBinding&&!content){expect(element,attrName,content);}}function getText(element){element=element[0]||element;var walker=document.createTreeWalker(element,NodeFilter.SHOW_TEXT,null,false);var text='';var node;while(node=walker.nextNode()){if(!isAriaHiddenNode(node)){text+=node.textContent;}}return text.trim()||'';function isAriaHiddenNode(node){while(node.parentNode&&(node=node.parentNode)!==element){if(node.getAttribute&&node.getAttribute('aria-hidden')==='true'){return true;}}}}function childHasAttribute(node,attrName){var hasChildren=node.hasChildNodes(),hasAttr=false;function isHidden(el){var style=el.currentStyle?el.currentStyle:$window.getComputedStyle(el);return style.display==='none';}if(hasChildren){var children=node.childNodes;for(var i=0;i<children.length;i++){var child=children[i];if(child.nodeType===1&&child.hasAttribute(attrName)){if(!isHidden(child)){hasAttr=true;}}}}return hasAttr;}/**
	   * Check if expected element has aria label attribute
	   * @param element
	   */function hasAriaLabel(element){var node=angular.element(element)[0]||element;/* Check if compatible node type (ie: not HTML Document node) */if(!node.hasAttribute){return false;}/* Check label or description attributes */return node.hasAttribute('aria-label')||node.hasAttribute('aria-labelledby')||node.hasAttribute('aria-describedby');}/**
	   * Check if expected element's parent has aria label attribute and has valid role and tagName
	   * @param element
	   * @param {optional} level Number of levels deep search should be performed
	   */function parentHasAriaLabel(element,level){level=level||1;var node=angular.element(element)[0]||element;if(!node.parentNode){return false;}if(performCheck(node.parentNode)){return true;}level--;if(level){return parentHasAriaLabel(node.parentNode,level);}return false;function performCheck(parentNode){if(!hasAriaLabel(parentNode)){return false;}/* Perform role blacklist check */if(parentNode.hasAttribute('role')){switch(parentNode.getAttribute('role').toLowerCase()){case'command':case'definition':case'directory':case'grid':case'list':case'listitem':case'log':case'marquee':case'menu':case'menubar':case'note':case'presentation':case'separator':case'scrollbar':case'status':case'tablist':return false;}}/* Perform tagName blacklist check */switch(parentNode.tagName.toLowerCase()){case'abbr':case'acronym':case'address':case'applet':case'audio':case'b':case'bdi':case'bdo':case'big':case'blockquote':case'br':case'canvas':case'caption':case'center':case'cite':case'code':case'col':case'data':case'dd':case'del':case'dfn':case'dir':case'div':case'dl':case'em':case'embed':case'fieldset':case'figcaption':case'font':case'h1':case'h2':case'h3':case'h4':case'h5':case'h6':case'hgroup':case'html':case'i':case'ins':case'isindex':case'kbd':case'keygen':case'label':case'legend':case'li':case'map':case'mark':case'menu':case'object':case'ol':case'output':case'pre':case'presentation':case'q':case'rt':case'ruby':case'samp':case'small':case'source':case'span':case'status':case'strike':case'strong':case'sub':case'sup':case'svg':case'tbody':case'td':case'th':case'thead':case'time':case'tr':case'track':case'tt':case'ul':case'var':return false;}return true;}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.core.compiler
	 * @description
	 * AngularJS Material template and element compiler.
	 */angular.module('material.core').provider('$mdCompiler',MdCompilerProvider);/**
	 * @ngdoc service
	 * @name $mdCompiler
	 * @module material.core.compiler
	 * @description
	 * The $mdCompiler service is an abstraction of AngularJS's compiler, that allows developers
	 * to easily compile an element with options like in a Directive Definition Object.
	 *
	 * > The compiler powers a lot of components inside of AngularJS Material.
	 * > Like the `$mdPanel` or `$mdDialog`.
	 *
	 * @usage
	 *
	 * Basic Usage with a template
	 *
	 * <hljs lang="js">
	 *   $mdCompiler.compile({
	 *     templateUrl: 'modal.html',
	 *     controller: 'ModalCtrl',
	 *     locals: {
	 *       modal: myModalInstance;
	 *     }
	 *   }).then(function (compileData) {
	 *     compileData.element; // Compiled DOM element
	 *     compileData.link(myScope); // Instantiate controller and link element to scope.
	 *   });
	 * </hljs>
	 *
	 * Example with a content element
	 *
	 * <hljs lang="js">
	 *
	 *   // Create a virtual element and link it manually.
	 *   // The compiler doesn't need to recompile the element each time.
	 *   var myElement = $compile('<span>Test</span>')(myScope);
	 *
	 *   $mdCompiler.compile({
	 *     contentElement: myElement
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 * > Content Element is a significant performance improvement when the developer already knows that the
	 * > compiled element will be always the same and the scope will not change either.
	 *
	 * The `contentElement` option also supports DOM elements which will be temporary removed and restored
	 * at its old position.
	 *
	 * <hljs lang="js">
	 *   var domElement = document.querySelector('#myElement');
	 *
	 *   $mdCompiler.compile({
	 *     contentElement: myElement
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 * The `$mdCompiler` can also query for the element in the DOM itself.
	 *
	 * <hljs lang="js">
	 *   $mdCompiler.compile({
	 *     contentElement: '#myElement'
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 */MdCompilerProvider.$inject=['$compileProvider'];function MdCompilerProvider($compileProvider){var provider=this;/**
	   * @name  $mdCompilerProvider#respectPreAssignBindingsEnabled
	   *
	   * @param {boolean=} respected update the respectPreAssignBindingsEnabled state if provided, otherwise just return
	   * the current Material preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @description
	   * Call this method to enable/disable whether Material-specific (dialogs/toasts) controllers respect the AngularJS
	   * `$compile.preAssignBindingsEnabled` flag. Note that this doesn't affect directives/components created via
	   * regular AngularJS methods which constitute most Material & user-created components.
	   *
	   * @see [AngularJS documentation for `$compile.preAssignBindingsEnabled`
	   * ](https://code.angularjs.org/1.6.4/docs/api/ng/provider/$compileProvider#preAssignBindingsEnabled)
	   * for more information.
	   *
	   * If disabled (false), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If enabled (true) the behavior depends on the AngularJS version used:
	   *
	   *     - `<1.5.10` - bindings are pre-assigned
	   *     - `>=1.5.10 <1.7` - behaves like set to whatever `$compileProvider.preAssignBindingsEnabled()` reports; if
	   *                         the `$compileProvider` flag wasn't set manually, it defaults to pre-assigning bindings
	   *                         with AngularJS `1.5.x` & to calling the constructor first with AngularJS `1.6.x`.
	   *     - `>=1.7` - the compiler calls the constructor first before assigning bindings
	   *
	   * The default value is `false` but will change to `true` in AngularJS Material 1.2.
	   *
	   * It is recommended to set this flag to `true` in AngularJS Material 1.1.x; the only reason it's not set that way
	   * by default is backwards compatibility. Not setting the flag to `true` when
	   * `$compileProvider.preAssignBindingsEnabled()` is set to `false` (i.e. default behavior in AngularJS 1.6.0 or newer)
	   * makes it hard to unit test Material Dialog/Toast controllers using the `$controller` helper as it always follows
	   * the `$compileProvider.preAssignBindingsEnabled()` value.
	   */// TODO change it to `true` in Material 1.2.
	var respectPreAssignBindingsEnabled=false;this.respectPreAssignBindingsEnabled=function(respected){if(angular.isDefined(respected)){respectPreAssignBindingsEnabled=respected;return this;}return respectPreAssignBindingsEnabled;};/**
	   * @description
	   * This function returns `true` if Material-specific (dialogs/toasts) controllers have bindings pre-assigned in
	   * controller constructors and `false` otherwise.
	   *
	   * Note that this doesn't affect directives/components created via regular AngularJS methods which constitute most
	   * Material & user-created components; their behavior can be checked via `$compileProvider.preAssignBindingsEnabled()`
	   * in AngularJS `>=1.5.10 <1.7.0`.
	   *
	   * @returns {*} current preAssignBindingsEnabled state
	   */function getPreAssignBindingsEnabled(){if(!respectPreAssignBindingsEnabled){// respectPreAssignBindingsEnabled === false
	// We're ignoring the AngularJS `$compileProvider.preAssignBindingsEnabled()` value in this case.
	return true;}// respectPreAssignBindingsEnabled === true
	if(typeof $compileProvider.preAssignBindingsEnabled==='function'){return $compileProvider.preAssignBindingsEnabled();}// Flag respected but not present => apply logic based on AngularJS version used.
	if(angular.version.major===1&&angular.version.minor<6){// AngularJS <1.5.10
	return true;}// AngularJS >=1.7.0
	return false;}this.$get=["$q","$templateRequest","$injector","$compile","$controller",function($q,$templateRequest,$injector,$compile,$controller){return new MdCompilerService($q,$templateRequest,$injector,$compile,$controller);}];function MdCompilerService($q,$templateRequest,$injector,$compile,$controller){/** @private @const {!angular.$q} */this.$q=$q;/** @private @const {!angular.$templateRequest} */this.$templateRequest=$templateRequest;/** @private @const {!angular.$injector} */this.$injector=$injector;/** @private @const {!angular.$compile} */this.$compile=$compile;/** @private @const {!angular.$controller} */this.$controller=$controller;}/**
	   * @ngdoc method
	   * @name $mdCompiler#compile
	   * @description
	   *
	   * A method to compile a HTML template with the AngularJS compiler.
	   * The `$mdCompiler` is wrapper around the AngularJS compiler and provides extra functionality
	   * like controller instantiation or async resolves.
	   *
	   * @param {!Object} options An options object, with the following properties:
	   *
	   *    - `controller` - `{string|Function}` Controller fn that should be associated with
	   *         newly created scope or the name of a registered controller if passed as a string.
	   *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
	   *         published to scope under the `controllerAs` name.
	   *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
	   *         compiled each time, you can also use a DOM element.<br/>
	   *    - `template` - `{string=}` An html template as a string.
	   *    - `templateUrl` - `{string=}` A path to an html template.
	   *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
	   *        it is loaded. It will be given the template string as a parameter, and should
	   *        return a a new string representing the transformed template.
	   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
	   *        be injected into the controller. If any of these dependencies are promises, the compiler
	   *        will wait for them all to be resolved, or if one is rejected before the controller is
	   *        instantiated `compile()` will fail..
	   *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
	   *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
	   *        Otherwise if function, then it is injected and the return value is treated as the
	   *        dependency. If the result is a promise, it is resolved before its value is
	   *        injected into the controller.
	   *
	   * @returns {Object} promise A promise, which will be resolved with a `compileData` object.
	   * `compileData` has the following properties:
	   *
	   *   - `element` - `{element}`: an uncompiled element matching the provided template.
	   *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
	   *     the element and instantiate the provided controller (if given).
	   *   - `locals` - `{object}`: The locals which will be passed into the controller once `link` is
	   *     called. If `bindToController` is true, they will be coppied to the ctrl instead
	   *
	   */MdCompilerService.prototype.compile=function(options){if(options.contentElement){return this._prepareContentElement(options);}else{return this._compileTemplate(options);}};/**
	   * Instead of compiling any template, the compiler just fetches an existing HTML element from the DOM and
	   * provides a restore function to put the element back it old DOM position.
	   * @param {!Object} options Options to be used for the compiler.
	   */MdCompilerService.prototype._prepareContentElement=function(options){var contentElement=this._fetchContentElement(options);return this.$q.resolve({element:contentElement.element,cleanup:contentElement.restore,locals:{},link:function link(){return contentElement.element;}});};/**
	   * Compiles a template by considering all options and waiting for all resolves to be ready.
	   * @param {!Object} options Compile options
	   * @returns {!Object} Compile data with link function.
	   */MdCompilerService.prototype._compileTemplate=function(options){var self=this;var templateUrl=options.templateUrl;var template=options.template||'';var resolve=angular.extend({},options.resolve);var locals=angular.extend({},options.locals);var transformTemplate=options.transformTemplate||angular.identity;// Take resolve values and invoke them.
	// Resolves can either be a string (value: 'MyRegisteredAngularConst'),
	// or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
	angular.forEach(resolve,function(value,key){if(angular.isString(value)){resolve[key]=self.$injector.get(value);}else{resolve[key]=self.$injector.invoke(value);}});// Add the locals, which are just straight values to inject
	// eg locals: { three: 3 }, will inject three into the controller
	angular.extend(resolve,locals);if(templateUrl){resolve.$$ngTemplate=this.$templateRequest(templateUrl);}else{resolve.$$ngTemplate=this.$q.when(template);}// Wait for all the resolves to finish if they are promises
	return this.$q.all(resolve).then(function(locals){var template=transformTemplate(locals.$$ngTemplate,options);var element=options.element||angular.element('<div>').html(template.trim()).contents();return self._compileElement(locals,element,options);});};/**
	   * Method to compile an element with the given options.
	   * @param {!Object} locals Locals to be injected to the controller if present
	   * @param {!JQLite} element Element to be compiled and linked
	   * @param {!Object} options Options to be used for linking.
	   * @returns {!Object} Compile data with link function.
	   */MdCompilerService.prototype._compileElement=function(locals,element,options){var self=this;var ngLinkFn=this.$compile(element);var compileData={element:element,cleanup:element.remove.bind(element),locals:locals,link:linkFn};function linkFn(scope){locals.$scope=scope;// Instantiate controller if the developer provided one.
	if(options.controller){var injectLocals=angular.extend({},locals,{$element:element});// Create the specified controller instance.
	var ctrl=self._createController(options,injectLocals,locals);// Unique identifier for AngularJS Route ngView controllers.
	element.data('$ngControllerController',ctrl);element.children().data('$ngControllerController',ctrl);// Expose the instantiated controller to the compile data
	compileData.controller=ctrl;}// Invoke the AngularJS $compile link function.
	return ngLinkFn(scope);}return compileData;};/**
	   * Creates and instantiates a new controller with the specified options.
	   * @param {!Object} options Options that include the controller
	   * @param {!Object} injectLocals Locals to to be provided in the controller DI.
	   * @param {!Object} locals Locals to be injected to the controller.
	   * @returns {!Object} Created controller instance.
	   */MdCompilerService.prototype._createController=function(options,injectLocals,locals){// The third and fourth arguments to $controller are considered private and are undocumented:
	// https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L86
	// Passing `true` as the third argument causes `$controller` to return a function that
	// gets the controller instance instead returning of the instance directly. When the
	// controller is defined as a function, `invokeCtrl.instance` is the *same instance* as
	// `invokeCtrl()`. However, then the controller is an ES6 class, `invokeCtrl.instance` is a
	// *different instance* from `invokeCtrl()`.
	var invokeCtrl=this.$controller(options.controller,injectLocals,true,options.controllerAs);if(getPreAssignBindingsEnabled()&&options.bindToController){angular.extend(invokeCtrl.instance,locals);}// Instantiate and initialize the specified controller.
	var ctrl=invokeCtrl();if(!getPreAssignBindingsEnabled()&&options.bindToController){angular.extend(ctrl,locals);}// Call the $onInit hook if it's present on the controller.
	angular.isFunction(ctrl.$onInit)&&ctrl.$onInit();return ctrl;};/**
	   * Fetches an element removing it from the DOM and using it temporary for the compiler.
	   * Elements which were fetched will be restored after use.
	   * @param {!Object} options Options to be used for the compilation.
	   * @returns {{element: !JQLite, restore: !Function}}
	   */MdCompilerService.prototype._fetchContentElement=function(options){var contentEl=options.contentElement;var restoreFn=null;if(angular.isString(contentEl)){contentEl=document.querySelector(contentEl);restoreFn=createRestoreFn(contentEl);}else{contentEl=contentEl[0]||contentEl;// When the element is visible in the DOM, then we restore it at close of the dialog.
	// Otherwise it will be removed from the DOM after close.
	if(document.contains(contentEl)){restoreFn=createRestoreFn(contentEl);}else{restoreFn=function restoreFn(){if(contentEl.parentNode){contentEl.parentNode.removeChild(contentEl);}};}}return{element:angular.element(contentEl),restore:restoreFn};function createRestoreFn(element){var parent=element.parentNode;var nextSibling=element.nextElementSibling;return function(){if(!nextSibling){// When the element didn't had any sibling, then it can be simply appended to the
	// parent, because it plays no role, which index it had before.
	parent.appendChild(element);}else{// When the element had a sibling, which marks the previous position of the element
	// in the DOM, we insert it correctly before the sibling, to have the same index as
	// before.
	parent.insertBefore(element,nextSibling);}};}};}})();(function(){"use strict";MdGesture.$inject=["$$MdGestureHandler","$$rAF","$timeout"];attachToDocument.$inject=["$mdGesture","$$MdGestureHandler"];var HANDLERS={};/* The state of the current 'pointer'
	 * The pointer represents the state of the current touch.
	 * It contains normalized x and y coordinates from DOM events,
	 * as well as other information abstracted from the DOM.
	 */var pointer,lastPointer,forceSkipClickHijack=false,maxClickDistance=6;/**
	 * The position of the most recent click if that click was on a label element.
	 * @type {{x: number, y: number}?}
	 */var lastLabelClickPos=null;// Used to attach event listeners once when multiple ng-apps are running.
	var isInitialized=false;angular.module('material.core.gestures',[]).provider('$mdGesture',MdGestureProvider).factory('$$MdGestureHandler',MdGestureHandler).run(attachToDocument);/**
	   * @ngdoc service
	   * @name $mdGestureProvider
	   * @module material.core.gestures
	   *
	   * @description
	   * In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked.
	   * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking on mobile
	   * devices.
	   * You can also change max click distance (6px by default) if you have issues on some touch screens.
	   *
	   * <hljs lang="js">
	   *   app.config(function($mdGestureProvider) {
	   *
	   *     // For mobile devices without jQuery loaded, do not
	   *     // intercept click events during the capture phase.
	   *     $mdGestureProvider.skipClickHijack();
	   *
	   *     // If hijcacking clicks, change default 6px click distance
	   *     $mdGestureProvider.setMaxClickDistance(12);
	   *
	   *   });
	   * </hljs>
	   *
	   */function MdGestureProvider(){}MdGestureProvider.prototype={// Publish access to setter to configure a variable  BEFORE the
	// $mdGesture service is instantiated...
	skipClickHijack:function skipClickHijack(){return forceSkipClickHijack=true;},setMaxClickDistance:function setMaxClickDistance(clickDistance){maxClickDistance=parseInt(clickDistance);},/**
	   * $get is used to build an instance of $mdGesture
	   * @ngInject
	   */$get:["$$MdGestureHandler","$$rAF","$timeout",function($$MdGestureHandler,$$rAF,$timeout){return new MdGesture($$MdGestureHandler,$$rAF,$timeout);}]};/**
	 * MdGesture factory construction function
	 * @ngInject
	 */function MdGesture($$MdGestureHandler,$$rAF,$timeout){var userAgent=navigator.userAgent||navigator.vendor||window.opera;var isIos=userAgent.match(/ipad|iphone|ipod/i);var isAndroid=userAgent.match(/android/i);var touchActionProperty=getTouchAction();var hasJQuery=typeof window.jQuery!=='undefined'&&angular.element===window.jQuery;var self={handler:addHandler,register:register,isAndroid:isAndroid,isIos:isIos,// On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
	isHijackingClicks:(isIos||isAndroid)&&!hasJQuery&&!forceSkipClickHijack};if(self.isHijackingClicks){self.handler('click',{options:{maxDistance:maxClickDistance},onEnd:checkDistanceAndEmit('click')});self.handler('focus',{options:{maxDistance:maxClickDistance},onEnd:function onEnd(ev,pointer){if(pointer.distance<this.state.options.maxDistance&&canFocus(ev.target)){this.dispatchEvent(ev,'focus',pointer);ev.target.focus();}}});self.handler('mouseup',{options:{maxDistance:maxClickDistance},onEnd:checkDistanceAndEmit('mouseup')});self.handler('mousedown',{onStart:function onStart(ev){this.dispatchEvent(ev,'mousedown');}});}function checkDistanceAndEmit(eventName){return function(ev,pointer){if(pointer.distance<this.state.options.maxDistance){this.dispatchEvent(ev,eventName,pointer);}};}/*
	   * Register an element to listen for a handler.
	   * This allows an element to override the default options for a handler.
	   * Additionally, some handlers like drag and hold only dispatch events if
	   * the domEvent happens inside an element that's registered to listen for these events.
	   *
	   * @see GestureHandler for how overriding of default options works.
	   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horziontal: false })
	   */function register(element,handlerName,options){var handler=HANDLERS[handlerName.replace(/^\$md./,'')];if(!handler){throw new Error('Failed to register element with handler '+handlerName+'. '+'Available handlers: '+Object.keys(HANDLERS).join(', '));}return handler.registerElement(element,options);}/*
	   * add a handler to $mdGesture. see below.
	   */function addHandler(name,definition){var handler=new $$MdGestureHandler(name);angular.extend(handler,definition);HANDLERS[name]=handler;return self;}/*
	   * Register handlers. These listen to touch/start/move events, interpret them,
	   * and dispatch gesture events depending on options & conditions. These are all
	   * instances of GestureHandler.
	   * @see GestureHandler
	   */return self/*
	     * The press handler dispatches an event on touchdown/touchend.
	     * It's a simple abstraction of touch/mouse/pointer start and end.
	     */.handler('press',{onStart:function onStart(ev,pointer){this.dispatchEvent(ev,'$md.pressdown');},onEnd:function onEnd(ev,pointer){this.dispatchEvent(ev,'$md.pressup');}})/*
	     * The hold handler dispatches an event if the user keeps their finger within
	     * the same <maxDistance> area for <delay> ms.
	     * The hold handler will only run if a parent of the touch target is registered
	     * to listen for hold events through $mdGesture.register()
	     */.handler('hold',{options:{maxDistance:6,delay:500},onCancel:function onCancel(){$timeout.cancel(this.state.timeout);},onStart:function onStart(ev,pointer){// For hold, require a parent to be registered with $mdGesture.register()
	// Because we prevent scroll events, this is necessary.
	if(!this.state.registeredParent)return this.cancel();this.state.pos={x:pointer.x,y:pointer.y};this.state.timeout=$timeout(angular.bind(this,function holdDelayFn(){this.dispatchEvent(ev,'$md.hold');this.cancel();//we're done!
	}),this.state.options.delay,false);},onMove:function onMove(ev,pointer){// Don't scroll while waiting for hold.
	// If we don't preventDefault touchmove events here, Android will assume we don't
	// want to listen to anymore touch events. It will start scrolling and stop sending
	// touchmove events.
	if(!touchActionProperty&&ev.type==='touchmove')ev.preventDefault();// If the user moves greater than <maxDistance> pixels, stop the hold timer
	// set in onStart
	var dx=this.state.pos.x-pointer.x;var dy=this.state.pos.y-pointer.y;if(Math.sqrt(dx*dx+dy*dy)>this.options.maxDistance){this.cancel();}},onEnd:function onEnd(){this.onCancel();}})/*
	     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
	     * <minDistance> px in the x or y direction, depending on options.horizontal.
	     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
	     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
	     * pixels vertically, this handler won't consider the move part of a drag.
	     */.handler('drag',{options:{minDistance:6,horizontal:true,cancelMultiplier:1.5},onSetup:function onSetup(element,options){if(touchActionProperty){// We check for horizontal to be false, because otherwise we would overwrite the default opts.
	this.oldTouchAction=element[0].style[touchActionProperty];element[0].style[touchActionProperty]=options.horizontal?'pan-y':'pan-x';}},onCleanup:function onCleanup(element){if(this.oldTouchAction){element[0].style[touchActionProperty]=this.oldTouchAction;}},onStart:function onStart(ev){// For drag, require a parent to be registered with $mdGesture.register()
	if(!this.state.registeredParent)this.cancel();},onMove:function onMove(ev,pointer){var shouldStartDrag,shouldCancel;// Don't scroll while deciding if this touchmove qualifies as a drag event.
	// If we don't preventDefault touchmove events here, Android will assume we don't
	// want to listen to anymore touch events. It will start scrolling and stop sending
	// touchmove events.
	if(!touchActionProperty&&ev.type==='touchmove')ev.preventDefault();if(!this.state.dragPointer){if(this.state.options.horizontal){shouldStartDrag=Math.abs(pointer.distanceX)>this.state.options.minDistance;shouldCancel=Math.abs(pointer.distanceY)>this.state.options.minDistance*this.state.options.cancelMultiplier;}else{shouldStartDrag=Math.abs(pointer.distanceY)>this.state.options.minDistance;shouldCancel=Math.abs(pointer.distanceX)>this.state.options.minDistance*this.state.options.cancelMultiplier;}if(shouldStartDrag){// Create a new pointer representing this drag, starting at this point where the drag started.
	this.state.dragPointer=makeStartPointer(ev);updatePointerState(ev,this.state.dragPointer);this.dispatchEvent(ev,'$md.dragstart',this.state.dragPointer);}else if(shouldCancel){this.cancel();}}else{this.dispatchDragMove(ev);}},// Only dispatch dragmove events every frame; any more is unnecessary
	dispatchDragMove:$$rAF.throttle(function(ev){// Make sure the drag didn't stop while waiting for the next frame
	if(this.state.isRunning){updatePointerState(ev,this.state.dragPointer);this.dispatchEvent(ev,'$md.drag',this.state.dragPointer);}}),onEnd:function onEnd(ev,pointer){if(this.state.dragPointer){updatePointerState(ev,this.state.dragPointer);this.dispatchEvent(ev,'$md.dragend',this.state.dragPointer);}}})/*
	     * The swipe handler will dispatch a swipe event if, on the end of a touch,
	     * the velocity and distance were high enough.
	     */.handler('swipe',{options:{minVelocity:0.65,minDistance:10},onEnd:function onEnd(ev,pointer){var eventType;if(Math.abs(pointer.velocityX)>this.state.options.minVelocity&&Math.abs(pointer.distanceX)>this.state.options.minDistance){eventType=pointer.directionX=='left'?'$md.swipeleft':'$md.swiperight';this.dispatchEvent(ev,eventType);}else if(Math.abs(pointer.velocityY)>this.state.options.minVelocity&&Math.abs(pointer.distanceY)>this.state.options.minDistance){eventType=pointer.directionY=='up'?'$md.swipeup':'$md.swipedown';this.dispatchEvent(ev,eventType);}}});function getTouchAction(){var testEl=document.createElement('div');var vendorPrefixes=['','webkit','Moz','MS','ms','o'];for(var i=0;i<vendorPrefixes.length;i++){var prefix=vendorPrefixes[i];var property=prefix?prefix+'TouchAction':'touchAction';if(angular.isDefined(testEl.style[property])){return property;}}}}/**
	 * MdGestureHandler
	 * A GestureHandler is an object which is able to dispatch custom dom events
	 * based on native dom {touch,pointer,mouse}{start,move,end} events.
	 *
	 * A gesture will manage its lifecycle through the start,move,end, and cancel
	 * functions, which are called by native dom events.
	 *
	 * A gesture has the concept of 'options' (eg a swipe's required velocity), which can be
	 * overridden by elements registering through $mdGesture.register()
	 */function GestureHandler(name){this.name=name;this.state={};}function MdGestureHandler(){var hasJQuery=typeof window.jQuery!=='undefined'&&angular.element===window.jQuery;GestureHandler.prototype={options:{},// jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
	// differently when jQuery is loaded
	dispatchEvent:hasJQuery?jQueryDispatchEvent:nativeDispatchEvent,// These are overridden by the registered handler
	onSetup:angular.noop,onCleanup:angular.noop,onStart:angular.noop,onMove:angular.noop,onEnd:angular.noop,onCancel:angular.noop,// onStart sets up a new state for the handler, which includes options from the
	// nearest registered parent element of ev.target.
	start:function start(ev,pointer){if(this.state.isRunning)return;var parentTarget=this.getNearestParent(ev.target);// Get the options from the nearest registered parent
	var parentTargetOptions=parentTarget&&parentTarget.$mdGesture[this.name]||{};this.state={isRunning:true,// Override the default options with the nearest registered parent's options
	options:angular.extend({},this.options,parentTargetOptions),// Pass in the registered parent node to the state so the onStart listener can use
	registeredParent:parentTarget};this.onStart(ev,pointer);},move:function move(ev,pointer){if(!this.state.isRunning)return;this.onMove(ev,pointer);},end:function end(ev,pointer){if(!this.state.isRunning)return;this.onEnd(ev,pointer);this.state.isRunning=false;},cancel:function cancel(ev,pointer){this.onCancel(ev,pointer);this.state={};},// Find and return the nearest parent element that has been registered to
	// listen for this handler via $mdGesture.register(element, 'handlerName').
	getNearestParent:function getNearestParent(node){var current=node;while(current){if((current.$mdGesture||{})[this.name]){return current;}current=current.parentNode;}return null;},// Called from $mdGesture.register when an element registers itself with a handler.
	// Store the options the user gave on the DOMElement itself. These options will
	// be retrieved with getNearestParent when the handler starts.
	registerElement:function registerElement(element,options){var self=this;element[0].$mdGesture=element[0].$mdGesture||{};element[0].$mdGesture[this.name]=options||{};element.on('$destroy',onDestroy);self.onSetup(element,options||{});return onDestroy;function onDestroy(){delete element[0].$mdGesture[self.name];element.off('$destroy',onDestroy);self.onCleanup(element,options||{});}}};return GestureHandler;/*
	   * Dispatch an event with jQuery
	   * TODO: Make sure this sends bubbling events
	   *
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */function jQueryDispatchEvent(srcEvent,eventType,eventPointer){eventPointer=eventPointer||pointer;var eventObj=new angular.element.Event(eventType);eventObj.$material=true;eventObj.pointer=eventPointer;eventObj.srcEvent=srcEvent;angular.extend(eventObj,{clientX:eventPointer.x,clientY:eventPointer.y,screenX:eventPointer.x,screenY:eventPointer.y,pageX:eventPointer.x,pageY:eventPointer.y,ctrlKey:srcEvent.ctrlKey,altKey:srcEvent.altKey,shiftKey:srcEvent.shiftKey,metaKey:srcEvent.metaKey});angular.element(eventPointer.target).trigger(eventObj);}/*
	   * NOTE: nativeDispatchEvent is very performance sensitive.
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */function nativeDispatchEvent(srcEvent,eventType,eventPointer){eventPointer=eventPointer||pointer;var eventObj;if(eventType==='click'||eventType=='mouseup'||eventType=='mousedown'){eventObj=document.createEvent('MouseEvents');eventObj.initMouseEvent(eventType,true,true,window,srcEvent.detail,eventPointer.x,eventPointer.y,eventPointer.x,eventPointer.y,srcEvent.ctrlKey,srcEvent.altKey,srcEvent.shiftKey,srcEvent.metaKey,srcEvent.button,srcEvent.relatedTarget||null);}else{eventObj=document.createEvent('CustomEvent');eventObj.initCustomEvent(eventType,true,true,{});}eventObj.$material=true;eventObj.pointer=eventPointer;eventObj.srcEvent=srcEvent;eventPointer.target.dispatchEvent(eventObj);}}/**
	 * Attach Gestures: hook document and check shouldHijack clicks
	 * @ngInject
	 */function attachToDocument($mdGesture,$$MdGestureHandler){// Polyfill document.contains for IE11.
	// TODO: move to util
	document.contains||(document.contains=function(node){return document.body.contains(node);});if(!isInitialized&&$mdGesture.isHijackingClicks){/*
	     * If hijack clicks is true, we preventDefault any click that wasn't
	     * sent by AngularJS Material. This is because on older Android & iOS, a false, or 'ghost',
	     * click event will be sent ~400ms after a touchend event happens.
	     * The only way to know if this click is real is to prevent any normal
	     * click events, and add a flag to events sent by material so we know not to prevent those.
	     *
	     * Two exceptions to click events that should be prevented are:
	     *  - click events sent by the keyboard (eg form submit)
	     *  - events that originate from an Ionic app
	     */document.addEventListener('click',clickHijacker,true);document.addEventListener('mouseup',mouseInputHijacker,true);document.addEventListener('mousedown',mouseInputHijacker,true);document.addEventListener('focus',mouseInputHijacker,true);isInitialized=true;}function mouseInputHijacker(ev){var isKeyClick=!ev.clientX&&!ev.clientY;if(!isKeyClick&&!ev.$material&&!ev.isIonicTap&&!isInputEventFromLabelClick(ev)&&(ev.type!=='mousedown'||!canFocus(ev.target)&&!canFocus(document.activeElement))){ev.preventDefault();ev.stopPropagation();}}function clickHijacker(ev){var isKeyClick=ev.clientX===0&&ev.clientY===0;var isSubmitEvent=ev.target&&ev.target.type==='submit';if(!isKeyClick&&!ev.$material&&!ev.isIonicTap&&!isInputEventFromLabelClick(ev)&&!isSubmitEvent){ev.preventDefault();ev.stopPropagation();lastLabelClickPos=null;}else{lastLabelClickPos=null;if(ev.target.tagName.toLowerCase()=='label'){lastLabelClickPos={x:ev.x,y:ev.y};}}}// Listen to all events to cover all platforms.
	var START_EVENTS='mousedown touchstart pointerdown';var MOVE_EVENTS='mousemove touchmove pointermove';var END_EVENTS='mouseup mouseleave touchend touchcancel pointerup pointercancel';angular.element(document).on(START_EVENTS,gestureStart).on(MOVE_EVENTS,gestureMove).on(END_EVENTS,gestureEnd)// For testing
	.on('$$mdGestureReset',function gestureClearCache(){lastPointer=pointer=null;});/*
	   * When a DOM event happens, run all registered gesture handlers' lifecycle
	   * methods which match the DOM event.
	   * Eg when a 'touchstart' event happens, runHandlers('start') will call and
	   * run `handler.cancel()` and `handler.start()` on all registered handlers.
	   */function runHandlers(handlerEvent,event){var handler;for(var name in HANDLERS){handler=HANDLERS[name];if(handler instanceof $$MdGestureHandler){if(handlerEvent==='start'){// Run cancel to reset any handlers' state
	handler.cancel();}handler[handlerEvent](event,pointer);}}}/*
	   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
	   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
	   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
	   * won't effect it.
	   */function gestureStart(ev){// If we're already touched down, abort
	if(pointer)return;var now=+Date.now();// iOS & old android bug: after a touch event, a click event is sent 350 ms later.
	// If <400ms have passed, don't allow an event of a different type than the previous event
	if(lastPointer&&!typesMatch(ev,lastPointer)&&now-lastPointer.endTime<1500){return;}pointer=makeStartPointer(ev);runHandlers('start',ev);}/*
	   * If a move event happens of the right type, update the pointer and run all the move handlers.
	   * "of the right type": if a mousemove happens but our pointer started with a touch event, do nothing.
	   */function gestureMove(ev){if(!pointer||!typesMatch(ev,pointer))return;updatePointerState(ev,pointer);runHandlers('move',ev);}/*
	   * If an end event happens of the right type, update the pointer, run endHandlers, and save the pointer as 'lastPointer'
	   */function gestureEnd(ev){if(!pointer||!typesMatch(ev,pointer))return;updatePointerState(ev,pointer);pointer.endTime=+Date.now();if(ev.type!=='pointercancel'){runHandlers('end',ev);}lastPointer=pointer;pointer=null;}}// ********************
	// Module Functions
	// ********************
	/*
	 * Initiate the pointer. x, y, and the pointer's type.
	 */function makeStartPointer(ev){var point=getEventPoint(ev);var startPointer={startTime:+Date.now(),target:ev.target,// 'p' for pointer events, 'm' for mouse, 't' for touch
	type:ev.type.charAt(0)};startPointer.startX=startPointer.x=point.pageX;startPointer.startY=startPointer.y=point.pageY;return startPointer;}/*
	 * return whether the pointer's type matches the event's type.
	 * Eg if a touch event happens but the pointer has a mouse type, return false.
	 */function typesMatch(ev,pointer){return ev&&pointer&&ev.type.charAt(0)===pointer.type;}/**
	 * Gets whether the given event is an input event that was caused by clicking on an
	 * associated label element.
	 *
	 * This is necessary because the browser will, upon clicking on a label element, fire an
	 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
	 * click as with `$material` correctly, but not the second input click.
	 *
	 * In order to determine whether an input event is from a label click, we compare the (x, y) for
	 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
	 * click occurs). Unfortunately, there are no event properties that tie the input and the label
	 * together (such as relatedTarget).
	 *
	 * @param {MouseEvent} event
	 * @returns {boolean}
	 */function isInputEventFromLabelClick(event){return lastLabelClickPos&&lastLabelClickPos.x==event.x&&lastLabelClickPos.y==event.y;}/*
	 * Update the given pointer based upon the given DOMEvent.
	 * Distance, velocity, direction, duration, etc
	 */function updatePointerState(ev,pointer){var point=getEventPoint(ev);var x=pointer.x=point.pageX;var y=pointer.y=point.pageY;pointer.distanceX=x-pointer.startX;pointer.distanceY=y-pointer.startY;pointer.distance=Math.sqrt(pointer.distanceX*pointer.distanceX+pointer.distanceY*pointer.distanceY);pointer.directionX=pointer.distanceX>0?'right':pointer.distanceX<0?'left':'';pointer.directionY=pointer.distanceY>0?'down':pointer.distanceY<0?'up':'';pointer.duration=+Date.now()-pointer.startTime;pointer.velocityX=pointer.distanceX/pointer.duration;pointer.velocityY=pointer.distanceY/pointer.duration;}/*
	 * Normalize the point where the DOM event happened whether it's touch or mouse.
	 * @returns point event obj with pageX and pageY on it.
	 */function getEventPoint(ev){ev=ev.originalEvent||ev;// support jQuery events
	return ev.touches&&ev.touches[0]||ev.changedTouches&&ev.changedTouches[0]||ev;}/** Checks whether an element can be focused. */function canFocus(element){return!!element&&element.getAttribute('tabindex')!='-1'&&!element.hasAttribute('disabled')&&(element.hasAttribute('tabindex')||element.hasAttribute('href')||element.isContentEditable||['INPUT','SELECT','BUTTON','TEXTAREA','VIDEO','AUDIO'].indexOf(element.nodeName)!=-1);}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.core.interaction
	 * @description
	 * User interaction detection to provide proper accessibility.
	 */MdInteractionService.$inject=["$timeout","$mdUtil"];angular.module('material.core.interaction',[]).service('$mdInteraction',MdInteractionService);/**
	 * @ngdoc service
	 * @name $mdInteraction
	 * @module material.core.interaction
	 *
	 * @description
	 *
	 * Service which keeps track of the last interaction type and validates them for several browsers.
	 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
	 *
	 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
	 *
	 * Here is an example markup for using the interaction service.
	 *
	 * <hljs lang="js">
	 *   var lastType = $mdInteraction.getLastInteractionType();
	 *
	 *   if (lastType === 'keyboard') {
	 *     // We only restore the focus for keyboard users.
	 *     restoreFocus();
	 *   }
	 * </hljs>
	 *
	 */function MdInteractionService($timeout,$mdUtil){this.$timeout=$timeout;this.$mdUtil=$mdUtil;this.bodyElement=angular.element(document.body);this.isBuffering=false;this.bufferTimeout=null;this.lastInteractionType=null;this.lastInteractionTime=null;// Type Mappings for the different events
	// There will be three three interaction types
	// `keyboard`, `mouse` and `touch`
	// type `pointer` will be evaluated in `pointerMap` for IE Browser events
	this.inputEventMap={'keydown':'keyboard','mousedown':'mouse','mouseenter':'mouse','touchstart':'touch','pointerdown':'pointer','MSPointerDown':'pointer'};// IE PointerDown events will be validated in `touch` or `mouse`
	// Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
	this.iePointerMap={2:'touch',3:'touch',4:'mouse'};this.initializeEvents();}/**
	 * Initializes the interaction service, by registering all interaction events to the
	 * body element.
	 */MdInteractionService.prototype.initializeEvents=function(){// IE browsers can also trigger pointer events, which also leads to an interaction.
	var pointerEvent='MSPointerEvent'in window?'MSPointerDown':'PointerEvent'in window?'pointerdown':null;this.bodyElement.on('keydown mousedown',this.onInputEvent.bind(this));if('ontouchstart'in document.documentElement){this.bodyElement.on('touchstart',this.onBufferInputEvent.bind(this));}if(pointerEvent){this.bodyElement.on(pointerEvent,this.onInputEvent.bind(this));}};/**
	 * Event listener for normal interaction events, which should be tracked.
	 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
	 */MdInteractionService.prototype.onInputEvent=function(event){if(this.isBuffering){return;}var type=this.inputEventMap[event.type];if(type==='pointer'){type=this.iePointerMap[event.pointerType]||event.pointerType;}this.lastInteractionType=type;this.lastInteractionTime=this.$mdUtil.now();};/**
	 * Event listener for interaction events which should be buffered (touch events).
	 * @param event {TouchEvent}
	 */MdInteractionService.prototype.onBufferInputEvent=function(event){this.$timeout.cancel(this.bufferTimeout);this.onInputEvent(event);this.isBuffering=true;// The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
	// the `onInput` function multiple times.
	this.bufferTimeout=this.$timeout(function(){this.isBuffering=false;}.bind(this),650,false);};/**
	 * @ngdoc method
	 * @name $mdInteraction#getLastInteractionType
	 * @description Retrieves the last interaction type triggered in body.
	 * @returns {string|null} Last interaction type.
	 */MdInteractionService.prototype.getLastInteractionType=function(){return this.lastInteractionType;};/**
	 * @ngdoc method
	 * @name $mdInteraction#isUserInvoked
	 * @description Method to detect whether any interaction happened recently or not.
	 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
	 * @returns {boolean} Whether there was any interaction or not.
	 */MdInteractionService.prototype.isUserInvoked=function(checkDelay){var delay=angular.isNumber(checkDelay)?checkDelay:15;// Check for any interaction to be within the specified check time.
	return this.lastInteractionTime>=this.$mdUtil.now()-delay;};})();(function(){"use strict";angular.module('material.core').provider('$$interimElement',InterimElementProvider);/*
	 * @ngdoc service
	 * @name $$interimElement
	 * @module material.core
	 *
	 * @description
	 *
	 * Factory that contructs `$$interimElement.$service` services.
	 * Used internally in material design for elements that appear on screen temporarily.
	 * The service provides a promise-like API for interacting with the temporary
	 * elements.
	 *
	 * ```js
	 * app.service('$mdToast', function($$interimElement) {
	 *   var $mdToast = $$interimElement(toastDefaultOptions);
	 *   return $mdToast;
	 * });
	 * ```
	 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
	 *
	 * @returns {$$interimElement.$service}
	 *
	 */function InterimElementProvider(){InterimElementFactory.$inject=["$document","$q","$rootScope","$timeout","$rootElement","$animate","$mdUtil","$mdCompiler","$mdTheming","$injector","$exceptionHandler"];createInterimElementProvider.$get=InterimElementFactory;return createInterimElementProvider;/**
	   * Returns a new provider which allows configuration of a new interimElement
	   * service. Allows configuration of default options & methods for options,
	   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
	   */function createInterimElementProvider(interimFactoryName){factory.$inject=["$$interimElement","$injector"];var EXPOSED_METHODS=['onHide','onShow','onRemove'];var customMethods={};var providerConfig={presets:{}};var provider={setDefaults:setDefaults,addPreset:addPreset,addMethod:addMethod,$get:factory};/**
	     * all interim elements will come with the 'build' preset
	     */provider.addPreset('build',{methods:['controller','controllerAs','resolve','multiple','template','templateUrl','themable','transformTemplate','parent','contentElement']});return provider;/**
	     * Save the configured defaults to be used when the factory is instantiated
	     */function setDefaults(definition){providerConfig.optionsFactory=definition.options;providerConfig.methods=(definition.methods||[]).concat(EXPOSED_METHODS);return provider;}/**
	     * Add a method to the factory that isn't specific to any interim element operations
	     */function addMethod(name,fn){customMethods[name]=fn;return provider;}/**
	     * Save the configured preset to be used when the factory is instantiated
	     */function addPreset(name,definition){definition=definition||{};definition.methods=definition.methods||[];definition.options=definition.options||function(){return{};};if(/^cancel|hide|show$/.test(name)){throw new Error("Preset '"+name+"' in "+interimFactoryName+" is reserved!");}if(definition.methods.indexOf('_options')>-1){throw new Error("Method '_options' in "+interimFactoryName+" is reserved!");}providerConfig.presets[name]={methods:definition.methods.concat(EXPOSED_METHODS),optionsFactory:definition.options,argOption:definition.argOption};return provider;}function addPresetMethod(presetName,methodName,method){providerConfig.presets[presetName][methodName]=method;}/**
	     * Create a factory that has the given methods & defaults implementing interimElement
	     *//* @ngInject */function factory($$interimElement,$injector){var defaultMethods;var defaultOptions;var interimElementService=$$interimElement();/*
	       * publicService is what the developer will be using.
	       * It has methods hide(), cancel(), show(), build(), and any other
	       * presets which were set during the config phase.
	       */var publicService={hide:interimElementService.hide,cancel:interimElementService.cancel,show:showInterimElement,// Special internal method to destroy an interim element without animations
	// used when navigation changes causes a $scope.$destroy() action
	destroy:destroyInterimElement};defaultMethods=providerConfig.methods||[];// This must be invoked after the publicService is initialized
	defaultOptions=invokeFactory(providerConfig.optionsFactory,{});// Copy over the simple custom methods
	angular.forEach(customMethods,function(fn,name){publicService[name]=fn;});angular.forEach(providerConfig.presets,function(definition,name){var presetDefaults=invokeFactory(definition.optionsFactory,{});var presetMethods=(definition.methods||[]).concat(defaultMethods);// Every interimElement built with a preset has a field called `$type`,
	// which matches the name of the preset.
	// Eg in preset 'confirm', options.$type === 'confirm'
	angular.extend(presetDefaults,{$type:name});// This creates a preset class which has setter methods for every
	// method given in the `.addPreset()` function, as well as every
	// method given in the `.setDefaults()` function.
	//
	// @example
	// .setDefaults({
	//   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
	//   options: dialogDefaultOptions
	// })
	// .addPreset('alert', {
	//   methods: ['title', 'ok'],
	//   options: alertDialogOptions
	// })
	//
	// Set values will be passed to the options when interimElement.show() is called.
	function Preset(opts){this._options=angular.extend({},presetDefaults,opts);}angular.forEach(presetMethods,function(name){Preset.prototype[name]=function(value){this._options[name]=value;return this;};});// Create shortcut method for one-linear methods
	if(definition.argOption){var methodName='show'+name.charAt(0).toUpperCase()+name.slice(1);publicService[methodName]=function(arg){var config=publicService[name](arg);return publicService.show(config);};}// eg $mdDialog.alert() will return a new alert preset
	publicService[name]=function(arg){// If argOption is supplied, eg `argOption: 'content'`, then we assume
	// if the argument is not an options object then it is the `argOption` option.
	//
	// @example `$mdToast.simple('hello')` // sets options.content to hello
	//                                     // because argOption === 'content'
	if(arguments.length&&definition.argOption&&!angular.isObject(arg)&&!angular.isArray(arg)){return new Preset()[definition.argOption](arg);}else{return new Preset(arg);}};});return publicService;/**
	       *
	       */function showInterimElement(opts){// opts is either a preset which stores its options on an _options field,
	// or just an object made up of options
	opts=opts||{};if(opts._options)opts=opts._options;return interimElementService.show(angular.extend({},defaultOptions,opts));}/**
	       *  Special method to hide and destroy an interimElement WITHOUT
	       *  any 'leave` or hide animations ( an immediate force hide/remove )
	       *
	       *  NOTE: This calls the onRemove() subclass method for each component...
	       *  which must have code to respond to `options.$destroy == true`
	       */function destroyInterimElement(opts){return interimElementService.destroy(opts);}/**
	       * Helper to call $injector.invoke with a local of the factory name for
	       * this provider.
	       * If an $mdDialog is providing options for a dialog and tries to inject
	       * $mdDialog, a circular dependency error will happen.
	       * We get around that by manually injecting $mdDialog as a local.
	       */function invokeFactory(factory,defaultVal){var locals={};locals[interimFactoryName]=publicService;return $injector.invoke(factory||function(){return defaultVal;},{},locals);}}}/* @ngInject */function InterimElementFactory($document,$q,$rootScope,$timeout,$rootElement,$animate,$mdUtil,$mdCompiler,$mdTheming,$injector,$exceptionHandler){return function createInterimElementService(){var SHOW_CANCELLED=false;/*
	       * @ngdoc service
	       * @name $$interimElement.$service
	       *
	       * @description
	       * A service used to control inserting and removing an element into the DOM.
	       *
	       */var service;var showPromises=[];// Promises for the interim's which are currently opening.
	var hidePromises=[];// Promises for the interim's which are currently hiding.
	var showingInterims=[];// Interim elements which are currently showing up.
	// Publish instance $$interimElement service;
	// ... used as $mdDialog, $mdToast, $mdMenu, and $mdSelect
	return service={show:show,hide:waitForInterim(hide),cancel:waitForInterim(cancel),destroy:destroy,$injector_:$injector};/*
	       * @ngdoc method
	       * @name $$interimElement.$service#show
	       * @kind function
	       *
	       * @description
	       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved or rejected
	       * with hide or cancel, respectively. To external cancel/hide, developers should use the
	       *
	       * @param {*} options is hashMap of settings
	       * @returns a Promise
	       *
	       */function show(options){options=options||{};var interimElement=new InterimElement(options||{});// When an interim element is currently showing, we have to cancel it.
	// Just hiding it, will resolve the InterimElement's promise, the promise should be
	// rejected instead.
	var hideAction=options.multiple?$q.resolve():$q.all(showPromises);if(!options.multiple){// Wait for all opening interim's to finish their transition.
	hideAction=hideAction.then(function(){// Wait for all closing and showing interim's to be completely closed.
	var promiseArray=hidePromises.concat(showingInterims.map(service.cancel));return $q.all(promiseArray);});}var showAction=hideAction.then(function(){return interimElement.show().catch(function(reason){return reason;}).finally(function(){showPromises.splice(showPromises.indexOf(showAction),1);showingInterims.push(interimElement);});});showPromises.push(showAction);// In AngularJS 1.6+, exceptions inside promises will cause a rejection. We need to handle
	// the rejection and only log it if it's an error.
	interimElement.deferred.promise.catch(function(fault){if(fault instanceof Error){$exceptionHandler(fault);}return fault;});// Return a promise that will be resolved when the interim
	// element is hidden or cancelled...
	return interimElement.deferred.promise;}/*
	       * @ngdoc method
	       * @name $$interimElement.$service#hide
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and resolves the promise returned from `show`
	       *
	       * @param {*} resolveParam Data to resolve the promise with
	       * @returns a Promise that will be resolved after the element has been removed.
	       *
	       */function hide(reason,options){options=options||{};if(options.closeAll){// We have to make a shallow copy of the array, because otherwise the map will break.
	return $q.all(showingInterims.slice().reverse().map(closeElement));}else if(options.closeTo!==undefined){return $q.all(showingInterims.slice(options.closeTo).map(closeElement));}// Hide the latest showing interim element.
	return closeElement(showingInterims[showingInterims.length-1]);function closeElement(interim){var hideAction=interim.remove(reason,false,options||{}).catch(function(reason){return reason;}).finally(function(){hidePromises.splice(hidePromises.indexOf(hideAction),1);});showingInterims.splice(showingInterims.indexOf(interim),1);hidePromises.push(hideAction);return interim.deferred.promise;}}/*
	       * @ngdoc method
	       * @name $$interimElement.$service#cancel
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and rejects the promise returned from `show`
	       *
	       * @param {*} reason Data to reject the promise with
	       * @returns Promise that will be resolved after the element has been removed.
	       *
	       */function cancel(reason,options){var interim=showingInterims.pop();if(!interim){return $q.when(reason);}var cancelAction=interim.remove(reason,true,options||{}).catch(function(reason){return reason;}).finally(function(){hidePromises.splice(hidePromises.indexOf(cancelAction),1);});hidePromises.push(cancelAction);// Since AngularJS 1.6.7, promises will be logged to $exceptionHandler when the promise
	// is not handling the rejection. We create a pseudo catch handler, which will prevent the
	// promise from being logged to the $exceptionHandler.
	return interim.deferred.promise.catch(angular.noop);}/**
	       * Creates a function to wait for at least one interim element to be available.
	       * @param callbackFn Function to be used as callback
	       * @returns {Function}
	       */function waitForInterim(callbackFn){return function(){var fnArguments=arguments;if(!showingInterims.length){// When there are still interim's opening, then wait for the first interim element to
	// finish its open animation.
	if(showPromises.length){return showPromises[0].finally(function(){return callbackFn.apply(service,fnArguments);});}return $q.when("No interim elements currently showing up.");}return callbackFn.apply(service,fnArguments);};}/*
	       * Special method to quick-remove the interim element without animations
	       * Note: interim elements are in "interim containers"
	       */function destroy(targetEl){var interim=!targetEl?showingInterims.shift():null;var parentEl=angular.element(targetEl).length&&angular.element(targetEl)[0].parentNode;if(parentEl){// Try to find the interim in the stack which corresponds to the supplied DOM element.
	var filtered=showingInterims.filter(function(entry){return entry.options.element[0]===parentEl;});// Note: This function might be called when the element already has been removed,
	// in which case we won't find any matches.
	if(filtered.length){interim=filtered[0];showingInterims.splice(showingInterims.indexOf(interim),1);}}return interim?interim.remove(SHOW_CANCELLED,false,{'$destroy':true}):$q.when(SHOW_CANCELLED);}/*
	       * Internal Interim Element Object
	       * Used internally to manage the DOM element and related data
	       */function InterimElement(options){var self,element,showAction=$q.when(true);options=configureScopeAndTransitions(options);return self={options:options,deferred:$q.defer(),show:createAndTransitionIn,remove:transitionOutAndRemove};/**
	         * Compile, link, and show this interim element
	         * Use optional autoHided and transition-in effects
	         */function createAndTransitionIn(){return $q(function(resolve,reject){// Trigger onCompiling callback before the compilation starts.
	// This is useful, when modifying options, which can be influenced by developers.
	options.onCompiling&&options.onCompiling(options);compileElement(options).then(function(compiledData){element=linkElement(compiledData,options);// Expose the cleanup function from the compiler.
	options.cleanupElement=compiledData.cleanup;showAction=showElement(element,options,compiledData.controller).then(resolve,rejectAll);}).catch(rejectAll);function rejectAll(fault){// Force the '$md<xxx>.show()' promise to reject
	self.deferred.reject(fault);// Continue rejection propagation
	reject(fault);}});}/**
	         * After the show process has finished/rejected:
	         * - announce 'removing',
	         * - perform the transition-out, and
	         * - perform optional clean up scope.
	         */function transitionOutAndRemove(response,isCancelled,opts){// abort if the show() and compile failed
	if(!element)return $q.when(false);options=angular.extend(options||{},opts||{});options.cancelAutoHide&&options.cancelAutoHide();options.element.triggerHandler('$mdInterimElementRemove');if(options.$destroy===true){return hideElement(options.element,options).then(function(){isCancelled&&rejectAll(response)||resolveAll(response);});}else{$q.when(showAction).finally(function(){hideElement(options.element,options).then(function(){isCancelled?rejectAll(response):resolveAll(response);},rejectAll);});return self.deferred.promise;}/**
	           * The `show()` returns a promise that will be resolved when the interim
	           * element is hidden or cancelled...
	           */function resolveAll(response){self.deferred.resolve(response);}/**
	           * Force the '$md<xxx>.show()' promise to reject
	           */function rejectAll(fault){self.deferred.reject(fault);}}/**
	         * Prepare optional isolated scope and prepare $animate with default enter and leave
	         * transitions for the new element instance.
	         */function configureScopeAndTransitions(options){options=options||{};if(options.template){options.template=$mdUtil.processTemplate(options.template);}return angular.extend({preserveScope:false,cancelAutoHide:angular.noop,scope:options.scope||$rootScope.$new(options.isolateScope),/**
	             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
	             */onShow:function transitionIn(scope,element,options){return $animate.enter(element,options.parent);},/**
	             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
	             */onRemove:function transitionOut(scope,element){// Element could be undefined if a new element is shown before
	// the old one finishes compiling.
	return element&&$animate.leave(element)||$q.when();}},options);}/**
	         * Compile an element with a templateUrl, controller, and locals
	         */function compileElement(options){var compiled=!options.skipCompile?$mdCompiler.compile(options):null;return compiled||$q(function(resolve){resolve({locals:{},link:function link(){return options.element;}});});}/**
	         *  Link an element with compiled configuration
	         */function linkElement(compileData,options){angular.extend(compileData.locals,options);var element=compileData.link(options.scope);// Search for parent at insertion time, if not specified
	options.element=element;options.parent=findParent(element,options);if(options.themable)$mdTheming(element);return element;}/**
	         * Search for parent at insertion time, if not specified
	         */function findParent(element,options){var parent=options.parent;// Search for parent at insertion time, if not specified
	if(angular.isFunction(parent)){parent=parent(options.scope,element,options);}else if(angular.isString(parent)){parent=angular.element($document[0].querySelector(parent));}else{parent=angular.element(parent);}// If parent querySelector/getter function fails, or it's just null,
	// find a default.
	if(!(parent||{}).length){var el;if($rootElement[0]&&$rootElement[0].querySelector){el=$rootElement[0].querySelector(':not(svg) > body');}if(!el)el=$rootElement[0];if(el.nodeName=='#comment'){el=$document[0].body;}return angular.element(el);}return parent;}/**
	         * If auto-hide is enabled, start timer and prepare cancel function
	         */function startAutoHide(){var autoHideTimer,cancelAutoHide=angular.noop;if(options.hideDelay){autoHideTimer=$timeout(service.hide,options.hideDelay);cancelAutoHide=function cancelAutoHide(){$timeout.cancel(autoHideTimer);};}// Cache for subsequent use
	options.cancelAutoHide=function(){cancelAutoHide();options.cancelAutoHide=undefined;};}/**
	         * Show the element ( with transitions), notify complete and start
	         * optional auto-Hide
	         */function showElement(element,options,controller){// Trigger onShowing callback before the `show()` starts
	var notifyShowing=options.onShowing||angular.noop;// Trigger onComplete callback when the `show()` finishes
	var notifyComplete=options.onComplete||angular.noop;// Necessary for consistency between AngularJS 1.5 and 1.6.
	try{notifyShowing(options.scope,element,options,controller);}catch(e){return $q.reject(e);}return $q(function(resolve,reject){try{// Start transitionIn
	$q.when(options.onShow(options.scope,element,options,controller)).then(function(){notifyComplete(options.scope,element,options);startAutoHide();resolve(element);},reject);}catch(e){reject(e.message);}});}function hideElement(element,options){var announceRemoving=options.onRemoving||angular.noop;return $q(function(resolve,reject){try{// Start transitionIn
	var action=$q.when(options.onRemove(options.scope,element,options)||true);// Trigger callback *before* the remove operation starts
	announceRemoving(element,action);if(options.$destroy){// For $destroy, onRemove should be synchronous
	resolve(element);if(!options.preserveScope&&options.scope){// scope destroy should still be be done after the current digest is done
	action.then(function(){options.scope.$destroy();});}}else{// Wait until transition-out is done
	action.then(function(){if(!options.preserveScope&&options.scope){options.scope.$destroy();}resolve(element);},reject);}}catch(e){reject(e.message);}});}}};}}})();(function(){"use strict";(function(){'use strict';var $mdUtil,$interpolate,$log;var SUFFIXES=/(-gt)?-(sm|md|lg|print)/g;var WHITESPACE=/\s+/g;var FLEX_OPTIONS=['grow','initial','auto','none','noshrink','nogrow'];var LAYOUT_OPTIONS=['row','column'];var ALIGNMENT_MAIN_AXIS=["","start","center","end","stretch","space-around","space-between"];var ALIGNMENT_CROSS_AXIS=["","start","center","end","stretch"];var config={/**
	     * Enable directive attribute-to-class conversions
	     * Developers can use `<body md-layout-css />` to quickly
	     * disable the Layout directives and prohibit the injection of Layout classNames
	     */enabled:true,/**
	     * List of mediaQuery breakpoints and associated suffixes
	     *
	     *   [
	     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
	     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
	     *   ]
	     */breakpoints:[]};registerLayoutAPI(angular.module('material.core.layout',['ng']));/**
	   *   registerLayoutAPI()
	   *
	   *   The original AngularJS Material Layout solution used attribute selectors and CSS.
	   *
	   *  ```html
	   *  <div layout="column"> My Content </div>
	   *  ```
	   *
	   *  ```css
	   *  [layout] {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  [layout=column] {
	   *    flex-direction : column
	   *  }
	   *  ```
	   *
	   *  Use of attribute selectors creates significant performance impacts in some
	   *  browsers... mainly IE.
	   *
	   *  This module registers directives that allow the same layout attributes to be
	   *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
	   *  contains a Layout directive.
	   *
	   * ```html
	   *   <div layout="column" class="layout layout-column"> My Content </div>
	   *```
	   *
	   *  ```css
	   *  .layout {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  .layout-column {
	   *    flex-direction : column
	   *  }
	   *  ```
	   */function registerLayoutAPI(module){var PREFIX_REGEXP=/^((?:x|data)[:\-_])/i;var SPECIAL_CHARS_REGEXP=/([:\-_]+(.))/g;// NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
	var BREAKPOINTS=["","xs","gt-xs","sm","gt-sm","md","gt-md","lg","gt-lg","xl","print"];var API_WITH_VALUES=["layout","flex","flex-order","flex-offset","layout-align"];var API_NO_VALUES=["show","hide","layout-padding","layout-margin"];// Build directive registration functions for the standard Layout API... for all breakpoints.
	angular.forEach(BREAKPOINTS,function(mqb){// Attribute directives with expected, observable value(s)
	angular.forEach(API_WITH_VALUES,function(name){var fullName=mqb?name+"-"+mqb:name;module.directive(directiveNormalize(fullName),attributeWithObserve(fullName));});// Attribute directives with no expected value(s)
	angular.forEach(API_NO_VALUES,function(name){var fullName=mqb?name+"-"+mqb:name;module.directive(directiveNormalize(fullName),attributeWithoutValue(fullName));});});// Register other, special directive functions for the Layout features:
	module.provider('$$mdLayout',function(){// Publish internal service for Layouts
	return{$get:angular.noop,validateAttributeValue:validateAttributeValue,validateAttributeUsage:validateAttributeUsage,/**
	           * Easy way to disable/enable the Layout API.
	           * When disabled, this stops all attribute-to-classname generations
	           */disableLayouts:function disableLayouts(isDisabled){config.enabled=isDisabled!==true;}};}).directive('mdLayoutCss',disableLayoutDirective).directive('ngCloak',buildCloakInterceptor('ng-cloak')).directive('layoutWrap',attributeWithoutValue('layout-wrap')).directive('layoutNowrap',attributeWithoutValue('layout-nowrap')).directive('layoutNoWrap',attributeWithoutValue('layout-no-wrap')).directive('layoutFill',attributeWithoutValue('layout-fill'))// !! Deprecated attributes: use the `-lt` (aka less-than) notations
	.directive('layoutLtMd',warnAttrNotSupported('layout-lt-md',true)).directive('layoutLtLg',warnAttrNotSupported('layout-lt-lg',true)).directive('flexLtMd',warnAttrNotSupported('flex-lt-md',true)).directive('flexLtLg',warnAttrNotSupported('flex-lt-lg',true)).directive('layoutAlignLtMd',warnAttrNotSupported('layout-align-lt-md')).directive('layoutAlignLtLg',warnAttrNotSupported('layout-align-lt-lg')).directive('flexOrderLtMd',warnAttrNotSupported('flex-order-lt-md')).directive('flexOrderLtLg',warnAttrNotSupported('flex-order-lt-lg')).directive('offsetLtMd',warnAttrNotSupported('flex-offset-lt-md')).directive('offsetLtLg',warnAttrNotSupported('flex-offset-lt-lg')).directive('hideLtMd',warnAttrNotSupported('hide-lt-md')).directive('hideLtLg',warnAttrNotSupported('hide-lt-lg')).directive('showLtMd',warnAttrNotSupported('show-lt-md')).directive('showLtLg',warnAttrNotSupported('show-lt-lg'))// Determine if
	.config(detectDisabledLayouts);/**
	     * Converts snake_case to camelCase.
	     * Also there is special case for Moz prefix starting with upper case letter.
	     * @param name Name to normalize
	     */function directiveNormalize(name){return name.replace(PREFIX_REGEXP,'').replace(SPECIAL_CHARS_REGEXP,function(_,separator,letter,offset){return offset?letter.toUpperCase():letter;});}}/**
	    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
	    * If yes, then immediately disable all layout API features
	    *
	    * Note: this attribute should be specified on either the HTML or BODY tags
	    *//**
	    * @ngInject
	    */function detectDisabledLayouts(){var isDisabled=!!document.querySelector('[md-layouts-disabled]');config.enabled=!isDisabled;}/**
	   * Special directive that will disable ALL Layout conversions of layout
	   * attribute(s) to classname(s).
	   *
	   * <link rel="stylesheet" href="angular-material.min.css">
	   * <link rel="stylesheet" href="angular-material.layout.css">
	   *
	   * <body md-layout-css>
	   *  ...
	   * </body>
	   *
	   * Note: Using md-layout-css directive requires the developer to load the Material
	   * Layout Attribute stylesheet (which only uses attribute selectors):
	   *
	   *       `angular-material.layout.css`
	   *
	   * Another option is to use the LayoutProvider to configure and disable the attribute
	   * conversions; this would obviate the use of the `md-layout-css` directive
	   *
	   */function disableLayoutDirective(){// Return a 1x-only, first-match attribute directive
	config.enabled=false;return{restrict:'A',priority:'900'};}/**
	   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
	   * finish processing. Eliminates flicker with Material.Layouts
	   */function buildCloakInterceptor(className){return['$timeout',function($timeout){return{restrict:'A',priority:-10,// run after normal ng-cloak
	compile:function compile(element){if(!config.enabled)return angular.noop;// Re-add the cloak
	element.addClass(className);return function(scope,element){// Wait while layout injectors configure, then uncloak
	// NOTE: $rAF does not delay enough... and this is a 1x-only event,
	//       $timeout is acceptable.
	$timeout(function(){element.removeClass(className);},10,false);};}};}];}// *********************************************************************************
	//
	// These functions create registration functions for AngularJS Material Layout attribute directives
	// This provides easy translation to switch AngularJS Material attribute selectors to
	// CLASS selectors and directives; which has huge performance implications
	// for IE Browsers
	//
	// *********************************************************************************
	/**
	   * Creates a directive registration function where a possible dynamic attribute
	   * value will be observed/watched.
	   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
	   */function attributeWithObserve(className){return['$mdUtil','$interpolate',"$log",function(_$mdUtil_,_$interpolate_,_$log_){$mdUtil=_$mdUtil_;$interpolate=_$interpolate_;$log=_$log_;return{restrict:'A',compile:function compile(element,attr){var linkFn;if(config.enabled){// immediately replace static (non-interpolated) invalid values...
	validateAttributeUsage(className,attr,element,$log);validateAttributeValue(className,getNormalizedAttrValue(className,attr,""),buildUpdateFn(element,className,attr));linkFn=translateWithValueToCssClass;}// Use for postLink to account for transforms after ng-transclude.
	return linkFn||angular.noop;}};}];/**
	     * Add as transformed class selector(s), then
	     * remove the deprecated attribute selector
	     */function translateWithValueToCssClass(scope,element,attrs){var updateFn=updateClassWithValue(element,className,attrs);var unwatch=attrs.$observe(attrs.$normalize(className),updateFn);updateFn(getNormalizedAttrValue(className,attrs,""));scope.$on("$destroy",function(){unwatch();});}}/**
	   * Creates a registration function for AngularJS Material Layout attribute directive.
	   * This is a `simple` transpose of attribute usage to class usage; where we ignore
	   * any attribute value
	   */function attributeWithoutValue(className){return['$mdUtil','$interpolate',"$log",function(_$mdUtil_,_$interpolate_,_$log_){$mdUtil=_$mdUtil_;$interpolate=_$interpolate_;$log=_$log_;return{restrict:'A',compile:function compile(element,attr){var linkFn;if(config.enabled){// immediately replace static (non-interpolated) invalid values...
	validateAttributeValue(className,getNormalizedAttrValue(className,attr,""),buildUpdateFn(element,className,attr));translateToCssClass(null,element);// Use for postLink to account for transforms after ng-transclude.
	linkFn=translateToCssClass;}return linkFn||angular.noop;}};}];/**
	     * Add as transformed class selector, then
	     * remove the deprecated attribute selector
	     */function translateToCssClass(scope,element){element.addClass(className);}}/**
	   * After link-phase, do NOT remove deprecated layout attribute selector.
	   * Instead watch the attribute so interpolated data-bindings to layout
	   * selectors will continue to be supported.
	   *
	   * $observe() the className and update with new class (after removing the last one)
	   *
	   * e.g. `layout="{{layoutDemo.direction}}"` will update...
	   *
	   * NOTE: The value must match one of the specified styles in the CSS.
	   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
	   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
	   *
	   */function updateClassWithValue(element,className){var lastClass;return function updateClassFn(newValue){var value=validateAttributeValue(className,newValue||"");if(angular.isDefined(value)){if(lastClass)element.removeClass(lastClass);lastClass=!value?className:className+"-"+value.trim().replace(WHITESPACE,"-");element.addClass(lastClass);}};}/**
	   * Provide console warning that this layout attribute has been deprecated
	   *
	   */function warnAttrNotSupported(className){var parts=className.split("-");return["$log",function($log){$log.warn(className+"has been deprecated. Please use a `"+parts[0]+"-gt-<xxx>` variant.");return angular.noop;}];}/**
	   * Centralize warnings for known flexbox issues (especially IE-related issues)
	   */function validateAttributeUsage(className,attr,element,$log){var message,usage,url;var nodeName=element[0].nodeName.toLowerCase();switch(className.replace(SUFFIXES,"")){case"flex":if(nodeName=="md-button"||nodeName=="fieldset"){// @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
	// Use <div flex> wrapper inside (preferred) or outside
	usage="<"+nodeName+" "+className+"></"+nodeName+">";url="https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";message="Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";$log.warn($mdUtil.supplant(message,[usage,url]));}}}/**
	   * For the Layout attribute value, validate or replace with default
	   * fallback value
	   */function validateAttributeValue(className,value,updateFn){var origValue;if(!needsInterpolation(value)){switch(className.replace(SUFFIXES,"")){case'layout':if(!findIn(value,LAYOUT_OPTIONS)){value=LAYOUT_OPTIONS[0];// 'row';
	}break;case'flex':if(!findIn(value,FLEX_OPTIONS)){if(isNaN(value)){value='';}}break;case'flex-offset':case'flex-order':if(!value||isNaN(+value)){value='0';}break;case'layout-align':var axis=extractAlignAxis(value);value=$mdUtil.supplant("{main}-{cross}",axis);break;case'layout-padding':case'layout-margin':case'layout-fill':case'layout-wrap':case'layout-nowrap':value='';break;}if(value!=origValue){(updateFn||angular.noop)(value);}}return value?value.trim():"";}/**
	   * Replace current attribute value with fallback value
	   */function buildUpdateFn(element,className,attrs){return function updateAttrValue(fallback){if(!needsInterpolation(fallback)){// Do not modify the element's attribute value; so
	// uses '<ui-layout layout="/api/sidebar.html" />' will not
	// be affected. Just update the attrs value.
	attrs[attrs.$normalize(className)]=fallback;}};}/**
	   * See if the original value has interpolation symbols:
	   * e.g.  flex-gt-md="{{triggerPoint}}"
	   */function needsInterpolation(value){return(value||"").indexOf($interpolate.startSymbol())>-1;}function getNormalizedAttrValue(className,attrs,defaultVal){var normalizedAttr=attrs.$normalize(className);return attrs[normalizedAttr]?attrs[normalizedAttr].trim().replace(WHITESPACE,"-"):defaultVal||null;}function findIn(item,list,replaceWith){item=replaceWith&&item?item.replace(WHITESPACE,replaceWith):item;var found=false;if(item){list.forEach(function(it){it=replaceWith?it.replace(WHITESPACE,replaceWith):it;found=found||it===item;});}return found;}function extractAlignAxis(attrValue){var axis={main:"start",cross:"stretch"},values;attrValue=attrValue||"";if(attrValue.indexOf("-")===0||attrValue.indexOf(" ")===0){// For missing main-axis values
	attrValue="none"+attrValue;}values=attrValue.toLowerCase().trim().replace(WHITESPACE,"-").split("-");if(values.length&&values[0]==="space"){// for main-axis values of "space-around" or "space-between"
	values=[values[0]+"-"+values[1],values[2]];}if(values.length>0)axis.main=values[0]||axis.main;if(values.length>1)axis.cross=values[1]||axis.cross;if(ALIGNMENT_MAIN_AXIS.indexOf(axis.main)<0)axis.main="start";if(ALIGNMENT_CROSS_AXIS.indexOf(axis.cross)<0)axis.cross="stretch";return axis;}})();})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.core.liveannouncer
	 * @description
	 * AngularJS Material Live Announcer to provide accessibility for Voice Readers.
	 */MdLiveAnnouncer.$inject=["$timeout"];angular.module('material.core').service('$mdLiveAnnouncer',MdLiveAnnouncer);/**
	 * @ngdoc service
	 * @name $mdLiveAnnouncer
	 * @module material.core.liveannouncer
	 *
	 * @description
	 *
	 * Service to announce messages to supported screenreaders.
	 *
	 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
	 *
	 * <hljs lang="js">
	 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
	 *     // Basic announcement (Polite Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google');
	 *
	 *     // Custom announcement (Assertive Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
	 *   });
	 * </hljs>
	 *
	 */function MdLiveAnnouncer($timeout){/** @private @const @type {!angular.$timeout} */this._$timeout=$timeout;/** @private @const @type {!HTMLElement} */this._liveElement=this._createLiveElement();/** @private @const @type {!number} */this._announceTimeout=100;}/**
	 * @ngdoc method
	 * @name $mdLiveAnnouncer#announce
	 * @description Announces messages to supported screenreaders.
	 * @param {string} message Message to be announced to the screenreader
	 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
	 */MdLiveAnnouncer.prototype.announce=function(message,politeness){if(!politeness){politeness='polite';}var self=this;self._liveElement.textContent='';self._liveElement.setAttribute('aria-live',politeness);// This 100ms timeout is necessary for some browser + screen-reader combinations:
	// - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
	// - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
	//   second time without clearing and then using a non-zero delay.
	// (using JAWS 17 at time of this writing).
	self._$timeout(function(){self._liveElement.textContent=message;},self._announceTimeout,false);};/**
	 * Creates a live announcer element, which listens for DOM changes and announces them
	 * to the screenreaders.
	 * @returns {!HTMLElement}
	 * @private
	 */MdLiveAnnouncer.prototype._createLiveElement=function(){var liveEl=document.createElement('div');liveEl.classList.add('md-visually-hidden');liveEl.setAttribute('role','status');liveEl.setAttribute('aria-atomic','true');liveEl.setAttribute('aria-live','polite');document.body.appendChild(liveEl);return liveEl;};})();(function(){"use strict";/**
	 * @ngdoc service
	 * @name $$mdMeta
	 * @module material.core.meta
	 *
	 * @description
	 *
	 * A provider and a service that simplifies meta tags access
	 *
	 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
	 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
	 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
	 *
	 * ```js
	 * app.config(function($$mdMetaProvider) {
	 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 *
	 * app.controller('myController', function($$mdMeta) {
	 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 * ```
	 *
	 * @returns {$$mdMeta.$service}
	 *
	 */angular.module('material.core.meta',[]).provider('$$mdMeta',function(){var head=angular.element(document.head);var metaElements={};/**
	     * Checks if the requested element was written manually and maps it
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {boolean} returns true if there is an element with the requested name
	     */function mapExistingElement(name){if(metaElements[name]){return true;}var element=document.getElementsByName(name)[0];if(!element){return false;}metaElements[name]=angular.element(element);return true;}/**
	     * @ngdoc method
	     * @name $$mdMeta#setMeta
	     *
	     * @description
	     * Creates meta element with the 'name' and 'content' attributes,
	     * if the meta tag is already created than we replace the 'content' value
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @param {string} content meta tag 'content' attribute value
	     * @returns {function} remove function
	     *
	     */function setMeta(name,content){mapExistingElement(name);if(!metaElements[name]){var newMeta=angular.element('<meta name="'+name+'" content="'+content+'"/>');head.append(newMeta);metaElements[name]=newMeta;}else{metaElements[name].attr('content',content);}return function(){metaElements[name].attr('content','');metaElements[name].remove();delete metaElements[name];};}/**
	     * @ngdoc method
	     * @name $$mdMeta#getMeta
	     *
	     * @description
	     * Gets the 'content' attribute value of the wanted meta element
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {string} content attribute value
	     */function getMeta(name){if(!mapExistingElement(name)){throw Error('$$mdMeta: could not find a meta tag with the name \''+name+'\'');}return metaElements[name].attr('content');}var module={setMeta:setMeta,getMeta:getMeta};return angular.extend({},module,{$get:function $get(){return module;}});});})();(function(){"use strict";/**
	   * @ngdoc module
	   * @name material.core.componentRegistry
	   *
	   * @description
	   * A component instance registration service.
	   * Note: currently this as a private service in the SideNav component.
	   */ComponentRegistry.$inject=["$log","$q"];angular.module('material.core').factory('$mdComponentRegistry',ComponentRegistry);/*
	   * @private
	   * @ngdoc factory
	   * @name ComponentRegistry
	   * @module material.core.componentRegistry
	   *
	   */function ComponentRegistry($log,$q){var self;var instances=[];var pendings={};return self={/**
	       * Used to print an error when an instance for a handle isn't found.
	       */notFoundError:function notFoundError(handle,msgContext){$log.error((msgContext||"")+'No instance found for handle',handle);},/**
	       * Return all registered instances as an array.
	       */getInstances:function getInstances(){return instances;},/**
	       * Get a registered instance.
	       * @param handle the String handle to look up for a registered instance.
	       */get:function get(handle){if(!isValidID(handle))return null;var i,j,instance;for(i=0,j=instances.length;i<j;i++){instance=instances[i];if(instance.$$mdHandle===handle){return instance;}}return null;},/**
	       * Register an instance.
	       * @param instance the instance to register
	       * @param handle the handle to identify the instance under.
	       */register:function register(instance,handle){if(!handle)return angular.noop;instance.$$mdHandle=handle;instances.push(instance);resolveWhen();return deregister;/**
	         * Remove registration for an instance
	         */function deregister(){var index=instances.indexOf(instance);if(index!==-1){instances.splice(index,1);}}/**
	         * Resolve any pending promises for this instance
	         */function resolveWhen(){var dfd=pendings[handle];if(dfd){dfd.forEach(function(promise){promise.resolve(instance);});delete pendings[handle];}}},/**
	       * Async accessor to registered component instance
	       * If not available then a promise is created to notify
	       * all listeners when the instance is registered.
	       */when:function when(handle){if(isValidID(handle)){var deferred=$q.defer();var instance=self.get(handle);if(instance){deferred.resolve(instance);}else{if(pendings[handle]===undefined){pendings[handle]=[];}pendings[handle].push(deferred);}return deferred.promise;}return $q.reject("Invalid `md-component-id` value.");}};function isValidID(handle){return handle&&handle!=="";}}})();(function(){"use strict";(function(){'use strict';/**
	   * @ngdoc service
	   * @name $mdButtonInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
	   */MdButtonInkRipple.$inject=["$mdInkRipple"];angular.module('material.core').factory('$mdButtonInkRipple',MdButtonInkRipple);function MdButtonInkRipple($mdInkRipple){return{attach:function attachRipple(scope,element,options){options=angular.extend(optionsForElement(element),options);return $mdInkRipple.attach(scope,element,options);}};function optionsForElement(element){if(element.hasClass('md-icon-button')){return{isMenuItem:element.hasClass('md-menu-item'),fitRipple:true,center:true};}else{return{isMenuItem:element.hasClass('md-menu-item'),dimBackground:true};}}}})();})();(function(){"use strict";(function(){'use strict';/**
	   * @ngdoc service
	   * @name $mdCheckboxInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */MdCheckboxInkRipple.$inject=["$mdInkRipple"];angular.module('material.core').factory('$mdCheckboxInkRipple',MdCheckboxInkRipple);function MdCheckboxInkRipple($mdInkRipple){return{attach:attach};function attach(scope,element,options){return $mdInkRipple.attach(scope,element,angular.extend({center:true,dimBackground:false,fitRipple:true},options));}}})();})();(function(){"use strict";(function(){'use strict';/**
	   * @ngdoc service
	   * @name $mdListInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */MdListInkRipple.$inject=["$mdInkRipple"];angular.module('material.core').factory('$mdListInkRipple',MdListInkRipple);function MdListInkRipple($mdInkRipple){return{attach:attach};function attach(scope,element,options){return $mdInkRipple.attach(scope,element,angular.extend({center:false,dimBackground:true,outline:false,rippleSize:'full'},options));}}})();})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.core.ripple
	 * @description
	 * Ripple
	 */InkRippleCtrl.$inject=["$scope","$element","rippleOptions","$window","$timeout","$mdUtil","$mdColorUtil"];InkRippleDirective.$inject=["$mdButtonInkRipple","$mdCheckboxInkRipple"];angular.module('material.core').provider('$mdInkRipple',InkRippleProvider).directive('mdInkRipple',InkRippleDirective).directive('mdNoInk',attrNoDirective).directive('mdNoBar',attrNoDirective).directive('mdNoStretch',attrNoDirective);var DURATION=450;/**
	 * @ngdoc directive
	 * @name mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * The `md-ink-ripple` directive allows you to specify the ripple color or if a ripple is allowed.
	 *
	 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
	 *
	 * @usage
	 * ### String values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="#FF0000">
	 *     Ripples in red
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="false">
	 *     Not rippling
	 *   </ANY>
	 * </hljs>
	 *
	 * ### Interpolated values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="{{ randomColor() }}">
	 *     Ripples with the return value of 'randomColor' function
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="{{ canRipple() }}">
	 *     Ripples if 'canRipple' function return value is not 'false' or '0'
	 *   </ANY>
	 * </hljs>
	 */function InkRippleDirective($mdButtonInkRipple,$mdCheckboxInkRipple){return{controller:angular.noop,link:function link(scope,element,attr){attr.hasOwnProperty('mdInkRippleCheckbox')?$mdCheckboxInkRipple.attach(scope,element):$mdButtonInkRipple.attach(scope,element);}};}/**
	 * @ngdoc service
	 * @name $mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * `$mdInkRipple` is a service for adding ripples to any element
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.factory('$myElementInkRipple', function($mdInkRipple) {
	 *   return {
	 *     attach: function (scope, element, options) {
	 *       return $mdInkRipple.attach(scope, element, angular.extend({
	 *         center: false,
	 *         dimBackground: true
	 *       }, options));
	 *     }
	 *   };
	 * });
	 *
	 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
	 *   $scope.onClick = function (ev) {
	 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
	 *   }
	 * });
	 * </hljs>
	 *
	 * ### Disabling ripples globally
	 * If you want to disable ink ripples globally, for all components, you can call the
	 * `disableInkRipple` method in your app's config.
	 *
	 * <hljs lang="js">
	 * app.config(function ($mdInkRippleProvider) {
	 *   $mdInkRippleProvider.disableInkRipple();
	 * });
	 */function InkRippleProvider(){var isDisabledGlobally=false;return{disableInkRipple:disableInkRipple,$get:["$injector",function($injector){return{attach:attach};/**
	       * @ngdoc method
	       * @name $mdInkRipple#attach
	       *
	       * @description
	       * Attaching given scope, element and options to inkRipple controller
	       *
	       * @param {object=} scope Scope within the current context
	       * @param {object=} element The element the ripple effect should be applied to
	       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
	       * * `center` -  Whether the ripple should start from the center of the container element
	       * * `dimBackground` - Whether the background should be dimmed with the ripple color
	       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
	       * * `fitRipple` - Whether the ripple should fill the element
	       */function attach(scope,element,options){if(isDisabledGlobally||element.controller('mdNoInk'))return angular.noop;return $injector.instantiate(InkRippleCtrl,{$scope:scope,$element:element,rippleOptions:options});}}]};/**
	   * @ngdoc method
	   * @name $mdInkRipple#disableInkRipple
	   *
	   * @description
	   * A config-time method that, when called, disables ripples globally.
	   */function disableInkRipple(){isDisabledGlobally=true;}}/**
	 * Controller used by the ripple service in order to apply ripples
	 * @ngInject
	 */function InkRippleCtrl($scope,$element,rippleOptions,$window,$timeout,$mdUtil,$mdColorUtil){this.$window=$window;this.$timeout=$timeout;this.$mdUtil=$mdUtil;this.$mdColorUtil=$mdColorUtil;this.$scope=$scope;this.$element=$element;this.options=rippleOptions;this.mousedown=false;this.ripples=[];this.timeout=null;// Stores a reference to the most-recent ripple timeout
	this.lastRipple=null;$mdUtil.valueOnUse(this,'container',this.createContainer);this.$element.addClass('md-ink-ripple');// attach method for unit tests
	($element.controller('mdInkRipple')||{}).createRipple=angular.bind(this,this.createRipple);($element.controller('mdInkRipple')||{}).setColor=angular.bind(this,this.color);this.bindEvents();}/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup or mouseleave event)
	 */function autoCleanup(self,cleanupFn){if(self.mousedown||self.lastRipple){self.mousedown=false;self.$mdUtil.nextTick(angular.bind(self,cleanupFn),false);}}/**
	 * Returns the color that the ripple should be (either based on CSS or hard-coded)
	 * @returns {string}
	 */InkRippleCtrl.prototype.color=function(value){var self=this;// If assigning a color value, apply it to background and the ripple color
	if(angular.isDefined(value)){self._color=self._parseColor(value);}// If color lookup, use assigned, defined, or inherited
	return self._color||self._parseColor(self.inkRipple())||self._parseColor(getElementColor());/**
	   * Finds the color element and returns its text color for use as default ripple color
	   * @returns {string}
	   */function getElementColor(){var items=self.options&&self.options.colorElement?self.options.colorElement:[];var elem=items.length?items[0]:self.$element[0];return elem?self.$window.getComputedStyle(elem).color:'rgb(0,0,0)';}};/**
	 * Updating the ripple colors based on the current inkRipple value
	 * or the element's computed style color
	 */InkRippleCtrl.prototype.calculateColor=function(){return this.color();};/**
	 * Takes a string color and converts it to RGBA format
	 * @param color {string}
	 * @param [multiplier] {int}
	 * @returns {string}
	 */InkRippleCtrl.prototype._parseColor=function parseColor(color,multiplier){multiplier=multiplier||1;var colorUtil=this.$mdColorUtil;if(!color)return;if(color.indexOf('rgba')===0)return color.replace(/\d?\.?\d*\s*\)\s*$/,(0.1*multiplier).toString()+')');if(color.indexOf('rgb')===0)return colorUtil.rgbToRgba(color);if(color.indexOf('#')===0)return colorUtil.hexToRgba(color);};/**
	 * Binds events to the root element for
	 */InkRippleCtrl.prototype.bindEvents=function(){this.$element.on('mousedown',angular.bind(this,this.handleMousedown));this.$element.on('mouseup touchend',angular.bind(this,this.handleMouseup));this.$element.on('mouseleave',angular.bind(this,this.handleMouseup));this.$element.on('touchmove',angular.bind(this,this.handleTouchmove));};/**
	 * Create a new ripple on every mousedown event from the root element
	 * @param event {MouseEvent}
	 */InkRippleCtrl.prototype.handleMousedown=function(event){if(this.mousedown)return;// When jQuery is loaded, we have to get the original event
	if(event.hasOwnProperty('originalEvent'))event=event.originalEvent;this.mousedown=true;if(this.options.center){this.createRipple(this.container.prop('clientWidth')/2,this.container.prop('clientWidth')/2);}else{// We need to calculate the relative coordinates if the target is a sublayer of the ripple element
	if(event.srcElement!==this.$element[0]){var layerRect=this.$element[0].getBoundingClientRect();var layerX=event.clientX-layerRect.left;var layerY=event.clientY-layerRect.top;this.createRipple(layerX,layerY);}else{this.createRipple(event.offsetX,event.offsetY);}}};/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup, touchend or mouseleave event)
	 */InkRippleCtrl.prototype.handleMouseup=function(){autoCleanup(this,this.clearRipples);};/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
	 * touchmove)
	 */InkRippleCtrl.prototype.handleTouchmove=function(){autoCleanup(this,this.deleteRipples);};/**
	 * Cycles through all ripples and attempts to remove them.
	 */InkRippleCtrl.prototype.deleteRipples=function(){for(var i=0;i<this.ripples.length;i++){this.ripples[i].remove();}};/**
	 * Cycles through all ripples and attempts to remove them with fade.
	 * Depending on logic within `fadeInComplete`, some removals will be postponed.
	 */InkRippleCtrl.prototype.clearRipples=function(){for(var i=0;i<this.ripples.length;i++){this.fadeInComplete(this.ripples[i]);}};/**
	 * Creates the ripple container element
	 * @returns {*}
	 */InkRippleCtrl.prototype.createContainer=function(){var container=angular.element('<div class="md-ripple-container"></div>');this.$element.append(container);return container;};InkRippleCtrl.prototype.clearTimeout=function(){if(this.timeout){this.$timeout.cancel(this.timeout);this.timeout=null;}};InkRippleCtrl.prototype.isRippleAllowed=function(){var element=this.$element[0];do{if(!element.tagName||element.tagName==='BODY')break;if(element&&angular.isFunction(element.hasAttribute)){if(element.hasAttribute('disabled'))return false;if(this.inkRipple()==='false'||this.inkRipple()==='0')return false;}}while(element=element.parentNode);return true;};/**
	 * The attribute `md-ink-ripple` may be a static or interpolated
	 * color value OR a boolean indicator (used to disable ripples)
	 */InkRippleCtrl.prototype.inkRipple=function(){return this.$element.attr('md-ink-ripple');};/**
	 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
	 * @param left
	 * @param top
	 */InkRippleCtrl.prototype.createRipple=function(left,top){if(!this.isRippleAllowed())return;var ctrl=this;var colorUtil=ctrl.$mdColorUtil;var ripple=angular.element('<div class="md-ripple"></div>');var width=this.$element.prop('clientWidth');var height=this.$element.prop('clientHeight');var x=Math.max(Math.abs(width-left),left)*2;var y=Math.max(Math.abs(height-top),top)*2;var size=getSize(this.options.fitRipple,x,y);var color=this.calculateColor();ripple.css({left:left+'px',top:top+'px',background:'black',width:size+'px',height:size+'px',backgroundColor:colorUtil.rgbaToRgb(color),borderColor:colorUtil.rgbaToRgb(color)});this.lastRipple=ripple;// we only want one timeout to be running at a time
	this.clearTimeout();this.timeout=this.$timeout(function(){ctrl.clearTimeout();if(!ctrl.mousedown)ctrl.fadeInComplete(ripple);},DURATION*0.35,false);if(this.options.dimBackground)this.container.css({backgroundColor:color});this.container.append(ripple);this.ripples.push(ripple);ripple.addClass('md-ripple-placed');this.$mdUtil.nextTick(function(){ripple.addClass('md-ripple-scaled md-ripple-active');ctrl.$timeout(function(){ctrl.clearRipples();},DURATION,false);},false);function getSize(fit,x,y){return fit?Math.max(x,y):Math.sqrt(Math.pow(x,2)+Math.pow(y,2));}};/**
	 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
	 * @param ripple
	 */InkRippleCtrl.prototype.fadeInComplete=function(ripple){if(this.lastRipple===ripple){if(!this.timeout&&!this.mousedown){this.removeRipple(ripple);}}else{this.removeRipple(ripple);}};/**
	 * Kicks off the animation for removing a ripple
	 * @param ripple {Element}
	 */InkRippleCtrl.prototype.removeRipple=function(ripple){var ctrl=this;var index=this.ripples.indexOf(ripple);if(index<0)return;this.ripples.splice(this.ripples.indexOf(ripple),1);ripple.removeClass('md-ripple-active');ripple.addClass('md-ripple-remove');if(this.ripples.length===0)this.container.css({backgroundColor:''});// use a 2-second timeout in order to allow for the animation to finish
	// we don't actually care how long the animation takes
	this.$timeout(function(){ctrl.fadeOutComplete(ripple);},DURATION,false);};/**
	 * Removes the provided ripple from the DOM
	 * @param ripple
	 */InkRippleCtrl.prototype.fadeOutComplete=function(ripple){ripple.remove();this.lastRipple=null;};/**
	 * Used to create an empty directive.  This is used to track flag-directives whose children may have
	 * functionality based on them.
	 *
	 * Example: `md-no-ink` will potentially be used by all child directives.
	 */function attrNoDirective(){return{controller:angular.noop};}})();(function(){"use strict";(function(){'use strict';/**
	   * @ngdoc service
	   * @name $mdTabInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */MdTabInkRipple.$inject=["$mdInkRipple"];angular.module('material.core').factory('$mdTabInkRipple',MdTabInkRipple);function MdTabInkRipple($mdInkRipple){return{attach:attach};function attach(scope,element,options){return $mdInkRipple.attach(scope,element,angular.extend({center:false,dimBackground:true,outline:false,rippleSize:'full'},options));}}})();})();(function(){"use strict";angular.module('material.core.theming.palette',[]).constant('$mdColorPalette',{'red':{'50':'#ffebee','100':'#ffcdd2','200':'#ef9a9a','300':'#e57373','400':'#ef5350','500':'#f44336','600':'#e53935','700':'#d32f2f','800':'#c62828','900':'#b71c1c','A100':'#ff8a80','A200':'#ff5252','A400':'#ff1744','A700':'#d50000','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 300 A100','contrastStrongLightColors':'400 500 600 700 A200 A400 A700'},'pink':{'50':'#fce4ec','100':'#f8bbd0','200':'#f48fb1','300':'#f06292','400':'#ec407a','500':'#e91e63','600':'#d81b60','700':'#c2185b','800':'#ad1457','900':'#880e4f','A100':'#ff80ab','A200':'#ff4081','A400':'#f50057','A700':'#c51162','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 A100','contrastStrongLightColors':'500 600 A200 A400 A700'},'purple':{'50':'#f3e5f5','100':'#e1bee7','200':'#ce93d8','300':'#ba68c8','400':'#ab47bc','500':'#9c27b0','600':'#8e24aa','700':'#7b1fa2','800':'#6a1b9a','900':'#4a148c','A100':'#ea80fc','A200':'#e040fb','A400':'#d500f9','A700':'#aa00ff','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 A100','contrastStrongLightColors':'300 400 A200 A400 A700'},'deep-purple':{'50':'#ede7f6','100':'#d1c4e9','200':'#b39ddb','300':'#9575cd','400':'#7e57c2','500':'#673ab7','600':'#5e35b1','700':'#512da8','800':'#4527a0','900':'#311b92','A100':'#b388ff','A200':'#7c4dff','A400':'#651fff','A700':'#6200ea','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 A100','contrastStrongLightColors':'300 400 A200'},'indigo':{'50':'#e8eaf6','100':'#c5cae9','200':'#9fa8da','300':'#7986cb','400':'#5c6bc0','500':'#3f51b5','600':'#3949ab','700':'#303f9f','800':'#283593','900':'#1a237e','A100':'#8c9eff','A200':'#536dfe','A400':'#3d5afe','A700':'#304ffe','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 A100','contrastStrongLightColors':'300 400 A200 A400'},'blue':{'50':'#e3f2fd','100':'#bbdefb','200':'#90caf9','300':'#64b5f6','400':'#42a5f5','500':'#2196f3','600':'#1e88e5','700':'#1976d2','800':'#1565c0','900':'#0d47a1','A100':'#82b1ff','A200':'#448aff','A400':'#2979ff','A700':'#2962ff','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 300 400 A100','contrastStrongLightColors':'500 600 700 A200 A400 A700'},'light-blue':{'50':'#e1f5fe','100':'#b3e5fc','200':'#81d4fa','300':'#4fc3f7','400':'#29b6f6','500':'#03a9f4','600':'#039be5','700':'#0288d1','800':'#0277bd','900':'#01579b','A100':'#80d8ff','A200':'#40c4ff','A400':'#00b0ff','A700':'#0091ea','contrastDefaultColor':'dark','contrastLightColors':'600 700 800 900 A700','contrastStrongLightColors':'600 700 800 A700'},'cyan':{'50':'#e0f7fa','100':'#b2ebf2','200':'#80deea','300':'#4dd0e1','400':'#26c6da','500':'#00bcd4','600':'#00acc1','700':'#0097a7','800':'#00838f','900':'#006064','A100':'#84ffff','A200':'#18ffff','A400':'#00e5ff','A700':'#00b8d4','contrastDefaultColor':'dark','contrastLightColors':'700 800 900','contrastStrongLightColors':'700 800 900'},'teal':{'50':'#e0f2f1','100':'#b2dfdb','200':'#80cbc4','300':'#4db6ac','400':'#26a69a','500':'#009688','600':'#00897b','700':'#00796b','800':'#00695c','900':'#004d40','A100':'#a7ffeb','A200':'#64ffda','A400':'#1de9b6','A700':'#00bfa5','contrastDefaultColor':'dark','contrastLightColors':'500 600 700 800 900','contrastStrongLightColors':'500 600 700'},'green':{'50':'#e8f5e9','100':'#c8e6c9','200':'#a5d6a7','300':'#81c784','400':'#66bb6a','500':'#4caf50','600':'#43a047','700':'#388e3c','800':'#2e7d32','900':'#1b5e20','A100':'#b9f6ca','A200':'#69f0ae','A400':'#00e676','A700':'#00c853','contrastDefaultColor':'dark','contrastLightColors':'500 600 700 800 900','contrastStrongLightColors':'500 600 700'},'light-green':{'50':'#f1f8e9','100':'#dcedc8','200':'#c5e1a5','300':'#aed581','400':'#9ccc65','500':'#8bc34a','600':'#7cb342','700':'#689f38','800':'#558b2f','900':'#33691e','A100':'#ccff90','A200':'#b2ff59','A400':'#76ff03','A700':'#64dd17','contrastDefaultColor':'dark','contrastLightColors':'700 800 900','contrastStrongLightColors':'700 800 900'},'lime':{'50':'#f9fbe7','100':'#f0f4c3','200':'#e6ee9c','300':'#dce775','400':'#d4e157','500':'#cddc39','600':'#c0ca33','700':'#afb42b','800':'#9e9d24','900':'#827717','A100':'#f4ff81','A200':'#eeff41','A400':'#c6ff00','A700':'#aeea00','contrastDefaultColor':'dark','contrastLightColors':'900','contrastStrongLightColors':'900'},'yellow':{'50':'#fffde7','100':'#fff9c4','200':'#fff59d','300':'#fff176','400':'#ffee58','500':'#ffeb3b','600':'#fdd835','700':'#fbc02d','800':'#f9a825','900':'#f57f17','A100':'#ffff8d','A200':'#ffff00','A400':'#ffea00','A700':'#ffd600','contrastDefaultColor':'dark'},'amber':{'50':'#fff8e1','100':'#ffecb3','200':'#ffe082','300':'#ffd54f','400':'#ffca28','500':'#ffc107','600':'#ffb300','700':'#ffa000','800':'#ff8f00','900':'#ff6f00','A100':'#ffe57f','A200':'#ffd740','A400':'#ffc400','A700':'#ffab00','contrastDefaultColor':'dark'},'orange':{'50':'#fff3e0','100':'#ffe0b2','200':'#ffcc80','300':'#ffb74d','400':'#ffa726','500':'#ff9800','600':'#fb8c00','700':'#f57c00','800':'#ef6c00','900':'#e65100','A100':'#ffd180','A200':'#ffab40','A400':'#ff9100','A700':'#ff6d00','contrastDefaultColor':'dark','contrastLightColors':'800 900','contrastStrongLightColors':'800 900'},'deep-orange':{'50':'#fbe9e7','100':'#ffccbc','200':'#ffab91','300':'#ff8a65','400':'#ff7043','500':'#ff5722','600':'#f4511e','700':'#e64a19','800':'#d84315','900':'#bf360c','A100':'#ff9e80','A200':'#ff6e40','A400':'#ff3d00','A700':'#dd2c00','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 300 400 A100 A200','contrastStrongLightColors':'500 600 700 800 900 A400 A700'},'brown':{'50':'#efebe9','100':'#d7ccc8','200':'#bcaaa4','300':'#a1887f','400':'#8d6e63','500':'#795548','600':'#6d4c41','700':'#5d4037','800':'#4e342e','900':'#3e2723','A100':'#d7ccc8','A200':'#bcaaa4','A400':'#8d6e63','A700':'#5d4037','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 A100 A200','contrastStrongLightColors':'300 400'},'grey':{'50':'#fafafa','100':'#f5f5f5','200':'#eeeeee','300':'#e0e0e0','400':'#bdbdbd','500':'#9e9e9e','600':'#757575','700':'#616161','800':'#424242','900':'#212121','A100':'#ffffff','A200':'#000000','A400':'#303030','A700':'#616161','contrastDefaultColor':'dark','contrastLightColors':'600 700 800 900 A200 A400 A700'},'blue-grey':{'50':'#eceff1','100':'#cfd8dc','200':'#b0bec5','300':'#90a4ae','400':'#78909c','500':'#607d8b','600':'#546e7a','700':'#455a64','800':'#37474f','900':'#263238','A100':'#cfd8dc','A200':'#b0bec5','A400':'#78909c','A700':'#455a64','contrastDefaultColor':'light','contrastDarkColors':'50 100 200 300 A100 A200','contrastStrongLightColors':'400 500 700'}});})();(function(){"use strict";(function(angular){'use strict';/**
	 * @ngdoc module
	 * @name material.core.theming
	 * @description
	 * Theming
	 */detectDisabledThemes.$inject=["$mdThemingProvider"];ThemingDirective.$inject=["$mdTheming","$interpolate","$parse","$mdUtil","$q","$log"];ThemableDirective.$inject=["$mdTheming"];ThemingProvider.$inject=["$mdColorPalette","$$mdMetaProvider"];generateAllThemes.$inject=["$injector","$mdTheming"];angular.module('material.core.theming',['material.core.theming.palette','material.core.meta']).directive('mdTheme',ThemingDirective).directive('mdThemable',ThemableDirective).directive('mdThemesDisabled',disableThemesDirective).provider('$mdTheming',ThemingProvider).config(detectDisabledThemes).run(generateAllThemes);/**
	 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
	 * If yes, then immediately disable all theme stylesheet generation and DOM injection
	 *//**
	 * @ngInject
	 */function detectDisabledThemes($mdThemingProvider){var isDisabled=!!document.querySelector('[md-themes-disabled]');$mdThemingProvider.disableTheming(isDisabled);}/**
	 * @ngdoc service
	 * @name $mdThemingProvider
	 * @module material.core.theming
	 *
	 * @description Provider to configure the `$mdTheming` service.
	 *
	 * ### Default Theme
	 * The `$mdThemingProvider` uses by default the following theme configuration:
	 *
	 * - Primary Palette: `Blue`
	 * - Accent Palette: `Pink`
	 * - Warn Palette: `Deep-Orange`
	 * - Background Palette: `Grey`
	 *
	 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
	 * the default theme.<br/>
	 * This can be done by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     $mdThemingProvider
	 *       .theme('default')
	 *       .primaryPalette('blue')
	 *       .accentPalette('teal')
	 *       .warnPalette('red')
	 *       .backgroundPalette('grey');
	 *   });
	 * </hljs>
	 *
	
	 * ### Dynamic Themes
	 *
	 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
	 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable theme watching.
	 *     $mdThemingProvider.alwaysWatchTheme(true);
	 *   });
	 * </hljs>
	 *
	 * ### Custom Theme Styles
	 *
	 * Sometimes you may want to use your own theme styles for some custom components.<br/>
	 * You are able to register your own styles by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register our custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(STYLESHEET);
	 *   });
	 * </hljs>
	 *
	 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
	 * stylesheet file into the `$mdThemingProvider`.
	 *
	 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
	 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register your custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
	 *   });
	 * </hljs>
	 *
	 * ### Browser color
	 *
	 * Enables browser header coloring
	 * for more info please visit:
	 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	 *
	 * Options parameter: <br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable browser color
	 *     $mdThemingProvider.enableBrowserColor({
	 *       theme: 'myTheme', // Default is 'default'
	 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
	 *       hue: '200' // Default is '800'
	 *     });
	 *   });
	 * </hljs>
	 *//**
	 * @ngdoc method
	 * @name $mdThemingProvider#registerStyles
	 * @param {string} styles The styles to be appended to AngularJS Material's built in theme css.
	 *//**
	 * @ngdoc method
	 * @name $mdThemingProvider#setNonce
	 * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
	 * Setting a value allows the use of CSP policy without using the unsafe-inline directive.
	 *//**
	 * @ngdoc method
	 * @name $mdThemingProvider#setDefaultTheme
	 * @param {string} themeName Default theme name to be applied to elements. Default value is `default`.
	 *//**
	 * @ngdoc method
	 * @name $mdThemingProvider#alwaysWatchTheme
	 * @param {boolean} watch Whether or not to always watch themes for changes and re-apply
	 * classes when they change. Default is `false`. Enabling can reduce performance.
	 *//**
	 * @ngdoc method
	 * @name $mdThemingProvider#enableBrowserColor
	 * @param {Object=} options Options object for the browser color<br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 * @returns {Function} remove function of the browser color
	 *//* Some Example Valid Theming Expressions
	 * =======================================
	 *
	 * Intention group expansion: (valid for primary, accent, warn, background)
	 *
	 * {{primary-100}} - grab shade 100 from the primary palette
	 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
	 * {{primary-100-contrast}} - grab shade 100's contrast color
	 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
	 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
	 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
	 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
	 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
	 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
	 *
	 * Foreground expansion: Applies rgba to black/white foreground text
	 *
	 * {{foreground-1}} - used for primary text
	 * {{foreground-2}} - used for secondary text/divider
	 * {{foreground-3}} - used for disabled text
	 * {{foreground-4}} - used for dividers
	 *
	 */// In memory generated CSS rules; registered by theme.name
	var GENERATED={};// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
	var PALETTES;// Text Colors on light and dark backgrounds
	// @see https://www.google.com/design/spec/style/color.html#color-text-background-colors
	var DARK_FOREGROUND={name:'dark','1':'rgba(0,0,0,0.87)','2':'rgba(0,0,0,0.54)','3':'rgba(0,0,0,0.38)','4':'rgba(0,0,0,0.12)'};var LIGHT_FOREGROUND={name:'light','1':'rgba(255,255,255,1.0)','2':'rgba(255,255,255,0.7)','3':'rgba(255,255,255,0.5)','4':'rgba(255,255,255,0.12)'};var DARK_SHADOW='1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';var LIGHT_SHADOW='';var DARK_CONTRAST_COLOR=colorToRgbaArray('rgba(0,0,0,0.87)');var LIGHT_CONTRAST_COLOR=colorToRgbaArray('rgba(255,255,255,0.87)');var STRONG_LIGHT_CONTRAST_COLOR=colorToRgbaArray('rgb(255,255,255)');var THEME_COLOR_TYPES=['primary','accent','warn','background'];var DEFAULT_COLOR_TYPE='primary';// A color in a theme will use these hues by default, if not specified by user.
	var LIGHT_DEFAULT_HUES={'accent':{'default':'A200','hue-1':'A100','hue-2':'A400','hue-3':'A700'},'background':{'default':'50','hue-1':'A100','hue-2':'100','hue-3':'300'}};var DARK_DEFAULT_HUES={'background':{'default':'A400','hue-1':'800','hue-2':'900','hue-3':'A200'}};THEME_COLOR_TYPES.forEach(function(colorType){// Color types with unspecified default hues will use these default hue values
	var defaultDefaultHues={'default':'500','hue-1':'300','hue-2':'800','hue-3':'A100'};if(!LIGHT_DEFAULT_HUES[colorType])LIGHT_DEFAULT_HUES[colorType]=defaultDefaultHues;if(!DARK_DEFAULT_HUES[colorType])DARK_DEFAULT_HUES[colorType]=defaultDefaultHues;});var VALID_HUE_VALUES=['50','100','200','300','400','500','600','700','800','900','A100','A200','A400','A700'];var themeConfig={disableTheming:false,// Generate our themes at run time; also disable stylesheet DOM injection
	generateOnDemand:false,// Whether or not themes are to be generated on-demand (vs. eagerly).
	registeredStyles:[],// Custom styles registered to be used in the theming of custom components.
	nonce:null// Nonce to be added as an attribute to the generated themes style tags.
	};/**
	 *
	 */function ThemingProvider($mdColorPalette,$$mdMetaProvider){ThemingService.$inject=["$rootScope","$mdUtil","$q","$log"];PALETTES={};var THEMES={};var themingProvider;var _alwaysWatchTheme=false;var defaultTheme='default';// Load JS Defined Palettes
	angular.extend(PALETTES,$mdColorPalette);// Default theme defined in core.js
	/**
	   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
	   * @param {string} color Hex value of the wanted browser color
	   * @returns {Function} Remove function of the meta tags
	   */var setBrowserColor=function setBrowserColor(color){// Chrome, Firefox OS and Opera
	var removeChrome=$$mdMetaProvider.setMeta('theme-color',color);// Windows Phone
	var removeWindows=$$mdMetaProvider.setMeta('msapplication-navbutton-color',color);return function(){removeChrome();removeWindows();};};/**
	   * Enables browser header coloring
	   * for more info please visit:
	   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	   *
	   * The default color is `800` from `primary` palette of the `default` theme
	   *
	   * options are:
	   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme
	   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	   *             'accent', 'background' and 'warn'. Default is `primary`
	   * `hue`     - The hue from the selected palette. Default is `800`
	   *
	   * @param {Object=} options Options object for the browser color
	   * @returns {Function} remove function of the browser color
	   */var enableBrowserColor=function enableBrowserColor(options){options=angular.isObject(options)?options:{};var theme=options.theme||'default';var hue=options.hue||'800';var palette=PALETTES[options.palette]||PALETTES[THEMES[theme].colors[options.palette||'primary'].name];var color=angular.isObject(palette[hue])?palette[hue].hex:palette[hue];return setBrowserColor(color);};return themingProvider={definePalette:definePalette,extendPalette:extendPalette,theme:registerTheme,/**
	     * return a read-only clone of the current theme configuration
	     */configuration:function configuration(){return angular.extend({},themeConfig,{defaultTheme:defaultTheme,alwaysWatchTheme:_alwaysWatchTheme,registeredStyles:[].concat(themeConfig.registeredStyles)});},/**
	     * Easy way to disable theming without having to use
	     * `.constant("$MD_THEME_CSS","");` This disables
	     * all dynamic theme style sheet generations and injections...
	     */disableTheming:function disableTheming(isDisabled){themeConfig.disableTheming=angular.isUndefined(isDisabled)||!!isDisabled;},registerStyles:function registerStyles(styles){themeConfig.registeredStyles.push(styles);},setNonce:function setNonce(nonceValue){themeConfig.nonce=nonceValue;},generateThemesOnDemand:function generateThemesOnDemand(onDemand){themeConfig.generateOnDemand=onDemand;},setDefaultTheme:function setDefaultTheme(theme){defaultTheme=theme;},alwaysWatchTheme:function alwaysWatchTheme(alwaysWatch){_alwaysWatchTheme=alwaysWatch;},enableBrowserColor:enableBrowserColor,$get:ThemingService,_LIGHT_DEFAULT_HUES:LIGHT_DEFAULT_HUES,_DARK_DEFAULT_HUES:DARK_DEFAULT_HUES,_PALETTES:PALETTES,_THEMES:THEMES,_parseRules:parseRules,_rgba:rgba};// Example: $mdThemingProvider.definePalette('neonRed', { 50: '#f5fafa', ... });
	function definePalette(name,map){map=map||{};PALETTES[name]=checkPaletteValid(name,map);return themingProvider;}// Returns an new object which is a copy of a given palette `name` with variables from
	// `map` overwritten
	// Example: var neonRedMap = $mdThemingProvider.extendPalette('red', { 50: '#f5fafafa' });
	function extendPalette(name,map){return checkPaletteValid(name,angular.extend({},PALETTES[name]||{},map));}// Make sure that palette has all required hues
	function checkPaletteValid(name,map){var missingColors=VALID_HUE_VALUES.filter(function(field){return!map[field];});if(missingColors.length){throw new Error("Missing colors %1 in palette %2!".replace('%1',missingColors.join(', ')).replace('%2',name));}return map;}// Register a theme (which is a collection of color palettes to use with various states
	// ie. warn, accent, primary )
	// Optionally inherit from an existing theme
	// $mdThemingProvider.theme('custom-theme').primaryPalette('red');
	function registerTheme(name,inheritFrom){if(THEMES[name])return THEMES[name];inheritFrom=inheritFrom||'default';var parentTheme=typeof inheritFrom==='string'?THEMES[inheritFrom]:inheritFrom;var theme=new Theme(name);if(parentTheme){angular.forEach(parentTheme.colors,function(color,colorType){theme.colors[colorType]={name:color.name,// Make sure a COPY of the hues is given to the child color,
	// not the same reference.
	hues:angular.extend({},color.hues)};});}THEMES[name]=theme;return theme;}function Theme(name){var self=this;self.name=name;self.colors={};self.dark=setDark;setDark(false);function setDark(isDark){isDark=arguments.length===0?true:!!isDark;// If no change, abort
	if(isDark===self.isDark)return;self.isDark=isDark;self.foregroundPalette=self.isDark?LIGHT_FOREGROUND:DARK_FOREGROUND;self.foregroundShadow=self.isDark?DARK_SHADOW:LIGHT_SHADOW;// Light and dark themes have different default hues.
	// Go through each existing color type for this theme, and for every
	// hue value that is still the default hue value from the previous light/dark setting,
	// set it to the default hue value from the new light/dark setting.
	var newDefaultHues=self.isDark?DARK_DEFAULT_HUES:LIGHT_DEFAULT_HUES;var oldDefaultHues=self.isDark?LIGHT_DEFAULT_HUES:DARK_DEFAULT_HUES;angular.forEach(newDefaultHues,function(newDefaults,colorType){var color=self.colors[colorType];var oldDefaults=oldDefaultHues[colorType];if(color){for(var hueName in color.hues){if(color.hues[hueName]===oldDefaults[hueName]){color.hues[hueName]=newDefaults[hueName];}}}});return self;}THEME_COLOR_TYPES.forEach(function(colorType){var defaultHues=(self.isDark?DARK_DEFAULT_HUES:LIGHT_DEFAULT_HUES)[colorType];self[colorType+'Palette']=function setPaletteType(paletteName,hues){var color=self.colors[colorType]={name:paletteName,hues:angular.extend({},defaultHues,hues)};Object.keys(color.hues).forEach(function(name){if(!defaultHues[name]){throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4".replace('%1',name).replace('%2',self.name).replace('%3',paletteName).replace('%4',Object.keys(defaultHues).join(', ')));}});Object.keys(color.hues).map(function(key){return color.hues[key];}).forEach(function(hueValue){if(VALID_HUE_VALUES.indexOf(hueValue)==-1){throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5".replace('%1',hueValue).replace('%2',self.name).replace('%3',colorType).replace('%4',paletteName).replace('%5',VALID_HUE_VALUES.join(', ')));}});return self;};self[colorType+'Color']=function(){var args=Array.prototype.slice.call(arguments);// eslint-disable-next-line no-console
	console.warn('$mdThemingProviderTheme.'+colorType+'Color() has been deprecated. '+'Use $mdThemingProviderTheme.'+colorType+'Palette() instead.');return self[colorType+'Palette'].apply(self,args);};});}/**
	   * @ngdoc service
	   * @name $mdTheming
	   * @module material.core.theming
	   *
	   * @description
	   *
	   * Service that makes an element apply theming related <b>classes</b> to itself.
	   *
	   * <hljs lang="js">
	   * app.directive('myFancyDirective', function($mdTheming) {
	   *   return {
	   *     restrict: 'e',
	   *     link: function(scope, el, attrs) {
	   *       $mdTheming(el);
	   *
	   *       $mdTheming.defineTheme('myTheme', {
	   *         primary: 'blue',
	   *         accent: 'pink',
	   *         dark: true
	   *       })
	   *     }
	   *   };
	   * });
	   * </hljs>
	   * @param {element=} element to apply theming to
	   *//**
	   * @ngdoc property
	   * @name $mdTheming#THEMES
	   * @description
	   * Property to get all the themes defined
	   * @returns {Object} All the themes defined with their properties
	   *//**
	   * @ngdoc property
	   * @name $mdTheming#PALETTES
	   * @description
	   * Property to get all the palettes defined
	   * @returns {Object} All the palettes defined with their colors
	   *//**
	   * @ngdoc method
	   * @name $mdTheming#registered
	   * @description
	   * Determine is specified theme name is a valid, registered theme
	   * @param {string} themeName the theme to check if registered
	   * @returns {boolean} whether the theme is registered or not
	   *//**
	   * @ngdoc method
	   * @name $mdTheming#defaultTheme
	   * @description
	   * Returns the default theme
	   * @returns {string} The default theme
	   *//**
	   * @ngdoc method
	   * @name $mdTheming#generateTheme
	   * @description
	   * Lazy generate themes - by default, every theme is generated when defined.
	   * You can disable this in the configuration section using the
	   * `$mdThemingProvider.generateThemesOnDemand(true);`
	   *
	   * The theme name that is passed in must match the name of the theme that was defined as part of the configuration block.
	   *
	   * @param name {string} theme name to generate
	   *//**
	   * @ngdoc method
	   * @name $mdTheming#setBrowserColor
	   * @description
	   * Sets browser header coloring
	   * for more info please visit:
	   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	   *
	   * The default color is `800` from `primary` palette of the `default` theme
	   *
	   * options are:<br/>
	   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme.<br/>
	   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	   *             'accent', 'background' and 'warn'. Default is `primary`<br/>
	   * `hue`     - The hue from the selected palette. Default is `800`
	   *
	   * @param {Object} options Options object for the browser color
	   * @returns {Function} remove function of the browser color
	   *//**
	   * @ngdoc method
	   * @name $mdTheming#defineTheme
	   * @description
	   * Dynamically define a theme by an options object
	   *
	   * options are:<br/>
	   * `primary`    - The primary palette of the theme.<br/>
	   * `accent`     - The accent palette of the theme.<br/>
	   * `warn`       - The warn palette of the theme.<br/>
	   * `background` - The background palette of the theme.<br/>
	   * `dark`       - Indicates if it's a dark theme.<br/>
	   *
	   * @param {String} name Theme name to define
	   * @param {Object} options Theme definition options
	   * @returns {Promise<string>} A resolved promise with the theme name
	   *//* @ngInject */function ThemingService($rootScope,$mdUtil,$q,$log){// Allow us to be invoked via a linking function signature.
	var applyTheme=function applyTheme(scope,el){if(el===undefined){el=scope;scope=undefined;}if(scope===undefined){scope=$rootScope;}applyTheme.inherit(el,el);};Object.defineProperty(applyTheme,'THEMES',{get:function get(){return angular.extend({},THEMES);}});Object.defineProperty(applyTheme,'PALETTES',{get:function get(){return angular.extend({},PALETTES);}});Object.defineProperty(applyTheme,'ALWAYS_WATCH',{get:function get(){return _alwaysWatchTheme;}});applyTheme.inherit=inheritTheme;applyTheme.registered=registered;applyTheme.defaultTheme=function(){return defaultTheme;};applyTheme.generateTheme=function(name){generateTheme(THEMES[name],name,themeConfig.nonce);};applyTheme.defineTheme=function(name,options){options=options||{};var theme=registerTheme(name);if(options.primary){theme.primaryPalette(options.primary);}if(options.accent){theme.accentPalette(options.accent);}if(options.warn){theme.warnPalette(options.warn);}if(options.background){theme.backgroundPalette(options.background);}if(options.dark){theme.dark();}this.generateTheme(name);return $q.resolve(name);};applyTheme.setBrowserColor=enableBrowserColor;return applyTheme;/**
	     * Determine is specified theme name is a valid, registered theme
	     */function registered(themeName){if(themeName===undefined||themeName==='')return true;return applyTheme.THEMES[themeName]!==undefined;}/**
	     * Get theme name for the element, then update with Theme CSS class
	     */function inheritTheme(el,parent){var ctrl=parent.controller('mdTheme')||el.data('$mdThemeController');updateThemeClass(lookupThemeName());if(ctrl){var watchTheme=_alwaysWatchTheme||ctrl.$shouldWatch||$mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));var unwatch=ctrl.registerChanges(function(name){updateThemeClass(name);if(!watchTheme){unwatch();}else{el.on('$destroy',unwatch);}});}/**
	       * Find the theme name from the parent controller or element data
	       */function lookupThemeName(){// As a few components (dialog) add their controllers later, we should also watch for a controller init.
	return ctrl&&ctrl.$mdTheme||(defaultTheme=='default'?'':defaultTheme);}/**
	       * Remove old theme class and apply a new one
	       * NOTE: if not a valid theme name, then the current name is not changed
	       */function updateThemeClass(theme){if(!theme)return;if(!registered(theme)){$log.warn('Attempted to use unregistered theme \''+theme+'\'. '+'Register it with $mdThemingProvider.theme().');}var oldTheme=el.data('$mdThemeName');if(oldTheme)el.removeClass('md-'+oldTheme+'-theme');el.addClass('md-'+theme+'-theme');el.data('$mdThemeName',theme);if(ctrl){el.data('$mdThemeController',ctrl);}}}}}function ThemingDirective($mdTheming,$interpolate,$parse,$mdUtil,$q,$log){return{priority:101,// has to be more than 100 to be before interpolation (issue on IE)
	link:{pre:function pre(scope,el,attrs){var registeredCallbacks=[];var startSymbol=$interpolate.startSymbol();var endSymbol=$interpolate.endSymbol();var theme=attrs.mdTheme.trim();var hasInterpolation=theme.substr(0,startSymbol.length)===startSymbol&&theme.lastIndexOf(endSymbol)===theme.length-endSymbol.length;var oneTimeOperator='::';var oneTimeBind=attrs.mdTheme.split(startSymbol).join('').split(endSymbol).join('').trim().substr(0,oneTimeOperator.length)===oneTimeOperator;var ctrl={registerChanges:function registerChanges(cb,context){if(context){cb=angular.bind(context,cb);}registeredCallbacks.push(cb);return function(){var index=registeredCallbacks.indexOf(cb);if(index>-1){registeredCallbacks.splice(index,1);}};},$setTheme:function $setTheme(theme){if(!$mdTheming.registered(theme)){$log.warn('attempted to use unregistered theme \''+theme+'\'');}ctrl.$mdTheme=theme;// Iterating backwards to support unregistering during iteration
	// http://stackoverflow.com/a/9882349/890293
	// we don't use `reverse()` of array because it mutates the array and we don't want it to get re-indexed
	for(var i=registeredCallbacks.length;i--;){registeredCallbacks[i](theme);}},$shouldWatch:$mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'))||$mdTheming.ALWAYS_WATCH||hasInterpolation&&!oneTimeBind};el.data('$mdThemeController',ctrl);var getTheme=function getTheme(){var interpolation=$interpolate(attrs.mdTheme)(scope);return $parse(interpolation)(scope)||interpolation;};var setParsedTheme=function setParsedTheme(theme){if(typeof theme==='string'){return ctrl.$setTheme(theme);}$q.when(angular.isFunction(theme)?theme():theme).then(function(name){ctrl.$setTheme(name);});};setParsedTheme(getTheme());var unwatch=scope.$watch(getTheme,function(theme){if(theme){setParsedTheme(theme);if(!ctrl.$shouldWatch){unwatch();}}});}}};}/**
	 * Special directive that will disable ALL runtime Theme style generation and DOM injection
	 *
	 * <link rel="stylesheet" href="angular-material.min.css">
	 * <link rel="stylesheet" href="angular-material.themes.css">
	 *
	 * <body md-themes-disabled>
	 *  ...
	 * </body>
	 *
	 * Note: Using md-themes-css directive requires the developer to load external
	 * theme stylesheets; e.g. custom themes from Material-Tools:
	 *
	 *       `angular-material.themes.css`
	 *
	 * Another option is to use the ThemingProvider to configure and disable the attribute
	 * conversions; this would obviate the use of the `md-themes-css` directive
	 *
	 */function disableThemesDirective(){themeConfig.disableTheming=true;// Return a 1x-only, first-match attribute directive
	return{restrict:'A',priority:'900'};}function ThemableDirective($mdTheming){return $mdTheming;}function parseRules(theme,colorType,rules){checkValidPalette(theme,colorType);rules=rules.replace(/THEME_NAME/g,theme.name);var themeNameRegex=new RegExp('\\.md-'+theme.name+'-theme','g');var simpleVariableRegex=/'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue-[0-3]|shadow|default)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;// find and replace simple variables where we use a specific hue, not an entire palette
	// eg. "{{primary-100}}"
	//\(' + THEME_COLOR_TYPES.join('\|') + '\)'
	rules=rules.replace(simpleVariableRegex,function(match,colorType,hue,opacity,contrast){if(colorType==='foreground'){if(hue=='shadow'){return theme.foregroundShadow;}else{return theme.foregroundPalette[hue]||theme.foregroundPalette['1'];}}// `default` is also accepted as a hue-value, because the background palettes are
	// using it as a name for the default hue.
	if(hue.indexOf('hue')===0||hue==='default'){hue=theme.colors[colorType].hues[hue];}return rgba((PALETTES[theme.colors[colorType].name][hue]||'')[contrast?'contrast':'value'],opacity);});// Matches '{{ primary-color }}', etc
	var hueRegex=new RegExp('(\'|")?{{\\s*([a-zA-Z]+)-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}("|\')?','g');var generatedRules=[];// For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
	angular.forEach(['default','hue-1','hue-2','hue-3'],function(hueName){var newRule=rules.replace(hueRegex,function(match,_,matchedColorType,hueType,opacity){var color=theme.colors[matchedColorType];var palette=PALETTES[color.name];var hueValue=color.hues[hueName];return rgba(palette[hueValue][hueType==='color'?'value':'contrast'],opacity);});if(hueName!=='default'){newRule=newRule.replace(themeNameRegex,'.md-'+theme.name+'-theme.md-'+hueName);}// Don't apply a selector rule to the default theme, making it easier to override
	// styles of the base-component
	if(theme.name=='default'){var themeRuleRegex=/((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;newRule=newRule.replace(themeRuleRegex,function(match,start,end){return match+', '+start+end;});}generatedRules.push(newRule);});return generatedRules;}var rulesByType={};// Generate our themes at run time given the state of THEMES and PALETTES
	function generateAllThemes($injector,$mdTheming){var head=document.head;var firstChild=head?head.firstElementChild:null;var themeCss=!themeConfig.disableTheming&&$injector.has('$MD_THEME_CSS')?$injector.get('$MD_THEME_CSS'):'';// Append our custom registered styles to the theme stylesheet.
	themeCss+=themeConfig.registeredStyles.join('');if(!firstChild)return;if(themeCss.length===0)return;// no rules, so no point in running this expensive task
	// Expose contrast colors for palettes to ensure that text is always readable
	angular.forEach(PALETTES,sanitizePalette);// MD_THEME_CSS is a string generated by the build process that includes all the themable
	// components as templates
	// Break the CSS into individual rules
	var rules=themeCss.split(/\}(?!(\}|'|"|;))/).filter(function(rule){return rule&&rule.trim().length;}).map(function(rule){return rule.trim()+'}';});THEME_COLOR_TYPES.forEach(function(type){rulesByType[type]='';});// Sort the rules based on type, allowing us to do color substitution on a per-type basis
	rules.forEach(function(rule){// First: test that if the rule has '.md-accent', it goes into the accent set of rules
	for(var i=0,type;type=THEME_COLOR_TYPES[i];i++){if(rule.indexOf('.md-'+type)>-1){return rulesByType[type]+=rule;}}// If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
	// there
	for(i=0;type=THEME_COLOR_TYPES[i];i++){if(rule.indexOf(type)>-1){return rulesByType[type]+=rule;}}// Default to the primary array
	return rulesByType[DEFAULT_COLOR_TYPE]+=rule;});// If themes are being generated on-demand, quit here. The user will later manually
	// call generateTheme to do this on a theme-by-theme basis.
	if(themeConfig.generateOnDemand)return;angular.forEach($mdTheming.THEMES,function(theme){if(!GENERATED[theme.name]&&!($mdTheming.defaultTheme()!=='default'&&theme.name==='default')){generateTheme(theme,theme.name,themeConfig.nonce);}});// *************************
	// Internal functions
	// *************************
	// The user specifies a 'default' contrast color as either light or dark,
	// then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
	function sanitizePalette(palette,name){var defaultContrast=palette.contrastDefaultColor;var lightColors=palette.contrastLightColors||[];var strongLightColors=palette.contrastStrongLightColors||[];var darkColors=palette.contrastDarkColors||[];// These colors are provided as space-separated lists
	if(typeof lightColors==='string')lightColors=lightColors.split(' ');if(typeof strongLightColors==='string')strongLightColors=strongLightColors.split(' ');if(typeof darkColors==='string')darkColors=darkColors.split(' ');// Cleanup after ourselves
	delete palette.contrastDefaultColor;delete palette.contrastLightColors;delete palette.contrastStrongLightColors;delete palette.contrastDarkColors;// Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
	angular.forEach(palette,function(hueValue,hueName){if(angular.isObject(hueValue))return;// Already converted
	// Map everything to rgb colors
	var rgbValue=colorToRgbaArray(hueValue);if(!rgbValue){throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected.".replace('%1',hueValue).replace('%2',palette.name).replace('%3',hueName));}palette[hueName]={hex:palette[hueName],value:rgbValue,contrast:getContrastColor()};function getContrastColor(){if(defaultContrast==='light'){if(darkColors.indexOf(hueName)>-1){return DARK_CONTRAST_COLOR;}else{return strongLightColors.indexOf(hueName)>-1?STRONG_LIGHT_CONTRAST_COLOR:LIGHT_CONTRAST_COLOR;}}else{if(lightColors.indexOf(hueName)>-1){return strongLightColors.indexOf(hueName)>-1?STRONG_LIGHT_CONTRAST_COLOR:LIGHT_CONTRAST_COLOR;}else{return DARK_CONTRAST_COLOR;}}}});}}function generateTheme(theme,name,nonce){var head=document.head;var firstChild=head?head.firstElementChild:null;if(!GENERATED[name]){// For each theme, use the color palettes specified for
	// `primary`, `warn` and `accent` to generate CSS rules.
	THEME_COLOR_TYPES.forEach(function(colorType){var styleStrings=parseRules(theme,colorType,rulesByType[colorType]);while(styleStrings.length){var styleContent=styleStrings.shift();if(styleContent){var style=document.createElement('style');style.setAttribute('md-theme-style','');if(nonce){style.setAttribute('nonce',nonce);}style.appendChild(document.createTextNode(styleContent));head.insertBefore(style,firstChild);}}});GENERATED[theme.name]=true;}}function checkValidPalette(theme,colorType){// If theme attempts to use a palette that doesnt exist, throw error
	if(!PALETTES[(theme.colors[colorType]||{}).name]){throw new Error("You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3".replace('%1',theme.name).replace('%2',colorType).replace('%3',Object.keys(PALETTES).join(', ')));}}function colorToRgbaArray(clr){if(angular.isArray(clr)&&clr.length==3)return clr;if(/^rgb/.test(clr)){return clr.replace(/(^\s*rgba?\(|\)\s*$)/g,'').split(',').map(function(value,i){return i==3?parseFloat(value,10):parseInt(value,10);});}if(clr.charAt(0)=='#')clr=clr.substring(1);if(!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr))return;var dig=clr.length/3;var red=clr.substr(0,dig);var grn=clr.substr(dig,dig);var blu=clr.substr(dig*2);if(dig===1){red+=red;grn+=grn;blu+=blu;}return[parseInt(red,16),parseInt(grn,16),parseInt(blu,16)];}function rgba(rgbArray,opacity){if(!rgbArray)return"rgb('0,0,0')";if(rgbArray.length==4){rgbArray=angular.copy(rgbArray);opacity?rgbArray.pop():opacity=rgbArray.pop();}return opacity&&(typeof opacity=='number'||typeof opacity=='string'&&opacity.length)?'rgba('+rgbArray.join(',')+','+opacity+')':'rgb('+rgbArray.join(',')+')';}})(window.angular);})();(function(){"use strict";// Polyfill angular < 1.4 (provide $animateCss)
	angular.module('material.core').factory('$$mdAnimate',["$q","$timeout","$mdConstant","$animateCss",function($q,$timeout,$mdConstant,$animateCss){// Since $$mdAnimate is injected into $mdUtil... use a wrapper function
	// to subsequently inject $mdUtil as an argument to the AnimateDomUtils
	return function($mdUtil){return AnimateDomUtils($mdUtil,$q,$timeout,$mdConstant,$animateCss);};}]);/**
	 * Factory function that requires special injections
	 */function AnimateDomUtils($mdUtil,$q,$timeout,$mdConstant,$animateCss){var self;return self={/**
	     *
	     */translate3d:function translate3d(target,from,to,options){return $animateCss(target,{from:from,to:to,addClass:options.transitionInClass,removeClass:options.transitionOutClass,duration:options.duration}).start().then(function(){// Resolve with reverser function...
	return reverseTranslate;});/**
	       * Specific reversal of the request translate animation above...
	       */function reverseTranslate(newFrom){return $animateCss(target,{to:newFrom||from,addClass:options.transitionOutClass,removeClass:options.transitionInClass,duration:options.duration}).start();}},/**
	     * Listen for transitionEnd event (with optional timeout)
	     * Announce completion or failure via promise handlers
	     */waitTransitionEnd:function waitTransitionEnd(element,opts){var TIMEOUT=3000;// fallback is 3 secs
	return $q(function(resolve,reject){opts=opts||{};// If there is no transition is found, resolve immediately
	//
	// NOTE: using $mdUtil.nextTick() causes delays/issues
	if(noTransitionFound(opts.cachedTransitionStyles)){TIMEOUT=0;}var timer=$timeout(finished,opts.timeout||TIMEOUT);element.on($mdConstant.CSS.TRANSITIONEND,finished);/**
	         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
	         * NOTE: Make sure this transitionEnd didn't bubble up from a child
	         */function finished(ev){if(ev&&ev.target!==element[0])return;if(ev)$timeout.cancel(timer);element.off($mdConstant.CSS.TRANSITIONEND,finished);// Never reject since ngAnimate may cause timeouts due missed transitionEnd events
	resolve();}/**
	         * Checks whether or not there is a transition.
	         *
	         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
	         * will be used.
	         *
	         * @returns {boolean} True if there is no transition/duration; false otherwise.
	         */function noTransitionFound(styles){styles=styles||window.getComputedStyle(element[0]);return styles.transitionDuration=='0s'||!styles.transition&&!styles.transitionProperty;}});},calculateTransformValues:function calculateTransformValues(element,originator){var origin=originator.element;var bounds=originator.bounds;if(origin||bounds){var originBnds=origin?self.clientRect(origin)||currentBounds():self.copyRect(bounds);var dialogRect=self.copyRect(element[0].getBoundingClientRect());var dialogCenterPt=self.centerPointFor(dialogRect);var originCenterPt=self.centerPointFor(originBnds);return{centerX:originCenterPt.x-dialogCenterPt.x,centerY:originCenterPt.y-dialogCenterPt.y,scaleX:Math.round(100*Math.min(0.5,originBnds.width/dialogRect.width))/100,scaleY:Math.round(100*Math.min(0.5,originBnds.height/dialogRect.height))/100};}return{centerX:0,centerY:0,scaleX:0.5,scaleY:0.5};/**
	       * This is a fallback if the origin information is no longer valid, then the
	       * origin bounds simply becomes the current bounds for the dialogContainer's parent
	       */function currentBounds(){var cntr=element?element.parent():null;var parent=cntr?cntr.parent():null;return parent?self.clientRect(parent):null;}},/**
	     * Calculate the zoom transform from dialog to origin.
	     *
	     * We use this to set the dialog position immediately;
	     * then the md-transition-in actually translates back to
	     * `translate3d(0,0,0) scale(1.0)`...
	     *
	     * NOTE: all values are rounded to the nearest integer
	     */calculateZoomToOrigin:function calculateZoomToOrigin(element,originator){var zoomTemplate="translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";var buildZoom=angular.bind(null,$mdUtil.supplant,zoomTemplate);return buildZoom(self.calculateTransformValues(element,originator));},/**
	     * Calculate the slide transform from panel to origin.
	     * NOTE: all values are rounded to the nearest integer
	     */calculateSlideToOrigin:function calculateSlideToOrigin(element,originator){var slideTemplate="translate3d( {centerX}px, {centerY}px, 0 )";var buildSlide=angular.bind(null,$mdUtil.supplant,slideTemplate);return buildSlide(self.calculateTransformValues(element,originator));},/**
	     * Enhance raw values to represent valid css stylings...
	     */toCss:function toCss(raw){var css={};var lookups='left top right bottom width height x y min-width min-height max-width max-height';angular.forEach(raw,function(value,key){if(angular.isUndefined(value))return;if(lookups.indexOf(key)>=0){css[key]=value+'px';}else{switch(key){case'transition':convertToVendor(key,$mdConstant.CSS.TRANSITION,value);break;case'transform':convertToVendor(key,$mdConstant.CSS.TRANSFORM,value);break;case'transformOrigin':convertToVendor(key,$mdConstant.CSS.TRANSFORM_ORIGIN,value);break;case'font-size':css['font-size']=value;// font sizes aren't always in px
	break;}}});return css;function convertToVendor(key,vendor,value){angular.forEach(vendor.split(' '),function(key){css[key]=value;});}},/**
	     * Convert the translate CSS value to key/value pair(s).
	     */toTransformCss:function toTransformCss(transform,addTransition,transition){var css={};angular.forEach($mdConstant.CSS.TRANSFORM.split(' '),function(key){css[key]=transform;});if(addTransition){transition=transition||"all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";css.transition=transition;}return css;},/**
	     *  Clone the Rect and calculate the height/width if needed
	     */copyRect:function copyRect(source,destination){if(!source)return null;destination=destination||{};angular.forEach('left top right bottom width height'.split(' '),function(key){destination[key]=Math.round(source[key]);});destination.width=destination.width||destination.right-destination.left;destination.height=destination.height||destination.bottom-destination.top;return destination;},/**
	     * Calculate ClientRect of element; return null if hidden or zero size
	     */clientRect:function clientRect(element){var bounds=angular.element(element)[0].getBoundingClientRect();var isPositiveSizeClientRect=function isPositiveSizeClientRect(rect){return rect&&rect.width>0&&rect.height>0;};// If the event origin element has zero size, it has probably been hidden.
	return isPositiveSizeClientRect(bounds)?self.copyRect(bounds):null;},/**
	     *  Calculate 'rounded' center point of Rect
	     */centerPointFor:function centerPointFor(targetRect){return targetRect?{x:Math.round(targetRect.left+targetRect.width/2),y:Math.round(targetRect.top+targetRect.height/2)}:{x:0,y:0};}};}})();(function(){"use strict";if(angular.version.minor>=4){angular.module('material.core.animate',[]);}else{(function(){"use strict";var forEach=angular.forEach;var WEBKIT=angular.isDefined(document.documentElement.style.WebkitAppearance);var TRANSITION_PROP=WEBKIT?'WebkitTransition':'transition';var ANIMATION_PROP=WEBKIT?'WebkitAnimation':'animation';var PREFIX=WEBKIT?'-webkit-':'';var TRANSITION_EVENTS=(WEBKIT?'webkitTransitionEnd ':'')+'transitionend';var ANIMATION_EVENTS=(WEBKIT?'webkitAnimationEnd ':'')+'animationend';var $$ForceReflowFactory=['$document',function($document){return function(){return $document[0].body.clientWidth+1;};}];var $$rAFMutexFactory=['$$rAF',function($$rAF){return function(){var passed=false;$$rAF(function(){passed=true;});return function(fn){passed?fn():$$rAF(fn);};};}];var $$AnimateRunnerFactory=['$q','$$rAFMutex',function($q,$$rAFMutex){var INITIAL_STATE=0;var DONE_PENDING_STATE=1;var DONE_COMPLETE_STATE=2;function AnimateRunner(host){this.setHost(host);this._doneCallbacks=[];this._runInAnimationFrame=$$rAFMutex();this._state=0;}AnimateRunner.prototype={setHost:function setHost(host){this.host=host||{};},done:function done(fn){if(this._state===DONE_COMPLETE_STATE){fn();}else{this._doneCallbacks.push(fn);}},progress:angular.noop,getPromise:function getPromise(){if(!this.promise){var self=this;this.promise=$q(function(resolve,reject){self.done(function(status){status===false?reject():resolve();});});}return this.promise;},then:function then(resolveHandler,rejectHandler){return this.getPromise().then(resolveHandler,rejectHandler);},'catch':function _catch(handler){return this.getPromise()['catch'](handler);},'finally':function _finally(handler){return this.getPromise()['finally'](handler);},pause:function pause(){if(this.host.pause){this.host.pause();}},resume:function resume(){if(this.host.resume){this.host.resume();}},end:function end(){if(this.host.end){this.host.end();}this._resolve(true);},cancel:function cancel(){if(this.host.cancel){this.host.cancel();}this._resolve(false);},complete:function complete(response){var self=this;if(self._state===INITIAL_STATE){self._state=DONE_PENDING_STATE;self._runInAnimationFrame(function(){self._resolve(response);});}},_resolve:function _resolve(response){if(this._state!==DONE_COMPLETE_STATE){forEach(this._doneCallbacks,function(fn){fn(response);});this._doneCallbacks.length=0;this._state=DONE_COMPLETE_STATE;}}};// Polyfill AnimateRunner.all which is used by input animations
	AnimateRunner.all=function(runners,callback){var count=0;var status=true;forEach(runners,function(runner){runner.done(onProgress);});function onProgress(response){status=status&&response;if(++count===runners.length){callback(status);}}};return AnimateRunner;}];angular.module('material.core.animate',[]).factory('$$forceReflow',$$ForceReflowFactory).factory('$$AnimateRunner',$$AnimateRunnerFactory).factory('$$rAFMutex',$$rAFMutexFactory).factory('$animateCss',['$window','$$rAF','$$AnimateRunner','$$forceReflow','$$jqLite','$timeout','$animate',function($window,$$rAF,$$AnimateRunner,$$forceReflow,$$jqLite,$timeout,$animate){function init(element,options){var temporaryStyles=[];var node=getDomNode(element);var areAnimationsAllowed=node&&$animate.enabled();var hasCompleteStyles=false;var hasCompleteClasses=false;if(areAnimationsAllowed){if(options.transitionStyle){temporaryStyles.push([PREFIX+'transition',options.transitionStyle]);}if(options.keyframeStyle){temporaryStyles.push([PREFIX+'animation',options.keyframeStyle]);}if(options.delay){temporaryStyles.push([PREFIX+'transition-delay',options.delay+'s']);}if(options.duration){temporaryStyles.push([PREFIX+'transition-duration',options.duration+'s']);}hasCompleteStyles=options.keyframeStyle||options.to&&(options.duration>0||options.transitionStyle);hasCompleteClasses=!!options.addClass||!!options.removeClass;blockTransition(element,true);}var hasCompleteAnimation=areAnimationsAllowed&&(hasCompleteStyles||hasCompleteClasses);applyAnimationFromStyles(element,options);var animationClosed=false;var events,eventFn;return{close:$window.close,start:function start(){var runner=new $$AnimateRunner();waitUntilQuiet(function(){blockTransition(element,false);if(!hasCompleteAnimation){return close();}forEach(temporaryStyles,function(entry){var key=entry[0];var value=entry[1];node.style[camelCase(key)]=value;});applyClasses(element,options);var timings=computeTimings(element);if(timings.duration===0){return close();}var moreStyles=[];if(options.easing){if(timings.transitionDuration){moreStyles.push([PREFIX+'transition-timing-function',options.easing]);}if(timings.animationDuration){moreStyles.push([PREFIX+'animation-timing-function',options.easing]);}}if(options.delay&&timings.animationDelay){moreStyles.push([PREFIX+'animation-delay',options.delay+'s']);}if(options.duration&&timings.animationDuration){moreStyles.push([PREFIX+'animation-duration',options.duration+'s']);}forEach(moreStyles,function(entry){var key=entry[0];var value=entry[1];node.style[camelCase(key)]=value;temporaryStyles.push(entry);});var maxDelay=timings.delay;var maxDelayTime=maxDelay*1000;var maxDuration=timings.duration;var maxDurationTime=maxDuration*1000;var startTime=Date.now();events=[];if(timings.transitionDuration){events.push(TRANSITION_EVENTS);}if(timings.animationDuration){events.push(ANIMATION_EVENTS);}events=events.join(' ');eventFn=function eventFn(event){event.stopPropagation();var ev=event.originalEvent||event;var timeStamp=ev.timeStamp||Date.now();var elapsedTime=parseFloat(ev.elapsedTime.toFixed(3));if(Math.max(timeStamp-startTime,0)>=maxDelayTime&&elapsedTime>=maxDuration){close();}};element.on(events,eventFn);applyAnimationToStyles(element,options);$timeout(close,maxDelayTime+maxDurationTime*1.5,false);});return runner;function close(){if(animationClosed)return;animationClosed=true;if(events&&eventFn){element.off(events,eventFn);}applyClasses(element,options);applyAnimationStyles(element,options);forEach(temporaryStyles,function(entry){node.style[camelCase(entry[0])]='';});runner.complete(true);return runner;}}};}function applyClasses(element,options){if(options.addClass){$$jqLite.addClass(element,options.addClass);options.addClass=null;}if(options.removeClass){$$jqLite.removeClass(element,options.removeClass);options.removeClass=null;}}function computeTimings(element){var node=getDomNode(element);var cs=$window.getComputedStyle(node);var tdr=parseMaxTime(cs[prop('transitionDuration')]);var adr=parseMaxTime(cs[prop('animationDuration')]);var tdy=parseMaxTime(cs[prop('transitionDelay')]);var ady=parseMaxTime(cs[prop('animationDelay')]);adr*=parseInt(cs[prop('animationIterationCount')],10)||1;var duration=Math.max(adr,tdr);var delay=Math.max(ady,tdy);return{duration:duration,delay:delay,animationDuration:adr,transitionDuration:tdr,animationDelay:ady,transitionDelay:tdy};function prop(key){return WEBKIT?'Webkit'+key.charAt(0).toUpperCase()+key.substr(1):key;}}function parseMaxTime(str){var maxValue=0;var values=(str||"").split(/\s*,\s*/);forEach(values,function(value){// it's always safe to consider only second values and omit `ms` values since
	// getComputedStyle will always handle the conversion for us
	if(value.charAt(value.length-1)=='s'){value=value.substring(0,value.length-1);}value=parseFloat(value)||0;maxValue=maxValue?Math.max(value,maxValue):value;});return maxValue;}var cancelLastRAFRequest;var rafWaitQueue=[];function waitUntilQuiet(callback){if(cancelLastRAFRequest){cancelLastRAFRequest();//cancels the request
	}rafWaitQueue.push(callback);cancelLastRAFRequest=$$rAF(function(){cancelLastRAFRequest=null;// DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	// PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	var pageWidth=$$forceReflow();// we use a for loop to ensure that if the queue is changed
	// during this looping then it will consider new requests
	for(var i=0;i<rafWaitQueue.length;i++){rafWaitQueue[i](pageWidth);}rafWaitQueue.length=0;});}function applyAnimationStyles(element,options){applyAnimationFromStyles(element,options);applyAnimationToStyles(element,options);}function applyAnimationFromStyles(element,options){if(options.from){element.css(options.from);options.from=null;}}function applyAnimationToStyles(element,options){if(options.to){element.css(options.to);options.to=null;}}function getDomNode(element){for(var i=0;i<element.length;i++){if(element[i].nodeType===1)return element[i];}}function blockTransition(element,bool){var node=getDomNode(element);var key=camelCase(PREFIX+'transition-delay');node.style[key]=bool?'-9999s':'';}return init;}]);/**
	   * Older browsers [FF31] expect camelCase
	   * property keys.
	   * e.g.
	   *  animation-duration --> animationDuration
	   */function camelCase(str){return str.replace(/-[a-z]/g,function(str){return str.charAt(1).toUpperCase();});}})();}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.autocomplete
	 *//*
	 * @see js folder for autocomplete implementation
	 */angular.module('material.components.autocomplete',['material.core','material.components.icon','material.components.virtualRepeat']);})();(function(){"use strict";/*
	 * @ngdoc module
	 * @name material.components.backdrop
	 * @description Backdrop
	 *//**
	 * @ngdoc directive
	 * @name mdBackdrop
	 * @module material.components.backdrop
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
	 * Apply class `opaque` to make the backdrop use the theme backdrop color.
	 *
	 */angular.module('material.components.backdrop',['material.core']).directive('mdBackdrop',["$mdTheming","$mdUtil","$animate","$rootElement","$window","$log","$$rAF","$document",function BackdropDirective($mdTheming,$mdUtil,$animate,$rootElement,$window,$log,$$rAF,$document){var ERROR_CSS_POSITION='<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';return{restrict:'E',link:postLink};function postLink(scope,element,attrs){// backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
	if($animate.pin)$animate.pin(element,$rootElement);var bodyStyles;$$rAF(function(){// If body scrolling has been disabled using mdUtil.disableBodyScroll(),
	// adjust the 'backdrop' height to account for the fixed 'body' top offset.
	// Note that this can be pretty expensive and is better done inside the $$rAF.
	bodyStyles=$window.getComputedStyle($document[0].body);if(bodyStyles.position==='fixed'){var resizeHandler=$mdUtil.debounce(function(){bodyStyles=$window.getComputedStyle($document[0].body);resize();},60,null,false);resize();angular.element($window).on('resize',resizeHandler);scope.$on('$destroy',function(){angular.element($window).off('resize',resizeHandler);});}// Often $animate.enter() is used to append the backDrop element
	// so let's wait until $animate is done...
	var parent=element.parent();if(parent.length){if(parent[0].nodeName==='BODY'){element.css('position','fixed');}var styles=$window.getComputedStyle(parent[0]);if(styles.position==='static'){// backdrop uses position:absolute and will not work properly with parent position:static (default)
	$log.warn(ERROR_CSS_POSITION);}// Only inherit the parent if the backdrop has a parent.
	$mdTheming.inherit(element,parent);}});function resize(){var viewportHeight=parseInt(bodyStyles.height,10)+Math.abs(parseInt(bodyStyles.top,10));element.css('height',viewportHeight+'px');}}}]);})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.bottomSheet
	 * @description
	 * BottomSheet
	 */MdBottomSheetDirective.$inject=["$mdBottomSheet"];MdBottomSheetProvider.$inject=["$$interimElementProvider"];angular.module('material.components.bottomSheet',['material.core','material.components.backdrop']).directive('mdBottomSheet',MdBottomSheetDirective).provider('$mdBottomSheet',MdBottomSheetProvider);/* @ngInject */function MdBottomSheetDirective($mdBottomSheet){return{restrict:'E',link:function postLink(scope,element){element.addClass('_md');// private md component indicator for styling
	// When navigation force destroys an interimElement, then
	// listen and $destroy() that interim instance...
	scope.$on('$destroy',function(){$mdBottomSheet.destroy();});}};}/**
	 * @ngdoc service
	 * @name $mdBottomSheet
	 * @module material.components.bottomSheet
	 *
	 * @description
	 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
	 *
	 * ## Restrictions
	 *
	 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
	 * - Add the `md-grid` class to the bottom sheet for a grid layout.
	 * - Add the `md-list` class to the bottom sheet for a list layout.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openBottomSheet()">
	 *     Open a Bottom Sheet!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdBottomSheet) {
	 *   $scope.openBottomSheet = function() {
	 *     $mdBottomSheet.show({
	 *       template: '<md-bottom-sheet>' +
	 *       'Hello! <md-button ng-click="closeBottomSheet()">Close</md-button>' +
	 *       '</md-bottom-sheet>'
	 *     })
	 *
	 *     // Fires when the hide() method is used
	 *     .then(function() {
	 *       console.log('You clicked the button to close the bottom sheet!');
	 *     })
	 *
	 *     // Fires when the cancel() method is used
	 *     .catch(function() {
	 *       console.log('You hit escape or clicked the backdrop to close.');
	 *     });
	 *   };
	 *
	 *   $scope.closeBottomSheet = function($scope, $mdBottomSheet) {
	 *     $mdBottomSheet.hide();
	 *   }
	 *
	 * });
	 * </hljs>
	 *//**
	 * @ngdoc method
	 * @name $mdBottomSheet#show
	 *
	 * @description
	 * Show a bottom sheet with the specified options.
	 *
	 * <em><b>Note:</b> You should <b>always</b> provide a `.catch()` method in case the user hits the
	 * `esc` key or clicks the background to close. In this case, the `cancel()` method will
	 * automatically be called on the bottom sheet which will `reject()` the promise. See the @usage
	 * section above for an example.
	 *
	 * Newer versions of Angular will throw a `Possibly unhandled rejection` exception if you forget
	 * this.</em>
	 *
	 * @param {object} options An options object, with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *   be used as the content of the bottom sheet. Restrictions: the template must
	 *   have an outer `md-bottom-sheet` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *   template string.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	 *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
	 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	 *   be used as names of values to inject into the controller. For example,
	 *   `locals: {three: 3}` would inject `three` into the controller with the value
	 *   of 3.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
	 *     close it. Default true.
	 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the controller instance.
	 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
	 *     Default true.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	 *   and the bottom sheet will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
	 *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
	 *   e.g. angular.element(document.getElementById('content')) or "#content"
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
	 *     Default true.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
	 * rejected with `$mdBottomSheet.cancel()`.
	 *//**
	 * @ngdoc method
	 * @name $mdBottomSheet#hide
	 *
	 * @description
	 * Hide the existing bottom sheet and resolve the promise returned from
	 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottomsheet (if
	 * any).
	 *
	 * <em><b>Note:</b> Use a `.then()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdBottomSheet#cancel
	 *
	 * @description
	 * Hide the existing bottom sheet and reject the promise returned from
	 * `$mdBottomSheet.show()`.
	 *
	 * <em><b>Note:</b> Use a `.catch()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 */function MdBottomSheetProvider($$interimElementProvider){// how fast we need to flick down to close the sheet, pixels/ms
	bottomSheetDefaults.$inject=["$animate","$mdConstant","$mdUtil","$mdTheming","$mdBottomSheet","$rootElement","$mdGesture","$log"];var CLOSING_VELOCITY=0.5;var PADDING=80;// same as css
	return $$interimElementProvider('$mdBottomSheet').setDefaults({methods:['disableParentScroll','escapeToClose','clickOutsideToClose'],options:bottomSheetDefaults});/* @ngInject */function bottomSheetDefaults($animate,$mdConstant,$mdUtil,$mdTheming,$mdBottomSheet,$rootElement,$mdGesture,$log){var backdrop;return{themable:true,onShow:onShow,onRemove:onRemove,disableBackdrop:false,escapeToClose:true,clickOutsideToClose:true,disableParentScroll:true};function onShow(scope,element,options,controller){element=$mdUtil.extractElementByName(element,'md-bottom-sheet');// prevent tab focus or click focus on the bottom-sheet container
	element.attr('tabindex',"-1");// Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
	// This is a very common problem, so we have to notify the developer about this.
	if(element.hasClass('ng-cloak')){var message='$mdBottomSheet: using `<md-bottom-sheet ng-cloak >` will affect the bottom-sheet opening animations.';$log.warn(message,element[0]);}if(!options.disableBackdrop){// Add a backdrop that will close on click
	backdrop=$mdUtil.createBackdrop(scope,"md-bottom-sheet-backdrop md-opaque");// Prevent mouse focus on backdrop; ONLY programatic focus allowed.
	// This allows clicks on backdrop to propogate to the $rootElement and
	// ESC key events to be detected properly.
	backdrop[0].tabIndex=-1;if(options.clickOutsideToClose){backdrop.on('click',function(){$mdUtil.nextTick($mdBottomSheet.cancel,true);});}$mdTheming.inherit(backdrop,options.parent);$animate.enter(backdrop,options.parent,null);}var bottomSheet=new BottomSheet(element,options.parent);options.bottomSheet=bottomSheet;$mdTheming.inherit(bottomSheet.element,options.parent);if(options.disableParentScroll){options.restoreScroll=$mdUtil.disableScrollAround(bottomSheet.element,options.parent);}return $animate.enter(bottomSheet.element,options.parent,backdrop).then(function(){var focusable=$mdUtil.findFocusTarget(element)||angular.element(element[0].querySelector('button')||element[0].querySelector('a')||element[0].querySelector($mdUtil.prefixer('ng-click',true)))||backdrop;if(options.escapeToClose){options.rootElementKeyupCallback=function(e){if(e.keyCode===$mdConstant.KEY_CODE.ESCAPE){$mdUtil.nextTick($mdBottomSheet.cancel,true);}};$rootElement.on('keyup',options.rootElementKeyupCallback);focusable&&focusable.focus();}});}function onRemove(scope,element,options){var bottomSheet=options.bottomSheet;if(!options.disableBackdrop)$animate.leave(backdrop);return $animate.leave(bottomSheet.element).then(function(){if(options.disableParentScroll){options.restoreScroll();delete options.restoreScroll;}bottomSheet.cleanup();});}/**
	     * BottomSheet class to apply bottom-sheet behavior to an element
	     */function BottomSheet(element,parent){var deregister=$mdGesture.register(parent,'drag',{horizontal:false});parent.on('$md.dragstart',onDragStart).on('$md.drag',onDrag).on('$md.dragend',onDragEnd);return{element:element,cleanup:function cleanup(){deregister();parent.off('$md.dragstart',onDragStart);parent.off('$md.drag',onDrag);parent.off('$md.dragend',onDragEnd);}};function onDragStart(ev){// Disable transitions on transform so that it feels fast
	element.css($mdConstant.CSS.TRANSITION_DURATION,'0ms');}function onDrag(ev){var transform=ev.pointer.distanceY;if(transform<5){// Slow down drag when trying to drag up, and stop after PADDING
	transform=Math.max(-PADDING,transform/2);}element.css($mdConstant.CSS.TRANSFORM,'translate3d(0,'+(PADDING+transform)+'px,0)');}function onDragEnd(ev){if(ev.pointer.distanceY>0&&(ev.pointer.distanceY>20||Math.abs(ev.pointer.velocityY)>CLOSING_VELOCITY)){var distanceRemaining=element.prop('offsetHeight')-ev.pointer.distanceY;var transitionDuration=Math.min(distanceRemaining/ev.pointer.velocityY*0.75,500);element.css($mdConstant.CSS.TRANSITION_DURATION,transitionDuration+'ms');$mdUtil.nextTick($mdBottomSheet.cancel,true);}else{element.css($mdConstant.CSS.TRANSITION_DURATION,'');element.css($mdConstant.CSS.TRANSFORM,'');}}}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.button
	 * @description
	 *
	 * Button
	 */MdButtonDirective.$inject=["$mdButtonInkRipple","$mdTheming","$mdAria","$mdInteraction"];MdAnchorDirective.$inject=["$mdTheming"];angular.module('material.components.button',['material.core']).directive('mdButton',MdButtonDirective).directive('a',MdAnchorDirective);/**
	 * @private
	 * @restrict E
	 *
	 * @description
	 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 *  <md-content md-theme="myTheme">
	 *    <a href="#chapter1" class="md-accent"></a>
	 *  </md-content>
	 * </hljs>
	 */function MdAnchorDirective($mdTheming){return{restrict:'E',link:function postLink(scope,element){// Make sure to inherit theme so stand-alone anchors
	// support theme colors for md-primary, md-accent, etc.
	$mdTheming(element);}};}/**
	 * @ngdoc directive
	 * @name mdButton
	 * @module material.components.button
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-button>` is a button directive with optional ink ripples (default enabled).
	 *
	 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
	 * will become a `<button>` element. As per the
	 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
	 * the FAB button background is filled with the accent color [by default]. The primary color palette
	 * may be used with the `md-primary` class.
	 *
	 * Developers can also change the color palette of the button, by using the following classes
	 * - `md-primary`
	 * - `md-accent`
	 * - `md-warn`
	 *
	 * See for example
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-primary">Primary Button</md-button>
	 * </hljs>
	 *
	 * Button can be also raised, which means that they will use the current color palette to fill the button.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
	 * </hljs>
	 *
	 * It is also possible to disable the focus effect on the button, by using the following markup.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-no-focus">No Focus Style</md-button>
	 * </hljs>
	 *
	 * @param {boolean=} md-no-ink If present, disable ripple ink effects.
	 * @param {expression=} ng-disabled En/Disable based on the expression
	 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`
	 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
	 * If no default text is found, a warning will be logged.
	 *
	 * @usage
	 *
	 * Regular buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button> Flat Button </md-button>
	 *  <md-button href="http://google.com"> Flat link </md-button>
	 *  <md-button class="md-raised"> Raised Button </md-button>
	 *  <md-button ng-disabled="true"> Disabled Button </md-button>
	 *  <md-button>
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *    Register Now
	 *  </md-button>
	 * </hljs>
	 *
	 * FAB buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button class="md-fab" aria-label="FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- mini-FAB -->
	 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- Button with SVG Icon -->
	 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
	 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
	 *  </md-button>
	 * </hljs>
	 */function MdButtonDirective($mdButtonInkRipple,$mdTheming,$mdAria,$mdInteraction){return{restrict:'EA',replace:true,transclude:true,template:getTemplate,link:postLink};function isAnchor(attr){return angular.isDefined(attr.href)||angular.isDefined(attr.ngHref)||angular.isDefined(attr.ngLink)||angular.isDefined(attr.uiSref);}function getTemplate(element,attr){if(isAnchor(attr)){return'<a class="md-button" ng-transclude></a>';}else{//If buttons don't have type="button", they will submit forms automatically.
	var btnType=typeof attr.type==='undefined'?'button':attr.type;return'<button class="md-button" type="'+btnType+'" ng-transclude></button>';}}function postLink(scope,element,attr){$mdTheming(element);$mdButtonInkRipple.attach(scope,element);// Use async expect to support possible bindings in the button label
	$mdAria.expectWithoutText(element,'aria-label');// For anchor elements, we have to set tabindex manually when the
	// element is disabled
	if(isAnchor(attr)&&angular.isDefined(attr.ngDisabled)){scope.$watch(attr.ngDisabled,function(isDisabled){element.attr('tabindex',isDisabled?-1:0);});}// disabling click event when disabled is true
	element.on('click',function(e){if(attr.disabled===true){e.preventDefault();e.stopImmediatePropagation();}});if(!element.hasClass('md-no-focus')){element.on('focus',function(){// Only show the focus effect when being focused through keyboard interaction or programmatically
	if(!$mdInteraction.isUserInvoked()||$mdInteraction.getLastInteractionType()==='keyboard'){element.addClass('md-focused');}});element.on('blur',function(){element.removeClass('md-focused');});}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.card
	 *
	 * @description
	 * Card components.
	 */mdCardDirective.$inject=["$mdTheming"];angular.module('material.components.card',['material.core']).directive('mdCard',mdCardDirective);/**
	 * @ngdoc directive
	 * @name mdCard
	 * @module material.components.card
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-card>` directive is a container element used within `<md-content>` containers.
	 *
	 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
	 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
	 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
	 * optionally included to put content flush against the bottom edge of the card.
	 *
	 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
	 * You can then position buttons using layout attributes.
	 *
	 * Card is built with:
	 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
	 *  - `<md-card-avatar>` - Card avatar
	 *    - `md-user-avatar` - Class for user image
	 *    - `<md-icon>`
	 *  - `<md-card-header-text>` - Contains elements for the card description
	 *    - `md-title` - Class for the card title
	 *    - `md-subhead` - Class for the card sub header
	 * * `<img>` - Image for the card
	 * * `<md-card-title>` - Card content title
	 *  - `<md-card-title-text>`
	 *    - `md-headline` - Class for the card content title
	 *    - `md-subhead` - Class for the card content sub header
	 *  - `<md-card-title-media>` - Squared image within the title
	 *    - `md-media-sm` - Class for small image
	 *    - `md-media-md` - Class for medium image
	 *    - `md-media-lg` - Class for large image
	 *    - `md-media-xl` - Class for extra large image
	 * * `<md-card-content>` - Card content
	 * * `<md-card-actions>` - Card actions
	 *  - `<md-card-icon-actions>` - Icon actions
	 *
	 * Cards have constant width and variable heights; where the maximum height is limited to what can
	 * fit within a single view on a platform, but it can temporarily expand as needed.
	 *
	 * @usage
	 * ### Card with optional footer
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-footer>
	 *    Card footer
	 *  </md-card-footer>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with actions
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-actions layout="row" layout-align="end center">
	 *    <md-button>Action 1</md-button>
	 *    <md-button>Action 2</md-button>
	 *  </md-card-actions>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with header, image, title actions and content
	 * <hljs lang="html">
	 * <md-card>
	 *   <md-card-header>
	 *     <md-card-avatar>
	 *       <img class="md-user-avatar" src="avatar.png"/>
	 *     </md-card-avatar>
	 *     <md-card-header-text>
	 *       <span class="md-title">Title</span>
	 *       <span class="md-subhead">Sub header</span>
	 *     </md-card-header-text>
	 *   </md-card-header>
	 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
	 *   <md-card-title>
	 *     <md-card-title-text>
	 *       <span class="md-headline">Card headline</span>
	 *       <span class="md-subhead">Card subheader</span>
	 *     </md-card-title-text>
	 *   </md-card-title>
	 *   <md-card-actions layout="row" layout-align="start center">
	 *     <md-button>Action 1</md-button>
	 *     <md-button>Action 2</md-button>
	 *     <md-card-icon-actions>
	 *       <md-button class="md-icon-button" aria-label="icon">
	 *         <md-icon md-svg-icon="icon"></md-icon>
	 *       </md-button>
	 *     </md-card-icon-actions>
	 *   </md-card-actions>
	 *   <md-card-content>
	 *     <p>
	 *      Card content
	 *     </p>
	 *   </md-card-content>
	 * </md-card>
	 * </hljs>
	 */function mdCardDirective($mdTheming){return{restrict:'E',link:function link($scope,$element,attr){$element.addClass('_md');// private md component indicator for styling
	$mdTheming($element);}};}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.checkbox
	 * @description Checkbox module!
	 */MdCheckboxDirective.$inject=["inputDirective","$mdAria","$mdConstant","$mdTheming","$mdUtil","$mdInteraction"];angular.module('material.components.checkbox',['material.core']).directive('mdCheckbox',MdCheckboxDirective);/**
	 * @ngdoc directive
	 * @name mdCheckbox
	 * @module material.components.checkbox
	 * @restrict E
	 *
	 * @description
	 * The checkbox directive is used like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-color-schemes)
	 * the checkbox is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects
	 * @param {string=} aria-label Adds label to checkbox for accessibility.
	 *     Defaults to checkbox's text. If no default text is found, a warning will be logged.
	 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as 'indeterminate'.
	 *     If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state.
	 *     If falsy expression is passed in it just looks like a normal unchecked checkbox.
	 *     The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time.
	 *     Adding the 'md-indeterminate' attribute overrides any checked/unchecked rendering logic.
	 *     When using the 'md-indeterminate' attribute use 'ng-checked' to define rendering logic instead of using 'ng-model'.
	 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css class is added to the checkbox and it
	 *     will appear checked.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
	 *   Finished ?
	 * </md-checkbox>
	 *
	 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-checkbox>
	 *
	 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-checkbox>
	 *
	 * </hljs>
	 *
	 */function MdCheckboxDirective(inputDirective,$mdAria,$mdConstant,$mdTheming,$mdUtil,$mdInteraction){inputDirective=inputDirective[0];return{restrict:'E',transclude:true,require:['^?mdInputContainer','?ngModel','?^form'],priority:$mdConstant.BEFORE_NG_ARIA,template:'<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>'+'<div class="md-icon"></div>'+'</div>'+'<div ng-transclude class="md-label"></div>',compile:compile};// **********************************************************
	// Private Methods
	// **********************************************************
	function compile(tElement,tAttrs){tAttrs.$set('tabindex',tAttrs.tabindex||'0');tAttrs.$set('type','checkbox');tAttrs.$set('role',tAttrs.type);return{pre:function pre(scope,element){// Attach a click handler during preLink, in order to immediately stop propagation
	// (especially for ng-click) when the checkbox is disabled.
	element.on('click',function(e){if(this.hasAttribute('disabled')){e.stopImmediatePropagation();}});},post:postLink};function postLink(scope,element,attr,ctrls){var isIndeterminate;var containerCtrl=ctrls[0];var ngModelCtrl=ctrls[1]||$mdUtil.fakeNgModel();var formCtrl=ctrls[2];if(containerCtrl){var isErrorGetter=containerCtrl.isErrorGetter||function(){return ngModelCtrl.$invalid&&(ngModelCtrl.$touched||formCtrl&&formCtrl.$submitted);};containerCtrl.input=element;scope.$watch(isErrorGetter,containerCtrl.setInvalid);}$mdTheming(element);// Redirect focus events to the root element, because IE11 is always focusing the container element instead
	// of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
	element.children().on('focus',function(){element.focus();});if($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)){setIndeterminateState();scope.$watch(attr.mdIndeterminate,setIndeterminateState);}if(attr.ngChecked){scope.$watch(scope.$eval.bind(scope,attr.ngChecked),function(value){ngModelCtrl.$setViewValue(value);ngModelCtrl.$render();});}$$watchExpr('ngDisabled','tabindex',{true:'-1',false:attr.tabindex});$mdAria.expectWithText(element,'aria-label');// Reuse the original input[type=checkbox] directive from AngularJS core.
	// This is a bit hacky as we need our own event listener and own render
	// function.
	inputDirective.link.pre(scope,{on:angular.noop,0:{}},attr,[ngModelCtrl]);element.on('click',listener).on('keypress',keypressHandler).on('focus',function(){if($mdInteraction.getLastInteractionType()==='keyboard'){element.addClass('md-focused');}}).on('blur',function(){element.removeClass('md-focused');});ngModelCtrl.$render=render;function $$watchExpr(expr,htmlAttr,valueOpts){if(attr[expr]){scope.$watch(attr[expr],function(val){if(valueOpts[val]){element.attr(htmlAttr,valueOpts[val]);}});}}function keypressHandler(ev){var keyCode=ev.which||ev.keyCode;if(keyCode===$mdConstant.KEY_CODE.SPACE||keyCode===$mdConstant.KEY_CODE.ENTER){ev.preventDefault();element.addClass('md-focused');listener(ev);}}function listener(ev){// skipToggle boolean is used by the switch directive to prevent the click event
	// when releasing the drag. There will be always a click if releasing the drag over the checkbox
	if(element[0].hasAttribute('disabled')||scope.skipToggle){return;}scope.$apply(function(){// Toggle the checkbox value...
	var viewValue=attr.ngChecked&&attr.ngClick?attr.checked:!ngModelCtrl.$viewValue;ngModelCtrl.$setViewValue(viewValue,ev&&ev.type);ngModelCtrl.$render();});}function render(){// Cast the $viewValue to a boolean since it could be undefined
	element.toggleClass('md-checked',!!ngModelCtrl.$viewValue&&!isIndeterminate);}function setIndeterminateState(newValue){isIndeterminate=newValue!==false;if(isIndeterminate){element.attr('aria-checked','mixed');}element.toggleClass('md-indeterminate',isIndeterminate);}}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.chips
	 *//*
	 * @see js folder for chips implementation
	 */angular.module('material.components.chips',['material.core','material.components.autocomplete']);})();(function(){"use strict";(function(){"use strict";/**
	   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
	   *  or one that should be observed and dynamically interpolated.
	   */MdColorsDirective.$inject=["$mdColors","$mdUtil","$log","$parse"];MdColorsService.$inject=["$mdTheming","$mdUtil","$log"];var STATIC_COLOR_EXPRESSION=/^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?('|")[a-zA-Z0-9-.]*('|"))+\s*}$/;var colorPalettes=null;/**
	   * @ngdoc module
	   * @name material.components.colors
	   *
	   * @description
	   * Define $mdColors service and a `md-colors=""` attribute directive
	   */angular.module('material.components.colors',['material.core']).directive('mdColors',MdColorsDirective).service('$mdColors',MdColorsService);/**
	   * @ngdoc service
	   * @name $mdColors
	   * @module material.components.colors
	   *
	   * @description
	   * With only defining themes, one couldn't get non AngularJS Material elements colored with Material colors,
	   * `$mdColors` service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply
	   * those values to element as CSS property values.
	   *
	   *  @usage
	   *  <hljs lang="js">
	   *    angular.controller('myCtrl', function ($mdColors) {
	   *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	   *      ...
	   *    });
	   *  </hljs>
	   *
	   */function MdColorsService($mdTheming,$mdUtil,$log){colorPalettes=colorPalettes||Object.keys($mdTheming.PALETTES);// Publish service instance
	return{applyThemeColors:applyThemeColors,getThemeColor:getThemeColor,hasTheme:hasTheme};// ********************************************
	// Internal Methods
	// ********************************************
	/**
	     * @ngdoc method
	     * @name $mdColors#applyThemeColors
	     *
	     * @description
	     * Gets a color json object, keys are css properties and values are string of the wanted color
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @param {DOMElement} element the element to apply the styles on.
	     * @param {object} colorExpression json object, keys are css properties and values are string of the wanted color,
	     * for example: `{color: 'red-A200-0.3'}`.
	     *
	     * @usage
	     * <hljs lang="js">
	     *   app.directive('myDirective', function($mdColors) {
	     *     return {
	     *       ...
	     *       link: function (scope, elem) {
	     *         $mdColors.applyThemeColors(elem, {color: 'red'});
	     *       }
	     *    }
	     *   });
	     * </hljs>
	     */function applyThemeColors(element,colorExpression){try{if(colorExpression){// Assign the calculate RGBA color values directly as inline CSS
	element.css(interpolateColors(colorExpression));}}catch(e){$log.error(e.message);}}/**
	     * @ngdoc method
	     * @name $mdColors#getThemeColor
	     *
	     * @description
	     * Get parsed color from expression
	     *
	     * @param {string} expression string of a color expression (for instance `'red-700-0.8'`)
	     *
	     * @returns {string} a css color expression (for instance `rgba(211, 47, 47, 0.8)`)
	     *
	     * @usage
	     *  <hljs lang="js">
	     *    angular.controller('myCtrl', function ($mdColors) {
	     *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	     *      ...
	     *    });
	     *  </hljs>
	     */function getThemeColor(expression){var color=extractColorOptions(expression);return parseColor(color);}/**
	     * Return the parsed color
	     * @param color hashmap of color definitions
	     * @param contrast whether use contrast color for foreground
	     * @returns rgba color string
	     */function parseColor(color,contrast){contrast=contrast||false;var rgbValues=$mdTheming.PALETTES[color.palette][color.hue];rgbValues=contrast?rgbValues.contrast:rgbValues.value;return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',[rgbValues[0],rgbValues[1],rgbValues[2],rgbValues[3]||color.opacity]);}/**
	     * Convert the color expression into an object with scope-interpolated values
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @results Hashmap of CSS properties with associated `rgba( )` string vales
	     *
	     *
	     */function interpolateColors(themeColors){var rgbColors={};var hasColorProperty=themeColors.hasOwnProperty('color');angular.forEach(themeColors,function(value,key){var color=extractColorOptions(value);var hasBackground=key.indexOf('background')>-1;rgbColors[key]=parseColor(color);if(hasBackground&&!hasColorProperty){rgbColors.color=parseColor(color,true);}});return rgbColors;}/**
	     * Check if expression has defined theme
	     * e.g.
	     * 'myTheme-primary' => true
	     * 'red-800' => false
	     */function hasTheme(expression){return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);}/**
	     * For the evaluated expression, extract the color parts into a hash map
	     */function extractColorOptions(expression){var parts=expression.split('-');var hasTheme=angular.isDefined($mdTheming.THEMES[parts[0]]);var theme=hasTheme?parts.splice(0,1)[0]:$mdTheming.defaultTheme();return{theme:theme,palette:extractPalette(parts,theme),hue:extractHue(parts,theme),opacity:parts[2]||1};}/**
	     * Calculate the theme palette name
	     */function extractPalette(parts,theme){// If the next section is one of the palettes we assume it's a two word palette
	// Two word palette can be also written in camelCase, forming camelCase to dash-case
	var isTwoWord=parts.length>1&&colorPalettes.indexOf(parts[1])!==-1;var palette=parts[0].replace(/([a-z])([A-Z])/g,'$1-$2').toLowerCase();if(isTwoWord)palette=parts[0]+'-'+parts.splice(1,1);if(colorPalettes.indexOf(palette)===-1){// If the palette is not in the palette list it's one of primary/accent/warn/background
	var scheme=$mdTheming.THEMES[theme].colors[palette];if(!scheme){throw new Error($mdUtil.supplant('mdColors: couldn\'t find \'{palette}\' in the palettes.',{palette:palette}));}palette=scheme.name;}return palette;}function extractHue(parts,theme){var themeColors=$mdTheming.THEMES[theme].colors;if(parts[1]==='hue'){var hueNumber=parseInt(parts.splice(2,1)[0],10);if(hueNumber<1||hueNumber>3){throw new Error($mdUtil.supplant('mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'',{hueNumber:hueNumber}));}parts[1]='hue-'+hueNumber;if(!(parts[0]in themeColors)){throw new Error($mdUtil.supplant('mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'',{availableThemes:Object.keys(themeColors).join(', '),usedTheme:parts[0]}));}return themeColors[parts[0]].hues[parts[1]];}return parts[1]||themeColors[parts[0]in themeColors?parts[0]:'primary'].hues['default'];}}/**
	   * @ngdoc directive
	   * @name mdColors
	   * @module material.components.colors
	   *
	   * @restrict A
	   *
	   * @description
	   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
	   *
	   *   The format will be similar to our color defining in the scss files:
	   *
	   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
	   *   - [theme]    - default value is the default theme
	   *   - [palette]  - can be either palette name or primary/accent/warn/background
	   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
	   *   - [opacity]  - default is 1
	   *
	   *   > `?` indicates optional parameter
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
	   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
	   *       <span>Color demo</span>
	   *     </div>
	   *   </div>
	   * </hljs>
	   *
	   * `mdColors` directive will automatically watch for changes in the expression if it recognizes an interpolation
	   * expression or a function. For performance options, you can use `::` prefix to the `md-colors` expression
	   * to indicate a one-time data binding.
	   * <hljs lang="html">
	   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
	   *   </md-card>
	   * </hljs>
	   *
	   */function MdColorsDirective($mdColors,$mdUtil,$log,$parse){return{restrict:'A',require:['^?mdTheme'],compile:function compile(tElem,tAttrs){var shouldWatch=shouldColorsWatch();return function(scope,element,attrs,ctrl){var mdThemeController=ctrl[0];var lastColors={};var parseColors=function parseColors(theme){if(typeof theme!=='string'){theme='';}if(!attrs.mdColors){attrs.mdColors='{}';}/**
	             * Json.parse() does not work because the keys are not quoted;
	             * use $parse to convert to a hash map
	             */var colors=$parse(attrs.mdColors)(scope);/**
	             * If mdTheme is defined up the DOM tree
	             * we add mdTheme theme to colors who doesn't specified a theme
	             *
	             * # example
	             * <hljs lang="html">
	             *   <div md-theme="myTheme">
	             *     <div md-colors="{background: 'primary-600'}">
	             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
	             *     </div>
	             *   </div>
	             * </hljs>
	             *
	             * 'primary-600' will be 'myTheme-primary-600',
	             * but 'mySecondTheme-accent-200' will stay the same cause it has a theme prefix
	             */if(mdThemeController){Object.keys(colors).forEach(function(prop){var color=colors[prop];if(!$mdColors.hasTheme(color)){colors[prop]=(theme||mdThemeController.$mdTheme)+'-'+color;}});}cleanElement(colors);return colors;};var cleanElement=function cleanElement(colors){if(!angular.equals(colors,lastColors)){var keys=Object.keys(lastColors);if(lastColors.background&&!keys.color){keys.push('color');}keys.forEach(function(key){element.css(key,'');});}lastColors=colors;};/**
	           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever a theme changes
	           */var unregisterChanges=angular.noop;if(mdThemeController){unregisterChanges=mdThemeController.registerChanges(function(theme){$mdColors.applyThemeColors(element,parseColors(theme));});}scope.$on('$destroy',function(){unregisterChanges();});try{if(shouldWatch){scope.$watch(parseColors,angular.bind(this,$mdColors.applyThemeColors,element),true);}else{$mdColors.applyThemeColors(element,parseColors());}}catch(e){$log.error(e.message);}};function shouldColorsWatch(){// Simulate 1x binding and mark mdColorsWatch == false
	var rawColorExpression=tAttrs.mdColors;var bindOnce=rawColorExpression.indexOf('::')>-1;var isStatic=bindOnce?true:STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);// Remove it for the postLink...
	tAttrs.mdColors=rawColorExpression.replace('::','');var hasWatchAttr=angular.isDefined(tAttrs.mdColorsWatch);return bindOnce||isStatic?false:hasWatchAttr?$mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch):true;}}};}})();})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.content
	 *
	 * @description
	 * Scrollable content
	 */mdContentDirective.$inject=["$mdTheming"];angular.module('material.components.content',['material.core']).directive('mdContent',mdContentDirective);/**
	 * @ngdoc directive
	 * @name mdContent
	 * @module material.components.content
	 *
	 * @restrict E
	 *
	 * @description
	 *
	 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
	 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
	 *
	 * In general, `<md-content>` components are not designed to be nested inside one another. If
	 * possible, it is better to make them siblings. This often results in a better user experience as
	 * having nested scrollbars may confuse the user.
	 *
	 * ## Troubleshooting
	 *
	 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
	 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
	 * SVG icons and some other components.
	 *
	 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
	 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
	 * inside (which eliminates the flicker on iOS devices).
	 *
	 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
	 * related to the z-index of elements. Please use with caution and only on the elements needed._
	 *
	 * @usage
	 *
	 * Add the `[layout-padding]` attribute to make the content padded.
	 *
	 * <hljs lang="html">
	 *  <md-content layout-padding>
	 *      Lorem ipsum dolor sit amet, ne quod novum mei.
	 *  </md-content>
	 * </hljs>
	 */function mdContentDirective($mdTheming){return{restrict:'E',controller:['$scope','$element',ContentController],link:function link(scope,element){element.addClass('_md');// private md component indicator for styling
	$mdTheming(element);scope.$broadcast('$mdContentLoaded',element);iosScrollFix(element[0]);}};function ContentController($scope,$element){this.$scope=$scope;this.$element=$element;}}function iosScrollFix(node){// IOS FIX:
	// If we scroll where there is no more room for the webview to scroll,
	// by default the webview itself will scroll up and down, this looks really
	// bad.  So if we are scrolling to the very top or bottom, add/subtract one
	angular.element(node).on('$md.pressdown',function(ev){// Only touch events
	if(ev.pointer.type!=='t')return;// Don't let a child content's touchstart ruin it for us.
	if(ev.$materialScrollFixed)return;ev.$materialScrollFixed=true;if(node.scrollTop===0){node.scrollTop=1;}else if(node.scrollHeight===node.scrollTop+node.offsetHeight){node.scrollTop-=1;}});}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.datepicker
	 * @description Module for the datepicker component.
	 */angular.module('material.components.datepicker',['material.core','material.components.icon','material.components.virtualRepeat']);})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.dialog
	 */MdDialogDirective.$inject=["$$rAF","$mdTheming","$mdDialog"];MdDialogProvider.$inject=["$$interimElementProvider"];angular.module('material.components.dialog',['material.core','material.components.backdrop']).directive('mdDialog',MdDialogDirective).provider('$mdDialog',MdDialogProvider);/**
	 * @ngdoc directive
	 * @name mdDialog
	 * @module material.components.dialog
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-dialog>` - The dialog's template must be inside this element.
	 *
	 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 * an `<md-dialog-actions>` element for the dialog's actions.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * ## Notes
	 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
	 * prefixed with `dialogContent_`.
	 *
	 * @usage
	 * ### Dialog template
	 * <hljs lang="html">
	 * <md-dialog aria-label="List dialog">
	 *   <md-dialog-content>
	 *     <md-list>
	 *       <md-list-item ng-repeat="item in items">
	 *         <p>Number {{item}}</p>
	 *       </md-list-item>
	 *     </md-list>
	 *   </md-dialog-content>
	 *   <md-dialog-actions>
	 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
	 *   </md-dialog-actions>
	 * </md-dialog>
	 * </hljs>
	 */function MdDialogDirective($$rAF,$mdTheming,$mdDialog){return{restrict:'E',link:function link(scope,element){element.addClass('_md');// private md component indicator for styling
	$mdTheming(element);$$rAF(function(){var images;var content=element[0].querySelector('md-dialog-content');if(content){images=content.getElementsByTagName('img');addOverflowClass();//-- delayed image loading may impact scroll height, check after images are loaded
	angular.element(images).on('load',addOverflowClass);}scope.$on('$destroy',function(){$mdDialog.destroy(element);});/**
	         *
	         */function addOverflowClass(){element.toggleClass('md-content-overflow',content.scrollHeight>content.clientHeight);}});}};}/**
	 * @ngdoc service
	 * @name $mdDialog
	 * @module material.components.dialog
	 *
	 * @description
	 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
	 *  them to make decisions. There are two approaches for setup: a simple promise API
	 *  and regular object syntax.
	 *
	 * ## Restrictions
	 *
	 * - The dialog is always given an isolate scope.
	 * - The dialog's template must have an outer `<md-dialog>` element.
	 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 *   an `<md-dialog-actions>` element for the dialog's actions.
	 * - Dialogs must cover the entire application to keep interactions inside of them.
	 * Use the `parent` option to change where dialogs are appended.
	 *
	 * ## Sizing
	 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
	 * - Default max-width is 80% of the `rootElement` or `parent`.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div  ng-app="demoApp" ng-controller="EmployeeController">
	 *   <div>
	 *     <md-button ng-click="showAlert()" class="md-raised md-warn">
	 *       Employee Alert!
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showDialog($event)" class="md-raised">
	 *       Custom Dialog
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">
	 *       Close Alert
	 *     </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showGreeting($event)" class="md-raised md-primary" >
	 *       Greet Employee
	 *       </md-button>
	 *   </div>
	 * </div>
	 * </hljs>
	 *
	 * ### JavaScript: object syntax
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *    .module('demoApp', ['ngMaterial'])
	 *    .controller('AppCtrl', AppController);
	 *
	 *   function AppController($scope, $mdDialog) {
	 *     var alert;
	 *     $scope.showAlert = showAlert;
	 *     $scope.showDialog = showDialog;
	 *     $scope.items = [1, 2, 3];
	 *
	 *     // Internal method
	 *     function showAlert() {
	 *       alert = $mdDialog.alert({
	 *         title: 'Attention',
	 *         textContent: 'This is an example of how easy dialogs can be!',
	 *         ok: 'Close'
	 *       });
	 *
	 *       $mdDialog
	 *         .show( alert )
	 *         .finally(function() {
	 *           alert = undefined;
	 *         });
	 *     }
	 *
	 *     function showDialog($event) {
	 *        var parentEl = angular.element(document.body);
	 *        $mdDialog.show({
	 *          parent: parentEl,
	 *          targetEvent: $event,
	 *          template:
	 *            '<md-dialog aria-label="List dialog">' +
	 *            '  <md-dialog-content>'+
	 *            '    <md-list>'+
	 *            '      <md-list-item ng-repeat="item in items">'+
	 *            '       <p>Number {{item}}</p>' +
	 *            '      </md-item>'+
	 *            '    </md-list>'+
	 *            '  </md-dialog-content>' +
	 *            '  <md-dialog-actions>' +
	 *            '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *            '      Close Dialog' +
	 *            '    </md-button>' +
	 *            '  </md-dialog-actions>' +
	 *            '</md-dialog>',
	 *          locals: {
	 *            items: $scope.items
	 *          },
	 *          controller: DialogController
	 *       });
	 *       function DialogController($scope, $mdDialog, items) {
	 *         $scope.items = items;
	 *         $scope.closeDialog = function() {
	 *           $mdDialog.hide();
	 *         }
	 *       }
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 *
	 * ### Multiple Dialogs
	 * Using the `multiple` option for the `$mdDialog` service allows developers to show multiple dialogs
	 * at the same time.
	 *
	 * <hljs lang="js">
	 *   // From plain options
	 *   $mdDialog.show({
	 *     multiple: true
	 *   });
	 *
	 *   // From a dialog preset
	 *   $mdDialog.show(
	 *     $mdDialog
	 *       .alert()
	 *       .multiple(true)
	 *   );
	 *
	 * </hljs>
	 *
	 * ### Pre-Rendered Dialogs
	 * By using the `contentElement` option, it is possible to use an already existing element in the DOM.
	 *
	 * > Pre-rendered dialogs will be not linked to any scope and will not instantiate any new controller.<br/>
	 * > You can manually link the elements to a scope or instantiate a controller from the template (`ng-controller`)
	 *
	 * <hljs lang="js">
	 *   $scope.showPrerenderedDialog = function() {
	 *     $mdDialog.show({
	 *       contentElement: '#myStaticDialog',
	 *       parent: angular.element(document.body)
	 *     });
	 *   };
	 * </hljs>
	 *
	 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS selector.
	 *
	 * <hljs lang="html">
	 *   <div style="visibility: hidden">
	 *     <div class="md-dialog-container" id="myStaticDialog">
	 *       <md-dialog>
	 *         This is a pre-rendered dialog.
	 *       </md-dialog>
	 *     </div>
	 *   </div>
	 * </hljs>
	 *
	 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise the dialog
	 * will not show up.
	 *
	 * It also possible to use a DOM element for the `contentElement` option.
	 * - `contentElement: document.querySelector('#myStaticDialog')`
	 * - `contentElement: angular.element(TEMPLATE)`
	 *
	 * When using a `template` as content element, it will be not compiled upon open.
	 * This allows you to compile the element yourself and use it each time the dialog opens.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdDialogProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-dialog>' +
	 *             'This is a custom preset' +
	 *           '</md-dialog>',
	 *         controllerAs: 'dialog',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you created your preset at config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdDialog.show(
	 *     $mdDialog.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ### JavaScript: promise API syntax, custom dialog template
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *     .module('demoApp', ['ngMaterial'])
	 *     .controller('EmployeeController', EmployeeEditor)
	 *     .controller('GreetingController', GreetingController);
	 *
	 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
	 *
	 *   function EmployeeEditor($scope, $mdDialog) {
	 *     var alert;
	 *
	 *     $scope.showAlert = showAlert;
	 *     $scope.closeAlert = closeAlert;
	 *     $scope.showGreeting = showCustomGreeting;
	 *
	 *     $scope.hasAlert = function() { return !!alert };
	 *     $scope.userName = $scope.userName || 'Bobby';
	 *
	 *     // Dialog #1 - Show simple alert dialog and cache
	 *     // reference to dialog instance
	 *
	 *     function showAlert() {
	 *       alert = $mdDialog.alert()
	 *         .title('Attention, ' + $scope.userName)
	 *         .textContent('This is an example of how easy dialogs can be!')
	 *         .ok('Close');
	 *
	 *       $mdDialog
	 *           .show( alert )
	 *           .finally(function() {
	 *             alert = undefined;
	 *           });
	 *     }
	 *
	 *     // Close the specified dialog instance and resolve with 'finished' flag
	 *     // Normally this is not needed, just use '$mdDialog.hide()' to close
	 *     // the most recent dialog popup.
	 *
	 *     function closeAlert() {
	 *       $mdDialog.hide( alert, "finished" );
	 *       alert = undefined;
	 *     }
	 *
	 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
	 *
	 *     function showCustomGreeting($event) {
	 *         $mdDialog.show({
	 *           targetEvent: $event,
	 *           template:
	 *             '<md-dialog>' +
	 *
	 *             '  <md-dialog-content>Hello {{ employee }}!</md-dialog-content>' +
	 *
	 *             '  <md-dialog-actions>' +
	 *             '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *             '      Close Greeting' +
	 *             '    </md-button>' +
	 *             '  </md-dialog-actions>' +
	 *             '</md-dialog>',
	 *           controller: 'GreetingController',
	 *           onComplete: afterShowAnimation,
	 *           locals: { employee: $scope.userName }
	 *         });
	 *
	 *         // When the 'enter' animation finishes...
	 *
	 *         function afterShowAnimation(scope, element, options) {
	 *            // post-show code here: DOM element focus, etc.
	 *         }
	 *     }
	 *
	 *     // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog
	 *     //             Here we used ng-controller="GreetingController as vm" and
	 *     //             $scope.vm === <controller instance>
	 *
	 *     function showCustomGreeting() {
	 *
	 *        $mdDialog.show({
	 *           clickOutsideToClose: true,
	 *
	 *           scope: $scope,        // use parent scope in template
	 *           preserveScope: true,  // do not forget this if use parent scope
	
	 *           // Since GreetingController is instantiated with ControllerAs syntax
	 *           // AND we are passing the parent '$scope' to the dialog, we MUST
	 *           // use 'vm.<xxx>' in the template markup
	 *
	 *           template: '<md-dialog>' +
	 *                     '  <md-dialog-content>' +
	 *                     '     Hi There {{vm.employee}}' +
	 *                     '  </md-dialog-content>' +
	 *                     '</md-dialog>',
	 *
	 *           controller: function DialogController($scope, $mdDialog) {
	 *             $scope.closeDialog = function() {
	 *               $mdDialog.hide();
	 *             }
	 *           }
	 *        });
	 *     }
	 *
	 *   }
	 *
	 *   // Greeting controller used with the more complex 'showCustomGreeting()' custom dialog
	 *
	 *   function GreetingController($scope, $mdDialog, employee) {
	 *     // Assigned from construction <code>locals</code> options...
	 *     $scope.employee = employee;
	 *
	 *     $scope.closeDialog = function() {
	 *       // Easily hides most recent dialog shown...
	 *       // no specific instance reference is needed.
	 *       $mdDialog.hide();
	 *     };
	 *   }
	 *
	 * })(angular);
	 * </hljs>
	 *//**
	 * @ngdoc method
	 * @name $mdDialog#alert
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the alert title.
	 * - $mdDialogPreset#textContent(string) - Sets the alert message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the alert "Okay" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the alert dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdDialog#confirm
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message. You can call show and the promise returned
	 * will be resolved only if the user clicks the confirm action on the dialog.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the confirm title.
	 * - $mdDialogPreset#textContent(string) - Sets the confirm message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the confirm "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the confirm "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdDialog#prompt
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message and input box. You can call show and the promise returned
	 * will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the prompt title.
	 * - $mdDialogPreset#textContent(string) - Sets the prompt message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.
	 * - $mdDialogPreset#required(boolean) - Sets the input required value.
	 * - $mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.
	 * - $mdDialogPreset#ok(string) - Sets the prompt "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the prompt "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdDialog#show
	 *
	 * @description
	 * Show a dialog with the specified options.
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdDialogPreset` returned from `alert()`, and
	 * `confirm()`, or an options object with the following properties:
	 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
	 *   of the dialog.
	 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
	 *      with respect to Angular's [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *      This template should **never** be constructed with any kind of user input or user data.
	 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled each time a
	 *     dialog opens, you can also use a DOM element.<br/>
	 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch the element into
	 *       the dialog and restores it at the old DOM position upon close.
	 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
	 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
	 *     custom dialog directive.
	 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *   - `openFrom` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
	 *     originate.
	 *   - `closeTo` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
	 *     target.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new isolate scope.
	 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
	 *     Default true.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
	 *     Default true.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
	 *     close it. Default false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
	 *     Default true.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
	 *     focusing some other way, as focus management is required for dialogs to be accessible.
	 *     Defaults to true.
	 *   - `controller` - `{function|string=}`: The controller to associate with the dialog. The controller
	 *     will be injected with the local `$mdDialog`, which passes along a scope for the dialog.
	 *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will be used as names
	 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
	 *     copied to the controller instead.
	 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	 *   - `resolve` - `{function=}`: Similar to locals, except it takes as values functions that return promises, and the	
	 *      dialog will not open until all of the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
	 *     to the root element of the application.
	 *   - `onShowing` - `function(scope, element)`: Callback function used to announce the show() action is
	 *     starting.
	 *   - `onComplete` - `function(scope, element)`: Callback function used to announce when the show() action is
	 *     finished.
	 *   - `onRemoving` - `function(element, removePromise)`: Callback function used to announce the
	 *      close/hide() action is starting. This allows developers to run custom animations
	 *      in parallel with the close animations.
	 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
	 *      or not. Defaults to `false`.
	 *   - `multiple` `{boolean=}`: An option to allow this dialog to display over one that's currently open.
	 * @returns {promise} A promise that can be resolved with `$mdDialog.hide()` or
	 * rejected with `$mdDialog.cancel()`.
	 *//**
	 * @ngdoc method
	 * @name $mdDialog#hide
	 *
	 * @description
	 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 *//**
	 * @ngdoc method
	 * @name $mdDialog#cancel
	 *
	 * @description
	 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */function MdDialogProvider($$interimElementProvider){// Elements to capture and redirect focus when the user presses tab at the dialog boundary.
	MdDialogController.$inject=["$mdDialog","$mdConstant"];dialogDefaultOptions.$inject=["$mdDialog","$mdAria","$mdUtil","$mdConstant","$animate","$document","$window","$rootElement","$log","$injector","$mdTheming","$interpolate","$mdInteraction"];var topFocusTrap,bottomFocusTrap;return $$interimElementProvider('$mdDialog').setDefaults({methods:['disableParentScroll','hasBackdrop','clickOutsideToClose','escapeToClose','targetEvent','closeTo','openFrom','parent','fullscreen','multiple'],options:dialogDefaultOptions}).addPreset('alert',{methods:['title','htmlContent','textContent','content','ariaLabel','ok','theme','css'],options:advancedDialogOptions}).addPreset('confirm',{methods:['title','htmlContent','textContent','content','ariaLabel','ok','cancel','theme','css'],options:advancedDialogOptions}).addPreset('prompt',{methods:['title','htmlContent','textContent','initialValue','content','placeholder','ariaLabel','ok','cancel','theme','css','required'],options:advancedDialogOptions});/* @ngInject */function advancedDialogOptions(){return{template:['<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">','  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">','    <h2 class="md-title">{{ dialog.title }}</h2>','    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ','        ng-bind-html="::dialog.mdHtmlContent"></div>','    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">','      <p>{{::dialog.mdTextContent}}</p>','    </div>','    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">','      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" '+'             placeholder="{{::dialog.placeholder}}" ng-required="dialog.required">','    </md-input-container>','  </md-dialog-content>','  <md-dialog-actions>','    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"'+'               ng-click="dialog.abort()" class="md-primary md-cancel-button">','      {{ dialog.cancel }}','    </md-button>','    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'"'+'               ng-disabled="dialog.required && !dialog.result">','      {{ dialog.ok }}','    </md-button>','  </md-dialog-actions>','</md-dialog>'].join('').replace(/\s\s+/g,''),controller:MdDialogController,controllerAs:'dialog',bindToController:true};}/**
	   * Controller for the md-dialog interim elements
	   * @ngInject
	   */function MdDialogController($mdDialog,$mdConstant){// For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
	// interimElements. The $mdCompiler simulates the $onInit hook for all versions.
	this.$onInit=function(){var isPrompt=this.$type=='prompt';if(isPrompt&&this.initialValue){this.result=this.initialValue;}this.hide=function(){$mdDialog.hide(isPrompt?this.result:true);};this.abort=function(){$mdDialog.cancel();};this.keypress=function($event){var invalidPrompt=isPrompt&&this.required&&!angular.isDefined(this.result);if($event.keyCode===$mdConstant.KEY_CODE.ENTER&&!invalidPrompt){$mdDialog.hide(this.result);}};};}/* @ngInject */function dialogDefaultOptions($mdDialog,$mdAria,$mdUtil,$mdConstant,$animate,$document,$window,$rootElement,$log,$injector,$mdTheming,$interpolate,$mdInteraction){return{hasBackdrop:true,isolateScope:true,onCompiling:beforeCompile,onShow:onShow,onShowing:beforeShow,onRemove:onRemove,clickOutsideToClose:false,escapeToClose:true,targetEvent:null,closeTo:null,openFrom:null,focusOnOpen:true,disableParentScroll:true,autoWrap:true,fullscreen:false,transformTemplate:function transformTemplate(template,options){// Make the dialog container focusable, because otherwise the focus will be always redirected to
	// an element outside of the container, and the focus trap won't work probably..
	// Also the tabindex is needed for the `escapeToClose` functionality, because
	// the keyDown event can't be triggered when the focus is outside of the container.
	var startSymbol=$interpolate.startSymbol();var endSymbol=$interpolate.endSymbol();var theme=startSymbol+(options.themeWatch?'':'::')+'theme'+endSymbol;var themeAttr=options.hasTheme?'md-theme="'+theme+'"':'';return'<div class="md-dialog-container" tabindex="-1" '+themeAttr+'>'+validatedTemplate(template)+'</div>';/**
	         * The specified template should contain a <md-dialog> wrapper element....
	         */function validatedTemplate(template){if(options.autoWrap&&!/<\/md-dialog>/g.test(template)){return'<md-dialog>'+(template||'')+'</md-dialog>';}else{return template||'';}}}};function beforeCompile(options){// Automatically apply the theme, if the user didn't specify a theme explicitly.
	// Those option changes need to be done, before the compilation has started, because otherwise
	// the option changes will be not available in the $mdCompilers locales.
	options.defaultTheme=$mdTheming.defaultTheme();detectTheming(options);}function beforeShow(scope,element,options,controller){if(controller){var mdHtmlContent=controller.htmlContent||options.htmlContent||'';var mdTextContent=controller.textContent||options.textContent||controller.content||options.content||'';if(mdHtmlContent&&!$injector.has('$sanitize')){throw Error('The ngSanitize module must be loaded in order to use htmlContent.');}if(mdHtmlContent&&mdTextContent){throw Error('md-dialog cannot have both `htmlContent` and `textContent`');}// Only assign the content if nothing throws, otherwise it'll still be compiled.
	controller.mdHtmlContent=mdHtmlContent;controller.mdTextContent=mdTextContent;}}/** Show method for dialogs */function onShow(scope,element,options,controller){angular.element($document[0].body).addClass('md-dialog-is-showing');var dialogElement=element.find('md-dialog');// Once a dialog has `ng-cloak` applied on his template the dialog animation will not work properly.
	// This is a very common problem, so we have to notify the developer about this.
	if(dialogElement.hasClass('ng-cloak')){var message='$mdDialog: using `<md-dialog ng-cloak>` will affect the dialog opening animations.';$log.warn(message,element[0]);}captureParentAndFromToElements(options);configureAria(dialogElement,options);showBackdrop(scope,element,options);activateListeners(element,options);return dialogPopIn(element,options).then(function(){lockScreenReader(element,options);warnDeprecatedActions();focusOnOpen();});/**
	       * Check to see if they used the deprecated .md-actions class and log a warning
	       */function warnDeprecatedActions(){if(element[0].querySelector('.md-actions')){$log.warn('Using a class of md-actions is deprecated, please use <md-dialog-actions>.');}}/**
	       * For alerts, focus on content... otherwise focus on
	       * the close button (or equivalent)
	       */function focusOnOpen(){if(options.focusOnOpen){var target=$mdUtil.findFocusTarget(element)||findCloseButton()||dialogElement;target.focus();}/**
	         * If no element with class dialog-close, try to find the last
	         * button child in md-actions and assume it is a close button.
	         *
	         * If we find no actions at all, log a warning to the console.
	         */function findCloseButton(){return element[0].querySelector('.dialog-close, md-dialog-actions button:last-child');}}}/**
	     * Remove function for all dialogs
	     */function onRemove(scope,element,options){options.deactivateListeners();options.unlockScreenReader();options.hideBackdrop(options.$destroy);// Remove the focus traps that we added earlier for keeping focus within the dialog.
	if(topFocusTrap&&topFocusTrap.parentNode){topFocusTrap.parentNode.removeChild(topFocusTrap);}if(bottomFocusTrap&&bottomFocusTrap.parentNode){bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);}// For navigation $destroy events, do a quick, non-animated removal,
	// but for normal closes (from clicks, etc) animate the removal
	return options.$destroy?detachAndClean():animateRemoval().then(detachAndClean);/**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */function animateRemoval(){return dialogPopOut(element,options);}/**
	       * Detach the element
	       */function detachAndClean(){angular.element($document[0].body).removeClass('md-dialog-is-showing');// Reverse the container stretch if using a content element.
	if(options.contentElement){options.reverseContainerStretch();}// Exposed cleanup function from the $mdCompiler.
	options.cleanupElement();// Restores the focus to the origin element if the last interaction upon opening was a keyboard.
	if(!options.$destroy&&options.originInteraction==='keyboard'){options.origin.focus();}}}function detectTheming(options){// Once the user specifies a targetEvent, we will automatically try to find the correct
	// nested theme.
	var targetEl;if(options.targetEvent&&options.targetEvent.target){targetEl=angular.element(options.targetEvent.target);}var themeCtrl=targetEl&&targetEl.controller('mdTheme');options.hasTheme=!!themeCtrl;if(!options.hasTheme){return;}options.themeWatch=themeCtrl.$shouldWatch;var theme=options.theme||themeCtrl.$mdTheme;if(theme){options.scope.theme=theme;}var unwatch=themeCtrl.registerChanges(function(newTheme){options.scope.theme=newTheme;if(!options.themeWatch){unwatch();}});}/**
	     * Capture originator/trigger/from/to element information (if available)
	     * and the parent container for the dialog; defaults to the $rootElement
	     * unless overridden in the options.parent
	     */function captureParentAndFromToElements(options){options.origin=angular.extend({element:null,bounds:null,focus:angular.noop},options.origin||{});options.parent=getDomElement(options.parent,$rootElement);options.closeTo=getBoundingClientRect(getDomElement(options.closeTo));options.openFrom=getBoundingClientRect(getDomElement(options.openFrom));if(options.targetEvent){options.origin=getBoundingClientRect(options.targetEvent.target,options.origin);options.originInteraction=$mdInteraction.getLastInteractionType();}/**
	           * Identify the bounding RECT for the target element
	           *
	           */function getBoundingClientRect(element,orig){var source=angular.element(element||{});if(source&&source.length){// Compute and save the target element's bounding rect, so that if the
	// element is hidden when the dialog closes, we can shrink the dialog
	// back to the same position it expanded from.
	//
	// Checking if the source is a rect object or a DOM element
	var bounds={top:0,left:0,height:0,width:0};var hasFn=angular.isFunction(source[0].getBoundingClientRect);return angular.extend(orig||{},{element:hasFn?source:undefined,bounds:hasFn?source[0].getBoundingClientRect():angular.extend({},bounds,source[0]),focus:angular.bind(source,source.focus)});}}/**
	           * If the specifier is a simple string selector, then query for
	           * the DOM element.
	           */function getDomElement(element,defaultElement){if(angular.isString(element)){element=$document[0].querySelector(element);}// If we have a reference to a raw dom element, always wrap it in jqLite
	return angular.element(element||defaultElement);}}/**
	     * Listen for escape keys and outside clicks to auto close
	     */function activateListeners(element,options){var window=angular.element($window);var onWindowResize=$mdUtil.debounce(function(){stretchDialogContainerToViewport(element,options);},60);var removeListeners=[];var smartClose=function smartClose(){// Only 'confirm' dialogs have a cancel button... escape/clickOutside will
	// cancel or fallback to hide.
	var closeFn=options.$type=='alert'?$mdDialog.hide:$mdDialog.cancel;$mdUtil.nextTick(closeFn,true);};if(options.escapeToClose){var parentTarget=options.parent;var keyHandlerFn=function keyHandlerFn(ev){if(ev.keyCode===$mdConstant.KEY_CODE.ESCAPE){ev.stopPropagation();ev.preventDefault();smartClose();}};// Add keydown listeners
	element.on('keydown',keyHandlerFn);parentTarget.on('keydown',keyHandlerFn);// Queue remove listeners function
	removeListeners.push(function(){element.off('keydown',keyHandlerFn);parentTarget.off('keydown',keyHandlerFn);});}// Register listener to update dialog on window resize
	window.on('resize',onWindowResize);removeListeners.push(function(){window.off('resize',onWindowResize);});if(options.clickOutsideToClose){var target=element;var sourceElem;// Keep track of the element on which the mouse originally went down
	// so that we can only close the backdrop when the 'click' started on it.
	// A simple 'click' handler does not work,
	// it sets the target object as the element the mouse went down on.
	var mousedownHandler=function mousedownHandler(ev){sourceElem=ev.target;};// We check if our original element and the target is the backdrop
	// because if the original was the backdrop and the target was inside the dialog
	// we don't want to dialog to close.
	var mouseupHandler=function mouseupHandler(ev){if(sourceElem===target[0]&&ev.target===target[0]){ev.stopPropagation();ev.preventDefault();smartClose();}};// Add listeners
	target.on('mousedown',mousedownHandler);target.on('mouseup',mouseupHandler);// Queue remove listeners function
	removeListeners.push(function(){target.off('mousedown',mousedownHandler);target.off('mouseup',mouseupHandler);});}// Attach specific `remove` listener handler
	options.deactivateListeners=function(){removeListeners.forEach(function(removeFn){removeFn();});options.deactivateListeners=null;};}/**
	     * Show modal backdrop element...
	     */function showBackdrop(scope,element,options){if(options.disableParentScroll){// !! DO this before creating the backdrop; since disableScrollAround()
	//    configures the scroll offset; which is used by mdBackDrop postLink()
	options.restoreScroll=$mdUtil.disableScrollAround(element,options.parent);}if(options.hasBackdrop){options.backdrop=$mdUtil.createBackdrop(scope,"md-dialog-backdrop md-opaque");$animate.enter(options.backdrop,options.parent);}/**
	       * Hide modal backdrop element...
	       */options.hideBackdrop=function hideBackdrop($destroy){if(options.backdrop){if($destroy)options.backdrop.remove();else $animate.leave(options.backdrop);}if(options.disableParentScroll){options.restoreScroll&&options.restoreScroll();delete options.restoreScroll;}options.hideBackdrop=null;};}/**
	     * Inject ARIA-specific attributes appropriate for Dialogs
	     */function configureAria(element,options){var role=options.$type==='alert'?'alertdialog':'dialog';var dialogContent=element.find('md-dialog-content');var existingDialogId=element.attr('id');var dialogContentId='dialogContent_'+(existingDialogId||$mdUtil.nextUid());element.attr({'role':role,'tabIndex':'-1'});if(dialogContent.length===0){dialogContent=element;// If the dialog element already had an ID, don't clobber it.
	if(existingDialogId){dialogContentId=existingDialogId;}}dialogContent.attr('id',dialogContentId);element.attr('aria-describedby',dialogContentId);if(options.ariaLabel){$mdAria.expect(element,'aria-label',options.ariaLabel);}else{$mdAria.expectAsync(element,'aria-label',function(){// If dialog title is specified, set aria-label with it
	// See https://github.com/angular/material/issues/10582
	if(options.title){return options.title;}else{var words=dialogContent.text().split(/\s+/);if(words.length>3)words=words.slice(0,3).concat('...');return words.join(' ');}});}// Set up elements before and after the dialog content to capture focus and
	// redirect back into the dialog.
	topFocusTrap=document.createElement('div');topFocusTrap.classList.add('md-dialog-focus-trap');topFocusTrap.tabIndex=0;bottomFocusTrap=topFocusTrap.cloneNode(false);// When focus is about to move out of the dialog, we want to intercept it and redirect it
	// back to the dialog element.
	var focusHandler=function focusHandler(){element.focus();};topFocusTrap.addEventListener('focus',focusHandler);bottomFocusTrap.addEventListener('focus',focusHandler);// The top focus trap inserted immeidately before the md-dialog element (as a sibling).
	// The bottom focus trap is inserted at the very end of the md-dialog element (as a child).
	element[0].parentNode.insertBefore(topFocusTrap,element[0]);element.after(bottomFocusTrap);}/**
	     * Prevents screen reader interaction behind modal window
	     * on swipe interfaces
	     */function lockScreenReader(element,options){var isHidden=true;// get raw DOM node
	walkDOM(element[0]);options.unlockScreenReader=function(){isHidden=false;walkDOM(element[0]);options.unlockScreenReader=null;};/**
	       * Walk DOM to apply or remove aria-hidden on sibling nodes
	       * and parent sibling nodes
	       *
	       */function walkDOM(element){while(element.parentNode){if(element===document.body){return;}var children=element.parentNode.children;for(var i=0;i<children.length;i++){// skip over child if it is an ascendant of the dialog
	// or a script or style tag
	if(element!==children[i]&&!isNodeOneOf(children[i],['SCRIPT','STYLE'])&&!children[i].hasAttribute('aria-live')){children[i].setAttribute('aria-hidden',isHidden);}}walkDOM(element=element.parentNode);}}}/**
	     * Ensure the dialog container fill-stretches to the viewport
	     */function stretchDialogContainerToViewport(container,options){var isFixed=$window.getComputedStyle($document[0].body).position=='fixed';var backdrop=options.backdrop?$window.getComputedStyle(options.backdrop[0]):null;var height=backdrop?Math.min($document[0].body.clientHeight,Math.ceil(Math.abs(parseInt(backdrop.height,10)))):0;var previousStyles={top:container.css('top'),height:container.css('height')};// If the body is fixed, determine the distance to the viewport in relative from the parent.
	var parentTop=Math.abs(options.parent[0].getBoundingClientRect().top);container.css({top:(isFixed?parentTop:0)+'px',height:height?height+'px':'100%'});return function(){// Reverts the modified styles back to the previous values.
	// This is needed for contentElements, which should have the same styles after close
	// as before.
	container.css(previousStyles);};}/**
	     *  Dialog open and pop-in animation
	     */function dialogPopIn(container,options){// Add the `md-dialog-container` to the DOM
	options.parent.append(container);options.reverseContainerStretch=stretchDialogContainerToViewport(container,options);var dialogEl=container.find('md-dialog');var animator=$mdUtil.dom.animator;var buildTranslateToOrigin=animator.calculateZoomToOrigin;var translateOptions={transitionInClass:'md-transition-in',transitionOutClass:'md-transition-out'};var from=animator.toTransformCss(buildTranslateToOrigin(dialogEl,options.openFrom||options.origin));var to=animator.toTransformCss("");// defaults to center display (or parent or $rootElement)
	dialogEl.toggleClass('md-dialog-fullscreen',!!options.fullscreen);return animator.translate3d(dialogEl,from,to,translateOptions).then(function(animateReversal){// Build a reversal translate function synced to this translation...
	options.reverseAnimate=function(){delete options.reverseAnimate;if(options.closeTo){// Using the opposite classes to create a close animation to the closeTo element
	translateOptions={transitionInClass:'md-transition-out',transitionOutClass:'md-transition-in'};from=to;to=animator.toTransformCss(buildTranslateToOrigin(dialogEl,options.closeTo));return animator.translate3d(dialogEl,from,to,translateOptions);}return animateReversal(to=animator.toTransformCss(// in case the origin element has moved or is hidden,
	// let's recalculate the translateCSS
	buildTranslateToOrigin(dialogEl,options.origin)));};// Function to revert the generated animation styles on the dialog element.
	// Useful when using a contentElement instead of a template.
	options.clearAnimate=function(){delete options.clearAnimate;// Remove the transition classes, added from $animateCSS, since those can't be removed
	// by reversely running the animator.
	dialogEl.removeClass([translateOptions.transitionOutClass,translateOptions.transitionInClass].join(' '));// Run the animation reversely to remove the previous added animation styles.
	return animator.translate3d(dialogEl,to,animator.toTransformCss(''),{});};return true;});}/**
	     * Dialog close and pop-out animation
	     */function dialogPopOut(container,options){return options.reverseAnimate().then(function(){if(options.contentElement){// When we use a contentElement, we want the element to be the same as before.
	// That means, that we have to clear all the animation properties, like transform.
	options.clearAnimate();}});}/**
	     * Utility function to filter out raw DOM nodes
	     */function isNodeOneOf(elem,nodeTypeArray){if(nodeTypeArray.indexOf(elem.nodeName)!==-1){return true;}}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.divider
	 * @description Divider module!
	 */MdDividerDirective.$inject=["$mdTheming"];angular.module('material.components.divider',['material.core']).directive('mdDivider',MdDividerDirective);/**
	 * @ngdoc directive
	 * @name mdDivider
	 * @module material.components.divider
	 * @restrict E
	 *
	 * @description
	 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
	 *
	 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
	 * @usage
	 * <hljs lang="html">
	 * <md-divider></md-divider>
	 *
	 * <md-divider md-inset></md-divider>
	 * </hljs>
	 *
	 */function MdDividerDirective($mdTheming){return{restrict:'E',link:$mdTheming};}})();(function(){"use strict";(function(){'use strict';/**
	   * @ngdoc module
	   * @name material.components.fabActions
	   */MdFabActionsDirective.$inject=["$mdUtil"];angular.module('material.components.fabActions',['material.core']).directive('mdFabActions',MdFabActionsDirective);/**
	   * @ngdoc directive
	   * @name mdFabActions
	   * @module material.components.fabActions
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
	   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
	   * proper event listeners.
	   *
	   * @usage
	   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
	   */function MdFabActionsDirective($mdUtil){return{restrict:'E',require:['^?mdFabSpeedDial','^?mdFabToolbar'],compile:function compile(element,attributes){var children=element.children();var hasNgRepeat=$mdUtil.prefixer().hasAttribute(children,'ng-repeat');// Support both ng-repeat and static content
	if(hasNgRepeat){children.addClass('md-fab-action-item');}else{// Wrap every child in a new div and add a class that we can scale/fling independently
	children.wrap('<div class="md-fab-action-item">');}}};}})();})();(function(){"use strict";(function(){'use strict';MdFabController.$inject=["$scope","$element","$animate","$mdUtil","$mdConstant","$timeout"];angular.module('material.components.fabShared',['material.core']).controller('MdFabController',MdFabController);function MdFabController($scope,$element,$animate,$mdUtil,$mdConstant,$timeout){var vm=this;var initialAnimationAttempts=0;// NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops
	vm.open=function(){$scope.$evalAsync("vm.isOpen = true");};vm.close=function(){// Async eval to avoid conflicts with existing digest loops
	$scope.$evalAsync("vm.isOpen = false");// Focus the trigger when the element closes so users can still tab to the next item
	$element.find('md-fab-trigger')[0].focus();};// Toggle the open/close state when the trigger is clicked
	vm.toggle=function(){$scope.$evalAsync("vm.isOpen = !vm.isOpen");};/*
	     * AngularJS Lifecycle hook for newer AngularJS versions.
	     * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	     */vm.$onInit=function(){setupDefaults();setupListeners();setupWatchers();fireInitialAnimations();};// For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	// manually call the $onInit hook.
	if(angular.version.major===1&&angular.version.minor<=4){this.$onInit();}function setupDefaults(){// Set the default direction to 'down' if none is specified
	vm.direction=vm.direction||'down';// Set the default to be closed
	vm.isOpen=vm.isOpen||false;// Start the keyboard interaction at the first action
	resetActionIndex();// Add an animations waiting class so we know not to run
	$element.addClass('md-animations-waiting');}function setupListeners(){var eventTypes=['click','focusin','focusout'];// Add our listeners
	angular.forEach(eventTypes,function(eventType){$element.on(eventType,parseEvents);});// Remove our listeners when destroyed
	$scope.$on('$destroy',function(){angular.forEach(eventTypes,function(eventType){$element.off(eventType,parseEvents);});// remove any attached keyboard handlers in case element is removed while
	// speed dial is open
	disableKeyboard();});}var closeTimeout;function parseEvents(event){// If the event is a click, just handle it
	if(event.type=='click'){handleItemClick(event);}// If we focusout, set a timeout to close the element
	if(event.type=='focusout'&&!closeTimeout){closeTimeout=$timeout(function(){vm.close();},100,false);}// If we see a focusin and there is a timeout about to run, cancel it so we stay open
	if(event.type=='focusin'&&closeTimeout){$timeout.cancel(closeTimeout);closeTimeout=null;}}function resetActionIndex(){vm.currentActionIndex=-1;}function setupWatchers(){// Watch for changes to the direction and update classes/attributes
	$scope.$watch('vm.direction',function(newDir,oldDir){// Add the appropriate classes so we can target the direction in the CSS
	$animate.removeClass($element,'md-'+oldDir);$animate.addClass($element,'md-'+newDir);// Reset the action index since it may have changed
	resetActionIndex();});var trigger,actions;// Watch for changes to md-open
	$scope.$watch('vm.isOpen',function(isOpen){// Reset the action index since it may have changed
	resetActionIndex();// We can't get the trigger/actions outside of the watch because the component hasn't been
	// linked yet, so we wait until the first watch fires to cache them.
	if(!trigger||!actions){trigger=getTriggerElement();actions=getActionsElement();}if(isOpen){enableKeyboard();}else{disableKeyboard();}var toAdd=isOpen?'md-is-open':'';var toRemove=isOpen?'':'md-is-open';// Set the proper ARIA attributes
	trigger.attr('aria-haspopup',true);trigger.attr('aria-expanded',isOpen);actions.attr('aria-hidden',!isOpen);// Animate the CSS classes
	$animate.setClass($element,toAdd,toRemove);});}function fireInitialAnimations(){// If the element is actually visible on the screen
	if($element[0].scrollHeight>0){// Fire our animation
	$animate.addClass($element,'_md-animations-ready').then(function(){// Remove the waiting class
	$element.removeClass('md-animations-waiting');});}// Otherwise, try for up to 1 second before giving up
	else if(initialAnimationAttempts<10){$timeout(fireInitialAnimations,100);// Increment our counter
	initialAnimationAttempts=initialAnimationAttempts+1;}}function enableKeyboard(){$element.on('keydown',keyPressed);// On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
	// clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
	$mdUtil.nextTick(function(){angular.element(document).on('click touchend',checkForOutsideClick);});// TODO: On desktop, we should be able to reset the indexes so you cannot tab through, but
	// this breaks accessibility, especially on mobile, since you have no arrow keys to press
	//resetActionTabIndexes();
	}function disableKeyboard(){$element.off('keydown',keyPressed);angular.element(document).off('click touchend',checkForOutsideClick);}function checkForOutsideClick(event){if(event.target){var closestTrigger=$mdUtil.getClosest(event.target,'md-fab-trigger');var closestActions=$mdUtil.getClosest(event.target,'md-fab-actions');if(!closestTrigger&&!closestActions){vm.close();}}}function keyPressed(event){switch(event.which){case $mdConstant.KEY_CODE.ESCAPE:vm.close();event.preventDefault();return false;case $mdConstant.KEY_CODE.LEFT_ARROW:doKeyLeft(event);return false;case $mdConstant.KEY_CODE.UP_ARROW:doKeyUp(event);return false;case $mdConstant.KEY_CODE.RIGHT_ARROW:doKeyRight(event);return false;case $mdConstant.KEY_CODE.DOWN_ARROW:doKeyDown(event);return false;}}function doActionPrev(event){focusAction(event,-1);}function doActionNext(event){focusAction(event,1);}function focusAction(event,direction){var actions=resetActionTabIndexes();// Increment/decrement the counter with restrictions
	vm.currentActionIndex=vm.currentActionIndex+direction;vm.currentActionIndex=Math.min(actions.length-1,vm.currentActionIndex);vm.currentActionIndex=Math.max(0,vm.currentActionIndex);// Focus the element
	var focusElement=angular.element(actions[vm.currentActionIndex]).children()[0];angular.element(focusElement).attr('tabindex',0);focusElement.focus();// Make sure the event doesn't bubble and cause something else
	event.preventDefault();event.stopImmediatePropagation();}function resetActionTabIndexes(){// Grab all of the actions
	var actions=getActionsElement()[0].querySelectorAll('.md-fab-action-item');// Disable all other actions for tabbing
	angular.forEach(actions,function(action){angular.element(angular.element(action).children()[0]).attr('tabindex',-1);});return actions;}function doKeyLeft(event){if(vm.direction==='left'){doActionNext(event);}else{doActionPrev(event);}}function doKeyUp(event){if(vm.direction==='down'){doActionPrev(event);}else{doActionNext(event);}}function doKeyRight(event){if(vm.direction==='left'){doActionPrev(event);}else{doActionNext(event);}}function doKeyDown(event){if(vm.direction==='up'){doActionPrev(event);}else{doActionNext(event);}}function isTrigger(element){return $mdUtil.getClosest(element,'md-fab-trigger');}function isAction(element){return $mdUtil.getClosest(element,'md-fab-actions');}function handleItemClick(event){if(isTrigger(event.target)){vm.toggle();}if(isAction(event.target)){vm.close();}}function getTriggerElement(){return $element.find('md-fab-trigger');}function getActionsElement(){return $element.find('md-fab-actions');}}})();})();(function(){"use strict";(function(){'use strict';/**
	   * The duration of the CSS animation in milliseconds.
	   *
	   * @type {number}
	   */MdFabSpeedDialFlingAnimation.$inject=["$timeout"];MdFabSpeedDialScaleAnimation.$inject=["$timeout"];var cssAnimationDuration=300;/**
	   * @ngdoc module
	   * @name material.components.fabSpeedDial
	   */angular// Declare our module
	.module('material.components.fabSpeedDial',['material.core','material.components.fabShared','material.components.fabActions'])// Register our directive
	.directive('mdFabSpeedDial',MdFabSpeedDialDirective)// Register our custom animations
	.animation('.md-fling',MdFabSpeedDialFlingAnimation).animation('.md-scale',MdFabSpeedDialScaleAnimation)// Register a service for each animation so that we can easily inject them into unit tests
	.service('mdFabSpeedDialFlingAnimation',MdFabSpeedDialFlingAnimation).service('mdFabSpeedDialScaleAnimation',MdFabSpeedDialScaleAnimation);/**
	   * @ngdoc directive
	   * @name mdFabSpeedDial
	   * @module material.components.fabSpeedDial
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
	   * `<md-button>`s) for quick access to common actions.
	   *
	   * There are currently two animations available by applying one of the following classes to
	   * the component:
	   *
	   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
	   *    appropriate positions.
	   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-speed-dial>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
	   * open or close the speed dial. However, if you wish to allow users to hover over the empty
	   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
	   * dial element. Without this, the hover effect will only occur on top of the trigger.
	   *
	   * See the demos for more information.
	   *
	   * ## Troubleshooting
	   *
	   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
	   * the parent container to ensure that it is only visible once ready. We have plans to remove this
	   * necessity in the future.
	   *
	   * @usage
	   * <hljs lang="html">
	   * <md-fab-speed-dial md-direction="up" class="md-fling">
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-fab-actions>
	   *     <md-button aria-label="Add User">
	   *       <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *     </md-button>
	   *
	   *     <md-button aria-label="Add Group">
	   *       <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *     </md-button>
	   *   </md-fab-actions>
	   * </md-fab-speed-dial>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the speed dial to appear
	   * relative to the trigger element.
	   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
	   */function MdFabSpeedDialDirective(){return{restrict:'E',scope:{direction:'@?mdDirection',isOpen:'=?mdOpen'},bindToController:true,controller:'MdFabController',controllerAs:'vm',link:FabSpeedDialLink};function FabSpeedDialLink(scope,element){// Prepend an element to hold our CSS variables so we can use them in the animations below
	element.prepend('<div class="_md-css-variables"></div>');}}function MdFabSpeedDialFlingAnimation($timeout){function delayDone(done){$timeout(done,cssAnimationDuration,false);}function runAnimation(element){// Don't run if we are still waiting and we are not ready
	if(element.hasClass('md-animations-waiting')&&!element.hasClass('_md-animations-ready')){return;}var el=element[0];var ctrl=element.controller('mdFabSpeedDial');var items=el.querySelectorAll('.md-fab-action-item');// Grab our trigger element
	var triggerElement=el.querySelector('md-fab-trigger');// Grab our element which stores CSS variables
	var variablesElement=el.querySelector('._md-css-variables');// Setup JS variables based on our CSS variables
	var startZIndex=parseInt(window.getComputedStyle(variablesElement).zIndex);// Always reset the items to their natural position/state
	angular.forEach(items,function(item,index){var styles=item.style;styles.transform=styles.webkitTransform='';styles.transitionDelay='';styles.opacity=1;// Make the items closest to the trigger have the highest z-index
	styles.zIndex=items.length-index+startZIndex;});// Set the trigger to be above all of the actions so they disappear behind it.
	triggerElement.style.zIndex=startZIndex+items.length+1;// If the control is closed, hide the items behind the trigger
	if(!ctrl.isOpen){angular.forEach(items,function(item,index){var newPosition,axis;var styles=item.style;// Make sure to account for differences in the dimensions of the trigger verses the items
	// so that we can properly center everything; this helps hide the item's shadows behind
	// the trigger.
	var triggerItemHeightOffset=(triggerElement.clientHeight-item.clientHeight)/2;var triggerItemWidthOffset=(triggerElement.clientWidth-item.clientWidth)/2;switch(ctrl.direction){case'up':newPosition=item.scrollHeight*(index+1)+triggerItemHeightOffset;axis='Y';break;case'down':newPosition=-(item.scrollHeight*(index+1)+triggerItemHeightOffset);axis='Y';break;case'left':newPosition=item.scrollWidth*(index+1)+triggerItemWidthOffset;axis='X';break;case'right':newPosition=-(item.scrollWidth*(index+1)+triggerItemWidthOffset);axis='X';break;}var newTranslate='translate'+axis+'('+newPosition+'px)';styles.transform=styles.webkitTransform=newTranslate;});}}return{addClass:function addClass(element,className,done){if(element.hasClass('md-fling')){runAnimation(element);delayDone(done);}else{done();}},removeClass:function removeClass(element,className,done){runAnimation(element);delayDone(done);}};}function MdFabSpeedDialScaleAnimation($timeout){function delayDone(done){$timeout(done,cssAnimationDuration,false);}var delay=65;function runAnimation(element){var el=element[0];var ctrl=element.controller('mdFabSpeedDial');var items=el.querySelectorAll('.md-fab-action-item');// Grab our element which stores CSS variables
	var variablesElement=el.querySelector('._md-css-variables');// Setup JS variables based on our CSS variables
	var startZIndex=parseInt(window.getComputedStyle(variablesElement).zIndex);// Always reset the items to their natural position/state
	angular.forEach(items,function(item,index){var styles=item.style,offsetDelay=index*delay;styles.opacity=ctrl.isOpen?1:0;styles.transform=styles.webkitTransform=ctrl.isOpen?'scale(1)':'scale(0)';styles.transitionDelay=(ctrl.isOpen?offsetDelay:items.length-offsetDelay)+'ms';// Make the items closest to the trigger have the highest z-index
	styles.zIndex=items.length-index+startZIndex;});}return{addClass:function addClass(element,className,done){runAnimation(element);delayDone(done);},removeClass:function removeClass(element,className,done){runAnimation(element);delayDone(done);}};}})();})();(function(){"use strict";(function(){'use strict';/**
	   * @ngdoc module
	   * @name material.components.fabToolbar
	   */angular// Declare our module
	.module('material.components.fabToolbar',['material.core','material.components.fabShared','material.components.fabActions'])// Register our directive
	.directive('mdFabToolbar',MdFabToolbarDirective)// Register our custom animations
	.animation('.md-fab-toolbar',MdFabToolbarAnimation)// Register a service for the animation so that we can easily inject it into unit tests
	.service('mdFabToolbarAnimation',MdFabToolbarAnimation);/**
	   * @ngdoc directive
	   * @name mdFabToolbar
	   * @module material.components.fabToolbar
	   *
	   * @restrict E
	   *
	   * @description
	   *
	   * The `<md-fab-toolbar>` directive is used to present a toolbar of elements (usually `<md-button>`s)
	   * for quick access to common actions when a floating action button is activated (via click or
	   * keyboard navigation).
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-toolbar>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   * <md-fab-toolbar md-direction='left'>
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-toolbar>
	   *    <md-fab-actions>
	   *      <md-button aria-label="Add User">
	   *        <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *      </md-button>
	   *
	   *      <md-button aria-label="Add Group">
	   *        <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *      </md-button>
	   *    </md-fab-actions>
	   *   </md-toolbar>
	   * </md-fab-toolbar>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the toolbar items to appear
	   * relative to the trigger element. Supports `left` and `right` directions.
	   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
	   */function MdFabToolbarDirective(){return{restrict:'E',transclude:true,template:'<div class="md-fab-toolbar-wrapper">'+'  <div class="md-fab-toolbar-content" ng-transclude></div>'+'</div>',scope:{direction:'@?mdDirection',isOpen:'=?mdOpen'},bindToController:true,controller:'MdFabController',controllerAs:'vm',link:link};function link(scope,element,attributes){// Add the base class for animations
	element.addClass('md-fab-toolbar');// Prepend the background element to the trigger's button
	element.find('md-fab-trigger').find('button').prepend('<div class="md-fab-toolbar-background"></div>');}}function MdFabToolbarAnimation(){function runAnimation(element,className,done){// If no className was specified, don't do anything
	if(!className){return;}var el=element[0];var ctrl=element.controller('mdFabToolbar');// Grab the relevant child elements
	var backgroundElement=el.querySelector('.md-fab-toolbar-background');var triggerElement=el.querySelector('md-fab-trigger button');var toolbarElement=el.querySelector('md-toolbar');var iconElement=el.querySelector('md-fab-trigger button md-icon');var actions=element.find('md-fab-actions').children();// If we have both elements, use them to position the new background
	if(triggerElement&&backgroundElement){// Get our variables
	var color=window.getComputedStyle(triggerElement).getPropertyValue('background-color');var width=el.offsetWidth;var height=el.offsetHeight;// Make it twice as big as it should be since we scale from the center
	var scale=2*(width/triggerElement.offsetWidth);// Set some basic styles no matter what animation we're doing
	backgroundElement.style.backgroundColor=color;backgroundElement.style.borderRadius=width+'px';// If we're open
	if(ctrl.isOpen){// Turn on toolbar pointer events when closed
	toolbarElement.style.pointerEvents='inherit';backgroundElement.style.width=triggerElement.offsetWidth+'px';backgroundElement.style.height=triggerElement.offsetHeight+'px';backgroundElement.style.transform='scale('+scale+')';// Set the next close animation to have the proper delays
	backgroundElement.style.transitionDelay='0ms';iconElement&&(iconElement.style.transitionDelay='.3s');// Apply a transition delay to actions
	angular.forEach(actions,function(action,index){action.style.transitionDelay=(actions.length-index)*25+'ms';});}else{// Turn off toolbar pointer events when closed
	toolbarElement.style.pointerEvents='none';// Scale it back down to the trigger's size
	backgroundElement.style.transform='scale(1)';// Reset the position
	backgroundElement.style.top='0';if(element.hasClass('md-right')){backgroundElement.style.left='0';backgroundElement.style.right=null;}if(element.hasClass('md-left')){backgroundElement.style.right='0';backgroundElement.style.left=null;}// Set the next open animation to have the proper delays
	backgroundElement.style.transitionDelay='200ms';iconElement&&(iconElement.style.transitionDelay='0ms');// Apply a transition delay to actions
	angular.forEach(actions,function(action,index){action.style.transitionDelay=200+index*25+'ms';});}}}return{addClass:function addClass(element,className,done){runAnimation(element,className,done);done();},removeClass:function removeClass(element,className,done){runAnimation(element,className,done);done();}};}})();})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.gridList
	 */GridListController.$inject=["$mdUtil"];GridLayoutFactory.$inject=["$mdUtil"];GridListDirective.$inject=["$interpolate","$mdConstant","$mdGridLayout","$mdMedia"];GridTileDirective.$inject=["$mdMedia"];angular.module('material.components.gridList',['material.core']).directive('mdGridList',GridListDirective).directive('mdGridTile',GridTileDirective).directive('mdGridTileFooter',GridTileCaptionDirective).directive('mdGridTileHeader',GridTileCaptionDirective).factory('$mdGridLayout',GridLayoutFactory);/**
	 * @ngdoc directive
	 * @name mdGridList
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Grid lists are an alternative to standard list views. Grid lists are distinct
	 * from grids used for layouts and other visual presentations.
	 *
	 * A grid list is best suited to presenting a homogenous data type, typically
	 * images, and is optimized for visual comprehension and differentiating between
	 * like data types.
	 *
	 * A grid list is a continuous element consisting of tessellated, regular
	 * subdivisions called cells that contain tiles (`md-grid-tile`).
	 *
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
	 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
	 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
	 *
	 * Cells are arrayed vertically and horizontally within the grid.
	 *
	 * Tiles hold content and can span one or more cells vertically or horizontally.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-list` directive supports "responsive" attributes, which allow
	 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
	 * currently matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-cols-lg="8"`)
	 *
	 * @param {number} md-cols Number of columns in the grid.
	 * @param {string} md-row-height One of
	 * <ul>
	 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
	 *   <li>`{width}:{height}` - Ratio of width to height (eg.
	 *   `md-row-height="16:9"`)</li>
	 *   <li>`"fit"` - Height will be determined by subdividing the available
	 *   height by the number of rows</li>
	 * </ul>
	 * @param {string=} md-gutter The amount of space between tiles in CSS units
	 *     (default 1px)
	 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
	 *     object is available as `$event`, and contains performance information.
	 *
	 * @usage
	 * Basic:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fixed-height rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="200px" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fit rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Using responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-list
	 *     md-cols-sm="2"
	 *     md-cols-md="4"
	 *     md-cols-lg="8"
	 *     md-cols-gt-lg="12"
	 *     ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 */function GridListDirective($interpolate,$mdConstant,$mdGridLayout,$mdMedia){return{restrict:'E',controller:GridListController,scope:{mdOnLayout:'&'},link:postLink};function postLink(scope,element,attrs,ctrl){element.addClass('_md');// private md component indicator for styling
	// Apply semantics
	element.attr('role','list');// Provide the controller with a way to trigger layouts.
	ctrl.layoutDelegate=layoutDelegate;var invalidateLayout=angular.bind(ctrl,ctrl.invalidateLayout),unwatchAttrs=watchMedia();scope.$on('$destroy',unwatchMedia);/**
	     * Watches for changes in media, invalidating layout as necessary.
	     */function watchMedia(){for(var mediaName in $mdConstant.MEDIA){$mdMedia(mediaName);// initialize
	$mdMedia.getQuery($mdConstant.MEDIA[mediaName]).addListener(invalidateLayout);}return $mdMedia.watchResponsiveAttributes(['md-cols','md-row-height','md-gutter'],attrs,layoutIfMediaMatch);}function unwatchMedia(){ctrl.layoutDelegate=angular.noop;unwatchAttrs();for(var mediaName in $mdConstant.MEDIA){$mdMedia.getQuery($mdConstant.MEDIA[mediaName]).removeListener(invalidateLayout);}}/**
	     * Performs grid layout if the provided mediaName matches the currently
	     * active media type.
	     */function layoutIfMediaMatch(mediaName){if(mediaName==null){// TODO(shyndman): It would be nice to only layout if we have
	// instances of attributes using this media type
	ctrl.invalidateLayout();}else if($mdMedia(mediaName)){ctrl.invalidateLayout();}}var lastLayoutProps;/**
	     * Invokes the layout engine, and uses its results to lay out our
	     * tile elements.
	     *
	     * @param {boolean} tilesInvalidated Whether tiles have been
	     *    added/removed/moved since the last layout. This is to avoid situations
	     *    where tiles are replaced with properties identical to their removed
	     *    counterparts.
	     */function layoutDelegate(tilesInvalidated){var tiles=getTileElements();var props={tileSpans:getTileSpans(tiles),colCount:getColumnCount(),rowMode:getRowMode(),rowHeight:getRowHeight(),gutter:getGutter()};if(!tilesInvalidated&&angular.equals(props,lastLayoutProps)){return;}var performance=$mdGridLayout(props.colCount,props.tileSpans,tiles).map(function(tilePositions,rowCount){return{grid:{element:element,style:getGridStyle(props.colCount,rowCount,props.gutter,props.rowMode,props.rowHeight)},tiles:tilePositions.map(function(ps,i){return{element:angular.element(tiles[i]),style:getTileStyle(ps.position,ps.spans,props.colCount,rowCount,props.gutter,props.rowMode,props.rowHeight)};})};}).reflow().performance();// Report layout
	scope.mdOnLayout({$event:{performance:performance}});lastLayoutProps=props;}// Use $interpolate to do some simple string interpolation as a convenience.
	var startSymbol=$interpolate.startSymbol();var endSymbol=$interpolate.endSymbol();// Returns an expression wrapped in the interpolator's start and end symbols.
	function expr(exprStr){return startSymbol+exprStr+endSymbol;}// The amount of space a single 1x1 tile would take up (either width or height), used as
	// a basis for other calculations. This consists of taking the base size percent (as would be
	// if evenly dividing the size between cells), and then subtracting the size of one gutter.
	// However, since there are no gutters on the edges, each tile only uses a fration
	// (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
	// tile, and then breaking up the extra gutter on the edge evenly among the cells).
	var UNIT=$interpolate(expr('share')+'% - ('+expr('gutter')+' * '+expr('gutterShare')+')');// The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	// The position comes the size of a 1x1 tile plus gutter for each previous tile in the
	// row/column (offset).
	var POSITION=$interpolate('calc(('+expr('unit')+' + '+expr('gutter')+') * '+expr('offset')+')');// The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
	// This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
	// in the space that the gutter would normally have used (which was already accounted for in
	// the base unit calculation).
	var DIMENSION=$interpolate('calc(('+expr('unit')+') * '+expr('span')+' + ('+expr('span')+' - 1) * '+expr('gutter')+')');/**
	     * Gets the styles applied to a tile element described by the given parameters.
	     * @param {{row: number, col: number}} position The row and column indices of the tile.
	     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
	     * @param {number} colCount The number of columns.
	     * @param {number} rowCount The number of rows.
	     * @param {string} gutter The amount of space between tiles. This will be something like
	     *     '5px' or '2em'.
	     * @param {string} rowMode The row height mode. Can be one of:
	     *     'fixed': all rows have a fixed size, given by rowHeight,
	     *     'ratio': row height defined as a ratio to width, or
	     *     'fit': fit to the grid-list element height, divinding evenly among rows.
	     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
	     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
	     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
	     *     values for top, left, width, height, marginTop, and paddingTop.
	     */function getTileStyle(position,spans,colCount,rowCount,gutter,rowMode,rowHeight){// TODO(shyndman): There are style caching opportunities here.
	// Percent of the available horizontal space that one column takes up.
	var hShare=1/colCount*100;// Fraction of the gutter size that each column takes up.
	var hGutterShare=(colCount-1)/colCount;// Base horizontal size of a column.
	var hUnit=UNIT({share:hShare,gutterShare:hGutterShare,gutter:gutter});// The width and horizontal position of each tile is always calculated the same way, but the
	// height and vertical position depends on the rowMode.
	var ltr=document.dir!='rtl'&&document.body.dir!='rtl';var style=ltr?{left:POSITION({unit:hUnit,offset:position.col,gutter:gutter}),width:DIMENSION({unit:hUnit,span:spans.col,gutter:gutter}),// resets
	paddingTop:'',marginTop:'',top:'',height:''}:{right:POSITION({unit:hUnit,offset:position.col,gutter:gutter}),width:DIMENSION({unit:hUnit,span:spans.col,gutter:gutter}),// resets
	paddingTop:'',marginTop:'',top:'',height:''};switch(rowMode){case'fixed':// In fixed mode, simply use the given rowHeight.
	style.top=POSITION({unit:rowHeight,offset:position.row,gutter:gutter});style.height=DIMENSION({unit:rowHeight,span:spans.row,gutter:gutter});break;case'ratio':// Percent of the available vertical space that one row takes up. Here, rowHeight holds
	// the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
	var vShare=hShare/rowHeight;// Base veritcal size of a row.
	var vUnit=UNIT({share:vShare,gutterShare:hGutterShare,gutter:gutter});// padidngTop and marginTop are used to maintain the given aspect ratio, as
	// a percentage-based value for these properties is applied to the *width* of the
	// containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
	style.paddingTop=DIMENSION({unit:vUnit,span:spans.row,gutter:gutter});style.marginTop=POSITION({unit:vUnit,offset:position.row,gutter:gutter});break;case'fit':// Fraction of the gutter size that each column takes up.
	var vGutterShare=(rowCount-1)/rowCount;// Percent of the available vertical space that one row takes up.
	vShare=1/rowCount*100;// Base vertical size of a row.
	vUnit=UNIT({share:vShare,gutterShare:vGutterShare,gutter:gutter});style.top=POSITION({unit:vUnit,offset:position.row,gutter:gutter});style.height=DIMENSION({unit:vUnit,span:spans.row,gutter:gutter});break;}return style;}function getGridStyle(colCount,rowCount,gutter,rowMode,rowHeight){var style={};switch(rowMode){case'fixed':style.height=DIMENSION({unit:rowHeight,span:rowCount,gutter:gutter});style.paddingBottom='';break;case'ratio':// rowHeight is width / height
	var hGutterShare=colCount===1?0:(colCount-1)/colCount,hShare=1/colCount*100,vShare=hShare*(1/rowHeight),vUnit=UNIT({share:vShare,gutterShare:hGutterShare,gutter:gutter});style.height='';style.paddingBottom=DIMENSION({unit:vUnit,span:rowCount,gutter:gutter});break;case'fit':// noop, as the height is user set
	break;}return style;}function getTileElements(){return[].filter.call(element.children(),function(ele){return ele.tagName=='MD-GRID-TILE'&&!ele.$$mdDestroyed;});}/**
	     * Gets an array of objects containing the rowspan and colspan for each tile.
	     * @returns {Array<{row: number, col: number}>}
	     */function getTileSpans(tileElements){return[].map.call(tileElements,function(ele){var ctrl=angular.element(ele).controller('mdGridTile');return{row:parseInt($mdMedia.getResponsiveAttribute(ctrl.$attrs,'md-rowspan'),10)||1,col:parseInt($mdMedia.getResponsiveAttribute(ctrl.$attrs,'md-colspan'),10)||1};});}function getColumnCount(){var colCount=parseInt($mdMedia.getResponsiveAttribute(attrs,'md-cols'),10);if(isNaN(colCount)){throw'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';}return colCount;}function getGutter(){return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs,'md-gutter')||1);}function getRowHeight(){var rowHeight=$mdMedia.getResponsiveAttribute(attrs,'md-row-height');if(!rowHeight){throw'md-grid-list: md-row-height attribute was not found';}switch(getRowMode()){case'fixed':return applyDefaultUnit(rowHeight);case'ratio':var whRatio=rowHeight.split(':');return parseFloat(whRatio[0])/parseFloat(whRatio[1]);case'fit':return 0;// N/A
	}}function getRowMode(){var rowHeight=$mdMedia.getResponsiveAttribute(attrs,'md-row-height');if(!rowHeight){throw'md-grid-list: md-row-height attribute was not found';}if(rowHeight=='fit'){return'fit';}else if(rowHeight.indexOf(':')!==-1){return'ratio';}else{return'fixed';}}function applyDefaultUnit(val){return /\D$/.test(val)?val:val+'px';}}}/* @ngInject */function GridListController($mdUtil){this.layoutInvalidated=false;this.tilesInvalidated=false;this.$timeout_=$mdUtil.nextTick;this.layoutDelegate=angular.noop;}GridListController.prototype={invalidateTiles:function invalidateTiles(){this.tilesInvalidated=true;this.invalidateLayout();},invalidateLayout:function invalidateLayout(){if(this.layoutInvalidated){return;}this.layoutInvalidated=true;this.$timeout_(angular.bind(this,this.layout));},layout:function layout(){try{this.layoutDelegate(this.tilesInvalidated);}finally{this.layoutInvalidated=false;this.tilesInvalidated=false;}}};/* @ngInject */function GridLayoutFactory($mdUtil){var defaultAnimator=GridTileAnimator;/**
	   * Set the reflow animator callback
	   */GridLayout.animateWith=function(customAnimator){defaultAnimator=!angular.isFunction(customAnimator)?GridTileAnimator:customAnimator;};return GridLayout;/**
	   * Publish layout function
	   */function GridLayout(colCount,tileSpans){var self,_layoutInfo,gridStyles,layoutTime,mapTime,reflowTime;layoutTime=$mdUtil.time(function(){_layoutInfo=calculateGridFor(colCount,tileSpans);});return self={/**
	         * An array of objects describing each tile's position in the grid.
	         */layoutInfo:function layoutInfo(){return _layoutInfo;},/**
	         * Maps grid positioning to an element and a set of styles using the
	         * provided updateFn.
	         */map:function map(updateFn){mapTime=$mdUtil.time(function(){var info=self.layoutInfo();gridStyles=updateFn(info.positioning,info.rowCount);});return self;},/**
	         * Default animator simply sets the element.css( <styles> ). An alternate
	         * animator can be provided as an argument. The function has the following
	         * signature:
	         *
	         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
	         */reflow:function reflow(animatorFn){reflowTime=$mdUtil.time(function(){var animator=animatorFn||defaultAnimator;animator(gridStyles.grid,gridStyles.tiles);});return self;},/**
	         * Timing for the most recent layout run.
	         */performance:function performance(){return{tileCount:tileSpans.length,layoutTime:layoutTime,mapTime:mapTime,reflowTime:reflowTime,totalTime:layoutTime+mapTime+reflowTime};}};}/**
	   * Default Gridlist animator simple sets the css for each element;
	   * NOTE: any transitions effects must be manually set in the CSS.
	   * e.g.
	   *
	   *  md-grid-tile {
	   *    transition: all 700ms ease-out 50ms;
	   *  }
	   *
	   */function GridTileAnimator(grid,tiles){grid.element.css(grid.style);tiles.forEach(function(t){t.element.css(t.style);});}/**
	   * Calculates the positions of tiles.
	   *
	   * The algorithm works as follows:
	   *    An Array<Number> with length colCount (spaceTracker) keeps track of
	   *    available tiling positions, where elements of value 0 represents an
	   *    empty position. Space for a tile is reserved by finding a sequence of
	   *    0s with length <= than the tile's colspan. When such a space has been
	   *    found, the occupied tile positions are incremented by the tile's
	   *    rowspan value, as these positions have become unavailable for that
	   *    many rows.
	   *
	   *    If the end of a row has been reached without finding space for the
	   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
	   *    of 0. Rows are searched in this fashion until space is found.
	   */function calculateGridFor(colCount,tileSpans){var curCol=0,curRow=0,spaceTracker=newSpaceTracker();return{positioning:tileSpans.map(function(spans,i){return{spans:spans,position:reserveSpace(spans,i)};}),rowCount:curRow+Math.max.apply(Math,spaceTracker)};function reserveSpace(spans,i){if(spans.col>colCount){throw'md-grid-list: Tile at position '+i+' has a colspan '+'('+spans.col+') that exceeds the column count '+'('+colCount+')';}var start=0,end=0;// TODO(shyndman): This loop isn't strictly necessary if you can
	// determine the minimum number of rows before a space opens up. To do
	// this, recognize that you've iterated across an entire row looking for
	// space, and if so fast-forward by the minimum rowSpan count. Repeat
	// until the required space opens up.
	while(end-start<spans.col){if(curCol>=colCount){nextRow();continue;}start=spaceTracker.indexOf(0,curCol);if(start===-1||(end=findEnd(start+1))===-1){start=end=0;nextRow();continue;}curCol=end+1;}adjustRow(start,spans.col,spans.row);curCol=start+spans.col;return{col:start,row:curRow};}function nextRow(){curCol=0;curRow++;adjustRow(0,colCount,-1);// Decrement row spans by one
	}function adjustRow(from,cols,by){for(var i=from;i<from+cols;i++){spaceTracker[i]=Math.max(spaceTracker[i]+by,0);}}function findEnd(start){var i;for(i=start;i<spaceTracker.length;i++){if(spaceTracker[i]!==0){return i;}}if(i===spaceTracker.length){return i;}}function newSpaceTracker(){var tracker=[];for(var i=0;i<colCount;i++){tracker.push(0);}return tracker;}}}/**
	 * @ngdoc directive
	 * @name mdGridTile
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Tiles contain the content of an `md-grid-list`. They span one or more grid
	 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
	 * display secondary content.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-tile` directive supports "responsive" attributes, which allow
	 * different `md-rowspan` and `md-colspan` values depending on the currently
	 * matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-colspan-sm="4"`)
	 *
	 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
	 *    exceed the number of columns in the grid. Supports interpolation.
	 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
	 *     interpolation.
	 *
	 * @usage
	 * With header:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-header>
	 *     <h3>This is a header</h3>
	 *   </md-grid-tile-header>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * With footer:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-footer>
	 *     <h3>This is a footer</h3>
	 *   </md-grid-tile-footer>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Spanning multiple rows/columns:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="2" md-rowspan="3">
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
	 * </md-grid-tile>
	 * </hljs>
	 */function GridTileDirective($mdMedia){return{restrict:'E',require:'^mdGridList',template:'<figure ng-transclude></figure>',transclude:true,scope:{},// Simple controller that exposes attributes to the grid directive
	controller:["$attrs",function($attrs){this.$attrs=$attrs;}],link:postLink};function postLink(scope,element,attrs,gridCtrl){// Apply semantics
	element.attr('role','listitem');// If our colspan or rowspan changes, trigger a layout
	var unwatchAttrs=$mdMedia.watchResponsiveAttributes(['md-colspan','md-rowspan'],attrs,angular.bind(gridCtrl,gridCtrl.invalidateLayout));// Tile registration/deregistration
	gridCtrl.invalidateTiles();scope.$on('$destroy',function(){// Mark the tile as destroyed so it is no longer considered in layout,
	// even if the DOM element sticks around (like during a leave animation)
	element[0].$$mdDestroyed=true;unwatchAttrs();gridCtrl.invalidateLayout();});if(angular.isDefined(scope.$parent.$index)){scope.$watch(function(){return scope.$parent.$index;},function indexChanged(newIdx,oldIdx){if(newIdx===oldIdx){return;}gridCtrl.invalidateTiles();});}}}function GridTileCaptionDirective(){return{template:'<figcaption ng-transclude></figcaption>',transclude:true};}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.icon
	 * @description
	 * Icon
	 */angular.module('material.components.icon',['material.core']);})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.input
	 */mdInputContainerDirective.$inject=["$mdTheming","$parse"];inputTextareaDirective.$inject=["$mdUtil","$window","$mdAria","$timeout","$mdGesture"];mdMaxlengthDirective.$inject=["$animate","$mdUtil"];placeholderDirective.$inject=["$compile"];ngMessageDirective.$inject=["$mdUtil"];mdSelectOnFocusDirective.$inject=["$document","$timeout"];mdInputInvalidMessagesAnimation.$inject=["$$AnimateRunner","$animateCss","$mdUtil","$log"];ngMessagesAnimation.$inject=["$$AnimateRunner","$animateCss","$mdUtil","$log"];ngMessageAnimation.$inject=["$$AnimateRunner","$animateCss","$mdUtil","$log"];var inputModule=angular.module('material.components.input',['material.core']).directive('mdInputContainer',mdInputContainerDirective).directive('label',labelDirective).directive('input',inputTextareaDirective).directive('textarea',inputTextareaDirective).directive('mdMaxlength',mdMaxlengthDirective).directive('placeholder',placeholderDirective).directive('ngMessages',ngMessagesDirective).directive('ngMessage',ngMessageDirective).directive('ngMessageExp',ngMessageDirective).directive('mdSelectOnFocus',mdSelectOnFocusDirective).animation('.md-input-invalid',mdInputInvalidMessagesAnimation).animation('.md-input-messages-animation',ngMessagesAnimation).animation('.md-input-message-animation',ngMessageAnimation);// If we are running inside of tests; expose some extra services so that we can test them
	if(window._mdMocksIncluded){inputModule.service('$$mdInput',function(){return{// special accessor to internals... useful for testing
	messages:{show:showInputMessages,hide:hideInputMessages,getElement:getMessagesElement}};})// Register a service for each animation so that we can easily inject them into unit tests
	.service('mdInputInvalidAnimation',mdInputInvalidMessagesAnimation).service('mdInputMessagesAnimation',ngMessagesAnimation).service('mdInputMessageAnimation',ngMessageAnimation);}/**
	 * @ngdoc directive
	 * @name mdInputContainer
	 * @module material.components.input
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-input-container>` is the parent of any input or textarea element.
	 *
	 * Input and textarea elements will not behave properly unless the md-input-container
	 * parent is provided.
	 *
	 * A single `<md-input-container>` should contain only one `<input>` element, otherwise it will throw an error.
	 *
	 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an error, so
	 * you may combine these with other inputs.
	 *
	 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container elements
	 * are *block* elements, otherwise animations applied to the messages will not look as intended. Either use a `div` and
	 * apply the `ng-message` and `ng-messages` classes respectively, or use the `md-block` class on your element.
	 *
	 * @param md-is-error {expression=} When the given expression evaluates to true, the input container
	 *   will go into error state. Defaults to erroring if the input has been touched and is invalid.
	 * @param md-no-float {boolean=} When present, `placeholder` attributes on the input will not be converted to floating
	 *   labels.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Username</label>
	 *   <input type="text" ng-model="user.name">
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <label>Description</label>
	 *   <textarea ng-model="user.description"></textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 *
	 * <h3>When disabling floating labels</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container md-no-float>
	 *   <input type="text" placeholder="Non-Floating Label">
	 * </md-input-container>
	 *
	 * </hljs>
	 */function mdInputContainerDirective($mdTheming,$parse){ContainerCtrl.$inject=["$scope","$element","$attrs","$animate"];var INPUT_TAGS=['INPUT','TEXTAREA','SELECT','MD-SELECT'];var LEFT_SELECTORS=INPUT_TAGS.reduce(function(selectors,isel){return selectors.concat(['md-icon ~ '+isel,'.md-icon ~ '+isel]);},[]).join(",");var RIGHT_SELECTORS=INPUT_TAGS.reduce(function(selectors,isel){return selectors.concat([isel+' ~ md-icon',isel+' ~ .md-icon']);},[]).join(",");return{restrict:'E',compile:compile,controller:ContainerCtrl};function compile(tElement){// Check for both a left & right icon
	var leftIcon=tElement[0].querySelector(LEFT_SELECTORS);var rightIcon=tElement[0].querySelector(RIGHT_SELECTORS);if(leftIcon){tElement.addClass('md-icon-left');}if(rightIcon){tElement.addClass('md-icon-right');}return function postLink(scope,element){$mdTheming(element);};}function ContainerCtrl($scope,$element,$attrs,$animate){var self=this;self.isErrorGetter=$attrs.mdIsError&&$parse($attrs.mdIsError);self.delegateClick=function(){self.input.focus();};self.element=$element;self.setFocused=function(isFocused){$element.toggleClass('md-input-focused',!!isFocused);};self.setHasValue=function(hasValue){$element.toggleClass('md-input-has-value',!!hasValue);};self.setHasPlaceholder=function(hasPlaceholder){$element.toggleClass('md-input-has-placeholder',!!hasPlaceholder);};self.setInvalid=function(isInvalid){if(isInvalid){$animate.addClass($element,'md-input-invalid');}else{$animate.removeClass($element,'md-input-invalid');}};$scope.$watch(function(){return self.label&&self.input;},function(hasLabelAndInput){if(hasLabelAndInput&&!self.label.attr('for')){self.label.attr('for',self.input.attr('id'));}});}}function labelDirective(){return{restrict:'E',require:'^?mdInputContainer',link:function link(scope,element,attr,containerCtrl){if(!containerCtrl||attr.mdNoFloat||element.hasClass('md-container-ignore'))return;containerCtrl.label=element;scope.$on('$destroy',function(){containerCtrl.label=null;});}};}/**
	 * @ngdoc directive
	 * @name mdInput
	 * @restrict E
	 * @module material.components.input
	 *
	 * @description
	 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
	 * allows you to build complex forms for data entry.
	 *
	 * When the input is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`).<br/>
	 * This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
	 *   specified, a character counter will be shown underneath the input.<br/><br/>
	 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
	 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
	 *   or maxlength attributes.<br/><br/>
	 *   **Note:** Only valid for text/string inputs (not numeric).
	 *
	 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
	 *   will be logged in the console if not present.
	 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
	 *   PRESENT. The placeholder text is copied to the aria-label attribute.
	 * @param md-no-autogrow {boolean=} When present, textareas will not grow automatically.
	 * @param md-no-asterisk {boolean=} When present, an asterisk will not be appended to the inputs floating label
	 * @param md-no-resize {boolean=} Disables the textarea resize handle.
	 * @param {number=} max-rows The maximum amount of rows for a textarea.
	 * @param md-detect-hidden {boolean=} When present, textareas will be sized properly when they are
	 *   revealed after being hidden. This is off by default for performance reasons because it
	 *   guarantees a reflow every digest cycle.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Color</label>
	 *   <input type="text" ng-model="color" required md-maxlength="10">
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>With Errors</h3>
	 *
	 * `md-input-container` also supports errors using the standard `ng-messages` directives and
	 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
	 * the `ngShow`/`ngHide` events.
	 *
	 * By default, the messages will be hidden until the input is in an error state. This is based off
	 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
	 * fill out the form before the errors become visible.
	 *
	 * <hljs lang="html">
	 * <form name="colorForm">
	 *   <md-input-container>
	 *     <label>Favorite Color</label>
	 *     <input name="favoriteColor" ng-model="favoriteColor" required>
	 *     <div ng-messages="colorForm.favoriteColor.$error">
	 *       <div ng-message="required">This is required!</div>
	 *     </div>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * We automatically disable this auto-hiding functionality if you provide any of the following
	 * visibility directives on the `ng-messages` container:
	 *
	 *  - `ng-if`
	 *  - `ng-show`/`ng-hide`
	 *  - `ng-switch-when`/`ng-switch-default`
	 *
	 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
	 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
	 * or if you are building your own visibilty directive.
	 *
	 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
	 * initialization of the `ng-messages` directive to see if it equals the string `false`._
	 *
	 * <hljs lang="html">
	 * <form name="userForm">
	 *   <md-input-container>
	 *     <label>Last Name</label>
	 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
	 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *       <div ng-message="minlength">That's too short!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <label>Biography</label>
	 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
	 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input aria-label='title' ng-model='title'>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input placeholder='title' ng-model='title'>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * <h3>Notes</h3>
	 *
	 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
	 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
	 *
	 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
	 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
	 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
	 *
	 *
	 * <h3>Textarea directive</h3>
	 * The `textarea` element within a `md-input-container` has the following specific behavior:
	 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
	 * attribute.
	 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
	 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
	 * high initially. If no rows are specified, the directive defaults to 1.
	 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
	 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
	 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
	 * - If you want a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
	 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
	 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
	 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
	 */function inputTextareaDirective($mdUtil,$window,$mdAria,$timeout,$mdGesture){return{restrict:'E',require:['^?mdInputContainer','?ngModel','?^form'],link:postLink};function postLink(scope,element,attr,ctrls){var containerCtrl=ctrls[0];var hasNgModel=!!ctrls[1];var ngModelCtrl=ctrls[1]||$mdUtil.fakeNgModel();var parentForm=ctrls[2];var isReadonly=angular.isDefined(attr.readonly);var mdNoAsterisk=$mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);var tagName=element[0].tagName.toLowerCase();if(!containerCtrl)return;if(attr.type==='hidden'){element.attr('aria-hidden','true');return;}else if(containerCtrl.input){if(containerCtrl.input[0].contains(element[0])){return;}else{throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");}}containerCtrl.input=element;setupAttributeWatchers();// Add an error spacer div after our input to provide space for the char counter and any ng-messages
	var errorsSpacer=angular.element('<div class="md-errors-spacer">');element.after(errorsSpacer);var placeholderText=angular.isString(attr.placeholder)?attr.placeholder.trim():'';if(!containerCtrl.label&&!placeholderText.length){$mdAria.expect(element,'aria-label');}element.addClass('md-input');if(!element.attr('id')){element.attr('id','input_'+$mdUtil.nextUid());}// This works around a Webkit issue where number inputs, placed in a flexbox, that have
	// a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
	// for more info. Also note that we don't override the `step` if the user has specified it,
	// in order to prevent some unexpected behaviour.
	if(tagName==='input'&&attr.type==='number'&&attr.min&&attr.max&&!attr.step){element.attr('step','any');}else if(tagName==='textarea'){setupTextarea();}// If the input doesn't have an ngModel, it may have a static value. For that case,
	// we have to do one initial check to determine if the container should be in the
	// "has a value" state.
	if(!hasNgModel){inputCheckValue();}var isErrorGetter=containerCtrl.isErrorGetter||function(){return ngModelCtrl.$invalid&&(ngModelCtrl.$touched||parentForm&&parentForm.$submitted);};scope.$watch(isErrorGetter,containerCtrl.setInvalid);// When the developer uses the ngValue directive for the input, we have to observe the attribute, because
	// AngularJS's ngValue directive is just setting the `value` attribute.
	if(attr.ngValue){attr.$observe('value',inputCheckValue);}ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);element.on('input',inputCheckValue);if(!isReadonly){element.on('focus',function(ev){$mdUtil.nextTick(function(){containerCtrl.setFocused(true);});}).on('blur',function(ev){$mdUtil.nextTick(function(){containerCtrl.setFocused(false);inputCheckValue();});});}scope.$on('$destroy',function(){containerCtrl.setFocused(false);containerCtrl.setHasValue(false);containerCtrl.input=null;});/** Gets run through ngModel's pipeline and set the `has-value` class on the container. */function ngModelPipelineCheckValue(arg){containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));return arg;}function setupAttributeWatchers(){if(containerCtrl.label){attr.$observe('required',function(value){// We don't need to parse the required value, it's always a boolean because of angular's
	// required directive.
	containerCtrl.label.toggleClass('md-required',value&&!mdNoAsterisk);});}}function inputCheckValue(){// An input's value counts if its length > 0,
	// or if the input's validity state says it has bad input (eg string in a number input)
	containerCtrl.setHasValue(element.val().length>0||(element[0].validity||{}).badInput);}function setupTextarea(){var isAutogrowing=!attr.hasOwnProperty('mdNoAutogrow');attachResizeHandle();if(!isAutogrowing)return;// Can't check if height was or not explicity set,
	// so rows attribute will take precedence if present
	var minRows=attr.hasOwnProperty('rows')?parseInt(attr.rows):NaN;var maxRows=attr.hasOwnProperty('maxRows')?parseInt(attr.maxRows):NaN;var scopeResizeListener=scope.$on('md-resize-textarea',growTextarea);var lineHeight=null;var node=element[0];// This timeout is necessary, because the browser needs a little bit
	// of time to calculate the `clientHeight` and `scrollHeight`.
	$timeout(function(){$mdUtil.nextTick(growTextarea);},10,false);// We could leverage ngModel's $parsers here, however it
	// isn't reliable, because AngularJS trims the input by default,
	// which means that growTextarea won't fire when newlines and
	// spaces are added.
	element.on('input',growTextarea);// We should still use the $formatters, because they fire when
	// the value was changed from outside the textarea.
	if(hasNgModel){ngModelCtrl.$formatters.push(formattersListener);}if(!minRows){element.attr('rows',1);}angular.element($window).on('resize',growTextarea);scope.$on('$destroy',disableAutogrow);function growTextarea(){// temporarily disables element's flex so its height 'runs free'
	element.attr('rows',1).css('height','auto').addClass('md-no-flex');var height=getHeight();if(!lineHeight){// offsetHeight includes padding which can throw off our value
	var originalPadding=element[0].style.padding||'';lineHeight=element.css('padding',0).prop('offsetHeight');element[0].style.padding=originalPadding;}if(minRows&&lineHeight){height=Math.max(height,lineHeight*minRows);}if(maxRows&&lineHeight){var maxHeight=lineHeight*maxRows;if(maxHeight<height){element.attr('md-no-autogrow','');height=maxHeight;}else{element.removeAttr('md-no-autogrow');}}if(lineHeight){element.attr('rows',Math.round(height/lineHeight));}element.css('height',height+'px').removeClass('md-no-flex');}function getHeight(){var offsetHeight=node.offsetHeight;var line=node.scrollHeight-offsetHeight;return offsetHeight+Math.max(line,0);}function formattersListener(value){$mdUtil.nextTick(growTextarea);return value;}function disableAutogrow(){if(!isAutogrowing)return;isAutogrowing=false;angular.element($window).off('resize',growTextarea);scopeResizeListener&&scopeResizeListener();element.attr('md-no-autogrow','').off('input',growTextarea);if(hasNgModel){var listenerIndex=ngModelCtrl.$formatters.indexOf(formattersListener);if(listenerIndex>-1){ngModelCtrl.$formatters.splice(listenerIndex,1);}}}function attachResizeHandle(){if(attr.hasOwnProperty('mdNoResize'))return;var handle=angular.element('<div class="md-resize-handle"></div>');var isDragging=false;var dragStart=null;var startHeight=0;var container=containerCtrl.element;var dragGestureHandler=$mdGesture.register(handle,'drag',{horizontal:false});element.wrap('<div class="md-resize-wrapper">').after(handle);handle.on('mousedown',onMouseDown);container.on('$md.dragstart',onDragStart).on('$md.drag',onDrag).on('$md.dragend',onDragEnd);scope.$on('$destroy',function(){handle.off('mousedown',onMouseDown).remove();container.off('$md.dragstart',onDragStart).off('$md.drag',onDrag).off('$md.dragend',onDragEnd);dragGestureHandler();handle=null;container=null;dragGestureHandler=null;});function onMouseDown(ev){ev.preventDefault();isDragging=true;dragStart=ev.clientY;startHeight=parseFloat(element.css('height'))||element.prop('offsetHeight');}function onDragStart(ev){if(!isDragging)return;ev.preventDefault();disableAutogrow();container.addClass('md-input-resized');}function onDrag(ev){if(!isDragging)return;element.css('height',startHeight+ev.pointer.distanceY+'px');}function onDragEnd(ev){if(!isDragging)return;isDragging=false;container.removeClass('md-input-resized');}}// Attach a watcher to detect when the textarea gets shown.
	if(attr.hasOwnProperty('mdDetectHidden')){var handleHiddenChange=function(){var wasHidden=false;return function(){var isHidden=node.offsetHeight===0;if(isHidden===false&&wasHidden===true){growTextarea();}wasHidden=isHidden;};}();// Check every digest cycle whether the visibility of the textarea has changed.
	// Queue up to run after the digest cycle is complete.
	scope.$watch(function(){$mdUtil.nextTick(handleHiddenChange,false);return true;});}}}}function mdMaxlengthDirective($animate,$mdUtil){return{restrict:'A',require:['ngModel','^mdInputContainer'],link:postLink};function postLink(scope,element,attr,ctrls){var maxlength=parseInt(attr.mdMaxlength);if(isNaN(maxlength))maxlength=-1;var ngModelCtrl=ctrls[0];var containerCtrl=ctrls[1];var charCountEl,errorsSpacer;ngModelCtrl.$validators['md-maxlength']=function(modelValue,viewValue){if(!angular.isNumber(maxlength)||maxlength<0){return true;}// We always update the char count, when the modelValue has changed.
	// Using the $validators for triggering the update works very well.
	renderCharCount();return(modelValue||element.val()||viewValue||'').length<=maxlength;};// Wait until the next tick to ensure that the input has setup the errors spacer where we will
	// append our counter
	$mdUtil.nextTick(function(){errorsSpacer=angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));charCountEl=angular.element('<div class="md-char-counter">');// Append our character counter inside the errors spacer
	errorsSpacer.append(charCountEl);// Stop model from trimming. This makes it so whitespace
	// over the maxlength still counts as invalid.
	attr.$set('ngTrim','false');scope.$watch(attr.mdMaxlength,function(value){maxlength=value;if(angular.isNumber(value)&&value>0){if(!charCountEl.parent().length){$animate.enter(charCountEl,errorsSpacer);}renderCharCount();}else{$animate.leave(charCountEl);}});});function renderCharCount(value){// If we have not been initialized or appended to the body yet; do not render
	if(!charCountEl||!charCountEl.parent){return value;}// Force the value into a string since it may be a number,
	// which does not have a length property.
	charCountEl.text(String(element.val()||value||'').length+' / '+maxlength);return value;}}}function placeholderDirective($compile){return{restrict:'A',require:'^^?mdInputContainer',priority:200,link:{// Note that we need to do this in the pre-link, as opposed to the post link, if we want to
	// support data bindings in the placeholder. This is necessary, because we have a case where
	// we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
	// If we did this in the post-link, AngularJS would have set up the observers already and would be
	// re-adding the attribute, even though we removed it from the element.
	pre:preLink}};function preLink(scope,element,attr,inputContainer){// If there is no input container, just return
	if(!inputContainer)return;var label=inputContainer.element.find('label');var noFloat=inputContainer.element.attr('md-no-float');// If we have a label, or they specify the md-no-float attribute, just return
	if(label&&label.length||noFloat===''||scope.$eval(noFloat)){// Add a placeholder class so we can target it in the CSS
	inputContainer.setHasPlaceholder(true);return;}// md-select handles placeholders on it's own
	if(element[0].nodeName!='MD-SELECT'){// Move the placeholder expression to the label
	var newLabel=angular.element('<label ng-click="delegateClick()" tabindex="-1">'+attr.placeholder+'</label>');// Note that we unset it via `attr`, in order to get AngularJS
	// to remove any observers that it might have set up. Otherwise
	// the attribute will be added on the next digest.
	attr.$set('placeholder',null);// We need to compile the label manually in case it has any bindings.
	// A gotcha here is that we first add the element to the DOM and we compile
	// it later. This is necessary, because if we compile the element beforehand,
	// it won't be able to find the `mdInputContainer` controller.
	inputContainer.element.addClass('md-icon-float').prepend(newLabel);$compile(newLabel)(scope);}}}/**
	 * @ngdoc directive
	 * @name mdSelectOnFocus
	 * @module material.components.input
	 *
	 * @restrict A
	 *
	 * @description
	 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
	 *
	 * <h3>Notes</h3>
	 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
	 *
	 * @usage
	 * <h3>Using with an Input</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <input type="text" md-select-on-focus>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>Using with a Textarea</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 */function mdSelectOnFocusDirective($document,$timeout){return{restrict:'A',link:postLink};function postLink(scope,element,attr){if(element[0].nodeName!=='INPUT'&&element[0].nodeName!=="TEXTAREA")return;var preventMouseUp=false;element.on('focus',onFocus).on('mouseup',onMouseUp);scope.$on('$destroy',function(){element.off('focus',onFocus).off('mouseup',onMouseUp);});function onFocus(){preventMouseUp=true;$timeout(function(){// Use HTMLInputElement#select to fix firefox select issues.
	// The debounce is here for Edge's sake, otherwise the selection doesn't work.
	// Since focus may already have been lost on the input (and because `select()`
	// will re-focus), make sure the element is still active before applying.
	if($document[0].activeElement===element[0]){element[0].select();}// This should be reset from inside the `focus`, because the event might
	// have originated from something different than a click, e.g. a keyboard event.
	preventMouseUp=false;},1,false);}// Prevents the default action of the first `mouseup` after a focus.
	// This is necessary, because browsers fire a `mouseup` right after the element
	// has been focused. In some browsers (Firefox in particular) this can clear the
	// selection. There are examples of the problem in issue #7487.
	function onMouseUp(event){if(preventMouseUp){event.preventDefault();}}}}var visibilityDirectives=['ngIf','ngShow','ngHide','ngSwitchWhen','ngSwitchDefault'];function ngMessagesDirective(){return{restrict:'EA',link:postLink,// This is optional because we don't want target *all* ngMessage instances, just those inside of
	// mdInputContainer.
	require:'^^?mdInputContainer'};function postLink(scope,element,attrs,inputContainer){// If we are not a child of an input container, don't do anything
	if(!inputContainer)return;// Add our animation class
	element.toggleClass('md-input-messages-animation',true);// Add our md-auto-hide class to automatically hide/show messages when container is invalid
	element.toggleClass('md-auto-hide',true);// If we see some known visibility directives, remove the md-auto-hide class
	if(attrs.mdAutoHide=='false'||hasVisibiltyDirective(attrs)){element.toggleClass('md-auto-hide',false);}}function hasVisibiltyDirective(attrs){return visibilityDirectives.some(function(attr){return attrs[attr];});}}function ngMessageDirective($mdUtil){return{restrict:'EA',compile:compile,priority:100};function compile(tElement){if(!isInsideInputContainer(tElement)){// When the current element is inside of a document fragment, then we need to check for an input-container
	// in the postLink, because the element will be later added to the DOM and is currently just in a temporary
	// fragment, which causes the input-container check to fail.
	if(isInsideFragment()){return function(scope,element){if(isInsideInputContainer(element)){// Inside of the postLink function, a ngMessage directive will be a comment element, because it's
	// currently hidden. To access the shown element, we need to use the element from the compile function.
	initMessageElement(tElement);}};}}else{initMessageElement(tElement);}function isInsideFragment(){var nextNode=tElement[0];while(nextNode=nextNode.parentNode){if(nextNode.nodeType===Node.DOCUMENT_FRAGMENT_NODE){return true;}}return false;}function isInsideInputContainer(element){return!!$mdUtil.getClosest(element,"md-input-container");}function initMessageElement(element){// Add our animation class
	element.toggleClass('md-input-message-animation',true);}}}var $$AnimateRunner,$animateCss,$mdUtil,$log;function mdInputInvalidMessagesAnimation($$AnimateRunner,$animateCss,$mdUtil,$log){saveSharedServices($$AnimateRunner,$animateCss,$mdUtil,$log);return{addClass:function addClass(element,className,done){showInputMessages(element,done);}// NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
	};}function ngMessagesAnimation($$AnimateRunner,$animateCss,$mdUtil,$log){saveSharedServices($$AnimateRunner,$animateCss,$mdUtil,$log);return{enter:function enter(element,done){showInputMessages(element,done);},leave:function leave(element,done){hideInputMessages(element,done);},addClass:function addClass(element,className,done){if(className=="ng-hide"){hideInputMessages(element,done);}else{done();}},removeClass:function removeClass(element,className,done){if(className=="ng-hide"){showInputMessages(element,done);}else{done();}}};}function ngMessageAnimation($$AnimateRunner,$animateCss,$mdUtil,$log){saveSharedServices($$AnimateRunner,$animateCss,$mdUtil,$log);return{enter:function enter(element,done){var animator=showMessage(element);animator.start().done(done);},leave:function leave(element,done){var animator=hideMessage(element);animator.start().done(done);}};}function showInputMessages(element,done){var animators=[],animator;var messages=getMessagesElement(element);var children=messages.children();if(messages.length==0||children.length==0){$log.warn('mdInput messages show animation called on invalid messages element: ',element);done();return;}angular.forEach(children,function(child){animator=showMessage(angular.element(child));animators.push(animator.start());});$$AnimateRunner.all(animators,done);}function hideInputMessages(element,done){var animators=[],animator;var messages=getMessagesElement(element);var children=messages.children();if(messages.length==0||children.length==0){$log.warn('mdInput messages hide animation called on invalid messages element: ',element);done();return;}angular.forEach(children,function(child){animator=hideMessage(angular.element(child));animators.push(animator.start());});$$AnimateRunner.all(animators,done);}function showMessage(element){var height=parseInt(window.getComputedStyle(element[0]).height);var topMargin=parseInt(window.getComputedStyle(element[0]).marginTop);var messages=getMessagesElement(element);var container=getInputElement(element);// Check to see if the message is already visible so we can skip
	var alreadyVisible=topMargin>-height;// If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
	if(alreadyVisible||messages.hasClass('md-auto-hide')&&!container.hasClass('md-input-invalid')){return $animateCss(element,{});}return $animateCss(element,{event:'enter',structural:true,from:{"opacity":0,"margin-top":-height+"px"},to:{"opacity":1,"margin-top":"0"},duration:0.3});}function hideMessage(element){var height=element[0].offsetHeight;var styles=window.getComputedStyle(element[0]);// If we are already hidden, just return an empty animation
	if(parseInt(styles.opacity)===0){return $animateCss(element,{});}// Otherwise, animate
	return $animateCss(element,{event:'leave',structural:true,from:{"opacity":1,"margin-top":0},to:{"opacity":0,"margin-top":-height+"px"},duration:0.3});}function getInputElement(element){var inputContainer=element.controller('mdInputContainer');return inputContainer.element;}function getMessagesElement(element){// If we ARE the messages element, just return ourself
	if(element.hasClass('md-input-messages-animation')){return element;}// If we are a ng-message element, we need to traverse up the DOM tree
	if(element.hasClass('md-input-message-animation')){return angular.element($mdUtil.getClosest(element,function(node){return node.classList.contains('md-input-messages-animation');}));}// Otherwise, we can traverse down
	return angular.element(element[0].querySelector('.md-input-messages-animation'));}function saveSharedServices(_$$AnimateRunner_,_$animateCss_,_$mdUtil_,_$log_){$$AnimateRunner=_$$AnimateRunner_;$animateCss=_$animateCss_;$mdUtil=_$mdUtil_;$log=_$log_;}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.list
	 * @description
	 * List module
	 */MdListController.$inject=["$scope","$element","$mdListInkRipple"];mdListDirective.$inject=["$mdTheming"];mdListItemDirective.$inject=["$mdAria","$mdConstant","$mdUtil","$timeout"];angular.module('material.components.list',['material.core']).controller('MdListController',MdListController).directive('mdList',mdListDirective).directive('mdListItem',mdListItemDirective);/**
	 * @ngdoc directive
	 * @name mdList
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-list>
	 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
	 *     <md-checkbox ng-model="item.done"></md-checkbox>
	 *     <div class="md-list-item-text">
	 *       <h3>{{item.title}}</h3>
	 *       <p>{{item.description}}</p>
	 *     </div>
	 *   </md-list-item>
	 * </md-list>
	 * </hljs>
	 */function mdListDirective($mdTheming){return{restrict:'E',compile:function compile(tEl){tEl[0].setAttribute('role','list');return $mdTheming;}};}/**
	 * @ngdoc directive
	 * @name mdListItem
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * A `md-list-item` element can be used to represent some information in a row.<br/>
	 *
	 * @usage
	 * ### Single Row Item
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Multiple Lines
	 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-2-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It is also possible to have three lines inside of one list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-3-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *       <p>Third Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Secondary Items
	 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">
	 *       Secondary Button
	 *     </md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It also possible to have multiple secondary items inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">First Button</md-button>
	 *     <md-button class="md-secondary">Second Button</md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Proxy Item
	 * Proxies are elements, which will execute their specific action on click<br/>
	 * Currently supported proxy items are
	 * - `md-checkbox` (Toggle)
	 * - `md-switch` (Toggle)
	 * - `md-menu` (Open)
	 *
	 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
	 * automatically become clickable and executes the associated action of the proxy element on click.
	 *
	 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-no-proxy">
	 *     <span>No Proxy List</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * Here are a few examples of proxy elements inside of a list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on click.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-switch class="md-secondary"></md-switch>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
	 *
	 * It is also possible to have a `md-menu` inside of a `md-list-item`.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <p>Click anywhere to fire the secondary action</p>
	 *     <md-menu class="md-secondary">
	 *       <md-button class="md-icon-button">
	 *         <md-icon md-svg-icon="communication:message"></md-icon>
	 *       </md-button>
	 *       <md-menu-content width="4">
	 *         <md-menu-item>
	 *           <md-button>
	 *             Redial
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Check voicemail
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-divider></md-menu-divider>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Notifications
	 *           </md-button>
	 *         </md-menu-item>
	 *       </md-menu-content>
	 *     </md-menu>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
	 *
	 * If the developer didn't specify any position mode on the menu, the `md-list-item` will automatically detect the
	 * position mode and applies it to the `md-menu`.
	 *
	 * ### Avatars
	 * Sometimes you may want to have some avatars inside of the `md-list-item `.<br/>
	 * You are able to create a optimized icon for the list item, by applying the `.md-avatar` class on the `<img>` element.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <img src="my-avatar.png" class="md-avatar">
	 *     <span>Alan Turing</span>
	 * </hljs>
	 *
	 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <md-icon class="md-avatar-icon" md-svg-icon="avatars:timothy"></md-icon>
	 *     <span>Timothy Kopra</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * In cases, you have a `md-list-item`, which doesn't have any avatar,
	 * but you want to align it with the other avatar items, you have to use the `.md-offset` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-offset">
	 *     <span>Jon Doe</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### DOM modification
	 * The `md-list-item` component automatically detects if the list item should be clickable.
	 *
	 * ---
	 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
	 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`)
	 *
	 * We create an overlaying button, instead of wrapping all content inside of the button,
	 * because otherwise some elements may not be clickable inside of the button.
	 *
	 * ---
	 * When using a secondary item inside of your list item, the `md-list-item` component will automatically create
	 * a secondary container at the end of the `md-list-item`, which contains all secondary items.
	 *
	 * The secondary item container is not static, because otherwise the overflow will not work properly on the
	 * list item.
	 *
	 */function mdListItemDirective($mdAria,$mdConstant,$mdUtil,$timeout){var proxiedTypes=['md-checkbox','md-switch','md-menu'];return{restrict:'E',controller:'MdListController',compile:function compile(tEl,tAttrs){// Check for proxy controls (no ng-click on parent, and a control inside)
	var secondaryItems=tEl[0].querySelectorAll('.md-secondary');var hasProxiedElement;var proxyElement;var itemContainer=tEl;tEl[0].setAttribute('role','listitem');if(tAttrs.ngClick||tAttrs.ngDblclick||tAttrs.ngHref||tAttrs.href||tAttrs.uiSref||tAttrs.ngAttrUiSref){wrapIn('button');}else if(!tEl.hasClass('md-no-proxy')){for(var i=0,type;type=proxiedTypes[i];++i){if(proxyElement=tEl[0].querySelector(type)){hasProxiedElement=true;break;}}if(hasProxiedElement){wrapIn('div');}else{tEl.addClass('md-no-proxy');}}wrapSecondaryItems();setupToggleAria();if(hasProxiedElement&&proxyElement.nodeName==="MD-MENU"){setupProxiedMenu();}function setupToggleAria(){var toggleTypes=['md-switch','md-checkbox'];var toggle;for(var i=0,toggleType;toggleType=toggleTypes[i];++i){if(toggle=tEl.find(toggleType)[0]){if(!toggle.hasAttribute('aria-label')){var p=tEl.find('p')[0];if(!p)return;toggle.setAttribute('aria-label','Toggle '+p.textContent);}}}}function setupProxiedMenu(){var menuEl=angular.element(proxyElement);var isEndAligned=menuEl.parent().hasClass('md-secondary-container')||proxyElement.parentNode.firstElementChild!==proxyElement;var xAxisPosition='left';if(isEndAligned){// When the proxy item is aligned at the end of the list, we have to set the origin to the end.
	xAxisPosition='right';}// Set the position mode / origin of the proxied menu.
	if(!menuEl.attr('md-position-mode')){menuEl.attr('md-position-mode',xAxisPosition+' target');}// Apply menu open binding to menu button
	var menuOpenButton=menuEl.children().eq(0);if(!hasClickEvent(menuOpenButton[0])){menuOpenButton.attr('ng-click','$mdMenu.open($event)');}if(!menuOpenButton.attr('aria-label')){menuOpenButton.attr('aria-label','Open List Menu');}}function wrapIn(type){if(type=='div'){itemContainer=angular.element('<div class="md-no-style md-list-item-inner">');itemContainer.append(tEl.contents());tEl.addClass('md-proxy-focus');}else{// Element which holds the default list-item content.
	itemContainer=angular.element('<div class="md-button md-no-style">'+'   <div class="md-list-item-inner"></div>'+'</div>');// Button which shows ripple and executes primary action.
	var buttonWrap=angular.element('<md-button class="md-no-style"></md-button>');copyAttributes(tEl[0],buttonWrap[0]);// If there is no aria-label set on the button (previously copied over if present)
	// we determine the label from the content and copy it to the button.
	if(!buttonWrap.attr('aria-label')){buttonWrap.attr('aria-label',$mdAria.getText(tEl));}// We allow developers to specify the `md-no-focus` class, to disable the focus style
	// on the button executor. Once more classes should be forwarded, we should probably make the
	// class forward more generic.
	if(tEl.hasClass('md-no-focus')){buttonWrap.addClass('md-no-focus');}// Append the button wrap before our list-item content, because it will overlay in relative.
	itemContainer.prepend(buttonWrap);itemContainer.children().eq(1).append(tEl.contents());tEl.addClass('_md-button-wrap');}tEl[0].setAttribute('tabindex','-1');tEl.append(itemContainer);}function wrapSecondaryItems(){var secondaryItemsWrapper=angular.element('<div class="md-secondary-container">');angular.forEach(secondaryItems,function(secondaryItem){wrapSecondaryItem(secondaryItem,secondaryItemsWrapper);});itemContainer.append(secondaryItemsWrapper);}function wrapSecondaryItem(secondaryItem,container){// If the current secondary item is not a button, but contains a ng-click attribute,
	// the secondary item will be automatically wrapped inside of a button.
	if(secondaryItem&&!isButton(secondaryItem)&&secondaryItem.hasAttribute('ng-click')){$mdAria.expect(secondaryItem,'aria-label');var buttonWrapper=angular.element('<md-button class="md-secondary md-icon-button">');// Copy the attributes from the secondary item to the generated button.
	// We also support some additional attributes from the secondary item,
	// because some developers may use a ngIf, ngHide, ngShow on their item.
	copyAttributes(secondaryItem,buttonWrapper[0],['ng-if','ng-hide','ng-show']);secondaryItem.setAttribute('tabindex','-1');buttonWrapper.append(secondaryItem);secondaryItem=buttonWrapper[0];}if(secondaryItem&&(!hasClickEvent(secondaryItem)||!tAttrs.ngClick&&isProxiedElement(secondaryItem))){// In this case we remove the secondary class, so we can identify it later, when we searching for the
	// proxy items.
	angular.element(secondaryItem).removeClass('md-secondary');}tEl.addClass('md-with-secondary');container.append(secondaryItem);}/**
	       * Copies attributes from a source element to the destination element
	       * By default the function will copy the most necessary attributes, supported
	       * by the button executor for clickable list items.
	       * @param source Element with the specified attributes
	       * @param destination Element which will retrieve the attributes
	       * @param extraAttrs Additional attributes, which will be copied over.
	       */function copyAttributes(source,destination,extraAttrs){var copiedAttrs=$mdUtil.prefixer(['ng-if','ng-click','ng-dblclick','aria-label','ng-disabled','ui-sref','href','ng-href','rel','target','ng-attr-ui-sref','ui-sref-opts','download']);if(extraAttrs){copiedAttrs=copiedAttrs.concat($mdUtil.prefixer(extraAttrs));}angular.forEach(copiedAttrs,function(attr){if(source.hasAttribute(attr)){destination.setAttribute(attr,source.getAttribute(attr));source.removeAttribute(attr);}});}function isProxiedElement(el){return proxiedTypes.indexOf(el.nodeName.toLowerCase())!=-1;}function isButton(el){var nodeName=el.nodeName.toUpperCase();return nodeName=="MD-BUTTON"||nodeName=="BUTTON";}function hasClickEvent(element){var attr=element.attributes;for(var i=0;i<attr.length;i++){if(tAttrs.$normalize(attr[i].name)==='ngClick')return true;}return false;}return postLink;function postLink($scope,$element,$attr,ctrl){$element.addClass('_md');// private md component indicator for styling
	var proxies=[],firstElement=$element[0].firstElementChild,isButtonWrap=$element.hasClass('_md-button-wrap'),clickChild=isButtonWrap?firstElement.firstElementChild:firstElement,hasClick=clickChild&&hasClickEvent(clickChild),noProxies=$element.hasClass('md-no-proxy');computeProxies();computeClickable();if(proxies.length){angular.forEach(proxies,function(proxy){proxy=angular.element(proxy);$scope.mouseActive=false;proxy.on('mousedown',function(){$scope.mouseActive=true;$timeout(function(){$scope.mouseActive=false;},100);}).on('focus',function(){if($scope.mouseActive===false){$element.addClass('md-focused');}proxy.on('blur',function proxyOnBlur(){$element.removeClass('md-focused');proxy.off('blur',proxyOnBlur);});});});}function computeProxies(){if(firstElement&&firstElement.children&&!hasClick&&!noProxies){angular.forEach(proxiedTypes,function(type){// All elements which are not capable for being used a proxy have the .md-secondary class
	// applied. These items had been sorted out in the secondary wrap function.
	angular.forEach(firstElement.querySelectorAll(type+':not(.md-secondary)'),function(child){proxies.push(child);});});}}function computeClickable(){if(proxies.length==1||hasClick){$element.addClass('md-clickable');if(!hasClick){ctrl.attachRipple($scope,angular.element($element[0].querySelector('.md-no-style')));}}}function isEventFromControl(event){var forbiddenControls=['md-slider'];// If there is no path property in the event, then we can assume that the event was not bubbled.
	if(!event.path){return forbiddenControls.indexOf(event.target.tagName.toLowerCase())!==-1;}// We iterate the event path up and check for a possible component.
	// Our maximum index to search, is the list item root.
	var maxPath=event.path.indexOf($element.children()[0]);for(var i=0;i<maxPath;i++){if(forbiddenControls.indexOf(event.path[i].tagName.toLowerCase())!==-1){return true;}}}var clickChildKeypressListener=function clickChildKeypressListener(e){if(e.target.nodeName!='INPUT'&&e.target.nodeName!='TEXTAREA'&&!e.target.isContentEditable){var keyCode=e.which||e.keyCode;if(keyCode==$mdConstant.KEY_CODE.SPACE){if(clickChild){clickChild.click();e.preventDefault();e.stopPropagation();}}}};if(!hasClick&&!proxies.length){clickChild&&clickChild.addEventListener('keypress',clickChildKeypressListener);}$element.off('click');$element.off('keypress');if(proxies.length==1&&clickChild){$element.children().eq(0).on('click',function(e){// When the event is coming from an control and it should not trigger the proxied element
	// then we are skipping.
	if(isEventFromControl(e))return;var parentButton=$mdUtil.getClosest(e.target,'BUTTON');if(!parentButton&&clickChild.contains(e.target)){angular.forEach(proxies,function(proxy){if(e.target!==proxy&&!proxy.contains(e.target)){if(proxy.nodeName==='MD-MENU'){proxy=proxy.children[0];}angular.element(proxy).triggerHandler('click');}});}});}$scope.$on('$destroy',function(){clickChild&&clickChild.removeEventListener('keypress',clickChildKeypressListener);});}}};}/*
	 * @private
	 * @ngdoc controller
	 * @name MdListController
	 * @module material.components.list
	 *
	 */function MdListController($scope,$element,$mdListInkRipple){var ctrl=this;ctrl.attachRipple=attachRipple;function attachRipple(scope,element){var options={};$mdListInkRipple.attach(scope,element,options);}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.menu
	 */angular.module('material.components.menu',['material.core','material.components.backdrop']);})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.menuBar
	 */angular.module('material.components.menuBar',['material.core','material.components.icon','material.components.menu']);})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.navBar
	 */MdNavBarController.$inject=["$element","$scope","$timeout","$mdConstant"];MdNavItem.$inject=["$mdAria","$$rAF","$mdUtil","$window"];MdNavItemController.$inject=["$element"];MdNavBar.$inject=["$mdAria","$mdTheming"];angular.module('material.components.navBar',['material.core']).controller('MdNavBarController',MdNavBarController).directive('mdNavBar',MdNavBar).controller('MdNavItemController',MdNavItemController).directive('mdNavItem',MdNavItem);/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************//**
	 * @ngdoc directive
	 * @name mdNavBar
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
	 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
	 * body and no bar pagination.
	 *
	 * Because it deals with page navigation, certain routing concepts are built-in.
	 * Route changes via ng-href, ui-sref, or ng-click events are supported.
	 * Alternatively, the user could simply watch currentNavItem for changes.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 *
	 * @param {string=} mdSelectedNavItem The name of the current tab; this must
	 *     match the name attribute of `<md-nav-item>`
	 * @param {boolean=} mdNoInkBar If set to true, the ink bar will be hidden.
	 * @param {string=} navBarAriaLabel An aria-label for the nav-bar
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-nav-bar md-selected-nav-item="currentNavItem">
	 *    <md-nav-item md-nav-click="goto('page1')" name="page1">
	 *      Page One
	 *    </md-nav-item>
	 *    <md-nav-item md-nav-href="#page2" name="page3">Page Two</md-nav-item>
	 *    <md-nav-item md-nav-sref="page3" name="page2">Page Three</md-nav-item>
	 *    <md-nav-item
	 *      md-nav-sref="app.page4"
	 *      sref-opts="{reload: true, notify: true}"
	 *      name="page4">
	 *      Page Four
	 *    </md-nav-item>
	 *  </md-nav-bar>
	 *</hljs>
	 * <hljs lang="js">
	 * (function() {
	 *   'use strict';
	 *
	 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
	 *      $scope.currentLink = getCurrentLinkFromRoute(current);
	 *    });
	 * });
	 * </hljs>
	 *//*****************************************************************************
	 *                            mdNavItem
	 *****************************************************************************//**
	 * @ngdoc directive
	 * @name mdNavItem
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>`
	 * component. It renders an md-button as the actual link.
	 *
	 * Exactly one of the mdNavClick, mdNavHref, mdNavSref attributes are required
	 * to be specified.
	 *
	 * @param {Function=} mdNavClick Function which will be called when the
	 *     link is clicked to change the page. Renders as an `ng-click`.
	 * @param {string=} mdNavHref url to transition to when this link is clicked.
	 *     Renders as an `ng-href`.
	 * @param {string=} mdNavSref Ui-router state to transition to when this link is
	 *     clicked. Renders as a `ui-sref`.
	 * @param {!Object=} srefOpts Ui-router options that are passed to the
	 *     `$state.go()` function. See the [Ui-router documentation for details]
	 *     (https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html).
	 * @param {string=} name The name of this link. Used by the nav bar to know
	 *     which link is currently selected.
	 * @param {string=} aria-label Adds alternative text for accessibility
	 *
	 * @usage
	 * See `<md-nav-bar>` for usage.
	 *//*****************************************************************************
	 *                                IMPLEMENTATION                             *
	 *****************************************************************************/function MdNavBar($mdAria,$mdTheming){return{restrict:'E',transclude:true,controller:MdNavBarController,controllerAs:'ctrl',bindToController:true,scope:{'mdSelectedNavItem':'=?','mdNoInkBar':'=?','navBarAriaLabel':'@?'},template:'<div class="md-nav-bar">'+'<nav role="navigation">'+'<ul class="_md-nav-bar-list" ng-transclude role="listbox"'+'tabindex="0"'+'ng-focus="ctrl.onFocus()"'+'ng-keydown="ctrl.onKeydown($event)"'+'aria-label="{{ctrl.navBarAriaLabel}}">'+'</ul>'+'</nav>'+'<md-nav-ink-bar ng-hide="ctrl.mdNoInkBar"></md-nav-ink-bar>'+'</div>',link:function link(scope,element,attrs,ctrl){$mdTheming(element);if(!ctrl.navBarAriaLabel){$mdAria.expectAsync(element,'aria-label',angular.noop);}}};}/**
	 * Controller for the nav-bar component.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 * @param {!angular.JQLite} $element
	 * @param {!angular.Scope} $scope
	 * @param {!angular.Timeout} $timeout
	 * @param {!Object} $mdConstant
	 * @constructor
	 * @final
	 * @ngInject
	 */function MdNavBarController($element,$scope,$timeout,$mdConstant){// Injected variables
	/** @private @const {!angular.Timeout} */this._$timeout=$timeout;/** @private @const {!angular.Scope} */this._$scope=$scope;/** @private @const {!Object} */this._$mdConstant=$mdConstant;// Data-bound variables.
	/** @type {string} */this.mdSelectedNavItem;/** @type {string} */this.navBarAriaLabel;// State variables.
	/** @type {?angular.JQLite} */this._navBarEl=$element[0];/** @type {?angular.JQLite} */this._inkbar;var self=this;// need to wait for transcluded content to be available
	var deregisterTabWatch=this._$scope.$watch(function(){return self._navBarEl.querySelectorAll('._md-nav-button').length;},function(newLength){if(newLength>0){self._initTabs();deregisterTabWatch();}});}/**
	 * Initializes the tab components once they exist.
	 * @private
	 */MdNavBarController.prototype._initTabs=function(){this._inkbar=angular.element(this._navBarEl.querySelector('md-nav-ink-bar'));var self=this;this._$timeout(function(){self._updateTabs(self.mdSelectedNavItem,undefined);});this._$scope.$watch('ctrl.mdSelectedNavItem',function(newValue,oldValue){// Wait a digest before update tabs for products doing
	// anything dynamic in the template.
	self._$timeout(function(){self._updateTabs(newValue,oldValue);});});};/**
	 * Set the current tab to be selected.
	 * @param {string|undefined} newValue New current tab name.
	 * @param {string|undefined} oldValue Previous tab name.
	 * @private
	 */MdNavBarController.prototype._updateTabs=function(newValue,oldValue){var self=this;var tabs=this._getTabs();// this._getTabs can return null if nav-bar has not yet been initialized
	if(!tabs)return;var oldIndex=-1;var newIndex=-1;var newTab=this._getTabByName(newValue);var oldTab=this._getTabByName(oldValue);if(oldTab){oldTab.setSelected(false);oldIndex=tabs.indexOf(oldTab);}if(newTab){newTab.setSelected(true);newIndex=tabs.indexOf(newTab);}this._$timeout(function(){self._updateInkBarStyles(newTab,newIndex,oldIndex);});};/**
	 * Repositions the ink bar to the selected tab.
	 * @private
	 */MdNavBarController.prototype._updateInkBarStyles=function(tab,newIndex,oldIndex){this._inkbar.toggleClass('_md-left',newIndex<oldIndex).toggleClass('_md-right',newIndex>oldIndex);this._inkbar.css({display:newIndex<0?'none':''});if(tab){var tabEl=tab.getButtonEl();var left=tabEl.offsetLeft;this._inkbar.css({left:left+'px',width:tabEl.offsetWidth+'px'});}};/**
	 * Returns an array of the current tabs.
	 * @return {!Array<!NavItemController>}
	 * @private
	 */MdNavBarController.prototype._getTabs=function(){var controllers=Array.prototype.slice.call(this._navBarEl.querySelectorAll('.md-nav-item')).map(function(el){return angular.element(el).controller('mdNavItem');});return controllers.indexOf(undefined)?controllers:null;};/**
	 * Returns the tab with the specified name.
	 * @param {string} name The name of the tab, found in its name attribute.
	 * @return {!NavItemController|undefined}
	 * @private
	 */MdNavBarController.prototype._getTabByName=function(name){return this._findTab(function(tab){return tab.getName()==name;});};/**
	 * Returns the selected tab.
	 * @return {!NavItemController|undefined}
	 * @private
	 */MdNavBarController.prototype._getSelectedTab=function(){return this._findTab(function(tab){return tab.isSelected();});};/**
	 * Returns the focused tab.
	 * @return {!NavItemController|undefined}
	 */MdNavBarController.prototype.getFocusedTab=function(){return this._findTab(function(tab){return tab.hasFocus();});};/**
	 * Find a tab that matches the specified function.
	 * @private
	 */MdNavBarController.prototype._findTab=function(fn){var tabs=this._getTabs();for(var i=0;i<tabs.length;i++){if(fn(tabs[i])){return tabs[i];}}return null;};/**
	 * Direct focus to the selected tab when focus enters the nav bar.
	 */MdNavBarController.prototype.onFocus=function(){var tab=this._getSelectedTab();if(tab){tab.setFocused(true);}};/**
	 * Move focus from oldTab to newTab.
	 * @param {!NavItemController} oldTab
	 * @param {!NavItemController} newTab
	 * @private
	 */MdNavBarController.prototype._moveFocus=function(oldTab,newTab){oldTab.setFocused(false);newTab.setFocused(true);};/**
	 * Responds to keypress events.
	 * @param {!Event} e
	 */MdNavBarController.prototype.onKeydown=function(e){var keyCodes=this._$mdConstant.KEY_CODE;var tabs=this._getTabs();var focusedTab=this.getFocusedTab();if(!focusedTab)return;var focusedTabIndex=tabs.indexOf(focusedTab);// use arrow keys to navigate between tabs
	switch(e.keyCode){case keyCodes.UP_ARROW:case keyCodes.LEFT_ARROW:if(focusedTabIndex>0){this._moveFocus(focusedTab,tabs[focusedTabIndex-1]);}break;case keyCodes.DOWN_ARROW:case keyCodes.RIGHT_ARROW:if(focusedTabIndex<tabs.length-1){this._moveFocus(focusedTab,tabs[focusedTabIndex+1]);}break;case keyCodes.SPACE:case keyCodes.ENTER:// timeout to avoid a "digest already in progress" console error
	this._$timeout(function(){focusedTab.getButtonEl().click();});break;}};/**
	 * @ngInject
	 */function MdNavItem($mdAria,$$rAF,$mdUtil,$window){return{restrict:'E',require:['mdNavItem','^mdNavBar'],controller:MdNavItemController,bindToController:true,controllerAs:'ctrl',replace:true,transclude:true,template:function template(tElement,tAttrs){var hasNavClick=tAttrs.mdNavClick;var hasNavHref=tAttrs.mdNavHref;var hasNavSref=tAttrs.mdNavSref;var hasSrefOpts=tAttrs.srefOpts;var navigationAttribute;var navigationOptions;var buttonTemplate;// Cannot specify more than one nav attribute
	if((hasNavClick?1:0)+(hasNavHref?1:0)+(hasNavSref?1:0)>1){throw Error('Must not specify more than one of the md-nav-click, md-nav-href, '+'or md-nav-sref attributes per nav-item directive.');}if(hasNavClick){navigationAttribute='ng-click="ctrl.mdNavClick()"';}else if(hasNavHref){navigationAttribute='ng-href="{{ctrl.mdNavHref}}"';}else if(hasNavSref){navigationAttribute='ui-sref="{{ctrl.mdNavSref}}"';}navigationOptions=hasSrefOpts?'ui-sref-opts="{{ctrl.srefOpts}}" ':'';if(navigationAttribute){buttonTemplate=''+'<md-button class="_md-nav-button md-accent" '+'ng-class="ctrl.getNgClassMap()" '+'ng-blur="ctrl.setFocused(false)" '+'ng-disabled="ctrl.disabled"'+'tabindex="-1" '+navigationOptions+navigationAttribute+'>'+'<span ng-transclude class="_md-nav-button-text"></span>'+'</md-button>';}return''+'<li class="md-nav-item" '+'role="option" '+'aria-selected="{{ctrl.isSelected()}}">'+(buttonTemplate||'')+'</li>';},scope:{'mdNavClick':'&?','mdNavHref':'@?','mdNavSref':'@?','srefOpts':'=?','name':'@'},link:function link(scope,element,attrs,controllers){// When accessing the element's contents synchronously, they
	// may not be defined yet because of transclusion. There is a higher
	// chance that it will be accessible if we wait one frame.
	var disconnect;$$rAF(function(){var mdNavItem=controllers[0];var mdNavBar=controllers[1];var navButton=angular.element(element[0].querySelector('._md-nav-button'));if(!mdNavItem.name){mdNavItem.name=angular.element(element[0].querySelector('._md-nav-button-text')).text().trim();}navButton.on('click',function(){mdNavBar.mdSelectedNavItem=mdNavItem.name;scope.$apply();});if('MutationObserver'in $window){var config={attributes:true,attributeFilter:['disabled']};var targetNode=element[0];var mutationCallback=function mutationCallback(mutationList){$mdUtil.nextTick(function(){mdNavItem.disabled=$mdUtil.parseAttributeBoolean(attrs[mutationList[0].attributeName],false);});};var observer=new MutationObserver(mutationCallback);observer.observe(targetNode,config);disconnect=observer.disconnect.bind(observer);}else{attrs.$observe('disabled',function(value){mdNavItem.disabled=$mdUtil.parseAttributeBoolean(value,false);});}$mdAria.expectWithText(element,'aria-label');});scope.$on('destroy',function(){disconnect();});}};}/**
	 * Controller for the nav-item component.
	 * @param {!angular.JQLite} $element
	 * @constructor
	 * @final
	 * @ngInject
	 */function MdNavItemController($element){/** @private @const {!angular.JQLite} */this._$element=$element;// Data-bound variables
	/** @const {?Function} */this.mdNavClick;/** @const {?string} */this.mdNavHref;/** @const {?string} */this.mdNavSref;/** @const {?Object} */this.srefOpts;/** @const {?string} */this.name;// State variables
	/** @private {boolean} */this._selected=false;/** @private {boolean} */this._focused=false;}/**
	 * Returns a map of class names and values for use by ng-class.
	 * @return {!Object<string,boolean>}
	 */MdNavItemController.prototype.getNgClassMap=function(){return{'md-active':this._selected,'md-primary':this._selected,'md-unselected':!this._selected,'md-focused':this._focused};};/**
	 * Get the name attribute of the tab.
	 * @return {string}
	 */MdNavItemController.prototype.getName=function(){return this.name;};/**
	 * Get the button element associated with the tab.
	 * @return {!Element}
	 */MdNavItemController.prototype.getButtonEl=function(){return this._$element[0].querySelector('._md-nav-button');};/**
	 * Set the selected state of the tab.
	 * @param {boolean} isSelected
	 */MdNavItemController.prototype.setSelected=function(isSelected){this._selected=isSelected;};/**
	 * @return {boolean}
	 */MdNavItemController.prototype.isSelected=function(){return this._selected;};/**
	 * Set the focused state of the tab.
	 * @param {boolean} isFocused
	 */MdNavItemController.prototype.setFocused=function(isFocused){this._focused=isFocused;if(isFocused){this.getButtonEl().focus();}};/**
	 * @return {boolean}
	 */MdNavItemController.prototype.hasFocus=function(){return this._focused;};})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.panel
	 */MdPanelService.$inject=["presets","$rootElement","$rootScope","$injector","$window"];angular.module('material.components.panel',['material.core','material.components.backdrop']).provider('$mdPanel',MdPanelProvider);/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************//**
	 * @ngdoc service
	 * @name $mdPanelProvider
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanelProvider` allows users to create configuration presets that will be
	 * stored within a cached presets object. When the configuration is needed, the
	 * user can request the preset by passing it as the first parameter in the
	 * `$mdPanel.create` or `$mdPanel.open` methods.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .config(DemoConfig)
	 *       .controller('DemoCtrl', DemoCtrl)
	 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
	 *
	 *   function DemoConfig($mdPanelProvider) {
	 *     $mdPanelProvider.definePreset('demoPreset', {
	 *       attachTo: angular.element(document.body),
	 *       controller: DemoMenuCtrl,
	 *       controllerAs: 'ctrl',
	 *       template: '' +
	 *           '<div class="menu-panel" md-whiteframe="4">' +
	 *           '  <div class="menu-content">' +
	 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
	 *           '      <button class="md-button">' +
	 *           '        <span>{{item}}</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '    <md-divider></md-divider>' +
	 *           '    <div class="menu-item">' +
	 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
	 *           '        <span>Close Menu</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '  </div>' +
	 *           '</div>',
	 *       panelClass: 'menu-panel-container',
	 *       focusOnOpen: false,
	 *       zIndex: 100,
	 *       propagateContainerEvents: true,
	 *       groupName: 'menus'
	 *     });
	 *   }
	 *
	 *   function PanelProviderCtrl($mdPanel) {
	 *     this.navigation = {
	 *       name: 'navigation',
	 *       items: [
	 *         'Home',
	 *         'About',
	 *         'Contact'
	 *       ]
	 *     };
	 *     this.favorites = {
	 *       name: 'favorites',
	 *       items: [
	 *         'Add to Favorites'
	 *       ]
	 *     };
	 *     this.more = {
	 *       name: 'more',
	 *       items: [
	 *         'Account',
	 *         'Sign Out'
	 *       ]
	 *     };
	 *
	 *     $mdPanel.newPanelGroup('menus', {
	 *       maxOpen: 2
	 *     });
	 *
	 *     this.showMenu = function($event, menu) {
	 *       $mdPanel.open('demoPreset', {
	 *         id: 'menu_' + menu.name,
	 *         position: $mdPanel.newPanelPosition()
	 *             .relativeTo($event.srcElement)
	 *             .addPanelPosition(
	 *               $mdPanel.xPosition.ALIGN_START,
	 *               $mdPanel.yPosition.BELOW
	 *             ),
	 *         locals: {
	 *           items: menu.items
	 *         },
	 *         openFrom: $event
	 *       });
	 *     };
	 *   }
	 *
	 *   function PanelMenuCtrl(mdPanelRef) {
	 *     // The controller is provided with an import named 'mdPanelRef'
	 *     this.closeMenu = function() {
	 *       mdPanelRef && mdPanelRef.close();
	 *     };
	 *   }
	 * })(angular);
	 * </hljs>
	 *//**
	 * @ngdoc method
	 * @name $mdPanelProvider#definePreset
	 * @description
	 * Takes the passed in preset name and preset configuration object and adds it
	 * to the `_presets` object of the provider. This `_presets` object is then
	 * passed along to the `$mdPanel` service.
	 *
	 * @param {string} name Preset name.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters avaialble within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 *//*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************//**
	 * @ngdoc service
	 * @name $mdPanel
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanel` is a robust, low-level service for creating floating panels on
	 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
	 *
	 * The following types, referenced below, have separate documentation:
	 * - <a href="api/type/MdPanelAnimation">MdPanelAnimation</a> from `$mdPanel.newPanelAnimation()`
	 * - <a href="api/type/MdPanelPosition">MdPanelPosition</a> from `$mdPanel.newPanelPosition()`
	 * - <a href="api/type/MdPanelRef">MdPanelRef</a> from the `$mdPanel.open()` Promise or
	 * injected in the panel's controller
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .controller('DemoDialogController', DialogController)
	 *       .controller('DemoCtrl', function($mdPanel) {
	 *
	 *     var panelRef;
	 *
	 *     function showPanel($event) {
	 *       var panelPosition = $mdPanel.newPanelPosition()
	 *           .absolute()
	 *           .top('50%')
	 *           .left('50%');
	 *
	 *       var panelAnimation = $mdPanel.newPanelAnimation()
	 *           .openFrom($event)
	 *           .duration(200)
	 *           .closeTo('.show-button')
	 *           .withAnimation($mdPanel.animation.SCALE);
	 *
	 *       var config = {
	 *         attachTo: angular.element(document.body),
	 *         controller: DialogController,
	 *         controllerAs: 'ctrl',
	 *         position: panelPosition,
	 *         animation: panelAnimation,
	 *         targetEvent: $event,
	 *         templateUrl: 'dialog-template.html',
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true,
	 *         focusOnOpen: true
	 *       };
	 *
	 *       $mdPanel.open(config)
	 *           .then(function(result) {
	 *             panelRef = result;
	 *           });
	 *     }
	 *   }
	 *
	 *   function DialogController(MdPanelRef) {
	 *     function closeDialog() {
	 *       if (MdPanelRef) MdPanelRef.close();
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 *//**
	 * @ngdoc method
	 * @name $mdPanel#create
	 * @description
	 * Creates a panel with the specified options.
	 *
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
	 *     the created panel is added to a tracked panels object. Any subsequent
	 *     requests made to create a panel with that ID are ignored. This is useful
	 *     in having the panel service not open multiple panels from the same user
	 *     interaction when there is no backdrop and events are propagated. Defaults
	 *     to an arbitrary string that is not tracked.
	 *   - `template` - `{string=}`: HTML template to show in the panel. This
	 *     **must** be trusted HTML with respect to AngularJS’s
	 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
	 *     the panel.
	 *   - `contentElement` - `{(string|!angular.JQLite|!Element)=}`: Pre-compiled
	 *     element to be used as the panel's content.
	 *   - `controller` - `{(function|string)=}`: The controller to associate with
	 *     the panel. The controller can inject a reference to the returned
	 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
	 *     fields passed in through locals or resolve will be bound to the
	 *     controller.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
	 *     the scope.
	 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
	 *     instead of passing them in. Defaults to true, as this is a best
	 *     practice.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
	 *     will be used as names of values to inject into the controller. For
	 *     example, `locals: {three: 3}` would inject `three` into the controller,
	 *     with the value 3. 'mdPanelRef' is a reserved key, and will always
	 *     be set to the created MdPanelRef instance.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
	 *     values. The panel will not open until all of the promises resolve.
	 *   - `attachTo` - `{(string|!angular.JQLite|!Element)=}`: The element to
	 *     attach the panel to. Defaults to appending to the root element of the
	 *     application.
	 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
	 *     events should be allowed to propagate 'go through' the container, aka the
	 *     wrapper, of the panel. Defaults to false.
	 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
	 *     This class should define any borders, box-shadow, etc. for the panel.
	 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
	 *     Defaults to 80.
	 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
	 *     specifies the alignment of the panel. For more information, see
	 *     `MdPanelPosition`.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
	 *     outside the panel to close it. Defaults to false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
	 *     close the panel. Defaults to false.
	 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
	 *     called after the close successfully finishes. The first parameter passed
	 *     into this function is the current panelRef and the 2nd is an optional
	 *     string explaining the close reason. The currently supported closeReasons
	 *     can be found in the MdPanelRef.closeReasons enum. These are by default
	 *     passed along by the panel.
	 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
	 *     panel. If `trapFocus` is true, the user will not be able to interact
	 *     with the rest of the page until the panel is dismissed. Defaults to
	 *     false.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
	 *     open. Only disable if focusing some other way, as focus management is
	 *     required for panels to be accessible. Defaults to true.
	 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
	 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
	 *     to false.
	 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
	 *     specifies the animation of the panel. For more information, see
	 *     `MdPanelAnimation`.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
	 *     behind the panel. Defaults to false.
	 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
	 *     page behind the panel. Defaults to false.
	 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
	 *     the panel is added to the DOM.
	 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
	 *     when the open() action is finished.
	 *   - `onRemoving` - `{function=}`: Callback function used to announce the
	 *     close/hide() action is starting.
	 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
	 *     the panel is removed from the DOM.
	 *   - `origin` - `{(string|!angular.JQLite|!Element)=}`: The element to focus
	 *     on when the panel closes. This is commonly the element which triggered
	 *     the opening of the panel. If you do not use `origin`, you need to control
	 *     the focus manually.
	 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
	 *     group names. The group name is used for creating a group of panels. The
	 *     group is used for configuring the number of open panels and identifying
	 *     specific behaviors for groups. For instance, all tooltips could be
	 *     identified using the same groupName.
	 *
	 * @returns {!MdPanelRef} panelRef
	 *//**
	 * @ngdoc method
	 * @name $mdPanel#open
	 * @description
	 * Calls the create method above, then opens the panel. This is a shortcut for
	 * creating and then calling open manually. If custom methods need to be
	 * called when the panel is added to the DOM or opened, do not use this method.
	 * Instead create the panel, chain promises on the domAdded and openComplete
	 * methods, and call open from the returned panelRef.
	 *
	 * @param {!Object=} config Specific configuration object that may contain
	 *     the properties defined in `$mdPanel.create`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} panelRef A promise that resolves
	 *     to an instance of the panel.
	 *//**
	 * @ngdoc method
	 * @name $mdPanel#newPanelPosition
	 * @description
	 * Returns a new instance of the MdPanelPosition object. Use this to create
	 * the position config object.
	 *
	 * @returns {!MdPanelPosition} panelPosition
	 *//**
	 * @ngdoc method
	 * @name $mdPanel#newPanelAnimation
	 * @description
	 * Returns a new instance of the MdPanelAnimation object. Use this to create
	 * the animation config object.
	 *
	 * @returns {!MdPanelAnimation} panelAnimation
	 *//**
	 * @ngdoc method
	 * @name $mdPanel#newPanelGroup
	 * @description
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 *
	 * @param {string} groupName Name of the group to create.
	 * @param {!Object=} config Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed to
	 *     be open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 *//**
	 * @ngdoc method
	 * @name $mdPanel#setGroupMaxOpen
	 * @description
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 *
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 *//*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************//**
	 * @ngdoc type
	 * @name MdPanelRef
	 * @module material.components.panel
	 * @description
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with the following properties:
	 *
	 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
	 *     when a panel was interacted with.
	 *   - `config` - `{!Object=}`: The entire config object that was used in
	 *     create.
	 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
	 *     Visibility to the user does not factor into isAttached.
	 *   - `panelContainer` - `{angular.JQLite}`: The wrapper element containing the
	 *     panel. This property is added in order to have access to the `addClass`,
	 *     `removeClass`, `toggleClass`, etc methods.
	 *   - `panelEl` - `{angular.JQLite}`: The panel element. This property is added
	 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
	 *     etc methods.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#open
	 * @description
	 * Attaches and shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     opened.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#close
	 * @description
	 * Hides and detaches the panel. Note that this will **not** destroy the panel.
	 * If you don't intend on using the panel again, call the {@link #destroy
	 * destroy} method afterwards.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     closed.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#attach
	 * @description
	 * Create the panel elements and attach them to the DOM. The panel will be
	 * hidden by default.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     attached.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#detach
	 * @description
	 * Removes the panel from the DOM. This will NOT hide the panel before removing
	 * it.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     detached.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#show
	 * @description
	 * Shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     shown and animations are completed.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#hide
	 * @description
	 * Hides the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     hidden and animations are completed.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#destroy
	 * @description
	 * Destroys the panel. The panel cannot be opened again after this is called.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#addClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Adds a class to the panel. DO NOT use this hide/show the panel.
	 *
	 * @param {string} newClass class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#removeClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Removes a class from the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#toggleClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Toggles a class on the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} toggleClass Class to be toggled.
	 * @param {boolean} onElement Whether or not to remove the class from the panel
	 *     element instead of the container.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#updatePosition
	 * @description
	 * Updates the position configuration of a panel. Use this to update the
	 * position of a panel that is open, without having to close and re-open the
	 * panel.
	 *
	 * @param {!MdPanelPosition} position
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#addToGroup
	 * @description
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 *
	 * @param {string} groupName The name of the group to add the panel to.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#removeFromGroup
	 * @description
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 *
	 * @param {string} groupName The name of the group.
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#registerInterceptor
	 * @description
	 * Registers an interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected. The interceptors are called sequentially
	 * and it reverse order. `type` must be one of the following
	 * values available on `$mdPanel.interceptorTypes`:
	 * * `CLOSE` - Gets called before the panel begins closing.
	 *
	 * @param {string} type Type of interceptor.
	 * @param {!angular.$q.Promise<any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#removeInterceptor
	 * @description
	 * Removes a registered interceptor.
	 *
	 * @param {string} type Type of interceptor to be removed.
	 * @param {function(): !angular.$q.Promise<any>} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#removeAllInterceptors
	 * @description
	 * Removes all interceptors. If a type is supplied, only the
	 * interceptors of that type will be cleared.
	 *
	 * @param {string=} type Type of interceptors to be removed.
	 * @returns {!MdPanelRef}
	 *//**
	 * @ngdoc method
	 * @name MdPanelRef#updateAnimation
	 * @description
	 * Updates the animation configuration for a panel. You can use this to change
	 * the panel's animation without having to re-create it.
	 *
	 * @param {!MdPanelAnimation} animation
	 *//*****************************************************************************
	 *                               MdPanelPosition                            *
	 *****************************************************************************//**
	 * @ngdoc type
	 * @name MdPanelPosition
	 * @module material.components.panel
	 * @description
	 *
	 * Object for configuring the position of the panel.
	 *
	 * @usage
	 *
	 * #### Centering the panel
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition().absolute().center();
	 * </hljs>
	 *
	 * #### Overlapping the panel with an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.ALIGN_START,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 * </hljs>
	 *
	 * #### Aligning the panel with the bottom of an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
	 * </hljs>
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#absolute
	 * @description
	 * Positions the panel absolutely relative to the parent element. If the parent
	 * is document.body, this is equivalent to positioning the panel absolutely
	 * within the viewport.
	 *
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#relativeTo
	 * @description
	 * Positions the panel relative to a specific element.
	 *
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to position the panel with respect to.
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#top
	 * @description
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#bottom
	 * @description
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#start
	 * @description
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 *
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#end
	 * @description
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 *
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#left
	 * @description
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#right
	 * @description
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#centerHorizontally
	 * @description
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 *
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#centerVertically
	 * @description
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 *
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#center
	 * @description
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 *
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#addPanelPosition
	 * @description
	 * Sets the x and y position for the panel relative to another element. Can be
	 * called multiple times to specify an ordered list of panel positions. The
	 * first position which allows the panel to be completely on-screen will be
	 * chosen; the last position will be chose whether it is on-screen or not.
	 *
	 * xPosition must be one of the following values available on
	 * $mdPanel.xPosition:
	 *
	 *
	 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
	 *
	 * <pre>
	 *    *************
	 *    *           *
	 *    *   PANEL   *
	 *    *           *
	 *    *************
	 *   A B    C    D E
	 *
	 * A: OFFSET_START (for LTR displays)
	 * B: ALIGN_START (for LTR displays)
	 * C: CENTER
	 * D: ALIGN_END (for LTR displays)
	 * E: OFFSET_END (for LTR displays)
	 * </pre>
	 *
	 * yPosition must be one of the following values available on
	 * $mdPanel.yPosition:
	 *
	 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
	 *
	 * <pre>
	 *   F
	 *   G *************
	 *     *           *
	 *   H *   PANEL   *
	 *     *           *
	 *   I *************
	 *   J
	 *
	 * F: BELOW
	 * G: ALIGN_TOPS
	 * H: CENTER
	 * I: ALIGN_BOTTOMS
	 * J: ABOVE
	 * </pre>
	 *
	 * @param {string} xPosition
	 * @param {string} yPosition
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetX
	 * @description
	 * Sets the value of the offset in the x-direction.
	 *
	 * @param {string|number} offsetX
	 * @returns {!MdPanelPosition}
	 *//**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetY
	 * @description
	 * Sets the value of the offset in the y-direction.
	 *
	 * @param {string|number} offsetY
	 * @returns {!MdPanelPosition}
	 *//*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************//**
	 * @ngdoc type
	 * @name MdPanelAnimation
	 * @module material.components.panel
	 * @description
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * @usage
	 *
	 * <hljs lang="js">
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .duration(1337)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 * </hljs>
	 *//**
	 * @ngdoc method
	 * @name MdPanelAnimation#openFrom
	 * @description
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 *
	 * @param {string|!Element|!Event|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 *//**
	 * @ngdoc method
	 * @name MdPanelAnimation#closeTo
	 * @description
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 *
	 * @param {string|!Element|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 *//**
	 * @ngdoc method
	 * @name MdPanelAnimation#withAnimation
	 * @description
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used: `$mdPanel.animation.`
	 *  - `SLIDE`: The panel slides in and out from the specified
	 *       elements. It will not fade in or out.
	 *  - `SCALE`: The panel scales in and out. Slide and fade are
	 *       included in this animation.
	 *  - `FADE`: The panel fades in and out.
	 *
	 * Custom classes will by default fade in and out unless
	 * `transition: opacity 1ms` is added to the to custom class.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 *//**
	 * @ngdoc method
	 * @name MdPanelAnimation#duration
	 * @description
	 * Specifies the duration of the animation in milliseconds. The `duration`
	 * method accepts either a number or an object with separate open and close
	 * durations.
	 *
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 *//*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/var MD_PANEL_Z_INDEX=80;var MD_PANEL_HIDDEN='_md-panel-hidden';var FOCUS_TRAP_TEMPLATE=angular.element('<div class="_md-panel-focus-trap" tabindex="0"></div>');var _presets={};/**
	 * A provider that is used for creating presets for the panel API.
	 * @final @constructor @ngInject
	 */function MdPanelProvider(){return{'definePreset':definePreset,'getAllPresets':getAllPresets,'clearPresets':clearPresets,'$get':$getProvider()};}/**
	 * Takes the passed in panel configuration object and adds it to the `_presets`
	 * object at the specified name.
	 * @param {string} name Name of the preset to set.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters available within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */function definePreset(name,preset){if(!name||!preset){throw new Error('mdPanelProvider: The panel preset definition is '+'malformed. The name and preset object are required.');}else if(_presets.hasOwnProperty(name)){throw new Error('mdPanelProvider: The panel preset you have requested '+'has already been defined.');}// Delete any property on the preset that is not allowed.
	delete preset.id;delete preset.position;delete preset.animation;_presets[name]=preset;}/**
	 * Gets a clone of the `_presets`.
	 * @return {!Object}
	 */function getAllPresets(){return angular.copy(_presets);}/**
	 * Clears all of the stored presets.
	 */function clearPresets(){_presets={};}/**
	 * Represents the `$get` method of the AngularJS provider. From here, a new
	 * reference to the MdPanelService is returned where the needed arguments are
	 * passed in including the MdPanelProvider `_presets`.
	 * @param {!Object} _presets
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 */function $getProvider(){return['$rootElement','$rootScope','$injector','$window',function($rootElement,$rootScope,$injector,$window){return new MdPanelService(_presets,$rootElement,$rootScope,$injector,$window);}];}/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************//**
	 * A service that is used for controlling/displaying panels on the screen.
	 * @param {!Object} presets
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 * @final @constructor @ngInject
	 */function MdPanelService(presets,$rootElement,$rootScope,$injector,$window){/**
	   * Default config options for the panel.
	   * Anything angular related needs to be done later. Therefore
	   *     scope: $rootScope.$new(true),
	   *     attachTo: $rootElement,
	   * are added later.
	   * @private {!Object}
	   */this._defaultConfigOptions={bindToController:true,clickOutsideToClose:false,disableParentScroll:false,escapeToClose:false,focusOnOpen:true,fullscreen:false,hasBackdrop:false,propagateContainerEvents:false,transformTemplate:angular.bind(this,this._wrapTemplate),trapFocus:false,zIndex:MD_PANEL_Z_INDEX};/** @private {!Object} */this._config={};/** @private {!Object} */this._presets=presets;/** @private @const */this._$rootElement=$rootElement;/** @private @const */this._$rootScope=$rootScope;/** @private @const */this._$injector=$injector;/** @private @const */this._$window=$window;/** @private @const */this._$mdUtil=this._$injector.get('$mdUtil');/** @private {!Object<string, !MdPanelRef>} */this._trackedPanels={};/**
	   * @private {!Object<string,
	   *     {panels: !Array<!MdPanelRef>,
	   *     openPanels: !Array<!MdPanelRef>,
	   *     maxOpen: number}>}
	   */this._groups=Object.create(null);/**
	   * Default animations that can be used within the panel.
	   * @type {enum}
	   */this.animation=MdPanelAnimation.animation;/**
	   * Possible values of xPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */this.xPosition=MdPanelPosition.xPosition;/**
	   * Possible values of yPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */this.yPosition=MdPanelPosition.yPosition;/**
	   * Possible values for the interceptors that can be registered on a panel.
	   * @type {enum}
	   */this.interceptorTypes=MdPanelRef.interceptorTypes;/**
	   * Possible values for closing of a panel.
	   * @type {enum}
	   */this.closeReasons=MdPanelRef.closeReasons;/**
	   * Possible values of absolute position.
	   * @type {enum}
	   */this.absPosition=MdPanelPosition.absPosition;}/**
	 * Creates a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!MdPanelRef}
	 */MdPanelService.prototype.create=function(preset,config){if(typeof preset==='string'){preset=this._getPresetByName(preset);}else if((typeof preset==="undefined"?"undefined":_typeof(preset))==='object'&&(angular.isUndefined(config)||!config)){config=preset;preset={};}preset=preset||{};config=config||{};// If the passed-in config contains an ID and the ID is within _trackedPanels,
	// return the tracked panel after updating its config with the passed-in
	// config.
	if(angular.isDefined(config.id)&&this._trackedPanels[config.id]){var trackedPanel=this._trackedPanels[config.id];angular.extend(trackedPanel.config,config);return trackedPanel;}// Combine the passed-in config, the _defaultConfigOptions, and the preset
	// configuration into the `_config`.
	this._config=angular.extend({// If no ID is set within the passed-in config, then create an arbitrary ID.
	id:config.id||'panel_'+this._$mdUtil.nextUid(),scope:this._$rootScope.$new(true),attachTo:this._$rootElement},this._defaultConfigOptions,config,preset);// Create the panelRef and add it to the `_trackedPanels` object.
	var panelRef=new MdPanelRef(this._config,this._$injector);this._trackedPanels[config.id]=panelRef;// Add the panel to each of its requested groups.
	if(this._config.groupName){if(angular.isString(this._config.groupName)){this._config.groupName=[this._config.groupName];}angular.forEach(this._config.groupName,function(group){panelRef.addToGroup(group);});}this._config.scope.$on('$destroy',angular.bind(panelRef,panelRef.detach));return panelRef;};/**
	 * Creates and opens a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} The panel created from create.
	 */MdPanelService.prototype.open=function(preset,config){var panelRef=this.create(preset,config);return panelRef.open().then(function(){return panelRef;});};/**
	 * Gets a specific preset configuration object saved within `_presets`.
	 * @param {string} preset Name of the preset to search for.
	 * @returns {!Object} The preset configuration object.
	 */MdPanelService.prototype._getPresetByName=function(preset){if(!this._presets[preset]){throw new Error('mdPanel: The panel preset configuration that you '+'requested does not exist. Use the $mdPanelProvider to create a '+'preset before requesting one.');}return this._presets[preset];};/**
	 * Returns a new instance of the MdPanelPosition. Use this to create the
	 * positioning object.
	 * @returns {!MdPanelPosition}
	 */MdPanelService.prototype.newPanelPosition=function(){return new MdPanelPosition(this._$injector);};/**
	 * Returns a new instance of the MdPanelAnimation. Use this to create the
	 * animation object.
	 * @returns {!MdPanelAnimation}
	 */MdPanelService.prototype.newPanelAnimation=function(){return new MdPanelAnimation(this._$injector);};/**
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 * @param groupName {string} Name of the group to create.
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed
	 *     open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */MdPanelService.prototype.newPanelGroup=function(groupName,config){if(!this._groups[groupName]){config=config||{};var group={panels:[],openPanels:[],maxOpen:config.maxOpen>0?config.maxOpen:Infinity};this._groups[groupName]=group;}return this._groups[groupName];};/**
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */MdPanelService.prototype.setGroupMaxOpen=function(groupName,maxOpen){if(this._groups[groupName]){this._groups[groupName].maxOpen=maxOpen;}else{throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');}};/**
	 * Determines if the current number of open panels within a group exceeds the
	 * limit of allowed open panels.
	 * @param {string} groupName The name of the group to check.
	 * @returns {boolean} true if open count does exceed maxOpen and false if not.
	 * @private
	 */MdPanelService.prototype._openCountExceedsMaxOpen=function(groupName){if(this._groups[groupName]){var group=this._groups[groupName];return group.maxOpen>0&&group.openPanels.length>group.maxOpen;}return false;};/**
	 * Closes the first open panel within a specific group.
	 * @param {string} groupName The name of the group.
	 * @private
	 */MdPanelService.prototype._closeFirstOpenedPanel=function(groupName){this._groups[groupName].openPanels[0].close();};/**
	 * Wraps the users template in two elements, md-panel-outer-wrapper, which
	 * covers the entire attachTo element, and md-panel, which contains only the
	 * template. This allows the panel control over positioning, animations,
	 * and similar properties.
	 * @param {string} origTemplate The original template.
	 * @returns {string} The wrapped template.
	 * @private
	 */MdPanelService.prototype._wrapTemplate=function(origTemplate){var template=origTemplate||'';// The panel should be initially rendered offscreen so we can calculate
	// height and width for positioning.
	return''+'<div class="md-panel-outer-wrapper">'+'  <div class="md-panel _md-panel-offscreen">'+template+'</div>'+'</div>';};/**
	 * Wraps a content element in a md-panel-outer wrapper and
	 * positions it off-screen. Allows for proper control over positoning
	 * and animations.
	 * @param {!angular.JQLite} contentElement Element to be wrapped.
	 * @return {!angular.JQLite} Wrapper element.
	 * @private
	 */MdPanelService.prototype._wrapContentElement=function(contentElement){var wrapper=angular.element('<div class="md-panel-outer-wrapper">');contentElement.addClass('md-panel _md-panel-offscreen');wrapper.append(contentElement);return wrapper;};/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************//**
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with properties/functions used to control the panel.
	 * @param {!Object} config
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */function MdPanelRef(config,$injector){// Injected variables.
	/** @private @const {!angular.$q} */this._$q=$injector.get('$q');/** @private @const {!angular.$mdCompiler} */this._$mdCompiler=$injector.get('$mdCompiler');/** @private @const {!angular.$mdConstant} */this._$mdConstant=$injector.get('$mdConstant');/** @private @const {!angular.$mdUtil} */this._$mdUtil=$injector.get('$mdUtil');/** @private @const {!angular.$mdTheming} */this._$mdTheming=$injector.get('$mdTheming');/** @private @const {!angular.Scope} */this._$rootScope=$injector.get('$rootScope');/** @private @const {!angular.$animate} */this._$animate=$injector.get('$animate');/** @private @const {!MdPanelRef} */this._$mdPanel=$injector.get('$mdPanel');/** @private @const {!angular.$log} */this._$log=$injector.get('$log');/** @private @const {!angular.$window} */this._$window=$injector.get('$window');/** @private @const {!Function} */this._$$rAF=$injector.get('$$rAF');// Public variables.
	/**
	   * Unique id for the panelRef.
	   * @type {string}
	   */this.id=config.id;/** @type {!Object} */this.config=config;/** @type {!angular.JQLite|undefined} */this.panelContainer;/** @type {!angular.JQLite|undefined} */this.panelEl;/**
	   * Whether the panel is attached. This is synchronous. When attach is called,
	   * isAttached is set to true. When detach is called, isAttached is set to
	   * false.
	   * @type {boolean}
	   */this.isAttached=false;// Private variables.
	/** @private {Array<function()>} */this._removeListeners=[];/** @private {!angular.JQLite|undefined} */this._topFocusTrap;/** @private {!angular.JQLite|undefined} */this._bottomFocusTrap;/** @private {!$mdPanel|undefined} */this._backdropRef;/** @private {Function?} */this._restoreScroll=null;/**
	   * Keeps track of all the panel interceptors.
	   * @private {!Object}
	   */this._interceptors=Object.create(null);/**
	   * Cleanup function, provided by `$mdCompiler` and assigned after the element
	   * has been compiled. When `contentElement` is used, the function is used to
	   * restore the element to it's proper place in the DOM.
	   * @private {!Function}
	   */this._compilerCleanup=null;/**
	   * Cache for saving and restoring element inline styles, CSS classes etc.
	   * @type {{styles: string, classes: string}}
	   */this._restoreCache={styles:'',classes:''};}MdPanelRef.interceptorTypes={CLOSE:'onClose'};/**
	 * Opens an already created and configured panel. If the panel is already
	 * visible, does nothing.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is opened and animations finish.
	 */MdPanelRef.prototype.open=function(){var self=this;return this._$q(function(resolve,reject){var done=self._done(resolve,self);var show=self._simpleBind(self.show,self);var checkGroupMaxOpen=function checkGroupMaxOpen(){if(self.config.groupName){angular.forEach(self.config.groupName,function(group){if(self._$mdPanel._openCountExceedsMaxOpen(group)){self._$mdPanel._closeFirstOpenedPanel(group);}});}};self.attach().then(show).then(checkGroupMaxOpen).then(done).catch(reject);});};/**
	 * Closes the panel.
	 * @param {string} closeReason The event type that triggered the close.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is closed and animations finish.
	 */MdPanelRef.prototype.close=function(closeReason){var self=this;return this._$q(function(resolve,reject){self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function(){var done=self._done(resolve,self);var detach=self._simpleBind(self.detach,self);var onCloseSuccess=self.config['onCloseSuccess']||angular.noop;onCloseSuccess=angular.bind(self,onCloseSuccess,self,closeReason);self.hide().then(detach).then(done).then(onCloseSuccess).catch(reject);},reject);});};/**
	 * Attaches the panel. The panel will be hidden afterwards.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is attached.
	 */MdPanelRef.prototype.attach=function(){if(this.isAttached&&this.panelEl){return this._$q.when(this);}var self=this;return this._$q(function(resolve,reject){var done=self._done(resolve,self);var onDomAdded=self.config['onDomAdded']||angular.noop;var addListeners=function addListeners(response){self.isAttached=true;self._addEventListeners();return response;};self._$q.all([self._createBackdrop(),self._createPanel().then(addListeners).catch(reject)]).then(onDomAdded).then(done).catch(reject);});};/**
	 * Only detaches the panel. Will NOT hide the panel first.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is detached.
	 */MdPanelRef.prototype.detach=function(){if(!this.isAttached){return this._$q.when(this);}var self=this;var onDomRemoved=self.config['onDomRemoved']||angular.noop;var detachFn=function detachFn(){self._removeEventListeners();// Remove the focus traps that we added earlier for keeping focus within
	// the panel.
	if(self._topFocusTrap&&self._topFocusTrap.parentNode){self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);}if(self._bottomFocusTrap&&self._bottomFocusTrap.parentNode){self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);}if(self._restoreCache.classes){self.panelEl[0].className=self._restoreCache.classes;}// Either restore the saved styles or clear the ones set by mdPanel.
	self.panelEl[0].style.cssText=self._restoreCache.styles||'';self._compilerCleanup();self.panelContainer.remove();self.isAttached=false;return self._$q.when(self);};if(this._restoreScroll){this._restoreScroll();this._restoreScroll=null;}return this._$q(function(resolve,reject){var done=self._done(resolve,self);self._$q.all([detachFn(),self._backdropRef?self._backdropRef.detach():true]).then(onDomRemoved).then(done).catch(reject);});};/**
	 * Destroys the panel. The Panel cannot be opened again after this.
	 */MdPanelRef.prototype.destroy=function(){var self=this;if(this.config.groupName){angular.forEach(this.config.groupName,function(group){self.removeFromGroup(group);});}this.config.scope.$destroy();this.config.locals=null;this.config.onDomAdded=null;this.config.onDomRemoved=null;this.config.onRemoving=null;this.config.onOpenComplete=null;this._interceptors=null;};/**
	 * Shows the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has shown and animations finish.
	 */MdPanelRef.prototype.show=function(){if(!this.panelContainer){return this._$q(function(resolve,reject){reject('mdPanel: Panel does not exist yet. Call open() or attach().');});}if(!this.panelContainer.hasClass(MD_PANEL_HIDDEN)){return this._$q.when(this);}var self=this;var animatePromise=function animatePromise(){self.panelContainer.removeClass(MD_PANEL_HIDDEN);return self._animateOpen();};return this._$q(function(resolve,reject){var done=self._done(resolve,self);var onOpenComplete=self.config['onOpenComplete']||angular.noop;var addToGroupOpen=function addToGroupOpen(){if(self.config.groupName){angular.forEach(self.config.groupName,function(group){self._$mdPanel._groups[group].openPanels.push(self);});}};self._$q.all([self._backdropRef?self._backdropRef.show():self,animatePromise().then(function(){self._focusOnOpen();},reject)]).then(onOpenComplete).then(addToGroupOpen).then(done).catch(reject);});};/**
	 * Hides the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has hidden and animations finish.
	 */MdPanelRef.prototype.hide=function(){if(!this.panelContainer){return this._$q(function(resolve,reject){reject('mdPanel: Panel does not exist yet. Call open() or attach().');});}if(this.panelContainer.hasClass(MD_PANEL_HIDDEN)){return this._$q.when(this);}var self=this;return this._$q(function(resolve,reject){var done=self._done(resolve,self);var onRemoving=self.config['onRemoving']||angular.noop;var hidePanel=function hidePanel(){self.panelContainer.addClass(MD_PANEL_HIDDEN);};var removeFromGroupOpen=function removeFromGroupOpen(){if(self.config.groupName){var group,index;angular.forEach(self.config.groupName,function(group){group=self._$mdPanel._groups[group];index=group.openPanels.indexOf(self);if(index>-1){group.openPanels.splice(index,1);}});}};var focusOnOrigin=function focusOnOrigin(){var origin=self.config['origin'];if(origin){getElement(origin).focus();}};self._$q.all([self._backdropRef?self._backdropRef.hide():self,self._animateClose().then(onRemoving).then(hidePanel).then(removeFromGroupOpen).then(focusOnOrigin).catch(reject)]).then(done,reject);});};/**
	 * Add a class to the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} newClass Class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */MdPanelRef.prototype.addClass=function(newClass,toElement){this._$log.warn('mdPanel: The addClass method is in the process of being deprecated. '+'Full deprecation is scheduled for the AngularJS Material 1.2 release. '+'To achieve the same results, use the panelContainer or panelEl '+'JQLite elements that are referenced in MdPanelRef.');if(!this.panelContainer){throw new Error('mdPanel: Panel does not exist yet. Call open() or attach().');}if(!toElement&&!this.panelContainer.hasClass(newClass)){this.panelContainer.addClass(newClass);}else if(toElement&&!this.panelEl.hasClass(newClass)){this.panelEl.addClass(newClass);}};/**
	 * Remove a class from the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */MdPanelRef.prototype.removeClass=function(oldClass,fromElement){this._$log.warn('mdPanel: The removeClass method is in the process of being deprecated. '+'Full deprecation is scheduled for the AngularJS Material 1.2 release. '+'To achieve the same results, use the panelContainer or panelEl '+'JQLite elements that are referenced in MdPanelRef.');if(!this.panelContainer){throw new Error('mdPanel: Panel does not exist yet. Call open() or attach().');}if(!fromElement&&this.panelContainer.hasClass(oldClass)){this.panelContainer.removeClass(oldClass);}else if(fromElement&&this.panelEl.hasClass(oldClass)){this.panelEl.removeClass(oldClass);}};/**
	 * Toggle a class on the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} toggleClass The class to toggle.
	 * @param {boolean} onElement Whether or not to toggle the class on the panel
	 *     element instead of the container.
	 */MdPanelRef.prototype.toggleClass=function(toggleClass,onElement){this._$log.warn('mdPanel: The toggleClass method is in the process of being deprecated. '+'Full deprecation is scheduled for the AngularJS Material 1.2 release. '+'To achieve the same results, use the panelContainer or panelEl '+'JQLite elements that are referenced in MdPanelRef.');if(!this.panelContainer){throw new Error('mdPanel: Panel does not exist yet. Call open() or attach().');}if(!onElement){this.panelContainer.toggleClass(toggleClass);}else{this.panelEl.toggleClass(toggleClass);}};/**
	 * Compiles the panel, according to the passed in config and appends it to
	 * the DOM. Helps normalize differences in the compilation process between
	 * using a string template and a content element.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} Promise that is resolved when
	 *     the element has been compiled and added to the DOM.
	 * @private
	 */MdPanelRef.prototype._compile=function(){var self=this;// Compile the element via $mdCompiler. Note that when using a
	// contentElement, the element isn't actually being compiled, rather the
	// compiler saves it's place in the DOM and provides a way of restoring it.
	return self._$mdCompiler.compile(self.config).then(function(compileData){var config=self.config;if(config.contentElement){var panelEl=compileData.element;// Since mdPanel modifies the inline styles and CSS classes, we need
	// to save them in order to be able to restore on close.
	self._restoreCache.styles=panelEl[0].style.cssText;self._restoreCache.classes=panelEl[0].className;self.panelContainer=self._$mdPanel._wrapContentElement(panelEl);self.panelEl=panelEl;}else{self.panelContainer=compileData.link(config['scope']);self.panelEl=angular.element(self.panelContainer[0].querySelector('.md-panel'));}// Save a reference to the cleanup function from the compiler.
	self._compilerCleanup=compileData.cleanup;// Attach the panel to the proper place in the DOM.
	getElement(self.config['attachTo']).append(self.panelContainer);return self;});};/**
	 * Creates a panel and adds it to the dom.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     created.
	 * @private
	 */MdPanelRef.prototype._createPanel=function(){var self=this;return this._$q(function(resolve,reject){if(!self.config.locals){self.config.locals={};}self.config.locals.mdPanelRef=self;self._compile().then(function(){if(self.config['disableParentScroll']){self._restoreScroll=self._$mdUtil.disableScrollAround(null,self.panelContainer,{disableScrollMask:true});}// Add a custom CSS class to the panel element.
	if(self.config['panelClass']){self.panelEl.addClass(self.config['panelClass']);}// Handle click and touch events for the panel container.
	if(self.config['propagateContainerEvents']){self.panelContainer.css('pointer-events','none');self.panelEl.css('pointer-events','all');}// Panel may be outside the $rootElement, tell ngAnimate to animate
	// regardless.
	if(self._$animate.pin){self._$animate.pin(self.panelContainer,getElement(self.config['attachTo']));}self._configureTrapFocus();self._addStyles().then(function(){resolve(self);},reject);},reject);});};/**
	 * Adds the styles for the panel, such as positioning and z-index. Also,
	 * themes the panel element and panel container using `$mdTheming`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */MdPanelRef.prototype._addStyles=function(){var self=this;return this._$q(function(resolve){self.panelContainer.css('z-index',self.config['zIndex']);self.panelEl.css('z-index',self.config['zIndex']+1);var hideAndResolve=function hideAndResolve(){// Theme the element and container.
	self._setTheming();// Remove offscreen class and add hidden class.
	self.panelEl.removeClass('_md-panel-offscreen');self.panelContainer.addClass(MD_PANEL_HIDDEN);resolve(self);};if(self.config['fullscreen']){self.panelEl.addClass('_md-panel-fullscreen');hideAndResolve();return;// Don't setup positioning.
	}var positionConfig=self.config['position'];if(!positionConfig){hideAndResolve();return;// Don't setup positioning.
	}// Wait for angular to finish processing the template
	self._$rootScope['$$postDigest'](function(){// Position it correctly. This is necessary so that the panel will have a
	// defined height and width.
	self._updatePosition(true);// Theme the element and container.
	self._setTheming();resolve(self);});});};/**
	 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
	 * @private
	 */MdPanelRef.prototype._setTheming=function(){this._$mdTheming(this.panelEl);this._$mdTheming(this.panelContainer);};/**
	 * Updates the position configuration of a panel
	 * @param {!MdPanelPosition} position
	 */MdPanelRef.prototype.updatePosition=function(position){if(!this.panelContainer){throw new Error('mdPanel: Panel does not exist yet. Call open() or attach().');}this.config['position']=position;this._updatePosition();};/**
	 * Calculates and updates the position of the panel.
	 * @param {boolean=} init
	 * @private
	 */MdPanelRef.prototype._updatePosition=function(init){var positionConfig=this.config['position'];if(positionConfig){positionConfig._setPanelPosition(this.panelEl);// Hide the panel now that position is known.
	if(init){this.panelEl.removeClass('_md-panel-offscreen');this.panelContainer.addClass(MD_PANEL_HIDDEN);}this.panelEl.css(MdPanelPosition.absPosition.TOP,positionConfig.getTop());this.panelEl.css(MdPanelPosition.absPosition.BOTTOM,positionConfig.getBottom());this.panelEl.css(MdPanelPosition.absPosition.LEFT,positionConfig.getLeft());this.panelEl.css(MdPanelPosition.absPosition.RIGHT,positionConfig.getRight());}};/**
	 * Focuses on the panel or the first focus target.
	 * @private
	 */MdPanelRef.prototype._focusOnOpen=function(){if(this.config['focusOnOpen']){// Wait for the template to finish rendering to guarantee md-autofocus has
	// finished adding the class md-autofocus, otherwise the focusable element
	// isn't available to focus.
	var self=this;this._$rootScope['$$postDigest'](function(){var target=self._$mdUtil.findFocusTarget(self.panelEl)||self.panelEl;target.focus();});}};/**
	 * Shows the backdrop.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the backdrop
	 *     is created and attached.
	 * @private
	 */MdPanelRef.prototype._createBackdrop=function(){if(this.config.hasBackdrop){if(!this._backdropRef){var backdropAnimation=this._$mdPanel.newPanelAnimation().openFrom(this.config.attachTo).withAnimation({open:'_md-opaque-enter',close:'_md-opaque-leave'});if(this.config.animation){backdropAnimation.duration(this.config.animation._rawDuration);}var backdropConfig={animation:backdropAnimation,attachTo:this.config.attachTo,focusOnOpen:false,panelClass:'_md-panel-backdrop',zIndex:this.config.zIndex-1};this._backdropRef=this._$mdPanel.create(backdropConfig);}if(!this._backdropRef.isAttached){return this._backdropRef.attach();}}};/**
	 * Listen for escape keys and outside clicks to auto close.
	 * @private
	 */MdPanelRef.prototype._addEventListeners=function(){this._configureEscapeToClose();this._configureClickOutsideToClose();this._configureScrollListener();};/**
	 * Remove event listeners added in _addEventListeners.
	 * @private
	 */MdPanelRef.prototype._removeEventListeners=function(){this._removeListeners&&this._removeListeners.forEach(function(removeFn){removeFn();});this._removeListeners=[];};/**
	 * Setup the escapeToClose event listeners.
	 * @private
	 */MdPanelRef.prototype._configureEscapeToClose=function(){if(this.config['escapeToClose']){var parentTarget=getElement(this.config['attachTo']);var self=this;var keyHandlerFn=function keyHandlerFn(ev){if(ev.keyCode===self._$mdConstant.KEY_CODE.ESCAPE){ev.stopPropagation();ev.preventDefault();self.close(MdPanelRef.closeReasons.ESCAPE);}};// Add keydown listeners
	this.panelContainer.on('keydown',keyHandlerFn);parentTarget.on('keydown',keyHandlerFn);// Queue remove listeners function
	this._removeListeners.push(function(){self.panelContainer.off('keydown',keyHandlerFn);parentTarget.off('keydown',keyHandlerFn);});}};/**
	 * Setup the clickOutsideToClose event listeners.
	 * @private
	 */MdPanelRef.prototype._configureClickOutsideToClose=function(){if(this.config['clickOutsideToClose']){var target=this.config['propagateContainerEvents']?angular.element(document.body):this.panelContainer;var sourceEl;// Keep track of the element on which the mouse originally went down
	// so that we can only close the backdrop when the 'click' started on it.
	// A simple 'click' handler does not work, it sets the target object as the
	// element the mouse went down on.
	var mousedownHandler=function mousedownHandler(ev){sourceEl=ev.target;};// We check if our original element and the target is the backdrop
	// because if the original was the backdrop and the target was inside the
	// panel we don't want to panel to close.
	var self=this;var mouseupHandler=function mouseupHandler(ev){if(self.config['propagateContainerEvents']){// We check if the sourceEl of the event is the panel element or one
	// of it's children. If it is not, then close the panel.
	if(sourceEl!==self.panelEl[0]&&!self.panelEl[0].contains(sourceEl)){self.close();}}else if(sourceEl===target[0]&&ev.target===target[0]){ev.stopPropagation();ev.preventDefault();self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);}};// Add listeners
	target.on('mousedown',mousedownHandler);target.on('mouseup',mouseupHandler);// Queue remove listeners function
	this._removeListeners.push(function(){target.off('mousedown',mousedownHandler);target.off('mouseup',mouseupHandler);});}};/**
	 * Configures the listeners for updating the panel position on scroll.
	 * @private
	*/MdPanelRef.prototype._configureScrollListener=function(){// No need to bind the event if scrolling is disabled.
	if(!this.config['disableParentScroll']){var updatePosition=angular.bind(this,this._updatePosition);var debouncedUpdatePosition=this._$$rAF.throttle(updatePosition);var self=this;var onScroll=function onScroll(){debouncedUpdatePosition();};// Add listeners.
	this._$window.addEventListener('scroll',onScroll,true);// Queue remove listeners function.
	this._removeListeners.push(function(){self._$window.removeEventListener('scroll',onScroll,true);});}};/**
	 * Setup the focus traps. These traps will wrap focus when tabbing past the
	 * panel. When shift-tabbing, the focus will stick in place.
	 * @private
	 */MdPanelRef.prototype._configureTrapFocus=function(){// Focus doesn't remain inside of the panel without this.
	this.panelEl.attr('tabIndex','-1');if(this.config['trapFocus']){var element=this.panelEl;// Set up elements before and after the panel to capture focus and
	// redirect back into the panel.
	this._topFocusTrap=FOCUS_TRAP_TEMPLATE.clone()[0];this._bottomFocusTrap=FOCUS_TRAP_TEMPLATE.clone()[0];// When focus is about to move out of the panel, we want to intercept it
	// and redirect it back to the panel element.
	var focusHandler=function focusHandler(){element.focus();};this._topFocusTrap.addEventListener('focus',focusHandler);this._bottomFocusTrap.addEventListener('focus',focusHandler);// Queue remove listeners function
	this._removeListeners.push(this._simpleBind(function(){this._topFocusTrap.removeEventListener('focus',focusHandler);this._bottomFocusTrap.removeEventListener('focus',focusHandler);},this));// The top focus trap inserted immediately before the md-panel element (as
	// a sibling). The bottom focus trap inserted immediately after the
	// md-panel element (as a sibling).
	element[0].parentNode.insertBefore(this._topFocusTrap,element[0]);element.after(this._bottomFocusTrap);}};/**
	 * Updates the animation of a panel.
	 * @param {!MdPanelAnimation} animation
	 */MdPanelRef.prototype.updateAnimation=function(animation){this.config['animation']=animation;if(this._backdropRef){this._backdropRef.config.animation.duration(animation._rawDuration);}};/**
	 * Animate the panel opening.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated open.
	 * @private
	 */MdPanelRef.prototype._animateOpen=function(){this.panelContainer.addClass('md-panel-is-showing');var animationConfig=this.config['animation'];if(!animationConfig){// Promise is in progress, return it.
	this.panelContainer.addClass('_md-panel-shown');return this._$q.when(this);}var self=this;return this._$q(function(resolve){var done=self._done(resolve,self);var warnAndOpen=function warnAndOpen(){self._$log.warn('mdPanel: MdPanel Animations failed. '+'Showing panel without animating.');done();};animationConfig.animateOpen(self.panelEl).then(done,warnAndOpen);});};/**
	 * Animate the panel closing.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated closed.
	 * @private
	 */MdPanelRef.prototype._animateClose=function(){var animationConfig=this.config['animation'];if(!animationConfig){this.panelContainer.removeClass('md-panel-is-showing');this.panelContainer.removeClass('_md-panel-shown');return this._$q.when(this);}var self=this;return this._$q(function(resolve){var done=function done(){self.panelContainer.removeClass('md-panel-is-showing');resolve(self);};var warnAndClose=function warnAndClose(){self._$log.warn('mdPanel: MdPanel Animations failed. '+'Hiding panel without animating.');done();};animationConfig.animateClose(self.panelEl).then(done,warnAndClose);});};/**
	 * Registers a interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected.
	 * @param {string} type Type of interceptor.
	 * @param {!angular.$q.Promise<!any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */MdPanelRef.prototype.registerInterceptor=function(type,callback){var error=null;if(!angular.isString(type)){error='Interceptor type must be a string, instead got '+(typeof type==="undefined"?"undefined":_typeof(type));}else if(!angular.isFunction(callback)){error='Interceptor callback must be a function, instead got '+(typeof callback==="undefined"?"undefined":_typeof(callback));}if(error){throw new Error('MdPanel: '+error);}var interceptors=this._interceptors[type]=this._interceptors[type]||[];if(interceptors.indexOf(callback)===-1){interceptors.push(callback);}return this;};/**
	 * Removes a registered interceptor.
	 * @param {string} type Type of interceptor to be removed.
	 * @param {Function} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */MdPanelRef.prototype.removeInterceptor=function(type,callback){var index=this._interceptors[type]?this._interceptors[type].indexOf(callback):-1;if(index>-1){this._interceptors[type].splice(index,1);}return this;};/**
	 * Removes all interceptors.
	 * @param {string=} type Type of interceptors to be removed.
	 *     If ommited, all interceptors types will be removed.
	 * @returns {!MdPanelRef}
	 */MdPanelRef.prototype.removeAllInterceptors=function(type){if(type){this._interceptors[type]=[];}else{this._interceptors=Object.create(null);}return this;};/**
	 * Invokes all the interceptors of a certain type sequantially in
	 *     reverse order. Works in a similar way to `$q.all`, except it
	 *     respects the order of the functions.
	 * @param {string} type Type of interceptors to be invoked.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */MdPanelRef.prototype._callInterceptors=function(type){var self=this;var $q=self._$q;var interceptors=self._interceptors&&self._interceptors[type]||[];return interceptors.reduceRight(function(promise,interceptor){var isPromiseLike=interceptor&&angular.isFunction(interceptor.then);var response=isPromiseLike?interceptor:null;/**
	    * For interceptors to reject/cancel subsequent portions of the chain, simply
	    * return a `$q.reject(<value>)`
	    */return promise.then(function(){if(!response){try{response=interceptor(self);}catch(e){response=$q.reject(e);}}return response;});},$q.resolve(self));};/**
	 * Faster, more basic than angular.bind
	 * http://jsperf.com/angular-bind-vs-custom-vs-native
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a bound self.
	 */MdPanelRef.prototype._simpleBind=function(callback,self){return function(value){return callback.apply(self,value);};};/**
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a self param.
	 */MdPanelRef.prototype._done=function(callback,self){return function(){callback(self);};};/**
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 * @param {string} groupName The name of the group.
	 */MdPanelRef.prototype.addToGroup=function(groupName){if(!this._$mdPanel._groups[groupName]){this._$mdPanel.newPanelGroup(groupName);}var group=this._$mdPanel._groups[groupName];var index=group.panels.indexOf(this);if(index<0){group.panels.push(this);}};/**
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 * @param {string} groupName The name of the group.
	 */MdPanelRef.prototype.removeFromGroup=function(groupName){if(!this._$mdPanel._groups[groupName]){throw new Error('mdPanel: The group '+groupName+' does not exist.');}var group=this._$mdPanel._groups[groupName];var index=group.panels.indexOf(this);if(index>-1){group.panels.splice(index,1);}};/**
	 * Possible default closeReasons for the close function.
	 * @enum {string}
	 */MdPanelRef.closeReasons={CLICK_OUTSIDE:'clickOutsideToClose',ESCAPE:'escapeToClose'};/*****************************************************************************
	 *                               MdPanelPosition                             *
	 *****************************************************************************//**
	 * Position configuration object. To use, create an MdPanelPosition with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelPosition = new MdPanelPosition()
	 *     .relativeTo(myButtonEl)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.CENTER,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 *
	 * $mdPanel.create({
	 *   position: panelPosition
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */function MdPanelPosition($injector){/** @private @const {!angular.$window} */this._$window=$injector.get('$window');/** @private {boolean} */this._isRTL=$injector.get('$mdUtil').bidi()==='rtl';/** @private @const {!angular.$mdConstant} */this._$mdConstant=$injector.get('$mdConstant');/** @private {boolean} */this._absolute=false;/** @private {!angular.JQLite} */this._relativeToEl;/** @private {string} */this._top='';/** @private {string} */this._bottom='';/** @private {string} */this._left='';/** @private {string} */this._right='';/** @private {!Array<string>} */this._translateX=[];/** @private {!Array<string>} */this._translateY=[];/** @private {!Array<{x:string, y:string}>} */this._positions=[];/** @private {?{x:string, y:string}} */this._actualPosition;}/**
	 * Possible values of xPosition.
	 * @enum {string}
	 */MdPanelPosition.xPosition={CENTER:'center',ALIGN_START:'align-start',ALIGN_END:'align-end',OFFSET_START:'offset-start',OFFSET_END:'offset-end'};/**
	 * Possible values of yPosition.
	 * @enum {string}
	 */MdPanelPosition.yPosition={CENTER:'center',ALIGN_TOPS:'align-tops',ALIGN_BOTTOMS:'align-bottoms',ABOVE:'above',BELOW:'below'};/**
	 * Possible values of absolute position.
	 * @enum {string}
	 */MdPanelPosition.absPosition={TOP:'top',RIGHT:'right',BOTTOM:'bottom',LEFT:'left'};/**
	 * Margin between the edges of a panel and the viewport.
	 * @const {number}
	 */MdPanelPosition.viewportMargin=8;/**
	 * Sets absolute positioning for the panel.
	 * @return {!MdPanelPosition}
	 */MdPanelPosition.prototype.absolute=function(){this._absolute=true;return this;};/**
	 * Sets the value of a position for the panel. Clears any previously set
	 * position.
	 * @param {string} position Position to set
	 * @param {string=} value Value of the position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 * @private
	 */MdPanelPosition.prototype._setPosition=function(position,value){if(position===MdPanelPosition.absPosition.RIGHT||position===MdPanelPosition.absPosition.LEFT){this._left=this._right='';}else if(position===MdPanelPosition.absPosition.BOTTOM||position===MdPanelPosition.absPosition.TOP){this._top=this._bottom='';}else{var positions=Object.keys(MdPanelPosition.absPosition).join().toLowerCase();throw new Error('mdPanel: Position must be one of '+positions+'.');}this['_'+position]=angular.isString(value)?value:'0';return this;};/**
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.top=function(top){return this._setPosition(MdPanelPosition.absPosition.TOP,top);};/**
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.bottom=function(bottom){return this._setPosition(MdPanelPosition.absPosition.BOTTOM,bottom);};/**
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.start=function(start){var position=this._isRTL?MdPanelPosition.absPosition.RIGHT:MdPanelPosition.absPosition.LEFT;return this._setPosition(position,start);};/**
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.end=function(end){var position=this._isRTL?MdPanelPosition.absPosition.LEFT:MdPanelPosition.absPosition.RIGHT;return this._setPosition(position,end);};/**
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.left=function(left){return this._setPosition(MdPanelPosition.absPosition.LEFT,left);};/**
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	*/MdPanelPosition.prototype.right=function(right){return this._setPosition(MdPanelPosition.absPosition.RIGHT,right);};/**
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.centerHorizontally=function(){this._left='50%';this._right='';this._translateX=['-50%'];return this;};/**
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.centerVertically=function(){this._top='50%';this._bottom='';this._translateY=['-50%'];return this;};/**
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.center=function(){return this.centerHorizontally().centerVertically();};/**
	 * Sets element for relative positioning.
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to set the panel relative to.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.relativeTo=function(element){this._absolute=false;this._relativeToEl=getElement(element);return this;};/**
	 * Sets the x and y positions for the panel relative to another element.
	 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
	 *     values.
	 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
	 *     values.
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.addPanelPosition=function(xPosition,yPosition){if(!this._relativeToEl){throw new Error('mdPanel: addPanelPosition can only be used with '+'relative positioning. Set relativeTo first.');}this._validateXPosition(xPosition);this._validateYPosition(yPosition);this._positions.push({x:xPosition,y:yPosition});return this;};/**
	 * Ensures that yPosition is a valid position name. Throw an exception if not.
	 * @param {string} yPosition
	 */MdPanelPosition.prototype._validateYPosition=function(yPosition){// empty is ok
	if(yPosition==null){return;}var positionKeys=Object.keys(MdPanelPosition.yPosition);var positionValues=[];for(var key,i=0;key=positionKeys[i];i++){var position=MdPanelPosition.yPosition[key];positionValues.push(position);if(position===yPosition){return;}}throw new Error('mdPanel: Panel y position only accepts the following '+'values:\n'+positionValues.join(' | '));};/**
	 * Ensures that xPosition is a valid position name. Throw an exception if not.
	 * @param {string} xPosition
	 */MdPanelPosition.prototype._validateXPosition=function(xPosition){// empty is ok
	if(xPosition==null){return;}var positionKeys=Object.keys(MdPanelPosition.xPosition);var positionValues=[];for(var key,i=0;key=positionKeys[i];i++){var position=MdPanelPosition.xPosition[key];positionValues.push(position);if(position===xPosition){return;}}throw new Error('mdPanel: Panel x Position only accepts the following '+'values:\n'+positionValues.join(' | '));};/**
	 * Sets the value of the offset in the x-direction. This will add to any
	 * previously set offsets.
	 * @param {string|number|function(MdPanelPosition): string} offsetX
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.withOffsetX=function(offsetX){this._translateX.push(addUnits(offsetX));return this;};/**
	 * Sets the value of the offset in the y-direction. This will add to any
	 * previously set offsets.
	 * @param {string|number|function(MdPanelPosition): string} offsetY
	 * @returns {!MdPanelPosition}
	 */MdPanelPosition.prototype.withOffsetY=function(offsetY){this._translateY.push(addUnits(offsetY));return this;};/**
	 * Gets the value of `top` for the panel.
	 * @returns {string}
	 */MdPanelPosition.prototype.getTop=function(){return this._top;};/**
	 * Gets the value of `bottom` for the panel.
	 * @returns {string}
	 */MdPanelPosition.prototype.getBottom=function(){return this._bottom;};/**
	 * Gets the value of `left` for the panel.
	 * @returns {string}
	 */MdPanelPosition.prototype.getLeft=function(){return this._left;};/**
	 * Gets the value of `right` for the panel.
	 * @returns {string}
	 */MdPanelPosition.prototype.getRight=function(){return this._right;};/**
	 * Gets the value of `transform` for the panel.
	 * @returns {string}
	 */MdPanelPosition.prototype.getTransform=function(){var translateX=this._reduceTranslateValues('translateX',this._translateX);var translateY=this._reduceTranslateValues('translateY',this._translateY);// It's important to trim the result, because the browser will ignore the set
	// operation if the string contains only whitespace.
	return(translateX+' '+translateY).trim();};/**
	 * Sets the `transform` value for a panel element.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.JQLite}
	 * @private
	 */MdPanelPosition.prototype._setTransform=function(panelEl){return panelEl.css(this._$mdConstant.CSS.TRANSFORM,this.getTransform());};/**
	 * True if the panel is completely on-screen with this positioning; false
	 * otherwise.
	 * @param {!angular.JQLite} panelEl
	 * @return {boolean}
	 * @private
	 */MdPanelPosition.prototype._isOnscreen=function(panelEl){// this works because we always use fixed positioning for the panel,
	// which is relative to the viewport.
	var left=parseInt(this.getLeft());var top=parseInt(this.getTop());if(this._translateX.length||this._translateY.length){var prefixedTransform=this._$mdConstant.CSS.TRANSFORM;var offsets=getComputedTranslations(panelEl,prefixedTransform);left+=offsets.x;top+=offsets.y;}var right=left+panelEl[0].offsetWidth;var bottom=top+panelEl[0].offsetHeight;return left>=0&&top>=0&&bottom<=this._$window.innerHeight&&right<=this._$window.innerWidth;};/**
	 * Gets the first x/y position that can fit on-screen.
	 * @returns {{x: string, y: string}}
	 */MdPanelPosition.prototype.getActualPosition=function(){return this._actualPosition;};/**
	 * Reduces a list of translate values to a string that can be used within
	 * transform.
	 * @param {string} translateFn
	 * @param {!Array<string>} values
	 * @returns {string}
	 * @private
	 */MdPanelPosition.prototype._reduceTranslateValues=function(translateFn,values){return values.map(function(translation){var translationValue=angular.isFunction(translation)?addUnits(translation(this)):translation;return translateFn+'('+translationValue+')';},this).join(' ');};/**
	 * Sets the panel position based on the created panel element and best x/y
	 * positioning.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */MdPanelPosition.prototype._setPanelPosition=function(panelEl){// Remove the "position adjusted" class in case it has been added before.
	panelEl.removeClass('_md-panel-position-adjusted');// Only calculate the position if necessary.
	if(this._absolute){this._setTransform(panelEl);return;}if(this._actualPosition){this._calculatePanelPosition(panelEl,this._actualPosition);this._setTransform(panelEl);this._constrainToViewport(panelEl);return;}for(var i=0;i<this._positions.length;i++){this._actualPosition=this._positions[i];this._calculatePanelPosition(panelEl,this._actualPosition);this._setTransform(panelEl);if(this._isOnscreen(panelEl)){return;}}this._constrainToViewport(panelEl);};/**
	 * Constrains a panel's position to the viewport.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */MdPanelPosition.prototype._constrainToViewport=function(panelEl){var margin=MdPanelPosition.viewportMargin;var initialTop=this._top;var initialLeft=this._left;if(this.getTop()){var top=parseInt(this.getTop());var bottom=panelEl[0].offsetHeight+top;var viewportHeight=this._$window.innerHeight;if(top<margin){this._top=margin+'px';}else if(bottom>viewportHeight){this._top=top-(bottom-viewportHeight+margin)+'px';}}if(this.getLeft()){var left=parseInt(this.getLeft());var right=panelEl[0].offsetWidth+left;var viewportWidth=this._$window.innerWidth;if(left<margin){this._left=margin+'px';}else if(right>viewportWidth){this._left=left-(right-viewportWidth+margin)+'px';}}// Class that can be used to re-style the panel if it was repositioned.
	panelEl.toggleClass('_md-panel-position-adjusted',this._top!==initialTop||this._left!==initialLeft);};/**
	 * Switches between 'start' and 'end'.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} Reversed position
	 * @private
	 */MdPanelPosition.prototype._reverseXPosition=function(position){if(position===MdPanelPosition.xPosition.CENTER){return position;}var start='start';var end='end';return position.indexOf(start)>-1?position.replace(start,end):position.replace(end,start);};/**
	 * Handles horizontal positioning in rtl or ltr environments.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} The correct position according the page direction
	 * @private
	 */MdPanelPosition.prototype._bidi=function(position){return this._isRTL?this._reverseXPosition(position):position;};/**
	 * Calculates the panel position based on the created panel element and the
	 * provided positioning.
	 * @param {!angular.JQLite} panelEl
	 * @param {!{x:string, y:string}} position
	 * @private
	 */MdPanelPosition.prototype._calculatePanelPosition=function(panelEl,position){var panelBounds=panelEl[0].getBoundingClientRect();var panelWidth=Math.max(panelBounds.width,panelEl[0].clientWidth);var panelHeight=Math.max(panelBounds.height,panelEl[0].clientHeight);var targetBounds=this._relativeToEl[0].getBoundingClientRect();var targetLeft=targetBounds.left;var targetRight=targetBounds.right;var targetWidth=targetBounds.width;switch(this._bidi(position.x)){case MdPanelPosition.xPosition.OFFSET_START:this._left=targetLeft-panelWidth+'px';break;case MdPanelPosition.xPosition.ALIGN_END:this._left=targetRight-panelWidth+'px';break;case MdPanelPosition.xPosition.CENTER:var left=targetLeft+0.5*targetWidth-0.5*panelWidth;this._left=left+'px';break;case MdPanelPosition.xPosition.ALIGN_START:this._left=targetLeft+'px';break;case MdPanelPosition.xPosition.OFFSET_END:this._left=targetRight+'px';break;}var targetTop=targetBounds.top;var targetBottom=targetBounds.bottom;var targetHeight=targetBounds.height;switch(position.y){case MdPanelPosition.yPosition.ABOVE:this._top=targetTop-panelHeight+'px';break;case MdPanelPosition.yPosition.ALIGN_BOTTOMS:this._top=targetBottom-panelHeight+'px';break;case MdPanelPosition.yPosition.CENTER:var top=targetTop+0.5*targetHeight-0.5*panelHeight;this._top=top+'px';break;case MdPanelPosition.yPosition.ALIGN_TOPS:this._top=targetTop+'px';break;case MdPanelPosition.yPosition.BELOW:this._top=targetBottom+'px';break;}};/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************//**
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */function MdPanelAnimation($injector){/** @private @const {!angular.$mdUtil} */this._$mdUtil=$injector.get('$mdUtil');/**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */this._openFrom;/**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */this._closeTo;/** @private {string|{open: string, close: string}} */this._animationClass='';/** @private {number} */this._openDuration;/** @private {number} */this._closeDuration;/** @private {number|{open: number, close: number}} */this._rawDuration;}/**
	 * Possible default animations.
	 * @enum {string}
	 */MdPanelAnimation.animation={SLIDE:'md-panel-animate-slide',SCALE:'md-panel-animate-scale',FADE:'md-panel-animate-fade'};/**
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
	 * @returns {!MdPanelAnimation}
	 */MdPanelAnimation.prototype.openFrom=function(openFrom){// Check if 'openFrom' is an Event.
	openFrom=openFrom.target?openFrom.target:openFrom;this._openFrom=this._getPanelAnimationTarget(openFrom);if(!this._closeTo){this._closeTo=this._openFrom;}return this;};/**
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 * @param {string|!Element|{top: number, left: number}} closeTo
	 * @returns {!MdPanelAnimation}
	 */MdPanelAnimation.prototype.closeTo=function(closeTo){this._closeTo=this._getPanelAnimationTarget(closeTo);return this;};/**
	 * Specifies the duration of the animation in milliseconds.
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */MdPanelAnimation.prototype.duration=function(duration){if(duration){if(angular.isNumber(duration)){this._openDuration=this._closeDuration=toSeconds(duration);}else if(angular.isObject(duration)){this._openDuration=toSeconds(duration.open);this._closeDuration=toSeconds(duration.close);}}// Save the original value so it can be passed to the backdrop.
	this._rawDuration=duration;return this;function toSeconds(value){if(angular.isNumber(value))return value/1000;}};/**
	 * Returns the element and bounds for the animation target.
	 * @param {string|!Element|{top: number, left: number}} location
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */MdPanelAnimation.prototype._getPanelAnimationTarget=function(location){if(angular.isDefined(location.top)||angular.isDefined(location.left)){return{element:undefined,bounds:{top:location.top||0,left:location.left||0}};}else{return this._getBoundingClientRect(getElement(location));}};/**
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * (MdPanelAnimation.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *        elements.
	 *   SCALE: The panel scales in and out.
	 *   FADE: The panel fades in and out.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */MdPanelAnimation.prototype.withAnimation=function(cssClass){this._animationClass=cssClass;return this;};/**
	 * Animate the panel open.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that is resolved when the open
	 *     animation is complete.
	 */MdPanelAnimation.prototype.animateOpen=function(panelEl){var animator=this._$mdUtil.dom.animator;this._fixBounds(panelEl);var animationOptions={};// Include the panel transformations when calculating the animations.
	var panelTransform=panelEl[0].style.transform||'';var openFrom=animator.toTransformCss(panelTransform);var openTo=animator.toTransformCss(panelTransform);switch(this._animationClass){case MdPanelAnimation.animation.SLIDE:// Slide should start with opacity: 1.
	panelEl.css('opacity','1');animationOptions={transitionInClass:'_md-panel-animate-enter'};var openSlide=animator.calculateSlideToOrigin(panelEl,this._openFrom)||'';openFrom=animator.toTransformCss(openSlide+' '+panelTransform);break;case MdPanelAnimation.animation.SCALE:animationOptions={transitionInClass:'_md-panel-animate-enter'};var openScale=animator.calculateZoomToOrigin(panelEl,this._openFrom)||'';openFrom=animator.toTransformCss(openScale+' '+panelTransform);break;case MdPanelAnimation.animation.FADE:animationOptions={transitionInClass:'_md-panel-animate-enter'};break;default:if(angular.isString(this._animationClass)){animationOptions={transitionInClass:this._animationClass};}else{animationOptions={transitionInClass:this._animationClass['open'],transitionOutClass:this._animationClass['close']};}}animationOptions.duration=this._openDuration;return animator.translate3d(panelEl,openFrom,openTo,animationOptions);};/**
	 * Animate the panel close.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that resolves when the close
	 *     animation is complete.
	 */MdPanelAnimation.prototype.animateClose=function(panelEl){var animator=this._$mdUtil.dom.animator;var reverseAnimationOptions={};// Include the panel transformations when calculating the animations.
	var panelTransform=panelEl[0].style.transform||'';var closeFrom=animator.toTransformCss(panelTransform);var closeTo=animator.toTransformCss(panelTransform);switch(this._animationClass){case MdPanelAnimation.animation.SLIDE:// Slide should start with opacity: 1.
	panelEl.css('opacity','1');reverseAnimationOptions={transitionInClass:'_md-panel-animate-leave'};var closeSlide=animator.calculateSlideToOrigin(panelEl,this._closeTo)||'';closeTo=animator.toTransformCss(closeSlide+' '+panelTransform);break;case MdPanelAnimation.animation.SCALE:reverseAnimationOptions={transitionInClass:'_md-panel-animate-scale-out _md-panel-animate-leave'};var closeScale=animator.calculateZoomToOrigin(panelEl,this._closeTo)||'';closeTo=animator.toTransformCss(closeScale+' '+panelTransform);break;case MdPanelAnimation.animation.FADE:reverseAnimationOptions={transitionInClass:'_md-panel-animate-fade-out _md-panel-animate-leave'};break;default:if(angular.isString(this._animationClass)){reverseAnimationOptions={transitionOutClass:this._animationClass};}else{reverseAnimationOptions={transitionInClass:this._animationClass['close'],transitionOutClass:this._animationClass['open']};}}reverseAnimationOptions.duration=this._closeDuration;return animator.translate3d(panelEl,closeFrom,closeTo,reverseAnimationOptions);};/**
	 * Set the height and width to match the panel if not provided.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */MdPanelAnimation.prototype._fixBounds=function(panelEl){var panelWidth=panelEl[0].offsetWidth;var panelHeight=panelEl[0].offsetHeight;if(this._openFrom&&this._openFrom.bounds.height==null){this._openFrom.bounds.height=panelHeight;}if(this._openFrom&&this._openFrom.bounds.width==null){this._openFrom.bounds.width=panelWidth;}if(this._closeTo&&this._closeTo.bounds.height==null){this._closeTo.bounds.height=panelHeight;}if(this._closeTo&&this._closeTo.bounds.width==null){this._closeTo.bounds.width=panelWidth;}};/**
	 * Identify the bounding RECT for the target element.
	 * @param {!angular.JQLite} element
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */MdPanelAnimation.prototype._getBoundingClientRect=function(element){if(element instanceof angular.element){return{element:element,bounds:element[0].getBoundingClientRect()};}};/*****************************************************************************
	 *                                Util Methods                               *
	 *****************************************************************************//**
	 * Returns the angular element associated with a css selector or element.
	 * @param el {string|!angular.JQLite|!Element}
	 * @returns {!angular.JQLite}
	 */function getElement(el){var queryResult=angular.isString(el)?document.querySelector(el):el;return angular.element(queryResult);}/**
	 * Gets the computed values for an element's translateX and translateY in px.
	 * @param {!angular.JQLite|!Element} el
	 * @param {string} property
	 * @return {{x: number, y: number}}
	 */function getComputedTranslations(el,property){// The transform being returned by `getComputedStyle` is in the format:
	// `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
	// if the element doesn't have a transform.
	var transform=getComputedStyle(el[0]||el)[property];var openIndex=transform.indexOf('(');var closeIndex=transform.lastIndexOf(')');var output={x:0,y:0};if(openIndex>-1&&closeIndex>-1){var parsedValues=transform.substring(openIndex+1,closeIndex).split(', ').slice(-2);output.x=parseInt(parsedValues[0]);output.y=parseInt(parsedValues[1]);}return output;}/**
	 * Adds units to a number value.
	 * @param {string|number} value
	 * @return {string}
	 */function addUnits(value){return angular.isNumber(value)?value+'px':value;}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.progressCircular
	 * @description Module for a circular progressbar
	 */angular.module('material.components.progressCircular',['material.core']);})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.progressLinear
	 * @description Linear Progress module!
	 */MdProgressLinearDirective.$inject=["$mdTheming","$mdUtil","$log"];angular.module('material.components.progressLinear',['material.core']).directive('mdProgressLinear',MdProgressLinearDirective);/**
	 * @ngdoc directive
	 * @name mdProgressLinear
	 * @module material.components.progressLinear
	 * @restrict E
	 *
	 * @description
	 * The linear progress directive is used to make loading content
	 * in your app as delightful and painless as possible by minimizing
	 * the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * Each operation should only be represented by one activity indicator
	 * For example: one refresh operation should not display both a
	 * refresh bar and an activity circle.
	 *
	 * For operations where the percentage of the operation completed
	 * can be determined, use a determinate indicator. They give users
	 * a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while
	 * something finishes up, and it’s not necessary to expose what's
	 * happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
	 * then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
	 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="query"></md-progress-linear>
	 * </hljs>
	 */function MdProgressLinearDirective($mdTheming,$mdUtil,$log){var MODE_DETERMINATE="determinate";var MODE_INDETERMINATE="indeterminate";var MODE_BUFFER="buffer";var MODE_QUERY="query";var DISABLED_CLASS="_md-progress-linear-disabled";return{restrict:'E',template:'<div class="md-container">'+'<div class="md-dashed"></div>'+'<div class="md-bar md-bar1"></div>'+'<div class="md-bar md-bar2"></div>'+'</div>',compile:compile};function compile(tElement,tAttrs,transclude){tElement.attr('aria-valuemin',0);tElement.attr('aria-valuemax',100);tElement.attr('role','progressbar');return postLink;}function postLink(scope,element,attr){$mdTheming(element);var lastMode;var isDisabled=attr.hasOwnProperty('disabled');var toVendorCSS=$mdUtil.dom.animator.toCss;var bar1=angular.element(element[0].querySelector('.md-bar1'));var bar2=angular.element(element[0].querySelector('.md-bar2'));var container=angular.element(element[0].querySelector('.md-container'));element.attr('md-mode',mode()).toggleClass(DISABLED_CLASS,isDisabled);validateMode();watchAttributes();/**
	     * Watch the value, md-buffer-value, and md-mode attributes
	     */function watchAttributes(){attr.$observe('value',function(value){var percentValue=clamp(value);element.attr('aria-valuenow',percentValue);if(mode()!=MODE_QUERY)animateIndicator(bar2,percentValue);});attr.$observe('mdBufferValue',function(value){animateIndicator(bar1,clamp(value));});attr.$observe('disabled',function(value){if(value===true||value===false){isDisabled=!!value;}else{isDisabled=angular.isDefined(value);}element.toggleClass(DISABLED_CLASS,isDisabled);container.toggleClass(lastMode,!isDisabled);});attr.$observe('mdMode',function(mode){if(lastMode)container.removeClass(lastMode);switch(mode){case MODE_QUERY:case MODE_BUFFER:case MODE_DETERMINATE:case MODE_INDETERMINATE:container.addClass(lastMode="md-mode-"+mode);break;default:container.addClass(lastMode="md-mode-"+MODE_INDETERMINATE);break;}});}/**
	     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
	     */function validateMode(){if(angular.isUndefined(attr.mdMode)){var hasValue=angular.isDefined(attr.value);var mode=hasValue?MODE_DETERMINATE:MODE_INDETERMINATE;var info="Auto-adding the missing md-mode='{0}' to the ProgressLinear element";//$log.debug( $mdUtil.supplant(info, [mode]) );
	element.attr("md-mode",mode);attr.mdMode=mode;}}/**
	     * Is the md-mode a valid option?
	     */function mode(){var value=(attr.mdMode||"").trim();if(value){switch(value){case MODE_DETERMINATE:case MODE_INDETERMINATE:case MODE_BUFFER:case MODE_QUERY:break;default:value=MODE_INDETERMINATE;break;}}return value;}/**
	     * Manually set CSS to animate the Determinate indicator based on the specified
	     * percentage value (0-100).
	     */function animateIndicator(target,value){if(isDisabled||!mode())return;var to=$mdUtil.supplant("translateX({0}%) scale({1},1)",[(value-100)/2,value/100]);var styles=toVendorCSS({transform:to});angular.element(target).css(styles);}}/**
	   * Clamps the value to be between 0 and 100.
	   * @param {number} value The value to clamp.
	   * @returns {number}
	   */function clamp(value){return Math.max(0,Math.min(value||0,100));}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.radioButton
	 * @description radioButton module!
	 */mdRadioGroupDirective.$inject=["$mdUtil","$mdConstant","$mdTheming","$timeout"];mdRadioButtonDirective.$inject=["$mdAria","$mdUtil","$mdTheming"];angular.module('material.components.radioButton',['material.core']).directive('mdRadioGroup',mdRadioGroupDirective).directive('mdRadioButton',mdRadioButtonDirective);/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioGroup
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-group>` directive identifies a grouping
	 * container for the 1..n grouped radio buttons; specified using nested
	 * `<md-radio-button>` tags.
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the radio button is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * Note: `<md-radio-group>` and `<md-radio-button>` handle tabindex differently
	 * than the native `<input type='radio'>` controls. Whereas the native controls
	 * force the user to tab through all the radio buttons, `<md-radio-group>`
	 * is focusable, and by default the `<md-radio-button>`s are not.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {boolean=} md-no-ink Use of attribute indicates flag to disable ink ripple effects.
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-radio-group ng-model="selected">
	 *
	 *   <md-radio-button
	 *        ng-repeat="d in colorOptions"
	 *        ng-value="d.value" aria-label="{{ d.label }}">
	 *
	 *          {{ d.label }}
	 *
	 *   </md-radio-button>
	 *
	 * </md-radio-group>
	 * </hljs>
	 *
	 */function mdRadioGroupDirective($mdUtil,$mdConstant,$mdTheming,$timeout){RadioGroupController.prototype=createRadioGroupControllerProto();return{restrict:'E',controller:['$element',RadioGroupController],require:['mdRadioGroup','?ngModel'],link:{pre:linkRadioGroup}};function linkRadioGroup(scope,element,attr,ctrls){element.addClass('_md');// private md component indicator for styling
	$mdTheming(element);var rgCtrl=ctrls[0];var ngModelCtrl=ctrls[1]||$mdUtil.fakeNgModel();rgCtrl.init(ngModelCtrl);scope.mouseActive=false;element.attr({'role':'radiogroup','tabIndex':element.attr('tabindex')||'0'}).on('keydown',keydownListener).on('mousedown',function(event){scope.mouseActive=true;$timeout(function(){scope.mouseActive=false;},100);}).on('focus',function(){if(scope.mouseActive===false){rgCtrl.$element.addClass('md-focused');}}).on('blur',function(){rgCtrl.$element.removeClass('md-focused');});/**
	     *
	     */function setFocus(){if(!element.hasClass('md-focused')){element.addClass('md-focused');}}/**
	     *
	     */function keydownListener(ev){var keyCode=ev.which||ev.keyCode;// Only listen to events that we originated ourselves
	// so that we don't trigger on things like arrow keys in
	// inputs.
	if(keyCode!=$mdConstant.KEY_CODE.ENTER&&ev.currentTarget!=ev.target){return;}switch(keyCode){case $mdConstant.KEY_CODE.LEFT_ARROW:case $mdConstant.KEY_CODE.UP_ARROW:ev.preventDefault();rgCtrl.selectPrevious();setFocus();break;case $mdConstant.KEY_CODE.RIGHT_ARROW:case $mdConstant.KEY_CODE.DOWN_ARROW:ev.preventDefault();rgCtrl.selectNext();setFocus();break;case $mdConstant.KEY_CODE.ENTER:var form=angular.element($mdUtil.getClosest(element[0],'form'));if(form.length>0){form.triggerHandler('submit');}break;}}}function RadioGroupController($element){this._radioButtonRenderFns=[];this.$element=$element;}function createRadioGroupControllerProto(){return{init:function init(ngModelCtrl){this._ngModelCtrl=ngModelCtrl;this._ngModelCtrl.$render=angular.bind(this,this.render);},add:function add(rbRender){this._radioButtonRenderFns.push(rbRender);},remove:function remove(rbRender){var index=this._radioButtonRenderFns.indexOf(rbRender);if(index!==-1){this._radioButtonRenderFns.splice(index,1);}},render:function render(){this._radioButtonRenderFns.forEach(function(rbRender){rbRender();});},setViewValue:function setViewValue(value,eventType){this._ngModelCtrl.$setViewValue(value,eventType);// update the other radio buttons as well
	this.render();},getViewValue:function getViewValue(){return this._ngModelCtrl.$viewValue;},selectNext:function selectNext(){return changeSelectedButton(this.$element,1);},selectPrevious:function selectPrevious(){return changeSelectedButton(this.$element,-1);},setActiveDescendant:function setActiveDescendant(radioId){this.$element.attr('aria-activedescendant',radioId);},isDisabled:function isDisabled(){return this.$element[0].hasAttribute('disabled');}};}/**
	   * Change the radio group's selected button by a given increment.
	   * If no button is selected, select the first button.
	   */function changeSelectedButton(parent,increment){// Coerce all child radio buttons into an array, then wrap then in an iterator
	var buttons=$mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'),true);if(buttons.count()){var validate=function validate(button){// If disabled, then NOT valid
	return!angular.element(button).attr("disabled");};var selected=parent[0].querySelector('md-radio-button.md-checked');var target=buttons[increment<0?'previous':'next'](selected,validate)||buttons.first();// Activate radioButton's click listener (triggerHandler won't create a real click event)
	angular.element(target).triggerHandler('click');}}}/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioButton
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
	 *
	 * While similar to the `<input type="radio" ng-model="" value="">` directive,
	 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
	 * supports use within named radio groups.
	 *
	 * @param {string} ngValue AngularJS expression which sets the value to which the expression should
	 *    be set when selected.
	 * @param {string} value The value to which the expression should be set when selected.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} aria-label Adds label to radio button for accessibility.
	 * Defaults to radio button's text. If no text content is available, a warning will be logged.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-radio-button value="1" aria-label="Label 1">
	 *   Label 1
	 * </md-radio-button>
	 *
	 * <md-radio-button ng-value="specialValue" aria-label="Green">
	 *   Green
	 * </md-radio-button>
	 *
	 * </hljs>
	 *
	 */function mdRadioButtonDirective($mdAria,$mdUtil,$mdTheming){var CHECKED_CSS='md-checked';return{restrict:'E',require:'^mdRadioGroup',transclude:true,template:'<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>'+'<div class="md-off"></div>'+'<div class="md-on"></div>'+'</div>'+'<div ng-transclude class="md-label"></div>',link:link};function link(scope,element,attr,rgCtrl){var lastChecked;$mdTheming(element);configureAria(element,scope);// ngAria overwrites the aria-checked inside a $watch for ngValue.
	// We should defer the initialization until all the watches have fired.
	// This can also be fixed by removing the `lastChecked` check, but that'll
	// cause more DOM manipulation on each digest.
	if(attr.ngValue){$mdUtil.nextTick(initialize,false);}else{initialize();}/**
	     * Initializes the component.
	     */function initialize(){if(!rgCtrl){throw'RadioButton: No RadioGroupController could be found.';}rgCtrl.add(render);attr.$observe('value',render);element.on('click',listener).on('$destroy',function(){rgCtrl.remove(render);});}/**
	     * On click functionality.
	     */function listener(ev){if(element[0].hasAttribute('disabled')||rgCtrl.isDisabled())return;scope.$apply(function(){rgCtrl.setViewValue(attr.value,ev&&ev.type);});}/**
	     *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
	     *  Update the `aria-activedescendant` attribute.
	     */function render(){var checked=rgCtrl.getViewValue()==attr.value;if(checked===lastChecked)return;if(element[0].parentNode.nodeName.toLowerCase()!=='md-radio-group'){// If the radioButton is inside a div, then add class so highlighting will work
	element.parent().toggleClass(CHECKED_CSS,checked);}if(checked){rgCtrl.setActiveDescendant(element.attr('id'));}lastChecked=checked;element.attr('aria-checked',checked).toggleClass(CHECKED_CSS,checked);}/**
	     * Inject ARIA-specific attributes appropriate for each radio button
	     */function configureAria(element,scope){element.attr({id:attr.id||'radio_'+$mdUtil.nextUid(),role:'radio','aria-checked':'false'});$mdAria.expectWithText(element,'aria-label');}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.showHide
	 */// Add additional handlers to ng-show and ng-hide that notify directives
	// contained within that they should recompute their size.
	// These run in addition to AngularJS's built-in ng-hide and ng-show directives.
	angular.module('material.components.showHide',['material.core']).directive('ngShow',createDirective('ngShow',true)).directive('ngHide',createDirective('ngHide',false));function createDirective(name,targetValue){return['$mdUtil','$window',function($mdUtil,$window){return{restrict:'A',multiElement:true,link:function link($scope,$element,$attr){var unregister=$scope.$on('$md-resize-enable',function(){unregister();var node=$element[0];var cachedTransitionStyles=node.nodeType===$window.Node.ELEMENT_NODE?$window.getComputedStyle(node):{};$scope.$watch($attr[name],function(value){if(!!value===targetValue){$mdUtil.nextTick(function(){$scope.$broadcast('$md-resize');});var opts={cachedTransitionStyles:cachedTransitionStyles};$mdUtil.dom.animator.waitTransitionEnd($element,opts).then(function(){$scope.$broadcast('$md-resize');});}});});}};}];}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.select
	 *//***************************************************
	
	 ### TODO - POST RC1 ###
	 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service
	
	 ***************************************************/SelectDirective.$inject=["$mdSelect","$mdUtil","$mdConstant","$mdTheming","$mdAria","$parse","$sce","$injector"];SelectMenuDirective.$inject=["$parse","$mdUtil","$mdConstant","$mdTheming"];OptionDirective.$inject=["$mdButtonInkRipple","$mdUtil","$mdTheming"];SelectProvider.$inject=["$$interimElementProvider"];var SELECT_EDGE_MARGIN=8;var selectNextId=0;var CHECKBOX_SELECTION_INDICATOR=angular.element('<div class="md-container"><div class="md-icon"></div></div>');angular.module('material.components.select',['material.core','material.components.backdrop']).directive('mdSelect',SelectDirective).directive('mdSelectMenu',SelectMenuDirective).directive('mdOption',OptionDirective).directive('mdOptgroup',OptgroupDirective).directive('mdSelectHeader',SelectHeaderDirective).provider('$mdSelect',SelectProvider);/**
	 * @ngdoc directive
	 * @name mdSelect
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a select box, bound to an ng-model.
	 *
	 * When the select is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * By default, the select will display with an underline to match other form elements. This can be
	 * disabled by applying the `md-no-underline` CSS class.
	 *
	 * ### Option Params
	 *
	 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to  clear the
	 * select and put it back in it's default state. You may supply this attribute on any option you
	 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
	 * defined.
	 *
	 * **Automatically Applied**
	 *
	 *  - `<md-option>`
	 *  - `<md-option value>`
	 *  - `<md-option value="">`
	 *  - `<md-option ng-value>`
	 *  - `<md-option ng-value="">`
	 *
	 * **NOT Automatically Applied**
	 *
	 *  - `<md-option ng-value="1">`
	 *  - `<md-option ng-value="''">`
	 *  - `<md-option ng-value="undefined">`
	 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
	 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
	 *
	 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
	 * attribute) since you may wish this to be your "Not Available" or "None" option.
	 *
	 * **Note:** Using the `value` attribute (as opposed to `ng-value`) always evaluates to a string, so
	 * `value="null"` will require the test `ng-if="myValue != 'null'"` rather than `ng-if="!myValue"`.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {boolean=} multiple When set to true, allows for more than one option to be selected. The model is an array with the selected choices.
	 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
	 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
	 * Will hide the select options and show a spinner until the evaluated promise resolves.
	 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed. The value
	 * will be treated as *text* (not html).
	 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed. The value
	 * will be treated as *html*. The value must either be explicitly marked as trustedHtml or
	 * the ngSanitize module must be loaded.
	 * @param {string=} placeholder Placeholder hint text.
	 * @param md-no-asterisk {boolean=} When set to true, an asterisk will not be appended to the
	 * floating label. **Note:** This attribute is only evaluated once; it is not watched.
	 * @param {string=} aria-label Optional label for accessibility. Only necessary if no placeholder or
	 * explicit label is present.
	 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
	 * element (for custom styling).
	 *
	 * @usage
	 * With a placeholder (label and aria-label are added dynamically)
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select
	 *       ng-model="someModel"
	 *       placeholder="Select a state">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With an explicit label
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <label>State</label>
	 *     <md-select
	 *       ng-model="someModel">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With a select-header
	 *
	 * When a developer needs to put more than just a text label in the
	 * md-select-menu, they should use the md-select-header.
	 * The user can put custom HTML inside of the header and style it to their liking.
	 * One common use case of this would be a sticky search bar.
	 *
	 * When using the md-select-header the labels that would previously be added to the
	 * OptGroupDirective are ignored.
	 *
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select ng-model="someModel">
	 *       <md-select-header>
	 *         <span> Neighborhoods - </span>
	 *       </md-select-header>
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * ## Selects and object equality
	 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
	 * equality. Consider the following example:
	 * <hljs lang="js">
	 * angular.controller('MyCtrl', function($scope) {
	 *   $scope.users = [
	 *     { id: 1, name: 'Bob' },
	 *     { id: 2, name: 'Alice' },
	 *     { id: 3, name: 'Steve' }
	 *   ];
	 *   $scope.selectedUser = { id: 1, name: 'Bob' };
	 * });
	 * </hljs>
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 *
	 * At first one might expect that the select should be populated with "Bob" as the selected user. However,
	 * this is not true. To determine whether something is selected,
	 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
	 *
	 * Javascript's `==` operator does not check for deep equality (ie. that all properties
	 * on the object are the same), but instead whether the objects are *the same object in memory*.
	 * In this case, we have two instances of identical objects, but they exist in memory as unique
	 * entities. Because of this, the select will have no value populated for a selected user.
	 *
	 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a different
	 * expression which will be used for the equality operator. As such, we can update our `html` to
	 * make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the `md-select`
	 * element. This converts our equality expression to be
	 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
	 * which results in Bob being selected as desired.
	 *
	 * Working HTML:
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 */function SelectDirective($mdSelect,$mdUtil,$mdConstant,$mdTheming,$mdAria,$parse,$sce,$injector){var keyCodes=$mdConstant.KEY_CODE;var NAVIGATION_KEYS=[keyCodes.SPACE,keyCodes.ENTER,keyCodes.UP_ARROW,keyCodes.DOWN_ARROW];return{restrict:'E',require:['^?mdInputContainer','mdSelect','ngModel','?^form'],compile:compile,controller:function controller(){}// empty placeholder controller to be initialized in link
	};function compile(element,attr){// add the select value that will hold our placeholder or selected option value
	var valueEl=angular.element('<md-select-value><span></span></md-select-value>');valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');valueEl.addClass('md-select-value');if(!valueEl[0].hasAttribute('id')){valueEl.attr('id','select_value_label_'+$mdUtil.nextUid());}// There's got to be an md-content inside. If there's not one, let's add it.
	var mdContentEl=element.find('md-content');if(!mdContentEl.length){element.append(angular.element('<md-content>').append(element.contents()));}mdContentEl.attr('role','presentation');// Add progress spinner for md-options-loading
	if(attr.mdOnOpen){// Show progress indicator while loading async
	// Use ng-hide for `display:none` so the indicator does not interfere with the options list
	element.find('md-content').prepend(angular.element('<div>'+' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false" md-diameter="25px"></md-progress-circular>'+'</div>'));// Hide list [of item options] while loading async
	element.find('md-option').attr('ng-show','$$loadingAsyncDone');}if(attr.name){var autofillClone=angular.element('<select class="md-visually-hidden"></select>');autofillClone.attr({'name':attr.name,'aria-hidden':'true','tabindex':'-1'});var opts=element.find('md-option');angular.forEach(opts,function(el){var newEl=angular.element('<option>'+el.innerHTML+'</option>');if(el.hasAttribute('ng-value'))newEl.attr('ng-value',el.getAttribute('ng-value'));else if(el.hasAttribute('value'))newEl.attr('value',el.getAttribute('value'));autofillClone.append(newEl);});// Adds an extra option that will hold the selected value for the
	// cases where the select is a part of a non-angular form. This can be done with a ng-model,
	// however if the `md-option` is being `ng-repeat`-ed, AngularJS seems to insert a similar
	// `option` node, but with a value of `? string: <value> ?` which would then get submitted.
	// This also goes around having to prepend a dot to the name attribute.
	autofillClone.append('<option ng-value="'+attr.ngModel+'" selected></option>');element.parent().append(autofillClone);}var isMultiple=$mdUtil.parseAttributeBoolean(attr.multiple);// Use everything that's left inside element.contents() as the contents of the menu
	var multipleContent=isMultiple?'multiple':'';var selectTemplate=''+'<div class="md-select-menu-container" aria-hidden="true" role="presentation">'+'<md-select-menu role="presentation" {0}>{1}</md-select-menu>'+'</div>';selectTemplate=$mdUtil.supplant(selectTemplate,[multipleContent,element.html()]);element.empty().append(valueEl);element.append(selectTemplate);if(!attr.tabindex){attr.$set('tabindex',0);}return function postLink(scope,element,attr,ctrls){var untouched=true;var isDisabled,ariaLabelBase;var containerCtrl=ctrls[0];var mdSelectCtrl=ctrls[1];var ngModelCtrl=ctrls[2];var formCtrl=ctrls[3];// grab a reference to the select menu value label
	var valueEl=element.find('md-select-value');var isReadonly=angular.isDefined(attr.readonly);var disableAsterisk=$mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);if(disableAsterisk){element.addClass('md-no-asterisk');}if(containerCtrl){var isErrorGetter=containerCtrl.isErrorGetter||function(){return ngModelCtrl.$invalid&&(ngModelCtrl.$touched||formCtrl&&formCtrl.$submitted);};if(containerCtrl.input){// We ignore inputs that are in the md-select-header (one
	// case where this might be useful would be adding as searchbox)
	if(element.find('md-select-header').find('input')[0]!==containerCtrl.input[0]){throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");}}containerCtrl.input=element;if(!containerCtrl.label){$mdAria.expect(element,'aria-label',element.attr('placeholder'));}scope.$watch(isErrorGetter,containerCtrl.setInvalid);}var selectContainer,selectScope,selectMenuCtrl;findSelectContainer();$mdTheming(element);if(formCtrl&&angular.isDefined(attr.multiple)){$mdUtil.nextTick(function(){var hasModelValue=ngModelCtrl.$modelValue||ngModelCtrl.$viewValue;if(hasModelValue){formCtrl.$setPristine();}});}var originalRender=ngModelCtrl.$render;ngModelCtrl.$render=function(){originalRender();syncLabelText();syncAriaLabel();inputCheckValue();};attr.$observe('placeholder',ngModelCtrl.$render);if(containerCtrl&&containerCtrl.label){attr.$observe('required',function(value){// Toggle the md-required class on the input containers label, because the input container is automatically
	// applying the asterisk indicator on the label.
	containerCtrl.label.toggleClass('md-required',value&&!disableAsterisk);});}mdSelectCtrl.setLabelText=function(text){mdSelectCtrl.setIsPlaceholder(!text);// Whether the select label has been given via user content rather than the internal
	// template of <md-option>
	var isSelectLabelFromUser=false;if(attr.mdSelectedText&&attr.mdSelectedHtml){throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');}if(attr.mdSelectedText||attr.mdSelectedHtml){text=$parse(attr.mdSelectedText||attr.mdSelectedHtml)(scope);isSelectLabelFromUser=true;}else if(!text){// Use placeholder attribute, otherwise fallback to the md-input-container label
	var tmpPlaceholder=attr.placeholder||(containerCtrl&&containerCtrl.label?containerCtrl.label.text():'');text=tmpPlaceholder||'';isSelectLabelFromUser=true;}var target=valueEl.children().eq(0);if(attr.mdSelectedHtml){// Using getTrustedHtml will run the content through $sanitize if it is not already
	// explicitly trusted. If the ngSanitize module is not loaded, this will
	// *correctly* throw an sce error.
	target.html($sce.getTrustedHtml(text));}else if(isSelectLabelFromUser){target.text(text);}else{// If we've reached this point, the text is not user-provided.
	target.html(text);}};mdSelectCtrl.setIsPlaceholder=function(isPlaceholder){if(isPlaceholder){valueEl.addClass('md-select-placeholder');if(containerCtrl&&containerCtrl.label){containerCtrl.label.addClass('md-placeholder');}}else{valueEl.removeClass('md-select-placeholder');if(containerCtrl&&containerCtrl.label){containerCtrl.label.removeClass('md-placeholder');}}};if(!isReadonly){element.on('focus',function(ev){// Always focus the container (if we have one) so floating labels and other styles are
	// applied properly
	containerCtrl&&containerCtrl.setFocused(true);});// Attach before ngModel's blur listener to stop propagation of blur event
	// to prevent from setting $touched.
	element.on('blur',function(event){if(untouched){untouched=false;if(selectScope._mdSelectIsOpen){event.stopImmediatePropagation();}}if(selectScope._mdSelectIsOpen)return;containerCtrl&&containerCtrl.setFocused(false);inputCheckValue();});}mdSelectCtrl.triggerClose=function(){$parse(attr.mdOnClose)(scope);};scope.$$postDigest(function(){initAriaLabel();syncLabelText();syncAriaLabel();});function initAriaLabel(){var labelText=element.attr('aria-label')||element.attr('placeholder');if(!labelText&&containerCtrl&&containerCtrl.label){labelText=containerCtrl.label.text();}ariaLabelBase=labelText;$mdAria.expect(element,'aria-label',labelText);}scope.$watch(function(){return selectMenuCtrl.selectedLabels();},syncLabelText);function syncLabelText(){if(selectContainer){selectMenuCtrl=selectMenuCtrl||selectContainer.find('md-select-menu').controller('mdSelectMenu');mdSelectCtrl.setLabelText(selectMenuCtrl.selectedLabels());}}function syncAriaLabel(){if(!ariaLabelBase)return;var ariaLabels=selectMenuCtrl.selectedLabels({mode:'aria'});element.attr('aria-label',ariaLabels.length?ariaLabelBase+': '+ariaLabels:ariaLabelBase);}var deregisterWatcher;attr.$observe('ngMultiple',function(val){if(deregisterWatcher)deregisterWatcher();var parser=$parse(val);deregisterWatcher=scope.$watch(function(){return parser(scope);},function(multiple,prevVal){if(multiple===undefined&&prevVal===undefined)return;// assume compiler did a good job
	if(multiple){element.attr('multiple','multiple');}else{element.removeAttr('multiple');}element.attr('aria-multiselectable',multiple?'true':'false');if(selectContainer){selectMenuCtrl.setMultiple(multiple);originalRender=ngModelCtrl.$render;ngModelCtrl.$render=function(){originalRender();syncLabelText();syncAriaLabel();inputCheckValue();};ngModelCtrl.$render();}});});attr.$observe('disabled',function(disabled){if(angular.isString(disabled)){disabled=true;}// Prevent click event being registered twice
	if(isDisabled!==undefined&&isDisabled===disabled){return;}isDisabled=disabled;if(disabled){element.attr({'aria-disabled':'true'}).removeAttr('tabindex').off('click',openSelect).off('keydown',handleKeypress);}else{element.attr({'tabindex':attr.tabindex,'aria-disabled':'false'}).on('click',openSelect).on('keydown',handleKeypress);}});if(!attr.hasOwnProperty('disabled')&&!attr.hasOwnProperty('ngDisabled')){element.attr({'aria-disabled':'false'});element.on('click',openSelect);element.on('keydown',handleKeypress);}var ariaAttrs={role:'listbox','aria-expanded':'false','aria-multiselectable':isMultiple&&!attr.ngMultiple?'true':'false'};if(!element[0].hasAttribute('id')){ariaAttrs.id='select_'+$mdUtil.nextUid();}var containerId='select_container_'+$mdUtil.nextUid();selectContainer.attr('id',containerId);// Only add aria-owns if element ownership is NOT represented in the DOM.
	if(!element.find('md-select-menu').length){ariaAttrs['aria-owns']=containerId;}element.attr(ariaAttrs);scope.$on('$destroy',function(){$mdSelect.destroy().finally(function(){if(containerCtrl){containerCtrl.setFocused(false);containerCtrl.setHasValue(false);containerCtrl.input=null;}ngModelCtrl.$setTouched();});});function inputCheckValue(){// The select counts as having a value if one or more options are selected,
	// or if the input's validity state says it has bad input (eg string in a number input)
	containerCtrl&&containerCtrl.setHasValue(selectMenuCtrl.selectedLabels().length>0||(element[0].validity||{}).badInput);}function findSelectContainer(){selectContainer=angular.element(element[0].querySelector('.md-select-menu-container'));selectScope=scope;if(attr.mdContainerClass){var value=selectContainer[0].getAttribute('class')+' '+attr.mdContainerClass;selectContainer[0].setAttribute('class',value);}selectMenuCtrl=selectContainer.find('md-select-menu').controller('mdSelectMenu');selectMenuCtrl.init(ngModelCtrl,attr.ngModel);element.on('$destroy',function(){selectContainer.remove();});}function handleKeypress(e){if($mdConstant.isNavigationKey(e)){// prevent page scrolling on interaction
	e.preventDefault();openSelect(e);}else{if(shouldHandleKey(e,$mdConstant)){e.preventDefault();var node=selectMenuCtrl.optNodeForKeyboardSearch(e);if(!node||node.hasAttribute('disabled'))return;var optionCtrl=angular.element(node).controller('mdOption');if(!selectMenuCtrl.isMultiple){selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);}selectMenuCtrl.select(optionCtrl.hashKey,optionCtrl.value);selectMenuCtrl.refreshViewValue();}}}function openSelect(){selectScope._mdSelectIsOpen=true;element.attr('aria-expanded','true');$mdSelect.show({scope:selectScope,preserveScope:true,skipCompile:true,element:selectContainer,target:element[0],selectCtrl:mdSelectCtrl,preserveElement:true,hasBackdrop:true,loadingAsync:attr.mdOnOpen?scope.$eval(attr.mdOnOpen)||true:false}).finally(function(){selectScope._mdSelectIsOpen=false;element.focus();element.attr('aria-expanded','false');ngModelCtrl.$setTouched();});}};}}function SelectMenuDirective($parse,$mdUtil,$mdConstant,$mdTheming){// We want the scope to be set to 'false' so an isolated scope is not created
	// which would interfere with the md-select-header's access to the
	// parent scope.
	SelectMenuController.$inject=["$scope","$attrs","$element"];return{restrict:'E',require:['mdSelectMenu'],scope:false,controller:SelectMenuController,link:{pre:preLink}};// We use preLink instead of postLink to ensure that the select is initialized before
	// its child options run postLink.
	function preLink(scope,element,attr,ctrls){var selectCtrl=ctrls[0];element.addClass('_md');// private md component indicator for styling
	$mdTheming(element);element.on('click',clickListener);element.on('keypress',keyListener);function keyListener(e){if(e.keyCode==13||e.keyCode==32){clickListener(e);}}function clickListener(ev){var option=$mdUtil.getClosest(ev.target,'md-option');var optionCtrl=option&&angular.element(option).data('$mdOptionController');if(!option||!optionCtrl)return;if(option.hasAttribute('disabled')){ev.stopImmediatePropagation();return false;}var optionHashKey=selectCtrl.hashGetter(optionCtrl.value);var isSelected=angular.isDefined(selectCtrl.selected[optionHashKey]);scope.$apply(function(){if(selectCtrl.isMultiple){if(isSelected){selectCtrl.deselect(optionHashKey);}else{selectCtrl.select(optionHashKey,optionCtrl.value);}}else{if(!isSelected){selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);selectCtrl.select(optionHashKey,optionCtrl.value);}}selectCtrl.refreshViewValue();});}}function SelectMenuController($scope,$attrs,$element){var self=this;self.isMultiple=angular.isDefined($attrs.multiple);// selected is an object with keys matching all of the selected options' hashed values
	self.selected={};// options is an object with keys matching every option's hash value,
	// and values matching every option's controller.
	self.options={};$scope.$watchCollection(function(){return self.options;},function(){self.ngModel.$render();});var deregisterCollectionWatch;var defaultIsEmpty;self.setMultiple=function(isMultiple){var ngModel=self.ngModel;defaultIsEmpty=defaultIsEmpty||ngModel.$isEmpty;self.isMultiple=isMultiple;if(deregisterCollectionWatch)deregisterCollectionWatch();if(self.isMultiple){ngModel.$validators['md-multiple']=validateArray;ngModel.$render=renderMultiple;// watchCollection on the model because by default ngModel only watches the model's
	// reference. This allowed the developer to also push and pop from their array.
	$scope.$watchCollection(self.modelBinding,function(value){if(validateArray(value))renderMultiple(value);});ngModel.$isEmpty=function(value){return!value||value.length===0;};}else{delete ngModel.$validators['md-multiple'];ngModel.$render=renderSingular;}function validateArray(modelValue,viewValue){// If a value is truthy but not an array, reject it.
	// If value is undefined/falsy, accept that it's an empty array.
	return angular.isArray(modelValue||viewValue||[]);}};var searchStr='';var clearSearchTimeout,optNodes,optText;var CLEAR_SEARCH_AFTER=300;self.optNodeForKeyboardSearch=function(e){clearSearchTimeout&&clearTimeout(clearSearchTimeout);clearSearchTimeout=setTimeout(function(){clearSearchTimeout=undefined;searchStr='';optText=undefined;optNodes=undefined;},CLEAR_SEARCH_AFTER);// Support 1-9 on numpad
	var keyCode=e.keyCode-($mdConstant.isNumPadKey(e)?48:0);searchStr+=String.fromCharCode(keyCode);var search=new RegExp('^'+searchStr,'i');if(!optNodes){optNodes=$element.find('md-option');optText=new Array(optNodes.length);angular.forEach(optNodes,function(el,i){optText[i]=el.textContent.trim();});}for(var i=0;i<optText.length;++i){if(search.test(optText[i])){return optNodes[i];}}};self.init=function(ngModel,binding){self.ngModel=ngModel;self.modelBinding=binding;// Setup a more robust version of isEmpty to ensure value is a valid option
	self.ngModel.$isEmpty=function($viewValue){// We have to transform the viewValue into the hashKey, because otherwise the
	// OptionCtrl may not exist. Developers may have specified a trackBy function.
	return!self.options[self.hashGetter($viewValue)];};// Allow users to provide `ng-model="foo" ng-model-options="{trackBy: 'foo.id'}"` so
	// that we can properly compare objects set on the model to the available options
	var trackByOption=$mdUtil.getModelOption(ngModel,'trackBy');if(trackByOption){var trackByLocals={};var trackByParsed=$parse(trackByOption);self.hashGetter=function(value,valueScope){trackByLocals.$value=value;return trackByParsed(valueScope||$scope,trackByLocals);};// If the user doesn't provide a trackBy, we automatically generate an id for every
	// value passed in
	}else{self.hashGetter=function getHashValue(value){if(angular.isObject(value)){return'object_'+(value.$$mdSelectId||(value.$$mdSelectId=++selectNextId));}return value;};}self.setMultiple(self.isMultiple);};self.selectedLabels=function(opts){opts=opts||{};var mode=opts.mode||'html';var selectedOptionEls=$mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));if(selectedOptionEls.length){var mapFn;if(mode=='html'){// Map the given element to its innerHTML string. If the element has a child ripple
	// container remove it from the HTML string, before returning the string.
	mapFn=function mapFn(el){// If we do not have a `value` or `ng-value`, assume it is an empty option which clears the select
	if(el.hasAttribute('md-option-empty')){return'';}var html=el.innerHTML;// Remove the ripple container from the selected option, copying it would cause a CSP violation.
	var rippleContainer=el.querySelector('.md-ripple-container');if(rippleContainer){html=html.replace(rippleContainer.outerHTML,'');}// Remove the checkbox container, because it will cause the label to wrap inside of the placeholder.
	// It should be not displayed inside of the label element.
	var checkboxContainer=el.querySelector('.md-container');if(checkboxContainer){html=html.replace(checkboxContainer.outerHTML,'');}return html;};}else if(mode=='aria'){mapFn=function mapFn(el){return el.hasAttribute('aria-label')?el.getAttribute('aria-label'):el.textContent;};}// Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
	return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');}else{return'';}};self.select=function(hashKey,hashedValue){var option=self.options[hashKey];option&&option.setSelected(true);self.selected[hashKey]=hashedValue;};self.deselect=function(hashKey){var option=self.options[hashKey];option&&option.setSelected(false);delete self.selected[hashKey];};self.addOption=function(hashKey,optionCtrl){if(angular.isDefined(self.options[hashKey])){throw new Error('Duplicate md-option values are not allowed in a select. '+'Duplicate value "'+optionCtrl.value+'" found.');}self.options[hashKey]=optionCtrl;// If this option's value was already in our ngModel, go ahead and select it.
	if(angular.isDefined(self.selected[hashKey])){self.select(hashKey,optionCtrl.value);// When the current $modelValue of the ngModel Controller is using the same hash as
	// the current option, which will be added, then we can be sure, that the validation
	// of the option has occurred before the option was added properly.
	// This means, that we have to manually trigger a new validation of the current option.
	if(angular.isDefined(self.ngModel.$modelValue)&&self.hashGetter(self.ngModel.$modelValue)===hashKey){self.ngModel.$validate();}self.refreshViewValue();}};self.removeOption=function(hashKey){delete self.options[hashKey];// Don't deselect an option when it's removed - the user's ngModel should be allowed
	// to have values that do not match a currently available option.
	};self.refreshViewValue=function(){var values=[];var option;for(var hashKey in self.selected){// If this hashKey has an associated option, push that option's value to the model.
	if(option=self.options[hashKey]){values.push(option.value);}else{// Otherwise, the given hashKey has no associated option, and we got it
	// from an ngModel value at an earlier time. Push the unhashed value of
	// this hashKey to the model.
	// This allows the developer to put a value in the model that doesn't yet have
	// an associated option.
	values.push(self.selected[hashKey]);}}var usingTrackBy=$mdUtil.getModelOption(self.ngModel,'trackBy');var newVal=self.isMultiple?values:values[0];var prevVal=self.ngModel.$modelValue;if(usingTrackBy?!angular.equals(prevVal,newVal):prevVal+''!==newVal){self.ngModel.$setViewValue(newVal);self.ngModel.$render();}};function renderMultiple(){var newSelectedValues=self.ngModel.$modelValue||self.ngModel.$viewValue||[];if(!angular.isArray(newSelectedValues))return;var oldSelected=Object.keys(self.selected);var newSelectedHashes=newSelectedValues.map(self.hashGetter);var deselected=oldSelected.filter(function(hash){return newSelectedHashes.indexOf(hash)===-1;});deselected.forEach(self.deselect);newSelectedHashes.forEach(function(hashKey,i){self.select(hashKey,newSelectedValues[i]);});}function renderSingular(){var value=self.ngModel.$viewValue||self.ngModel.$modelValue;Object.keys(self.selected).forEach(self.deselect);self.select(self.hashGetter(value),value);}}}function OptionDirective($mdButtonInkRipple,$mdUtil,$mdTheming){OptionController.$inject=["$element"];return{restrict:'E',require:['mdOption','^^mdSelectMenu'],controller:OptionController,compile:compile};function compile(element,attr){// Manual transclusion to avoid the extra inner <span> that ng-transclude generates
	element.append(angular.element('<div class="md-text">').append(element.contents()));element.attr('tabindex',attr.tabindex||'0');if(!hasDefinedValue(attr)){element.attr('md-option-empty','');}return postLink;}function hasDefinedValue(attr){var value=attr.value;var ngValue=attr.ngValue;return value||ngValue;}function postLink(scope,element,attr,ctrls){var optionCtrl=ctrls[0];var selectCtrl=ctrls[1];$mdTheming(element);if(selectCtrl.isMultiple){element.addClass('md-checkbox-enabled');element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());}if(angular.isDefined(attr.ngValue)){scope.$watch(attr.ngValue,setOptionValue);}else if(angular.isDefined(attr.value)){setOptionValue(attr.value);}else{scope.$watch(function(){return element.text().trim();},setOptionValue);}attr.$observe('disabled',function(disabled){if(disabled){element.attr('tabindex','-1');}else{element.attr('tabindex','0');}});scope.$$postDigest(function(){attr.$observe('selected',function(selected){if(!angular.isDefined(selected))return;if(typeof selected=='string')selected=true;if(selected){if(!selectCtrl.isMultiple){selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);}selectCtrl.select(optionCtrl.hashKey,optionCtrl.value);}else{selectCtrl.deselect(optionCtrl.hashKey);}selectCtrl.refreshViewValue();});});$mdButtonInkRipple.attach(scope,element);configureAria();function setOptionValue(newValue,oldValue,prevAttempt){if(!selectCtrl.hashGetter){if(!prevAttempt){scope.$$postDigest(function(){setOptionValue(newValue,oldValue,true);});}return;}var oldHashKey=selectCtrl.hashGetter(oldValue,scope);var newHashKey=selectCtrl.hashGetter(newValue,scope);optionCtrl.hashKey=newHashKey;optionCtrl.value=newValue;selectCtrl.removeOption(oldHashKey,optionCtrl);selectCtrl.addOption(newHashKey,optionCtrl);}scope.$on('$destroy',function(){selectCtrl.removeOption(optionCtrl.hashKey,optionCtrl);});function configureAria(){var ariaAttrs={'role':'option','aria-selected':'false'};if(!element[0].hasAttribute('id')){ariaAttrs.id='select_option_'+$mdUtil.nextUid();}element.attr(ariaAttrs);}}function OptionController($element){this.selected=false;this.setSelected=function(isSelected){if(isSelected&&!this.selected){$element.attr({'selected':'selected','aria-selected':'true'});}else if(!isSelected&&this.selected){$element.removeAttr('selected');$element.attr('aria-selected','false');}this.selected=isSelected;};}}function OptgroupDirective(){return{restrict:'E',compile:compile};function compile(el,attrs){// If we have a select header element, we don't want to add the normal label
	// header.
	if(!hasSelectHeader()){setupLabelElement();}function hasSelectHeader(){return el.parent().find('md-select-header').length;}function setupLabelElement(){var labelElement=el.find('label');if(!labelElement.length){labelElement=angular.element('<label>');el.prepend(labelElement);}labelElement.addClass('md-container-ignore');labelElement.attr('aria-hidden','true');if(attrs.label)labelElement.text(attrs.label);}}}function SelectHeaderDirective(){return{restrict:'E'};}function SelectProvider($$interimElementProvider){selectDefaultOptions.$inject=["$mdSelect","$mdConstant","$mdUtil","$window","$q","$$rAF","$animateCss","$animate","$document"];return $$interimElementProvider('$mdSelect').setDefaults({methods:['target'],options:selectDefaultOptions});/* @ngInject */function selectDefaultOptions($mdSelect,$mdConstant,$mdUtil,$window,$q,$$rAF,$animateCss,$animate,$document){var ERROR_TARGET_EXPECTED="$mdSelect.show() expected a target element in options.target but got '{0}'!";var animator=$mdUtil.dom.animator;var keyCodes=$mdConstant.KEY_CODE;return{parent:'body',themable:true,onShow:onShow,onRemove:onRemove,hasBackdrop:true,disableParentScroll:true};/**
	     * Interim-element onRemove logic....
	     */function onRemove(scope,element,opts){var animationRunner=null;var destroyListener=scope.$on('$destroy',function(){// Listen for the case where the element was destroyed while there was an
	// ongoing close animation. If this happens, we need to end the animation
	// manually.
	animationRunner.end();});opts=opts||{};opts.cleanupInteraction();opts.cleanupResizing();opts.hideBackdrop();// For navigation $destroy events, do a quick, non-animated removal,
	// but for normal closes (from clicks, etc) animate the removal
	return opts.$destroy===true?cleanElement():animateRemoval().then(cleanElement);/**
	       * For normal closes (eg clicks), animate the removal.
	       * For forced closes (like $destroy events from navigation),
	       * skip the animations
	       */function animateRemoval(){animationRunner=$animateCss(element,{addClass:'md-leave'});return animationRunner.start();}/**
	       * Restore the element to a closed state
	       */function cleanElement(){destroyListener();element.removeClass('md-active').attr('aria-hidden','true').css('display','none');element.parent().find('md-select-value').removeAttr('aria-hidden');announceClosed(opts);if(!opts.$destroy&&opts.restoreFocus){opts.target.focus();}}}/**
	     * Interim-element onShow logic....
	     */function onShow(scope,element,opts){watchAsyncLoad();sanitizeAndConfigure(scope,opts);opts.hideBackdrop=showBackdrop(scope,element,opts);return showDropDown(scope,element,opts).then(function(response){element.attr('aria-hidden','false');opts.alreadyOpen=true;opts.cleanupInteraction=activateInteraction();opts.cleanupResizing=activateResizing();autoFocus(opts.focusedNode);return response;},opts.hideBackdrop);// ************************************
	// Closure Functions
	// ************************************
	/**
	       *  Attach the select DOM element(s) and animate to the correct positions
	       *  and scalings...
	       */function showDropDown(scope,element,opts){if(opts.parent!==element.parent()){element.parent().attr('aria-owns',element.attr('id'));}element.parent().find('md-select-value').attr('aria-hidden','true');opts.parent.append(element);return $q(function(resolve,reject){try{$animateCss(element,{removeClass:'md-leave',duration:0}).start().then(positionAndFocusMenu).then(resolve);}catch(e){reject(e);}});}/**
	       * Initialize container and dropDown menu positions/scale, then animate
	       * to show.
	       */function positionAndFocusMenu(){return $q(function(resolve){if(opts.isRemoved)return $q.reject(false);var info=calculateMenuPositions(scope,element,opts);info.container.element.css(animator.toCss(info.container.styles));info.dropDown.element.css(animator.toCss(info.dropDown.styles));$$rAF(function(){element.addClass('md-active');info.dropDown.element.css(animator.toCss({transform:''}));resolve();});});}/**
	       * Show modal backdrop element...
	       */function showBackdrop(scope,element,options){// If we are not within a dialog...
	if(options.disableParentScroll&&!$mdUtil.getClosest(options.target,'MD-DIALOG')){// !! DO this before creating the backdrop; since disableScrollAround()
	//    configures the scroll offset; which is used by mdBackDrop postLink()
	options.restoreScroll=$mdUtil.disableScrollAround(options.element,options.parent);}else{options.disableParentScroll=false;}if(options.hasBackdrop){// Override duration to immediately show invisible backdrop
	options.backdrop=$mdUtil.createBackdrop(scope,"md-select-backdrop md-click-catcher");$animate.enter(options.backdrop,$document[0].body,null,{duration:0});}/**
	         * Hide modal backdrop element...
	         */return function hideBackdrop(){if(options.backdrop)options.backdrop.remove();if(options.disableParentScroll)options.restoreScroll();delete options.restoreScroll;};}/**
	       *
	       */function autoFocus(focusedNode){if(focusedNode&&!focusedNode.hasAttribute('disabled')){focusedNode.focus();}}/**
	       * Check for valid opts and set some sane defaults
	       */function sanitizeAndConfigure(scope,options){var selectEl=element.find('md-select-menu');if(!options.target){throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED,[options.target]));}angular.extend(options,{isRemoved:false,target:angular.element(options.target),//make sure it's not a naked dom node
	parent:angular.element(options.parent),selectEl:selectEl,contentEl:element.find('md-content'),optionNodes:selectEl[0].getElementsByTagName('md-option')});}/**
	       * Configure various resize listeners for screen changes
	       */function activateResizing(){var debouncedOnResize=function(scope,target,options){return function(){if(options.isRemoved)return;var updates=calculateMenuPositions(scope,target,options);var container=updates.container;var dropDown=updates.dropDown;container.element.css(animator.toCss(container.styles));dropDown.element.css(animator.toCss(dropDown.styles));};}(scope,element,opts);var window=angular.element($window);window.on('resize',debouncedOnResize);window.on('orientationchange',debouncedOnResize);// Publish deactivation closure...
	return function deactivateResizing(){// Disable resizing handlers
	window.off('resize',debouncedOnResize);window.off('orientationchange',debouncedOnResize);};}/**
	       *  If asynchronously loading, watch and update internal
	       *  '$$loadingAsyncDone' flag
	       */function watchAsyncLoad(){if(opts.loadingAsync&&!opts.isRemoved){scope.$$loadingAsyncDone=false;$q.when(opts.loadingAsync).then(function(){scope.$$loadingAsyncDone=true;delete opts.loadingAsync;}).then(function(){$$rAF(positionAndFocusMenu);});}}/**
	       *
	       */function activateInteraction(){if(opts.isRemoved)return;var dropDown=opts.selectEl;var selectCtrl=dropDown.controller('mdSelectMenu')||{};element.addClass('md-clickable');// Close on backdrop click
	opts.backdrop&&opts.backdrop.on('click',onBackdropClick);// Escape to close
	// Cycling of options, and closing on enter
	dropDown.on('keydown',onMenuKeyDown);dropDown.on('click',checkCloseMenu);return function cleanupInteraction(){opts.backdrop&&opts.backdrop.off('click',onBackdropClick);dropDown.off('keydown',onMenuKeyDown);dropDown.off('click',checkCloseMenu);element.removeClass('md-clickable');opts.isRemoved=true;};// ************************************
	// Closure Functions
	// ************************************
	function onBackdropClick(e){e.preventDefault();e.stopPropagation();opts.restoreFocus=false;$mdUtil.nextTick($mdSelect.hide,true);}function onMenuKeyDown(ev){ev.preventDefault();ev.stopPropagation();switch(ev.keyCode){case keyCodes.UP_ARROW:return focusPrevOption();case keyCodes.DOWN_ARROW:return focusNextOption();case keyCodes.SPACE:case keyCodes.ENTER:var option=$mdUtil.getClosest(ev.target,'md-option');if(option){dropDown.triggerHandler({type:'click',target:option});ev.preventDefault();}checkCloseMenu(ev);break;case keyCodes.TAB:case keyCodes.ESCAPE:ev.stopPropagation();ev.preventDefault();opts.restoreFocus=true;$mdUtil.nextTick($mdSelect.hide,true);break;default:if(shouldHandleKey(ev,$mdConstant)){var optNode=dropDown.controller('mdSelectMenu').optNodeForKeyboardSearch(ev);opts.focusedNode=optNode||opts.focusedNode;optNode&&optNode.focus();}}}function focusOption(direction){var optionsArray=$mdUtil.nodesToArray(opts.optionNodes);var index=optionsArray.indexOf(opts.focusedNode);var newOption;do{if(index===-1){// We lost the previously focused element, reset to first option
	index=0;}else if(direction==='next'&&index<optionsArray.length-1){index++;}else if(direction==='prev'&&index>0){index--;}newOption=optionsArray[index];if(newOption.hasAttribute('disabled'))newOption=undefined;}while(!newOption&&index<optionsArray.length-1&&index>0);newOption&&newOption.focus();opts.focusedNode=newOption;}function focusNextOption(){focusOption('next');}function focusPrevOption(){focusOption('prev');}function checkCloseMenu(ev){if(ev&&ev.type=='click'&&ev.currentTarget!=dropDown[0])return;if(mouseOnScrollbar())return;var option=$mdUtil.getClosest(ev.target,'md-option');if(option&&option.hasAttribute&&!option.hasAttribute('disabled')){ev.preventDefault();ev.stopPropagation();if(!selectCtrl.isMultiple){opts.restoreFocus=true;$mdUtil.nextTick(function(){$mdSelect.hide(selectCtrl.ngModel.$viewValue);},true);}}/**
	           * check if the mouseup event was on a scrollbar
	           */function mouseOnScrollbar(){var clickOnScrollbar=false;if(ev&&ev.currentTarget.children.length>0){var child=ev.currentTarget.children[0];var hasScrollbar=child.scrollHeight>child.clientHeight;if(hasScrollbar&&child.children.length>0){var relPosX=ev.pageX-ev.currentTarget.getBoundingClientRect().left;if(relPosX>child.querySelector('md-option').offsetWidth)clickOnScrollbar=true;}}return clickOnScrollbar;}}}}/**
	     * To notify listeners that the Select menu has closed,
	     * trigger the [optional] user-defined expression
	     */function announceClosed(opts){var mdSelect=opts.selectCtrl;if(mdSelect){var menuController=opts.selectEl.controller('mdSelectMenu');mdSelect.setLabelText(menuController?menuController.selectedLabels():'');mdSelect.triggerClose();}}/**
	     * Calculate the
	     */function calculateMenuPositions(scope,element,opts){var containerNode=element[0],targetNode=opts.target[0].children[0],// target the label
	parentNode=$document[0].body,selectNode=opts.selectEl[0],contentNode=opts.contentEl[0],parentRect=parentNode.getBoundingClientRect(),targetRect=targetNode.getBoundingClientRect(),shouldOpenAroundTarget=false,bounds={left:parentRect.left+SELECT_EDGE_MARGIN,top:SELECT_EDGE_MARGIN,bottom:parentRect.height-SELECT_EDGE_MARGIN,right:parentRect.width-SELECT_EDGE_MARGIN-($mdUtil.floatingScrollbars()?16:0)},spaceAvailable={top:targetRect.top-bounds.top,left:targetRect.left-bounds.left,right:bounds.right-(targetRect.left+targetRect.width),bottom:bounds.bottom-(targetRect.top+targetRect.height)},maxWidth=parentRect.width-SELECT_EDGE_MARGIN*2,selectedNode=selectNode.querySelector('md-option[selected]'),optionNodes=selectNode.getElementsByTagName('md-option'),optgroupNodes=selectNode.getElementsByTagName('md-optgroup'),isScrollable=calculateScrollable(element,contentNode),centeredNode;var loading=isPromiseLike(opts.loadingAsync);if(!loading){// If a selected node, center around that
	if(selectedNode){centeredNode=selectedNode;// If there are option groups, center around the first option group
	}else if(optgroupNodes.length){centeredNode=optgroupNodes[0];// Otherwise - if we are not loading async - center around the first optionNode
	}else if(optionNodes.length){centeredNode=optionNodes[0];// In case there are no options, center on whatever's in there... (eg progress indicator)
	}else{centeredNode=contentNode.firstElementChild||contentNode;}}else{// If loading, center on progress indicator
	centeredNode=contentNode.firstElementChild||contentNode;}if(contentNode.offsetWidth>maxWidth){contentNode.style['max-width']=maxWidth+'px';}else{contentNode.style.maxWidth=null;}if(shouldOpenAroundTarget){contentNode.style['min-width']=targetRect.width+'px';}// Remove padding before we compute the position of the menu
	if(isScrollable){selectNode.classList.add('md-overflow');}var focusedNode=centeredNode;if((focusedNode.tagName||'').toUpperCase()==='MD-OPTGROUP'){focusedNode=optionNodes[0]||contentNode.firstElementChild||contentNode;centeredNode=focusedNode;}// Cache for autoFocus()
	opts.focusedNode=focusedNode;// Get the selectMenuRect *after* max-width is possibly set above
	containerNode.style.display='block';var selectMenuRect=selectNode.getBoundingClientRect();var centeredRect=getOffsetRect(centeredNode);if(centeredNode){var centeredStyle=$window.getComputedStyle(centeredNode);centeredRect.paddingLeft=parseInt(centeredStyle.paddingLeft,10)||0;centeredRect.paddingRight=parseInt(centeredStyle.paddingRight,10)||0;}if(isScrollable){var scrollBuffer=contentNode.offsetHeight/2;contentNode.scrollTop=centeredRect.top+centeredRect.height/2-scrollBuffer;if(spaceAvailable.top<scrollBuffer){contentNode.scrollTop=Math.min(centeredRect.top,contentNode.scrollTop+scrollBuffer-spaceAvailable.top);}else if(spaceAvailable.bottom<scrollBuffer){contentNode.scrollTop=Math.max(centeredRect.top+centeredRect.height-selectMenuRect.height,contentNode.scrollTop-scrollBuffer+spaceAvailable.bottom);}}var left,top,transformOrigin,minWidth,fontSize;if(shouldOpenAroundTarget){left=targetRect.left;top=targetRect.top+targetRect.height;transformOrigin='50% 0';if(top+selectMenuRect.height>bounds.bottom){top=targetRect.top-selectMenuRect.height;transformOrigin='50% 100%';}}else{left=targetRect.left+centeredRect.left-centeredRect.paddingLeft+2;top=Math.floor(targetRect.top+targetRect.height/2-centeredRect.height/2-centeredRect.top+contentNode.scrollTop)+2;transformOrigin=centeredRect.left+targetRect.width/2+'px '+(centeredRect.top+centeredRect.height/2-contentNode.scrollTop)+'px 0px';minWidth=Math.min(targetRect.width+centeredRect.paddingLeft+centeredRect.paddingRight,maxWidth);fontSize=window.getComputedStyle(targetNode)['font-size'];}// Keep left and top within the window
	var containerRect=containerNode.getBoundingClientRect();var scaleX=Math.round(100*Math.min(targetRect.width/selectMenuRect.width,1.0))/100;var scaleY=Math.round(100*Math.min(targetRect.height/selectMenuRect.height,1.0))/100;return{container:{element:angular.element(containerNode),styles:{left:Math.floor(clamp(bounds.left,left,bounds.right-containerRect.width)),top:Math.floor(clamp(bounds.top,top,bounds.bottom-containerRect.height)),'min-width':minWidth,'font-size':fontSize}},dropDown:{element:angular.element(selectNode),styles:{transformOrigin:transformOrigin,transform:!opts.alreadyOpen?$mdUtil.supplant('scale({0},{1})',[scaleX,scaleY]):""}}};}}function isPromiseLike(obj){return obj&&angular.isFunction(obj.then);}function clamp(min,n,max){return Math.max(min,Math.min(n,max));}function getOffsetRect(node){return node?{left:node.offsetLeft,top:node.offsetTop,width:node.offsetWidth,height:node.offsetHeight}:{left:0,top:0,width:0,height:0};}function calculateScrollable(element,contentNode){var isScrollable=false;try{var oldDisplay=element[0].style.display;// Set the element's display to block so that this calculation is correct
	element[0].style.display='block';isScrollable=contentNode.scrollHeight>contentNode.offsetHeight;// Reset it back afterwards
	element[0].style.display=oldDisplay;}finally{// Nothing to do
	}return isScrollable;}}function shouldHandleKey(ev,$mdConstant){var char=String.fromCharCode(ev.keyCode);var isNonUsefulKey=ev.keyCode<=31;return char&&char.length&&!isNonUsefulKey&&!$mdConstant.isMetaKey(ev)&&!$mdConstant.isFnLockKey(ev)&&!$mdConstant.hasModifierKey(ev);}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.sidenav
	 *
	 * @description
	 * A Sidenav QP component.
	 */SidenavService.$inject=["$mdComponentRegistry","$mdUtil","$q","$log"];SidenavDirective.$inject=["$mdMedia","$mdUtil","$mdConstant","$mdTheming","$mdInteraction","$animate","$compile","$parse","$log","$q","$document","$window","$$rAF"];SidenavController.$inject=["$scope","$attrs","$mdComponentRegistry","$q","$interpolate"];angular.module('material.components.sidenav',['material.core','material.components.backdrop']).factory('$mdSidenav',SidenavService).directive('mdSidenav',SidenavDirective).directive('mdSidenavFocus',SidenavFocusDirective).controller('$mdSidenavController',SidenavController);/**
	 * @ngdoc service
	 * @name $mdSidenav
	 * @module material.components.sidenav
	 *
	 * @description
	 * `$mdSidenav` makes it easy to interact with multiple sidenavs
	 * in an app. When looking up a sidenav instance, you can either look
	 * it up synchronously or wait for it to be initializied asynchronously.
	 * This is done by passing the second argument to `$mdSidenav`.
	 *
	 * @usage
	 * <hljs lang="js">
	 * // Async lookup for sidenav instance; will resolve when the instance is available
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Sync lookup for sidenav instance; this will resolve immediately.
	 * $mdSidenav(componentId).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Async toggle the given sidenav;
	 * // when instance is known ready and lazy lookup is not needed.
	 * $mdSidenav(componentId)
	 *    .toggle()
	 *    .then(function(){
	 *      $log.debug('toggled');
	 *    });
	 * // Async open the given sidenav
	 * $mdSidenav(componentId)
	 *    .open()
	 *    .then(function(){
	 *      $log.debug('opened');
	 *    });
	 * // Async close the given sidenav
	 * $mdSidenav(componentId)
	 *    .close()
	 *    .then(function(){
	 *      $log.debug('closed');
	 *    });
	 * // Async lookup for sidenav instance
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   // On close callback to handle close, backdrop click, or escape key pressed.
	 *   // Callback happens BEFORE the close action occurs.
	 *   instance.onClose(function() {
	 *     $log.debug('closing');
	 *   });
	 * });
	 * // Sync check to see if the specified sidenav is set to be open
	 * $mdSidenav(componentId).isOpen();
	 * // Sync check to whether given sidenav is locked open
	 * // If this is true, the sidenav will be open regardless of close()
	 * $mdSidenav(componentId).isLockedOpen();
	 * </hljs>
	 */function SidenavService($mdComponentRegistry,$mdUtil,$q,$log){var errorMsg="SideNav '{0}' is not available! Did you use md-component-id='{0}'?";var service={find:findInstance,//  sync  - returns proxy API
	waitFor:waitForInstance//  async - returns promise
	};/**
	   * Service API that supports three (3) usages:
	   *   $mdSidenav().find("left")                       // sync (must already exist) or returns undefined
	   *   $mdSidenav("left").toggle();                    // sync (must already exist) or returns reject promise;
	   *   $mdSidenav("left",true).then( function(left){   // async returns instance when available
	   *    left.toggle();
	   *   });
	   */return function(handle,enableWait){if(angular.isUndefined(handle))return service;var shouldWait=enableWait===true;var instance=service.find(handle,shouldWait);return!instance&&shouldWait?service.waitFor(handle):!instance&&angular.isUndefined(enableWait)?addLegacyAPI(service,handle):instance;};/**
	   * For failed instance/handle lookups, older-clients expect an response object with noops
	   * that include `rejected promise APIs`
	   */function addLegacyAPI(service,handle){var falseFn=function falseFn(){return false;};var rejectFn=function rejectFn(){return $q.when($mdUtil.supplant(errorMsg,[handle||""]));};return angular.extend({isLockedOpen:falseFn,isOpen:falseFn,toggle:rejectFn,open:rejectFn,close:rejectFn,onClose:angular.noop,then:function then(callback){return waitForInstance(handle).then(callback||angular.noop);}},service);}/**
	     * Synchronously lookup the controller instance for the specified sidNav instance which has been
	     * registered with the markup `md-component-id`
	     */function findInstance(handle,shouldWait){var instance=$mdComponentRegistry.get(handle);if(!instance&&!shouldWait){// Report missing instance
	$log.error($mdUtil.supplant(errorMsg,[handle||""]));// The component has not registered itself... most like NOT yet created
	// return null to indicate that the Sidenav is not in the DOM
	return undefined;}return instance;}/**
	     * Asynchronously wait for the component instantiation,
	     * Deferred lookup of component instance using $component registry
	     */function waitForInstance(handle){return $mdComponentRegistry.when(handle).catch($log.error);}}/**
	 * @ngdoc directive
	 * @name mdSidenavFocus
	 * @module material.components.sidenav
	 *
	 * @restrict A
	 *
	 * @description
	 * `mdSidenavFocus` provides a way to specify the focused element when a sidenav opens.
	 * This is completely optional, as the sidenav itself is focused by default.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-sidenav>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-sidenav-focus>
	 *     </md-input-container>
	 *   </form>
	 * </md-sidenav>
	 * </hljs>
	 **/function SidenavFocusDirective(){return{restrict:'A',require:'^mdSidenav',link:function link(scope,element,attr,sidenavCtrl){// @see $mdUtil.findFocusTarget(...)
	}};}/**
	 * @ngdoc directive
	 * @name mdSidenav
	 * @module material.components.sidenav
	 * @restrict E
	 *
	 * @description
	 *
	 * A Sidenav component that can be opened and closed programatically.
	 *
	 * By default, upon opening it will slide out on top of the main content area.
	 *
	 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
	 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('myApp', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdSidenav) {
	 *   $scope.openLeftMenu = function() {
	 *     $mdSidenav('left').toggle();
	 *   };
	 * });
	 * </hljs>
	 *
	 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
	 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a backdrop.
	 * @param {string=} md-component-id componentId to use with $mdSidenav service.
	 * @param {expression=} md-is-locked-open When this expression evaluates to true,
	 * the sidenav 'locks open': it falls into the content's flow instead
	 * of appearing over it. This overrides the `md-is-open` attribute.
	 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
	 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
	 *
	* The $mdMedia() service is exposed to the is-locked-open attribute, which
	 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
	 * Examples:
	 *
	 *   - `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>` (locks open on small screens)
	 */function SidenavDirective($mdMedia,$mdUtil,$mdConstant,$mdTheming,$mdInteraction,$animate,$compile,$parse,$log,$q,$document,$window,$$rAF){return{restrict:'E',scope:{isOpen:'=?mdIsOpen'},controller:'$mdSidenavController',compile:function compile(element){element.addClass('md-closed').attr('tabIndex','-1');return postLink;}};/**
	   * Directive Post Link function...
	   */function postLink(scope,element,attr,sidenavCtrl){var lastParentOverFlow;var backdrop;var disableScrollTarget=null;var triggeringInteractionType;var triggeringElement=null;var previousContainerStyles;var promise=$q.when(true);var isLockedOpenParsed=$parse(attr.mdIsLockedOpen);var ngWindow=angular.element($window);var isLocked=function isLocked(){return isLockedOpenParsed(scope.$parent,{$media:function $media(arg){$log.warn("$media is deprecated for is-locked-open. Use $mdMedia instead.");return $mdMedia(arg);},$mdMedia:$mdMedia});};if(attr.mdDisableScrollTarget){disableScrollTarget=$document[0].querySelector(attr.mdDisableScrollTarget);if(disableScrollTarget){disableScrollTarget=angular.element(disableScrollTarget);}else{$log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching '+'selector "{selector}". Falling back to parent.',{selector:attr.mdDisableScrollTarget}));}}if(!disableScrollTarget){disableScrollTarget=element.parent();}// Only create the backdrop if the backdrop isn't disabled.
	if(!attr.hasOwnProperty('mdDisableBackdrop')){backdrop=$mdUtil.createBackdrop(scope,"md-sidenav-backdrop md-opaque ng-enter");}element.addClass('_md');// private md component indicator for styling
	$mdTheming(element);// The backdrop should inherit the sidenavs theme,
	// because the backdrop will take its parent theme by default.
	if(backdrop)$mdTheming.inherit(backdrop,element);element.on('$destroy',function(){backdrop&&backdrop.remove();sidenavCtrl.destroy();});scope.$on('$destroy',function(){backdrop&&backdrop.remove();});scope.$watch(isLocked,updateIsLocked);scope.$watch('isOpen',updateIsOpen);// Publish special accessor for the Controller instance
	sidenavCtrl.$toggleOpen=toggleOpen;/**
	     * Toggle the DOM classes to indicate `locked`
	     * @param isLocked
	     */function updateIsLocked(isLocked,oldValue){scope.isLockedOpen=isLocked;if(isLocked===oldValue){element.toggleClass('md-locked-open',!!isLocked);}else{$animate[isLocked?'addClass':'removeClass'](element,'md-locked-open');}if(backdrop){backdrop.toggleClass('md-locked-open',!!isLocked);}}/**
	     * Toggle the SideNav view and attach/detach listeners
	     * @param isOpen
	     */function updateIsOpen(isOpen){// Support deprecated md-sidenav-focus attribute as fallback
	var focusEl=$mdUtil.findFocusTarget(element)||$mdUtil.findFocusTarget(element,'[md-sidenav-focus]')||element;var parent=element.parent();parent[isOpen?'on':'off']('keydown',onKeyDown);if(backdrop)backdrop[isOpen?'on':'off']('click',close);var restorePositioning=updateContainerPositions(parent,isOpen);if(isOpen){// Capture upon opening..
	triggeringElement=$document[0].activeElement;triggeringInteractionType=$mdInteraction.getLastInteractionType();}disableParentScroll(isOpen);return promise=$q.all([isOpen&&backdrop?$animate.enter(backdrop,parent):backdrop?$animate.leave(backdrop):$q.when(true),$animate[isOpen?'removeClass':'addClass'](element,'md-closed')]).then(function(){// Perform focus when animations are ALL done...
	if(scope.isOpen){$$rAF(function(){// Notifies child components that the sidenav was opened. Should wait
	// a frame in order to allow for the element height to be computed.
	ngWindow.triggerHandler('resize');});focusEl&&focusEl.focus();}// Restores the positioning on the sidenav and backdrop.
	restorePositioning&&restorePositioning();});}function updateContainerPositions(parent,willOpen){var drawerEl=element[0];var scrollTop=parent[0].scrollTop;if(willOpen&&scrollTop){previousContainerStyles={top:drawerEl.style.top,bottom:drawerEl.style.bottom,height:drawerEl.style.height};// When the parent is scrolled down, then we want to be able to show the sidenav at the current scroll
	// position. We're moving the sidenav down to the correct scroll position and apply the height of the
	// parent, to increase the performance. Using 100% as height, will impact the performance heavily.
	var positionStyle={top:scrollTop+'px',bottom:'auto',height:parent[0].clientHeight+'px'};// Apply the new position styles to the sidenav and backdrop.
	element.css(positionStyle);backdrop.css(positionStyle);}// When the sidenav is closing and we have previous defined container styles,
	// then we return a restore function, which resets the sidenav and backdrop.
	if(!willOpen&&previousContainerStyles){return function(){drawerEl.style.top=previousContainerStyles.top;drawerEl.style.bottom=previousContainerStyles.bottom;drawerEl.style.height=previousContainerStyles.height;backdrop[0].style.top=null;backdrop[0].style.bottom=null;backdrop[0].style.height=null;previousContainerStyles=null;};}}/**
	     * Prevent parent scrolling (when the SideNav is open)
	     */function disableParentScroll(disabled){if(disabled&&!lastParentOverFlow){lastParentOverFlow=disableScrollTarget.css('overflow');disableScrollTarget.css('overflow','hidden');}else if(angular.isDefined(lastParentOverFlow)){disableScrollTarget.css('overflow',lastParentOverFlow);lastParentOverFlow=undefined;}}/**
	     * Toggle the sideNav view and publish a promise to be resolved when
	     * the view animation finishes.
	     *
	     * @param isOpen
	     * @returns {*}
	     */function toggleOpen(isOpen){if(scope.isOpen==isOpen){return $q.when(true);}else{if(scope.isOpen&&sidenavCtrl.onCloseCb)sidenavCtrl.onCloseCb();return $q(function(resolve){// Toggle value to force an async `updateIsOpen()` to run
	scope.isOpen=isOpen;$mdUtil.nextTick(function(){// When the current `updateIsOpen()` animation finishes
	promise.then(function(result){if(!scope.isOpen&&triggeringElement&&triggeringInteractionType==='keyboard'){// reset focus to originating element (if available) upon close
	triggeringElement.focus();triggeringElement=null;}resolve(result);});});});}}/**
	     * Auto-close sideNav when the `escape` key is pressed.
	     * @param evt
	     */function onKeyDown(ev){var isEscape=ev.keyCode===$mdConstant.KEY_CODE.ESCAPE;return isEscape?close(ev):$q.when(true);}/**
	     * With backdrop `clicks` or `escape` key-press, immediately
	     * apply the CSS close transition... Then notify the controller
	     * to close() and perform its own actions.
	     */function close(ev){ev.preventDefault();return sidenavCtrl.close();}}}/*
	 * @private
	 * @ngdoc controller
	 * @name SidenavController
	 * @module material.components.sidenav
	 */function SidenavController($scope,$attrs,$mdComponentRegistry,$q,$interpolate){var self=this;// Use Default internal method until overridden by directive postLink
	// Synchronous getters
	self.isOpen=function(){return!!$scope.isOpen;};self.isLockedOpen=function(){return!!$scope.isLockedOpen;};// Synchronous setters
	self.onClose=function(callback){self.onCloseCb=callback;return self;};// Async actions
	self.open=function(){return self.$toggleOpen(true);};self.close=function(){return self.$toggleOpen(false);};self.toggle=function(){return self.$toggleOpen(!$scope.isOpen);};self.$toggleOpen=function(value){return $q.when($scope.isOpen=value);};// Evaluate the component id.
	var rawId=$attrs.mdComponentId;var hasDataBinding=rawId&&rawId.indexOf($interpolate.startSymbol())>-1;var componentId=hasDataBinding?$interpolate(rawId)($scope.$parent):rawId;// Register the component.
	self.destroy=$mdComponentRegistry.register(self,componentId);// Watch and update the component, if the id has changed.
	if(hasDataBinding){$attrs.$observe('mdComponentId',function(id){if(id&&id!==self.$$mdHandle){self.destroy();// `destroy` only deregisters the old component id so we can add the new one.
	self.destroy=$mdComponentRegistry.register(self,id);}});}}})();(function(){"use strict";/**
	   * @ngdoc module
	   * @name material.components.slider
	   */SliderDirective.$inject=["$$rAF","$window","$mdAria","$mdUtil","$mdConstant","$mdTheming","$mdGesture","$parse","$log","$timeout"];angular.module('material.components.slider',['material.core']).directive('mdSlider',SliderDirective).directive('mdSliderContainer',SliderContainerDirective);/**
	 * @ngdoc directive
	 * @name mdSliderContainer
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider-container>` contains slider with two other elements.
	 *
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * </hljs>
	 */function SliderContainerDirective(){return{controller:function controller(){},compile:function compile(elem){var slider=elem.find('md-slider');if(!slider){return;}var vertical=slider.attr('md-vertical');if(vertical!==undefined){elem.attr('md-vertical','');}if(!slider.attr('flex')){slider.attr('flex','');}return function postLink(scope,element,attr,ctrl){element.addClass('_md');// private md component indicator for styling
	// We have to manually stop the $watch on ngDisabled because it exists
	// on the parent scope, and won't be automatically destroyed when
	// the component is destroyed.
	function setDisable(value){element.children().attr('disabled',value);element.find('input').attr('disabled',value);}var stopDisabledWatch=angular.noop;if(attr.disabled){setDisable(true);}else if(attr.ngDisabled){stopDisabledWatch=scope.$watch(attr.ngDisabled,function(value){setDisable(value);});}scope.$on('$destroy',function(){stopDisabledWatch();});var initialMaxWidth;ctrl.fitInputWidthToTextLength=function(length){var input=element[0].querySelector('md-input-container');if(input){var computedStyle=getComputedStyle(input);var minWidth=parseInt(computedStyle.minWidth);var padding=parseInt(computedStyle.padding)*2;initialMaxWidth=initialMaxWidth||parseInt(computedStyle.maxWidth);var newMaxWidth=Math.max(initialMaxWidth,minWidth+padding+minWidth/2*length);input.style.maxWidth=newMaxWidth+'px';}};};}};}/**
	 * @ngdoc directive
	 * @name mdSlider
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider>` component allows the user to choose from a range of
	 * values.
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the slider is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * It has two modes: 'normal' mode, where the user slides between a wide range
	 * of values, and 'discrete' mode, where the user slides between only a few
	 * select values.
	 *
	 * To enable discrete mode, add the `md-discrete` attribute to a slider,
	 * and use the `step` attribute to change the distance between
	 * values the user is allowed to pick.
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * <md-slider ng-model="myValue" min="5" max="500">
	 * </md-slider>
	 * </hljs>
	 * <h4>Discrete Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 * <h4>Invert Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 *
	 * @param {boolean=} md-discrete Whether to enable discrete mode.
	 * @param {boolean=} md-invert Whether to enable invert mode.
	 * @param {number=} step The distance between values the user is allowed to pick. Default 1.
	 * @param {number=} min The minimum value the user is allowed to pick. Default 0.
	 * @param {number=} max The maximum value the user is allowed to pick. Default 100.
	 * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
	 */function SliderDirective($$rAF,$window,$mdAria,$mdUtil,$mdConstant,$mdTheming,$mdGesture,$parse,$log,$timeout){return{scope:{},require:['?ngModel','?^mdSliderContainer'],template:'<div class="md-slider-wrapper">'+'<div class="md-slider-content">'+'<div class="md-track-container">'+'<div class="md-track"></div>'+'<div class="md-track md-track-fill"></div>'+'<div class="md-track-ticks"></div>'+'</div>'+'<div class="md-thumb-container">'+'<div class="md-thumb"></div>'+'<div class="md-focus-thumb"></div>'+'<div class="md-focus-ring"></div>'+'<div class="md-sign">'+'<span class="md-thumb-text"></span>'+'</div>'+'<div class="md-disabled-thumb"></div>'+'</div>'+'</div>'+'</div>',compile:compile};// **********************************************************
	// Private Methods
	// **********************************************************
	function compile(tElement,tAttrs){var wrapper=angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));var tabIndex=tAttrs.tabindex||0;wrapper.attr('tabindex',tabIndex);if(tAttrs.disabled||tAttrs.ngDisabled)wrapper.attr('tabindex',-1);tElement.attr('role','slider');$mdAria.expect(tElement,'aria-label');return postLink;}function postLink(scope,element,attr,ctrls){$mdTheming(element);var ngModelCtrl=ctrls[0]||{// Mock ngModelController if it doesn't exist to give us
	// the minimum functionality needed
	$setViewValue:function $setViewValue(val){this.$viewValue=val;this.$viewChangeListeners.forEach(function(cb){cb();});},$parsers:[],$formatters:[],$viewChangeListeners:[]};var containerCtrl=ctrls[1];var container=angular.element($mdUtil.getClosest(element,'_md-slider-container',true));var isDisabled=attr.ngDisabled?angular.bind(null,$parse(attr.ngDisabled),scope.$parent):function(){return element[0].hasAttribute('disabled');};var thumb=angular.element(element[0].querySelector('.md-thumb'));var thumbText=angular.element(element[0].querySelector('.md-thumb-text'));var thumbContainer=thumb.parent();var trackContainer=angular.element(element[0].querySelector('.md-track-container'));var activeTrack=angular.element(element[0].querySelector('.md-track-fill'));var tickContainer=angular.element(element[0].querySelector('.md-track-ticks'));var wrapper=angular.element(element[0].getElementsByClassName('md-slider-wrapper'));var content=angular.element(element[0].getElementsByClassName('md-slider-content'));var throttledRefreshDimensions=$mdUtil.throttle(refreshSliderDimensions,5000);// Default values, overridable by attrs
	var DEFAULT_ROUND=3;var vertical=angular.isDefined(attr.mdVertical);var discrete=angular.isDefined(attr.mdDiscrete);var invert=angular.isDefined(attr.mdInvert);angular.isDefined(attr.min)?attr.$observe('min',updateMin):updateMin(0);angular.isDefined(attr.max)?attr.$observe('max',updateMax):updateMax(100);angular.isDefined(attr.step)?attr.$observe('step',updateStep):updateStep(1);angular.isDefined(attr.round)?attr.$observe('round',updateRound):updateRound(DEFAULT_ROUND);// We have to manually stop the $watch on ngDisabled because it exists
	// on the parent scope, and won't be automatically destroyed when
	// the component is destroyed.
	var stopDisabledWatch=angular.noop;if(attr.ngDisabled){stopDisabledWatch=scope.$parent.$watch(attr.ngDisabled,updateAriaDisabled);}$mdGesture.register(wrapper,'drag',{horizontal:!vertical});scope.mouseActive=false;wrapper.on('keydown',keydownListener).on('mousedown',mouseDownListener).on('focus',focusListener).on('blur',blurListener).on('$md.pressdown',onPressDown).on('$md.pressup',onPressUp).on('$md.dragstart',onDragStart).on('$md.drag',onDrag).on('$md.dragend',onDragEnd);// On resize, recalculate the slider's dimensions and re-render
	function updateAll(){refreshSliderDimensions();ngModelRender();}setTimeout(updateAll,0);var debouncedUpdateAll=$$rAF.throttle(updateAll);angular.element($window).on('resize',debouncedUpdateAll);scope.$on('$destroy',function(){angular.element($window).off('resize',debouncedUpdateAll);});ngModelCtrl.$render=ngModelRender;ngModelCtrl.$viewChangeListeners.push(ngModelRender);ngModelCtrl.$formatters.push(minMaxValidator);ngModelCtrl.$formatters.push(stepValidator);/**
	     * Attributes
	     */var min;var max;var step;var round;function updateMin(value){min=parseFloat(value);element.attr('aria-valuemin',value);updateAll();}function updateMax(value){max=parseFloat(value);element.attr('aria-valuemax',value);updateAll();}function updateStep(value){step=parseFloat(value);}function updateRound(value){// Set max round digits to 6, after 6 the input uses scientific notation
	round=minMaxValidator(parseInt(value),0,6);}function updateAriaDisabled(){element.attr('aria-disabled',!!isDisabled());}// Draw the ticks with canvas.
	// The alternative to drawing ticks with canvas is to draw one element for each tick,
	// which could quickly become a performance bottleneck.
	var tickCanvas,tickCtx;function redrawTicks(){if(!discrete||isDisabled())return;if(angular.isUndefined(step))return;if(step<=0){var msg='Slider step value must be greater than zero when in discrete mode';$log.error(msg);throw new Error(msg);}var numSteps=Math.floor((max-min)/step);if(!tickCanvas){tickCanvas=angular.element('<canvas>').css('position','absolute');tickContainer.append(tickCanvas);tickCtx=tickCanvas[0].getContext('2d');}var dimensions=getSliderDimensions();// If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
	if(dimensions&&!dimensions.height&&!dimensions.width){refreshSliderDimensions();dimensions=sliderDimensions;}tickCanvas[0].width=dimensions.width;tickCanvas[0].height=dimensions.height;var distance;for(var i=0;i<=numSteps;i++){var trackTicksStyle=$window.getComputedStyle(tickContainer[0]);tickCtx.fillStyle=trackTicksStyle.color||'black';distance=Math.floor((vertical?dimensions.height:dimensions.width)*(i/numSteps));tickCtx.fillRect(vertical?0:distance-1,vertical?distance-1:0,vertical?dimensions.width:2,vertical?2:dimensions.height);}}function clearTicks(){if(tickCanvas&&tickCtx){var dimensions=getSliderDimensions();tickCtx.clearRect(0,0,dimensions.width,dimensions.height);}}/**
	     * Refreshing Dimensions
	     */var sliderDimensions={};refreshSliderDimensions();function refreshSliderDimensions(){sliderDimensions=trackContainer[0].getBoundingClientRect();}function getSliderDimensions(){throttledRefreshDimensions();return sliderDimensions;}/**
	     * left/right/up/down arrow listener
	     */function keydownListener(ev){if(isDisabled())return;var changeAmount;if(vertical?ev.keyCode===$mdConstant.KEY_CODE.DOWN_ARROW:ev.keyCode===$mdConstant.KEY_CODE.LEFT_ARROW){changeAmount=-step;}else if(vertical?ev.keyCode===$mdConstant.KEY_CODE.UP_ARROW:ev.keyCode===$mdConstant.KEY_CODE.RIGHT_ARROW){changeAmount=step;}changeAmount=invert?-changeAmount:changeAmount;if(changeAmount){if(ev.metaKey||ev.ctrlKey||ev.altKey){changeAmount*=4;}ev.preventDefault();ev.stopPropagation();scope.$evalAsync(function(){setModelValue(ngModelCtrl.$viewValue+changeAmount);});}}function mouseDownListener(){redrawTicks();scope.mouseActive=true;wrapper.removeClass('md-focused');$timeout(function(){scope.mouseActive=false;},100);}function focusListener(){if(scope.mouseActive===false){wrapper.addClass('md-focused');}}function blurListener(){wrapper.removeClass('md-focused');element.removeClass('md-active');clearTicks();}/**
	     * ngModel setters and validators
	     */function setModelValue(value){ngModelCtrl.$setViewValue(minMaxValidator(stepValidator(value)));}function ngModelRender(){if(isNaN(ngModelCtrl.$viewValue)){ngModelCtrl.$viewValue=ngModelCtrl.$modelValue;}ngModelCtrl.$viewValue=minMaxValidator(ngModelCtrl.$viewValue);var percent=valueToPercent(ngModelCtrl.$viewValue);scope.modelValue=ngModelCtrl.$viewValue;element.attr('aria-valuenow',ngModelCtrl.$viewValue);setSliderPercent(percent);thumbText.text(ngModelCtrl.$viewValue);}function minMaxValidator(value,minValue,maxValue){if(angular.isNumber(value)){minValue=angular.isNumber(minValue)?minValue:min;maxValue=angular.isNumber(maxValue)?maxValue:max;return Math.max(minValue,Math.min(maxValue,value));}}function stepValidator(value){if(angular.isNumber(value)){var formattedValue=Math.round((value-min)/step)*step+min;formattedValue=Math.round(formattedValue*Math.pow(10,round))/Math.pow(10,round);if(containerCtrl&&containerCtrl.fitInputWidthToTextLength){$mdUtil.debounce(function(){containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);},100)();}return formattedValue;}}/**
	     * @param percent 0-1
	     */function setSliderPercent(percent){percent=clamp(percent);var thumbPosition=percent*100+'%';var activeTrackPercent=invert?(1-percent)*100+'%':thumbPosition;if(vertical){thumbContainer.css('bottom',thumbPosition);}else{$mdUtil.bidiProperty(thumbContainer,'left','right',thumbPosition);}activeTrack.css(vertical?'height':'width',activeTrackPercent);element.toggleClass(invert?'md-max':'md-min',percent===0);element.toggleClass(invert?'md-min':'md-max',percent===1);}/**
	     * Slide listeners
	     */var isDragging=false;function onPressDown(ev){if(isDisabled())return;element.addClass('md-active');element[0].focus();refreshSliderDimensions();var exactVal=percentToValue(positionToPercent(vertical?ev.pointer.y:ev.pointer.x));var closestVal=minMaxValidator(stepValidator(exactVal));scope.$apply(function(){setModelValue(closestVal);setSliderPercent(valueToPercent(closestVal));});}function onPressUp(ev){if(isDisabled())return;element.removeClass('md-dragging');var exactVal=percentToValue(positionToPercent(vertical?ev.pointer.y:ev.pointer.x));var closestVal=minMaxValidator(stepValidator(exactVal));scope.$apply(function(){setModelValue(closestVal);ngModelRender();});}function onDragStart(ev){if(isDisabled())return;isDragging=true;ev.stopPropagation();element.addClass('md-dragging');setSliderFromEvent(ev);}function onDrag(ev){if(!isDragging)return;ev.stopPropagation();setSliderFromEvent(ev);}function onDragEnd(ev){if(!isDragging)return;ev.stopPropagation();isDragging=false;}function setSliderFromEvent(ev){// While panning discrete, update only the
	// visual positioning but not the model value.
	if(discrete)adjustThumbPosition(vertical?ev.pointer.y:ev.pointer.x);else doSlide(vertical?ev.pointer.y:ev.pointer.x);}/**
	     * Slide the UI by changing the model value
	     * @param x
	     */function doSlide(x){scope.$evalAsync(function(){setModelValue(percentToValue(positionToPercent(x)));});}/**
	     * Slide the UI without changing the model (while dragging/panning)
	     * @param x
	     */function adjustThumbPosition(x){var exactVal=percentToValue(positionToPercent(x));var closestVal=minMaxValidator(stepValidator(exactVal));setSliderPercent(positionToPercent(x));thumbText.text(closestVal);}/**
	    * Clamps the value to be between 0 and 1.
	    * @param {number} value The value to clamp.
	    * @returns {number}
	    */function clamp(value){return Math.max(0,Math.min(value||0,1));}/**
	     * Convert position on slider to percentage value of offset from beginning...
	     * @param position
	     * @returns {number}
	     */function positionToPercent(position){var offset=vertical?sliderDimensions.top:sliderDimensions.left;var size=vertical?sliderDimensions.height:sliderDimensions.width;var calc=(position-offset)/size;if(!vertical&&$mdUtil.bidi()==='rtl'){calc=1-calc;}return Math.max(0,Math.min(1,vertical?1-calc:calc));}/**
	     * Convert percentage offset on slide to equivalent model value
	     * @param percent
	     * @returns {*}
	     */function percentToValue(percent){var adjustedPercent=invert?1-percent:percent;return min+adjustedPercent*(max-min);}function valueToPercent(val){var percent=(val-min)/(max-min);return invert?1-percent:percent;}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.sticky
	 * @description
	 * Sticky effects for md
	 *
	 */MdSticky.$inject=["$mdConstant","$$rAF","$mdUtil","$compile"];angular.module('material.components.sticky',['material.core','material.components.content']).factory('$mdSticky',MdSticky);/**
	 * @ngdoc service
	 * @name $mdSticky
	 * @module material.components.sticky
	 *
	 * @description
	 * The `$mdSticky`service provides a mixin to make elements sticky.
	 *
	 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will just
	 * use the native browser stickiness.
	 *
	 * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
	 * parameter, in the same scope as the actual element lives.
	 *
	 *
	 * <h3>Notes</h3>
	 * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
	 * you should compile the clone yourself using the plain template.<br/><br/>
	 * See the right usage below:
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickySelect', function($mdSticky, $compile) {
	 *       var SELECT_TEMPLATE =
	 *         '<md-select ng-model="selected">' +
	 *           '<md-option>Option 1</md-option>' +
	 *         '</md-select>';
	 *
	 *       return {
	 *         restrict: 'E',
	 *         replace: true,
	 *         template: SELECT_TEMPLATE,
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickyText', function($mdSticky, $compile) {
	 *       return {
	 *         restrict: 'E',
	 *         template: '<span>Sticky Text</span>',
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element);
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @returns A `$mdSticky` function that takes three arguments:
	 *   - `scope`
	 *   - `element`: The element that will be 'sticky'
	 *   - `elementClone`: A clone of the element, that will be shown
	 *     when the user starts scrolling past the original element.
	 *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
	 */function MdSticky($mdConstant,$$rAF,$mdUtil,$compile){var browserStickySupport=$mdUtil.checkStickySupport();/**
	   * Registers an element as sticky, used internally by directives to register themselves
	   */return function registerStickyElement(scope,element,stickyClone){var contentCtrl=element.controller('mdContent');if(!contentCtrl)return;if(browserStickySupport){element.css({position:browserStickySupport,top:0,'z-index':2});}else{var $$sticky=contentCtrl.$element.data('$$sticky');if(!$$sticky){$$sticky=setupSticky(contentCtrl);contentCtrl.$element.data('$$sticky',$$sticky);}// Compile our cloned element, when cloned in this service, into the given scope.
	var cloneElement=stickyClone||$compile(element.clone())(scope);var deregister=$$sticky.add(element,cloneElement);scope.$on('$destroy',deregister);}};function setupSticky(contentCtrl){var contentEl=contentCtrl.$element;// Refresh elements is very expensive, so we use the debounced
	// version when possible.
	var debouncedRefreshElements=$$rAF.throttle(refreshElements);// setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
	// more reliable than `scroll` on android.
	setupAugmentedScrollEvents(contentEl);contentEl.on('$scrollstart',debouncedRefreshElements);contentEl.on('$scroll',onScroll);var self;return self={prev:null,current:null,//the currently stickied item
	next:null,items:[],add:add,refreshElements:refreshElements};/***************
	     * Public
	     ***************/// Add an element and its sticky clone to this content's sticky collection
	function add(element,stickyClone){stickyClone.addClass('md-sticky-clone');var item={element:element,clone:stickyClone};self.items.push(item);$mdUtil.nextTick(function(){contentEl.prepend(item.clone);});debouncedRefreshElements();return function remove(){self.items.forEach(function(item,index){if(item.element[0]===element[0]){self.items.splice(index,1);item.clone.remove();}});debouncedRefreshElements();};}function refreshElements(){// Sort our collection of elements by their current position in the DOM.
	// We need to do this because our elements' order of being added may not
	// be the same as their order of display.
	self.items.forEach(refreshPosition);self.items=self.items.sort(function(a,b){return a.top<b.top?-1:1;});// Find which item in the list should be active, 
	// based upon the content's current scroll position
	var item;var currentScrollTop=contentEl.prop('scrollTop');for(var i=self.items.length-1;i>=0;i--){if(currentScrollTop>self.items[i].top){item=self.items[i];break;}}setCurrentItem(item);}/***************
	     * Private
	     ***************/// Find the `top` of an item relative to the content element,
	// and also the height.
	function refreshPosition(item){// Find the top of an item by adding to the offsetHeight until we reach the 
	// content element.
	var current=item.element[0];item.top=0;item.left=0;item.right=0;while(current&&current!==contentEl[0]){item.top+=current.offsetTop;item.left+=current.offsetLeft;if(current.offsetParent){item.right+=current.offsetParent.offsetWidth-current.offsetWidth-current.offsetLeft;//Compute offsetRight
	}current=current.offsetParent;}item.height=item.element.prop('offsetHeight');var defaultVal=$mdUtil.floatingScrollbars()?'0':undefined;$mdUtil.bidi(item.clone,'margin-left',item.left,defaultVal);$mdUtil.bidi(item.clone,'margin-right',defaultVal,item.right);}// As we scroll, push in and select the correct sticky element.
	function onScroll(){var scrollTop=contentEl.prop('scrollTop');var isScrollingDown=scrollTop>(onScroll.prevScrollTop||0);// Store the previous scroll so we know which direction we are scrolling
	onScroll.prevScrollTop=scrollTop;//
	// AT TOP (not scrolling)
	//
	if(scrollTop===0){// If we're at the top, just clear the current item and return
	setCurrentItem(null);return;}//
	// SCROLLING DOWN (going towards the next item)
	//
	if(isScrollingDown){// If we've scrolled down past the next item's position, sticky it and return
	if(self.next&&self.next.top<=scrollTop){setCurrentItem(self.next);return;}// If the next item is close to the current one, push the current one up out of the way
	if(self.current&&self.next&&self.next.top-scrollTop<=self.next.height){translate(self.current,scrollTop+(self.next.top-self.next.height-scrollTop));return;}}//
	// SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
	//
	if(!isScrollingDown){// If we've scrolled up past the previous item's position, sticky it and return
	if(self.current&&self.prev&&scrollTop<self.current.top){setCurrentItem(self.prev);return;}// If the next item is close to the current one, pull the current one down into view
	if(self.next&&self.current&&scrollTop>=self.next.top-self.current.height){translate(self.current,scrollTop+(self.next.top-scrollTop-self.current.height));return;}}//
	// Otherwise, just move the current item to the proper place (scrolling up or down)
	//
	if(self.current){translate(self.current,scrollTop);}}function setCurrentItem(item){if(self.current===item)return;// Deactivate currently active item
	if(self.current){translate(self.current,null);setStickyState(self.current,null);}// Activate new item if given
	if(item){setStickyState(item,'active');}self.current=item;var index=self.items.indexOf(item);// If index === -1, index + 1 = 0. It works out.
	self.next=self.items[index+1];self.prev=self.items[index-1];setStickyState(self.next,'next');setStickyState(self.prev,'prev');}function setStickyState(item,state){if(!item||item.state===state)return;if(item.state){item.clone.attr('sticky-prev-state',item.state);item.element.attr('sticky-prev-state',item.state);}item.clone.attr('sticky-state',state);item.element.attr('sticky-state',state);item.state=state;}function translate(item,amount){if(!item)return;if(amount===null||amount===undefined){if(item.translateY){item.translateY=null;item.clone.css($mdConstant.CSS.TRANSFORM,'');}}else{item.translateY=amount;$mdUtil.bidi(item.clone,$mdConstant.CSS.TRANSFORM,'translate3d('+item.left+'px,'+amount+'px,0)','translateY('+amount+'px)');}}}// Android 4.4 don't accurately give scroll events.
	// To fix this problem, we setup a fake scroll event. We say:
	// > If a scroll or touchmove event has happened in the last DELAY milliseconds, 
	//   then send a `$scroll` event every animationFrame.
	// Additionally, we add $scrollstart and $scrollend events.
	function setupAugmentedScrollEvents(element){var SCROLL_END_DELAY=200;var isScrolling;var lastScrollTime;element.on('scroll touchmove',function(){if(!isScrolling){isScrolling=true;$$rAF.throttle(loopScrollEvent);element.triggerHandler('$scrollstart');}element.triggerHandler('$scroll');lastScrollTime=+$mdUtil.now();});function loopScrollEvent(){if(+$mdUtil.now()-lastScrollTime>SCROLL_END_DELAY){isScrolling=false;element.triggerHandler('$scrollend');}else{element.triggerHandler('$scroll');$$rAF.throttle(loopScrollEvent);}}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.subheader
	 * @description
	 * SubHeader module
	 *
	 *  Subheaders are special list tiles that delineate distinct sections of a
	 *  list or grid list and are typically related to the current filtering or
	 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
	 *  can be associated with content, for example, in an adjacent column.
	 *
	 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
	 *  pinned until pushed on or off screen by the next subheader. @see [Material
	 *  Design Specifications](https://www.google.com/design/spec/components/subheaders.html)
	 *
	 *  > To improve the visual grouping of content, use the system color for your subheaders.
	 *
	 */MdSubheaderDirective.$inject=["$mdSticky","$compile","$mdTheming","$mdUtil","$mdAria"];angular.module('material.components.subheader',['material.core','material.components.sticky']).directive('mdSubheader',MdSubheaderDirective);/**
	 * @ngdoc directive
	 * @name mdSubheader
	 * @module material.components.subheader
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-subheader` directive creates a sticky subheader for a section.
	 *
	 * Developers are able to disable the stickiness of the subheader by using the following markup
	 *
	 * <hljs lang="html">
	 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
	 * </hljs>
	 *
	 * ### Notes
	 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
	 * to make the subheader sticky.
	 *
	 * > Whenever the current browser doesn't support stickiness natively, the subheader
	 * will be compiled twice to create a sticky clone of the subheader.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-subheader>Online Friends</md-subheader>
	 * </hljs>
	 */function MdSubheaderDirective($mdSticky,$compile,$mdTheming,$mdUtil,$mdAria){return{restrict:'E',replace:true,transclude:true,template:'<div class="md-subheader _md">'+'  <div class="md-subheader-inner">'+'    <div class="md-subheader-content"></div>'+'  </div>'+'</div>',link:function postLink(scope,element,attr,controllers,transclude){$mdTheming(element);element.addClass('_md');// Remove the ngRepeat attribute from the root element, because we don't want to compile
	// the ngRepeat for the sticky clone again.
	$mdUtil.prefixer().removeAttribute(element,'ng-repeat');var outerHTML=element[0].outerHTML;function getContent(el){return angular.element(el[0].querySelector('.md-subheader-content'));}// Set the ARIA attributes on the original element since it keeps it's original place in
	// the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
	// in order to avoid having multiple element be marked as headers.
	attr.$set('role','heading');$mdAria.expect(element,'aria-level','2');// Transclude the user-given contents of the subheader
	// the conventional way.
	transclude(scope,function(clone){getContent(element).append(clone);});// Create another clone, that uses the outer and inner contents
	// of the element, that will be 'stickied' as the user scrolls.
	if(!element.hasClass('md-no-sticky')){transclude(scope,function(clone){// If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
	// compiled clone below will only be a comment tag (since they replace their elements with
	// a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
	// DIV to ensure we have something $mdSticky can use
	var wrapper=$compile('<div class="md-subheader-wrapper" aria-hidden="true">'+outerHTML+'</div>')(scope);// Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
	// attempting to create the clone
	$mdUtil.nextTick(function(){// Append our transcluded clone into the wrapper.
	// We don't have to recompile the element again, because the clone is already
	// compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
	// our ngIf's and other previous registered bindings / properties.
	getContent(wrapper).append(clone);});// Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
	// element.
	$mdSticky(scope,element,wrapper);});}}};}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.swipe
	 * @description Swipe module!
	 *//**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeLeft
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
	 * left.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-left` directive by using `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-left="onSwipeLeft($event, $target)">Swipe me left!</div>
	 * </hljs>
	 *//**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeRight
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
	 * right.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-right` directive by using `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-right="onSwipeRight($event, $target)">Swipe me right!</div>
	 * </hljs>
	 *//**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeUp
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
	 * up.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-up` directive by using `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-up="onSwipeUp($event, $target)">Swipe me up!</div>
	 * </hljs>
	 *//**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeDown
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
	 * down.
	 *
	 * ### Notes
	 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
	 * reference to the element that actually holds the `md-swipe-down` directive by using `$target.current`
	 *
	 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer Tools console while swiping).
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-down="onSwipDown($event, $target)">Swipe me down!</div>
	 * </hljs>
	 */angular.module('material.components.swipe',['material.core']).directive('mdSwipeLeft',getDirective('SwipeLeft')).directive('mdSwipeRight',getDirective('SwipeRight')).directive('mdSwipeUp',getDirective('SwipeUp')).directive('mdSwipeDown',getDirective('SwipeDown'));function getDirective(name){DirectiveFactory.$inject=["$parse"];var directiveName='md'+name;var eventName='$md.'+name.toLowerCase();return DirectiveFactory;/* @ngInject */function DirectiveFactory($parse){return{restrict:'A',link:postLink};function postLink(scope,element,attr){var fn=$parse(attr[directiveName]);element.on(eventName,function(ev){var currentTarget=ev.currentTarget;scope.$applyAsync(function(){fn(scope,{$event:ev,$target:{current:currentTarget}});});});}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.switch
	 */MdSwitch.$inject=["mdCheckboxDirective","$mdUtil","$mdConstant","$parse","$$rAF","$mdGesture","$timeout"];angular.module('material.components.switch',['material.core','material.components.checkbox']).directive('mdSwitch',MdSwitch);/**
	 * @ngdoc directive
	 * @module material.components.switch
	 * @name mdSwitch
	 * @restrict E
	 *
	 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the switch is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {expression} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {expression=} ng-change Expression to be executed when the model value changes.
	 * @param {expression=} ng-disabled En/Disable based on the expression.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
	 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
	 * @param {boolean=} md-invert When set to true, the switch will be inverted.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-switch ng-model="isActive" aria-label="Finished?">
	 *   Finished ?
	 * </md-switch>
	 *
	 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-switch>
	 *
	 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-switch>
	 *
	 * </hljs>
	 */function MdSwitch(mdCheckboxDirective,$mdUtil,$mdConstant,$parse,$$rAF,$mdGesture,$timeout){var checkboxDirective=mdCheckboxDirective[0];return{restrict:'E',priority:$mdConstant.BEFORE_NG_ARIA,transclude:true,template:'<div class="md-container">'+'<div class="md-bar"></div>'+'<div class="md-thumb-container">'+'<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>'+'</div>'+'</div>'+'<div ng-transclude class="md-label"></div>',require:['^?mdInputContainer','?ngModel','?^form'],compile:mdSwitchCompile};function mdSwitchCompile(element,attr){var checkboxLink=checkboxDirective.compile(element,attr).post;// No transition on initial load.
	element.addClass('md-dragging');return function(scope,element,attr,ctrls){var containerCtrl=ctrls[0];var ngModel=ctrls[1]||$mdUtil.fakeNgModel();var formCtrl=ctrls[2];var disabledGetter=null;if(attr.disabled!=null){disabledGetter=function disabledGetter(){return true;};}else if(attr.ngDisabled){disabledGetter=$parse(attr.ngDisabled);}var thumbContainer=angular.element(element[0].querySelector('.md-thumb-container'));var switchContainer=angular.element(element[0].querySelector('.md-container'));var labelContainer=angular.element(element[0].querySelector('.md-label'));// no transition on initial load
	$$rAF(function(){element.removeClass('md-dragging');});checkboxLink(scope,element,attr,ctrls);if(disabledGetter){scope.$watch(disabledGetter,function(isDisabled){element.attr('tabindex',isDisabled?-1:0);});}attr.$observe('mdInvert',function(newValue){var isInverted=$mdUtil.parseAttributeBoolean(newValue);isInverted?element.prepend(labelContainer):element.prepend(switchContainer);// Toggle a CSS class to update the margin.
	element.toggleClass('md-inverted',isInverted);});// These events are triggered by setup drag
	$mdGesture.register(switchContainer,'drag');switchContainer.on('$md.dragstart',onDragStart).on('$md.drag',onDrag).on('$md.dragend',onDragEnd);var drag;function onDragStart(ev){// Don't go if the switch is disabled.
	if(disabledGetter&&disabledGetter(scope))return;ev.stopPropagation();element.addClass('md-dragging');drag={width:thumbContainer.prop('offsetWidth')};}function onDrag(ev){if(!drag)return;ev.stopPropagation();ev.srcEvent&&ev.srcEvent.preventDefault();var percent=ev.pointer.distanceX/drag.width;//if checked, start from right. else, start from left
	var translate=ngModel.$viewValue?1+percent:percent;// Make sure the switch stays inside its bounds, 0-1%
	translate=Math.max(0,Math.min(1,translate));thumbContainer.css($mdConstant.CSS.TRANSFORM,'translate3d('+100*translate+'%,0,0)');drag.translate=translate;}function onDragEnd(ev){if(!drag)return;ev.stopPropagation();element.removeClass('md-dragging');thumbContainer.css($mdConstant.CSS.TRANSFORM,'');// We changed if there is no distance (this is a click a click),
	// or if the drag distance is >50% of the total.
	var isChanged=ngModel.$viewValue?drag.translate<0.5:drag.translate>0.5;if(isChanged){applyModelValue(!ngModel.$viewValue);}drag=null;// Wait for incoming mouse click
	scope.skipToggle=true;$timeout(function(){scope.skipToggle=false;},1);}function applyModelValue(newValue){scope.$apply(function(){ngModel.$setViewValue(newValue);ngModel.$render();});}};}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.tabs
	 * @description
	 *
	 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
	 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
	 *
	 *  Features include support for:
	 *
	 *  - static or dynamic tabs,
	 *  - responsive designs,
	 *  - accessibility support (ARIA),
	 *  - tab pagination,
	 *  - external or internal tab content,
	 *  - focus indicators and arrow-key navigations,
	 *  - programmatic lookup and access to tab controllers, and
	 *  - dynamic transitions through different tab contents.
	 *
	 *//*
	 * @see js folder for tabs implementation
	 */angular.module('material.components.tabs',['material.core','material.components.icon']);})();(function(){"use strict";angular.module('material.components.tabs').service('MdTabsPaginationService',MdTabsPaginationService);/**
	 * @private
	 * @module material.components.tabs
	 * @name MdTabsPaginationService
	 * @description Provides many standalone functions to ease in pagination calculations.
	 *
	 * Most functions accept the elements and the current offset.
	 *
	 * The `elements` parameter is typically the value returned from the `getElements()` function of the
	 * tabsController.
	 *
	 * The `offset` parameter is always positive regardless of LTR or RTL (we simply make the LTR one
	 * negative when we apply our transform). This is typically the `ctrl.leftOffset` variable in the
	 * tabsController.
	 *
	 * @returns MdTabsPaginationService
	 * @constructor
	 */function MdTabsPaginationService(){return{decreasePageOffset:decreasePageOffset,increasePageOffset:increasePageOffset,getTabOffsets:getTabOffsets,getTotalTabsWidth:getTotalTabsWidth};/**
	   * Returns the offset for the next decreasing page.
	   *
	   * @param elements
	   * @param currentOffset
	   * @returns {number}
	   */function decreasePageOffset(elements,currentOffset){var canvas=elements.canvas,tabOffsets=getTabOffsets(elements),i,firstVisibleTabOffset;// Find the first fully visible tab in offset range
	for(i=0;i<tabOffsets.length;i++){if(tabOffsets[i]>=currentOffset){firstVisibleTabOffset=tabOffsets[i];break;}}// Return (the first visible tab offset - the tabs container width) without going negative
	return Math.max(0,firstVisibleTabOffset-canvas.clientWidth);}/**
	   * Returns the offset for the next increasing page.
	   *
	   * @param elements
	   * @param currentOffset
	   * @returns {number}
	   */function increasePageOffset(elements,currentOffset){var canvas=elements.canvas,maxOffset=getTotalTabsWidth(elements)-canvas.clientWidth,tabOffsets=getTabOffsets(elements),i,firstHiddenTabOffset;// Find the first partially (or fully) invisible tab
	for(i=0;i<tabOffsets.length,tabOffsets[i]<=currentOffset+canvas.clientWidth;i++){firstHiddenTabOffset=tabOffsets[i];}// Return the offset of the first hidden tab, or the maximum offset (whichever is smaller)
	return Math.min(maxOffset,firstHiddenTabOffset);}/**
	   * Returns the offsets of all of the tabs based on their widths.
	   *
	   * @param elements
	   * @returns {number[]}
	   */function getTabOffsets(elements){var i,tab,currentOffset=0,offsets=[];for(i=0;i<elements.tabs.length;i++){tab=elements.tabs[i];offsets.push(currentOffset);currentOffset+=tab.offsetWidth;}return offsets;}/**
	   * Sum the width of all tabs.
	   *
	   * @param elements
	   * @returns {number}
	   */function getTotalTabsWidth(elements){var sum=0,i,tab;for(i=0;i<elements.tabs.length;i++){tab=elements.tabs[i];sum+=tab.offsetWidth;}return sum;}}})();(function(){"use strict";/**
	  * @ngdoc module
	  * @name material.components.toast
	  * @description
	  * Toast
	  */MdToastDirective.$inject=["$mdToast"];MdToastProvider.$inject=["$$interimElementProvider"];angular.module('material.components.toast',['material.core','material.components.button']).directive('mdToast',MdToastDirective).provider('$mdToast',MdToastProvider);/* @ngInject */function MdToastDirective($mdToast){return{restrict:'E',link:function postLink(scope,element){element.addClass('_md');// private md component indicator for styling
	// When navigation force destroys an interimElement, then
	// listen and $destroy() that interim instance...
	scope.$on('$destroy',function(){$mdToast.destroy();});}};}/**
	  * @ngdoc service
	  * @name $mdToast
	  * @module material.components.toast
	  *
	  * @description
	  * `$mdToast` is a service to build a toast notification on any position
	  * on the screen with an optional duration, and provides a simple promise API.
	  *
	  * The toast will be always positioned at the `bottom`, when the screen size is
	  * between `600px` and `959px` (`sm` breakpoint)
	  *
	  * ## Restrictions on custom toasts
	  * - The toast's template must have an outer `<md-toast>` element.
	  * - For a toast action, use element with class `md-action`.
	  * - Add the class `md-capsule` for curved corners.
	  *
	  * ### Custom Presets
	  * Developers are also able to create their own preset, which can be easily used without repeating
	  * their options each time.
	  *
	  * <hljs lang="js">
	  *   $mdToastProvider.addPreset('testPreset', {
	  *     options: function() {
	  *       return {
	  *         template:
	  *           '<md-toast>' +
	  *             '<div class="md-toast-content">' +
	  *               'This is a custom preset' +
	  *             '</div>' +
	  *           '</md-toast>',
	  *         controllerAs: 'toast',
	  *         bindToController: true
	  *       };
	  *     }
	  *   });
	  * </hljs>
	  *
	  * After you created your preset at config phase, you can easily access it.
	  *
	  * <hljs lang="js">
	  *   $mdToast.show(
	  *     $mdToast.testPreset()
	  *   );
	  * </hljs>
	  *
	  * ## Parent container notes
	  *
	  * The toast is positioned using absolute positioning relative to its first non-static parent
	  * container. Thus, if the requested parent container uses static positioning, we will temporarily
	  * set its positioning to `relative` while the toast is visible and reset it when the toast is
	  * hidden.
	  *
	  * Because of this, it is usually best to ensure that the parent container has a fixed height and
	  * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
	  * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
	  *
	  * You can, however, have a scrollable element inside of the container; just make sure the
	  * container itself does not scroll.
	  *
	  * <hljs lang="html">
	  * <div layout-fill id="toast-container">
	  *   <md-content>
	  *     I can have lots of content and scroll!
	  *   </md-content>
	  * </div>
	  * </hljs>
	  *
	  * @usage
	  * <hljs lang="html">
	  * <div ng-controller="MyController">
	  *   <md-button ng-click="openToast()">
	  *     Open a Toast!
	  *   </md-button>
	  * </div>
	  * </hljs>
	  *
	  * <hljs lang="js">
	  * var app = angular.module('app', ['ngMaterial']);
	  * app.controller('MyController', function($scope, $mdToast) {
	  *   $scope.openToast = function($event) {
	  *     $mdToast.show($mdToast.simple().textContent('Hello!'));
	  *     // Could also do $mdToast.showSimple('Hello');
	  *   };
	  * });
	  * </hljs>
	  *//**
	 * @ngdoc method
	 * @name $mdToast#showSimple
	 *
	 * @param {string} message The message to display inside the toast
	 * @description
	 * Convenience method which builds and shows a simple toast.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	 * rejected with `$mdToast.cancel()`.
	 *
	 *//**
	  * @ngdoc method
	  * @name $mdToast#simple
	  *
	  * @description
	  * Builds a preconfigured toast.
	  *
	  * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
	  *
	  * _**Note:** These configuration methods are provided in addition to the methods provided by
	  * the `build()` and `show()` methods below._
	  *
	  * <table class="md-api-table methods">
	  *    <thead>
	  *      <tr>
	  *        <th>Method</th>
	  *        <th>Description</th>
	  *      </tr>
	  *    </thead>
	  *    <tbody>
	  *      <tr>
	  *        <td>`.textContent(string)`</td>
	  *        <td>Sets the toast content to the specified string</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.action(string)`</td>
	  *        <td>
	  *          Adds an action button. <br/>
	  *          If clicked, the promise (returned from `show()`)
	  *          will resolve with the value `'ok'`; otherwise, it is resolved with `true` after a `hideDelay`
	  *          timeout
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightAction(boolean)`</td>
	  *        <td>
	  *          Whether or not the action button will have an additional highlight class.<br/>
	  *          By default the `accent` color will be applied to the action button.
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightClass(string)`</td>
	  *        <td>
	  *          If set, the given class will be applied to the highlighted action button.<br/>
	  *          This allows you to specify the highlight color easily. Highlight classes are `md-primary`, `md-warn`
	  *          and `md-accent`
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.capsule(boolean)`</td>
	  *        <td>Whether or not to add the `md-capsule` class to the toast to provide rounded corners</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.theme(string)`</td>
	  *        <td>Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s default.</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.toastClass(string)`</td>
	  *        <td>Sets a class on the toast element</td>
	  *      </tr>
	  *    </tbody>
	  * </table>
	  *
	  *//**
	  * @ngdoc method
	  * @name $mdToast#updateTextContent
	  *
	  * @description
	  * Updates the content of an existing toast. Useful for updating things like counts, etc.
	  *
	  *//**
	  * @ngdoc method
	  * @name $mdToast#build
	  *
	  * @description
	  * Creates a custom `$mdToastPreset` that you can configure.
	  *
	  * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options (see below).
	  *//**
	  * @ngdoc method
	  * @name $mdToast#show
	  *
	  * @description Shows the toast.
	  *
	  * @param {object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
	  * and `build()`, or an options object with the following properties:
	  *
	  *   - `templateUrl` - `{string=}`: The url of an html template file that will
	  *     be used as the content of the toast. Restrictions: the template must
	  *     have an outer `md-toast` element.
	  *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	  *     template string.
	  *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
	  *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled if you provide a
	  *     custom toast directive.
	  *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	  *     This scope will be destroyed when the toast is removed unless `preserveScope` is set to true.
	  *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	  *   - `hideDelay` - `{number=}`: How many milliseconds the toast should stay
	  *     active before automatically closing.  Set to 0 or false to have the toast stay open until
	  *     closed manually. Default: 3000.
	  *   - `position` - `{string=}`: Sets the position of the toast. <br/>
	  *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'` and `'start'`.
	  *     The properties `'end'` and `'start'` are dynamic and can be used for RTL support.<br/>
	  *     Default combination: `'bottom left'`.
	  *   - `toastClass` - `{string=}`: A class to set on the toast element.
	  *   - `controller` - `{string=}`: The controller to associate with this toast.
	  *     The controller will be injected the local `$mdToast.hide( )`, which is a function
	  *     used to hide the toast.
	  *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	  *     be used as names of values to inject into the controller. For example,
	  *     `locals: {three: 3}` would inject `three` into the controller with the value
	  *     of 3.
	  *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	  *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	  *     and the toast will not open until the promises resolve.
	  *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	  *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
	  *     to the root element of the application.
	  *
	  * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	  * rejected with `$mdToast.cancel()`. `$mdToast.hide()` will resolve either with a Boolean
	  * value == 'true' or the value passed as an argument to `$mdToast.hide()`.
	  * And `$mdToast.cancel()` will resolve the promise with a Boolean value == 'false'
	  *//**
	  * @ngdoc method
	  * @name $mdToast#hide
	  *
	  * @description
	  * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the resolved promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM.
	  * The promise is resolved with either a Boolean value == 'true' or the value passed as the
	  * argument to `.hide()`.
	  *
	  *//**
	  * @ngdoc method
	  * @name $mdToast#cancel
	  *
	  * @description
	  * `DEPRECATED` - The promise returned from opening a toast is used only to notify about the closing of the toast.
	  * As such, there isn't any reason to also allow that promise to be rejected,
	  * since it's not clear what the difference between resolve and reject would be.
	  *
	  * Hide the existing toast and reject the promise returned from
	  * `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the rejected promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM
	  * The promise is resolved with a Boolean value == 'false'.
	  *
	  */function MdToastProvider($$interimElementProvider){// Differentiate promise resolves: hide timeout (value == true) and hide action clicks (value == ok).
	MdToastController.$inject=["$mdToast","$scope"];toastDefaultOptions.$inject=["$animate","$mdToast","$mdUtil","$mdMedia"];var ACTION_RESOLVE='ok';var activeToastContent;var $mdToast=$$interimElementProvider('$mdToast').setDefaults({methods:['position','hideDelay','capsule','parent','position','toastClass'],options:toastDefaultOptions}).addPreset('simple',{argOption:'textContent',methods:['textContent','content','action','highlightAction','highlightClass','theme','parent'],options:/* @ngInject */["$mdToast","$mdTheming",function($mdToast,$mdTheming){return{template:'<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">'+'  <div class="md-toast-content">'+'    <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">'+'      {{ toast.content }}'+'    </span>'+'    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" '+'        ng-class="highlightClasses">'+'      {{ toast.action }}'+'    </md-button>'+'  </div>'+'</md-toast>',controller:MdToastController,theme:$mdTheming.defaultTheme(),controllerAs:'toast',bindToController:true};}]}).addMethod('updateTextContent',updateTextContent).addMethod('updateContent',updateTextContent);function updateTextContent(newContent){activeToastContent=newContent;}return $mdToast;/**
	   * Controller for the Toast interim elements.
	   * @ngInject
	   */function MdToastController($mdToast,$scope){// For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
	// interimElements. The $mdCompiler simulates the $onInit hook for all versions.
	this.$onInit=function(){var self=this;if(self.highlightAction){$scope.highlightClasses=['md-highlight',self.highlightClass];}$scope.$watch(function(){return activeToastContent;},function(){self.content=activeToastContent;});this.resolve=function(){$mdToast.hide(ACTION_RESOLVE);};};}/* @ngInject */function toastDefaultOptions($animate,$mdToast,$mdUtil,$mdMedia){var SWIPE_EVENTS='$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';return{onShow:onShow,onRemove:onRemove,toastClass:'',position:'bottom left',themable:true,hideDelay:3000,autoWrap:true,transformTemplate:function transformTemplate(template,options){var shouldAddWrapper=options.autoWrap&&template&&!/md-toast-content/g.test(template);if(shouldAddWrapper){// Root element of template will be <md-toast>. We need to wrap all of its content inside of
	// of <div class="md-toast-content">. All templates provided here should be static, developer-controlled
	// content (meaning we're not attempting to guard against XSS).
	var templateRoot=document.createElement('md-template');templateRoot.innerHTML=template;// Iterate through all root children, to detect possible md-toast directives.
	for(var i=0;i<templateRoot.children.length;i++){if(templateRoot.children[i].nodeName==='MD-TOAST'){var wrapper=angular.element('<div class="md-toast-content">');// Wrap the children of the `md-toast` directive in jqLite, to be able to append multiple
	// nodes with the same execution.
	wrapper.append(angular.element(templateRoot.children[i].childNodes));// Append the new wrapped element to the `md-toast` directive.
	templateRoot.children[i].appendChild(wrapper[0]);}}// We have to return the innerHTMl, because we do not want to have the `md-template` element to be
	// the root element of our interimElement.
	return templateRoot.innerHTML;}return template||'';}};function onShow(scope,element,options){activeToastContent=options.textContent||options.content;// support deprecated #content method
	var isSmScreen=!$mdMedia('gt-sm');element=$mdUtil.extractElementByName(element,'md-toast',true);options.element=element;options.onSwipe=function(ev,gesture){//Add the relevant swipe class to the element so it can animate correctly
	var swipe=ev.type.replace('$md.','');var direction=swipe.replace('swipe','');// If the swipe direction is down/up but the toast came from top/bottom don't fade away
	// Unless the screen is small, then the toast always on bottom
	if(direction==='down'&&options.position.indexOf('top')!=-1&&!isSmScreen||direction==='up'&&(options.position.indexOf('bottom')!=-1||isSmScreen)){return;}if((direction==='left'||direction==='right')&&isSmScreen){return;}element.addClass('md-'+swipe);$mdUtil.nextTick($mdToast.cancel);};options.openClass=toastOpenClass(options.position);element.addClass(options.toastClass);// 'top left' -> 'md-top md-left'
	options.parent.addClass(options.openClass);// static is the default position
	if($mdUtil.hasComputedStyle(options.parent,'position','static')){options.parent.css('position','relative');}element.on(SWIPE_EVENTS,options.onSwipe);element.addClass(isSmScreen?'md-bottom':options.position.split(' ').map(function(pos){return'md-'+pos;}).join(' '));if(options.parent)options.parent.addClass('md-toast-animating');return $animate.enter(element,options.parent).then(function(){if(options.parent)options.parent.removeClass('md-toast-animating');});}function onRemove(scope,element,options){element.off(SWIPE_EVENTS,options.onSwipe);if(options.parent)options.parent.addClass('md-toast-animating');if(options.openClass)options.parent.removeClass(options.openClass);return(options.$destroy==true?element.remove():$animate.leave(element)).then(function(){if(options.parent)options.parent.removeClass('md-toast-animating');if($mdUtil.hasComputedStyle(options.parent,'position','static')){options.parent.css('position','');}});}function toastOpenClass(position){// For mobile, always open full-width on bottom
	if(!$mdMedia('gt-xs')){return'md-toast-open-bottom';}return'md-toast-open-'+(position.indexOf('top')>-1?'top':'bottom');}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.toolbar
	 */mdToolbarDirective.$inject=["$$rAF","$mdConstant","$mdUtil","$mdTheming","$animate"];angular.module('material.components.toolbar',['material.core','material.components.content']).directive('mdToolbar',mdToolbarDirective);/**
	 * @ngdoc directive
	 * @name mdToolbar
	 * @module material.components.toolbar
	 * @restrict E
	 * @description
	 * `md-toolbar` is used to place a toolbar in your app.
	 *
	 * Toolbars are usually used above a content area to display the title of the
	 * current page, and show relevant action buttons for that page.
	 *
	 * You can change the height of the toolbar by adding either the
	 * `md-medium-tall` or `md-tall` class to the toolbar.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="column" layout-fill>
	 *   <md-toolbar>
	 *
	 *     <div class="md-toolbar-tools">
	 *       <h2 md-truncate flex>My App's Title</h2>
	 *
	 *       <md-button>
	 *         Right Bar Button
	 *       </md-button>
	 *     </div>
	 *
	 *   </md-toolbar>
	 *   <md-content>
	 *     Hello!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
	 * ellipsis if the title is longer than the width of the Toolbar.</i>
	 *
	 * ## CSS & Styles
	 *
	 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
	 * functionality of your toolbar.
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
	 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
	 *     buttons and text. When applied, it will center the buttons and text vertically for you.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 *
	 * ### Private Classes
	 *
	 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
	 * considered public.
	 *
	 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
	 * the user scrolls down, and reveal itself as the user scrolls up.
	 *
	 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
	 * `md-content` element, placed before it. See the scroll shrink demo._
	 *
	 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
	 * initialization, it does not watch for scope changes._
	 *
	 *
	 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
	 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
	 * at one fourth the rate at which the user scrolls down. Default 0.5.
	 *
	 */function mdToolbarDirective($$rAF,$mdConstant,$mdUtil,$mdTheming,$animate){var translateY=angular.bind(null,$mdUtil.supplant,'translate3d(0,{0}px,0)');return{template:'',restrict:'E',link:function link(scope,element,attr){element.addClass('_md');// private md component indicator for styling
	$mdTheming(element);$mdUtil.nextTick(function(){element.addClass('_md-toolbar-transitions');// adding toolbar transitions after digest
	},false);if(angular.isDefined(attr.mdScrollShrink)){setupScrollShrink();}function setupScrollShrink(){var toolbarHeight;var contentElement;var disableScrollShrink=angular.noop;// Current "y" position of scroll
	// Store the last scroll top position
	var y=0;var prevScrollTop=0;var shrinkSpeedFactor=attr.mdShrinkSpeedFactor||0.5;var debouncedContentScroll=$$rAF.throttle(onContentScroll);var debouncedUpdateHeight=$mdUtil.debounce(updateToolbarHeight,5*1000);// Wait for $mdContentLoaded event from mdContent directive.
	// If the mdContent element is a sibling of our toolbar, hook it up
	// to scroll events.
	scope.$on('$mdContentLoaded',onMdContentLoad);// If the toolbar is used inside an ng-if statement, we may miss the
	// $mdContentLoaded event, so we attempt to fake it if we have a
	// md-content close enough.
	attr.$observe('mdScrollShrink',onChangeScrollShrink);// If the toolbar has ngShow or ngHide we need to update height immediately as it changed
	// and not wait for $mdUtil.debounce to happen
	if(attr.ngShow){scope.$watch(attr.ngShow,updateToolbarHeight);}if(attr.ngHide){scope.$watch(attr.ngHide,updateToolbarHeight);}// If the scope is destroyed (which could happen with ng-if), make sure
	// to disable scroll shrinking again
	scope.$on('$destroy',disableScrollShrink);/**
	         *
	         */function onChangeScrollShrink(shrinkWithScroll){var closestContent=element.parent().find('md-content');// If we have a content element, fake the call; this might still fail
	// if the content element isn't a sibling of the toolbar
	if(!contentElement&&closestContent.length){onMdContentLoad(null,closestContent);}// Evaluate the expression
	shrinkWithScroll=scope.$eval(shrinkWithScroll);// Disable only if the attribute's expression evaluates to false
	if(shrinkWithScroll===false){disableScrollShrink();}else{disableScrollShrink=enableScrollShrink();}}/**
	         *
	         */function onMdContentLoad($event,newContentEl){// Toolbar and content must be siblings
	if(newContentEl&&element.parent()[0]===newContentEl.parent()[0]){// unhook old content event listener if exists
	if(contentElement){contentElement.off('scroll',debouncedContentScroll);}contentElement=newContentEl;disableScrollShrink=enableScrollShrink();}}/**
	         *
	         */function onContentScroll(e){var scrollTop=e?e.target.scrollTop:prevScrollTop;debouncedUpdateHeight();y=Math.min(toolbarHeight/shrinkSpeedFactor,Math.max(0,y+scrollTop-prevScrollTop));element.css($mdConstant.CSS.TRANSFORM,translateY([-y*shrinkSpeedFactor]));contentElement.css($mdConstant.CSS.TRANSFORM,translateY([(toolbarHeight-y)*shrinkSpeedFactor]));prevScrollTop=scrollTop;$mdUtil.nextTick(function(){var hasWhiteFrame=element.hasClass('md-whiteframe-z1');if(hasWhiteFrame&&!y){$animate.removeClass(element,'md-whiteframe-z1');}else if(!hasWhiteFrame&&y){$animate.addClass(element,'md-whiteframe-z1');}});}/**
	         *
	         */function enableScrollShrink(){if(!contentElement)return angular.noop;// no md-content
	contentElement.on('scroll',debouncedContentScroll);contentElement.attr('scroll-shrink','true');$mdUtil.nextTick(updateToolbarHeight,false);return function disableScrollShrink(){contentElement.off('scroll',debouncedContentScroll);contentElement.attr('scroll-shrink','false');updateToolbarHeight();};}/**
	         *
	         */function updateToolbarHeight(){toolbarHeight=element.prop('offsetHeight');// Add a negative margin-top the size of the toolbar to the content el.
	// The content will start transformed down the toolbarHeight amount,
	// so everything looks normal.
	//
	// As the user scrolls down, the content will be transformed up slowly
	// to put the content underneath where the toolbar was.
	var margin=-toolbarHeight*shrinkSpeedFactor+'px';contentElement.css({"margin-top":margin,"margin-bottom":margin});onContentScroll();}}}};}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.tooltip
	 */MdTooltipDirective.$inject=["$timeout","$window","$$rAF","$document","$interpolate","$mdUtil","$mdPanel","$$mdTooltipRegistry"];angular.module('material.components.tooltip',['material.core','material.components.panel']).directive('mdTooltip',MdTooltipDirective).service('$$mdTooltipRegistry',MdTooltipRegistry);/**
	 * @ngdoc directive
	 * @name mdTooltip
	 * @module material.components.tooltip
	 * @description
	 * Tooltips are used to describe elements that are interactive and primarily
	 * graphical (not textual).
	 *
	 * Place a `<md-tooltip>` as a child of the element it describes.
	 *
	 * A tooltip will activate when the user hovers over, focuses, or touches the
	 * parent element.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-button class="md-fab md-accent" aria-label="Play">
	 *     <md-tooltip>Play Music</md-tooltip>
	 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
	 *   </md-button>
	 * </hljs>
	 *
	 * @param {number=} md-z-index The visual level that the tooltip will appear
	 *     in comparison with the rest of the elements of the application.
	 * @param {expression=} md-visible Boolean bound to whether the tooltip is
	 *     currently visible.
	 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
	 *     after the user hovers over, focuses, or touches the parent element.
	 *     Defaults to 0ms on non-touch devices and 75ms on touch.
	 * @param {boolean=} md-autohide If present or provided with a boolean value,
	 *     the tooltip will hide on mouse leave, regardless of focus.
	 * @param {string=} md-direction The direction that the tooltip is shown,
	 *     relative to the parent element. Supports top, right, bottom, and left.
	 *     Defaults to bottom.
	 */function MdTooltipDirective($timeout,$window,$$rAF,$document,$interpolate,$mdUtil,$mdPanel,$$mdTooltipRegistry){var ENTER_EVENTS='focus touchstart mouseenter';var LEAVE_EVENTS='blur touchcancel mouseleave';var TOOLTIP_DEFAULT_Z_INDEX=100;var TOOLTIP_DEFAULT_SHOW_DELAY=0;var TOOLTIP_DEFAULT_DIRECTION='bottom';var TOOLTIP_DIRECTIONS={top:{x:$mdPanel.xPosition.CENTER,y:$mdPanel.yPosition.ABOVE},right:{x:$mdPanel.xPosition.OFFSET_END,y:$mdPanel.yPosition.CENTER},bottom:{x:$mdPanel.xPosition.CENTER,y:$mdPanel.yPosition.BELOW},left:{x:$mdPanel.xPosition.OFFSET_START,y:$mdPanel.yPosition.CENTER}};return{restrict:'E',priority:210,// Before ngAria
	scope:{mdZIndex:'=?mdZIndex',mdDelay:'=?mdDelay',mdVisible:'=?mdVisible',mdAutohide:'=?mdAutohide',mdDirection:'@?mdDirection'// Do not expect expressions.
	},link:linkFunc};function linkFunc(scope,element,attr){// Set constants.
	var tooltipId='md-tooltip-'+$mdUtil.nextUid();var parent=$mdUtil.getParentWithPointerEvents(element);var debouncedOnResize=$$rAF.throttle(updatePosition);var mouseActive=false;var origin,position,panelPosition,panelRef,autohide,showTimeout,elementFocusedOnWindowBlur=null;// Set defaults
	setDefaults();// Set parent aria-label.
	addAriaLabel();// Remove the element from its current DOM position.
	element.detach();updatePosition();bindEvents();configureWatchers();function setDefaults(){scope.mdZIndex=scope.mdZIndex||TOOLTIP_DEFAULT_Z_INDEX;scope.mdDelay=scope.mdDelay||TOOLTIP_DEFAULT_SHOW_DELAY;if(!TOOLTIP_DIRECTIONS[scope.mdDirection]){scope.mdDirection=TOOLTIP_DEFAULT_DIRECTION;}}function addAriaLabel(labelText){// Only interpolate the text from the HTML element because otherwise the custom text could
	// be interpolated twice and cause XSS violations.
	var interpolatedText=labelText||$interpolate(element.text().trim())(scope.$parent);// Only add the `aria-label` to the parent if there isn't already one, if there isn't an
	// already present `aria-labelledby`, or if the previous `aria-label` was added by the
	// tooltip directive.
	if(!parent.attr('aria-label')&&!parent.attr('aria-labelledby')||parent.attr('md-labeled-by-tooltip')){parent.attr('aria-label',interpolatedText);// Set the `md-labeled-by-tooltip` attribute if it has not already been set.
	if(!parent.attr('md-labeled-by-tooltip')){parent.attr('md-labeled-by-tooltip',tooltipId);}}}function updatePosition(){setDefaults();// If the panel has already been created, remove the current origin
	// class from the panel element.
	if(panelRef&&panelRef.panelEl){panelRef.panelEl.removeClass(origin);}// Set the panel element origin class based off of the current
	// mdDirection.
	origin='md-origin-'+scope.mdDirection;// Create the position of the panel based off of the mdDirection.
	position=TOOLTIP_DIRECTIONS[scope.mdDirection];// Using the newly created position object, use the MdPanel
	// panelPosition API to build the panel's position.
	panelPosition=$mdPanel.newPanelPosition().relativeTo(parent).addPanelPosition(position.x,position.y);// If the panel has already been created, add the new origin class to
	// the panel element and update it's position with the panelPosition.
	if(panelRef&&panelRef.panelEl){panelRef.panelEl.addClass(origin);panelRef.updatePosition(panelPosition);}}function bindEvents(){// Add a mutationObserver where there is support for it and the need
	// for it in the form of viable host(parent[0]).
	if(parent[0]&&'MutationObserver'in $window){// Use a mutationObserver to tackle #2602.
	var attributeObserver=new MutationObserver(function(mutations){if(isDisabledMutation(mutations)){$mdUtil.nextTick(function(){setVisible(false);});}});attributeObserver.observe(parent[0],{attributes:true});}elementFocusedOnWindowBlur=false;$$mdTooltipRegistry.register('scroll',windowScrollEventHandler,true);$$mdTooltipRegistry.register('blur',windowBlurEventHandler);$$mdTooltipRegistry.register('resize',debouncedOnResize);scope.$on('$destroy',onDestroy);// To avoid 'synthetic clicks', we listen to mousedown instead of
	// 'click'.
	parent.on('mousedown',mousedownEventHandler);parent.on(ENTER_EVENTS,enterEventHandler);function isDisabledMutation(mutations){mutations.some(function(mutation){return mutation.attributeName==='disabled'&&parent[0].disabled;});return false;}function windowScrollEventHandler(){setVisible(false);}function windowBlurEventHandler(){elementFocusedOnWindowBlur=document.activeElement===parent[0];}function enterEventHandler($event){// Prevent the tooltip from showing when the window is receiving
	// focus.
	if($event.type==='focus'&&elementFocusedOnWindowBlur){elementFocusedOnWindowBlur=false;}else if(!scope.mdVisible){parent.on(LEAVE_EVENTS,leaveEventHandler);setVisible(true);// If the user is on a touch device, we should bind the tap away
	// after the 'touched' in order to prevent the tooltip being
	// removed immediately.
	if($event.type==='touchstart'){parent.one('touchend',function(){$mdUtil.nextTick(function(){$document.one('touchend',leaveEventHandler);},false);});}}}function leaveEventHandler(){autohide=scope.hasOwnProperty('mdAutohide')?scope.mdAutohide:attr.hasOwnProperty('mdAutohide');if(autohide||mouseActive||$document[0].activeElement!==parent[0]){// When a show timeout is currently in progress, then we have
	// to cancel it, otherwise the tooltip will remain showing
	// without focus or hover.
	if(showTimeout){$timeout.cancel(showTimeout);setVisible.queued=false;showTimeout=null;}parent.off(LEAVE_EVENTS,leaveEventHandler);parent.triggerHandler('blur');setVisible(false);}mouseActive=false;}function mousedownEventHandler(){mouseActive=true;}function onDestroy(){$$mdTooltipRegistry.deregister('scroll',windowScrollEventHandler,true);$$mdTooltipRegistry.deregister('blur',windowBlurEventHandler);$$mdTooltipRegistry.deregister('resize',debouncedOnResize);parent.off(ENTER_EVENTS,enterEventHandler).off(LEAVE_EVENTS,leaveEventHandler).off('mousedown',mousedownEventHandler);// Trigger the handler in case any of the tooltips are
	// still visible.
	leaveEventHandler();attributeObserver&&attributeObserver.disconnect();}}function configureWatchers(){if(element[0]&&'MutationObserver'in $window){var attributeObserver=new MutationObserver(function(mutations){mutations.forEach(function(mutation){if(mutation.attributeName==='md-visible'&&!scope.visibleWatcher){scope.visibleWatcher=scope.$watch('mdVisible',onVisibleChanged);}});});attributeObserver.observe(element[0],{attributes:true});// Build watcher only if mdVisible is being used.
	if(attr.hasOwnProperty('mdVisible')){scope.visibleWatcher=scope.$watch('mdVisible',onVisibleChanged);}}else{// MutationObserver not supported
	scope.visibleWatcher=scope.$watch('mdVisible',onVisibleChanged);}// Direction watcher
	scope.$watch('mdDirection',updatePosition);// Clean up if the element or parent was removed via jqLite's .remove.
	// A couple of notes:
	//   - In these cases the scope might not have been destroyed, which
	//     is why we destroy it manually. An example of this can be having
	//     `md-visible="false"` and adding tooltips while they're
	//     invisible. If `md-visible` becomes true, at some point, you'd
	//     usually get a lot of tooltips.
	//   - We use `.one`, not `.on`, because this only needs to fire once.
	//     If we were using `.on`, it would get thrown into an infinite
	//     loop.
	//   - This kicks off the scope's `$destroy` event which finishes the
	//     cleanup.
	element.one('$destroy',onElementDestroy);parent.one('$destroy',onElementDestroy);scope.$on('$destroy',function(){setVisible(false);panelRef&&panelRef.destroy();attributeObserver&&attributeObserver.disconnect();element.remove();});// Updates the aria-label when the element text changes. This watch
	// doesn't need to be set up if the element doesn't have any data
	// bindings.
	if(element.text().indexOf($interpolate.startSymbol())>-1){scope.$watch(function(){return element.text().trim();},addAriaLabel);}function onElementDestroy(){scope.$destroy();}}function setVisible(value){// Break if passed value is already in queue or there is no queue and
	// passed value is current in the controller.
	if(setVisible.queued&&setVisible.value===!!value||!setVisible.queued&&scope.mdVisible===!!value){return;}setVisible.value=!!value;if(!setVisible.queued){if(value){setVisible.queued=true;showTimeout=$timeout(function(){scope.mdVisible=setVisible.value;setVisible.queued=false;showTimeout=null;if(!scope.visibleWatcher){onVisibleChanged(scope.mdVisible);}},scope.mdDelay);}else{$mdUtil.nextTick(function(){scope.mdVisible=false;if(!scope.visibleWatcher){onVisibleChanged(false);}});}}}function onVisibleChanged(isVisible){isVisible?showTooltip():hideTooltip();}function showTooltip(){// Do not show the tooltip if the text is empty.
	if(!element[0].textContent.trim()){throw new Error('Text for the tooltip has not been provided. '+'Please include text within the mdTooltip element.');}if(!panelRef){var attachTo=angular.element(document.body);var panelAnimation=$mdPanel.newPanelAnimation().openFrom(parent).closeTo(parent).withAnimation({open:'md-show',close:'md-hide'});var panelConfig={id:tooltipId,attachTo:attachTo,contentElement:element,propagateContainerEvents:true,panelClass:'md-tooltip',animation:panelAnimation,position:panelPosition,zIndex:scope.mdZIndex,focusOnOpen:false,onDomAdded:function onDomAdded(){panelRef.panelEl.addClass(origin);}};panelRef=$mdPanel.create(panelConfig);}panelRef.open().then(function(){panelRef.panelEl.attr('role','tooltip');});}function hideTooltip(){panelRef&&panelRef.close();}}}/**
	 * Service that is used to reduce the amount of listeners that are being
	 * registered on the `window` by the tooltip component. Works by collecting
	 * the individual event handlers and dispatching them from a global handler.
	 *
	 * @ngInject
	 */function MdTooltipRegistry(){var listeners={};var ngWindow=angular.element(window);return{register:register,deregister:deregister};/**
	   * Global event handler that dispatches the registered handlers in the
	   * service.
	   * @param {!Event} event Event object passed in by the browser
	   */function globalEventHandler(event){if(listeners[event.type]){listeners[event.type].forEach(function(currentHandler){currentHandler.call(this,event);},this);}}/**
	   * Registers a new handler with the service.
	   * @param {string} type Type of event to be registered.
	   * @param {!Function} handler Event handler.
	   * @param {boolean} useCapture Whether to use event capturing.
	   */function register(type,handler,useCapture){var handlers=listeners[type]=listeners[type]||[];if(!handlers.length){useCapture?window.addEventListener(type,globalEventHandler,true):ngWindow.on(type,globalEventHandler);}if(handlers.indexOf(handler)===-1){handlers.push(handler);}}/**
	   * Removes an event handler from the service.
	   * @param {string} type Type of event handler.
	   * @param {!Function} handler The event handler itself.
	   * @param {boolean} useCapture Whether the event handler used event capturing.
	   */function deregister(type,handler,useCapture){var handlers=listeners[type];var index=handlers?handlers.indexOf(handler):-1;if(index>-1){handlers.splice(index,1);if(handlers.length===0){useCapture?window.removeEventListener(type,globalEventHandler,true):ngWindow.off(type,globalEventHandler);}}}}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.truncate
	 */MdTruncateController.$inject=["$element"];angular.module('material.components.truncate',['material.core']).directive('mdTruncate',MdTruncateDirective);/**
	 * @ngdoc directive
	 * @name mdTruncate
	 * @module material.components.truncate
	 * @restrict AE
	 * @description
	 *
	 * The `md-truncate` component displays a label that will automatically clip text which is wider
	 * than the component. By default, it displays an ellipsis, but you may apply the `md-clip` CSS
	 * class to override this default and use a standard "clipping" approach.
	 *
	 * <i><b>Note:</b> The `md-truncate` component does not automatically adjust it's width. You must
	 * provide the `flex` attribute, or some other CSS-based width management. See the
	 * <a ng-href="./demo/truncate">demos</a> for examples.</i>
	 *
	 * @usage
	 *
	 * ### As an Element
	 *
	 * <hljs lang="html">
	 *   <div layout="row">
	 *     <md-button>Back</md-button>
	 *
	 *     <md-truncate flex>Chapter 1 - The Way of the Old West</md-truncate>
	 *
	 *     <md-button>Forward</md-button>
	 *   </div>
	 * </hljs>
	 *
	 * ### As an Attribute
	 *
	 * <hljs lang="html">
	 *   <h2 md-truncate style="max-width: 100px;">Some Title With a Lot of Text</h2>
	 * </hljs>
	 *
	 * ## CSS & Styles
	 *
	 * `<md-truncate>` provides two CSS classes that you may use to control the type of clipping.
	 *
	 * <i><b>Note:</b> The `md-truncate` also applies a setting of `width: 0;` when used with the `flex`
	 * attribute to fix an issue with the flex element not shrinking properly.</i>
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code=".md-ellipsis">
	 *     Assigns the "ellipsis" behavior (default) which will cut off mid-word and append an ellipsis
	 *     (&hellip;) to the end of the text.
	 *   </docs-css-selector>
	 *
	 *   <docs-css-selector code=".md-clip">
	 *     Assigns the "clipping" behavior which will simply chop off the text. This may happen
	 *     mid-word or even mid-character.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 */function MdTruncateDirective(){return{restrict:'AE',controller:MdTruncateController};}/**
	 * Controller for the <md-truncate> component.
	 *
	 * @param $element The md-truncate element.
	 *
	 * @constructor
	 * @ngInject
	 */function MdTruncateController($element){$element.addClass('md-truncate');}})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.virtualRepeat
	 */VirtualRepeatContainerController.$inject=["$$rAF","$mdUtil","$mdConstant","$parse","$rootScope","$window","$scope","$element","$attrs"];VirtualRepeatController.$inject=["$scope","$element","$attrs","$browser","$document","$rootScope","$$rAF","$mdUtil"];VirtualRepeatDirective.$inject=["$parse"];angular.module('material.components.virtualRepeat',['material.core','material.components.showHide']).directive('mdVirtualRepeatContainer',VirtualRepeatContainerDirective).directive('mdVirtualRepeat',VirtualRepeatDirective).directive('mdForceHeight',ForceHeightDirective);/**
	 * @ngdoc directive
	 * @name mdVirtualRepeatContainer
	 * @module material.components.virtualRepeat
	 * @restrict E
	 * @description
	 * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
	 *
	 * VirtualRepeat is a limited substitute for ng-repeat that renders only
	 * enough DOM nodes to fill the container and recycling them as the user scrolls.
	 *
	 * Once an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for
	 * another visible item by replacing the previous dataset with the new one.
	 *
	 * ### Common Issues
	 *
	 * - When having one-time bindings inside of the view template, the VirtualRepeat will not properly
	 *   update the bindings for new items, since the view will be recycled.
	 * - Directives inside of a VirtualRepeat will be only compiled (linked) once, because those
	 *   items will be recycled and used for other items.
	 *   The VirtualRepeat just updates the scope bindings.
	 *
	 *
	 * ### Notes
	 *
	 * > The VirtualRepeat is a similar implementation to the Android
	 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html)
	 *
	 * <!-- This comment forces a break between blockquotes //-->
	 *
	 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">VirtualRepeat</a>
	 * documentation for more information.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-virtual-repeat-container md-top-index="topIndex">
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
	 *     container to `$scope`. It can both read and set the scroll position.
	 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
	 *     (defaults to orientation and scrolling vertically).
	 * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
	 *     the number of items when that number is less than its original size.
	 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
	 *     will shrink to (default: 0).
	 */function VirtualRepeatContainerDirective(){return{controller:VirtualRepeatContainerController,template:virtualRepeatContainerTemplate,compile:function virtualRepeatContainerCompile($element,$attrs){$element.addClass('md-virtual-repeat-container').addClass($attrs.hasOwnProperty('mdOrientHorizontal')?'md-orient-horizontal':'md-orient-vertical');}};}function virtualRepeatContainerTemplate($element){return'<div class="md-virtual-repeat-scroller" role="presentation">'+'<div class="md-virtual-repeat-sizer" role="presentation"></div>'+'<div class="md-virtual-repeat-offsetter" role="presentation">'+$element[0].innerHTML+'</div></div>';}/**
	 * Number of additional elements to render above and below the visible area inside
	 * of the virtual repeat container. A higher number results in less flicker when scrolling
	 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
	 * @const {number}
	 */var NUM_EXTRA=3;/** @ngInject */function VirtualRepeatContainerController($$rAF,$mdUtil,$mdConstant,$parse,$rootScope,$window,$scope,$element,$attrs){this.$rootScope=$rootScope;this.$scope=$scope;this.$element=$element;this.$attrs=$attrs;/** @type {number} The width or height of the container */this.size=0;/** @type {number} The scroll width or height of the scroller */this.scrollSize=0;/** @type {number} The scrollLeft or scrollTop of the scroller */this.scrollOffset=0;/** @type {boolean} Whether the scroller is oriented horizontally */this.horizontal=this.$attrs.hasOwnProperty('mdOrientHorizontal');/** @type {!VirtualRepeatController} The repeater inside of this container */this.repeater=null;/** @type {boolean} Whether auto-shrink is enabled */this.autoShrink=this.$attrs.hasOwnProperty('mdAutoShrink');/** @type {number} Minimum number of items to auto-shrink to */this.autoShrinkMin=parseInt(this.$attrs.mdAutoShrinkMin,10)||0;/** @type {?number} Original container size when shrank */this.originalSize=null;/** @type {number} Amount to offset the total scroll size by. */this.offsetSize=parseInt(this.$attrs.mdOffsetSize,10)||0;/** @type {?string} height or width element style on the container prior to auto-shrinking. */this.oldElementSize=null;/** @type {!number} Maximum amount of pixels allowed for a single DOM element */this.maxElementPixels=$mdConstant.ELEMENT_MAX_PIXELS;if(this.$attrs.mdTopIndex){/** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */this.bindTopIndex=$parse(this.$attrs.mdTopIndex);/** @type {number} The index of the item that is at the top of the scroll container */this.topIndex=this.bindTopIndex(this.$scope);if(!angular.isDefined(this.topIndex)){this.topIndex=0;this.bindTopIndex.assign(this.$scope,0);}this.$scope.$watch(this.bindTopIndex,angular.bind(this,function(newIndex){if(newIndex!==this.topIndex){this.scrollToIndex(newIndex);}}));}else{this.topIndex=0;}this.scroller=$element[0].querySelector('.md-virtual-repeat-scroller');this.sizer=this.scroller.querySelector('.md-virtual-repeat-sizer');this.offsetter=this.scroller.querySelector('.md-virtual-repeat-offsetter');// After the dom stablizes, measure the initial size of the container and
	// make a best effort at re-measuring as it changes.
	var boundUpdateSize=angular.bind(this,this.updateSize);$$rAF(angular.bind(this,function(){boundUpdateSize();var debouncedUpdateSize=$mdUtil.debounce(boundUpdateSize,10,null,false);var jWindow=angular.element($window);// Make one more attempt to get the size if it is 0.
	// This is not by any means a perfect approach, but there's really no
	// silver bullet here.
	if(!this.size){debouncedUpdateSize();}jWindow.on('resize',debouncedUpdateSize);$scope.$on('$destroy',function(){jWindow.off('resize',debouncedUpdateSize);});$scope.$emit('$md-resize-enable');$scope.$on('$md-resize',boundUpdateSize);}));}/** Called by the md-virtual-repeat inside of the container at startup. */VirtualRepeatContainerController.prototype.register=function(repeaterCtrl){this.repeater=repeaterCtrl;angular.element(this.scroller).on('scroll wheel touchmove touchend',angular.bind(this,this.handleScroll_));};/** @return {boolean} Whether the container is configured for horizontal scrolling. */VirtualRepeatContainerController.prototype.isHorizontal=function(){return this.horizontal;};/** @return {number} The size (width or height) of the container. */VirtualRepeatContainerController.prototype.getSize=function(){return this.size;};/**
	 * Resizes the container.
	 * @private
	 * @param {number} size The new size to set.
	 */VirtualRepeatContainerController.prototype.setSize_=function(size){var dimension=this.getDimensionName_();this.size=size;this.$element[0].style[dimension]=size+'px';};VirtualRepeatContainerController.prototype.unsetSize_=function(){this.$element[0].style[this.getDimensionName_()]=this.oldElementSize;this.oldElementSize=null;};/** Instructs the container to re-measure its size. */VirtualRepeatContainerController.prototype.updateSize=function(){// If the original size is already determined, we can skip the update.
	if(this.originalSize)return;this.size=this.isHorizontal()?this.$element[0].clientWidth:this.$element[0].clientHeight;// Recheck the scroll position after updating the size. This resolves
	// problems that can result if the scroll position was measured while the
	// element was display: none or detached from the document.
	this.handleScroll_();this.repeater&&this.repeater.containerUpdated();};/** @return {number} The container's scrollHeight or scrollWidth. */VirtualRepeatContainerController.prototype.getScrollSize=function(){return this.scrollSize;};VirtualRepeatContainerController.prototype.getDimensionName_=function(){return this.isHorizontal()?'width':'height';};/**
	 * Sets the scroller element to the specified size.
	 * @private
	 * @param {number} size The new size.
	 */VirtualRepeatContainerController.prototype.sizeScroller_=function(size){var dimension=this.getDimensionName_();var crossDimension=this.isHorizontal()?'height':'width';// Clear any existing dimensions.
	this.sizer.innerHTML='';// If the size falls within the browser's maximum explicit size for a single element, we can
	// set the size and be done. Otherwise, we have to create children that add up the the desired
	// size.
	if(size<this.maxElementPixels){this.sizer.style[dimension]=size+'px';}else{this.sizer.style[dimension]='auto';this.sizer.style[crossDimension]='auto';// Divide the total size we have to render into N max-size pieces.
	var numChildren=Math.floor(size/this.maxElementPixels);// Element template to clone for each max-size piece.
	var sizerChild=document.createElement('div');sizerChild.style[dimension]=this.maxElementPixels+'px';sizerChild.style[crossDimension]='1px';for(var i=0;i<numChildren;i++){this.sizer.appendChild(sizerChild.cloneNode(false));}// Re-use the element template for the remainder.
	sizerChild.style[dimension]=size-numChildren*this.maxElementPixels+'px';this.sizer.appendChild(sizerChild);}};/**
	 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
	 * @private
	 * @param {number} size The new size.
	 */VirtualRepeatContainerController.prototype.autoShrink_=function(size){var shrinkSize=Math.max(size,this.autoShrinkMin*this.repeater.getItemSize());if(this.autoShrink&&shrinkSize!==this.size){if(this.oldElementSize===null){this.oldElementSize=this.$element[0].style[this.getDimensionName_()];}var currentSize=this.originalSize||this.size;if(!currentSize||shrinkSize<currentSize){if(!this.originalSize){this.originalSize=this.size;}// Now we update the containers size, because shrinking is enabled.
	this.setSize_(shrinkSize);}else if(this.originalSize!==null){// Set the size back to our initial size.
	this.unsetSize_();var _originalSize=this.originalSize;this.originalSize=null;// We determine the repeaters size again, if the original size was zero.
	// The originalSize needs to be null, to be able to determine the size.
	if(!_originalSize)this.updateSize();// Apply the original size or the determined size back to the container, because
	// it has been overwritten before, in the shrink block.
	this.setSize_(_originalSize||this.size);}this.repeater.containerUpdated();}};/**
	 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
	 * its item count and item size.
	 * @param {number} itemsSize The total size of the items.
	 */VirtualRepeatContainerController.prototype.setScrollSize=function(itemsSize){var size=itemsSize+this.offsetSize;if(this.scrollSize===size)return;this.sizeScroller_(size);this.autoShrink_(size);this.scrollSize=size;};/** @return {number} The container's current scroll offset. */VirtualRepeatContainerController.prototype.getScrollOffset=function(){return this.scrollOffset;};/**
	 * Scrolls to a given scrollTop position.
	 * @param {number} position
	 */VirtualRepeatContainerController.prototype.scrollTo=function(position){this.scroller[this.isHorizontal()?'scrollLeft':'scrollTop']=position;this.handleScroll_();};/**
	 * Scrolls the item with the given index to the top of the scroll container.
	 * @param {number} index
	 */VirtualRepeatContainerController.prototype.scrollToIndex=function(index){var itemSize=this.repeater.getItemSize();var itemsLength=this.repeater.itemsLength;if(index>itemsLength){index=itemsLength-1;}this.scrollTo(itemSize*index);};VirtualRepeatContainerController.prototype.resetScroll=function(){this.scrollTo(0);};VirtualRepeatContainerController.prototype.handleScroll_=function(){var ltr=document.dir!='rtl'&&document.body.dir!='rtl';if(!ltr&&!this.maxSize){this.scroller.scrollLeft=this.scrollSize;this.maxSize=this.scroller.scrollLeft;}var offset=this.isHorizontal()?ltr?this.scroller.scrollLeft:this.maxSize-this.scroller.scrollLeft:this.scroller.scrollTop;if(offset===this.scrollOffset||offset>this.scrollSize-this.size)return;var itemSize=this.repeater.getItemSize();if(!itemSize)return;var numItems=Math.max(0,Math.floor(offset/itemSize)-NUM_EXTRA);var transform=(this.isHorizontal()?'translateX(':'translateY(')+(!this.isHorizontal()||ltr?numItems*itemSize:-(numItems*itemSize))+'px)';this.scrollOffset=offset;this.offsetter.style.webkitTransform=transform;this.offsetter.style.transform=transform;if(this.bindTopIndex){var topIndex=Math.floor(offset/itemSize);if(topIndex!==this.topIndex&&topIndex<this.repeater.getItemCount()){this.topIndex=topIndex;this.bindTopIndex.assign(this.$scope,topIndex);if(!this.$rootScope.$$phase)this.$scope.$digest();}}this.repeater.containerUpdated();};/**
	 * @ngdoc directive
	 * @name mdVirtualRepeat
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @priority 1000
	 * @description
	 * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
	 *
	 * Virtual repeat is a limited substitute for ng-repeat that renders only
	 * enough DOM nodes to fill the container and recycling them as the user scrolls.
	 *
	 * Arrays, but not objects are supported for iteration.
	 * Track by, as alias, and (key, value) syntax are not supported.
	 *
	 * ### On-Demand Async Item Loading
	 *
	 * When using the `md-on-demand` attribute and loading some asynchronous data, the `getItemAtIndex` function will
	 * mostly return nothing.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.getItemAtIndex = function(index) {
	 *     if (this.pages[index]) {
	 *       return this.pages[index];
	 *     } else {
	 *       // This is an asynchronous action and does not return any value.
	 *       this.loadPage(index);
	 *     }
	 *   };
	 * </hljs>
	 *
	 * This means that the VirtualRepeat will not have any value for the given index.<br/>
	 * After the data loading completed, the user expects the VirtualRepeat to recognize the change.
	 *
	 * To make sure that the VirtualRepeat properly detects any change, you need to run the operation
	 * in another digest.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.loadPage = function(index) {
	 *     var self = this;
	 *
	 *     // Trigger a new digest by using $timeout
	 *     $timeout(function() {
	 *       self.pages[index] = Data;
	 *     });
	 *   };
	 * </hljs>
	 *
	 * > <b>Note:</b> Please also review the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
	 *   for more information.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-virtual-repeat-container>
	 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 *
	 * <md-virtual-repeat-container md-orient-horizontal>
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {number=} md-item-size The height or width of the repeated elements (which must be
	 *   identical for each element). Optional. Will attempt to read the size from the dom if missing,
	 *   but still assumes that all repeated nodes have same height or width.
	 * @param {string=} md-extra-name Evaluates to an additional name to which the current iterated item
	 *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
	 * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument as an object
	 *   that can fetch rows rather than an array.
	 *
	 *   **NOTE:** This object must implement the following interface with two (2) methods:
	 *
	 *   - `getItemAtIndex: function(index) [object]` The item at that index or null if it is not yet
	 *     loaded (it should start downloading the item in that case).
	 *   - `getLength: function() [number]` The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 */function VirtualRepeatDirective($parse){return{controller:VirtualRepeatController,priority:1000,require:['mdVirtualRepeat','^^mdVirtualRepeatContainer'],restrict:'A',terminal:true,transclude:'element',compile:function VirtualRepeatCompile($element,$attrs){var expression=$attrs.mdVirtualRepeat;var match=expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);var repeatName=match[1];var repeatListExpression=$parse(match[2]);var extraName=$attrs.mdExtraName&&$parse($attrs.mdExtraName);return function VirtualRepeatLink($scope,$element,$attrs,ctrl,$transclude){ctrl[0].link_(ctrl[1],$transclude,repeatName,repeatListExpression,extraName);};}};}/** @ngInject */function VirtualRepeatController($scope,$element,$attrs,$browser,$document,$rootScope,$$rAF,$mdUtil){this.$scope=$scope;this.$element=$element;this.$attrs=$attrs;this.$browser=$browser;this.$document=$document;this.$mdUtil=$mdUtil;this.$rootScope=$rootScope;this.$$rAF=$$rAF;/** @type {boolean} Whether we are in on-demand mode. */this.onDemand=$mdUtil.parseAttributeBoolean($attrs.mdOnDemand);/** @type {!Function} Backup reference to $browser.$$checkUrlChange */this.browserCheckUrlChange=$browser.$$checkUrlChange;/** @type {number} Most recent starting repeat index (based on scroll offset) */this.newStartIndex=0;/** @type {number} Most recent ending repeat index (based on scroll offset) */this.newEndIndex=0;/** @type {number} Most recent end visible index (based on scroll offset) */this.newVisibleEnd=0;/** @type {number} Previous starting repeat index (based on scroll offset) */this.startIndex=0;/** @type {number} Previous ending repeat index (based on scroll offset) */this.endIndex=0;// TODO: measure width/height of first element from dom if not provided.
	// getComputedStyle?
	/** @type {?number} Height/width of repeated elements. */this.itemSize=$scope.$eval($attrs.mdItemSize)||null;/** @type {boolean} Whether this is the first time that items are rendered. */this.isFirstRender=true;/**
	   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
	   *     nested calls to virtualRepeatUpdate_.
	   */this.isVirtualRepeatUpdating_=false;/** @type {number} Most recently seen length of items. */this.itemsLength=0;/**
	   * @type {!Function} Unwatch callback for item size (when md-items-size is
	   *     not specified), or angular.noop otherwise.
	   */this.unwatchItemSize_=angular.noop;/**
	   * Presently rendered blocks by repeat index.
	   * @type {Object<number, !VirtualRepeatController.Block}
	   */this.blocks={};/** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */this.pooledBlocks=[];$scope.$on('$destroy',angular.bind(this,this.cleanupBlocks_));}/**
	 * An object representing a repeated item.
	 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
	 */VirtualRepeatController.Block;/**
	 * Called at startup by the md-virtual-repeat postLink function.
	 * @param {!VirtualRepeatContainerController} container The container's controller.
	 * @param {!Function} transclude The repeated element's bound transclude function.
	 * @param {string} repeatName The left hand side of the repeat expression, indicating
	 *     the name for each item in the array.
	 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
	 *     of the repeat expression. Points to the array to repeat over.
	 * @param {string|undefined} extraName The optional extra repeatName.
	 */VirtualRepeatController.prototype.link_=function(container,transclude,repeatName,repeatListExpression,extraName){this.container=container;this.transclude=transclude;this.repeatName=repeatName;this.rawRepeatListExpression=repeatListExpression;this.extraName=extraName;this.sized=false;this.repeatListExpression=angular.bind(this,this.repeatListExpression_);this.container.register(this);};/** @private Cleans up unused blocks. */VirtualRepeatController.prototype.cleanupBlocks_=function(){angular.forEach(this.pooledBlocks,function cleanupBlock(block){block.element.remove();});};/** @private Attempts to set itemSize by measuring a repeated element in the dom */VirtualRepeatController.prototype.readItemSize_=function(){if(this.itemSize){// itemSize was successfully read in a different asynchronous call.
	return;}this.items=this.repeatListExpression(this.$scope);this.parentNode=this.$element[0].parentNode;var block=this.getBlock_(0);if(!block.element[0].parentNode){this.parentNode.appendChild(block.element[0]);}this.itemSize=block.element[0][this.container.isHorizontal()?'offsetWidth':'offsetHeight']||null;this.blocks[0]=block;this.poolBlock_(0);if(this.itemSize){this.containerUpdated();}};/**
	 * Returns the user-specified repeat list, transforming it into an array-like
	 * object in the case of infinite scroll/dynamic load mode.
	 * @param {!angular.Scope} The scope.
	 * @return {!Array|!Object} An array or array-like object for iteration.
	 */VirtualRepeatController.prototype.repeatListExpression_=function(scope){var repeatList=this.rawRepeatListExpression(scope);if(this.onDemand&&repeatList){var virtualList=new VirtualRepeatModelArrayLike(repeatList);virtualList.$$includeIndexes(this.newStartIndex,this.newVisibleEnd);return virtualList;}else{return repeatList;}};/**
	 * Called by the container. Informs us that the containers scroll or size has
	 * changed.
	 */VirtualRepeatController.prototype.containerUpdated=function(){// If itemSize is unknown, attempt to measure it.
	if(!this.itemSize){// Make sure to clean up watchers if we can (see #8178)
	if(this.unwatchItemSize_&&this.unwatchItemSize_!==angular.noop){this.unwatchItemSize_();}this.unwatchItemSize_=this.$scope.$watchCollection(this.repeatListExpression,angular.bind(this,function(items){if(items&&items.length){this.readItemSize_();}}));if(!this.$rootScope.$$phase)this.$scope.$digest();return;}else if(!this.sized){this.items=this.repeatListExpression(this.$scope);}if(!this.sized){this.unwatchItemSize_();this.sized=true;this.$scope.$watchCollection(this.repeatListExpression,angular.bind(this,function(items,oldItems){if(!this.isVirtualRepeatUpdating_){this.virtualRepeatUpdate_(items,oldItems);}}));}this.updateIndexes_();if(this.newStartIndex!==this.startIndex||this.newEndIndex!==this.endIndex||this.container.getScrollOffset()>this.container.getScrollSize()){if(this.items instanceof VirtualRepeatModelArrayLike){this.items.$$includeIndexes(this.newStartIndex,this.newEndIndex);}this.virtualRepeatUpdate_(this.items,this.items);}};/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} Size of a repeated item.
	 */VirtualRepeatController.prototype.getItemSize=function(){return this.itemSize;};/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} Size of a repeated item.
	 */VirtualRepeatController.prototype.getItemCount=function(){return this.itemsLength;};/**
	 * Updates the order and visible offset of repeated blocks in response to scrolling
	 * or items updates.
	 * @private
	 */VirtualRepeatController.prototype.virtualRepeatUpdate_=function(items,oldItems){this.isVirtualRepeatUpdating_=true;var itemsLength=items&&items.length||0;var lengthChanged=false;// If the number of items shrank, keep the scroll position.
	if(this.items&&itemsLength<this.items.length&&this.container.getScrollOffset()!==0){this.items=items;var previousScrollOffset=this.container.getScrollOffset();this.container.resetScroll();this.container.scrollTo(previousScrollOffset);}if(itemsLength!==this.itemsLength){lengthChanged=true;this.itemsLength=itemsLength;}this.items=items;if(items!==oldItems||lengthChanged){this.updateIndexes_();}this.parentNode=this.$element[0].parentNode;if(lengthChanged){this.container.setScrollSize(itemsLength*this.itemSize);}// Detach and pool any blocks that are no longer in the viewport.
	Object.keys(this.blocks).forEach(function(blockIndex){var index=parseInt(blockIndex,10);if(index<this.newStartIndex||index>=this.newEndIndex){this.poolBlock_(index);}},this);// Add needed blocks.
	// For performance reasons, temporarily block browser url checks as we digest
	// the restored block scopes ($$checkUrlChange reads window.location to
	// check for changes and trigger route change, etc, which we don't need when
	// trying to scroll at 60fps).
	this.$browser.$$checkUrlChange=angular.noop;var i,block,newStartBlocks=[],newEndBlocks=[];// Collect blocks at the top.
	for(i=this.newStartIndex;i<this.newEndIndex&&this.blocks[i]==null;i++){block=this.getBlock_(i);this.updateBlock_(block,i);newStartBlocks.push(block);}// Update blocks that are already rendered.
	for(;this.blocks[i]!=null;i++){this.updateBlock_(this.blocks[i],i);}var maxIndex=i-1;// Collect blocks at the end.
	for(;i<this.newEndIndex;i++){block=this.getBlock_(i);this.updateBlock_(block,i);newEndBlocks.push(block);}// Attach collected blocks to the document.
	if(newStartBlocks.length){this.parentNode.insertBefore(this.domFragmentFromBlocks_(newStartBlocks),this.$element[0].nextSibling);}if(newEndBlocks.length){this.parentNode.insertBefore(this.domFragmentFromBlocks_(newEndBlocks),this.blocks[maxIndex]&&this.blocks[maxIndex].element[0].nextSibling);}// Restore $$checkUrlChange.
	this.$browser.$$checkUrlChange=this.browserCheckUrlChange;this.startIndex=this.newStartIndex;this.endIndex=this.newEndIndex;if(this.isFirstRender){this.isFirstRender=false;var firstRenderStartIndex=this.$attrs.mdStartIndex?this.$scope.$eval(this.$attrs.mdStartIndex):this.container.topIndex;// The first call to virtualRepeatUpdate_ may not be when the virtual repeater is ready.
	// Introduce a slight delay so that the update happens when it is actually ready.
	this.$mdUtil.nextTick(function(){this.container.scrollToIndex(firstRenderStartIndex);}.bind(this));}this.isVirtualRepeatUpdating_=false;};/**
	 * @param {number} index Where the block is to be in the repeated list.
	 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
	 * @private
	 */VirtualRepeatController.prototype.getBlock_=function(index){if(this.pooledBlocks.length){return this.pooledBlocks.pop();}var block;this.transclude(angular.bind(this,function(clone,scope){block={element:clone,new:true,scope:scope};this.updateScope_(scope,index);this.parentNode.appendChild(clone[0]);}));return block;};/**
	 * Updates and if not in a digest cycle, digests the specified block's scope to the data
	 * at the specified index.
	 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */VirtualRepeatController.prototype.updateBlock_=function(block,index){this.blocks[index]=block;if(!block.new&&block.scope.$index===index&&block.scope[this.repeatName]===this.items[index]){return;}block.new=false;// Update and digest the block's scope.
	this.updateScope_(block.scope,index);// Perform digest before reattaching the block.
	// Any resulting synchronous dom mutations should be much faster as a result.
	// This might break some directives, but I'm going to try it for now.
	if(!this.$rootScope.$$phase){block.scope.$digest();}};/**
	 * Updates scope to the data at the specified index.
	 * @param {!angular.Scope} scope The scope which should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */VirtualRepeatController.prototype.updateScope_=function(scope,index){scope.$index=index;scope[this.repeatName]=this.items&&this.items[index];if(this.extraName)scope[this.extraName(this.$scope)]=this.items[index];};/**
	 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
	 * @param {number} index The index at which the block to pool is stored.
	 * @private
	 */VirtualRepeatController.prototype.poolBlock_=function(index){this.pooledBlocks.push(this.blocks[index]);this.parentNode.removeChild(this.blocks[index].element[0]);delete this.blocks[index];};/**
	 * Produces a dom fragment containing the elements from the list of blocks.
	 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
	 *     should be added to the document fragment.
	 * @return {DocumentFragment}
	 * @private
	 */VirtualRepeatController.prototype.domFragmentFromBlocks_=function(blocks){var fragment=this.$document[0].createDocumentFragment();blocks.forEach(function(block){fragment.appendChild(block.element[0]);});return fragment;};/**
	 * Updates start and end indexes based on length of repeated items and container size.
	 * @private
	 */VirtualRepeatController.prototype.updateIndexes_=function(){var itemsLength=this.items?this.items.length:0;var containerLength=Math.ceil(this.container.getSize()/this.itemSize);this.newStartIndex=Math.max(0,Math.min(itemsLength-containerLength,Math.floor(this.container.getScrollOffset()/this.itemSize)));this.newVisibleEnd=this.newStartIndex+containerLength+NUM_EXTRA;this.newEndIndex=Math.min(itemsLength,this.newVisibleEnd);this.newStartIndex=Math.max(0,this.newStartIndex-NUM_EXTRA);};/**
	 * This VirtualRepeatModelArrayLike class enforces the interface requirements
	 * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
	 * interface must implement the following interface with two (2) methods:
	 *
	 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
	 *     loaded (It should start downloading the item in that case).
	 *
	 * getLength: function() -> number The data legnth to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-virtual-repeat-container md-orient-horizontal>
	 *    <div md-virtual-repeat="i in items" md-on-demand>
	 *      Hello {{i}}!
	 *    </div>
	 *  </md-virtual-repeat-container>
	 * </hljs>
	 *
	 */function VirtualRepeatModelArrayLike(model){if(!angular.isFunction(model.getItemAtIndex)||!angular.isFunction(model.getLength)){throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement '+'functions getItemAtIndex() and getLength() ');}this.model=model;}VirtualRepeatModelArrayLike.prototype.$$includeIndexes=function(start,end){for(var i=start;i<end;i++){if(!this.hasOwnProperty(i)){this[i]=this.model.getItemAtIndex(i);}}this.length=this.model.getLength();};/**
	 * @ngdoc directive
	 * @name mdForceHeight
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @description
	 *
	 * Force an element to have a certain px height. This is used in place of a style tag in order to
	 * conform to the Content Security Policy regarding unsafe-inline style tags.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <div md-force-height="'100px'"></div>
	 * </hljs>
	 */function ForceHeightDirective($mdUtil){return{restrict:'A',link:function link(scope,element,attrs){var height=scope.$eval(attrs.mdForceHeight)||null;if(height&&element){element[0].style.height=height;}}};}ForceHeightDirective.$inject=['$mdUtil'];})();(function(){"use strict";/**
	 * @ngdoc module
	 * @name material.components.whiteframe
	 */MdWhiteframeDirective.$inject=["$log"];angular.module('material.components.whiteframe',['material.core']).directive('mdWhiteframe',MdWhiteframeDirective);/**
	 * @ngdoc directive
	 * @module material.components.whiteframe
	 * @name mdWhiteframe
	 *
	 * @description
	 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
	 *
	 * The attribute values needs to be a number between 1 and 24 or -1.
	 * When set to -1 no style is applied.
	 *
	 * ### Notes
	 * - If there is no value specified it defaults to 4dp.
	 * - If the value is not valid it defaults to 4dp.
	
	 * @usage
	 * <hljs lang="html">
	 * <div md-whiteframe="3">
	 *   <span>Elevation of 3dp</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div md-whiteframe="-1">
	 *   <span>No elevation shadow applied</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
	 *   <span>Elevation of 5dp with an interpolated value</span>
	 * </div>
	 * </hljs>
	 */function MdWhiteframeDirective($log){var DISABLE_DP=-1;var MIN_DP=1;var MAX_DP=24;var DEFAULT_DP=4;return{link:postLink};function postLink(scope,element,attr){var oldClass='';attr.$observe('mdWhiteframe',function(elevation){elevation=parseInt(elevation,10)||DEFAULT_DP;if(elevation!=DISABLE_DP&&(elevation>MAX_DP||elevation<MIN_DP)){$log.warn('md-whiteframe attribute value is invalid. It should be a number between '+MIN_DP+' and '+MAX_DP,element[0]);elevation=DEFAULT_DP;}var newClass=elevation==DISABLE_DP?'':'md-whiteframe-'+elevation+'dp';attr.$updateClass(newClass,oldClass);oldClass=newClass;});}}})();(function(){"use strict";MdAutocompleteCtrl.$inject=["$scope","$element","$mdUtil","$mdConstant","$mdTheming","$window","$animate","$rootElement","$attrs","$q","$log","$mdLiveAnnouncer"];angular.module('material.components.autocomplete').controller('MdAutocompleteCtrl',MdAutocompleteCtrl);var ITEM_HEIGHT=48,MAX_ITEMS=5,MENU_PADDING=8,INPUT_PADDING=2;// Padding provided by `md-input-container`
	function MdAutocompleteCtrl($scope,$element,$mdUtil,$mdConstant,$mdTheming,$window,$animate,$rootElement,$attrs,$q,$log,$mdLiveAnnouncer){// Internal Variables.
	var ctrl=this,itemParts=$scope.itemsExpr.split(/ in /i),itemExpr=itemParts[1],elements=null,cache={},noBlur=false,selectedItemWatchers=[],hasFocus=false,fetchesInProgress=0,enableWrapScroll=null,inputModelCtrl=null,debouncedOnResize=$mdUtil.debounce(onWindowResize);// Public Exported Variables with handlers
	defineProperty('hidden',handleHiddenChange,true);// Public Exported Variables
	ctrl.scope=$scope;ctrl.parent=$scope.$parent;ctrl.itemName=itemParts[0];ctrl.matches=[];ctrl.loading=false;ctrl.hidden=true;ctrl.index=null;ctrl.id=$mdUtil.nextUid();ctrl.isDisabled=null;ctrl.isRequired=null;ctrl.isReadonly=null;ctrl.hasNotFound=false;// Public Exported Methods
	ctrl.keydown=keydown;ctrl.blur=blur;ctrl.focus=focus;ctrl.clear=clearValue;ctrl.select=select;ctrl.listEnter=onListEnter;ctrl.listLeave=onListLeave;ctrl.mouseUp=onMouseup;ctrl.getCurrentDisplayValue=getCurrentDisplayValue;ctrl.registerSelectedItemWatcher=registerSelectedItemWatcher;ctrl.unregisterSelectedItemWatcher=unregisterSelectedItemWatcher;ctrl.notFoundVisible=notFoundVisible;ctrl.loadingIsVisible=loadingIsVisible;ctrl.positionDropdown=positionDropdown;/**
	   * Report types to be used for the $mdLiveAnnouncer
	   * @enum {number} Unique flag id.
	   */var ReportType={Count:1,Selected:2};return init();//-- initialization methods
	/**
	   * Initialize the controller, setup watchers, gather elements
	   */function init(){$mdUtil.initOptionalProperties($scope,$attrs,{searchText:'',selectedItem:null,clearButton:false});$mdTheming($element);configureWatchers();$mdUtil.nextTick(function(){gatherElements();moveDropdown();// Forward all focus events to the input element when autofocus is enabled
	if($scope.autofocus){$element.on('focus',focusInputElement);}});}function updateModelValidators(){if(!$scope.requireMatch||!inputModelCtrl)return;inputModelCtrl.$setValidity('md-require-match',!!$scope.selectedItem||!$scope.searchText);}/**
	   * Calculates the dropdown's position and applies the new styles to the menu element
	   * @returns {*}
	   */function positionDropdown(){if(!elements){return $mdUtil.nextTick(positionDropdown,false,$scope);}var dropdownHeight=($scope.dropdownItems||MAX_ITEMS)*ITEM_HEIGHT;var hrect=elements.wrap.getBoundingClientRect(),vrect=elements.snap.getBoundingClientRect(),root=elements.root.getBoundingClientRect(),top=vrect.bottom-root.top,bot=root.bottom-vrect.top,left=hrect.left-root.left,width=hrect.width,offset=getVerticalOffset(),position=$scope.dropdownPosition,styles;// Automatically determine dropdown placement based on available space in viewport.
	if(!position){position=top>bot&&root.height-top-MENU_PADDING<dropdownHeight?'top':'bottom';}// Adjust the width to account for the padding provided by `md-input-container`
	if($attrs.mdFloatingLabel){left+=INPUT_PADDING;width-=INPUT_PADDING*2;}styles={left:left+'px',minWidth:width+'px',maxWidth:Math.max(hrect.right-root.left,root.right-hrect.left)-MENU_PADDING+'px'};if(position==='top'){styles.top='auto';styles.bottom=bot+'px';styles.maxHeight=Math.min(dropdownHeight,hrect.top-root.top-MENU_PADDING)+'px';}else{var bottomSpace=root.bottom-hrect.bottom-MENU_PADDING+$mdUtil.getViewportTop();styles.top=top-offset+'px';styles.bottom='auto';styles.maxHeight=Math.min(dropdownHeight,bottomSpace)+'px';}elements.$.scrollContainer.css(styles);$mdUtil.nextTick(correctHorizontalAlignment,false);/**
	     * Calculates the vertical offset for floating label examples to account for ngMessages
	     * @returns {number}
	     */function getVerticalOffset(){var offset=0;var inputContainer=$element.find('md-input-container');if(inputContainer.length){var input=inputContainer.find('input');offset=inputContainer.prop('offsetHeight');offset-=input.prop('offsetTop');offset-=input.prop('offsetHeight');// add in the height left up top for the floating label text
	offset+=inputContainer.prop('offsetTop');}return offset;}/**
	     * Makes sure that the menu doesn't go off of the screen on either side.
	     */function correctHorizontalAlignment(){var dropdown=elements.scrollContainer.getBoundingClientRect(),styles={};if(dropdown.right>root.right-MENU_PADDING){styles.left=hrect.right-dropdown.width+'px';}elements.$.scrollContainer.css(styles);}}/**
	   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
	   */function moveDropdown(){if(!elements.$.root.length)return;$mdTheming(elements.$.scrollContainer);elements.$.scrollContainer.detach();elements.$.root.append(elements.$.scrollContainer);if($animate.pin)$animate.pin(elements.$.scrollContainer,$rootElement);}/**
	   * Sends focus to the input element.
	   */function focusInputElement(){elements.input.focus();}/**
	   * Sets up any watchers used by autocomplete
	   */function configureWatchers(){var wait=parseInt($scope.delay,10)||0;$attrs.$observe('disabled',function(value){ctrl.isDisabled=$mdUtil.parseAttributeBoolean(value,false);});$attrs.$observe('required',function(value){ctrl.isRequired=$mdUtil.parseAttributeBoolean(value,false);});$attrs.$observe('readonly',function(value){ctrl.isReadonly=$mdUtil.parseAttributeBoolean(value,false);});$scope.$watch('searchText',wait?$mdUtil.debounce(handleSearchText,wait):handleSearchText);$scope.$watch('selectedItem',selectedItemChange);angular.element($window).on('resize',debouncedOnResize);$scope.$on('$destroy',cleanup);}/**
	   * Removes any events or leftover elements created by this controller
	   */function cleanup(){if(!ctrl.hidden){$mdUtil.enableScrolling();}angular.element($window).off('resize',debouncedOnResize);if(elements){var items=['ul','scroller','scrollContainer','input'];angular.forEach(items,function(key){elements.$[key].remove();});}}/**
	   * Event handler to be called whenever the window resizes.
	   */function onWindowResize(){if(!ctrl.hidden){positionDropdown();}}/**
	   * Gathers all of the elements needed for this controller
	   */function gatherElements(){var snapWrap=gatherSnapWrap();elements={main:$element[0],scrollContainer:$element[0].querySelector('.md-virtual-repeat-container'),scroller:$element[0].querySelector('.md-virtual-repeat-scroller'),ul:$element.find('ul')[0],input:$element.find('input')[0],wrap:snapWrap.wrap,snap:snapWrap.snap,root:document.body};elements.li=elements.ul.getElementsByTagName('li');elements.$=getAngularElements(elements);inputModelCtrl=elements.$.input.controller('ngModel');}/**
	   * Gathers the snap and wrap elements
	   *
	   */function gatherSnapWrap(){var element;var value;for(element=$element;element.length;element=element.parent()){value=element.attr('md-autocomplete-snap');if(angular.isDefined(value))break;}if(element.length){return{snap:element[0],wrap:value.toLowerCase()==='width'?element[0]:$element.find('md-autocomplete-wrap')[0]};}var wrap=$element.find('md-autocomplete-wrap')[0];return{snap:wrap,wrap:wrap};}/**
	   * Gathers angular-wrapped versions of each element
	   * @param elements
	   * @returns {{}}
	   */function getAngularElements(elements){var obj={};for(var key in elements){if(elements.hasOwnProperty(key))obj[key]=angular.element(elements[key]);}return obj;}//-- event/change handlers
	/**
	   * Handles changes to the `hidden` property.
	   * @param hidden
	   * @param oldHidden
	   */function handleHiddenChange(hidden,oldHidden){if(!hidden&&oldHidden){positionDropdown();// Report in polite mode, because the screenreader should finish the default description of
	// the input. element.
	reportMessages(true,ReportType.Count|ReportType.Selected);if(elements){$mdUtil.disableScrollAround(elements.ul);enableWrapScroll=disableElementScrollEvents(angular.element(elements.wrap));}}else if(hidden&&!oldHidden){$mdUtil.enableScrolling();if(enableWrapScroll){enableWrapScroll();enableWrapScroll=null;}}}/**
	   * Disables scrolling for a specific element
	   */function disableElementScrollEvents(element){function preventDefault(e){e.preventDefault();}element.on('wheel',preventDefault);element.on('touchmove',preventDefault);return function(){element.off('wheel',preventDefault);element.off('touchmove',preventDefault);};}/**
	   * When the user mouses over the dropdown menu, ignore blur events.
	   */function onListEnter(){noBlur=true;}/**
	   * When the user's mouse leaves the menu, blur events may hide the menu again.
	   */function onListLeave(){if(!hasFocus&&!ctrl.hidden)elements.input.focus();noBlur=false;ctrl.hidden=shouldHide();}/**
	   * When the mouse button is released, send focus back to the input field.
	   */function onMouseup(){elements.input.focus();}/**
	   * Handles changes to the selected item.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */function selectedItemChange(selectedItem,previousSelectedItem){updateModelValidators();if(selectedItem){getDisplayValue(selectedItem).then(function(val){$scope.searchText=val;handleSelectedItemChange(selectedItem,previousSelectedItem);});}else if(previousSelectedItem&&$scope.searchText){getDisplayValue(previousSelectedItem).then(function(displayValue){// Clear the searchText, when the selectedItem is set to null.
	// Do not clear the searchText, when the searchText isn't matching with the previous
	// selected item.
	if(angular.isString($scope.searchText)&&displayValue.toString().toLowerCase()===$scope.searchText.toLowerCase()){$scope.searchText='';}});}if(selectedItem!==previousSelectedItem)announceItemChange();}/**
	   * Use the user-defined expression to announce changes each time a new item is selected
	   */function announceItemChange(){angular.isFunction($scope.itemChange)&&$scope.itemChange(getItemAsNameVal($scope.selectedItem));}/**
	   * Use the user-defined expression to announce changes each time the search text is changed
	   */function announceTextChange(){angular.isFunction($scope.textChange)&&$scope.textChange();}/**
	   * Calls any external watchers listening for the selected item.  Used in conjunction with
	   * `registerSelectedItemWatcher`.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */function handleSelectedItemChange(selectedItem,previousSelectedItem){selectedItemWatchers.forEach(function(watcher){watcher(selectedItem,previousSelectedItem);});}/**
	   * Register a function to be called when the selected item changes.
	   * @param cb
	   */function registerSelectedItemWatcher(cb){if(selectedItemWatchers.indexOf(cb)==-1){selectedItemWatchers.push(cb);}}/**
	   * Unregister a function previously registered for selected item changes.
	   * @param cb
	   */function unregisterSelectedItemWatcher(cb){var i=selectedItemWatchers.indexOf(cb);if(i!=-1){selectedItemWatchers.splice(i,1);}}/**
	   * Handles changes to the searchText property.
	   * @param searchText
	   * @param previousSearchText
	   */function handleSearchText(searchText,previousSearchText){ctrl.index=getDefaultIndex();// do nothing on init
	if(searchText===previousSearchText)return;updateModelValidators();getDisplayValue($scope.selectedItem).then(function(val){// clear selected item if search text no longer matches it
	if(searchText!==val){$scope.selectedItem=null;// trigger change event if available
	if(searchText!==previousSearchText)announceTextChange();// cancel results if search text is not long enough
	if(!isMinLengthMet()){ctrl.matches=[];setLoading(false);reportMessages(false,ReportType.Count);}else{handleQuery();}}});}/**
	   * Handles input blur event, determines if the dropdown should hide.
	   */function blur($event){hasFocus=false;if(!noBlur){ctrl.hidden=shouldHide();evalAttr('ngBlur',{$event:$event});}}/**
	   * Force blur on input element
	   * @param forceBlur
	   */function doBlur(forceBlur){if(forceBlur){noBlur=false;hasFocus=false;}elements.input.blur();}/**
	   * Handles input focus event, determines if the dropdown should show.
	   */function focus($event){hasFocus=true;if(isSearchable()&&isMinLengthMet()){handleQuery();}ctrl.hidden=shouldHide();evalAttr('ngFocus',{$event:$event});}/**
	   * Handles keyboard input.
	   * @param event
	   */function keydown(event){switch(event.keyCode){case $mdConstant.KEY_CODE.DOWN_ARROW:if(ctrl.loading)return;event.stopPropagation();event.preventDefault();ctrl.index=Math.min(ctrl.index+1,ctrl.matches.length-1);updateScroll();reportMessages(false,ReportType.Selected);break;case $mdConstant.KEY_CODE.UP_ARROW:if(ctrl.loading)return;event.stopPropagation();event.preventDefault();ctrl.index=ctrl.index<0?ctrl.matches.length-1:Math.max(0,ctrl.index-1);updateScroll();reportMessages(false,ReportType.Selected);break;case $mdConstant.KEY_CODE.TAB:// If we hit tab, assume that we've left the list so it will close
	onListLeave();if(ctrl.hidden||ctrl.loading||ctrl.index<0||ctrl.matches.length<1)return;select(ctrl.index);break;case $mdConstant.KEY_CODE.ENTER:if(ctrl.hidden||ctrl.loading||ctrl.index<0||ctrl.matches.length<1)return;if(hasSelection())return;event.stopPropagation();event.preventDefault();select(ctrl.index);break;case $mdConstant.KEY_CODE.ESCAPE:event.preventDefault();// Prevent browser from always clearing input
	if(!shouldProcessEscape())return;event.stopPropagation();clearSelectedItem();if($scope.searchText&&hasEscapeOption('clear')){clearSearchText();}// Manually hide (needed for mdNotFound support)
	ctrl.hidden=true;if(hasEscapeOption('blur')){// Force the component to blur if they hit escape
	doBlur(true);}break;default:}}//-- getters
	/**
	   * Returns the minimum length needed to display the dropdown.
	   * @returns {*}
	   */function getMinLength(){return angular.isNumber($scope.minLength)?$scope.minLength:1;}/**
	   * Returns the display value for an item.
	   * @param item
	   * @returns {*}
	   */function getDisplayValue(item){return $q.when(getItemText(item)||item).then(function(itemText){if(itemText&&!angular.isString(itemText)){$log.warn('md-autocomplete: Could not resolve display value to a string. '+'Please check the `md-item-text` attribute.');}return itemText;});/**
	     * Getter function to invoke user-defined expression (in the directive)
	     * to convert your object to a single string.
	     */function getItemText(item){return item&&$scope.itemText?$scope.itemText(getItemAsNameVal(item)):null;}}/**
	   * Returns the locals object for compiling item templates.
	   * @param item
	   * @returns {{}}
	   */function getItemAsNameVal(item){if(!item)return undefined;var locals={};if(ctrl.itemName)locals[ctrl.itemName]=item;return locals;}/**
	   * Returns the default index based on whether or not autoselect is enabled.
	   * @returns {number}
	   */function getDefaultIndex(){return $scope.autoselect?0:-1;}/**
	   * Sets the loading parameter and updates the hidden state.
	   * @param value {boolean} Whether or not the component is currently loading.
	   */function setLoading(value){if(ctrl.loading!=value){ctrl.loading=value;}// Always refresh the hidden variable as something else might have changed
	ctrl.hidden=shouldHide();}/**
	   * Determines if the menu should be hidden.
	   * @returns {boolean}
	   */function shouldHide(){if(!isSearchable())return true;// Hide when not able to query
	else return!shouldShow();// Hide when the dropdown is not able to show.
	}/**
	   * Determines whether the autocomplete is able to query within the current state.
	   * @returns {boolean}
	   */function isSearchable(){if(ctrl.loading&&!hasMatches())return false;// No query when query is in progress.
	else if(hasSelection())return false;// No query if there is already a selection
	else if(!hasFocus)return false;// No query if the input does not have focus
	return true;}/**
	   * Determines if the escape keydown should be processed
	   * @returns {boolean}
	   */function shouldProcessEscape(){return hasEscapeOption('blur')||!ctrl.hidden||ctrl.loading||hasEscapeOption('clear')&&$scope.searchText;}/**
	   * Determines if an escape option is set
	   * @returns {boolean}
	   */function hasEscapeOption(option){return!$scope.escapeOptions||$scope.escapeOptions.toLowerCase().indexOf(option)!==-1;}/**
	   * Determines if the menu should be shown.
	   * @returns {boolean}
	   */function shouldShow(){return isMinLengthMet()&&hasMatches()||notFoundVisible();}/**
	   * Returns true if the search text has matches.
	   * @returns {boolean}
	   */function hasMatches(){return ctrl.matches.length?true:false;}/**
	   * Returns true if the autocomplete has a valid selection.
	   * @returns {boolean}
	   */function hasSelection(){return ctrl.scope.selectedItem?true:false;}/**
	   * Returns true if the loading indicator is, or should be, visible.
	   * @returns {boolean}
	   */function loadingIsVisible(){return ctrl.loading&&!hasSelection();}/**
	   * Returns the display value of the current item.
	   * @returns {*}
	   */function getCurrentDisplayValue(){return getDisplayValue(ctrl.matches[ctrl.index]);}/**
	   * Determines if the minimum length is met by the search text.
	   * @returns {*}
	   */function isMinLengthMet(){return($scope.searchText||'').length>=getMinLength();}//-- actions
	/**
	   * Defines a public property with a handler and a default value.
	   * @param key
	   * @param handler
	   * @param value
	   */function defineProperty(key,handler,value){Object.defineProperty(ctrl,key,{get:function get(){return value;},set:function set(newValue){var oldValue=value;value=newValue;handler(newValue,oldValue);}});}/**
	   * Selects the item at the given index.
	   * @param index
	   */function select(index){//-- force form to update state for validation
	$mdUtil.nextTick(function(){getDisplayValue(ctrl.matches[index]).then(function(val){var ngModel=elements.$.input.controller('ngModel');ngModel.$setViewValue(val);ngModel.$render();}).finally(function(){$scope.selectedItem=ctrl.matches[index];setLoading(false);});},false);}/**
	   * Clears the searchText value and selected item.
	   */function clearValue(){clearSelectedItem();clearSearchText();}/**
	   * Clears the selected item
	   */function clearSelectedItem(){// Reset our variables
	ctrl.index=0;ctrl.matches=[];}/**
	   * Clears the searchText value
	   */function clearSearchText(){// Set the loading to true so we don't see flashes of content.
	// The flashing will only occur when an async request is running.
	// So the loading process will stop when the results had been retrieved.
	setLoading(true);$scope.searchText='';// Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
	// But some browsers are not detecting it properly, which means that we have to trigger the event.
	// Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
	// The `change` event is a good alternative and is supported by all supported browsers.
	var eventObj=document.createEvent('CustomEvent');eventObj.initCustomEvent('change',true,true,{value:''});elements.input.dispatchEvent(eventObj);// For some reason, firing the above event resets the value of $scope.searchText if
	// $scope.searchText has a space character at the end, so we blank it one more time and then
	// focus.
	elements.input.blur();$scope.searchText='';elements.input.focus();}/**
	   * Fetches the results for the provided search text.
	   * @param searchText
	   */function fetchResults(searchText){var items=$scope.$parent.$eval(itemExpr),term=searchText.toLowerCase(),isList=angular.isArray(items),isPromise=!!items.then;// Every promise should contain a `then` property
	if(isList)onResultsRetrieved(items);else if(isPromise)handleAsyncResults(items);function handleAsyncResults(items){if(!items)return;items=$q.when(items);fetchesInProgress++;setLoading(true);$mdUtil.nextTick(function(){items.then(onResultsRetrieved).finally(function(){if(--fetchesInProgress===0){setLoading(false);}});},true,$scope);}function onResultsRetrieved(matches){cache[term]=matches;// Just cache the results if the request is now outdated.
	// The request becomes outdated, when the new searchText has changed during the result fetching.
	if((searchText||'')!==($scope.searchText||'')){return;}handleResults(matches);}}/**
	   * Reports given message types to supported screenreaders.
	   * @param {boolean} isPolite Whether the announcement should be polite.
	   * @param {!number} types Message flags to be reported to the screenreader.
	   */function reportMessages(isPolite,types){var politeness=isPolite?'polite':'assertive';var messages=[];if(types&ReportType.Selected&&ctrl.index!==-1){messages.push(getCurrentDisplayValue());}if(types&ReportType.Count){messages.push($q.resolve(getCountMessage()));}$q.all(messages).then(function(data){$mdLiveAnnouncer.announce(data.join(' '),politeness);});}/**
	   * Returns the ARIA message for how many results match the current query.
	   * @returns {*}
	   */function getCountMessage(){switch(ctrl.matches.length){case 0:return'There are no matches available.';case 1:return'There is 1 match available.';default:return'There are '+ctrl.matches.length+' matches available.';}}/**
	   * Makes sure that the focused element is within view.
	   */function updateScroll(){if(!elements.li[0])return;var height=elements.li[0].offsetHeight,top=height*ctrl.index,bot=top+height,hgt=elements.scroller.clientHeight,scrollTop=elements.scroller.scrollTop;if(top<scrollTop){scrollTo(top);}else if(bot>scrollTop+hgt){scrollTo(bot-hgt);}}function isPromiseFetching(){return fetchesInProgress!==0;}function scrollTo(offset){elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);}function notFoundVisible(){var textLength=(ctrl.scope.searchText||'').length;return ctrl.hasNotFound&&!hasMatches()&&(!ctrl.loading||isPromiseFetching())&&textLength>=getMinLength()&&(hasFocus||noBlur)&&!hasSelection();}/**
	   * Starts the query to gather the results for the current searchText.  Attempts to return cached
	   * results first, then forwards the process to `fetchResults` if necessary.
	   */function handleQuery(){var searchText=$scope.searchText||'';var term=searchText.toLowerCase();// If caching is enabled and the current searchText is stored in the cache
	if(!$scope.noCache&&cache[term]){// The results should be handled as same as a normal un-cached request does.
	handleResults(cache[term]);}else{fetchResults(searchText);}ctrl.hidden=shouldHide();}/**
	   * Handles the retrieved results by showing them in the autocompletes dropdown.
	   * @param results Retrieved results
	   */function handleResults(results){ctrl.matches=results;ctrl.hidden=shouldHide();// If loading is in progress, then we'll end the progress. This is needed for example,
	// when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
	if(ctrl.loading)setLoading(false);if($scope.selectOnMatch)selectItemOnMatch();positionDropdown();reportMessages(true,ReportType.Count);}/**
	   * If there is only one matching item and the search text matches its display value exactly,
	   * automatically select that item.  Note: This function is only called if the user uses the
	   * `md-select-on-match` flag.
	   */function selectItemOnMatch(){var searchText=$scope.searchText,matches=ctrl.matches,item=matches[0];if(matches.length===1)getDisplayValue(item).then(function(displayValue){var isMatching=searchText==displayValue;if($scope.matchInsensitive&&!isMatching){isMatching=searchText.toLowerCase()==displayValue.toLowerCase();}if(isMatching)select(0);});}/**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   * @param {Object?} locals Properties to be injected into the evaluation context.
	   */function evalAttr(attr,locals){if($attrs[attr]){$scope.$parent.$eval($attrs[attr],locals||{});}}}})();(function(){"use strict";MdAutocomplete.$inject=["$$mdSvgRegistry"];angular.module('material.components.autocomplete').directive('mdAutocomplete',MdAutocomplete);/**
	 * @ngdoc directive
	 * @name mdAutocomplete
	 * @module material.components.autocomplete
	 *
	 * @description
	 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
	 *     custom query. This component allows you to provide real-time suggestions as the user types
	 *     in the input area.
	 *
	 * To start, you will need to specify the required parameters and provide a template for your
	 *     results. The content inside `md-autocomplete` will be treated as a template.
	 *
	 * In more complex cases, you may want to include other content such as a message to display when
	 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
	 *     adding a tag for `md-not-found`.  An example of this is shown below.
	 *
	 * To reset the displayed value you must clear both values for `md-search-text` and `md-selected-item`.
	 *
	 * ### Validation
	 *
	 * You can use `ng-messages` to include validation the same way that you would normally validate;
	 *     however, if you want to replicate a standard input with a floating label, you will have to
	 *     do the following:
	 *
	 * - Make sure that your template is wrapped in `md-item-template`
	 * - Add your `ng-messages` code inside of `md-autocomplete`
	 * - Add your validation properties to `md-autocomplete` (ie. `required`)
	 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
	 *
	 * There is an example below of how this should look.
	 *
	 * ### Snapping Drop-Down
	 *
	 * You can cause the autocomplete drop-down to snap to an ancestor element by applying the
	 *     `md-autocomplete-snap` attribute to that element. You can also snap to the width of
	 *     the `md-autocomplete-snap` element by setting the attribute's value to `width`
	 *     (ie. `md-autocomplete-snap="width"`).
	 *
	 * ### Notes
	 *
	 * **Autocomplete Dropdown Items Rendering**
	 *
	 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeat</a>
	 * directive for displaying the results inside of the dropdown.<br/>
	 *
	 * > When encountering issues regarding the item template please take a look at the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
	 *
	 * **Autocomplete inside of a Virtual Repeat**
	 *
	 * When using the `md-autocomplete` directive inside of a
	 * <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> the dropdown items might
	 * not update properly, because caching of the results is enabled by default.
	 *
	 * The autocomplete will then show invalid dropdown items, because the VirtualRepeat only updates the
	 * scope bindings, rather than re-creating the `md-autocomplete` and the previous cached results will be used.
	 *
	 * > To avoid such problems ensure that the autocomplete does not cache any results.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-no-cache="true"
	 *       md-selected-item="selectedItem"
	 *       md-items="item in items"
	 *       md-search-text="searchText"
	 *       md-item-text="item.display">
	 *     <span>{{ item.display }}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 *
	 *
	 * @param {expression} md-items An expression in the format of `item in results` to iterate over
	 *     matches for your search.<br/><br/>
	 *     The `results` expression can be also a function, which returns the results synchronously
	 *     or asynchronously (per Promise).
	 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
	 *     selected.
	 * @param {expression=} md-search-text-change An expression to be run each time the search text
	 *     updates.
	 * @param {expression=} md-search-text A model to bind the search query text to.
	 * @param {object=} md-selected-item A model to bind the selected item to.
	 * @param {expression=} md-item-text An expression that will convert your object to a single string.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete.
	 * @param {boolean=} ng-disabled Determines whether or not to disable the input field.
	 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
	 *     which will evaluate to false, when no item is currently selected.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *     make suggestions.
	 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
	 *     for results.
	 * @param {boolean=} md-clear-button Whether the clear button for the autocomplete input should show up or not.
	 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a `$mdDialog`,
	 *     `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening. <br/><br/>
	 *     Also the autocomplete will immediately focus the input element.
	 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating label.
	 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
	 *     in the dropdown upon open.
	 * @param {string=} md-menu-class This will be applied to the dropdown menu for styling.
	 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
	 *     `md-input-container`.
	 * @param {string=} md-input-name The name attribute given to the input element to be used with
	 *     FormController.
	 * @param {string=} md-select-on-focus When present the inputs text will be automatically selected
	 *     on focus.
	 * @param {string=} md-input-id An ID to be added to the input element.
	 * @param {number=} md-input-minlength The minimum length for the input's value for validation.
	 * @param {number=} md-input-maxlength The maximum length for the input's value for validation.
	 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select
	 *     the item if the search text is an exact match. <br/><br/>
	 *     An exact match is when only one match is displayed.
	 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
	 *     will select on case-insensitive match.
	 * @param {string=} md-escape-options Override escape key logic. Default is `blur clear`.<br/>
	 *     Options: `blur`, `clear`, `none`.
	 * @param {string=} md-dropdown-items Specifies the maximum amount of items to be shown in
	 *     the dropdown.<br/><br/>
	 *     When the dropdown doesn't fit into the viewport, the dropdown will shrink
	 *     as much as possible.
	 * @param {string=} md-dropdown-position Overrides the default dropdown position. Options: `top`, `bottom`.
	 * @param {string=} ng-trim If set to false, the search text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} ng-pattern Adds the pattern validator to the ngModel of the search text.
	 *     See the [ngPattern Directive](https://docs.angularjs.org/api/ng/directive/ngPattern)
	 *     for more details.
	 *
	 * @usage
	 * ### Basic Example
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with "not found" message
	 * <hljs lang="html">
	 * <md-autocomplete
	 *     md-selected-item="selectedItem"
	 *     md-search-text="searchText"
	 *     md-items="item in getMatches(searchText)"
	 *     md-item-text="item.display">
	 *   <md-item-template>
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-item-template>
	 *   <md-not-found>
	 *     No matches found.
	 *   </md-not-found>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
	 *     different parts that make up our component.
	 *
	 * ### Clear button for the input
	 * By default, for floating label autocomplete's the clear button is not showing up
	 * ([See specs](https://material.google.com/components/text-fields.html#text-fields-auto-complete-text-field))
	 *
	 * Nevertheless, developers are able to explicitly toggle the clear button for all types of autocomplete's.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... md-clear-button="true"></md-autocomplete>
	 *   <md-autocomplete ... md-clear-button="false"></md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with validation
	 * <hljs lang="html">
	 * <form name="autocompleteForm">
	 *   <md-autocomplete
	 *       required
	 *       md-input-name="autocomplete"
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item.display}}</span>
	 *     </md-item-template>
	 *     <div ng-messages="autocompleteForm.autocomplete.$error">
	 *       <div ng-message="required">This field is required</div>
	 *     </div>
	 *   </md-autocomplete>
	 * </form>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
	 *     input validation for the field.
	 *
	 * ### Asynchronous Results
	 * The autocomplete items expression also supports promises, which will resolve with the query results.
	 *
	 * <hljs lang="js">
	 *   function AppController($scope, $http) {
	 *     $scope.query = function(searchText) {
	 *       return $http
	 *         .get(BACKEND_URL + '/items/' + searchText)
	 *         .then(function(data) {
	 *           // Map the response object to the data object.
	 *           return data;
	 *         });
	 *     };
	 *   }
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in query(searchText)">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item}}</span>
	 *     </md-item-template>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 */function MdAutocomplete($$mdSvgRegistry){return{controller:'MdAutocompleteCtrl',controllerAs:'$mdAutocompleteCtrl',scope:{inputName:'@mdInputName',inputMinlength:'@mdInputMinlength',inputMaxlength:'@mdInputMaxlength',searchText:'=?mdSearchText',selectedItem:'=?mdSelectedItem',itemsExpr:'@mdItems',itemText:'&mdItemText',placeholder:'@placeholder',noCache:'=?mdNoCache',requireMatch:'=?mdRequireMatch',selectOnMatch:'=?mdSelectOnMatch',matchInsensitive:'=?mdMatchCaseInsensitive',itemChange:'&?mdSelectedItemChange',textChange:'&?mdSearchTextChange',minLength:'=?mdMinLength',delay:'=?mdDelay',autofocus:'=?mdAutofocus',floatingLabel:'@?mdFloatingLabel',autoselect:'=?mdAutoselect',menuClass:'@?mdMenuClass',inputId:'@?mdInputId',escapeOptions:'@?mdEscapeOptions',dropdownItems:'=?mdDropdownItems',dropdownPosition:'@?mdDropdownPosition',clearButton:'=?mdClearButton'},compile:function compile(tElement,tAttrs){var attributes=['md-select-on-focus','md-no-asterisk','ng-trim','ng-pattern'];var input=tElement.find('input');attributes.forEach(function(attribute){var attrValue=tAttrs[tAttrs.$normalize(attribute)];if(attrValue!==null){input.attr(attribute,attrValue);}});return function(scope,element,attrs,ctrl){// Retrieve the state of using a md-not-found template by using our attribute, which will
	// be added to the element in the template function.
	ctrl.hasNotFound=!!element.attr('md-has-not-found');// By default the inset autocomplete should show the clear button when not explicitly overwritten.
	if(!angular.isDefined(attrs.mdClearButton)&&!scope.floatingLabel){scope.clearButton=true;}};},template:function template(element,attr){var noItemsTemplate=getNoItemsTemplate(),itemTemplate=getItemTemplate(),leftover=element.html(),tabindex=attr.tabindex;// Set our attribute for the link function above which runs later.
	// We will set an attribute, because otherwise the stored variables will be trashed when
	// removing the element is hidden while retrieving the template. For example when using ngIf.
	if(noItemsTemplate)element.attr('md-has-not-found',true);// Always set our tabindex of the autocomplete directive to -1, because our input
	// will hold the actual tabindex.
	element.attr('tabindex','-1');return'\
	        <md-autocomplete-wrap\
	            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
	                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
	                        \'md-show-clear-button\': !!clearButton }">\
	          '+getInputElement()+'\
	          '+getClearButton()+'\
	          <md-progress-linear\
	              class="'+(attr.mdFloatingLabel?'md-inline':'')+'"\
	              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
	              md-mode="indeterminate"></md-progress-linear>\
	          <md-virtual-repeat-container\
	              md-auto-shrink\
	              md-auto-shrink-min="1"\
	              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	              ng-mouseup="$mdAutocompleteCtrl.mouseUp()"\
	              ng-hide="$mdAutocompleteCtrl.hidden"\
	              class="md-autocomplete-suggestions-container md-whiteframe-z1"\
	              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	              role="presentation">\
	            <ul class="md-autocomplete-suggestions"\
	                ng-class="::menuClass"\
	                id="ul-{{$mdAutocompleteCtrl.id}}">\
	              <li md-virtual-repeat="item in $mdAutocompleteCtrl.matches"\
	                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
	                  ng-click="$mdAutocompleteCtrl.select($index)"\
	                  md-extra-name="$mdAutocompleteCtrl.itemName">\
	                  '+itemTemplate+'\
	                  </li>'+noItemsTemplate+'\
	            </ul>\
	          </md-virtual-repeat-container>\
	        </md-autocomplete-wrap>';function getItemTemplate(){var templateTag=element.find('md-item-template').detach(),html=templateTag.length?templateTag.html():element.html();if(!templateTag.length)element.empty();return'<md-autocomplete-parent-scope md-autocomplete-replace>'+html+'</md-autocomplete-parent-scope>';}function getNoItemsTemplate(){var templateTag=element.find('md-not-found').detach(),template=templateTag.length?templateTag.html():'';return template?'<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
	                         md-autocomplete-parent-scope>'+template+'</li>':'';}function getInputElement(){if(attr.mdFloatingLabel){return'\
	            <md-input-container ng-if="floatingLabel">\
	              <label>{{floatingLabel}}</label>\
	              <input type="search"\
	                  '+(tabindex!=null?'tabindex="'+tabindex+'"':'')+'\
	                  id="{{ inputId || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
	                  name="{{inputName}}"\
	                  autocomplete="off"\
	                  ng-required="$mdAutocompleteCtrl.isRequired"\
	                  ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                  ng-minlength="inputMinlength"\
	                  ng-maxlength="inputMaxlength"\
	                  ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                  ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                  ng-model-options="{ allowInvalid: true }"\
	                  ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                  ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                  ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                  aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                  aria-label="{{floatingLabel}}"\
	                  aria-autocomplete="list"\
	                  role="combobox"\
	                  aria-haspopup="true"\
	                  aria-activedescendant=""\
	                  aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
	              <div md-autocomplete-parent-scope md-autocomplete-replace>'+leftover+'</div>\
	            </md-input-container>';}else{return'\
	            <input type="search"\
	                '+(tabindex!=null?'tabindex="'+tabindex+'"':'')+'\
	                id="{{ inputId || \'input-\' + $mdAutocompleteCtrl.id }}"\
	                name="{{inputName}}"\
	                ng-if="!floatingLabel"\
	                autocomplete="off"\
	                ng-required="$mdAutocompleteCtrl.isRequired"\
	                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                ng-minlength="inputMinlength"\
	                ng-maxlength="inputMaxlength"\
	                ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                placeholder="{{placeholder}}"\
	                aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                aria-label="{{placeholder}}"\
	                aria-autocomplete="list"\
	                role="combobox"\
	                aria-haspopup="true"\
	                aria-activedescendant=""\
	                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>';}}function getClearButton(){return''+'<button '+'type="button" '+'aria-label="Clear Input" '+'tabindex="-1" '+'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText" '+'ng-click="$mdAutocompleteCtrl.clear($event)">'+'<md-icon md-svg-src="'+$$mdSvgRegistry.mdClose+'"></md-icon>'+'</button>';}}};}})();(function(){"use strict";MdAutocompleteItemScopeDirective.$inject=["$compile","$mdUtil"];angular.module('material.components.autocomplete').directive('mdAutocompleteParentScope',MdAutocompleteItemScopeDirective);function MdAutocompleteItemScopeDirective($compile,$mdUtil){return{restrict:'AE',compile:compile,terminal:true,transclude:'element'};function compile(tElement,tAttr,transclude){return function postLink(scope,element,attr){var ctrl=scope.$mdAutocompleteCtrl;var newScope=ctrl.parent.$new();var itemName=ctrl.itemName;// Watch for changes to our scope's variables and copy them to the new scope
	watchVariable('$index','$index');watchVariable('item',itemName);// Ensure that $digest calls on our scope trigger $digest on newScope.
	connectScopes();// Link the element against newScope.
	transclude(newScope,function(clone){element.after(clone);});/**
	       * Creates a watcher for variables that are copied from the parent scope
	       * @param variable
	       * @param alias
	       */function watchVariable(variable,alias){newScope[alias]=scope[variable];scope.$watch(variable,function(value){$mdUtil.nextTick(function(){newScope[alias]=value;});});}/**
	       * Creates watchers on scope and newScope that ensure that for any
	       * $digest of scope, newScope is also $digested.
	       */function connectScopes(){var scopeDigesting=false;var newScopeDigesting=false;scope.$watch(function(){if(newScopeDigesting||scopeDigesting){return;}scopeDigesting=true;scope.$$postDigest(function(){if(!newScopeDigesting){newScope.$digest();}scopeDigesting=newScopeDigesting=false;});});newScope.$watch(function(){newScopeDigesting=true;});}};}}})();(function(){"use strict";MdHighlightCtrl.$inject=["$scope","$element","$attrs"];angular.module('material.components.autocomplete').controller('MdHighlightCtrl',MdHighlightCtrl);function MdHighlightCtrl($scope,$element,$attrs){this.$scope=$scope;this.$element=$element;this.$attrs=$attrs;// Cache the Regex to avoid rebuilding each time.
	this.regex=null;}MdHighlightCtrl.prototype.init=function(unsafeTermFn,unsafeContentFn){this.flags=this.$attrs.mdHighlightFlags||'';this.unregisterFn=this.$scope.$watch(function($scope){return{term:unsafeTermFn($scope),contentText:unsafeContentFn($scope)};}.bind(this),this.onRender.bind(this),true);this.$element.on('$destroy',this.unregisterFn);};/**
	 * Triggered once a new change has been recognized and the highlighted
	 * text needs to be updated.
	 */MdHighlightCtrl.prototype.onRender=function(state,prevState){var contentText=state.contentText;/* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */if(this.regex===null||state.term!==prevState.term){this.regex=this.createRegex(state.term,this.flags);}/* If a term is available apply the regex to the content */if(state.term){this.applyRegex(contentText);}else{this.$element.text(contentText);}};/**
	 * Decomposes the specified text into different tokens (whether match or not).
	 * Breaking down the string guarantees proper XSS protection due to the native browser
	 * escaping of unsafe text.
	 */MdHighlightCtrl.prototype.applyRegex=function(text){var tokens=this.resolveTokens(text);this.$element.empty();tokens.forEach(function(token){if(token.isMatch){var tokenEl=angular.element('<span class="highlight">').text(token.text);this.$element.append(tokenEl);}else{this.$element.append(document.createTextNode(token));}}.bind(this));};/**
	 * Decomposes the specified text into different tokens by running the regex against the text.
	 */MdHighlightCtrl.prototype.resolveTokens=function(string){var tokens=[];var lastIndex=0;// Use replace here, because it supports global and single regular expressions at same time.
	string.replace(this.regex,function(match,index){appendToken(lastIndex,index);tokens.push({text:match,isMatch:true});lastIndex=index+match.length;});// Append the missing text as a token.
	appendToken(lastIndex);return tokens;function appendToken(from,to){var targetText=string.slice(from,to);targetText&&tokens.push(targetText);}};/** Creates a regex for the specified text with the given flags. */MdHighlightCtrl.prototype.createRegex=function(term,flags){var startFlag='',endFlag='';var regexTerm=this.sanitizeRegex(term);if(flags.indexOf('^')>=0)startFlag='^';if(flags.indexOf('$')>=0)endFlag='$';return new RegExp(startFlag+regexTerm+endFlag,flags.replace(/[$^]/g,''));};/** Sanitizes a regex by removing all common RegExp identifiers */MdHighlightCtrl.prototype.sanitizeRegex=function(term){return term&&term.toString().replace(/[\\^$*+?.()|{}[\]]/g,'\\$&');};})();(function(){"use strict";MdHighlight.$inject=["$interpolate","$parse"];angular.module('material.components.autocomplete').directive('mdHighlightText',MdHighlight);/**
	 * @ngdoc directive
	 * @name mdHighlightText
	 * @module material.components.autocomplete
	 *
	 * @description
	 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
	 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
	 *     be styled through CSS.  Please note that child elements may not be used with this directive.
	 *
	 * @param {string} md-highlight-text A model to be searched for
	 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
	 * #### **Supported flags**:
	 * - `g`: Find all matches within the provided text
	 * - `i`: Ignore case when searching for matches
	 * - `$`: Only match if the text ends with the search term
	 * - `^`: Only match if the text begins with the search term
	 *
	 * @usage
	 * <hljs lang="html">
	 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
	 * <ul>
	 *   <li ng-repeat="result in results" md-highlight-text="searchTerm">
	 *     {{result.text}}
	 *   </li>
	 * </ul>
	 * </hljs>
	 */function MdHighlight($interpolate,$parse){return{terminal:true,controller:'MdHighlightCtrl',compile:function mdHighlightCompile(tElement,tAttr){var termExpr=$parse(tAttr.mdHighlightText);var unsafeContentExpr=$interpolate(tElement.html());return function mdHighlightLink(scope,element,attr,ctrl){ctrl.init(termExpr,unsafeContentExpr);};}};}})();(function(){"use strict";MdChipCtrl.$inject=["$scope","$element","$mdConstant","$timeout","$mdUtil"];angular.module('material.components.chips').controller('MdChipCtrl',MdChipCtrl);/**
	 * Controller for the MdChip component. Responsible for handling keyboard
	 * events and editting the chip if needed.
	 *
	 * @param $scope
	 * @param $element
	 * @param $mdConstant
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */function MdChipCtrl($scope,$element,$mdConstant,$timeout,$mdUtil){/**
	   * @type {$scope}
	   */this.$scope=$scope;/**
	   * @type {$element}
	   */this.$element=$element;/**
	   * @type {$mdConstant}
	   */this.$mdConstant=$mdConstant;/**
	   * @type {$timeout}
	   */this.$timeout=$timeout;/**
	   * @type {$mdUtil}
	   */this.$mdUtil=$mdUtil;/**
	   * @type {boolean}
	   */this.isEditting=false;/**
	   * @type {MdChipsCtrl}
	   */this.parentController=undefined;/**
	   * @type {boolean}
	   */this.enableChipEdit=false;}/**
	 * @param {MdChipsCtrl} controller
	 */MdChipCtrl.prototype.init=function(controller){this.parentController=controller;this.enableChipEdit=this.parentController.enableChipEdit;if(this.enableChipEdit){this.$element.on('keydown',this.chipKeyDown.bind(this));this.$element.on('mousedown',this.chipMouseDown.bind(this));this.getChipContent().addClass('_md-chip-content-edit-is-enabled');}};/**
	 * @return {Object}
	 */MdChipCtrl.prototype.getChipContent=function(){var chipContents=this.$element[0].getElementsByClassName('md-chip-content');return angular.element(chipContents[0]);};/**
	 * @return {Object}
	 */MdChipCtrl.prototype.getContentElement=function(){return angular.element(this.getChipContent().children()[0]);};/**
	 * @return {number}
	 */MdChipCtrl.prototype.getChipIndex=function(){return parseInt(this.$element.attr('index'));};/**
	 * Presents an input element to edit the contents of the chip.
	 */MdChipCtrl.prototype.goOutOfEditMode=function(){if(!this.isEditting)return;this.isEditting=false;this.$element.removeClass('_md-chip-editing');this.getChipContent()[0].contentEditable='false';var chipIndex=this.getChipIndex();var content=this.getContentElement().text();if(content){this.parentController.updateChipContents(chipIndex,this.getContentElement().text());this.$mdUtil.nextTick(function(){if(this.parentController.selectedChip===chipIndex){this.parentController.focusChip(chipIndex);}}.bind(this));}else{this.parentController.removeChipAndFocusInput(chipIndex);}};/**
	 * Given an HTML element. Selects contents of it.
	 * @param node
	 */MdChipCtrl.prototype.selectNodeContents=function(node){var range,selection;if(document.body.createTextRange){range=document.body.createTextRange();range.moveToElementText(node);range.select();}else if(window.getSelection){selection=window.getSelection();range=document.createRange();range.selectNodeContents(node);selection.removeAllRanges();selection.addRange(range);}};/**
	 * Presents an input element to edit the contents of the chip.
	 */MdChipCtrl.prototype.goInEditMode=function(){this.isEditting=true;this.$element.addClass('_md-chip-editing');this.getChipContent()[0].contentEditable='true';this.getChipContent().on('blur',function(){this.goOutOfEditMode();}.bind(this));this.selectNodeContents(this.getChipContent()[0]);};/**
	 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
	 * set to true, space or enter keys can trigger going into edit mode. Enter can also
	 * trigger submitting if the chip is already being edited.
	 * @param event
	 */MdChipCtrl.prototype.chipKeyDown=function(event){if(!this.isEditting&&(event.keyCode===this.$mdConstant.KEY_CODE.ENTER||event.keyCode===this.$mdConstant.KEY_CODE.SPACE)){event.preventDefault();this.goInEditMode();}else if(this.isEditting&&event.keyCode===this.$mdConstant.KEY_CODE.ENTER){event.preventDefault();this.goOutOfEditMode();}};/**
	 * Handles the double click event
	 */MdChipCtrl.prototype.chipMouseDown=function(){if(this.getChipIndex()==this.parentController.selectedChip&&this.enableChipEdit&&!this.isEditting){this.goInEditMode();}};})();(function(){"use strict";MdChip.$inject=["$mdTheming","$mdUtil","$compile","$timeout"];angular.module('material.components.chips').directive('mdChip',MdChip);/**
	 * @ngdoc directive
	 * @name mdChip
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-chip>` is a component used within `<md-chips>` and is responsible for rendering individual
	 * chips.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chip>{{$chip}}</md-chip>
	 * </hljs>
	 *
	 */// This hint text is hidden within a chip but used by screen readers to
	// inform the user how they can interact with a chip.
	var DELETE_HINT_TEMPLATE='\
	    <span ng-if="!$mdChipsCtrl.readonly" class="md-visually-hidden">\
	      {{$mdChipsCtrl.deleteHint}}\
	    </span>';/**
	 * MDChip Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @ngInject
	 */function MdChip($mdTheming,$mdUtil,$compile,$timeout){var deleteHintTemplate=$mdUtil.processTemplate(DELETE_HINT_TEMPLATE);return{restrict:'E',require:['^?mdChips','mdChip'],link:postLink,controller:'MdChipCtrl'};function postLink(scope,element,attr,ctrls){var chipsController=ctrls.shift();var chipController=ctrls.shift();var chipContentElement=angular.element(element[0].querySelector('.md-chip-content'));$mdTheming(element);if(chipsController){chipController.init(chipsController);// Append our delete hint to the div.md-chip-content (which does not exist at compile time)
	chipContentElement.append($compile(deleteHintTemplate)(scope));// When a chip is blurred, make sure to unset (or reset) the selected chip so that tabbing
	// through elements works properly
	chipContentElement.on('blur',function(){chipsController.resetSelectedChip();chipsController.$scope.$applyAsync();});}// Use $timeout to ensure we run AFTER the element has been added to the DOM so we can focus it.
	$timeout(function(){if(!chipsController){return;}if(chipsController.shouldFocusLastChip){chipsController.focusLastChipThenInput();}});}}})();(function(){"use strict";MdChipRemove.$inject=["$timeout"];angular.module('material.components.chips').directive('mdChipRemove',MdChipRemove);/**
	 * @ngdoc directive
	 * @name mdChipRemove
	 * @restrict A
	 * @module material.components.chips
	 *
	 * @description
	 * Designates an element to be used as the delete button for a chip. <br/>
	 * This element is passed as a child of the `md-chips` element.
	 *
	 * The designated button will be just appended to the chip and removes the given chip on click.<br/>
	 * By default the button is not being styled by the `md-chips` component.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chips>
	 *     <button md-chip-remove="">
	 *       <md-icon md-svg-icon="md-close"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 *//**
	 * MdChipRemove Directive Definition.
	 * 
	 * @param $timeout
	 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
	 * @constructor
	 */function MdChipRemove($timeout){return{restrict:'A',require:'^mdChips',scope:false,link:postLink};function postLink(scope,element,attr,ctrl){element.on('click',function(event){scope.$apply(function(){ctrl.removeChip(scope.$$replacedScope.$index);});});// Child elements aren't available until after a $timeout tick as they are hidden by an
	// `ng-if`. see http://goo.gl/zIWfuw
	$timeout(function(){element.attr({tabindex:-1,'aria-hidden':true});element.find('button').attr('tabindex','-1');});}}})();(function(){"use strict";MdChipTransclude.$inject=["$compile"];angular.module('material.components.chips').directive('mdChipTransclude',MdChipTransclude);function MdChipTransclude($compile){return{restrict:'EA',terminal:true,link:link,scope:false};function link(scope,element,attr){var ctrl=scope.$parent.$mdChipsCtrl,newScope=ctrl.parent.$new(false,ctrl.parent);newScope.$$replacedScope=scope;newScope.$chip=scope.$chip;newScope.$index=scope.$index;newScope.$mdChipsCtrl=ctrl;var newHtml=ctrl.$scope.$eval(attr.mdChipTransclude);element.html(newHtml);$compile(element.contents())(newScope);}}})();(function(){"use strict";/**
	 * The default chip append delay.
	 *
	 * @type {number}
	 */MdChipsCtrl.$inject=["$scope","$attrs","$mdConstant","$log","$element","$timeout","$mdUtil"];var DEFAULT_CHIP_APPEND_DELAY=300;angular.module('material.components.chips').controller('MdChipsCtrl',MdChipsCtrl);/**
	 * Controller for the MdChips component. Responsible for adding to and
	 * removing from the list of chips, marking chips as selected, and binding to
	 * the models of various input components.
	 *
	 * @param $scope
	 * @param $attrs
	 * @param $mdConstant
	 * @param $log
	 * @param $element
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */function MdChipsCtrl($scope,$attrs,$mdConstant,$log,$element,$timeout,$mdUtil){/** @type {$timeout} **/this.$timeout=$timeout;/** @type {Object} */this.$mdConstant=$mdConstant;/** @type {angular.$scope} */this.$scope=$scope;/** @type {angular.$scope} */this.parent=$scope.$parent;/** @type {$mdUtil} */this.$mdUtil=$mdUtil;/** @type {$log} */this.$log=$log;/** @type {$element} */this.$element=$element;/** @type {$attrs} */this.$attrs=$attrs;/** @type {angular.NgModelController} */this.ngModelCtrl=null;/** @type {angular.NgModelController} */this.userInputNgModelCtrl=null;/** @type {MdAutocompleteCtrl} */this.autocompleteCtrl=null;/** @type {Element} */this.userInputElement=null;/** @type {Array.<Object>} */this.items=[];/** @type {number} */this.selectedChip=-1;/** @type {string} */this.enableChipEdit=$mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);/** @type {string} */this.addOnBlur=$mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);/**
	   * The text to be used as the aria-label for the input.
	   * @type {string}
	   */this.inputAriaLabel='Chips input.';/**
	   * Hidden hint text to describe the chips container. Used to give context to screen readers when
	   * the chips are readonly and the input cannot be selected.
	   *
	   * @type {string}
	   */this.containerHint='Chips container. Use arrow keys to select chips.';/**
	   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
	   * @type {string}
	   */this.deleteHint='Press delete to remove this chip.';/**
	   * Hidden label for the delete button. Used to give context to screen readers.
	   * @type {string}
	   */this.deleteButtonLabel='Remove';/**
	   * Model used by the input element.
	   * @type {string}
	   */this.chipBuffer='';/**
	   * Whether to use the transformChip expression to transform the chip buffer
	   * before appending it to the list.
	   * @type {boolean}
	   */this.useTransformChip=false;/**
	   * Whether to use the onAdd expression to notify of chip additions.
	   * @type {boolean}
	   */this.useOnAdd=false;/**
	   * Whether to use the onRemove expression to notify of chip removals.
	   * @type {boolean}
	   */this.useOnRemove=false;/**
	   * The ID of the chips wrapper which is used to build unique IDs for the chips and the aria-owns
	   * attribute.
	   *
	   * Defaults to '_md-chips-wrapper-' plus a unique number.
	   *
	   * @type {string}
	   */this.wrapperId='';/**
	   * Array of unique numbers which will be auto-generated any time the items change, and is used to
	   * create unique IDs for the aria-owns attribute.
	   *
	   * @type {Array}
	   */this.contentIds=[];/**
	   * The index of the chip that should have it's tabindex property set to 0 so it is selectable
	   * via the keyboard.
	   *
	   * @type {int}
	   */this.ariaTabIndex=null;/**
	   * After appending a chip, the chip will be focused for this number of milliseconds before the
	   * input is refocused.
	   *
	   * **Note:** This is **required** for compatibility with certain screen readers in order for
	   * them to properly allow keyboard access.
	   *
	   * @type {number}
	   */this.chipAppendDelay=DEFAULT_CHIP_APPEND_DELAY;/**
	   * Collection of functions to call to un-register watchers
	   *
	   * @type {Array}
	   */this.deRegister=[];this.init();}/**
	 * Initializes variables and sets up watchers
	 */MdChipsCtrl.prototype.init=function(){var ctrl=this;// Set the wrapper ID
	this.wrapperId='_md-chips-wrapper-'+this.$mdUtil.nextUid();// Setup a watcher which manages the role and aria-owns attributes
	this.deRegister.push(this.$scope.$watchCollection('$mdChipsCtrl.items',function(){// Make sure our input and wrapper have the correct ARIA attributes
	ctrl.setupInputAria();ctrl.setupWrapperAria();}));this.deRegister.push(this.$attrs.$observe('mdChipAppendDelay',function(newValue){var numberValue=parseInt(newValue);ctrl.chipAppendDelay=isNaN(numberValue)?DEFAULT_CHIP_APPEND_DELAY:numberValue;}));};/**
	 * Destructor for cleanup
	 */MdChipsCtrl.prototype.$onDestroy=function $onDestroy(){var $destroyFn;while($destroyFn=this.deRegister.pop()){$destroyFn.call(this);}};/**
	 * If we have an input, ensure it has the appropriate ARIA attributes.
	 */MdChipsCtrl.prototype.setupInputAria=function(){var input=this.$element.find('input');// If we have no input, just return
	if(!input){return;}input.attr('role','textbox');input.attr('aria-multiline',true);};/**
	 * Ensure our wrapper has the appropriate ARIA attributes.
	 */MdChipsCtrl.prototype.setupWrapperAria=function(){var ctrl=this,wrapper=this.$element.find('md-chips-wrap');if(this.items&&this.items.length){// Dynamically add the listbox role on every change because it must be removed when there are
	// no items.
	wrapper.attr('role','listbox');// Generate some random (but unique) IDs for each chip
	this.contentIds=this.items.map(function(){return ctrl.wrapperId+'-chip-'+ctrl.$mdUtil.nextUid();});// Use the contentIDs above to generate the aria-owns attribute
	wrapper.attr('aria-owns',this.contentIds.join(' '));}else{// If we have no items, then the role and aria-owns attributes MUST be removed
	wrapper.removeAttr('role');wrapper.removeAttr('aria-owns');}};/**
	 * Handles the keydown event on the input element: by default <enter> appends
	 * the buffer to the chip list, while backspace removes the last chip in the
	 * list if the current buffer is empty.
	 * @param event
	 */MdChipsCtrl.prototype.inputKeydown=function(event){var chipBuffer=this.getChipBuffer();// If we have an autocomplete, and it handled the event, we have nothing to do
	if(this.autocompleteCtrl&&event.isDefaultPrevented&&event.isDefaultPrevented()){return;}if(event.keyCode===this.$mdConstant.KEY_CODE.BACKSPACE){// Only select and focus the previous chip, if the current caret position of the
	// input element is at the beginning.
	if(this.getCursorPosition(event.target)!==0){return;}event.preventDefault();event.stopPropagation();if(this.items.length){this.selectAndFocusChipSafe(this.items.length-1);}return;}// By default <enter> appends the buffer to the chip list.
	if(!this.separatorKeys||this.separatorKeys.length<1){this.separatorKeys=[this.$mdConstant.KEY_CODE.ENTER];}// Support additional separator key codes in an array of `md-separator-keys`.
	if(this.separatorKeys.indexOf(event.keyCode)!==-1){if(this.autocompleteCtrl&&this.requireMatch||!chipBuffer)return;event.preventDefault();// Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	if(this.hasMaxChipsReached())return;this.appendChip(chipBuffer.trim());this.resetChipBuffer();return false;}};/**
	 * Returns the cursor position of the specified input element.
	 * @param element HTMLInputElement
	 * @returns {Number} Cursor Position of the input.
	 */MdChipsCtrl.prototype.getCursorPosition=function(element){/*
	   * Figure out whether the current input for the chips buffer is valid for using
	   * the selectionStart / end property to retrieve the cursor position.
	   * Some browsers do not allow the use of those attributes, on different input types.
	   */try{if(element.selectionStart===element.selectionEnd){return element.selectionStart;}}catch(e){if(!element.value){return 0;}}};/**
	 * Updates the content of the chip at given index
	 * @param chipIndex
	 * @param chipContents
	 */MdChipsCtrl.prototype.updateChipContents=function(chipIndex,chipContents){if(chipIndex>=0&&chipIndex<this.items.length){this.items[chipIndex]=chipContents;this.ngModelCtrl.$setDirty();}};/**
	 * Returns true if a chip is currently being edited. False otherwise.
	 * @return {boolean}
	 */MdChipsCtrl.prototype.isEditingChip=function(){return!!this.$element[0].querySelector('._md-chip-editing');};MdChipsCtrl.prototype.isRemovable=function(){// Return false if we have static chips
	if(!this.ngModelCtrl){return false;}return this.readonly?this.removable:angular.isDefined(this.removable)?this.removable:true;};/**
	 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
	 * keys switch which chips is active
	 * @param event
	 */MdChipsCtrl.prototype.chipKeydown=function(event){if(this.getChipBuffer())return;if(this.isEditingChip())return;switch(event.keyCode){case this.$mdConstant.KEY_CODE.BACKSPACE:case this.$mdConstant.KEY_CODE.DELETE:if(this.selectedChip<0)return;event.preventDefault();// Cancel the delete action only after the event cancel. Otherwise the page will go back.
	if(!this.isRemovable())return;this.removeAndSelectAdjacentChip(this.selectedChip);break;case this.$mdConstant.KEY_CODE.LEFT_ARROW:event.preventDefault();// By default, allow selection of -1 which will focus the input; if we're readonly, don't go
	// below 0
	if(this.selectedChip<0||this.readonly&&this.selectedChip==0){this.selectedChip=this.items.length;}if(this.items.length)this.selectAndFocusChipSafe(this.selectedChip-1);break;case this.$mdConstant.KEY_CODE.RIGHT_ARROW:event.preventDefault();this.selectAndFocusChipSafe(this.selectedChip+1);break;case this.$mdConstant.KEY_CODE.ESCAPE:case this.$mdConstant.KEY_CODE.TAB:if(this.selectedChip<0)return;event.preventDefault();this.onFocus();break;}};/**
	 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
	 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
	 * always.
	 */MdChipsCtrl.prototype.getPlaceholder=function(){// Allow `secondary-placeholder` to be blank.
	var useSecondary=this.items&&this.items.length&&(this.secondaryPlaceholder==''||this.secondaryPlaceholder);return useSecondary?this.secondaryPlaceholder:this.placeholder;};/**
	 * Removes chip at {@code index} and selects the adjacent chip.
	 * @param index
	 */MdChipsCtrl.prototype.removeAndSelectAdjacentChip=function(index){var self=this;var selIndex=self.getAdjacentChipIndex(index);var wrap=this.$element[0].querySelector('md-chips-wrap');var chip=this.$element[0].querySelector('md-chip[index="'+index+'"]');self.removeChip(index);// The dobule-timeout is currently necessary to ensure that the DOM has finalized and the select()
	// will find the proper chip since the selection is index-based.
	//
	// TODO: Investigate calling from within chip $scope.$on('$destroy') to reduce/remove timeouts
	self.$timeout(function(){self.$timeout(function(){self.selectAndFocusChipSafe(selIndex);});});};/**
	 * Sets the selected chip index to -1.
	 */MdChipsCtrl.prototype.resetSelectedChip=function(){this.selectedChip=-1;this.ariaTabIndex=null;};/**
	 * Gets the index of an adjacent chip to select after deletion. Adjacency is
	 * determined as the next chip in the list, unless the target chip is the
	 * last in the list, then it is the chip immediately preceding the target. If
	 * there is only one item in the list, -1 is returned (select none).
	 * The number returned is the index to select AFTER the target has been
	 * removed.
	 * If the current chip is not selected, then -1 is returned to select none.
	 */MdChipsCtrl.prototype.getAdjacentChipIndex=function(index){var len=this.items.length-1;return len==0?-1:index==len?index-1:index;};/**
	 * Append the contents of the buffer to the chip list. This method will first
	 * call out to the md-transform-chip method, if provided.
	 *
	 * @param newChip
	 */MdChipsCtrl.prototype.appendChip=function(newChip){this.shouldFocusLastChip=true;if(this.useTransformChip&&this.transformChip){var transformedChip=this.transformChip({'$chip':newChip});// Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
	// they want the string version.
	if(angular.isDefined(transformedChip)){newChip=transformedChip;}}// If items contains an identical object to newChip, do not append
	if(angular.isObject(newChip)){var identical=this.items.some(function(item){return angular.equals(newChip,item);});if(identical)return;}// Check for a null (but not undefined), or existing chip and cancel appending
	if(newChip==null||this.items.indexOf(newChip)+1)return;// Append the new chip onto our list
	var length=this.items.push(newChip);var index=length-1;// Update model validation
	this.ngModelCtrl.$setDirty();this.validateModel();// If they provide the md-on-add attribute, notify them of the chip addition
	if(this.useOnAdd&&this.onAdd){this.onAdd({'$chip':newChip,'$index':index});}};/**
	 * Sets whether to use the md-transform-chip expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code transformChip}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */MdChipsCtrl.prototype.useTransformChipExpression=function(){this.useTransformChip=true;};/**
	 * Sets whether to use the md-on-add expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onAdd}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */MdChipsCtrl.prototype.useOnAddExpression=function(){this.useOnAdd=true;};/**
	 * Sets whether to use the md-on-remove expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onRemove}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */MdChipsCtrl.prototype.useOnRemoveExpression=function(){this.useOnRemove=true;};/*
	 * Sets whether to use the md-on-select expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onSelect}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */MdChipsCtrl.prototype.useOnSelectExpression=function(){this.useOnSelect=true;};/**
	 * Gets the input buffer. The input buffer can be the model bound to the
	 * default input item {@code this.chipBuffer}, the {@code selectedItem}
	 * model of an {@code md-autocomplete}, or, through some magic, the model
	 * bound to any inpput or text area element found within a
	 * {@code md-input-container} element.
	 * @return {string}
	 */MdChipsCtrl.prototype.getChipBuffer=function(){var chipBuffer=!this.userInputElement?this.chipBuffer:this.userInputNgModelCtrl?this.userInputNgModelCtrl.$viewValue:this.userInputElement[0].value;// Ensure that the chip buffer is always a string. For example, the input element buffer might be falsy.
	return angular.isString(chipBuffer)?chipBuffer:'';};/**
	 * Resets the input buffer for either the internal input or user provided input element.
	 */MdChipsCtrl.prototype.resetChipBuffer=function(){if(this.userInputElement){if(this.userInputNgModelCtrl){this.userInputNgModelCtrl.$setViewValue('');this.userInputNgModelCtrl.$render();}else{this.userInputElement[0].value='';}}else{this.chipBuffer='';}};MdChipsCtrl.prototype.hasMaxChipsReached=function(){if(angular.isString(this.maxChips))this.maxChips=parseInt(this.maxChips,10)||0;return this.maxChips>0&&this.items.length>=this.maxChips;};/**
	 * Updates the validity properties for the ngModel.
	 */MdChipsCtrl.prototype.validateModel=function(){this.ngModelCtrl.$setValidity('md-max-chips',!this.hasMaxChipsReached());this.ngModelCtrl.$validate();// rerun any registered validators
	};/**
	 * Removes the chip at the given index.
	 * @param index
	 */MdChipsCtrl.prototype.removeChip=function(index){var removed=this.items.splice(index,1);// Update model validation
	this.ngModelCtrl.$setDirty();this.validateModel();if(removed&&removed.length&&this.useOnRemove&&this.onRemove){this.onRemove({'$chip':removed[0],'$index':index});}};MdChipsCtrl.prototype.removeChipAndFocusInput=function(index){this.removeChip(index);if(this.autocompleteCtrl){// Always hide the autocomplete dropdown before focusing the autocomplete input.
	// Wait for the input to move horizontally, because the chip was removed.
	// This can lead to an incorrect dropdown position.
	this.autocompleteCtrl.hidden=true;this.$mdUtil.nextTick(this.onFocus.bind(this));}else{this.onFocus();}};/**
	 * Selects the chip at `index`,
	 * @param index
	 */MdChipsCtrl.prototype.selectAndFocusChipSafe=function(index){// If we have no chips, or are asked to select a chip before the first, just focus the input
	if(!this.items.length||index===-1){return this.focusInput();}// If we are asked to select a chip greater than the number of chips...
	if(index>=this.items.length){if(this.readonly){// If we are readonly, jump back to the start (because we have no input)
	index=0;}else{// If we are not readonly, we should attempt to focus the input
	return this.onFocus();}}index=Math.max(index,0);index=Math.min(index,this.items.length-1);this.selectChip(index);this.focusChip(index);};MdChipsCtrl.prototype.focusLastChipThenInput=function(){var ctrl=this;ctrl.shouldFocusLastChip=false;ctrl.focusChip(this.items.length-1);ctrl.$timeout(function(){ctrl.focusInput();},ctrl.chipAppendDelay);};MdChipsCtrl.prototype.focusInput=function(){this.selectChip(-1);this.onFocus();};/**
	 * Marks the chip at the given index as selected.
	 * @param index
	 */MdChipsCtrl.prototype.selectChip=function(index){if(index>=-1&&index<=this.items.length){this.selectedChip=index;// Fire the onSelect if provided
	if(this.useOnSelect&&this.onSelect){this.onSelect({'$chip':this.items[index]});}}else{this.$log.warn('Selected Chip index out of bounds; ignoring.');}};/**
	 * Selects the chip at `index` and gives it focus.
	 * @param index
	 */MdChipsCtrl.prototype.selectAndFocusChip=function(index){this.selectChip(index);if(index!=-1){this.focusChip(index);}};/**
	 * Call `focus()` on the chip at `index`
	 */MdChipsCtrl.prototype.focusChip=function(index){var chipContent=this.$element[0].querySelector('md-chip[index="'+index+'"] .md-chip-content');this.ariaTabIndex=index;chipContent.focus();};/**
	 * Configures the required interactions with the ngModel Controller.
	 * Specifically, set {@code this.items} to the {@code NgModelCtrl#$viewVale}.
	 * @param ngModelCtrl
	 */MdChipsCtrl.prototype.configureNgModel=function(ngModelCtrl){this.ngModelCtrl=ngModelCtrl;var self=this;// in chips the meaning of $isEmpty changes
	ngModelCtrl.$isEmpty=function(value){return!value||value.length===0;};ngModelCtrl.$render=function(){// model is updated. do something.
	self.items=self.ngModelCtrl.$viewValue;};};MdChipsCtrl.prototype.onFocus=function(){var input=this.$element[0].querySelector('input');input&&input.focus();this.resetSelectedChip();};MdChipsCtrl.prototype.onInputFocus=function(){this.inputHasFocus=true;// Make sure we have the appropriate ARIA attributes
	this.setupInputAria();// Make sure we don't have any chips selected
	this.resetSelectedChip();};MdChipsCtrl.prototype.onInputBlur=function(){this.inputHasFocus=false;if(this.shouldAddOnBlur()){this.appendChip(this.getChipBuffer().trim());this.resetChipBuffer();}};/**
	 * Configure event bindings on input element.
	 * @param inputElement
	 */MdChipsCtrl.prototype.configureInput=function configureInput(inputElement){// Find the NgModelCtrl for the input element
	var ngModelCtrl=inputElement.controller('ngModel');var ctrl=this;if(ngModelCtrl){// sync touched-state from inner input to chips-element
	this.deRegister.push(this.$scope.$watch(function(){return ngModelCtrl.$touched;},function(isTouched){isTouched&&ctrl.ngModelCtrl.$setTouched();}));// sync dirty-state from inner input to chips-element
	this.deRegister.push(this.$scope.$watch(function(){return ngModelCtrl.$dirty;},function(isDirty){isDirty&&ctrl.ngModelCtrl.$setDirty();}));}};/**
	 * Configure event bindings on a user-provided input element.
	 * @param inputElement
	 */MdChipsCtrl.prototype.configureUserInput=function(inputElement){this.userInputElement=inputElement;// Find the NgModelCtrl for the input element
	var ngModelCtrl=inputElement.controller('ngModel');// `.controller` will look in the parent as well.
	if(ngModelCtrl!=this.ngModelCtrl){this.userInputNgModelCtrl=ngModelCtrl;}var scope=this.$scope;var ctrl=this;// Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
	var scopeApplyFn=function scopeApplyFn(event,fn){scope.$evalAsync(angular.bind(ctrl,fn,event));};// Bind to keydown and focus events of input
	inputElement.attr({tabindex:0}).on('keydown',function(event){scopeApplyFn(event,ctrl.inputKeydown);}).on('focus',function(event){scopeApplyFn(event,ctrl.onInputFocus);}).on('blur',function(event){scopeApplyFn(event,ctrl.onInputBlur);});};MdChipsCtrl.prototype.configureAutocomplete=function(ctrl){if(ctrl){this.autocompleteCtrl=ctrl;ctrl.registerSelectedItemWatcher(angular.bind(this,function(item){if(item){// Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	if(this.hasMaxChipsReached())return;this.appendChip(item);this.resetChipBuffer();}}));this.$element.find('input').on('focus',angular.bind(this,this.onInputFocus)).on('blur',angular.bind(this,this.onInputBlur));}};/**
	 * Whether the current chip buffer should be added on input blur or not.
	 * @returns {boolean}
	 */MdChipsCtrl.prototype.shouldAddOnBlur=function(){// Update the custom ngModel validators from the chips component.
	this.validateModel();var chipBuffer=this.getChipBuffer().trim();var isModelValid=this.ngModelCtrl.$valid;var isAutocompleteShowing=this.autocompleteCtrl&&!this.autocompleteCtrl.hidden;if(this.userInputNgModelCtrl){isModelValid=isModelValid&&this.userInputNgModelCtrl.$valid;}return this.addOnBlur&&!this.requireMatch&&chipBuffer&&isModelValid&&!isAutocompleteShowing;};MdChipsCtrl.prototype.hasFocus=function(){return this.inputHasFocus||this.selectedChip>=0;};MdChipsCtrl.prototype.contentIdFor=function(index){return this.contentIds[index];};})();(function(){"use strict";MdChips.$inject=["$mdTheming","$mdUtil","$compile","$log","$timeout","$$mdSvgRegistry"];angular.module('material.components.chips').directive('mdChips',MdChips);/**
	   * @ngdoc directive
	   * @name mdChips
	   * @module material.components.chips
	   *
	   * @description
	   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
	   * displayed as 'chips'. This component can make use of an `<input>` element or an
	   * `<md-autocomplete>` element.
	   *
	   * ### Custom templates
	   * A custom template may be provided to render the content of each chip. This is achieved by
	   * specifying an `<md-chip-template>` element containing the custom content as a child of
	   * `<md-chips>`.
	   *
	   * Note: Any attributes on
	   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
	   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
	   * the chip object and its index in the list of chips, respectively.
	   * To override the chip delete control, include an element (ideally a button) with the attribute
	   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
	   * is also placed as a sibling to the chip content (on which there are also click listeners) to
	   * avoid a nested ng-click situation.
	   *
	   * <!-- Note: We no longer want to include this in the site docs; but it should remain here for
	   * future developers and those looking at the documentation.
	   *
	   * <h3> Pending Features </h3>
	   * <ul style="padding-left:20px;">
	   *
	   *   <ul>Style
	   *     <li>Colours for hover, press states (ripple?).</li>
	   *   </ul>
	   *
	   *   <ul>Validation
	   *     <li>allow a validation callback</li>
	   *     <li>highlighting style for invalid chips</li>
	   *   </ul>
	   *
	   *   <ul>Item mutation
	   *     <li>Support `
	   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
	   *       click?
	   *     </li>
	   *   </ul>
	   *
	   *   <ul>Truncation and Disambiguation (?)
	   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
	   *     indistinguishable.</li>
	   *   </ul>
	   *
	   *   <ul>Drag and Drop
	   *     <li>Drag and drop chips between related `<md-chips>` elements.
	   *     </li>
	   *   </ul>
	   * </ul>
	   *
	   * //-->
	   *
	   * Sometimes developers want to limit the amount of possible chips.<br/>
	   * You can specify the maximum amount of chips by using the following markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *   </md-chips>
	   * </hljs>
	   *
	   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
	   * When the maximum amount of chips has been reached, you can also disable the autocomplete selection.<br/>
	   * Here is an example markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips ng-model="myItems" md-max-chips="5">
	   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
	   *   </md-chips>
	   * </hljs>
	   *
	   * ### Accessibility
	   *
	   * The `md-chips` component supports keyboard and screen reader users since Version 1.1.2. In
	   * order to achieve this, we modified the chips behavior to select newly appended chips for
	   * `300ms` before re-focusing the input and allowing the user to type.
	   *
	   * For most users, this delay is small enough that it will not be noticeable but allows certain
	   * screen readers to function properly (JAWS and NVDA in particular).
	   *
	   * We introduced a new `md-chip-append-delay` option to allow developers to better control this
	   * behavior.
	   *
	   * Please refer to the documentation of this option (below) for more information.
	   *
	   * @param {string=|object=} ng-model A model to which the list of items will be bound.
	   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	   *    displayed when there is at least one item in the list
	   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
	   *    removal icon or the Delete/Backspace key. Defaults to true.
	   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
	   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
	   *    marked as readonly.<br/><br/>
	   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and disabled.
	   * @param {string=} md-enable-chip-edit Set this to "true" to enable editing of chip contents. The user can
	   *    go into edit mode with pressing "space", "enter", or double clicking on the chip. Chip edit is only
	   *    supported for chips with basic template.
	   * @param {boolean=} ng-required Whether ng-model is allowed to be empty or not.
	   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
	   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
	   *    amount is reached.
	   * @param {boolean=} md-add-on-blur When set to true, remaining text inside of the input will
	   *    be converted into a new chip on blur.
	   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when called
	   *    expects one of the following return values:
	   *    - an object representing the `$chip` input string
	   *    - `undefined` to simply add the `$chip` input string, or
	   *    - `null` to prevent the chip from being appended
	   * @param {expression=} md-on-add An expression which will be called when a chip has been
	   *    added.
	   * @param {expression=} md-on-remove An expression which will be called when a chip has been
	   *    removed.
	   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
	   * @param {boolean} md-require-match If true, and the chips template contains an autocomplete,
	   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
	   * @param {string=} input-aria-label A string read by screen readers to identify the input.
	   * @param {string=} container-hint A string read by screen readers informing users of how to
	   *    navigate the chips. Used in readonly mode.
	   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	   *    the delete key will remove the chip.
	   * @param {string=} delete-button-label A label for the delete button. Also hidden and read by
	   *    screen readers.
	   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
	   * @param {string=} md-chip-append-delay The number of milliseconds that the component will select
	   *    a newly appended chip before allowing a user to type into the input. This is **necessary**
	   *    for keyboard accessibility for screen readers. It defaults to 300ms and any number less than
	   *    300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).
	   *
	   *    _Available since Version 1.1.2._
	   *
	   *    **Note:** You can safely set this to `0` in one of the following two instances:
	   *
	   *    1. You are targeting an iOS or Safari-only application (where users would use VoiceOver) or
	   *    only ChromeVox users.
	   *
	   *    2. If you have utilized the `md-separator-keys` to disable the `enter` keystroke in
	   *    favor of another one (such as `,` or `;`).
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       readonly="isReadOnly">
	   *   </md-chips>
	   * </hljs>
	   *
	   * <h3>Validation</h3>
	   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
	   * on our custom validators.
	   * <hljs lang="html">
	   *   <form name="userForm">
	   *     <md-chips
	   *       name="fruits"
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *     </md-chips>
	   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
	   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
	   *    </div>
	   *   </form>
	   * </hljs>
	   *
	   */var MD_CHIPS_TEMPLATE='\
	      <md-chips-wrap\
	          id="{{$mdChipsCtrl.wrapperId}}"\
	          tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"\
	          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
	          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
	                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
	                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
	          aria-setsize="{{$mdChipsCtrl.items.length}}"\
	          class="md-chips">\
	        <span ng-if="$mdChipsCtrl.readonly" class="md-visually-hidden">\
	          {{$mdChipsCtrl.containerHint}}\
	        </span>\
	        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
	            index="{{$index}}"\
	            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
	          <div class="md-chip-content"\
	              tabindex="{{$mdChipsCtrl.ariaTabIndex == $index ? 0 : -1}}"\
	              id="{{$mdChipsCtrl.contentIdFor($index)}}"\
	              role="option"\
	              aria-selected="{{$mdChipsCtrl.selectedChip == $index}}" \
	              aria-posinset="{{$index}}"\
	              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
	              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
	              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
	          <div ng-if="$mdChipsCtrl.isRemovable()"\
	               class="md-chip-remove-container"\
	               tabindex="-1"\
	               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
	        </md-chip>\
	        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
	          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
	        </div>\
	      </md-chips-wrap>';var CHIP_INPUT_TEMPLATE='\
	        <input\
	            class="md-input"\
	            tabindex="0"\
	            aria-label="{{$mdChipsCtrl.inputAriaLabel}}" \
	            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
	            ng-model="$mdChipsCtrl.chipBuffer"\
	            ng-focus="$mdChipsCtrl.onInputFocus()"\
	            ng-blur="$mdChipsCtrl.onInputBlur()"\
	            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';var CHIP_DEFAULT_TEMPLATE='\
	      <span>{{$chip}}</span>';var CHIP_REMOVE_TEMPLATE='\
	      <button\
	          class="md-chip-remove"\
	          ng-if="$mdChipsCtrl.isRemovable()"\
	          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)"\
	          type="button"\
	          tabindex="-1">\
	        <md-icon md-svg-src="{{ $mdChipsCtrl.mdCloseIcon }}"></md-icon>\
	        <span class="md-visually-hidden">\
	          {{$mdChipsCtrl.deleteButtonLabel}}\
	        </span>\
	      </button>';/**
	   * MDChips Directive Definition
	   */function MdChips($mdTheming,$mdUtil,$compile,$log,$timeout,$$mdSvgRegistry){// Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
	var templates=getTemplates();return{template:function template(element,attrs){// Clone the element into an attribute. By prepending the attribute
	// name with '$', AngularJS won't write it into the DOM. The cloned
	// element propagates to the link function via the attrs argument,
	// where various contained-elements can be consumed.
	attrs['$mdUserTemplate']=element.clone();return templates.chips;},require:['mdChips'],restrict:'E',controller:'MdChipsCtrl',controllerAs:'$mdChipsCtrl',bindToController:true,compile:compile,scope:{readonly:'=readonly',removable:'=mdRemovable',placeholder:'@',secondaryPlaceholder:'@',maxChips:'@mdMaxChips',transformChip:'&mdTransformChip',onAppend:'&mdOnAppend',onAdd:'&mdOnAdd',onRemove:'&mdOnRemove',onSelect:'&mdOnSelect',inputAriaLabel:'@',containerHint:'@',deleteHint:'@',deleteButtonLabel:'@',separatorKeys:'=?mdSeparatorKeys',requireMatch:'=?mdRequireMatch',chipAppendDelayString:'@?mdChipAppendDelay'}};/**
	     * Builds the final template for `md-chips` and returns the postLink function.
	     *
	     * Building the template involves 3 key components:
	     * static chips
	     * chip template
	     * input control
	     *
	     * If no `ng-model` is provided, only the static chip work needs to be done.
	     *
	     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
	     * template is appended to the chip content element.
	     *
	     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
	     *
	     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
	     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
	     * If no user input is provided, a default one is appended to the input container node in the
	     * template.
	     *
	     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
	     * transclusion in the `postLink` function.
	     *
	     *
	     * @param element
	     * @param attr
	     * @returns {Function}
	     */function compile(element,attr){// Grab the user template from attr and reset the attribute to null.
	var userTemplate=attr['$mdUserTemplate'];attr['$mdUserTemplate']=null;var chipTemplate=getTemplateByQuery('md-chips>md-chip-template');var chipRemoveSelector=$mdUtil.prefixer().buildList('md-chip-remove').map(function(attr){return'md-chips>*['+attr+']';}).join(',');// Set the chip remove, chip contents and chip input templates. The link function will put
	// them on the scope for transclusion later.
	var chipRemoveTemplate=getTemplateByQuery(chipRemoveSelector)||templates.remove,chipContentsTemplate=chipTemplate||templates.default,chipInputTemplate=getTemplateByQuery('md-chips>md-autocomplete')||getTemplateByQuery('md-chips>input')||templates.input,staticChips=userTemplate.find('md-chip');// Warn of malformed template. See #2545
	if(userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')){$log.warn('invalid placement of md-chip-remove within md-chip-template.');}function getTemplateByQuery(query){if(!attr.ngModel)return;var element=userTemplate[0].querySelector(query);return element&&element.outerHTML;}/**
	       * Configures controller and transcludes.
	       */return function postLink(scope,element,attrs,controllers){$mdUtil.initOptionalProperties(scope,attr);$mdTheming(element);var mdChipsCtrl=controllers[0];if(chipTemplate){// Chip editing functionality assumes we are using the default chip template.
	mdChipsCtrl.enableChipEdit=false;}mdChipsCtrl.chipContentsTemplate=chipContentsTemplate;mdChipsCtrl.chipRemoveTemplate=chipRemoveTemplate;mdChipsCtrl.chipInputTemplate=chipInputTemplate;mdChipsCtrl.mdCloseIcon=$$mdSvgRegistry.mdClose;element.attr({tabindex:-1}).on('focus',function(){mdChipsCtrl.onFocus();});if(attr.ngModel){mdChipsCtrl.configureNgModel(element.controller('ngModel'));// If an `md-transform-chip` attribute was set, tell the controller to use the expression
	// before appending chips.
	if(attrs.mdTransformChip)mdChipsCtrl.useTransformChipExpression();// If an `md-on-append` attribute was set, tell the controller to use the expression
	// when appending chips.
	//
	// DEPRECATED: Will remove in official 1.0 release
	if(attrs.mdOnAppend)mdChipsCtrl.useOnAppendExpression();// If an `md-on-add` attribute was set, tell the controller to use the expression
	// when adding chips.
	if(attrs.mdOnAdd)mdChipsCtrl.useOnAddExpression();// If an `md-on-remove` attribute was set, tell the controller to use the expression
	// when removing chips.
	if(attrs.mdOnRemove)mdChipsCtrl.useOnRemoveExpression();// If an `md-on-select` attribute was set, tell the controller to use the expression
	// when selecting chips.
	if(attrs.mdOnSelect)mdChipsCtrl.useOnSelectExpression();// The md-autocomplete and input elements won't be compiled until after this directive
	// is complete (due to their nested nature). Wait a tick before looking for them to
	// configure the controller.
	if(chipInputTemplate!=templates.input){// The autocomplete will not appear until the readonly attribute is not true (i.e.
	// false or undefined), so we have to watch the readonly and then on the next tick
	// after the chip transclusion has run, we can configure the autocomplete and user
	// input.
	scope.$watch('$mdChipsCtrl.readonly',function(readonly){if(!readonly){$mdUtil.nextTick(function(){if(chipInputTemplate.indexOf('<md-autocomplete')===0){var autocompleteEl=element.find('md-autocomplete');mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));}mdChipsCtrl.configureUserInput(element.find('input'));});}});}// At the next tick, if we find an input, make sure it has the md-input class
	$mdUtil.nextTick(function(){var input=element.find('input');if(input){mdChipsCtrl.configureInput(input);input.toggleClass('md-input',true);}});}// Compile with the parent's scope and prepend any static chips to the wrapper.
	if(staticChips.length>0){var compiledStaticChips=$compile(staticChips.clone())(scope.$parent);$timeout(function(){element.find('md-chips-wrap').prepend(compiledStaticChips);});}};}function getTemplates(){return{chips:$mdUtil.processTemplate(MD_CHIPS_TEMPLATE),input:$mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),default:$mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),remove:$mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)};}}})();(function(){"use strict";angular.module('material.components.chips').controller('MdContactChipsCtrl',MdContactChipsCtrl);/**
	 * Controller for the MdContactChips component
	 * @constructor
	 */function MdContactChipsCtrl(){/** @type {Object} */this.selectedItem=null;/** @type {string} */this.searchText='';}MdContactChipsCtrl.prototype.queryContact=function(searchText){return this.contactQuery({'$query':searchText});};MdContactChipsCtrl.prototype.itemName=function(item){return item[this.contactName];};})();(function(){"use strict";MdContactChips.$inject=["$mdTheming","$mdUtil"];angular.module('material.components.chips').directive('mdContactChips',MdContactChips);/**
	 * @ngdoc directive
	 * @name mdContactChips
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
	 * `md-autocomplete` element. The component allows the caller to supply a query expression which
	 * returns  a list of possible contacts. The user can select one of these and add it to the list of
	 * chips.
	 *
	 * You may also use the `md-highlight-text` directive along with its parameters to control the
	 * appearance of the matched text inside of the contacts' autocomplete popup.
	 *
	 * @param {string=|object=} ng-model A model to bind the list of items to
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	 *    displayed when there is at least on item in the list
	 * @param {expression} md-contacts An expression expected to return contacts matching the search
	 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
	 *    waiting for it to resolve.
	 * @param {string} md-contact-name The field name of the contact object representing the
	 *    contact's name.
	 * @param {string} md-contact-email The field name of the contact object representing the
	 *    contact's email address.
	 * @param {string} md-contact-image The field name of the contact object representing the
	 *    contact's image.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *    make suggestions
	 *
	 * @param {expression=} filter-selected Whether to filter selected contacts from the list of
	 *    suggestions shown in the autocomplete.
	 *
	 *    ***Note:** This attribute has been removed but may come back.*
	 *
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-contact-chips
	 *       ng-model="ctrl.contacts"
	 *       md-contacts="ctrl.querySearch($query)"
	 *       md-contact-name="name"
	 *       md-contact-image="image"
	 *       md-contact-email="email"
	 *       placeholder="To">
	 *   </md-contact-chips>
	 * </hljs>
	 *
	 */var MD_CONTACT_CHIPS_TEMPLATE='\
	      <md-chips class="md-contact-chips"\
	          ng-model="$mdContactChipsCtrl.contacts"\
	          md-require-match="$mdContactChipsCtrl.requireMatch"\
	          md-chip-append-delay="{{$mdContactChipsCtrl.chipAppendDelay}}" \
	          md-autocomplete-snap>\
	          <md-autocomplete\
	              md-menu-class="md-contact-chips-suggestions"\
	              md-selected-item="$mdContactChipsCtrl.selectedItem"\
	              md-search-text="$mdContactChipsCtrl.searchText"\
	              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
	              md-item-text="$mdContactChipsCtrl.itemName(item)"\
	              md-no-cache="true"\
	              md-min-length="$mdContactChipsCtrl.minLength"\
	              md-autoselect\
	              placeholder="{{$mdContactChipsCtrl.contacts.length == 0 ?\
	                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
	            <div class="md-contact-suggestion">\
	              <img \
	                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
	              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
	                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
	                {{item[$mdContactChipsCtrl.contactName]}}\
	              </span>\
	              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
	            </div>\
	          </md-autocomplete>\
	          <md-chip-template>\
	            <div class="md-contact-avatar">\
	              <img \
	                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
	            </div>\
	            <div class="md-contact-name">\
	              {{$chip[$mdContactChipsCtrl.contactName]}}\
	            </div>\
	          </md-chip-template>\
	      </md-chips>';/**
	 * MDContactChips Directive Definition
	 *
	 * @param $mdTheming
	 * @returns {*}
	 * @ngInject
	 */function MdContactChips($mdTheming,$mdUtil){return{template:function template(element,attrs){return MD_CONTACT_CHIPS_TEMPLATE;},restrict:'E',controller:'MdContactChipsCtrl',controllerAs:'$mdContactChipsCtrl',bindToController:true,compile:compile,scope:{contactQuery:'&mdContacts',placeholder:'@',secondaryPlaceholder:'@',contactName:'@mdContactName',contactImage:'@mdContactImage',contactEmail:'@mdContactEmail',contacts:'=ngModel',requireMatch:'=?mdRequireMatch',minLength:'=?mdMinLength',highlightFlags:'@?mdHighlightFlags',chipAppendDelay:'@?mdChipAppendDelay'}};function compile(element,attr){return function postLink(scope,element,attrs,controllers){var contactChipsController=controllers;$mdUtil.initOptionalProperties(scope,attr);$mdTheming(element);element.attr('tabindex','-1');attrs.$observe('mdChipAppendDelay',function(newValue){contactChipsController.chipAppendDelay=newValue;});};}}})();(function(){"use strict";(function(){'use strict';/**
	   * @ngdoc directive
	   * @name mdCalendar
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Should be a Date object.
	   * @param {Date=} md-min-date Expression representing the minimum date.
	   * @param {Date=} md-max-date Expression representing the maximum date.
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   * @param {String=} md-current-view Current view of the calendar. Can be either "month" or "year".
	   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view. This option can
	   * be used if the user is only supposed to choose from a certain date type (e.g. only selecting the month).
	   * Can be either "month" or "day". **Note** that this will ovewrite the `md-current-view` value.
	   *
	   * @description
	   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
	   * It is a part of the `<md-datepicker>` pane, however it can also be used on it's own.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   *   <md-calendar ng-model="birthday"></md-calendar>
	   * </hljs>
	   */CalendarCtrl.$inject=["$element","$scope","$$mdDateUtil","$mdUtil","$mdConstant","$mdTheming","$$rAF","$attrs","$mdDateLocale"];angular.module('material.components.datepicker').directive('mdCalendar',calendarDirective);// POST RELEASE
	// TODO(jelbourn): Mac Cmd + left / right == Home / End
	// TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
	// TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
	// TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
	// TODO(jelbourn): Scroll snapping (virtual repeat)
	// TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
	// TODO(jelbourn): Month headers stick to top when scrolling.
	// TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
	// TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
	//     announcement and key handling).
	// Read-only calendar (not just date-picker).
	function calendarDirective(){return{template:function template(tElement,tAttr){// TODO(crisbeto): This is a workaround that allows the calendar to work, without
	// a datepicker, until issue #8585 gets resolved. It can safely be removed
	// afterwards. This ensures that the virtual repeater scrolls to the proper place on load by
	// deferring the execution until the next digest. It's necessary only if the calendar is used
	// without a datepicker, otherwise it's already wrapped in an ngIf.
	var extraAttrs=tAttr.hasOwnProperty('ngIf')?'':'ng-if="calendarCtrl.isInitialized"';var template=''+'<div ng-switch="calendarCtrl.currentView" '+extraAttrs+'>'+'<md-calendar-year ng-switch-when="year"></md-calendar-year>'+'<md-calendar-month ng-switch-default></md-calendar-month>'+'</div>';return template;},scope:{minDate:'=mdMinDate',maxDate:'=mdMaxDate',dateFilter:'=mdDateFilter',// These need to be prefixed, because Angular resets
	// any changes to the value due to bindToController.
	_mode:'@mdMode',_currentView:'@mdCurrentView'},require:['ngModel','mdCalendar'],controller:CalendarCtrl,controllerAs:'calendarCtrl',bindToController:true,link:function link(scope,element,attrs,controllers){var ngModelCtrl=controllers[0];var mdCalendarCtrl=controllers[1];mdCalendarCtrl.configureNgModel(ngModelCtrl);}};}/**
	   * Occasionally the hideVerticalScrollbar method might read an element's
	   * width as 0, because it hasn't been laid out yet. This value will be used
	   * as a fallback, in order to prevent scenarios where the element's width
	   * would otherwise have been set to 0. This value is the "usual" width of a
	   * calendar within a floating calendar pane.
	   */var FALLBACK_WIDTH=340;/** Next identifier for calendar instance. */var nextUniqueId=0;/** Maps the `md-mode` values to their corresponding calendar views. */var MODE_MAP={day:'month',month:'year'};/**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */function CalendarCtrl($element,$scope,$$mdDateUtil,$mdUtil,$mdConstant,$mdTheming,$$rAF,$attrs,$mdDateLocale){$mdTheming($element);/** @final {!angular.JQLite} */this.$element=$element;/** @final {!angular.Scope} */this.$scope=$scope;/** @final */this.dateUtil=$$mdDateUtil;/** @final */this.$mdUtil=$mdUtil;/** @final */this.keyCode=$mdConstant.KEY_CODE;/** @final */this.$$rAF=$$rAF;/** @final */this.$mdDateLocale=$mdDateLocale;/** @final {Date} */this.today=this.dateUtil.createDateAtMidnight();/** @type {!angular.NgModelController} */this.ngModelCtrl=null;/** @type {String} Class applied to the selected date cell. */this.SELECTED_DATE_CLASS='md-calendar-selected-date';/** @type {String} Class applied to the cell for today. */this.TODAY_CLASS='md-calendar-date-today';/** @type {String} Class applied to the focused cell. */this.FOCUSED_DATE_CLASS='md-focus';/** @final {number} Unique ID for this calendar instance. */this.id=nextUniqueId++;/**
	     * The date that is currently focused or showing in the calendar. This will initially be set
	     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
	     * to other months. The cell corresponding to the displayDate does not necesarily always have
	     * focus in the document (such as for cases when the user is scrolling the calendar).
	     * @type {Date}
	     */this.displayDate=null;/**
	     * The selected date. Keep track of this separately from the ng-model value so that we
	     * can know, when the ng-model value changes, what the previous value was before it's updated
	     * in the component's UI.
	     *
	     * @type {Date}
	     */this.selectedDate=null;/**
	     * The first date that can be rendered by the calendar. The default is taken
	     * from the mdDateLocale provider and is limited by the mdMinDate.
	     * @type {Date}
	     */this.firstRenderableDate=null;/**
	     * The last date that can be rendered by the calendar. The default comes
	     * from the mdDateLocale provider and is limited by the maxDate.
	     * @type {Date}
	     */this.lastRenderableDate=null;/**
	     * Used to toggle initialize the root element in the next digest.
	     * @type {Boolean}
	     */this.isInitialized=false;/**
	     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
	     * and to avoid extra reflows when switching between views.
	     * @type {Number}
	     */this.width=0;/**
	     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
	     * @type {Number}
	     */this.scrollbarWidth=0;// Unless the user specifies so, the calendar should not be a tab stop.
	// This is necessary because ngAria might add a tabindex to anything with an ng-model
	// (based on whether or not the user has turned that particular feature on/off).
	if(!$attrs.tabindex){$element.attr('tabindex','-1');}var boundKeyHandler=angular.bind(this,this.handleKeyEvent);// If use the md-calendar directly in the body without datepicker,
	// handleKeyEvent will disable other inputs on the page.
	// So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
	// otherwise apply on the calendar element only.
	var handleKeyElement;if($element.parent().hasClass('md-datepicker-calendar')){handleKeyElement=angular.element(document.body);}else{handleKeyElement=$element;}// Bind the keydown handler to the body, in order to handle cases where the focused
	// element gets removed from the DOM and stops propagating click events.
	handleKeyElement.on('keydown',boundKeyHandler);$scope.$on('$destroy',function(){handleKeyElement.off('keydown',boundKeyHandler);});// For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	// manually call the $onInit hook.
	if(angular.version.major===1&&angular.version.minor<=4){this.$onInit();}}/**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */CalendarCtrl.prototype.$onInit=function(){/**
	     * The currently visible calendar view. Note the prefix on the scope value,
	     * which is necessary, because the datepicker seems to reset the real one value if the
	     * calendar is open, but the `currentView` on the datepicker's scope is empty.
	     * @type {String}
	     */if(this._mode&&MODE_MAP.hasOwnProperty(this._mode)){this.currentView=MODE_MAP[this._mode];this.mode=this._mode;}else{this.currentView=this._currentView||'month';this.mode=null;}var dateLocale=this.$mdDateLocale;if(this.minDate&&this.minDate>dateLocale.firstRenderableDate){this.firstRenderableDate=this.minDate;}else{this.firstRenderableDate=dateLocale.firstRenderableDate;}if(this.maxDate&&this.maxDate<dateLocale.lastRenderableDate){this.lastRenderableDate=this.maxDate;}else{this.lastRenderableDate=dateLocale.lastRenderableDate;}};/**
	   * Sets up the controller's reference to ngModelController.
	   * @param {!angular.NgModelController} ngModelCtrl
	   */CalendarCtrl.prototype.configureNgModel=function(ngModelCtrl){var self=this;self.ngModelCtrl=ngModelCtrl;self.$mdUtil.nextTick(function(){self.isInitialized=true;});ngModelCtrl.$render=function(){var value=this.$viewValue;// Notify the child scopes of any changes.
	self.$scope.$broadcast('md-calendar-parent-changed',value);// Set up the selectedDate if it hasn't been already.
	if(!self.selectedDate){self.selectedDate=value;}// Also set up the displayDate.
	if(!self.displayDate){self.displayDate=self.selectedDate||self.today;}};};/**
	   * Sets the ng-model value for the calendar and emits a change event.
	   * @param {Date} date
	   */CalendarCtrl.prototype.setNgModelValue=function(date){var value=this.dateUtil.createDateAtMidnight(date);this.focus(value);this.$scope.$emit('md-calendar-change',value);this.ngModelCtrl.$setViewValue(value);this.ngModelCtrl.$render();return value;};/**
	   * Sets the current view that should be visible in the calendar
	   * @param {string} newView View name to be set.
	   * @param {number|Date} time Date object or a timestamp for the new display date.
	   */CalendarCtrl.prototype.setCurrentView=function(newView,time){var self=this;self.$mdUtil.nextTick(function(){self.currentView=newView;if(time){self.displayDate=angular.isDate(time)?time:new Date(time);}});};/**
	   * Focus the cell corresponding to the given date.
	   * @param {Date} date The date to be focused.
	   */CalendarCtrl.prototype.focus=function(date){if(this.dateUtil.isValidDate(date)){var previousFocus=this.$element[0].querySelector('.'+this.FOCUSED_DATE_CLASS);if(previousFocus){previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);}var cellId=this.getDateId(date,this.currentView);var cell=document.getElementById(cellId);if(cell){cell.classList.add(this.FOCUSED_DATE_CLASS);cell.focus();this.displayDate=date;}}else{var rootElement=this.$element[0].querySelector('[ng-switch]');if(rootElement){rootElement.focus();}}};/**
	   * Highlights a date cell on the calendar and changes the selected date.
	   * @param {Date=} date Date to be marked as selected.
	   */CalendarCtrl.prototype.changeSelectedDate=function(date){var selectedDateClass=this.SELECTED_DATE_CLASS;var prevDateCell=this.$element[0].querySelector('.'+selectedDateClass);// Remove the selected class from the previously selected date, if any.
	if(prevDateCell){prevDateCell.classList.remove(selectedDateClass);prevDateCell.setAttribute('aria-selected','false');}// Apply the select class to the new selected date if it is set.
	if(date){var dateCell=document.getElementById(this.getDateId(date,this.currentView));if(dateCell){dateCell.classList.add(selectedDateClass);dateCell.setAttribute('aria-selected','true');}}this.selectedDate=date;};/**
	   * Normalizes the key event into an action name. The action will be broadcast
	   * to the child controllers.
	   * @param {KeyboardEvent} event
	   * @returns {String} The action that should be taken, or null if the key
	   * does not match a calendar shortcut.
	   */CalendarCtrl.prototype.getActionFromKeyEvent=function(event){var keyCode=this.keyCode;switch(event.which){case keyCode.ENTER:return'select';case keyCode.RIGHT_ARROW:return'move-right';case keyCode.LEFT_ARROW:return'move-left';case keyCode.DOWN_ARROW:return event.metaKey?'move-page-down':'move-row-down';case keyCode.UP_ARROW:return event.metaKey?'move-page-up':'move-row-up';case keyCode.PAGE_DOWN:return'move-page-down';case keyCode.PAGE_UP:return'move-page-up';case keyCode.HOME:return'start';case keyCode.END:return'end';default:return null;}};/**
	   * Handles a key event in the calendar with the appropriate action. The action will either
	   * be to select the focused date or to navigate to focus a new date.
	   * @param {KeyboardEvent} event
	   */CalendarCtrl.prototype.handleKeyEvent=function(event){var self=this;this.$scope.$apply(function(){// Capture escape and emit back up so that a wrapping component
	// (such as a date-picker) can decide to close.
	if(event.which==self.keyCode.ESCAPE||event.which==self.keyCode.TAB){self.$scope.$emit('md-calendar-close');if(event.which==self.keyCode.TAB){event.preventDefault();}return;}// Broadcast the action that any child controllers should take.
	var action=self.getActionFromKeyEvent(event);if(action){event.preventDefault();event.stopPropagation();self.$scope.$broadcast('md-calendar-parent-action',action);}});};/**
	   * Hides the vertical scrollbar on the calendar scroller of a child controller by
	   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
	   * around the scroller, and then setting a padding-right on the scroller equal
	   * to the width of the browser's scrollbar.
	   *
	   * This will cause a reflow.
	   *
	   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
	   */CalendarCtrl.prototype.hideVerticalScrollbar=function(childCtrl){var self=this;var element=childCtrl.$element[0];var scrollMask=element.querySelector('.md-calendar-scroll-mask');if(self.width>0){setWidth();}else{self.$$rAF(function(){var scroller=childCtrl.calendarScroller;self.scrollbarWidth=scroller.offsetWidth-scroller.clientWidth;self.width=element.querySelector('table').offsetWidth;setWidth();});}function setWidth(){var width=self.width||FALLBACK_WIDTH;var scrollbarWidth=self.scrollbarWidth;var scroller=childCtrl.calendarScroller;scrollMask.style.width=width+'px';scroller.style.width=width+scrollbarWidth+'px';scroller.style.paddingRight=scrollbarWidth+'px';}};/**
	   * Gets an identifier for a date unique to the calendar instance for internal
	   * purposes. Not to be displayed.
	   * @param {Date} date The date for which the id is being generated
	   * @param {string} namespace Namespace for the id. (month, year etc.)
	   * @returns {string}
	   */CalendarCtrl.prototype.getDateId=function(date,namespace){if(!namespace){throw new Error('A namespace for the date id has to be specified.');}return['md',this.id,namespace,date.getFullYear(),date.getMonth(),date.getDate()].join('-');};/**
	   * Util to trigger an extra digest on a parent scope, in order to to ensure that
	   * any child virtual repeaters have updated. This is necessary, because the virtual
	   * repeater doesn't update the $index the first time around since the content isn't
	   * in place yet. The case, in which this is an issue, is when the repeater has less
	   * than a page of content (e.g. a month or year view has a min or max date).
	   */CalendarCtrl.prototype.updateVirtualRepeat=function(){var scope=this.$scope;var virtualRepeatResizeListener=scope.$on('$md-resize-enable',function(){if(!scope.$$phase){scope.$apply();}virtualRepeatResizeListener();});};})();})();(function(){"use strict";(function(){'use strict';CalendarMonthCtrl.$inject=["$element","$scope","$animate","$q","$$mdDateUtil","$mdDateLocale"];angular.module('material.components.datepicker').directive('mdCalendarMonth',calendarDirective);/**
	   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific months.
	   */var TBODY_HEIGHT=265;/**
	   * Height of a calendar month with a single row. This is needed to calculate the offset for
	   * rendering an extra month in virtual-repeat that only contains one row.
	   */var TBODY_SINGLE_ROW_HEIGHT=45;/** Private directive that represents a list of months inside the calendar. */function calendarDirective(){return{template:'<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>'+'<div class="md-calendar-scroll-mask">'+'<md-virtual-repeat-container class="md-calendar-scroll-container" '+'md-offset-size="'+(TBODY_SINGLE_ROW_HEIGHT-TBODY_HEIGHT)+'">'+'<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">'+'<tbody '+'md-calendar-month-body '+'role="rowgroup" '+'md-virtual-repeat="i in monthCtrl.items" '+'md-month-offset="$index" '+'class="md-calendar-month" '+'md-start-index="monthCtrl.getSelectedMonthIndex()" '+'md-item-size="'+TBODY_HEIGHT+'">'+// The <tr> ensures that the <tbody> will always have the
	// proper height, even if it's empty. If it's content is
	// compiled, the <tr> will be overwritten.
	'<tr aria-hidden="true" md-force-height="\''+TBODY_HEIGHT+'px\'"></tr>'+'</tbody>'+'</table>'+'</md-virtual-repeat-container>'+'</div>',require:['^^mdCalendar','mdCalendarMonth'],controller:CalendarMonthCtrl,controllerAs:'monthCtrl',bindToController:true,link:function link(scope,element,attrs,controllers){var calendarCtrl=controllers[0];var monthCtrl=controllers[1];monthCtrl.initialize(calendarCtrl);}};}/**
	   * Controller for the calendar month component.
	   * @ngInject @constructor
	   */function CalendarMonthCtrl($element,$scope,$animate,$q,$$mdDateUtil,$mdDateLocale){/** @final {!angular.JQLite} */this.$element=$element;/** @final {!angular.Scope} */this.$scope=$scope;/** @final {!angular.$animate} */this.$animate=$animate;/** @final {!angular.$q} */this.$q=$q;/** @final */this.dateUtil=$$mdDateUtil;/** @final */this.dateLocale=$mdDateLocale;/** @final {HTMLElement} */this.calendarScroller=$element[0].querySelector('.md-virtual-repeat-scroller');/** @type {boolean} */this.isInitialized=false;/** @type {boolean} */this.isMonthTransitionInProgress=false;var self=this;/**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */this.cellClickHandler=function(){var timestamp=$$mdDateUtil.getTimestampFromNode(this);self.$scope.$apply(function(){self.calendarCtrl.setNgModelValue(timestamp);});};/**
	     * Handles click events on the month headers. Switches
	     * the calendar to the year view.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */this.headerClickHandler=function(){self.calendarCtrl.setCurrentView('year',$$mdDateUtil.getTimestampFromNode(this));};}/*** Initialization ***//**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */CalendarMonthCtrl.prototype.initialize=function(calendarCtrl){/**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of months that can be viewed. We add 2 months: one to include the current month
	     * and one for the last dummy month.
	     *
	     * This is shorter than ideal because of a (potential) Firefox bug
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
	     */this.items={length:this.dateUtil.getMonthDistance(calendarCtrl.firstRenderableDate,calendarCtrl.lastRenderableDate)+2};this.calendarCtrl=calendarCtrl;this.attachScopeListeners();calendarCtrl.updateVirtualRepeat();// Fire the initial render, since we might have missed it the first time it fired.
	calendarCtrl.ngModelCtrl&&calendarCtrl.ngModelCtrl.$render();};/**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */CalendarMonthCtrl.prototype.getSelectedMonthIndex=function(){var calendarCtrl=this.calendarCtrl;return this.dateUtil.getMonthDistance(calendarCtrl.firstRenderableDate,calendarCtrl.displayDate||calendarCtrl.selectedDate||calendarCtrl.today);};/**
	   * Change the date that is being shown in the calendar. If the given date is in a different
	   * month, the displayed month will be transitioned.
	   * @param {Date} date
	   */CalendarMonthCtrl.prototype.changeDisplayDate=function(date){// Initialization is deferred until this function is called because we want to reflect
	// the starting value of ngModel.
	if(!this.isInitialized){this.buildWeekHeader();this.calendarCtrl.hideVerticalScrollbar(this);this.isInitialized=true;return this.$q.when();}// If trying to show an invalid date or a transition is in progress, do nothing.
	if(!this.dateUtil.isValidDate(date)||this.isMonthTransitionInProgress){return this.$q.when();}this.isMonthTransitionInProgress=true;var animationPromise=this.animateDateChange(date);this.calendarCtrl.displayDate=date;var self=this;animationPromise.then(function(){self.isMonthTransitionInProgress=false;});return animationPromise;};/**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */CalendarMonthCtrl.prototype.animateDateChange=function(date){if(this.dateUtil.isValidDate(date)){var monthDistance=this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate,date);this.calendarScroller.scrollTop=monthDistance*TBODY_HEIGHT;}return this.$q.when();};/**
	   * Builds and appends a day-of-the-week header to the calendar.
	   * This should only need to be called once during initialization.
	   */CalendarMonthCtrl.prototype.buildWeekHeader=function(){var firstDayOfWeek=this.dateLocale.firstDayOfWeek;var shortDays=this.dateLocale.shortDays;var row=document.createElement('tr');for(var i=0;i<7;i++){var th=document.createElement('th');th.textContent=shortDays[(i+firstDayOfWeek)%7];row.appendChild(th);}this.$element.find('thead').append(row);};/**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */CalendarMonthCtrl.prototype.attachScopeListeners=function(){var self=this;self.$scope.$on('md-calendar-parent-changed',function(event,value){self.calendarCtrl.changeSelectedDate(value);self.changeDisplayDate(value);});self.$scope.$on('md-calendar-parent-action',angular.bind(this,this.handleKeyEvent));};/**
	   * Handles the month-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */CalendarMonthCtrl.prototype.handleKeyEvent=function(event,action){var calendarCtrl=this.calendarCtrl;var displayDate=calendarCtrl.displayDate;if(action==='select'){calendarCtrl.setNgModelValue(displayDate);}else{var date=null;var dateUtil=this.dateUtil;switch(action){case'move-right':date=dateUtil.incrementDays(displayDate,1);break;case'move-left':date=dateUtil.incrementDays(displayDate,-1);break;case'move-page-down':date=dateUtil.incrementMonths(displayDate,1);break;case'move-page-up':date=dateUtil.incrementMonths(displayDate,-1);break;case'move-row-down':date=dateUtil.incrementDays(displayDate,7);break;case'move-row-up':date=dateUtil.incrementDays(displayDate,-7);break;case'start':date=dateUtil.getFirstDateOfMonth(displayDate);break;case'end':date=dateUtil.getLastDateOfMonth(displayDate);break;}if(date){date=this.dateUtil.clampDate(date,calendarCtrl.minDate,calendarCtrl.maxDate);this.changeDisplayDate(date).then(function(){calendarCtrl.focus(date);});}}};})();})();(function(){"use strict";(function(){'use strict';mdCalendarMonthBodyDirective.$inject=["$compile","$$mdSvgRegistry"];CalendarMonthBodyCtrl.$inject=["$element","$$mdDateUtil","$mdDateLocale"];angular.module('material.components.datepicker').directive('mdCalendarMonthBody',mdCalendarMonthBodyDirective);/**
	   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
	   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
	   * the rest of the calendar controller logic.
	   * @ngInject
	   */function mdCalendarMonthBodyDirective($compile,$$mdSvgRegistry){var ARROW_ICON=$compile('<md-icon md-svg-src="'+$$mdSvgRegistry.mdTabsArrow+'"></md-icon>')({})[0];return{require:['^^mdCalendar','^^mdCalendarMonth','mdCalendarMonthBody'],scope:{offset:'=mdMonthOffset'},controller:CalendarMonthBodyCtrl,controllerAs:'mdMonthBodyCtrl',bindToController:true,link:function link(scope,element,attrs,controllers){var calendarCtrl=controllers[0];var monthCtrl=controllers[1];var monthBodyCtrl=controllers[2];monthBodyCtrl.calendarCtrl=calendarCtrl;monthBodyCtrl.monthCtrl=monthCtrl;monthBodyCtrl.arrowIcon=ARROW_ICON.cloneNode(true);// The virtual-repeat re-uses the same DOM elements, so there are only a limited number
	// of repeated items that are linked, and then those elements have their bindings updated.
	// Since the months are not generated by bindings, we simply regenerate the entire thing
	// when the binding (offset) changes.
	scope.$watch(function(){return monthBodyCtrl.offset;},function(offset){if(angular.isNumber(offset)){monthBodyCtrl.generateContent();}});}};}/**
	   * Controller for a single calendar month.
	   * @ngInject @constructor
	   */function CalendarMonthBodyCtrl($element,$$mdDateUtil,$mdDateLocale){/** @final {!angular.JQLite} */this.$element=$element;/** @final */this.dateUtil=$$mdDateUtil;/** @final */this.dateLocale=$mdDateLocale;/** @type {Object} Reference to the month view. */this.monthCtrl=null;/** @type {Object} Reference to the calendar. */this.calendarCtrl=null;/**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */this.offset=null;/**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */this.focusAfterAppend=null;}/** Generate and append the content for this month to the directive element. */CalendarMonthBodyCtrl.prototype.generateContent=function(){var date=this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate,this.offset);this.$element.empty().append(this.buildCalendarForMonth(date));if(this.focusAfterAppend){this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);this.focusAfterAppend.focus();this.focusAfterAppend=null;}};/**
	   * Creates a single cell to contain a date in the calendar with all appropriate
	   * attributes and classes added. If a date is given, the cell content will be set
	   * based on the date.
	   * @param {Date=} opt_date
	   * @returns {HTMLElement}
	   */CalendarMonthBodyCtrl.prototype.buildDateCell=function(opt_date){var monthCtrl=this.monthCtrl;var calendarCtrl=this.calendarCtrl;// TODO(jelbourn): cloneNode is likely a faster way of doing this.
	var cell=document.createElement('td');cell.tabIndex=-1;cell.classList.add('md-calendar-date');cell.setAttribute('role','gridcell');if(opt_date){cell.setAttribute('tabindex','-1');cell.setAttribute('aria-label',this.dateLocale.longDateFormatter(opt_date));cell.id=calendarCtrl.getDateId(opt_date,'month');// Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	cell.setAttribute('data-timestamp',opt_date.getTime());// TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
	// It may be better to finish the construction and then query the node and add the class.
	if(this.dateUtil.isSameDay(opt_date,calendarCtrl.today)){cell.classList.add(calendarCtrl.TODAY_CLASS);}if(this.dateUtil.isValidDate(calendarCtrl.selectedDate)&&this.dateUtil.isSameDay(opt_date,calendarCtrl.selectedDate)){cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);cell.setAttribute('aria-selected','true');}var cellText=this.dateLocale.dates[opt_date.getDate()];if(this.isDateEnabled(opt_date)){// Add a indicator for select, hover, and focus states.
	var selectionIndicator=document.createElement('span');selectionIndicator.classList.add('md-calendar-date-selection-indicator');selectionIndicator.textContent=cellText;cell.appendChild(selectionIndicator);cell.addEventListener('click',monthCtrl.cellClickHandler);if(calendarCtrl.displayDate&&this.dateUtil.isSameDay(opt_date,calendarCtrl.displayDate)){this.focusAfterAppend=cell;}}else{cell.classList.add('md-calendar-date-disabled');cell.textContent=cellText;}}return cell;};/**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */CalendarMonthBodyCtrl.prototype.isDateEnabled=function(opt_date){return this.dateUtil.isDateWithinRange(opt_date,this.calendarCtrl.minDate,this.calendarCtrl.maxDate)&&(!angular.isFunction(this.calendarCtrl.dateFilter)||this.calendarCtrl.dateFilter(opt_date));};/**
	   * Builds a `tr` element for the calendar grid.
	   * @param rowNumber The week number within the month.
	   * @returns {HTMLElement}
	   */CalendarMonthBodyCtrl.prototype.buildDateRow=function(rowNumber){var row=document.createElement('tr');row.setAttribute('role','row');// Because of an NVDA bug (with Firefox), the row needs an aria-label in order
	// to prevent the entire row being read aloud when the user moves between rows.
	// See http://community.nvda-project.org/ticket/4643.
	row.setAttribute('aria-label',this.dateLocale.weekNumberFormatter(rowNumber));return row;};/**
	   * Builds the <tbody> content for the given date's month.
	   * @param {Date=} opt_dateInMonth
	   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
	   */CalendarMonthBodyCtrl.prototype.buildCalendarForMonth=function(opt_dateInMonth){var date=this.dateUtil.isValidDate(opt_dateInMonth)?opt_dateInMonth:new Date();var firstDayOfMonth=this.dateUtil.getFirstDateOfMonth(date);var firstDayOfTheWeek=this.getLocaleDay_(firstDayOfMonth);var numberOfDaysInMonth=this.dateUtil.getNumberOfDaysInMonth(date);// Store rows for the month in a document fragment so that we can append them all at once.
	var monthBody=document.createDocumentFragment();var rowNumber=1;var row=this.buildDateRow(rowNumber);monthBody.appendChild(row);// If this is the final month in the list of items, only the first week should render,
	// so we should return immediately after the first row is complete and has been
	// attached to the body.
	var isFinalMonth=this.offset===this.monthCtrl.items.length-1;// Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
	// goes on a row above the first of the month. Otherwise, the month label takes up the first
	// two cells of the first row.
	var blankCellOffset=0;var monthLabelCell=document.createElement('td');var monthLabelCellContent=document.createElement('span');var calendarCtrl=this.calendarCtrl;monthLabelCellContent.textContent=this.dateLocale.monthHeaderFormatter(date);monthLabelCell.appendChild(monthLabelCellContent);monthLabelCell.classList.add('md-calendar-month-label');// If the entire month is after the max date, render the label as a disabled state.
	if(calendarCtrl.maxDate&&firstDayOfMonth>calendarCtrl.maxDate){monthLabelCell.classList.add('md-calendar-month-label-disabled');// If the user isn't supposed to be able to change views, render the
	// label as usual, but disable the clicking functionality.
	}else if(!calendarCtrl.mode){monthLabelCell.addEventListener('click',this.monthCtrl.headerClickHandler);monthLabelCell.setAttribute('data-timestamp',firstDayOfMonth.getTime());monthLabelCell.setAttribute('aria-label',this.dateLocale.monthFormatter(date));monthLabelCell.classList.add('md-calendar-label-clickable');monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));}if(firstDayOfTheWeek<=2){monthLabelCell.setAttribute('colspan','7');var monthLabelRow=this.buildDateRow();monthLabelRow.appendChild(monthLabelCell);monthBody.insertBefore(monthLabelRow,row);if(isFinalMonth){return monthBody;}}else{blankCellOffset=3;monthLabelCell.setAttribute('colspan','3');row.appendChild(monthLabelCell);}// Add a blank cell for each day of the week that occurs before the first of the month.
	// For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
	// The blankCellOffset is needed in cases where the first N cells are used by the month label.
	for(var i=blankCellOffset;i<firstDayOfTheWeek;i++){row.appendChild(this.buildDateCell());}// Add a cell for each day of the month, keeping track of the day of the week so that
	// we know when to start a new row.
	var dayOfWeek=firstDayOfTheWeek;var iterationDate=firstDayOfMonth;for(var d=1;d<=numberOfDaysInMonth;d++){// If we've reached the end of the week, start a new row.
	if(dayOfWeek===7){// We've finished the first row, so we're done if this is the final month.
	if(isFinalMonth){return monthBody;}dayOfWeek=0;rowNumber++;row=this.buildDateRow(rowNumber);monthBody.appendChild(row);}iterationDate.setDate(d);var cell=this.buildDateCell(iterationDate);row.appendChild(cell);dayOfWeek++;}// Ensure that the last row of the month has 7 cells.
	while(row.childNodes.length<7){row.appendChild(this.buildDateCell());}// Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
	// requires that all items have exactly the same height.
	while(monthBody.childNodes.length<6){var whitespaceRow=this.buildDateRow();for(var j=0;j<7;j++){whitespaceRow.appendChild(this.buildDateCell());}monthBody.appendChild(whitespaceRow);}return monthBody;};/**
	   * Gets the day-of-the-week index for a date for the current locale.
	   * @private
	   * @param {Date} date
	   * @returns {number} The column index of the date in the calendar.
	   */CalendarMonthBodyCtrl.prototype.getLocaleDay_=function(date){return(date.getDay()+(7-this.dateLocale.firstDayOfWeek))%7;};})();})();(function(){"use strict";(function(){'use strict';CalendarYearCtrl.$inject=["$element","$scope","$animate","$q","$$mdDateUtil","$mdUtil"];angular.module('material.components.datepicker').directive('mdCalendarYear',calendarDirective);/**
	   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific years.
	   */var TBODY_HEIGHT=88;/** Private component, representing a list of years in the calendar. */function calendarDirective(){return{template:'<div class="md-calendar-scroll-mask">'+'<md-virtual-repeat-container class="md-calendar-scroll-container">'+'<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">'+'<tbody '+'md-calendar-year-body '+'role="rowgroup" '+'md-virtual-repeat="i in yearCtrl.items" '+'md-year-offset="$index" class="md-calendar-year" '+'md-start-index="yearCtrl.getFocusedYearIndex()" '+'md-item-size="'+TBODY_HEIGHT+'">'+// The <tr> ensures that the <tbody> will have the proper
	// height, even though it may be empty.
	'<tr aria-hidden="true" md-force-height="\''+TBODY_HEIGHT+'px\'"></tr>'+'</tbody>'+'</table>'+'</md-virtual-repeat-container>'+'</div>',require:['^^mdCalendar','mdCalendarYear'],controller:CalendarYearCtrl,controllerAs:'yearCtrl',bindToController:true,link:function link(scope,element,attrs,controllers){var calendarCtrl=controllers[0];var yearCtrl=controllers[1];yearCtrl.initialize(calendarCtrl);}};}/**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */function CalendarYearCtrl($element,$scope,$animate,$q,$$mdDateUtil,$mdUtil){/** @final {!angular.JQLite} */this.$element=$element;/** @final {!angular.Scope} */this.$scope=$scope;/** @final {!angular.$animate} */this.$animate=$animate;/** @final {!angular.$q} */this.$q=$q;/** @final */this.dateUtil=$$mdDateUtil;/** @final {HTMLElement} */this.calendarScroller=$element[0].querySelector('.md-virtual-repeat-scroller');/** @type {boolean} */this.isInitialized=false;/** @type {boolean} */this.isMonthTransitionInProgress=false;/** @final */this.$mdUtil=$mdUtil;var self=this;/**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */this.cellClickHandler=function(){self.onTimestampSelected($$mdDateUtil.getTimestampFromNode(this));};}/**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */CalendarYearCtrl.prototype.initialize=function(calendarCtrl){/**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of years that can be viewed. We add 1 extra in order to include the current year.
	     */this.items={length:this.dateUtil.getYearDistance(calendarCtrl.firstRenderableDate,calendarCtrl.lastRenderableDate)+1};this.calendarCtrl=calendarCtrl;this.attachScopeListeners();calendarCtrl.updateVirtualRepeat();// Fire the initial render, since we might have missed it the first time it fired.
	calendarCtrl.ngModelCtrl&&calendarCtrl.ngModelCtrl.$render();};/**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */CalendarYearCtrl.prototype.getFocusedYearIndex=function(){var calendarCtrl=this.calendarCtrl;return this.dateUtil.getYearDistance(calendarCtrl.firstRenderableDate,calendarCtrl.displayDate||calendarCtrl.selectedDate||calendarCtrl.today);};/**
	   * Change the date that is highlighted in the calendar.
	   * @param {Date} date
	   */CalendarYearCtrl.prototype.changeDate=function(date){// Initialization is deferred until this function is called because we want to reflect
	// the starting value of ngModel.
	if(!this.isInitialized){this.calendarCtrl.hideVerticalScrollbar(this);this.isInitialized=true;return this.$q.when();}else if(this.dateUtil.isValidDate(date)&&!this.isMonthTransitionInProgress){var self=this;var animationPromise=this.animateDateChange(date);self.isMonthTransitionInProgress=true;self.calendarCtrl.displayDate=date;return animationPromise.then(function(){self.isMonthTransitionInProgress=false;});}};/**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */CalendarYearCtrl.prototype.animateDateChange=function(date){if(this.dateUtil.isValidDate(date)){var monthDistance=this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate,date);this.calendarScroller.scrollTop=monthDistance*TBODY_HEIGHT;}return this.$q.when();};/**
	   * Handles the year-view-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */CalendarYearCtrl.prototype.handleKeyEvent=function(event,action){var self=this;var calendarCtrl=self.calendarCtrl;var displayDate=calendarCtrl.displayDate;if(action==='select'){self.changeDate(displayDate).then(function(){self.onTimestampSelected(displayDate);});}else{var date=null;var dateUtil=self.dateUtil;switch(action){case'move-right':date=dateUtil.incrementMonths(displayDate,1);break;case'move-left':date=dateUtil.incrementMonths(displayDate,-1);break;case'move-row-down':date=dateUtil.incrementMonths(displayDate,6);break;case'move-row-up':date=dateUtil.incrementMonths(displayDate,-6);break;}if(date){var min=calendarCtrl.minDate?dateUtil.getFirstDateOfMonth(calendarCtrl.minDate):null;var max=calendarCtrl.maxDate?dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate):null;date=dateUtil.getFirstDateOfMonth(self.dateUtil.clampDate(date,min,max));self.changeDate(date).then(function(){calendarCtrl.focus(date);});}}};/**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */CalendarYearCtrl.prototype.attachScopeListeners=function(){var self=this;self.$scope.$on('md-calendar-parent-changed',function(event,value){self.calendarCtrl.changeSelectedDate(value?self.dateUtil.getFirstDateOfMonth(value):value);self.changeDate(value);});self.$scope.$on('md-calendar-parent-action',angular.bind(self,self.handleKeyEvent));};/**
	   * Handles the behavior when a date is selected. Depending on the `mode`
	   * of the calendar, this can either switch back to the calendar view or
	   * set the model value.
	   * @param {number} timestamp The selected timestamp.
	   */CalendarYearCtrl.prototype.onTimestampSelected=function(timestamp){var calendarCtrl=this.calendarCtrl;if(calendarCtrl.mode){this.$mdUtil.nextTick(function(){calendarCtrl.setNgModelValue(timestamp);});}else{calendarCtrl.setCurrentView('month',timestamp);}};})();})();(function(){"use strict";(function(){'use strict';CalendarYearBodyCtrl.$inject=["$element","$$mdDateUtil","$mdDateLocale"];angular.module('material.components.datepicker').directive('mdCalendarYearBody',mdCalendarYearDirective);/**
	   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
	   * and allows for the year view to use md-virtual-repeat.
	   */function mdCalendarYearDirective(){return{require:['^^mdCalendar','^^mdCalendarYear','mdCalendarYearBody'],scope:{offset:'=mdYearOffset'},controller:CalendarYearBodyCtrl,controllerAs:'mdYearBodyCtrl',bindToController:true,link:function link(scope,element,attrs,controllers){var calendarCtrl=controllers[0];var yearCtrl=controllers[1];var yearBodyCtrl=controllers[2];yearBodyCtrl.calendarCtrl=calendarCtrl;yearBodyCtrl.yearCtrl=yearCtrl;scope.$watch(function(){return yearBodyCtrl.offset;},function(offset){if(angular.isNumber(offset)){yearBodyCtrl.generateContent();}});}};}/**
	   * Controller for a single year.
	   * @ngInject @constructor
	   */function CalendarYearBodyCtrl($element,$$mdDateUtil,$mdDateLocale){/** @final {!angular.JQLite} */this.$element=$element;/** @final */this.dateUtil=$$mdDateUtil;/** @final */this.dateLocale=$mdDateLocale;/** @type {Object} Reference to the calendar. */this.calendarCtrl=null;/** @type {Object} Reference to the year view. */this.yearCtrl=null;/**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */this.offset=null;/**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */this.focusAfterAppend=null;}/** Generate and append the content for this year to the directive element. */CalendarYearBodyCtrl.prototype.generateContent=function(){var date=this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate,this.offset);this.$element.empty().append(this.buildCalendarForYear(date));if(this.focusAfterAppend){this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);this.focusAfterAppend.focus();this.focusAfterAppend=null;}};/**
	   * Creates a single cell to contain a year in the calendar.
	   * @param {number} opt_year Four-digit year.
	   * @param {number} opt_month Zero-indexed month.
	   * @returns {HTMLElement}
	   */CalendarYearBodyCtrl.prototype.buildMonthCell=function(year,month){var calendarCtrl=this.calendarCtrl;var yearCtrl=this.yearCtrl;var cell=this.buildBlankCell();// Represent this month/year as a date.
	var firstOfMonth=new Date(year,month,1);cell.setAttribute('aria-label',this.dateLocale.monthFormatter(firstOfMonth));cell.id=calendarCtrl.getDateId(firstOfMonth,'year');// Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	cell.setAttribute('data-timestamp',firstOfMonth.getTime());if(this.dateUtil.isSameMonthAndYear(firstOfMonth,calendarCtrl.today)){cell.classList.add(calendarCtrl.TODAY_CLASS);}if(this.dateUtil.isValidDate(calendarCtrl.selectedDate)&&this.dateUtil.isSameMonthAndYear(firstOfMonth,calendarCtrl.selectedDate)){cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);cell.setAttribute('aria-selected','true');}var cellText=this.dateLocale.shortMonths[month];if(this.dateUtil.isMonthWithinRange(firstOfMonth,calendarCtrl.minDate,calendarCtrl.maxDate)){var selectionIndicator=document.createElement('span');selectionIndicator.classList.add('md-calendar-date-selection-indicator');selectionIndicator.textContent=cellText;cell.appendChild(selectionIndicator);cell.addEventListener('click',yearCtrl.cellClickHandler);if(calendarCtrl.displayDate&&this.dateUtil.isSameMonthAndYear(firstOfMonth,calendarCtrl.displayDate)){this.focusAfterAppend=cell;}}else{cell.classList.add('md-calendar-date-disabled');cell.textContent=cellText;}return cell;};/**
	   * Builds a blank cell.
	   * @return {HTMLTableCellElement}
	   */CalendarYearBodyCtrl.prototype.buildBlankCell=function(){var cell=document.createElement('td');cell.tabIndex=-1;cell.classList.add('md-calendar-date');cell.setAttribute('role','gridcell');cell.setAttribute('tabindex','-1');return cell;};/**
	   * Builds the <tbody> content for the given year.
	   * @param {Date} date Date for which the content should be built.
	   * @returns {DocumentFragment} A document fragment containing the months within the year.
	   */CalendarYearBodyCtrl.prototype.buildCalendarForYear=function(date){// Store rows for the month in a document fragment so that we can append them all at once.
	var year=date.getFullYear();var yearBody=document.createDocumentFragment();var monthCell,i;// First row contains label and Jan-Jun.
	var firstRow=document.createElement('tr');var labelCell=document.createElement('td');labelCell.className='md-calendar-month-label';labelCell.textContent=year;firstRow.appendChild(labelCell);for(i=0;i<6;i++){firstRow.appendChild(this.buildMonthCell(year,i));}yearBody.appendChild(firstRow);// Second row contains a blank cell and Jul-Dec.
	var secondRow=document.createElement('tr');secondRow.appendChild(this.buildBlankCell());for(i=6;i<12;i++){secondRow.appendChild(this.buildMonthCell(year,i));}yearBody.appendChild(secondRow);return yearBody;};})();})();(function(){"use strict";(function(){'use strict';/**
	   * @ngdoc service
	   * @name $mdDateLocaleProvider
	   * @module material.components.datepicker
	   *
	   * @description
	   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
	   * This provider that allows the user to specify messages, formatters, and parsers for date
	   * internationalization. The `$mdDateLocale` service itself is consumed by AngularJS Material
	   * components that deal with dates.
	   *
	   * @property {(Array<string>)=} months Array of month names (in order).
	   * @property {(Array<string>)=} shortMonths Array of abbreviated month names.
	   * @property {(Array<string>)=} days Array of the days of the week (in order).
	   * @property {(Array<string>)=} shortDays Array of abbreviated days of the week.
	   * @property {(Array<string>)=} dates Array of dates of the month. Only necessary for locales
	   *     using a numeral system other than [1, 2, 3...].
	   * @property {(Array<string>)=} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
	   *    etc.
	   * @property {(function(string): Date)=} parseDate Function to parse a date object from a string.
	   * @property {(function(Date, string): string)=} formatDate Function to format a date object to a
	   *     string. The datepicker directive also provides the time zone, if it was specified.
	   * @property {(function(Date): string)=} monthHeaderFormatter Function that returns the label for
	   *     a month given a date.
	   * @property {(function(Date): string)=} monthFormatter Function that returns the full name of a month
	   *     for a given date.
	   * @property {(function(number): string)=} weekNumberFormatter Function that returns a label for
	   *     a week given the week number.
	   * @property {(string)=} msgCalendar Translation of the label "Calendar" for the current locale.
	   * @property {(string)=} msgOpenCalendar Translation of the button label "Open calendar" for the
	   *     current locale.
	   * @property {Date=} firstRenderableDate The date from which the datepicker calendar will begin
	   * rendering. Note that this will be ignored if a minimum date is set. Defaults to January 1st 1880.
	   * @property {Date=} lastRenderableDate The last date that will be rendered by the datepicker
	   * calendar. Note that this will be ignored if a maximum date is set. Defaults to January 1st 2130.
	   *
	   * @usage
	   * <hljs lang="js">
	   * myAppModule.config(function($mdDateLocaleProvider) {
	   *
	   *     // Example of a French localization.
	   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
	   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
	   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
	   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
	   *
	   *     // Can change week display to start on Monday.
	   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
	   *
	   *     // Optional.
	   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
	   *
	   *     // Example uses moment.js to parse and format dates.
	   *     $mdDateLocaleProvider.parseDate = function(dateString) {
	   *       var m = moment(dateString, 'L', true);
	   *       return m.isValid() ? m.toDate() : new Date(NaN);
	   *     };
	   *
	   *     $mdDateLocaleProvider.formatDate = function(date) {
	   *       var m = moment(date);
	   *       return m.isValid() ? m.format('L') : '';
	   *     };
	   *
	   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
	   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
	   *     };
	   *
	   *     // In addition to date display, date components also need localized messages
	   *     // for aria-labels for screen-reader users.
	   *
	   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
	   *       return 'Semaine ' + weekNumber;
	   *     };
	   *
	   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
	   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
	   *
	   *     // You can also set when your calendar begins and ends.
	   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
	   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
	   * });
	   * </hljs>
	   *
	   */angular.module('material.components.datepicker').config(["$provide",function($provide){// TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.
	/** @constructor */function DateLocaleProvider(){/** Array of full month names. E.g., ['January', 'Febuary', ...] */this.months=null;/** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */this.shortMonths=null;/** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */this.days=null;/** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */this.shortDays=null;/** Array of dates of a month (1 - 31). Characters might be different in some locales. */this.dates=null;/** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */this.firstDayOfWeek=0;/**
	       * Function that converts the date portion of a Date to a string.
	       * @type {(function(Date): string)}
	       */this.formatDate=null;/**
	       * Function that converts a date string to a Date object (the date portion)
	       * @type {function(string): Date}
	       */this.parseDate=null;/**
	       * Function that formats a Date into a month header string.
	       * @type {function(Date): string}
	       */this.monthHeaderFormatter=null;/**
	       * Function that formats a week number into a label for the week.
	       * @type {function(number): string}
	       */this.weekNumberFormatter=null;/**
	       * Function that formats a date into a long aria-label that is read
	       * when the focused date changes.
	       * @type {function(Date): string}
	       */this.longDateFormatter=null;/**
	       * ARIA label for the calendar "dialog" used in the datepicker.
	       * @type {string}
	       */this.msgCalendar='';/**
	       * ARIA label for the datepicker's "Open calendar" buttons.
	       * @type {string}
	       */this.msgOpenCalendar='';}/**
	     * Factory function that returns an instance of the dateLocale service.
	     * @ngInject
	     * @param $locale
	     * @returns {DateLocale}
	     */DateLocaleProvider.prototype.$get=function($locale,$filter){/**
	       * Default date-to-string formatting function.
	       * @param {!Date} date
	       * @param {string=} timezone
	       * @returns {string}
	       */function defaultFormatDate(date,timezone){if(!date){return'';}// All of the dates created through ng-material *should* be set to midnight.
	// If we encounter a date where the localeTime shows at 11pm instead of midnight,
	// we have run into an issue with DST where we need to increment the hour by one:
	// var d = new Date(1992, 9, 8, 0, 0, 0);
	// d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
	var localeTime=date.toLocaleTimeString();var formatDate=date;if(date.getHours()===0&&(localeTime.indexOf('11:')!==-1||localeTime.indexOf('23:')!==-1)){formatDate=new Date(date.getFullYear(),date.getMonth(),date.getDate(),1,0,0);}return $filter('date')(formatDate,'M/d/yyyy',timezone);}/**
	       * Default string-to-date parsing function.
	       * @param {string} dateString
	       * @returns {!Date}
	       */function defaultParseDate(dateString){return new Date(dateString);}/**
	       * Default function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       *
	       * This is very permissive and is just a basic sanity check to ensure that
	       * things like single integers aren't able to be parsed into dates.
	       * @param {string} dateString
	       * @returns {boolean}
	       */function defaultIsDateComplete(dateString){dateString=dateString.trim();// Looks for three chunks of content (either numbers or text) separated
	// by delimiters.
	var re=/^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;return re.test(dateString);}/**
	       * Default date-to-string formatter to get a month header.
	       * @param {!Date} date
	       * @returns {string}
	       */function defaultMonthHeaderFormatter(date){return service.shortMonths[date.getMonth()]+' '+date.getFullYear();}/**
	       * Default formatter for a month.
	       * @param {!Date} date
	       * @returns {string}
	       */function defaultMonthFormatter(date){return service.months[date.getMonth()]+' '+date.getFullYear();}/**
	       * Default week number formatter.
	       * @param number
	       * @returns {string}
	       */function defaultWeekNumberFormatter(number){return'Week '+number;}/**
	       * Default formatter for date cell aria-labels.
	       * @param {!Date} date
	       * @returns {string}
	       */function defaultLongDateFormatter(date){// Example: 'Thursday June 18 2015'
	return[service.days[date.getDay()],service.months[date.getMonth()],service.dates[date.getDate()],date.getFullYear()].join(' ');}// The default "short" day strings are the first character of each day,
	// e.g., "Monday" => "M".
	var defaultShortDays=$locale.DATETIME_FORMATS.SHORTDAY.map(function(day){return day.substring(0,1);});// The default dates are simply the numbers 1 through 31.
	var defaultDates=Array(32);for(var i=1;i<=31;i++){defaultDates[i]=i;}// Default ARIA messages are in English (US).
	var defaultMsgCalendar='Calendar';var defaultMsgOpenCalendar='Open calendar';// Default start/end dates that are rendered in the calendar.
	var defaultFirstRenderableDate=new Date(1880,0,1);var defaultLastRendereableDate=new Date(defaultFirstRenderableDate.getFullYear()+250,0,1);var service={months:this.months||$locale.DATETIME_FORMATS.MONTH,shortMonths:this.shortMonths||$locale.DATETIME_FORMATS.SHORTMONTH,days:this.days||$locale.DATETIME_FORMATS.DAY,shortDays:this.shortDays||defaultShortDays,dates:this.dates||defaultDates,firstDayOfWeek:this.firstDayOfWeek||0,formatDate:this.formatDate||defaultFormatDate,parseDate:this.parseDate||defaultParseDate,isDateComplete:this.isDateComplete||defaultIsDateComplete,monthHeaderFormatter:this.monthHeaderFormatter||defaultMonthHeaderFormatter,monthFormatter:this.monthFormatter||defaultMonthFormatter,weekNumberFormatter:this.weekNumberFormatter||defaultWeekNumberFormatter,longDateFormatter:this.longDateFormatter||defaultLongDateFormatter,msgCalendar:this.msgCalendar||defaultMsgCalendar,msgOpenCalendar:this.msgOpenCalendar||defaultMsgOpenCalendar,firstRenderableDate:this.firstRenderableDate||defaultFirstRenderableDate,lastRenderableDate:this.lastRenderableDate||defaultLastRendereableDate};return service;};DateLocaleProvider.prototype.$get.$inject=["$locale","$filter"];$provide.provider('$mdDateLocale',new DateLocaleProvider());}]);})();})();(function(){"use strict";(function(){'use strict';/**
	   * Utility for performing date calculations to facilitate operation of the calendar and
	   * datepicker.
	   */angular.module('material.components.datepicker').factory('$$mdDateUtil',function(){return{getFirstDateOfMonth:getFirstDateOfMonth,getNumberOfDaysInMonth:getNumberOfDaysInMonth,getDateInNextMonth:getDateInNextMonth,getDateInPreviousMonth:getDateInPreviousMonth,isInNextMonth:isInNextMonth,isInPreviousMonth:isInPreviousMonth,getDateMidpoint:getDateMidpoint,isSameMonthAndYear:isSameMonthAndYear,getWeekOfMonth:getWeekOfMonth,incrementDays:incrementDays,incrementMonths:incrementMonths,getLastDateOfMonth:getLastDateOfMonth,isSameDay:isSameDay,getMonthDistance:getMonthDistance,isValidDate:isValidDate,setDateTimeToMidnight:setDateTimeToMidnight,createDateAtMidnight:createDateAtMidnight,isDateWithinRange:isDateWithinRange,incrementYears:incrementYears,getYearDistance:getYearDistance,clampDate:clampDate,getTimestampFromNode:getTimestampFromNode,isMonthWithinRange:isMonthWithinRange};/**
	     * Gets the first day of the month for the given date's month.
	     * @param {Date} date
	     * @returns {Date}
	     */function getFirstDateOfMonth(date){return new Date(date.getFullYear(),date.getMonth(),1);}/**
	     * Gets the number of days in the month for the given date's month.
	     * @param date
	     * @returns {number}
	     */function getNumberOfDaysInMonth(date){return new Date(date.getFullYear(),date.getMonth()+1,0).getDate();}/**
	     * Get an arbitrary date in the month after the given date's month.
	     * @param date
	     * @returns {Date}
	     */function getDateInNextMonth(date){return new Date(date.getFullYear(),date.getMonth()+1,1);}/**
	     * Get an arbitrary date in the month before the given date's month.
	     * @param date
	     * @returns {Date}
	     */function getDateInPreviousMonth(date){return new Date(date.getFullYear(),date.getMonth()-1,1);}/**
	     * Gets whether two dates have the same month and year.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */function isSameMonthAndYear(d1,d2){return d1.getFullYear()===d2.getFullYear()&&d1.getMonth()===d2.getMonth();}/**
	     * Gets whether two dates are the same day (not not necesarily the same time).
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */function isSameDay(d1,d2){return d1.getDate()==d2.getDate()&&isSameMonthAndYear(d1,d2);}/**
	     * Gets whether a date is in the month immediately after some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */function isInNextMonth(startDate,endDate){var nextMonth=getDateInNextMonth(startDate);return isSameMonthAndYear(nextMonth,endDate);}/**
	     * Gets whether a date is in the month immediately before some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */function isInPreviousMonth(startDate,endDate){var previousMonth=getDateInPreviousMonth(startDate);return isSameMonthAndYear(endDate,previousMonth);}/**
	     * Gets the midpoint between two dates.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {Date}
	     */function getDateMidpoint(d1,d2){return createDateAtMidnight((d1.getTime()+d2.getTime())/2);}/**
	     * Gets the week of the month that a given date occurs in.
	     * @param {Date} date
	     * @returns {number} Index of the week of the month (zero-based).
	     */function getWeekOfMonth(date){var firstDayOfMonth=getFirstDateOfMonth(date);return Math.floor((firstDayOfMonth.getDay()+date.getDate()-1)/7);}/**
	     * Gets a new date incremented by the given number of days. Number of days can be negative.
	     * @param {Date} date
	     * @param {number} numberOfDays
	     * @returns {Date}
	     */function incrementDays(date,numberOfDays){return new Date(date.getFullYear(),date.getMonth(),date.getDate()+numberOfDays);}/**
	     * Gets a new date incremented by the given number of months. Number of months can be negative.
	     * If the date of the given month does not match the target month, the date will be set to the
	     * last day of the month.
	     * @param {Date} date
	     * @param {number} numberOfMonths
	     * @returns {Date}
	     */function incrementMonths(date,numberOfMonths){// If the same date in the target month does not actually exist, the Date object will
	// automatically advance *another* month by the number of missing days.
	// For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
	// So, we check if the month overflowed and go to the last day of the target month instead.
	var dateInTargetMonth=new Date(date.getFullYear(),date.getMonth()+numberOfMonths,1);var numberOfDaysInMonth=getNumberOfDaysInMonth(dateInTargetMonth);if(numberOfDaysInMonth<date.getDate()){dateInTargetMonth.setDate(numberOfDaysInMonth);}else{dateInTargetMonth.setDate(date.getDate());}return dateInTargetMonth;}/**
	     * Get the integer distance between two months. This *only* considers the month and year
	     * portion of the Date instances.
	     *
	     * @param {Date} start
	     * @param {Date} end
	     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	     *     chronologically, this number will be negative.
	     */function getMonthDistance(start,end){return 12*(end.getFullYear()-start.getFullYear())+(end.getMonth()-start.getMonth());}/**
	     * Gets the last day of the month for the given date.
	     * @param {Date} date
	     * @returns {Date}
	     */function getLastDateOfMonth(date){return new Date(date.getFullYear(),date.getMonth(),getNumberOfDaysInMonth(date));}/**
	     * Checks whether a date is valid.
	     * @param {Date} date
	     * @return {boolean} Whether the date is a valid Date.
	     */function isValidDate(date){return date&&date.getTime&&!isNaN(date.getTime());}/**
	     * Sets a date's time to midnight.
	     * @param {Date} date
	     */function setDateTimeToMidnight(date){if(isValidDate(date)){date.setHours(0,0,0,0);}}/**
	     * Creates a date with the time set to midnight.
	     * Drop-in replacement for two forms of the Date constructor:
	     * 1. No argument for Date representing now.
	     * 2. Single-argument value representing number of seconds since Unix Epoch
	     * or a Date object.
	     * @param {number|Date=} opt_value
	     * @return {Date} New date with time set to midnight.
	     */function createDateAtMidnight(opt_value){var date;if(angular.isUndefined(opt_value)){date=new Date();}else{date=new Date(opt_value);}setDateTimeToMidnight(date);return date;}/**
	      * Checks if a date is within a min and max range, ignoring the time component.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */function isDateWithinRange(date,minDate,maxDate){var dateAtMidnight=createDateAtMidnight(date);var minDateAtMidnight=isValidDate(minDate)?createDateAtMidnight(minDate):null;var maxDateAtMidnight=isValidDate(maxDate)?createDateAtMidnight(maxDate):null;return(!minDateAtMidnight||minDateAtMidnight<=dateAtMidnight)&&(!maxDateAtMidnight||maxDateAtMidnight>=dateAtMidnight);}/**
	     * Gets a new date incremented by the given number of years. Number of years can be negative.
	     * See `incrementMonths` for notes on overflow for specific dates.
	     * @param {Date} date
	     * @param {number} numberOfYears
	     * @returns {Date}
	     */function incrementYears(date,numberOfYears){return incrementMonths(date,numberOfYears*12);}/**
	      * Get the integer distance between two years. This *only* considers the year portion of the
	      * Date instances.
	      *
	      * @param {Date} start
	      * @param {Date} end
	      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	      *     chronologically, this number will be negative.
	      */function getYearDistance(start,end){return end.getFullYear()-start.getFullYear();}/**
	      * Clamps a date between a minimum and a maximum date.
	      * @param {Date} date Date to be clamped
	      * @param {Date=} minDate Minimum date
	      * @param {Date=} maxDate Maximum date
	      * @return {Date}
	      */function clampDate(date,minDate,maxDate){var boundDate=date;if(minDate&&date<minDate){boundDate=new Date(minDate.getTime());}if(maxDate&&date>maxDate){boundDate=new Date(maxDate.getTime());}return boundDate;}/**
	      * Extracts and parses the timestamp from a DOM node.
	      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
	      * @return {number} Time since epoch.
	      */function getTimestampFromNode(node){if(node&&node.hasAttribute('data-timestamp')){return Number(node.getAttribute('data-timestamp'));}}/**
	      * Checks if a month is within a min and max range, ignoring the date and time components.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */function isMonthWithinRange(date,minDate,maxDate){var month=date.getMonth();var year=date.getFullYear();return(!minDate||minDate.getFullYear()<year||minDate.getMonth()<=month)&&(!maxDate||maxDate.getFullYear()>year||maxDate.getMonth()>=month);}});})();})();(function(){"use strict";(function(){'use strict';// POST RELEASE
	// TODO(jelbourn): Demo that uses moment.js
	// TODO(jelbourn): make sure this plays well with validation and ngMessages.
	// TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
	// TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
	// TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
	// TODO(jelbourn): input behavior (masking? auto-complete?)
	DatePickerCtrl.$inject=["$scope","$element","$attrs","$window","$mdConstant","$mdTheming","$mdUtil","$mdDateLocale","$$mdDateUtil","$$rAF","$filter"];datePickerDirective.$inject=["$$mdSvgRegistry","$mdUtil","$mdAria","inputDirective"];angular.module('material.components.datepicker').directive('mdDatepicker',datePickerDirective);/**
	   * @ngdoc directive
	   * @name mdDatepicker
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a value that can be parsed into one (e.g. a ISO 8601 string).
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being updated. Also allows
	   * for a timezone to be specified. <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the ngModelOptions docs.</a>
	   * @param {expression=} ng-change Expression evaluated when the model value changes.
	   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar is opened.
	   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the calendar is closed.
	   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
	   * @param {boolean=} ng-required Whether a value is required for the datepicker.
	   * @param {Date=} md-min-date Expression representing a min date (inclusive).
	   * @param {Date=} md-max-date Expression representing a max date (inclusive).
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   * @param {String=} md-placeholder The date input placeholder value.
	   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input is focused.
	   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar on-demand.
	   * @param {String=} md-current-view Default open view of the calendar pane. Can be either "month" or "year".
	   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view. This option can
	   * be used if the user is only supposed to choose from a certain date type (e.g. only selecting the month).
	   * Can be either "month" or "day". **Note** that this will ovewrite the `md-current-view` value.
	   *
	   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that this may cause the
	   * datepicker to not align properly with other components. **Use at your own risk.** Possible values are:
	   * * `"all"` - Hides all icons.
	   * * `"calendar"` - Only hides the calendar icon.
	   * * `"triangle"` - Only hides the triangle icon.
	   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
	   * ovewritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
	   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
	   *
	   * @description
	   * `<md-datepicker>` is a component used to select a single date.
	   * For information on how to configure internationalization for the date picker,
	   * see `$mdDateLocaleProvider`.
	   *
	   * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
	   * Supported attributes are:
	   * * `required`: whether a required date is not set.
	   * * `mindate`: whether the selected date is before the minimum allowed date.
	   * * `maxdate`: whether the selected date is after the maximum allowed date.
	   * * `debounceInterval`: ms to delay input processing (since last debounce reset); default value 500ms
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-datepicker ng-model="birthday"></md-datepicker>
	   * </hljs>
	   *
	   */function datePickerDirective($$mdSvgRegistry,$mdUtil,$mdAria,inputDirective){return{template:function template(tElement,tAttrs){// Buttons are not in the tab order because users can open the calendar via keyboard
	// interaction on the text input, and multiple tab stops for one component (picker)
	// may be confusing.
	var hiddenIcons=tAttrs.mdHideIcons;var ariaLabelValue=tAttrs.ariaLabel||tAttrs.mdPlaceholder;var calendarButton=hiddenIcons==='all'||hiddenIcons==='calendar'?'':'<md-button class="md-datepicker-button md-icon-button" type="button" '+'tabindex="-1" aria-hidden="true" '+'ng-click="ctrl.openCalendarPane($event)">'+'<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" '+'md-svg-src="'+$$mdSvgRegistry.mdCalendar+'"></md-icon>'+'</md-button>';var triangleButton='';if(hiddenIcons!=='all'&&hiddenIcons!=='triangle'){triangleButton=''+'<md-button type="button" md-no-ink '+'class="md-datepicker-triangle-button md-icon-button" '+'ng-click="ctrl.openCalendarPane($event)" '+'aria-label="{{::ctrl.locale.msgOpenCalendar}}">'+'<div class="md-datepicker-expand-triangle"></div>'+'</md-button>';tElement.addClass(HAS_TRIANGLE_ICON_CLASS);}return calendarButton+'<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">'+'<input '+(ariaLabelValue?'aria-label="'+ariaLabelValue+'" ':'')+'class="md-datepicker-input" '+'aria-haspopup="true" '+'aria-expanded="{{ctrl.isCalendarOpen}}" '+'ng-focus="ctrl.setFocused(true)" '+'ng-blur="ctrl.setFocused(false)"> '+triangleButton+'</div>'+// This pane will be detached from here and re-attached to the document body.
	'<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">'+'<div class="md-datepicker-input-mask">'+'<div class="md-datepicker-input-mask-opaque"></div>'+'</div>'+'<div class="md-datepicker-calendar">'+'<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" '+'md-current-view="{{::ctrl.currentView}}"'+'md-mode="{{::ctrl.mode}}"'+'md-min-date="ctrl.minDate"'+'md-max-date="ctrl.maxDate"'+'md-date-filter="ctrl.dateFilter"'+'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">'+'</md-calendar>'+'</div>'+'</div>';},require:['ngModel','mdDatepicker','?^mdInputContainer','?^form'],scope:{minDate:'=mdMinDate',maxDate:'=mdMaxDate',placeholder:'@mdPlaceholder',currentView:'@mdCurrentView',mode:'@mdMode',dateFilter:'=mdDateFilter',isOpen:'=?mdIsOpen',debounceInterval:'=mdDebounceInterval',dateLocale:'=mdDateLocale'},controller:DatePickerCtrl,controllerAs:'ctrl',bindToController:true,link:function link(scope,element,attr,controllers){var ngModelCtrl=controllers[0];var mdDatePickerCtrl=controllers[1];var mdInputContainer=controllers[2];var parentForm=controllers[3];var mdNoAsterisk=$mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);mdDatePickerCtrl.configureNgModel(ngModelCtrl,mdInputContainer,inputDirective);if(mdInputContainer){// We need to move the spacer after the datepicker itself,
	// because md-input-container adds it after the
	// md-datepicker-input by default. The spacer gets wrapped in a
	// div, because it floats and gets aligned next to the datepicker.
	// There are easier ways of working around this with CSS (making the
	// datepicker 100% wide, change the `display` etc.), however they
	// break the alignment with any other form controls.
	var spacer=element[0].querySelector('.md-errors-spacer');if(spacer){element.after(angular.element('<div>').append(spacer));}mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);mdInputContainer.input=element;mdInputContainer.element.addClass(INPUT_CONTAINER_CLASS).toggleClass(HAS_CALENDAR_ICON_CLASS,attr.mdHideIcons!=='calendar'&&attr.mdHideIcons!=='all');if(!mdInputContainer.label){$mdAria.expect(element,'aria-label',attr.mdPlaceholder);}else if(!mdNoAsterisk){attr.$observe('required',function(value){mdInputContainer.label.toggleClass('md-required',!!value);});}scope.$watch(mdInputContainer.isErrorGetter||function(){return ngModelCtrl.$invalid&&(ngModelCtrl.$touched||parentForm&&parentForm.$submitted);},mdInputContainer.setInvalid);}else if(parentForm){// If invalid, highlights the input when the parent form is submitted.
	var parentSubmittedWatcher=scope.$watch(function(){return parentForm.$submitted;},function(isSubmitted){if(isSubmitted){mdDatePickerCtrl.updateErrorState();parentSubmittedWatcher();}});}}};}/** Additional offset for the input's `size` attribute, which is updated based on its content. */var EXTRA_INPUT_SIZE=3;/** Class applied to the container if the date is invalid. */var INVALID_CLASS='md-datepicker-invalid';/** Class applied to the datepicker when it's open. */var OPEN_CLASS='md-datepicker-open';/** Class applied to the md-input-container, if a datepicker is placed inside it */var INPUT_CONTAINER_CLASS='_md-datepicker-floating-label';/** Class to be applied when the calendar icon is enabled. */var HAS_CALENDAR_ICON_CLASS='_md-datepicker-has-calendar-icon';/** Class to be applied when the triangle icon is enabled. */var HAS_TRIANGLE_ICON_CLASS='_md-datepicker-has-triangle-icon';/** Default time in ms to debounce input event by. */var DEFAULT_DEBOUNCE_INTERVAL=500;/**
	   * Height of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */var CALENDAR_PANE_HEIGHT=368;/**
	   * Width of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */var CALENDAR_PANE_WIDTH=360;/** Used for checking whether the current user agent is on iOS or Android. */var IS_MOBILE_REGEX=/ipad|iphone|ipod|android/i;/**
	   * Controller for md-datepicker.
	   *
	   * @ngInject @constructor
	   */function DatePickerCtrl($scope,$element,$attrs,$window,$mdConstant,$mdTheming,$mdUtil,$mdDateLocale,$$mdDateUtil,$$rAF,$filter){/** @final */this.$window=$window;/** @final */this.dateUtil=$$mdDateUtil;/** @final */this.$mdConstant=$mdConstant;/* @final */this.$mdUtil=$mdUtil;/** @final */this.$$rAF=$$rAF;/** @final */this.$mdDateLocale=$mdDateLocale;/**
	     * The root document element. This is used for attaching a top-level click handler to
	     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
	     * instead of body because, when scrolling is disabled, some browsers consider the body element
	     * to be completely off the screen and propagate events directly to the html element.
	     * @type {!angular.JQLite}
	     */this.documentElement=angular.element(document.documentElement);/** @type {!angular.NgModelController} */this.ngModelCtrl=null;/** @type {HTMLInputElement} */this.inputElement=$element[0].querySelector('input');/** @final {!angular.JQLite} */this.ngInputElement=angular.element(this.inputElement);/** @type {HTMLElement} */this.inputContainer=$element[0].querySelector('.md-datepicker-input-container');/** @type {HTMLElement} Floating calendar pane. */this.calendarPane=$element[0].querySelector('.md-datepicker-calendar-pane');/** @type {HTMLElement} Calendar icon button. */this.calendarButton=$element[0].querySelector('.md-datepicker-button');/**
	     * Element covering everything but the input in the top of the floating calendar pane.
	     * @type {!angular.JQLite}
	     */this.inputMask=angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));/** @final {!angular.JQLite} */this.$element=$element;/** @final {!angular.Attributes} */this.$attrs=$attrs;/** @final {!angular.Scope} */this.$scope=$scope;/** @type {Date} */this.date=null;/** @type {boolean} */this.isFocused=false;/** @type {boolean} */this.isDisabled;this.setDisabled($element[0].disabled||angular.isString($attrs.disabled));/** @type {boolean} Whether the date-picker's calendar pane is open. */this.isCalendarOpen=false;/** @type {boolean} Whether the calendar should open when the input is focused. */this.openOnFocus=$attrs.hasOwnProperty('mdOpenOnFocus');/** @final */this.mdInputContainer=null;/**
	     * Element from which the calendar pane was opened. Keep track of this so that we can return
	     * focus to it when the pane is closed.
	     * @type {HTMLElement}
	     */this.calendarPaneOpenedFrom=null;/** @type {String} Unique id for the calendar pane. */this.calendarPaneId='md-date-pane-'+$mdUtil.nextUid();/** Pre-bound click handler is saved so that the event listener can be removed. */this.bodyClickHandler=angular.bind(this,this.handleBodyClick);/**
	     * Name of the event that will trigger a close. Necessary to sniff the browser, because
	     * the resize event doesn't make sense on mobile and can have a negative impact since it
	     * triggers whenever the browser zooms in on a focused input.
	     */this.windowEventName=IS_MOBILE_REGEX.test(navigator.userAgent||navigator.vendor||window.opera)?'orientationchange':'resize';/** Pre-bound close handler so that the event listener can be removed. */this.windowEventHandler=$mdUtil.debounce(angular.bind(this,this.closeCalendarPane),100);/** Pre-bound handler for the window blur event. Allows for it to be removed later. */this.windowBlurHandler=angular.bind(this,this.handleWindowBlur);/** The built-in AngularJS date filter. */this.ngDateFilter=$filter('date');/** @type {Number} Extra margin for the left side of the floating calendar pane. */this.leftMargin=20;/** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */this.topMargin=null;// Unless the user specifies so, the datepicker should not be a tab stop.
	// This is necessary because ngAria might add a tabindex to anything with an ng-model
	// (based on whether or not the user has turned that particular feature on/off).
	if($attrs.tabindex){this.ngInputElement.attr('tabindex',$attrs.tabindex);$attrs.$set('tabindex',null);}else{$attrs.$set('tabindex','-1');}$attrs.$set('aria-owns',this.calendarPaneId);$mdTheming($element);$mdTheming(angular.element(this.calendarPane));var self=this;$scope.$on('$destroy',function(){self.detachCalendarPane();});if($attrs.mdIsOpen){$scope.$watch('ctrl.isOpen',function(shouldBeOpen){if(shouldBeOpen){self.openCalendarPane({target:self.inputElement});}else{self.closeCalendarPane();}});}// For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	// manually call the $onInit hook.
	if(angular.version.major===1&&angular.version.minor<=4){this.$onInit();}}/**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */DatePickerCtrl.prototype.$onInit=function(){/**
	     * Holds locale-specific formatters, parsers, labels etc. Allows
	     * the user to override specific ones from the $mdDateLocale provider.
	     * @type {!Object}
	     */this.locale=this.dateLocale?angular.extend({},this.$mdDateLocale,this.dateLocale):this.$mdDateLocale;this.installPropertyInterceptors();this.attachChangeListeners();this.attachInteractionListeners();};/**
	   * Sets up the controller's reference to ngModelController and
	   * applies AngularJS's `input[type="date"]` directive.
	   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
	   * @param {Object} inputDirective Config for AngularJS's `input` directive.
	   */DatePickerCtrl.prototype.configureNgModel=function(ngModelCtrl,mdInputContainer,inputDirective){this.ngModelCtrl=ngModelCtrl;this.mdInputContainer=mdInputContainer;// The input needs to be [type="date"] in order to be picked up by AngularJS.
	this.$attrs.$set('type','date');// Invoke the `input` directive link function, adding a stub for the element.
	// This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
	// It works by calling the link function directly which then adds the proper `$parsers` and
	// `$formatters` to the ngModel controller.
	inputDirective[0].link.pre(this.$scope,{on:angular.noop,val:angular.noop,0:{}},this.$attrs,[ngModelCtrl]);var self=this;// Responds to external changes to the model value.
	self.ngModelCtrl.$formatters.push(function(value){var parsedValue=angular.isDefined(value)?value:null;if(!(value instanceof Date)){parsedValue=Date.parse(value);// `parsedValue` is the time since epoch if valid or `NaN` if invalid.
	if(!isNaN(parsedValue)&&angular.isNumber(parsedValue)){value=new Date(parsedValue);}if(value&&!(value instanceof Date)){throw Error('The ng-model for md-datepicker must be a Date instance or a value '+'that can be parsed into a date. Currently the model is of type: '+(typeof value==="undefined"?"undefined":_typeof(value)));}}self.onExternalChange(value);return value;});// Responds to external error state changes (e.g. ng-required based on another input).
	ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this,this.updateErrorState));// Forwards any events from the input to the root element. This is necessary to get `updateOn`
	// working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
	// the `<md-datepicker>`.
	var updateOn=self.$mdUtil.getModelOption(ngModelCtrl,'updateOn');if(updateOn){this.ngInputElement.on(updateOn,angular.bind(this.$element,this.$element.triggerHandler,updateOn));}};/**
	   * Attach event listeners for both the text input and the md-calendar.
	   * Events are used instead of ng-model so that updates don't infinitely update the other
	   * on a change. This should also be more performant than using a $watch.
	   */DatePickerCtrl.prototype.attachChangeListeners=function(){var self=this;self.$scope.$on('md-calendar-change',function(event,date){self.setModelValue(date);self.onExternalChange(date);self.closeCalendarPane();});self.ngInputElement.on('input',angular.bind(self,self.resizeInputElement));var debounceInterval=angular.isDefined(this.debounceInterval)?this.debounceInterval:DEFAULT_DEBOUNCE_INTERVAL;self.ngInputElement.on('input',self.$mdUtil.debounce(self.handleInputEvent,debounceInterval,self));};/** Attach event listeners for user interaction. */DatePickerCtrl.prototype.attachInteractionListeners=function(){var self=this;var $scope=this.$scope;var keyCodes=this.$mdConstant.KEY_CODE;// Add event listener through angular so that we can triggerHandler in unit tests.
	self.ngInputElement.on('keydown',function(event){if(event.altKey&&event.keyCode==keyCodes.DOWN_ARROW){self.openCalendarPane(event);$scope.$digest();}});if(self.openOnFocus){self.ngInputElement.on('focus',angular.bind(self,self.openCalendarPane));angular.element(self.$window).on('blur',self.windowBlurHandler);$scope.$on('$destroy',function(){angular.element(self.$window).off('blur',self.windowBlurHandler);});}$scope.$on('md-calendar-close',function(){self.closeCalendarPane();});};/**
	   * Capture properties set to the date-picker and imperitively handle internal changes.
	   * This is done to avoid setting up additional $watches.
	   */DatePickerCtrl.prototype.installPropertyInterceptors=function(){var self=this;if(this.$attrs.ngDisabled){// The expression is to be evaluated against the directive element's scope and not
	// the directive's isolate scope.
	var scope=this.$scope.$parent;if(scope){scope.$watch(this.$attrs.ngDisabled,function(isDisabled){self.setDisabled(isDisabled);});}}Object.defineProperty(this,'placeholder',{get:function get(){return self.inputElement.placeholder;},set:function set(value){self.inputElement.placeholder=value||'';}});};/**
	   * Sets whether the date-picker is disabled.
	   * @param {boolean} isDisabled
	   */DatePickerCtrl.prototype.setDisabled=function(isDisabled){this.isDisabled=isDisabled;this.inputElement.disabled=isDisabled;if(this.calendarButton){this.calendarButton.disabled=isDisabled;}};/**
	   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
	   *   - mindate: whether the selected date is before the minimum date.
	   *   - maxdate: whether the selected flag is after the maximum date.
	   *   - filtered: whether the selected date is allowed by the custom filtering function.
	   *   - valid: whether the entered text input is a valid date
	   *
	   * The 'required' flag is handled automatically by ngModel.
	   *
	   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
	   */DatePickerCtrl.prototype.updateErrorState=function(opt_date){var date=opt_date||this.date;// Clear any existing errors to get rid of anything that's no longer relevant.
	this.clearErrorState();if(this.dateUtil.isValidDate(date)){// Force all dates to midnight in order to ignore the time portion.
	date=this.dateUtil.createDateAtMidnight(date);if(this.dateUtil.isValidDate(this.minDate)){var minDate=this.dateUtil.createDateAtMidnight(this.minDate);this.ngModelCtrl.$setValidity('mindate',date>=minDate);}if(this.dateUtil.isValidDate(this.maxDate)){var maxDate=this.dateUtil.createDateAtMidnight(this.maxDate);this.ngModelCtrl.$setValidity('maxdate',date<=maxDate);}if(angular.isFunction(this.dateFilter)){this.ngModelCtrl.$setValidity('filtered',this.dateFilter(date));}}else{// The date is seen as "not a valid date" if there is *something* set
	// (i.e.., not null or undefined), but that something isn't a valid date.
	this.ngModelCtrl.$setValidity('valid',date==null);}angular.element(this.inputContainer).toggleClass(INVALID_CLASS,!this.ngModelCtrl.$valid);};/** Clears any error flags set by `updateErrorState`. */DatePickerCtrl.prototype.clearErrorState=function(){this.inputContainer.classList.remove(INVALID_CLASS);['mindate','maxdate','filtered','valid'].forEach(function(field){this.ngModelCtrl.$setValidity(field,true);},this);};/** Resizes the input element based on the size of its content. */DatePickerCtrl.prototype.resizeInputElement=function(){this.inputElement.size=this.inputElement.value.length+EXTRA_INPUT_SIZE;};/**
	   * Sets the model value if the user input is a valid date.
	   * Adds an invalid class to the input element if not.
	   */DatePickerCtrl.prototype.handleInputEvent=function(){var inputString=this.inputElement.value;var parsedDate=inputString?this.locale.parseDate(inputString):null;this.dateUtil.setDateTimeToMidnight(parsedDate);// An input string is valid if it is either empty (representing no date)
	// or if it parses to a valid date that the user is allowed to select.
	var isValidInput=inputString==''||this.dateUtil.isValidDate(parsedDate)&&this.locale.isDateComplete(inputString)&&this.isDateEnabled(parsedDate);// The datepicker's model is only updated when there is a valid input.
	if(isValidInput){this.setModelValue(parsedDate);this.date=parsedDate;}this.updateErrorState(parsedDate);};/**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */DatePickerCtrl.prototype.isDateEnabled=function(opt_date){return this.dateUtil.isDateWithinRange(opt_date,this.minDate,this.maxDate)&&(!angular.isFunction(this.dateFilter)||this.dateFilter(opt_date));};/** Position and attach the floating calendar to the document. */DatePickerCtrl.prototype.attachCalendarPane=function(){var calendarPane=this.calendarPane;var body=document.body;calendarPane.style.transform='';this.$element.addClass(OPEN_CLASS);this.mdInputContainer&&this.mdInputContainer.element.addClass(OPEN_CLASS);angular.element(body).addClass('md-datepicker-is-showing');var elementRect=this.inputContainer.getBoundingClientRect();var bodyRect=body.getBoundingClientRect();if(!this.topMargin||this.topMargin<0){this.topMargin=(this.inputMask.parent().prop('clientHeight')-this.ngInputElement.prop('clientHeight'))/2;}// Check to see if the calendar pane would go off the screen. If so, adjust position
	// accordingly to keep it within the viewport.
	var paneTop=elementRect.top-bodyRect.top-this.topMargin;var paneLeft=elementRect.left-bodyRect.left-this.leftMargin;// If ng-material has disabled body scrolling (for example, if a dialog is open),
	// then it's possible that the already-scrolled body has a negative top/left. In this case,
	// we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
	// though, the top of the viewport should just be the body's scroll position.
	var viewportTop=bodyRect.top<0&&document.body.scrollTop==0?-bodyRect.top:document.body.scrollTop;var viewportLeft=bodyRect.left<0&&document.body.scrollLeft==0?-bodyRect.left:document.body.scrollLeft;var viewportBottom=viewportTop+this.$window.innerHeight;var viewportRight=viewportLeft+this.$window.innerWidth;// Creates an overlay with a hole the same size as element. We remove a pixel or two
	// on each end to make it overlap slightly. The overlay's background is added in
	// the theme in the form of a box-shadow with a huge spread.
	this.inputMask.css({position:'absolute',left:this.leftMargin+'px',top:this.topMargin+'px',width:elementRect.width-1+'px',height:elementRect.height-2+'px'});// If the right edge of the pane would be off the screen and shifting it left by the
	// difference would not go past the left edge of the screen. If the calendar pane is too
	// big to fit on the screen at all, move it to the left of the screen and scale the entire
	// element down to fit.
	if(paneLeft+CALENDAR_PANE_WIDTH>viewportRight){if(viewportRight-CALENDAR_PANE_WIDTH>0){paneLeft=viewportRight-CALENDAR_PANE_WIDTH;}else{paneLeft=viewportLeft;var scale=this.$window.innerWidth/CALENDAR_PANE_WIDTH;calendarPane.style.transform='scale('+scale+')';}calendarPane.classList.add('md-datepicker-pos-adjusted');}// If the bottom edge of the pane would be off the screen and shifting it up by the
	// difference would not go past the top edge of the screen.
	if(paneTop+CALENDAR_PANE_HEIGHT>viewportBottom&&viewportBottom-CALENDAR_PANE_HEIGHT>viewportTop){paneTop=viewportBottom-CALENDAR_PANE_HEIGHT;calendarPane.classList.add('md-datepicker-pos-adjusted');}calendarPane.style.left=paneLeft+'px';calendarPane.style.top=paneTop+'px';document.body.appendChild(calendarPane);// Add CSS class after one frame to trigger open animation.
	this.$$rAF(function(){calendarPane.classList.add('md-pane-open');});};/** Detach the floating calendar pane from the document. */DatePickerCtrl.prototype.detachCalendarPane=function(){this.$element.removeClass(OPEN_CLASS);this.mdInputContainer&&this.mdInputContainer.element.removeClass(OPEN_CLASS);angular.element(document.body).removeClass('md-datepicker-is-showing');this.calendarPane.classList.remove('md-pane-open');this.calendarPane.classList.remove('md-datepicker-pos-adjusted');if(this.isCalendarOpen){this.$mdUtil.enableScrolling();}if(this.calendarPane.parentNode){// Use native DOM removal because we do not want any of the
	// angular state of this element to be disposed.
	this.calendarPane.parentNode.removeChild(this.calendarPane);}};/**
	   * Open the floating calendar pane.
	   * @param {Event} event
	   */DatePickerCtrl.prototype.openCalendarPane=function(event){if(!this.isCalendarOpen&&!this.isDisabled&&!this.inputFocusedOnWindowBlur){this.isCalendarOpen=this.isOpen=true;this.calendarPaneOpenedFrom=event.target;// Because the calendar pane is attached directly to the body, it is possible that the
	// rest of the component (input, etc) is in a different scrolling container, such as
	// an md-content. This means that, if the container is scrolled, the pane would remain
	// stationary. To remedy this, we disable scrolling while the calendar pane is open, which
	// also matches the native behavior for things like `<select>` on Mac and Windows.
	this.$mdUtil.disableScrollAround(this.calendarPane);this.attachCalendarPane();this.focusCalendar();this.evalAttr('ngFocus');// Attach click listener inside of a timeout because, if this open call was triggered by a
	// click, we don't want it to be immediately propogated up to the body and handled.
	var self=this;this.$mdUtil.nextTick(function(){// Use 'touchstart` in addition to click in order to work on iOS Safari, where click
	// events aren't propogated under most circumstances.
	// See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	self.documentElement.on('click touchstart',self.bodyClickHandler);},false);window.addEventListener(this.windowEventName,this.windowEventHandler);}};/** Close the floating calendar pane. */DatePickerCtrl.prototype.closeCalendarPane=function(){if(this.isCalendarOpen){var self=this;self.detachCalendarPane();self.ngModelCtrl.$setTouched();self.evalAttr('ngBlur');self.documentElement.off('click touchstart',self.bodyClickHandler);window.removeEventListener(self.windowEventName,self.windowEventHandler);self.calendarPaneOpenedFrom.focus();self.calendarPaneOpenedFrom=null;if(self.openOnFocus){// Ensures that all focus events have fired before resetting
	// the calendar. Prevents the calendar from reopening immediately
	// in IE when md-open-on-focus is set. Also it needs to trigger
	// a digest, in order to prevent issues where the calendar wasn't
	// showing up on the next open.
	self.$mdUtil.nextTick(reset);}else{reset();}}function reset(){self.isCalendarOpen=self.isOpen=false;}};/** Gets the controller instance for the calendar in the floating pane. */DatePickerCtrl.prototype.getCalendarCtrl=function(){return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');};/** Focus the calendar in the floating pane. */DatePickerCtrl.prototype.focusCalendar=function(){// Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
	var self=this;this.$mdUtil.nextTick(function(){self.getCalendarCtrl().focus();},false);};/**
	   * Sets whether the input is currently focused.
	   * @param {boolean} isFocused
	   */DatePickerCtrl.prototype.setFocused=function(isFocused){if(!isFocused){this.ngModelCtrl.$setTouched();}// The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
	// because they also get called when the calendar is opened/closed.
	if(!this.openOnFocus){this.evalAttr(isFocused?'ngFocus':'ngBlur');}this.isFocused=isFocused;};/**
	   * Handles a click on the document body when the floating calendar pane is open.
	   * Closes the floating calendar pane if the click is not inside of it.
	   * @param {MouseEvent} event
	   */DatePickerCtrl.prototype.handleBodyClick=function(event){if(this.isCalendarOpen){var isInCalendar=this.$mdUtil.getClosest(event.target,'md-calendar');if(!isInCalendar){this.closeCalendarPane();}this.$scope.$digest();}};/**
	   * Handles the event when the user navigates away from the current tab. Keeps track of
	   * whether the input was focused when the event happened, in order to prevent the calendar
	   * from re-opening.
	   */DatePickerCtrl.prototype.handleWindowBlur=function(){this.inputFocusedOnWindowBlur=document.activeElement===this.inputElement;};/**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   */DatePickerCtrl.prototype.evalAttr=function(attr){if(this.$attrs[attr]){this.$scope.$parent.$eval(this.$attrs[attr]);}};/**
	   * Sets the ng-model value by first converting the date object into a strng. Converting it
	   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
	   * the value into a Date object afterwards, before setting it on the model.
	   * @param {Date=} value Date to be set as the model value.
	   */DatePickerCtrl.prototype.setModelValue=function(value){var timezone=this.$mdUtil.getModelOption(this.ngModelCtrl,'timezone');this.ngModelCtrl.$setViewValue(this.ngDateFilter(value,'yyyy-MM-dd',timezone));};/**
	   * Updates the datepicker when a model change occurred externally.
	   * @param {Date=} value Value that was set to the model.
	   */DatePickerCtrl.prototype.onExternalChange=function(value){var timezone=this.$mdUtil.getModelOption(this.ngModelCtrl,'timezone');this.date=value;this.inputElement.value=this.locale.formatDate(value,timezone);this.mdInputContainer&&this.mdInputContainer.setHasValue(!!value);this.resizeInputElement();this.updateErrorState();};})();})();(function(){"use strict";angular.module('material.components.icon').directive('mdIcon',['$mdIcon','$mdTheming','$mdAria','$sce',mdIconDirective]);/**
	 * @ngdoc directive
	 * @name mdIcon
	 * @module material.components.icon
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
	 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
	 *
	 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
	 * inside a `md-button` to add hover and click features.
	 *
	 * ### Icon fonts
	 * Icon fonts are a technique in which you use a font where the glyphs in the font are
	 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
	 * single HTTP request, simple scaling, easy color changing, and more.
	 *
	 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
	 * by name rather than character code.
	 *
	 * ### SVG
	 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
	 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
	 * animation.
	 *
	 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
	 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
	 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
	 * reference it by name instead of URL throughout your templates.
	 *
	 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
	 * your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can
	 * also be given a name, which acts as a namespace for individual icons, so you can reference them
	 * like `"social:cake"`.
	 *
	 * When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be
	 * easily loaded and used. When using font-icons, developers must follow three (3) simple steps:
	 *
	 * <ol>
	 * <li>Load the font library. e.g.<br/>
	 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
	 *    rel="stylesheet">`
	 * </li>
	 * <li>
	 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
	 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
	 *   none is specified.
	 * </li>
	 * <li> Use any of the following templates: <br/>
	 *   <ul>
	 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
	 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
	 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
	 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
	 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
	 *   </ul>
	 * </li>
	 * </ol>
	 *
	 * Full details for these steps can be found:
	 *
	 * <ul>
	 * <li>http://google.github.io/material-design-icons/</li>
	 * <li>http://google.github.io/material-design-icons/#icon-font-for-the-web</li>
	 * </ul>
	 *
	 * The Material Design icon style <code>.material-icons</code> and the icon font references are published in
	 * Material Design Icons:
	 *
	 * <ul>
	 * <li>https://design.google.com/icons/</li>
	 * <li>https://design.google.com/icons/#ic_accessibility</li>
	 * </ul>
	 *
	 * ### Localization
	 *
	 * Because an `md-icon` element's text content is not intended to be translated, it is recommended to declare the text
	 * content for an `md-icon` element in its start tag. Instead of using the HTML text content, consider using `ng-bind`
	 * with a scope variable or literal string.
	 *
	 * Examples:
	 *
	 * <ul>
	 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
	 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
	 * </ul>
	 *
	 * <h2 id="material_design_icons">Material Design Icons</h2>
	 * Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and
	 * determine its textual name and character reference code. Click on any icon to see the slide-up information
	 * panel with details regarding a SVG download or information on the font-icon usage.
	 *
	 * <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">
	 * <img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png"
	 *      aria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%">
	 * </a>
	 *
	 * <span class="image_caption">
	 *  Click on the image above to link to the
	 *  <a href="https://design.google.com/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.
	 * </span>
	 *
	 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
	 * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
	 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
	 * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
	 * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
	 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
	 *     external SVG.
	 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
	 *     interpolated strings or expressions may also be used. Specific set names can be used with
	 *     the syntax `<set name>:<icon name>`.<br/><br/>
	 * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
	 * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 *
	 * @usage
	 * When using SVGs:
	 * <hljs lang="html">
	 *
	 *  <!-- Icon ID; may contain optional icon set prefix; icons must registered using $mdIconProvider -->
	 *  <md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
	 *
	 *  <!-- Icon urls; may be preloaded in templateCache -->
	 *  <md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
	 *  <md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
	 *
	 * </hljs>
	 *
	 * Use the <code>$mdIconProvider</code> to configure your application with
	 * svg iconsets.
	 *
	 * <hljs lang="js">
	 *  angular.module('appSvgIconSets', ['ngMaterial'])
	 *    .controller('DemoCtrl', function($scope) {})
	 *    .config(function($mdIconProvider) {
	 *      $mdIconProvider
	 *         .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
	 *         .defaultIconSet('img/icons/sets/core-icons.svg', 24);
	 *     });
	 * </hljs>
	 *
	 *
	 * When using Font Icons with classnames:
	 * <hljs lang="html">
	 *
	 *  <md-icon md-font-icon="android" aria-label="android" ></md-icon>
	 *  <md-icon class="icon_home"      aria-label="Home"    ></md-icon>
	 *
	 * </hljs>
	 *
	 * When using Material Font Icons with ligatures:
	 * <hljs lang="html">
	 *  <!--
	 *  For Material Design Icons
	 *  The class '.material-icons' is auto-added if a style has NOT been specified
	 *  since `material-icons` is the default fontset. So your markup:
	 *  -->
	 *  <md-icon> face </md-icon>
	 *  <!-- becomes this at runtime: -->
	 *  <md-icon md-font-set="material-icons"> face </md-icon>
	 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
	 *  <md-icon> &#xE87C; </md-icon>
	 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
	 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
	 * </hljs>
	 *
	 * When using other Font-Icon libraries:
	 *
	 * <hljs lang="js">
	 *  // Specify a font-icon style alias
	 *  angular.config(function($mdIconProvider) {
	 *    $mdIconProvider.fontSet('md', 'material-icons');
	 *  });
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *  <md-icon md-font-set="md">favorite</md-icon>
	 * </hljs>
	 *
	 */function mdIconDirective($mdIcon,$mdTheming,$mdAria,$sce){return{restrict:'E',link:postLink};/**
	   * Directive postLink
	   * Supports embedded SVGs, font-icons, & external SVGs
	   */function postLink(scope,element,attr){$mdTheming(element);var lastFontIcon=attr.mdFontIcon;var lastFontSet=$mdIcon.fontSet(attr.mdFontSet);prepareForFontIcon();attr.$observe('mdFontIcon',fontIconChanged);attr.$observe('mdFontSet',fontIconChanged);// Keep track of the content of the svg src so we can compare against it later to see if the
	// attribute is static (and thus safe).
	var originalSvgSrc=element[0].getAttribute(attr.$attr.mdSvgSrc);// If using a font-icon, then the textual name of the icon itself
	// provides the aria-label.
	var attrName=attr.$normalize(attr.$attr.mdSvgIcon||attr.$attr.mdSvgSrc||'');/* Provide a default accessibility role of img */if(!attr.role){$mdAria.expect(element,'role','img');/* manually update attr variable */attr.role='img';}/* Don't process ARIA if already valid */if(attr.role==="img"&&!attr.ariaHidden&&!$mdAria.hasAriaLabel(element)){var iconName;if(attr.alt){/* Use alt text by default if available */$mdAria.expect(element,'aria-label',attr.alt);}else if($mdAria.parentHasAriaLabel(element,2)){/* Parent has ARIA so we will assume it will describe the image */$mdAria.expect(element,'aria-hidden','true');}else if(iconName=attr.mdFontIcon||attr.mdSvgIcon||element.text()){/* Use icon name as aria-label */$mdAria.expect(element,'aria-label',iconName);}else{/* No label found */$mdAria.expect(element,'aria-hidden','true');}}if(attrName){// Use either pre-configured SVG or URL source, respectively.
	attr.$observe(attrName,function(attrVal){element.empty();if(attrVal){$mdIcon(attrVal).then(function(svg){element.empty();element.append(svg);});}});}function prepareForFontIcon(){if(!attr.mdSvgIcon&&!attr.mdSvgSrc){if(attr.mdFontIcon){element.addClass('md-font '+attr.mdFontIcon);}element.addClass(lastFontSet);}}function fontIconChanged(){if(!attr.mdSvgIcon&&!attr.mdSvgSrc){if(attr.mdFontIcon){element.removeClass(lastFontIcon);element.addClass(attr.mdFontIcon);lastFontIcon=attr.mdFontIcon;}var fontSet=$mdIcon.fontSet(attr.mdFontSet);if(lastFontSet!==fontSet){element.removeClass(lastFontSet);element.addClass(fontSet);lastFontSet=fontSet;}}}}}})();(function(){"use strict";MdIconService.$inject=["config","$templateRequest","$q","$log","$mdUtil","$sce"];angular.module('material.components.icon').constant('$$mdSvgRegistry',{'mdTabsArrow':'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=','mdClose':'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=','mdCancel':'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==','mdMenu':'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+','mdToggleArrow':'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==','mdCalendar':'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==','mdChecked':'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'}).provider('$mdIcon',MdIconProvider);/**
	 * @ngdoc service
	 * @name $mdIconProvider
	 * @module material.components.icon
	 *
	 * @description
	 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
	 * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
	 * directives are compiled.
	 *
	 * If using font-icons, the developer is responsible for loading the fonts.
	 *
	 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
	 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
	 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
	 * that URL is used to on-demand load and parse the SVG dynamically.
	 *
	 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
	 * This means, when loading icons from an external URL, you have to trust the URL in the `$sceDelegateProvider`.
	 *
	 * <hljs lang="js">
	 *   app.config(function($sceDelegateProvider) {
	 *     $sceDelegateProvider.resourceUrlWhitelist([
	 *       // Adding 'self' to the whitelist, will allow requests from the current origin.
	 *       'self',
	 *       // Using double asterisks here, will allow all URLs to load.
	 *       // We recommend to only specify the given domain you want to allow.
	 *       '**'
	 *     ]);
	 *   });
	 * </hljs>
	 *
	 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
	 *
	 * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
	 *  In such cases you are not able to use the icon's ligature name - Like so:
	 *
	 *  <hljs lang="html">
	 *    <md-icon md-font-set="fa">fa-bell</md-icon>
	 *  </hljs>
	 *
	 * You should instead use the given unicode, instead of the ligature name.
	 *
	 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
	 *  ```html
	 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
	 *  ```
	 *
	 * All unicode ligatures are prefixed with the `&#x` string.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
	    *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
	 * **startup** process (shown below):
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Register a default set of SVG icon definitions
	    *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
	    *
	    *   })
	 *   .run(function($templateRequest){
	    *
	    *     // Pre-fetch icons sources by URL and cache in the $templateCache...
	    *     // subsequent $templateRequest calls will look there first.
	    *
	    *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
	    *
	    *     angular.forEach(urls, function(url) {
	    *       $templateRequest(url);
	    *     });
	    *
	    *   });
	 *
	 * </hljs>
	 *
	 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdIconProvider#icon
	 *
	 * @description
	 * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
	 * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
	 *
	 * @param {string} id Icon name/id used to register the icon
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
	 * It is ignored for icons with an existing viewBox. Default size is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdIconProvider#iconSet
	 *
	 * @description
	 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
	 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
	 * `$mdIcon(<icon set name>:<icon name>)`
	 *
	 * @param {string} id Icon name/id used to register the iconset
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
	    *   });
	 * </hljs>
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultIconSet
	 *
	 * @description
	 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
	 * subsequent lookups of icons will failover to search this 'default' icon set.
	 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
	 *
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
	    *   });
	 * </hljs>
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultFontSet
	 *
	 * @description
	 * When using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and automatically
	 * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
	 * class style that should be applied to the `<md-icon>`.
	 *
	 * Configuring the default means that the attributes
	 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
	 * `<md-icon>` markup. For example:
	 *
	 *  `<md-icon> face </md-icon>`
	 *  will render as
	 *  `<span class="material-icons"> face </span>`, and
	 *
	 *  `<md-icon md-font-set="fa"> face </md-icon>`
	 *  will render as
	 *  `<span class="fa"> face </span>`
	 *
	 * @param {string} name of the font-library style that should be applied to the md-icon DOM element
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     $mdIconProvider.defaultFontSet( 'fa' );
	   *   });
	 * </hljs>
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdIconProvider#fontSet
	 *
	 * @description
	 * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
	 * attribute. If the fonset className is really long, your markup may become cluttered... an easy
	 * solution is to define an `alias` for your fontset:
	 *
	 * @param {string} alias of the specified fontset.
	 * @param {string} className of the fontset.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     // In this case, we set an alias for the `material-icons` fontset.
	   *     $mdIconProvider.fontSet('md', 'material-icons');
	   *   });
	 * </hljs>
	 *
	 *//**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultViewBoxSize
	 *
	 * @description
	 * While `<md-icon />` markup can also be style with sizing CSS, this method configures
	 * the default width **and** height used for all icons; unless overridden by specific CSS.
	 * The default sizing is (24px, 24px).
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
	 * All icons in a set should be the same size. The default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
	    *   });
	 * </hljs>
	 *
	 */var config={defaultViewBoxSize:24,defaultFontSet:'material-icons',fontSets:[]};function MdIconProvider(){}MdIconProvider.prototype={icon:function icon(id,url,viewBoxSize){if(id.indexOf(':')==-1)id='$default:'+id;config[id]=new ConfigurationItem(url,viewBoxSize);return this;},iconSet:function iconSet(id,url,viewBoxSize){config[id]=new ConfigurationItem(url,viewBoxSize);return this;},defaultIconSet:function defaultIconSet(url,viewBoxSize){var setName='$default';if(!config[setName]){config[setName]=new ConfigurationItem(url,viewBoxSize);}config[setName].viewBoxSize=viewBoxSize||config.defaultViewBoxSize;return this;},defaultViewBoxSize:function defaultViewBoxSize(viewBoxSize){config.defaultViewBoxSize=viewBoxSize;return this;},/**
	   * Register an alias name associated with a font-icon library style ;
	   */fontSet:function fontSet(alias,className){config.fontSets.push({alias:alias,fontSet:className||alias});return this;},/**
	   * Specify a default style name associated with a font-icon library
	   * fallback to Material Icons.
	   *
	   */defaultFontSet:function defaultFontSet(className){config.defaultFontSet=!className?'':className;return this;},defaultIconSize:function defaultIconSize(iconSize){config.defaultIconSize=iconSize;return this;},$get:['$templateRequest','$q','$log','$mdUtil','$sce',function($templateRequest,$q,$log,$mdUtil,$sce){return MdIconService(config,$templateRequest,$q,$log,$mdUtil,$sce);}]};/**
	 *  Configuration item stored in the Icon registry; used for lookups
	 *  to load if not already cached in the `loaded` cache
	 */function ConfigurationItem(url,viewBoxSize){this.url=url;this.viewBoxSize=viewBoxSize||config.defaultViewBoxSize;}/**
	 * @ngdoc service
	 * @name $mdIcon
	 * @module material.components.icon
	 *
	 * @description
	 * The `$mdIcon` service is a function used to lookup SVG icons.
	 *
	 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
	 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
	 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
	 *
	 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
	 * using the `$mdIconProvider`.
	 *
	 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
	 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
	 * will get rejected.
	 *
	 * @usage
	 * <hljs lang="js">
	 * function SomeDirective($mdIcon) {
	  *
	  *   // See if the icon has already been loaded, if not
	  *   // then lookup the icon from the registry cache, load and cache
	  *   // it for future requests.
	  *   // NOTE: ID queries require configuration with $mdIconProvider
	  *
	  *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
	  *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
	  *
	  *   // Load and cache the external SVG using a URL
	  *
	  *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
	  *     element.append(iconEl);
	  *   });
	  * };
	 * </hljs>
	 *
	 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, loaded,
	 *   and instantiate SVG DOM elements.
	 *//* @ngInject */function MdIconService(config,$templateRequest,$q,$log,$mdUtil,$sce){var iconCache={};var svgCache={};var urlRegex=/[-\w@:%+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%+.~#?&//=]*)?/i;var dataUrlRegex=/^data:image\/svg\+xml[\s*;\w\-=]*?(base64)?,(.*)$/i;Icon.prototype={clone:cloneSVG,prepare:prepareAndStyle};getIcon.fontSet=findRegisteredFontSet;// Publish service...
	return getIcon;/**
	   * Actual $mdIcon service is essentially a lookup function
	   */function getIcon(id){id=id||'';// If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
	// over a URL string. If the value is not trusted, this will intentionally throw an error
	// because the user is attempted to use an unsafe URL, potentially opening themselves up
	// to an XSS attack.
	if(!angular.isString(id)){id=$sce.getTrustedUrl(id);}// If already loaded and cached, use a clone of the cached icon.
	// Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.
	if(iconCache[id]){return $q.when(transformClone(iconCache[id]));}if(urlRegex.test(id)||dataUrlRegex.test(id)){return loadByURL(id).then(cacheIcon(id));}if(id.indexOf(':')==-1){id='$default:'+id;}var load=config[id]?loadByID:loadFromIconSet;return load(id).then(cacheIcon(id));}/**
	   * Lookup registered fontSet style using its alias...
	   * If not found,
	   */function findRegisteredFontSet(alias){var useDefault=angular.isUndefined(alias)||!(alias&&alias.length);if(useDefault)return config.defaultFontSet;var result=alias;angular.forEach(config.fontSets,function(it){if(it.alias==alias)result=it.fontSet||result;});return result;}function transformClone(cacheElement){var clone=cacheElement.clone();var cacheSuffix='_cache'+$mdUtil.nextUid();// We need to modify for each cached icon the id attributes.
	// This is needed because SVG id's are treated as normal DOM ids
	// and should not have a duplicated id.
	if(clone.id)clone.id+=cacheSuffix;angular.forEach(clone.querySelectorAll('[id]'),function(item){item.id+=cacheSuffix;});return clone;}/**
	   * Prepare and cache the loaded icon for the specified `id`
	   */function cacheIcon(id){return function updateCache(icon){iconCache[id]=isIcon(icon)?icon:new Icon(icon,config[id]);return iconCache[id].clone();};}/**
	   * Lookup the configuration in the registry, if !registered throw an error
	   * otherwise load the icon [on-demand] using the registered URL.
	   *
	   */function loadByID(id){var iconConfig=config[id];return loadByURL(iconConfig.url).then(function(icon){return new Icon(icon,iconConfig);});}/**
	   *    Loads the file as XML and uses querySelector( <id> ) to find
	   *    the desired node...
	   */function loadFromIconSet(id){var setName=id.substring(0,id.lastIndexOf(':'))||'$default';var iconSetConfig=config[setName];return!iconSetConfig?announceIdNotFound(id):loadByURL(iconSetConfig.url).then(extractFromSet);function extractFromSet(set){var iconName=id.slice(id.lastIndexOf(':')+1);var icon=set.querySelector('#'+iconName);return icon?new Icon(icon,iconSetConfig):announceIdNotFound(id);}function announceIdNotFound(id){var msg='icon '+id+' not found';$log.warn(msg);return $q.reject(msg||id);}}/**
	   * Load the icon by URL (may use the $templateCache).
	   * Extract the data for later conversion to Icon
	   */function loadByURL(url){/* Load the icon from embedded data URL. */function loadByDataUrl(url){var results=dataUrlRegex.exec(url);var isBase64=/base64/i.test(url);var data=isBase64?window.atob(results[2]):results[2];return $q.when(angular.element(data)[0]);}/* Load the icon by URL using HTTP. */function loadByHttpUrl(url){return $q(function(resolve,reject){// Catch HTTP or generic errors not related to incorrect icon IDs.
	var announceAndReject=function announceAndReject(err){var msg=angular.isString(err)?err:err.message||err.data||err.statusText;$log.warn(msg);reject(err);},extractSvg=function extractSvg(response){if(!svgCache[url]){svgCache[url]=angular.element('<div>').append(response)[0].querySelector('svg');}resolve(svgCache[url]);};$templateRequest(url,true).then(extractSvg,announceAndReject);});}return dataUrlRegex.test(url)?loadByDataUrl(url):loadByHttpUrl(url);}/**
	   * Check target signature to see if it is an Icon instance.
	   */function isIcon(target){return angular.isDefined(target.element)&&angular.isDefined(target.config);}/**
	   *  Define the Icon class
	   */function Icon(el,config){if(el&&el.tagName!='svg'){el=angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];}// Inject the namespace if not available...
	if(!el.getAttribute('xmlns')){el.setAttribute('xmlns',"http://www.w3.org/2000/svg");}this.element=el;this.config=config;this.prepare();}/**
	   *  Prepare the DOM element that will be cached in the
	   *  loaded iconCache store.
	   */function prepareAndStyle(){var viewBoxSize=this.config?this.config.viewBoxSize:config.defaultViewBoxSize;angular.forEach({'fit':'','height':'100%','width':'100%','preserveAspectRatio':'xMidYMid meet','viewBox':this.element.getAttribute('viewBox')||'0 0 '+viewBoxSize+' '+viewBoxSize,'focusable':false// Disable IE11s default behavior to make SVGs focusable
	},function(val,attr){this.element.setAttribute(attr,val);},this);}/**
	   * Clone the Icon DOM element.
	   */function cloneSVG(){// If the element or any of its children have a style attribute, then a CSP policy without
	// 'unsafe-inline' in the style-src directive, will result in a violation.
	return this.element.cloneNode(true);}}})();(function(){"use strict";MenuController.$inject=["$mdMenu","$attrs","$element","$scope","$mdUtil","$timeout","$rootScope","$q","$log"];angular.module('material.components.menu').controller('mdMenuCtrl',MenuController);/**
	 * @ngInject
	 */function MenuController($mdMenu,$attrs,$element,$scope,$mdUtil,$timeout,$rootScope,$q,$log){var prefixer=$mdUtil.prefixer();var menuContainer;var self=this;var triggerElement;this.nestLevel=parseInt($attrs.mdNestLevel,10)||0;/**
	   * Called by our linking fn to provide access to the menu-content
	   * element removed during link
	   */this.init=function init(setMenuContainer,opts){opts=opts||{};menuContainer=setMenuContainer;// Default element for ARIA attributes has the ngClick or ngMouseenter expression
	triggerElement=$element[0].querySelector(prefixer.buildSelector(['ng-click','ng-mouseenter']));triggerElement.setAttribute('aria-expanded','false');this.isInMenuBar=opts.isInMenuBar;this.nestedMenus=$mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));menuContainer.on('$mdInterimElementRemove',function(){self.isOpen=false;$mdUtil.nextTick(function(){self.onIsOpenChanged(self.isOpen);});});$mdUtil.nextTick(function(){self.onIsOpenChanged(self.isOpen);});var menuContainerId='menu_container_'+$mdUtil.nextUid();menuContainer.attr('id',menuContainerId);angular.element(triggerElement).attr({'aria-owns':menuContainerId,'aria-haspopup':'true'});$scope.$on('$destroy',angular.bind(this,function(){this.disableHoverListener();$mdMenu.destroy();}));menuContainer.on('$destroy',function(){$mdMenu.destroy();});};var openMenuTimeout,menuItems,deregisterScopeListeners=[];this.enableHoverListener=function(){deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen',function(event,el){if(menuContainer[0].contains(el[0])){self.currentlyOpenMenu=el.controller('mdMenu');self.isAlreadyOpening=false;self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));}}));deregisterScopeListeners.push($rootScope.$on('$mdMenuClose',function(event,el){if(menuContainer[0].contains(el[0])){self.currentlyOpenMenu=undefined;}}));menuItems=angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));menuItems.on('mouseenter',self.handleMenuItemHover);menuItems.on('mouseleave',self.handleMenuItemMouseLeave);};this.disableHoverListener=function(){while(deregisterScopeListeners.length){deregisterScopeListeners.shift()();}menuItems&&menuItems.off('mouseenter',self.handleMenuItemHover);menuItems&&menuItems.off('mouseleave',self.handleMenuItemMouseLeave);};this.handleMenuItemHover=function(event){if(self.isAlreadyOpening)return;var nestedMenu=event.target.querySelector('md-menu')||$mdUtil.getClosest(event.target,'MD-MENU');openMenuTimeout=$timeout(function(){if(nestedMenu){nestedMenu=angular.element(nestedMenu).controller('mdMenu');}if(self.currentlyOpenMenu&&self.currentlyOpenMenu!=nestedMenu){var closeTo=self.nestLevel+1;self.currentlyOpenMenu.close(true,{closeTo:closeTo});self.isAlreadyOpening=!!nestedMenu;nestedMenu&&nestedMenu.open();}else if(nestedMenu&&!nestedMenu.isOpen&&nestedMenu.open){self.isAlreadyOpening=!!nestedMenu;nestedMenu&&nestedMenu.open();}},nestedMenu?100:250);var focusableTarget=event.currentTarget.querySelector('.md-button:not([disabled])');focusableTarget&&focusableTarget.focus();};this.handleMenuItemMouseLeave=function(){if(openMenuTimeout){$timeout.cancel(openMenuTimeout);openMenuTimeout=undefined;}};/**
	   * Uses the $mdMenu interim element service to open the menu contents
	   */this.open=function openMenu(ev){ev&&ev.stopPropagation();ev&&ev.preventDefault();if(self.isOpen)return;self.enableHoverListener();self.isOpen=true;$mdUtil.nextTick(function(){self.onIsOpenChanged(self.isOpen);});triggerElement=triggerElement||(ev?ev.target:$element[0]);triggerElement.setAttribute('aria-expanded','true');$scope.$emit('$mdMenuOpen',$element);$mdMenu.show({scope:$scope,mdMenuCtrl:self,nestLevel:self.nestLevel,element:menuContainer,target:triggerElement,preserveElement:true,parent:'body'}).finally(function(){triggerElement.setAttribute('aria-expanded','false');self.disableHoverListener();});};this.onIsOpenChanged=function(isOpen){if(isOpen){menuContainer.attr('aria-hidden','false');$element[0].classList.add('md-open');angular.forEach(self.nestedMenus,function(el){el.classList.remove('md-open');});}else{menuContainer.attr('aria-hidden','true');$element[0].classList.remove('md-open');}$scope.$mdMenuIsOpen=self.isOpen;};this.focusMenuContainer=function focusMenuContainer(){var focusTarget=menuContainer[0].querySelector(prefixer.buildSelector(['md-menu-focus-target','md-autofocus']));if(!focusTarget)focusTarget=menuContainer[0].querySelector('.md-button:not([disabled])');focusTarget.focus();};this.registerContainerProxy=function registerContainerProxy(handler){this.containerProxy=handler;};this.triggerContainerProxy=function triggerContainerProxy(ev){this.containerProxy&&this.containerProxy(ev);};this.destroy=function(){return self.isOpen?$mdMenu.destroy():$q.when(false);};// Use the $mdMenu interim element service to close the menu contents
	this.close=function closeMenu(skipFocus,closeOpts){if(!self.isOpen)return;self.isOpen=false;$mdUtil.nextTick(function(){self.onIsOpenChanged(self.isOpen);});var eventDetails=angular.extend({},closeOpts,{skipFocus:skipFocus});$scope.$emit('$mdMenuClose',$element,eventDetails);$mdMenu.hide(null,closeOpts);if(!skipFocus){var el=self.restoreFocusTo||$element.find('button')[0];if(el instanceof angular.element)el=el[0];if(el)el.focus();}};/**
	   * Build a nice object out of our string attribute which specifies the
	   * target mode for left and top positioning
	   */this.positionMode=function positionMode(){var attachment=($attrs.mdPositionMode||'target').split(' ');// If attachment is a single item, duplicate it for our second value.
	// ie. 'target' -> 'target target'
	if(attachment.length==1){attachment.push(attachment[0]);}return{left:attachment[0],top:attachment[1]};};/**
	   * Build a nice object out of our string attribute which specifies
	   * the offset of top and left in pixels.
	   */this.offsets=function offsets(){var position=($attrs.mdOffset||'0 0').split(' ').map(parseFloat);if(position.length==2){return{left:position[0],top:position[1]};}else if(position.length==1){return{top:position[0],left:position[0]};}else{throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');}};// Functionality that is exposed in the view.
	$scope.$mdMenu={open:this.open,close:this.close};// Deprecated APIs
	$scope.$mdOpenMenu=angular.bind(this,function(){$log.warn('mdMenu: The $mdOpenMenu method is deprecated. Please use `$mdMenu.open`.');return this.open.apply(this,arguments);});}})();(function(){"use strict";/**
	 * @ngdoc directive
	 * @name mdMenu
	 * @module material.components.menu
	 * @restrict E
	 * @description
	 *
	 * Menus are elements that open when clicked. They are useful for displaying
	 * additional options within the context of an action.
	 *
	 * Every `md-menu` must specify exactly two child elements. The first element is what is
	 * left in the DOM and is used to open the menu. This element is called the trigger element.
	 * The trigger element's scope has access to `$mdMenu.open($event)`
	 * which it may call to open the menu. By passing $event as argument, the
	 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
	 * can be used to close the menu.
	 *
	 * The second element is the `md-menu-content` element which represents the
	 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
	 * but you can do custom content as well.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <!-- Trigger element is a md-button with an icon -->
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	
	 * ## Sizing Menus
	 *
	 * The width of the menu when it is open may be specified by specifying a `width`
	 * attribute on the `md-menu-content` element.
	 * See the [Material Design Spec](https://material.google.com/components/menus.html#menus-simple-menus)
	 * for more information.
	 *
	 *
	 * ## Aligning Menus
	 *
	 * When a menu opens, it is important that the content aligns with the trigger element.
	 * Failure to align menus can result in jarring experiences for users as content
	 * suddenly shifts. To help with this, `md-menu` provides serveral APIs to help
	 * with alignment.
	 *
	 * ### Target Mode
	 *
	 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
	 * designated child elements in both the trigger and the menu content.
	 *
	 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
	 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
	 * will be used as the origin element.
	 *
	 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
	 * `md-menu-item` to specify the node that it should try and align with.
	 *
	 * In this example code, we specify an icon to be our origin element, and an
	 * icon in our menu content to be our alignment target. This ensures that both
	 * icons are aligned when the menu opens.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
	 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item>
	 *      <md-button ng-click="doSomething()" aria-label="Do something">
	 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *        Do Something
	 *      </md-button>
	 *    </md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * Sometimes we want to specify alignment on the right side of an element, for example
	 * if we have a menu on the right side a toolbar, we want to right align our menu content.
	 *
	 * We can specify the origin by using the `md-position-mode` attribute on both
	 * the `x` and `y` axis. Right now only the `x-axis` has more than one option.
	 * You may specify the default mode of `target target` or
	 * `target-right target` to specify a right-oriented alignment target. See the
	 * position section of the demos for more examples.
	 *
	 * ### Menu Offsets
	 *
	 * It is sometimes unavoidable to need to have a deeper level of control for
	 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
	 * the `md-offset` attribute to allow pixel level specificty of adjusting the
	 * exact positioning.
	 *
	 * This offset is provided in the format of `x y` or `n` where `n` will be used
	 * in both the `x` and `y` axis.
	 *
	 * For example, to move a menu by `2px` down from the top, we can use:
	 * <hljs lang="html">
	 * <md-menu md-offset="0 2">
	 *   <!-- menu-content -->
	 * </md-menu>
	 * </hljs>
	 *
	 * ### Auto Focus
	 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
	 *
	 * But sometimes you would like to focus another specific menu item instead of the first.<br/>
	 * This can be done by applying the `md-autofocus` directive on the given element.
	 *
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-button md-autofocus ng-click="doSomething()">
	 *     Auto Focus
	 *   </md-button>
	 * </md-menu-item>
	 * </hljs>
	 *
	 *
	 * ### Preventing close
	 *
	 * Sometimes you would like to be able to click on a menu item without having the menu
	 * close. To do this, AngularJS Material exposes the `md-prevent-menu-close` attribute which
	 * can be added to a button inside a menu to stop the menu from automatically closing.
	 * You can then close the menu either by using `$mdMenu.close()` in the template,
	 * or programatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
	 *
	 * <hljs lang="html">
	 * <md-menu-content ng-mouseleave="$mdMenu.close()">
	 *   <md-menu-item>
	 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
	 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *       Do Something
	 *     </md-button>
	 *   </md-menu-item>
	 * </md-menu-content>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * @param {string} md-position-mode The position mode in the form of
	 *           `x`, `y`. Default value is `target`,`target`. Right now the `x` axis
	 *           also supports `target-right`.
	 * @param {string} md-offset An offset to apply to the dropdown after positioning
	 *           `x`, `y`. Default value is `0`,`0`.
	 *
	 */MenuDirective.$inject=["$mdUtil"];angular.module('material.components.menu').directive('mdMenu',MenuDirective);/**
	 * @ngInject
	 */function MenuDirective($mdUtil){var INVALID_PREFIX='Invalid HTML for md-menu: ';return{restrict:'E',require:['mdMenu','?^mdMenuBar'],controller:'mdMenuCtrl',// empty function to be built by link
	scope:true,compile:compile};function compile(templateElement){templateElement.addClass('md-menu');var triggerEl=templateElement.children()[0];var prefixer=$mdUtil.prefixer();if(!prefixer.hasAttribute(triggerEl,'ng-click')){triggerEl=triggerEl.querySelector(prefixer.buildSelector(['ng-click','ng-mouseenter']))||triggerEl;}var isButtonTrigger=triggerEl.nodeName==='MD-BUTTON'||triggerEl.nodeName==='BUTTON';if(triggerEl&&isButtonTrigger&&!triggerEl.hasAttribute('type')){triggerEl.setAttribute('type','button');}if(!triggerEl){throw Error(INVALID_PREFIX+'Expected the menu to have a trigger element.');}if(templateElement.children().length!==2){throw Error(INVALID_PREFIX+'Expected two children elements. The second element must have a `md-menu-content` element.');}// Default element for ARIA attributes has the ngClick or ngMouseenter expression
	triggerEl&&triggerEl.setAttribute('aria-haspopup','true');var nestedMenus=templateElement[0].querySelectorAll('md-menu');var nestingDepth=parseInt(templateElement[0].getAttribute('md-nest-level'),10)||0;if(nestedMenus){angular.forEach($mdUtil.nodesToArray(nestedMenus),function(menuEl){if(!menuEl.hasAttribute('md-position-mode')){menuEl.setAttribute('md-position-mode','cascade');}menuEl.classList.add('_md-nested-menu');menuEl.setAttribute('md-nest-level',nestingDepth+1);});}return link;}function link(scope,element,attr,ctrls){var mdMenuCtrl=ctrls[0];var isInMenuBar=!!ctrls[1];// Move everything into a md-menu-container and pass it to the controller
	var menuContainer=angular.element('<div class="_md md-open-menu-container md-whiteframe-z2"></div>');var menuContents=element.children()[1];element.addClass('_md');// private md component indicator for styling
	if(!menuContents.hasAttribute('role')){menuContents.setAttribute('role','menu');}menuContainer.append(menuContents);element.on('$destroy',function(){menuContainer.remove();});element.append(menuContainer);menuContainer[0].style.display='none';mdMenuCtrl.init(menuContainer,{isInMenuBar:isInMenuBar});}}})();(function(){"use strict";MenuProvider.$inject=["$$interimElementProvider"];angular.module('material.components.menu').provider('$mdMenu',MenuProvider);/*
	 * Interim element provider for the menu.
	 * Handles behavior for a menu while it is open, including:
	 *    - handling animating the menu opening/closing
	 *    - handling key/mouse events on the menu element
	 *    - handling enabling/disabling scroll while the menu is open
	 *    - handling redrawing during resizes and orientation changes
	 *
	 */function MenuProvider($$interimElementProvider){menuDefaultOptions.$inject=["$mdUtil","$mdTheming","$mdConstant","$document","$window","$q","$$rAF","$animateCss","$animate","$log"];var MENU_EDGE_MARGIN=8;return $$interimElementProvider('$mdMenu').setDefaults({methods:['target'],options:menuDefaultOptions});/* @ngInject */function menuDefaultOptions($mdUtil,$mdTheming,$mdConstant,$document,$window,$q,$$rAF,$animateCss,$animate,$log){var prefixer=$mdUtil.prefixer();var animator=$mdUtil.dom.animator;return{parent:'body',onShow:onShow,onRemove:onRemove,hasBackdrop:true,disableParentScroll:true,skipCompile:true,preserveScope:true,multiple:true,themable:true};/**
	     * Show modal backdrop element...
	     * @returns {function(): void} A function that removes this backdrop
	     */function showBackdrop(scope,element,options){if(options.nestLevel)return angular.noop;// If we are not within a dialog...
	if(options.disableParentScroll&&!$mdUtil.getClosest(options.target,'MD-DIALOG')){// !! DO this before creating the backdrop; since disableScrollAround()
	//    configures the scroll offset; which is used by mdBackDrop postLink()
	options.restoreScroll=$mdUtil.disableScrollAround(options.element,options.parent);}else{options.disableParentScroll=false;}if(options.hasBackdrop){options.backdrop=$mdUtil.createBackdrop(scope,"md-menu-backdrop md-click-catcher");$animate.enter(options.backdrop,$document[0].body);}/**
	       * Hide and destroys the backdrop created by showBackdrop()
	       */return function hideBackdrop(){if(options.backdrop)options.backdrop.remove();if(options.disableParentScroll)options.restoreScroll();};}/**
	     * Removing the menu element from the DOM and remove all associated event listeners
	     * and backdrop
	     */function onRemove(scope,element,opts){opts.cleanupInteraction();opts.cleanupBackdrop();opts.cleanupResizing();opts.hideBackdrop();// Before the menu is closing remove the clickable class.
	element.removeClass('md-clickable');// For navigation $destroy events, do a quick, non-animated removal,
	// but for normal closes (from clicks, etc) animate the removal
	return opts.$destroy===true?detachAndClean():animateRemoval().then(detachAndClean);/**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */function animateRemoval(){return $animateCss(element,{addClass:'md-leave'}).start();}/**
	       * Detach the element
	       */function detachAndClean(){element.removeClass('md-active');detachElement(element,opts);opts.alreadyOpen=false;}}/**
	     * Inserts and configures the staged Menu element into the DOM, positioning it,
	     * and wiring up various interaction events
	     */function onShow(scope,element,opts){sanitizeAndConfigure(opts);if(opts.menuContentEl[0]){// Inherit the theme from the target element.
	$mdTheming.inherit(opts.menuContentEl,opts.target);}else{$log.warn('$mdMenu: Menu elements should always contain a `md-menu-content` element,'+'otherwise interactivity features will not work properly.',element);}// Register various listeners to move menu on resize/orientation change
	opts.cleanupResizing=startRepositioningOnResize();opts.hideBackdrop=showBackdrop(scope,element,opts);// Return the promise for when our menu is done animating in
	return showMenu().then(function(response){opts.alreadyOpen=true;opts.cleanupInteraction=activateInteraction();opts.cleanupBackdrop=setupBackdrop();// Since the menu finished its animation, mark the menu as clickable.
	element.addClass('md-clickable');return response;});/**
	       * Place the menu into the DOM and call positioning related functions
	       */function showMenu(){opts.parent.append(element);element[0].style.display='';return $q(function(resolve){var position=calculateMenuPosition(element,opts);element.removeClass('md-leave');// Animate the menu scaling, and opacity [from its position origin (default == top-left)]
	// to normal scale.
	$animateCss(element,{addClass:'md-active',from:animator.toCss(position),to:animator.toCss({transform:''})}).start().then(resolve);});}/**
	       * Check for valid opts and set some sane defaults
	       */function sanitizeAndConfigure(){if(!opts.target){throw Error('$mdMenu.show() expected a target to animate from in options.target');}angular.extend(opts,{alreadyOpen:false,isRemoved:false,target:angular.element(opts.target),//make sure it's not a naked dom node
	parent:angular.element(opts.parent),menuContentEl:angular.element(element[0].querySelector('md-menu-content'))});}/**
	       * Configure various resize listeners for screen changes
	       */function startRepositioningOnResize(){var repositionMenu=function(target,options){return $$rAF.throttle(function(){if(opts.isRemoved)return;var position=calculateMenuPosition(target,options);target.css(animator.toCss(position));});}(element,opts);$window.addEventListener('resize',repositionMenu);$window.addEventListener('orientationchange',repositionMenu);return function stopRepositioningOnResize(){// Disable resizing handlers
	$window.removeEventListener('resize',repositionMenu);$window.removeEventListener('orientationchange',repositionMenu);};}/**
	       * Sets up the backdrop and listens for click elements.
	       * Once the backdrop will be clicked, the menu will automatically close.
	       * @returns {!Function} Function to remove the backdrop.
	       */function setupBackdrop(){if(!opts.backdrop)return angular.noop;opts.backdrop.on('click',onBackdropClick);return function(){opts.backdrop.off('click',onBackdropClick);};}/**
	       * Function to be called whenever the backdrop is clicked.
	       * @param {!MouseEvent} event
	       */function onBackdropClick(event){event.preventDefault();event.stopPropagation();scope.$apply(function(){opts.mdMenuCtrl.close(true,{closeAll:true});});}/**
	       * Activate interaction on the menu. Resolves the focus target and closes the menu on
	       * escape or option click.
	       * @returns {!Function} Function to deactivate the interaction listeners.
	       */function activateInteraction(){if(!opts.menuContentEl[0])return angular.noop;// Wire up keyboard listeners.
	// - Close on escape,
	// - focus next item on down arrow,
	// - focus prev item on up
	opts.menuContentEl.on('keydown',onMenuKeyDown);opts.menuContentEl[0].addEventListener('click',captureClickListener,true);// kick off initial focus in the menu on the first enabled element
	var focusTarget=opts.menuContentEl[0].querySelector(prefixer.buildSelector(['md-menu-focus-target','md-autofocus']));if(!focusTarget){var childrenLen=opts.menuContentEl[0].children.length;for(var childIndex=0;childIndex<childrenLen;childIndex++){var child=opts.menuContentEl[0].children[childIndex];focusTarget=child.querySelector('.md-button:not([disabled])');if(focusTarget){break;}if(child.firstElementChild&&!child.firstElementChild.disabled){focusTarget=child.firstElementChild;break;}}}focusTarget&&focusTarget.focus();return function cleanupInteraction(){opts.menuContentEl.off('keydown',onMenuKeyDown);opts.menuContentEl[0].removeEventListener('click',captureClickListener,true);};// ************************************
	// internal functions
	// ************************************
	function onMenuKeyDown(ev){var handled;switch(ev.keyCode){case $mdConstant.KEY_CODE.ESCAPE:opts.mdMenuCtrl.close(false,{closeAll:true});handled=true;break;case $mdConstant.KEY_CODE.TAB:opts.mdMenuCtrl.close(false,{closeAll:true});// Don't prevent default or stop propagation on this event as we want tab
	// to move the focus to the next focusable element on the page.
	handled=false;break;case $mdConstant.KEY_CODE.UP_ARROW:if(!focusMenuItem(ev,opts.menuContentEl,opts,-1)&&!opts.nestLevel){opts.mdMenuCtrl.triggerContainerProxy(ev);}handled=true;break;case $mdConstant.KEY_CODE.DOWN_ARROW:if(!focusMenuItem(ev,opts.menuContentEl,opts,1)&&!opts.nestLevel){opts.mdMenuCtrl.triggerContainerProxy(ev);}handled=true;break;case $mdConstant.KEY_CODE.LEFT_ARROW:if(opts.nestLevel){opts.mdMenuCtrl.close();}else{opts.mdMenuCtrl.triggerContainerProxy(ev);}handled=true;break;case $mdConstant.KEY_CODE.RIGHT_ARROW:var parentMenu=$mdUtil.getClosest(ev.target,'MD-MENU');if(parentMenu&&parentMenu!=opts.parent[0]){ev.target.click();}else{opts.mdMenuCtrl.triggerContainerProxy(ev);}handled=true;break;}if(handled){ev.preventDefault();ev.stopImmediatePropagation();}}function onBackdropClick(e){e.preventDefault();e.stopPropagation();scope.$apply(function(){opts.mdMenuCtrl.close(true,{closeAll:true});});}// Close menu on menu item click, if said menu-item is not disabled
	function captureClickListener(e){var target=e.target;// Traverse up the event until we get to the menuContentEl to see if
	// there is an ng-click and that the ng-click is not disabled
	do{if(target==opts.menuContentEl[0])return;if((hasAnyAttribute(target,['ng-click','ng-href','ui-sref'])||target.nodeName=='BUTTON'||target.nodeName=='MD-BUTTON')&&!hasAnyAttribute(target,['md-prevent-menu-close'])){var closestMenu=$mdUtil.getClosest(target,'MD-MENU');if(!target.hasAttribute('disabled')&&(!closestMenu||closestMenu==opts.parent[0])){close();}break;}}while(target=target.parentNode);function close(){scope.$apply(function(){opts.mdMenuCtrl.close(true,{closeAll:true});});}function hasAnyAttribute(target,attrs){if(!target)return false;for(var i=0,attr;attr=attrs[i];++i){if(prefixer.hasAttribute(target,attr)){return true;}}return false;}}}}/**
	     * Takes a keypress event and focuses the next/previous menu
	     * item from the emitting element
	     * @param {event} e - The origin keypress event
	     * @param {angular.element} menuEl - The menu element
	     * @param {object} opts - The interim element options for the mdMenu
	     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
	     */function focusMenuItem(e,menuEl,opts,direction){var currentItem=$mdUtil.getClosest(e.target,'MD-MENU-ITEM');var items=$mdUtil.nodesToArray(menuEl[0].children);var currentIndex=items.indexOf(currentItem);// Traverse through our elements in the specified direction (+/-1) and try to
	// focus them until we find one that accepts focus
	var didFocus;for(var i=currentIndex+direction;i>=0&&i<items.length;i=i+direction){var focusTarget=items[i].querySelector('.md-button');didFocus=attemptFocus(focusTarget);if(didFocus){break;}}return didFocus;}/**
	     * Attempts to focus an element. Checks whether that element is the currently
	     * focused element after attempting.
	     * @param {HTMLElement} el - the element to attempt focus on
	     * @returns {boolean} - whether the element was successfully focused
	     */function attemptFocus(el){if(el&&el.getAttribute('tabindex')!=-1){el.focus();return $document[0].activeElement==el;}}/**
	     * Use browser to remove this element without triggering a $destroy event
	     */function detachElement(element,opts){if(!opts.preserveElement){if(toNode(element).parentNode===toNode(opts.parent)){toNode(opts.parent).removeChild(toNode(element));}}else{toNode(element).style.display='none';}}/**
	     * Computes menu position and sets the style on the menu container
	     * @param {HTMLElement} el - the menu container element
	     * @param {object} opts - the interim element options object
	     */function calculateMenuPosition(el,opts){var containerNode=el[0],openMenuNode=el[0].firstElementChild,openMenuNodeRect=openMenuNode.getBoundingClientRect(),boundryNode=$document[0].body,boundryNodeRect=boundryNode.getBoundingClientRect();var menuStyle=$window.getComputedStyle(openMenuNode);var originNode=opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin'))||opts.target[0],originNodeRect=originNode.getBoundingClientRect();var bounds={left:boundryNodeRect.left+MENU_EDGE_MARGIN,top:Math.max(boundryNodeRect.top,0)+MENU_EDGE_MARGIN,bottom:Math.max(boundryNodeRect.bottom,Math.max(boundryNodeRect.top,0)+boundryNodeRect.height)-MENU_EDGE_MARGIN,right:boundryNodeRect.right-MENU_EDGE_MARGIN};var alignTarget,alignTargetRect={top:0,left:0,right:0,bottom:0},existingOffsets={top:0,left:0,right:0,bottom:0};var positionMode=opts.mdMenuCtrl.positionMode();if(positionMode.top=='target'||positionMode.left=='target'||positionMode.left=='target-right'){alignTarget=firstVisibleChild();if(alignTarget){// TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
	alignTarget=alignTarget.firstElementChild||alignTarget;alignTarget=alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target'))||alignTarget;alignTargetRect=alignTarget.getBoundingClientRect();existingOffsets={top:parseFloat(containerNode.style.top||0),left:parseFloat(containerNode.style.left||0)};}}var position={};var transformOrigin='top ';switch(positionMode.top){case'target':position.top=existingOffsets.top+originNodeRect.top-alignTargetRect.top;break;case'cascade':position.top=originNodeRect.top-parseFloat(menuStyle.paddingTop)-originNode.style.top;break;case'bottom':position.top=originNodeRect.top+originNodeRect.height;break;default:throw new Error('Invalid target mode "'+positionMode.top+'" specified for md-menu on Y axis.');}var rtl=$mdUtil.bidi()=='rtl';switch(positionMode.left){case'target':position.left=existingOffsets.left+originNodeRect.left-alignTargetRect.left;transformOrigin+=rtl?'right':'left';break;case'target-left':position.left=originNodeRect.left;transformOrigin+='left';break;case'target-right':position.left=originNodeRect.right-openMenuNodeRect.width+(openMenuNodeRect.right-alignTargetRect.right);transformOrigin+='right';break;case'cascade':var willFitRight=rtl?originNodeRect.left-openMenuNodeRect.width<bounds.left:originNodeRect.right+openMenuNodeRect.width<bounds.right;position.left=willFitRight?originNodeRect.right-originNode.style.left:originNodeRect.left-originNode.style.left-openMenuNodeRect.width;transformOrigin+=willFitRight?'left':'right';break;case'right':if(rtl){position.left=originNodeRect.right-originNodeRect.width;transformOrigin+='left';}else{position.left=originNodeRect.right-openMenuNodeRect.width;transformOrigin+='right';}break;case'left':if(rtl){position.left=originNodeRect.right-openMenuNodeRect.width;transformOrigin+='right';}else{position.left=originNodeRect.left;transformOrigin+='left';}break;default:throw new Error('Invalid target mode "'+positionMode.left+'" specified for md-menu on X axis.');}var offsets=opts.mdMenuCtrl.offsets();position.top+=offsets.top;position.left+=offsets.left;clamp(position);var scaleX=Math.round(100*Math.min(originNodeRect.width/containerNode.offsetWidth,1.0))/100;var scaleY=Math.round(100*Math.min(originNodeRect.height/containerNode.offsetHeight,1.0))/100;return{top:Math.round(position.top),left:Math.round(position.left),// Animate a scale out if we aren't just repositioning
	transform:!opts.alreadyOpen?$mdUtil.supplant('scale({0},{1})',[scaleX,scaleY]):undefined,transformOrigin:transformOrigin};/**
	       * Clamps the repositioning of the menu within the confines of
	       * bounding element (often the screen/body)
	       */function clamp(pos){pos.top=Math.max(Math.min(pos.top,bounds.bottom-containerNode.offsetHeight),bounds.top);pos.left=Math.max(Math.min(pos.left,bounds.right-containerNode.offsetWidth),bounds.left);}/**
	       * Gets the first visible child in the openMenuNode
	       * Necessary incase menu nodes are being dynamically hidden
	       */function firstVisibleChild(){for(var i=0;i<openMenuNode.children.length;++i){if($window.getComputedStyle(openMenuNode.children[i]).display!='none'){return openMenuNode.children[i];}}}}}function toNode(el){if(el instanceof angular.element){el=el[0];}return el;}}})();(function(){"use strict";MenuBarController.$inject=["$scope","$rootScope","$element","$attrs","$mdConstant","$document","$mdUtil","$timeout"];angular.module('material.components.menuBar').controller('MenuBarController',MenuBarController);var BOUND_MENU_METHODS=['handleKeyDown','handleMenuHover','scheduleOpenHoveredMenu','cancelScheduledOpen'];/**
	 * @ngInject
	 */function MenuBarController($scope,$rootScope,$element,$attrs,$mdConstant,$document,$mdUtil,$timeout){this.$element=$element;this.$attrs=$attrs;this.$mdConstant=$mdConstant;this.$mdUtil=$mdUtil;this.$document=$document;this.$scope=$scope;this.$rootScope=$rootScope;this.$timeout=$timeout;var self=this;angular.forEach(BOUND_MENU_METHODS,function(methodName){self[methodName]=angular.bind(self,self[methodName]);});}MenuBarController.prototype.init=function(){var $element=this.$element;var $mdUtil=this.$mdUtil;var $scope=this.$scope;var self=this;var deregisterFns=[];$element.on('keydown',this.handleKeyDown);this.parentToolbar=$mdUtil.getClosest($element,'MD-TOOLBAR');deregisterFns.push(this.$rootScope.$on('$mdMenuOpen',function(event,el){if(self.getMenus().indexOf(el[0])!=-1){$element[0].classList.add('md-open');el[0].classList.add('md-open');self.currentlyOpenMenu=el.controller('mdMenu');self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);self.enableOpenOnHover();}}));deregisterFns.push(this.$rootScope.$on('$mdMenuClose',function(event,el,opts){var rootMenus=self.getMenus();if(rootMenus.indexOf(el[0])!=-1){$element[0].classList.remove('md-open');el[0].classList.remove('md-open');}if($element[0].contains(el[0])){var parentMenu=el[0];while(parentMenu&&rootMenus.indexOf(parentMenu)==-1){parentMenu=$mdUtil.getClosest(parentMenu,'MD-MENU',true);}if(parentMenu){if(!opts.skipFocus)parentMenu.querySelector('button:not([disabled])').focus();self.currentlyOpenMenu=undefined;self.disableOpenOnHover();self.setKeyboardMode(true);}}}));$scope.$on('$destroy',function(){self.disableOpenOnHover();while(deregisterFns.length){deregisterFns.shift()();}});this.setKeyboardMode(true);};MenuBarController.prototype.setKeyboardMode=function(enabled){if(enabled)this.$element[0].classList.add('md-keyboard-mode');else this.$element[0].classList.remove('md-keyboard-mode');};MenuBarController.prototype.enableOpenOnHover=function(){if(this.openOnHoverEnabled)return;var self=this;self.openOnHoverEnabled=true;if(self.parentToolbar){self.parentToolbar.classList.add('md-has-open-menu');// Needs to be on the next tick so it doesn't close immediately.
	self.$mdUtil.nextTick(function(){angular.element(self.parentToolbar).on('click',self.handleParentClick);},false);}angular.element(self.getMenus()).on('mouseenter',self.handleMenuHover);};MenuBarController.prototype.handleMenuHover=function(e){this.setKeyboardMode(false);if(this.openOnHoverEnabled){this.scheduleOpenHoveredMenu(e);}};MenuBarController.prototype.disableOpenOnHover=function(){if(!this.openOnHoverEnabled)return;this.openOnHoverEnabled=false;if(this.parentToolbar){this.parentToolbar.classList.remove('md-has-open-menu');angular.element(this.parentToolbar).off('click',this.handleParentClick);}angular.element(this.getMenus()).off('mouseenter',this.handleMenuHover);};MenuBarController.prototype.scheduleOpenHoveredMenu=function(e){var menuEl=angular.element(e.currentTarget);var menuCtrl=menuEl.controller('mdMenu');this.setKeyboardMode(false);this.scheduleOpenMenu(menuCtrl);};MenuBarController.prototype.scheduleOpenMenu=function(menuCtrl){var self=this;var $timeout=this.$timeout;if(menuCtrl!=self.currentlyOpenMenu){$timeout.cancel(self.pendingMenuOpen);self.pendingMenuOpen=$timeout(function(){self.pendingMenuOpen=undefined;if(self.currentlyOpenMenu){self.currentlyOpenMenu.close(true,{closeAll:true});}menuCtrl.open();},200,false);}};MenuBarController.prototype.handleKeyDown=function(e){var keyCodes=this.$mdConstant.KEY_CODE;var currentMenu=this.currentlyOpenMenu;var wasOpen=currentMenu&&currentMenu.isOpen;this.setKeyboardMode(true);var handled,newMenu,newMenuCtrl;switch(e.keyCode){case keyCodes.DOWN_ARROW:if(currentMenu){currentMenu.focusMenuContainer();}else{this.openFocusedMenu();}handled=true;break;case keyCodes.UP_ARROW:currentMenu&&currentMenu.close();handled=true;break;case keyCodes.LEFT_ARROW:newMenu=this.focusMenu(-1);if(wasOpen){newMenuCtrl=angular.element(newMenu).controller('mdMenu');this.scheduleOpenMenu(newMenuCtrl);}handled=true;break;case keyCodes.RIGHT_ARROW:newMenu=this.focusMenu(+1);if(wasOpen){newMenuCtrl=angular.element(newMenu).controller('mdMenu');this.scheduleOpenMenu(newMenuCtrl);}handled=true;break;}if(handled){e&&e.preventDefault&&e.preventDefault();e&&e.stopImmediatePropagation&&e.stopImmediatePropagation();}};MenuBarController.prototype.focusMenu=function(direction){var menus=this.getMenus();var focusedIndex=this.getFocusedMenuIndex();if(focusedIndex==-1){focusedIndex=this.getOpenMenuIndex();}var changed=false;if(focusedIndex==-1){focusedIndex=0;changed=true;}else if(direction<0&&focusedIndex>0||direction>0&&focusedIndex<menus.length-direction){focusedIndex+=direction;changed=true;}if(changed){menus[focusedIndex].querySelector('button').focus();return menus[focusedIndex];}};MenuBarController.prototype.openFocusedMenu=function(){var menu=this.getFocusedMenu();menu&&angular.element(menu).controller('mdMenu').open();};MenuBarController.prototype.getMenus=function(){var $element=this.$element;return this.$mdUtil.nodesToArray($element[0].children).filter(function(el){return el.nodeName=='MD-MENU';});};MenuBarController.prototype.getFocusedMenu=function(){return this.getMenus()[this.getFocusedMenuIndex()];};MenuBarController.prototype.getFocusedMenuIndex=function(){var $mdUtil=this.$mdUtil;var focusedEl=$mdUtil.getClosest(this.$document[0].activeElement,'MD-MENU');if(!focusedEl)return-1;var focusedIndex=this.getMenus().indexOf(focusedEl);return focusedIndex;};MenuBarController.prototype.getOpenMenuIndex=function(){var menus=this.getMenus();for(var i=0;i<menus.length;++i){if(menus[i].classList.contains('md-open'))return i;}return-1;};MenuBarController.prototype.handleParentClick=function(event){var openMenu=this.querySelector('md-menu.md-open');if(openMenu&&!openMenu.contains(event.target)){angular.element(openMenu).controller('mdMenu').close(true,{closeAll:true});}};})();(function(){"use strict";/**
	 * @ngdoc directive
	 * @name mdMenuBar
	 * @module material.components.menuBar
	 * @restrict E
	 * @description
	 *
	 * Menu bars are containers that hold multiple menus. They change the behavior and appearence
	 * of the `md-menu` directive to behave similar to an operating system provided menu.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">
	 *       File
	 *     </button>
	 *     <md-menu-content>
	 *       <md-menu-item>
	 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
	 *           Share...
	 *         </md-button>
	 *       </md-menu-item>
	 *       <md-menu-divider></md-menu-divider>
	 *       <md-menu-item>
	 *       <md-menu-item>
	 *         <md-menu>
	 *           <md-button ng-click="$mdMenu.open()">New</md-button>
	 *           <md-menu-content>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *           </md-menu-content>
	 *         </md-menu>
	 *       </md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 * ## Menu Bar Controls
	 *
	 * You may place `md-menu-items` that function as controls within menu bars.
	 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
	 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
	 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
	 * to the `string` value of the `value` attribute. If you need non-string values, you can use
	 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]` works.
	 *
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *  <md-menu>
	 *    <button ng-click="$mdMenu.open()">
	 *      Sample Menu
	 *    </button>
	 *    <md-menu-content>
	 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item>
	 *      <md-menu-divider></md-menu-divider>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 2</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 3</md-menu-item>
	 *    </md-menu-content>
	 *  </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 *
	 * ### Nesting Menus
	 *
	 * Menus may be nested within menu bars. This is commonly called cascading menus.
	 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">New</md-button>
	 *     <md-menu-content>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-item>
	 * </hljs>
	 *
	 */MenuBarDirective.$inject=["$mdUtil","$mdTheming"];angular.module('material.components.menuBar').directive('mdMenuBar',MenuBarDirective);/* @ngInject */function MenuBarDirective($mdUtil,$mdTheming){return{restrict:'E',require:'mdMenuBar',controller:'MenuBarController',compile:function compile(templateEl,templateAttrs){if(!templateAttrs.ariaRole){templateEl[0].setAttribute('role','menubar');}angular.forEach(templateEl[0].children,function(menuEl){if(menuEl.nodeName=='MD-MENU'){if(!menuEl.hasAttribute('md-position-mode')){menuEl.setAttribute('md-position-mode','left bottom');// Since we're in the compile function and actual `md-buttons` are not compiled yet,
	// we need to query for possible `md-buttons` as well.
	menuEl.querySelector('button, a, md-button').setAttribute('role','menuitem');}var contentEls=$mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));angular.forEach(contentEls,function(contentEl){contentEl.classList.add('md-menu-bar-menu');contentEl.classList.add('md-dense');if(!contentEl.hasAttribute('width')){contentEl.setAttribute('width',5);}});}});// Mark the child menu items that they're inside a menu bar. This is necessary,
	// because mnMenuItem has special behaviour during compilation, depending on
	// whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
	// however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
	// the element won't have a parent and won't compile properly.
	templateEl.find('md-menu-item').addClass('md-in-menu-bar');return function postLink(scope,el,attr,ctrl){el.addClass('_md');// private md component indicator for styling
	$mdTheming(scope,el);ctrl.init();};}};}})();(function(){"use strict";angular.module('material.components.menuBar').directive('mdMenuDivider',MenuDividerDirective);function MenuDividerDirective(){return{restrict:'E',compile:function compile(templateEl,templateAttrs){if(!templateAttrs.role){templateEl[0].setAttribute('role','separator');}}};}})();(function(){"use strict";MenuItemController.$inject=["$scope","$element","$attrs"];angular.module('material.components.menuBar').controller('MenuItemController',MenuItemController);/**
	 * @ngInject
	 */function MenuItemController($scope,$element,$attrs){this.$element=$element;this.$attrs=$attrs;this.$scope=$scope;}MenuItemController.prototype.init=function(ngModel){var $element=this.$element;var $attrs=this.$attrs;this.ngModel=ngModel;if($attrs.type=='checkbox'||$attrs.type=='radio'){this.mode=$attrs.type;this.iconEl=$element[0].children[0];this.buttonEl=$element[0].children[1];if(ngModel){// Clear ngAria set attributes
	this.initClickListeners();}}};// ngAria auto sets attributes on a menu-item with a ngModel.
	// We don't want this because our content (buttons) get the focus
	// and set their own aria attributes appropritately. Having both
	// breaks NVDA / JAWS. This undeoes ngAria's attrs.
	MenuItemController.prototype.clearNgAria=function(){var el=this.$element[0];var clearAttrs=['role','tabindex','aria-invalid','aria-checked'];angular.forEach(clearAttrs,function(attr){el.removeAttribute(attr);});};MenuItemController.prototype.initClickListeners=function(){var self=this;var ngModel=this.ngModel;var $scope=this.$scope;var $attrs=this.$attrs;var $element=this.$element;var mode=this.mode;this.handleClick=angular.bind(this,this.handleClick);var icon=this.iconEl;var button=angular.element(this.buttonEl);var handleClick=this.handleClick;$attrs.$observe('disabled',setDisabled);setDisabled($attrs.disabled);ngModel.$render=function render(){self.clearNgAria();if(isSelected()){icon.style.display='';button.attr('aria-checked','true');}else{icon.style.display='none';button.attr('aria-checked','false');}};$scope.$$postDigest(ngModel.$render);function isSelected(){if(mode=='radio'){var val=$attrs.ngValue?$scope.$eval($attrs.ngValue):$attrs.value;return ngModel.$modelValue==val;}else{return ngModel.$modelValue;}}function setDisabled(disabled){if(disabled){button.off('click',handleClick);}else{button.on('click',handleClick);}}};MenuItemController.prototype.handleClick=function(e){var mode=this.mode;var ngModel=this.ngModel;var $attrs=this.$attrs;var newVal;if(mode=='checkbox'){newVal=!ngModel.$modelValue;}else if(mode=='radio'){newVal=$attrs.ngValue?this.$scope.$eval($attrs.ngValue):$attrs.value;}ngModel.$setViewValue(newVal);ngModel.$render();};})();(function(){"use strict";MenuItemDirective.$inject=["$mdUtil","$mdConstant","$$mdSvgRegistry"];angular.module('material.components.menuBar').directive('mdMenuItem',MenuItemDirective);/* @ngInject */function MenuItemDirective($mdUtil,$mdConstant,$$mdSvgRegistry){return{controller:'MenuItemController',require:['mdMenuItem','?ngModel'],priority:$mdConstant.BEFORE_NG_ARIA,compile:function compile(templateEl,templateAttrs){var type=templateAttrs.type;var inMenuBarClass='md-in-menu-bar';// Note: This allows us to show the `check` icon for the md-menu-bar items.
	// The `md-in-menu-bar` class is set by the mdMenuBar directive.
	if((type=='checkbox'||type=='radio')&&templateEl.hasClass(inMenuBarClass)){var text=templateEl[0].textContent;var buttonEl=angular.element('<md-button type="button"></md-button>');var iconTemplate='<md-icon md-svg-src="'+$$mdSvgRegistry.mdChecked+'"></md-icon>';buttonEl.html(text);buttonEl.attr('tabindex','0');templateEl.html('');templateEl.append(angular.element(iconTemplate));templateEl.append(buttonEl);templateEl.addClass('md-indent').removeClass(inMenuBarClass);setDefault('role',type=='checkbox'?'menuitemcheckbox':'menuitemradio',buttonEl);moveAttrToButton('ng-disabled');}else{setDefault('role','menuitem',templateEl[0].querySelector('md-button, button, a'));}return function(scope,el,attrs,ctrls){var ctrl=ctrls[0];var ngModel=ctrls[1];ctrl.init(ngModel);};function setDefault(attr,val,el){el=el||templateEl;if(el instanceof angular.element){el=el[0];}if(!el.hasAttribute(attr)){el.setAttribute(attr,val);}}function moveAttrToButton(attribute){var attributes=$mdUtil.prefixer(attribute);angular.forEach(attributes,function(attr){if(templateEl[0].hasAttribute(attr)){var val=templateEl[0].getAttribute(attr);buttonEl[0].setAttribute(attr,val);templateEl[0].removeAttribute(attr);}});}}};}})();(function(){"use strict";/**
	 * @ngdoc directive
	 * @name mdProgressCircular
	 * @module material.components.progressCircular
	 * @restrict E
	 *
	 * @description
	 * The circular progress directive is used to make loading content in your app as delightful and
	 * painless as possible by minimizing the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * For operations where the percentage of the operation completed can be determined, use a
	 * determinate indicator. They give users a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while something finishes up, and it’s
	 * not necessary to expose what's happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
	 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate mode, this number represents the percentage of the
	 *     circular progress. Default: 0
	 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
	 * should be a pixel-size value (eg '100'). If this attribute is
	 * not present then a default value of '50px' is assumed.
	 *
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
	 * </hljs>
	 */MdProgressCircularDirective.$inject=["$window","$mdProgressCircular","$mdTheming","$mdUtil","$interval","$log"];angular.module('material.components.progressCircular').directive('mdProgressCircular',MdProgressCircularDirective);/* @ngInject */function MdProgressCircularDirective($window,$mdProgressCircular,$mdTheming,$mdUtil,$interval,$log){// Note that this shouldn't use use $$rAF, because it can cause an infinite loop
	// in any tests that call $animate.flush.
	var rAF=$window.requestAnimationFrame||$window.webkitRequestAnimationFrame||angular.noop;var cAF=$window.cancelAnimationFrame||$window.webkitCancelAnimationFrame||$window.webkitCancelRequestAnimationFrame||angular.noop;var MODE_DETERMINATE='determinate';var MODE_INDETERMINATE='indeterminate';var DISABLED_CLASS='_md-progress-circular-disabled';var INDETERMINATE_CLASS='md-mode-indeterminate';return{restrict:'E',scope:{value:'@',mdDiameter:'@',mdMode:'@'},template:'<svg xmlns="http://www.w3.org/2000/svg">'+'<path fill="none"/>'+'</svg>',compile:function compile(element,attrs){element.attr({'aria-valuemin':0,'aria-valuemax':100,'role':'progressbar'});if(angular.isUndefined(attrs.mdMode)){var mode=attrs.hasOwnProperty('value')?MODE_DETERMINATE:MODE_INDETERMINATE;attrs.$set('mdMode',mode);}else{attrs.$set('mdMode',attrs.mdMode.trim());}return MdProgressCircularLink;}};function MdProgressCircularLink(scope,element,attrs){var node=element[0];var svg=angular.element(node.querySelector('svg'));var path=angular.element(node.querySelector('path'));var startIndeterminate=$mdProgressCircular.startIndeterminate;var endIndeterminate=$mdProgressCircular.endIndeterminate;var iterationCount=0;var lastAnimationId=0;var lastDrawFrame;var interval;$mdTheming(element);element.toggleClass(DISABLED_CLASS,attrs.hasOwnProperty('disabled'));// If the mode is indeterminate, it doesn't need to
	// wait for the next digest. It can start right away.
	if(scope.mdMode===MODE_INDETERMINATE){startIndeterminateAnimation();}scope.$on('$destroy',function(){cleanupIndeterminateAnimation();if(lastDrawFrame){cAF(lastDrawFrame);}});scope.$watchGroup(['value','mdMode',function(){var isDisabled=node.disabled;// Sometimes the browser doesn't return a boolean, in
	// which case we should check whether the attribute is
	// present.
	if(isDisabled===true||isDisabled===false){return isDisabled;}return angular.isDefined(element.attr('disabled'));}],function(newValues,oldValues){var mode=newValues[1];var isDisabled=newValues[2];var wasDisabled=oldValues[2];if(isDisabled!==wasDisabled){element.toggleClass(DISABLED_CLASS,!!isDisabled);}if(isDisabled){cleanupIndeterminateAnimation();}else{if(mode!==MODE_DETERMINATE&&mode!==MODE_INDETERMINATE){mode=MODE_INDETERMINATE;attrs.$set('mdMode',mode);}if(mode===MODE_INDETERMINATE){startIndeterminateAnimation();}else{var newValue=clamp(newValues[0]);cleanupIndeterminateAnimation();element.attr('aria-valuenow',newValue);renderCircle(clamp(oldValues[0]),newValue);}}});// This is in a separate watch in order to avoid layout, unless
	// the value has actually changed.
	scope.$watch('mdDiameter',function(newValue){var diameter=getSize(newValue);var strokeWidth=getStroke(diameter);var value=clamp(scope.value);var transformOrigin=diameter/2+'px';var dimensions={width:diameter+'px',height:diameter+'px'};// The viewBox has to be applied via setAttribute, because it is
	// case-sensitive. If jQuery is included in the page, `.attr` lowercases
	// all attribute names.
	svg[0].setAttribute('viewBox','0 0 '+diameter+' '+diameter);// Usually viewBox sets the dimensions for the SVG, however that doesn't
	// seem to be the case on IE10.
	// Important! The transform origin has to be set from here and it has to
	// be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
	// IE and Edge, because they don't account for the stroke width when
	// rotating. Also "center" doesn't help in this case, it has to be a
	// precise value.
	svg.css(dimensions).css('transform-origin',transformOrigin+' '+transformOrigin+' '+transformOrigin);element.css(dimensions);path.attr('stroke-width',strokeWidth);path.attr('stroke-linecap','square');if(scope.mdMode==MODE_INDETERMINATE){path.attr('d',getSvgArc(diameter,strokeWidth,true));path.attr('stroke-dasharray',(diameter-strokeWidth)*$window.Math.PI*0.75);path.attr('stroke-dashoffset',getDashLength(diameter,strokeWidth,1,75));}else{path.attr('d',getSvgArc(diameter,strokeWidth,false));path.attr('stroke-dasharray',(diameter-strokeWidth)*$window.Math.PI);path.attr('stroke-dashoffset',getDashLength(diameter,strokeWidth,0,100));renderCircle(value,value);}});function renderCircle(animateFrom,animateTo,easing,duration,iterationCount,maxValue){var id=++lastAnimationId;var startTime=$mdUtil.now();var changeInValue=animateTo-animateFrom;var diameter=getSize(scope.mdDiameter);var strokeWidth=getStroke(diameter);var ease=easing||$mdProgressCircular.easeFn;var animationDuration=duration||$mdProgressCircular.duration;var rotation=-90*(iterationCount||0);var dashLimit=maxValue||100;// No need to animate it if the values are the same
	if(animateTo===animateFrom){renderFrame(animateTo);}else{lastDrawFrame=rAF(function animation(){var currentTime=$window.Math.max(0,$window.Math.min($mdUtil.now()-startTime,animationDuration));renderFrame(ease(currentTime,animateFrom,changeInValue,animationDuration));// Do not allow overlapping animations
	if(id===lastAnimationId&&currentTime<animationDuration){lastDrawFrame=rAF(animation);}});}function renderFrame(value){path.attr('stroke-dashoffset',getDashLength(diameter,strokeWidth,value,dashLimit));path.attr('transform','rotate('+rotation+' '+diameter/2+' '+diameter/2+')');}}function animateIndeterminate(){renderCircle(startIndeterminate,endIndeterminate,$mdProgressCircular.easeFnIndeterminate,$mdProgressCircular.durationIndeterminate,iterationCount,75);// The %4 technically isn't necessary, but it keeps the rotation
	// under 360, instead of becoming a crazy large number.
	iterationCount=++iterationCount%4;}function startIndeterminateAnimation(){if(!interval){// Note that this interval isn't supposed to trigger a digest.
	interval=$interval(animateIndeterminate,$mdProgressCircular.durationIndeterminate,0,false);animateIndeterminate();element.addClass(INDETERMINATE_CLASS).removeAttr('aria-valuenow');}}function cleanupIndeterminateAnimation(){if(interval){$interval.cancel(interval);interval=null;element.removeClass(INDETERMINATE_CLASS);}}}/**
	   * Returns SVG path data for progress circle
	   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {boolean} indeterminate Use if progress circle will be used for indeterminate
	   *
	   * @returns {string} String representation of an SVG arc.
	   */function getSvgArc(diameter,strokeWidth,indeterminate){var radius=diameter/2;var offset=strokeWidth/2;var start=radius+','+offset;// ie: (25, 2.5) or 12 o'clock
	var end=offset+','+radius;// ie: (2.5, 25) or  9 o'clock
	var arcRadius=radius-offset;return'M'+start+'A'+arcRadius+','+arcRadius+' 0 1 1 '+end// 75% circle
	+(indeterminate?'':'A'+arcRadius+','+arcRadius+' 0 0 1 '+start);// loop to start
	}/**
	   * Return stroke length for progress circle
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {number} value Percentage of circle (between 0 and 100)
	   * @param {number} limit Max percentage for circle
	   *
	   * @returns {number} Stroke length for progres circle
	   */function getDashLength(diameter,strokeWidth,value,limit){return(diameter-strokeWidth)*$window.Math.PI*(3*(limit||100)/100-value/100);}/**
	   * Limits a value between 0 and 100.
	   */function clamp(value){return $window.Math.max(0,$window.Math.min(value||0,100));}/**
	   * Determines the size of a progress circle, based on the provided
	   * value in the following formats: `X`, `Ypx`, `Z%`.
	   */function getSize(value){var defaultValue=$mdProgressCircular.progressSize;if(value){var parsed=parseFloat(value);if(value.lastIndexOf('%')===value.length-1){parsed=parsed/100*defaultValue;}return parsed;}return defaultValue;}/**
	   * Determines the circle's stroke width, based on
	   * the provided diameter.
	   */function getStroke(diameter){return $mdProgressCircular.strokeWidth/100*diameter;}}})();(function(){"use strict";/**
	 * @ngdoc service
	 * @name $mdProgressCircular
	 * @module material.components.progressCircular
	 *
	 * @description
	 * Allows the user to specify the default options for the `progressCircular` directive.
	 *
	 * @property {number} progressSize Diameter of the progress circle in pixels.
	 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
	 * @property {number} duration Length of the circle animation in milliseconds.
	 * @property {function} easeFn Default easing animation function.
	 * @property {object} easingPresets Collection of pre-defined easing functions.
	 *
	 * @property {number} durationIndeterminate Duration of the indeterminate animation.
	 * @property {number} startIndeterminate Indeterminate animation start point.
	 * @property {number} endIndeterminate Indeterminate animation end point.
	 * @property {function} easeFnIndeterminate Easing function to be used when animating
	 * between the indeterminate values.
	 *
	 * @property {(function(object): object)} configure Used to modify the default options.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdProgressCircularProvider) {
	 *
	 *     // Example of changing the default progress options.
	 *     $mdProgressCircularProvider.configure({
	 *       progressSize: 100,
	 *       strokeWidth: 20,
	 *       duration: 800
	 *     });
	 * });
	 * </hljs>
	 *
	 */angular.module('material.components.progressCircular').provider("$mdProgressCircular",MdProgressCircularProvider);function MdProgressCircularProvider(){var progressConfig={progressSize:50,strokeWidth:10,duration:100,easeFn:linearEase,durationIndeterminate:1333,startIndeterminate:1,endIndeterminate:149,easeFnIndeterminate:materialEase,easingPresets:{linearEase:linearEase,materialEase:materialEase}};return{configure:function configure(options){progressConfig=angular.extend(progressConfig,options||{});return progressConfig;},$get:function $get(){return progressConfig;}};function linearEase(t,b,c,d){return c*t/d+b;}function materialEase(t,b,c,d){// via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
	// with settings of [0, 0, 1, 1]
	var ts=(t/=d)*t;var tc=ts*t;return b+c*(6*tc*ts+-15*ts*ts+10*tc);}}})();(function(){"use strict";/**
	 * @ngdoc directive
	 * @name mdTab
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tab>` is a nested directive used within `<md-tabs>` to specify a tab with a **label** and optional *view content*.
	 *
	 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to specify more
	 * complex tab header markup. If neither the **label** nor the **md-tab-label** are specified, then the nested
	 * markup of the `<md-tab>` is used as the tab header markup.
	 *
	 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the `<md-tab-body>` tag.  This
	 * is to define a clear separation between the tab content and the tab label.
	 *
	 * This container is used by the TabsController to show/hide the active tab's content view. This synchronization is
	 * automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can
	 * be initiated via data binding changes, programmatic invocation, or user gestures.
	 *
	 * @param {string=} label Optional attribute to specify a simple string as the tab label
	 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab selection.
	 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been de-selected.
	 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
	 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active tab at a time.
	 *
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 * <md-tab label="" ng-disabled md-on-select="" md-on-deselect="" >
	 *   <h3>My Tab content</h3>
	 * </md-tab>
	 *
	 * <md-tab >
	 *   <md-tab-label>
	 *     <h3>My Tab content</h3>
	 *   </md-tab-label>
	 *   <md-tab-body>
	 *     <p>
	 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
	 *       totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
	 *       dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
	 *       sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
	 *     </p>
	 *   </md-tab-body>
	 * </md-tab>
	 * </hljs>
	 *
	 */angular.module('material.components.tabs').directive('mdTab',MdTab);function MdTab(){return{require:'^?mdTabs',terminal:true,compile:function compile(element,attr){var label=firstChild(element,'md-tab-label'),body=firstChild(element,'md-tab-body');if(label.length===0){label=angular.element('<md-tab-label></md-tab-label>');if(attr.label)label.text(attr.label);else label.append(element.contents());if(body.length===0){var contents=element.contents().detach();body=angular.element('<md-tab-body></md-tab-body>');body.append(contents);}}element.append(label);if(body.html())element.append(body);return postLink;},scope:{active:'=?mdActive',disabled:'=?ngDisabled',select:'&?mdOnSelect',deselect:'&?mdOnDeselect'}};function postLink(scope,element,attr,ctrl){if(!ctrl)return;var index=ctrl.getTabElementIndex(element),body=firstChild(element,'md-tab-body').remove(),label=firstChild(element,'md-tab-label').remove(),data=ctrl.insertTab({scope:scope,parent:scope.$parent,index:index,element:element,template:body.html(),label:label.html()},index);scope.select=scope.select||angular.noop;scope.deselect=scope.deselect||angular.noop;scope.$watch('active',function(active){if(active)ctrl.select(data.getIndex(),true);});scope.$watch('disabled',function(){ctrl.refreshIndex();});scope.$watch(function(){return ctrl.getTabElementIndex(element);},function(newIndex){data.index=newIndex;ctrl.updateTabOrder();});scope.$on('$destroy',function(){ctrl.removeTab(data);});}function firstChild(element,tagName){var children=element[0].children;for(var i=0,len=children.length;i<len;i++){var child=children[i];if(child.tagName===tagName.toUpperCase())return angular.element(child);}return angular.element();}}})();(function(){"use strict";angular.module('material.components.tabs').directive('mdTabItem',MdTabItem);function MdTabItem(){return{require:'^?mdTabs',link:function link(scope,element,attr,ctrl){if(!ctrl)return;ctrl.attachRipple(scope,element);}};}})();(function(){"use strict";angular.module('material.components.tabs').directive('mdTabLabel',MdTabLabel);function MdTabLabel(){return{terminal:true};}})();(function(){"use strict";MdTabScroll.$inject=["$parse"];angular.module('material.components.tabs').directive('mdTabScroll',MdTabScroll);function MdTabScroll($parse){return{restrict:'A',compile:function compile($element,attr){var fn=$parse(attr.mdTabScroll,null,true);return function ngEventHandler(scope,element){element.on('mousewheel',function(event){scope.$apply(function(){fn(scope,{$event:event});});});};}};}})();(function(){"use strict";MdTabsController.$inject=["$scope","$element","$window","$mdConstant","$mdTabInkRipple","$mdUtil","$animateCss","$attrs","$compile","$mdTheming","$mdInteraction","MdTabsPaginationService"];angular.module('material.components.tabs').controller('MdTabsController',MdTabsController);/**
	 * @ngInject
	 */function MdTabsController($scope,$element,$window,$mdConstant,$mdTabInkRipple,$mdUtil,$animateCss,$attrs,$compile,$mdTheming,$mdInteraction,MdTabsPaginationService){// define private properties
	var ctrl=this,locked=false,elements=getElements(),queue=[],destroyed=false,loaded=false;// Define public methods
	ctrl.$onInit=$onInit;ctrl.updatePagination=$mdUtil.debounce(updatePagination,100);ctrl.redirectFocus=redirectFocus;ctrl.attachRipple=attachRipple;ctrl.insertTab=insertTab;ctrl.removeTab=removeTab;ctrl.select=select;ctrl.scroll=scroll;ctrl.nextPage=nextPage;ctrl.previousPage=previousPage;ctrl.keydown=keydown;ctrl.canPageForward=canPageForward;ctrl.canPageBack=canPageBack;ctrl.refreshIndex=refreshIndex;ctrl.incrementIndex=incrementIndex;ctrl.getTabElementIndex=getTabElementIndex;ctrl.updateInkBarStyles=$mdUtil.debounce(updateInkBarStyles,100);ctrl.updateTabOrder=$mdUtil.debounce(updateTabOrder,100);ctrl.getFocusedTabId=getFocusedTabId;// For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	// manually call the $onInit hook.
	if(angular.version.major===1&&angular.version.minor<=4){this.$onInit();}/**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */function $onInit(){// Define one-way bindings
	defineOneWayBinding('stretchTabs',handleStretchTabs);// Define public properties with change handlers
	defineProperty('focusIndex',handleFocusIndexChange,ctrl.selectedIndex||0);defineProperty('offsetLeft',handleOffsetChange,0);defineProperty('hasContent',handleHasContent,false);defineProperty('maxTabWidth',handleMaxTabWidth,getMaxTabWidth());defineProperty('shouldPaginate',handleShouldPaginate,false);// Define boolean attributes
	defineBooleanAttribute('noInkBar',handleInkBar);defineBooleanAttribute('dynamicHeight',handleDynamicHeight);defineBooleanAttribute('noPagination');defineBooleanAttribute('swipeContent');defineBooleanAttribute('noDisconnect');defineBooleanAttribute('autoselect');defineBooleanAttribute('noSelectClick');defineBooleanAttribute('centerTabs',handleCenterTabs,false);defineBooleanAttribute('enableDisconnect');// Define public properties
	ctrl.scope=$scope;ctrl.parent=$scope.$parent;ctrl.tabs=[];ctrl.lastSelectedIndex=null;ctrl.hasFocus=false;ctrl.styleTabItemFocus=false;ctrl.shouldCenterTabs=shouldCenterTabs();ctrl.tabContentPrefix='tab-content-';// Setup the tabs controller after all bindings are available.
	setupTabsController();}/**
	   * Perform setup for the controller, setup events and watcher(s)
	   */function setupTabsController(){ctrl.selectedIndex=ctrl.selectedIndex||0;compileTemplate();configureWatchers();bindEvents();$mdTheming($element);$mdUtil.nextTick(function(){// Note that the element references need to be updated, because certain "browsers"
	// (IE/Edge) lose them and start throwing "Invalid calling object" errors, when we
	// compile the element contents down in `compileElement`.
	elements=getElements();updateHeightFromContent();adjustOffset();updateInkBarStyles();ctrl.tabs[ctrl.selectedIndex]&&ctrl.tabs[ctrl.selectedIndex].scope.select();loaded=true;updatePagination();});}/**
	   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
	   * directive's template function.
	   */function compileTemplate(){var template=$attrs.$mdTabsTemplate,element=angular.element($element[0].querySelector('md-tab-data'));element.html(template);$compile(element.contents())(ctrl.parent);delete $attrs.$mdTabsTemplate;}/**
	   * Binds events used by the tabs component.
	   */function bindEvents(){angular.element($window).on('resize',handleWindowResize);$scope.$on('$destroy',cleanup);}/**
	   * Configure watcher(s) used by Tabs
	   */function configureWatchers(){$scope.$watch('$mdTabsCtrl.selectedIndex',handleSelectedIndexChange);}/**
	   * Creates a one-way binding manually rather than relying on AngularJS's isolated scope
	   * @param key
	   * @param handler
	   */function defineOneWayBinding(key,handler){var attr=$attrs.$normalize('md-'+key);if(handler)defineProperty(key,handler);$attrs.$observe(attr,function(newValue){ctrl[key]=newValue;});}/**
	   * Defines boolean attributes with default value set to true.  (ie. md-stretch-tabs with no value
	   * will be treated as being truthy)
	   * @param key
	   * @param handler
	   */function defineBooleanAttribute(key,handler){var attr=$attrs.$normalize('md-'+key);if(handler)defineProperty(key,handler);if($attrs.hasOwnProperty(attr))updateValue($attrs[attr]);$attrs.$observe(attr,updateValue);function updateValue(newValue){ctrl[key]=newValue!=='false';}}/**
	   * Remove any events defined by this controller
	   */function cleanup(){destroyed=true;angular.element($window).off('resize',handleWindowResize);}// Change handlers
	/**
	   * Toggles stretch tabs class and updates inkbar when tab stretching changes
	   * @param stretchTabs
	   */function handleStretchTabs(stretchTabs){var elements=getElements();angular.element(elements.wrapper).toggleClass('md-stretch-tabs',shouldStretchTabs());updateInkBarStyles();}function handleCenterTabs(newValue){ctrl.shouldCenterTabs=shouldCenterTabs();}function handleMaxTabWidth(newWidth,oldWidth){if(newWidth!==oldWidth){var elements=getElements();// Set the max width for the real tabs
	angular.forEach(elements.tabs,function(tab){tab.style.maxWidth=newWidth+'px';});// Set the max width for the dummy tabs too
	angular.forEach(elements.dummies,function(tab){tab.style.maxWidth=newWidth+'px';});$mdUtil.nextTick(ctrl.updateInkBarStyles);}}function handleShouldPaginate(newValue,oldValue){if(newValue!==oldValue){ctrl.maxTabWidth=getMaxTabWidth();ctrl.shouldCenterTabs=shouldCenterTabs();$mdUtil.nextTick(function(){ctrl.maxTabWidth=getMaxTabWidth();adjustOffset(ctrl.selectedIndex);});}}/**
	   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
	   * @param hasContent
	   */function handleHasContent(hasContent){$element[hasContent?'removeClass':'addClass']('md-no-tab-content');}/**
	   * Apply ctrl.offsetLeft to the paging element when it changes
	   * @param left
	   */function handleOffsetChange(left){var elements=getElements();var newValue=(ctrl.shouldCenterTabs||isRtl()?'':'-')+left+'px';// Fix double-negative which can happen with RTL support
	newValue=newValue.replace('--','');angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM,'translate3d('+newValue+', 0, 0)');$scope.$broadcast('$mdTabsPaginationChanged');}/**
	   * Update the UI whenever `ctrl.focusIndex` is updated
	   * @param newIndex
	   * @param oldIndex
	   */function handleFocusIndexChange(newIndex,oldIndex){if(newIndex===oldIndex)return;if(!getElements().tabs[newIndex])return;adjustOffset();redirectFocus();}/**
	   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
	   * @param newValue
	   * @param oldValue
	   */function handleSelectedIndexChange(newValue,oldValue){if(newValue===oldValue)return;ctrl.selectedIndex=getNearestSafeIndex(newValue);ctrl.lastSelectedIndex=oldValue;ctrl.updateInkBarStyles();updateHeightFromContent();adjustOffset(newValue);$scope.$broadcast('$mdTabsChanged');ctrl.tabs[oldValue]&&ctrl.tabs[oldValue].scope.deselect();ctrl.tabs[newValue]&&ctrl.tabs[newValue].scope.select();}function getTabElementIndex(tabEl){var tabs=$element[0].getElementsByTagName('md-tab');return Array.prototype.indexOf.call(tabs,tabEl[0]);}/**
	   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
	   * hidden.
	   */function handleResizeWhenVisible(){// if there is already a watcher waiting for resize, do nothing
	if(handleResizeWhenVisible.watcher)return;// otherwise, we will abuse the $watch function to check for visible
	handleResizeWhenVisible.watcher=$scope.$watch(function(){// since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
	$mdUtil.nextTick(function(){// if the watcher has already run (ie. multiple digests in one cycle), do nothing
	if(!handleResizeWhenVisible.watcher)return;if($element.prop('offsetParent')){handleResizeWhenVisible.watcher();handleResizeWhenVisible.watcher=null;handleWindowResize();}},false);});}// Event handlers / actions
	/**
	   * Handle user keyboard interactions
	   * @param event
	   */function keydown(event){switch(event.keyCode){case $mdConstant.KEY_CODE.LEFT_ARROW:event.preventDefault();incrementIndex(-1,true);break;case $mdConstant.KEY_CODE.RIGHT_ARROW:event.preventDefault();incrementIndex(1,true);break;case $mdConstant.KEY_CODE.SPACE:case $mdConstant.KEY_CODE.ENTER:event.preventDefault();if(!locked)select(ctrl.focusIndex);break;case $mdConstant.KEY_CODE.TAB:// On tabbing out of the tablist, reset hasFocus to reset ng-focused and
	// its md-focused class if the focused tab is not the active tab.
	if(ctrl.focusIndex!==ctrl.selectedIndex){ctrl.focusIndex=ctrl.selectedIndex;}break;}}/**
	   * Update the selected index. Triggers a click event on the original `md-tab` element in order
	   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
	   * @param index
	   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
	   */function select(index,canSkipClick){if(!locked)ctrl.focusIndex=ctrl.selectedIndex=index;// skip the click event if noSelectClick is enabled
	if(canSkipClick&&ctrl.noSelectClick)return;// nextTick is required to prevent errors in user-defined click events
	$mdUtil.nextTick(function(){ctrl.tabs[index].element.triggerHandler('click');},false);}/**
	   * When pagination is on, this makes sure the selected index is in view.
	   * @param event
	   */function scroll(event){if(!ctrl.shouldPaginate)return;event.preventDefault();ctrl.offsetLeft=fixOffset(ctrl.offsetLeft-event.wheelDelta);}/**
	   * Slides the tabs over approximately one page forward.
	   */function nextPage(){if(!ctrl.canPageForward()){return;}var newOffset=MdTabsPaginationService.increasePageOffset(getElements(),ctrl.offsetLeft);ctrl.offsetLeft=fixOffset(newOffset);}/**
	   * Slides the tabs over approximately one page backward.
	   */function previousPage(){if(!ctrl.canPageBack()){return;}var newOffset=MdTabsPaginationService.decreasePageOffset(getElements(),ctrl.offsetLeft);// Set the new offset
	ctrl.offsetLeft=fixOffset(newOffset);}/**
	   * Update size calculations when the window is resized.
	   */function handleWindowResize(){ctrl.lastSelectedIndex=ctrl.selectedIndex;ctrl.offsetLeft=fixOffset(ctrl.offsetLeft);$mdUtil.nextTick(function(){ctrl.updateInkBarStyles();updatePagination();});}function handleInkBar(hide){angular.element(getElements().inkBar).toggleClass('ng-hide',hide);}/**
	   * Toggle dynamic height class when value changes
	   * @param value
	   */function handleDynamicHeight(value){$element.toggleClass('md-dynamic-height',value);}/**
	   * Remove a tab from the data and select the nearest valid tab.
	   * @param tabData
	   */function removeTab(tabData){if(destroyed)return;var selectedIndex=ctrl.selectedIndex,tab=ctrl.tabs.splice(tabData.getIndex(),1)[0];refreshIndex();// when removing a tab, if the selected index did not change, we have to manually trigger the
	//   tab select/deselect events
	if(ctrl.selectedIndex===selectedIndex){tab.scope.deselect();ctrl.tabs[ctrl.selectedIndex]&&ctrl.tabs[ctrl.selectedIndex].scope.select();}$mdUtil.nextTick(function(){updatePagination();ctrl.offsetLeft=fixOffset(ctrl.offsetLeft);});}/**
	   * Create an entry in the tabs array for a new tab at the specified index.
	   * @param tabData
	   * @param index
	   * @returns {*}
	   */function insertTab(tabData,index){var hasLoaded=loaded;var proto={getIndex:function getIndex(){return ctrl.tabs.indexOf(tab);},isActive:function isActive(){return this.getIndex()===ctrl.selectedIndex;},isLeft:function isLeft(){return this.getIndex()<ctrl.selectedIndex;},isRight:function isRight(){return this.getIndex()>ctrl.selectedIndex;},shouldRender:function shouldRender(){return!ctrl.noDisconnect||this.isActive();},hasFocus:function hasFocus(){return ctrl.styleTabItemFocus&&ctrl.hasFocus&&this.getIndex()===ctrl.focusIndex;},id:$mdUtil.nextUid(),hasContent:!!(tabData.template&&tabData.template.trim())},tab=angular.extend(proto,tabData);if(angular.isDefined(index)){ctrl.tabs.splice(index,0,tab);}else{ctrl.tabs.push(tab);}processQueue();updateHasContent();$mdUtil.nextTick(function(){updatePagination();setAriaControls(tab);// if autoselect is enabled, select the newly added tab
	if(hasLoaded&&ctrl.autoselect)$mdUtil.nextTick(function(){$mdUtil.nextTick(function(){select(ctrl.tabs.indexOf(tab));});});});return tab;}// Getter methods
	/**
	   * Gathers references to all of the DOM elements used by this controller.
	   * @returns {{}}
	   */function getElements(){var elements={};var node=$element[0];// gather tab bar elements
	elements.wrapper=node.querySelector('md-tabs-wrapper');elements.canvas=elements.wrapper.querySelector('md-tabs-canvas');elements.paging=elements.canvas.querySelector('md-pagination-wrapper');elements.inkBar=elements.paging.querySelector('md-ink-bar');elements.nextButton=node.querySelector('md-next-button');elements.prevButton=node.querySelector('md-prev-button');elements.contents=node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');elements.tabs=elements.paging.querySelectorAll('md-tab-item');elements.dummies=elements.canvas.querySelectorAll('md-dummy-tab');return elements;}/**
	   * Determines whether or not the left pagination arrow should be enabled.
	   * @returns {boolean}
	   */function canPageBack(){// This works for both LTR and RTL
	return ctrl.offsetLeft>0;}/**
	   * Determines whether or not the right pagination arrow should be enabled.
	   * @returns {*|boolean}
	   */function canPageForward(){var elements=getElements();var lastTab=elements.tabs[elements.tabs.length-1];if(isRtl()){return ctrl.offsetLeft<elements.paging.offsetWidth-elements.canvas.offsetWidth;}return lastTab&&lastTab.offsetLeft+lastTab.offsetWidth>elements.canvas.clientWidth+ctrl.offsetLeft;}/**
	   * Returns currently focused tab item's element ID
	   */function getFocusedTabId(){var focusedTab=ctrl.tabs[ctrl.focusIndex];if(!focusedTab||!focusedTab.id){return null;}return'tab-item-'+focusedTab.id;}/**
	   * Determines if the UI should stretch the tabs to fill the available space.
	   * @returns {*}
	   */function shouldStretchTabs(){switch(ctrl.stretchTabs){case'always':return true;case'never':return false;default:return!ctrl.shouldPaginate&&$window.matchMedia('(max-width: 600px)').matches;}}/**
	   * Determines if the tabs should appear centered.
	   * @returns {string|boolean}
	   */function shouldCenterTabs(){return ctrl.centerTabs&&!ctrl.shouldPaginate;}/**
	   * Determines if pagination is necessary to display the tabs within the available space.
	   * @returns {boolean}
	   */function shouldPaginate(){if(ctrl.noPagination||!loaded)return false;var canvasWidth=$element.prop('clientWidth');angular.forEach(getElements().tabs,function(tab){canvasWidth-=tab.offsetWidth;});return canvasWidth<0;}/**
	   * Finds the nearest tab index that is available.  This is primarily used for when the active
	   * tab is removed.
	   * @param newIndex
	   * @returns {*}
	   */function getNearestSafeIndex(newIndex){if(newIndex===-1)return-1;var maxOffset=Math.max(ctrl.tabs.length-newIndex,newIndex),i,tab;for(i=0;i<=maxOffset;i++){tab=ctrl.tabs[newIndex+i];if(tab&&tab.scope.disabled!==true)return tab.getIndex();tab=ctrl.tabs[newIndex-i];if(tab&&tab.scope.disabled!==true)return tab.getIndex();}return newIndex;}// Utility methods
	/**
	   * Defines a property using a getter and setter in order to trigger a change handler without
	   * using `$watch` to observe changes.
	   * @param key
	   * @param handler
	   * @param value
	   */function defineProperty(key,handler,value){Object.defineProperty(ctrl,key,{get:function get(){return value;},set:function set(newValue){var oldValue=value;value=newValue;handler&&handler(newValue,oldValue);}});}/**
	   * Updates whether or not pagination should be displayed.
	   */function updatePagination(){ctrl.maxTabWidth=getMaxTabWidth();ctrl.shouldPaginate=shouldPaginate();}/**
	   * Calculates the width of the pagination wrapper by summing the widths of the dummy tabs.
	   * @returns {number}
	   */function calcPagingWidth(){return calcTabsWidth(getElements().tabs);}function calcTabsWidth(tabs){var width=0;angular.forEach(tabs,function(tab){//-- Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
	//   prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
	//   also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
	//   of a dialog)
	width+=Math.max(tab.offsetWidth,tab.getBoundingClientRect().width);});return Math.ceil(width);}function getMaxTabWidth(){var elements=getElements(),containerWidth=elements.canvas.clientWidth,// See https://material.google.com/components/tabs.html#tabs-specs
	specMax=264;// Do the spec maximum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
	// width can break the pagination) but not less than 0
	return Math.max(0,Math.min(containerWidth-1,specMax));}function getMinTabWidth(){var elements=getElements(),containerWidth=elements.canvas.clientWidth,xsBreakpoint=600,// See https://material.google.com/components/tabs.html#tabs-specs
	specMin=containerWidth>xsBreakpoint?160:72;// Do the spec minimum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
	// width can break the pagination) but not less than 0
	return Math.max(0,Math.min(containerWidth-1,specMin));}/**
	   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
	   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
	   */function updateTabOrder(){var selectedItem=ctrl.tabs[ctrl.selectedIndex],focusItem=ctrl.tabs[ctrl.focusIndex];ctrl.tabs=ctrl.tabs.sort(function(a,b){return a.index-b.index;});ctrl.selectedIndex=ctrl.tabs.indexOf(selectedItem);ctrl.focusIndex=ctrl.tabs.indexOf(focusItem);}/**
	   * This moves the selected or focus index left or right.  This is used by the keydown handler.
	   * @param inc
	   */function incrementIndex(inc,focus){var newIndex,key=focus?'focusIndex':'selectedIndex',index=ctrl[key];for(newIndex=index+inc;ctrl.tabs[newIndex]&&ctrl.tabs[newIndex].scope.disabled;newIndex+=inc){/* do nothing */}newIndex=(index+inc+ctrl.tabs.length)%ctrl.tabs.length;if(ctrl.tabs[newIndex]){ctrl[key]=newIndex;}}/**
	   * This is used to forward focus to tab container elements.  This method is necessary to avoid
	   * animation issues when attempting to focus an item that is out of view.
	   */function redirectFocus(){ctrl.styleTabItemFocus=$mdInteraction.getLastInteractionType()==='keyboard';getElements().tabs[ctrl.focusIndex].focus();}/**
	   * Forces the pagination to move the focused tab into view.
	   */function adjustOffset(index){var elements=getElements();if(!angular.isNumber(index))index=ctrl.focusIndex;if(!elements.tabs[index])return;if(ctrl.shouldCenterTabs)return;var tab=elements.tabs[index],left=tab.offsetLeft,right=tab.offsetWidth+left,extraOffset=32;// If we are selecting the first tab (in LTR and RTL), always set the offset to 0
	if(index==0){ctrl.offsetLeft=0;return;}if(isRtl()){var tabWidthsBefore=calcTabsWidth(Array.prototype.slice.call(elements.tabs,0,index));var tabWidthsIncluding=calcTabsWidth(Array.prototype.slice.call(elements.tabs,0,index+1));ctrl.offsetLeft=Math.min(ctrl.offsetLeft,fixOffset(tabWidthsBefore));ctrl.offsetLeft=Math.max(ctrl.offsetLeft,fixOffset(tabWidthsIncluding-elements.canvas.clientWidth));}else{ctrl.offsetLeft=Math.max(ctrl.offsetLeft,fixOffset(right-elements.canvas.clientWidth+extraOffset));ctrl.offsetLeft=Math.min(ctrl.offsetLeft,fixOffset(left));}}/**
	   * Iterates through all queued functions and clears the queue.  This is used for functions that
	   * are called before the UI is ready, such as size calculations.
	   */function processQueue(){queue.forEach(function(func){$mdUtil.nextTick(func);});queue=[];}/**
	   * Determines if the tab content area is needed.
	   */function updateHasContent(){var hasContent=false;for(var i=0;i<ctrl.tabs.length;i++){if(ctrl.tabs[i].hasContent){hasContent=true;break;}}ctrl.hasContent=hasContent;}/**
	   * Moves the indexes to their nearest valid values.
	   */function refreshIndex(){ctrl.selectedIndex=getNearestSafeIndex(ctrl.selectedIndex);ctrl.focusIndex=getNearestSafeIndex(ctrl.focusIndex);}/**
	   * Calculates the content height of the current tab.
	   * @returns {*}
	   */function updateHeightFromContent(){if(!ctrl.dynamicHeight)return $element.css('height','');if(!ctrl.tabs.length)return queue.push(updateHeightFromContent);var elements=getElements();var tabContent=elements.contents[ctrl.selectedIndex],contentHeight=tabContent?tabContent.offsetHeight:0,tabsHeight=elements.wrapper.offsetHeight,newHeight=contentHeight+tabsHeight,currentHeight=$element.prop('clientHeight');if(currentHeight===newHeight)return;// Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
	// positioning.  This should probably be cleaned up if a cleaner solution is possible.
	if($element.attr('md-align-tabs')==='bottom'){currentHeight-=tabsHeight;newHeight-=tabsHeight;// Need to include bottom border in these calculations
	if($element.attr('md-border-bottom')!==undefined)++currentHeight;}// Lock during animation so the user can't change tabs
	locked=true;var fromHeight={height:currentHeight+'px'},toHeight={height:newHeight+'px'};// Set the height to the current, specific pixel height to fix a bug on iOS where the height
	// first animates to 0, then back to the proper height causing a visual glitch
	$element.css(fromHeight);// Animate the height from the old to the new
	$animateCss($element,{from:fromHeight,to:toHeight,easing:'cubic-bezier(0.35, 0, 0.25, 1)',duration:0.5}).start().done(function(){// Then (to fix the same iOS issue as above), disable transitions and remove the specific
	// pixel height so the height can size with browser width/content changes, etc.
	$element.css({transition:'none',height:''});// In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
	// enough to batch it for us instead of doing it immediately, which undoes the original
	// transition: none)
	$mdUtil.nextTick(function(){$element.css('transition','');});// And unlock so tab changes can occur
	locked=false;});}/**
	   * Repositions the ink bar to the selected tab.
	   * @returns {*}
	   */function updateInkBarStyles(){var elements=getElements();if(!elements.tabs[ctrl.selectedIndex]){angular.element(elements.inkBar).css({left:'auto',right:'auto'});return;}if(!ctrl.tabs.length)return queue.push(ctrl.updateInkBarStyles);// if the element is not visible, we will not be able to calculate sizes until it is
	// we should treat that as a resize event rather than just updating the ink bar
	if(!$element.prop('offsetParent'))return handleResizeWhenVisible();var index=ctrl.selectedIndex,totalWidth=elements.paging.offsetWidth,tab=elements.tabs[index],left=tab.offsetLeft,right=totalWidth-left-tab.offsetWidth;if(ctrl.shouldCenterTabs){// We need to use the same calculate process as in the pagination wrapper, to avoid rounding deviations.
	var tabWidth=calcTabsWidth(elements.tabs);if(totalWidth>tabWidth){$mdUtil.nextTick(updateInkBarStyles,false);}}updateInkBarClassName();angular.element(elements.inkBar).css({left:left+'px',right:right+'px'});}/**
	   * Adds left/right classes so that the ink bar will animate properly.
	   */function updateInkBarClassName(){var elements=getElements();var newIndex=ctrl.selectedIndex,oldIndex=ctrl.lastSelectedIndex,ink=angular.element(elements.inkBar);if(!angular.isNumber(oldIndex))return;ink.toggleClass('md-left',newIndex<oldIndex).toggleClass('md-right',newIndex>oldIndex);}/**
	   * Takes an offset value and makes sure that it is within the min/max allowed values.
	   * @param value
	   * @returns {*}
	   */function fixOffset(value){var elements=getElements();if(!elements.tabs.length||!ctrl.shouldPaginate)return 0;var lastTab=elements.tabs[elements.tabs.length-1],totalWidth=lastTab.offsetLeft+lastTab.offsetWidth;if(isRtl()){value=Math.min(elements.paging.offsetWidth-elements.canvas.clientWidth,value);value=Math.max(0,value);}else{value=Math.max(0,value);value=Math.min(totalWidth-elements.canvas.clientWidth,value);}return value;}/**
	   * Attaches a ripple to the tab item element.
	   * @param scope
	   * @param element
	   */function attachRipple(scope,element){var elements=getElements();var options={colorElement:angular.element(elements.inkBar)};$mdTabInkRipple.attach(scope,element,options);}/**
	   * Sets the `aria-controls` attribute to the elements that
	   * correspond to the passed-in tab.
	   * @param tab
	   */function setAriaControls(tab){if(tab.hasContent){var nodes=$element[0].querySelectorAll('[md-tab-id="'+tab.id+'"]');angular.element(nodes).attr('aria-controls',ctrl.tabContentPrefix+tab.id);}}function isRtl(){return $mdUtil.bidi()=='rtl';}}})();(function(){"use strict";/**
	 * @ngdoc directive
	 * @name mdTabs
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tabs>` directive serves as the container for 1..n `<md-tab>` child directives to
	 * produces a Tabs components. In turn, the nested `<md-tab>` directive is used to specify a tab
	 * label for the **header button** and a [optional] tab view content that will be associated with
	 * each tab button.
	 *
	 * Below is the markup for its simplest usage:
	 *
	 *  <hljs lang="html">
	 *  <md-tabs>
	 *    <md-tab label="Tab #1"></md-tab>
	 *    <md-tab label="Tab #2"></md-tab>
	 *    <md-tab label="Tab #3"></md-tab>
	 *  </md-tabs>
	 *  </hljs>
	 *
	 * Tabs supports three (3) usage scenarios:
	 *
	 *  1. Tabs (buttons only)
	 *  2. Tabs with internal view content
	 *  3. Tabs with external view content
	 *
	 * **Tab-only** support is useful when tab buttons are used for custom navigation regardless of any
	 * other components, content, or views.
	 *
	 * <i><b>Note:</b> If you are using the Tabs component for page-level navigation, please take a look
	 * at the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead as it can handle this
	 * case a bit more natively.</i>
	 *
	 * **Tabs with internal views** are the traditional usages where each tab has associated view
	 * content and the view switching is managed internally by the Tabs component.
	 *
	 * **Tabs with external view content** is often useful when content associated with each tab is
	 * independently managed and data-binding notifications announce tab selection changes.
	 *
	 * Additional features also include:
	 *
	 * *  Content can include any markup.
	 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
	 *
	 * ### Explanation of tab stretching
	 *
	 * Initially, tabs will have an inherent size.  This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS.  Calculations will be based on this size.
	 *
	 * On mobile devices, tabs will be expanded to fill the available horizontal space.  When this happens, all tabs will become the same size.
	 *
	 * On desktops, by default, stretching will never occur.
	 *
	 * This default behavior can be overridden through the `md-stretch-tabs` attribute.  Here is a table showing when stretching will occur:
	 *
	 * `md-stretch-tabs` | mobile    | desktop
	 * ------------------|-----------|--------
	 * `auto`            | stretched | ---
	 * `always`          | stretched | stretched
	 * `never`           | ---       | ---
	 *
	 * @param {integer=} md-selected Index of the active/selected tab
	 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
	 * @param {boolean=} md-no-ink-bar If present, disables the selection ink bar.
	 * @param {string=}  md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`; default is `top`
	 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`, `always`, or `never`; default is `auto`
	 * @param {boolean=} md-dynamic-height When enabled, the tab wrapper will resize based on the contents of the selected tab
	 * @param {boolean=} md-border-bottom If present, shows a solid `1px` border between the tabs and their content
	 * @param {boolean=} md-center-tabs When enabled, tabs will be centered provided there is no need for pagination
	 * @param {boolean=} md-no-pagination When enabled, pagination will remain off
	 * @param {boolean=} md-swipe-content When enabled, swipe gestures will be enabled for the content area to jump between tabs
	 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that are not being displayed.  This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.
	 * @param {boolean=} md-autoselect When present, any tabs added after the initial load will be automatically selected
	 * @param {boolean=} md-no-select-click When enabled, click events will not be fired when selecting tabs
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-tabs md-selected="selectedIndex" >
	 *   <img ng-src="img/angular.png" class="centered">
	 *   <md-tab
	 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
	 *       md-on-select="onTabSelected(tab)"
	 *       md-on-deselect="announceDeselected(tab)"
	 *       ng-disabled="tab.disabled">
	 *     <md-tab-label>
	 *       {{tab.title}}
	 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
	 *     </md-tab-label>
	 *     <md-tab-body>
	 *       {{tab.content}}
	 *     </md-tab-body>
	 *   </md-tab>
	 * </md-tabs>
	 * </hljs>
	 *
	 */MdTabs.$inject=["$$mdSvgRegistry"];angular.module('material.components.tabs').directive('mdTabs',MdTabs);function MdTabs($$mdSvgRegistry){return{scope:{selectedIndex:'=?mdSelected'},template:function template(element,attr){attr.$mdTabsTemplate=element.html();return''+'<md-tabs-wrapper> '+'<md-tab-data></md-tab-data> '+'<md-prev-button '+'tabindex="-1" '+'role="button" '+'aria-label="Previous Page" '+'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" '+'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" '+'ng-if="$mdTabsCtrl.shouldPaginate" '+'ng-click="$mdTabsCtrl.previousPage()"> '+'<md-icon md-svg-src="'+$$mdSvgRegistry.mdTabsArrow+'"></md-icon> '+'</md-prev-button> '+'<md-next-button '+'tabindex="-1" '+'role="button" '+'aria-label="Next Page" '+'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" '+'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" '+'ng-if="$mdTabsCtrl.shouldPaginate" '+'ng-click="$mdTabsCtrl.nextPage()"> '+'<md-icon md-svg-src="'+$$mdSvgRegistry.mdTabsArrow+'"></md-icon> '+'</md-next-button> '+'<md-tabs-canvas '+'ng-focus="$mdTabsCtrl.redirectFocus()" '+'ng-class="{ '+'\'md-paginated\': $mdTabsCtrl.shouldPaginate, '+'\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs '+'}" '+'ng-keydown="$mdTabsCtrl.keydown($event)"> '+'<md-pagination-wrapper '+'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" '+'md-tab-scroll="$mdTabsCtrl.scroll($event)" '+'role="tablist"> '+'<md-tab-item '+'tabindex="{{ tab.isActive() ? 0 : -1 }}" '+'class="md-tab" '+'ng-repeat="tab in $mdTabsCtrl.tabs" '+'role="tab" '+'id="tab-item-{{::tab.id}}" '+'md-tab-id="{{::tab.id}}"'+'aria-selected="{{tab.isActive()}}" '+'aria-disabled="{{tab.scope.disabled || \'false\'}}" '+'ng-click="$mdTabsCtrl.select(tab.getIndex())" '+'ng-focus="$mdTabsCtrl.hasFocus = true" '+'ng-blur="$mdTabsCtrl.hasFocus = false" '+'ng-class="{ '+'\'md-active\':    tab.isActive(), '+'\'md-focused\':   tab.hasFocus(), '+'\'md-disabled\':  tab.scope.disabled '+'}" '+'ng-disabled="tab.scope.disabled" '+'md-swipe-left="$mdTabsCtrl.nextPage()" '+'md-swipe-right="$mdTabsCtrl.previousPage()" '+'md-tabs-template="::tab.label" '+'md-scope="::tab.parent"></md-tab-item> '+'<md-ink-bar></md-ink-bar> '+'</md-pagination-wrapper> '+'<md-tabs-dummy-wrapper aria-hidden="true" class="md-visually-hidden md-dummy-wrapper"> '+'<md-dummy-tab '+'class="md-tab" '+'tabindex="-1" '+'ng-repeat="tab in $mdTabsCtrl.tabs" '+'md-tabs-template="::tab.label" '+'md-scope="::tab.parent"></md-dummy-tab> '+'</md-tabs-dummy-wrapper> '+'</md-tabs-canvas> '+'</md-tabs-wrapper> '+'<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> '+'<md-tab-content '+'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" '+'class="_md" '+'role="tabpanel" '+'aria-labelledby="tab-item-{{::tab.id}}" '+'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" '+'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" '+'ng-if="tab.hasContent" '+'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" '+'ng-class="{ '+'\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, '+'\'md-active\':        tab.isActive(), '+'\'md-left\':          tab.isLeft(), '+'\'md-right\':         tab.isRight(), '+'\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight '+'}"> '+'<div '+'md-tabs-template="::tab.template" '+'md-connected-if="tab.isActive()" '+'md-scope="::tab.parent" '+'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> '+'</md-tab-content> '+'</md-tabs-content-wrapper>';},controller:'MdTabsController',controllerAs:'$mdTabsCtrl',bindToController:true};}})();(function(){"use strict";MdTabsDummyWrapper.$inject=["$mdUtil","$window"];angular.module('material.components.tabs').directive('mdTabsDummyWrapper',MdTabsDummyWrapper);/**
	 * @private
	 *
	 * @param $mdUtil
	 * @param $window
	 * @returns {{require: string, link: link}}
	 * @constructor
	 *
	 * @ngInject
	 */function MdTabsDummyWrapper($mdUtil,$window){return{require:'^?mdTabs',link:function link(scope,element,attr,ctrl){if(!ctrl)return;var observer;var disconnect;var mutationCallback=function mutationCallback(){ctrl.updatePagination();ctrl.updateInkBarStyles();};if('MutationObserver'in $window){var config={childList:true,subtree:true,// Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
	// the childList mutation, once a <span> element's innerText changes.
	// The characterData of the <span> element will change.
	characterData:true};observer=new MutationObserver(mutationCallback);observer.observe(element[0],config);disconnect=observer.disconnect.bind(observer);}else{var debounced=$mdUtil.debounce(mutationCallback,15,null,false);element.on('DOMSubtreeModified',debounced);disconnect=element.off.bind(element,'DOMSubtreeModified',debounced);}// Disconnect the observer
	scope.$on('$destroy',function(){disconnect();});}};}})();(function(){"use strict";MdTabsTemplate.$inject=["$compile","$mdUtil"];angular.module('material.components.tabs').directive('mdTabsTemplate',MdTabsTemplate);function MdTabsTemplate($compile,$mdUtil){return{restrict:'A',link:link,scope:{template:'=mdTabsTemplate',connected:'=?mdConnectedIf',compileScope:'=mdScope'},require:'^?mdTabs'};function link(scope,element,attr,ctrl){if(!ctrl)return;var compileScope=ctrl.enableDisconnect?scope.compileScope.$new():scope.compileScope;element.html(scope.template);$compile(element.contents())(compileScope);return $mdUtil.nextTick(handleScope);function handleScope(){scope.$watch('connected',function(value){value===false?disconnect():reconnect();});scope.$on('$destroy',reconnect);}function disconnect(){if(ctrl.enableDisconnect)$mdUtil.disconnectScope(compileScope);}function reconnect(){if(ctrl.enableDisconnect)$mdUtil.reconnectScope(compileScope);}}}})();(function(){angular.module("material.core").constant("$MD_THEME_CSS","md-autocomplete.md-THEME_NAME-theme{background:\"{{background-A100}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-100}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-A100}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li{color:\"{{background-900}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight{color:\"{{background-600}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover{background:\"{{background-200}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-50}}\";border-top-color:\"{{background-300}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-50}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{color:\"{{primary-contrast}}\";background-color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-raised{color:\"{{background-900}}\";background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{color:\"{{warn-contrast}}\";background-color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{color:\"{{accent-contrast}}\";background-color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-hue-1}}\";border-radius:2px}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{color:\"{{background-color}}\";background-color:\"{{foreground-3}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{accent-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:\"{{background-500}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-content.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-default}}\"}.md-calendar.md-THEME_NAME-theme{background:\"{{background-A100}}\";color:\"{{background-A200-0.87}}\"}.md-calendar.md-THEME_NAME-theme tr:last-child td{border-bottom-color:\"{{background-200}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-300}}\";color:\"{{background-A200-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-300}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";color:\"{{primary-500-contrast}}\";border-color:transparent}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{background-A200-0.435}}\"}.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-A100}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{border-radius:4px;background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions,md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions,md-divider.md-THEME_NAME-theme{border-top-color:\"{{foreground-4}}\"}.layout-gt-lg-row>md-divider.md-THEME_NAME-theme,.layout-gt-md-row>md-divider.md-THEME_NAME-theme,.layout-gt-sm-row>md-divider.md-THEME_NAME-theme,.layout-gt-xs-row>md-divider.md-THEME_NAME-theme,.layout-lg-row>md-divider.md-THEME_NAME-theme,.layout-md-row>md-divider.md-THEME_NAME-theme,.layout-row>md-divider.md-THEME_NAME-theme,.layout-sm-row>md-divider.md-THEME_NAME-theme,.layout-xl-row>md-divider.md-THEME_NAME-theme,.layout-xs-row>md-divider.md-THEME_NAME-theme{border-right-color:\"{{foreground-4}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{color:\"{{foreground-1}}\";border-color:\"{{foreground-4}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{border-bottom-color:transparent;color:\"{{foreground-3}}\";background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-A100}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{background-A200-0.87}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{background-A200-0.25}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{background-A200-0.11}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{color:\"{{foreground-2}}\";border-radius:2px}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{outline:none;background:\"{{background-200}}\"}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.2}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.2}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-A100}}\";color:\"{{background-A200}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{background-A100-0.87}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{background-A100-0.87}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar{background-color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar{background-color:\"{{warn-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar{background-color:\"{{primary-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{primary-color}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-bar1{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-dashed:before{background:radial-gradient(\"{{primary-100}}\" 0,\"{{primary-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme[disabled] .md-select-value{border-bottom-color:transparent;background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background:\"{{background-A100}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{background-600-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{background-900-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{background-400-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background:\"{{background-200}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{background-900-0.87}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{border-color:\"{{background-color}}\";background-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{border-color:\"{{accent-color}}\";background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{border-color:\"{{warn-color}}\";background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{border-color:\"{{primary-color}}\";background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{border-color:transparent;background-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{color:\"{{ foreground-2-0.23 }}\";background-color:\"{{background-default}}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme .md-paginator md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{color:\"{{primary-contrast}}\";fill:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{color:\"{{primary-contrast-0.26}}\";fill:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{color:\"{{accent-contrast}}\";fill:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{color:\"{{accent-contrast-0.26}}\";fill:\"{{accent-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{color:\"{{background-700-contrast}}\";background-color:\"{{background-700}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-color}}\"}");})();})(window,window.angular);;window.ngMaterial={version:{full:"1.1.8"}};

/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function (window, angular) {
	  'use strict';
	
	  var forEach;
	  var isArray;
	  var isString;
	  var jqLite;
	
	  /**
	   * @ngdoc module
	   * @name ngMessages
	   * @description
	   *
	   * The `ngMessages` module provides enhanced support for displaying messages within templates
	   * (typically within forms or when rendering message objects that return key/value data).
	   * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	   * show and hide error messages specific to the state of an input field, the `ngMessages` and
	   * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	   * sequencing based on the order of how the messages are defined in the template.
	   *
	   * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	   * `ngMessage` and `ngMessageExp` directives.
	   *
	   * ## Usage
	   * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	   * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	   * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	   * {@link ngModel ngModel} directive.
	   *
	   * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	   * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	   * the `ngMessages` directive.
	   *
	   * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	   * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	   * directive.
	   *
	   * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	   *
	   * ```html
	   * <form name="myForm">
	   *   <label>
	   *     Enter text:
	   *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	   *   </label>
	   *   <div ng-messages="myForm.myField.$error" role="alert">
	   *     <div ng-message="required">Please enter a value for this field.</div>
	   *     <div ng-message="email">This field must be a valid email address.</div>
	   *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	   *   </div>
	   * </form>
	   * ```
	   *
	   * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	   * set to the `$error` object owned by the `myField` input in our `myForm` form.
	   *
	   * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	   * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	   * setting `ng-message="required"` specifies that this particular element should be displayed when there
	   * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	   * `myForm.myField.$error`).
	   *
	   * ### Message order
	   *
	   * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	   * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	   * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	   * to prioritize messages using custom JavaScript code.
	   *
	   * Given the following error object for our example (which informs us that the field `myField` currently has both the
	   * `required` and `email` errors):
	   *
	   * ```javascript
	   * <!-- keep in mind that ngModel automatically sets these error flags -->
	   * myField.$error = { required : true, email: true, maxlength: false };
	   * ```
	   * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	   * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	   * but the `email` message will be visible because it is still applicable.
	   *
	   * ### Displaying multiple messages at the same time
	   *
	   * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	   * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	   *
	   * ```html
	   * <!-- attribute-style usage -->
	   * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	   *
	   * <!-- element-style usage -->
	   * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	   * ```
	   *
	   * ## Reusing and Overriding Messages
	   * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	   * template. This allows for generic collection of messages to be reused across multiple parts of an
	   * application.
	   *
	   * ```html
	   * <script type="text/ng-template" id="error-messages">
	   *   <div ng-message="required">This field is required</div>
	   *   <div ng-message="minlength">This field is too short</div>
	   * </script>
	   *
	   * <div ng-messages="myForm.myField.$error" role="alert">
	   *   <div ng-messages-include="error-messages"></div>
	   * </div>
	   * ```
	   *
	   * However, including generic messages may not be useful enough to match all input fields, therefore,
	   * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	   * them within the directive container.
	   *
	   * ```html
	   * <!-- a generic template of error messages known as "my-custom-messages" -->
	   * <script type="text/ng-template" id="my-custom-messages">
	   *   <div ng-message="required">This field is required</div>
	   *   <div ng-message="minlength">This field is too short</div>
	   * </script>
	   *
	   * <form name="myForm">
	   *   <label>
	   *     Email address
	   *     <input type="email"
	   *            id="email"
	   *            name="myEmail"
	   *            ng-model="email"
	   *            minlength="5"
	   *            required />
	   *   </label>
	   *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	   *        override the messages present in the ng-messages-include template -->
	   *   <div ng-messages="myForm.myEmail.$error" role="alert">
	   *     <!-- this required message has overridden the template message -->
	   *     <div ng-message="required">You did not enter your email address</div>
	   *
	   *     <!-- this is a brand new message and will appear last in the prioritization -->
	   *     <div ng-message="email">Your email address is invalid</div>
	   *
	   *     <!-- and here are the generic error messages -->
	   *     <div ng-messages-include="my-custom-messages"></div>
	   *   </div>
	   * </form>
	   * ```
	   *
	   * In the example HTML code above the message that is set on required will override the corresponding
	   * required message defined within the remote template. Therefore, with particular input fields (such
	   * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	   * while more generic messages can be used to handle other, more general input errors.
	   *
	   * ## Dynamic Messaging
	   * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	   * repeaters to list messages is also supported. This means that the code below will be able to
	   * fully adapt itself and display the appropriate message when any of the expression data changes:
	   *
	   * ```html
	   * <form name="myForm">
	   *   <label>
	   *     Email address
	   *     <input type="email"
	   *            name="myEmail"
	   *            ng-model="email"
	   *            minlength="5"
	   *            required />
	   *   </label>
	   *   <div ng-messages="myForm.myEmail.$error" role="alert">
	   *     <div ng-message="required">You did not enter your email address</div>
	   *     <div ng-repeat="errorMessage in errorMessages">
	   *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	   *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	   *     </div>
	   *   </div>
	   * </form>
	   * ```
	   *
	   * The `errorMessage.type` expression can be a string value or it can be an array so
	   * that multiple errors can be associated with a single error message:
	   *
	   * ```html
	   *   <label>
	   *     Email address
	   *     <input type="email"
	   *            ng-model="data.email"
	   *            name="myEmail"
	   *            ng-minlength="5"
	   *            ng-maxlength="100"
	   *            required />
	   *   </label>
	   *   <div ng-messages="myForm.myEmail.$error" role="alert">
	   *     <div ng-message-exp="'required'">You did not enter your email address</div>
	   *     <div ng-message-exp="['minlength', 'maxlength']">
	   *       Your email must be between 5 and 100 characters long
	   *     </div>
	   *   </div>
	   * ```
	   *
	   * Feel free to use other structural directives such as ng-if and ng-switch to further control
	   * what messages are active and when. Be careful, if you place ng-message on the same element
	   * as these structural directives, AngularJS may not be able to determine if a message is active
	   * or not. Therefore it is best to place the ng-message on a child element of the structural
	   * directive.
	   *
	   * ```html
	   * <div ng-messages="myForm.myEmail.$error" role="alert">
	   *   <div ng-if="showRequiredError">
	   *     <div ng-message="required">Please enter something</div>
	   *   </div>
	   * </div>
	   * ```
	   *
	   * ## Animations
	   * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	   * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	   * the DOM by the `ngMessages` directive.
	   *
	   * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	   * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	   * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	   * hook into the animations whenever these classes are added/removed.
	   *
	   * Let's say that our HTML code for our messages container looks like so:
	   *
	   * ```html
	   * <div ng-messages="myMessages" class="my-messages" role="alert">
	   *   <div ng-message="alert" class="some-message">...</div>
	   *   <div ng-message="fail" class="some-message">...</div>
	   * </div>
	   * ```
	   *
	   * Then the CSS animation code for the message container looks like so:
	   *
	   * ```css
	   * .my-messages {
	   *   transition:1s linear all;
	   * }
	   * .my-messages.ng-active {
	   *   // messages are visible
	   * }
	   * .my-messages.ng-inactive {
	   *   // messages are hidden
	   * }
	   * ```
	   *
	   * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	   * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	   *
	   * Therefore, the CSS code for the inner messages looks like so:
	   *
	   * ```css
	   * .some-message {
	   *   transition:1s linear all;
	   * }
	   *
	   * .some-message.ng-enter {}
	   * .some-message.ng-enter.ng-enter-active {}
	   *
	   * .some-message.ng-leave {}
	   * .some-message.ng-leave.ng-leave-active {}
	   * ```
	   *
	   * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	   */
	  angular.module('ngMessages', [], function initAngularHelpers() {
	    // Access helpers from AngularJS core.
	    // Do it inside a `config` block to ensure `window.angular` is available.
	    forEach = angular.forEach;
	    isArray = angular.isArray;
	    isString = angular.isString;
	    jqLite = angular.element;
	  }).info({ angularVersion: '1.6.9' })
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used to promote message reusability and messages can also be
	   * overridden.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function ($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() {
	          return nextAttachId++;
	        };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function (collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) || isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function (value, key) {
	                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                  // this is to prevent the same error name from showing up twice
	                  if (matchedKeys[key]) return;
	                  matchedKeys[key] = true;
	
	                  messageUsed = true;
	                  messageCtrl.attach();
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function (messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          if (unmatchedMessages.length !== totalMessages) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        this.reRender = function () {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function () {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function (comment, messageCtrl) {
	          var nextKey = latestKey.toString();
	          messages[nextKey] = {
	            message: messageCtrl
	          };
	          insertMessageNode($element[0], comment, nextKey);
	          comment.$$ngMessageNode = nextKey;
	          latestKey++;
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function (comment) {
	          var key = comment.$$ngMessageNode;
	          delete comment.$$ngMessageNode;
	          removeMessageNode($element[0], comment, key);
	          delete messages[key];
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          // This message node may have already been removed by a call to deregister()
	          if (!messageNode) return;
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	      return isString(attr) && attr.length === 0 || //empty attribute
	      truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude', ['$templateRequest', '$document', '$compile', function ($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function link($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function (html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function (contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ? $compile.$$createComment('ngMessagesInclude', src) : $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   * @priority 1
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	  function ngMessageDirectiveFactory() {
	    return ['$animate', function ($animate) {
	      return {
	        restrict: 'AE',
	        transclude: 'element',
	        priority: 1, // must run before ngBind, otherwise the text is set on the comment
	        terminal: true,
	        require: '^^ngMessages',
	        link: function link(scope, element, attrs, ngMessagesCtrl, $transclude) {
	          var commentNode = element[0];
	
	          var records;
	          var staticExp = attrs.ngMessage || attrs.when;
	          var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	          var assignRecords = function assignRecords(items) {
	            records = items ? isArray(items) ? items : items.split(/[\s,]+/) : null;
	            ngMessagesCtrl.reRender();
	          };
	
	          if (dynamicExp) {
	            assignRecords(scope.$eval(dynamicExp));
	            scope.$watchCollection(dynamicExp, assignRecords);
	          } else {
	            assignRecords(staticExp);
	          }
	
	          var currentElement, messageCtrl;
	          ngMessagesCtrl.register(commentNode, messageCtrl = {
	            test: function test(name) {
	              return contains(records, name);
	            },
	            attach: function attach() {
	              if (!currentElement) {
	                $transclude(function (elm, newScope) {
	                  $animate.enter(elm, null, element);
	                  currentElement = elm;
	
	                  // Each time we attach this node to a message we get a new id that we can match
	                  // when we are destroying the node later.
	                  var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                  // in the event that the element or a parent element is destroyed
	                  // by another structural directive then it's time
	                  // to deregister the message from the controller
	                  currentElement.on('$destroy', function () {
	                    // If the message element was removed via a call to `detach` then `currentElement` will be null
	                    // So this handler only handles cases where something else removed the message element.
	                    if (currentElement && currentElement.$$attachId === $$attachId) {
	                      ngMessagesCtrl.deregister(commentNode);
	                      messageCtrl.detach();
	                    }
	                    newScope.$destroy();
	                  });
	                });
	              }
	            },
	            detach: function detach() {
	              if (currentElement) {
	                var elm = currentElement;
	                currentElement = null;
	                $animate.leave(elm);
	              }
	            }
	          });
	
	          // We need to ensure that this directive deregisters itself when it no longer exists
	          // Normally this is done when the attached element is destroyed; but if this directive
	          // gets removed before we attach the message to the DOM there is nothing to watch
	          // in which case we must deregister when the containing scope is destroyed.
	          scope.$on('$destroy', function () {
	            ngMessagesCtrl.deregister(commentNode);
	          });
	        }
	      };
	    }];
	
	    function contains(collection, key) {
	      if (collection) {
	        return isArray(collection) ? collection.indexOf(key) >= 0 : collection.hasOwnProperty(key);
	      }
	    }
	  }
	})(window, window.angular);

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(221);
	module.exports = 'ngMessages';

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * AngularJS filter for Numeral.js: number formatting as a filter
	 * @version v1.3.2 - 2016-12-27
	 * @link https://github.com/baumandm/angular-numeraljs
	 * @author Dave Bauman <baumandm@gmail.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (root, factory) {
	    if (( false ? 'undefined' : _typeof(exports)) === 'object') {
	        // CommonJS
	        module.exports = factory(__webpack_require__(14));
	    } else if (true) {
	        // AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function (numeral) {
	            return root.ngNumeraljs = factory(numeral);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Global Variables
	        root.ngNumeraljs = factory(root.numeral);
	    }
	})(undefined, function (numeral) {
	    return angular.module('ngNumeraljs', []).provider('$numeraljsConfig', function () {
	        var formats = {};
	
	        this.setFormat = function (name, format) {
	            formats[name] = format;
	        };
	
	        this.setDefaultFormat = function (format) {
	            numeral.defaultFormat(format);
	        };
	
	        this.setLanguage = function (lang, def) {
	            numeral.language(lang, def);
	        };
	
	        this.setCurrentLanguage = function (lang) {
	            numeral.language(lang);
	        };
	
	        this.$get = function () {
	            return {
	                customFormat: function customFormat(name) {
	                    return formats[name] || name;
	                },
	
	                setCurrentLanguage: this.setCurrentLanguage,
	
	                setDefaultFormat: this.setDefaultFormat,
	
	                setFormat: this.setFormat,
	
	                setLanguage: this.setLanguage
	            };
	        };
	    }).filter('numeraljs', ['$numeraljsConfig', function ($numeraljsConfig) {
	        return function (input, format) {
	            if (input == null) {
	                return input;
	            }
	
	            format = $numeraljsConfig.customFormat(format);
	
	            return numeral(input).format(format);
	        };
	    }]);
	});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * angular-translate - v2.17.0 - 2017-12-21
	 * 
	 * Copyright (c) 2017 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	})(undefined, function () {
	
	  /**
	   * @ngdoc overview
	   * @name pascalprecht.translate
	   *
	   * @description
	   * The main module which holds everything together.
	   */
	  runTranslate.$inject = ['$translate'];
	  $translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	  $translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	  translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	  translateAttrDirective.$inject = ['$translate', '$rootScope'];
	  translateCloakDirective.$inject = ['$translate', '$rootScope'];
	  translateFilterFactory.$inject = ['$parse', '$translate'];
	  $translationCache.$inject = ['$cacheFactory'];
	  angular.module('pascalprecht.translate', ['ng']).run(runTranslate);
	
	  function runTranslate($translate) {
	
	    'use strict';
	
	    var key = $translate.storageKey(),
	        storage = $translate.storage();
	
	    var fallbackFromIncorrectStorageValue = function fallbackFromIncorrectStorageValue() {
	      var preferred = $translate.preferredLanguage();
	      if (angular.isString(preferred)) {
	        $translate.use(preferred);
	        // $translate.use() will also remember the language.
	        // So, we don't need to call storage.put() here.
	      } else {
	        storage.put(key, $translate.use());
	      }
	    };
	
	    fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	    if (storage) {
	      if (!storage.get(key)) {
	        fallbackFromIncorrectStorageValue();
	      } else {
	        $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	      }
	    } else if (angular.isString($translate.preferredLanguage())) {
	      $translate.use($translate.preferredLanguage());
	    }
	  }
	
	  runTranslate.displayName = 'runTranslate';
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   *
	   * Configurations for $translateSanitization
	   */
	  angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	  function $translateSanitizationProvider() {
	
	    'use strict';
	
	    var $sanitize,
	        $sce,
	        currentStrategy = null,
	        // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	    hasConfiguredStrategy = false,
	        hasShownNoStrategyConfiguredWarning = false,
	        strategies;
	
	    /**
	     * Definition of a sanitization strategy function
	     * @callback StrategyFunction
	     * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	     * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	     * @return {string|object}
	     */
	
	    /**
	     * @ngdoc property
	     * @name strategies
	     * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	     *
	     * @description
	     * Following strategies are built-in:
	     * <dl>
	     *   <dt>sanitize</dt>
	     *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	     *   <dt>escape</dt>
	     *   <dd>Escapes HTML in the translation</dd>
	     *   <dt>sanitizeParameters</dt>
	     *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	     *   <dt>escapeParameters</dt>
	     *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	     *   <dt>escaped</dt>
	     *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	     * </dl>
	     *
	     */
	
	    strategies = {
	      sanitize: function sanitize(value, mode /*, context*/) {
	        if (mode === 'text') {
	          value = htmlSanitizeValue(value);
	        }
	        return value;
	      },
	      escape: function escape(value, mode /*, context*/) {
	        if (mode === 'text') {
	          value = htmlEscapeValue(value);
	        }
	        return value;
	      },
	      sanitizeParameters: function sanitizeParameters(value, mode /*, context*/) {
	        if (mode === 'params') {
	          value = mapInterpolationParameters(value, htmlSanitizeValue);
	        }
	        return value;
	      },
	      escapeParameters: function escapeParameters(value, mode /*, context*/) {
	        if (mode === 'params') {
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	        return value;
	      },
	      sce: function sce(value, mode, context) {
	        if (mode === 'text') {
	          value = htmlTrustValue(value);
	        } else if (mode === 'params') {
	          if (context !== 'filter') {
	            // do html escape in filter context #1101
	            value = mapInterpolationParameters(value, htmlEscapeValue);
	          }
	        }
	        return value;
	      },
	      sceParameters: function sceParameters(value, mode /*, context*/) {
	        if (mode === 'params') {
	          value = mapInterpolationParameters(value, htmlTrustValue);
	        }
	        return value;
	      }
	    };
	    // Support legacy strategy name 'escaped' for backwards compatibility.
	    // TODO should be removed in 3.0
	    strategies.escaped = strategies.escapeParameters;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	     * @methodOf pascalprecht.translate.$translateSanitizationProvider
	     *
	     * @description
	     * Adds a sanitization strategy to the list of known strategies.
	     *
	     * @param {string} strategyName - unique key for a strategy
	     * @param {StrategyFunction} strategyFunction - strategy function
	     * @returns {object} this
	     */
	    this.addStrategy = function (strategyName, strategyFunction) {
	      strategies[strategyName] = strategyFunction;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	     * @methodOf pascalprecht.translate.$translateSanitizationProvider
	     *
	     * @description
	     * Removes a sanitization strategy from the list of known strategies.
	     *
	     * @param {string} strategyName - unique key for a strategy
	     * @returns {object} this
	     */
	    this.removeStrategy = function (strategyName) {
	      delete strategies[strategyName];
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	     * @methodOf pascalprecht.translate.$translateSanitizationProvider
	     *
	     * @description
	     * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	     *
	     * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	     * @returns {object} this
	     */
	    this.useStrategy = function (strategy) {
	      hasConfiguredStrategy = true;
	      currentStrategy = strategy;
	      return this;
	    };
	
	    /**
	     * @ngdoc object
	     * @name pascalprecht.translate.$translateSanitization
	     * @requires $injector
	     * @requires $log
	     *
	     * @description
	     * Sanitizes interpolation parameters and translated texts.
	     *
	     */
	    this.$get = ['$injector', '$log', function ($injector, $log) {
	
	      var cachedStrategyMap = {};
	
	      var applyStrategies = function applyStrategies(value, mode, context, selectedStrategies) {
	        angular.forEach(selectedStrategies, function (selectedStrategy) {
	          if (angular.isFunction(selectedStrategy)) {
	            value = selectedStrategy(value, mode, context);
	          } else if (angular.isFunction(strategies[selectedStrategy])) {
	            value = strategies[selectedStrategy](value, mode, context);
	          } else if (angular.isString(strategies[selectedStrategy])) {
	            if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	              try {
	                cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	              } catch (e) {
	                cachedStrategyMap[strategies[selectedStrategy]] = function () {};
	                throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	              }
	            }
	            value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	          } else {
	            throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	          }
	        });
	        return value;
	      };
	
	      // TODO: should be removed in 3.0
	      var showNoStrategyConfiguredWarning = function showNoStrategyConfiguredWarning() {
	        if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	          $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	          hasShownNoStrategyConfiguredWarning = true;
	        }
	      };
	
	      if ($injector.has('$sanitize')) {
	        $sanitize = $injector.get('$sanitize');
	      }
	      if ($injector.has('$sce')) {
	        $sce = $injector.get('$sce');
	      }
	
	      return {
	        /**
	         * @ngdoc function
	         * @name pascalprecht.translate.$translateSanitization#useStrategy
	         * @methodOf pascalprecht.translate.$translateSanitization
	         *
	         * @description
	         * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	         *
	         * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	         */
	        useStrategy: function (self) {
	          return function (strategy) {
	            self.useStrategy(strategy);
	          };
	        }(this),
	
	        /**
	         * @ngdoc function
	         * @name pascalprecht.translate.$translateSanitization#sanitize
	         * @methodOf pascalprecht.translate.$translateSanitization
	         *
	         * @description
	         * Sanitizes a value.
	         *
	         * @param {string|object} value The value which should be sanitized.
	         * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	         * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	         * @param {string} [context] The context of this call: filter, service. Default is service
	         * @returns {string|object} sanitized value
	         */
	        sanitize: function sanitize(value, mode, strategy, context) {
	          if (!currentStrategy) {
	            showNoStrategyConfiguredWarning();
	          }
	
	          if (!strategy && strategy !== null) {
	            strategy = currentStrategy;
	          }
	
	          if (!strategy) {
	            return value;
	          }
	
	          if (!context) {
	            context = 'service';
	          }
	
	          var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	          return applyStrategies(value, mode, context, selectedStrategies);
	        }
	      };
	    }];
	
	    var htmlEscapeValue = function htmlEscapeValue(value) {
	      var element = angular.element('<div></div>');
	      element.text(value); // not chainable, see #1044
	      return element.html();
	    };
	
	    var htmlSanitizeValue = function htmlSanitizeValue(value) {
	      if (!$sanitize) {
	        throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	      }
	      return $sanitize(value);
	    };
	
	    var htmlTrustValue = function htmlTrustValue(value) {
	      if (!$sce) {
	        throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	      }
	      return $sce.trustAsHtml(value);
	    };
	
	    var mapInterpolationParameters = function mapInterpolationParameters(value, iteratee, stack) {
	      if (angular.isDate(value)) {
	        return value;
	      } else if (angular.isObject(value)) {
	        var result = angular.isArray(value) ? [] : {};
	
	        if (!stack) {
	          stack = [];
	        } else {
	          if (stack.indexOf(value) > -1) {
	            throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	          }
	        }
	
	        stack.push(value);
	        angular.forEach(value, function (propertyValue, propertyKey) {
	
	          /* Skipping function properties. */
	          if (angular.isFunction(propertyValue)) {
	            return;
	          }
	
	          result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	        });
	        stack.splice(-1, 1); // remove last
	
	        return result;
	      } else if (angular.isNumber(value)) {
	        return value;
	      } else if (value === true || value === false) {
	        return value;
	      } else if (!angular.isUndefined(value) && value !== null) {
	        return iteratee(value);
	      } else {
	        return value;
	      }
	    };
	  }
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateProvider
	   * @description
	   *
	   * $translateProvider allows developers to register translation-tables, asynchronous loaders
	   * and similar to configure translation behavior directly inside of a module.
	   *
	   */
	  angular.module('pascalprecht.translate').constant('pascalprechtTranslateOverrider', {}).provider('$translate', $translate);
	
	  function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	    'use strict';
	
	    var $translationTable = {},
	        $preferredLanguage,
	        $availableLanguageKeys = [],
	        $languageKeyAliases,
	        $fallbackLanguage,
	        $fallbackWasString,
	        $uses,
	        $nextLang,
	        $storageFactory,
	        $storageKey = $STORAGE_KEY,
	        $storagePrefix,
	        $missingTranslationHandlerFactory,
	        $interpolationFactory,
	        $interpolatorFactories = [],
	        $loaderFactory,
	        $cloakClassName = 'translate-cloak',
	        $loaderOptions,
	        $notFoundIndicatorLeft,
	        $notFoundIndicatorRight,
	        $postCompilingEnabled = false,
	        $forceAsyncReloadEnabled = false,
	        $nestedObjectDelimeter = '.',
	        $isReady = false,
	        $keepContent = false,
	        loaderCache,
	        directivePriority = 0,
	        statefulFilter = true,
	        postProcessFn,
	        uniformLanguageTagResolver = 'default',
	        languageTagResolver = {
	      'default': function _default(tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java: function java(tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? parts[0].toLowerCase() + '_' + parts[1].toUpperCase() : temp;
	      },
	      bcp47: function bcp47(tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1:
	            // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2:
	            // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) {
	              // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else {
	              // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3:
	            // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1': function iso6391(tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	    var version = '2.17.0';
	
	    // tries to determine the browsers language
	    var getFirstBrowserLanguage = function getFirstBrowserLanguage() {
	
	      // internal purpose only
	      if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	        return pascalprechtTranslateOverrider.getLocale();
	      }
	
	      var nav = $windowProvider.$get().navigator,
	          browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	          i,
	          language;
	
	      // support for HTML 5.1 "navigator.languages"
	      if (angular.isArray(nav.languages)) {
	        for (i = 0; i < nav.languages.length; i++) {
	          language = nav.languages[i];
	          if (language && language.length) {
	            return language;
	          }
	        }
	      }
	
	      // support for other well known properties in browsers
	      for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	        language = nav[browserLanguagePropertyKeys[i]];
	        if (language && language.length) {
	          return language;
	        }
	      }
	
	      return null;
	    };
	    getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	    // tries to determine the browsers locale
	    var getLocale = function getLocale() {
	      var locale = getFirstBrowserLanguage() || '';
	      if (languageTagResolver[uniformLanguageTagResolver]) {
	        locale = languageTagResolver[uniformLanguageTagResolver](locale);
	      }
	      return locale;
	    };
	    getLocale.displayName = 'angular-translate/service: getLocale';
	
	    /**
	     * @name indexOf
	     * @private
	     *
	     * @description
	     * indexOf polyfill. Kinda sorta.
	     *
	     * @param {array} array Array to search in.
	     * @param {string} searchElement Element to search for.
	     *
	     * @returns {int} Index of search element.
	     */
	    var indexOf = function indexOf(array, searchElement) {
	      for (var i = 0, len = array.length; i < len; i++) {
	        if (array[i] === searchElement) {
	          return i;
	        }
	      }
	      return -1;
	    };
	
	    /**
	     * @name trim
	     * @private
	     *
	     * @description
	     * trim polyfill
	     *
	     * @returns {string} The string stripped of whitespace from both ends
	     */
	    var trim = function trim() {
	      return this.toString().replace(/^\s+|\s+$/g, '');
	    };
	
	    /**
	     * @name lowercase
	     * @private
	     *
	     * @description
	     * Return the lowercase string only if the type is string
	     *
	     * @returns {string} The string all in lowercase
	     */
	    var lowercase = function lowercase(string) {
	      return angular.isString(string) ? string.toLowerCase() : string;
	    };
	
	    var negotiateLocale = function negotiateLocale(preferred) {
	      if (!preferred) {
	        return;
	      }
	
	      var avail = [],
	          locale = lowercase(preferred),
	          i = 0,
	          n = $availableLanguageKeys.length;
	
	      for (; i < n; i++) {
	        avail.push(lowercase($availableLanguageKeys[i]));
	      }
	
	      // Check for an exact match in our list of available keys
	      i = indexOf(avail, locale);
	      if (i > -1) {
	        return $availableLanguageKeys[i];
	      }
	
	      if ($languageKeyAliases) {
	        var alias;
	        for (var langKeyAlias in $languageKeyAliases) {
	          if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	            var hasWildcardKey = false;
	            var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) && lowercase(langKeyAlias) === lowercase(preferred);
	
	            if (langKeyAlias.slice(-1) === '*') {
	              hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	            }
	            if (hasExactKey || hasWildcardKey) {
	              alias = $languageKeyAliases[langKeyAlias];
	              if (indexOf(avail, lowercase(alias)) > -1) {
	                return alias;
	              }
	            }
	          }
	        }
	      }
	
	      // Check for a language code without region
	      var parts = preferred.split('_');
	
	      if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	        return parts[0];
	      }
	
	      // If everything fails, return undefined.
	      return;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#translations
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Registers a new translation table for specific language key.
	     *
	     * To register a translation table for specific language, pass a defined language
	     * key as first parameter.
	     *
	     * <pre>
	     *  // register translation table for language: 'de_DE'
	     *  $translateProvider.translations('de_DE', {
	     *    'GREETING': 'Hallo Welt!'
	     *  });
	     *
	     *  // register another one
	     *  $translateProvider.translations('en_US', {
	     *    'GREETING': 'Hello world!'
	     *  });
	     * </pre>
	     *
	     * When registering multiple translation tables for for the same language key,
	     * the actual translation table gets extended. This allows you to define module
	     * specific translation which only get added, once a specific module is loaded in
	     * your app.
	     *
	     * Invoking this method with no arguments returns the translation table which was
	     * registered with no language key. Invoking it with a language key returns the
	     * related translation table.
	     *
	     * @param {string} langKey A language key.
	     * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	     *
	     */
	    var translations = function translations(langKey, translationTable) {
	
	      if (!langKey && !translationTable) {
	        return $translationTable;
	      }
	
	      if (langKey && !translationTable) {
	        if (angular.isString(langKey)) {
	          return $translationTable[langKey];
	        }
	      } else {
	        if (!angular.isObject($translationTable[langKey])) {
	          $translationTable[langKey] = {};
	        }
	        angular.extend($translationTable[langKey], flatObject(translationTable));
	      }
	      return this;
	    };
	
	    this.translations = translations;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#cloakClassName
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     *
	     * Let's you change the class name for `translate-cloak` directive.
	     * Default class name is `translate-cloak`.
	     *
	     * @param {string} name translate-cloak class name
	     */
	    this.cloakClassName = function (name) {
	      if (!name) {
	        return $cloakClassName;
	      }
	      $cloakClassName = name;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     *
	     * Let's you change the delimiter for namespaced translations.
	     * Default delimiter is `.`.
	     *
	     * @param {string} delimiter namespace separator
	     */
	    this.nestedObjectDelimeter = function (delimiter) {
	      if (!delimiter) {
	        return $nestedObjectDelimeter;
	      }
	      $nestedObjectDelimeter = delimiter;
	      return this;
	    };
	
	    /**
	     * @name flatObject
	     * @private
	     *
	     * @description
	     * Flats an object. This function is used to flatten given translation data with
	     * namespaces, so they are later accessible via dot notation.
	     */
	    var flatObject = function flatObject(data, path, result, prevKey) {
	      var key, keyWithPath, keyWithShortPath, val;
	
	      if (!path) {
	        path = [];
	      }
	      if (!result) {
	        result = {};
	      }
	      for (key in data) {
	        if (!Object.prototype.hasOwnProperty.call(data, key)) {
	          continue;
	        }
	        val = data[key];
	        if (angular.isObject(val)) {
	          flatObject(val, path.concat(key), result, key);
	        } else {
	          keyWithPath = path.length ? '' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key : key;
	          if (path.length && key === prevKey) {
	            // Create shortcut path (foo.bar == foo.bar.bar)
	            keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	            // Link it to original path
	            result[keyWithShortPath] = '@:' + keyWithPath;
	          }
	          result[keyWithPath] = val;
	        }
	      }
	      return result;
	    };
	    flatObject.displayName = 'flatObject';
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#addInterpolation
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Adds interpolation services to angular-translate, so it can manage them.
	     *
	     * @param {object} factory Interpolation service factory
	     */
	    this.addInterpolation = function (factory) {
	      $interpolatorFactories.push(factory);
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to use interpolation functionality of messageformat.js.
	     * This is useful when having high level pluralization and gender selection.
	     */
	    this.useMessageFormatInterpolation = function () {
	      return this.useInterpolation('$translateMessageFormatInterpolation');
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useInterpolation
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate which interpolation style to use as default, application-wide.
	     * Simply pass a factory/service name. The interpolation service has to implement
	     * the correct interface.
	     *
	     * @param {string} factory Interpolation service name.
	     */
	    this.useInterpolation = function (factory) {
	      $interpolationFactory = factory;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Simply sets a sanitation strategy type.
	     *
	     * @param {string} value Strategy type.
	     */
	    this.useSanitizeValueStrategy = function (value) {
	      $translateSanitizationProvider.useStrategy(value);
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#preferredLanguage
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells the module which of the registered translation tables to use for translation
	     * at initial startup by passing a language key. Similar to `$translateProvider#use`
	     * only that it says which language to **prefer**.
	     * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	     *
	     * @param {string} langKey A language key.
	     */
	    this.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	        return this;
	      }
	      return $preferredLanguage;
	    };
	    var setupPreferredLanguage = function setupPreferredLanguage(langKey) {
	      if (langKey) {
	        $preferredLanguage = langKey;
	      }
	      return $preferredLanguage;
	    };
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Sets an indicator which is used when a translation isn't found. E.g. when
	     * setting the indicator as 'X' and one tries to translate a translation id
	     * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	     *
	     * Internally this methods sets a left indicator and a right indicator using
	     * `$translateProvider.translationNotFoundIndicatorLeft()` and
	     * `$translateProvider.translationNotFoundIndicatorRight()`.
	     *
	     * **Note**: These methods automatically add a whitespace between the indicators
	     * and the translation id.
	     *
	     * @param {string} indicator An indicator, could be any string.
	     */
	    this.translationNotFoundIndicator = function (indicator) {
	      this.translationNotFoundIndicatorLeft(indicator);
	      this.translationNotFoundIndicatorRight(indicator);
	      return this;
	    };
	
	    /**
	     * ngdoc function
	     * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Sets an indicator which is used when a translation isn't found left to the
	     * translation id.
	     *
	     * @param {string} indicator An indicator.
	     */
	    this.translationNotFoundIndicatorLeft = function (indicator) {
	      if (!indicator) {
	        return $notFoundIndicatorLeft;
	      }
	      $notFoundIndicatorLeft = indicator;
	      return this;
	    };
	
	    /**
	     * ngdoc function
	     * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Sets an indicator which is used when a translation isn't found right to the
	     * translation id.
	     *
	     * @param {string} indicator An indicator.
	     */
	    this.translationNotFoundIndicatorRight = function (indicator) {
	      if (!indicator) {
	        return $notFoundIndicatorRight;
	      }
	      $notFoundIndicatorRight = indicator;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells the module which of the registered translation tables to use when missing translations
	     * at initial startup by passing a language key. Similar to `$translateProvider#use`
	     * only that it says which language to **fallback**.
	     *
	     * @param {string||array} langKey A language key.
	     *
	     */
	    this.fallbackLanguage = function (langKey) {
	      fallbackStack(langKey);
	      return this;
	    };
	
	    var fallbackStack = function fallbackStack(langKey) {
	      if (langKey) {
	        if (angular.isString(langKey)) {
	          $fallbackWasString = true;
	          $fallbackLanguage = [langKey];
	        } else if (angular.isArray(langKey)) {
	          $fallbackWasString = false;
	          $fallbackLanguage = langKey;
	        }
	        if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	          $fallbackLanguage.push($preferredLanguage);
	        }
	
	        return this;
	      } else {
	        if ($fallbackWasString) {
	          return $fallbackLanguage[0];
	        } else {
	          return $fallbackLanguage;
	        }
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#use
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Set which translation table to use for translation by given language key. When
	     * trying to 'use' a language which isn't provided, it'll throw an error.
	     *
	     * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	     * does the job too.
	     *
	     * @param {string} langKey A language key.
	     */
	    this.use = function (langKey) {
	      if (langKey) {
	        if (!$translationTable[langKey] && !$loaderFactory) {
	          // only throw an error, when not loading translation data asynchronously
	          throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	        }
	        $uses = langKey;
	        return this;
	      }
	      return $uses;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    this.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#storageKey
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells the module which key must represent the choosed language by a user in the storage.
	     *
	     * @param {string} key A key for the storage.
	     */
	    var storageKey = function storageKey(key) {
	      if (!key) {
	        if ($storagePrefix) {
	          return $storagePrefix + $storageKey;
	        }
	        return $storageKey;
	      }
	      $storageKey = key;
	      return this;
	    };
	
	    this.storageKey = storageKey;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useUrlLoader
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	     *
	     * @param {string} url Url
	     * @param {Object=} options Optional configuration object
	     */
	    this.useUrlLoader = function (url, options) {
	      return this.useLoader('$translateUrlLoader', angular.extend({ url: url }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	     *
	     * @param {Object=} options Optional configuration object
	     */
	    this.useStaticFilesLoader = function (options) {
	      return this.useLoader('$translateStaticFilesLoader', options);
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useLoader
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to use any other service as loader.
	     *
	     * @param {string} loaderFactory Factory name to use
	     * @param {Object=} options Optional configuration object
	     */
	    this.useLoader = function (loaderFactory, options) {
	      $loaderFactory = loaderFactory;
	      $loaderOptions = options || {};
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useLocalStorage
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	     *
	     */
	    this.useLocalStorage = function () {
	      return this.useStorage('$translateLocalStorage');
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useCookieStorage
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	     */
	    this.useCookieStorage = function () {
	      return this.useStorage('$translateCookieStorage');
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useStorage
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to use custom service as storage layer.
	     */
	    this.useStorage = function (storageFactory) {
	      $storageFactory = storageFactory;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#storagePrefix
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Sets prefix for storage key.
	     *
	     * @param {string} prefix Storage key prefix
	     */
	    this.storagePrefix = function (prefix) {
	      if (!prefix) {
	        return prefix;
	      }
	      $storagePrefix = prefix;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to use built-in log handler when trying to translate
	     * a translation Id which doesn't exist.
	     *
	     * This is actually a shortcut method for `useMissingTranslationHandler()`.
	     *
	     */
	    this.useMissingTranslationHandlerLog = function () {
	      return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Expects a factory name which later gets instantiated with `$injector`.
	     * This method can be used to tell angular-translate to use a custom
	     * missingTranslationHandler. Just build a factory which returns a function
	     * and expects a translation id as argument.
	     *
	     * Example:
	     * <pre>
	     *  app.config(function ($translateProvider) {
	     *    $translateProvider.useMissingTranslationHandler('customHandler');
	     *  });
	     *
	     *  app.factory('customHandler', function (dep1, dep2) {
	     *    return function (translationId) {
	     *      // something with translationId and dep1 and dep2
	     *    };
	     *  });
	     * </pre>
	     *
	     * @param {string} factory Factory name
	     */
	    this.useMissingTranslationHandler = function (factory) {
	      $missingTranslationHandlerFactory = factory;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#usePostCompiling
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * If post compiling is enabled, all translated values will be processed
	     * again with AngularJS' $compile.
	     *
	     * Example:
	     * <pre>
	     *  app.config(function ($translateProvider) {
	     *    $translateProvider.usePostCompiling(true);
	     *  });
	     * </pre>
	     *
	     * @param {string} factory Factory name
	     */
	    this.usePostCompiling = function (value) {
	      $postCompilingEnabled = !!value;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * If force async reload is enabled, async loader will always be called
	     * even if $translationTable already contains the language key, adding
	     * possible new entries to the $translationTable.
	     *
	     * Example:
	     * <pre>
	     *  app.config(function ($translateProvider) {
	     *    $translateProvider.forceAsyncReload(true);
	     *  });
	     * </pre>
	     *
	     * @param {boolean} value - valid values are true or false
	     */
	    this.forceAsyncReload = function (value) {
	      $forceAsyncReloadEnabled = !!value;
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate which language tag should be used as a result when determining
	     * the current browser language.
	     *
	     * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	     *
	     * <pre>
	     * $translateProvider
	     *   .uniformLanguageTag('bcp47')
	     *   .determinePreferredLanguage()
	     * </pre>
	     *
	     * The resolver currently supports:
	     * * default
	     *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	     *     en-US => en_US
	     *     en_US => en_US
	     *     en-us => en_us
	     * * java
	     *     like default, but the second part will be always in uppercase
	     *     en-US => en_US
	     *     en_US => en_US
	     *     en-us => en_US
	     * * BCP 47 (RFC 4646 & 4647)
	     *     EN => en
	     *     en-US => en-US
	     *     en_US => en-US
	     *     en-us => en-US
	     *     sr-latn => sr-Latn
	     *     sr-latn-rs => sr-Latn-RS
	     *
	     * See also:
	     * * http://en.wikipedia.org/wiki/IETF_language_tag
	     * * http://www.w3.org/International/core/langtags/
	     * * http://tools.ietf.org/html/bcp47
	     *
	     * @param {string|object} options - options (or standard)
	     * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	     */
	    this.uniformLanguageTag = function (options) {
	
	      if (!options) {
	        options = {};
	      } else if (angular.isString(options)) {
	        options = {
	          standard: options
	        };
	      }
	
	      uniformLanguageTagResolver = options.standard;
	
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Tells angular-translate to try to determine on its own which language key
	     * to set as preferred language. When `fn` is given, angular-translate uses it
	     * to determine a language key, otherwise it uses the built-in `getLocale()`
	     * method.
	     *
	     * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	     * `[lang]` depending on what the browser provides.
	     *
	     * Use this method at your own risk, since not all browsers return a valid
	     * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	     *
	     * @param {Function=} fn Function to determine a browser's locale
	     */
	    this.determinePreferredLanguage = function (fn) {
	
	      var locale = fn && angular.isFunction(fn) ? fn() : getLocale();
	
	      if (!$availableLanguageKeys.length) {
	        $preferredLanguage = locale;
	      } else {
	        $preferredLanguage = negotiateLocale(locale) || locale;
	      }
	
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Registers a set of language keys the app will work with. Use this method in
	     * combination with
	     * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	     * When available languages keys are registered, angular-translate
	     * tries to find the best fitting language key depending on the browsers locale,
	     * considering your language key convention.
	     *
	     * @param {object} languageKeys Array of language keys the your app will use
	     * @param {object=} aliases Alias map.
	     */
	    this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	      if (languageKeys) {
	        $availableLanguageKeys = languageKeys;
	        if (aliases) {
	          $languageKeyAliases = aliases;
	        }
	        return this;
	      }
	      return $availableLanguageKeys;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#useLoaderCache
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Registers a cache for internal $http based loaders.
	     * {@link pascalprecht.translate.$translationCache $translationCache}.
	     * When false the cache will be disabled (default). When true or undefined
	     * the cache will be a default (see $cacheFactory). When an object it will
	     * be treat as a cache object itself: the usage is $http({cache: cache})
	     *
	     * @param {object} cache boolean, string or cache-object
	     */
	    this.useLoaderCache = function (cache) {
	      if (cache === false) {
	        // disable cache
	        loaderCache = undefined;
	      } else if (cache === true) {
	        // enable cache using AJS defaults
	        loaderCache = true;
	      } else if (typeof cache === 'undefined') {
	        // enable cache using default
	        loaderCache = '$translationCache';
	      } else if (cache) {
	        // enable cache using given one (see $cacheFactory)
	        loaderCache = cache;
	      }
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#directivePriority
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Sets the default priority of the translate directive. The standard value is `0`.
	     * Calling this function without an argument will return the current value.
	     *
	     * @param {number} priority for the translate-directive
	     */
	    this.directivePriority = function (priority) {
	      if (priority === undefined) {
	        // getter
	        return directivePriority;
	      } else {
	        // setter with chaining
	        directivePriority = priority;
	        return this;
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#statefulFilter
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	     * have to explicit define this behavior.
	     * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	     * meaning being stateful.
	     * Calling this function without an argument will return the current value.
	     *
	     * @param {boolean} state - defines the state of the filter
	     */
	    this.statefulFilter = function (state) {
	      if (state === undefined) {
	        // getter
	        return statefulFilter;
	      } else {
	        // setter with chaining
	        statefulFilter = state;
	        return this;
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#postProcess
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * The post processor will be intercept right after the translation result. It can modify the result.
	     *
	     * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	     */
	    this.postProcess = function (fn) {
	      if (fn) {
	        postProcessFn = fn;
	      } else {
	        postProcessFn = undefined;
	      }
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateProvider#keepContent
	     * @methodOf pascalprecht.translate.$translateProvider
	     *
	     * @description
	     * If keepContent is set to true than translate directive will always use innerHTML
	     * as a default translation
	     *
	     * Example:
	     * <pre>
	     *  app.config(function ($translateProvider) {
	     *    $translateProvider.keepContent(true);
	     *  });
	     * </pre>
	     *
	     * @param {boolean} value - valid values are true or false
	     */
	    this.keepContent = function (value) {
	      $keepContent = !!value;
	      return this;
	    };
	
	    /**
	     * @ngdoc object
	     * @name pascalprecht.translate.$translate
	     * @requires $interpolate
	     * @requires $log
	     * @requires $rootScope
	     * @requires $q
	     *
	     * @description
	     * The `$translate` service is the actual core of angular-translate. It expects a translation id
	     * and optional interpolate parameters to translate contents.
	     *
	     * <pre>
	     *  $translate('HEADLINE_TEXT').then(function (translation) {
	     *    $scope.translatedText = translation;
	     *  });
	     * </pre>
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function returns an object where each key
	     *                                     is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] An object hash for dynamic values
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	     *                                        as default text in case it is not found in any configured language
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     * @returns {object} promise
	     */
	    this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	      var Storage,
	          defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	          pendingLoader = false,
	          interpolatorHashMap = {},
	          langPromises = {},
	          fallbackIndex,
	          startFallbackIteration;
	
	      var $translate = function $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	        if (!$uses && $preferredLanguage) {
	          $uses = $preferredLanguage;
	        }
	        var uses = forceLanguage && forceLanguage !== $uses ? // we don't want to re-negotiate $uses
	        negotiateLocale(forceLanguage) || forceLanguage : $uses;
	
	        // Check forceLanguage is present
	        if (forceLanguage) {
	          loadTranslationsIfMissing(forceLanguage);
	        }
	
	        // Duck detection: If the first argument is an array, a bunch of translations was requested.
	        // The result is an object.
	        if (angular.isArray(translationId)) {
	          // Inspired by Q.allSettled by Kris Kowal
	          // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	          // This transforms all promises regardless resolved or rejected
	          var translateAll = function translateAll(translationIds) {
	            var results = {}; // storing the actual results
	            var promises = []; // promises to wait for
	            // Wraps the promise a) being always resolved and b) storing the link id->value
	            var translate = function translate(translationId) {
	              var deferred = $q.defer();
	              var regardless = function regardless(value) {
	                results[translationId] = value;
	                deferred.resolve([translationId, value]);
	              };
	              // we don't care whether the promise was resolved or rejected; just store the values
	              $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	              return deferred.promise;
	            };
	            for (var i = 0, c = translationIds.length; i < c; i++) {
	              promises.push(translate(translationIds[i]));
	            }
	            // wait for all (including storing to results)
	            return $q.all(promises).then(function () {
	              // return the results
	              return results;
	            });
	          };
	          return translateAll(translationId);
	        }
	
	        var deferred = $q.defer();
	
	        // trim off any whitespace
	        if (translationId) {
	          translationId = trim.apply(translationId);
	        }
	
	        var promiseToWaitFor = function () {
	          var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	          fallbackIndex = 0;
	
	          if ($storageFactory && !promise) {
	            // looks like there's no pending promise for $preferredLanguage or
	            // $uses. Maybe there's one pending for a language that comes from
	            // storage.
	            var langKey = Storage.get($storageKey);
	            promise = langPromises[langKey];
	
	            if ($fallbackLanguage && $fallbackLanguage.length) {
	              var index = indexOf($fallbackLanguage, langKey);
	              // maybe the language from storage is also defined as fallback language
	              // we increase the fallback language index to not search in that language
	              // as fallback, since it's probably the first used language
	              // in that case the index starts after the first element
	              fallbackIndex = index === 0 ? 1 : 0;
	
	              // but we can make sure to ALWAYS fallback to preferred language at least
	              if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	                $fallbackLanguage.push($preferredLanguage);
	              }
	            }
	          }
	          return promise;
	        }();
	
	        if (!promiseToWaitFor) {
	          // no promise to wait for? okay. Then there's no loader registered
	          // nor is a one pending for language that comes from storage.
	          // We can just translate.
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        } else {
	          var promiseResolved = function promiseResolved() {
	            // $uses may have changed while waiting
	            if (!forceLanguage) {
	              uses = $uses;
	            }
	            determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          };
	          promiseResolved.displayName = 'promiseResolved';
	
	          promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name applyNotFoundIndicators
	       * @private
	       *
	       * @description
	       * Applies not fount indicators to given translation id, if needed.
	       * This function gets only executed, if a translation id doesn't exist,
	       * which is why a translation id is expected as argument.
	       *
	       * @param {string} translationId Translation id.
	       * @returns {string} Same as given translation id but applied with not found
	       * indicators.
	       */
	      var applyNotFoundIndicators = function applyNotFoundIndicators(translationId) {
	        // applying notFoundIndicators
	        if ($notFoundIndicatorLeft) {
	          translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	        }
	        if ($notFoundIndicatorRight) {
	          translationId = [translationId, $notFoundIndicatorRight].join(' ');
	        }
	        return translationId;
	      };
	
	      /**
	       * @name useLanguage
	       * @private
	       *
	       * @description
	       * Makes actual use of a language by setting a given language key as used
	       * language and informs registered interpolators to also use the given
	       * key as locale.
	       *
	       * @param {string} key Locale key.
	       */
	      var useLanguage = function useLanguage(key) {
	        $uses = key;
	
	        // make sure to store new language key before triggering success event
	        if ($storageFactory) {
	          Storage.put($translate.storageKey(), $uses);
	        }
	
	        $rootScope.$emit('$translateChangeSuccess', { language: key });
	
	        // inform default interpolator
	        defaultInterpolator.setLocale($uses);
	
	        var eachInterpolator = function eachInterpolator(interpolator, id) {
	          interpolatorHashMap[id].setLocale($uses);
	        };
	        eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	        // inform all others too!
	        angular.forEach(interpolatorHashMap, eachInterpolator);
	        $rootScope.$emit('$translateChangeEnd', { language: key });
	      };
	
	      /**
	       * @name loadAsync
	       * @private
	       *
	       * @description
	       * Kicks off registered async loader using `$injector` and applies existing
	       * loader options. When resolved, it updates translation tables accordingly
	       * or rejects with given language key.
	       *
	       * @param {string} key Language key.
	       * @return {Promise} A promise.
	       */
	      var loadAsync = function loadAsync(key) {
	        if (!key) {
	          throw 'No language key specified for loading.';
	        }
	
	        var deferred = $q.defer();
	
	        $rootScope.$emit('$translateLoadingStart', { language: key });
	        pendingLoader = true;
	
	        var cache = loaderCache;
	        if (typeof cache === 'string') {
	          // getting on-demand instance of loader
	          cache = $injector.get(cache);
	        }
	
	        var loaderOptions = angular.extend({}, $loaderOptions, {
	          key: key,
	          $http: angular.extend({}, {
	            cache: cache
	          }, $loaderOptions.$http)
	        });
	
	        var onLoaderSuccess = function onLoaderSuccess(data) {
	          var translationTable = {};
	          $rootScope.$emit('$translateLoadingSuccess', { language: key });
	
	          if (angular.isArray(data)) {
	            angular.forEach(data, function (table) {
	              angular.extend(translationTable, flatObject(table));
	            });
	          } else {
	            angular.extend(translationTable, flatObject(data));
	          }
	          pendingLoader = false;
	          deferred.resolve({
	            key: key,
	            table: translationTable
	          });
	          $rootScope.$emit('$translateLoadingEnd', { language: key });
	        };
	        onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	        var onLoaderError = function onLoaderError(key) {
	          $rootScope.$emit('$translateLoadingError', { language: key });
	          deferred.reject(key);
	          $rootScope.$emit('$translateLoadingEnd', { language: key });
	        };
	        onLoaderError.displayName = 'onLoaderError';
	
	        $injector.get($loaderFactory)(loaderOptions).then(onLoaderSuccess, onLoaderError);
	
	        return deferred.promise;
	      };
	
	      if ($storageFactory) {
	        Storage = $injector.get($storageFactory);
	
	        if (!Storage.get || !Storage.put) {
	          throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	        }
	      }
	
	      // if we have additional interpolations that were added via
	      // $translateProvider.addInterpolation(), we have to map'em
	      if ($interpolatorFactories.length) {
	        var eachInterpolationFactory = function eachInterpolationFactory(interpolatorFactory) {
	          var interpolator = $injector.get(interpolatorFactory);
	          // setting initial locale for each interpolation service
	          interpolator.setLocale($preferredLanguage || $uses);
	          // make'em recognizable through id
	          interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	        };
	        eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	        angular.forEach($interpolatorFactories, eachInterpolationFactory);
	      }
	
	      /**
	       * @name getTranslationTable
	       * @private
	       *
	       * @description
	       * Returns a promise that resolves to the translation table
	       * or is rejected if an error occurred.
	       *
	       * @param langKey
	       * @returns {Q.promise}
	       */
	      var getTranslationTable = function getTranslationTable(langKey) {
	        var deferred = $q.defer();
	        if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	          deferred.resolve($translationTable[langKey]);
	        } else if (langPromises[langKey]) {
	          var onResolve = function onResolve(data) {
	            translations(data.key, data.table);
	            deferred.resolve(data.table);
	          };
	          onResolve.displayName = 'translationTableResolver';
	          langPromises[langKey].then(onResolve, deferred.reject);
	        } else {
	          deferred.reject();
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name getFallbackTranslation
	       * @private
	       *
	       * @description
	       * Returns a promise that will resolve to the translation
	       * or be rejected if no translation was found for the language.
	       * This function is currently only used for fallback language translation.
	       *
	       * @param langKey The language to translate to.
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @param sanitizeStrategy
	       * @returns {Q.promise}
	       */
	      var getFallbackTranslation = function getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	        var deferred = $q.defer();
	
	        var onResolve = function onResolve(translationTable) {
	          if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	            Interpolator.setLocale(langKey);
	            var translation = translationTable[translationId];
	            if (translation.substr(0, 2) === '@:') {
	              getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	            } else {
	              var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	              interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	              deferred.resolve(interpolatedValue);
	            }
	            Interpolator.setLocale($uses);
	          } else {
	            deferred.reject();
	          }
	        };
	        onResolve.displayName = 'fallbackTranslationResolver';
	
	        getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	        return deferred.promise;
	      };
	
	      /**
	       * @name getFallbackTranslationInstant
	       * @private
	       *
	       * @description
	       * Returns a translation
	       * This function is currently only used for fallback language translation.
	       *
	       * @param langKey The language to translate to.
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @param sanitizeStrategy sanitize strategy override
	       *
	       * @returns {string} translation
	       */
	      var getFallbackTranslationInstant = function getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	        var result,
	            translationTable = $translationTable[langKey];
	
	        if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	          // workaround for TrustedValueHolderType
	          if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	            var result2 = result.$$unwrapTrustedValue();
	            if (result2.substr(0, 2) === '@:') {
	              return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	            }
	          } else if (result.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	          Interpolator.setLocale($uses);
	        }
	
	        return result;
	      };
	
	      /**
	       * @name translateByHandler
	       * @private
	       *
	       * Translate by missing translation handler.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param defaultTranslationText
	       * @param sanitizeStrategy sanitize strategy override
	       *
	       * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	       * absent
	       */
	      var translateByHandler = function translateByHandler(translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	        // If we have a handler factory - we might also call it here to determine if it provides
	        // a default text for a translationid that can't be found anywhere in our tables
	        if ($missingTranslationHandlerFactory) {
	          return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	        } else {
	          return translationId;
	        }
	      };
	
	      /**
	       * @name resolveForFallbackLanguage
	       * @private
	       *
	       * Recursive helper function for fallbackTranslation that will sequentially look
	       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	       *
	       * @param fallbackLanguageIndex
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @param defaultTranslationText
	       * @param sanitizeStrategy
	       * @returns {Q.promise} Promise that will resolve to the translation.
	       */
	      var resolveForFallbackLanguage = function resolveForFallbackLanguage(fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	        var deferred = $q.defer();
	
	        if (fallbackLanguageIndex < $fallbackLanguage.length) {
	          var langKey = $fallbackLanguage[fallbackLanguageIndex];
	          getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(function (data) {
	            deferred.resolve(data);
	          }, function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          });
	        } else {
	          // No translation found in any fallback language
	          // if a default translation text is set in the directive, then return this as a result
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	            // if no default translation is set and an error handler is defined, send it to the handler
	            // and then return the result if it isn't undefined
	            if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	              deferred.resolve(missingTranslationHandlerTranslation);
	            } else {
	              deferred.reject(applyNotFoundIndicators(translationId));
	            }
	          }
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name resolveForFallbackLanguageInstant
	       * @private
	       *
	       * Recursive helper function for fallbackTranslation that will sequentially look
	       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	       *
	       * @param fallbackLanguageIndex
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @param sanitizeStrategy
	       * @returns {string} translation
	       */
	      var resolveForFallbackLanguageInstant = function resolveForFallbackLanguageInstant(fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	        var result;
	
	        if (fallbackLanguageIndex < $fallbackLanguage.length) {
	          var langKey = $fallbackLanguage[fallbackLanguageIndex];
	          result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	          if (!result && result !== '') {
	            result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	          }
	        }
	        return result;
	      };
	
	      /**
	       * Translates with the usage of the fallback languages.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @param defaultTranslationText
	       * @param sanitizeStrategy
	       * @returns {Q.promise} Promise, that resolves to the translation.
	       */
	      var fallbackTranslation = function fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	        // Start with the fallbackLanguage with index 0
	        return resolveForFallbackLanguage(startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	      };
	
	      /**
	       * Translates with the usage of the fallback languages.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @param sanitizeStrategy
	       * @returns {String} translation
	       */
	      var fallbackTranslationInstant = function fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	        // Start with the fallbackLanguage with index 0
	        return resolveForFallbackLanguageInstant(startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	      };
	
	      var determineTranslation = function determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	        var deferred = $q.defer();
	
	        var table = uses ? $translationTable[uses] : $translationTable,
	            Interpolator = interpolationId ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	        // if the translation id exists, we can just interpolate it
	        if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	          var translation = table[translationId];
	
	          // If using link, rerun $translate with linked translationId and return it
	          if (translation.substr(0, 2) === '@:') {
	
	            $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          } else {
	            //
	            var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	            resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	            deferred.resolve(resolvedTranslation);
	          }
	        } else {
	          var missingTranslationHandlerTranslation;
	          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	          }
	
	          // since we couldn't translate the inital requested translation id,
	          // we try it now with one or more fallback languages, if fallback language(s) is
	          // configured.
	          if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	            fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            if (defaultTranslationText) {
	              deferred.resolve(defaultTranslationText);
	            } else {
	              deferred.resolve(missingTranslationHandlerTranslation);
	            }
	          } else {
	            if (defaultTranslationText) {
	              deferred.resolve(defaultTranslationText);
	            } else {
	              deferred.reject(applyNotFoundIndicators(translationId));
	            }
	          }
	        }
	        return deferred.promise;
	      };
	
	      var determineTranslationInstant = function determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	        var result,
	            table = uses ? $translationTable[uses] : $translationTable,
	            Interpolator = defaultInterpolator;
	
	        // if the interpolation id exists use custom interpolator
	        if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	          Interpolator = interpolatorHashMap[interpolationId];
	        }
	
	        // if the translation id exists, we can just interpolate it
	        if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	          var translation = table[translationId];
	
	          // If using link, rerun $translate with linked translationId and return it
	          if (translation.substr(0, 2) === '@:') {
	            result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	          } else {
	            result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	            result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	          }
	        } else {
	          var missingTranslationHandlerTranslation;
	          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          // since we couldn't translate the inital requested translation id,
	          // we try it now with one or more fallback languages, if fallback language(s) is
	          // configured.
	          if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	            fallbackIndex = 0;
	            result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            result = missingTranslationHandlerTranslation;
	          } else {
	            result = applyNotFoundIndicators(translationId);
	          }
	        }
	
	        return result;
	      };
	
	      var clearNextLangAndPromise = function clearNextLangAndPromise(key) {
	        if ($nextLang === key) {
	          $nextLang = undefined;
	        }
	        langPromises[key] = undefined;
	      };
	
	      var applyPostProcessing = function applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	        var fn = postProcessFn;
	
	        if (fn) {
	
	          if (typeof fn === 'string') {
	            // getting on-demand instance
	            fn = $injector.get(fn);
	          }
	          if (fn) {
	            return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	          }
	        }
	
	        return resolvedTranslation;
	      };
	
	      var loadTranslationsIfMissing = function loadTranslationsIfMissing(key) {
	        if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	          langPromises[key] = loadAsync(key).then(function (translation) {
	            translations(translation.key, translation.table);
	            return translation;
	          });
	        }
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#preferredLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key for the preferred language.
	       *
	       * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	       *
	       * @return {string} preferred language key
	       */
	      $translate.preferredLanguage = function (langKey) {
	        if (langKey) {
	          setupPreferredLanguage(langKey);
	        }
	        return $preferredLanguage;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#cloakClassName
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the configured class name for `translate-cloak` directive.
	       *
	       * @return {string} cloakClassName
	       */
	      $translate.cloakClassName = function () {
	        return $cloakClassName;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the configured delimiter for nested namespaces.
	       *
	       * @return {string} nestedObjectDelimeter
	       */
	      $translate.nestedObjectDelimeter = function () {
	        return $nestedObjectDelimeter;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#fallbackLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key for the fallback languages or sets a new fallback stack.
	       * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	       *
	       * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	       *
	       * @return {string||array} fallback language key
	       */
	      $translate.fallbackLanguage = function (langKey) {
	        if (langKey !== undefined && langKey !== null) {
	          fallbackStack(langKey);
	
	          // as we might have an async loader initiated and a new translation language might have been defined
	          // we need to add the promise to the stack also. So - iterate.
	          if ($loaderFactory) {
	            if ($fallbackLanguage && $fallbackLanguage.length) {
	              for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	                if (!langPromises[$fallbackLanguage[i]]) {
	                  langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	                }
	              }
	            }
	          }
	          $translate.use($translate.use());
	        }
	        if ($fallbackWasString) {
	          return $fallbackLanguage[0];
	        } else {
	          return $fallbackLanguage;
	        }
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#useFallbackLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Sets the first key of the fallback language stack to be used for translation.
	       * Therefore all languages in the fallback array BEFORE this key will be skipped!
	       *
	       * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	       * get back to the whole stack
	       */
	      $translate.useFallbackLanguage = function (langKey) {
	        if (langKey !== undefined && langKey !== null) {
	          if (!langKey) {
	            startFallbackIteration = 0;
	          } else {
	            var langKeyPosition = indexOf($fallbackLanguage, langKey);
	            if (langKeyPosition > -1) {
	              startFallbackIteration = langKeyPosition;
	            }
	          }
	        }
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#proposedLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key of language that is currently loaded asynchronously.
	       *
	       * @return {string} language key
	       */
	      $translate.proposedLanguage = function () {
	        return $nextLang;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#storage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns registered storage.
	       *
	       * @return {object} Storage
	       */
	      $translate.storage = function () {
	        return Storage;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#negotiateLocale
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns a language key based on available languages and language aliases. If a
	       * language key cannot be resolved, returns undefined.
	       *
	       * If no or a falsy key is given, returns undefined.
	       *
	       * @param {string} [key] Language key
	       * @return {string|undefined} Language key or undefined if no language key is found.
	       */
	      $translate.negotiateLocale = negotiateLocale;
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#use
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Tells angular-translate which language to use by given language key. This method is
	       * used to change language at runtime. It also takes care of storing the language
	       * key in a configured store to let your app remember the choosed language.
	       *
	       * When trying to 'use' a language which isn't available it tries to load it
	       * asynchronously with registered loaders.
	       *
	       * Returns promise object with loaded language file data or string of the currently used language.
	       *
	       * If no or a falsy key is given it returns the currently used language key.
	       * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	       * @example
	       * $translate.use("en_US").then(function(data){
	         *   $scope.text = $translate("HELLO");
	         * });
	       *
	       * @param {string=} key Language key
	       * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	       */
	      $translate.use = function (key) {
	        if (!key) {
	          return $uses;
	        }
	
	        var deferred = $q.defer();
	        deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	        $rootScope.$emit('$translateChangeStart', { language: key });
	
	        // Try to get the aliased language key
	        var aliasedKey = negotiateLocale(key);
	        // Ensure only registered language keys will be loaded
	        if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	          return $q.reject(key);
	        }
	
	        if (aliasedKey) {
	          key = aliasedKey;
	        }
	
	        // if there isn't a translation table for the language we've requested,
	        // we load it asynchronously
	        $nextLang = key;
	        if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	          langPromises[key] = loadAsync(key).then(function (translation) {
	            translations(translation.key, translation.table);
	            deferred.resolve(translation.key);
	            if ($nextLang === key) {
	              useLanguage(translation.key);
	            }
	            return translation;
	          }, function (key) {
	            $rootScope.$emit('$translateChangeError', { language: key });
	            deferred.reject(key);
	            $rootScope.$emit('$translateChangeEnd', { language: key });
	            return $q.reject(key);
	          });
	          langPromises[key]['finally'](function () {
	            clearNextLangAndPromise(key);
	          })['catch'](angular.noop); // we don't care about errors (clearing)
	        } else if (langPromises[key]) {
	          // we are already loading this asynchronously
	          // resolve our new deferred when the old langPromise is resolved
	          langPromises[key].then(function (translation) {
	            if ($nextLang === translation.key) {
	              useLanguage(translation.key);
	            }
	            deferred.resolve(translation.key);
	            return translation;
	          }, function (key) {
	            // find first available fallback language if that request has failed
	            if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	              return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	            } else {
	              return deferred.reject(key);
	            }
	          });
	        } else {
	          deferred.resolve(key);
	          useLanguage(key);
	        }
	
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#resolveClientLocale
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	       *
	       * @returns {string} the current client/browser language key
	       */
	      $translate.resolveClientLocale = function () {
	        return getLocale();
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#storageKey
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the key for the storage.
	       *
	       * @return {string} storage key
	       */
	      $translate.storageKey = function () {
	        return storageKey();
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether post compiling is enabled or not
	       *
	       * @return {bool} storage key
	       */
	      $translate.isPostCompilingEnabled = function () {
	        return $postCompilingEnabled;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether force async reload is enabled or not
	       *
	       * @return {boolean} forceAsyncReload value
	       */
	      $translate.isForceAsyncReloadEnabled = function () {
	        return $forceAsyncReloadEnabled;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isKeepContent
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether keepContent or not
	       *
	       * @return {boolean} keepContent value
	       */
	      $translate.isKeepContent = function () {
	        return $keepContent;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#refresh
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	       * the module will drop all existent translation tables and load new version of those which
	       * are currently in use.
	       *
	       * Refresh means that the module will drop target translation table and try to load it again.
	       *
	       * In case there are no loaders registered the refresh() method will throw an Error.
	       *
	       * If the module is able to refresh translation tables refresh() method will broadcast
	       * $translateRefreshStart and $translateRefreshEnd events.
	       *
	       * @example
	       * // this will drop all currently existent translation tables and reload those which are
	       * // currently in use
	       * $translate.refresh();
	       * // this will refresh a translation table for the en_US language
	       * $translate.refresh('en_US');
	       *
	       * @param {string} langKey A language key of the table, which has to be refreshed
	       *
	       * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	       * process is finished successfully, and reject if not.
	       */
	      $translate.refresh = function (langKey) {
	        if (!$loaderFactory) {
	          throw new Error('Couldn\'t refresh translation table, no loader registered!');
	        }
	
	        $rootScope.$emit('$translateRefreshStart', { language: langKey });
	
	        var deferred = $q.defer(),
	            updatedLanguages = {};
	
	        //private helper
	        function loadNewData(languageKey) {
	          var promise = loadAsync(languageKey);
	          //update the load promise cache for this language
	          langPromises[languageKey] = promise;
	          //register a data handler for the promise
	          promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	          return promise;
	        }
	
	        //set up post-processing
	        deferred.promise.then(function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop)['finally'](function () {
	          $rootScope.$emit('$translateRefreshEnd', { language: langKey });
	        });
	
	        if (!langKey) {
	          // if there's no language key specified we refresh ALL THE THINGS!
	          var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	          if ($uses && languagesToReload.indexOf($uses) === -1) {
	            languagesToReload.push($uses);
	          }
	          $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	        } else if ($translationTable[langKey]) {
	          //just refresh the specified language cache
	          loadNewData(langKey).then(deferred.resolve, deferred.reject);
	        } else {
	          deferred.reject();
	        }
	
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#instant
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns a translation instantly from the internal state of loaded translation. All rules
	       * regarding the current language, the preferred language of even fallback languages will be
	       * used except any promise handling. If a language was not found, an asynchronous loading
	       * will be invoked in the background.
	       *
	       * @param {string|array} translationId A token which represents a translation id
	       *                                     This can be optionally an array of translation ids which
	       *                                     results that the function's promise returns an object where
	       *                                     each key is the translation id and the value the translation.
	       * @param {object=} [interpolateParams={}] Params
	       * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	       * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	       * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	       *
	       * @return {string|object} translation
	       */
	      $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	        // we don't want to re-negotiate $uses
	        var uses = forceLanguage && forceLanguage !== $uses ? // we don't want to re-negotiate $uses
	        negotiateLocale(forceLanguage) || forceLanguage : $uses;
	
	        // Detect undefined and null values to shorten the execution and prevent exceptions
	        if (translationId === null || angular.isUndefined(translationId)) {
	          return translationId;
	        }
	
	        // Check forceLanguage is present
	        if (forceLanguage) {
	          loadTranslationsIfMissing(forceLanguage);
	        }
	
	        // Duck detection: If the first argument is an array, a bunch of translations was requested.
	        // The result is an object.
	        if (angular.isArray(translationId)) {
	          var results = {};
	          for (var i = 0, c = translationId.length; i < c; i++) {
	            results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	          }
	          return results;
	        }
	
	        // We discarded unacceptable values. So we just need to verify if translationId is empty String
	        if (angular.isString(translationId) && translationId.length < 1) {
	          return translationId;
	        }
	
	        // trim off any whitespace
	        if (translationId) {
	          translationId = trim.apply(translationId);
	        }
	
	        var result,
	            possibleLangKeys = [];
	        if ($preferredLanguage) {
	          possibleLangKeys.push($preferredLanguage);
	        }
	        if (uses) {
	          possibleLangKeys.push(uses);
	        }
	        if ($fallbackLanguage && $fallbackLanguage.length) {
	          possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	        }
	        for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	          var possibleLangKey = possibleLangKeys[j];
	          if ($translationTable[possibleLangKey]) {
	            if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	              result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	            }
	          }
	          if (typeof result !== 'undefined') {
	            break;
	          }
	        }
	
	        if (!result && result !== '') {
	          if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	            result = applyNotFoundIndicators(translationId);
	          } else {
	            // Return translation of default interpolator if not found anything.
	            result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            var missingTranslationHandlerTranslation;
	            if ($missingTranslationHandlerFactory && !pendingLoader) {
	              missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	            }
	
	            if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	              result = missingTranslationHandlerTranslation;
	            }
	          }
	        }
	
	        return result;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#versionInfo
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the current version information for the angular-translate library
	       *
	       * @return {string} angular-translate version
	       */
	      $translate.versionInfo = function () {
	        return version;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#loaderCache
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the defined loaderCache.
	       *
	       * @return {boolean|string|object} current value of loaderCache
	       */
	      $translate.loaderCache = function () {
	        return loaderCache;
	      };
	
	      // internal purpose only
	      $translate.directivePriority = function () {
	        return directivePriority;
	      };
	
	      // internal purpose only
	      $translate.statefulFilter = function () {
	        return statefulFilter;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isReady
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	       *
	       * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	       *
	       * @return {boolean} current value of ready
	       */
	      $translate.isReady = function () {
	        return $isReady;
	      };
	
	      var $onReadyDeferred = $q.defer();
	      $onReadyDeferred.promise.then(function () {
	        $isReady = true;
	      });
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#onReady
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	       *
	       * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	       *
	       * @param {Function=} fn Function to invoke when service is ready
	       * @return {object} Promise resolved when service is ready
	       */
	      $translate.onReady = function (fn) {
	        var deferred = $q.defer();
	        if (angular.isFunction(fn)) {
	          deferred.promise.then(fn);
	        }
	        if ($isReady) {
	          deferred.resolve();
	        } else {
	          $onReadyDeferred.promise.then(deferred.resolve);
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * This function simply returns the registered language keys being defined before in the config phase
	       * With this, an application can use the array to provide a language selection dropdown or similar
	       * without any additional effort
	       *
	       * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	       */
	      $translate.getAvailableLanguageKeys = function () {
	        if ($availableLanguageKeys.length > 0) {
	          return $availableLanguageKeys;
	        }
	        return null;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#getTranslationTable
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns translation table by the given language key.
	       *
	       * Unless a language is provided it returns a translation table of the current one.
	       * Note: If translation dictionary is currently downloading or in progress
	       * it will return null.
	       *
	       * @param {string} langKey A token which represents a translation id
	       *
	       * @return {object} a copy of angular-translate $translationTable
	       */
	      $translate.getTranslationTable = function (langKey) {
	        langKey = langKey || $translate.use();
	        if (langKey && $translationTable[langKey]) {
	          return angular.copy($translationTable[langKey]);
	        }
	        return null;
	      };
	
	      // Whenever $translateReady is being fired, this will ensure the state of $isReady
	      var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	        $onReadyDeferred.resolve();
	        globalOnReadyListener(); // one time only
	        globalOnReadyListener = null;
	      });
	      var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	        $onReadyDeferred.resolve();
	        globalOnChangeListener(); // one time only
	        globalOnChangeListener = null;
	      });
	
	      if ($loaderFactory) {
	
	        // If at least one async loader is defined and there are no
	        // (default) translations available we should try to load them.
	        if (angular.equals($translationTable, {})) {
	          if ($translate.use()) {
	            $translate.use($translate.use());
	          }
	        }
	
	        // Also, if there are any fallback language registered, we start
	        // loading them asynchronously as soon as we can.
	        if ($fallbackLanguage && $fallbackLanguage.length) {
	          var processAsyncResult = function processAsyncResult(translation) {
	            translations(translation.key, translation.table);
	            $rootScope.$emit('$translateChangeEnd', { language: translation.key });
	            return translation;
	          };
	          for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	            var fallbackLanguageId = $fallbackLanguage[i];
	            if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	              langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	            }
	          }
	        }
	      } else {
	        $rootScope.$emit('$translateReady', { language: $translate.use() });
	      }
	
	      return $translate;
	    }];
	  }
	
	  $translate.displayName = 'displayName';
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateDefaultInterpolation
	   * @requires $interpolate
	   *
	   * @description
	   * Uses angular's `$interpolate` services to interpolate strings against some values.
	   *
	   * Be aware to configure a proper sanitization strategy.
	   *
	   * See also:
	   * * {@link pascalprecht.translate.$translateSanitization}
	   *
	   * @return {object} $translateDefaultInterpolation Interpolator service
	   */
	  angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	  function $translateDefaultInterpolation($interpolate, $translateSanitization) {
	
	    'use strict';
	
	    var $translateInterpolator = {},
	        $locale,
	        $identifier = 'default';
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	     * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	     *
	     * @description
	     * Sets current locale (this is currently not use in this interpolation).
	     *
	     * @param {string} locale Language key or locale.
	     */
	    $translateInterpolator.setLocale = function (locale) {
	      $locale = locale;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	     * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	     *
	     * @description
	     * Returns an identifier for this interpolation service.
	     *
	     * @returns {string} $identifier
	     */
	    $translateInterpolator.getInterpolationIdentifier = function () {
	      return $identifier;
	    };
	
	    /**
	     * @deprecated will be removed in 3.0
	     * @see {@link pascalprecht.translate.$translateSanitization}
	     */
	    $translateInterpolator.useSanitizeValueStrategy = function (value) {
	      $translateSanitization.useStrategy(value);
	      return this;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	     * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	     *
	     * @description
	     * Interpolates given value agains given interpolate params using angulars
	     * `$interpolate` service.
	     *
	     * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	     *
	     * @param {string} value translation
	     * @param {object} [interpolationParams={}] interpolation params
	     * @param {string} [context=undefined] current context (filter, directive, service)
	     * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	     * @param {string} translationId current translationId
	     *
	     * @returns {string} interpolated string
	     */
	    $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) {
	      // jshint ignore:line
	      interpolationParams = interpolationParams || {};
	      interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	      var interpolatedText;
	      if (angular.isNumber(value)) {
	        // numbers are safe
	        interpolatedText = '' + value;
	      } else if (angular.isString(value)) {
	        // strings must be interpolated (that's the job here)
	        interpolatedText = $interpolate(value)(interpolationParams);
	        interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	      } else {
	        // neither a number or a string, cant interpolate => empty string
	        interpolatedText = '';
	      }
	
	      return interpolatedText;
	    };
	
	    return $translateInterpolator;
	  }
	
	  $translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	  angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	  angular.module('pascalprecht.translate')
	  /**
	   * @ngdoc directive
	   * @name pascalprecht.translate.directive:translate
	   * @requires $interpolate,
	   * @requires $compile,
	   * @requires $parse,
	   * @requires $rootScope
	   * @restrict AE
	   *
	   * @description
	   * Translates given translation id either through attribute or DOM content.
	   * Internally it uses $translate service to translate the translation id. It possible to
	   * pass an optional `translate-values` object literal as string into translation id.
	   *
	   * @param {string=} translate Translation id which could be either string or interpolated string.
	   * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	   * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	   * @param {string=} translate-default will be used unless translation was successful
	   * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	   * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	   * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	   *
	   * @example
	     <example module="ngView">
	      <file name="index.html">
	        <div ng-controller="TranslateCtrl">
	  
	          <pre translate="TRANSLATION_ID"></pre>
	          <pre translate>TRANSLATION_ID</pre>
	          <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	          <pre translate="{{translationId}}"></pre>
	          <pre translate>{{translationId}}</pre>
	          <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	          <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	          <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	          <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	          <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	          <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	  
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngView', ['pascalprecht.translate'])
	  
	        .config(function ($translateProvider) {
	  
	          $translateProvider.translations('en',{
	            'TRANSLATION_ID': 'Hello there!',
	            'WITH_VALUES': 'The following value is dynamic: {{value}}',
	            'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	          }).preferredLanguage('en');
	  
	        });
	  
	        angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	          $scope.translationId = 'TRANSLATION_ID';
	  
	          $scope.values = {
	            value: 78
	          };
	        });
	      </file>
	      <file name="scenario.js">
	        it('should translate', function () {
	          inject(function ($rootScope, $compile) {
	            $rootScope.translationId = 'TRANSLATION_ID';
	  
	            element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	            $rootScope.$digest();
	            expect(element.text()).toBe('Hello there!');
	  
	            element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	            $rootScope.$digest();
	            expect(element.text()).toBe('Hello there!');
	  
	            element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	            $rootScope.$digest();
	            expect(element.text()).toBe('Hello there!');
	  
	            element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	            $rootScope.$digest();
	            expect(element.text()).toBe('Hello there!');
	  
	            element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	            $rootScope.$digest();
	            expect(element.attr('title')).toBe('Hello there!');
	  
	            element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	            $rootScope.$digest();
	            expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	          });
	        });
	      </file>
	     </example>
	   */
	  .directive('translate', translateDirective);
	  function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	    'use strict';
	
	    /**
	     * @name trim
	     * @private
	     *
	     * @description
	     * trim polyfill
	     *
	     * @returns {string} The string stripped of whitespace from both ends
	     */
	
	    var trim = function trim() {
	      return this.toString().replace(/^\s+|\s+$/g, '');
	    };
	
	    /**
	     * @name lowercase
	     * @private
	     *
	     * @description
	     * Return the lowercase string only if the type is string
	     *
	     * @returns {string} The string all in lowercase
	     */
	    var lowercase = function lowercase(string) {
	      return angular.isString(string) ? string.toLowerCase() : string;
	    };
	
	    return {
	      restrict: 'AE',
	      scope: true,
	      priority: $translate.directivePriority(),
	      compile: function compile(tElement, tAttr) {
	
	        var translateValuesExist = tAttr.translateValues ? tAttr.translateValues : undefined;
	
	        var translateInterpolation = tAttr.translateInterpolation ? tAttr.translateInterpolation : undefined;
	
	        var translateSanitizeStrategyExist = tAttr.translateSanitizeStrategy ? tAttr.translateSanitizeStrategy : undefined;
	
	        var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	        var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	            watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	        return function linkFn(scope, iElement, iAttr) {
	
	          scope.interpolateParams = {};
	          scope.preText = '';
	          scope.postText = '';
	          scope.translateNamespace = getTranslateNamespace(scope);
	          var translationIds = {};
	
	          var initInterpolationParams = function initInterpolationParams(interpolateParams, iAttr, tAttr) {
	            // initial setup
	            if (iAttr.translateValues) {
	              angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	            }
	            // initially fetch all attributes if existing and fill the params
	            if (translateValueExist) {
	              for (var attr in tAttr) {
	                if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                  var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                  interpolateParams[attributeName] = tAttr[attr];
	                }
	              }
	            }
	          };
	
	          // Ensures any change of the attribute "translate" containing the id will
	          // be re-stored to the scope's "translationId".
	          // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	          var observeElementTranslation = function observeElementTranslation(translationId) {
	
	            // Remove any old watcher
	            if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	              observeElementTranslation._unwatchOld();
	              observeElementTranslation._unwatchOld = undefined;
	            }
	
	            if (angular.equals(translationId, '') || !angular.isDefined(translationId)) {
	              var iElementText = trim.apply(iElement.text());
	
	              // Resolve translation id by inner html if required
	              var interpolateMatches = iElementText.match(interpolateRegExp);
	              // Interpolate translation id if required
	              if (angular.isArray(interpolateMatches)) {
	                scope.preText = interpolateMatches[1];
	                scope.postText = interpolateMatches[3];
	                translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	                var watcherMatches = iElementText.match(watcherRegExp);
	                if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                  observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                    translationIds.translate = newValue;
	                    updateTranslations();
	                  });
	                }
	              } else {
	                // do not assigne the translation id if it is empty.
	                translationIds.translate = !iElementText ? undefined : iElementText;
	              }
	            } else {
	              translationIds.translate = translationId;
	            }
	            updateTranslations();
	          };
	
	          var observeAttributeTranslation = function observeAttributeTranslation(translateAttr) {
	            iAttr.$observe(translateAttr, function (translationId) {
	              translationIds[translateAttr] = translationId;
	              updateTranslations();
	            });
	          };
	
	          // initial setup with values
	          initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	          var firstAttributeChangedEvent = true;
	          iAttr.$observe('translate', function (translationId) {
	            if (typeof translationId === 'undefined') {
	              // case of element "<translate>xyz</translate>"
	              observeElementTranslation('');
	            } else {
	              // case of regular attribute
	              if (translationId !== '' || !firstAttributeChangedEvent) {
	                translationIds.translate = translationId;
	                updateTranslations();
	              }
	            }
	            firstAttributeChangedEvent = false;
	          });
	
	          for (var translateAttr in iAttr) {
	            if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	              observeAttributeTranslation(translateAttr);
	            }
	          }
	
	          iAttr.$observe('translateDefault', function (value) {
	            scope.defaultText = value;
	            updateTranslations();
	          });
	
	          if (translateSanitizeStrategyExist) {
	            iAttr.$observe('translateSanitizeStrategy', function (value) {
	              scope.sanitizeStrategy = $parse(value)(scope.$parent);
	              updateTranslations();
	            });
	          }
	
	          if (translateValuesExist) {
	            iAttr.$observe('translateValues', function (interpolateParams) {
	              if (interpolateParams) {
	                scope.$parent.$watch(function () {
	                  angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	                });
	              }
	            });
	          }
	
	          if (translateValueExist) {
	            var observeValueAttribute = function observeValueAttribute(attrName) {
	              iAttr.$observe(attrName, function (value) {
	                var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	                scope.interpolateParams[attributeName] = value;
	              });
	            };
	            for (var attr in iAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                observeValueAttribute(attr);
	              }
	            }
	          }
	
	          // Master update function
	          var updateTranslations = function updateTranslations() {
	            for (var key in translationIds) {
	              if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	                updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	              }
	            }
	          };
	
	          // Put translation processing function outside loop
	          var updateTranslation = function updateTranslation(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	            if (translationId) {
	              // if translation id starts with '.' and translateNamespace given, prepend namespace
	              if (translateNamespace && translationId.charAt(0) === '.') {
	                translationId = translateNamespace + translationId;
	              }
	
	              $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy).then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	            } else {
	              // as an empty string cannot be translated, we can solve this using successful=false
	              applyTranslation(translationId, scope, false, translateAttr);
	            }
	          };
	
	          var applyTranslation = function applyTranslation(value, scope, successful, translateAttr) {
	            if (!successful) {
	              if (typeof scope.defaultText !== 'undefined') {
	                value = scope.defaultText;
	              }
	            }
	            if (translateAttr === 'translate') {
	              // default translate into innerHTML
	              if (successful || !successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined') {
	                iElement.empty().append(scope.preText + value + scope.postText);
	              }
	              var globallyEnabled = $translate.isPostCompilingEnabled();
	              var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	              var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	              if (globallyEnabled && !locallyDefined || locallyEnabled) {
	                $compile(iElement.contents())(scope);
	              }
	            } else {
	              // translate attribute
	              var attributeName = iAttr.$attr[translateAttr];
	              if (attributeName.substr(0, 5) === 'data-') {
	                // ensure html5 data prefix is stripped
	                attributeName = attributeName.substr(5);
	              }
	              attributeName = attributeName.substr(15);
	              iElement.attr(attributeName, value);
	            }
	          };
	
	          if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	            scope.$watch('interpolateParams', updateTranslations, true);
	          }
	
	          // Replaced watcher on translateLanguage with event listener
	          scope.$on('translateLanguageChanged', updateTranslations);
	
	          // Ensures the text will be refreshed after the current language was changed
	          // w/ $translate.use(...)
	          var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	          // ensure translation will be looked up at least one
	          if (iElement.text().length) {
	            if (iAttr.translate) {
	              observeElementTranslation(iAttr.translate);
	            } else {
	              observeElementTranslation('');
	            }
	          } else if (iAttr.translate) {
	            // ensure attribute will be not skipped
	            observeElementTranslation(iAttr.translate);
	          }
	          updateTranslations();
	          scope.$on('$destroy', unbind);
	        };
	      }
	    };
	  }
	
	  /**
	   * Returns the scope's namespace.
	   * @private
	   * @param scope
	   * @returns {string}
	   */
	  function getTranslateNamespace(scope) {
	    'use strict';
	
	    if (scope.translateNamespace) {
	      return scope.translateNamespace;
	    }
	    if (scope.$parent) {
	      return getTranslateNamespace(scope.$parent);
	    }
	  }
	
	  translateDirective.displayName = 'translateDirective';
	
	  angular.module('pascalprecht.translate')
	  /**
	   * @ngdoc directive
	   * @name pascalprecht.translate.directive:translate-attr
	   * @restrict A
	   *
	   * @description
	   * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	   * Internally it uses `translate` service to translate translation id. It possible to
	   * pass an optional `translate-values` object literal as string into translation id.
	   *
	   * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	   * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	   * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	   *
	   * @example
	     <example module="ngView">
	      <file name="index.html">
	        <div ng-controller="TranslateCtrl">
	  
	          <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	  
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngView', ['pascalprecht.translate'])
	  
	        .config(function ($translateProvider) {
	  
	          $translateProvider.translations('en',{
	            'TRANSLATION_ID': 'Hello there!',
	            'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          }).preferredLanguage('en');
	  
	        });
	  
	        angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	          $scope.translationId = 'TRANSLATION_ID';
	  
	          $scope.values = {
	            value: 78
	          };
	        });
	      </file>
	      <file name="scenario.js">
	        it('should translate', function () {
	          inject(function ($rootScope, $compile) {
	            $rootScope.translationId = 'TRANSLATION_ID';
	  
	            element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	            $rootScope.$digest();
	            expect(element.attr('placeholder)).toBe('Hello there!');
	            expect(element.attr('title)).toBe('The following value is dynamic: 5');
	          });
	        });
	      </file>
	     </example>
	   */
	  .directive('translateAttr', translateAttrDirective);
	  function translateAttrDirective($translate, $rootScope) {
	
	    'use strict';
	
	    return {
	      restrict: 'A',
	      priority: $translate.directivePriority(),
	      link: function linkFn(scope, element, attr) {
	
	        var translateAttr,
	            translateValues,
	            translateSanitizeStrategy,
	            previousAttributes = {};
	
	        // Main update translations function
	        var updateTranslations = function updateTranslations() {
	          angular.forEach(translateAttr, function (translationId, attributeName) {
	            if (!translationId) {
	              return;
	            }
	            previousAttributes[attributeName] = true;
	
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (scope.translateNamespace && translationId.charAt(0) === '.') {
	              translationId = scope.translateNamespace + translationId;
	            }
	            $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy).then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	          });
	
	          // Removing unused attributes that were previously used
	          angular.forEach(previousAttributes, function (flag, attributeName) {
	            if (!translateAttr[attributeName]) {
	              element.removeAttr(attributeName);
	              delete previousAttributes[attributeName];
	            }
	          });
	        };
	
	        // Watch for attribute changes
	        watchAttribute(scope, attr.translateAttr, function (newValue) {
	          translateAttr = newValue;
	        }, updateTranslations);
	        // Watch for value changes
	        watchAttribute(scope, attr.translateValues, function (newValue) {
	          translateValues = newValue;
	        }, updateTranslations);
	        // Watch for sanitize strategy changes
	        watchAttribute(scope, attr.translateSanitizeStrategy, function (newValue) {
	          translateSanitizeStrategy = newValue;
	        }, updateTranslations);
	
	        if (attr.translateValues) {
	          scope.$watch(attr.translateValues, updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      }
	    };
	  }
	
	  function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	    'use strict';
	
	    if (!attribute) {
	      return;
	    }
	    if (attribute.substr(0, 2) === '::') {
	      attribute = attribute.substr(2);
	    } else {
	      scope.$watch(attribute, function (newValue) {
	        valueCallback(newValue);
	        changeCallback();
	      }, true);
	    }
	    valueCallback(scope.$eval(attribute));
	  }
	
	  translateAttrDirective.displayName = 'translateAttrDirective';
	
	  angular.module('pascalprecht.translate')
	  /**
	   * @ngdoc directive
	   * @name pascalprecht.translate.directive:translateCloak
	   * @requires $translate
	   * @restrict A
	   *
	   * $description
	   * Adds a `translate-cloak` class name to the given element where this directive
	   * is applied initially and removes it, once a loader has finished loading.
	   *
	   * This directive can be used to prevent initial flickering when loading translation
	   * data asynchronously.
	   *
	   * The class name is defined in
	   * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	   *
	   * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	   *                                  or hiding the cloak. Basically it relies on the translation
	   *                                  resolve.
	   */
	  .directive('translateCloak', translateCloakDirective);
	
	  function translateCloakDirective($translate, $rootScope) {
	
	    'use strict';
	
	    return {
	      compile: function compile(tElement) {
	        var applyCloak = function applyCloak(element) {
	          element.addClass($translate.cloakClassName());
	        },
	            removeCloak = function removeCloak(element) {
	          element.removeClass($translate.cloakClassName());
	        };
	        applyCloak(tElement);
	
	        return function linkFn(scope, iElement, iAttr) {
	          //Create bound functions that incorporate the active DOM element.
	          var iRemoveCloak = removeCloak.bind(this, iElement),
	              iApplyCloak = applyCloak.bind(this, iElement);
	          if (iAttr.translateCloak && iAttr.translateCloak.length) {
	            // Register a watcher for the defined translation allowing a fine tuned cloak
	            iAttr.$observe('translateCloak', function (translationId) {
	              $translate(translationId).then(iRemoveCloak, iApplyCloak);
	            });
	            $rootScope.$on('$translateChangeSuccess', function () {
	              $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	            });
	          } else {
	            $translate.onReady(iRemoveCloak);
	          }
	        };
	      }
	    };
	  }
	
	  translateCloakDirective.displayName = 'translateCloakDirective';
	
	  angular.module('pascalprecht.translate')
	  /**
	   * @ngdoc directive
	   * @name pascalprecht.translate.directive:translateNamespace
	   * @restrict A
	   *
	   * @description
	   * Translates given translation id either through attribute or DOM content.
	   * Internally it uses `translate` filter to translate translation id. It possible to
	   * pass an optional `translate-values` object literal as string into translation id.
	   *
	   * @param {string=} translate namespace name which could be either string or interpolated string.
	   *
	   * @example
	     <example module="ngView">
	      <file name="index.html">
	        <div translate-namespace="CONTENT">
	  
	          <div>
	              <h1 translate>.HEADERS.TITLE</h1>
	              <h1 translate>.HEADERS.WELCOME</h1>
	          </div>
	  
	          <div translate-namespace=".HEADERS">
	              <h1 translate>.TITLE</h1>
	              <h1 translate>.WELCOME</h1>
	          </div>
	  
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngView', ['pascalprecht.translate'])
	  
	        .config(function ($translateProvider) {
	  
	          $translateProvider.translations('en',{
	            'TRANSLATION_ID': 'Hello there!',
	            'CONTENT': {
	              'HEADERS': {
	                  TITLE: 'Title'
	              }
	            },
	            'CONTENT.HEADERS.WELCOME': 'Welcome'
	          }).preferredLanguage('en');
	  
	        });
	  
	      </file>
	     </example>
	   */
	  .directive('translateNamespace', translateNamespaceDirective);
	
	  function translateNamespaceDirective() {
	
	    'use strict';
	
	    return {
	      restrict: 'A',
	      scope: true,
	      compile: function compile() {
	        return {
	          pre: function pre(scope, iElement, iAttrs) {
	            scope.translateNamespace = getTranslateNamespace(scope);
	
	            if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	              scope.translateNamespace += iAttrs.translateNamespace;
	            } else {
	              scope.translateNamespace = iAttrs.translateNamespace;
	            }
	          }
	        };
	      }
	    };
	  }
	
	  /**
	   * Returns the scope's namespace.
	   * @private
	   * @param scope
	   * @returns {string}
	   */
	  function getTranslateNamespace(scope) {
	    'use strict';
	
	    if (scope.translateNamespace) {
	      return scope.translateNamespace;
	    }
	    if (scope.$parent) {
	      return getTranslateNamespace(scope.$parent);
	    }
	  }
	
	  translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	  angular.module('pascalprecht.translate')
	  /**
	   * @ngdoc directive
	   * @name pascalprecht.translate.directive:translateLanguage
	   * @restrict A
	   *
	   * @description
	   * Forces the language to the directives in the underlying scope.
	   *
	   * @param {string=} translate language that will be negotiated.
	   *
	   * @example
	     <example module="ngView">
	      <file name="index.html">
	        <div>
	  
	          <div>
	              <h1 translate>HELLO</h1>
	          </div>
	  
	          <div translate-language="de">
	              <h1 translate>HELLO</h1>
	          </div>
	  
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngView', ['pascalprecht.translate'])
	  
	        .config(function ($translateProvider) {
	  
	          $translateProvider
	            .translations('en',{
	              'HELLO': 'Hello world!'
	            })
	            .translations('de',{
	              'HELLO': 'Hallo Welt!'
	            })
	            .preferredLanguage('en');
	  
	        });
	  
	      </file>
	     </example>
	   */
	  .directive('translateLanguage', translateLanguageDirective);
	
	  function translateLanguageDirective() {
	
	    'use strict';
	
	    return {
	      restrict: 'A',
	      scope: true,
	      compile: function compile() {
	        return function linkFn(scope, iElement, iAttrs) {
	
	          iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	            scope.translateLanguage = newTranslateLanguage;
	          });
	
	          scope.$watch('translateLanguage', function () {
	            scope.$broadcast('translateLanguageChanged');
	          });
	        };
	      }
	    };
	  }
	
	  translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	  angular.module('pascalprecht.translate')
	  /**
	   * @ngdoc filter
	   * @name pascalprecht.translate.filter:translate
	   * @requires $parse
	   * @requires pascalprecht.translate.$translate
	   * @function
	   *
	   * @description
	   * Uses `$translate` service to translate contents. Accepts interpolate parameters
	   * to pass dynamized values though translation.
	   *
	   * @param {string} translationId A translation id to be translated.
	   * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	   *
	   * @returns {string} Translated text.
	   *
	   * @example
	     <example module="ngView">
	      <file name="index.html">
	        <div ng-controller="TranslateCtrl">
	  
	          <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	          <pre>{{ translationId | translate }}</pre>
	          <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	          <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	  
	        </div>
	      </file>
	      <file name="script.js">
	        angular.module('ngView', ['pascalprecht.translate'])
	  
	        .config(function ($translateProvider) {
	  
	          $translateProvider.translations('en', {
	            'TRANSLATION_ID': 'Hello there!',
	            'WITH_VALUES': 'The following value is dynamic: {{value}}'
	          });
	          $translateProvider.preferredLanguage('en');
	  
	        });
	  
	        angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	          $scope.translationId = 'TRANSLATION_ID';
	  
	          $scope.values = {
	            value: 78
	          };
	        });
	      </file>
	     </example>
	   */
	  .filter('translate', translateFilterFactory);
	
	  function translateFilterFactory($parse, $translate) {
	
	    'use strict';
	
	    var translateFilter = function translateFilter(translationId, interpolateParams, interpolation, forceLanguage) {
	      if (!angular.isObject(interpolateParams)) {
	        var ctx = this || {
	          '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	        interpolateParams = $parse(interpolateParams)(ctx);
	      }
	
	      return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	    };
	
	    if ($translate.statefulFilter()) {
	      translateFilter.$stateful = true;
	    }
	
	    return translateFilter;
	  }
	
	  translateFilterFactory.displayName = 'translateFilterFactory';
	
	  angular.module('pascalprecht.translate')
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translationCache
	   * @requires $cacheFactory
	   *
	   * @description
	   * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	   * can load translation tables directly into the cache by consuming the
	   * `$translationCache` service directly.
	   *
	   * @return {object} $cacheFactory object.
	   */
	  .factory('$translationCache', $translationCache);
	
	  function $translationCache($cacheFactory) {
	
	    'use strict';
	
	    return $cacheFactory('translations');
	  }
	
	  $translationCache.displayName = '$translationCache';
	  return 'pascalprecht.translate';
	});

/***/ },
/* 225 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 1.2.5 - 2016-03-20
	 * License: MIT
	 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.debounce", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html", "uib/template/accordion/accordion.html", "uib/template/alert/alert.html", "uib/template/carousel/carousel.html", "uib/template/carousel/slide.html", "uib/template/datepicker/datepicker.html", "uib/template/datepicker/day.html", "uib/template/datepicker/month.html", "uib/template/datepicker/popup.html", "uib/template/datepicker/year.html", "uib/template/modal/backdrop.html", "uib/template/modal/window.html", "uib/template/pager/pager.html", "uib/template/pagination/pagination.html", "uib/template/tooltip/tooltip-html-popup.html", "uib/template/tooltip/tooltip-popup.html", "uib/template/tooltip/tooltip-template-popup.html", "uib/template/popover/popover-html.html", "uib/template/popover/popover-template.html", "uib/template/popover/popover.html", "uib/template/progressbar/bar.html", "uib/template/progressbar/progress.html", "uib/template/progressbar/progressbar.html", "uib/template/rating/rating.html", "uib/template/tabs/tab.html", "uib/template/tabs/tabset.html", "uib/template/timepicker/timepicker.html", "uib/template/typeahead/typeahead-match.html", "uib/template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.collapse', []).directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
	  var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	  return {
	    link: function link(scope, element, attrs) {
	      var expandingExpr = $parse(attrs.expanding),
	          expandedExpr = $parse(attrs.expanded),
	          collapsingExpr = $parse(attrs.collapsing),
	          collapsedExpr = $parse(attrs.collapsed);
	
	      if (!scope.$eval(attrs.uibCollapse)) {
	        element.addClass('in').addClass('collapse').attr('aria-expanded', true).attr('aria-hidden', false).css({ height: 'auto' });
	      }
	
	      function expand() {
	        if (element.hasClass('collapse') && element.hasClass('in')) {
	          return;
	        }
	
	        $q.resolve(expandingExpr(scope)).then(function () {
	          element.removeClass('collapse').addClass('collapsing').attr('aria-expanded', true).attr('aria-hidden', false);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              addClass: 'in',
	              easing: 'ease',
	              to: { height: element[0].scrollHeight + 'px' }
	            }).start()['finally'](expandDone);
	          } else {
	            $animate.addClass(element, 'in', {
	              to: { height: element[0].scrollHeight + 'px' }
	            }).then(expandDone);
	          }
	        });
	      }
	
	      function expandDone() {
	        element.removeClass('collapsing').addClass('collapse').css({ height: 'auto' });
	        expandedExpr(scope);
	      }
	
	      function collapse() {
	        if (!element.hasClass('collapse') && !element.hasClass('in')) {
	          return collapseDone();
	        }
	
	        $q.resolve(collapsingExpr(scope)).then(function () {
	          element
	          // IMPORTANT: The height must be set before adding "collapsing" class.
	          // Otherwise, the browser attempts to animate from height 0 (in
	          // collapsing class) to the given height here.
	          .css({ height: element[0].scrollHeight + 'px' })
	          // initially all panel collapse have the collapse class, this removal
	          // prevents the animation from jumping to collapsed state
	          .removeClass('collapse').addClass('collapsing').attr('aria-expanded', false).attr('aria-hidden', true);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: 'in',
	              to: { height: '0' }
	            }).start()['finally'](collapseDone);
	          } else {
	            $animate.removeClass(element, 'in', {
	              to: { height: '0' }
	            }).then(collapseDone);
	          }
	        });
	      }
	
	      function collapseDone() {
	        element.css({ height: '0' }); // Required so that collapse works when animation is disabled
	        element.removeClass('collapsing').addClass('collapse');
	        collapsedExpr(scope);
	      }
	
	      scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
	        if (shouldCollapse) {
	          collapse();
	        } else {
	          expand();
	        }
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse']).constant('uibAccordionConfig', {
	  closeOthers: true
	}).controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function (openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function (group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function (groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function (event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function (group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function () {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function () {
	  return {
	    require: '^uibAccordion', // We need this directive to be inside an accordion
	    transclude: true, // It transcludes the contents of the directive into the template
	    replace: true, // The element containing the directive will be replaced with the template
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@', // Interpolate the heading attribute onto this scope
	      panelClass: '@?', // Ditto with panelClass
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function controller() {
	      this.setHeading = function (element) {
	        this.heading = element;
	      };
	    },
	    link: function link(scope, element, attrs, accordionCtrl) {
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass || 'panel-default';
	      scope.$watch('isOpen', function (value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function ($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	
	      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      scope.headingId = id + '-tab';
	      scope.panelId = id + '-panel';
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function () {
	  return {
	    transclude: true, // Grab the contents to be used as the heading
	    template: '', // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function link(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function () {
	  return {
	    require: '^uibAccordionGroup',
	    link: function link(scope, element, attrs, controller) {
	      scope.$watch(function () {
	        return controller[attrs.uibAccordionTransclude];
	      }, function (heading) {
	        if (heading) {
	          var elem = angular.element(element[0].querySelector('[uib-accordion-header]'));
	          elem.html('');
	          elem.append(heading);
	        }
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.alert', []).controller('UibAlertController', ['$scope', '$attrs', '$interpolate', '$timeout', function ($scope, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ? $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function () {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}]).directive('uibAlert', function () {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/alert/alert.html';
	    },
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@',
	      close: '&'
	    }
	  };
	});
	
	angular.module('ui.bootstrap.buttons', []).constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	}).controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}]).directive('uibBtnRadio', ['$parse', function ($parse) {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function link(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	      var uncheckableExpr = $parse(attrs.uibUncheckable);
	
	      element.find('input').css({ display: 'none' });
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function () {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function () {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	
	      if (attrs.uibUncheckable) {
	        scope.$watch(uncheckableExpr, function (uncheckable) {
	          attrs.$set('uncheckable', uncheckable ? '' : undefined);
	        });
	      }
	    }
	  };
	}]).directive('uibBtnCheckbox', function () {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function link(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      element.find('input').css({ display: 'none' });
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function () {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function () {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.carousel', []).controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
	  var self = this,
	      slides = self.slides = $scope.slides = [],
	      SLIDE_DIRECTION = 'uib-slideDirection',
	      currentIndex = $scope.active,
	      currentInterval,
	      isPlaying,
	      bufferedTransitions = [];
	
	  var destroyed = false;
	
	  self.addSlide = function (slide, element) {
	    slides.push({
	      slide: slide,
	      element: element
	    });
	    slides.sort(function (a, b) {
	      return +a.slide.index > +b.slide.index;
	    });
	    //if this is the first slide or the slide is set to active, select it
	    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
	      if ($scope.$currentTransition) {
	        $scope.$currentTransition = null;
	      }
	
	      currentIndex = slide.index;
	      $scope.active = slide.index;
	      setActive(currentIndex);
	      self.select(slides[findSlideIndex(slide)]);
	      if (slides.length === 1) {
	        $scope.play();
	      }
	    }
	  };
	
	  self.getCurrentIndex = function () {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide.index === currentIndex) {
	        return i;
	      }
	    }
	  };
	
	  self.next = $scope.next = function () {
	    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
	
	    if (newIndex === 0 && $scope.noWrap()) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'next');
	  };
	
	  self.prev = $scope.prev = function () {
	    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
	
	    if ($scope.noWrap() && newIndex === slides.length - 1) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'prev');
	  };
	
	  self.removeSlide = function (slide) {
	    var index = findSlideIndex(slide);
	
	    var bufferedIndex = bufferedTransitions.indexOf(slides[index]);
	    if (bufferedIndex !== -1) {
	      bufferedTransitions.splice(bufferedIndex, 1);
	    }
	
	    //get the index of the slide inside the carousel
	    slides.splice(index, 1);
	    if (slides.length > 0 && currentIndex === index) {
	      if (index >= slides.length) {
	        currentIndex = slides.length - 1;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[slides.length - 1]);
	      } else {
	        currentIndex = index;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	      $scope.active = currentIndex;
	    }
	
	    //clean the active value when no more slide
	    if (slides.length === 0) {
	      currentIndex = null;
	      $scope.active = null;
	      clearBufferedTransitions();
	    }
	  };
	
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function (nextSlide, direction) {
	    var nextIndex = findSlideIndex(nextSlide.slide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	    }
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (nextSlide.slide.index !== currentIndex && !$scope.$currentTransition) {
	      goNext(nextSlide.slide, nextIndex, direction);
	    } else if (nextSlide && nextSlide.slide.index !== currentIndex && $scope.$currentTransition) {
	      bufferedTransitions.push(slides[nextIndex]);
	    }
	  };
	
	  /* Allow outside people to call indexOf on slides array */
	  $scope.indexOfSlide = function (slide) {
	    return +slide.slide.index;
	  };
	
	  $scope.isActive = function (slide) {
	    return $scope.active === slide.slide.index;
	  };
	
	  $scope.pause = function () {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  $scope.play = function () {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	    resetTimer();
	  });
	
	  $scope.$watch('noTransition', function (noTransition) {
	    $animate.enabled($element, !noTransition);
	  });
	
	  $scope.$watch('interval', restartTimer);
	
	  $scope.$watchCollection('slides', resetTransition);
	
	  $scope.$watch('active', function (index) {
	    if (angular.isNumber(index) && currentIndex !== index) {
	      for (var i = 0; i < slides.length; i++) {
	        if (slides[i].slide.index === index) {
	          index = i;
	          break;
	        }
	      }
	
	      var slide = slides[index];
	      if (slide) {
	        currentIndex = index;
	        setActive(index);
	        self.select(slides[index]);
	      }
	    }
	  });
	
	  function clearBufferedTransitions() {
	    while (bufferedTransitions.length) {
	      bufferedTransitions.shift();
	    }
	  }
	
	  function getSlideByIndex(index) {
	    for (var i = 0, l = slides.length; i < l; ++i) {
	      if (slides[i].index === index) {
	        return slides[i];
	      }
	    }
	  }
	
	  function setActive(index) {
	    for (var i = 0; i < slides.length; i++) {
	      slides[i].slide.active = i === index;
	    }
	  }
	
	  function goNext(slide, index, direction) {
	    if (destroyed) {
	      return;
	    }
	
	    angular.extend(slide, { direction: direction });
	    angular.extend(slides[currentIndex].slide || {}, { direction: direction });
	    if ($animate.enabled($element) && !$scope.$currentTransition && slides[index].element && self.slides.length > 1) {
	      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
	      var currentIdx = self.getCurrentIndex();
	
	      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
	        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
	      }
	
	      $scope.$currentTransition = true;
	      $animate.on('addClass', slides[index].element, function (element, phase) {
	        if (phase === 'close') {
	          $scope.$currentTransition = null;
	          $animate.off('addClass', element);
	          if (bufferedTransitions.length) {
	            var nextSlide = bufferedTransitions.pop().slide;
	            var nextIndex = nextSlide.index;
	            var nextDirection = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	            clearBufferedTransitions();
	
	            goNext(nextSlide, nextIndex, nextDirection);
	          }
	        }
	      });
	    }
	
	    $scope.active = slide.index;
	    currentIndex = slide.index;
	    setActive(index);
	
	    //every time you change slides, reset the timer
	    restartTimer();
	  }
	
	  function findSlideIndex(slide) {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide === slide) {
	        return i;
	      }
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function resetTransition(slides) {
	    if (!slides.length) {
	      $scope.$currentTransition = null;
	      clearBufferedTransitions();
	    }
	  }
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	}]).directive('uibCarousel', function () {
	  return {
	    transclude: true,
	    replace: true,
	    controller: 'UibCarouselController',
	    controllerAs: 'carousel',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
	    },
	    scope: {
	      active: '=',
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    }
	  };
	}).directive('uibSlide', function () {
	  return {
	    require: '^uibCarousel',
	    transclude: true,
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/slide.html';
	    },
	    scope: {
	      actual: '=?',
	      index: '=?'
	    },
	    link: function link(scope, element, attrs, carouselCtrl) {
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function () {
	        carouselCtrl.removeSlide(scope);
	      });
	    }
	  };
	}).animation('.item', ['$animateCss', function ($animateCss) {
	  var SLIDE_DIRECTION = 'uib-slideDirection';
	
	  function removeClass(element, className, callback) {
	    element.removeClass(className);
	    if (callback) {
	      callback();
	    }
	  }
	
	  return {
	    beforeAddClass: function beforeAddClass(element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass + ' ' + direction, done);
	        element.addClass(direction);
	
	        $animateCss(element, { addClass: directionClass }).start().done(removeClassFn);
	
	        return function () {
	          stopped = true;
	        };
	      }
	      done();
	    },
	    beforeRemoveClass: function beforeRemoveClass(element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass, done);
	
	        $animateCss(element, { addClass: directionClass }).start().done(removeClassFn);
	
	        return function () {
	          stopped = true;
	        };
	      }
	      done();
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dateparser', []).service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', function ($log, $locale, dateFilter, orderByFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function () {
	    localeId = $locale.id;
	
	    this.parsers = {};
	    this.formatters = {};
	
	    formatCodeToRegex = [{
	      key: 'yyyy',
	      regex: '\\d{4}',
	      apply: function apply(value) {
	        this.year = +value;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'yyyy');
	      }
	    }, {
	      key: 'yy',
	      regex: '\\d{2}',
	      apply: function apply(value) {
	        this.year = +value + 2000;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'yy');
	      }
	    }, {
	      key: 'y',
	      regex: '\\d{1,4}',
	      apply: function apply(value) {
	        this.year = +value;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'y');
	      }
	    }, {
	      key: 'M!',
	      regex: '0?[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        var value = date.getMonth();
	        if (/^[0-9]$/.test(value)) {
	          return dateFilter(date, 'MM');
	        }
	
	        return dateFilter(date, 'M');
	      }
	    }, {
	      key: 'MMMM',
	      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	      apply: function apply(value) {
	        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MMMM');
	      }
	    }, {
	      key: 'MMM',
	      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	      apply: function apply(value) {
	        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MMM');
	      }
	    }, {
	      key: 'MM',
	      regex: '0[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MM');
	      }
	    }, {
	      key: 'M',
	      regex: '[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'M');
	      }
	    }, {
	      key: 'd!',
	      regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        var value = date.getDate();
	        if (/^[1-9]$/.test(value)) {
	          return dateFilter(date, 'dd');
	        }
	
	        return dateFilter(date, 'd');
	      }
	    }, {
	      key: 'dd',
	      regex: '[0-2][0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'dd');
	      }
	    }, {
	      key: 'd',
	      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'd');
	      }
	    }, {
	      key: 'EEEE',
	      regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'EEEE');
	      }
	    }, {
	      key: 'EEE',
	      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'EEE');
	      }
	    }, {
	      key: 'HH',
	      regex: '(?:0|1)[0-9]|2[0-3]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'HH');
	      }
	    }, {
	      key: 'hh',
	      regex: '0[0-9]|1[0-2]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'hh');
	      }
	    }, {
	      key: 'H',
	      regex: '1?[0-9]|2[0-3]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'H');
	      }
	    }, {
	      key: 'h',
	      regex: '[0-9]|1[0-2]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'h');
	      }
	    }, {
	      key: 'mm',
	      regex: '[0-5][0-9]',
	      apply: function apply(value) {
	        this.minutes = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'mm');
	      }
	    }, {
	      key: 'm',
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function apply(value) {
	        this.minutes = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'm');
	      }
	    }, {
	      key: 'sss',
	      regex: '[0-9][0-9][0-9]',
	      apply: function apply(value) {
	        this.milliseconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'sss');
	      }
	    }, {
	      key: 'ss',
	      regex: '[0-5][0-9]',
	      apply: function apply(value) {
	        this.seconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'ss');
	      }
	    }, {
	      key: 's',
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function apply(value) {
	        this.seconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 's');
	      }
	    }, {
	      key: 'a',
	      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	      apply: function apply(value) {
	        if (this.hours === 12) {
	          this.hours = 0;
	        }
	
	        if (value === 'PM') {
	          this.hours += 12;
	        }
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'a');
	      }
	    }, {
	      key: 'Z',
	      regex: '[+-]\\d{4}',
	      apply: function apply(value) {
	        var matches = value.match(/([+-])(\d{2})(\d{2})/),
	            sign = matches[1],
	            hours = matches[2],
	            minutes = matches[3];
	        this.hours += toInt(sign + hours);
	        this.minutes += toInt(sign + minutes);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'Z');
	      }
	    }, {
	      key: 'ww',
	      regex: '[0-4][0-9]|5[0-3]',
	      formatter: function formatter(date) {
	        return dateFilter(date, 'ww');
	      }
	    }, {
	      key: 'w',
	      regex: '[0-9]|[1-4][0-9]|5[0-3]',
	      formatter: function formatter(date) {
	        return dateFilter(date, 'w');
	      }
	    }, {
	      key: 'GGGG',
	      regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GGGG');
	      }
	    }, {
	      key: 'GGG',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GGG');
	      }
	    }, {
	      key: 'GG',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GG');
	      }
	    }, {
	      key: 'G',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'G');
	      }
	    }];
	  };
	
	  this.init();
	
	  function createParser(format, func) {
	    var map = [],
	        regex = format.split('');
	
	    // check for literal values
	    var quoteIndex = format.indexOf('\'');
	    if (quoteIndex > -1) {
	      var inLiteral = false;
	      format = format.split('');
	      for (var i = quoteIndex; i < format.length; i++) {
	        if (inLiteral) {
	          if (format[i] === '\'') {
	            if (i + 1 < format.length && format[i + 1] === '\'') {
	              // escaped single quote
	              format[i + 1] = '$';
	              regex[i + 1] = '';
	            } else {
	              // end of literal
	              regex[i] = '';
	              inLiteral = false;
	            }
	          }
	          format[i] = '$';
	        } else {
	          if (format[i] === '\'') {
	            // start of literal
	            format[i] = '$';
	            regex[i] = '';
	            inLiteral = true;
	          }
	        }
	      }
	
	      format = format.join('');
	    }
	
	    angular.forEach(formatCodeToRegex, function (data) {
	      var index = format.indexOf(data.key);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({
	          index: index,
	          key: data.key,
	          apply: data[func],
	          matcher: data.regex
	        });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  this.filter = function (date, format) {
	    if (!angular.isDate(date) || isNaN(date) || !format) {
	      return '';
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.formatters[format]) {
	      this.formatters[format] = createParser(format, 'formatter');
	    }
	
	    var parser = this.formatters[format],
	        map = parser.map;
	
	    var _format = format;
	
	    return map.reduce(function (str, mapper, i) {
	      var match = _format.match(new RegExp('(.*)' + mapper.key));
	      if (match && angular.isString(match[1])) {
	        str += match[1];
	        _format = _format.replace(match[1] + mapper.key, '');
	      }
	
	      var endStr = i === map.length - 1 ? _format : '';
	
	      if (mapper.apply) {
	        return str + mapper.apply.call(null, date) + endStr;
	      }
	
	      return str + endStr;
	    }, '');
	  };
	
	  this.parse = function (input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format, 'apply');
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex),
	        tzOffset = false;
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i - 1];
	        if (mapper.matcher === 'Z') {
	          tzOffset = true;
	        }
	
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      var datesetter = tzOffset ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear;
	      var timesetter = tzOffset ? Date.prototype.setUTCHours : Date.prototype.setHours;
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	          dt = new Date(baseDate);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours, fields.minutes, fields.seconds, fields.milliseconds);
	        } else {
	          dt = new Date(0);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours || 0, fields.minutes || 0, fields.seconds || 0, fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	  this.toTimezone = toTimezone;
	  this.fromTimezone = fromTimezone;
	  this.timezoneToOffset = timezoneToOffset;
	  this.addDateMinutes = addDateMinutes;
	  this.convertTimezoneToLocal = convertTimezoneToLocal;
	
	  function toTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	  }
	
	  function fromTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	  }
	
	  //https://github.com/angular/angular.js/blob/4daafd3dbe6a80d578f5a31df1bb99c77559543e/src/Angular.js#L1207
	  function timezoneToOffset(timezone, fallback) {
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var timezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
	    return addDateMinutes(date, reverse * (timezoneOffset - date.getTimezoneOffset()));
	  }
	}]);
	
	// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass', []).directive('uibIsClass', ['$animate', function ($animate) {
	  //                    11111111          22222222
	  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	  //                    11111111           22222222
	  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
	
	  var dataPerTracked = {};
	
	  return {
	    restrict: 'A',
	    compile: function compile(tElement, tAttrs) {
	      var linkedScopes = [];
	      var instances = [];
	      var expToData = {};
	      var lastActivated = null;
	      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	      var onExp = onExpMatches[2];
	      var expsStr = onExpMatches[1];
	      var exps = expsStr.split(',');
	
	      return linkFn;
	
	      function linkFn(scope, element, attrs) {
	        linkedScopes.push(scope);
	        instances.push({
	          scope: scope,
	          element: element
	        });
	
	        exps.forEach(function (exp, k) {
	          addForExp(exp, scope);
	        });
	
	        scope.$on('$destroy', removeScope);
	      }
	
	      function addForExp(exp, scope) {
	        var matches = exp.match(IS_REGEXP);
	        var clazz = scope.$eval(matches[1]);
	        var compareWithExp = matches[2];
	        var data = expToData[exp];
	        if (!data) {
	          var watchFn = function watchFn(compareWithVal) {
	            var newActivated = null;
	            instances.some(function (instance) {
	              var thisVal = instance.scope.$eval(onExp);
	              if (thisVal === compareWithVal) {
	                newActivated = instance;
	                return true;
	              }
	            });
	            if (data.lastActivated !== newActivated) {
	              if (data.lastActivated) {
	                $animate.removeClass(data.lastActivated.element, clazz);
	              }
	              if (newActivated) {
	                $animate.addClass(newActivated.element, clazz);
	              }
	              data.lastActivated = newActivated;
	            }
	          };
	          expToData[exp] = data = {
	            lastActivated: null,
	            scope: scope,
	            watchFn: watchFn,
	            compareWithExp: compareWithExp,
	            watcher: scope.$watch(compareWithExp, watchFn)
	          };
	        }
	        data.watchFn(scope.$eval(compareWithExp));
	      }
	
	      function removeScope(e) {
	        var removedScope = e.targetScope;
	        var index = linkedScopes.indexOf(removedScope);
	        linkedScopes.splice(index, 1);
	        instances.splice(index, 1);
	        if (linkedScopes.length) {
	          var newWatchScope = linkedScopes[0];
	          angular.forEach(expToData, function (data) {
	            if (data.scope === removedScope) {
	              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	              data.scope = newWatchScope;
	            }
	          });
	        } else {
	          expToData = {};
	        }
	      }
	    }
	  };
	}]);
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	.factory('$uibPosition', ['$document', '$window', function ($document, $window) {
	  /**
	   * Used by scrollbarWidth() function to cache scrollbar's width.
	   * Do not access this variable directly, use scrollbarWidth() instead.
	   */
	  var SCROLLBAR_WIDTH;
	  var OVERFLOW_REGEX = {
	    normal: /(auto|scroll)/,
	    hidden: /(auto|scroll|hidden)/
	  };
	  var PLACEMENT_REGEX = {
	    auto: /\s?auto?\s?/i,
	    primary: /^(top|bottom|left|right)$/,
	    secondary: /^(top|bottom|left|right|center)$/,
	    vertical: /^(top|bottom)$/
	  };
	
	  return {
	
	    /**
	     * Provides a raw DOM element from a jQuery/jQLite element.
	     *
	     * @param {element} elem - The element to convert.
	     *
	     * @returns {element} A HTML element.
	     */
	    getRawNode: function getRawNode(elem) {
	      return elem.nodeName ? elem : elem[0] || elem;
	    },
	
	    /**
	     * Provides a parsed number for a style property.  Strips
	     * units and casts invalid numbers to 0.
	     *
	     * @param {string} value - The style value to parse.
	     *
	     * @returns {number} A valid number.
	     */
	    parseStyle: function parseStyle(value) {
	      value = parseFloat(value);
	      return isFinite(value) ? value : 0;
	    },
	
	    /**
	     * Provides the closest positioned ancestor.
	     *
	     * @param {element} element - The element to get the offest parent for.
	     *
	     * @returns {element} The closest positioned ancestor.
	     */
	    offsetParent: function offsetParent(elem) {
	      elem = this.getRawNode(elem);
	
	      var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	      function isStaticPositioned(el) {
	        return ($window.getComputedStyle(el).position || 'static') === 'static';
	      }
	
	      while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	        offsetParent = offsetParent.offsetParent;
	      }
	
	      return offsetParent || $document[0].documentElement;
	    },
	
	    /**
	     * Provides the scrollbar width, concept from TWBS measureScrollbar()
	     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	     *
	     * @returns {number} The width of the browser scollbar.
	     */
	    scrollbarWidth: function scrollbarWidth() {
	      if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	        var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	        $document.find('body').append(scrollElem);
	        SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	        SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	        scrollElem.remove();
	      }
	
	      return SCROLLBAR_WIDTH;
	    },
	
	    /**
	     * Checks to see if the element is scrollable.
	     *
	     * @param {element} elem - The element to check.
	     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	     *   default is false.
	     *
	     * @returns {boolean} Whether the element is scrollable.
	     */
	    isScrollable: function isScrollable(elem, includeHidden) {
	      elem = this.getRawNode(elem);
	
	      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	      var elemStyle = $window.getComputedStyle(elem);
	      return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	    },
	
	    /**
	     * Provides the closest scrollable ancestor.
	     * A port of the jQuery UI scrollParent method:
	     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	     *
	     * @param {element} elem - The element to find the scroll parent of.
	     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	     *   default is false.
	     *
	     * @returns {element} A HTML element.
	     */
	    scrollParent: function scrollParent(elem, includeHidden) {
	      elem = this.getRawNode(elem);
	
	      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	      var documentEl = $document[0].documentElement;
	      var elemStyle = $window.getComputedStyle(elem);
	      var excludeStatic = elemStyle.position === 'absolute';
	      var scrollParent = elem.parentElement || documentEl;
	
	      if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	        return documentEl;
	      }
	
	      while (scrollParent.parentElement && scrollParent !== documentEl) {
	        var spStyle = $window.getComputedStyle(scrollParent);
	        if (excludeStatic && spStyle.position !== 'static') {
	          excludeStatic = false;
	        }
	
	        if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	          break;
	        }
	        scrollParent = scrollParent.parentElement;
	      }
	
	      return scrollParent;
	    },
	
	    /**
	     * Provides read-only equivalent of jQuery's position function:
	     * http://api.jquery.com/position/ - distance to closest positioned
	     * ancestor.  Does not account for margins by default like jQuery position.
	     *
	     * @param {element} elem - The element to caclulate the position on.
	     * @param {boolean=} [includeMargins=false] - Should margins be accounted
	     * for, default is false.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**width**: the width of the element</li>
	     *     <li>**height**: the height of the element</li>
	     *     <li>**top**: distance to top edge of offset parent</li>
	     *     <li>**left**: distance to left edge of offset parent</li>
	     *   </ul>
	     */
	    position: function position(elem, includeMagins) {
	      elem = this.getRawNode(elem);
	
	      var elemOffset = this.offset(elem);
	      if (includeMagins) {
	        var elemStyle = $window.getComputedStyle(elem);
	        elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	        elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	      }
	      var parent = this.offsetParent(elem);
	      var parentOffset = { top: 0, left: 0 };
	
	      if (parent !== $document[0].documentElement) {
	        parentOffset = this.offset(parent);
	        parentOffset.top += parent.clientTop - parent.scrollTop;
	        parentOffset.left += parent.clientLeft - parent.scrollLeft;
	      }
	
	      return {
	        width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	        height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	        top: Math.round(elemOffset.top - parentOffset.top),
	        left: Math.round(elemOffset.left - parentOffset.left)
	      };
	    },
	
	    /**
	     * Provides read-only equivalent of jQuery's offset function:
	     * http://api.jquery.com/offset/ - distance to viewport.  Does
	     * not account for borders, margins, or padding on the body
	     * element.
	     *
	     * @param {element} elem - The element to calculate the offset on.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**width**: the width of the element</li>
	     *     <li>**height**: the height of the element</li>
	     *     <li>**top**: distance to top edge of viewport</li>
	     *     <li>**right**: distance to bottom edge of viewport</li>
	     *   </ul>
	     */
	    offset: function offset(elem) {
	      elem = this.getRawNode(elem);
	
	      var elemBCR = elem.getBoundingClientRect();
	      return {
	        width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	        height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	        top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	        left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	      };
	    },
	
	    /**
	     * Provides offset distance to the closest scrollable ancestor
	     * or viewport.  Accounts for border and scrollbar width.
	     *
	     * Right and bottom dimensions represent the distance to the
	     * respective edge of the viewport element.  If the element
	     * edge extends beyond the viewport, a negative value will be
	     * reported.
	     *
	     * @param {element} elem - The element to get the viewport offset for.
	     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	     * of the first scrollable element, default is false.
	     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	     * be accounted for, default is true.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**top**: distance to the top content edge of viewport element</li>
	     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	     *     <li>**left**: distance to the left content edge of viewport element</li>
	     *     <li>**right**: distance to the right content edge of viewport element</li>
	     *   </ul>
	     */
	    viewportOffset: function viewportOffset(elem, useDocument, includePadding) {
	      elem = this.getRawNode(elem);
	      includePadding = includePadding !== false ? true : false;
	
	      var elemBCR = elem.getBoundingClientRect();
	      var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };
	
	      var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	      var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	      offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	      offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	      if (offsetParent === $document[0].documentElement) {
	        offsetBCR.top += $window.pageYOffset;
	        offsetBCR.left += $window.pageXOffset;
	      }
	      offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	      offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	      if (includePadding) {
	        var offsetParentStyle = $window.getComputedStyle(offsetParent);
	        offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	        offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	        offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	        offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	      }
	
	      return {
	        top: Math.round(elemBCR.top - offsetBCR.top),
	        bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	        left: Math.round(elemBCR.left - offsetBCR.left),
	        right: Math.round(offsetBCR.right - elemBCR.right)
	      };
	    },
	
	    /**
	     * Provides an array of placement values parsed from a placement string.
	     * Along with the 'auto' indicator, supported placement strings are:
	     *   <ul>
	     *     <li>top: element on top, horizontally centered on host element.</li>
	     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	     *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	     *     <li>left: element on left, vertically centered on host element.</li>
	     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	     *     <li>right: element on right, vertically centered on host element.</li>
	     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	     *   </ul>
	     * A placement string with an 'auto' indicator is expected to be
	     * space separated from the placement, i.e: 'auto bottom-left'  If
	     * the primary and secondary placement values do not match 'top,
	     * bottom, left, right' then 'top' will be the primary placement and
	     * 'center' will be the secondary placement.  If 'auto' is passed, true
	     * will be returned as the 3rd value of the array.
	     *
	     * @param {string} placement - The placement string to parse.
	     *
	     * @returns {array} An array with the following values
	     * <ul>
	     *   <li>**[0]**: The primary placement.</li>
	     *   <li>**[1]**: The secondary placement.</li>
	     *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	     * </ul>
	     */
	    parsePlacement: function parsePlacement(placement) {
	      var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	      if (autoPlace) {
	        placement = placement.replace(PLACEMENT_REGEX.auto, '');
	      }
	
	      placement = placement.split('-');
	
	      placement[0] = placement[0] || 'top';
	      if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	        placement[0] = 'top';
	      }
	
	      placement[1] = placement[1] || 'center';
	      if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	        placement[1] = 'center';
	      }
	
	      if (autoPlace) {
	        placement[2] = true;
	      } else {
	        placement[2] = false;
	      }
	
	      return placement;
	    },
	
	    /**
	     * Provides coordinates for an element to be positioned relative to
	     * another element.  Passing 'auto' as part of the placement parameter
	     * will enable smart placement - where the element fits. i.e:
	     * 'auto left-top' will check to see if there is enough space to the left
	     * of the hostElem to fit the targetElem, if not place right (same for secondary
	     * top placement).  Available space is calculated using the viewportOffset
	     * function.
	     *
	     * @param {element} hostElem - The element to position against.
	     * @param {element} targetElem - The element to position.
	     * @param {string=} [placement=top] - The placement for the targetElem,
	     *   default is 'top'. 'center' is assumed as secondary placement for
	     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	     *   <ul>
	     *     <li>top</li>
	     *     <li>top-right</li>
	     *     <li>top-left</li>
	     *     <li>bottom</li>
	     *     <li>bottom-left</li>
	     *     <li>bottom-right</li>
	     *     <li>left</li>
	     *     <li>left-top</li>
	     *     <li>left-bottom</li>
	     *     <li>right</li>
	     *     <li>right-top</li>
	     *     <li>right-bottom</li>
	     *   </ul>
	     * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	     *   be calculated from the body element, default is false.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**top**: Value for targetElem top.</li>
	     *     <li>**left**: Value for targetElem left.</li>
	     *     <li>**placement**: The resolved placement.</li>
	     *   </ul>
	     */
	    positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {
	      hostElem = this.getRawNode(hostElem);
	      targetElem = this.getRawNode(targetElem);
	
	      // need to read from prop to support tests.
	      var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	      var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	      placement = this.parsePlacement(placement);
	
	      var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	      var targetElemPos = { top: 0, left: 0, placement: '' };
	
	      if (placement[2]) {
	        var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	        var targetElemStyle = $window.getComputedStyle(targetElem);
	        var adjustedSize = {
	          width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	          height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	        };
	
	        placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' : placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' : placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' : placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' : placement[0];
	
	        placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' : placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' : placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' : placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' : placement[1];
	
	        if (placement[1] === 'center') {
	          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	              placement[1] = 'left';
	            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	              placement[1] = 'right';
	            }
	          } else {
	            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	              placement[1] = 'top';
	            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	              placement[1] = 'bottom';
	            }
	          }
	        }
	      }
	
	      switch (placement[0]) {
	        case 'top':
	          targetElemPos.top = hostElemPos.top - targetHeight;
	          break;
	        case 'bottom':
	          targetElemPos.top = hostElemPos.top + hostElemPos.height;
	          break;
	        case 'left':
	          targetElemPos.left = hostElemPos.left - targetWidth;
	          break;
	        case 'right':
	          targetElemPos.left = hostElemPos.left + hostElemPos.width;
	          break;
	      }
	
	      switch (placement[1]) {
	        case 'top':
	          targetElemPos.top = hostElemPos.top;
	          break;
	        case 'bottom':
	          targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	          break;
	        case 'left':
	          targetElemPos.left = hostElemPos.left;
	          break;
	        case 'right':
	          targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	          break;
	        case 'center':
	          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	          } else {
	            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	          }
	          break;
	      }
	
	      targetElemPos.top = Math.round(targetElemPos.top);
	      targetElemPos.left = Math.round(targetElemPos.left);
	      targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	      return targetElemPos;
	    },
	
	    /**
	    * Provides a way for positioning tooltip & dropdown
	    * arrows when using placement options beyond the standard
	    * left, right, top, or bottom.
	    *
	    * @param {element} elem - The tooltip/dropdown element.
	    * @param {string} placement - The placement for the elem.
	    */
	    positionArrow: function positionArrow(elem, placement) {
	      elem = this.getRawNode(elem);
	
	      var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	      if (!innerElem) {
	        return;
	      }
	
	      var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	      var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	      if (!arrowElem) {
	        return;
	      }
	
	      var arrowCss = {
	        top: '',
	        bottom: '',
	        left: '',
	        right: ''
	      };
	
	      placement = this.parsePlacement(placement);
	      if (placement[1] === 'center') {
	        // no adjustment necessary - just reset styles
	        angular.element(arrowElem).css(arrowCss);
	        return;
	      }
	
	      var borderProp = 'border-' + placement[0] + '-width';
	      var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	      var borderRadiusProp = 'border-';
	      if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	        borderRadiusProp += placement[0] + '-' + placement[1];
	      } else {
	        borderRadiusProp += placement[1] + '-' + placement[0];
	      }
	      borderRadiusProp += '-radius';
	      var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	      switch (placement[0]) {
	        case 'top':
	          arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'bottom':
	          arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'left':
	          arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'right':
	          arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	          break;
	      }
	
	      arrowCss[placement[1]] = borderRadius;
	
	      angular.element(arrowElem).css(arrowCss);
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass', 'ui.bootstrap.position']).value('$datepickerSuppressError', false).value('uibDatepickerAttributeWarning', true).constant('uibDatepickerConfig', {
	  datepickerMode: 'day',
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  maxDate: null,
	  maxMode: 'year',
	  minDate: null,
	  minMode: 'day',
	  ngModelOptions: {},
	  shortcutPropagation: false,
	  showWeeks: true,
	  yearColumns: 5,
	  yearRows: 4
	}).controller('UibDatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerSuppressError', 'uibDatepickerAttributeWarning', 'uibDateParser', function ($scope, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerSuppressError, datepickerAttributeWarning, dateParser) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop },
	      // nullModelCtrl;
	  ngModelOptions = {},
	      watchListeners = [],
	      optionsUsed = !!$attrs.datepickerOptions;
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  if (optionsUsed) {
	    ['customClass', 'dateDisabled', 'datepickerMode', 'formatDay', 'formatDayHeader', 'formatDayTitle', 'formatMonth', 'formatMonthTitle', 'formatYear', 'initDate', 'maxDate', 'maxMode', 'minDate', 'minMode', 'showWeeks', 'shortcutPropagation', 'startingDay', 'yearColumns', 'yearRows'].forEach(function (key) {
	      switch (key) {
	        case 'customClass':
	        case 'dateDisabled':
	          $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	          break;
	        case 'datepickerMode':
	          $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ? $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	          break;
	        case 'formatDay':
	        case 'formatDayHeader':
	        case 'formatDayTitle':
	        case 'formatMonth':
	        case 'formatMonthTitle':
	        case 'formatYear':
	          self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $interpolate($scope.datepickerOptions[key])($scope.$parent) : datepickerConfig[key];
	          break;
	        case 'showWeeks':
	        case 'shortcutPropagation':
	        case 'yearColumns':
	        case 'yearRows':
	          self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $scope.datepickerOptions[key] : datepickerConfig[key];
	          break;
	        case 'startingDay':
	          if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	            self.startingDay = $scope.datepickerOptions.startingDay;
	          } else if (angular.isNumber(datepickerConfig.startingDay)) {
	            self.startingDay = datepickerConfig.startingDay;
	          } else {
	            self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	          }
	
	          break;
	        case 'maxDate':
	        case 'minDate':
	          if ($scope.datepickerOptions[key]) {
	            $scope.$watch(function () {
	              return $scope.datepickerOptions[key];
	            }, function (value) {
	              if (value) {
	                if (angular.isDate(value)) {
	                  self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
	                } else {
	                  self[key] = new Date(dateFilter(value, 'medium'));
	                }
	              } else {
	                self[key] = null;
	              }
	
	              self.refreshView();
	            });
	          } else {
	            self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;
	          }
	
	          break;
	        case 'maxMode':
	        case 'minMode':
	          if ($scope.datepickerOptions[key]) {
	            $scope.$watch(function () {
	              return $scope.datepickerOptions[key];
	            }, function (value) {
	              self[key] = $scope[key] = angular.isDefined(value) ? value : datepickerOptions[key];
	              if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	                $scope.datepickerMode = self[key];
	                $scope.datepickerOptions.datepickerMode = self[key];
	              }
	            });
	          } else {
	            self[key] = $scope[key] = datepickerConfig[key] || null;
	          }
	
	          break;
	        case 'initDate':
	          if ($scope.datepickerOptions.initDate) {
	            self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.timezone) || new Date();
	            $scope.$watch(function () {
	              return $scope.datepickerOptions.initDate;
	            }, function (initDate) {
	              if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	                self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
	                self.refreshView();
	              }
	            });
	          } else {
	            self.activeDate = new Date();
	          }
	      }
	    });
	  } else {
	    // Interpolated configuration attributes
	    angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle'], function (key) {
	      self[key] = angular.isDefined($attrs[key]) ? $interpolate($attrs[key])($scope.$parent) : datepickerConfig[key];
	
	      if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
	        $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	      }
	    });
	
	    // Evaled configuration attributes
	    angular.forEach(['showWeeks', 'yearRows', 'yearColumns', 'shortcutPropagation'], function (key) {
	      self[key] = angular.isDefined($attrs[key]) ? $scope.$parent.$eval($attrs[key]) : datepickerConfig[key];
	
	      if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
	        $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	      }
	    });
	
	    angular.forEach(['dateDisabled', 'customClass'], function (key) {
	      if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
	        $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	      }
	    });
	
	    if (angular.isDefined($attrs.startingDay)) {
	      if (datepickerAttributeWarning) {
	        $log.warn('uib-datepicker startingDay attribute usage is deprecated, use datepicker-options attribute instead');
	      }
	
	      self.startingDay = $scope.$parent.$eval($attrs.startingDay);
	    } else if (angular.isNumber(datepickerConfig.startingDay)) {
	      self.startingDay = datepickerConfig.startingDay;
	    } else {
	      self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	    }
	
	    // Watchable date attributes
	    angular.forEach(['minDate', 'maxDate'], function (key) {
	      if ($attrs[key]) {
	        if (datepickerAttributeWarning) {
	          $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	        }
	
	        watchListeners.push($scope.$parent.$watch($attrs[key], function (value) {
	          if (value) {
	            if (angular.isDate(value)) {
	              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
	            } else {
	              self[key] = new Date(dateFilter(value, 'medium'));
	            }
	          } else {
	            self[key] = null;
	          }
	
	          self.refreshView();
	        }));
	      } else {
	        self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;
	      }
	    });
	
	    angular.forEach(['minMode', 'maxMode'], function (key) {
	      if ($attrs[key]) {
	        if (datepickerAttributeWarning) {
	          $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	        }
	
	        watchListeners.push($scope.$parent.$watch($attrs[key], function (value) {
	          self[key] = $scope[key] = angular.isDefined(value) ? value : $attrs[key];
	          if (key === 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key])) {
	            $scope.datepickerMode = self[key];
	          }
	        }));
	      } else {
	        self[key] = $scope[key] = datepickerConfig[key] || null;
	      }
	    });
	
	    if (angular.isDefined($attrs.initDate)) {
	      if (datepickerAttributeWarning) {
	        $log.warn('uib-datepicker initDate attribute usage is deprecated, use datepicker-options attribute instead');
	      }
	
	      var initDate = dateParser.fromTimezone($scope.$parent.$eval($attrs.initDate), ngModelOptions.timezone);
	      this.activeDate = !isNaN(initDate) ? initDate : new Date();
	      watchListeners.push($scope.$parent.$watch($attrs.initDate, function (initDate) {
	        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	          initDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
	          self.activeDate = !isNaN(initDate) ? initDate : new Date();
	          self.refreshView();
	        }
	      }));
	    } else {
	      this.activeDate = new Date();
	    }
	
	    if ($attrs.datepickerMode && datepickerAttributeWarning) {
	      $log.warn('uib-datepicker datepickerMode attribute usage is deprecated, use datepicker-options attribute instead');
	    }
	
	    $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
	  }
	
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if (angular.isDefined($attrs.ngDisabled)) {
	    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
	      $scope.disabled = disabled;
	      self.refreshView();
	    }));
	  }
	
	  $scope.isActive = function (dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function (ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelOptions = ngModelCtrl_.$options || datepickerConfig.ngModelOptions;
	
	    this.activeDate = ngModelCtrl.$modelValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$modelValue), ngModelOptions.timezone) : dateParser.fromTimezone(new Date(), ngModelOptions.timezone);
	
	    ngModelCtrl.$render = function () {
	      self.render();
	    };
	  };
	
	  this.render = function () {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.timezone);
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function () {
	    if (this.element) {
	      $scope.selectedDt = null;
	      this._refreshView();
	      if ($scope.activeDt) {
	        $scope.activeDateId = $scope.activeDt.uid;
	      }
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      date = dateParser.fromTimezone(date, ngModelOptions.timezone);
	      ngModelCtrl.$setValidity('dateDisabled', !date || this.element && !this.isDisabled(date));
	    }
	  };
	
	  this.createDateObject = function (date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    model = dateParser.fromTimezone(model, ngModelOptions.timezone);
	    var today = new Date();
	    today = dateParser.fromTimezone(today, ngModelOptions.timezone);
	    var time = this.compare(date, today);
	    var dt = {
	      date: date,
	      label: dateParser.filter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      past: time < 0,
	      current: time === 0,
	      future: time > 0,
	      customClass: this.customClass(date) || null
	    };
	
	    if (model && this.compare(date, model) === 0) {
	      $scope.selectedDt = dt;
	    }
	
	    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	      $scope.activeDt = dt;
	    }
	
	    return dt;
	  };
	
	  this.isDisabled = function (date) {
	    return $scope.disabled || this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
	  };
	
	  this.customClass = function (date) {
	    return $scope.customClass({ date: date, mode: $scope.datepickerMode });
	  };
	
	  // Split array into smaller arrays
	  this.split = function (arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function (date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.timezone) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      dt = dateParser.toTimezone(dt, ngModelOptions.timezone);
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);
	
	      $scope.$emit('uib:datepicker.mode');
	    }
	  };
	
	  $scope.move = function (direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function (direction) {
	    direction = direction || 1;
	
	    if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {
	      return;
	    }
	
	    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);
	
	    $scope.$emit('uib:datepicker.mode');
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function focusElement() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function (evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	
	  $scope.$on("$destroy", function () {
	    //Clear all watch listeners on destroy
	    while (watchListeners.length) {
	      watchListeners.shift()();
	    }
	  });
	
	  function setMode(mode) {
	    $scope.datepickerMode = mode;
	    if (optionsUsed) {
	      $scope.datepickerOptions.datepickerMode = mode;
	    }
	  }
	}]).controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function (ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function (startDate, n) {
	    var dates = new Array(n),
	        current = new Date(startDate),
	        i = 0,
	        date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function () {
	    var year = this.activeDate.getFullYear(),
	        month = this.activeDate.getMonth(),
	        firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	        numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,
	        firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-week calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function (date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 7;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}]).controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function (ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function () {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, 3);
	  };
	
	  this.compare = function (date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 3;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 3;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}]).controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  var columns, range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function () {
	    columns = this.yearColumns;
	    range = this.yearRows * columns;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function () {
	    var years = new Array(range),
	        date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, columns);
	    scope.columns = columns;
	  };
	
	  this.compare = function (date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - columns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + columns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? -1 : 1) * range;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}]).directive('uibDatepicker', function () {
	  return {
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerMode: '=?',
	      datepickerOptions: '=?',
	      dateDisabled: '&',
	      customClass: '&',
	      shortcutPropagation: '&?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	}).directive('uibDaypicker', function () {
	  return {
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/day.html';
	    },
	    require: ['^uibDatepicker', 'uibDaypicker'],
	    controller: 'UibDaypickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	}).directive('uibMonthpicker', function () {
	  return {
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/month.html';
	    },
	    require: ['^uibDatepicker', 'uibMonthpicker'],
	    controller: 'UibMonthpickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	}).directive('uibYearpicker', function () {
	  return {
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/year.html';
	    },
	    require: ['^uibDatepicker', 'uibYearpicker'],
	    controller: 'UibYearpickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	}).value('uibDatepickerPopupAttributeWarning', true).constant('uibDatepickerPopupConfig', {
	  altInputFormats: [],
	  appendToBody: false,
	  clearText: 'Clear',
	  closeOnDateSelection: true,
	  closeText: 'Done',
	  currentText: 'Today',
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'uib/template/datepicker/popup.html',
	  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  onOpenFocus: true,
	  showButtonBar: true,
	  placement: 'auto bottom-left'
	}).controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', 'uibDatepickerPopupAttributeWarning', function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, datepickerPopupAttributeWarning) {
	  var cache = {},
	      isHtml5DateInput = false;
	  var dateFormat,
	      closeOnDateSelection,
	      appendToBody,
	      onOpenFocus,
	      datepickerPopupTemplateUrl,
	      datepickerTemplateUrl,
	      popupEl,
	      datepickerEl,
	      scrollParentEl,
	      ngModel,
	      ngModelOptions,
	      $popup,
	      altInputFormats,
	      watchListeners = [];
	
	  $scope.watchData = {};
	
	  this.init = function (_ngModel_) {
	    ngModel = _ngModel_;
	    ngModelOptions = _ngModel_.$options || datepickerConfig.ngModelOptions;
	    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ? $scope.$parent.$eval($attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ? $scope.$parent.$eval($attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ? $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ? $attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ? $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	    altInputFormats = angular.isDefined($attrs.altInputFormats) ? $scope.$parent.$eval($attrs.altInputFormats) : datepickerPopupConfig.altInputFormats;
	
	    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ? $scope.$parent.$eval($attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[$attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
	        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	        // Invalidate the $modelValue to ensure that formatters re-run
	        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	        if (newDateFormat !== dateFormat) {
	          dateFormat = newDateFormat;
	          ngModel.$modelValue = null;
	
	          if (!dateFormat) {
	            throw new Error('uibDatepickerPopup must have a date format specified.');
	          }
	        }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	    $scope.ngModelOptions = angular.copy(ngModelOptions);
	    $scope.ngModelOptions.timezone = null;
	    if ($scope.ngModelOptions.updateOnDefault === true) {
	      $scope.ngModelOptions.updateOn = $scope.ngModelOptions.updateOn ? $scope.ngModelOptions.updateOn + ' default' : 'default';
	    }
	
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-model-options': 'ngModelOptions',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (isHtml5DateInput) {
	      if ($attrs.type === 'month') {
	        datepickerEl.attr('datepicker-mode', '"month"');
	        datepickerEl.attr('min-mode', 'month');
	      }
	    }
	
	    if ($scope.datepickerOptions) {
	      datepickerEl.attr('datepicker-options', 'datepickerOptions');
	    }
	
	    angular.forEach(['minMode', 'maxMode', 'datepickerMode', 'shortcutPropagation'], function (key) {
	      if ($attrs[key]) {
	        if (datepickerPopupAttributeWarning) {
	          $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	        }
	
	        var getAttribute = $parse($attrs[key]);
	        var propConfig = {
	          get: function get() {
	            return getAttribute($scope.$parent);
	          }
	        };
	
	        datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
	
	        // Propagate changes from datepicker to outside
	        if (key === 'datepickerMode') {
	          var setAttribute = getAttribute.assign;
	          propConfig.set = function (v) {
	            setAttribute($scope.$parent, v);
	          };
	        }
	
	        Object.defineProperty($scope.watchData, key, propConfig);
	      }
	    });
	
	    angular.forEach(['minDate', 'maxDate', 'initDate'], function (key) {
	      if ($attrs[key]) {
	        if (datepickerPopupAttributeWarning) {
	          $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	        }
	
	        var getAttribute = $parse($attrs[key]);
	
	        watchListeners.push($scope.$parent.$watch(getAttribute, function (value) {
	          if (key === 'minDate' || key === 'maxDate') {
	            if (value === null) {
	              cache[key] = null;
	            } else if (angular.isDate(value)) {
	              cache[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
	            } else {
	              cache[key] = new Date(dateFilter(value, 'medium'));
	            }
	
	            $scope.watchData[key] = value === null ? null : cache[key];
	          } else {
	            var date = value ? new Date(value) : new Date();
	            $scope.watchData[key] = dateParser.fromTimezone(date, ngModelOptions.timezone);
	          }
	        }));
	
	        datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
	      }
	    });
	
	    if ($attrs.dateDisabled) {
	      if (datepickerPopupAttributeWarning) {
	        $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	      }
	
	      datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
	    }
	
	    angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle', 'showWeeks', 'startingDay', 'yearRows', 'yearColumns'], function (key) {
	      if (angular.isDefined($attrs[key])) {
	        if (datepickerPopupAttributeWarning) {
	          $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	        }
	
	        datepickerEl.attr(cameltoDash(key), $attrs[key]);
	      }
	    });
	
	    if ($attrs.customClass) {
	      if (datepickerPopupAttributeWarning) {
	        $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	      }
	
	      datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
	    }
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function (value) {
	        if (ngModel.$isEmpty(value)) {
	          $scope.date = value;
	          return value;
	        }
	
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);
	
	        if (angular.isNumber($scope.date)) {
	          $scope.date = new Date($scope.date);
	        }
	
	        return dateParser.filter($scope.date, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function (value) {
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function () {
	      $scope.date = parseDateString(ngModel.$viewValue);
	    });
	
	    $element.on('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)($scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      $element.after($popup);
	    }
	
	    $scope.$on('$destroy', function () {
	      if ($scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          $scope.$apply(function () {
	            $scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      $element.off('keydown', inputKeydownBind);
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });
	  };
	
	  $scope.getText = function (key) {
	    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  $scope.isDisabled = function (date) {
	    if (date === 'today') {
	      date = dateParser.fromTimezone(new Date(), ngModelOptions.timezone);
	    }
	
	    if ($scope.datepickerOptions) {
	      return $scope.datepickerOptions && $scope.datepickerOptions.minDate && $scope.compare(date, $scope.datepickerOptions.minDate) < 0 || $scope.datepickerOptions.maxDate && $scope.compare(date, $scope.datepickerOptions.maxDate) > 0;
	    }
	
	    return $scope.watchData.minDate && $scope.compare(date, cache.minDate) < 0 || $scope.watchData.maxDate && $scope.compare(date, cache.maxDate) > 0;
	  };
	
	  $scope.compare = function (date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	  };
	
	  // Inner change
	  $scope.dateSelection = function (dt) {
	    if (angular.isDefined(dt)) {
	      $scope.date = dt;
	    }
	    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    $element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.keydown = function (evt) {
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.select = function (date, evt) {
	    evt.stopPropagation();
	
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate($scope.date)) {
	        date = new Date($scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = new Date(today.setHours(0, 0, 0, 0));
	      }
	    }
	    $scope.dateSelection(date);
	  };
	
	  $scope.close = function (evt) {
	    evt.stopPropagation();
	
	    $scope.isOpen = false;
	    $element[0].focus();
	  };
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if ($attrs.ngDisabled) {
	    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
	      $scope.disabled = disabled;
	    }));
	  }
	
	  $scope.$watch('isOpen', function (value) {
	    if (value) {
	      if (!$scope.disabled) {
	        $timeout(function () {
	          positionPopup();
	
	          if (onOpenFocus) {
	            $scope.$broadcast('uib:datepicker.focus');
	          }
	          $document.on('click', documentClickBind);
	
	          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	          if (appendToBody || $position.parsePlacement(placement)[2]) {
	            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	            if (scrollParentEl) {
	              scrollParentEl.on('scroll', positionPopup);
	            }
	          } else {
	            scrollParentEl = null;
	          }
	
	          angular.element($window).on('resize', positionPopup);
	        }, 0, false);
	      } else {
	        $scope.isOpen = false;
	      }
	    } else {
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function ($1) {
	      return '-' + $1.toLowerCase();
	    });
	  }
	
	  function parseDateString(viewValue) {
	    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	    if (isNaN(date)) {
	      for (var i = 0; i < altInputFormats.length; i++) {
	        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	        if (!isNaN(date)) {
	          return date;
	        }
	      }
	    }
	    return date;
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    }
	
	    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    }
	
	    if (angular.isString(viewValue)) {
	      var date = parseDateString(viewValue);
	      if (!isNaN(date)) {
	        return dateParser.toTimezone(date, ngModelOptions.timezone);
	      }
	    }
	
	    return ngModel.$options && ngModel.$options.allowInvalid ? viewValue : undefined;
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!$attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	
	    if (!value) {
	      return true;
	    }
	
	    if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    }
	
	    if (angular.isString(value)) {
	      return !isNaN(parseDateString(viewValue));
	    }
	
	    return false;
	  }
	
	  function documentClickBind(event) {
	    if (!$scope.isOpen && $scope.disabled) {
	      return;
	    }
	
	    var popup = $popup[0];
	    var dpContainsTarget = $element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      $scope.$apply(function () {
	        $scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && $scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function () {
	        $scope.isOpen = false;
	      });
	      $element[0].focus();
	    } else if (evt.which === 40 && !$scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function () {
	        $scope.isOpen = true;
	      });
	    }
	  }
	
	  function positionPopup() {
	    if ($scope.isOpen) {
	      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	      var position = $position.positionElements($element, dpElement, placement, appendToBody);
	      dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
	      if (dpElement.hasClass('uib-position-measure')) {
	        dpElement.removeClass('uib-position-measure');
	      }
	    }
	  }
	
	  $scope.$on('uib:datepicker.mode', function () {
	    $timeout(positionPopup, 0, false);
	  });
	}]).directive('uibDatepickerPopup', function () {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      datepickerOptions: '=?',
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@',
	      dateDisabled: '&',
	      customClass: '&'
	    },
	    link: function link(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	          ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	}).directive('uibDatepickerPopupWrap', function () {
	  return {
	    replace: true,
	    transclude: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/popup.html';
	    }
	  };
	});
	
	angular.module('ui.bootstrap.debounce', [])
	/**
	 * A helper, internal service that debounces a function
	 */
	.factory('$$debounce', ['$timeout', function ($timeout) {
	  return function (callback, debounceTime) {
	    var timeoutPromise;
	
	    return function () {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	
	      timeoutPromise = $timeout(function () {
	        callback.apply(self, args);
	      }, debounceTime);
	    };
	  };
	}]);
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position']).constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	}).service('uibDropdownService', ['$document', '$rootScope', function ($document, $rootScope) {
	  var openScope = null;
	
	  this.open = function (dropdownScope) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	      $document.on('keydown', keybindFilter);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	  };
	
	  this.close = function (dropdownScope) {
	    if (openScope === dropdownScope) {
	      openScope = null;
	      $document.off('click', closeDropdown);
	      $document.off('keydown', keybindFilter);
	    }
	  };
	
	  var closeDropdown = function closeDropdown(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope) {
	      return;
	    }
	
	    if (evt && openScope.getAutoClose() === 'disabled') {
	      return;
	    }
	
	    if (evt && evt.which === 3) {
	      return;
	    }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  var keybindFilter = function keybindFilter(evt) {
	    if (evt.which === 27) {
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}]).controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	      scope = $scope.$new(),
	      // create a child scope so we are not polluting original one
	  templateScope,
	      appendToOpenClass = dropdownConfig.appendToOpenClass,
	      openClass = dropdownConfig.openClass,
	      getIsOpen,
	      setIsOpen = angular.noop,
	      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	      appendToBody = false,
	      appendTo = null,
	      keynavEnabled = false,
	      selectedOption = null,
	      body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function () {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function (value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      appendTo.append(self.dropdownMenu);
	      $element.on('$destroy', function handleDestroyEvent() {
	        self.dropdownMenu.remove();
	      });
	    }
	  };
	
	  this.toggle = function (open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function () {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function () {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function () {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function () {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function () {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function (keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	    angular.element(self.dropdownMenu).find('a') : $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40:
	        {
	          if (!angular.isNumber(self.selectedOption)) {
	            self.selectedOption = 0;
	          } else {
	            self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
	          }
	          break;
	        }
	      case 38:
	        {
	          if (!angular.isNumber(self.selectedOption)) {
	            self.selectedOption = elems.length - 1;
	          } else {
	            self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
	          }
	          break;
	        }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function () {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function () {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  scope.$watch('isOpen', function (isOpen, wasOpen) {
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	          css,
	          rightalign;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        css.right = window.innerWidth - (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth - (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var hasOpenClass = openContainer.hasClass(appendTo ? appendToOpenClass : openClass);
	
	    if (hasOpenClass === !isOpen) {
	      $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, appendTo ? appendToOpenClass : openClass).then(function () {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function (dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	          });
	        });
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope);
	    } else {
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      uibDropdownService.close(scope);
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	
	  $scope.$on('$locationChangeSuccess', function () {
	    if (scope.getAutoClose() !== 'disabled') {
	      scope.isOpen = false;
	    }
	  });
	}]).directive('uibDropdown', function () {
	  return {
	    controller: 'UibDropdownController',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	}).directive('uibDropdownMenu', function () {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	}).directive('uibDropdownToggle', function () {
	  return {
	    require: '?^uibDropdown',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function toggleDropdown(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function () {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.bind('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function () {
	        element.unbind('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	.factory('$$stackedMap', function () {
	  return {
	    createNew: function createNew() {
	      var stack = [];
	
	      return {
	        add: function add(key, value) {
	          stack.push({
	            key: key,
	            value: value
	          });
	        },
	        get: function get(key) {
	          for (var i = 0; i < stack.length; i++) {
	            if (key === stack[i].key) {
	              return stack[i];
	            }
	          }
	        },
	        keys: function keys() {
	          var keys = [];
	          for (var i = 0; i < stack.length; i++) {
	            keys.push(stack[i].key);
	          }
	          return keys;
	        },
	        top: function top() {
	          return stack[stack.length - 1];
	        },
	        remove: function remove(key) {
	          var idx = -1;
	          for (var i = 0; i < stack.length; i++) {
	            if (key === stack[i].key) {
	              idx = i;
	              break;
	            }
	          }
	          return stack.splice(idx, 1)[0];
	        },
	        removeTop: function removeTop() {
	          return stack.splice(stack.length - 1, 1)[0];
	        },
	        length: function length() {
	          return stack.length;
	        }
	      };
	    }
	  };
	});
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap'])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	.factory('$$multiMap', function () {
	  return {
	    createNew: function createNew() {
	      var map = {};
	
	      return {
	        entries: function entries() {
	          return Object.keys(map).map(function (key) {
	            return {
	              key: key,
	              value: map[key]
	            };
	          });
	        },
	        get: function get(key) {
	          return map[key];
	        },
	        hasKey: function hasKey(key) {
	          return !!map[key];
	        },
	        keys: function keys() {
	          return Object.keys(map);
	        },
	        put: function put(key, value) {
	          if (!map[key]) {
	            map[key] = [];
	          }
	
	          map[key].push(value);
	        },
	        remove: function remove(key, value) {
	          var values = map[key];
	
	          if (!values) {
	            return;
	          }
	
	          var idx = values.indexOf(value);
	
	          if (idx !== -1) {
	            values.splice(idx, 1);
	          }
	
	          if (!values.length) {
	            delete map[key];
	          }
	        }
	      };
	    }
	  };
	})
	
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	.provider('$uibResolve', function () {
	  var resolve = this;
	  this.resolver = null;
	
	  this.setResolver = function (resolver) {
	    this.resolver = resolver;
	  };
	
	  this.$get = ['$injector', '$q', function ($injector, $q) {
	    var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	    return {
	      resolve: function resolve(invocables, locals, parent, self) {
	        if (resolver) {
	          return resolver.resolve(invocables, locals, parent, self);
	        }
	
	        var promises = [];
	
	        angular.forEach(invocables, function (value) {
	          if (angular.isFunction(value) || angular.isArray(value)) {
	            promises.push($q.resolve($injector.invoke(value)));
	          } else if (angular.isString(value)) {
	            promises.push($q.resolve($injector.get(value)));
	          } else {
	            promises.push($q.resolve(value));
	          }
	        });
	
	        return $q.all(promises).then(function (resolves) {
	          var resolveObj = {};
	          var resolveIter = 0;
	          angular.forEach(invocables, function (value, key) {
	            resolveObj[key] = resolves[resolveIter++];
	          });
	
	          return resolveObj;
	        });
	      }
	    };
	  }];
	})
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	.directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack', function ($animate, $injector, $modalStack) {
	  return {
	    replace: true,
	    templateUrl: 'uib/template/modal/backdrop.html',
	    compile: function compile(tElement, tAttrs) {
	      tElement.addClass(tAttrs.backdropClass);
	      return linkFn;
	    }
	  };
	
	  function linkFn(scope, element, attrs) {
	    if (attrs.modalInClass) {
	      $animate.addClass(element, attrs.modalInClass);
	
	      scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	        var done = setIsAsync();
	        if (scope.modalOptions.animation) {
	          $animate.removeClass(element, attrs.modalInClass).then(done);
	        } else {
	          done();
	        }
	      });
	    }
	  }
	}]).directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document', function ($modalStack, $q, $animateCss, $document) {
	  return {
	    scope: {
	      index: '@'
	    },
	    replace: true,
	    transclude: true,
	    templateUrl: function templateUrl(tElement, tAttrs) {
	      return tAttrs.templateUrl || 'uib/template/modal/window.html';
	    },
	    link: function link(scope, element, attrs) {
	      element.addClass(attrs.windowClass || '');
	      element.addClass(attrs.windowTopClass || '');
	      scope.size = attrs.size;
	
	      scope.close = function (evt) {
	        var modal = $modalStack.getTop();
	        if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && evt.target === evt.currentTarget) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          $modalStack.dismiss(modal.key, 'backdrop click');
	        }
	      };
	
	      // moved from template to fix issue #2280
	      element.on('click', scope.close);
	
	      // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	      // We can detect that by using this property in the template associated with this directive and then use
	      // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	      scope.$isRendered = true;
	
	      // Deferred object that will be resolved when this modal is render.
	      var modalRenderDeferObj = $q.defer();
	      // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
	      // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
	      attrs.$observe('modalRender', function (value) {
	        if (value === 'true') {
	          modalRenderDeferObj.resolve();
	        }
	      });
	
	      modalRenderDeferObj.promise.then(function () {
	        var animationPromise = null;
	
	        if (attrs.modalInClass) {
	          animationPromise = $animateCss(element, {
	            addClass: attrs.modalInClass
	          }).start();
	
	          scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	            var done = setIsAsync();
	            $animateCss(element, {
	              removeClass: attrs.modalInClass
	            }).start().then(done);
	          });
	        }
	
	        $q.when(animationPromise).then(function () {
	          // Notify {@link $modalStack} that modal is rendered.
	          var modal = $modalStack.getTop();
	          if (modal) {
	            $modalStack.modalRendered(modal.key);
	          }
	
	          /**
	           * If something within the freshly-opened modal already has focus (perhaps via a
	           * directive that causes focus). then no need to try and focus anything.
	           */
	          if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	            var inputWithAutofocus = element[0].querySelector('[autofocus]');
	            /**
	             * Auto-focusing of a freshly-opened modal element causes any child elements
	             * with the autofocus attribute to lose focus. This is an issue on touch
	             * based devices which will show and then hide the onscreen keyboard.
	             * Attempts to refocus the autofocus element via JavaScript will not reopen
	             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	             * the modal element if the modal does not contain an autofocus element.
	             */
	            if (inputWithAutofocus) {
	              inputWithAutofocus.focus();
	            } else {
	              element[0].focus();
	            }
	          }
	        });
	      });
	    }
	  };
	}]).directive('uibModalAnimationClass', function () {
	  return {
	    compile: function compile(tElement, tAttrs) {
	      if (tAttrs.modalAnimation) {
	        tElement.addClass(tAttrs.uibModalAnimationClass);
	      }
	    }
	  };
	}).directive('uibModalTransclude', function () {
	  return {
	    link: function link(scope, element, attrs, controller, transclude) {
	      transclude(scope.$parent, function (clone) {
	        element.empty();
	        element.append(clone);
	      });
	    }
	  };
	}).factory('$uibModalStack', ['$animate', '$animateCss', '$document', '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap) {
	  var OPENED_MODAL_CLASS = 'modal-open';
	
	  var backdropDomEl, backdropScope;
	  var openedWindows = $$stackedMap.createNew();
	  var openedClasses = $$multiMap.createNew();
	  var $modalStack = {
	    NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	  };
	
	  //Modal focus behavior
	  var tabableSelector = 'a[href], area[href], input:not([disabled]), ' + 'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' + 'iframe, object, embed, *[tabindex], *[contenteditable=true]';
	
	  function isVisible(element) {
	    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
	  }
	
	  function backdropIndex() {
	    var topBackdropIndex = -1;
	    var opened = openedWindows.keys();
	    for (var i = 0; i < opened.length; i++) {
	      if (openedWindows.get(opened[i]).value.backdrop) {
	        topBackdropIndex = i;
	      }
	    }
	    return topBackdropIndex;
	  }
	
	  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
	    if (backdropScope) {
	      backdropScope.index = newBackdropIndex;
	    }
	  });
	
	  function removeModalWindow(modalInstance, elementToReceiveFocus) {
	    var modalWindow = openedWindows.get(modalInstance).value;
	    var appendToElement = modalWindow.appendTo;
	
	    //clean up the stack
	    openedWindows.remove(modalInstance);
	
	    removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
	      var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	      openedClasses.remove(modalBodyClass, modalInstance);
	      appendToElement.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
	      toggleTopWindowClass(true);
	    }, modalWindow.closedDeferred);
	    checkRemoveBackdrop();
	
	    //move focus to specified element if available, or else to body
	    if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	      elementToReceiveFocus.focus();
	    } else if (appendToElement.focus) {
	      appendToElement.focus();
	    }
	  }
	
	  // Add or remove "windowTopClass" from the top window in the stack
	  function toggleTopWindowClass(toggleSwitch) {
	    var modalWindow;
	
	    if (openedWindows.length() > 0) {
	      modalWindow = openedWindows.top().value;
	      modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	    }
	  }
	
	  function checkRemoveBackdrop() {
	    //remove backdrop if no longer needed
	    if (backdropDomEl && backdropIndex() === -1) {
	      var backdropScopeRef = backdropScope;
	      removeAfterAnimate(backdropDomEl, backdropScope, function () {
	        backdropScopeRef = null;
	      });
	      backdropDomEl = undefined;
	      backdropScope = undefined;
	    }
	  }
	
	  function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	    var asyncDeferred;
	    var asyncPromise = null;
	    var setIsAsync = function setIsAsync() {
	      if (!asyncDeferred) {
	        asyncDeferred = $q.defer();
	        asyncPromise = asyncDeferred.promise;
	      }
	
	      return function asyncDone() {
	        asyncDeferred.resolve();
	      };
	    };
	    scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	    // Note that it's intentional that asyncPromise might be null.
	    // That's when setIsAsync has not been called during the
	    // NOW_CLOSING_EVENT broadcast.
	    return $q.when(asyncPromise).then(afterAnimating);
	
	    function afterAnimating() {
	      if (afterAnimating.done) {
	        return;
	      }
	      afterAnimating.done = true;
	
	      $animate.leave(domEl).then(function () {
	        domEl.remove();
	        if (closedDeferred) {
	          closedDeferred.resolve();
	        }
	      });
	
	      scope.$destroy();
	      if (done) {
	        done();
	      }
	    }
	  }
	
	  $document.on('keydown', keydownListener);
	
	  $rootScope.$on('$destroy', function () {
	    $document.off('keydown', keydownListener);
	  });
	
	  function keydownListener(evt) {
	    if (evt.isDefaultPrevented()) {
	      return evt;
	    }
	
	    var modal = openedWindows.top();
	    if (modal) {
	      switch (evt.which) {
	        case 27:
	          {
	            if (modal.value.keyboard) {
	              evt.preventDefault();
	              $rootScope.$apply(function () {
	                $modalStack.dismiss(modal.key, 'escape key press');
	              });
	            }
	            break;
	          }
	        case 9:
	          {
	            var list = $modalStack.loadFocusElementList(modal);
	            var focusChanged = false;
	            if (evt.shiftKey) {
	              if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                focusChanged = $modalStack.focusLastFocusableElement(list);
	              }
	            } else {
	              if ($modalStack.isFocusInLastItem(evt, list)) {
	                focusChanged = $modalStack.focusFirstFocusableElement(list);
	              }
	            }
	
	            if (focusChanged) {
	              evt.preventDefault();
	              evt.stopPropagation();
	            }
	
	            break;
	          }
	      }
	    }
	  }
	
	  $modalStack.open = function (modalInstance, modal) {
	    var modalOpener = $document[0].activeElement,
	        modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	    toggleTopWindowClass(false);
	
	    openedWindows.add(modalInstance, {
	      deferred: modal.deferred,
	      renderDeferred: modal.renderDeferred,
	      closedDeferred: modal.closedDeferred,
	      modalScope: modal.scope,
	      backdrop: modal.backdrop,
	      keyboard: modal.keyboard,
	      openedClass: modal.openedClass,
	      windowTopClass: modal.windowTopClass,
	      animation: modal.animation,
	      appendTo: modal.appendTo
	    });
	
	    openedClasses.put(modalBodyClass, modalInstance);
	
	    var appendToElement = modal.appendTo,
	        currBackdropIndex = backdropIndex();
	
	    if (!appendToElement.length) {
	      throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	    }
	
	    if (currBackdropIndex >= 0 && !backdropDomEl) {
	      backdropScope = $rootScope.$new(true);
	      backdropScope.modalOptions = modal;
	      backdropScope.index = currBackdropIndex;
	      backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	      backdropDomEl.attr('backdrop-class', modal.backdropClass);
	      if (modal.animation) {
	        backdropDomEl.attr('modal-animation', 'true');
	      }
	      $compile(backdropDomEl)(backdropScope);
	      $animate.enter(backdropDomEl, appendToElement);
	    }
	
	    var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	    angularDomEl.attr({
	      'template-url': modal.windowTemplateUrl,
	      'window-class': modal.windowClass,
	      'window-top-class': modal.windowTopClass,
	      'size': modal.size,
	      'index': openedWindows.length() - 1,
	      'animate': 'animate'
	    }).html(modal.content);
	    if (modal.animation) {
	      angularDomEl.attr('modal-animation', 'true');
	    }
	
	    $animate.enter($compile(angularDomEl)(modal.scope), appendToElement).then(function () {
	      if (!modal.scope.$$uibDestructionScheduled) {
	        $animate.addClass(appendToElement, modalBodyClass);
	      }
	    });
	
	    openedWindows.top().value.modalDomEl = angularDomEl;
	    openedWindows.top().value.modalOpener = modalOpener;
	  };
	
	  function broadcastClosing(modalWindow, resultOrReason, closing) {
	    return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	  }
	
	  $modalStack.close = function (modalInstance, result) {
	    var modalWindow = openedWindows.get(modalInstance);
	    if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	      modalWindow.value.deferred.resolve(result);
	      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	      return true;
	    }
	    return !modalWindow;
	  };
	
	  $modalStack.dismiss = function (modalInstance, reason) {
	    var modalWindow = openedWindows.get(modalInstance);
	    if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	      modalWindow.value.deferred.reject(reason);
	      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	      return true;
	    }
	    return !modalWindow;
	  };
	
	  $modalStack.dismissAll = function (reason) {
	    var topModal = this.getTop();
	    while (topModal && this.dismiss(topModal.key, reason)) {
	      topModal = this.getTop();
	    }
	  };
	
	  $modalStack.getTop = function () {
	    return openedWindows.top();
	  };
	
	  $modalStack.modalRendered = function (modalInstance) {
	    var modalWindow = openedWindows.get(modalInstance);
	    if (modalWindow) {
	      modalWindow.value.renderDeferred.resolve();
	    }
	  };
	
	  $modalStack.focusFirstFocusableElement = function (list) {
	    if (list.length > 0) {
	      list[0].focus();
	      return true;
	    }
	    return false;
	  };
	
	  $modalStack.focusLastFocusableElement = function (list) {
	    if (list.length > 0) {
	      list[list.length - 1].focus();
	      return true;
	    }
	    return false;
	  };
	
	  $modalStack.isModalFocused = function (evt, modalWindow) {
	    if (evt && modalWindow) {
	      var modalDomEl = modalWindow.value.modalDomEl;
	      if (modalDomEl && modalDomEl.length) {
	        return (evt.target || evt.srcElement) === modalDomEl[0];
	      }
	    }
	    return false;
	  };
	
	  $modalStack.isFocusInFirstItem = function (evt, list) {
	    if (list.length > 0) {
	      return (evt.target || evt.srcElement) === list[0];
	    }
	    return false;
	  };
	
	  $modalStack.isFocusInLastItem = function (evt, list) {
	    if (list.length > 0) {
	      return (evt.target || evt.srcElement) === list[list.length - 1];
	    }
	    return false;
	  };
	
	  $modalStack.loadFocusElementList = function (modalWindow) {
	    if (modalWindow) {
	      var modalDomE1 = modalWindow.value.modalDomEl;
	      if (modalDomE1 && modalDomE1.length) {
	        var elements = modalDomE1[0].querySelectorAll(tabableSelector);
	        return elements ? Array.prototype.filter.call(elements, function (element) {
	          return isVisible(element);
	        }) : elements;
	      }
	    }
	  };
	
	  return $modalStack;
	}]).provider('$uibModal', function () {
	  var $modalProvider = {
	    options: {
	      animation: true,
	      backdrop: true, //can also be false or 'static'
	      keyboard: true
	    },
	    $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack', function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	      var $modal = {};
	
	      function getTemplatePromise(options) {
	        return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);
	      }
	
	      var promiseChain = null;
	      $modal.getPromiseChain = function () {
	        return promiseChain;
	      };
	
	      $modal.open = function (modalOptions) {
	        var modalResultDeferred = $q.defer();
	        var modalOpenedDeferred = $q.defer();
	        var modalClosedDeferred = $q.defer();
	        var modalRenderDeferred = $q.defer();
	
	        //prepare an instance of a modal to be injected into controllers and returned to a caller
	        var modalInstance = {
	          result: modalResultDeferred.promise,
	          opened: modalOpenedDeferred.promise,
	          closed: modalClosedDeferred.promise,
	          rendered: modalRenderDeferred.promise,
	          close: function close(result) {
	            return $modalStack.close(modalInstance, result);
	          },
	          dismiss: function dismiss(reason) {
	            return $modalStack.dismiss(modalInstance, reason);
	          }
	        };
	
	        //merge and clean up options
	        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	        modalOptions.resolve = modalOptions.resolve || {};
	        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	        //verify options
	        if (!modalOptions.template && !modalOptions.templateUrl) {
	          throw new Error('One of template or templateUrl options is required.');
	        }
	
	        var templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	
	        function resolveWithTemplate() {
	          return templateAndResolvePromise;
	        }
	
	        // Wait for the resolution of the existing promise chain.
	        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	        // Then add to $modalStack and resolve opened.
	        // Finally clean up the chain variable if no subsequent modal has overwritten it.
	        var samePromise;
	        samePromise = promiseChain = $q.all([promiseChain]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {
	          var providedScope = modalOptions.scope || $rootScope;
	
	          var modalScope = providedScope.$new();
	          modalScope.$close = modalInstance.close;
	          modalScope.$dismiss = modalInstance.dismiss;
	
	          modalScope.$on('$destroy', function () {
	            if (!modalScope.$$uibDestructionScheduled) {
	              modalScope.$dismiss('$uibUnscheduledDestruction');
	            }
	          });
	
	          var ctrlInstance,
	              ctrlInstantiate,
	              ctrlLocals = {};
	
	          //controllers
	          if (modalOptions.controller) {
	            ctrlLocals.$scope = modalScope;
	            ctrlLocals.$uibModalInstance = modalInstance;
	            angular.forEach(tplAndVars[1], function (value, key) {
	              ctrlLocals[key] = value;
	            });
	
	            // the third param will make the controller instantiate later,private api
	            // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	            ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true);
	            if (modalOptions.controllerAs) {
	              ctrlInstance = ctrlInstantiate.instance;
	
	              if (modalOptions.bindToController) {
	                ctrlInstance.$close = modalScope.$close;
	                ctrlInstance.$dismiss = modalScope.$dismiss;
	                angular.extend(ctrlInstance, providedScope);
	              }
	
	              ctrlInstance = ctrlInstantiate();
	
	              modalScope[modalOptions.controllerAs] = ctrlInstance;
	            } else {
	              ctrlInstance = ctrlInstantiate();
	            }
	
	            if (angular.isFunction(ctrlInstance.$onInit)) {
	              ctrlInstance.$onInit();
	            }
	          }
	
	          $modalStack.open(modalInstance, {
	            scope: modalScope,
	            deferred: modalResultDeferred,
	            renderDeferred: modalRenderDeferred,
	            closedDeferred: modalClosedDeferred,
	            content: tplAndVars[0],
	            animation: modalOptions.animation,
	            backdrop: modalOptions.backdrop,
	            keyboard: modalOptions.keyboard,
	            backdropClass: modalOptions.backdropClass,
	            windowTopClass: modalOptions.windowTopClass,
	            windowClass: modalOptions.windowClass,
	            windowTemplateUrl: modalOptions.windowTemplateUrl,
	            size: modalOptions.size,
	            openedClass: modalOptions.openedClass,
	            appendTo: modalOptions.appendTo
	          });
	          modalOpenedDeferred.resolve(true);
	        }, function resolveError(reason) {
	          modalOpenedDeferred.reject(reason);
	          modalResultDeferred.reject(reason);
	        })['finally'](function () {
	          if (promiseChain === samePromise) {
	            promiseChain = null;
	          }
	        });
	
	        return modalInstance;
	      };
	
	      return $modal;
	    }]
	  };
	
	  return $modalProvider;
	});
	
	angular.module('ui.bootstrap.paging', [])
	/**
	 * Helper internal service for generating common controller code between the
	 * pager and pagination components
	 */
	.factory('uibPaging', ['$parse', function ($parse) {
	  return {
	    create: function create(ctrl, $scope, $attrs) {
	      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
	      ctrl._watchers = [];
	
	      ctrl.init = function (ngModelCtrl, config) {
	        ctrl.ngModelCtrl = ngModelCtrl;
	        ctrl.config = config;
	
	        ngModelCtrl.$render = function () {
	          ctrl.render();
	        };
	
	        if ($attrs.itemsPerPage) {
	          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
	            ctrl.itemsPerPage = parseInt(value, 10);
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }));
	        } else {
	          ctrl.itemsPerPage = config.itemsPerPage;
	        }
	
	        $scope.$watch('totalItems', function (newTotal, oldTotal) {
	          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }
	        });
	      };
	
	      ctrl.calculateTotalPages = function () {
	        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	      };
	
	      ctrl.render = function () {
	        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
	      };
	
	      $scope.selectPage = function (page, evt) {
	        if (evt) {
	          evt.preventDefault();
	        }
	
	        var clickAllowed = !$scope.ngDisabled || !evt;
	        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	          if (evt && evt.target) {
	            evt.target.blur();
	          }
	          ctrl.ngModelCtrl.$setViewValue(page);
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.getText = function (key) {
	        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
	      };
	
	      $scope.noPrevious = function () {
	        return $scope.page === 1;
	      };
	
	      $scope.noNext = function () {
	        return $scope.page === $scope.totalPages;
	      };
	
	      ctrl.updatePage = function () {
	        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable
	
	        if ($scope.page > $scope.totalPages) {
	          $scope.selectPage($scope.totalPages);
	        } else {
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.$on('$destroy', function () {
	        while (ctrl._watchers.length) {
	          ctrl._watchers.shift()();
	        }
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging']).controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function ($scope, $attrs, uibPaging, uibPagerConfig) {
	  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;
	
	  uibPaging.create(this, $scope, $attrs);
	}]).constant('uibPagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	}).directive('uibPager', ['uibPagerConfig', function (uibPagerConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['uibPager', '?ngModel'],
	    controller: 'UibPagerController',
	    controllerAs: 'pager',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pager/pager.html';
	    },
	    replace: true,
	    link: function link(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	        return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging']).controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
	  var ctrl = this;
	  // Setup configuration parameters
	  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
	      rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
	      forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
	      boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
	      pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) {
	    return $scope.$parent.$eval($attrs.pageLabel, { $page: idx });
	  } : angular.identity;
	  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
	  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
	
	  uibPaging.create(this, $scope, $attrs);
	
	  if ($attrs.maxSize) {
	    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
	      maxSize = parseInt(value, 10);
	      ctrl.render();
	    }));
	  }
	
	  // Create page object used in template
	  function makePage(number, text, isActive) {
	    return {
	      number: number,
	      text: text,
	      active: isActive
	    };
	  }
	
	  function getPages(currentPage, totalPages) {
	    var pages = [];
	
	    // Default page limits
	    var startPage = 1,
	        endPage = totalPages;
	    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	    // recompute if maxSize
	    if (isMaxSized) {
	      if (rotate) {
	        // Current page is displayed in the middle of the visible ones
	        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
	        endPage = startPage + maxSize - 1;
	
	        // Adjust if limit is exceeded
	        if (endPage > totalPages) {
	          endPage = totalPages;
	          startPage = endPage - maxSize + 1;
	        }
	      } else {
	        // Visible pages are paginated with maxSize
	        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
	
	        // Adjust last page if limit is exceeded
	        endPage = Math.min(startPage + maxSize - 1, totalPages);
	      }
	    }
	
	    // Add page number links
	    for (var number = startPage; number <= endPage; number++) {
	      var page = makePage(number, pageLabel(number), number === currentPage);
	      pages.push(page);
	    }
	
	    // Add links to move between page sets
	    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
	      if (startPage > 1) {
	        if (!boundaryLinkNumbers || startPage > 3) {
	          //need ellipsis for all options unless range is too close to beginning
	          var previousPageSet = makePage(startPage - 1, '...', false);
	          pages.unshift(previousPageSet);
	        }
	        if (boundaryLinkNumbers) {
	          if (startPage === 3) {
	            //need to replace ellipsis when the buttons would be sequential
	            var secondPageLink = makePage(2, '2', false);
	            pages.unshift(secondPageLink);
	          }
	          //add the first page
	          var firstPageLink = makePage(1, '1', false);
	          pages.unshift(firstPageLink);
	        }
	      }
	
	      if (endPage < totalPages) {
	        if (!boundaryLinkNumbers || endPage < totalPages - 2) {
	          //need ellipsis for all options unless range is too close to end
	          var nextPageSet = makePage(endPage + 1, '...', false);
	          pages.push(nextPageSet);
	        }
	        if (boundaryLinkNumbers) {
	          if (endPage === totalPages - 2) {
	            //need to replace ellipsis when the buttons would be sequential
	            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
	            pages.push(secondToLastPageLink);
	          }
	          //add the last page
	          var lastPageLink = makePage(totalPages, totalPages, false);
	          pages.push(lastPageLink);
	        }
	      }
	    }
	    return pages;
	  }
	
	  var originalRender = this.render;
	  this.render = function () {
	    originalRender();
	    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
	      $scope.pages = getPages($scope.page, $scope.totalPages);
	    }
	  };
	}]).constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  boundaryLinkNumbers: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true,
	  forceEllipses: false
	}).directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled: '='
	    },
	    require: ['uibPagination', '?ngModel'],
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
	    },
	    replace: true,
	    link: function link(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	        return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function () {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
	  this.options = function (value) {
	    angular.extend(globalOptions, value);
	  };
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function (letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keypress', keypressListener);
	
	    $rootScope.$on('$destroy', function () {
	      $document.off('keypress', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          openedTooltips.removeTop();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function (trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template = '<div ' + directiveName + '-popup ' + 'title="' + startSym + 'title' + endSym + '" ' + (options.useContentExp ? 'content-exp="contentExp()" ' : 'content="' + startSym + 'content' + endSym + '" ') + 'placement="' + startSym + 'placement' + endSym + '" ' + 'popup-class="' + startSym + 'popupClass' + endSym + '" ' + 'animation="animation" ' + 'is-open="isOpen"' + 'origin-scope="origScope" ' + 'class="uib-position-measure"' + '>' + '</div>';
	
	      return {
	        compile: function compile(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function positionTooltip() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) {
	                return;
	              }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function () {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	
	                  if (!tooltip.hasClass(ttPosition.placement.split('-')[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(ttPosition.placement.split('-')[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	            openedTooltips.add(ttScope, {
	              close: hide
	            });
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function () {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function () {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	                tooltip = null;
	              }
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function () {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function (val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function (val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(scope.$watch(contentParse, function (val) {
	                  ttScope.content = val;
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  }
	                }));
	
	                observers.push(tooltipLinkedScope.$watch(function () {
	                  if (!repositionScheduled) {
	                    repositionScheduled = true;
	                    tooltipLinkedScope.$$postDigest(function () {
	                      repositionScheduled = false;
	                      if (ttScope && ttScope.isOpen) {
	                        positionTooltip();
	                      }
	                    });
	                  }
	                }));
	              } else {
	                observers.push(attrs.$observe(ttType, function (val) {
	                  ttScope.content = val;
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  } else {
	                    positionTooltip();
	                  }
	                }));
	              }
	
	              observers.push(attrs.$observe(prefix + 'Title', function (val) {
	                ttScope.title = val;
	                if (ttScope.isOpen) {
	                  positionTooltip();
	                }
	              }));
	
	              observers.push(attrs.$observe(prefix + 'Placement', function (val) {
	                ttScope.placement = val ? val : options.placement;
	                var placement = $position.parsePlacement(ttScope.placement);
	                lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	                if (ttScope.isOpen) {
	                  positionTooltip();
	                }
	              }));
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function (observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function unregisterTriggers() {
	              triggers.show.forEach(function (trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	              });
	              triggers.hide.forEach(function (trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var val = attrs[prefix + 'Trigger'];
	              unregisterTriggers();
	
	              triggers = getTriggers(val);
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function (trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	
	                  element.on('keypress', function (e) {
	                    if (e.which === 27) {
	                      hideTooltipBind();
	                    }
	                  });
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              openedTooltips.remove(ttScope);
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', ['$animate', '$sce', '$compile', '$templateRequest', function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function link(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	          currentScope,
	          previousElement,
	          currentElement;
	
	      var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function () {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function (response) {
	            if (thisChangeId !== changeCounter) {
	              return;
	            }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function (clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function () {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation()) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}]).directive('uibTooltipPopup', function () {
	  return {
	    replace: true,
	    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	}).directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}]).directive('uibTooltipTemplatePopup', function () {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	}).directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]).directive('uibTooltipHtmlPopup', function () {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	}).directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip']).directive('uibPopoverTemplatePopup', function () {
	  return {
	    replace: true,
	    scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'uib/template/popover/popover-template.html'
	  };
	}).directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}]).directive('uibPopoverHtmlPopup', function () {
	  return {
	    replace: true,
	    scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'uib/template/popover/popover-html.html'
	  };
	}).directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}]).directive('uibPopoverPopup', function () {
	  return {
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'uib/template/popover/popover.html'
	  };
	}).directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);
	
	angular.module('ui.bootstrap.progressbar', []).constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	}).controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = getMaxOrDefault();
	
	  this.addBar = function (bar, element, attrs) {
	    if (!animate) {
	      element.css({ 'transition': 'none' });
	    }
	
	    this.bars.push(bar);
	
	    bar.max = getMaxOrDefault();
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function (value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function () {
	      var totalPercentage = self.bars.reduce(function (total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function () {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function (bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  //$attrs.$observe('maxParam', function(maxParam) {
	  $scope.$watch('maxParam', function (maxParam) {
	    self.bars.forEach(function (bar) {
	      bar.max = getMaxOrDefault();
	      bar.recalculatePercentage();
	    });
	  });
	
	  function getMaxOrDefault() {
	    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
	  }
	}]).directive('uibProgress', function () {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      maxParam: '=?max'
	    },
	    templateUrl: 'uib/template/progressbar/progress.html'
	  };
	}).directive('uibBar', function () {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/bar.html',
	    link: function link(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	}).directive('uibProgressbar', function () {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      maxParam: '=?max',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/progressbar.html',
	    link: function link(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), { title: attrs.title });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.rating', []).constant('uibRatingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null,
	  enableReset: true,
	  titles: ['one', 'two', 'three', 'four', 'five']
	}).controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function ($scope, $attrs, ratingConfig) {
	  var ngModelCtrl = { $setViewValue: angular.noop },
	      self = this;
	
	  this.init = function (ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.push(function (value) {
	      if (angular.isNumber(value) && value << 0 !== value) {
	        value = Math.round(value);
	      }
	
	      return value;
	    });
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	    this.enableReset = angular.isDefined($attrs.enableReset) ? $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
	    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
	    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ? tmpTitles : ratingConfig.titles;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ? $scope.$parent.$eval($attrs.ratingStates) : new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function (states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	    }
	    return states;
	  };
	
	  this.getTitle = function (index) {
	    if (index >= this.titles.length) {
	      return index + 1;
	    }
	
	    return this.titles[index];
	  };
	
	  $scope.rate = function (value) {
	    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
	      ngModelCtrl.$setViewValue(newViewValue);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function (value) {
	    if (!$scope.readonly) {
	      $scope.value = value;
	    }
	    $scope.onHover({ value: value });
	  };
	
	  $scope.reset = function () {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function (evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	    }
	  };
	
	  this.render = function () {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.title = self.getTitle($scope.value - 1);
	  };
	}]).directive('uibRating', function () {
	  return {
	    require: ['uibRating', 'ngModel'],
	    scope: {
	      readonly: '=?readOnly',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'UibRatingController',
	    templateUrl: 'uib/template/rating/rating.html',
	    replace: true,
	    link: function link(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	});
	
	angular.module('ui.bootstrap.tabs', []).controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	      oldIndex;
	  ctrl.tabs = [];
	
	  ctrl.select = function (index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt
	        });
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	      } else if (!selected && angular.isNumber(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	    ctrl.tabs.sort(function (t1, t2) {
	      if (t1.index > t2.index) {
	        return 1;
	      }
	
	      if (t1.index < t2.index) {
	        return -1;
	      }
	
	      return 0;
	    });
	
	    if (tab.index === ctrl.active || !angular.isNumber(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index = findTabIndex(tab.index);
	
	    if (tab.index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ? index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function (val) {
	    if (angular.isNumber(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}]).directive('uibTabset', function () {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	    },
	    link: function link(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	      if (angular.isUndefined(attrs.active)) {
	        scope.active = 0;
	      }
	    }
	  };
	}).directive('uibTab', ['$parse', function ($parse) {
	  return {
	    require: '^uibTabset',
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	      //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function controller() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function link(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function (value) {
	          scope.disabled = !!value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {
	            return t.index;
	          })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function (evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function () {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}]).directive('uibTabHeadingTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^uibTab',
	    link: function link(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	}).directive('uibTabContentTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^uibTabset',
	    link: function link(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function (contents) {
	        angular.forEach(contents, function (node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (node.hasAttribute('uib-tab-heading') || node.hasAttribute('data-uib-tab-heading') || node.hasAttribute('x-uib-tab-heading') || node.tagName.toLowerCase() === 'uib-tab-heading' || node.tagName.toLowerCase() === 'data-uib-tab-heading' || node.tagName.toLowerCase() === 'x-uib-tab-heading' || node.tagName.toLowerCase() === 'uib:tab-heading');
	  }
	});
	
	angular.module('ui.bootstrap.timepicker', []).constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  secondStep: 1,
	  showMeridian: true,
	  showSeconds: false,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true,
	  templateUrl: 'uib/template/timepicker/timepicker.html'
	}).controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var selected = new Date(),
	      watchers = [],
	      ngModelCtrl = { $setViewValue: angular.noop },
	      // nullModelCtrl
	  meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
	      padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function (ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function (modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1),
	        secondsInputEl = inputs.eq(2);
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
	      hourStep = +value;
	    }));
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
	      minuteStep = +value;
	    }));
	  }
	
	  var min;
	  watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  }));
	
	  var max;
	  watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  }));
	
	  var disabled = false;
	  if ($attrs.ngDisabled) {
	    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
	      disabled = value;
	    }));
	  }
	
	  $scope.noIncrementHours = function () {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementHours = function () {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementMinutes = function () {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementMinutes = function () {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementSeconds = function () {
	    var incrementedSelected = addSeconds(selected, secondStep);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementSeconds = function () {
	    var decrementedSelected = addSeconds(selected, -secondStep);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noToggleMeridian = function () {
	    if (selected.getHours() < 12) {
	      return disabled || addMinutes(selected, 12 * 60) > max;
	    }
	
	    return disabled || addMinutes(selected, -12 * 60) < min;
	  };
	
	  var secondStep = timepickerConfig.secondStep;
	  if ($attrs.secondStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
	      secondStep = +value;
	    }));
	  }
	
	  $scope.showSeconds = timepickerConfig.showSeconds;
	  if ($attrs.showSeconds) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
	      $scope.showSeconds = !!value;
	    }));
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(),
	            minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    }));
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = +$scope.hours;
	    var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;
	    if (!valid) {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = +$scope.minutes;
	    return minutes >= 0 && minutes < 60 ? minutes : undefined;
	  }
	
	  function getSecondsFromTemplate() {
	    var seconds = +$scope.seconds;
	    return seconds >= 0 && seconds < 60 ? seconds : undefined;
	  }
	
	  function pad(value, noPad) {
	    if (value === null) {
	      return '';
	    }
	
	    return angular.isDefined(value) && value.toString().length < 2 && !noPad ? '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    var isScrollingUp = function isScrollingUp(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	      return e.detail || delta > 0;
	    };
	
	    hoursInputEl.bind('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      }
	      e.preventDefault();
	    });
	
	    minutesInputEl.bind('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      }
	      e.preventDefault();
	    });
	
	    secondsInputEl.bind('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	      }
	      e.preventDefault();
	    });
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    hoursInputEl.bind('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementHours();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementHours();
	          $scope.$apply();
	        }
	      }
	    });
	
	    minutesInputEl.bind('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementMinutes();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementMinutes();
	          $scope.$apply();
	        }
	      }
	    });
	
	    secondsInputEl.bind('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementSeconds();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementSeconds();
	          $scope.$apply();
	        }
	      }
	    });
	  };
	
	  this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      $scope.updateSeconds = angular.noop;
	      return;
	    }
	
	    var invalidate = function invalidate(invalidHours, invalidMinutes, invalidSeconds) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	      }
	
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	      }
	
	      if (angular.isDefined(invalidSeconds)) {
	        $scope.invalidSeconds = invalidSeconds;
	      }
	    };
	
	    $scope.updateHours = function () {
	      var hours = getHoursFromTemplate(),
	          minutes = getMinutesFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.bind('blur', function (e) {
	      ngModelCtrl.$setTouched();
	      if ($scope.hours === null || $scope.hours === '') {
	        invalidate(true);
	      } else if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function () {
	          $scope.hours = pad($scope.hours, !padHours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function () {
	      var minutes = getMinutesFromTemplate(),
	          hours = getHoursFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.bind('blur', function (e) {
	      ngModelCtrl.$setTouched();
	      if ($scope.minutes === null) {
	        invalidate(undefined, true);
	      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function () {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	    $scope.updateSeconds = function () {
	      var seconds = getSecondsFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(seconds)) {
	        selected.setSeconds(seconds);
	        refresh('s');
	      } else {
	        invalidate(undefined, undefined, true);
	      }
	    };
	
	    secondsInputEl.bind('blur', function (e) {
	      if (!$scope.invalidSeconds && $scope.seconds < 10) {
	        $scope.$apply(function () {
	          $scope.seconds = pad($scope.seconds);
	        });
	      }
	    });
	  };
	
	  this.render = function () {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	    $scope.invalidSeconds = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    if (!ngModelCtrl.$modelValue) {
	      $scope.hours = null;
	      $scope.minutes = null;
	      $scope.seconds = null;
	      $scope.meridian = meridians[0];
	    } else {
	      var hours = selected.getHours(),
	          minutes = selected.getMinutes(),
	          seconds = selected.getSeconds();
	
	      if ($scope.showMeridian) {
	        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	      }
	
	      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
	      if (keyboardChange !== 'm') {
	        $scope.minutes = pad(minutes);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	
	      if (keyboardChange !== 's') {
	        $scope.seconds = pad(seconds);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	    }
	  }
	
	  function addSecondsToSelected(seconds) {
	    selected = addSeconds(selected, seconds);
	    refresh();
	  }
	
	  function addMinutes(selected, minutes) {
	    return addSeconds(selected, minutes * 60);
	  }
	
	  function addSeconds(date, seconds) {
	    var dt = new Date(date.getTime() + seconds * 1000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	    return newDate;
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function () {
	    if (!$scope.noIncrementHours()) {
	      addSecondsToSelected(hourStep * 60 * 60);
	    }
	  };
	
	  $scope.decrementHours = function () {
	    if (!$scope.noDecrementHours()) {
	      addSecondsToSelected(-hourStep * 60 * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function () {
	    if (!$scope.noIncrementMinutes()) {
	      addSecondsToSelected(minuteStep * 60);
	    }
	  };
	
	  $scope.decrementMinutes = function () {
	    if (!$scope.noDecrementMinutes()) {
	      addSecondsToSelected(-minuteStep * 60);
	    }
	  };
	
	  $scope.incrementSeconds = function () {
	    if (!$scope.noIncrementSeconds()) {
	      addSecondsToSelected(secondStep);
	    }
	  };
	
	  $scope.decrementSeconds = function () {
	    if (!$scope.noDecrementSeconds()) {
	      addSecondsToSelected(-secondStep);
	    }
	  };
	
	  $scope.toggleMeridian = function () {
	    var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	    if (!$scope.noToggleMeridian()) {
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	      } else {
	        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	      }
	    }
	  };
	
	  $scope.blur = function () {
	    ngModelCtrl.$setTouched();
	  };
	
	  $scope.$on('$destroy', function () {
	    while (watchers.length) {
	      watchers.shift()();
	    }
	  });
	}]).directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
	  return {
	    require: ['uibTimepicker', '?^ngModel'],
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    replace: true,
	    scope: {},
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	    },
	    link: function link(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	.factory('uibTypeaheadParser', ['$parse', function ($parse) {
	  //                      00000111000000000000022200000000000000003333333333333330000000000044000
	  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	  return {
	    parse: function parse(input) {
	      var match = input.match(TYPEAHEAD_REGEXP);
	      if (!match) {
	        throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' + ' but got "' + input + '".');
	      }
	
	      return {
	        itemName: match[3],
	        source: $parse(match[4]),
	        viewMapper: $parse(match[2] || match[1]),
	        modelMapper: $parse(match[1])
	      };
	    }
	  };
	}]).controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser', function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
	  var HOT_KEYS = [9, 13, 27, 38, 40];
	  var eventDebounceTime = 200;
	  var modelCtrl, ngModelOptions;
	  //SUPPORTED ATTRIBUTES (OPTIONS)
	
	  //minimal no of characters that needs to be entered before typeahead kicks-in
	  var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	  if (!minLength && minLength !== 0) {
	    minLength = 1;
	  }
	
	  originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
	    minLength = !newVal && newVal !== 0 ? 1 : newVal;
	  });
	
	  //minimal wait time after last character typed before typeahead kicks-in
	  var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	  //should it restrict model values to the ones selected from the popup only?
	  var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	  originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
	    isEditable = newVal !== false;
	  });
	
	  //binding to a variable that indicates if matches are being retrieved asynchronously
	  var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	  //a callback executed when a match is selected
	  var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	  //should it select highlighted popup value when losing focus?
	  var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	  //binding to a variable that indicates if there were no results after the query is completed
	  var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	  var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	  var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	  var appendTo = attrs.typeaheadAppendTo ? originalScope.$eval(attrs.typeaheadAppendTo) : null;
	
	  var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	  //If input matches an item of the list exactly, select it automatically
	  var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	  //binding to a variable that indicates if dropdown is open
	  var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;
	
	  var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;
	
	  //INTERNAL VARIABLES
	
	  //model setter executed upon match selection
	  var parsedModel = $parse(attrs.ngModel);
	  var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	  var $setModelValue = function $setModelValue(scope, newValue) {
	    if (angular.isFunction(parsedModel(originalScope)) && ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
	      return invokeModelSetter(scope, { $$$p: newValue });
	    }
	
	    return parsedModel.assign(scope, newValue);
	  };
	
	  //expressions used by typeahead
	  var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
	
	  var hasFocus;
	
	  //Used to avoid bug in iOS webview where iOS keyboard does not fire
	  //mousedown & mouseup events
	  //Issue #3699
	  var selected;
	
	  //create a child scope for the typeahead directive so we are not polluting original scope
	  //with typeahead-specific data (matches, query etc.)
	  var scope = originalScope.$new();
	  var offDestroy = originalScope.$on('$destroy', function () {
	    scope.$destroy();
	  });
	  scope.$on('$destroy', offDestroy);
	
	  // WAI-ARIA
	  var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	  element.attr({
	    'aria-autocomplete': 'list',
	    'aria-expanded': false,
	    'aria-owns': popupId
	  });
	
	  var inputsContainer, hintInputElem;
	  //add read-only input to show hint
	  if (showHint) {
	    inputsContainer = angular.element('<div></div>');
	    inputsContainer.css('position', 'relative');
	    element.after(inputsContainer);
	    hintInputElem = element.clone();
	    hintInputElem.attr('placeholder', '');
	    hintInputElem.attr('tabindex', '-1');
	    hintInputElem.val('');
	    hintInputElem.css({
	      'position': 'absolute',
	      'top': '0px',
	      'left': '0px',
	      'border-color': 'transparent',
	      'box-shadow': 'none',
	      'opacity': 1,
	      'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
	      'color': '#999'
	    });
	    element.css({
	      'position': 'relative',
	      'vertical-align': 'top',
	      'background-color': 'transparent'
	    });
	    inputsContainer.append(hintInputElem);
	    hintInputElem.after(element);
	  }
	
	  //pop-up element used to display matches
	  var popUpEl = angular.element('<div uib-typeahead-popup></div>');
	  popUpEl.attr({
	    id: popupId,
	    matches: 'matches',
	    active: 'activeIdx',
	    select: 'select(activeIdx, evt)',
	    'move-in-progress': 'moveInProgress',
	    query: 'query',
	    position: 'position',
	    'assign-is-open': 'assignIsOpen(isOpen)',
	    debounce: 'debounceUpdate'
	  });
	  //custom item template
	  if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	    popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	  }
	
	  if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	    popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	  }
	
	  var resetHint = function resetHint() {
	    if (showHint) {
	      hintInputElem.val('');
	    }
	  };
	
	  var resetMatches = function resetMatches() {
	    scope.matches = [];
	    scope.activeIdx = -1;
	    element.attr('aria-expanded', false);
	    resetHint();
	  };
	
	  var getMatchId = function getMatchId(index) {
	    return popupId + '-option-' + index;
	  };
	
	  // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	  // This attribute is added or removed automatically when the `activeIdx` changes.
	  scope.$watch('activeIdx', function (index) {
	    if (index < 0) {
	      element.removeAttr('aria-activedescendant');
	    } else {
	      element.attr('aria-activedescendant', getMatchId(index));
	    }
	  });
	
	  var inputIsExactMatch = function inputIsExactMatch(inputValue, index) {
	    if (scope.matches.length > index && inputValue) {
	      return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	    }
	
	    return false;
	  };
	
	  var getMatchesAsync = function getMatchesAsync(inputValue, evt) {
	    var locals = { $viewValue: inputValue };
	    isLoadingSetter(originalScope, true);
	    isNoResultsSetter(originalScope, false);
	    $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
	      //it might happen that several async queries were in progress if a user were typing fast
	      //but we are interested only in responses that correspond to the current view value
	      var onCurrentRequest = inputValue === modelCtrl.$viewValue;
	      if (onCurrentRequest && hasFocus) {
	        if (matches && matches.length > 0) {
	          scope.activeIdx = focusFirst ? 0 : -1;
	          isNoResultsSetter(originalScope, false);
	          scope.matches.length = 0;
	
	          //transform labels
	          for (var i = 0; i < matches.length; i++) {
	            locals[parserResult.itemName] = matches[i];
	            scope.matches.push({
	              id: getMatchId(i),
	              label: parserResult.viewMapper(scope, locals),
	              model: matches[i]
	            });
	          }
	
	          scope.query = inputValue;
	          //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	          //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	          //due to other elements being rendered
	          recalculatePosition();
	
	          element.attr('aria-expanded', true);
	
	          //Select the single remaining option if user input matches
	          if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	              $$debounce(function () {
	                scope.select(0, evt);
	              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	            } else {
	              scope.select(0, evt);
	            }
	          }
	
	          if (showHint) {
	            var firstLabel = scope.matches[0].label;
	            if (angular.isString(inputValue) && inputValue.length > 0 && firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
	              hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
	            } else {
	              hintInputElem.val('');
	            }
	          }
	        } else {
	          resetMatches();
	          isNoResultsSetter(originalScope, true);
	        }
	      }
	      if (onCurrentRequest) {
	        isLoadingSetter(originalScope, false);
	      }
	    }, function () {
	      resetMatches();
	      isLoadingSetter(originalScope, false);
	      isNoResultsSetter(originalScope, true);
	    });
	  };
	
	  // bind events only if appendToBody params exist - performance feature
	  if (appendToBody) {
	    angular.element($window).on('resize', fireRecalculating);
	    $document.find('body').on('scroll', fireRecalculating);
	  }
	
	  // Declare the debounced function outside recalculating for
	  // proper debouncing
	  var debouncedRecalculate = $$debounce(function () {
	    // if popup is visible
	    if (scope.matches.length) {
	      recalculatePosition();
	    }
	
	    scope.moveInProgress = false;
	  }, eventDebounceTime);
	
	  // Default progress type
	  scope.moveInProgress = false;
	
	  function fireRecalculating() {
	    if (!scope.moveInProgress) {
	      scope.moveInProgress = true;
	      scope.$digest();
	    }
	
	    debouncedRecalculate();
	  }
	
	  // recalculate actual position and set new values to scope
	  // after digest loop is popup in right position
	  function recalculatePosition() {
	    scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	    scope.position.top += element.prop('offsetHeight');
	  }
	
	  //we need to propagate user's query so we can higlight matches
	  scope.query = undefined;
	
	  //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	  var timeoutPromise;
	
	  var scheduleSearchWithTimeout = function scheduleSearchWithTimeout(inputValue) {
	    timeoutPromise = $timeout(function () {
	      getMatchesAsync(inputValue);
	    }, waitTime);
	  };
	
	  var cancelPreviousTimeout = function cancelPreviousTimeout() {
	    if (timeoutPromise) {
	      $timeout.cancel(timeoutPromise);
	    }
	  };
	
	  resetMatches();
	
	  scope.assignIsOpen = function (isOpen) {
	    isOpenSetter(originalScope, isOpen);
	  };
	
	  scope.select = function (activeIdx, evt) {
	    //called from within the $digest() cycle
	    var locals = {};
	    var model, item;
	
	    selected = true;
	    locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	    model = parserResult.modelMapper(originalScope, locals);
	    $setModelValue(originalScope, model);
	    modelCtrl.$setValidity('editable', true);
	    modelCtrl.$setValidity('parse', true);
	
	    onSelectCallback(originalScope, {
	      $item: item,
	      $model: model,
	      $label: parserResult.viewMapper(originalScope, locals),
	      $event: evt
	    });
	
	    resetMatches();
	
	    //return focus to the input element if a match was selected via a mouse click event
	    // use timeout to avoid $rootScope:inprog error
	    if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	      $timeout(function () {
	        element[0].focus();
	      }, 0, false);
	    }
	  };
	
	  //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	  element.on('keydown', function (evt) {
	    //typeahead is open and an "interesting" key was pressed
	    if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	      return;
	    }
	
	    /**
	     * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
	     * or
	     * shift + tab is pressed to bring focus to the previous element
	     * then clear the results
	     */
	    if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13) || evt.which === 9 && !!evt.shiftKey) {
	      resetMatches();
	      scope.$digest();
	      return;
	    }
	
	    evt.preventDefault();
	    var target;
	    switch (evt.which) {
	      case 9:
	      case 13:
	        scope.$apply(function () {
	          if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	            $$debounce(function () {
	              scope.select(scope.activeIdx, evt);
	            }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	          } else {
	            scope.select(scope.activeIdx, evt);
	          }
	        });
	        break;
	      case 27:
	        evt.stopPropagation();
	
	        resetMatches();
	        originalScope.$digest();
	        break;
	      case 38:
	        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	        scope.$digest();
	        target = popUpEl.find('li')[scope.activeIdx];
	        target.parentNode.scrollTop = target.offsetTop;
	        break;
	      case 40:
	        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	        scope.$digest();
	        target = popUpEl.find('li')[scope.activeIdx];
	        target.parentNode.scrollTop = target.offsetTop;
	        break;
	    }
	  });
	
	  element.bind('focus', function (evt) {
	    hasFocus = true;
	    if (minLength === 0 && !modelCtrl.$viewValue) {
	      $timeout(function () {
	        getMatchesAsync(modelCtrl.$viewValue, evt);
	      }, 0);
	    }
	  });
	
	  element.bind('blur', function (evt) {
	    if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	      selected = true;
	      scope.$apply(function () {
	        if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
	          $$debounce(function () {
	            scope.select(scope.activeIdx, evt);
	          }, scope.debounceUpdate.blur);
	        } else {
	          scope.select(scope.activeIdx, evt);
	        }
	      });
	    }
	    if (!isEditable && modelCtrl.$error.editable) {
	      modelCtrl.$viewValue = '';
	      // Reset validity as we are clearing
	      modelCtrl.$setValidity('editable', true);
	      modelCtrl.$setValidity('parse', true);
	      element.val('');
	    }
	    hasFocus = false;
	    selected = false;
	  });
	
	  // Keep reference to click handler to unbind it.
	  var dismissClickHandler = function dismissClickHandler(evt) {
	    // Issue #3973
	    // Firefox treats right click as a click on document
	    if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	      resetMatches();
	      if (!$rootScope.$$phase) {
	        originalScope.$digest();
	      }
	    }
	  };
	
	  $document.on('click', dismissClickHandler);
	
	  originalScope.$on('$destroy', function () {
	    $document.off('click', dismissClickHandler);
	    if (appendToBody || appendTo) {
	      $popup.remove();
	    }
	
	    if (appendToBody) {
	      angular.element($window).off('resize', fireRecalculating);
	      $document.find('body').off('scroll', fireRecalculating);
	    }
	    // Prevent jQuery cache memory leak
	    popUpEl.remove();
	
	    if (showHint) {
	      inputsContainer.remove();
	    }
	  });
	
	  var $popup = $compile(popUpEl)(scope);
	
	  if (appendToBody) {
	    $document.find('body').append($popup);
	  } else if (appendTo) {
	    angular.element(appendTo).eq(0).append($popup);
	  } else {
	    element.after($popup);
	  }
	
	  this.init = function (_modelCtrl, _ngModelOptions) {
	    modelCtrl = _modelCtrl;
	    ngModelOptions = _ngModelOptions;
	
	    scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);
	
	    //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	    //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	    modelCtrl.$parsers.unshift(function (inputValue) {
	      hasFocus = true;
	
	      if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	        if (waitTime > 0) {
	          cancelPreviousTimeout();
	          scheduleSearchWithTimeout(inputValue);
	        } else {
	          getMatchesAsync(inputValue);
	        }
	      } else {
	        isLoadingSetter(originalScope, false);
	        cancelPreviousTimeout();
	        resetMatches();
	      }
	
	      if (isEditable) {
	        return inputValue;
	      }
	
	      if (!inputValue) {
	        // Reset in case user had typed something previously.
	        modelCtrl.$setValidity('editable', true);
	        return null;
	      }
	
	      modelCtrl.$setValidity('editable', false);
	      return undefined;
	    });
	
	    modelCtrl.$formatters.push(function (modelValue) {
	      var candidateViewValue, emptyViewValue;
	      var locals = {};
	
	      // The validity may be set to false via $parsers (see above) if
	      // the model is restricted to selected values. If the model
	      // is set manually it is considered to be valid.
	      if (!isEditable) {
	        modelCtrl.$setValidity('editable', true);
	      }
	
	      if (inputFormatter) {
	        locals.$model = modelValue;
	        return inputFormatter(originalScope, locals);
	      }
	
	      //it might happen that we don't have enough info to properly render input value
	      //we need to check for this situation and simply return model value if we can't apply custom formatting
	      locals[parserResult.itemName] = modelValue;
	      candidateViewValue = parserResult.viewMapper(originalScope, locals);
	      locals[parserResult.itemName] = undefined;
	      emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	      return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	    });
	  };
	}]).directive('uibTypeahead', function () {
	  return {
	    controller: 'UibTypeaheadController',
	    require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
	    link: function link(originalScope, element, attrs, ctrls) {
	      ctrls[2].init(ctrls[0], ctrls[1]);
	    }
	  };
	}).directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
	  return {
	    scope: {
	      matches: '=',
	      query: '=',
	      active: '=',
	      position: '&',
	      moveInProgress: '=',
	      select: '&',
	      assignIsOpen: '&',
	      debounce: '&'
	    },
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
	    },
	    link: function link(scope, element, attrs) {
	      scope.templateUrl = attrs.templateUrl;
	
	      scope.isOpen = function () {
	        var isDropdownOpen = scope.matches.length > 0;
	        scope.assignIsOpen({ isOpen: isDropdownOpen });
	        return isDropdownOpen;
	      };
	
	      scope.isActive = function (matchIdx) {
	        return scope.active === matchIdx;
	      };
	
	      scope.selectActive = function (matchIdx) {
	        scope.active = matchIdx;
	      };
	
	      scope.selectMatch = function (activeIdx, evt) {
	        var debounce = scope.debounce();
	        if (angular.isNumber(debounce) || angular.isObject(debounce)) {
	          $$debounce(function () {
	            scope.select({ activeIdx: activeIdx, evt: evt });
	          }, angular.isNumber(debounce) ? debounce : debounce['default']);
	        } else {
	          scope.select({ activeIdx: activeIdx, evt: evt });
	        }
	      };
	    }
	  };
	}]).directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
	  return {
	    scope: {
	      index: '=',
	      match: '=',
	      query: '='
	    },
	    link: function link(scope, element, attrs) {
	      var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
	      $templateRequest(tplUrl).then(function (tplContent) {
	        var tplEl = angular.element(tplContent.trim());
	        element.replaceWith(tplEl);
	        $compile(tplEl)(scope);
	      });
	    }
	  };
	}]).filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
	  var isSanitizePresent;
	  isSanitizePresent = $injector.has('$sanitize');
	
	  function escapeRegexp(queryToEscape) {
	    // Regex: capture the whole query string and replace it with the string that will be used to match
	    // the results, for example if the capture is "a" the result will be \a
	    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  function containsHtml(matchItem) {
	    return (/<.*>/g.test(matchItem)
	    );
	  }
	
	  return function (matchItem, query) {
	    if (!isSanitizePresent && containsHtml(matchItem)) {
	      $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	    }
	    matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	    if (!isSanitizePresent) {
	      matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	    }
	    return matchItem;
	  };
	}]);
	
	angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion-group.html", "<div class=\"panel\" ng-class=\"panelClass || 'panel-default'\">\n" + "  <div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" + "    <h4 class=\"panel-title\">\n" + "      <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\"><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" + "    </h4>\n" + "  </div>\n" + "  <div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" + "    <div class=\"panel-body\" ng-transclude></div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion.html", "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/alert/alert.html", "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" + "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" + "        <span aria-hidden=\"true\">&times;</span>\n" + "        <span class=\"sr-only\">Close</span>\n" + "    </button>\n" + "    <div ng-transclude></div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/carousel.html", "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" + "  <div class=\"carousel-inner\" ng-transclude></div>\n" + "  <a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\">\n" + "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" + "    <span class=\"sr-only\">previous</span>\n" + "  </a>\n" + "  <a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\">\n" + "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" + "    <span class=\"sr-only\">next</span>\n" + "  </a>\n" + "  <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" + "    <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" + "      <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" + "    </li>\n" + "  </ol>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/slide.html", "<div ng-class=\"{\n" + "    'active': active\n" + "  }\" class=\"item text-center\" ng-transclude></div>\n" + "");
	}]);
	
	angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/datepicker.html", "<div class=\"uib-datepicker\" ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" + "  <uib-daypicker ng-switch-when=\"day\" tabindex=\"0\"></uib-daypicker>\n" + "  <uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\"></uib-monthpicker>\n" + "  <uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\"></uib-yearpicker>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/day.html", "<table class=\"uib-daypicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "    <tr>\n" + "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" + "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);
	
	angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/month.html", "<table class=\"uib-monthpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);
	
	angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/popup.html", "<div>\n" + "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" + "    <li ng-transclude></li>\n" + "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" + "      <span class=\"btn-group pull-left\">\n" + "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" + "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" + "      </span>\n" + "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" + "    </li>\n" + "  </ul>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/year.html", "<table class=\"uib-yearpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);
	
	angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/backdrop.html", "<div class=\"modal-backdrop\"\n" + "     uib-modal-animation-class=\"fade\"\n" + "     modal-in-class=\"in\"\n" + "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" + "></div>\n" + "");
	}]);
	
	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html", "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" + "    uib-modal-animation-class=\"fade\"\n" + "    modal-in-class=\"in\"\n" + "    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n" + "    <div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pager/pager.html", "<ul class=\"pager\">\n" + "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" + "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" + "</ul>\n" + "");
	}]);
	
	angular.module("uib/template/pagination/pager.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pagination/pager.html", "<ul class=\"pager\">\n" + "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" + "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" + "</ul>\n" + "");
	}]);
	
	angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pagination/pagination.html", "<ul class=\"pagination\">\n" + "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" + "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" + "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" + "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" + "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" + "</ul>\n" + "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html", "<div class=\"tooltip\"\n" + "  tooltip-animation-class=\"fade\"\n" + "  uib-tooltip-classes\n" + "  ng-class=\"{ in: isOpen() }\">\n" + "  <div class=\"tooltip-arrow\"></div>\n" + "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html", "<div class=\"tooltip\"\n" + "  tooltip-animation-class=\"fade\"\n" + "  uib-tooltip-classes\n" + "  ng-class=\"{ in: isOpen() }\">\n" + "  <div class=\"tooltip-arrow\"></div>\n" + "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html", "<div class=\"tooltip\"\n" + "  tooltip-animation-class=\"fade\"\n" + "  uib-tooltip-classes\n" + "  ng-class=\"{ in: isOpen() }\">\n" + "  <div class=\"tooltip-arrow\"></div>\n" + "  <div class=\"tooltip-inner\"\n" + "    uib-tooltip-template-transclude=\"contentExp()\"\n" + "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-html.html", "<div class=\"popover\"\n" + "  tooltip-animation-class=\"fade\"\n" + "  uib-tooltip-classes\n" + "  ng-class=\"{ in: isOpen() }\">\n" + "  <div class=\"arrow\"></div>\n" + "\n" + "  <div class=\"popover-inner\">\n" + "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" + "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-template.html", "<div class=\"popover\"\n" + "  tooltip-animation-class=\"fade\"\n" + "  uib-tooltip-classes\n" + "  ng-class=\"{ in: isOpen() }\">\n" + "  <div class=\"arrow\"></div>\n" + "\n" + "  <div class=\"popover-inner\">\n" + "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" + "      <div class=\"popover-content\"\n" + "        uib-tooltip-template-transclude=\"contentExp()\"\n" + "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover.html", "<div class=\"popover\"\n" + "  tooltip-animation-class=\"fade\"\n" + "  uib-tooltip-classes\n" + "  ng-class=\"{ in: isOpen() }\">\n" + "  <div class=\"arrow\"></div>\n" + "\n" + "  <div class=\"popover-inner\">\n" + "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" + "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/bar.html", "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" + "");
	}]);
	
	angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progress.html", "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);
	
	angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progressbar.html", "<div class=\"progress\">\n" + "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/rating/rating.html", "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" + "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" + "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" + "</span>\n" + "");
	}]);
	
	angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tab.html", "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" + "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" + "</li>\n" + "");
	}]);
	
	angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tabset.html", "<div>\n" + "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" + "  <div class=\"tab-content\">\n" + "    <div class=\"tab-pane\"\n" + "         ng-repeat=\"tab in tabset.tabs\"\n" + "         ng-class=\"{active: tabset.active === tab.index}\"\n" + "         uib-tab-content-transclude=\"tab\">\n" + "    </div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);
	
	angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/timepicker/timepicker.html", "<table class=\"uib-timepicker\">\n" + "  <tbody>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "    <tr>\n" + "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" + "        <input style=\"width:50px;\" type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" + "        <input style=\"width:50px;\" type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" + "        <input style=\"width:50px;\" type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" + "    </tr>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-match.html", "<a href\n" + "   tabindex=\"-1\"\n" + "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" + "   ng-attr-title=\"{{match.label}}\"></a>\n" + "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-popup.html", "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" + "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" + "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" + "    </li>\n" + "</ul>\n" + "");
	}]);
	angular.module('ui.bootstrap.carousel').run(function () {
	  !angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');angular.$$uibCarouselCss = true;
	});
	angular.module('ui.bootstrap.position').run(function () {
	  !angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll;}</style>');angular.$$uibPositionCss = true;
	});
	angular.module('ui.bootstrap.datepicker').run(function () {
	  !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}.uib-left,.uib-right{width:100%}</style>');angular.$$uibDatepickerCss = true;
	});
	angular.module('ui.bootstrap.tooltip').run(function () {
	  !angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>');angular.$$uibTooltipCss = true;
	});
	angular.module('ui.bootstrap.timepicker').run(function () {
	  !angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>');angular.$$uibTimepickerCss = true;
	});
	angular.module('ui.bootstrap.typeahead').run(function () {
	  !angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>');angular.$$uibTypeaheadCss = true;
	});

/***/ },
/* 226 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Binds a CodeMirror widget to a <textarea> element.
	 */
	
	angular.module('ui.codemirror', []).constant('uiCodemirrorConfig', {}).directive('uiCodemirror', ['$timeout', 'uiCodemirrorConfig', uiCodemirrorDirective]);
	
	/**
	 * @ngInject
	 */
	function uiCodemirrorDirective($timeout, uiCodemirrorConfig) {
	
	  return {
	    restrict: 'EA',
	    require: '?ngModel',
	    compile: function compile() {
	
	      // Require CodeMirror
	      if (angular.isUndefined(window.CodeMirror)) {
	        throw new Error('ui-codemirror needs CodeMirror to work... (o rly?)');
	      }
	
	      return postLink;
	    }
	  };
	
	  function postLink(scope, iElement, iAttrs, ngModel) {
	
	    var codemirrorOptions = angular.extend({ value: iElement.text() }, uiCodemirrorConfig.codemirror || {}, scope.$eval(iAttrs.uiCodemirror), scope.$eval(iAttrs.uiCodemirrorOpts));
	
	    var codemirror = newCodemirrorEditor(iElement, codemirrorOptions);
	
	    configOptionsWatcher(codemirror, iAttrs.uiCodemirror || iAttrs.uiCodemirrorOpts, scope);
	
	    configNgModelLink(codemirror, ngModel, scope);
	
	    configUiRefreshAttribute(codemirror, iAttrs.uiRefresh, scope);
	
	    // Allow access to the CodeMirror instance through a broadcasted event
	    // eg: $broadcast('CodeMirror', function(cm){...});
	    scope.$on('CodeMirror', function (event, callback) {
	      if (angular.isFunction(callback)) {
	        callback(codemirror);
	      } else {
	        throw new Error('the CodeMirror event requires a callback function');
	      }
	    });
	
	    // onLoad callback
	    if (angular.isFunction(codemirrorOptions.onLoad)) {
	      codemirrorOptions.onLoad(codemirror);
	    }
	  }
	
	  function newCodemirrorEditor(iElement, codemirrorOptions) {
	    var codemirrot;
	
	    if (iElement[0].tagName === 'TEXTAREA') {
	      // Might bug but still ...
	      codemirrot = window.CodeMirror.fromTextArea(iElement[0], codemirrorOptions);
	    } else {
	      iElement.html('');
	      codemirrot = new window.CodeMirror(function (cm_el) {
	        iElement.append(cm_el);
	      }, codemirrorOptions);
	    }
	
	    return codemirrot;
	  }
	
	  function configOptionsWatcher(codemirrot, uiCodemirrorAttr, scope) {
	    if (!uiCodemirrorAttr) {
	      return;
	    }
	
	    var codemirrorDefaultsKeys = Object.keys(window.CodeMirror.defaults);
	    scope.$watch(uiCodemirrorAttr, updateOptions, true);
	    function updateOptions(newValues, oldValue) {
	      if (!angular.isObject(newValues)) {
	        return;
	      }
	      codemirrorDefaultsKeys.forEach(function (key) {
	        if (newValues.hasOwnProperty(key)) {
	
	          if (oldValue && newValues[key] === oldValue[key]) {
	            return;
	          }
	
	          codemirrot.setOption(key, newValues[key]);
	        }
	      });
	    }
	  }
	
	  function configNgModelLink(codemirror, ngModel, scope) {
	    if (!ngModel) {
	      return;
	    }
	    // CodeMirror expects a string, so make sure it gets one.
	    // This does not change the model.
	    ngModel.$formatters.push(function (value) {
	      if (angular.isUndefined(value) || value === null) {
	        return '';
	      } else if (angular.isObject(value) || angular.isArray(value)) {
	        throw new Error('ui-codemirror cannot use an object or an array as a model');
	      }
	      return value;
	    });
	
	    // Override the ngModelController $render method, which is what gets called when the model is updated.
	    // This takes care of the synchronizing the codeMirror element with the underlying model, in the case that it is changed by something else.
	    ngModel.$render = function () {
	      //Code mirror expects a string so make sure it gets one
	      //Although the formatter have already done this, it can be possible that another formatter returns undefined (for example the required directive)
	      var safeViewValue = ngModel.$viewValue || '';
	      codemirror.setValue(safeViewValue);
	    };
	
	    // Keep the ngModel in sync with changes from CodeMirror
	    codemirror.on('change', function (instance) {
	      var newValue = instance.getValue();
	      if (newValue !== ngModel.$viewValue) {
	        scope.$evalAsync(function () {
	          ngModel.$setViewValue(newValue);
	        });
	      }
	    });
	  }
	
	  function configUiRefreshAttribute(codeMirror, uiRefreshAttr, scope) {
	    if (!uiRefreshAttr) {
	      return;
	    }
	
	    scope.$watch(uiRefreshAttr, function (newVal, oldVal) {
	      // Skip the initial watch firing
	      if (newVal !== oldVal) {
	        $timeout(function () {
	          codeMirror.refresh();
	        });
	      }
	    });
	  }
	}

/***/ },
/* 227 */
/***/ function(module, exports) {

	'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */(function(window){'use strict';/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/var minErrConfig={objectMaxDepth:5};/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 */function errorHandlingConfig(config){if(isObject(config)){if(isDefined(config.objectMaxDepth)){minErrConfig.objectMaxDepth=isValidObjectMaxDepth(config.objectMaxDepth)?config.objectMaxDepth:NaN;}}else{return minErrConfig;}}/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */function isValidObjectMaxDepth(maxDepth){return isNumber(maxDepth)&&maxDepth>0;}/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */function minErr(module,ErrorConstructor){ErrorConstructor=ErrorConstructor||Error;return function(){var code=arguments[0],template=arguments[1],message='['+(module?module+':':'')+code+'] ',templateArgs=sliceArgs(arguments,2).map(function(arg){return toDebugString(arg,minErrConfig.objectMaxDepth);}),paramPrefix,i;message+=template.replace(/\{\d+\}/g,function(match){var index=+match.slice(1,-1);if(index<templateArgs.length){return templateArgs[index];}return match;});message+='\nhttp://errors.angularjs.org/1.6.9/'+(module?module+'/':'')+code;for(i=0,paramPrefix='?';i<templateArgs.length;i++,paramPrefix='&'){message+=paramPrefix+'p'+i+'='+encodeURIComponent(templateArgs[i]);}return new ErrorConstructor(message);};}/* We need to tell ESLint what variables are being exported *//* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/////////////////////////////////////
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */var REGEX_STRING_REGEXP=/^\/(.+)\/([a-z]*)$/;// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY='validity';var hasOwnProperty=Object.prototype.hasOwnProperty;/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */var lowercase=function lowercase(string){return isString(string)?string.toLowerCase():string;};/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */var uppercase=function uppercase(string){return isString(string)?string.toUpperCase():string;};var manualLowercase=function manualLowercase(s){/* eslint-disable no-bitwise */return isString(s)?s.replace(/[A-Z]/g,function(ch){return String.fromCharCode(ch.charCodeAt(0)|32);}):s;/* eslint-enable */};var manualUppercase=function manualUppercase(s){/* eslint-disable no-bitwise */return isString(s)?s.replace(/[a-z]/g,function(ch){return String.fromCharCode(ch.charCodeAt(0)&~32);}):s;/* eslint-enable */};// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if('i'!=='I'.toLowerCase()){lowercase=manualLowercase;uppercase=manualUppercase;}var msie,// holds major version number for IE, or NaN if UA is not IE.
	jqLite,// delay binding since jQuery could be loaded after us.
	jQuery,// delay binding
	slice=[].slice,splice=[].splice,push=[].push,toString=Object.prototype.toString,getPrototypeOf=Object.getPrototypeOf,ngMinErr=minErr('ng'),/** @name angular */angular=window.angular||(window.angular={}),angularModule,uid=0;// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */msie=window.document.documentMode;/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */function isArrayLike(obj){// `null`, `undefined` and `window` are not array-like
	if(obj==null||isWindow(obj))return false;// arrays, strings and jQuery/jqLite objects are array like
	// * jqLite is either the jQuery or jqLite constructor function
	// * we have to check the existence of jqLite first as this method is called
	//   via the forEach method when constructing the jqLite object in the first place
	if(isArray(obj)||isString(obj)||jqLite&&obj instanceof jqLite)return true;// Support: iOS 8.2 (not reproducible in simulator)
	// "length" in obj used to prevent JIT error (gh-11508)
	var length='length'in Object(obj)&&obj.length;// NodeList objects (with `item` method) and
	// other objects with suitable length characteristics are array-like
	return isNumber(length)&&(length>=0&&(length-1 in obj||obj instanceof Array)||typeof obj.item==='function');}/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */function forEach(obj,iterator,context){var key,length;if(obj){if(isFunction(obj)){for(key in obj){if(key!=='prototype'&&key!=='length'&&key!=='name'&&obj.hasOwnProperty(key)){iterator.call(context,obj[key],key,obj);}}}else if(isArray(obj)||isArrayLike(obj)){var isPrimitive=(typeof obj==='undefined'?'undefined':_typeof(obj))!=='object';for(key=0,length=obj.length;key<length;key++){if(isPrimitive||key in obj){iterator.call(context,obj[key],key,obj);}}}else if(obj.forEach&&obj.forEach!==forEach){obj.forEach(iterator,context,obj);}else if(isBlankObject(obj)){// createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	for(key in obj){iterator.call(context,obj[key],key,obj);}}else if(typeof obj.hasOwnProperty==='function'){// Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	for(key in obj){if(obj.hasOwnProperty(key)){iterator.call(context,obj[key],key,obj);}}}else{// Slow path for objects which do not have a method `hasOwnProperty`
	for(key in obj){if(hasOwnProperty.call(obj,key)){iterator.call(context,obj[key],key,obj);}}}}return obj;}function forEachSorted(obj,iterator,context){var keys=Object.keys(obj).sort();for(var i=0;i<keys.length;i++){iterator.call(context,obj[keys[i]],keys[i]);}return keys;}/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */function reverseParams(iteratorFn){return function(value,key){iteratorFn(key,value);};}/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */function nextUid(){return++uid;}/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */function setHashKey(obj,h){if(h){obj.$$hashKey=h;}else{delete obj.$$hashKey;}}function baseExtend(dst,objs,deep){var h=dst.$$hashKey;for(var i=0,ii=objs.length;i<ii;++i){var obj=objs[i];if(!isObject(obj)&&!isFunction(obj))continue;var keys=Object.keys(obj);for(var j=0,jj=keys.length;j<jj;j++){var key=keys[j];var src=obj[key];if(deep&&isObject(src)){if(isDate(src)){dst[key]=new Date(src.valueOf());}else if(isRegExp(src)){dst[key]=new RegExp(src);}else if(src.nodeName){dst[key]=src.cloneNode(true);}else if(isElement(src)){dst[key]=src.clone();}else{if(!isObject(dst[key]))dst[key]=isArray(src)?[]:{};baseExtend(dst[key],[src],true);}}else{dst[key]=src;}}}setHashKey(dst,h);return dst;}/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */function extend(dst){return baseExtend(dst,slice.call(arguments,1),false);}/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest
	* using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/function merge(dst){return baseExtend(dst,slice.call(arguments,1),true);}function toInt(str){return parseInt(str,10);}var isNumberNaN=Number.isNaN||function isNumberNaN(num){// eslint-disable-next-line no-self-compare
	return num!==num;};function inherit(parent,extra){return extend(Object.create(parent),extra);}/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */function noop(){}noop.$inject=[];/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */function identity($){return $;}identity.$inject=[];function valueFn(value){return function valueRef(){return value;};}function hasCustomToString(obj){return isFunction(obj.toString)&&obj.toString!==toString;}/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */function isUndefined(value){return typeof value==='undefined';}/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */function isDefined(value){return typeof value!=='undefined';}/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */function isObject(value){// http://jsperf.com/isobject4
	return value!==null&&(typeof value==='undefined'?'undefined':_typeof(value))==='object';}/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */function isBlankObject(value){return value!==null&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'&&!getPrototypeOf(value);}/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */function isString(value){return typeof value==='string';}/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */function isNumber(value){return typeof value==='number';}/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */function isDate(value){return toString.call(value)==='[object Date]';}/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */var isArray=Array.isArray;/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */function isError(value){var tag=toString.call(value);switch(tag){case'[object Error]':return true;case'[object Exception]':return true;case'[object DOMException]':return true;default:return value instanceof Error;}}/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */function isFunction(value){return typeof value==='function';}/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */function isRegExp(value){return toString.call(value)==='[object RegExp]';}/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */function isWindow(obj){return obj&&obj.window===obj;}function isScope(obj){return obj&&obj.$evalAsync&&obj.$watch;}function isFile(obj){return toString.call(obj)==='[object File]';}function isFormData(obj){return toString.call(obj)==='[object FormData]';}function isBlob(obj){return toString.call(obj)==='[object Blob]';}function isBoolean(value){return typeof value==='boolean';}function isPromiseLike(obj){return obj&&isFunction(obj.then);}var TYPED_ARRAY_REGEXP=/^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;function isTypedArray(value){return value&&isNumber(value.length)&&TYPED_ARRAY_REGEXP.test(toString.call(value));}function isArrayBuffer(obj){return toString.call(obj)==='[object ArrayBuffer]';}var trim=function trim(value){return isString(value)?value.trim():value;};// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp=function escapeForRegexp(s){return s.replace(/([-()[\]{}+?*.$^|,:#<!\\])/g,'\\$1')// eslint-disable-next-line no-control-regex
	.replace(/\x08/g,'\\x08');};/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */function isElement(node){return!!(node&&(node.nodeName// We are a direct element.
	||node.prop&&node.attr&&node.find));// We have an on and find method part of jQuery API.
	}/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */function makeMap(str){var obj={},items=str.split(','),i;for(i=0;i<items.length;i++){obj[items[i]]=true;}return obj;}function nodeName_(element){return lowercase(element.nodeName||element[0]&&element[0].nodeName);}function includes(array,obj){return Array.prototype.indexOf.call(array,obj)!==-1;}function arrayRemove(array,value){var index=array.indexOf(value);if(index>=0){array.splice(index,1);}return index;}/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */function copy(source,destination,maxDepth){var stackSource=[];var stackDest=[];maxDepth=isValidObjectMaxDepth(maxDepth)?maxDepth:NaN;if(destination){if(isTypedArray(destination)||isArrayBuffer(destination)){throw ngMinErr('cpta','Can\'t copy! TypedArray destination cannot be mutated.');}if(source===destination){throw ngMinErr('cpi','Can\'t copy! Source and destination are identical.');}// Empty the destination object
	if(isArray(destination)){destination.length=0;}else{forEach(destination,function(value,key){if(key!=='$$hashKey'){delete destination[key];}});}stackSource.push(source);stackDest.push(destination);return copyRecurse(source,destination,maxDepth);}return copyElement(source,maxDepth);function copyRecurse(source,destination,maxDepth){maxDepth--;if(maxDepth<0){return'...';}var h=destination.$$hashKey;var key;if(isArray(source)){for(var i=0,ii=source.length;i<ii;i++){destination.push(copyElement(source[i],maxDepth));}}else if(isBlankObject(source)){// createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	for(key in source){destination[key]=copyElement(source[key],maxDepth);}}else if(source&&typeof source.hasOwnProperty==='function'){// Slow path, which must rely on hasOwnProperty
	for(key in source){if(source.hasOwnProperty(key)){destination[key]=copyElement(source[key],maxDepth);}}}else{// Slowest path --- hasOwnProperty can't be called as a method
	for(key in source){if(hasOwnProperty.call(source,key)){destination[key]=copyElement(source[key],maxDepth);}}}setHashKey(destination,h);return destination;}function copyElement(source,maxDepth){// Simple values
	if(!isObject(source)){return source;}// Already copied values
	var index=stackSource.indexOf(source);if(index!==-1){return stackDest[index];}if(isWindow(source)||isScope(source)){throw ngMinErr('cpws','Can\'t copy! Making copies of Window or Scope instances is not supported.');}var needsRecurse=false;var destination=copyType(source);if(destination===undefined){destination=isArray(source)?[]:Object.create(getPrototypeOf(source));needsRecurse=true;}stackSource.push(source);stackDest.push(destination);return needsRecurse?copyRecurse(source,destination,maxDepth):destination;}function copyType(source){switch(toString.call(source)){case'[object Int8Array]':case'[object Int16Array]':case'[object Int32Array]':case'[object Float32Array]':case'[object Float64Array]':case'[object Uint8Array]':case'[object Uint8ClampedArray]':case'[object Uint16Array]':case'[object Uint32Array]':return new source.constructor(copyElement(source.buffer),source.byteOffset,source.length);case'[object ArrayBuffer]':// Support: IE10
	if(!source.slice){// If we're in this case we know the environment supports ArrayBuffer
	/* eslint-disable no-undef */var copied=new ArrayBuffer(source.byteLength);new Uint8Array(copied).set(new Uint8Array(source));/* eslint-enable */return copied;}return source.slice(0);case'[object Boolean]':case'[object Number]':case'[object String]':case'[object Date]':return new source.constructor(source.valueOf());case'[object RegExp]':var re=new RegExp(source.source,source.toString().match(/[^/]*$/)[0]);re.lastIndex=source.lastIndex;return re;case'[object Blob]':return new source.constructor([source],{type:source.type});}if(isFunction(source.cloneNode)){return source.cloneNode(true);}}}// eslint-disable-next-line no-self-compare
	function simpleCompare(a,b){return a===b||a!==a&&b!==b;}/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */function equals(o1,o2){if(o1===o2)return true;if(o1===null||o2===null)return false;// eslint-disable-next-line no-self-compare
	if(o1!==o1&&o2!==o2)return true;// NaN === NaN
	var t1=typeof o1==='undefined'?'undefined':_typeof(o1),t2=typeof o2==='undefined'?'undefined':_typeof(o2),length,key,keySet;if(t1===t2&&t1==='object'){if(isArray(o1)){if(!isArray(o2))return false;if((length=o1.length)===o2.length){for(key=0;key<length;key++){if(!equals(o1[key],o2[key]))return false;}return true;}}else if(isDate(o1)){if(!isDate(o2))return false;return simpleCompare(o1.getTime(),o2.getTime());}else if(isRegExp(o1)){if(!isRegExp(o2))return false;return o1.toString()===o2.toString();}else{if(isScope(o1)||isScope(o2)||isWindow(o1)||isWindow(o2)||isArray(o2)||isDate(o2)||isRegExp(o2))return false;keySet=createMap();for(key in o1){if(key.charAt(0)==='$'||isFunction(o1[key]))continue;if(!equals(o1[key],o2[key]))return false;keySet[key]=true;}for(key in o2){if(!(key in keySet)&&key.charAt(0)!=='$'&&isDefined(o2[key])&&!isFunction(o2[key]))return false;}return true;}}return false;}var csp=function csp(){if(!isDefined(csp.rules)){var ngCspElement=window.document.querySelector('[ng-csp]')||window.document.querySelector('[data-ng-csp]');if(ngCspElement){var ngCspAttribute=ngCspElement.getAttribute('ng-csp')||ngCspElement.getAttribute('data-ng-csp');csp.rules={noUnsafeEval:!ngCspAttribute||ngCspAttribute.indexOf('no-unsafe-eval')!==-1,noInlineStyle:!ngCspAttribute||ngCspAttribute.indexOf('no-inline-style')!==-1};}else{csp.rules={noUnsafeEval:noUnsafeEval(),noInlineStyle:false};}}return csp.rules;function noUnsafeEval(){try{// eslint-disable-next-line no-new, no-new-func
	new Function('');return false;}catch(e){return true;}}};/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */var jq=function jq(){if(isDefined(jq.name_))return jq.name_;var el;var i,ii=ngAttrPrefixes.length,prefix,name;for(i=0;i<ii;++i){prefix=ngAttrPrefixes[i];el=window.document.querySelector('['+prefix.replace(':','\\:')+'jq]');if(el){name=el.getAttribute(prefix+'jq');break;}}return jq.name_=name;};function concat(array1,array2,index){return array1.concat(slice.call(array2,index));}function sliceArgs(args,startIndex){return slice.call(args,startIndex||0);}/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */function bind(self,fn){var curryArgs=arguments.length>2?sliceArgs(arguments,2):[];if(isFunction(fn)&&!(fn instanceof RegExp)){return curryArgs.length?function(){return arguments.length?fn.apply(self,concat(curryArgs,arguments,0)):fn.apply(self,curryArgs);}:function(){return arguments.length?fn.apply(self,arguments):fn.call(self);};}else{// In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	return fn;}}function toJsonReplacer(key,value){var val=value;if(typeof key==='string'&&key.charAt(0)==='$'&&key.charAt(1)==='$'){val=undefined;}else if(isWindow(value)){val='$WINDOW';}else if(value&&window.document===value){val='$DOCUMENT';}else if(isScope(value)){val='$SCOPE';}return val;}/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */function toJson(obj,pretty){if(isUndefined(obj))return undefined;if(!isNumber(pretty)){pretty=pretty?2:null;}return JSON.stringify(obj,toJsonReplacer,pretty);}/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */function fromJson(json){return isString(json)?JSON.parse(json):json;}var ALL_COLONS=/:/g;function timezoneToOffset(timezone,fallback){// Support: IE 9-11 only, Edge 13-15+
	// IE/Edge do not "understand" colon (`:`) in timezone
	timezone=timezone.replace(ALL_COLONS,'');var requestedTimezoneOffset=Date.parse('Jan 01, 1970 00:00:00 '+timezone)/60000;return isNumberNaN(requestedTimezoneOffset)?fallback:requestedTimezoneOffset;}function addDateMinutes(date,minutes){date=new Date(date.getTime());date.setMinutes(date.getMinutes()+minutes);return date;}function convertTimezoneToLocal(date,timezone,reverse){reverse=reverse?-1:1;var dateTimezoneOffset=date.getTimezoneOffset();var timezoneOffset=timezoneToOffset(timezone,dateTimezoneOffset);return addDateMinutes(date,reverse*(timezoneOffset-dateTimezoneOffset));}/**
	 * @returns {string} Returns the string representation of the element.
	 */function startingTag(element){element=jqLite(element).clone().empty();var elemHtml=jqLite('<div>').append(element).html();try{return element[0].nodeType===NODE_TYPE_TEXT?lowercase(elemHtml):elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w-]+)/,function(match,nodeName){return'<'+lowercase(nodeName);});}catch(e){return lowercase(elemHtml);}}/////////////////////////////////////////////////
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */function tryDecodeURIComponent(value){try{return decodeURIComponent(value);}catch(e){// Ignore any invalid uri component.
	}}/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */function parseKeyValue(/**string*/keyValue){var obj={};forEach((keyValue||'').split('&'),function(keyValue){var splitPoint,key,val;if(keyValue){key=keyValue=keyValue.replace(/\+/g,'%20');splitPoint=keyValue.indexOf('=');if(splitPoint!==-1){key=keyValue.substring(0,splitPoint);val=keyValue.substring(splitPoint+1);}key=tryDecodeURIComponent(key);if(isDefined(key)){val=isDefined(val)?tryDecodeURIComponent(val):true;if(!hasOwnProperty.call(obj,key)){obj[key]=val;}else if(isArray(obj[key])){obj[key].push(val);}else{obj[key]=[obj[key],val];}}}});return obj;}function toKeyValue(obj){var parts=[];forEach(obj,function(value,key){if(isArray(value)){forEach(value,function(arrayValue){parts.push(encodeUriQuery(key,true)+(arrayValue===true?'':'='+encodeUriQuery(arrayValue,true)));});}else{parts.push(encodeUriQuery(key,true)+(value===true?'':'='+encodeUriQuery(value,true)));}});return parts.length?parts.join('&'):'';}/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */function encodeUriSegment(val){return encodeUriQuery(val,true).replace(/%26/gi,'&').replace(/%3D/gi,'=').replace(/%2B/gi,'+');}/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */function encodeUriQuery(val,pctEncodeSpaces){return encodeURIComponent(val).replace(/%40/gi,'@').replace(/%3A/gi,':').replace(/%24/g,'$').replace(/%2C/gi,',').replace(/%3B/gi,';').replace(/%20/g,pctEncodeSpaces?'%20':'+');}var ngAttrPrefixes=['ng-','data-ng-','ng:','x-ng-'];function getNgAttribute(element,ngAttr){var attr,i,ii=ngAttrPrefixes.length;for(i=0;i<ii;++i){attr=ngAttrPrefixes[i]+ngAttr;if(isString(attr=element.getAttribute(attr))){return attr;}}return null;}function allowAutoBootstrap(document){var script=document.currentScript;if(!script){// Support: IE 9-11 only
	// IE does not have `document.currentScript`
	return true;}// If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	if(!(script instanceof window.HTMLScriptElement||script instanceof window.SVGScriptElement)){return false;}var attributes=script.attributes;var srcs=[attributes.getNamedItem('src'),attributes.getNamedItem('href'),attributes.getNamedItem('xlink:href')];return srcs.every(function(src){if(!src){return true;}if(!src.value){return false;}var link=document.createElement('a');link.href=src.value;if(document.location.origin===link.origin){// Same-origin resources are always allowed, even for non-whitelisted schemes.
	return true;}// Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	// This is to prevent angular.js bundled with browser extensions from being used to bypass the
	// content security policy in web pages and other browser extensions.
	switch(link.protocol){case'http:':case'https:':case'ftp:':case'blob:':case'file:':case'data:':return true;default:return false;}});}// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed=allowAutoBootstrap(window.document);/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */function angularInit(element,bootstrap){var appElement,module,config={};// The element `element` has priority over any other element.
	forEach(ngAttrPrefixes,function(prefix){var name=prefix+'app';if(!appElement&&element.hasAttribute&&element.hasAttribute(name)){appElement=element;module=element.getAttribute(name);}});forEach(ngAttrPrefixes,function(prefix){var name=prefix+'app';var candidate;if(!appElement&&(candidate=element.querySelector('['+name.replace(':','\\:')+']'))){appElement=candidate;module=candidate.getAttribute(name);}});if(appElement){if(!isAutoBootstrapAllowed){window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates '+'an extension, document.location.href does not match.');return;}config.strictDi=getNgAttribute(appElement,'strict-di')!==null;bootstrap(appElement,module?[module]:[],config);}}/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */function bootstrap(element,modules,config){if(!isObject(config))config={};var defaultConfig={strictDi:false};config=extend(defaultConfig,config);var doBootstrap=function doBootstrap(){element=jqLite(element);if(element.injector()){var tag=element[0]===window.document?'document':startingTag(element);// Encode angle brackets to prevent input from being sanitized to empty string #8683.
	throw ngMinErr('btstrpd','App already bootstrapped with this element \'{0}\'',tag.replace(/</,'&lt;').replace(/>/,'&gt;'));}modules=modules||[];modules.unshift(['$provide',function($provide){$provide.value('$rootElement',element);}]);if(config.debugInfoEnabled){// Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	modules.push(['$compileProvider',function($compileProvider){$compileProvider.debugInfoEnabled(true);}]);}modules.unshift('ng');var injector=createInjector(modules,config.strictDi);injector.invoke(['$rootScope','$rootElement','$compile','$injector',function bootstrapApply(scope,element,compile,injector){scope.$apply(function(){element.data('$injector',injector);compile(element)(scope);});}]);return injector;};var NG_ENABLE_DEBUG_INFO=/^NG_ENABLE_DEBUG_INFO!/;var NG_DEFER_BOOTSTRAP=/^NG_DEFER_BOOTSTRAP!/;if(window&&NG_ENABLE_DEBUG_INFO.test(window.name)){config.debugInfoEnabled=true;window.name=window.name.replace(NG_ENABLE_DEBUG_INFO,'');}if(window&&!NG_DEFER_BOOTSTRAP.test(window.name)){return doBootstrap();}window.name=window.name.replace(NG_DEFER_BOOTSTRAP,'');angular.resumeBootstrap=function(extraModules){forEach(extraModules,function(module){modules.push(module);});return doBootstrap();};if(isFunction(angular.resumeDeferredBootstrap)){angular.resumeDeferredBootstrap();}}/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */function reloadWithDebugInfo(){window.name='NG_ENABLE_DEBUG_INFO!'+window.name;window.location.reload();}/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */function getTestability(rootElement){var injector=angular.element(rootElement).injector();if(!injector){throw ngMinErr('test','no injector found for element argument to getTestability');}return injector.get('$$testability');}var SNAKE_CASE_REGEXP=/[A-Z]/g;function snake_case(name,separator){separator=separator||'_';return name.replace(SNAKE_CASE_REGEXP,function(letter,pos){return(pos?separator:'')+letter.toLowerCase();});}var bindJQueryFired=false;function bindJQuery(){var originalCleanData;if(bindJQueryFired){return;}// bind to jQuery if present;
	var jqName=jq();jQuery=isUndefined(jqName)?window.jQuery:// use jQuery (if present)
	!jqName?undefined:// use jqLite
	window[jqName];// use jQuery specified by `ngJq`
	// Use jQuery if it exists with proper functionality, otherwise default to us.
	// AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	// AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	// versions. It will not work for sure with jQuery <1.7, though.
	if(jQuery&&jQuery.fn.on){jqLite=jQuery;extend(jQuery.fn,{scope:JQLitePrototype.scope,isolateScope:JQLitePrototype.isolateScope,controller:/** @type {?} */JQLitePrototype.controller,injector:JQLitePrototype.injector,inheritedData:JQLitePrototype.inheritedData});// All nodes removed from the DOM via various jQuery APIs like .remove()
	// are passed through jQuery.cleanData. Monkey-patch this method to fire
	// the $destroy event on all removed nodes.
	originalCleanData=jQuery.cleanData;jQuery.cleanData=function(elems){var events;for(var i=0,elem;(elem=elems[i])!=null;i++){events=jQuery._data(elem,'events');if(events&&events.$destroy){jQuery(elem).triggerHandler('$destroy');}}originalCleanData(elems);};}else{jqLite=JQLite;}angular.element=jqLite;// Prevent double-proxying.
	bindJQueryFired=true;}/**
	 * throw error if the argument is falsy.
	 */function assertArg(arg,name,reason){if(!arg){throw ngMinErr('areq','Argument \'{0}\' is {1}',name||'?',reason||'required');}return arg;}function assertArgFn(arg,name,acceptArrayAnnotation){if(acceptArrayAnnotation&&isArray(arg)){arg=arg[arg.length-1];}assertArg(isFunction(arg),name,'not a function, got '+(arg&&(typeof arg==='undefined'?'undefined':_typeof(arg))==='object'?arg.constructor.name||'Object':typeof arg==='undefined'?'undefined':_typeof(arg)));return arg;}/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */function assertNotHasOwnProperty(name,context){if(name==='hasOwnProperty'){throw ngMinErr('badname','hasOwnProperty is not a valid {0} name',context);}}/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 *///TODO(misko): this function needs to be removed
	function getter(obj,path,bindFnToScope){if(!path)return obj;var keys=path.split('.');var key;var lastInstance=obj;var len=keys.length;for(var i=0;i<len;i++){key=keys[i];if(obj){obj=(lastInstance=obj)[key];}}if(!bindFnToScope&&isFunction(obj)){return bind(lastInstance,obj);}return obj;}/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */function getBlockNodes(nodes){// TODO(perf): update `nodes` instead of creating a new object?
	var node=nodes[0];var endNode=nodes[nodes.length-1];var blockNodes;for(var i=1;node!==endNode&&(node=node.nextSibling);i++){if(blockNodes||nodes[i]!==node){if(!blockNodes){blockNodes=jqLite(slice.call(nodes,0,i));}blockNodes.push(node);}}return blockNodes||nodes;}/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */function createMap(){return Object.create(null);}function stringify(value){if(value==null){// null || undefined
	return'';}switch(typeof value==='undefined'?'undefined':_typeof(value)){case'string':break;case'number':value=''+value;break;default:if(hasCustomToString(value)&&!isArray(value)&&!isDate(value)){value=value.toString();}else{value=toJson(value);}}return value;}var NODE_TYPE_ELEMENT=1;var NODE_TYPE_ATTRIBUTE=2;var NODE_TYPE_TEXT=3;var NODE_TYPE_COMMENT=8;var NODE_TYPE_DOCUMENT=9;var NODE_TYPE_DOCUMENT_FRAGMENT=11;/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */function setupModuleLoader(window){var $injectorMinErr=minErr('$injector');var ngMinErr=minErr('ng');function ensure(obj,name,factory){return obj[name]||(obj[name]=factory());}var angular=ensure(window,'angular',Object);// We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	angular.$$minErr=angular.$$minErr||minErr;return ensure(angular,'module',function(){/** @type {Object.<string, angular.Module>} */var modules={};/**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */return function module(name,requires,configFn){var _info={};var assertNotHasOwnProperty=function assertNotHasOwnProperty(name,context){if(name==='hasOwnProperty'){throw ngMinErr('badname','hasOwnProperty is not a valid {0} name',context);}};assertNotHasOwnProperty(name,'module');if(requires&&modules.hasOwnProperty(name)){modules[name]=null;}return ensure(modules,name,function(){if(!requires){throw $injectorMinErr('nomod','Module \'{0}\' is not available! You either misspelled '+'the module name or forgot to load it. If registering a module ensure that you '+'specify the dependencies as the second argument.',name);}/** @type {!Array.<Array.<*>>} */var invokeQueue=[];/** @type {!Array.<Function>} */var configBlocks=[];/** @type {!Array.<Function>} */var runBlocks=[];var config=invokeLater('$injector','invoke','push',configBlocks);/** @type {angular.Module} */var moduleInstance={// Private state
	_invokeQueue:invokeQueue,_configBlocks:configBlocks,_runBlocks:runBlocks,/**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */info:function info(value){if(isDefined(value)){if(!isObject(value))throw ngMinErr('aobj','Argument \'{0}\' must be an object','value');_info=value;return this;}return _info;},/**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */requires:requires,/**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */name:name,/**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */provider:invokeLaterAndSetModuleName('$provide','provider'),/**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */factory:invokeLaterAndSetModuleName('$provide','factory'),/**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */service:invokeLaterAndSetModuleName('$provide','service'),/**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */value:invokeLater('$provide','value'),/**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */constant:invokeLater('$provide','constant','unshift'),/**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */decorator:invokeLaterAndSetModuleName('$provide','decorator',configBlocks),/**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */animation:invokeLaterAndSetModuleName('$animateProvider','register'),/**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */filter:invokeLaterAndSetModuleName('$filterProvider','register'),/**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */controller:invokeLaterAndSetModuleName('$controllerProvider','register'),/**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */directive:invokeLaterAndSetModuleName('$compileProvider','directive'),/**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */component:invokeLaterAndSetModuleName('$compileProvider','component'),/**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */config:config,/**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */run:function run(block){runBlocks.push(block);return this;}};if(configFn){config(configFn);}return moduleInstance;/**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */function invokeLater(provider,method,insertMethod,queue){if(!queue)queue=invokeQueue;return function(){queue[insertMethod||'push']([provider,method,arguments]);return moduleInstance;};}/**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */function invokeLaterAndSetModuleName(provider,method,queue){if(!queue)queue=invokeQueue;return function(recipeName,factoryFunction){if(factoryFunction&&isFunction(factoryFunction))factoryFunction.$$moduleName=name;queue.push([provider,method,arguments]);return moduleInstance;};}});};});}/* global shallowCopy: true *//**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */function shallowCopy(src,dst){if(isArray(src)){dst=dst||[];for(var i=0,ii=src.length;i<ii;i++){dst[i]=src[i];}}else if(isObject(src)){dst=dst||{};for(var key in src){if(!(key.charAt(0)==='$'&&key.charAt(1)==='$')){dst[key]=src[key];}}}return dst||src;}/* exported toDebugString */function serializeObject(obj,maxDepth){var seen=[];// There is no direct way to stringify object until reaching a specific depth
	// and a very deep object can cause a performance issue, so we copy the object
	// based on this specific depth and then stringify it.
	if(isValidObjectMaxDepth(maxDepth)){// This file is also included in `angular-loader`, so `copy()` might not always be available in
	// the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	obj=angular.copy(obj,null,maxDepth);}return JSON.stringify(obj,function(key,val){val=toJsonReplacer(key,val);if(isObject(val)){if(seen.indexOf(val)>=0)return'...';seen.push(val);}return val;});}function toDebugString(obj,maxDepth){if(typeof obj==='function'){return obj.toString().replace(/ \{[\s\S]*$/,'');}else if(isUndefined(obj)){return'undefined';}else if(typeof obj!=='string'){return serializeObject(obj,maxDepth);}return obj;}/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*//**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */var version={// These placeholder strings will be replaced by grunt's `build` task.
	// They need to be double- or single-quoted.
	full:'1.6.9',major:1,minor:6,dot:9,codeName:'fiery-basilisk'};function publishExternalAPI(angular){extend(angular,{'errorHandlingConfig':errorHandlingConfig,'bootstrap':bootstrap,'copy':copy,'extend':extend,'merge':merge,'equals':equals,'element':jqLite,'forEach':forEach,'injector':createInjector,'noop':noop,'bind':bind,'toJson':toJson,'fromJson':fromJson,'identity':identity,'isUndefined':isUndefined,'isDefined':isDefined,'isString':isString,'isFunction':isFunction,'isObject':isObject,'isNumber':isNumber,'isElement':isElement,'isArray':isArray,'version':version,'isDate':isDate,'lowercase':lowercase,'uppercase':uppercase,'callbacks':{$$counter:0},'getTestability':getTestability,'reloadWithDebugInfo':reloadWithDebugInfo,'$$minErr':minErr,'$$csp':csp,'$$encodeUriSegment':encodeUriSegment,'$$encodeUriQuery':encodeUriQuery,'$$stringify':stringify});angularModule=setupModuleLoader(window);angularModule('ng',['ngLocale'],['$provide',function ngModule($provide){// $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	$provide.provider({$$sanitizeUri:$$SanitizeUriProvider});$provide.provider('$compile',$CompileProvider).directive({a:htmlAnchorDirective,input:inputDirective,textarea:inputDirective,form:formDirective,script:scriptDirective,select:selectDirective,option:optionDirective,ngBind:ngBindDirective,ngBindHtml:ngBindHtmlDirective,ngBindTemplate:ngBindTemplateDirective,ngClass:ngClassDirective,ngClassEven:ngClassEvenDirective,ngClassOdd:ngClassOddDirective,ngCloak:ngCloakDirective,ngController:ngControllerDirective,ngForm:ngFormDirective,ngHide:ngHideDirective,ngIf:ngIfDirective,ngInclude:ngIncludeDirective,ngInit:ngInitDirective,ngNonBindable:ngNonBindableDirective,ngPluralize:ngPluralizeDirective,ngRepeat:ngRepeatDirective,ngShow:ngShowDirective,ngStyle:ngStyleDirective,ngSwitch:ngSwitchDirective,ngSwitchWhen:ngSwitchWhenDirective,ngSwitchDefault:ngSwitchDefaultDirective,ngOptions:ngOptionsDirective,ngTransclude:ngTranscludeDirective,ngModel:ngModelDirective,ngList:ngListDirective,ngChange:ngChangeDirective,pattern:patternDirective,ngPattern:patternDirective,required:requiredDirective,ngRequired:requiredDirective,minlength:minlengthDirective,ngMinlength:minlengthDirective,maxlength:maxlengthDirective,ngMaxlength:maxlengthDirective,ngValue:ngValueDirective,ngModelOptions:ngModelOptionsDirective}).directive({ngInclude:ngIncludeFillContentDirective}).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);$provide.provider({$anchorScroll:$AnchorScrollProvider,$animate:$AnimateProvider,$animateCss:$CoreAnimateCssProvider,$$animateJs:$$CoreAnimateJsProvider,$$animateQueue:$$CoreAnimateQueueProvider,$$AnimateRunner:$$AnimateRunnerFactoryProvider,$$animateAsyncRun:$$AnimateAsyncRunFactoryProvider,$browser:$BrowserProvider,$cacheFactory:$CacheFactoryProvider,$controller:$ControllerProvider,$document:$DocumentProvider,$$isDocumentHidden:$$IsDocumentHiddenProvider,$exceptionHandler:$ExceptionHandlerProvider,$filter:$FilterProvider,$$forceReflow:$$ForceReflowProvider,$interpolate:$InterpolateProvider,$interval:$IntervalProvider,$http:$HttpProvider,$httpParamSerializer:$HttpParamSerializerProvider,$httpParamSerializerJQLike:$HttpParamSerializerJQLikeProvider,$httpBackend:$HttpBackendProvider,$xhrFactory:$xhrFactoryProvider,$jsonpCallbacks:$jsonpCallbacksProvider,$location:$LocationProvider,$log:$LogProvider,$parse:$ParseProvider,$rootScope:$RootScopeProvider,$q:$QProvider,$$q:$$QProvider,$sce:$SceProvider,$sceDelegate:$SceDelegateProvider,$sniffer:$SnifferProvider,$templateCache:$TemplateCacheProvider,$templateRequest:$TemplateRequestProvider,$$testability:$$TestabilityProvider,$timeout:$TimeoutProvider,$window:$WindowProvider,$$rAF:$$RAFProvider,$$jqLite:$$jqLiteProvider,$$Map:$$MapProvider,$$cookieReader:$$CookieReaderProvider});}]).info({angularVersion:'1.6.9'});}/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *//* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*///////////////////////////////////
	//JQLite
	//////////////////////////////////
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */JQLite.expando='ng339';var jqCache=JQLite.cache={},jqId=1;/*
	 * !!! This is an undocumented "private" function !!!
	 */JQLite._data=function(node){//jQuery always returns an object on cache miss
	return this.cache[node[this.expando]]||{};};function jqNextId(){return++jqId;}var DASH_LOWERCASE_REGEXP=/-([a-z])/g;var MS_HACK_REGEXP=/^-ms-/;var MOUSE_EVENT_MAP={mouseleave:'mouseout',mouseenter:'mouseover'};var jqLiteMinErr=minErr('jqLite');/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */function cssKebabToCamel(name){return kebabToCamel(name.replace(MS_HACK_REGEXP,'ms-'));}function fnCamelCaseReplace(all,letter){return letter.toUpperCase();}/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */function kebabToCamel(name){return name.replace(DASH_LOWERCASE_REGEXP,fnCamelCaseReplace);}var SINGLE_TAG_REGEXP=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;var HTML_REGEXP=/<|&#?\w+;/;var TAG_NAME_REGEXP=/<([\w:-]+)/;var XHTML_TAG_REGEXP=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;var wrapMap={'option':[1,'<select multiple="multiple">','</select>'],'thead':[1,'<table>','</table>'],'col':[2,'<table><colgroup>','</colgroup></table>'],'tr':[2,'<table><tbody>','</tbody></table>'],'td':[3,'<table><tbody><tr>','</tr></tbody></table>'],'_default':[0,'','']};wrapMap.optgroup=wrapMap.option;wrapMap.tbody=wrapMap.tfoot=wrapMap.colgroup=wrapMap.caption=wrapMap.thead;wrapMap.th=wrapMap.td;function jqLiteIsTextNode(html){return!HTML_REGEXP.test(html);}function jqLiteAcceptsData(node){// The window object can accept data but has no nodeType
	// Otherwise we are only interested in elements (1) and documents (9)
	var nodeType=node.nodeType;return nodeType===NODE_TYPE_ELEMENT||!nodeType||nodeType===NODE_TYPE_DOCUMENT;}function jqLiteHasData(node){for(var key in jqCache[node.ng339]){return true;}return false;}function jqLiteBuildFragment(html,context){var tmp,tag,wrap,fragment=context.createDocumentFragment(),nodes=[],i;if(jqLiteIsTextNode(html)){// Convert non-html into a text node
	nodes.push(context.createTextNode(html));}else{// Convert html into DOM nodes
	tmp=fragment.appendChild(context.createElement('div'));tag=(TAG_NAME_REGEXP.exec(html)||['',''])[1].toLowerCase();wrap=wrapMap[tag]||wrapMap._default;tmp.innerHTML=wrap[1]+html.replace(XHTML_TAG_REGEXP,'<$1></$2>')+wrap[2];// Descend through wrappers to the right content
	i=wrap[0];while(i--){tmp=tmp.lastChild;}nodes=concat(nodes,tmp.childNodes);tmp=fragment.firstChild;tmp.textContent='';}// Remove wrapper from fragment
	fragment.textContent='';fragment.innerHTML='';// Clear inner HTML
	forEach(nodes,function(node){fragment.appendChild(node);});return fragment;}function jqLiteParseHTML(html,context){context=context||window.document;var parsed;if(parsed=SINGLE_TAG_REGEXP.exec(html)){return[context.createElement(parsed[1])];}if(parsed=jqLiteBuildFragment(html,context)){return parsed.childNodes;}return[];}function jqLiteWrapNode(node,wrapper){var parent=node.parentNode;if(parent){parent.replaceChild(wrapper,node);}wrapper.appendChild(node);}// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains=window.Node.prototype.contains||/** @this */function(arg){// eslint-disable-next-line no-bitwise
	return!!(this.compareDocumentPosition(arg)&16);};/////////////////////////////////////////////
	function JQLite(element){if(element instanceof JQLite){return element;}var argIsString;if(isString(element)){element=trim(element);argIsString=true;}if(!(this instanceof JQLite)){if(argIsString&&element.charAt(0)!=='<'){throw jqLiteMinErr('nosel','Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');}return new JQLite(element);}if(argIsString){jqLiteAddNodes(this,jqLiteParseHTML(element));}else if(isFunction(element)){jqLiteReady(element);}else{jqLiteAddNodes(this,element);}}function jqLiteClone(element){return element.cloneNode(true);}function jqLiteDealoc(element,onlyDescendants){if(!onlyDescendants&&jqLiteAcceptsData(element))jqLite.cleanData([element]);if(element.querySelectorAll){jqLite.cleanData(element.querySelectorAll('*'));}}function jqLiteOff(element,type,fn,unsupported){if(isDefined(unsupported))throw jqLiteMinErr('offargs','jqLite#off() does not support the `selector` argument');var expandoStore=jqLiteExpandoStore(element);var events=expandoStore&&expandoStore.events;var handle=expandoStore&&expandoStore.handle;if(!handle)return;//no listeners registered
	if(!type){for(type in events){if(type!=='$destroy'){element.removeEventListener(type,handle);}delete events[type];}}else{var removeHandler=function removeHandler(type){var listenerFns=events[type];if(isDefined(fn)){arrayRemove(listenerFns||[],fn);}if(!(isDefined(fn)&&listenerFns&&listenerFns.length>0)){element.removeEventListener(type,handle);delete events[type];}};forEach(type.split(' '),function(type){removeHandler(type);if(MOUSE_EVENT_MAP[type]){removeHandler(MOUSE_EVENT_MAP[type]);}});}}function jqLiteRemoveData(element,name){var expandoId=element.ng339;var expandoStore=expandoId&&jqCache[expandoId];if(expandoStore){if(name){delete expandoStore.data[name];return;}if(expandoStore.handle){if(expandoStore.events.$destroy){expandoStore.handle({},'$destroy');}jqLiteOff(element);}delete jqCache[expandoId];element.ng339=undefined;// don't delete DOM expandos. IE and Chrome don't like it
	}}function jqLiteExpandoStore(element,createIfNecessary){var expandoId=element.ng339,expandoStore=expandoId&&jqCache[expandoId];if(createIfNecessary&&!expandoStore){element.ng339=expandoId=jqNextId();expandoStore=jqCache[expandoId]={events:{},data:{},handle:undefined};}return expandoStore;}function jqLiteData(element,key,value){if(jqLiteAcceptsData(element)){var prop;var isSimpleSetter=isDefined(value);var isSimpleGetter=!isSimpleSetter&&key&&!isObject(key);var massGetter=!key;var expandoStore=jqLiteExpandoStore(element,!isSimpleGetter);var data=expandoStore&&expandoStore.data;if(isSimpleSetter){// data('key', value)
	data[kebabToCamel(key)]=value;}else{if(massGetter){// data()
	return data;}else{if(isSimpleGetter){// data('key')
	// don't force creation of expandoStore if it doesn't exist yet
	return data&&data[kebabToCamel(key)];}else{// mass-setter: data({key1: val1, key2: val2})
	for(prop in key){data[kebabToCamel(prop)]=key[prop];}}}}}}function jqLiteHasClass(element,selector){if(!element.getAttribute)return false;return(' '+(element.getAttribute('class')||'')+' ').replace(/[\n\t]/g,' ').indexOf(' '+selector+' ')>-1;}function jqLiteRemoveClass(element,cssClasses){if(cssClasses&&element.setAttribute){var existingClasses=(' '+(element.getAttribute('class')||'')+' ').replace(/[\n\t]/g,' ');var newClasses=existingClasses;forEach(cssClasses.split(' '),function(cssClass){cssClass=trim(cssClass);newClasses=newClasses.replace(' '+cssClass+' ',' ');});if(newClasses!==existingClasses){element.setAttribute('class',trim(newClasses));}}}function jqLiteAddClass(element,cssClasses){if(cssClasses&&element.setAttribute){var existingClasses=(' '+(element.getAttribute('class')||'')+' ').replace(/[\n\t]/g,' ');var newClasses=existingClasses;forEach(cssClasses.split(' '),function(cssClass){cssClass=trim(cssClass);if(newClasses.indexOf(' '+cssClass+' ')===-1){newClasses+=cssClass+' ';}});if(newClasses!==existingClasses){element.setAttribute('class',trim(newClasses));}}}function jqLiteAddNodes(root,elements){// THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	if(elements){// if a Node (the most common case)
	if(elements.nodeType){root[root.length++]=elements;}else{var length=elements.length;// if an Array or NodeList and not a Window
	if(typeof length==='number'&&elements.window!==elements){if(length){for(var i=0;i<length;i++){root[root.length++]=elements[i];}}}else{root[root.length++]=elements;}}}}function jqLiteController(element,name){return jqLiteInheritedData(element,'$'+(name||'ngController')+'Controller');}function jqLiteInheritedData(element,name,value){// if element is the document object work with the html element instead
	// this makes $(document).scope() possible
	if(element.nodeType===NODE_TYPE_DOCUMENT){element=element.documentElement;}var names=isArray(name)?name:[name];while(element){for(var i=0,ii=names.length;i<ii;i++){if(isDefined(value=jqLite.data(element,names[i])))return value;}// If dealing with a document fragment node with a host element, and no parent, use the host
	// element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	// to lookup parent controllers.
	element=element.parentNode||element.nodeType===NODE_TYPE_DOCUMENT_FRAGMENT&&element.host;}}function jqLiteEmpty(element){jqLiteDealoc(element,true);while(element.firstChild){element.removeChild(element.firstChild);}}function jqLiteRemove(element,keepData){if(!keepData)jqLiteDealoc(element);var parent=element.parentNode;if(parent)parent.removeChild(element);}function jqLiteDocumentLoaded(action,win){win=win||window;if(win.document.readyState==='complete'){// Force the action to be run async for consistent behavior
	// from the action's point of view
	// i.e. it will definitely not be in a $apply
	win.setTimeout(action);}else{// No need to unbind this handler as load is only ever called once
	jqLite(win).on('load',action);}}function jqLiteReady(fn){function trigger(){window.document.removeEventListener('DOMContentLoaded',trigger);window.removeEventListener('load',trigger);fn();}// check if document is already loaded
	if(window.document.readyState==='complete'){window.setTimeout(fn);}else{// We can not use jqLite since we are not done loading and jQuery could be loaded later.
	// Works for modern browsers and IE9
	window.document.addEventListener('DOMContentLoaded',trigger);// Fallback to window.onload for others
	window.addEventListener('load',trigger);}}//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype=JQLite.prototype={ready:jqLiteReady,toString:function toString(){var value=[];forEach(this,function(e){value.push(''+e);});return'['+value.join(', ')+']';},eq:function eq(index){return index>=0?jqLite(this[index]):jqLite(this[this.length+index]);},length:0,push:push,sort:[].sort,splice:[].splice};//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR={};forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','),function(value){BOOLEAN_ATTR[lowercase(value)]=value;});var BOOLEAN_ELEMENTS={};forEach('input,select,option,textarea,button,form,details'.split(','),function(value){BOOLEAN_ELEMENTS[value]=true;});var ALIASED_ATTR={'ngMinlength':'minlength','ngMaxlength':'maxlength','ngMin':'min','ngMax':'max','ngPattern':'pattern','ngStep':'step'};function getBooleanAttrName(element,name){// check dom last since we will most likely fail on name
	var booleanAttr=BOOLEAN_ATTR[name.toLowerCase()];// booleanAttr is here twice to minimize DOM access
	return booleanAttr&&BOOLEAN_ELEMENTS[nodeName_(element)]&&booleanAttr;}function getAliasedAttrName(name){return ALIASED_ATTR[name];}forEach({data:jqLiteData,removeData:jqLiteRemoveData,hasData:jqLiteHasData,cleanData:function jqLiteCleanData(nodes){for(var i=0,ii=nodes.length;i<ii;i++){jqLiteRemoveData(nodes[i]);}}},function(fn,name){JQLite[name]=fn;});forEach({data:jqLiteData,inheritedData:jqLiteInheritedData,scope:function scope(element){// Can't use jqLiteData here directly so we stay compatible with jQuery!
	return jqLite.data(element,'$scope')||jqLiteInheritedData(element.parentNode||element,['$isolateScope','$scope']);},isolateScope:function isolateScope(element){// Can't use jqLiteData here directly so we stay compatible with jQuery!
	return jqLite.data(element,'$isolateScope')||jqLite.data(element,'$isolateScopeNoTemplate');},controller:jqLiteController,injector:function injector(element){return jqLiteInheritedData(element,'$injector');},removeAttr:function removeAttr(element,name){element.removeAttribute(name);},hasClass:jqLiteHasClass,css:function css(element,name,value){name=cssKebabToCamel(name);if(isDefined(value)){element.style[name]=value;}else{return element.style[name];}},attr:function attr(element,name,value){var ret;var nodeType=element.nodeType;if(nodeType===NODE_TYPE_TEXT||nodeType===NODE_TYPE_ATTRIBUTE||nodeType===NODE_TYPE_COMMENT||!element.getAttribute){return;}var lowercasedName=lowercase(name);var isBooleanAttr=BOOLEAN_ATTR[lowercasedName];if(isDefined(value)){// setter
	if(value===null||value===false&&isBooleanAttr){element.removeAttribute(name);}else{element.setAttribute(name,isBooleanAttr?lowercasedName:value);}}else{// getter
	ret=element.getAttribute(name);if(isBooleanAttr&&ret!==null){ret=lowercasedName;}// Normalize non-existing attributes to undefined (as jQuery).
	return ret===null?undefined:ret;}},prop:function prop(element,name,value){if(isDefined(value)){element[name]=value;}else{return element[name];}},text:function(){getText.$dv='';return getText;function getText(element,value){if(isUndefined(value)){var nodeType=element.nodeType;return nodeType===NODE_TYPE_ELEMENT||nodeType===NODE_TYPE_TEXT?element.textContent:'';}element.textContent=value;}}(),val:function val(element,value){if(isUndefined(value)){if(element.multiple&&nodeName_(element)==='select'){var result=[];forEach(element.options,function(option){if(option.selected){result.push(option.value||option.text);}});return result;}return element.value;}element.value=value;},html:function html(element,value){if(isUndefined(value)){return element.innerHTML;}jqLiteDealoc(element,true);element.innerHTML=value;},empty:jqLiteEmpty},function(fn,name){/**
	   * Properties: writes return selection, reads return first value
	   */JQLite.prototype[name]=function(arg1,arg2){var i,key;var nodeCount=this.length;// jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	// in a way that survives minification.
	// jqLiteEmpty takes no arguments but is a setter.
	if(fn!==jqLiteEmpty&&isUndefined(fn.length===2&&fn!==jqLiteHasClass&&fn!==jqLiteController?arg1:arg2)){if(isObject(arg1)){// we are a write, but the object properties are the key/values
	for(i=0;i<nodeCount;i++){if(fn===jqLiteData){// data() takes the whole object in jQuery
	fn(this[i],arg1);}else{for(key in arg1){fn(this[i],key,arg1[key]);}}}// return self for chaining
	return this;}else{// we are a read, so read the first child.
	// TODO: do we still need this?
	var value=fn.$dv;// Only if we have $dv do we iterate over all, otherwise it is just the first element.
	var jj=isUndefined(value)?Math.min(nodeCount,1):nodeCount;for(var j=0;j<jj;j++){var nodeValue=fn(this[j],arg1,arg2);value=value?value+nodeValue:nodeValue;}return value;}}else{// we are a write, so apply to all children
	for(i=0;i<nodeCount;i++){fn(this[i],arg1,arg2);}// return self for chaining
	return this;}};});function createEventHandler(element,events){var eventHandler=function eventHandler(event,type){// jQuery specific api
	event.isDefaultPrevented=function(){return event.defaultPrevented;};var eventFns=events[type||event.type];var eventFnsLength=eventFns?eventFns.length:0;if(!eventFnsLength)return;if(isUndefined(event.immediatePropagationStopped)){var originalStopImmediatePropagation=event.stopImmediatePropagation;event.stopImmediatePropagation=function(){event.immediatePropagationStopped=true;if(event.stopPropagation){event.stopPropagation();}if(originalStopImmediatePropagation){originalStopImmediatePropagation.call(event);}};}event.isImmediatePropagationStopped=function(){return event.immediatePropagationStopped===true;};// Some events have special handlers that wrap the real handler
	var handlerWrapper=eventFns.specialHandlerWrapper||defaultHandlerWrapper;// Copy event handlers in case event handlers array is modified during execution.
	if(eventFnsLength>1){eventFns=shallowCopy(eventFns);}for(var i=0;i<eventFnsLength;i++){if(!event.isImmediatePropagationStopped()){handlerWrapper(element,event,eventFns[i]);}}};// TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	//       events on `element`
	eventHandler.elem=element;return eventHandler;}function defaultHandlerWrapper(element,event,handler){handler.call(element,event);}function specialMouseHandlerWrapper(target,event,handler){// Refer to jQuery's implementation of mouseenter & mouseleave
	// Read about mouseenter and mouseleave:
	// http://www.quirksmode.org/js/events_mouse.html#link8
	var related=event.relatedTarget;// For mousenter/leave call the handler if related is outside the target.
	// NB: No relatedTarget if the mouse left/entered the browser window
	if(!related||related!==target&&!jqLiteContains.call(target,related)){handler.call(target,event);}}//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({removeData:jqLiteRemoveData,on:function jqLiteOn(element,type,fn,unsupported){if(isDefined(unsupported))throw jqLiteMinErr('onargs','jqLite#on() does not support the `selector` or `eventData` parameters');// Do not add event handlers to non-elements because they will not be cleaned up.
	if(!jqLiteAcceptsData(element)){return;}var expandoStore=jqLiteExpandoStore(element,true);var events=expandoStore.events;var handle=expandoStore.handle;if(!handle){handle=expandoStore.handle=createEventHandler(element,events);}// http://jsperf.com/string-indexof-vs-split
	var types=type.indexOf(' ')>=0?type.split(' '):[type];var i=types.length;var addHandler=function addHandler(type,specialHandlerWrapper,noEventListener){var eventFns=events[type];if(!eventFns){eventFns=events[type]=[];eventFns.specialHandlerWrapper=specialHandlerWrapper;if(type!=='$destroy'&&!noEventListener){element.addEventListener(type,handle);}}eventFns.push(fn);};while(i--){type=types[i];if(MOUSE_EVENT_MAP[type]){addHandler(MOUSE_EVENT_MAP[type],specialMouseHandlerWrapper);addHandler(type,undefined,true);}else{addHandler(type);}}},off:jqLiteOff,one:function one(element,type,fn){element=jqLite(element);//add the listener twice so that when it is called
	//you can remove the original function and still be
	//able to call element.off(ev, fn) normally
	element.on(type,function onFn(){element.off(type,fn);element.off(type,onFn);});element.on(type,fn);},replaceWith:function replaceWith(element,replaceNode){var index,parent=element.parentNode;jqLiteDealoc(element);forEach(new JQLite(replaceNode),function(node){if(index){parent.insertBefore(node,index.nextSibling);}else{parent.replaceChild(node,element);}index=node;});},children:function children(element){var children=[];forEach(element.childNodes,function(element){if(element.nodeType===NODE_TYPE_ELEMENT){children.push(element);}});return children;},contents:function contents(element){return element.contentDocument||element.childNodes||[];},append:function append(element,node){var nodeType=element.nodeType;if(nodeType!==NODE_TYPE_ELEMENT&&nodeType!==NODE_TYPE_DOCUMENT_FRAGMENT)return;node=new JQLite(node);for(var i=0,ii=node.length;i<ii;i++){var child=node[i];element.appendChild(child);}},prepend:function prepend(element,node){if(element.nodeType===NODE_TYPE_ELEMENT){var index=element.firstChild;forEach(new JQLite(node),function(child){element.insertBefore(child,index);});}},wrap:function wrap(element,wrapNode){jqLiteWrapNode(element,jqLite(wrapNode).eq(0).clone()[0]);},remove:jqLiteRemove,detach:function detach(element){jqLiteRemove(element,true);},after:function after(element,newElement){var index=element,parent=element.parentNode;if(parent){newElement=new JQLite(newElement);for(var i=0,ii=newElement.length;i<ii;i++){var node=newElement[i];parent.insertBefore(node,index.nextSibling);index=node;}}},addClass:jqLiteAddClass,removeClass:jqLiteRemoveClass,toggleClass:function toggleClass(element,selector,condition){if(selector){forEach(selector.split(' '),function(className){var classCondition=condition;if(isUndefined(classCondition)){classCondition=!jqLiteHasClass(element,className);}(classCondition?jqLiteAddClass:jqLiteRemoveClass)(element,className);});}},parent:function parent(element){var parent=element.parentNode;return parent&&parent.nodeType!==NODE_TYPE_DOCUMENT_FRAGMENT?parent:null;},next:function next(element){return element.nextElementSibling;},find:function find(element,selector){if(element.getElementsByTagName){return element.getElementsByTagName(selector);}else{return[];}},clone:jqLiteClone,triggerHandler:function triggerHandler(element,event,extraParameters){var dummyEvent,eventFnsCopy,handlerArgs;var eventName=event.type||event;var expandoStore=jqLiteExpandoStore(element);var events=expandoStore&&expandoStore.events;var eventFns=events&&events[eventName];if(eventFns){// Create a dummy event to pass to the handlers
	dummyEvent={preventDefault:function preventDefault(){this.defaultPrevented=true;},isDefaultPrevented:function isDefaultPrevented(){return this.defaultPrevented===true;},stopImmediatePropagation:function stopImmediatePropagation(){this.immediatePropagationStopped=true;},isImmediatePropagationStopped:function isImmediatePropagationStopped(){return this.immediatePropagationStopped===true;},stopPropagation:noop,type:eventName,target:element};// If a custom event was provided then extend our dummy event with it
	if(event.type){dummyEvent=extend(dummyEvent,event);}// Copy event handlers in case event handlers array is modified during execution.
	eventFnsCopy=shallowCopy(eventFns);handlerArgs=extraParameters?[dummyEvent].concat(extraParameters):[dummyEvent];forEach(eventFnsCopy,function(fn){if(!dummyEvent.isImmediatePropagationStopped()){fn.apply(element,handlerArgs);}});}}},function(fn,name){/**
	   * chaining functions
	   */JQLite.prototype[name]=function(arg1,arg2,arg3){var value;for(var i=0,ii=this.length;i<ii;i++){if(isUndefined(value)){value=fn(this[i],arg1,arg2,arg3);if(isDefined(value)){// any function which returns a value needs to be wrapped
	value=jqLite(value);}}else{jqLiteAddNodes(value,fn(this[i],arg1,arg2,arg3));}}return isDefined(value)?value:this;};});// bind legacy bind/unbind to on/off
	JQLite.prototype.bind=JQLite.prototype.on;JQLite.prototype.unbind=JQLite.prototype.off;// Provider for private $$jqLite service
	/** @this */function $$jqLiteProvider(){this.$get=function $$jqLite(){return extend(JQLite,{hasClass:function hasClass(node,classes){if(node.attr)node=node[0];return jqLiteHasClass(node,classes);},addClass:function addClass(node,classes){if(node.attr)node=node[0];return jqLiteAddClass(node,classes);},removeClass:function removeClass(node,classes){if(node.attr)node=node[0];return jqLiteRemoveClass(node,classes);}});};}/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */function hashKey(obj,nextUidFn){var key=obj&&obj.$$hashKey;if(key){if(typeof key==='function'){key=obj.$$hashKey();}return key;}var objType=typeof obj==='undefined'?'undefined':_typeof(obj);if(objType==='function'||objType==='object'&&obj!==null){key=obj.$$hashKey=objType+':'+(nextUidFn||nextUid)();}else{key=objType+':'+obj;}return key;}// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey=Object.create(null);function NgMapShim(){this._keys=[];this._values=[];this._lastKey=NaN;this._lastIndex=-1;}NgMapShim.prototype={_idx:function _idx(key){if(key===this._lastKey){return this._lastIndex;}this._lastKey=key;this._lastIndex=this._keys.indexOf(key);return this._lastIndex;},_transformKey:function _transformKey(key){return isNumberNaN(key)?nanKey:key;},get:function get(key){key=this._transformKey(key);var idx=this._idx(key);if(idx!==-1){return this._values[idx];}},set:function set(key,value){key=this._transformKey(key);var idx=this._idx(key);if(idx===-1){idx=this._lastIndex=this._keys.length;}this._keys[idx]=key;this._values[idx]=value;// Support: IE11
	// Do not `return this` to simulate the partial IE11 implementation
	},delete:function _delete(key){key=this._transformKey(key);var idx=this._idx(key);if(idx===-1){return false;}this._keys.splice(idx,1);this._values.splice(idx,1);this._lastKey=NaN;this._lastIndex=-1;return true;}};// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap=NgMapShim;var $$MapProvider=[/** @this */function(){this.$get=[function(){return NgMap;}];}];/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 *//**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */var ARROW_ARG=/^([^(]+?)=>/;var FN_ARGS=/^[^(]*\(\s*([^)]*)\)/m;var FN_ARG_SPLIT=/,/;var FN_ARG=/^\s*(_?)(\S+?)\1\s*$/;var STRIP_COMMENTS=/((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;var $injectorMinErr=minErr('$injector');function stringifyFn(fn){return Function.prototype.toString.call(fn);}function extractArgs(fn){var fnText=stringifyFn(fn).replace(STRIP_COMMENTS,''),args=fnText.match(ARROW_ARG)||fnText.match(FN_ARGS);return args;}function anonFn(fn){// For anonymous functions, showing at the very least the function signature can help in
	// debugging.
	var args=extractArgs(fn);if(args){return'function('+(args[1]||'').replace(/[\s\r\n]+/,' ')+')';}return'fn';}function annotate(fn,strictDi,name){var $inject,argDecl,last;if(typeof fn==='function'){if(!($inject=fn.$inject)){$inject=[];if(fn.length){if(strictDi){if(!isString(name)||!name){name=fn.name||anonFn(fn);}throw $injectorMinErr('strictdi','{0} is not using explicit annotation and cannot be invoked in strict mode',name);}argDecl=extractArgs(fn);forEach(argDecl[1].split(FN_ARG_SPLIT),function(arg){arg.replace(FN_ARG,function(all,underscore,name){$inject.push(name);});});}fn.$inject=$inject;}}else if(isArray(fn)){last=fn.length-1;assertArgFn(fn[last],'fn');$inject=fn.slice(0,last);}else{assertArgFn(fn,'fn',true);}return $inject;}///////////////////////////////////////
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 *//**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 *//**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 *//**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 *//**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 *//**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 *//**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 *//**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 *//**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 *//**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 *//**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */function createInjector(modulesToLoad,strictDi){strictDi=strictDi===true;var INSTANTIATING={},providerSuffix='Provider',path=[],loadedModules=new NgMap(),providerCache={$provide:{provider:supportObject(provider),factory:supportObject(factory),service:supportObject(service),value:supportObject(value),constant:supportObject(constant),decorator:decorator}},providerInjector=providerCache.$injector=createInternalInjector(providerCache,function(serviceName,caller){if(angular.isString(caller)){path.push(caller);}throw $injectorMinErr('unpr','Unknown provider: {0}',path.join(' <- '));}),instanceCache={},protoInstanceInjector=createInternalInjector(instanceCache,function(serviceName,caller){var provider=providerInjector.get(serviceName+providerSuffix,caller);return instanceInjector.invoke(provider.$get,provider,undefined,serviceName);}),instanceInjector=protoInstanceInjector;providerCache['$injector'+providerSuffix]={$get:valueFn(protoInstanceInjector)};instanceInjector.modules=providerInjector.modules=createMap();var runBlocks=loadModules(modulesToLoad);instanceInjector=protoInstanceInjector.get('$injector');instanceInjector.strictDi=strictDi;forEach(runBlocks,function(fn){if(fn)instanceInjector.invoke(fn);});instanceInjector.loadNewModules=function(mods){forEach(loadModules(mods),function(fn){if(fn)instanceInjector.invoke(fn);});};return instanceInjector;////////////////////////////////////
	// $provider
	////////////////////////////////////
	function supportObject(delegate){return function(key,value){if(isObject(key)){forEach(key,reverseParams(delegate));}else{return delegate(key,value);}};}function provider(name,provider_){assertNotHasOwnProperty(name,'service');if(isFunction(provider_)||isArray(provider_)){provider_=providerInjector.instantiate(provider_);}if(!provider_.$get){throw $injectorMinErr('pget','Provider \'{0}\' must define $get factory method.',name);}return providerCache[name+providerSuffix]=provider_;}function enforceReturnValue(name,factory){return(/** @this */function enforcedReturnValue(){var result=instanceInjector.invoke(factory,this);if(isUndefined(result)){throw $injectorMinErr('undef','Provider \'{0}\' must return a value from $get factory method.',name);}return result;});}function factory(name,factoryFn,enforce){return provider(name,{$get:enforce!==false?enforceReturnValue(name,factoryFn):factoryFn});}function service(name,constructor){return factory(name,['$injector',function($injector){return $injector.instantiate(constructor);}]);}function value(name,val){return factory(name,valueFn(val),false);}function constant(name,value){assertNotHasOwnProperty(name,'constant');providerCache[name]=value;instanceCache[name]=value;}function decorator(serviceName,decorFn){var origProvider=providerInjector.get(serviceName+providerSuffix),orig$get=origProvider.$get;origProvider.$get=function(){var origInstance=instanceInjector.invoke(orig$get,origProvider);return instanceInjector.invoke(decorFn,null,{$delegate:origInstance});};}////////////////////////////////////
	// Module Loading
	////////////////////////////////////
	function loadModules(modulesToLoad){assertArg(isUndefined(modulesToLoad)||isArray(modulesToLoad),'modulesToLoad','not an array');var runBlocks=[],moduleFn;forEach(modulesToLoad,function(module){if(loadedModules.get(module))return;loadedModules.set(module,true);function runInvokeQueue(queue){var i,ii;for(i=0,ii=queue.length;i<ii;i++){var invokeArgs=queue[i],provider=providerInjector.get(invokeArgs[0]);provider[invokeArgs[1]].apply(provider,invokeArgs[2]);}}try{if(isString(module)){moduleFn=angularModule(module);instanceInjector.modules[module]=moduleFn;runBlocks=runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);runInvokeQueue(moduleFn._invokeQueue);runInvokeQueue(moduleFn._configBlocks);}else if(isFunction(module)){runBlocks.push(providerInjector.invoke(module));}else if(isArray(module)){runBlocks.push(providerInjector.invoke(module));}else{assertArgFn(module,'module');}}catch(e){if(isArray(module)){module=module[module.length-1];}if(e.message&&e.stack&&e.stack.indexOf(e.message)===-1){// Safari & FF's stack traces don't contain error.message content
	// unlike those of Chrome and IE
	// So if stack doesn't contain message, we create a new string that contains both.
	// Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	// eslint-disable-next-line no-ex-assign
	e=e.message+'\n'+e.stack;}throw $injectorMinErr('modulerr','Failed to instantiate module {0} due to:\n{1}',module,e.stack||e.message||e);}});return runBlocks;}////////////////////////////////////
	// internal Injector
	////////////////////////////////////
	function createInternalInjector(cache,factory){function getService(serviceName,caller){if(cache.hasOwnProperty(serviceName)){if(cache[serviceName]===INSTANTIATING){throw $injectorMinErr('cdep','Circular dependency found: {0}',serviceName+' <- '+path.join(' <- '));}return cache[serviceName];}else{try{path.unshift(serviceName);cache[serviceName]=INSTANTIATING;cache[serviceName]=factory(serviceName,caller);return cache[serviceName];}catch(err){if(cache[serviceName]===INSTANTIATING){delete cache[serviceName];}throw err;}finally{path.shift();}}}function injectionArgs(fn,locals,serviceName){var args=[],$inject=createInjector.$$annotate(fn,strictDi,serviceName);for(var i=0,length=$inject.length;i<length;i++){var key=$inject[i];if(typeof key!=='string'){throw $injectorMinErr('itkn','Incorrect injection token! Expected service name as string, got {0}',key);}args.push(locals&&locals.hasOwnProperty(key)?locals[key]:getService(key,serviceName));}return args;}function isClass(func){// Support: IE 9-11 only
	// IE 9-11 do not support classes and IE9 leaks with the code below.
	if(msie||typeof func!=='function'){return false;}var result=func.$$ngIsClass;if(!isBoolean(result)){// Support: Edge 12-13 only
	// See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	result=func.$$ngIsClass=/^(?:class\b|constructor\()/.test(stringifyFn(func));}return result;}function invoke(fn,self,locals,serviceName){if(typeof locals==='string'){serviceName=locals;locals=null;}var args=injectionArgs(fn,locals,serviceName);if(isArray(fn)){fn=fn[fn.length-1];}if(!isClass(fn)){// http://jsperf.com/angularjs-invoke-apply-vs-switch
	// #5388
	return fn.apply(self,args);}else{args.unshift(null);return new(Function.prototype.bind.apply(fn,args))();}}function instantiate(Type,locals,serviceName){// Check if Type is annotated and use just the given function at n-1 as parameter
	// e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	var ctor=isArray(Type)?Type[Type.length-1]:Type;var args=injectionArgs(Type,locals,serviceName);// Empty object at position 0 is ignored for invocation with `new`, but required.
	args.unshift(null);return new(Function.prototype.bind.apply(ctor,args))();}return{invoke:invoke,instantiate:instantiate,get:getService,annotate:createInjector.$$annotate,has:function has(name){return providerCache.hasOwnProperty(name+providerSuffix)||cache.hasOwnProperty(name);}};}}createInjector.$$annotate=annotate;/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */function $AnchorScrollProvider(){var autoScrollingEnabled=true;/**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */this.disableAutoScrolling=function(){autoScrollingEnabled=false;};/**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */this.$get=['$window','$location','$rootScope',function($window,$location,$rootScope){var document=$window.document;// Helper function to get first anchor from a NodeList
	// (using `Array#some()` instead of `angular#forEach()` since it's more performant
	//  and working in all supported browsers.)
	function getFirstAnchor(list){var result=null;Array.prototype.some.call(list,function(element){if(nodeName_(element)==='a'){result=element;return true;}});return result;}function getYOffset(){var offset=scroll.yOffset;if(isFunction(offset)){offset=offset();}else if(isElement(offset)){var elem=offset[0];var style=$window.getComputedStyle(elem);if(style.position!=='fixed'){offset=0;}else{offset=elem.getBoundingClientRect().bottom;}}else if(!isNumber(offset)){offset=0;}return offset;}function scrollTo(elem){if(elem){elem.scrollIntoView();var offset=getYOffset();if(offset){// `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	// This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	// top of the viewport.
	//
	// IF the number of pixels from the top of `elem` to the end of the page's content is less
	// than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	// way down the page.
	//
	// This is often the case for elements near the bottom of the page.
	//
	// In such cases we do not need to scroll the whole `offset` up, just the difference between
	// the top of the element and the offset, which is enough to align the top of `elem` at the
	// desired position.
	var elemTop=elem.getBoundingClientRect().top;$window.scrollBy(0,elemTop-offset);}}else{$window.scrollTo(0,0);}}function scroll(hash){// Allow numeric hashes
	hash=isString(hash)?hash:isNumber(hash)?hash.toString():$location.hash();var elm;// empty hash, scroll to the top of the page
	if(!hash)scrollTo(null);// element with given id
	else if(elm=document.getElementById(hash))scrollTo(elm);// first anchor with given name :-D
	else if(elm=getFirstAnchor(document.getElementsByName(hash)))scrollTo(elm);// no element and hash === 'top', scroll to the top of the page
	else if(hash==='top')scrollTo(null);}// does not scroll when user clicks on anchor link that is currently on
	// (no url change, no $location.hash() change), browser native does scroll
	if(autoScrollingEnabled){$rootScope.$watch(function autoScrollWatch(){return $location.hash();},function autoScrollWatchAction(newVal,oldVal){// skip the initial scroll if $location.hash is empty
	if(newVal===oldVal&&newVal==='')return;jqLiteDocumentLoaded(function(){$rootScope.$evalAsync(scroll);});});}return scroll;}];}var $animateMinErr=minErr('$animate');var ELEMENT_NODE=1;var NG_ANIMATE_CLASSNAME='ng-animate';function mergeClasses(a,b){if(!a&&!b)return'';if(!a)return b;if(!b)return a;if(isArray(a))a=a.join(' ');if(isArray(b))b=b.join(' ');return a+' '+b;}function extractElementNode(element){for(var i=0;i<element.length;i++){var elm=element[i];if(elm.nodeType===ELEMENT_NODE){return elm;}}}function splitClasses(classes){if(isString(classes)){classes=classes.split(' ');}// Use createMap() to prevent class assumptions involving property names in
	// Object.prototype
	var obj=createMap();forEach(classes,function(klass){// sometimes the split leaves empty string values
	// incase extra spaces were applied to the options
	if(klass.length){obj[klass]=true;}});return obj;}// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options){return isObject(options)?options:{};}var $$CoreAnimateJsProvider=/** @this */function $$CoreAnimateJsProvider(){this.$get=noop;};// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider=/** @this */function $$CoreAnimateQueueProvider(){var postDigestQueue=new NgMap();var postDigestElements=[];this.$get=['$$AnimateRunner','$rootScope',function($$AnimateRunner,$rootScope){return{enabled:noop,on:noop,off:noop,pin:noop,push:function push(element,event,options,domOperation){if(domOperation){domOperation();}options=options||{};if(options.from){element.css(options.from);}if(options.to){element.css(options.to);}if(options.addClass||options.removeClass){addRemoveClassesPostDigest(element,options.addClass,options.removeClass);}var runner=new $$AnimateRunner();// since there are no animations to run the runner needs to be
	// notified that the animation call is complete.
	runner.complete();return runner;}};function updateData(data,classes,value){var changed=false;if(classes){classes=isString(classes)?classes.split(' '):isArray(classes)?classes:[];forEach(classes,function(className){if(className){changed=true;data[className]=value;}});}return changed;}function handleCSSClassChanges(){forEach(postDigestElements,function(element){var data=postDigestQueue.get(element);if(data){var existing=splitClasses(element.attr('class'));var toAdd='';var toRemove='';forEach(data,function(status,className){var hasClass=!!existing[className];if(status!==hasClass){if(status){toAdd+=(toAdd.length?' ':'')+className;}else{toRemove+=(toRemove.length?' ':'')+className;}}});forEach(element,function(elm){if(toAdd){jqLiteAddClass(elm,toAdd);}if(toRemove){jqLiteRemoveClass(elm,toRemove);}});postDigestQueue.delete(element);}});postDigestElements.length=0;}function addRemoveClassesPostDigest(element,add,remove){var data=postDigestQueue.get(element)||{};var classesAdded=updateData(data,add,true);var classesRemoved=updateData(data,remove,false);if(classesAdded||classesRemoved){postDigestQueue.set(element,data);postDigestElements.push(element);if(postDigestElements.length===1){$rootScope.$$postDigest(handleCSSClassChanges);}}}}];};/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */var $AnimateProvider=['$provide',/** @this */function($provide){var provider=this;var classNameFilter=null;var customFilter=null;this.$$registeredAnimations=Object.create(null);/**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */this.register=function(name,factory){if(name&&name.charAt(0)!=='.'){throw $animateMinErr('notcsel','Expecting class selector starting with \'.\' got \'{0}\'.',name);}var key=name+'-animation';provider.$$registeredAnimations[name.substr(1)]=key;$provide.factory(key,factory);};/**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */this.customFilter=function(filterFn){if(arguments.length===1){customFilter=isFunction(filterFn)?filterFn:null;}return customFilter;};/**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */this.classNameFilter=function(expression){if(arguments.length===1){classNameFilter=expression instanceof RegExp?expression:null;if(classNameFilter){var reservedRegex=new RegExp('[(\\s|\\/)]'+NG_ANIMATE_CLASSNAME+'[(\\s|\\/)]');if(reservedRegex.test(classNameFilter.toString())){classNameFilter=null;throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.',NG_ANIMATE_CLASSNAME);}}}return classNameFilter;};this.$get=['$$animateQueue',function($$animateQueue){function domInsert(element,parentElement,afterElement){// if for some reason the previous element was removed
	// from the dom sometime before this code runs then let's
	// just stick to using the parent element as the anchor
	if(afterElement){var afterNode=extractElementNode(afterElement);if(afterNode&&!afterNode.parentNode&&!afterNode.previousElementSibling){afterElement=null;}}if(afterElement){afterElement.after(element);}else{parentElement.prepend(element);}}/**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */return{// we don't call it directly since non-existant arguments may
	// be interpreted as null within the sub enabled function
	/**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */on:$$animateQueue.on,/**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */off:$$animateQueue.off,/**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */pin:$$animateQueue.pin,/**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */enabled:$$animateQueue.enabled,/**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */cancel:function cancel(runner){if(runner.end){runner.end();}},/**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */enter:function enter(element,parent,after,options){parent=parent&&jqLite(parent);after=after&&jqLite(after);parent=parent||after.parent();domInsert(element,parent,after);return $$animateQueue.push(element,'enter',prepareAnimateOptions(options));},/**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */move:function move(element,parent,after,options){parent=parent&&jqLite(parent);after=after&&jqLite(after);parent=parent||after.parent();domInsert(element,parent,after);return $$animateQueue.push(element,'move',prepareAnimateOptions(options));},/**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */leave:function leave(element,options){return $$animateQueue.push(element,'leave',prepareAnimateOptions(options),function(){element.remove();});},/**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */addClass:function addClass(element,className,options){options=prepareAnimateOptions(options);options.addClass=mergeClasses(options.addclass,className);return $$animateQueue.push(element,'addClass',options);},/**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */removeClass:function removeClass(element,className,options){options=prepareAnimateOptions(options);options.removeClass=mergeClasses(options.removeClass,className);return $$animateQueue.push(element,'removeClass',options);},/**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */setClass:function setClass(element,add,remove,options){options=prepareAnimateOptions(options);options.addClass=mergeClasses(options.addClass,add);options.removeClass=mergeClasses(options.removeClass,remove);return $$animateQueue.push(element,'setClass',options);},/**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */animate:function animate(element,from,to,className,options){options=prepareAnimateOptions(options);options.from=options.from?extend(options.from,from):from;options.to=options.to?extend(options.to,to):to;className=className||'ng-inline-animate';options.tempClasses=mergeClasses(options.tempClasses,className);return $$animateQueue.push(element,'animate',options);}};}];}];var $$AnimateAsyncRunFactoryProvider=/** @this */function $$AnimateAsyncRunFactoryProvider(){this.$get=['$$rAF',function($$rAF){var waitQueue=[];function waitForTick(fn){waitQueue.push(fn);if(waitQueue.length>1)return;$$rAF(function(){for(var i=0;i<waitQueue.length;i++){waitQueue[i]();}waitQueue=[];});}return function(){var passed=false;waitForTick(function(){passed=true;});return function(callback){if(passed){callback();}else{waitForTick(callback);}};};}];};var $$AnimateRunnerFactoryProvider=/** @this */function $$AnimateRunnerFactoryProvider(){this.$get=['$q','$sniffer','$$animateAsyncRun','$$isDocumentHidden','$timeout',function($q,$sniffer,$$animateAsyncRun,$$isDocumentHidden,$timeout){var INITIAL_STATE=0;var DONE_PENDING_STATE=1;var DONE_COMPLETE_STATE=2;AnimateRunner.chain=function(chain,callback){var index=0;next();function next(){if(index===chain.length){callback(true);return;}chain[index](function(response){if(response===false){callback(false);return;}index++;next();});}};AnimateRunner.all=function(runners,callback){var count=0;var status=true;forEach(runners,function(runner){runner.done(onProgress);});function onProgress(response){status=status&&response;if(++count===runners.length){callback(status);}}};function AnimateRunner(host){this.setHost(host);var rafTick=$$animateAsyncRun();var timeoutTick=function timeoutTick(fn){$timeout(fn,0,false);};this._doneCallbacks=[];this._tick=function(fn){if($$isDocumentHidden()){timeoutTick(fn);}else{rafTick(fn);}};this._state=0;}AnimateRunner.prototype={setHost:function setHost(host){this.host=host||{};},done:function done(fn){if(this._state===DONE_COMPLETE_STATE){fn();}else{this._doneCallbacks.push(fn);}},progress:noop,getPromise:function getPromise(){if(!this.promise){var self=this;this.promise=$q(function(resolve,reject){self.done(function(status){if(status===false){reject();}else{resolve();}});});}return this.promise;},then:function then(resolveHandler,rejectHandler){return this.getPromise().then(resolveHandler,rejectHandler);},'catch':function _catch(handler){return this.getPromise()['catch'](handler);},'finally':function _finally(handler){return this.getPromise()['finally'](handler);},pause:function pause(){if(this.host.pause){this.host.pause();}},resume:function resume(){if(this.host.resume){this.host.resume();}},end:function end(){if(this.host.end){this.host.end();}this._resolve(true);},cancel:function cancel(){if(this.host.cancel){this.host.cancel();}this._resolve(false);},complete:function complete(response){var self=this;if(self._state===INITIAL_STATE){self._state=DONE_PENDING_STATE;self._tick(function(){self._resolve(response);});}},_resolve:function _resolve(response){if(this._state!==DONE_COMPLETE_STATE){forEach(this._doneCallbacks,function(fn){fn(response);});this._doneCallbacks.length=0;this._state=DONE_COMPLETE_STATE;}}};return AnimateRunner;}];};/* exported $CoreAnimateCssProvider *//**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */var $CoreAnimateCssProvider=function $CoreAnimateCssProvider(){this.$get=['$$rAF','$q','$$AnimateRunner',function($$rAF,$q,$$AnimateRunner){return function(element,initialOptions){// all of the animation functions should create
	// a copy of the options data, however, if a
	// parent service has already created a copy then
	// we should stick to using that
	var options=initialOptions||{};if(!options.$$prepared){options=copy(options);}// there is no point in applying the styles since
	// there is no animation that goes on at all in
	// this version of $animateCss.
	if(options.cleanupStyles){options.from=options.to=null;}if(options.from){element.css(options.from);options.from=null;}var closed,runner=new $$AnimateRunner();return{start:run,end:run};function run(){$$rAF(function(){applyAnimationContents();if(!closed){runner.complete();}closed=true;});return runner;}function applyAnimationContents(){if(options.addClass){element.addClass(options.addClass);options.addClass=null;}if(options.removeClass){element.removeClass(options.removeClass);options.removeClass=null;}if(options.to){element.css(options.to);options.to=null;}}};}];};/* global stripHash: true *//**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 *//**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */function Browser(window,document,$log,$sniffer){var self=this,location=window.location,history=window.history,setTimeout=window.setTimeout,clearTimeout=window.clearTimeout,pendingDeferIds={};self.isMock=false;var outstandingRequestCount=0;var outstandingRequestCallbacks=[];// TODO(vojta): remove this temporary api
	self.$$completeOutstandingRequest=completeOutstandingRequest;self.$$incOutstandingRequestCount=function(){outstandingRequestCount++;};/**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */function completeOutstandingRequest(fn){try{fn.apply(null,sliceArgs(arguments,1));}finally{outstandingRequestCount--;if(outstandingRequestCount===0){while(outstandingRequestCallbacks.length){try{outstandingRequestCallbacks.pop()();}catch(e){$log.error(e);}}}}}function getHash(url){var index=url.indexOf('#');return index===-1?'':url.substr(index);}/**
	   * @private
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */self.notifyWhenNoOutstandingRequests=function(callback){if(outstandingRequestCount===0){callback();}else{outstandingRequestCallbacks.push(callback);}};//////////////////////////////////////////////////////////////
	// URL API
	//////////////////////////////////////////////////////////////
	var cachedState,lastHistoryState,lastBrowserUrl=location.href,baseElement=document.find('base'),pendingLocation=null,getCurrentState=!$sniffer.history?noop:function getCurrentState(){try{return history.state;}catch(e){// MSIE can reportedly throw when there is no state (UNCONFIRMED).
	}};cacheState();/**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */self.url=function(url,replace,state){// In modern browsers `history.state` is `null` by default; treating it separately
	// from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	// to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	if(isUndefined(state)){state=null;}// Android Browser BFCache causes location, history reference to become stale.
	if(location!==window.location)location=window.location;if(history!==window.history)history=window.history;// setter
	if(url){var sameState=lastHistoryState===state;// Don't change anything if previous and current URLs and states match. This also prevents
	// IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	// See https://github.com/angular/angular.js/commit/ffb2701
	if(lastBrowserUrl===url&&(!$sniffer.history||sameState)){return self;}var sameBase=lastBrowserUrl&&stripHash(lastBrowserUrl)===stripHash(url);lastBrowserUrl=url;lastHistoryState=state;// Don't use history API if only the hash changed
	// due to a bug in IE10/IE11 which leads
	// to not firing a `hashchange` nor `popstate` event
	// in some cases (see #9143).
	if($sniffer.history&&(!sameBase||!sameState)){history[replace?'replaceState':'pushState'](state,'',url);cacheState();}else{if(!sameBase){pendingLocation=url;}if(replace){location.replace(url);}else if(!sameBase){location.href=url;}else{location.hash=getHash(url);}if(location.href!==url){pendingLocation=url;}}if(pendingLocation){pendingLocation=url;}return self;// getter
	}else{// - pendingLocation is needed as browsers don't allow to read out
	//   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	//   https://openradar.appspot.com/22186109).
	// - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	return pendingLocation||location.href.replace(/%27/g,'\'');}};/**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */self.state=function(){return cachedState;};var urlChangeListeners=[],urlChangeInit=false;function cacheStateAndFireUrlChange(){pendingLocation=null;fireStateOrUrlChange();}// This variable should be used *only* inside the cacheState function.
	var lastCachedState=null;function cacheState(){// This should be the only place in $browser where `history.state` is read.
	cachedState=getCurrentState();cachedState=isUndefined(cachedState)?null:cachedState;// Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	if(equals(cachedState,lastCachedState)){cachedState=lastCachedState;}lastCachedState=cachedState;lastHistoryState=cachedState;}function fireStateOrUrlChange(){var prevLastHistoryState=lastHistoryState;cacheState();if(lastBrowserUrl===self.url()&&prevLastHistoryState===cachedState){return;}lastBrowserUrl=self.url();lastHistoryState=cachedState;forEach(urlChangeListeners,function(listener){listener(self.url(),cachedState);});}/**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */self.onUrlChange=function(callback){// TODO(vojta): refactor to use node's syntax for events
	if(!urlChangeInit){// We listen on both (hashchange/popstate) when available, as some browsers don't
	// fire popstate when user changes the address bar and don't fire hashchange when url
	// changed by push/replaceState
	// html5 history api - popstate event
	if($sniffer.history)jqLite(window).on('popstate',cacheStateAndFireUrlChange);// hashchange event
	jqLite(window).on('hashchange',cacheStateAndFireUrlChange);urlChangeInit=true;}urlChangeListeners.push(callback);return callback;};/**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */self.$$applicationDestroyed=function(){jqLite(window).off('hashchange popstate',cacheStateAndFireUrlChange);};/**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */self.$$checkUrlChange=fireStateOrUrlChange;//////////////////////////////////////////////////////////////
	// Misc API
	//////////////////////////////////////////////////////////////
	/**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */self.baseHref=function(){var href=baseElement.attr('href');return href?href.replace(/^(https?:)?\/\/[^/]*/,''):'';};/**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */self.defer=function(fn,delay){var timeoutId;outstandingRequestCount++;timeoutId=setTimeout(function(){delete pendingDeferIds[timeoutId];completeOutstandingRequest(fn);},delay||0);pendingDeferIds[timeoutId]=true;return timeoutId;};/**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */self.defer.cancel=function(deferId){if(pendingDeferIds[deferId]){delete pendingDeferIds[deferId];clearTimeout(deferId);completeOutstandingRequest(noop);return true;}return false;};}/** @this */function $BrowserProvider(){this.$get=['$window','$log','$sniffer','$document',function($window,$log,$sniffer,$document){return new Browser($window,$document,$log,$sniffer);}];}/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */function $CacheFactoryProvider(){this.$get=function(){var caches={};function cacheFactory(cacheId,options){if(cacheId in caches){throw minErr('$cacheFactory')('iid','CacheId \'{0}\' is already taken!',cacheId);}var size=0,stats=extend({},options,{id:cacheId}),data=createMap(),capacity=options&&options.capacity||Number.MAX_VALUE,lruHash=createMap(),freshEnd=null,staleEnd=null;/**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */return caches[cacheId]={/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */put:function put(key,value){if(isUndefined(value))return;if(capacity<Number.MAX_VALUE){var lruEntry=lruHash[key]||(lruHash[key]={key:key});refresh(lruEntry);}if(!(key in data))size++;data[key]=value;if(size>capacity){this.remove(staleEnd.key);}return value;},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */get:function get(key){if(capacity<Number.MAX_VALUE){var lruEntry=lruHash[key];if(!lruEntry)return;refresh(lruEntry);}return data[key];},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */remove:function remove(key){if(capacity<Number.MAX_VALUE){var lruEntry=lruHash[key];if(!lruEntry)return;if(lruEntry===freshEnd)freshEnd=lruEntry.p;if(lruEntry===staleEnd)staleEnd=lruEntry.n;link(lruEntry.n,lruEntry.p);delete lruHash[key];}if(!(key in data))return;delete data[key];size--;},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */removeAll:function removeAll(){data=createMap();size=0;lruHash=createMap();freshEnd=staleEnd=null;},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */destroy:function destroy(){data=null;stats=null;lruHash=null;delete caches[cacheId];},/**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */info:function info(){return extend({},stats,{size:size});}};/**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */function refresh(entry){if(entry!==freshEnd){if(!staleEnd){staleEnd=entry;}else if(staleEnd===entry){staleEnd=entry.n;}link(entry.n,entry.p);link(entry,freshEnd);freshEnd=entry;freshEnd.n=null;}}/**
	       * bidirectionally links two entries of the LRU linked list
	       */function link(nextEntry,prevEntry){if(nextEntry!==prevEntry){if(nextEntry)nextEntry.p=prevEntry;//p stands for previous, 'prev' didn't minify
	if(prevEntry)prevEntry.n=nextEntry;//n stands for next, 'next' didn't minify
	}}}/**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */cacheFactory.info=function(){var info={};forEach(caches,function(cache,cacheId){info[cacheId]=cache.info();});return info;};/**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */cacheFactory.get=function(cacheId){return caches[cacheId];};return cacheFactory;};}/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */function $TemplateCacheProvider(){this.$get=['$cacheFactory',function($cacheFactory){return $cacheFactory('templates');}];}/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *//* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 *//**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
	 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
	 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` (*DEPRECATED*)
	 *
	 * `replace` will be removed in next major release - i.e. v2.0).
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */var $compileMinErr=minErr('$compile');function UNINITIALIZED_VALUE(){}var _UNINITIALIZED_VALUE=new UNINITIALIZED_VALUE();/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */$CompileProvider.$inject=['$provide','$$sanitizeUriProvider'];/** @this */function $CompileProvider($provide,$$sanitizeUriProvider){var hasDirectives={},Suffix='Directive',COMMENT_DIRECTIVE_REGEXP=/^\s*directive:\s*([\w-]+)\s+(.*)$/,CLASS_DIRECTIVE_REGEXP=/(([\w-]+)(?::([^;]+))?;?)/,ALL_OR_NOTHING_ATTRS=makeMap('ngSrc,ngSrcset,src,srcset'),REQUIRE_PREFIX_REGEXP=/^(?:(\^\^?)?(\?)?(\^\^?)?)?/;// Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	// The assumption is that future DOM event attribute names will begin with
	// 'on' and be composed of only English letters.
	var EVENT_HANDLER_ATTR_REGEXP=/^(on[a-z]+|formaction)$/;var bindingCache=createMap();function parseIsolateBindings(scope,directiveName,isController){var LOCAL_REGEXP=/^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;var bindings=createMap();forEach(scope,function(definition,scopeName){if(definition in bindingCache){bindings[scopeName]=bindingCache[definition];return;}var match=definition.match(LOCAL_REGEXP);if(!match){throw $compileMinErr('iscp','Invalid {3} for directive \'{0}\'.'+' Definition: {... {1}: \'{2}\' ...}',directiveName,scopeName,definition,isController?'controller bindings definition':'isolate scope definition');}bindings[scopeName]={mode:match[1][0],collection:match[2]==='*',optional:match[3]==='?',attrName:match[4]||scopeName};if(match[4]){bindingCache[definition]=bindings[scopeName];}});return bindings;}function parseDirectiveBindings(directive,directiveName){var bindings={isolateScope:null,bindToController:null};if(isObject(directive.scope)){if(directive.bindToController===true){bindings.bindToController=parseIsolateBindings(directive.scope,directiveName,true);bindings.isolateScope={};}else{bindings.isolateScope=parseIsolateBindings(directive.scope,directiveName,false);}}if(isObject(directive.bindToController)){bindings.bindToController=parseIsolateBindings(directive.bindToController,directiveName,true);}if(bindings.bindToController&&!directive.controller){// There is no controller
	throw $compileMinErr('noctrl','Cannot bind to controller without directive \'{0}\'s controller.',directiveName);}return bindings;}function assertValidDirectiveName(name){var letter=name.charAt(0);if(!letter||letter!==lowercase(letter)){throw $compileMinErr('baddir','Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter',name);}if(name!==name.trim()){throw $compileMinErr('baddir','Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',name);}}function getDirectiveRequire(directive){var require=directive.require||directive.controller&&directive.name;if(!isArray(require)&&isObject(require)){forEach(require,function(value,key){var match=value.match(REQUIRE_PREFIX_REGEXP);var name=value.substring(match[0].length);if(!name)require[key]=match[0]+key;});}return require;}function getDirectiveRestrict(restrict,name){if(restrict&&!(isString(restrict)&&/[EACM]/.test(restrict))){throw $compileMinErr('badrestrict','Restrict property \'{0}\' of directive \'{1}\' is invalid',restrict,name);}return restrict||'EA';}/**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */this.directive=function registerDirective(name,directiveFactory){assertArg(name,'name');assertNotHasOwnProperty(name,'directive');if(isString(name)){assertValidDirectiveName(name);assertArg(directiveFactory,'directiveFactory');if(!hasDirectives.hasOwnProperty(name)){hasDirectives[name]=[];$provide.factory(name+Suffix,['$injector','$exceptionHandler',function($injector,$exceptionHandler){var directives=[];forEach(hasDirectives[name],function(directiveFactory,index){try{var directive=$injector.invoke(directiveFactory);if(isFunction(directive)){directive={compile:valueFn(directive)};}else if(!directive.compile&&directive.link){directive.compile=valueFn(directive.link);}directive.priority=directive.priority||0;directive.index=index;directive.name=directive.name||name;directive.require=getDirectiveRequire(directive);directive.restrict=getDirectiveRestrict(directive.restrict,name);directive.$$moduleName=directiveFactory.$$moduleName;directives.push(directive);}catch(e){$exceptionHandler(e);}});return directives;}]);}hasDirectives[name].push(directiveFactory);}else{forEach(name,reverseParams(registerDirective));}return this;};/**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */this.component=function registerComponent(name,options){if(!isString(name)){forEach(name,reverseParams(bind(this,registerComponent)));return this;}var controller=options.controller||function(){};function factory($injector){function makeInjectable(fn){if(isFunction(fn)||isArray(fn)){return(/** @this */function(tElement,tAttrs){return $injector.invoke(fn,this,{$element:tElement,$attrs:tAttrs});});}else{return fn;}}var template=!options.template&&!options.templateUrl?'':options.template;var ddo={controller:controller,controllerAs:identifierForController(options.controller)||options.controllerAs||'$ctrl',template:makeInjectable(template),templateUrl:makeInjectable(options.templateUrl),transclude:options.transclude,scope:{},bindToController:options.bindings||{},restrict:'E',require:options.require};// Copy annotations (starting with $) over to the DDO
	forEach(options,function(val,key){if(key.charAt(0)==='$')ddo[key]=val;});return ddo;}// TODO(pete) remove the following `forEach` before we release 1.6.0
	// The component-router@0.2.0 looks for the annotations on the controller constructor
	// Nothing in AngularJS looks for annotations on the factory function but we can't remove
	// it from 1.5.x yet.
	// Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	// These could be used by libraries such as the new component router
	forEach(options,function(val,key){if(key.charAt(0)==='$'){factory[key]=val;// Don't try to copy over annotations to named controller
	if(isFunction(controller))controller[key]=val;}});factory.$inject=['$injector'];return this.directive(name,factory);};/**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */this.aHrefSanitizationWhitelist=function(regexp){if(isDefined(regexp)){$$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);return this;}else{return $$sanitizeUriProvider.aHrefSanitizationWhitelist();}};/**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */this.imgSrcSanitizationWhitelist=function(regexp){if(isDefined(regexp)){$$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);return this;}else{return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();}};/**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */var debugInfoEnabled=true;this.debugInfoEnabled=function(enabled){if(isDefined(enabled)){debugInfoEnabled=enabled;return this;}return debugInfoEnabled;};/**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is false.
	   *
	   * @deprecated
	   * sinceVersion="1.6.0"
	   * removeVersion="1.7.0"
	   *
	   * This method and the option to assign the bindings before calling the controller's constructor
	   * will be removed in v1.7.0.
	   */var preAssignBindingsEnabled=false;this.preAssignBindingsEnabled=function(enabled){if(isDefined(enabled)){preAssignBindingsEnabled=enabled;return this;}return preAssignBindingsEnabled;};/**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided, otherwise just return the
	   * current strictComponentBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable strict component bindings check. If enabled, the compiler will enforce that
	   * for all bindings of a component that are not set as optional with `?`, an attribute needs to be provided
	   * on the component's HTML tag.
	   *
	   * The default value is false.
	   */var strictComponentBindingsEnabled=false;this.strictComponentBindingsEnabled=function(enabled){if(isDefined(enabled)){strictComponentBindingsEnabled=enabled;return this;}return strictComponentBindingsEnabled;};var TTL=10;/**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */this.onChangesTtl=function(value){if(arguments.length){TTL=value;return this;}return TTL;};var commentDirectivesEnabledConfig=true;/**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */this.commentDirectivesEnabled=function(value){if(arguments.length){commentDirectivesEnabledConfig=value;return this;}return commentDirectivesEnabledConfig;};var cssClassDirectivesEnabledConfig=true;/**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */this.cssClassDirectivesEnabled=function(value){if(arguments.length){cssClassDirectivesEnabledConfig=value;return this;}return cssClassDirectivesEnabledConfig;};this.$get=['$injector','$interpolate','$exceptionHandler','$templateRequest','$parse','$controller','$rootScope','$sce','$animate','$$sanitizeUri',function($injector,$interpolate,$exceptionHandler,$templateRequest,$parse,$controller,$rootScope,$sce,$animate,$$sanitizeUri){var SIMPLE_ATTR_NAME=/^\w/;var specialAttrHolder=window.document.createElement('div');var commentDirectivesEnabled=commentDirectivesEnabledConfig;var cssClassDirectivesEnabled=cssClassDirectivesEnabledConfig;var onChangesTtl=TTL;// The onChanges hooks should all be run together in a single digest
	// When changes occur, the call to trigger their hooks will be added to this queue
	var onChangesQueue;// This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	function flushOnChangesQueue(){try{if(! --onChangesTtl){// We have hit the TTL limit so reset everything
	onChangesQueue=undefined;throw $compileMinErr('infchng','{0} $onChanges() iterations reached. Aborting!\n',TTL);}// We must run this hook in an apply since the $$postDigest runs outside apply
	$rootScope.$apply(function(){var errors=[];for(var i=0,ii=onChangesQueue.length;i<ii;++i){try{onChangesQueue[i]();}catch(e){errors.push(e);}}// Reset the queue to trigger a new schedule next time there is a change
	onChangesQueue=undefined;if(errors.length){throw errors;}});}finally{onChangesTtl++;}}function Attributes(element,attributesToCopy){if(attributesToCopy){var keys=Object.keys(attributesToCopy);var i,l,key;for(i=0,l=keys.length;i<l;i++){key=keys[i];this[key]=attributesToCopy[key];}}else{this.$attr={};}this.$$element=element;}Attributes.prototype={/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */$normalize:directiveNormalize,/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */$addClass:function $addClass(classVal){if(classVal&&classVal.length>0){$animate.addClass(this.$$element,classVal);}},/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */$removeClass:function $removeClass(classVal){if(classVal&&classVal.length>0){$animate.removeClass(this.$$element,classVal);}},/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */$updateClass:function $updateClass(newClasses,oldClasses){var toAdd=tokenDifference(newClasses,oldClasses);if(toAdd&&toAdd.length){$animate.addClass(this.$$element,toAdd);}var toRemove=tokenDifference(oldClasses,newClasses);if(toRemove&&toRemove.length){$animate.removeClass(this.$$element,toRemove);}},/**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */$set:function $set(key,value,writeAttr,attrName){// TODO: decide whether or not to throw an error if "class"
	//is set through this function since it may cause $updateClass to
	//become unstable.
	var node=this.$$element[0],booleanKey=getBooleanAttrName(node,key),aliasedKey=getAliasedAttrName(key),observer=key,nodeName;if(booleanKey){this.$$element.prop(key,value);attrName=booleanKey;}else if(aliasedKey){this[aliasedKey]=value;observer=aliasedKey;}this[key]=value;// translate normalized key to actual key
	if(attrName){this.$attr[key]=attrName;}else{attrName=this.$attr[key];if(!attrName){this.$attr[key]=attrName=snake_case(key,'-');}}nodeName=nodeName_(this.$$element);if(nodeName==='a'&&(key==='href'||key==='xlinkHref')||nodeName==='img'&&key==='src'){// sanitize a[href] and img[src] values
	this[key]=value=$$sanitizeUri(value,key==='src');}else if(nodeName==='img'&&key==='srcset'&&isDefined(value)){// sanitize img[srcset] values
	var result='';// first check if there are spaces because it's not the same pattern
	var trimmedSrcset=trim(value);//                (   999x   ,|   999w   ,|   ,|,   )
	var srcPattern=/(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;var pattern=/\s/.test(trimmedSrcset)?srcPattern:/(,)/;// split srcset into tuple of uri and descriptor except for the last item
	var rawUris=trimmedSrcset.split(pattern);// for each tuples
	var nbrUrisWith2parts=Math.floor(rawUris.length/2);for(var i=0;i<nbrUrisWith2parts;i++){var innerIdx=i*2;// sanitize the uri
	result+=$$sanitizeUri(trim(rawUris[innerIdx]),true);// add the descriptor
	result+=' '+trim(rawUris[innerIdx+1]);}// split the last item into uri and descriptor
	var lastTuple=trim(rawUris[i*2]).split(/\s/);// sanitize the last uri
	result+=$$sanitizeUri(trim(lastTuple[0]),true);// and add the last descriptor if any
	if(lastTuple.length===2){result+=' '+trim(lastTuple[1]);}this[key]=value=result;}if(writeAttr!==false){if(value===null||isUndefined(value)){this.$$element.removeAttr(attrName);}else{if(SIMPLE_ATTR_NAME.test(attrName)){this.$$element.attr(attrName,value);}else{setSpecialAttr(this.$$element[0],attrName,value);}}}// fire observers
	var $$observers=this.$$observers;if($$observers){forEach($$observers[observer],function(fn){try{fn(value);}catch(e){$exceptionHandler(e);}});}},/**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */$observe:function $observe(key,fn){var attrs=this,$$observers=attrs.$$observers||(attrs.$$observers=createMap()),listeners=$$observers[key]||($$observers[key]=[]);listeners.push(fn);$rootScope.$evalAsync(function(){if(!listeners.$$inter&&attrs.hasOwnProperty(key)&&!isUndefined(attrs[key])){// no one registered attribute interpolation function, so lets call it manually
	fn(attrs[key]);}});return function(){arrayRemove(listeners,fn);};}};function setSpecialAttr(element,attrName,value){// Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	// so we have to jump through some hoops to get such an attribute
	// https://github.com/angular/angular.js/pull/13318
	specialAttrHolder.innerHTML='<span '+attrName+'>';var attributes=specialAttrHolder.firstChild.attributes;var attribute=attributes[0];// We have to remove the attribute from its container element before we can add it to the destination element
	attributes.removeNamedItem(attribute.name);attribute.value=value;element.attributes.setNamedItem(attribute);}function safeAddClass($element,className){try{$element.addClass(className);}catch(e){// ignore, since it means that we are trying to set class on
	// SVG element, where class name is read-only.
	}}var startSymbol=$interpolate.startSymbol(),endSymbol=$interpolate.endSymbol(),denormalizeTemplate=startSymbol==='{{'&&endSymbol==='}}'?identity:function denormalizeTemplate(template){return template.replace(/\{\{/g,startSymbol).replace(/}}/g,endSymbol);},NG_ATTR_BINDING=/^ngAttr[A-Z]/;var MULTI_ELEMENT_DIR_RE=/^(.+)Start$/;compile.$$addBindingInfo=debugInfoEnabled?function $$addBindingInfo($element,binding){var bindings=$element.data('$binding')||[];if(isArray(binding)){bindings=bindings.concat(binding);}else{bindings.push(binding);}$element.data('$binding',bindings);}:noop;compile.$$addBindingClass=debugInfoEnabled?function $$addBindingClass($element){safeAddClass($element,'ng-binding');}:noop;compile.$$addScopeInfo=debugInfoEnabled?function $$addScopeInfo($element,scope,isolated,noTemplate){var dataName=isolated?noTemplate?'$isolateScopeNoTemplate':'$isolateScope':'$scope';$element.data(dataName,scope);}:noop;compile.$$addScopeClass=debugInfoEnabled?function $$addScopeClass($element,isolated){safeAddClass($element,isolated?'ng-isolate-scope':'ng-scope');}:noop;compile.$$createComment=function(directiveName,comment){var content='';if(debugInfoEnabled){content=' '+(directiveName||'')+': ';if(comment)content+=comment+' ';}return window.document.createComment(content);};return compile;//================================
	function compile($compileNodes,transcludeFn,maxPriority,ignoreDirective,previousCompileContext){if(!($compileNodes instanceof jqLite)){// jquery always rewraps, whereas we need to preserve the original selector so that we can
	// modify it.
	$compileNodes=jqLite($compileNodes);}var compositeLinkFn=compileNodes($compileNodes,transcludeFn,$compileNodes,maxPriority,ignoreDirective,previousCompileContext);compile.$$addScopeClass($compileNodes);var namespace=null;return function publicLinkFn(scope,cloneConnectFn,options){if(!$compileNodes){throw $compileMinErr('multilink','This element has already been linked.');}assertArg(scope,'scope');if(previousCompileContext&&previousCompileContext.needsNewScope){// A parent directive did a replace and a directive on this element asked
	// for transclusion, which caused us to lose a layer of element on which
	// we could hold the new transclusion scope, so we will create it manually
	// here.
	scope=scope.$parent.$new();}options=options||{};var parentBoundTranscludeFn=options.parentBoundTranscludeFn,transcludeControllers=options.transcludeControllers,futureParentElement=options.futureParentElement;// When `parentBoundTranscludeFn` is passed, it is a
	// `controllersBoundTransclude` function (it was previously passed
	// as `transclude` to directive.link) so we must unwrap it to get
	// its `boundTranscludeFn`
	if(parentBoundTranscludeFn&&parentBoundTranscludeFn.$$boundTransclude){parentBoundTranscludeFn=parentBoundTranscludeFn.$$boundTransclude;}if(!namespace){namespace=detectNamespaceForChildElements(futureParentElement);}var $linkNode;if(namespace!=='html'){// When using a directive with replace:true and templateUrl the $compileNodes
	// (or a child element inside of them)
	// might change, so we need to recreate the namespace adapted compileNodes
	// for call to the link function.
	// Note: This will already clone the nodes...
	$linkNode=jqLite(wrapTemplate(namespace,jqLite('<div>').append($compileNodes).html()));}else if(cloneConnectFn){// important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	// and sometimes changes the structure of the DOM.
	$linkNode=JQLitePrototype.clone.call($compileNodes);}else{$linkNode=$compileNodes;}if(transcludeControllers){for(var controllerName in transcludeControllers){$linkNode.data('$'+controllerName+'Controller',transcludeControllers[controllerName].instance);}}compile.$$addScopeInfo($linkNode,scope);if(cloneConnectFn)cloneConnectFn($linkNode,scope);if(compositeLinkFn)compositeLinkFn(scope,$linkNode,$linkNode,parentBoundTranscludeFn);if(!cloneConnectFn){$compileNodes=compositeLinkFn=null;}return $linkNode;};}function detectNamespaceForChildElements(parentElement){// TODO: Make this detect MathML as well...
	var node=parentElement&&parentElement[0];if(!node){return'html';}else{return nodeName_(node)!=='foreignobject'&&toString.call(node).match(/SVG/)?'svg':'html';}}/**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */function compileNodes(nodeList,transcludeFn,$rootElement,maxPriority,ignoreDirective,previousCompileContext){var linkFns=[],// `nodeList` can be either an element's `.childNodes` (live NodeList)
	// or a jqLite/jQuery collection or an array
	notLiveList=isArray(nodeList)||nodeList instanceof jqLite,attrs,directives,nodeLinkFn,childNodes,childLinkFn,linkFnFound,nodeLinkFnFound;for(var i=0;i<nodeList.length;i++){attrs=new Attributes();// Support: IE 11 only
	// Workaround for #11781 and #14924
	if(msie===11){mergeConsecutiveTextNodes(nodeList,i,notLiveList);}// We must always refer to `nodeList[i]` hereafter,
	// since the nodes can be replaced underneath us.
	directives=collectDirectives(nodeList[i],[],attrs,i===0?maxPriority:undefined,ignoreDirective);nodeLinkFn=directives.length?applyDirectivesToNode(directives,nodeList[i],attrs,transcludeFn,$rootElement,null,[],[],previousCompileContext):null;if(nodeLinkFn&&nodeLinkFn.scope){compile.$$addScopeClass(attrs.$$element);}childLinkFn=nodeLinkFn&&nodeLinkFn.terminal||!(childNodes=nodeList[i].childNodes)||!childNodes.length?null:compileNodes(childNodes,nodeLinkFn?(nodeLinkFn.transcludeOnThisElement||!nodeLinkFn.templateOnThisElement)&&nodeLinkFn.transclude:transcludeFn);if(nodeLinkFn||childLinkFn){linkFns.push(i,nodeLinkFn,childLinkFn);linkFnFound=true;nodeLinkFnFound=nodeLinkFnFound||nodeLinkFn;}//use the previous context only for the first element in the virtual group
	previousCompileContext=null;}// return a linking function if we have found anything, null otherwise
	return linkFnFound?compositeLinkFn:null;function compositeLinkFn(scope,nodeList,$rootElement,parentBoundTranscludeFn){var nodeLinkFn,childLinkFn,node,childScope,i,ii,idx,childBoundTranscludeFn;var stableNodeList;if(nodeLinkFnFound){// copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	// offsets don't get screwed up
	var nodeListLength=nodeList.length;stableNodeList=new Array(nodeListLength);// create a sparse array by only copying the elements which have a linkFn
	for(i=0;i<linkFns.length;i+=3){idx=linkFns[i];stableNodeList[idx]=nodeList[idx];}}else{stableNodeList=nodeList;}for(i=0,ii=linkFns.length;i<ii;){node=stableNodeList[linkFns[i++]];nodeLinkFn=linkFns[i++];childLinkFn=linkFns[i++];if(nodeLinkFn){if(nodeLinkFn.scope){childScope=scope.$new();compile.$$addScopeInfo(jqLite(node),childScope);}else{childScope=scope;}if(nodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn=createBoundTranscludeFn(scope,nodeLinkFn.transclude,parentBoundTranscludeFn);}else if(!nodeLinkFn.templateOnThisElement&&parentBoundTranscludeFn){childBoundTranscludeFn=parentBoundTranscludeFn;}else if(!parentBoundTranscludeFn&&transcludeFn){childBoundTranscludeFn=createBoundTranscludeFn(scope,transcludeFn);}else{childBoundTranscludeFn=null;}nodeLinkFn(childLinkFn,childScope,node,$rootElement,childBoundTranscludeFn);}else if(childLinkFn){childLinkFn(scope,node.childNodes,undefined,parentBoundTranscludeFn);}}}}function mergeConsecutiveTextNodes(nodeList,idx,notLiveList){var node=nodeList[idx];var parent=node.parentNode;var sibling;if(node.nodeType!==NODE_TYPE_TEXT){return;}while(true){sibling=parent?node.nextSibling:nodeList[idx+1];if(!sibling||sibling.nodeType!==NODE_TYPE_TEXT){break;}node.nodeValue=node.nodeValue+sibling.nodeValue;if(sibling.parentNode){sibling.parentNode.removeChild(sibling);}if(notLiveList&&sibling===nodeList[idx+1]){nodeList.splice(idx+1,1);}}}function createBoundTranscludeFn(scope,transcludeFn,previousBoundTranscludeFn){function boundTranscludeFn(transcludedScope,cloneFn,controllers,futureParentElement,containingScope){if(!transcludedScope){transcludedScope=scope.$new(false,containingScope);transcludedScope.$$transcluded=true;}return transcludeFn(transcludedScope,cloneFn,{parentBoundTranscludeFn:previousBoundTranscludeFn,transcludeControllers:controllers,futureParentElement:futureParentElement});}// We need  to attach the transclusion slots onto the `boundTranscludeFn`
	// so that they are available inside the `controllersBoundTransclude` function
	var boundSlots=boundTranscludeFn.$$slots=createMap();for(var slotName in transcludeFn.$$slots){if(transcludeFn.$$slots[slotName]){boundSlots[slotName]=createBoundTranscludeFn(scope,transcludeFn.$$slots[slotName],previousBoundTranscludeFn);}else{boundSlots[slotName]=null;}}return boundTranscludeFn;}/**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */function collectDirectives(node,directives,attrs,maxPriority,ignoreDirective){var nodeType=node.nodeType,attrsMap=attrs.$attr,match,nodeName,className;switch(nodeType){case NODE_TYPE_ELEMENT:/* Element */nodeName=nodeName_(node);// use the node name: <directive>
	addDirective(directives,directiveNormalize(nodeName),'E',maxPriority,ignoreDirective);// iterate over the attributes
	for(var attr,name,nName,ngAttrName,value,isNgAttr,nAttrs=node.attributes,j=0,jj=nAttrs&&nAttrs.length;j<jj;j++){var attrStartName=false;var attrEndName=false;attr=nAttrs[j];name=attr.name;value=attr.value;// support ngAttr attribute binding
	ngAttrName=directiveNormalize(name);isNgAttr=NG_ATTR_BINDING.test(ngAttrName);if(isNgAttr){name=name.replace(PREFIX_REGEXP,'').substr(8).replace(/_(.)/g,function(match,letter){return letter.toUpperCase();});}var multiElementMatch=ngAttrName.match(MULTI_ELEMENT_DIR_RE);if(multiElementMatch&&directiveIsMultiElement(multiElementMatch[1])){attrStartName=name;attrEndName=name.substr(0,name.length-5)+'end';name=name.substr(0,name.length-6);}nName=directiveNormalize(name.toLowerCase());attrsMap[nName]=name;if(isNgAttr||!attrs.hasOwnProperty(nName)){attrs[nName]=value;if(getBooleanAttrName(node,nName)){attrs[nName]=true;// presence means true
	}}addAttrInterpolateDirective(node,directives,value,nName,isNgAttr);addDirective(directives,nName,'A',maxPriority,ignoreDirective,attrStartName,attrEndName);}if(nodeName==='input'&&node.getAttribute('type')==='hidden'){// Hidden input elements can have strange behaviour when navigating back to the page
	// This tells the browser not to try to cache and reinstate previous values
	node.setAttribute('autocomplete','off');}// use class as directive
	if(!cssClassDirectivesEnabled)break;className=node.className;if(isObject(className)){// Maybe SVGAnimatedString
	className=className.animVal;}if(isString(className)&&className!==''){while(match=CLASS_DIRECTIVE_REGEXP.exec(className)){nName=directiveNormalize(match[2]);if(addDirective(directives,nName,'C',maxPriority,ignoreDirective)){attrs[nName]=trim(match[3]);}className=className.substr(match.index+match[0].length);}}break;case NODE_TYPE_TEXT:/* Text Node */addTextInterpolateDirective(directives,node.nodeValue);break;case NODE_TYPE_COMMENT:/* Comment */if(!commentDirectivesEnabled)break;collectCommentDirectives(node,directives,attrs,maxPriority,ignoreDirective);break;}directives.sort(byPriority);return directives;}function collectCommentDirectives(node,directives,attrs,maxPriority,ignoreDirective){// function created because of performance, try/catch disables
	// the optimization of the whole function #14848
	try{var match=COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);if(match){var nName=directiveNormalize(match[1]);if(addDirective(directives,nName,'M',maxPriority,ignoreDirective)){attrs[nName]=trim(match[2]);}}}catch(e){// turns out that under some circumstances IE9 throws errors when one attempts to read
	// comment's node value.
	// Just ignore it and continue. (Can't seem to reproduce in test case.)
	}}/**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */function groupScan(node,attrStart,attrEnd){var nodes=[];var depth=0;if(attrStart&&node.hasAttribute&&node.hasAttribute(attrStart)){do{if(!node){throw $compileMinErr('uterdir','Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',attrStart,attrEnd);}if(node.nodeType===NODE_TYPE_ELEMENT){if(node.hasAttribute(attrStart))depth++;if(node.hasAttribute(attrEnd))depth--;}nodes.push(node);node=node.nextSibling;}while(depth>0);}else{nodes.push(node);}return jqLite(nodes);}/**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */function groupElementsLinkFnWrapper(linkFn,attrStart,attrEnd){return function groupedElementsLink(scope,element,attrs,controllers,transcludeFn){element=groupScan(element[0],attrStart,attrEnd);return linkFn(scope,element,attrs,controllers,transcludeFn);};}/**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */function compilationGenerator(eager,$compileNodes,transcludeFn,maxPriority,ignoreDirective,previousCompileContext){var compiled;if(eager){return compile($compileNodes,transcludeFn,maxPriority,ignoreDirective,previousCompileContext);}return(/** @this */function lazyCompilation(){if(!compiled){compiled=compile($compileNodes,transcludeFn,maxPriority,ignoreDirective,previousCompileContext);// Null out all of these references in order to make them eligible for garbage collection
	// since this is a potentially long lived closure
	$compileNodes=transcludeFn=previousCompileContext=null;}return compiled.apply(this,arguments);});}/**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */function applyDirectivesToNode(directives,compileNode,templateAttrs,transcludeFn,jqCollection,originalReplaceDirective,preLinkFns,postLinkFns,previousCompileContext){previousCompileContext=previousCompileContext||{};var terminalPriority=-Number.MAX_VALUE,newScopeDirective=previousCompileContext.newScopeDirective,controllerDirectives=previousCompileContext.controllerDirectives,newIsolateScopeDirective=previousCompileContext.newIsolateScopeDirective,templateDirective=previousCompileContext.templateDirective,nonTlbTranscludeDirective=previousCompileContext.nonTlbTranscludeDirective,hasTranscludeDirective=false,hasTemplate=false,hasElementTranscludeDirective=previousCompileContext.hasElementTranscludeDirective,$compileNode=templateAttrs.$$element=jqLite(compileNode),directive,directiveName,$template,replaceDirective=originalReplaceDirective,childTranscludeFn=transcludeFn,linkFn,didScanForMultipleTransclusion=false,mightHaveMultipleTransclusionError=false,directiveValue;// executes all directives on the current element
	for(var i=0,ii=directives.length;i<ii;i++){directive=directives[i];var attrStart=directive.$$start;var attrEnd=directive.$$end;// collect multiblock sections
	if(attrStart){$compileNode=groupScan(compileNode,attrStart,attrEnd);}$template=undefined;if(terminalPriority>directive.priority){break;// prevent further processing of directives
	}directiveValue=directive.scope;if(directiveValue){// skip the check for directives with async templates, we'll check the derived sync
	// directive when the template arrives
	if(!directive.templateUrl){if(isObject(directiveValue)){// This directive is trying to add an isolated scope.
	// Check that there is no scope of any kind already
	assertNoDuplicate('new/isolated scope',newIsolateScopeDirective||newScopeDirective,directive,$compileNode);newIsolateScopeDirective=directive;}else{// This directive is trying to add a child scope.
	// Check that there is no isolated scope already
	assertNoDuplicate('new/isolated scope',newIsolateScopeDirective,directive,$compileNode);}}newScopeDirective=newScopeDirective||directive;}directiveName=directive.name;// If we encounter a condition that can result in transclusion on the directive,
	// then scan ahead in the remaining directives for others that may cause a multiple
	// transclusion error to be thrown during the compilation process.  If a matching directive
	// is found, then we know that when we encounter a transcluded directive, we need to eagerly
	// compile the `transclude` function rather than doing it lazily in order to throw
	// exceptions at the correct time
	if(!didScanForMultipleTransclusion&&(directive.replace&&(directive.templateUrl||directive.template)||directive.transclude&&!directive.$$tlb)){var candidateDirective;for(var scanningIndex=i+1;candidateDirective=directives[scanningIndex++];){if(candidateDirective.transclude&&!candidateDirective.$$tlb||candidateDirective.replace&&(candidateDirective.templateUrl||candidateDirective.template)){mightHaveMultipleTransclusionError=true;break;}}didScanForMultipleTransclusion=true;}if(!directive.templateUrl&&directive.controller){controllerDirectives=controllerDirectives||createMap();assertNoDuplicate('\''+directiveName+'\' controller',controllerDirectives[directiveName],directive,$compileNode);controllerDirectives[directiveName]=directive;}directiveValue=directive.transclude;if(directiveValue){hasTranscludeDirective=true;// Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	// This option should only be used by directives that know how to safely handle element transclusion,
	// where the transcluded nodes are added or replaced after linking.
	if(!directive.$$tlb){assertNoDuplicate('transclusion',nonTlbTranscludeDirective,directive,$compileNode);nonTlbTranscludeDirective=directive;}if(directiveValue==='element'){hasElementTranscludeDirective=true;terminalPriority=directive.priority;$template=$compileNode;$compileNode=templateAttrs.$$element=jqLite(compile.$$createComment(directiveName,templateAttrs[directiveName]));compileNode=$compileNode[0];replaceWith(jqCollection,sliceArgs($template),compileNode);// Support: Chrome < 50
	// https://github.com/angular/angular.js/issues/14041
	// In the versions of V8 prior to Chrome 50, the document fragment that is created
	// in the `replaceWith` function is improperly garbage collected despite still
	// being referenced by the `parentNode` property of all of the child nodes.  By adding
	// a reference to the fragment via a different property, we can avoid that incorrect
	// behavior.
	// TODO: remove this line after Chrome 50 has been released
	$template[0].$$parentNode=$template[0].parentNode;childTranscludeFn=compilationGenerator(mightHaveMultipleTransclusionError,$template,transcludeFn,terminalPriority,replaceDirective&&replaceDirective.name,{// Don't pass in:
	// - controllerDirectives - otherwise we'll create duplicates controllers
	// - newIsolateScopeDirective or templateDirective - combining templates with
	//   element transclusion doesn't make sense.
	//
	// We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	// on the same element more than once.
	nonTlbTranscludeDirective:nonTlbTranscludeDirective});}else{var slots=createMap();if(!isObject(directiveValue)){$template=jqLite(jqLiteClone(compileNode)).contents();}else{// We have transclusion slots,
	// collect them up, compile them and store their transclusion functions
	$template=[];var slotMap=createMap();var filledSlots=createMap();// Parse the element selectors
	forEach(directiveValue,function(elementSelector,slotName){// If an element selector starts with a ? then it is optional
	var optional=elementSelector.charAt(0)==='?';elementSelector=optional?elementSelector.substring(1):elementSelector;slotMap[elementSelector]=slotName;// We explicitly assign `null` since this implies that a slot was defined but not filled.
	// Later when calling boundTransclusion functions with a slot name we only error if the
	// slot is `undefined`
	slots[slotName]=null;// filledSlots contains `true` for all slots that are either optional or have been
	// filled. This is used to check that we have not missed any required slots
	filledSlots[slotName]=optional;});// Add the matching elements into their slot
	forEach($compileNode.contents(),function(node){var slotName=slotMap[directiveNormalize(nodeName_(node))];if(slotName){filledSlots[slotName]=true;slots[slotName]=slots[slotName]||[];slots[slotName].push(node);}else{$template.push(node);}});// Check for required slots that were not filled
	forEach(filledSlots,function(filled,slotName){if(!filled){throw $compileMinErr('reqslot','Required transclusion slot `{0}` was not filled.',slotName);}});for(var slotName in slots){if(slots[slotName]){// Only define a transclusion function if the slot was filled
	slots[slotName]=compilationGenerator(mightHaveMultipleTransclusionError,slots[slotName],transcludeFn);}}}$compileNode.empty();// clear contents
	childTranscludeFn=compilationGenerator(mightHaveMultipleTransclusionError,$template,transcludeFn,undefined,undefined,{needsNewScope:directive.$$isolateScope||directive.$$newScope});childTranscludeFn.$$slots=slots;}}if(directive.template){hasTemplate=true;assertNoDuplicate('template',templateDirective,directive,$compileNode);templateDirective=directive;directiveValue=isFunction(directive.template)?directive.template($compileNode,templateAttrs):directive.template;directiveValue=denormalizeTemplate(directiveValue);if(directive.replace){replaceDirective=directive;if(jqLiteIsTextNode(directiveValue)){$template=[];}else{$template=removeComments(wrapTemplate(directive.templateNamespace,trim(directiveValue)));}compileNode=$template[0];if($template.length!==1||compileNode.nodeType!==NODE_TYPE_ELEMENT){throw $compileMinErr('tplrt','Template for directive \'{0}\' must have exactly one root element. {1}',directiveName,'');}replaceWith(jqCollection,$compileNode,compileNode);var newTemplateAttrs={$attr:{}};// combine directives from the original node and from the template:
	// - take the array of directives for this element
	// - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	// - collect directives from the template and sort them by priority
	// - combine directives as: processed + template + unprocessed
	var templateDirectives=collectDirectives(compileNode,[],newTemplateAttrs);var unprocessedDirectives=directives.splice(i+1,directives.length-(i+1));if(newIsolateScopeDirective||newScopeDirective){// The original directive caused the current element to be replaced but this element
	// also needs to have a new scope, so we need to tell the template directives
	// that they would need to get their scope from further up, if they require transclusion
	markDirectiveScope(templateDirectives,newIsolateScopeDirective,newScopeDirective);}directives=directives.concat(templateDirectives).concat(unprocessedDirectives);mergeTemplateAttributes(templateAttrs,newTemplateAttrs);ii=directives.length;}else{$compileNode.html(directiveValue);}}if(directive.templateUrl){hasTemplate=true;assertNoDuplicate('template',templateDirective,directive,$compileNode);templateDirective=directive;if(directive.replace){replaceDirective=directive;}// eslint-disable-next-line no-func-assign
	nodeLinkFn=compileTemplateUrl(directives.splice(i,directives.length-i),$compileNode,templateAttrs,jqCollection,hasTranscludeDirective&&childTranscludeFn,preLinkFns,postLinkFns,{controllerDirectives:controllerDirectives,newScopeDirective:newScopeDirective!==directive&&newScopeDirective,newIsolateScopeDirective:newIsolateScopeDirective,templateDirective:templateDirective,nonTlbTranscludeDirective:nonTlbTranscludeDirective});ii=directives.length;}else if(directive.compile){try{linkFn=directive.compile($compileNode,templateAttrs,childTranscludeFn);var context=directive.$$originalDirective||directive;if(isFunction(linkFn)){addLinkFns(null,bind(context,linkFn),attrStart,attrEnd);}else if(linkFn){addLinkFns(bind(context,linkFn.pre),bind(context,linkFn.post),attrStart,attrEnd);}}catch(e){$exceptionHandler(e,startingTag($compileNode));}}if(directive.terminal){nodeLinkFn.terminal=true;terminalPriority=Math.max(terminalPriority,directive.priority);}}nodeLinkFn.scope=newScopeDirective&&newScopeDirective.scope===true;nodeLinkFn.transcludeOnThisElement=hasTranscludeDirective;nodeLinkFn.templateOnThisElement=hasTemplate;nodeLinkFn.transclude=childTranscludeFn;previousCompileContext.hasElementTranscludeDirective=hasElementTranscludeDirective;// might be normal or delayed nodeLinkFn depending on if templateUrl is present
	return nodeLinkFn;////////////////////
	function addLinkFns(pre,post,attrStart,attrEnd){if(pre){if(attrStart)pre=groupElementsLinkFnWrapper(pre,attrStart,attrEnd);pre.require=directive.require;pre.directiveName=directiveName;if(newIsolateScopeDirective===directive||directive.$$isolateScope){pre=cloneAndAnnotateFn(pre,{isolateScope:true});}preLinkFns.push(pre);}if(post){if(attrStart)post=groupElementsLinkFnWrapper(post,attrStart,attrEnd);post.require=directive.require;post.directiveName=directiveName;if(newIsolateScopeDirective===directive||directive.$$isolateScope){post=cloneAndAnnotateFn(post,{isolateScope:true});}postLinkFns.push(post);}}function nodeLinkFn(childLinkFn,scope,linkNode,$rootElement,boundTranscludeFn){var i,ii,linkFn,isolateScope,controllerScope,elementControllers,transcludeFn,$element,attrs,scopeBindingInfo;if(compileNode===linkNode){attrs=templateAttrs;$element=templateAttrs.$$element;}else{$element=jqLite(linkNode);attrs=new Attributes($element,templateAttrs);}controllerScope=scope;if(newIsolateScopeDirective){isolateScope=scope.$new(true);}else if(newScopeDirective){controllerScope=scope.$parent;}if(boundTranscludeFn){// track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	// is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	transcludeFn=controllersBoundTransclude;transcludeFn.$$boundTransclude=boundTranscludeFn;// expose the slots on the `$transclude` function
	transcludeFn.isSlotFilled=function(slotName){return!!boundTranscludeFn.$$slots[slotName];};}if(controllerDirectives){elementControllers=setupControllers($element,attrs,transcludeFn,controllerDirectives,isolateScope,scope,newIsolateScopeDirective);}if(newIsolateScopeDirective){// Initialize isolate scope bindings for new isolate scope directive.
	compile.$$addScopeInfo($element,isolateScope,true,!(templateDirective&&(templateDirective===newIsolateScopeDirective||templateDirective===newIsolateScopeDirective.$$originalDirective)));compile.$$addScopeClass($element,true);isolateScope.$$isolateBindings=newIsolateScopeDirective.$$isolateBindings;scopeBindingInfo=initializeDirectiveBindings(scope,attrs,isolateScope,isolateScope.$$isolateBindings,newIsolateScopeDirective);if(scopeBindingInfo.removeWatches){isolateScope.$on('$destroy',scopeBindingInfo.removeWatches);}}// Initialize bindToController bindings
	for(var name in elementControllers){var controllerDirective=controllerDirectives[name];var controller=elementControllers[name];var bindings=controllerDirective.$$bindings.bindToController;if(preAssignBindingsEnabled){if(bindings){controller.bindingInfo=initializeDirectiveBindings(controllerScope,attrs,controller.instance,bindings,controllerDirective);}else{controller.bindingInfo={};}var controllerResult=controller();if(controllerResult!==controller.instance){// If the controller constructor has a return value, overwrite the instance
	// from setupControllers
	controller.instance=controllerResult;$element.data('$'+controllerDirective.name+'Controller',controllerResult);if(controller.bindingInfo.removeWatches){controller.bindingInfo.removeWatches();}controller.bindingInfo=initializeDirectiveBindings(controllerScope,attrs,controller.instance,bindings,controllerDirective);}}else{controller.instance=controller();$element.data('$'+controllerDirective.name+'Controller',controller.instance);controller.bindingInfo=initializeDirectiveBindings(controllerScope,attrs,controller.instance,bindings,controllerDirective);}}// Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	forEach(controllerDirectives,function(controllerDirective,name){var require=controllerDirective.require;if(controllerDirective.bindToController&&!isArray(require)&&isObject(require)){extend(elementControllers[name].instance,getControllers(name,require,$element,elementControllers));}});// Handle the init and destroy lifecycle hooks on all controllers that have them
	forEach(elementControllers,function(controller){var controllerInstance=controller.instance;if(isFunction(controllerInstance.$onChanges)){try{controllerInstance.$onChanges(controller.bindingInfo.initialChanges);}catch(e){$exceptionHandler(e);}}if(isFunction(controllerInstance.$onInit)){try{controllerInstance.$onInit();}catch(e){$exceptionHandler(e);}}if(isFunction(controllerInstance.$doCheck)){controllerScope.$watch(function(){controllerInstance.$doCheck();});controllerInstance.$doCheck();}if(isFunction(controllerInstance.$onDestroy)){controllerScope.$on('$destroy',function callOnDestroyHook(){controllerInstance.$onDestroy();});}});// PRELINKING
	for(i=0,ii=preLinkFns.length;i<ii;i++){linkFn=preLinkFns[i];invokeLinkFn(linkFn,linkFn.isolateScope?isolateScope:scope,$element,attrs,linkFn.require&&getControllers(linkFn.directiveName,linkFn.require,$element,elementControllers),transcludeFn);}// RECURSION
	// We only pass the isolate scope, if the isolate directive has a template,
	// otherwise the child elements do not belong to the isolate directive.
	var scopeToChild=scope;if(newIsolateScopeDirective&&(newIsolateScopeDirective.template||newIsolateScopeDirective.templateUrl===null)){scopeToChild=isolateScope;}if(childLinkFn){childLinkFn(scopeToChild,linkNode.childNodes,undefined,boundTranscludeFn);}// POSTLINKING
	for(i=postLinkFns.length-1;i>=0;i--){linkFn=postLinkFns[i];invokeLinkFn(linkFn,linkFn.isolateScope?isolateScope:scope,$element,attrs,linkFn.require&&getControllers(linkFn.directiveName,linkFn.require,$element,elementControllers),transcludeFn);}// Trigger $postLink lifecycle hooks
	forEach(elementControllers,function(controller){var controllerInstance=controller.instance;if(isFunction(controllerInstance.$postLink)){controllerInstance.$postLink();}});// This is the function that is injected as `$transclude`.
	// Note: all arguments are optional!
	function controllersBoundTransclude(scope,cloneAttachFn,futureParentElement,slotName){var transcludeControllers;// No scope passed in:
	if(!isScope(scope)){slotName=futureParentElement;futureParentElement=cloneAttachFn;cloneAttachFn=scope;scope=undefined;}if(hasElementTranscludeDirective){transcludeControllers=elementControllers;}if(!futureParentElement){futureParentElement=hasElementTranscludeDirective?$element.parent():$element;}if(slotName){// slotTranscludeFn can be one of three things:
	//  * a transclude function - a filled slot
	//  * `null` - an optional slot that was not filled
	//  * `undefined` - a slot that was not declared (i.e. invalid)
	var slotTranscludeFn=boundTranscludeFn.$$slots[slotName];if(slotTranscludeFn){return slotTranscludeFn(scope,cloneAttachFn,transcludeControllers,futureParentElement,scopeToChild);}else if(isUndefined(slotTranscludeFn)){throw $compileMinErr('noslot','No parent directive that requires a transclusion with slot name "{0}". '+'Element: {1}',slotName,startingTag($element));}}else{return boundTranscludeFn(scope,cloneAttachFn,transcludeControllers,futureParentElement,scopeToChild);}}}}function getControllers(directiveName,require,$element,elementControllers){var value;if(isString(require)){var match=require.match(REQUIRE_PREFIX_REGEXP);var name=require.substring(match[0].length);var inheritType=match[1]||match[3];var optional=match[2]==='?';//If only parents then start at the parent element
	if(inheritType==='^^'){$element=$element.parent();//Otherwise attempt getting the controller from elementControllers in case
	//the element is transcluded (and has no data) and to avoid .data if possible
	}else{value=elementControllers&&elementControllers[name];value=value&&value.instance;}if(!value){var dataName='$'+name+'Controller';value=inheritType?$element.inheritedData(dataName):$element.data(dataName);}if(!value&&!optional){throw $compileMinErr('ctreq','Controller \'{0}\', required by directive \'{1}\', can\'t be found!',name,directiveName);}}else if(isArray(require)){value=[];for(var i=0,ii=require.length;i<ii;i++){value[i]=getControllers(directiveName,require[i],$element,elementControllers);}}else if(isObject(require)){value={};forEach(require,function(controller,property){value[property]=getControllers(directiveName,controller,$element,elementControllers);});}return value||null;}function setupControllers($element,attrs,transcludeFn,controllerDirectives,isolateScope,scope,newIsolateScopeDirective){var elementControllers=createMap();for(var controllerKey in controllerDirectives){var directive=controllerDirectives[controllerKey];var locals={$scope:directive===newIsolateScopeDirective||directive.$$isolateScope?isolateScope:scope,$element:$element,$attrs:attrs,$transclude:transcludeFn};var controller=directive.controller;if(controller==='@'){controller=attrs[directive.name];}var controllerInstance=$controller(controller,locals,true,directive.controllerAs);// For directives with element transclusion the element is a comment.
	// In this case .data will not attach any data.
	// Instead, we save the controllers for the element in a local hash and attach to .data
	// later, once we have the actual element.
	elementControllers[directive.name]=controllerInstance;$element.data('$'+directive.name+'Controller',controllerInstance.instance);}return elementControllers;}// Depending upon the context in which a directive finds itself it might need to have a new isolated
	// or child scope created. For instance:
	// * if the directive has been pulled into a template because another directive with a higher priority
	// asked for element transclusion
	// * if the directive itself asks for transclusion but it is at the root of a template and the original
	// element was replaced. See https://github.com/angular/angular.js/issues/12936
	function markDirectiveScope(directives,isolateScope,newScope){for(var j=0,jj=directives.length;j<jj;j++){directives[j]=inherit(directives[j],{$$isolateScope:isolateScope,$$newScope:newScope});}}/**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */function addDirective(tDirectives,name,location,maxPriority,ignoreDirective,startAttrName,endAttrName){if(name===ignoreDirective)return null;var match=null;if(hasDirectives.hasOwnProperty(name)){for(var directive,directives=$injector.get(name+Suffix),i=0,ii=directives.length;i<ii;i++){directive=directives[i];if((isUndefined(maxPriority)||maxPriority>directive.priority)&&directive.restrict.indexOf(location)!==-1){if(startAttrName){directive=inherit(directive,{$$start:startAttrName,$$end:endAttrName});}if(!directive.$$bindings){var bindings=directive.$$bindings=parseDirectiveBindings(directive,directive.name);if(isObject(bindings.isolateScope)){directive.$$isolateBindings=bindings.isolateScope;}}tDirectives.push(directive);match=directive;}}}return match;}/**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */function directiveIsMultiElement(name){if(hasDirectives.hasOwnProperty(name)){for(var directive,directives=$injector.get(name+Suffix),i=0,ii=directives.length;i<ii;i++){directive=directives[i];if(directive.multiElement){return true;}}}return false;}/**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */function mergeTemplateAttributes(dst,src){var srcAttr=src.$attr,dstAttr=dst.$attr;// reapply the old attributes to the new element
	forEach(dst,function(value,key){if(key.charAt(0)!=='$'){if(src[key]&&src[key]!==value){if(value.length){value+=(key==='style'?';':' ')+src[key];}else{value=src[key];}}dst.$set(key,value,true,srcAttr[key]);}});// copy the new attributes on the old attrs object
	forEach(src,function(value,key){// Check if we already set this attribute in the loop above.
	// `dst` will never contain hasOwnProperty as DOM parser won't let it.
	// You will get an "InvalidCharacterError: DOM Exception 5" error if you
	// have an attribute like "has-own-property" or "data-has-own-property", etc.
	if(!dst.hasOwnProperty(key)&&key.charAt(0)!=='$'){dst[key]=value;if(key!=='class'&&key!=='style'){dstAttr[key]=srcAttr[key];}}});}function compileTemplateUrl(directives,$compileNode,tAttrs,$rootElement,childTranscludeFn,preLinkFns,postLinkFns,previousCompileContext){var linkQueue=[],afterTemplateNodeLinkFn,afterTemplateChildLinkFn,beforeTemplateCompileNode=$compileNode[0],origAsyncDirective=directives.shift(),derivedSyncDirective=inherit(origAsyncDirective,{templateUrl:null,transclude:null,replace:null,$$originalDirective:origAsyncDirective}),templateUrl=isFunction(origAsyncDirective.templateUrl)?origAsyncDirective.templateUrl($compileNode,tAttrs):origAsyncDirective.templateUrl,templateNamespace=origAsyncDirective.templateNamespace;$compileNode.empty();$templateRequest(templateUrl).then(function(content){var compileNode,tempTemplateAttrs,$template,childBoundTranscludeFn;content=denormalizeTemplate(content);if(origAsyncDirective.replace){if(jqLiteIsTextNode(content)){$template=[];}else{$template=removeComments(wrapTemplate(templateNamespace,trim(content)));}compileNode=$template[0];if($template.length!==1||compileNode.nodeType!==NODE_TYPE_ELEMENT){throw $compileMinErr('tplrt','Template for directive \'{0}\' must have exactly one root element. {1}',origAsyncDirective.name,templateUrl);}tempTemplateAttrs={$attr:{}};replaceWith($rootElement,$compileNode,compileNode);var templateDirectives=collectDirectives(compileNode,[],tempTemplateAttrs);if(isObject(origAsyncDirective.scope)){// the original directive that caused the template to be loaded async required
	// an isolate scope
	markDirectiveScope(templateDirectives,true);}directives=templateDirectives.concat(directives);mergeTemplateAttributes(tAttrs,tempTemplateAttrs);}else{compileNode=beforeTemplateCompileNode;$compileNode.html(content);}directives.unshift(derivedSyncDirective);afterTemplateNodeLinkFn=applyDirectivesToNode(directives,compileNode,tAttrs,childTranscludeFn,$compileNode,origAsyncDirective,preLinkFns,postLinkFns,previousCompileContext);forEach($rootElement,function(node,i){if(node===compileNode){$rootElement[i]=$compileNode[0];}});afterTemplateChildLinkFn=compileNodes($compileNode[0].childNodes,childTranscludeFn);while(linkQueue.length){var scope=linkQueue.shift(),beforeTemplateLinkNode=linkQueue.shift(),linkRootElement=linkQueue.shift(),boundTranscludeFn=linkQueue.shift(),linkNode=$compileNode[0];if(scope.$$destroyed)continue;if(beforeTemplateLinkNode!==beforeTemplateCompileNode){var oldClasses=beforeTemplateLinkNode.className;if(!(previousCompileContext.hasElementTranscludeDirective&&origAsyncDirective.replace)){// it was cloned therefore we have to clone as well.
	linkNode=jqLiteClone(compileNode);}replaceWith(linkRootElement,jqLite(beforeTemplateLinkNode),linkNode);// Copy in CSS classes from original node
	safeAddClass(jqLite(linkNode),oldClasses);}if(afterTemplateNodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn=createBoundTranscludeFn(scope,afterTemplateNodeLinkFn.transclude,boundTranscludeFn);}else{childBoundTranscludeFn=boundTranscludeFn;}afterTemplateNodeLinkFn(afterTemplateChildLinkFn,scope,linkNode,$rootElement,childBoundTranscludeFn);}linkQueue=null;}).catch(function(error){if(isError(error)){$exceptionHandler(error);}});return function delayedNodeLinkFn(ignoreChildLinkFn,scope,node,rootElement,boundTranscludeFn){var childBoundTranscludeFn=boundTranscludeFn;if(scope.$$destroyed)return;if(linkQueue){linkQueue.push(scope,node,rootElement,childBoundTranscludeFn);}else{if(afterTemplateNodeLinkFn.transcludeOnThisElement){childBoundTranscludeFn=createBoundTranscludeFn(scope,afterTemplateNodeLinkFn.transclude,boundTranscludeFn);}afterTemplateNodeLinkFn(afterTemplateChildLinkFn,scope,node,rootElement,childBoundTranscludeFn);}};}/**
	     * Sorting function for bound directives.
	     */function byPriority(a,b){var diff=b.priority-a.priority;if(diff!==0)return diff;if(a.name!==b.name)return a.name<b.name?-1:1;return a.index-b.index;}function assertNoDuplicate(what,previousDirective,directive,element){function wrapModuleNameIfDefined(moduleName){return moduleName?' (module: '+moduleName+')':'';}if(previousDirective){throw $compileMinErr('multidir','Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',previousDirective.name,wrapModuleNameIfDefined(previousDirective.$$moduleName),directive.name,wrapModuleNameIfDefined(directive.$$moduleName),what,startingTag(element));}}function addTextInterpolateDirective(directives,text){var interpolateFn=$interpolate(text,true);if(interpolateFn){directives.push({priority:0,compile:function textInterpolateCompileFn(templateNode){var templateNodeParent=templateNode.parent(),hasCompileParent=!!templateNodeParent.length;// When transcluding a template that has bindings in the root
	// we don't have a parent and thus need to add the class during linking fn.
	if(hasCompileParent)compile.$$addBindingClass(templateNodeParent);return function textInterpolateLinkFn(scope,node){var parent=node.parent();if(!hasCompileParent)compile.$$addBindingClass(parent);compile.$$addBindingInfo(parent,interpolateFn.expressions);scope.$watch(interpolateFn,function interpolateFnWatchAction(value){node[0].nodeValue=value;});};}});}}function wrapTemplate(type,template){type=lowercase(type||'html');switch(type){case'svg':case'math':var wrapper=window.document.createElement('div');wrapper.innerHTML='<'+type+'>'+template+'</'+type+'>';return wrapper.childNodes[0].childNodes;default:return template;}}function getTrustedContext(node,attrNormalizedName){if(attrNormalizedName==='srcdoc'){return $sce.HTML;}var tag=nodeName_(node);// All tags with src attributes require a RESOURCE_URL value, except for
	// img and various html5 media tags.
	if(attrNormalizedName==='src'||attrNormalizedName==='ngSrc'){if(['img','video','audio','source','track'].indexOf(tag)===-1){return $sce.RESOURCE_URL;}// maction[xlink:href] can source SVG.  It's not limited to <maction>.
	}else if(attrNormalizedName==='xlinkHref'||tag==='form'&&attrNormalizedName==='action'||// links can be stylesheets or imports, which can run script in the current origin
	tag==='link'&&attrNormalizedName==='href'){return $sce.RESOURCE_URL;}}function addAttrInterpolateDirective(node,directives,value,name,isNgAttr){var trustedContext=getTrustedContext(node,name);var mustHaveExpression=!isNgAttr;var allOrNothing=ALL_OR_NOTHING_ATTRS[name]||isNgAttr;var interpolateFn=$interpolate(value,mustHaveExpression,trustedContext,allOrNothing);// no interpolation found -> ignore
	if(!interpolateFn)return;if(name==='multiple'&&nodeName_(node)==='select'){throw $compileMinErr('selmulti','Binding to the \'multiple\' attribute is not supported. Element: {0}',startingTag(node));}if(EVENT_HANDLER_ATTR_REGEXP.test(name)){throw $compileMinErr('nodomevents','Interpolations for HTML DOM event attributes are disallowed.  Please use the '+'ng- versions (such as ng-click instead of onclick) instead.');}directives.push({priority:100,compile:function compile(){return{pre:function attrInterpolatePreLinkFn(scope,element,attr){var $$observers=attr.$$observers||(attr.$$observers=createMap());// If the attribute has changed since last $interpolate()ed
	var newValue=attr[name];if(newValue!==value){// we need to interpolate again since the attribute value has been updated
	// (e.g. by another directive's compile function)
	// ensure unset/empty values make interpolateFn falsy
	interpolateFn=newValue&&$interpolate(newValue,true,trustedContext,allOrNothing);value=newValue;}// if attribute was updated so that there is no interpolation going on we don't want to
	// register any observers
	if(!interpolateFn)return;// initialize attr object so that it's ready in case we need the value for isolate
	// scope initialization, otherwise the value would not be available from isolate
	// directive's linking fn during linking phase
	attr[name]=interpolateFn(scope);($$observers[name]||($$observers[name]=[])).$$inter=true;(attr.$$observers&&attr.$$observers[name].$$scope||scope).$watch(interpolateFn,function interpolateFnWatchAction(newValue,oldValue){//special case for class attribute addition + removal
	//so that class changes can tap into the animation
	//hooks provided by the $animate service. Be sure to
	//skip animations when the first digest occurs (when
	//both the new and the old values are the same) since
	//the CSS classes are the non-interpolated values
	if(name==='class'&&newValue!==oldValue){attr.$updateClass(newValue,oldValue);}else{attr.$set(name,newValue);}});}};}});}/**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */function replaceWith($rootElement,elementsToRemove,newNode){var firstElementToRemove=elementsToRemove[0],removeCount=elementsToRemove.length,parent=firstElementToRemove.parentNode,i,ii;if($rootElement){for(i=0,ii=$rootElement.length;i<ii;i++){if($rootElement[i]===firstElementToRemove){$rootElement[i++]=newNode;for(var j=i,j2=j+removeCount-1,jj=$rootElement.length;j<jj;j++,j2++){if(j2<jj){$rootElement[j]=$rootElement[j2];}else{delete $rootElement[j];}}$rootElement.length-=removeCount-1;// If the replaced element is also the jQuery .context then replace it
	// .context is a deprecated jQuery api, so we should set it only when jQuery set it
	// http://api.jquery.com/context/
	if($rootElement.context===firstElementToRemove){$rootElement.context=newNode;}break;}}}if(parent){parent.replaceChild(newNode,firstElementToRemove);}// Append all the `elementsToRemove` to a fragment. This will...
	// - remove them from the DOM
	// - allow them to still be traversed with .nextSibling
	// - allow a single fragment.qSA to fetch all elements being removed
	var fragment=window.document.createDocumentFragment();for(i=0;i<removeCount;i++){fragment.appendChild(elementsToRemove[i]);}if(jqLite.hasData(firstElementToRemove)){// Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	// data here because there's no public interface in jQuery to do that and copying over
	// event listeners (which is the main use of private data) wouldn't work anyway.
	jqLite.data(newNode,jqLite.data(firstElementToRemove));// Remove $destroy event listeners from `firstElementToRemove`
	jqLite(firstElementToRemove).off('$destroy');}// Cleanup any data/listeners on the elements and children.
	// This includes invoking the $destroy event on any elements with listeners.
	jqLite.cleanData(fragment.querySelectorAll('*'));// Update the jqLite collection to only contain the `newNode`
	for(i=1;i<removeCount;i++){delete elementsToRemove[i];}elementsToRemove[0]=newNode;elementsToRemove.length=1;}function cloneAndAnnotateFn(fn,annotation){return extend(function(){return fn.apply(null,arguments);},fn,annotation);}function invokeLinkFn(linkFn,scope,$element,attrs,controllers,transcludeFn){try{linkFn(scope,$element,attrs,controllers,transcludeFn);}catch(e){$exceptionHandler(e,startingTag($element));}}function strictBindingsCheck(attrName,directiveName){if(strictComponentBindingsEnabled){throw $compileMinErr('missingattr','Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',attrName,directiveName);}}// Set up $watches for isolate scope and controller bindings.
	function initializeDirectiveBindings(scope,attrs,destination,bindings,directive){var removeWatchCollection=[];var initialChanges={};var changes;forEach(bindings,function initializeBinding(definition,scopeName){var attrName=definition.attrName,optional=definition.optional,mode=definition.mode,// @, =, <, or &
	lastValue,parentGet,parentSet,compare,removeWatch;switch(mode){case'@':if(!optional&&!hasOwnProperty.call(attrs,attrName)){strictBindingsCheck(attrName,directive.name);destination[scopeName]=attrs[attrName]=undefined;}removeWatch=attrs.$observe(attrName,function(value){if(isString(value)||isBoolean(value)){var oldValue=destination[scopeName];recordChanges(scopeName,value,oldValue);destination[scopeName]=value;}});attrs.$$observers[attrName].$$scope=scope;lastValue=attrs[attrName];if(isString(lastValue)){// If the attribute has been provided then we trigger an interpolation to ensure
	// the value is there for use in the link fn
	destination[scopeName]=$interpolate(lastValue)(scope);}else if(isBoolean(lastValue)){// If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	// the value to boolean rather than a string, so we special case this situation
	destination[scopeName]=lastValue;}initialChanges[scopeName]=new SimpleChange(_UNINITIALIZED_VALUE,destination[scopeName]);removeWatchCollection.push(removeWatch);break;case'=':if(!hasOwnProperty.call(attrs,attrName)){if(optional)break;strictBindingsCheck(attrName,directive.name);attrs[attrName]=undefined;}if(optional&&!attrs[attrName])break;parentGet=$parse(attrs[attrName]);if(parentGet.literal){compare=equals;}else{compare=simpleCompare;}parentSet=parentGet.assign||function(){// reset the change, or we will throw this exception on every $digest
	lastValue=destination[scopeName]=parentGet(scope);throw $compileMinErr('nonassign','Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',attrs[attrName],attrName,directive.name);};lastValue=destination[scopeName]=parentGet(scope);var parentValueWatch=function parentValueWatch(parentValue){if(!compare(parentValue,destination[scopeName])){// we are out of sync and need to copy
	if(!compare(parentValue,lastValue)){// parent changed and it has precedence
	destination[scopeName]=parentValue;}else{// if the parent can be assigned then do so
	parentSet(scope,parentValue=destination[scopeName]);}}lastValue=parentValue;return lastValue;};parentValueWatch.$stateful=true;if(definition.collection){removeWatch=scope.$watchCollection(attrs[attrName],parentValueWatch);}else{removeWatch=scope.$watch($parse(attrs[attrName],parentValueWatch),null,parentGet.literal);}removeWatchCollection.push(removeWatch);break;case'<':if(!hasOwnProperty.call(attrs,attrName)){if(optional)break;strictBindingsCheck(attrName,directive.name);attrs[attrName]=undefined;}if(optional&&!attrs[attrName])break;parentGet=$parse(attrs[attrName]);var deepWatch=parentGet.literal;var initialValue=destination[scopeName]=parentGet(scope);initialChanges[scopeName]=new SimpleChange(_UNINITIALIZED_VALUE,destination[scopeName]);removeWatch=scope.$watch(parentGet,function parentValueWatchAction(newValue,oldValue){if(oldValue===newValue){if(oldValue===initialValue||deepWatch&&equals(oldValue,initialValue)){return;}oldValue=initialValue;}recordChanges(scopeName,newValue,oldValue);destination[scopeName]=newValue;},deepWatch);removeWatchCollection.push(removeWatch);break;case'&':if(!optional&&!hasOwnProperty.call(attrs,attrName)){strictBindingsCheck(attrName,directive.name);}// Don't assign Object.prototype method to scope
	parentGet=attrs.hasOwnProperty(attrName)?$parse(attrs[attrName]):noop;// Don't assign noop to destination if expression is not valid
	if(parentGet===noop&&optional)break;destination[scopeName]=function(locals){return parentGet(scope,locals);};break;}});function recordChanges(key,currentValue,previousValue){if(isFunction(destination.$onChanges)&&!simpleCompare(currentValue,previousValue)){// If we have not already scheduled the top level onChangesQueue handler then do so now
	if(!onChangesQueue){scope.$$postDigest(flushOnChangesQueue);onChangesQueue=[];}// If we have not already queued a trigger of onChanges for this controller then do so now
	if(!changes){changes={};onChangesQueue.push(triggerOnChangesHook);}// If the has been a change on this property already then we need to reuse the previous value
	if(changes[key]){previousValue=changes[key].previousValue;}// Store this change
	changes[key]=new SimpleChange(previousValue,currentValue);}}function triggerOnChangesHook(){destination.$onChanges(changes);// Now clear the changes so that we schedule onChanges when more changes arrive
	changes=undefined;}return{initialChanges:initialChanges,removeWatches:removeWatchCollection.length&&function removeWatches(){for(var i=0,ii=removeWatchCollection.length;i<ii;++i){removeWatchCollection[i]();}}};}}];}function SimpleChange(previous,current){this.previousValue=previous;this.currentValue=current;}SimpleChange.prototype.isFirstChange=function(){return this.previousValue===_UNINITIALIZED_VALUE;};var PREFIX_REGEXP=/^((?:x|data)[:\-_])/i;var SPECIAL_CHARS_REGEXP=/[:\-_]+(.)/g;/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */function directiveNormalize(name){return name.replace(PREFIX_REGEXP,'').replace(SPECIAL_CHARS_REGEXP,function(_,letter,offset){return offset?letter.toUpperCase():letter;});}/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 *//**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 *//**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 *//**
	 * Closure compiler type information
	 */function nodesetLinkingFn(/* angular.Scope */scope,/* NodeList */nodeList,/* Element */rootElement,/* function(Function) */boundTranscludeFn){}function directiveLinkingFn(/* nodesetLinkingFn */nodesetLinkingFn,/* angular.Scope */scope,/* Node */node,/* Element */rootElement,/* function(Function) */boundTranscludeFn){}function tokenDifference(str1,str2){var values='',tokens1=str1.split(/\s+/),tokens2=str2.split(/\s+/);outer:for(var i=0;i<tokens1.length;i++){var token=tokens1[i];for(var j=0;j<tokens2.length;j++){if(token===tokens2[j])continue outer;}values+=(values.length>0?' ':'')+token;}return values;}function removeComments(jqNodes){jqNodes=jqLite(jqNodes);var i=jqNodes.length;if(i<=1){return jqNodes;}while(i--){var node=jqNodes[i];if(node.nodeType===NODE_TYPE_COMMENT||node.nodeType===NODE_TYPE_TEXT&&node.nodeValue.trim()===''){splice.call(jqNodes,i,1);}}return jqNodes;}var $controllerMinErr=minErr('$controller');var CNTRL_REG=/^(\S+)(\s+as\s+([\w$]+))?$/;function identifierForController(controller,ident){if(ident&&isString(ident))return ident;if(isString(controller)){var match=CNTRL_REG.exec(controller);if(match)return match[3];}}/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */function $ControllerProvider(){var controllers={},globals=false;/**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */this.has=function(name){return controllers.hasOwnProperty(name);};/**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */this.register=function(name,constructor){assertNotHasOwnProperty(name,'controller');if(isObject(name)){extend(controllers,name);}else{controllers[name]=constructor;}};/**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */this.allowGlobals=function(){globals=true;};this.$get=['$injector','$window',function($injector,$window){/**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */return function $controller(expression,locals,later,ident){// PRIVATE API:
	//   param `later` --- indicates that the controller's constructor is invoked at a later time.
	//                     If true, $controller will allocate the object with the correct
	//                     prototype chain, but will not invoke the controller until a returned
	//                     callback is invoked.
	//   param `ident` --- An optional label which overrides the label parsed from the controller
	//                     expression, if any.
	var instance,match,constructor,identifier;later=later===true;if(ident&&isString(ident)){identifier=ident;}if(isString(expression)){match=expression.match(CNTRL_REG);if(!match){throw $controllerMinErr('ctrlfmt','Badly formed controller string \'{0}\'. '+'Must match `__name__ as __id__` or `__name__`.',expression);}constructor=match[1];identifier=identifier||match[3];expression=controllers.hasOwnProperty(constructor)?controllers[constructor]:getter(locals.$scope,constructor,true)||(globals?getter($window,constructor,true):undefined);if(!expression){throw $controllerMinErr('ctrlreg','The controller with the name \'{0}\' is not registered.',constructor);}assertArgFn(expression,constructor,true);}if(later){// Instantiate controller later:
	// This machinery is used to create an instance of the object before calling the
	// controller's constructor itself.
	//
	// This allows properties to be added to the controller before the constructor is
	// invoked. Primarily, this is used for isolate scope bindings in $compile.
	//
	// This feature is not intended for use by applications, and is thus not documented
	// publicly.
	// Object creation: http://jsperf.com/create-constructor/2
	var controllerPrototype=(isArray(expression)?expression[expression.length-1]:expression).prototype;instance=Object.create(controllerPrototype||null);if(identifier){addIdentifier(locals,identifier,instance,constructor||expression.name);}return extend(function $controllerInit(){var result=$injector.invoke(expression,instance,locals,constructor);if(result!==instance&&(isObject(result)||isFunction(result))){instance=result;if(identifier){// If result changed, re-assign controllerAs value to scope.
	addIdentifier(locals,identifier,instance,constructor||expression.name);}}return instance;},{instance:instance,identifier:identifier});}instance=$injector.instantiate(expression,locals,constructor);if(identifier){addIdentifier(locals,identifier,instance,constructor||expression.name);}return instance;};function addIdentifier(locals,identifier,instance,name){if(!(locals&&isObject(locals.$scope))){throw minErr('$controller')('noscp','Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',name,identifier);}locals.$scope[identifier]=instance;}}];}/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */function $DocumentProvider(){this.$get=['$window',function(window){return jqLite(window.document);}];}/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */function $$IsDocumentHiddenProvider(){this.$get=['$document','$rootScope',function($document,$rootScope){var doc=$document[0];var hidden=doc&&doc.hidden;$document.on('visibilitychange',changeListener);$rootScope.$on('$destroy',function(){$document.off('visibilitychange',changeListener);});function changeListener(){hidden=doc.hidden;}return function(){return hidden;};}];}/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */function $ExceptionHandlerProvider(){this.$get=['$log',function($log){return function(exception,cause){$log.error.apply($log,arguments);};}];}var $$ForceReflowProvider=/** @this */function $$ForceReflowProvider(){this.$get=['$document',function($document){return function(domNode){//the line below will force the browser to perform a repaint so
	//that all the animated elements within the animation frame will
	//be properly updated and drawn on screen. This is required to
	//ensure that the preparation animation is properly flushed so that
	//the active state picks up from there. DO NOT REMOVE THIS LINE.
	//DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	//WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	//WILL TAKE YEARS AWAY FROM YOUR LIFE.
	if(domNode){if(!domNode.nodeType&&domNode instanceof jqLite){domNode=domNode[0];}}else{domNode=$document[0].body;}return domNode.offsetWidth+1;};}];};var APPLICATION_JSON='application/json';var CONTENT_TYPE_APPLICATION_JSON={'Content-Type':APPLICATION_JSON+';charset=utf-8'};var JSON_START=/^\[|^\{(?!\{)/;var JSON_ENDS={'[':/]$/,'{':/}$/};var JSON_PROTECTION_PREFIX=/^\)]\}',?\n/;var $httpMinErr=minErr('$http');function serializeValue(v){if(isObject(v)){return isDate(v)?v.toISOString():toJson(v);}return v;}/** @this */function $HttpParamSerializerProvider(){/**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */this.$get=function(){return function ngParamSerializer(params){if(!params)return'';var parts=[];forEachSorted(params,function(value,key){if(value===null||isUndefined(value)||isFunction(value))return;if(isArray(value)){forEach(value,function(v){parts.push(encodeUriQuery(key)+'='+encodeUriQuery(serializeValue(v)));});}else{parts.push(encodeUriQuery(key)+'='+encodeUriQuery(serializeValue(value)));}});return parts.join('&');};};}/** @this */function $HttpParamSerializerJQLikeProvider(){/**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */this.$get=function(){return function jQueryLikeParamSerializer(params){if(!params)return'';var parts=[];serialize(params,'',true);return parts.join('&');function serialize(toSerialize,prefix,topLevel){if(toSerialize===null||isUndefined(toSerialize))return;if(isArray(toSerialize)){forEach(toSerialize,function(value,index){serialize(value,prefix+'['+(isObject(value)?index:'')+']');});}else if(isObject(toSerialize)&&!isDate(toSerialize)){forEachSorted(toSerialize,function(value,key){serialize(value,prefix+(topLevel?'':'[')+key+(topLevel?'':']'));});}else{parts.push(encodeUriQuery(prefix)+'='+encodeUriQuery(serializeValue(toSerialize)));}}};};}function defaultHttpResponseTransform(data,headers){if(isString(data)){// Strip json vulnerability protection prefix and trim whitespace
	var tempData=data.replace(JSON_PROTECTION_PREFIX,'').trim();if(tempData){var contentType=headers('Content-Type');var hasJsonContentType=contentType&&contentType.indexOf(APPLICATION_JSON)===0;if(hasJsonContentType||isJsonLike(tempData)){try{data=fromJson(tempData);}catch(e){if(!hasJsonContentType){return data;}throw $httpMinErr('baddata','Data must be a valid JSON object. Received: "{0}". '+'Parse error: "{1}"',data,e);}}}}return data;}function isJsonLike(str){var jsonStart=str.match(JSON_START);return jsonStart&&JSON_ENDS[jsonStart[0]].test(str);}/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */function parseHeaders(headers){var parsed=createMap(),i;function fillInParsed(key,val){if(key){parsed[key]=parsed[key]?parsed[key]+', '+val:val;}}if(isString(headers)){forEach(headers.split('\n'),function(line){i=line.indexOf(':');fillInParsed(lowercase(trim(line.substr(0,i))),trim(line.substr(i+1)));});}else if(isObject(headers)){forEach(headers,function(headerVal,headerKey){fillInParsed(lowercase(headerKey),trim(headerVal));});}return parsed;}/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */function headersGetter(headers){var headersObj;return function(name){if(!headersObj)headersObj=parseHeaders(headers);if(name){var value=headersObj[lowercase(name)];if(value===undefined){value=null;}return value;}return headersObj;};}/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */function transformData(data,headers,status,fns){if(isFunction(fns)){return fns(data,headers,status);}forEach(fns,function(fn){data=fn(data,headers,status);});return data;}function isSuccess(status){return 200<=status&&status<300;}/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */function $HttpProvider(){/**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   **/var defaults=this.defaults={// transform incoming response data
	transformResponse:[defaultHttpResponseTransform],// transform outgoing request data
	transformRequest:[function(d){return isObject(d)&&!isFile(d)&&!isBlob(d)&&!isFormData(d)?toJson(d):d;}],// default headers
	headers:{common:{'Accept':'application/json, text/plain, */*'},post:shallowCopy(CONTENT_TYPE_APPLICATION_JSON),put:shallowCopy(CONTENT_TYPE_APPLICATION_JSON),patch:shallowCopy(CONTENT_TYPE_APPLICATION_JSON)},xsrfCookieName:'XSRF-TOKEN',xsrfHeaderName:'X-XSRF-TOKEN',paramSerializer:'$httpParamSerializer',jsonpCallbackParam:'callback'};var useApplyAsync=false;/**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/this.useApplyAsync=function(value){if(isDefined(value)){useApplyAsync=!!value;return this;}return useApplyAsync;};/**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/var interceptorFactories=this.interceptors=[];this.$get=['$browser','$httpBackend','$$cookieReader','$cacheFactory','$rootScope','$q','$injector','$sce',function($browser,$httpBackend,$$cookieReader,$cacheFactory,$rootScope,$q,$injector,$sce){var defaultCache=$cacheFactory('$http');/**
	     * Make sure that default param serializer is exposed as a function
	     */defaults.paramSerializer=isString(defaults.paramSerializer)?$injector.get(defaults.paramSerializer):defaults.paramSerializer;/**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */var reversedInterceptors=[];forEach(interceptorFactories,function(interceptorFactory){reversedInterceptors.unshift(isString(interceptorFactory)?$injector.get(interceptorFactory):$injector.invoke(interceptorFactory));});/**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest (`complete`, `error`, `timeout` or `abort`).
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */function $http(requestConfig){if(!isObject(requestConfig)){throw minErr('$http')('badreq','Http request configuration must be an object.  Received: {0}',requestConfig);}if(!isString($sce.valueOf(requestConfig.url))){throw minErr('$http')('badreq','Http request configuration url must be a string or a $sce trusted object.  Received: {0}',requestConfig.url);}var config=extend({method:'get',transformRequest:defaults.transformRequest,transformResponse:defaults.transformResponse,paramSerializer:defaults.paramSerializer,jsonpCallbackParam:defaults.jsonpCallbackParam},requestConfig);config.headers=mergeHeaders(requestConfig);config.method=uppercase(config.method);config.paramSerializer=isString(config.paramSerializer)?$injector.get(config.paramSerializer):config.paramSerializer;$browser.$$incOutstandingRequestCount();var requestInterceptors=[];var responseInterceptors=[];var promise=$q.resolve(config);// apply interceptors
	forEach(reversedInterceptors,function(interceptor){if(interceptor.request||interceptor.requestError){requestInterceptors.unshift(interceptor.request,interceptor.requestError);}if(interceptor.response||interceptor.responseError){responseInterceptors.push(interceptor.response,interceptor.responseError);}});promise=chainInterceptors(promise,requestInterceptors);promise=promise.then(serverRequest);promise=chainInterceptors(promise,responseInterceptors);promise=promise.finally(completeOutstandingRequest);return promise;function chainInterceptors(promise,interceptors){for(var i=0,ii=interceptors.length;i<ii;){var thenFn=interceptors[i++];var rejectFn=interceptors[i++];promise=promise.then(thenFn,rejectFn);}interceptors.length=0;return promise;}function completeOutstandingRequest(){$browser.$$completeOutstandingRequest(noop);}function executeHeaderFns(headers,config){var headerContent,processedHeaders={};forEach(headers,function(headerFn,header){if(isFunction(headerFn)){headerContent=headerFn(config);if(headerContent!=null){processedHeaders[header]=headerContent;}}else{processedHeaders[header]=headerFn;}});return processedHeaders;}function mergeHeaders(config){var defHeaders=defaults.headers,reqHeaders=extend({},config.headers),defHeaderName,lowercaseDefHeaderName,reqHeaderName;defHeaders=extend({},defHeaders.common,defHeaders[lowercase(config.method)]);// using for-in instead of forEach to avoid unnecessary iteration after header has been found
	defaultHeadersIteration:for(defHeaderName in defHeaders){lowercaseDefHeaderName=lowercase(defHeaderName);for(reqHeaderName in reqHeaders){if(lowercase(reqHeaderName)===lowercaseDefHeaderName){continue defaultHeadersIteration;}}reqHeaders[defHeaderName]=defHeaders[defHeaderName];}// execute if header value is a function for merged headers
	return executeHeaderFns(reqHeaders,shallowCopy(config));}function serverRequest(config){var headers=config.headers;var reqData=transformData(config.data,headersGetter(headers),undefined,config.transformRequest);// strip content-type if data is undefined
	if(isUndefined(reqData)){forEach(headers,function(value,header){if(lowercase(header)==='content-type'){delete headers[header];}});}if(isUndefined(config.withCredentials)&&!isUndefined(defaults.withCredentials)){config.withCredentials=defaults.withCredentials;}// send request
	return sendReq(config,reqData).then(transformResponse,transformResponse);}function transformResponse(response){// make a copy since the response must be cacheable
	var resp=extend({},response);resp.data=transformData(response.data,response.headers,response.status,config.transformResponse);return isSuccess(response.status)?resp:$q.reject(resp);}}$http.pendingRequests=[];/**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     *//**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     *//**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     *//**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */createShortMethods('get','delete','head','jsonp');/**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     *//**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     *//**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	      * @returns {HttpPromise} Future object
	      */createShortMethodsWithData('post','put','patch');/**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */$http.defaults=defaults;return $http;function createShortMethods(names){forEach(arguments,function(name){$http[name]=function(url,config){return $http(extend({},config||{},{method:name,url:url}));};});}function createShortMethodsWithData(name){forEach(arguments,function(name){$http[name]=function(url,data,config){return $http(extend({},config||{},{method:name,url:url,data:data}));};});}/**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */function sendReq(config,reqData){var deferred=$q.defer(),promise=deferred.promise,cache,cachedResp,reqHeaders=config.headers,isJsonp=lowercase(config.method)==='jsonp',url=config.url;if(isJsonp){// JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	// our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	url=$sce.getTrustedResourceUrl(url);}else if(!isString(url)){// If it is not a string then the URL must be a $sce trusted object
	url=$sce.valueOf(url);}url=buildUrl(url,config.paramSerializer(config.params));if(isJsonp){// Check the url and add the JSONP callback placeholder
	url=sanitizeJsonpCallbackParam(url,config.jsonpCallbackParam);}$http.pendingRequests.push(config);promise.then(removePendingReq,removePendingReq);if((config.cache||defaults.cache)&&config.cache!==false&&(config.method==='GET'||config.method==='JSONP')){cache=isObject(config.cache)?config.cache:isObject(/** @type {?} */defaults.cache)?/** @type {?} */defaults.cache:defaultCache;}if(cache){cachedResp=cache.get(url);if(isDefined(cachedResp)){if(isPromiseLike(cachedResp)){// cached request has already been sent, but there is no response yet
	cachedResp.then(resolvePromiseWithResult,resolvePromiseWithResult);}else{// serving from cache
	if(isArray(cachedResp)){resolvePromise(cachedResp[1],cachedResp[0],shallowCopy(cachedResp[2]),cachedResp[3],cachedResp[4]);}else{resolvePromise(cachedResp,200,{},'OK','complete');}}}else{// put the promise for the non-transformed response into cache as a placeholder
	cache.put(url,promise);}}// if we won't have the response in cache, set the xsrf headers and
	// send the request to the backend
	if(isUndefined(cachedResp)){var xsrfValue=urlIsSameOrigin(config.url)?$$cookieReader()[config.xsrfCookieName||defaults.xsrfCookieName]:undefined;if(xsrfValue){reqHeaders[config.xsrfHeaderName||defaults.xsrfHeaderName]=xsrfValue;}$httpBackend(config.method,url,reqData,done,reqHeaders,config.timeout,config.withCredentials,config.responseType,createApplyHandlers(config.eventHandlers),createApplyHandlers(config.uploadEventHandlers));}return promise;function createApplyHandlers(eventHandlers){if(eventHandlers){var applyHandlers={};forEach(eventHandlers,function(eventHandler,key){applyHandlers[key]=function(event){if(useApplyAsync){$rootScope.$applyAsync(callEventHandler);}else if($rootScope.$$phase){callEventHandler();}else{$rootScope.$apply(callEventHandler);}function callEventHandler(){eventHandler(event);}};});return applyHandlers;}}/**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */function done(status,response,headersString,statusText,xhrStatus){if(cache){if(isSuccess(status)){cache.put(url,[status,response,parseHeaders(headersString),statusText,xhrStatus]);}else{// remove promise from the cache
	cache.remove(url);}}function resolveHttpPromise(){resolvePromise(response,status,headersString,statusText,xhrStatus);}if(useApplyAsync){$rootScope.$applyAsync(resolveHttpPromise);}else{resolveHttpPromise();if(!$rootScope.$$phase)$rootScope.$apply();}}/**
	       * Resolves the raw $http promise.
	       */function resolvePromise(response,status,headers,statusText,xhrStatus){//status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	status=status>=-1?status:0;(isSuccess(status)?deferred.resolve:deferred.reject)({data:response,status:status,headers:headersGetter(headers),config:config,statusText:statusText,xhrStatus:xhrStatus});}function resolvePromiseWithResult(result){resolvePromise(result.data,result.status,shallowCopy(result.headers()),result.statusText,result.xhrStatus);}function removePendingReq(){var idx=$http.pendingRequests.indexOf(config);if(idx!==-1)$http.pendingRequests.splice(idx,1);}}function buildUrl(url,serializedParams){if(serializedParams.length>0){url+=(url.indexOf('?')===-1?'?':'&')+serializedParams;}return url;}function sanitizeJsonpCallbackParam(url,cbKey){var parts=url.split('?');if(parts.length>2){// Throw if the url contains more than one `?` query indicator
	throw $httpMinErr('badjsonp','Illegal use more than one "?", in url, "{1}"',url);}var params=parseKeyValue(parts[1]);forEach(params,function(value,key){if(value==='JSON_CALLBACK'){// Throw if the url already contains a reference to JSON_CALLBACK
	throw $httpMinErr('badjsonp','Illegal use of JSON_CALLBACK in url, "{0}"',url);}if(key===cbKey){// Throw if the callback param was already provided
	throw $httpMinErr('badjsonp','Illegal use of callback param, "{0}", in url, "{1}"',cbKey,url);}});// Add in the JSON_CALLBACK callback param value
	url+=(url.indexOf('?')===-1?'?':'&')+cbKey+'=JSON_CALLBACK';return url;}}];}/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */function $xhrFactoryProvider(){this.$get=function(){return function createXhr(){return new window.XMLHttpRequest();};};}/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */function $HttpBackendProvider(){this.$get=['$browser','$jsonpCallbacks','$document','$xhrFactory',function($browser,$jsonpCallbacks,$document,$xhrFactory){return createHttpBackend($browser,$xhrFactory,$browser.defer,$jsonpCallbacks,$document[0]);}];}function createHttpBackend($browser,createXhr,$browserDefer,callbacks,rawDocument){// TODO(vojta): fix the signature
	return function(method,url,post,callback,headers,timeout,withCredentials,responseType,eventHandlers,uploadEventHandlers){url=url||$browser.url();if(lowercase(method)==='jsonp'){var callbackPath=callbacks.createCallback(url);var jsonpDone=jsonpReq(url,callbackPath,function(status,text){// jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	var response=status===200&&callbacks.getResponse(callbackPath);completeRequest(callback,status,response,'',text,'complete');callbacks.removeCallback(callbackPath);});}else{var xhr=createXhr(method,url);xhr.open(method,url,true);forEach(headers,function(value,key){if(isDefined(value)){xhr.setRequestHeader(key,value);}});xhr.onload=function requestLoaded(){var statusText=xhr.statusText||'';// responseText is the old-school way of retrieving response (supported by IE9)
	// response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	var response='response'in xhr?xhr.response:xhr.responseText;// normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	var status=xhr.status===1223?204:xhr.status;// fix status code when it is 0 (0 status is undocumented).
	// Occurs when accessing file resources or on Android 4.1 stock browser
	// while retrieving files from application cache.
	if(status===0){status=response?200:urlResolve(url).protocol==='file'?404:0;}completeRequest(callback,status,response,xhr.getAllResponseHeaders(),statusText,'complete');};var requestError=function requestError(){// The response is always empty
	// See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	completeRequest(callback,-1,null,null,'','error');};var requestAborted=function requestAborted(){completeRequest(callback,-1,null,null,'','abort');};var requestTimeout=function requestTimeout(){// The response is always empty
	// See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	completeRequest(callback,-1,null,null,'','timeout');};xhr.onerror=requestError;xhr.onabort=requestAborted;xhr.ontimeout=requestTimeout;forEach(eventHandlers,function(value,key){xhr.addEventListener(key,value);});forEach(uploadEventHandlers,function(value,key){xhr.upload.addEventListener(key,value);});if(withCredentials){xhr.withCredentials=true;}if(responseType){try{xhr.responseType=responseType;}catch(e){// WebKit added support for the json responseType value on 09/03/2013
	// https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	// known to throw when setting the value "json" as the response type. Other older
	// browsers implementing the responseType
	//
	// The json response type can be ignored if not supported, because JSON payloads are
	// parsed on the client-side regardless.
	if(responseType!=='json'){throw e;}}}xhr.send(isUndefined(post)?null:post);}if(timeout>0){var timeoutId=$browserDefer(timeoutRequest,timeout);}else if(isPromiseLike(timeout)){timeout.then(timeoutRequest);}function timeoutRequest(){if(jsonpDone){jsonpDone();}if(xhr){xhr.abort();}}function completeRequest(callback,status,response,headersString,statusText,xhrStatus){// cancel timeout and subsequent timeout promise resolution
	if(isDefined(timeoutId)){$browserDefer.cancel(timeoutId);}jsonpDone=xhr=null;callback(status,response,headersString,statusText,xhrStatus);}};function jsonpReq(url,callbackPath,done){url=url.replace('JSON_CALLBACK',callbackPath);// we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	// - fetches local scripts via XHR and evals them
	// - adds and immediately removes script elements from the document
	var script=rawDocument.createElement('script'),_callback=null;script.type='text/javascript';script.src=url;script.async=true;_callback=function callback(event){script.removeEventListener('load',_callback);script.removeEventListener('error',_callback);rawDocument.body.removeChild(script);script=null;var status=-1;var text='unknown';if(event){if(event.type==='load'&&!callbacks.wasCalled(callbackPath)){event={type:'error'};}text=event.type;status=event.type==='error'?404:200;}if(done){done(status,text);}};script.addEventListener('load',_callback);script.addEventListener('error',_callback);rawDocument.body.appendChild(script);return _callback;}}var $interpolateMinErr=angular.$interpolateMinErr=minErr('$interpolate');$interpolateMinErr.throwNoconcat=function(text){throw $interpolateMinErr('noconcat','Error while interpolating: {0}\nStrict Contextual Escaping disallows '+'interpolations that concatenate multiple expressions when a trusted value is '+'required.  See http://docs.angularjs.org/api/ng.$sce',text);};$interpolateMinErr.interr=function(text,err){return $interpolateMinErr('interr','Can\'t interpolate: {0}\n{1}',text,err.toString());};/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */function $InterpolateProvider(){var startSymbol='{{';var endSymbol='}}';/**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */this.startSymbol=function(value){if(value){startSymbol=value;return this;}else{return startSymbol;}};/**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */this.endSymbol=function(value){if(value){endSymbol=value;return this;}else{return endSymbol;}};this.$get=['$parse','$exceptionHandler','$sce',function($parse,$exceptionHandler,$sce){var startSymbolLength=startSymbol.length,endSymbolLength=endSymbol.length,escapedStartRegexp=new RegExp(startSymbol.replace(/./g,escape),'g'),escapedEndRegexp=new RegExp(endSymbol.replace(/./g,escape),'g');function escape(ch){return'\\\\\\'+ch;}function unescapeText(text){return text.replace(escapedStartRegexp,startSymbol).replace(escapedEndRegexp,endSymbol);}// TODO: this is the same as the constantWatchDelegate in parse.js
	function constantWatchDelegate(scope,listener,objectEquality,constantInterp){var unwatch=scope.$watch(function constantInterpolateWatch(scope){unwatch();return constantInterp(scope);},listener,objectEquality);return unwatch;}/**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */function $interpolate(text,mustHaveExpression,trustedContext,allOrNothing){// Provide a quick exit and simplified result function for text with no interpolation
	if(!text.length||text.indexOf(startSymbol)===-1){var constantInterp;if(!mustHaveExpression){var unescapedText=unescapeText(text);constantInterp=valueFn(unescapedText);constantInterp.exp=text;constantInterp.expressions=[];constantInterp.$$watchDelegate=constantWatchDelegate;}return constantInterp;}allOrNothing=!!allOrNothing;var startIndex,endIndex,index=0,expressions=[],parseFns=[],textLength=text.length,exp,concat=[],expressionPositions=[];while(index<textLength){if((startIndex=text.indexOf(startSymbol,index))!==-1&&(endIndex=text.indexOf(endSymbol,startIndex+startSymbolLength))!==-1){if(index!==startIndex){concat.push(unescapeText(text.substring(index,startIndex)));}exp=text.substring(startIndex+startSymbolLength,endIndex);expressions.push(exp);parseFns.push($parse(exp,parseStringifyInterceptor));index=endIndex+endSymbolLength;expressionPositions.push(concat.length);concat.push('');}else{// we did not find an interpolation, so we have to add the remainder to the separators array
	if(index!==textLength){concat.push(unescapeText(text.substring(index)));}break;}}// Concatenating expressions makes it hard to reason about whether some combination of
	// concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	// single expression be used for iframe[src], object[src], etc., we ensure that the value
	// that's used is assigned or constructed by some JS code somewhere that is more testable or
	// make it obvious that you bound the value to some user controlled value.  This helps reduce
	// the load when auditing for XSS issues.
	if(trustedContext&&concat.length>1){$interpolateMinErr.throwNoconcat(text);}if(!mustHaveExpression||expressions.length){var compute=function compute(values){for(var i=0,ii=expressions.length;i<ii;i++){if(allOrNothing&&isUndefined(values[i]))return;concat[expressionPositions[i]]=values[i];}return concat.join('');};var getValue=function getValue(value){return trustedContext?$sce.getTrusted(trustedContext,value):$sce.valueOf(value);};return extend(function interpolationFn(context){var i=0;var ii=expressions.length;var values=new Array(ii);try{for(;i<ii;i++){values[i]=parseFns[i](context);}return compute(values);}catch(err){$exceptionHandler($interpolateMinErr.interr(text,err));}},{// all of these properties are undocumented for now
	exp:text,//just for compatibility with regular watchers created via $watch
	expressions:expressions,$$watchDelegate:function $$watchDelegate(scope,listener){var lastValue;return scope.$watchGroup(parseFns,/** @this */function interpolateFnWatcher(values,oldValues){var currValue=compute(values);listener.call(this,currValue,values!==oldValues?lastValue:currValue,scope);lastValue=currValue;});}});}function parseStringifyInterceptor(value){try{value=getValue(value);return allOrNothing&&!isDefined(value)?value:stringify(value);}catch(err){$exceptionHandler($interpolateMinErr.interr(text,err));}}}/**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */$interpolate.startSymbol=function(){return startSymbol;};/**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */$interpolate.endSymbol=function(){return endSymbol;};return $interpolate;}];}/** @this */function $IntervalProvider(){this.$get=['$rootScope','$window','$q','$$q','$browser',function($rootScope,$window,$q,$$q,$browser){var intervals={};/**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */function interval(fn,delay,count,invokeApply){var hasParams=arguments.length>4,args=hasParams?sliceArgs(arguments,4):[],setInterval=$window.setInterval,clearInterval=$window.clearInterval,iteration=0,skipApply=isDefined(invokeApply)&&!invokeApply,deferred=(skipApply?$$q:$q).defer(),promise=deferred.promise;count=isDefined(count)?count:0;promise.$$intervalId=setInterval(function tick(){if(skipApply){$browser.defer(callback);}else{$rootScope.$evalAsync(callback);}deferred.notify(iteration++);if(count>0&&iteration>=count){deferred.resolve(iteration);clearInterval(promise.$$intervalId);delete intervals[promise.$$intervalId];}if(!skipApply)$rootScope.$apply();},delay);intervals[promise.$$intervalId]=deferred;return promise;function callback(){if(!hasParams){fn(iteration);}else{fn.apply(null,args);}}}/**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */interval.cancel=function(promise){if(promise&&promise.$$intervalId in intervals){// Interval cancels should not report as unhandled promise.
	markQExceptionHandled(intervals[promise.$$intervalId].promise);intervals[promise.$$intervalId].reject('canceled');$window.clearInterval(promise.$$intervalId);delete intervals[promise.$$intervalId];return true;}return false;};return interval;}];}/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */var $jsonpCallbacksProvider=/** @this */function $jsonpCallbacksProvider(){this.$get=function(){var callbacks=angular.callbacks;var callbackMap={};function _createCallback(callbackId){var callback=function callback(data){callback.data=data;callback.called=true;};callback.id=callbackId;return callback;}return{/**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */createCallback:function createCallback(url){var callbackId='_'+(callbacks.$$counter++).toString(36);var callbackPath='angular.callbacks.'+callbackId;var callback=_createCallback(callbackId);callbackMap[callbackPath]=callbacks[callbackId]=callback;return callbackPath;},/**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */wasCalled:function wasCalled(callbackPath){return callbackMap[callbackPath].called;},/**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */getResponse:function getResponse(callbackPath){return callbackMap[callbackPath].data;},/**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */removeCallback:function removeCallback(callbackPath){var callback=callbackMap[callbackPath];delete callbacks[callback.id];delete callbackMap[callbackPath];}};};};/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */var PATH_MATCH=/^([^?#]*)(\?([^#]*))?(#(.*))?$/,DEFAULT_PORTS={'http':80,'https':443,'ftp':21};var $locationMinErr=minErr('$location');/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */function encodePath(path){var segments=path.split('/'),i=segments.length;while(i--){// decode forward slashes to prevent them from being double encoded
	segments[i]=encodeUriSegment(segments[i].replace(/%2F/g,'/'));}return segments.join('/');}function decodePath(path,html5Mode){var segments=path.split('/'),i=segments.length;while(i--){segments[i]=decodeURIComponent(segments[i]);if(html5Mode){// encode forward slashes to prevent them from being mistaken for path separators
	segments[i]=segments[i].replace(/\//g,'%2F');}}return segments.join('/');}function parseAbsoluteUrl(absoluteUrl,locationObj){var parsedUrl=urlResolve(absoluteUrl);locationObj.$$protocol=parsedUrl.protocol;locationObj.$$host=parsedUrl.hostname;locationObj.$$port=toInt(parsedUrl.port)||DEFAULT_PORTS[parsedUrl.protocol]||null;}var DOUBLE_SLASH_REGEX=/^\s*[\\/]{2,}/;function parseAppUrl(url,locationObj,html5Mode){if(DOUBLE_SLASH_REGEX.test(url)){throw $locationMinErr('badpath','Invalid url "{0}".',url);}var prefixed=url.charAt(0)!=='/';if(prefixed){url='/'+url;}var match=urlResolve(url);var path=prefixed&&match.pathname.charAt(0)==='/'?match.pathname.substring(1):match.pathname;locationObj.$$path=decodePath(path,html5Mode);locationObj.$$search=parseKeyValue(match.search);locationObj.$$hash=decodeURIComponent(match.hash);// make sure path starts with '/';
	if(locationObj.$$path&&locationObj.$$path.charAt(0)!=='/'){locationObj.$$path='/'+locationObj.$$path;}}function startsWith(str,search){return str.slice(0,search.length)===search;}/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */function stripBaseUrl(base,url){if(startsWith(url,base)){return url.substr(base.length);}}function stripHash(url){var index=url.indexOf('#');return index===-1?url:url.substr(0,index);}function trimEmptyHash(url){return url.replace(/(#.+)|#$/,'$1');}function stripFile(url){return url.substr(0,stripHash(url).lastIndexOf('/')+1);}/* return the server only (scheme://host:port) */function serverBase(url){return url.substring(0,url.indexOf('/',url.indexOf('//')+2));}/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */function LocationHtml5Url(appBase,appBaseNoFile,basePrefix){this.$$html5=true;basePrefix=basePrefix||'';parseAbsoluteUrl(appBase,this);/**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */this.$$parse=function(url){var pathUrl=stripBaseUrl(appBaseNoFile,url);if(!isString(pathUrl)){throw $locationMinErr('ipthprfx','Invalid url "{0}", missing path prefix "{1}".',url,appBaseNoFile);}parseAppUrl(pathUrl,this,true);if(!this.$$path){this.$$path='/';}this.$$compose();};/**
	   * Compose url and update `absUrl` property
	   * @private
	   */this.$$compose=function(){var search=toKeyValue(this.$$search),hash=this.$$hash?'#'+encodeUriSegment(this.$$hash):'';this.$$url=encodePath(this.$$path)+(search?'?'+search:'')+hash;this.$$absUrl=appBaseNoFile+this.$$url.substr(1);// first char is always '/'
	this.$$urlUpdatedByLocation=true;};this.$$parseLinkUrl=function(url,relHref){if(relHref&&relHref[0]==='#'){// special case for links to hash fragments:
	// keep the old url and only replace the hash fragment
	this.hash(relHref.slice(1));return true;}var appUrl,prevAppUrl;var rewrittenUrl;if(isDefined(appUrl=stripBaseUrl(appBase,url))){prevAppUrl=appUrl;if(basePrefix&&isDefined(appUrl=stripBaseUrl(basePrefix,appUrl))){rewrittenUrl=appBaseNoFile+(stripBaseUrl('/',appUrl)||appUrl);}else{rewrittenUrl=appBase+prevAppUrl;}}else if(isDefined(appUrl=stripBaseUrl(appBaseNoFile,url))){rewrittenUrl=appBaseNoFile+appUrl;}else if(appBaseNoFile===url+'/'){rewrittenUrl=appBaseNoFile;}if(rewrittenUrl){this.$$parse(rewrittenUrl);}return!!rewrittenUrl;};}/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */function LocationHashbangUrl(appBase,appBaseNoFile,hashPrefix){parseAbsoluteUrl(appBase,this);/**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */this.$$parse=function(url){var withoutBaseUrl=stripBaseUrl(appBase,url)||stripBaseUrl(appBaseNoFile,url);var withoutHashUrl;if(!isUndefined(withoutBaseUrl)&&withoutBaseUrl.charAt(0)==='#'){// The rest of the URL starts with a hash so we have
	// got either a hashbang path or a plain hash fragment
	withoutHashUrl=stripBaseUrl(hashPrefix,withoutBaseUrl);if(isUndefined(withoutHashUrl)){// There was no hashbang prefix so we just have a hash fragment
	withoutHashUrl=withoutBaseUrl;}}else{// There was no hashbang path nor hash fragment:
	// If we are in HTML5 mode we use what is left as the path;
	// Otherwise we ignore what is left
	if(this.$$html5){withoutHashUrl=withoutBaseUrl;}else{withoutHashUrl='';if(isUndefined(withoutBaseUrl)){appBase=url;/** @type {?} */this.replace();}}}parseAppUrl(withoutHashUrl,this,false);this.$$path=removeWindowsDriveName(this.$$path,withoutHashUrl,appBase);this.$$compose();/*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */function removeWindowsDriveName(path,url,base){/*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */var windowsFilePathExp=/^\/[A-Z]:(\/.*)/;var firstPathSegmentMatch;//Get the relative path from the input URL.
	if(startsWith(url,base)){url=url.replace(base,'');}// The input URL intentionally contains a first path segment that ends with a colon.
	if(windowsFilePathExp.exec(url)){return path;}firstPathSegmentMatch=windowsFilePathExp.exec(path);return firstPathSegmentMatch?firstPathSegmentMatch[1]:path;}};/**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */this.$$compose=function(){var search=toKeyValue(this.$$search),hash=this.$$hash?'#'+encodeUriSegment(this.$$hash):'';this.$$url=encodePath(this.$$path)+(search?'?'+search:'')+hash;this.$$absUrl=appBase+(this.$$url?hashPrefix+this.$$url:'');this.$$urlUpdatedByLocation=true;};this.$$parseLinkUrl=function(url,relHref){if(stripHash(appBase)===stripHash(url)){this.$$parse(url);return true;}return false;};}/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */function LocationHashbangInHtml5Url(appBase,appBaseNoFile,hashPrefix){this.$$html5=true;LocationHashbangUrl.apply(this,arguments);this.$$parseLinkUrl=function(url,relHref){if(relHref&&relHref[0]==='#'){// special case for links to hash fragments:
	// keep the old url and only replace the hash fragment
	this.hash(relHref.slice(1));return true;}var rewrittenUrl;var appUrl;if(appBase===stripHash(url)){rewrittenUrl=url;}else if(appUrl=stripBaseUrl(appBaseNoFile,url)){rewrittenUrl=appBase+hashPrefix+appUrl;}else if(appBaseNoFile===url+'/'){rewrittenUrl=appBaseNoFile;}if(rewrittenUrl){this.$$parse(rewrittenUrl);}return!!rewrittenUrl;};this.$$compose=function(){var search=toKeyValue(this.$$search),hash=this.$$hash?'#'+encodeUriSegment(this.$$hash):'';this.$$url=encodePath(this.$$path)+(search?'?'+search:'')+hash;// include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	this.$$absUrl=appBase+hashPrefix+this.$$url;this.$$urlUpdatedByLocation=true;};}var locationPrototype={/**
	   * Ensure absolute URL is initialized.
	   * @private
	   */$$absUrl:'',/**
	   * Are we in html5 mode?
	   * @private
	   */$$html5:false,/**
	   * Has any change been replacing?
	   * @private
	   */$$replace:false,/**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */absUrl:locationGetter('$$absUrl'),/**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */url:function url(_url){if(isUndefined(_url)){return this.$$url;}var match=PATH_MATCH.exec(_url);if(match[1]||_url==='')this.path(decodeURIComponent(match[1]));if(match[2]||match[1]||_url==='')this.search(match[3]||'');this.hash(match[5]||'');return this;},/**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */protocol:locationGetter('$$protocol'),/**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */host:locationGetter('$$host'),/**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */port:locationGetter('$$port'),/**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */path:locationGetterSetter('$$path',function(path){path=path!==null?path.toString():'';return path.charAt(0)==='/'?path:'/'+path;}),/**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */search:function search(_search,paramValue){switch(arguments.length){case 0:return this.$$search;case 1:if(isString(_search)||isNumber(_search)){_search=_search.toString();this.$$search=parseKeyValue(_search);}else if(isObject(_search)){_search=copy(_search,{});// remove object undefined or null properties
	forEach(_search,function(value,key){if(value==null)delete _search[key];});this.$$search=_search;}else{throw $locationMinErr('isrcharg','The first argument of the `$location#search()` call must be a string or an object.');}break;default:if(isUndefined(paramValue)||paramValue===null){delete this.$$search[_search];}else{this.$$search[_search]=paramValue;}}this.$$compose();return this;},/**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */hash:locationGetterSetter('$$hash',function(hash){return hash!==null?hash.toString():'';}),/**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */replace:function replace(){this.$$replace=true;return this;}};forEach([LocationHashbangInHtml5Url,LocationHashbangUrl,LocationHtml5Url],function(Location){Location.prototype=Object.create(locationPrototype);/**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */Location.prototype.state=function(state){if(!arguments.length){return this.$$state;}if(Location!==LocationHtml5Url||!this.$$html5){throw $locationMinErr('nostate','History API state support is available only '+'in HTML5 mode and only in browsers supporting HTML5 History API');}// The user might modify `stateObject` after invoking `$location.state(stateObject)`
	// but we're changing the $$state reference to $browser.state() during the $digest
	// so the modification window is narrow.
	this.$$state=isUndefined(state)?null:state;this.$$urlUpdatedByLocation=true;return this;};});function locationGetter(property){return(/** @this */function(){return this[property];});}function locationGetterSetter(property,preprocess){return(/** @this */function(value){if(isUndefined(value)){return this[property];}this[property]=preprocess(value);this.$$compose();return this;});}/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 *//**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */function $LocationProvider(){var hashPrefix='!',html5Mode={enabled:false,requireBase:true,rewriteLinks:true};/**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */this.hashPrefix=function(prefix){if(isDefined(prefix)){hashPrefix=prefix;return this;}else{return hashPrefix;}};/**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */this.html5Mode=function(mode){if(isBoolean(mode)){html5Mode.enabled=mode;return this;}else if(isObject(mode)){if(isBoolean(mode.enabled)){html5Mode.enabled=mode.enabled;}if(isBoolean(mode.requireBase)){html5Mode.requireBase=mode.requireBase;}if(isBoolean(mode.rewriteLinks)||isString(mode.rewriteLinks)){html5Mode.rewriteLinks=mode.rewriteLinks;}return this;}else{return html5Mode;}};/**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   *//**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */this.$get=['$rootScope','$browser','$sniffer','$rootElement','$window',function($rootScope,$browser,$sniffer,$rootElement,$window){var $location,LocationMode,baseHref=$browser.baseHref(),// if base[href] is undefined, it defaults to ''
	initialUrl=$browser.url(),appBase;if(html5Mode.enabled){if(!baseHref&&html5Mode.requireBase){throw $locationMinErr('nobase','$location in HTML5 mode requires a <base> tag to be present!');}appBase=serverBase(initialUrl)+(baseHref||'/');LocationMode=$sniffer.history?LocationHtml5Url:LocationHashbangInHtml5Url;}else{appBase=stripHash(initialUrl);LocationMode=LocationHashbangUrl;}var appBaseNoFile=stripFile(appBase);$location=new LocationMode(appBase,appBaseNoFile,'#'+hashPrefix);$location.$$parseLinkUrl(initialUrl,initialUrl);$location.$$state=$browser.state();var IGNORE_URI_REGEXP=/^\s*(javascript|mailto):/i;function setBrowserUrlWithFallback(url,replace,state){var oldUrl=$location.url();var oldState=$location.$$state;try{$browser.url(url,replace,state);// Make sure $location.state() returns referentially identical (not just deeply equal)
	// state object; this makes possible quick checking if the state changed in the digest
	// loop. Checking deep equality would be too expensive.
	$location.$$state=$browser.state();}catch(e){// Restore old values if pushState fails
	$location.url(oldUrl);$location.$$state=oldState;throw e;}}$rootElement.on('click',function(event){var rewriteLinks=html5Mode.rewriteLinks;// TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	// currently we open nice url link and redirect then
	if(!rewriteLinks||event.ctrlKey||event.metaKey||event.shiftKey||event.which===2||event.button===2)return;var elm=jqLite(event.target);// traverse the DOM up to find first A tag
	while(nodeName_(elm[0])!=='a'){// ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	if(elm[0]===$rootElement[0]||!(elm=elm.parent())[0])return;}if(isString(rewriteLinks)&&isUndefined(elm.attr(rewriteLinks)))return;var absHref=elm.prop('href');// get the actual href attribute - see
	// http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	var relHref=elm.attr('href')||elm.attr('xlink:href');if(isObject(absHref)&&absHref.toString()==='[object SVGAnimatedString]'){// SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	// an animation.
	absHref=urlResolve(absHref.animVal).href;}// Ignore when url is started with javascript: or mailto:
	if(IGNORE_URI_REGEXP.test(absHref))return;if(absHref&&!elm.attr('target')&&!event.isDefaultPrevented()){if($location.$$parseLinkUrl(absHref,relHref)){// We do a preventDefault for all urls that are part of the AngularJS application,
	// in html5mode and also without, so that we are able to abort navigation without
	// getting double entries in the location history.
	event.preventDefault();// update location manually
	if($location.absUrl()!==$browser.url()){$rootScope.$apply();// hack to work around FF6 bug 684208 when scenario runner clicks on links
	$window.angular['ff-684208-preventDefault']=true;}}}});// rewrite hashbang url <> html5 url
	if(trimEmptyHash($location.absUrl())!==trimEmptyHash(initialUrl)){$browser.url($location.absUrl(),true);}var initializing=true;// update $location when $browser url changes
	$browser.onUrlChange(function(newUrl,newState){if(!startsWith(newUrl,appBaseNoFile)){// If we are navigating outside of the app then force a reload
	$window.location.href=newUrl;return;}$rootScope.$evalAsync(function(){var oldUrl=$location.absUrl();var oldState=$location.$$state;var defaultPrevented;newUrl=trimEmptyHash(newUrl);$location.$$parse(newUrl);$location.$$state=newState;defaultPrevented=$rootScope.$broadcast('$locationChangeStart',newUrl,oldUrl,newState,oldState).defaultPrevented;// if the location was changed by a `$locationChangeStart` handler then stop
	// processing this location change
	if($location.absUrl()!==newUrl)return;if(defaultPrevented){$location.$$parse(oldUrl);$location.$$state=oldState;setBrowserUrlWithFallback(oldUrl,false,oldState);}else{initializing=false;afterLocationChange(oldUrl,oldState);}});if(!$rootScope.$$phase)$rootScope.$digest();});// update browser
	$rootScope.$watch(function $locationWatch(){if(initializing||$location.$$urlUpdatedByLocation){$location.$$urlUpdatedByLocation=false;var oldUrl=trimEmptyHash($browser.url());var newUrl=trimEmptyHash($location.absUrl());var oldState=$browser.state();var currentReplace=$location.$$replace;var urlOrStateChanged=oldUrl!==newUrl||$location.$$html5&&$sniffer.history&&oldState!==$location.$$state;if(initializing||urlOrStateChanged){initializing=false;$rootScope.$evalAsync(function(){var newUrl=$location.absUrl();var defaultPrevented=$rootScope.$broadcast('$locationChangeStart',newUrl,oldUrl,$location.$$state,oldState).defaultPrevented;// if the location was changed by a `$locationChangeStart` handler then stop
	// processing this location change
	if($location.absUrl()!==newUrl)return;if(defaultPrevented){$location.$$parse(oldUrl);$location.$$state=oldState;}else{if(urlOrStateChanged){setBrowserUrlWithFallback(newUrl,currentReplace,oldState===$location.$$state?null:$location.$$state);}afterLocationChange(oldUrl,oldState);}});}}$location.$$replace=false;// we don't need to return anything because $evalAsync will make the digest loop dirty when
	// there is a change
	});return $location;function afterLocationChange(oldUrl,oldState){$rootScope.$broadcast('$locationChangeSuccess',$location.absUrl(),oldUrl,$location.$$state,oldState);}}];}/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 *//**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */function $LogProvider(){var debug=true,self=this;/**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */this.debugEnabled=function(flag){if(isDefined(flag)){debug=flag;return this;}else{return debug;}};this.$get=['$window',function($window){// Support: IE 9-11, Edge 12-14+
	// IE/Edge display errors in such a way that it requires the user to click in 4 places
	// to see the stack trace. There is no way to feature-detect it so there's a chance
	// of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	// break apps. Other browsers display errors in a sensible way and some of them map stack
	// traces along source maps if available so it makes sense to let browsers display it
	// as they want.
	var formatStackTrace=msie||/\bEdge\//.test($window.navigator&&$window.navigator.userAgent);return{/**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */log:consoleLog('log'),/**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */info:consoleLog('info'),/**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */warn:consoleLog('warn'),/**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */error:consoleLog('error'),/**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */debug:function(){var fn=consoleLog('debug');return function(){if(debug){fn.apply(self,arguments);}};}()};function formatError(arg){if(isError(arg)){if(arg.stack&&formatStackTrace){arg=arg.message&&arg.stack.indexOf(arg.message)===-1?'Error: '+arg.message+'\n'+arg.stack:arg.stack;}else if(arg.sourceURL){arg=arg.message+'\n'+arg.sourceURL+':'+arg.line;}}return arg;}function consoleLog(type){var console=$window.console||{},logFn=console[type]||console.log||noop;return function(){var args=[];forEach(arguments,function(arg){args.push(formatError(arg));});// Support: IE 9 only
	// console methods don't inherit from Function.prototype in IE 9 so we can't
	// call `logFn.apply(console, args)` directly.
	return Function.prototype.apply.call(logFn,console,args);};}}];}/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */var $parseMinErr=minErr('$parse');var objectValueOf={}.constructor.prototype.valueOf;// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	function getStringValue(name){// Property names must be strings. This means that non-string objects cannot be used
	// as keys in an object. Any non-string object, including a number, is typecasted
	// into a string via the toString method.
	// -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	//
	// So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	// to a string. It's not always possible. If `name` is an object and its `toString` method is
	// 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	//
	// TypeError: Cannot convert object to primitive value
	//
	// For performance reasons, we don't catch this error here and allow it to propagate up the call
	// stack. Note that you'll get the same error in JavaScript if you try to access a property using
	// such a 'broken' object as a key.
	return name+'';}var OPERATORS=createMap();forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '),function(operator){OPERATORS[operator]=true;});var ESCAPE={'n':'\n','f':'\f','r':'\r','t':'\t','v':'\v','\'':'\'','"':'"'};/////////////////////////////////////////
	/**
	 * @constructor
	 */var Lexer=function Lexer(options){this.options=options;};Lexer.prototype={constructor:Lexer,lex:function lex(text){this.text=text;this.index=0;this.tokens=[];while(this.index<this.text.length){var ch=this.text.charAt(this.index);if(ch==='"'||ch==='\''){this.readString(ch);}else if(this.isNumber(ch)||ch==='.'&&this.isNumber(this.peek())){this.readNumber();}else if(this.isIdentifierStart(this.peekMultichar())){this.readIdent();}else if(this.is(ch,'(){}[].,;:?')){this.tokens.push({index:this.index,text:ch});this.index++;}else if(this.isWhitespace(ch)){this.index++;}else{var ch2=ch+this.peek();var ch3=ch2+this.peek(2);var op1=OPERATORS[ch];var op2=OPERATORS[ch2];var op3=OPERATORS[ch3];if(op1||op2||op3){var token=op3?ch3:op2?ch2:ch;this.tokens.push({index:this.index,text:token,operator:true});this.index+=token.length;}else{this.throwError('Unexpected next character ',this.index,this.index+1);}}}return this.tokens;},is:function is(ch,chars){return chars.indexOf(ch)!==-1;},peek:function peek(i){var num=i||1;return this.index+num<this.text.length?this.text.charAt(this.index+num):false;},isNumber:function isNumber(ch){return'0'<=ch&&ch<='9'&&typeof ch==='string';},isWhitespace:function isWhitespace(ch){// IE treats non-breaking space as \u00A0
	return ch===' '||ch==='\r'||ch==='\t'||ch==='\n'||ch==='\v'||ch==='\xA0';},isIdentifierStart:function isIdentifierStart(ch){return this.options.isIdentifierStart?this.options.isIdentifierStart(ch,this.codePointAt(ch)):this.isValidIdentifierStart(ch);},isValidIdentifierStart:function isValidIdentifierStart(ch){return'a'<=ch&&ch<='z'||'A'<=ch&&ch<='Z'||'_'===ch||ch==='$';},isIdentifierContinue:function isIdentifierContinue(ch){return this.options.isIdentifierContinue?this.options.isIdentifierContinue(ch,this.codePointAt(ch)):this.isValidIdentifierContinue(ch);},isValidIdentifierContinue:function isValidIdentifierContinue(ch,cp){return this.isValidIdentifierStart(ch,cp)||this.isNumber(ch);},codePointAt:function codePointAt(ch){if(ch.length===1)return ch.charCodeAt(0);// eslint-disable-next-line no-bitwise
	return(ch.charCodeAt(0)<<10)+ch.charCodeAt(1)-0x35FDC00;},peekMultichar:function peekMultichar(){var ch=this.text.charAt(this.index);var peek=this.peek();if(!peek){return ch;}var cp1=ch.charCodeAt(0);var cp2=peek.charCodeAt(0);if(cp1>=0xD800&&cp1<=0xDBFF&&cp2>=0xDC00&&cp2<=0xDFFF){return ch+peek;}return ch;},isExpOperator:function isExpOperator(ch){return ch==='-'||ch==='+'||this.isNumber(ch);},throwError:function throwError(error,start,end){end=end||this.index;var colStr=isDefined(start)?'s '+start+'-'+this.index+' ['+this.text.substring(start,end)+']':' '+end;throw $parseMinErr('lexerr','Lexer Error: {0} at column{1} in expression [{2}].',error,colStr,this.text);},readNumber:function readNumber(){var number='';var start=this.index;while(this.index<this.text.length){var ch=lowercase(this.text.charAt(this.index));if(ch==='.'||this.isNumber(ch)){number+=ch;}else{var peekCh=this.peek();if(ch==='e'&&this.isExpOperator(peekCh)){number+=ch;}else if(this.isExpOperator(ch)&&peekCh&&this.isNumber(peekCh)&&number.charAt(number.length-1)==='e'){number+=ch;}else if(this.isExpOperator(ch)&&(!peekCh||!this.isNumber(peekCh))&&number.charAt(number.length-1)==='e'){this.throwError('Invalid exponent');}else{break;}}this.index++;}this.tokens.push({index:start,text:number,constant:true,value:Number(number)});},readIdent:function readIdent(){var start=this.index;this.index+=this.peekMultichar().length;while(this.index<this.text.length){var ch=this.peekMultichar();if(!this.isIdentifierContinue(ch)){break;}this.index+=ch.length;}this.tokens.push({index:start,text:this.text.slice(start,this.index),identifier:true});},readString:function readString(quote){var start=this.index;this.index++;var string='';var rawString=quote;var escape=false;while(this.index<this.text.length){var ch=this.text.charAt(this.index);rawString+=ch;if(escape){if(ch==='u'){var hex=this.text.substring(this.index+1,this.index+5);if(!hex.match(/[\da-f]{4}/i)){this.throwError('Invalid unicode escape [\\u'+hex+']');}this.index+=4;string+=String.fromCharCode(parseInt(hex,16));}else{var rep=ESCAPE[ch];string=string+(rep||ch);}escape=false;}else if(ch==='\\'){escape=true;}else if(ch===quote){this.index++;this.tokens.push({index:start,text:rawString,constant:true,value:string});return;}else{string+=ch;}this.index++;}this.throwError('Unterminated quote',start);}};var AST=function AST(lexer,options){this.lexer=lexer;this.options=options;};AST.Program='Program';AST.ExpressionStatement='ExpressionStatement';AST.AssignmentExpression='AssignmentExpression';AST.ConditionalExpression='ConditionalExpression';AST.LogicalExpression='LogicalExpression';AST.BinaryExpression='BinaryExpression';AST.UnaryExpression='UnaryExpression';AST.CallExpression='CallExpression';AST.MemberExpression='MemberExpression';AST.Identifier='Identifier';AST.Literal='Literal';AST.ArrayExpression='ArrayExpression';AST.Property='Property';AST.ObjectExpression='ObjectExpression';AST.ThisExpression='ThisExpression';AST.LocalsExpression='LocalsExpression';// Internal use only
	AST.NGValueParameter='NGValueParameter';AST.prototype={ast:function ast(text){this.text=text;this.tokens=this.lexer.lex(text);var value=this.program();if(this.tokens.length!==0){this.throwError('is an unexpected token',this.tokens[0]);}return value;},program:function program(){var body=[];while(true){if(this.tokens.length>0&&!this.peek('}',')',';',']'))body.push(this.expressionStatement());if(!this.expect(';')){return{type:AST.Program,body:body};}}},expressionStatement:function expressionStatement(){return{type:AST.ExpressionStatement,expression:this.filterChain()};},filterChain:function filterChain(){var left=this.expression();while(this.expect('|')){left=this.filter(left);}return left;},expression:function expression(){return this.assignment();},assignment:function assignment(){var result=this.ternary();if(this.expect('=')){if(!isAssignable(result)){throw $parseMinErr('lval','Trying to assign a value to a non l-value');}result={type:AST.AssignmentExpression,left:result,right:this.assignment(),operator:'='};}return result;},ternary:function ternary(){var test=this.logicalOR();var alternate;var consequent;if(this.expect('?')){alternate=this.expression();if(this.consume(':')){consequent=this.expression();return{type:AST.ConditionalExpression,test:test,alternate:alternate,consequent:consequent};}}return test;},logicalOR:function logicalOR(){var left=this.logicalAND();while(this.expect('||')){left={type:AST.LogicalExpression,operator:'||',left:left,right:this.logicalAND()};}return left;},logicalAND:function logicalAND(){var left=this.equality();while(this.expect('&&')){left={type:AST.LogicalExpression,operator:'&&',left:left,right:this.equality()};}return left;},equality:function equality(){var left=this.relational();var token;while(token=this.expect('==','!=','===','!==')){left={type:AST.BinaryExpression,operator:token.text,left:left,right:this.relational()};}return left;},relational:function relational(){var left=this.additive();var token;while(token=this.expect('<','>','<=','>=')){left={type:AST.BinaryExpression,operator:token.text,left:left,right:this.additive()};}return left;},additive:function additive(){var left=this.multiplicative();var token;while(token=this.expect('+','-')){left={type:AST.BinaryExpression,operator:token.text,left:left,right:this.multiplicative()};}return left;},multiplicative:function multiplicative(){var left=this.unary();var token;while(token=this.expect('*','/','%')){left={type:AST.BinaryExpression,operator:token.text,left:left,right:this.unary()};}return left;},unary:function unary(){var token;if(token=this.expect('+','-','!')){return{type:AST.UnaryExpression,operator:token.text,prefix:true,argument:this.unary()};}else{return this.primary();}},primary:function primary(){var primary;if(this.expect('(')){primary=this.filterChain();this.consume(')');}else if(this.expect('[')){primary=this.arrayDeclaration();}else if(this.expect('{')){primary=this.object();}else if(this.selfReferential.hasOwnProperty(this.peek().text)){primary=copy(this.selfReferential[this.consume().text]);}else if(this.options.literals.hasOwnProperty(this.peek().text)){primary={type:AST.Literal,value:this.options.literals[this.consume().text]};}else if(this.peek().identifier){primary=this.identifier();}else if(this.peek().constant){primary=this.constant();}else{this.throwError('not a primary expression',this.peek());}var next;while(next=this.expect('(','[','.')){if(next.text==='('){primary={type:AST.CallExpression,callee:primary,arguments:this.parseArguments()};this.consume(')');}else if(next.text==='['){primary={type:AST.MemberExpression,object:primary,property:this.expression(),computed:true};this.consume(']');}else if(next.text==='.'){primary={type:AST.MemberExpression,object:primary,property:this.identifier(),computed:false};}else{this.throwError('IMPOSSIBLE');}}return primary;},filter:function filter(baseExpression){var args=[baseExpression];var result={type:AST.CallExpression,callee:this.identifier(),arguments:args,filter:true};while(this.expect(':')){args.push(this.expression());}return result;},parseArguments:function parseArguments(){var args=[];if(this.peekToken().text!==')'){do{args.push(this.filterChain());}while(this.expect(','));}return args;},identifier:function identifier(){var token=this.consume();if(!token.identifier){this.throwError('is not a valid identifier',token);}return{type:AST.Identifier,name:token.text};},constant:function constant(){// TODO check that it is a constant
	return{type:AST.Literal,value:this.consume().value};},arrayDeclaration:function arrayDeclaration(){var elements=[];if(this.peekToken().text!==']'){do{if(this.peek(']')){// Support trailing commas per ES5.1.
	break;}elements.push(this.expression());}while(this.expect(','));}this.consume(']');return{type:AST.ArrayExpression,elements:elements};},object:function object(){var properties=[],property;if(this.peekToken().text!=='}'){do{if(this.peek('}')){// Support trailing commas per ES5.1.
	break;}property={type:AST.Property,kind:'init'};if(this.peek().constant){property.key=this.constant();property.computed=false;this.consume(':');property.value=this.expression();}else if(this.peek().identifier){property.key=this.identifier();property.computed=false;if(this.peek(':')){this.consume(':');property.value=this.expression();}else{property.value=property.key;}}else if(this.peek('[')){this.consume('[');property.key=this.expression();this.consume(']');property.computed=true;this.consume(':');property.value=this.expression();}else{this.throwError('invalid key',this.peek());}properties.push(property);}while(this.expect(','));}this.consume('}');return{type:AST.ObjectExpression,properties:properties};},throwError:function throwError(msg,token){throw $parseMinErr('syntax','Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',token.text,msg,token.index+1,this.text,this.text.substring(token.index));},consume:function consume(e1){if(this.tokens.length===0){throw $parseMinErr('ueoe','Unexpected end of expression: {0}',this.text);}var token=this.expect(e1);if(!token){this.throwError('is unexpected, expecting ['+e1+']',this.peek());}return token;},peekToken:function peekToken(){if(this.tokens.length===0){throw $parseMinErr('ueoe','Unexpected end of expression: {0}',this.text);}return this.tokens[0];},peek:function peek(e1,e2,e3,e4){return this.peekAhead(0,e1,e2,e3,e4);},peekAhead:function peekAhead(i,e1,e2,e3,e4){if(this.tokens.length>i){var token=this.tokens[i];var t=token.text;if(t===e1||t===e2||t===e3||t===e4||!e1&&!e2&&!e3&&!e4){return token;}}return false;},expect:function expect(e1,e2,e3,e4){var token=this.peek(e1,e2,e3,e4);if(token){this.tokens.shift();return token;}return false;},selfReferential:{'this':{type:AST.ThisExpression},'$locals':{type:AST.LocalsExpression}}};function ifDefined(v,d){return typeof v!=='undefined'?v:d;}function plusFn(l,r){if(typeof l==='undefined')return r;if(typeof r==='undefined')return l;return l+r;}function isStateless($filter,filterName){var fn=$filter(filterName);return!fn.$stateful;}var PURITY_ABSOLUTE=1;var PURITY_RELATIVE=2;// Detect nodes which could depend on non-shallow state of objects
	function isPure(node,parentIsPure){switch(node.type){// Computed members might invoke a stateful toString()
	case AST.MemberExpression:if(node.computed){return false;}break;// Unary always convert to primative
	case AST.UnaryExpression:return PURITY_ABSOLUTE;// The binary + operator can invoke a stateful toString().
	case AST.BinaryExpression:return node.operator!=='+'?PURITY_ABSOLUTE:false;// Functions / filters probably read state from within objects
	case AST.CallExpression:return false;}return undefined===parentIsPure?PURITY_RELATIVE:parentIsPure;}function findConstantAndWatchExpressions(ast,$filter,parentIsPure){var allConstants;var argsToWatch;var isStatelessFilter;var astIsPure=ast.isPure=isPure(ast,parentIsPure);switch(ast.type){case AST.Program:allConstants=true;forEach(ast.body,function(expr){findConstantAndWatchExpressions(expr.expression,$filter,astIsPure);allConstants=allConstants&&expr.expression.constant;});ast.constant=allConstants;break;case AST.Literal:ast.constant=true;ast.toWatch=[];break;case AST.UnaryExpression:findConstantAndWatchExpressions(ast.argument,$filter,astIsPure);ast.constant=ast.argument.constant;ast.toWatch=ast.argument.toWatch;break;case AST.BinaryExpression:findConstantAndWatchExpressions(ast.left,$filter,astIsPure);findConstantAndWatchExpressions(ast.right,$filter,astIsPure);ast.constant=ast.left.constant&&ast.right.constant;ast.toWatch=ast.left.toWatch.concat(ast.right.toWatch);break;case AST.LogicalExpression:findConstantAndWatchExpressions(ast.left,$filter,astIsPure);findConstantAndWatchExpressions(ast.right,$filter,astIsPure);ast.constant=ast.left.constant&&ast.right.constant;ast.toWatch=ast.constant?[]:[ast];break;case AST.ConditionalExpression:findConstantAndWatchExpressions(ast.test,$filter,astIsPure);findConstantAndWatchExpressions(ast.alternate,$filter,astIsPure);findConstantAndWatchExpressions(ast.consequent,$filter,astIsPure);ast.constant=ast.test.constant&&ast.alternate.constant&&ast.consequent.constant;ast.toWatch=ast.constant?[]:[ast];break;case AST.Identifier:ast.constant=false;ast.toWatch=[ast];break;case AST.MemberExpression:findConstantAndWatchExpressions(ast.object,$filter,astIsPure);if(ast.computed){findConstantAndWatchExpressions(ast.property,$filter,astIsPure);}ast.constant=ast.object.constant&&(!ast.computed||ast.property.constant);ast.toWatch=ast.constant?[]:[ast];break;case AST.CallExpression:isStatelessFilter=ast.filter?isStateless($filter,ast.callee.name):false;allConstants=isStatelessFilter;argsToWatch=[];forEach(ast.arguments,function(expr){findConstantAndWatchExpressions(expr,$filter,astIsPure);allConstants=allConstants&&expr.constant;argsToWatch.push.apply(argsToWatch,expr.toWatch);});ast.constant=allConstants;ast.toWatch=isStatelessFilter?argsToWatch:[ast];break;case AST.AssignmentExpression:findConstantAndWatchExpressions(ast.left,$filter,astIsPure);findConstantAndWatchExpressions(ast.right,$filter,astIsPure);ast.constant=ast.left.constant&&ast.right.constant;ast.toWatch=[ast];break;case AST.ArrayExpression:allConstants=true;argsToWatch=[];forEach(ast.elements,function(expr){findConstantAndWatchExpressions(expr,$filter,astIsPure);allConstants=allConstants&&expr.constant;argsToWatch.push.apply(argsToWatch,expr.toWatch);});ast.constant=allConstants;ast.toWatch=argsToWatch;break;case AST.ObjectExpression:allConstants=true;argsToWatch=[];forEach(ast.properties,function(property){findConstantAndWatchExpressions(property.value,$filter,astIsPure);allConstants=allConstants&&property.value.constant;argsToWatch.push.apply(argsToWatch,property.value.toWatch);if(property.computed){//`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	findConstantAndWatchExpressions(property.key,$filter,/*parentIsPure=*/false);allConstants=allConstants&&property.key.constant;argsToWatch.push.apply(argsToWatch,property.key.toWatch);}});ast.constant=allConstants;ast.toWatch=argsToWatch;break;case AST.ThisExpression:ast.constant=false;ast.toWatch=[];break;case AST.LocalsExpression:ast.constant=false;ast.toWatch=[];break;}}function getInputs(body){if(body.length!==1)return;var lastExpression=body[0].expression;var candidate=lastExpression.toWatch;if(candidate.length!==1)return candidate;return candidate[0]!==lastExpression?candidate:undefined;}function isAssignable(ast){return ast.type===AST.Identifier||ast.type===AST.MemberExpression;}function assignableAST(ast){if(ast.body.length===1&&isAssignable(ast.body[0].expression)){return{type:AST.AssignmentExpression,left:ast.body[0].expression,right:{type:AST.NGValueParameter},operator:'='};}}function isLiteral(ast){return ast.body.length===0||ast.body.length===1&&(ast.body[0].expression.type===AST.Literal||ast.body[0].expression.type===AST.ArrayExpression||ast.body[0].expression.type===AST.ObjectExpression);}function isConstant(ast){return ast.constant;}function ASTCompiler($filter){this.$filter=$filter;}ASTCompiler.prototype={compile:function compile(ast){var self=this;this.state={nextId:0,filters:{},fn:{vars:[],body:[],own:{}},assign:{vars:[],body:[],own:{}},inputs:[]};findConstantAndWatchExpressions(ast,self.$filter);var extra='';var assignable;this.stage='assign';if(assignable=assignableAST(ast)){this.state.computing='assign';var result=this.nextId();this.recurse(assignable,result);this.return_(result);extra='fn.assign='+this.generateFunction('assign','s,v,l');}var toWatch=getInputs(ast.body);self.stage='inputs';forEach(toWatch,function(watch,key){var fnKey='fn'+key;self.state[fnKey]={vars:[],body:[],own:{}};self.state.computing=fnKey;var intoId=self.nextId();self.recurse(watch,intoId);self.return_(intoId);self.state.inputs.push({name:fnKey,isPure:watch.isPure});watch.watchId=key;});this.state.computing='fn';this.stage='main';this.recurse(ast);var fnString=// The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	// This is a workaround for this until we do a better job at only removing the prefix only when we should.
	'"'+this.USE+' '+this.STRICT+'";\n'+this.filterPrefix()+'var fn='+this.generateFunction('fn','s,l,a,i')+extra+this.watchFns()+'return fn;';// eslint-disable-next-line no-new-func
	var fn=new Function('$filter','getStringValue','ifDefined','plus',fnString)(this.$filter,getStringValue,ifDefined,plusFn);this.state=this.stage=undefined;return fn;},USE:'use',STRICT:'strict',watchFns:function watchFns(){var result=[];var inputs=this.state.inputs;var self=this;forEach(inputs,function(input){result.push('var '+input.name+'='+self.generateFunction(input.name,'s'));if(input.isPure){result.push(input.name,'.isPure='+JSON.stringify(input.isPure)+';');}});if(inputs.length){result.push('fn.inputs=['+inputs.map(function(i){return i.name;}).join(',')+'];');}return result.join('');},generateFunction:function generateFunction(name,params){return'function('+params+'){'+this.varsPrefix(name)+this.body(name)+'};';},filterPrefix:function filterPrefix(){var parts=[];var self=this;forEach(this.state.filters,function(id,filter){parts.push(id+'=$filter('+self.escape(filter)+')');});if(parts.length)return'var '+parts.join(',')+';';return'';},varsPrefix:function varsPrefix(section){return this.state[section].vars.length?'var '+this.state[section].vars.join(',')+';':'';},body:function body(section){return this.state[section].body.join('');},recurse:function recurse(ast,intoId,nameId,recursionFn,create,skipWatchIdCheck){var left,right,self=this,args,expression,computed;recursionFn=recursionFn||noop;if(!skipWatchIdCheck&&isDefined(ast.watchId)){intoId=intoId||this.nextId();this.if_('i',this.lazyAssign(intoId,this.computedMember('i',ast.watchId)),this.lazyRecurse(ast,intoId,nameId,recursionFn,create,true));return;}switch(ast.type){case AST.Program:forEach(ast.body,function(expression,pos){self.recurse(expression.expression,undefined,undefined,function(expr){right=expr;});if(pos!==ast.body.length-1){self.current().body.push(right,';');}else{self.return_(right);}});break;case AST.Literal:expression=this.escape(ast.value);this.assign(intoId,expression);recursionFn(intoId||expression);break;case AST.UnaryExpression:this.recurse(ast.argument,undefined,undefined,function(expr){right=expr;});expression=ast.operator+'('+this.ifDefined(right,0)+')';this.assign(intoId,expression);recursionFn(expression);break;case AST.BinaryExpression:this.recurse(ast.left,undefined,undefined,function(expr){left=expr;});this.recurse(ast.right,undefined,undefined,function(expr){right=expr;});if(ast.operator==='+'){expression=this.plus(left,right);}else if(ast.operator==='-'){expression=this.ifDefined(left,0)+ast.operator+this.ifDefined(right,0);}else{expression='('+left+')'+ast.operator+'('+right+')';}this.assign(intoId,expression);recursionFn(expression);break;case AST.LogicalExpression:intoId=intoId||this.nextId();self.recurse(ast.left,intoId);self.if_(ast.operator==='&&'?intoId:self.not(intoId),self.lazyRecurse(ast.right,intoId));recursionFn(intoId);break;case AST.ConditionalExpression:intoId=intoId||this.nextId();self.recurse(ast.test,intoId);self.if_(intoId,self.lazyRecurse(ast.alternate,intoId),self.lazyRecurse(ast.consequent,intoId));recursionFn(intoId);break;case AST.Identifier:intoId=intoId||this.nextId();if(nameId){nameId.context=self.stage==='inputs'?'s':this.assign(this.nextId(),this.getHasOwnProperty('l',ast.name)+'?l:s');nameId.computed=false;nameId.name=ast.name;}self.if_(self.stage==='inputs'||self.not(self.getHasOwnProperty('l',ast.name)),function(){self.if_(self.stage==='inputs'||'s',function(){if(create&&create!==1){self.if_(self.isNull(self.nonComputedMember('s',ast.name)),self.lazyAssign(self.nonComputedMember('s',ast.name),'{}'));}self.assign(intoId,self.nonComputedMember('s',ast.name));});},intoId&&self.lazyAssign(intoId,self.nonComputedMember('l',ast.name)));recursionFn(intoId);break;case AST.MemberExpression:left=nameId&&(nameId.context=this.nextId())||this.nextId();intoId=intoId||this.nextId();self.recurse(ast.object,left,undefined,function(){self.if_(self.notNull(left),function(){if(ast.computed){right=self.nextId();self.recurse(ast.property,right);self.getStringValue(right);if(create&&create!==1){self.if_(self.not(self.computedMember(left,right)),self.lazyAssign(self.computedMember(left,right),'{}'));}expression=self.computedMember(left,right);self.assign(intoId,expression);if(nameId){nameId.computed=true;nameId.name=right;}}else{if(create&&create!==1){self.if_(self.isNull(self.nonComputedMember(left,ast.property.name)),self.lazyAssign(self.nonComputedMember(left,ast.property.name),'{}'));}expression=self.nonComputedMember(left,ast.property.name);self.assign(intoId,expression);if(nameId){nameId.computed=false;nameId.name=ast.property.name;}}},function(){self.assign(intoId,'undefined');});recursionFn(intoId);},!!create);break;case AST.CallExpression:intoId=intoId||this.nextId();if(ast.filter){right=self.filter(ast.callee.name);args=[];forEach(ast.arguments,function(expr){var argument=self.nextId();self.recurse(expr,argument);args.push(argument);});expression=right+'('+args.join(',')+')';self.assign(intoId,expression);recursionFn(intoId);}else{right=self.nextId();left={};args=[];self.recurse(ast.callee,right,left,function(){self.if_(self.notNull(right),function(){forEach(ast.arguments,function(expr){self.recurse(expr,ast.constant?undefined:self.nextId(),undefined,function(argument){args.push(argument);});});if(left.name){expression=self.member(left.context,left.name,left.computed)+'('+args.join(',')+')';}else{expression=right+'('+args.join(',')+')';}self.assign(intoId,expression);},function(){self.assign(intoId,'undefined');});recursionFn(intoId);});}break;case AST.AssignmentExpression:right=this.nextId();left={};this.recurse(ast.left,undefined,left,function(){self.if_(self.notNull(left.context),function(){self.recurse(ast.right,right);expression=self.member(left.context,left.name,left.computed)+ast.operator+right;self.assign(intoId,expression);recursionFn(intoId||expression);});},1);break;case AST.ArrayExpression:args=[];forEach(ast.elements,function(expr){self.recurse(expr,ast.constant?undefined:self.nextId(),undefined,function(argument){args.push(argument);});});expression='['+args.join(',')+']';this.assign(intoId,expression);recursionFn(intoId||expression);break;case AST.ObjectExpression:args=[];computed=false;forEach(ast.properties,function(property){if(property.computed){computed=true;}});if(computed){intoId=intoId||this.nextId();this.assign(intoId,'{}');forEach(ast.properties,function(property){if(property.computed){left=self.nextId();self.recurse(property.key,left);}else{left=property.key.type===AST.Identifier?property.key.name:''+property.key.value;}right=self.nextId();self.recurse(property.value,right);self.assign(self.member(intoId,left,property.computed),right);});}else{forEach(ast.properties,function(property){self.recurse(property.value,ast.constant?undefined:self.nextId(),undefined,function(expr){args.push(self.escape(property.key.type===AST.Identifier?property.key.name:''+property.key.value)+':'+expr);});});expression='{'+args.join(',')+'}';this.assign(intoId,expression);}recursionFn(intoId||expression);break;case AST.ThisExpression:this.assign(intoId,'s');recursionFn(intoId||'s');break;case AST.LocalsExpression:this.assign(intoId,'l');recursionFn(intoId||'l');break;case AST.NGValueParameter:this.assign(intoId,'v');recursionFn(intoId||'v');break;}},getHasOwnProperty:function getHasOwnProperty(element,property){var key=element+'.'+property;var own=this.current().own;if(!own.hasOwnProperty(key)){own[key]=this.nextId(false,element+'&&('+this.escape(property)+' in '+element+')');}return own[key];},assign:function assign(id,value){if(!id)return;this.current().body.push(id,'=',value,';');return id;},filter:function filter(filterName){if(!this.state.filters.hasOwnProperty(filterName)){this.state.filters[filterName]=this.nextId(true);}return this.state.filters[filterName];},ifDefined:function ifDefined(id,defaultValue){return'ifDefined('+id+','+this.escape(defaultValue)+')';},plus:function plus(left,right){return'plus('+left+','+right+')';},return_:function return_(id){this.current().body.push('return ',id,';');},if_:function if_(test,alternate,consequent){if(test===true){alternate();}else{var body=this.current().body;body.push('if(',test,'){');alternate();body.push('}');if(consequent){body.push('else{');consequent();body.push('}');}}},not:function not(expression){return'!('+expression+')';},isNull:function isNull(expression){return expression+'==null';},notNull:function notNull(expression){return expression+'!=null';},nonComputedMember:function nonComputedMember(left,right){var SAFE_IDENTIFIER=/^[$_a-zA-Z][$_a-zA-Z0-9]*$/;var UNSAFE_CHARACTERS=/[^$_a-zA-Z0-9]/g;if(SAFE_IDENTIFIER.test(right)){return left+'.'+right;}else{return left+'["'+right.replace(UNSAFE_CHARACTERS,this.stringEscapeFn)+'"]';}},computedMember:function computedMember(left,right){return left+'['+right+']';},member:function member(left,right,computed){if(computed)return this.computedMember(left,right);return this.nonComputedMember(left,right);},getStringValue:function getStringValue(item){this.assign(item,'getStringValue('+item+')');},lazyRecurse:function lazyRecurse(ast,intoId,nameId,recursionFn,create,skipWatchIdCheck){var self=this;return function(){self.recurse(ast,intoId,nameId,recursionFn,create,skipWatchIdCheck);};},lazyAssign:function lazyAssign(id,value){var self=this;return function(){self.assign(id,value);};},stringEscapeRegex:/[^ a-zA-Z0-9]/g,stringEscapeFn:function stringEscapeFn(c){return'\\u'+('0000'+c.charCodeAt(0).toString(16)).slice(-4);},escape:function escape(value){if(isString(value))return'\''+value.replace(this.stringEscapeRegex,this.stringEscapeFn)+'\'';if(isNumber(value))return value.toString();if(value===true)return'true';if(value===false)return'false';if(value===null)return'null';if(typeof value==='undefined')return'undefined';throw $parseMinErr('esc','IMPOSSIBLE');},nextId:function nextId(skip,init){var id='v'+this.state.nextId++;if(!skip){this.current().vars.push(id+(init?'='+init:''));}return id;},current:function current(){return this.state[this.state.computing];}};function ASTInterpreter($filter){this.$filter=$filter;}ASTInterpreter.prototype={compile:function compile(ast){var self=this;findConstantAndWatchExpressions(ast,self.$filter);var assignable;var assign;if(assignable=assignableAST(ast)){assign=this.recurse(assignable);}var toWatch=getInputs(ast.body);var inputs;if(toWatch){inputs=[];forEach(toWatch,function(watch,key){var input=self.recurse(watch);input.isPure=watch.isPure;watch.input=input;inputs.push(input);watch.watchId=key;});}var expressions=[];forEach(ast.body,function(expression){expressions.push(self.recurse(expression.expression));});var fn=ast.body.length===0?noop:ast.body.length===1?expressions[0]:function(scope,locals){var lastValue;forEach(expressions,function(exp){lastValue=exp(scope,locals);});return lastValue;};if(assign){fn.assign=function(scope,value,locals){return assign(scope,locals,value);};}if(inputs){fn.inputs=inputs;}return fn;},recurse:function recurse(ast,context,create){var left,right,self=this,args;if(ast.input){return this.inputs(ast.input,ast.watchId);}switch(ast.type){case AST.Literal:return this.value(ast.value,context);case AST.UnaryExpression:right=this.recurse(ast.argument);return this['unary'+ast.operator](right,context);case AST.BinaryExpression:left=this.recurse(ast.left);right=this.recurse(ast.right);return this['binary'+ast.operator](left,right,context);case AST.LogicalExpression:left=this.recurse(ast.left);right=this.recurse(ast.right);return this['binary'+ast.operator](left,right,context);case AST.ConditionalExpression:return this['ternary?:'](this.recurse(ast.test),this.recurse(ast.alternate),this.recurse(ast.consequent),context);case AST.Identifier:return self.identifier(ast.name,context,create);case AST.MemberExpression:left=this.recurse(ast.object,false,!!create);if(!ast.computed){right=ast.property.name;}if(ast.computed)right=this.recurse(ast.property);return ast.computed?this.computedMember(left,right,context,create):this.nonComputedMember(left,right,context,create);case AST.CallExpression:args=[];forEach(ast.arguments,function(expr){args.push(self.recurse(expr));});if(ast.filter)right=this.$filter(ast.callee.name);if(!ast.filter)right=this.recurse(ast.callee,true);return ast.filter?function(scope,locals,assign,inputs){var values=[];for(var i=0;i<args.length;++i){values.push(args[i](scope,locals,assign,inputs));}var value=right.apply(undefined,values,inputs);return context?{context:undefined,name:undefined,value:value}:value;}:function(scope,locals,assign,inputs){var rhs=right(scope,locals,assign,inputs);var value;if(rhs.value!=null){var values=[];for(var i=0;i<args.length;++i){values.push(args[i](scope,locals,assign,inputs));}value=rhs.value.apply(rhs.context,values);}return context?{value:value}:value;};case AST.AssignmentExpression:left=this.recurse(ast.left,true,1);right=this.recurse(ast.right);return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);var rhs=right(scope,locals,assign,inputs);lhs.context[lhs.name]=rhs;return context?{value:rhs}:rhs;};case AST.ArrayExpression:args=[];forEach(ast.elements,function(expr){args.push(self.recurse(expr));});return function(scope,locals,assign,inputs){var value=[];for(var i=0;i<args.length;++i){value.push(args[i](scope,locals,assign,inputs));}return context?{value:value}:value;};case AST.ObjectExpression:args=[];forEach(ast.properties,function(property){if(property.computed){args.push({key:self.recurse(property.key),computed:true,value:self.recurse(property.value)});}else{args.push({key:property.key.type===AST.Identifier?property.key.name:''+property.key.value,computed:false,value:self.recurse(property.value)});}});return function(scope,locals,assign,inputs){var value={};for(var i=0;i<args.length;++i){if(args[i].computed){value[args[i].key(scope,locals,assign,inputs)]=args[i].value(scope,locals,assign,inputs);}else{value[args[i].key]=args[i].value(scope,locals,assign,inputs);}}return context?{value:value}:value;};case AST.ThisExpression:return function(scope){return context?{value:scope}:scope;};case AST.LocalsExpression:return function(scope,locals){return context?{value:locals}:locals;};case AST.NGValueParameter:return function(scope,locals,assign){return context?{value:assign}:assign;};}},'unary+':function unary(argument,context){return function(scope,locals,assign,inputs){var arg=argument(scope,locals,assign,inputs);if(isDefined(arg)){arg=+arg;}else{arg=0;}return context?{value:arg}:arg;};},'unary-':function unary(argument,context){return function(scope,locals,assign,inputs){var arg=argument(scope,locals,assign,inputs);if(isDefined(arg)){arg=-arg;}else{arg=-0;}return context?{value:arg}:arg;};},'unary!':function unary(argument,context){return function(scope,locals,assign,inputs){var arg=!argument(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary+':function binary(left,right,context){return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);var rhs=right(scope,locals,assign,inputs);var arg=plusFn(lhs,rhs);return context?{value:arg}:arg;};},'binary-':function binary(left,right,context){return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);var rhs=right(scope,locals,assign,inputs);var arg=(isDefined(lhs)?lhs:0)-(isDefined(rhs)?rhs:0);return context?{value:arg}:arg;};},'binary*':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)*right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary/':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)/right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary%':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)%right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary===':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)===right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary!==':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)!==right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary==':function binary(left,right,context){return function(scope,locals,assign,inputs){// eslint-disable-next-line eqeqeq
	var arg=left(scope,locals,assign,inputs)==right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary!=':function binary(left,right,context){return function(scope,locals,assign,inputs){// eslint-disable-next-line eqeqeq
	var arg=left(scope,locals,assign,inputs)!=right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary<':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)<right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary>':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)>right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary<=':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)<=right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary>=':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)>=right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary&&':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)&&right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'binary||':function binary(left,right,context){return function(scope,locals,assign,inputs){var arg=left(scope,locals,assign,inputs)||right(scope,locals,assign,inputs);return context?{value:arg}:arg;};},'ternary?:':function ternary(test,alternate,consequent,context){return function(scope,locals,assign,inputs){var arg=test(scope,locals,assign,inputs)?alternate(scope,locals,assign,inputs):consequent(scope,locals,assign,inputs);return context?{value:arg}:arg;};},value:function value(_value2,context){return function(){return context?{context:undefined,name:undefined,value:_value2}:_value2;};},identifier:function identifier(name,context,create){return function(scope,locals,assign,inputs){var base=locals&&name in locals?locals:scope;if(create&&create!==1&&base&&base[name]==null){base[name]={};}var value=base?base[name]:undefined;if(context){return{context:base,name:name,value:value};}else{return value;}};},computedMember:function computedMember(left,right,context,create){return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);var rhs;var value;if(lhs!=null){rhs=right(scope,locals,assign,inputs);rhs=getStringValue(rhs);if(create&&create!==1){if(lhs&&!lhs[rhs]){lhs[rhs]={};}}value=lhs[rhs];}if(context){return{context:lhs,name:rhs,value:value};}else{return value;}};},nonComputedMember:function nonComputedMember(left,right,context,create){return function(scope,locals,assign,inputs){var lhs=left(scope,locals,assign,inputs);if(create&&create!==1){if(lhs&&lhs[right]==null){lhs[right]={};}}var value=lhs!=null?lhs[right]:undefined;if(context){return{context:lhs,name:right,value:value};}else{return value;}};},inputs:function inputs(input,watchId){return function(scope,value,locals,inputs){if(inputs)return inputs[watchId];return input(scope,value,locals);};}};/**
	 * @constructor
	 */function Parser(lexer,$filter,options){this.ast=new AST(lexer,options);this.astCompiler=options.csp?new ASTInterpreter($filter):new ASTCompiler($filter);}Parser.prototype={constructor:Parser,parse:function parse(text){var ast=this.getAst(text);var fn=this.astCompiler.compile(ast.ast);fn.literal=isLiteral(ast.ast);fn.constant=isConstant(ast.ast);fn.oneTime=ast.oneTime;return fn;},getAst:function getAst(exp){var oneTime=false;exp=exp.trim();if(exp.charAt(0)===':'&&exp.charAt(1)===':'){oneTime=true;exp=exp.substring(2);}return{ast:this.ast.ast(exp),oneTime:oneTime};}};function getValueOf(value){return isFunction(value.valueOf)?value.valueOf():objectValueOf.call(value);}///////////////////////////////////
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 *//**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */function $ParseProvider(){var cache=createMap();var literals={'true':true,'false':false,'null':null,'undefined':undefined};var identStart,identContinue;/**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/this.addLiteral=function(literalName,literalValue){literals[literalName]=literalValue;};/**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */this.setIdentifierFns=function(identifierStart,identifierContinue){identStart=identifierStart;identContinue=identifierContinue;return this;};this.$get=['$filter',function($filter){var noUnsafeEval=csp().noUnsafeEval;var $parseOptions={csp:noUnsafeEval,literals:copy(literals),isIdentifierStart:isFunction(identStart)&&identStart,isIdentifierContinue:isFunction(identContinue)&&identContinue};$parse.$$getAst=$$getAst;return $parse;function $parse(exp,interceptorFn){var parsedExpression,cacheKey;switch(typeof exp==='undefined'?'undefined':_typeof(exp)){case'string':exp=exp.trim();cacheKey=exp;parsedExpression=cache[cacheKey];if(!parsedExpression){var lexer=new Lexer($parseOptions);var parser=new Parser(lexer,$filter,$parseOptions);parsedExpression=parser.parse(exp);if(parsedExpression.constant){parsedExpression.$$watchDelegate=constantWatchDelegate;}else if(parsedExpression.oneTime){parsedExpression.$$watchDelegate=parsedExpression.literal?oneTimeLiteralWatchDelegate:oneTimeWatchDelegate;}else if(parsedExpression.inputs){parsedExpression.$$watchDelegate=inputsWatchDelegate;}cache[cacheKey]=parsedExpression;}return addInterceptor(parsedExpression,interceptorFn);case'function':return addInterceptor(exp,interceptorFn);default:return addInterceptor(noop,interceptorFn);}}function $$getAst(exp){var lexer=new Lexer($parseOptions);var parser=new Parser(lexer,$filter,$parseOptions);return parser.getAst(exp).ast;}function expressionInputDirtyCheck(newValue,oldValueOfValue,compareObjectIdentity){if(newValue==null||oldValueOfValue==null){// null/undefined
	return newValue===oldValueOfValue;}if((typeof newValue==='undefined'?'undefined':_typeof(newValue))==='object'){// attempt to convert the value to a primitive type
	// TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	//             be cheaply dirty-checked
	newValue=getValueOf(newValue);if((typeof newValue==='undefined'?'undefined':_typeof(newValue))==='object'&&!compareObjectIdentity){// objects/arrays are not supported - deep-watching them would be too expensive
	return false;}// fall-through to the primitive equality check
	}//Primitive or NaN
	// eslint-disable-next-line no-self-compare
	return newValue===oldValueOfValue||newValue!==newValue&&oldValueOfValue!==oldValueOfValue;}function inputsWatchDelegate(scope,listener,objectEquality,parsedExpression,prettyPrintExpression){var inputExpressions=parsedExpression.inputs;var lastResult;if(inputExpressions.length===1){var oldInputValueOf=expressionInputDirtyCheck;// init to something unique so that equals check fails
	inputExpressions=inputExpressions[0];return scope.$watch(function expressionInputWatch(scope){var newInputValue=inputExpressions(scope);if(!expressionInputDirtyCheck(newInputValue,oldInputValueOf,inputExpressions.isPure)){lastResult=parsedExpression(scope,undefined,undefined,[newInputValue]);oldInputValueOf=newInputValue&&getValueOf(newInputValue);}return lastResult;},listener,objectEquality,prettyPrintExpression);}var oldInputValueOfValues=[];var oldInputValues=[];for(var i=0,ii=inputExpressions.length;i<ii;i++){oldInputValueOfValues[i]=expressionInputDirtyCheck;// init to something unique so that equals check fails
	oldInputValues[i]=null;}return scope.$watch(function expressionInputsWatch(scope){var changed=false;for(var i=0,ii=inputExpressions.length;i<ii;i++){var newInputValue=inputExpressions[i](scope);if(changed||(changed=!expressionInputDirtyCheck(newInputValue,oldInputValueOfValues[i],inputExpressions[i].isPure))){oldInputValues[i]=newInputValue;oldInputValueOfValues[i]=newInputValue&&getValueOf(newInputValue);}}if(changed){lastResult=parsedExpression(scope,undefined,undefined,oldInputValues);}return lastResult;},listener,objectEquality,prettyPrintExpression);}function oneTimeWatchDelegate(scope,listener,objectEquality,parsedExpression,prettyPrintExpression){var unwatch,lastValue;if(parsedExpression.inputs){unwatch=inputsWatchDelegate(scope,oneTimeListener,objectEquality,parsedExpression,prettyPrintExpression);}else{unwatch=scope.$watch(oneTimeWatch,oneTimeListener,objectEquality);}return unwatch;function oneTimeWatch(scope){return parsedExpression(scope);}function oneTimeListener(value,old,scope){lastValue=value;if(isFunction(listener)){listener(value,old,scope);}if(isDefined(value)){scope.$$postDigest(function(){if(isDefined(lastValue)){unwatch();}});}}}function oneTimeLiteralWatchDelegate(scope,listener,objectEquality,parsedExpression){var unwatch,lastValue;unwatch=scope.$watch(function oneTimeWatch(scope){return parsedExpression(scope);},function oneTimeListener(value,old,scope){lastValue=value;if(isFunction(listener)){listener(value,old,scope);}if(isAllDefined(value)){scope.$$postDigest(function(){if(isAllDefined(lastValue))unwatch();});}},objectEquality);return unwatch;function isAllDefined(value){var allDefined=true;forEach(value,function(val){if(!isDefined(val))allDefined=false;});return allDefined;}}function constantWatchDelegate(scope,listener,objectEquality,parsedExpression){var unwatch=scope.$watch(function constantWatch(scope){unwatch();return parsedExpression(scope);},listener,objectEquality);return unwatch;}function addInterceptor(parsedExpression,interceptorFn){if(!interceptorFn)return parsedExpression;var watchDelegate=parsedExpression.$$watchDelegate;var useInputs=false;var regularWatch=watchDelegate!==oneTimeLiteralWatchDelegate&&watchDelegate!==oneTimeWatchDelegate;var fn=regularWatch?function regularInterceptedExpression(scope,locals,assign,inputs){var value=useInputs&&inputs?inputs[0]:parsedExpression(scope,locals,assign,inputs);return interceptorFn(value,scope,locals);}:function oneTimeInterceptedExpression(scope,locals,assign,inputs){var value=parsedExpression(scope,locals,assign,inputs);var result=interceptorFn(value,scope,locals);// we only return the interceptor's result if the
	// initial value is defined (for bind-once)
	return isDefined(value)?result:value;};// Propagate $$watchDelegates other then inputsWatchDelegate
	useInputs=!parsedExpression.inputs;if(watchDelegate&&watchDelegate!==inputsWatchDelegate){fn.$$watchDelegate=watchDelegate;fn.inputs=parsedExpression.inputs;}else if(!interceptorFn.$stateful){// Treat interceptor like filters - assume non-stateful by default and use the inputsWatchDelegate
	fn.$$watchDelegate=inputsWatchDelegate;fn.inputs=parsedExpression.inputs?parsedExpression.inputs:[parsedExpression];}if(fn.inputs){fn.inputs=fn.inputs.map(function(e){// Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	// potentially non-pure interceptor function.
	if(e.isPure===PURITY_RELATIVE){return function depurifier(s){return e(s);};}return e;});}return fn;}}];}/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 *//**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */function $QProvider(){var errorOnUnhandledRejections=true;this.$get=['$rootScope','$exceptionHandler',function($rootScope,$exceptionHandler){return qFactory(function(callback){$rootScope.$evalAsync(callback);},$exceptionHandler,errorOnUnhandledRejections);}];/**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */this.errorOnUnhandledRejections=function(value){if(isDefined(value)){errorOnUnhandledRejections=value;return this;}else{return errorOnUnhandledRejections;}};}/** @this */function $$QProvider(){var errorOnUnhandledRejections=true;this.$get=['$browser','$exceptionHandler',function($browser,$exceptionHandler){return qFactory(function(callback){$browser.defer(callback);},$exceptionHandler,errorOnUnhandledRejections);}];this.errorOnUnhandledRejections=function(value){if(isDefined(value)){errorOnUnhandledRejections=value;return this;}else{return errorOnUnhandledRejections;}};}/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */function qFactory(nextTick,exceptionHandler,errorOnUnhandledRejections){var $qMinErr=minErr('$q',TypeError);var queueSize=0;var checkQueue=[];/**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */function defer(){return new Deferred();}function Deferred(){var promise=this.promise=new Promise();//Non prototype methods necessary to support unbound execution :/
	this.resolve=function(val){resolvePromise(promise,val);};this.reject=function(reason){rejectPromise(promise,reason);};this.notify=function(progress){notifyPromise(promise,progress);};}function Promise(){this.$$state={status:0};}extend(Promise.prototype,{then:function then(onFulfilled,onRejected,progressBack){if(isUndefined(onFulfilled)&&isUndefined(onRejected)&&isUndefined(progressBack)){return this;}var result=new Promise();this.$$state.pending=this.$$state.pending||[];this.$$state.pending.push([result,onFulfilled,onRejected,progressBack]);if(this.$$state.status>0)scheduleProcessQueue(this.$$state);return result;},'catch':function _catch(callback){return this.then(null,callback);},'finally':function _finally(callback,progressBack){return this.then(function(value){return handleCallback(value,resolve,callback);},function(error){return handleCallback(error,reject,callback);},progressBack);}});function processQueue(state){var fn,promise,pending;pending=state.pending;state.processScheduled=false;state.pending=undefined;try{for(var i=0,ii=pending.length;i<ii;++i){markQStateExceptionHandled(state);promise=pending[i][0];fn=pending[i][state.status];try{if(isFunction(fn)){resolvePromise(promise,fn(state.value));}else if(state.status===1){resolvePromise(promise,state.value);}else{rejectPromise(promise,state.value);}}catch(e){rejectPromise(promise,e);// This error is explicitly marked for being passed to the $exceptionHandler
	if(e&&e.$$passToExceptionHandler===true){exceptionHandler(e);}}}}finally{--queueSize;if(errorOnUnhandledRejections&&queueSize===0){nextTick(processChecks);}}}function processChecks(){// eslint-disable-next-line no-unmodified-loop-condition
	while(!queueSize&&checkQueue.length){var toCheck=checkQueue.shift();if(!isStateExceptionHandled(toCheck)){markQStateExceptionHandled(toCheck);var errorMessage='Possibly unhandled rejection: '+toDebugString(toCheck.value);if(isError(toCheck.value)){exceptionHandler(toCheck.value,errorMessage);}else{exceptionHandler(errorMessage);}}}}function scheduleProcessQueue(state){if(errorOnUnhandledRejections&&!state.pending&&state.status===2&&!isStateExceptionHandled(state)){if(queueSize===0&&checkQueue.length===0){nextTick(processChecks);}checkQueue.push(state);}if(state.processScheduled||!state.pending)return;state.processScheduled=true;++queueSize;nextTick(function(){processQueue(state);});}function resolvePromise(promise,val){if(promise.$$state.status)return;if(val===promise){$$reject(promise,$qMinErr('qcycle','Expected promise to be resolved with value other than itself \'{0}\'',val));}else{$$resolve(promise,val);}}function $$resolve(promise,val){var then;var done=false;try{if(isObject(val)||isFunction(val))then=val.then;if(isFunction(then)){promise.$$state.status=-1;then.call(val,doResolve,doReject,doNotify);}else{promise.$$state.value=val;promise.$$state.status=1;scheduleProcessQueue(promise.$$state);}}catch(e){doReject(e);}function doResolve(val){if(done)return;done=true;$$resolve(promise,val);}function doReject(val){if(done)return;done=true;$$reject(promise,val);}function doNotify(progress){notifyPromise(promise,progress);}}function rejectPromise(promise,reason){if(promise.$$state.status)return;$$reject(promise,reason);}function $$reject(promise,reason){promise.$$state.value=reason;promise.$$state.status=2;scheduleProcessQueue(promise.$$state);}function notifyPromise(promise,progress){var callbacks=promise.$$state.pending;if(promise.$$state.status<=0&&callbacks&&callbacks.length){nextTick(function(){var callback,result;for(var i=0,ii=callbacks.length;i<ii;i++){result=callbacks[i][0];callback=callbacks[i][3];try{notifyPromise(result,isFunction(callback)?callback(progress):progress);}catch(e){exceptionHandler(e);}}});}}/**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */function reject(reason){var result=new Promise();rejectPromise(result,reason);return result;}function handleCallback(value,resolver,callback){var callbackOutput=null;try{if(isFunction(callback))callbackOutput=callback();}catch(e){return reject(e);}if(isPromiseLike(callbackOutput)){return callbackOutput.then(function(){return resolver(value);},reject);}else{return resolver(value);}}/**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */function when(value,callback,errback,progressBack){var result=new Promise();resolvePromise(result,value);return result.then(callback,errback,progressBack);}/**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */var resolve=when;/**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */function all(promises){var result=new Promise(),counter=0,results=isArray(promises)?[]:{};forEach(promises,function(promise,key){counter++;when(promise).then(function(value){results[key]=value;if(! --counter)resolvePromise(result,results);},function(reason){rejectPromise(result,reason);});});if(counter===0){resolvePromise(result,results);}return result;}/**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */function race(promises){var deferred=defer();forEach(promises,function(promise){when(promise).then(deferred.resolve,deferred.reject);});return deferred.promise;}function $Q(resolver){if(!isFunction(resolver)){throw $qMinErr('norslvr','Expected resolverFn, got \'{0}\'',resolver);}var promise=new Promise();function resolveFn(value){resolvePromise(promise,value);}function rejectFn(reason){rejectPromise(promise,reason);}resolver(resolveFn,rejectFn);return promise;}// Let's make the instanceof operator work for promises, so that
	// `new $q(fn) instanceof $q` would evaluate to true.
	$Q.prototype=Promise.prototype;$Q.defer=defer;$Q.reject=reject;$Q.when=when;$Q.resolve=resolve;$Q.all=all;$Q.race=race;return $Q;}function isStateExceptionHandled(state){return!!state.pur;}function markQStateExceptionHandled(state){state.pur=true;}function markQExceptionHandled(q){markQStateExceptionHandled(q.$$state);}/** @this */function $$RAFProvider(){//rAF
	this.$get=['$window','$timeout',function($window,$timeout){var requestAnimationFrame=$window.requestAnimationFrame||$window.webkitRequestAnimationFrame;var cancelAnimationFrame=$window.cancelAnimationFrame||$window.webkitCancelAnimationFrame||$window.webkitCancelRequestAnimationFrame;var rafSupported=!!requestAnimationFrame;var raf=rafSupported?function(fn){var id=requestAnimationFrame(fn);return function(){cancelAnimationFrame(id);};}:function(fn){var timer=$timeout(fn,16.66,false);// 1000 / 60 = 16.666
	return function(){$timeout.cancel(timer);};};raf.supported=rafSupported;return raf;}];}/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 *//**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 *//**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 *//**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */function $RootScopeProvider(){var TTL=10;var $rootScopeMinErr=minErr('$rootScope');var lastDirtyWatch=null;var applyAsyncId=null;this.digestTtl=function(value){if(arguments.length){TTL=value;}return TTL;};function createChildScopeClass(parent){function ChildScope(){this.$$watchers=this.$$nextSibling=this.$$childHead=this.$$childTail=null;this.$$listeners={};this.$$listenerCount={};this.$$watchersCount=0;this.$id=nextUid();this.$$ChildScope=null;}ChildScope.prototype=parent;return ChildScope;}this.$get=['$exceptionHandler','$parse','$browser',function($exceptionHandler,$parse,$browser){function destroyChildScope($event){$event.currentScope.$$destroyed=true;}function cleanUpScope($scope){// Support: IE 9 only
	if(msie===9){// There is a memory leak in IE9 if all child scopes are not disconnected
	// completely when a scope is destroyed. So this code will recurse up through
	// all this scopes children
	//
	// See issue https://github.com/angular/angular.js/issues/10706
	if($scope.$$childHead){cleanUpScope($scope.$$childHead);}if($scope.$$nextSibling){cleanUpScope($scope.$$nextSibling);}}// The code below works around IE9 and V8's memory leaks
	//
	// See:
	// - https://code.google.com/p/v8/issues/detail?id=2073#c26
	// - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	// - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	$scope.$parent=$scope.$$nextSibling=$scope.$$prevSibling=$scope.$$childHead=$scope.$$childTail=$scope.$root=$scope.$$watchers=null;}/**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */function Scope(){this.$id=nextUid();this.$$phase=this.$parent=this.$$watchers=this.$$nextSibling=this.$$prevSibling=this.$$childHead=this.$$childTail=null;this.$root=this;this.$$destroyed=false;this.$$listeners={};this.$$listenerCount={};this.$$watchersCount=0;this.$$isolateBindings=null;}/**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     *//**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      *//**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */Scope.prototype={constructor:Scope,/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */$new:function $new(isolate,parent){var child;parent=parent||this;if(isolate){child=new Scope();child.$root=this.$root;}else{// Only create a child scope class if somebody asks for one,
	// but cache it to allow the VM to optimize lookups.
	if(!this.$$ChildScope){this.$$ChildScope=createChildScopeClass(this);}child=new this.$$ChildScope();}child.$parent=parent;child.$$prevSibling=parent.$$childTail;if(parent.$$childHead){parent.$$childTail.$$nextSibling=child;parent.$$childTail=child;}else{parent.$$childHead=parent.$$childTail=child;}// When the new scope is not isolated or we inherit from `this`, and
	// the parent scope is destroyed, the property `$$destroyed` is inherited
	// prototypically. In all other cases, this property needs to be set
	// when the parent scope is destroyed.
	// The listener needs to be added after the parent is set
	if(isolate||parent!==this)child.$on('$destroy',destroyChildScope);return child;},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */$watch:function $watch(watchExp,listener,objectEquality,prettyPrintExpression){var get=$parse(watchExp);var fn=isFunction(listener)?listener:noop;if(get.$$watchDelegate){return get.$$watchDelegate(this,fn,objectEquality,get,watchExp);}var scope=this,array=scope.$$watchers,watcher={fn:fn,last:initWatchVal,get:get,exp:prettyPrintExpression||watchExp,eq:!!objectEquality};lastDirtyWatch=null;if(!array){array=scope.$$watchers=[];array.$$digestWatchIndex=-1;}// we use unshift since we use a while loop in $digest for speed.
	// the while loop reads in reverse order.
	array.unshift(watcher);array.$$digestWatchIndex++;incrementWatchersCount(this,1);return function deregisterWatch(){var index=arrayRemove(array,watcher);if(index>=0){incrementWatchersCount(scope,-1);if(index<array.$$digestWatchIndex){array.$$digestWatchIndex--;}}lastDirtyWatch=null;};},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * `$watchGroup` is more performant than watching each expression individually, and should be
	       * used when the listener does not need to know which expression has changed.
	       * If the listener needs to know which expression has changed,
	       * {@link ng.$rootScope.Scope#$watch $watch()} or
	       * {@link ng.$rootScope.Scope#$watchCollection $watchCollection()} should be used.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`.
	       *
	       *    Note that `newValues` and `oldValues` reflect the differences in each **individual**
	       *    expression, and not the difference of the values between each call of the listener.
	       *    That means the difference between `newValues` and `oldValues` cannot be used to determine
	       *    which expression has changed / remained stable:
	       *
	       *    ```js
	       *
	       *    $scope.$watchGroup(['v1', 'v2'], function(newValues, oldValues) {
	       *      console.log(newValues, oldValues);
	       *    });
	       *
	       *    // newValues, oldValues initially
	       *    // [undefined, undefined], [undefined, undefined]
	       *
	       *    $scope.v1 = 'a';
	       *    $scope.v2 = 'a';
	       *
	       *    // ['a', 'a'], [undefined, undefined]
	       *
	       *    $scope.v2 = 'b'
	       *
	       *    // v1 hasn't changed since it became `'a'`, therefore its oldValue is still `undefined`
	       *    // ['a', 'b'], [undefined, 'a']
	       *
	       *    ```
	       *
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */$watchGroup:function $watchGroup(watchExpressions,listener){var oldValues=new Array(watchExpressions.length);var newValues=new Array(watchExpressions.length);var deregisterFns=[];var self=this;var changeReactionScheduled=false;var firstRun=true;if(!watchExpressions.length){// No expressions means we call the listener ASAP
	var shouldCall=true;self.$evalAsync(function(){if(shouldCall)listener(newValues,newValues,self);});return function deregisterWatchGroup(){shouldCall=false;};}if(watchExpressions.length===1){// Special case size of one
	return this.$watch(watchExpressions[0],function watchGroupAction(value,oldValue,scope){newValues[0]=value;oldValues[0]=oldValue;listener(newValues,value===oldValue?newValues:oldValues,scope);});}forEach(watchExpressions,function(expr,i){var unwatchFn=self.$watch(expr,function watchGroupSubAction(value,oldValue){newValues[i]=value;oldValues[i]=oldValue;if(!changeReactionScheduled){changeReactionScheduled=true;self.$evalAsync(watchGroupAction);}});deregisterFns.push(unwatchFn);});function watchGroupAction(){changeReactionScheduled=false;if(firstRun){firstRun=false;listener(newValues,newValues,self);}else{listener(newValues,oldValues,self);}}return function deregisterWatchGroup(){while(deregisterFns.length){deregisterFns.shift()();}};},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */$watchCollection:function $watchCollection(obj,listener){$watchCollectionInterceptor.$stateful=true;var self=this;// the current value, updated on each dirty-check run
	var newValue;// a shallow copy of the newValue from the last dirty-check run,
	// updated to match newValue during dirty-check run
	var oldValue;// a shallow copy of the newValue from when the last change happened
	var veryOldValue;// only track veryOldValue if the listener is asking for it
	var trackVeryOldValue=listener.length>1;var changeDetected=0;var changeDetector=$parse(obj,$watchCollectionInterceptor);var internalArray=[];var internalObject={};var initRun=true;var oldLength=0;function $watchCollectionInterceptor(_value){newValue=_value;var newLength,key,bothNaN,newItem,oldItem;// If the new value is undefined, then return undefined as the watch may be a one-time watch
	if(isUndefined(newValue))return;if(!isObject(newValue)){// if primitive
	if(oldValue!==newValue){oldValue=newValue;changeDetected++;}}else if(isArrayLike(newValue)){if(oldValue!==internalArray){// we are transitioning from something which was not an array into array.
	oldValue=internalArray;oldLength=oldValue.length=0;changeDetected++;}newLength=newValue.length;if(oldLength!==newLength){// if lengths do not match we need to trigger change notification
	changeDetected++;oldValue.length=oldLength=newLength;}// copy the items to oldValue and look for changes.
	for(var i=0;i<newLength;i++){oldItem=oldValue[i];newItem=newValue[i];// eslint-disable-next-line no-self-compare
	bothNaN=oldItem!==oldItem&&newItem!==newItem;if(!bothNaN&&oldItem!==newItem){changeDetected++;oldValue[i]=newItem;}}}else{if(oldValue!==internalObject){// we are transitioning from something which was not an object into object.
	oldValue=internalObject={};oldLength=0;changeDetected++;}// copy the items to oldValue and look for changes.
	newLength=0;for(key in newValue){if(hasOwnProperty.call(newValue,key)){newLength++;newItem=newValue[key];oldItem=oldValue[key];if(key in oldValue){// eslint-disable-next-line no-self-compare
	bothNaN=oldItem!==oldItem&&newItem!==newItem;if(!bothNaN&&oldItem!==newItem){changeDetected++;oldValue[key]=newItem;}}else{oldLength++;oldValue[key]=newItem;changeDetected++;}}}if(oldLength>newLength){// we used to have more keys, need to find them and destroy them.
	changeDetected++;for(key in oldValue){if(!hasOwnProperty.call(newValue,key)){oldLength--;delete oldValue[key];}}}}return changeDetected;}function $watchCollectionAction(){if(initRun){initRun=false;listener(newValue,newValue,self);}else{listener(newValue,veryOldValue,self);}// make a copy for the next time a collection is changed
	if(trackVeryOldValue){if(!isObject(newValue)){//primitive
	veryOldValue=newValue;}else if(isArrayLike(newValue)){veryOldValue=new Array(newValue.length);for(var i=0;i<newValue.length;i++){veryOldValue[i]=newValue[i];}}else{// if object
	veryOldValue={};for(var key in newValue){if(hasOwnProperty.call(newValue,key)){veryOldValue[key]=newValue[key];}}}}}return this.$watch(changeDetector,$watchCollectionAction);},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */$digest:function $digest(){var watch,value,last,fn,get,watchers,dirty,ttl=TTL,next,current,target=this,watchLog=[],logIdx,asyncTask;beginPhase('$digest');// Check for changes to browser url that happened in sync before the call to $digest
	$browser.$$checkUrlChange();if(this===$rootScope&&applyAsyncId!==null){// If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	// cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	$browser.defer.cancel(applyAsyncId);flushApplyAsync();}lastDirtyWatch=null;do{// "while dirty" loop
	dirty=false;current=target;// It's safe for asyncQueuePosition to be a local variable here because this loop can't
	// be reentered recursively. Calling $digest from a function passed to $evalAsync would
	// lead to a '$digest already in progress' error.
	for(var asyncQueuePosition=0;asyncQueuePosition<asyncQueue.length;asyncQueuePosition++){try{asyncTask=asyncQueue[asyncQueuePosition];fn=asyncTask.fn;fn(asyncTask.scope,asyncTask.locals);}catch(e){$exceptionHandler(e);}lastDirtyWatch=null;}asyncQueue.length=0;traverseScopesLoop:do{// "traverse the scopes" loop
	if(watchers=current.$$watchers){// process our watches
	watchers.$$digestWatchIndex=watchers.length;while(watchers.$$digestWatchIndex--){try{watch=watchers[watchers.$$digestWatchIndex];// Most common watches are on primitives, in which case we can short
	// circuit it with === operator, only when === fails do we use .equals
	if(watch){get=watch.get;if((value=get(current))!==(last=watch.last)&&!(watch.eq?equals(value,last):isNumberNaN(value)&&isNumberNaN(last))){dirty=true;lastDirtyWatch=watch;watch.last=watch.eq?copy(value,null):value;fn=watch.fn;fn(value,last===initWatchVal?value:last,current);if(ttl<5){logIdx=4-ttl;if(!watchLog[logIdx])watchLog[logIdx]=[];watchLog[logIdx].push({msg:isFunction(watch.exp)?'fn: '+(watch.exp.name||watch.exp.toString()):watch.exp,newVal:value,oldVal:last});}}else if(watch===lastDirtyWatch){// If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	// have already been tested.
	dirty=false;break traverseScopesLoop;}}}catch(e){$exceptionHandler(e);}}}// Insanity Warning: scope depth-first traversal
	// yes, this code is a bit crazy, but it works and we have tests to prove it!
	// this piece should be kept in sync with the traversal in $broadcast
	if(!(next=current.$$watchersCount&&current.$$childHead||current!==target&&current.$$nextSibling)){while(current!==target&&!(next=current.$$nextSibling)){current=current.$parent;}}}while(current=next);// `break traverseScopesLoop;` takes us to here
	if((dirty||asyncQueue.length)&&!ttl--){clearPhase();throw $rootScopeMinErr('infdig','{0} $digest() iterations reached. Aborting!\n'+'Watchers fired in the last 5 iterations: {1}',TTL,watchLog);}}while(dirty||asyncQueue.length);clearPhase();// postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	while(postDigestQueuePosition<postDigestQueue.length){try{postDigestQueue[postDigestQueuePosition++]();}catch(e){$exceptionHandler(e);}}postDigestQueue.length=postDigestQueuePosition=0;// Check for changes to browser url that happened during the $digest
	// (for which no event is fired; e.g. via `history.pushState()`)
	$browser.$$checkUrlChange();},/**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       *//**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */$destroy:function $destroy(){// We can't destroy a scope that has been already destroyed.
	if(this.$$destroyed)return;var parent=this.$parent;this.$broadcast('$destroy');this.$$destroyed=true;if(this===$rootScope){//Remove handlers attached to window when $rootScope is removed
	$browser.$$applicationDestroyed();}incrementWatchersCount(this,-this.$$watchersCount);for(var eventName in this.$$listenerCount){decrementListenerCount(this,this.$$listenerCount[eventName],eventName);}// sever all the references to parent scopes (after this cleanup, the current scope should
	// not be retained by any of our references and should be eligible for garbage collection)
	if(parent&&parent.$$childHead===this)parent.$$childHead=this.$$nextSibling;if(parent&&parent.$$childTail===this)parent.$$childTail=this.$$prevSibling;if(this.$$prevSibling)this.$$prevSibling.$$nextSibling=this.$$nextSibling;if(this.$$nextSibling)this.$$nextSibling.$$prevSibling=this.$$prevSibling;// Disable listeners, watchers and apply/digest methods
	this.$destroy=this.$digest=this.$apply=this.$evalAsync=this.$applyAsync=noop;this.$on=this.$watch=this.$watchGroup=function(){return noop;};this.$$listeners={};// Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	this.$$nextSibling=null;cleanUpScope(this);},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */$eval:function $eval(expr,locals){return $parse(expr)(this,locals);},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */$evalAsync:function $evalAsync(expr,locals){// if we are outside of an $digest loop and this is the first time we are scheduling async
	// task also schedule async auto-flush
	if(!$rootScope.$$phase&&!asyncQueue.length){$browser.defer(function(){if(asyncQueue.length){$rootScope.$digest();}});}asyncQueue.push({scope:this,fn:$parse(expr),locals:locals});},$$postDigest:function $$postDigest(fn){postDigestQueue.push(fn);},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */$apply:function $apply(expr){try{beginPhase('$apply');try{return this.$eval(expr);}finally{clearPhase();}}catch(e){$exceptionHandler(e);}finally{try{$rootScope.$digest();}catch(e){$exceptionHandler(e);// eslint-disable-next-line no-unsafe-finally
	throw e;}}},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */$applyAsync:function $applyAsync(expr){var scope=this;if(expr){applyAsyncQueue.push($applyAsyncExpression);}expr=$parse(expr);scheduleApplyAsync();function $applyAsyncExpression(){scope.$eval(expr);}},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */$on:function $on(name,listener){var namedListeners=this.$$listeners[name];if(!namedListeners){this.$$listeners[name]=namedListeners=[];}namedListeners.push(listener);var current=this;do{if(!current.$$listenerCount[name]){current.$$listenerCount[name]=0;}current.$$listenerCount[name]++;}while(current=current.$parent);var self=this;return function(){var indexOfListener=namedListeners.indexOf(listener);if(indexOfListener!==-1){// Use delete in the hope of the browser deallocating the memory for the array entry,
	// while not shifting the array indexes of other listeners.
	// See issue https://github.com/angular/angular.js/issues/16135
	delete namedListeners[indexOfListener];decrementListenerCount(self,1,name);}};},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */$emit:function $emit(name,args){var empty=[],namedListeners,scope=this,_stopPropagation=false,event={name:name,targetScope:scope,stopPropagation:function stopPropagation(){_stopPropagation=true;},preventDefault:function preventDefault(){event.defaultPrevented=true;},defaultPrevented:false},listenerArgs=concat([event],arguments,1),i,length;do{namedListeners=scope.$$listeners[name]||empty;event.currentScope=scope;for(i=0,length=namedListeners.length;i<length;i++){// if listeners were deregistered, defragment the array
	if(!namedListeners[i]){namedListeners.splice(i,1);i--;length--;continue;}try{//allow all listeners attached to the current scope to run
	namedListeners[i].apply(null,listenerArgs);}catch(e){$exceptionHandler(e);}}//if any listener on the current scope stops propagation, prevent bubbling
	if(_stopPropagation){break;}//traverse upwards
	scope=scope.$parent;}while(scope);event.currentScope=null;return event;},/**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */$broadcast:function $broadcast(name,args){var target=this,current=target,next=target,event={name:name,targetScope:target,preventDefault:function preventDefault(){event.defaultPrevented=true;},defaultPrevented:false};if(!target.$$listenerCount[name])return event;var listenerArgs=concat([event],arguments,1),listeners,i,length;//down while you can, then up and next sibling or up and next sibling until back at root
	while(current=next){event.currentScope=current;listeners=current.$$listeners[name]||[];for(i=0,length=listeners.length;i<length;i++){// if listeners were deregistered, defragment the array
	if(!listeners[i]){listeners.splice(i,1);i--;length--;continue;}try{listeners[i].apply(null,listenerArgs);}catch(e){$exceptionHandler(e);}}// Insanity Warning: scope depth-first traversal
	// yes, this code is a bit crazy, but it works and we have tests to prove it!
	// this piece should be kept in sync with the traversal in $digest
	// (though it differs due to having the extra check for $$listenerCount)
	if(!(next=current.$$listenerCount[name]&&current.$$childHead||current!==target&&current.$$nextSibling)){while(current!==target&&!(next=current.$$nextSibling)){current=current.$parent;}}}event.currentScope=null;return event;}};var $rootScope=new Scope();//The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	var asyncQueue=$rootScope.$$asyncQueue=[];var postDigestQueue=$rootScope.$$postDigestQueue=[];var applyAsyncQueue=$rootScope.$$applyAsyncQueue=[];var postDigestQueuePosition=0;return $rootScope;function beginPhase(phase){if($rootScope.$$phase){throw $rootScopeMinErr('inprog','{0} already in progress',$rootScope.$$phase);}$rootScope.$$phase=phase;}function clearPhase(){$rootScope.$$phase=null;}function incrementWatchersCount(current,count){do{current.$$watchersCount+=count;}while(current=current.$parent);}function decrementListenerCount(current,count,name){do{current.$$listenerCount[name]-=count;if(current.$$listenerCount[name]===0){delete current.$$listenerCount[name];}}while(current=current.$parent);}/**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */function initWatchVal(){}function flushApplyAsync(){while(applyAsyncQueue.length){try{applyAsyncQueue.shift()();}catch(e){$exceptionHandler(e);}}applyAsyncId=null;}function scheduleApplyAsync(){if(applyAsyncId===null){applyAsyncId=$browser.defer(function(){$rootScope.$apply(flushApplyAsync);});}}}];}/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */// the implementation is in angular.bootstrap
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */function $$SanitizeUriProvider(){var aHrefSanitizationWhitelist=/^\s*(https?|s?ftp|mailto|tel|file):/,imgSrcSanitizationWhitelist=/^\s*((https?|ftp|file|blob):|data:image\/)/;/**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */this.aHrefSanitizationWhitelist=function(regexp){if(isDefined(regexp)){aHrefSanitizationWhitelist=regexp;return this;}return aHrefSanitizationWhitelist;};/**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */this.imgSrcSanitizationWhitelist=function(regexp){if(isDefined(regexp)){imgSrcSanitizationWhitelist=regexp;return this;}return imgSrcSanitizationWhitelist;};this.$get=function(){return function sanitizeUri(uri,isImage){var regex=isImage?imgSrcSanitizationWhitelist:aHrefSanitizationWhitelist;var normalizedVal;normalizedVal=urlResolve(uri&&uri.trim()).href;if(normalizedVal!==''&&!normalizedVal.match(regex)){return'unsafe:'+normalizedVal;}return uri;};};}/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *//* exported $SceProvider, $SceDelegateProvider */var $sceMinErr=minErr('$sce');var SCE_CONTEXTS={// HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	HTML:'html',// Style statements or stylesheets. Currently unused in AngularJS.
	CSS:'css',// An URL used in a context where it does not refer to a resource that loads code. Currently
	// unused in AngularJS.
	URL:'url',// RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	// code. (e.g. ng-include, script src binding, templateUrl)
	RESOURCE_URL:'resourceUrl',// Script. Currently unused in AngularJS.
	JS:'js'};// Helper functions follow.
	var UNDERSCORE_LOWERCASE_REGEXP=/_([a-z])/g;function snakeToCamel(name){return name.replace(UNDERSCORE_LOWERCASE_REGEXP,fnCamelCaseReplace);}function adjustMatcher(matcher){if(matcher==='self'){return matcher;}else if(isString(matcher)){// Strings match exactly except for 2 wildcards - '*' and '**'.
	// '*' matches any character except those from the set ':/.?&'.
	// '**' matches any character (like .* in a RegExp).
	// More than 2 *'s raises an error as it's ill defined.
	if(matcher.indexOf('***')>-1){throw $sceMinErr('iwcard','Illegal sequence *** in string matcher.  String: {0}',matcher);}matcher=escapeForRegexp(matcher).replace(/\\\*\\\*/g,'.*').replace(/\\\*/g,'[^:/.?&;]*');return new RegExp('^'+matcher+'$');}else if(isRegExp(matcher)){// The only other type of matcher allowed is a Regexp.
	// Match entire URL / disallow partial matches.
	// Flags are reset (i.e. no global, ignoreCase or multiline)
	return new RegExp('^'+matcher.source+'$');}else{throw $sceMinErr('imatcher','Matchers may only be "self", string patterns or RegExp objects');}}function adjustMatchers(matchers){var adjustedMatchers=[];if(isDefined(matchers)){forEach(matchers,function(matcher){adjustedMatchers.push(adjustMatcher(matcher));});}return adjustedMatchers;}/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *//**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */function $SceDelegateProvider(){this.SCE_CONTEXTS=SCE_CONTEXTS;// Resource URLs can also be trusted by policy.
	var resourceUrlWhitelist=['self'],resourceUrlBlacklist=[];/**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */this.resourceUrlWhitelist=function(value){if(arguments.length){resourceUrlWhitelist=adjustMatchers(value);}return resourceUrlWhitelist;};/**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */this.resourceUrlBlacklist=function(value){if(arguments.length){resourceUrlBlacklist=adjustMatchers(value);}return resourceUrlBlacklist;};this.$get=['$injector',function($injector){var htmlSanitizer=function htmlSanitizer(html){throw $sceMinErr('unsafe','Attempting to use an unsafe value in a safe context.');};if($injector.has('$sanitize')){htmlSanitizer=$injector.get('$sanitize');}function matchUrl(matcher,parsedUrl){if(matcher==='self'){return urlIsSameOrigin(parsedUrl);}else{// definitely a regex.  See adjustMatchers()
	return!!matcher.exec(parsedUrl.href);}}function isResourceUrlAllowedByPolicy(url){var parsedUrl=urlResolve(url.toString());var i,n,allowed=false;// Ensure that at least one item from the whitelist allows this url.
	for(i=0,n=resourceUrlWhitelist.length;i<n;i++){if(matchUrl(resourceUrlWhitelist[i],parsedUrl)){allowed=true;break;}}if(allowed){// Ensure that no item from the blacklist blocked this url.
	for(i=0,n=resourceUrlBlacklist.length;i<n;i++){if(matchUrl(resourceUrlBlacklist[i],parsedUrl)){allowed=false;break;}}}return allowed;}function generateHolderType(Base){var holderType=function TrustedValueHolderType(trustedValue){this.$$unwrapTrustedValue=function(){return trustedValue;};};if(Base){holderType.prototype=new Base();}holderType.prototype.valueOf=function sceValueOf(){return this.$$unwrapTrustedValue();};holderType.prototype.toString=function sceToString(){return this.$$unwrapTrustedValue().toString();};return holderType;}var trustedValueHolderBase=generateHolderType(),byType={};byType[SCE_CONTEXTS.HTML]=generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.CSS]=generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.URL]=generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.JS]=generateHolderType(trustedValueHolderBase);byType[SCE_CONTEXTS.RESOURCE_URL]=generateHolderType(byType[SCE_CONTEXTS.URL]);/**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */function trustAs(type,trustedValue){var Constructor=byType.hasOwnProperty(type)?byType[type]:null;if(!Constructor){throw $sceMinErr('icontext','Attempted to trust a value in invalid context. Context: {0}; Value: {1}',type,trustedValue);}if(trustedValue===null||isUndefined(trustedValue)||trustedValue===''){return trustedValue;}// All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	// mutable objects, we ensure here that the value passed in is actually a string.
	if(typeof trustedValue!=='string'){throw $sceMinErr('itype','Attempted to trust a non-string value in a content requiring a string: Context: {0}',type);}return new Constructor(trustedValue);}/**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */function valueOf(maybeTrusted){if(maybeTrusted instanceof trustedValueHolderBase){return maybeTrusted.$$unwrapTrustedValue();}else{return maybeTrusted;}}/**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes any input, and either returns a value that's safe to use in the specified context, or
	     * throws an exception.
	     *
	     * In practice, there are several cases. When given a string, this function runs checks
	     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
	     * value if that value's context is valid for this call's context. Finally, this function can
	     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
	     * is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */function getTrusted(type,maybeTrusted){if(maybeTrusted===null||isUndefined(maybeTrusted)||maybeTrusted===''){return maybeTrusted;}var constructor=byType.hasOwnProperty(type)?byType[type]:null;// If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	// as-is.
	if(constructor&&maybeTrusted instanceof constructor){return maybeTrusted.$$unwrapTrustedValue();}// Otherwise, if we get here, then we may either make it safe, or throw an exception. This
	// depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
	// some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
	// has no corresponding sinks.
	if(type===SCE_CONTEXTS.RESOURCE_URL){// RESOURCE_URL uses a whitelist.
	if(isResourceUrlAllowedByPolicy(maybeTrusted)){return maybeTrusted;}else{throw $sceMinErr('insecurl','Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',maybeTrusted.toString());}}else if(type===SCE_CONTEXTS.HTML){// htmlSanitizer throws its own error when no sanitizer is available.
	return htmlSanitizer(maybeTrusted);}// Default error when the $sce service has no way to make the input safe.
	throw $sceMinErr('unsafe','Attempting to use an unsafe value in a safe context.');}return{trustAs:trustAs,getTrusted:getTrusted,valueOf:valueOf};}];}/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *//**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
	 * also use the `$sanitize` service if it is available when binding untrusted values to
	 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
	 *
	 *
	 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
	 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
	 * might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */function $SceProvider(){var enabled=true;/**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */this.enabled=function(value){if(arguments.length){enabled=!!value;}return enabled;};/* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */this.$get=['$parse','$sceDelegate',function($parse,$sceDelegate){// Support: IE 9-11 only
	// Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	// the "expression(javascript expression)" syntax which is insecure.
	if(enabled&&msie<8){throw $sceMinErr('iequirks','Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks '+'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML '+'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');}var sce=shallowCopy(SCE_CONTEXTS);/**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */sce.isEnabled=function(){return enabled;};sce.trustAs=$sceDelegate.trustAs;sce.getTrusted=$sceDelegate.getTrusted;sce.valueOf=$sceDelegate.valueOf;if(!enabled){sce.trustAs=sce.getTrusted=function(type,value){return value;};sce.valueOf=identity;}/**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */sce.parseAs=function sceParseAs(type,expr){var parsed=$parse(expr);if(parsed.literal&&parsed.constant){return parsed;}else{return $parse(expr,function(value){return sce.getTrusted(type,value);});}};/**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     *//**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     *//**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */// Shorthand delegations.
	var parse=sce.parseAs,getTrusted=sce.getTrusted,trustAs=sce.trustAs;forEach(SCE_CONTEXTS,function(enumValue,name){var lName=lowercase(name);sce[snakeToCamel('parse_as_'+lName)]=function(expr){return parse(enumValue,expr);};sce[snakeToCamel('get_trusted_'+lName)]=function(value){return getTrusted(enumValue,value);};sce[snakeToCamel('trust_as_'+lName)]=function(value){return trustAs(enumValue,value);};});return sce;}];}/* exported $SnifferProvider *//**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */function $SnifferProvider(){this.$get=['$window','$document',function($window,$document){var eventSupport={},// Chrome Packaged Apps are not allowed to access `history.pushState`.
	// If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	// (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	// the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	// (see https://developer.chrome.com/apps/manifest/sandbox).
	// (NW.js apps have access to Chrome APIs, but do support `history`.)
	isNw=$window.nw&&$window.nw.process,isChromePackagedApp=!isNw&&$window.chrome&&($window.chrome.app&&$window.chrome.app.runtime||!$window.chrome.app&&$window.chrome.runtime&&$window.chrome.runtime.id),hasHistoryPushState=!isChromePackagedApp&&$window.history&&$window.history.pushState,android=toInt((/android (\d+)/.exec(lowercase(($window.navigator||{}).userAgent))||[])[1]),boxee=/Boxee/i.test(($window.navigator||{}).userAgent),document=$document[0]||{},bodyStyle=document.body&&document.body.style,transitions=false,animations=false;if(bodyStyle){// Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	// Mentioned browsers need a -webkit- prefix for transitions & animations.
	transitions=!!('transition'in bodyStyle||'webkitTransition'in bodyStyle);animations=!!('animation'in bodyStyle||'webkitAnimation'in bodyStyle);}return{// Android has history.pushState, but it does not update location correctly
	// so let's not use the history API at all.
	// http://code.google.com/p/android/issues/detail?id=17471
	// https://github.com/angular/angular.js/issues/904
	// older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	// so let's not use the history API also
	// We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	history:!!(hasHistoryPushState&&!(android<4)&&!boxee),hasEvent:function hasEvent(event){// Support: IE 9-11 only
	// IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	// it. In particular the event is not fired when backspace or delete key are pressed or
	// when cut operation is performed.
	// IE10+ implements 'input' event but it erroneously fires under various situations,
	// e.g. when placeholder changes, or a form is focused.
	if(event==='input'&&msie)return false;if(isUndefined(eventSupport[event])){var divElm=document.createElement('div');eventSupport[event]='on'+event in divElm;}return eventSupport[event];},csp:csp(),transitions:transitions,animations:animations,android:android};}];}var $templateRequestMinErr=minErr('$compile');/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */function $TemplateRequestProvider(){var httpOptions;/**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */this.httpOptions=function(val){if(val){httpOptions=val;return this;}return httpOptions;};/**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */this.$get=['$exceptionHandler','$templateCache','$http','$q','$sce',function($exceptionHandler,$templateCache,$http,$q,$sce){function handleRequestFn(tpl,ignoreRequestError){handleRequestFn.totalPendingRequests++;// We consider the template cache holds only trusted templates, so
	// there's no need to go through whitelisting again for keys that already
	// are included in there. This also makes AngularJS accept any script
	// directive, no matter its name. However, we still need to unwrap trusted
	// types.
	if(!isString(tpl)||isUndefined($templateCache.get(tpl))){tpl=$sce.getTrustedResourceUrl(tpl);}var transformResponse=$http.defaults&&$http.defaults.transformResponse;if(isArray(transformResponse)){transformResponse=transformResponse.filter(function(transformer){return transformer!==defaultHttpResponseTransform;});}else if(transformResponse===defaultHttpResponseTransform){transformResponse=null;}return $http.get(tpl,extend({cache:$templateCache,transformResponse:transformResponse},httpOptions)).finally(function(){handleRequestFn.totalPendingRequests--;}).then(function(response){$templateCache.put(tpl,response.data);return response.data;},handleError);function handleError(resp){if(!ignoreRequestError){resp=$templateRequestMinErr('tpload','Failed to load template: {0} (HTTP status: {1} {2})',tpl,resp.status,resp.statusText);$exceptionHandler(resp);}return $q.reject(resp);}}handleRequestFn.totalPendingRequests=0;return handleRequestFn;}];}/** @this */function $$TestabilityProvider(){this.$get=['$rootScope','$browser','$location',function($rootScope,$browser,$location){/**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */var testability={};/**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */testability.findBindings=function(element,expression,opt_exactMatch){var bindings=element.getElementsByClassName('ng-binding');var matches=[];forEach(bindings,function(binding){var dataBinding=angular.element(binding).data('$binding');if(dataBinding){forEach(dataBinding,function(bindingName){if(opt_exactMatch){var matcher=new RegExp('(^|\\s)'+escapeForRegexp(expression)+'(\\s|\\||$)');if(matcher.test(bindingName)){matches.push(binding);}}else{if(bindingName.indexOf(expression)!==-1){matches.push(binding);}}});}});return matches;};/**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */testability.findModels=function(element,expression,opt_exactMatch){var prefixes=['ng-','data-ng-','ng\\:'];for(var p=0;p<prefixes.length;++p){var attributeEquals=opt_exactMatch?'=':'*=';var selector='['+prefixes[p]+'model'+attributeEquals+'"'+expression+'"]';var elements=element.querySelectorAll(selector);if(elements.length){return elements;}}};/**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */testability.getLocation=function(){return $location.url();};/**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */testability.setLocation=function(url){if(url!==$location.url()){$location.url(url);$rootScope.$digest();}};/**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */testability.whenStable=function(callback){$browser.notifyWhenNoOutstandingRequests(callback);};return testability;}];}/** @this */function $TimeoutProvider(){this.$get=['$rootScope','$browser','$q','$$q','$exceptionHandler',function($rootScope,$browser,$q,$$q,$exceptionHandler){var deferreds={};/**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */function timeout(fn,delay,invokeApply){if(!isFunction(fn)){invokeApply=delay;delay=fn;fn=noop;}var args=sliceArgs(arguments,3),skipApply=isDefined(invokeApply)&&!invokeApply,deferred=(skipApply?$$q:$q).defer(),promise=deferred.promise,timeoutId;timeoutId=$browser.defer(function(){try{deferred.resolve(fn.apply(null,args));}catch(e){deferred.reject(e);$exceptionHandler(e);}finally{delete deferreds[promise.$$timeoutId];}if(!skipApply)$rootScope.$apply();},delay);promise.$$timeoutId=timeoutId;deferreds[timeoutId]=deferred;return promise;}/**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */timeout.cancel=function(promise){if(promise&&promise.$$timeoutId in deferreds){// Timeout cancels should not report an unhandled promise.
	markQExceptionHandled(deferreds[promise.$$timeoutId].promise);deferreds[promise.$$timeoutId].reject('canceled');delete deferreds[promise.$$timeoutId];return $browser.defer.cancel(promise.$$timeoutId);}return false;};return timeout;}];}// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode=window.document.createElement('a');var originUrl=urlResolve(window.location.href);/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */function urlResolve(url){var href=url;// Support: IE 9-11 only
	if(msie){// Normalize before parse.  Refer Implementation Notes on why this is
	// done in two steps on IE.
	urlParsingNode.setAttribute('href',href);href=urlParsingNode.href;}urlParsingNode.setAttribute('href',href);// urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	return{href:urlParsingNode.href,protocol:urlParsingNode.protocol?urlParsingNode.protocol.replace(/:$/,''):'',host:urlParsingNode.host,search:urlParsingNode.search?urlParsingNode.search.replace(/^\?/,''):'',hash:urlParsingNode.hash?urlParsingNode.hash.replace(/^#/,''):'',hostname:urlParsingNode.hostname,port:urlParsingNode.port,pathname:urlParsingNode.pathname.charAt(0)==='/'?urlParsingNode.pathname:'/'+urlParsingNode.pathname};}/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */function urlIsSameOrigin(requestUrl){var parsed=isString(requestUrl)?urlResolve(requestUrl):requestUrl;return parsed.protocol===originUrl.protocol&&parsed.host===originUrl.host;}/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */function $WindowProvider(){this.$get=valueFn(window);}/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */function $$CookieReader($document){var rawDocument=$document[0]||{};var lastCookies={};var lastCookieString='';function safeGetCookie(rawDocument){try{return rawDocument.cookie||'';}catch(e){return'';}}function safeDecodeURIComponent(str){try{return decodeURIComponent(str);}catch(e){return str;}}return function(){var cookieArray,cookie,i,index,name;var currentCookieString=safeGetCookie(rawDocument);if(currentCookieString!==lastCookieString){lastCookieString=currentCookieString;cookieArray=lastCookieString.split('; ');lastCookies={};for(i=0;i<cookieArray.length;i++){cookie=cookieArray[i];index=cookie.indexOf('=');if(index>0){//ignore nameless cookies
	name=safeDecodeURIComponent(cookie.substring(0,index));// the first value that is seen for a cookie is the most
	// specific one.  values for the same cookie name that
	// follow are for less specific paths.
	if(isUndefined(lastCookies[name])){lastCookies[name]=safeDecodeURIComponent(cookie.substring(index+1));}}}}return lastCookies;};}$$CookieReader.$inject=['$document'];/** @this */function $$CookieReaderProvider(){this.$get=$$CookieReader;}/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 *//**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 *//**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */$FilterProvider.$inject=['$provide'];/** @this */function $FilterProvider($provide){var suffix='Filter';/**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */function register(name,factory){if(isObject(name)){var filters={};forEach(name,function(filter,key){filters[key]=register(key,filter);});return filters;}else{return $provide.factory(name+suffix,factory);}}this.register=register;this.$get=['$injector',function($injector){return function(name){return $injector.get(name+suffix);};}];////////////////////////////////////////
	/* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */register('currency',currencyFilter);register('date',dateFilter);register('filter',filterFilter);register('json',jsonFilter);register('limitTo',limitToFilter);register('lowercase',lowercaseFilter);register('number',numberFilter);register('orderBy',orderByFilter);register('uppercase',uppercaseFilter);}/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */function filterFilter(){return function(array,expression,comparator,anyPropertyKey){if(!isArrayLike(array)){if(array==null){return array;}else{throw minErr('filter')('notarray','Expected array but received: {0}',array);}}anyPropertyKey=anyPropertyKey||'$';var expressionType=getTypeForFilter(expression);var predicateFn;var matchAgainstAnyProp;switch(expressionType){case'function':predicateFn=expression;break;case'boolean':case'null':case'number':case'string':matchAgainstAnyProp=true;// falls through
	case'object':predicateFn=createPredicateFn(expression,comparator,anyPropertyKey,matchAgainstAnyProp);break;default:return array;}return Array.prototype.filter.call(array,predicateFn);};}// Helper functions for `filterFilter`
	function createPredicateFn(expression,comparator,anyPropertyKey,matchAgainstAnyProp){var shouldMatchPrimitives=isObject(expression)&&anyPropertyKey in expression;var predicateFn;if(comparator===true){comparator=equals;}else if(!isFunction(comparator)){comparator=function comparator(actual,expected){if(isUndefined(actual)){// No substring matching against `undefined`
	return false;}if(actual===null||expected===null){// No substring matching against `null`; only match against `null`
	return actual===expected;}if(isObject(expected)||isObject(actual)&&!hasCustomToString(actual)){// Should not compare primitives against objects, unless they have custom `toString` method
	return false;}actual=lowercase(''+actual);expected=lowercase(''+expected);return actual.indexOf(expected)!==-1;};}predicateFn=function predicateFn(item){if(shouldMatchPrimitives&&!isObject(item)){return deepCompare(item,expression[anyPropertyKey],comparator,anyPropertyKey,false);}return deepCompare(item,expression,comparator,anyPropertyKey,matchAgainstAnyProp);};return predicateFn;}function deepCompare(actual,expected,comparator,anyPropertyKey,matchAgainstAnyProp,dontMatchWholeObject){var actualType=getTypeForFilter(actual);var expectedType=getTypeForFilter(expected);if(expectedType==='string'&&expected.charAt(0)==='!'){return!deepCompare(actual,expected.substring(1),comparator,anyPropertyKey,matchAgainstAnyProp);}else if(isArray(actual)){// In case `actual` is an array, consider it a match
	// if ANY of it's items matches `expected`
	return actual.some(function(item){return deepCompare(item,expected,comparator,anyPropertyKey,matchAgainstAnyProp);});}switch(actualType){case'object':var key;if(matchAgainstAnyProp){for(key in actual){// Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	// See: https://github.com/angular/angular.js/issues/15644
	if(key.charAt&&key.charAt(0)!=='$'&&deepCompare(actual[key],expected,comparator,anyPropertyKey,true)){return true;}}return dontMatchWholeObject?false:deepCompare(actual,expected,comparator,anyPropertyKey,false);}else if(expectedType==='object'){for(key in expected){var expectedVal=expected[key];if(isFunction(expectedVal)||isUndefined(expectedVal)){continue;}var matchAnyProperty=key===anyPropertyKey;var actualVal=matchAnyProperty?actual:actual[key];if(!deepCompare(actualVal,expectedVal,comparator,anyPropertyKey,matchAnyProperty,matchAnyProperty)){return false;}}return true;}else{return comparator(actual,expected);}case'function':return false;default:return comparator(actual,expected);}}// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val){return val===null?'null':typeof val==='undefined'?'undefined':_typeof(val);}var MAX_DIGITS=22;var DECIMAL_SEP='.';var ZERO_CHAR='0';/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */currencyFilter.$inject=['$locale'];function currencyFilter($locale){var formats=$locale.NUMBER_FORMATS;return function(amount,currencySymbol,fractionSize){if(isUndefined(currencySymbol)){currencySymbol=formats.CURRENCY_SYM;}if(isUndefined(fractionSize)){fractionSize=formats.PATTERNS[1].maxFrac;}// If the currency symbol is empty, trim whitespace around the symbol
	var currencySymbolRe=!currencySymbol?/\s*\u00A4\s*/g:/\u00A4/g;// if null or undefined pass it through
	return amount==null?amount:formatNumber(amount,formats.PATTERNS[1],formats.GROUP_SEP,formats.DECIMAL_SEP,fractionSize).replace(currencySymbolRe,currencySymbol);};}/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */numberFilter.$inject=['$locale'];function numberFilter($locale){var formats=$locale.NUMBER_FORMATS;return function(number,fractionSize){// if null or undefined pass it through
	return number==null?number:formatNumber(number,formats.PATTERNS[0],formats.GROUP_SEP,formats.DECIMAL_SEP,fractionSize);};}/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */function parse(numStr){var exponent=0,digits,numberOfIntegerDigits;var i,j,zeros;// Decimal point?
	if((numberOfIntegerDigits=numStr.indexOf(DECIMAL_SEP))>-1){numStr=numStr.replace(DECIMAL_SEP,'');}// Exponential form?
	if((i=numStr.search(/e/i))>0){// Work out the exponent.
	if(numberOfIntegerDigits<0)numberOfIntegerDigits=i;numberOfIntegerDigits+=+numStr.slice(i+1);numStr=numStr.substring(0,i);}else if(numberOfIntegerDigits<0){// There was no decimal point or exponent so it is an integer.
	numberOfIntegerDigits=numStr.length;}// Count the number of leading zeros.
	for(i=0;numStr.charAt(i)===ZERO_CHAR;i++){/* empty */}if(i===(zeros=numStr.length)){// The digits are all zero.
	digits=[0];numberOfIntegerDigits=1;}else{// Count the number of trailing zeros
	zeros--;while(numStr.charAt(zeros)===ZERO_CHAR){zeros--;}// Trailing zeros are insignificant so ignore them
	numberOfIntegerDigits-=i;digits=[];// Convert string to array of digits without leading/trailing zeros.
	for(j=0;i<=zeros;i++,j++){digits[j]=+numStr.charAt(i);}}// If the number overflows the maximum allowed digits then use an exponent.
	if(numberOfIntegerDigits>MAX_DIGITS){digits=digits.splice(0,MAX_DIGITS-1);exponent=numberOfIntegerDigits-1;numberOfIntegerDigits=1;}return{d:digits,e:exponent,i:numberOfIntegerDigits};}/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */function roundNumber(parsedNumber,fractionSize,minFrac,maxFrac){var digits=parsedNumber.d;var fractionLen=digits.length-parsedNumber.i;// determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	fractionSize=isUndefined(fractionSize)?Math.min(Math.max(minFrac,fractionLen),maxFrac):+fractionSize;// The index of the digit to where rounding is to occur
	var roundAt=fractionSize+parsedNumber.i;var digit=digits[roundAt];if(roundAt>0){// Drop fractional digits beyond `roundAt`
	digits.splice(Math.max(parsedNumber.i,roundAt));// Set non-fractional digits beyond `roundAt` to 0
	for(var j=roundAt;j<digits.length;j++){digits[j]=0;}}else{// We rounded to zero so reset the parsedNumber
	fractionLen=Math.max(0,fractionLen);parsedNumber.i=1;digits.length=Math.max(1,roundAt=fractionSize+1);digits[0]=0;for(var i=1;i<roundAt;i++){digits[i]=0;}}if(digit>=5){if(roundAt-1<0){for(var k=0;k>roundAt;k--){digits.unshift(0);parsedNumber.i++;}digits.unshift(1);parsedNumber.i++;}else{digits[roundAt-1]++;}}// Pad out with zeros to get the required fraction length
	for(;fractionLen<Math.max(0,fractionSize);fractionLen++){digits.push(0);}// Do any carrying, e.g. a digit was rounded up to 10
	var carry=digits.reduceRight(function(carry,d,i,digits){d=d+carry;digits[i]=d%10;return Math.floor(d/10);},0);if(carry){digits.unshift(carry);parsedNumber.i++;}}/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */function formatNumber(number,pattern,groupSep,decimalSep,fractionSize){if(!(isString(number)||isNumber(number))||isNaN(number))return'';var isInfinity=!isFinite(number);var isZero=false;var numStr=Math.abs(number)+'',formattedText='',parsedNumber;if(isInfinity){formattedText='\u221E';}else{parsedNumber=parse(numStr);roundNumber(parsedNumber,fractionSize,pattern.minFrac,pattern.maxFrac);var digits=parsedNumber.d;var integerLen=parsedNumber.i;var exponent=parsedNumber.e;var decimals=[];isZero=digits.reduce(function(isZero,d){return isZero&&!d;},true);// pad zeros for small numbers
	while(integerLen<0){digits.unshift(0);integerLen++;}// extract decimals digits
	if(integerLen>0){decimals=digits.splice(integerLen,digits.length);}else{decimals=digits;digits=[0];}// format the integer digits with grouping separators
	var groups=[];if(digits.length>=pattern.lgSize){groups.unshift(digits.splice(-pattern.lgSize,digits.length).join(''));}while(digits.length>pattern.gSize){groups.unshift(digits.splice(-pattern.gSize,digits.length).join(''));}if(digits.length){groups.unshift(digits.join(''));}formattedText=groups.join(groupSep);// append the decimal digits
	if(decimals.length){formattedText+=decimalSep+decimals.join('');}if(exponent){formattedText+='e+'+exponent;}}if(number<0&&!isZero){return pattern.negPre+formattedText+pattern.negSuf;}else{return pattern.posPre+formattedText+pattern.posSuf;}}function padNumber(num,digits,trim,negWrap){var neg='';if(num<0||negWrap&&num<=0){if(negWrap){num=-num+1;}else{num=-num;neg='-';}}num=''+num;while(num.length<digits){num=ZERO_CHAR+num;}if(trim){num=num.substr(num.length-digits);}return neg+num;}function dateGetter(name,size,offset,trim,negWrap){offset=offset||0;return function(date){var value=date['get'+name]();if(offset>0||value>-offset){value+=offset;}if(value===0&&offset===-12)value=12;return padNumber(value,size,trim,negWrap);};}function dateStrGetter(name,shortForm,standAlone){return function(date,formats){var value=date['get'+name]();var propPrefix=(standAlone?'STANDALONE':'')+(shortForm?'SHORT':'');var get=uppercase(propPrefix+name);return formats[get][value];};}function timeZoneGetter(date,formats,offset){var zone=-1*offset;var paddedZone=zone>=0?'+':'';paddedZone+=padNumber(Math[zone>0?'floor':'ceil'](zone/60),2)+padNumber(Math.abs(zone%60),2);return paddedZone;}function getFirstThursdayOfYear(year){// 0 = index of January
	var dayOfWeekOnFirst=new Date(year,0,1).getDay();// 4 = index of Thursday (+1 to account for 1st = 5)
	// 11 = index of *next* Thursday (+1 account for 1st = 12)
	return new Date(year,0,(dayOfWeekOnFirst<=4?5:12)-dayOfWeekOnFirst);}function getThursdayThisWeek(datetime){return new Date(datetime.getFullYear(),datetime.getMonth(),// 4 = index of Thursday
	datetime.getDate()+(4-datetime.getDay()));}function weekGetter(size){return function(date){var firstThurs=getFirstThursdayOfYear(date.getFullYear()),thisThurs=getThursdayThisWeek(date);var diff=+thisThurs-+firstThurs,result=1+Math.round(diff/6.048e8);// 6.048e8 ms per week
	return padNumber(result,size);};}function ampmGetter(date,formats){return date.getHours()<12?formats.AMPMS[0]:formats.AMPMS[1];}function eraGetter(date,formats){return date.getFullYear()<=0?formats.ERAS[0]:formats.ERAS[1];}function longEraGetter(date,formats){return date.getFullYear()<=0?formats.ERANAMES[0]:formats.ERANAMES[1];}var DATE_FORMATS={yyyy:dateGetter('FullYear',4,0,false,true),yy:dateGetter('FullYear',2,0,true,true),y:dateGetter('FullYear',1,0,false,true),MMMM:dateStrGetter('Month'),MMM:dateStrGetter('Month',true),MM:dateGetter('Month',2,1),M:dateGetter('Month',1,1),LLLL:dateStrGetter('Month',false,true),dd:dateGetter('Date',2),d:dateGetter('Date',1),HH:dateGetter('Hours',2),H:dateGetter('Hours',1),hh:dateGetter('Hours',2,-12),h:dateGetter('Hours',1,-12),mm:dateGetter('Minutes',2),m:dateGetter('Minutes',1),ss:dateGetter('Seconds',2),s:dateGetter('Seconds',1),// while ISO 8601 requires fractions to be prefixed with `.` or `,`
	// we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	sss:dateGetter('Milliseconds',3),EEEE:dateStrGetter('Day'),EEE:dateStrGetter('Day',true),a:ampmGetter,Z:timeZoneGetter,ww:weekGetter(2),w:weekGetter(1),G:eraGetter,GG:eraGetter,GGG:eraGetter,GGGG:longEraGetter};var DATE_FORMATS_SPLIT=/((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,NUMBER_STRING=/^-?\d+$/;/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */dateFilter.$inject=['$locale'];function dateFilter($locale){var R_ISO8601_STR=/^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;// 1        2       3         4          5          6          7          8  9     10      11
	function jsonStringToDate(string){var match;if(match=string.match(R_ISO8601_STR)){var date=new Date(0),tzHour=0,tzMin=0,dateSetter=match[8]?date.setUTCFullYear:date.setFullYear,timeSetter=match[8]?date.setUTCHours:date.setHours;if(match[9]){tzHour=toInt(match[9]+match[10]);tzMin=toInt(match[9]+match[11]);}dateSetter.call(date,toInt(match[1]),toInt(match[2])-1,toInt(match[3]));var h=toInt(match[4]||0)-tzHour;var m=toInt(match[5]||0)-tzMin;var s=toInt(match[6]||0);var ms=Math.round(parseFloat('0.'+(match[7]||0))*1000);timeSetter.call(date,h,m,s,ms);return date;}return string;}return function(date,format,timezone){var text='',parts=[],fn,match;format=format||'mediumDate';format=$locale.DATETIME_FORMATS[format]||format;if(isString(date)){date=NUMBER_STRING.test(date)?toInt(date):jsonStringToDate(date);}if(isNumber(date)){date=new Date(date);}if(!isDate(date)||!isFinite(date.getTime())){return date;}while(format){match=DATE_FORMATS_SPLIT.exec(format);if(match){parts=concat(parts,match,1);format=parts.pop();}else{parts.push(format);format=null;}}var dateTimezoneOffset=date.getTimezoneOffset();if(timezone){dateTimezoneOffset=timezoneToOffset(timezone,dateTimezoneOffset);date=convertTimezoneToLocal(date,timezone,true);}forEach(parts,function(value){fn=DATE_FORMATS[value];text+=fn?fn(date,$locale.DATETIME_FORMATS,dateTimezoneOffset):value==='\'\''?'\'':value.replace(/(^'|'$)/g,'').replace(/''/g,'\'');});return text;};}/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */function jsonFilter(){return function(object,spacing){if(isUndefined(spacing)){spacing=2;}return toJson(object,spacing);};}/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */var lowercaseFilter=valueFn(lowercase);/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */var uppercaseFilter=valueFn(uppercase);/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/function limitToFilter(){return function(input,limit,begin){if(Math.abs(Number(limit))===Infinity){limit=Number(limit);}else{limit=toInt(limit);}if(isNumberNaN(limit))return input;if(isNumber(input))input=input.toString();if(!isArrayLike(input))return input;begin=!begin||isNaN(begin)?0:toInt(begin);begin=begin<0?Math.max(0,input.length+begin):begin;if(limit>=0){return sliceFn(input,begin,begin+limit);}else{if(begin===0){return sliceFn(input,limit,input.length);}else{return sliceFn(input,Math.max(0,begin+limit),begin);}}};}function sliceFn(input,begin,end){if(isString(input))return input.slice(begin,end);return slice.call(input,begin,end);}/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */orderByFilter.$inject=['$parse'];function orderByFilter($parse){return function(array,sortPredicate,reverseOrder,compareFn){if(array==null)return array;if(!isArrayLike(array)){throw minErr('orderBy')('notarray','Expected array but received: {0}',array);}if(!isArray(sortPredicate)){sortPredicate=[sortPredicate];}if(sortPredicate.length===0){sortPredicate=['+'];}var predicates=processPredicates(sortPredicate);var descending=reverseOrder?-1:1;// Define the `compare()` function. Use a default comparator if none is specified.
	var compare=isFunction(compareFn)?compareFn:defaultCompare;// The next three lines are a version of a Swartzian Transform idiom from Perl
	// (sometimes called the Decorate-Sort-Undecorate idiom)
	// See https://en.wikipedia.org/wiki/Schwartzian_transform
	var compareValues=Array.prototype.map.call(array,getComparisonObject);compareValues.sort(doComparison);array=compareValues.map(function(item){return item.value;});return array;function getComparisonObject(value,index){// NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	// This will be used to keep the sort stable when none of the input predicates can
	// distinguish between two elements.
	return{value:value,tieBreaker:{value:index,type:'number',index:index},predicateValues:predicates.map(function(predicate){return getPredicateValue(predicate.get(value),index);})};}function doComparison(v1,v2){for(var i=0,ii=predicates.length;i<ii;i++){var result=compare(v1.predicateValues[i],v2.predicateValues[i]);if(result){return result*predicates[i].descending*descending;}}return(compare(v1.tieBreaker,v2.tieBreaker)||defaultCompare(v1.tieBreaker,v2.tieBreaker))*descending;}};function processPredicates(sortPredicates){return sortPredicates.map(function(predicate){var descending=1,get=identity;if(isFunction(predicate)){get=predicate;}else if(isString(predicate)){if(predicate.charAt(0)==='+'||predicate.charAt(0)==='-'){descending=predicate.charAt(0)==='-'?-1:1;predicate=predicate.substring(1);}if(predicate!==''){get=$parse(predicate);if(get.constant){var key=get();get=function get(value){return value[key];};}}}return{get:get,descending:descending};});}function isPrimitive(value){switch(typeof value==='undefined'?'undefined':_typeof(value)){case'number':/* falls through */case'boolean':/* falls through */case'string':return true;default:return false;}}function objectValue(value){// If `valueOf` is a valid function use that
	if(isFunction(value.valueOf)){value=value.valueOf();if(isPrimitive(value))return value;}// If `toString` is a valid function and not the one from `Object.prototype` use that
	if(hasCustomToString(value)){value=value.toString();if(isPrimitive(value))return value;}return value;}function getPredicateValue(value,index){var type=typeof value==='undefined'?'undefined':_typeof(value);if(value===null){type='string';value='null';}else if(type==='object'){value=objectValue(value);}return{value:value,type:type,index:index};}function defaultCompare(v1,v2){var result=0;var type1=v1.type;var type2=v2.type;if(type1===type2){var value1=v1.value;var value2=v2.value;if(type1==='string'){// Compare strings case-insensitively
	value1=value1.toLowerCase();value2=value2.toLowerCase();}else if(type1==='object'){// For basic objects, use the position of the object
	// in the collection instead of the value
	if(isObject(value1))value1=v1.index;if(isObject(value2))value2=v2.index;}if(value1!==value2){result=value1<value2?-1:1;}}else{result=type1<type2?-1:1;}return result;}}function ngDirective(directive){if(isFunction(directive)){directive={link:directive};}directive.restrict=directive.restrict||'AC';return valueFn(directive);}/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */var htmlAnchorDirective=valueFn({restrict:'E',compile:function compile(element,attr){if(!attr.href&&!attr.xlinkHref){return function(scope,element){// If the linked element is not an anchor tag anymore, do nothing
	if(element[0].nodeName.toLowerCase()!=='a')return;// SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	var href=toString.call(element.prop('href'))==='[object SVGAnimatedString]'?'xlink:href':'href';element.on('click',function(event){// if we have no href url, then don't navigate anywhere.
	if(!element.attr(href)){event.preventDefault();}});};}}});/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 *//**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 *//**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 *//**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 *//**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 *//**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 *//**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 *//**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */var ngAttributeAliasDirectives={};// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR,function(propName,attrName){// binding to multiple is not supported
	if(propName==='multiple')return;function defaultLinkFn(scope,element,attr){scope.$watch(attr[normalized],function ngBooleanAttrWatchAction(value){attr.$set(attrName,!!value);});}var normalized=directiveNormalize('ng-'+attrName);var linkFn=defaultLinkFn;if(propName==='checked'){linkFn=function linkFn(scope,element,attr){// ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	if(attr.ngModel!==attr[normalized]){defaultLinkFn(scope,element,attr);}};}ngAttributeAliasDirectives[normalized]=function(){return{restrict:'A',priority:100,link:linkFn};};});// aliased input attrs are evaluated
	forEach(ALIASED_ATTR,function(htmlAttr,ngAttr){ngAttributeAliasDirectives[ngAttr]=function(){return{priority:100,link:function link(scope,element,attr){//special case ngPattern when a literal regular expression value
	//is used as the expression (this way we don't have to watch anything).
	if(ngAttr==='ngPattern'&&attr.ngPattern.charAt(0)==='/'){var match=attr.ngPattern.match(REGEX_STRING_REGEXP);if(match){attr.$set('ngPattern',new RegExp(match[1],match[2]));return;}}scope.$watch(attr[ngAttr],function ngAttrAliasWatchAction(value){attr.$set(ngAttr,value);});}};};});// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src','srcset','href'],function(attrName){var normalized=directiveNormalize('ng-'+attrName);ngAttributeAliasDirectives[normalized]=function(){return{priority:99,// it needs to run after the attributes are interpolated
	link:function link(scope,element,attr){var propName=attrName,name=attrName;if(attrName==='href'&&toString.call(element.prop('href'))==='[object SVGAnimatedString]'){name='xlinkHref';attr.$attr[name]='xlink:href';propName=null;}attr.$observe(normalized,function(value){if(!value){if(attrName==='href'){attr.$set(name,null);}return;}attr.$set(name,value);// Support: IE 9-11 only
	// On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	// then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	// to set the property as well to achieve the desired effect.
	// We use attr[attrName] value since $set can sanitize the url.
	if(msie&&propName)element.prop(propName,attr[name]);});}};};});/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */var nullFormCtrl={$addControl:noop,$$renameControl:nullFormRenameControl,$removeControl:noop,$setValidity:noop,$setDirty:noop,$setPristine:noop,$setSubmitted:noop},PENDING_CLASS='ng-pending',SUBMITTED_CLASS='ng-submitted';function nullFormRenameControl(control,name){control.$name=name;}/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 *///asks for $scope to fool the BC controller module
	FormController.$inject=['$element','$attrs','$scope','$animate','$interpolate'];function FormController($element,$attrs,$scope,$animate,$interpolate){this.$$controls=[];// init state
	this.$error={};this.$$success={};this.$pending=undefined;this.$name=$interpolate($attrs.name||$attrs.ngForm||'')($scope);this.$dirty=false;this.$pristine=true;this.$valid=true;this.$invalid=false;this.$submitted=false;this.$$parentForm=nullFormCtrl;this.$$element=$element;this.$$animate=$animate;setupValidity(this);}FormController.prototype={/**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */$rollbackViewValue:function $rollbackViewValue(){forEach(this.$$controls,function(control){control.$rollbackViewValue();});},/**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */$commitViewValue:function $commitViewValue(){forEach(this.$$controls,function(control){control.$commitViewValue();});},/**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */$addControl:function $addControl(control){// Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	// and not added to the scope.  Now we throw an error.
	assertNotHasOwnProperty(control.$name,'input');this.$$controls.push(control);if(control.$name){this[control.$name]=control;}control.$$parentForm=this;},// Private API: rename a form control
	$$renameControl:function $$renameControl(control,newName){var oldName=control.$name;if(this[oldName]===control){delete this[oldName];}this[newName]=control;control.$name=newName;},/**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */$removeControl:function $removeControl(control){if(control.$name&&this[control.$name]===control){delete this[control.$name];}forEach(this.$pending,function(value,name){// eslint-disable-next-line no-invalid-this
	this.$setValidity(name,null,control);},this);forEach(this.$error,function(value,name){// eslint-disable-next-line no-invalid-this
	this.$setValidity(name,null,control);},this);forEach(this.$$success,function(value,name){// eslint-disable-next-line no-invalid-this
	this.$setValidity(name,null,control);},this);arrayRemove(this.$$controls,control);control.$$parentForm=nullFormCtrl;},/**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */$setDirty:function $setDirty(){this.$$animate.removeClass(this.$$element,PRISTINE_CLASS);this.$$animate.addClass(this.$$element,DIRTY_CLASS);this.$dirty=true;this.$pristine=false;this.$$parentForm.$setDirty();},/**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */$setPristine:function $setPristine(){this.$$animate.setClass(this.$$element,PRISTINE_CLASS,DIRTY_CLASS+' '+SUBMITTED_CLASS);this.$dirty=false;this.$pristine=true;this.$submitted=false;forEach(this.$$controls,function(control){control.$setPristine();});},/**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */$setUntouched:function $setUntouched(){forEach(this.$$controls,function(control){control.$setUntouched();});},/**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */$setSubmitted:function $setSubmitted(){this.$$animate.addClass(this.$$element,SUBMITTED_CLASS);this.$submitted=true;this.$$parentForm.$setSubmitted();}};/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */addSetValidityMethod({clazz:FormController,set:function set(object,property,controller){var list=object[property];if(!list){object[property]=[controller];}else{var index=list.indexOf(controller);if(index===-1){list.push(controller);}}},unset:function unset(object,property,controller){var list=object[property];if(!list){return;}arrayRemove(list,controller);if(list.length===0){delete object[property];}}});/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 *//**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */var formDirectiveFactory=function formDirectiveFactory(isNgForm){return['$timeout','$parse',function($timeout,$parse){var formDirective={name:'form',restrict:isNgForm?'EAC':'E',require:['form','^^?form'],//first is the form's own ctrl, second is an optional parent form
	controller:FormController,compile:function ngFormCompile(formElement,attr){// Setup initial state of the control
	formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);var nameAttr=attr.name?'name':isNgForm&&attr.ngForm?'ngForm':false;return{pre:function ngFormPreLink(scope,formElement,attr,ctrls){var controller=ctrls[0];// if `action` attr is not present on the form, prevent the default action (submission)
	if(!('action'in attr)){// we can't use jq events because if a form is destroyed during submission the default
	// action is not prevented. see #1238
	//
	// IE 9 is not affected because it doesn't fire a submit event and try to do a full
	// page reload if the form was destroyed by submission of the form via a click handler
	// on a button in the form. Looks like an IE9 specific bug.
	var handleFormSubmission=function handleFormSubmission(event){scope.$apply(function(){controller.$commitViewValue();controller.$setSubmitted();});event.preventDefault();};formElement[0].addEventListener('submit',handleFormSubmission);// unregister the preventDefault listener so that we don't not leak memory but in a
	// way that will achieve the prevention of the default action.
	formElement.on('$destroy',function(){$timeout(function(){formElement[0].removeEventListener('submit',handleFormSubmission);},0,false);});}var parentFormCtrl=ctrls[1]||controller.$$parentForm;parentFormCtrl.$addControl(controller);var setter=nameAttr?getSetter(controller.$name):noop;if(nameAttr){setter(scope,controller);attr.$observe(nameAttr,function(newValue){if(controller.$name===newValue)return;setter(scope,undefined);controller.$$parentForm.$$renameControl(controller,newValue);setter=getSetter(controller.$name);setter(scope,controller);});}formElement.on('$destroy',function(){controller.$$parentForm.$removeControl(controller);setter(scope,undefined);extend(controller,nullFormCtrl);//stop propagating child destruction handlers upwards
	});}};}};return formDirective;function getSetter(expression){if(expression===''){//create an assignable expression, so forms with an empty name can be renamed later
	return $parse('this[""]').assign;}return $parse(expression).assign||noop;}}];};var formDirective=formDirectiveFactory();var ngFormDirective=formDirectiveFactory(true);// helper methods
	function setupValidity(instance){instance.$$classCache={};instance.$$classCache[INVALID_CLASS]=!(instance.$$classCache[VALID_CLASS]=instance.$$element.hasClass(VALID_CLASS));}function addSetValidityMethod(context){var clazz=context.clazz,set=context.set,unset=context.unset;clazz.prototype.$setValidity=function(validationErrorKey,state,controller){if(isUndefined(state)){createAndSet(this,'$pending',validationErrorKey,controller);}else{unsetAndCleanup(this,'$pending',validationErrorKey,controller);}if(!isBoolean(state)){unset(this.$error,validationErrorKey,controller);unset(this.$$success,validationErrorKey,controller);}else{if(state){unset(this.$error,validationErrorKey,controller);set(this.$$success,validationErrorKey,controller);}else{set(this.$error,validationErrorKey,controller);unset(this.$$success,validationErrorKey,controller);}}if(this.$pending){cachedToggleClass(this,PENDING_CLASS,true);this.$valid=this.$invalid=undefined;toggleValidationCss(this,'',null);}else{cachedToggleClass(this,PENDING_CLASS,false);this.$valid=isObjectEmpty(this.$error);this.$invalid=!this.$valid;toggleValidationCss(this,'',this.$valid);}// re-read the state as the set/unset methods could have
	// combined state in this.$error[validationError] (used for forms),
	// where setting/unsetting only increments/decrements the value,
	// and does not replace it.
	var combinedState;if(this.$pending&&this.$pending[validationErrorKey]){combinedState=undefined;}else if(this.$error[validationErrorKey]){combinedState=false;}else if(this.$$success[validationErrorKey]){combinedState=true;}else{combinedState=null;}toggleValidationCss(this,validationErrorKey,combinedState);this.$$parentForm.$setValidity(validationErrorKey,combinedState,this);};function createAndSet(ctrl,name,value,controller){if(!ctrl[name]){ctrl[name]={};}set(ctrl[name],value,controller);}function unsetAndCleanup(ctrl,name,value,controller){if(ctrl[name]){unset(ctrl[name],value,controller);}if(isObjectEmpty(ctrl[name])){ctrl[name]=undefined;}}function cachedToggleClass(ctrl,className,switchValue){if(switchValue&&!ctrl.$$classCache[className]){ctrl.$$animate.addClass(ctrl.$$element,className);ctrl.$$classCache[className]=true;}else if(!switchValue&&ctrl.$$classCache[className]){ctrl.$$animate.removeClass(ctrl.$$element,className);ctrl.$$classCache[className]=false;}}function toggleValidationCss(ctrl,validationErrorKey,isValid){validationErrorKey=validationErrorKey?'-'+snake_case(validationErrorKey,'-'):'';cachedToggleClass(ctrl,VALID_CLASS+validationErrorKey,isValid===true);cachedToggleClass(ctrl,INVALID_CLASS+validationErrorKey,isValid===false);}}function isObjectEmpty(obj){if(obj){for(var prop in obj){if(obj.hasOwnProperty(prop)){return false;}}}return true;}/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP=/^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP=/^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;// eslint-disable-next-line max-len
	var EMAIL_REGEXP=/^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;var NUMBER_REGEXP=/^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;var DATE_REGEXP=/^(\d{4,})-(\d{2})-(\d{2})$/;var DATETIMELOCAL_REGEXP=/^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;var WEEK_REGEXP=/^(\d{4,})-W(\d\d)$/;var MONTH_REGEXP=/^(\d{4,})-(\d\d)$/;var TIME_REGEXP=/^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;var PARTIAL_VALIDATION_EVENTS='keydown wheel mousedown';var PARTIAL_VALIDATION_TYPES=createMap();forEach('date,datetime-local,month,time,week'.split(','),function(type){PARTIAL_VALIDATION_TYPES[type]=true;});var inputType={/**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */'text':textInputType,/**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */'date':createDateInputType('date',DATE_REGEXP,createDateParser(DATE_REGEXP,['yyyy','MM','dd']),'yyyy-MM-dd'),/**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */'datetime-local':createDateInputType('datetimelocal',DATETIMELOCAL_REGEXP,createDateParser(DATETIMELOCAL_REGEXP,['yyyy','MM','dd','HH','mm','ss','sss']),'yyyy-MM-ddTHH:mm:ss.sss'),/**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */'time':createDateInputType('time',TIME_REGEXP,createDateParser(TIME_REGEXP,['HH','mm','ss','sss']),'HH:mm:ss.sss'),/**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */'week':createDateInputType('week',WEEK_REGEXP,weekParser,'yyyy-Www'),/**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */'month':createDateInputType('month',MONTH_REGEXP,createDateParser(MONTH_REGEXP,['yyyy','MM']),'yyyy-MM'),/**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */'number':numberInputType,/**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */'url':urlInputType,/**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */'email':emailInputType,/**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */'radio':radioInputType,/**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */'range':rangeInputType,/**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */'checkbox':checkboxInputType,'hidden':noop,'button':noop,'submit':noop,'reset':noop,'file':noop};function stringBasedInputType(ctrl){ctrl.$formatters.push(function(value){return ctrl.$isEmpty(value)?value:value.toString();});}function textInputType(scope,element,attr,ctrl,$sniffer,$browser){baseInputType(scope,element,attr,ctrl,$sniffer,$browser);stringBasedInputType(ctrl);}function baseInputType(scope,element,attr,ctrl,$sniffer,$browser){var type=lowercase(element[0].type);// In composition mode, users are still inputting intermediate text buffer,
	// hold the listener until composition is done.
	// More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	if(!$sniffer.android){var composing=false;element.on('compositionstart',function(){composing=true;});element.on('compositionend',function(){composing=false;listener();});}var timeout;var listener=function listener(ev){if(timeout){$browser.defer.cancel(timeout);timeout=null;}if(composing)return;var value=element.val(),event=ev&&ev.type;// By default we will trim the value
	// If the attribute ng-trim exists we will avoid trimming
	// If input type is 'password', the value is never trimmed
	if(type!=='password'&&(!attr.ngTrim||attr.ngTrim!=='false')){value=trim(value);}// If a control is suffering from bad input (due to native validators), browsers discard its
	// value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	// control's value is the same empty value twice in a row.
	if(ctrl.$viewValue!==value||value===''&&ctrl.$$hasNativeValidators){ctrl.$setViewValue(value,event);}};// if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	// input event on backspace, delete or cut
	if($sniffer.hasEvent('input')){element.on('input',listener);}else{var deferListener=function deferListener(ev,input,origValue){if(!timeout){timeout=$browser.defer(function(){timeout=null;if(!input||input.value!==origValue){listener(ev);}});}};element.on('keydown',/** @this */function(event){var key=event.keyCode;// ignore
	//    command            modifiers                   arrows
	if(key===91||15<key&&key<19||37<=key&&key<=40)return;deferListener(event,this,this.value);});// if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	if($sniffer.hasEvent('paste')){element.on('paste cut drop',deferListener);}}// if user paste into input using mouse on older browser
	// or form autocomplete on newer browser, we need "change" event to catch it
	element.on('change',listener);// Some native input types (date-family) have the ability to change validity without
	// firing any input/change events.
	// For these event types, when native validators are present and the browser supports the type,
	// check for validity changes on various DOM events.
	if(PARTIAL_VALIDATION_TYPES[type]&&ctrl.$$hasNativeValidators&&type===attr.type){element.on(PARTIAL_VALIDATION_EVENTS,/** @this */function(ev){if(!timeout){var validity=this[VALIDITY_STATE_PROPERTY];var origBadInput=validity.badInput;var origTypeMismatch=validity.typeMismatch;timeout=$browser.defer(function(){timeout=null;if(validity.badInput!==origBadInput||validity.typeMismatch!==origTypeMismatch){listener(ev);}});}});}ctrl.$render=function(){// Workaround for Firefox validation #12102.
	var value=ctrl.$isEmpty(ctrl.$viewValue)?'':ctrl.$viewValue;if(element.val()!==value){element.val(value);}};}function weekParser(isoWeek,existingDate){if(isDate(isoWeek)){return isoWeek;}if(isString(isoWeek)){WEEK_REGEXP.lastIndex=0;var parts=WEEK_REGEXP.exec(isoWeek);if(parts){var year=+parts[1],week=+parts[2],hours=0,minutes=0,seconds=0,milliseconds=0,firstThurs=getFirstThursdayOfYear(year),addDays=(week-1)*7;if(existingDate){hours=existingDate.getHours();minutes=existingDate.getMinutes();seconds=existingDate.getSeconds();milliseconds=existingDate.getMilliseconds();}return new Date(year,0,firstThurs.getDate()+addDays,hours,minutes,seconds,milliseconds);}}return NaN;}function createDateParser(regexp,mapping){return function(iso,date){var parts,map;if(isDate(iso)){return iso;}if(isString(iso)){// When a date is JSON'ified to wraps itself inside of an extra
	// set of double quotes. This makes the date parsing code unable
	// to match the date string and parse it as a date.
	if(iso.charAt(0)==='"'&&iso.charAt(iso.length-1)==='"'){iso=iso.substring(1,iso.length-1);}if(ISO_DATE_REGEXP.test(iso)){return new Date(iso);}regexp.lastIndex=0;parts=regexp.exec(iso);if(parts){parts.shift();if(date){map={yyyy:date.getFullYear(),MM:date.getMonth()+1,dd:date.getDate(),HH:date.getHours(),mm:date.getMinutes(),ss:date.getSeconds(),sss:date.getMilliseconds()/1000};}else{map={yyyy:1970,MM:1,dd:1,HH:0,mm:0,ss:0,sss:0};}forEach(parts,function(part,index){if(index<mapping.length){map[mapping[index]]=+part;}});return new Date(map.yyyy,map.MM-1,map.dd,map.HH,map.mm,map.ss||0,map.sss*1000||0);}}return NaN;};}function createDateInputType(type,regexp,parseDate,format){return function dynamicDateInputType(scope,element,attr,ctrl,$sniffer,$browser,$filter){badInputChecker(scope,element,attr,ctrl);baseInputType(scope,element,attr,ctrl,$sniffer,$browser);var timezone=ctrl&&ctrl.$options.getOption('timezone');var previousDate;ctrl.$$parserName=type;ctrl.$parsers.push(function(value){if(ctrl.$isEmpty(value))return null;if(regexp.test(value)){// Note: We cannot read ctrl.$modelValue, as there might be a different
	// parser/formatter in the processing chain so that the model
	// contains some different data format!
	var parsedDate=parseDate(value,previousDate);if(timezone){parsedDate=convertTimezoneToLocal(parsedDate,timezone);}return parsedDate;}return undefined;});ctrl.$formatters.push(function(value){if(value&&!isDate(value)){throw ngModelMinErr('datefmt','Expected `{0}` to be a date',value);}if(isValidDate(value)){previousDate=value;if(previousDate&&timezone){previousDate=convertTimezoneToLocal(previousDate,timezone,true);}return $filter('date')(value,format,timezone);}else{previousDate=null;return'';}});if(isDefined(attr.min)||attr.ngMin){var minVal;ctrl.$validators.min=function(value){return!isValidDate(value)||isUndefined(minVal)||parseDate(value)>=minVal;};attr.$observe('min',function(val){minVal=parseObservedDateValue(val);ctrl.$validate();});}if(isDefined(attr.max)||attr.ngMax){var maxVal;ctrl.$validators.max=function(value){return!isValidDate(value)||isUndefined(maxVal)||parseDate(value)<=maxVal;};attr.$observe('max',function(val){maxVal=parseObservedDateValue(val);ctrl.$validate();});}function isValidDate(value){// Invalid Date: getTime() returns NaN
	return value&&!(value.getTime&&value.getTime()!==value.getTime());}function parseObservedDateValue(val){return isDefined(val)&&!isDate(val)?parseDate(val)||undefined:val;}};}function badInputChecker(scope,element,attr,ctrl){var node=element[0];var nativeValidation=ctrl.$$hasNativeValidators=isObject(node.validity);if(nativeValidation){ctrl.$parsers.push(function(value){var validity=element.prop(VALIDITY_STATE_PROPERTY)||{};return validity.badInput||validity.typeMismatch?undefined:value;});}}function numberFormatterParser(ctrl){ctrl.$$parserName='number';ctrl.$parsers.push(function(value){if(ctrl.$isEmpty(value))return null;if(NUMBER_REGEXP.test(value))return parseFloat(value);return undefined;});ctrl.$formatters.push(function(value){if(!ctrl.$isEmpty(value)){if(!isNumber(value)){throw ngModelMinErr('numfmt','Expected `{0}` to be a number',value);}value=value.toString();}return value;});}function parseNumberAttrVal(val){if(isDefined(val)&&!isNumber(val)){val=parseFloat(val);}return!isNumberNaN(val)?val:undefined;}function isNumberInteger(num){// See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	// (minus the assumption that `num` is a number)
	// eslint-disable-next-line no-bitwise
	return(num|0)===num;}function countDecimals(num){var numString=num.toString();var decimalSymbolIndex=numString.indexOf('.');if(decimalSymbolIndex===-1){if(-1<num&&num<1){// It may be in the exponential notation format (`1e-X`)
	var match=/e-(\d+)$/.exec(numString);if(match){return Number(match[1]);}}return 0;}return numString.length-decimalSymbolIndex-1;}function isValidForStep(viewValue,stepBase,step){// At this point `stepBase` and `step` are expected to be non-NaN values
	// and `viewValue` is expected to be a valid stringified number.
	var value=Number(viewValue);var isNonIntegerValue=!isNumberInteger(value);var isNonIntegerStepBase=!isNumberInteger(stepBase);var isNonIntegerStep=!isNumberInteger(step);// Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	// `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	if(isNonIntegerValue||isNonIntegerStepBase||isNonIntegerStep){var valueDecimals=isNonIntegerValue?countDecimals(value):0;var stepBaseDecimals=isNonIntegerStepBase?countDecimals(stepBase):0;var stepDecimals=isNonIntegerStep?countDecimals(step):0;var decimalCount=Math.max(valueDecimals,stepBaseDecimals,stepDecimals);var multiplier=Math.pow(10,decimalCount);value=value*multiplier;stepBase=stepBase*multiplier;step=step*multiplier;if(isNonIntegerValue)value=Math.round(value);if(isNonIntegerStepBase)stepBase=Math.round(stepBase);if(isNonIntegerStep)step=Math.round(step);}return(value-stepBase)%step===0;}function numberInputType(scope,element,attr,ctrl,$sniffer,$browser){badInputChecker(scope,element,attr,ctrl);numberFormatterParser(ctrl);baseInputType(scope,element,attr,ctrl,$sniffer,$browser);var minVal;var maxVal;if(isDefined(attr.min)||attr.ngMin){ctrl.$validators.min=function(value){return ctrl.$isEmpty(value)||isUndefined(minVal)||value>=minVal;};attr.$observe('min',function(val){minVal=parseNumberAttrVal(val);// TODO(matsko): implement validateLater to reduce number of validations
	ctrl.$validate();});}if(isDefined(attr.max)||attr.ngMax){ctrl.$validators.max=function(value){return ctrl.$isEmpty(value)||isUndefined(maxVal)||value<=maxVal;};attr.$observe('max',function(val){maxVal=parseNumberAttrVal(val);// TODO(matsko): implement validateLater to reduce number of validations
	ctrl.$validate();});}if(isDefined(attr.step)||attr.ngStep){var stepVal;ctrl.$validators.step=function(modelValue,viewValue){return ctrl.$isEmpty(viewValue)||isUndefined(stepVal)||isValidForStep(viewValue,minVal||0,stepVal);};attr.$observe('step',function(val){stepVal=parseNumberAttrVal(val);// TODO(matsko): implement validateLater to reduce number of validations
	ctrl.$validate();});}}function rangeInputType(scope,element,attr,ctrl,$sniffer,$browser){badInputChecker(scope,element,attr,ctrl);numberFormatterParser(ctrl);baseInputType(scope,element,attr,ctrl,$sniffer,$browser);var supportsRange=ctrl.$$hasNativeValidators&&element[0].type==='range',minVal=supportsRange?0:undefined,maxVal=supportsRange?100:undefined,stepVal=supportsRange?1:undefined,validity=element[0].validity,hasMinAttr=isDefined(attr.min),hasMaxAttr=isDefined(attr.max),hasStepAttr=isDefined(attr.step);var originalRender=ctrl.$render;ctrl.$render=supportsRange&&isDefined(validity.rangeUnderflow)&&isDefined(validity.rangeOverflow)?//Browsers that implement range will set these values automatically, but reading the adjusted values after
	//$render would cause the min / max validators to be applied with the wrong value
	function rangeRender(){originalRender();ctrl.$setViewValue(element.val());}:originalRender;if(hasMinAttr){ctrl.$validators.min=supportsRange?// Since all browsers set the input to a valid value, we don't need to check validity
	function noopMinValidator(){return true;}:// non-support browsers validate the min val
	function minValidator(modelValue,viewValue){return ctrl.$isEmpty(viewValue)||isUndefined(minVal)||viewValue>=minVal;};setInitialValueAndObserver('min',minChange);}if(hasMaxAttr){ctrl.$validators.max=supportsRange?// Since all browsers set the input to a valid value, we don't need to check validity
	function noopMaxValidator(){return true;}:// non-support browsers validate the max val
	function maxValidator(modelValue,viewValue){return ctrl.$isEmpty(viewValue)||isUndefined(maxVal)||viewValue<=maxVal;};setInitialValueAndObserver('max',maxChange);}if(hasStepAttr){ctrl.$validators.step=supportsRange?function nativeStepValidator(){// Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	// input element value to a valid value). It's possible that other browsers set the stepMismatch
	// validity error instead, so we can at least report an error in that case.
	return!validity.stepMismatch;}:// ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	function stepValidator(modelValue,viewValue){return ctrl.$isEmpty(viewValue)||isUndefined(stepVal)||isValidForStep(viewValue,minVal||0,stepVal);};setInitialValueAndObserver('step',stepChange);}function setInitialValueAndObserver(htmlAttrName,changeFn){// interpolated attributes set the attribute value only after a digest, but we need the
	// attribute value when the input is first rendered, so that the browser can adjust the
	// input value based on the min/max value
	element.attr(htmlAttrName,attr[htmlAttrName]);attr.$observe(htmlAttrName,changeFn);}function minChange(val){minVal=parseNumberAttrVal(val);// ignore changes before model is initialized
	if(isNumberNaN(ctrl.$modelValue)){return;}if(supportsRange){var elVal=element.val();// IE11 doesn't set the el val correctly if the minVal is greater than the element value
	if(minVal>elVal){elVal=minVal;element.val(elVal);}ctrl.$setViewValue(elVal);}else{// TODO(matsko): implement validateLater to reduce number of validations
	ctrl.$validate();}}function maxChange(val){maxVal=parseNumberAttrVal(val);// ignore changes before model is initialized
	if(isNumberNaN(ctrl.$modelValue)){return;}if(supportsRange){var elVal=element.val();// IE11 doesn't set the el val correctly if the maxVal is less than the element value
	if(maxVal<elVal){element.val(maxVal);// IE11 and Chrome don't set the value to the minVal when max < min
	elVal=maxVal<minVal?minVal:maxVal;}ctrl.$setViewValue(elVal);}else{// TODO(matsko): implement validateLater to reduce number of validations
	ctrl.$validate();}}function stepChange(val){stepVal=parseNumberAttrVal(val);// ignore changes before model is initialized
	if(isNumberNaN(ctrl.$modelValue)){return;}// Some browsers don't adjust the input value correctly, but set the stepMismatch error
	if(supportsRange&&ctrl.$viewValue!==element.val()){ctrl.$setViewValue(element.val());}else{// TODO(matsko): implement validateLater to reduce number of validations
	ctrl.$validate();}}}function urlInputType(scope,element,attr,ctrl,$sniffer,$browser){// Note: no badInputChecker here by purpose as `url` is only a validation
	// in browsers, i.e. we can always read out input.value even if it is not valid!
	baseInputType(scope,element,attr,ctrl,$sniffer,$browser);stringBasedInputType(ctrl);ctrl.$$parserName='url';ctrl.$validators.url=function(modelValue,viewValue){var value=modelValue||viewValue;return ctrl.$isEmpty(value)||URL_REGEXP.test(value);};}function emailInputType(scope,element,attr,ctrl,$sniffer,$browser){// Note: no badInputChecker here by purpose as `url` is only a validation
	// in browsers, i.e. we can always read out input.value even if it is not valid!
	baseInputType(scope,element,attr,ctrl,$sniffer,$browser);stringBasedInputType(ctrl);ctrl.$$parserName='email';ctrl.$validators.email=function(modelValue,viewValue){var value=modelValue||viewValue;return ctrl.$isEmpty(value)||EMAIL_REGEXP.test(value);};}function radioInputType(scope,element,attr,ctrl){var doTrim=!attr.ngTrim||trim(attr.ngTrim)!=='false';// make the name unique, if not defined
	if(isUndefined(attr.name)){element.attr('name',nextUid());}var listener=function listener(ev){var value;if(element[0].checked){value=attr.value;if(doTrim){value=trim(value);}ctrl.$setViewValue(value,ev&&ev.type);}};element.on('click',listener);ctrl.$render=function(){var value=attr.value;if(doTrim){value=trim(value);}element[0].checked=value===ctrl.$viewValue;};attr.$observe('value',ctrl.$render);}function parseConstantExpr($parse,context,name,expression,fallback){var parseFn;if(isDefined(expression)){parseFn=$parse(expression);if(!parseFn.constant){throw ngModelMinErr('constexpr','Expected constant expression for `{0}`, but saw '+'`{1}`.',name,expression);}return parseFn(context);}return fallback;}function checkboxInputType(scope,element,attr,ctrl,$sniffer,$browser,$filter,$parse){var trueValue=parseConstantExpr($parse,scope,'ngTrueValue',attr.ngTrueValue,true);var falseValue=parseConstantExpr($parse,scope,'ngFalseValue',attr.ngFalseValue,false);var listener=function listener(ev){ctrl.$setViewValue(element[0].checked,ev&&ev.type);};element.on('click',listener);ctrl.$render=function(){element[0].checked=ctrl.$viewValue;};// Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	// This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	// it to a boolean.
	ctrl.$isEmpty=function(value){return value===false;};ctrl.$formatters.push(function(value){return equals(value,trueValue);});ctrl.$parsers.push(function(value){return value?trueValue:falseValue;});}/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 *//**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */var inputDirective=['$browser','$sniffer','$filter','$parse',function($browser,$sniffer,$filter,$parse){return{restrict:'E',require:['?ngModel'],link:{pre:function pre(scope,element,attr,ctrls){if(ctrls[0]){(inputType[lowercase(attr.type)]||inputType.text)(scope,element,attr,ctrls[0],$sniffer,$browser,$filter,$parse);}}}};}];var CONSTANT_VALUE_REGEXP=/^(true|false|\d+)$/;/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */var ngValueDirective=function ngValueDirective(){/**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */function updateElementValue(element,attr,value){// Support: IE9 only
	// In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	var propValue=isDefined(value)?value:msie===9?'':null;element.prop('value',propValue);attr.$set('value',value);}return{restrict:'A',priority:100,compile:function compile(tpl,tplAttr){if(CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)){return function ngValueConstantLink(scope,elm,attr){var value=scope.$eval(attr.ngValue);updateElementValue(elm,attr,value);};}else{return function ngValueLink(scope,elm,attr){scope.$watch(attr.ngValue,function valueWatchAction(value){updateElementValue(elm,attr,value);});};}}};};/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */var ngBindDirective=['$compile',function($compile){return{restrict:'AC',compile:function ngBindCompile(templateElement){$compile.$$addBindingClass(templateElement);return function ngBindLink(scope,element,attr){$compile.$$addBindingInfo(element,attr.ngBind);element=element[0];scope.$watch(attr.ngBind,function ngBindWatchAction(value){element.textContent=stringify(value);});};}};}];/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */var ngBindTemplateDirective=['$interpolate','$compile',function($interpolate,$compile){return{compile:function ngBindTemplateCompile(templateElement){$compile.$$addBindingClass(templateElement);return function ngBindTemplateLink(scope,element,attr){var interpolateFn=$interpolate(element.attr(attr.$attr.ngBindTemplate));$compile.$$addBindingInfo(element,interpolateFn.expressions);element=element[0];attr.$observe('ngBindTemplate',function(value){element.textContent=isUndefined(value)?'':value;});};}};}];/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */var ngBindHtmlDirective=['$sce','$parse','$compile',function($sce,$parse,$compile){return{restrict:'A',compile:function ngBindHtmlCompile(tElement,tAttrs){var ngBindHtmlGetter=$parse(tAttrs.ngBindHtml);var ngBindHtmlWatch=$parse(tAttrs.ngBindHtml,function sceValueOf(val){// Unwrap the value to compare the actual inner safe value, not the wrapper object.
	return $sce.valueOf(val);});$compile.$$addBindingClass(tElement);return function ngBindHtmlLink(scope,element,attr){$compile.$$addBindingInfo(element,attr.ngBindHtml);scope.$watch(ngBindHtmlWatch,function ngBindHtmlWatchAction(){// The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	var value=ngBindHtmlGetter(scope);element.html($sce.getTrustedHtml(value)||'');});};}};}];/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */var ngChangeDirective=valueFn({restrict:'A',require:'ngModel',link:function link(scope,element,attr,ctrl){ctrl.$viewChangeListeners.push(function(){scope.$eval(attr.ngChange);});}});/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/function classDirective(name,selector){name='ngClass'+name;var indexWatchExpression;return['$parse',function($parse){return{restrict:'AC',link:function link(scope,element,attr){var expression=attr[name].trim();var isOneTime=expression.charAt(0)===':'&&expression.charAt(1)===':';var watchInterceptor=isOneTime?toFlatValue:toClassString;var watchExpression=$parse(expression,watchInterceptor);var watchAction=isOneTime?ngClassOneTimeWatchAction:ngClassWatchAction;var classCounts=element.data('$classCounts');var oldModulo=true;var oldClassString;if(!classCounts){// Use createMap() to prevent class assumptions involving property
	// names in Object.prototype
	classCounts=createMap();element.data('$classCounts',classCounts);}if(name!=='ngClass'){if(!indexWatchExpression){indexWatchExpression=$parse('$index',function moduloTwo($index){// eslint-disable-next-line no-bitwise
	return $index&1;});}scope.$watch(indexWatchExpression,ngClassIndexWatchAction);}scope.$watch(watchExpression,watchAction,isOneTime);function addClasses(classString){classString=digestClassCounts(split(classString),1);attr.$addClass(classString);}function removeClasses(classString){classString=digestClassCounts(split(classString),-1);attr.$removeClass(classString);}function updateClasses(oldClassString,newClassString){var oldClassArray=split(oldClassString);var newClassArray=split(newClassString);var toRemoveArray=arrayDifference(oldClassArray,newClassArray);var toAddArray=arrayDifference(newClassArray,oldClassArray);var toRemoveString=digestClassCounts(toRemoveArray,-1);var toAddString=digestClassCounts(toAddArray,1);attr.$addClass(toAddString);attr.$removeClass(toRemoveString);}function digestClassCounts(classArray,count){var classesToUpdate=[];forEach(classArray,function(className){if(count>0||classCounts[className]){classCounts[className]=(classCounts[className]||0)+count;if(classCounts[className]===+(count>0)){classesToUpdate.push(className);}}});return classesToUpdate.join(' ');}function ngClassIndexWatchAction(newModulo){// This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
	// adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	// `ngClass[OneTime]WatchAction()` will update the classes.
	if(newModulo===selector){addClasses(oldClassString);}else{removeClasses(oldClassString);}oldModulo=newModulo;}function ngClassOneTimeWatchAction(newClassValue){var newClassString=toClassString(newClassValue);if(newClassString!==oldClassString){ngClassWatchAction(newClassString);}}function ngClassWatchAction(newClassString){if(oldModulo===selector){updateClasses(oldClassString,newClassString);}oldClassString=newClassString;}}};}];// Helpers
	function arrayDifference(tokens1,tokens2){if(!tokens1||!tokens1.length)return[];if(!tokens2||!tokens2.length)return tokens1;var values=[];outer:for(var i=0;i<tokens1.length;i++){var token=tokens1[i];for(var j=0;j<tokens2.length;j++){if(token===tokens2[j])continue outer;}values.push(token);}return values;}function split(classString){return classString&&classString.split(' ');}function toClassString(classValue){var classString=classValue;if(isArray(classValue)){classString=classValue.map(toClassString).join(' ');}else if(isObject(classValue)){classString=Object.keys(classValue).filter(function(key){return classValue[key];}).join(' ');}return classString;}function toFlatValue(classValue){var flatValue=classValue;if(isArray(classValue)){flatValue=classValue.map(toFlatValue);}else if(isObject(classValue)){var hasUndefined=false;flatValue=Object.keys(classValue).filter(function(key){var value=classValue[key];if(!hasUndefined&&isUndefined(value)){hasUndefined=true;}return value;});if(hasUndefined){// Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
	// the watcher, by including at least one `undefined` value.
	flatValue.push(undefined);}}return flatValue;}}/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */var ngClassDirective=classDirective('',true);/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */var ngClassOddDirective=classDirective('Odd',0);/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */var ngClassEvenDirective=classDirective('Even',1);/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */var ngCloakDirective=ngDirective({compile:function compile(element,attr){attr.$set('ngCloak',undefined);element.removeClass('ng-cloak');}});/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */var ngControllerDirective=[function(){return{restrict:'A',scope:true,controller:'@',priority:500};}];/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 *//*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */var ngEventDirectives={};// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents={'blur':true,'focus':true};forEach('click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),function(eventName){var directiveName=directiveNormalize('ng-'+eventName);ngEventDirectives[directiveName]=['$parse','$rootScope',function($parse,$rootScope){return{restrict:'A',compile:function compile($element,attr){// NOTE:
	// We expose the powerful `$event` object on the scope that provides access to the Window,
	// etc. This is OK, because expressions are not sandboxed any more (and the expression
	// sandbox was never meant to be a security feature anyway).
	var fn=$parse(attr[directiveName]);return function ngEventHandler(scope,element){element.on(eventName,function(event){var callback=function callback(){fn(scope,{$event:event});};if(forceAsyncEvents[eventName]&&$rootScope.$$phase){scope.$evalAsync(callback);}else{scope.$apply(callback);}});};}};}];});/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 *//**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 *//**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 *//**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */var ngIfDirective=['$animate','$compile',function($animate,$compile){return{multiElement:true,transclude:'element',priority:600,terminal:true,restrict:'A',$$tlb:true,link:function link($scope,$element,$attr,ctrl,$transclude){var block,childScope,previousElements;$scope.$watch($attr.ngIf,function ngIfWatchAction(value){if(value){if(!childScope){$transclude(function(clone,newScope){childScope=newScope;clone[clone.length++]=$compile.$$createComment('end ngIf',$attr.ngIf);// Note: We only need the first/last node of the cloned nodes.
	// However, we need to keep the reference to the jqlite wrapper as it might be changed later
	// by a directive with templateUrl when its template arrives.
	block={clone:clone};$animate.enter(clone,$element.parent(),$element);});}}else{if(previousElements){previousElements.remove();previousElements=null;}if(childScope){childScope.$destroy();childScope=null;}if(block){previousElements=getBlockNodes(block.clone);$animate.leave(previousElements).done(function(response){if(response!==false)previousElements=null;});block=null;}}});}};}];/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 *//**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 *//**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 *//**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */var ngIncludeDirective=['$templateRequest','$anchorScroll','$animate',function($templateRequest,$anchorScroll,$animate){return{restrict:'ECA',priority:400,terminal:true,transclude:'element',controller:angular.noop,compile:function compile(element,attr){var srcExp=attr.ngInclude||attr.src,onloadExp=attr.onload||'',autoScrollExp=attr.autoscroll;return function(scope,$element,$attr,ctrl,$transclude){var changeCounter=0,currentScope,previousElement,currentElement;var cleanupLastIncludeContent=function cleanupLastIncludeContent(){if(previousElement){previousElement.remove();previousElement=null;}if(currentScope){currentScope.$destroy();currentScope=null;}if(currentElement){$animate.leave(currentElement).done(function(response){if(response!==false)previousElement=null;});previousElement=currentElement;currentElement=null;}};scope.$watch(srcExp,function ngIncludeWatchAction(src){var afterAnimation=function afterAnimation(response){if(response!==false&&isDefined(autoScrollExp)&&(!autoScrollExp||scope.$eval(autoScrollExp))){$anchorScroll();}};var thisChangeId=++changeCounter;if(src){//set the 2nd param to true to ignore the template request error so that the inner
	//contents and scope can be cleaned up.
	$templateRequest(src,true).then(function(response){if(scope.$$destroyed)return;if(thisChangeId!==changeCounter)return;var newScope=scope.$new();ctrl.template=response;// Note: This will also link all children of ng-include that were contained in the original
	// html. If that content contains controllers, ... they could pollute/change the scope.
	// However, using ng-include on an element with additional content does not make sense...
	// Note: We can't remove them in the cloneAttchFn of $transclude as that
	// function is called before linking the content, which would apply child
	// directives to non existing elements.
	var clone=$transclude(newScope,function(clone){cleanupLastIncludeContent();$animate.enter(clone,null,$element).done(afterAnimation);});currentScope=newScope;currentElement=clone;currentScope.$emit('$includeContentLoaded',src);scope.$eval(onloadExp);},function(){if(scope.$$destroyed)return;if(thisChangeId===changeCounter){cleanupLastIncludeContent();scope.$emit('$includeContentError',src);}});scope.$emit('$includeContentRequested',src);}else{cleanupLastIncludeContent();ctrl.template=null;}});};}};}];// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective=['$compile',function($compile){return{restrict:'ECA',priority:-400,require:'ngInclude',link:function link(scope,$element,$attr,ctrl){if(toString.call($element[0]).match(/SVG/)){// WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	// support innerHTML, so detect this here and try to generate the contents
	// specially.
	$element.empty();$compile(jqLiteBuildFragment(ctrl.template,window.document).childNodes)(scope,function namespaceAdaptedClone(clone){$element.append(clone);},{futureParentElement:$element});return;}$element.html(ctrl.template);$compile($element.contents())(scope);}};}];/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */var ngInitDirective=ngDirective({priority:450,compile:function compile(){return{pre:function pre(scope,element,attrs){scope.$eval(attrs.ngInit);}};}});/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */var ngListDirective=function ngListDirective(){return{restrict:'A',priority:100,require:'ngModel',link:function link(scope,element,attr,ctrl){var ngList=attr.ngList||', ';var trimValues=attr.ngTrim!=='false';var separator=trimValues?trim(ngList):ngList;var parse=function parse(viewValue){// If the viewValue is invalid (say required but empty) it will be `undefined`
	if(isUndefined(viewValue))return;var list=[];if(viewValue){forEach(viewValue.split(separator),function(value){if(value)list.push(trimValues?trim(value):value);});}return list;};ctrl.$parsers.push(parse);ctrl.$formatters.push(function(value){if(isArray(value)){return value.join(ngList);}return undefined;});// Override the standard $isEmpty because an empty array means the input is empty.
	ctrl.$isEmpty=function(value){return!value||!value.length;};}};};/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/var VALID_CLASS='ng-valid',INVALID_CLASS='ng-invalid',PRISTINE_CLASS='ng-pristine',DIRTY_CLASS='ng-dirty',UNTOUCHED_CLASS='ng-untouched',TOUCHED_CLASS='ng-touched',EMPTY_CLASS='ng-empty',NOT_EMPTY_CLASS='ng-not-empty';var ngModelMinErr=minErr('ngModel');/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */NgModelController.$inject=['$scope','$exceptionHandler','$attrs','$element','$parse','$animate','$timeout','$q','$interpolate'];function NgModelController($scope,$exceptionHandler,$attr,$element,$parse,$animate,$timeout,$q,$interpolate){this.$viewValue=Number.NaN;this.$modelValue=Number.NaN;this.$$rawModelValue=undefined;// stores the parsed modelValue / model set from scope regardless of validity.
	this.$validators={};this.$asyncValidators={};this.$parsers=[];this.$formatters=[];this.$viewChangeListeners=[];this.$untouched=true;this.$touched=false;this.$pristine=true;this.$dirty=false;this.$valid=true;this.$invalid=false;this.$error={};// keep invalid keys here
	this.$$success={};// keep valid keys here
	this.$pending=undefined;// keep pending keys here
	this.$name=$interpolate($attr.name||'',false)($scope);this.$$parentForm=nullFormCtrl;this.$options=defaultModelOptions;this.$$updateEvents='';// Attach the correct context to the event handler function for updateOn
	this.$$updateEventHandler=this.$$updateEventHandler.bind(this);this.$$parsedNgModel=$parse($attr.ngModel);this.$$parsedNgModelAssign=this.$$parsedNgModel.assign;this.$$ngModelGet=this.$$parsedNgModel;this.$$ngModelSet=this.$$parsedNgModelAssign;this.$$pendingDebounce=null;this.$$parserValid=undefined;this.$$currentValidationRunId=0;// https://github.com/angular/angular.js/issues/15833
	// Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
	Object.defineProperty(this,'$$scope',{value:$scope});this.$$attr=$attr;this.$$element=$element;this.$$animate=$animate;this.$$timeout=$timeout;this.$$parse=$parse;this.$$q=$q;this.$$exceptionHandler=$exceptionHandler;setupValidity(this);setupModelWatcher(this);}NgModelController.prototype={$$initGetterSetters:function $$initGetterSetters(){if(this.$options.getOption('getterSetter')){var invokeModelGetter=this.$$parse(this.$$attr.ngModel+'()'),invokeModelSetter=this.$$parse(this.$$attr.ngModel+'($$$p)');this.$$ngModelGet=function($scope){var modelValue=this.$$parsedNgModel($scope);if(isFunction(modelValue)){modelValue=invokeModelGetter($scope);}return modelValue;};this.$$ngModelSet=function($scope,newValue){if(isFunction(this.$$parsedNgModel($scope))){invokeModelSetter($scope,{$$$p:newValue});}else{this.$$parsedNgModelAssign($scope,newValue);}};}else if(!this.$$parsedNgModel.assign){throw ngModelMinErr('nonassign','Expression \'{0}\' is non-assignable. Element: {1}',this.$$attr.ngModel,startingTag(this.$$element));}},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */$render:noop,/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */$isEmpty:function $isEmpty(value){// eslint-disable-next-line no-self-compare
	return isUndefined(value)||value===''||value===null||value!==value;},$$updateEmptyClasses:function $$updateEmptyClasses(value){if(this.$isEmpty(value)){this.$$animate.removeClass(this.$$element,NOT_EMPTY_CLASS);this.$$animate.addClass(this.$$element,EMPTY_CLASS);}else{this.$$animate.removeClass(this.$$element,EMPTY_CLASS);this.$$animate.addClass(this.$$element,NOT_EMPTY_CLASS);}},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */$setPristine:function $setPristine(){this.$dirty=false;this.$pristine=true;this.$$animate.removeClass(this.$$element,DIRTY_CLASS);this.$$animate.addClass(this.$$element,PRISTINE_CLASS);},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */$setDirty:function $setDirty(){this.$dirty=true;this.$pristine=false;this.$$animate.removeClass(this.$$element,PRISTINE_CLASS);this.$$animate.addClass(this.$$element,DIRTY_CLASS);this.$$parentForm.$setDirty();},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */$setUntouched:function $setUntouched(){this.$touched=false;this.$untouched=true;this.$$animate.setClass(this.$$element,UNTOUCHED_CLASS,TOUCHED_CLASS);},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */$setTouched:function $setTouched(){this.$touched=true;this.$untouched=false;this.$$animate.setClass(this.$$element,TOUCHED_CLASS,UNTOUCHED_CLASS);},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */$rollbackViewValue:function $rollbackViewValue(){this.$$timeout.cancel(this.$$pendingDebounce);this.$viewValue=this.$$lastCommittedViewValue;this.$render();},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */$validate:function $validate(){// ignore $validate before model is initialized
	if(isNumberNaN(this.$modelValue)){return;}var viewValue=this.$$lastCommittedViewValue;// Note: we use the $$rawModelValue as $modelValue might have been
	// set to undefined during a view -> model update that found validation
	// errors. We can't parse the view here, since that could change
	// the model although neither viewValue nor the model on the scope changed
	var modelValue=this.$$rawModelValue;var prevValid=this.$valid;var prevModelValue=this.$modelValue;var allowInvalid=this.$options.getOption('allowInvalid');var that=this;this.$$runValidators(modelValue,viewValue,function(allValid){// If there was no change in validity, don't update the model
	// This prevents changing an invalid modelValue to undefined
	if(!allowInvalid&&prevValid!==allValid){// Note: Don't check this.$valid here, as we could have
	// external validators (e.g. calculated on the server),
	// that just call $setValidity and need the model value
	// to calculate their validity.
	that.$modelValue=allValid?modelValue:undefined;if(that.$modelValue!==prevModelValue){that.$$writeModelToScope();}}});},$$runValidators:function $$runValidators(modelValue,viewValue,doneCallback){this.$$currentValidationRunId++;var localValidationRunId=this.$$currentValidationRunId;var that=this;// check parser error
	if(!processParseErrors()){validationDone(false);return;}if(!processSyncValidators()){validationDone(false);return;}processAsyncValidators();function processParseErrors(){var errorKey=that.$$parserName||'parse';if(isUndefined(that.$$parserValid)){setValidity(errorKey,null);}else{if(!that.$$parserValid){forEach(that.$validators,function(v,name){setValidity(name,null);});forEach(that.$asyncValidators,function(v,name){setValidity(name,null);});}// Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	setValidity(errorKey,that.$$parserValid);return that.$$parserValid;}return true;}function processSyncValidators(){var syncValidatorsValid=true;forEach(that.$validators,function(validator,name){var result=Boolean(validator(modelValue,viewValue));syncValidatorsValid=syncValidatorsValid&&result;setValidity(name,result);});if(!syncValidatorsValid){forEach(that.$asyncValidators,function(v,name){setValidity(name,null);});return false;}return true;}function processAsyncValidators(){var validatorPromises=[];var allValid=true;forEach(that.$asyncValidators,function(validator,name){var promise=validator(modelValue,viewValue);if(!isPromiseLike(promise)){throw ngModelMinErr('nopromise','Expected asynchronous validator to return a promise but got \'{0}\' instead.',promise);}setValidity(name,undefined);validatorPromises.push(promise.then(function(){setValidity(name,true);},function(){allValid=false;setValidity(name,false);}));});if(!validatorPromises.length){validationDone(true);}else{that.$$q.all(validatorPromises).then(function(){validationDone(allValid);},noop);}}function setValidity(name,isValid){if(localValidationRunId===that.$$currentValidationRunId){that.$setValidity(name,isValid);}}function validationDone(allValid){if(localValidationRunId===that.$$currentValidationRunId){doneCallback(allValid);}}},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */$commitViewValue:function $commitViewValue(){var viewValue=this.$viewValue;this.$$timeout.cancel(this.$$pendingDebounce);// If the view value has not changed then we should just exit, except in the case where there is
	// a native validator on the element. In this case the validation state may have changed even though
	// the viewValue has stayed empty.
	if(this.$$lastCommittedViewValue===viewValue&&(viewValue!==''||!this.$$hasNativeValidators)){return;}this.$$updateEmptyClasses(viewValue);this.$$lastCommittedViewValue=viewValue;// change to dirty
	if(this.$pristine){this.$setDirty();}this.$$parseAndValidate();},$$parseAndValidate:function $$parseAndValidate(){var viewValue=this.$$lastCommittedViewValue;var modelValue=viewValue;var that=this;this.$$parserValid=isUndefined(modelValue)?undefined:true;if(this.$$parserValid){for(var i=0;i<this.$parsers.length;i++){modelValue=this.$parsers[i](modelValue);if(isUndefined(modelValue)){this.$$parserValid=false;break;}}}if(isNumberNaN(this.$modelValue)){// this.$modelValue has not been touched yet...
	this.$modelValue=this.$$ngModelGet(this.$$scope);}var prevModelValue=this.$modelValue;var allowInvalid=this.$options.getOption('allowInvalid');this.$$rawModelValue=modelValue;if(allowInvalid){this.$modelValue=modelValue;writeToModelIfNeeded();}// Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	// This can happen if e.g. $setViewValue is called from inside a parser
	this.$$runValidators(modelValue,this.$$lastCommittedViewValue,function(allValid){if(!allowInvalid){// Note: Don't check this.$valid here, as we could have
	// external validators (e.g. calculated on the server),
	// that just call $setValidity and need the model value
	// to calculate their validity.
	that.$modelValue=allValid?modelValue:undefined;writeToModelIfNeeded();}});function writeToModelIfNeeded(){if(that.$modelValue!==prevModelValue){that.$$writeModelToScope();}}},$$writeModelToScope:function $$writeModelToScope(){this.$$ngModelSet(this.$$scope,this.$modelValue);forEach(this.$viewChangeListeners,function(listener){try{listener();}catch(e){// eslint-disable-next-line no-invalid-this
	this.$$exceptionHandler(e);}},this);},/**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */$setViewValue:function $setViewValue(value,trigger){this.$viewValue=value;if(this.$options.getOption('updateOnDefault')){this.$$debounceViewValueCommit(trigger);}},$$debounceViewValueCommit:function $$debounceViewValueCommit(trigger){var debounceDelay=this.$options.getOption('debounce');if(isNumber(debounceDelay[trigger])){debounceDelay=debounceDelay[trigger];}else if(isNumber(debounceDelay['default'])){debounceDelay=debounceDelay['default'];}this.$$timeout.cancel(this.$$pendingDebounce);var that=this;if(debounceDelay>0){// this fails if debounceDelay is an object
	this.$$pendingDebounce=this.$$timeout(function(){that.$commitViewValue();},debounceDelay);}else if(this.$$scope.$root.$$phase){this.$commitViewValue();}else{this.$$scope.$apply(function(){that.$commitViewValue();});}},/**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */$overrideModelOptions:function $overrideModelOptions(options){this.$options=this.$options.createChild(options);this.$$setUpdateOnEvents();},/**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */$processModelValue:function $processModelValue(){var viewValue=this.$$format();if(this.$viewValue!==viewValue){this.$$updateEmptyClasses(viewValue);this.$viewValue=this.$$lastCommittedViewValue=viewValue;this.$render();// It is possible that model and view value have been updated during render
	this.$$runValidators(this.$modelValue,this.$viewValue,noop);}},/**
	   * This method is called internally to run the $formatters on the $modelValue
	   */$$format:function $$format(){var formatters=this.$formatters,idx=formatters.length;var viewValue=this.$modelValue;while(idx--){viewValue=formatters[idx](viewValue);}return viewValue;},/**
	   * This method is called internally when the bound scope value changes.
	   */$$setModelValue:function $$setModelValue(modelValue){this.$modelValue=this.$$rawModelValue=modelValue;this.$$parserValid=undefined;this.$processModelValue();},$$setUpdateOnEvents:function $$setUpdateOnEvents(){if(this.$$updateEvents){this.$$element.off(this.$$updateEvents,this.$$updateEventHandler);}this.$$updateEvents=this.$options.getOption('updateOn');if(this.$$updateEvents){this.$$element.on(this.$$updateEvents,this.$$updateEventHandler);}},$$updateEventHandler:function $$updateEventHandler(ev){this.$$debounceViewValueCommit(ev&&ev.type);}};function setupModelWatcher(ctrl){// model -> value
	// Note: we cannot use a normal scope.$watch as we want to detect the following:
	// 1. scope value is 'a'
	// 2. user enters 'b'
	// 3. ng-change kicks in and reverts scope value to 'a'
	//    -> scope value did not change since the last digest as
	//       ng-change executes in apply phase
	// 4. view should be changed back to 'a'
	ctrl.$$scope.$watch(function ngModelWatch(scope){var modelValue=ctrl.$$ngModelGet(scope);// if scope model value and ngModel value are out of sync
	// This cannot be moved to the action function, because it would not catch the
	// case where the model is changed in the ngChange function or the model setter
	if(modelValue!==ctrl.$modelValue&&(// checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	// eslint-disable-next-line no-self-compare
	ctrl.$modelValue===ctrl.$modelValue||modelValue===modelValue)){ctrl.$$setModelValue(modelValue);}return modelValue;});}/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */addSetValidityMethod({clazz:NgModelController,set:function set(object,property){object[property]=true;},unset:function unset(object,property){delete object[property];}});/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */var ngModelDirective=['$rootScope',function($rootScope){return{restrict:'A',require:['ngModel','^?form','^?ngModelOptions'],controller:NgModelController,// Prelink needs to run before any input directive
	// so that we can set the NgModelOptions in NgModelController
	// before anyone else uses it.
	priority:1,compile:function ngModelCompile(element){// Setup initial state of the control
	element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);return{pre:function ngModelPreLink(scope,element,attr,ctrls){var modelCtrl=ctrls[0],formCtrl=ctrls[1]||modelCtrl.$$parentForm,optionsCtrl=ctrls[2];if(optionsCtrl){modelCtrl.$options=optionsCtrl.$options;}modelCtrl.$$initGetterSetters();// notify others, especially parent forms
	formCtrl.$addControl(modelCtrl);attr.$observe('name',function(newValue){if(modelCtrl.$name!==newValue){modelCtrl.$$parentForm.$$renameControl(modelCtrl,newValue);}});scope.$on('$destroy',function(){modelCtrl.$$parentForm.$removeControl(modelCtrl);});},post:function ngModelPostLink(scope,element,attr,ctrls){var modelCtrl=ctrls[0];modelCtrl.$$setUpdateOnEvents();function setTouched(){modelCtrl.$setTouched();}element.on('blur',function(){if(modelCtrl.$touched)return;if($rootScope.$$phase){scope.$evalAsync(setTouched);}else{scope.$apply(setTouched);}});}};}};}];/* exported defaultModelOptions */var defaultModelOptions;var DEFAULT_REGEXP=/(\s+|^)default(\s+|$)/;/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */function ModelOptions(options){this.$$options=options;}ModelOptions.prototype={/**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */getOption:function getOption(name){return this.$$options[name];},/**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */createChild:function createChild(options){var inheritAll=false;// make a shallow copy
	options=extend({},options);// Inherit options from the parent if specified by the value `"$inherit"`
	forEach(options,/* @this */function(option,key){if(option==='$inherit'){if(key==='*'){inheritAll=true;}else{options[key]=this.$$options[key];// `updateOn` is special so we must also inherit the `updateOnDefault` option
	if(key==='updateOn'){options.updateOnDefault=this.$$options.updateOnDefault;}}}else{if(key==='updateOn'){// If the `updateOn` property contains the `default` event then we have to remove
	// it from the event list and set the `updateOnDefault` flag.
	options.updateOnDefault=false;options[key]=trim(option.replace(DEFAULT_REGEXP,function(){options.updateOnDefault=true;return' ';}));}}},this);if(inheritAll){// We have a property of the form: `"*": "$inherit"`
	delete options['*'];defaults(options,this.$$options);}// Finally add in any missing defaults
	defaults(options,defaultModelOptions.$$options);return new ModelOptions(options);}};defaultModelOptions=new ModelOptions({updateOn:'',updateOnDefault:true,debounce:0,getterSetter:false,allowInvalid:false,timezone:null});/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 *
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur click',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *
	 *     "default" also applies to all events that are listed in `updateOn` but are not
	 *     listed in `debounce`, i.e. "click" would also be debounced by 500 milliseconds.
	 *
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */var ngModelOptionsDirective=function ngModelOptionsDirective(){NgModelOptionsController.$inject=['$attrs','$scope'];function NgModelOptionsController($attrs,$scope){this.$$attrs=$attrs;this.$$scope=$scope;}NgModelOptionsController.prototype={$onInit:function $onInit(){var parentOptions=this.parentCtrl?this.parentCtrl.$options:defaultModelOptions;var modelOptionsDefinition=this.$$scope.$eval(this.$$attrs.ngModelOptions);this.$options=parentOptions.createChild(modelOptionsDefinition);}};return{restrict:'A',// ngModelOptions needs to run before ngModel and input directives
	priority:10,require:{parentCtrl:'?^^ngModelOptions'},bindToController:true,controller:NgModelOptionsController};};// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst,src){forEach(src,function(value,key){if(!isDefined(dst[key])){dst[key]=value;}});}/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */var ngNonBindableDirective=ngDirective({terminal:true,priority:1000});/* exported ngOptionsDirective *//* global jqLiteRemove */var ngOptionsMinErr=minErr('ngOptions');/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 *//* eslint-disable max-len *///                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;// 1: value expression (valueFn)
	// 2: label expression (displayFn)
	// 3: group by expression (groupByFn)
	// 4: disable when expression (disableWhenFn)
	// 5: array item variable name
	// 6: object item key variable name
	// 7: object item value variable name
	// 8: collection expression
	// 9: track by expression
	/* eslint-enable */var ngOptionsDirective=['$compile','$document','$parse',function($compile,$document,$parse){function parseOptionsExpression(optionsExp,selectElement,scope){var match=optionsExp.match(NG_OPTIONS_REGEXP);if(!match){throw ngOptionsMinErr('iexp','Expected expression in form of '+'\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\''+' but got \'{0}\'. Element: {1}',optionsExp,startingTag(selectElement));}// Extract the parts from the ngOptions expression
	// The variable name for the value of the item in the collection
	var valueName=match[5]||match[7];// The variable name for the key of the item in the collection
	var keyName=match[6];// An expression that generates the viewValue for an option if there is a label expression
	var selectAs=/ as /.test(match[0])&&match[1];// An expression that is used to track the id of each object in the options collection
	var trackBy=match[9];// An expression that generates the viewValue for an option if there is no label expression
	var valueFn=$parse(match[2]?match[1]:valueName);var selectAsFn=selectAs&&$parse(selectAs);var viewValueFn=selectAsFn||valueFn;var trackByFn=trackBy&&$parse(trackBy);// Get the value by which we are going to track the option
	// if we have a trackFn then use that (passing scope and locals)
	// otherwise just hash the given viewValue
	var getTrackByValueFn=trackBy?function(value,locals){return trackByFn(scope,locals);}:function getHashOfValue(value){return hashKey(value);};var getTrackByValue=function getTrackByValue(value,key){return getTrackByValueFn(value,getLocals(value,key));};var displayFn=$parse(match[2]||match[1]);var groupByFn=$parse(match[3]||'');var disableWhenFn=$parse(match[4]||'');var valuesFn=$parse(match[8]);var locals={};var getLocals=keyName?function(value,key){locals[keyName]=key;locals[valueName]=value;return locals;}:function(value){locals[valueName]=value;return locals;};function Option(selectValue,viewValue,label,group,disabled){this.selectValue=selectValue;this.viewValue=viewValue;this.label=label;this.group=group;this.disabled=disabled;}function getOptionValuesKeys(optionValues){var optionValuesKeys;if(!keyName&&isArrayLike(optionValues)){optionValuesKeys=optionValues;}else{// if object, extract keys, in enumeration order, unsorted
	optionValuesKeys=[];for(var itemKey in optionValues){if(optionValues.hasOwnProperty(itemKey)&&itemKey.charAt(0)!=='$'){optionValuesKeys.push(itemKey);}}}return optionValuesKeys;}return{trackBy:trackBy,getTrackByValue:getTrackByValue,getWatchables:$parse(valuesFn,function(optionValues){// Create a collection of things that we would like to watch (watchedArray)
	// so that they can all be watched using a single $watchCollection
	// that only runs the handler once if anything changes
	var watchedArray=[];optionValues=optionValues||[];var optionValuesKeys=getOptionValuesKeys(optionValues);var optionValuesLength=optionValuesKeys.length;for(var index=0;index<optionValuesLength;index++){var key=optionValues===optionValuesKeys?index:optionValuesKeys[index];var value=optionValues[key];var locals=getLocals(value,key);var selectValue=getTrackByValueFn(value,locals);watchedArray.push(selectValue);// Only need to watch the displayFn if there is a specific label expression
	if(match[2]||match[1]){var label=displayFn(scope,locals);watchedArray.push(label);}// Only need to watch the disableWhenFn if there is a specific disable expression
	if(match[4]){var disableWhen=disableWhenFn(scope,locals);watchedArray.push(disableWhen);}}return watchedArray;}),getOptions:function getOptions(){var optionItems=[];var selectValueMap={};// The option values were already computed in the `getWatchables` fn,
	// which must have been called to trigger `getOptions`
	var optionValues=valuesFn(scope)||[];var optionValuesKeys=getOptionValuesKeys(optionValues);var optionValuesLength=optionValuesKeys.length;for(var index=0;index<optionValuesLength;index++){var key=optionValues===optionValuesKeys?index:optionValuesKeys[index];var value=optionValues[key];var locals=getLocals(value,key);var viewValue=viewValueFn(scope,locals);var selectValue=getTrackByValueFn(viewValue,locals);var label=displayFn(scope,locals);var group=groupByFn(scope,locals);var disabled=disableWhenFn(scope,locals);var optionItem=new Option(selectValue,viewValue,label,group,disabled);optionItems.push(optionItem);selectValueMap[selectValue]=optionItem;}return{items:optionItems,selectValueMap:selectValueMap,getOptionFromViewValue:function getOptionFromViewValue(value){return selectValueMap[getTrackByValue(value)];},getViewValueFromOption:function getViewValueFromOption(option){// If the viewValue could be an object that may be mutated by the application,
	// we need to make a copy and not return the reference to the value on the option.
	return trackBy?copy(option.viewValue):option.viewValue;}};}};}// Support: IE 9 only
	// We can't just jqLite('<option>') since jqLite is not smart enough
	// to create it in <select> and IE barfs otherwise.
	var optionTemplate=window.document.createElement('option'),optGroupTemplate=window.document.createElement('optgroup');function ngOptionsPostLink(scope,selectElement,attr,ctrls){var selectCtrl=ctrls[0];var ngModelCtrl=ctrls[1];var multiple=attr.multiple;// The emptyOption allows the application developer to provide their own custom "empty"
	// option when the viewValue does not match any of the option values.
	for(var i=0,children=selectElement.children(),ii=children.length;i<ii;i++){if(children[i].value===''){selectCtrl.hasEmptyOption=true;selectCtrl.emptyOption=children.eq(i);break;}}// The empty option will be compiled and rendered before we first generate the options
	selectElement.empty();var providedEmptyOption=!!selectCtrl.emptyOption;var unknownOption=jqLite(optionTemplate.cloneNode(false));unknownOption.val('?');var options;var ngOptions=parseOptionsExpression(attr.ngOptions,selectElement,scope);// This stores the newly created options before they are appended to the select.
	// Since the contents are removed from the fragment when it is appended,
	// we only need to create it once.
	var listFragment=$document[0].createDocumentFragment();// Overwrite the implementation. ngOptions doesn't use hashes
	selectCtrl.generateUnknownOptionValue=function(val){return'?';};// Update the controller methods for multiple selectable options
	if(!multiple){selectCtrl.writeValue=function writeNgOptionsValue(value){// The options might not be defined yet when ngModel tries to render
	if(!options)return;var selectedOption=selectElement[0].options[selectElement[0].selectedIndex];var option=options.getOptionFromViewValue(value);// Make sure to remove the selected attribute from the previously selected option
	// Otherwise, screen readers might get confused
	if(selectedOption)selectedOption.removeAttribute('selected');if(option){// Don't update the option when it is already selected.
	// For example, the browser will select the first option by default. In that case,
	// most properties are set automatically - except the `selected` attribute, which we
	// set always
	if(selectElement[0].value!==option.selectValue){selectCtrl.removeUnknownOption();selectElement[0].value=option.selectValue;option.element.selected=true;}option.element.setAttribute('selected','selected');}else{selectCtrl.selectUnknownOrEmptyOption(value);}};selectCtrl.readValue=function readNgOptionsValue(){var selectedOption=options.selectValueMap[selectElement.val()];if(selectedOption&&!selectedOption.disabled){selectCtrl.unselectEmptyOption();selectCtrl.removeUnknownOption();return options.getViewValueFromOption(selectedOption);}return null;};// If we are using `track by` then we must watch the tracked value on the model
	// since ngModel only watches for object identity change
	// FIXME: When a user selects an option, this watch will fire needlessly
	if(ngOptions.trackBy){scope.$watch(function(){return ngOptions.getTrackByValue(ngModelCtrl.$viewValue);},function(){ngModelCtrl.$render();});}}else{selectCtrl.writeValue=function writeNgOptionsMultiple(values){// The options might not be defined yet when ngModel tries to render
	if(!options)return;// Only set `<option>.selected` if necessary, in order to prevent some browsers from
	// scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	var selectedOptions=values&&values.map(getAndUpdateSelectedOption)||[];options.items.forEach(function(option){if(option.element.selected&&!includes(selectedOptions,option)){option.element.selected=false;}});};selectCtrl.readValue=function readNgOptionsMultiple(){var selectedValues=selectElement.val()||[],selections=[];forEach(selectedValues,function(value){var option=options.selectValueMap[value];if(option&&!option.disabled)selections.push(options.getViewValueFromOption(option));});return selections;};// If we are using `track by` then we must watch these tracked values on the model
	// since ngModel only watches for object identity change
	if(ngOptions.trackBy){scope.$watchCollection(function(){if(isArray(ngModelCtrl.$viewValue)){return ngModelCtrl.$viewValue.map(function(value){return ngOptions.getTrackByValue(value);});}},function(){ngModelCtrl.$render();});}}if(providedEmptyOption){// compile the element since there might be bindings in it
	$compile(selectCtrl.emptyOption)(scope);selectElement.prepend(selectCtrl.emptyOption);if(selectCtrl.emptyOption[0].nodeType===NODE_TYPE_COMMENT){// This means the empty option has currently no actual DOM node, probably because
	// it has been modified by a transclusion directive.
	selectCtrl.hasEmptyOption=false;// Redefine the registerOption function, which will catch
	// options that are added by ngIf etc. (rendering of the node is async because of
	// lazy transclusion)
	selectCtrl.registerOption=function(optionScope,optionEl){if(optionEl.val()===''){selectCtrl.hasEmptyOption=true;selectCtrl.emptyOption=optionEl;selectCtrl.emptyOption.removeClass('ng-scope');// This ensures the new empty option is selected if previously no option was selected
	ngModelCtrl.$render();optionEl.on('$destroy',function(){var needsRerender=selectCtrl.$isEmptyOptionSelected();selectCtrl.hasEmptyOption=false;selectCtrl.emptyOption=undefined;if(needsRerender)ngModelCtrl.$render();});}};}else{// remove the class, which is added automatically because we recompile the element and it
	// becomes the compilation root
	selectCtrl.emptyOption.removeClass('ng-scope');}}// We will re-render the option elements if the option values or labels change
	scope.$watchCollection(ngOptions.getWatchables,updateOptions);// ------------------------------------------------------------------ //
	function addOptionElement(option,parent){var optionElement=optionTemplate.cloneNode(false);parent.appendChild(optionElement);updateOptionElement(option,optionElement);}function getAndUpdateSelectedOption(viewValue){var option=options.getOptionFromViewValue(viewValue);var element=option&&option.element;if(element&&!element.selected)element.selected=true;return option;}function updateOptionElement(option,element){option.element=element;element.disabled=option.disabled;// Support: IE 11 only, Edge 12-13 only
	// NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	// selects in certain circumstances when multiple selects are next to each other and display
	// the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	// See https://github.com/angular/angular.js/issues/11314 for more info.
	// This is unfortunately untestable with unit / e2e tests
	if(option.label!==element.label){element.label=option.label;element.textContent=option.label;}element.value=option.selectValue;}function updateOptions(){var previousValue=options&&selectCtrl.readValue();// We must remove all current options, but cannot simply set innerHTML = null
	// since the providedEmptyOption might have an ngIf on it that inserts comments which we
	// must preserve.
	// Instead, iterate over the current option elements and remove them or their optgroup
	// parents
	if(options){for(var i=options.items.length-1;i>=0;i--){var option=options.items[i];if(isDefined(option.group)){jqLiteRemove(option.element.parentNode);}else{jqLiteRemove(option.element);}}}options=ngOptions.getOptions();var groupElementMap={};options.items.forEach(function addOption(option){var groupElement;if(isDefined(option.group)){// This option is to live in a group
	// See if we have already created this group
	groupElement=groupElementMap[option.group];if(!groupElement){groupElement=optGroupTemplate.cloneNode(false);listFragment.appendChild(groupElement);// Update the label on the group element
	// "null" is special cased because of Safari
	groupElement.label=option.group===null?'null':option.group;// Store it for use later
	groupElementMap[option.group]=groupElement;}addOptionElement(option,groupElement);}else{// This option is not in a group
	addOptionElement(option,listFragment);}});selectElement[0].appendChild(listFragment);ngModelCtrl.$render();// Check to see if the value has changed due to the update to the options
	if(!ngModelCtrl.$isEmpty(previousValue)){var nextValue=selectCtrl.readValue();var isNotPrimitive=ngOptions.trackBy||multiple;if(isNotPrimitive?!equals(previousValue,nextValue):previousValue!==nextValue){ngModelCtrl.$setViewValue(nextValue);ngModelCtrl.$render();}}}}return{restrict:'A',terminal:true,require:['select','ngModel'],link:{pre:function ngOptionsPreLink(scope,selectElement,attr,ctrls){// Deactivate the SelectController.register method to prevent
	// option directives from accidentally registering themselves
	// (and unwanted $destroy handlers etc.)
	ctrls[0].registerOption=noop;},post:ngOptionsPostLink}};}];/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */var ngPluralizeDirective=['$locale','$interpolate','$log',function($locale,$interpolate,$log){var BRACE=/{}/g,IS_WHEN=/^when(Minus)?(.+)$/;return{link:function link(scope,element,attr){var numberExp=attr.count,whenExp=attr.$attr.when&&element.attr(attr.$attr.when),// we have {{}} in attrs
	offset=attr.offset||0,whens=scope.$eval(whenExp)||{},whensExpFns={},startSymbol=$interpolate.startSymbol(),endSymbol=$interpolate.endSymbol(),braceReplacement=startSymbol+numberExp+'-'+offset+endSymbol,watchRemover=angular.noop,lastCount;forEach(attr,function(expression,attributeName){var tmpMatch=IS_WHEN.exec(attributeName);if(tmpMatch){var whenKey=(tmpMatch[1]?'-':'')+lowercase(tmpMatch[2]);whens[whenKey]=element.attr(attr.$attr[attributeName]);}});forEach(whens,function(expression,key){whensExpFns[key]=$interpolate(expression.replace(BRACE,braceReplacement));});scope.$watch(numberExp,function ngPluralizeWatchAction(newVal){var count=parseFloat(newVal);var countIsNaN=isNumberNaN(count);if(!countIsNaN&&!(count in whens)){// If an explicit number rule such as 1, 2, 3... is defined, just use it.
	// Otherwise, check it against pluralization rules in $locale service.
	count=$locale.pluralCat(count-offset);}// If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	// In JS `NaN !== NaN`, so we have to explicitly check.
	if(count!==lastCount&&!(countIsNaN&&isNumberNaN(lastCount))){watchRemover();var whenExpFn=whensExpFns[count];if(isUndefined(whenExpFn)){if(newVal!=null){$log.debug('ngPluralize: no rule defined for \''+count+'\' in '+whenExp);}watchRemover=noop;updateElementText();}else{watchRemover=scope.$watch(whenExpFn,updateElementText);}lastCount=count;}});function updateElementText(newText){element.text(newText||'');}}};}];/* exported ngRepeatDirective *//**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */var ngRepeatDirective=['$parse','$animate','$compile',function($parse,$animate,$compile){var NG_REMOVED='$$NG_REMOVED';var ngRepeatMinErr=minErr('ngRepeat');var updateScope=function updateScope(scope,index,valueIdentifier,value,keyIdentifier,key,arrayLength){// TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	scope[valueIdentifier]=value;if(keyIdentifier)scope[keyIdentifier]=key;scope.$index=index;scope.$first=index===0;scope.$last=index===arrayLength-1;scope.$middle=!(scope.$first||scope.$last);// eslint-disable-next-line no-bitwise
	scope.$odd=!(scope.$even=(index&1)===0);};var getBlockStart=function getBlockStart(block){return block.clone[0];};var getBlockEnd=function getBlockEnd(block){return block.clone[block.clone.length-1];};return{restrict:'A',multiElement:true,transclude:'element',priority:1000,terminal:true,$$tlb:true,compile:function ngRepeatCompile($element,$attr){var expression=$attr.ngRepeat;var ngRepeatEndComment=$compile.$$createComment('end ngRepeat',expression);var match=expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);if(!match){throw ngRepeatMinErr('iexp','Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',expression);}var lhs=match[1];var rhs=match[2];var aliasAs=match[3];var trackByExp=match[4];match=lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);if(!match){throw ngRepeatMinErr('iidexp','\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',lhs);}var valueIdentifier=match[3]||match[1];var keyIdentifier=match[2];if(aliasAs&&(!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs)||/^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))){throw ngRepeatMinErr('badident','alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',aliasAs);}var trackByExpGetter,trackByIdExpFn,trackByIdArrayFn,trackByIdObjFn;var hashFnLocals={$id:hashKey};if(trackByExp){trackByExpGetter=$parse(trackByExp);}else{trackByIdArrayFn=function trackByIdArrayFn(key,value){return hashKey(value);};trackByIdObjFn=function trackByIdObjFn(key){return key;};}return function ngRepeatLink($scope,$element,$attr,ctrl,$transclude){if(trackByExpGetter){trackByIdExpFn=function trackByIdExpFn(key,value,index){// assign key, value, and $index to the locals so that they can be used in hash functions
	if(keyIdentifier)hashFnLocals[keyIdentifier]=key;hashFnLocals[valueIdentifier]=value;hashFnLocals.$index=index;return trackByExpGetter($scope,hashFnLocals);};}// Store a list of elements from previous run. This is a hash where key is the item from the
	// iterator, and the value is objects with following properties.
	//   - scope: bound scope
	//   - clone: previous element.
	//   - index: position
	//
	// We are using no-proto object so that we don't need to guard against inherited props via
	// hasOwnProperty.
	var lastBlockMap=createMap();//watch props
	$scope.$watchCollection(rhs,function ngRepeatAction(collection){var index,length,previousNode=$element[0],// node that cloned nodes should be inserted after
	// initialized to the comment node anchor
	nextNode,// Same as lastBlockMap but it has the current state. It will become the
	// lastBlockMap on the next iteration.
	nextBlockMap=createMap(),collectionLength,key,value,// key/value of iteration
	trackById,trackByIdFn,collectionKeys,block,// last object information {scope, element, id}
	nextBlockOrder,elementsToRemove;if(aliasAs){$scope[aliasAs]=collection;}if(isArrayLike(collection)){collectionKeys=collection;trackByIdFn=trackByIdExpFn||trackByIdArrayFn;}else{trackByIdFn=trackByIdExpFn||trackByIdObjFn;// if object, extract keys, in enumeration order, unsorted
	collectionKeys=[];for(var itemKey in collection){if(hasOwnProperty.call(collection,itemKey)&&itemKey.charAt(0)!=='$'){collectionKeys.push(itemKey);}}}collectionLength=collectionKeys.length;nextBlockOrder=new Array(collectionLength);// locate existing items
	for(index=0;index<collectionLength;index++){key=collection===collectionKeys?index:collectionKeys[index];value=collection[key];trackById=trackByIdFn(key,value,index);if(lastBlockMap[trackById]){// found previously seen block
	block=lastBlockMap[trackById];delete lastBlockMap[trackById];nextBlockMap[trackById]=block;nextBlockOrder[index]=block;}else if(nextBlockMap[trackById]){// if collision detected. restore lastBlockMap and throw an error
	forEach(nextBlockOrder,function(block){if(block&&block.scope)lastBlockMap[block.id]=block;});throw ngRepeatMinErr('dupes','Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',expression,trackById,value);}else{// new never before seen block
	nextBlockOrder[index]={id:trackById,scope:undefined,clone:undefined};nextBlockMap[trackById]=true;}}// remove leftover items
	for(var blockKey in lastBlockMap){block=lastBlockMap[blockKey];elementsToRemove=getBlockNodes(block.clone);$animate.leave(elementsToRemove);if(elementsToRemove[0].parentNode){// if the element was not removed yet because of pending animation, mark it as deleted
	// so that we can ignore it later
	for(index=0,length=elementsToRemove.length;index<length;index++){elementsToRemove[index][NG_REMOVED]=true;}}block.scope.$destroy();}// we are not using forEach for perf reasons (trying to avoid #call)
	for(index=0;index<collectionLength;index++){key=collection===collectionKeys?index:collectionKeys[index];value=collection[key];block=nextBlockOrder[index];if(block.scope){// if we have already seen this object, then we need to reuse the
	// associated scope/element
	nextNode=previousNode;// skip nodes that are already pending removal via leave animation
	do{nextNode=nextNode.nextSibling;}while(nextNode&&nextNode[NG_REMOVED]);if(getBlockStart(block)!==nextNode){// existing item which got moved
	$animate.move(getBlockNodes(block.clone),null,previousNode);}previousNode=getBlockEnd(block);updateScope(block.scope,index,valueIdentifier,value,keyIdentifier,key,collectionLength);}else{// new item which we don't know about
	$transclude(function ngRepeatTransclude(clone,scope){block.scope=scope;// http://jsperf.com/clone-vs-createcomment
	var endNode=ngRepeatEndComment.cloneNode(false);clone[clone.length++]=endNode;$animate.enter(clone,null,previousNode);previousNode=endNode;// Note: We only need the first/last node of the cloned nodes.
	// However, we need to keep the reference to the jqlite wrapper as it might be changed later
	// by a directive with templateUrl when its template arrives.
	block.clone=clone;nextBlockMap[block.id]=block;updateScope(block.scope,index,valueIdentifier,value,keyIdentifier,key,collectionLength);});}}lastBlockMap=nextBlockMap;});};}};}];var NG_HIDE_CLASS='ng-hide';var NG_HIDE_IN_PROGRESS_CLASS='ng-hide-animate';/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */var ngShowDirective=['$animate',function($animate){return{restrict:'A',multiElement:true,link:function link(scope,element,attr){scope.$watch(attr.ngShow,function ngShowWatchAction(value){// we're adding a temporary, animation-specific class for ng-hide since this way
	// we can control when the element is actually displayed on screen without having
	// to have a global/greedy CSS selector that breaks when other animations are run.
	// Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	$animate[value?'removeClass':'addClass'](element,NG_HIDE_CLASS,{tempClasses:NG_HIDE_IN_PROGRESS_CLASS});});}};}];/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */var ngHideDirective=['$animate',function($animate){return{restrict:'A',multiElement:true,link:function link(scope,element,attr){scope.$watch(attr.ngHide,function ngHideWatchAction(value){// The comment inside of the ngShowDirective explains why we add and
	// remove a temporary class for the show/hide animation
	$animate[value?'addClass':'removeClass'](element,NG_HIDE_CLASS,{tempClasses:NG_HIDE_IN_PROGRESS_CLASS});});}};}];/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */var ngStyleDirective=ngDirective(function(scope,element,attr){scope.$watch(attr.ngStyle,function ngStyleWatchAction(newStyles,oldStyles){if(oldStyles&&newStyles!==oldStyles){forEach(oldStyles,function(val,style){element.css(style,'');});}if(newStyles)element.css(newStyles);},true);});/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */var ngSwitchDirective=['$animate','$compile',function($animate,$compile){return{require:'ngSwitch',// asks for $scope to fool the BC controller module
	controller:['$scope',function NgSwitchController(){this.cases={};}],link:function link(scope,element,attr,ngSwitchController){var watchExpr=attr.ngSwitch||attr.on,selectedTranscludes=[],selectedElements=[],previousLeaveAnimations=[],selectedScopes=[];var spliceFactory=function spliceFactory(array,index){return function(response){if(response!==false)array.splice(index,1);};};scope.$watch(watchExpr,function ngSwitchWatchAction(value){var i,ii;// Start with the last, in case the array is modified during the loop
	while(previousLeaveAnimations.length){$animate.cancel(previousLeaveAnimations.pop());}for(i=0,ii=selectedScopes.length;i<ii;++i){var selected=getBlockNodes(selectedElements[i].clone);selectedScopes[i].$destroy();var runner=previousLeaveAnimations[i]=$animate.leave(selected);runner.done(spliceFactory(previousLeaveAnimations,i));}selectedElements.length=0;selectedScopes.length=0;if(selectedTranscludes=ngSwitchController.cases['!'+value]||ngSwitchController.cases['?']){forEach(selectedTranscludes,function(selectedTransclude){selectedTransclude.transclude(function(caseElement,selectedScope){selectedScopes.push(selectedScope);var anchor=selectedTransclude.element;caseElement[caseElement.length++]=$compile.$$createComment('end ngSwitchWhen');var block={clone:caseElement};selectedElements.push(block);$animate.enter(caseElement,anchor.parent(),anchor);});});}});}};}];var ngSwitchWhenDirective=ngDirective({transclude:'element',priority:1200,require:'^ngSwitch',multiElement:true,link:function link(scope,element,attrs,ctrl,$transclude){var cases=attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(// Filter duplicate cases
	function(element,index,array){return array[index-1]!==element;});forEach(cases,function(whenCase){ctrl.cases['!'+whenCase]=ctrl.cases['!'+whenCase]||[];ctrl.cases['!'+whenCase].push({transclude:$transclude,element:element});});}});var ngSwitchDefaultDirective=ngDirective({transclude:'element',priority:1200,require:'^ngSwitch',multiElement:true,link:function link(scope,element,attr,ctrl,$transclude){ctrl.cases['?']=ctrl.cases['?']||[];ctrl.cases['?'].push({transclude:$transclude,element:element});}});/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */var ngTranscludeMinErr=minErr('ngTransclude');var ngTranscludeDirective=['$compile',function($compile){return{restrict:'EAC',compile:function ngTranscludeCompile(tElement){// Remove and cache any original content to act as a fallback
	var fallbackLinkFn=$compile(tElement.contents());tElement.empty();return function ngTranscludePostLink($scope,$element,$attrs,controller,$transclude){if(!$transclude){throw ngTranscludeMinErr('orphan','Illegal use of ngTransclude directive in the template! '+'No parent directive that requires a transclusion found. '+'Element: {0}',startingTag($element));}// If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	if($attrs.ngTransclude===$attrs.$attr.ngTransclude){$attrs.ngTransclude='';}var slotName=$attrs.ngTransclude||$attrs.ngTranscludeSlot;// If the slot is required and no transclusion content is provided then this call will throw an error
	$transclude(ngTranscludeCloneAttachFn,null,slotName);// If the slot is optional and no transclusion content is provided then use the fallback content
	if(slotName&&!$transclude.isSlotFilled(slotName)){useFallbackContent();}function ngTranscludeCloneAttachFn(clone,transcludedScope){if(clone.length&&notWhitespace(clone)){$element.append(clone);}else{useFallbackContent();// There is nothing linked against the transcluded scope since no content was available,
	// so it should be safe to clean up the generated scope.
	transcludedScope.$destroy();}}function useFallbackContent(){// Since this is the fallback content rather than the transcluded content,
	// we link against the scope of this directive rather than the transcluded scope
	fallbackLinkFn($scope,function(clone){$element.append(clone);});}function notWhitespace(nodes){for(var i=0,ii=nodes.length;i<ii;i++){var node=nodes[i];if(node.nodeType!==NODE_TYPE_TEXT||node.nodeValue.trim()){return true;}}}};}};}];/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */var scriptDirective=['$templateCache',function($templateCache){return{restrict:'E',terminal:true,compile:function compile(element,attr){if(attr.type==='text/ng-template'){var templateUrl=attr.id,text=element[0].text;$templateCache.put(templateUrl,text);}}};}];/* exported selectDirective, optionDirective */var noopNgModelController={$setViewValue:noop,$render:noop};function setOptionSelectedStatus(optionEl,value){optionEl.prop('selected',value);/**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */optionEl.attr('selected',value);}/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */var SelectController=['$element','$scope',/** @this */function($element,$scope){var self=this,optionsMap=new NgMap();self.selectValueMap={};// Keys are the hashed values, values the original values
	// If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	self.ngModelCtrl=noopNgModelController;self.multiple=false;// The "unknown" option is one that is prepended to the list if the viewValue
	// does not match any of the options. When it is rendered the value of the unknown
	// option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	//
	// Support: IE 9 only
	// We can't just jqLite('<option>') since jqLite is not smart enough
	// to create it in <select> and IE barfs otherwise.
	self.unknownOption=jqLite(window.document.createElement('option'));// The empty option is an option with the value '' that the application developer can
	// provide inside the select. It is always selectable and indicates that a "null" selection has
	// been made by the user.
	// If the select has an empty option, and the model of the select is set to "undefined" or "null",
	// the empty option is selected.
	// If the model is set to a different unmatched value, the unknown option is rendered and
	// selected, i.e both are present, because a "null" selection and an unknown value are different.
	self.hasEmptyOption=false;self.emptyOption=undefined;self.renderUnknownOption=function(val){var unknownVal=self.generateUnknownOptionValue(val);self.unknownOption.val(unknownVal);$element.prepend(self.unknownOption);setOptionSelectedStatus(self.unknownOption,true);$element.val(unknownVal);};self.updateUnknownOption=function(val){var unknownVal=self.generateUnknownOptionValue(val);self.unknownOption.val(unknownVal);setOptionSelectedStatus(self.unknownOption,true);$element.val(unknownVal);};self.generateUnknownOptionValue=function(val){return'? '+hashKey(val)+' ?';};self.removeUnknownOption=function(){if(self.unknownOption.parent())self.unknownOption.remove();};self.selectEmptyOption=function(){if(self.emptyOption){$element.val('');setOptionSelectedStatus(self.emptyOption,true);}};self.unselectEmptyOption=function(){if(self.hasEmptyOption){setOptionSelectedStatus(self.emptyOption,false);}};$scope.$on('$destroy',function(){// disable unknown option so that we don't do work when the whole select is being destroyed
	self.renderUnknownOption=noop;});// Read the value of the select control, the implementation of this changes depending
	// upon whether the select can have multiple values and whether ngOptions is at work.
	self.readValue=function readSingleValue(){var val=$element.val();// ngValue added option values are stored in the selectValueMap, normal interpolations are not
	var realVal=val in self.selectValueMap?self.selectValueMap[val]:val;if(self.hasOption(realVal)){return realVal;}return null;};// Write the value to the select control, the implementation of this changes depending
	// upon whether the select can have multiple values and whether ngOptions is at work.
	self.writeValue=function writeSingleValue(value){// Make sure to remove the selected attribute from the previously selected option
	// Otherwise, screen readers might get confused
	var currentlySelectedOption=$element[0].options[$element[0].selectedIndex];if(currentlySelectedOption)setOptionSelectedStatus(jqLite(currentlySelectedOption),false);if(self.hasOption(value)){self.removeUnknownOption();var hashedVal=hashKey(value);$element.val(hashedVal in self.selectValueMap?hashedVal:value);// Set selected attribute and property on selected option for screen readers
	var selectedOption=$element[0].options[$element[0].selectedIndex];setOptionSelectedStatus(jqLite(selectedOption),true);}else{self.selectUnknownOrEmptyOption(value);}};// Tell the select control that an option, with the given value, has been added
	self.addOption=function(value,element){// Skip comment nodes, as they only pollute the `optionsMap`
	if(element[0].nodeType===NODE_TYPE_COMMENT)return;assertNotHasOwnProperty(value,'"option value"');if(value===''){self.hasEmptyOption=true;self.emptyOption=element;}var count=optionsMap.get(value)||0;optionsMap.set(value,count+1);// Only render at the end of a digest. This improves render performance when many options
	// are added during a digest and ensures all relevant options are correctly marked as selected
	scheduleRender();};// Tell the select control that an option, with the given value, has been removed
	self.removeOption=function(value){var count=optionsMap.get(value);if(count){if(count===1){optionsMap.delete(value);if(value===''){self.hasEmptyOption=false;self.emptyOption=undefined;}}else{optionsMap.set(value,count-1);}}};// Check whether the select control has an option matching the given value
	self.hasOption=function(value){return!!optionsMap.get(value);};/**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */self.$hasEmptyOption=function(){return self.hasEmptyOption;};/**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */self.$isUnknownOptionSelected=function(){// Presence of the unknown option means it is selected
	return $element[0].options[0]===self.unknownOption[0];};/**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */self.$isEmptyOptionSelected=function(){return self.hasEmptyOption&&$element[0].options[$element[0].selectedIndex]===self.emptyOption[0];};self.selectUnknownOrEmptyOption=function(value){if(value==null&&self.emptyOption){self.removeUnknownOption();self.selectEmptyOption();}else if(self.unknownOption.parent().length){self.updateUnknownOption(value);}else{self.renderUnknownOption(value);}};var renderScheduled=false;function scheduleRender(){if(renderScheduled)return;renderScheduled=true;$scope.$$postDigest(function(){renderScheduled=false;self.ngModelCtrl.$render();});}var updateScheduled=false;function scheduleViewValueUpdate(renderAfter){if(updateScheduled)return;updateScheduled=true;$scope.$$postDigest(function(){if($scope.$$destroyed)return;updateScheduled=false;self.ngModelCtrl.$setViewValue(self.readValue());if(renderAfter)self.ngModelCtrl.$render();});}self.registerOption=function(optionScope,optionElement,optionAttrs,interpolateValueFn,interpolateTextFn){if(optionAttrs.$attr.ngValue){// The value attribute is set by ngValue
	var oldVal,hashedVal=NaN;optionAttrs.$observe('value',function valueAttributeObserveAction(newVal){var removal;var previouslySelected=optionElement.prop('selected');if(isDefined(hashedVal)){self.removeOption(oldVal);delete self.selectValueMap[hashedVal];removal=true;}hashedVal=hashKey(newVal);oldVal=newVal;self.selectValueMap[hashedVal]=newVal;self.addOption(newVal,optionElement);// Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	// from firing a second time. Other $observers on value will also get the result of the
	// ngValue expression, not the hashed value
	optionElement.attr('value',hashedVal);if(removal&&previouslySelected){scheduleViewValueUpdate();}});}else if(interpolateValueFn){// The value attribute is interpolated
	optionAttrs.$observe('value',function valueAttributeObserveAction(newVal){// This method is overwritten in ngOptions and has side-effects!
	self.readValue();var removal;var previouslySelected=optionElement.prop('selected');if(isDefined(oldVal)){self.removeOption(oldVal);removal=true;}oldVal=newVal;self.addOption(newVal,optionElement);if(removal&&previouslySelected){scheduleViewValueUpdate();}});}else if(interpolateTextFn){// The text content is interpolated
	optionScope.$watch(interpolateTextFn,function interpolateWatchAction(newVal,oldVal){optionAttrs.$set('value',newVal);var previouslySelected=optionElement.prop('selected');if(oldVal!==newVal){self.removeOption(oldVal);}self.addOption(newVal,optionElement);if(oldVal&&previouslySelected){scheduleViewValueUpdate();}});}else{// The value attribute is static
	self.addOption(optionAttrs.value,optionElement);}optionAttrs.$observe('disabled',function(newVal){// Since model updates will also select disabled options (like ngOptions),
	// we only have to handle options becoming disabled, not enabled
	if(newVal==='true'||newVal&&optionElement.prop('selected')){if(self.multiple){scheduleViewValueUpdate(true);}else{self.ngModelCtrl.$setViewValue(null);self.ngModelCtrl.$render();}}});optionElement.on('$destroy',function(){var currentValue=self.readValue();var removeValue=optionAttrs.value;self.removeOption(removeValue);scheduleRender();if(self.multiple&&currentValue&&currentValue.indexOf(removeValue)!==-1||currentValue===removeValue){// When multiple (selected) options are destroyed at the same time, we don't want
	// to run a model update for each of them. Instead, run a single update in the $$postDigest
	scheduleViewValueUpdate(true);}});};}];/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @knownIssue
	 *
	 * In Firefox, the select model is only updated when the select element is blurred. For example,
	 * when switching between options with the keyboard, the select model is only set to the
	 * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
	 * outside the select.
	 *
	 * This is due to an ambiguity in the select element specification. See the
	 * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
	 * for more information, and this
	 * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */var selectDirective=function selectDirective(){return{restrict:'E',require:['select','?ngModel'],controller:SelectController,priority:1,link:{pre:selectPreLink,post:selectPostLink}};function selectPreLink(scope,element,attr,ctrls){var selectCtrl=ctrls[0];var ngModelCtrl=ctrls[1];// if ngModel is not defined, we don't need to do anything but set the registerOption
	// function to noop, so options don't get added internally
	if(!ngModelCtrl){selectCtrl.registerOption=noop;return;}selectCtrl.ngModelCtrl=ngModelCtrl;// When the selected item(s) changes we delegate getting the value of the select control
	// to the `readValue` method, which can be changed if the select can have multiple
	// selected values or if the options are being generated by `ngOptions`
	element.on('change',function(){selectCtrl.removeUnknownOption();scope.$apply(function(){ngModelCtrl.$setViewValue(selectCtrl.readValue());});});// If the select allows multiple values then we need to modify how we read and write
	// values from and to the control; also what it means for the value to be empty and
	// we have to add an extra watch since ngModel doesn't work well with arrays - it
	// doesn't trigger rendering if only an item in the array changes.
	if(attr.multiple){selectCtrl.multiple=true;// Read value now needs to check each option to see if it is selected
	selectCtrl.readValue=function readMultipleValue(){var array=[];forEach(element.find('option'),function(option){if(option.selected&&!option.disabled){var val=option.value;array.push(val in selectCtrl.selectValueMap?selectCtrl.selectValueMap[val]:val);}});return array;};// Write value now needs to set the selected property of each matching option
	selectCtrl.writeValue=function writeMultipleValue(value){forEach(element.find('option'),function(option){var shouldBeSelected=!!value&&(includes(value,option.value)||includes(value,selectCtrl.selectValueMap[option.value]));var currentlySelected=option.selected;// Support: IE 9-11 only, Edge 12-15+
	// In IE and Edge adding options to the selection via shift+click/UP/DOWN
	// will de-select already selected options if "selected" on those options was set
	// more than once (i.e. when the options were already selected)
	// So we only modify the selected property if necessary.
	// Note: this behavior cannot be replicated via unit tests because it only shows in the
	// actual user interface.
	if(shouldBeSelected!==currentlySelected){setOptionSelectedStatus(jqLite(option),shouldBeSelected);}});};// we have to do it on each watch since ngModel watches reference, but
	// we need to work of an array, so we need to see if anything was inserted/removed
	var lastView,lastViewRef=NaN;scope.$watch(function selectMultipleWatch(){if(lastViewRef===ngModelCtrl.$viewValue&&!equals(lastView,ngModelCtrl.$viewValue)){lastView=shallowCopy(ngModelCtrl.$viewValue);ngModelCtrl.$render();}lastViewRef=ngModelCtrl.$viewValue;});// If we are a multiple select then value is now a collection
	// so the meaning of $isEmpty changes
	ngModelCtrl.$isEmpty=function(value){return!value||value.length===0;};}}function selectPostLink(scope,element,attrs,ctrls){// if ngModel is not defined, we don't need to do anything
	var ngModelCtrl=ctrls[1];if(!ngModelCtrl)return;var selectCtrl=ctrls[0];// We delegate rendering to the `writeValue` method, which can be changed
	// if the select can have multiple selected values or if the options are being
	// generated by `ngOptions`.
	// This must be done in the postLink fn to prevent $render to be called before
	// all nodes have been linked correctly.
	ngModelCtrl.$render=function(){selectCtrl.writeValue(ngModelCtrl.$viewValue);};}};// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective=['$interpolate',function($interpolate){return{restrict:'E',priority:100,compile:function compile(element,attr){var interpolateValueFn,interpolateTextFn;if(isDefined(attr.ngValue)){// Will be handled by registerOption
	}else if(isDefined(attr.value)){// If the value attribute is defined, check if it contains an interpolation
	interpolateValueFn=$interpolate(attr.value,true);}else{// If the value attribute is not defined then we fall back to the
	// text content of the option element, which may be interpolated
	interpolateTextFn=$interpolate(element.text(),true);if(!interpolateTextFn){attr.$set('value',element.text());}}return function(scope,element,attr){// This is an optimization over using ^^ since we don't want to have to search
	// all the way to the root of the DOM for every single option element
	var selectCtrlName='$selectController',parent=element.parent(),selectCtrl=parent.data(selectCtrlName)||parent.parent().data(selectCtrlName);// in case we are in optgroup
	if(selectCtrl){selectCtrl.registerOption(scope,element,attr,interpolateValueFn,interpolateTextFn);}};}};}];/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */var requiredDirective=function requiredDirective(){return{restrict:'A',require:'?ngModel',link:function link(scope,elm,attr,ctrl){if(!ctrl)return;attr.required=true;// force truthy in case we are on non input element
	ctrl.$validators.required=function(modelValue,viewValue){return!attr.required||!ctrl.$isEmpty(viewValue);};attr.$observe('required',function(){ctrl.$validate();});}};};/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */var patternDirective=function patternDirective(){return{restrict:'A',require:'?ngModel',link:function link(scope,elm,attr,ctrl){if(!ctrl)return;var regexp,patternExp=attr.ngPattern||attr.pattern;attr.$observe('pattern',function(regex){if(isString(regex)&&regex.length>0){regex=new RegExp('^'+regex+'$');}if(regex&&!regex.test){throw minErr('ngPattern')('noregexp','Expected {0} to be a RegExp but was {1}. Element: {2}',patternExp,regex,startingTag(elm));}regexp=regex||undefined;ctrl.$validate();});ctrl.$validators.pattern=function(modelValue,viewValue){// HTML5 pattern constraint validates the input value, so we validate the viewValue
	return ctrl.$isEmpty(viewValue)||isUndefined(regexp)||regexp.test(viewValue);};}};};/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */var maxlengthDirective=function maxlengthDirective(){return{restrict:'A',require:'?ngModel',link:function link(scope,elm,attr,ctrl){if(!ctrl)return;var maxlength=-1;attr.$observe('maxlength',function(value){var intVal=toInt(value);maxlength=isNumberNaN(intVal)?-1:intVal;ctrl.$validate();});ctrl.$validators.maxlength=function(modelValue,viewValue){return maxlength<0||ctrl.$isEmpty(viewValue)||viewValue.length<=maxlength;};}};};/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */var minlengthDirective=function minlengthDirective(){return{restrict:'A',require:'?ngModel',link:function link(scope,elm,attr,ctrl){if(!ctrl)return;var minlength=0;attr.$observe('minlength',function(value){minlength=toInt(value)||0;ctrl.$validate();});ctrl.$validators.minlength=function(modelValue,viewValue){return ctrl.$isEmpty(viewValue)||viewValue.length>=minlength;};}};};if(window.angular.bootstrap){// AngularJS is already loaded, so we can return here...
	if(window.console){console.log('WARNING: Tried to load AngularJS more than once.');}return;}// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();publishExternalAPI(angular);angular.module("ngLocale",[],["$provide",function($provide){var PLURAL_CATEGORY={ZERO:"zero",ONE:"one",TWO:"two",FEW:"few",MANY:"many",OTHER:"other"};function getDecimals(n){n=n+'';var i=n.indexOf('.');return i==-1?0:n.length-i-1;}function getVF(n,opt_precision){var v=opt_precision;if(undefined===v){v=Math.min(getDecimals(n),3);}var base=Math.pow(10,v);var f=(n*base|0)%base;return{v:v,f:f};}$provide.value("$locale",{"DATETIME_FORMATS":{"AMPMS":["AM","PM"],"DAY":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"ERANAMES":["Before Christ","Anno Domini"],"ERAS":["BC","AD"],"FIRSTDAYOFWEEK":6,"MONTH":["January","February","March","April","May","June","July","August","September","October","November","December"],"SHORTDAY":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"SHORTMONTH":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"STANDALONEMONTH":["January","February","March","April","May","June","July","August","September","October","November","December"],"WEEKENDRANGE":[5,6],"fullDate":"EEEE, MMMM d, y","longDate":"MMMM d, y","medium":"MMM d, y h:mm:ss a","mediumDate":"MMM d, y","mediumTime":"h:mm:ss a","short":"M/d/yy h:mm a","shortDate":"M/d/yy","shortTime":"h:mm a"},"NUMBER_FORMATS":{"CURRENCY_SYM":"$","DECIMAL_SEP":".","GROUP_SEP":",","PATTERNS":[{"gSize":3,"lgSize":3,"maxFrac":3,"minFrac":0,"minInt":1,"negPre":"-","negSuf":"","posPre":"","posSuf":""},{"gSize":3,"lgSize":3,"maxFrac":2,"minFrac":2,"minInt":1,"negPre":'-\xA4',"negSuf":"","posPre":'\xA4',"posSuf":""}]},"id":"en-us","localeID":"en_US","pluralCat":function pluralCat(n,opt_precision){var i=n|0;var vf=getVF(n,opt_precision);if(i==1&&vf.v==0){return PLURAL_CATEGORY.ONE;}return PLURAL_CATEGORY.OTHER;}});}]);jqLite(function(){angularInit(window.document,bootstrap);});})(window);!window.angular.$$csp().noInlineStyle&&window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	;(function (exports) {
		'use strict';
	
		var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	
		var PLUS = '+'.charCodeAt(0);
		var SLASH = '/'.charCodeAt(0);
		var NUMBER = '0'.charCodeAt(0);
		var LOWER = 'a'.charCodeAt(0);
		var UPPER = 'A'.charCodeAt(0);
		var PLUS_URL_SAFE = '-'.charCodeAt(0);
		var SLASH_URL_SAFE = '_'.charCodeAt(0);
	
		function decode(elt) {
			var code = elt.charCodeAt(0);
			if (code === PLUS || code === PLUS_URL_SAFE) return 62; // '+'
			if (code === SLASH || code === SLASH_URL_SAFE) return 63; // '/'
			if (code < NUMBER) return -1; //no match
			if (code < NUMBER + 10) return code - NUMBER + 26 + 26;
			if (code < UPPER + 26) return code - UPPER;
			if (code < LOWER + 26) return code - LOWER + 26;
		}
	
		function b64ToByteArray(b64) {
			var i, j, l, tmp, placeHolders, arr;
	
			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4');
			}
	
			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length;
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0;
	
			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders);
	
			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length;
	
			var L = 0;
	
			function push(v) {
				arr[L++] = v;
			}
	
			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = decode(b64.charAt(i)) << 18 | decode(b64.charAt(i + 1)) << 12 | decode(b64.charAt(i + 2)) << 6 | decode(b64.charAt(i + 3));
				push((tmp & 0xFF0000) >> 16);
				push((tmp & 0xFF00) >> 8);
				push(tmp & 0xFF);
			}
	
			if (placeHolders === 2) {
				tmp = decode(b64.charAt(i)) << 2 | decode(b64.charAt(i + 1)) >> 4;
				push(tmp & 0xFF);
			} else if (placeHolders === 1) {
				tmp = decode(b64.charAt(i)) << 10 | decode(b64.charAt(i + 1)) << 4 | decode(b64.charAt(i + 2)) >> 2;
				push(tmp >> 8 & 0xFF);
				push(tmp & 0xFF);
			}
	
			return arr;
		}
	
		function uint8ToBase64(uint8) {
			var i,
			    extraBytes = uint8.length % 3,
			    // if we have 1 byte left, pad 2 bytes
			output = "",
			    temp,
			    length;
	
			function encode(num) {
				return lookup.charAt(num);
			}
	
			function tripletToBase64(num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F);
			}
	
			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
				output += tripletToBase64(temp);
			}
	
			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1];
					output += encode(temp >> 2);
					output += encode(temp << 4 & 0x3F);
					output += '==';
					break;
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + uint8[uint8.length - 1];
					output += encode(temp >> 10);
					output += encode(temp >> 4 & 0x3F);
					output += encode(temp << 2 & 0x3F);
					output += '=';
					break;
			}
	
			return output;
		}
	
		exports.toByteArray = b64ToByteArray;
		exports.fromByteArray = uint8ToBase64;
	})( false ? undefined.base64js = {} : exports);

/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery');
	}
	
	+function ($) {
	  'use strict';
	
	  var version = $.fn.jquery.split(' ')[0].split('.');
	  if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1 || version[0] > 3) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4');
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap');
	
	    var transEndEventNames = {
	      WebkitTransition: 'webkitTransitionEnd',
	      MozTransition: 'transitionend',
	      OTransition: 'oTransitionEnd otransitionend',
	      transition: 'transitionend'
	    };
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] };
	      }
	    }
	
	    return false; // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false;
	    var $el = this;
	    $(this).one('bsTransitionEnd', function () {
	      called = true;
	    });
	    var callback = function callback() {
	      if (!called) $($el).trigger($.support.transition.end);
	    };
	    setTimeout(callback, duration);
	    return this;
	  };
	
	  $(function () {
	    $.support.transition = transitionEnd();
	
	    if (!$.support.transition) return;
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function handle(e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
	      }
	    };
	  });
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]';
	  var Alert = function Alert(el) {
	    $(el).on('click', dismiss, this.close);
	  };
	
	  Alert.VERSION = '3.3.7';
	
	  Alert.TRANSITION_DURATION = 150;
	
	  Alert.prototype.close = function (e) {
	    var $this = $(this);
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector);
	
	    if (e) e.preventDefault();
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert');
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'));
	
	    if (e.isDefaultPrevented()) return;
	
	    $parent.removeClass('in');
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove();
	    }
	
	    $.support.transition && $parent.hasClass('fade') ? $parent.one('bsTransitionEnd', removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement();
	  };
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.alert');
	
	      if (!data) $this.data('bs.alert', data = new Alert(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.alert;
	
	  $.fn.alert = Plugin;
	  $.fn.alert.Constructor = Alert;
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old;
	    return this;
	  };
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close);
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function Button(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Button.DEFAULTS, options);
	    this.isLoading = false;
	  };
	
	  Button.VERSION = '3.3.7';
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  };
	
	  Button.prototype.setState = function (state) {
	    var d = 'disabled';
	    var $el = this.$element;
	    var val = $el.is('input') ? 'val' : 'html';
	    var data = $el.data();
	
	    state += 'Text';
	
	    if (data.resetText == null) $el.data('resetText', $el[val]());
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state]);
	
	      if (state == 'loadingText') {
	        this.isLoading = true;
	        $el.addClass(d).attr(d, d).prop(d, true);
	      } else if (this.isLoading) {
	        this.isLoading = false;
	        $el.removeClass(d).removeAttr(d).prop(d, false);
	      }
	    }, this), 0);
	  };
	
	  Button.prototype.toggle = function () {
	    var changed = true;
	    var $parent = this.$element.closest('[data-toggle="buttons"]');
	
	    if ($parent.length) {
	      var $input = this.$element.find('input');
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false;
	        $parent.find('.active').removeClass('active');
	        this.$element.addClass('active');
	      } else if ($input.prop('type') == 'checkbox') {
	        if ($input.prop('checked') !== this.$element.hasClass('active')) changed = false;
	        this.$element.toggleClass('active');
	      }
	      $input.prop('checked', this.$element.hasClass('active'));
	      if (changed) $input.trigger('change');
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'));
	      this.$element.toggleClass('active');
	    }
	  };
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.button');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.button', data = new Button(this, options));
	
	      if (option == 'toggle') data.toggle();else if (option) data.setState(option);
	    });
	  }
	
	  var old = $.fn.button;
	
	  $.fn.button = Plugin;
	  $.fn.button.Constructor = Button;
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old;
	    return this;
	  };
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    var $btn = $(e.target).closest('.btn');
	    Plugin.call($btn, 'toggle');
	    if (!$(e.target).is('input[type="radio"], input[type="checkbox"]')) {
	      // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	      e.preventDefault();
	      // The target component still receive the focus
	      if ($btn.is('input,button')) $btn.trigger('focus');else $btn.find('input:visible,button:visible').first().trigger('focus');
	    }
	  }).on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type));
	  });
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function Carousel(element, options) {
	    this.$element = $(element);
	    this.$indicators = this.$element.find('.carousel-indicators');
	    this.options = options;
	    this.paused = null;
	    this.sliding = null;
	    this.interval = null;
	    this.$active = null;
	    this.$items = null;
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this));
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element.on('mouseenter.bs.carousel', $.proxy(this.pause, this)).on('mouseleave.bs.carousel', $.proxy(this.cycle, this));
	  };
	
	  Carousel.VERSION = '3.3.7';
	
	  Carousel.TRANSITION_DURATION = 600;
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  };
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return;
	    switch (e.which) {
	      case 37:
	        this.prev();break;
	      case 39:
	        this.next();break;
	      default:
	        return;
	    }
	
	    e.preventDefault();
	  };
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false);
	
	    this.interval && clearInterval(this.interval);
	
	    this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));
	
	    return this;
	  };
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item');
	    return this.$items.index(item || this.$active);
	  };
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active);
	    var willWrap = direction == 'prev' && activeIndex === 0 || direction == 'next' && activeIndex == this.$items.length - 1;
	    if (willWrap && !this.options.wrap) return active;
	    var delta = direction == 'prev' ? -1 : 1;
	    var itemIndex = (activeIndex + delta) % this.$items.length;
	    return this.$items.eq(itemIndex);
	  };
	
	  Carousel.prototype.to = function (pos) {
	    var that = this;
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'));
	
	    if (pos > this.$items.length - 1 || pos < 0) return;
	
	    if (this.sliding) return this.$element.one('slid.bs.carousel', function () {
	      that.to(pos);
	    }); // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle();
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos));
	  };
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true);
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end);
	      this.cycle(true);
	    }
	
	    this.interval = clearInterval(this.interval);
	
	    return this;
	  };
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return;
	    return this.slide('next');
	  };
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return;
	    return this.slide('prev');
	  };
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active = this.$element.find('.item.active');
	    var $next = next || this.getItemForDirection(type, $active);
	    var isCycling = this.interval;
	    var direction = type == 'next' ? 'left' : 'right';
	    var that = this;
	
	    if ($next.hasClass('active')) return this.sliding = false;
	
	    var relatedTarget = $next[0];
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    });
	    this.$element.trigger(slideEvent);
	    if (slideEvent.isDefaultPrevented()) return;
	
	    this.sliding = true;
	
	    isCycling && this.pause();
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active');
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
	      $nextIndicator && $nextIndicator.addClass('active');
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }); // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type);
	      $next[0].offsetWidth; // force reflow
	      $active.addClass(direction);
	      $next.addClass(direction);
	      $active.one('bsTransitionEnd', function () {
	        $next.removeClass([type, direction].join(' ')).addClass('active');
	        $active.removeClass(['active', direction].join(' '));
	        that.sliding = false;
	        setTimeout(function () {
	          that.$element.trigger(slidEvent);
	        }, 0);
	      }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
	    } else {
	      $active.removeClass('active');
	      $next.addClass('active');
	      this.sliding = false;
	      this.$element.trigger(slidEvent);
	    }
	
	    isCycling && this.cycle();
	
	    return this;
	  };
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.carousel');
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	      var action = typeof option == 'string' ? option : options.slide;
	
	      if (!data) $this.data('bs.carousel', data = new Carousel(this, options));
	      if (typeof option == 'number') data.to(option);else if (action) data[action]();else if (options.interval) data.pause().cycle();
	    });
	  }
	
	  var old = $.fn.carousel;
	
	  $.fn.carousel = Plugin;
	  $.fn.carousel.Constructor = Carousel;
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old;
	    return this;
	  };
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function clickHandler(e) {
	    var href;
	    var $this = $(this);
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')); // strip for ie7
	    if (!$target.hasClass('carousel')) return;
	    var options = $.extend({}, $target.data(), $this.data());
	    var slideIndex = $this.attr('data-slide-to');
	    if (slideIndex) options.interval = false;
	
	    Plugin.call($target, options);
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex);
	    }
	
	    e.preventDefault();
	  };
	
	  $(document).on('click.bs.carousel.data-api', '[data-slide]', clickHandler).on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler);
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this);
	      Plugin.call($carousel, $carousel.data());
	    });
	  });
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function Collapse(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Collapse.DEFAULTS, options);
	    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
	    this.transitioning = null;
	
	    if (this.options.parent) {
	      this.$parent = this.getParent();
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
	    }
	
	    if (this.options.toggle) this.toggle();
	  };
	
	  Collapse.VERSION = '3.3.7';
	
	  Collapse.TRANSITION_DURATION = 350;
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  };
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width');
	    return hasWidth ? 'width' : 'height';
	  };
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return;
	
	    var activesData;
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse');
	      if (activesData && activesData.transitioning) return;
	    }
	
	    var startEvent = $.Event('show.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide');
	      activesData || actives.data('bs.collapse', null);
	    }
	
	    var dimension = this.dimension();
	
	    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);
	
	    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
	      this.transitioning = 0;
	      this.$element.trigger('shown.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'));
	
	    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
	  };
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return;
	
	    var startEvent = $.Event('hide.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    var dimension = this.dimension();
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
	
	    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);
	
	    this.$trigger.addClass('collapsed').attr('aria-expanded', false);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.transitioning = 0;
	      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
	  };
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']();
	  };
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
	      var $element = $(element);
	      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
	    }, this)).end();
	  };
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in');
	
	    $element.attr('aria-expanded', isOpen);
	    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
	  };
	
	  function getTargetFromTrigger($trigger) {
	    var href;
	    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7
	
	    return $(target);
	  }
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.collapse');
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
	      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.collapse;
	
	  $.fn.collapse = Plugin;
	  $.fn.collapse.Constructor = Collapse;
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old;
	    return this;
	  };
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this = $(this);
	
	    if (!$this.attr('data-target')) e.preventDefault();
	
	    var $target = getTargetFromTrigger($this);
	    var data = $target.data('bs.collapse');
	    var option = data ? 'toggle' : $this.data();
	
	    Plugin.call($target, option);
	  });
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop';
	  var toggle = '[data-toggle="dropdown"]';
	  var Dropdown = function Dropdown(element) {
	    $(element).on('click.bs.dropdown', this.toggle);
	  };
	
	  Dropdown.VERSION = '3.3.7';
	
	  function getParent($this) {
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    var $parent = selector && $(selector);
	
	    return $parent && $parent.length ? $parent : $this.parent();
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return;
	    $(backdrop).remove();
	    $(toggle).each(function () {
	      var $this = $(this);
	      var $parent = getParent($this);
	      var relatedTarget = { relatedTarget: this };
	
	      if (!$parent.hasClass('open')) return;
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return;
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.attr('aria-expanded', 'false');
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
	    });
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this);
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    clearMenus();
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div')).addClass('dropdown-backdrop').insertAfter($(this)).on('click', clearMenus);
	      }
	
	      var relatedTarget = { relatedTarget: this };
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.trigger('focus').attr('aria-expanded', 'true');
	
	      $parent.toggleClass('open').trigger($.Event('shown.bs.dropdown', relatedTarget));
	    }
	
	    return false;
	  };
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
	
	    var $this = $(this);
	
	    e.preventDefault();
	    e.stopPropagation();
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus');
	      return $this.trigger('click');
	    }
	
	    var desc = ' li:not(.disabled):visible a';
	    var $items = $parent.find('.dropdown-menu' + desc);
	
	    if (!$items.length) return;
	
	    var index = $items.index(e.target);
	
	    if (e.which == 38 && index > 0) index--; // up
	    if (e.which == 40 && index < $items.length - 1) index++; // down
	    if (!~index) index = 0;
	
	    $items.eq(index).trigger('focus');
	  };
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.dropdown');
	
	      if (!data) $this.data('bs.dropdown', data = new Dropdown(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.dropdown;
	
	  $.fn.dropdown = Plugin;
	  $.fn.dropdown.Constructor = Dropdown;
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old;
	    return this;
	  };
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
	    e.stopPropagation();
	  }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown).on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown);
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function Modal(element, options) {
	    this.options = options;
	    this.$body = $(document.body);
	    this.$element = $(element);
	    this.$dialog = this.$element.find('.modal-dialog');
	    this.$backdrop = null;
	    this.isShown = null;
	    this.originalBodyPad = null;
	    this.scrollbarWidth = 0;
	    this.ignoreBackdropClick = false;
	
	    if (this.options.remote) {
	      this.$element.find('.modal-content').load(this.options.remote, $.proxy(function () {
	        this.$element.trigger('loaded.bs.modal');
	      }, this));
	    }
	  };
	
	  Modal.VERSION = '3.3.7';
	
	  Modal.TRANSITION_DURATION = 300;
	  Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  };
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget);
	  };
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this;
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });
	
	    this.$element.trigger(e);
	
	    if (this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = true;
	
	    this.checkScrollbar();
	    this.setScrollbar();
	    this.$body.addClass('modal-open');
	
	    this.escape();
	    this.resize();
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
	      });
	    });
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade');
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body); // don't move modals dom position
	      }
	
	      that.$element.show().scrollTop(0);
	
	      that.adjustDialog();
	
	      if (transition) {
	        that.$element[0].offsetWidth; // force reflow
	      }
	
	      that.$element.addClass('in');
	
	      that.enforceFocus();
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });
	
	      transition ? that.$dialog // wait for modal to slide in
	      .one('bsTransitionEnd', function () {
	        that.$element.trigger('focus').trigger(e);
	      }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger('focus').trigger(e);
	    });
	  };
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault();
	
	    e = $.Event('hide.bs.modal');
	
	    this.$element.trigger(e);
	
	    if (!this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = false;
	
	    this.escape();
	    this.resize();
	
	    $(document).off('focusin.bs.modal');
	
	    this.$element.removeClass('in').off('click.dismiss.bs.modal').off('mouseup.dismiss.bs.modal');
	
	    this.$dialog.off('mousedown.dismiss.bs.modal');
	
	    $.support.transition && this.$element.hasClass('fade') ? this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
	  };
	
	  Modal.prototype.enforceFocus = function () {
	    $(document).off('focusin.bs.modal') // guard against infinite focus loop
	    .on('focusin.bs.modal', $.proxy(function (e) {
	      if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
	        this.$element.trigger('focus');
	      }
	    }, this));
	  };
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide();
	      }, this));
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal');
	    }
	  };
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
	    } else {
	      $(window).off('resize.bs.modal');
	    }
	  };
	
	  Modal.prototype.hideModal = function () {
	    var that = this;
	    this.$element.hide();
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open');
	      that.resetAdjustments();
	      that.resetScrollbar();
	      that.$element.trigger('hidden.bs.modal');
	    });
	  };
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove();
	    this.$backdrop = null;
	  };
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this;
	    var animate = this.$element.hasClass('fade') ? 'fade' : '';
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate;
	
	      this.$backdrop = $(document.createElement('div')).addClass('modal-backdrop ' + animate).appendTo(this.$body);
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false;
	          return;
	        }
	        if (e.target !== e.currentTarget) return;
	        this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide();
	      }, this));
	
	      if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow
	
	      this.$backdrop.addClass('in');
	
	      if (!callback) return;
	
	      doAnimate ? this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in');
	
	      var callbackRemove = function callbackRemove() {
	        that.removeBackdrop();
	        callback && callback();
	      };
	      $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one('bsTransitionEnd', callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
	    } else if (callback) {
	      callback();
	    }
	  };
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog();
	  };
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    });
	  };
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    });
	  };
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth;
	    if (!fullWindowWidth) {
	      // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect();
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
	    this.scrollbarWidth = this.measureScrollbar();
	  };
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
	    this.originalBodyPad = document.body.style.paddingRight || '';
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
	  };
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad);
	  };
	
	  Modal.prototype.measureScrollbar = function () {
	    // thx walsh
	    var scrollDiv = document.createElement('div');
	    scrollDiv.className = 'modal-scrollbar-measure';
	    this.$body.append(scrollDiv);
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	    this.$body[0].removeChild(scrollDiv);
	    return scrollbarWidth;
	  };
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.modal');
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	
	      if (!data) $this.data('bs.modal', data = new Modal(this, options));
	      if (typeof option == 'string') data[option](_relatedTarget);else if (options.show) data.show(_relatedTarget);
	    });
	  }
	
	  var old = $.fn.modal;
	
	  $.fn.modal = Plugin;
	  $.fn.modal.Constructor = Modal;
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old;
	    return this;
	  };
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this);
	    var href = $this.attr('href');
	    var $target = $($this.attr('data-target') || href && href.replace(/.*(?=#[^\s]+$)/, '')); // strip for ie7
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());
	
	    if ($this.is('a')) e.preventDefault();
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return; // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus');
	      });
	    });
	    Plugin.call($target, option, this);
	  });
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function Tooltip(element, options) {
	    this.type = null;
	    this.options = null;
	    this.enabled = null;
	    this.timeout = null;
	    this.hoverState = null;
	    this.$element = null;
	    this.inState = null;
	
	    this.init('tooltip', element, options);
	  };
	
	  Tooltip.VERSION = '3.3.7';
	
	  Tooltip.TRANSITION_DURATION = 150;
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  };
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled = true;
	    this.type = type;
	    this.$element = $(element);
	    this.options = this.getOptions(options);
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
	    this.inState = { click: false, hover: false, focus: false };
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
	    }
	
	    var triggers = this.options.trigger.split(' ');
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i];
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
	      } else if (trigger != 'manual') {
	        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';
	
	        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
	      }
	    }
	
	    this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
	  };
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS;
	  };
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options);
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      };
	    }
	
	    return options;
	  };
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options = {};
	    var defaults = this.getDefaults();
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value;
	    });
	
	    return options;
	  };
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true;
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in';
	      return;
	    }
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'in';
	
	    if (!self.options.delay || !self.options.delay.show) return self.show();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show();
	    }, self.options.delay.show);
	  };
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true;
	    }
	
	    return false;
	  };
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false;
	    }
	
	    if (self.isInStateTrue()) return;
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'out';
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide();
	    }, self.options.delay.hide);
	  };
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type);
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e);
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
	      if (e.isDefaultPrevented() || !inDom) return;
	      var that = this;
	
	      var $tip = this.tip();
	
	      var tipId = this.getUID(this.type);
	
	      this.setContent();
	      $tip.attr('id', tipId);
	      this.$element.attr('aria-describedby', tipId);
	
	      if (this.options.animation) $tip.addClass('fade');
	
	      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
	
	      var autoToken = /\s?auto?\s?/i;
	      var autoPlace = autoToken.test(placement);
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';
	
	      $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement).data('bs.' + this.type, this);
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
	      this.$element.trigger('inserted.bs.' + this.type);
	
	      var pos = this.getPosition();
	      var actualWidth = $tip[0].offsetWidth;
	      var actualHeight = $tip[0].offsetHeight;
	
	      if (autoPlace) {
	        var orgPlacement = placement;
	        var viewportDim = this.getPosition(this.$viewport);
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < viewportDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > viewportDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < viewportDim.left ? 'right' : placement;
	
	        $tip.removeClass(orgPlacement).addClass(placement);
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
	
	      this.applyPlacement(calculatedOffset, placement);
	
	      var complete = function complete() {
	        var prevHoverState = that.hoverState;
	        that.$element.trigger('shown.bs.' + that.type);
	        that.hoverState = null;
	
	        if (prevHoverState == 'out') that.leave(that);
	      };
	
	      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	    }
	  };
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip = this.tip();
	    var width = $tip[0].offsetWidth;
	    var height = $tip[0].offsetHeight;
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10);
	    var marginLeft = parseInt($tip.css('margin-left'), 10);
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop)) marginTop = 0;
	    if (isNaN(marginLeft)) marginLeft = 0;
	
	    offset.top += marginTop;
	    offset.left += marginLeft;
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function using(props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        });
	      }
	    }, offset), 0);
	
	    $tip.addClass('in');
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth = $tip[0].offsetWidth;
	    var actualHeight = $tip[0].offsetHeight;
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight;
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
	
	    if (delta.left) offset.left += delta.left;else offset.top += delta.top;
	
	    var isVertical = /top|bottom/.test(placement);
	    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
	
	    $tip.offset(offset);
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
	  };
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
	  };
	
	  Tooltip.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
	    $tip.removeClass('fade in top bottom left right');
	  };
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this;
	    var $tip = $(this.$tip);
	    var e = $.Event('hide.bs.' + this.type);
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach();
	      if (that.$element) {
	        // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
	      }
	      callback && callback();
	    }
	
	    this.$element.trigger(e);
	
	    if (e.isDefaultPrevented()) return;
	
	    $tip.removeClass('in');
	
	    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	
	    this.hoverState = null;
	
	    return this;
	  };
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element;
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
	    }
	  };
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle();
	  };
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element = $element || this.$element;
	
	    var el = $element[0];
	    var isBody = el.tagName == 'BODY';
	
	    var elRect = el.getBoundingClientRect();
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement;
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset = isBody ? { top: 0, left: 0 } : isSvg ? null : $element.offset();
	    var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset);
	  };
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	    /* placement == 'right' */{ top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
	  };
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 };
	    if (!this.$viewport) return delta;
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
	    var viewportDimensions = this.getPosition(this.$viewport);
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
	      if (topEdgeOffset < viewportDimensions.top) {
	        // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset;
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
	        // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
	      }
	    } else {
	      var leftEdgeOffset = pos.left - viewportPadding;
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
	      if (leftEdgeOffset < viewportDimensions.left) {
	        // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset;
	      } else if (rightEdgeOffset > viewportDimensions.right) {
	        // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
	      }
	    }
	
	    return delta;
	  };
	
	  Tooltip.prototype.getTitle = function () {
	    var title;
	    var $e = this.$element;
	    var o = this.options;
	
	    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);
	
	    return title;
	  };
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * 1000000);
	    } while (document.getElementById(prefix));
	    return prefix;
	  };
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template);
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!');
	      }
	    }
	    return this.$tip;
	  };
	
	  Tooltip.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
	  };
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true;
	  };
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false;
	  };
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled;
	  };
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this;
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type);
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
	        $(e.currentTarget).data('bs.' + this.type, self);
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click;
	      if (self.isInStateTrue()) self.enter(self);else self.leave(self);
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
	    }
	  };
	
	  Tooltip.prototype.destroy = function () {
	    var that = this;
	    clearTimeout(this.timeout);
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type);
	      if (that.$tip) {
	        that.$tip.detach();
	      }
	      that.$tip = null;
	      that.$arrow = null;
	      that.$viewport = null;
	      that.$element = null;
	    });
	  };
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tooltip');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tooltip;
	
	  $.fn.tooltip = Plugin;
	  $.fn.tooltip.Constructor = Tooltip;
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old;
	    return this;
	  };
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function Popover(element, options) {
	    this.init('popover', element, options);
	  };
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');
	
	  Popover.VERSION = '3.3.7';
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  });
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);
	
	  Popover.prototype.constructor = Popover;
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS;
	  };
	
	  Popover.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	    var content = this.getContent();
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
	    $tip.find('.popover-content').children().detach().end()[// we use append for html objects to maintain js events
	    this.options.html ? typeof content == 'string' ? 'html' : 'append' : 'text'](content);
	
	    $tip.removeClass('fade top bottom left right in');
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
	  };
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent();
	  };
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element;
	    var o = this.options;
	
	    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
	  };
	
	  Popover.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.arrow');
	  };
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.popover');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.popover', data = new Popover(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.popover;
	
	  $.fn.popover = Plugin;
	  $.fn.popover.Constructor = Popover;
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old;
	    return this;
	  };
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body = $(document.body);
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element);
	    this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
	    this.selector = (this.options.target || '') + ' .nav li > a';
	    this.offsets = [];
	    this.targets = [];
	    this.activeTarget = null;
	    this.scrollHeight = 0;
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this));
	    this.refresh();
	    this.process();
	  }
	
	  ScrollSpy.VERSION = '3.3.7';
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  };
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
	  };
	
	  ScrollSpy.prototype.refresh = function () {
	    var that = this;
	    var offsetMethod = 'offset';
	    var offsetBase = 0;
	
	    this.offsets = [];
	    this.targets = [];
	    this.scrollHeight = this.getScrollHeight();
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position';
	      offsetBase = this.$scrollElement.scrollTop();
	    }
	
	    this.$body.find(this.selector).map(function () {
	      var $el = $(this);
	      var href = $el.data('target') || $el.attr('href');
	      var $href = /^#./.test(href) && $(href);
	
	      return $href && $href.length && $href.is(':visible') && [[$href[offsetMethod]().top + offsetBase, href]] || null;
	    }).sort(function (a, b) {
	      return a[0] - b[0];
	    }).each(function () {
	      that.offsets.push(this[0]);
	      that.targets.push(this[1]);
	    });
	  };
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
	    var scrollHeight = this.getScrollHeight();
	    var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
	    var offsets = this.offsets;
	    var targets = this.targets;
	    var activeTarget = this.activeTarget;
	    var i;
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh();
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null;
	      return this.clear();
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
	    }
	  };
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target;
	
	    this.clear();
	
	    var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
	
	    var active = $(selector).parents('li').addClass('active');
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active.closest('li.dropdown').addClass('active');
	    }
	
	    active.trigger('activate.bs.scrollspy');
	  };
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector).parentsUntil(this.options.target, '.active').removeClass('active');
	  };
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.scrollspy');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.scrollspy', data = new ScrollSpy(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.scrollspy;
	
	  $.fn.scrollspy = Plugin;
	  $.fn.scrollspy.Constructor = ScrollSpy;
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old;
	    return this;
	  };
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this);
	      Plugin.call($spy, $spy.data());
	    });
	  });
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function Tab(element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element);
	    // jscs:enable requireDollarBeforejQueryAssignment
	  };
	
	  Tab.VERSION = '3.3.7';
	
	  Tab.TRANSITION_DURATION = 150;
	
	  Tab.prototype.show = function () {
	    var $this = this.element;
	    var $ul = $this.closest('ul:not(.dropdown-menu)');
	    var selector = $this.data('target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return;
	
	    var $previous = $ul.find('.active:last a');
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    });
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    });
	
	    $previous.trigger(hideEvent);
	    $this.trigger(showEvent);
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
	
	    var $target = $(selector);
	
	    this.activate($this.closest('li'), $ul);
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      });
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      });
	    });
	  };
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active = container.find('> .active');
	    var transition = callback && $.support.transition && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length);
	
	    function next() {
	      $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', false);
	
	      element.addClass('active').find('[data-toggle="tab"]').attr('aria-expanded', true);
	
	      if (transition) {
	        element[0].offsetWidth; // reflow for transition
	        element.addClass('in');
	      } else {
	        element.removeClass('fade');
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element.closest('li.dropdown').addClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', true);
	      }
	
	      callback && callback();
	    }
	
	    $active.length && transition ? $active.one('bsTransitionEnd', next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
	
	    $active.removeClass('in');
	  };
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tab');
	
	      if (!data) $this.data('bs.tab', data = new Tab(this));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tab;
	
	  $.fn.tab = Plugin;
	  $.fn.tab.Constructor = Tab;
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old;
	    return this;
	  };
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function clickHandler(e) {
	    e.preventDefault();
	    Plugin.call($(this), 'show');
	  };
	
	  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler).on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler);
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function Affix(element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options);
	
	    this.$target = $(this.options.target).on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this)).on('click.bs.affix.data-api', $.proxy(this.checkPositionWithEventLoop, this));
	
	    this.$element = $(element);
	    this.affixed = null;
	    this.unpin = null;
	    this.pinnedOffset = null;
	
	    this.checkPosition();
	  };
	
	  Affix.VERSION = '3.3.7';
	
	  Affix.RESET = 'affix affix-top affix-bottom';
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  };
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    var targetHeight = this.$target.height();
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false;
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return scrollTop + this.unpin <= position.top ? false : 'bottom';
	      return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : 'bottom';
	    }
	
	    var initializing = this.affixed == null;
	    var colliderTop = initializing ? scrollTop : position.top;
	    var colliderHeight = initializing ? targetHeight : height;
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top';
	    if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return 'bottom';
	
	    return false;
	  };
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset;
	    this.$element.removeClass(Affix.RESET).addClass('affix');
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    return this.pinnedOffset = position.top - scrollTop;
	  };
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1);
	  };
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return;
	
	    var height = this.$element.height();
	    var offset = this.options.offset;
	    var offsetTop = offset.top;
	    var offsetBottom = offset.bottom;
	    var scrollHeight = Math.max($(document).height(), $(document.body).height());
	
	    if ((typeof offset === 'undefined' ? 'undefined' : _typeof(offset)) != 'object') offsetBottom = offsetTop = offset;
	    if (typeof offsetTop == 'function') offsetTop = offset.top(this.$element);
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element);
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '');
	
	      var affixType = 'affix' + (affix ? '-' + affix : '');
	      var e = $.Event(affixType + '.bs.affix');
	
	      this.$element.trigger(e);
	
	      if (e.isDefaultPrevented()) return;
	
	      this.affixed = affix;
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null;
	
	      this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace('affix', 'affixed') + '.bs.affix');
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      });
	    }
	  };
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.affix');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.affix', data = new Affix(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.affix;
	
	  $.fn.affix = Plugin;
	  $.fn.affix.Constructor = Affix;
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old;
	    return this;
	  };
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this);
	      var data = $spy.data();
	
	      data.offset = data.offset || {};
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom;
	      if (data.offsetTop != null) data.offset.top = data.offsetTop;
	
	      Plugin.call($spy, data);
	    });
	  });
	}(jQuery);

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var defaults = {
	    pairs: "()[]{}''\"\"",
	    triples: "",
	    explode: "[]{}"
	  };
	
	  var Pos = CodeMirror.Pos;
	
	  CodeMirror.defineOption("autoCloseBrackets", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.removeKeyMap(keyMap);
	      cm.state.closeBrackets = null;
	    }
	    if (val) {
	      ensureBound(getOption(val, "pairs"));
	      cm.state.closeBrackets = val;
	      cm.addKeyMap(keyMap);
	    }
	  });
	
	  function getOption(conf, name) {
	    if (name == "pairs" && typeof conf == "string") return conf;
	    if ((typeof conf === "undefined" ? "undefined" : _typeof(conf)) == "object" && conf[name] != null) return conf[name];
	    return defaults[name];
	  }
	
	  var keyMap = { Backspace: handleBackspace, Enter: handleEnter };
	  function ensureBound(chars) {
	    for (var i = 0; i < chars.length; i++) {
	      var ch = chars.charAt(i),
	          key = "'" + ch + "'";
	      if (!keyMap[key]) keyMap[key] = handler(ch);
	    }
	  }
	  ensureBound(defaults.pairs + "`");
	
	  function handler(ch) {
	    return function (cm) {
	      return handleChar(cm, ch);
	    };
	  }
	
	  function getConfig(cm) {
	    var deflt = cm.state.closeBrackets;
	    if (!deflt || deflt.override) return deflt;
	    var mode = cm.getModeAt(cm.getCursor());
	    return mode.closeBrackets || deflt;
	  }
	
	  function handleBackspace(cm) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || pairs.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var cur = ranges[i].head;
	      cm.replaceRange("", Pos(cur.line, cur.ch - 1), Pos(cur.line, cur.ch + 1), "+delete");
	    }
	  }
	
	  function handleEnter(cm) {
	    var conf = getConfig(cm);
	    var explode = conf && getOption(conf, "explode");
	    if (!explode || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || explode.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    cm.operation(function () {
	      var linesep = cm.lineSeparator() || "\n";
	      cm.replaceSelection(linesep + linesep, null);
	      cm.execCommand("goCharLeft");
	      ranges = cm.listSelections();
	      for (var i = 0; i < ranges.length; i++) {
	        var line = ranges[i].head.line;
	        cm.indentLine(line, null, true);
	        cm.indentLine(line + 1, null, true);
	      }
	    });
	  }
	
	  function contractSelection(sel) {
	    var inverted = CodeMirror.cmpPos(sel.anchor, sel.head) > 0;
	    return { anchor: new Pos(sel.anchor.line, sel.anchor.ch + (inverted ? -1 : 1)),
	      head: new Pos(sel.head.line, sel.head.ch + (inverted ? 1 : -1)) };
	  }
	
	  function handleChar(cm, ch) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var pos = pairs.indexOf(ch);
	    if (pos == -1) return CodeMirror.Pass;
	    var triples = getOption(conf, "triples");
	
	    var identical = pairs.charAt(pos + 1) == ch;
	    var ranges = cm.listSelections();
	    var opening = pos % 2 == 0;
	
	    var type;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i],
	          cur = range.head,
	          curType;
	      var next = cm.getRange(cur, Pos(cur.line, cur.ch + 1));
	      if (opening && !range.empty()) {
	        curType = "surround";
	      } else if ((identical || !opening) && next == ch) {
	        if (identical && stringStartsAfter(cm, cur)) curType = "both";else if (triples.indexOf(ch) >= 0 && cm.getRange(cur, Pos(cur.line, cur.ch + 3)) == ch + ch + ch) curType = "skipThree";else curType = "skip";
	      } else if (identical && cur.ch > 1 && triples.indexOf(ch) >= 0 && cm.getRange(Pos(cur.line, cur.ch - 2), cur) == ch + ch) {
	        if (cur.ch > 2 && /\bstring/.test(cm.getTokenTypeAt(Pos(cur.line, cur.ch - 2)))) return CodeMirror.Pass;
	        curType = "addFour";
	      } else if (identical) {
	        var prev = cur.ch == 0 ? " " : cm.getRange(Pos(cur.line, cur.ch - 1), cur);
	        if (!CodeMirror.isWordChar(next) && prev != ch && !CodeMirror.isWordChar(prev)) curType = "both";else return CodeMirror.Pass;
	      } else if (opening && (cm.getLine(cur.line).length == cur.ch || isClosingBracket(next, pairs) || /\s/.test(next))) {
	        curType = "both";
	      } else {
	        return CodeMirror.Pass;
	      }
	      if (!type) type = curType;else if (type != curType) return CodeMirror.Pass;
	    }
	
	    var left = pos % 2 ? pairs.charAt(pos - 1) : ch;
	    var right = pos % 2 ? ch : pairs.charAt(pos + 1);
	    cm.operation(function () {
	      if (type == "skip") {
	        cm.execCommand("goCharRight");
	      } else if (type == "skipThree") {
	        for (var i = 0; i < 3; i++) {
	          cm.execCommand("goCharRight");
	        }
	      } else if (type == "surround") {
	        var sels = cm.getSelections();
	        for (var i = 0; i < sels.length; i++) {
	          sels[i] = left + sels[i] + right;
	        }cm.replaceSelections(sels, "around");
	        sels = cm.listSelections().slice();
	        for (var i = 0; i < sels.length; i++) {
	          sels[i] = contractSelection(sels[i]);
	        }cm.setSelections(sels);
	      } else if (type == "both") {
	        cm.replaceSelection(left + right, null);
	        cm.triggerElectric(left + right);
	        cm.execCommand("goCharLeft");
	      } else if (type == "addFour") {
	        cm.replaceSelection(left + left + left + left, "before");
	        cm.execCommand("goCharRight");
	      }
	    });
	  }
	
	  function isClosingBracket(ch, pairs) {
	    var pos = pairs.lastIndexOf(ch);
	    return pos > -1 && pos % 2 == 1;
	  }
	
	  function charsAround(cm, pos) {
	    var str = cm.getRange(Pos(pos.line, pos.ch - 1), Pos(pos.line, pos.ch + 1));
	    return str.length == 2 ? str : null;
	  }
	
	  function stringStartsAfter(cm, pos) {
	    var token = cm.getTokenAt(Pos(pos.line, pos.ch + 1));
	    return (/\bstring/.test(token.type) && token.start == pos.ch && (pos.ch == 0 || !/\bstring/.test(cm.getTokenTypeAt(pos)))
	    );
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var ie_lt8 = /MSIE \d/.test(navigator.userAgent) && (document.documentMode == null || document.documentMode < 8);
	
	  var Pos = CodeMirror.Pos;
	
	  var matching = { "(": ")>", ")": "(<", "[": "]>", "]": "[<", "{": "}>", "}": "{<" };
	
	  function findMatchingBracket(cm, where, config) {
	    var line = cm.getLineHandle(where.line),
	        pos = where.ch - 1;
	    var afterCursor = config && config.afterCursor;
	    if (afterCursor == null) afterCursor = /(^| )cm-fat-cursor($| )/.test(cm.getWrapperElement().className);
	
	    // A cursor is defined as between two characters, but in in vim command mode
	    // (i.e. not insert mode), the cursor is visually represented as a
	    // highlighted box on top of the 2nd character. Otherwise, we allow matches
	    // from before or after the cursor.
	    var match = !afterCursor && pos >= 0 && matching[line.text.charAt(pos)] || matching[line.text.charAt(++pos)];
	    if (!match) return null;
	    var dir = match.charAt(1) == ">" ? 1 : -1;
	    if (config && config.strict && dir > 0 != (pos == where.ch)) return null;
	    var style = cm.getTokenTypeAt(Pos(where.line, pos + 1));
	
	    var found = scanForBracket(cm, Pos(where.line, pos + (dir > 0 ? 1 : 0)), dir, style || null, config);
	    if (found == null) return null;
	    return { from: Pos(where.line, pos), to: found && found.pos,
	      match: found && found.ch == match.charAt(0), forward: dir > 0 };
	  }
	
	  // bracketRegex is used to specify which type of bracket to scan
	  // should be a regexp, e.g. /[[\]]/
	  //
	  // Note: If "where" is on an open bracket, then this bracket is ignored.
	  //
	  // Returns false when no bracket was found, null when it reached
	  // maxScanLines and gave up
	  function scanForBracket(cm, where, dir, style, config) {
	    var maxScanLen = config && config.maxScanLineLength || 10000;
	    var maxScanLines = config && config.maxScanLines || 1000;
	
	    var stack = [];
	    var re = config && config.bracketRegex ? config.bracketRegex : /[(){}[\]]/;
	    var lineEnd = dir > 0 ? Math.min(where.line + maxScanLines, cm.lastLine() + 1) : Math.max(cm.firstLine() - 1, where.line - maxScanLines);
	    for (var lineNo = where.line; lineNo != lineEnd; lineNo += dir) {
	      var line = cm.getLine(lineNo);
	      if (!line) continue;
	      var pos = dir > 0 ? 0 : line.length - 1,
	          end = dir > 0 ? line.length : -1;
	      if (line.length > maxScanLen) continue;
	      if (lineNo == where.line) pos = where.ch - (dir < 0 ? 1 : 0);
	      for (; pos != end; pos += dir) {
	        var ch = line.charAt(pos);
	        if (re.test(ch) && (style === undefined || cm.getTokenTypeAt(Pos(lineNo, pos + 1)) == style)) {
	          var match = matching[ch];
	          if (match.charAt(1) == ">" == dir > 0) stack.push(ch);else if (!stack.length) return { pos: Pos(lineNo, pos), ch: ch };else stack.pop();
	        }
	      }
	    }
	    return lineNo - dir == (dir > 0 ? cm.lastLine() : cm.firstLine()) ? false : null;
	  }
	
	  function matchBrackets(cm, autoclear, config) {
	    // Disable brace matching in long lines, since it'll cause hugely slow updates
	    var maxHighlightLen = cm.state.matchBrackets.maxHighlightLineLength || 1000;
	    var marks = [],
	        ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      var match = ranges[i].empty() && findMatchingBracket(cm, ranges[i].head, config);
	      if (match && cm.getLine(match.from.line).length <= maxHighlightLen) {
	        var style = match.match ? "CodeMirror-matchingbracket" : "CodeMirror-nonmatchingbracket";
	        marks.push(cm.markText(match.from, Pos(match.from.line, match.from.ch + 1), { className: style }));
	        if (match.to && cm.getLine(match.to.line).length <= maxHighlightLen) marks.push(cm.markText(match.to, Pos(match.to.line, match.to.ch + 1), { className: style }));
	      }
	    }
	
	    if (marks.length) {
	      // Kludge to work around the IE bug from issue #1193, where text
	      // input stops going to the textare whever this fires.
	      if (ie_lt8 && cm.state.focused) cm.focus();
	
	      var clear = function clear() {
	        cm.operation(function () {
	          for (var i = 0; i < marks.length; i++) {
	            marks[i].clear();
	          }
	        });
	      };
	      if (autoclear) setTimeout(clear, 800);else return clear;
	    }
	  }
	
	  function doMatchBrackets(cm) {
	    cm.operation(function () {
	      if (cm.state.matchBrackets.currentlyHighlighted) {
	        cm.state.matchBrackets.currentlyHighlighted();
	        cm.state.matchBrackets.currentlyHighlighted = null;
	      }
	      cm.state.matchBrackets.currentlyHighlighted = matchBrackets(cm, false, cm.state.matchBrackets);
	    });
	  }
	
	  CodeMirror.defineOption("matchBrackets", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.off("cursorActivity", doMatchBrackets);
	      if (cm.state.matchBrackets && cm.state.matchBrackets.currentlyHighlighted) {
	        cm.state.matchBrackets.currentlyHighlighted();
	        cm.state.matchBrackets.currentlyHighlighted = null;
	      }
	    }
	    if (val) {
	      cm.state.matchBrackets = (typeof val === "undefined" ? "undefined" : _typeof(val)) == "object" ? val : {};
	      cm.on("cursorActivity", doMatchBrackets);
	    }
	  });
	
	  CodeMirror.defineExtension("matchBrackets", function () {
	    matchBrackets(this, true);
	  });
	  CodeMirror.defineExtension("findMatchingBracket", function (pos, config, oldConfig) {
	    // Backwards-compatibility kludge
	    if (oldConfig || typeof config == "boolean") {
	      if (!oldConfig) {
	        config = config ? { strict: true } : null;
	      } else {
	        oldConfig.strict = config;
	        config = oldConfig;
	      }
	    }
	    return findMatchingBracket(this, pos, config);
	  });
	  CodeMirror.defineExtension("scanForBracket", function (pos, dir, style, config) {
	    return scanForBracket(this, pos, dir, style, config);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Depends on jsonlint.js from https://github.com/zaach/jsonlint
	
	// declare global: jsonlint
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.registerHelper("lint", "json", function (text) {
	    var found = [];
	    if (!window.jsonlint) {
	      if (window.console) {
	        window.console.error("Error: window.jsonlint not defined, CodeMirror JSON linting cannot run.");
	      }
	      return found;
	    }
	    jsonlint.parseError = function (str, hash) {
	      var loc = hash.loc;
	      found.push({ from: CodeMirror.Pos(loc.first_line - 1, loc.first_column),
	        to: CodeMirror.Pos(loc.last_line - 1, loc.last_column),
	        message: str });
	    };
	    try {
	      jsonlint.parse(text);
	    } catch (e) {}
	    return found;
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var GUTTER_ID = "CodeMirror-lint-markers";
	
	  function showTooltip(e, content) {
	    var tt = document.createElement("div");
	    tt.className = "CodeMirror-lint-tooltip";
	    tt.appendChild(content.cloneNode(true));
	    document.body.appendChild(tt);
	
	    function position(e) {
	      if (!tt.parentNode) return CodeMirror.off(document, "mousemove", position);
	      tt.style.top = Math.max(0, e.clientY - tt.offsetHeight - 5) + "px";
	      tt.style.left = e.clientX + 5 + "px";
	    }
	    CodeMirror.on(document, "mousemove", position);
	    position(e);
	    if (tt.style.opacity != null) tt.style.opacity = 1;
	    return tt;
	  }
	  function rm(elt) {
	    if (elt.parentNode) elt.parentNode.removeChild(elt);
	  }
	  function hideTooltip(tt) {
	    if (!tt.parentNode) return;
	    if (tt.style.opacity == null) rm(tt);
	    tt.style.opacity = 0;
	    setTimeout(function () {
	      rm(tt);
	    }, 600);
	  }
	
	  function showTooltipFor(e, content, node) {
	    var tooltip = showTooltip(e, content);
	    function hide() {
	      CodeMirror.off(node, "mouseout", hide);
	      if (tooltip) {
	        hideTooltip(tooltip);tooltip = null;
	      }
	    }
	    var poll = setInterval(function () {
	      if (tooltip) for (var n = node;; n = n.parentNode) {
	        if (n && n.nodeType == 11) n = n.host;
	        if (n == document.body) return;
	        if (!n) {
	          hide();break;
	        }
	      }
	      if (!tooltip) return clearInterval(poll);
	    }, 400);
	    CodeMirror.on(node, "mouseout", hide);
	  }
	
	  function LintState(cm, options, hasGutter) {
	    this.marked = [];
	    this.options = options;
	    this.timeout = null;
	    this.hasGutter = hasGutter;
	    this.onMouseOver = function (e) {
	      onMouseOver(cm, e);
	    };
	    this.waitingFor = 0;
	  }
	
	  function parseOptions(_cm, options) {
	    if (options instanceof Function) return { getAnnotations: options };
	    if (!options || options === true) options = {};
	    return options;
	  }
	
	  function clearMarks(cm) {
	    var state = cm.state.lint;
	    if (state.hasGutter) cm.clearGutter(GUTTER_ID);
	    for (var i = 0; i < state.marked.length; ++i) {
	      state.marked[i].clear();
	    }state.marked.length = 0;
	  }
	
	  function makeMarker(labels, severity, multiple, tooltips) {
	    var marker = document.createElement("div"),
	        inner = marker;
	    marker.className = "CodeMirror-lint-marker-" + severity;
	    if (multiple) {
	      inner = marker.appendChild(document.createElement("div"));
	      inner.className = "CodeMirror-lint-marker-multiple";
	    }
	
	    if (tooltips != false) CodeMirror.on(inner, "mouseover", function (e) {
	      showTooltipFor(e, labels, inner);
	    });
	
	    return marker;
	  }
	
	  function getMaxSeverity(a, b) {
	    if (a == "error") return a;else return b;
	  }
	
	  function groupByLine(annotations) {
	    var lines = [];
	    for (var i = 0; i < annotations.length; ++i) {
	      var ann = annotations[i],
	          line = ann.from.line;
	      (lines[line] || (lines[line] = [])).push(ann);
	    }
	    return lines;
	  }
	
	  function annotationTooltip(ann) {
	    var severity = ann.severity;
	    if (!severity) severity = "error";
	    var tip = document.createElement("div");
	    tip.className = "CodeMirror-lint-message-" + severity;
	    if (typeof ann.messageHTML != 'undefined') {
	      tip.innerHTML = ann.messageHTML;
	    } else {
	      tip.appendChild(document.createTextNode(ann.message));
	    }
	    return tip;
	  }
	
	  function lintAsync(cm, getAnnotations, passOptions) {
	    var state = cm.state.lint;
	    var id = ++state.waitingFor;
	    function abort() {
	      id = -1;
	      cm.off("change", abort);
	    }
	    cm.on("change", abort);
	    getAnnotations(cm.getValue(), function (annotations, arg2) {
	      cm.off("change", abort);
	      if (state.waitingFor != id) return;
	      if (arg2 && annotations instanceof CodeMirror) annotations = arg2;
	      cm.operation(function () {
	        updateLinting(cm, annotations);
	      });
	    }, passOptions, cm);
	  }
	
	  function startLinting(cm) {
	    var state = cm.state.lint,
	        options = state.options;
	    /*
	     * Passing rules in `options` property prevents JSHint (and other linters) from complaining
	     * about unrecognized rules like `onUpdateLinting`, `delay`, `lintOnChange`, etc.
	     */
	    var passOptions = options.options || options;
	    var getAnnotations = options.getAnnotations || cm.getHelper(CodeMirror.Pos(0, 0), "lint");
	    if (!getAnnotations) return;
	    if (options.async || getAnnotations.async) {
	      lintAsync(cm, getAnnotations, passOptions);
	    } else {
	      var annotations = getAnnotations(cm.getValue(), passOptions, cm);
	      if (!annotations) return;
	      if (annotations.then) annotations.then(function (issues) {
	        cm.operation(function () {
	          updateLinting(cm, issues);
	        });
	      });else cm.operation(function () {
	        updateLinting(cm, annotations);
	      });
	    }
	  }
	
	  function updateLinting(cm, annotationsNotSorted) {
	    clearMarks(cm);
	    var state = cm.state.lint,
	        options = state.options;
	
	    var annotations = groupByLine(annotationsNotSorted);
	
	    for (var line = 0; line < annotations.length; ++line) {
	      var anns = annotations[line];
	      if (!anns) continue;
	
	      var maxSeverity = null;
	      var tipLabel = state.hasGutter && document.createDocumentFragment();
	
	      for (var i = 0; i < anns.length; ++i) {
	        var ann = anns[i];
	        var severity = ann.severity;
	        if (!severity) severity = "error";
	        maxSeverity = getMaxSeverity(maxSeverity, severity);
	
	        if (options.formatAnnotation) ann = options.formatAnnotation(ann);
	        if (state.hasGutter) tipLabel.appendChild(annotationTooltip(ann));
	
	        if (ann.to) state.marked.push(cm.markText(ann.from, ann.to, {
	          className: "CodeMirror-lint-mark-" + severity,
	          __annotation: ann
	        }));
	      }
	
	      if (state.hasGutter) cm.setGutterMarker(line, GUTTER_ID, makeMarker(tipLabel, maxSeverity, anns.length > 1, state.options.tooltips));
	    }
	    if (options.onUpdateLinting) options.onUpdateLinting(annotationsNotSorted, annotations, cm);
	  }
	
	  function onChange(cm) {
	    var state = cm.state.lint;
	    if (!state) return;
	    clearTimeout(state.timeout);
	    state.timeout = setTimeout(function () {
	      startLinting(cm);
	    }, state.options.delay || 500);
	  }
	
	  function popupTooltips(annotations, e) {
	    var target = e.target || e.srcElement;
	    var tooltip = document.createDocumentFragment();
	    for (var i = 0; i < annotations.length; i++) {
	      var ann = annotations[i];
	      tooltip.appendChild(annotationTooltip(ann));
	    }
	    showTooltipFor(e, tooltip, target);
	  }
	
	  function onMouseOver(cm, e) {
	    var target = e.target || e.srcElement;
	    if (!/\bCodeMirror-lint-mark-/.test(target.className)) return;
	    var box = target.getBoundingClientRect(),
	        x = (box.left + box.right) / 2,
	        y = (box.top + box.bottom) / 2;
	    var spans = cm.findMarksAt(cm.coordsChar({ left: x, top: y }, "client"));
	
	    var annotations = [];
	    for (var i = 0; i < spans.length; ++i) {
	      var ann = spans[i].__annotation;
	      if (ann) annotations.push(ann);
	    }
	    if (annotations.length) popupTooltips(annotations, e);
	  }
	
	  CodeMirror.defineOption("lint", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      clearMarks(cm);
	      if (cm.state.lint.options.lintOnChange !== false) cm.off("change", onChange);
	      CodeMirror.off(cm.getWrapperElement(), "mouseover", cm.state.lint.onMouseOver);
	      clearTimeout(cm.state.lint.timeout);
	      delete cm.state.lint;
	    }
	
	    if (val) {
	      var gutters = cm.getOption("gutters"),
	          hasLintGutter = false;
	      for (var i = 0; i < gutters.length; ++i) {
	        if (gutters[i] == GUTTER_ID) hasLintGutter = true;
	      }var state = cm.state.lint = new LintState(cm, parseOptions(cm, val), hasLintGutter);
	      if (state.options.lintOnChange !== false) cm.on("change", onChange);
	      if (state.options.tooltips != false && state.options.tooltips != "gutter") CodeMirror.on(cm.getWrapperElement(), "mouseover", state.onMouseOver);
	
	      startLinting(cm);
	    }
	  });
	
	  CodeMirror.defineExtension("performLint", function () {
	    if (this.state.lint) startLinting(this);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var WRAP_CLASS = "CodeMirror-activeline";
	  var BACK_CLASS = "CodeMirror-activeline-background";
	  var GUTT_CLASS = "CodeMirror-activeline-gutter";
	
	  CodeMirror.defineOption("styleActiveLine", false, function (cm, val, old) {
	    var prev = old == CodeMirror.Init ? false : old;
	    if (val == prev) return;
	    if (prev) {
	      cm.off("beforeSelectionChange", selectionChange);
	      clearActiveLines(cm);
	      delete cm.state.activeLines;
	    }
	    if (val) {
	      cm.state.activeLines = [];
	      updateActiveLines(cm, cm.listSelections());
	      cm.on("beforeSelectionChange", selectionChange);
	    }
	  });
	
	  function clearActiveLines(cm) {
	    for (var i = 0; i < cm.state.activeLines.length; i++) {
	      cm.removeLineClass(cm.state.activeLines[i], "wrap", WRAP_CLASS);
	      cm.removeLineClass(cm.state.activeLines[i], "background", BACK_CLASS);
	      cm.removeLineClass(cm.state.activeLines[i], "gutter", GUTT_CLASS);
	    }
	  }
	
	  function sameArray(a, b) {
	    if (a.length != b.length) return false;
	    for (var i = 0; i < a.length; i++) {
	      if (a[i] != b[i]) return false;
	    }return true;
	  }
	
	  function updateActiveLines(cm, ranges) {
	    var active = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      var option = cm.getOption("styleActiveLine");
	      if ((typeof option === "undefined" ? "undefined" : _typeof(option)) == "object" && option.nonEmpty ? range.anchor.line != range.head.line : !range.empty()) continue;
	      var line = cm.getLineHandleVisualStart(range.head.line);
	      if (active[active.length - 1] != line) active.push(line);
	    }
	    if (sameArray(cm.state.activeLines, active)) return;
	    cm.operation(function () {
	      clearActiveLines(cm);
	      for (var i = 0; i < active.length; i++) {
	        cm.addLineClass(active[i], "wrap", WRAP_CLASS);
	        cm.addLineClass(active[i], "background", BACK_CLASS);
	        cm.addLineClass(active[i], "gutter", GUTT_CLASS);
	      }
	      cm.state.activeLines = active;
	    });
	  }
	
	  function selectionChange(cm, sel) {
	    updateActiveLines(cm, sel.ranges);
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(3));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("javascript", function (config, parserConfig) {
	    var indentUnit = config.indentUnit;
	    var statementIndent = parserConfig.statementIndent;
	    var jsonldMode = parserConfig.jsonld;
	    var jsonMode = parserConfig.json || jsonldMode;
	    var isTS = parserConfig.typescript;
	    var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
	
	    // Tokenizer
	
	    var keywords = function () {
	      function kw(type) {
	        return { type: type, style: "keyword" };
	      }
	      var A = kw("keyword a"),
	          B = kw("keyword b"),
	          C = kw("keyword c"),
	          D = kw("keyword d");
	      var operator = kw("operator"),
	          atom = { type: "atom", style: "atom" };
	
	      return {
	        "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
	        "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
	        "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
	        "function": kw("function"), "catch": kw("catch"),
	        "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	        "in": operator, "typeof": operator, "instanceof": operator,
	        "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
	        "this": kw("this"), "class": kw("class"), "super": kw("atom"),
	        "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
	        "await": C
	      };
	    }();
	
	    var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
	    var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
	
	    function readRegexp(stream) {
	      var escaped = false,
	          next,
	          inSet = false;
	      while ((next = stream.next()) != null) {
	        if (!escaped) {
	          if (next == "/" && !inSet) return;
	          if (next == "[") inSet = true;else if (inSet && next == "]") inSet = false;
	        }
	        escaped = !escaped && next == "\\";
	      }
	    }
	
	    // Used as scratch variables to communicate multiple values without
	    // consing up tons of objects.
	    var type, content;
	    function ret(tp, style, cont) {
	      type = tp;content = cont;
	      return style;
	    }
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	      if (ch == '"' || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      } else if (ch == "." && stream.match(/^\d+(?:[eE][+\-]?\d+)?/)) {
	        return ret("number", "number");
	      } else if (ch == "." && stream.match("..")) {
	        return ret("spread", "meta");
	      } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	        return ret(ch);
	      } else if (ch == "=" && stream.eat(">")) {
	        return ret("=>", "operator");
	      } else if (ch == "0" && stream.eat(/x/i)) {
	        stream.eatWhile(/[\da-f]/i);
	        return ret("number", "number");
	      } else if (ch == "0" && stream.eat(/o/i)) {
	        stream.eatWhile(/[0-7]/i);
	        return ret("number", "number");
	      } else if (ch == "0" && stream.eat(/b/i)) {
	        stream.eatWhile(/[01]/i);
	        return ret("number", "number");
	      } else if (/\d/.test(ch)) {
	        stream.match(/^\d*(?:\.\d*)?(?:[eE][+\-]?\d+)?/);
	        return ret("number", "number");
	      } else if (ch == "/") {
	        if (stream.eat("*")) {
	          state.tokenize = tokenComment;
	          return tokenComment(stream, state);
	        } else if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ret("comment", "comment");
	        } else if (expressionAllowed(stream, state, 1)) {
	          readRegexp(stream);
	          stream.match(/^\b(([gimyu])(?![gimyu]*\2))+\b/);
	          return ret("regexp", "string-2");
	        } else {
	          stream.eat("=");
	          return ret("operator", "operator", stream.current());
	        }
	      } else if (ch == "`") {
	        state.tokenize = tokenQuasi;
	        return tokenQuasi(stream, state);
	      } else if (ch == "#") {
	        stream.skipToEnd();
	        return ret("error", "error");
	      } else if (isOperatorChar.test(ch)) {
	        if (ch != ">" || !state.lexical || state.lexical.type != ">") {
	          if (stream.eat("=")) {
	            if (ch == "!" || ch == "=") stream.eat("=");
	          } else if (/[<>*+\-]/.test(ch)) {
	            stream.eat(ch);
	            if (ch == ">") stream.eat(ch);
	          }
	        }
	        return ret("operator", "operator", stream.current());
	      } else if (wordRE.test(ch)) {
	        stream.eatWhile(wordRE);
	        var word = stream.current();
	        if (state.lastType != ".") {
	          if (keywords.propertyIsEnumerable(word)) {
	            var kw = keywords[word];
	            return ret(kw.type, kw.style, word);
	          }
	          if (word == "async" && stream.match(/^(\s|\/\*.*?\*\/)*[\(\w]/, false)) return ret("async", "keyword", word);
	        }
	        return ret("variable", "variable", word);
	      }
	    }
	
	    function tokenString(quote) {
	      return function (stream, state) {
	        var escaped = false,
	            next;
	        if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)) {
	          state.tokenize = tokenBase;
	          return ret("jsonld-keyword", "meta");
	        }
	        while ((next = stream.next()) != null) {
	          if (next == quote && !escaped) break;
	          escaped = !escaped && next == "\\";
	        }
	        if (!escaped) state.tokenize = tokenBase;
	        return ret("string", "string");
	      };
	    }
	
	    function tokenComment(stream, state) {
	      var maybeEnd = false,
	          ch;
	      while (ch = stream.next()) {
	        if (ch == "/" && maybeEnd) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        maybeEnd = ch == "*";
	      }
	      return ret("comment", "comment");
	    }
	
	    function tokenQuasi(stream, state) {
	      var escaped = false,
	          next;
	      while ((next = stream.next()) != null) {
	        if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      return ret("quasi", "string-2", stream.current());
	    }
	
	    var brackets = "([{}])";
	    // This is a crude lookahead trick to try and notice that we're
	    // parsing the argument patterns for a fat-arrow function before we
	    // actually hit the arrow token. It only works if the arrow is on
	    // the same line as the arguments and there's no strange noise
	    // (comments) in between. Fallback is to only notice when we hit the
	    // arrow, and not declare the arguments as locals for the arrow
	    // body.
	    function findFatArrow(stream, state) {
	      if (state.fatArrowAt) state.fatArrowAt = null;
	      var arrow = stream.string.indexOf("=>", stream.start);
	      if (arrow < 0) return;
	
	      if (isTS) {
	        // Try to skip TypeScript return type declarations after the arguments
	        var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow));
	        if (m) arrow = m.index;
	      }
	
	      var depth = 0,
	          sawSomething = false;
	      for (var pos = arrow - 1; pos >= 0; --pos) {
	        var ch = stream.string.charAt(pos);
	        var bracket = brackets.indexOf(ch);
	        if (bracket >= 0 && bracket < 3) {
	          if (!depth) {
	            ++pos;break;
	          }
	          if (--depth == 0) {
	            if (ch == "(") sawSomething = true;break;
	          }
	        } else if (bracket >= 3 && bracket < 6) {
	          ++depth;
	        } else if (wordRE.test(ch)) {
	          sawSomething = true;
	        } else if (/["'\/]/.test(ch)) {
	          return;
	        } else if (sawSomething && !depth) {
	          ++pos;
	          break;
	        }
	      }
	      if (sawSomething && !depth) state.fatArrowAt = pos;
	    }
	
	    // Parser
	
	    var atomicTypes = { "atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true };
	
	    function JSLexical(indented, column, type, align, prev, info) {
	      this.indented = indented;
	      this.column = column;
	      this.type = type;
	      this.prev = prev;
	      this.info = info;
	      if (align != null) this.align = align;
	    }
	
	    function inScope(state, varname) {
	      for (var v = state.localVars; v; v = v.next) {
	        if (v.name == varname) return true;
	      }for (var cx = state.context; cx; cx = cx.prev) {
	        for (var v = cx.vars; v; v = v.next) {
	          if (v.name == varname) return true;
	        }
	      }
	    }
	
	    function parseJS(state, style, type, content, stream) {
	      var cc = state.cc;
	      // Communicate our context to the combinators.
	      // (Less wasteful than consing up a hundred closures on every call.)
	      cx.state = state;cx.stream = stream;cx.marked = null, cx.cc = cc;cx.style = style;
	
	      if (!state.lexical.hasOwnProperty("align")) state.lexical.align = true;
	
	      while (true) {
	        var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
	        if (combinator(type, content)) {
	          while (cc.length && cc[cc.length - 1].lex) {
	            cc.pop()();
	          }if (cx.marked) return cx.marked;
	          if (type == "variable" && inScope(state, content)) return "variable-2";
	          return style;
	        }
	      }
	    }
	
	    // Combinator utils
	
	    var cx = { state: null, column: null, marked: null, cc: null };
	    function pass() {
	      for (var i = arguments.length - 1; i >= 0; i--) {
	        cx.cc.push(arguments[i]);
	      }
	    }
	    function cont() {
	      pass.apply(null, arguments);
	      return true;
	    }
	    function register(varname) {
	      function inList(list) {
	        for (var v = list; v; v = v.next) {
	          if (v.name == varname) return true;
	        }return false;
	      }
	      var state = cx.state;
	      cx.marked = "def";
	      if (state.context) {
	        if (inList(state.localVars)) return;
	        state.localVars = { name: varname, next: state.localVars };
	      } else {
	        if (inList(state.globalVars)) return;
	        if (parserConfig.globalVars) state.globalVars = { name: varname, next: state.globalVars };
	      }
	    }
	
	    function isModifier(name) {
	      return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly";
	    }
	
	    // Combinators
	
	    var defaultVars = { name: "this", next: { name: "arguments" } };
	    function pushcontext() {
	      cx.state.context = { prev: cx.state.context, vars: cx.state.localVars };
	      cx.state.localVars = defaultVars;
	    }
	    function popcontext() {
	      cx.state.localVars = cx.state.context.vars;
	      cx.state.context = cx.state.context.prev;
	    }
	    function pushlex(type, info) {
	      var result = function result() {
	        var state = cx.state,
	            indent = state.indented;
	        if (state.lexical.type == "stat") indent = state.lexical.indented;else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev) {
	          indent = outer.indented;
	        }state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
	      };
	      result.lex = true;
	      return result;
	    }
	    function poplex() {
	      var state = cx.state;
	      if (state.lexical.prev) {
	        if (state.lexical.type == ")") state.indented = state.lexical.indented;
	        state.lexical = state.lexical.prev;
	      }
	    }
	    poplex.lex = true;
	
	    function expect(wanted) {
	      function exp(type) {
	        if (type == wanted) return cont();else if (wanted == ";") return pass();else return cont(exp);
	      };
	      return exp;
	    }
	
	    function statement(type, value) {
	      if (type == "var") return cont(pushlex("vardef", value.length), vardef, expect(";"), poplex);
	      if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
	      if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	      if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
	      if (type == "debugger") return cont(expect(";"));
	      if (type == "{") return cont(pushlex("}"), block, poplex);
	      if (type == ";") return cont();
	      if (type == "if") {
	        if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex) cx.state.cc.pop()();
	        return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
	      }
	      if (type == "function") return cont(functiondef);
	      if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
	      if (type == "class" || isTS && value == "interface") {
	        cx.marked = "keyword";return cont(pushlex("form"), className, poplex);
	      }
	      if (type == "variable") {
	        if (isTS && value == "declare") {
	          cx.marked = "keyword";
	          return cont(statement);
	        } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
	          cx.marked = "keyword";
	          if (value == "enum") return cont(enumdef);else if (value == "type") return cont(typeexpr, expect("operator"), typeexpr, expect(";"));else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex);
	        } else if (isTS && value == "namespace") {
	          cx.marked = "keyword";
	          return cont(pushlex("form"), expression, block, poplex);
	        } else {
	          return cont(pushlex("stat"), maybelabel);
	        }
	      }
	      if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), block, poplex, poplex);
	      if (type == "case") return cont(expression, expect(":"));
	      if (type == "default") return cont(expect(":"));
	      if (type == "catch") return cont(pushlex("form"), pushcontext, expect("("), funarg, expect(")"), statement, poplex, popcontext);
	      if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
	      if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
	      if (type == "async") return cont(statement);
	      if (value == "@") return cont(expression, statement);
	      return pass(pushlex("stat"), expression, expect(";"), poplex);
	    }
	    function expression(type, value) {
	      return expressionInner(type, value, false);
	    }
	    function expressionNoComma(type, value) {
	      return expressionInner(type, value, true);
	    }
	    function parenExpr(type) {
	      if (type != "(") return pass();
	      return cont(pushlex(")"), expression, expect(")"), poplex);
	    }
	    function expressionInner(type, value, noComma) {
	      if (cx.state.fatArrowAt == cx.stream.start) {
	        var body = noComma ? arrowBodyNoComma : arrowBody;
	        if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
	      }
	
	      var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
	      if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
	      if (type == "function") return cont(functiondef, maybeop);
	      if (type == "class" || isTS && value == "interface") {
	        cx.marked = "keyword";return cont(pushlex("form"), classExpression, poplex);
	      }
	      if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
	      if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
	      if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
	      if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
	      if (type == "{") return contCommasep(objprop, "}", null, maybeop);
	      if (type == "quasi") return pass(quasi, maybeop);
	      if (type == "new") return cont(maybeTarget(noComma));
	      if (type == "import") return cont(expression);
	      return cont();
	    }
	    function maybeexpression(type) {
	      if (type.match(/[;\}\)\],]/)) return pass();
	      return pass(expression);
	    }
	
	    function maybeoperatorComma(type, value) {
	      if (type == ",") return cont(expression);
	      return maybeoperatorNoComma(type, value, false);
	    }
	    function maybeoperatorNoComma(type, value, noComma) {
	      var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
	      var expr = noComma == false ? expression : expressionNoComma;
	      if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
	      if (type == "operator") {
	        if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
	        if (isTS && value == "<" && cx.stream.match(/^([^>]|<.*?>)*>\s*\(/, false)) return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
	        if (value == "?") return cont(expression, expect(":"), expr);
	        return cont(expr);
	      }
	      if (type == "quasi") {
	        return pass(quasi, me);
	      }
	      if (type == ";") return;
	      if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
	      if (type == ".") return cont(property, me);
	      if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
	      if (isTS && value == "as") {
	        cx.marked = "keyword";return cont(typeexpr, me);
	      }
	      if (type == "regexp") {
	        cx.state.lastType = cx.marked = "operator";
	        cx.stream.backUp(cx.stream.pos - cx.stream.start - 1);
	        return cont(expr);
	      }
	    }
	    function quasi(type, value) {
	      if (type != "quasi") return pass();
	      if (value.slice(value.length - 2) != "${") return cont(quasi);
	      return cont(expression, continueQuasi);
	    }
	    function continueQuasi(type) {
	      if (type == "}") {
	        cx.marked = "string-2";
	        cx.state.tokenize = tokenQuasi;
	        return cont(quasi);
	      }
	    }
	    function arrowBody(type) {
	      findFatArrow(cx.stream, cx.state);
	      return pass(type == "{" ? statement : expression);
	    }
	    function arrowBodyNoComma(type) {
	      findFatArrow(cx.stream, cx.state);
	      return pass(type == "{" ? statement : expressionNoComma);
	    }
	    function maybeTarget(noComma) {
	      return function (type) {
	        if (type == ".") return cont(noComma ? targetNoComma : target);else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma);else return pass(noComma ? expressionNoComma : expression);
	      };
	    }
	    function target(_, value) {
	      if (value == "target") {
	        cx.marked = "keyword";return cont(maybeoperatorComma);
	      }
	    }
	    function targetNoComma(_, value) {
	      if (value == "target") {
	        cx.marked = "keyword";return cont(maybeoperatorNoComma);
	      }
	    }
	    function maybelabel(type) {
	      if (type == ":") return cont(poplex, statement);
	      return pass(maybeoperatorComma, expect(";"), poplex);
	    }
	    function property(type) {
	      if (type == "variable") {
	        cx.marked = "property";return cont();
	      }
	    }
	    function objprop(type, value) {
	      if (type == "async") {
	        cx.marked = "property";
	        return cont(objprop);
	      } else if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        if (value == "get" || value == "set") return cont(getterSetter);
	        var m; // Work around fat-arrow-detection complication for detecting typescript typed arrow params
	        if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false))) cx.state.fatArrowAt = cx.stream.pos + m[0].length;
	        return cont(afterprop);
	      } else if (type == "number" || type == "string") {
	        cx.marked = jsonldMode ? "property" : cx.style + " property";
	        return cont(afterprop);
	      } else if (type == "jsonld-keyword") {
	        return cont(afterprop);
	      } else if (isTS && isModifier(value)) {
	        cx.marked = "keyword";
	        return cont(objprop);
	      } else if (type == "[") {
	        return cont(expression, maybetype, expect("]"), afterprop);
	      } else if (type == "spread") {
	        return cont(expressionNoComma, afterprop);
	      } else if (value == "*") {
	        cx.marked = "keyword";
	        return cont(objprop);
	      } else if (type == ":") {
	        return pass(afterprop);
	      }
	    }
	    function getterSetter(type) {
	      if (type != "variable") return pass(afterprop);
	      cx.marked = "property";
	      return cont(functiondef);
	    }
	    function afterprop(type) {
	      if (type == ":") return cont(expressionNoComma);
	      if (type == "(") return pass(functiondef);
	    }
	    function commasep(what, end, sep) {
	      function proceed(type, value) {
	        if (sep ? sep.indexOf(type) > -1 : type == ",") {
	          var lex = cx.state.lexical;
	          if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
	          return cont(function (type, value) {
	            if (type == end || value == end) return pass();
	            return pass(what);
	          }, proceed);
	        }
	        if (type == end || value == end) return cont();
	        return cont(expect(end));
	      }
	      return function (type, value) {
	        if (type == end || value == end) return cont();
	        return pass(what, proceed);
	      };
	    }
	    function contCommasep(what, end, info) {
	      for (var i = 3; i < arguments.length; i++) {
	        cx.cc.push(arguments[i]);
	      }return cont(pushlex(end, info), commasep(what, end), poplex);
	    }
	    function block(type) {
	      if (type == "}") return cont();
	      return pass(statement, block);
	    }
	    function maybetype(type, value) {
	      if (isTS) {
	        if (type == ":") return cont(typeexpr);
	        if (value == "?") return cont(maybetype);
	      }
	    }
	    function mayberettype(type) {
	      if (isTS && type == ":") {
	        if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr);else return cont(typeexpr);
	      }
	    }
	    function isKW(_, value) {
	      if (value == "is") {
	        cx.marked = "keyword";
	        return cont();
	      }
	    }
	    function typeexpr(type, value) {
	      if (value == "keyof" || value == "typeof") {
	        cx.marked = "keyword";
	        return cont(value == "keyof" ? typeexpr : expression);
	      }
	      if (type == "variable" || value == "void") {
	        cx.marked = "type";
	        return cont(afterType);
	      }
	      if (type == "string" || type == "number" || type == "atom") return cont(afterType);
	      if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType);
	      if (type == "{") return cont(pushlex("}"), commasep(typeprop, "}", ",;"), poplex, afterType);
	      if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType);
	    }
	    function maybeReturnType(type) {
	      if (type == "=>") return cont(typeexpr);
	    }
	    function typeprop(type, value) {
	      if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        return cont(typeprop);
	      } else if (value == "?") {
	        return cont(typeprop);
	      } else if (type == ":") {
	        return cont(typeexpr);
	      } else if (type == "[") {
	        return cont(expression, maybetype, expect("]"), typeprop);
	      }
	    }
	    function typearg(type) {
	      if (type == "variable") return cont(typearg);else if (type == ":") return cont(typeexpr);
	    }
	    function afterType(type, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
	      if (value == "|" || type == "." || value == "&") return cont(typeexpr);
	      if (type == "[") return cont(expect("]"), afterType);
	      if (value == "extends" || value == "implements") {
	        cx.marked = "keyword";return cont(typeexpr);
	      }
	    }
	    function maybeTypeArgs(_, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
	    }
	    function typeparam() {
	      return pass(typeexpr, maybeTypeDefault);
	    }
	    function maybeTypeDefault(_, value) {
	      if (value == "=") return cont(typeexpr);
	    }
	    function vardef(_, value) {
	      if (value == "enum") {
	        cx.marked = "keyword";return cont(enumdef);
	      }
	      return pass(pattern, maybetype, maybeAssign, vardefCont);
	    }
	    function pattern(type, value) {
	      if (isTS && isModifier(value)) {
	        cx.marked = "keyword";return cont(pattern);
	      }
	      if (type == "variable") {
	        register(value);return cont();
	      }
	      if (type == "spread") return cont(pattern);
	      if (type == "[") return contCommasep(pattern, "]");
	      if (type == "{") return contCommasep(proppattern, "}");
	    }
	    function proppattern(type, value) {
	      if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
	        register(value);
	        return cont(maybeAssign);
	      }
	      if (type == "variable") cx.marked = "property";
	      if (type == "spread") return cont(pattern);
	      if (type == "}") return pass();
	      return cont(expect(":"), pattern, maybeAssign);
	    }
	    function maybeAssign(_type, value) {
	      if (value == "=") return cont(expressionNoComma);
	    }
	    function vardefCont(type) {
	      if (type == ",") return cont(vardef);
	    }
	    function maybeelse(type, value) {
	      if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
	    }
	    function forspec(type, value) {
	      if (value == "await") return cont(forspec);
	      if (type == "(") return cont(pushlex(")"), forspec1, expect(")"), poplex);
	    }
	    function forspec1(type) {
	      if (type == "var") return cont(vardef, expect(";"), forspec2);
	      if (type == ";") return cont(forspec2);
	      if (type == "variable") return cont(formaybeinof);
	      return pass(expression, expect(";"), forspec2);
	    }
	    function formaybeinof(_type, value) {
	      if (value == "in" || value == "of") {
	        cx.marked = "keyword";return cont(expression);
	      }
	      return cont(maybeoperatorComma, forspec2);
	    }
	    function forspec2(type, value) {
	      if (type == ";") return cont(forspec3);
	      if (value == "in" || value == "of") {
	        cx.marked = "keyword";return cont(expression);
	      }
	      return pass(expression, expect(";"), forspec3);
	    }
	    function forspec3(type) {
	      if (type != ")") cont(expression);
	    }
	    function functiondef(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(functiondef);
	      }
	      if (type == "variable") {
	        register(value);return cont(functiondef);
	      }
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
	      if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef);
	    }
	    function funarg(type, value) {
	      if (value == "@") cont(expression, funarg);
	      if (type == "spread") return cont(funarg);
	      if (isTS && isModifier(value)) {
	        cx.marked = "keyword";return cont(funarg);
	      }
	      return pass(pattern, maybetype, maybeAssign);
	    }
	    function classExpression(type, value) {
	      // Class expressions may have an optional name.
	      if (type == "variable") return className(type, value);
	      return classNameAfter(type, value);
	    }
	    function className(type, value) {
	      if (type == "variable") {
	        register(value);return cont(classNameAfter);
	      }
	    }
	    function classNameAfter(type, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter);
	      if (value == "extends" || value == "implements" || isTS && type == ",") {
	        if (value == "implements") cx.marked = "keyword";
	        return cont(isTS ? typeexpr : expression, classNameAfter);
	      }
	      if (type == "{") return cont(pushlex("}"), classBody, poplex);
	    }
	    function classBody(type, value) {
	      if (type == "async" || type == "variable" && (value == "static" || value == "get" || value == "set" || isTS && isModifier(value)) && cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false)) {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        return cont(isTS ? classfield : functiondef, classBody);
	      }
	      if (type == "[") return cont(expression, maybetype, expect("]"), isTS ? classfield : functiondef, classBody);
	      if (value == "*") {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      if (type == ";") return cont(classBody);
	      if (type == "}") return cont();
	      if (value == "@") return cont(expression, classBody);
	    }
	    function classfield(type, value) {
	      if (value == "?") return cont(classfield);
	      if (type == ":") return cont(typeexpr, maybeAssign);
	      if (value == "=") return cont(expressionNoComma);
	      return pass(functiondef);
	    }
	    function afterExport(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(maybeFrom, expect(";"));
	      }
	      if (value == "default") {
	        cx.marked = "keyword";return cont(expression, expect(";"));
	      }
	      if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
	      return pass(statement);
	    }
	    function exportField(type, value) {
	      if (value == "as") {
	        cx.marked = "keyword";return cont(expect("variable"));
	      }
	      if (type == "variable") return pass(expressionNoComma, exportField);
	    }
	    function afterImport(type) {
	      if (type == "string") return cont();
	      if (type == "(") return pass(expression);
	      return pass(importSpec, maybeMoreImports, maybeFrom);
	    }
	    function importSpec(type, value) {
	      if (type == "{") return contCommasep(importSpec, "}");
	      if (type == "variable") register(value);
	      if (value == "*") cx.marked = "keyword";
	      return cont(maybeAs);
	    }
	    function maybeMoreImports(type) {
	      if (type == ",") return cont(importSpec, maybeMoreImports);
	    }
	    function maybeAs(_type, value) {
	      if (value == "as") {
	        cx.marked = "keyword";return cont(importSpec);
	      }
	    }
	    function maybeFrom(_type, value) {
	      if (value == "from") {
	        cx.marked = "keyword";return cont(expression);
	      }
	    }
	    function arrayLiteral(type) {
	      if (type == "]") return cont();
	      return pass(commasep(expressionNoComma, "]"));
	    }
	    function enumdef() {
	      return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex);
	    }
	    function enummember() {
	      return pass(pattern, maybeAssign);
	    }
	
	    function isContinuedStatement(state, textAfter) {
	      return state.lastType == "operator" || state.lastType == "," || isOperatorChar.test(textAfter.charAt(0)) || /[,.]/.test(textAfter.charAt(0));
	    }
	
	    function expressionAllowed(stream, state, backUp) {
	      return state.tokenize == tokenBase && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) || state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0)));
	    }
	
	    // Interface
	
	    return {
	      startState: function startState(basecolumn) {
	        var state = {
	          tokenize: tokenBase,
	          lastType: "sof",
	          cc: [],
	          lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	          localVars: parserConfig.localVars,
	          context: parserConfig.localVars && { vars: parserConfig.localVars },
	          indented: basecolumn || 0
	        };
	        if (parserConfig.globalVars && _typeof(parserConfig.globalVars) == "object") state.globalVars = parserConfig.globalVars;
	        return state;
	      },
	
	      token: function token(stream, state) {
	        if (stream.sol()) {
	          if (!state.lexical.hasOwnProperty("align")) state.lexical.align = false;
	          state.indented = stream.indentation();
	          findFatArrow(stream, state);
	        }
	        if (state.tokenize != tokenComment && stream.eatSpace()) return null;
	        var style = state.tokenize(stream, state);
	        if (type == "comment") return style;
	        state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
	        return parseJS(state, style, type, content, stream);
	      },
	
	      indent: function indent(state, textAfter) {
	        if (state.tokenize == tokenComment) return CodeMirror.Pass;
	        if (state.tokenize != tokenBase) return 0;
	        var firstChar = textAfter && textAfter.charAt(0),
	            lexical = state.lexical,
	            top;
	        // Kludge to prevent 'maybelse' from blocking lexical scope pops
	        if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
	          var c = state.cc[i];
	          if (c == poplex) lexical = lexical.prev;else if (c != maybeelse) break;
	        }
	        while ((lexical.type == "stat" || lexical.type == "form") && (firstChar == "}" || (top = state.cc[state.cc.length - 1]) && (top == maybeoperatorComma || top == maybeoperatorNoComma) && !/^[,\.=+\-*:?[\(]/.test(textAfter))) {
	          lexical = lexical.prev;
	        }if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat") lexical = lexical.prev;
	        var type = lexical.type,
	            closing = firstChar == type;
	
	        if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info + 1 : 0);else if (type == "form" && firstChar == "{") return lexical.indented;else if (type == "form") return lexical.indented + indentUnit;else if (type == "stat") return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false) return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);else if (lexical.align) return lexical.column + (closing ? 0 : 1);else return lexical.indented + (closing ? 0 : indentUnit);
	      },
	
	      electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
	      blockCommentStart: jsonMode ? null : "/*",
	      blockCommentEnd: jsonMode ? null : "*/",
	      blockCommentContinue: jsonMode ? null : " * ",
	      lineComment: jsonMode ? null : "//",
	      fold: "brace",
	      closeBrackets: "()[]{}''\"\"``",
	
	      helperType: jsonMode ? "json" : "javascript",
	      jsonldMode: jsonldMode,
	      jsonMode: jsonMode,
	
	      expressionAllowed: expressionAllowed,
	
	      skipExpression: function skipExpression(state) {
	        var top = state.cc[state.cc.length - 1];
	        if (top == expression || top == expressionNoComma) state.cc.pop();
	      }
	    };
	  });
	
	  CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
	
	  CodeMirror.defineMIME("text/javascript", "javascript");
	  CodeMirror.defineMIME("text/ecmascript", "javascript");
	  CodeMirror.defineMIME("application/javascript", "javascript");
	  CodeMirror.defineMIME("application/x-javascript", "javascript");
	  CodeMirror.defineMIME("application/ecmascript", "javascript");
	  CodeMirror.defineMIME("application/json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/x-json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/ld+json", { name: "javascript", jsonld: true });
	  CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
	  CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	var require;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, setImmediate, global, module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   2.3.0
	 */
	
	(function () {
	  "use strict";
	
	  function lib$es6$promise$utils$$objectOrFunction(x) {
	    return typeof x === 'function' || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null;
	  }
	
	  function lib$es6$promise$utils$$isFunction(x) {
	    return typeof x === 'function';
	  }
	
	  function lib$es6$promise$utils$$isMaybeThenable(x) {
	    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null;
	  }
	
	  var lib$es6$promise$utils$$_isArray;
	  if (!Array.isArray) {
	    lib$es6$promise$utils$$_isArray = function lib$es6$promise$utils$$_isArray(x) {
	      return Object.prototype.toString.call(x) === '[object Array]';
	    };
	  } else {
	    lib$es6$promise$utils$$_isArray = Array.isArray;
	  }
	
	  var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
	  var lib$es6$promise$asap$$len = 0;
	  var lib$es6$promise$asap$$toString = {}.toString;
	  var lib$es6$promise$asap$$vertxNext;
	  var lib$es6$promise$asap$$customSchedulerFn;
	
	  var lib$es6$promise$asap$$asap = function asap(callback, arg) {
	    lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
	    lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
	    lib$es6$promise$asap$$len += 2;
	    if (lib$es6$promise$asap$$len === 2) {
	      // If len is 2, that means that we need to schedule an async flush.
	      // If additional callbacks are queued before the queue is flushed, they
	      // will be processed by this flush that we are scheduling.
	      if (lib$es6$promise$asap$$customSchedulerFn) {
	        lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
	      } else {
	        lib$es6$promise$asap$$scheduleFlush();
	      }
	    }
	  };
	
	  function lib$es6$promise$asap$$setScheduler(scheduleFn) {
	    lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
	  }
	
	  function lib$es6$promise$asap$$setAsap(asapFn) {
	    lib$es6$promise$asap$$asap = asapFn;
	  }
	
	  var lib$es6$promise$asap$$browserWindow = typeof window !== 'undefined' ? window : undefined;
	  var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
	  var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
	  var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	  // test for web worker but not in IE10
	  var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	  // node
	  function lib$es6$promise$asap$$useNextTick() {
	    var nextTick = process.nextTick;
	    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	    // setImmediate should be used instead instead
	    var version = process.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
	    if (Array.isArray(version) && version[1] === '0' && version[2] === '10') {
	      nextTick = setImmediate;
	    }
	    return function () {
	      nextTick(lib$es6$promise$asap$$flush);
	    };
	  }
	
	  // vertx
	  function lib$es6$promise$asap$$useVertxTimer() {
	    return function () {
	      lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
	    };
	  }
	
	  function lib$es6$promise$asap$$useMutationObserver() {
	    var iterations = 0;
	    var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
	    var node = document.createTextNode('');
	    observer.observe(node, { characterData: true });
	
	    return function () {
	      node.data = iterations = ++iterations % 2;
	    };
	  }
	
	  // web worker
	  function lib$es6$promise$asap$$useMessageChannel() {
	    var channel = new MessageChannel();
	    channel.port1.onmessage = lib$es6$promise$asap$$flush;
	    return function () {
	      channel.port2.postMessage(0);
	    };
	  }
	
	  function lib$es6$promise$asap$$useSetTimeout() {
	    return function () {
	      setTimeout(lib$es6$promise$asap$$flush, 1);
	    };
	  }
	
	  var lib$es6$promise$asap$$queue = new Array(1000);
	  function lib$es6$promise$asap$$flush() {
	    for (var i = 0; i < lib$es6$promise$asap$$len; i += 2) {
	      var callback = lib$es6$promise$asap$$queue[i];
	      var arg = lib$es6$promise$asap$$queue[i + 1];
	
	      callback(arg);
	
	      lib$es6$promise$asap$$queue[i] = undefined;
	      lib$es6$promise$asap$$queue[i + 1] = undefined;
	    }
	
	    lib$es6$promise$asap$$len = 0;
	  }
	
	  function lib$es6$promise$asap$$attemptVertex() {
	    try {
	      var r = require;
	      var vertx = __webpack_require__(434);
	      lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
	      return lib$es6$promise$asap$$useVertxTimer();
	    } catch (e) {
	      return lib$es6$promise$asap$$useSetTimeout();
	    }
	  }
	
	  var lib$es6$promise$asap$$scheduleFlush;
	  // Decide what async method to use to triggering processing of queued callbacks:
	  if (lib$es6$promise$asap$$isNode) {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
	  } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
	  } else if (lib$es6$promise$asap$$isWorker) {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
	  } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertex();
	  } else {
	    lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
	  }
	
	  function lib$es6$promise$$internal$$noop() {}
	
	  var lib$es6$promise$$internal$$PENDING = void 0;
	  var lib$es6$promise$$internal$$FULFILLED = 1;
	  var lib$es6$promise$$internal$$REJECTED = 2;
	
	  var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	  function lib$es6$promise$$internal$$selfFullfillment() {
	    return new TypeError("You cannot resolve a promise with itself");
	  }
	
	  function lib$es6$promise$$internal$$cannotReturnOwn() {
	    return new TypeError('A promises callback cannot return that same promise.');
	  }
	
	  function lib$es6$promise$$internal$$getThen(promise) {
	    try {
	      return promise.then;
	    } catch (error) {
	      lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
	      return lib$es6$promise$$internal$$GET_THEN_ERROR;
	    }
	  }
	
	  function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	    try {
	      then.call(value, fulfillmentHandler, rejectionHandler);
	    } catch (e) {
	      return e;
	    }
	  }
	
	  function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
	    lib$es6$promise$asap$$asap(function (promise) {
	      var sealed = false;
	      var error = lib$es6$promise$$internal$$tryThen(then, thenable, function (value) {
	        if (sealed) {
	          return;
	        }
	        sealed = true;
	        if (thenable !== value) {
	          lib$es6$promise$$internal$$resolve(promise, value);
	        } else {
	          lib$es6$promise$$internal$$fulfill(promise, value);
	        }
	      }, function (reason) {
	        if (sealed) {
	          return;
	        }
	        sealed = true;
	
	        lib$es6$promise$$internal$$reject(promise, reason);
	      }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	      if (!sealed && error) {
	        sealed = true;
	        lib$es6$promise$$internal$$reject(promise, error);
	      }
	    }, promise);
	  }
	
	  function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
	    if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
	      lib$es6$promise$$internal$$fulfill(promise, thenable._result);
	    } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
	      lib$es6$promise$$internal$$reject(promise, thenable._result);
	    } else {
	      lib$es6$promise$$internal$$subscribe(thenable, undefined, function (value) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      }, function (reason) {
	        lib$es6$promise$$internal$$reject(promise, reason);
	      });
	    }
	  }
	
	  function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
	    if (maybeThenable.constructor === promise.constructor) {
	      lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
	    } else {
	      var then = lib$es6$promise$$internal$$getThen(maybeThenable);
	
	      if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
	      } else if (then === undefined) {
	        lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	      } else if (lib$es6$promise$utils$$isFunction(then)) {
	        lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
	      } else {
	        lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	      }
	    }
	  }
	
	  function lib$es6$promise$$internal$$resolve(promise, value) {
	    if (promise === value) {
	      lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFullfillment());
	    } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
	      lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
	    } else {
	      lib$es6$promise$$internal$$fulfill(promise, value);
	    }
	  }
	
	  function lib$es6$promise$$internal$$publishRejection(promise) {
	    if (promise._onerror) {
	      promise._onerror(promise._result);
	    }
	
	    lib$es6$promise$$internal$$publish(promise);
	  }
	
	  function lib$es6$promise$$internal$$fulfill(promise, value) {
	    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	      return;
	    }
	
	    promise._result = value;
	    promise._state = lib$es6$promise$$internal$$FULFILLED;
	
	    if (promise._subscribers.length !== 0) {
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
	    }
	  }
	
	  function lib$es6$promise$$internal$$reject(promise, reason) {
	    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	      return;
	    }
	    promise._state = lib$es6$promise$$internal$$REJECTED;
	    promise._result = reason;
	
	    lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
	  }
	
	  function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
	    var subscribers = parent._subscribers;
	    var length = subscribers.length;
	
	    parent._onerror = null;
	
	    subscribers[length] = child;
	    subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
	    subscribers[length + lib$es6$promise$$internal$$REJECTED] = onRejection;
	
	    if (length === 0 && parent._state) {
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
	    }
	  }
	
	  function lib$es6$promise$$internal$$publish(promise) {
	    var subscribers = promise._subscribers;
	    var settled = promise._state;
	
	    if (subscribers.length === 0) {
	      return;
	    }
	
	    var child,
	        callback,
	        detail = promise._result;
	
	    for (var i = 0; i < subscribers.length; i += 3) {
	      child = subscribers[i];
	      callback = subscribers[i + settled];
	
	      if (child) {
	        lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
	      } else {
	        callback(detail);
	      }
	    }
	
	    promise._subscribers.length = 0;
	  }
	
	  function lib$es6$promise$$internal$$ErrorObject() {
	    this.error = null;
	  }
	
	  var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	  function lib$es6$promise$$internal$$tryCatch(callback, detail) {
	    try {
	      return callback(detail);
	    } catch (e) {
	      lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
	      return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
	    }
	  }
	
	  function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
	    var hasCallback = lib$es6$promise$utils$$isFunction(callback),
	        value,
	        error,
	        succeeded,
	        failed;
	
	    if (hasCallback) {
	      value = lib$es6$promise$$internal$$tryCatch(callback, detail);
	
	      if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
	        failed = true;
	        error = value.error;
	        value = null;
	      } else {
	        succeeded = true;
	      }
	
	      if (promise === value) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
	        return;
	      }
	    } else {
	      value = detail;
	      succeeded = true;
	    }
	
	    if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	      // noop
	    } else if (hasCallback && succeeded) {
	      lib$es6$promise$$internal$$resolve(promise, value);
	    } else if (failed) {
	      lib$es6$promise$$internal$$reject(promise, error);
	    } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
	      lib$es6$promise$$internal$$fulfill(promise, value);
	    } else if (settled === lib$es6$promise$$internal$$REJECTED) {
	      lib$es6$promise$$internal$$reject(promise, value);
	    }
	  }
	
	  function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
	    try {
	      resolver(function resolvePromise(value) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      }, function rejectPromise(reason) {
	        lib$es6$promise$$internal$$reject(promise, reason);
	      });
	    } catch (e) {
	      lib$es6$promise$$internal$$reject(promise, e);
	    }
	  }
	
	  function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
	    var enumerator = this;
	
	    enumerator._instanceConstructor = Constructor;
	    enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	    if (enumerator._validateInput(input)) {
	      enumerator._input = input;
	      enumerator.length = input.length;
	      enumerator._remaining = input.length;
	
	      enumerator._init();
	
	      if (enumerator.length === 0) {
	        lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	      } else {
	        enumerator.length = enumerator.length || 0;
	        enumerator._enumerate();
	        if (enumerator._remaining === 0) {
	          lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	        }
	      }
	    } else {
	      lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
	    }
	  }
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function (input) {
	    return lib$es6$promise$utils$$isArray(input);
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function () {
	    return new Error('Array Methods must be provided an Array');
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._init = function () {
	    this._result = new Array(this.length);
	  };
	
	  var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function () {
	    var enumerator = this;
	
	    var length = enumerator.length;
	    var promise = enumerator.promise;
	    var input = enumerator._input;
	
	    for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	      enumerator._eachEntry(input[i], i);
	    }
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function (entry, i) {
	    var enumerator = this;
	    var c = enumerator._instanceConstructor;
	
	    if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
	      if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
	        entry._onerror = null;
	        enumerator._settledAt(entry._state, i, entry._result);
	      } else {
	        enumerator._willSettleAt(c.resolve(entry), i);
	      }
	    } else {
	      enumerator._remaining--;
	      enumerator._result[i] = entry;
	    }
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function (state, i, value) {
	    var enumerator = this;
	    var promise = enumerator.promise;
	
	    if (promise._state === lib$es6$promise$$internal$$PENDING) {
	      enumerator._remaining--;
	
	      if (state === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, value);
	      } else {
	        enumerator._result[i] = value;
	      }
	    }
	
	    if (enumerator._remaining === 0) {
	      lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
	    }
	  };
	
	  lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function (promise, i) {
	    var enumerator = this;
	
	    lib$es6$promise$$internal$$subscribe(promise, undefined, function (value) {
	      enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
	    }, function (reason) {
	      enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
	    });
	  };
	  function lib$es6$promise$promise$all$$all(entries) {
	    return new lib$es6$promise$enumerator$$default(this, entries).promise;
	  }
	  var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
	  function lib$es6$promise$promise$race$$race(entries) {
	    /*jshint validthis:true */
	    var Constructor = this;
	
	    var promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	    if (!lib$es6$promise$utils$$isArray(entries)) {
	      lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
	      return promise;
	    }
	
	    var length = entries.length;
	
	    function onFulfillment(value) {
	      lib$es6$promise$$internal$$resolve(promise, value);
	    }
	
	    function onRejection(reason) {
	      lib$es6$promise$$internal$$reject(promise, reason);
	    }
	
	    for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	      lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
	    }
	
	    return promise;
	  }
	  var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
	  function lib$es6$promise$promise$resolve$$resolve(object) {
	    /*jshint validthis:true */
	    var Constructor = this;
	
	    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.constructor === Constructor) {
	      return object;
	    }
	
	    var promise = new Constructor(lib$es6$promise$$internal$$noop);
	    lib$es6$promise$$internal$$resolve(promise, object);
	    return promise;
	  }
	  var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
	  function lib$es6$promise$promise$reject$$reject(reason) {
	    /*jshint validthis:true */
	    var Constructor = this;
	    var promise = new Constructor(lib$es6$promise$$internal$$noop);
	    lib$es6$promise$$internal$$reject(promise, reason);
	    return promise;
	  }
	  var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;
	
	  var lib$es6$promise$promise$$counter = 0;
	
	  function lib$es6$promise$promise$$needsResolver() {
	    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	  }
	
	  function lib$es6$promise$promise$$needsNew() {
	    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	  }
	
	  var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
	  /**
	    Promise objects represent the eventual result of an asynchronous operation. The
	    primary way of interacting with a promise is through its `then` method, which
	    registers callbacks to receive either a promise's eventual value or the reason
	    why the promise cannot be fulfilled.
	     Terminology
	    -----------
	     - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	    - `thenable` is an object or function that defines a `then` method.
	    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	    - `exception` is a value that is thrown using the throw statement.
	    - `reason` is a value that indicates why a promise was rejected.
	    - `settled` the final resting state of a promise, fulfilled or rejected.
	     A promise can be in one of three states: pending, fulfilled, or rejected.
	     Promises that are fulfilled have a fulfillment value and are in the fulfilled
	    state.  Promises that are rejected have a rejection reason and are in the
	    rejected state.  A fulfillment value is never a thenable.
	     Promises can also be said to *resolve* a value.  If this value is also a
	    promise, then the original promise's settled state will match the value's
	    settled state.  So a promise that *resolves* a promise that rejects will
	    itself reject, and a promise that *resolves* a promise that fulfills will
	    itself fulfill.
	      Basic Usage:
	    ------------
	     ```js
	    var promise = new Promise(function(resolve, reject) {
	      // on success
	      resolve(value);
	       // on failure
	      reject(reason);
	    });
	     promise.then(function(value) {
	      // on fulfillment
	    }, function(reason) {
	      // on rejection
	    });
	    ```
	     Advanced Usage:
	    ---------------
	     Promises shine when abstracting away asynchronous interactions such as
	    `XMLHttpRequest`s.
	     ```js
	    function getJSON(url) {
	      return new Promise(function(resolve, reject){
	        var xhr = new XMLHttpRequest();
	         xhr.open('GET', url);
	        xhr.onreadystatechange = handler;
	        xhr.responseType = 'json';
	        xhr.setRequestHeader('Accept', 'application/json');
	        xhr.send();
	         function handler() {
	          if (this.readyState === this.DONE) {
	            if (this.status === 200) {
	              resolve(this.response);
	            } else {
	              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	            }
	          }
	        };
	      });
	    }
	     getJSON('/posts.json').then(function(json) {
	      // on fulfillment
	    }, function(reason) {
	      // on rejection
	    });
	    ```
	     Unlike callbacks, promises are great composable primitives.
	     ```js
	    Promise.all([
	      getJSON('/posts'),
	      getJSON('/comments')
	    ]).then(function(values){
	      values[0] // => postsJSON
	      values[1] // => commentsJSON
	       return values;
	    });
	    ```
	     @class Promise
	    @param {function} resolver
	    Useful for tooling.
	    @constructor
	  */
	  function lib$es6$promise$promise$$Promise(resolver) {
	    this._id = lib$es6$promise$promise$$counter++;
	    this._state = undefined;
	    this._result = undefined;
	    this._subscribers = [];
	
	    if (lib$es6$promise$$internal$$noop !== resolver) {
	      if (!lib$es6$promise$utils$$isFunction(resolver)) {
	        lib$es6$promise$promise$$needsResolver();
	      }
	
	      if (!(this instanceof lib$es6$promise$promise$$Promise)) {
	        lib$es6$promise$promise$$needsNew();
	      }
	
	      lib$es6$promise$$internal$$initializePromise(this, resolver);
	    }
	  }
	
	  lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
	  lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
	  lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
	  lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
	  lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
	  lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
	  lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;
	
	  lib$es6$promise$promise$$Promise.prototype = {
	    constructor: lib$es6$promise$promise$$Promise,
	
	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.
	       ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```
	       Chaining
	      --------
	       The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.
	       ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });
	       findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we're unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	       ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```
	       Assimilation
	      ------------
	       Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.
	       ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```
	       If the assimliated promise rejects, then the downstream promise will also reject.
	       ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```
	       Simple Example
	      --------------
	       Synchronous Example
	       ```javascript
	      var result;
	       try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	       Errback Example
	       ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```
	       Promise Example;
	       ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```
	       Advanced Example
	      --------------
	       Synchronous Example
	       ```javascript
	      var author, books;
	       try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	       Errback Example
	       ```js
	       function foundBooks(books) {
	       }
	       function failure(reason) {
	       }
	       findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```
	       Promise Example;
	       ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```
	       @method then
	      @param {Function} onFulfilled
	      @param {Function} onRejected
	      Useful for tooling.
	      @return {Promise}
	    */
	    then: function then(onFulfillment, onRejection) {
	      var parent = this;
	      var state = parent._state;
	
	      if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
	        return this;
	      }
	
	      var child = new this.constructor(lib$es6$promise$$internal$$noop);
	      var result = parent._result;
	
	      if (state) {
	        var callback = arguments[state - 1];
	        lib$es6$promise$asap$$asap(function () {
	          lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
	        });
	      } else {
	        lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
	      }
	
	      return child;
	    },
	
	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.
	       ```js
	      function findAuthor(){
	        throw new Error('couldn't find that author');
	      }
	       // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }
	       // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```
	       @method catch
	      @param {Function} onRejection
	      Useful for tooling.
	      @return {Promise}
	    */
	    'catch': function _catch(onRejection) {
	      return this.then(null, onRejection);
	    }
	  };
	  function lib$es6$promise$polyfill$$polyfill() {
	    var local;
	
	    if (typeof global !== 'undefined') {
	      local = global;
	    } else if (typeof self !== 'undefined') {
	      local = self;
	    } else {
	      try {
	        local = Function('return this')();
	      } catch (e) {
	        throw new Error('polyfill failed because global object is unavailable in this environment');
	      }
	    }
	
	    var P = local.Promise;
	
	    if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
	      return;
	    }
	
	    local.Promise = lib$es6$promise$promise$$default;
	  }
	  var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;
	
	  var lib$es6$promise$umd$$ES6Promise = {
	    'Promise': lib$es6$promise$promise$$default,
	    'polyfill': lib$es6$promise$polyfill$$default
	  };
	
	  /* global define:true module:true window: true */
	  if ("function" === 'function' && __webpack_require__(433)['amd']) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return lib$es6$promise$umd$$ES6Promise;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module['exports']) {
	    module['exports'] = lib$es6$promise$umd$$ES6Promise;
	  } else if (typeof this !== 'undefined') {
	    this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
	  }
	
	  lib$es6$promise$polyfill$$default();
	}).call(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(16).setImmediate, (function() { return this; }()), __webpack_require__(4)(module)))

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * humane.js
	 * Humanized Messages for Notifications
	 * @author Marc Harter (@wavded)
	 * @example
	 *   humane.log('hello world');
	 * @license MIT
	 * See more usage examples at: http://wavded.github.com/humane-js/
	 */
	
	;!function (name, context, definition) {
	   if (true) module.exports = definition(name, context);else if (typeof define === 'function' && _typeof(define.amd) === 'object') define(definition);else context[name] = definition(name, context);
	}('humane', undefined, function (name, context) {
	   var win = window;
	   var doc = document;
	
	   var ENV = {
	      on: function on(el, type, cb) {
	         'addEventListener' in win ? el.addEventListener(type, cb, false) : el.attachEvent('on' + type, cb);
	      },
	      off: function off(el, type, cb) {
	         'removeEventListener' in win ? el.removeEventListener(type, cb, false) : el.detachEvent('on' + type, cb);
	      },
	      bind: function bind(fn, ctx) {
	         return function () {
	            fn.apply(ctx, arguments);
	         };
	      },
	      isArray: Array.isArray || function (obj) {
	         return Object.prototype.toString.call(obj) === '[object Array]';
	      },
	      config: function config(preferred, fallback) {
	         return preferred != null ? preferred : fallback;
	      },
	      transSupport: false,
	      useFilter: /msie [678]/i.test(navigator.userAgent), // sniff, sniff
	      _checkTransition: function _checkTransition() {
	         var el = doc.createElement('div');
	         var vendors = { webkit: 'webkit', Moz: '', O: 'o', ms: 'MS' };
	
	         for (var vendor in vendors) {
	            if (vendor + 'Transition' in el.style) {
	               this.vendorPrefix = vendors[vendor];
	               this.transSupport = true;
	            }
	         }
	      }
	   };
	   ENV._checkTransition();
	
	   var Humane = function Humane(o) {
	      o || (o = {});
	      this.queue = [];
	      this.baseCls = o.baseCls || 'humane';
	      this.addnCls = o.addnCls || '';
	      this.timeout = 'timeout' in o ? o.timeout : 2500;
	      this.waitForMove = o.waitForMove || false;
	      this.clickToClose = o.clickToClose || false;
	      this.timeoutAfterMove = o.timeoutAfterMove || false;
	      this.container = o.container;
	
	      try {
	         this._setupEl();
	      } // attempt to setup elements
	      catch (e) {
	         ENV.on(win, 'load', ENV.bind(this._setupEl, this)); // dom wasn't ready, wait till ready
	      }
	   };
	
	   Humane.prototype = {
	      constructor: Humane,
	      _setupEl: function _setupEl() {
	         var el = doc.createElement('div');
	         el.style.display = 'none';
	         if (!this.container) {
	            if (doc.body) this.container = doc.body;else throw 'document.body is null';
	         }
	         this.container.appendChild(el);
	         this.el = el;
	         this.removeEvent = ENV.bind(function () {
	            var timeoutAfterMove = ENV.config(this.currentMsg.timeoutAfterMove, this.timeoutAfterMove);
	            if (!timeoutAfterMove) {
	               this.remove();
	            } else {
	               setTimeout(ENV.bind(this.remove, this), timeoutAfterMove);
	            }
	         }, this);
	
	         this.transEvent = ENV.bind(this._afterAnimation, this);
	         this._run();
	      },
	      _afterTimeout: function _afterTimeout() {
	         if (!ENV.config(this.currentMsg.waitForMove, this.waitForMove)) this.remove();else if (!this.removeEventsSet) {
	            ENV.on(doc.body, 'mousemove', this.removeEvent);
	            ENV.on(doc.body, 'click', this.removeEvent);
	            ENV.on(doc.body, 'keypress', this.removeEvent);
	            ENV.on(doc.body, 'touchstart', this.removeEvent);
	            this.removeEventsSet = true;
	         }
	      },
	      _run: function _run() {
	         if (this._animating || !this.queue.length || !this.el) return;
	
	         this._animating = true;
	         if (this.currentTimer) {
	            clearTimeout(this.currentTimer);
	            this.currentTimer = null;
	         }
	
	         var msg = this.queue.shift();
	         var clickToClose = ENV.config(msg.clickToClose, this.clickToClose);
	
	         if (clickToClose) {
	            ENV.on(this.el, 'click', this.removeEvent);
	            ENV.on(this.el, 'touchstart', this.removeEvent);
	         }
	
	         var timeout = ENV.config(msg.timeout, this.timeout);
	
	         if (timeout > 0) this.currentTimer = setTimeout(ENV.bind(this._afterTimeout, this), timeout);
	
	         if (ENV.isArray(msg.html)) msg.html = '<ul><li>' + msg.html.join('<li>') + '</ul>';
	
	         this.el.innerHTML = msg.html;
	         this.currentMsg = msg;
	         this.el.className = this.baseCls;
	         if (ENV.transSupport) {
	            this.el.style.display = 'block';
	            setTimeout(ENV.bind(this._showMsg, this), 50);
	         } else {
	            this._showMsg();
	         }
	      },
	      _setOpacity: function _setOpacity(opacity) {
	         if (ENV.useFilter) {
	            try {
	               this.el.filters.item('DXImageTransform.Microsoft.Alpha').Opacity = opacity * 100;
	            } catch (err) {}
	         } else {
	            this.el.style.opacity = String(opacity);
	         }
	      },
	      _showMsg: function _showMsg() {
	         var addnCls = ENV.config(this.currentMsg.addnCls, this.addnCls);
	         if (ENV.transSupport) {
	            this.el.className = this.baseCls + ' ' + addnCls + ' ' + this.baseCls + '-animate';
	         } else {
	            var opacity = 0;
	            this.el.className = this.baseCls + ' ' + addnCls + ' ' + this.baseCls + '-js-animate';
	            this._setOpacity(0); // reset value so hover states work
	            this.el.style.display = 'block';
	
	            var self = this;
	            var interval = setInterval(function () {
	               if (opacity < 1) {
	                  opacity += 0.1;
	                  if (opacity > 1) opacity = 1;
	                  self._setOpacity(opacity);
	               } else clearInterval(interval);
	            }, 30);
	         }
	      },
	      _hideMsg: function _hideMsg() {
	         var addnCls = ENV.config(this.currentMsg.addnCls, this.addnCls);
	         if (ENV.transSupport) {
	            this.el.className = this.baseCls + ' ' + addnCls;
	            ENV.on(this.el, ENV.vendorPrefix ? ENV.vendorPrefix + 'TransitionEnd' : 'transitionend', this.transEvent);
	         } else {
	            var opacity = 1;
	            var self = this;
	            var interval = setInterval(function () {
	               if (opacity > 0) {
	                  opacity -= 0.1;
	                  if (opacity < 0) opacity = 0;
	                  self._setOpacity(opacity);
	               } else {
	                  self.el.className = self.baseCls + ' ' + addnCls;
	                  clearInterval(interval);
	                  self._afterAnimation();
	               }
	            }, 30);
	         }
	      },
	      _afterAnimation: function _afterAnimation() {
	         if (ENV.transSupport) ENV.off(this.el, ENV.vendorPrefix ? ENV.vendorPrefix + 'TransitionEnd' : 'transitionend', this.transEvent);
	
	         if (this.currentMsg.cb) this.currentMsg.cb();
	         this.el.style.display = 'none';
	
	         this._animating = false;
	         this._run();
	      },
	      remove: function remove(e) {
	         var cb = typeof e == 'function' ? e : null;
	
	         ENV.off(doc.body, 'mousemove', this.removeEvent);
	         ENV.off(doc.body, 'click', this.removeEvent);
	         ENV.off(doc.body, 'keypress', this.removeEvent);
	         ENV.off(doc.body, 'touchstart', this.removeEvent);
	         ENV.off(this.el, 'click', this.removeEvent);
	         ENV.off(this.el, 'touchstart', this.removeEvent);
	         this.removeEventsSet = false;
	
	         if (cb && this.currentMsg) this.currentMsg.cb = cb;
	         if (this._animating) this._hideMsg();else if (cb) cb();
	      },
	      log: function log(html, o, cb, defaults) {
	         var msg = {};
	         if (defaults) for (var opt in defaults) {
	            msg[opt] = defaults[opt];
	         }if (typeof o == 'function') cb = o;else if (o) for (var opt in o) {
	            msg[opt] = o[opt];
	         }msg.html = html;
	         if (cb) msg.cb = cb;
	         this.queue.push(msg);
	         this._run();
	         return this;
	      },
	      spawn: function spawn(defaults) {
	         var self = this;
	         return function (html, o, cb) {
	            self.log.call(self, html, o, cb, defaults);
	            return self;
	         };
	      },
	      create: function create(o) {
	         return new Humane(o);
	      }
	   };
	   return new Humane();
	});

/***/ },
/* 238 */
/***/ function(module, exports) {

	"use strict";
	
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? nBytes - 1 : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];
	
	  i += d;
	
	  e = s & (1 << -nBits) - 1;
	  s >>= -nBits;
	  nBits += eLen;
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : (s ? -1 : 1) * Infinity;
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	};
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	  var i = isLE ? 0 : nBytes - 1;
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	
	  value = Math.abs(value);
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128;
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * inflection
	 * Copyright(c) 2011 Ben Lin <ben@dreamerslab.com>
	 * MIT Licensed
	 *
	 * @fileoverview
	 * A port of inflection-js to node.js module.
	 */
	
	(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    module.exports = factory();
	  } else {
	    root.inflection = factory();
	  }
	})(undefined, function () {
	
	  /**
	   * @description This is a list of nouns that use the same form for both singular and plural.
	   *              This list should remain entirely in lower case to correctly match Strings.
	   * @private
	   */
	  var uncountable_words = ['equipment', 'information', 'rice', 'money', 'species', 'series', 'fish', 'sheep', 'moose', 'deer', 'news'];
	
	  /**
	   * @description These rules translate from the singular form of a noun to its plural form.
	   * @private
	   */
	  var plural_rules = [
	
	  // do not replace if its already a plural word
	  [new RegExp('(m)en$', 'gi')], [new RegExp('(pe)ople$', 'gi')], [new RegExp('(child)ren$', 'gi')], [new RegExp('([ti])a$', 'gi')], [new RegExp('((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$', 'gi')], [new RegExp('(hive)s$', 'gi')], [new RegExp('(tive)s$', 'gi')], [new RegExp('(curve)s$', 'gi')], [new RegExp('([lr])ves$', 'gi')], [new RegExp('([^fo])ves$', 'gi')], [new RegExp('([^aeiouy]|qu)ies$', 'gi')], [new RegExp('(s)eries$', 'gi')], [new RegExp('(m)ovies$', 'gi')], [new RegExp('(x|ch|ss|sh)es$', 'gi')], [new RegExp('([m|l])ice$', 'gi')], [new RegExp('(bus)es$', 'gi')], [new RegExp('(o)es$', 'gi')], [new RegExp('(shoe)s$', 'gi')], [new RegExp('(cris|ax|test)es$', 'gi')], [new RegExp('(octop|vir)i$', 'gi')], [new RegExp('(alias|status)es$', 'gi')], [new RegExp('^(ox)en', 'gi')], [new RegExp('(vert|ind)ices$', 'gi')], [new RegExp('(matr)ices$', 'gi')], [new RegExp('^feet$', 'gi')], [new RegExp('^teeth$', 'gi')], [new RegExp('^geese$', 'gi')], [new RegExp('(quiz)zes$', 'gi')],
	
	  // original rule
	  [new RegExp('(m)an$', 'gi'), '$1en'], [new RegExp('(pe)rson$', 'gi'), '$1ople'], [new RegExp('(child)$', 'gi'), '$1ren'], [new RegExp('^(ox)$', 'gi'), '$1en'], [new RegExp('(ax|test)is$', 'gi'), '$1es'], [new RegExp('(octop|vir)us$', 'gi'), '$1i'], [new RegExp('(alias|status)$', 'gi'), '$1es'], [new RegExp('(bu)s$', 'gi'), '$1ses'], [new RegExp('(buffal|tomat|potat)o$', 'gi'), '$1oes'], [new RegExp('([ti])um$', 'gi'), '$1a'], [new RegExp('sis$', 'gi'), 'ses'], [new RegExp('(?:([^f])fe|([lr])f)$', 'gi'), '$1$2ves'], [new RegExp('(hive)$', 'gi'), '$1s'], [new RegExp('([^aeiouy]|qu)y$', 'gi'), '$1ies'], [new RegExp('(x|ch|ss|sh)$', 'gi'), '$1es'], [new RegExp('(matr|vert|ind)ix|ex$', 'gi'), '$1ices'], [new RegExp('([m|l])ouse$', 'gi'), '$1ice'], [new RegExp('^foot$', 'gi'), 'feet'], [new RegExp('^tooth$', 'gi'), 'teeth'], [new RegExp('^goose$', 'gi'), 'geese'], [new RegExp('(quiz)$', 'gi'), '$1zes'], [new RegExp('s$', 'gi'), 's'], [new RegExp('$', 'gi'), 's']];
	
	  /**
	   * @description These rules translate from the plural form of a noun to its singular form.
	   * @private
	   */
	  var singular_rules = [
	
	  // do not replace if its already a singular word
	  [new RegExp('(m)an$', 'gi')], [new RegExp('(pe)rson$', 'gi')], [new RegExp('(child)$', 'gi')], [new RegExp('^(ox)$', 'gi')], [new RegExp('(ax|test)is$', 'gi')], [new RegExp('(octop|vir)us$', 'gi')], [new RegExp('(alias|status)$', 'gi')], [new RegExp('(bu)s$', 'gi')], [new RegExp('(buffal|tomat|potat)o$', 'gi')], [new RegExp('([ti])um$', 'gi')], [new RegExp('sis$', 'gi')], [new RegExp('(?:([^f])fe|([lr])f)$', 'gi')], [new RegExp('(hive)$', 'gi')], [new RegExp('([^aeiouy]|qu)y$', 'gi')], [new RegExp('(x|ch|ss|sh)$', 'gi')], [new RegExp('(matr|vert|ind)ix|ex$', 'gi')], [new RegExp('([m|l])ouse$', 'gi')], [new RegExp('^foot$', 'gi')], [new RegExp('^tooth$', 'gi')], [new RegExp('^goose$', 'gi')], [new RegExp('(quiz)$', 'gi')],
	
	  // original rule
	  [new RegExp('(m)en$', 'gi'), '$1an'], [new RegExp('(pe)ople$', 'gi'), '$1rson'], [new RegExp('(child)ren$', 'gi'), '$1'], [new RegExp('([ti])a$', 'gi'), '$1um'], [new RegExp('((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$', 'gi'), '$1$2sis'], [new RegExp('(hive)s$', 'gi'), '$1'], [new RegExp('(tive)s$', 'gi'), '$1'], [new RegExp('(curve)s$', 'gi'), '$1'], [new RegExp('([lr])ves$', 'gi'), '$1f'], [new RegExp('([^fo])ves$', 'gi'), '$1fe'], [new RegExp('(m)ovies$', 'gi'), '$1ovie'], [new RegExp('([^aeiouy]|qu)ies$', 'gi'), '$1y'], [new RegExp('(s)eries$', 'gi'), '$1eries'], [new RegExp('(x|ch|ss|sh)es$', 'gi'), '$1'], [new RegExp('([m|l])ice$', 'gi'), '$1ouse'], [new RegExp('(bus)es$', 'gi'), '$1'], [new RegExp('(o)es$', 'gi'), '$1'], [new RegExp('(shoe)s$', 'gi'), '$1'], [new RegExp('(cris|ax|test)es$', 'gi'), '$1is'], [new RegExp('(octop|vir)i$', 'gi'), '$1us'], [new RegExp('(alias|status)es$', 'gi'), '$1'], [new RegExp('^(ox)en', 'gi'), '$1'], [new RegExp('(vert|ind)ices$', 'gi'), '$1ex'], [new RegExp('(matr)ices$', 'gi'), '$1ix'], [new RegExp('^feet$', 'gi'), 'foot'], [new RegExp('^teeth$', 'gi'), 'tooth'], [new RegExp('^geese$', 'gi'), 'goose'], [new RegExp('(quiz)zes$', 'gi'), '$1'], [new RegExp('ss$', 'gi'), 'ss'], [new RegExp('s$', 'gi'), '']];
	
	  /**
	   * @description This is a list of words that should not be capitalized for title case.
	   * @private
	   */
	  var non_titlecased_words = ['and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at', 'by', 'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over', 'with', 'for'];
	
	  /**
	   * @description These are regular expressions used for converting between String formats.
	   * @private
	   */
	  var id_suffix = new RegExp('(_ids|_id)$', 'g');
	  var underbar = new RegExp('_', 'g');
	  var space_or_underbar = new RegExp('[\ _]', 'g');
	  var uppercase = new RegExp('([A-Z])', 'g');
	  var underbar_prefix = new RegExp('^_');
	
	  var inflector = {
	
	    /**
	     * A helper method that applies rules based replacement to a String.
	     * @private
	     * @function
	     * @param {String} str String to modify and return based on the passed rules.
	     * @param {Array: [RegExp, String]} rules Regexp to match paired with String to use for replacement
	     * @param {Array: [String]} skip Strings to skip if they match
	     * @param {String} override String to return as though this method succeeded (used to conform to APIs)
	     * @returns {String} Return passed String modified by passed rules.
	     * @example
	     *
	     *     this._apply_rules( 'cows', singular_rules ); // === 'cow'
	     */
	    _apply_rules: function _apply_rules(str, rules, skip, override) {
	      if (override) {
	        str = override;
	      } else {
	        var ignore = inflector.indexOf(skip, str.toLowerCase()) > -1;
	
	        if (!ignore) {
	          var i = 0;
	          var j = rules.length;
	
	          for (; i < j; i++) {
	            if (str.match(rules[i][0])) {
	              if (rules[i][1] !== undefined) {
	                str = str.replace(rules[i][0], rules[i][1]);
	              }
	              break;
	            }
	          }
	        }
	      }
	
	      return str;
	    },
	
	    /**
	     * This lets us detect if an Array contains a given element.
	     * @public
	     * @function
	     * @param {Array} arr The subject array.
	     * @param {Object} item Object to locate in the Array.
	     * @param {Number} from_index Starts checking from this position in the Array.(optional)
	     * @param {Function} compare_func Function used to compare Array item vs passed item.(optional)
	     * @returns {Number} Return index position in the Array of the passed item.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.indexOf([ 'hi','there' ], 'guys' ); // === -1
	     *     inflection.indexOf([ 'hi','there' ], 'hi' ); // === 0
	     */
	    indexOf: function indexOf(arr, item, from_index, compare_func) {
	      if (!from_index) {
	        from_index = -1;
	      }
	
	      var index = -1;
	      var i = from_index;
	      var j = arr.length;
	
	      for (; i < j; i++) {
	        if (arr[i] === item || compare_func && compare_func(arr[i], item)) {
	          index = i;
	          break;
	        }
	      }
	
	      return index;
	    },
	
	    /**
	     * This function adds pluralization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {String} plural Overrides normal output with said String.(optional)
	     * @returns {String} Singular English language nouns are returned in plural form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.pluralize( 'person' ); // === 'people'
	     *     inflection.pluralize( 'octopus' ); // === 'octopi'
	     *     inflection.pluralize( 'Hat' ); // === 'Hats'
	     *     inflection.pluralize( 'person', 'guys' ); // === 'guys'
	     */
	    pluralize: function pluralize(str, plural) {
	      return inflector._apply_rules(str, plural_rules, uncountable_words, plural);
	    },
	
	    /**
	     * This function adds singularization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {String} singular Overrides normal output with said String.(optional)
	     * @returns {String} Plural English language nouns are returned in singular form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.singularize( 'people' ); // === 'person'
	     *     inflection.singularize( 'octopi' ); // === 'octopus'
	     *     inflection.singularize( 'Hats' ); // === 'Hat'
	     *     inflection.singularize( 'guys', 'person' ); // === 'person'
	     */
	    singularize: function singularize(str, singular) {
	      return inflector._apply_rules(str, singular_rules, uncountable_words, singular);
	    },
	
	    /**
	     * This function will pluralize or singularlize a String appropriately based on an integer value
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Number} count The number to base pluralization off of.
	     * @param {String} singular Overrides normal output with said String.(optional)
	     * @param {String} plural Overrides normal output with said String.(optional)
	     * @returns {String} English language nouns are returned in the plural or singular form based on the count.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.inflect( 'people' 1 ); // === 'person'
	     *     inflection.inflect( 'octopi' 1 ); // === 'octopus'
	     *     inflection.inflect( 'Hats' 1 ); // === 'Hat'
	     *     inflection.inflect( 'guys', 1 , 'person' ); // === 'person'
	     *     inflection.inflect( 'person', 2 ); // === 'people'
	     *     inflection.inflect( 'octopus', 2 ); // === 'octopi'
	     *     inflection.inflect( 'Hat', 2 ); // === 'Hats'
	     *     inflection.inflect( 'person', 2, null, 'guys' ); // === 'guys'
	     */
	    inflect: function inflect(str, count, singular, plural) {
	      count = parseInt(count, 10);
	
	      if (isNaN(count)) return str;
	
	      if (count === 0 || count > 1) {
	        return inflector._apply_rules(str, plural_rules, uncountable_words, plural);
	      } else {
	        return inflector._apply_rules(str, singular_rules, uncountable_words, singular);
	      }
	    },
	
	    /**
	     * This function adds camelization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Boolean} low_first_letter Default is to capitalize the first letter of the results.(optional)
	     *                                 Passing true will lowercase it.
	     * @returns {String} Lower case underscored words will be returned in camel case.
	     *                  additionally '/' is translated to '::'
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.camelize( 'message_properties' ); // === 'MessageProperties'
	     *     inflection.camelize( 'message_properties', true ); // === 'messageProperties'
	     */
	    camelize: function camelize(str, low_first_letter) {
	      var str_path = str.split('/');
	      var i = 0;
	      var j = str_path.length;
	      var str_arr, init_x, k, l, first;
	
	      for (; i < j; i++) {
	        str_arr = str_path[i].split('_');
	        k = 0;
	        l = str_arr.length;
	
	        for (; k < l; k++) {
	          if (k !== 0) {
	            str_arr[k] = str_arr[k].toLowerCase();
	          }
	
	          first = str_arr[k].charAt(0);
	          first = low_first_letter && i === 0 && k === 0 ? first.toLowerCase() : first.toUpperCase();
	          str_arr[k] = first + str_arr[k].substring(1);
	        }
	
	        str_path[i] = str_arr.join('');
	      }
	
	      return str_path.join('::');
	    },
	
	    /**
	     * This function adds underscore support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Boolean} all_upper_case Default is to lowercase and add underscore prefix.(optional)
	     *                  Passing true will return as entered.
	     * @returns {String} Camel cased words are returned as lower cased and underscored.
	     *                  additionally '::' is translated to '/'.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.underscore( 'MessageProperties' ); // === 'message_properties'
	     *     inflection.underscore( 'messageProperties' ); // === 'message_properties'
	     *     inflection.underscore( 'MP', true ); // === 'MP'
	     */
	    underscore: function underscore(str, all_upper_case) {
	      if (all_upper_case && str === str.toUpperCase()) return str;
	
	      var str_path = str.split('::');
	      var i = 0;
	      var j = str_path.length;
	
	      for (; i < j; i++) {
	        str_path[i] = str_path[i].replace(uppercase, '_$1');
	        str_path[i] = str_path[i].replace(underbar_prefix, '');
	      }
	
	      return str_path.join('/').toLowerCase();
	    },
	
	    /**
	     * This function adds humanize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Boolean} low_first_letter Default is to capitalize the first letter of the results.(optional)
	     *                                 Passing true will lowercase it.
	     * @returns {String} Lower case underscored words will be returned in humanized form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.humanize( 'message_properties' ); // === 'Message properties'
	     *     inflection.humanize( 'message_properties', true ); // === 'message properties'
	     */
	    humanize: function humanize(str, low_first_letter) {
	      str = str.toLowerCase();
	      str = str.replace(id_suffix, '');
	      str = str.replace(underbar, ' ');
	
	      if (!low_first_letter) {
	        str = inflector.capitalize(str);
	      }
	
	      return str;
	    },
	
	    /**
	     * This function adds capitalization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} All characters will be lower case and the first will be upper.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.capitalize( 'message_properties' ); // === 'Message_properties'
	     *     inflection.capitalize( 'message properties', true ); // === 'Message properties'
	     */
	    capitalize: function capitalize(str) {
	      str = str.toLowerCase();
	
	      return str.substring(0, 1).toUpperCase() + str.substring(1);
	    },
	
	    /**
	     * This function adds dasherization support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Replaces all spaces or underbars with dashes.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.dasherize( 'message_properties' ); // === 'message-properties'
	     *     inflection.dasherize( 'Message Properties' ); // === 'Message-Properties'
	     */
	    dasherize: function dasherize(str) {
	      return str.replace(space_or_underbar, '-');
	    },
	
	    /**
	     * This function adds titleize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Capitalizes words as you would for a book title.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.titleize( 'message_properties' ); // === 'Message Properties'
	     *     inflection.titleize( 'message properties to keep' ); // === 'Message Properties to Keep'
	     */
	    titleize: function titleize(str) {
	      str = str.toLowerCase().replace(underbar, ' ');
	      var str_arr = str.split(' ');
	      var i = 0;
	      var j = str_arr.length;
	      var d, k, l;
	
	      for (; i < j; i++) {
	        d = str_arr[i].split('-');
	        k = 0;
	        l = d.length;
	
	        for (; k < l; k++) {
	          if (inflector.indexOf(non_titlecased_words, d[k].toLowerCase()) < 0) {
	            d[k] = inflector.capitalize(d[k]);
	          }
	        }
	
	        str_arr[i] = d.join('-');
	      }
	
	      str = str_arr.join(' ');
	      str = str.substring(0, 1).toUpperCase() + str.substring(1);
	
	      return str;
	    },
	
	    /**
	     * This function adds demodulize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Removes module names leaving only class names.(Ruby style)
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.demodulize( 'Message::Bus::Properties' ); // === 'Properties'
	     */
	    demodulize: function demodulize(str) {
	      var str_arr = str.split('::');
	
	      return str_arr[str_arr.length - 1];
	    },
	
	    /**
	     * This function adds tableize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Return camel cased words into their underscored plural form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.tableize( 'MessageBusProperty' ); // === 'message_bus_properties'
	     */
	    tableize: function tableize(str) {
	      str = inflector.underscore(str);
	      str = inflector.pluralize(str);
	
	      return str;
	    },
	
	    /**
	     * This function adds classification support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Underscored plural nouns become the camel cased singular form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.classify( 'message_bus_properties' ); // === 'MessageBusProperty'
	     */
	    classify: function classify(str) {
	      str = inflector.camelize(str);
	      str = inflector.singularize(str);
	
	      return str;
	    },
	
	    /**
	     * This function adds foreign key support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Boolean} drop_id_ubar Default is to seperate id with an underbar at the end of the class name,
	                                   you can pass true to skip it.(optional)
	     * @returns {String} Underscored plural nouns become the camel cased singular form.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.foreign_key( 'MessageBusProperty' ); // === 'message_bus_property_id'
	     *     inflection.foreign_key( 'MessageBusProperty', true ); // === 'message_bus_propertyid'
	     */
	    foreign_key: function foreign_key(str, drop_id_ubar) {
	      str = inflector.demodulize(str);
	      str = inflector.underscore(str) + (drop_id_ubar ? '' : '_') + 'id';
	
	      return str;
	    },
	
	    /**
	     * This function adds ordinalize support to every String object.
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @returns {String} Return all found numbers their sequence like '22nd'.
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.ordinalize( 'the 1 pitch' ); // === 'the 1st pitch'
	     */
	    ordinalize: function ordinalize(str) {
	      var str_arr = str.split(' ');
	      var i = 0;
	      var j = str_arr.length;
	
	      for (; i < j; i++) {
	        var k = parseInt(str_arr[i], 10);
	
	        if (!isNaN(k)) {
	          var ltd = str_arr[i].substring(str_arr[i].length - 2);
	          var ld = str_arr[i].substring(str_arr[i].length - 1);
	          var suf = 'th';
	
	          if (ltd != '11' && ltd != '12' && ltd != '13') {
	            if (ld === '1') {
	              suf = 'st';
	            } else if (ld === '2') {
	              suf = 'nd';
	            } else if (ld === '3') {
	              suf = 'rd';
	            }
	          }
	
	          str_arr[i] += suf;
	        }
	      }
	
	      return str_arr.join(' ');
	    },
	
	    /**
	     * This function performs multiple inflection methods on a string
	     * @public
	     * @function
	     * @param {String} str The subject string.
	     * @param {Array} arr An array of inflection methods.
	     * @returns {String}
	     * @example
	     *
	     *     var inflection = require( 'inflection' );
	     *
	     *     inflection.transform( 'all job', [ 'pluralize', 'capitalize', 'dasherize' ]); // === 'All-jobs'
	     */
	    transform: function transform(str, arr) {
	      var i = 0;
	      var j = arr.length;
	
	      for (; i < j; i++) {
	        var method = arr[i];
	
	        if (this.hasOwnProperty(method)) {
	          str = this[method](str);
	        }
	      }
	
	      return str;
	    }
	  };
	
	  /**
	   * @public
	   */
	  inflector.version = '1.4.2';
	
	  return inflector;
	});

/***/ },
/* 240 */
/***/ function(module, exports) {

	'use strict';
	
	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	(function (global, factory) {
	
		"use strict";
	
		if (( false ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ? factory(global, true) : function (w) {
				if (!w.document) {
					throw new Error("jQuery requires a window with a document");
				}
				return factory(w);
			};
		} else {
			factory(global);
		}
	
		// Pass this if window is not defined yet
	})(typeof window !== "undefined" ? window : undefined, function (window, noGlobal) {
	
		// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
		// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
		// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
		// enough that all such attempts are guarded in a try block.
		"use strict";
	
		var arr = [];
	
		var document = window.document;
	
		var getProto = Object.getPrototypeOf;
	
		var _slice = arr.slice;
	
		var concat = arr.concat;
	
		var push = arr.push;
	
		var indexOf = arr.indexOf;
	
		var class2type = {};
	
		var toString = class2type.toString;
	
		var hasOwn = class2type.hasOwnProperty;
	
		var fnToString = hasOwn.toString;
	
		var ObjectFunctionString = fnToString.call(Object);
	
		var support = {};
	
		var isFunction = function isFunction(obj) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			return typeof obj === "function" && typeof obj.nodeType !== "number";
		};
	
		var isWindow = function isWindow(obj) {
			return obj != null && obj === obj.window;
		};
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval(code, doc, node) {
			doc = doc || document;
	
			var i,
			    script = doc.createElement("script");
	
			script.text = code;
			if (node) {
				for (i in preservedScriptAttributes) {
					if (node[i]) {
						script[i] = node[i];
					}
				}
			}
			doc.head.appendChild(script).parentNode.removeChild(script);
		}
	
		function toType(obj) {
			if (obj == null) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
		}
		/* global Symbol */
		// Defining this global in .eslintrc.json would create a danger of using the global
		// unguarded in another place, it seems safer to define global only for this module
	
	
		var version = "3.3.1",
	
	
		// Define a local copy of jQuery
		jQuery = function jQuery(selector, context) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init(selector, context);
		},
	
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
		jQuery.fn = jQuery.prototype = {
	
			// The current version of jQuery being used
			jquery: version,
	
			constructor: jQuery,
	
			// The default length of a jQuery object is 0
			length: 0,
	
			toArray: function toArray() {
				return _slice.call(this);
			},
	
			// Get the Nth element in the matched element set OR
			// Get the whole matched element set as a clean array
			get: function get(num) {
	
				// Return all the elements in a clean array
				if (num == null) {
					return _slice.call(this);
				}
	
				// Return just the one element from the set
				return num < 0 ? this[num + this.length] : this[num];
			},
	
			// Take an array of elements and push it onto the stack
			// (returning the new matched element set)
			pushStack: function pushStack(elems) {
	
				// Build a new jQuery matched element set
				var ret = jQuery.merge(this.constructor(), elems);
	
				// Add the old object onto the stack (as a reference)
				ret.prevObject = this;
	
				// Return the newly-formed element set
				return ret;
			},
	
			// Execute a callback for every element in the matched set.
			each: function each(callback) {
				return jQuery.each(this, callback);
			},
	
			map: function map(callback) {
				return this.pushStack(jQuery.map(this, function (elem, i) {
					return callback.call(elem, i, elem);
				}));
			},
	
			slice: function slice() {
				return this.pushStack(_slice.apply(this, arguments));
			},
	
			first: function first() {
				return this.eq(0);
			},
	
			last: function last() {
				return this.eq(-1);
			},
	
			eq: function eq(i) {
				var len = this.length,
				    j = +i + (i < 0 ? len : 0);
				return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
			},
	
			end: function end() {
				return this.prevObject || this.constructor();
			},
	
			// For internal use only.
			// Behaves like an Array's method, not like a jQuery method.
			push: push,
			sort: arr.sort,
			splice: arr.splice
		};
	
		jQuery.extend = jQuery.fn.extend = function () {
			var options,
			    name,
			    src,
			    copy,
			    copyIsArray,
			    clone,
			    target = arguments[0] || {},
			    i = 1,
			    length = arguments.length,
			    deep = false;
	
			// Handle a deep copy situation
			if (typeof target === "boolean") {
				deep = target;
	
				// Skip the boolean and the target
				target = arguments[i] || {};
				i++;
			}
	
			// Handle case when target is a string or something (possible in deep copy)
			if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object" && !isFunction(target)) {
				target = {};
			}
	
			// Extend jQuery itself if only one argument is passed
			if (i === length) {
				target = this;
				i--;
			}
	
			for (; i < length; i++) {
	
				// Only deal with non-null/undefined values
				if ((options = arguments[i]) != null) {
	
					// Extend the base object
					for (name in options) {
						src = target[name];
						copy = options[name];
	
						// Prevent never-ending loop
						if (target === copy) {
							continue;
						}
	
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
	
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && Array.isArray(src) ? src : [];
							} else {
								clone = src && jQuery.isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = jQuery.extend(deep, clone, copy);
	
							// Don't bring in undefined values
						} else if (copy !== undefined) {
							target[name] = copy;
						}
					}
				}
			}
	
			// Return the modified object
			return target;
		};
	
		jQuery.extend({
	
			// Unique for each copy of jQuery on the page
			expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
	
			// Assume jQuery is ready without the ready module
			isReady: true,
	
			error: function error(msg) {
				throw new Error(msg);
			},
	
			noop: function noop() {},
	
			isPlainObject: function isPlainObject(obj) {
				var proto, Ctor;
	
				// Detect obvious negatives
				// Use toString instead of jQuery.type to catch host objects
				if (!obj || toString.call(obj) !== "[object Object]") {
					return false;
				}
	
				proto = getProto(obj);
	
				// Objects with no prototype (e.g., `Object.create( null )`) are plain
				if (!proto) {
					return true;
				}
	
				// Objects with prototype are plain iff they were constructed by a global Object function
				Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
				return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
			},
	
			isEmptyObject: function isEmptyObject(obj) {
	
				/* eslint-disable no-unused-vars */
				// See https://github.com/eslint/eslint/issues/6125
				var name;
	
				for (name in obj) {
					return false;
				}
				return true;
			},
	
			// Evaluates a script in a global context
			globalEval: function globalEval(code) {
				DOMEval(code);
			},
	
			each: function each(obj, callback) {
				var length,
				    i = 0;
	
				if (isArrayLike(obj)) {
					length = obj.length;
					for (; i < length; i++) {
						if (callback.call(obj[i], i, obj[i]) === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (callback.call(obj[i], i, obj[i]) === false) {
							break;
						}
					}
				}
	
				return obj;
			},
	
			// Support: Android <=4.0 only
			trim: function trim(text) {
				return text == null ? "" : (text + "").replace(rtrim, "");
			},
	
			// results is for internal usage only
			makeArray: function makeArray(arr, results) {
				var ret = results || [];
	
				if (arr != null) {
					if (isArrayLike(Object(arr))) {
						jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
					} else {
						push.call(ret, arr);
					}
				}
	
				return ret;
			},
	
			inArray: function inArray(elem, arr, i) {
				return arr == null ? -1 : indexOf.call(arr, elem, i);
			},
	
			// Support: Android <=4.0 only, PhantomJS 1 only
			// push.apply(_, arraylike) throws on ancient WebKit
			merge: function merge(first, second) {
				var len = +second.length,
				    j = 0,
				    i = first.length;
	
				for (; j < len; j++) {
					first[i++] = second[j];
				}
	
				first.length = i;
	
				return first;
			},
	
			grep: function grep(elems, callback, invert) {
				var callbackInverse,
				    matches = [],
				    i = 0,
				    length = elems.length,
				    callbackExpect = !invert;
	
				// Go through the array, only saving the items
				// that pass the validator function
				for (; i < length; i++) {
					callbackInverse = !callback(elems[i], i);
					if (callbackInverse !== callbackExpect) {
						matches.push(elems[i]);
					}
				}
	
				return matches;
			},
	
			// arg is for internal usage only
			map: function map(elems, callback, arg) {
				var length,
				    value,
				    i = 0,
				    ret = [];
	
				// Go through the array, translating each of the items to their new values
				if (isArrayLike(elems)) {
					length = elems.length;
					for (; i < length; i++) {
						value = callback(elems[i], i, arg);
	
						if (value != null) {
							ret.push(value);
						}
					}
	
					// Go through every key on the object,
				} else {
					for (i in elems) {
						value = callback(elems[i], i, arg);
	
						if (value != null) {
							ret.push(value);
						}
					}
				}
	
				// Flatten any nested arrays
				return concat.apply([], ret);
			},
	
			// A global GUID counter for objects
			guid: 1,
	
			// jQuery.support is not used in Core but other projects attach their
			// properties to it so it needs to exist.
			support: support
		});
	
		if (typeof Symbol === "function") {
			jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
		}
	
		// Populate the class2type map
		jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (i, name) {
			class2type["[object " + name + "]"] = name.toLowerCase();
		});
	
		function isArrayLike(obj) {
	
			// Support: real iOS 8.2 only (not reproducible in simulator)
			// `in` check used to prevent JIT error (gh-2145)
			// hasOwn isn't used here due to false negatives
			// regarding Nodelist length in IE
			var length = !!obj && "length" in obj && obj.length,
			    type = toType(obj);
	
			if (isFunction(obj) || isWindow(obj)) {
				return false;
			}
	
			return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
		}
		var Sizzle =
		/*!
	  * Sizzle CSS Selector Engine v2.3.3
	  * https://sizzlejs.com/
	  *
	  * Copyright jQuery Foundation and other contributors
	  * Released under the MIT license
	  * http://jquery.org/license
	  *
	  * Date: 2016-08-08
	  */
		function (window) {
	
			var i,
			    support,
			    Expr,
			    getText,
			    isXML,
			    tokenize,
			    compile,
			    select,
			    outermostContext,
			    sortInput,
			    hasDuplicate,
	
	
			// Local document vars
			setDocument,
			    document,
			    docElem,
			    documentIsHTML,
			    rbuggyQSA,
			    rbuggyMatches,
			    matches,
			    contains,
	
	
			// Instance-specific data
			expando = "sizzle" + 1 * new Date(),
			    preferredDoc = window.document,
			    dirruns = 0,
			    done = 0,
			    classCache = createCache(),
			    tokenCache = createCache(),
			    compilerCache = createCache(),
			    sortOrder = function sortOrder(a, b) {
				if (a === b) {
					hasDuplicate = true;
				}
				return 0;
			},
	
	
			// Instance methods
			hasOwn = {}.hasOwnProperty,
			    arr = [],
			    pop = arr.pop,
			    push_native = arr.push,
			    push = arr.push,
			    slice = arr.slice,
	
			// Use a stripped-down indexOf as it's faster than native
			// https://jsperf.com/thor-indexof-vs-for/5
			indexOf = function indexOf(list, elem) {
				var i = 0,
				    len = list.length;
				for (; i < len; i++) {
					if (list[i] === elem) {
						return i;
					}
				}
				return -1;
			},
			    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
	
			// Regular expressions
	
			// http://www.w3.org/TR/css3-selectors/#whitespace
			whitespace = "[\\x20\\t\\r\\n\\f]",
	
	
			// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
			identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
	
			// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
			attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
			    pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" + ")\\)|)",
	
	
			// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
			rwhitespace = new RegExp(whitespace + "+", "g"),
			    rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
			    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
			    rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
			    rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
			    rpseudo = new RegExp(pseudos),
			    ridentifier = new RegExp("^" + identifier + "$"),
			    matchExpr = {
				"ID": new RegExp("^#(" + identifier + ")"),
				"CLASS": new RegExp("^\\.(" + identifier + ")"),
				"TAG": new RegExp("^(" + identifier + "|[*])"),
				"ATTR": new RegExp("^" + attributes),
				"PSEUDO": new RegExp("^" + pseudos),
				"CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
				"bool": new RegExp("^(?:" + booleans + ")$", "i"),
				// For use in libraries implementing .is()
				// We use this for POS matching in `select`
				"needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
			},
			    rinputs = /^(?:input|select|textarea|button)$/i,
			    rheader = /^h\d$/i,
			    rnative = /^[^{]+\{\s*\[native \w/,
	
	
			// Easily-parseable/retrievable ID or TAG or CLASS selectors
			rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
			    rsibling = /[+~]/,
	
	
			// CSS escapes
			// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
			runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
			    funescape = function funescape(_, escaped, escapedWhitespace) {
				var high = "0x" + escaped - 0x10000;
				// NaN means non-codepoint
				// Support: Firefox<24
				// Workaround erroneous numeric interpretation of +"0x"
				return high !== high || escapedWhitespace ? escaped : high < 0 ?
				// BMP codepoint
				String.fromCharCode(high + 0x10000) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
			},
	
	
			// CSS string/identifier serialization
			// https://drafts.csswg.org/cssom/#common-serializing-idioms
			rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
			    fcssescape = function fcssescape(ch, asCodePoint) {
				if (asCodePoint) {
	
					// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
					if (ch === "\0") {
						return "\uFFFD";
					}
	
					// Control characters and (dependent upon position) numbers get escaped as code points
					return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
				}
	
				// Other potentially-special ASCII characters get backslash-escaped
				return "\\" + ch;
			},
	
	
			// Used for iframes
			// See setDocument()
			// Removing the function wrapper causes a "Permission Denied"
			// error in IE
			unloadHandler = function unloadHandler() {
				setDocument();
			},
			    disabledAncestor = addCombinator(function (elem) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			}, { dir: "parentNode", next: "legend" });
	
			// Optimize for push.apply( _, NodeList )
			try {
				push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
				// Support: Android<4.0
				// Detect silently failing push.apply
				arr[preferredDoc.childNodes.length].nodeType;
			} catch (e) {
				push = { apply: arr.length ?
	
					// Leverage slice if possible
					function (target, els) {
						push_native.apply(target, slice.call(els));
					} :
	
					// Support: IE<9
					// Otherwise append directly
					function (target, els) {
						var j = target.length,
						    i = 0;
						// Can't trust NodeList.length
						while (target[j++] = els[i++]) {}
						target.length = j - 1;
					}
				};
			}
	
			function Sizzle(selector, context, results, seed) {
				var m,
				    i,
				    elem,
				    nid,
				    match,
				    groups,
				    newSelector,
				    newContext = context && context.ownerDocument,
	
	
				// nodeType defaults to 9, since context defaults to document
				nodeType = context ? context.nodeType : 9;
	
				results = results || [];
	
				// Return early from calls with invalid selector or context
				if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
	
					return results;
				}
	
				// Try to shortcut find operations (as opposed to filters) in HTML documents
				if (!seed) {
	
					if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
						setDocument(context);
					}
					context = context || document;
	
					if (documentIsHTML) {
	
						// If the selector is sufficiently simple, try using a "get*By*" DOM method
						// (excepting DocumentFragment context, where the methods don't exist)
						if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
	
							// ID selector
							if (m = match[1]) {
	
								// Document context
								if (nodeType === 9) {
									if (elem = context.getElementById(m)) {
	
										// Support: IE, Opera, Webkit
										// TODO: identify versions
										// getElementById can match elements by name instead of ID
										if (elem.id === m) {
											results.push(elem);
											return results;
										}
									} else {
										return results;
									}
	
									// Element context
								} else {
	
									// Support: IE, Opera, Webkit
									// TODO: identify versions
									// getElementById can match elements by name instead of ID
									if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
	
										results.push(elem);
										return results;
									}
								}
	
								// Type selector
							} else if (match[2]) {
								push.apply(results, context.getElementsByTagName(selector));
								return results;
	
								// Class selector
							} else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
	
								push.apply(results, context.getElementsByClassName(m));
								return results;
							}
						}
	
						// Take advantage of querySelectorAll
						if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
	
							if (nodeType !== 1) {
								newContext = context;
								newSelector = selector;
	
								// qSA looks outside Element context, which is not what we want
								// Thanks to Andrew Dupont for this workaround technique
								// Support: IE <=8
								// Exclude object elements
							} else if (context.nodeName.toLowerCase() !== "object") {
	
								// Capture the context ID, setting it first if necessary
								if (nid = context.getAttribute("id")) {
									nid = nid.replace(rcssescape, fcssescape);
								} else {
									context.setAttribute("id", nid = expando);
								}
	
								// Prefix every selector in the list
								groups = tokenize(selector);
								i = groups.length;
								while (i--) {
									groups[i] = "#" + nid + " " + toSelector(groups[i]);
								}
								newSelector = groups.join(",");
	
								// Expand context for sibling selectors
								newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
							}
	
							if (newSelector) {
								try {
									push.apply(results, newContext.querySelectorAll(newSelector));
									return results;
								} catch (qsaError) {} finally {
									if (nid === expando) {
										context.removeAttribute("id");
									}
								}
							}
						}
					}
				}
	
				// All others
				return select(selector.replace(rtrim, "$1"), context, results, seed);
			}
	
			/**
	   * Create key-value caches of limited size
	   * @returns {function(string, object)} Returns the Object data after storing it on itself with
	   *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	   *	deleting the oldest entry
	   */
			function createCache() {
				var keys = [];
	
				function cache(key, value) {
					// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
					if (keys.push(key + " ") > Expr.cacheLength) {
						// Only keep the most recent entries
						delete cache[keys.shift()];
					}
					return cache[key + " "] = value;
				}
				return cache;
			}
	
			/**
	   * Mark a function for special use by Sizzle
	   * @param {Function} fn The function to mark
	   */
			function markFunction(fn) {
				fn[expando] = true;
				return fn;
			}
	
			/**
	   * Support testing using an element
	   * @param {Function} fn Passed the created element and returns a boolean result
	   */
			function assert(fn) {
				var el = document.createElement("fieldset");
	
				try {
					return !!fn(el);
				} catch (e) {
					return false;
				} finally {
					// Remove from its parent by default
					if (el.parentNode) {
						el.parentNode.removeChild(el);
					}
					// release memory in IE
					el = null;
				}
			}
	
			/**
	   * Adds the same handler for all of the specified attrs
	   * @param {String} attrs Pipe-separated list of attributes
	   * @param {Function} handler The method that will be applied
	   */
			function addHandle(attrs, handler) {
				var arr = attrs.split("|"),
				    i = arr.length;
	
				while (i--) {
					Expr.attrHandle[arr[i]] = handler;
				}
			}
	
			/**
	   * Checks document order of two siblings
	   * @param {Element} a
	   * @param {Element} b
	   * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	   */
			function siblingCheck(a, b) {
				var cur = b && a,
				    diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
	
				// Use IE sourceIndex if available on both nodes
				if (diff) {
					return diff;
				}
	
				// Check if b follows a
				if (cur) {
					while (cur = cur.nextSibling) {
						if (cur === b) {
							return -1;
						}
					}
				}
	
				return a ? 1 : -1;
			}
	
			/**
	   * Returns a function to use in pseudos for input types
	   * @param {String} type
	   */
			function createInputPseudo(type) {
				return function (elem) {
					var name = elem.nodeName.toLowerCase();
					return name === "input" && elem.type === type;
				};
			}
	
			/**
	   * Returns a function to use in pseudos for buttons
	   * @param {String} type
	   */
			function createButtonPseudo(type) {
				return function (elem) {
					var name = elem.nodeName.toLowerCase();
					return (name === "input" || name === "button") && elem.type === type;
				};
			}
	
			/**
	   * Returns a function to use in pseudos for :enabled/:disabled
	   * @param {Boolean} disabled true for :disabled; false for :enabled
	   */
			function createDisabledPseudo(disabled) {
	
				// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
				return function (elem) {
	
					// Only certain elements can match :enabled or :disabled
					// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
					// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
					if ("form" in elem) {
	
						// Check for inherited disabledness on relevant non-disabled elements:
						// * listed form-associated elements in a disabled fieldset
						//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
						//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
						// * option elements in a disabled optgroup
						//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
						// All such elements have a "form" property.
						if (elem.parentNode && elem.disabled === false) {
	
							// Option elements defer to a parent optgroup if present
							if ("label" in elem) {
								if ("label" in elem.parentNode) {
									return elem.parentNode.disabled === disabled;
								} else {
									return elem.disabled === disabled;
								}
							}
	
							// Support: IE 6 - 11
							// Use the isDisabled shortcut property to check for disabled fieldset ancestors
							return elem.isDisabled === disabled ||
	
							// Where there is no isDisabled, check manually
							/* jshint -W018 */
							elem.isDisabled !== !disabled && disabledAncestor(elem) === disabled;
						}
	
						return elem.disabled === disabled;
	
						// Try to winnow out elements that can't be disabled before trusting the disabled property.
						// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
						// even exist on them, let alone have a boolean value.
					} else if ("label" in elem) {
						return elem.disabled === disabled;
					}
	
					// Remaining elements are neither :enabled nor :disabled
					return false;
				};
			}
	
			/**
	   * Returns a function to use in pseudos for positionals
	   * @param {Function} fn
	   */
			function createPositionalPseudo(fn) {
				return markFunction(function (argument) {
					argument = +argument;
					return markFunction(function (seed, matches) {
						var j,
						    matchIndexes = fn([], seed.length, argument),
						    i = matchIndexes.length;
	
						// Match elements found at the specified indexes
						while (i--) {
							if (seed[j = matchIndexes[i]]) {
								seed[j] = !(matches[j] = seed[j]);
							}
						}
					});
				});
			}
	
			/**
	   * Checks a node for validity as a Sizzle context
	   * @param {Element|Object=} context
	   * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	   */
			function testContext(context) {
				return context && typeof context.getElementsByTagName !== "undefined" && context;
			}
	
			// Expose support vars for convenience
			support = Sizzle.support = {};
	
			/**
	   * Detects XML nodes
	   * @param {Element|Object} elem An element or a document
	   * @returns {Boolean} True iff elem is a non-HTML XML node
	   */
			isXML = Sizzle.isXML = function (elem) {
				// documentElement is verified for cases where it doesn't yet exist
				// (such as loading iframes in IE - #4833)
				var documentElement = elem && (elem.ownerDocument || elem).documentElement;
				return documentElement ? documentElement.nodeName !== "HTML" : false;
			};
	
			/**
	   * Sets document-related variables once based on the current document
	   * @param {Element|Object} [doc] An element or document object to use to set the document
	   * @returns {Object} Returns the current document
	   */
			setDocument = Sizzle.setDocument = function (node) {
				var hasCompare,
				    subWindow,
				    doc = node ? node.ownerDocument || node : preferredDoc;
	
				// Return early if doc is invalid or already selected
				if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
					return document;
				}
	
				// Update global variables
				document = doc;
				docElem = document.documentElement;
				documentIsHTML = !isXML(document);
	
				// Support: IE 9-11, Edge
				// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
				if (preferredDoc !== document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
	
					// Support: IE 11, Edge
					if (subWindow.addEventListener) {
						subWindow.addEventListener("unload", unloadHandler, false);
	
						// Support: IE 9 - 10 only
					} else if (subWindow.attachEvent) {
						subWindow.attachEvent("onunload", unloadHandler);
					}
				}
	
				/* Attributes
	   ---------------------------------------------------------------------- */
	
				// Support: IE<8
				// Verify that getAttribute really returns attributes and not properties
				// (excepting IE8 booleans)
				support.attributes = assert(function (el) {
					el.className = "i";
					return !el.getAttribute("className");
				});
	
				/* getElement(s)By*
	   ---------------------------------------------------------------------- */
	
				// Check if getElementsByTagName("*") returns only elements
				support.getElementsByTagName = assert(function (el) {
					el.appendChild(document.createComment(""));
					return !el.getElementsByTagName("*").length;
				});
	
				// Support: IE<9
				support.getElementsByClassName = rnative.test(document.getElementsByClassName);
	
				// Support: IE<10
				// Check if getElementById returns elements by name
				// The broken getElementById methods don't pick up programmatically-set names,
				// so use a roundabout getElementsByName test
				support.getById = assert(function (el) {
					docElem.appendChild(el).id = expando;
					return !document.getElementsByName || !document.getElementsByName(expando).length;
				});
	
				// ID filter and find
				if (support.getById) {
					Expr.filter["ID"] = function (id) {
						var attrId = id.replace(runescape, funescape);
						return function (elem) {
							return elem.getAttribute("id") === attrId;
						};
					};
					Expr.find["ID"] = function (id, context) {
						if (typeof context.getElementById !== "undefined" && documentIsHTML) {
							var elem = context.getElementById(id);
							return elem ? [elem] : [];
						}
					};
				} else {
					Expr.filter["ID"] = function (id) {
						var attrId = id.replace(runescape, funescape);
						return function (elem) {
							var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
							return node && node.value === attrId;
						};
					};
	
					// Support: IE 6 - 7 only
					// getElementById is not reliable as a find shortcut
					Expr.find["ID"] = function (id, context) {
						if (typeof context.getElementById !== "undefined" && documentIsHTML) {
							var node,
							    i,
							    elems,
							    elem = context.getElementById(id);
	
							if (elem) {
	
								// Verify the id attribute
								node = elem.getAttributeNode("id");
								if (node && node.value === id) {
									return [elem];
								}
	
								// Fall back on getElementsByName
								elems = context.getElementsByName(id);
								i = 0;
								while (elem = elems[i++]) {
									node = elem.getAttributeNode("id");
									if (node && node.value === id) {
										return [elem];
									}
								}
							}
	
							return [];
						}
					};
				}
	
				// Tag
				Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
					if (typeof context.getElementsByTagName !== "undefined") {
						return context.getElementsByTagName(tag);
	
						// DocumentFragment nodes don't have gEBTN
					} else if (support.qsa) {
						return context.querySelectorAll(tag);
					}
				} : function (tag, context) {
					var elem,
					    tmp = [],
					    i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName(tag);
	
					// Filter out possible comments
					if (tag === "*") {
						while (elem = results[i++]) {
							if (elem.nodeType === 1) {
								tmp.push(elem);
							}
						}
	
						return tmp;
					}
					return results;
				};
	
				// Class
				Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
					if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
						return context.getElementsByClassName(className);
					}
				};
	
				/* QSA/matchesSelector
	   ---------------------------------------------------------------------- */
	
				// QSA and matchesSelector support
	
				// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
				rbuggyMatches = [];
	
				// qSa(:focus) reports false when true (Chrome 21)
				// We allow this because of a bug in IE8/9 that throws an error
				// whenever `document.activeElement` is accessed on an iframe
				// So, we allow :focus to pass through QSA all the time to avoid the IE error
				// See https://bugs.jquery.com/ticket/13378
				rbuggyQSA = [];
	
				if (support.qsa = rnative.test(document.querySelectorAll)) {
					// Build QSA regex
					// Regex strategy adopted from Diego Perini
					assert(function (el) {
						// Select is set to empty string on purpose
						// This is to test IE's treatment of not explicitly
						// setting a boolean content attribute,
						// since its presence should be enough
						// https://bugs.jquery.com/ticket/12359
						docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
	
						// Support: IE8, Opera 11-12.16
						// Nothing should be selected when empty strings follow ^= or $= or *=
						// The test attribute must be unknown in Opera but "safe" for WinRT
						// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
						if (el.querySelectorAll("[msallowcapture^='']").length) {
							rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
						}
	
						// Support: IE8
						// Boolean attributes and "value" are not treated correctly
						if (!el.querySelectorAll("[selected]").length) {
							rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
						}
	
						// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
						if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
							rbuggyQSA.push("~=");
						}
	
						// Webkit/Opera - :checked should return selected option elements
						// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
						// IE8 throws error here and will not see later tests
						if (!el.querySelectorAll(":checked").length) {
							rbuggyQSA.push(":checked");
						}
	
						// Support: Safari 8+, iOS 8+
						// https://bugs.webkit.org/show_bug.cgi?id=136851
						// In-page `selector#id sibling-combinator selector` fails
						if (!el.querySelectorAll("a#" + expando + "+*").length) {
							rbuggyQSA.push(".#.+[+~]");
						}
					});
	
					assert(function (el) {
						el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";
	
						// Support: Windows 8 Native Apps
						// The type and name attributes are restricted during .innerHTML assignment
						var input = document.createElement("input");
						input.setAttribute("type", "hidden");
						el.appendChild(input).setAttribute("name", "D");
	
						// Support: IE8
						// Enforce case-sensitivity of name attribute
						if (el.querySelectorAll("[name=d]").length) {
							rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
						}
	
						// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
						// IE8 throws error here and will not see later tests
						if (el.querySelectorAll(":enabled").length !== 2) {
							rbuggyQSA.push(":enabled", ":disabled");
						}
	
						// Support: IE9-11+
						// IE's :disabled selector does not pick up the children of disabled fieldsets
						docElem.appendChild(el).disabled = true;
						if (el.querySelectorAll(":disabled").length !== 2) {
							rbuggyQSA.push(":enabled", ":disabled");
						}
	
						// Opera 10-11 does not throw on post-comma invalid pseudos
						el.querySelectorAll("*,:x");
						rbuggyQSA.push(",.*:");
					});
				}
	
				if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {
	
					assert(function (el) {
						// Check to see if it's possible to do matchesSelector
						// on a disconnected node (IE 9)
						support.disconnectedMatch = matches.call(el, "*");
	
						// This should fail with an exception
						// Gecko does not error, returns false instead
						matches.call(el, "[s!='']:x");
						rbuggyMatches.push("!=", pseudos);
					});
				}
	
				rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
				rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
	
				/* Contains
	   ---------------------------------------------------------------------- */
				hasCompare = rnative.test(docElem.compareDocumentPosition);
	
				// Element contains another
				// Purposefully self-exclusive
				// As in, an element does not contain itself
				contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
					var adown = a.nodeType === 9 ? a.documentElement : a,
					    bup = b && b.parentNode;
					return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
				} : function (a, b) {
					if (b) {
						while (b = b.parentNode) {
							if (b === a) {
								return true;
							}
						}
					}
					return false;
				};
	
				/* Sorting
	   ---------------------------------------------------------------------- */
	
				// Document order sorting
				sortOrder = hasCompare ? function (a, b) {
	
					// Flag for duplicate removal
					if (a === b) {
						hasDuplicate = true;
						return 0;
					}
	
					// Sort on method existence if only one input has compareDocumentPosition
					var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
					if (compare) {
						return compare;
					}
	
					// Calculate position if both inputs belong to the same document
					compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) :
	
					// Otherwise we know they are disconnected
					1;
	
					// Disconnected nodes
					if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
	
						// Choose the first element that is related to our preferred document
						if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
							return -1;
						}
						if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
							return 1;
						}
	
						// Maintain original order
						return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
					}
	
					return compare & 4 ? -1 : 1;
				} : function (a, b) {
					// Exit early if the nodes are identical
					if (a === b) {
						hasDuplicate = true;
						return 0;
					}
	
					var cur,
					    i = 0,
					    aup = a.parentNode,
					    bup = b.parentNode,
					    ap = [a],
					    bp = [b];
	
					// Parentless nodes are either documents or disconnected
					if (!aup || !bup) {
						return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
	
						// If the nodes are siblings, we can do a quick check
					} else if (aup === bup) {
						return siblingCheck(a, b);
					}
	
					// Otherwise we need full lists of their ancestors for comparison
					cur = a;
					while (cur = cur.parentNode) {
						ap.unshift(cur);
					}
					cur = b;
					while (cur = cur.parentNode) {
						bp.unshift(cur);
					}
	
					// Walk down the tree looking for a discrepancy
					while (ap[i] === bp[i]) {
						i++;
					}
	
					return i ?
					// Do a sibling check if the nodes have a common ancestor
					siblingCheck(ap[i], bp[i]) :
	
					// Otherwise nodes in our document sort first
					ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
				};
	
				return document;
			};
	
			Sizzle.matches = function (expr, elements) {
				return Sizzle(expr, null, null, elements);
			};
	
			Sizzle.matchesSelector = function (elem, expr) {
				// Set document vars if needed
				if ((elem.ownerDocument || elem) !== document) {
					setDocument(elem);
				}
	
				// Make sure that attribute selectors are quoted
				expr = expr.replace(rattributeQuotes, "='$1']");
	
				if (support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
	
					try {
						var ret = matches.call(elem, expr);
	
						// IE 9's matchesSelector returns false on disconnected nodes
						if (ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11) {
							return ret;
						}
					} catch (e) {}
				}
	
				return Sizzle(expr, document, null, [elem]).length > 0;
			};
	
			Sizzle.contains = function (context, elem) {
				// Set document vars if needed
				if ((context.ownerDocument || context) !== document) {
					setDocument(context);
				}
				return contains(context, elem);
			};
	
			Sizzle.attr = function (elem, name) {
				// Set document vars if needed
				if ((elem.ownerDocument || elem) !== document) {
					setDocument(elem);
				}
	
				var fn = Expr.attrHandle[name.toLowerCase()],
	
				// Don't get fooled by Object.prototype properties (jQuery #13807)
				val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
	
				return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
			};
	
			Sizzle.escape = function (sel) {
				return (sel + "").replace(rcssescape, fcssescape);
			};
	
			Sizzle.error = function (msg) {
				throw new Error("Syntax error, unrecognized expression: " + msg);
			};
	
			/**
	   * Document sorting and removing duplicates
	   * @param {ArrayLike} results
	   */
			Sizzle.uniqueSort = function (results) {
				var elem,
				    duplicates = [],
				    j = 0,
				    i = 0;
	
				// Unless we *know* we can detect duplicates, assume their presence
				hasDuplicate = !support.detectDuplicates;
				sortInput = !support.sortStable && results.slice(0);
				results.sort(sortOrder);
	
				if (hasDuplicate) {
					while (elem = results[i++]) {
						if (elem === results[i]) {
							j = duplicates.push(i);
						}
					}
					while (j--) {
						results.splice(duplicates[j], 1);
					}
				}
	
				// Clear input after sorting to release objects
				// See https://github.com/jquery/sizzle/pull/225
				sortInput = null;
	
				return results;
			};
	
			/**
	   * Utility function for retrieving the text value of an array of DOM nodes
	   * @param {Array|Element} elem
	   */
			getText = Sizzle.getText = function (elem) {
				var node,
				    ret = "",
				    i = 0,
				    nodeType = elem.nodeType;
	
				if (!nodeType) {
					// If no nodeType, this is expected to be an array
					while (node = elem[i++]) {
						// Do not traverse comment nodes
						ret += getText(node);
					}
				} else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
					// Use textContent for elements
					// innerText usage removed for consistency of new lines (jQuery #11153)
					if (typeof elem.textContent === "string") {
						return elem.textContent;
					} else {
						// Traverse its children
						for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
							ret += getText(elem);
						}
					}
				} else if (nodeType === 3 || nodeType === 4) {
					return elem.nodeValue;
				}
				// Do not include comment or processing instruction nodes
	
				return ret;
			};
	
			Expr = Sizzle.selectors = {
	
				// Can be adjusted by the user
				cacheLength: 50,
	
				createPseudo: markFunction,
	
				match: matchExpr,
	
				attrHandle: {},
	
				find: {},
	
				relative: {
					">": { dir: "parentNode", first: true },
					" ": { dir: "parentNode" },
					"+": { dir: "previousSibling", first: true },
					"~": { dir: "previousSibling" }
				},
	
				preFilter: {
					"ATTR": function ATTR(match) {
						match[1] = match[1].replace(runescape, funescape);
	
						// Move the given value to match[3] whether quoted or unquoted
						match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
	
						if (match[2] === "~=") {
							match[3] = " " + match[3] + " ";
						}
	
						return match.slice(0, 4);
					},
	
					"CHILD": function CHILD(match) {
						/* matches from matchExpr["CHILD"]
	     	1 type (only|nth|...)
	     	2 what (child|of-type)
	     	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
	     	4 xn-component of xn+y argument ([+-]?\d*n|)
	     	5 sign of xn-component
	     	6 x of xn-component
	     	7 sign of y-component
	     	8 y of y-component
	     */
						match[1] = match[1].toLowerCase();
	
						if (match[1].slice(0, 3) === "nth") {
							// nth-* requires argument
							if (!match[3]) {
								Sizzle.error(match[0]);
							}
	
							// numeric x and y parameters for Expr.filter.CHILD
							// remember that false/true cast respectively to 0/1
							match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
							match[5] = +(match[7] + match[8] || match[3] === "odd");
	
							// other types prohibit arguments
						} else if (match[3]) {
							Sizzle.error(match[0]);
						}
	
						return match;
					},
	
					"PSEUDO": function PSEUDO(match) {
						var excess,
						    unquoted = !match[6] && match[2];
	
						if (matchExpr["CHILD"].test(match[0])) {
							return null;
						}
	
						// Accept quoted arguments as-is
						if (match[3]) {
							match[2] = match[4] || match[5] || "";
	
							// Strip excess characters from unquoted arguments
						} else if (unquoted && rpseudo.test(unquoted) && (
						// Get excess from tokenize (recursively)
						excess = tokenize(unquoted, true)) && (
						// advance to the next closing parenthesis
						excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
	
							// excess is a negative index
							match[0] = match[0].slice(0, excess);
							match[2] = unquoted.slice(0, excess);
						}
	
						// Return only captures needed by the pseudo filter method (type and argument)
						return match.slice(0, 3);
					}
				},
	
				filter: {
	
					"TAG": function TAG(nodeNameSelector) {
						var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
						return nodeNameSelector === "*" ? function () {
							return true;
						} : function (elem) {
							return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
						};
					},
	
					"CLASS": function CLASS(className) {
						var pattern = classCache[className + " "];
	
						return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
							return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
						});
					},
	
					"ATTR": function ATTR(name, operator, check) {
						return function (elem) {
							var result = Sizzle.attr(elem, name);
	
							if (result == null) {
								return operator === "!=";
							}
							if (!operator) {
								return true;
							}
	
							result += "";
	
							return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
						};
					},
	
					"CHILD": function CHILD(type, what, argument, first, last) {
						var simple = type.slice(0, 3) !== "nth",
						    forward = type.slice(-4) !== "last",
						    ofType = what === "of-type";
	
						return first === 1 && last === 0 ?
	
						// Shortcut for :nth-*(n)
						function (elem) {
							return !!elem.parentNode;
						} : function (elem, context, xml) {
							var cache,
							    uniqueCache,
							    outerCache,
							    node,
							    nodeIndex,
							    start,
							    dir = simple !== forward ? "nextSibling" : "previousSibling",
							    parent = elem.parentNode,
							    name = ofType && elem.nodeName.toLowerCase(),
							    useCache = !xml && !ofType,
							    diff = false;
	
							if (parent) {
	
								// :(first|last|only)-(child|of-type)
								if (simple) {
									while (dir) {
										node = elem;
										while (node = node[dir]) {
											if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
	
												return false;
											}
										}
										// Reverse direction for :only-* (if we haven't yet done so)
										start = dir = type === "only" && !start && "nextSibling";
									}
									return true;
								}
	
								start = [forward ? parent.firstChild : parent.lastChild];
	
								// non-xml :nth-child(...) stores cache data on `parent`
								if (forward && useCache) {
	
									// Seek `elem` from a previously-cached index
	
									// ...in a gzip-friendly way
									node = parent;
									outerCache = node[expando] || (node[expando] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
									cache = uniqueCache[type] || [];
									nodeIndex = cache[0] === dirruns && cache[1];
									diff = nodeIndex && cache[2];
									node = nodeIndex && parent.childNodes[nodeIndex];
	
									while (node = ++nodeIndex && node && node[dir] || (
	
									// Fallback to seeking `elem` from the start
									diff = nodeIndex = 0) || start.pop()) {
	
										// When found, cache indexes on `parent` and break
										if (node.nodeType === 1 && ++diff && node === elem) {
											uniqueCache[type] = [dirruns, nodeIndex, diff];
											break;
										}
									}
								} else {
									// Use previously-cached element index if available
									if (useCache) {
										// ...in a gzip-friendly way
										node = elem;
										outerCache = node[expando] || (node[expando] = {});
	
										// Support: IE <9 only
										// Defend against cloned attroperties (jQuery gh-1709)
										uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
										cache = uniqueCache[type] || [];
										nodeIndex = cache[0] === dirruns && cache[1];
										diff = nodeIndex;
									}
	
									// xml :nth-child(...)
									// or :nth-last-child(...) or :nth(-last)?-of-type(...)
									if (diff === false) {
										// Use the same loop as above to seek `elem` from the start
										while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	
											if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
	
												// Cache the index of each encountered element
												if (useCache) {
													outerCache = node[expando] || (node[expando] = {});
	
													// Support: IE <9 only
													// Defend against cloned attroperties (jQuery gh-1709)
													uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
													uniqueCache[type] = [dirruns, diff];
												}
	
												if (node === elem) {
													break;
												}
											}
										}
									}
								}
	
								// Incorporate the offset, then check against cycle size
								diff -= last;
								return diff === first || diff % first === 0 && diff / first >= 0;
							}
						};
					},
	
					"PSEUDO": function PSEUDO(pseudo, argument) {
						// pseudo-class names are case-insensitive
						// http://www.w3.org/TR/selectors/#pseudo-classes
						// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
						// Remember that setFilters inherits from pseudos
						var args,
						    fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
	
						// The user may use createPseudo to indicate that
						// arguments are needed to create the filter function
						// just as Sizzle does
						if (fn[expando]) {
							return fn(argument);
						}
	
						// But maintain support for old signatures
						if (fn.length > 1) {
							args = [pseudo, pseudo, "", argument];
							return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
								var idx,
								    matched = fn(seed, argument),
								    i = matched.length;
								while (i--) {
									idx = indexOf(seed, matched[i]);
									seed[idx] = !(matches[idx] = matched[i]);
								}
							}) : function (elem) {
								return fn(elem, 0, args);
							};
						}
	
						return fn;
					}
				},
	
				pseudos: {
					// Potentially complex pseudos
					"not": markFunction(function (selector) {
						// Trim the selector passed to compile
						// to avoid treating leading and trailing
						// spaces as combinators
						var input = [],
						    results = [],
						    matcher = compile(selector.replace(rtrim, "$1"));
	
						return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
							var elem,
							    unmatched = matcher(seed, null, xml, []),
							    i = seed.length;
	
							// Match elements unmatched by `matcher`
							while (i--) {
								if (elem = unmatched[i]) {
									seed[i] = !(matches[i] = elem);
								}
							}
						}) : function (elem, context, xml) {
							input[0] = elem;
							matcher(input, null, xml, results);
							// Don't keep the element (issue #299)
							input[0] = null;
							return !results.pop();
						};
					}),
	
					"has": markFunction(function (selector) {
						return function (elem) {
							return Sizzle(selector, elem).length > 0;
						};
					}),
	
					"contains": markFunction(function (text) {
						text = text.replace(runescape, funescape);
						return function (elem) {
							return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
						};
					}),
	
					// "Whether an element is represented by a :lang() selector
					// is based solely on the element's language value
					// being equal to the identifier C,
					// or beginning with the identifier C immediately followed by "-".
					// The matching of C against the element's language value is performed case-insensitively.
					// The identifier C does not have to be a valid language name."
					// http://www.w3.org/TR/selectors/#lang-pseudo
					"lang": markFunction(function (lang) {
						// lang value must be a valid identifier
						if (!ridentifier.test(lang || "")) {
							Sizzle.error("unsupported lang: " + lang);
						}
						lang = lang.replace(runescape, funescape).toLowerCase();
						return function (elem) {
							var elemLang;
							do {
								if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
	
									elemLang = elemLang.toLowerCase();
									return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
								}
							} while ((elem = elem.parentNode) && elem.nodeType === 1);
							return false;
						};
					}),
	
					// Miscellaneous
					"target": function target(elem) {
						var hash = window.location && window.location.hash;
						return hash && hash.slice(1) === elem.id;
					},
	
					"root": function root(elem) {
						return elem === docElem;
					},
	
					"focus": function focus(elem) {
						return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
					},
	
					// Boolean properties
					"enabled": createDisabledPseudo(false),
					"disabled": createDisabledPseudo(true),
	
					"checked": function checked(elem) {
						// In CSS3, :checked should return both checked and selected elements
						// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
						var nodeName = elem.nodeName.toLowerCase();
						return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
					},
	
					"selected": function selected(elem) {
						// Accessing this property makes selected-by-default
						// options in Safari work properly
						if (elem.parentNode) {
							elem.parentNode.selectedIndex;
						}
	
						return elem.selected === true;
					},
	
					// Contents
					"empty": function empty(elem) {
						// http://www.w3.org/TR/selectors/#empty-pseudo
						// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
						//   but not by others (comment: 8; processing instruction: 7; etc.)
						// nodeType < 6 works because attributes (2) do not appear as children
						for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
							if (elem.nodeType < 6) {
								return false;
							}
						}
						return true;
					},
	
					"parent": function parent(elem) {
						return !Expr.pseudos["empty"](elem);
					},
	
					// Element/input types
					"header": function header(elem) {
						return rheader.test(elem.nodeName);
					},
	
					"input": function input(elem) {
						return rinputs.test(elem.nodeName);
					},
	
					"button": function button(elem) {
						var name = elem.nodeName.toLowerCase();
						return name === "input" && elem.type === "button" || name === "button";
					},
	
					"text": function text(elem) {
						var attr;
						return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && (
	
						// Support: IE<8
						// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
						(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
					},
	
					// Position-in-collection
					"first": createPositionalPseudo(function () {
						return [0];
					}),
	
					"last": createPositionalPseudo(function (matchIndexes, length) {
						return [length - 1];
					}),
	
					"eq": createPositionalPseudo(function (matchIndexes, length, argument) {
						return [argument < 0 ? argument + length : argument];
					}),
	
					"even": createPositionalPseudo(function (matchIndexes, length) {
						var i = 0;
						for (; i < length; i += 2) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"odd": createPositionalPseudo(function (matchIndexes, length) {
						var i = 1;
						for (; i < length; i += 2) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"lt": createPositionalPseudo(function (matchIndexes, length, argument) {
						var i = argument < 0 ? argument + length : argument;
						for (; --i >= 0;) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"gt": createPositionalPseudo(function (matchIndexes, length, argument) {
						var i = argument < 0 ? argument + length : argument;
						for (; ++i < length;) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					})
				}
			};
	
			Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
			// Add button/input type pseudos
			for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
				Expr.pseudos[i] = createInputPseudo(i);
			}
			for (i in { submit: true, reset: true }) {
				Expr.pseudos[i] = createButtonPseudo(i);
			}
	
			// Easy API for creating new setFilters
			function setFilters() {}
			setFilters.prototype = Expr.filters = Expr.pseudos;
			Expr.setFilters = new setFilters();
	
			tokenize = Sizzle.tokenize = function (selector, parseOnly) {
				var matched,
				    match,
				    tokens,
				    type,
				    soFar,
				    groups,
				    preFilters,
				    cached = tokenCache[selector + " "];
	
				if (cached) {
					return parseOnly ? 0 : cached.slice(0);
				}
	
				soFar = selector;
				groups = [];
				preFilters = Expr.preFilter;
	
				while (soFar) {
	
					// Comma and first run
					if (!matched || (match = rcomma.exec(soFar))) {
						if (match) {
							// Don't consume trailing commas as valid
							soFar = soFar.slice(match[0].length) || soFar;
						}
						groups.push(tokens = []);
					}
	
					matched = false;
	
					// Combinators
					if (match = rcombinators.exec(soFar)) {
						matched = match.shift();
						tokens.push({
							value: matched,
							// Cast descendant combinators to space
							type: match[0].replace(rtrim, " ")
						});
						soFar = soFar.slice(matched.length);
					}
	
					// Filters
					for (type in Expr.filter) {
						if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
							matched = match.shift();
							tokens.push({
								value: matched,
								type: type,
								matches: match
							});
							soFar = soFar.slice(matched.length);
						}
					}
	
					if (!matched) {
						break;
					}
				}
	
				// Return the length of the invalid excess
				// if we're just parsing
				// Otherwise, throw an error or return tokens
				return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) :
				// Cache the tokens
				tokenCache(selector, groups).slice(0);
			};
	
			function toSelector(tokens) {
				var i = 0,
				    len = tokens.length,
				    selector = "";
				for (; i < len; i++) {
					selector += tokens[i].value;
				}
				return selector;
			}
	
			function addCombinator(matcher, combinator, base) {
				var dir = combinator.dir,
				    skip = combinator.next,
				    key = skip || dir,
				    checkNonElements = base && key === "parentNode",
				    doneName = done++;
	
				return combinator.first ?
				// Check against closest ancestor/preceding element
				function (elem, context, xml) {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							return matcher(elem, context, xml);
						}
					}
					return false;
				} :
	
				// Check against all ancestor/preceding elements
				function (elem, context, xml) {
					var oldCache,
					    uniqueCache,
					    outerCache,
					    newCache = [dirruns, doneName];
	
					// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
					if (xml) {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								if (matcher(elem, context, xml)) {
									return true;
								}
							}
						}
					} else {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								outerCache = elem[expando] || (elem[expando] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
	
								if (skip && skip === elem.nodeName.toLowerCase()) {
									elem = elem[dir] || elem;
								} else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
	
									// Assign to newCache so results back-propagate to previous elements
									return newCache[2] = oldCache[2];
								} else {
									// Reuse newcache so results back-propagate to previous elements
									uniqueCache[key] = newCache;
	
									// A match means we're done; a fail means we have to keep checking
									if (newCache[2] = matcher(elem, context, xml)) {
										return true;
									}
								}
							}
						}
					}
					return false;
				};
			}
	
			function elementMatcher(matchers) {
				return matchers.length > 1 ? function (elem, context, xml) {
					var i = matchers.length;
					while (i--) {
						if (!matchers[i](elem, context, xml)) {
							return false;
						}
					}
					return true;
				} : matchers[0];
			}
	
			function multipleContexts(selector, contexts, results) {
				var i = 0,
				    len = contexts.length;
				for (; i < len; i++) {
					Sizzle(selector, contexts[i], results);
				}
				return results;
			}
	
			function condense(unmatched, map, filter, context, xml) {
				var elem,
				    newUnmatched = [],
				    i = 0,
				    len = unmatched.length,
				    mapped = map != null;
	
				for (; i < len; i++) {
					if (elem = unmatched[i]) {
						if (!filter || filter(elem, context, xml)) {
							newUnmatched.push(elem);
							if (mapped) {
								map.push(i);
							}
						}
					}
				}
	
				return newUnmatched;
			}
	
			function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
				if (postFilter && !postFilter[expando]) {
					postFilter = setMatcher(postFilter);
				}
				if (postFinder && !postFinder[expando]) {
					postFinder = setMatcher(postFinder, postSelector);
				}
				return markFunction(function (seed, results, context, xml) {
					var temp,
					    i,
					    elem,
					    preMap = [],
					    postMap = [],
					    preexisting = results.length,
	
	
					// Get initial elements from seed or context
					elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
	
	
					// Prefilter to get matcher input, preserving a map for seed-results synchronization
					matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
					    matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || (seed ? preFilter : preexisting || postFilter) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results : matcherIn;
	
					// Find primary matches
					if (matcher) {
						matcher(matcherIn, matcherOut, context, xml);
					}
	
					// Apply postFilter
					if (postFilter) {
						temp = condense(matcherOut, postMap);
						postFilter(temp, [], context, xml);
	
						// Un-match failing elements by moving them back to matcherIn
						i = temp.length;
						while (i--) {
							if (elem = temp[i]) {
								matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
							}
						}
					}
	
					if (seed) {
						if (postFinder || preFilter) {
							if (postFinder) {
								// Get the final matcherOut by condensing this intermediate into postFinder contexts
								temp = [];
								i = matcherOut.length;
								while (i--) {
									if (elem = matcherOut[i]) {
										// Restore matcherIn since elem is not yet a final match
										temp.push(matcherIn[i] = elem);
									}
								}
								postFinder(null, matcherOut = [], temp, xml);
							}
	
							// Move matched elements from seed to results to keep them synchronized
							i = matcherOut.length;
							while (i--) {
								if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
	
									seed[temp] = !(results[temp] = elem);
								}
							}
						}
	
						// Add elements to results, through postFinder if defined
					} else {
						matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
						if (postFinder) {
							postFinder(null, results, matcherOut, xml);
						} else {
							push.apply(results, matcherOut);
						}
					}
				});
			}
	
			function matcherFromTokens(tokens) {
				var checkContext,
				    matcher,
				    j,
				    len = tokens.length,
				    leadingRelative = Expr.relative[tokens[0].type],
				    implicitRelative = leadingRelative || Expr.relative[" "],
				    i = leadingRelative ? 1 : 0,
	
	
				// The foundational matcher ensures that elements are reachable from top-level context(s)
				matchContext = addCombinator(function (elem) {
					return elem === checkContext;
				}, implicitRelative, true),
				    matchAnyContext = addCombinator(function (elem) {
					return indexOf(checkContext, elem) > -1;
				}, implicitRelative, true),
				    matchers = [function (elem, context, xml) {
					var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
					// Avoid hanging onto element (issue #299)
					checkContext = null;
					return ret;
				}];
	
				for (; i < len; i++) {
					if (matcher = Expr.relative[tokens[i].type]) {
						matchers = [addCombinator(elementMatcher(matchers), matcher)];
					} else {
						matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
	
						// Return special upon seeing a positional matcher
						if (matcher[expando]) {
							// Find the next relative operator (if any) for proper handling
							j = ++i;
							for (; j < len; j++) {
								if (Expr.relative[tokens[j].type]) {
									break;
								}
							}
							return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
						}
						matchers.push(matcher);
					}
				}
	
				return elementMatcher(matchers);
			}
	
			function matcherFromGroupMatchers(elementMatchers, setMatchers) {
				var bySet = setMatchers.length > 0,
				    byElement = elementMatchers.length > 0,
				    superMatcher = function superMatcher(seed, context, xml, results, outermost) {
					var elem,
					    j,
					    matcher,
					    matchedCount = 0,
					    i = "0",
					    unmatched = seed && [],
					    setMatched = [],
					    contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]("*", outermost),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
					    len = elems.length;
	
					if (outermost) {
						outermostContext = context === document || context || outermost;
					}
	
					// Add elements passing elementMatchers directly to results
					// Support: IE<9, Safari
					// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
					for (; i !== len && (elem = elems[i]) != null; i++) {
						if (byElement && elem) {
							j = 0;
							if (!context && elem.ownerDocument !== document) {
								setDocument(elem);
								xml = !documentIsHTML;
							}
							while (matcher = elementMatchers[j++]) {
								if (matcher(elem, context || document, xml)) {
									results.push(elem);
									break;
								}
							}
							if (outermost) {
								dirruns = dirrunsUnique;
							}
						}
	
						// Track unmatched elements for set filters
						if (bySet) {
							// They will have gone through all possible matchers
							if (elem = !matcher && elem) {
								matchedCount--;
							}
	
							// Lengthen the array for every element, matched or not
							if (seed) {
								unmatched.push(elem);
							}
						}
					}
	
					// `i` is now the count of elements visited above, and adding it to `matchedCount`
					// makes the latter nonnegative.
					matchedCount += i;
	
					// Apply set filters to unmatched elements
					// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
					// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
					// no element matchers and no seed.
					// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
					// case, which will result in a "00" `matchedCount` that differs from `i` but is also
					// numerically zero.
					if (bySet && i !== matchedCount) {
						j = 0;
						while (matcher = setMatchers[j++]) {
							matcher(unmatched, setMatched, context, xml);
						}
	
						if (seed) {
							// Reintegrate element matches to eliminate the need for sorting
							if (matchedCount > 0) {
								while (i--) {
									if (!(unmatched[i] || setMatched[i])) {
										setMatched[i] = pop.call(results);
									}
								}
							}
	
							// Discard index placeholder values to get only actual matches
							setMatched = condense(setMatched);
						}
	
						// Add matches to results
						push.apply(results, setMatched);
	
						// Seedless set matches succeeding multiple successful matchers stipulate sorting
						if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
	
							Sizzle.uniqueSort(results);
						}
					}
	
					// Override manipulation of globals by nested matchers
					if (outermost) {
						dirruns = dirrunsUnique;
						outermostContext = contextBackup;
					}
	
					return unmatched;
				};
	
				return bySet ? markFunction(superMatcher) : superMatcher;
			}
	
			compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
				var i,
				    setMatchers = [],
				    elementMatchers = [],
				    cached = compilerCache[selector + " "];
	
				if (!cached) {
					// Generate a function of recursive functions that can be used to check each element
					if (!match) {
						match = tokenize(selector);
					}
					i = match.length;
					while (i--) {
						cached = matcherFromTokens(match[i]);
						if (cached[expando]) {
							setMatchers.push(cached);
						} else {
							elementMatchers.push(cached);
						}
					}
	
					// Cache the compiled function
					cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
	
					// Save selector and tokenization
					cached.selector = selector;
				}
				return cached;
			};
	
			/**
	   * A low-level selection function that works with Sizzle's compiled
	   *  selector functions
	   * @param {String|Function} selector A selector or a pre-compiled
	   *  selector function built with Sizzle.compile
	   * @param {Element} context
	   * @param {Array} [results]
	   * @param {Array} [seed] A set of elements to match against
	   */
			select = Sizzle.select = function (selector, context, results, seed) {
				var i,
				    tokens,
				    token,
				    type,
				    find,
				    compiled = typeof selector === "function" && selector,
				    match = !seed && tokenize(selector = compiled.selector || selector);
	
				results = results || [];
	
				// Try to minimize operations if there is only one selector in the list and no seed
				// (the latter of which guarantees us context)
				if (match.length === 1) {
	
					// Reduce context if the leading compound selector is an ID
					tokens = match[0] = match[0].slice(0);
					if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
	
						context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
						if (!context) {
							return results;
	
							// Precompiled matchers will still verify ancestry, so step up a level
						} else if (compiled) {
							context = context.parentNode;
						}
	
						selector = selector.slice(tokens.shift().value.length);
					}
	
					// Fetch a seed set for right-to-left matching
					i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
					while (i--) {
						token = tokens[i];
	
						// Abort if we hit a combinator
						if (Expr.relative[type = token.type]) {
							break;
						}
						if (find = Expr.find[type]) {
							// Search, expanding context for leading sibling combinators
							if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
	
								// If seed is empty or no tokens remain, we can return early
								tokens.splice(i, 1);
								selector = seed.length && toSelector(tokens);
								if (!selector) {
									push.apply(results, seed);
									return results;
								}
	
								break;
							}
						}
					}
				}
	
				// Compile and execute a filtering function if one is not provided
				// Provide `match` to avoid retokenization if we modified the selector above
				(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
				return results;
			};
	
			// One-time assignments
	
			// Sort stability
			support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
	
			// Support: Chrome 14-35+
			// Always assume duplicates if they aren't passed to the comparison function
			support.detectDuplicates = !!hasDuplicate;
	
			// Initialize against the default document
			setDocument();
	
			// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
			// Detached nodes confoundingly follow *each other*
			support.sortDetached = assert(function (el) {
				// Should return 1, but returns 4 (following)
				return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
			});
	
			// Support: IE<8
			// Prevent attribute/property "interpolation"
			// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
			if (!assert(function (el) {
				el.innerHTML = "<a href='#'></a>";
				return el.firstChild.getAttribute("href") === "#";
			})) {
				addHandle("type|href|height|width", function (elem, name, isXML) {
					if (!isXML) {
						return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
					}
				});
			}
	
			// Support: IE<9
			// Use defaultValue in place of getAttribute("value")
			if (!support.attributes || !assert(function (el) {
				el.innerHTML = "<input/>";
				el.firstChild.setAttribute("value", "");
				return el.firstChild.getAttribute("value") === "";
			})) {
				addHandle("value", function (elem, name, isXML) {
					if (!isXML && elem.nodeName.toLowerCase() === "input") {
						return elem.defaultValue;
					}
				});
			}
	
			// Support: IE<9
			// Use getAttributeNode to fetch booleans when getAttribute lies
			if (!assert(function (el) {
				return el.getAttribute("disabled") == null;
			})) {
				addHandle(booleans, function (elem, name, isXML) {
					var val;
					if (!isXML) {
						return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
					}
				});
			}
	
			return Sizzle;
		}(window);
	
		jQuery.find = Sizzle;
		jQuery.expr = Sizzle.selectors;
	
		// Deprecated
		jQuery.expr[":"] = jQuery.expr.pseudos;
		jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
		jQuery.text = Sizzle.getText;
		jQuery.isXMLDoc = Sizzle.isXML;
		jQuery.contains = Sizzle.contains;
		jQuery.escapeSelector = Sizzle.escape;
	
		var dir = function dir(elem, _dir, until) {
			var matched = [],
			    truncate = until !== undefined;
	
			while ((elem = elem[_dir]) && elem.nodeType !== 9) {
				if (elem.nodeType === 1) {
					if (truncate && jQuery(elem).is(until)) {
						break;
					}
					matched.push(elem);
				}
			}
			return matched;
		};
	
		var _siblings = function _siblings(n, elem) {
			var matched = [];
	
			for (; n; n = n.nextSibling) {
				if (n.nodeType === 1 && n !== elem) {
					matched.push(n);
				}
			}
	
			return matched;
		};
	
		var rneedsContext = jQuery.expr.match.needsContext;
	
		function nodeName(elem, name) {
	
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		};
		var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
	
		// Implement the identical functionality for filter and not
		function winnow(elements, qualifier, not) {
			if (isFunction(qualifier)) {
				return jQuery.grep(elements, function (elem, i) {
					return !!qualifier.call(elem, i, elem) !== not;
				});
			}
	
			// Single element
			if (qualifier.nodeType) {
				return jQuery.grep(elements, function (elem) {
					return elem === qualifier !== not;
				});
			}
	
			// Arraylike of elements (jQuery, arguments, Array)
			if (typeof qualifier !== "string") {
				return jQuery.grep(elements, function (elem) {
					return indexOf.call(qualifier, elem) > -1 !== not;
				});
			}
	
			// Filtered directly for both simple and complex selectors
			return jQuery.filter(qualifier, elements, not);
		}
	
		jQuery.filter = function (expr, elems, not) {
			var elem = elems[0];
	
			if (not) {
				expr = ":not(" + expr + ")";
			}
	
			if (elems.length === 1 && elem.nodeType === 1) {
				return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
			}
	
			return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
				return elem.nodeType === 1;
			}));
		};
	
		jQuery.fn.extend({
			find: function find(selector) {
				var i,
				    ret,
				    len = this.length,
				    self = this;
	
				if (typeof selector !== "string") {
					return this.pushStack(jQuery(selector).filter(function () {
						for (i = 0; i < len; i++) {
							if (jQuery.contains(self[i], this)) {
								return true;
							}
						}
					}));
				}
	
				ret = this.pushStack([]);
	
				for (i = 0; i < len; i++) {
					jQuery.find(selector, self[i], ret);
				}
	
				return len > 1 ? jQuery.uniqueSort(ret) : ret;
			},
			filter: function filter(selector) {
				return this.pushStack(winnow(this, selector || [], false));
			},
			not: function not(selector) {
				return this.pushStack(winnow(this, selector || [], true));
			},
			is: function is(selector) {
				return !!winnow(this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
			}
		});
	
		// Initialize a jQuery object
	
	
		// A central reference to the root jQuery(document)
		var rootjQuery,
	
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
		    init = jQuery.fn.init = function (selector, context, root) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if (!selector) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if (typeof selector === "string") {
				if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [null, selector, null];
				} else {
					match = rquickExpr.exec(selector);
				}
	
				// Match html or make sure no context is specified for #id
				if (match && (match[1] || !context)) {
	
					// HANDLE: $(html) -> $(array)
					if (match[1]) {
						context = context instanceof jQuery ? context[0] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
	
						// HANDLE: $(html, props)
						if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
							for (match in context) {
	
								// Properties of context are called as methods if possible
								if (isFunction(this[match])) {
									this[match](context[match]);
	
									// ...and otherwise set as attributes
								} else {
									this.attr(match, context[match]);
								}
							}
						}
	
						return this;
	
						// HANDLE: $(#id)
					} else {
						elem = document.getElementById(match[2]);
	
						if (elem) {
	
							// Inject the element directly into the jQuery object
							this[0] = elem;
							this.length = 1;
						}
						return this;
					}
	
					// HANDLE: $(expr, $(...))
				} else if (!context || context.jquery) {
					return (context || root).find(selector);
	
					// HANDLE: $(expr, context)
					// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor(context).find(selector);
				}
	
				// HANDLE: $(DOMElement)
			} else if (selector.nodeType) {
				this[0] = selector;
				this.length = 1;
				return this;
	
				// HANDLE: $(function)
				// Shortcut for document ready
			} else if (isFunction(selector)) {
				return root.ready !== undefined ? root.ready(selector) :
	
				// Execute immediately if ready is not present
				selector(jQuery);
			}
	
			return jQuery.makeArray(selector, this);
		};
	
		// Give the init function the jQuery prototype for later instantiation
		init.prototype = jQuery.fn;
	
		// Initialize central reference
		rootjQuery = jQuery(document);
	
		var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
		jQuery.fn.extend({
			has: function has(target) {
				var targets = jQuery(target, this),
				    l = targets.length;
	
				return this.filter(function () {
					var i = 0;
					for (; i < l; i++) {
						if (jQuery.contains(this, targets[i])) {
							return true;
						}
					}
				});
			},
	
			closest: function closest(selectors, context) {
				var cur,
				    i = 0,
				    l = this.length,
				    matched = [],
				    targets = typeof selectors !== "string" && jQuery(selectors);
	
				// Positional selectors never match, since there's no _selection_ context
				if (!rneedsContext.test(selectors)) {
					for (; i < l; i++) {
						for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
	
							// Always skip document fragments
							if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
	
								matched.push(cur);
								break;
							}
						}
					}
				}
	
				return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
			},
	
			// Determine the position of an element within the set
			index: function index(elem) {
	
				// No argument, return index in parent
				if (!elem) {
					return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
				}
	
				// Index in selector
				if (typeof elem === "string") {
					return indexOf.call(jQuery(elem), this[0]);
				}
	
				// Locate the position of the desired element
				return indexOf.call(this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[0] : elem);
			},
	
			add: function add(selector, context) {
				return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
			},
	
			addBack: function addBack(selector) {
				return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
			}
		});
	
		function sibling(cur, dir) {
			while ((cur = cur[dir]) && cur.nodeType !== 1) {}
			return cur;
		}
	
		jQuery.each({
			parent: function parent(elem) {
				var parent = elem.parentNode;
				return parent && parent.nodeType !== 11 ? parent : null;
			},
			parents: function parents(elem) {
				return dir(elem, "parentNode");
			},
			parentsUntil: function parentsUntil(elem, i, until) {
				return dir(elem, "parentNode", until);
			},
			next: function next(elem) {
				return sibling(elem, "nextSibling");
			},
			prev: function prev(elem) {
				return sibling(elem, "previousSibling");
			},
			nextAll: function nextAll(elem) {
				return dir(elem, "nextSibling");
			},
			prevAll: function prevAll(elem) {
				return dir(elem, "previousSibling");
			},
			nextUntil: function nextUntil(elem, i, until) {
				return dir(elem, "nextSibling", until);
			},
			prevUntil: function prevUntil(elem, i, until) {
				return dir(elem, "previousSibling", until);
			},
			siblings: function siblings(elem) {
				return _siblings((elem.parentNode || {}).firstChild, elem);
			},
			children: function children(elem) {
				return _siblings(elem.firstChild);
			},
			contents: function contents(elem) {
				if (nodeName(elem, "iframe")) {
					return elem.contentDocument;
				}
	
				// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
				// Treat the template element as a regular one in browsers that
				// don't support it.
				if (nodeName(elem, "template")) {
					elem = elem.content || elem;
				}
	
				return jQuery.merge([], elem.childNodes);
			}
		}, function (name, fn) {
			jQuery.fn[name] = function (until, selector) {
				var matched = jQuery.map(this, fn, until);
	
				if (name.slice(-5) !== "Until") {
					selector = until;
				}
	
				if (selector && typeof selector === "string") {
					matched = jQuery.filter(selector, matched);
				}
	
				if (this.length > 1) {
	
					// Remove duplicates
					if (!guaranteedUnique[name]) {
						jQuery.uniqueSort(matched);
					}
	
					// Reverse order for parents* and prev-derivatives
					if (rparentsprev.test(name)) {
						matched.reverse();
					}
				}
	
				return this.pushStack(matched);
			};
		});
		var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
	
		// Convert String-formatted options into Object-formatted ones
		function createOptions(options) {
			var object = {};
			jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
				object[flag] = true;
			});
			return object;
		}
	
		/*
	  * Create a callback list using the following parameters:
	  *
	  *	options: an optional list of space-separated options that will change how
	  *			the callback list behaves or a more traditional option object
	  *
	  * By default a callback list will act like an event callback list and can be
	  * "fired" multiple times.
	  *
	  * Possible options:
	  *
	  *	once:			will ensure the callback list can only be fired once (like a Deferred)
	  *
	  *	memory:			will keep track of previous values and will call any callback added
	  *					after the list has been fired right away with the latest "memorized"
	  *					values (like a Deferred)
	  *
	  *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	  *
	  *	stopOnFalse:	interrupt callings when a callback returns false
	  *
	  */
		jQuery.Callbacks = function (options) {
	
			// Convert options from String-formatted to Object-formatted if needed
			// (we check in cache first)
			options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
	
			var // Flag to know if list is currently firing
			firing,
	
	
			// Last fire value for non-forgettable lists
			memory,
	
	
			// Flag to know if list was already fired
			_fired,
	
	
			// Flag to prevent firing
			_locked,
	
	
			// Actual callback list
			list = [],
	
	
			// Queue of execution data for repeatable lists
			queue = [],
	
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
	
			// Fire callbacks
			fire = function fire() {
	
				// Enforce single-firing
				_locked = _locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				_fired = firing = true;
				for (; queue.length; firingIndex = -1) {
					memory = queue.shift();
					while (++firingIndex < list.length) {
	
						// Run callback and check for early termination
						if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if (!options.memory) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if (_locked) {
	
					// Keep an empty list if we have data for future add calls
					if (memory) {
						list = [];
	
						// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function add() {
					if (list) {
	
						// If we have memory from a past run, we should fire after adding
						if (memory && !firing) {
							firingIndex = list.length - 1;
							queue.push(memory);
						}
	
						(function add(args) {
							jQuery.each(args, function (_, arg) {
								if (isFunction(arg)) {
									if (!options.unique || !self.has(arg)) {
										list.push(arg);
									}
								} else if (arg && arg.length && toType(arg) !== "string") {
	
									// Inspect recursively
									add(arg);
								}
							});
						})(arguments);
	
						if (memory && !firing) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function remove() {
					jQuery.each(arguments, function (_, arg) {
						var index;
						while ((index = jQuery.inArray(arg, list, index)) > -1) {
							list.splice(index, 1);
	
							// Handle firing indexes
							if (index <= firingIndex) {
								firingIndex--;
							}
						}
					});
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function has(fn) {
					return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function empty() {
					if (list) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function disable() {
					_locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function disabled() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function lock() {
					_locked = queue = [];
					if (!memory && !firing) {
						list = memory = "";
					}
					return this;
				},
				locked: function locked() {
					return !!_locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function fireWith(context, args) {
					if (!_locked) {
						args = args || [];
						args = [context, args.slice ? args.slice() : args];
						queue.push(args);
						if (!firing) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function fire() {
					self.fireWith(this, arguments);
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function fired() {
					return !!_fired;
				}
			};
	
			return self;
		};
	
		function Identity(v) {
			return v;
		}
		function Thrower(ex) {
			throw ex;
		}
	
		function adoptValue(value, resolve, reject, noValue) {
			var method;
	
			try {
	
				// Check for promise aspect first to privilege synchronous behavior
				if (value && isFunction(method = value.promise)) {
					method.call(value).done(resolve).fail(reject);
	
					// Other thenables
				} else if (value && isFunction(method = value.then)) {
					method.call(value, resolve, reject);
	
					// Other non-thenables
				} else {
	
					// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
					// * false: [ value ].slice( 0 ) => resolve( value )
					// * true: [ value ].slice( 1 ) => resolve()
					resolve.apply(undefined, [value].slice(noValue));
				}
	
				// For Promises/A+, convert exceptions into rejections
				// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
				// Deferred#then to conditionally suppress rejection.
			} catch (value) {
	
				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				reject.apply(undefined, [value]);
			}
		}
	
		jQuery.extend({
	
			Deferred: function Deferred(func) {
				var tuples = [
	
				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
				    _state = "pending",
				    _promise = {
					state: function state() {
						return _state;
					},
					always: function always() {
						deferred.done(arguments).fail(arguments);
						return this;
					},
					"catch": function _catch(fn) {
						return _promise.then(null, fn);
					},
	
					// Keep pipe for back-compat
					pipe: function pipe() /* fnDone, fnFail, fnProgress */{
						var fns = arguments;
	
						return jQuery.Deferred(function (newDefer) {
							jQuery.each(tuples, function (i, tuple) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[tuple[1]](function () {
									var returned = fn && fn.apply(this, arguments);
									if (returned && isFunction(returned.promise)) {
										returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
									} else {
										newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
									}
								});
							});
							fns = null;
						}).promise();
					},
					then: function then(onFulfilled, onRejected, onProgress) {
						var maxDepth = 0;
						function resolve(depth, deferred, handler, special) {
							return function () {
								var that = this,
								    args = arguments,
								    mightThrow = function mightThrow() {
									var returned, then;
	
									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if (depth < maxDepth) {
										return;
									}
	
									returned = handler.apply(that, args);
	
									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if (returned === deferred.promise()) {
										throw new TypeError("Thenable self-resolution");
									}
	
									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned && (
	
									// Support: Promises/A+ section 2.3.4
									// https://promisesaplus.com/#point-64
									// Only check objects and functions for thenability
									(typeof returned === "undefined" ? "undefined" : _typeof(returned)) === "object" || typeof returned === "function") && returned.then;
	
									// Handle a returned thenable
									if (isFunction(then)) {
	
										// Special processors (notify) just wait for resolution
										if (special) {
											then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
	
											// Normal processors (resolve) also hook into progress
										} else {
	
											// ...and disregard older resolution values
											maxDepth++;
	
											then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
										}
	
										// Handle all other returned values
									} else {
	
										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if (handler !== Identity) {
											that = undefined;
											args = [returned];
										}
	
										// Process the value(s)
										// Default process is resolve
										(special || deferred.resolveWith)(that, args);
									}
								},
	
	
								// Only normal processors (resolve) catch and reject exceptions
								process = special ? mightThrow : function () {
									try {
										mightThrow();
									} catch (e) {
	
										if (jQuery.Deferred.exceptionHook) {
											jQuery.Deferred.exceptionHook(e, process.stackTrace);
										}
	
										// Support: Promises/A+ section 2.3.3.3.4.1
										// https://promisesaplus.com/#point-61
										// Ignore post-resolution exceptions
										if (depth + 1 >= maxDepth) {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if (handler !== Thrower) {
												that = undefined;
												args = [e];
											}
	
											deferred.rejectWith(that, args);
										}
									}
								};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if (depth) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if (jQuery.Deferred.getStackHook) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout(process);
								}
							};
						}
	
						return jQuery.Deferred(function (newDefer) {
	
							// progress_handlers.add( ... )
							tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
	
							// fulfilled_handlers.add( ... )
							tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
	
							// rejected_handlers.add( ... )
							tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
						}).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function promise(obj) {
						return obj != null ? jQuery.extend(obj, _promise) : _promise;
					}
				},
				    deferred = {};
	
				// Add list-specific methods
				jQuery.each(tuples, function (i, tuple) {
					var list = tuple[2],
					    stateString = tuple[5];
	
					// promise.progress = list.add
					// promise.done = list.add
					// promise.fail = list.add
					_promise[tuple[1]] = list.add;
	
					// Handle state
					if (stateString) {
						list.add(function () {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							_state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[3 - i][2].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[3 - i][3].disable,
	
						// progress_callbacks.lock
						tuples[0][2].lock,
	
						// progress_handlers.lock
						tuples[0][3].lock);
					}
	
					// progress_handlers.fire
					// fulfilled_handlers.fire
					// rejected_handlers.fire
					list.add(tuple[3].fire);
	
					// deferred.notify = function() { deferred.notifyWith(...) }
					// deferred.resolve = function() { deferred.resolveWith(...) }
					// deferred.reject = function() { deferred.rejectWith(...) }
					deferred[tuple[0]] = function () {
						deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
						return this;
					};
	
					// deferred.notifyWith = list.fireWith
					// deferred.resolveWith = list.fireWith
					// deferred.rejectWith = list.fireWith
					deferred[tuple[0] + "With"] = list.fireWith;
				});
	
				// Make the deferred a promise
				_promise.promise(deferred);
	
				// Call given func if any
				if (func) {
					func.call(deferred, deferred);
				}
	
				// All done!
				return deferred;
			},
	
			// Deferred helper
			when: function when(singleValue) {
				var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
	
				// count of unprocessed arguments
				i = remaining,
	
	
				// subordinate fulfillment data
				resolveContexts = Array(i),
				    resolveValues = _slice.call(arguments),
	
	
				// the master Deferred
				master = jQuery.Deferred(),
	
	
				// subordinate callback factory
				updateFunc = function updateFunc(i) {
					return function (value) {
						resolveContexts[i] = this;
						resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
						if (! --remaining) {
							master.resolveWith(resolveContexts, resolveValues);
						}
					};
				};
	
				// Single- and empty arguments are adopted like Promise.resolve
				if (remaining <= 1) {
					adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);
	
					// Use .then() to unwrap secondary thenables (cf. gh-3000)
					if (master.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
	
						return master.then();
					}
				}
	
				// Multiple arguments are aggregated like Promise.all array elements
				while (i--) {
					adoptValue(resolveValues[i], updateFunc(i), master.reject);
				}
	
				return master.promise();
			}
		});
	
		// These usually indicate a programmer mistake during development,
		// warn about them ASAP rather than swallowing them by default.
		var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
		jQuery.Deferred.exceptionHook = function (error, stack) {
	
			// Support: IE 8 - 9 only
			// Console exists when dev tools are open, which can happen at any time
			if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
				window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
			}
		};
	
		jQuery.readyException = function (error) {
			window.setTimeout(function () {
				throw error;
			});
		};
	
		// The deferred used on DOM ready
		var readyList = jQuery.Deferred();
	
		jQuery.fn.ready = function (fn) {
	
			readyList.then(fn)
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch(function (error) {
				jQuery.readyException(error);
			});
	
			return this;
		};
	
		jQuery.extend({
	
			// Is the DOM ready to be used? Set to true once it occurs.
			isReady: false,
	
			// A counter to track how many items to wait for before
			// the ready event fires. See #6781
			readyWait: 1,
	
			// Handle when the DOM is ready
			ready: function ready(wait) {
	
				// Abort if there are pending holds or we're already ready
				if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
					return;
				}
	
				// Remember that the DOM is ready
				jQuery.isReady = true;
	
				// If a normal DOM Ready event fired, decrement, and wait if need be
				if (wait !== true && --jQuery.readyWait > 0) {
					return;
				}
	
				// If there are functions bound, to execute
				readyList.resolveWith(document, [jQuery]);
			}
		});
	
		jQuery.ready.then = readyList.then;
	
		// The ready event handler and self cleanup method
		function completed() {
			document.removeEventListener("DOMContentLoaded", completed);
			window.removeEventListener("load", completed);
			jQuery.ready();
		}
	
		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE <=9 - 10 only
		// Older IE sometimes signals "interactive" too soon
		if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
	
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout(jQuery.ready);
		} else {
	
			// Use the handy event callback
			document.addEventListener("DOMContentLoaded", completed);
	
			// A fallback to window.onload, that will always work
			window.addEventListener("load", completed);
		}
	
		// Multifunctional method to get and set values of a collection
		// The value/s can optionally be executed if it's a function
		var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
			var i = 0,
			    len = elems.length,
			    bulk = key == null;
	
			// Sets many values
			if (toType(key) === "object") {
				chainable = true;
				for (i in key) {
					access(elems, fn, i, key[i], true, emptyGet, raw);
				}
	
				// Sets one value
			} else if (value !== undefined) {
				chainable = true;
	
				if (!isFunction(value)) {
					raw = true;
				}
	
				if (bulk) {
	
					// Bulk operations run against the entire set
					if (raw) {
						fn.call(elems, value);
						fn = null;
	
						// ...except when executing function values
					} else {
						bulk = fn;
						fn = function fn(elem, key, value) {
							return bulk.call(jQuery(elem), value);
						};
					}
				}
	
				if (fn) {
					for (; i < len; i++) {
						fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
					}
				}
			}
	
			if (chainable) {
				return elems;
			}
	
			// Gets
			if (bulk) {
				return fn.call(elems);
			}
	
			return len ? fn(elems[0], key) : emptyGet;
		};
	
		// Matches dashed string for camelizing
		var rmsPrefix = /^-ms-/,
		    rdashAlpha = /-([a-z])/g;
	
		// Used by camelCase as callback to replace()
		function fcamelCase(all, letter) {
			return letter.toUpperCase();
		}
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 15
		// Microsoft forgot to hump their vendor prefix (#9572)
		function camelCase(string) {
			return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
		}
		var acceptData = function acceptData(owner) {
	
			// Accepts only:
			//  - Node
			//    - Node.ELEMENT_NODE
			//    - Node.DOCUMENT_NODE
			//  - Object
			//    - Any
			return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
		};
	
		function Data() {
			this.expando = jQuery.expando + Data.uid++;
		}
	
		Data.uid = 1;
	
		Data.prototype = {
	
			cache: function cache(owner) {
	
				// Check if the owner object already has a cache
				var value = owner[this.expando];
	
				// If not, create one
				if (!value) {
					value = {};
	
					// We can accept data for non-element nodes in modern browsers,
					// but we should not, see #8335.
					// Always return an empty object.
					if (acceptData(owner)) {
	
						// If it is a node unlikely to be stringify-ed or looped over
						// use plain assignment
						if (owner.nodeType) {
							owner[this.expando] = value;
	
							// Otherwise secure it in a non-enumerable property
							// configurable must be true to allow the property to be
							// deleted when data is removed
						} else {
							Object.defineProperty(owner, this.expando, {
								value: value,
								configurable: true
							});
						}
					}
				}
	
				return value;
			},
			set: function set(owner, data, value) {
				var prop,
				    cache = this.cache(owner);
	
				// Handle: [ owner, key, value ] args
				// Always use camelCase key (gh-2257)
				if (typeof data === "string") {
					cache[camelCase(data)] = value;
	
					// Handle: [ owner, { properties } ] args
				} else {
	
					// Copy the properties one-by-one to the cache object
					for (prop in data) {
						cache[camelCase(prop)] = data[prop];
					}
				}
				return cache;
			},
			get: function get(owner, key) {
				return key === undefined ? this.cache(owner) :
	
				// Always use camelCase key (gh-2257)
				owner[this.expando] && owner[this.expando][camelCase(key)];
			},
			access: function access(owner, key, value) {
	
				// In cases where either:
				//
				//   1. No key was specified
				//   2. A string key was specified, but no value provided
				//
				// Take the "read" path and allow the get method to determine
				// which value to return, respectively either:
				//
				//   1. The entire cache object
				//   2. The data stored at the key
				//
				if (key === undefined || key && typeof key === "string" && value === undefined) {
	
					return this.get(owner, key);
				}
	
				// When the key is not a string, or both a key and value
				// are specified, set or extend (existing objects) with either:
				//
				//   1. An object of properties
				//   2. A key and value
				//
				this.set(owner, key, value);
	
				// Since the "set" path can have two possible entry points
				// return the expected data based on which path was taken[*]
				return value !== undefined ? value : key;
			},
			remove: function remove(owner, key) {
				var i,
				    cache = owner[this.expando];
	
				if (cache === undefined) {
					return;
				}
	
				if (key !== undefined) {
	
					// Support array or space separated string of keys
					if (Array.isArray(key)) {
	
						// If key is an array of keys...
						// We always set camelCase keys, so remove that.
						key = key.map(camelCase);
					} else {
						key = camelCase(key);
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
					}
	
					i = key.length;
	
					while (i--) {
						delete cache[key[i]];
					}
				}
	
				// Remove the expando if there's no more data
				if (key === undefined || jQuery.isEmptyObject(cache)) {
	
					// Support: Chrome <=35 - 45
					// Webkit & Blink performance suffers when deleting properties
					// from DOM nodes, so set to undefined instead
					// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
					if (owner.nodeType) {
						owner[this.expando] = undefined;
					} else {
						delete owner[this.expando];
					}
				}
			},
			hasData: function hasData(owner) {
				var cache = owner[this.expando];
				return cache !== undefined && !jQuery.isEmptyObject(cache);
			}
		};
		var dataPriv = new Data();
	
		var dataUser = new Data();
	
		//	Implementation Summary
		//
		//	1. Enforce API surface and semantic compatibility with 1.9.x branch
		//	2. Improve the module's maintainability by reducing the storage
		//		paths to a single mechanism.
		//	3. Use the same single mechanism to support "private" and "user" data.
		//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
		//	5. Avoid exposing implementation details on user objects (eg. expando properties)
		//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
		var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		    rmultiDash = /[A-Z]/g;
	
		function getData(data) {
			if (data === "true") {
				return true;
			}
	
			if (data === "false") {
				return false;
			}
	
			if (data === "null") {
				return null;
			}
	
			// Only convert to a number if it doesn't change the string
			if (data === +data + "") {
				return +data;
			}
	
			if (rbrace.test(data)) {
				return JSON.parse(data);
			}
	
			return data;
		}
	
		function dataAttr(elem, key, data) {
			var name;
	
			// If nothing was found internally, try to fetch any
			// data from the HTML5 data-* attribute
			if (data === undefined && elem.nodeType === 1) {
				name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
				data = elem.getAttribute(name);
	
				if (typeof data === "string") {
					try {
						data = getData(data);
					} catch (e) {}
	
					// Make sure we set the data so it isn't changed later
					dataUser.set(elem, key, data);
				} else {
					data = undefined;
				}
			}
			return data;
		}
	
		jQuery.extend({
			hasData: function hasData(elem) {
				return dataUser.hasData(elem) || dataPriv.hasData(elem);
			},
	
			data: function data(elem, name, _data) {
				return dataUser.access(elem, name, _data);
			},
	
			removeData: function removeData(elem, name) {
				dataUser.remove(elem, name);
			},
	
			// TODO: Now that all calls to _data and _removeData have been replaced
			// with direct calls to dataPriv methods, these can be deprecated.
			_data: function _data(elem, name, data) {
				return dataPriv.access(elem, name, data);
			},
	
			_removeData: function _removeData(elem, name) {
				dataPriv.remove(elem, name);
			}
		});
	
		jQuery.fn.extend({
			data: function data(key, value) {
				var i,
				    name,
				    data,
				    elem = this[0],
				    attrs = elem && elem.attributes;
	
				// Gets all values
				if (key === undefined) {
					if (this.length) {
						data = dataUser.get(elem);
	
						if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
							i = attrs.length;
							while (i--) {
	
								// Support: IE 11 only
								// The attrs elements can be null (#14894)
								if (attrs[i]) {
									name = attrs[i].name;
									if (name.indexOf("data-") === 0) {
										name = camelCase(name.slice(5));
										dataAttr(elem, name, data[name]);
									}
								}
							}
							dataPriv.set(elem, "hasDataAttrs", true);
						}
					}
	
					return data;
				}
	
				// Sets multiple values
				if ((typeof key === "undefined" ? "undefined" : _typeof(key)) === "object") {
					return this.each(function () {
						dataUser.set(this, key);
					});
				}
	
				return access(this, function (value) {
					var data;
	
					// The calling jQuery object (element matches) is not empty
					// (and therefore has an element appears at this[ 0 ]) and the
					// `value` parameter was not undefined. An empty jQuery object
					// will result in `undefined` for elem = this[ 0 ] which will
					// throw an exception if an attempt to read a data cache is made.
					if (elem && value === undefined) {
	
						// Attempt to get data from the cache
						// The key will always be camelCased in Data
						data = dataUser.get(elem, key);
						if (data !== undefined) {
							return data;
						}
	
						// Attempt to "discover" the data in
						// HTML5 custom data-* attrs
						data = dataAttr(elem, key);
						if (data !== undefined) {
							return data;
						}
	
						// We tried really hard, but the data doesn't exist.
						return;
					}
	
					// Set the data...
					this.each(function () {
	
						// We always store the camelCased key
						dataUser.set(this, key, value);
					});
				}, null, value, arguments.length > 1, null, true);
			},
	
			removeData: function removeData(key) {
				return this.each(function () {
					dataUser.remove(this, key);
				});
			}
		});
	
		jQuery.extend({
			queue: function queue(elem, type, data) {
				var queue;
	
				if (elem) {
					type = (type || "fx") + "queue";
					queue = dataPriv.get(elem, type);
	
					// Speed up dequeue by getting out quickly if this is just a lookup
					if (data) {
						if (!queue || Array.isArray(data)) {
							queue = dataPriv.access(elem, type, jQuery.makeArray(data));
						} else {
							queue.push(data);
						}
					}
					return queue || [];
				}
			},
	
			dequeue: function dequeue(elem, type) {
				type = type || "fx";
	
				var queue = jQuery.queue(elem, type),
				    startLength = queue.length,
				    fn = queue.shift(),
				    hooks = jQuery._queueHooks(elem, type),
				    next = function next() {
					jQuery.dequeue(elem, type);
				};
	
				// If the fx queue is dequeued, always remove the progress sentinel
				if (fn === "inprogress") {
					fn = queue.shift();
					startLength--;
				}
	
				if (fn) {
	
					// Add a progress sentinel to prevent the fx queue from being
					// automatically dequeued
					if (type === "fx") {
						queue.unshift("inprogress");
					}
	
					// Clear up the last queue stop function
					delete hooks.stop;
					fn.call(elem, next, hooks);
				}
	
				if (!startLength && hooks) {
					hooks.empty.fire();
				}
			},
	
			// Not public - generate a queueHooks object, or return the current one
			_queueHooks: function _queueHooks(elem, type) {
				var key = type + "queueHooks";
				return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
					empty: jQuery.Callbacks("once memory").add(function () {
						dataPriv.remove(elem, [type + "queue", key]);
					})
				});
			}
		});
	
		jQuery.fn.extend({
			queue: function queue(type, data) {
				var setter = 2;
	
				if (typeof type !== "string") {
					data = type;
					type = "fx";
					setter--;
				}
	
				if (arguments.length < setter) {
					return jQuery.queue(this[0], type);
				}
	
				return data === undefined ? this : this.each(function () {
					var queue = jQuery.queue(this, type, data);
	
					// Ensure a hooks for this queue
					jQuery._queueHooks(this, type);
	
					if (type === "fx" && queue[0] !== "inprogress") {
						jQuery.dequeue(this, type);
					}
				});
			},
			dequeue: function dequeue(type) {
				return this.each(function () {
					jQuery.dequeue(this, type);
				});
			},
			clearQueue: function clearQueue(type) {
				return this.queue(type || "fx", []);
			},
	
			// Get a promise resolved when queues of a certain type
			// are emptied (fx is the type by default)
			promise: function promise(type, obj) {
				var tmp,
				    count = 1,
				    defer = jQuery.Deferred(),
				    elements = this,
				    i = this.length,
				    resolve = function resolve() {
					if (! --count) {
						defer.resolveWith(elements, [elements]);
					}
				};
	
				if (typeof type !== "string") {
					obj = type;
					type = undefined;
				}
				type = type || "fx";
	
				while (i--) {
					tmp = dataPriv.get(elements[i], type + "queueHooks");
					if (tmp && tmp.empty) {
						count++;
						tmp.empty.add(resolve);
					}
				}
				resolve();
				return defer.promise(obj);
			}
		});
		var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
	
		var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
	
		var cssExpand = ["Top", "Right", "Bottom", "Left"];
	
		var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" || elem.style.display === "" &&
	
			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains(elem.ownerDocument, elem) && jQuery.css(elem, "display") === "none";
		};
	
		var swap = function swap(elem, options, callback, args) {
			var ret,
			    name,
			    old = {};
	
			// Remember the old values, and insert the new ones
			for (name in options) {
				old[name] = elem.style[name];
				elem.style[name] = options[name];
			}
	
			ret = callback.apply(elem, args || []);
	
			// Revert the old values
			for (name in options) {
				elem.style[name] = old[name];
			}
	
			return ret;
		};
	
		function adjustCSS(elem, prop, valueParts, tween) {
			var adjusted,
			    scale,
			    maxIterations = 20,
			    currentValue = tween ? function () {
				return tween.cur();
			} : function () {
				return jQuery.css(elem, prop, "");
			},
			    initial = currentValue(),
			    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
	
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
	
			if (initialInUnit && initialInUnit[3] !== unit) {
	
				// Support: Firefox <=54
				// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
				initial = initial / 2;
	
				// Trust units reported by jQuery.css
				unit = unit || initialInUnit[3];
	
				// Iteratively approximate from a nonzero starting point
				initialInUnit = +initial || 1;
	
				while (maxIterations--) {
	
					// Evaluate and update our best guess (doubling guesses that zero out).
					// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
					jQuery.style(elem, prop, initialInUnit + unit);
					if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
						maxIterations = 0;
					}
					initialInUnit = initialInUnit / scale;
				}
	
				initialInUnit = initialInUnit * 2;
				jQuery.style(elem, prop, initialInUnit + unit);
	
				// Make sure we update the tween properties later on
				valueParts = valueParts || [];
			}
	
			if (valueParts) {
				initialInUnit = +initialInUnit || +initial || 0;
	
				// Apply relative offset (+=/-=) if specified
				adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
				if (tween) {
					tween.unit = unit;
					tween.start = initialInUnit;
					tween.end = adjusted;
				}
			}
			return adjusted;
		}
	
		var defaultDisplayMap = {};
	
		function getDefaultDisplay(elem) {
			var temp,
			    doc = elem.ownerDocument,
			    nodeName = elem.nodeName,
			    display = defaultDisplayMap[nodeName];
	
			if (display) {
				return display;
			}
	
			temp = doc.body.appendChild(doc.createElement(nodeName));
			display = jQuery.css(temp, "display");
	
			temp.parentNode.removeChild(temp);
	
			if (display === "none") {
				display = "block";
			}
			defaultDisplayMap[nodeName] = display;
	
			return display;
		}
	
		function showHide(elements, show) {
			var display,
			    elem,
			    values = [],
			    index = 0,
			    length = elements.length;
	
			// Determine new display value for elements that need to change
			for (; index < length; index++) {
				elem = elements[index];
				if (!elem.style) {
					continue;
				}
	
				display = elem.style.display;
				if (show) {
	
					// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
					// check is required in this first loop unless we have a nonempty display value (either
					// inline or about-to-be-restored)
					if (display === "none") {
						values[index] = dataPriv.get(elem, "display") || null;
						if (!values[index]) {
							elem.style.display = "";
						}
					}
					if (elem.style.display === "" && isHiddenWithinTree(elem)) {
						values[index] = getDefaultDisplay(elem);
					}
				} else {
					if (display !== "none") {
						values[index] = "none";
	
						// Remember what we're overwriting
						dataPriv.set(elem, "display", display);
					}
				}
			}
	
			// Set the display of the elements in a second loop to avoid constant reflow
			for (index = 0; index < length; index++) {
				if (values[index] != null) {
					elements[index].style.display = values[index];
				}
			}
	
			return elements;
		}
	
		jQuery.fn.extend({
			show: function show() {
				return showHide(this, true);
			},
			hide: function hide() {
				return showHide(this);
			},
			toggle: function toggle(state) {
				if (typeof state === "boolean") {
					return state ? this.show() : this.hide();
				}
	
				return this.each(function () {
					if (isHiddenWithinTree(this)) {
						jQuery(this).show();
					} else {
						jQuery(this).hide();
					}
				});
			}
		});
		var rcheckableType = /^(?:checkbox|radio)$/i;
	
		var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i;
	
		var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
	
		// We have to close these tags to support XHTML (#13200)
		var wrapMap = {
	
			// Support: IE <=9 only
			option: [1, "<select multiple='multiple'>", "</select>"],
	
			// XHTML parsers do not magically insert elements in the
			// same way that tag soup parsers do. So we cannot shorten
			// this by omitting <tbody> or other required elements.
			thead: [1, "<table>", "</table>"],
			col: [2, "<table><colgroup>", "</colgroup></table>"],
			tr: [2, "<table><tbody>", "</tbody></table>"],
			td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
	
			_default: [0, "", ""]
		};
	
		// Support: IE <=9 only
		wrapMap.optgroup = wrapMap.option;
	
		wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
		wrapMap.th = wrapMap.td;
	
		function getAll(context, tag) {
	
			// Support: IE <=9 - 11 only
			// Use typeof to avoid zero-argument method invocation on host objects (#15151)
			var ret;
	
			if (typeof context.getElementsByTagName !== "undefined") {
				ret = context.getElementsByTagName(tag || "*");
			} else if (typeof context.querySelectorAll !== "undefined") {
				ret = context.querySelectorAll(tag || "*");
			} else {
				ret = [];
			}
	
			if (tag === undefined || tag && nodeName(context, tag)) {
				return jQuery.merge([context], ret);
			}
	
			return ret;
		}
	
		// Mark scripts as having already been evaluated
		function setGlobalEval(elems, refElements) {
			var i = 0,
			    l = elems.length;
	
			for (; i < l; i++) {
				dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
			}
		}
	
		var rhtml = /<|&#?\w+;/;
	
		function buildFragment(elems, context, scripts, selection, ignored) {
			var elem,
			    tmp,
			    tag,
			    wrap,
			    contains,
			    j,
			    fragment = context.createDocumentFragment(),
			    nodes = [],
			    i = 0,
			    l = elems.length;
	
			for (; i < l; i++) {
				elem = elems[i];
	
				if (elem || elem === 0) {
	
					// Add nodes directly
					if (toType(elem) === "object") {
	
						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
	
						// Convert non-html into a text node
					} else if (!rhtml.test(elem)) {
						nodes.push(context.createTextNode(elem));
	
						// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild(context.createElement("div"));
	
						// Deserialize a standard representation
						tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
						wrap = wrapMap[tag] || wrapMap._default;
						tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
	
						// Descend through wrappers to the right content
						j = wrap[0];
						while (j--) {
							tmp = tmp.lastChild;
						}
	
						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge(nodes, tmp.childNodes);
	
						// Remember the top-level container
						tmp = fragment.firstChild;
	
						// Ensure the created nodes are orphaned (#12392)
						tmp.textContent = "";
					}
				}
			}
	
			// Remove wrapper from fragment
			fragment.textContent = "";
	
			i = 0;
			while (elem = nodes[i++]) {
	
				// Skip elements already in the context collection (trac-4087)
				if (selection && jQuery.inArray(elem, selection) > -1) {
					if (ignored) {
						ignored.push(elem);
					}
					continue;
				}
	
				contains = jQuery.contains(elem.ownerDocument, elem);
	
				// Append to fragment
				tmp = getAll(fragment.appendChild(elem), "script");
	
				// Preserve script evaluation history
				if (contains) {
					setGlobalEval(tmp);
				}
	
				// Capture executables
				if (scripts) {
					j = 0;
					while (elem = tmp[j++]) {
						if (rscriptType.test(elem.type || "")) {
							scripts.push(elem);
						}
					}
				}
			}
	
			return fragment;
		}
	
		(function () {
			var fragment = document.createDocumentFragment(),
			    div = fragment.appendChild(document.createElement("div")),
			    input = document.createElement("input");
	
			// Support: Android 4.0 - 4.3 only
			// Check state lost if the name is set (#11217)
			// Support: Windows Web Apps (WWA)
			// `name` and `type` must use .setAttribute for WWA (#14901)
			input.setAttribute("type", "radio");
			input.setAttribute("checked", "checked");
			input.setAttribute("name", "t");
	
			div.appendChild(input);
	
			// Support: Android <=4.1 only
			// Older WebKit doesn't clone checked state correctly in fragments
			support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
	
			// Support: IE <=11 only
			// Make sure textarea (and checkbox) defaultValue is properly cloned
			div.innerHTML = "<textarea>x</textarea>";
			support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
		})();
		var documentElement = document.documentElement;
	
		var rkeyEvent = /^key/,
		    rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		    rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
		function returnTrue() {
			return true;
		}
	
		function returnFalse() {
			return false;
		}
	
		// Support: IE <=9 only
		// See #13393 for more info
		function safeActiveElement() {
			try {
				return document.activeElement;
			} catch (err) {}
		}
	
		function _on(elem, types, selector, data, fn, one) {
			var origFn, type;
	
			// Types can be a map of types/handlers
			if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {
	
				// ( types-Object, selector, data )
				if (typeof selector !== "string") {
	
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for (type in types) {
					_on(elem, type, selector, data, types[type], one);
				}
				return elem;
			}
	
			if (data == null && fn == null) {
	
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if (fn == null) {
				if (typeof selector === "string") {
	
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
	
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if (fn === false) {
				fn = returnFalse;
			} else if (!fn) {
				return elem;
			}
	
			if (one === 1) {
				origFn = fn;
				fn = function fn(event) {
	
					// Can use an empty set, since event contains the info
					jQuery().off(event);
					return origFn.apply(this, arguments);
				};
	
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
			}
			return elem.each(function () {
				jQuery.event.add(this, types, fn, data, selector);
			});
		}
	
		/*
	  * Helper functions for managing events -- not part of the public interface.
	  * Props to Dean Edwards' addEvent library for many of the ideas.
	  */
		jQuery.event = {
	
			global: {},
	
			add: function add(elem, types, handler, data, selector) {
	
				var handleObjIn,
				    eventHandle,
				    tmp,
				    events,
				    t,
				    handleObj,
				    special,
				    handlers,
				    type,
				    namespaces,
				    origType,
				    elemData = dataPriv.get(elem);
	
				// Don't attach events to noData or text/comment nodes (but allow plain objects)
				if (!elemData) {
					return;
				}
	
				// Caller can pass in an object of custom data in lieu of the handler
				if (handler.handler) {
					handleObjIn = handler;
					handler = handleObjIn.handler;
					selector = handleObjIn.selector;
				}
	
				// Ensure that invalid selectors throw exceptions at attach time
				// Evaluate against documentElement in case elem is a non-element node (e.g., document)
				if (selector) {
					jQuery.find.matchesSelector(documentElement, selector);
				}
	
				// Make sure that the handler has a unique ID, used to find/remove it later
				if (!handler.guid) {
					handler.guid = jQuery.guid++;
				}
	
				// Init the element's event structure and main handler, if this is the first
				if (!(events = elemData.events)) {
					events = elemData.events = {};
				}
				if (!(eventHandle = elemData.handle)) {
					eventHandle = elemData.handle = function (e) {
	
						// Discard the second event of a jQuery.event.trigger() and
						// when an event is called after a page has unloaded
						return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
					};
				}
	
				// Handle multiple events separated by a space
				types = (types || "").match(rnothtmlwhite) || [""];
				t = types.length;
				while (t--) {
					tmp = rtypenamespace.exec(types[t]) || [];
					type = origType = tmp[1];
					namespaces = (tmp[2] || "").split(".").sort();
	
					// There *must* be a type, no attaching namespace-only handlers
					if (!type) {
						continue;
					}
	
					// If event changes its type, use the special event handlers for the changed type
					special = jQuery.event.special[type] || {};
	
					// If selector defined, determine special event api type, otherwise given type
					type = (selector ? special.delegateType : special.bindType) || type;
	
					// Update special based on newly reset type
					special = jQuery.event.special[type] || {};
	
					// handleObj is passed to all event handlers
					handleObj = jQuery.extend({
						type: type,
						origType: origType,
						data: data,
						handler: handler,
						guid: handler.guid,
						selector: selector,
						needsContext: selector && jQuery.expr.match.needsContext.test(selector),
						namespace: namespaces.join(".")
					}, handleObjIn);
	
					// Init the event handler queue if we're the first
					if (!(handlers = events[type])) {
						handlers = events[type] = [];
						handlers.delegateCount = 0;
	
						// Only use addEventListener if the special events handler returns false
						if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
	
							if (elem.addEventListener) {
								elem.addEventListener(type, eventHandle);
							}
						}
					}
	
					if (special.add) {
						special.add.call(elem, handleObj);
	
						if (!handleObj.handler.guid) {
							handleObj.handler.guid = handler.guid;
						}
					}
	
					// Add to the element's handler list, delegates in front
					if (selector) {
						handlers.splice(handlers.delegateCount++, 0, handleObj);
					} else {
						handlers.push(handleObj);
					}
	
					// Keep track of which events have ever been used, for event optimization
					jQuery.event.global[type] = true;
				}
			},
	
			// Detach an event or set of events from an element
			remove: function remove(elem, types, handler, selector, mappedTypes) {
	
				var j,
				    origCount,
				    tmp,
				    events,
				    t,
				    handleObj,
				    special,
				    handlers,
				    type,
				    namespaces,
				    origType,
				    elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
	
				if (!elemData || !(events = elemData.events)) {
					return;
				}
	
				// Once for each type.namespace in types; type may be omitted
				types = (types || "").match(rnothtmlwhite) || [""];
				t = types.length;
				while (t--) {
					tmp = rtypenamespace.exec(types[t]) || [];
					type = origType = tmp[1];
					namespaces = (tmp[2] || "").split(".").sort();
	
					// Unbind all events (on this namespace, if provided) for the element
					if (!type) {
						for (type in events) {
							jQuery.event.remove(elem, type + types[t], handler, selector, true);
						}
						continue;
					}
	
					special = jQuery.event.special[type] || {};
					type = (selector ? special.delegateType : special.bindType) || type;
					handlers = events[type] || [];
					tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
	
					// Remove matching events
					origCount = j = handlers.length;
					while (j--) {
						handleObj = handlers[j];
	
						if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
							handlers.splice(j, 1);
	
							if (handleObj.selector) {
								handlers.delegateCount--;
							}
							if (special.remove) {
								special.remove.call(elem, handleObj);
							}
						}
					}
	
					// Remove generic event handler if we removed something and no more handlers exist
					// (avoids potential for endless recursion during removal of special event handlers)
					if (origCount && !handlers.length) {
						if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
	
							jQuery.removeEvent(elem, type, elemData.handle);
						}
	
						delete events[type];
					}
				}
	
				// Remove data and the expando if it's no longer used
				if (jQuery.isEmptyObject(events)) {
					dataPriv.remove(elem, "handle events");
				}
			},
	
			dispatch: function dispatch(nativeEvent) {
	
				// Make a writable jQuery.Event from the native event object
				var event = jQuery.event.fix(nativeEvent);
	
				var i,
				    j,
				    ret,
				    matched,
				    handleObj,
				    handlerQueue,
				    args = new Array(arguments.length),
				    handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
				    special = jQuery.event.special[event.type] || {};
	
				// Use the fix-ed jQuery.Event rather than the (read-only) native event
				args[0] = event;
	
				for (i = 1; i < arguments.length; i++) {
					args[i] = arguments[i];
				}
	
				event.delegateTarget = this;
	
				// Call the preDispatch hook for the mapped type, and let it bail if desired
				if (special.preDispatch && special.preDispatch.call(this, event) === false) {
					return;
				}
	
				// Determine handlers
				handlerQueue = jQuery.event.handlers.call(this, event, handlers);
	
				// Run delegates first; they may want to stop propagation beneath us
				i = 0;
				while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
					event.currentTarget = matched.elem;
	
					j = 0;
					while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
	
						// Triggered event must either 1) have no namespace, or 2) have namespace(s)
						// a subset or equal to those in the bound event (both can have no namespace).
						if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {
	
							event.handleObj = handleObj;
							event.data = handleObj.data;
	
							ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
	
							if (ret !== undefined) {
								if ((event.result = ret) === false) {
									event.preventDefault();
									event.stopPropagation();
								}
							}
						}
					}
				}
	
				// Call the postDispatch hook for the mapped type
				if (special.postDispatch) {
					special.postDispatch.call(this, event);
				}
	
				return event.result;
			},
	
			handlers: function handlers(event, _handlers) {
				var i,
				    handleObj,
				    sel,
				    matchedHandlers,
				    matchedSelectors,
				    handlerQueue = [],
				    delegateCount = _handlers.delegateCount,
				    cur = event.target;
	
				// Find delegate handlers
				if (delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!(event.type === "click" && event.button >= 1)) {
	
					for (; cur !== this; cur = cur.parentNode || this) {
	
						// Don't check non-elements (#13208)
						// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
						if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
							matchedHandlers = [];
							matchedSelectors = {};
							for (i = 0; i < delegateCount; i++) {
								handleObj = _handlers[i];
	
								// Don't conflict with Object.prototype properties (#13203)
								sel = handleObj.selector + " ";
	
								if (matchedSelectors[sel] === undefined) {
									matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
								}
								if (matchedSelectors[sel]) {
									matchedHandlers.push(handleObj);
								}
							}
							if (matchedHandlers.length) {
								handlerQueue.push({ elem: cur, handlers: matchedHandlers });
							}
						}
					}
				}
	
				// Add the remaining (directly-bound) handlers
				cur = this;
				if (delegateCount < _handlers.length) {
					handlerQueue.push({ elem: cur, handlers: _handlers.slice(delegateCount) });
				}
	
				return handlerQueue;
			},
	
			addProp: function addProp(name, hook) {
				Object.defineProperty(jQuery.Event.prototype, name, {
					enumerable: true,
					configurable: true,
	
					get: isFunction(hook) ? function () {
						if (this.originalEvent) {
							return hook(this.originalEvent);
						}
					} : function () {
						if (this.originalEvent) {
							return this.originalEvent[name];
						}
					},
	
					set: function set(value) {
						Object.defineProperty(this, name, {
							enumerable: true,
							configurable: true,
							writable: true,
							value: value
						});
					}
				});
			},
	
			fix: function fix(originalEvent) {
				return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
			},
	
			special: {
				load: {
	
					// Prevent triggered image.load events from bubbling to window.load
					noBubble: true
				},
				focus: {
	
					// Fire native event if possible so blur/focus sequence is correct
					trigger: function trigger() {
						if (this !== safeActiveElement() && this.focus) {
							this.focus();
							return false;
						}
					},
					delegateType: "focusin"
				},
				blur: {
					trigger: function trigger() {
						if (this === safeActiveElement() && this.blur) {
							this.blur();
							return false;
						}
					},
					delegateType: "focusout"
				},
				click: {
	
					// For checkbox, fire native event so checked state will be right
					trigger: function trigger() {
						if (this.type === "checkbox" && this.click && nodeName(this, "input")) {
							this.click();
							return false;
						}
					},
	
					// For cross-browser consistency, don't fire native .click() on links
					_default: function _default(event) {
						return nodeName(event.target, "a");
					}
				},
	
				beforeunload: {
					postDispatch: function postDispatch(event) {
	
						// Support: Firefox 20+
						// Firefox doesn't alert if the returnValue field is not set.
						if (event.result !== undefined && event.originalEvent) {
							event.originalEvent.returnValue = event.result;
						}
					}
				}
			}
		};
	
		jQuery.removeEvent = function (elem, type, handle) {
	
			// This "if" is needed for plain objects
			if (elem.removeEventListener) {
				elem.removeEventListener(type, handle);
			}
		};
	
		jQuery.Event = function (src, props) {
	
			// Allow instantiation without the 'new' keyword
			if (!(this instanceof jQuery.Event)) {
				return new jQuery.Event(src, props);
			}
	
			// Event object
			if (src && src.type) {
				this.originalEvent = src;
				this.type = src.type;
	
				// Events bubbling up the document may have been marked as prevented
				// by a handler lower down the tree; reflect the correct value.
				this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&
	
				// Support: Android <=2.3 only
				src.returnValue === false ? returnTrue : returnFalse;
	
				// Create target properties
				// Support: Safari <=6 - 7 only
				// Target should not be a text node (#504, #13143)
				this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
	
				this.currentTarget = src.currentTarget;
				this.relatedTarget = src.relatedTarget;
	
				// Event type
			} else {
				this.type = src;
			}
	
			// Put explicitly provided properties onto the event object
			if (props) {
				jQuery.extend(this, props);
			}
	
			// Create a timestamp if incoming event doesn't have one
			this.timeStamp = src && src.timeStamp || Date.now();
	
			// Mark it as fixed
			this[jQuery.expando] = true;
		};
	
		// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
		// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
		jQuery.Event.prototype = {
			constructor: jQuery.Event,
			isDefaultPrevented: returnFalse,
			isPropagationStopped: returnFalse,
			isImmediatePropagationStopped: returnFalse,
			isSimulated: false,
	
			preventDefault: function preventDefault() {
				var e = this.originalEvent;
	
				this.isDefaultPrevented = returnTrue;
	
				if (e && !this.isSimulated) {
					e.preventDefault();
				}
			},
			stopPropagation: function stopPropagation() {
				var e = this.originalEvent;
	
				this.isPropagationStopped = returnTrue;
	
				if (e && !this.isSimulated) {
					e.stopPropagation();
				}
			},
			stopImmediatePropagation: function stopImmediatePropagation() {
				var e = this.originalEvent;
	
				this.isImmediatePropagationStopped = returnTrue;
	
				if (e && !this.isSimulated) {
					e.stopImmediatePropagation();
				}
	
				this.stopPropagation();
			}
		};
	
		// Includes all common event props including KeyEvent and MouseEvent specific props
		jQuery.each({
			altKey: true,
			bubbles: true,
			cancelable: true,
			changedTouches: true,
			ctrlKey: true,
			detail: true,
			eventPhase: true,
			metaKey: true,
			pageX: true,
			pageY: true,
			shiftKey: true,
			view: true,
			"char": true,
			charCode: true,
			key: true,
			keyCode: true,
			button: true,
			buttons: true,
			clientX: true,
			clientY: true,
			offsetX: true,
			offsetY: true,
			pointerId: true,
			pointerType: true,
			screenX: true,
			screenY: true,
			targetTouches: true,
			toElement: true,
			touches: true,
	
			which: function which(event) {
				var button = event.button;
	
				// Add which for key events
				if (event.which == null && rkeyEvent.test(event.type)) {
					return event.charCode != null ? event.charCode : event.keyCode;
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
					if (button & 1) {
						return 1;
					}
	
					if (button & 2) {
						return 3;
					}
	
					if (button & 4) {
						return 2;
					}
	
					return 0;
				}
	
				return event.which;
			}
		}, jQuery.event.addProp);
	
		// Create mouseenter/leave events using mouseover/out and event-time checks
		// so that event delegation works in jQuery.
		// Do the same for pointerenter/pointerleave and pointerover/pointerout
		//
		// Support: Safari 7 only
		// Safari sends mouseenter too often; see:
		// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
		// for the description of the bug (it existed in older Chrome versions as well).
		jQuery.each({
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			pointerenter: "pointerover",
			pointerleave: "pointerout"
		}, function (orig, fix) {
			jQuery.event.special[orig] = {
				delegateType: fix,
				bindType: fix,
	
				handle: function handle(event) {
					var ret,
					    target = this,
					    related = event.relatedTarget,
					    handleObj = event.handleObj;
	
					// For mouseenter/leave call the handler if related is outside the target.
					// NB: No relatedTarget if the mouse left/entered the browser window
					if (!related || related !== target && !jQuery.contains(target, related)) {
						event.type = handleObj.origType;
						ret = handleObj.handler.apply(this, arguments);
						event.type = fix;
					}
					return ret;
				}
			};
		});
	
		jQuery.fn.extend({
	
			on: function on(types, selector, data, fn) {
				return _on(this, types, selector, data, fn);
			},
			one: function one(types, selector, data, fn) {
				return _on(this, types, selector, data, fn, 1);
			},
			off: function off(types, selector, fn) {
				var handleObj, type;
				if (types && types.preventDefault && types.handleObj) {
	
					// ( event )  dispatched jQuery.Event
					handleObj = types.handleObj;
					jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
					return this;
				}
				if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {
	
					// ( types-object [, selector] )
					for (type in types) {
						this.off(type, selector, types[type]);
					}
					return this;
				}
				if (selector === false || typeof selector === "function") {
	
					// ( types [, fn] )
					fn = selector;
					selector = undefined;
				}
				if (fn === false) {
					fn = returnFalse;
				}
				return this.each(function () {
					jQuery.event.remove(this, types, fn, selector);
				});
			}
		});
	
		var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
		// Prefer a tbody over its parent table for containing new rows
		function manipulationTarget(elem, content) {
			if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
	
				return jQuery(elem).children("tbody")[0] || elem;
			}
	
			return elem;
		}
	
		// Replace/restore the type attribute of script elements for safe DOM manipulation
		function disableScript(elem) {
			elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
			return elem;
		}
		function restoreScript(elem) {
			if ((elem.type || "").slice(0, 5) === "true/") {
				elem.type = elem.type.slice(5);
			} else {
				elem.removeAttribute("type");
			}
	
			return elem;
		}
	
		function cloneCopyEvent(src, dest) {
			var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
			if (dest.nodeType !== 1) {
				return;
			}
	
			// 1. Copy private data: events, handlers, etc.
			if (dataPriv.hasData(src)) {
				pdataOld = dataPriv.access(src);
				pdataCur = dataPriv.set(dest, pdataOld);
				events = pdataOld.events;
	
				if (events) {
					delete pdataCur.handle;
					pdataCur.events = {};
	
					for (type in events) {
						for (i = 0, l = events[type].length; i < l; i++) {
							jQuery.event.add(dest, type, events[type][i]);
						}
					}
				}
			}
	
			// 2. Copy user data
			if (dataUser.hasData(src)) {
				udataOld = dataUser.access(src);
				udataCur = jQuery.extend({}, udataOld);
	
				dataUser.set(dest, udataCur);
			}
		}
	
		// Fix IE bugs, see support tests
		function fixInput(src, dest) {
			var nodeName = dest.nodeName.toLowerCase();
	
			// Fails to persist the checked state of a cloned checkbox or radio button.
			if (nodeName === "input" && rcheckableType.test(src.type)) {
				dest.checked = src.checked;
	
				// Fails to return the selected option to the default selected state when cloning options
			} else if (nodeName === "input" || nodeName === "textarea") {
				dest.defaultValue = src.defaultValue;
			}
		}
	
		function domManip(collection, args, callback, ignored) {
	
			// Flatten any nested arrays
			args = concat.apply([], args);
	
			var fragment,
			    first,
			    scripts,
			    hasScripts,
			    node,
			    doc,
			    i = 0,
			    l = collection.length,
			    iNoClone = l - 1,
			    value = args[0],
			    valueIsFunction = isFunction(value);
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
				return collection.each(function (index) {
					var self = collection.eq(index);
					if (valueIsFunction) {
						args[0] = value.call(this, index, self.html());
					}
					domManip(self, args, callback, ignored);
				});
			}
	
			if (l) {
				fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
				first = fragment.firstChild;
	
				if (fragment.childNodes.length === 1) {
					fragment = first;
				}
	
				// Require either new content or an interest in ignored elements to invoke the callback
				if (first || ignored) {
					scripts = jQuery.map(getAll(fragment, "script"), disableScript);
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item
					// instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for (; i < l; i++) {
						node = fragment;
	
						if (i !== iNoClone) {
							node = jQuery.clone(node, true, true);
	
							// Keep references to cloned scripts for later restoration
							if (hasScripts) {
	
								// Support: Android <=4.0 only, PhantomJS 1 only
								// push.apply(_, arraylike) throws on ancient WebKit
								jQuery.merge(scripts, getAll(node, "script"));
							}
						}
	
						callback.call(collection[i], node, i);
					}
	
					if (hasScripts) {
						doc = scripts[scripts.length - 1].ownerDocument;
	
						// Reenable scripts
						jQuery.map(scripts, restoreScript);
	
						// Evaluate executable scripts on first document insertion
						for (i = 0; i < hasScripts; i++) {
							node = scripts[i];
							if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
	
								if (node.src && (node.type || "").toLowerCase() !== "module") {
	
									// Optional AJAX dependency, but won't run scripts if not present
									if (jQuery._evalUrl) {
										jQuery._evalUrl(node.src);
									}
								} else {
									DOMEval(node.textContent.replace(rcleanScript, ""), doc, node);
								}
							}
						}
					}
				}
			}
	
			return collection;
		}
	
		function _remove(elem, selector, keepData) {
			var node,
			    nodes = selector ? jQuery.filter(selector, elem) : elem,
			    i = 0;
	
			for (; (node = nodes[i]) != null; i++) {
				if (!keepData && node.nodeType === 1) {
					jQuery.cleanData(getAll(node));
				}
	
				if (node.parentNode) {
					if (keepData && jQuery.contains(node.ownerDocument, node)) {
						setGlobalEval(getAll(node, "script"));
					}
					node.parentNode.removeChild(node);
				}
			}
	
			return elem;
		}
	
		jQuery.extend({
			htmlPrefilter: function htmlPrefilter(html) {
				return html.replace(rxhtmlTag, "<$1></$2>");
			},
	
			clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
				var i,
				    l,
				    srcElements,
				    destElements,
				    clone = elem.cloneNode(true),
				    inPage = jQuery.contains(elem.ownerDocument, elem);
	
				// Fix IE cloning issues
				if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
	
					// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
					destElements = getAll(clone);
					srcElements = getAll(elem);
	
					for (i = 0, l = srcElements.length; i < l; i++) {
						fixInput(srcElements[i], destElements[i]);
					}
				}
	
				// Copy the events from the original to the clone
				if (dataAndEvents) {
					if (deepDataAndEvents) {
						srcElements = srcElements || getAll(elem);
						destElements = destElements || getAll(clone);
	
						for (i = 0, l = srcElements.length; i < l; i++) {
							cloneCopyEvent(srcElements[i], destElements[i]);
						}
					} else {
						cloneCopyEvent(elem, clone);
					}
				}
	
				// Preserve script evaluation history
				destElements = getAll(clone, "script");
				if (destElements.length > 0) {
					setGlobalEval(destElements, !inPage && getAll(elem, "script"));
				}
	
				// Return the cloned set
				return clone;
			},
	
			cleanData: function cleanData(elems) {
				var data,
				    elem,
				    type,
				    special = jQuery.event.special,
				    i = 0;
	
				for (; (elem = elems[i]) !== undefined; i++) {
					if (acceptData(elem)) {
						if (data = elem[dataPriv.expando]) {
							if (data.events) {
								for (type in data.events) {
									if (special[type]) {
										jQuery.event.remove(elem, type);
	
										// This is a shortcut to avoid jQuery.event.remove's overhead
									} else {
										jQuery.removeEvent(elem, type, data.handle);
									}
								}
							}
	
							// Support: Chrome <=35 - 45+
							// Assign undefined instead of using delete, see Data#remove
							elem[dataPriv.expando] = undefined;
						}
						if (elem[dataUser.expando]) {
	
							// Support: Chrome <=35 - 45+
							// Assign undefined instead of using delete, see Data#remove
							elem[dataUser.expando] = undefined;
						}
					}
				}
			}
		});
	
		jQuery.fn.extend({
			detach: function detach(selector) {
				return _remove(this, selector, true);
			},
	
			remove: function remove(selector) {
				return _remove(this, selector);
			},
	
			text: function text(value) {
				return access(this, function (value) {
					return value === undefined ? jQuery.text(this) : this.empty().each(function () {
						if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
							this.textContent = value;
						}
					});
				}, null, value, arguments.length);
			},
	
			append: function append() {
				return domManip(this, arguments, function (elem) {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						var target = manipulationTarget(this, elem);
						target.appendChild(elem);
					}
				});
			},
	
			prepend: function prepend() {
				return domManip(this, arguments, function (elem) {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						var target = manipulationTarget(this, elem);
						target.insertBefore(elem, target.firstChild);
					}
				});
			},
	
			before: function before() {
				return domManip(this, arguments, function (elem) {
					if (this.parentNode) {
						this.parentNode.insertBefore(elem, this);
					}
				});
			},
	
			after: function after() {
				return domManip(this, arguments, function (elem) {
					if (this.parentNode) {
						this.parentNode.insertBefore(elem, this.nextSibling);
					}
				});
			},
	
			empty: function empty() {
				var elem,
				    i = 0;
	
				for (; (elem = this[i]) != null; i++) {
					if (elem.nodeType === 1) {
	
						// Prevent memory leaks
						jQuery.cleanData(getAll(elem, false));
	
						// Remove any remaining nodes
						elem.textContent = "";
					}
				}
	
				return this;
			},
	
			clone: function clone(dataAndEvents, deepDataAndEvents) {
				dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
				deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
				return this.map(function () {
					return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
				});
			},
	
			html: function html(value) {
				return access(this, function (value) {
					var elem = this[0] || {},
					    i = 0,
					    l = this.length;
	
					if (value === undefined && elem.nodeType === 1) {
						return elem.innerHTML;
					}
	
					// See if we can take a shortcut and just use innerHTML
					if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
	
						value = jQuery.htmlPrefilter(value);
	
						try {
							for (; i < l; i++) {
								elem = this[i] || {};
	
								// Remove element nodes and prevent memory leaks
								if (elem.nodeType === 1) {
									jQuery.cleanData(getAll(elem, false));
									elem.innerHTML = value;
								}
							}
	
							elem = 0;
	
							// If using innerHTML throws an exception, use the fallback method
						} catch (e) {}
					}
	
					if (elem) {
						this.empty().append(value);
					}
				}, null, value, arguments.length);
			},
	
			replaceWith: function replaceWith() {
				var ignored = [];
	
				// Make the changes, replacing each non-ignored context element with the new content
				return domManip(this, arguments, function (elem) {
					var parent = this.parentNode;
	
					if (jQuery.inArray(this, ignored) < 0) {
						jQuery.cleanData(getAll(this));
						if (parent) {
							parent.replaceChild(elem, this);
						}
					}
	
					// Force callback invocation
				}, ignored);
			}
		});
	
		jQuery.each({
			appendTo: "append",
			prependTo: "prepend",
			insertBefore: "before",
			insertAfter: "after",
			replaceAll: "replaceWith"
		}, function (name, original) {
			jQuery.fn[name] = function (selector) {
				var elems,
				    ret = [],
				    insert = jQuery(selector),
				    last = insert.length - 1,
				    i = 0;
	
				for (; i <= last; i++) {
					elems = i === last ? this : this.clone(true);
					jQuery(insert[i])[original](elems);
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// .get() because push.apply(_, arraylike) throws on ancient WebKit
					push.apply(ret, elems.get());
				}
	
				return this.pushStack(ret);
			};
		});
		var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
	
		var getStyles = function getStyles(elem) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if (!view || !view.opener) {
				view = window;
			}
	
			return view.getComputedStyle(elem);
		};
	
		var rboxStyle = new RegExp(cssExpand.join("|"), "i");
	
		(function () {
	
			// Executing both pixelPosition & boxSizingReliable tests require only one layout
			// so they're executed at the same time to save the second computation.
			function computeStyleTests() {
	
				// This is a singleton, we need to execute it only once
				if (!div) {
					return;
				}
	
				container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
				div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
				documentElement.appendChild(container).appendChild(div);
	
				var divStyle = window.getComputedStyle(div);
				pixelPositionVal = divStyle.top !== "1%";
	
				// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
				reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
	
				// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
				// Some styles come back with percentage values, even though they shouldn't
				div.style.right = "60%";
				pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
	
				// Support: IE 9 - 11 only
				// Detect misreporting of content dimensions for box-sizing:border-box elements
				boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
	
				// Support: IE 9 only
				// Detect overflow:scroll screwiness (gh-3699)
				div.style.position = "absolute";
				scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
				documentElement.removeChild(container);
	
				// Nullify the div so it wouldn't be stored in the memory and
				// it will also be a sign that checks already performed
				div = null;
			}
	
			function roundPixelMeasures(measure) {
				return Math.round(parseFloat(measure));
			}
	
			var pixelPositionVal,
			    boxSizingReliableVal,
			    scrollboxSizeVal,
			    pixelBoxStylesVal,
			    reliableMarginLeftVal,
			    container = document.createElement("div"),
			    div = document.createElement("div");
	
			// Finish early in limited (non-browser) environments
			if (!div.style) {
				return;
			}
	
			// Support: IE <=9 - 11 only
			// Style of cloned element affects source element cloned (#8908)
			div.style.backgroundClip = "content-box";
			div.cloneNode(true).style.backgroundClip = "";
			support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
			jQuery.extend(support, {
				boxSizingReliable: function boxSizingReliable() {
					computeStyleTests();
					return boxSizingReliableVal;
				},
				pixelBoxStyles: function pixelBoxStyles() {
					computeStyleTests();
					return pixelBoxStylesVal;
				},
				pixelPosition: function pixelPosition() {
					computeStyleTests();
					return pixelPositionVal;
				},
				reliableMarginLeft: function reliableMarginLeft() {
					computeStyleTests();
					return reliableMarginLeftVal;
				},
				scrollboxSize: function scrollboxSize() {
					computeStyleTests();
					return scrollboxSizeVal;
				}
			});
		})();
	
		function curCSS(elem, name, computed) {
			var width,
			    minWidth,
			    maxWidth,
			    ret,
	
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
			computed = computed || getStyles(elem);
	
			// getPropertyValue is needed for:
			//   .css('filter') (IE 9 only, #12537)
			//   .css('--customProperty) (#3144)
			if (computed) {
				ret = computed.getPropertyValue(name) || computed[name];
	
				if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) {
					ret = jQuery.style(elem, name);
				}
	
				// A tribute to the "awesome hack by Dean Edwards"
				// Android Browser returns percentage for some values,
				// but width seems to be reliably pixels.
				// This is against the CSSOM draft spec:
				// https://drafts.csswg.org/cssom/#resolved-values
				if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
	
					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;
	
					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;
	
					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}
	
			return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" : ret;
		}
	
		function addGetHookIf(conditionFn, hookFn) {
	
			// Define the hook, we'll check on the first run if it's really needed.
			return {
				get: function get() {
					if (conditionFn()) {
	
						// Hook not needed (or it's not possible to use it due
						// to missing dependency), remove it.
						delete this.get;
						return;
					}
	
					// Hook needed; redefine it so that the support test is not executed again.
					return (this.get = hookFn).apply(this, arguments);
				}
			};
		}
	
		var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		    rcustomProp = /^--/,
		    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		    cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
		    cssPrefixes = ["Webkit", "Moz", "ms"],
		    emptyStyle = document.createElement("div").style;
	
		// Return a css property mapped to a potentially vendor prefixed property
		function vendorPropName(name) {
	
			// Shortcut for names that are not vendor prefixed
			if (name in emptyStyle) {
				return name;
			}
	
			// Check for vendor prefixed names
			var capName = name[0].toUpperCase() + name.slice(1),
			    i = cssPrefixes.length;
	
			while (i--) {
				name = cssPrefixes[i] + capName;
				if (name in emptyStyle) {
					return name;
				}
			}
		}
	
		// Return a property mapped along what jQuery.cssProps suggests or to
		// a vendor prefixed property.
		function finalPropName(name) {
			var ret = jQuery.cssProps[name];
			if (!ret) {
				ret = jQuery.cssProps[name] = vendorPropName(name) || name;
			}
			return ret;
		}
	
		function setPositiveNumber(elem, value, subtract) {
	
			// Any relative (+/-) values have already been
			// normalized at this point
			var matches = rcssNum.exec(value);
			return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
		}
	
		function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
			var i = dimension === "width" ? 1 : 0,
			    extra = 0,
			    delta = 0;
	
			// Adjustment may not be necessary
			if (box === (isBorderBox ? "border" : "content")) {
				return 0;
			}
	
			for (; i < 4; i += 2) {
	
				// Both box models exclude margin
				if (box === "margin") {
					delta += jQuery.css(elem, box + cssExpand[i], true, styles);
				}
	
				// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
				if (!isBorderBox) {
	
					// Add padding
					delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
	
					// For "border" or "margin", add border
					if (box !== "padding") {
						delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
	
						// But still keep track of it otherwise
					} else {
						extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
					}
	
					// If we get here with a border-box (content + padding + border), we're seeking "content" or
					// "padding" or "margin"
				} else {
	
					// For "content", subtract padding
					if (box === "content") {
						delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
					}
	
					// For "content" or "padding", subtract border
					if (box !== "margin") {
						delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
					}
				}
			}
	
			// Account for positive content-box scroll gutter when requested by providing computedVal
			if (!isBorderBox && computedVal >= 0) {
	
				// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
				// Assuming integer scroll gutter, subtract the rest and round down
				delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5));
			}
	
			return delta;
		}
	
		function getWidthOrHeight(elem, dimension, extra) {
	
			// Start with computed style
			var styles = getStyles(elem),
			    val = curCSS(elem, dimension, styles),
			    isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box",
			    valueIsBorderBox = isBorderBox;
	
			// Support: Firefox <=54
			// Return a confounding non-pixel value or feign ignorance, as appropriate.
			if (rnumnonpx.test(val)) {
				if (!extra) {
					return val;
				}
				val = "auto";
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = valueIsBorderBox && (support.boxSizingReliable() || val === elem.style[dimension]);
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			if (val === "auto" || !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") {
	
				val = elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)];
	
				// offsetWidth/offsetHeight provide border-box values
				valueIsBorderBox = true;
			}
	
			// Normalize "" and auto
			val = parseFloat(val) || 0;
	
			// Adjust for the element's box model
			return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,
	
			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val) + "px";
		}
	
		jQuery.extend({
	
			// Add in style property hooks for overriding the default
			// behavior of getting and setting a style property
			cssHooks: {
				opacity: {
					get: function get(elem, computed) {
						if (computed) {
	
							// We should always get a number back from opacity
							var ret = curCSS(elem, "opacity");
							return ret === "" ? "1" : ret;
						}
					}
				}
			},
	
			// Don't automatically add "px" to these possibly-unitless properties
			cssNumber: {
				"animationIterationCount": true,
				"columnCount": true,
				"fillOpacity": true,
				"flexGrow": true,
				"flexShrink": true,
				"fontWeight": true,
				"lineHeight": true,
				"opacity": true,
				"order": true,
				"orphans": true,
				"widows": true,
				"zIndex": true,
				"zoom": true
			},
	
			// Add in properties whose names you wish to fix before
			// setting or getting the value
			cssProps: {},
	
			// Get and set the style property on a DOM Node
			style: function style(elem, name, value, extra) {
	
				// Don't set styles on text and comment nodes
				if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
					return;
				}
	
				// Make sure that we're working with the right name
				var ret,
				    type,
				    hooks,
				    origName = camelCase(name),
				    isCustomProp = rcustomProp.test(name),
				    style = elem.style;
	
				// Make sure that we're working with the right name. We don't
				// want to query the value if it is a CSS custom property
				// since they are user-defined.
				if (!isCustomProp) {
					name = finalPropName(origName);
				}
	
				// Gets hook for the prefixed version, then unprefixed version
				hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
	
				// Check if we're setting a value
				if (value !== undefined) {
					type = typeof value === "undefined" ? "undefined" : _typeof(value);
	
					// Convert "+=" or "-=" to relative numbers (#7345)
					if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
						value = adjustCSS(elem, name, ret);
	
						// Fixes bug #9237
						type = "number";
					}
	
					// Make sure that null and NaN values aren't set (#7116)
					if (value == null || value !== value) {
						return;
					}
	
					// If a number was passed in, add the unit (except for certain CSS properties)
					if (type === "number") {
						value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
					}
	
					// background-* props affect original clone's values
					if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
						style[name] = "inherit";
					}
	
					// If a hook was provided, use that value, otherwise just set the specified value
					if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
	
						if (isCustomProp) {
							style.setProperty(name, value);
						} else {
							style[name] = value;
						}
					}
				} else {
	
					// If a hook was provided get the non-computed value from there
					if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
	
						return ret;
					}
	
					// Otherwise just get the value from the style object
					return style[name];
				}
			},
	
			css: function css(elem, name, extra, styles) {
				var val,
				    num,
				    hooks,
				    origName = camelCase(name),
				    isCustomProp = rcustomProp.test(name);
	
				// Make sure that we're working with the right name. We don't
				// want to modify the value if it is a CSS custom property
				// since they are user-defined.
				if (!isCustomProp) {
					name = finalPropName(origName);
				}
	
				// Try prefixed name followed by the unprefixed name
				hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
	
				// If a hook was provided get the computed value from there
				if (hooks && "get" in hooks) {
					val = hooks.get(elem, true, extra);
				}
	
				// Otherwise, if a way to get the computed value exists, use that
				if (val === undefined) {
					val = curCSS(elem, name, styles);
				}
	
				// Convert "normal" to computed value
				if (val === "normal" && name in cssNormalTransform) {
					val = cssNormalTransform[name];
				}
	
				// Make numeric if forced or a qualifier was provided and val looks numeric
				if (extra === "" || extra) {
					num = parseFloat(val);
					return extra === true || isFinite(num) ? num || 0 : val;
				}
	
				return val;
			}
		});
	
		jQuery.each(["height", "width"], function (i, dimension) {
			jQuery.cssHooks[dimension] = {
				get: function get(elem, computed, extra) {
					if (computed) {
	
						// Certain elements can have dimension info if we invisibly show them
						// but it must have a current display style that would benefit
						return rdisplayswap.test(jQuery.css(elem, "display")) && (
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
							return getWidthOrHeight(elem, dimension, extra);
						}) : getWidthOrHeight(elem, dimension, extra);
					}
				},
	
				set: function set(elem, value, extra) {
					var matches,
					    styles = getStyles(elem),
					    isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box",
					    subtract = extra && boxModelAdjustment(elem, dimension, extra, isBorderBox, styles);
	
					// Account for unreliable border-box dimensions by comparing offset* to computed and
					// faking a content-box to get border and padding (gh-3699)
					if (isBorderBox && support.scrollboxSize() === styles.position) {
						subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
					}
	
					// Convert to pixels if value adjustment is needed
					if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
	
						elem.style[dimension] = value;
						value = jQuery.css(elem, dimension);
					}
	
					return setPositiveNumber(elem, value, subtract);
				}
			};
		});
	
		jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
			if (computed) {
				return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function () {
					return elem.getBoundingClientRect().left;
				})) + "px";
			}
		});
	
		// These hooks are used by animate to expand properties
		jQuery.each({
			margin: "",
			padding: "",
			border: "Width"
		}, function (prefix, suffix) {
			jQuery.cssHooks[prefix + suffix] = {
				expand: function expand(value) {
					var i = 0,
					    expanded = {},
	
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [value];
	
					for (; i < 4; i++) {
						expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
					}
	
					return expanded;
				}
			};
	
			if (prefix !== "margin") {
				jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
			}
		});
	
		jQuery.fn.extend({
			css: function css(name, value) {
				return access(this, function (elem, name, value) {
					var styles,
					    len,
					    map = {},
					    i = 0;
	
					if (Array.isArray(name)) {
						styles = getStyles(elem);
						len = name.length;
	
						for (; i < len; i++) {
							map[name[i]] = jQuery.css(elem, name[i], false, styles);
						}
	
						return map;
					}
	
					return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
				}, name, value, arguments.length > 1);
			}
		});
	
		function Tween(elem, options, prop, end, easing) {
			return new Tween.prototype.init(elem, options, prop, end, easing);
		}
		jQuery.Tween = Tween;
	
		Tween.prototype = {
			constructor: Tween,
			init: function init(elem, options, prop, end, easing, unit) {
				this.elem = elem;
				this.prop = prop;
				this.easing = easing || jQuery.easing._default;
				this.options = options;
				this.start = this.now = this.cur();
				this.end = end;
				this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
			},
			cur: function cur() {
				var hooks = Tween.propHooks[this.prop];
	
				return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
			},
			run: function run(percent) {
				var eased,
				    hooks = Tween.propHooks[this.prop];
	
				if (this.options.duration) {
					this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
				} else {
					this.pos = eased = percent;
				}
				this.now = (this.end - this.start) * eased + this.start;
	
				if (this.options.step) {
					this.options.step.call(this.elem, this.now, this);
				}
	
				if (hooks && hooks.set) {
					hooks.set(this);
				} else {
					Tween.propHooks._default.set(this);
				}
				return this;
			}
		};
	
		Tween.prototype.init.prototype = Tween.prototype;
	
		Tween.propHooks = {
			_default: {
				get: function get(tween) {
					var result;
	
					// Use a property on the element directly when it is not a DOM element,
					// or when there is no matching style property that exists.
					if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
						return tween.elem[tween.prop];
					}
	
					// Passing an empty string as a 3rd parameter to .css will automatically
					// attempt a parseFloat and fallback to a string if the parse fails.
					// Simple values such as "10px" are parsed to Float;
					// complex values such as "rotate(1rad)" are returned as-is.
					result = jQuery.css(tween.elem, tween.prop, "");
	
					// Empty strings, null, undefined and "auto" are converted to 0.
					return !result || result === "auto" ? 0 : result;
				},
				set: function set(tween) {
	
					// Use step hook for back compat.
					// Use cssHook if its there.
					// Use .style if available and use plain properties where available.
					if (jQuery.fx.step[tween.prop]) {
						jQuery.fx.step[tween.prop](tween);
					} else if (tween.elem.nodeType === 1 && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) {
						jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
					} else {
						tween.elem[tween.prop] = tween.now;
					}
				}
			}
		};
	
		// Support: IE <=9 only
		// Panic based approach to setting things on disconnected nodes
		Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
			set: function set(tween) {
				if (tween.elem.nodeType && tween.elem.parentNode) {
					tween.elem[tween.prop] = tween.now;
				}
			}
		};
	
		jQuery.easing = {
			linear: function linear(p) {
				return p;
			},
			swing: function swing(p) {
				return 0.5 - Math.cos(p * Math.PI) / 2;
			},
			_default: "swing"
		};
	
		jQuery.fx = Tween.prototype.init;
	
		// Back compat <1.8 extension point
		jQuery.fx.step = {};
	
		var fxNow,
		    inProgress,
		    rfxtypes = /^(?:toggle|show|hide)$/,
		    rrun = /queueHooks$/;
	
		function schedule() {
			if (inProgress) {
				if (document.hidden === false && window.requestAnimationFrame) {
					window.requestAnimationFrame(schedule);
				} else {
					window.setTimeout(schedule, jQuery.fx.interval);
				}
	
				jQuery.fx.tick();
			}
		}
	
		// Animations created synchronously will run synchronously
		function createFxNow() {
			window.setTimeout(function () {
				fxNow = undefined;
			});
			return fxNow = Date.now();
		}
	
		// Generate parameters to create a standard animation
		function genFx(type, includeWidth) {
			var which,
			    i = 0,
			    attrs = { height: type };
	
			// If we include width, step value is 1 to do all cssExpand values,
			// otherwise step value is 2 to skip over Left and Right
			includeWidth = includeWidth ? 1 : 0;
			for (; i < 4; i += 2 - includeWidth) {
				which = cssExpand[i];
				attrs["margin" + which] = attrs["padding" + which] = type;
			}
	
			if (includeWidth) {
				attrs.opacity = attrs.width = type;
			}
	
			return attrs;
		}
	
		function createTween(value, prop, animation) {
			var tween,
			    collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
			    index = 0,
			    length = collection.length;
			for (; index < length; index++) {
				if (tween = collection[index].call(animation, prop, value)) {
	
					// We're done with this property
					return tween;
				}
			}
		}
	
		function defaultPrefilter(elem, props, opts) {
			var prop,
			    value,
			    toggle,
			    hooks,
			    oldfire,
			    propTween,
			    restoreDisplay,
			    display,
			    isBox = "width" in props || "height" in props,
			    anim = this,
			    orig = {},
			    style = elem.style,
			    hidden = elem.nodeType && isHiddenWithinTree(elem),
			    dataShow = dataPriv.get(elem, "fxshow");
	
			// Queue-skipping animations hijack the fx hooks
			if (!opts.queue) {
				hooks = jQuery._queueHooks(elem, "fx");
				if (hooks.unqueued == null) {
					hooks.unqueued = 0;
					oldfire = hooks.empty.fire;
					hooks.empty.fire = function () {
						if (!hooks.unqueued) {
							oldfire();
						}
					};
				}
				hooks.unqueued++;
	
				anim.always(function () {
	
					// Ensure the complete handler is called before this completes
					anim.always(function () {
						hooks.unqueued--;
						if (!jQuery.queue(elem, "fx").length) {
							hooks.empty.fire();
						}
					});
				});
			}
	
			// Detect show/hide animations
			for (prop in props) {
				value = props[prop];
				if (rfxtypes.test(value)) {
					delete props[prop];
					toggle = toggle || value === "toggle";
					if (value === (hidden ? "hide" : "show")) {
	
						// Pretend to be hidden if this is a "show" and
						// there is still data from a stopped show/hide
						if (value === "show" && dataShow && dataShow[prop] !== undefined) {
							hidden = true;
	
							// Ignore all other no-op show/hide data
						} else {
							continue;
						}
					}
					orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
				}
			}
	
			// Bail out if this is a no-op like .hide().hide()
			propTween = !jQuery.isEmptyObject(props);
			if (!propTween && jQuery.isEmptyObject(orig)) {
				return;
			}
	
			// Restrict "overflow" and "display" styles during box animations
			if (isBox && elem.nodeType === 1) {
	
				// Support: IE <=9 - 11, Edge 12 - 15
				// Record all 3 overflow attributes because IE does not infer the shorthand
				// from identically-valued overflowX and overflowY and Edge just mirrors
				// the overflowX value there.
				opts.overflow = [style.overflow, style.overflowX, style.overflowY];
	
				// Identify a display type, preferring old show/hide data over the CSS cascade
				restoreDisplay = dataShow && dataShow.display;
				if (restoreDisplay == null) {
					restoreDisplay = dataPriv.get(elem, "display");
				}
				display = jQuery.css(elem, "display");
				if (display === "none") {
					if (restoreDisplay) {
						display = restoreDisplay;
					} else {
	
						// Get nonempty value(s) by temporarily forcing visibility
						showHide([elem], true);
						restoreDisplay = elem.style.display || restoreDisplay;
						display = jQuery.css(elem, "display");
						showHide([elem]);
					}
				}
	
				// Animate inline elements as inline-block
				if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
					if (jQuery.css(elem, "float") === "none") {
	
						// Restore the original display value at the end of pure show/hide animations
						if (!propTween) {
							anim.done(function () {
								style.display = restoreDisplay;
							});
							if (restoreDisplay == null) {
								display = style.display;
								restoreDisplay = display === "none" ? "" : display;
							}
						}
						style.display = "inline-block";
					}
				}
			}
	
			if (opts.overflow) {
				style.overflow = "hidden";
				anim.always(function () {
					style.overflow = opts.overflow[0];
					style.overflowX = opts.overflow[1];
					style.overflowY = opts.overflow[2];
				});
			}
	
			// Implement show/hide animations
			propTween = false;
			for (prop in orig) {
	
				// General show/hide setup for this element animation
				if (!propTween) {
					if (dataShow) {
						if ("hidden" in dataShow) {
							hidden = dataShow.hidden;
						}
					} else {
						dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
					}
	
					// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
					if (toggle) {
						dataShow.hidden = !hidden;
					}
	
					// Show elements before animating them
					if (hidden) {
						showHide([elem], true);
					}
	
					/* eslint-disable no-loop-func */
	
					anim.done(function () {
	
						/* eslint-enable no-loop-func */
	
						// The final step of a "hide" animation is actually hiding the element
						if (!hidden) {
							showHide([elem]);
						}
						dataPriv.remove(elem, "fxshow");
						for (prop in orig) {
							jQuery.style(elem, prop, orig[prop]);
						}
					});
				}
	
				// Per-property setup
				propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
				if (!(prop in dataShow)) {
					dataShow[prop] = propTween.start;
					if (hidden) {
						propTween.end = propTween.start;
						propTween.start = 0;
					}
				}
			}
		}
	
		function propFilter(props, specialEasing) {
			var index, name, easing, value, hooks;
	
			// camelCase, specialEasing and expand cssHook pass
			for (index in props) {
				name = camelCase(index);
				easing = specialEasing[name];
				value = props[index];
				if (Array.isArray(value)) {
					easing = value[1];
					value = props[index] = value[0];
				}
	
				if (index !== name) {
					props[name] = value;
					delete props[index];
				}
	
				hooks = jQuery.cssHooks[name];
				if (hooks && "expand" in hooks) {
					value = hooks.expand(value);
					delete props[name];
	
					// Not quite $.extend, this won't overwrite existing keys.
					// Reusing 'index' because we have the correct "name"
					for (index in value) {
						if (!(index in props)) {
							props[index] = value[index];
							specialEasing[index] = easing;
						}
					}
				} else {
					specialEasing[name] = easing;
				}
			}
		}
	
		function Animation(elem, properties, options) {
			var result,
			    stopped,
			    index = 0,
			    length = Animation.prefilters.length,
			    deferred = jQuery.Deferred().always(function () {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			}),
			    tick = function tick() {
				if (stopped) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
				    remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
	
	
				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				    percent = 1 - temp,
				    index = 0,
				    length = animation.tweens.length;
	
				for (; index < length; index++) {
					animation.tweens[index].run(percent);
				}
	
				deferred.notifyWith(elem, [animation, percent, remaining]);
	
				// If there's more to do, yield
				if (percent < 1 && length) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if (!length) {
					deferred.notifyWith(elem, [animation, 1, 0]);
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith(elem, [animation]);
				return false;
			},
			    animation = deferred.promise({
				elem: elem,
				props: jQuery.extend({}, properties),
				opts: jQuery.extend(true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function createTween(prop, end) {
					var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
					animation.tweens.push(tween);
					return tween;
				},
				stop: function stop(gotoEnd) {
					var index = 0,
	
	
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
					if (stopped) {
						return this;
					}
					stopped = true;
					for (; index < length; index++) {
						animation.tweens[index].run(1);
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if (gotoEnd) {
						deferred.notifyWith(elem, [animation, 1, 0]);
						deferred.resolveWith(elem, [animation, gotoEnd]);
					} else {
						deferred.rejectWith(elem, [animation, gotoEnd]);
					}
					return this;
				}
			}),
			    props = animation.props;
	
			propFilter(props, animation.opts.specialEasing);
	
			for (; index < length; index++) {
				result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
				if (result) {
					if (isFunction(result.stop)) {
						jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
					}
					return result;
				}
			}
	
			jQuery.map(props, createTween, animation);
	
			if (isFunction(animation.opts.start)) {
				animation.opts.start.call(elem, animation);
			}
	
			// Attach callbacks from options
			animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
	
			jQuery.fx.timer(jQuery.extend(tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			}));
	
			return animation;
		}
	
		jQuery.Animation = jQuery.extend(Animation, {
	
			tweeners: {
				"*": [function (prop, value) {
					var tween = this.createTween(prop, value);
					adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
					return tween;
				}]
			},
	
			tweener: function tweener(props, callback) {
				if (isFunction(props)) {
					callback = props;
					props = ["*"];
				} else {
					props = props.match(rnothtmlwhite);
				}
	
				var prop,
				    index = 0,
				    length = props.length;
	
				for (; index < length; index++) {
					prop = props[index];
					Animation.tweeners[prop] = Animation.tweeners[prop] || [];
					Animation.tweeners[prop].unshift(callback);
				}
			},
	
			prefilters: [defaultPrefilter],
	
			prefilter: function prefilter(callback, prepend) {
				if (prepend) {
					Animation.prefilters.unshift(callback);
				} else {
					Animation.prefilters.push(callback);
				}
			}
		});
	
		jQuery.speed = function (speed, easing, fn) {
			var opt = speed && (typeof speed === "undefined" ? "undefined" : _typeof(speed)) === "object" ? jQuery.extend({}, speed) : {
				complete: fn || !fn && easing || isFunction(speed) && speed,
				duration: speed,
				easing: fn && easing || easing && !isFunction(easing) && easing
			};
	
			// Go to the end state if fx are off
			if (jQuery.fx.off) {
				opt.duration = 0;
			} else {
				if (typeof opt.duration !== "number") {
					if (opt.duration in jQuery.fx.speeds) {
						opt.duration = jQuery.fx.speeds[opt.duration];
					} else {
						opt.duration = jQuery.fx.speeds._default;
					}
				}
			}
	
			// Normalize opt.queue - true/undefined/null -> "fx"
			if (opt.queue == null || opt.queue === true) {
				opt.queue = "fx";
			}
	
			// Queueing
			opt.old = opt.complete;
	
			opt.complete = function () {
				if (isFunction(opt.old)) {
					opt.old.call(this);
				}
	
				if (opt.queue) {
					jQuery.dequeue(this, opt.queue);
				}
			};
	
			return opt;
		};
	
		jQuery.fn.extend({
			fadeTo: function fadeTo(speed, to, easing, callback) {
	
				// Show any hidden elements after setting opacity to 0
				return this.filter(isHiddenWithinTree).css("opacity", 0).show()
	
				// Animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback);
			},
			animate: function animate(prop, speed, easing, callback) {
				var empty = jQuery.isEmptyObject(prop),
				    optall = jQuery.speed(speed, easing, callback),
				    doAnimation = function doAnimation() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation(this, jQuery.extend({}, prop), optall);
	
					// Empty animations, or finishing resolves immediately
					if (empty || dataPriv.get(this, "finish")) {
						anim.stop(true);
					}
				};
				doAnimation.finish = doAnimation;
	
				return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
			},
			stop: function stop(type, clearQueue, gotoEnd) {
				var stopQueue = function stopQueue(hooks) {
					var stop = hooks.stop;
					delete hooks.stop;
					stop(gotoEnd);
				};
	
				if (typeof type !== "string") {
					gotoEnd = clearQueue;
					clearQueue = type;
					type = undefined;
				}
				if (clearQueue && type !== false) {
					this.queue(type || "fx", []);
				}
	
				return this.each(function () {
					var dequeue = true,
					    index = type != null && type + "queueHooks",
					    timers = jQuery.timers,
					    data = dataPriv.get(this);
	
					if (index) {
						if (data[index] && data[index].stop) {
							stopQueue(data[index]);
						}
					} else {
						for (index in data) {
							if (data[index] && data[index].stop && rrun.test(index)) {
								stopQueue(data[index]);
							}
						}
					}
	
					for (index = timers.length; index--;) {
						if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
	
							timers[index].anim.stop(gotoEnd);
							dequeue = false;
							timers.splice(index, 1);
						}
					}
	
					// Start the next in the queue if the last step wasn't forced.
					// Timers currently will call their complete callbacks, which
					// will dequeue but only if they were gotoEnd.
					if (dequeue || !gotoEnd) {
						jQuery.dequeue(this, type);
					}
				});
			},
			finish: function finish(type) {
				if (type !== false) {
					type = type || "fx";
				}
				return this.each(function () {
					var index,
					    data = dataPriv.get(this),
					    queue = data[type + "queue"],
					    hooks = data[type + "queueHooks"],
					    timers = jQuery.timers,
					    length = queue ? queue.length : 0;
	
					// Enable finishing flag on private data
					data.finish = true;
	
					// Empty the queue first
					jQuery.queue(this, type, []);
	
					if (hooks && hooks.stop) {
						hooks.stop.call(this, true);
					}
	
					// Look for any active animations, and finish them
					for (index = timers.length; index--;) {
						if (timers[index].elem === this && timers[index].queue === type) {
							timers[index].anim.stop(true);
							timers.splice(index, 1);
						}
					}
	
					// Look for any animations in the old queue and finish them
					for (index = 0; index < length; index++) {
						if (queue[index] && queue[index].finish) {
							queue[index].finish.call(this);
						}
					}
	
					// Turn off finishing flag
					delete data.finish;
				});
			}
		});
	
		jQuery.each(["toggle", "show", "hide"], function (i, name) {
			var cssFn = jQuery.fn[name];
			jQuery.fn[name] = function (speed, easing, callback) {
				return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
			};
		});
	
		// Generate shortcuts for custom animations
		jQuery.each({
			slideDown: genFx("show"),
			slideUp: genFx("hide"),
			slideToggle: genFx("toggle"),
			fadeIn: { opacity: "show" },
			fadeOut: { opacity: "hide" },
			fadeToggle: { opacity: "toggle" }
		}, function (name, props) {
			jQuery.fn[name] = function (speed, easing, callback) {
				return this.animate(props, speed, easing, callback);
			};
		});
	
		jQuery.timers = [];
		jQuery.fx.tick = function () {
			var timer,
			    i = 0,
			    timers = jQuery.timers;
	
			fxNow = Date.now();
	
			for (; i < timers.length; i++) {
				timer = timers[i];
	
				// Run the timer and safely remove it when done (allowing for external removal)
				if (!timer() && timers[i] === timer) {
					timers.splice(i--, 1);
				}
			}
	
			if (!timers.length) {
				jQuery.fx.stop();
			}
			fxNow = undefined;
		};
	
		jQuery.fx.timer = function (timer) {
			jQuery.timers.push(timer);
			jQuery.fx.start();
		};
	
		jQuery.fx.interval = 13;
		jQuery.fx.start = function () {
			if (inProgress) {
				return;
			}
	
			inProgress = true;
			schedule();
		};
	
		jQuery.fx.stop = function () {
			inProgress = null;
		};
	
		jQuery.fx.speeds = {
			slow: 600,
			fast: 200,
	
			// Default speed
			_default: 400
		};
	
		// Based off of the plugin by Clint Helfers, with permission.
		// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
		jQuery.fn.delay = function (time, type) {
			time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
			type = type || "fx";
	
			return this.queue(type, function (next, hooks) {
				var timeout = window.setTimeout(next, time);
				hooks.stop = function () {
					window.clearTimeout(timeout);
				};
			});
		};
	
		(function () {
			var input = document.createElement("input"),
			    select = document.createElement("select"),
			    opt = select.appendChild(document.createElement("option"));
	
			input.type = "checkbox";
	
			// Support: Android <=4.3 only
			// Default value for a checkbox should be "on"
			support.checkOn = input.value !== "";
	
			// Support: IE <=11 only
			// Must access selectedIndex to make default options select
			support.optSelected = opt.selected;
	
			// Support: IE <=11 only
			// An input loses its value after becoming a radio
			input = document.createElement("input");
			input.value = "t";
			input.type = "radio";
			support.radioValue = input.value === "t";
		})();
	
		var boolHook,
		    attrHandle = jQuery.expr.attrHandle;
	
		jQuery.fn.extend({
			attr: function attr(name, value) {
				return access(this, jQuery.attr, name, value, arguments.length > 1);
			},
	
			removeAttr: function removeAttr(name) {
				return this.each(function () {
					jQuery.removeAttr(this, name);
				});
			}
		});
	
		jQuery.extend({
			attr: function attr(elem, name, value) {
				var ret,
				    hooks,
				    nType = elem.nodeType;
	
				// Don't get/set attributes on text, comment and attribute nodes
				if (nType === 3 || nType === 8 || nType === 2) {
					return;
				}
	
				// Fallback to prop when attributes are not supported
				if (typeof elem.getAttribute === "undefined") {
					return jQuery.prop(elem, name, value);
				}
	
				// Attribute hooks are determined by the lowercase version
				// Grab necessary hook if one is defined
				if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
					hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
				}
	
				if (value !== undefined) {
					if (value === null) {
						jQuery.removeAttr(elem, name);
						return;
					}
	
					if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
						return ret;
					}
	
					elem.setAttribute(name, value + "");
					return value;
				}
	
				if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
					return ret;
				}
	
				ret = jQuery.find.attr(elem, name);
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ? undefined : ret;
			},
	
			attrHooks: {
				type: {
					set: function set(elem, value) {
						if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
							var val = elem.value;
							elem.setAttribute("type", value);
							if (val) {
								elem.value = val;
							}
							return value;
						}
					}
				}
			},
	
			removeAttr: function removeAttr(elem, value) {
				var name,
				    i = 0,
	
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match(rnothtmlwhite);
	
				if (attrNames && elem.nodeType === 1) {
					while (name = attrNames[i++]) {
						elem.removeAttribute(name);
					}
				}
			}
		});
	
		// Hooks for boolean attributes
		boolHook = {
			set: function set(elem, value, name) {
				if (value === false) {
	
					// Remove boolean attributes when set to false
					jQuery.removeAttr(elem, name);
				} else {
					elem.setAttribute(name, name);
				}
				return name;
			}
		};
	
		jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
			var getter = attrHandle[name] || jQuery.find.attr;
	
			attrHandle[name] = function (elem, name, isXML) {
				var ret,
				    handle,
				    lowercaseName = name.toLowerCase();
	
				if (!isXML) {
	
					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[lowercaseName];
					attrHandle[lowercaseName] = ret;
					ret = getter(elem, name, isXML) != null ? lowercaseName : null;
					attrHandle[lowercaseName] = handle;
				}
				return ret;
			};
		});
	
		var rfocusable = /^(?:input|select|textarea|button)$/i,
		    rclickable = /^(?:a|area)$/i;
	
		jQuery.fn.extend({
			prop: function prop(name, value) {
				return access(this, jQuery.prop, name, value, arguments.length > 1);
			},
	
			removeProp: function removeProp(name) {
				return this.each(function () {
					delete this[jQuery.propFix[name] || name];
				});
			}
		});
	
		jQuery.extend({
			prop: function prop(elem, name, value) {
				var ret,
				    hooks,
				    nType = elem.nodeType;
	
				// Don't get/set properties on text, comment and attribute nodes
				if (nType === 3 || nType === 8 || nType === 2) {
					return;
				}
	
				if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
	
					// Fix name and attach hooks
					name = jQuery.propFix[name] || name;
					hooks = jQuery.propHooks[name];
				}
	
				if (value !== undefined) {
					if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
						return ret;
					}
	
					return elem[name] = value;
				}
	
				if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
					return ret;
				}
	
				return elem[name];
			},
	
			propHooks: {
				tabIndex: {
					get: function get(elem) {
	
						// Support: IE <=9 - 11 only
						// elem.tabIndex doesn't always return the
						// correct value when it hasn't been explicitly set
						// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
						// Use proper attribute retrieval(#12072)
						var tabindex = jQuery.find.attr(elem, "tabindex");
	
						if (tabindex) {
							return parseInt(tabindex, 10);
						}
	
						if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
							return 0;
						}
	
						return -1;
					}
				}
			},
	
			propFix: {
				"for": "htmlFor",
				"class": "className"
			}
		});
	
		// Support: IE <=11 only
		// Accessing the selectedIndex property
		// forces the browser to respect setting selected
		// on the option
		// The getter ensures a default option is selected
		// when in an optgroup
		// eslint rule "no-unused-expressions" is disabled for this code
		// since it considers such accessions noop
		if (!support.optSelected) {
			jQuery.propHooks.selected = {
				get: function get(elem) {
	
					/* eslint no-unused-expressions: "off" */
	
					var parent = elem.parentNode;
					if (parent && parent.parentNode) {
						parent.parentNode.selectedIndex;
					}
					return null;
				},
				set: function set(elem) {
	
					/* eslint no-unused-expressions: "off" */
	
					var parent = elem.parentNode;
					if (parent) {
						parent.selectedIndex;
	
						if (parent.parentNode) {
							parent.parentNode.selectedIndex;
						}
					}
				}
			};
		}
	
		jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
			jQuery.propFix[this.toLowerCase()] = this;
		});
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse(value) {
			var tokens = value.match(rnothtmlwhite) || [];
			return tokens.join(" ");
		}
	
		function getClass(elem) {
			return elem.getAttribute && elem.getAttribute("class") || "";
		}
	
		function classesToArray(value) {
			if (Array.isArray(value)) {
				return value;
			}
			if (typeof value === "string") {
				return value.match(rnothtmlwhite) || [];
			}
			return [];
		}
	
		jQuery.fn.extend({
			addClass: function addClass(value) {
				var classes,
				    elem,
				    cur,
				    curValue,
				    clazz,
				    j,
				    finalValue,
				    i = 0;
	
				if (isFunction(value)) {
					return this.each(function (j) {
						jQuery(this).addClass(value.call(this, j, getClass(this)));
					});
				}
	
				classes = classesToArray(value);
	
				if (classes.length) {
					while (elem = this[i++]) {
						curValue = getClass(elem);
						cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
	
						if (cur) {
							j = 0;
							while (clazz = classes[j++]) {
								if (cur.indexOf(" " + clazz + " ") < 0) {
									cur += clazz + " ";
								}
							}
	
							// Only assign if different to avoid unneeded rendering.
							finalValue = stripAndCollapse(cur);
							if (curValue !== finalValue) {
								elem.setAttribute("class", finalValue);
							}
						}
					}
				}
	
				return this;
			},
	
			removeClass: function removeClass(value) {
				var classes,
				    elem,
				    cur,
				    curValue,
				    clazz,
				    j,
				    finalValue,
				    i = 0;
	
				if (isFunction(value)) {
					return this.each(function (j) {
						jQuery(this).removeClass(value.call(this, j, getClass(this)));
					});
				}
	
				if (!arguments.length) {
					return this.attr("class", "");
				}
	
				classes = classesToArray(value);
	
				if (classes.length) {
					while (elem = this[i++]) {
						curValue = getClass(elem);
	
						// This expression is here for better compressibility (see addClass)
						cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
	
						if (cur) {
							j = 0;
							while (clazz = classes[j++]) {
	
								// Remove *all* instances
								while (cur.indexOf(" " + clazz + " ") > -1) {
									cur = cur.replace(" " + clazz + " ", " ");
								}
							}
	
							// Only assign if different to avoid unneeded rendering.
							finalValue = stripAndCollapse(cur);
							if (curValue !== finalValue) {
								elem.setAttribute("class", finalValue);
							}
						}
					}
				}
	
				return this;
			},
	
			toggleClass: function toggleClass(value, stateVal) {
				var type = typeof value === "undefined" ? "undefined" : _typeof(value),
				    isValidValue = type === "string" || Array.isArray(value);
	
				if (typeof stateVal === "boolean" && isValidValue) {
					return stateVal ? this.addClass(value) : this.removeClass(value);
				}
	
				if (isFunction(value)) {
					return this.each(function (i) {
						jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
					});
				}
	
				return this.each(function () {
					var className, i, self, classNames;
	
					if (isValidValue) {
	
						// Toggle individual class names
						i = 0;
						self = jQuery(this);
						classNames = classesToArray(value);
	
						while (className = classNames[i++]) {
	
							// Check each className given, space separated list
							if (self.hasClass(className)) {
								self.removeClass(className);
							} else {
								self.addClass(className);
							}
						}
	
						// Toggle whole class name
					} else if (value === undefined || type === "boolean") {
						className = getClass(this);
						if (className) {
	
							// Store className if set
							dataPriv.set(this, "__className__", className);
						}
	
						// If the element has a class name or if we're passed `false`,
						// then remove the whole classname (if there was one, the above saved it).
						// Otherwise bring back whatever was previously saved (if anything),
						// falling back to the empty string if nothing was stored.
						if (this.setAttribute) {
							this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
						}
					}
				});
			},
	
			hasClass: function hasClass(selector) {
				var className,
				    elem,
				    i = 0;
	
				className = " " + selector + " ";
				while (elem = this[i++]) {
					if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
						return true;
					}
				}
	
				return false;
			}
		});
	
		var rreturn = /\r/g;
	
		jQuery.fn.extend({
			val: function val(value) {
				var hooks,
				    ret,
				    valueIsFunction,
				    elem = this[0];
	
				if (!arguments.length) {
					if (elem) {
						hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
	
						if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
							return ret;
						}
	
						ret = elem.value;
	
						// Handle most common string cases
						if (typeof ret === "string") {
							return ret.replace(rreturn, "");
						}
	
						// Handle cases where value is null/undef or number
						return ret == null ? "" : ret;
					}
	
					return;
				}
	
				valueIsFunction = isFunction(value);
	
				return this.each(function (i) {
					var val;
	
					if (this.nodeType !== 1) {
						return;
					}
	
					if (valueIsFunction) {
						val = value.call(this, i, jQuery(this).val());
					} else {
						val = value;
					}
	
					// Treat null/undefined as ""; convert numbers to string
					if (val == null) {
						val = "";
					} else if (typeof val === "number") {
						val += "";
					} else if (Array.isArray(val)) {
						val = jQuery.map(val, function (value) {
							return value == null ? "" : value + "";
						});
					}
	
					hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
	
					// If set returns undefined, fall back to normal setting
					if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
						this.value = val;
					}
				});
			}
		});
	
		jQuery.extend({
			valHooks: {
				option: {
					get: function get(elem) {
	
						var val = jQuery.find.attr(elem, "value");
						return val != null ? val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse(jQuery.text(elem));
					}
				},
				select: {
					get: function get(elem) {
						var value,
						    option,
						    i,
						    options = elem.options,
						    index = elem.selectedIndex,
						    one = elem.type === "select-one",
						    values = one ? null : [],
						    max = one ? index + 1 : options.length;
	
						if (index < 0) {
							i = max;
						} else {
							i = one ? index : 0;
						}
	
						// Loop through all the selected options
						for (; i < max; i++) {
							option = options[i];
	
							// Support: IE <=9 only
							// IE8-9 doesn't update selected after form reset (#2551)
							if ((option.selected || i === index) &&
	
							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
	
								// Get the specific value for the option
								value = jQuery(option).val();
	
								// We don't need an array for one selects
								if (one) {
									return value;
								}
	
								// Multi-Selects return an array
								values.push(value);
							}
						}
	
						return values;
					},
	
					set: function set(elem, value) {
						var optionSet,
						    option,
						    options = elem.options,
						    values = jQuery.makeArray(value),
						    i = options.length;
	
						while (i--) {
							option = options[i];
	
							/* eslint-disable no-cond-assign */
	
							if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
								optionSet = true;
							}
	
							/* eslint-enable no-cond-assign */
						}
	
						// Force browsers to behave consistently when non-matching value is set
						if (!optionSet) {
							elem.selectedIndex = -1;
						}
						return values;
					}
				}
			}
		});
	
		// Radios and checkboxes getter/setter
		jQuery.each(["radio", "checkbox"], function () {
			jQuery.valHooks[this] = {
				set: function set(elem, value) {
					if (Array.isArray(value)) {
						return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
					}
				}
			};
			if (!support.checkOn) {
				jQuery.valHooks[this].get = function (elem) {
					return elem.getAttribute("value") === null ? "on" : elem.value;
				};
			}
		});
	
		// Return jQuery for attributes-only inclusion
	
	
		support.focusin = "onfocusin" in window;
	
		var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		    stopPropagationCallback = function stopPropagationCallback(e) {
			e.stopPropagation();
		};
	
		jQuery.extend(jQuery.event, {
	
			trigger: function trigger(event, data, elem, onlyHandlers) {
	
				var i,
				    cur,
				    tmp,
				    bubbleType,
				    ontype,
				    handle,
				    special,
				    lastElement,
				    eventPath = [elem || document],
				    type = hasOwn.call(event, "type") ? event.type : event,
				    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
	
				cur = lastElement = tmp = elem = elem || document;
	
				// Don't do events on text and comment nodes
				if (elem.nodeType === 3 || elem.nodeType === 8) {
					return;
				}
	
				// focus/blur morphs to focusin/out; ensure we're not firing them right now
				if (rfocusMorph.test(type + jQuery.event.triggered)) {
					return;
				}
	
				if (type.indexOf(".") > -1) {
	
					// Namespaced trigger; create a regexp to match event type in handle()
					namespaces = type.split(".");
					type = namespaces.shift();
					namespaces.sort();
				}
				ontype = type.indexOf(":") < 0 && "on" + type;
	
				// Caller can pass in a jQuery.Event object, Object, or just an event type string
				event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : _typeof(event)) === "object" && event);
	
				// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
				event.isTrigger = onlyHandlers ? 2 : 3;
				event.namespace = namespaces.join(".");
				event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
	
				// Clean up the event in case it is being reused
				event.result = undefined;
				if (!event.target) {
					event.target = elem;
				}
	
				// Clone any incoming data and prepend the event, creating the handler arg list
				data = data == null ? [event] : jQuery.makeArray(data, [event]);
	
				// Allow special events to draw outside the lines
				special = jQuery.event.special[type] || {};
				if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
					return;
				}
	
				// Determine event propagation path in advance, per W3C events spec (#9951)
				// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
				if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
	
					bubbleType = special.delegateType || type;
					if (!rfocusMorph.test(bubbleType + type)) {
						cur = cur.parentNode;
					}
					for (; cur; cur = cur.parentNode) {
						eventPath.push(cur);
						tmp = cur;
					}
	
					// Only add window if we got to document (e.g., not plain obj or detached DOM)
					if (tmp === (elem.ownerDocument || document)) {
						eventPath.push(tmp.defaultView || tmp.parentWindow || window);
					}
				}
	
				// Fire handlers on the event path
				i = 0;
				while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
					lastElement = cur;
					event.type = i > 1 ? bubbleType : special.bindType || type;
	
					// jQuery handler
					handle = (dataPriv.get(cur, "events") || {})[event.type] && dataPriv.get(cur, "handle");
					if (handle) {
						handle.apply(cur, data);
					}
	
					// Native handler
					handle = ontype && cur[ontype];
					if (handle && handle.apply && acceptData(cur)) {
						event.result = handle.apply(cur, data);
						if (event.result === false) {
							event.preventDefault();
						}
					}
				}
				event.type = type;
	
				// If nobody prevented the default action, do it now
				if (!onlyHandlers && !event.isDefaultPrevented()) {
	
					if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
	
						// Call a native DOM method on the target with the same name as the event.
						// Don't do default actions on window, that's where global variables be (#6170)
						if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
	
							// Don't re-trigger an onFOO event when we call its FOO() method
							tmp = elem[ontype];
	
							if (tmp) {
								elem[ontype] = null;
							}
	
							// Prevent re-triggering of the same event, since we already bubbled it above
							jQuery.event.triggered = type;
	
							if (event.isPropagationStopped()) {
								lastElement.addEventListener(type, stopPropagationCallback);
							}
	
							elem[type]();
	
							if (event.isPropagationStopped()) {
								lastElement.removeEventListener(type, stopPropagationCallback);
							}
	
							jQuery.event.triggered = undefined;
	
							if (tmp) {
								elem[ontype] = tmp;
							}
						}
					}
				}
	
				return event.result;
			},
	
			// Piggyback on a donor event to simulate a different one
			// Used only for `focus(in | out)` events
			simulate: function simulate(type, elem, event) {
				var e = jQuery.extend(new jQuery.Event(), event, {
					type: type,
					isSimulated: true
				});
	
				jQuery.event.trigger(e, null, elem);
			}
	
		});
	
		jQuery.fn.extend({
	
			trigger: function trigger(type, data) {
				return this.each(function () {
					jQuery.event.trigger(type, data, this);
				});
			},
			triggerHandler: function triggerHandler(type, data) {
				var elem = this[0];
				if (elem) {
					return jQuery.event.trigger(type, data, elem, true);
				}
			}
		});
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		if (!support.focusin) {
			jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {
	
				// Attach a single capturing handler on the document while someone wants focusin/focusout
				var handler = function handler(event) {
					jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
				};
	
				jQuery.event.special[fix] = {
					setup: function setup() {
						var doc = this.ownerDocument || this,
						    attaches = dataPriv.access(doc, fix);
	
						if (!attaches) {
							doc.addEventListener(orig, handler, true);
						}
						dataPriv.access(doc, fix, (attaches || 0) + 1);
					},
					teardown: function teardown() {
						var doc = this.ownerDocument || this,
						    attaches = dataPriv.access(doc, fix) - 1;
	
						if (!attaches) {
							doc.removeEventListener(orig, handler, true);
							dataPriv.remove(doc, fix);
						} else {
							dataPriv.access(doc, fix, attaches);
						}
					}
				};
			});
		}
		var location = window.location;
	
		var nonce = Date.now();
	
		var rquery = /\?/;
	
		// Cross-browser xml parsing
		jQuery.parseXML = function (data) {
			var xml;
			if (!data || typeof data !== "string") {
				return null;
			}
	
			// Support: IE 9 - 11 only
			// IE throws on parseFromString with invalid input.
			try {
				xml = new window.DOMParser().parseFromString(data, "text/xml");
			} catch (e) {
				xml = undefined;
			}
	
			if (!xml || xml.getElementsByTagName("parsererror").length) {
				jQuery.error("Invalid XML: " + data);
			}
			return xml;
		};
	
		var rbracket = /\[\]$/,
		    rCRLF = /\r?\n/g,
		    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		    rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
		function buildParams(prefix, obj, traditional, add) {
			var name;
	
			if (Array.isArray(obj)) {
	
				// Serialize array item.
				jQuery.each(obj, function (i, v) {
					if (traditional || rbracket.test(prefix)) {
	
						// Treat each array item as a scalar.
						add(prefix, v);
					} else {
	
						// Item is non-scalar (array or object), encode its numeric index.
						buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
					}
				});
			} else if (!traditional && toType(obj) === "object") {
	
				// Serialize object item.
				for (name in obj) {
					buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
				}
			} else {
	
				// Serialize scalar item.
				add(prefix, obj);
			}
		}
	
		// Serialize an array of form elements or a set of
		// key/values into a query string
		jQuery.param = function (a, traditional) {
			var prefix,
			    s = [],
			    add = function add(key, valueOrFunction) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
	
				s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
			};
	
			// If an array was passed in, assume that it is an array of form elements.
			if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
	
				// Serialize the form elements
				jQuery.each(a, function () {
					add(this.name, this.value);
				});
			} else {
	
				// If traditional, encode the "old" way (the way 1.3.2 or older
				// did it), otherwise encode params recursively.
				for (prefix in a) {
					buildParams(prefix, a[prefix], traditional, add);
				}
			}
	
			// Return the resulting serialization
			return s.join("&");
		};
	
		jQuery.fn.extend({
			serialize: function serialize() {
				return jQuery.param(this.serializeArray());
			},
			serializeArray: function serializeArray() {
				return this.map(function () {
	
					// Can add propHook for "elements" to filter or add form elements
					var elements = jQuery.prop(this, "elements");
					return elements ? jQuery.makeArray(elements) : this;
				}).filter(function () {
					var type = this.type;
	
					// Use .is( ":disabled" ) so that fieldset[disabled] works
					return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
				}).map(function (i, elem) {
					var val = jQuery(this).val();
	
					if (val == null) {
						return null;
					}
	
					if (Array.isArray(val)) {
						return jQuery.map(val, function (val) {
							return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
						});
					}
	
					return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
				}).get();
			}
		});
	
		var r20 = /%20/g,
		    rhash = /#.*$/,
		    rantiCache = /([?&])_=[^&]*/,
		    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		    rnoContent = /^(?:GET|HEAD)$/,
		    rprotocol = /^\/\//,
	
	
		/* Prefilters
	  * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	  * 2) These are called:
	  *    - BEFORE asking for a transport
	  *    - AFTER param serialization (s.data is a string if s.processData is true)
	  * 3) key is the dataType
	  * 4) the catchall symbol "*" can be used
	  * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	  */
		prefilters = {},
	
	
		/* Transports bindings
	  * 1) key is the dataType
	  * 2) the catchall symbol "*" can be used
	  * 3) selection will start with transport dataType and THEN go to "*" if needed
	  */
		transports = {},
	
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat("*"),
	
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement("a");
		originAnchor.href = location.href;
	
		// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
		function addToPrefiltersOrTransports(structure) {
	
			// dataTypeExpression is optional and defaults to "*"
			return function (dataTypeExpression, func) {
	
				if (typeof dataTypeExpression !== "string") {
					func = dataTypeExpression;
					dataTypeExpression = "*";
				}
	
				var dataType,
				    i = 0,
				    dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
	
				if (isFunction(func)) {
	
					// For each dataType in the dataTypeExpression
					while (dataType = dataTypes[i++]) {
	
						// Prepend if requested
						if (dataType[0] === "+") {
							dataType = dataType.slice(1) || "*";
							(structure[dataType] = structure[dataType] || []).unshift(func);
	
							// Otherwise append
						} else {
							(structure[dataType] = structure[dataType] || []).push(func);
						}
					}
				}
			};
		}
	
		// Base inspection function for prefilters and transports
		function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
	
			var inspected = {},
			    seekingTransport = structure === transports;
	
			function inspect(dataType) {
				var selected;
				inspected[dataType] = true;
				jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
					var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
					if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
	
						options.dataTypes.unshift(dataTypeOrTransport);
						inspect(dataTypeOrTransport);
						return false;
					} else if (seekingTransport) {
						return !(selected = dataTypeOrTransport);
					}
				});
				return selected;
			}
	
			return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
		}
	
		// A special extend for ajax options
		// that takes "flat" options (not to be deep extended)
		// Fixes #9887
		function ajaxExtend(target, src) {
			var key,
			    deep,
			    flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
			for (key in src) {
				if (src[key] !== undefined) {
					(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
				}
			}
			if (deep) {
				jQuery.extend(true, target, deep);
			}
	
			return target;
		}
	
		/* Handles responses to an ajax request:
	  * - finds the right dataType (mediates between content-type and expected dataType)
	  * - returns the corresponding response
	  */
		function ajaxHandleResponses(s, jqXHR, responses) {
	
			var ct,
			    type,
			    finalDataType,
			    firstDataType,
			    contents = s.contents,
			    dataTypes = s.dataTypes;
	
			// Remove auto dataType and get content-type in the process
			while (dataTypes[0] === "*") {
				dataTypes.shift();
				if (ct === undefined) {
					ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
				}
			}
	
			// Check if we're dealing with a known content-type
			if (ct) {
				for (type in contents) {
					if (contents[type] && contents[type].test(ct)) {
						dataTypes.unshift(type);
						break;
					}
				}
			}
	
			// Check to see if we have a response for the expected dataType
			if (dataTypes[0] in responses) {
				finalDataType = dataTypes[0];
			} else {
	
				// Try convertible dataTypes
				for (type in responses) {
					if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
						finalDataType = type;
						break;
					}
					if (!firstDataType) {
						firstDataType = type;
					}
				}
	
				// Or just use first one
				finalDataType = finalDataType || firstDataType;
			}
	
			// If we found a dataType
			// We add the dataType to the list if needed
			// and return the corresponding response
			if (finalDataType) {
				if (finalDataType !== dataTypes[0]) {
					dataTypes.unshift(finalDataType);
				}
				return responses[finalDataType];
			}
		}
	
		/* Chain conversions given the request and the original response
	  * Also sets the responseXXX fields on the jqXHR instance
	  */
		function ajaxConvert(s, response, jqXHR, isSuccess) {
			var conv2,
			    current,
			    conv,
			    tmp,
			    prev,
			    converters = {},
	
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
			// Create converters map with lowercased keys
			if (dataTypes[1]) {
				for (conv in s.converters) {
					converters[conv.toLowerCase()] = s.converters[conv];
				}
			}
	
			current = dataTypes.shift();
	
			// Convert to each sequential dataType
			while (current) {
	
				if (s.responseFields[current]) {
					jqXHR[s.responseFields[current]] = response;
				}
	
				// Apply the dataFilter if provided
				if (!prev && isSuccess && s.dataFilter) {
					response = s.dataFilter(response, s.dataType);
				}
	
				prev = current;
				current = dataTypes.shift();
	
				if (current) {
	
					// There's only work to do if current dataType is non-auto
					if (current === "*") {
	
						current = prev;
	
						// Convert response if prev dataType is non-auto and differs from current
					} else if (prev !== "*" && prev !== current) {
	
						// Seek a direct converter
						conv = converters[prev + " " + current] || converters["* " + current];
	
						// If none found, seek a pair
						if (!conv) {
							for (conv2 in converters) {
	
								// If conv2 outputs current
								tmp = conv2.split(" ");
								if (tmp[1] === current) {
	
									// If prev can be converted to accepted input
									conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
									if (conv) {
	
										// Condense equivalence converters
										if (conv === true) {
											conv = converters[conv2];
	
											// Otherwise, insert the intermediate dataType
										} else if (converters[conv2] !== true) {
											current = tmp[0];
											dataTypes.unshift(tmp[1]);
										}
										break;
									}
								}
							}
						}
	
						// Apply converter (if not an equivalence)
						if (conv !== true) {
	
							// Unless errors are allowed to bubble, catch and return them
							if (conv && s.throws) {
								response = conv(response);
							} else {
								try {
									response = conv(response);
								} catch (e) {
									return {
										state: "parsererror",
										error: conv ? e : "No conversion from " + prev + " to " + current
									};
								}
							}
						}
					}
				}
			}
	
			return { state: "success", data: response };
		}
	
		jQuery.extend({
	
			// Counter for holding the number of active queries
			active: 0,
	
			// Last-Modified header cache for next request
			lastModified: {},
			etag: {},
	
			ajaxSettings: {
				url: location.href,
				type: "GET",
				isLocal: rlocalProtocol.test(location.protocol),
				global: true,
				processData: true,
				async: true,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
				/*
	   timeout: 0,
	   data: null,
	   dataType: null,
	   username: null,
	   password: null,
	   cache: null,
	   throws: false,
	   traditional: false,
	   headers: {},
	   */
	
				accepts: {
					"*": allTypes,
					text: "text/plain",
					html: "text/html",
					xml: "application/xml, text/xml",
					json: "application/json, text/javascript"
				},
	
				contents: {
					xml: /\bxml\b/,
					html: /\bhtml/,
					json: /\bjson\b/
				},
	
				responseFields: {
					xml: "responseXML",
					text: "responseText",
					json: "responseJSON"
				},
	
				// Data converters
				// Keys separate source (or catchall "*") and destination types with a single space
				converters: {
	
					// Convert anything to text
					"* text": String,
	
					// Text to html (true = no transformation)
					"text html": true,
	
					// Evaluate text as a json expression
					"text json": JSON.parse,
	
					// Parse text as xml
					"text xml": jQuery.parseXML
				},
	
				// For options that shouldn't be deep extended:
				// you can add your own custom options here if
				// and when you create one that shouldn't be
				// deep extended (see ajaxExtend)
				flatOptions: {
					url: true,
					context: true
				}
			},
	
			// Creates a full fledged settings object into target
			// with both ajaxSettings and settings fields.
			// If target is omitted, writes into ajaxSettings.
			ajaxSetup: function ajaxSetup(target, settings) {
				return settings ?
	
				// Building a settings object
				ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :
	
				// Extending ajaxSettings
				ajaxExtend(jQuery.ajaxSettings, target);
			},
	
			ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
			ajaxTransport: addToPrefiltersOrTransports(transports),
	
			// Main method
			ajax: function ajax(url, options) {
	
				// If url is an object, simulate pre-1.5 signature
				if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === "object") {
					options = url;
					url = undefined;
				}
	
				// Force options to be an object
				options = options || {};
	
				var transport,
	
	
				// URL without anti-cache param
				cacheURL,
	
	
				// Response headers
				responseHeadersString,
				    responseHeaders,
	
	
				// timeout handle
				timeoutTimer,
	
	
				// Url cleanup var
				urlAnchor,
	
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
	
				// To know if global events are to be dispatched
				fireGlobals,
	
	
				// Loop variable
				i,
	
	
				// uncached part of the url
				uncached,
	
	
				// Create the final options object
				s = jQuery.ajaxSetup({}, options),
	
	
				// Callbacks context
				callbackContext = s.context || s,
	
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
	
	
				// Deferreds
				deferred = jQuery.Deferred(),
				    completeDeferred = jQuery.Callbacks("once memory"),
	
	
				// Status-dependent callbacks
				_statusCode = s.statusCode || {},
	
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				    requestHeadersNames = {},
	
	
				// Default abort message
				strAbort = "canceled",
	
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function getResponseHeader(key) {
						var match;
						if (completed) {
							if (!responseHeaders) {
								responseHeaders = {};
								while (match = rheaders.exec(responseHeadersString)) {
									responseHeaders[match[1].toLowerCase()] = match[2];
								}
							}
							match = responseHeaders[key.toLowerCase()];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function getAllResponseHeaders() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function setRequestHeader(name, value) {
						if (completed == null) {
							name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
							requestHeaders[name] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function overrideMimeType(type) {
						if (completed == null) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function statusCode(map) {
						var code;
						if (map) {
							if (completed) {
	
								// Execute the appropriate callbacks
								jqXHR.always(map[jqXHR.status]);
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for (code in map) {
									_statusCode[code] = [_statusCode[code], map[code]];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function abort(statusText) {
						var finalText = statusText || strAbort;
						if (transport) {
							transport.abort(finalText);
						}
						done(0, finalText);
						return this;
					}
				};
	
				// Attach deferreds
				deferred.promise(jqXHR);
	
				// Add protocol if not provided (prefilters might expect it)
				// Handle falsy url in the settings object (#10093: consistency with old signature)
				// We also use the url parameter if available
				s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
	
				// Alias method option to type as per ticket #12004
				s.type = options.method || options.type || s.method || s.type;
	
				// Extract dataTypes list
				s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
	
				// A cross-domain request is in order when the origin doesn't match the current origin.
				if (s.crossDomain == null) {
					urlAnchor = document.createElement("a");
	
					// Support: IE <=8 - 11, Edge 12 - 15
					// IE throws exception on accessing the href property if url is malformed,
					// e.g. http://example.com:80x/
					try {
						urlAnchor.href = s.url;
	
						// Support: IE <=8 - 11 only
						// Anchor's host property isn't correctly set when s.url is relative
						urlAnchor.href = urlAnchor.href;
						s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
					} catch (e) {
	
						// If there is an error parsing the URL, assume it is crossDomain,
						// it can be rejected by the transport if it is invalid
						s.crossDomain = true;
					}
				}
	
				// Convert data if not already a string
				if (s.data && s.processData && typeof s.data !== "string") {
					s.data = jQuery.param(s.data, s.traditional);
				}
	
				// Apply prefilters
				inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
	
				// If request was aborted inside a prefilter, stop there
				if (completed) {
					return jqXHR;
				}
	
				// We can fire global events as of now if asked to
				// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
				fireGlobals = jQuery.event && s.global;
	
				// Watch for a new set of requests
				if (fireGlobals && jQuery.active++ === 0) {
					jQuery.event.trigger("ajaxStart");
				}
	
				// Uppercase the type
				s.type = s.type.toUpperCase();
	
				// Determine if request has content
				s.hasContent = !rnoContent.test(s.type);
	
				// Save the URL in case we're toying with the If-Modified-Since
				// and/or If-None-Match header later on
				// Remove hash to simplify url manipulation
				cacheURL = s.url.replace(rhash, "");
	
				// More options handling for requests with no content
				if (!s.hasContent) {
	
					// Remember the hash so we can put it back
					uncached = s.url.slice(cacheURL.length);
	
					// If data is available and should be processed, append data to url
					if (s.data && (s.processData || typeof s.data === "string")) {
						cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
	
						// #9682: remove data so that it's not used in an eventual retry
						delete s.data;
					}
	
					// Add or update anti-cache param if needed
					if (s.cache === false) {
						cacheURL = cacheURL.replace(rantiCache, "$1");
						uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++ + uncached;
					}
	
					// Put hash and anti-cache on the URL that will be requested (gh-1732)
					s.url = cacheURL + uncached;
	
					// Change '%20' to '+' if this is encoded form body content (gh-2658)
				} else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
					s.data = s.data.replace(r20, "+");
				}
	
				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if (s.ifModified) {
					if (jQuery.lastModified[cacheURL]) {
						jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
					}
					if (jQuery.etag[cacheURL]) {
						jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
					}
				}
	
				// Set the correct header, if data is being sent
				if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
					jqXHR.setRequestHeader("Content-Type", s.contentType);
				}
	
				// Set the Accepts header for the server, depending on the dataType
				jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
	
				// Check for headers option
				for (i in s.headers) {
					jqXHR.setRequestHeader(i, s.headers[i]);
				}
	
				// Allow custom headers/mimetypes and early abort
				if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
	
					// Abort if not done already and return
					return jqXHR.abort();
				}
	
				// Aborting is no longer a cancellation
				strAbort = "abort";
	
				// Install callbacks on deferreds
				completeDeferred.add(s.complete);
				jqXHR.done(s.success);
				jqXHR.fail(s.error);
	
				// Get transport
				transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
	
				// If no transport, we auto-abort
				if (!transport) {
					done(-1, "No Transport");
				} else {
					jqXHR.readyState = 1;
	
					// Send global event
					if (fireGlobals) {
						globalEventContext.trigger("ajaxSend", [jqXHR, s]);
					}
	
					// If request was aborted inside ajaxSend, stop there
					if (completed) {
						return jqXHR;
					}
	
					// Timeout
					if (s.async && s.timeout > 0) {
						timeoutTimer = window.setTimeout(function () {
							jqXHR.abort("timeout");
						}, s.timeout);
					}
	
					try {
						completed = false;
						transport.send(requestHeaders, done);
					} catch (e) {
	
						// Rethrow post-completion exceptions
						if (completed) {
							throw e;
						}
	
						// Propagate others as results
						done(-1, e);
					}
				}
	
				// Callback for when everything is done
				function done(status, nativeStatusText, responses, headers) {
					var isSuccess,
					    success,
					    error,
					    response,
					    modified,
					    statusText = nativeStatusText;
	
					// Ignore repeat invocations
					if (completed) {
						return;
					}
	
					completed = true;
	
					// Clear timeout if it exists
					if (timeoutTimer) {
						window.clearTimeout(timeoutTimer);
					}
	
					// Dereference transport for early garbage collection
					// (no matter how long the jqXHR object will be used)
					transport = undefined;
	
					// Cache response headers
					responseHeadersString = headers || "";
	
					// Set readyState
					jqXHR.readyState = status > 0 ? 4 : 0;
	
					// Determine if successful
					isSuccess = status >= 200 && status < 300 || status === 304;
	
					// Get response data
					if (responses) {
						response = ajaxHandleResponses(s, jqXHR, responses);
					}
	
					// Convert no matter what (that way responseXXX fields are always set)
					response = ajaxConvert(s, response, jqXHR, isSuccess);
	
					// If successful, handle type chaining
					if (isSuccess) {
	
						// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
						if (s.ifModified) {
							modified = jqXHR.getResponseHeader("Last-Modified");
							if (modified) {
								jQuery.lastModified[cacheURL] = modified;
							}
							modified = jqXHR.getResponseHeader("etag");
							if (modified) {
								jQuery.etag[cacheURL] = modified;
							}
						}
	
						// if no content
						if (status === 204 || s.type === "HEAD") {
							statusText = "nocontent";
	
							// if not modified
						} else if (status === 304) {
							statusText = "notmodified";
	
							// If we have data, let's convert it
						} else {
							statusText = response.state;
							success = response.data;
							error = response.error;
							isSuccess = !error;
						}
					} else {
	
						// Extract error from statusText and normalize for non-aborts
						error = statusText;
						if (status || !statusText) {
							statusText = "error";
							if (status < 0) {
								status = 0;
							}
						}
					}
	
					// Set data for the fake xhr object
					jqXHR.status = status;
					jqXHR.statusText = (nativeStatusText || statusText) + "";
	
					// Success/Error
					if (isSuccess) {
						deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
					} else {
						deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
					}
	
					// Status-dependent callbacks
					jqXHR.statusCode(_statusCode);
					_statusCode = undefined;
	
					if (fireGlobals) {
						globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
					}
	
					// Complete
					completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
	
					if (fireGlobals) {
						globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
	
						// Handle the global AJAX counter
						if (! --jQuery.active) {
							jQuery.event.trigger("ajaxStop");
						}
					}
				}
	
				return jqXHR;
			},
	
			getJSON: function getJSON(url, data, callback) {
				return jQuery.get(url, data, callback, "json");
			},
	
			getScript: function getScript(url, callback) {
				return jQuery.get(url, undefined, callback, "script");
			}
		});
	
		jQuery.each(["get", "post"], function (i, method) {
			jQuery[method] = function (url, data, callback, type) {
	
				// Shift arguments if data argument was omitted
				if (isFunction(data)) {
					type = type || callback;
					callback = data;
					data = undefined;
				}
	
				// The url can be an options object (which then must have .url)
				return jQuery.ajax(jQuery.extend({
					url: url,
					type: method,
					dataType: type,
					data: data,
					success: callback
				}, jQuery.isPlainObject(url) && url));
			};
		});
	
		jQuery._evalUrl = function (url) {
			return jQuery.ajax({
				url: url,
	
				// Make this explicit, since user can override this through ajaxSetup (#11264)
				type: "GET",
				dataType: "script",
				cache: true,
				async: false,
				global: false,
				"throws": true
			});
		};
	
		jQuery.fn.extend({
			wrapAll: function wrapAll(html) {
				var wrap;
	
				if (this[0]) {
					if (isFunction(html)) {
						html = html.call(this[0]);
					}
	
					// The elements to wrap the target around
					wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
	
					if (this[0].parentNode) {
						wrap.insertBefore(this[0]);
					}
	
					wrap.map(function () {
						var elem = this;
	
						while (elem.firstElementChild) {
							elem = elem.firstElementChild;
						}
	
						return elem;
					}).append(this);
				}
	
				return this;
			},
	
			wrapInner: function wrapInner(html) {
				if (isFunction(html)) {
					return this.each(function (i) {
						jQuery(this).wrapInner(html.call(this, i));
					});
				}
	
				return this.each(function () {
					var self = jQuery(this),
					    contents = self.contents();
	
					if (contents.length) {
						contents.wrapAll(html);
					} else {
						self.append(html);
					}
				});
			},
	
			wrap: function wrap(html) {
				var htmlIsFunction = isFunction(html);
	
				return this.each(function (i) {
					jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
				});
			},
	
			unwrap: function unwrap(selector) {
				this.parent(selector).not("body").each(function () {
					jQuery(this).replaceWith(this.childNodes);
				});
				return this;
			}
		});
	
		jQuery.expr.pseudos.hidden = function (elem) {
			return !jQuery.expr.pseudos.visible(elem);
		};
		jQuery.expr.pseudos.visible = function (elem) {
			return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
		};
	
		jQuery.ajaxSettings.xhr = function () {
			try {
				return new window.XMLHttpRequest();
			} catch (e) {}
		};
	
		var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		    xhrSupported = jQuery.ajaxSettings.xhr();
	
		support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
		support.ajax = xhrSupported = !!xhrSupported;
	
		jQuery.ajaxTransport(function (options) {
			var _callback, errorCallback;
	
			// Cross domain only allowed if supported through XMLHttpRequest
			if (support.cors || xhrSupported && !options.crossDomain) {
				return {
					send: function send(headers, complete) {
						var i,
						    xhr = options.xhr();
	
						xhr.open(options.type, options.url, options.async, options.username, options.password);
	
						// Apply custom fields if provided
						if (options.xhrFields) {
							for (i in options.xhrFields) {
								xhr[i] = options.xhrFields[i];
							}
						}
	
						// Override mime type if needed
						if (options.mimeType && xhr.overrideMimeType) {
							xhr.overrideMimeType(options.mimeType);
						}
	
						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if (!options.crossDomain && !headers["X-Requested-With"]) {
							headers["X-Requested-With"] = "XMLHttpRequest";
						}
	
						// Set headers
						for (i in headers) {
							xhr.setRequestHeader(i, headers[i]);
						}
	
						// Callback
						_callback = function callback(type) {
							return function () {
								if (_callback) {
									_callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
	
									if (type === "abort") {
										xhr.abort();
									} else if (type === "error") {
	
										// Support: IE <=9 only
										// On a manual native abort, IE9 throws
										// errors on any property access that is not readyState
										if (typeof xhr.status !== "number") {
											complete(0, "error");
										} else {
											complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status, xhr.statusText);
										}
									} else {
										complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										(xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText }, xhr.getAllResponseHeaders());
									}
								}
							};
						};
	
						// Listen to events
						xhr.onload = _callback();
						errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");
	
						// Support: IE 9 only
						// Use onreadystatechange to replace onabort
						// to handle uncaught aborts
						if (xhr.onabort !== undefined) {
							xhr.onabort = errorCallback;
						} else {
							xhr.onreadystatechange = function () {
	
								// Check readyState before timeout as it changes
								if (xhr.readyState === 4) {
	
									// Allow onerror to be called first,
									// but that will not handle a native abort
									// Also, save errorCallback to a variable
									// as xhr.onerror cannot be accessed
									window.setTimeout(function () {
										if (_callback) {
											errorCallback();
										}
									});
								}
							};
						}
	
						// Create the abort callback
						_callback = _callback("abort");
	
						try {
	
							// Do send the request (this may raise an exception)
							xhr.send(options.hasContent && options.data || null);
						} catch (e) {
	
							// #14683: Only rethrow if this hasn't been notified as an error yet
							if (_callback) {
								throw e;
							}
						}
					},
	
					abort: function abort() {
						if (_callback) {
							_callback();
						}
					}
				};
			}
		});
	
		// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
		jQuery.ajaxPrefilter(function (s) {
			if (s.crossDomain) {
				s.contents.script = false;
			}
		});
	
		// Install script dataType
		jQuery.ajaxSetup({
			accepts: {
				script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
			},
			contents: {
				script: /\b(?:java|ecma)script\b/
			},
			converters: {
				"text script": function textScript(text) {
					jQuery.globalEval(text);
					return text;
				}
			}
		});
	
		// Handle cache's special case and crossDomain
		jQuery.ajaxPrefilter("script", function (s) {
			if (s.cache === undefined) {
				s.cache = false;
			}
			if (s.crossDomain) {
				s.type = "GET";
			}
		});
	
		// Bind script tag hack transport
		jQuery.ajaxTransport("script", function (s) {
	
			// This transport only deals with cross domain requests
			if (s.crossDomain) {
				var script, _callback2;
				return {
					send: function send(_, complete) {
						script = jQuery("<script>").prop({
							charset: s.scriptCharset,
							src: s.url
						}).on("load error", _callback2 = function callback(evt) {
							script.remove();
							_callback2 = null;
							if (evt) {
								complete(evt.type === "error" ? 404 : 200, evt.type);
							}
						});
	
						// Use native DOM manipulation to avoid our domManip AJAX trickery
						document.head.appendChild(script[0]);
					},
					abort: function abort() {
						if (_callback2) {
							_callback2();
						}
					}
				};
			}
		});
	
		var oldCallbacks = [],
		    rjsonp = /(=)\?(?=&|$)|\?\?/;
	
		// Default jsonp settings
		jQuery.ajaxSetup({
			jsonp: "callback",
			jsonpCallback: function jsonpCallback() {
				var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
				this[callback] = true;
				return callback;
			}
		});
	
		// Detect, normalize options and install callbacks for jsonp requests
		jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
	
			var callbackName,
			    overwritten,
			    responseContainer,
			    jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
	
			// Handle iff the expected data type is "jsonp" or we have a parameter to set
			if (jsonProp || s.dataTypes[0] === "jsonp") {
	
				// Get callback name, remembering preexisting value associated with it
				callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
	
				// Insert callback into url or form data
				if (jsonProp) {
					s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
				} else if (s.jsonp !== false) {
					s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
				}
	
				// Use data converter to retrieve json after script execution
				s.converters["script json"] = function () {
					if (!responseContainer) {
						jQuery.error(callbackName + " was not called");
					}
					return responseContainer[0];
				};
	
				// Force json dataType
				s.dataTypes[0] = "json";
	
				// Install callback
				overwritten = window[callbackName];
				window[callbackName] = function () {
					responseContainer = arguments;
				};
	
				// Clean-up function (fires after converters)
				jqXHR.always(function () {
	
					// If previous value didn't exist - remove it
					if (overwritten === undefined) {
						jQuery(window).removeProp(callbackName);
	
						// Otherwise restore preexisting value
					} else {
						window[callbackName] = overwritten;
					}
	
					// Save back as free
					if (s[callbackName]) {
	
						// Make sure that re-using the options doesn't screw things around
						s.jsonpCallback = originalSettings.jsonpCallback;
	
						// Save the callback name for future use
						oldCallbacks.push(callbackName);
					}
	
					// Call if it was a function and we have a response
					if (responseContainer && isFunction(overwritten)) {
						overwritten(responseContainer[0]);
					}
	
					responseContainer = overwritten = undefined;
				});
	
				// Delegate to script
				return "script";
			}
		});
	
		// Support: Safari 8 only
		// In Safari 8 documents created via document.implementation.createHTMLDocument
		// collapse sibling forms: the second one becomes a child of the first one.
		// Because of that, this security measure has to be disabled in Safari 8.
		// https://bugs.webkit.org/show_bug.cgi?id=137337
		support.createHTMLDocument = function () {
			var body = document.implementation.createHTMLDocument("").body;
			body.innerHTML = "<form></form><form></form>";
			return body.childNodes.length === 2;
		}();
	
		// Argument "data" should be string of html
		// context (optional): If specified, the fragment will be created in this context,
		// defaults to document
		// keepScripts (optional): If true, will include scripts passed in the html string
		jQuery.parseHTML = function (data, context, keepScripts) {
			if (typeof data !== "string") {
				return [];
			}
			if (typeof context === "boolean") {
				keepScripts = context;
				context = false;
			}
	
			var base, parsed, scripts;
	
			if (!context) {
	
				// Stop scripts or inline event handlers from being executed immediately
				// by using document.implementation
				if (support.createHTMLDocument) {
					context = document.implementation.createHTMLDocument("");
	
					// Set the base href for the created document
					// so any parsed elements with URLs
					// are based on the document's URL (gh-2965)
					base = context.createElement("base");
					base.href = document.location.href;
					context.head.appendChild(base);
				} else {
					context = document;
				}
			}
	
			parsed = rsingleTag.exec(data);
			scripts = !keepScripts && [];
	
			// Single tag
			if (parsed) {
				return [context.createElement(parsed[1])];
			}
	
			parsed = buildFragment([data], context, scripts);
	
			if (scripts && scripts.length) {
				jQuery(scripts).remove();
			}
	
			return jQuery.merge([], parsed.childNodes);
		};
	
		/**
	  * Load a url into a page
	  */
		jQuery.fn.load = function (url, params, callback) {
			var selector,
			    type,
			    response,
			    self = this,
			    off = url.indexOf(" ");
	
			if (off > -1) {
				selector = stripAndCollapse(url.slice(off));
				url = url.slice(0, off);
			}
	
			// If it's a function
			if (isFunction(params)) {
	
				// We assume that it's the callback
				callback = params;
				params = undefined;
	
				// Otherwise, build a param string
			} else if (params && (typeof params === "undefined" ? "undefined" : _typeof(params)) === "object") {
				type = "POST";
			}
	
			// If we have elements to modify, make the request
			if (self.length > 0) {
				jQuery.ajax({
					url: url,
	
					// If "type" variable is undefined, then "GET" method will be used.
					// Make value of this field explicit since
					// user can override it through ajaxSetup method
					type: type || "GET",
					dataType: "html",
					data: params
				}).done(function (responseText) {
	
					// Save response for use in complete callback
					response = arguments;
	
					self.html(selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :
	
					// Otherwise use the full result
					responseText);
	
					// If the request succeeds, this function gets "data", "status", "jqXHR"
					// but they are ignored because response was set above.
					// If it fails, this function gets "jqXHR", "status", "error"
				}).always(callback && function (jqXHR, status) {
					self.each(function () {
						callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
					});
				});
			}
	
			return this;
		};
	
		// Attach a bunch of functions for handling common AJAX events
		jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (i, type) {
			jQuery.fn[type] = function (fn) {
				return this.on(type, fn);
			};
		});
	
		jQuery.expr.pseudos.animated = function (elem) {
			return jQuery.grep(jQuery.timers, function (fn) {
				return elem === fn.elem;
			}).length;
		};
	
		jQuery.offset = {
			setOffset: function setOffset(elem, options, i) {
				var curPosition,
				    curLeft,
				    curCSSTop,
				    curTop,
				    curOffset,
				    curCSSLeft,
				    calculatePosition,
				    position = jQuery.css(elem, "position"),
				    curElem = jQuery(elem),
				    props = {};
	
				// Set position first, in-case top/left are set even on static elem
				if (position === "static") {
					elem.style.position = "relative";
				}
	
				curOffset = curElem.offset();
				curCSSTop = jQuery.css(elem, "top");
				curCSSLeft = jQuery.css(elem, "left");
				calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
	
				// Need to be able to calculate position if either
				// top or left is auto and position is either absolute or fixed
				if (calculatePosition) {
					curPosition = curElem.position();
					curTop = curPosition.top;
					curLeft = curPosition.left;
				} else {
					curTop = parseFloat(curCSSTop) || 0;
					curLeft = parseFloat(curCSSLeft) || 0;
				}
	
				if (isFunction(options)) {
	
					// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
					options = options.call(elem, i, jQuery.extend({}, curOffset));
				}
	
				if (options.top != null) {
					props.top = options.top - curOffset.top + curTop;
				}
				if (options.left != null) {
					props.left = options.left - curOffset.left + curLeft;
				}
	
				if ("using" in options) {
					options.using.call(elem, props);
				} else {
					curElem.css(props);
				}
			}
		};
	
		jQuery.fn.extend({
	
			// offset() relates an element's border box to the document origin
			offset: function offset(options) {
	
				// Preserve chaining for setter
				if (arguments.length) {
					return options === undefined ? this : this.each(function (i) {
						jQuery.offset.setOffset(this, options, i);
					});
				}
	
				var rect,
				    win,
				    elem = this[0];
	
				if (!elem) {
					return;
				}
	
				// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
				// Support: IE <=11 only
				// Running getBoundingClientRect on a
				// disconnected node in IE throws an error
				if (!elem.getClientRects().length) {
					return { top: 0, left: 0 };
				}
	
				// Get document-relative position by adding viewport scroll to viewport-relative gBCR
				rect = elem.getBoundingClientRect();
				win = elem.ownerDocument.defaultView;
				return {
					top: rect.top + win.pageYOffset,
					left: rect.left + win.pageXOffset
				};
			},
	
			// position() relates an element's margin box to its offset parent's padding box
			// This corresponds to the behavior of CSS absolute positioning
			position: function position() {
				if (!this[0]) {
					return;
				}
	
				var offsetParent,
				    offset,
				    doc,
				    elem = this[0],
				    parentOffset = { top: 0, left: 0 };
	
				// position:fixed elements are offset from the viewport, which itself always has zero offset
				if (jQuery.css(elem, "position") === "fixed") {
	
					// Assume position:fixed implies availability of getBoundingClientRect
					offset = elem.getBoundingClientRect();
				} else {
					offset = this.offset();
	
					// Account for the *real* offset parent, which can be the document or its root element
					// when a statically positioned element is identified
					doc = elem.ownerDocument;
					offsetParent = elem.offsetParent || doc.documentElement;
					while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
	
						offsetParent = offsetParent.parentNode;
					}
					if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
	
						// Incorporate borders into its offset, since they are outside its content origin
						parentOffset = jQuery(offsetParent).offset();
						parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
						parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
					}
				}
	
				// Subtract parent offsets and element margins
				return {
					top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
					left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
				};
			},
	
			// This method will return documentElement in the following cases:
			// 1) For the element inside the iframe without offsetParent, this method will return
			//    documentElement of the parent window
			// 2) For the hidden or detached element
			// 3) For body or html element, i.e. in case of the html node - it will return itself
			//
			// but those exceptions were never presented as a real life use-cases
			// and might be considered as more preferable results.
			//
			// This logic, however, is not guaranteed and can change at any point in the future
			offsetParent: function offsetParent() {
				return this.map(function () {
					var offsetParent = this.offsetParent;
	
					while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
						offsetParent = offsetParent.offsetParent;
					}
	
					return offsetParent || documentElement;
				});
			}
		});
	
		// Create scrollLeft and scrollTop methods
		jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
			var top = "pageYOffset" === prop;
	
			jQuery.fn[method] = function (val) {
				return access(this, function (elem, method, val) {
	
					// Coalesce documents and windows
					var win;
					if (isWindow(elem)) {
						win = elem;
					} else if (elem.nodeType === 9) {
						win = elem.defaultView;
					}
	
					if (val === undefined) {
						return win ? win[prop] : elem[method];
					}
	
					if (win) {
						win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
					} else {
						elem[method] = val;
					}
				}, method, val, arguments.length);
			};
		});
	
		// Support: Safari <=7 - 9.1, Chrome <=37 - 49
		// Add the top/left cssHooks using jQuery.fn.position
		// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
		// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
		// getComputedStyle returns percent when specified for top/left/bottom/right;
		// rather than make the css module depend on the offset module, just check for it here
		jQuery.each(["top", "left"], function (i, prop) {
			jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
				if (computed) {
					computed = curCSS(elem, prop);
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
				}
			});
		});
	
		// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
		jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
			jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name }, function (defaultExtra, funcName) {
	
				// Margin is only for outerHeight, outerWidth
				jQuery.fn[funcName] = function (margin, value) {
					var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
					    extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
	
					return access(this, function (elem, type, value) {
						var doc;
	
						if (isWindow(elem)) {
	
							// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
							return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
						}
	
						// Get document width or height
						if (elem.nodeType === 9) {
							doc = elem.documentElement;
	
							// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
							// whichever is greatest
							return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
						}
	
						return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css(elem, type, extra) :
	
						// Set width or height on the element
						jQuery.style(elem, type, value, extra);
					}, type, chainable ? margin : undefined, chainable);
				};
			});
		});
	
		jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (i, name) {
	
			// Handle event binding
			jQuery.fn[name] = function (data, fn) {
				return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
			};
		});
	
		jQuery.fn.extend({
			hover: function hover(fnOver, fnOut) {
				return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
			}
		});
	
		jQuery.fn.extend({
	
			bind: function bind(types, data, fn) {
				return this.on(types, null, data, fn);
			},
			unbind: function unbind(types, fn) {
				return this.off(types, null, fn);
			},
	
			delegate: function delegate(selector, types, data, fn) {
				return this.on(types, selector, data, fn);
			},
			undelegate: function undelegate(selector, types, fn) {
	
				// ( namespace ) or ( selector, types [, fn] )
				return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
			}
		});
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
		// However, it is not slated for removal any time soon
		jQuery.proxy = function (fn, context) {
			var tmp, args, proxy;
	
			if (typeof context === "string") {
				tmp = fn[context];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if (!isFunction(fn)) {
				return undefined;
			}
	
			// Simulated bind
			args = _slice.call(arguments, 2);
			proxy = function proxy() {
				return fn.apply(context || this, args.concat(_slice.call(arguments)));
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		};
	
		jQuery.holdReady = function (hold) {
			if (hold) {
				jQuery.readyWait++;
			} else {
				jQuery.ready(true);
			}
		};
		jQuery.isArray = Array.isArray;
		jQuery.parseJSON = JSON.parse;
		jQuery.nodeName = nodeName;
		jQuery.isFunction = isFunction;
		jQuery.isWindow = isWindow;
		jQuery.camelCase = camelCase;
		jQuery.type = toType;
	
		jQuery.now = Date.now;
	
		jQuery.isNumeric = function (obj) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type(obj);
			return (type === "number" || type === "string") &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN(obj - parseFloat(obj));
		};
	
		// Register as a named AMD module, since jQuery can be concatenated with other
		// files that may use define, but not via a proper concatenation script that
		// understands anonymous AMD modules. A named AMD is safest and most robust
		// way to register. Lowercase jquery is used because AMD module names are
		// derived from file names, and jQuery is normally delivered in a lowercase
		// file name. Do this after creating the global so that if an AMD module wants
		// to call noConflict to hide this version of jQuery, it will work.
	
		// Note that for maximum portability, libraries that are not jQuery should
		// declare themselves as anonymous modules, and avoid setting a global if an
		// AMD loader is present. jQuery is a special case. For more information, see
		// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return jQuery;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
		jQuery.noConflict = function (deep) {
			if (window.$ === jQuery) {
				window.$ = _$;
			}
	
			if (deep && window.jQuery === jQuery) {
				window.jQuery = _jQuery;
			}
	
			return jQuery;
		};
	
		// Expose jQuery and $ identifiers, even in AMD
		// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
		// and CommonJS for browser emulators (#13566)
		if (!noGlobal) {
			window.jQuery = window.$ = jQuery;
		}
	
		return jQuery;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (( false ? 'undefined' : _typeof(exports)) === 'object') {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	})(function () {
		function extend() {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[i];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init(converter) {
			function api(key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return document.cookie = key + '=' + value + stringifiedAttributes;
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	var jsonlint = function () {
	  var a = !0,
	      b = !1,
	      c = {},
	      d = function () {
	    var a = { trace: function trace() {}, yy: {}, symbols_: { error: 2, JSONString: 3, STRING: 4, JSONNumber: 5, NUMBER: 6, JSONNullLiteral: 7, NULL: 8, JSONBooleanLiteral: 9, TRUE: 10, FALSE: 11, JSONText: 12, JSONValue: 13, EOF: 14, JSONObject: 15, JSONArray: 16, "{": 17, "}": 18, JSONMemberList: 19, JSONMember: 20, ":": 21, ",": 22, "[": 23, "]": 24, JSONElementList: 25, $accept: 0, $end: 1 }, terminals_: { 2: "error", 4: "STRING", 6: "NUMBER", 8: "NULL", 10: "TRUE", 11: "FALSE", 14: "EOF", 17: "{", 18: "}", 21: ":", 22: ",", 23: "[", 24: "]" }, productions_: [0, [3, 1], [5, 1], [7, 1], [9, 1], [9, 1], [12, 2], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [15, 2], [15, 3], [20, 3], [19, 1], [19, 3], [16, 2], [16, 3], [25, 1], [25, 3]], performAction: function performAction(b, c, d, e, f, g, h) {
	        var i = g.length - 1;switch (f) {case 1:
	            this.$ = b.replace(/\\(\\|")/g, "$1").replace(/\\n/g, "\n").replace(/\\r/g, "\r").replace(/\\t/g, "	").replace(/\\v/g, "").replace(/\\f/g, "\f").replace(/\\b/g, "\b");break;case 2:
	            this.$ = Number(b);break;case 3:
	            this.$ = null;break;case 4:
	            this.$ = !0;break;case 5:
	            this.$ = !1;break;case 6:
	            return this.$ = g[i - 1];case 13:
	            this.$ = {};break;case 14:
	            this.$ = g[i - 1];break;case 15:
	            this.$ = [g[i - 2], g[i]];break;case 16:
	            this.$ = {}, this.$[g[i][0]] = g[i][1];break;case 17:
	            this.$ = g[i - 2], g[i - 2][g[i][0]] = g[i][1];break;case 18:
	            this.$ = [];break;case 19:
	            this.$ = g[i - 1];break;case 20:
	            this.$ = [g[i]];break;case 21:
	            this.$ = g[i - 2], g[i - 2].push(g[i]);}
	      }, table: [{ 3: 5, 4: [1, 12], 5: 6, 6: [1, 13], 7: 3, 8: [1, 9], 9: 4, 10: [1, 10], 11: [1, 11], 12: 1, 13: 2, 15: 7, 16: 8, 17: [1, 14], 23: [1, 15] }, { 1: [3] }, { 14: [1, 16] }, { 14: [2, 7], 18: [2, 7], 22: [2, 7], 24: [2, 7] }, { 14: [2, 8], 18: [2, 8], 22: [2, 8], 24: [2, 8] }, { 14: [2, 9], 18: [2, 9], 22: [2, 9], 24: [2, 9] }, { 14: [2, 10], 18: [2, 10], 22: [2, 10], 24: [2, 10] }, { 14: [2, 11], 18: [2, 11], 22: [2, 11], 24: [2, 11] }, { 14: [2, 12], 18: [2, 12], 22: [2, 12], 24: [2, 12] }, { 14: [2, 3], 18: [2, 3], 22: [2, 3], 24: [2, 3] }, { 14: [2, 4], 18: [2, 4], 22: [2, 4], 24: [2, 4] }, { 14: [2, 5], 18: [2, 5], 22: [2, 5], 24: [2, 5] }, { 14: [2, 1], 18: [2, 1], 21: [2, 1], 22: [2, 1], 24: [2, 1] }, { 14: [2, 2], 18: [2, 2], 22: [2, 2], 24: [2, 2] }, { 3: 20, 4: [1, 12], 18: [1, 17], 19: 18, 20: 19 }, { 3: 5, 4: [1, 12], 5: 6, 6: [1, 13], 7: 3, 8: [1, 9], 9: 4, 10: [1, 10], 11: [1, 11], 13: 23, 15: 7, 16: 8, 17: [1, 14], 23: [1, 15], 24: [1, 21], 25: 22 }, { 1: [2, 6] }, { 14: [2, 13], 18: [2, 13], 22: [2, 13], 24: [2, 13] }, { 18: [1, 24], 22: [1, 25] }, { 18: [2, 16], 22: [2, 16] }, { 21: [1, 26] }, { 14: [2, 18], 18: [2, 18], 22: [2, 18], 24: [2, 18] }, { 22: [1, 28], 24: [1, 27] }, { 22: [2, 20], 24: [2, 20] }, { 14: [2, 14], 18: [2, 14], 22: [2, 14], 24: [2, 14] }, { 3: 20, 4: [1, 12], 20: 29 }, { 3: 5, 4: [1, 12], 5: 6, 6: [1, 13], 7: 3, 8: [1, 9], 9: 4, 10: [1, 10], 11: [1, 11], 13: 30, 15: 7, 16: 8, 17: [1, 14], 23: [1, 15] }, { 14: [2, 19], 18: [2, 19], 22: [2, 19], 24: [2, 19] }, { 3: 5, 4: [1, 12], 5: 6, 6: [1, 13], 7: 3, 8: [1, 9], 9: 4, 10: [1, 10], 11: [1, 11], 13: 31, 15: 7, 16: 8, 17: [1, 14], 23: [1, 15] }, { 18: [2, 17], 22: [2, 17] }, { 18: [2, 15], 22: [2, 15] }, { 22: [2, 21], 24: [2, 21] }], defaultActions: { 16: [2, 6] }, parseError: function parseError(b, c) {
	        throw new Error(b);
	      }, parse: function parse(b) {
	        function o(a) {
	          d.length = d.length - 2 * a, e.length = e.length - a, f.length = f.length - a;
	        }function p() {
	          var a;return a = c.lexer.lex() || 1, typeof a != "number" && (a = c.symbols_[a] || a), a;
	        }var c = this,
	            d = [0],
	            e = [null],
	            f = [],
	            g = this.table,
	            h = "",
	            i = 0,
	            j = 0,
	            k = 0,
	            l = 2,
	            m = 1;this.lexer.setInput(b), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, typeof this.lexer.yylloc == "undefined" && (this.lexer.yylloc = {});var n = this.lexer.yylloc;f.push(n), typeof this.yy.parseError == "function" && (this.parseError = this.yy.parseError);var q,
	            r,
	            s,
	            t,
	            u,
	            v,
	            w = {},
	            x,
	            y,
	            z,
	            A;for (;;) {
	          s = d[d.length - 1], this.defaultActions[s] ? t = this.defaultActions[s] : (q == null && (q = p()), t = g[s] && g[s][q]);if (typeof t == "undefined" || !t.length || !t[0]) {
	            if (!k) {
	              A = [];for (x in g[s]) {
	                this.terminals_[x] && x > 2 && A.push("'" + this.terminals_[x] + "'");
	              }var B = "";this.lexer.showPosition ? B = "Parse error on line " + (i + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + this.terminals_[q] + "'" : B = "Parse error on line " + (i + 1) + ": Unexpected " + (q == 1 ? "end of input" : "'" + (this.terminals_[q] || q) + "'"), this.parseError(B, { text: this.lexer.match, token: this.terminals_[q] || q, line: this.lexer.yylineno, loc: n, expected: A });
	            }if (k == 3) {
	              if (q == m) throw new Error(B || "Parsing halted.");j = this.lexer.yyleng, h = this.lexer.yytext, i = this.lexer.yylineno, n = this.lexer.yylloc, q = p();
	            }for (;;) {
	              if (l.toString() in g[s]) break;if (s == 0) throw new Error(B || "Parsing halted.");o(1), s = d[d.length - 1];
	            }r = q, q = l, s = d[d.length - 1], t = g[s] && g[s][l], k = 3;
	          }if (t[0] instanceof Array && t.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + s + ", token: " + q);switch (t[0]) {case 1:
	              d.push(q), e.push(this.lexer.yytext), f.push(this.lexer.yylloc), d.push(t[1]), q = null, r ? (q = r, r = null) : (j = this.lexer.yyleng, h = this.lexer.yytext, i = this.lexer.yylineno, n = this.lexer.yylloc, k > 0 && k--);break;case 2:
	              y = this.productions_[t[1]][1], w.$ = e[e.length - y], w._$ = { first_line: f[f.length - (y || 1)].first_line, last_line: f[f.length - 1].last_line, first_column: f[f.length - (y || 1)].first_column, last_column: f[f.length - 1].last_column }, v = this.performAction.call(w, h, j, i, this.yy, t[1], e, f);if (typeof v != "undefined") return v;y && (d = d.slice(0, -1 * y * 2), e = e.slice(0, -1 * y), f = f.slice(0, -1 * y)), d.push(this.productions_[t[1]][0]), e.push(w.$), f.push(w._$), z = g[d[d.length - 2]][d[d.length - 1]], d.push(z);break;case 3:
	              return !0;}
	        }return !0;
	      } },
	        b = function () {
	      var a = { EOF: 1, parseError: function parseError(b, c) {
	          if (!this.yy.parseError) throw new Error(b);this.yy.parseError(b, c);
	        }, setInput: function setInput(a) {
	          return this._input = a, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }, this;
	        }, input: function input() {
	          var a = this._input[0];this.yytext += a, this.yyleng++, this.match += a, this.matched += a;var b = a.match(/\n/);return b && this.yylineno++, this._input = this._input.slice(1), a;
	        }, unput: function unput(a) {
	          return this._input = a + this._input, this;
	        }, more: function more() {
	          return this._more = !0, this;
	        }, less: function less(a) {
	          this._input = this.match.slice(a) + this._input;
	        }, pastInput: function pastInput() {
	          var a = this.matched.substr(0, this.matched.length - this.match.length);return (a.length > 20 ? "..." : "") + a.substr(-20).replace(/\n/g, "");
	        }, upcomingInput: function upcomingInput() {
	          var a = this.match;return a.length < 20 && (a += this._input.substr(0, 20 - a.length)), (a.substr(0, 20) + (a.length > 20 ? "..." : "")).replace(/\n/g, "");
	        }, showPosition: function showPosition() {
	          var a = this.pastInput(),
	              b = new Array(a.length + 1).join("-");return a + this.upcomingInput() + "\n" + b + "^";
	        }, next: function next() {
	          if (this.done) return this.EOF;this._input || (this.done = !0);var a, b, c, d, e, f;this._more || (this.yytext = "", this.match = "");var g = this._currentRules();for (var h = 0; h < g.length; h++) {
	            c = this._input.match(this.rules[g[h]]);if (c && (!b || c[0].length > b[0].length)) {
	              b = c, d = h;if (!this.options.flex) break;
	            }
	          }if (b) {
	            f = b[0].match(/\n.*/g), f && (this.yylineno += f.length), this.yylloc = { first_line: this.yylloc.last_line, last_line: this.yylineno + 1, first_column: this.yylloc.last_column, last_column: f ? f[f.length - 1].length - 1 : this.yylloc.last_column + b[0].length }, this.yytext += b[0], this.match += b[0], this.yyleng = this.yytext.length, this._more = !1, this._input = this._input.slice(b[0].length), this.matched += b[0], a = this.performAction.call(this, this.yy, this, g[d], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1);if (a) return a;return;
	          }if (this._input === "") return this.EOF;this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), { text: "", token: null, line: this.yylineno });
	        }, lex: function lex() {
	          var b = this.next();return typeof b != "undefined" ? b : this.lex();
	        }, begin: function begin(b) {
	          this.conditionStack.push(b);
	        }, popState: function popState() {
	          return this.conditionStack.pop();
	        }, _currentRules: function _currentRules() {
	          return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	        }, topState: function topState() {
	          return this.conditionStack[this.conditionStack.length - 2];
	        }, pushState: function pushState(b) {
	          this.begin(b);
	        } };return a.options = {}, a.performAction = function (b, c, d, e) {
	        var f = e;switch (d) {case 0:
	            break;case 1:
	            return 6;case 2:
	            return c.yytext = c.yytext.substr(1, c.yyleng - 2), 4;case 3:
	            return 17;case 4:
	            return 18;case 5:
	            return 23;case 6:
	            return 24;case 7:
	            return 22;case 8:
	            return 21;case 9:
	            return 10;case 10:
	            return 11;case 11:
	            return 8;case 12:
	            return 14;case 13:
	            return "INVALID";}
	      }, a.rules = [/^(?:\s+)/, /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/, /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/, /^(?:\{)/, /^(?:\})/, /^(?:\[)/, /^(?:\])/, /^(?:,)/, /^(?::)/, /^(?:true\b)/, /^(?:false\b)/, /^(?:null\b)/, /^(?:$)/, /^(?:.)/], a.conditions = { INITIAL: { rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13], inclusive: !0 } }, a;
	    }();return a.lexer = b, a;
	  }();return typeof a != "undefined" && typeof c != "undefined" && (c.parser = d, c.parse = function () {
	    return d.parse.apply(d, arguments);
	  }, c.main = function (d) {
	    if (!d[1]) throw new Error("Usage: " + d[0] + " FILE");if (typeof process != "undefined") var e = a("fs").readFileSync(a("path").join(process.cwd(), d[1]), "utf8");else var f = a("file").path(a("file").cwd()),
	        e = f.join(d[1]).read({ charset: "utf-8" });return c.parser.parse(e);
	  }, typeof b != "undefined" && a.main === b && c.main(typeof process != "undefined" ? process.argv.slice(1) : a("system").args)), c;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ },
/* 244 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function now() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? other + '' : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
	}
	
	module.exports = debounce;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.5';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading and trailing whitespace. */var reTrim=/^\s+|\s+$/g,reTrimStart=/^\s+/,reTrimEnd=/\s+$/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos='[\'\u2019]',rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
	'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
	'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010A':'C','\u010C':'C','\u0107':'c','\u0109':'c','\u010B':'c','\u010D':'c','\u010E':'D','\u0110':'D','\u010F':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011A':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011B':'e','\u011C':'G','\u011E':'G','\u0120':'G','\u0122':'G','\u011D':'g','\u011F':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012A':'I','\u012C':'I','\u012E':'I','\u0130':'I','\u0129':'i','\u012B':'i','\u012D':'i','\u012F':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013B':'L','\u013D':'L','\u013F':'L','\u0141':'L','\u013A':'l','\u013C':'l','\u013E':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014A':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014B':'n','\u014C':'O','\u014E':'O','\u0150':'O','\u014D':'o','\u014F':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015A':'S','\u015C':'S','\u015E':'S','\u0160':'S','\u015B':'s','\u015D':'s','\u015F':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016A':'U','\u016C':'U','\u016E':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016B':'u','\u016D':'u','\u016F':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017B':'Z','\u017D':'Z','\u017A':'z','\u017C':'z','\u017E':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017F':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=(typeof global==='undefined'?'undefined':_typeof(global))=='object'&&global&&global.Object===Object&&global;/** Detect free variable `self`. */var freeSelf=(typeof self==='undefined'?'undefined':_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=( false?'undefined':_typeof(exports))=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&( false?'undefined':_typeof(module))=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*//**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */var asciiSize=baseProperty('length');/**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function asciiToArray(string){return string.split('');}/**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */function baseIsNaN(value){return value!==value;}/**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */function baseUnary(func){return function(value){return func(value);};}/**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */function cacheHas(cache,key){return cache.has(key);}/**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */var deburrLetter=basePropertyOf(deburredLetters);/**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */function getValue(object,key){return object==null?undefined:object[key];}/**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */function hasUnicode(string){return reHasUnicode.test(string);}/**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */function safeGet(object,key){return key=='__proto__'?undefined:object[key];}/**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*//**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,_Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol?_Symbol.isConcatSpreadable:undefined,symIterator=_Symbol?_Symbol.iterator:undefined,symToStringTag=_Symbol?_Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol?_Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */function baseLodash(){}// No operation performed.
	/**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */lodash.templateSettings={/**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'escape':reEscape,/**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'evaluate':reEvaluate,/**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'interpolate':reInterpolate,/**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */'variable':'',/**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */'imports':{/**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
	Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*//**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */function listCacheClear(){this.__data__=[];this.size=0;}/**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
	ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*//**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
	MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*//**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
	SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*//**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function stackGet(key){return this.__data__.get(key);}/**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function stackHas(key){return this.__data__.has(key);}/**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
	Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*//**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
	key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
	isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
	isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
	isIndex(key,length)))){result.push(key);}}return result;}/**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
	stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});return result;}if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
	assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEach=createBaseEach(baseForOwn);/**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
	baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseFor=createBaseFor();/**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseForRight=createBaseFor(true);/**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */function baseGt(value,other){return value>other;}/**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	if(typeof value=='function'){return value;}if(value==null){return identity;}if((typeof value==='undefined'?'undefined':_typeof(value))=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */function baseLt(value,other){return value<other;}/**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){if(isObject(srcValue)){stack||(stack=new Stack());baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||srcIndex&&isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */function baseOrderBy(collection,iteratees,orders){var index=-1;iteratees=arrayMap(iteratees.length?iteratees:[identity],baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
	// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */function baseSample(collection){return arraySample(values(collection));}/**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndexBy(array,value,iteratee,retHighest){value=iteratee(value);var low=0,high=array==null?0:array.length,valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
	if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
	return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */function castFunction(value){return typeof value=='function'?value:identity;}/**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */var castRest=baseRest;/**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	// that causes it, under certain circumstances, to provide the same value for
	// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	// for more details.
	//
	// This also ensures a stable sort in V8 and other engines.
	// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	return object.index-other.index;}/**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
	// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	// for more details.
	var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
	// See https://es5.github.io/#x13.2.2 for more details.
	return isObject(result)?result:thisBinding;};}/**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
	start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision){// Shift with exponential notation to avoid floating-point issues.
	// See [MDN](https://mdn.io/round#Examples) for more details.
	var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(array);if(stacked&&stack.get(other)){return stacked==other;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
	while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
	if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
	// Invalid dates are coerced to `NaN`.
	return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
	// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	// for more details.
	return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
	stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked&&stack.get(other)){return stacked==other;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
	if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
	if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
	if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */function isIndex(value,length){var type=typeof value==='undefined'?'undefined':_typeof(value);length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index==='undefined'?'undefined':_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value==='undefined'?'undefined':_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */function isKeyable(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */var isMaskable=coreJsData?isFunction:stubFalse;/**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
	if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
	if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
	newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
	var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
	value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
	value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
	if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
	if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
	data[0]=source[0];data[1]=newBitmask;return data;}/**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */function objectToString(value){return nativeObjectToString.call(value);}/**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var setData=shortOut(baseSetData);/**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var setToString=shortOut(baseSetToString);/**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*//**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */function head(array){return array&&array.length?array[0]:undefined;}/**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */var pull=baseRest(pullAll);/**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */var zip=baseRest(unzip);/**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */function tap(value,interceptor){interceptor(value);return value;}/**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */function thru(value,interceptor){return interceptor(value);}/**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */function wrapperChain(){return chain(this);}/**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */function wrapperToIterator(){return this;}/**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*//**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */var find=createFind(findIndex);/**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */var findLast=createFind(findLastIndex);/**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*//**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*//**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
	lastInvokeTime=time;// Start the timer for the trailing edge.
	timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
	return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
	// trailing edge, the system time has gone backwards and we're treating
	// it as the trailing edge, or we've hit the `maxWait` limit.
	return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
	timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
	// debounced at least once.
	if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
	timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
	memoize.Cache=MapCache;/**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */function once(func){return before(2,func);}/**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */function unary(func){return ary(func,1);}/**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*//**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */var gt=createRelationalOperation(baseGt);/**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */var isArray=Array.isArray;/**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */var isBuffer=nativeIsBuffer||stubFalse;/**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */function isEqual(value,other){return baseIsEqual(value,other);}/**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
	// in Safari 9 which returns 'object' for typed arrays and other constructors.
	var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */function isObject(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */function isObjectLike(value){return value!=null&&(typeof value==='undefined'?'undefined':_typeof(value))=='object';}/**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
	// Perform the `toStringTag` check first to avoid errors with some
	// ActiveX objects in IE.
	return isNumber(value)&&value!=+value;}/**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */function isNull(value){return value===null;}/**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */function isNil(value){return value==null;}/**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */function isSymbol(value){return(typeof value==='undefined'?'undefined':_typeof(value))=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */function isUndefined(value){return value===undefined;}/**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */var lt=createRelationalOperation(baseLt);/**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=value.replace(reTrim,'');var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*//**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */var at=flatRest(baseAt);/**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */var invoke=baseRest(baseInvoke);/**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
	if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */var toPairs=createToPairs(keys);/**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */var toPairsIn=createToPairs(keysIn);/**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*//**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*//**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */var lowerFirst=createCaseFirst('toLowerCase');/**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
	// (http://ejohn.org/blog/javascript-micro-templating/)
	// and Laura Doktorova's doT.js (https://github.com/olado/doT).
	var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
	var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
	var sourceURL='//# sourceURL='+('sourceURL'in options?options.sourceURL:'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
	source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
	if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
	// order to produce the correct `offset` value.
	return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
	// code to add the data object to the top of the scope chain.
	var variable=options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Cleanup code by stripping empty strings.
	source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
	source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
	// the `source` property as a convenience for inlining compiled templates.
	result.source=source;if(isError(result)){throw result;}return result;}/**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */function toLower(value){return toString(value).toLowerCase();}/**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */function toUpper(value){return toString(value).toUpperCase();}/**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrim,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimEnd,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */var upperFirst=createCaseFirst('toUpperCase');/**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*//**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */function constant(value){return function(){return value;};}/**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flow=createFlow();/**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flowRight=createFlow(true);/**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */function identity(value){return value;}/**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */function noop(){}// No operation performed.
	/**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */var over=createOver(arrayMap);/**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */var overEvery=createOver(arrayEvery);/**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */var overSome=createOver(arraySome);/**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */var range=createRange();/**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */var rangeRight=createRange(true);/**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */function stubArray(){return[];}/**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */function stubFalse(){return false;}/**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */function stubObject(){return{};}/**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */function stubString(){return'';}/**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */function stubTrue(){return true;}/**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*//**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */var ceil=createRound('ceil');/**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */var floor=createRound('floor');/**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */function mean(array){return baseMean(array,identity);}/**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */var round=createRound('round');/**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/// Add methods that return wrapped values in chain sequences.
	lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
	lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
	mixin(lodash,lodash);/*------------------------------------------------------------------------*/// Add methods that return unwrapped values in chain sequences.
	lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
	lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*//**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */lodash.VERSION=VERSION;// Assign default placeholders.
	arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
	arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
	arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
	isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
	arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'',names=realNames[key]||(realNames[key]=[]);names.push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
	LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
	lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
	lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/// Export lodash.
	var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
	if("function"=='function'&&_typeof(__webpack_require__(117))=='object'&&__webpack_require__(117)){// Expose Lodash on the global object to prevent errors when Lodash is
	// loaded by a script tag in the presence of an AMD loader.
	// See http://requirejs.org/docs/errors.html#mismatch for more details.
	// Use `_.noConflict` to remove Lodash from the global object.
	root._=_;// Define as an anonymous module so, through path mapping, it can be
	// referenced as the "underscore" module.
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return _;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
	else if(freeModule){// Export for Node.js.
	(freeModule.exports=_)._=_;// Export for CommonJS support.
	freeExports._=_;}else{// Export to the global object.
	root._=_;}}).call(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(4)(module)))

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Factory = __webpack_require__(356);
	
	var _Factory2 = _interopRequireDefault(_Factory);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	__webpack_require__(236).polyfill(); // for IE
	
	__webpack_require__(354);
	__webpack_require__(339);
	__webpack_require__(247);
	
	var moduleName = 'ng-admin';
	var factory = angular.module('AdminDescriptionModule', []);
	factory.constant('AdminDescription', new _Factory2.default());
	
	var ngadmin = angular.module(moduleName, ['ui.select', 'main', 'crud', 'AdminDescriptionModule']);
	
	ngadmin.config(['NgAdminConfigurationProvider', 'AdminDescription', function (NgAdminConfigurationProvider, AdminDescription) {
	    NgAdminConfigurationProvider.setAdminDescription(AdminDescription);
	}]);
	
	ngadmin.config(['uiSelectConfig', function (uiSelectConfig) {
	    uiSelectConfig.theme = 'bootstrap';
	}]);
	
	exports.default = moduleName;
	module.exports = exports['default'];
	//# sourceMappingURL=ng-admin.js.map

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	__webpack_require__(389);
	__webpack_require__(391);
	__webpack_require__(390);
	
	__webpack_require__(226);
	
	var CrudModule = _angular2.default.module('crud', ['ui.router', 'ui.bootstrap', 'ui.codemirror', 'ngSanitize', 'textAngular', 'ngInflection', 'ngFileUpload', 'ngNumeraljs']);
	
	CrudModule.controller('ListLayoutController', __webpack_require__(318));
	CrudModule.controller('ListController', __webpack_require__(317));
	CrudModule.controller('ShowController', __webpack_require__(336));
	CrudModule.controller('FormController', __webpack_require__(316));
	CrudModule.controller('DeleteController', __webpack_require__(277));
	CrudModule.controller('BatchDeleteController', __webpack_require__(276));
	
	CrudModule.service('EntryFormatter', __webpack_require__(328));
	CrudModule.service('PromisesResolver', __webpack_require__(329));
	CrudModule.service('ReadQueries', __webpack_require__(332));
	CrudModule.service('ReferenceRefresher', __webpack_require__(333));
	CrudModule.service('WriteQueries', __webpack_require__(334));
	
	CrudModule.service('RestWrapper', __webpack_require__(330));
	
	CrudModule.directive('maJsonValidator', __webpack_require__(338));
	
	CrudModule.directive('maField', __webpack_require__(284));
	CrudModule.directive('maButtonField', __webpack_require__(278));
	CrudModule.directive('maChoiceField', __webpack_require__(280));
	CrudModule.directive('maChoicesField', __webpack_require__(281));
	CrudModule.directive('maDateField', __webpack_require__(282));
	CrudModule.directive('maEmbeddedListField', __webpack_require__(283));
	CrudModule.directive('maInputField', __webpack_require__(286));
	CrudModule.directive('maJsonField', __webpack_require__(287));
	CrudModule.directive('maFileField', __webpack_require__(285));
	CrudModule.directive('maCheckboxField', __webpack_require__(279));
	CrudModule.directive('maReferenceField', __webpack_require__(288));
	CrudModule.directive('maReferenceManyField', __webpack_require__(289));
	CrudModule.directive('maTextField', __webpack_require__(291));
	CrudModule.directive('maWysiwygField', __webpack_require__(292));
	CrudModule.directive('maTemplateField', __webpack_require__(290));
	CrudModule.directive('uiSelectRequired', __webpack_require__(293));
	
	CrudModule.provider('FieldViewConfiguration', __webpack_require__(301));
	
	CrudModule.directive('maListActions', __webpack_require__(326));
	CrudModule.directive('maDatagrid', __webpack_require__(319));
	CrudModule.directive('maDatagridPagination', __webpack_require__(324));
	CrudModule.directive('maDatagridInfinitePagination', __webpack_require__(321));
	CrudModule.directive('maDatagridItemSelector', __webpack_require__(322));
	CrudModule.directive('maDatagridMultiSelector', __webpack_require__(323));
	CrudModule.directive('maFilterForm', __webpack_require__(315));
	CrudModule.directive('maFilter', __webpack_require__(314));
	
	CrudModule.directive('maColumn', __webpack_require__(262));
	CrudModule.directive('maBooleanColumn', __webpack_require__(260));
	CrudModule.directive('maChoicesColumn', __webpack_require__(261));
	CrudModule.directive('maDateColumn', __webpack_require__(263));
	CrudModule.directive('maEmbeddedListColumn', __webpack_require__(264));
	CrudModule.directive('maJsonColumn', __webpack_require__(265));
	CrudModule.directive('maNumberColumn', __webpack_require__(266));
	CrudModule.directive('maReferenceColumn', __webpack_require__(267));
	CrudModule.directive('maReferencedListColumn', __webpack_require__(271));
	CrudModule.directive('maReferenceLinkColumn', __webpack_require__(268));
	CrudModule.directive('maReferenceManyColumn', __webpack_require__(269));
	CrudModule.directive('maReferenceManyLinkColumn', __webpack_require__(270));
	CrudModule.directive('maStringColumn', __webpack_require__(272));
	CrudModule.directive('maTemplateColumn', __webpack_require__(273));
	CrudModule.directive('maWysiwygColumn', __webpack_require__(274));
	
	CrudModule.directive('maBackButton', __webpack_require__(248));
	CrudModule.directive('maCreateButton', __webpack_require__(250));
	CrudModule.directive('maEditButton', __webpack_require__(252));
	CrudModule.directive('maFilterButton', __webpack_require__(254));
	CrudModule.directive('maFilteredListButton', __webpack_require__(255));
	CrudModule.directive('maShowButton', __webpack_require__(257));
	CrudModule.directive('maListButton', __webpack_require__(256));
	CrudModule.directive('maDeleteButton', __webpack_require__(251));
	CrudModule.directive('maBatchDeleteButton', __webpack_require__(249));
	CrudModule.directive('maExportToCsvButton', __webpack_require__(253));
	CrudModule.directive('maSubmitButton', __webpack_require__(258));
	CrudModule.directive('maViewBatchActions', __webpack_require__(259));
	
	CrudModule.directive('maShowItem', __webpack_require__(337));
	CrudModule.directive('maViewActions', __webpack_require__(331));
	CrudModule.directive('compile', __webpack_require__(327));
	
	CrudModule.config(__webpack_require__(335));
	CrudModule.config(__webpack_require__(275));
	
	CrudModule.factory('Papa', function () {
	    return __webpack_require__(386);
	});
	
	CrudModule.factory('notification', function () {
	    var humane = __webpack_require__(237);
	    humane.timeout = 5000;
	    humane.clickToClose = true;
	    return humane;
	});
	
	CrudModule.factory('progression', function () {
	    return __webpack_require__(385);
	});
	
	CrudModule.run(['Restangular', 'NgAdminConfiguration', function (Restangular, NgAdminConfiguration) {
	    Restangular.setBaseUrl(NgAdminConfiguration().baseApiUrl());
	}]);
	
	exports.default = CrudModule;
	module.exports = exports['default'];
	//# sourceMappingURL=CrudModule.js.map

/***/ },
/* 248 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maBackButtonDirective;
	/**
	 * Link to previous page
	 *
	 * Usage:
	 * <ma-back-button entry="entry" size="xs"></ma-back-button>
	 */
	function maBackButtonDirective($window) {
	    return {
	        restrict: 'E',
	        scope: {
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'BACK';
	            scope.back = function () {
	                return $window.history.back();
	            };
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ng-click="back()">\n<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maBackButtonDirective.$inject = ['$window'];
	module.exports = exports['default'];
	//# sourceMappingURL=maBackButton.js.map

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maBatchDeleteButtonDirective;
	function maBatchDeleteButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            selection: '&',
	            label: '@'
	        },
	        link: function link($scope) {
	            $scope.label = $scope.label || 'DELETE';
	            $scope.gotoBatchDelete = function () {
	                var ids = $scope.selection().map(function (entry) {
	                    return entry.identifierValue;
	                });
	
	                $state.go('batchDelete', angular.extend({
	                    ids: ids,
	                    entity: $scope.entity().name()
	                }, $state.params));
	            };
	        },
	        template: '<span ng-click="gotoBatchDelete()">\n<span class="glyphicon glyphicon-trash" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</span>'
	    };
	}
	
	maBatchDeleteButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maBatchDeleteButton.js.map

/***/ },
/* 250 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maCreateButtonDirective;
	/**
	 * Link to create
	 *
	 * Usage:
	 * <ma-create-button entity="entity" default-values="{}" size="xs"></ma-create-button>
	 */
	function maCreateButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            defaultValues: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'CREATE';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.defaultValues = scope.defaultValues();
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="create(stateParams)">\n<span class="glyphicon glyphicon-plus" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maCreateButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maCreateButton.js.map

/***/ },
/* 251 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maDeleteButtonDirective;
	/**
	 * Link to delete
	 *
	 * Usage:
	 * <ma-delete-button entity="entity" entry="entry" size="xs"></ma-delete-button>
	 */
	function maDeleteButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'DELETE';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="delete(stateParams)">\n<span class="glyphicon glyphicon-trash" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maDeleteButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDeleteButton.js.map

/***/ },
/* 252 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maEditButtonDirective;
	/**
	 * Link to edit
	 *
	 * Usage:
	 * <ma-edit-button entity="entity" entry="entry" size="xs"></ma-edit-button>
	 */
	function maEditButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'EDIT';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="edit(stateParams)">\n<span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maEditButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maEditButton.js.map

/***/ },
/* 253 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maExportToCsvButton;
	function maExportToCsvButton($stateParams, Papa, notification, AdminDescription, entryFormatter, ReadQueries) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            label: '@',
	            datastore: '&'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'EXPORT';
	            scope.datastore = scope.datastore();
	            scope.entity = scope.entity();
	            var exportView = scope.entity.exportView();
	            var listView = scope.entity.listView();
	            if (exportView.fields().length === 0) {
	                var exportFields = listView.exportFields();
	                if (exportFields === null) {
	                    exportFields = listView.fields();
	                }
	                exportView.fields(exportFields);
	                exportView.filters(listView.filters());
	                exportView.name(listView.name()); // to enable reuse of sortField
	            }
	            scope.has_export = exportView.fields().length > 0;
	            var formatEntry = entryFormatter.getFormatter(exportView.fields());
	
	            scope.exportToCsv = function () {
	                var rawEntries;
	
	                ReadQueries.getAll(exportView, -1, $stateParams.search, $stateParams.sortField, $stateParams.sortDir).then(function (response) {
	                    rawEntries = response.data;
	                    return rawEntries;
	                }).then(function (rawEntries) {
	                    return ReadQueries.getReferenceData(exportView.fields(), rawEntries);
	                }).then(function (referenceData) {
	                    var references = exportView.getReferences();
	                    for (var name in referenceData) {
	                        AdminDescription.getEntryConstructor().createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                            return scope.datastore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                        });
	                    }
	                }).then(function () {
	                    var entries = exportView.mapEntries(rawEntries);
	
	                    // shortcut to diplay collection of entry with included referenced values
	                    scope.datastore.fillReferencesValuesFromCollection(entries, exportView.getReferences(), true);
	
	                    var results = [];
	                    for (var i = entries.length - 1; i >= 0; i--) {
	                        results[i] = formatEntry(entries[i]);
	                    }
	                    var csv = Papa.unparse(results, listView.exportOptions());
	                    var fakeLink = document.createElement('a');
	                    document.body.appendChild(fakeLink);
	
	                    var blobName = scope.entity.name() + '.csv';
	
	                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                        // Manage IE11+ & Edge
	                        var blob = new Blob([csv], { type: 'text/csv' });
	                        window.navigator.msSaveOrOpenBlob(blob, blobName);
	                    } else {
	                        fakeLink.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(csv));
	                        fakeLink.setAttribute('download', blobName);
	                        fakeLink.click();
	                    }
	                }, function (error) {
	                    notification.log(error.message, { addnCls: 'humane-flatty-error' });
	                });
	            };
	        },
	        template: '<span ng-if="has_export">\n    <a class="btn btn-default" ng-click="exportToCsv()">\n        <span class="glyphicon glyphicon-download" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n    </a>\n</span>'
	    };
	}
	
	maExportToCsvButton.$inject = ['$stateParams', 'Papa', 'notification', 'AdminDescription', 'EntryFormatter', 'ReadQueries'];
	module.exports = exports['default'];
	//# sourceMappingURL=maExportToCsvButton.js.map

/***/ },
/* 254 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFilterButton;
	function maFilterButton() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '&',
	            enabledFilters: '=',
	            enableFilter: '&',
	            label: "@"
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'ADD_FILTER';
	            scope.notYetEnabledFilters = function () {
	                return scope.filters().filter(function (filter) {
	                    return scope.enabledFilters.indexOf(filter) === -1;
	                });
	            };
	            scope.hasFilters = function () {
	                return scope.notYetEnabledFilters().length > 0;
	            };
	        },
	        template: '<span class="btn-group" uib-dropdown is-open="isopen" ng-if="hasFilters()">\n    <button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle >\n        <span class="glyphicon glyphicon-filter" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>&nbsp;<span class="caret"></span>\n    </button>\n    <ul class="dropdown-menu" role="menu">\n        <li ng-repeat="filter in notYetEnabledFilters()" ng-switch="button">\n            <a ng-click="enableFilter()(filter)">{{ filter.label() | translate }}</a>\n        </li>\n    </ul>\n</span>'
	    };
	}
	
	maFilterButton.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maFilterButton.js.map

/***/ },
/* 255 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFilteredListButtonDirective;
	/**
	 * Link to filtered list
	 *
	 * Usage:
	 *
	 *     <!-- In a scope where the current entry is a post, link tio the related comments -->
	 *     <ma-filtered-list-button
	 *       entity-name="comments"
	 *       filter="{ post_id: entry.values.id }"
	 *       text="See related comments"
	 *       size="xs">
	 *     </ma-filtered-list-button>')
	 *
	 * Usage as a template field:
	 *
	 * nga.field('', 'template')
	 *   .label('')
	 *   .template('<ma-filtered-list-button entity-name="comments" filter="{ post_id: entry.values.id }"></ma-filtered-list-button>')
	 */
	function maFilteredListButtonDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            entityName: '@',
	            filter: '&',
	            label: '@',
	            size: '@'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'SEE_RELATED';
	            scope.stateParams = { 'entity': scope.entityName, 'search': scope.filter() };
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="list(stateParams)">\n    <span class="glyphicon glyphicon-list" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}" translate-values="{ entityName: entityName }"></span>\n</a>'
	    };
	}
	
	maFilteredListButtonDirective.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maFilteredListButton.js.map

/***/ },
/* 256 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maListButtonDirective;
	/**
	 * Link to list
	 *
	 * Usage:
	 * <ma-list-button entity="entity" size="xs"></ma-list-button>
	 */
	function maListButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'LIST';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="list(stateParams)">\n<span class="glyphicon glyphicon-list" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maListButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maListButton.js.map

/***/ },
/* 257 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maShowButtonDirective;
	/**
	 * Link to show
	 *
	 * Usage:
	 * <ma-show-button entity="entity" entry="entry" size="xs"></ma-show-button>
	 */
	function maShowButtonDirective($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'SHOW';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? _extends({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ui-sref="show(stateParams)">\n<span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	maShowButtonDirective.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maShowButton.js.map

/***/ },
/* 258 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maSubmitButtonDirective;
	/**
	 * Save button
	 *
	 * Usage:
	 * <ma-submit-button label="Save changes"></ma-submit-button>
	 */
	function maSubmitButtonDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            label: '@'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'SAVE';
	        },
	        template: '<button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span></button>'
	    };
	}
	
	maSubmitButtonDirective.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maSubmitButton.js.map

/***/ },
/* 259 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maViewBatchActionsDirective;
	function maViewBatchActionsDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            'entity': '=',
	            'selection': '=',
	            'buttons': '&',
	            'label': '@'
	        },
	        link: function link(scope) {
	            scope.label = scope.label || 'N_SELECTED';
	            scope.isopen = false;
	            scope.toggleDropdown = function ($event) {
	                $event.preventDefault();
	                $event.stopPropagation();
	                scope.isopen = !scope.isopen;
	            };
	            scope.buttons = scope.buttons();
	            if (typeof scope.buttons === 'string') {
	                scope.customTemplate = scope.buttons;
	                scope.buttons = null;
	            }
	        },
	        // the ng-class hidden is necessary to hide the inner blank space used for spacing buttons when the selection is not empty
	        template: '<span ng-if="selection" ng-class="{hidden:!selection || selection.length==0}"> <span class="btn-group" uib-dropdown is-open="isopen"><button type="button" ng-if="selection.length" class="btn btn-default dropdown-toggle" uib-dropdown-toggle >\n            <span translate="{{ ::label }}" translate-values="{ length: selection.length }"></span>&nbsp;<span class="caret"></span>\n        </button>\n        <ul class="dropdown-menu" role="menu">\n            <li ng-repeat="button in buttons" ng-switch="button">\n                <a ng-switch-when="delete">\n                    <ma-batch-delete-button selection="selection" entity="entity"/>\n                </a>\n                <a ng-switch-default>\n                    <span compile="button"></span>\n                </a>\n            </li>\n        </ul>\n    </span>\n</span>'
	    };
	}
	
	maViewBatchActionsDirective.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maViewBatchActions.js.map

/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maBooleanColumn;
	function maBooleanColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        link: function link(scope) {
	            scope.value = scope.value();
	        },
	        template: '<span class="glyphicon" ng-class="{\'glyphicon-ok\': !!value, \'glyphicon-remove\': !value }"></span>'
	    };
	}
	
	maBooleanColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maBooleanColumn.js.map

/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maChoicesColumn;
	function maChoicesColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            values: '&'
	        },
	        template: '<span ng-repeat="ref in values() track by $index" class="label label-default">{{ ref }}</span>'
	    };
	}
	
	maChoicesColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maChoicesColumn.js.map

/***/ },
/* 262 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	exports.default = maColumn;
	function maColumn($state, $anchorScroll, $compile, Configuration, FieldViewConfiguration) {
	
	    function getDetailLinkRouteName(field, entity) {
	        if (entity.isReadOnly) {
	            return entity.showView().enabled ? 'show' : false;
	        }
	        if (field.detailLinkRoute() == 'edit' && entity.editionView().enabled) {
	            return 'edit';
	        }
	        return entity.showView().enabled ? 'show' : false;
	    }
	
	    function isDetailLink(field, entity) {
	        if (field.isDetailLink() === false) {
	            return false;
	        }
	        if (field.type() == 'reference' || field.type() == 'reference_many') {
	            var relatedEntity = Configuration().getEntity(field.targetEntity().name());
	            if (!relatedEntity) {
	                return false;
	            }
	            return getDetailLinkRouteName(field, relatedEntity) !== false;
	        }
	        return getDetailLinkRouteName(field, entity) !== false;
	    }
	
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '&',
	            entity: '&',
	            datastore: '&'
	        },
	        link: function link(scope, element) {
	            scope.datastore = scope.datastore();
	            scope.field = scope.field();
	            scope.entry = scope.entry();
	            scope.value = typeof scope.entry === 'undefined' ? '' : scope.entry.values[scope.field.name()];
	            scope.entity = scope.entity();
	            var customTemplate = scope.field.getTemplateValue(scope.entry);
	            if (customTemplate && !scope.field.templateIncludesLabel()) {
	                element.append(customTemplate);
	            } else {
	                var type = scope.field.type();
	                if (isDetailLink(scope.field, scope.entity)) {
	                    element.append(FieldViewConfiguration[type].getLinkWidget());
	                } else {
	                    element.append(FieldViewConfiguration[type].getReadWidget());
	                }
	            }
	            scope.detailState = false;
	            scope.detailStateParams = {};
	            if (typeof scope.entry !== 'undefined') {
	                scope.detailState = getDetailLinkRouteName(scope.field, scope.entity);
	                scope.detailStateParams = _extends({}, $state.params, {
	                    entity: scope.entry.entityName,
	                    id: scope.entry.identifierValue
	                });
	            }
	            $compile(element.contents())(scope);
	        }
	    };
	}
	
	maColumn.$inject = ['$state', '$anchorScroll', '$compile', 'NgAdminConfiguration', 'FieldViewConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=maColumn.js.map

/***/ },
/* 263 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDateColumn;
	function maDateColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&',
	            field: '&'
	        },
	        link: function link(scope) {
	            var field = scope.field();
	            scope.format = field.format();
	            if (!scope.format) {
	                scope.format = field.type() === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss';
	            }
	        },
	        template: '<span>{{ value() | date:format }}</span>'
	    };
	}
	
	maDateColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDateColumn.js.map

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maEmbeddedListColumn;
	
	var _Entry = __webpack_require__(6);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function sorter(sortField, sortDir) {
	    return function (entry1, entry2) {
	        // use < and > instead of substraction to sort strings properly
	        var sortFactor = sortDir === 'DESC' ? -1 : 1;
	        if (entry1.values[sortField] > entry2.values[sortField]) {
	            return sortFactor;
	        }
	        if (entry1.values[sortField] < entry2.values[sortField]) {
	            return -1 * sortFactor;
	        }
	        return 0;
	    };
	}
	
	function maEmbeddedListColumn(NgAdminConfiguration) {
	    var application = NgAdminConfiguration(); // jshint ignore:line
	    return {
	        scope: {
	            'field': '&',
	            'value': '&',
	            'datastore': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var field = scope.field();
	                var targetEntity = field.targetEntity();
	                var targetEntityName = targetEntity.name();
	                var targetFields = field.targetFields();
	                var sortField = field.sortField();
	                var sortDir = field.sortDir();
	                var filterFunc;
	                if (field.permanentFilters()) {
	                    (function () {
	                        var filters = field.permanentFilters();
	                        var filterKeys = Object.keys(filters);
	                        filterFunc = function filterFunc(entry) {
	                            return filterKeys.reduce(function (isFiltered, key) {
	                                return isFiltered && entry.values[key] === filters[key];
	                            }, true);
	                        };
	                    })();
	                } else {
	                    filterFunc = function filterFunc() {
	                        return true;
	                    };
	                }
	                var entries = _Entry2.default.createArrayFromRest(scope.value() || [], targetFields, targetEntityName, targetEntity.identifier().name()).sort(sorter(sortField, sortDir)).filter(filterFunc);
	                if (!targetEntityName) {
	                    (function () {
	                        var index = 0;
	                        entries = entries.map(function (e) {
	                            e._identifierValue = index++;
	                            return e;
	                        });
	                    })();
	                }
	                scope.field = field;
	                scope.targetFields = targetFields;
	                scope.entries = entries;
	                scope.entity = targetEntityName ? application.getEntity(targetEntityName) : targetEntity;
	                scope.sortField = sortField;
	                scope.sortDir = sortDir;
	                scope.sort = function (field) {
	                    var sortDir = 'ASC';
	                    var sortField = field.name();
	                    if (scope.sortField === sortField) {
	                        // inverse sort dir
	                        sortDir = scope.sortDir === 'ASC' ? 'DESC' : 'ASC';
	                    }
	                    scope.entries = scope.entries.sort(sorter(sortField, sortDir));
	                    scope.sortField = sortField;
	                    scope.sortDir = sortDir;
	                };
	            }
	        },
	        template: '\n<ma-datagrid ng-if="::entries.length > 0"\n    entries="entries"\n    fields="::targetFields"\n    list-actions="::field.listActions()"\n    entity="::entity"\n    datastore="::datastore()"\n    sort-field="sortField"\n    sort-dir="sortDir"\n    sort="::sort">\n</ma-datagrid>'
	    };
	}
	
	maEmbeddedListColumn.$inject = ['NgAdminConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=maEmbeddedListColumn.js.map

/***/ },
/* 265 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maJsonColumn;
	function maJsonColumn($compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        link: function link(scope, element) {
	            scope.guessType = function (obj) {
	                var type = Object.prototype.toString.call(obj);
	
	                if (type === "[object Object]") {
	                    return "Object";
	                }
	
	                if (type === "[object Array]") {
	                    return "Array";
	                }
	
	                return "Literal";
	            };
	
	            var template = '<span ng-switch="guessType(value())">\n    <table class="table table-condensed" ng-switch-when="Array">\n        <tbody>\n            <tr ng-repeat="val in value() track by $index">\n                <td ng-switch="guessType(val)">\n                    <ma-json-column ng-switch-when="Object" value="::val"></ma-json-column>\n                    <ma-json-column ng-switch-when="Array" value="::val"></ma-json-column>\n                    <span ng-switch-when="Literal">{{ val }}</span>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n    <table class="table table-condensed table-bordered" ng-switch-when="Object">\n        <tbody>\n            <tr ng-repeat="(key, val) in value() track by key">\n                <th class="active">{{ key }}</th>\n                <td ng-switch="guessType(val)">\n                    <ma-json-column ng-switch-when="Object" value="::val"></ma-json-column>\n                    <ma-json-column ng-switch-when="Array" value="::val"></ma-json-column>\n                    <span ng-switch-when="Literal">{{ val }}</span>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</span>';
	
	            var newElement = angular.element(template);
	            $compile(newElement)(scope);
	            element.replaceWith(newElement);
	        }
	    };
	}
	
	maJsonColumn.$inject = ['$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maJsonColumn.js.map

/***/ },
/* 266 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maNumberColumn;
	function maNumberColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&',
	            field: '&'
	        },
	        template: '<span>{{ value() | numeraljs:field().format() }}</span>'
	    };
	}
	
	maNumberColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maNumberColumn.js.map

/***/ },
/* 267 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceColumn;
	function maReferenceColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            value: '&',
	            datastore: '&'
	        },
	        link: {
	            pre: function pre(scope) {
	                var value = scope.value();
	                scope.field = scope.field();
	                scope.targetEntity = scope.field.targetEntity();
	                scope.targetField = scope.field.targetField();
	                var identifierName = scope.targetEntity.identifier().name();
	                scope.referencedEntry = scope.datastore().getFirstEntry(scope.targetEntity.uniqueId + '_values', function (entry) {
	                    return entry.values[identifierName] == value;
	                });
	            }
	        },
	        template: '<ma-column field="::targetField" entry="::referencedEntry" entity="::targetEntity" datastore="::datastore()"></ma-column>'
	    };
	}
	
	maReferenceColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceColumn.js.map

/***/ },
/* 268 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceLinkColumn;
	function getDetailLinkRouteName(field, entity) {
	    if (entity.isReadOnly) {
	        return entity.showView().enabled ? 'show' : false;
	    }
	    if (field.detailLinkRoute() == 'edit' && entity.editionView().enabled) {
	        return 'edit';
	    }
	    return entity.showView().enabled ? 'show' : false;
	}
	
	function maReferenceLinkColumn(NgAdminConfiguration) {
	    return {
	        restrict: 'E',
	        scope: {
	            entry: '&',
	            field: '&',
	            value: '&',
	            datastore: '&'
	        },
	        link: {
	            pre: function pre(scope) {
	                var field = scope.field();
	                var referenceEntity = field.targetEntity().name();
	                var relatedEntity = NgAdminConfiguration().getEntity(referenceEntity);
	                var referenceId = scope.entry().values[field.name()];
	                scope.route = getDetailLinkRouteName(field, relatedEntity);
	                scope.stateParams = {
	                    entity: referenceEntity,
	                    id: referenceId
	                };
	                scope.field = field;
	            }
	        },
	        template: '<a ui-sref="{{route}}(stateParams)"><ma-reference-column field="::field" value="::value()" datastore="::datastore()"></ma-reference-column></a>'
	    };
	}
	
	maReferenceLinkColumn.$inject = ['NgAdminConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceLinkColumn.js.map

/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceManyColumn;
	function maReferenceManyColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            values: '&'
	        },
	        template: '<span ng-repeat="ref in values() track by $index">\n    <span class="label label-default">{{ ref }}</span>\n</span>'
	    };
	}
	
	maReferenceManyColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceManyColumn.js.map

/***/ },
/* 270 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceManyLinkColumn;
	function maReferenceManyLinkColumn(NgAdminConfiguration) {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            values: '&',
	            ids: '&'
	        },
	        link: function link(scope) {
	            scope.field = scope.field();
	            scope.values = scope.values();
	            scope.ids = scope.ids();
	            scope.referenceEntity = scope.field.targetEntity().name();
	            scope.route = NgAdminConfiguration().getEntity(scope.referenceEntity).isReadOnly ? 'show' : 'edit';
	        },
	        template: '<a ng-repeat="ref in values track by $index" ui-sref="{{route}}({ entity: referenceEntity, id: ids[$index] })" class="multiple">\n    <span class="label label-default">{{ ref }}</span>\n</a>'
	    };
	}
	
	maReferenceManyLinkColumn.$inject = ['NgAdminConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceManyLinkColumn.js.map

/***/ },
/* 271 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferencedListColumn;
	function isSortFieldForMe(sortField, field) {
	    if (!sortField) return false;
	    return sortField.split('.')[0] == field.targetEntity().name() + '_ListView';
	}
	
	function maReferencedListColumn(NgAdminConfiguration, $stateParams) {
	    return {
	        scope: {
	            'field': '&',
	            'datastore': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                scope.field = scope.field();
	                var targetEntity = scope.field.targetEntity();
	                scope.entries = scope.datastore().getEntries(targetEntity.uniqueId + '_list');
	                scope.entity = NgAdminConfiguration().getEntity(targetEntity.name());
	                scope.sortField = isSortFieldForMe($stateParams.sortField, scope.field) ? $stateParams.sortField : scope.field.getSortFieldName();
	                scope.sortDir = $stateParams.sortDir || scope.field.sortDir();
	            }
	        },
	        template: '\n<ma-datagrid ng-if="::entries.length > 0" name="{{ field.datagridName() }}"\n    entries="::entries"\n    fields="::field.targetFields()"\n    list-actions="::field.listActions()"\n    entity="::entity"\n    sort-field="::sortField"\n    sort-dir="::sortDir"\n    datastore="::datastore()"\n    entry-css-classes="::field.entryCssClasses()">\n</ma-datagrid>'
	    };
	}
	
	maReferencedListColumn.$inject = ['NgAdminConfiguration', '$stateParams'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferencedListColumn.js.map

/***/ },
/* 272 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maStringColumn;
	function maStringColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        template: '<span>{{ value() | translate }}</span>'
	    };
	}
	
	maStringColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maStringColumn.js.map

/***/ },
/* 273 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maTemplateColumn;
	function maTemplateColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '&',
	            entity: '&'
	        },
	        link: function link(scope) {
	            scope.field = scope.field();
	            scope.entry = scope.entry();
	            scope.entity = scope.entity();
	        },
	        template: '<span compile="field.getTemplateValue(entry)"></span>'
	    };
	}
	
	maTemplateColumn.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maTemplateColumn.js.map

/***/ },
/* 274 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maWysiwygColumn;
	function maWysiwygColumn($filter) {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&',
	            field: '&'
	        },
	        link: function link(scope) {
	            var value = scope.value();
	            if (scope.field().stripTags()) {
	                value = $filter('stripTags')(value);
	            }
	            scope.htmlValue = value;
	        },
	        template: '<span ng-bind-html="htmlValue"></span>'
	    };
	}
	
	maWysiwygColumn.$inject = ['$filter'];
	module.exports = exports['default'];
	//# sourceMappingURL=maWysiwygColumn.js.map

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = factories;
	function factories(fvp) {
	    fvp.registerFieldView('boolean', __webpack_require__(294));
	    fvp.registerFieldView('choice', __webpack_require__(295));
	    fvp.registerFieldView('choices', __webpack_require__(296));
	    fvp.registerFieldView('date', __webpack_require__(297));
	    fvp.registerFieldView('datetime', __webpack_require__(298));
	    fvp.registerFieldView('email', __webpack_require__(299));
	    fvp.registerFieldView('embedded_list', __webpack_require__(300));
	    fvp.registerFieldView('file', __webpack_require__(302));
	    fvp.registerFieldView('float', __webpack_require__(303));
	    fvp.registerFieldView('json', __webpack_require__(304));
	    fvp.registerFieldView('number', __webpack_require__(305));
	    fvp.registerFieldView('password', __webpack_require__(306));
	    fvp.registerFieldView('referenced_list', __webpack_require__(309));
	    fvp.registerFieldView('reference', __webpack_require__(307));
	    fvp.registerFieldView('reference_many', __webpack_require__(308));
	    fvp.registerFieldView('string', __webpack_require__(310));
	    fvp.registerFieldView('template', __webpack_require__(311));
	    fvp.registerFieldView('text', __webpack_require__(312));
	    fvp.registerFieldView('wysiwyg', __webpack_require__(313));
	}
	
	factories.$inject = ['FieldViewConfigurationProvider'];
	module.exports = exports['default'];
	//# sourceMappingURL=factories.js.map

/***/ },
/* 276 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var BatchDeleteController = function () {
	    function BatchDeleteController($scope, $state, $translate, WriteQueries, progression, notification, view, HttpErrorService) {
	        _classCallCheck(this, BatchDeleteController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$translate = $translate;
	        this.WriteQueries = WriteQueries;
	        this.progression = progression;
	        this.notification = notification;
	        this.view = view;
	        this.entity = view.getEntity();
	        this.entityIds = $state.params.ids;
	        this.selection = []; // fixme: query db to get selection
	        this.title = view.title();
	        this.description = view.description();
	        this.actions = view.actions();
	        this.loadingPage = false;
	        this.fields = view.fields();
	        this.HttpErrorService = HttpErrorService;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(BatchDeleteController, [{
	        key: 'batchDelete',
	        value: function batchDelete($event) {
	            var _this = this;
	
	            var entityName = this.entity.name();
	            var $translate = this.$translate,
	                $state = this.$state,
	                progression = this.progression,
	                notification = this.notification;
	
	            var fromState = $state.current.name;
	            var fromParams = $state.current.params;
	            var toState = $state.get('list');
	            var toParams = _extends({
	                entity: entityName
	            }, $state.params);
	            progression.start();
	            return this.WriteQueries.batchDelete(this.view, this.entityIds).then(function () {
	                return $state.go(toState, toParams);
	            })
	            // no need to call progression.done() in case of success, as it's called by the view dislayed afterwards
	            .then(function () {
	                return $translate('BATCH_DELETE_SUCCESS');
	            }).then(function (text) {
	                return notification.log(text, { addnCls: 'humane-flatty-success' });
	            }).catch(function (error) {
	                progression.done();
	                _this.HttpErrorService.handleError($event, toState, toParams, fromState, fromParams, error);
	            });
	        }
	    }, {
	        key: 'back',
	        value: function back() {
	            this.$state.go(this.$state.get('list'), angular.extend({
	                entity: this.entity.name()
	            }, this.$state.params));
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$state = undefined;
	            this.$translate = undefined;
	            this.WriteQueries = undefined;
	            this.progression = undefined;
	            this.notification = undefined;
	        }
	    }]);
	
	    return BatchDeleteController;
	}();
	
	exports.default = BatchDeleteController;
	
	BatchDeleteController.$inject = ['$scope', '$state', '$translate', 'WriteQueries', 'progression', 'notification', 'view', 'HttpErrorService'];
	module.exports = exports['default'];
	//# sourceMappingURL=BatchDeleteController.js.map

/***/ },
/* 277 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var DeleteController = function () {
	    function DeleteController($scope, $window, $state, $q, $translate, WriteQueries, Configuration, progression, notification, params, view, entry, HttpErrorService) {
	        var _this = this;
	
	        _classCallCheck(this, DeleteController);
	
	        this.$scope = $scope;
	        this.$window = $window;
	        this.$state = $state;
	        this.$translate = $translate;
	        this.WriteQueries = WriteQueries;
	        this.config = Configuration();
	        this.entityLabel = params.entity;
	        this.entityId = params.id;
	        this.view = view;
	        this.title = view.title();
	        this.description = view.description();
	        this.actions = view.actions();
	        this.entity = view.getEntity();
	        this.progression = progression;
	        this.notification = notification;
	        this.$scope.entry = entry;
	        this.$scope.view = view;
	        this.HttpErrorService = HttpErrorService;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	
	        this.previousStateParametersDeferred = $q.defer();
	        $scope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
	            _this.previousStateParametersDeferred.resolve(fromParams);
	        });
	    }
	
	    _createClass(DeleteController, [{
	        key: 'deleteOne',
	        value: function deleteOne($event) {
	            var _this2 = this;
	
	            return new Promise(function (resolve, reject) {
	                var entityName = _this2.entity.name();
	                var $translate = _this2.$translate,
	                    notification = _this2.notification,
	                    progression = _this2.progression;
	
	                progression.start();
	
	                _this2.previousStateParametersDeferred.promise.then(function (previousStateParameters) {
	                    var fromState = 'delete';
	                    var fromParams = previousStateParameters;
	                    var toState = void 0;
	                    var toParams = void 0;
	
	                    // if previous page was related to deleted entity,
	                    // redirect to list
	                    if (fromParams.entity === entityName && fromParams.id === _this2.entityId) {
	                        toState = _this2.$state.get('list');
	                        toParams = _extends({
	                            entity: entityName
	                        }, _this2.$state.params);
	                    }
	
	                    return _this2.WriteQueries.deleteOne(_this2.view, _this2.entityId).then(function () {
	                        if (toState) {
	                            return _this2.$state.go(toState, toParams);
	                        }
	                        return _this2.back();
	                    }).then(function () {
	                        return $translate('DELETE_SUCCESS');
	                    }).then(function (text) {
	                        return notification.log(text, { addnCls: 'humane-flatty-success' });
	                    }).then(function () {
	                        resolve();
	                    }).catch(function (error) {
	                        progression.done();
	                        _this2.HttpErrorService.handleError($event, toState, toParams, fromState, fromParams, error);
	                        reject();
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'back',
	        value: function back() {
	            this.$window.history.back();
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$window = undefined;
	            this.$state = undefined;
	            this.$translate = undefined;
	            this.WriteQueries = undefined;
	            this.view = undefined;
	            this.entity = undefined;
	            this.progression = undefined;
	            this.notification = undefined;
	        }
	    }]);
	
	    return DeleteController;
	}();
	
	exports.default = DeleteController;
	
	DeleteController.$inject = ['$scope', '$window', '$state', '$q', '$translate', 'WriteQueries', 'NgAdminConfiguration', 'progression', 'notification', 'params', 'view', 'entry', 'HttpErrorService'];
	module.exports = exports['default'];
	//# sourceMappingURL=DeleteController.js.map

/***/ },
/* 278 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maButtonField;
	/**
	 * Toggle input
	 *
	 * @example <ma-button-field type="text" field="field" value="value"></ma-button-field>
	 */
	function maButtonField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.label = field.label();
	            scope.value = !!scope.value;
	            var a = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                a.setAttribute(name, attributes[name]);
	            }
	            scope.toggle = function () {
	                this.value = !this.value;
	            };
	            scope.isActive = function () {
	                return !!this.value;
	            };
	        },
	        template: '<a class="btn btn-default" ng-click="toggle()" id="{{ name }}" ng-class="{active: isActive()}" >{{ label | translate }}</a>'
	    };
	}
	
	maButtonField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maButtonField.js.map

/***/ },
/* 279 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maCheckboxField;
	/**
	 * Generic edition field
	 *
	 * @example <ma-checkbox-field type="text" field="field" value="value"></ma-checkbox-field>
	 */
	function maCheckboxField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.v = field.validation();
	            scope.value = !!scope.value;
	            var input = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                input.setAttribute(name, attributes[name]);
	            }
	        },
	        template: '<input type="checkbox" ng-model="value" id="{{ name }}" name="{{ name }}" class="form-control" />'
	    };
	}
	
	maCheckboxField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maCheckboxField.js.map

/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maChoiceField;
	function updateChoices(scope, choices) {
	    scope.choices = choices;
	    scope.$root.$$phase || scope.$digest();
	}
	
	function maChoiceField($compile) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?',
	            'refresh': '&',
	            'choices': '&?'
	        },
	        restrict: 'E',
	        compile: function compile() {
	            return {
	                pre: function pre(scope, element) {
	                    var field = scope.field();
	                    var attributes = field.attributes();
	                    scope.placeholder = attributes && attributes.placeholder || 'FILTER_VALUES';
	                    scope.name = field.name();
	                    scope.v = field.validation();
	                    scope.$watch('value', function (newValue, oldValue) {
	                        if (newValue !== oldValue && newValue === undefined) {
	                            // fix for https://github.com/angular-ui/ui-select/issues/863
	                            scope.value = null;
	                        }
	                    });
	
	                    var refreshAttributes = '';
	                    var itemsFilter = '| filter: {label: $select.search}';
	                    if (field.type().indexOf('reference') === 0 && field.remoteComplete()) {
	                        // FIXME wrong place to do that
	                        scope.refreshDelay = field.remoteCompleteOptions().refreshDelay;
	                        refreshAttributes = 'refresh-delay="refreshDelay" refresh="refresh({ $search: $select.search })"';
	                        itemsFilter = '';
	                    }
	
	                    var choices = scope.choices ? scope.choices : field.choices ? field.choices() : [];
	                    var choicesFactory = void 0;
	
	                    if (typeof choices === 'function' && choices(scope.entry)) {
	                        choicesFactory = choices;
	                        scope.choices = choicesFactory(scope.entry);
	                    } else {
	                        scope.choices = choices ? choices : [];
	                    }
	
	                    var template = '\n                        <ui-select ng-model="$parent.value" ng-required="v.required" id="{{ name }}" name="{{ name }}">\n                            <ui-select-match allow-clear="{{ !v.required }}" placeholder="{{ placeholder | translate }}">{{ $select.selected.label | translate }}</ui-select-match>\n                            <ui-select-choices ' + refreshAttributes + ' repeat="item.value as item in choices ' + itemsFilter + ' track by $index">\n                                {{ item.label | translate }}\n                            </ui-select-choices>\n                        </ui-select>';
	
	                    // as choices may be a function depending of another entry field, we need to watch the whole entry
	                    scope.$watch('entry', function (newEntry, oldEntry) {
	                        if (!choicesFactory) {
	                            return;
	                        }
	
	                        var oldChoices = scope.choices;
	                        scope.choices = choicesFactory(newEntry);
	                        if (!angular.equals(scope.choices, oldChoices)) {
	                            scope.value = null;
	                        }
	                    }, true);
	
	                    element.html(template);
	
	                    var select = element.children()[0];
	                    for (var name in attributes) {
	                        select.setAttribute(name, attributes[name]);
	                    }
	
	                    $compile(element.contents())(scope);
	                },
	                post: function post(scope) {
	                    scope.$on('choices:update', function (e, data) {
	                        updateChoices(scope, data.choices);
	                    });
	                }
	            };
	        }
	    };
	}
	
	maChoiceField.$inject = ['$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maChoiceField.js.map

/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maChoicesField;
	/**
	 * Edition field for a selection of elements in a list - a multiple select.
	 *
	 * @example <ma-choices-field entry="entry" field="field" value="value"></ma-choices-field>
	 */
	function maChoicesField($compile) {
	    'use strict';
	
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?',
	            'refresh': '&'
	        },
	        restrict: 'E',
	        compile: function compile() {
	            return {
	                pre: function pre(scope, element) {
	                    var field = scope.field();
	                    var attributes = field.attributes();
	                    scope.placeholder = attributes && attributes.placeholder || 'FILTER_VALUES';
	                    scope.name = field.name();
	                    scope.v = field.validation();
	
	                    var refreshAttributes = '';
	                    var itemsFilter = '| filter: {label: $select.search}';
	                    if (field.type().indexOf('reference') === 0 && field.remoteComplete()) {
	                        scope.refreshDelay = field.remoteCompleteOptions().refreshDelay;
	                        refreshAttributes = 'refresh-delay="refreshDelay" refresh="refresh({ $search: $select.search })"';
	                        itemsFilter = '';
	                    }
	
	                    var choices = field.choices ? field.choices() : [];
	
	                    scope.onRemove = function () {
	                        scope.refresh({ $search: this.$select.search });
	                    };
	
	                    var template = '\n                        <ui-select ' + (scope.v.required ? 'ui-select-required' : '') + ' multiple on-remove="onRemove()" ng-model="$parent.value" ng-required="v.required" id="{{ name }}" name="{{ name }}">\n                            <ui-select-match placeholder="{{ placeholder | translate }}">{{ $item.label | translate }}</ui-select-match>\n                            <ui-select-choices ' + refreshAttributes + ' repeat="item.value as item in choices ' + itemsFilter + '">\n                                {{ item.label | translate }}\n                            </ui-select-choices>\n                        </ui-select>';
	
	                    scope.choices = typeof choices === 'function' ? choices(scope.entry) : choices;
	                    element.html(template);
	
	                    var select = element.children()[0];
	
	                    for (var name in attributes) {
	                        select.setAttribute(name, attributes[name]);
	                    }
	
	                    $compile(element.contents())(scope);
	                },
	                post: function post(scope) {
	                    scope.$on('choices:update', function (e, data) {
	                        scope.choices = data.choices;
	                        scope.$root.$$phase || scope.$digest();
	                    });
	                }
	            };
	        }
	    };
	}
	
	maChoicesField.$inject = ['$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maChoicesField.js.map

/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDateField;
	var valueToRawValue = function valueToRawValue(value) {
	    if (value instanceof Date) {
	        return value;
	    }
	
	    return new Date(value);
	};
	
	/**
	 * Edition field for a date - a text input with a datepicker.
	 *
	 * @example <ma-date-field field="field" value="value"></ma-date-field>
	 */
	function maDateField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.rawValue = scope.value == null ? null : valueToRawValue(scope.value);
	
	            scope.$watch('rawValue', function (newRawValue) {
	                if (newRawValue === undefined) {
	                    // ui bootstrap datepicker set value to undefined
	                    // when the value is invalid and null if empty
	                    return;
	                }
	                var newValue = field.parse()(newRawValue);
	
	                if (!angular.equals(scope.value, newValue)) {
	                    scope.value = newValue;
	                }
	            });
	
	            scope.$watch('value', function (newValue, oldValue) {
	                if (angular.equals(newValue, oldValue)) {
	                    return;
	                }
	
	                if (!newValue) {
	                    if (scope.rawValue !== null) {
	                        scope.rawValue = null;
	                    }
	
	                    return;
	                }
	
	                var newRawValue = valueToRawValue(scope.value);
	
	                if (!angular.equals(scope.rawValue, newRawValue)) {
	                    scope.rawValue = newRawValue;
	                }
	            });
	
	            scope.format = field.format();
	            if (!scope.format) {
	                scope.format = field.type() === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss';
	            }
	
	            scope.v = field.validation();
	            scope.isOpen = false;
	            var input = element.find('input').eq(0);
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                input.attr(name, attributes[name]);
	            }
	            scope.toggleDatePicker = function ($event) {
	                $event.preventDefault();
	                $event.stopPropagation();
	                scope.isOpen = !scope.isOpen;
	            };
	        },
	        template: '<div class="input-group datepicker">\n    <input\n        type="text" ng-model="rawValue" id="{{ name }}" name="{{ name }}" class="form-control"\n        uib-datepicker-popup="{{ format }}" is-open="isOpen" ng-required="v.required"\n        close-text="{{ \'CLOSE\' | translate }}" clear-text="{{ \'CLEAR\' | translate }}" current-text="{{ \'CURRENT\' | translate }}"/>\n    <span class="input-group-btn">\n        <button type="button" class="btn btn-default" ng-click="toggleDatePicker($event)">\n            <i class="glyphicon glyphicon-calendar"></i>\n        </button>\n    </span>\n</div>'
	    };
	}
	
	maDateField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDateField.js.map

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maEmbeddedListField;
	
	var _Entry = __webpack_require__(6);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maEmbeddedListField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'datastore': '&'
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var field = scope.field();
	                var targetEntity = field.targetEntity();
	                var targetEntityName = targetEntity.name();
	                var targetFields = field.targetFields();
	                var sortField = field.sortField();
	                var sortDir = field.sortDir() === 'DESC' ? -1 : 1;
	                var filterFunc;
	                if (field.permanentFilters()) {
	                    (function () {
	                        var filters = field.permanentFilters();
	                        var filterKeys = Object.keys(filters);
	                        filterFunc = function filterFunc(entry) {
	                            return filterKeys.reduce(function (isFiltered, key) {
	                                return isFiltered && entry.values[key] === filters[key];
	                            }, true);
	                        };
	                    })();
	                } else {
	                    filterFunc = function filterFunc() {
	                        return true;
	                    };
	                }
	                scope.fields = targetFields;
	                scope.targetEntity = targetEntity;
	                scope.entries = _Entry2.default.createArrayFromRest(scope.value || [], targetFields, targetEntityName, targetEntity.identifier().name()).sort(function (entry1, entry2) {
	                    // use < and > instead of substraction to sort strings properly
	                    if (entry1.values[sortField] > entry2.values[sortField]) {
	                        return sortDir;
	                    }
	                    if (entry1.values[sortField] < entry2.values[sortField]) {
	                        return -1 * sortDir;
	                    }
	                    return 0;
	                }).filter(filterFunc);
	                scope.addNew = function () {
	                    return scope.entries.push(_Entry2.default.createForFields(targetFields));
	                };
	                scope.remove = function (entry) {
	                    scope.entries = scope.entries.filter(function (e) {
	                        return e !== entry;
	                    });
	                };
	                scope.$watch('entries', function (newEntries, oldEntries) {
	                    if (newEntries === oldEntries) {
	                        return;
	                    }
	                    scope.value = newEntries.map(function (e) {
	                        return e.transformToRest(targetFields);
	                    });
	                }, true);
	            }
	        },
	        template: '\n<div class="row"><div class="col-sm-12">\n    <ng-form ng-repeat="entry in entries track by $index" class="subentry" name="subform_{{$index}}" ng-init="formName = \'subform_\' + $index">\n        <div class="remove_button_container">\n            <a class="btn btn-default btn-sm" ng-click="remove(entry)"><span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span>&nbsp;<span translate="REMOVE"></span></a>\n        </div>\n        <div class="form-field form-group" ng-repeat="field in ::fields track by $index">\n            <ma-field field="::field" value="entry.values[field.name()]" entry="entry" entity="::targetEntity" form="formName" datastore="::datastore()"></ma-field>\n        </div>\n        <hr/>\n    </ng-form>\n    <div class="form-group">\n        <div class="col-sm-offset-2 col-sm-10">\n            <a class="btn btn-default btn-sm" ng-click="addNew()"><span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>&nbsp;<span translate="ADD_NEW" translate-values="{ name: field().label().toLowerCase() }"></span></a>\n        </div>\n    </div>\n</div></div>'
	    };
	}
	
	maEmbeddedListField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maEmbeddedListField.js.map

/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maField;
	function maField(FieldViewConfiguration, $compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '=',
	            value: '=',
	            entity: '&',
	            form: '&',
	            datastore: '&'
	        },
	        link: function link(scope, element) {
	            var field = scope.field();
	            var type = field.type();
	            scope.field = field;
	            scope.type = type;
	            scope.entity = scope.entity();
	            scope.form = scope.form();
	            scope.datastore = scope.datastore();
	            scope.getCssClasses = function (entry) {
	                return 'ng-admin-field-' + field.name().replace('.', '_') + ' ng-admin-type-' + type + ' ' + (field.getCssClasses(entry) || 'col-sm-10 col-md-8 col-lg-7');
	            };
	
	            scope.getInput = function () {
	                return scope.form[field.name()];
	            };
	
	            /**
	             * Should validation status be displayed for a given field?
	             *
	             * - No for non-editable fields, or template fields which not have a corresponding input
	             * - No for non-altered input
	             * - Yes otherwise
	             */
	            scope.fieldHasValidation = function () {
	                var input = this.getInput();
	                return input && input.$dirty;
	            };
	
	            scope.fieldIsValid = function () {
	                var input = this.getInput();
	                return input && input.$valid;
	            };
	
	            scope.getFieldValidationClass = function () {
	                if (this.fieldHasValidation()) {
	                    return this.fieldIsValid() ? 'has-success' : 'has-error';
	                }
	            };
	
	            var fieldTemplate;
	            if (scope.field.editable()) {
	                fieldTemplate = '<div ng-class="getCssClasses(entry)">\n    ' + (!field.templateIncludesLabel() && field.getTemplateValue(scope.entry) || FieldViewConfiguration[type].getWriteWidget()) + '\n    <span ng-show="fieldHasValidation()" class="glyphicon form-control-feedback" ng-class="fieldIsValid() ? \'glyphicon-ok\' : \'glyphicon-remove\'"></span>\n</div>';
	            } else {
	                fieldTemplate = '<div ng-class="field.getCssClasses(entry)||\'col-sm-10\'">\n    <p class="form-control-static">\n        <ma-column field="::field" entry="::entry" entity="::entity" datastore="::datastore"></ma-column>\n    </p>\n</div>';
	            }
	
	            var template = '<div id="row-{{ field.name() }}" class="form-field form-group has-feedback" ng-class="getFieldValidationClass()">\n    <label for="{{ field.name() }}" class="col-sm-2 control-label">\n        {{ field.label() | translate }}<span ng-if="field.validation().required">&nbsp;*</span>&nbsp;\n    </label>\n    ' + fieldTemplate + '\n</div>';
	
	            element.append(template);
	            $compile(element.contents())(scope);
	        }
	    };
	}
	
	maField.$inject = ['FieldViewConfiguration', '$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maField.js.map

/***/ },
/* 285 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFileField;
	/**
	 * Edition field for a file - a file uploader.
	 *
	 * @example <ma-file-field field="field"></ma-file-field>
	 */
	function maFileField(Upload) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: {
	            pre: function pre(scope) {
	                var uploadInformation = scope.field().uploadInformation();
	                if (!uploadInformation.hasOwnProperty('url')) {
	                    throw new Error('You must provide a URL property to allow the upload of files.');
	                }
	
	                scope.multiple = uploadInformation.hasOwnProperty('multiple') ? uploadInformation.multiple : false;
	                scope.accept = "*";
	                if (uploadInformation.hasOwnProperty('accept')) {
	                    scope.accept = uploadInformation.accept;
	                }
	                scope.apifilename = uploadInformation.hasOwnProperty('apifilename') ? uploadInformation.apifilename : false;
	
	                var files = scope.value ? scope.value.split(',') : [];
	                scope.files = {};
	                for (var file in files) {
	                    scope.files[files[file]] = {
	                        "name": files[file],
	                        "progress": 0
	                    };
	                }
	            },
	            post: function post(scope, element) {
	                var field = scope.field();
	                scope.name = field.name();
	                scope.v = field.validation();
	                if (scope.value) {
	                    scope.v.required = false;
	                }
	                var input = element.find('input')[0];
	                var attributes = field.attributes();
	                for (var name in attributes) {
	                    input.setAttribute(name, attributes[name]);
	                }
	
	                scope.fileSelected = function (selectedFiles) {
	                    if (!selectedFiles || !selectedFiles.length) {
	                        return;
	                    }
	
	                    var uploadParams;
	
	                    scope.files = {};
	                    for (var file in selectedFiles) {
	                        uploadParams = angular.copy(scope.field().uploadInformation());
	                        uploadParams.file = selectedFiles[file];
	                        Upload.upload(uploadParams).progress(function (evt) {
	                            scope.files[evt.config.file.name] = {
	                                "name": evt.config.file.name,
	                                "progress": Math.min(100, parseInt(100.0 * evt.loaded / evt.total))
	                            };
	                        }).success(function (data, status, headers, config) {
	                            scope.files[config.file.name] = {
	                                "name": scope.apifilename ? data[scope.apifilename] : config.file.name,
	                                "progress": 0
	                            };
	                            if (scope.apifilename) {
	                                var apiNames = Object.keys(scope.files).map(function (fileindex) {
	                                    return scope.files[fileindex].name;
	                                });
	                                scope.value = apiNames.join(',');
	                            } else {
	                                scope.value = Object.keys(scope.files).join(',');
	                            }
	                        }).error(function (data, status, headers, config) {
	                            delete scope.files[config.file.name];
	
	                            scope.value = Object.keys(scope.files).join(',');
	                        });
	                    }
	                };
	
	                scope.selectFile = function () {
	                    input.click();
	                };
	            }
	        },
	        template: '<div class="row">\n    <div class="col-md-2">\n        <a class="btn btn-default" ng-click="selectFile()">\n            <span translate="BROWSE"></span>\n        </a>\n    </div>\n    <div class="col-md-10">\n        <div class="row" ng-repeat="file in files track by $index">\n            <div class="col-md-3" style="padding-top: 6px;">\n                <div class="progress" style="margin-bottom: 0;" ng-if="file.progress">\n                    <div class="progress-bar" role="progressbar" aria-valuenow="{{ file.progress }}" aria-valuemin="0" aria-valuemax="100" style="width: {{ file.progress }}%;">\n                        <span class="sr-only" translate="N_COMPLETE" translate-values="{ progress: file.progress }"></span>\n                    </div>\n                </div>\n            </div>\n            <div class="col-md-9" style="padding-top: 6px;"><small><em>{{ file.name }}</em></small></div>\n        </div>\n    </div>\n</div>\n<input type="file" ngf-multiple="multiple" accept="{{ accept }}" ngf-select="fileSelected($files)"\n       id="{{ name }}" name="{{ name }}" ng-required="v.required" style="display:none" />'
	    };
	}
	
	maFileField.$inject = ['Upload'];
	module.exports = exports['default'];
	//# sourceMappingURL=maFileField.js.map

/***/ },
/* 286 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maInputField;
	/**
	 * Generic edition field
	 *
	 * @example <ma-input-field type="text" field="field" value="value"></ma-input-field>
	 */
	function maInputField() {
	    return {
	        scope: {
	            'type': '@',
	            'step': '@?',
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.v = field.validation();
	            var input = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                if (name === 'step') {
	                    // allow to use `step` attribute instead of `scope.step`
	                    scope.step = attributes[name];
	                    continue;
	                }
	
	                input.setAttribute(name, attributes[name]);
	            }
	        },
	        template: '<input type="{{ type || \'text\' }}" ng-attr-step="{{ step }}" ng-model="value"\n    id="{{ name }}" name="{{ name }}" class="form-control"\n    ng-required="v.required" ng-minlength="v.minlength" ng-maxlength="v.maxlength" ng-pattern="v.pattern" />'
	    };
	}
	
	maInputField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maInputField.js.map

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maJsonField;
	var codemirror = __webpack_require__(3);
	
	global.jsonlint = __webpack_require__(243);
	
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(233);
	__webpack_require__(232);
	__webpack_require__(234);
	__webpack_require__(235);
	
	codemirror.defineOption("matchBrackets", true);
	codemirror.defineOption("autoCloseBrackets", true);
	codemirror.defineOption("lineWrapping", true);
	codemirror.defineOption("tabSize", 2);
	codemirror.defineOption("mode", "application/json");
	codemirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
	codemirror.defineOption("lint", true);
	codemirror.defineOption("styleActiveLine", true);
	
	global.CodeMirror = codemirror;
	
	/**
	 * Edition field for a JSON string in a textarea.
	 *
	 * @example <ma-json-field field="field" value="value"></ma-json-field>
	 */
	function maJsonField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.v = field.validation();
	            scope.jsonValue = scope.value === null ? '' : angular.toJson(scope.value, true);
	            var input = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                input.setAttribute(name, attributes[name]);
	            }
	            scope.$watch('jsonValue', function (jsonValue) {
	                if (jsonValue == '' || typeof jsonValue === 'undefined') {
	                    scope.value = null;
	
	                    return;
	                }
	                try {
	                    var value = angular.fromJson(jsonValue);
	                    scope.value = value;
	                } catch (e) {
	                    // incorrect JSON, do not convert back to value
	                }
	            });
	        },
	        template: '<textarea ui-codemirror ng-model="jsonValue" id="{{ name }}" name="{{ name }}" ng-required="v.required" ma-json-validator>' + '</textarea>'
	    };
	}
	
	maJsonField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maJsonField.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceField;
	function maReferenceField(ReferenceRefresher) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?'
	        },
	        restrict: 'E',
	        link: function link(scope) {
	            var field = scope.field();
	            var identifierName = field.targetEntity().identifier().name();
	            scope.name = field.name();
	            scope.v = field.validation();
	
	            if (!field.remoteComplete()) {
	                // fetch choices from the datastore, populated during routing resolve
	                var initialEntries = scope.datastore().getEntries(field.targetEntity().uniqueId + '_choices');
	                if (scope.value) {
	                    var isCurrentValueInInitialEntries = initialEntries.filter(function (e) {
	                        return e.identifierValue === scope.value;
	                    }).length > 0;
	                    if (!isCurrentValueInInitialEntries) {
	                        initialEntries.unshift(scope.datastore().getEntries(field.targetEntity().uniqueId + '_values').find(function (entry) {
	                            return entry.values[identifierName] == scope.value;
	                        }));
	                    }
	                }
	                var initialChoices = initialEntries.map(function (entry) {
	                    return {
	                        value: entry.values[identifierName],
	                        label: entry.values[field.targetField().name()]
	                    };
	                });
	                scope.$broadcast('choices:update', { choices: initialChoices });
	            } else {
	                // ui-select doesn't allow to prepopulate autocomplete selects, see https://github.com/angular-ui/ui-select/issues/1197
	                // let ui-select fetch the options using the ReferenceRefresher
	                scope.refresh = function refresh(search) {
	                    return ReferenceRefresher.refresh(field, scope.value, search).then(function addCurrentChoice(results) {
	                        if (!search && scope.value) {
	                            var isCurrentValueInEntries = results.filter(function (e) {
	                                return e.value === scope.value;
	                            }).length > 0;
	                            if (!isCurrentValueInEntries) {
	                                var currentEntry = scope.datastore().getEntries(field.targetEntity().uniqueId + '_values').find(function (entry) {
	                                    return entry.values[identifierName] == scope.value;
	                                });
	                                results.unshift({
	                                    value: currentEntry.values[identifierName],
	                                    label: currentEntry.values[field.targetField().name()]
	                                });
	                            }
	                        }
	                        return results;
	                    }).then(function (formattedResults) {
	                        scope.$broadcast('choices:update', { choices: formattedResults });
	                    });
	                };
	            }
	        },
	        template: '<ma-choice-field\n                field="field()"\n                datastore="datastore()"\n                refresh="refresh($search)"\n                value="value">\n            </ma-choice-field>'
	    };
	}
	
	maReferenceField.$inject = ['ReferenceRefresher'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceField.js.map

/***/ },
/* 289 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maReferenceManyField;
	function maReferenceManyField(ReferenceRefresher) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?'
	        },
	        restrict: 'E',
	        link: function link(scope) {
	            var field = scope.field();
	            var identifierName = field.targetEntity().identifier().name();
	            scope.name = field.name();
	            scope.v = field.validation();
	            scope.choices = [];
	
	            var setInitialChoices = function setInitialChoices(initialEntries) {
	                if (scope.value && scope.value.length) {
	                    scope.value.map(function (value) {
	                        var isCurrentValueInInitialEntries = initialEntries.filter(function (e) {
	                            return e.identifierValue === value;
	                        }).length > 0;
	                        if (value && !isCurrentValueInInitialEntries) {
	                            initialEntries.push(scope.datastore().getEntries(field.targetEntity().uniqueId + '_values').filter(function (entry) {
	                                return entry.values[identifierName] == value;
	                            }).pop());
	                        }
	                    });
	                }
	                var initialChoices = initialEntries.map(function (entry) {
	                    return {
	                        value: entry.values[identifierName],
	                        label: entry.values[field.targetField().name()]
	                    };
	                });
	                scope.$broadcast('choices:update', { choices: initialChoices });
	            };
	
	            if (!field.remoteComplete()) {
	                // fetch choices from the datastore
	                var initialEntries = scope.datastore().getEntries(field.targetEntity().uniqueId + '_choices');
	                setInitialChoices(initialEntries);
	            } else {
	                var _initialEntries = [];
	                setInitialChoices(_initialEntries);
	
	                // ui-select doesn't allow to prepopulate autocomplete selects, see https://github.com/angular-ui/ui-select/issues/1197
	                // let ui-select fetch the options using the ReferenceRefresher
	                scope.refresh = function (search) {
	                    return ReferenceRefresher.refresh(field, scope.value, search).then(function (formattedResults) {
	                        scope.$broadcast('choices:update', { choices: formattedResults });
	                    });
	                };
	            }
	        },
	        template: '<ma-choices-field\n                field="field()"\n                datastore="datastore()"\n                refresh="refresh($search)"\n                value="value">\n            </ma-choices-field>'
	    };
	}
	
	maReferenceManyField.$inject = ['ReferenceRefresher'];
	module.exports = exports['default'];
	//# sourceMappingURL=maReferenceManyField.js.map

/***/ },
/* 290 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maTemplateField;
	function maTemplateField() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '&',
	            entity: '&',
	            value: '=',
	            values: '='
	        },
	        link: function link(scope) {
	            scope.field = scope.field();
	            scope.entry = scope.entry();
	            scope.entity = scope.entity();
	        },
	        template: '<span compile="field.getTemplateValue(entry)"></span>'
	    };
	}
	
	maTemplateField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maTemplateField.js.map

/***/ },
/* 291 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maTextField;
	/**
	 * Edition field for a multiline string - a textarea.
	 *
	 * @example <ma-text-field field="field" value="value"></ma-text-field>
	 */
	function maTextField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	            scope.v = field.validation();
	            var input = element.children()[0];
	            var attributes = field.attributes();
	            for (var name in attributes) {
	                input.setAttribute(name, attributes[name]);
	            }
	        },
	        template: '<textarea ng-model="value" id="{{ name }}" name="{{ name }}" class="form-control"\n    ng-required="v.required" ng-minlength="v.minlength" ng-maxlength="v.maxlength" ng-pattern="v.pattern">\n</textarea>'
	    };
	}
	
	maTextField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maTextField.js.map

/***/ },
/* 292 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maWysiwygField;
	/**
	 * Edition field for a multiline HTML string - a rich text editor.
	 *
	 * @example <ma-wysiwyg-field field="field" value="value"></ma-wysiwyg-field>
	 */
	function maWysiwygField() {
	    return {
	        scope: {
	            'field': '&',
	            'value': '='
	        },
	        restrict: 'E',
	        link: function link(scope, element) {
	            var field = scope.field();
	            scope.name = field.name();
	        },
	        template: '<div text-angular ta-unsafe-sanitizer="{{ !field.sanitize() }}" ng-model="value" id="{{ name }}" name="{{ name }}" ' + 'ta-text-editor-class="border-around" ta-html-editor-class="border-around">' + '</div>'
	    };
	}
	
	maWysiwygField.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maWysiwygField.js.map

/***/ },
/* 293 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = uiSelectRequired;
	/**
	 * Directive created to fix a bug with ui-select and multiple required values.
	 * @see https://github.com/angular-ui/ui-select/issues/258
	 */
	function uiSelectRequired() {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function link(scope, elm, attrs, ctrl) {
	            ctrl.$validators.uiSelectRequired = function (modelValue, viewValue) {
	                var determineVal;
	                if (angular.isArray(modelValue)) {
	                    determineVal = modelValue;
	                } else if (angular.isArray(viewValue)) {
	                    determineVal = viewValue;
	                } else {
	                    return false;
	                }
	
	                return determineVal.length > 0;
	            };
	        }
	    };
	}
	
	uiSelectRequired.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=uiSelectRequired.js.map

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-boolean-column value="::value"></ma-boolean-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choice-field field="::field" value="value" choices="::field.filterChoices()"></ma-choice-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="row">\n        <ma-choice-field class="col-sm-4 col-md-3" ng-if="!field.validation().required" field="::field" value="$parent.value"></ma-choice-field>\n        <ma-checkbox-field class="col-sm-4 col-md-3" ng-if="!!field.validation().required" field="::field" value="$parent.value"></ma-checkbox-field>\n    </div>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=BooleanFieldView.js.map

/***/ },
/* 295 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::field.getLabelForChoice(value, entry)"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choice-field field="::field" value="value"></ma-choice-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-choice-field field="::field" entry="entry" value="value"></ma-choice-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ChoiceFieldView.js.map

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-choices-column values="::value"></ma-choices-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choices-field field="::field" value="value"></ma-choices-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-choices-field field="::field" entry="::entry" value="value"></ma-choices-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ChoicesFieldView.js.map

/***/ },
/* 297 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-date-column field="::field" value="::value"></ma-date-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="date_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=DateFieldView.js.map

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-date-column field="::field" value="::value"></ma-date-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=DateTimeFieldView.js.map

/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="email" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=EmailFieldView.js.map

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-embedded-list-column field="::field" value="::value" datastore="::datastore"></ma-embedded-list-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display referenced_list field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display referenced_list field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-embedded-list-field field="::field" value="value" datastore="::datastore"></ma-embedded-list-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=EmbeddedListFieldView.js.map

/***/ },
/* 301 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var FieldViewConfiguration = function () {
	    function FieldViewConfiguration() {
	        _classCallCheck(this, FieldViewConfiguration);
	
	        this.fieldViews = {};
	    }
	
	    _createClass(FieldViewConfiguration, [{
	        key: "registerFieldView",
	        value: function registerFieldView(type, FieldView) {
	            this.fieldViews[type] = FieldView;
	        }
	    }, {
	        key: "$get",
	        value: function $get() {
	            return this.fieldViews;
	        }
	    }]);
	
	    return FieldViewConfiguration;
	}();
	
	exports.default = FieldViewConfiguration;
	
	FieldViewConfiguration.$inject = [];
	module.exports = exports["default"];
	//# sourceMappingURL=FieldViewConfiguration.js.map

/***/ },
/* 302 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return 'error: cannot display file field as readable';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display file field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display file field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-file-field field="::field" value="value"></ma-file-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=FileFieldView.js.map

/***/ },
/* 303 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::value"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=FloatFieldView.js.map

/***/ },
/* 304 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-json-column value="::value"></ma-json-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display a json field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-json-field field="::field" value="value"></ma-json-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=JsonFieldView.js.map

/***/ },
/* 305 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::value"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="number" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=NumberFieldView.js.map

/***/ },
/* 306 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return 'error: cannot display password field as readable';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display password field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display password field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="password" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=PasswordFieldView.js.map

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-reference-column field="::field" value="::value" datastore="::datastore"></ma-reference-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<ma-reference-link-column entry="::entry" field="::field" value="::value" datastore="::datastore"></ma-reference-link-column>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceFieldView.js.map

/***/ },
/* 308 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-choices-column values="::entry.listValues[field.name()]"></ma-choices-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<ma-reference-many-link-column ids="::value" values="::entry.listValues[field.name()]" field="::field"></ma-reference-many-link-column>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-reference-many-field field="::field" value="value" datastore="::datastore"></ma-reference-many-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-reference-many-field field="::field" value="value" datastore="::datastore"></ma-reference-many-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceManyFieldView.js.map

/***/ },
/* 309 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-referenced-list-column field="::field" datastore="::datastore"></ma-referenced-list-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display referenced_list field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display referenced_list field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-referenced-list-column field="::field" datastore="::datastore"></ma-referenced-list-column>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=ReferencedListFieldView.js.map

/***/ },
/* 310 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=StringFieldView.js.map

/***/ },
/* 311 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-template-column entry="::entry" field="::field" entity="::entity"></ma-template-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-template-field field="::field" value="value" values="values" filters="filters"></ma-template-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-template-field field="::field" value="value" entry="entry" entity="::entity"></ma-template-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=TemplateFieldView.js.map

/***/ },
/* 312 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-text-field field="::field" value="value"></ma-text-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=TextFieldView.js.map

/***/ },
/* 313 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-wysiwyg-column field="::field" value="::value"></ma-wysiwyg-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-wysiwyg-field field="::field" value="value"></ma-wysiwyg-field>';
	    }
	};
	module.exports = exports['default'];
	//# sourceMappingURL=WysiwygFieldView.js.map

/***/ },
/* 314 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFilter;
	function maFilter(FieldViewConfiguration, $compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '=',
	            datastore: '&',
	            values: '=',
	            value: '='
	        },
	        link: function link(scope, element) {
	            scope.datastore = scope.datastore();
	            element.append(scope.field.getTemplateValue(scope.values) || FieldViewConfiguration[scope.field.type()].getFilterWidget());
	            $compile(element.contents())(scope);
	        }
	    };
	}
	
	maFilter.$inject = ['FieldViewConfiguration', '$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maFilter.js.map

/***/ },
/* 315 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maFilterForm;
	function maFilterForm() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '=',
	            datastore: '&',
	            values: '=',
	            removeFilter: '&'
	        },
	        link: function link(scope) {
	            scope.datastore = scope.datastore();
	            scope.removeFilter = scope.removeFilter();
	            scope.shouldFilter = function () {
	                return Object.keys(scope.filters).length;
	            };
	        },
	        template: '<div class="row">\n    <form class="filters col-md-offset-6 col-md-6 form-horizontal" ng-if="shouldFilter()">\n        <div class="filter {{ field.name() }} form-group input-{{ field.type() }}" ng-repeat="field in filters track by field.name()">\n            <div class="col-sm-1 col-xs-1 remove_filter">\n                <a ng-if="!field.pinned()" ng-click="removeFilter(field)"><span class="glyphicon glyphicon-remove"></span></a>\n            </div>\n            <label for="{{ field.name() }}" class="col-sm-4 col-xs-11 control-label">\n                {{ field.label() | translate }}<span ng-if="field.validation().required">&nbsp;*</span>&nbsp;\n            </label>\n            <div class="col-sm-7" ng-switch="field.type()" ng-class="field.getCssClasses(entry)">\n                <ma-filter field="::field" value="values[field.name()]" values="values" datastore="datastore"></ma-filter>\n            </div>\n        </div>\n    </form>\n</div>'
	    };
	}
	
	maFilterForm.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maFilterForm.js.map

/***/ },
/* 316 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var FormController = function () {
	    function FormController($scope, $state, $injector, $translate, previousState, WriteQueries, Configuration, progression, notification, view, dataStore, HttpErrorService) {
	        _classCallCheck(this, FormController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$injector = $injector;
	        this.$translate = $translate;
	        this.previousState = previousState;
	        this.WriteQueries = WriteQueries;
	        this.dataStore = dataStore;
	        this.progression = progression;
	        this.notification = notification;
	        this.title = view.title();
	        this.description = view.description();
	        this.actions = view.actions();
	        this.fields = view.fields();
	        this.config = Configuration();
	        this.view = view;
	        this.entity = this.view.getEntity();
	        this.$scope.entry = dataStore.getFirstEntry(this.entity.uniqueId);
	        this.$scope.view = view;
	        this.$scope.entity = this.entity;
	        this.HttpErrorService = HttpErrorService;
	
	        // in case of entity identifier being modified
	        this.originEntityId = this.$scope.entry.values[this.entity.identifier().name()];
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(FormController, [{
	        key: 'validateEntry',
	        value: function validateEntry() {
	            var _this = this;
	
	            if (!this.form.$valid) {
	                this.$translate('INVALID_FORM').then(function (text) {
	                    return _this.notification.log(text, { addnCls: 'humane-flatty-error' });
	                });
	                return false;
	            }
	
	            try {
	                this.view.validate(this.$scope.entry);
	            } catch (error) {
	                this.notification.log(error, { addnCls: 'humane-flatty-error' });
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'submitCreation',
	        value: function submitCreation($event) {
	            var _this2 = this;
	
	            $event.preventDefault();
	            if (!this.validateEntry()) {
	                return Promise.reject();
	            }
	            var entity = this.entity,
	                view = this.view,
	                $state = this.$state,
	                progression = this.progression,
	                notification = this.notification,
	                $translate = this.$translate;
	
	            var route = entity.showView().enabled ? 'show' : 'list';
	            var restEntry = this.$scope.entry.transformToRest(view.fields());
	            var fromState = $state.current.name;
	            var fromParams = $state.current.params;
	            var toState = $state.get(route);
	            var entry = null;
	            var toParams = function toParams() {
	                return {
	                    entity: entity.name(),
	                    id: entry ? entry.identifierValue : null
	                };
	            };
	            progression.start();
	
	            return new Promise(function (resolve, reject) {
	                return _this2.WriteQueries.createOne(view, restEntry).then(function (rawEntry) {
	                    entry = view.mapEntry(rawEntry);
	                    return entry;
	                }).then(function (entry) {
	                    return view.onSubmitSuccess() && _this2.$injector.invoke(view.onSubmitSuccess(), view, { $event: $event, entity: entity, entry: entry, route: route, controller: _this2, form: _this2.form, progression: progression, notification: notification });
	                }).then(function (customHandlerReturnValue) {
	                    return customHandlerReturnValue === false ? new Promise(function (innerResolve) {
	                        return innerResolve();
	                    }) : $state.go(toState, toParams());
	                }).then(function () {
	                    return progression.done();
	                }).then(function () {
	                    return $translate('CREATION_SUCCESS');
	                }).then(function (text) {
	                    return notification.log(text, { addnCls: 'humane-flatty-success' });
	                }).then(function () {
	                    resolve();
	                }).catch(function (error) {
	                    var customHandlerReturnValue = view.onSubmitError() && _this2.$injector.invoke(view.onSubmitError(), view, { $event: $event, error: error, entity: entity, entry: entry, route: route, controller: _this2, form: _this2.form, progression: progression, notification: notification });
	                    if (customHandlerReturnValue === false) return;
	                    progression.done();
	                    _this2.HttpErrorService.handleError($event, toState, toParams(), fromState, fromParams, error);
	                    reject();
	                });
	            });
	        }
	    }, {
	        key: 'submitEdition',
	        value: function submitEdition($event) {
	            var _this3 = this;
	
	            $event.preventDefault();
	            if (!this.validateEntry()) {
	                return;
	            }
	            var view = this.view,
	                $state = this.$state,
	                previousState = this.previousState,
	                progression = this.progression,
	                notification = this.notification,
	                $translate = this.$translate;
	
	            var restEntry = this.$scope.entry.transformToRest(view.fields());
	            var fromState = $state.current.name;
	            var fromParams = $state.current.params;
	            var toState = previousState.name;
	            var entry = null;
	            var toParams = previousState.params;
	            progression.start();
	            return new Promise(function (resolve, reject) {
	                return _this3.WriteQueries.updateOne(view, restEntry, _this3.originEntityId).then(function (rawEntry) {
	                    entry = view.mapEntry(rawEntry);
	                    return entry;
	                }).then(function (entry) {
	                    return view.onSubmitSuccess() && _this3.$injector.invoke(view.onSubmitSuccess(), view, { $event: $event, entity: _this3.entity, entry: entry, controller: _this3, form: _this3.form, progression: progression, notification: notification });
	                }).then(function (customHandlerReturnValue) {
	                    if (customHandlerReturnValue === false) return;
	                    $state.go(toState, toParams).then(function () {
	                        return progression.done();
	                    }).then(function () {
	                        return $translate('EDITION_SUCCESS');
	                    }).then(function (text) {
	                        return notification.log(text, { addnCls: 'humane-flatty-success' });
	                    });
	                }).then(function () {
	                    resolve();
	                }).catch(function (error) {
	                    var customHandlerReturnValue = view.onSubmitError() && _this3.$injector.invoke(view.onSubmitError(), view, { $event: $event, error: error, entity: _this3.entity, entry: entry, controller: _this3, form: _this3.form, progression: progression, notification: notification });
	                    if (customHandlerReturnValue === false) return;
	                    progression.done();
	                    _this3.HttpErrorService.handleError($event, toState, toParams, fromState, fromParams, error);
	                    reject();
	                });
	            });
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$state = undefined;
	            this.$injector = undefined;
	            this.$translate = undefined;
	            this.previousState = undefined;
	            this.WriteQueries = undefined;
	            this.dataStore = undefined;
	            this.view = undefined;
	            this.entity = undefined;
	        }
	    }]);
	
	    return FormController;
	}();
	
	exports.default = FormController;
	
	FormController.$inject = ['$scope', '$state', '$injector', '$translate', 'previousState', 'WriteQueries', 'NgAdminConfiguration', 'progression', 'notification', 'view', 'dataStore', 'HttpErrorService'];
	module.exports = exports['default'];
	//# sourceMappingURL=FormController.js.map

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _Entry = __webpack_require__(6);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var ListController = function () {
	    function ListController($scope, $stateParams, $location, $anchorScroll, ReadQueries, progression, view, dataStore, totalItems) {
	        _classCallCheck(this, ListController);
	
	        this.$scope = $scope;
	        this.$stateParams = $stateParams;
	        this.$location = $location;
	        this.$anchorScroll = $anchorScroll;
	        this.ReadQueries = ReadQueries;
	        this.progression = progression;
	        this.view = view;
	        this.entity = view.getEntity();
	        this.loadingPage = false;
	        this.search = $stateParams.search;
	        this.dataStore = dataStore;
	        this.fields = view.fields();
	        this.listActions = view.listActions();
	        this.totalItems = totalItems;
	        this.page = $stateParams.page || 1;
	        this.infinitePagination = this.view.infinitePagination();
	        this.entryCssClasses = this.view.getEntryCssClasses.bind(this.view);
	        this.nextPageCallback = this.nextPage.bind(this);
	        this.setPageCallback = this.setPage.bind(this);
	        this.sortField = this.$stateParams.sortField || this.view.getSortFieldName();
	        this.sortDir = this.$stateParams.sortDir || this.view.sortDir();
	        this.queryPromises = [];
	
	        if ($scope.selectionUpdater) {
	            $scope.selection = $scope.selection || [];
	            $scope.$watch('selection', $scope.selectionUpdater);
	        } else {
	            $scope.selection = null;
	        }
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(ListController, [{
	        key: 'nextPage',
	        value: function nextPage(page) {
	            var _this = this;
	
	            if (this.loadingPage) {
	                return;
	            }
	
	            var view = this.view,
	                dataStore = this.dataStore;
	
	            this.progression.start();
	
	            var references = view.getReferences();
	            var data = void 0;
	
	            var queryPromise = this.ReadQueries.getAll(view, page, this.search, this.sortField, this.sortDir).then(function (response) {
	                data = response.data;
	                return _this.ReadQueries.getReferenceData(view.fields(), data);
	            }).then(function (referenceData) {
	                _this.progression.done();
	
	                for (var name in referenceData) {
	                    _Entry2.default.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                    });
	                }
	            });
	            this.queryPromises.push(queryPromise);
	            // make sure all preceding promises complete before loading data into store
	            Promise.all(this.queryPromises).then(function () {
	                view.mapEntries(data).map(function (entry) {
	                    dataStore.fillReferencesValuesFromEntry(entry, references, true);
	                    dataStore.addEntry(_this.entity.uniqueId, entry);
	                });
	
	                _this.loadingPage = false;
	            });
	        }
	    }, {
	        key: 'setPage',
	        value: function setPage(number) {
	            this.$location.search('page', number);
	            this.$anchorScroll(0);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$stateParams = undefined;
	            this.$location = undefined;
	            this.$anchorScroll = undefined;
	            this.dataStore = undefined;
	        }
	    }]);
	
	    return ListController;
	}();
	
	exports.default = ListController;
	
	ListController.$inject = ['$scope', '$stateParams', '$location', '$anchorScroll', 'ReadQueries', 'progression', 'view', 'dataStore', 'totalItems'];
	module.exports = exports['default'];
	//# sourceMappingURL=ListController.js.map

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _defineProperty(obj, key, value) {
	    if (key in obj) {
	        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	    } else {
	        obj[key] = value;
	    }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var debounce = __webpack_require__(244);
	
	var ListLayoutController = function () {
	    function ListLayoutController($scope, $stateParams, $state, $location, $timeout, view, dataStore) {
	        var _this = this;
	
	        _classCallCheck(this, ListLayoutController);
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$timeout = $timeout;
	        this.view = view;
	        this.dataStore = dataStore;
	        this.entity = view.getEntity();
	        this.actions = view.actions();
	        this.batchActions = view.batchActions();
	        this.loadingPage = false;
	        this.filters = view.filters();
	        this.search = ListLayoutController.getCurrentSearchParam($location, this.filters);
	        this.path = $location.path();
	        // since search isn't a $stateParam of the listLayout state,
	        // the controller doesn't change when the search changes
	        // so we must update filter values manually when the location changes
	        $scope.$watch(function () {
	            return $location.search() && $location.search().search;
	        }, function (newval, oldval) {
	            if (newval === oldval) {
	                return;
	            }
	            if ($location.path() !== _this.path) {
	                return; // already transitioned to another page
	            }
	            _this.search = ListLayoutController.getCurrentSearchParam($location, _this.filters);
	            _this.enabledFilters = _this.getEnabledFilters();
	        });
	        // apply filters when filter values change
	        $scope.$watch(function () {
	            return _this.search;
	        }, debounce(function (newValues, oldValues) {
	            if (newValues != oldValues) {
	                _this.updateFilters();
	            }
	        }, 500), true);
	        this.filters = view.filters();
	        this.enabledFilters = this.getEnabledFilters();
	        this.hasFilters = Object.keys(this.filters).length > 0;
	        this.focusedFilterId = null;
	        this.enableFilter = this.enableFilter.bind(this);
	        this.removeFilter = this.removeFilter.bind(this);
	        if (this.batchActions.length) {
	            // required in scope to communicate with listView
	            $scope.selectionUpdater = function (selection) {
	                return $scope.selection = selection;
	            };
	            $scope.selection = [];
	        }
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(ListLayoutController, [{
	        key: 'enableFilter',
	        value: function enableFilter(filter) {
	            var _this2 = this;
	
	            var defaultValue = filter.defaultValue();
	            if (defaultValue !== null) {
	                this.search[filter.name()] = defaultValue;
	            }
	            this.enabledFilters.push(filter);
	            this.focusedFilterId = filter.name();
	            this.$timeout(function () {
	                var el = window.document.getElementById(_this2.focusedFilterId);
	                if (el && el.focus) {
	                    el.focus();
	                }
	            }, 200, false);
	        }
	    }, {
	        key: 'getEnabledFilters',
	        value: function getEnabledFilters() {
	            var _this3 = this;
	
	            return this.filters.filter(function (filter) {
	                if (filter.pinned()) {
	                    return true;
	                }
	                return _this3.search && filter.name() in _this3.search;
	            });
	        }
	    }, {
	        key: 'updateFilters',
	        value: function updateFilters() {
	            var values = {},
	                filters = this.enabledFilters,
	                fieldName,
	                field,
	                i;
	            for (i in filters) {
	                field = filters[i];
	                fieldName = field.name();
	                if (this.search[fieldName] === '') {
	                    delete this.search[fieldName];
	                    continue;
	                }
	
	                if (field.type() === 'boolean' && fieldName in this.search || // for boolean false is the same as null
	                field.type() !== 'boolean' && this.search[fieldName] !== null) {
	                    values[fieldName] = field.getTransformedValue(this.search[fieldName]);
	                }
	            }
	            this.$stateParams.search = values;
	            this.$stateParams.page = 1;
	            this.$state.go('list', this.$stateParams);
	        }
	    }, {
	        key: 'removeFilter',
	        value: function removeFilter(filter) {
	            delete this.search[filter.name()];
	            this.enabledFilters = this.enabledFilters.filter(function (f) {
	                return f !== filter;
	            });
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$state = undefined;
	            this.$stateParams = undefined;
	            this.$timeout = undefined;
	            this.dataStore = undefined;
	        }
	    }], [{
	        key: 'getCurrentSearchParam',
	        value: function getCurrentSearchParam(location, filters) {
	            var baseSearch = location.search().search ? JSON.parse(location.search().search) : {};
	
	            return filters.reduce(function (search, filter) {
	                if (typeof search[filter.name()] !== 'undefined') {
	                    return _extends({}, search, _defineProperty({}, filter.name(), filter.getMappedValue(search[filter.name()])));
	                }
	                if (filter.pinned() && !search[filter.name()] && filter.defaultValue()) {
	                    return _extends({}, search, _defineProperty({}, filter.name(), filter.getMappedValue(filter.defaultValue())));
	                }
	                return search;
	            }, baseSearch);
	        }
	    }]);
	
	    return ListLayoutController;
	}();
	
	exports.default = ListLayoutController;
	
	ListLayoutController.$inject = ['$scope', '$stateParams', '$state', '$location', '$timeout', 'view', 'dataStore'];
	module.exports = exports['default'];
	//# sourceMappingURL=ListLayoutController.js.map

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagrid;
	
	var _maDatagridController = __webpack_require__(320);
	
	var _maDatagridController2 = _interopRequireDefault(_maDatagridController);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maDatagrid() {
	    return {
	        restrict: 'E',
	        scope: {
	            name: '@',
	            entries: '=',
	            selection: '=',
	            fields: '&',
	            listActions: '&',
	            entity: '&',
	            entryCssClasses: '&?',
	            datastore: '&',
	            sortField: '&',
	            sortDir: '&',
	            sort: '&'
	        },
	        controllerAs: 'datagrid',
	        controller: _maDatagridController2.default,
	        template: '<table class="grid table table-condensed table-hover table-striped">\n    <thead>\n        <tr>\n            <th ng-if="selection">\n                <ma-datagrid-multi-selector toggle-select-all="toggleSelectAll()" selection="selection" entries="entries"/>\n            </th>\n            <th ng-repeat="field in fields() track by $index" ng-class="field.getCssClasses()" class="ng-admin-column-{{ ::field.name() }} ng-admin-type-{{ ::field.type() }}">\n                <a ng-if="field.sortable()" ng-click="datagrid.sortCallback(field)">\n                    <span class="glyphicon {{ sortDir() === \'DESC\' ? \'glyphicon-chevron-up\': \'glyphicon-chevron-down\' }}" ng-if="datagrid.isSorting(field)"></span>\n                    {{ field.label() | translate }}\n                </a>\n                <span ng-if="!field.sortable()">\n                    {{ field.label() | translate }}\n                </span>\n            </th>\n            <th ng-if="datagrid.shouldDisplayActions" class="ng-admin-column-actions" translate="ACTIONS"></th>\n        </tr>\n    </thead>\n\n    <tbody>\n        <tr ng-repeat="entry in entries track by entry.identifierValue" ng-class="getEntryCssClasses(entry)">\n            <td ng-if="selection">\n                <ma-datagrid-item-selector toggle-select="toggleSelect(entry)" selection="selection" entry="entry"/>\n            </td>\n            <td ng-repeat="field in fields() track by $index" ng-class="field.getCssClasses(entry)" class="ng-admin-column-{{ ::field.name() }} ng-admin-type-{{ ::field.type() }}">\n                <ma-column field="::field" entry="::entry" entity="::entity" datastore="datagrid.datastore"></ma-column>\n            </td>\n            <td ng-if="datagrid.shouldDisplayActions" class="ng-admin-column-actions">\n                <ma-list-actions entry="::entry" entity="::entity" buttons="listActions()"></ma-list-actions>\n            </td>\n        </tr>\n    </tbody>\n</table>'
	    };
	}
	
	maDatagrid.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagrid.js.map

/***/ },
/* 320 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var DatagridController = function () {
	    function DatagridController($scope, $location, $stateParams, $anchorScroll) {
	        _classCallCheck(this, DatagridController);
	
	        $scope.entity = $scope.entity();
	        this.$scope = $scope;
	        this.$location = $location;
	        this.$anchorScroll = $anchorScroll;
	        this.datastore = this.$scope.datastore();
	        this.filters = {};
	        this.shouldDisplayActions = this.$scope.listActions() && this.$scope.listActions().length > 0;
	        $scope.getEntryCssClasses = this.getEntryCssClasses.bind(this);
	        $scope.toggleSelect = this.toggleSelect.bind(this);
	        $scope.toggleSelectAll = this.toggleSelectAll.bind(this);
	        this.sortField = $scope.sortField();
	        this.sortDir = $scope.sortDir();
	        this.sortCallback = $scope.sort() ? $scope.sort() : this.sort.bind(this);
	    }
	
	    /**
	     * Return true if a column is being sorted
	     *
	     * @param {Field} field
	     *
	     * @returns {Boolean}
	     */
	
	    _createClass(DatagridController, [{
	        key: 'isSorting',
	        value: function isSorting(field) {
	            return this.$scope.sortField() === this.getSortName(field);
	        }
	
	        /**
	         * Return 'even'|'odd' based on the index parameter
	         *
	         * @param {Number} index
	         * @returns {string}
	         */
	
	    }, {
	        key: 'itemClass',
	        value: function itemClass(index) {
	            return index % 2 === 0 ? 'even' : 'odd';
	        }
	
	        /**
	         *
	         * @param {Field} field
	         */
	
	    }, {
	        key: 'sort',
	        value: function sort(field) {
	            var dir = 'ASC',
	                fieldName = this.getSortName(field);
	
	            if (this.sortField === fieldName) {
	                dir = this.sortDir === 'ASC' ? 'DESC' : 'ASC';
	            }
	
	            this.$location.search('sortField', fieldName);
	            this.$location.search('sortDir', dir);
	        }
	
	        /**
	         * Return fieldName like (view.fieldName) to sort
	         *
	         * @param {Field} field
	         *
	         * @returns {String}
	         */
	
	    }, {
	        key: 'getSortName',
	        value: function getSortName(field) {
	            return this.$scope.name ? this.$scope.name + '.' + field.name() : field.name();
	        }
	    }, {
	        key: 'getEntryCssClasses',
	        value: function getEntryCssClasses(entry) {
	            var entryCssClasses = this.$scope.entryCssClasses;
	            if (typeof entryCssClasses !== 'function') {
	                return;
	            }
	            var getEntryCssClasses = entryCssClasses();
	            if (typeof getEntryCssClasses !== 'function') {
	                return;
	            }
	            return getEntryCssClasses(entry.values);
	        }
	    }, {
	        key: 'toggleSelect',
	        value: function toggleSelect(entry) {
	            var selection = this.$scope.selection.slice();
	
	            var index = selection.indexOf(entry);
	
	            if (index === -1) {
	                this.$scope.selection = selection.concat(entry);
	                return;
	            }
	            selection.splice(index, 1);
	            this.$scope.selection = selection;
	        }
	    }, {
	        key: 'toggleSelectAll',
	        value: function toggleSelectAll() {
	
	            if (this.$scope.selection.length < this.$scope.entries.length) {
	                this.$scope.selection = this.$scope.entries;
	                return;
	            }
	
	            this.$scope.selection = [];
	        }
	    }]);
	
	    return DatagridController;
	}();
	
	exports.default = DatagridController;
	
	DatagridController.$inject = ['$scope', '$location', '$stateParams', '$anchorScroll'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridController.js.map

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagridInfinitePagination;
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var isScrollingDown = function isScrollingDown(wheelEvent) {
	    if (!wheelEvent) return true;
	
	    return wheelEvent.deltaY > 0;
	};
	
	function maDatagridInfinitePagination($window, $document) {
	    var offset = 100;
	    var body = $document[0].body;
	
	    return {
	        restrict: 'E',
	        scope: {
	            perPage: '@',
	            totalItems: '@',
	            nextPage: '&'
	        },
	        link: function link(scope) {
	            scope.processing = false;
	            var perPage = parseInt(scope.perPage, 10) || 1;
	            var totalItems = parseInt(scope.totalItems, 10);
	            var nbPages = Math.ceil(totalItems / perPage) || 1;
	            var loadedPages = [];
	            var page = 1;
	            var interval = void 0;
	
	            var handler = function handler(wheelEvent) {
	                if (!isScrollingDown(wheelEvent) || scope.processing || !!interval) {
	                    return;
	                }
	
	                scope.processing = true;
	
	                interval = setInterval(function () {
	                    if (body.offsetHeight - $window.innerHeight - $window.scrollY < offset) {
	                        if (page >= nbPages) {
	                            return;
	                        }
	
	                        page++;
	
	                        if (page in loadedPages) {
	                            return;
	                        }
	
	                        loadedPages.push(page);
	                        scope.nextPage()(page);
	                    } else {
	                        scope.processing = false;
	
	                        if (interval) {
	                            clearInterval(interval);
	                            interval = null;
	                        }
	                    }
	                }, 100);
	            };
	
	            // Trigger the scroll at least once
	            // This way, it loads at least one screen of data to enable further scrolling
	            // @see https://github.com/marmelab/ng-admin/issues/681
	            handler();
	
	            $window.addEventListener('wheel', handler);
	            scope.$on('$destroy', function () {
	                $window.removeEventListener('wheel', handler);
	
	                if (interval) {
	                    clearInterval(interval);
	                }
	            });
	        }
	    };
	}
	
	maDatagridInfinitePagination.$inject = ['$window', '$document'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridInfinitePagination.js.map

/***/ },
/* 322 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagridItemSelector;
	function maDatagridItemSelector() {
	    return {
	        restrict: 'E',
	        scope: {
	            entry: '=',
	            selection: '=',
	            toggleSelect: '&'
	        },
	        template: '<input type="checkbox" ng-click="toggle(entry)" ng-checked="isInSelection()"/>',
	        link: function link(scope) {
	            scope.toggle = function (entry) {
	                return scope.toggleSelect({ entry: entry });
	            };
	            var e = scope.entry;
	            scope.isInSelection = function () {
	                return scope.selection.filter(function (s) {
	                    return s._entityName == e._entityName && s._identifierValue == e._identifierValue;
	                }).length > 0;
	            };
	        }
	    };
	}
	
	maDatagridItemSelector.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridItemSelector.js.map

/***/ },
/* 323 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagridMultiSelector;
	function maDatagridMultiSelector() {
	    return {
	        restrict: 'E',
	        scope: {
	            entries: '=',
	            selection: '=',
	            toggleSelectAll: '&'
	        },
	        template: '<input type="checkbox" ng-click="toggleSelectAll()" ng-checked="selection.length == entries.length" />',
	        link: function link(scope, element) {
	            scope.$watch('selection', function (selection) {
	                element.children()[0].indeterminate = selection.length > 0 && selection.length != scope.entries.length;
	            });
	            scope.$watch('entries', function (entries) {
	                element.children()[0].indeterminate = scope.selection.length > 0 && scope.selection.length != entries.length;
	            });
	        }
	    };
	}
	
	maDatagridMultiSelector.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridMultiSelector.js.map

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDatagridPagination;
	
	var _maDatagridPagination = __webpack_require__(426);
	
	var _maDatagridPagination2 = _interopRequireDefault(_maDatagridPagination);
	
	var _maDatagridPaginationController = __webpack_require__(325);
	
	var _maDatagridPaginationController2 = _interopRequireDefault(_maDatagridPaginationController);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maDatagridPagination() {
	    return {
	        restrict: 'E',
	        scope: {
	            page: '@',
	            perPage: '@',
	            totalItems: '@',
	            setPage: '&'
	        },
	        template: _maDatagridPagination2.default,
	        controllerAs: 'paginationCtrl',
	        controller: _maDatagridPaginationController2.default
	    };
	}
	
	maDatagridPagination.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridPagination.js.map

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var DatagridPaginationController = function () {
	    function DatagridPaginationController($scope) {
	        _classCallCheck(this, DatagridPaginationController);
	
	        this.$scope = $scope;
	        var perPage = parseInt(this.$scope.perPage, 10) || 1,
	            totalItems = parseInt(this.$scope.totalItems, 10),
	            page = Math.max(parseInt(this.$scope.page, 10), 1);
	
	        this.nbPages = Math.ceil(totalItems / perPage) || 1;
	        this.page = Math.min(this.nbPages, page);
	        this.offsetEnd = Math.min(this.page * perPage, totalItems);
	        this.offsetBegin = Math.min((this.page - 1) * perPage + 1, this.offsetEnd);
	        this.totalItems = totalItems;
	        this.displayPagination = perPage < totalItems;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    /**
	     * Return an array with the range between min & max, useful for pagination
	     *
	     * @param {int} min
	     * @param {int} max
	     * @returns {Array}
	     */
	
	    _createClass(DatagridPaginationController, [{
	        key: 'range',
	        value: function range(page) {
	            var input = [],
	                nbPages = this.nbPages;
	
	            // display page links around the current page
	            if (page > 2) {
	                input.push('1');
	            }
	            if (page == 4) {
	                input.push('2');
	            }
	            if (page > 4) {
	                input.push('.');
	            }
	            if (page > 1) {
	                input.push(page - 1);
	            }
	            input.push(page);
	            if (page < nbPages) {
	                input.push(page + 1);
	            }
	            if (page == nbPages - 3) {
	                input.push(nbPages - 1);
	            }
	            if (page < nbPages - 3) {
	                input.push('.');
	            }
	            if (page < nbPages - 1) {
	                input.push(nbPages);
	            }
	
	            return input;
	        }
	
	        /**
	         * Link to page number of the list
	         *
	         * @param {int} number
	         */
	
	    }, {
	        key: 'setPage',
	        value: function setPage(number) {
	            if (number <= 0 || number > this.nbPages) {
	                return;
	            }
	            this.$scope.setPage()(number);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	        }
	    }]);
	
	    return DatagridPaginationController;
	}();
	
	exports.default = DatagridPaginationController;
	
	DatagridPaginationController.$inject = ['$scope'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDatagridPaginationController.js.map

/***/ },
/* 326 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maListActions;
	function maListActions() {
	    return {
	        restrict: 'E',
	        transclude: true,
	        scope: {
	            'buttons': '&',
	            'entry': '&',
	            'entity': '&'
	        },
	        link: function link($scope) {
	            $scope.buttons = $scope.buttons();
	            $scope.entry = $scope.entry();
	            $scope.entity = $scope.entity();
	            $scope.customTemplate = false;
	            if (typeof $scope.buttons === 'string') {
	                $scope.customTemplate = $scope.buttons;
	                $scope.buttons = null;
	            }
	        },
	        template: '<span compile="customTemplate">\n    <span ng-repeat="button in ::buttons" ng-switch="button">\n        <ma-show-button ng-switch-when="show" entry="::entry" entity="::entity" size="xs"></ma-show-button>\n        <ma-edit-button ng-switch-when="edit" ng-if="::entity.editionView().enabled" entry="::entry" entity="::entity" size="xs"></ma-edit-button>\n        <ma-delete-button ng-switch-when="delete" ng-if="::entity.deletionView().enabled" entry="::entry" entity="::entity" size="xs"></ma-delete-button>\n        <span ng-switch-default><span compile="button"></span></span>\n    </span>\n</span>'
	    };
	}
	
	maListActions.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maListActions.js.map

/***/ },
/* 327 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Compile;
	// @see https://docs.angularjs.org/api/ng/service/$compile
	function Compile($injector) {
	    var $compile = $injector.get('$compile');
	
	    return {
	        transclude: true,
	        link: function link(scope, element, attrs, controller, transcludeFn) {
	            var unbindWatcher = scope.$watch(function (scope) {
	                // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	            }, function (value) {
	                if (false === value) {
	                    // use the default tag content
	                    transcludeFn(scope, function (clone) {
	                        element.append(clone);
	                    });
	                    return;
	                }
	                // when the 'compile' expression changes assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current scope.
	                $compile(element.contents())(scope);
	
	                if (attrs.compileOnce == 'true') {
	                    unbindWatcher();
	                }
	            });
	        }
	    };
	}
	
	Compile.$inject = ['$injector'];
	module.exports = exports['default'];
	//# sourceMappingURL=Compile.js.map

/***/ },
/* 328 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var EntryFormatter = function () {
	    function EntryFormatter($filter) {
	        _classCallCheck(this, EntryFormatter);
	
	        this.formatDate = function (format) {
	            return function (date) {
	                return $filter('date')(date, format);
	            };
	        };
	        this.formatNumber = function (format) {
	            return function (number) {
	                return $filter('numeraljs')(number, format);
	            };
	        };
	    }
	
	    _createClass(EntryFormatter, [{
	        key: 'formatField',
	        value: function formatField(field) {
	            var label = field.label() || field.name();
	            var type = field.type();
	            switch (type) {
	                case 'boolean':
	                case 'choice':
	                case 'choices':
	                case 'string':
	                case 'text':
	                case 'wysiwyg':
	                case 'email':
	                case 'json':
	                case 'file':
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: entry.values[field.name()]
	                        };
	                    };
	                case 'template':
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: field.getTemplateValue(entry)
	                        };
	                    };
	                case 'number':
	                case 'float':
	                    var formatNumber = this.formatNumber(field.format());
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: formatNumber(entry.values[field.name()])
	                        };
	                    };
	                case 'date':
	                case 'datetime':
	                    var format = field.format();
	                    if (!format) {
	                        format = type === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss';
	                    }
	
	                    var formatDate = this.formatDate(format);
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: formatDate(entry.values[field.name()])
	                        };
	                    };
	                case 'reference':
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: entry.listValues[field.name()]
	                        };
	                    };
	                case 'reference_many':
	                    return function (entry) {
	                        return {
	                            name: label,
	                            value: entry.listValues[field.name()].join(', ')
	                        };
	                    };
	                case 'referenced_list':
	                    return; //ignored
	            }
	        }
	    }, {
	        key: 'getFormatter',
	        value: function getFormatter(fields) {
	            var fieldsFormatters = fields.map(this.formatField.bind(this));
	
	            return function formatEntry(entry) {
	                var result = {};
	                fieldsFormatters.map(function (formatter) {
	                    if (!formatter) {
	                        return;
	                    }
	                    return formatter(entry);
	                }).forEach(function (field) {
	                    if (!field) {
	                        return;
	                    }
	                    result[field.name] = field.value;
	                });
	
	                return result;
	            };
	        }
	    }]);
	
	    return EntryFormatter;
	}();
	
	exports.default = EntryFormatter;
	
	EntryFormatter.$inject = ['$filter'];
	module.exports = exports['default'];
	//# sourceMappingURL=EntryFormatter.js.map

/***/ },
/* 329 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PromisesResolver;
	function PromisesResolver(AdminDescription) {
	    return AdminDescription.getPromisesResolver();
	}
	
	PromisesResolver.$inject = ['AdminDescription'];
	module.exports = exports['default'];
	//# sourceMappingURL=PromisesResolver.js.map

/***/ },
/* 330 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var RestWrapper = function () {
	    function RestWrapper(Restangular) {
	        _classCallCheck(this, RestWrapper);
	
	        this.Restangular = Restangular;
	
	        Restangular.setFullResponse(true);
	    }
	
	    /**
	     * Returns the promise of one resource by URL
	     *
	     * @param {String} entityName
	     * @param {String} url
	     *
	     * @returns {promise}
	     */
	
	    _createClass(RestWrapper, [{
	        key: 'getOne',
	        value: function getOne(entityName, url) {
	            return this.Restangular.oneUrl(entityName, url).get().then(function (response) {
	                return response.data;
	            });
	        }
	
	        /**
	         * Returns the promise of a list of resources
	         *
	         * @param {Object} params
	         * @param {String} entityName
	         * @param {String} url
	         *
	         * @returns {promise}
	         */
	
	    }, {
	        key: 'getList',
	        value: function getList(params, entityName, url) {
	            return this.Restangular.allUrl(entityName, url).getList(params);
	        }
	    }, {
	        key: 'createOne',
	        value: function createOne(rawEntity, entityName, url, method) {
	            var resource = this.Restangular.oneUrl(entityName, url),
	                operation = method ? resource.customOperation(method, null, {}, {}, rawEntity) : resource.customPOST(rawEntity);
	
	            return operation.then(function (response) {
	                return response.data;
	            });
	        }
	    }, {
	        key: 'updateOne',
	        value: function updateOne(rawEntity, entityName, url, method) {
	            var resource = this.Restangular.oneUrl(entityName, url),
	                operation = method ? resource.customOperation(method, null, {}, {}, rawEntity) : resource.customPUT(rawEntity);
	
	            return operation.then(function (response) {
	                return response.data;
	            });
	        }
	    }, {
	        key: 'deleteOne',
	        value: function deleteOne(entityName, url) {
	            return this.Restangular.oneUrl(entityName, url).customDELETE();
	        }
	    }]);
	
	    return RestWrapper;
	}();
	
	exports.default = RestWrapper;
	
	RestWrapper.$inject = ['Restangular'];
	module.exports = exports['default'];
	//# sourceMappingURL=RestWrapper.js.map

/***/ },
/* 331 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ViewActions;
	function ViewActions($injector) {
	    var $compile = $injector.get('$compile');
	
	    return {
	        restrict: 'E',
	        transclude: true,
	        scope: {
	            override: '&',
	            entry: '=',
	            entity: '=',
	            selection: '=',
	            batchButtons: '&',
	            datastore: '=',
	            search: '=',
	            filters: '&',
	            enabledFilters: '=',
	            enableFilter: '&'
	        },
	        link: function link($scope, element, attrs, controller, transcludeFn) {
	            var override = $scope.override();
	            if (!override) {
	                // use the default tag content
	                transcludeFn($scope, function (clone) {
	                    element.append(clone);
	                });
	                return;
	            }
	            if (typeof override === 'string') {
	                // custom template, use it instead of default template
	                element.html(override);
	                $compile(element.contents())($scope);
	                return;
	            }
	            // list of buttons - default template
	            $scope.buttons = override;
	        },
	        template: '<span ng-repeat="button in buttons" ng-switch="button" class="view_actions">\n    <ma-filter-button ng-switch-when="filter" filters="filters()" enabled-filters="enabledFilters" enable-filter="enableFilter()"></ma-filter-button>\n    <ma-view-batch-actions ng-switch-when="batch" buttons="batchButtons()" selection="selection" entity="entity"></ma-view-batch-actions>\n    <ma-back-button ng-switch-when="back"></ma-back-button>\n    <ma-list-button ng-switch-when="list" entity="entity"></ma-list-button>\n    <ma-create-button ng-switch-when="create" entity="entity"></ma-create-button>\n    <ma-show-button ng-switch-when="show" entry="entry" entity="entity"></ma-show-button>\n    <ma-edit-button ng-switch-when="edit" entry="entry" entity="entity"></ma-edit-button>\n    <ma-delete-button ng-switch-when="delete" entry="entry" entity="entity"></ma-delete-button>\n    <ma-export-to-csv-button ng-switch-when="export" datastore="datastore" entity="entity"></ma-export-to-csv-button>\n    <span ng-switch-default><span compile="button"></span></span>\n</span>'
	    };
	}
	
	ViewActions.$inject = ['$injector'];
	module.exports = exports['default'];
	//# sourceMappingURL=ViewActions.js.map

/***/ },
/* 332 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReadQueries;
	/**
	 * @param {RestWrapper} RestWrapper
	 * @param {Configuration} Configuration
	 * @param {AdminDescription} AdminDescription
	 * @param {PromisesResolver} PromisesResolver
	 *
	 * @returns {ReadQueries}
	 * @constructor
	 */
	function ReadQueries(RestWrapper, Configuration, AdminDescription, PromisesResolver) {
	  return AdminDescription.getReadQueries(RestWrapper, PromisesResolver, Configuration());
	}
	
	ReadQueries.$inject = ['RestWrapper', 'NgAdminConfiguration', 'AdminDescription', 'PromisesResolver'];
	module.exports = exports['default'];
	//# sourceMappingURL=ReadQueries.js.map

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _Entry = __webpack_require__(6);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var ReferenceRefresher = function () {
	    function ReferenceRefresher(ReadQueries) {
	        _classCallCheck(this, ReferenceRefresher);
	
	        this.ReadQueries = ReadQueries;
	    }
	
	    _createClass(ReferenceRefresher, [{
	        key: 'refresh',
	        value: function refresh(field, currentValue, search) {
	            var _this = this;
	
	            var referenceFields = {};
	            referenceFields[field.name()] = field;
	
	            var promise = this.ReadQueries.getAllReferencedData(referenceFields, search).then(function (r) {
	                return r[field.name()];
	            }).then(function (results) {
	                return _this._transformRecords(field, results);
	            });
	
	            if (field.type() === 'reference_many' || field.type() === 'choices') {
	                promise = promise.then(function (formattedResults) {
	                    return _this._removeDuplicates(formattedResults, currentValue);
	                });
	            }
	
	            return promise;
	        }
	    }, {
	        key: '_removeDuplicates',
	        value: function _removeDuplicates(results, currentValue) {
	            // remove already assigned values: ui-select still return them if multiple
	            if (!currentValue) {
	                return results;
	            }
	
	            if (!Array.isArray(currentValue)) {
	                currentValue = [currentValue];
	            }
	
	            return results.filter(function (fr) {
	                return currentValue.indexOf(fr.value) === -1;
	            });
	        }
	    }, {
	        key: '_transformRecords',
	        value: function _transformRecords(field, records) {
	            var targetEntity = field.targetEntity();
	            var targetField = field.targetField();
	            var valueFieldName = targetEntity.identifier().name();
	            var labelFieldName = targetField.name();
	            return _Entry2.default.createArrayFromRest(records, [targetField], targetEntity.name(), valueFieldName).map(function (r) {
	                return {
	                    value: r.values[valueFieldName],
	                    label: r.values[labelFieldName]
	                };
	            });
	        }
	    }]);
	
	    return ReferenceRefresher;
	}();
	
	exports.default = ReferenceRefresher;
	
	ReferenceRefresher.$inject = ['ReadQueries'];
	module.exports = exports['default'];
	//# sourceMappingURL=ReferenceRefresher.js.map

/***/ },
/* 334 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WriteQueries;
	/**
	 * @param {RestWrapper} RestWrapper
	 * @param {Configuration} Configuration
	 * @param {AdminDescription} AdminDescription
	 * @param {PromisesResolver} PromisesResolver
	 *
	 * @returns {ReadQueries}
	 * @constructor
	 */
	function WriteQueries(RestWrapper, Configuration, AdminDescription, PromisesResolver) {
	  return AdminDescription.getWriteQueries(RestWrapper, PromisesResolver, Configuration());
	}
	
	WriteQueries.$inject = ['RestWrapper', 'NgAdminConfiguration', 'AdminDescription', 'PromisesResolver'];
	module.exports = exports['default'];
	//# sourceMappingURL=WriteQueries.js.map

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _DataStore = __webpack_require__(108);
	
	var _DataStore2 = _interopRequireDefault(_DataStore);
	
	var _Entry = __webpack_require__(6);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	var _batchDelete = __webpack_require__(420);
	
	var _batchDelete2 = _interopRequireDefault(_batchDelete);
	
	var _delete = __webpack_require__(421);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _create = __webpack_require__(422);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _edit = __webpack_require__(423);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _list = __webpack_require__(424);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _listLayout = __webpack_require__(425);
	
	var _listLayout2 = _interopRequireDefault(_listLayout);
	
	var _show = __webpack_require__(427);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function templateProvider(viewName, defaultView) {
	    return ['$stateParams', 'NgAdminConfiguration', function ($stateParams, Configuration) {
	        var customTemplate;
	        var view = Configuration().getViewByEntityAndType($stateParams.entity, viewName);
	        customTemplate = view.template();
	        if (customTemplate) {
	            return customTemplate;
	        }
	        customTemplate = Configuration().customTemplate()(viewName);
	        if (customTemplate) {
	            return customTemplate;
	        }
	        return defaultView;
	    }];
	}
	
	function viewProvider(viewName) {
	    return ['$stateParams', 'NgAdminConfiguration', function ($stateParams, Configuration) {
	        var view;
	        try {
	            view = Configuration().getViewByEntityAndType($stateParams.entity, viewName);
	        } catch (e) {
	            var error404 = new Error('Unknown view or entity name');
	            error404.status = 404; // trigger the 404 error
	            throw error404;
	        }
	        if (!view.enabled) {
	            throw new Error('The ' + viewName + ' is disabled for this entity');
	        }
	        return view;
	    }];
	}
	
	function routing($stateProvider) {
	
	    $stateProvider.state('listLayout', {
	        abstract: true,
	        url: '/:entity/list',
	        params: {
	            entity: null
	        },
	        parent: 'ng-admin',
	        controller: 'ListLayoutController',
	        controllerAs: 'llCtrl',
	        templateProvider: templateProvider('ListView', _listLayout2.default),
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            view: viewProvider('ListView'),
	            filterData: ['ReadQueries', 'view', function (ReadQueries, view) {
	                return ReadQueries.getAllReferencedData(view.getFilterReferences(false));
	            }],
	            filterEntries: ['dataStore', 'view', 'filterData', function (dataStore, view, filterData) {
	                var filters = view.getFilterReferences(false);
	                for (var name in filterData) {
	                    _Entry2.default.createArrayFromRest(filterData[name], [filters[name].targetField()], filters[name].targetEntity().name(), filters[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(filters[name].targetEntity().uniqueId + '_choices', entry);
	                    });
	                }
	            }]
	        }
	    }).state('list', {
	        url: '?{search:json}&{page:int}&sortField&sortDir',
	        params: {
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        parent: 'listLayout',
	        views: {
	            grid: {
	                controller: 'ListController',
	                controllerAs: 'listController',
	                template: _list2.default,
	                resolve: {
	                    dataStore: function dataStore() {
	                        return new _DataStore2.default();
	                    },
	                    view: viewProvider('ListView'),
	                    response: ['$stateParams', 'ReadQueries', 'view', function ($stateParams, ReadQueries, view) {
	                        var page = $stateParams.page,
	                            filters = $stateParams.search,
	                            sortField = $stateParams.sortField,
	                            sortDir = $stateParams.sortDir;
	
	                        return ReadQueries.getAll(view, page, filters, sortField, sortDir);
	                    }],
	                    totalItems: ['response', function (response) {
	                        return response.totalItems;
	                    }],
	                    referenceData: ['ReadQueries', 'view', 'response', function (ReadQueries, view, response) {
	                        return ReadQueries.getReferenceData(view.fields(), response.data);
	                    }],
	                    referenceEntries: ['dataStore', 'view', 'referenceData', function (dataStore, view, referenceData) {
	                        var references = view.getReferences();
	                        for (var name in referenceData) {
	                            _Entry2.default.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                                return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                            });
	                        }
	                    }],
	                    entries: ['dataStore', 'view', 'response', 'referenceEntries', function (dataStore, view, response, referenceEntries) {
	                        var entries = view.mapEntries(response.data);
	
	                        // shortcut to diplay collection of entry with included referenced values
	                        dataStore.fillReferencesValuesFromCollection(entries, view.getReferences(), true);
	
	                        // set entries here ???
	                        dataStore.setEntries(view.getEntity().uniqueId, entries);
	
	                        return entries;
	                    }],
	                    prepare: ['view', '$stateParams', 'dataStore', 'entries', '$window', '$injector', function (view, $stateParams, dataStore, entries, $window, $injector) {
	                        return view.prepare() && $injector.invoke(view.prepare(), view, {
	                            query: $stateParams,
	                            datastore: dataStore,
	                            view: view,
	                            Entry: _Entry2.default,
	                            entries: entries,
	                            window: $window
	                        });
	                    }]
	                }
	            }
	        }
	    });
	
	    $stateProvider.state('show', {
	        parent: 'ng-admin',
	        url: '/:entity/show/:id?sortField&sortDir',
	        controller: 'ShowController',
	        controllerAs: 'showController',
	        templateProvider: templateProvider('ShowView', _show2.default),
	        params: {
	            entity: null,
	            id: null,
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            view: viewProvider('ShowView'),
	            rawEntry: ['$stateParams', 'ReadQueries', 'view', function ($stateParams, ReadQueries, view) {
	                return ReadQueries.getOne(view.getEntity(), view.type, $stateParams.id, view.identifier(), view.getUrl());
	            }],
	            entry: ['view', 'rawEntry', function (view, rawEntry) {
	                return view.mapEntry(rawEntry);
	            }],
	            referenceData: ['ReadQueries', 'view', 'entry', function (ReadQueries, view, entry) {
	                return ReadQueries.getReferenceData(view.fields(), [entry.values]);
	            }],
	            referenceEntries: ['dataStore', 'view', 'referenceData', function (dataStore, view, referenceData) {
	                var references = view.getReferences();
	                for (var name in referenceData) {
	                    _Entry2.default.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                    });
	                }
	            }],
	            referencedListData: ['$stateParams', 'ReadQueries', 'view', 'entry', function ($stateParams, ReadQueries, view, entry) {
	                return ReadQueries.getReferencedListData(view.getReferencedLists(), $stateParams.sortField, $stateParams.sortDir, entry.identifierValue);
	            }],
	            referencedListEntries: ['dataStore', 'view', 'referencedListData', function (dataStore, view, referencedListData) {
	                var referencedLists = view.getReferencedLists();
	                for (var name in referencedLists) {
	                    _Entry2.default.createArrayFromRest(referencedListData[name], referencedLists[name].targetFields(), referencedLists[name].targetEntity().name(), referencedLists[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(referencedLists[name].targetEntity().uniqueId + '_list', entry);
	                    });
	                }
	            }],
	            entryWithReferences: ['dataStore', 'view', 'entry', 'referenceEntries', function (dataStore, view, entry, referenceEntries) {
	                dataStore.fillReferencesValuesFromEntry(entry, view.getReferences(), true);
	                dataStore.addEntry(view.getEntity().uniqueId, entry);
	            }],
	            referenceDataForReferencedLists: ['$q', 'ReadQueries', 'view', 'referencedListData', function ($q, ReadQueries, view, referencedListData) {
	                var referencedLists = view.getReferencedLists();
	                var promises = {};
	                Object.keys(referencedLists).map(function (name) {
	                    promises[name] = ReadQueries.getReferenceData(referencedLists[name].targetFields(), referencedListData[name]);
	                });
	                return $q.all(promises);
	            }],
	            referenceEntriesForReferencedLists: ['dataStore', 'view', 'referenceDataForReferencedLists', function (dataStore, view, referenceDataForReferencedLists) {
	                var referencedLists = view.getReferencedLists();
	                Object.keys(referencedLists).map(function (referencedListName) {
	                    var references = referencedLists[referencedListName].getReferences();
	                    for (var name in references) {
	                        if (!referenceDataForReferencedLists[referencedListName][name]) {
	                            continue;
	                        }
	                        _Entry2.default.createArrayFromRest(referenceDataForReferencedLists[referencedListName][name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                            return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                        });
	                    }
	                });
	                return true;
	            }],
	            prepare: ['view', '$stateParams', 'dataStore', 'entry', 'entryWithReferences', 'referencedListEntries', 'referenceEntriesForReferencedLists', '$window', '$injector', function (view, $stateParams, dataStore, entry, entryWithReferences, referencedListEntries, referenceEntriesForReferencedLists, $window, $injector) {
	                return view.prepare() && $injector.invoke(view.prepare(), view, {
	                    query: $stateParams,
	                    datastore: dataStore,
	                    view: view,
	                    Entry: _Entry2.default,
	                    entry: entry,
	                    window: $window
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('create', {
	        parent: 'ng-admin',
	        url: '/:entity/create?{defaultValues:json}',
	        controller: 'FormController',
	        controllerAs: 'formController',
	        templateProvider: templateProvider('CreateView', _create2.default),
	        params: {
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            defaultValues: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            previousState: ['$state', '$stateParams', function ($state, $stateParams) {
	                return {
	                    name: $state.current.name || 'edit',
	                    params: Object.keys($state.params).length > 0 ? $state.params : $stateParams
	                };
	            }],
	            view: viewProvider('CreateView'),
	            entry: ['$stateParams', 'dataStore', 'view', function ($stateParams, dataStore, view) {
	                var entry = _Entry2.default.createForFields(view.getFields(), view.entity.name());
	                Object.keys($stateParams.defaultValues).forEach(function (key) {
	                    return entry.values[key] = $stateParams.defaultValues[key];
	                });
	                dataStore.addEntry(view.getEntity().uniqueId, entry);
	
	                return entry;
	            }],
	            choiceData: ['ReadQueries', 'view', function (ReadQueries, view) {
	                return ReadQueries.getAllReferencedData(view.getReferences(false));
	            }],
	            choiceEntries: ['dataStore', 'view', 'choiceData', function (dataStore, view, filterData) {
	                var choices = view.getReferences(false);
	                for (var name in filterData) {
	                    _Entry2.default.createArrayFromRest(filterData[name], [choices[name].targetField()], choices[name].targetEntity().name(), choices[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(choices[name].targetEntity().uniqueId + '_choices', entry);
	                    });
	                }
	            }],
	            prepare: ['view', '$stateParams', 'dataStore', 'entry', 'choiceEntries', '$window', '$injector', function (view, $stateParams, dataStore, entry, choiceEntries, $window, $injector) {
	                return view.prepare() && $injector.invoke(view.prepare(), view, {
	                    query: $stateParams,
	                    datastore: dataStore,
	                    view: view,
	                    Entry: _Entry2.default,
	                    entry: entry,
	                    window: $window
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('edit', {
	        parent: 'ng-admin',
	        url: '/:entity/edit/:id?sortField&sortDir',
	        controller: 'FormController',
	        controllerAs: 'formController',
	        templateProvider: templateProvider('EditView', _edit2.default),
	        params: {
	            entity: null,
	            id: null,
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            previousState: ['$state', '$stateParams', function ($state, $stateParams) {
	                return {
	                    name: $state.current.name || 'edit',
	                    params: Object.keys($state.params).length > 0 ? $state.params : $stateParams
	                };
	            }],
	            view: viewProvider('EditView'),
	            rawEntry: ['$stateParams', 'ReadQueries', 'view', function ($stateParams, ReadQueries, view) {
	                return ReadQueries.getOne(view.getEntity(), view.type, $stateParams.id, view.identifier(), view.getUrl($stateParams.id));
	            }],
	            entry: ['view', 'rawEntry', function (view, rawEntry) {
	                return view.mapEntry(rawEntry);
	            }],
	            referenceData: ['ReadQueries', 'view', 'entry', function (ReadQueries, view, entry) {
	                return ReadQueries.getReferenceData(view.fields(), [entry.values]);
	            }],
	            referenceEntries: ['dataStore', 'view', 'referenceData', function (dataStore, view, referenceData) {
	                var references = view.getReferences();
	                for (var name in referenceData) {
	                    _Entry2.default.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                    });
	                }
	            }],
	            referencedListData: ['$stateParams', 'ReadQueries', 'view', 'entry', function ($stateParams, ReadQueries, view, entry) {
	                return ReadQueries.getReferencedListData(view.getReferencedLists(), $stateParams.sortField, $stateParams.sortDir, entry.identifierValue);
	            }],
	            referencedListEntries: ['dataStore', 'view', 'referencedListData', function (dataStore, view, referencedListData) {
	                var referencedLists = view.getReferencedLists();
	                for (var name in referencedLists) {
	                    _Entry2.default.createArrayFromRest(referencedListData[name], referencedLists[name].targetFields(), referencedLists[name].targetEntity().name(), referencedLists[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(referencedLists[name].targetEntity().uniqueId + '_list', entry);
	                    });
	                }
	            }],
	            entryWithReferences: ['dataStore', 'view', 'entry', 'referenceEntries', function (dataStore, view, entry, referenceEntries) {
	                dataStore.fillReferencesValuesFromEntry(entry, view.getReferences(), true);
	                dataStore.addEntry(view.getEntity().uniqueId, entry);
	            }],
	            choiceData: ['ReadQueries', 'view', function (ReadQueries, view) {
	                return ReadQueries.getAllReferencedData(view.getReferences(false));
	            }],
	            choiceEntries: ['dataStore', 'view', 'choiceData', function (dataStore, view, filterData) {
	                var choices = view.getReferences(false);
	                for (var name in filterData) {
	                    _Entry2.default.createArrayFromRest(filterData[name], [choices[name].targetField()], choices[name].targetEntity().name(), choices[name].targetEntity().identifier().name()).map(function (entry) {
	                        return dataStore.addEntry(choices[name].targetEntity().uniqueId + '_choices', entry);
	                    });
	                }
	            }],
	            referenceDataForReferencedLists: ['$q', 'ReadQueries', 'view', 'referencedListData', function ($q, ReadQueries, view, referencedListData) {
	                var referencedLists = view.getReferencedLists();
	                var promises = {};
	                Object.keys(referencedLists).map(function (name) {
	                    promises[name] = ReadQueries.getReferenceData(referencedLists[name].targetFields(), referencedListData[name]);
	                });
	                return $q.all(promises);
	            }],
	            referenceEntriesForReferencedLists: ['dataStore', 'view', 'referenceDataForReferencedLists', function (dataStore, view, referenceDataForReferencedLists) {
	                var referencedLists = view.getReferencedLists();
	                Object.keys(referencedLists).map(function (referencedListName) {
	                    var references = referencedLists[referencedListName].getReferences();
	                    for (var name in references) {
	                        if (!referenceDataForReferencedLists[referencedListName][name]) {
	                            continue;
	                        }
	                        _Entry2.default.createArrayFromRest(referenceDataForReferencedLists[referencedListName][name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                            return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                        });
	                    }
	                });
	                return true;
	            }],
	            prepare: ['view', '$stateParams', 'dataStore', 'entry', 'referenceEntriesForReferencedLists', 'choiceEntries', 'entryWithReferences', '$window', '$injector', function (view, $stateParams, dataStore, entry, referenceEntriesForReferencedLists, choiceEntries, entryWithReferences, $window, $injector) {
	                return view.prepare() && $injector.invoke(view.prepare(), view, {
	                    query: $stateParams,
	                    datastore: dataStore,
	                    view: view,
	                    Entry: _Entry2.default,
	                    entry: entry,
	                    window: $window
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('delete', {
	        parent: 'ng-admin',
	        url: '/:entity/delete/:id',
	        controller: 'DeleteController',
	        controllerAs: 'deleteController',
	        templateProvider: templateProvider('DeleteView', _delete2.default),
	        params: {
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            dataStore: function dataStore() {
	                return new _DataStore2.default();
	            },
	            view: viewProvider('DeleteView'),
	            params: ['$stateParams', function ($stateParams) {
	                return $stateParams;
	            }],
	            rawEntry: ['$stateParams', 'ReadQueries', 'view', function ($stateParams, ReadQueries, view) {
	                return ReadQueries.getOne(view.getEntity(), view.type, $stateParams.id, view.identifier(), view.getUrl());
	            }],
	            entry: ['view', 'rawEntry', function (view, rawEntry) {
	                return view.mapEntry(rawEntry);
	            }],
	            prepare: ['view', '$stateParams', 'dataStore', 'entry', '$window', '$injector', function (view, $stateParams, dataStore, entry, $window, $injector) {
	                return view.prepare() && $injector.invoke(view.prepare(), view, {
	                    query: $stateParams,
	                    datastore: dataStore,
	                    view: view,
	                    Entry: _Entry2.default,
	                    entry: entry,
	                    window: $window
	                });
	            }]
	        }
	    });
	
	    $stateProvider.state('batchDelete', {
	        parent: 'ng-admin',
	        url: '/:entity/batch-delete/{ids:json}',
	        controller: 'BatchDeleteController',
	        controllerAs: 'batchDeleteController',
	        templateProvider: templateProvider('BatchDeleteView', _batchDelete2.default),
	        params: {
	            entity: null,
	            ids: [],
	            page: { value: 1, squash: true },
	            search: { value: {}, squash: true },
	            sortField: null,
	            sortDir: null
	        },
	        resolve: {
	            view: viewProvider('BatchDeleteView'),
	            params: ['$stateParams', function ($stateParams) {
	                return $stateParams;
	            }]
	        }
	    });
	}
	
	routing.$inject = ['$stateProvider'];
	
	exports.default = routing;
	module.exports = exports['default'];
	//# sourceMappingURL=routing.js.map

/***/ },
/* 336 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var ShowController = function () {
	    function ShowController($scope, $location, view, dataStore) {
	        _classCallCheck(this, ShowController);
	
	        this.$scope = $scope;
	        this.$location = $location;
	        this.title = view.title();
	        this.description = view.description();
	        this.actions = view.actions();
	
	        this.fields = view.fields();
	        this.$scope.entry = dataStore.getFirstEntry(view.getEntity().uniqueId);
	        this.$scope.view = view;
	        this.view = view;
	        this.entity = this.view.getEntity();
	        this.dataStore = dataStore;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(ShowController, [{
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$location = undefined;
	            this.view = undefined;
	            this.entity = undefined;
	            this.dataStore = undefined;
	        }
	    }]);
	
	    return ShowController;
	}();
	
	exports.default = ShowController;
	
	ShowController.$inject = ['$scope', '$location', 'view', 'dataStore'];
	module.exports = exports['default'];
	//# sourceMappingURL=ShowController.js.map

/***/ },
/* 337 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maShowItem;
	/**
	 * A directive containing a label and a column
	 *
	 * To be used in the showView
	 */
	function maShowItem() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            entry: '&',
	            entity: '&',
	            datastore: '&'
	        },
	        link: {
	            pre: function pre(scope) {
	                scope.field = scope.field();
	                scope.entry = scope.entry();
	                scope.entity = scope.entity();
	                scope.datastore = scope.datastore();
	            }
	        },
	        template: '<div class="col-lg-12 form-group">\n    <label class="col-sm-2 control-label">{{ field.label() | translate }}</label>\n    <div class="show-value" ng-class="(field.getCssClasses(entry) || \'col-sm-10 col-md-8 col-lg-7\')">\n        <div ng-class="::\'ng-admin-field-\' + field.name() + \' \' + \'ng-admin-type-\' + field.type()">\n            <ma-column field="::field" entry="::entry" entity="::entity" datastore="::datastore"></ma-column>\n        </div>\n    </div>\n</div>'
	    };
	}
	
	maShowItem.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maShowItem.js.map

/***/ },
/* 338 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maJsonValidator;
	function maJsonValidator() {
	    return {
	        require: 'ngModel',
	        link: function link(scope, elm, attr, ctrl) {
	            ctrl.$validators.json = function (value) {
	                if (ctrl.$isEmpty(value)) {
	                    return true;
	                }
	
	                try {
	                    angular.fromJson(value);
	
	                    return true;
	                } catch (e) {
	                    return false;
	                }
	            };
	        }
	    };
	}
	
	maJsonValidator.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=maJsonValidator.js.map

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	__webpack_require__(19);
	__webpack_require__(388);
	
	var MainModule = _angular2.default.module('main', ['ui.router', 'restangular', 'pascalprecht.translate']);
	
	MainModule.controller('AppController', __webpack_require__(340));
	MainModule.controller('DashboardController', __webpack_require__(341));
	MainModule.provider('NgAdminConfiguration', __webpack_require__(347));
	MainModule.provider('HttpErrorService', __webpack_require__(346));
	
	MainModule.filter('orderElement', __webpack_require__(344));
	MainModule.filter('stripTags', __webpack_require__(345));
	
	MainModule.directive('maDashboardPanel', __webpack_require__(342));
	MainModule.directive('maMenuBar', __webpack_require__(343));
	
	MainModule.config(__webpack_require__(348));
	MainModule.config(__webpack_require__(350));
	MainModule.config(__webpack_require__(351));
	MainModule.config(__webpack_require__(349));
	
	MainModule.run(__webpack_require__(352));
	MainModule.run(__webpack_require__(353));
	//# sourceMappingURL=MainModule.js.map

/***/ },
/* 340 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	/**
	 * @param {$scope}  $scope
	 * @param {$state}  $state
	 * @param {NgAdmin} Configuration
	 * @constructor
	 */
	var AppController = function () {
	    function AppController($scope, $state, Configuration) {
	        _classCallCheck(this, AppController);
	
	        var application = Configuration();
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$scope.isCollapsed = true;
	        this.menu = application.menu();
	        this.applicationName = application.title();
	        this.header = application.header();
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(AppController, [{
	        key: 'displayHome',
	        value: function displayHome() {
	            this.$state.go(this.$state.get('dashboard'));
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$scope = undefined;
	            this.$state = undefined;
	        }
	    }]);
	
	    return AppController;
	}();
	
	exports.default = AppController;
	
	AppController.$inject = ['$scope', '$state', 'NgAdminConfiguration'];
	module.exports = exports['default'];
	//# sourceMappingURL=AppController.js.map

/***/ },
/* 341 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	/**
	 * @param {$scope} $scope
	 * @param {$state} $state
	 * @param {PanelBuilder} PanelBuilder
	 * @constructor
	 */
	var DashboardController = function () {
	    function DashboardController($scope, $state, collections, entries, hasEntities, dataStore) {
	        _classCallCheck(this, DashboardController);
	
	        this.$state = $state;
	        this.collections = collections;
	        this.entries = entries;
	        this.hasEntities = hasEntities;
	        this.datastore = dataStore;
	
	        $scope.$on('$destroy', this.destroy.bind(this));
	    }
	
	    _createClass(DashboardController, [{
	        key: 'gotoList',
	        value: function gotoList(entityName) {
	            this.$state.go(this.$state.get('list'), { entity: entityName });
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this.$state = undefined;
	        }
	    }]);
	
	    return DashboardController;
	}();
	
	exports.default = DashboardController;
	
	DashboardController.$inject = ['$scope', '$state', 'collections', 'entries', 'hasEntities', 'dataStore'];
	module.exports = exports['default'];
	//# sourceMappingURL=DashboardController.js.map

/***/ },
/* 342 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maDashboardPanel;
	function maDashboardPanel($state) {
	    return {
	        restrict: 'E',
	        scope: {
	            collection: '&',
	            entries: '&',
	            datastore: '&'
	        },
	        link: function link(scope) {
	            scope.gotoList = function () {
	                $state.go($state.get('list'), { entity: scope.collection().entity.name() });
	            };
	        },
	        template: '<div class="panel-heading">\n    <a ng-click="gotoList()">{{ (collection().title() || collection().entity.label()) | translate }}</a>\n</div>\n<ma-datagrid name="{{ collection().name() }}"\n    entries="entries()"\n    fields="::collection().fields()"\n    entity="::collection().entity"\n    list-actions="::collection().listActions()"\n    datastore="datastore()">\n</ma-datagrid>'
	    };
	}
	
	maDashboardPanel.$inject = ['$state'];
	module.exports = exports['default'];
	//# sourceMappingURL=maDashboardPanel.js.map

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = maMenuBar;
	
	var _menuBar = __webpack_require__(431);
	
	var _menuBar2 = _interopRequireDefault(_menuBar);
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function maMenuBar($location, $rootScope, $compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            'menu': '&'
	        },
	        link: function link(scope, element) {
	            scope.menu = scope.menu();
	            scope.path = $location.path();
	            // initialize openMenus
	            var openMenus = scope.menu.children().filter(function (menu) {
	                return menu.isChildActive(scope.path);
	            });
	            // manually render on change to avoid checking menu.isActive at each dirty check
	            var listener = $rootScope.$on('$locationChangeSuccess', function () {
	                scope.path = $location.path();
	                render();
	            });
	            $rootScope.$on('$destroy', listener);
	            scope.toggleMenu = function (menu) {
	                // handle click on parent menu manually
	                // because we chose bindOnce in the template for performance reasons
	                if (openMenus.indexOf(menu) !== -1) {
	                    // menu is already open, the click closes it
	                    // except if a submenu is open
	                    if (menu.isChildActive(scope.path)) {
	                        return;
	                    }
	                    openMenus.splice(openMenus.indexOf(menu), 1);
	                    closeMenu(menu);
	                } else {
	                    // menu is closed, the click opens it
	                    openMenus.push(menu);
	                    openMenu(menu);
	                }
	                // we don't render() in that case because it would cut the animation
	                return;
	            };
	            scope.activateLink = function (menu) {
	                if (!menu.link()) {
	                    return;
	                }
	                // close all open menus
	                // no need to close the menus with animation using closeMenu(),
	                // the menu will rerender anyway because of the listener on $locationChangeSuccess
	                // so the animation don't work in that case
	                if (menu.autoClose()) {
	                    openMenus = [];
	                }
	            };
	            scope.isOpen = function (menu) {
	                return menu.isChildActive(scope.path) || openMenus.indexOf(menu) !== -1;
	            };
	            render();
	
	            function render() {
	                element.html(_menuBar2.default);
	                $compile(element.contents())(scope);
	            }
	            function closeMenu(menu) {
	                var elements = getElementsForMenu(menu);
	                elements.ul.addClass('collapsed');
	                elements.arrow.removeClass('glyphicon-menu-down');
	                elements.arrow.addClass('glyphicon-menu-right');
	            }
	            function openMenu(menu) {
	                var elements = getElementsForMenu(menu);
	                elements.ul.removeClass('collapsed');
	                elements.arrow.removeClass('glyphicon-menu-right');
	                elements.arrow.addClass('glyphicon-menu-down');
	            }
	            function getElementsForMenu(menu) {
	                var parentLi;
	                _angular2.default.forEach(element.find('li'), function (li) {
	                    var liElement = _angular2.default.element(li);
	                    if (liElement.attr('data-menu-id') == menu.uuid) {
	                        parentLi = liElement;
	                    }
	                });
	                return {
	                    arrow: _angular2.default.element(parentLi.find('a')[0].getElementsByClassName('arrow')[0]),
	                    ul: parentLi.find('ul').eq(0)
	                };
	            }
	        }
	    };
	}
	
	maMenuBar.$inject = ['$location', '$rootScope', '$compile'];
	module.exports = exports['default'];
	//# sourceMappingURL=maMenuBar.js.map

/***/ },
/* 344 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = OrderElement;
	function OrderElement() {
	    return function (input) {
	        var results = [],
	            objectKey;
	
	        for (objectKey in input) {
	            results.push(input[objectKey]);
	        }
	
	        results.sort(function (field1, field2) {
	            return typeof field1.order === 'function' ? field1.order() - field2.order() : field1.order - field2.order;
	        });
	
	        return results;
	    };
	}
	
	OrderElement.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=OrderElement.js.map

/***/ },
/* 345 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stripTags;
	function stripTags() {
	    return function (input) {
	        return input.replace(/(<([^>]+)>)/ig, '');
	    };
	}
	
	stripTags.$inject = [];
	module.exports = exports['default'];
	//# sourceMappingURL=StripTags.js.map

/***/ },
/* 346 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var HttpErrorService = function HttpErrorService($state, $translate, notification) {
	    return {
	        handleError: function handleError(event, toState, toParams, fromState, fromParams, error) {
	            switch (error.status) {
	                case 404:
	                    this.handle404Error(event, error);
	                    break;
	                case 403:
	                    this.handle403Error(error);
	                    break;
	                default:
	                    this.handleDefaultError(error);
	                    break;
	            }
	        },
	
	        handle404Error: function handle404Error(event) {
	            event.preventDefault();
	            $state.go('ma-404');
	        },
	
	        handle403Error: function handle403Error(error) {
	            $translate('STATE_FORBIDDEN_ERROR', { message: error.data.message }).then(this.displayError);
	            throw error;
	        },
	
	        handleDefaultError: function handleDefaultError(error) {
	            $translate('STATE_CHANGE_ERROR', { message: error.data.message }).then(this.displayError);
	            throw error;
	        },
	
	        displayError: function displayError(text) {
	            return notification.log(text, { addnCls: 'humane-flatty-error' });
	        }
	    };
	};
	
	HttpErrorService.$inject = ['$state', '$translate', 'notification'];
	
	exports.default = { $get: HttpErrorService };
	module.exports = exports['default'];
	//# sourceMappingURL=HttpErrorService.js.map

/***/ },
/* 347 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var NgAdminConfiguration = function () {
	    function NgAdminConfiguration($compileProvider) {
	        _classCallCheck(this, NgAdminConfiguration);
	
	        this.config = null;
	        this.adminDescription = null;
	        this.$compileProvider = $compileProvider;
	    }
	
	    _createClass(NgAdminConfiguration, [{
	        key: 'setAdminDescription',
	        value: function setAdminDescription(adminDescription) {
	            this.adminDescription = adminDescription;
	        }
	    }, {
	        key: 'configure',
	        value: function configure(config) {
	            this.config = config;
	
	            this.$compileProvider.debugInfoEnabled(this.config.debug());
	        }
	    }, {
	        key: '$get',
	        value: function $get() {
	            var config = this.config;
	            return function () {
	                return config;
	            };
	        }
	    }, {
	        key: 'application',
	        value: function application(name, debug) {
	            return this.adminDescription.application(name, debug);
	        }
	    }, {
	        key: 'entity',
	        value: function entity(name) {
	            return this.adminDescription.entity(name);
	        }
	    }, {
	        key: 'field',
	        value: function field(name, type) {
	            return this.adminDescription.field(name, type);
	        }
	    }, {
	        key: 'registerFieldType',
	        value: function registerFieldType(name, type) {
	            return this.adminDescription.registerFieldType(name, type);
	        }
	    }, {
	        key: 'getFieldConstructor',
	        value: function getFieldConstructor(name) {
	            return this.adminDescription.getFieldConstructor(name);
	        }
	    }, {
	        key: 'menu',
	        value: function menu(entity) {
	            return this.adminDescription.menu(entity);
	        }
	    }, {
	        key: 'collection',
	        value: function collection(_collection) {
	            return this.adminDescription.collection(_collection);
	        }
	    }, {
	        key: 'dashboard',
	        value: function dashboard(_dashboard) {
	            return this.adminDescription.dashboard(_dashboard);
	        }
	    }]);
	
	    return NgAdminConfiguration;
	}();
	
	exports.default = NgAdminConfiguration;
	
	NgAdminConfiguration.$inject = ['$compileProvider'];
	module.exports = exports['default'];
	//# sourceMappingURL=NgAdminConfiguration.js.map

/***/ },
/* 348 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = http;
	function http($httpProvider) {
	    $httpProvider.useApplyAsync(true);
	}
	
	http.$inject = ['$httpProvider'];
	module.exports = exports['default'];
	//# sourceMappingURL=http.js.map

/***/ },
/* 349 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var location = function location($locationProvider) {
	    // Keep the start of all routes to #/ instead of #!/
	    // while updating to Angular 1.6
	    // @see https://docs.angularjs.org/guide/migration#commit-aa077e8
	    $locationProvider.hashPrefix('');
	};
	
	location.$inject = ['$locationProvider'];
	
	exports.default = location;
	module.exports = exports['default'];
	//# sourceMappingURL=location.js.map

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _layout = __webpack_require__(430);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _dashboard = __webpack_require__(429);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _ = __webpack_require__(428);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function dataStoreProvider() {
	    return ['AdminDescription', function (AdminDescription) {
	        return AdminDescription.getDataStore();
	    }];
	}
	
	function entryConstructorProvider() {
	    return ['AdminDescription', function (AdminDescription) {
	        return AdminDescription.getEntryConstructor();
	    }];
	}
	
	function routing($stateProvider, $urlRouterProvider) {
	
	    $stateProvider.state('ng-admin', {
	        abstract: true,
	        views: {
	            'ng-admin': {
	                controller: 'AppController',
	                controllerAs: 'appController',
	                templateProvider: ['NgAdminConfiguration', function (Configuration) {
	                    return Configuration().layout() || _layout2.default;
	                }]
	            }
	        }
	    });
	
	    $stateProvider.state('dashboard', {
	        parent: 'ng-admin',
	        url: '/dashboard?sortField&sortDir',
	        params: {
	            sortField: null,
	            sortDir: null
	        },
	        controller: 'DashboardController',
	        controllerAs: 'dashboardController',
	        templateProvider: ['NgAdminConfiguration', function (Configuration) {
	            return Configuration().dashboard().template() || _dashboard2.default;
	        }],
	        resolve: {
	            dataStore: dataStoreProvider(),
	            Entry: entryConstructorProvider(),
	            hasEntities: ['NgAdminConfiguration', function (Configuration) {
	                return Configuration().entities.length > 0;
	            }],
	            collections: ['NgAdminConfiguration', function (Configuration) {
	                return Configuration().dashboard().collections();
	            }],
	            responses: ['$stateParams', '$q', 'collections', 'dataStore', 'Entry', 'ReadQueries', function ($stateParams, $q, collections, dataStore, Entry, ReadQueries) {
	                var sortField = 'sortField' in $stateParams ? $stateParams.sortField : null;
	                var sortDir = 'sortDir' in $stateParams ? $stateParams.sortDir : null;
	
	                var promises = {},
	                    collection,
	                    collectionSortField,
	                    collectionSortDir,
	                    collectionName;
	
	                for (collectionName in collections) {
	                    collection = collections[collectionName];
	                    collectionSortField = collection.getSortFieldName();
	                    collectionSortDir = collection.sortDir();
	                    if (sortField && sortField.split('.')[0] === collection.name()) {
	                        collectionSortField = sortField;
	                        collectionSortDir = sortDir;
	                    }
	                    promises[collectionName] = function (collection, collectionSortField, collectionSortDir) {
	                        var rawEntries;
	
	                        return ReadQueries.getAll(collection, 1, {}, collectionSortField, collectionSortDir).then(function (response) {
	                            rawEntries = response.data;
	                            return rawEntries;
	                        }).then(function (rawEntries) {
	                            return ReadQueries.getReferenceData(collection.fields(), rawEntries);
	                        }).then(function (referenceData) {
	                            var references = collection.getReferences();
	                            for (var name in referenceData) {
	                                Entry.createArrayFromRest(referenceData[name], [references[name].targetField()], references[name].targetEntity().name(), references[name].targetEntity().identifier().name()).map(function (entry) {
	                                    return dataStore.addEntry(references[name].targetEntity().uniqueId + '_values', entry);
	                                });
	                            }
	                        }).then(function () {
	                            var entries = collection.mapEntries(rawEntries);
	
	                            // shortcut to display collection of entry with included referenced values
	                            dataStore.fillReferencesValuesFromCollection(entries, collection.getReferences(), true);
	
	                            return entries;
	                        });
	                    }(collection, collectionSortField, collectionSortDir);
	                }
	
	                return $q.all(promises);
	            }],
	            entries: ['responses', 'collections', function (responses, collections) {
	                var collectionName,
	                    entries = {};
	
	                for (collectionName in responses) {
	                    entries[collections[collectionName].name()] = responses[collectionName];
	                }
	
	                return entries;
	            }]
	        }
	    });
	
	    $stateProvider.state('ma-404', {
	        parent: 'ng-admin',
	        template: _2.default
	    });
	
	    $urlRouterProvider.when('', '/dashboard');
	
	    $urlRouterProvider.otherwise(function ($injector, $location) {
	        var state = $injector.get('$state');
	        state.go('ma-404');
	        return $location.path();
	    });
	}
	
	routing.$inject = ['$stateProvider', '$urlRouterProvider'];
	
	exports.default = routing;
	module.exports = exports['default'];
	//# sourceMappingURL=routing.js.map

/***/ },
/* 351 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = translate;
	function translate($translateProvider) {
	  $translateProvider.translations('en', {
	    'BACK': 'Back',
	    'DELETE': 'Delete',
	    'CREATE': 'Create',
	    'EDIT': 'Edit',
	    'EXPORT': 'Export',
	    'ADD_FILTER': 'Add filter',
	    'SEE_RELATED': 'See all related {{ entityName }}',
	    'LIST': 'List',
	    'SHOW': 'Show',
	    'SAVE': 'Save',
	    'N_SELECTED': '{{ length }} Selected',
	    'ARE_YOU_SURE': 'Are you sure?',
	    'YES': 'Yes',
	    'NO': 'No',
	    'FILTER_VALUES': 'Filter values',
	    'CLOSE': 'Close',
	    'CLEAR': 'Clear',
	    'CURRENT': 'Current',
	    'REMOVE': 'Remove',
	    'ADD_NEW': 'Add new {{ name }}',
	    'BROWSE': 'Browse',
	    'N_COMPLETE': '{{ progress }}% Complete',
	    'CREATE_NEW': 'Create new',
	    'SUBMIT': 'Submit',
	    'SAVE_CHANGES': 'Save changes',
	    'BATCH_DELETE_SUCCESS': 'Elements successfully deleted',
	    'DELETE_SUCCESS': 'Element successfully deleted',
	    'ERROR_MESSAGE': 'Oops, an error occurred (code: {{ status }})',
	    'INVALID_FORM': 'Invalid form',
	    'CREATION_SUCCESS': 'Element successfully created',
	    'EDITION_SUCCESS': 'Changes successfully saved',
	    'ACTIONS': 'Actions',
	    'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>',
	    'NO_PAGINATION': 'No record found',
	    'PREVIOUS': '« Prev',
	    'NEXT': 'Next »',
	    'DETAIL': 'Detail',
	    'STATE_CHANGE_ERROR': 'State change error: {{ message }}',
	    'STATE_FORBIDDEN_ERROR': 'A server 403 error occured: {{ message }}',
	    'NOT_FOUND': 'Not Found',
	    'NOT_FOUND_DETAILS': 'The page you are looking for cannot be found. Take a break before trying again.'
	  });
	  $translateProvider.preferredLanguage('en');
	  $translateProvider.useSanitizeValueStrategy(null);
	}
	
	translate.$inject = ['$translateProvider'];
	module.exports = exports['default'];
	//# sourceMappingURL=translate.js.map

/***/ },
/* 352 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = HttpErrorHandler;
	function HttpErrorHandler($rootScope, HttpErrorService) {
	    $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error) {
	        HttpErrorService.handleError(event, toState, toParams, fromState, fromParams, error);
	    });
	}
	
	HttpErrorHandler.$inject = ['$rootScope', 'HttpErrorService'];
	module.exports = exports['default'];
	//# sourceMappingURL=HttpErrorHandler.js.map

/***/ },
/* 353 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = loader;
	/**
	 * Display loader on each route change
	 *
	 * @param {$rootScope}  $rootScope
	 * @param {$window}     $window
	 * @param {progression} progression
	 */
	function loader($rootScope, $window, progression) {
	    $rootScope.$on('$stateChangeStart', function () {
	        progression.start();
	    });
	
	    $rootScope.$on('$stateChangeSuccess', function () {
	        progression.done();
	        $window.scrollTo(0, 0);
	    });
	
	    $rootScope.$on("$stateChangeError", function () {
	        progression.done();
	    });
	}
	
	loader.$inject = ['$rootScope', '$window', 'progression'];
	module.exports = exports['default'];
	//# sourceMappingURL=Loader.js.map

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	global.rangy = __webpack_require__(116);
	global.rangy = __webpack_require__(387);
	global.numeral = __webpack_require__(14);
	
	__webpack_require__(5);
	__webpack_require__(19);
	__webpack_require__(384);
	__webpack_require__(393);
	__webpack_require__(224);
	
	__webpack_require__(223);
	__webpack_require__(225);
	__webpack_require__(383);
	
	global._ = __webpack_require__(245);
	//# sourceMappingURL=vendors.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var _MenuMenu = __webpack_require__(111);
	
	var _MenuMenu2 = _interopRequireDefault(_MenuMenu);
	
	var _Collection = __webpack_require__(106);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _Dashboard = __webpack_require__(107);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _UtilsOrderElement = __webpack_require__(114);
	
	var _UtilsOrderElement2 = _interopRequireDefault(_UtilsOrderElement);
	
	var Application = function () {
	    function Application() {
	        var title = arguments.length <= 0 || arguments[0] === undefined ? 'ng-admin' : arguments[0];
	        var debug = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	        _classCallCheck(this, Application);
	
	        this._baseApiUrl = '';
	        this._customTemplate = function (viewName) {};
	        this._title = title;
	        this._menu = null;
	        this._dashboard = null;
	        this._layout = false;
	        this._header = false;
	        this._entities = [];
	        this._errorMessage = this.defaultErrorMessage;
	        this._debug = debug;
	    }
	
	    _createClass(Application, [{
	        key: 'defaultErrorMessage',
	        value: function defaultErrorMessage(response) {
	            var body = response.data;
	
	            if ((typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object') {
	                body = JSON.stringify(body);
	            }
	
	            return 'Oops, an error occured : (code: ' + response.status + ') ' + body;
	        }
	    }, {
	        key: 'getViewsOfType',
	        value: function getViewsOfType(type) {
	            return _UtilsOrderElement2['default'].order(this.entities.map(function (entity) {
	                return entity.views[type];
	            }).filter(function (view) {
	                return view.enabled;
	            }));
	        }
	    }, {
	        key: 'getRouteFor',
	        value: function getRouteFor(entity, viewUrl, viewType, identifierValue, identifierName) {
	            var baseApiUrl = entity.baseApiUrl() || this.baseApiUrl(),
	                url = viewUrl || entity.getUrl(viewType, identifierValue, identifierName);
	
	            // If the view or the entity don't define the url, retrieve it from the baseURL of the entity or the app
	            if (!url) {
	                url = baseApiUrl + encodeURIComponent(entity.name());
	                if (identifierValue != null) {
	                    url += '/' + encodeURIComponent(identifierValue);
	                }
	            } else if (!/^(?:[a-z]+:)?\/\//.test(url)) {
	                // Add baseUrl for relative URL
	                url = baseApiUrl + url;
	            }
	
	            return url;
	        }
	    }, {
	        key: 'debug',
	        value: function debug(_debug) {
	            if (!arguments.length) return this._debug;
	            this._debug = _debug;
	            return this;
	        }
	    }, {
	        key: 'layout',
	        value: function layout(_layout) {
	            if (!arguments.length) return this._layout;
	            this._layout = _layout;
	            return this;
	        }
	    }, {
	        key: 'header',
	        value: function header(_header) {
	            if (!arguments.length) return this._header;
	            this._header = _header;
	            return this;
	        }
	    }, {
	        key: 'title',
	        value: function title(_title) {
	            if (!arguments.length) return this._title;
	            this._title = _title;
	            return this;
	        }
	
	        /**
	         * Getter/Setter for the main application menu
	         *
	         * If the getter is called first, it will return a menu based on entities.
	         *
	         *     application.addEntity(new Entity('posts'));
	         *     application.addEntity(new Entity('comments'));
	         *     application.menu(); // Menu { children: [ Menu { title: "Posts" }, Menu { title: "Comments" } ]}
	         *
	         * If the setter is called first, all subsequent calls to the getter will return the set menu.
	         *
	         *     application.addEntity(new Entity('posts'));
	         *     application.addEntity(new Entity('comments'));
	         *     application.menu(new Menu().addChild(new Menu().title('Foo')));
	         *     application.menu(); // Menu { children: [ Menu { title: "Foo" } ]}
	         *
	         * @see Menu
	         */
	    }, {
	        key: 'menu',
	        value: function menu(_menu) {
	            if (!arguments.length) {
	                if (!this._menu) {
	                    this._menu = this.buildMenuFromEntities();
	                }
	                return this._menu;
	            }
	
	            this._menu = _menu;
	            return this;
	        }
	    }, {
	        key: 'buildMenuFromEntities',
	        value: function buildMenuFromEntities() {
	            return new _MenuMenu2['default']().children(this.entities.filter(function (entity) {
	                return entity.menuView().enabled;
	            }).sort(function (e1, e2) {
	                return e1.menuView().order() - e2.menuView().order();
	            }).map(function (entity) {
	                return new _MenuMenu2['default']().populateFromEntity(entity);
	            }));
	        }
	    }, {
	        key: 'dashboard',
	        value: function dashboard(_dashboard) {
	            if (!arguments.length) {
	                if (!this._dashboard) {
	                    this._dashboard = this.buildDashboardFromEntities();
	                }
	                return this._dashboard;
	            }
	            this._dashboard = _dashboard;
	            return this;
	        }
	    }, {
	        key: 'buildDashboardFromEntities',
	        value: function buildDashboardFromEntities() {
	            var dashboard = new _Dashboard2['default']();
	            this.entities.filter(function (entity) {
	                return entity.dashboardView().enabled;
	            }).map(function (entity) {
	                dashboard.addCollection(entity.dashboardView()); // yep, a collection is a ListView, and so is a DashboardView - forgive this duck typing for BC sake
	            });
	            if (!dashboard.hasCollections()) {
	                // still no collection from dashboardViews, let's use listViews instead
	                this.entities.filter(function (entity) {
	                    return entity.listView().enabled;
	                }).map(function (entity, index) {
	                    var collection = new _Collection2['default']();
	                    var listView = entity.listView();
	                    collection.setEntity(entity);
	                    collection.perPage(listView.perPage());
	                    collection.sortField(listView.sortField());
	                    collection.sortDir(listView.sortDir());
	                    collection.order(index);
	                    // use only the first 3 cols
	                    collection.fields(listView.fields().filter(function (el, index) {
	                        return index < 3;
	                    }));
	                    dashboard.addCollection(collection);
	                });
	            }
	            return dashboard;
	        }
	    }, {
	        key: 'customTemplate',
	        value: function customTemplate(_customTemplate) {
	            if (!arguments.length) return this._customTemplate;
	            this._customTemplate = _customTemplate;
	            return this;
	        }
	    }, {
	        key: 'baseApiUrl',
	        value: function baseApiUrl(url) {
	            if (!arguments.length) return this._baseApiUrl;
	            this._baseApiUrl = url;
	            return this;
	        }
	    }, {
	        key: 'addEntity',
	        value: function addEntity(entity) {
	            if (!entity) {
	                throw new Error("No entity given");
	            }
	
	            this._entities.push(entity);
	
	            return this;
	        }
	    }, {
	        key: 'getEntity',
	        value: function getEntity(entityName) {
	            var foundEntity = this._entities.filter(function (e) {
	                return e.name() === entityName;
	            })[0];
	            if (!foundEntity) {
	                throw new Error('Unable to find entity "' + entityName + '"');
	            }
	
	            return foundEntity;
	        }
	    }, {
	        key: 'hasEntity',
	        value: function hasEntity(fieldName) {
	            return !!this._entities.filter(function (f) {
	                return f.name() === fieldName;
	            }).length;
	        }
	    }, {
	        key: 'getViewByEntityAndType',
	        value: function getViewByEntityAndType(entityName, type) {
	            return this._entities.filter(function (e) {
	                return e.name() === entityName;
	            })[0].views[type];
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: 'errorMessage',
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: 'getErrorMessageFor',
	        value: function getErrorMessageFor(view, response) {
	            return view.getErrorMessage(response) || view.getEntity().getErrorMessage(response) || this.getErrorMessage(response);
	        }
	    }, {
	        key: 'getEntityNames',
	        value: function getEntityNames() {
	            return this.entities.map(function (f) {
	                return f.name();
	            });
	        }
	    }, {
	        key: 'entities',
	        get: function get() {
	            return this._entities;
	        }
	    }]);
	
	    return Application;
	}();
	
	exports['default'] = Application;
	module.exports = exports['default'];
	//# sourceMappingURL=Application.js.map

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	var _Application = __webpack_require__(355);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _EntityEntity = __webpack_require__(10);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	var _DataStoreDataStore = __webpack_require__(108);
	
	var _DataStoreDataStore2 = _interopRequireDefault(_DataStoreDataStore);
	
	var _UtilsPromisesResolver = __webpack_require__(373);
	
	var _UtilsPromisesResolver2 = _interopRequireDefault(_UtilsPromisesResolver);
	
	var _QueriesReadQueries = __webpack_require__(371);
	
	var _QueriesReadQueries2 = _interopRequireDefault(_QueriesReadQueries);
	
	var _QueriesWriteQueries = __webpack_require__(372);
	
	var _QueriesWriteQueries2 = _interopRequireDefault(_QueriesWriteQueries);
	
	var _FieldField = __webpack_require__(2);
	
	var _FieldField2 = _interopRequireDefault(_FieldField);
	
	var _FieldBooleanField = __webpack_require__(357);
	
	var _FieldBooleanField2 = _interopRequireDefault(_FieldBooleanField);
	
	var _FieldChoiceField = __webpack_require__(11);
	
	var _FieldChoiceField2 = _interopRequireDefault(_FieldChoiceField);
	
	var _FieldChoicesField = __webpack_require__(358);
	
	var _FieldChoicesField2 = _interopRequireDefault(_FieldChoicesField);
	
	var _FieldDateField = __webpack_require__(109);
	
	var _FieldDateField2 = _interopRequireDefault(_FieldDateField);
	
	var _FieldDateTimeField = __webpack_require__(359);
	
	var _FieldDateTimeField2 = _interopRequireDefault(_FieldDateTimeField);
	
	var _FieldEmailField = __webpack_require__(360);
	
	var _FieldEmailField2 = _interopRequireDefault(_FieldEmailField);
	
	var _FieldEmbeddedListField = __webpack_require__(361);
	
	var _FieldEmbeddedListField2 = _interopRequireDefault(_FieldEmbeddedListField);
	
	var _FieldFloatFieldJs = __webpack_require__(363);
	
	var _FieldFloatFieldJs2 = _interopRequireDefault(_FieldFloatFieldJs);
	
	var _FieldFileField = __webpack_require__(362);
	
	var _FieldFileField2 = _interopRequireDefault(_FieldFileField);
	
	var _FieldJsonField = __webpack_require__(364);
	
	var _FieldJsonField2 = _interopRequireDefault(_FieldJsonField);
	
	var _FieldNumberField = __webpack_require__(110);
	
	var _FieldNumberField2 = _interopRequireDefault(_FieldNumberField);
	
	var _FieldPasswordField = __webpack_require__(365);
	
	var _FieldPasswordField2 = _interopRequireDefault(_FieldPasswordField);
	
	var _FieldReferenceField = __webpack_require__(12);
	
	var _FieldReferenceField2 = _interopRequireDefault(_FieldReferenceField);
	
	var _FieldReferencedListField = __webpack_require__(367);
	
	var _FieldReferencedListField2 = _interopRequireDefault(_FieldReferencedListField);
	
	var _FieldReferenceManyField = __webpack_require__(366);
	
	var _FieldReferenceManyField2 = _interopRequireDefault(_FieldReferenceManyField);
	
	var _FieldTemplateField = __webpack_require__(368);
	
	var _FieldTemplateField2 = _interopRequireDefault(_FieldTemplateField);
	
	var _FieldTextField = __webpack_require__(369);
	
	var _FieldTextField2 = _interopRequireDefault(_FieldTextField);
	
	var _FieldWysiwygField = __webpack_require__(370);
	
	var _FieldWysiwygField2 = _interopRequireDefault(_FieldWysiwygField);
	
	var _MenuMenu = __webpack_require__(111);
	
	var _MenuMenu2 = _interopRequireDefault(_MenuMenu);
	
	var _Collection = __webpack_require__(106);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _Dashboard = __webpack_require__(107);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Entry = __webpack_require__(6);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	var Factory = function () {
	    function Factory() {
	        _classCallCheck(this, Factory);
	
	        this._fieldTypes = [];
	        this._init();
	    }
	
	    _createClass(Factory, [{
	        key: "application",
	        value: function application(name, debug) {
	            return new _Application2["default"](name, debug);
	        }
	    }, {
	        key: "entity",
	        value: function entity(name) {
	            return new _EntityEntity2["default"](name);
	        }
	    }, {
	        key: "field",
	        value: function field(name, type) {
	            type = type || 'string';
	
	            if (!(type in this._fieldTypes)) {
	                throw new Error("Unknown field type \"" + type + "\".");
	            }
	
	            return new this._fieldTypes[type](name);
	        }
	    }, {
	        key: "registerFieldType",
	        value: function registerFieldType(name, constructor) {
	            this._fieldTypes[name] = constructor;
	        }
	    }, {
	        key: "getFieldConstructor",
	        value: function getFieldConstructor(name) {
	            return this._fieldTypes[name];
	        }
	    }, {
	        key: "menu",
	        value: function menu(entity) {
	            var menu = new _MenuMenu2["default"]();
	            if (entity) {
	                menu.populateFromEntity(entity);
	            }
	            return menu;
	        }
	    }, {
	        key: "dashboard",
	        value: function dashboard() {
	            return new _Dashboard2["default"]();
	        }
	    }, {
	        key: "collection",
	        value: function collection(entity) {
	            var collection = new _Collection2["default"]();
	            if (entity) {
	                collection.setEntity(entity);
	            }
	            return collection;
	        }
	    }, {
	        key: "getEntryConstructor",
	        value: function getEntryConstructor() {
	            return _Entry2["default"];
	        }
	    }, {
	        key: "getDataStore",
	        value: function getDataStore() {
	            return new _DataStoreDataStore2["default"]();
	        }
	    }, {
	        key: "getReadQueries",
	        value: function getReadQueries(RestWrapper, PromisesResolver, Application) {
	            return new _QueriesReadQueries2["default"](RestWrapper, PromisesResolver, Application);
	        }
	    }, {
	        key: "getWriteQueries",
	        value: function getWriteQueries(RestWrapper, PromisesResolver, Application) {
	            return new _QueriesWriteQueries2["default"](RestWrapper, PromisesResolver, Application);
	        }
	    }, {
	        key: "getPromisesResolver",
	        value: function getPromisesResolver() {
	            return _UtilsPromisesResolver2["default"];
	        }
	    }, {
	        key: "_init",
	        value: function _init() {
	            this.registerFieldType('boolean', _FieldBooleanField2["default"]);
	            this.registerFieldType('choice', _FieldChoiceField2["default"]);
	            this.registerFieldType('choices', _FieldChoicesField2["default"]);
	            this.registerFieldType('date', _FieldDateField2["default"]);
	            this.registerFieldType('datetime', _FieldDateTimeField2["default"]);
	            this.registerFieldType('email', _FieldEmailField2["default"]);
	            this.registerFieldType('embedded_list', _FieldEmbeddedListField2["default"]);
	            this.registerFieldType('float', _FieldFloatFieldJs2["default"]);
	            this.registerFieldType('string', _FieldField2["default"]);
	            this.registerFieldType('file', _FieldFileField2["default"]);
	            this.registerFieldType('json', _FieldJsonField2["default"]);
	            this.registerFieldType('number', _FieldNumberField2["default"]);
	            this.registerFieldType('password', _FieldPasswordField2["default"]);
	            this.registerFieldType('reference', _FieldReferenceField2["default"]);
	            this.registerFieldType('reference_many', _FieldReferenceManyField2["default"]);
	            this.registerFieldType('referenced_list', _FieldReferencedListField2["default"]);
	            this.registerFieldType('template', _FieldTemplateField2["default"]);
	            this.registerFieldType('text', _FieldTextField2["default"]);
	            this.registerFieldType('wysiwyg', _FieldWysiwygField2["default"]);
	        }
	    }]);
	
	    return Factory;
	}();
	
	exports["default"] = Factory;
	module.exports = exports["default"];
	//# sourceMappingURL=Factory.js.map

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _ChoiceField2 = __webpack_require__(11);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var BooleanField = function (_ChoiceField) {
	    _inherits(BooleanField, _ChoiceField);
	
	    function BooleanField(name) {
	        _classCallCheck(this, BooleanField);
	
	        _get(Object.getPrototypeOf(BooleanField.prototype), "constructor", this).call(this, name);
	        this._type = "boolean";
	        this._choices = [{ value: null, label: 'undefined' }, { value: true, label: 'true' }, { value: false, label: 'false' }];
	        this._filterChoices = [{ value: true, label: 'true' }, { value: false, label: 'false' }];
	    }
	
	    _createClass(BooleanField, [{
	        key: "filterChoices",
	        value: function filterChoices(_filterChoices) {
	            if (!arguments.length) return this._filterChoices;
	            this._filterChoices = _filterChoices;
	
	            return this;
	        }
	    }]);
	
	    return BooleanField;
	}(_ChoiceField3["default"]);
	
	exports["default"] = BooleanField;
	module.exports = exports["default"];
	//# sourceMappingURL=BooleanField.js.map

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _ChoiceField2 = __webpack_require__(11);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var ChoicesField = function (_ChoiceField) {
	    _inherits(ChoicesField, _ChoiceField);
	
	    function ChoicesField(name) {
	        _classCallCheck(this, ChoicesField);
	
	        _get(Object.getPrototypeOf(ChoicesField.prototype), "constructor", this).call(this, name);
	        this._type = "choices";
	    }
	
	    return ChoicesField;
	}(_ChoiceField3["default"]);
	
	exports["default"] = ChoicesField;
	module.exports = exports["default"];
	//# sourceMappingURL=ChoicesField.js.map

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _DateField2 = __webpack_require__(109);
	
	var _DateField3 = _interopRequireDefault(_DateField2);
	
	var DateTimeField = function (_DateField) {
	    _inherits(DateTimeField, _DateField);
	
	    function DateTimeField(name) {
	        _classCallCheck(this, DateTimeField);
	
	        _get(Object.getPrototypeOf(DateTimeField.prototype), "constructor", this).call(this, name);
	
	        this._format = null;
	        this._parse = function (date) {
	            return date;
	        };
	
	        this._type = 'datetime';
	    }
	
	    return DateTimeField;
	}(_DateField3["default"]);
	
	exports["default"] = DateTimeField;
	module.exports = exports["default"];
	//# sourceMappingURL=DateTimeField.js.map

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var EmailField = function (_Field) {
	    _inherits(EmailField, _Field);
	
	    function EmailField(name) {
	        _classCallCheck(this, EmailField);
	
	        _get(Object.getPrototypeOf(EmailField.prototype), "constructor", this).call(this, name);
	        this._type = "email";
	    }
	
	    return EmailField;
	}(_Field3["default"]);
	
	exports["default"] = EmailField;
	module.exports = exports["default"];
	//# sourceMappingURL=EmailField.js.map

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var _EntityEntity = __webpack_require__(10);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	/**
	 * Map an embedded list in the entry
	 *
	 * @example
	 *
	 *     {
	 *        id: 123,
	 *        title: "hello, world",
	 *        comments: [
	 *          { date: "2015-09-30", author: "John Doe", body: "Lorem Ipsum" },
	 *          { date: "2015-10-02", author: "Jane Doe", body: "Sic dolor amet" }
	 *        ]
	 *     }
	 *
	 *     let commentsField = new EmbeddedListField('comments')
	 *        .targetFields([
	 *          new DateField('date'),
	 *          new StringField('author'),
	 *          new StringField('body')
	 *        ])
	 */
	
	var EmbeddedListField = function (_Field) {
	    _inherits(EmbeddedListField, _Field);
	
	    function EmbeddedListField(name) {
	        _classCallCheck(this, EmbeddedListField);
	
	        _get(Object.getPrototypeOf(EmbeddedListField.prototype), "constructor", this).call(this, name);
	        this._type = 'embedded_list';
	        this._flattenable = false;
	        this._targetEntity = new _EntityEntity2["default"](); // link to an empty entity by default
	        this._targetFields = [];
	        this._sortField = null;
	        this._sortDir = null;
	        this._permanentFilters = null;
	        this._listActions = [];
	    }
	
	    /**
	     * Optionally set the target Entity
	     *
	     * Useful if the embedded entries can be edited in standalone
	     */
	
	    _createClass(EmbeddedListField, [{
	        key: "targetEntity",
	        value: function targetEntity(entity) {
	            if (!arguments.length) {
	                return this._targetEntity;
	            }
	            this._targetEntity = entity;
	
	            return this;
	        }
	
	        /**
	         * List the fields to map in the embedded entries
	         *
	         * @example
	         *
	         *     embeddedListField.targetFields([
	         *       new DateField('date'),
	         *       new StringField('author'),
	         *       new StringField('body')
	         *     ])
	         */
	    }, {
	        key: "targetFields",
	        value: function targetFields(value) {
	            if (!arguments.length) return this._targetFields;
	            this._targetFields = value;
	
	            return this;
	        }
	
	        /**
	         * Name of the field used for sorting.
	         *
	         * @param string
	         */
	    }, {
	        key: "sortField",
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField ? this._sortField : this.targetEntity().identifier().name();
	        }
	
	        /**
	         * Direction used for sorting.
	         *
	         * @param String either 'ASC' or 'DESC'
	         */
	    }, {
	        key: "sortDir",
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: "listActions",
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     nga.field('post_id', 'reference').permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts/:id?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: "permanentFilters",
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	    }]);
	
	    return EmbeddedListField;
	}(_Field3["default"]);
	
	exports["default"] = EmbeddedListField;
	module.exports = exports["default"];
	//# sourceMappingURL=EmbeddedListField.js.map

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var FileField = function (_Field) {
	    _inherits(FileField, _Field);
	
	    function FileField(name) {
	        _classCallCheck(this, FileField);
	
	        _get(Object.getPrototypeOf(FileField.prototype), "constructor", this).call(this, name);
	        this._type = "file";
	        this._uploadInformation = {
	            url: '/upload',
	            accept: '*'
	        };
	    }
	
	    _createClass(FileField, [{
	        key: "uploadInformation",
	        value: function uploadInformation(information) {
	            if (!arguments.length) return this._uploadInformation;
	            this._uploadInformation = information;
	            return this;
	        }
	    }]);
	
	    return FileField;
	}(_Field3["default"]);
	
	exports["default"] = FileField;
	module.exports = exports["default"];
	//# sourceMappingURL=FileField.js.map

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _NumberField2 = __webpack_require__(110);
	
	var _NumberField3 = _interopRequireDefault(_NumberField2);
	
	var FloatField = function (_NumberField) {
	    _inherits(FloatField, _NumberField);
	
	    function FloatField(name) {
	        _classCallCheck(this, FloatField);
	
	        _get(Object.getPrototypeOf(FloatField.prototype), 'constructor', this).call(this, name);
	        this._type = 'float';
	        this._format = '0.000';
	    }
	
	    return FloatField;
	}(_NumberField3['default']);
	
	exports['default'] = FloatField;
	module.exports = exports['default'];
	//# sourceMappingURL=FloatField.js.map

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var JsonField = function (_Field) {
	    _inherits(JsonField, _Field);
	
	    function JsonField(name) {
	        _classCallCheck(this, JsonField);
	
	        _get(Object.getPrototypeOf(JsonField.prototype), "constructor", this).call(this, name);
	        this._type = "json";
	        this._flattenable = false;
	    }
	
	    return JsonField;
	}(_Field3["default"]);
	
	exports["default"] = JsonField;
	module.exports = exports["default"];
	//# sourceMappingURL=JsonField.js.map

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var PasswordField = function (_Field) {
	    _inherits(PasswordField, _Field);
	
	    function PasswordField(name) {
	        _classCallCheck(this, PasswordField);
	
	        _get(Object.getPrototypeOf(PasswordField.prototype), "constructor", this).call(this, name);
	        this._type = "password";
	    }
	
	    return PasswordField;
	}(_Field3["default"]);
	
	exports["default"] = PasswordField;
	module.exports = exports["default"];
	//# sourceMappingURL=PasswordField.js.map

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _ReferenceField2 = __webpack_require__(12);
	
	var _ReferenceField3 = _interopRequireDefault(_ReferenceField2);
	
	var ReferenceManyField = function (_ReferenceField) {
	    _inherits(ReferenceManyField, _ReferenceField);
	
	    function ReferenceManyField(name) {
	        _classCallCheck(this, ReferenceManyField);
	
	        _get(Object.getPrototypeOf(ReferenceManyField.prototype), "constructor", this).call(this, name);
	        this._type = 'reference_many';
	    }
	
	    return ReferenceManyField;
	}(_ReferenceField3["default"]);
	
	exports["default"] = ReferenceManyField;
	module.exports = exports["default"];
	//# sourceMappingURL=ReferenceManyField.js.map

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _ReferenceField2 = __webpack_require__(12);
	
	var _ReferenceField3 = _interopRequireDefault(_ReferenceField2);
	
	var _UtilsReferenceExtractor = __webpack_require__(13);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var ReferencedListField = function (_ReferenceField) {
	    _inherits(ReferencedListField, _ReferenceField);
	
	    function ReferencedListField(name) {
	        _classCallCheck(this, ReferencedListField);
	
	        _get(Object.getPrototypeOf(ReferencedListField.prototype), 'constructor', this).call(this, name);
	        this._type = 'referenced_list';
	        this._targetReferenceField = null;
	        this._targetFields = [];
	        this._detailLink = false;
	        this._listActions = [];
	        this._entryCssClasses = null;
	    }
	
	    _createClass(ReferencedListField, [{
	        key: 'targetReferenceField',
	        value: function targetReferenceField(value) {
	            if (!arguments.length) return this._targetReferenceField;
	            this._targetReferenceField = value;
	            return this;
	        }
	    }, {
	        key: 'targetFields',
	        value: function targetFields(value) {
	            if (!arguments.length) return this._targetFields;
	            this._targetFields = value;
	
	            return this;
	        }
	    }, {
	        key: 'getGridColumns',
	        value: function getGridColumns() {
	            var columns = [];
	            for (var i = 0, l = this._targetFields.length; i < l; i++) {
	                var field = this._targetFields[i];
	                columns.push({
	                    field: field,
	                    label: field.label()
	                });
	            }
	
	            return columns;
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            if (!this.sortField()) {
	                return null;
	            }
	
	            return this._targetEntity.name() + '_ListView.' + this.sortField();
	        }
	    }, {
	        key: 'listActions',
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'entryCssClasses',
	        value: function entryCssClasses(classes) {
	            if (!arguments.length) {
	                return this._entryCssClasses;
	            }
	
	            this._entryCssClasses = classes;
	
	            return this;
	        }
	    }, {
	        key: 'getReferences',
	        value: function getReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getReferences(this._targetFields, withRemoteComplete);
	        }
	    }, {
	        key: 'getNonOptimizedReferences',
	        value: function getNonOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getNonOptimizedReferences(this._targetFields, withRemoteComplete);
	        }
	    }, {
	        key: 'getOptimizedReferences',
	        value: function getOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getOptimizedReferences(this._targetFields, withRemoteComplete);
	        }
	    }]);
	
	    return ReferencedListField;
	}(_ReferenceField3['default']);
	
	exports['default'] = ReferencedListField;
	module.exports = exports['default'];
	//# sourceMappingURL=ReferencedListField.js.map

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var TemplateField = function (_Field) {
	    _inherits(TemplateField, _Field);
	
	    function TemplateField(name) {
	        _classCallCheck(this, TemplateField);
	
	        _get(Object.getPrototypeOf(TemplateField.prototype), "constructor", this).call(this, name);
	        this._type = "template";
	        this._flattenable = false;
	    }
	
	    return TemplateField;
	}(_Field3["default"]);
	
	exports["default"] = TemplateField;
	module.exports = exports["default"];
	//# sourceMappingURL=TemplateField.js.map

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var TextField = function (_Field) {
	    _inherits(TextField, _Field);
	
	    function TextField(name) {
	        _classCallCheck(this, TextField);
	
	        _get(Object.getPrototypeOf(TextField.prototype), "constructor", this).call(this, name);
	        this._type = "text";
	    }
	
	    return TextField;
	}(_Field3["default"]);
	
	exports["default"] = TextField;
	module.exports = exports["default"];
	//# sourceMappingURL=TextField.js.map

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ("value" in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Field2 = __webpack_require__(2);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var WysiwygField = function (_Field) {
	    _inherits(WysiwygField, _Field);
	
	    function WysiwygField(name) {
	        _classCallCheck(this, WysiwygField);
	
	        _get(Object.getPrototypeOf(WysiwygField.prototype), "constructor", this).call(this, name);
	        this._type = "wysiwyg";
	        this._stripTags = false;
	        this._sanitize = true;
	    }
	
	    _createClass(WysiwygField, [{
	        key: "stripTags",
	        value: function stripTags(value) {
	            if (!arguments.length) return this._stripTags;
	            this._stripTags = value;
	            return this;
	        }
	    }, {
	        key: "sanitize",
	        value: function sanitize(value) {
	            if (!arguments.length) return this._sanitize;
	            this._sanitize = value;
	            return this;
	        }
	    }]);
	
	    return WysiwygField;
	}(_Field3["default"]);
	
	exports["default"] = WysiwygField;
	module.exports = exports["default"];
	//# sourceMappingURL=WysiwygField.js.map

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Queries2 = __webpack_require__(112);
	
	var _Queries3 = _interopRequireDefault(_Queries2);
	
	var _UtilsReferenceExtractor = __webpack_require__(13);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var ReadQueries = function (_Queries) {
	    _inherits(ReadQueries, _Queries);
	
	    function ReadQueries() {
	        _classCallCheck(this, ReadQueries);
	
	        _get(Object.getPrototypeOf(ReadQueries.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ReadQueries, [{
	        key: 'getOne',
	
	        /**
	         * Get one entity
	         *
	         * @param {Entity}   entity
	         * @param {String}   viewType
	         * @param {mixed}    identifierValue
	         * @param {String}   identifierName
	         * @param {String}   url
	         *
	         * @returns {promise} (list of fields (with their values if set) & the entity name, label & id-
	         */
	        value: function getOne(entity, viewType, identifierValue, identifierName, url) {
	            return this._restWrapper.getOne(entity.name(), this._application.getRouteFor(entity, url, viewType, identifierValue, identifierName), entity.retrieveMethod());
	        }
	
	        /**
	         * Return the list of all object of entityName type
	         * Get all the object from the API
	         *
	         * @param {ListView} view                the view associated to the entity
	         * @param {Number}   page                the page number
	         * @param {Object}   filterValues        searchQuery to filter elements
	         * @param {String}   sortField           the field to be sorted ex: entity.fieldName
	         * @param {String}   sortDir             the direction of the sort
	         *
	         * @returns {promise} the entity config & the list of objects
	         */
	    }, {
	        key: 'getAll',
	        value: function getAll(view, page, filterValues, sortField, sortDir) {
	            page = page || 1;
	            filterValues = filterValues || {};
	            var url = view.getUrl();
	
	            if (sortField && sortField.split('.')[0] === view.name()) {
	                sortField = sortField;
	                sortDir = sortDir;
	            } else {
	                sortField = view.getSortFieldName();
	                sortDir = view.sortDir();
	            }
	
	            var allFilterValues = {};
	            var permanentFilters = view.permanentFilters();
	            Object.keys(filterValues).forEach(function (key) {
	                allFilterValues[key] = filterValues[key];
	            });
	            Object.keys(permanentFilters).forEach(function (key) {
	                allFilterValues[key] = permanentFilters[key];
	            });
	
	            return this.getRawValues(view.entity, view.name(), view.type, page, view.perPage(), allFilterValues, view.filters(), sortField, sortDir, url).then(function (values) {
	                return {
	                    data: values.data,
	                    totalItems: values.totalCount || values.headers('X-Total-Count') || values.data.length
	                };
	            });
	        }
	
	        /**
	         * Return the list of all object of entityName type
	         * Get all the object from the API
	         *
	         * @param {Entity}   entity
	         * @param {String}   viewName
	         * @param {String}   viewType
	         * @param {Number}   page
	         * @param {Number}   perPage
	         * @param {Object}   filterValues
	         * @param {Object}   filterFields
	         * @param {String}   sortField
	         * @param {String}   sortDir
	         * @param {String}   url
	         *
	         * @returns {promise} the entity config & the list of objects
	         */
	    }, {
	        key: 'getRawValues',
	        value: function getRawValues(entity, viewName, viewType, page, perPage, filterValues, filterFields, sortField, sortDir, url) {
	            var params = {};
	
	            // Compute pagination
	            if (page !== -1) {
	                params._page = typeof page === 'undefined' ? 1 : parseInt(page, 10);
	                params._perPage = perPage;
	            }
	
	            // Compute sorting
	            if (sortField && sortField.split('.')[0] === viewName) {
	                params._sortField = sortField.substr(sortField.indexOf('.') + 1);
	                params._sortDir = sortDir;
	            }
	
	            // Compute filtering
	            if (filterValues && Object.keys(filterValues).length !== 0) {
	                (function () {
	                    params._filters = {};
	                    var filterName = undefined,
	                        mappedValue = undefined;
	                    for (filterName in filterValues) {
	                        if (filterFields.hasOwnProperty(filterName) && filterFields[filterName].hasMaps()) {
	                            mappedValue = filterFields[filterName].getMappedValue(filterValues[filterName]);
	                            Object.keys(mappedValue).forEach(function (key) {
	                                params._filters[key] = mappedValue[key];
	                            });
	                            continue;
	                        }
	
	                        // It's weird to not map, but why not.
	                        params._filters[filterName] = filterValues[filterName];
	                    }
	                })();
	            }
	
	            // Get grid data
	            return this._restWrapper.getList(params, entity.name(), this._application.getRouteFor(entity, url, viewType), entity.retrieveMethod());
	        }
	    }, {
	        key: 'getReferenceData',
	        value: function getReferenceData(references, rawValues) {
	            var nonOptimizedReferencedData = this.getFilteredReferenceData(_UtilsReferenceExtractor2['default'].getNonOptimizedReferences(references), rawValues);
	            var optimizedReferencedData = this.getOptimizedReferenceData(_UtilsReferenceExtractor2['default'].getOptimizedReferences(references), rawValues);
	            return Promise.all([nonOptimizedReferencedData, optimizedReferencedData]).then(function (results) {
	                var data = {};
	                var name = undefined;
	                for (name in results[0]) {
	                    data[name] = results[0][name];
	                }
	                for (name in results[1]) {
	                    data[name] = results[1][name];
	                }
	                return data;
	            });
	        }
	
	        /**
	         * Returns all References for an entity with associated values [{targetEntity.identifier: targetLabel}, ...]
	         * by calling the API for each entries
	         *
	         * @param {ReferenceField} references A hash of Reference and ReferenceMany objects
	         * @param {Array} rawValues
	         *
	         * @returns {Promise}
	         */
	    }, {
	        key: 'getFilteredReferenceData',
	        value: function getFilteredReferenceData(references, rawValues) {
	            if (!references || !Object.keys(references).length) {
	                return this._promisesResolver.empty({});
	            }
	
	            var getOne = this.getOne.bind(this),
	                calls = [];
	
	            for (var i in references) {
	                var reference = references[i],
	                    targetEntity = reference.targetEntity(),
	                    identifiers = reference.getIdentifierValues(rawValues);
	
	                for (var k in identifiers) {
	                    calls.push(getOne(targetEntity, 'listView', identifiers[k], reference.name()));
	                }
	            }
	
	            return this.fillFilteredReferencedData(calls, references, rawValues);
	        }
	
	        /**
	         * Returns all References for an entity with associated values [{targetEntity.identifier: targetLabel}, ...]
	         * by calling the API once
	         *
	         * @param {[ReferenceField]} references A hash of Reference and ReferenceMany objects
	         * @param {Array} rawValues
	         *
	         * @returns {Promise}
	         */
	    }, {
	        key: 'getOptimizedReferenceData',
	        value: function getOptimizedReferenceData(references, rawValues) {
	            if (!references || !Object.keys(references).length) {
	                return this._promisesResolver.empty({});
	            }
	
	            var getRawValues = this.getRawValues.bind(this),
	                calls = [];
	
	            for (var i in references) {
	                var reference = references[i],
	                    targetEntity = reference.targetEntity(),
	                    identifiers = reference.getIdentifierValues(rawValues);
	
	                // Check if we should retrieve values with 1 or multiple requests
	                var singleCallFilters = reference.getSingleApiCall(identifiers);
	                calls.push(getRawValues(targetEntity, targetEntity.name() + '_ListView', 'listView', 1, reference.perPage(), singleCallFilters, {}, reference.sortField(), reference.sortDir()));
	            }
	
	            return this.fillOptimizedReferencedData(calls, references);
	        }
	
	        /**
	         * Returns all References for an entity with associated values [{targetEntity.identifier: targetLabel}, ...]
	         * without filters on an entity
	         *
	         * @param {[ReferenceField]} references A hash of Reference and ReferenceMany objects
	         *
	         * @returns {Promise}
	         */
	    }, {
	        key: 'getAllReferencedData',
	        value: function getAllReferencedData(references, search) {
	            if (!references || !Object.keys(references).length) {
	                return this._promisesResolver.empty({});
	            }
	
	            var calls = [],
	                getRawValues = this.getRawValues.bind(this);
	
	            var _loop = function _loop(i) {
	                var reference = references[i];
	                var targetEntity = reference.targetEntity();
	
	                var permanentFilters = reference.permanentFilters();
	                var filterValues = permanentFilters || {};
	
	                if (typeof permanentFilters === 'function') {
	                    console.warn('Reference.permanentFilters() called with a function is deprecated. Use the searchQuery option for remoteComplete() instead');
	                    filterValues = permanentFilters(search);
	                }
	
	                if (search) {
	                    // remote complete situation
	                    var options = reference.remoteCompleteOptions();
	                    if (options.searchQuery) {
	                        (function () {
	                            var filterValuesFromRemoteComplete = options.searchQuery(search);
	                            Object.keys(filterValuesFromRemoteComplete).forEach(function (key) {
	                                filterValues[key] = filterValuesFromRemoteComplete[key];
	                            });
	                        })();
	                    } else {
	                        // by default, filter the list by the referenceField name
	                        filterValues[reference.targetField().name()] = search;
	                    }
	                }
	
	                var filterFields = {};
	                filterFields[reference.name()] = reference;
	
	                calls.push(getRawValues(targetEntity, targetEntity.name() + '_ListView', 'listView', 1, reference.perPage(), filterValues, filterFields, reference.getSortFieldName(), reference.sortDir()));
	            };
	
	            for (var i in references) {
	                _loop(i);
	            }
	
	            return this.fillOptimizedReferencedData(calls, references);
	        }
	
	        /**
	         * Fill all reference entries to return [{targetEntity.identifier: targetLabel}, ...]
	         *
	         * @param {[Promise]} apiCalls
	         * @param {[Reference]} references
	         * @returns {Promise}
	         */
	    }, {
	        key: 'fillOptimizedReferencedData',
	        value: function fillOptimizedReferencedData(apiCalls, references) {
	            return this._promisesResolver.allEvenFailed(apiCalls).then(function (responses) {
	                if (responses.length === 0) {
	                    return {};
	                }
	
	                var referencedData = {},
	                    i = 0;
	
	                for (var j in references) {
	                    var reference = references[j],
	                        response = responses[i++];
	
	                    // Retrieve entries depending on 1 or many request was done
	                    if (response.status == 'error') {
	                        // the response failed
	                        continue;
	                    }
	
	                    referencedData[reference.name()] = response.result.data;
	                }
	
	                return referencedData;
	            });
	        }
	
	        /**
	         * Fill all reference entries to return [{targetEntity.identifier: targetLabel}, ...]
	         *
	         * @param {[Promise]} apiCalls
	         * @param {[Reference]} references
	         * @param {[Object]} rawValues
	         * @returns {Promise}
	         */
	    }, {
	        key: 'fillFilteredReferencedData',
	        value: function fillFilteredReferencedData(apiCalls, references, rawValues) {
	            return this._promisesResolver.allEvenFailed(apiCalls).then(function (responses) {
	                if (responses.length === 0) {
	                    return {};
	                }
	
	                var referencedData = {},
	                    response = undefined,
	                    i = 0;
	
	                for (var j in references) {
	                    var data = [],
	                        reference = references[j],
	                        identifiers = reference.getIdentifierValues(rawValues);
	
	                    for (var k in identifiers) {
	                        response = responses[i++];
	                        if (response.status == 'error') {
	                            // one of the responses failed
	                            continue;
	                        }
	                        data.push(response.result);
	                    }
	
	                    if (!data.length) {
	                        continue;
	                    }
	
	                    referencedData[reference.name()] = data;
	                }
	
	                return referencedData;
	            });
	        }
	
	        /**
	         * Returns all ReferencedList for an entity for associated values [{targetEntity.identifier: [targetFields, ...]}}
	         *
	         * @param {View}   referencedLists
	         * @param {String} sortField
	         * @param {String} sortDir
	         * @param {*} entityId
	         *
	         * @returns {promise}
	         */
	    }, {
	        key: 'getReferencedListData',
	        value: function getReferencedListData(referencedLists, sortField, sortDir, entityId) {
	            var getRawValues = this.getRawValues.bind(this),
	                calls = [];
	
	            var _loop2 = function _loop2(i) {
	                var referencedList = referencedLists[i],
	                    targetEntity = referencedList.targetEntity(),
	                    viewName = referencedList.datagridName(),
	                    currentSortField = referencedList.getSortFieldName(),
	                    currentSortDir = referencedList.sortDir(),
	                    filter = {};
	
	                if (sortField && sortField.split('.')[0] === viewName) {
	                    currentSortField = sortField;
	                    currentSortDir = sortDir || 'ASC';
	                }
	
	                var permanentFilters = referencedList.permanentFilters() || {};
	                Object.keys(permanentFilters).forEach(function (key) {
	                    filter[key] = permanentFilters[key];
	                });
	                filter[referencedList.targetReferenceField()] = entityId;
	
	                calls.push(getRawValues(targetEntity, viewName, 'listView', 1, referencedList.perPage(), filter, {}, currentSortField, currentSortDir));
	            };
	
	            for (var i in referencedLists) {
	                _loop2(i);
	            }
	
	            return this._promisesResolver.allEvenFailed(calls).then(function (responses) {
	                var j = 0,
	                    entries = {};
	
	                for (var i in referencedLists) {
	                    var response = responses[j++];
	                    if (response.status == 'error') {
	                        // If a response fail, skip it
	                        continue;
	                    }
	
	                    entries[i] = response.result.data;
	                }
	
	                return entries;
	            });
	        }
	    }, {
	        key: 'getRecordsByIds',
	        value: function getRecordsByIds(entity, ids) {
	            var _this = this;
	
	            if (!ids || !ids.length) {
	                return this._promisesResolver.empty();
	            }
	
	            var calls = ids.map(function (id) {
	                return _this.getOne(entity, 'listView', id, entity.identifier().name());
	            });
	
	            return this._promisesResolver.allEvenFailed(calls).then(function (responses) {
	                return responses.filter(function (r) {
	                    return r.status != 'error';
	                }).map(function (r) {
	                    return r.result;
	                });
	            });
	        }
	    }]);
	
	    return ReadQueries;
	}(_Queries3['default']);
	
	exports['default'] = ReadQueries;
	module.exports = exports['default'];
	//# sourceMappingURL=ReadQueries.js.map

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _Queries2 = __webpack_require__(112);
	
	var _Queries3 = _interopRequireDefault(_Queries2);
	
	var WriteQueries = function (_Queries) {
	    _inherits(WriteQueries, _Queries);
	
	    function WriteQueries() {
	        _classCallCheck(this, WriteQueries);
	
	        _get(Object.getPrototypeOf(WriteQueries.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(WriteQueries, [{
	        key: 'createOne',
	
	        /**
	         * Create a new entity
	         * Post the data to the API to create the new object
	         *
	         * @param {View}   view      the formView related to the entity
	         * @param {Object} rawEntity the entity's object
	         *
	         * @returns {promise}  the new object
	         */
	        value: function createOne(view, rawEntity) {
	            return this._restWrapper.createOne(rawEntity, view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(), view.type), view.entity.createMethod());
	        }
	
	        /**
	         * Update an entity
	         * Put the data to the API to create the new object
	         *
	         * @param {View}   view             the formView related to the entity
	         * @param {Object} rawEntity        the entity's object
	         * @param {String} originEntityId   if entity identifier is modified
	         *
	         * @returns {promise} the updated object
	         */
	    }, {
	        key: 'updateOne',
	        value: function updateOne(view, rawEntity, originEntityId) {
	            var entityId = originEntityId || rawEntity[view.entity.identifier().name()];
	
	            // Update element data
	            return this._restWrapper.updateOne(rawEntity, view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(entityId), view.type, entityId, view.identifier()), view.entity.updateMethod());
	        }
	
	        /**
	         * Delete an entity
	         * Delete the data to the API
	         *
	         * @param {String} view     the formView related to the entity
	         * @param {*}      entityId the entity's id
	         *
	         * @returns {promise}
	         */
	    }, {
	        key: 'deleteOne',
	        value: function deleteOne(view, entityId) {
	            return this._restWrapper.deleteOne(view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(entityId), view.type, entityId, view.identifier()), view.entity.deleteMethod());
	        }
	
	        /**
	         * Delete a batch of entity
	         * Delete the data to the API
	         *
	         * @param {String} view     the formView related to the entity
	         * @param {*}      entityIds the entities ids
	         *
	         * @returns {promise}
	         */
	    }, {
	        key: 'batchDelete',
	        value: function batchDelete(view, entityIds) {
	            var deleteOne = this.deleteOne.bind(this);
	            var promises = entityIds.map(function (id) {
	                return deleteOne(view, id);
	            });
	
	            return this._promisesResolver.allEvenFailed(promises);
	        }
	    }]);
	
	    return WriteQueries;
	}(_Queries3['default']);
	
	exports['default'] = WriteQueries;
	module.exports = exports['default'];
	//# sourceMappingURL=WriteQueries.js.map

/***/ },
/* 373 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	var PromisesResolver = function () {
	    function PromisesResolver() {
	        _classCallCheck(this, PromisesResolver);
	    }
	
	    _createClass(PromisesResolver, null, [{
	        key: 'empty',
	        value: function empty(value) {
	            return new Promise(function (resolve) {
	                resolve(value);
	            });
	        }
	    }, {
	        key: 'allEvenFailed',
	        value: function allEvenFailed(promises) {
	            if (!Array.isArray(promises)) {
	                throw Error('allEvenFailed can only handle an array of promises');
	            }
	
	            return new Promise(function (resolve, reject) {
	                if (promises.length === 0) {
	                    return resolve([]);
	                }
	
	                var states = [],
	                    results = [];
	
	                promises.forEach(function (promise, key) {
	                    states[key] = false; // promises are not resolved by default
	                });
	
	                promises.forEach(function (promise, key) {
	                    function resolveState(result) {
	                        states[key] = true;
	                        results[key] = result; // result may be an error
	                        for (var i in states) {
	                            if (!states[i]) {
	                                return;
	                            }
	                        }
	
	                        resolve(results);
	                    }
	
	                    function resolveSuccess(result) {
	                        return resolveState({ status: 'success', result: result });
	                    }
	
	                    function resolveError(result) {
	                        return resolveState({ status: 'error', error: result });
	                    }
	
	                    // whether the promise ends with success or error, consider it done
	                    promise.then(resolveSuccess, resolveError);
	                });
	            });
	        }
	    }]);
	
	    return PromisesResolver;
	}();
	
	exports['default'] = PromisesResolver;
	module.exports = exports['default'];
	//# sourceMappingURL=PromisesResolver.js.map

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(7);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var BatchDeleteView = function (_View) {
	    _inherits(BatchDeleteView, _View);
	
	    function BatchDeleteView(name) {
	        _classCallCheck(this, BatchDeleteView);
	
	        _get(Object.getPrototypeOf(BatchDeleteView.prototype), 'constructor', this).call(this, name);
	
	        this._type = 'BatchDeleteView';
	        this._enabled = true;
	    }
	
	    return BatchDeleteView;
	}(_View3['default']);
	
	exports['default'] = BatchDeleteView;
	module.exports = exports['default'];
	//# sourceMappingURL=BatchDeleteView.js.map

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(7);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var CreateView = function (_View) {
	    _inherits(CreateView, _View);
	
	    function CreateView(name) {
	        _classCallCheck(this, CreateView);
	
	        _get(Object.getPrototypeOf(CreateView.prototype), 'constructor', this).call(this, name);
	        this._type = 'CreateView';
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    /**
	     * Add a function to be executed after the creation succeeds.
	     *
	     * This is the ideal place to use the response to update the entry, or
	     * redirect to another view.
	     *
	     * If the function returns false, the default execution workflow is stopped.
	     * This means that the function must provide a custom workflow.
	     *
	     * If the function throws an exception, the onSubmitError callback will
	     * execute.
	     *
	     * The syntax depends on the framework calling the function.
	     *
	     * With ng-admin, the function can be an angular injectable, listing
	     * required dependencies in an array. Among other, the function can receive
	     * the following services:
	     *  - $event: the form submission event
	     *  - entry: the current Entry instance
	     *  - entity: the current entity
	     *  - form: the form object (for form validation and errors)
	     *  - progression: the controller for the loading indicator
	     *  - notification: the controller for top notifications
	     *
	     * The function can be asynchronous, in which case it should return
	     * a Promise.
	     *
	     * @example
	     *
	     *     post.creationView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	     *         // stop the progress bar
	     *         progression.done();
	     *         // add a notification
	     *         notification.log(`Element #${entry._identifierValue} successfully created.`, { addnCls: 'humane-flatty-success' });
	     *         // redirect to the list view
	     *         $state.go($state.get('list'), { entity: entity.name() });
	     *         // cancel the default action (redirect to the edition view)
	     *         return false;
	     *      }])
	     *
	     */
	
	    _createClass(CreateView, [{
	        key: 'onSubmitSuccess',
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	
	        /**
	         * Add a function to be executed after the creation request receives a
	         * failed http response from the server.
	         *
	         * This is the ideal place to use the response to update the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.creationView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // mark fields based on errors from the response
	         *         error.violations.forEach(violation => {
	         *             if (form[violation.propertyPath]) {
	         *                 form[violation.propertyPath].$valid = false;
	         *             }
	         *         });
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Some values are invalid, see details in the form`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	    }, {
	        key: 'onSubmitError',
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }]);
	
	    return CreateView;
	}(_View3['default']);
	
	exports['default'] = CreateView;
	module.exports = exports['default'];
	//# sourceMappingURL=CreateView.js.map

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _ListView2 = __webpack_require__(9);
	
	var _ListView3 = _interopRequireDefault(_ListView2);
	
	var DashboardView = function (_ListView) {
	    _inherits(DashboardView, _ListView);
	
	    function DashboardView() {
	        _classCallCheck(this, DashboardView);
	
	        _get(Object.getPrototypeOf(DashboardView.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(DashboardView, [{
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name();
	            }
	            return this;
	        }
	    }]);
	
	    return DashboardView;
	}(_ListView3['default']);
	
	exports['default'] = DashboardView;
	module.exports = exports['default'];
	//# sourceMappingURL=DashboardView.js.map

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(7);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var DeleteView = function (_View) {
	    _inherits(DeleteView, _View);
	
	    function DeleteView(name) {
	        _classCallCheck(this, DeleteView);
	
	        _get(Object.getPrototypeOf(DeleteView.prototype), 'constructor', this).call(this, name);
	        this._type = 'DeleteView';
	        this._enabled = true;
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    /**
	     * Add a function to be executed after the delete succeeds.
	     *
	     * This is the ideal place to use the response to delete the entry, or
	     * redirect to another view.
	     *
	     * If the function returns false, the default execution workflow is stopped.
	     * This means that the function must provide a custom workflow.
	     *
	     * If the function throws an exception, the onSubmitError callback will
	     * execute.
	     *
	     * The syntax depends on the framework calling the function.
	     *
	     * With ng-admin, the function can be an angular injectable, listing
	     * required dependencies in an array. Among other, the function can receive
	     * the following services:
	     *  - $event: the form submission event
	     *  - entry: the current Entry instance
	     *  - entity: the current entity
	     *  - form: the form object (for form validation and errors)
	     *  - progression: the controller for the loading indicator
	     *  - notification: the controller for top notifications
	     *
	     * The function can be asynchronous, in which case it should return
	     * a Promise.
	     *
	     * @example
	     *
	     *     post.deletionView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	     *         // stop the progress bar
	     *         progression.done();
	     *         // add a notification
	     *         notification.log(`Element #${entry._identifierValue} successfully deleted.`, { addnCls: 'humane-flatty-success' });
	     *         // redirect to the list view
	     *         $state.go($state.get('list'), { entity: entity.name() });
	     *         // cancel the default action (redirect to the edition view)
	     *         return false;
	     *      }])
	     */
	
	    _createClass(DeleteView, [{
	        key: 'onSubmitSuccess',
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	
	        /**
	         * Add a function to be executed after the delete request receives a failed
	         * http response from the server.
	         *
	         * This is the ideal place to use the response to delete the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.deletionView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Failed to delete element.`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	    }, {
	        key: 'onSubmitError',
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }]);
	
	    return DeleteView;
	}(_View3['default']);
	
	exports['default'] = DeleteView;
	module.exports = exports['default'];
	//# sourceMappingURL=DeleteView.js.map

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(7);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var EditView = function (_View) {
	    _inherits(EditView, _View);
	
	    function EditView(name) {
	        _classCallCheck(this, EditView);
	
	        _get(Object.getPrototypeOf(EditView.prototype), 'constructor', this).call(this, name);
	        this._type = 'EditView';
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    /**
	     * Add a function to be executed after the update succeeds.
	     *
	     * This is the ideal place to use the response to update the entry, or
	     * redirect to another view.
	     *
	     * If the function returns false, the default execution workflow is stopped.
	     * This means that the function must provide a custom workflow.
	     *
	     * If the function throws an exception, the onSubmitError callback will
	     * execute.
	     *
	     * The syntax depends on the framework calling the function.
	     *
	     * With ng-admin, the function can be an angular injectable, listing
	     * required dependencies in an array. Among other, the function can receive
	     * the following services:
	     *  - $event: the form submission event
	     *  - entry: the current Entry instance
	     *  - entity: the current entity
	     *  - form: the form object (for form validation and errors)
	     *  - progression: the controller for the loading indicator
	     *  - notification: the controller for top notifications
	     *
	     * The function can be asynchronous, in which case it should return
	     * a Promise.
	     *
	     * @example
	     *
	     *     post.editionView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	     *         // stop the progress bar
	     *         progression.done();
	     *         // add a notification
	     *         notification.log(`Element #${entry._identifierValue} successfully edited.`, { addnCls: 'humane-flatty-success' });
	     *         // redirect to the list view
	     *         $state.go($state.get('list'), { entity: entity.name() });
	     *         // cancel the default action (redirect to the edition view)
	     *         return false;
	     *      }])
	     */
	
	    _createClass(EditView, [{
	        key: 'onSubmitSuccess',
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	
	        /**
	         * Add a function to be executed after the update request receives a failed
	         * http response from the server.
	         *
	         * This is the ideal place to use the response to update the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.editionView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // mark fields based on errors from the response
	         *         error.violations.forEach(violation => {
	         *             if (form[violation.propertyPath]) {
	         *                 form[violation.propertyPath].$valid = false;
	         *             }
	         *         });
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Some values are invalid, see details in the form`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	    }, {
	        key: 'onSubmitError',
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }]);
	
	    return EditView;
	}(_View3['default']);
	
	exports['default'] = EditView;
	module.exports = exports['default'];
	//# sourceMappingURL=EditView.js.map

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _ListView2 = __webpack_require__(9);
	
	var _ListView3 = _interopRequireDefault(_ListView2);
	
	var ExportView = function (_ListView) {
	    _inherits(ExportView, _ListView);
	
	    function ExportView(name) {
	        _classCallCheck(this, ExportView);
	
	        _get(Object.getPrototypeOf(ExportView.prototype), 'constructor', this).call(this, name);
	        this._fields = [];
	        this._type = 'ExportView';
	    }
	
	    return ExportView;
	}(_ListView3['default']);
	
	exports['default'] = ExportView;
	module.exports = exports['default'];
	//# sourceMappingURL=ExportView.js.map

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(7);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var MenuView = function (_View) {
	    _inherits(MenuView, _View);
	
	    function MenuView(name) {
	        _classCallCheck(this, MenuView);
	
	        _get(Object.getPrototypeOf(MenuView.prototype), 'constructor', this).call(this, name);
	        this._type = 'MenuView';
	        this._icon = null;
	    }
	
	    _createClass(MenuView, [{
	        key: 'icon',
	        value: function icon() {
	            if (arguments.length) {
	                console.warn('entity.menuView() is deprecated. Please use the Menu class instead');
	                this._icon = arguments[0];
	                return this;
	            }
	
	            if (this._icon === null) {
	                return '<span class="glyphicon glyphicon-list"></span>';
	            }
	
	            return this._icon;
	        }
	    }, {
	        key: 'enabled',
	        get: function get() {
	            return this._enabled === null ? this.entity._views['ListView'].enabled : this._enabled;
	        }
	    }]);
	
	    return MenuView;
	}(_View3['default']);
	
	exports['default'] = MenuView;
	module.exports = exports['default'];
	//# sourceMappingURL=MenuView.js.map

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) {
	    var _again = true;_function: while (_again) {
	        var object = _x,
	            property = _x2,
	            receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	            var parent = Object.getPrototypeOf(object);if (parent === null) {
	                return undefined;
	            } else {
	                _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
	            }
	        } else if ('value' in desc) {
	            return desc.value;
	        } else {
	            var getter = desc.get;if (getter === undefined) {
	                return undefined;
	            }return getter.call(receiver);
	        }
	    }
	};
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	}
	
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	        throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _View2 = __webpack_require__(7);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var ShowView = function (_View) {
	    _inherits(ShowView, _View);
	
	    function ShowView(name) {
	        _classCallCheck(this, ShowView);
	
	        _get(Object.getPrototypeOf(ShowView.prototype), 'constructor', this).call(this, name);
	        this._type = 'ShowView';
	    }
	
	    return ShowView;
	}(_View3['default']);
	
	exports['default'] = ShowView;
	module.exports = exports['default'];
	//# sourceMappingURL=ShowView.js.map

/***/ },
/* 382 */
/***/ function(module, exports) {

	'use strict';
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 7.3.9
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, { get: fn });
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  FileAPI.shouldLoad = window.XMLHttpRequest && !window.FormData || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function initializeUploadListener(xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : orig == null ? null : orig.apply(this, [h]);
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : orig == null ? null : orig.apply(this);
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : orig == null ? null : orig.apply(this);
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function complete(err, fileApiXHR) {
	              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
	                // this error seems to be fine the file is being uploaded properly.
	                err = null;
	              }
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load) xhr.__listeners.load({
	                type: 'load',
	                loaded: xhr.__loaded,
	                total: xhr.__total,
	                target: xhr,
	                lengthComputable: true
	              });
	              if (!err && xhr.__listeners.loadend) xhr.__listeners.loadend({
	                type: 'loadend',
	                loaded: xhr.__loaded,
	                total: xhr.__total,
	                target: xhr,
	                lengthComputable: true
	              });
	              if (err === 'abort' && xhr.__listeners.abort) xhr.__listeners.abort({
	                type: 'abort',
	                loaded: xhr.__loaded,
	                total: xhr.__total,
	                target: xhr,
	                lengthComputable: true
	              });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return fileApiXHR.status === 0 && err && err !== 'abort' ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function progress(e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {};
	                    _this.complete(null, { status: 204, statusText: 'No Content' });
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function FormData() {
	      return {
	        append: function append(key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function Blob(b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0,
	        top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += obj.offsetLeft - obj.scrollLeft;
	        top += obj.offsetTop - obj.scrollTop;
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl,
	          basePath,
	          script = document.createElement('script'),
	          allScripts = document.getElementsByTagName('script'),
	          i,
	          index,
	          src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	
	      FileAPI.hasFlash = hasFlash();
	    }
	
	    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var fixInputStyle = function fixInputStyle() {
	        if (elem.attr('disabled')) {
	          if (fileElem) fileElem.removeClass('js-fileapi-wrapper');
	        } else {
	          if (!fileElem.attr('__ngf_flash_')) {
	            fileElem.unbind('change');
	            fileElem.unbind('click');
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	            });
	            fileElem.attr('__ngf_flash_', 'true');
	          }
	          fileElem.addClass('js-fileapi-wrapper');
	          if (!isInputTypeFile(elem)) {
	            fileElem.css('position', 'absolute').css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px').css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px').css('filter', 'alpha(opacity=0)').css('display', elem.css('display')).css('overflow', 'hidden').css('z-index', '900000').css('visibility', 'visible');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', fixInputStyle);
	
	      var fileApiChangeFn = function fileApiChangeFn(evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this,
	        loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function constructEvent(type, evt) {
	      var e = { type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error };
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function listener(evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsArrayBuffer = function (file) {
	      FileAPI.readAsBinaryString(file, listener);
	    };
	    this.readAsBinaryString = function (file) {
	      FileAPI.readAsBinaryString(file, listener);
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 7.3.9
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  }(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '7.3.9';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	
	  this.isResumeSupported = function () {
	    return window.Blob && new Blob().slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start, total: config._file.size, type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    config.headers.__setXHR_ = function () {
	      return function (xhr) {
	        if (!xhr) return;
	        config.__XHR = xhr;
	        if (config.xhrFn) config.xhrFn(xhr);
	        xhr.upload.addEventListener('progress', function (e) {
	          e.config = config;
	          notifyProgress(getNotifyEvent(e));
	        }, false);
	        //fix for firefox not firing upload progress end, also IE8-9
	        xhr.upload.addEventListener('load', function (e) {
	          if (e.lengthComputable) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }
	        }, false);
	      };
	    };
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	        if (resumeSupported && config._chunkSize && !config._finished) {
	          notifyProgress({ loaded: config._end, total: config._file.size, config: config, type: 'progress' });
	          upload.upload(config);
	        } else {
	          if (config._finished) delete config._finished;
	          deferred.resolve(r);
	        }
	      }, function (e) {
	        deferred.reject(e);
	      }, function (n) {
	        deferred.notify(n);
	      });
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      uploadWithAngular();
	    }
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      }(config.xhrFn);
	      return promise;
	    };
	
	    return promise;
	  }
	
	  this.upload = function (config) {
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (config.sendFieldsAs === 'form') {
	          if (angular.isObject(val)) {
	            for (var k in val) {
	              if (val.hasOwnProperty(k)) {
	                addFieldToFormData(formData, val[k], key + '[' + k + ']');
	              }
	            }
	          } else {
	            formData.append(key, val);
	          }
	        } else {
	          val = angular.isString(val) ? val : angular.toJson(val);
	          if (config.sendFieldsAs === 'json-blob') {
	            formData.append(key, new Blob([val], { type: 'application/json' }));
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function isFile(file) {
	      return file instanceof Blob || file.flashId && file.name && file.size;
	    }
	
	    function addFileToFormData(formData, file, key) {
	      if (isFile(file)) {
	        config._file = config._file || file;
	        if (config._start != null && resumeSupported) {
	          if (config._end && config._end >= file.size) {
	            config._finished = true;
	            config._end = file.size;
	          }
	          var slice = file.slice(config._start, config._end || file.size);
	          slice.name = file.name;
	          file = slice;
	          if (config._chunkSize) {
	            formData.append('chunkSize', config._end - config._start);
	            formData.append('chunkNumber', Math.floor(config._start / config._chunkSize));
	            formData.append('totalSize', config._file.size);
	          }
	        }
	        formData.append(key, file, file.fileName || file.name);
	      } else if (angular.isObject(file)) {
	        for (var k in file) {
	          if (file.hasOwnProperty(k)) {
	            var split = k.split(',');
	            if (split[1]) {
	              file[k].fileName = split[1].replace(/^\s+|\s+$/g, '');
	            }
	            addFileToFormData(formData, file[k], split[0]);
	          }
	        }
	      } else {
	        throw 'Expected file object in Upload.upload file option: ' + file.toString();
	      }
	    }
	
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    config.headers = config.headers || {};
	    config.headers['Content-Type'] = undefined;
	    config.transformRequest = config.transformRequest ? angular.isArray(config.transformRequest) ? config.transformRequest : [config.transformRequest] : [];
	    config.transformRequest.push(function (data) {
	      var formData = new FormData(),
	          allFields = {},
	          key;
	      for (key in config.fields) {
	        if (config.fields.hasOwnProperty(key)) {
	          allFields[key] = config.fields[key];
	        }
	      }
	      if (data) allFields.data = data;
	      for (key in allFields) {
	        if (allFields.hasOwnProperty(key)) {
	          var val = allFields[key];
	          if (config.formDataAppender) {
	            config.formDataAppender(formData, key, val);
	          } else {
	            addFieldToFormData(formData, val, key);
	          }
	        }
	      }
	
	      if (config.file != null) {
	        if (angular.isArray(config.file)) {
	          for (var i = 0; i < config.file.length; i++) {
	            addFileToFormData(formData, config.file[i], 'file');
	          }
	        } else {
	          addFileToFormData(formData, config.file, 'file');
	        }
	      }
	      return formData;
	    });
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config.transformRequest = config.transformRequest || function (data) {
	      if (window.ArrayBuffer && data instanceof window.ArrayBuffer || data instanceof Blob) {
	        return data;
	      }
	      return $http.defaults.transformRequest[0].apply(this, arguments);
	    };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000000);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000000000);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', 'UploadResize', function ($parse, $timeout, $compile, UploadResize) {
	  var upload = UploadResize;
	  upload.getAttrWithDefaults = function (attr, name) {
	    return attr[name] != null ? attr[name] : upload.defaults[name] == null ? upload.defaults[name] : upload.defaults[name].toString();
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(this.getAttrWithDefaults(attr, name))(scope, params);
	        } else {
	          return $parse(this.getAttrWithDefaults(attr, name))(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return this.getAttrWithDefaults(attr, name);
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return this.getAttrWithDefaults(attr, name);
	    }
	  };
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    var newFiles = files,
	        dupFiles = [];
	
	    function update() {
	      var file = files && files.length ? files[0] : null;
	      if (ngModel) {
	        var singleModel = !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr) && !keep;
	        $parse(upload.attrGetter('ngModel', attr)).assign(scope, singleModel ? file : files);
	      }
	      var ngfModel = upload.attrGetter('ngfModel', attr);
	      if (ngfModel) {
	        $parse(ngfModel).assign(scope, files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $event: evt
	        });
	      }
	      // scope apply changes
	      $timeout(function () {});
	    }
	
	    var prevFiles = (ngModel && ngModel.$modelValue || attr.$$ngfPrevFiles || []).slice(0);
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    if (keep === true) {
	      if (!files || !files.length) return;
	
	      var hasNew = false;
	
	      if (upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	        var len = prevFiles.length;
	        for (var i = 0; i < files.length; i++) {
	          for (var j = 0; j < len; j++) {
	            if (files[i].name === prevFiles[j].name) {
	              dupFiles.push(files[i]);
	              break;
	            }
	          }
	          if (j === len) {
	            prevFiles.push(files[i]);
	            hasNew = true;
	          }
	        }
	        if (!hasNew) return;
	        files = prevFiles;
	      } else {
	        files = prevFiles.concat(files);
	      }
	    }
	
	    attr.$$ngfPrevFiles = files;
	
	    function resize(files, callback) {
	      var param = upload.attrGetter('ngfResize', attr, scope);
	      if (!param || !upload.isResizeSupported()) return callback();
	      var count = files.length;
	      var checkCallback = function checkCallback() {
	        count--;
	        if (count === 0) callback();
	      };
	      var success = function success(index) {
	        return function (resizedFile) {
	          files.splice(index, 1, resizedFile);
	          checkCallback();
	        };
	      };
	      var error = function error(f) {
	        return function (e) {
	          checkCallback();
	          f.$error = 'resize';
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	        };
	      };
	      for (var i = 0; i < files.length; i++) {
	        var f = files[i];
	        if (!f.$error && f.type.indexOf('image') === 0) {
	          upload.resize(f, param.width, param.height, param.quality).then(success(i), error(f));
	        } else {
	          checkCallback();
	        }
	      }
	    }
	
	    if (noDelay) {
	      update();
	    } else if (upload.validate(files, ngModel, attr, scope, upload.attrGetter('ngfValidateLater', attr), function () {
	      resize(files, function () {
	        $timeout(function () {
	          update();
	        });
	      });
	    })) ;
	
	    // cleaning object url memories
	    var l = prevFiles.length;
	    while (l--) {
	      var prevFile = prevFiles[l];
	      if (window.URL && prevFile.blobUrl) {
	        URL.revokeObjectURL(prevFile.blobUrl);
	        delete prevFile.blobUrl;
	      }
	    }
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || parseInt(m[1]) === v && parseInt(m[2]) < v;
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModel */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    /** @namespace attr.ngfKeepDistinct */
	    var attrGetter = function attrGetter(name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      var fileList = evt.__files_ || evt.target && evt.target.files,
	          files = [];
	      for (var i = 0; i < fileList.length; i++) {
	        files.push(fileList[i]);
	      }
	      upload.updateModel(ngModel, attr, scope, fileChangeAttr(), files.length ? files : null, evt);
	    }
	
	    var unwatches = [];
	    unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	      fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	    }));
	    unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	      fileElem.attr('capture', attrGetter('ngfCapture', scope));
	    }));
	    attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    });
	    unwatches.push(function () {
	      if (attr.$$observers) delete attr.$$observers.accept;
	    });
	    function bindAttrToFileInput(fileElem) {
	      if (elem !== fileElem) {
	        for (var i = 0; i < elem[0].attributes.length; i++) {
	          var attribute = elem[0].attributes[i];
	          if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'id' && attribute.name !== 'style') {
	            if (attribute.value == null || attribute.value === '') {
	              if (attribute.name === 'required') attribute.value = 'required';
	              if (attribute.name === 'multiple') attribute.value = 'multiple';
	            }
	            fileElem.attr(attribute.name, attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	      bindAttrToFileInput(fileElem);
	
	      fileElem.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden').css('width', '0px').css('height', '0px').css('border', 'none').css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      generatedElems.push({ el: elem, ref: fileElem });
	      document.body.appendChild(fileElem[0]);
	
	      return fileElem;
	    }
	
	    var initialTouchStartY = 0;
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled') || attrGetter('ngfSelectDisabled', scope)) return false;
	
	      var r = handleTouch(evt);
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	    function handleTouch(evt) {
	      var touches = evt.changedTouches || evt.originalEvent && evt.originalEvent.changedTouches;
	      if (evt.type === 'touchstart') {
	        initialTouchStartY = touches ? touches[0].clientY : 0;
	        return true; // don't block event default
	      } else {
	        evt.stopPropagation();
	        evt.preventDefault();
	
	        // prevent scroll from triggering event
	        if (evt.type === 'touchend') {
	          var currentLocation = touches ? touches[0].clientY : 0;
	          if (Math.abs(currentLocation - initialTouchStartY) > 20) return false;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    upload.registerValidators(ngModel, fileElem, attr, scope);
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function link(scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (disallowObjectUrl && file.dataUrl != null || !disallowObjectUrl && file.blobUrl != null) {
	        var d = $q.defer();
	        $timeout(function () {
	          d.resolve(disallowObjectUrl ? file.dataUrl : file.blobUrl);
	        });
	        return d.promise;
	      }
	      var p = disallowObjectUrl ? file.$ngfDataUrlPromise : file.$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file && (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) && (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.blobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.blobUrl = url;
	              if (url) deferred.resolve(url);
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.dataUrl = e.target.result;
	                deferred.resolve(e.target.result);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.dataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? 'dataUrl' : 'blobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$ngfDataUrlPromise' : '$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return (/./
	    );
	  }
	
	  var style = angular.element('<style>.ngf-hide{display:none !important}</style>');
	  document.getElementsByTagName('head')[0].appendChild(style[0]);
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.dataUrl : file.blobUrl) || file.dataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ngf-hide');
	          } else {
	            elem.addClass('ngf-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = { width: elem[0].clientWidth, height: elem[0].clientHeight };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            size = { width: parseInt(style.width.slice(0, -2)),
	              height: parseInt(style.height.slice(0, -2)) };
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ngf-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 && (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            Upload.resize(file, size.width, size.height, size.quality).then(function (f) {
	              constructDataUrl(f);
	            }, function (e) {
	              throw e;
	            });
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ngf-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function link(scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc', Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function link(scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground', Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function link(scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size, Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  //ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	  //  if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|local|file|data|blob):/);
	  //  if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|local|file|data|blob):/);
	  //}]);
	  //
	  //ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	  //  return function (file, disallowObjectUrl) {
	  //    if (angular.isString(file)) {
	  //      return $sce.trustAsResourceUrl(file);
	  //    }
	  //    if (file && !file.dataUrl) {
	  //      if (file.dataUrl === undefined && angular.isObject(file)) {
	  //        file.dataUrl = null;
	  //        UploadDataUrl.dataUrl(file, disallowObjectUrl);
	  //      }
	  //      return '';
	  //    }
	  //    return (file && file.dataUrl ? $sce.trustAsResourceUrl(file.dataUrl) : file) || '';
	  //  };
	  //}]);
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '',
	        excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return { regexp: regexp, excludes: excludes };
	  }
	
	  upload.registerValidators = function (ngModel, elem, attr, scope) {
	    if (!ngModel) return;
	
	    ngModel.$ngfValidations = [];
	    function setValidities(ngModel) {
	      angular.forEach(ngModel.$ngfValidations, function (validation) {
	        ngModel.$setValidity(validation.name, validation.valid);
	      });
	    }
	
	    ngModel.$formatters.push(function (val) {
	      if (upload.attrGetter('ngfValidateLater', attr, scope) || !ngModel.$$ngfValidated) {
	        upload.validate(val, ngModel, attr, scope, false, function () {
	          setValidities(ngModel);
	          ngModel.$$ngfValidated = false;
	        });
	        if (val && val.length === 0) {
	          val = null;
	        }
	        if (elem && (val == null || val.length === 0)) {
	          if (elem.val()) {
	            elem.val(null);
	          }
	        }
	      } else {
	        setValidities(ngModel);
	        ngModel.$$ngfValidated = false;
	      }
	      return val;
	    });
	  };
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val),
	        valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = file.type != null && regexp.test(file.type) || file.name != null && regexp.test(file.name);
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) && (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.validate = function (files, ngModel, attr, scope, later, callback) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function attrGetter(name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (later) {
	      callback.call(ngModel);
	      return;
	    }
	    ngModel.$$ngfValidated = true;
	
	    if (files == null || files.length === 0) {
	      callback.call(ngModel);
	      return;
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	
	    function validateSync(name, validatorVal, fn) {
	      if (files) {
	        var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	        var i = files.length,
	            valid = null;
	
	        while (i--) {
	          var file = files[i];
	          var val = attrGetter(dName, { '$file': file });
	          if (val == null) {
	            val = validatorVal(attrGetter('ngfValidate') || {});
	            valid = valid == null ? true : valid;
	          }
	          if (val != null) {
	            if (!fn(file, val)) {
	              file.$error = name;
	              file.$errorParam = val;
	              files.splice(i, 1);
	              valid = false;
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({ name: name, valid: valid });
	        }
	      }
	    }
	
	    validateSync('pattern', function (cons) {
	      return cons.pattern;
	    }, upload.validatePattern);
	    validateSync('minSize', function (cons) {
	      return cons.size && cons.size.min;
	    }, function (file, val) {
	      return file.size >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', function (cons) {
	      return cons.size && cons.size.max;
	    }, function (file, val) {
	      return file.size <= upload.translateScalars(val);
	    });
	
	    validateSync('validateFn', function () {
	      return null;
	    }, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      callback.call(ngModel, ngModel.$ngfValidations);
	      return;
	    }
	
	    var pendings = 0;
	
	    function validateAsync(name, validatorVal, type, asyncFn, fn) {
	      if (files) {
	        var thisPendings = 0,
	            hasError = false,
	            dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          if (file.type.search(type) !== 0) {
	            return true;
	          }
	          var val = attrGetter(dName, { '$file': file }) || validatorVal(attrGetter('ngfValidate', { '$file': file }) || {});
	          if (val) {
	            pendings++;
	            thisPendings++;
	            asyncFn(file, val).then(function (d) {
	              if (!fn(d, val)) {
	                file.$error = name;
	                file.$errorParam = val;
	                hasError = true;
	              }
	            }, function () {
	              if (attrGetter('ngfValidateForce', { '$file': file })) {
	                file.$error = name;
	                file.$errorParam = val;
	                hasError = true;
	              }
	            })['finally'](function () {
	              pendings--;
	              thisPendings--;
	              if (!thisPendings) {
	                ngModel.$ngfValidations.push({ name: name, valid: !hasError });
	              }
	              if (!pendings) {
	                callback.call(ngModel, ngModel.$ngfValidations);
	              }
	            });
	          }
	        });
	      }
	    }
	
	    validateAsync('maxHeight', function (cons) {
	      return cons.height && cons.height.max;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.height <= val;
	    });
	    validateAsync('minHeight', function (cons) {
	      return cons.height && cons.height.min;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.height >= val;
	    });
	    validateAsync('maxWidth', function (cons) {
	      return cons.width && cons.width.max;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.width <= val;
	    });
	    validateAsync('minWidth', function (cons) {
	      return cons.width && cons.width.min;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.width >= val;
	    });
	    validateAsync('ratio', function (cons) {
	      return cons.ratio;
	    }, /image/, this.imageDimensions, function (d, val) {
	      var split = val.toString().split(','),
	          valid = false;
	
	      for (var i = 0; i < split.length; i++) {
	        var r = split[i],
	            xIndex = r.search(/x/i);
	        if (xIndex > -1) {
	          r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	        } else {
	          r = parseFloat(r);
	        }
	        if (Math.abs(d.width / d.height - r) < 0.0001) {
	          valid = true;
	        }
	      }
	      return valid;
	    });
	    validateAsync('maxDuration', function (cons) {
	      return cons.duration && cons.duration.max;
	    }, /audio|video/, this.mediaDuration, function (d, val) {
	      return d <= upload.translateScalars(val);
	    });
	    validateAsync('minDuration', function (cons) {
	      return cons.duration && cons.duration.min;
	    }, /audio|video/, this.mediaDuration, function (d, val) {
	      return d >= upload.translateScalars(val);
	    });
	
	    validateAsync('validateAsyncFn', function () {
	      return null;
	    }, /./, function (file, val) {
	      return val;
	    }, function (r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!pendings) {
	      callback.call(ngModel, ngModel.$ngfValidations);
	    }
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.width && file.height) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({ width: file.width, height: file.height });
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl).css('visibility', 'hidden').css('position', 'fixed');
	
	        function success() {
	          var width = img[0].clientWidth;
	          var height = img[0].clientHeight;
	          img.remove();
	          file.width = width;
	          file.height = height;
	          deferred.resolve({ width: width, height: height });
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.duration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.duration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>').attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.duration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}]);
	
	// source: Source: https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', '$timeout', function (UploadValidate, $q, $timeout) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
	    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return { width: srcWidth * ratio, height: srcHeight * ratio };
	  };
	
	  /**
	   Reduce imagen size and quality.
	   @param {String} imagen is a base64 string
	   @param {Number} width
	   @param {Number} height
	   @param {Number} quality from 0.1 to 1.0
	   @return Promise.<String>
	   **/
	  var resize = function resize(imagen, width, height, quality, type) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imagenElement = document.createElement('img');
	    if (width === 0) {
	      width = imagenElement.width;
	      height = imagenElement.height;
	    }
	    imagenElement.onload = function () {
	      try {
	        var dimensions = calculateAspectRatioFit(imagenElement.width, imagenElement.height, width, height);
	        canvasElement.width = dimensions.width;
	        canvasElement.height = dimensions.height;
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imagenElement, 0, 0, dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 1.0));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imagenElement.onerror = function () {
	      deferred.reject();
	    };
	    imagenElement.src = imagen;
	    return deferred.promise;
	  };
	
	  var dataURLtoBlob = function dataURLtoBlob(dataurl) {
	    var arr = dataurl.split(','),
	        mime = arr[0].match(/:(.*?);/)[1],
	        bstr = atob(arr[1]),
	        n = bstr.length,
	        u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    return new Blob([u8arr], { type: mime });
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d');
	  };
	
	  upload.resize = function (file, width, height, quality) {
	    var deferred = $q.defer();
	    if (file.type.indexOf('image') !== 0) {
	      $timeout(function () {
	        deferred.resolve('Only images are allowed for resizing!');
	      });
	      return deferred.promise;
	    }
	
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, width, height, quality, file.type).then(function (dataUrl) {
	        var blob = dataURLtoBlob(dataUrl);
	        blob.name = file.name;
	        deferred.resolve(blob);
	      }, function () {
	        deferred.reject();
	      });
	    }, function () {
	      deferred.reject();
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$location', 'Upload', function ($parse, $timeout, $location, Upload) {
	    return {
	      restrict: 'AEC',
	      require: '?ngModel',
	      link: function link(scope, elem, attr, ngModel) {
	        linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location, Upload);
	      }
	    };
	  }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location, upload) {
	    var available = dropAvailable();
	
	    var attrGetter = function attrGetter(name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    upload.registerValidators(ngModel, null, attr, scope);
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = 'move' === b || 'linkMove' === b ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function () {
	      if (isDisabled()) return;
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	      }, dragOverDelay || 1);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFiles(evt, function (files) {
	        upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	      }, attrGetter('ngfAllowDir', scope) !== false, attrGetter('multiple') || attrGetter('ngfMultiple', scope));
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (isDisabled()) return;
	      var files = [];
	      var clipboard = evt.clipboardData || evt.originalEvent.clipboardData;
	      if (clipboard && clipboard.items) {
	        for (var k = 0; k < clipboard.items.length; k++) {
	          if (clipboard.items[k].type.indexOf('image') !== -1) {
	            files.push(clipboard.items[k].getAsFile());
	          }
	        }
	        upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	      }
	    }, false);
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var clazz = attrGetter('ngfDragOverClass', scope, { $event: evt }),
	          dClass = attrGetter('ngfDragOverClass') || 'dragover';
	      if (angular.isString(clazz)) {
	        callback(clazz);
	        return;
	      }
	      if (clazz) {
	        if (clazz.delay) dragOverDelay = clazz.delay;
	        if (clazz.accept || clazz.reject) {
	          var items = evt.dataTransfer.items;
	          if (items != null) {
	            var pattern = attrGetter('ngfPattern', scope, { $event: evt });
	            for (var i = 0; i < items.length; i++) {
	              if (items[i].kind === 'file' || items[i].kind === '') {
	                if (!upload.validatePattern(items[i], pattern)) {
	                  dClass = clazz.reject;
	                  break;
	                } else {
	                  dClass = clazz.accept;
	                }
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(evt, callback, allowDir, multiple) {
	      var files = [],
	          processing = 0;
	
	      function traverseFileTree(files, entry, path) {
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var filePath = (path || '') + entry.name;
	            files.push({ name: entry.name, type: 'directory', path: filePath });
	            var dirReader = entry.createReader();
	            var entries = [];
	            processing++;
	            var readEntries = function readEntries() {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    for (var i = 0; i < entries.length; i++) {
	                      traverseFileTree(files, entries[i], (path ? path : '') + entry.name + '/');
	                    }
	                    processing--;
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  processing--;
	                  console.error(e);
	                }
	              }, function () {
	                processing--;
	              });
	            };
	            readEntries();
	          } else {
	            processing++;
	            entry.file(function (file) {
	              try {
	                processing--;
	                file.path = (path ? path : '') + file.name;
	                files.push(file);
	              } catch (e) {
	                processing--;
	                console.error(e);
	              }
	            }, function () {
	              processing--;
	            });
	          }
	        }
	      }
	
	      var items = evt.dataTransfer.items;
	
	      if (items && items.length > 0 && $location.protocol() !== 'file') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              traverseFileTree(files, entry);
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) files.push(f);
	          }
	          if (!multiple && files.length > 0) break;
	        }
	      } else {
	        var fileList = evt.dataTransfer.files;
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            files.push(fileList.item(j));
	            if (!multiple && files.length > 0) {
	              break;
	            }
	          }
	        }
	      }
	      var delays = 0;
	      (function waitForProcess(delay) {
	        $timeout(function () {
	          if (!processing) {
	            if (!multiple && files.length > 1) {
	              i = 0;
	              while (files[i].type === 'directory') {
	                i++;
	              }files = [files[i]];
	            }
	            callback(files);
	          } else {
	            if (delays++ * 10 < 20 * 1000) {
	              waitForProcess(10);
	            }
	          }
	        }, delay || 0);
	      })();
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return 'draggable' in div && 'ondrop' in div && !/Edge\/12./i.test(navigator.userAgent);
	  }
	})();

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(382);
	module.exports = 'ngFileUpload';

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function () {
	  var inflection = window && window.inflection ? window.inflection : __webpack_require__(239);
	  var angular = window && window.angular ? window.angular : __webpack_require__(5);
	  var app = angular.module('ngInflection', []);
	
	  function wrap(op) {
	    return function () {
	      return function (inp) {
	        if (inp) {
	          return inflection[op].apply(this, arguments);
	        }
	      };
	    };
	  }
	
	  var ops = ['indexOf', 'pluralize', 'singularize', 'inflect', 'camelize', 'underscore', 'humanize', 'capitalize', 'dasherize', 'titleize', 'demodulize', 'tableize', 'classify', 'foreign_key', 'ordinalize'];
	
	  for (var i in ops) {
	    app.filter(ops[i], wrap(ops[i]));
	  }
	
	  app.filter('transform', function () {
	    return function (string, arr) {
	      if (string && arr) {
	        return inflection.transform(string, arr);
	      }
	    };
	  });
	};
	
	module.exports();

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
	 * @license MIT */
	
	;(function (root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    module.exports = factory();
	  } else {
	    root.NProgress = factory();
	  }
	})(undefined, function () {
	  var NProgress = {};
	
	  NProgress.version = '0.2.0';
	
	  var Settings = NProgress.settings = {
	    minimum: 0.08,
	    easing: 'ease',
	    positionUsing: '',
	    speed: 200,
	    trickle: true,
	    trickleRate: 0.02,
	    trickleSpeed: 800,
	    showSpinner: true,
	    barSelector: '[role="bar"]',
	    spinnerSelector: '[role="spinner"]',
	    parent: 'body',
	    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
	  };
	
	  /**
	   * Updates configuration.
	   *
	   *     NProgress.configure({
	   *       minimum: 0.1
	   *     });
	   */
	  NProgress.configure = function (options) {
	    var key, value;
	    for (key in options) {
	      value = options[key];
	      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
	    }
	
	    return this;
	  };
	
	  /**
	   * Last number.
	   */
	
	  NProgress.status = null;
	
	  /**
	   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
	   *
	   *     NProgress.set(0.4);
	   *     NProgress.set(1.0);
	   */
	
	  NProgress.set = function (n) {
	    var started = NProgress.isStarted();
	
	    n = clamp(n, Settings.minimum, 1);
	    NProgress.status = n === 1 ? null : n;
	
	    var progress = NProgress.render(!started),
	        bar = progress.querySelector(Settings.barSelector),
	        speed = Settings.speed,
	        ease = Settings.easing;
	
	    progress.offsetWidth; /* Repaint */
	
	    queue(function (next) {
	      // Set positionUsing if it hasn't already been set
	      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();
	
	      // Add transition
	      css(bar, barPositionCSS(n, speed, ease));
	
	      if (n === 1) {
	        // Fade out
	        css(progress, {
	          transition: 'none',
	          opacity: 1
	        });
	        progress.offsetWidth; /* Repaint */
	
	        setTimeout(function () {
	          css(progress, {
	            transition: 'all ' + speed + 'ms linear',
	            opacity: 0
	          });
	          setTimeout(function () {
	            NProgress.remove();
	            next();
	          }, speed);
	        }, speed);
	      } else {
	        setTimeout(next, speed);
	      }
	    });
	
	    return this;
	  };
	
	  NProgress.isStarted = function () {
	    return typeof NProgress.status === 'number';
	  };
	
	  /**
	   * Shows the progress bar.
	   * This is the same as setting the status to 0%, except that it doesn't go backwards.
	   *
	   *     NProgress.start();
	   *
	   */
	  NProgress.start = function () {
	    if (!NProgress.status) NProgress.set(0);
	
	    var work = function work() {
	      setTimeout(function () {
	        if (!NProgress.status) return;
	        NProgress.trickle();
	        work();
	      }, Settings.trickleSpeed);
	    };
	
	    if (Settings.trickle) work();
	
	    return this;
	  };
	
	  /**
	   * Hides the progress bar.
	   * This is the *sort of* the same as setting the status to 100%, with the
	   * difference being `done()` makes some placebo effect of some realistic motion.
	   *
	   *     NProgress.done();
	   *
	   * If `true` is passed, it will show the progress bar even if its hidden.
	   *
	   *     NProgress.done(true);
	   */
	
	  NProgress.done = function (force) {
	    if (!force && !NProgress.status) return this;
	
	    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
	  };
	
	  /**
	   * Increments by a random amount.
	   */
	
	  NProgress.inc = function (amount) {
	    var n = NProgress.status;
	
	    if (!n) {
	      return NProgress.start();
	    } else {
	      if (typeof amount !== 'number') {
	        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
	      }
	
	      n = clamp(n + amount, 0, 0.994);
	      return NProgress.set(n);
	    }
	  };
	
	  NProgress.trickle = function () {
	    return NProgress.inc(Math.random() * Settings.trickleRate);
	  };
	
	  /**
	   * Waits for all supplied jQuery promises and
	   * increases the progress as the promises resolve.
	   *
	   * @param $promise jQUery Promise
	   */
	  (function () {
	    var initial = 0,
	        current = 0;
	
	    NProgress.promise = function ($promise) {
	      if (!$promise || $promise.state() === "resolved") {
	        return this;
	      }
	
	      if (current === 0) {
	        NProgress.start();
	      }
	
	      initial++;
	      current++;
	
	      $promise.always(function () {
	        current--;
	        if (current === 0) {
	          initial = 0;
	          NProgress.done();
	        } else {
	          NProgress.set((initial - current) / initial);
	        }
	      });
	
	      return this;
	    };
	  })();
	
	  /**
	   * (Internal) renders the progress bar markup based on the `template`
	   * setting.
	   */
	
	  NProgress.render = function (fromStart) {
	    if (NProgress.isRendered()) return document.getElementById('nprogress');
	
	    addClass(document.documentElement, 'nprogress-busy');
	
	    var progress = document.createElement('div');
	    progress.id = 'nprogress';
	    progress.innerHTML = Settings.template;
	
	    var bar = progress.querySelector(Settings.barSelector),
	        perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
	        parent = document.querySelector(Settings.parent),
	        spinner;
	
	    css(bar, {
	      transition: 'all 0 linear',
	      transform: 'translate3d(' + perc + '%,0,0)'
	    });
	
	    if (!Settings.showSpinner) {
	      spinner = progress.querySelector(Settings.spinnerSelector);
	      spinner && removeElement(spinner);
	    }
	
	    if (parent != document.body) {
	      addClass(parent, 'nprogress-custom-parent');
	    }
	
	    parent.appendChild(progress);
	    return progress;
	  };
	
	  /**
	   * Removes the element. Opposite of render().
	   */
	
	  NProgress.remove = function () {
	    removeClass(document.documentElement, 'nprogress-busy');
	    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
	    var progress = document.getElementById('nprogress');
	    progress && removeElement(progress);
	  };
	
	  /**
	   * Checks if the progress bar is rendered.
	   */
	
	  NProgress.isRendered = function () {
	    return !!document.getElementById('nprogress');
	  };
	
	  /**
	   * Determine which positioning CSS rule to use.
	   */
	
	  NProgress.getPositioningCSS = function () {
	    // Sniff on document.body.style
	    var bodyStyle = document.body.style;
	
	    // Sniff prefixes
	    var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';
	
	    if (vendorPrefix + 'Perspective' in bodyStyle) {
	      // Modern browsers with 3D support, e.g. Webkit, IE10
	      return 'translate3d';
	    } else if (vendorPrefix + 'Transform' in bodyStyle) {
	      // Browsers without 3D support, e.g. IE9
	      return 'translate';
	    } else {
	      // Browsers without translate() support, e.g. IE7-8
	      return 'margin';
	    }
	  };
	
	  /**
	   * Helpers
	   */
	
	  function clamp(n, min, max) {
	    if (n < min) return min;
	    if (n > max) return max;
	    return n;
	  }
	
	  /**
	   * (Internal) converts a percentage (`0..1`) to a bar translateX
	   * percentage (`-100%..0%`).
	   */
	
	  function toBarPerc(n) {
	    return (-1 + n) * 100;
	  }
	
	  /**
	   * (Internal) returns the correct CSS for changing the bar's
	   * position given an n percentage, and speed and ease from Settings
	   */
	
	  function barPositionCSS(n, speed, ease) {
	    var barCSS;
	
	    if (Settings.positionUsing === 'translate3d') {
	      barCSS = { transform: 'translate3d(' + toBarPerc(n) + '%,0,0)' };
	    } else if (Settings.positionUsing === 'translate') {
	      barCSS = { transform: 'translate(' + toBarPerc(n) + '%,0)' };
	    } else {
	      barCSS = { 'margin-left': toBarPerc(n) + '%' };
	    }
	
	    barCSS.transition = 'all ' + speed + 'ms ' + ease;
	
	    return barCSS;
	  }
	
	  /**
	   * (Internal) Queues a function to be executed.
	   */
	
	  var queue = function () {
	    var pending = [];
	
	    function next() {
	      var fn = pending.shift();
	      if (fn) {
	        fn(next);
	      }
	    }
	
	    return function (fn) {
	      pending.push(fn);
	      if (pending.length == 1) next();
	    };
	  }();
	
	  /**
	   * (Internal) Applies css properties to an element, similar to the jQuery 
	   * css method.
	   *
	   * While this helper does assist with vendor prefixed property names, it 
	   * does not perform any manipulation of values prior to setting styles.
	   */
	
	  var css = function () {
	    var cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'],
	        cssProps = {};
	
	    function camelCase(string) {
	      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function (match, letter) {
	        return letter.toUpperCase();
	      });
	    }
	
	    function getVendorProp(name) {
	      var style = document.body.style;
	      if (name in style) return name;
	
	      var i = cssPrefixes.length,
	          capName = name.charAt(0).toUpperCase() + name.slice(1),
	          vendorName;
	      while (i--) {
	        vendorName = cssPrefixes[i] + capName;
	        if (vendorName in style) return vendorName;
	      }
	
	      return name;
	    }
	
	    function getStyleProp(name) {
	      name = camelCase(name);
	      return cssProps[name] || (cssProps[name] = getVendorProp(name));
	    }
	
	    function applyCss(element, prop, value) {
	      prop = getStyleProp(prop);
	      element.style[prop] = value;
	    }
	
	    return function (element, properties) {
	      var args = arguments,
	          prop,
	          value;
	
	      if (args.length == 2) {
	        for (prop in properties) {
	          value = properties[prop];
	          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
	        }
	      } else {
	        applyCss(element, args[1], args[2]);
	      }
	    };
	  }();
	
	  /**
	   * (Internal) Determines if an element or space separated list of class names contains a class name.
	   */
	
	  function hasClass(element, name) {
	    var list = typeof element == 'string' ? element : classList(element);
	    return list.indexOf(' ' + name + ' ') >= 0;
	  }
	
	  /**
	   * (Internal) Adds a class to an element.
	   */
	
	  function addClass(element, name) {
	    var oldList = classList(element),
	        newList = oldList + name;
	
	    if (hasClass(oldList, name)) return;
	
	    // Trim the opening space.
	    element.className = newList.substring(1);
	  }
	
	  /**
	   * (Internal) Removes a class from an element.
	   */
	
	  function removeClass(element, name) {
	    var oldList = classList(element),
	        newList;
	
	    if (!hasClass(element, name)) return;
	
	    // Replace the class name.
	    newList = oldList.replace(' ' + name + ' ', ' ');
	
	    // Trim the opening and closing spaces.
	    element.className = newList.substring(1, newList.length - 1);
	  }
	
	  /**
	   * (Internal) Gets a space separated list of the class names on the element. 
	   * The list is wrapped with a single space on each end to facilitate finding 
	   * matches within the list.
	   */
	
	  function classList(element) {
	    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
	  }
	
	  /**
	   * (Internal) Removes an element from the DOM.
	   */
	
	  function removeElement(element) {
	    element && element.parentNode && element.parentNode.removeChild(element);
	  }
	
	  return NProgress;
	});

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
		Papa Parse
		v4.3.7
		https://github.com/mholt/PapaParse
		License: MIT
	*/
	(function (root, factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && typeof exports !== 'undefined') {
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.Papa = factory();
		}
	})(undefined, function () {
		'use strict';
	
		var global = function () {
			// alternative method, similar to `Function('return this')()`
			// but without using `eval` (which is disabled when
			// using Content Security Policy).
	
			if (typeof self !== 'undefined') {
				return self;
			}
			if (typeof window !== 'undefined') {
				return window;
			}
			if (typeof global !== 'undefined') {
				return global;
			}
	
			// When running tests none of the above have been defined
			return {};
		}();
	
		var IS_WORKER = !global.document && !!global.postMessage,
		    IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
		    LOADED_SYNC = false,
		    AUTO_SCRIPT_PATH;
		var workers = {},
		    workerIdCounter = 0;
	
		var Papa = {};
	
		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;
	
		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = '\uFEFF';
		Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.SCRIPT_PATH = null; // Must be set by your code if you use workers and this lib is loaded asynchronously
	
		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10; // 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5; // 5 MB
		Papa.DefaultDelimiter = ','; // Used if not specified and detection fails
	
		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;
		Papa.ReadableStreamStreamer = ReadableStreamStreamer;
	
		if (global.jQuery) {
			var $ = global.jQuery;
			$.fn.parse = function (options) {
				var config = options.config || {};
				var queue = [];
	
				this.each(function (idx) {
					var supported = $(this).prop('tagName').toUpperCase() === 'INPUT' && $(this).attr('type').toLowerCase() === 'file' && global.FileReader;
	
					if (!supported || !this.files || this.files.length === 0) return true; // continue to next input element
	
					for (var i = 0; i < this.files.length; i++) {
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});
	
				parseNextFile(); // begin parsing
				return this; // maintains chainability
	
	
				function parseNextFile() {
					if (queue.length === 0) {
						if (isFunction(options.complete)) options.complete();
						return;
					}
	
					var f = queue[0];
	
					if (isFunction(options.before)) {
						var returned = options.before(f.file, f.inputElem);
	
						if ((typeof returned === 'undefined' ? 'undefined' : _typeof(returned)) === 'object') {
							if (returned.action === 'abort') {
								error('AbortError', f.file, f.inputElem, returned.reason);
								return; // Aborts all queued files immediately
							} else if (returned.action === 'skip') {
								fileComplete(); // parse the next file in the queue, if any
								return;
							} else if (_typeof(returned.config) === 'object') f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						} else if (returned === 'skip') {
							fileComplete(); // parse the next file in the queue, if any
							return;
						}
					}
	
					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function (results) {
						if (isFunction(userCompleteFunc)) userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};
	
					Papa.parse(f.file, f.instanceConfig);
				}
	
				function error(name, file, elem, reason) {
					if (isFunction(options.error)) options.error({ name: name }, file, elem, reason);
				}
	
				function fileComplete() {
					queue.splice(0, 1);
					parseNextFile();
				}
			};
		}
	
		if (IS_PAPA_WORKER) {
			global.onmessage = workerThreadReceivedMessage;
		} else if (Papa.WORKERS_SUPPORTED) {
			AUTO_SCRIPT_PATH = getScriptPath();
	
			// Check if the script was loaded synchronously
			if (!document.body) {
				// Body doesn't exist yet, must be synchronous
				LOADED_SYNC = true;
			} else {
				document.addEventListener('DOMContentLoaded', function () {
					LOADED_SYNC = true;
				}, true);
			}
		}
	
		function CsvToJson(_input, _config) {
			_config = _config || {};
			var dynamicTyping = _config.dynamicTyping || false;
			if (isFunction(dynamicTyping)) {
				_config.dynamicTypingFunction = dynamicTyping;
				// Will be filled on first row call
				dynamicTyping = {};
			}
			_config.dynamicTyping = dynamicTyping;
	
			if (_config.worker && Papa.WORKERS_SUPPORTED) {
				var w = newWorker();
	
				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;
	
				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker; // prevent infinite loop
	
				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});
	
				return;
			}
	
			var streamer = null;
			if (typeof _input === 'string') {
				if (_config.download) streamer = new NetworkStreamer(_config);else streamer = new StringStreamer(_config);
			} else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on)) {
				streamer = new ReadableStreamStreamer(_config);
			} else if (global.File && _input instanceof File || _input instanceof Object) // ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);
	
			return streamer.stream(_input);
		}
	
		function JsonToCsv(_input, _config) {
			var _output = '';
			var _fields = [];
	
			// Default configuration
	
			/** whether to surround every datum with quotes */
			var _quotes = false;
	
			/** whether to write headers */
			var _writeHeader = true;
	
			/** delimiting character */
			var _delimiter = ',';
	
			/** newline character(s) */
			var _newline = '\r\n';
	
			/** quote character */
			var _quoteChar = '"';
	
			unpackConfig();
	
			var quoteCharRegex = new RegExp(_quoteChar, 'g');
	
			if (typeof _input === 'string') _input = JSON.parse(_input);
	
			if (_input instanceof Array) {
				if (!_input.length || _input[0] instanceof Array) return serialize(null, _input);else if (_typeof(_input[0]) === 'object') return serialize(objectKeys(_input[0]), _input);
			} else if ((typeof _input === 'undefined' ? 'undefined' : _typeof(_input)) === 'object') {
				if (typeof _input.data === 'string') _input.data = JSON.parse(_input.data);
	
				if (_input.data instanceof Array) {
					if (!_input.fields) _input.fields = _input.meta && _input.meta.fields;
	
					if (!_input.fields) _input.fields = _input.data[0] instanceof Array ? _input.fields : objectKeys(_input.data[0]);
	
					if (!(_input.data[0] instanceof Array) && _typeof(_input.data[0]) !== 'object') _input.data = [_input.data]; // handles input like [1,2,3] or ['asdf']
				}
	
				return serialize(_input.fields || [], _input.data || []);
			}
	
			// Default (any valid paths should return before this)
			throw 'exception: Unable to serialize unrecognized input';
	
			function unpackConfig() {
				if ((typeof _config === 'undefined' ? 'undefined' : _typeof(_config)) !== 'object') return;
	
				if (typeof _config.delimiter === 'string' && _config.delimiter.length === 1 && Papa.BAD_DELIMITERS.indexOf(_config.delimiter) === -1) {
					_delimiter = _config.delimiter;
				}
	
				if (typeof _config.quotes === 'boolean' || _config.quotes instanceof Array) _quotes = _config.quotes;
	
				if (typeof _config.newline === 'string') _newline = _config.newline;
	
				if (typeof _config.quoteChar === 'string') _quoteChar = _config.quoteChar;
	
				if (typeof _config.header === 'boolean') _writeHeader = _config.header;
			}
	
			/** Turns an object's keys into an array */
			function objectKeys(obj) {
				if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') return [];
				var keys = [];
				for (var key in obj) {
					keys.push(key);
				}return keys;
			}
	
			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data) {
				var csv = '';
	
				if (typeof fields === 'string') fields = JSON.parse(fields);
				if (typeof data === 'string') data = JSON.parse(data);
	
				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);
	
				// If there a header row, write it first
				if (hasHeader && _writeHeader) {
					for (var i = 0; i < fields.length; i++) {
						if (i > 0) csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0) csv += _newline;
				}
	
				// Then write out the data
				for (var row = 0; row < data.length; row++) {
					var maxCol = hasHeader ? fields.length : data[row].length;
	
					for (var col = 0; col < maxCol; col++) {
						if (col > 0) csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
	
					if (row < data.length - 1) csv += _newline;
				}
	
				return csv;
			}
	
			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col) {
				if (typeof str === 'undefined' || str === null) return '';
	
				str = str.toString().replace(quoteCharRegex, _quoteChar + _quoteChar);
	
				var needsQuotes = typeof _quotes === 'boolean' && _quotes || _quotes instanceof Array && _quotes[col] || hasAny(str, Papa.BAD_DELIMITERS) || str.indexOf(_delimiter) > -1 || str.charAt(0) === ' ' || str.charAt(str.length - 1) === ' ';
	
				return needsQuotes ? _quoteChar + str + _quoteChar : str;
			}
	
			function hasAny(str, substrings) {
				for (var i = 0; i < substrings.length; i++) {
					if (str.indexOf(substrings[i]) > -1) return true;
				}return false;
			}
		}
	
		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config) {
			this._handle = null;
			this._paused = false;
			this._finished = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = '';
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);
	
			this.parseChunk = function (chunk) {
				// First chunk pre-processing
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk)) {
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined) chunk = modifiedChunk;
				}
				this.isFirstChunk = false;
	
				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = '';
	
				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);
	
				if (this._handle.paused() || this._handle.aborted()) return;
	
				var lastIndex = results.meta.cursor;
	
				if (!this._finished) {
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}
	
				if (results && results.data) this._rowCount += results.data.length;
	
				var finishedIncludingPreview = this._finished || this._config.preview && this._rowCount >= this._config.preview;
	
				if (IS_PAPA_WORKER) {
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				} else if (isFunction(this._config.chunk)) {
					this._config.chunk(results, this._handle);
					if (this._paused) return;
					results = undefined;
					this._completeResults = undefined;
				}
	
				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}
	
				if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted)) this._config.complete(this._completeResults, this._input);
	
				if (!finishedIncludingPreview && (!results || !results.meta.paused)) this._nextChunk();
	
				return results;
			};
	
			this._sendError = function (error) {
				if (isFunction(this._config.error)) this._config.error(error);else if (IS_PAPA_WORKER && this._config.error) {
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};
	
			function replaceConfig(config) {
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize); // parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk) configCopy.chunkSize = null; // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy; // persist the copy to the caller
			}
		}
	
		function NetworkStreamer(config) {
			config = config || {};
			if (!config.chunkSize) config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);
	
			var xhr;
	
			if (IS_WORKER) {
				this._nextChunk = function () {
					this._readChunk();
					this._chunkLoaded();
				};
			} else {
				this._nextChunk = function () {
					this._readChunk();
				};
			}
	
			this.stream = function (url) {
				this._input = url;
				this._nextChunk(); // Starts streaming
			};
	
			this._readChunk = function () {
				if (this._finished) {
					this._chunkLoaded();
					return;
				}
	
				xhr = new XMLHttpRequest();
	
				if (this._config.withCredentials) {
					xhr.withCredentials = this._config.withCredentials;
				}
	
				if (!IS_WORKER) {
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}
	
				xhr.open('GET', this._input, !IS_WORKER);
				// Headers can only be set when once the request state is OPENED
				if (this._config.downloadRequestHeaders) {
					var headers = this._config.downloadRequestHeaders;
	
					for (var headerName in headers) {
						xhr.setRequestHeader(headerName, headers[headerName]);
					}
				}
	
				if (this._config.chunkSize) {
					var end = this._start + this._config.chunkSize - 1; // minus one because byte range is inclusive
					xhr.setRequestHeader('Range', 'bytes=' + this._start + '-' + end);
					xhr.setRequestHeader('If-None-Match', 'webkit-no-cache'); // https://bugs.webkit.org/show_bug.cgi?id=82672
				}
	
				try {
					xhr.send();
				} catch (err) {
					this._chunkError(err.message);
				}
	
				if (IS_WORKER && xhr.status === 0) this._chunkError();else this._start += this._config.chunkSize;
			};
	
			this._chunkLoaded = function () {
				if (xhr.readyState != 4) return;
	
				if (xhr.status < 200 || xhr.status >= 400) {
					this._chunkError();
					return;
				}
	
				this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			};
	
			this._chunkError = function (errorMessage) {
				var errorText = xhr.statusText || errorMessage;
				this._sendError(errorText);
			};
	
			function getFileSize(xhr) {
				var contentRange = xhr.getResponseHeader('Content-Range');
				if (contentRange === null) {
					// no content range, then finish!
					return -1;
				}
				return parseInt(contentRange.substr(contentRange.lastIndexOf('/') + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;
	
		function FileStreamer(config) {
			config = config || {};
			if (!config.chunkSize) config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);
	
			var reader, slice;
	
			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined'; // Safari doesn't consider it a function - see issue #105
	
			this.stream = function (file) {
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;
	
				if (usingAsyncReader) {
					reader = new FileReader(); // Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				} else reader = new FileReaderSync(); // Hack for running in a web worker in Firefox
	
				this._nextChunk(); // Starts streaming
			};
	
			this._nextChunk = function () {
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview)) this._readChunk();
			};
	
			this._readChunk = function () {
				var input = this._input;
				if (this._config.chunkSize) {
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader) this._chunkLoaded({ target: { result: txt } }); // mimic the async signature
			};
	
			this._chunkLoaded = function (event) {
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			};
	
			this._chunkError = function () {
				this._sendError(reader.error.message);
			};
		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;
	
		function StringStreamer(config) {
			config = config || {};
			ChunkStreamer.call(this, config);
	
			var string;
			var remaining;
			this.stream = function (s) {
				string = s;
				remaining = s;
				return this._nextChunk();
			};
			this._nextChunk = function () {
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk = size ? remaining.substr(0, size) : remaining;
				remaining = size ? remaining.substr(size) : '';
				this._finished = !remaining;
				return this.parseChunk(chunk);
			};
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;
	
		function ReadableStreamStreamer(config) {
			config = config || {};
	
			ChunkStreamer.call(this, config);
	
			var queue = [];
			var parseOnData = true;
	
			this.stream = function (stream) {
				this._input = stream;
	
				this._input.on('data', this._streamData);
				this._input.on('end', this._streamEnd);
				this._input.on('error', this._streamError);
			};
	
			this._nextChunk = function () {
				if (queue.length) {
					this.parseChunk(queue.shift());
				} else {
					parseOnData = true;
				}
			};
	
			this._streamData = bindFunction(function (chunk) {
				try {
					queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));
	
					if (parseOnData) {
						parseOnData = false;
						this.parseChunk(queue.shift());
					}
				} catch (error) {
					this._streamError(error);
				}
			}, this);
	
			this._streamError = bindFunction(function (error) {
				this._streamCleanUp();
				this._sendError(error.message);
			}, this);
	
			this._streamEnd = bindFunction(function () {
				this._streamCleanUp();
				this._finished = true;
				this._streamData('');
			}, this);
	
			this._streamCleanUp = bindFunction(function () {
				this._input.removeListener('data', this._streamData);
				this._input.removeListener('end', this._streamEnd);
				this._input.removeListener('error', this._streamError);
			}, this);
		}
		ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
		ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;
	
		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config) {
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
	
			var self = this;
			var _stepCounter = 0; // Number of times step was called (number of rows parsed)
			var _input; // The input being parsed
			var _parser; // The core parser being used
			var _paused = false; // Whether we are paused or not
			var _aborted = false; // Whether the parser has aborted or not
			var _delimiterError; // Temporary state between delimiter detection and processing results
			var _fields = []; // Fields are from the header row of the input, if there is one
			var _results = { // The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};
	
			if (isFunction(_config.step)) {
				var userStep = _config.step;
				_config.step = function (results) {
					_results = results;
	
					if (needsHeaderRow()) processResults();else // only call user's step function after header row
						{
							processResults();
	
							// It's possbile that this line was empty and there's no row here after all
							if (_results.data.length === 0) return;
	
							_stepCounter += results.data.length;
							if (_config.preview && _stepCounter > _config.preview) _parser.abort();else userStep(_results, self);
						}
				};
			}
	
			/**
	   * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
	   * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
	   * when an input comes in multiple chunks, like from a file.
	   */
			this.parse = function (input, baseIndex, ignoreLastRow) {
				if (!_config.newline) _config.newline = guessLineEndings(input);
	
				_delimiterError = false;
				if (!_config.delimiter) {
					var delimGuess = guessDelimiter(input, _config.newline, _config.skipEmptyLines);
					if (delimGuess.successful) _config.delimiter = delimGuess.bestDelimiter;else {
						_delimiterError = true; // add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				} else if (isFunction(_config.delimiter)) {
					_config.delimiter = _config.delimiter(input);
					_results.meta.delimiter = _config.delimiter;
				}
	
				var parserConfig = copy(_config);
				if (_config.preview && _config.header) parserConfig.preview++; // to compensate for header row
	
				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : _results || { meta: { paused: false } };
			};
	
			this.paused = function () {
				return _paused;
			};
	
			this.pause = function () {
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};
	
			this.resume = function () {
				_paused = false;
				self.streamer.parseChunk(_input);
			};
	
			this.aborted = function () {
				return _aborted;
			};
	
			this.abort = function () {
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete)) _config.complete(_results);
				_input = '';
			};
	
			function processResults() {
				if (_results && _delimiterError) {
					addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \'' + Papa.DefaultDelimiter + '\'');
					_delimiterError = false;
				}
	
				if (_config.skipEmptyLines) {
					for (var i = 0; i < _results.data.length; i++) {
						if (_results.data[i].length === 1 && _results.data[i][0] === '') _results.data.splice(i--, 1);
					}
				}
	
				if (needsHeaderRow()) fillHeaderFields();
	
				return applyHeaderAndDynamicTyping();
			}
	
			function needsHeaderRow() {
				return _config.header && _fields.length === 0;
			}
	
			function fillHeaderFields() {
				if (!_results) return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++) {
					for (var j = 0; j < _results.data[i].length; j++) {
						_fields.push(_results.data[i][j]);
					}
				}_results.data.splice(0, 1);
			}
	
			function shouldApplyDynamicTyping(field) {
				// Cache function values to avoid calling it for each row
				if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
					_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
				}
				return (_config.dynamicTyping[field] || _config.dynamicTyping) === true;
			}
	
			function parseDynamic(field, value) {
				if (shouldApplyDynamicTyping(field)) {
					if (value === 'true' || value === 'TRUE') return true;else if (value === 'false' || value === 'FALSE') return false;else return tryParseFloat(value);
				}
				return value;
			}
	
			function applyHeaderAndDynamicTyping() {
				if (!_results || !_config.header && !_config.dynamicTyping) return _results;
	
				for (var i = 0; i < _results.data.length; i++) {
					var row = _config.header ? {} : [];
	
					for (var j = 0; j < _results.data[i].length; j++) {
						var field = j;
						var value = _results.data[i][j];
	
						if (_config.header) field = j >= _fields.length ? '__parsed_extra' : _fields[j];
	
						value = parseDynamic(field, value);
	
						if (field === '__parsed_extra') {
							row[field] = row[field] || [];
							row[field].push(value);
						} else row[field] = value;
					}
	
					_results.data[i] = row;
	
					if (_config.header) {
						if (j > _fields.length) addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, i);else if (j < _fields.length) addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
					}
				}
	
				if (_config.header && _results.meta) _results.meta.fields = _fields;
				return _results;
			}
	
			function guessDelimiter(input, newline, skipEmptyLines) {
				var delimChoices = [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;
	
				for (var i = 0; i < delimChoices.length; i++) {
					var delim = delimChoices[i];
					var delta = 0,
					    avgFieldCount = 0,
					    emptyLinesCount = 0;
					fieldCountPrevRow = undefined;
	
					var preview = new Parser({
						delimiter: delim,
						newline: newline,
						preview: 10
					}).parse(input);
	
					for (var j = 0; j < preview.data.length; j++) {
						if (skipEmptyLines && preview.data[j].length === 1 && preview.data[j][0].length === 0) {
							emptyLinesCount++;
							continue;
						}
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;
	
						if (typeof fieldCountPrevRow === 'undefined') {
							fieldCountPrevRow = fieldCount;
							continue;
						} else if (fieldCount > 1) {
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}
	
					if (preview.data.length > 0) avgFieldCount /= preview.data.length - emptyLinesCount;
	
					if ((typeof bestDelta === 'undefined' || delta < bestDelta) && avgFieldCount > 1.99) {
						bestDelta = delta;
						bestDelim = delim;
					}
				}
	
				_config.delimiter = bestDelim;
	
				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				};
			}
	
			function guessLineEndings(input) {
				input = input.substr(0, 1024 * 1024); // max length 1 MB
	
				var r = input.split('\r');
	
				var n = input.split('\n');
	
				var nAppearsFirst = n.length > 1 && n[0].length < r[0].length;
	
				if (r.length === 1 || nAppearsFirst) return '\n';
	
				var numWithN = 0;
				for (var i = 0; i < r.length; i++) {
					if (r[i][0] === '\n') numWithN++;
				}
	
				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}
	
			function tryParseFloat(val) {
				var isNumber = FLOAT.test(val);
				return isNumber ? parseFloat(val) : val;
			}
	
			function addError(type, code, msg, row) {
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}
	
		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config) {
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
			/** Allows for no quoteChar by setting quoteChar to undefined in config */
			if (config.quoteChar === undefined) {
				var quoteChar = '"';
			} else {
				var quoteChar = config.quoteChar;
			}
	
			// Delimiter must be valid
			if (typeof delim !== 'string' || Papa.BAD_DELIMITERS.indexOf(delim) > -1) delim = ',';
	
			// Comment character must be valid
			if (comments === delim) throw 'Comment character same as delimiter';else if (comments === true) comments = '#';else if (typeof comments !== 'string' || Papa.BAD_DELIMITERS.indexOf(comments) > -1) comments = false;
	
			// Newline must be valid: \r, \n, or \r\n
			if (newline != '\n' && newline != '\r' && newline != '\r\n') newline = '\n';
	
			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;
	
			this.parse = function (input, baseIndex, ignoreLastRow) {
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string') throw 'Input must be a string';
	
				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
				    delimLen = delim.length,
				    newlineLen = newline.length,
				    commentsLen = comments.length;
				var stepIsFunction = isFunction(step);
	
				// Establish starting state
				cursor = 0;
				var data = [],
				    errors = [],
				    row = [],
				    lastCursor = 0;
	
				if (!input) return returnable();
	
				if (fastMode || fastMode !== false && input.indexOf(quoteChar) === -1) {
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++) {
						var row = rows[i];
						cursor += row.length;
						if (i !== rows.length - 1) cursor += newline.length;else if (ignoreLastRow) return returnable();
						if (comments && row.substr(0, commentsLen) === comments) continue;
						if (stepIsFunction) {
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted) return returnable();
						} else pushRow(row.split(delim));
						if (preview && i >= preview) {
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}
	
				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
				var quoteCharRegex = new RegExp(quoteChar + quoteChar, 'g');
	
				// Parser loop
				for (;;) {
					// Field has opening quote
					if (input[cursor] === quoteChar) {
						// Start our search for the closing quote where the cursor is
						var quoteSearch = cursor;
	
						// Skip the opening quote
						cursor++;
	
						for (;;) {
							// Find closing quote
							var quoteSearch = input.indexOf(quoteChar, quoteSearch + 1);
	
							//No other quotes are found - no other delimiters
							if (quoteSearch === -1) {
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: 'Quotes',
										code: 'MissingQuotes',
										message: 'Quoted field unterminated',
										row: data.length, // row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}
	
							// Closing quote at EOF
							if (quoteSearch === inputLen - 1) {
								var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
								return finish(value);
							}
	
							// If this quote is escaped, it's part of the data; skip it
							if (input[quoteSearch + 1] === quoteChar) {
								quoteSearch++;
								continue;
							}
	
							// Closing quote followed by delimiter
							if (input[quoteSearch + 1] === delim) {
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								cursor = quoteSearch + 1 + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}
	
							// Closing quote followed by newline
							if (input.substr(quoteSearch + 1, newlineLen) === newline) {
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								saveRow(quoteSearch + 1 + newlineLen);
								nextDelim = input.indexOf(delim, cursor); // because we may have skipped the nextDelim in the quoted field
	
								if (stepIsFunction) {
									doStep();
									if (aborted) return returnable();
								}
	
								if (preview && data.length >= preview) return returnable(true);
	
								break;
							}
	
							// Checks for valid closing quotes are complete (escaped quotes or quote followed by EOF/delimiter/newline) -- assume these quotes are part of an invalid text string
							errors.push({
								type: 'Quotes',
								code: 'InvalidQuotes',
								message: 'Trailing quote on quoted field is malformed',
								row: data.length, // row has yet to be inserted
								index: cursor
							});
	
							quoteSearch++;
							continue;
						}
	
						continue;
					}
	
					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments) {
						if (nextNewline === -1) // Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1)) {
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// End of row
					if (nextNewline !== -1) {
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);
	
						if (stepIsFunction) {
							doStep();
							if (aborted) return returnable();
						}
	
						if (preview && data.length >= preview) return returnable(true);
	
						continue;
					}
	
					break;
				}
	
				return finish();
	
				function pushRow(row) {
					data.push(row);
					lastCursor = cursor;
				}
	
				/**
	    * Appends the remaining input from cursor to the end into
	    * row, saves the row, calls step, and returns the results.
	    */
				function finish(value) {
					if (ignoreLastRow) return returnable();
					if (typeof value === 'undefined') value = input.substr(cursor);
					row.push(value);
					cursor = inputLen; // important in case parsing is paused
					pushRow(row);
					if (stepIsFunction) doStep();
					return returnable();
				}
	
				/**
	    * Appends the current row to the results. It sets the cursor
	    * to newCursor and finds the nextNewline. The caller should
	    * take care to execute user's step function and check for
	    * preview and end parsing if necessary.
	    */
				function saveRow(newCursor) {
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}
	
				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped) {
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0)
						}
					};
				}
	
				/** Executes the user's step function and resets data & errors. */
				function doStep() {
					step(returnable());
					data = [], errors = [];
				}
			};
	
			/** Sets the abort flag */
			this.abort = function () {
				aborted = true;
			};
	
			/** Gets the cursor position */
			this.getCharIndex = function () {
				return cursor;
			};
		}
	
		// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
		// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
		function getScriptPath() {
			var scripts = document.getElementsByTagName('script');
			return scripts.length ? scripts[scripts.length - 1].src : '';
		}
	
		function newWorker() {
			if (!Papa.WORKERS_SUPPORTED) return false;
			if (!LOADED_SYNC && Papa.SCRIPT_PATH === null) throw new Error('Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' + 'You need to set Papa.SCRIPT_PATH manually.');
			var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
			// Append 'papaworker' to the search string to tell papaparse that this is our worker.
			workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}
	
		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e) {
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;
	
			if (msg.error) worker.userError(msg.error, msg.file);else if (msg.results && msg.results.data) {
				var abort = function abort() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};
	
				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};
	
				if (isFunction(worker.userStep)) {
					for (var i = 0; i < msg.results.data.length; i++) {
						worker.userStep({
							data: [msg.results.data[i]],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted) break;
					}
					delete msg.results; // free memory ASAP
				} else if (isFunction(worker.userChunk)) {
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}
	
			if (msg.finished && !aborted) completeWorker(msg.workerId, msg.results);
		}
	
		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete)) worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}
	
		function notImplemented() {
			throw 'Not implemented.';
		}
	
		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e) {
			var msg = e.data;
	
			if (typeof Papa.WORKER_ID === 'undefined' && msg) Papa.WORKER_ID = msg.workerId;
	
			if (typeof msg.input === 'string') {
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			} else if (global.File && msg.input instanceof File || msg.input instanceof Object) // thank you, Safari (see issue #106)
				{
					var results = Papa.parse(msg.input, msg.config);
					if (results) global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
				}
		}
	
		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj) {
			if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj) {
				cpy[key] = copy(obj[key]);
			}return cpy;
		}
	
		function bindFunction(f, self) {
			return function () {
				f.apply(self, arguments);
			};
		}
	
		function isFunction(func) {
			return typeof func === 'function';
		}
	
		return Papa;
	});

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Selection save and restore module for Rangy.
	 * Saves and restores user selections using marker invisible elements in the DOM.
	 *
	 * Part of Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Depends on Rangy core.
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	(function (factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module with a dependency on Rangy.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(116)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object") {
	        // Node/CommonJS style
	        module.exports = factory(require("rangy"));
	    } else {
	        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
	        factory(root.rangy);
	    }
	})(function (rangy) {
	    rangy.createModule("SaveRestore", ["WrappedRange"], function (api, module) {
	        var dom = api.dom;
	        var removeNode = dom.removeNode;
	        var isDirectionBackward = api.Selection.isDirectionBackward;
	        var markerTextChar = "\uFEFF";
	
	        function gEBI(id, doc) {
	            return (doc || document).getElementById(id);
	        }
	
	        function insertRangeBoundaryMarker(range, atStart) {
	            var markerId = "selectionBoundary_" + +new Date() + "_" + ("" + Math.random()).slice(2);
	            var markerEl;
	            var doc = dom.getDocument(range.startContainer);
	
	            // Clone the Range and collapse to the appropriate boundary point
	            var boundaryRange = range.cloneRange();
	            boundaryRange.collapse(atStart);
	
	            // Create the marker element containing a single invisible character using DOM methods and insert it
	            markerEl = doc.createElement("span");
	            markerEl.id = markerId;
	            markerEl.style.lineHeight = "0";
	            markerEl.style.display = "none";
	            markerEl.className = "rangySelectionBoundary";
	            markerEl.appendChild(doc.createTextNode(markerTextChar));
	
	            boundaryRange.insertNode(markerEl);
	            return markerEl;
	        }
	
	        function setRangeBoundary(doc, range, markerId, atStart) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                range[atStart ? "setStartBefore" : "setEndBefore"](markerEl);
	                removeNode(markerEl);
	            } else {
	                module.warn("Marker element has been removed. Cannot restore selection.");
	            }
	        }
	
	        function compareRanges(r1, r2) {
	            return r2.compareBoundaryPoints(r1.START_TO_START, r1);
	        }
	
	        function saveRange(range, direction) {
	            var startEl,
	                endEl,
	                doc = api.DomRange.getRangeDocument(range),
	                text = range.toString();
	            var backward = isDirectionBackward(direction);
	
	            if (range.collapsed) {
	                endEl = insertRangeBoundaryMarker(range, false);
	                return {
	                    document: doc,
	                    markerId: endEl.id,
	                    collapsed: true
	                };
	            } else {
	                endEl = insertRangeBoundaryMarker(range, false);
	                startEl = insertRangeBoundaryMarker(range, true);
	
	                return {
	                    document: doc,
	                    startMarkerId: startEl.id,
	                    endMarkerId: endEl.id,
	                    collapsed: false,
	                    backward: backward,
	                    toString: function toString() {
	                        return "original text: '" + text + "', new text: '" + range.toString() + "'";
	                    }
	                };
	            }
	        }
	
	        function restoreRange(rangeInfo, normalize) {
	            var doc = rangeInfo.document;
	            if (typeof normalize == "undefined") {
	                normalize = true;
	            }
	            var range = api.createRange(doc);
	            if (rangeInfo.collapsed) {
	                var markerEl = gEBI(rangeInfo.markerId, doc);
	                if (markerEl) {
	                    markerEl.style.display = "inline";
	                    var previousNode = markerEl.previousSibling;
	
	                    // Workaround for issue 17
	                    if (previousNode && previousNode.nodeType == 3) {
	                        removeNode(markerEl);
	                        range.collapseToPoint(previousNode, previousNode.length);
	                    } else {
	                        range.collapseBefore(markerEl);
	                        removeNode(markerEl);
	                    }
	                } else {
	                    module.warn("Marker element has been removed. Cannot restore selection.");
	                }
	            } else {
	                setRangeBoundary(doc, range, rangeInfo.startMarkerId, true);
	                setRangeBoundary(doc, range, rangeInfo.endMarkerId, false);
	            }
	
	            if (normalize) {
	                range.normalizeBoundaries();
	            }
	
	            return range;
	        }
	
	        function saveRanges(ranges, direction) {
	            var rangeInfos = [],
	                range,
	                doc;
	            var backward = isDirectionBackward(direction);
	
	            // Order the ranges by position within the DOM, latest first, cloning the array to leave the original untouched
	            ranges = ranges.slice(0);
	            ranges.sort(compareRanges);
	
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                rangeInfos[i] = saveRange(ranges[i], backward);
	            }
	
	            // Now that all the markers are in place and DOM manipulation over, adjust each range's boundaries to lie
	            // between its markers
	            for (i = len - 1; i >= 0; --i) {
	                range = ranges[i];
	                doc = api.DomRange.getRangeDocument(range);
	                if (range.collapsed) {
	                    range.collapseAfter(gEBI(rangeInfos[i].markerId, doc));
	                } else {
	                    range.setEndBefore(gEBI(rangeInfos[i].endMarkerId, doc));
	                    range.setStartAfter(gEBI(rangeInfos[i].startMarkerId, doc));
	                }
	            }
	
	            return rangeInfos;
	        }
	
	        function saveSelection(win) {
	            if (!api.isSelectionValid(win)) {
	                module.warn("Cannot save selection. This usually happens when the selection is collapsed and the selection document has lost focus.");
	                return null;
	            }
	            var sel = api.getSelection(win);
	            var ranges = sel.getAllRanges();
	            var backward = ranges.length == 1 && sel.isBackward();
	
	            var rangeInfos = saveRanges(ranges, backward);
	
	            // Ensure current selection is unaffected
	            if (backward) {
	                sel.setSingleRange(ranges[0], backward);
	            } else {
	                sel.setRanges(ranges);
	            }
	
	            return {
	                win: win,
	                rangeInfos: rangeInfos,
	                restored: false
	            };
	        }
	
	        function restoreRanges(rangeInfos) {
	            var ranges = [];
	
	            // Ranges are in reverse order of appearance in the DOM. We want to restore earliest first to avoid
	            // normalization affecting previously restored ranges.
	            var rangeCount = rangeInfos.length;
	
	            for (var i = rangeCount - 1; i >= 0; i--) {
	                ranges[i] = restoreRange(rangeInfos[i], true);
	            }
	
	            return ranges;
	        }
	
	        function restoreSelection(savedSelection, preserveDirection) {
	            if (!savedSelection.restored) {
	                var rangeInfos = savedSelection.rangeInfos;
	                var sel = api.getSelection(savedSelection.win);
	                var ranges = restoreRanges(rangeInfos),
	                    rangeCount = rangeInfos.length;
	
	                if (rangeCount == 1 && preserveDirection && api.features.selectionHasExtend && rangeInfos[0].backward) {
	                    sel.removeAllRanges();
	                    sel.addRange(ranges[0], true);
	                } else {
	                    sel.setRanges(ranges);
	                }
	
	                savedSelection.restored = true;
	            }
	        }
	
	        function removeMarkerElement(doc, markerId) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                removeNode(markerEl);
	            }
	        }
	
	        function removeMarkers(savedSelection) {
	            var rangeInfos = savedSelection.rangeInfos;
	            for (var i = 0, len = rangeInfos.length, rangeInfo; i < len; ++i) {
	                rangeInfo = rangeInfos[i];
	                if (rangeInfo.collapsed) {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.markerId);
	                } else {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.startMarkerId);
	                    removeMarkerElement(savedSelection.doc, rangeInfo.endMarkerId);
	                }
	            }
	        }
	
	        api.util.extend(api, {
	            saveRange: saveRange,
	            restoreRange: restoreRange,
	            saveRanges: saveRanges,
	            restoreRanges: restoreRanges,
	            saveSelection: saveSelection,
	            restoreSelection: restoreSelection,
	            removeMarkerElement: removeMarkerElement,
	            removeMarkers: removeMarkers
	        });
	    });
	
	    return rangy;
	}, undefined);

/***/ },
/* 388 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Restful Resources service for AngularJS apps
	 * @version v1.5.2 - 2016-02-08 * @link https://github.com/mgonto/restangular
	 * @author Martin Gontovnikas <martin@gon.to>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */!function () {
	  var a = angular.module("restangular", []);a.provider("Restangular", function () {
	    var a = {};a.init = function (a, b) {
	      function c(a, b, c, d) {
	        var e = {};return _.each(_.keys(d), function (f) {
	          var g = d[f];g.params = _.extend({}, g.params, a.defaultRequestParams[g.method.toLowerCase()]), _.isEmpty(g.params) && delete g.params, a.isSafe(g.method) ? e[f] = function () {
	            return b(_.extend(g, { url: c }));
	          } : e[f] = function (a) {
	            return b(_.extend(g, { url: c, data: a }));
	          };
	        }), e;
	      }a.configuration = b;var d = ["get", "head", "options", "trace", "getlist"];b.isSafe = function (a) {
	        return _.includes(d, a.toLowerCase());
	      };var e = /^https?:\/\//i;b.isAbsoluteUrl = function (a) {
	        return _.isUndefined(b.absoluteUrl) || _.isNull(b.absoluteUrl) ? a && e.test(a) : b.absoluteUrl;
	      }, b.absoluteUrl = _.isUndefined(b.absoluteUrl) ? !0 : b.absoluteUrl, a.setSelfLinkAbsoluteUrl = function (a) {
	        b.absoluteUrl = a;
	      }, b.baseUrl = _.isUndefined(b.baseUrl) ? "" : b.baseUrl, a.setBaseUrl = function (a) {
	        return b.baseUrl = /\/$/.test(a) ? a.substring(0, a.length - 1) : a, this;
	      }, b.extraFields = b.extraFields || [], a.setExtraFields = function (a) {
	        return b.extraFields = a, this;
	      }, b.defaultHttpFields = b.defaultHttpFields || {}, a.setDefaultHttpFields = function (a) {
	        return b.defaultHttpFields = a, this;
	      }, b.withHttpValues = function (a, c) {
	        return _.defaults(c, a, b.defaultHttpFields);
	      }, b.encodeIds = _.isUndefined(b.encodeIds) ? !0 : b.encodeIds, a.setEncodeIds = function (a) {
	        b.encodeIds = a;
	      }, b.defaultRequestParams = b.defaultRequestParams || { get: {}, post: {}, put: {}, remove: {}, common: {} }, a.setDefaultRequestParams = function (a, c) {
	        var d = [],
	            e = c || a;return _.isUndefined(c) ? d.push("common") : _.isArray(a) ? d = a : d.push(a), _.each(d, function (a) {
	          b.defaultRequestParams[a] = e;
	        }), this;
	      }, a.requestParams = b.defaultRequestParams, b.defaultHeaders = b.defaultHeaders || {}, a.setDefaultHeaders = function (c) {
	        return b.defaultHeaders = c, a.defaultHeaders = b.defaultHeaders, this;
	      }, a.defaultHeaders = b.defaultHeaders, b.methodOverriders = b.methodOverriders || [], a.setMethodOverriders = function (a) {
	        var c = _.extend([], a);return b.isOverridenMethod("delete", c) && c.push("remove"), b.methodOverriders = c, this;
	      }, b.jsonp = _.isUndefined(b.jsonp) ? !1 : b.jsonp, a.setJsonp = function (a) {
	        b.jsonp = a;
	      }, b.isOverridenMethod = function (a, c) {
	        var d = c || b.methodOverriders;return !_.isUndefined(_.find(d, function (b) {
	          return b.toLowerCase() === a.toLowerCase();
	        }));
	      }, b.urlCreator = b.urlCreator || "path", a.setUrlCreator = function (a) {
	        if (!_.has(b.urlCreatorFactory, a)) throw new Error("URL Path selected isn't valid");return b.urlCreator = a, this;
	      }, b.restangularFields = b.restangularFields || { id: "id", route: "route", parentResource: "parentResource", restangularCollection: "restangularCollection", cannonicalId: "__cannonicalId", etag: "restangularEtag", selfLink: "href", get: "get", getList: "getList", put: "put", post: "post", remove: "remove", head: "head", trace: "trace", options: "options", patch: "patch", getRestangularUrl: "getRestangularUrl", getRequestedUrl: "getRequestedUrl", putElement: "putElement", addRestangularMethod: "addRestangularMethod", getParentList: "getParentList", clone: "clone", ids: "ids", httpConfig: "_$httpConfig", reqParams: "reqParams", one: "one", all: "all", several: "several", oneUrl: "oneUrl", allUrl: "allUrl", customPUT: "customPUT", customPOST: "customPOST", customDELETE: "customDELETE", customGET: "customGET", customGETLIST: "customGETLIST", customOperation: "customOperation", doPUT: "doPUT", doPOST: "doPOST", doDELETE: "doDELETE", doGET: "doGET", doGETLIST: "doGETLIST", fromServer: "fromServer", withConfig: "withConfig", withHttpConfig: "withHttpConfig", singleOne: "singleOne", plain: "plain", save: "save", restangularized: "restangularized" }, a.setRestangularFields = function (a) {
	        return b.restangularFields = _.extend(b.restangularFields, a), this;
	      }, b.isRestangularized = function (a) {
	        return !!a[b.restangularFields.restangularized];
	      }, b.setFieldToElem = function (a, b, c) {
	        var d = a.split("."),
	            e = b;return _.each(_.initial(d), function (a) {
	          e[a] = {}, e = e[a];
	        }), e[_.last(d)] = c, this;
	      }, b.getFieldFromElem = function (a, b) {
	        var c = a.split("."),
	            d = b;return _.each(c, function (a) {
	          d && (d = d[a]);
	        }), angular.copy(d);
	      }, b.setIdToElem = function (a, c) {
	        return b.setFieldToElem(b.restangularFields.id, a, c), this;
	      }, b.getIdFromElem = function (a) {
	        return b.getFieldFromElem(b.restangularFields.id, a);
	      }, b.isValidId = function (a) {
	        return "" !== a && !_.isUndefined(a) && !_.isNull(a);
	      }, b.setUrlToElem = function (a, c) {
	        return b.setFieldToElem(b.restangularFields.selfLink, a, c), this;
	      }, b.getUrlFromElem = function (a) {
	        return b.getFieldFromElem(b.restangularFields.selfLink, a);
	      }, b.useCannonicalId = _.isUndefined(b.useCannonicalId) ? !1 : b.useCannonicalId, a.setUseCannonicalId = function (a) {
	        return b.useCannonicalId = a, this;
	      }, b.getCannonicalIdFromElem = function (a) {
	        var c = a[b.restangularFields.cannonicalId],
	            d = b.isValidId(c) ? c : b.getIdFromElem(a);return d;
	      }, b.responseInterceptors = b.responseInterceptors || [], b.defaultResponseInterceptor = function (a) {
	        return a;
	      }, b.responseExtractor = function (a, c, d, e, f, g) {
	        var h = angular.copy(b.responseInterceptors);h.push(b.defaultResponseInterceptor);var i = a;return _.each(h, function (a) {
	          i = a(i, c, d, e, f, g);
	        }), i;
	      }, a.addResponseInterceptor = function (a) {
	        return b.responseInterceptors.push(a), this;
	      }, b.errorInterceptors = b.errorInterceptors || [], a.addErrorInterceptor = function (a) {
	        return b.errorInterceptors.push(a), this;
	      }, a.setResponseInterceptor = a.addResponseInterceptor, a.setResponseExtractor = a.addResponseInterceptor, a.setErrorInterceptor = a.addErrorInterceptor, b.requestInterceptors = b.requestInterceptors || [], b.defaultInterceptor = function (a, b, c, d, e, f, g) {
	        return { element: a, headers: e, params: f, httpConfig: g };
	      }, b.fullRequestInterceptor = function (a, c, d, e, f, g, h) {
	        var i = angular.copy(b.requestInterceptors),
	            j = b.defaultInterceptor(a, c, d, e, f, g, h);return _.reduce(i, function (a, b) {
	          return _.extend(a, b(a.element, c, d, e, a.headers, a.params, a.httpConfig));
	        }, j);
	      }, a.addRequestInterceptor = function (a) {
	        return b.requestInterceptors.push(function (b, c, d, e, f, g, h) {
	          return { headers: f, params: g, element: a(b, c, d, e), httpConfig: h };
	        }), this;
	      }, a.setRequestInterceptor = a.addRequestInterceptor, a.addFullRequestInterceptor = function (a) {
	        return b.requestInterceptors.push(a), this;
	      }, a.setFullRequestInterceptor = a.addFullRequestInterceptor, b.onBeforeElemRestangularized = b.onBeforeElemRestangularized || function (a) {
	        return a;
	      }, a.setOnBeforeElemRestangularized = function (a) {
	        return b.onBeforeElemRestangularized = a, this;
	      }, a.setRestangularizePromiseInterceptor = function (a) {
	        return b.restangularizePromiseInterceptor = a, this;
	      }, b.onElemRestangularized = b.onElemRestangularized || function (a) {
	        return a;
	      }, a.setOnElemRestangularized = function (a) {
	        return b.onElemRestangularized = a, this;
	      }, b.shouldSaveParent = b.shouldSaveParent || function () {
	        return !0;
	      }, a.setParentless = function (a) {
	        return _.isArray(a) ? b.shouldSaveParent = function (b) {
	          return !_.includes(a, b);
	        } : _.isBoolean(a) && (b.shouldSaveParent = function () {
	          return !a;
	        }), this;
	      }, b.suffix = _.isUndefined(b.suffix) ? null : b.suffix, a.setRequestSuffix = function (a) {
	        return b.suffix = a, this;
	      }, b.transformers = b.transformers || {}, a.addElementTransformer = function (c, d, e) {
	        var f = null,
	            g = null;2 === arguments.length ? g = d : (g = e, f = d);var h = b.transformers[c];return h || (h = b.transformers[c] = []), h.push(function (a, b) {
	          return _.isNull(f) || a === f ? g(b) : b;
	        }), a;
	      }, a.extendCollection = function (b, c) {
	        return a.addElementTransformer(b, !0, c);
	      }, a.extendModel = function (b, c) {
	        return a.addElementTransformer(b, !1, c);
	      }, b.transformElem = function (a, c, d, e, f) {
	        if (!f && !b.transformLocalElements && !a[b.restangularFields.fromServer]) return a;var g = b.transformers[d],
	            h = a;return g && _.each(g, function (a) {
	          h = a(c, h);
	        }), b.onElemRestangularized(h, c, d, e);
	      }, b.transformLocalElements = _.isUndefined(b.transformLocalElements) ? !1 : b.transformLocalElements, a.setTransformOnlyServerElements = function (a) {
	        b.transformLocalElements = !a;
	      }, b.fullResponse = _.isUndefined(b.fullResponse) ? !1 : b.fullResponse, a.setFullResponse = function (a) {
	        return b.fullResponse = a, this;
	      }, b.urlCreatorFactory = {};var f = function f() {};f.prototype.setConfig = function (a) {
	        return this.config = a, this;
	      }, f.prototype.parentsArray = function (a) {
	        for (var b = []; a;) {
	          b.push(a), a = a[this.config.restangularFields.parentResource];
	        }return b.reverse();
	      }, f.prototype.resource = function (a, d, e, f, g, h, i, j) {
	        var k = _.defaults(g || {}, this.config.defaultRequestParams.common),
	            l = _.defaults(f || {}, this.config.defaultHeaders);i && (b.isSafe(j) ? l["If-None-Match"] = i : l["If-Match"] = i);var m = this.base(a);if (h) {
	          var n = "";/\/$/.test(m) || (n += "/"), n += h, m += n;
	        }return this.config.suffix && -1 === m.indexOf(this.config.suffix, m.length - this.config.suffix.length) && !this.config.getUrlFromElem(a) && (m += this.config.suffix), a[this.config.restangularFields.httpConfig] = void 0, c(this.config, d, m, { getList: this.config.withHttpValues(e, { method: "GET", params: k, headers: l }), get: this.config.withHttpValues(e, { method: "GET", params: k, headers: l }), jsonp: this.config.withHttpValues(e, { method: "jsonp", params: k, headers: l }), put: this.config.withHttpValues(e, { method: "PUT", params: k, headers: l }), post: this.config.withHttpValues(e, { method: "POST", params: k, headers: l }), remove: this.config.withHttpValues(e, { method: "DELETE", params: k, headers: l }), head: this.config.withHttpValues(e, { method: "HEAD", params: k, headers: l }), trace: this.config.withHttpValues(e, { method: "TRACE", params: k, headers: l }), options: this.config.withHttpValues(e, { method: "OPTIONS", params: k, headers: l }), patch: this.config.withHttpValues(e, { method: "PATCH", params: k, headers: l }) });
	      };var g = function g() {};g.prototype = new f(), g.prototype.normalizeUrl = function (a) {
	        var b = /(http[s]?:\/\/)?(.*)?/.exec(a);return b[2] = b[2].replace(/[\\\/]+/g, "/"), "undefined" != typeof b[1] ? b[1] + b[2] : b[2];
	      }, g.prototype.base = function (a) {
	        var c = this;return _.reduce(this.parentsArray(a), function (a, d) {
	          var e,
	              f = c.config.getUrlFromElem(d);if (f) {
	            if (c.config.isAbsoluteUrl(f)) return f;e = f;
	          } else if (e = d[c.config.restangularFields.route], d[c.config.restangularFields.restangularCollection]) {
	            var g = d[c.config.restangularFields.ids];g && (e += "/" + g.join(","));
	          } else {
	            var h;h = c.config.useCannonicalId ? c.config.getCannonicalIdFromElem(d) : c.config.getIdFromElem(d), b.isValidId(h) && !d.singleOne && (e += "/" + (c.config.encodeIds ? encodeURIComponent(h) : h));
	          }return a = a.replace(/\/$/, "") + "/" + e, c.normalizeUrl(a);
	        }, this.config.baseUrl);
	      }, g.prototype.fetchUrl = function (a, b) {
	        var c = this.base(a);return b && (c += "/" + b), c;
	      }, g.prototype.fetchRequestedUrl = function (a, c) {
	        function d(a) {
	          var b = [];for (var c in a) {
	            a.hasOwnProperty(c) && b.push(c);
	          }return b.sort();
	        }function e(a, b, c) {
	          for (var e = d(a), f = 0; f < e.length; f++) {
	            b.call(c, a[e[f]], e[f]);
	          }return e;
	        }function f(a, b) {
	          return encodeURIComponent(a).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, b ? "%20" : "+");
	        }var g = this.fetchUrl(a, c),
	            h = a[b.restangularFields.reqParams];if (!h) return g + (this.config.suffix || "");var i = [];return e(h, function (a, b) {
	          null !== a && void 0 !== a && (angular.isArray(a) || (a = [a]), angular.forEach(a, function (a) {
	            angular.isObject(a) && (a = angular.toJson(a)), i.push(f(b) + "=" + f(a));
	          }));
	        }), g + (this.config.suffix || "") + (-1 === g.indexOf("?") ? "?" : "&") + i.join("&");
	      }, b.urlCreatorFactory.path = g;
	    };var b = {};a.init(this, b), this.$get = ["$http", "$q", function (c, d) {
	      function e(b) {
	        function f(a, c, d, e, f) {
	          if (c[b.restangularFields.route] = d, c[b.restangularFields.getRestangularUrl] = _.bind(P.fetchUrl, P, c), c[b.restangularFields.getRequestedUrl] = _.bind(P.fetchRequestedUrl, P, c), c[b.restangularFields.addRestangularMethod] = _.bind(L, c), c[b.restangularFields.clone] = _.bind(r, c, c), c[b.restangularFields.reqParams] = _.isEmpty(e) ? null : e, c[b.restangularFields.withHttpConfig] = _.bind(z, c), c[b.restangularFields.plain] = _.bind(p, c, c), c[b.restangularFields.restangularized] = !0, c[b.restangularFields.one] = _.bind(g, c, c), c[b.restangularFields.all] = _.bind(h, c, c), c[b.restangularFields.several] = _.bind(i, c, c), c[b.restangularFields.oneUrl] = _.bind(j, c, c), c[b.restangularFields.allUrl] = _.bind(k, c, c), c[b.restangularFields.fromServer] = !!f, a && b.shouldSaveParent(d)) {
	            var l = b.getIdFromElem(a),
	                m = b.getUrlFromElem(a),
	                n = _.union(_.values(_.pick(b.restangularFields, ["route", "singleOne", "parentResource"])), b.extraFields),
	                o = _.pick(a, n);b.isValidId(l) && b.setIdToElem(o, l, d), b.isValidId(m) && b.setUrlToElem(o, m, d), c[b.restangularFields.parentResource] = o;
	          } else c[b.restangularFields.parentResource] = null;return c;
	        }function g(a, c, d, e) {
	          var f;if (_.isNumber(c) || _.isNumber(a)) throw f = "You're creating a Restangular entity with the number ", f += "instead of the route or the parent. For example, you can't call .one(12).", new Error(f);if (_.isUndefined(c)) throw f = "You're creating a Restangular entity either without the path. ", f += "For example you can't call .one(). Please check if your arguments are valid.", new Error(f);var g = {};return b.setIdToElem(g, d, c), b.setFieldToElem(b.restangularFields.singleOne, g, e), s(a, g, c, !1);
	        }function h(a, b) {
	          return t(a, [], b, !1);
	        }function i(a, c) {
	          var d = [];return d[b.restangularFields.ids] = Array.prototype.splice.call(arguments, 2), t(a, d, c, !1);
	        }function j(a, c, d) {
	          if (!c) throw new Error("Route is mandatory when creating new Restangular objects.");var e = {};return b.setUrlToElem(e, d, c), s(a, e, c, !1);
	        }function k(a, c, d) {
	          if (!c) throw new Error("Route is mandatory when creating new Restangular objects.");var e = {};return b.setUrlToElem(e, d, c), t(a, e, c, !1);
	        }function l(a, c, d) {
	          return a.call = _.bind(m, a), a.get = _.bind(n, a), a[b.restangularFields.restangularCollection] = c, c && (a.push = _.bind(m, a, "push")), a.$object = d, b.restangularizePromiseInterceptor && b.restangularizePromiseInterceptor(a), a;
	        }function m(a) {
	          var c = d.defer(),
	              e = arguments,
	              f = {};return this.then(function (b) {
	            var d = Array.prototype.slice.call(e, 1),
	                g = b[a];g.apply(b, d), f = b, c.resolve(b);
	          }), l(c.promise, this[b.restangularFields.restangularCollection], f);
	        }function n(a) {
	          var c = d.defer(),
	              e = {};return this.then(function (b) {
	            e = b[a], c.resolve(e);
	          }), l(c.promise, this[b.restangularFields.restangularCollection], e);
	        }function o(a, c, d, e) {
	          return _.extend(e, d), b.fullResponse ? a.resolve(_.extend(c, { data: d })) : void a.resolve(d);
	        }function p(a) {
	          if (_.isArray(a)) {
	            var c = [];return _.each(a, function (a) {
	              c.push(b.isRestangularized(a) ? p(a) : a);
	            }), c;
	          }return _.omit(a, _.values(_.omit(b.restangularFields, "id")));
	        }function q(a) {
	          a[b.restangularFields.customOperation] = _.bind(K, a), _.each(["put", "post", "get", "delete"], function (b) {
	            _.each(["do", "custom"], function (c) {
	              var d,
	                  e = "delete" === b ? "remove" : b,
	                  f = c + b.toUpperCase();d = "put" !== e && "post" !== e ? K : function (a, b, c, d, e) {
	                return _.bind(K, this)(a, c, d, e, b);
	              }, a[f] = _.bind(d, a, e);
	            });
	          }), a[b.restangularFields.customGETLIST] = _.bind(y, a), a[b.restangularFields.doGETLIST] = a[b.restangularFields.customGETLIST];
	        }function r(a, c) {
	          var d = angular.copy(a, c);return s(d[b.restangularFields.parentResource], d, d[b.restangularFields.route], !0);
	        }function s(a, c, d, e, g, h) {
	          var i = b.onBeforeElemRestangularized(c, !1, d),
	              j = f(a, i, d, h, e);return b.useCannonicalId && (j[b.restangularFields.cannonicalId] = b.getIdFromElem(j)), g && (j[b.restangularFields.getParentList] = function () {
	            return g;
	          }), j[b.restangularFields.restangularCollection] = !1, j[b.restangularFields.get] = _.bind(C, j), j[b.restangularFields.getList] = _.bind(y, j), j[b.restangularFields.put] = _.bind(E, j), j[b.restangularFields.post] = _.bind(F, j), j[b.restangularFields.remove] = _.bind(D, j), j[b.restangularFields.head] = _.bind(G, j), j[b.restangularFields.trace] = _.bind(H, j), j[b.restangularFields.options] = _.bind(I, j), j[b.restangularFields.patch] = _.bind(J, j), j[b.restangularFields.save] = _.bind(A, j), q(j), b.transformElem(j, !1, d, O, !0);
	        }function t(a, c, d, e, g) {
	          var h = b.onBeforeElemRestangularized(c, !0, d),
	              i = f(a, h, d, g, e);return i[b.restangularFields.restangularCollection] = !0, i[b.restangularFields.post] = _.bind(F, i, null), i[b.restangularFields.remove] = _.bind(D, i), i[b.restangularFields.head] = _.bind(G, i), i[b.restangularFields.trace] = _.bind(H, i), i[b.restangularFields.putElement] = _.bind(w, i), i[b.restangularFields.options] = _.bind(I, i), i[b.restangularFields.patch] = _.bind(J, i), i[b.restangularFields.get] = _.bind(v, i), i[b.restangularFields.getList] = _.bind(y, i, null), q(i), b.transformElem(i, !0, d, O, !0);
	        }function u(a, b, c) {
	          var d = t(a, b, c, !1);return _.each(d, function (b) {
	            s(a, b, c, !1);
	          }), d;
	        }function v(a, b, c) {
	          return this.customGET(a.toString(), b, c);
	        }function w(a, c, e) {
	          var f = this,
	              g = this[a],
	              h = d.defer(),
	              i = [];return i = b.transformElem(i, !0, g[b.restangularFields.route], O), g.put(c, e).then(function (b) {
	            var c = r(f);c[a] = b, i = c, h.resolve(c);
	          }, function (a) {
	            h.reject(a);
	          }), l(h.promise, !0, i);
	        }function x(a, c, d, e, f, g) {
	          var h = b.responseExtractor(a, c, d, e, f, g),
	              i = f.headers("ETag");return h && i && (h[b.restangularFields.etag] = i), h;
	        }function y(a, e, f) {
	          var g = this,
	              h = d.defer(),
	              i = "getList",
	              j = P.fetchUrl(this, a),
	              k = a || g[b.restangularFields.route],
	              m = b.fullRequestInterceptor(null, i, k, j, f || {}, e || {}, this[b.restangularFields.httpConfig] || {}),
	              n = [];n = b.transformElem(n, !0, k, O);var p = "getList";b.jsonp && (p = "jsonp");var q = function q(c) {
	            var d = c.data,
	                e = c.config.params,
	                f = x(d, i, k, j, c, h);if ((_.isUndefined(f) || "" === f) && (f = []), !_.isArray(f)) throw new Error("Response for getList SHOULD be an array and not an object or something else");var l = _.map(f, function (c) {
	              return g[b.restangularFields.restangularCollection] ? s(g[b.restangularFields.parentResource], c, g[b.restangularFields.route], !0, f) : s(g, c, a, !0, f);
	            });l = _.extend(f, l), g[b.restangularFields.restangularCollection] ? o(h, c, t(g[b.restangularFields.parentResource], l, g[b.restangularFields.route], !0, e), n) : o(h, c, t(g, l, a, !0, e), n);
	          };return P.resource(this, c, m.httpConfig, m.headers, m.params, a, this[b.restangularFields.etag], i)[p]().then(q, function (a) {
	            304 === a.status && g[b.restangularFields.restangularCollection] ? o(h, a, g, n) : _.every(b.errorInterceptors, function (b) {
	              return b(a, h, q) !== !1;
	            }) && h.reject(a);
	          }), l(h.promise, !0, n);
	        }function z(a) {
	          return this[b.restangularFields.httpConfig] = a, this;
	        }function A(a, c) {
	          return this[b.restangularFields.fromServer] ? this[b.restangularFields.put](a, c) : _.bind(B, this)("post", void 0, a, void 0, c);
	        }function B(a, e, f, g, h) {
	          var i = this,
	              j = d.defer(),
	              k = f || {},
	              m = e || this[b.restangularFields.route],
	              n = P.fetchUrl(this, e),
	              q = g || this,
	              r = q[b.restangularFields.etag] || ("post" !== a ? this[b.restangularFields.etag] : null);_.isObject(q) && b.isRestangularized(q) && (q = p(q));var t = b.fullRequestInterceptor(q, a, m, n, h || {}, k || {}, this[b.restangularFields.httpConfig] || {}),
	              u = {};u = b.transformElem(u, !1, m, O);var v = function v(c) {
	            var d = c.data,
	                e = c.config.params,
	                f = x(d, a, m, n, c, j);if (f) {
	              var g;"post" !== a || i[b.restangularFields.restangularCollection] ? (g = s(i[b.restangularFields.parentResource], f, i[b.restangularFields.route], !0, null, e), g[b.restangularFields.singleOne] = i[b.restangularFields.singleOne], o(j, c, g, u)) : (g = s(i[b.restangularFields.parentResource], f, m, !0, null, e), o(j, c, g, u));
	            } else o(j, c, void 0, u);
	          },
	              w = function w(c) {
	            304 === c.status && b.isSafe(a) ? o(j, c, i, u) : _.every(b.errorInterceptors, function (a) {
	              return a(c, j, v) !== !1;
	            }) && j.reject(c);
	          },
	              y = a,
	              z = _.extend({}, t.headers),
	              A = b.isOverridenMethod(a);return A ? (y = "post", z = _.extend(z, { "X-HTTP-Method-Override": "remove" === a ? "DELETE" : a.toUpperCase() })) : b.jsonp && "get" === y && (y = "jsonp"), b.isSafe(a) ? A ? P.resource(this, c, t.httpConfig, z, t.params, e, r, y)[y]({}).then(v, w) : P.resource(this, c, t.httpConfig, z, t.params, e, r, y)[y]().then(v, w) : P.resource(this, c, t.httpConfig, z, t.params, e, r, y)[y](t.element).then(v, w), l(j.promise, !1, u);
	        }function C(a, b) {
	          return _.bind(B, this)("get", void 0, a, void 0, b);
	        }function D(a, b) {
	          return _.bind(B, this)("remove", void 0, a, void 0, b);
	        }function E(a, b) {
	          return _.bind(B, this)("put", void 0, a, void 0, b);
	        }function F(a, b, c, d) {
	          return _.bind(B, this)("post", a, c, b, d);
	        }function G(a, b) {
	          return _.bind(B, this)("head", void 0, a, void 0, b);
	        }function H(a, b) {
	          return _.bind(B, this)("trace", void 0, a, void 0, b);
	        }function I(a, b) {
	          return _.bind(B, this)("options", void 0, a, void 0, b);
	        }function J(a, b, c) {
	          return _.bind(B, this)("patch", void 0, b, a, c);
	        }function K(a, b, c, d, e) {
	          return _.bind(B, this)(a, b, c, e, d);
	        }function L(a, c, d, e, f, g) {
	          var h;h = "getList" === c ? _.bind(y, this, d) : _.bind(K, this, c, d);var i = function i(a, b, c) {
	            var d = _.defaults({ params: a, headers: b, elem: c }, { params: e, headers: f, elem: g });return h(d.params, d.headers, d.elem);
	          };b.isSafe(c) ? this[a] = i : this[a] = function (a, b, c) {
	            return i(b, c, a);
	          };
	        }function M(c) {
	          var d = angular.copy(_.omit(b, "configuration"));return a.init(d, d), c(d), e(d);
	        }function N(a, c) {
	          var d = _.values(b.restangularFields),
	              e = {},
	              f = (c || O).all(a);e.one = _.bind(g, c || O, c, a), e.post = _.bind(f.post, f), e.getList = _.bind(f.getList, f);for (var h in f) {
	            f.hasOwnProperty(h) && _.isFunction(f[h]) && !_.includes(d, h) && (e[h] = _.bind(f[h], f));
	          }return e;
	        }var O = {},
	            P = new b.urlCreatorFactory[b.urlCreator]();return P.setConfig(b), a.init(O, b), O.copy = _.bind(r, O), O.service = _.bind(N, O), O.withConfig = _.bind(M, O), O.one = _.bind(g, O, null), O.all = _.bind(h, O, null), O.several = _.bind(i, O, null), O.oneUrl = _.bind(j, O, null), O.allUrl = _.bind(k, O, null), O.stripRestangular = _.bind(p, O), O.restangularizeElement = _.bind(s, O), O.restangularizeCollection = _.bind(u, O), O;
	      }return e(b);
	    }];
	  });
	}();

/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @license AngularJS v1.3.10
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function (window, angular, undefined) {
	  'use strict';
	
	  var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	  /**
	   * @ngdoc module
	   * @name ngSanitize
	   * @description
	   *
	   * # ngSanitize
	   *
	   * The `ngSanitize` module provides functionality to sanitize HTML.
	   *
	   *
	   * <div doc-module-components="ngSanitize"></div>
	   *
	   * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	   */
	
	  /*
	   * HTML Parser By Misko Hevery (misko@hevery.com)
	   * based on:  HTML Parser By John Resig (ejohn.org)
	   * Original code by Erik Arvidsson, Mozilla Public License
	   * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	   *
	   * // Use like so:
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs, unary) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   */
	
	  /**
	   * @ngdoc service
	   * @name $sanitize
	   * @kind function
	   *
	   * @description
	   *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	   *   then serialized back to properly escaped html string. This means that no unsafe input can make
	   *   it into the returned string, however, since our parser is more strict than a typical browser
	   *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	   *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	   *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	   *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	   *
	   * @param {string} html HTML input.
	   * @returns {string} Sanitized HTML.
	   *
	   * @example
	     <example module="sanitizeExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	           angular.module('sanitizeExample', ['ngSanitize'])
	             .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	               $scope.snippet =
	                 '<p style="color:blue">an html\n' +
	                 '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	                 'snippet</p>';
	               $scope.deliberatelyTrustDangerousSnippet = function() {
	                 return $sce.trustAsHtml($scope.snippet);
	               };
	             }]);
	       </script>
	       <div ng-controller="ExampleController">
	          Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	         <table>
	           <tr>
	             <td>Directive</td>
	             <td>How</td>
	             <td>Source</td>
	             <td>Rendered</td>
	           </tr>
	           <tr id="bind-html-with-sanitize">
	             <td>ng-bind-html</td>
	             <td>Automatically uses $sanitize</td>
	             <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	             <td><div ng-bind-html="snippet"></div></td>
	           </tr>
	           <tr id="bind-html-with-trust">
	             <td>ng-bind-html</td>
	             <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	             <td>
	             <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	  &lt;/div&gt;</pre>
	             </td>
	             <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	           </tr>
	           <tr id="bind-default">
	             <td>ng-bind</td>
	             <td>Automatically escapes</td>
	             <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	             <td><div ng-bind="snippet"></div></td>
	           </tr>
	         </table>
	         </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should sanitize the html snippet by default', function() {
	         expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	           toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	       });
	  
	       it('should inline raw snippet if bound to a trusted value', function() {
	         expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	           toBe("<p style=\"color:blue\">an html\n" +
	                "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	                "snippet</p>");
	       });
	  
	       it('should escape snippet without any filter', function() {
	         expect(element(by.css('#bind-default div')).getInnerHtml()).
	           toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	                "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	                "snippet&lt;/p&gt;");
	       });
	  
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	         expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	           toBe('new <b>text</b>');
	         expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	           'new <b onclick="alert(1)">text</b>');
	         expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	           "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	       });
	     </file>
	     </example>
	   */
	  function $SanitizeProvider() {
	    this.$get = ['$$sanitizeUri', function ($$sanitizeUri) {
	      return function (html) {
	        if (typeof arguments[1] != 'undefined') {
	          arguments[1].version = 'taSanitize';
	        }
	        var buf = [];
	        htmlParser(html, htmlSanitizeWriter(buf, function (uri, isImage) {
	          return !/^unsafe/.test($$sanitizeUri(uri, isImage));
	        }));
	        return buf.join('');
	      };
	    }];
	  }
	
	  function sanitizeText(chars) {
	    var buf = [];
	    var writer = htmlSanitizeWriter(buf, angular.noop);
	    writer.chars(chars);
	    return buf.join('');
	  }
	
	  // Regular Expressions for parsing tags and attributes
	  var START_TAG_REGEXP = /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
	      END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
	      ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
	      BEGIN_TAG_REGEXP = /^</,
	      BEGING_END_TAGE_REGEXP = /^<\//,
	      COMMENT_REGEXP = /<!--(.*?)-->/g,
	      DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
	      CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
	      SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = makeMap("area,br,col,hr,img,wbr,input");
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	      optionalEndTagInlineElements = makeMap("rp,rt"),
	      optionalEndTagElements = angular.extend({}, optionalEndTagInlineElements, optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," + "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," + "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));
	
	  // Inline Elements - HTML5
	  var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," + "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," + "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  var svgElements = makeMap("animate,animateColor,animateMotion,animateTransform,circle,defs," + "desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient," + "line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set," + "stop,svg,switch,text,title,tspan,use");
	
	  // Special Elements (can contain anything)
	  var specialElements = makeMap("script,style");
	
	  var validElements = angular.extend({}, voidElements, blockElements, inlineElements, optionalEndTagElements, svgElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");
	
	  var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' + 'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' + 'id,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' + 'scope,scrolling,shape,size,span,start,summary,target,title,type,' + 'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' + 'attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,' + 'color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,' + 'font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,' + 'gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,' + 'keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,' + 'markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,' + 'overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,' + 'repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,' + 'stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,' + 'stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,' + 'stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,' + 'underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,' + 'viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,' + 'xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,' + 'zoomAndPan');
	
	  var validAttrs = angular.extend({}, uriAttrs, svgAttrs, htmlAttrs);
	
	  function makeMap(str) {
	    var obj = {},
	        items = str.split(','),
	        i;
	    for (i = 0; i < items.length; i++) {
	      obj[items[i]] = true;
	    }return obj;
	  }
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs, unary) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParser(html, handler) {
	    if (typeof html !== 'string') {
	      if (html === null || typeof html === 'undefined') {
	        html = '';
	      } else {
	        html = '' + html;
	      }
	    }
	    var index,
	        chars,
	        match,
	        stack = [],
	        last = html,
	        text;
	    stack.last = function () {
	      return stack[stack.length - 1];
	    };
	
	    while (html) {
	      text = '';
	      chars = true;
	
	      // Make sure we're not in a script or style element
	      if (!stack.last() || !specialElements[stack.last()]) {
	
	        // Comment
	        if (html.indexOf("<!--") === 0) {
	          // comments containing -- are not allowed unless they terminate the comment
	          index = html.indexOf("--", 4);
	
	          if (index >= 0 && html.lastIndexOf("-->", index) === index) {
	            if (handler.comment) handler.comment(html.substring(4, index));
	            html = html.substring(index + 3);
	            chars = false;
	          }
	          // DOCTYPE
	        } else if (DOCTYPE_REGEXP.test(html)) {
	          match = html.match(DOCTYPE_REGEXP);
	
	          if (match) {
	            html = html.replace(match[0], '');
	            chars = false;
	          }
	          // end tag
	        } else if (BEGING_END_TAGE_REGEXP.test(html)) {
	          match = html.match(END_TAG_REGEXP);
	
	          if (match) {
	            html = html.substring(match[0].length);
	            match[0].replace(END_TAG_REGEXP, parseEndTag);
	            chars = false;
	          }
	
	          // start tag
	        } else if (BEGIN_TAG_REGEXP.test(html)) {
	          match = html.match(START_TAG_REGEXP);
	
	          if (match) {
	            // We only have a valid start-tag if there is a '>'.
	            if (match[4]) {
	              html = html.substring(match[0].length);
	              match[0].replace(START_TAG_REGEXP, parseStartTag);
	            }
	            chars = false;
	          } else {
	            // no ending tag found --- this piece should be encoded as an entity.
	            text += '<';
	            html = html.substring(1);
	          }
	        }
	
	        if (chars) {
	          index = html.indexOf("<");
	
	          text += index < 0 ? html : html.substring(0, index);
	          html = index < 0 ? "" : html.substring(index);
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	        }
	      } else {
	        html = html.replace(new RegExp("([^]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'), function (all, text) {
	          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	
	          return "";
	        });
	
	        parseEndTag("", stack.last());
	      }
	
	      if (html == last) {
	        throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " + "of html: {0}", html);
	      }
	      last = html;
	    }
	
	    // Clean up any remaining tags
	    parseEndTag();
	
	    function parseStartTag(tag, tagName, rest, unary) {
	      tagName = angular.lowercase(tagName);
	      if (blockElements[tagName]) {
	        while (stack.last() && inlineElements[stack.last()]) {
	          parseEndTag("", stack.last());
	        }
	      }
	
	      if (optionalEndTagElements[tagName] && stack.last() == tagName) {
	        parseEndTag("", tagName);
	      }
	
	      unary = voidElements[tagName] || !!unary;
	
	      if (!unary) stack.push(tagName);
	
	      var attrs = {};
	
	      rest.replace(ATTR_REGEXP, function (match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
	        var value = doubleQuotedValue || singleQuotedValue || unquotedValue || '';
	
	        attrs[name] = decodeEntities(value);
	      });
	      if (handler.start) handler.start(tagName, attrs, unary);
	    }
	
	    function parseEndTag(tag, tagName) {
	      var pos = 0,
	          i;
	      tagName = angular.lowercase(tagName);
	      if (tagName)
	        // Find the closest opened tag of the same type
	        for (pos = stack.length - 1; pos >= 0; pos--) {
	          if (stack[pos] == tagName) break;
	        }if (pos >= 0) {
	        // Close all the open elements, up the stack
	        for (i = stack.length - 1; i >= pos; i--) {
	          if (handler.end) handler.end(stack[i]);
	        } // Remove the open elements from the stack
	        stack.length = pos;
	      }
	    }
	  }
	
	  var hiddenPre = document.createElement("pre");
	  var spaceRe = /^(\s*)([\s\S]*?)(\s*)$/;
	  /**
	   * decodes all entities into regular string
	   * @param value
	   * @returns {string} A string with decoded entities.
	   */
	  function decodeEntities(value) {
	    if (!value) {
	      return '';
	    }
	
	    // Note: IE8 does not preserve spaces at the start/end of innerHTML
	    // so we must capture them and reattach them afterward
	    var parts = spaceRe.exec(value);
	    var spaceBefore = parts[1];
	    var spaceAfter = parts[3];
	    var content = parts[2];
	    if (content) {
	      hiddenPre.innerHTML = content.replace(/</g, "&lt;");
	      // innerText depends on styling as it doesn't display hidden elements.
	      // Therefore, it's better to use textContent not to cause unnecessary
	      // reflows. However, IE<9 don't support textContent so the innerText
	      // fallback is necessary.
	      content = 'textContent' in hiddenPre ? hiddenPre.textContent : hiddenPre.innerText;
	    }
	    return spaceBefore + content + spaceAfter;
	  }
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.replace(/&/g, '&amp;').replace(SURROGATE_PAIR_REGEXP, function (value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + ((hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000) + ';';
	    }).replace(NON_ALPHANUMERIC_REGEXP, function (value) {
	      // unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
	      // decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
	      var c = value.charCodeAt(0);
	      // if unsafe character encode
	      if (c <= 159 || c == 173 || c >= 1536 && c <= 1540 || c == 1807 || c == 6068 || c == 6069 || c >= 8204 && c <= 8207 || c >= 8232 && c <= 8239 || c >= 8288 && c <= 8303 || c == 65279 || c >= 65520 && c <= 65535) return '&#' + c + ';';
	      return value; // avoids multilingual issues
	    }).replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  }
	
	  var trim = function () {
	    // native trim is way faster: http://jsperf.com/angular-trim-test
	    // but IE doesn't have it... :-(
	    // TODO: we should move this into IE/ES5 polyfill
	    if (!String.prototype.trim) {
	      return function (value) {
	        return angular.isString(value) ? value.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : value;
	      };
	    }
	    return function (value) {
	      return angular.isString(value) ? value.trim() : value;
	    };
	  }();
	
	  // Custom logic for accepting certain style options only - textAngular
	  // Currently allows only the color, background-color, text-align, float, width and height attributes
	  // all other attributes should be easily done through classes.
	  function validStyles(styleAttr) {
	    var result = '';
	    var styleArray = styleAttr.split(';');
	    angular.forEach(styleArray, function (value) {
	      var v = value.split(':');
	      if (v.length == 2) {
	        var key = trim(angular.lowercase(v[0]));
	        var value = trim(angular.lowercase(v[1]));
	        if ((key === 'color' || key === 'background-color') && (value.match(/^rgb\([0-9%,\. ]*\)$/i) || value.match(/^rgba\([0-9%,\. ]*\)$/i) || value.match(/^hsl\([0-9%,\. ]*\)$/i) || value.match(/^hsla\([0-9%,\. ]*\)$/i) || value.match(/^#[0-9a-f]{3,6}$/i) || value.match(/^[a-z]*$/i)) || key === 'text-align' && (value === 'left' || value === 'right' || value === 'center' || value === 'justify') || key === 'float' && (value === 'left' || value === 'right' || value === 'none') || (key === 'width' || key === 'height') && value.match(/[0-9\.]*(px|em|rem|%)/) || // Reference #520
	        key === 'direction' && value.match(/^ltr|rtl|initial|inherit$/)) result += key + ': ' + value + ';';
	      }
	    });
	    return result;
	  }
	
	  // this function is used to manually allow specific attributes on specific tags with certain prerequisites
	  function validCustomTag(tag, attrs, lkey, value) {
	    // catch the div placeholder for the iframe replacement
	    if (tag === 'img' && attrs['ta-insert-video']) {
	      if (lkey === 'ta-insert-video' || lkey === 'allowfullscreen' || lkey === 'frameborder' || lkey === 'contenteditable' && value === 'false') return true;
	    }
	    return false;
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.jain('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs, unary) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriter(buf, uriValidator) {
	    var ignore = false;
	    var out = angular.bind(buf, buf.push);
	    return {
	      start: function start(tag, attrs, unary) {
	        tag = angular.lowercase(tag);
	        if (!ignore && specialElements[tag]) {
	          ignore = tag;
	        }
	        if (!ignore && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          angular.forEach(attrs, function (value, key) {
	            var lkey = angular.lowercase(key);
	            var isImage = tag === 'img' && lkey === 'src' || lkey === 'background';
	            if (lkey === 'style' && (value = validStyles(value)) !== '' || validCustomTag(tag, attrs, lkey, value) || validAttrs[lkey] === true && (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out(unary ? '/>' : '>');
	        }
	      },
	      end: function end(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignore && validElements[tag] === true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignore) {
	          ignore = false;
	        }
	      },
	      chars: function chars(_chars) {
	        if (!ignore) {
	          out(encodeEntities(_chars));
	        }
	      }
	    };
	  }
	
	  // define ngSanitize module and register $sanitize service
	  angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	  /* global sanitizeText: false */
	
	  /**
	   * @ngdoc filter
	   * @name linky
	   * @kind function
	   *
	   * @description
	   * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	   * plain email address links.
	   *
	   * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	   *
	   * @param {string} text Input text.
	   * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	   * @returns {string} Html-linkified text.
	   *
	   * @usage
	     <span ng-bind-html="linky_expression | linky"></span>
	   *
	   * @example
	     <example module="linkyExample" deps="angular-sanitize.js">
	       <file name="index.html">
	         <script>
	           angular.module('linkyExample', ['ngSanitize'])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.snippet =
	                 'Pretty text with some links:\n'+
	                 'http://angularjs.org/,\n'+
	                 'mailto:us@somewhere.org,\n'+
	                 'another@somewhere.org,\n'+
	                 'and one more: ftp://127.0.0.1/.';
	               $scope.snippetWithTarget = 'http://angularjs.org/';
	             }]);
	         </script>
	         <div ng-controller="ExampleController">
	         Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	         <table>
	           <tr>
	             <td>Filter</td>
	             <td>Source</td>
	             <td>Rendered</td>
	           </tr>
	           <tr id="linky-filter">
	             <td>linky filter</td>
	             <td>
	               <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	             </td>
	             <td>
	               <div ng-bind-html="snippet | linky"></div>
	             </td>
	           </tr>
	           <tr id="linky-target">
	            <td>linky target</td>
	            <td>
	              <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	            </td>
	            <td>
	              <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	            </td>
	           </tr>
	           <tr id="escaped-html">
	             <td>no filter</td>
	             <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	             <td><div ng-bind="snippet"></div></td>
	           </tr>
	         </table>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should linkify the snippet with urls', function() {
	           expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	               toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                    'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	           expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	         });
	  
	         it('should not linkify snippet without the linky filter', function() {
	           expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	               toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                    'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	           expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	         });
	  
	         it('should update', function() {
	           element(by.model('snippet')).clear();
	           element(by.model('snippet')).sendKeys('new http://link.');
	           expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	               toBe('new http://link.');
	           expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	           expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	               .toBe('new http://link.');
	         });
	  
	         it('should work with the target property', function() {
	          expect(element(by.id('linky-target')).
	              element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	              toBe('http://angularjs.org/');
	          expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	         });
	       </file>
	     </example>
	   */
	  angular.module('ngSanitize').filter('linky', ['$sanitize', function ($sanitize) {
	    var LINKY_URL_REGEXP = /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,
	        MAILTO_REGEXP = /^mailto:/;
	
	    return function (text, target) {
	      if (!text) return text;
	      var match;
	      var raw = text;
	      var html = [];
	      var url;
	      var i;
	      while (match = raw.match(LINKY_URL_REGEXP)) {
	        // We can not end in these as they are sometimes found at the end of the sentence
	        url = match[0];
	        // if we did not match ftp/http/www/mailto then assume mailto
	        if (!match[2] && !match[4]) {
	          url = (match[3] ? 'http://' : 'mailto:') + url;
	        }
	        i = match.index;
	        addText(raw.substr(0, i));
	        addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	        raw = raw.substring(i + match[0].length);
	      }
	      addText(raw);
	      return $sanitize(html.join(''));
	
	      function addText(text) {
	        if (!text) {
	          return;
	        }
	        html.push(sanitizeText(text));
	      }
	
	      function addLink(url, text) {
	        html.push('<a ');
	        if (angular.isDefined(target)) {
	          html.push('target="', target, '" ');
	        }
	        html.push('href="', url.replace(/"/g, '&quot;'), '">');
	        addText(text);
	        html.push('</a>');
	      }
	    };
	  }]);
	})(window, window.angular);

/***/ },
/* 390 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	@license textAngular
	Author : Austin Anderson
	License : 2013 MIT
	Version 1.4.3
	
	See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
	*/
	
	(function () {
		// encapsulate all variables so they don't become global vars
		"use strict";
		// IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
		// We need this as IE sometimes plays funny tricks with the contenteditable.
		// ----------------------------------------------------------
		// If you're not in IE (or IE version is less than 5) then:
		// ie === undefined
		// If you're in IE (>=5) then you can determine which version:
		// ie === 7; // IE7
		// Thus, to detect IE:
		// if (ie) {}
		// And to detect the version:
		// ie === 6 // IE6
		// ie > 7 // IE8, IE9, IE10 ...
		// ie < 9 // Anything less than IE9
		// ----------------------------------------------------------
		/* istanbul ignore next: untestable browser check */
	
		var _browserDetect = {
			ie: function () {
				var undef,
				    v = 3,
				    div = document.createElement('div'),
				    all = div.getElementsByTagName('i');
	
				while (div.innerHTML = '<!--[if gt IE ' + ++v + ']><i></i><![endif]-->', all[0]) {}
	
				return v > 4 ? v : undef;
			}(),
			webkit: /AppleWebKit\/([\d.]+)/i.test(navigator.userAgent)
		};
	
		// fix a webkit bug, see: https://gist.github.com/shimondoodkin/1081133
		// this is set true when a blur occurs as the blur of the ta-bind triggers before the click
		var globalContentEditableBlur = false;
		/* istanbul ignore next: Browser Un-Focus fix for webkit */
		if (_browserDetect.webkit) {
			document.addEventListener("mousedown", function (_event) {
				var e = _event || window.event;
				var curelement = e.target;
				if (globalContentEditableBlur && curelement !== null) {
					var isEditable = false;
					var tempEl = curelement;
					while (tempEl !== null && tempEl.tagName.toLowerCase() !== 'html' && !isEditable) {
						isEditable = tempEl.contentEditable === 'true';
						tempEl = tempEl.parentNode;
					}
					if (!isEditable) {
						document.getElementById('textAngular-editableFix-010203040506070809').setSelectionRange(0, 0); // set caret focus to an element that handles caret focus correctly.
						curelement.focus(); // focus the wanted element.
						if (curelement.select) {
							curelement.select(); // use select to place cursor for input elements.
						}
					}
				}
				globalContentEditableBlur = false;
			}, false); // add global click handler
			angular.element(document).ready(function () {
				angular.element(document.body).append(angular.element('<input id="textAngular-editableFix-010203040506070809" class="ta-hidden-input" aria-hidden="true" unselectable="on" tabIndex="-1">'));
			});
		}
	
		// Gloabl to textAngular REGEXP vars for block and list elements.
	
		var BLOCKELEMENTS = /^(address|article|aside|audio|blockquote|canvas|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i;
		var LISTELEMENTS = /^(ul|li|ol)$/i;
		var VALIDELEMENTS = /^(address|article|aside|audio|blockquote|canvas|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;
	
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
		/* istanbul ignore next: trim shim for older browsers */
		if (!String.prototype.trim) {
			String.prototype.trim = function () {
				return this.replace(/^\s+|\s+$/g, '');
			};
		}
	
		// tests against the current jqLite/jquery implementation if this can be an element
		function validElementString(string) {
			try {
				return angular.element(string).length !== 0;
			} catch (any) {
				return false;
			}
		}
	
		/*
	 	Custom stylesheet for the placeholders rules.
	 	Credit to: http://davidwalsh.name/add-rules-stylesheets
	 */
		var sheet, addCSSRule, removeCSSRule, _addCSSRule, _removeCSSRule, _getRuleIndex;
		/* istanbul ignore else: IE <8 test*/
		if (_browserDetect.ie > 8 || _browserDetect.ie === undefined) {
			var _sheets = document.styleSheets;
			/* istanbul ignore next: preference for stylesheet loaded externally */
			for (var i = 0; i < _sheets.length; i++) {
				if (_sheets[i].media.length === 0 || _sheets[i].media.mediaText.match(/(all|screen)/ig)) {
					if (_sheets[i].href) {
						if (_sheets[i].href.match(/textangular\.(min\.|)css/ig)) {
							sheet = _sheets[i];
							break;
						}
					}
				}
			}
			/* istanbul ignore next: preference for stylesheet loaded externally */
			if (!sheet) {
				// this sheet is used for the placeholders later on.
				sheet = function () {
					// Create the <style> tag
					var style = document.createElement("style");
					/* istanbul ignore else : WebKit hack :( */
					if (_browserDetect.webkit) style.appendChild(document.createTextNode(""));
	
					// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
					document.getElementsByTagName('head')[0].appendChild(style);
	
					return style.sheet;
				}();
			}
	
			// use as: addCSSRule("header", "float: left");
			addCSSRule = function addCSSRule(selector, rules) {
				return _addCSSRule(sheet, selector, rules);
			};
			_addCSSRule = function _addCSSRule(_sheet, selector, rules) {
				var insertIndex;
				var insertedRule;
				// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
				/* istanbul ignore next: browser catches */
				if (_sheet.cssRules) insertIndex = Math.max(_sheet.cssRules.length - 1, 0);else if (_sheet.rules) insertIndex = Math.max(_sheet.rules.length - 1, 0);
	
				/* istanbul ignore else: untestable IE option */
				if (_sheet.insertRule) {
					_sheet.insertRule(selector + "{" + rules + "}", insertIndex);
				} else {
					_sheet.addRule(selector, rules, insertIndex);
				}
				/* istanbul ignore next: browser catches */
				if (sheet.rules) insertedRule = sheet.rules[insertIndex];else if (sheet.cssRules) insertedRule = sheet.cssRules[insertIndex];
				// return the inserted stylesheet rule
				return insertedRule;
			};
	
			_getRuleIndex = function _getRuleIndex(rule, rules) {
				var i, ruleIndex;
				for (i = 0; i < rules.length; i++) {
					/* istanbul ignore else: check for correct rule */
					if (rules[i].cssText === rule.cssText) {
						ruleIndex = i;
						break;
					}
				}
				return ruleIndex;
			};
	
			removeCSSRule = function removeCSSRule(rule) {
				_removeCSSRule(sheet, rule);
			};
			/* istanbul ignore next: tests are browser specific */
			_removeCSSRule = function _removeCSSRule(sheet, rule) {
				var rules = sheet.cssRules || sheet.rules;
				if (!rules || rules.length === 0) return;
				var ruleIndex = _getRuleIndex(rule, rules);
				if (sheet.removeRule) {
					sheet.removeRule(ruleIndex);
				} else {
					sheet.deleteRule(ruleIndex);
				}
			};
		}
	
		angular.module('textAngular.factories', []).factory('taBrowserTag', [function () {
			return function (tag) {
				/* istanbul ignore next: ie specific test */
				if (!tag) return _browserDetect.ie <= 8 ? 'P' : 'p';else if (tag === '') return _browserDetect.ie === undefined ? 'div' : _browserDetect.ie <= 8 ? 'P' : 'p';else return _browserDetect.ie <= 8 ? tag.toUpperCase() : tag;
			};
		}]).factory('taApplyCustomRenderers', ['taCustomRenderers', 'taDOM', function (taCustomRenderers, taDOM) {
			return function (val) {
				var element = angular.element('<div></div>');
				element[0].innerHTML = val;
	
				angular.forEach(taCustomRenderers, function (renderer) {
					var elements = [];
					// get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
					if (renderer.selector && renderer.selector !== '') elements = element.find(renderer.selector);
					/* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */
					else if (renderer.customAttribute && renderer.customAttribute !== '') elements = taDOM.getByAttribute(element, renderer.customAttribute);
					// process elements if any found
					angular.forEach(elements, function (_element) {
						_element = angular.element(_element);
						if (renderer.selector && renderer.selector !== '' && renderer.customAttribute && renderer.customAttribute !== '') {
							if (_element.attr(renderer.customAttribute) !== undefined) renderer.renderLogic(_element);
						} else renderer.renderLogic(_element);
					});
				});
	
				return element[0].innerHTML;
			};
		}]).factory('taFixChrome', function () {
			// get whaterever rubbish is inserted in chrome
			// should be passed an html string, returns an html string
			var taFixChrome = function taFixChrome(html) {
				if (!html || !angular.isString(html) || html.length <= 0) return html;
				// grab all elements with a style attibute
				var spanMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
				var match,
				    styleVal,
				    newTag,
				    finalHtml = '',
				    lastIndex = 0;
				while (match = spanMatch.exec(html)) {
					// one of the quoted values ' or "
					/* istanbul ignore next: quotations match */
					styleVal = match[3] || match[4];
					// test for chrome inserted junk
					if (styleVal && styleVal.match(/line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;/i)) {
						// replace original tag with new tag
						styleVal = styleVal.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;/ig, '');
						newTag = '<' + match[1].trim();
						if (styleVal.trim().length > 0) newTag += ' style=' + match[2].substring(0, 1) + styleVal + match[2].substring(0, 1);
						newTag += match[5].trim() + ">";
						finalHtml += html.substring(lastIndex, match.index) + newTag;
						lastIndex = match.index + match[0].length;
					}
				}
				finalHtml += html.substring(lastIndex);
				// only replace when something has changed, else we get focus problems on inserting lists
				if (lastIndex > 0) {
					// replace all empty strings
					return finalHtml.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/ig, '$1');
				} else return html;
			};
			return taFixChrome;
		}).factory('taSanitize', ['$sanitize', function taSanitizeFactory($sanitize) {
	
			var convert_infos = [{
				property: 'font-weight',
				values: ['bold'],
				tag: 'b'
			}, {
				property: 'font-style',
				values: ['italic'],
				tag: 'i'
			}];
	
			var styleMatch = [];
			for (var i = 0; i < convert_infos.length; i++) {
				var _partialStyle = '(' + convert_infos[i].property + ':\\s*(';
				for (var j = 0; j < convert_infos[i].values.length; j++) {
					/* istanbul ignore next: not needed to be tested yet */
					if (j > 0) _partialStyle += '|';
					_partialStyle += convert_infos[i].values[j];
				}
				_partialStyle += ');)';
				styleMatch.push(_partialStyle);
			}
			var styleRegexString = '(' + styleMatch.join('|') + ')';
	
			function wrapNested(html, wrapTag) {
				var depth = 0;
				var lastIndex = 0;
				var match;
				var tagRegex = /<[^>]*>/ig;
				while (match = tagRegex.exec(html)) {
					lastIndex = match.index;
					if (match[0].substr(1, 1) === '/') {
						if (depth === 0) break;else depth--;
					} else depth++;
				}
				return wrapTag + html.substring(0, lastIndex) +
				// get the start tags reversed - this is safe as we construct the strings with no content except the tags
				angular.element(wrapTag)[0].outerHTML.substring(wrapTag.length) + html.substring(lastIndex);
			}
	
			function transformLegacyStyles(html) {
				if (!html || !angular.isString(html) || html.length <= 0) return html;
				var i;
				var styleElementMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
				var match,
				    subMatch,
				    styleVal,
				    newTag,
				    lastNewTag = '',
				    newHtml,
				    finalHtml = '',
				    lastIndex = 0;
				while (match = styleElementMatch.exec(html)) {
					// one of the quoted values ' or "
					/* istanbul ignore next: quotations match */
					styleVal = match[3] || match[4];
					var styleRegex = new RegExp(styleRegexString, 'i');
					// test for style values to change
					if (angular.isString(styleVal) && styleRegex.test(styleVal)) {
						// remove build tag list
						newTag = '';
						// init regex here for exec
						var styleRegexExec = new RegExp(styleRegexString, 'ig');
						// find relevand tags and build a string of them
						while (subMatch = styleRegexExec.exec(styleVal)) {
							for (i = 0; i < convert_infos.length; i++) {
								if (!!subMatch[i * 2 + 2]) {
									newTag += '<' + convert_infos[i].tag + '>';
								}
							}
						}
						// recursively find more legacy styles in html before this tag and after the previous match (if any)
						newHtml = transformLegacyStyles(html.substring(lastIndex, match.index));
						// build up html
						if (lastNewTag.length > 0) {
							finalHtml += wrapNested(newHtml, lastNewTag);
						} else finalHtml += newHtml;
						// grab the style val without the transformed values
						styleVal = styleVal.replace(new RegExp(styleRegexString, 'ig'), '');
						// build the html tag
						finalHtml += '<' + match[1].trim();
						if (styleVal.length > 0) finalHtml += ' style="' + styleVal + '"';
						finalHtml += match[5] + '>';
						// update the start index to after this tag
						lastIndex = match.index + match[0].length;
						lastNewTag = newTag;
					}
				}
				if (lastNewTag.length > 0) {
					finalHtml += wrapNested(html.substring(lastIndex), lastNewTag);
				} else finalHtml += html.substring(lastIndex);
				return finalHtml;
			}
	
			function transformLegacyAttributes(html) {
				if (!html || !angular.isString(html) || html.length <= 0) return html;
				// replace all align='...' tags with text-align attributes
				var attrElementMatch = /<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/ig;
				var match,
				    finalHtml = '',
				    lastIndex = 0;
				// match all attr tags
				while (match = attrElementMatch.exec(html)) {
					// add all html before this tag
					finalHtml += html.substring(lastIndex, match.index);
					// record last index after this tag
					lastIndex = match.index + match[0].length;
					// construct tag without the align attribute
					var newTag = '<' + match[1] + match[5];
					// add the style attribute
					if (/style=("([^"]+)"|'([^']+)')/ig.test(newTag)) {
						/* istanbul ignore next: quotations match */
						newTag = newTag.replace(/style=("([^"]+)"|'([^']+)')/i, 'style="$2$3 text-align:' + (match[3] || match[4]) + ';"');
					} else {
						/* istanbul ignore next: quotations match */
						newTag += ' style="text-align:' + (match[3] || match[4]) + ';"';
					}
					newTag += '>';
					// add to html
					finalHtml += newTag;
				}
				// return with remaining html
				return finalHtml + html.substring(lastIndex);
			}
	
			return function taSanitize(unsafe, oldsafe, ignore) {
				// unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
				if (!ignore) {
					try {
						unsafe = transformLegacyStyles(unsafe);
					} catch (e) {}
				}
	
				// unsafe and oldsafe should be valid HTML strings
				// any exceptions (lets say, color for example) should be made here but with great care
				// setup unsafe element for modification
				unsafe = transformLegacyAttributes(unsafe);
	
				var safe;
				try {
					safe = $sanitize(unsafe);
					// do this afterwards, then the $sanitizer should still throw for bad markup
					if (ignore) safe = unsafe;
				} catch (e) {
					safe = oldsafe || '';
				}
	
				// Do processing for <pre> tags, removing tabs and return carriages outside of them
	
				var _preTags = safe.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/ig);
				var processedSafe = safe.replace(/(&#(9|10);)*/ig, '');
				var re = /<pre[^>]*>.*?<\/pre[^>]*>/ig;
				var index = 0;
				var lastIndex = 0;
				var origTag;
				safe = '';
				while ((origTag = re.exec(processedSafe)) !== null && index < _preTags.length) {
					safe += processedSafe.substring(lastIndex, origTag.index) + _preTags[index];
					lastIndex = origTag.index + origTag[0].length;
					index++;
				}
				return safe + processedSafe.substring(lastIndex);
			};
		}]).factory('taToolExecuteAction', ['$q', '$log', function ($q, $log) {
			// this must be called on a toolScope or instance
			return function (editor) {
				if (editor !== undefined) this.$editor = function () {
					return editor;
				};
				var deferred = $q.defer(),
				    promise = deferred.promise,
				    _editor = this.$editor();
				// pass into the action the deferred function and also the function to reload the current selection if rangy available
				var result;
				try {
					result = this.action(deferred, _editor.startAction());
					// We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
					promise['finally'](function () {
						_editor.endAction.call(_editor);
					});
				} catch (exc) {
					$log.error(exc);
				}
				if (result || result === undefined) {
					// if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
					deferred.resolve();
				}
			};
		}]);
		angular.module('textAngular.DOM', ['textAngular.factories']).factory('taExecCommand', ['taSelection', 'taBrowserTag', '$document', function (taSelection, taBrowserTag, $document) {
			var listToDefault = function listToDefault(listElement, defaultWrap) {
				var $target, i;
				// if all selected then we should remove the list
				// grab all li elements and convert to taDefaultWrap tags
				var children = listElement.find('li');
				for (i = children.length - 1; i >= 0; i--) {
					$target = angular.element('<' + defaultWrap + '>' + children[i].innerHTML + '</' + defaultWrap + '>');
					listElement.after($target);
				}
				listElement.remove();
				taSelection.setSelectionToElementEnd($target[0]);
			};
			var selectLi = function selectLi(liElement) {
				if (/(<br(|\/)>)$/i.test(liElement.innerHTML.trim())) taSelection.setSelectionBeforeElement(angular.element(liElement).find("br")[0]);else taSelection.setSelectionToElementEnd(liElement);
			};
			var listToList = function listToList(listElement, newListTag) {
				var $target = angular.element('<' + newListTag + '>' + listElement[0].innerHTML + '</' + newListTag + '>');
				listElement.after($target);
				listElement.remove();
				selectLi($target.find('li')[0]);
			};
			var childElementsToList = function childElementsToList(elements, listElement, newListTag) {
				var html = '';
				for (var i = 0; i < elements.length; i++) {
					html += '<' + taBrowserTag('li') + '>' + elements[i].innerHTML + '</' + taBrowserTag('li') + '>';
				}
				var $target = angular.element('<' + newListTag + '>' + html + '</' + newListTag + '>');
				listElement.after($target);
				listElement.remove();
				selectLi($target.find('li')[0]);
			};
			return function (taDefaultWrap, topNode) {
				taDefaultWrap = taBrowserTag(taDefaultWrap);
				return function (command, showUI, options, defaultTagAttributes) {
					var i, $target, html, _nodes, next, optionsTagName, selectedElement;
					var defaultWrapper = angular.element('<' + taDefaultWrap + '>');
					try {
						selectedElement = taSelection.getSelectionElement();
					} catch (e) {}
					var $selected = angular.element(selectedElement);
					if (selectedElement !== undefined) {
						var tagName = selectedElement.tagName.toLowerCase();
						if (command.toLowerCase() === 'insertorderedlist' || command.toLowerCase() === 'insertunorderedlist') {
							var selfTag = taBrowserTag(command.toLowerCase() === 'insertorderedlist' ? 'ol' : 'ul');
							if (tagName === selfTag) {
								// if all selected then we should remove the list
								// grab all li elements and convert to taDefaultWrap tags
								return listToDefault($selected, taDefaultWrap);
							} else if (tagName === 'li' && $selected.parent()[0].tagName.toLowerCase() === selfTag && $selected.parent().children().length === 1) {
								// catch for the previous statement if only one li exists
								return listToDefault($selected.parent(), taDefaultWrap);
							} else if (tagName === 'li' && $selected.parent()[0].tagName.toLowerCase() !== selfTag && $selected.parent().children().length === 1) {
								// catch for the previous statement if only one li exists
								return listToList($selected.parent(), selfTag);
							} else if (tagName.match(BLOCKELEMENTS) && !$selected.hasClass('ta-bind')) {
								// if it's one of those block elements we have to change the contents
								// if it's a ol/ul we are changing from one to the other
								if (tagName === 'ol' || tagName === 'ul') {
									return listToList($selected, selfTag);
								} else {
									var childBlockElements = false;
									angular.forEach($selected.children(), function (elem) {
										if (elem.tagName.match(BLOCKELEMENTS)) {
											childBlockElements = true;
										}
									});
									if (childBlockElements) {
										return childElementsToList($selected.children(), $selected, selfTag);
									} else {
										return childElementsToList([angular.element('<div>' + selectedElement.innerHTML + '</div>')[0]], $selected, selfTag);
									}
								}
							} else if (tagName.match(BLOCKELEMENTS)) {
								// if we get here then all the contents of the ta-bind are selected
								_nodes = taSelection.getOnlySelectedElements();
								if (_nodes.length === 0) {
									// here is if there is only text in ta-bind ie <div ta-bind>test content</div>
									$target = angular.element('<' + selfTag + '><li>' + selectedElement.innerHTML + '</li></' + selfTag + '>');
									$selected.html('');
									$selected.append($target);
								} else if (_nodes.length === 1 && (_nodes[0].tagName.toLowerCase() === 'ol' || _nodes[0].tagName.toLowerCase() === 'ul')) {
									if (_nodes[0].tagName.toLowerCase() === selfTag) {
										// remove
										return listToDefault(angular.element(_nodes[0]), taDefaultWrap);
									} else {
										return listToList(angular.element(_nodes[0]), selfTag);
									}
								} else {
									html = '';
									var $nodes = [];
									for (i = 0; i < _nodes.length; i++) {
										/* istanbul ignore else: catch for real-world can't make it occur in testing */
										if (_nodes[i].nodeType !== 3) {
											var $n = angular.element(_nodes[i]);
											/* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */
											if (_nodes[i].tagName.toLowerCase() === 'li') continue;else if (_nodes[i].tagName.toLowerCase() === 'ol' || _nodes[i].tagName.toLowerCase() === 'ul') {
												html += $n[0].innerHTML; // if it's a list, add all it's children
											} else if (_nodes[i].tagName.toLowerCase() === 'span' && (_nodes[i].childNodes[0].tagName.toLowerCase() === 'ol' || _nodes[i].childNodes[0].tagName.toLowerCase() === 'ul')) {
												html += $n[0].childNodes[0].innerHTML; // if it's a list, add all it's children
											} else {
												html += '<' + taBrowserTag('li') + '>' + $n[0].innerHTML + '</' + taBrowserTag('li') + '>';
											}
											$nodes.unshift($n);
										}
									}
									$target = angular.element('<' + selfTag + '>' + html + '</' + selfTag + '>');
									$nodes.pop().replaceWith($target);
									angular.forEach($nodes, function ($node) {
										$node.remove();
									});
								}
								taSelection.setSelectionToElementEnd($target[0]);
								return;
							}
						} else if (command.toLowerCase() === 'formatblock') {
							optionsTagName = options.toLowerCase().replace(/[<>]/ig, '');
							if (optionsTagName.trim() === 'default') {
								optionsTagName = taDefaultWrap;
								options = '<' + taDefaultWrap + '>';
							}
							if (tagName === 'li') $target = $selected.parent();else $target = $selected;
							// find the first blockElement
							while (!$target[0].tagName || !$target[0].tagName.match(BLOCKELEMENTS) && !$target.parent().attr('contenteditable')) {
								$target = $target.parent();
								/* istanbul ignore next */
								tagName = ($target[0].tagName || '').toLowerCase();
							}
							if (tagName === optionsTagName) {
								// $target is wrap element
								_nodes = $target.children();
								var hasBlock = false;
								for (i = 0; i < _nodes.length; i++) {
									hasBlock = hasBlock || _nodes[i].tagName.match(BLOCKELEMENTS);
								}
								if (hasBlock) {
									$target.after(_nodes);
									next = $target.next();
									$target.remove();
									$target = next;
								} else {
									defaultWrapper.append($target[0].childNodes);
									$target.after(defaultWrapper);
									$target.remove();
									$target = defaultWrapper;
								}
							} else if ($target.parent()[0].tagName.toLowerCase() === optionsTagName && !$target.parent().hasClass('ta-bind')) {
								//unwrap logic for parent
								var blockElement = $target.parent();
								var contents = blockElement.contents();
								for (i = 0; i < contents.length; i++) {
									/* istanbul ignore next: can't test - some wierd thing with how phantomjs works */
									if (blockElement.parent().hasClass('ta-bind') && contents[i].nodeType === 3) {
										defaultWrapper = angular.element('<' + taDefaultWrap + '>');
										defaultWrapper[0].innerHTML = contents[i].outerHTML;
										contents[i] = defaultWrapper[0];
									}
									blockElement.parent()[0].insertBefore(contents[i], blockElement[0]);
								}
								blockElement.remove();
							} else if (tagName.match(LISTELEMENTS)) {
								// wrapping a list element
								$target.wrap(options);
							} else {
								// default wrap behaviour
								_nodes = taSelection.getOnlySelectedElements();
								if (_nodes.length === 0) _nodes = [$target[0]];
								// find the parent block element if any of the nodes are inline or text
								for (i = 0; i < _nodes.length; i++) {
									if (_nodes[i].nodeType === 3 || !_nodes[i].tagName.match(BLOCKELEMENTS)) {
										while (_nodes[i].nodeType === 3 || !_nodes[i].tagName || !_nodes[i].tagName.match(BLOCKELEMENTS)) {
											_nodes[i] = _nodes[i].parentNode;
										}
									}
								}
								if (angular.element(_nodes[0]).hasClass('ta-bind')) {
									$target = angular.element(options);
									$target[0].innerHTML = _nodes[0].innerHTML;
									_nodes[0].innerHTML = $target[0].outerHTML;
								} else if (optionsTagName === 'blockquote') {
									// blockquotes wrap other block elements
									html = '';
									for (i = 0; i < _nodes.length; i++) {
										html += _nodes[i].outerHTML;
									}
									$target = angular.element(options);
									$target[0].innerHTML = html;
									_nodes[0].parentNode.insertBefore($target[0], _nodes[0]);
									for (i = _nodes.length - 1; i >= 0; i--) {
										/* istanbul ignore else:  */
										if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
									}
								} else {
									// regular block elements replace other block elements
									for (i = 0; i < _nodes.length; i++) {
										$target = angular.element(options);
										$target[0].innerHTML = _nodes[i].innerHTML;
										_nodes[i].parentNode.insertBefore($target[0], _nodes[i]);
										_nodes[i].parentNode.removeChild(_nodes[i]);
									}
								}
							}
							taSelection.setSelectionToElementEnd($target[0]);
							return;
						} else if (command.toLowerCase() === 'createlink') {
							var tagBegin = '<a href="' + options + '" target="' + (defaultTagAttributes.a.target ? defaultTagAttributes.a.target : '') + '">',
							    tagEnd = '</a>',
							    _selection = taSelection.getSelection();
							if (_selection.collapsed) {
								// insert text at selection, then select then just let normal exec-command run
								taSelection.insertHtml(tagBegin + options + tagEnd, topNode);
							} else if (rangy.getSelection().getRangeAt(0).canSurroundContents()) {
								var node = angular.element(tagBegin + tagEnd)[0];
								rangy.getSelection().getRangeAt(0).surroundContents(node);
							}
							return;
						} else if (command.toLowerCase() === 'inserthtml') {
							taSelection.insertHtml(options, topNode);
							return;
						}
					}
					try {
						$document[0].execCommand(command, showUI, options);
					} catch (e) {}
				};
			};
		}]).service('taSelection', ['$window', '$document', 'taDOM',
		/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
		function ($window, $document, taDOM) {
			// need to dereference the document else the calls don't work correctly
			var _document = $document[0];
			var rangy = $window.rangy;
			var brException = function brException(element, offset) {
				/* check if selection is a BR element at the beginning of a container. If so, get
	   * the parentNode instead.
	   * offset should be zero in this case. Otherwise, return the original
	   * element.
	   */
				if (element.tagName && element.tagName.match(/^br$/i) && offset === 0 && !element.previousSibling) {
					return {
						element: element.parentNode,
						offset: 0
					};
				} else {
					return {
						element: element,
						offset: offset
					};
				}
			};
			var api = {
				getSelection: function getSelection() {
					var range = rangy.getSelection().getRangeAt(0);
					var container = range.commonAncestorContainer;
					var selection = {
						start: brException(range.startContainer, range.startOffset),
						end: brException(range.endContainer, range.endOffset),
						collapsed: range.collapsed
					};
					// Check if the container is a text node and return its parent if so
					container = container.nodeType === 3 ? container.parentNode : container;
					if (container.parentNode === selection.start.element || container.parentNode === selection.end.element) {
						selection.container = container.parentNode;
					} else {
						selection.container = container;
					}
					return selection;
				},
				getOnlySelectedElements: function getOnlySelectedElements() {
					var range = rangy.getSelection().getRangeAt(0);
					var container = range.commonAncestorContainer;
					// Check if the container is a text node and return its parent if so
					container = container.nodeType === 3 ? container.parentNode : container;
					return range.getNodes([1], function (node) {
						return node.parentNode === container;
					});
				},
				// Some basic selection functions
				getSelectionElement: function getSelectionElement() {
					return api.getSelection().container;
				},
				setSelection: function setSelection(el, start, end) {
					var range = rangy.createRange();
	
					range.setStart(el, start);
					range.setEnd(el, end);
	
					rangy.getSelection().setSingleRange(range);
				},
				setSelectionBeforeElement: function setSelectionBeforeElement(el) {
					var range = rangy.createRange();
	
					range.selectNode(el);
					range.collapse(true);
	
					rangy.getSelection().setSingleRange(range);
				},
				setSelectionAfterElement: function setSelectionAfterElement(el) {
					var range = rangy.createRange();
	
					range.selectNode(el);
					range.collapse(false);
	
					rangy.getSelection().setSingleRange(range);
				},
				setSelectionToElementStart: function setSelectionToElementStart(el) {
					var range = rangy.createRange();
	
					range.selectNodeContents(el);
					range.collapse(true);
	
					rangy.getSelection().setSingleRange(range);
				},
				setSelectionToElementEnd: function setSelectionToElementEnd(el) {
					var range = rangy.createRange();
	
					range.selectNodeContents(el);
					range.collapse(false);
					if (el.childNodes && el.childNodes[el.childNodes.length - 1] && el.childNodes[el.childNodes.length - 1].nodeName === 'br') {
						range.startOffset = range.endOffset = range.startOffset - 1;
					}
					rangy.getSelection().setSingleRange(range);
				},
				// from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
				// topNode is the contenteditable normally, all manipulation MUST be inside this.
				insertHtml: function insertHtml(html, topNode) {
					var parent, secondParent, _childI, nodes, i, lastNode, _tempFrag;
					var element = angular.element("<div>" + html + "</div>");
					var range = rangy.getSelection().getRangeAt(0);
					var frag = _document.createDocumentFragment();
					var children = element[0].childNodes;
					var isInline = true;
	
					if (children.length > 0) {
						// NOTE!! We need to do the following:
						// check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
						// If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
						nodes = [];
						for (_childI = 0; _childI < children.length; _childI++) {
							if (!(children[_childI].nodeName.toLowerCase() === 'p' && children[_childI].innerHTML.trim() === '' || // empty p element
							children[_childI].nodeType === 3 && children[_childI].nodeValue.trim() === '' // empty text node
							)) {
								isInline = isInline && !BLOCKELEMENTS.test(children[_childI].nodeName);
								nodes.push(children[_childI]);
							}
						}
						for (var _n = 0; _n < nodes.length; _n++) {
							lastNode = frag.appendChild(nodes[_n]);
						}if (!isInline && range.collapsed && /^(|<br(|\/)>)$/i.test(range.startContainer.innerHTML)) range.selectNode(range.startContainer);
					} else {
						isInline = true;
						// paste text of some sort
						lastNode = frag = _document.createTextNode(html);
					}
	
					// Other Edge case - selected data spans multiple blocks.
					if (isInline) {
						range.deleteContents();
					} else {
						// not inline insert
						if (range.collapsed && range.startContainer !== topNode) {
							if (range.startContainer.innerHTML && range.startContainer.innerHTML.match(/^<[^>]*>$/i)) {
								// this log is to catch when innerHTML is something like `<img ...>`
								parent = range.startContainer;
								if (range.startOffset === 1) {
									// before single tag
									range.setStartAfter(parent);
									range.setEndAfter(parent);
								} else {
									// after single tag
									range.setStartBefore(parent);
									range.setEndBefore(parent);
								}
							} else {
								// split element into 2 and insert block element in middle
								if (range.startContainer.nodeType === 3 && range.startContainer.parentNode !== topNode) {
									// if text node
									parent = range.startContainer.parentNode;
									secondParent = parent.cloneNode();
									// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
									taDOM.splitNodes(parent.childNodes, parent, secondParent, range.startContainer, range.startOffset);
	
									// Escape out of the inline tags like b
									while (!VALIDELEMENTS.test(parent.nodeName)) {
										angular.element(parent).after(secondParent);
										parent = parent.parentNode;
										var _lastSecondParent = secondParent;
										secondParent = parent.cloneNode();
										// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
										taDOM.splitNodes(parent.childNodes, parent, secondParent, _lastSecondParent);
									}
								} else {
									parent = range.startContainer;
									secondParent = parent.cloneNode();
									taDOM.splitNodes(parent.childNodes, parent, secondParent, undefined, undefined, range.startOffset);
								}
	
								angular.element(parent).after(secondParent);
								// put cursor to end of inserted content
								range.setStartAfter(parent);
								range.setEndAfter(parent);
	
								if (/^(|<br(|\/)>)$/i.test(parent.innerHTML.trim())) {
									range.setStartBefore(parent);
									range.setEndBefore(parent);
									angular.element(parent).remove();
								}
								if (/^(|<br(|\/)>)$/i.test(secondParent.innerHTML.trim())) angular.element(secondParent).remove();
								if (parent.nodeName.toLowerCase() === 'li') {
									_tempFrag = _document.createDocumentFragment();
									for (i = 0; i < frag.childNodes.length; i++) {
										element = angular.element('<li>');
										taDOM.transferChildNodes(frag.childNodes[i], element[0]);
										taDOM.transferNodeAttributes(frag.childNodes[i], element[0]);
										_tempFrag.appendChild(element[0]);
									}
									frag = _tempFrag;
									if (lastNode) {
										lastNode = frag.childNodes[frag.childNodes.length - 1];
										lastNode = lastNode.childNodes[lastNode.childNodes.length - 1];
									}
								}
							}
						} else {
							range.deleteContents();
						}
					}
	
					range.insertNode(frag);
					if (lastNode) {
						api.setSelectionToElementEnd(lastNode);
					}
				}
			};
			return api;
		}]).service('taDOM', function () {
			var taDOM = {
				// recursive function that returns an array of angular.elements that have the passed attribute set on them
				getByAttribute: function getByAttribute(element, attribute) {
					var resultingElements = [];
					var childNodes = element.children();
					if (childNodes.length) {
						angular.forEach(childNodes, function (child) {
							resultingElements = resultingElements.concat(taDOM.getByAttribute(angular.element(child), attribute));
						});
					}
					if (element.attr(attribute) !== undefined) resultingElements.push(element);
					return resultingElements;
				},
	
				transferChildNodes: function transferChildNodes(source, target) {
					// clear out target
					target.innerHTML = '';
					while (source.childNodes.length > 0) {
						target.appendChild(source.childNodes[0]);
					}return target;
				},
	
				splitNodes: function splitNodes(nodes, target1, target2, splitNode, subSplitIndex, splitIndex) {
					if (!splitNode && isNaN(splitIndex)) throw new Error('taDOM.splitNodes requires a splitNode or splitIndex');
					var startNodes = document.createDocumentFragment();
					var endNodes = document.createDocumentFragment();
					var index = 0;
	
					while (nodes.length > 0 && (isNaN(splitIndex) || splitIndex !== index) && nodes[0] !== splitNode) {
						startNodes.appendChild(nodes[0]); // this removes from the nodes array (if proper childNodes object.
						index++;
					}
	
					if (!isNaN(subSplitIndex) && subSplitIndex >= 0 && nodes[0]) {
						startNodes.appendChild(document.createTextNode(nodes[0].nodeValue.substring(0, subSplitIndex)));
						nodes[0].nodeValue = nodes[0].nodeValue.substring(subSplitIndex);
					}
					while (nodes.length > 0) {
						endNodes.appendChild(nodes[0]);
					}taDOM.transferChildNodes(startNodes, target1);
					taDOM.transferChildNodes(endNodes, target2);
				},
	
				transferNodeAttributes: function transferNodeAttributes(source, target) {
					for (var i = 0; i < source.attributes.length; i++) {
						target.setAttribute(source.attributes[i].name, source.attributes[i].value);
					}return target;
				}
			};
			return taDOM;
		});
		angular.module('textAngular.validators', []).directive('taMaxText', function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function link(scope, elem, attrs, ctrl) {
					var max = parseInt(scope.$eval(attrs.taMaxText));
					if (isNaN(max)) {
						throw 'Max text must be an integer';
					}
					attrs.$observe('taMaxText', function (value) {
						max = parseInt(value);
						if (isNaN(max)) {
							throw 'Max text must be an integer';
						}
						if (ctrl.$dirty) {
							ctrl.$validate();
						}
					});
					ctrl.$validators.taMaxText = function (viewValue) {
						var source = angular.element('<div/>');
						source.html(viewValue);
						return source.text().length <= max;
					};
				}
			};
		}).directive('taMinText', function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function link(scope, elem, attrs, ctrl) {
					var min = parseInt(scope.$eval(attrs.taMinText));
					if (isNaN(min)) {
						throw 'Min text must be an integer';
					}
					attrs.$observe('taMinText', function (value) {
						min = parseInt(value);
						if (isNaN(min)) {
							throw 'Min text must be an integer';
						}
						if (ctrl.$dirty) {
							ctrl.$validate();
						}
					});
					ctrl.$validators.taMinText = function (viewValue) {
						var source = angular.element('<div/>');
						source.html(viewValue);
						return !source.text().length || source.text().length >= min;
					};
				}
			};
		});
		angular.module('textAngular.taBind', ['textAngular.factories', 'textAngular.DOM']).service('_taBlankTest', [function () {
			var INLINETAGS_NONBLANK = /<(a|abbr|acronym|bdi|bdo|big|cite|code|del|dfn|img|ins|kbd|label|map|mark|q|ruby|rp|rt|s|samp|time|tt|var)[^>]*(>|$)/i;
			return function (_defaultTest) {
				return function (_blankVal) {
					if (!_blankVal) return true;
					// find first non-tag match - ie start of string or after tag that is not whitespace
					var _firstMatch = /(^[^<]|>)[^<]/i.exec(_blankVal);
					var _firstTagIndex;
					if (!_firstMatch) {
						// find the end of the first tag removing all the
						// Don't do a global replace as that would be waaayy too long, just replace the first 4 occurences should be enough
						_blankVal = _blankVal.toString().replace(/="[^"]*"/i, '').replace(/="[^"]*"/i, '').replace(/="[^"]*"/i, '').replace(/="[^"]*"/i, '');
						_firstTagIndex = _blankVal.indexOf('>');
					} else {
						_firstTagIndex = _firstMatch.index;
					}
					_blankVal = _blankVal.trim().substring(_firstTagIndex, _firstTagIndex + 100);
					// check for no tags entry
					if (/^[^<>]+$/i.test(_blankVal)) return false;
					// this regex is to match any number of whitespace only between two tags
					if (_blankVal.length === 0 || _blankVal === _defaultTest || /^>(\s|&nbsp;)*<\/[^>]+>$/ig.test(_blankVal)) return true;
					// this regex tests if there is a tag followed by some optional whitespace and some text after that
					else if (/>\s*[^\s<]/i.test(_blankVal) || INLINETAGS_NONBLANK.test(_blankVal)) return false;else return true;
				};
			};
		}]).directive('taButton', [function () {
			return {
				link: function link(scope, element, attrs) {
					element.attr('unselectable', 'on');
					element.on('mousedown', function (e, eventData) {
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if (eventData) angular.extend(e, eventData);
						// this prevents focusout from firing on the editor when clicking toolbar buttons
						e.preventDefault();
						return false;
					});
				}
			};
		}]).directive('taBind', ['taSanitize', '$timeout', '$window', '$document', 'taFixChrome', 'taBrowserTag', 'taSelection', 'taSelectableElements', 'taApplyCustomRenderers', 'taOptions', '_taBlankTest', '$parse', 'taDOM', 'textAngularManager', function (taSanitize, $timeout, $window, $document, taFixChrome, taBrowserTag, taSelection, taSelectableElements, taApplyCustomRenderers, taOptions, _taBlankTest, $parse, taDOM, textAngularManager) {
			// Uses for this are textarea or input with ng-model and ta-bind='text'
			// OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
			return {
				priority: 2, // So we override validators correctly
				require: ['ngModel', '?ngModelOptions'],
				link: function link(scope, element, attrs, controller) {
					var ngModel = controller[0];
					var ngModelOptions = controller[1] || {};
					// the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
					var _isContentEditable = element.attr('contenteditable') !== undefined && element.attr('contenteditable');
					var _isInputFriendly = _isContentEditable || element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input';
					var _isReadonly = false;
					var _focussed = false;
					var _skipRender = false;
					var _disableSanitizer = attrs.taUnsafeSanitizer || taOptions.disableSanitizer;
					var _lastKey;
					// see http://www.javascripter.net/faq/keycodes.htm for good information
					// NOTE Mute On|Off 173 (Opera MSIE Safari Chrome) 181 (Firefox)
					// BLOCKED_KEYS are special keys...
					// Tab, pause/break, CapsLock, Esc, Page Up, End, Home,
					// Left arrow, Up arrow, Right arrow, Down arrow, Insert, Delete,
					// f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12
					// NumLock, ScrollLock
					var BLOCKED_KEYS = /^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i;
					// UNDO_TRIGGER_KEYS - spaces, enter, delete, backspace, all punctuation
					// Backspace, Enter, Space, Delete, (; :) (Firefox), (= +) (Firefox),
					// Numpad +, Numpad -, (; :), (= +),
					// (, <), (- _), (. >), (/ ?), (` ~), ([ {), (\ |), (] }), (' ")
					// NOTE - Firefox: 173 = (- _) -- adding this to UNDO_TRIGGER_KEYS
					var UNDO_TRIGGER_KEYS = /^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i;
					var _pasteHandler;
	
					// defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
					// non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
					var _defaultVal, _defaultTest;
	
					var _CTRL_KEY = 0x0001;
					var _META_KEY = 0x0002;
					var _ALT_KEY = 0x0004;
					var _SHIFT_KEY = 0x0008;
					// map events to special keys...
					// mappings is an array of maps from events to specialKeys as declared in textAngularSetup
					var _keyMappings = [
					//		ctrl/command + z
					{
						specialKey: 'UndoKey',
						forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
						mustHaveModifiers: [_META_KEY + _CTRL_KEY],
						keyCode: 90
					},
					//		ctrl/command + shift + z
					{
						specialKey: 'RedoKey',
						forbiddenModifiers: _ALT_KEY,
						mustHaveModifiers: [_META_KEY + _CTRL_KEY, _SHIFT_KEY],
						keyCode: 90
					},
					//		ctrl/command + y
					{
						specialKey: 'RedoKey',
						forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
						mustHaveModifiers: [_META_KEY + _CTRL_KEY],
						keyCode: 89
					},
					//		TabKey
					{
						specialKey: 'TabKey',
						forbiddenModifiers: _META_KEY + _SHIFT_KEY + _ALT_KEY + _CTRL_KEY,
						mustHaveModifiers: [],
						keyCode: 9
					},
					//		shift + TabKey
					{
						specialKey: 'ShiftTabKey',
						forbiddenModifiers: _META_KEY + _ALT_KEY + _CTRL_KEY,
						mustHaveModifiers: [_SHIFT_KEY],
						keyCode: 9
					}];
					function _mapKeys(event) {
						var specialKey;
						_keyMappings.forEach(function (map) {
							if (map.keyCode === event.keyCode) {
								var netModifiers = (event.metaKey ? _META_KEY : 0) + (event.ctrlKey ? _CTRL_KEY : 0) + (event.shiftKey ? _SHIFT_KEY : 0) + (event.altKey ? _ALT_KEY : 0);
								if (map.forbiddenModifiers & netModifiers) return;
								if (map.mustHaveModifiers.every(function (modifier) {
									return netModifiers & modifier;
								})) {
									specialKey = map.specialKey;
								}
							}
						});
						return specialKey;
					}
	
					// set the default to be a paragraph value
					if (attrs.taDefaultWrap === undefined) attrs.taDefaultWrap = 'p';
					/* istanbul ignore next: ie specific test */
					if (attrs.taDefaultWrap === '') {
						_defaultVal = '';
						_defaultTest = _browserDetect.ie === undefined ? '<div><br></div>' : _browserDetect.ie >= 11 ? '<p><br></p>' : _browserDetect.ie <= 8 ? '<P>&nbsp;</P>' : '<p>&nbsp;</p>';
					} else {
						_defaultVal = _browserDetect.ie === undefined || _browserDetect.ie >= 11 ? '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>' : _browserDetect.ie <= 8 ? '<' + attrs.taDefaultWrap.toUpperCase() + '></' + attrs.taDefaultWrap.toUpperCase() + '>' : '<' + attrs.taDefaultWrap + '></' + attrs.taDefaultWrap + '>';
						_defaultTest = _browserDetect.ie === undefined || _browserDetect.ie >= 11 ? '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>' : _browserDetect.ie <= 8 ? '<' + attrs.taDefaultWrap.toUpperCase() + '>&nbsp;</' + attrs.taDefaultWrap.toUpperCase() + '>' : '<' + attrs.taDefaultWrap + '>&nbsp;</' + attrs.taDefaultWrap + '>';
					}
	
					/* istanbul ignore else */
					if (!ngModelOptions.$options) ngModelOptions.$options = {}; // ng-model-options support
	
					var _blankTest = _taBlankTest(_defaultTest);
	
					var _ensureContentWrapped = function _ensureContentWrapped(value) {
						if (_blankTest(value)) return value;
						var domTest = angular.element("<div>" + value + "</div>");
						if (domTest.children().length === 0) {
							value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
						} else {
							var _children = domTest[0].childNodes;
							var i;
							var _foundBlockElement = false;
							for (i = 0; i < _children.length; i++) {
								if (_foundBlockElement = _children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)) break;
							}
							if (!_foundBlockElement) {
								value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
							} else {
								value = "";
								for (i = 0; i < _children.length; i++) {
									if (!_children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)) {
										var _subVal = _children[i].outerHTML || _children[i].nodeValue;
										/* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */
										if (_subVal.trim() !== '') value += "<" + attrs.taDefaultWrap + ">" + _subVal + "</" + attrs.taDefaultWrap + ">";else value += _subVal;
									} else {
										value += _children[i].outerHTML;
									}
								}
							}
						}
						return value;
					};
	
					if (attrs.taPaste) _pasteHandler = $parse(attrs.taPaste);
	
					element.addClass('ta-bind');
	
					var _undoKeyupTimeout;
	
					scope['$undoManager' + (attrs.id || '')] = ngModel.$undoManager = {
						_stack: [],
						_index: 0,
						_max: 1000,
						push: function push(value) {
							if (typeof value === "undefined" || value === null || typeof this.current() !== "undefined" && this.current() !== null && value === this.current()) return value;
							if (this._index < this._stack.length - 1) {
								this._stack = this._stack.slice(0, this._index + 1);
							}
							this._stack.push(value);
							if (_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
							if (this._stack.length > this._max) this._stack.shift();
							this._index = this._stack.length - 1;
							return value;
						},
						undo: function undo() {
							return this.setToIndex(this._index - 1);
						},
						redo: function redo() {
							return this.setToIndex(this._index + 1);
						},
						setToIndex: function setToIndex(index) {
							if (index < 0 || index > this._stack.length - 1) {
								return undefined;
							}
							this._index = index;
							return this.current();
						},
						current: function current() {
							return this._stack[this._index];
						}
					};
	
					var _redoUndoTimeout;
					var _undo = scope['$undoTaBind' + (attrs.id || '')] = function () {
						/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
						if (!_isReadonly && _isContentEditable) {
							var content = ngModel.$undoManager.undo();
							if (typeof content !== "undefined" && content !== null) {
								_setInnerHTML(content);
								_setViewValue(content, false);
								if (_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
								_redoUndoTimeout = $timeout(function () {
									element[0].focus();
									taSelection.setSelectionToElementEnd(element[0]);
								}, 1);
							}
						}
					};
	
					var _redo = scope['$redoTaBind' + (attrs.id || '')] = function () {
						/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
						if (!_isReadonly && _isContentEditable) {
							var content = ngModel.$undoManager.redo();
							if (typeof content !== "undefined" && content !== null) {
								_setInnerHTML(content);
								_setViewValue(content, false);
								/* istanbul ignore next */
								if (_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
								_redoUndoTimeout = $timeout(function () {
									element[0].focus();
									taSelection.setSelectionToElementEnd(element[0]);
								}, 1);
							}
						}
					};
	
					// in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
					var _compileHtml = function _compileHtml() {
						if (_isContentEditable) return element[0].innerHTML;
						if (_isInputFriendly) return element.val();
						throw 'textAngular Error: attempting to update non-editable taBind';
					};
	
					var _setViewValue = function _setViewValue(_val, triggerUndo, skipRender) {
						_skipRender = skipRender || false;
						if (typeof triggerUndo === "undefined" || triggerUndo === null) triggerUndo = true && _isContentEditable; // if not contentEditable then the native undo/redo is fine
						if (typeof _val === "undefined" || _val === null) _val = _compileHtml();
						if (_blankTest(_val)) {
							// this avoids us from tripping the ng-pristine flag if we click in and out with out typing
							if (ngModel.$viewValue !== '') ngModel.$setViewValue('');
							if (triggerUndo && ngModel.$undoManager.current() !== '') ngModel.$undoManager.push('');
						} else {
							_reApplyOnSelectorHandlers();
							if (ngModel.$viewValue !== _val) {
								ngModel.$setViewValue(_val);
								if (triggerUndo) ngModel.$undoManager.push(_val);
							}
						}
						ngModel.$render();
					};
	
					//used for updating when inserting wrapped elements
					scope['updateTaBind' + (attrs.id || '')] = function () {
						if (!_isReadonly) _setViewValue(undefined, undefined, true);
					};
	
					// catch DOM XSS via taSanitize
					// Sanitizing both ways is identical
					var _sanitize = function _sanitize(unsafe) {
						return ngModel.$oldViewValue = taSanitize(taFixChrome(unsafe), ngModel.$oldViewValue, _disableSanitizer);
					};
	
					// trigger the validation calls
					if (element.attr('required')) ngModel.$validators.required = function (modelValue, viewValue) {
						return !_blankTest(modelValue || viewValue);
					};
					// parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
					ngModel.$parsers.push(_sanitize);
					ngModel.$parsers.unshift(_ensureContentWrapped);
					// because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
					ngModel.$formatters.push(_sanitize);
					ngModel.$formatters.unshift(_ensureContentWrapped);
					ngModel.$formatters.unshift(function (value) {
						return ngModel.$undoManager.push(value || '');
					});
	
					//this code is used to update the models when data is entered/deleted
					if (_isInputFriendly) {
						scope.events = {};
						if (!_isContentEditable) {
							// if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
							element.on('change blur', scope.events.change = scope.events.blur = function () {
								if (!_isReadonly) ngModel.$setViewValue(_compileHtml());
							});
	
							element.on('keydown', scope.events.keydown = function (event, eventData) {
								/* istanbul ignore else: this is for catching the jqLite testing*/
								if (eventData) angular.extend(event, eventData);
								// Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
								/* istanbul ignore else: otherwise normal functionality */
								if (event.keyCode === 9) {
									// tab was pressed
									// get caret position/selection
									var start = this.selectionStart;
									var end = this.selectionEnd;
	
									var value = element.val();
									if (event.shiftKey) {
										// find \t
										var _linebreak = value.lastIndexOf('\n', start),
										    _tab = value.lastIndexOf('\t', start);
										if (_tab !== -1 && _tab >= _linebreak) {
											// set textarea value to: text before caret + tab + text after caret
											element.val(value.substring(0, _tab) + value.substring(_tab + 1));
	
											// put caret at right position again (add one for the tab)
											this.selectionStart = this.selectionEnd = start - 1;
										}
									} else {
										// set textarea value to: text before caret + tab + text after caret
										element.val(value.substring(0, start) + "\t" + value.substring(end));
	
										// put caret at right position again (add one for the tab)
										this.selectionStart = this.selectionEnd = start + 1;
									}
									// prevent the focus lose
									event.preventDefault();
								}
							});
	
							var _repeat = function _repeat(string, n) {
								var result = '';
								for (var _n = 0; _n < n; _n++) {
									result += string;
								}return result;
							};
	
							var recursiveListFormat = function recursiveListFormat(listNode, tablevel) {
								var _html = '',
								    _children = listNode.childNodes;
								tablevel++;
								_html += _repeat('\t', tablevel - 1) + listNode.outerHTML.substring(0, listNode.outerHTML.indexOf('<li'));
								for (var _i = 0; _i < _children.length; _i++) {
									/* istanbul ignore next: browser catch */
									if (!_children[_i].outerHTML) continue;
									if (_children[_i].nodeName.toLowerCase() === 'ul' || _children[_i].nodeName.toLowerCase() === 'ol') _html += '\n' + recursiveListFormat(_children[_i], tablevel);else _html += '\n' + _repeat('\t', tablevel) + _children[_i].outerHTML;
								}
								_html += '\n' + _repeat('\t', tablevel - 1) + listNode.outerHTML.substring(listNode.outerHTML.lastIndexOf('<'));
								return _html;
							};
							ngModel.$formatters.unshift(function (htmlValue) {
								// tabulate the HTML so it looks nicer
								var _children = angular.element('<div>' + htmlValue + '</div>')[0].childNodes;
								if (_children.length > 0) {
									htmlValue = '';
									for (var i = 0; i < _children.length; i++) {
										/* istanbul ignore next: browser catch */
										if (!_children[i].outerHTML) continue;
										if (htmlValue.length > 0) htmlValue += '\n';
										if (_children[i].nodeName.toLowerCase() === 'ul' || _children[i].nodeName.toLowerCase() === 'ol') htmlValue += '' + recursiveListFormat(_children[i], 0);else htmlValue += '' + _children[i].outerHTML;
									}
								}
	
								return htmlValue;
							});
						} else {
							// all the code specific to contenteditable divs
							var _processingPaste = false;
							/* istanbul ignore next: phantom js cannot test this for some reason */
							var processpaste = function processpaste(text) {
								/* istanbul ignore else: don't care if nothing pasted */
								if (text && text.trim().length) {
									// test paste from word/microsoft product
									if (text.match(/class=["']*Mso(Normal|List)/i)) {
										var textFragment = text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);
										if (!textFragment) textFragment = text;else textFragment = textFragment[1];
										textFragment = textFragment.replace(/<o:p>[\s\S]*?<\/o:p>/ig, '').replace(/class=(["']|)MsoNormal(["']|)/ig, '');
										var dom = angular.element("<div>" + textFragment + "</div>");
										var targetDom = angular.element("<div></div>");
										var _list = {
											element: null,
											lastIndent: [],
											lastLi: null,
											isUl: false
										};
										_list.lastIndent.peek = function () {
											var n = this.length;
											if (n > 0) return this[n - 1];
										};
										var _resetList = function _resetList(isUl) {
											_list.isUl = isUl;
											_list.element = angular.element(isUl ? "<ul>" : "<ol>");
											_list.lastIndent = [];
											_list.lastIndent.peek = function () {
												var n = this.length;
												if (n > 0) return this[n - 1];
											};
											_list.lastLevelMatch = null;
										};
										for (var i = 0; i <= dom[0].childNodes.length; i++) {
											if (!dom[0].childNodes[i] || dom[0].childNodes[i].nodeName === "#text" || dom[0].childNodes[i].tagName.toLowerCase() !== "p") continue;
											var el = angular.element(dom[0].childNodes[i]);
											var _listMatch = (el.attr('class') || '').match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);
	
											if (_listMatch) {
												if (el[0].childNodes.length < 2 || el[0].childNodes[1].childNodes.length < 1) {
													continue;
												}
												var isUl = _listMatch[1].toLowerCase() === "bullet" || _listMatch[1].toLowerCase() !== "number" && !(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].innerHTML) || /^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].childNodes[0].innerHTML));
												var _indentMatch = (el.attr('style') || '').match(/margin-left:([\-\.0-9]*)/i);
												var indent = parseFloat(_indentMatch ? _indentMatch[1] : 0);
												var _levelMatch = (el.attr('style') || '').match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);
												// prefers the mso-list syntax
	
												if (_levelMatch && _levelMatch[2]) indent = parseInt(_levelMatch[2]);
	
												if (_levelMatch && (!_list.lastLevelMatch || _levelMatch[1] !== _list.lastLevelMatch[1]) || !_listMatch[3] || _listMatch[3].toLowerCase() === "first" || _list.lastIndent.peek() === null || _list.isUl !== isUl && _list.lastIndent.peek() === indent) {
													_resetList(isUl);
													targetDom.append(_list.element);
												} else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() < indent) {
													_list.element = angular.element(isUl ? "<ul>" : "<ol>");
													_list.lastLi.append(_list.element);
												} else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent) {
													while (_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent) {
														if (_list.element.parent()[0].tagName.toLowerCase() === 'li') {
															_list.element = _list.element.parent();
															continue;
														} else if (/[uo]l/i.test(_list.element.parent()[0].tagName.toLowerCase())) {
															_list.element = _list.element.parent();
														} else {
															// else it's it should be a sibling
															break;
														}
														_list.lastIndent.pop();
													}
													_list.isUl = _list.element[0].tagName.toLowerCase() === "ul";
													if (isUl !== _list.isUl) {
														_resetList(isUl);
														targetDom.append(_list.element);
													}
												}
	
												_list.lastLevelMatch = _levelMatch;
												if (indent !== _list.lastIndent.peek()) _list.lastIndent.push(indent);
												_list.lastLi = angular.element("<li>");
												_list.element.append(_list.lastLi);
												_list.lastLi.html(el.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/ig, ''));
												el.remove();
											} else {
												_resetList(false);
												targetDom.append(el);
											}
										}
										var _unwrapElement = function _unwrapElement(node) {
											node = angular.element(node);
											for (var _n = node[0].childNodes.length - 1; _n >= 0; _n--) {
												node.after(node[0].childNodes[_n]);
											}node.remove();
										};
	
										angular.forEach(targetDom.find('span'), function (node) {
											node.removeAttribute('lang');
											if (node.attributes.length <= 0) _unwrapElement(node);
										});
										angular.forEach(targetDom.find('font'), _unwrapElement);
										text = targetDom.html();
									} else {
										// remove unnecessary chrome insert
										text = text.replace(/<(|\/)meta[^>]*?>/ig, '');
										if (text.match(/<[^>]*?(ta-bind)[^>]*?>/)) {
											// entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
											if (text.match(/<[^>]*?(text-angular)[^>]*?>/)) {
												var _el = angular.element("<div>" + text + "</div>");
												_el.find('textarea').remove();
												var binds = taDOM.getByAttribute(_el, 'ta-bind');
												for (var _b = 0; _b < binds.length; _b++) {
													var _target = binds[_b][0].parentNode.parentNode;
													for (var _c = 0; _c < binds[_b][0].childNodes.length; _c++) {
														_target.parentNode.insertBefore(binds[_b][0].childNodes[_c], _target);
													}
													_target.parentNode.removeChild(_target);
												}
												text = _el.html().replace('<br class="Apple-interchange-newline">', '');
											}
										} else if (text.match(/^<span/)) {
											// in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
											text = text.replace(/<(|\/)span[^>]*?>/ig, '');
										}
										// Webkit on Apple tags
										text = text.replace(/<br class="Apple-interchange-newline"[^>]*?>/ig, '').replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/ig, '&nbsp;');
									}
	
									if (/<li(\s.*)?>/i.test(text) && /(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(text) === false) {
										// insert missing parent of li element
										text = text.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i, '<ul>$&</ul>');
									}
	
									if (_pasteHandler) text = _pasteHandler(scope, { $html: text }) || text;
	
									text = taSanitize(text, '', _disableSanitizer);
	
									taSelection.insertHtml(text, element[0]);
									$timeout(function () {
										ngModel.$setViewValue(_compileHtml());
										_processingPaste = false;
										element.removeClass('processing-paste');
									}, 0);
								} else {
									_processingPaste = false;
									element.removeClass('processing-paste');
								}
							};
	
							element.on('paste', scope.events.paste = function (e, eventData) {
								/* istanbul ignore else: this is for catching the jqLite testing*/
								if (eventData) angular.extend(e, eventData);
								if (_isReadonly || _processingPaste) {
									e.stopPropagation();
									e.preventDefault();
									return false;
								}
	
								// Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
								_processingPaste = true;
								element.addClass('processing-paste');
								var pastedContent;
								var clipboardData = (e.originalEvent || e).clipboardData;
								if (clipboardData && clipboardData.getData && clipboardData.types.length > 0) {
									// Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
									var _types = "";
									for (var _t = 0; _t < clipboardData.types.length; _t++) {
										_types += " " + clipboardData.types[_t];
									}
									/* istanbul ignore next: browser tests */
									if (/text\/html/i.test(_types)) {
										pastedContent = clipboardData.getData('text/html');
									} else if (/text\/plain/i.test(_types)) {
										pastedContent = clipboardData.getData('text/plain');
									}
	
									processpaste(pastedContent);
									e.stopPropagation();
									e.preventDefault();
									return false;
								} else {
									// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
									var _savedSelection = $window.rangy.saveSelection(),
									    _tempDiv = angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');
									$document.find('body').append(_tempDiv);
									_tempDiv[0].focus();
									$timeout(function () {
										// restore selection
										$window.rangy.restoreSelection(_savedSelection);
										processpaste(_tempDiv[0].innerHTML);
										element[0].focus();
										_tempDiv.remove();
									}, 0);
								}
							});
							element.on('cut', scope.events.cut = function (e) {
								// timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
								if (!_isReadonly) $timeout(function () {
									ngModel.$setViewValue(_compileHtml());
								}, 0);else e.preventDefault();
							});
	
							element.on('keydown', scope.events.keydown = function (event, eventData) {
								/* istanbul ignore else: this is for catching the jqLite testing*/
								if (eventData) angular.extend(event, eventData);
								event.specialKey = _mapKeys(event);
								var userSpecialKey;
								/* istanbul ignore next: difficult to test */
								taOptions.keyMappings.forEach(function (mapping) {
									if (event.specialKey === mapping.commandKeyCode) {
										// taOptions has remapped this binding... so
										// we disable our own
										event.specialKey = undefined;
									}
									if (mapping.testForKey(event)) {
										userSpecialKey = mapping.commandKeyCode;
									}
									if (mapping.commandKeyCode === 'UndoKey' || mapping.commandKeyCode === 'RedoKey') {
										// this is necessary to fully stop the propagation.
										if (!mapping.enablePropagation) {
											event.preventDefault();
										}
									}
								});
								/* istanbul ignore next: difficult to test */
								if (typeof userSpecialKey !== 'undefined') {
									event.specialKey = userSpecialKey;
								}
								/* istanbul ignore next: difficult to test as can't seem to select */
								if (typeof event.specialKey !== 'undefined' && (event.specialKey !== 'UndoKey' || event.specialKey !== 'RedoKey')) {
									event.preventDefault();
									textAngularManager.sendKeyCommand(scope, event);
								}
								/* istanbul ignore else: readonly check */
								if (!_isReadonly) {
									if (event.specialKey === 'UndoKey') {
										_undo();
										event.preventDefault();
									}
									if (event.specialKey === 'RedoKey') {
										_redo();
										event.preventDefault();
									}
									/* istanbul ignore next: difficult to test as can't seem to select */
									if (event.keyCode === 13 && !event.shiftKey) {
										var $selection;
										var selection = taSelection.getSelectionElement();
										if (!selection.tagName.match(VALIDELEMENTS)) return;
										var _new = angular.element(_defaultVal);
										if (/^<br(|\/)>$/i.test(selection.innerHTML.trim()) && selection.parentNode.tagName.toLowerCase() === 'blockquote' && !selection.nextSibling) {
											// if last element in blockquote and element is blank, pull element outside of blockquote.
											$selection = angular.element(selection);
											var _parent = $selection.parent();
											_parent.after(_new);
											$selection.remove();
											if (_parent.children().length === 0) _parent.remove();
											taSelection.setSelectionToElementStart(_new[0]);
											event.preventDefault();
										} else if (/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(selection.innerHTML.trim()) && selection.tagName.toLowerCase() === 'blockquote') {
											$selection = angular.element(selection);
											$selection.after(_new);
											$selection.remove();
											taSelection.setSelectionToElementStart(_new[0]);
											event.preventDefault();
										}
									}
								}
							});
							var _keyupTimeout;
							element.on('keyup', scope.events.keyup = function (event, eventData) {
								/* istanbul ignore else: this is for catching the jqLite testing*/
								if (eventData) angular.extend(event, eventData);
								/* istanbul ignore next: FF specific bug fix */
								if (event.keyCode === 9) {
									var _selection = taSelection.getSelection();
									if (_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
									return;
								}
								if (_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
								if (!_isReadonly && !BLOCKED_KEYS.test(event.keyCode)) {
									// if enter - insert new taDefaultWrap, if shift+enter insert <br/>
									if (_defaultVal !== '' && event.keyCode === 13) {
										if (!event.shiftKey) {
											// new paragraph, br should be caught correctly
											var selection = taSelection.getSelectionElement();
											while (!selection.tagName.match(VALIDELEMENTS) && selection !== element[0]) {
												selection = selection.parentNode;
											}
	
											if (selection.tagName.toLowerCase() !== attrs.taDefaultWrap && selection.tagName.toLowerCase() !== 'li' && (selection.innerHTML.trim() === '' || selection.innerHTML.trim() === '<br>')) {
												var _new = angular.element(_defaultVal);
												angular.element(selection).replaceWith(_new);
												taSelection.setSelectionToElementStart(_new[0]);
											}
										}
									}
									var val = _compileHtml();
									if (_defaultVal !== '' && val.trim() === '') {
										_setInnerHTML(_defaultVal);
										taSelection.setSelectionToElementStart(element.children()[0]);
									} else if (val.substring(0, 1) !== '<' && attrs.taDefaultWrap !== '') {
										var _savedSelection = $window.rangy.saveSelection();
										val = _compileHtml();
										val = "<" + attrs.taDefaultWrap + ">" + val + "</" + attrs.taDefaultWrap + ">";
										_setInnerHTML(val);
										$window.rangy.restoreSelection(_savedSelection);
									}
									var triggerUndo = _lastKey !== event.keyCode && UNDO_TRIGGER_KEYS.test(event.keyCode);
									if (_keyupTimeout) $timeout.cancel(_keyupTimeout);
									_keyupTimeout = $timeout(function () {
										_setViewValue(val, triggerUndo, true);
									}, ngModelOptions.$options.debounce || 400);
									if (!triggerUndo) _undoKeyupTimeout = $timeout(function () {
										ngModel.$undoManager.push(val);
									}, 250);
									_lastKey = event.keyCode;
								}
							});
	
							element.on('blur', scope.events.blur = function () {
								_focussed = false;
								/* istanbul ignore else: if readonly don't update model */
								if (!_isReadonly) {
									_setViewValue(undefined, undefined, true);
								} else {
									_skipRender = true; // don't redo the whole thing, just check the placeholder logic
									ngModel.$render();
								}
							});
	
							// Placeholders not supported on ie 8 and below
							if (attrs.placeholder && (_browserDetect.ie > 8 || _browserDetect.ie === undefined)) {
								var rule;
								if (attrs.id) rule = addCSSRule('#' + attrs.id + '.placeholder-text:before', 'content: "' + attrs.placeholder + '"');else throw 'textAngular Error: An unique ID is required for placeholders to work';
	
								scope.$on('$destroy', function () {
									removeCSSRule(rule);
								});
							}
	
							element.on('focus', scope.events.focus = function () {
								_focussed = true;
								element.removeClass('placeholder-text');
								_reApplyOnSelectorHandlers();
							});
	
							element.on('mouseup', scope.events.mouseup = function () {
								var _selection = taSelection.getSelection();
								if (_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
							});
	
							// prevent propagation on mousedown in editor, see #206
							element.on('mousedown', scope.events.mousedown = function (event, eventData) {
								/* istanbul ignore else: this is for catching the jqLite testing*/
								if (eventData) angular.extend(event, eventData);
								event.stopPropagation();
							});
						}
					}
	
					var selectorClickHandler = function selectorClickHandler(event) {
						// emit the element-select event, pass the element
						scope.$emit('ta-element-select', this);
						event.preventDefault();
						return false;
					};
					var fileDropHandler = function fileDropHandler(event, eventData) {
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if (eventData) angular.extend(event, eventData);
						// emit the drop event, pass the element, preventing should be done elsewhere
						if (!dropFired && !_isReadonly) {
							dropFired = true;
							var dataTransfer;
							if (event.originalEvent) dataTransfer = event.originalEvent.dataTransfer;else dataTransfer = event.dataTransfer;
							scope.$emit('ta-drop-event', this, event, dataTransfer);
							$timeout(function () {
								dropFired = false;
								_setViewValue(undefined, undefined, true);
							}, 100);
						}
					};
	
					//used for updating when inserting wrapped elements
					var _reApplyOnSelectorHandlers = scope['reApplyOnSelectorHandlers' + (attrs.id || '')] = function () {
						/* istanbul ignore else */
						if (!_isReadonly) angular.forEach(taSelectableElements, function (selector) {
							// check we don't apply the handler twice
							element.find(selector).off('click', selectorClickHandler).on('click', selectorClickHandler);
						});
					};
	
					var _setInnerHTML = function _setInnerHTML(newval) {
						element[0].innerHTML = newval;
					};
					var _renderTimeout;
					var _renderInProgress = false;
					// changes to the model variable from outside the html/text inputs
					ngModel.$render = function () {
						/* istanbul ignore if: Catches rogue renders, hard to replicate in tests */
						if (_renderInProgress) return;else _renderInProgress = true;
						// catch model being null or undefined
						var val = ngModel.$viewValue || '';
						// if the editor isn't focused it needs to be updated, otherwise it's receiving user input
						if (!_skipRender) {
							/* istanbul ignore else: in other cases we don't care */
							if (_isContentEditable && _focussed) {
								// update while focussed
								element.removeClass('placeholder-text');
								if (_renderTimeout) $timeout.cancel(_renderTimeout);
								_renderTimeout = $timeout(function () {
									/* istanbul ignore if: Can't be bothered testing this... */
									if (!_focussed) {
										element[0].focus();
										taSelection.setSelectionToElementEnd(element.children()[element.children().length - 1]);
									}
									_renderTimeout = undefined;
								}, 1);
							}
							if (_isContentEditable) {
								// WYSIWYG Mode
								if (attrs.placeholder) {
									if (val === '') {
										// blank
										_setInnerHTML(_defaultVal);
									} else {
										// not-blank
										_setInnerHTML(val);
									}
								} else {
									_setInnerHTML(val === '' ? _defaultVal : val);
								}
								// if in WYSIWYG and readOnly we kill the use of links by clicking
								if (!_isReadonly) {
									_reApplyOnSelectorHandlers();
									element.on('drop', fileDropHandler);
								} else {
									element.off('drop', fileDropHandler);
								}
							} else if (element[0].tagName.toLowerCase() !== 'textarea' && element[0].tagName.toLowerCase() !== 'input') {
								// make sure the end user can SEE the html code as a display. This is a read-only display element
								_setInnerHTML(taApplyCustomRenderers(val));
							} else {
								// only for input and textarea inputs
								element.val(val);
							}
						}
						if (_isContentEditable && attrs.placeholder) {
							if (val === '') {
								if (_focussed) element.removeClass('placeholder-text');else element.addClass('placeholder-text');
							} else {
								element.removeClass('placeholder-text');
							}
						}
						_renderInProgress = _skipRender = false;
					};
	
					if (attrs.taReadonly) {
						//set initial value
						_isReadonly = scope.$eval(attrs.taReadonly);
						if (_isReadonly) {
							element.addClass('ta-readonly');
							// we changed to readOnly mode (taReadonly='true')
							if (element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input') {
								element.attr('disabled', 'disabled');
							}
							if (element.attr('contenteditable') !== undefined && element.attr('contenteditable')) {
								element.removeAttr('contenteditable');
							}
						} else {
							element.removeClass('ta-readonly');
							// we changed to NOT readOnly mode (taReadonly='false')
							if (element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input') {
								element.removeAttr('disabled');
							} else if (_isContentEditable) {
								element.attr('contenteditable', 'true');
							}
						}
						// taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
						// Otherwise it is readonly by default
						scope.$watch(attrs.taReadonly, function (newVal, oldVal) {
							if (oldVal === newVal) return;
							if (newVal) {
								element.addClass('ta-readonly');
								// we changed to readOnly mode (taReadonly='true')
								if (element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input') {
									element.attr('disabled', 'disabled');
								}
								if (element.attr('contenteditable') !== undefined && element.attr('contenteditable')) {
									element.removeAttr('contenteditable');
								}
								// turn ON selector click handlers
								angular.forEach(taSelectableElements, function (selector) {
									element.find(selector).on('click', selectorClickHandler);
								});
								element.off('drop', fileDropHandler);
							} else {
								element.removeClass('ta-readonly');
								// we changed to NOT readOnly mode (taReadonly='false')
								if (element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input') {
									element.removeAttr('disabled');
								} else if (_isContentEditable) {
									element.attr('contenteditable', 'true');
								}
								// remove the selector click handlers
								angular.forEach(taSelectableElements, function (selector) {
									element.find(selector).off('click', selectorClickHandler);
								});
								element.on('drop', fileDropHandler);
							}
							_isReadonly = newVal;
						});
					}
	
					// Initialise the selectableElements
					// if in WYSIWYG and readOnly we kill the use of links by clicking
					if (_isContentEditable && !_isReadonly) {
						angular.forEach(taSelectableElements, function (selector) {
							element.find(selector).on('click', selectorClickHandler);
						});
						element.on('drop', fileDropHandler);
						element.on('blur', function () {
							/* istanbul ignore next: webkit fix */
							if (_browserDetect.webkit) {
								// detect webkit
								globalContentEditableBlur = true;
							}
						});
					}
				}
			};
		}]);
	
		// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
		var dropFired = false;
		var textAngular = angular.module("textAngular", ['ngSanitize', 'textAngularSetup', 'textAngular.factories', 'textAngular.DOM', 'textAngular.validators', 'textAngular.taBind']); //This makes ngSanitize required
	
		// setup the global contstant functions for setting up the toolbar
	
		// all tool definitions
		var taTools = {};
		/*
	 	A tool definition is an object with the following key/value parameters:
	 		action: [function(deferred, restoreSelection)]
	 				a function that is executed on clicking on the button - this will allways be executed using ng-click and will
	 				overwrite any ng-click value in the display attribute.
	 				The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
	 				manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
	 				restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
	 				selection in the WYSIWYG editor.
	 		display: [string]?
	 				Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
	 				If set this will cause buttontext and iconclass to be ignored
	 		class: [string]?
	 				Optional, if set will override the taOptions.classes.toolbarButton class.
	 		buttontext: [string]?
	 				if this is defined it will replace the contents of the element contained in the `display` element
	 		iconclass: [string]?
	 				if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
	 		tooltiptext: [string]?
	 				Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
	 		activestate: [function(commonElement)]?
	 				this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
	 				will be applied to the `display` element, else the class will be removed
	 		disabled: [function()]?
	 				if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
	 	Other functions available on the scope are:
	 		name: [string]
	 				the name of the tool, this is the first parameter passed into taRegisterTool
	 		isDisabled: [function()]
	 				returns true if the tool is disabled, false if it isn't
	 		displayActiveToolClass: [function(boolean)]
	 				returns true if the tool is 'active' in the currently focussed toolbar
	 		onElementSelect: [Object]
	 				This object contains the following key/value pairs and is used to trigger the ta-element-select event
	 				element: [String]
	 					an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
	 				filter: [function(element)]?
	 					an optional filter that returns a boolean, if true it will trigger the onElementSelect.
	 				action: [function(event, element, editorScope)]
	 					the action that should be executed if the onElementSelect function runs
	 */
		// name and toolDefinition to add into the tools available to be added on the toolbar
		function registerTextAngularTool(name, toolDefinition) {
			if (!name || name === '' || taTools.hasOwnProperty(name)) throw 'textAngular Error: A unique name is required for a Tool Definition';
			if (toolDefinition.display && (toolDefinition.display === '' || !validElementString(toolDefinition.display)) || !toolDefinition.display && !toolDefinition.buttontext && !toolDefinition.iconclass) throw 'textAngular Error: Tool Definition for "' + name + '" does not have a valid display/iconclass/buttontext value';
			taTools[name] = toolDefinition;
		}
	
		textAngular.constant('taRegisterTool', registerTextAngularTool);
		textAngular.value('taTools', taTools);
	
		textAngular.config([function () {
			// clear taTools variable. Just catches testing and any other time that this config may run multiple times...
			angular.forEach(taTools, function (value, key) {
				delete taTools[key];
			});
		}]);
	
		textAngular.run([function () {
			/* istanbul ignore next: not sure how to test this */
			// Require Rangy and rangy savedSelection module.
			if (!window.rangy) {
				throw "rangy-core.js and rangy-selectionsaverestore.js are required for textAngular to work correctly, rangy-core is not yet loaded.";
			} else {
				window.rangy.init();
				if (!window.rangy.saveSelection) {
					throw "rangy-selectionsaverestore.js is required for textAngular to work correctly.";
				}
			}
		}]);
	
		textAngular.directive("textAngular", ['$compile', '$timeout', 'taOptions', 'taSelection', 'taExecCommand', 'textAngularManager', '$window', '$document', '$animate', '$log', '$q', '$parse', function ($compile, $timeout, taOptions, taSelection, taExecCommand, textAngularManager, $window, $document, $animate, $log, $q, $parse) {
			return {
				require: '?ngModel',
				scope: {},
				restrict: "EA",
				priority: 2, // So we override validators correctly
				link: function link(scope, element, attrs, ngModel) {
					// all these vars should not be accessable outside this directive
					var _keydown,
					    _keyup,
					    _keypress,
					    _mouseup,
					    _focusin,
					    _focusout,
					    _originalContents,
					    _toolbars,
					    _serial = attrs.serial ? attrs.serial : Math.floor(Math.random() * 10000000000000000),
					    _taExecCommand,
					    _resizeMouseDown,
					    _updateSelectedStylesTimeout;
	
					scope._name = attrs.name ? attrs.name : 'textAngularEditor' + _serial;
	
					var oneEvent = function oneEvent(_element, event, action) {
						$timeout(function () {
							// shim the .one till fixed
							var _func = function _func() {
								_element.off(event, _func);
								action.apply(this, arguments);
							};
							_element.on(event, _func);
						}, 100);
					};
					_taExecCommand = taExecCommand(attrs.taDefaultWrap);
					// get the settings from the defaults and add our specific functions that need to be on the scope
					angular.extend(scope, angular.copy(taOptions), {
						// wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
						wrapSelection: function wrapSelection(command, opt, isSelectableElementTool) {
							if (command.toLowerCase() === "undo") {
								scope['$undoTaBindtaTextElement' + _serial]();
							} else if (command.toLowerCase() === "redo") {
								scope['$redoTaBindtaTextElement' + _serial]();
							} else {
								// catch errors like FF erroring when you try to force an undo with nothing done
								_taExecCommand(command, false, opt, scope.defaultTagAttributes);
								if (isSelectableElementTool) {
									// re-apply the selectable tool events
									scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
								}
								// refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
								// You still have focus on the text/html input it just doesn't show up
								scope.displayElements.text[0].focus();
							}
						},
						showHtml: scope.$eval(attrs.taShowHtml) || false
					});
					// setup the options from the optional attributes
					if (attrs.taFocussedClass) scope.classes.focussed = attrs.taFocussedClass;
					if (attrs.taTextEditorClass) scope.classes.textEditor = attrs.taTextEditorClass;
					if (attrs.taHtmlEditorClass) scope.classes.htmlEditor = attrs.taHtmlEditorClass;
					if (attrs.taDefaultTagAttributes) {
						try {
							//	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
							angular.extend(scope.defaultTagAttributes, angular.fromJson(attrs.taDefaultTagAttributes));
						} catch (error) {
							$log.error(error);
						}
					}
					// optional setup functions
					if (attrs.taTextEditorSetup) scope.setup.textEditorSetup = scope.$parent.$eval(attrs.taTextEditorSetup);
					if (attrs.taHtmlEditorSetup) scope.setup.htmlEditorSetup = scope.$parent.$eval(attrs.taHtmlEditorSetup);
					// optional fileDropHandler function
					if (attrs.taFileDrop) scope.fileDropHandler = scope.$parent.$eval(attrs.taFileDrop);else scope.fileDropHandler = scope.defaultFileDropHandler;
	
					_originalContents = element[0].innerHTML;
					// clear the original content
					element[0].innerHTML = '';
	
					// Setup the HTML elements as variable references for use later
					scope.displayElements = {
						// we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
						// wheras the input will ALLWAYS have the correct value.
						forminput: angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),
						html: angular.element("<textarea></textarea>"),
						text: angular.element("<div></div>"),
						// other toolbased elements
						scrollWindow: angular.element("<div class='ta-scroll-window'></div>"),
						popover: angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),
						popoverArrow: angular.element('<div class="arrow"></div>'),
						popoverContainer: angular.element('<div class="popover-content"></div>'),
						resize: {
							overlay: angular.element('<div class="ta-resizer-handle-overlay"></div>'),
							background: angular.element('<div class="ta-resizer-handle-background"></div>'),
							anchors: [angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'), angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'), angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'), angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')],
							info: angular.element('<div class="ta-resizer-handle-info"></div>')
						}
					};
	
					// Setup the popover
					scope.displayElements.popover.append(scope.displayElements.popoverArrow);
					scope.displayElements.popover.append(scope.displayElements.popoverContainer);
					scope.displayElements.scrollWindow.append(scope.displayElements.popover);
	
					scope.displayElements.popover.on('mousedown', function (e, eventData) {
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if (eventData) angular.extend(e, eventData);
						// this prevents focusout from firing on the editor when clicking anything in the popover
						e.preventDefault();
						return false;
					});
	
					// define the popover show and hide functions
					scope.showPopover = function (_el) {
						scope.displayElements.popover.css('display', 'block');
						scope.reflowPopover(_el);
						$animate.addClass(scope.displayElements.popover, 'in');
						oneEvent($document.find('body'), 'click keyup', function () {
							scope.hidePopover();
						});
					};
					scope.reflowPopover = function (_el) {
						/* istanbul ignore if: catches only if near bottom of editor */
						if (scope.displayElements.text[0].offsetHeight - 51 > _el[0].offsetTop) {
							scope.displayElements.popover.css('top', _el[0].offsetTop + _el[0].offsetHeight + scope.displayElements.scrollWindow[0].scrollTop + 'px');
							scope.displayElements.popover.removeClass('top').addClass('bottom');
						} else {
							scope.displayElements.popover.css('top', _el[0].offsetTop - 54 + scope.displayElements.scrollWindow[0].scrollTop + 'px');
							scope.displayElements.popover.removeClass('bottom').addClass('top');
						}
						var _maxLeft = scope.displayElements.text[0].offsetWidth - scope.displayElements.popover[0].offsetWidth;
						var _targetLeft = _el[0].offsetLeft + _el[0].offsetWidth / 2.0 - scope.displayElements.popover[0].offsetWidth / 2.0;
						scope.displayElements.popover.css('left', Math.max(0, Math.min(_maxLeft, _targetLeft)) + 'px');
						scope.displayElements.popoverArrow.css('margin-left', Math.min(_targetLeft, Math.max(0, _targetLeft - _maxLeft)) - 11 + 'px');
					};
					scope.hidePopover = function () {
						/* istanbul ignore next: dosen't test with mocked animate */
						var doneCb = function doneCb() {
							scope.displayElements.popover.css('display', '');
							scope.displayElements.popoverContainer.attr('style', '');
							scope.displayElements.popoverContainer.attr('class', 'popover-content');
						};
						$q.when($animate.removeClass(scope.displayElements.popover, 'in', doneCb)).then(doneCb);
					};
	
					// setup the resize overlay
					scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);
					angular.forEach(scope.displayElements.resize.anchors, function (anchor) {
						scope.displayElements.resize.overlay.append(anchor);
					});
					scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);
					scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);
	
					// define the show and hide events
					scope.reflowResizeOverlay = function (_el) {
						_el = angular.element(_el)[0];
						scope.displayElements.resize.overlay.css({
							'display': 'block',
							'left': _el.offsetLeft - 5 + 'px',
							'top': _el.offsetTop - 5 + 'px',
							'width': _el.offsetWidth + 10 + 'px',
							'height': _el.offsetHeight + 10 + 'px'
						});
						scope.displayElements.resize.info.text(_el.offsetWidth + ' x ' + _el.offsetHeight);
					};
					/* istanbul ignore next: pretty sure phantomjs won't test this */
					scope.showResizeOverlay = function (_el) {
						var _body = $document.find('body');
						_resizeMouseDown = function _resizeMouseDown(event) {
							var startPosition = {
								width: parseInt(_el.attr('width')),
								height: parseInt(_el.attr('height')),
								x: event.clientX,
								y: event.clientY
							};
							if (startPosition.width === undefined || isNaN(startPosition.width)) startPosition.width = _el[0].offsetWidth;
							if (startPosition.height === undefined || isNaN(startPosition.height)) startPosition.height = _el[0].offsetHeight;
							scope.hidePopover();
							var ratio = startPosition.height / startPosition.width;
							var mousemove = function mousemove(event) {
								// calculate new size
								var pos = {
									x: Math.max(0, startPosition.width + (event.clientX - startPosition.x)),
									y: Math.max(0, startPosition.height + (event.clientY - startPosition.y))
								};
	
								// DEFAULT: the aspect ratio is not locked unless the Shift key is pressed.
								//
								// attribute: ta-resize-force-aspect-ratio -- locks resize into maintaing the aspect ratio
								var bForceAspectRatio = attrs.taResizeForceAspectRatio !== undefined;
								// attribute: ta-resize-maintain-aspect-ratio=true causes the space ratio to remain locked
								// unless the Shift key is pressed
								var bFlipKeyBinding = attrs.taResizeMaintainAspectRatio;
								var bKeepRatio = bForceAspectRatio || bFlipKeyBinding && !event.shiftKey;
								if (bKeepRatio) {
									var newRatio = pos.y / pos.x;
									pos.x = ratio > newRatio ? pos.x : pos.y / ratio;
									pos.y = ratio > newRatio ? pos.x * ratio : pos.y;
								}
								var el = angular.element(_el);
								el.css('height', Math.round(Math.max(0, pos.y) + 'px'));
								el.css('width', Math.round(Math.max(0, pos.x) + 'px'));
	
								// reflow the popover tooltip
								scope.reflowResizeOverlay(_el);
							};
							_body.on('mousemove', mousemove);
							oneEvent(_body, 'mouseup', function (event) {
								event.preventDefault();
								event.stopPropagation();
								_body.off('mousemove', mousemove);
								scope.showPopover(_el);
							});
							event.stopPropagation();
							event.preventDefault();
						};
	
						scope.displayElements.resize.anchors[3].off('mousedown');
						scope.displayElements.resize.anchors[3].on('mousedown', _resizeMouseDown);
	
						scope.reflowResizeOverlay(_el);
						oneEvent(_body, 'click', function () {
							scope.hideResizeOverlay();
						});
					};
					/* istanbul ignore next: pretty sure phantomjs won't test this */
					scope.hideResizeOverlay = function () {
						scope.displayElements.resize.anchors[3].off('mousedown', _resizeMouseDown);
						scope.displayElements.resize.overlay.css('display', '');
					};
	
					// allow for insertion of custom directives on the textarea and div
					scope.setup.htmlEditorSetup(scope.displayElements.html);
					scope.setup.textEditorSetup(scope.displayElements.text);
					scope.displayElements.html.attr({
						'id': 'taHtmlElement' + _serial,
						'ng-show': 'showHtml',
						'ta-bind': 'ta-bind',
						'ng-model': 'html',
						'ng-model-options': element.attr('ng-model-options')
					});
					scope.displayElements.text.attr({
						'id': 'taTextElement' + _serial,
						'contentEditable': 'true',
						'ta-bind': 'ta-bind',
						'ng-model': 'html',
						'ng-model-options': element.attr('ng-model-options')
					});
					scope.displayElements.scrollWindow.attr({ 'ng-hide': 'showHtml' });
					if (attrs.taDefaultWrap) scope.displayElements.text.attr('ta-default-wrap', attrs.taDefaultWrap);
	
					if (attrs.taUnsafeSanitizer) {
						scope.displayElements.text.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
						scope.displayElements.html.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
					}
	
					// add the main elements to the origional element
					scope.displayElements.scrollWindow.append(scope.displayElements.text);
					element.append(scope.displayElements.scrollWindow);
					element.append(scope.displayElements.html);
	
					scope.displayElements.forminput.attr('name', scope._name);
					element.append(scope.displayElements.forminput);
	
					if (attrs.tabindex) {
						element.removeAttr('tabindex');
						scope.displayElements.text.attr('tabindex', attrs.tabindex);
						scope.displayElements.html.attr('tabindex', attrs.tabindex);
					}
	
					if (attrs.placeholder) {
						scope.displayElements.text.attr('placeholder', attrs.placeholder);
						scope.displayElements.html.attr('placeholder', attrs.placeholder);
					}
	
					if (attrs.taDisabled) {
						scope.displayElements.text.attr('ta-readonly', 'disabled');
						scope.displayElements.html.attr('ta-readonly', 'disabled');
						scope.disabled = scope.$parent.$eval(attrs.taDisabled);
						scope.$parent.$watch(attrs.taDisabled, function (newVal) {
							scope.disabled = newVal;
							if (scope.disabled) {
								element.addClass(scope.classes.disabled);
							} else {
								element.removeClass(scope.classes.disabled);
							}
						});
					}
	
					if (attrs.taPaste) {
						scope._pasteHandler = function (_html) {
							return $parse(attrs.taPaste)(scope.$parent, { $html: _html });
						};
						scope.displayElements.text.attr('ta-paste', '_pasteHandler($html)');
					}
	
					// compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
					$compile(scope.displayElements.scrollWindow)(scope);
					$compile(scope.displayElements.html)(scope);
	
					scope.updateTaBindtaTextElement = scope['updateTaBindtaTextElement' + _serial];
					scope.updateTaBindtaHtmlElement = scope['updateTaBindtaHtmlElement' + _serial];
	
					// add the classes manually last
					element.addClass("ta-root");
					scope.displayElements.scrollWindow.addClass("ta-text ta-editor " + scope.classes.textEditor);
					scope.displayElements.html.addClass("ta-html ta-editor " + scope.classes.htmlEditor);
	
					// used in the toolbar actions
					scope._actionRunning = false;
					var _savedSelection = false;
					scope.startAction = function () {
						scope._actionRunning = true;
						// if rangy library is loaded return a function to reload the current selection
						_savedSelection = $window.rangy.saveSelection();
						return function () {
							if (_savedSelection) $window.rangy.restoreSelection(_savedSelection);
						};
					};
					scope.endAction = function () {
						scope._actionRunning = false;
						if (_savedSelection) {
							if (scope.showHtml) {
								scope.displayElements.html[0].focus();
							} else {
								scope.displayElements.text[0].focus();
							}
							// $window.rangy.restoreSelection(_savedSelection);
							$window.rangy.removeMarkers(_savedSelection);
						}
						_savedSelection = false;
						scope.updateSelectedStyles();
						// only update if in text or WYSIWYG mode
						if (!scope.showHtml) scope['updateTaBindtaTextElement' + _serial]();
					};
	
					// note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
					// cascades to displayElements.text and displayElements.html automatically.
					_focusin = function _focusin() {
						scope.focussed = true;
						element.addClass(scope.classes.focussed);
						_toolbars.focus();
						element.triggerHandler('focus');
					};
					scope.displayElements.html.on('focus', _focusin);
					scope.displayElements.text.on('focus', _focusin);
					_focusout = function _focusout(e) {
						// if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
						if (!scope._actionRunning && $document[0].activeElement !== scope.displayElements.html[0] && $document[0].activeElement !== scope.displayElements.text[0]) {
							element.removeClass(scope.classes.focussed);
							_toolbars.unfocus();
							// to prevent multiple apply error defer to next seems to work.
							$timeout(function () {
								scope._bUpdateSelectedStyles = false;
								element.triggerHandler('blur');
								scope.focussed = false;
							}, 0);
						}
						e.preventDefault();
						return false;
					};
					scope.displayElements.html.on('blur', _focusout);
					scope.displayElements.text.on('blur', _focusout);
	
					scope.displayElements.text.on('paste', function (event) {
						element.triggerHandler('paste', event);
					});
	
					// Setup the default toolbar tools, this way allows the user to add new tools like plugins.
					// This is on the editor for future proofing if we find a better way to do this.
					scope.queryFormatBlockState = function (command) {
						// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
						return !scope.showHtml && command.toLowerCase() === $document[0].queryCommandValue('formatBlock').toLowerCase();
					};
					scope.queryCommandState = function (command) {
						// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
						return !scope.showHtml ? $document[0].queryCommandState(command) : '';
					};
					scope.switchView = function () {
						scope.showHtml = !scope.showHtml;
						$animate.enabled(false, scope.displayElements.html);
						$animate.enabled(false, scope.displayElements.text);
						//Show the HTML view
						if (scope.showHtml) {
							//defer until the element is visible
							$timeout(function () {
								$animate.enabled(true, scope.displayElements.html);
								$animate.enabled(true, scope.displayElements.text);
								// [0] dereferences the DOM object from the angular.element
								return scope.displayElements.html[0].focus();
							}, 100);
						} else {
							//Show the WYSIWYG view
							//defer until the element is visible
							$timeout(function () {
								$animate.enabled(true, scope.displayElements.html);
								$animate.enabled(true, scope.displayElements.text);
								// [0] dereferences the DOM object from the angular.element
								return scope.displayElements.text[0].focus();
							}, 100);
						}
					};
	
					// changes to the model variable from outside the html/text inputs
					// if no ngModel, then the only input is from inside text-angular
					if (attrs.ngModel) {
						var _firstRun = true;
						ngModel.$render = function () {
							if (_firstRun) {
								// we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
								_firstRun = false;
								// if view value is null or undefined initially and there was original content, set to the original content
								var _initialValue = scope.$parent.$eval(attrs.ngModel);
								if ((_initialValue === undefined || _initialValue === null) && _originalContents && _originalContents !== '') {
									// on passing through to taBind it will be sanitised
									ngModel.$setViewValue(_originalContents);
								}
							}
							scope.displayElements.forminput.val(ngModel.$viewValue);
							// if the editors aren't focused they need to be updated, otherwise they are doing the updating
							scope.html = ngModel.$viewValue || '';
						};
						// trigger the validation calls
						if (element.attr('required')) ngModel.$validators.required = function (modelValue, viewValue) {
							var value = modelValue || viewValue;
							return !(!value || value.trim() === '');
						};
					} else {
						// if no ngModel then update from the contents of the origional html.
						scope.displayElements.forminput.val(_originalContents);
						scope.html = _originalContents;
					}
	
					// changes from taBind back up to here
					scope.$watch('html', function (newValue, oldValue) {
						if (newValue !== oldValue) {
							if (attrs.ngModel && ngModel.$viewValue !== newValue) ngModel.$setViewValue(newValue);
							scope.displayElements.forminput.val(newValue);
						}
					});
	
					if (attrs.taTargetToolbars) _toolbars = textAngularManager.registerEditor(scope._name, scope, attrs.taTargetToolbars.split(','));else {
						var _toolbar = angular.element('<div text-angular-toolbar name="textAngularToolbar' + _serial + '">');
						// passthrough init of toolbar options
						if (attrs.taToolbar) _toolbar.attr('ta-toolbar', attrs.taToolbar);
						if (attrs.taToolbarClass) _toolbar.attr('ta-toolbar-class', attrs.taToolbarClass);
						if (attrs.taToolbarGroupClass) _toolbar.attr('ta-toolbar-group-class', attrs.taToolbarGroupClass);
						if (attrs.taToolbarButtonClass) _toolbar.attr('ta-toolbar-button-class', attrs.taToolbarButtonClass);
						if (attrs.taToolbarActiveButtonClass) _toolbar.attr('ta-toolbar-active-button-class', attrs.taToolbarActiveButtonClass);
						if (attrs.taFocussedClass) _toolbar.attr('ta-focussed-class', attrs.taFocussedClass);
	
						element.prepend(_toolbar);
						$compile(_toolbar)(scope.$parent);
						_toolbars = textAngularManager.registerEditor(scope._name, scope, ['textAngularToolbar' + _serial]);
					}
	
					scope.$on('$destroy', function () {
						textAngularManager.unregisterEditor(scope._name);
					});
	
					// catch element select event and pass to toolbar tools
					scope.$on('ta-element-select', function (event, element) {
						if (_toolbars.triggerElementSelect(event, element)) {
							scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
						}
					});
	
					scope.$on('ta-drop-event', function (event, element, dropEvent, dataTransfer) {
						scope.displayElements.text[0].focus();
						if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
							angular.forEach(dataTransfer.files, function (file) {
								// taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
								// If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
								// Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
								try {
									$q.when(scope.fileDropHandler(file, scope.wrapSelection) || scope.fileDropHandler !== scope.defaultFileDropHandler && $q.when(scope.defaultFileDropHandler(file, scope.wrapSelection))).then(function () {
										scope['updateTaBindtaTextElement' + _serial]();
									});
								} catch (error) {
									$log.error(error);
								}
							});
							dropEvent.preventDefault();
							dropEvent.stopPropagation();
							/* istanbul ignore else, the updates if moved text */
						} else {
							$timeout(function () {
								scope['updateTaBindtaTextElement' + _serial]();
							}, 0);
						}
					});
	
					// the following is for applying the active states to the tools that support it
					scope._bUpdateSelectedStyles = false;
					/* istanbul ignore next: browser window/tab leave check */
					angular.element(window).on('blur', function () {
						scope._bUpdateSelectedStyles = false;
						scope.focussed = false;
					});
					// loop through all the tools polling their activeState function if it exists
					scope.updateSelectedStyles = function () {
						var _selection;
						/* istanbul ignore next: This check is to ensure multiple timeouts don't exist */
						if (_updateSelectedStylesTimeout) $timeout.cancel(_updateSelectedStylesTimeout);
						// test if the common element ISN'T the root ta-text node
						if ((_selection = taSelection.getSelectionElement()) !== undefined && _selection.parentNode !== scope.displayElements.text[0]) {
							_toolbars.updateSelectedStyles(angular.element(_selection));
						} else _toolbars.updateSelectedStyles();
						// used to update the active state when a key is held down, ie the left arrow
						/* istanbul ignore else: browser only check */
						if (scope._bUpdateSelectedStyles) _updateSelectedStylesTimeout = $timeout(scope.updateSelectedStyles, 200);
					};
					// start updating on keydown
					_keydown = function _keydown() {
						/* istanbul ignore next: ie catch */
						if (!scope.focussed) {
							scope._bUpdateSelectedStyles = false;
							return;
						}
						/* istanbul ignore else: don't run if already running */
						if (!scope._bUpdateSelectedStyles) {
							scope._bUpdateSelectedStyles = true;
							scope.$apply(function () {
								scope.updateSelectedStyles();
							});
						}
					};
					scope.displayElements.html.on('keydown', _keydown);
					scope.displayElements.text.on('keydown', _keydown);
					// stop updating on key up and update the display/model
					_keyup = function _keyup() {
						scope._bUpdateSelectedStyles = false;
					};
					scope.displayElements.html.on('keyup', _keyup);
					scope.displayElements.text.on('keyup', _keyup);
					// stop updating on key up and update the display/model
					_keypress = function _keypress(event, eventData) {
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if (eventData) angular.extend(event, eventData);
						scope.$apply(function () {
							if (_toolbars.sendKeyCommand(event)) {
								/* istanbul ignore else: don't run if already running */
								if (!scope._bUpdateSelectedStyles) {
									scope.updateSelectedStyles();
								}
								event.preventDefault();
								return false;
							}
						});
					};
					scope.displayElements.html.on('keypress', _keypress);
					scope.displayElements.text.on('keypress', _keypress);
					// update the toolbar active states when we click somewhere in the text/html boxed
					_mouseup = function _mouseup() {
						// ensure only one execution of updateSelectedStyles()
						scope._bUpdateSelectedStyles = false;
						scope.$apply(function () {
							scope.updateSelectedStyles();
						});
					};
					scope.displayElements.html.on('mouseup', _mouseup);
					scope.displayElements.text.on('mouseup', _mouseup);
				}
			};
		}]);
		textAngular.service('textAngularManager', ['taToolExecuteAction', 'taTools', 'taRegisterTool', function (taToolExecuteAction, taTools, taRegisterTool) {
			// this service is used to manage all textAngular editors and toolbars.
			// All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
			// these contain references to all the editors and toolbars that have been initialised in this app
			var toolbars = {},
			    editors = {};
			// when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
			// We also need to set the tools to be updated to be the toolbars...
			return {
				// register an editor and the toolbars that it is affected by
				registerEditor: function registerEditor(name, scope, targetToolbars) {
					// targetToolbars are optional, we don't require a toolbar to function
					if (!name || name === '') throw 'textAngular Error: An editor requires a name';
					if (!scope) throw 'textAngular Error: An editor requires a scope';
					if (editors[name]) throw 'textAngular Error: An Editor with name "' + name + '" already exists';
					// _toolbars is an ARRAY of toolbar scopes
					var _toolbars = [];
					angular.forEach(targetToolbars, function (_name) {
						if (toolbars[_name]) _toolbars.push(toolbars[_name]);
						// if it doesn't exist it may not have been compiled yet and it will be added later
					});
					editors[name] = {
						scope: scope,
						toolbars: targetToolbars,
						_registerToolbar: function _registerToolbar(toolbarScope) {
							// add to the list late
							if (this.toolbars.indexOf(toolbarScope.name) >= 0) _toolbars.push(toolbarScope);
						},
						// this is a suite of functions the editor should use to update all it's linked toolbars
						editorFunctions: {
							disable: function disable() {
								// disable all linked toolbars
								angular.forEach(_toolbars, function (toolbarScope) {
									toolbarScope.disabled = true;
								});
							},
							enable: function enable() {
								// enable all linked toolbars
								angular.forEach(_toolbars, function (toolbarScope) {
									toolbarScope.disabled = false;
								});
							},
							focus: function focus() {
								// this should be called when the editor is focussed
								angular.forEach(_toolbars, function (toolbarScope) {
									toolbarScope._parent = scope;
									toolbarScope.disabled = false;
									toolbarScope.focussed = true;
									scope.focussed = true;
								});
							},
							unfocus: function unfocus() {
								// this should be called when the editor becomes unfocussed
								angular.forEach(_toolbars, function (toolbarScope) {
									toolbarScope.disabled = true;
									toolbarScope.focussed = false;
								});
								scope.focussed = false;
							},
							updateSelectedStyles: function updateSelectedStyles(selectedElement) {
								// update the active state of all buttons on liked toolbars
								angular.forEach(_toolbars, function (toolbarScope) {
									angular.forEach(toolbarScope.tools, function (toolScope) {
										if (toolScope.activeState) {
											toolbarScope._parent = scope;
											toolScope.active = toolScope.activeState(selectedElement);
										}
									});
								});
							},
							sendKeyCommand: function sendKeyCommand(event) {
								// we return true if we applied an action, false otherwise
								var result = false;
								if (event.ctrlKey || event.metaKey || event.specialKey) angular.forEach(taTools, function (tool, name) {
									if (tool.commandKeyCode && (tool.commandKeyCode === event.which || tool.commandKeyCode === event.specialKey)) {
										for (var _t = 0; _t < _toolbars.length; _t++) {
											if (_toolbars[_t].tools[name] !== undefined) {
												taToolExecuteAction.call(_toolbars[_t].tools[name], scope);
												result = true;
												break;
											}
										}
									}
								});
								return result;
							},
							triggerElementSelect: function triggerElementSelect(event, element) {
								// search through the taTools to see if a match for the tag is made.
								// if there is, see if the tool is on a registered toolbar and not disabled.
								// NOTE: This can trigger on MULTIPLE tools simultaneously.
								var elementHasAttrs = function elementHasAttrs(_element, attrs) {
									var result = true;
									for (var i = 0; i < attrs.length; i++) {
										result = result && _element.attr(attrs[i]);
									}return result;
								};
								var workerTools = [];
								var unfilteredTools = {};
								var result = false;
								element = angular.element(element);
								// get all valid tools by element name, keep track if one matches the
								var onlyWithAttrsFilter = false;
								angular.forEach(taTools, function (tool, name) {
									if (tool.onElementSelect && tool.onElementSelect.element && tool.onElementSelect.element.toLowerCase() === element[0].tagName.toLowerCase() && (!tool.onElementSelect.filter || tool.onElementSelect.filter(element))) {
										// this should only end up true if the element matches the only attributes
										onlyWithAttrsFilter = onlyWithAttrsFilter || angular.isArray(tool.onElementSelect.onlyWithAttrs) && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs);
										if (!tool.onElementSelect.onlyWithAttrs || elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) unfilteredTools[name] = tool;
									}
								});
								// if we matched attributes to filter on, then filter, else continue
								if (onlyWithAttrsFilter) {
									angular.forEach(unfilteredTools, function (tool, name) {
										if (tool.onElementSelect.onlyWithAttrs && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) workerTools.push({ 'name': name, 'tool': tool });
									});
									// sort most specific (most attrs to find) first
									workerTools.sort(function (a, b) {
										return b.tool.onElementSelect.onlyWithAttrs.length - a.tool.onElementSelect.onlyWithAttrs.length;
									});
								} else {
									angular.forEach(unfilteredTools, function (tool, name) {
										workerTools.push({ 'name': name, 'tool': tool });
									});
								}
								// Run the actions on the first visible filtered tool only
								if (workerTools.length > 0) {
									for (var _i = 0; _i < workerTools.length; _i++) {
										var tool = workerTools[_i].tool;
										var name = workerTools[_i].name;
										for (var _t = 0; _t < _toolbars.length; _t++) {
											if (_toolbars[_t].tools[name] !== undefined) {
												tool.onElementSelect.action.call(_toolbars[_t].tools[name], event, element, scope);
												result = true;
												break;
											}
										}
										if (result) break;
									}
								}
								return result;
							}
						}
					};
					return editors[name].editorFunctions;
				},
				// retrieve editor by name, largely used by testing suites only
				retrieveEditor: function retrieveEditor(name) {
					return editors[name];
				},
				unregisterEditor: function unregisterEditor(name) {
					delete editors[name];
				},
				// registers a toolbar such that it can be linked to editors
				registerToolbar: function registerToolbar(scope) {
					if (!scope) throw 'textAngular Error: A toolbar requires a scope';
					if (!scope.name || scope.name === '') throw 'textAngular Error: A toolbar requires a name';
					if (toolbars[scope.name]) throw 'textAngular Error: A toolbar with name "' + scope.name + '" already exists';
					toolbars[scope.name] = scope;
					angular.forEach(editors, function (_editor) {
						_editor._registerToolbar(scope);
					});
				},
				// retrieve toolbar by name, largely used by testing suites only
				retrieveToolbar: function retrieveToolbar(name) {
					return toolbars[name];
				},
				// retrieve toolbars by editor name, largely used by testing suites only
				retrieveToolbarsViaEditor: function retrieveToolbarsViaEditor(name) {
					var result = [],
					    _this = this;
					angular.forEach(this.retrieveEditor(name).toolbars, function (name) {
						result.push(_this.retrieveToolbar(name));
					});
					return result;
				},
				unregisterToolbar: function unregisterToolbar(name) {
					delete toolbars[name];
				},
				// functions for updating the toolbar buttons display
				updateToolsDisplay: function updateToolsDisplay(newTaTools) {
					// pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
					var _this = this;
					angular.forEach(newTaTools, function (_newTool, key) {
						_this.updateToolDisplay(key, _newTool);
					});
				},
				// this function resets all toolbars to their default tool definitions
				resetToolsDisplay: function resetToolsDisplay() {
					var _this = this;
					angular.forEach(taTools, function (_newTool, key) {
						_this.resetToolDisplay(key);
					});
				},
				// update a tool on all toolbars
				updateToolDisplay: function updateToolDisplay(toolKey, _newTool) {
					var _this = this;
					angular.forEach(toolbars, function (toolbarScope, toolbarKey) {
						_this.updateToolbarToolDisplay(toolbarKey, toolKey, _newTool);
					});
				},
				// resets a tool to the default/starting state on all toolbars
				resetToolDisplay: function resetToolDisplay(toolKey) {
					var _this = this;
					angular.forEach(toolbars, function (toolbarScope, toolbarKey) {
						_this.resetToolbarToolDisplay(toolbarKey, toolKey);
					});
				},
				// update a tool on a specific toolbar
				updateToolbarToolDisplay: function updateToolbarToolDisplay(toolbarKey, toolKey, _newTool) {
					if (toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, _newTool);else throw 'textAngular Error: No Toolbar with name "' + toolbarKey + '" exists';
				},
				// reset a tool on a specific toolbar to it's default starting value
				resetToolbarToolDisplay: function resetToolbarToolDisplay(toolbarKey, toolKey) {
					if (toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, taTools[toolKey], true);else throw 'textAngular Error: No Toolbar with name "' + toolbarKey + '" exists';
				},
				// removes a tool from all toolbars and it's definition
				removeTool: function removeTool(toolKey) {
					delete taTools[toolKey];
					angular.forEach(toolbars, function (toolbarScope) {
						delete toolbarScope.tools[toolKey];
						for (var i = 0; i < toolbarScope.toolbar.length; i++) {
							var toolbarIndex;
							for (var j = 0; j < toolbarScope.toolbar[i].length; j++) {
								if (toolbarScope.toolbar[i][j] === toolKey) {
									toolbarIndex = {
										group: i,
										index: j
									};
									break;
								}
								if (toolbarIndex !== undefined) break;
							}
							if (toolbarIndex !== undefined) {
								toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index, 1);
								toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();
							}
						}
					});
				},
				// toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
				addTool: function addTool(toolKey, toolDefinition, group, index) {
					taRegisterTool(toolKey, toolDefinition);
					angular.forEach(toolbars, function (toolbarScope) {
						toolbarScope.addTool(toolKey, toolDefinition, group, index);
					});
				},
				// adds a Tool but only to one toolbar not all
				addToolToToolbar: function addToolToToolbar(toolKey, toolDefinition, toolbarKey, group, index) {
					taRegisterTool(toolKey, toolDefinition);
					toolbars[toolbarKey].addTool(toolKey, toolDefinition, group, index);
				},
				// this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
				// this will call a $digest if not already happening
				refreshEditor: function refreshEditor(name) {
					if (editors[name]) {
						editors[name].scope.updateTaBindtaTextElement();
						/* istanbul ignore else: phase catch */
						if (!editors[name].scope.$$phase) editors[name].scope.$digest();
					} else throw 'textAngular Error: No Editor with name "' + name + '" exists';
				},
				// this is used by taBind to send a key command in response to a special key event
				sendKeyCommand: function sendKeyCommand(scope, event) {
					angular.forEach(editors, function (_editor) {
						/* istanbul ignore else: if nothing to do, do nothing */
						if (_editor.editorFunctions.sendKeyCommand(event)) {
							/* istanbul ignore else: don't run if already running */
							if (!scope._bUpdateSelectedStyles) {
								scope.updateSelectedStyles();
							}
							event.preventDefault();
							return false;
						}
					});
				}
			};
		}]);
		textAngular.directive('textAngularToolbar', ['$compile', 'textAngularManager', 'taOptions', 'taTools', 'taToolExecuteAction', '$window', function ($compile, textAngularManager, taOptions, taTools, taToolExecuteAction, $window) {
			return {
				scope: {
					name: '@' // a name IS required
				},
				restrict: "EA",
				link: function link(scope, element, attrs) {
					if (!scope.name || scope.name === '') throw 'textAngular Error: A toolbar requires a name';
					angular.extend(scope, angular.copy(taOptions));
					if (attrs.taToolbar) scope.toolbar = scope.$parent.$eval(attrs.taToolbar);
					if (attrs.taToolbarClass) scope.classes.toolbar = attrs.taToolbarClass;
					if (attrs.taToolbarGroupClass) scope.classes.toolbarGroup = attrs.taToolbarGroupClass;
					if (attrs.taToolbarButtonClass) scope.classes.toolbarButton = attrs.taToolbarButtonClass;
					if (attrs.taToolbarActiveButtonClass) scope.classes.toolbarButtonActive = attrs.taToolbarActiveButtonClass;
					if (attrs.taFocussedClass) scope.classes.focussed = attrs.taFocussedClass;
	
					scope.disabled = true;
					scope.focussed = false;
					scope._$element = element;
					element[0].innerHTML = '';
					element.addClass("ta-toolbar " + scope.classes.toolbar);
	
					scope.$watch('focussed', function () {
						if (scope.focussed) element.addClass(scope.classes.focussed);else element.removeClass(scope.classes.focussed);
					});
	
					var setupToolElement = function setupToolElement(toolDefinition, toolScope) {
						var toolElement;
						if (toolDefinition && toolDefinition.display) {
							toolElement = angular.element(toolDefinition.display);
						} else toolElement = angular.element("<button type='button'>");
	
						if (toolDefinition && toolDefinition["class"]) toolElement.addClass(toolDefinition["class"]);else toolElement.addClass(scope.classes.toolbarButton);
	
						toolElement.attr('name', toolScope.name);
						// important to not take focus from the main text/html entry
						toolElement.attr('ta-button', 'ta-button');
						toolElement.attr('ng-disabled', 'isDisabled()');
						toolElement.attr('tabindex', '-1');
						toolElement.attr('ng-click', 'executeAction()');
						toolElement.attr('ng-class', 'displayActiveToolClass(active)');
	
						if (toolDefinition && toolDefinition.tooltiptext) {
							toolElement.attr('title', toolDefinition.tooltiptext);
						}
						if (toolDefinition && !toolDefinition.display && !toolScope._display) {
							// first clear out the current contents if any
							toolElement[0].innerHTML = '';
							// add the buttonText
							if (toolDefinition.buttontext) toolElement[0].innerHTML = toolDefinition.buttontext;
							// add the icon to the front of the button if there is content
							if (toolDefinition.iconclass) {
								var icon = angular.element('<i>'),
								    content = toolElement[0].innerHTML;
								icon.addClass(toolDefinition.iconclass);
								toolElement[0].innerHTML = '';
								toolElement.append(icon);
								if (content && content !== '') toolElement.append('&nbsp;' + content);
							}
						}
	
						toolScope._lastToolDefinition = angular.copy(toolDefinition);
	
						return $compile(toolElement)(toolScope);
					};
	
					// Keep a reference for updating the active states later
					scope.tools = {};
					// create the tools in the toolbar
					// default functions and values to prevent errors in testing and on init
					scope._parent = {
						disabled: true,
						showHtml: false,
						queryFormatBlockState: function queryFormatBlockState() {
							return false;
						},
						queryCommandState: function queryCommandState() {
							return false;
						}
					};
					var defaultChildScope = {
						$window: $window,
						$editor: function $editor() {
							// dynamically gets the editor as it is set
							return scope._parent;
						},
						isDisabled: function isDisabled() {
							// to set your own disabled logic set a function or boolean on the tool called 'disabled'
							return (// this bracket is important as without it it just returns the first bracket and ignores the rest
								// when the button's disabled function/value evaluates to true
								typeof this.$eval('disabled') !== 'function' && this.$eval('disabled') || this.$eval('disabled()') ||
								// all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
								this.name !== 'html' && this.$editor().showHtml ||
								// if the toolbar is disabled
								this.$parent.disabled ||
								// if the current editor is disabled
								this.$editor().disabled
							);
						},
						displayActiveToolClass: function displayActiveToolClass(active) {
							return active ? scope.classes.toolbarButtonActive : '';
						},
						executeAction: taToolExecuteAction
					};
	
					angular.forEach(scope.toolbar, function (group) {
						// setup the toolbar group
						var groupElement = angular.element("<div>");
						groupElement.addClass(scope.classes.toolbarGroup);
						angular.forEach(group, function (tool) {
							// init and add the tools to the group
							// a tool name (key name from taTools struct)
							//creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
							// reference to the scope and element kept
							scope.tools[tool] = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, { name: tool });
							scope.tools[tool].$element = setupToolElement(taTools[tool], scope.tools[tool]);
							// append the tool compiled with the childScope to the group element
							groupElement.append(scope.tools[tool].$element);
						});
						// append the group to the toolbar
						element.append(groupElement);
					});
	
					// update a tool
					// if a value is set to null, remove from the display
					// when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
					// to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
					scope.updateToolDisplay = function (key, _newTool, forceNew) {
						var toolInstance = scope.tools[key];
						if (toolInstance) {
							// get the last toolDefinition, then override with the new definition
							if (toolInstance._lastToolDefinition && !forceNew) _newTool = angular.extend({}, toolInstance._lastToolDefinition, _newTool);
							if (_newTool.buttontext === null && _newTool.iconclass === null && _newTool.display === null) throw 'textAngular Error: Tool Definition for updating "' + key + '" does not have a valid display/iconclass/buttontext value';
	
							// if tool is defined on this toolbar, update/redo the tool
							if (_newTool.buttontext === null) {
								delete _newTool.buttontext;
							}
							if (_newTool.iconclass === null) {
								delete _newTool.iconclass;
							}
							if (_newTool.display === null) {
								delete _newTool.display;
							}
	
							var toolElement = setupToolElement(_newTool, toolInstance);
							toolInstance.$element.replaceWith(toolElement);
							toolInstance.$element = toolElement;
						}
					};
	
					// we assume here that all values passed are valid and correct
					scope.addTool = function (key, _newTool, groupIndex, index) {
						scope.tools[key] = angular.extend(scope.$new(true), taTools[key], defaultChildScope, { name: key });
						scope.tools[key].$element = setupToolElement(taTools[key], scope.tools[key]);
						var group;
						if (groupIndex === undefined) groupIndex = scope.toolbar.length - 1;
						group = angular.element(element.children()[groupIndex]);
	
						if (index === undefined) {
							group.append(scope.tools[key].$element);
							scope.toolbar[groupIndex][scope.toolbar[groupIndex].length - 1] = key;
						} else {
							group.children().eq(index).after(scope.tools[key].$element);
							scope.toolbar[groupIndex][index] = key;
						}
					};
	
					textAngularManager.registerToolbar(scope);
	
					scope.$on('$destroy', function () {
						textAngularManager.unregisterToolbar(scope.name);
					});
				}
			};
		}]);
	})();

/***/ },
/* 391 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	@license textAngular
	Author : Austin Anderson
	License : 2013 MIT
	Version 1.3.7
	
	See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
	*/
	
	angular.module('textAngularSetup', [])
	// Here we set up the global display defaults, to set your own use a angular $provider#decorator.
	.value('taOptions', {
		//////////////////////////////////////////////////////////////////////////////////////
		// forceTextAngularSanitize
		// set false to allow the textAngular-sanitize provider to be replaced
		// with angular-sanitize or a custom provider.
		forceTextAngularSanitize: true,
		///////////////////////////////////////////////////////////////////////////////////////
		// keyMappings
		// allow customizable keyMappings for specialized key boards or languages
		//
		// keyMappings provides key mappings that are attached to a given commandKeyCode.
		// To modify a specific keyboard binding, simply provide function which returns true
		// for the event you wish to map to.
		// Or to disable a specific keyboard binding, provide a function which returns false.
		// Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
		// At present, the following commandKeyCodes are in use:
		// 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
		//
		// To map to an new commandKeyCode, add a new key mapping such as:
		// {commandKeyCode: 'CustomKey', testForKey: function (event) {
		//  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
		// } }
		// to the keyMappings. This example maps ctrl+9 to 'CustomKey'
		// Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
		// tool will be bound to ctrl+9.
		//
		// To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
		// {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
		// {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
		// to disable them.
		//
		keyMappings: [],
		toolbar: [['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'], ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'], ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'], ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']],
		classes: {
			focussed: "focussed",
			toolbar: "btn-toolbar",
			toolbarGroup: "btn-group",
			toolbarButton: "btn btn-default",
			toolbarButtonActive: "active",
			disabled: "disabled",
			textEditor: 'form-control',
			htmlEditor: 'form-control'
		},
		defaultTagAttributes: {
			a: { target: "" }
		},
		setup: {
			// wysiwyg mode
			textEditorSetup: function textEditorSetup($element) {/* Do some processing here */},
			// raw html
			htmlEditorSetup: function htmlEditorSetup($element) {/* Do some processing here */}
		},
		defaultFileDropHandler:
		/* istanbul ignore next: untestable image processing */
		function defaultFileDropHandler(file, insertAction) {
			var reader = new FileReader();
			if (file.type.substring(0, 5) === 'image') {
				reader.onload = function () {
					if (reader.result !== '') insertAction('insertImage', reader.result, true);
				};
	
				reader.readAsDataURL(file);
				// NOTE: For async procedures return a promise and resolve it when the editor should update the model.
				return true;
			}
			return false;
		}
	})
	
	// This is the element selector string that is used to catch click events within a taBind, prevents the default and $emits a 'ta-element-select' event
	// these are individually used in an angular.element().find() call. What can go here depends on whether you have full jQuery loaded or just jQLite with angularjs.
	// div is only used as div.ta-insert-video caught in filter.
	.value('taSelectableElements', ['a', 'img'])
	
	// This is an array of objects with the following options:
	//				selector: <string> a jqLite or jQuery selector string
	//				customAttribute: <string> an attribute to search for
	//				renderLogic: <function(element)>
	// Both or one of selector and customAttribute must be defined.
	.value('taCustomRenderers', [{
		// Parse back out: '<div class="ta-insert-video" ta-insert-video src="' + urlLink + '" allowfullscreen="true" width="300" frameborder="0" height="250"></div>'
		// To correct video element. For now only support youtube
		selector: 'img',
		customAttribute: 'ta-insert-video',
		renderLogic: function renderLogic(element) {
			var iframe = angular.element('<iframe></iframe>');
			var attributes = element.prop("attributes");
			// loop through element attributes and apply them on iframe
			angular.forEach(attributes, function (attr) {
				iframe.attr(attr.name, attr.value);
			});
			iframe.attr('src', iframe.attr('ta-insert-video'));
			element.replaceWith(iframe);
		}
	}]).value('taTranslations', {
		// moved to sub-elements
		//toggleHTML: "Toggle HTML",
		//insertImage: "Please enter a image URL to insert",
		//insertLink: "Please enter a URL to insert",
		//insertVideo: "Please enter a youtube URL to embed",
		html: {
			tooltip: 'Toggle html / Rich Text'
		},
		// tooltip for heading - might be worth splitting
		heading: {
			tooltip: 'Heading '
		},
		p: {
			tooltip: 'Paragraph'
		},
		pre: {
			tooltip: 'Preformatted text'
		},
		ul: {
			tooltip: 'Unordered List'
		},
		ol: {
			tooltip: 'Ordered List'
		},
		quote: {
			tooltip: 'Quote/unquote selection or paragraph'
		},
		undo: {
			tooltip: 'Undo'
		},
		redo: {
			tooltip: 'Redo'
		},
		bold: {
			tooltip: 'Bold'
		},
		italic: {
			tooltip: 'Italic'
		},
		underline: {
			tooltip: 'Underline'
		},
		strikeThrough: {
			tooltip: 'Strikethrough'
		},
		justifyLeft: {
			tooltip: 'Align text left'
		},
		justifyRight: {
			tooltip: 'Align text right'
		},
		justifyFull: {
			tooltip: 'Justify text'
		},
		justifyCenter: {
			tooltip: 'Center'
		},
		indent: {
			tooltip: 'Increase indent'
		},
		outdent: {
			tooltip: 'Decrease indent'
		},
		clear: {
			tooltip: 'Clear formatting'
		},
		insertImage: {
			dialogPrompt: 'Please enter an image URL to insert',
			tooltip: 'Insert image',
			hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
		},
		insertVideo: {
			tooltip: 'Insert video',
			dialogPrompt: 'Please enter a youtube URL to embed'
		},
		insertLink: {
			tooltip: 'Insert / edit link',
			dialogPrompt: "Please enter a URL to insert"
		},
		editLink: {
			reLinkButton: {
				tooltip: "Relink"
			},
			unLinkButton: {
				tooltip: "Unlink"
			},
			targetToggle: {
				buttontext: "Open in New Window"
			}
		},
		wordcount: {
			tooltip: 'Display words Count'
		},
		charcount: {
			tooltip: 'Display characters Count'
		}
	}).factory('taToolFunctions', ['$window', 'taTranslations', function ($window, taTranslations) {
		return {
			imgOnSelectAction: function imgOnSelectAction(event, $element, editorScope) {
				// setup the editor toolbar
				// Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
				var finishEdit = function finishEdit() {
					editorScope.updateTaBindtaTextElement();
					editorScope.hidePopover();
				};
				event.preventDefault();
				editorScope.displayElements.popover.css('width', '375px');
				var container = editorScope.displayElements.popoverContainer;
				container.empty();
				var buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
				var fullButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');
				fullButton.on('click', function (event) {
					event.preventDefault();
					$element.css({
						'width': '100%',
						'height': ''
					});
					finishEdit();
				});
				var halfButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');
				halfButton.on('click', function (event) {
					event.preventDefault();
					$element.css({
						'width': '50%',
						'height': ''
					});
					finishEdit();
				});
				var quartButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');
				quartButton.on('click', function (event) {
					event.preventDefault();
					$element.css({
						'width': '25%',
						'height': ''
					});
					finishEdit();
				});
				var resetButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');
				resetButton.on('click', function (event) {
					event.preventDefault();
					$element.css({
						width: '',
						height: ''
					});
					finishEdit();
				});
				buttonGroup.append(fullButton);
				buttonGroup.append(halfButton);
				buttonGroup.append(quartButton);
				buttonGroup.append(resetButton);
				container.append(buttonGroup);
	
				buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
				var floatLeft = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');
				floatLeft.on('click', function (event) {
					event.preventDefault();
					// webkit
					$element.css('float', 'left');
					// firefox
					$element.css('cssFloat', 'left');
					// IE < 8
					$element.css('styleFloat', 'left');
					finishEdit();
				});
				var floatRight = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');
				floatRight.on('click', function (event) {
					event.preventDefault();
					// webkit
					$element.css('float', 'right');
					// firefox
					$element.css('cssFloat', 'right');
					// IE < 8
					$element.css('styleFloat', 'right');
					finishEdit();
				});
				var floatNone = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');
				floatNone.on('click', function (event) {
					event.preventDefault();
					// webkit
					$element.css('float', '');
					// firefox
					$element.css('cssFloat', '');
					// IE < 8
					$element.css('styleFloat', '');
					finishEdit();
				});
				buttonGroup.append(floatLeft);
				buttonGroup.append(floatNone);
				buttonGroup.append(floatRight);
				container.append(buttonGroup);
	
				buttonGroup = angular.element('<div class="btn-group">');
				var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
				remove.on('click', function (event) {
					event.preventDefault();
					$element.remove();
					finishEdit();
				});
				buttonGroup.append(remove);
				container.append(buttonGroup);
	
				editorScope.showPopover($element);
				editorScope.showResizeOverlay($element);
			},
			aOnSelectAction: function aOnSelectAction(event, $element, editorScope) {
				// setup the editor toolbar
				// Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
				event.preventDefault();
				editorScope.displayElements.popover.css('width', '436px');
				var container = editorScope.displayElements.popoverContainer;
				container.empty();
				container.css('line-height', '28px');
				var link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
				link.css({
					'display': 'inline-block',
					'max-width': '200px',
					'overflow': 'hidden',
					'text-overflow': 'ellipsis',
					'white-space': 'nowrap',
					'vertical-align': 'middle'
				});
				container.append(link);
				var buttonGroup = angular.element('<div class="btn-group pull-right">');
				var reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
				reLinkButton.on('click', function (event) {
					event.preventDefault();
					var urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
					if (urlLink && urlLink !== '' && urlLink !== 'http://') {
						$element.attr('href', urlLink);
						editorScope.updateTaBindtaTextElement();
					}
					editorScope.hidePopover();
				});
				buttonGroup.append(reLinkButton);
				var unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
				// directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
				unLinkButton.on('click', function (event) {
					event.preventDefault();
					$element.replaceWith($element.contents());
					editorScope.updateTaBindtaTextElement();
					editorScope.hidePopover();
				});
				buttonGroup.append(unLinkButton);
				var targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
				if ($element.attr('target') === '_blank') {
					targetToggle.addClass('active');
				}
				targetToggle.on('click', function (event) {
					event.preventDefault();
					$element.attr('target', $element.attr('target') === '_blank' ? '' : '_blank');
					targetToggle.toggleClass('active');
					editorScope.updateTaBindtaTextElement();
				});
				buttonGroup.append(targetToggle);
				container.append(buttonGroup);
				editorScope.showPopover($element);
			},
			extractYoutubeVideoId: function extractYoutubeVideoId(url) {
				var re = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
				var match = url.match(re);
				return match && match[1] || null;
			}
		};
	}]).run(['taRegisterTool', '$window', 'taTranslations', 'taSelection', 'taToolFunctions', '$sanitize', 'taOptions', function (taRegisterTool, $window, taTranslations, taSelection, taToolFunctions, $sanitize, taOptions) {
		// test for the version of $sanitize that is in use
		// You can disable this check by setting taOptions.textAngularSanitize == false
		var gv = {};$sanitize('', gv);
		/* istanbul ignore next, throws error */
		if (taOptions.forceTextAngularSanitize === true && gv.version !== 'taSanitize') {
			throw angular.$$minErr('textAngular')("textAngularSetup", "The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");
		}
		taRegisterTool("html", {
			iconclass: 'fa fa-code',
			tooltiptext: taTranslations.html.tooltip,
			action: function action() {
				this.$editor().switchView();
			},
			activeState: function activeState() {
				return this.$editor().showHtml;
			}
		});
		// add the Header tools
		// convenience functions so that the loop works correctly
		var _retActiveStateFunction = function _retActiveStateFunction(q) {
			return function () {
				return this.$editor().queryFormatBlockState(q);
			};
		};
		var headerAction = function headerAction() {
			return this.$editor().wrapSelection("formatBlock", "<" + this.name.toUpperCase() + ">");
		};
		angular.forEach(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'], function (h) {
			taRegisterTool(h.toLowerCase(), {
				buttontext: h.toUpperCase(),
				tooltiptext: taTranslations.heading.tooltip + h.charAt(1),
				action: headerAction,
				activeState: _retActiveStateFunction(h.toLowerCase())
			});
		});
		taRegisterTool('p', {
			buttontext: 'P',
			tooltiptext: taTranslations.p.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("formatBlock", "<P>");
			},
			activeState: function activeState() {
				return this.$editor().queryFormatBlockState('p');
			}
		});
		// key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
		taRegisterTool('pre', {
			buttontext: 'pre',
			tooltiptext: taTranslations.pre.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("formatBlock", "<PRE>");
			},
			activeState: function activeState() {
				return this.$editor().queryFormatBlockState('pre');
			}
		});
		taRegisterTool('ul', {
			iconclass: 'fa fa-list-ul',
			tooltiptext: taTranslations.ul.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("insertUnorderedList", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('insertUnorderedList');
			}
		});
		taRegisterTool('ol', {
			iconclass: 'fa fa-list-ol',
			tooltiptext: taTranslations.ol.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("insertOrderedList", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('insertOrderedList');
			}
		});
		taRegisterTool('quote', {
			iconclass: 'fa fa-quote-right',
			tooltiptext: taTranslations.quote.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("formatBlock", "<BLOCKQUOTE>");
			},
			activeState: function activeState() {
				return this.$editor().queryFormatBlockState('blockquote');
			}
		});
		taRegisterTool('undo', {
			iconclass: 'fa fa-undo',
			tooltiptext: taTranslations.undo.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("undo", null);
			}
		});
		taRegisterTool('redo', {
			iconclass: 'fa fa-repeat',
			tooltiptext: taTranslations.redo.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("redo", null);
			}
		});
		taRegisterTool('bold', {
			iconclass: 'fa fa-bold',
			tooltiptext: taTranslations.bold.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("bold", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('bold');
			},
			commandKeyCode: 98
		});
		taRegisterTool('justifyLeft', {
			iconclass: 'fa fa-align-left',
			tooltiptext: taTranslations.justifyLeft.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("justifyLeft", null);
			},
			activeState: function activeState(commonElement) {
				/* istanbul ignore next: */
				if (commonElement && commonElement.nodeName === '#document') return false;
				var result = false;
				if (commonElement) result = commonElement.css('text-align') === 'left' || commonElement.attr('align') === 'left' || commonElement.css('text-align') !== 'right' && commonElement.css('text-align') !== 'center' && commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter') && !this.$editor().queryCommandState('justifyFull');
				result = result || this.$editor().queryCommandState('justifyLeft');
				return result;
			}
		});
		taRegisterTool('justifyRight', {
			iconclass: 'fa fa-align-right',
			tooltiptext: taTranslations.justifyRight.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("justifyRight", null);
			},
			activeState: function activeState(commonElement) {
				/* istanbul ignore next: */
				if (commonElement && commonElement.nodeName === '#document') return false;
				var result = false;
				if (commonElement) result = commonElement.css('text-align') === 'right';
				result = result || this.$editor().queryCommandState('justifyRight');
				return result;
			}
		});
		taRegisterTool('justifyFull', {
			iconclass: 'fa fa-align-justify',
			tooltiptext: taTranslations.justifyFull.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("justifyFull", null);
			},
			activeState: function activeState(commonElement) {
				var result = false;
				if (commonElement) result = commonElement.css('text-align') === 'justify';
				result = result || this.$editor().queryCommandState('justifyFull');
				return result;
			}
		});
		taRegisterTool('justifyCenter', {
			iconclass: 'fa fa-align-center',
			tooltiptext: taTranslations.justifyCenter.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("justifyCenter", null);
			},
			activeState: function activeState(commonElement) {
				/* istanbul ignore next: */
				if (commonElement && commonElement.nodeName === '#document') return false;
				var result = false;
				if (commonElement) result = commonElement.css('text-align') === 'center';
				result = result || this.$editor().queryCommandState('justifyCenter');
				return result;
			}
		});
		taRegisterTool('indent', {
			iconclass: 'fa fa-indent',
			tooltiptext: taTranslations.indent.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("indent", null);
			},
			activeState: function activeState() {
				return this.$editor().queryFormatBlockState('blockquote');
			},
			commandKeyCode: 'TabKey'
		});
		taRegisterTool('outdent', {
			iconclass: 'fa fa-outdent',
			tooltiptext: taTranslations.outdent.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("outdent", null);
			},
			activeState: function activeState() {
				return false;
			},
			commandKeyCode: 'ShiftTabKey'
		});
		taRegisterTool('italics', {
			iconclass: 'fa fa-italic',
			tooltiptext: taTranslations.italic.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("italic", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('italic');
			},
			commandKeyCode: 105
		});
		taRegisterTool('underline', {
			iconclass: 'fa fa-underline',
			tooltiptext: taTranslations.underline.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("underline", null);
			},
			activeState: function activeState() {
				return this.$editor().queryCommandState('underline');
			},
			commandKeyCode: 117
		});
		taRegisterTool('strikeThrough', {
			iconclass: 'fa fa-strikethrough',
			tooltiptext: taTranslations.strikeThrough.tooltip,
			action: function action() {
				return this.$editor().wrapSelection("strikeThrough", null);
			},
			activeState: function activeState() {
				return document.queryCommandState('strikeThrough');
			}
		});
		taRegisterTool('clear', {
			iconclass: 'fa fa-ban',
			tooltiptext: taTranslations.clear.tooltip,
			action: function action(deferred, restoreSelection) {
				var i;
				this.$editor().wrapSelection("removeFormat", null);
				var possibleNodes = angular.element(taSelection.getSelectionElement());
				// remove lists
				var removeListElements = function removeListElements(list) {
					list = angular.element(list);
					var prevElement = list;
					angular.forEach(list.children(), function (liElem) {
						var newElem = angular.element('<p></p>');
						newElem.html(angular.element(liElem).html());
						prevElement.after(newElem);
						prevElement = newElem;
					});
					list.remove();
				};
				angular.forEach(possibleNodes.find("ul"), removeListElements);
				angular.forEach(possibleNodes.find("ol"), removeListElements);
				if (possibleNodes[0].tagName.toLowerCase() === 'li') {
					var _list = possibleNodes[0].parentNode.childNodes;
					var _preLis = [],
					    _postLis = [],
					    _found = false;
					for (i = 0; i < _list.length; i++) {
						if (_list[i] === possibleNodes[0]) {
							_found = true;
						} else if (!_found) _preLis.push(_list[i]);else _postLis.push(_list[i]);
					}
					var _parent = angular.element(possibleNodes[0].parentNode);
					var newElem = angular.element('<p></p>');
					newElem.html(angular.element(possibleNodes[0]).html());
					if (_preLis.length === 0 || _postLis.length === 0) {
						if (_postLis.length === 0) _parent.after(newElem);else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
						if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();else angular.element(possibleNodes[0]).remove();
					} else {
						var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
						var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
						for (i = 0; i < _preLis.length; i++) {
							_firstList.append(angular.element(_preLis[i]));
						}for (i = 0; i < _postLis.length; i++) {
							_secondList.append(angular.element(_postLis[i]));
						}_parent.after(_secondList);
						_parent.after(newElem);
						_parent.after(_firstList);
						_parent.remove();
					}
					taSelection.setSelectionToElementEnd(newElem[0]);
				}
				// clear out all class attributes. These do not seem to be cleared via removeFormat
				var $editor = this.$editor();
				var recursiveRemoveClass = function recursiveRemoveClass(node) {
					node = angular.element(node);
					if (node[0] !== $editor.displayElements.text[0]) node.removeAttr('class');
					angular.forEach(node.children(), recursiveRemoveClass);
				};
				angular.forEach(possibleNodes, recursiveRemoveClass);
				// check if in list. If not in list then use formatBlock option
				if (possibleNodes[0].tagName.toLowerCase() !== 'li' && possibleNodes[0].tagName.toLowerCase() !== 'ol' && possibleNodes[0].tagName.toLowerCase() !== 'ul') this.$editor().wrapSelection("formatBlock", "default");
				restoreSelection();
			}
		});
	
		taRegisterTool('insertImage', {
			iconclass: 'fa fa-picture-o',
			tooltiptext: taTranslations.insertImage.tooltip,
			action: function action() {
				var imageLink;
				imageLink = $window.prompt(taTranslations.insertImage.dialogPrompt, 'http://');
				if (imageLink && imageLink !== '' && imageLink !== 'http://') {
					return this.$editor().wrapSelection('insertImage', imageLink, true);
				}
			},
			onElementSelect: {
				element: 'img',
				action: taToolFunctions.imgOnSelectAction
			}
		});
		taRegisterTool('insertVideo', {
			iconclass: 'fa fa-youtube-play',
			tooltiptext: taTranslations.insertVideo.tooltip,
			action: function action() {
				var urlPrompt;
				urlPrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, 'https://');
				if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {
	
					videoId = taToolFunctions.extractYoutubeVideoId(urlPrompt);
	
					/* istanbul ignore else: if it's invalid don't worry - though probably should show some kind of error message */
					if (videoId) {
						// create the embed link
						var urlLink = "https://www.youtube.com/embed/" + videoId;
						// create the HTML
						// for all options see: http://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
						// maxresdefault.jpg seems to be undefined on some.
						var embed = '<img class="ta-insert-video" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" ta-insert-video="' + urlLink + '" contenteditable="false" allowfullscreen="true" frameborder="0" />';
						// insert
						return this.$editor().wrapSelection('insertHTML', embed, true);
					}
				}
			},
			onElementSelect: {
				element: 'img',
				onlyWithAttrs: ['ta-insert-video'],
				action: taToolFunctions.imgOnSelectAction
			}
		});
		taRegisterTool('insertLink', {
			tooltiptext: taTranslations.insertLink.tooltip,
			iconclass: 'fa fa-link',
			action: function action() {
				var urlLink;
				urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'http://');
				if (urlLink && urlLink !== '' && urlLink !== 'http://') {
					return this.$editor().wrapSelection('createLink', urlLink, true);
				}
			},
			activeState: function activeState(commonElement) {
				if (commonElement) return commonElement[0].tagName === 'A';
				return false;
			},
			onElementSelect: {
				element: 'a',
				action: taToolFunctions.aOnSelectAction
			}
		});
		taRegisterTool('wordcount', {
			display: '<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',
			disabled: true,
			wordcount: 0,
			activeState: function activeState() {
				// this fires on keyup
				var textElement = this.$editor().displayElements.text;
				/* istanbul ignore next: will default to '' when undefined */
				var workingHTML = textElement[0].innerHTML || '';
				var noOfWords = 0;
	
				/* istanbul ignore if: will default to '' when undefined */
				if (workingHTML.replace(/\s*<[^>]*?>\s*/g, '') !== '') {
					noOfWords = workingHTML.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '') // remove inline tags without adding spaces
					.replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ') // replace adjacent tags with possible space between with a space
					.replace(/(<[^>]*?>)/ig, '') // remove any singular tags
					.replace(/\s+/ig, ' ') // condense spacing
					.match(/\S+/g).length; // count remaining non-space strings
				}
	
				//Set current scope
				this.wordcount = noOfWords;
				//Set editor scope
				this.$editor().wordcount = noOfWords;
	
				return false;
			}
		});
		taRegisterTool('charcount', {
			display: '<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',
			disabled: true,
			charcount: 0,
			activeState: function activeState() {
				// this fires on keyup
				var textElement = this.$editor().displayElements.text;
				var sourceText = textElement[0].innerText || textElement[0].textContent; // to cover the non-jquery use case.
	
				// Caculate number of chars
				var noOfChars = sourceText.replace(/(\r\n|\n|\r)/gm, "").replace(/^\s+/g, ' ').replace(/\s+$/g, ' ').length;
				//Set current scope
				this.charcount = noOfChars;
				//Set editor scope
				this.$editor().charcount = noOfChars;
				return false;
			}
		});
	}]);

/***/ },
/* 392 */
/***/ function(module, exports) {

	"use strict";
	
	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.18.1 - 2016-07-10T00:30:49.391Z
	 * License: MIT
	 */
	
	(function () {
	  "use strict";
	
	  var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91: "COMMAND", 8: "BACKSPACE", 9: "TAB", 13: "ENTER", 16: "SHIFT", 17: "CTRL", 18: "ALT", 19: "PAUSEBREAK", 20: "CAPSLOCK", 27: "ESC", 32: "SPACE", 33: "PAGE_UP", 34: "PAGE_DOWN", 35: "END", 36: "HOME", 37: "LEFT", 38: "UP", 39: "RIGHT", 40: "DOWN", 43: "+", 44: "PRINTSCREEN", 45: "INSERT", 46: "DELETE", 48: "0", 49: "1", 50: "2", 51: "3", 52: "4", 53: "5", 54: "6", 55: "7", 56: "8", 57: "9", 59: ";", 61: "=", 65: "A", 66: "B", 67: "C", 68: "D", 69: "E", 70: "F", 71: "G", 72: "H", 73: "I", 74: "J", 75: "K", 76: "L", 77: "M", 78: "N", 79: "O", 80: "P", 81: "Q", 82: "R", 83: "S", 84: "T", 85: "U", 86: "V", 87: "W", 88: "X", 89: "Y", 90: "Z", 96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7", 104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111: "/", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NUMLOCK", 145: "SCROLLLOCK", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'"
	    },
	
	    isControl: function isControl(e) {
	      var k = e.which;
	      switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	          return true;
	      }
	
	      if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	      return false;
	    },
	    isFunctionKey: function isFunctionKey(k) {
	      k = k.which ? k.which : k;
	      return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function isVerticalMovement(k) {
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function isHorizontalMovement(k) {
	      return ~[KEY.LEFT, KEY.RIGHT, KEY.BACKSPACE, KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function toSeparator(k) {
	      var sep = { ENTER: "\n", TAB: "\t", SPACE: " " }[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	  /**
	   * Add querySelectorAll() to jqLite.
	   *
	   * jqLite find() is limited to lookups by tag name.
	   * TODO This will change with future versions of AngularJS, to be removed when this happens
	   *
	   * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	   * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	   */
	  if (angular.element.prototype.querySelectorAll === undefined) {
	    angular.element.prototype.querySelectorAll = function (selector) {
	      return angular.element(this[0].querySelectorAll(selector));
	    };
	  }
	
	  /**
	   * Add closest() to jqLite.
	   */
	  if (angular.element.prototype.closest === undefined) {
	    angular.element.prototype.closest = function (selector) {
	      var elem = this[0];
	      var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	      while (elem) {
	        if (matchesSelector.bind(elem)(selector)) {
	          return elem;
	        } else {
	          elem = elem.parentElement;
	        }
	      }
	      return false;
	    };
	  }
	
	  var latestId = 0;
	
	  var uis = angular.module('ui.select', []).constant('uiSelectConfig', {
	    theme: 'bootstrap',
	    searchEnabled: true,
	    sortable: false,
	    placeholder: '', // Empty by default, like HTML tag <select>
	    refreshDelay: 1000, // In milliseconds
	    closeOnSelect: true,
	    skipFocusser: false,
	    dropdownPosition: 'auto',
	    removeSelected: true,
	    generateId: function generateId() {
	      return latestId++;
	    },
	    appendToBody: false
	  })
	
	  // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	  .service('uiSelectMinErr', function () {
	    var minErr = angular.$$minErr('ui.select');
	    return function () {
	      var error = minErr.apply(this, arguments);
	      var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	      return new Error(message);
	    };
	  })
	
	  // Recreates old behavior of ng-transclude. Used internally.
	  .directive('uisTranscludeAppend', function () {
	    return {
	      link: function link(scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	  })
	
	  /**
	   * Highlights text that matches $select.search.
	   *
	   * Taken from AngularUI Bootstrap Typeahead
	   * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	   */
	  .filter('highlight', function () {
	    function escapeRegexp(queryToEscape) {
	      return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    return function (matchItem, query) {
	      return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	    };
	  })
	
	  /**
	   * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	   *
	   * Taken from AngularUI Bootstrap Position:
	   * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	   */
	  .factory('uisOffset', ['$document', '$window', function ($document, $window) {
	
	    return function (element) {
	      var boundingClientRect = element[0].getBoundingClientRect();
	      return {
	        width: boundingClientRect.width || element.prop('offsetWidth'),
	        height: boundingClientRect.height || element.prop('offsetHeight'),
	        top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	        left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	      };
	    };
	  }]);
	
	  uis.directive('uiSelectChoices', ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window', function (uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-choices');
	
	        // Gets theme attribute from parent (ui-select)
	        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	        return theme + '/choices.tpl.html';
	      },
	
	      compile: function compile(tElement, tAttrs) {
	
	        if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	        // var repeat = RepeatParser.parse(attrs.repeat);
	        var groupByExp = tAttrs.groupBy;
	        var groupFilterExp = tAttrs.groupFilter;
	
	        if (groupByExp) {
	          var groups = tElement.querySelectorAll('.ui-select-choices-group');
	          if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	          groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	        }
	
	        var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	        var choices = tElement.querySelectorAll('.ui-select-choices-row');
	        if (choices.length !== 1) {
	          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	        }
	
	        choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp)).attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	        var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	        if (rowsInner.length !== 1) {
	          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	        }
	        rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	        // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event. 
	        var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	        clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	        return function link(scope, element, attrs, $select) {
	
	          $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	
	          $select.disableChoiceExpression = attrs.uiDisableChoice;
	          $select.onHighlightCallback = attrs.onHighlight;
	
	          $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	          scope.$on('$destroy', function () {
	            choices.remove();
	          });
	
	          scope.$watch('$select.search', function (newValue) {
	            if (newValue && !$select.open && $select.multiple) $select.activate(false, true);
	            $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	            if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	              $select.refresh(attrs.refresh);
	            } else {
	              $select.items = [];
	            }
	          });
	
	          attrs.$observe('refreshDelay', function () {
	            // $eval() is needed otherwise we get a string instead of a number
	            var refreshDelay = scope.$eval(attrs.refreshDelay);
	            $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	          });
	        };
	      }
	    };
	  }]);
	
	  /**
	   * Contains ui-select "intelligence".
	   *
	   * The goal is to limit dependency on the DOM whenever possible and
	   * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	   */
	  uis.controller('uiSelectCtrl', ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window', function ($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	    var ctrl = this;
	
	    var EMPTY_SEARCH = '';
	
	    ctrl.placeholder = uiSelectConfig.placeholder;
	    ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	    ctrl.sortable = uiSelectConfig.sortable;
	    ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	    ctrl.paste = uiSelectConfig.paste;
	
	    ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	    ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	    ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	    ctrl.search = EMPTY_SEARCH;
	
	    ctrl.activeIndex = 0; //Dropdown of choices
	    ctrl.items = []; //All available choices
	
	    ctrl.open = false;
	    ctrl.focus = false;
	    ctrl.disabled = false;
	    ctrl.selected = undefined;
	
	    ctrl.dropdownPosition = 'auto';
	
	    ctrl.focusser = undefined; //Reference to input element used to handle focus events
	    ctrl.resetSearchInput = true;
	    ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	    ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	    ctrl.tagging = { isActivated: false, fct: undefined };
	    ctrl.taggingTokens = { isActivated: false, tokens: undefined };
	    ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	    ctrl.clickTriggeredSelect = false;
	    ctrl.$filter = $filter;
	    ctrl.$element = $element;
	
	    // Use $injector to check for $animate and store a reference to it
	    ctrl.$animate = function () {
	      try {
	        return $injector.get('$animate');
	      } catch (err) {
	        // $animate does not exist
	        return null;
	      }
	    }();
	
	    ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	    if (ctrl.searchInput.length !== 1) {
	      throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	    }
	
	    ctrl.isEmpty = function () {
	      return angular.isUndefined(ctrl.selected) || ctrl.selected === null || ctrl.selected === '' || ctrl.multiple && ctrl.selected.length === 0;
	    };
	
	    function _findIndex(collection, predicate, thisArg) {
	      if (collection.findIndex) {
	        return collection.findIndex(predicate, thisArg);
	      } else {
	        var list = Object(collection);
	        var length = list.length >>> 0;
	        var value;
	
	        for (var i = 0; i < length; i++) {
	          value = list[i];
	          if (predicate.call(thisArg, value, i, list)) {
	            return i;
	          }
	        }
	        return -1;
	      }
	    }
	
	    // Most of the time the user does not want to empty the search input when in typeahead mode
	    function _resetSearchInput() {
	      if (ctrl.resetSearchInput || ctrl.resetSearchInput === undefined && uiSelectConfig.resetSearchInput) {
	        ctrl.search = EMPTY_SEARCH;
	        //reset activeIndex
	        if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	          ctrl.activeIndex = _findIndex(ctrl.items, function (item) {
	            return angular.equals(this, item);
	          }, ctrl.selected);
	        }
	      }
	    }
	
	    function _groupsFilter(groups, groupNames) {
	      var i,
	          j,
	          result = [];
	      for (i = 0; i < groupNames.length; i++) {
	        for (j = 0; j < groups.length; j++) {
	          if (groups[j].name == [groupNames[i]]) {
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	    // When the user clicks on ui-select, displays the dropdown list
	    ctrl.activate = function (initSearchValue, avoidReset) {
	      if (!ctrl.disabled && !ctrl.open) {
	        if (!avoidReset) _resetSearchInput();
	
	        $scope.$broadcast('uis:activate');
	
	        ctrl.open = true;
	
	        ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	
	        // ensure that the index is set to zero for tagging variants
	        // that where first option is auto-selected
	        if (ctrl.activeIndex === -1 && ctrl.taggingLabel !== false) {
	          ctrl.activeIndex = 0;
	        }
	
	        var container = $element.querySelectorAll('.ui-select-choices-content');
	        var searchInput = $element.querySelectorAll('.ui-select-search');
	        if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	          var animateHandler = function animateHandler(elem, phase) {
	            if (phase === 'start' && ctrl.items.length === 0) {
	              // Only focus input after the animation has finished
	              ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	              $timeout(function () {
	                ctrl.focusSearchInput(initSearchValue);
	              });
	            } else if (phase === 'close') {
	              // Only focus input after the animation has finished
	              ctrl.$animate.off('enter', container[0], animateHandler);
	              $timeout(function () {
	                ctrl.focusSearchInput(initSearchValue);
	              });
	            }
	          };
	
	          if (ctrl.items.length > 0) {
	            ctrl.$animate.on('enter', container[0], animateHandler);
	          } else {
	            ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	          }
	        } else {
	          $timeout(function () {
	            ctrl.focusSearchInput(initSearchValue);
	            if (!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	              _ensureHighlightVisible();
	            }
	          });
	        }
	      }
	    };
	
	    ctrl.focusSearchInput = function (initSearchValue) {
	      ctrl.search = initSearchValue || ctrl.search;
	      ctrl.searchInput[0].focus();
	    };
	
	    ctrl.findGroupByName = function (name) {
	      return ctrl.groups && ctrl.groups.filter(function (group) {
	        return group.name === name;
	      })[0];
	    };
	
	    ctrl.parseRepeatAttr = function (repeatAttr, groupByExp, groupFilterExp) {
	      function updateGroups(items) {
	        var groupFn = $scope.$eval(groupByExp);
	        ctrl.groups = [];
	        angular.forEach(items, function (item) {
	          var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	          var group = ctrl.findGroupByName(groupName);
	          if (group) {
	            group.items.push(item);
	          } else {
	            ctrl.groups.push({ name: groupName, items: [item] });
	          }
	        });
	        if (groupFilterExp) {
	          var groupFilterFn = $scope.$eval(groupFilterExp);
	          if (angular.isFunction(groupFilterFn)) {
	            ctrl.groups = groupFilterFn(ctrl.groups);
	          } else if (angular.isArray(groupFilterFn)) {
	            ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	          }
	        }
	        ctrl.items = [];
	        ctrl.groups.forEach(function (group) {
	          ctrl.items = ctrl.items.concat(group.items);
	        });
	      }
	
	      function setPlainItems(items) {
	        ctrl.items = items;
	      }
	
	      ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	      ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	      ctrl.isGrouped = !!groupByExp;
	      ctrl.itemProperty = ctrl.parserResult.itemName;
	
	      //If collection is an Object, convert it to Array
	
	      var originalSource = ctrl.parserResult.source;
	
	      //When an object is used as source, we better create an array and use it as 'source'
	      var createArrayFromObject = function createArrayFromObject() {
	        var origSrc = originalSource($scope);
	        $scope.$uisSource = Object.keys(origSrc).map(function (v) {
	          var result = {};
	          result[ctrl.parserResult.keyName] = v;
	          result.value = origSrc[v];
	          return result;
	        });
	      };
	
	      if (ctrl.parserResult.keyName) {
	        // Check for (key,value) syntax
	        createArrayFromObject();
	        ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	        $scope.$watch(originalSource, function (newVal, oldVal) {
	          if (newVal !== oldVal) createArrayFromObject();
	        }, true);
	      }
	
	      ctrl.refreshItems = function (data) {
	        data = data || ctrl.parserResult.source($scope);
	        var selectedItems = ctrl.selected;
	        //TODO should implement for single mode removeSelected
	        if (ctrl.isEmpty() || angular.isArray(selectedItems) && !selectedItems.length || !ctrl.multiple || !ctrl.removeSelected) {
	          ctrl.setItemsFn(data);
	        } else {
	          if (data !== undefined && data !== null) {
	            var filteredItems = data.filter(function (i) {
	              return angular.isArray(selectedItems) ? selectedItems.every(function (selectedItem) {
	                return !angular.equals(i, selectedItem);
	              }) : !angular.equals(i, selectedItems);
	            });
	            ctrl.setItemsFn(filteredItems);
	          }
	        }
	        if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up') {
	          $scope.calculateDropdownPos();
	        }
	
	        $scope.$broadcast('uis:refresh');
	      };
	
	      // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	      $scope.$watchCollection(ctrl.parserResult.source, function (items) {
	        if (items === undefined || items === null) {
	          // If the user specifies undefined or null => reset the collection
	          // Special case: items can be undefined if the user did not initialized the collection on the scope
	          // i.e $scope.addresses = [] is missing
	          ctrl.items = [];
	        } else {
	          if (!angular.isArray(items)) {
	            throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	          } else {
	            //Remove already selected items (ex: while searching)
	            //TODO Should add a test
	            ctrl.refreshItems(items);
	
	            //update the view value with fresh data from items, if there is a valid model value
	            if (angular.isDefined(ctrl.ngModel.$modelValue)) {
	              ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	            }
	          }
	        }
	      });
	    };
	
	    var _refreshDelayPromise;
	
	    /**
	     * Typeahead mode: lets the user refresh the collection using his own function.
	     *
	     * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	     */
	    ctrl.refresh = function (refreshAttr) {
	      if (refreshAttr !== undefined) {
	
	        // Debounce
	        // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	        // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	        if (_refreshDelayPromise) {
	          $timeout.cancel(_refreshDelayPromise);
	        }
	        _refreshDelayPromise = $timeout(function () {
	          $scope.$eval(refreshAttr);
	        }, ctrl.refreshDelay);
	      }
	    };
	
	    ctrl.isActive = function (itemScope) {
	      if (!ctrl.open) {
	        return false;
	      }
	      var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	      var isActive = itemIndex == ctrl.activeIndex;
	
	      if (!isActive || itemIndex < 0) {
	        return false;
	      }
	
	      if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	        itemScope.$eval(ctrl.onHighlightCallback);
	      }
	
	      return isActive;
	    };
	
	    var _isItemSelected = function _isItemSelected(item) {
	      return ctrl.selected && angular.isArray(ctrl.selected) && ctrl.selected.filter(function (selection) {
	        return angular.equals(selection, item);
	      }).length > 0;
	    };
	
	    var disabledItems = [];
	
	    function _updateItemDisabled(item, isDisabled) {
	      var disabledItemIndex = disabledItems.indexOf(item);
	      if (isDisabled && disabledItemIndex === -1) {
	        disabledItems.push(item);
	      }
	
	      if (!isDisabled && disabledItemIndex > -1) {
	        disabledItems.splice(disabledItemIndex, 0);
	      }
	    }
	
	    function _isItemDisabled(item) {
	      return disabledItems.indexOf(item) > -1;
	    }
	
	    ctrl.isDisabled = function (itemScope) {
	
	      if (!ctrl.open) return;
	
	      var item = itemScope[ctrl.itemProperty];
	      var itemIndex = ctrl.items.indexOf(item);
	      var isDisabled = false;
	
	      if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	        if (item.isTag) return false;
	
	        if (ctrl.multiple) {
	          isDisabled = _isItemSelected(item);
	        }
	
	        if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	          isDisabled = !!itemScope.$eval(ctrl.disableChoiceExpression);
	        }
	
	        _updateItemDisabled(item, isDisabled);
	      }
	
	      return isDisabled;
	    };
	
	    // When the user selects an item with ENTER or clicks the dropdown
	    ctrl.select = function (item, skipFocusser, $event) {
	      if (item === undefined || !_isItemDisabled(item)) {
	
	        if (!ctrl.items && !ctrl.search && !ctrl.tagging.isActivated) return;
	
	        if (!item || !_isItemDisabled(item)) {
	          if (ctrl.tagging.isActivated) {
	            // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	            if (ctrl.taggingLabel === false) {
	              if (ctrl.activeIndex < 0) {
	                if (item === undefined) {
	                  item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	                }
	                if (!item || angular.equals(ctrl.items[0], item)) {
	                  return;
	                }
	              } else {
	                // keyboard nav happened first, user selected from dropdown
	                item = ctrl.items[ctrl.activeIndex];
	              }
	            } else {
	              // tagging always operates at index zero, taggingLabel === false pushes
	              // the ctrl.search value without having it injected
	              if (ctrl.activeIndex === 0) {
	                // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	                // for `item` if it is a detected duplicate
	                if (item === undefined) return;
	
	                // create new item on the fly if we don't already have one;
	                // use tagging function if we have one
	                if (ctrl.tagging.fct !== undefined && typeof item === 'string') {
	                  item = ctrl.tagging.fct(item);
	                  if (!item) return;
	                  // if item type is 'string', apply the tagging label
	                } else if (typeof item === 'string') {
	                  // trim the trailing space
	                  item = item.replace(ctrl.taggingLabel, '').trim();
	                }
	              }
	            }
	            // search ctrl.selected for dupes potentially caused by tagging and return early if found
	            if (_isItemSelected(item)) {
	              ctrl.close(skipFocusser);
	              return;
	            }
	          }
	
	          $scope.$broadcast('uis:select', item);
	
	          var locals = {};
	          locals[ctrl.parserResult.itemName] = item;
	
	          $timeout(function () {
	            ctrl.onSelectCallback($scope, {
	              $item: item,
	              $model: ctrl.parserResult.modelMapper($scope, locals)
	            });
	          });
	
	          if (ctrl.closeOnSelect) {
	            ctrl.close(skipFocusser);
	          }
	          if ($event && $event.type === 'click') {
	            ctrl.clickTriggeredSelect = true;
	          }
	        }
	      }
	    };
	
	    // Closes the dropdown
	    ctrl.close = function (skipFocusser) {
	      if (!ctrl.open) return;
	      if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	      _resetSearchInput();
	      ctrl.open = false;
	
	      $scope.$broadcast('uis:close', skipFocusser);
	    };
	
	    ctrl.setFocus = function () {
	      if (!ctrl.focus) ctrl.focusInput[0].focus();
	    };
	
	    ctrl.clear = function ($event) {
	      ctrl.select(undefined);
	      $event.stopPropagation();
	      $timeout(function () {
	        ctrl.focusser[0].focus();
	      }, 0, false);
	    };
	
	    // Toggle dropdown
	    ctrl.toggle = function (e) {
	      if (ctrl.open) {
	        ctrl.close();
	        e.preventDefault();
	        e.stopPropagation();
	      } else {
	        ctrl.activate();
	      }
	    };
	
	    // Set default function for locked choices - avoids unnecessary 
	    // logic if functionality is not being used
	    ctrl.isLocked = function () {
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	    }, _initaliseLockedChoices);
	
	    function _initaliseLockedChoices(doInitalise) {
	      if (!doInitalise) return;
	
	      var lockedItems = [];
	
	      function _updateItemLocked(item, isLocked) {
	        var lockedItemIndex = lockedItems.indexOf(item);
	        if (isLocked && lockedItemIndex === -1) {
	          lockedItems.push(item);
	        }
	
	        if (!isLocked && lockedItemIndex > -1) {
	          lockedItems.splice(lockedItemIndex, 0);
	        }
	      }
	
	      function _isItemlocked(item) {
	        return lockedItems.indexOf(item) > -1;
	      }
	
	      ctrl.isLocked = function (itemScope, itemIndex) {
	        var isLocked = false,
	            item = ctrl.selected[itemIndex];
	
	        if (item) {
	          if (itemScope) {
	            isLocked = !!itemScope.$eval(ctrl.lockChoiceExpression);
	            _updateItemLocked(item, isLocked);
	          } else {
	            isLocked = _isItemlocked(item);
	          }
	        }
	
	        return isLocked;
	      };
	    }
	
	    var sizeWatch = null;
	    var updaterScheduled = false;
	    ctrl.sizeSearchInput = function () {
	
	      var input = ctrl.searchInput[0],
	          container = ctrl.searchInput.parent().parent()[0],
	          calculateContainerWidth = function calculateContainerWidth() {
	        // Return the container width only if the search input is visible
	        return container.clientWidth * !!input.offsetParent;
	      },
	          updateIfVisible = function updateIfVisible(containerWidth) {
	        if (containerWidth === 0) {
	          return false;
	        }
	        var inputWidth = containerWidth - input.offsetLeft - 10;
	        if (inputWidth < 50) inputWidth = containerWidth;
	        ctrl.searchInput.css('width', inputWidth + 'px');
	        return true;
	      };
	
	      ctrl.searchInput.css('width', '10px');
	      $timeout(function () {
	        //Give tags time to render correctly
	        if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	          sizeWatch = $scope.$watch(function () {
	            if (!updaterScheduled) {
	              updaterScheduled = true;
	              $scope.$$postDigest(function () {
	                updaterScheduled = false;
	                if (updateIfVisible(calculateContainerWidth())) {
	                  sizeWatch();
	                  sizeWatch = null;
	                }
	              });
	            }
	          }, angular.noop);
	        }
	      });
	    };
	
	    function _handleDropDownSelection(key) {
	      var processed = true;
	      switch (key) {
	        case KEY.DOWN:
	          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	          else if (ctrl.activeIndex < ctrl.items.length - 1) {
	              ctrl.activeIndex++;
	            }
	          break;
	        case KEY.UP:
	          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	          else if (ctrl.activeIndex > 0 || ctrl.search.length === 0 && ctrl.tagging.isActivated && ctrl.activeIndex > -1) {
	              ctrl.activeIndex--;
	            }
	          break;
	        case KEY.TAB:
	          if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	          break;
	        case KEY.ENTER:
	          if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)) {
	            ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	          } else {
	            ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	          }
	          break;
	        case KEY.ESC:
	          ctrl.close();
	          break;
	        default:
	          processed = false;
	      }
	      return processed;
	    }
	
	    // Bind to keyboard shortcuts
	    ctrl.searchInput.on('keydown', function (e) {
	
	      var key = e.which;
	
	      if (~[KEY.ENTER, KEY.ESC].indexOf(key)) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	
	      // if(~[KEY.ESC,KEY.TAB].indexOf(key)){
	      //   //TODO: SEGURO?
	      //   ctrl.close();
	      // }
	
	      $scope.$apply(function () {
	
	        var tagged = false;
	
	        if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	          _handleDropDownSelection(key);
	          if (ctrl.taggingTokens.isActivated) {
	            for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	              if (ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode]) {
	                // make sure there is a new value to push via tagging
	                if (ctrl.search.length > 0) {
	                  tagged = true;
	                }
	              }
	            }
	            if (tagged) {
	              $timeout(function () {
	                ctrl.searchInput.triggerHandler('tagged');
	                var newItem = ctrl.search.replace(KEY.MAP[e.keyCode], '').trim();
	                if (ctrl.tagging.fct) {
	                  newItem = ctrl.tagging.fct(newItem);
	                }
	                if (newItem) ctrl.select(newItem, true);
	              });
	            }
	          }
	        }
	      });
	
	      if (KEY.isVerticalMovement(key) && ctrl.items.length > 0) {
	        _ensureHighlightVisible();
	      }
	
	      if (key === KEY.ENTER || key === KEY.ESC) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    });
	
	    ctrl.searchInput.on('paste', function (e) {
	      var data;
	
	      if (window.clipboardData && window.clipboardData.getData) {
	        // IE
	        data = window.clipboardData.getData('Text');
	      } else {
	        data = (e.originalEvent || e).clipboardData.getData('text/plain');
	      }
	
	      // Prepend the current input field text to the paste buffer.
	      data = ctrl.search + data;
	
	      if (data && data.length > 0) {
	        // If tagging try to split by tokens and add items
	        if (ctrl.taggingTokens.isActivated) {
	          var items = [];
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            // split by first token that is contained in data
	            var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	            if (data.indexOf(separator) > -1) {
	              items = data.split(separator);
	              break; // only split by one token
	            }
	          }
	          if (items.length === 0) {
	            items = [data];
	          }
	          var oldsearch = ctrl.search;
	          angular.forEach(items, function (item) {
	            var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	            if (newItem) {
	              ctrl.select(newItem, true);
	            }
	          });
	          ctrl.search = oldsearch || EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (ctrl.paste) {
	          ctrl.paste(data);
	          ctrl.search = EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      }
	    });
	
	    ctrl.searchInput.on('tagged', function () {
	      $timeout(function () {
	        _resetSearchInput();
	      });
	    });
	
	    // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	    function _ensureHighlightVisible() {
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var choices = container.querySelectorAll('.ui-select-choices-row');
	      if (choices.length < 1) {
	        throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      if (ctrl.activeIndex < 0) {
	        return;
	      }
	
	      var highlighted = choices[ctrl.activeIndex];
	      var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	      var height = container[0].offsetHeight;
	
	      if (posY > height) {
	        container[0].scrollTop += posY - height;
	      } else if (posY < highlighted.clientHeight) {
	        if (ctrl.isGrouped && ctrl.activeIndex === 0) container[0].scrollTop = 0; //To make group header visible when going all the way up
	        else container[0].scrollTop -= highlighted.clientHeight - posY;
	      }
	    }
	
	    var onResize = $$uisDebounce(function () {
	      ctrl.sizeSearchInput();
	    }, 50);
	
	    angular.element($window).bind('resize', onResize);
	
	    $scope.$on('$destroy', function () {
	      ctrl.searchInput.off('keyup keydown tagged blur paste');
	      angular.element($window).off('resize', onResize);
	    });
	  }]);
	
	  uis.directive('uiSelect', ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout', function ($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	    return {
	      restrict: 'EA',
	      templateUrl: function templateUrl(tElement, tAttrs) {
	        var theme = tAttrs.theme || uiSelectConfig.theme;
	        return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	      },
	      replace: true,
	      transclude: true,
	      require: ['uiSelect', '^ngModel'],
	      scope: true,
	
	      controller: 'uiSelectCtrl',
	      controllerAs: '$select',
	      compile: function compile(tElement, tAttrs) {
	
	        // Allow setting ngClass on uiSelect
	        var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	        if (match) {
	          var combined = '{' + match[1] + ', ' + match[2] + '}';
	          tAttrs.ngClass = combined;
	          tElement.attr('ng-class', combined);
	        }
	
	        //Multiple or Single depending if multiple attribute presence
	        if (angular.isDefined(tAttrs.multiple)) tElement.append('<ui-select-multiple/>').removeAttr('multiple');else tElement.append('<ui-select-single/>');
	
	        if (tAttrs.inputId) tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	        return function (scope, element, attrs, ctrls, transcludeFn) {
	
	          var $select = ctrls[0];
	          var ngModel = ctrls[1];
	
	          $select.generatedId = uiSelectConfig.generateId();
	          $select.baseTitle = attrs.title || 'Select box';
	          $select.focusserTitle = $select.baseTitle + ' focus';
	          $select.focusserId = 'focusser-' + $select.generatedId;
	
	          $select.closeOnSelect = function () {
	            if (angular.isDefined(attrs.closeOnSelect)) {
	              return $parse(attrs.closeOnSelect)();
	            } else {
	              return uiSelectConfig.closeOnSelect;
	            }
	          }();
	
	          scope.$watch('skipFocusser', function () {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	          });
	
	          $select.onSelectCallback = $parse(attrs.onSelect);
	          $select.onRemoveCallback = $parse(attrs.onRemove);
	
	          //Set reference to ngModel from uiSelectCtrl
	          $select.ngModel = ngModel;
	
	          $select.choiceGrouped = function (group) {
	            return $select.isGrouped && group && group.name;
	          };
	
	          if (attrs.tabindex) {
	            attrs.$observe('tabindex', function (value) {
	              $select.focusInput.attr('tabindex', value);
	              element.removeAttr('tabindex');
	            });
	          }
	
	          scope.$watch(function () {
	            return scope.$eval(attrs.searchEnabled);
	          }, function (newVal) {
	            $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	          });
	
	          scope.$watch('sortable', function () {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	          });
	
	          attrs.$observe('limit', function () {
	            //Limit the number of selections allowed
	            $select.limit = angular.isDefined(attrs.limit) ? parseInt(attrs.limit, 10) : undefined;
	          });
	
	          scope.$watch('removeSelected', function () {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	          });
	
	          attrs.$observe('disabled', function () {
	            // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	            $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	          });
	
	          attrs.$observe('resetSearchInput', function () {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	            $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	          });
	
	          attrs.$observe('paste', function () {
	            $select.paste = scope.$eval(attrs.paste);
	          });
	
	          attrs.$observe('tagging', function () {
	            if (attrs.tagging !== undefined) {
	              // $eval() is needed otherwise we get a string instead of a boolean
	              var taggingEval = scope.$eval(attrs.tagging);
	              $select.tagging = { isActivated: true, fct: taggingEval !== true ? taggingEval : undefined };
	            } else {
	              $select.tagging = { isActivated: false, fct: undefined };
	            }
	          });
	
	          attrs.$observe('taggingLabel', function () {
	            if (attrs.tagging !== undefined) {
	              // check eval for FALSE, in this case, we disable the labels
	              // associated with tagging
	              if (attrs.taggingLabel === 'false') {
	                $select.taggingLabel = false;
	              } else {
	                $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	              }
	            }
	          });
	
	          attrs.$observe('taggingTokens', function () {
	            if (attrs.tagging !== undefined) {
	              var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',', 'ENTER'];
	              $select.taggingTokens = { isActivated: true, tokens: tokens };
	            }
	          });
	
	          //Automatically gets focus when loaded
	          if (angular.isDefined(attrs.autofocus)) {
	            $timeout(function () {
	              $select.setFocus();
	            });
	          }
	
	          //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	          if (angular.isDefined(attrs.focusOn)) {
	            scope.$on(attrs.focusOn, function () {
	              $timeout(function () {
	                $select.setFocus();
	              });
	            });
	          }
	
	          function onDocumentClick(e) {
	            if (!$select.open) return; //Skip it if dropdown is close
	
	            var contains = false;
	
	            if (window.jQuery) {
	              // Firefox 3.6 does not support element.contains()
	              // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	              contains = window.jQuery.contains(element[0], e.target);
	            } else {
	              contains = element[0].contains(e.target);
	            }
	
	            if (!contains && !$select.clickTriggeredSelect) {
	              var skipFocusser;
	              if (!$select.skipFocusser) {
	                //Will lose focus only with certain targets
	                var focusableControls = ['input', 'button', 'textarea', 'select'];
	                var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	                skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	                if (!skipFocusser) skipFocusser = ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	              } else {
	                skipFocusser = true;
	              }
	              $select.close(skipFocusser);
	              scope.$digest();
	            }
	            $select.clickTriggeredSelect = false;
	          }
	
	          // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	          $document.on('click', onDocumentClick);
	
	          scope.$on('$destroy', function () {
	            $document.off('click', onDocumentClick);
	          });
	
	          // Move transcluded elements to their correct position in main template
	          transcludeFn(scope, function (clone) {
	            // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	            // One day jqLite will be replaced by jQuery and we will be able to write:
	            // var transcludedElement = clone.filter('.my-class')
	            // instead of creating a hackish DOM element:
	            var transcluded = angular.element('<div>').append(clone);
	
	            var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	            transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	            transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	            if (transcludedMatch.length !== 1) {
	              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	            }
	            element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	            var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	            transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	            transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	            if (transcludedChoices.length !== 1) {
	              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	            }
	            element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	            var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	            transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	            transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	            if (transcludedNoChoice.length == 1) {
	              element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	            }
	          });
	
	          // Support for appending the select field to the body when its open
	          var appendToBody = scope.$eval(attrs.appendToBody);
	          if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	            scope.$watch('$select.open', function (isOpen) {
	              if (isOpen) {
	                positionDropdown();
	              } else {
	                resetDropdown();
	              }
	            });
	
	            // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	            // it might stick around when the user routes away or the select field is otherwise removed
	            scope.$on('$destroy', function () {
	              resetDropdown();
	            });
	          }
	
	          // Hold on to a reference to the .ui-select-container element for appendToBody support
	          var placeholder = null,
	              originalWidth = '';
	
	          function positionDropdown() {
	            // Remember the absolute position of the element
	            var offset = uisOffset(element);
	
	            // Clone the element into a placeholder element to take its original place in the DOM
	            placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	            placeholder[0].style.width = offset.width + 'px';
	            placeholder[0].style.height = offset.height + 'px';
	            element.after(placeholder);
	
	            // Remember the original value of the element width inline style, so it can be restored
	            // when the dropdown is closed
	            originalWidth = element[0].style.width;
	
	            // Now move the actual dropdown element to the end of the body
	            $document.find('body').append(element);
	
	            element[0].style.position = 'absolute';
	            element[0].style.left = offset.left + 'px';
	            element[0].style.top = offset.top + 'px';
	            element[0].style.width = offset.width + 'px';
	          }
	
	          function resetDropdown() {
	            if (placeholder === null) {
	              // The dropdown has not actually been display yet, so there's nothing to reset
	              return;
	            }
	
	            // Move the dropdown element back to its original location in the DOM
	            placeholder.replaceWith(element);
	            placeholder = null;
	
	            element[0].style.position = '';
	            element[0].style.left = '';
	            element[0].style.top = '';
	            element[0].style.width = originalWidth;
	
	            // Set focus back on to the moved element
	            $select.setFocus();
	          }
	
	          // Hold on to a reference to the .ui-select-dropdown element for direction support.
	          var dropdown = null,
	              directionUpClassName = 'direction-up';
	
	          // Support changing the direction of the dropdown if there isn't enough space to render it.
	          scope.$watch('$select.open', function () {
	
	            if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up') {
	              scope.calculateDropdownPos();
	            }
	          });
	
	          var setDropdownPosUp = function setDropdownPosUp(offset, offsetDropdown) {
	
	            offset = offset || uisOffset(element);
	            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	            dropdown[0].style.position = 'absolute';
	            dropdown[0].style.top = offsetDropdown.height * -1 + 'px';
	            element.addClass(directionUpClassName);
	          };
	
	          var setDropdownPosDown = function setDropdownPosDown(offset, offsetDropdown) {
	
	            element.removeClass(directionUpClassName);
	
	            offset = offset || uisOffset(element);
	            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	          };
	
	          var calculateDropdownPosAfterAnimation = function calculateDropdownPosAfterAnimation() {
	            // Delay positioning the dropdown until all choices have been added so its height is correct.
	            $timeout(function () {
	              if ($select.dropdownPosition === 'up') {
	                //Go UP
	                setDropdownPosUp();
	              } else {
	                //AUTO
	                element.removeClass(directionUpClassName);
	
	                var offset = uisOffset(element);
	                var offsetDropdown = uisOffset(dropdown);
	
	                //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	                var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	                // Determine if the direction of the dropdown needs to be changed.
	                if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                  //Go UP
	                  setDropdownPosUp(offset, offsetDropdown);
	                } else {
	                  //Go DOWN
	                  setDropdownPosDown(offset, offsetDropdown);
	                }
	              }
	
	              // Display the dropdown once it has been positioned.
	              dropdown[0].style.opacity = 1;
	            });
	          };
	
	          scope.calculateDropdownPos = function () {
	            if ($select.open) {
	              dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	              if (dropdown.length === 0) {
	                return;
	              }
	
	              // Hide the dropdown so there is no flicker until $timeout is done executing.
	              dropdown[0].style.opacity = 0;
	
	              if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	                var needsCalculated = true;
	
	                $select.$animate.on('enter', dropdown, function (elem, phase) {
	                  if (phase === 'close' && needsCalculated) {
	                    calculateDropdownPosAfterAnimation();
	                    needsCalculated = false;
	                  }
	                });
	              } else {
	                calculateDropdownPosAfterAnimation();
	              }
	            } else {
	              if (dropdown === null || dropdown.length === 0) {
	                return;
	              }
	
	              // Reset the position of the dropdown.
	              dropdown[0].style.opacity = 0;
	              dropdown[0].style.position = '';
	              dropdown[0].style.top = '';
	              element.removeClass(directionUpClassName);
	            }
	          };
	        };
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectMatch', ['uiSelectConfig', function (uiSelectConfig) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-match');
	
	        var parent = tElement.parent();
	        // Gets theme attribute from parent (ui-select)
	        var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	        var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	        return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');
	      },
	      link: function link(scope, element, attrs, $select) {
	        $select.lockChoiceExpression = attrs.uiLockChoice;
	        attrs.$observe('placeholder', function (placeholder) {
	          $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	        });
	
	        function setAllowClear(allow) {
	          $select.allowClear = angular.isDefined(allow) ? allow === '' ? true : allow.toLowerCase() === 'true' : false;
	        }
	
	        attrs.$observe('allowClear', setAllowClear);
	        setAllowClear(attrs.allowClear);
	
	        if ($select.multiple) {
	          $select.sizeSearchInput();
	        }
	      }
	    };
	
	    function getAttribute(elem, attribute) {
	      if (elem[0].hasAttribute(attribute)) return elem.attr(attribute);
	
	      if (elem[0].hasAttribute('data-' + attribute)) return elem.attr('data-' + attribute);
	
	      if (elem[0].hasAttribute('x-' + attribute)) return elem.attr('x-' + attribute);
	    }
	  }]);
	
	  uis.directive('uiSelectMultiple', ['uiSelectMinErr', '$timeout', function (uiSelectMinErr, $timeout) {
	    return {
	      restrict: 'EA',
	      require: ['^uiSelect', '^ngModel'],
	
	      controller: ['$scope', '$timeout', function ($scope, $timeout) {
	
	        var ctrl = this,
	            $select = $scope.$select,
	            ngModel;
	
	        if (angular.isUndefined($select.selected)) $select.selected = [];
	
	        //Wait for link fn to inject it
	        $scope.$evalAsync(function () {
	          ngModel = $scope.ngModel;
	        });
	
	        ctrl.activeMatchIndex = -1;
	
	        ctrl.updateModel = function () {
	          ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	          ctrl.refreshComponent();
	        };
	
	        ctrl.refreshComponent = function () {
	          //Remove already selected items
	          //e.g. When user clicks on a selection, the selected array changes and
	          //the dropdown should remove that item
	          if ($select.refreshItems) {
	            $select.refreshItems();
	          }
	          if ($select.sizeSearchInput) {
	            $select.sizeSearchInput();
	          }
	        };
	
	        // Remove item from multiple select
	        ctrl.removeChoice = function (index) {
	
	          // if the choice is locked, don't remove it
	          if ($select.isLocked(null, index)) return false;
	
	          var removedChoice = $select.selected[index];
	
	          var locals = {};
	          locals[$select.parserResult.itemName] = removedChoice;
	
	          $select.selected.splice(index, 1);
	          ctrl.activeMatchIndex = -1;
	          $select.sizeSearchInput();
	
	          // Give some time for scope propagation.
	          $timeout(function () {
	            $select.onRemoveCallback($scope, {
	              $item: removedChoice,
	              $model: $select.parserResult.modelMapper($scope, locals)
	            });
	          });
	
	          ctrl.updateModel();
	
	          return true;
	        };
	
	        ctrl.getPlaceholder = function () {
	          //Refactor single?
	          if ($select.selected && $select.selected.length) return;
	          return $select.placeholder;
	        };
	      }],
	      controllerAs: '$selectMultiple',
	
	      link: function link(scope, element, attrs, ctrls) {
	
	        var $select = ctrls[0];
	        var ngModel = scope.ngModel = ctrls[1];
	        var $selectMultiple = scope.$selectMultiple;
	
	        //$select.selected = raw selected objects (ignoring any property binding)
	
	        $select.multiple = true;
	
	        //Input that will handle focus
	        $select.focusInput = $select.searchInput;
	
	        //Properly check for empty if set to multiple
	        ngModel.$isEmpty = function (value) {
	          return !value || value.length === 0;
	        };
	
	        //From view --> model
	        ngModel.$parsers.unshift(function () {
	          var locals = {},
	              result,
	              resultMultiple = [];
	          for (var j = $select.selected.length - 1; j >= 0; j--) {
	            locals = {};
	            locals[$select.parserResult.itemName] = $select.selected[j];
	            result = $select.parserResult.modelMapper(scope, locals);
	            resultMultiple.unshift(result);
	          }
	          return resultMultiple;
	        });
	
	        // From model --> view
	        ngModel.$formatters.unshift(function (inputValue) {
	          var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }),
	              //Overwrite $search
	          locals = {},
	              result;
	          if (!data) return inputValue;
	          var resultMultiple = [];
	          var checkFnMultiple = function checkFnMultiple(list, value) {
	            if (!list || !list.length) return;
	            for (var p = list.length - 1; p >= 0; p--) {
	              locals[$select.parserResult.itemName] = list[p];
	              result = $select.parserResult.modelMapper(scope, locals);
	              if ($select.parserResult.trackByExp) {
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if (propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName) {
	                  if (matches && matches.length > 0 && result[matches[1]] == value[matches[1]]) {
	                    resultMultiple.unshift(list[p]);
	                    return true;
	                  }
	                }
	              }
	              if (angular.equals(result, value)) {
	                resultMultiple.unshift(list[p]);
	                return true;
	              }
	            }
	            return false;
	          };
	          if (!inputValue) return resultMultiple; //If ngModel was undefined
	          for (var k = inputValue.length - 1; k >= 0; k--) {
	            //Check model array of currently selected items
	            if (!checkFnMultiple($select.selected, inputValue[k])) {
	              //Check model array of all items available
	              if (!checkFnMultiple(data, inputValue[k])) {
	                //If not found on previous lists, just add it directly to resultMultiple
	                resultMultiple.unshift(inputValue[k]);
	              }
	            }
	          }
	          return resultMultiple;
	        });
	
	        //Watch for external model changes
	        scope.$watchCollection(function () {
	          return ngModel.$modelValue;
	        }, function (newValue, oldValue) {
	          if (oldValue != newValue) {
	            //update the view value with fresh data from items, if there is a valid model value
	            if (angular.isDefined(ngModel.$modelValue)) {
	              ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	            }
	            $selectMultiple.refreshComponent();
	          }
	        });
	
	        ngModel.$render = function () {
	          // Make sure that model value is array
	          if (!angular.isArray(ngModel.$viewValue)) {
	            // Have tolerance for null or undefined values
	            if (angular.isUndefined(ngModel.$viewValue) || ngModel.$viewValue === null) {
	              ngModel.$viewValue = [];
	            } else {
	              throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	            }
	          }
	          $select.selected = ngModel.$viewValue;
	          $selectMultiple.refreshComponent();
	          scope.$evalAsync(); //To force $digest
	        };
	
	        scope.$on('uis:select', function (event, item) {
	          if ($select.selected.length >= $select.limit) {
	            return;
	          }
	          $select.selected.push(item);
	          $selectMultiple.updateModel();
	        });
	
	        scope.$on('uis:activate', function () {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	
	        scope.$watch('$select.disabled', function (newValue, oldValue) {
	          // As the search input field may now become visible, it may be necessary to recompute its size
	          if (oldValue && !newValue) $select.sizeSearchInput();
	        });
	
	        $select.searchInput.on('keydown', function (e) {
	          var key = e.which;
	          scope.$apply(function () {
	            var processed = false;
	            // var tagged = false; //Checkme
	            if (KEY.isHorizontalMovement(key)) {
	              processed = _handleMatchSelection(key);
	            }
	            if (processed && key != KEY.TAB) {
	              //TODO Check si el tab selecciona aun correctamente
	              //Crear test
	              e.preventDefault();
	              e.stopPropagation();
	            }
	          });
	        });
	        function _getCaretPosition(el) {
	          if (angular.isNumber(el.selectionStart)) return el.selectionStart;
	          // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	          else return el.value.length;
	        }
	        // Handles selected options in "multiple" mode
	        function _handleMatchSelection(key) {
	          var caretPosition = _getCaretPosition($select.searchInput[0]),
	              length = $select.selected.length,
	
	          // none  = -1,
	          first = 0,
	              last = length - 1,
	              curr = $selectMultiple.activeMatchIndex,
	              next = $selectMultiple.activeMatchIndex + 1,
	              prev = $selectMultiple.activeMatchIndex - 1,
	              newIndex = curr;
	
	          if (caretPosition > 0 || $select.search.length && key == KEY.RIGHT) return false;
	
	          $select.close();
	
	          function getNewActiveMatchIndex() {
	            switch (key) {
	              case KEY.LEFT:
	                // Select previous/first item
	                if (~$selectMultiple.activeMatchIndex) return prev;
	                // Select last item
	                else return last;
	                break;
	              case KEY.RIGHT:
	                // Open drop-down
	                if (!~$selectMultiple.activeMatchIndex || curr === last) {
	                  $select.activate();
	                  return false;
	                }
	                // Select next/last item
	                else return next;
	                break;
	              case KEY.BACKSPACE:
	                // Remove selected item and select previous/first
	                if (~$selectMultiple.activeMatchIndex) {
	                  if ($selectMultiple.removeChoice(curr)) {
	                    return prev;
	                  } else {
	                    return curr;
	                  }
	                } else {
	                  // If nothing yet selected, select last item
	                  return last;
	                }
	                break;
	              case KEY.DELETE:
	                // Remove selected item and select next item
	                if (~$selectMultiple.activeMatchIndex) {
	                  $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                  return curr;
	                } else return false;
	            }
	          }
	
	          newIndex = getNewActiveMatchIndex();
	
	          if (!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;else $selectMultiple.activeMatchIndex = Math.min(last, Math.max(first, newIndex));
	
	          return true;
	        }
	
	        $select.searchInput.on('keyup', function (e) {
	
	          if (!KEY.isVerticalMovement(e.which)) {
	            scope.$evalAsync(function () {
	              $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	            });
	          }
	          // Push a "create new" item into array if there is a search string
	          if ($select.tagging.isActivated && $select.search.length > 0) {
	
	            // return early with these keys
	            if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which)) {
	              return;
	            }
	            // always reset the activeIndex to the first item when tagging
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	            // taggingLabel === false bypasses all of this
	            if ($select.taggingLabel === false) return;
	
	            var items = angular.copy($select.items);
	            var stashArr = angular.copy($select.items);
	            var newItem;
	            var item;
	            var hasTag = false;
	            var dupeIndex = -1;
	            var tagItems;
	            var tagItem;
	
	            // case for object tagging via transform `$select.tagging.fct` function
	            if ($select.tagging.fct !== undefined) {
	              tagItems = $select.$filter('filter')(items, { 'isTag': true });
	              if (tagItems.length > 0) {
	                tagItem = tagItems[0];
	              }
	              // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	              if (items.length > 0 && tagItem) {
	                hasTag = true;
	                items = items.slice(1, items.length);
	                stashArr = stashArr.slice(1, stashArr.length);
	              }
	              newItem = $select.tagging.fct($select.search);
	              // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	              if (stashArr.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              }) || $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })) {
	                scope.$evalAsync(function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	                return;
	              }
	              if (newItem) newItem.isTag = true;
	              // handle newItem string and stripping dupes in tagging string context
	            } else {
	              // find any tagging items already in the $select.items array and store them
	              tagItems = $select.$filter('filter')(items, function (item) {
	                return item.match($select.taggingLabel);
	              });
	              if (tagItems.length > 0) {
	                tagItem = tagItems[0];
	              }
	              item = items[0];
	              // remove existing tag item if found (should only ever be one tag item)
	              if (item !== undefined && items.length > 0 && tagItem) {
	                hasTag = true;
	                items = items.slice(1, items.length);
	                stashArr = stashArr.slice(1, stashArr.length);
	              }
	              newItem = $select.search + ' ' + $select.taggingLabel;
	              if (_findApproxDupe($select.selected, $select.search) > -1) {
	                return;
	              }
	              // verify the the tag doesn't match the value of an existing item from
	              // the searched data set or the items already selected
	              if (_findCaseInsensitiveDupe(stashArr.concat($select.selected))) {
	                // if there is a tag from prev iteration, strip it / queue the change
	                // and return early
	                if (hasTag) {
	                  items = stashArr;
	                  scope.$evalAsync(function () {
	                    $select.activeIndex = 0;
	                    $select.items = items;
	                  });
	                }
	                return;
	              }
	              if (_findCaseInsensitiveDupe(stashArr)) {
	                // if there is a tag from prev iteration, strip it
	                if (hasTag) {
	                  $select.items = stashArr.slice(1, stashArr.length);
	                }
	                return;
	              }
	            }
	            if (hasTag) dupeIndex = _findApproxDupe($select.selected, newItem);
	            // dupe found, shave the first item
	            if (dupeIndex > -1) {
	              items = items.slice(dupeIndex + 1, items.length - 1);
	            } else {
	              items = [];
	              if (newItem) items.push(newItem);
	              items = items.concat(stashArr);
	            }
	            scope.$evalAsync(function () {
	              $select.activeIndex = 0;
	              $select.items = items;
	
	              if ($select.isGrouped) {
	                // update item references in groups, so that indexOf will work after angular.copy
	                var itemsWithoutTag = newItem ? items.slice(1) : items;
	                $select.setItemsFn(itemsWithoutTag);
	                if (newItem) {
	                  // add tag item as a new group
	                  $select.items.unshift(newItem);
	                  $select.groups.unshift({ name: '', items: [newItem], tagging: true });
	                }
	              }
	            });
	          }
	        });
	        function _findCaseInsensitiveDupe(arr) {
	          if (arr === undefined || $select.search === undefined) {
	            return false;
	          }
	          var hasDupe = arr.filter(function (origItem) {
	            if ($select.search.toUpperCase() === undefined || origItem === undefined) {
	              return false;
	            }
	            return origItem.toUpperCase() === $select.search.toUpperCase();
	          }).length > 0;
	
	          return hasDupe;
	        }
	        function _findApproxDupe(haystack, needle) {
	          var dupeIndex = -1;
	          if (angular.isArray(haystack)) {
	            var tempArr = angular.copy(haystack);
	            for (var i = 0; i < tempArr.length; i++) {
	              // handle the simple string version of tagging
	              if ($select.tagging.fct === undefined) {
	                // search the array for the match
	                if (tempArr[i] + ' ' + $select.taggingLabel === needle) {
	                  dupeIndex = i;
	                }
	                // handle the object tagging implementation
	              } else {
	                var mockObj = tempArr[i];
	                if (angular.isObject(mockObj)) {
	                  mockObj.isTag = true;
	                }
	                if (angular.equals(mockObj, needle)) {
	                  dupeIndex = i;
	                }
	              }
	            }
	          }
	          return dupeIndex;
	        }
	
	        $select.searchInput.on('blur', function () {
	          $timeout(function () {
	            $selectMultiple.activeMatchIndex = -1;
	          });
	        });
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectNoChoice', ['uiSelectConfig', function (uiSelectConfig) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-no-choice');
	
	        // Gets theme attribute from parent (ui-select)
	        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	        return theme + '/no-choice.tpl.html';
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectSingle', ['$timeout', '$compile', function ($timeout, $compile) {
	    return {
	      restrict: 'EA',
	      require: ['^uiSelect', '^ngModel'],
	      link: function link(scope, element, attrs, ctrls) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        //From view --> model
	        ngModel.$parsers.unshift(function (inputValue) {
	          var locals = {},
	              result;
	          locals[$select.parserResult.itemName] = inputValue;
	          result = $select.parserResult.modelMapper(scope, locals);
	          return result;
	        });
	
	        //From model --> view
	        ngModel.$formatters.unshift(function (inputValue) {
	          var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }),
	              //Overwrite $search
	          locals = {},
	              result;
	          if (data) {
	            var checkFnSingle = function checkFnSingle(d) {
	              locals[$select.parserResult.itemName] = d;
	              result = $select.parserResult.modelMapper(scope, locals);
	              return result === inputValue;
	            };
	            //If possible pass same object stored in $select.selected
	            if ($select.selected && checkFnSingle($select.selected)) {
	              return $select.selected;
	            }
	            for (var i = data.length - 1; i >= 0; i--) {
	              if (checkFnSingle(data[i])) return data[i];
	            }
	          }
	          return inputValue;
	        });
	
	        //Update viewValue if model change
	        scope.$watch('$select.selected', function (newValue) {
	          if (ngModel.$viewValue !== newValue) {
	            ngModel.$setViewValue(newValue);
	          }
	        });
	
	        ngModel.$render = function () {
	          $select.selected = ngModel.$viewValue;
	        };
	
	        scope.$on('uis:select', function (event, item) {
	          $select.selected = item;
	        });
	
	        scope.$on('uis:close', function (event, skipFocusser) {
	          $timeout(function () {
	            $select.focusser.prop('disabled', false);
	            if (!skipFocusser) $select.focusser[0].focus();
	          }, 0, false);
	        });
	
	        scope.$on('uis:activate', function () {
	          focusser.prop('disabled', true); //Will reactivate it on .close()
	        });
	
	        //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	        var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	        $compile(focusser)(scope);
	        $select.focusser = focusser;
	
	        //Input that will handle focus
	        $select.focusInput = focusser;
	
	        element.parent().append(focusser);
	        focusser.bind("focus", function () {
	          scope.$evalAsync(function () {
	            $select.focus = true;
	          });
	        });
	        focusser.bind("blur", function () {
	          scope.$evalAsync(function () {
	            $select.focus = false;
	          });
	        });
	        focusser.bind("keydown", function (e) {
	
	          if (e.which === KEY.BACKSPACE) {
	            e.preventDefault();
	            e.stopPropagation();
	            $select.select(undefined);
	            scope.$apply();
	            return;
	          }
	
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	            return;
	          }
	
	          if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE) {
	            e.preventDefault();
	            e.stopPropagation();
	            $select.activate();
	          }
	
	          scope.$digest();
	        });
	
	        focusser.bind("keyup input", function (e) {
	
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	            return;
	          }
	
	          $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	          focusser.val('');
	          scope.$digest();
	        });
	      }
	    };
	  }]);
	
	  // Make multiple matches sortable
	  uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function ($timeout, uiSelectConfig, uiSelectMinErr) {
	    return {
	      require: ['^^uiSelect', '^ngModel'],
	      link: function link(scope, element, attrs, ctrls) {
	        if (scope[attrs.uiSelectSort] === null) {
	          throw uiSelectMinErr('sort', 'Expected a list to sort');
	        }
	
	        var $select = ctrls[0];
	        var $ngModel = ctrls[1];
	
	        var options = angular.extend({
	          axis: 'horizontal'
	        }, scope.$eval(attrs.uiSelectSortOptions));
	
	        var axis = options.axis;
	        var draggingClassName = 'dragging';
	        var droppingClassName = 'dropping';
	        var droppingBeforeClassName = 'dropping-before';
	        var droppingAfterClassName = 'dropping-after';
	
	        scope.$watch(function () {
	          return $select.sortable;
	        }, function (newValue) {
	          if (newValue) {
	            element.attr('draggable', true);
	          } else {
	            element.removeAttr('draggable');
	          }
	        });
	
	        element.on('dragstart', function (event) {
	          element.addClass(draggingClassName);
	
	          (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	        });
	
	        element.on('dragend', function () {
	          removeClass(draggingClassName);
	        });
	
	        var move = function move(from, to) {
	          /*jshint validthis: true */
	          this.splice(to, 0, this.splice(from, 1)[0]);
	        };
	
	        var removeClass = function removeClass(className) {
	          angular.forEach($select.$element.querySelectorAll('.' + className), function (el) {
	            angular.element(el).removeClass(className);
	          });
	        };
	
	        var dragOverHandler = function dragOverHandler(event) {
	          event.preventDefault();
	
	          var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	          if (offset < this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2) {
	            removeClass(droppingAfterClassName);
	            element.addClass(droppingBeforeClassName);
	          } else {
	            removeClass(droppingBeforeClassName);
	            element.addClass(droppingAfterClassName);
	          }
	        };
	
	        var dropTimeout;
	
	        var dropHandler = function dropHandler(event) {
	          event.preventDefault();
	
	          var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	          // prevent event firing multiple times in firefox
	          $timeout.cancel(dropTimeout);
	          dropTimeout = $timeout(function () {
	            _dropHandler(droppedItemIndex);
	          }, 20);
	        };
	
	        var _dropHandler = function _dropHandler(droppedItemIndex) {
	          var theList = scope.$eval(attrs.uiSelectSort);
	          var itemToMove = theList[droppedItemIndex];
	          var newIndex = null;
	
	          if (element.hasClass(droppingBeforeClassName)) {
	            if (droppedItemIndex < scope.$index) {
	              newIndex = scope.$index - 1;
	            } else {
	              newIndex = scope.$index;
	            }
	          } else {
	            if (droppedItemIndex < scope.$index) {
	              newIndex = scope.$index;
	            } else {
	              newIndex = scope.$index + 1;
	            }
	          }
	
	          move.apply(theList, [droppedItemIndex, newIndex]);
	
	          $ngModel.$setViewValue(Date.now());
	
	          scope.$apply(function () {
	            scope.$emit('uiSelectSort:change', {
	              array: theList,
	              item: itemToMove,
	              from: droppedItemIndex,
	              to: newIndex
	            });
	          });
	
	          removeClass(droppingClassName);
	          removeClass(droppingBeforeClassName);
	          removeClass(droppingAfterClassName);
	
	          element.off('drop', dropHandler);
	        };
	
	        element.on('dragenter', function () {
	          if (element.hasClass(draggingClassName)) {
	            return;
	          }
	
	          element.addClass(droppingClassName);
	
	          element.on('dragover', dragOverHandler);
	          element.on('drop', dropHandler);
	        });
	
	        element.on('dragleave', function (event) {
	          if (event.target != element) {
	            return;
	          }
	
	          removeClass(droppingClassName);
	          removeClass(droppingBeforeClassName);
	          removeClass(droppingAfterClassName);
	
	          element.off('dragover', dragOverHandler);
	          element.off('drop', dropHandler);
	        });
	      }
	    };
	  }]);
	
	  /**
	   * Debounces functions
	   *
	   * Taken from UI Bootstrap $$debounce source code
	   * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	   *
	   */
	  uis.factory('$$uisDebounce', ['$timeout', function ($timeout) {
	    return function (callback, debounceTime) {
	      var timeoutPromise;
	
	      return function () {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	
	        timeoutPromise = $timeout(function () {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);
	
	  /**
	   * Parses "repeat" attribute.
	   *
	   * Taken from AngularJS ngRepeat source code
	   * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	   *
	   * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	   * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	   */
	
	  uis.service('uisRepeatParser', ['uiSelectMinErr', '$parse', function (uiSelectMinErr, $parse) {
	    var self = this;
	
	    /**
	     * Example:
	     * expression = "address in addresses | filter: {street: $select.search} track by $index"
	     * itemName = "address",
	     * source = "addresses | filter: {street: $select.search}",
	     * trackByExp = "$index",
	     */
	    self.parse = function (expression) {
	
	      var match;
	      //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	      // If an array is used as collection
	
	      // if (isObjectCollection){
	      // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	      match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      // 1 Alias
	      // 2 Item
	      // 3 Key on (key,value)
	      // 4 Value on (key,value)
	      // 5 Source expression (including filters)
	      // 6 Track by
	
	      if (!match) {
	        throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
	      }
	
	      var source = match[5],
	          filters = '';
	
	      // When using (key,value) ui-select requires filters to be extracted, since the object
	      // is converted to an array for $select.items 
	      // (in which case the filters need to be reapplied)
	      if (match[3]) {
	        // Remove any enclosing parenthesis
	        source = match[5].replace(/(^\()|(\)$)/g, '');
	        // match all after | but not after ||
	        var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	        if (filterMatch && filterMatch[1].trim()) {
	          filters = filterMatch[1];
	          source = source.replace(filters, '');
	        }
	      }
	
	      return {
	        itemName: match[4] || match[2], // (lhs) Left-hand side,
	        keyName: match[3], //for (key, value) syntax
	        source: $parse(source),
	        filters: filters,
	        trackByExp: match[6],
	        modelMapper: $parse(match[1] || match[4] || match[2]),
	        repeatExpression: function repeatExpression(grouped) {
	          var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	          if (this.trackByExp) {
	            expression += ' track by ' + this.trackByExp;
	          }
	          return expression;
	        }
	      };
	    };
	
	    self.getGroupNgRepeatExpression = function () {
	      return '$group in $select.groups';
	    };
	  }]);
	})();
	angular.module("ui.select").run(["$templateCache", function ($templateCache) {
	  $templateCache.put("bootstrap/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" role=\"listbox\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><a href=\"\" class=\"ui-select-choices-row-inner\"></a></div></li></ul>");
	  $templateCache.put("bootstrap/match-multiple.tpl.html", "<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	  $templateCache.put("bootstrap/match.tpl.html", "<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	  $templateCache.put("bootstrap/no-choice.tpl.html", "<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	  $templateCache.put("bootstrap/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	  $templateCache.put("bootstrap/select.tpl.html", "<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"form-control ui-select-search\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.searchEnabled && $select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	  $templateCache.put("select2/choices.tpl.html", "<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul role=\"listbox\" id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	  $templateCache.put("select2/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	  $templateCache.put("select2/match.tpl.html", "<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	  $templateCache.put("select2/no-choice.tpl.html", "<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	  $templateCache.put("select2/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	  $templateCache.put("select2/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"select2-search\" ng-show=\"$select.searchEnabled\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	  $templateCache.put("selectize/choices.tpl.html", "<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown single\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\" role=\"listbox\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	  $templateCache.put("selectize/match.tpl.html", "<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\" ng-transclude=\"\"></div>");
	  $templateCache.put("selectize/no-choice.tpl.html", "<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	  $templateCache.put("selectize/select.tpl.html", "<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.searchEnabled || (!$select.isEmpty() && !$select.open)\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	}]);

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(392);
	module.exports = 'ui.select';

/***/ },
/* 394 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 395 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'ACCOUNT' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=50 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline><i class=\"fa fa-user\"></i> {{ user.name }} {{ user.surname }}</span> <span class=md-subhead>{{ 'YOU_ARE' | translate}} {{ user.type | translate }}</span></md-card-title-text><md-card-title-media></md-card-title-media></md-card-title><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ui-sref=profile><i class=\"fa fa-pencil\"></i> {{ 'EDIT' | translate }}</md-button></md-card-actions></md-card></div><div flex-xs flex-gt-xs=50 layout=column ng-if=\"!has_admin && !has_patient\"><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'YOUR_LICENCES' | translate}}</span><div ng-if=!has_company><span ng-if=user.licences.length class=md-subhead><a ui-sref=purchase_licence>{{ 'NEED_MORE_LICENCES' | translate}}</a></span> <span ng-if=!user.licences.length class=md-subhead><a ui-sref=purchase_licence>{{ 'PURCHASE_LICENCES' | translate}}</a></span></div></md-card-title-text><md-card-title-media><div><span class=\"text-lg text-primary\">{{ licences.length }}</span> {{ 'LICENCES' | translate}}</div></md-card-title-media></md-card-title><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-warn\" ui-sref=licences><i class=\"fa fa-list\"></i> {{ 'MANAGE_LICENCES' | translate }}</md-button><md-button class=\"md-raised md-primary\" ng-if=!has_company ui-sref=purchase_licence><i class=\"fa fa-plus\"></i> {{ 'ADD_LICENCE' | translate }}</md-button></md-card-actions></md-card></div></md-content><md-content layout-xs=column layout=row ng-if=\"!has_admin && !has_patient\"><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'YOUR_SUBSCRIPTIONS' | translate}}</span><div ng-if=!has_company><span ng-if=user.subscriptions.length class=md-subhead><a ui-sref=\"purchases({id:'subscription'})\">{{ 'RECHARGE_SUBSCRIPTIONS' | translate}}</a></span> <span ng-if=!user.subscriptions.length class=md-subhead><a ui-sref=\"purchases({id:'subscription'})\">{{ 'PURCHASE_SUBSCRIPTIONS' | translate}}</a></span></div></md-card-title-text><md-card-title-media><span class=\"text-lg text-primary\">{{ user.use_subscriptions }}</span> {{ 'ACTIVE_UNUSED' | translate}}</md-card-title-media></md-card-title><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-warn\" ui-sref=subscriptions><i class=\"fa fa-list\"></i> {{ 'MANAGE_SUSCRIPTIONS' | translate }}</md-button><md-button class=\"md-raised md-primary\" ng-if=!has_company ui-sref=\"purchases({id:'subscription'})\"><i class=\"fa fa-plus\"></i> {{ 'ADD_SUSCRIPTIONS' | translate }}</md-button></md-card-actions></md-card></div></md-content><md-content layout-xs=column layout=row ng-if=\"!has_company && !has_admin && !has_patient\"><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'ORDERS_INVOICES' | translate}}</span></md-card-title-text></md-card-title><md-card-content><div ng-if=last_pay.total><i class=\"fa fa-calendar fa-2x\"></i> {{ 'YOUR_LAST_PAYMENT' | translate }} {{ last_pay.total | currency:\"€\" }}, {{ 'WAS_MADE_ON' | translate}} {{ last_pay.day }} {{ last_pay.month | translate }}</div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ui-sref=invoices><i class=\"fa fa-usd\"></i> {{ 'SHOW_ORDERS' | translate }}</md-button></md-card-actions></md-card></div></md-content>";

/***/ },
/* 396 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><ma-view-actions><ma-back-button></ma-back-button></ma-view-actions><div><h1>{{ 'CHANGE_PASSWORD' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><form name=form ng-submit=register() role=form novalidate><md-card md-theme-watch><md-card-content><md-input-container class=md-block><label>{{ 'OLD_PASSWORD' | translate }}</label><input type=password name=old ng-model=old required><div ng-messages=form.old.$error><div ng-message=required>{{ 'OLD_PASSWORD_REQUIRED' | translate }}.</div><div ng-message=not>{{ 'OLD_PASSWORD_NOT' | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ 'NEW_PASSWORD' | translate }}</label><input type=password name=plainPassword ng-model=plainPassword required><div ng-messages=form.plainPassword.$error><div ng-message=required>{{ 'NEW_PASSWORD_REQUIRED' | translate }}.</div><div ng-message=low>{{ \"PASSWORD_SHORT\" | translate }}</div></div></md-input-container><md-input-container class=md-block><label>{{ 'CONFIRM_PASSWORD' | translate }}</label><input type=password name=confirm ng-model=confirm required><div ng-messages=form.confirm.$error><div ng-message=required>{{ 'CONFIRM_PASSWORD_REQUIRED' | translate }}.</div><div ng-message=same>{{ 'CONFIRM_PASSWORD_SAME' | translate }}</div></div></md-input-container></md-card-content></md-card><md-card-actions layout=row layout-align=\"end center\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\">{{ 'CHANGE_PASSWORD'| translate }}</md-button></md-card-actions></form>";

/***/ },
/* 397 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><uib-alert type=info close=dismissAlert() ng-show=!has_seen_alert>Hello</uib-alert></div></div><div class=row><div class=col-lg-3><div class=\"panel panel-primary\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-usd fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ stats.commands.revenue | number:0 }}</div><div>{{\"MONTHLY_REVENUE\" | translate}}</div></div></div></div><a ui-sref=\"list({entity:'commands'})\"><div class=panel-footer><span class=pull-left>{{\"VIEW_DETAILS\" | translate}}</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div><div class=col-lg-3><div class=\"panel panel-green\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-shopping-cart fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ stats.commands.pending_orders }}</div><div>{{\"PENDING_ORDERS\" | translate}}</div></div></div></div><a ui-sref=\"list({entity:'commands',search:{status:'ordered'}})\"><div class=panel-footer><span class=pull-left>{{\"VIEW_DETAILS\" | translate}}</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div><div class=col-lg-3><div class=\"panel panel-yellow\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-comments fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ stats.reviews }}</div><div>{{\"PENDING_REVIEWS\" | translate}}</div></div></div></div><a ui-sref=\"list({entity:'reviews', search:{status:'pending'}})\"><div class=panel-footer><span class=pull-left>{{\"VIEW_DETAILS\" | translate}}</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div><div class=col-lg-3><div class=\"panel panel-red\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-user-plus fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ stats.customers }}</div><div>{{\"NEW_CUSTOMERS\" | translate}}</div></div></div></div><a ui-sref=\"list({entity:'customers',search:{has_ordered:true}})\"><div class=panel-footer><span class=pull-left>{{\"VIEW_DETAILS\" | translate}}</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div></div>";

/***/ },
/* 398 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'DOWNLOADS' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><div class=\"image pro\"></div><div class=\"image specialist\"></div><div class=\"image home\"></div><div class=\"image vr\"></div></md-card-title-text></md-card-title><md-card-actions layout=row layout-align=\"end center\" class=btn-download><span>{{ 'TEXT_DOWNLOAD' | translate }}</span><md-button class=\"md-raised md-primary\" href=https://s3-brainvt-app.s3.amazonaws.com/app/InstaladorLauncher/Instalador_Educa.msi target=_blank><i class=\"fa fa-download\"></i> {{ 'DOWNLOAD' | translate }}</md-button></md-card-actions></md-card></div></md-content>";

/***/ },
/* 399 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions ng-if=entry entry=entry entity=entity><ma-list-button entity=entity></ma-list-button><a class=\"btn btn-default\" ui-sref=edit(entry)><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span>&nbsp;<span class=hidden-xs translate=\"{{ 'Edit' }}\"></span></a></ma-view-actions><h1>{{ label | humanize | singularize | translate }} #{{ id }} {{ 'TEST' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description }}</p></div></div></div><div class=row id=test-view><div class=col-xs-12><form class=form-inline><div class=form-group><label>{{ 'initial age' | humanize | singularize | translate }}</label><ma-date-field field=date value=age class=ng-isolate-scope></ma-date-field><button ng-click=apply() class=\"btn btn-primary\" translate=Apply></button></div><table class=\"table table-striped table-bordered table-hover table-condensed\" style=\"table-layout: fixed; width: auto\"><caption>Entrada</caption><thead><tr><th translate=\"Variables (Initial Hardness)\" width=10% colspan=2><th ng-repeat=\"n in range(0, columns)\" translate=\"User Values\" width=10%><tbody><tr ng-repeat=\"config in configs\"><th><div class=form-group><label>{{ config.variable.name | humanize | singularize | translate }}</label></div><th><input value=\"{{ config.initial_value }}\"><th ng-repeat=\"n in range(0, columns)\"><input ng-model=config.data[n]><tr><th colspan=2>Finished<th ng-repeat=\"n in range(0, columns)\"><input type=checkbox ng-model=configs[n].finished><tr><th colspan=2><th ng-repeat=\"n in range(0, columns)\"><button class=\"btn btn-success\" translate=run ng-click=run(n) ng-disabled=\"columns > n\"></button> <button class=\"btn btn-info\" translate=reset ng-click=reset(n) ng-disabled=!configs[0].return[n]></button><thead><tr><th translate=Variables colspan=2><th ng-repeat=\"n in range(0, columns)\" translate=\"Retrun Value\"><tbody><tr ng-repeat=\"config in configs\"><th colspan=2><div class=form-group><label>{{ config.variable.name | humanize | singularize | translate }}</label></div><th ng-repeat=\"n in range(0, columns)\"><input ng-model=config.return[n]></table></form><button class=\"btn btn-info\" translate=\"reset all\" ng-click=reset_all() ng-disabled=!configs[0].return[0]></button> <button class=\"btn btn-warning\" translate=\"delete all\" ng-click=delete_all() ng-disabled=!configs[0].return[0]></button></div></div>";

/***/ },
/* 400 */
/***/ function(module, exports) {

	module.exports = "<div ng-controller=headerController><div class=navbar-header><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Eat cake\" ng-click=toggleLeft()><i class=\"fa fa-ellipsis-v\" ng-if=show></i> <i class=\"fa fa-bars\" ng-if=!show></i></md-button></div><ul class=\"nav navbar-top-links navbar-right hidden-xs\"><li><language-switcher></language-switcher></li><li><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open demo menu\" ng-click=$mdMenu.open($event) class=user_name><i class=\"fa fa-user fa-lg\"></i>&nbsp;{{ username }}</md-button><md-menu-content width=4><md-menu-item><md-button ui-sref=account><i class=\"fa fa-user fa-fw\"></i> {{ 'ACCOUNT' | translate}}</md-button></md-menu-item><md-menu-item><md-button ui-sref=change-password><i class=\"fa fa-lock fa-fw\"></i> {{ 'CHANGE_PASSWORD' | translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=logout()><i class=\"fa fa-sign-out fa-fw\"></i> {{ 'LOGOUT' | translate}}</md-button></md-menu-item></md-menu-content></md-menu></li></ul></div>";

/***/ },
/* 401 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><ma-view-actions><ma-back-button></ma-back-button></ma-view-actions><div><h1>{{ 'INVOICES' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><div ng-if=!has_company><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'INVOICES' | translate}}</span></md-card-title-text></md-card-title><md-divider></md-divider><md-card-content ng-if=invoices.length><md-table-container><table md-table md-progress=promise><thead md-head><tr md-row><th md-column><span>{{ 'ORDER' | translate}}</span><th md-column><span>{{ 'NUMBER' | translate}}</span><th md-column md-date><span>{{ 'PRODUCT' | translate }}</span><th md-column>{{ 'AMOUNT' | translate}}<th md-column>{{ 'DATE' | translate}}<th md-column><tbody md-body><tr md-row md-auto-select ng-repeat=\"invoice in invoices\"><td md-cell>{{invoice.purchase.order}}<td md-cell>{{invoice.numeration}}<td md-cell>{{invoice.product_name}}<td md-cell>{{invoice.price | currency : \"€\"}}<td md-cell>{{invoice.created | date : \"dd.MM.yyyy\"}}<td md-cell style=\"white-space: nowrap\"><i class=\"fa fa-download action-icon\" ng-click=\"viewInvoice($event, invoice)\"><md-tooltip md-direction=bottom>{{ \"DOWNLOAD_INVOICE\" | translate }}</md-tooltip></i></table></md-table-container></md-card-content><md-card-title ng-if=!purchases.length><md-card-title-text><span class=md-headline>{{ 'NO_PURCHASE_YET' | translate}}</span></md-card-title-text></md-card-title></md-card><md-card md-theme-watch ng-if=payments.length><md-card-title><md-card-title-text><span class=md-headline>{{ 'PAYMENTS' | translate}}</span></md-card-title-text></md-card-title><md-divider></md-divider><md-card-content><md-table-container><table md-table md-progress=promise><thead md-head><tr md-row><th md-column><span>{{ 'ORDER' | translate}}</span><th md-column><span>{{ 'NUMBER' | translate}}</span><th md-column md-date><span>{{ 'PRODUCT' | translate }}</span><th md-column>{{ 'AMOUNT' | translate}}<th md-column>{{ 'DATE' | translate}}<th md-column><tbody md-body><tr md-row md-auto-select ng-repeat=\"invoice in payments\"><td md-cell>{{invoice.purchase.order}}<td md-cell>{{invoice.numeration}}<td md-cell>{{invoice.product_name}}<td md-cell>{{invoice.price | currency : \"€\"}}<td md-cell>{{invoice.created | date : \"dd.MM.yyyy\"}}<td md-cell style=\"white-space: nowrap\"><i class=\"fa fa-download action-icon\" ng-click=\"viewInvoice($event, invoice)\"><md-tooltip md-direction=bottom>{{ \"DOWNLOAD_INVOICE\" | translate }}</md-tooltip></i></table></md-table-container></md-card-content><md-card-title ng-if=!purchases.length><md-card-title-text><span class=md-headline>{{ 'NO_PURCHASE_YET' | translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content><md-content layout-xs=column layout=row ng-if=pending.length><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch md-colors=\"::{backgroundColor: 'brown-primary-A200'}\"><md-card-title><md-card-title-text><span class=md-headline>{{ 'PENDING_ORDERS' | translate}}</span></md-card-title-text></md-card-title><md-divider></md-divider><md-card-content><md-table-container><table md-table md-progress=promise><thead md-head><tr md-row><th md-column><span>{{ 'ORDER' | translate}}</span><th md-column md-date><span>{{ 'PRODUCT' | translate }}</span><th md-column>{{ 'AMOUNT' | translate}}<th md-column>{{ 'DATE' | translate}}<th md-column><tbody md-body><tr md-row md-select=licence md-select-id=licence md-auto-select ng-repeat=\"(index, purchase) in pending\"><td md-cell>{{purchase.order}}<td md-cell>{{purchase.product.name}}<td md-cell>{{purchase.product.price | currency : \"€\"}}<td md-cell>{{purchase.created | date : \"dd.MM.yyyy\"}}<td md-cell style=\"white-space: nowrap\"><a class=\"fa fa-shopping-cart action-icon\" ng-if=\"purchase.product.type != 'licence'\" ui-sref=purchases({id:purchase.id})><md-tooltip md-direction=bottom>{{ \"MAKE_PAYMENT_NOW\" | translate }}</md-tooltip></a> <a class=\"fa fa-shopping-cart action-icon\" ng-if=\"purchase.product.type == 'licence'\" ui-sref=purchase_licence({id:purchase.id})><md-tooltip md-direction=bottom>{{ \"MAKE_PAYMENT_NOW\" | translate }}</md-tooltip></a> &nbsp;&nbsp; <i class=\"fa fa-close action-icon\" ng-click=\"removePending($event, purchase, index)\"><md-tooltip md-direction=bottom>{{ \"REMOVE_PENDING_ORDER\" | translate }}</md-tooltip></i></table></md-table-container></md-card-content></md-card></div></md-content></div><md-content layout-xs=column layout=row ng-if=has_company><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ \"YOU_DONT_HAVE_PERMISSION_AREA\"| translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content>";

/***/ },
/* 402 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><ma-view-actions><ma-back-button></ma-back-button></ma-view-actions><div><h1>{{ 'MANAGE_LICENCES' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-content><md-table-container><table md-table md-progress=promise><thead md-head><tr md-row><th md-column><span>{{ 'LICENCE' | translate}}</span><th md-column>{{ 'MAC' | translate}}<th md-column><span>{{ 'TYPE' | translate }}</span><th md-column md-date><span>{{ 'EXPIRATION_AT' | translate }}</span><th md-column>{{ 'PAY_STATE' | translate}}<th md-column><tbody md-body ng-repeat=\"licence in licences\"><tr md-row md-select=licence md-select-id=licence md-auto-select><td md-cell>{{licence.licence}}<td md-cell>{{licence.identifier}} &nbsp; <i class=\"fa fa-question-circle text-primary action-icon\" ng-if=licence.identifier><md-tooltip md-direction=bottom><strong>IP:</strong> {{ licence.ip }} | <strong>{{ \"UPDATED\" | translate }}:</strong> {{ licence.updated | date : \"dd.MM.yyyy\"}}</md-tooltip></i> <i class=\"fa fa-refresh action-icon\" ng-if=licence.identifier ng-click=\"removeIdentifier($event, licence)\"><md-tooltip md-direction=bottom>{{ \"REVOKE_MAC_LICENCE\" | translate }}</md-tooltip></i><td md-cell>{{licence.type.name}} <i ng-if=licence.promo>(PROMO)</i><td md-cell md-date>{{licence.finalized | date : \"dd.MM.yyyy\"}}<td md-cell>{{licence.purchase.paypal_status | translate}} <i class=\"fa fa-question-circle text-primary action-icon\" ng-if=licence.purchase.paypal_status><md-tooltip md-direction=bottom>{{licence.purchase.paypal_status + '_help' | translate}}</md-tooltip></i><td md-cell><i class=\"fa fa-eye action-icon\" ng-click=\"toggle_invoices($event, licence)\"><md-tooltip md-direction=bottom>{{ \"SHOW_INVOICES\" | translate }}</md-tooltip></i> <i class=\"fa fa-close action-icon\" ng-click=\"cancel_subscription($event, licence)\" ng-if=\"['recurring_payment_profile_created', 'recurring_payment'].indexOf(licence.purchase.paypal_status) != -1 \"><md-tooltip md-direction=bottom>{{ \"CANCEL_SUBSCRIPTION\" | translate }}</md-tooltip></i> <a class=\"fa fa-shopping-cart action-icon\" ui-sref=purchase_licence({id:licence.purchase.id}) ng-if=\"['recurring_payment_profile_created', 'recurring_payment'].indexOf(licence.purchase.paypal_status) == -1 \"><md-tooltip md-direction=bottom>{{ \"REFRESH_SUBSCRIPTION\" | translate }}</md-tooltip></a><tr md-row ng-if=\"toggleInvoiceLicence != null && toggleInvoiceLicence == licence.licence && licenceInvoices.length\"><td colspan=7><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch class=card-invoice-licence><md-card-content><md-table-container><table md-table md-progress=promise><thead md-head><tr md-row><th md-column><span>{{ 'ORDER' | translate}}</span><th md-column><span>{{ 'NUMBER' | translate}}</span><th md-column md-date><span>{{ 'PRODUCT' | translate }}</span><th md-column>{{ 'AMOUNT' | translate}}<th md-column>{{ 'DATE' | translate}}<th md-column><tbody md-body><tr md-row md-auto-select ng-repeat=\"invoice in licenceInvoices\"><td md-cell>{{invoice.purchase.order}}<td md-cell>{{invoice.numeration}}<td md-cell>{{invoice.product_name}}<td md-cell>{{invoice.price | currency : \"€\"}}<td md-cell>{{invoice.created | date : \"dd.MM.yyyy\"}}<td md-cell style=\"white-space: nowrap\"><i class=\"fa fa-download action-icon\" ng-click=\"viewInvoice($event, invoice)\"><md-tooltip md-direction=bottom>{{ \"DOWNLOAD_INVOICE\" | translate }}</md-tooltip></i></table></md-table-container></md-card-content></md-card></div></table></md-table-container></md-card-content></md-card></div></md-content><script type=text/ng-template id=dialog-template.html><md-dialog aria-label=\"options dialog\">\n        <md-dialog-content layout-padding>\n            <h2 class=\"md-title\">{{ 'CHOOSE_AN_USER' | translate}}</h2>\n            <md-select ng-model=\"user_reassign\" placeholder=\"{{ 'SELECT_AN_USER' | translate}}\">\n                <md-option ng-value=\"user.id\" ng-repeat=\"user in users\">{{user.name}} {{user.surname}}</md-option>\n            </md-select>\n        </md-dialog-content>\n        <md-dialog-actions>\n            <span flex></span>\n            <md-button ng-click=\"close()\">{{ 'REASSIGN' | translate}}!</md-button>\n        </md-dialog-actions>\n    </md-dialog></script>";

/***/ },
/* 403 */
/***/ function(module, exports) {

	module.exports = "<div class=background></div><div layout=column layout-align=\"center center\" class=loading-wrapper><div class=loading></div></div>";

/***/ },
/* 404 */
/***/ function(module, exports) {

	module.exports = "<div class=background></div><nav class=\"navbar navbar-primary navbar-transparent navbar-absolute\"><div class=container><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navigation-mobil ng-click=menu()><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><brand-home></brand-home></div><div class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav navbar-right\"><li><language-switcher></language-switcher></li><li><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> <span class=roboto>{{ 'REGISTER' | translate}}</span></md-button></li><li class=active><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> <span class=roboto>{{ 'LOGIN' | translate}}</span></md-button></li></ul></div></div></nav><div class=\"content wrapper-full-page\"><div class=container><div class=row><div class=\"col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3\"><form name=form ng-submit=login() role=form><div class=\"card card-login\"><div class=\"card-header text-center\" data-background-color=rose><h1 class=card-title layout=row layout-align=\"center center\"><a class=\"navbar-brand robotolight\">{{ 'LOGIN' | translate}}</a></h1></div><div class=card-content><md-input-container class=md-block><md-icon style=display:inline-block><i class=\"fa fa-user fa-2x\"></i></md-icon><label>{{ 'USERNAME_OR_EMAIL' | translate }}</label><input name=username ng-model=username required><div ng-messages=form.username.$error><div ng-message=required>{{ 'USERNAME_EMAIL_RECOVERY' | translate}}</div></div></md-input-container><div class=\"form-group label-floating is-empty\"><md-input-container class=md-block><md-icon style=display:inline-block><i class=\"fa fa-lock fa-2x\"></i></md-icon><label>{{ 'PASSWORD' | translate}}</label><input type=password name=password ng-model=password required><div ng-messages=form.username.$error><div ng-message=required>{{ 'PASSWORD_REQUIRED' | translate}}</div></div></md-input-container></div></div><div class=\"footer text-center\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\">{{ 'LETS_GO' | translate}}</md-button></div><div class=\"footer text-center recovery\"><md-button ui-sref=recovery>{{ 'RECOVERY_PASSWORD' | translate}}</md-button></div><div class=\"separator text-center or\"><span>{{ 'OR' | translate}}</span></div><div class=\"footer text-center recovery\"><md-button ui-sref=register>{{ 'LOGIN_REGISTER' | translate}}</md-button></div></div><div class=\"col-md-12 text-center\"><div class=social-line><md-button ng-href=\"https://www.facebook.com/BrainVT/\" target=_blank aria-label=\"\"><i class=\"fa fa-facebook-square\"></i></md-button><md-button ng-href=https://twitter.com/brainvt target=_blank aria-label=\"\"><i class=\"fa fa-twitter\"></i></md-button><md-button ng-href=\"https://www.linkedin.com/company/brainvt?trk=biz-companies-cym\" target=_blank aria-label=\"\"><i class=\"fa fa-linkedin\"></i></md-button></div></div></form></div></div></div></div><footer class=footer><div class=container><p class=\"copyright pull-right\">©{{ year }} <a href=http://www.brainvt.com>BrainVT</a></p></div></footer><div class=visible-xs><div class=\"collapse navbar-collapse off-canvas-sidebar collapse\" id=navigation-mobil><ul class=\"nav navbar-nav navbar-right\"><li><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> {{ 'REGISTER' | translate}}</md-button></li><li class=active><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> {{ 'LOGIN' | translate}}</md-button></li></ul></div></div>";

/***/ },
/* 405 */
/***/ function(module, exports) {

	module.exports = "<div layout=row><md-sidenav class=\"md-sidenav-left md-whiteframe-z1\" md-component-id=left md-is-locked-open=\"$mdMedia('gt-sm') && aside\"><md-toolbar md-scroll-shrink><div class=md-toolbar-tools><h1 layout=row layout-align=\"center center\"><brand-home layout=row layout-align=\"center center\" class=brand-home></brand-home></h1></div></md-toolbar><md-content role=navigation ng-controller=menuController><ul class=side-menu><li ng-repeat=\"item in ::appController.menu._children\" class=parent-list-item ng-class=\"{'parentActive' : isParentActive(item)}\"><menu-link item=item ng-if=!item._children[0]></menu-link><menu-toggle item=item ng-if=item._children[0]></menu-toggle></li></ul></md-content><div class=sidebar-background></div></md-sidenav><md-content flex class=content><span compile=::appController.header></span><div ui-view></div></md-content></div>";

/***/ },
/* 406 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'Options' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><form name=form ng-submit=save() role=form novalidate><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text layout=row layout-align=\"space-between center\"><span class=md-headline>Promo</span><md-switch ng-model=promo.enabled>Activar promo</md-switch></md-card-title-text></md-card-title><md-card-content ng-class=\"{ 'hidden' : !promo.enabled}\"><h4>Texto botón promo</h4><div layout=row><md-input-container flex=33><label>Castellano</label><input ng-model=promo.text.es></md-input-container><md-input-container flex=33><label>Catalán</label><input ng-model=promo.text.ca></md-input-container><md-input-container flex=33><label>Inglés</label><input ng-model=promo.text.en></md-input-container></div><h4>Producto (licencia) para la promo</h4><md-autocomplete md-selected-item=promo.product md-search-text-change=searchTextChange(searchText) md-search-text=searchText md-selected-item-change=selectedItemChange(item) md-items=\"item in querySearch(searchText)\" md-item-text=item.name md-min-length=0 placeholder=\"Selecciona un producto tipo licencia\"><md-item-template><span md-highlight-text=searchText md-highlight-flags=^i>{{item.name}}</span></md-item-template><md-not-found>No se encontraron productos \"{{searchText}}\"</md-not-found></md-autocomplete><h4>Duración de la promo</h4><md-datepicker ng-model=promo.duration md-placeholder=\"Select limit date\"></md-datepicker><h4>Tiempo de la licencia</h4><md-select ng-model=promo.licence><md-option ng-repeat=\"day in days\" ng-value=day.value>{{day.label}}</md-option></md-select></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\">{{ \"Save\" | translate }}</md-button></md-card-actions></md-card></div></md-content></form>";

/***/ },
/* 407 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'THANK_YOU' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'THE_PURCHASE_WAS_MADE_CORRECTLY' | translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content>";

/***/ },
/* 408 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'ERROR' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'COULD_NOT_COMPLETE_PURCHASE' | translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content>";

/***/ },
/* 409 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'THANK_YOU' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'THE_PURCHASE_WAS_MADE_CORRECTLY' | translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content>";

/***/ },
/* 410 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><ma-view-actions><ma-back-button></ma-back-button></ma-view-actions><div><h1>{{ 'PROFILE' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><form name=form ng-submit=register() role=form novalidate><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'ACCOUNT' | translate}}</span></md-card-title-text></md-card-title><md-divider></md-divider><md-card-content><md-input-container class=md-block><label>{{ 'EMAIL' | translate }}</label><input type=email name=email ng-model=email required><div ng-messages=form.email.$error><div ng-message=required>{{ 'EMAIL_REQUIRED' | translate }}.</div><div ng-message=email>{{ 'EMAIL_NOT_VALID' | translate }}.</div><div ng-message=exists>{{ 'EMAIL_ALREADY_TAKEN' | translate }}</div></div></md-input-container></md-card-content><md-card-actions layout=row layout-align=\"end center\"><a type=submit class=\"submit md-button md-raised md-warn\" ui-sref=change-password>{{ 'CHANGE_PASSWORD'| translate }}</a></md-card-actions></md-card><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline ng-if=\"type == 'patient' || type == 'prescriber'\">{{ 'USER' | translate}}</span> <span class=md-headline ng-if=\"type == 'company'\">{{ 'COMPANY' | translate}}</span></md-card-title-text></md-card-title><md-divider></md-divider><md-card-content><div ng-if=\"type == 'patient' || type == 'prescriber'\"><md-input-container class=md-block><label>{{ 'NAME' | translate}}</label><input name=name ng-model=$parent.name required><div ng-messages=form.name.$error><div ng-message=required>{{ 'NAME_REQUIRED' | translate}}.</div></div></md-input-container><md-input-container class=md-block><label>{{ 'SURNAME' | translate}}</label><input name=surname ng-model=$parent.surname required><div ng-messages=form.surname.$error><div ng-message=required>{{ 'SURNAME_REQUIRED' | translate}}.</div></div></md-input-container></div><div ng-if=\"type == 'patient'\"><md-input-container class=md-block><label>{{ 'BIRTHDAY' | translate}}</label><md-datepicker name=birthday ng-model=$parent.birthday md-current-view=year md-hide-icons=calendar md-open-on-focus=true md-max-date=maxdate required></md-datepicker><div ng-messages=form.birthday.$error><div ng-message=required>{{ 'BIRTHDAY_REQUIRED' | translate}}.</div></div></md-input-container></div><md-input-container class=md-block ng-if=\"type == 'prescriber'\"><label>{{ 'PRESCRIBER_TYPE' | translate}}</label><md-select ng-model=$parent.prescriberType required><md-option ng-repeat=\"type in prescriberTypes\" value={{type.id}}>{{type.label}}</md-option></md-select><div class=md-errors-spacer></div><div ng-messages=form.precriberType.$error><div ng-message=required>{{ 'PRESCRIBER_TYPE_REQUIRED' | translate}}.</div></div></md-input-container><div ng-if=\"type && type != 'patient'\"><md-input-container class=md-block><label>{{ 'COMPANY' | translate}}</label><input name=company ng-model=$parent.name required><div ng-messages=form.company.$error><div ng-message=required>{{ 'COMPANY_REQUIRED' | translate}}.</div></div></md-input-container><md-input-container class=md-block><label>{{ 'CIF/NIF' | translate}}</label><input name=cif ng-model=$parent.cif required><div ng-messages=form.cif.$error><div ng-message=required>{{ 'CIF_NIF_REQUIRED' | translate}}.</div></div></md-input-container><md-input-container class=md-block><label>{{ 'ADDRESS' | translate}}</label><input name=address ng-model=$parent.address required><div ng-messages=form.address.$error><div ng-message=required>{{ 'ADDRESS_REQUIRED' | translate}}.</div></div></md-input-container><div layout-gt-sm=row class=md-block><md-input-container class=md-block flex-gt-sm><label>{{ 'POSTAL_CODE' | translate}}</label><input name=postalCode ng-model=$parent.postalCode placeholder=12345 required ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=5 required><div ng-messages=form.postalCode.$error role=alert multiple><div ng-message=required class=my-message>{{ 'YOU_SUPPLY_POSTAL_CODE' | translate}}.</div><div ng-message=pattern class=my-message>{{ 'THAT_DOESNT_LOOK_LIKE_VALID_PC' | translate}} code.</div><div ng-message=md-maxlength class=my-message>{{ 'DONT_LONG_VERSION_SILLY' | translate}}...</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ 'CITY' | translate}}</label><input name=city ng-model=$parent.city required></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ 'STATE' | translate}}</label><md-select name=state ng-model=$parent.state required><md-option ng-repeat=\"state in states\" value={{state.id}}>{{state.name}}</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\">{{ 'UPDATE_MY_DATA'| translate }}</md-button></md-card-actions></md-card></form>";

/***/ },
/* 411 */
/***/ function(module, exports) {

	module.exports = "<div class=background></div><nav class=\"navbar navbar-primary navbar-transparent navbar-absolute\" id=navbar><div class=container><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navigation-mobil ng-click=menu()><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a href=http://www.brainvt.com class=logo></a></div><div class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav navbar-right\"><li><language-switcher></language-switcher></li><li class=active><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> <span class=roboto>{{ 'REGISTER' | translate}}</span></md-button></li><li><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> <span class=roboto>{{ 'LOGIN' | translate}}</span></md-button></li></ul></div></div></nav><div class=\"content wrapper-full-page\"><div class=container><div class=row><div class=\"col-md-10 col-md-offset-1\"><div class=\"card card-signup\"><h2 class=\"card-title text-center\">{{ \"PROMO_REGISTER\" | translate }}</h2><form name=form ng-submit=register() role=form novalidate><div class=row><div class=\"col-md-10 col-md-offset-1\"><div class=card-content><h4>{{ \"ACCOUNT\" | translate }}</h4><md-input-container class=md-block><label>{{ \"USERNAME_OR_EMAIL\" | translate }}</label><input name=username ng-model=username required><div ng-messages=form.username.$error><div ng-message=required>{{ \"USERNAME_REQUIRED\" | translate }}.</div><div ng-message=exists>{{ \"USERNAME_ALREADY_TAKEN\" | translate }}.</div></div><div class=hint ng-if=\"!form.username.$dirty || !form.username.$invalid\">{{ 'USERNAME_REASON' | translate}}</div></md-input-container><md-input-container class=md-block><label>{{ \"NAME\" | translate }}</label><input name=name ng-model=$parent.name required><div ng-messages=form.name.$error><div ng-message=required>{{ \"NAME_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"SURNAME\" | translate }}</label><input name=surname ng-model=$parent.surname required><div ng-messages=form.surname.$error><div ng-message=required>{{ \"SURNAME_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block ng-if=\"type == 'prescriber'\"><label>{{ \"PRESCRIBER_TYPE\" | translate }}</label><md-select ng-model=$parent.precriberType required><md-option ng-repeat=\"type in prescriberTypes\" value={{type.id}}>{{type.label}}</md-option></md-select><div class=md-errors-spacer></div><div ng-messages=form.precriberType.$error><div ng-message=required>{{ \"PRESCRIBER_TYPE_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"COMPANY\" | translate }}</label><input name=company ng-model=$parent.company required><div ng-messages=form.company.$error><div ng-message=required>{{ \"COMPANY_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"CIF/NIF\" | translate }}</label><input name=cif ng-model=$parent.cif required><div ng-messages=form.cif.$error><div ng-message=required>{{ \"CIF_NIF_REQUIRED\" | translate }}.</div><div ng-message=exists>{{ \"CIF_NIF_ALREADY_EXISTS\" | translate }}.</div><div ng-message=invalid>{{ \"CIF_NIF_INVALID\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"PHONE\" | translate }}</label><input name=phone ng-model=$parent.phone required><div ng-messages=form.phone.$error><div ng-message=required>{{ \"PHONE_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"ADDRESS\" | translate }}</label><input name=address ng-model=$parent.address required><div ng-messages=form.address.$error><div ng-message=required>{{ \"ADDRESS_REQUIRED\" | translate }}.</div></div></md-input-container><div layout-gt-sm=row class=md-block><md-input-container class=md-block flex-gt-sm><label>{{ \"POSTAL_CODE\" | translate }}</label><input name=postalCode ng-model=$parent.postalCode placeholder=12345 required ng-pattern=\"/^[0-9]{5}$/\"><div ng-messages=form.postalCode.$error role=alert multiple><div ng-message=required class=my-message>{{ \"YOU_SUPPLY_POSTAL_CODE\" | translate }}.</div><div ng-message=pattern class=my-message>{{ \"THAT_DOESNT_LOOK_LIKE_VALID_PC\" | translate }}.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ \"CITY\" | translate }}</label><input name=city ng-model=$parent.city required><div ng-messages=form.postalCode.$error role=alert multiple><div ng-message=required class=my-message>{{ \"CITY_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ \"STATE\" | translate }}</label><md-select name=state ng-model=$parent.state require><md-option ng-repeat=\"state in states\" value={{state.id}}>{{state.name}}</md-option></md-select></md-input-container></div><div class=text-center><md-input-container class=md-block><md-checkbox name=tos ng-model=tos required><a onclick=\"window.open('/aviso-legal')\" ng-click=$event.stopPropagation()>{{ \"ACCEPT_TERMS_SERVICE\" | translate }}.</a></md-checkbox><div ng-messages=form.tos.$error multiple md-auto-hide=false><div ng-message=required>{{ \"YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED\" | translate }}.</div></div></md-input-container><div class=\"footer text-center\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\">{{ \"LETS_GO\" | translate }}</md-button></div></div></div></div></div></form></div></div></div></div></div><footer class=footer><div class=container><p class=\"copyright pull-right\">©{{ year }} <a href=http://www.brainvt.com>BrainVT</a></p></div></footer><div class=visible-xs><div class=\"collapse navbar-collapse off-canvas-sidebar collapse\" id=navigation-mobil><ul class=\"nav navbar-nav navbar-right\"><li class=active><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> {{ \"REGISTER\" | translate }}</md-button></li><li><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> {{ \"LOGIN\" | translate }}</md-button></li></ul></div></div>";

/***/ },
/* 412 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><ma-view-actions><ma-back-button></ma-back-button></ma-view-actions><div><h1>{{ 'PURCHASES' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row ng-repeat=\"(key, type) in types\" ng-if=!has_company data-ng-init=gotoAnchor()><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch id=\"{{ key }}\"><form name=form ng-submit=buy($event) role=form novalidate ng-controller=purchaseLicenceBlockController><md-card-title><md-card-title-text><span class=md-headline>{{ type.name | translate}}</span> <small ng-if=\"type.name == 'LICENCES'\">{{ 'LICENCES_TEXT' | translate }}</small></md-card-title-text></md-card-title><md-divider></md-divider><md-card-content><div><div><md-input-container class=md-block><div layout=row layout-padding><div flex=100><md-input-container class=\"md-block promotional\"><label>{{ 'PROMOTIONAL_CODE' | translate }}</label><input name=promotion ng-model=promotion ng-keypress=validateCodeEnter($event) ng-change=validateCodeChange()><div ng-messages=form.promotion.$error><div ng-message=no>{{ 'CODE_DOES_NOT_PROMOTION' | translate}}</div></div></md-input-container></div></div><h3 class=text-center>Selecciona un producto</h3><div class=products layout-gt-xs=row layout-align=\"space-around none\" layout-wrap ng-class=\"{selected: product}\"><a ng-repeat=\"p in licences\" ng-hide=p.promotional ng-click=setProduct(p) ng-class=\"{active: p.id === product}\"><div flex class=image ng-if=p.image><div class=product_logo layout=row layout-align=\"center center\"><img src=\"{{ $parent.image_path }}{{ p.image }}\" style=max-width:100% flex></div></div><div class=title>{{p.name}}</div><div class=description>{{p.description}}</div></a></div><h3 class=text-center ng-if=product>Selecciona una mensualidad</h3><div class=subs layout-gt-xs=row layout-align=\"center center\" ng-if=product ng-class=\"{selected: sub}\" layout-margin><a ng-click=setSub(12) ng-class=\"{active: sub === 12}\"><div layout=column><h3>{{ 'BILLED_YEARLY' | translate}}</h3><span class=save>{{ 'YEAR_SAVE' | translate}}<br>{{ year_save }}%</span><div class=price layout=row layout-align=\"center end\"><span class=big>{{ year_big }}</span><span><strong>,{{ year_small }}€</strong><br>x 12 {{ 'MOTNH' | translate}}</span></div><md-button class=\"submit md-raised md-primary\">{{ 'SELECT' | translate}}</md-button><small><strong>{{ year_total | currency:\"€\"}}</strong> / {{ 'YEAR' | translate}}</small></div></a> <span class=or>{{ 'OR' | translate}}</span> <a ng-click=setSub(1) ng-class=\"{active: sub === 1}\"><div layout=column><h3>{{ 'BILLED_MONTHLY' | translate}}</h3><div class=price layout=row layout-align=\"center end\"><span class=big>{{ month_big }}</span><span><strong>,{{ month_small }}€</strong><br>/{{ 'MOTNH' | translate}}<span></span></span></div><md-button class=\"submit md-raised md-primary\">{{ 'SELECT' | translate}}</md-button><small><strong>{{ month_total | currency:\"€\"}}</strong> / {{ 'YEAR' | translate}}</small></div></a></div><div ng-messages=form.product.$error><div ng-message=required>{{ 'SELECT_PRODUCT' | translate }}</div></div></md-input-container></div></div><md-input-container class=md-block ng-if=sub><md-radio-group ng-model=$parent.invoice_data><md-radio-button value=user class=md-primary>{{ \"USE_MY_ACCOUNT_INFORMATION_INVOICE\" | translate }}&nbsp;&nbsp;&nbsp;&nbsp;<small class=text-primary>({{ data }})</small></md-radio-button><md-radio-button value=other class=md-primary>{{ \"USE_OTHER_INFORMATION_INVOICE\" | translate }}</md-radio-button></md-radio-group></md-input-container><div ng-if=\"invoice_data == 'other'\"><md-input-container class=md-block><label>{{ \"NAME\" | translate }}</label><input name=name ng-model=$parent.name required><div ng-messages=form.name.$error><div ng-message=required>{{ \"NAME_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"SURNAME\" | translate }}</label><input name=surname ng-model=$parent.surname required><div ng-messages=form.surname.$error><div ng-message=required>{{ \"SURNAME_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"COMPANY\" | translate }}</label><input name=company ng-model=$parent.company></md-input-container><md-input-container class=md-block><label>{{ \"CIF/NIF\" | translate }}</label><input name=cif ng-model=$parent.cif required><div ng-messages=form.cif.$error><div ng-message=required>{{ \"CIF_NIF_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"ADDRESS\" | translate }}</label><input name=address ng-model=$parent.address required><div ng-messages=form.address.$error><div ng-message=required>{{ \"COMPANY_REQUIRED\" | translate }}.</div></div></md-input-container><div layout-gt-sm=row class=md-block><md-input-container class=md-block flex-gt-sm><label>{{ \"POSTAL_CODE\" | translate }}</label><input name=postalCode ng-model=$parent.postalCode placeholder=12345 required ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=5 required><div ng-messages=form.postalCode.$error role=alert multiple><div ng-message=required class=my-message>{{ \"YOU_SUPPLY_POSTAL_CODE\" | translate }}.</div><div ng-message=pattern class=my-message>{{ \"THAT_DOESNT_LOOK_LIKE_VALID_PC\" | translate }}.</div><div ng-message=md-maxlength class=my-message>{{ \"DONT_LONG_VERSION_SILLY\" | translate }}...</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ \"CITY\" | translate }}</label><input name=city ng-model=$parent.city required></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ \"STATE\" | translate }}</label><md-select name=state ng-model=$parent.state required><md-option ng-repeat=\"state in states\" value={{state.id}}>{{state.name}}</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout-gt-xs=row layout-align-gt-xs=\"end start\" ng-if=sub><div flex-gt-xs=50><div layout=column layout-margin layout-fill layout-align=\"center none\" style=\"padding: 0 20px\"><div layout=row><div flex=50 class=text-right>{{ 'TOTAL_ITEMS' | translate }}:</div><div flex=40 flex-offset=10>{{ total | currency:\"€\"}}</div></div><div layout=row><div flex=50 class=text-right>{{ 'TAXES' | translate }}:</div><div flex=40 flex-offset=10>{{ taxes | currency:\"€\"}}</div></div><div layout=row><div flex=50 class=text-right>{{ 'AMOUNT_PAYABLE' | translate }}:</div><div flex=40 flex-offset=10>{{ total_taxes | currency:\"€\"}}</div></div></div></div><div layout=column flex-gt-xs=50 id=pay><md-input-container class=md-block style=\"padding: 0 20px; margin-top: 0\"><md-radio-group name=method ng-model=$parent.method required><md-radio-button value=paypal class=md-primary><i class=\"fa fa-paypal\"></i> {{ \"PAY_WITH_PAYPAL\" | translate }}</md-radio-button><md-radio-button value=credit_card class=md-primary disabled><i class=\"fa fa-credit-card-alt\"></i> {{ \"PAY_WITH_CREDIT_CARD\" | translate }}</md-radio-button><md-radio-button value=wire class=md-primary disabled><i class=\"fa fa-bank\"></i> {{ \"PAY_WITH_WIRE_TRANSFER\" | translate }}</md-radio-button></md-radio-group><div ng-messages=form.method.$error><div ng-message=required>{{ \"SELECT_METHOD\" | translate }}</div></div></md-input-container><div style=\"padding: 0 20px\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading || isBuy\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\"><i class=\"fa fa-shopping-cart\"></i> {{ 'BUY_SUSCRIPTIONS' | translate }}</md-button></div></div></md-card-actions><md-card-actions id=modal-pay layout=row layout-margin layout-padding layout-align=\"center center\" ng-if=\"order && method == 'wire'\"><div flex=60 class=\"text-center text-primary\"><h3>{{ 'BUY_SUCCESS' | translate }}</h3>{{ 'YOU_MUST_MAKE_BANK_TRANSFER' | translate }} <strong>{{ iban }}</strong><br>{{ 'WITH_THE_CONCEPT' | translate}}: <strong>{{ 'ORDER' | translate}} {{ order }}</strong></div></md-card-actions></form></md-card></div></md-content><md-content layout-xs=column layout=row ng-if=has_company><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ \"YOU_DONT_HAVE_PERMISSION_AREA\"| translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content><form name=from id=visa action=\"\" method=POST><input type=hidden name=Ds_SignatureVersion id=version value=\"HMAC_SHA256_V1\"> <input type=hidden name=Ds_MerchantParameters id=\"params\"> <input type=hidden name=Ds_Signature id=\"signature\"></form>";

/***/ },
/* 413 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'ERROR' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'COULD_NOT_COMPLETE_PURCHASE' | translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content>";

/***/ },
/* 414 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div><h1>{{ 'THANK_YOU' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ 'THE_PURCHASE_WAS_MADE_CORRECTLY' | translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content>";

/***/ },
/* 415 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><ma-view-actions><ma-back-button></ma-back-button></ma-view-actions><div><h1>{{ 'PURCHASES' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content ng-if=!types><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ \"NO_LICENCE\" | translate}}</span> <small><a ui-sref=purchase_licence>{{ 'NO_LICENCE_BUY' | translate }}</a></small></md-card-title-text></md-card-title></md-card></div></md-content><md-content layout-xs=column layout=row ng-repeat=\"(key, type) in types\" ng-if=!has_company data-ng-init=gotoAnchor()><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch id=\"{{ key }}\"><form name=form ng-submit=buy($event) role=form novalidate ng-controller=purchaseBlockController><md-card-title><md-card-title-text><span class=md-headline>{{ type.name | translate}}</span> <small ng-if=\"type.name == 'LICENCES'\">{{ 'LICENCES_TEXT' | translate }}</small></md-card-title-text></md-card-title><md-divider></md-divider><md-card-content><div layout-gt-xs=row><div flex-gt-xs=50><md-input-container class=md-block><div layout=row layout-padding><div flex=100><md-input-container class=md-block><label>{{ 'PROMOTIONAL_CODE' | translate }}</label><input name=promotion ng-model=promotion ng-keypress=validateCodeEnter($event) ng-change=validateCodeChange()><div ng-messages=form.promotion.$error><div ng-message=no>{{ 'CODE_DOES_NOT_PROMOTION' | translate}}</div></div></md-input-container></div></div><md-radio-group ng-model=product required><div ng-if=\"key == 'licence'\" ng-repeat=\"product in licences\" ng-hide=product.promotional class=row><div flex layout=row layout-padding layout-align=\"start center\"><div flex style=max-width:100px ng-if=product.image><div class=product_logo layout=row layout-align=\"center center\"><img src=\"{{ $parent.image_path }}{{ product.image }}\" style=max-width:100% flex></div></div><md-radio-button flex ng-value=product.id class=\"md-primary no-margin\"><div class=title>{{product.name}}</div><small class=price>{{ product.price | currency:\"€\"}}</small></md-radio-button></div></div><div ng-if=\"key == 'subscription'\" ng-repeat=\"product in subscriptions\" ng-hide=product.promotional class=row><div flex layout=row layout-padding layout-align=\"start center\"><div flex style=max-width:100px ng-if=product.image><div class=product_logo layout=row layout-align=\"center center\"><img src=\"{{ $parent.image_path }}{{ product.image }}\" style=max-width:100% flex></div></div><md-radio-button flex ng-value=product.id class=\"md-primary no-margin\"><div class=title>{{product.name}}</div><small class=price>{{ product.price | currency:\"€\"}} - ({{ 'UNIT_PRICE' | translate }} {{ product.price/product.units | currency:\"€\"}})</small></md-radio-button></div></div><div ng-if=\"key == 'game'\" ng-repeat=\"product in games\" ng-hide=product.promotional class=row><div flex layout=row layout-padding layout-align=\"start center\"><div flex style=max-width:100px ng-if=product.image><div class=product_logo layout=row layout-align=\"center center\"><img src=\"{{ $parent.image_path }}{{ product.image }}\" style=max-width:100% flex></div></div><md-radio-button flex ng-value=product.id class=\"md-primary no-margin\"><div class=title>{{product.name}}</div><small class=price>{{ product.price | currency:\"€\"}}</small></md-radio-button></div></div></md-radio-group><div ng-messages=form.product.$error><div ng-message=required>{{ 'SELECT_PRODUCT' | translate }}</div></div></md-input-container></div><div flex-gt-xs=40 flex-offset-gt-xs=10><div layout=column layout-margin layout-fill layout-align=\"center none\"><div layout=row><div flex=50 class=text-right>{{ 'TOTAL_ITEMS' | translate }}:</div><div flex=40 flex-offset=10>{{ total | currency:\"€\"}}</div></div><div layout=row><div flex=50 class=text-right>{{ 'TAXES' | translate }}:</div><div flex=40 flex-offset=10>{{ taxes | currency:\"€\"}}</div></div><div layout=row><div flex=50 class=text-right>{{ 'AMOUNT_PAYABLE' | translate }}:</div><div flex=40 flex-offset=10>{{ total_taxes | currency:\"€\"}}</div></div></div></div></div><md-input-container class=md-block><md-radio-group ng-model=invoice_data><md-radio-button value=user class=md-primary>{{ \"USE_MY_ACCOUNT_INFORMATION_INVOICE\" | translate }}&nbsp;&nbsp;&nbsp;&nbsp;<small class=text-primary>({{ data }})</small></md-radio-button><md-radio-button value=other class=md-primary>{{ \"USE_OTHER_INFORMATION_INVOICE\" | translate }}</md-radio-button></md-radio-group></md-input-container><div ng-if=\"invoice_data == 'other'\"><md-input-container class=md-block><label>{{ \"NAME\" | translate }}</label><input name=name ng-model=$parent.name required><div ng-messages=form.name.$error><div ng-message=required>{{ \"NAME_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"SURNAME\" | translate }}</label><input name=surname ng-model=$parent.surname required><div ng-messages=form.surname.$error><div ng-message=required>{{ \"SURNAME_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"COMPANY\" | translate }}</label><input name=company ng-model=$parent.company></md-input-container><md-input-container class=md-block><label>{{ \"CIF/NIF\" | translate }}</label><input name=cif ng-model=$parent.cif required><div ng-messages=form.cif.$error><div ng-message=required>{{ \"CIF_NIF_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"ADDRESS\" | translate }}</label><input name=address ng-model=$parent.address required><div ng-messages=form.address.$error><div ng-message=required>{{ \"COMPANY_REQUIRED\" | translate }}.</div></div></md-input-container><div layout-gt-sm=row class=md-block><md-input-container class=md-block flex-gt-sm><label>{{ \"POSTAL_CODE\" | translate }}</label><input name=postalCode ng-model=$parent.postalCode placeholder=12345 required ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=5 required><div ng-messages=form.postalCode.$error role=alert multiple><div ng-message=required class=my-message>{{ \"YOU_SUPPLY_POSTAL_CODE\" | translate }}.</div><div ng-message=pattern class=my-message>{{ \"THAT_DOESNT_LOOK_LIKE_VALID_PC\" | translate }}.</div><div ng-message=md-maxlength class=my-message>{{ \"DONT_LONG_VERSION_SILLY\" | translate }}...</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ \"CITY\" | translate }}</label><input name=city ng-model=$parent.city required></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ \"STATE\" | translate }}</label><md-select name=state ng-model=$parent.state required><md-option ng-repeat=\"state in states\" value={{state.id}}>{{state.name}}</md-option></md-select></md-input-container></div></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><div layout=column flex=50 style=max-width:200px><md-input-container class=md-block><md-radio-group name=method ng-model=method required><md-radio-button value=paypal class=md-primary disabled><i class=\"fa fa-paypal\"></i> {{ \"PAY_WITH_PAYPAL\" | translate }}</md-radio-button><md-radio-button value=credit_card class=md-primary><i class=\"fa fa-credit-card-alt\"></i> {{ \"PAY_WITH_CREDIT_CARD\" | translate }}</md-radio-button><md-radio-button value=wire class=md-primary><i class=\"fa fa-bank\"></i> {{ \"PAY_WITH_WIRE_TRANSFER\" | translate }}</md-radio-button></md-radio-group><div ng-messages=form.method.$error><div ng-message=required>{{ \"SELECT_METHOD\" | translate }}</div></div></md-input-container><md-button type=submit ng-disabled=\"form.$invalid || dataLoading || isBuy\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\"><i class=\"fa fa-shopping-cart\"></i> {{ 'BUY_SUSCRIPTIONS' | translate }}</md-button></div></md-card-actions><md-card-actions id=modal-pay layout=row layout-margin layout-padding layout-align=\"center center\" ng-if=\"order && method == 'wire'\"><div flex=60 class=\"text-center text-primary\"><h3>{{ 'BUY_SUCCESS' | translate }}</h3>{{ 'YOU_MUST_MAKE_BANK_TRANSFER' | translate }} <strong>{{ iban }}</strong><br>{{ 'WITH_THE_CONCEPT' | translate}}: <strong>{{ 'ORDER' | translate}} {{ order }}</strong></div></md-card-actions></form></md-card></div></md-content><md-content layout-xs=column layout=row ng-if=has_company><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-title><md-card-title-text><span class=md-headline>{{ \"YOU_DONT_HAVE_PERMISSION_AREA\"| translate}}</span></md-card-title-text></md-card-title></md-card></div></md-content><form name=from id=visa action=\"\" method=POST><input type=hidden name=Ds_SignatureVersion id=version value=\"HMAC_SHA256_V1\"> <input type=hidden name=Ds_MerchantParameters id=\"params\"> <input type=hidden name=Ds_Signature id=\"signature\"></form>";

/***/ },
/* 416 */
/***/ function(module, exports) {

	module.exports = "<div class=background></div><nav class=\"navbar navbar-primary navbar-transparent navbar-absolute\"><div class=container><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navigation-mobil ng-click=menu()><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><brand-home></brand-home></div><div class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav navbar-right\"><li><language-switcher></language-switcher></li><li><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> <span class=roboto>{{ 'REGISTER' | translate}}</span></md-button></li><li class=active><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> <span class=roboto>{{ 'LOGIN' | translate}}</span></md-button></li></ul></div></div></nav><div class=\"content wrapper-full-page\"><div class=container><div class=row><div class=\"col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3\"><form name=form ng-submit=recovery() role=form><div class=\"card card-login\"><h2 class=\"card-title text-center\">{{ \"RECOVERY_PASSWORD\" | translate }}</h2><div class=card-content><md-input-container class=md-block><md-icon style=display:inline-block><i class=\"fa fa-user fa-2x\"></i></md-icon><label>{{ \"USERNAME_OR_EMAIL\" | translate }}</label><input name=alias ng-model=alias required><div ng-messages=form.alias.$error><div ng-message=required>{{ \"USERNAME_EMAIL_RECOVERY\" | translate }}</div></div></md-input-container></div><div class=\"footer text-center\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\">{{ 'LETS_GO' | translate}}</md-button></div><div class=\"footer text-center recovery\"><md-button ui-sref=login>{{ \"SIGN_IN_AGAIN\" | translate }}</md-button></div></div><div class=\"col-md-12 text-center\"><div class=social-line><md-button ng-href=\"https://www.facebook.com/BrainVT/\" target=_blank aria-label=\"\"><i class=\"fa fa-facebook-square\"></i></md-button><md-button ng-href=https://twitter.com/brainvt target=_blank aria-label=\"\"><i class=\"fa fa-twitter\"></i></md-button><md-button ng-href=\"https://www.linkedin.com/company/brainvt?trk=biz-companies-cym\" target=_blank aria-label=\"\"><i class=\"fa fa-linkedin\"></i></md-button></div></div></form></div></div></div></div><footer class=footer><div class=container><p class=\"copyright pull-right\">©{{ year }} <a href=http://www.brainvt.com>BrainVT</a></p></div></footer><div class=visible-xs><div class=\"collapse navbar-collapse off-canvas-sidebar collapse\" id=navigation-mobil><ul class=\"nav navbar-nav navbar-right\"><li><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> {{ \"REGISTER\" | translate }}</md-button></li><li class=active><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> {{ \"LOGIN\" | translate }}</md-button></li></ul></div></div>";

/***/ },
/* 417 */
/***/ function(module, exports) {

	module.exports = "<div class=background></div><nav class=\"navbar navbar-primary navbar-transparent navbar-absolute\" id=navbar><div class=container><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navigation-mobil ng-click=menu()><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><brand-home></brand-home></div><div class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav navbar-right\"><li><language-switcher></language-switcher></li><li class=active><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> <span class=roboto>{{ 'REGISTER' | translate}}</span></md-button></li><li><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> <span class=roboto>{{ 'LOGIN' | translate}}</span></md-button></li></ul></div></div></nav><div class=\"content wrapper-full-page\"><div class=container><div class=row><div class=\"col-md-10 col-md-offset-1\"><div class=\"card card-signup\"><h2 class=\"card-title text-center\">{{ \"REGISTER\" | translate }}</h2><form name=form ng-submit=register() role=form novalidate><div class=row><div class=\"col-md-10 col-md-offset-1\"><div class=card-content><h4>{{ \"ACCOUNT\" | translate }}</h4><md-input-container class=md-block><label>{{ \"USERNAME\" | translate }}</label><input name=username ng-model=username required><div ng-messages=form.username.$error><div ng-message=required>{{ \"USERNAME_REQUIRED\" | translate }}.</div><div ng-message=exists>{{ \"USERNAME_ALREADY_TAKEN\" | translate }}.</div></div><div class=hint ng-if=\"!form.username.$dirty || !form.username.$invalid\">{{ 'USERNAME_REASON' | translate}}</div></md-input-container><md-input-container class=md-block><label>{{ \"EMAIL\" | translate }}</label><input type=email name=email ng-model=email required><div ng-messages=form.email.$error><div ng-message=required>{{ \"EMAIL_REQUIRED\" | translate }}.</div><div ng-message=email>{{ \"EMAIL_NOT_VALID\" | translate }}.</div><div ng-message=exists>{{ \"EMAIL_ALREADY_TAKEN\" | translate }}</div></div></md-input-container><md-input-container class=md-block><label>{{ \"PASSWORD\" | translate }}</label><input type=password name=plainPassword ng-model=plainPassword required><div ng-messages=form.plainPassword.$error><div ng-message=required>{{ \"PASSWORD_REQUIRED\" | translate }}.</div><div ng-message=low>{{ \"PASSWORD_SHORT\" | translate }}</div></div></md-input-container><md-input-container class=md-block><label>{{ 'CONFIRM_PASSWORD' | translate }}</label><input type=password name=confirm ng-model=confirm required><div ng-messages=form.confirm.$error><div ng-message=required>{{ 'CONFIRM_PASSWORD_REQUIRED' | translate }}.</div><div ng-message=same>{{ 'CONFIRM_PASSWORD_SAME' | translate }}</div></div></md-input-container><md-input-container class=md-block><label>{{ \"YOU_ARE\" | translate }}</label><md-select name=type ng-model=type required><md-option value=company>{{ \"COMPANY\" | translate }}</md-option><md-option value=prescriber>{{ \"PRESCRIBER\" | translate }}</md-option></md-select></md-input-container></div></div></div><div class=row><div class=\"col-md-10 col-md-offset-1\"><div class=card-content><h4 ng-if=\"type == 'patient' || type == 'prescriber'\">{{ \"USER\" | translate }}</h4><h4 ng-if=\"type == 'company'\">{{ \"COMPANY\" | translate }}</h4><div ng-if=\"type && type != 'company'\"><md-input-container class=md-block><label>{{ \"NAME\" | translate }}</label><input name=name ng-model=$parent.name required><div ng-messages=form.name.$error><div ng-message=required>{{ \"NAME_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"SURNAME\" | translate }}</label><input name=surname ng-model=$parent.surname required><div ng-messages=form.surname.$error><div ng-message=required>{{ \"SURNAME_REQUIRED\" | translate }}.</div></div></md-input-container></div><div ng-if=\"type == 'patient'\"><md-input-container class=md-block>{{ $parent.$parent.birthday }}<label>{{ \"BIRTHDAY\" | translate }}</label><md-datepicker name=birthday ng-model=$parent.birthday md-current-view=year md-hide-icons=calendar md-open-on-focus=true md-max-date=maxdate required></md-datepicker><div ng-messages=form.birthday.$error><div ng-message=required>{{ \"BIRTHDAY_REQUIRED\" | translate }}.</div></div></md-input-container></div><md-input-container class=md-block ng-if=\"type == 'prescriber'\"><label>{{ \"PRESCRIBER_TYPE\" | translate }}</label><md-select ng-model=$parent.precriberType required><md-option ng-repeat=\"type in prescriberTypes\" value={{type.id}}>{{type.label}}</md-option></md-select><div class=md-errors-spacer></div><div ng-messages=form.precriberType.$error><div ng-message=required>{{ \"PRESCRIBER_TYPE_REQUIRED\" | translate }}.</div></div></md-input-container><div ng-if=\"type && type != 'patient'\"><md-input-container class=md-block ng-if=\"type == 'company'\"><label>{{ \"COMPANY\" | translate }}</label><input name=company ng-model=$parent.$parent.company required><div ng-messages=form.company.$error><div ng-message=required>{{ \"COMPANY_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"CIF/NIF\" | translate }}</label><input name=cif ng-model=$parent.cif required><div ng-messages=form.cif.$error><div ng-message=required>{{ \"CIF_NIF_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"ADDRESS\" | translate }}</label><input name=address ng-model=$parent.address required><div ng-messages=form.address.$error><div ng-message=required>{{ \"ADDRESS_REQUIRED\" | translate }}.</div></div></md-input-container><div layout-gt-sm=row class=md-block><md-input-container class=md-block flex-gt-sm><label>{{ \"POSTAL_CODE\" | translate }}</label><input name=postalCode ng-model=$parent.postalCode placeholder=12345 required ng-pattern=\"/^[0-9]{5}$/\" required><div ng-messages=form.postalCode.$error role=alert multiple><div ng-message=required class=my-message>{{ \"YOU_SUPPLY_POSTAL_CODE\" | translate }}.</div><div ng-message=pattern class=my-message>{{ \"THAT_DOESNT_LOOK_LIKE_VALID_PC\" | translate }}.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ \"CITY\" | translate }}</label><input name=city ng-model=$parent.city required></md-input-container><md-input-container class=md-block flex-gt-sm><label>{{ \"STATE\" | translate }}</label><md-select name=state ng-model=$parent.state required><md-option ng-repeat=\"state in states\" value={{state.id}}>{{state.name}}</md-option></md-select></md-input-container></div></div><div class=text-center><md-input-container class=md-block><md-checkbox name=tos ng-model=tos required><a onclick=\"window.open('/aviso-legal')\" ng-click=$event.stopPropagation()>{{ \"ACCEPT_TERMS_SERVICE\" | translate }}.</a></md-checkbox><div ng-messages=form.tos.$error multiple md-auto-hide=false><div ng-message=required>{{ \"YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED\" | translate }}.</div></div></md-input-container><div class=\"footer text-center\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\">{{ \"LETS_GO\" | translate }}</md-button></div></div></div></div></div></form></div></div></div></div></div><footer class=footer><div class=container><p class=\"copyright pull-right\">©{{ year }} <a href=http://www.brainvt.com>BrainVT</a></p></div></footer><div class=visible-xs><div class=\"collapse navbar-collapse off-canvas-sidebar collapse\" id=navigation-mobil><ul class=\"nav navbar-nav navbar-right\"><li class=active><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> {{ \"REGISTER\" | translate }}</md-button></li><li><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> {{ \"LOGIN\" | translate }}</md-button></li></ul></div></div>";

/***/ },
/* 418 */
/***/ function(module, exports) {

	module.exports = "<div class=background></div><nav class=\"navbar navbar-primary navbar-transparent navbar-absolute\" id=navbar><div class=container><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navigation-mobil ng-click=menu()><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a href=http://www.brainvt.com class=logo></a></div><div class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav navbar-right\"><li><language-switcher></language-switcher></li><li class=active><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> <span class=roboto>{{ 'REGISTER' | translate}}</span></md-button></li><li><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> <span class=roboto>{{ 'LOGIN' | translate}}</span></md-button></li></ul></div></div></nav><div class=\"content wrapper-full-page\"><div class=container><div class=row><div class=\"col-md-10 col-md-offset-1\"><div class=\"card card-signup\"><h2 class=\"card-title text-center\">{{ \"PROMO_REQUEST\" | translate }}</h2><form name=form ng-submit=register() role=form novalidate><div class=row><div class=\"col-md-10 col-md-offset-1\"><div class=card-content><md-input-container class=md-block><label>{{ \"NAME\" | translate }}</label><input name=name ng-model=name required><div ng-messages=form.name.$error><div ng-message=required>{{ \"NAME_REQUIRED\" | translate }}.</div></div></md-input-container><md-input-container class=md-block><label>{{ \"EMAIL\" | translate }}</label><input type=email name=email ng-model=email required><div ng-messages=form.email.$error><div ng-message=required>{{ \"EMAIL_REQUIRED\" | translate }}.</div><div ng-message=email>{{ \"EMAIL_NOT_VALID\" | translate }}.</div><div ng-message=exists>{{ \"EMAIL_ALREADY_TAKEN\" | translate }}</div></div></md-input-container><div class=text-center><md-input-container class=md-block><md-checkbox name=tos ng-model=tos required><a onclick=\"window.open('/aviso-legal')\" ng-click=$event.stopPropagation()>{{ \"ACCEPT_TERMS_SERVICE\" | translate }}.</a></md-checkbox><div ng-messages=form.tos.$error multiple md-auto-hide=false><div ng-message=required>{{ \"YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED\" | translate }}.</div></div></md-input-container><div class=\"footer text-center\"><md-button type=submit ng-disabled=\"form.$invalid || dataLoading\" class=\"submit md-raised md-primary\" ng-class=\"{loading: dataLoading}\">{{ \"LETS_GO\" | translate }}</md-button></div></div></div></div></div></form></div></div></div></div></div><footer class=footer><div class=container><p class=\"copyright pull-right\">©{{ year }} <a href=http://www.brainvt.com>BrainVT</a></p></div></footer><div class=visible-xs><div class=\"collapse navbar-collapse off-canvas-sidebar collapse\" id=navigation-mobil><ul class=\"nav navbar-nav navbar-right\"><li class=active><md-button ui-sref=register aria-label=\"\"><i class=\"fa fa-user-plus\"></i> {{ \"REGISTER\" | translate }}</md-button></li><li><md-button ui-sref=login aria-label=\"\"><i class=\"fa fa-unlock-alt\"></i> {{ \"LOGIN\" | translate }}</md-button></li></ul></div></div>";

/***/ },
/* 419 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><ma-view-actions><ma-back-button></ma-back-button></ma-view-actions><div><h1>{{ 'MANAGE_SUBSCRIPTIONS' | translate }}</h1><p class=lead ng-if=description compile=description>{{ description | translate }}</p></div></div></div><md-content layout-xs=column layout=row><div flex-xs flex-gt-xs=100 layout=column><md-card md-theme-watch><md-card-content ng-if=users.length><md-table-container><table md-table md-progress=promise><thead md-head><tr md-row><th md-column ng-if=is_company><span>{{ 'PRESCRIPTOR' | translate}}</span><th md-column><span>{{ 'PATIENT' | translate}}</span><th md-column md-date><span>{{ 'PATIEN_EMAIL' | translate }}</span><th md-column>{{ 'STATUS' | translate}}<th md-column>{{ 'NUM_SUBSCRIPTIONS' | translate}}<th md-column><tbody md-body><tr md-row md-select=licence md-select-id=user md-auto-select ng-repeat=\"user in users\"><td md-cell ng-if=is_company><span>{{ user.prescriber.name }} {{ user.prescriber.surname }}</span><td md-cell>{{user.name}} {{user.surname}}<td md-cell>{{user.email }}<td md-cell><span ng-class=user.subscription_state>{{user.subscription_state | translate }}</span> <i class=\"fa fa-question-circle text-primary action-icon\"><md-tooltip md-direction=bottom><strong>{{ 'EXPIRATE_AT' | translate}}:</strong> <span ng-if=user.subscription_expirated>{{ user.subscription_expirated | date : \"dd.MM.yyyy\"}}</span> <span ng-if=!user.subscription_expirated>{{ \"No iniciada\" }}</span></md-tooltip></i><td md-cell>{{user.subscriptions_use }}<td md-cell style=\"white-space: nowrap\"><i class=\"fa fa-link action-icon\" ng-if=\"user.subscription_state != 'active'\" ng-click=\"addSubscription($event, user)\"><md-tooltip md-direction=bottom>{{ \"LINK_SUBSCRIPTION\" | translate }}</md-tooltip></i> <i class=\"fa fa-unlink action-icon\" ng-if=\"user.subscription_state == 'active'\" ng-click=\"removeSubscription($event, user)\"><md-tooltip md-direction=bottom>{{ \"UNLINK_SUBSCRIPTION\" | translate }}</md-tooltip></i> <i class=\"fa fa-refresh action-icon\" ng-if=\"user.subscription_state == 'active'\" ng-click=\"addSubscription($event, user)\"><md-tooltip md-direction=bottom>{{ \"ADD_SUBSCRIPTION\" | translate }}</md-tooltip></i></table></md-table-container></md-card-content><md-card-title ng-if=!users.length><md-card-title-text><span class=md-headline>{{ 'NO_USERS_YET' | translate}}.<br><a ui-sref=\"create({entity: 'user'})\"><i class=\"fa fa-plus\"></i> {{ 'WOULD_LIKE_ADD_NEW_USER' | translate}}</a></span></md-card-title-text></md-card-title></md-card></div></md-content>";

/***/ },
/* 420 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row list-header\"><div class=col-lg-12><div class=page-header><ma-view-actions override=::batchDeleteController.actions selection=batchDeleteController.selection entity=::batchDeleteController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button></ma-view-actions><h1 compile=::batchDeleteController.title>{{ 'DELETE' | translate }} {{ ::batchDeleteController.entityIds.length }} {{ ::batchDeleteController.view.entity.name() | humanize | pluralize | translate }}</h1></div></div></div><div class=row><div class=col-lg-12><p translate=ARE_YOU_SURE></p><button class=\"btn btn-danger\" ng-click=batchDeleteController.batchDelete($event) translate=YES></button> <button class=\"btn btn-default\" ng-click=batchDeleteController.back() translate=NO></button></div></div><div ng-if=selection class=\"row list-view\" ng-class=\"::'ng-admin-entity-' + batchDeleteController.entity.name()\"><div class=col-lg-12><ma-datagrid name=\"{{ ::batchDeleteController.view.name() }}\" entries=batchDeleteController.selection fields=::batchDeleteController.fields entity=::batchDeleteController.entity></ma-datagrid></div></div>";

/***/ },
/* 421 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions override=::deleteController.actions entry=::entry entity=::deleteController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button></ma-view-actions><h1 compile=::deleteController.title>{{ 'DELETE' | translate }} {{ ::deleteController.view.entity.label() | humanize:true | singularize | translate }} #{{ ::entry.identifierValue }}</h1><p class=lead ng-if=::deleteController.description compile=::deleteController.description>{{ ::deleteController.description }}</p></div></div></div><div class=row id=delete-view><div class=col-lg-12><p translate=ARE_YOU_SURE></p><button class=\"btn btn-danger\" ng-click=deleteController.deleteOne($event) translate=YES></button> <button class=\"btn btn-default\" ng-click=deleteController.back() translate=NO></button></div></div>";

/***/ },
/* 422 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions override=::formController.actions entry=entry entity=::formController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button></ma-view-actions><h1 compile=::formController.title>{{ 'CREATE_NEW' | translate }} {{ ::formController.view.entity.label() | humanize:true | singularize | translate }}</h1><p class=lead ng-if=::formController.description compile=::formController.description>{{ ::formController.description }}</p></div></div></div><div class=row id=create-view ng-class=\"::'ng-admin-entity-' + formController.entity.name()\"><form class=\"col-lg-12 form-horizontal\" name=formController.form ng-submit=formController.submitCreation($event)><div ng-repeat=\"field in ::formController.fields track by $index\" compile=::field.getTemplateValueWithLabel(entry)><ma-field field=::field value=entry.values[field.name()] entry=entry entity=::entity form=formController.form datastore=::formController.dataStore></ma-field></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><ma-submit-button label=SUBMIT></ma-submit-button></div></div></form></div>";

/***/ },
/* 423 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions override=::formController.actions entry=entry entity=::formController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button><ma-delete-button ng-if=::entity.deletionView().enabled entry=entry entity=::entity></ma-delete-button></ma-view-actions><h1 compile=::formController.title>{{ 'EDIT' | translate }} {{ ::formController.entity.label() | humanize:true | singularize | translate }} #{{ ::entry.identifierValue }}</h1><p class=lead ng-if=::formController.description compile=::formController.description>{{ ::formController.description }}</p></div></div></div><div class=row id=edit-view ng-class=\"::'ng-admin-entity-' + formController.entity.name()\"><form class=\"col-lg-12 form-horizontal\" name=formController.form ng-submit=formController.submitEdition($event)><div ng-repeat=\"field in ::formController.fields track by $index\" compile=::field.getTemplateValueWithLabel(entry)><ma-field field=::field value=entry.values[field.name()] entry=entry entity=::entity form=formController.form datastore=::formController.dataStore></ma-field></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><ma-submit-button label=SAVE_CHANGES></ma-submit-button></div></div></form></div>";

/***/ },
/* 424 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row list-view\" ng-class=\"::'ng-admin-entity-' + listController.entity.name()\"><div class=col-lg-12><ma-datagrid name=\"{{ ::listController.view.name() }}\" entries=listController.dataStore.getEntries(listController.entity.uniqueId) selection=selection fields=::listController.fields list-actions=::listController.listActions entity=::listController.entity sort-field=::listController.sortField sort-dir=::listController.sortDir entry-css-classes=::listController.entryCssClasses datastore=listController.dataStore></ma-datagrid></div></div><div class=row ng-if=::!listController.infinitePagination><div class=col-lg-12><ma-datagrid-pagination page=\"{{ listController.page }}\" per-page=\"{{ ::listController.view.perPage() }}\" total-items=\"{{ listController.totalItems }}\" set-page=::listController.setPageCallback></ma-datagrid-pagination></div></div><ma-datagrid-infinite-pagination ng-if=::listController.infinitePagination per-page=\"{{ ::listController.view.perPage() }}\" total-items=\"{{ ::listController.totalItems }}\" next-page=::listController.nextPageCallback></ma-datagrid-infinite-pagination>";

/***/ },
/* 425 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row list-header\"><div class=col-lg-12><div class=page-header><ma-view-actions override=::llCtrl.actions selection=selection batch-buttons=::llCtrl.batchActions entity=::llCtrl.entity datastore=::llCtrl.dataStore search=::llCtrl.search filters=::llCtrl.filters enabled-filters=llCtrl.enabledFilters enable-filter=llCtrl.enableFilter><ma-filter-button filters=filters() enabled-filters=enabledFilters enable-filter=enableFilter()></ma-filter-button><ma-view-batch-actions buttons=::batchButtons() selection=selection entity=::entity></ma-view-batch-actions><ma-export-to-csv-button entity=::entity datastore=::datastore></ma-export-to-csv-button><ma-create-button ng-if=::entity.creationView().enabled entity=::entity></ma-create-button></ma-view-actions><h1 compile=::llCtrl.view.title()>{{ ::llCtrl.view.entity.label() | humanize | pluralize | translate }} {{ 'LIST' | translate }}</h1><p class=lead ng-if=::llCtrl.view.description() compile=::llCtrl.view.description()>{{ ::llCtrl.view.description() }}</p></div><ma-filter-form ng-if=llCtrl.hasFilters filters=llCtrl.enabledFilters values=llCtrl.search datastore=::llCtrl.dataStore remove-filter=::llCtrl.removeFilter></ma-filter-form></div></div><div ui-view=grid></div>";

/***/ },
/* 426 */
/***/ function(module, exports) {

	module.exports = "<nav class=pagination-bar><div class=total ng-if=\"paginationCtrl.totalItems > 0\" translate=PAGINATION translate-values=\"{ begin: paginationCtrl.offsetBegin, end: paginationCtrl.offsetEnd, total: paginationCtrl.totalItems }\"></div><div class=\"total no-record\" ng-if=\"paginationCtrl.totalItems == 0\"><strong translate=NO_PAGINATION></strong></div><ul class=\"pagination pagination-sm pull-right\" role=group aria-label=pagination ng-if=paginationCtrl.displayPagination><li><a href ng-if=\"paginationCtrl.page != 1\" ng-click=\"paginationCtrl.setPage(paginationCtrl.page - 1)\" translate=PREVIOUS></a></li><li ng-repeat=\"n in paginationCtrl.range(paginationCtrl.page) track by $index\" ng-class=\"{'active': n == paginationCtrl.page}\"><a href ng-if=\"n != '.'\" ng-click=paginationCtrl.setPage(n)>{{ n }}</a> <span ng-if=\"n == '.'\">&hellip;</span></li><li><a href ng-if=\"paginationCtrl.page != paginationCtrl.nbPages\" ng-click=\"paginationCtrl.setPage(paginationCtrl.page + 1)\" translate=NEXT></a></li></ul></nav>";

/***/ },
/* 427 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><ma-view-actions override=::showController.actions entry=entry entity=::showController.entity><ma-list-button ng-if=::entity.listView().enabled entity=::entity></ma-list-button><ma-edit-button ng-if=::entity.editionView().enabled entry=entry entity=::entity></ma-edit-button><ma-delete-button ng-if=::entity.deletionView().enabled entry=entry entity=::entity></ma-delete-button></ma-view-actions><h1 compile=::showController.title>{{ ::showController.view.entity.label() | humanize | singularize | translate }} #{{ ::entry.identifierValue }} {{ 'DETAIL' | translate }}</h1><p class=lead ng-if=::showController.description compile=::showController.description>{{ ::showController.description }}</p></div></div></div><div class=\"row form-horizontal\" id=show-view><div ng-repeat=\"field in ::showController.fields track by $index\" compile=::field.getTemplateValueWithLabel(entry)><ma-show-item field=::field entry=::entry entity=::showController.entity datastore=::showController.dataStore></ma-show-item></div></div>";

/***/ },
/* 428 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-lg-12><div class=page-header><h1>{{ 'NOT_FOUND' | translate }}</h1></div></div></div><div class=\"row dashboard-content\"><div class=col-lg-12>{{ 'NOT_FOUND_DETAILS' | translate }}<br><br><br><br></div><pre class=\"ascii col-lg-offset-4 col-lg-4 col-md-offset-3 col-md-6 col-sm-offset-2 col-sm-8 col-cs-offset-1 col-xs-10\">\n\n       |\\      _,,,---,,_\n       /,`.-'`'    -.  ;-;;,_\n      |,4-  ) )-,_..;\\ (  `'-'\n     '---''(_/--'  `-'\\_)\n\n    </pre></div>";

/***/ },
/* 429 */
/***/ function(module, exports) {

	module.exports = "<div class=row ng-if=dashboardController.hasEntities><div class=col-lg-12><div class=page-header><h1>{{ 'Dashboard' | translate }}</h1></div></div></div><div class=\"row dashboard-content\"><div class=col-lg-6><div class=\"panel panel-default\" ng-repeat=\"collection in dashboardController.collections | orderElement\" ng-if=$even><ma-dashboard-panel collection=collection entries=dashboardController.entries[collection.name()] datastore=dashboardController.datastore></ma-dashboard-panel></div></div><div class=col-lg-6><div class=\"panel panel-default\" ng-repeat=\"collection in dashboardController.collections | orderElement\" ng-if=$odd><ma-dashboard-panel collection=collection entries=dashboardController.entries[collection.name()] datastore=dashboardController.datastore></ma-dashboard-panel></div></div></div><div class=row ng-if=!dashboardController.hasEntities><div class=col-lg-12><div class=dashboard-invite><p>All dependencies are set, ng-admin is ready to run!</p><p>Now you can <a href=https://github.com/marmelab/ng-admin/blob/master/README.md#configuring-ng-admin>update the configuration</a>: add entities to the admin, then refresh.</p></div></div></div>";

/***/ },
/* 430 */
/***/ function(module, exports) {

	module.exports = "<div id=wrapper><nav id=header-nav class=\"navbar navbar-default navbar-static-top\" role=navigation><span compile=::appController.header><div class=navbar-header><button type=button class=navbar-toggle ng-click=\"isCollapsed = !isCollapsed\"><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a href=# ng-click=appController.displayHome() class=navbar-brand>{{ ::appController.applicationName }}</a></div></span><ma-menu-bar menu=::appController.menu></ma-menu-bar></nav><div id=page-wrapper><div ui-view></div></div><div id=loader></div></div>";

/***/ },
/* 431 */
/***/ function(module, exports) {

	module.exports = "<div class=\"navbar-default sidebar\" role=navigation compile=menu.template()><div class=\"sidebar-nav navbar-collapse collapse\" uib-collapse=$parent.isCollapsed><ul class=nav id=side-menu><li class=entities-repeat ng-repeat=\"(key, menu) in ::menu.children()\" data-menu-id=\"{{ ::menu.uuid }}\" compile=menu.template()><a ng-if=::menu.hasChild() ng-click=toggleMenu(menu) ng-class=\"::{'active': menu.isActive(path)}\"><span compile=::menu.icon()><span class=\"glyphicon glyphicon-list\"></span></span> {{ menu.title() | translate }} <span class=\"glyphicon arrow\" ng-class=\"::{'glyphicon-menu-down': isOpen(menu), 'glyphicon-menu-right': !isOpen(menu) }\"></span></a> <a ng-if=::!menu.hasChild() href=\"#{{ menu.link() }}\" ng-click=activateLink(menu) ng-class=\"::{'active': menu.isActive(path)}\"><span compile=::menu.icon()><span class=\"glyphicon glyphicon-list\"></span></span> {{ menu.title() | translate }}</a><ul ng-if=::menu.hasChild() class=\"nav nav-second-level collapsible\" ng-class=\"::{'collapsed': !isOpen(menu) }\"><li ng-repeat=\"menu in ::menu.children()\" data-menu-id=\"{{ ::menu.uuid }}\" compile=menu.template()><a href=#{{menu.link()}} ng-click=activateLink(menu) ng-class=\"::{'active': menu.isActive(path)}\"><span compile=::menu.icon()><span class=\"glyphicon glyphicon-list\"></span></span> {{ menu.title() | translate }}</a></li></ul></li></ul></div></div>";

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 21,
		"./af.js": 21,
		"./ar": 25,
		"./ar-ma": 22,
		"./ar-ma.js": 22,
		"./ar-sa": 23,
		"./ar-sa.js": 23,
		"./ar-tn": 24,
		"./ar-tn.js": 24,
		"./ar.js": 25,
		"./az": 26,
		"./az.js": 26,
		"./be": 27,
		"./be.js": 27,
		"./bg": 28,
		"./bg.js": 28,
		"./bn": 29,
		"./bn.js": 29,
		"./bo": 30,
		"./bo.js": 30,
		"./br": 31,
		"./br.js": 31,
		"./bs": 32,
		"./bs.js": 32,
		"./ca": 33,
		"./ca.js": 33,
		"./cs": 34,
		"./cs.js": 34,
		"./cv": 35,
		"./cv.js": 35,
		"./cy": 36,
		"./cy.js": 36,
		"./da": 37,
		"./da.js": 37,
		"./de": 39,
		"./de-at": 38,
		"./de-at.js": 38,
		"./de.js": 39,
		"./el": 40,
		"./el.js": 40,
		"./en-au": 41,
		"./en-au.js": 41,
		"./en-ca": 42,
		"./en-ca.js": 42,
		"./en-gb": 43,
		"./en-gb.js": 43,
		"./eo": 44,
		"./eo.js": 44,
		"./es": 45,
		"./es.js": 45,
		"./et": 46,
		"./et.js": 46,
		"./eu": 47,
		"./eu.js": 47,
		"./fa": 48,
		"./fa.js": 48,
		"./fi": 49,
		"./fi.js": 49,
		"./fo": 50,
		"./fo.js": 50,
		"./fr": 52,
		"./fr-ca": 51,
		"./fr-ca.js": 51,
		"./fr.js": 52,
		"./fy": 53,
		"./fy.js": 53,
		"./gl": 54,
		"./gl.js": 54,
		"./he": 55,
		"./he.js": 55,
		"./hi": 56,
		"./hi.js": 56,
		"./hr": 57,
		"./hr.js": 57,
		"./hu": 58,
		"./hu.js": 58,
		"./hy-am": 59,
		"./hy-am.js": 59,
		"./id": 60,
		"./id.js": 60,
		"./is": 61,
		"./is.js": 61,
		"./it": 62,
		"./it.js": 62,
		"./ja": 63,
		"./ja.js": 63,
		"./jv": 64,
		"./jv.js": 64,
		"./ka": 65,
		"./ka.js": 65,
		"./km": 66,
		"./km.js": 66,
		"./ko": 67,
		"./ko.js": 67,
		"./lb": 68,
		"./lb.js": 68,
		"./lt": 69,
		"./lt.js": 69,
		"./lv": 70,
		"./lv.js": 70,
		"./me": 71,
		"./me.js": 71,
		"./mk": 72,
		"./mk.js": 72,
		"./ml": 73,
		"./ml.js": 73,
		"./mr": 74,
		"./mr.js": 74,
		"./ms": 76,
		"./ms-my": 75,
		"./ms-my.js": 75,
		"./ms.js": 76,
		"./my": 77,
		"./my.js": 77,
		"./nb": 78,
		"./nb.js": 78,
		"./ne": 79,
		"./ne.js": 79,
		"./nl": 80,
		"./nl.js": 80,
		"./nn": 81,
		"./nn.js": 81,
		"./pl": 82,
		"./pl.js": 82,
		"./pt": 84,
		"./pt-br": 83,
		"./pt-br.js": 83,
		"./pt.js": 84,
		"./ro": 85,
		"./ro.js": 85,
		"./ru": 86,
		"./ru.js": 86,
		"./si": 87,
		"./si.js": 87,
		"./sk": 88,
		"./sk.js": 88,
		"./sl": 89,
		"./sl.js": 89,
		"./sq": 90,
		"./sq.js": 90,
		"./sr": 92,
		"./sr-cyrl": 91,
		"./sr-cyrl.js": 91,
		"./sr.js": 92,
		"./sv": 93,
		"./sv.js": 93,
		"./ta": 94,
		"./ta.js": 94,
		"./th": 95,
		"./th.js": 95,
		"./tl-ph": 96,
		"./tl-ph.js": 96,
		"./tr": 97,
		"./tr.js": 97,
		"./tzl": 98,
		"./tzl.js": 98,
		"./tzm": 100,
		"./tzm-latn": 99,
		"./tzm-latn.js": 99,
		"./tzm.js": 100,
		"./uk": 101,
		"./uk.js": 101,
		"./uz": 102,
		"./uz.js": 102,
		"./vi": 103,
		"./vi.js": 103,
		"./zh-cn": 104,
		"./zh-cn.js": 104,
		"./zh-tw": 105,
		"./zh-tw.js": 105
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 432;


/***/ },
/* 433 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 434 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main.js
 **/